/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		103: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "static/js/" + ({"0":"404","1":"billing-success","2":"login","3":"exclusive-strategy","4":"withdraw","5":"about","6":"support","7":"helpdesk","8":"complaint-handling-policy","9":"en","10":"billing-fail","11":"index","12":"profile","13":"fillup-11","14":"tournament","15":"fillup-kerry-express","16":"fillup-20","17":"fillup-21","18":"fillup-4","19":"faq","20":"regbonus","21":"sightseeing","24":"fillup-13","25":"fillup-7","26":"fillup-5","27":"fillup-6","28":"change-password","30":"promo","31":"app-download","32":"finance-history","33":"offline-billing","34":"test-for-users","35":"signal-item","36":"analytics","37":"news-item","39":"conditions","41":"billing-qr","42":"return-refund-policy","43":"tutorials","44":"risk-notifications","45":"privacy-policy","46":"payment-privacy","47":"payment-policy","48":"bonus-program","49":"aml-policy","55":"harakiri","56":"ironcard","60":"vn","61":"tr","62":"th","63":"ru","64":"ph","65":"jp","66":"id","67":"hi","68":"es","69":"cn","70":"ar","71":"webview-rating","72":"unsubscribe","73":"tournaments","74":"register","75":"news","76":"logout","77":"error","78":"error-email","79":"confirm-email","80":"billing-redirect","92":"helpdesk-safety","93":"helpdesk-contacts","94":"helpdesk-search","95":"helpdesk-faq","96":"helpdesk-base","97":"helpdesk-start","98":"helpdesk-skilled","99":"helpdesk-practicing","100":"helpdesk-tutorials","101":"helpdesk-404"}[chunkId]||chunkId) + "." + {"0":"f0ac714d","1":"e312225a","2":"2d05114c","3":"1b2f66c4","4":"e080039c","5":"ff380548","6":"a02d8da9","7":"249c9da0","8":"8de29fb3","9":"40abd75e","10":"1b18d45c","11":"89c9e8bd","12":"20e836aa","13":"3fd8eff0","14":"a66ae8cf","15":"359a6de2","16":"7e12cc22","17":"f67b5c3f","18":"d8d77f5c","19":"5fc77370","20":"877133f8","21":"3e2f6d27","22":"2e1a4490","23":"1eaff1ec","24":"7078e92e","25":"1d0ec606","26":"3224ed0b","27":"88395b28","28":"f90edee2","29":"fe56774a","30":"019c692d","31":"f6d57cec","32":"9d392bbb","33":"5746c116","34":"d9098444","35":"3d4b10f8","36":"039dbed6","37":"35766c2a","38":"ec49e5c5","39":"c90f1f44","40":"409d37b3","41":"779df355","42":"3b10512f","43":"c3771071","44":"cfffa9a9","45":"0c8d6fa6","46":"409d9cd6","47":"dc5428b6","48":"42972ad8","49":"0db74f93","50":"c259f5fd","51":"3007a240","52":"d1770a7f","53":"003319ac","54":"0fd78400","55":"22602b3c","56":"bbe7ad10","57":"7f8eb5ba","58":"207122ff","59":"b1aada43","60":"7ba15af8","61":"5501640c","62":"cc565c97","63":"20089878","64":"90c34a4f","65":"a92782b0","66":"108bd5f3","67":"6737f459","68":"a230522b","69":"0b6a59d3","70":"764e1428","71":"32f290fe","72":"4bdfbcfc","73":"c208ddce","74":"e2962e25","75":"cd1b04fa","76":"dfb3954d","77":"a9c9a41e","78":"8407da1c","79":"7f653db2","80":"2c2a71ae","81":"76821456","82":"cf6dda4c","83":"2079eb40","84":"d92bb85e","85":"3ed76855","86":"0f69a098","87":"740116a4","88":"d1f4ece3","89":"3e70fa73","90":"5ae1706f","91":"681551c3","92":"5f4514b3","93":"2a9950e9","94":"56357699","95":"d926e87b","96":"6616540f","97":"81ac19cf","98":"3f18d862","99":"e68a79bb","100":"bff597cc","101":"48327ce9","102":"dd11b7fa"}[chunkId] + ".chunk.js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 880);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1089);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return keyframes; });
/* unused harmony export createGlobalStyle */
/* unused harmony export isStyledComponent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ThemeConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withTheme; });
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_memoize_one__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__ = __webpack_require__(1168);









// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 
function isFunction(test) {
  return typeof test === 'function';
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 
function isStyledComponent(target) {
  return target && typeof target.styledComponentId === 'string';
}

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PROJECT":"irontrade","REACT_APP_DEPLOY_TARGET":"irontrade","REACT_APP_GOOGLE_VERIFICATION":"ESqupn2XQE2LmAjohiwBb5TqRiW5ra0X4NOF3vQfjwg","REACT_APP_GOOGLE_MAPS_API":"AIzaSyAuE9NJI7UnRRkJmTns9m7Va5eAPHCW5Us"}).SC_ATTR || 'data-styled';

var SC_VERSION_ATTR = 'data-styled-version';

var SC_STREAM_ATTR = 'data-styled-streamed';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// Shared empty execution context when generating static styles
var STATIC_EXECUTION_CONTEXT = {};

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n- Are you trying to reuse it across renders?\n- Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n- Does this error occur on the client and is your target falsy?\n- Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n- Are you running in a client-like environment on the server?\n- Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n- Are you using a custom target that isn't mounted?\n- Does your document not have a valid head element?\n- Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.\n\n",
  "12": "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper (see https://www.styled-components.com/docs/api#css), which ensures the styles are injected correctly.\n"
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations)).trim()));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_0_stylis_stylis_min___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];

// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_1_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

var _componentId = void 0;
var _selector = void 0;
var _selectorRegexp = void 0;

var selfReferenceReplacer = function selfReferenceReplacer(match, offset, string) {
  if (
  // the first self-ref is always untouched
  offset > 0 &&
  // there should be at least two self-refs to do a replacement (.b > .b)
  string.slice(0, offset).indexOf(_selector) !== -1 &&
  // no consecutive self refs (.b.b); that is a precedence boost and treated differently
  string.slice(offset - _selector.length, offset) !== _selector) {
    return '.' + _componentId;
  }

  return match;
};

/**
 * When writing a style like
 *
 * & + & {
 *   color: red;
 * }
 *
 * The second ampersand should be a reference to the static component class. stylis
 * has no knowledge of static class so we have to intelligently replace the base selector.
 */
var selfReferenceReplacementPlugin = function selfReferenceReplacementPlugin(context, _, selectors) {
  if (context === 2 && selectors.length && selectors[0].lastIndexOf(_selector) > 0) {
    // eslint-disable-next-line no-param-reassign
    selectors[0] = selectors[0].replace(_selectorRegexp, selfReferenceReplacer);
  }
};

stylis.use([selfReferenceReplacementPlugin, parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

function stringifyRules(rules, selector, prefix) {
  var componentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '&';

  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  // stylis has no concept of state to be passed to plugins
  // but since JS is single=threaded, we can rely on that to ensure
  // these properties stay in sync with the current stylis run
  _componentId = componentId;
  _selector = selector;
  _selectorRegexp = new RegExp('\\' + _selector + '\\b', 'g');

  return stylis(prefix || !selector ? '' : selector, cssStr);
}

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');
  el.setAttribute(SC_VERSION_ATTR, "4.0.2");

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', SC_VERSION_ATTR + '="' + "4.0.2" + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props[SC_VERSION_ATTR] = "4.0.2", _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker) - 1;
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTag = function makeServerTag(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTag(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {

    /* add rehydration hook to methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },

    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    },

    removeRules: function removeRules(id) {
      rehydrate();
      return tag.removeRules(id);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {

  /* a map from ids to tags */

  /* deferred rules for a given id */

  /* this is used for not reinjecting rules via hasNameForId() */

  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */

  /* a list of tags belonging to this StyleSheet */

  /* a tag for import rules */

  /* current capacity until a new tag must be created */

  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }
    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + '][' + SC_VERSION_ATTR + '="' + "4.0.2" + '"]');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by createGlobalStyle, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for createGlobalStyle to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);

    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;

    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

// 

var Keyframes = function () {
  function Keyframes(name, rules) {
    var _this = this;

    classCallCheck(this, Keyframes);

    this.inject = function (styleSheet) {
      if (!styleSheet.hasNameForId(_this.id, _this.name)) {
        styleSheet.inject(_this.id, _this.rules, _this.name);
      }
    };

    this.toString = function () {
      throw new StyledComponentsError(12, String(_this.name));
    };

    this.name = name;
    this.rules = rules;

    this.id = 'sc-keyframes-' + name;
  }

  Keyframes.prototype.getName = function getName() {
    return this.name;
  };

  return Keyframes;
}();

// 

/**
 * inlined version of
 * https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/hyphenateStyleName.js
 */

var uppercasePattern = /([A-Z])/g;
var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return string.replace(uppercasePattern, '-$1').toLowerCase().replace(msPattern, '-ms-');
}

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

/**
 * It's falsish not falsy because 0 is allowed.
 */
var isFalsish = function isFalsish(chunk) {
  return chunk === undefined || chunk === null || chunk === false || chunk === '';
};

function flatten(chunk, executionContext, styleSheet) {
  if (Array.isArray(chunk)) {
    var ruleSet = [];

    for (var i = 0, len = chunk.length, result; i < len; i += 1) {
      result = flatten(chunk[i], executionContext, styleSheet);

      if (result === null) continue;else if (Array.isArray(result)) ruleSet.push.apply(ruleSet, result);else ruleSet.push(result);
    }

    return ruleSet;
  }

  if (isFalsish(chunk)) {
    return null;
  }

  /* Handle other components */
  if (isStyledComponent(chunk)) {
    return '.' + chunk.styledComponentId;
  }

  /* Either execute or defer the function */
  if (isFunction(chunk)) {
    if (executionContext) {
      if (false) {
        /* Warn if not referring styled component */
        try {
          // eslint-disable-next-line new-cap
          if (isElement(new chunk(executionContext))) {
            console.warn(getComponentName(chunk) + ' is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.');
          }
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }

      return flatten(chunk(executionContext), executionContext, styleSheet);
    } else return chunk;
  }

  if (chunk instanceof Keyframes) {
    if (styleSheet) {
      chunk.inject(styleSheet);
      return chunk.getName();
    } else return chunk;
  }

  /* Handle objects */
  return isPlainObject(chunk) ? objToCss(chunk) : chunk.toString();
}

// 

function css(styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (isFunction(styles) || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
}

// 

function constructWithOptions(componentConstructor, tag) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  if (!Object(__WEBPACK_IMPORTED_MODULE_3_react_is__["isValidElementType"])(tag)) {
    throw new StyledComponentsError(1, String(tag));
  }

  /* This is callable directly as a template function */
  // $FlowFixMe: Not typed to avoid destructuring arguments
  var templateFunction = function templateFunction() {
    return componentConstructor(tag, options, css.apply(undefined, arguments));
  };

  /* If config methods are called, wrap up a new template function and merge options */
  templateFunction.withConfig = function (config) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
  };
  templateFunction.attrs = function (attrs) {
    return constructWithOptions(componentConstructor, tag, _extends({}, options, {
      attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
    }));
  };

  return templateFunction;
}

// 
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(c) {
  for (var e = c.length | 0, a = e | 0, d = 0, b; e >= 4;) {
    b = c.charCodeAt(d) & 255 | (c.charCodeAt(++d) & 255) << 8 | (c.charCodeAt(++d) & 255) << 16 | (c.charCodeAt(++d) & 255) << 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), b ^= b >>> 24, b = 1540483477 * (b & 65535) + ((1540483477 * (b >>> 16) & 65535) << 16), a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16) ^ b, e -= 4, ++d;
  }
  switch (e) {
    case 3:
      a ^= (c.charCodeAt(d + 2) & 255) << 16;
    case 2:
      a ^= (c.charCodeAt(d + 1) & 255) << 8;
    case 1:
      a ^= c.charCodeAt(d) & 255, a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  }
  a ^= a >>> 13;
  a = 1540483477 * (a & 65535) + ((1540483477 * (a >>> 16) & 65535) << 16);
  return (a ^ a >>> 15) >>> 0;
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
}

// 

function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (isFunction(rule) && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (isFunction(value)) {
        return false;
      }
    }
  }

  return true;
}

//

// 

var isHMREnabled = "production" !== 'production' && typeof module !== 'undefined' && module.hot;

/* combines hashStr (murmurhash) and nameGenerator for convenience */
var hasher = function hasher(str) {
  return generateAlphabeticName(murmurhash(str));
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */

var ComponentStyle = function () {
  function ComponentStyle(rules, attrs, componentId) {
    classCallCheck(this, ComponentStyle);

    this.rules = rules;
    this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
    this.componentId = componentId;

    if (!StyleSheet.master.hasId(componentId)) {
      var placeholder =  false ? ['.' + componentId + ' {}'] : [];

      StyleSheet.master.deferredInject(componentId, placeholder);
    }
  }

  /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


  ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
    var isStatic = this.isStatic,
        componentId = this.componentId,
        lastClassName = this.lastClassName;

    if (IS_BROWSER && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
      return lastClassName;
    }

    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var name = hasher(this.componentId + flatCSS.join(''));
    if (!styleSheet.hasNameForId(componentId, name)) {
      styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name, undefined, componentId), name);
    }

    this.lastClassName = name;
    return name;
  };

  ComponentStyle.generateName = function generateName(str) {
    return hasher(str);
  };

  return ComponentStyle;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme) {
  var defaultProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types, flowtype-errors/show-errors */
  var isDefaultTheme = defaultProps ? props.theme === defaultProps.theme : false;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme || defaultProps.theme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

var _TYPE_STATICS;

var REACT_STATICS = {
  childContextTypes: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDerivedStateFromProps: true,
  propTypes: true,
  type: true
};

var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};

var TYPE_STATICS = (_TYPE_STATICS = {}, _TYPE_STATICS[__WEBPACK_IMPORTED_MODULE_3_react_is__["ForwardRef"]] = {
  $$typeof: true,
  render: true
}, _TYPE_STATICS);

var defineProperty$1 = Object.defineProperty,
    getOwnPropertyNames = Object.getOwnPropertyNames,
    _Object$getOwnPropert = Object.getOwnPropertySymbols,
    getOwnPropertySymbols = _Object$getOwnPropert === undefined ? function () {
  return [];
} : _Object$getOwnPropert,
    getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor,
    getPrototypeOf = Object.getPrototypeOf,
    objectPrototype = Object.prototype;
var arrayPrototype = Array.prototype;


function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components

    var inheritedComponent = getPrototypeOf(sourceComponent);

    if (inheritedComponent && inheritedComponent !== objectPrototype) {
      hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
    }

    var keys = arrayPrototype.concat(getOwnPropertyNames(sourceComponent),
    // $FlowFixMe
    getOwnPropertySymbols(sourceComponent));

    var targetStatics = TYPE_STATICS[targetComponent.$$typeof] || REACT_STATICS;

    var sourceStatics = TYPE_STATICS[sourceComponent.$$typeof] || REACT_STATICS;

    var i = keys.length;
    var descriptor = void 0;
    var key = void 0;

    // eslint-disable-next-line no-plusplus
    while (i--) {
      key = keys[i];

      if (
      // $FlowFixMe
      !KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) &&
      // $FlowFixMe
      !(targetStatics && targetStatics[key])) {
        descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        if (descriptor) {
          try {
            // Avoid failures from read-only properties
            defineProperty$1(targetComponent, key, descriptor);
          } catch (e) {
            /* fail silently */
          }
        }
      }
    }

    return targetComponent;
  }

  return targetComponent;
}

// 
function isDerivedReactComponent(fn) {
  return !!(fn && fn.prototype && fn.prototype.isReactComponent);
}

// 

var ThemeContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var ThemeConsumer = ThemeContext.Consumer;

/**
 * Provide a theme to an entire react component tree via context
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider(props) {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["default"])(_this.getContext.bind(_this));
    _this.renderInner = _this.renderInner.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) return null;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Consumer,
      null,
      this.renderInner
    );
  };

  ThemeProvider.prototype.renderInner = function renderInner(outerTheme) {
    var context = this.getContext(this.props.theme, outerTheme);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children)
    );
  };

  /**
   * Get the theme from the props, supporting both (outerTheme) => {}
   * as well as object notation
   */


  ThemeProvider.prototype.getTheme = function getTheme(theme, outerTheme) {
    if (isFunction(theme)) {
      var mergedTheme = theme(outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, outerTheme, theme);
  };

  ThemeProvider.prototype.getContext = function getContext(theme, outerTheme) {
    return this.getTheme(theme, outerTheme);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.sealed = false;
  }

  /**
   * Mark the ServerStyleSheet as being fully emitted and manually GC it from the
   * StyleSheet singleton.
   */


  ServerStyleSheet.prototype.seal = function seal() {
    if (!this.sealed) {
      /* Remove sealed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.sealed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.sealed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.seal();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.seal();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.seal();
    });
    readableStream.on('error', function (err) {
      _this.seal();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var StyleSheetContext = Object(__WEBPACK_IMPORTED_MODULE_2_react__["createContext"])();

var StyleSheetConsumer = StyleSheetContext.Consumer;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager(props) {
    classCallCheck(this, StyleSheetManager);

    var _this = possibleConstructorReturn(this, _Component.call(this, props));

    _this.getContext = Object(__WEBPACK_IMPORTED_MODULE_4_memoize_one__["default"])(_this.getContext);
    return _this;
  }

  StyleSheetManager.prototype.getContext = function getContext(sheet, target) {
    if (sheet) {
      return sheet;
    } else if (target) {
      return new StyleSheet(target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        sheet = _props.sheet,
        target = _props.target;

    var context = this.getContext(sheet, target);
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetContext.Provider,
      { value: context },
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children)
    );
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),

  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var classNameUseCheckInjector = (function (target) {
  var elementClassName = '';

  var targetCDM = target.componentDidMount;

  // eslint-disable-next-line no-param-reassign
  target.componentDidMount = function componentDidMount() {
    if (typeof targetCDM === 'function') {
      targetCDM.call(this);
    }

    var classNames = elementClassName.replace(/ +/g, ' ').trim().split(' ');
    // eslint-disable-next-line react/no-find-dom-node
    var node = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
    var selector = classNames.map(function (s) {
      return '.' + s;
    }).join('');

    if (node && node.nodeType === 1 && !classNames.every(function (className) {
      return node.classList && node.classList.contains(className);
    }) && !node.querySelector(selector)) {
      console.warn('It looks like you\'ve wrapped styled() around your React component (' + getComponentName(this.props.forwardedClass.target) + '), but the className prop is not being passed down to a child. No styles will be rendered unless className is composed within your React component.');
    }
  };

  var prevRenderInner = target.renderInner;

  // eslint-disable-next-line no-param-reassign
  target.renderInner = function renderInner() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var element = prevRenderInner.apply(this, args);

    elementClassName = element.props.className;

    return element;
  };
});

// 

var identifiers = {};

/* We depend on components having unique IDs */
function generateId(_ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + _ComponentStyle.generateName(displayName + nr);

  return parentComponentId ? parentComponentId + '-' + componentId : componentId;
}

var warnInnerRef = once(function () {
  return (
    // eslint-disable-next-line no-console
    console.warn('The "innerRef" API has been removed in styled-components v4 in favor of React 16 ref forwarding, use "ref" instead like a typical component.')
  );
});

// $FlowFixMe

var StyledComponent = function (_Component) {
  inherits(StyledComponent, _Component);

  function StyledComponent() {
    classCallCheck(this, StyledComponent);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.attrs = {};

    _this.renderOuter = _this.renderOuter.bind(_this);
    _this.renderInner = _this.renderInner.bind(_this);

    if (false) {
      classNameUseCheckInjector(_this);
    }
    return _this;
  }

  StyledComponent.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetConsumer,
      null,
      this.renderOuter
    );
  };

  StyledComponent.prototype.renderOuter = function renderOuter(styleSheet) {
    this.styleSheet = styleSheet;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      this.renderInner
    );
  };

  StyledComponent.prototype.renderInner = function renderInner(theme) {
    var _props$forwardedClass = this.props.forwardedClass,
        componentStyle = _props$forwardedClass.componentStyle,
        defaultProps = _props$forwardedClass.defaultProps,
        styledComponentId = _props$forwardedClass.styledComponentId,
        target = _props$forwardedClass.target;


    var generatedClassName = void 0;
    if (componentStyle.isStatic) {
      generatedClassName = this.generateAndInjectStyles(EMPTY_OBJECT, this.props, this.styleSheet);
    } else if (theme !== undefined) {
      generatedClassName = this.generateAndInjectStyles(determineTheme(this.props, theme, defaultProps), this.props, this.styleSheet);
    } else {
      generatedClassName = this.generateAndInjectStyles(this.props.theme || EMPTY_OBJECT, this.props, this.styleSheet);
    }
    var elementToBeCreated = this.props.as || this.attrs.as || target;
    var isTargetTag = isTag(elementToBeCreated);

    var propsForElement = _extends({}, this.attrs);

    var key = void 0;
    // eslint-disable-next-line guard-for-in
    for (key in this.props) {
      if (false) {
        warnInnerRef();
      }

      if (key === 'forwardedClass' || key === 'as') continue;else if (key === 'forwardedRef') propsForElement.ref = this.props[key];else if (!isTargetTag || Object(__WEBPACK_IMPORTED_MODULE_7__emotion_is_prop_valid__["a" /* default */])(key)) {
        // Don't pass through non HTML tags through to HTML elements
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    propsForElement.className = [this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(elementToBeCreated, propsForElement);
  };

  StyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props, attrs) {
    var context = _extends({}, props, { theme: theme });

    if (attrs === undefined) return context;

    this.attrs = {};

    var attr = void 0;
    var key = void 0;

    /* eslint-disable guard-for-in */
    for (key in attrs) {
      attr = attrs[key];

      this.attrs[key] = isFunction(attr) && !isDerivedReactComponent(attr) && !isStyledComponent(attr) ? attr(context) : attr;
    }
    /* eslint-enable */

    return _extends({}, context, this.attrs);
  };

  StyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var styleSheet = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : StyleSheet.master;
    var _props$forwardedClass2 = props.forwardedClass,
        attrs = _props$forwardedClass2.attrs,
        componentStyle = _props$forwardedClass2.componentStyle,
        warnTooManyClasses = _props$forwardedClass2.warnTooManyClasses;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names

    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(EMPTY_OBJECT, styleSheet);
    }

    var className = componentStyle.generateAndInjectStyles(this.buildExecutionContext(theme, props, props.forwardedClass.attrs), styleSheet);

    if (warnTooManyClasses) {
      warnTooManyClasses(className);
    }

    return className;
  };

  return StyledComponent;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

function createStyledComponent(target, options, rules) {
  var isTargetStyledComp = isStyledComponent(target);
  var isClass = !isTag(target);

  var _options$displayName = options.displayName,
      displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
      _options$componentId = options.componentId,
      componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
      _options$ParentCompon = options.ParentComponent,
      ParentComponent = _options$ParentCompon === undefined ? StyledComponent : _options$ParentCompon,
      attrs = options.attrs;


  var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

  // fold the underlying StyledComponent attrs up (implicit extend)
  var finalAttrs =
  // $FlowFixMe
  isTargetStyledComp && target.attrs ? _extends({}, target.attrs, attrs) : attrs;

  var componentStyle = new ComponentStyle(isTargetStyledComp ? // fold the underlying StyledComponent rules up (implicit extend)
  // $FlowFixMe
  target.componentStyle.rules.concat(rules) : rules, finalAttrs, styledComponentId);

  /**
   * forwardRef creates a new interim component, which we'll take advantage of
   * instead of extending ParentComponent to create _another_ interim class
   */
  var WrappedStyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ParentComponent, _extends({}, props, { forwardedClass: WrappedStyledComponent, forwardedRef: ref }));
  });

  // $FlowFixMe
  WrappedStyledComponent.attrs = finalAttrs;
  // $FlowFixMe
  WrappedStyledComponent.componentStyle = componentStyle;
  WrappedStyledComponent.displayName = displayName;
  // $FlowFixMe
  WrappedStyledComponent.styledComponentId = styledComponentId;

  // fold the underlying StyledComponent target up since we folded the styles
  // $FlowFixMe
  WrappedStyledComponent.target = isTargetStyledComp ? target.target : target;

  // $FlowFixMe
  WrappedStyledComponent.withComponent = function withComponent(tag) {
    var previousComponentId = options.componentId,
        optionsToCopy = objectWithoutProperties(options, ['componentId']);


    var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

    var newOptions = _extends({}, optionsToCopy, {
      attrs: finalAttrs,
      componentId: newComponentId,
      ParentComponent: ParentComponent
    });

    return createStyledComponent(tag, newOptions, rules);
  };

  if (false) {
    // $FlowFixMe
    WrappedStyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
  }

  if (isClass) {
    hoistNonReactStatics(WrappedStyledComponent, target, {
      // all SC-specific things should not be hoisted
      attrs: true,
      componentStyle: true,
      displayName: true,
      styledComponentId: true,
      target: true,
      warnTooManyClasses: true,
      withComponent: true
    });
  }

  return WrappedStyledComponent;
}

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var styled = function styled(tag) {
  return constructWithOptions(createStyledComponent, tag);
};

// Shorthands for all valid HTML Elements
domElements.forEach(function (domElement) {
  styled[domElement] = styled(domElement);
});

// 

var GlobalStyle = function () {
  function GlobalStyle(rules, componentId) {
    classCallCheck(this, GlobalStyle);

    this.rules = rules;
    this.componentId = componentId;
    this.isStatic = isStaticRules(rules);

    if (!StyleSheet.master.hasId(componentId)) {
      StyleSheet.master.deferredInject(componentId, []);
    }
  }

  GlobalStyle.prototype.createStyles = function createStyles(executionContext, styleSheet) {
    var flatCSS = flatten(this.rules, executionContext, styleSheet);
    var css = stringifyRules(flatCSS, '');

    styleSheet.inject(this.componentId, css);
  };

  GlobalStyle.prototype.removeStyles = function removeStyles(styleSheet) {
    var componentId = this.componentId;

    if (styleSheet.hasId(componentId)) {
      styleSheet.remove(componentId);
    }
  };

  // TODO: overwrite in-place instead of remove+create?


  GlobalStyle.prototype.renderStyles = function renderStyles(executionContext, styleSheet) {
    this.removeStyles(styleSheet);
    this.createStyles(executionContext, styleSheet);
  };

  return GlobalStyle;
}();

// 

// place our cache into shared context so it'll persist between HMRs
if (IS_BROWSER) {
  window.scCGSHMRCache = {};
}

function createGlobalStyle(strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));
  var id = 'sc-global-' + murmurhash(JSON.stringify(rules));
  var style = new GlobalStyle(rules, id);

  var GlobalStyleComponent = function (_React$Component) {
    inherits(GlobalStyleComponent, _React$Component);

    function GlobalStyleComponent() {
      classCallCheck(this, GlobalStyleComponent);

      var _this = possibleConstructorReturn(this, _React$Component.call(this));

      var _this$constructor = _this.constructor,
          globalStyle = _this$constructor.globalStyle,
          styledComponentId = _this$constructor.styledComponentId;


      if (IS_BROWSER) {
        window.scCGSHMRCache[styledComponentId] = (window.scCGSHMRCache[styledComponentId] || 0) + 1;
      }

      /**
       * This fixes HMR compatiblility. Don't ask me why, but this combination of
       * caching the closure variables via statics and then persisting the statics in
       * state works across HMR where no other combination did. ¯\_(ツ)_/¯
       */
      _this.state = {
        globalStyle: globalStyle,
        styledComponentId: styledComponentId
      };
      return _this;
    }

    GlobalStyleComponent.prototype.componentDidMount = function componentDidMount() {
      if (false) {
        console.warn('The global style component ' + this.state.styledComponentId + ' was composed and rendered multiple times in your React component tree. Only the last-rendered copy will have its styles remain in <head> (or your StyleSheetManager target.)');
      }
    };

    GlobalStyleComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      if (window.scCGSHMRCache[this.state.styledComponentId]) {
        window.scCGSHMRCache[this.state.styledComponentId] -= 1;
      }
      /**
       * Depending on the order "render" is called this can cause the styles to be lost
       * until the next render pass of the remaining instance, which may
       * not be immediate.
       */
      if (window.scCGSHMRCache[this.state.styledComponentId] === 0) {
        this.state.globalStyle.removeStyles(this.styleSheet);
      }
    };

    GlobalStyleComponent.prototype.render = function render() {
      var _this2 = this;

      if (false) {
        console.warn('The global style component ' + this.state.styledComponentId + ' was given child JSX. createGlobalStyle does not render children.');
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
        StyleSheetConsumer,
        null,
        function (styleSheet) {
          _this2.styleSheet = styleSheet || StyleSheet.master;

          var globalStyle = _this2.state.globalStyle;


          if (globalStyle.isStatic) {
            globalStyle.renderStyles(STATIC_EXECUTION_CONTEXT, _this2.styleSheet);

            return null;
          } else {
            return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
              ThemeConsumer,
              null,
              function (theme) {
                var defaultProps = _this2.constructor.defaultProps;


                var context = _extends({}, _this2.props);

                if (typeof theme !== 'undefined') {
                  context.theme = determineTheme(_this2.props, theme, defaultProps);
                }

                globalStyle.renderStyles(context, _this2.styleSheet);

                return null;
              }
            );
          }
        }
      );
    };

    return GlobalStyleComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  GlobalStyleComponent.defaultProps = {
    suppressMultiMountWarning: false
  };
  GlobalStyleComponent.globalStyle = style;
  GlobalStyleComponent.styledComponentId = id;
   false ? GlobalStyleComponent.propTypes = {
    suppressMultiMountWarning: PropTypes.bool
  } : void 0;


  return GlobalStyleComponent;
}

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

function keyframes(strings) {
  /* Warning if you've used keyframes on React Native */
  if (false) {
    console.warn('`keyframes` cannot be used on ReactNative, only on the web. To do animation in ReactNative please use Animated.');
  }

  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  var rules = css.apply(undefined, [strings].concat(interpolations));

  var name = generateAlphabeticName(murmurhash(replaceWhitespace(JSON.stringify(rules))));

  return new Keyframes(name, stringifyRules(rules, name, '@keyframes'));
}

// 

var withTheme = (function (Component$$1) {
  var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      ThemeConsumer,
      null,
      function (theme) {
        // $FlowFixMe
        var defaultProps = Component$$1.defaultProps;

        var themeProp = determineTheme(props, theme, defaultProps);

        if (false) {
          // eslint-disable-next-line no-console
          console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps in component class ' + getComponentName(Component$$1));
        }

        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({}, props, { theme: themeProp, ref: ref }));
      }
    );
  });

  hoistNonReactStatics(WithTheme, Component$$1);

  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';

  return WithTheme;
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

//

/* harmony default export */ __webpack_exports__["d"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(185), __webpack_require__(355)(module)))

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = inferLocale;
/* harmony export (immutable) */ __webpack_exports__["e"] = inferMomentLocale;
/* harmony export (immutable) */ __webpack_exports__["f"] = mapStateToGettext;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return withGettext; });
/* harmony export (immutable) */ __webpack_exports__["c"] = getDirection;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DictionaryUpdater; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_memoize__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_memoize__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n"],["\n  direction: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  background-color: ",";\n  direction: ltr;\n"],["\n  background-color: ",";\n  direction: ltr;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Direction=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,function(props){return props.direction||"ltr";});var Tomato=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2,Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PROJECT":"irontrade","REACT_APP_DEPLOY_TARGET":"irontrade","REACT_APP_GOOGLE_VERIFICATION":"ESqupn2XQE2LmAjohiwBb5TqRiW5ra0X4NOF3vQfjwg","REACT_APP_GOOGLE_MAPS_API":"AIzaSyAuE9NJI7UnRRkJmTns9m7Va5eAPHCW5Us"}).REACT_APP_STATIC_RENDER==="true"?"transparent":"tomato");function lookupString(dictionary,string){return dictionary[string]||null;}function lookupSubstrings(dictionary,substrings){var key=substrings.join("***");var translation=lookupString(dictionary,key);if(typeof translation==="string"){return translation.split("***");}// Обязательно возвращаем те же самые
// подстроки, чтобы потом можно было
// сравнивать массивы с `===`
return substrings;}var defaultLocale="en";var defaultDictionary={};function inferLocale(_ref){var profile=_ref.profile,serverData=_ref.serverData,fallbackLocale=_ref.fallbackLocale;var query=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(window.encodeURI(window.location.search.slice(1)));var userLang=window.navigator.language||window.navigator.userLanguage||window.navigator.browserLanguage||window.navigator.systemLanguage;userLang=userLang.split("-")[0];if(userLang==="vi")userLang="vn";if(userLang==="tl")userLang="ph";if(userLang==="fil")userLang="ph";var notApp=serverData!=null&&!serverData.isIOS&&!serverData.isAndroidApp;if(query.lang!=null){return query.lang;}else if(profile!=null){return profile.locale;}else if(fallbackLocale!=null){return fallbackLocale;}else if(!"irontrade"==="siamoption"&&localeMap[userLang]&&notApp){return userLang;}else if(false){return userLang;}else if(serverData!=null){return serverData.lang;}else{return defaultLocale;}}var siamLocaleMap={en:"en",th:"th"};var localeMap={en:"en",// jp: "jv",
ph:"tl-ph",th:"th",hi:"hi",id:"id",vn:"vi",ar:"ar"};function inferMomentLocale(state){var locale=inferLocale(state);return localeMap[locale]||"en";}function mapStateToDictionary(state){var locale=inferLocale(state);return{locale:locale,dictionary:state.dictionaries[locale]};}var makeGettext=__WEBPACK_IMPORTED_MODULE_5_lodash_memoize___default()(function(dictionary){return function(strings){for(var _len=arguments.length,values=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){values[_key-1]=arguments[_key];}if(typeof strings==="string"){if(false){try{throw new TypeError("gettext(string) is deprecated, please use gettext with template literal");}catch(error){console.warn(error.message+"\n"+error.stack.split("\n")[2]);}}return lookupString(dictionary,strings)||strings;}var translations=lookupSubstrings(dictionary,strings);return translations.reduce(function(result,string,index){return result+string+(values.length>index?values[index]:"");},"");};});function mapStateToGettext(state){var _mapStateToDictionary=mapStateToDictionary(state),_mapStateToDictionary2=_mapStateToDictionary.dictionary,dictionary=_mapStateToDictionary2===undefined?defaultDictionary:_mapStateToDictionary2;return{gettext:makeGettext(dictionary),isGettextReady:dictionary!==defaultDictionary};}var withGettext=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToGettext);function getDirection(locale){switch(locale){case"ar":return"rtl";default:return"ltr";}}function UnidirectionalText(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Direction,{direction:getDirection(props.locale)},props.children);}function Gettext(props){var _props$dictionary=props.dictionary,dictionary=_props$dictionary===undefined?defaultDictionary:_props$dictionary;if(Array.isArray(props.children)){var strings=[];var values=[];props.children.forEach(function(child,index){if(index%2===0){strings.push(typeof child==="string"?child:"");}else{values.push(child);}});// Строк всегда на 1 больше, чем значений,
// чтобы последнее значение не потерялось.
if(strings.length===values.length){strings.push("");}var translation=lookupSubstrings(dictionary,strings);if(false){if(translation===strings){return translation.reduce(function(result,string,index){return[].concat(_toConsumableArray(result),[React.createElement(Tomato,{key:index},string),values[index]]);},[]);}}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnidirectionalText,{locale:props.locale},translation.reduce(function(result,string,index){return[].concat(_toConsumableArray(result),[string,values[index]]);},[]));}if(typeof props.children==="string"){var _translation=lookupString(dictionary,props.children);if(typeof _translation==="string"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnidirectionalText,{locale:props.locale},_translation);}if(false){// Повторная typeof проверка нужна чтобы flow
// не ругалась. Мы не можем гарантировать ей,
// что lookupString() блоком выше не изменил
// тип props.children.
return React.createElement(Tomato,null,props.children);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Direction,null,props.children);}throw new TypeError("<Gettext/> expects a strng or an array as `children`");}/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToDictionary)(Gettext));var StatelessDictionaryUpdater=function(_React$Component){_inherits(StatelessDictionaryUpdater,_React$Component);function StatelessDictionaryUpdater(){_classCallCheck(this,StatelessDictionaryUpdater);return _possibleConstructorReturn(this,(StatelessDictionaryUpdater.__proto__||Object.getPrototypeOf(StatelessDictionaryUpdater)).apply(this,arguments));}_createClass(StatelessDictionaryUpdater,[{key:"UNSAFE_componentWillMount",value:function UNSAFE_componentWillMount(){this.props.dispatch({type:"REQUEST_DICTIONARY",payload:this.props.locale});}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var locale=this.props.locale;this.props.fetchDictionary(locale).then(function(dictionary){_this2.props.dispatch({type:"RECEIVE_DICTIONARY",payload:{dictionary:dictionary,locale:locale}});__WEBPACK_IMPORTED_MODULE_4_moment___default.a.locale(localeMap[locale]);});}},{key:"render",value:function render(){return null;}}]);return StatelessDictionaryUpdater;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var DictionaryUpdater=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToDictionary)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatelessDictionaryUpdater,Object.assign({key:props.locale},props));});

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(72);
var hide = __webpack_require__(59);
var redefine = __webpack_require__(60);
var ctx = __webpack_require__(73);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rtl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gridFallback; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      ",": ",";\n    "],["\n      ",": ",";\n    "]),_templateObject3=_taggedTemplateLiteral(["\n        ",";\n      "],["\n        ",";\n      "]),_templateObject4=_taggedTemplateLiteral(["\n                ",": right;\n              "],["\n                ",": right;\n              "]),_templateObject5=_taggedTemplateLiteral(["\n                ",": left;\n              "],["\n                ",": left;\n              "]),_templateObject6=_taggedTemplateLiteral(["\n                right: ",";\n              "],["\n                right: ",";\n              "]),_templateObject7=_taggedTemplateLiteral(["\n                left: ",";\n              "],["\n                left: ",";\n              "]),_templateObject8=_taggedTemplateLiteral(["\n                ","-right: ",";\n              "],["\n                ","-right: ",";\n              "]),_templateObject9=_taggedTemplateLiteral(["\n                ","-left: ",";\n              "],["\n                ","-left: ",";\n              "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var fontSize=function fontSize(size,arSize){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject,function(_ref){var theme=_ref.theme;switch(theme.locale){case"ar":return arSize?arSize+"px":theme.minFontSize;default:return size+"px";}});};var rtl=function rtl(property,value,rtlValue){if(rtlValue!=null){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject2,property,function(_ref2){var theme=_ref2.theme;return theme.direction==="rtl"?rtlValue:value;});}switch(property){case"text-align":return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3,function(_ref3){var theme=_ref3.theme;switch(true){case theme.direction==="rtl"&&value==="left":case theme.direction==="ltr"&&value==="right":return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject4,property);case theme.direction==="rtl"&&value==="right":case theme.direction==="ltr"&&value==="left":default:return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject5,property);}});case"left":case"right":return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3,function(_ref4){var theme=_ref4.theme;switch(true){case theme.direction==="rtl"&&property==="left":case theme.direction==="ltr"&&property==="right":return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject6,value);case theme.direction==="rtl"&&property==="right":case theme.direction==="ltr"&&property==="left":default:return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject7,value);}});default:var _property$split=property.split("-"),_property$split2=_slicedToArray(_property$split,2),prop=_property$split2[0],suffix=_property$split2[1];return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3,function(_ref5){var theme=_ref5.theme;switch(true){case theme.direction==="rtl"&&suffix==="left":case theme.direction==="ltr"&&suffix==="right":return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject8,prop,value);case theme.direction==="rtl"&&suffix==="right":case theme.direction==="ltr"&&suffix==="left":default:return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject9,prop,value);}});}};var gridFallback=function gridFallback(cols,gap){return"\n  flex-grow: 0;\n  flex-shrink: 1;\n  flex-basis: calc(1/"+cols+"*100% - (1 - 1/"+cols+")*"+gap+");\n  margin-bottom: "+gap+";\n\n  :not(:nth-of-type("+cols+"n + 1)) {\n    margin-left: "+gap+";\n  }\n\n  @supports (display: grid) {\n    margin-bottom: 0px;\n\n    :not(:nth-of-type("+cols+"n + 1)) {\n      margin-left: 0px;\n    }\n  }\n";};

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1095)();
}


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = toDate;
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isWebApp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Link; });
/* unused harmony export NavLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return OptionalLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getCompleteLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NewsLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withData__ = __webpack_require__(32);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline;\n  padding: 0;\n  border: none;\n  background: none;\n  text-decoration: underline;\n  cursor: pointer;\n"],["\n  display: inline;\n  padding: 0;\n  border: none;\n  background: none;\n  text-decoration: underline;\n  cursor: pointer;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject);var ExternalLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].a(_templateObject);var isWebApp=function isWebApp(){return window.matchMedia("(display-mode: standalone)").matches||window.navigator.standalone===true;};var Link=function Link(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["b" /* Link */],{to:props.to,className:props.className,onClick:props.onClick||null,target:isWebApp()?null:props.target,rel:props.rel},props.children);};var NavLink=function NavLink(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:props.to,className:props.className,onClick:props.onClick||null,target:props.target,exact:props.exact},props.children);};var OptionalLink=function OptionalLink(props){return!!props.to?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,props):!!props.href?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExternalLink,props):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,props);};var getCompleteLocale=function getCompleteLocale(locale){switch(locale){case"vn":return"vi_VN";case"ph":return"fi_PH";case"th":return"th_TH";case"id":return"id_ID";case"hi":return"hi_HI";default:return"en_EN";}};var NewsLink=Object(__WEBPACK_IMPORTED_MODULE_4__withData__["a" /* default */])({optional:["profile"]})(function(_ref){var _ref$to=_ref.to,to=_ref$to===undefined?"":_ref$to,props=_objectWithoutProperties(_ref,["to"]);return __WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* NEWS_LINK */]?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExternalLink,Object.assign({href:""+__WEBPACK_IMPORTED_MODULE_3__fetch__["a" /* NEWS_LINK */]+to+"?lang="+getCompleteLocale(props.profile&&props.profile.locale)},props)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,Object.assign({to:"/news/"+to},props));});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NEWS_LINK; });
/* unused harmony export APP_NEWS_LINK */
/* harmony export (immutable) */ __webpack_exports__["c"] = apiCall;
/* harmony export (immutable) */ __webpack_exports__["d"] = get;
/* harmony export (immutable) */ __webpack_exports__["f"] = post;
/* unused harmony export assertErrors */
/* harmony export (immutable) */ __webpack_exports__["g"] = reportServerFault;
/* harmony export (immutable) */ __webpack_exports__["e"] = mapDispatchToFetch;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return withFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Server; });
/* unused harmony export SessionStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customConsole__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spinners_BrandSpinner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__experimental_dataSource__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__crashLog__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Timing__ = __webpack_require__(580);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function getApiUrls(){return{api:window.API_URL,helpdesk:window.HELPDESK_API_URL,crash:window.CRASH_LOGGER_API_URL};}var apiList=getApiUrls();var NEWS_LINK=window.NEWS_URL;// process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
//   ? process.env.NODE_ENV === "development"
//     ? "https://testnews.irontrade.com"
//     : "https://news.irontrade.com"
//   : null;
var APP_NEWS_LINK= true?"https://ironnews.irontrade.com":null;var API= false?apiList.api:window.API_URL||Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PROJECT":"irontrade","REACT_APP_DEPLOY_TARGET":"irontrade","REACT_APP_GOOGLE_VERIFICATION":"ESqupn2XQE2LmAjohiwBb5TqRiW5ra0X4NOF3vQfjwg","REACT_APP_GOOGLE_MAPS_API":"AIzaSyAuE9NJI7UnRRkJmTns9m7Va5eAPHCW5Us"}).REACT_APP_API_URL;var HELPDESK_API=apiList.helpdesk;var CRASH_LOGGER_API= false?apiList.crash:window.CRASH_LOGGER_API_URL||Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_PROJECT":"irontrade","REACT_APP_DEPLOY_TARGET":"irontrade","REACT_APP_GOOGLE_VERIFICATION":"ESqupn2XQE2LmAjohiwBb5TqRiW5ra0X4NOF3vQfjwg","REACT_APP_GOOGLE_MAPS_API":"AIzaSyAuE9NJI7UnRRkJmTns9m7Va5eAPHCW5Us"}).REACT_APP_CRASH_LOGGER_API_URL;// const API =
//   process.env.NODE_ENV === "development"
//     ? process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
//       ? "https://testapp.irontrade.com"
//       : "https://testapp.siamoption.com"
//     : window.API_URL || process.env.REACT_APP_API_URL;
// const HELPDESK_API =
//   process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
//     ? "https://helpdesk.irontrade.com"
//     : "https://helpdesk.siamoption.com";
// const CRASH_LOGGER_API =
//   process.env.NODE_ENV === "development"
//     ? process.env.REACT_APP_DEPLOY_TARGET === "irontrade"
//       ? "https://logtest.irontrade.com"
//       : "https://logtest.siamoption.com"
//     : window.CRASH_LOGGER_API_URL || process.env.REACT_APP_CRASH_LOGGER_API_URL;
var defaultOptions={mode:"cors",credentials:"include"};function apiCall(method,options,mode){if(method.startsWith("/helpdesk")){return Object(__WEBPACK_IMPORTED_MODULE_8__Timing__["a" /* trackOnTimeline */])(fetch(""+HELPDESK_API+method.substring(9),options),"API Call: "+method);}if(method.startsWith("crashlog://")){return fetch(CRASH_LOGGER_API+"/"+method.substring(11),Object.assign({mode:"cors"},options));}return Object(__WEBPACK_IMPORTED_MODULE_8__Timing__["a" /* trackOnTimeline */])(fetch(""+API+method,Object.assign({},defaultOptions,options)),"API Call: "+method);}function get(method,options){return apiCall(method,options).then(function(response){if(response.status!==200){throw new TypeError("Expected response with status 200");}return response;}).then(function(res){return res.json();});}function post(url,data){var contentType=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"application/x-www-form-urlencoded; charset=UTF-8";return new Promise(function(resolve,reject){var _data=data;// TODO: do this only for form-urlencoded
if((typeof data==="undefined"?"undefined":_typeof(data))==="object"){var keys=Object.keys(data);var fields=keys.reduce(function(res,key){res.push(key+"="+encodeURIComponent(data[key]));return res;},[]);_data=fields.join("&");}var request=new XMLHttpRequest();request.responseType="json";request.addEventListener("load",function(){var json=request.response;resolve(json);});request.addEventListener("error",function(){var json=request.response;reject(json);});request.open("POST",""+API+url,true);request.setRequestHeader("Content-Type",contentType);request.send(_data);});}function assertErrors(response){if((typeof response==="undefined"?"undefined":_typeof(response))!=="object"){throw new TypeError("Response must be an object");}if(response.status!=="OK"){throw new Error(response.error||response.message);}return response;}function reportServerFault(fault){var details=_typeof(fault.response)==="object"?JSON.stringify(fault.response):fault.response!=null?fault.response:"No additional details";// показываем, где поломалось api, в режиме разработки
// с помощью нашей кастомной консоли
if(false){error("API Error: "+fault.status+" "+fault.statusText+" "+fault.endpoint+": "+fault.message);}try{__WEBPACK_IMPORTED_MODULE_6__dataLayer__["a" /* default */].push({event:"event-to-ga",eventCategory:"API Error",eventAction:fault.status+" "+fault.statusText+" "+fault.endpoint+": "+fault.message,eventLabel:details});}catch(error){console.warn("Failed to submit a bug report");}}function mapDispatchToFetch(dispatch){return{dispatch:dispatch,fetch:function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(method,options){var response,_data2,_data3,data,payload,_payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return apiCall(method,options);case 2:response=_context.sent;if(!(response.status>500)){_context.next=13;break;}_context.prev=4;_context.next=7;return response.json();case 7:_data2=_context.sent;Object(__WEBPACK_IMPORTED_MODULE_7__crashLog__["b" /* logCrash */])(apiCall)({error:{message:_data2.message,info:{responseStatus:response.status,endpoint:method}}});_context.next=13;break;case 11:_context.prev=11;_context.t0=_context["catch"](4);case 13:if(!(response.status===401)){_context.next=16;break;}dispatch({type:"INVALIDATE_PROFILE"});throw new TypeError("Authentication needed");case 16:if(!(options&&options.unstable_dontInferResponse===true)){_context.next=22;break;}_context.next=19;return response.json();case 19:_data3=_context.sent;if(_data3&&_data3.status&&typeof _data3.status.toUpperCase==="function"&&_data3.status.toUpperCase()!=="OK"){Object(__WEBPACK_IMPORTED_MODULE_7__crashLog__["b" /* logCrash */])(apiCall)({error:{message:_data3.message||_data3.msg,info:{responseStatus:_data3.status,endpoint:method}}});}return _context.abrupt("return",_data3);case 22:// Сервер не практикует корректные статусы,
// поэтому мы будем парсить всё что дают.
data=null;_context.prev=23;_context.next=26;return response.json();case 26:data=_context.sent;_context.next=35;break;case 29:_context.prev=29;_context.t1=_context["catch"](23);payload={isVisible:false,fault:{endpoint:method,status:response.status,statusText:response.statusText,options:options,message:_context.t1.message||"Unable to parse response"}};console.warn(payload);dispatch({type:"RECORD_SERVER_FAULT",payload:payload});throw _context.t1;case 35:if(!(data!==null)){_context.next=50;break;}if(!((typeof data==="undefined"?"undefined":_typeof(data))==="object"&&data.status==="ERROR"&&data.type==="verificationRequired")){_context.next=40;break;}return _context.abrupt("return",data);case 40:if(!((typeof data==="undefined"?"undefined":_typeof(data))==="object"&&typeof data.status==="string"&&data.status&&typeof data.status.toUpperCase==="function"&&data.status.toUpperCase()!=="OK")){_context.next=49;break;}_payload={isVisible:true,fault:{endpoint:method,status:response.status,statusText:response.statusText,options:options,message:data.message||data.msg,response:data}};console.warn(_payload);reportServerFault(_payload.fault);dispatch({type:"RECORD_SERVER_FAULT",payload:{isVisible:true,fault:{endpoint:method,options:options,message:data.message||data.msg,response:data}}});Object(__WEBPACK_IMPORTED_MODULE_7__crashLog__["b" /* logCrash */])(apiCall)({error:{message:data.message||data.msg,info:{responseStatus:data.status,endpoint:method}}});throw new TypeError("Unexpected server response");case 49:return _context.abrupt("return",data);case 50:case"end":return _context.stop();}}},_callee,this,[[4,11],[23,29]]);}));function fetch(_x2,_x3){return _ref.apply(this,arguments);}return fetch;}()};}var withFetch=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null,mapDispatchToFetch);var Server=Object(__WEBPACK_IMPORTED_MODULE_5__experimental_dataSource__["a" /* default */])({load:function load(key){return fetch(""+API+key,defaultOptions).then(function(response){return response.json();});}});var RawSessionStatus=function(_React$Component){_inherits(RawSessionStatus,_React$Component);function RawSessionStatus(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,RawSessionStatus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=RawSessionStatus.__proto__||Object.getPrototypeOf(RawSessionStatus)).call.apply(_ref2,[this].concat(args))),_this),_this.state={status:null,available:null},_this.pending=false,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RawSessionStatus,[{key:"probe",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var response,profile;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:if(!(this.state.available==null&&this.pending===false)){_context2.next=18;break;}this.pending=true;_context2.prev=2;_context2.next=5;return fetch(API+"/api/profile",defaultOptions);case 5:response=_context2.sent;this.pending=false;_context2.next=9;return response.json();case 9:profile=_context2.sent;this.setState({available:response.status===200});this.props.dispatch({type:"RECEIVE_PROFILE",payload:profile});_context2.next=18;break;case 14:_context2.prev=14;_context2.t0=_context2["catch"](2);this.pending=false;this.setState({available:false});case 18:case"end":return _context2.stop();}}},_callee2,this,[[2,14]]);}));function probe(){return _ref3.apply(this,arguments);}return probe;}()},{key:"render",value:function render(){this.probe();if(this.state.available==null){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Spinners_BrandSpinner__["a" /* default */],null);}else{return this.props.children(this.state.available,this.props.profile);}}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps,prevState){if(prevState.status==="INVALID"&&nextProps.status!=="INVALID"){return{status:nextProps.status,available:null};}else{return{status:nextProps.status};}}}]);return RawSessionStatus;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var SessionStatus=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{status:state.dataRequirementsStatus.profile,profile:state.profile};})(RawSessionStatus);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = mapStateToCurrency;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CurrencySymbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return withMoney; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withData__ = __webpack_require__(32);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function mapStateToCurrency(state,ownProps){if(state.apiConfigs==null||state.serverData==null){return{empty:true};}var apiConfigs=state.apiConfigs,serverData=state.serverData;var locale=Object(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["d" /* inferLocale */])(state);// irontrade config copy for siam (for now)
var fallbackUSD={symbol:"&#36;",rawSymbol:"$",internationalSymbol:{en:"$",abbr:"USD",default:"$"},// bids: [5, 10, 20, 30, 50, 100, 150, 200],
// initialDeposit: 1000,
// minFillup: 10,
// minWithdraw: 20,
// vipPayment: 900,
// minBidAmount: 1,
pattern:["symbol","sign","value"]};if((typeof ownProps==="undefined"?"undefined":_typeof(ownProps))==="object"&&ownProps.currency!=null){if(ownProps.currency==="USD"&&!apiConfigs.currencySettings[ownProps.currency]){return{currency:fallbackUSD,locale:locale};}if(_typeof(ownProps.currency)==="object"){return{currency:ownProps.currency,locale:locale};}return{currency:apiConfigs.currencySettings[ownProps.currency],locale:locale};}else{return{currency:apiConfigs.currencySettings[serverData.currency||apiConfigs.defaultCurrency],locale:locale};}}function withCurrency(Component){function EmptyWhileNoData(_ref){var empty=_ref.empty,props=_objectWithoutProperties(_ref,["empty"]);return empty?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,props);}return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToCurrency)(EmptyWhileNoData);}// const withCurrency = withData({
//   required: ["apiConfigs", "serverData"],
//   spinner: "simple",
//   selector: mapStateToCurrency
// });
var CurrencySymbol=withCurrency(function(_ref2){var currency=_ref2.currency,locale=_ref2.locale,dispatch=_ref2.dispatch,rest=_objectWithoutProperties(_ref2,["currency","locale","dispatch"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",rest,getSymbol(currency,locale));});var NBSP="\xA0";function formatMoney(amount,options){if(options.digits==="number"){return{value:Math.abs(amount).toFixed(options.digits),sign:amount<0?"-":""};}else{var withFraction=Math.abs(amount).toFixed(2);var withoutFraction=Math.abs(amount).toFixed(0);return{value:withFraction===withoutFraction+".00"?withoutFraction:withFraction,sign:amount<0?"-":""};}}function getSymbol(currency,locale){return currency&&(currency.internationalSymbol[locale]||currency.internationalSymbol.default);}function Money(_ref3){var children=_ref3.children,currency=_ref3.currency,locale=_ref3.locale,digits=_ref3.digits,dispatch=_ref3.dispatch,_ref3$Value=_ref3.Value,Value=_ref3$Value===undefined?"span":_ref3$Value,_ref3$Symbol=_ref3.Symbol,_Symbol=_ref3$Symbol===undefined?"span":_ref3$Symbol,_ref3$Sign=_ref3.Sign,Sign=_ref3$Sign===undefined?"span":_ref3$Sign,isTradePage=_ref3.isTradePage,props=_objectWithoutProperties(_ref3,["children","currency","locale","digits","dispatch","Value","Symbol","Sign","isTradePage"]);children=children||0;var units=Object.assign({},formatMoney(parseFloat(children),{digits:digits}),{space:NBSP,symbol:getSymbol(currency,locale)});var output=currency.pattern.map(function(key,i){var unit=units[key];switch(key){case"sign":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sign,{key:key+i},unit);case"space":return unit;case"symbol":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](_Symbol,{key:key+i,style:{whiteSpace:"nowrap"},istradepage:isTradePage},unit);case"value":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Value,{key:key+i,istradepage:isTradePage},unit);default:return null;}});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",{className:props.className,style:{direction:Object(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["c" /* getDirection */])(locale),display:"inline-block"}},output);}// withCurrency не пробрасывает статические методы,
// и у меня нет времени её этому учить, поэтому мы
// приклеиваем  методы к эксортируемому компоненту.
var _Money=withCurrency(Money);_Money.Value="span";_Money.Symbol="span";_Money.Sign="span";/* harmony default export */ __webpack_exports__["b"] = (_Money);// withMoney() это HoC, снабжающий компонент
// реквизитом `money()`, который форматирует
// деньги в строку.
var withMoney=Object(__WEBPACK_IMPORTED_MODULE_3__withData__["a" /* default */])({required:["apiConfigs","serverData"],spinner:"simple",selector:function selector(state){return{money:function money(amount){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var _mapStateToCurrency=mapStateToCurrency(state,options),currency=_mapStateToCurrency.currency;var units=Object.assign({},formatMoney(amount,options),{space:NBSP,symbol:currency.rawSymbol});return currency.pattern.map(function(key){return units[key];}).join("");}};}});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gaReducer; });
// !!ВАЖНО
// для поля event обязателен прификс "for_ga"
var sendEvent=function sendEvent(_ref){var event=_ref.event,eventCategory=_ref.eventCategory,_ref$eventAction=_ref.eventAction,eventAction=_ref$eventAction===undefined?null:_ref$eventAction,_ref$eventLabel=_ref.eventLabel,eventLabel=_ref$eventLabel===undefined?null:_ref$eventLabel;(window.dataLayer||[]).push({event:event,eventCategory:eventCategory,eventAction:eventAction,eventLabel:eventLabel});};var gaReducer=function gaReducer(event){var payload=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};if(false){console.log({type:event,payload:payload});}switch(event){case"TRIGGER_INTERVALS_SHOW":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_exp_time_show"});case"TRIGGER_STOCKS_SHOW":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_asset_show",eventLabel:payload.stock});case"TRIGGER_STOCKS_CLICK":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_asset_click",eventLabel:payload.stock});case"TRIGGER_PERCENT_SHOW":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_asset_ppercent_show",eventLabel:payload.stock});case"TRIGGER_PERCENT_CLICK":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_asset_ppercent_click",eventLabel:payload.stock});case"TRIGGER_BALANCE_SHOW":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_divide_balance_show"});case"TRIGGER_LOSS_SHOW":return sendEvent({event:"for_ga-disp-popup-trade-events",eventCategory:"disp-popup-trade-events",eventAction:"popup-trade-events_stop_show"});case"EARLY_SALE_POPUP_SHOW":return sendEvent({event:"for_ga-disp-early-trade-closure",eventCategory:"disp-early-trade-closure"});case"IOS_WEBAPP_POPUP_SHOW":return sendEvent({event:"for_ga-show-popup-webapp-ios",eventCategory:"install-webapp-ios"});case"WEBAPP_SHOW":return sendEvent({event:"for_ga_webapp_manifest",eventCategory:"webapp_manifest",eventAction:"webapp_manifest_show"});case"WEBAPP_ACCEPT":return sendEvent({event:"for_ga_webapp_manifest",eventCategory:"webapp_manifest",eventAction:"cl-webapp_manifest_install"});case"WEBAPP_NOTNOW":return sendEvent({event:"for_ga_webapp_manifest",eventCategory:"webapp_manifest",eventAction:"cl-webapp_manifest_cancel"});case"WEBAPP_INSTALL":return sendEvent({event:"for_ga_webapp_manifest",eventCategory:"webapp_manifest",eventAction:"cl-webapp_manifest_browser_install"});case"WEBAPP_DECLINE":return sendEvent({event:"for_ga_webapp_manifest",eventCategory:"webapp_manifest",eventAction:"cl-webapp_manifest_browser_cancel"});case"CLICKBTN_LOGIN_MAINPAGE"://Нажатие кнопки "Login" на главной странице
return sendEvent({event:"for_ga-cl-main-login_btn",eventCategory:"cl-main-login_btn",eventAction:payload.userId});case"CLICKBTN_REGISTER_MAINPAGE"://Нажатие кнопки "Register" на главной странице
return sendEvent({event:"for_ga-cl-main-reg_btn",eventCategory:"cl-main-reg_btn",eventAction:payload.userId});case"SUCCESS_REGISTARTION"://Успешная регистрация
return sendEvent({event:"for_ga-bk-reg_success",eventCategory:"bk-reg_success",eventAction:payload.userId,eventLabel:payload.regType// email / facebook / google
});case"CLICKBTN_SOCIALREGISTER_MAINPAGE"://Нажатие кнопки "Register" на главной странице после регистрации через соц. сеть
return sendEvent({event:"for_ga-cl-main-soc_reg_btn",eventCategory:"cl-main-soc_reg_btn",eventAction:payload.userId});case"CLICKBTN_DOWNLOADAPP_MAINPAGE"://Клик по кнопке для загрузки мобильного приложения
return sendEvent({event:"for_ga-cl-all-get_app",eventCategory:"cl-all-get_app",eventAction:payload.appSrc});case"CLICKBTN_OPENDEMOACC_MAINPAGE"://Клик по кнопке "Open Demo Account" на главной странице
return sendEvent({event:"for_ga-cl-main-open_demo_acc",eventCategory:"cl-main-open_demo_acc"});case"CLICKLINK_FOOTER_MAINPAGE"://Клик по ссылкам в футере
return sendEvent({event:"for_ga-cl-ftr-links",eventCategory:"cl-ftr-links",eventAction:payload.linkUrl,eventLabel:payload.linkText});case"CLICKBTN_SEARCH"://Клик по кнопке поиска
return sendEvent({event:"for_ga-cl-all-search",eventCategory:"cl-all-search",eventAction:payload.searchQuery});case"CLICKBTN_REF_SHARE":// кнопки шэра реферальной ссылки
return sendEvent({event:"for_ga-cl-all-referral_link_share",eventCategory:"cl-all-referral_link_share",eventAction:payload.clickId,eventLabel:payload.pagePath});case"CLICKBTN_FILLUP":// клик кнопки Pay на fillup
return sendEvent({event:"for_ga-cl-deposit-pay_btn",eventCategory:"cl-deposit-pay_btn",eventAction:payload.paymentMethod,eventLabel:payload.amount+"__"+payload.bonusAmount+"%"});case"CLICKBTN_VERIFY":// клик кнопки верификации в профиле
return sendEvent({event:"for_ga-cl-profile-verification_btn",eventCategory:"cl-profile-verification_btn"});case"CLICKBTN_DEPOSIT_MAINPAGE":// клик кнопки депозит на главной
return sendEvent({event:"for_ga-cl-main-deposit_btn",eventCategory:"cl-main-deposit_btn"});case"CLICKBTN_TRADE_MAINPAGE_HEADER":return sendEvent({event:"for_ga-cl-main-hdr-trade_now_btn",eventCategory:"cl-main-hdr-trade_now_btn"});case"CLICKBTN_DEPOSIT_MENU":// ссылка депозита в меню
return sendEvent({event:"for_ga-cl-all-menu-deposit_btn",eventCategory:"cl-all-menu-deposit_btn"});case"CLICKLINK_NAVIGATION":// клик по ссылкам в меню
return sendEvent({event:"for_ga-cl-all-menu-link",eventCategory:"cl-all-menu-link",eventAction:payload.linkUrl,eventLabel:payload.linkText});case"CLICKLINK_NAVIGATION_AB":return sendEvent({event:"for_ga-cl-all-menu-button",eventCategory:"cl-all-menu-button",eventAction:payload.linkUrl,eventLabel:payload.linkText});case"CLICKLINK_TRADE_DEPOSIT_HEADER":return sendEvent({event:"for_ga-cl-all-trade_deposit_btn",eventCategory:"cl-all-trade_deposit_btn",eventAction:payload.linkText,eventLabel:payload.pageUrl});case"CLICKBTN_TRADE_DEPOSIT_ACCOUNT":return sendEvent({event:"for_ga-cl-trade-trade_deposit_btn",eventCategory:"cl-trade-trade_deposit_btn",eventAction:payload.buttonText,eventLabel:payload.accountType});case"CLICKBTN_TRADE_ADD_MONEY":return sendEvent({event:"for_ga-cl-trade-add_money_btn",eventCategory:"cl-trade-add_money_btn"});case"CLICKBTN_PPP_DEPOSIT_SHOW":return sendEvent({event:"for_ga-disp-popup-demorefill",eventCategory:"disp-popup-demorefill",eventAction:"cl_popup2_show"});case"CLICKBTN_PPP_DEPOSIT_REFILL":return sendEvent({event:"for_ga-disp-popup-demorefill",eventCategory:"disp-popup-demorefill",eventAction:"cl_popup2_refill"});case"CLICKBTN_PPP_DEPOSIT_FILLUP":return sendEvent({event:"for_ga-disp-popup-demorefill",eventCategory:"disp-popup-demorefill",eventAction:"cl_popup2_fillup"});case"SHOW_TOUR":return sendEvent({event:"for_ga-disp-trade-tour_show",eventCategory:"disp-trade-tour_old"});case"CLICKBTN_GET_STARTED_TOUR":return sendEvent({event:"for_ga-cl-trade-start_tour_btn",eventCategory:"disp-trade-tour_old"});case"CLICKBTN_START_TOUR":return sendEvent({event:"for_ga-cl-trade-tour_to_start",eventCategory:"disp-trade-tour_old"});case"CLICKBTN_TRADE_TOUR":return sendEvent({event:"for_ga-cl-trade-tour_to_trade",eventCategory:"disp-trade-tour_old"});case"CLICKBTN_HELP_TOUR":return sendEvent({event:"for_ga-cl-trade-tour_to_help",eventCategory:"disp-trade-tour_old"});case"CLICKBTN_SHOW_TRADE_SETTINGS":return sendEvent({event:"for_ga-disp-trade-settings",eventCategory:"disp-trade-settings"});case"CLICKBTN_CHART_TYPE":return sendEvent({event:"for_ga-cl-trade-settings-chart_type",eventCategory:"cl-trade-settings-chart_type",eventAction:payload.buttonText});case"CLICKBTN_INTERVAL":return sendEvent({event:"for_ga-cl-trade-settings-intervals",eventCategory:"cl-trade-settings-intervals",eventAction:payload.buttonText});case"CLICKBTN_MOOD":return sendEvent({event:"for_ga-cl-trade-settings-indicator_tm",eventCategory:"cl-trade-settings-indicator_tm",eventAction:payload.value});case"CLICKBTN_INDICATOR":return sendEvent({event:"for_ga-cl-trade-settings-indicators",eventCategory:"cl-trade-settings-indicators",eventAction:payload.buttonText});case"CLICKBTN_THEME":return sendEvent({event:"for_ga-cl-trade-settings-theme",eventCategory:"cl-trade-settings-theme",eventAction:payload.buttonText});case"CLICKBTN_LINE":return sendEvent({event:"for_ga-cl-trade-settings-chart_line",eventCategory:"cl-trade-settings-chart_line",eventAction:payload.buttonText});case"CLICKBTN_SETTINGS_COLOR":return sendEvent({event:"for_ga-cl-trade-settings-chart_color",eventCategory:"cl-trade-settings-chart_color"});case"CLICKBTN_SOUND":return sendEvent({event:"for_ga-cl-trade-settings-sound_effects",eventCategory:"cl-trade-settings-sound_effects",eventAction:payload.value});case"CLICKBTN_CHANGE_THEME":return sendEvent({event:"for_ga-cl-trade-change_theme",eventCategory:"cl-trade-change_theme",eventAction:payload.theme});case"SHOW_TOURNAMENT_JOIN_POPUP":return sendEvent({event:"for_ga-disp-tournaments-join_window",eventCategory:"disp-tournaments-join_window"});case"CLICKBTN_JOIN_TOURNAMENT":return sendEvent({event:"for_ga-cl-tournaments-modal-join",eventCategory:"cl-tournaments-modal-join"});case"SHOW_TOURNAMENT_LEAVE_POPUP":return sendEvent({event:"for_ga-disp-tournaments-quit_window",eventCategory:"disp-tournaments-quit_window"});case"CLICKBTN_LEAVE_TOURNAMENT":return sendEvent({event:"for_ga-cl-tournaments-modal-quit",eventCategory:"cl-tournaments-modal-quit"});case"CLICKBTN_SAVE_NAME":return sendEvent({event:"for_ga-cl-profile-full_name",eventCategory:"cl-profile-full_name",eventAction:payload.name});case"CLICKBTN_SENDCODE_PROFILE":return sendEvent({event:"for_ga-cl-profile-send_code",eventCategory:"cl-profile-send_code"});case"CLICKBTN_CHANGE_PASSWORD":return sendEvent({event:"for_ga-cl-profile-change_pwd",eventCategory:"cl-profile-change_pwd"});case"CLICKBTN_PASSWORD_SUBMIT":return sendEvent({event:"for_ga-cl-profile-change_pwd_apply",eventCategory:"cl-profile-change_pwd_apply"});case"CLICKBTN_CHANGE_CONFIRMED_EMAIL":return sendEvent({event:"for_ga-cl-profile_change-email_btn",eventCategory:"cl-profile_change-email_btn"});case"CLICKBTN_SEND_EMAIL_CODE":return sendEvent({event:"for_ga-cl-profile_send-code_email_btn",eventCategory:"cl-profile_send-code_email_btn"});case"CLICKBTN_CHANGE_CONFIRMED_PHONE":return sendEvent({event:"for_ga-cl-profile_change-phone_btn",eventCategory:"cl-profile_change-phone_btn"});case"CLICKBTN_SEND_PHONE_CODE":return sendEvent({event:"for_ga-cl-profile_send-code_phone_btn",eventCategory:"cl-profile_send-code_phone_btn"});case"CLICKBTN_CHART_TIME":return sendEvent({event:"for_ga-cl-trade-history_length",eventCategory:"cl-trade-history_length",eventAction:payload.buttonText,eventLabel:payload.stock});case"CLICKBTN_TIME_MINUS":return sendEvent({event:"for_ga-cl-trade-workspace_farther",eventCategory:"cl-trade-workspace_farther",eventLabel:payload.stock});case"CLICKBTN_TIME_PLUS":return sendEvent({event:"for_ga-cl-trade-workspace_closer",eventCategory:"cl-trade-workspace_closer",eventLabel:payload.stock});case"CLICKBTN_TIME_NOW":return sendEvent({event:"for_ga-cl-trade-workspace_goto_now",eventCategory:"cl-trade-workspace_goto_now",eventLabel:payload.stock});case"CLICKBTN_STOCK":return sendEvent({event:"for_ga-cl-trade-workspace_assets",eventCategory:"cl-trade-workspace_assets",eventAction:payload.buttonText});case"CLICKBTN_OPEN_DEMO":return sendEvent({event:"for_ga-cl-main-open_demo_acc",eventCategory:"cl-main-open_demo_acc",eventAction:payload.pageUrl});case"CLICKBTN_BOTTOM_TRADE":return sendEvent({event:"for_ga-cl-main-ftr-trade_now_btn",eventCategory:"cl-main-ftr-trade_now_btn",eventAction:payload.pageUrl});case"CLICKBTN_UPPER_BET":return sendEvent({event:"for_ga-cl-trade-bet_upper",eventCategory:"cl-trade-bet",eventAction:"upper"});case"CLICKBTN_LOWER_BET":return sendEvent({event:"for_ga-cl-trade-bet_lower",eventCategory:"cl-trade-bet",eventAction:"lower"});case"CLICKBTN_CHANGE_LANG":return sendEvent({event:"for_ga-cl-all-change_lang",eventCategory:"cl-all-change_lang",eventAction:payload.lang});case"CLICKBTN_LATER_TOUR":return sendEvent({event:"for_ga-event-to-ga",eventCategory:"disp-trade-tour_old",eventAction:"show_later",eventLabel:"Показать тур позже"});case"CLICKBTN_GO_AFTER_TOUR":return sendEvent({event:"for_ga-event-to-ga",eventCategory:"disp-trade-tour_old",eventAction:payload.page,eventLabel:payload.pageLabel});case"SHOW_NEW_TOUR":return sendEvent({event:"for_ga-event-to-ga",eventCategory:"disp-trade-tour_old",eventAction:"shows-tour",eventLabel:"Показ нового тура"});case"TOUR_PAGE":return sendEvent({event:"for_ga-event-to-ga",eventCategory:"disp-trade-tour_old",eventAction:payload.slide,eventLabel:payload.slideText});case"SHOW_TOUR_3000":return sendEvent({event:"for_ga-disp-trade-tour_new1_show",eventCategory:"disp-trade-tour_new1",eventAction:"for_ga-disp-trade-tour_new1_show"});case"SHOW_LATER_TOUR_3000":return sendEvent({event:"for_ga-cl-trade-tour_new1_later_btn",eventCategory:"disp-trade-tour_new1",eventAction:"for_ga-cl-trade-tour_new1_later_btn"});case"SHOW_STEP_TOUR_3000":return sendEvent({event:"for_ga-trade-tour_new1_step"+payload.step,eventCategory:"disp-trade-tour_new1",eventAction:"for_ga-trade-tour_new1_step"+payload.step});case"CLICK_TRADE_TOUR_3000":return sendEvent({event:"for_ga-cl-trade-tour_new1_to_trade",eventCategory:"disp-trade-tour_new1",eventAction:"for_ga-cl-trade-tour_new1_to_trade"});case"CLICK_HELP_TOUR_3000":return sendEvent({event:"for_ga-cl-trade-tour_new1_to_help",eventCategory:"disp-trade-tour_new1",eventAction:"for_ga-cl-trade-tour_new1_to_help"});case"SHOW_TOUR_3001":return sendEvent({event:"for_ga-disp-trade-tour_new2_show",eventCategory:"disp-trade-tour_new2",eventAction:"for_ga-disp-trade-tour_new2_show"});case"SHOW_LATER_TOUR_3001":return sendEvent({event:"for_ga-cl-trade-tour_new2_later_btn",eventCategory:"disp-trade-tour_new2",eventAction:"for_ga-cl-trade-tour_new2_later_btn"});case"SHOW_STEP_TOUR_3001":return sendEvent({event:"for_ga-trade-tour_new2_step"+payload.step,eventCategory:"disp-trade-tour_new2",eventAction:"for_ga-trade-tour_new2_step"+payload.step});case"CLICK_TRADE_TOUR_3001":return sendEvent({event:"for_ga-cl-trade-tour_new2_to_trade",eventCategory:"disp-trade-tour_new2",eventAction:"for_ga-cl-trade-tour_new2_to_trade"});case"CLICK_HELP_TOUR_3001":return sendEvent({event:"for_ga-cl-trade-tour_new2_to_help",eventCategory:"disp-trade-tour_new2",eventAction:"for_ga-cl-trade-tour_new2_to_help"});case"CLICK_SKIP_TOUR_3000":return sendEvent({event:"for_ga-cl-trade-tour_new1_later_btn",eventCategory:"disp-trade-tour_new1",eventAction:"new1tour-skip-step"+payload.step});case"CLICK_SKIP_TOUR_3001":return sendEvent({event:"for_ga-cl-trade-tour_new2_later_btn",eventCategory:"disp-trade-tour_new2",eventAction:"new2tour-skip-step"+payload.step});case"ACTIVATE_TOUR_FROM_SIDEBAR":return sendEvent({event:"for_ga-cl-trade-tour_from",eventCategory:"enter-trade-tour",eventAction:"tour_from_menu"});case"ACTIVATE_TOUR_FROM_ICON":return sendEvent({event:"for_ga-cl-trade-tour_from",eventCategory:"enter-trade-tour",eventAction:"tour_from_icon"});case"ACTIVATE_TOUR_FROM_HELPDESK":return sendEvent({event:"for_ga-cl-trade-tour_from",eventCategory:"enter-trade-tour",eventAction:"tour_from_hc"});case"IRONCARD_POLL_YES":return sendEvent({event:"for_ga-cl-ironcard_poll_yes",eventCategory:"cl-ironcard_poll",eventAction:"ironcard_poll_yes"});case"IRONCARD_POLL_NO":return sendEvent({event:"for_ga-cl-ironcard_poll_no",eventCategory:"cl-ironcard_poll",eventAction:"ironcard_poll_no"});case"CLICK_MOBILE_SETTINGS":return sendEvent({event:"for_ga-cl-settings-mobile-link",eventCategory:"cl-settings-mobile-link",eventAction:"for_ga-cl-settings-mobile-link"});case"CLICK_MOBILE_DEALS":return sendEvent({event:"for_ga-cl-deals-mobile-link",eventCategory:"cl-deals-mobile-link",eventAction:"for_ga-cl-deals-mobile-link"});case"OPEN_SOCIAL_TRADING":return sendEvent({event:"for_ga-cl-social-trading-on",eventCategory:"cl-social-trading-on",eventAction:"social-trading-on"});case"CLOSE_SOCIAL_TRADING":return sendEvent({event:"for_ga-cl-social-trading-off",eventCategory:"cl-social-trading-off",eventAction:"social-trading-off"});case"CLICK_SOCIAL_TRADING_ASSET":return sendEvent({event:"for_ga-cl-social-trading-asset",eventCategory:"cl-social-trading-asset",eventAction:"social-trading-asset",eventLabel:payload.asset});case"DEAL_COMPENSATED":return sendEvent({event:"for_ga_safe_deal",eventCategory:"safe_deal",eventAction:"safe_deal_used",eventLabel:payload.amount});case"CANCEL_COMPENSATE":return sendEvent({event:"for_ga_safe_deal",eventCategory:"safe_deal",eventAction:"safe_deal_notused_trade",eventLabel:payload.amount});case"COMPENSATE_TIMEOUT":return sendEvent({event:"for_ga_safe_deal",eventCategory:"safe_deal",eventAction:"safe_deal_notused_time",eventLabel:payload.amount});case"CLOSE_TOUR":return sendEvent({event:"for_ga_cl-trade-tour_old_later_btn",eventCategory:"disp-trade-tour_old",eventAction:"tour_old-skip-step"+payload.currentSlide});case"START_TEST_FOR_USERS":return sendEvent({event:"for_ga-disp-test-for-users",eventCategory:"disp-test-for-users",eventAction:"disp-test-for-users_test_start"});case"REFUSE_TEST_FOR_USERS":return sendEvent({event:"for_ga-disp-test-for-users",eventCategory:"disp-test-for-users",eventAction:"disp-test-for-users_test_refuse"});case"ANSWER_TEST_FOR_USERS":return sendEvent({event:"for_ga-disp-test-for-users",eventCategory:"disp-test-for-users",eventAction:"disp-test-for-users_test_answer_"+payload.questionNumber,eventLabel:payload.answerText});case"TO_TRADE_TEST_FOR_USERS":return sendEvent({event:"for_ga-disp-test-for-users",eventCategory:"disp-test-for-users",eventAction:"disp-test-for-users_test_to_trade"});case"SHOW_RATE_APP_POPUP":return sendEvent({event:"for_ga-app-rate",eventCategory:"disp-app-rate",eventAction:"disp-app-rate-display"});case"SET_POSITIVE_APP_RATING":return sendEvent({event:"for_ga-app-rate",eventCategory:"disp-app-rate",eventAction:"disp-app-rate-positive",eventLabel:payload.rate});case"SET_NEGATIVE_APP_RATING":return sendEvent({event:"for_ga-app-rate",eventCategory:"disp-app-rate",eventAction:"disp-app-rate-negative",eventLabel:payload.rate});case"LATER_APP_RATING":return sendEvent({event:"for_ga-app-rate",eventCategory:"disp-app-rate",eventAction:"disp-app-rate-later"});case"SELECT_WITHDRAW_TOUR":return sendEvent({event:"for_ga-event-to-ga",eventCategory:"disp-trade-tour_old",eventAction:"cl-withdrawal",eventLabel:payload.withdrawMethod});case"RATE_APP_ERROR":return sendEvent({event:"for_ga-app-rate",eventCategory:"error-app-rate",eventAction:"error-app-rate-submit",eventLabel:payload.error});case"BELL_OPEN":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"disp-bell"});case"BELL_ALL_TOURNAMENTS_CLICK":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-all_tournaments"});case"BELL_ALL_NEWS_CLICK":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-all_news"});case"BELL_GO_TO_TOURNAMENT":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-enter_tournament",eventLabel:payload.type});case"BELL_GO_TO_NEWS":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-open_news_article",eventLabel:payload.title});case"BELL_GO_TO_PROMO":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-use_bonus_promocode"});case"BELL_GO_TO_SUCCESS_DEPOSIT":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-success_deposit"});case"BELL_GO_TO_SUCCESS_WITHDRAWAL":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-success_withdrawal"});case"BELL_GO_TO_TOURNAMENT_INVITE":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-enter_tournament_by_invitation"});case"BELL_GO_TO_SAFE_DEALS":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-get_bonus_safe_deals"});case"BELL_SUCCESS_VERIFICATION":return sendEvent({event:"for_ga-cl-bell",eventCategory:"cl-bell",eventAction:"cl-verification_approve"});case"SHOW_VIDEO_TOUR":return sendEvent({event:"for_ga-trade-tour_video",eventCategory:"trade-tour_video",eventAction:"trade-tour_video-display"});case"CLICKBTN_LATER_VIDEO_TOUR":return sendEvent({event:"for_ga-trade-tour_video",eventCategory:"trade-tour_video",eventAction:"trade-tour_video-later"});case"CLICKBTN_SKIP_VIDEO_TOUR":return sendEvent({event:"for_ga-trade-tour_video",eventCategory:"trade-tour_video",eventAction:"trade-tour_video-skip"});case"END_VIDEO_TOUR":return sendEvent({event:"for_ga-trade-tour_video",eventCategory:"trade-tour_video",eventAction:"trade-tour_video-complete"});case"TOUR_VIDEO_TO_TRADE":return sendEvent({event:"for_ga-trade-tour_video",eventCategory:"trade-tour_video",eventAction:"trade-tour_video-to_trade"});case"TOUR_VIDEO_TO_HELPDESK":return sendEvent({event:"for_ga-trade-tour_video",eventCategory:"trade-tour_video",eventAction:"trade-tour_video-to_helpdesk"});default:return false;}};

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserRouter; });
/* unused harmony export HashRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NavLink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(474);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2_react_router__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_tiny_warning__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_tiny_invariant__ = __webpack_require__(352);











/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  BrowserRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    forceRefresh: PropTypes.bool,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number
  };

  BrowserRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["c" /* Router */], {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  HashRouter.propTypes = {
    basename: PropTypes.string,
    children: PropTypes.node,
    getUserConfirmation: PropTypes.func,
    hashType: PropTypes.oneOf(["hashbang", "noslash", "slash"])
  };

  HashRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.") : void 0;
  };
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
/**
 * The public API for rendering a history-aware <a>.
 */


var Link =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Link, _React$Component);

  function Link() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Link.prototype;

  _proto.handleClick = function handleClick(event, history) {
    if (this.props.onClick) this.props.onClick(event);

    if (!event.defaultPrevented && // onClick prevented default
    event.button === 0 && ( // ignore everything but left clicks
    !this.props.target || this.props.target === "_self") && // let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        var method = this.props.replace ? history.replace : history.push;
        method(this.props.to);
      }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props = this.props,
        innerRef = _this$props.innerRef,
        replace = _this$props.replace,
        to = _this$props.to,
        rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["innerRef", "replace", "to"]); // eslint-disable-line no-unused-vars


    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["e" /* __RouterContext */].Consumer, null, function (context) {
      !context ?  false ? invariant(false, "You should not use <Link> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_8_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, context.location) : to;
      var href = location ? context.history.createHref(location) : "";
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a", Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        onClick: function onClick(event) {
          return _this.handleClick(event, context.history);
        },
        href: href,
        ref: innerRef
      }));
    });
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

if (false) {
  var toType = PropTypes.oneOfType([PropTypes.string, PropTypes.object]);
  var innerRefType = PropTypes.oneOfType([PropTypes.string, PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]);
  Link.propTypes = {
    innerRef: innerRefType,
    onClick: PropTypes.func,
    replace: PropTypes.bool,
    target: PropTypes.string,
    to: toType.isRequired
  };
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


function NavLink(_ref) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      location = _ref.location,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      rest = Object(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "strict", "style", "to"]);

  var path = typeof to === "object" ? to.pathname : to; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["b" /* Route */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;
      var isActive = !!(isActiveProp ? isActiveProp(match, location) : match);
      var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
      var style = isActive ? Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styleProp, activeStyle) : styleProp;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link, Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_extends__["a" /* default */])({
        "aria-current": isActive && ariaCurrent || null,
        className: className,
        style: style,
        to: to
      }, rest));
    }
  });
}

if (false) {
  var ariaCurrentType = PropTypes.oneOf(["page", "step", "location", "date", "time", "true"]);
  NavLink.propTypes = _extends({}, Link.propTypes, {
    "aria-current": ariaCurrentType,
    activeClassName: PropTypes.string,
    activeStyle: PropTypes.object,
    className: PropTypes.string,
    exact: Route.propTypes.exact,
    isActive: PropTypes.func,
    location: PropTypes.object,
    strict: Route.propTypes.strict,
    style: PropTypes.object
  });
}




/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

var emptyFunction_1 = emptyFunction;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var invariant_1 = invariant;

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction_1;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

var warning_1 = warning;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret;

if (false) {
  var invariant$1 = invariant_1;
  var warning$1 = warning_1;
  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
        } catch (ex) {
          error = ex;
        }
        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

var checkPropTypes_1 = checkPropTypes;

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret_1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant_1(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning_1(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction_1.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning_1(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction_1.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret_1) {
      // It is still safe when called from React.
      return;
    }
    invariant_1(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  }
  shim.isRequired = shim;
  function getShim() {
    return shim;
  }
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction_1;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = factoryWithThrowingShims();
}
});

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var NODE_ENV = "production";

var invariant$3 = function(condition, format, a, b, c, d, e, f) {
  if (NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

var invariant_1$2 = invariant$3;

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

var camel2hyphen_1 = camel2hyphen;

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen_1(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and ';
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', ';
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

var json2mq_1 = json2mq;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * Conditionally renders based on whether or not a media query matches.
 */

var Media = function (_React$Component) {
  inherits(Media, _React$Component);

  function Media() {
    var _temp, _this, _ret;

    classCallCheck(this, Media);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      matches: _this.props.defaultMatches
    }, _this.updateMatches = function () {
      return _this.setState({ matches: _this.mediaQueryList.matches });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  Media.prototype.componentWillMount = function componentWillMount() {
    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== "object") return;

    var targetWindow = this.props.targetWindow || window;

    invariant_1$2(typeof targetWindow.matchMedia === "function", "<Media targetWindow> does not support `matchMedia`.");

    var query = this.props.query;

    if (typeof query !== "string") query = json2mq_1(query);

    this.mediaQueryList = targetWindow.matchMedia(query);
    this.mediaQueryList.addListener(this.updateMatches);
    this.updateMatches();
  };

  Media.prototype.componentWillUnmount = function componentWillUnmount() {
    this.mediaQueryList.removeListener(this.updateMatches);
  };

  Media.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        render = _props.render;
    var matches = this.state.matches;


    return render ? matches ? render() : null : children ? typeof children === "function" ? children(matches) : !Array.isArray(children) || children.length // Preact defaults to empty children array
    ? matches ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children) : null : null : null;
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Media.propTypes = {
  defaultMatches: propTypes.bool,
  query: propTypes.oneOfType([propTypes.string, propTypes.object, propTypes.arrayOf(propTypes.object.isRequired)]).isRequired,
  render: propTypes.func,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  targetWindow: propTypes.object
};
Media.defaultProps = {
  defaultMatches: true
};

/* harmony default export */ __webpack_exports__["a"] = (Media);


/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActiveTournament; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TournamentAPIProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_memoize__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Optimistic__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popups_Error__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Helpdesk_withFetch__ = __webpack_require__(816);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tournament=__WEBPACK_IMPORTED_MODULE_1_react__["createContext"](null);var OptimisticTournamentContext=__WEBPACK_IMPORTED_MODULE_1_react__["createContext"](null);var ActiveTournament=OptimisticTournamentContext.Consumer;/* harmony default export */ __webpack_exports__["c"] = (Tournament);var INVALIDATION_THRESHOLD=60*1000;function validateSensibleResponse(response,requestTime){switch(response.status){case"OK":return{status:"Resolved",lastRequestTime:requestTime,value:response.payload};case"ERROR":return{status:"Rejected",lastRequestTime:requestTime,code:response.suspicious?"suspicious":response.code,message:response.message,error:null};default:throw new TypeError("Unexpected response status");}}var insaneResponseValidations={"/api/withdraw/banks/branches":function apiWithdrawBanksBranches(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/ajax/declineBonus":function ajaxDeclineBonus(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/request-withdraw":function requestWithdraw(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/announcements":function apiAnnouncements(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/bell-tolls-items":function apiBellTollsItems(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/ajax/stockHistory":function ajaxStockHistory(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/profile":function apiProfile(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/getAssets":function apiGetAssets(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/promo-code-info":function apiPromoCodeInfo(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/getAccounts":function apiGetAccounts(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/is-restricted":function apiIsRestricted(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};},"/api/withdraw/output-methods":function apiWithdrawOutputMethods(response,requestTime){return{status:"Resolved",lastRequestTime:requestTime,value:response};}};function validateResponse(key,response,requestTime){var method=key.split("?")[0];if(key.startsWith("/helpdesk")){return{status:"Resolved",lastRequestTime:requestTime,value:response};}else if(insaneResponseValidations[method]!=null){return insaneResponseValidations[method](response,requestTime);}else{return validateSensibleResponse(response,requestTime);}}var TournamentAPIProvider=function(_React$Component){_inherits(TournamentAPIProvider,_React$Component);function TournamentAPIProvider(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,TournamentAPIProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TournamentAPIProvider.__proto__||Object.getPrototypeOf(TournamentAPIProvider)).call.apply(_ref,[this].concat(args))),_this),_this.state={errorCode:null,lastUpdatedEntity:null},_this.cache={},_this.timer=null,_this.optimisticTournamentRef=__WEBPACK_IMPORTED_MODULE_1_react__["createRef"](),_this.helpdeskQueries=function(key){var additionalQueries={};if(key.includes("?")){additionalQueries=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(key.split("?")[1]);key=key.split("?")[0];}var object=Object.assign({},additionalQueries,{lang:Object(__WEBPACK_IMPORTED_MODULE_8__Helpdesk_withFetch__["b" /* inferHelpdeskLocale */])(_this.props.locale),currency:_this.props.currency.toUpperCase()});if(_this.props.profile!=null){object.tags=4;}return key+"?"+__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(object);},_this.getEntity=function(key){if(key.startsWith("/helpdesk")){key=_this.helpdeskQueries(key);}var entity=_this.cache[key];if(entity==null){var freshEntity={status:"Empty",value:null};_this.cache[key]=freshEntity;return freshEntity;}else{return entity;}},_this.actuallyFetchEntity=function(key){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{request:{}};var time=Date.now();var request=options.request;if(key.startsWith("/helpdesk")){key=_this.helpdeskQueries(key);request={headers:{"X-LOCALE":Object(__WEBPACK_IMPORTED_MODULE_8__Helpdesk_withFetch__["b" /* inferHelpdeskLocale */])(_this.props.locale),"X-CURRENCY":_this.props.currency.toUpperCase(),accept:"application/json"}};}var nextVersionPromise=Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["c" /* apiCall */])(key,request).then(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(response){var body;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(response.status===401){_this.props.onLogout();console.warn("Authentication needed");}if(!(response.status>=500)){_context.next=3;break;}throw new TypeError("Server error, status "+response.status);case 3:_context.prev=3;_context.next=6;return response.json();case 6:body=_context.sent;if(!key.startsWith("/helpdesk")&&body.status!=="OK"){Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["g" /* reportServerFault */])({endpoint:key,status:response.status,statusText:response.statusText,options:{},message:body.message,response:body});}if(!(key.startsWith("/helpdesk")&&response.headers.get("x-total-pages")!=null)){_context.next=10;break;}return _context.abrupt("return",{pages:response.headers.get("x-total-pages"),data:body});case 10:return _context.abrupt("return",body);case 13:_context.prev=13;_context.t0=_context["catch"](3);Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["g" /* reportServerFault */])({endpoint:key,status:response.status,statusText:response.statusText,options:{},message:"Unable to parse response"});throw _context.t0;case 17:case"end":return _context.stop();}}},_callee,_this2,[[3,13]]);}));return function(_x2){return _ref2.apply(this,arguments);};}()).then(function(body){return validateResponse(key,body,time);},function(error){return{status:"Rejected",lastRequestTime:time,error:error};}).catch(console.info);_this.setCache(function(cache){var prevVerison=cache[key];var nextVersion={status:"Pending",lastRequestTime:time,promise:nextVersionPromise,value:prevVerison!=null?prevVerison.value:null};return _defineProperty({},key,nextVersion);});nextVersionPromise.then(function(nextVersion){_this.setCache(function(cache){var prevVerison=cache[key];if(prevVerison!=null){return _defineProperty({},key,Object.assign({value:prevVerison.value},nextVersion));}return _defineProperty({},key,nextVersion);});_this.setState(function(state){return{lastUpdatedEntity:nextVersion,errorCode:nextVersion.status==="Rejected"?nextVersion.code:state.errorCode};});});return nextVersionPromise;},_this.invalidateEntity=function(key){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var entity=_this.getEntity(key);if(entity.status==="Pending"&&options.force!==true){return entity.promise;}var promise=_this.actuallyFetchEntity(key,options);// Кастомная логика для инвалидациии /stats,
// потому что там хранится баланс, а за его
// состоянием мы следим особенно пристально.
if(key==="/api/tournaments/stats"&&_this.optimisticTournamentRef.current!=null){_this.optimisticTournamentRef.current.invalidate({promise:promise});}return promise;},_this.handleStatsInvalidation=function(options){var promise=options!=null&&options.promise!=null?options.promise:_this.invalidateEntity("/api/tournaments/stats");return promise.then(function(entity){if(entity.status==="Resolved"){return entity.value.active_tournament;}else{throw entity.error;}});},_this.readEntity=function(key){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var entity=_this.getEntity(key);if(entity.status==="Empty"){_this.actuallyFetchEntity(key,options);return _this.getEntity(key);}else if(entity.status==="Resolved"&&typeof options.follow==="string"){// Фича follow позволяет перезапросить данные если какой-то
// другой метод обновился недавно
var followedEntity=_this.getEntity(options.follow);if(typeof entity.lastRequestTime==="number"&&typeof followedEntity.lastRequestTime==="number"&&entity.lastRequestTime<followedEntity.lastRequestTime){_this.actuallyFetchEntity(key,options);return _this.getEntity(key);}else{return entity;}}else{return entity;}},_this.clearEntities=function(startKey){var _loop=function _loop(_key2){if(_this.cache.hasOwnProperty(_key2)&&_key2.startsWith(startKey)){_this.setCache(function(cache){var prevVersion=cache[_key2];var nextVersion={status:"Empty",value:prevVersion!=null?prevVersion.value:null};return _defineProperty({},_key2,nextVersion);});}};for(var _key2 in _this.cache){_loop(_key2);}},_this.createRef=__WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default()(function(kek,errorCode){return{errorCode:errorCode,dismissError:_this.dismissError,simulateError:_this.simulateError,// getEntity: this.getEntity,
readEntity:_this.readEntity,fetchEntity:_this.invalidateEntity,clearEntities:_this.clearEntities};}),_this.invalidationLoop=function(){var importantEntities=_this.props.profile!=null?["/api/tournaments/stats"]:[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=importantEntities[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _key3=_step.value;var entity=_this.getEntity(_key3);switch(entity.status){case"Empty":_this.invalidateEntity(_key3);break;case"Pending":break;case"Resolved":case"Rejected":if(Date.now()-entity.lastRequestTime+1000>INVALIDATION_THRESHOLD){_this.invalidateEntity(_key3);}break;default:break;}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}},_this.dismissError=function(){_this.setState({errorCode:null});},_this.simulateError=function(code){_this.setState({errorCode:code});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TournamentAPIProvider,[{key:"setCache",value:function setCache(updater){var diff=updater(this.cache);Object.assign(this.cache,diff);}},{key:"componentDidMount",value:function componentDidMount(){this.timer=setInterval(this.invalidationLoop,INVALIDATION_THRESHOLD);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.locale!==prevProps.locale){for(var _key4 in this.cache){if(this.cache.hasOwnProperty(_key4)){if(_key4.startsWith("/api/tournaments/stats")||_key4.startsWith("/api/tournaments/info")||_key4.startsWith("/api/tournaments/list")||_key4.startsWith("/api/announcements")||_key4.startsWith("/api/bell-tolls-items")){this.invalidateEntity(_key4);}}}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);}},{key:"render",value:function render(){var _this3=this;var active_tournament=null;if(this.props.profile!=null){active_tournament=__WEBPACK_IMPORTED_MODULE_2_idx___default()(this.readEntity("/api/tournaments/stats"),function(stats){return stats.value.active_tournament;});}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Tournament.Provider,{value:this.createRef(this.state.lastUpdatedEntity,this.state.errorCode)},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Optimistic__["a" /* default */],{ref:this.optimisticTournamentRef,value:active_tournament,onInvalidate:this.handleStatsInvalidation},function(tournament){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OptimisticTournamentContext.Provider,{value:tournament},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Popups_Error__["a" /* DetermineErrorPopup */],{errorCode:_this3.state.errorCode}),_this3.props.children);}));}}]);return TournamentAPIProvider;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 * @format
 */

 // eslint-disable-line strict

/**
 * Traverses properties on objects and arrays. If an intermediate property is
 * either null or undefined, it is instead returned. The purpose of this method
 * is to simplify extracting properties from a chain of maybe-typed properties.
 *
 * === EXAMPLE ===
 *
 * Consider the following type:
 *
 *   const props: {
 *     user: ?{
 *       name: string,
 *       friends: ?Array<User>,
 *     }
 *   };
 *
 * Getting to the friends of my first friend would resemble:
 *
 *   props.user &&
 *   props.user.friends &&
 *   props.user.friends[0] &&
 *   props.user.friends[0].friends
 *
 * Instead, `idx` allows us to safely write:
 *
 *   idx(props, _ => _.user.friends[0].friends)
 *
 * The second argument must be a function that returns one or more nested member
 * expressions. Any other expression has undefined behavior.
 *
 * === NOTE ===
 *
 * The code below exists for the purpose of illustrating expected behavior and
 * is not meant to be executed. The `idx` function is used in conjunction with a
 * Babel transform that replaces it with better performing code:
 *
 *   props.user == null ? props.user :
 *   props.user.friends == null ? props.user.friends :
 *   props.user.friends[0] == null ? props.user.friends[0] :
 *   props.user.friends[0].friends
 *
 * All this machinery exists due to the fact that an existential operator does
 * not currently exist in JavaScript.
 */

function idx(input, accessor) {
  try {
    return accessor(input);
  } catch (error) {
    if (error instanceof TypeError) {
      if (nullPattern.test(error)) {
        return null;
      } else if (undefinedPattern.test(error)) {
        return undefined;
      }
    }
    throw error;
  }
}

/**
 * Some actual error messages for null:
 *
 * TypeError: Cannot read property 'bar' of null
 * TypeError: Cannot convert null value to object
 * TypeError: foo is null
 * TypeError: null has no properties
 * TypeError: null is not an object (evaluating 'foo.bar')
 * TypeError: null is not an object (evaluating '(" undefined ", null).bar')
 */
var nullPattern = /^null | null$|^[^(]* null /i;
var undefinedPattern = /^undefined | undefined$|^[^(]* undefined /i;

idx.default = idx;
module.exports = idx;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellPosition */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_CellRenderer */
/* unused harmony export bpfrpt_proptype_CellCache */
/* unused harmony export bpfrpt_proptype_StyleCache */
/* unused harmony export bpfrpt_proptype_CellRangeRendererParams */
/* unused harmony export bpfrpt_proptype_CellRangeRenderer */
/* unused harmony export bpfrpt_proptype_CellSizeGetter */
/* unused harmony export bpfrpt_proptype_CellSize */
/* unused harmony export bpfrpt_proptype_NoContentRenderer */
/* unused harmony export bpfrpt_proptype_Scroll */
/* unused harmony export bpfrpt_proptype_ScrollbarPresenceChange */
/* unused harmony export bpfrpt_proptype_RenderedSection */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetterParams */
/* unused harmony export bpfrpt_proptype_OverscanIndices */
/* unused harmony export bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony export bpfrpt_proptype_Alignment */
/* unused harmony export bpfrpt_proptype_VisibleCellRange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_CellPosition =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  columnIndex: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  rowIndex: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellCache =  true ? null : PropTypes.objectOf(PropTypes.node.isRequired);
var bpfrpt_proptype_StyleCache =  true ? null : PropTypes.objectOf(PropTypes.object.isRequired);
var bpfrpt_proptype_CellRangeRendererParams =  true ? null : {
  cellCache: PropTypes.objectOf(PropTypes.node.isRequired).isRequired,
  cellRenderer: PropTypes.func.isRequired,
  columnSizeAndPositionManager: function columnSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  deferredMeasurementCache: PropTypes.object,
  horizontalOffsetAdjustment: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isScrollingOptOut: PropTypes.bool.isRequired,
  parent: PropTypes.object.isRequired,
  rowSizeAndPositionManager: function rowSizeAndPositionManager() {
    return (typeof ScalingCellSizeAndPositionManager === 'function' ? PropTypes.instanceOf(ScalingCellSizeAndPositionManager).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  styleCache: PropTypes.objectOf(PropTypes.object.isRequired).isRequired,
  verticalOffsetAdjustment: PropTypes.number.isRequired,
  visibleColumnIndices: PropTypes.object.isRequired,
  visibleRowIndices: PropTypes.object.isRequired
};
var bpfrpt_proptype_CellRangeRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSizeGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_CellSize =  true ? null : PropTypes.oneOfType([PropTypes.func, PropTypes.number]);
var bpfrpt_proptype_NoContentRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  clientWidth: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired,
  scrollWidth: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollbarPresenceChange =  true ? null : {
  horizontal: PropTypes.bool.isRequired,
  vertical: PropTypes.bool.isRequired,
  size: PropTypes.number.isRequired
};
var bpfrpt_proptype_RenderedSection =  true ? null : {
  columnOverscanStartIndex: PropTypes.number.isRequired,
  columnOverscanStopIndex: PropTypes.number.isRequired,
  columnStartIndex: PropTypes.number.isRequired,
  columnStopIndex: PropTypes.number.isRequired,
  rowOverscanStartIndex: PropTypes.number.isRequired,
  rowOverscanStopIndex: PropTypes.number.isRequired,
  rowStartIndex: PropTypes.number.isRequired,
  rowStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetterParams =  true ? null : {
  // One of SCROLL_DIRECTION_HORIZONTAL or SCROLL_DIRECTION_VERTICAL
  direction: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,


  // One of SCROLL_DIRECTION_BACKWARD or SCROLL_DIRECTION_FORWARD
  scrollDirection: PropTypes.oneOf([-1, 1]).isRequired,


  // Number of rows or columns in the current axis
  cellCount: PropTypes.number.isRequired,


  // Maximum number of cells to over-render in either direction
  overscanCellsCount: PropTypes.number.isRequired,


  // Begin of range of visible cells
  startIndex: PropTypes.number.isRequired,


  // End of range of visible cells
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndices =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_OverscanIndicesGetter =  true ? null : PropTypes.func;
var bpfrpt_proptype_Alignment =  true ? null : PropTypes.oneOf(['auto', 'end', 'start', 'center']);
var bpfrpt_proptype_VisibleCellRange =  true ? null : {
  start: PropTypes.number,
  stop: PropTypes.number
};




















/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),
/* 20 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 21 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export adjustHue */
/* unused harmony export animation */
/* unused harmony export backgroundImages */
/* unused harmony export backgrounds */
/* unused harmony export between */
/* unused harmony export border */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* unused harmony export borderStyle */
/* unused harmony export borderWidth */
/* unused harmony export buttons */
/* unused harmony export clearFix */
/* unused harmony export complement */
/* unused harmony export cover */
/* unused harmony export darken */
/* unused harmony export desaturate */
/* unused harmony export directionalProperty */
/* unused harmony export ellipsis */
/* unused harmony export em */
/* unused harmony export fluidRange */
/* unused harmony export fontFace */
/* unused harmony export getLuminance */
/* unused harmony export getValueAndUnit */
/* unused harmony export grayscale */
/* unused harmony export invert */
/* unused harmony export hideText */
/* unused harmony export hideVisually */
/* unused harmony export hiDPI */
/* unused harmony export hsl */
/* unused harmony export hsla */
/* unused harmony export lighten */
/* unused harmony export margin */
/* unused harmony export mix */
/* unused harmony export modularScale */
/* unused harmony export normalize */
/* unused harmony export opacify */
/* unused harmony export padding */
/* unused harmony export parseToHsl */
/* unused harmony export parseToRgb */
/* unused harmony export placeholder */
/* unused harmony export position */
/* unused harmony export radialGradient */
/* unused harmony export readableColor */
/* unused harmony export rem */
/* unused harmony export retinaImage */
/* unused harmony export rgb */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rgba; });
/* unused harmony export saturate */
/* unused harmony export selection */
/* unused harmony export setHue */
/* unused harmony export setLightness */
/* unused harmony export setSaturation */
/* unused harmony export shade */
/* unused harmony export size */
/* unused harmony export stripUnit */
/* unused harmony export textInputs */
/* unused harmony export timingFunctions */
/* unused harmony export tint */
/* unused harmony export toColorString */
/* unused harmony export transitions */
/* unused harmony export transparentize */
/* unused harmony export triangle */
/* unused harmony export wordWrap */
// @private
function capitalizeString(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var positionMap = ['Top', 'Right', 'Bottom', 'Left'];

function generateProperty(property, position) {
  if (!property) return position.toLowerCase();
  var splitProperty = property.split('-');
  if (splitProperty.length > 1) {
    splitProperty.splice(1, 0, position);
    return splitProperty.reduce(function (acc, val) {
      return '' + acc + capitalizeString(val);
    });
  }
  var joinedProperty = property.replace(/([a-z])([A-Z])/g, '$1' + position + '$2');
  return property === joinedProperty ? '' + property + position : joinedProperty;
}

function generateStyles(property, valuesWithDefaults) {
  var styles = {};
  for (var i = 0; i < valuesWithDefaults.length; i += 1) {
    if (valuesWithDefaults[i] || valuesWithDefaults[i] === 0) {
      styles[generateProperty(property, positionMap[i])] = valuesWithDefaults[i];
    }
  }
  return styles;
}

/**
 * Enables shorthand for direction-based properties. It accepts a property (hyphenated or camelCased) and up to four values that map to top, right, bottom, and left, respectively. You can optionally pass an empty string to get only the directional values as properties. You can also optionally pass a null argument for a directional value to ignore it.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...directionalProperty('padding', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${directionalProperty('padding', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function directionalProperty(property) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  //  prettier-ignore
  var firstValue = values[0],
      _values$ = values[1],
      secondValue = _values$ === undefined ? firstValue : _values$,
      _values$2 = values[2],
      thirdValue = _values$2 === undefined ? firstValue : _values$2,
      _values$3 = values[3],
      fourthValue = _values$3 === undefined ? secondValue : _values$3;

  var valuesWithDefaults = [firstValue, secondValue, thirdValue, fourthValue];
  return generateStyles(property, valuesWithDefaults);
}

function endsWith (string, suffix) {
  return string.substr(-suffix.length) === suffix;
}

/**
 * Returns a given CSS value minus its unit (or the original value if an invalid string is passed).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': stripUnit('100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${stripUnit('100px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 * }
 */
function stripUnit(value) {
  var unitlessValue = parseFloat(value);
  if (isNaN(unitlessValue)) return value;
  return unitlessValue;
}

/**
 * Factory function that creates pixel-to-x converters
 * @private
 */
var pxtoFactory = function pxtoFactory(to) {
  return function (pxval) {
    var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '16px';

    var newPxval = pxval;
    var newBase = base;
    if (typeof pxval === 'string') {
      if (!endsWith(pxval, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the first argument to ' + to + '(), got "' + pxval + '" instead.');
      }
      newPxval = stripUnit(pxval);
    }

    if (typeof base === 'string') {
      if (!endsWith(base, 'px')) {
        throw new Error('Expected a string ending in "px" or a number passed as the second argument to ' + to + '(), got "' + base + '" instead.');
      }
      newBase = stripUnit(base);
    }

    if (typeof newPxval === 'string') {
      throw new Error('Passed invalid pixel value ("' + pxval + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    if (typeof newBase === 'string') {
      throw new Error('Passed invalid base value ("' + base + '") to ' + to + '(), please pass a value like "12px" or 12.');
    }

    return '' + newPxval / newBase + to;
  };
};

/**
 * Convert pixel value to ems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': em('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${em('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1em'
 * }
 */
var em = /*#__PURE__*/pxtoFactory('em');

var cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

/**
 * Returns a given CSS value and its unit as elements of an array.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   '--dimension': getValueAndUnit('100px')[0]
 *   '--unit': getValueAndUnit('100px')[1]
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   --dimension: ${getValueAndUnit('100px')[0]}
 *   --unit: ${getValueAndUnit('100px')[1]}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   '--dimension': 100
 *   '--unit': 'px'
 * }
 */
function getValueAndUnit(value) {
  if (typeof value !== 'string') return [value, ''];
  var matchedValue = value.match(cssRegex);
  if (matchedValue) return [parseFloat(value), matchedValue[2]];
  return [value, undefined];
}

var ratioNames = {
  minorSecond: 1.067,
  majorSecond: 1.125,
  minorThird: 1.2,
  majorThird: 1.25,
  perfectFourth: 1.333,
  augFourth: 1.414,
  perfectFifth: 1.5,
  minorSixth: 1.6,
  goldenSection: 1.618,
  majorSixth: 1.667,
  minorSeventh: 1.778,
  majorSeventh: 1.875,
  octave: 2,
  majorTenth: 2.5,
  majorEleventh: 2.667,
  majorTwelfth: 3,
  doubleOctave: 4
};

function getRatio(ratioName) {
  return ratioNames[ratioName];
}

/**
 * Establish consistent measurements and spacial relationships throughout your projects by incrementing up or down a defined scale. We provide a list of commonly used scales as pre-defined variables.
 * @example
 * // Styles as object usage
 * const styles = {
 *    // Increment two steps up the default scale
 *   'fontSize': modularScale(2)
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *    // Increment two steps up the default scale
 *   fontSize: ${modularScale(2)}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'fontSize': '1.77689em'
 * }
 */
function modularScale(steps) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '1em';
  var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'perfectFourth';

  if (typeof steps !== 'number') {
    throw new Error('Please provide a number of steps to the modularScale helper.');
  }
  if (typeof ratio === 'string' && !ratioNames[ratio]) {
    throw new Error('Please pass a number or one of the predefined scales to the modularScale helper as the ratio.');
  }

  var realBase = typeof base === 'string' ? stripUnit(base) : base;
  var realRatio = typeof ratio === 'string' ? getRatio(ratio) : ratio;

  if (typeof realBase === 'string') {
    throw new Error('Invalid value passed as base to modularScale, expected number or em string but got "' + base + '"');
  }

  return realBase * Math.pow(realRatio, steps) + 'em';
}

/**
 * Convert pixel value to rems. The default base value is 16px, but can be changed by passing a
 * second argument to the function.
 * @function
 * @param {string|number} pxval
 * @param {string|number} [base='16px']
 * @example
 * // Styles as object usage
 * const styles = {
 *   'height': rem('16px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   height: ${rem('16px')}
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   'height': '1rem'
 * }
 */
var rem = /*#__PURE__*/pxtoFactory('rem');

/**
 * Returns a CSS calc formula for linear interpolation of a property between two values. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px').
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: between('20px', '100px', '400px', '1000px'),
 *   fontSize: between('20px', '100px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${fontSize: between('20px', '100px', '400px', '1000px')};
 *   fontSize: ${fontSize: between('20px', '100px')}
 * `
 *
 * // CSS as JS Output
 *
 * h1: {
 *   'fontSize': 'calc(-33.33333333333334px + 13.333333333333334vw)',
 *   'fontSize': 'calc(-9.090909090909093px + 9.090909090909092vw)'
 * }
 */
function between(fromSize, toSize) {
  var minScreen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '320px';
  var maxScreen = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '1200px';

  var _getValueAndUnit = getValueAndUnit(fromSize),
      unitlessFromSize = _getValueAndUnit[0],
      fromSizeUnit = _getValueAndUnit[1];

  var _getValueAndUnit2 = getValueAndUnit(toSize),
      unitlessToSize = _getValueAndUnit2[0],
      toSizeUnit = _getValueAndUnit2[1];

  var _getValueAndUnit3 = getValueAndUnit(minScreen),
      unitlessMinScreen = _getValueAndUnit3[0],
      minScreenUnit = _getValueAndUnit3[1];

  var _getValueAndUnit4 = getValueAndUnit(maxScreen),
      unitlessMaxScreen = _getValueAndUnit4[0],
      maxScreenUnit = _getValueAndUnit4[1];

  if (typeof unitlessMinScreen !== 'number' || typeof unitlessMaxScreen !== 'number' || !minScreenUnit || !maxScreenUnit || minScreenUnit !== maxScreenUnit) {
    throw new Error('minScreen and maxScreen must be provided as stringified numbers with the same units.');
  }

  if (typeof unitlessFromSize !== 'number' || typeof unitlessToSize !== 'number' || !fromSizeUnit || !toSizeUnit || fromSizeUnit !== toSizeUnit) {
    throw new Error('fromSize and toSize must be provided as stringified numbers with the same units.');
  }

  var slope = (unitlessFromSize - unitlessToSize) / (unitlessMinScreen - unitlessMaxScreen);
  var base = unitlessToSize - slope * unitlessMaxScreen;
  return 'calc(' + base.toFixed(2) + fromSizeUnit + ' + ' + (100 * slope).toFixed(2) + 'vw)';
}

/**
 * CSS to contain a float (credit to CSSMojo).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...clearFix(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${clearFix()}
 * `
 *
 * // CSS as JS Output
 *
 * '&::after': {
 *   'clear': 'both',
 *   'content': '""',
 *   'display': 'table'
 * }
 */
function clearFix() {
  var _ref;

  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '&';

  var pseudoSelector = parent + '::after';
  return _ref = {}, _ref[pseudoSelector] = {
    clear: 'both',
    content: '""',
    display: 'table'
  }, _ref;
}

/**
 * CSS to fully cover an area. Can optionally be passed an offset to act as a "padding".
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...cover()
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${cover()}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'position': 'absolute',
 *   'top': '0',
 *   'right: '0',
 *   'bottom': '0',
 *   'left: '0'
 * }
 */
function cover() {
  var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  return {
    position: 'absolute',
    top: offset,
    right: offset,
    bottom: offset,
    left: offset
  };
}

/**
 * CSS to represent truncated text with an ellipsis.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...ellipsis('250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${ellipsis('250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   'display': 'inline-block',
 *   'maxWidth': '250px',
 *   'overflow': 'hidden',
 *   'textOverflow': 'ellipsis',
 *   'whiteSpace': 'nowrap',
 *   'wordWrap': 'normal'
 * }
 */
function ellipsis() {
  var width = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '100%';

  return {
    display: 'inline-block',
    maxWidth: width,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    wordWrap: 'normal'
  };
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var taggedTemplateLiteralLoose = function (strings, raw) {
  strings.raw = raw;
  return strings;
};

/**
 * Returns a set of media queries that resizes a property (or set of properties) between a provided fromSize and toSize. Accepts optional minScreen (defaults to '320px') and maxScreen (defaults to '1200px') to constrain the interpolation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...fluidRange(
 *    {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${fluidRange(
 *      {
 *        prop: 'padding',
 *        fromSize: '20px',
 *        toSize: '100px',
 *      },
 *      '400px',
 *      '1000px',
 *    )}
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   "@media (min-width: 1000px)": Object {
 *     "padding": "100px",
 *   },
 *   "@media (min-width: 400px)": Object {
 *     "padding": "calc(-33.33333333333334px + 13.333333333333334vw)",
 *   },
 *   "padding": "20px",
 * }
 */
function fluidRange(cssProp) {
  var minScreen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '320px';
  var maxScreen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '1200px';

  if (!Array.isArray(cssProp) && typeof cssProp !== 'object' || cssProp === null) {
    throw new Error('expects either an array of objects or a single object with the properties prop, fromSize, and toSize.');
  }

  if (Array.isArray(cssProp)) {
    var mediaQueries = {};
    var fallbacks = {};
    for (var _iterator = cssProp, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _babelHelpers$extends, _babelHelpers$extends2;

      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var obj = _ref;

      if (!obj.prop || !obj.fromSize || !obj.toSize) {
        throw new Error('expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.');
      }

      fallbacks[obj.prop] = obj.fromSize;
      mediaQueries['@media (min-width: ' + minScreen + ')'] = _extends({}, mediaQueries['@media (min-width: ' + minScreen + ')'], (_babelHelpers$extends = {}, _babelHelpers$extends[obj.prop] = between(obj.fromSize, obj.toSize, minScreen, maxScreen), _babelHelpers$extends));
      mediaQueries['@media (min-width: ' + maxScreen + ')'] = _extends({}, mediaQueries['@media (min-width: ' + maxScreen + ')'], (_babelHelpers$extends2 = {}, _babelHelpers$extends2[obj.prop] = obj.toSize, _babelHelpers$extends2));
    }

    return _extends({}, fallbacks, mediaQueries);
  } else {
    var _ref2, _ref3, _ref4;

    if (!cssProp.prop || !cssProp.fromSize || !cssProp.toSize) {
      throw new Error('expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.');
    }

    return _ref4 = {}, _ref4[cssProp.prop] = cssProp.fromSize, _ref4['@media (min-width: ' + minScreen + ')'] = (_ref2 = {}, _ref2[cssProp.prop] = between(cssProp.fromSize, cssProp.toSize, minScreen, maxScreen), _ref2), _ref4['@media (min-width: ' + maxScreen + ')'] = (_ref3 = {}, _ref3[cssProp.prop] = cssProp.toSize, _ref3), _ref4;
  }
}

function generateFileReferences(fontFilePath, fileFormats) {
  var fileFontReferences = fileFormats.map(function (format) {
    return 'url("' + fontFilePath + '.' + format + '")';
  });
  return fileFontReferences.join(', ');
}

function generateLocalReferences(localFonts) {
  var localFontReferences = localFonts.map(function (font) {
    return 'local("' + font + '")';
  });
  return localFontReferences.join(', ');
}

function generateSources(fontFilePath, localFonts, fileFormats) {
  var fontReferences = [];
  if (localFonts) fontReferences.push(generateLocalReferences(localFonts));
  if (fontFilePath) {
    fontReferences.push(generateFileReferences(fontFilePath, fileFormats));
  }
  return fontReferences.join(', ');
}

/**
 * CSS for a @font-face declaration.
 *
 * @example
 * // Styles as object basic usage
 * const styles = {
 *    ...fontFace({
 *      'fontFamily': 'Sans-Pro'
 *      'fontFilePath': 'path/to/file'
 *    })
 * }
 *
 * // styled-components basic usage
 * injectGlobal`${
 *   fontFace({
 *     'fontFamily': 'Sans-Pro'
 *     'fontFilePath': 'path/to/file'
 *   }
 * )}`
 *
 * // CSS as JS Output
 *
 * '@font-face': {
 *   'fontFamily': 'Sans-Pro',
 *   'src': 'url("path/to/file.eot"), url("path/to/file.woff2"), url("path/to/file.woff"), url("path/to/file.ttf"), url("path/to/file.svg")',
 * }
 */
function fontFace(_ref) {
  var fontFamily = _ref.fontFamily,
      fontFilePath = _ref.fontFilePath,
      fontStretch = _ref.fontStretch,
      fontStyle = _ref.fontStyle,
      fontVariant = _ref.fontVariant,
      fontWeight = _ref.fontWeight,
      _ref$fileFormats = _ref.fileFormats,
      fileFormats = _ref$fileFormats === undefined ? ['eot', 'woff2', 'woff', 'ttf', 'svg'] : _ref$fileFormats,
      localFonts = _ref.localFonts,
      unicodeRange = _ref.unicodeRange,
      fontDisplay = _ref.fontDisplay,
      fontVariationSettings = _ref.fontVariationSettings,
      fontFeatureSettings = _ref.fontFeatureSettings;

  // Error Handling
  if (!fontFamily) throw new Error('fontFace expects a name of a font-family.');
  if (!fontFilePath && !localFonts) {
    throw new Error('fontFace expects either the path to the font file(s) or a name of a local copy.');
  }
  if (localFonts && !Array.isArray(localFonts)) {
    throw new Error('fontFace expects localFonts to be an array.');
  }
  if (!Array.isArray(fileFormats)) {
    throw new Error('fontFace expects fileFormats to be an array.');
  }

  var fontFaceDeclaration = {
    '@font-face': {
      fontFamily: fontFamily,
      src: generateSources(fontFilePath, localFonts, fileFormats),
      unicodeRange: unicodeRange,
      fontStretch: fontStretch,
      fontStyle: fontStyle,
      fontVariant: fontVariant,
      fontWeight: fontWeight,
      fontDisplay: fontDisplay,
      fontVariationSettings: fontVariationSettings,
      fontFeatureSettings: fontFeatureSettings
    }

    // Removes undefined fields for cleaner css object.
  };return JSON.parse(JSON.stringify(fontFaceDeclaration));
}

/**
 * CSS to hide text to show a background image in a SEO-friendly way.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'backgroundImage': 'url(logo.png)',
 *   ...hideText(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   backgroundImage: url(logo.png);
 *   ${hideText()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'backgroundImage': 'url(logo.png)',
 *   'textIndent': '101%',
 *   'overflow': 'hidden',
 *   'whiteSpace': 'nowrap',
 * }
 */

function hideText() {
  return {
    textIndent: '101%',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  };
}

/**
 * CSS to hide content visually but remain accessible to screen readers.
 * from [HTML5 Boilerplate](https://github.com/h5bp/html5-boilerplate/blob/9a176f57af1cfe8ec70300da4621fb9b07e5fa31/src/css/main.css#L121)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...hideVisually(),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hideVisually()};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'border': '0',
 *   'clip': 'rect(0 0 0 0)',
 *   'clipPath': 'inset(50%)',
 *   'height': '1px',
 *   'margin': '-1px',
 *   'overflow': 'hidden',
 *   'padding': '0',
 *   'position': 'absolute',
 *   'whiteSpace': 'nowrap',
 *   'width': '1px',
 * }
 */
function hideVisually() {
  return {
    border: '0',
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: '0',
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
  };
}

/**
 * Generates a media query to target HiDPI devices.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  [hiDPI(1.5)]: {
 *    width: 200px;
 *  }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${hiDPI(1.5)} {
 *     width: 200px;
 *   }
 * `
 *
 * // CSS as JS Output
 *
 * '@media only screen and (-webkit-min-device-pixel-ratio: 1.5),
 *  only screen and (min--moz-device-pixel-ratio: 1.5),
 *  only screen and (-o-min-device-pixel-ratio: 1.5/1),
 *  only screen and (min-resolution: 144dpi),
 *  only screen and (min-resolution: 1.5dppx)': {
 *   'width': '200px',
 * }
 */

function hiDPI() {
  var ratio = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1.3;

  return "\n    @media only screen and (-webkit-min-device-pixel-ratio: " + ratio + "),\n    only screen and (min--moz-device-pixel-ratio: " + ratio + "),\n    only screen and (-o-min-device-pixel-ratio: " + ratio + "/1),\n    only screen and (min-resolution: " + Math.round(ratio * 96) + "dpi),\n    only screen and (min-resolution: " + ratio + "dppx)\n  ";
}

/**
 * CSS to normalize abnormalities across browsers (normalize.css v8.0.0 | MIT License | github.com/necolas/normalize.css)
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *    ...normalize(),
 * }
 *
 * // styled-components usage
 * injectGlobal`${normalize()}`
 *
 * // CSS as JS Output
 *
 * html {
 *   lineHeight: 1.15,
 *   textSizeAdjust: 100%,
 * } ...
 */
function normalize() {
  var _ref;

  return [(_ref = {
    html: {
      lineHeight: '1.15',
      textSizeAdjust: '100%'
    },

    body: {
      margin: '0'
    },

    h1: {
      fontSize: '2em',
      margin: '0.67em 0'
    },

    hr: {
      boxSizing: 'content-box',
      height: '0',
      overflow: 'visible'
    },

    pre: {
      fontFamily: 'monospace, monospace',
      fontSize: '1em'
    },

    a: {
      'background-color': 'transparent'
    },

    'abbr[title]': {
      borderBottom: 'none',
      textDecoration: 'underline'
    }

  }, _ref['b,\n    strong'] = {
    fontWeight: 'bolder'
  }, _ref['code,\n    kbd,\n    samp'] = {
    fontFamily: 'monospace, monospace',
    fontSize: '1em'
  }, _ref.small = {
    fontSize: '80%'
  }, _ref['sub,\n    sup'] = {
    fontSize: '75%',
    lineHeight: '0',
    position: 'relative',
    verticalAlign: 'baseline'
  }, _ref.sub = {
    bottom: '-0.25em'
  }, _ref.sup = {
    top: '-0.5em'
  }, _ref.img = {
    borderStyle: 'none'
  }, _ref['button,\n    input,\n    optgroup,\n    select,\n    textarea'] = {
    fontFamily: 'inherit',
    fontSize: '100%',
    lineHeight: '1.15',
    margin: '0'
  }, _ref['button,\n    input'] = {
    overflow: 'visible'
  }, _ref['button,\n    select'] = {
    textTransform: 'none'
  }, _ref['button,\n    html [type="button"],\n    [type="reset"],\n    [type="submit"]'] = {
    WebkitAppearance: 'button'
  }, _ref['button::-moz-focus-inner,\n    [type="button"]::-moz-focus-inner,\n    [type="reset"]::-moz-focus-inner,\n    [type="submit"]::-moz-focus-inner'] = {
    borderStyle: 'none',
    padding: '0'
  }, _ref['button:-moz-focusring,\n    [type="button"]:-moz-focusring,\n    [type="reset"]:-moz-focusring,\n    [type="submit"]:-moz-focusring'] = {
    outline: '1px dotted ButtonText'
  }, _ref.fieldset = {
    padding: '0.35em 0.625em 0.75em'
  }, _ref.legend = {
    boxSizing: 'border-box',
    color: 'inherit',
    display: 'table',
    maxWidth: '100%',
    padding: '0',
    whiteSpace: 'normal'
  }, _ref.progress = {
    verticalAlign: 'baseline'
  }, _ref.textarea = {
    overflow: 'auto'
  }, _ref['[type="checkbox"],\n    [type="radio"]'] = {
    boxSizing: 'border-box',
    padding: '0'
  }, _ref['[type="number"]::-webkit-inner-spin-button,\n    [type="number"]::-webkit-outer-spin-button'] = {
    height: 'auto'
  }, _ref['[type="search"]'] = {
    WebkitAppearance: 'textfield',
    outlineOffset: '-2px'
  }, _ref['[type="search"]::-webkit-search-decoration'] = {
    WebkitAppearance: 'none'
  }, _ref['::-webkit-file-upload-button'] = {
    WebkitAppearance: 'button',
    font: 'inherit'
  }, _ref.details = {
    display: 'block'
  }, _ref.summary = {
    display: 'list-item'
  }, _ref.template = {
    display: 'none'
  }, _ref['[hidden]'] = {
    display: 'none'
  }, _ref), {
    'abbr[title]': {
      textDecoration: 'underline dotted'
    }
  }];
}

/**
 * CSS to style the placeholder pseudo-element.
 *
 * @deprecated - placeholder has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed placeholder pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...placeholder({'color': 'blue'})
 * }
 *
 * // styled-components usage
 * const div = styled.input`
 *    ${placeholder({'color': 'blue'})}
 * `
 *
 * // CSS as JS Output
 *
 * 'input': {
 *   '&:-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&:-ms-input-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-moz-placeholder': {
 *     'color': 'blue',
 *   },
 *   '&::-webkit-input-placeholder': {
 *     'color': 'blue',
 *   },
 * },
 */
function placeholder(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '&';

  return _ref = {}, _ref[parent + '::-webkit-input-placeholder'] = _extends({}, styles), _ref[parent + ':-moz-placeholder'] = _extends({}, styles), _ref[parent + '::-moz-placeholder'] = _extends({}, styles), _ref[parent + ':-ms-input-placeholder'] = _extends({}, styles), _ref;
}

var _templateObject = /*#__PURE__*/ taggedTemplateLiteralLoose(['radial-gradient(', '', '', '', ')'], ['radial-gradient(', '', '', '', ')']);

function parseFallback(colorStops) {
  return colorStops[0].split(' ')[0];
}

function constructGradientValue(literals) {
  var template = '';
  for (var i = 0; i < literals.length; i += 1) {
    template += literals[i];
    // Adds leading coma if properties preceed color-stops
    if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && ((arguments.length <= 1 ? undefined : arguments[1]) || (arguments.length <= 2 ? undefined : arguments[2]) || (arguments.length <= 3 ? undefined : arguments[3]))) {
      template = template.slice(0, -1);
      template += ', ' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // No trailing space if color-stops is the only param provided
    } else if (i === 3 && (arguments.length <= i + 1 ? undefined : arguments[i + 1]) && !(arguments.length <= 1 ? undefined : arguments[1]) && !(arguments.length <= 2 ? undefined : arguments[2]) && !(arguments.length <= 3 ? undefined : arguments[3])) {
      template += '' + (arguments.length <= i + 1 ? undefined : arguments[i + 1]);
      // Only adds substitution if it is defined
    } else if (arguments.length <= i + 1 ? undefined : arguments[i + 1]) {
      template += (arguments.length <= i + 1 ? undefined : arguments[i + 1]) + ' ';
    }
  }
  return template.trim();
}

/**
 * CSS for declaring a radial gradient, including a fallback background-color. The fallback is either the first color-stop or an explicitly passed fallback color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${radialGradient({
 *     colorStops: ['#00FFFF 0%', 'rgba(0, 0, 255, 0) 50%', '#0000FF 95%'],
 *     extent: 'farthest-corner at 45px 45px',
 *     position: 'center',
 *     shape: 'ellipse',
 *   })}
 *`
 *
 * // CSS as JS Output
 *
 * div: {
 *   'backgroundColor': '#00FFFF',
 *   'backgroundImage': 'radial-gradient(center ellipse farthest-corner at 45px 45px, #00FFFF 0%, rgba(0, 0, 255, 0) 50%, #0000FF 95%)',
 * }
 */
function radialGradient(_ref) {
  var colorStops = _ref.colorStops,
      extent = _ref.extent,
      fallback = _ref.fallback,
      position = _ref.position,
      shape = _ref.shape;

  if (!colorStops || colorStops.length < 2) {
    throw new Error('radialGradient requries at least 2 color-stops to properly render.');
  }
  return {
    backgroundColor: fallback || parseFallback(colorStops),
    backgroundImage: constructGradientValue(_templateObject, position, shape, extent, colorStops.join(', '))
  };
}

/**
 * A helper to generate a retina background image and non-retina
 * background image. The retina background image will output to a HiDPI media query. The mixin uses
 * a _2x.png filename suffix by default.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *  ...retinaImage('my-img')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${retinaImage('my-img')}
 * `
 *
 * // CSS as JS Output
 * div {
 *   backgroundImage: 'url(my-img.png)',
 *   '@media only screen and (-webkit-min-device-pixel-ratio: 1.3),
 *    only screen and (min--moz-device-pixel-ratio: 1.3),
 *    only screen and (-o-min-device-pixel-ratio: 1.3/1),
 *    only screen and (min-resolution: 144dpi),
 *    only screen and (min-resolution: 1.5dppx)': {
 *     backgroundImage: 'url(my-img_2x.png)',
 *   }
 * }
 */
function retinaImage(filename, backgroundSize) {
  var extension = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'png';

  var _ref;

  var retinaFilename = arguments[3];
  var retinaSuffix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '_2x';

  if (!filename) {
    throw new Error('Please supply a filename to retinaImage() as the first argument.');
  }
  // Replace the dot at the beginning of the passed extension if one exists
  var ext = extension.replace(/^\./, '');
  var rFilename = retinaFilename ? retinaFilename + '.' + ext : '' + filename + retinaSuffix + '.' + ext;

  return _ref = {
    backgroundImage: 'url(' + filename + '.' + ext + ')'
  }, _ref[hiDPI()] = _extends({
    backgroundImage: 'url(' + rFilename + ')'
  }, backgroundSize ? { backgroundSize: backgroundSize } : {}), _ref;
}

/**
 * CSS to style the selection pseudo-element.
 *
 * @deprecated - selection has been marked for deprecation in polished 2.0 and will be fully deprecated in 3.0. It is no longer needed and can safely be replaced with the non-prefixed selection pseudo-element.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...selection({
 *     'backgroundColor': 'blue'
 *   }, 'section')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${selection({'backgroundColor': 'blue'}, 'section')}
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'section::-moz-selection': {
 *     'backgroundColor':'blue',
 *   },
 *   'section::selection': {
 *     'backgroundColor': 'blue',
 *   }
 * }
 */
function selection(styles) {
  var _ref;

  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  return _ref = {}, _ref[parent + '::-moz-selection'] = _extends({}, styles), _ref[parent + '::selection'] = _extends({}, styles), _ref;
}

/* eslint-disable key-spacing */
var functionsMap = {
  easeInBack: 'cubic-bezier(0.600, -0.280, 0.735, 0.045)',
  easeInCirc: 'cubic-bezier(0.600,  0.040, 0.980, 0.335)',
  easeInCubic: 'cubic-bezier(0.550,  0.055, 0.675, 0.190)',
  easeInExpo: 'cubic-bezier(0.950,  0.050, 0.795, 0.035)',
  easeInQuad: 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
  easeInQuart: 'cubic-bezier(0.895,  0.030, 0.685, 0.220)',
  easeInQuint: 'cubic-bezier(0.755,  0.050, 0.855, 0.060)',
  easeInSine: 'cubic-bezier(0.470,  0.000, 0.745, 0.715)',

  easeOutBack: 'cubic-bezier(0.175,  0.885, 0.320, 1.275)',
  easeOutCubic: 'cubic-bezier(0.215,  0.610, 0.355, 1.000)',
  easeOutCirc: 'cubic-bezier(0.075,  0.820, 0.165, 1.000)',
  easeOutExpo: 'cubic-bezier(0.190,  1.000, 0.220, 1.000)',
  easeOutQuad: 'cubic-bezier(0.250,  0.460, 0.450, 0.940)',
  easeOutQuart: 'cubic-bezier(0.165,  0.840, 0.440, 1.000)',
  easeOutQuint: 'cubic-bezier(0.230,  1.000, 0.320, 1.000)',
  easeOutSine: 'cubic-bezier(0.390,  0.575, 0.565, 1.000)',

  easeInOutBack: 'cubic-bezier(0.680, -0.550, 0.265, 1.550)',
  easeInOutCirc: 'cubic-bezier(0.785,  0.135, 0.150, 0.860)',
  easeInOutCubic: 'cubic-bezier(0.645,  0.045, 0.355, 1.000)',
  easeInOutExpo: 'cubic-bezier(1.000,  0.000, 0.000, 1.000)',
  easeInOutQuad: 'cubic-bezier(0.455,  0.030, 0.515, 0.955)',
  easeInOutQuart: 'cubic-bezier(0.770,  0.000, 0.175, 1.000)',
  easeInOutQuint: 'cubic-bezier(0.860,  0.000, 0.070, 1.000)',
  easeInOutSine: 'cubic-bezier(0.445,  0.050, 0.550, 0.950)'
  /* eslint-enable key-spacing */

};
function getTimingFunction(functionName) {
  return functionsMap[functionName];
}

/**
 * String to represent common easing functions as demonstrated here: (github.com/jaukia/easie).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   'transitionTimingFunction': timingFunctions('easeInQuad')
 * }
 *
 * // styled-components usage
 *  const div = styled.div`
 *   transitionTimingFunction: ${timingFunctions('easeInQuad')};
 * `
 *
 * // CSS as JS Output
 *
 * 'div': {
 *   'transitionTimingFunction': 'cubic-bezier(0.550,  0.085, 0.680, 0.530)',
 * }
 */

function timingFunctions(timingFunction) {
  return getTimingFunction(timingFunction);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderColor('red', 'green', 'blue', 'yellow')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderColor('red', 'green', 'blue', 'yellow')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderRightColor': 'green',
 *   'borderBottomColor': 'blue',
 *   'borderLeftColor': 'yellow'
 * }
 */
function borderColor() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderColor'].concat(values));
}

var getBorderWidth = function getBorderWidth(pointingDirection, height, width) {
  switch (pointingDirection) {
    case 'top':
      return '0 ' + width[0] / 2 + width[1] + ' ' + height[0] + height[1] + ' ' + width[0] / 2 + width[1];
    case 'left':
      return '' + height[0] / 2 + height[1] + ' ' + width[0] + width[1] + ' ' + height[0] / 2 + height[1] + ' 0';
    case 'bottom':
      return '' + height[0] + height[1] + ' ' + width[0] / 2 + width[1] + ' 0 ' + width[0] / 2 + width[1];
    case 'right':
      return '' + height[0] / 2 + height[1] + ' 0 ' + height[0] / 2 + height[1] + ' ' + width[0] + width[1];

    default:
      throw new Error("Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.");
  }
};

// needed for border-color
var reverseDirection = ['bottom', 'left', 'top', 'right'];

/**
 * CSS to represent triangle with any pointing direction with an optional background color. Accepts number or px values for height and width.
 *
 * @example
 * // Styles as object usage
 *
 * const styles = {
 *   ...triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })
 * }
 *
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${triangle({ pointingDirection: 'right', width: '100px', height: '100px', foregroundColor: 'red' })}
 *
 *
 * // CSS as JS Output
 *
 * div: {
 *  'borderColor': 'transparent',
 *  'borderLeftColor': 'red !important',
 *  'borderStyle': 'solid',
 *  'borderWidth': '50px 0 50px 100px',
 *  'height': '0',
 *  'width': '0',
 * }
 */
function triangle(_ref) {
  var pointingDirection = _ref.pointingDirection,
      height = _ref.height,
      width = _ref.width,
      foregroundColor = _ref.foregroundColor,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === undefined ? 'transparent' : _ref$backgroundColor;

  var widthAndUnit = [parseFloat(width), String(width).replace(/\d+/g, '') || 'px'];
  var heightAndUnit = [parseFloat(height), String(height).replace(/\d+/g, '') || 'px'];
  if (isNaN(heightAndUnit[0]) || isNaN(widthAndUnit[0])) {
    throw new Error('Passed an invalid value to `height` or `width`. Please provide a pixel based unit');
  }

  var reverseDirectionIndex = reverseDirection.indexOf(pointingDirection);
  return _extends({
    width: '0',
    height: '0',
    borderWidth: getBorderWidth(pointingDirection, heightAndUnit, widthAndUnit),
    borderStyle: 'solid'
  }, borderColor.apply(undefined, Array.from({ length: 4 }).map(function (_, index) {
    return index === reverseDirectionIndex ? foregroundColor : backgroundColor;
  })));
}

/**
 * Provides an easy way to change the `wordWrap` property.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...wordWrap('break-word')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${wordWrap('break-word')}
 * `
 *
 * // CSS as JS Output
 *
 * const styles = {
 *   overflowWrap: 'break-word',
 *   wordWrap: 'break-word',
 *   wordBreak: 'break-all',
 * }
 */
function wordWrap() {
  var wrap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'break-word';

  var wordBreak = wrap === 'break-word' ? 'break-all' : wrap;
  return {
    overflowWrap: wrap,
    wordWrap: wrap,
    wordBreak: wordBreak
  };
}

function colorToInt(color) {
  return Math.round(color * 255);
}

function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}

function hslToRgb(hue, saturation, lightness) {
  var convert = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : convertToInt;

  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formular from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = hue % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));

  var red = 0;
  var green = 0;
  var blue = 0;

  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }

  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'

  /**
   * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
   * @private
   */
};function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? '#' + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
var rgbaRegex = /^rgba\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*\)$/;
var hslaRegex = /^hsla\(\s*(\d{0,3}[.]?[0-9]+)\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*,\s*([-+]?[0-9]*[.]?[0-9]+)\s*\)$/;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new Error('Passed an incorrect argument to a color function, please pass a string representation of a color.');
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt('' + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt('' + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt('' + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt('' + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt('' + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt('' + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt('' + rgbMatched[1], 10),
      green: parseInt('' + rgbMatched[2], 10),
      blue: parseInt('' + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor);
  if (rgbaMatched) {
    return {
      red: parseInt('' + rgbaMatched[1], 10),
      green: parseInt('' + rgbaMatched[2], 10),
      blue: parseInt('' + rgbaMatched[3], 10),
      alpha: parseFloat('' + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt('' + hslMatched[1], 10);
    var saturation = parseInt('' + hslMatched[2], 10) / 100;
    var lightness = parseInt('' + hslMatched[3], 10) / 100;
    var rgbColorString = 'rgb(' + hslToRgb(hue, saturation, lightness) + ')';
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + rgbColorString + '.');
    }
    return {
      red: parseInt('' + hslRgbMatched[1], 10),
      green: parseInt('' + hslRgbMatched[2], 10),
      blue: parseInt('' + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor);
  if (hslaMatched) {
    var _hue = parseInt('' + hslaMatched[1], 10);
    var _saturation = parseInt('' + hslaMatched[2], 10) / 100;
    var _lightness = parseInt('' + hslaMatched[3], 10) / 100;
    var _rgbColorString = 'rgb(' + hslToRgb(_hue, _saturation, _lightness) + ')';
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new Error('Couldn\'t generate valid rgb string from ' + normalizedColor + ', it returned ' + _rgbColorString + '.');
    }
    return {
      red: parseInt('' + _hslRgbMatched[1], 10),
      green: parseInt('' + _hslRgbMatched[2], 10),
      blue: parseInt('' + _hslRgbMatched[3], 10),
      alpha: parseFloat('' + hslaMatched[4])
    };
  }
  throw new Error("Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.");
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;

  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;

  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return { hue: 0, saturation: 0, lightness: lightness };
    }
  }

  var hue = void 0;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }

  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return { hue: hue, saturation: saturation, lightness: lightness };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = 'rgb(255, 0, 0)';
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = 'hsla(210, 10%, 40%, 0.75)';
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}

function convertToHex(red, green, blue) {
  return reduceHexValue('#' + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}

function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }

  throw new Error('Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : 'rgba(' + hslToRgb(value, saturation, lightness) + ',' + alpha + ')';
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : 'rgba(' + hslToRgb(value.hue, value.saturation, value.lightness) + ',' + value.alpha + ')';
  }

  throw new Error('Passed invalid arguments to hsla, please pass multiple numbers e.g. hsl(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue('#' + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue('#' + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }

  throw new Error('Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).');
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return 'rgba(' + rgbValue.red + ',' + rgbValue.green + ',' + rgbValue.blue + ',' + secondValue + ')';
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : 'rgba(' + firstValue + ',' + secondValue + ',' + thirdValue + ',' + fourthValue + ')';
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : 'rgba(' + firstValue.red + ',' + firstValue.green + ',' + firstValue.blue + ',' + firstValue.alpha + ')';
  }

  throw new Error('Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).');
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};

var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};

var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

var errMsg = 'Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.';

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new Error(errMsg);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);

  throw new Error(errMsg);
}

// eslint-disable-next-line no-unused-vars
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare

// eslint-disable-next-line no-redeclare

// eslint-disable-next-line no-unused-vars


// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated along
 * the color wheel.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + parseFloat(degree)) % 360
  }));
}

var curriedAdjustHue = /*#__PURE__*/curry(adjustHue);

/**
 * Returns the complement of the provided color. This is identical to adjustHue(180, <color>).
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: complement('#448'),
 *   background: complement('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${complement('#448')};
 *   background: ${complement('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#884";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function complement(color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: (hslColor.hue + 180) % 360
  }));
}

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}

var curriedDarken = /*#__PURE__*/curry(darken);

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
}

var curriedDesaturate = /*#__PURE__*/curry(desaturate);

/**
 * Returns a number (float) representing the luminance of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff',
 *   background: getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)',
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${getLuminance('#CCCD64') >= getLuminance('#0000ff') ? '#CCCD64' : '#0000ff'};
 *   background: ${getLuminance('rgba(58, 133, 255, 1)') >= getLuminance('rgba(255, 57, 149, 1)') ?
 *                             'rgba(58, 133, 255, 1)' :
 *                             'rgba(255, 57, 149, 1)'};
 *
 * // CSS in JS Output
 *
 * div {
 *   background: "#CCCD64";
 *   background: "rgba(58, 133, 255, 1)";
 * }
 */
function getLuminance(color) {
  var rgbColor = parseToRgb(color);

  var _Object$keys$map = Object.keys(rgbColor).map(function (key) {
    var channel = rgbColor[key] / 255;
    return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }),
      r = _Object$keys$map[0],
      g = _Object$keys$map[1],
      b = _Object$keys$map[2];

  return parseFloat((0.2126 * r + 0.7152 * g + 0.0722 * b).toFixed(3));
}

/**
 * Converts the color to a grayscale, by reducing its saturation to 0.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: grayscale('#CCCD64'),
 *   background: grayscale('rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${grayscale('#CCCD64')};
 *   background: ${grayscale('rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#999";
 *   background: "rgba(153,153,153,0.7)";
 * }
 */
function grayscale(color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: 0
  }));
}

/**
 * Inverts the red, green and blue values of a color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: invert('#CCCD64'),
 *   background: invert('rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${invert('#CCCD64')};
 *   background: ${invert('rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#33329b";
 *   background: "rgba(154,155,50,0.7)";
 * }
 */
function invert(color) {
  // parse color string to rgb
  var value = parseToRgb(color);
  return toColorString(_extends({}, value, {
    red: 255 - value.red,
    green: 255 - value.green,
    blue: 255 - value.blue
  }));
}

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}

var curriedLighten = /*#__PURE__*/curry(lighten);

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix(weight, color, otherColor) {
  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });

  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1

    // The formular is copied from the original Sass implementation:
    // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  });var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;

  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha + (color2.alpha - color1.alpha) * (parseFloat(weight) / 1.0)
  };

  return rgba(mixedColor);
}

var curriedMix = /*#__PURE__*/curry(mix);

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedOpacify = /*#__PURE__*/curry(opacify);

/**
 * Returns black or white for best contrast depending on the luminosity of the given color.
 * Follows W3C specs for readability at https://www.w3.org/TR/WCAG20-TECHS/G18.html
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   color: readableColor('#000'),
 *   color: readableColor('papayawhip'),
 *   color: readableColor('rgb(255,0,0)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   color: ${readableColor('#000')};
 *   color: ${readableColor('papayawhip')};
 *   color: ${readableColor('rgb(255,0,0)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   color: "#fff";
 *   color: "#fff";
 *   color: "#000";
 * }
 */

function readableColor(color) {
  return getLuminance(color) > 0.179 ? '#000' : '#fff';
}

var curriedReadableColor = /*#__PURE__*/curry(readableColor);

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
}

var curriedSaturate = /*#__PURE__*/curry(saturate);

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
}

var curriedSetHue = /*#__PURE__*/curry(setHue);

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
}

var curriedSetLightness = /*#__PURE__*/curry(setLightness);

/**
 * Sets the saturation of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
}

var curriedSetSaturation = /*#__PURE__*/curry(setSaturation);

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  return curriedMix(parseFloat(percentage), color, 'rgb(0, 0, 0)');
}

var curriedShade = /*#__PURE__*/curry(shade);

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  return curriedMix(parseFloat(percentage), color, 'rgb(255, 255, 255)');
}

var curriedTint = /*#__PURE__*/curry(tint);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff');
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')},
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 - parseFloat(amount) * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

var curriedTransparentize = /*#__PURE__*/curry(transparentize);

/**
 * Shorthand for easily setting the animation property. Allows either multiple arrays with animations
 * or a single animation spread over the arguments.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation(['rotate', '1s', 'ease-in-out'], ['colorchange', '2s'])}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out, colorchange 2s'
 * }
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...animation('rotate', '1s', 'ease-in-out')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${animation('rotate', '1s', 'ease-in-out')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'animation': 'rotate 1s ease-in-out'
 * }
 */
function animation() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  // Allow single or multiple animations passed
  var multiMode = Array.isArray(args[0]);
  if (!multiMode && args.length > 8) {
    throw new Error('The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation');
  }
  var code = args.map(function (arg) {
    if (multiMode && !Array.isArray(arg) || !multiMode && Array.isArray(arg)) {
      throw new Error("To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')");
    }
    if (Array.isArray(arg) && arg.length > 8) {
      throw new Error('The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation');
    }

    return Array.isArray(arg) ? arg.join(' ') : arg;
  }).join(', ');

  return {
    animation: code
  };
}

/**
 * Shorthand that accepts any number of backgroundImage values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgroundImages('url("/image/background.jpg")', 'linear-gradient(red, green)')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'backgroundImage': 'url("/image/background.jpg"), linear-gradient(red, green)'
 * }
 */
function backgroundImages() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    backgroundImage: properties.join(', ')
  };
}

/**
 * Shorthand that accepts any number of background values as parameters for creating a single background statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${backgrounds('url("/image/background.jpg")', 'linear-gradient(red, green)', 'center no-repeat')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'background': 'url("/image/background.jpg"), linear-gradient(red, green), center no-repeat'
 * }
 */
function backgrounds() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  return {
    background: properties.join(', ')
  };
}

var sideMap = ['top', 'right', 'bottom', 'left'];

/**
 * Shorthand for the border property that splits out individual properties for use with tools like Fela and Styletron. A side keyword can optionally be passed to target only one side's border properties.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...border('1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderColor': 'red',
 *   'borderStyle': 'solid',
 *   'borderWidth': `1px`,
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...border('top', '1px', 'solid', 'red')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${border('top', '1px', 'solid', 'red')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopColor': 'red',
 *   'borderTopStyle': 'solid',
 *   'borderTopWidth': `1px`,
 * }
 */

function border(sideKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (typeof sideKeyword === 'string' && sideMap.indexOf(sideKeyword) >= 0) {
    var _ref;

    return _ref = {}, _ref['border' + capitalizeString(sideKeyword) + 'Width'] = values[0], _ref['border' + capitalizeString(sideKeyword) + 'Style'] = values[1], _ref['border' + capitalizeString(sideKeyword) + 'Color'] = values[2], _ref;
  } else {
    values.unshift(sideKeyword);
    return {
      borderWidth: values[0],
      borderStyle: values[1],
      borderColor: values[2]
    };
  }
}

/**
 * Shorthand that accepts a value for side and a value for radius and applies the radius value to both corners of the side.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderRadius('top', '5px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderRadius('top', '5px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopRightRadius': '5px',
 *   'borderTopLeftRadius': '5px',
 * }
 */
function borderRadius(side, radius) {
  var uppercaseSide = capitalizeString(side);
  if (!radius && radius !== 0) {
    throw new Error('borderRadius expects a radius value as a string or number as the second argument.');
  }
  if (uppercaseSide === 'Top' || uppercaseSide === 'Bottom') {
    var _ref;

    return _ref = {}, _ref['border' + uppercaseSide + 'RightRadius'] = radius, _ref['border' + uppercaseSide + 'LeftRadius'] = radius, _ref;
  }

  if (uppercaseSide === 'Left' || uppercaseSide === 'Right') {
    var _ref2;

    return _ref2 = {}, _ref2['borderTop' + uppercaseSide + 'Radius'] = radius, _ref2['borderBottom' + uppercaseSide + 'Radius'] = radius, _ref2;
  }

  throw new Error('borderRadius expects one of "top", "bottom", "left" or "right" as the first argument.');
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderStyle('solid', 'dashed', 'dotted', 'double')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderStyle('solid', 'dashed', 'dotted', 'double')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopStyle': 'solid',
 *   'borderRightStyle': 'dashed',
 *   'borderBottomStyle': 'dotted',
 *   'borderLeftStyle': 'double'
 * }
 */
function borderStyle() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderStyle'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...borderWidth('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${borderWidth('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'borderTopWidth': '12px',
 *   'borderRightWidth': '24px',
 *   'borderBottomWidth': '36px',
 *   'borderLeftWidth': '48px'
 * }
 */
function borderWidth() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['borderWidth'].concat(values));
}

function generateSelectors(template, state) {
  var stateSuffix = state ? ':' + state : '';
  return template(stateSuffix);
}

/**
 * Function helper that adds an array of states to a template of selectors. Used in textInputs and buttons.
 * @private
 */

function statefulSelectors(states, template, stateMap) {
  if (!template) throw new Error('You must provide a template to this method.');
  if (states.length === 0) return generateSelectors(template, null);
  var selectors = [];
  for (var i = 0; i < states.length; i += 1) {
    if (stateMap && stateMap.indexOf(states[i]) < 0) {
      throw new Error('You passed an unsupported selector state to this method.');
    }
    selectors.push(generateSelectors(template, states[i]));
  }
  selectors = selectors.join(',');
  return selectors;
}

var stateMap = [undefined, null, 'active', 'focus', 'hover'];

function template(state) {
  return 'button' + state + ',\n  input[type="button"]' + state + ',\n  input[type="reset"]' + state + ',\n  input[type="submit"]' + state;
}

/**
 * Populates selectors that target all buttons. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [buttons('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${buttons('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'button:active,
 *  'input[type="button"]:active,
 *  'input[type=\"reset\"]:active,
 *  'input[type=\"submit\"]:active: {
 *   'border': 'none'
 * }
 */
function buttons() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template, stateMap);
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...margin('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${margin('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'marginTop': '12px',
 *   'marginRight': '24px',
 *   'marginBottom': '36px',
 *   'marginLeft': '48px'
 * }
 */
function margin() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['margin'].concat(values));
}

/**
 * Shorthand that accepts up to four values, including null to skip a value, and maps them to their respective directions.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...padding('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${padding('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'paddingTop': '12px',
 *   'paddingRight': '24px',
 *   'paddingBottom': '36px',
 *   'paddingLeft': '48px'
 * }
 */
function padding() {
  for (var _len = arguments.length, values = Array(_len), _key = 0; _key < _len; _key++) {
    values[_key] = arguments[_key];
  }

  return directionalProperty.apply(undefined, ['padding'].concat(values));
}

var positionMap$1 = ['absolute', 'fixed', 'relative', 'static', 'sticky'];

/**
 * Shorthand accepts up to five values, including null to skip a value, and maps them to their respective directions. The first value can optionally be a position keyword.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...position('12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 *
 * // Styles as object usage
 * const styles = {
 *   ...position('absolute', '12px', '24px', '36px', '48px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${position('absolute', '12px', '24px', '36px', '48px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'position': 'absolute',
 *   'top': '12px',
 *   'right': '24px',
 *   'bottom': '36px',
 *   'left': '48px'
 * }
 */
function position(positionKeyword) {
  for (var _len = arguments.length, values = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    values[_key - 1] = arguments[_key];
  }

  if (positionMap$1.indexOf(positionKeyword) >= 0) {
    return _extends({
      position: positionKeyword
    }, directionalProperty.apply(undefined, [''].concat(values)));
  } else {
    var firstValue = positionKeyword; // in this case position is actually the first value
    return directionalProperty.apply(undefined, ['', firstValue].concat(values));
  }
}

/**
 * Shorthand to set the height and width properties in a single statement.
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...size('300px', '250px')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${size('300px', '250px')}
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'height': '300px',
 *   'width': '250px',
 * }
 */
function size(height) {
  var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : height;

  return {
    height: height,
    width: width
  };
}

var stateMap$1 = [undefined, null, 'active', 'focus', 'hover'];

function template$1(state) {
  return 'input[type="color"]' + state + ',\n    input[type="date"]' + state + ',\n    input[type="datetime"]' + state + ',\n    input[type="datetime-local"]' + state + ',\n    input[type="email"]' + state + ',\n    input[type="month"]' + state + ',\n    input[type="number"]' + state + ',\n    input[type="password"]' + state + ',\n    input[type="search"]' + state + ',\n    input[type="tel"]' + state + ',\n    input[type="text"]' + state + ',\n    input[type="time"]' + state + ',\n    input[type="url"]' + state + ',\n    input[type="week"]' + state + ',\n    input:not([type])' + state + ',\n    textarea' + state;
}

/**
 * Populates selectors that target all text inputs. You can pass optional states to append to the selectors.
 * @example
 * // Styles as object usage
 * const styles = {
 *   [textInputs('active')]: {
 *     'border': 'none'
 *   }
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   > ${textInputs('active')} {
 *     border: none;
 *   }
 * `
 *
 * // CSS in JS Output
 *
 *  'input[type="color"]:active,
 *  input[type="date"]:active,
 *  input[type="datetime"]:active,
 *  input[type="datetime-local"]:active,
 *  input[type="email"]:active,
 *  input[type="month"]:active,
 *  input[type="number"]:active,
 *  input[type="password"]:active,
 *  input[type="search"]:active,
 *  input[type="tel"]:active,
 *  input[type="text"]:active,
 *  input[type="time"]:active,
 *  input[type="url"]:active,
 *  input[type="week"]:active,
 *  input:not([type]):active,
 *  textarea:active': {
 *   'border': 'none'
 * }
 */
function textInputs() {
  for (var _len = arguments.length, states = Array(_len), _key = 0; _key < _len; _key++) {
    states[_key] = arguments[_key];
  }

  return statefulSelectors(states, template$1, stateMap$1);
}

/**
 * Accepts any number of transition values as parameters for creating a single transition statement. You may also pass an array of properties as the first parameter that you would like to apply the same tranisition values to (second parameter).
 * @example
 * // Styles as object usage
 * const styles = {
 *   ...transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s'),
 *   ...transitions(['color', 'background-color'], '2.0s ease-in 2s')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   ${transitions('opacity 1.0s ease-in 0s', 'width 2.0s ease-in 2s')};
 *   ${transitions(['color', 'background-color'], '2.0s ease-in 2s'),};
 * `
 *
 * // CSS as JS Output
 *
 * div {
 *   'transition': 'opacity 1.0s ease-in 0s, width 2.0s ease-in 2s'
 *   'transition': 'color 2.0s ease-in 2s, background-color 2.0s ease-in 2s',
 * }
 */
function transitions() {
  for (var _len = arguments.length, properties = Array(_len), _key = 0; _key < _len; _key++) {
    properties[_key] = arguments[_key];
  }

  if (Array.isArray(properties[0]) && properties.length === 2) {
    var value = properties[1];
    if (typeof value !== 'string') {
      throw new Error('Property must be a string value.');
    }
    var transitionsString = properties[0].map(function (property) {
      return property + ' ' + value;
    }).join(', ');
    return {
      transition: transitionsString
    };
  } else {
    return {
      transition: properties.join(', ')
    };
  }
}




/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1252);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date = new Date(y, m, d, h, M, s, ms);

        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
            date.setFullYear(y);
        }
        return date;
    }

    function createUTCDate (y) {
        var date = new Date(Date.UTC.apply(null, arguments));

        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 1st is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        if (!m) {
            return isArray(this._weekdays) ? this._weekdays :
                this._weekdays['standalone'];
        }
        return isArray(this._weekdays) ? this._weekdays[m.day()] :
            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : (match[1] === '+') ? 1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {milliseconds: 0, months: 0};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units || 'millisecond');
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input,units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input,units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    function startOf (units) {
        units = normalizeUnits(units);
        // the following switch intentionally omits break keywords
        // to utilize falling through the cases.
        switch (units) {
            case 'year':
                this.month(0);
                /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
                /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
            case 'date':
                this.hours(0);
                /* falls through */
            case 'hour':
                this.minutes(0);
                /* falls through */
            case 'minute':
                this.seconds(0);
                /* falls through */
            case 'second':
                this.milliseconds(0);
        }

        // weeks are a special case
        if (units === 'week') {
            this.weekday(0);
        }
        if (units === 'isoWeek') {
            this.isoWeekday(1);
        }

        // quarters are also special
        if (units === 'quarter') {
            this.month(Math.floor(this.month() / 3) * 3);
        }

        return this;
    }

    function endOf (units) {
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond') {
            return this;
        }

        // 'date' is an alias for 'day', so it should be considered as such.
        if (units === 'date') {
            units = 'day';
        }

        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'year') {
            days   = this._days   + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            return units === 'month' ? months : months / 12;
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.22.2';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'YYYY-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NewSimpleSpinnerIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NewSimpleSpinner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_spinner_simple_png__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_spinner_simple_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_spinner_simple_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_spinner_simple_accent_png__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_spinner_simple_accent_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_spinner_simple_accent_png__);
var _templateObject=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 1em;\n  height: 1em;\n  margin-top: -0.25em;\n  ",";\n  overflow: hidden;\n  background: transparent url(",") center no-repeat;\n  background-size: contain;\n  border: none;\n  border-radius: 50%;\n  transform: rotate(0deg) translateZ(0);\n  transform-origin: 50%;\n  animation: spin 1s infinite ease-in forwards;\n\n  @keyframes spin {\n    to {\n      transform: rotate(360deg) translateZ(0);\n    }\n  }\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 1em;\n  height: 1em;\n  margin-top: -0.25em;\n  ",";\n  overflow: hidden;\n  background: transparent url(",") center no-repeat;\n  background-size: contain;\n  border: none;\n  border-radius: 50%;\n  transform: rotate(0deg) translateZ(0);\n  transform-origin: 50%;\n  animation: spin 1s infinite ease-in forwards;\n\n  @keyframes spin {\n    to {\n      transform: rotate(360deg) translateZ(0);\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#3B9478":theme.accent||"#ffffff";});// prettier-ignore
/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("margin-right",function(props){return props.noMargin?0:"0.6em";}),function(props){return props.accent?__WEBPACK_IMPORTED_MODULE_4__images_spinner_simple_accent_png___default.a:__WEBPACK_IMPORTED_MODULE_3__images_spinner_simple_png___default.a;}));var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject3);var NewSimpleSpinnerIcon=function NewSimpleSpinnerIcon(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?"1em":_ref2$width,_ref2$height=_ref2.height,height=_ref2$height===undefined?"1em":_ref2$height,_ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"currentColor":_ref2$fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",width:width,height:height,viewBox:"0 0 50 50",enableBackground:"new 0 0 50 50",xmlSpace:"preserve",fill:fill},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("animateTransform",{attributeType:"xml",attributeName:"transform",type:"rotate",from:"0 25 25",to:"360 25 25",dur:"0.6s",repeatCount:"indefinite"})));};var NewSimpleSpinner=function NewSimpleSpinner(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewSimpleSpinnerIcon,props));};

/***/ }),
/* 27 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(231)('wks');
var uid = __webpack_require__(125);
var Symbol = __webpack_require__(17).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__async__ = __webpack_require__(2054);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error__ = __webpack_require__(798);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__error__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__is__ = __webpack_require__(299);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__is__["j"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(799);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_3__logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memo__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__misc__ = __webpack_require__(466);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_5__misc__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__object__ = __webpack_require__(2056);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_6__object__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__path__ = __webpack_require__(2057);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__promisebuffer__ = __webpack_require__(2058);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_8__promisebuffer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__string__ = __webpack_require__(2059);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_9__string__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__supports__ = __webpack_require__(2060);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_10__supports__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__syncpromise__ = __webpack_require__(2061);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__syncpromise__["a"]; });












//# sourceMappingURL=index.js.map

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(1090);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_identity__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_identity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_identity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zipObject__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_zipObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_zipObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Spinners_BrandSpinner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var updateActionMap={profile:{type:"REQUEST_PROFILE"},accounts:{type:"REQUEST_ACCOUNTS"},remoteTradeSettings:{type:"REQUEST_TRADE_SETTINGS"},serverData:{type:"REQUEST_SERVER_DATA"},deals:{type:"REQUEST_DEAL_HISTORY"},apiConfigs:{type:"REQUEST_API_CONFIGS"},apiCountries:{type:"REQUEST_API_COUNTRIES"},stocks:{type:"REQUEST_STOCK_ASSETS"},isIOSShowDeposit:{type:"REQUEST_IOS_SHOW_DEPOSIT"},withdrawOutputMethods:{type:"REQUEST_WITHDRAW_OUTPUT_METHODS"}};var GotDataOrWhat=function(_React$Component){_inherits(GotDataOrWhat,_React$Component);function GotDataOrWhat(){_classCallCheck(this,GotDataOrWhat);return _possibleConstructorReturn(this,(GotDataOrWhat.__proto__||Object.getPrototypeOf(GotDataOrWhat)).apply(this,arguments));}_createClass(GotDataOrWhat,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;__WEBPACK_IMPORTED_MODULE_1_react_dom__["unstable_batchedUpdates"](function(){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(_this2.props.__required)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var _key=_step.value;if(_this2.props.__required[_key]==="UNAVAILABLE"&&updateActionMap[_key]){_this2.props.dispatch(updateActionMap[_key]);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=Object.keys(_this2.props.__optional)[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var _key2=_step2.value;if(_this2.props.__optional[_key2]==="UNAVAILABLE"&&updateActionMap[_key2]){_this2.props.dispatch(updateActionMap[_key2]);}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}});}},{key:"render",value:function render(){var _props=this.props,component=_props.component,__required=_props.__required,__optional=_props.__optional,selector=_props.selector,props=_objectWithoutProperties(_props,["component","__required","__optional","selector"]);// Если какое-то из обязательных полей поломано, паникуем
Object.keys(__required).forEach(function(key){if(__required[key]==="INVALID"){throw new TypeError("Failed retrieving \""+key+"\" data from the server");}});if(Object.keys(__required).some(function(key){return __required[key]!=="AVAILABLE"&&props[key]==null;})){switch(this.props.spinner){case"simple":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["c" /* default */],{accent:true});case"none":return null;default:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Spinners_BrandSpinner__["a" /* default */],null);}}var Component=component;var dataKeys=[].concat(_toConsumableArray(Object.keys(__required)),_toConsumableArray(Object.keys(__optional)));var dataProps=__WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(props,dataKeys);var nonDataProps=__WEBPACK_IMPORTED_MODULE_6_lodash_omit___default()(props,dataKeys);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},nonDataProps,selector(dataProps,nonDataProps)));}}]);return GotDataOrWhat;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function withData(options,customSelector){var required=Array.isArray(options)?options:options.required||[];var optional=Array.isArray(options)?[]:options.optional||[];var spinner=Array.isArray(options)?null:options.spinner||null;var allFields=[].concat(_toConsumableArray(required),_toConsumableArray(optional));var selector=(Array.isArray(options)?customSelector:options.selector)||__WEBPACK_IMPORTED_MODULE_4_lodash_identity___default.a;var mapStateToProps=Object(__WEBPACK_IMPORTED_MODULE_3_reselect__["createSelector"])([function(state){return state.dataRequirementsStatus;}].concat(_toConsumableArray(allFields.map(function(field){return function(state){return state[field];};}))),function(statuses){for(var _len=arguments.length,data=Array(_len>1?_len-1:0),_key3=1;_key3<_len;_key3++){data[_key3-1]=arguments[_key3];}return Object.assign({__required:__WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(statuses,required),__optional:__WEBPACK_IMPORTED_MODULE_5_lodash_pick___default()(statuses,optional)},__WEBPACK_IMPORTED_MODULE_7_lodash_zipObject___default()(allFields,data));});var Wrapper=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(GotDataOrWhat);return function(Component){return function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,Object.assign({},props,{component:Component,spinner:spinner,selector:selector}));};};}/* harmony default export */ __webpack_exports__["a"] = (withData);

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(20)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var IE8_DOM_DEFINE = __webpack_require__(494);
var toPrimitive = __webpack_require__(83);
var dP = Object.defineProperty;

exports.f = __webpack_require__(33) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(85);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(601);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cup__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LineCup__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ColorfulCup__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FinalCup__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timer__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Wallet__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Rating__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Person__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Coins__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DownArrow__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PaymentError__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Caution__ = __webpack_require__(1488);
/* unused harmony reexport DownArrow */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Cup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__LineCup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__ColorfulCup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_3__FinalCup__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__FinalCup__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_4__Timer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__Wallet__["a"]; });
/* unused harmony reexport WalletPlus */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6__Rating__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__Rating__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__Coins__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Coins__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_7__Person__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_10__PaymentError__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Caution__["a"]; });


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalConsumer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ModalRoot; });
/* unused harmony export ModalPortal0 */
/* unused harmony export ModalPortal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Animations__ = __webpack_require__(119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var el=document.getElementById("modal");var ModalContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]({queue:[],showModal:function showModal(){},hideModal:function hideModal(){},dismissAllModals:function dismissAllModals(){}});var ModalConsumer=ModalContext.Consumer;var ModalProvider=function(_React$Component){_inherits(ModalProvider,_React$Component);function ModalProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ModalProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ModalProvider.__proto__||Object.getPrototypeOf(ModalProvider)).call.apply(_ref,[this].concat(args))),_this),_this.showModal=function(component){var props=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};_this.setState(function(state){return{queue:[].concat(_toConsumableArray(state.queue),[{component:component,props:props}])};});// if (document.body) {
//   document.body.style.overflow = "hidden";
// }
},_this.hideModal=function(hide){if(hide&&hide.all){_this.setState({queue:[]});}else{_this.setState(function(state){return{queue:state.queue.slice(0,-1)};});}// if (document.body) {
//   document.body.style.overflow = "";
// }
if(hide&&hide.callback!=null)hide.callback();},_this.dismissAllModals=function(){_this.setState({queue:[]});// if (document.body) {
//   document.body.style.overflow = "";
// }
},_this.state={queue:[],showModal:_this.showModal,hideModal:_this.hideModal,dismissAllModals:_this.dismissAllModals},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ModalProvider,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalContext.Provider,{value:this.state},this.props.children);}}]);return ModalProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalRoot=function(_React$Component2){_inherits(ModalRoot,_React$Component2);function ModalRoot(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,ModalRoot);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=ModalRoot.__proto__||Object.getPrototypeOf(ModalRoot)).call.apply(_ref2,[this].concat(args))),_this2),_this2.retainedModal=null,_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(ModalRoot,[{key:"render",value:function render(){var _this3=this;var Modal=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalConsumer,null,function(_ref3){var queue=_ref3.queue,hideModal=_ref3.hideModal,dismissAllModals=_ref3.dismissAllModals;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_transition_group__["TransitionGroup"],{component:null},queue.map(function(modal,i){var Component=modal.component,props=modal.props;var length=queue.length;// не показываем никакие попапы, кроме последнего
if(length-1!==i){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Animations__["a" /* Fade */],{key:props.id||i},function(_ref4){var style=_ref4.style;if(Component){_this3.retainedModal=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},props,{style:style,onDismiss:hideModal,onDismissAll:dismissAllModals}));return _this3.retainedModal;}if(_this3.retainedModal!=null){return __WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"](_this3.retainedModal,{style:style});}return null;});}));});return __WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](Modal,el);}}]);return ModalRoot;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalPortal0=function(_React$Component3){_inherits(ModalPortal0,_React$Component3);function ModalPortal0(){var _ref5;var _temp3,_this4,_ret3;_classCallCheck(this,ModalPortal0);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this4=_possibleConstructorReturn(this,(_ref5=ModalPortal0.__proto__||Object.getPrototypeOf(ModalPortal0)).call.apply(_ref5,[this].concat(args))),_this4),_this4.ref=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](),_this4.state={modal:null,showModal:function showModal(component,props){_this4.props.context.showModal("div",{ref:_this4.ref,id:props.id});setTimeout(function(){_this4.setState({modal:{component:component,props:props}});},0);}},_temp3),_possibleConstructorReturn(_this4,_ret3);}_createClass(ModalPortal0,[{key:"render",//
// componentDidMount() {
//   this.props.context.showModal("div", { ref: this.ref });
// }
value:function render(){var modal=null;if(this.state.modal&&this.ref.current){var _state$modal=this.state.modal,Component=_state$modal.component,_props=_state$modal.props;modal=__WEBPACK_IMPORTED_MODULE_1_react_dom__["createPortal"](__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},_props,{// style={style}
onDismiss:this.props.context.hideModal,onDismissAll:this.props.context.dismissAllModals})),this.ref.current);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.children(this.state),modal);}}]);return ModalPortal0;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ModalPortal=function ModalPortal(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalContext.Consumer,null,function(context){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ModalPortal0,Object.assign({},props,{context:context}));});};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tournamentCurrency; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,function(props){return props.color||props.theme.accent;});var tournamentCurrency={symbol:"T¢",rawSymbol:"T¢",internationalSymbol:{abbr:"LOL",default:"T¢"},// bids: [5, 10, 20, 30, 50, 100, 150, 200],
// initialDeposit: 1000,
// minFillup: 10,
// minWithdraw: 20,
// vipPayment: 900,
// minBidAmount: 1,
pattern:["sign","value","space","symbol"]};/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{className:props.className,color:props.color},props.children);});

/***/ }),
/* 40 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);
// Я хотел чтобы флаги оставались
// как можно статичнее, но реальность
// диктует иные правила, поэтому флаги
// теперь можно включать в рантайме.
function hydrateFlag(flag,defaultValue){var hashFlags=__WEBPACK_IMPORTED_MODULE_0_querystring___default.a.parse(window.location.hash.slice(1));if(typeof hashFlags[flag]==="string"){return hashFlags[flag]==="true";}try{var stored=localStorage.getItem("__superSecretUnstable_"+flag);if(typeof stored==="string"){return stored==="true";}else{return defaultValue;}}catch(error){return defaultValue;}}//const enableForSiam = process.env.REACT_APP_DEPLOY_TARGET === "siamoption";
var enableForIronAndEz="irontrade"==="irontrade"||"irontrade"==="eztrader";var disableForEz="irontrade"!=="eztrader";var flags={useCoolPhoneInputOnAuth:enableForIronAndEz,useCoolPhoneInputOnProfile:enableForIronAndEz,useCoolPhoneInputOnVerification:enableForIronAndEz,enableBell:true,enableHelpdesk:true,enableHelpdeskNews:true,enableTournaments:disableForEz,//hydrateFlag("enableTournaments", enableForSiam)
showHelpdeskNewsRoute:true,enableCitizenshipSelect:enableForIronAndEz,enableCurrencySelect:true,enableOptimisticDeals:false,enableBackgroundStockIndication:true,enableOneSignal:hydrateFlag("enableOneSignal",true),enableOneSignalInProfile:hydrateFlag("enableOneSignal",false)&&hydrateFlag("enableOneSignalInProfile",false),forceLongHistory:hydrateFlag("forceLongHistory",true),debugHistoryFrames:hydrateFlag("debugHistoryFrames",false),logSocket:hydrateFlag("logSocket",false),OperationCheque:true,enableNewFinalPopup:true,enableChat:true,enableTriggers:true};window.magicallyEnableFeature=function(flag){flags[flag]=true;localStorage.setItem("__superSecretUnstable_"+flag,"true");};/* harmony default export */ __webpack_exports__["a"] = (flags);

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(84);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(1169);
exports.encode = exports.stringify = __webpack_require__(1170);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TourContext; });
/* unused harmony export TourProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_floater__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Orientation__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_timer_svg__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icons_SideArrow__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__useGenerativeData__ = __webpack_require__(1474);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  padding-top: 5px;\n  font-size: ",";\n  ",";\n"],["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  padding-top: 5px;\n  font-size: ",";\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #0085eb;\n  cursor: pointer;\n  pointer-events: auto;\n"],["\n  font-size: ",";\n  color: #0085eb;\n  cursor: pointer;\n  pointer-events: auto;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 50px;\n  ",";\n  background-color: #fff;\n  border-radius: 0 0 8px 8px;\n"],["\n  direction: ",";\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  height: 50px;\n  ",";\n  background-color: #fff;\n  border-radius: 0 0 8px 8px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: ",";\n  font-weight: bold;\n  color: #919191;\n  text-transform: uppercase;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  display: flex;\n  align-items: center;\n  font-size: ",";\n  font-weight: bold;\n  color: #919191;\n  text-transform: uppercase;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(19px);\n  height: 24px;\n  padding: 0 15px;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: ",";\n  background-color: ",";\n  white-space: nowrap;\n  border-radius: 8px 8px 0 0;\n\n  ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  transform: translateX(-50%) translateY(19px);\n  height: 24px;\n  padding: 0 15px;\n  font-size: 14px;\n  line-height: 24px;\n  text-align: center;\n  color: ",";\n  background-color: ",";\n  white-space: nowrap;\n  border-radius: 8px 8px 0 0;\n\n  ",";\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      top: auto;\n      bottom: 100%;\n      transform: translateX(-50%) translateY(-19px);\n      border-radius: 0 0 8px 8px;\n    "],["\n      top: auto;\n      bottom: 100%;\n      transform: translateX(-50%) translateY(-19px);\n      border-radius: 0 0 8px 8px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      top: auto;\n      bottom: 100%;\n      transform: translateX(-50%);\n      border-radius: 8px 8px 0 0;\n    "],["\n      top: auto;\n      bottom: 100%;\n      transform: translateX(-50%);\n      border-radius: 8px 8px 0 0;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n  ",";\n  opacity: 0.59;\n"],["\n  ",";\n  opacity: 0.59;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  width: 100%;\n  background-color: rgb(255, 211, 0);\n"],["\n  direction: ",";\n  display: flex;\n  width: 100%;\n  background-color: rgb(255, 211, 0);\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 57px;\n  min-width: 57px;\n  background-color: #fff;\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 57px;\n  min-width: 57px;\n  background-color: #fff;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  align-self: stretch;\n\n  > svg {\n    opacity: 0.59;\n  }\n"],["\n  align-self: stretch;\n\n  > svg {\n    opacity: 0.59;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 15px;\n  -webkit-text-size-adjust: 100%;\n\n  div {\n    margin-bottom: 0 !important;\n    font-weight: bold !important;\n    line-height: 16px !important;\n  }\n"],["\n  width: 100%;\n  padding: 15px;\n  -webkit-text-size-adjust: 100%;\n\n  div {\n    margin-bottom: 0 !important;\n    font-weight: bold !important;\n    line-height: 16px !important;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -14px;\n  left: 65%;\n  color: rgb(255, 211, 0);\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: -14px;\n  left: 65%;\n  color: rgb(255, 211, 0);\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n      left: 50%;\n      margin-left: -13px;\n    "],["\n      left: 50%;\n      margin-left: -13px;\n    "]),_templateObject16=_taggedTemplateLiteral(["\n      top: 100%;\n      left: auto;\n      right: 15px;\n      margin-top: -3px;\n      color: #fff;\n      transform: rotate(180deg);\n    "],["\n      top: 100%;\n      left: auto;\n      right: 15px;\n      margin-top: -3px;\n      color: #fff;\n      transform: rotate(180deg);\n    "]),_templateObject17=_taggedTemplateLiteral(["\n      top: 5px;\n      left: 100%;\n      right: 15px;\n      margin-right: -3px;\n      color: #fff;\n      transform: rotate(90deg);\n    "],["\n      top: 5px;\n      left: 100%;\n      right: 15px;\n      margin-right: -3px;\n      color: #fff;\n      transform: rotate(90deg);\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0 3px;\n  font-size: ",";\n  text-align: center;\n  color: #000;\n  opacity: 0.59;\n  pointer-events: auto;\n"],["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  padding: 0 3px;\n  font-size: ",";\n  text-align: center;\n  color: #000;\n  opacity: 0.59;\n  pointer-events: auto;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  50% {\n    border-color: transparent;\n  }\n"],["\n  50% {\n    border-color: transparent;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["\n        animation: "," 0.4s linear;\n        animation-iteration-count: 2;\n      "],["\n        animation: "," 0.4s linear;\n        animation-iteration-count: 2;\n      "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TourContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);var SightContext=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(false);var Step=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12,16),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("text-align","left"));var DesktopSkip=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12,16));var FooterContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("padding-right","15px"));var NextButton=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].button(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12));var Timer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.lightAccent;},function(_ref4){var theme=_ref4.theme;return theme.main;},function(_ref5){var isMobile=_ref5.isMobile;return isMobile&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject6);},function(_ref6){var isLandscape=_ref6.isLandscape;return isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7);});var ButtonText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject8,function(_ref7){var theme=_ref7.theme;return theme.lightAccent;});var ArrowContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-left","12px"));var Footer=function Footer(_ref8){var onNext=_ref8.onNext;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NextButton,{onClick:onNext},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"next step")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons_SideArrow__["a" /* default */],null))));};var MobileContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject10,function(_ref9){var theme=_ref9.theme;return theme.direction;});var MobileSide=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject11);var MobileButtonContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(MobileSide)(_templateObject12);var MobileContent=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject13);var MobileArrow=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject14,function(_ref10){var step=_ref10.step,isLandscape=_ref10.isLandscape;return step==="chartWithDeals"&&!isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject15);},function(_ref11){var step=_ref11.step,isLandscape=_ref11.isLandscape;return step==="chartWithDeals"&&isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject16);},function(_ref12){var step=_ref12.step,isLandscape=_ref12.isLandscape;return step==="chartWithProfit"&&isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject17);});var Skip=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject18,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14));var MobileTooltip=function MobileTooltip(props){var withNextButton=props.withNextButton,tour=props.tour,content=props.content,withMobileArrow=props.withMobileArrow,disabledTooltip=props.disabledTooltip,withTimer=props.withTimer,isLandscape=props.isLandscape,rect=props.rect,onLater=props.onLater;var withArrow=withMobileArrow&&(tour.step==="chartWithProfit"||tour.step==="dealsProfit"||tour.step==="chartWithDeals");var disabled=disabledTooltip&&(tour.step==="chartWithProfit"||tour.step==="chartWithDeals");var tooltipStyles=function tooltipStyles(){if(tour.step==="chartWithProfit"){return isLandscape?{position:"absolute",width:rect.left-25,top:0,left:0,zIndex:10}:{position:"absolute",width:"100%",top:67,zIndex:10};}if(tour.step==="chartWithDeals"){return isLandscape?{position:"absolute",width:"100%",top:0,zIndex:10}:{position:"absolute",width:"100%",top:rect.bottom+20,zIndex:10};}var bottom=tour.step==="allStocksSelect"||tour.step==="showChart"&&!isLandscape||tour.step==="showStockSelect"||tour.step==="chartWithDeals"?"0":"auto";var top=bottom==="auto"?withArrow?67+rect.scrollTop:rect.scrollTop:"auto";return{position:"absolute",width:"100%",top:top,bottom:bottom,zIndex:10};};if(disabled){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:tooltipStyles()},withArrow&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileArrow,{step:tour.step,isLandscape:isLandscape},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{width:"26",height:"14",version:"1.1",xmlns:"http://www.w3.org/2000/svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"currentColor",points:"26,14 13,0 0,14"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileSide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Skip,{onClick:function onClick(){onLater("skip");}},tour.locale==="ph"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Icons_Close__["a" /* default */],{width:18,height:18}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Skip tour")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileContent,null,content),withNextButton&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileSide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileButtonContainer,{onClick:tour.next},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons_SideArrow__["a" /* default */],null))),withTimer&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileSide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10__images_timer_svg___default.a,alt:"",width:36})))));};var placement=function placement(step,isMobile,isLandscape){switch(step){case"selectAmount":case"selectTime":case"makeDeal":return"left";case"showChart":return"top-center";case"chartWithDeals":return"left";case"stockSelect":return"bottom-end";default:return"auto";}};function isCurrentStep(expected,current){if(typeof expected==="string"){return expected===current;}else{return expected.includes(current);}}var Tour=function Tour(props){var tour=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(TourContext);var hasActiveParentSight=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(SightContext);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),rect=_useState2[0],setRect=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),showLater=_useState4[0],onLater=_useState4[1];function measure(){if(props.originalRef.current!=null&&tour!=null){var _props$originalRef$cu=props.originalRef.current.getBoundingClientRect(),top=_props$originalRef$cu.top,right=_props$originalRef$cu.right,bottom=_props$originalRef$cu.bottom,left=_props$originalRef$cu.left;var scrollTop=document.body.scrollTop;setRect(function(rect){if(rect==null){return{top:top,right:right,bottom:bottom,left:left,scrollTop:scrollTop};}if(rect.top===top&&rect.right===right&&rect.bottom===bottom&&rect.left===left&&rect.scrollTop===scrollTop){return rect;}else{return{top:top,right:right,bottom:bottom,left:left,scrollTop:scrollTop};}});}}Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var isRunning=true;function loop(){if(isRunning){measure();requestAnimationFrame(loop);}}loop();return function(){isRunning=false;};},[]);/*useEffect(() => {
    // Кажется что на каждый апдейт мы реагируем новым апдейтом, иными словами —
    // мы в бесконечном цикле. Выживаем за счёт того что useEffect отложен по
    // таймеру.
    // Можно убедиться, если заменить useEffect на useLayoutEffect.
    // Туду пофиксить.
    if (props.originalRef.current != null && tour != null) {
      let {
        top,
        right,
        bottom,
        left
      } = props.originalRef.current.getBoundingClientRect();
      setRect({ top, right, bottom, left });
    }
  });*/if(showLater){// В этой ветке есть две ошибки:
// 1. Сайд-эффекты в рендере
// 2. Ранний выход перед хуками
// Пока живём, но надо будет на всякий случай поправить.
try{if(!sessionStorage.getItem("showTourLater")){sessionStorage.setItem("showTourLater","true");}}catch(error){console.log("sessionStorage error: ",error);}Object(__WEBPACK_IMPORTED_MODULE_13__common_fetch__["d" /* get */])("/tours/stats?action=3&tour=tour"+tour.analyticsID);if(showLater==="skip"){Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("CLICK_SKIP_TOUR_"+tour.analyticsID,{step:tour.index-1});}else{Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("SHOW_LATER_TOUR_"+tour.analyticsID);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{push:true,to:"/trade"});}if(isCurrentStep(props.step,"intro")){if(tour!=null&&tour.step==="intro"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children({next:tour.next,step:tour.step,isOriginal:false,isTourActive:true,onLater:onLater}));}else{return null;}}if(isCurrentStep(props.step,"outro")){if(tour!=null&&tour.step==="outro"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children({next:tour.next,step:tour.step,isOriginal:false,isTourActive:true,tour:tour}));}else{return null;}}if(tour!=null&&isCurrentStep(props.step,tour.step)&&rect!=null){var withFooter=tour.step==="showChart"||tour.step==="dealsProfit";var _disabled=function _disabled(){return props.disabled&&tour.step!=="stareAtTheChart"&&tour.step!=="showChart"&&tour.step!=="allStocksSelect";};var padding=tour.step==="showChart"||props.withoutStyles||tour.analyticsID==="fillup"?0:10;if(tour.analyticsID==="fillup"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["a" /* default */],null,function(screen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_floater__["a" /* default */],{open:true,styles:{wrapper:{cursor:"default",pointerEvents:"none",zIndex:props.zIndex?props.zIndex:100}},content:tour.content},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:rect.right-rect.left+padding*2,height:rect.bottom-rect.top+padding*2,transform:"translateX("+(rect.left-padding)+"px) translateY("+(rect.top-14)+"px)",position:"absolute",padding:padding,background:"white",pointerEvents:"auto",zIndex:150}},props.children({next:tour.next,step:tour.step,isOriginal:false,isTourActive:true,isTourMode:true,deal:tour.deal,startPointsLength:tour.startPointsLength,balance:tour.balance,tour:tour})));});}),tour.ref.current),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SightContext.Provider,{value:true},props.children({next:function next(){return void 0;},step:tour.step,isOriginal:true,isTourActive:true,isTourMode:true,index:tour.index,of:tour.of,balance:tour.balance,tour:tour,startPointsLength:tour.startPointsLength})));}if(hasActiveParentSight){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children({next:function next(){return void 0;},step:tour.step,isOriginal:true,isTourActive:false,isTourMode:true,index:tour.index,of:tour.of,balance:tour.balance,tour:tour}));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["a" /* default */],null,function(screen){return matches&&tour.analyticsID==="3001"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileTooltip,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen),tour:tour,content:tour.content,withNextButton:withFooter,withTimer:tour.step==="chartWithProfit"||tour.step==="chartWithDeals",withMobileArrow:props.withMobileArrow,disabledTooltip:props.disabledTooltip,rect:rect,onLater:onLater},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:rect.right-rect.left+padding*2,height:rect.bottom-rect.top+padding*2,transform:"translateX("+(rect.left-padding)+"px) translateY("+(props.disabledTooltip&&tour.step==="chartWithProfit"&&!Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)?rect.top-padding+80+rect.scrollTop:tour.step==="chartWithDeals"&&props.withoutStyles&&Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)?rect.top-padding+20+rect.scrollTop:rect.top-padding+rect.scrollTop)+"px)",position:"absolute",padding:padding,background:props.bgColor==="green"?props.theme.mainDark:props.theme.main,backgroundImage:props.bgColor==="green"&&"linear-gradient(to bottom, "+props.theme.tradeHeaderGradientTop+" 0, "+props.theme.tradeHeaderGradientBottom+" 100%)",borderRadius:props.dealsContainer?"6px 0 6px 6px":props.dealsTab?"6px 6px 0 0":props.withoutStyles?0:6,boxShadow:props.withoutStyles&&!props.dealsContainer&&!props.dealsTab?"none":"0 0 20px rgba(0, 0, 0, 0.38)",pointerEvents:_disabled()?"none":"auto",overflow:props.dealsContainer||props.dealsTab?"hidden":"auto"}},props.children({next:tour.next,step:tour.step,isOriginal:false,isTourActive:true,isTourMode:true,deal:tour.deal,makeDeal:tour.makeDeal,tourCurrentBid:tour.tourCurrentBid,setTourCurrentBid:tour.setTourCurrentBid,tourBalance:tour.tourBalance,setTourBalance:tour.setTourBalance,balance:tour.balance,tour:tour,startPointsLength:tour.startPointsLength}))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_floater__["a" /* default */],{footer:withFooter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,{onNext:tour.next}):null,styles:{wrapper:{cursor:"default",pointerEvents:"none",zIndex:props.zIndex?props.zIndex:100},floater:{pointerEvents:"none",maxWidth:matches&&Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)&&tour.step!=="makeDeal"||!matches&&tour.step==="stareAtTheChart"?450:300},container:{padding:0,backgroundColor:"rgb(255, 211, 0)",borderRadius:8,cursor:"default"},arrow:{length:14,spread:26,color:tour.step==="showChart"&&withFooter?"#fff":"rgb(255, 211, 0)"}},content:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{padding:20,paddingBottom:5}},tour.content,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Step,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesktopSkip,{onClick:function onClick(e){e.preventDefault();e.stopPropagation();onLater("skip");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Skip tour")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Step"),": ",tour.index-1,"/",tour.of-1)),matches&&Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)||props.showTimer&&tour.step==="stareAtTheChart"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Timer,{isMobile:matches},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"","00:"+(tour.step==="stareAtTheChart"&&tour.deals&&tour.deals[0]&&tour.deals[0].bTime&&(tour.startPointsLength-tour.points.length+tour.deals[0].bTime<10?"0"+(tour.startPointsLength-tour.points.length+tour.deals[0].bTime):tour.startPointsLength-tour.points.length+tour.deals[0].bTime))," until the closure"))),offset:matches&&!Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)&&props.showTimer&&tour.step==="stareAtTheChart"||props.showTimer&&tour.step==="stareAtTheChart"?29:5,open:!_disabled(),placement:placement(tour.step,matches,Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:rect.right-rect.left+padding*2,height:rect.bottom-rect.top+padding*2,transform:"translateX("+(rect.left-padding)+"px) translateY("+(rect.top-24)+"px)",position:"absolute",padding:matches&&!Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)&&tour.analyticsID==="3000"&&tour.step==="selectTime"||matches&&!Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)&&tour.analyticsID==="3000"&&tour.step==="selectAmount"?"10px 0":padding,background:props.bgColor==="green"?props.theme.mainDark:props.theme.main,backgroundImage:props.bgColor==="green"&&"linear-gradient(to bottom, "+props.theme.tradeHeaderGradientTop+" 0, "+props.theme.tradeHeaderGradientBottom+" 100%)",borderRadius:6,boxShadow:"0 0 20px rgba(0, 0, 0, 0.38)",pointerEvents:_disabled()?"none":"auto",zIndex:150}},matches&&Object(__WEBPACK_IMPORTED_MODULE_8__common_Orientation__["b" /* isLandscape */])(screen)&&props.showTimer&&tour.step==="stareAtTheChart"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Timer,{isMobile:matches,isLandscape:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"","00:"+(tour.step==="stareAtTheChart"&&tour.deals&&tour.deals[0]&&tour.deals[0].bTime&&(tour.startPointsLength-tour.points.length+tour.deals[0].bTime<10?"0"+(tour.startPointsLength-tour.points.length+tour.deals[0].bTime):tour.startPointsLength-tour.points.length+tour.deals[0].bTime))," until the closure")),props.children({next:tour.next,step:tour.step,isOriginal:false,isTourActive:true,isTourMode:true,deal:tour.deal,startPointsLength:tour.startPointsLength,balance:tour.balance,tour:tour})));});}),tour.ref.current),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SightContext.Provider,{value:true},props.children({next:function next(){return void 0;},step:tour.step,isOriginal:true,isTourActive:true,isTourMode:true,index:tour.index,of:tour.of,balance:tour.balance,tour:tour,startPointsLength:tour.startPointsLength})));}else if(tour!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children({next:function next(){return void 0;},step:tour.step,isOriginal:true,isTourActive:false,isTourMode:true,index:tour.index,of:tour.of,balance:tour.balance,tour:tour}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.children({next:function next(){return void 0;},isOriginal:true,isTourActive:false,isTourMode:false}));}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["f" /* withTheme */])(Tour));function useGenerator(createInstance){var gen=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);if(gen.current==null){for(var _len=arguments.length,initialArguments=Array(_len>1?_len-1:0),_key=1;_key<_len;_key++){initialArguments[_key-1]=arguments[_key];}gen.current=createInstance.apply(undefined,initialArguments);}var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return gen.current.next().value;}),_useState6=_slicedToArray(_useState5,2),state=_useState6[0],setState=_useState6[1];function next(){var _gen$current;setState((_gen$current=gen.current).next.apply(_gen$current,arguments).value);}return[state,next];}var TourProvider=function TourProvider(props){var _props$profile=props.profile,currency=_props$profile.currency,locale=_props$profile.locale;var bids=props.apiConfigs.currencySettings[currency].bids;var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),outside=_useState8[0],clickOutside=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(30),_useState10=_slicedToArray(_useState9,2),startPointsLength=_useState10[0],getPointsLength=_useState10[1];var borderStyles={border:"border: 2px solid #0085EB;",keyframe:Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["e" /* keyframes */])(_templateObject19),animation:function animation(){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject20,borderStyles.keyframe);}};var dataRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useGenerator=useGenerator(props.scenario,dataRef,currency,bids),_useGenerator2=_slicedToArray(_useGenerator,2),state=_useGenerator2[0],next=_useGenerator2[1];Object(__WEBPACK_IMPORTED_MODULE_14__useGenerativeData__["a" /* useGenerativeData */])(dataRef,{stock:state.stock,isRunning:state.isTimeRunning,deals:state.deals,next:next,attempt:state.attempt});var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_13__common_fetch__["d" /* get */])("/tours/stats?action=1&tour=tour"+props.analyticsID);},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){clickOutside(false);if(state.index===1){Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("SHOW_TOUR_"+props.analyticsID);}else{Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("SHOW_STEP_TOUR_"+props.analyticsID,{step:state.index-1});}},[state.index]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var timer=void 0;if(outside){timer=setTimeout(function(){return clickOutside(false);},1000);}return function(){return clearTimeout(timer);};},[outside]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(state.step==="stareAtTheChart"&&state.deals&&state.deals[0]&&state.deals[0].bTime){getPointsLength(dataRef.current.slice().length);}},[state.index]);var tour=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{analyticsID:props.analyticsID,step:state.step,next:next,ref:ref,index:state.index,of:state.of,balance:state.balance,deals:state.deals,content:state.content,points:dataRef.current,activeDeal:state.activeDeal,locale:locale,outside:outside,borderStyles:borderStyles,startPointsLength:startPointsLength};},[state,next,props.analyticsID,dataRef.current]);var container=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:function onClick(){return clickOutside(true);},style:{position:"fixed",top:0,right:0,bottom:0,left:0,background:"rgba(0, 0, 0, 0.25)",zIndex:5},ref:ref});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TourContext.Provider,{value:tour},props.children,container);};

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// Есть "точка", которая на самом деле представляет собой интервал
// Есть точка точка. Такие мы получаем из сокетов
// Точка с координатами, готовая к отрисовке
// Данные для отрисовки свечи
// Конфиг, обеспечивающий уникальность секции
// Тип секции. Со временем меняется, поэтому мы держим его отдельно
// Все секции на одном экране делят большинство свойств
// Чекпоинты это даты между выходными днями и не
// Легаси?

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return mapStateToTime; });
/* harmony export (immutable) */ __webpack_exports__["h"] = getTimes;
/* harmony export (immutable) */ __webpack_exports__["d"] = getActive;
/* harmony export (immutable) */ __webpack_exports__["e"] = getCompleted;
/* harmony export (immutable) */ __webpack_exports__["g"] = getNew;
/* unused harmony export getDurationObject */
/* harmony export (immutable) */ __webpack_exports__["f"] = getDuration;
/* harmony export (immutable) */ __webpack_exports__["b"] = compactTimer;
/* harmony export (immutable) */ __webpack_exports__["a"] = IncompletedTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = Timer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: ",";\n  align-items: ",";\n  font-size: inherit;\n  line-height: inherit;\n"],["\n  display: flex;\n  flex-direction: ",";\n  align-items: ",";\n  font-size: inherit;\n  line-height: inherit;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  direction: ",";\n"],["\n  direction: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-top: 5px;\n"],["\n  margin-top: 5px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: inline;\n  font-size: ",";\n  font-weight: ",";\n  color: inherit;\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  display: inline;\n  font-size: ",";\n  font-weight: ",";\n  color: inherit;\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject8=_taggedTemplateLiteral(["\n      color: #99959d;\n    "],["\n      color: #99959d;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n      color: #feac00;\n    "],["\n      color: #feac00;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: ",";\n  ",";\n  color: inherit;\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  width: ",";\n  ",";\n  color: inherit;\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  20%, 50% {opacity:0;}\n  50% {display: none;}\n  80%, 100% {opacity:1; display: block;}\n"],["\n  20%, 50% {opacity:0;}\n  50% {display: none;}\n  80%, 100% {opacity:1; display: block;}\n"]),_templateObject12=_taggedTemplateLiteral(["\n  position: absolute;\n  height: 14px;\n  display: inline-block;\n  animation-name: ",";\n  animation-duration: 8s;\n  animation-iteration-count: infinite;\n\n  ",";\n\n  ",";\n"],["\n  position: absolute;\n  height: 14px;\n  display: inline-block;\n  animation-name: ",";\n  animation-duration: 8s;\n  animation-iteration-count: infinite;\n\n  ",";\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      display: block;\n      width: 100%;\n      left: 0;\n      text-align: center;\n      font-size: 16px;\n      font-weight: 400;\n      color: ",";\n\n      @media (max-width: 359px) {\n        font-size: 14px;\n      }\n    "],["\n      display: block;\n      width: 100%;\n      left: 0;\n      text-align: center;\n      font-size: 16px;\n      font-weight: 400;\n      color: ",";\n\n      @media (max-width: 359px) {\n        font-size: 14px;\n      }\n    "]),_templateObject14=_taggedTemplateLiteral(["\n      font-size: 14px;\n      font-weight: 400;\n      color: rgba(255, 255, 255, 0.5) !important;\n    "],["\n      font-size: 14px;\n      font-weight: 400;\n      color: rgba(255, 255, 255, 0.5) !important;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  height: 14px;\n  display: inline-block;\n  animation-name: ",";\n  animation-duration: 8s;\n  animation-delay: 4s;\n  animation-iteration-count: infinite;\n\n  ",";\n\n  ",";\n"],["\n  position: absolute;\n  height: 14px;\n  display: inline-block;\n  animation-name: ",";\n  animation-duration: 8s;\n  animation-delay: 4s;\n  animation-iteration-count: infinite;\n\n  ",";\n\n  ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n      font-size: 14px;\n      font-weight: 400 !important;\n      color: rgba(255, 255, 255, 0.5) !important;\n    "],["\n      font-size: 14px;\n      font-weight: 400 !important;\n      color: rgba(255, 255, 255, 0.5) !important;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n  height: 0 !important;\n  color: transparent !important;\n  user-select: none !important;\n"],["\n  height: 0 !important;\n  color: transparent !important;\n  user-select: none !important;\n"]),_templateObject18=_taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400 !important;\n  color: rgba(255, 255, 255, 0.5) !important;\n"],["\n  font-size: 14px;\n  font-weight: 400 !important;\n  color: rgba(255, 255, 255, 0.5) !important;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 16px;\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 16px;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  display: flex;\n  margin-left: 8px;\n"],["\n  display: flex;\n  margin-left: 8px;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: 16px;\n  color: #ffcc00;\n"],["\n  font-weight: bold;\n  font-size: 16px;\n  color: #ffcc00;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: 400;\n  color: ",";\n  text-align: center;\n\n  @media (max-width: 359px) {\n    font-size: 14px;\n  }\n"],["\n  font-size: 16px;\n  font-weight: 400;\n  color: ",";\n  text-align: center;\n\n  @media (max-width: 359px) {\n    font-size: 14px;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import * as Icon from "./Icons";
// import { Clock } from "../Tournament/IconsTournament";
var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(props){return props.flexDirection;},function(props){return props.alignItems;});var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var TextView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject3,function(_ref){var theme=_ref.theme;return  true?"inherit":"#cccccc";});var DirectionContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.direction;});var TimeContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5);var TimeView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14,15),function(props){return props.noBold?400:700;},function(props){return props.isParticipating&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject7,function(_ref3){var theme=_ref3.theme;return theme.tournamentCardSecondaryColor;});},function(props){return props.isCompleted&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8);},function(_ref4){var isTradePage=_ref4.isTradePage;return isTradePage&&"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);});var IconContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10,function(props){return props.labelOnTop?"16px":"27px";},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-right","5px"),function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject7,function(_ref5){var theme=_ref5.theme;return theme.tournamentCardSecondaryColor;});},function(props){return props.isCompleted&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8);},function(_ref6){var isTradePage=_ref6.isTradePage;return isTradePage&&"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);});var mapStateToTime=function mapStateToTime(state){return{time:state.time||Date.now()};};function getTimes(props){var time=props.time?__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.time):__WEBPACK_IMPORTED_MODULE_1_moment___default()();var startTime=__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.start_date*1000);var endTime=__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.finish_date*1000);var publishTime=__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.publish_time*1000);return{time:time,startTime:startTime,endTime:endTime,publishTime:publishTime};}function getActive(props){var _getTimes=getTimes(props),time=_getTimes.time,startTime=_getTimes.startTime,endTime=_getTimes.endTime;return time.isBetween(startTime,endTime);}function getCompleted(props){var _getTimes2=getTimes(props),time=_getTimes2.time,endTime=_getTimes2.endTime;return time.isAfter(endTime);}function getNew(props){var _getTimes3=getTimes(props),time=_getTimes3.time,publishTime=_getTimes3.publishTime;var diff=time.diff(publishTime,"seconds");var seconds=10800;return Math.abs(diff)>seconds?false:true;}function getDurationObject(props,toStart){var _getTimes4=getTimes(props),time=_getTimes4.time,startTime=_getTimes4.startTime,endTime=_getTimes4.endTime;var duration=null;if(getActive(props)===true){duration=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endTime.diff(time));}else if(getCompleted(props)===false&&typeof toStart==="undefined"){duration=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(startTime.diff(time));}else if(getCompleted(props)===false&&typeof toStart==="string"){duration=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endTime.diff(startTime));}return duration;}function getDuration(props,measurement,toStart){var duration=getDurationObject(props,toStart);var res="00";if(duration!==null){switch(measurement){case"days":res=duration.days();break;case"hours":res=duration.hours();break;case"minutes":res=duration.minutes();break;case"seconds":res=duration.seconds();break;default:res=duration.milliseconds();}}if(isNaN(res)){res="??";}return zero(res);}function zero(value){if(typeof value!=="number"){return value;}return value<10?"0"+value:value;}function compactTimer(props){var duration=getDurationObject(props);if(!duration){return"00:00:00";}var days=duration.days()>0?duration.days()+"d ":"";var hours=zero(Math.max(0,duration.hours()));var minutes=zero(Math.max(0,duration.minutes()));var seconds=zero(Math.max(0,duration.seconds()));var timer=""+days+hours+":"+minutes+":"+seconds;return timer;}function Time(_ref7){var children=_ref7.children,labelOnTop=_ref7.labelOnTop,active=_ref7.active,isCompleted=_ref7.isCompleted,isParticipating=_ref7.isParticipating,isTradePage=_ref7.isTradePage,_ref7$TimeStyle=_ref7.TimeStyle,TimeStyle=_ref7$TimeStyle===undefined?TimeView:_ref7$TimeStyle;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeStyle,{noBold:labelOnTop,active:active,isCompleted:isCompleted,isParticipating:isParticipating,isTradePage:isTradePage},children);}function IncompletedTime(_ref8){var TextStyle=_ref8.TextStyle,props=_objectWithoutProperties(_ref8,["TextStyle"]);var precise=parseInt(props.days,10)===0;var Text=TextStyle||TextView;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.days&&parseInt(props.days,10)>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,props,props.days),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"days")),"\xA0"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,Object.assign({isTradePage:props.isTradePage},props),props.hours),"\xA0",precise?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,":"),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,props,props.minutes),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,":"),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,props,props.seconds)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"hours")));}var opacity=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["e" /* keyframes */])(_templateObject11);var ToStart=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject12,opacity,function(_ref9){var center=_ref9.center;return center&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject13,function(_ref10){var theme=_ref10.theme;return theme.tournamentCardSecondaryColor;});},function(_ref11){var date=_ref11.date;return date&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject14);});var Duration=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject15,opacity,function(_ref12){var center=_ref12.center;return center&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject13,function(_ref13){var theme=_ref13.theme;return theme.tournamentCardSecondaryColor;});},function(_ref14){var date=_ref14.date;return date&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject16);});var TextHack=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject17);var InfoText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject18);var TimerContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject19,function(_ref15){var theme=_ref15.theme;return theme.direction;});var TimerInner=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject20);var TimerText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject21);var CurrentText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject22,function(_ref16){var theme=_ref16.theme;return theme.tournamentCardSecondaryColor;});function Timer(_ref17){var _ref17$flexDirection=_ref17.flexDirection,flexDirection=_ref17$flexDirection===undefined?"column":_ref17$flexDirection,_ref17$alignItems=_ref17.alignItems,alignItems=_ref17$alignItems===undefined?"start":_ref17$alignItems,className=_ref17.className,isTradePage=_ref17.isTradePage,_ref17$TextStyle=_ref17.TextStyle,TextStyle=_ref17$TextStyle===undefined?TextView:_ref17$TextStyle,props=_objectWithoutProperties(_ref17,["flexDirection","alignItems","className","isTradePage","TextStyle"]);var label=props.noLabel===true?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TextStyle,{style:{marginRight:flexDirection==="row"?8:0,marginBottom:props.labelOnTop&&flexDirection!=="row"?8:0}},props.isCompleted?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The tournament is finished"):props.active?props.tournamentPage?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CurrentText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The tournament will finish on:")):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Time left until closing"),":"):!props.toStart?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The tournament will start in"),":"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{minHeight:14}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToStart,{center:props.tournamentPage},props.tournamentPage?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The tournament will start on:")):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The tournament will start in"),":")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Duration,{center:props.tournamentPage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Duration"),":")),!props.tournamentPage&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TextHack,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The tournament will start in"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Duration"),":"))));return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,{className:className,flexDirection:flexDirection,alignItems:alignItems},props.labelOnTop?label:null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,props.noIcon?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,{active:props.active,isCompleted:props.isCompleted,labelOnTop:props.labelOnTop,isTradePage:isTradePage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["l" /* Timer */],{width:props.small?"16px":"27px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DirectionContainer,null,props.labelOnTop?null:label,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeContainer,{style:{minHeight:14,marginTop:props.noLabel===true||props.labelOnTop===true?0:props.tournamentPage?11:5}},props.isCompleted&&props.completedTimer?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,props,props.completedTimer):props.toStart&&!props.active?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{minHeight:14}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToStart,{center:props.tournamentPage,date:props.tournamentPage},props.tournamentPage?__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.start_date*1000).format("DD MMM HH:mm"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IncompletedTime,Object.assign({isTradePage:isTradePage},props))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Duration,{center:props.tournamentPage,date:props.tournamentPage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IncompletedTime,Object.assign({},props,{days:getDuration(props,"days","toStart"),hours:getDuration(props,"hours","toStart"),minutes:getDuration(props,"minutes","toStart"),seconds:getDuration(props,"seconds","toStart"),active:props.active,isCompleted:props.isCompleted,labelOnTop:props.labelOnTop,isTradePage:isTradePage,TimeStyle:props.tournamentPage&&InfoText,TextStyle:props.tournamentPage&&InfoText})))):props.tournamentPage?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{height:14,marginTop:-3,textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.finish_date*1000).format("DD MMM HH:mm"))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IncompletedTime,Object.assign({isTradePage:isTradePage,TextStyle:TextStyle},props))))),props.tournamentPage&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["l" /* Timer */],{width:"16px"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimerInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IncompletedTime,Object.assign({isTradePage:isTradePage},props,{TimeStyle:TimerText,TextStyle:TimerText})))));}

/***/ }),
/* 47 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(544);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1293), __esModule: true };

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(602);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1316);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(1320);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(602);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = newInterval;
var t0 = new Date,
    t1 = new Date;

function newInterval(floori, offseti, count, field) {

  function interval(date) {
    return floori(date = new Date(+date)), date;
  }

  interval.floor = interval;

  interval.ceil = function(date) {
    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
  };

  interval.round = function(date) {
    var d0 = interval(date),
        d1 = interval.ceil(date);
    return date - d0 < d1 - date ? d0 : d1;
  };

  interval.offset = function(date, step) {
    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
  };

  interval.range = function(start, stop, step) {
    var range = [], previous;
    start = interval.ceil(start);
    step = step == null ? 1 : Math.floor(step);
    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
    while (previous < start && start < stop);
    return range;
  };

  interval.filter = function(test) {
    return newInterval(function(date) {
      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
    }, function(date, step) {
      if (date >= date) {
        if (step < 0) while (++step <= 0) {
          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
        } else while (--step >= 0) {
          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
        }
      }
    });
  };

  if (count) {
    interval.count = function(start, end) {
      t0.setTime(+start), t1.setTime(+end);
      floori(t0), floori(t1);
      return Math.floor(count(t0, t1));
    };

    interval.every = function(step) {
      step = Math.floor(step);
      return !isFinite(step) || !(step > 0) ? null
          : !(step > 1) ? interval
          : interval.filter(field
              ? function(d) { return field(d) % step === 0; }
              : function(d) { return interval.count(0, d) % step === 0; });
    };
  }

  return interval;
}


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TradeThemeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TradeThemeContextProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TradeThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IronRedesignThemeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__themes__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes_irontrade_irontrade__ = __webpack_require__(477);
var themeTarget=function(){switch("irontrade"){case"siamoption":return"ThProject";case"eztrader":return"eztrader";case"irontrade":default:return"iron";}}();// process.env.REACT_APP_DEPLOY_TARGET === "siamoption" ? "ThProject" : "iron";
var mapStateToTheme=function mapStateToTheme(state){return{theme:state.settings.theme,profile:state.profile};};var _ThemeProvider=function _ThemeProvider(props){var themeKey=props.themeOverride||"default";var theme=__WEBPACK_IMPORTED_MODULE_4__themes__[themeKey+themeTarget];var defaultTheme=__WEBPACK_IMPORTED_MODULE_4__themes__["default"+themeTarget];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* ThemeProvider */],{theme:theme||defaultTheme},props.children);};/* harmony default export */ __webpack_exports__["e"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToTheme)(_ThemeProvider));var TradeThemeContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);var TradeThemeContextProvider=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToTheme)(function(props){var themeKey=props.theme+themeTarget;var currentTheme=props.profile!=null&&props.profile.currency==="THB"&&themeTarget==="iron"&&props.theme==="default"?__WEBPACK_IMPORTED_MODULE_4__themes__["thProjectTrade"]:__WEBPACK_IMPORTED_MODULE_4__themes__[themeKey];var defaultThemeKey= true?"light":"default";var defaultTheme=__WEBPACK_IMPORTED_MODULE_4__themes__[defaultThemeKey+themeTarget];__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){// если темы нет, сбрасываем settings.theme на дефолтную
// светлую для irontrade, темную — для всего остального
if(currentTheme==null||props.theme==null){props.dispatch({type:"UPDATE_SETTINGS",payload:{theme:defaultThemeKey}});}},[props.theme]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TradeThemeContext.Provider,{value:currentTheme||defaultTheme},props.children);});var TradeThemeProvider=function TradeThemeProvider(props){var theme=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](TradeThemeContext);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* ThemeProvider */],{theme:theme},props.children);};var _IronRedesignThemeProvider=function _IronRedesignThemeProvider(_ref){var children=_ref.children,isMobileApp=_ref.isMobileApp,isInnerHeader=_ref.isInnerHeader,theme=_ref.theme;return  true?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* ThemeProvider */],{theme:isMobileApp||window.isApp?{}:theme==="thProjectTrade"?__WEBPACK_IMPORTED_MODULE_5__themes_irontrade_irontrade__["e" /* thProjectTrade */]:isInnerHeader?{}:__WEBPACK_IMPORTED_MODULE_5__themes_irontrade_irontrade__["c" /* newIndex */]},children):children!=null?children:null;};window.isApp=/wvbo/g.test(window.navigator.userAgent);window.isFullAndroidApp=/wvbo_full/g.test(window.navigator.userAgent);var mapStateToMobileApp=function mapStateToMobileApp(state){var isIOS=__WEBPACK_IMPORTED_MODULE_1_idx___default()(state,function(state){return state.serverData.isIOS;});var isAndroidApp=__WEBPACK_IMPORTED_MODULE_1_idx___default()(state,function(state){return state.serverData.isAndroidApp;});return{isMobileApp:isIOS||isAndroidApp||window.isApp};};var IronRedesignThemeProvider=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToMobileApp)(_IronRedesignThemeProvider);

/***/ }),
/* 54 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(385)('wks');
var uid = __webpack_require__(259);
var Symbol = __webpack_require__(55).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(611);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__ = __webpack_require__(1349);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__accessibilityOverscanIndicesGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRangeRenderer__ = __webpack_require__(615);
/* unused harmony reexport defaultCellRangeRenderer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultOverscanIndicesGetter__ = __webpack_require__(614);
/* unused harmony reexport defaultOverscanIndicesGetter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(18);
/* unused harmony reexport bpfrpt_proptype_NoContentRenderer */
/* unused harmony reexport bpfrpt_proptype_Alignment */
/* unused harmony reexport bpfrpt_proptype_CellPosition */
/* unused harmony reexport bpfrpt_proptype_CellSize */
/* unused harmony reexport bpfrpt_proptype_OverscanIndicesGetter */
/* unused harmony reexport bpfrpt_proptype_RenderedSection */
/* unused harmony reexport bpfrpt_proptype_CellRendererParams */
/* unused harmony reexport bpfrpt_proptype_Scroll */

























/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ClickOutside=function(_React$Component){_inherits(ClickOutside,_React$Component);function ClickOutside(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ClickOutside);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ClickOutside.__proto__||Object.getPrototypeOf(ClickOutside)).call.apply(_ref,[this].concat(args))),_this),_this.hanleDocumentClick=function(event){if(!_this.props.disabled&&_this.node!=null&&event.target instanceof Node&&!_this.node.contains(event.target)&&event.target.closest(".js-click-outside-disable")===null&&typeof _this.props.onOutsideClick==="function"){_this.props.onOutsideClick(event);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ClickOutside,[{key:"componentDidMount",value:function componentDidMount(){document.addEventListener("click",this.hanleDocumentClick,true);}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("click",this.hanleDocumentClick,true);}},{key:"render",value:function render(){var _this2=this;var _props=this.props,onOutsideClick=_props.onOutsideClick,props=_objectWithoutProperties(_props,["onOutsideClick"]);if(typeof this.props.children==="function"){return this.props.children({innerRef:function innerRef(node){_this2.node=node;}});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",Object.assign({ref:function ref(node){_this2.node=node;}},props));}}]);return ClickOutside;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ClickOutside);

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var createDesc = __webpack_require__(124);
module.exports = __webpack_require__(33) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var hide = __webpack_require__(59);
var has = __webpack_require__(66);
var SRC = __webpack_require__(125)('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(72).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var fails = __webpack_require__(20);
var defined = __webpack_require__(84);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 62 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Icon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Info__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Warning__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Forex__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SideArrow__ = __webpack_require__(408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Close__["a"]; });
/* unused harmony reexport InfoIcon */
/* unused harmony reexport WarningIcon */
/* unused harmony reexport Kuchka */
/* unused harmony reexport Forex */
/* unused harmony reexport SideArrow */
function Icon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:props.viewBox,fill:props.fill,width:props.width,height:props.height,className:props.className,style:props.style,onClick:props.onClick},props.children);}

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapStateToShowDeposit;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withDeposit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(5);
function mapStateToShowDeposit(state){var isIOS=state.serverData&&state.serverData.isIOS||false;var iOSShowDeposit=state.iOSShowDeposit||false;var hasRealAcc=state.accounts!=null?!!state.accounts.find(function(acc){return acc.type==="real";})||false:false;var isIronTrade="irontrade"==="irontrade";var showDeposit=false;if(hasRealAcc===true||// - iOS-приложение
!(isIOS===true&&// - для irontrade
isIronTrade===true&&// - ключ iOSShowDeposit = false
iOSShowDeposit===false)){showDeposit=true;}return{showDeposit:showDeposit};}var withDeposit=Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToShowDeposit);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Close;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Close(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?20:_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21.414 21.414",width:width,height:width,strokeWidth:"2px",fill:"none",stroke:"currentColor"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-79.293 0.707)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{x2:"20",y2:"20",transform:"translate(80 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{x1:"20",y2:"20",transform:"translate(80 0)"})));}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(182);
var defined = __webpack_require__(84);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(183);
var createDesc = __webpack_require__(124);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(83);
var has = __webpack_require__(66);
var IE8_DOM_DEFINE = __webpack_require__(494);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(33) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(66);
var toObject = __webpack_require__(42);
var IE_PROTO = __webpack_require__(326)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return WHITESPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VALID_DIGITS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return VALID_PUNCTUATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return PLUS_CHARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MAX_LENGTH_FOR_NSN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_LENGTH_COUNTRY_CODE; });
/* unused harmony export DIGITS */
/* harmony export (immutable) */ __webpack_exports__["j"] = parseDigit;
/* harmony export (immutable) */ __webpack_exports__["h"] = extractCountryCallingCode;
/* harmony export (immutable) */ __webpack_exports__["i"] = matches_entirely;
/* harmony export (immutable) */ __webpack_exports__["g"] = create_extension_pattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IDD__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parseIncompletePhoneNumber__ = __webpack_require__(256);





// `DASHES` will be right after the opening square bracket of the "character class"
var DASHES = '-\u2010-\u2015\u2212\u30FC\uFF0D';
var SLASHES = '\uFF0F/';
var DOTS = '\uFF0E.';
var WHITESPACE = ' \xA0\xAD\u200B\u2060\u3000';
var BRACKETS = '()\uFF08\uFF09\uFF3B\uFF3D\\[\\]';
// export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var TILDES = '~\u2053\u223C\uFF5E';

// Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).
var VALID_DIGITS = '0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9';

// Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.
var VALID_PUNCTUATION = '' + DASHES + SLASHES + DOTS + WHITESPACE + BRACKETS + TILDES;

var PLUS_CHARS = '+\uFF0B';
var LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+');

// The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.
var MAX_LENGTH_FOR_NSN = 17;

// The maximum length of the country calling code.
var MAX_LENGTH_COUNTRY_CODE = 3;

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
	'0': '0',
	'1': '1',
	'2': '2',
	'3': '3',
	'4': '4',
	'5': '5',
	'6': '6',
	'7': '7',
	'8': '8',
	'9': '9',
	'\uFF10': '0', // Fullwidth digit 0
	'\uFF11': '1', // Fullwidth digit 1
	'\uFF12': '2', // Fullwidth digit 2
	'\uFF13': '3', // Fullwidth digit 3
	'\uFF14': '4', // Fullwidth digit 4
	'\uFF15': '5', // Fullwidth digit 5
	'\uFF16': '6', // Fullwidth digit 6
	'\uFF17': '7', // Fullwidth digit 7
	'\uFF18': '8', // Fullwidth digit 8
	'\uFF19': '9', // Fullwidth digit 9
	'\u0660': '0', // Arabic-indic digit 0
	'\u0661': '1', // Arabic-indic digit 1
	'\u0662': '2', // Arabic-indic digit 2
	'\u0663': '3', // Arabic-indic digit 3
	'\u0664': '4', // Arabic-indic digit 4
	'\u0665': '5', // Arabic-indic digit 5
	'\u0666': '6', // Arabic-indic digit 6
	'\u0667': '7', // Arabic-indic digit 7
	'\u0668': '8', // Arabic-indic digit 8
	'\u0669': '9', // Arabic-indic digit 9
	'\u06F0': '0', // Eastern-Arabic digit 0
	'\u06F1': '1', // Eastern-Arabic digit 1
	'\u06F2': '2', // Eastern-Arabic digit 2
	'\u06F3': '3', // Eastern-Arabic digit 3
	'\u06F4': '4', // Eastern-Arabic digit 4
	'\u06F5': '5', // Eastern-Arabic digit 5
	'\u06F6': '6', // Eastern-Arabic digit 6
	'\u06F7': '7', // Eastern-Arabic digit 7
	'\u06F8': '8', // Eastern-Arabic digit 8
	'\u06F9': '9' // Eastern-Arabic digit 9
};

function parseDigit(character) {
	return DIGITS[character];
}

// Parses a formatted phone number
// and returns `{ countryCallingCode, number }`
// where `number` is just the "number" part
// which is left after extracting `countryCallingCode`
// and is not necessarily a "national (significant) number"
// and might as well contain national prefix.
//
function extractCountryCallingCode(number, country, metadata) {
	number = Object(__WEBPACK_IMPORTED_MODULE_2__parseIncompletePhoneNumber__["a" /* default */])(number);

	if (!number) {
		return {};
	}

	// If this is not an international phone number,
	// then don't extract country phone code.
	if (number[0] !== '+') {
		// Convert an "out-of-country" dialing phone number
		// to a proper international phone number.
		var numberWithoutIDD = Object(__WEBPACK_IMPORTED_MODULE_0__IDD__["b" /* stripIDDPrefix */])(number, country, metadata);

		// If an IDD prefix was stripped then
		// convert the number to international one
		// for subsequent parsing.
		if (numberWithoutIDD && numberWithoutIDD !== number) {
			number = '+' + numberWithoutIDD;
		} else {
			return { number: number };
		}
	}

	// Fast abortion: country codes do not begin with a '0'
	if (number[1] === '0') {
		return {};
	}

	metadata = new __WEBPACK_IMPORTED_MODULE_1__metadata__["a" /* default */](metadata);

	// The thing with country phone codes
	// is that they are orthogonal to each other
	// i.e. there's no such country phone code A
	// for which country phone code B exists
	// where B starts with A.
	// Therefore, while scanning digits,
	// if a valid country code is found,
	// that means that it is the country code.
	//
	var i = 2;
	while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
		var countryCallingCode = number.slice(1, i);

		if (metadata.countryCallingCodes()[countryCallingCode]) {
			return {
				countryCallingCode: countryCallingCode,
				number: number.slice(i)
			};
		}

		i++;
	}

	return {};
}

// Checks whether the entire input sequence can be matched
// against the regular expression.
function matches_entirely() {
	var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var regular_expression = arguments[1];

	return new RegExp('^(?:' + regular_expression + ')$').test(text);
}

// The RFC 3966 format for extensions.
var RFC3966_EXTN_PREFIX = ';ext=';

// Pattern to capture digits used in an extension.
// Places a maximum length of '7' for an extension.
var CAPTURING_EXTN_DIGITS = '([' + VALID_DIGITS + ']{1,7})';

/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */
function create_extension_pattern(purpose) {
	// One-character symbols that can be used to indicate an extension.
	var single_extension_characters = 'x\uFF58#\uFF03~\uFF5E';

	switch (purpose) {
		// For parsing, we are slightly more lenient in our interpretation than for matching. Here we
		// allow "comma" and "semicolon" as possible extension indicators. When matching, these are
		case 'parsing':
			single_extension_characters = ',;' + single_extension_characters;
	}

	return RFC3966_EXTN_PREFIX + CAPTURING_EXTN_DIGITS + '|' + '[ \xA0\\t,]*' + '(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|' +
	// "доб."
	'\u0434\u043E\u0431|' + '[' + single_extension_characters + ']|int|anexo|\uFF49\uFF4E\uFF54)' + '[:\\.\uFF0E]?[ \xA0\\t,-]*' + CAPTURING_EXTN_DIGITS + '#?|' + '[- ]+([' + VALID_DIGITS + ']{1,5})#';
}
//# sourceMappingURL=common.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Money__ = __webpack_require__(10);
var HowMuchInBucks=function HowMuchInBucks(props){var Money=props.moneyStyle||__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */];var abbr=__WEBPACK_IMPORTED_MODULE_1_idx___default()(props,function(props){return props.currency.internationalSymbol.abbr;});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,abbr!=="USD"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Money,{as:__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],Value:props.valueStyle,Symbol:props.symbolStyle,currency:props.currency,isTradePage:props.isTradePage},props.value),props.divider||" / "),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Money,{as:__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],Value:props.valueStyle,Symbol:props.symbolStyle,currency:"USD",isTradePage:props.isTradePage},props.valueUSD));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_3__Money__["c" /* mapStateToCurrency */])(HowMuchInBucks));

/***/ }),
/* 72 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.7' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(47);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 74 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(20);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 76 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateMetadata */
/* harmony export (immutable) */ __webpack_exports__["b"] = getExtPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semver_compare__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_semver_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_semver_compare__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



// Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".
var V2 = '1.0.18';

// Added "idd_prefix" and "default_idd_prefix".
var V3 = '1.2.0';

var DEFAULT_EXT_PREFIX = ' ext. ';

var Metadata = function () {
	function Metadata(metadata) {
		_classCallCheck(this, Metadata);

		validateMetadata(metadata);

		this.metadata = metadata;

		this.v1 = !metadata.version;
		this.v2 = metadata.version !== undefined && __WEBPACK_IMPORTED_MODULE_0_semver_compare___default()(metadata.version, V3) === -1;
		this.v3 = metadata.version !== undefined; // && compare(metadata.version, V4) === -1
	}

	_createClass(Metadata, [{
		key: 'hasCountry',
		value: function hasCountry(country) {
			return this.metadata.countries[country] !== undefined;
		}
	}, {
		key: 'country',
		value: function country(_country) {
			if (!_country) {
				this._country = undefined;
				this.country_metadata = undefined;
				return this;
			}

			if (!this.hasCountry(_country)) {
				throw new Error('Unknown country: ' + _country);
			}

			this._country = _country;
			this.country_metadata = this.metadata.countries[_country];
			return this;
		}
	}, {
		key: 'getDefaultCountryMetadataForRegion',
		value: function getDefaultCountryMetadataForRegion() {
			return this.metadata.countries[this.countryCallingCodes()[this.countryCallingCode()][0]];
		}
	}, {
		key: 'countryCallingCode',
		value: function countryCallingCode() {
			return this.country_metadata[0];
		}
	}, {
		key: 'IDDPrefix',
		value: function IDDPrefix() {
			if (this.v1 || this.v2) return;
			return this.country_metadata[1];
		}
	}, {
		key: 'defaultIDDPrefix',
		value: function defaultIDDPrefix() {
			if (this.v1 || this.v2) return;
			return this.country_metadata[12];
		}
	}, {
		key: 'nationalNumberPattern',
		value: function nationalNumberPattern() {
			if (this.v1 || this.v2) return this.country_metadata[1];
			return this.country_metadata[2];
		}
	}, {
		key: 'possibleLengths',
		value: function possibleLengths() {
			if (this.v1) return;
			return this.country_metadata[this.v2 ? 2 : 3];
		}
	}, {
		key: '_getFormats',
		value: function _getFormats(country_metadata) {
			return country_metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
		}

		// For countries of the same region (e.g. NANPA)
		// formats are all stored in the "main" country for that region.
		// E.g. "RU" and "KZ", "US" and "CA".

	}, {
		key: 'formats',
		value: function formats() {
			var _this = this;

			var formats = this._getFormats(this.country_metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
			return formats.map(function (_) {
				return new Format(_, _this);
			});
		}
	}, {
		key: 'nationalPrefix',
		value: function nationalPrefix() {
			return this.country_metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
		}
	}, {
		key: '_getNationalPrefixFormattingRule',
		value: function _getNationalPrefixFormattingRule(country_metadata) {
			return country_metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
		}

		// For countries of the same region (e.g. NANPA)
		// national prefix formatting rule is stored in the "main" country for that region.
		// E.g. "RU" and "KZ", "US" and "CA".

	}, {
		key: 'nationalPrefixFormattingRule',
		value: function nationalPrefixFormattingRule() {
			return this._getNationalPrefixFormattingRule(this.country_metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
		}
	}, {
		key: 'nationalPrefixForParsing',
		value: function nationalPrefixForParsing() {
			// If `national_prefix_for_parsing` is not set explicitly,
			// then infer it from `national_prefix` (if any)
			return this.country_metadata[this.v1 ? 5 : this.v2 ? 6 : 7] || this.nationalPrefix();
		}
	}, {
		key: 'nationalPrefixTransformRule',
		value: function nationalPrefixTransformRule() {
			return this.country_metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
		}
	}, {
		key: '_getNationalPrefixIsOptionalWhenFormatting',
		value: function _getNationalPrefixIsOptionalWhenFormatting() {
			return !!this.country_metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
		}

		// For countries of the same region (e.g. NANPA)
		// "national prefix is optional when parsing" flag is
		// stored in the "main" country for that region.
		// E.g. "RU" and "KZ", "US" and "CA".

	}, {
		key: 'nationalPrefixIsOptionalWhenFormatting',
		value: function nationalPrefixIsOptionalWhenFormatting() {
			return this._getNationalPrefixIsOptionalWhenFormatting(this.country_metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
		}
	}, {
		key: 'leadingDigits',
		value: function leadingDigits() {
			return this.country_metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
		}
	}, {
		key: 'types',
		value: function types() {
			return this.country_metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
		}
	}, {
		key: 'hasTypes',
		value: function hasTypes() {
			// Versions 1.2.0 - 1.2.4: can be `[]`.
			/* istanbul ignore next */
			if (this.types() && this.types().length === 0) {
				return false;
			}
			// Versions <= 1.2.4: can be `undefined`.
			// Version >= 1.2.5: can be `0`.
			return !!this.types();
		}
	}, {
		key: 'type',
		value: function type(_type) {
			if (this.hasTypes() && getType(this.types(), _type)) {
				return new Type(getType(this.types(), _type), this);
			}
		}
	}, {
		key: 'ext',
		value: function ext() {
			if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
			return this.country_metadata[13] || DEFAULT_EXT_PREFIX;
		}
	}, {
		key: 'countryCallingCodes',
		value: function countryCallingCodes() {
			if (this.v1) return this.metadata.country_phone_code_to_countries;
			return this.metadata.country_calling_codes;
		}

		// Formatting information for regions which share
		// a country calling code is contained by only one region
		// for performance reasons. For example, for NANPA region
		// ("North American Numbering Plan Administration",
		//  which includes USA, Canada, Cayman Islands, Bahamas, etc)
		// it will be contained in the metadata for `US`.
		//
		// `country_calling_code` is always valid.
		// But the actual country may not necessarily be part of the metadata.
		//

	}, {
		key: 'chooseCountryByCountryCallingCode',
		value: function chooseCountryByCountryCallingCode(country_calling_code) {
			var country = this.countryCallingCodes()[country_calling_code][0];

			// Do not want to test this case.
			// (custom metadata, not all countries).
			/* istanbul ignore else */
			if (this.hasCountry(country)) {
				this.country(country);
			}
		}
	}, {
		key: 'selectedCountry',
		value: function selectedCountry() {
			return this._country;
		}
	}]);

	return Metadata;
}();

/* harmony default export */ __webpack_exports__["a"] = (Metadata);

var Format = function () {
	function Format(format, metadata) {
		_classCallCheck(this, Format);

		this._format = format;
		this.metadata = metadata;
	}

	_createClass(Format, [{
		key: 'pattern',
		value: function pattern() {
			return this._format[0];
		}
	}, {
		key: 'format',
		value: function format() {
			return this._format[1];
		}
	}, {
		key: 'leadingDigitsPatterns',
		value: function leadingDigitsPatterns() {
			return this._format[2] || [];
		}
	}, {
		key: 'nationalPrefixFormattingRule',
		value: function nationalPrefixFormattingRule() {
			return this._format[3] || this.metadata.nationalPrefixFormattingRule();
		}
	}, {
		key: 'nationalPrefixIsOptionalWhenFormatting',
		value: function nationalPrefixIsOptionalWhenFormatting() {
			return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormatting();
		}
	}, {
		key: 'nationalPrefixIsMandatoryWhenFormatting',
		value: function nationalPrefixIsMandatoryWhenFormatting() {
			// National prefix is omitted if there's no national prefix formatting rule
			// set for this country, or when the national prefix formatting rule
			// contains no national prefix itself, or when this rule is set but
			// national prefix is optional for this phone number format
			// (and it is not enforced explicitly)
			return this.nationalPrefixFormattingRule() &&
			// Check that national prefix formatting rule is not a dummy one.
			// Check that national prefix formatting rule actually has national prefix digit(s).
			this.usesNationalPrefix() &&
			// Or maybe national prefix is optional for this format
			!this.nationalPrefixIsOptionalWhenFormatting();
		}

		// Checks whether national prefix formatting rule contains national prefix

	}, {
		key: 'usesNationalPrefix',
		value: function usesNationalPrefix() {
			// Check that national prefix formatting rule is not a dummy one
			return this.nationalPrefixFormattingRule() !== '$1' &&
			// Check that national prefix formatting rule actually has national prefix digit(s)
			/\d/.test(this.nationalPrefixFormattingRule().replace('$1', ''));
		}
	}, {
		key: 'internationalFormat',
		value: function internationalFormat() {
			return this._format[5] || this.format();
		}
	}]);

	return Format;
}();

var Type = function () {
	function Type(type, metadata) {
		_classCallCheck(this, Type);

		this.type = type;
		this.metadata = metadata;
	}

	_createClass(Type, [{
		key: 'pattern',
		value: function pattern() {
			if (this.metadata.v1) return this.type;
			return this.type[0];
		}
	}, {
		key: 'possibleLengths',
		value: function possibleLengths() {
			if (this.metadata.v1) return;
			return this.type[1] || this.metadata.possibleLengths();
		}
	}]);

	return Type;
}();

function getType(types, type) {
	switch (type) {
		case 'FIXED_LINE':
			return types[0];
		case 'MOBILE':
			return types[1];
		case 'TOLL_FREE':
			return types[2];
		case 'PREMIUM_RATE':
			return types[3];
		case 'PERSONAL_NUMBER':
			return types[4];
		case 'VOICEMAIL':
			return types[5];
		case 'UAN':
			return types[6];
		case 'PAGER':
			return types[7];
		case 'VOIP':
			return types[8];
		case 'SHARED_COST':
			return types[9];
	}
}

function validateMetadata(metadata) {
	if (!metadata) {
		throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
	}

	// `country_phone_code_to_countries` was renamed to
	// `country_calling_codes` in `1.0.18`.
	if (!is_object(metadata) || !is_object(metadata.countries) || !is_object(metadata.country_calling_codes) && !is_object(metadata.country_phone_code_to_countries)) {
		throw new Error('[libphonenumber-js] `metadata` argument was passed but it\'s not a valid metadata. Must be an object having `.countries` and `.country_calling_codes` child object properties. Got ' + (is_object(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + type_of(metadata) + ': ' + metadata) + '.');
	}
}

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var is_object = function is_object(_) {
	return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
};

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var type_of = function type_of(_) {
	return typeof _ === 'undefined' ? 'undefined' : _typeof(_);
};

function getExtPrefix(country, metadata) {
	return new Metadata(metadata).country(country).ext();
}
//# sourceMappingURL=metadata.js.map

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["c"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__ = __webpack_require__(2052);
/* unused harmony reexport addBreadcrumb */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["a"]; });
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* unused harmony reexport configureScope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__sentry_minimal__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(218);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* unused harmony reexport Span */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(2063);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__api__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseclient__ = __webpack_require__(2064);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__baseclient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__basebackend__ = __webpack_require__(2066);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__basebackend__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dsn__ = __webpack_require__(467);
/* unused harmony reexport Dsn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sdk__ = __webpack_require__(2067);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__sdk__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transports_noop__ = __webpack_require__(802);
/* unused harmony reexport NoopTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__integrations__ = __webpack_require__(2068);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__integrations__; });










//# sourceMappingURL=index.js.map

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return parseDate; });
/* unused harmony export twoDigits */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAndroidCloaca; });
/* unused harmony export isAndroid */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isWebKitWebViewIOSApp; });
/* unused harmony export isIphone8 */
/* unused harmony export isVietnam */
/* unused harmony export isAndroidApp */
/* unused harmony export androidAppVersion */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isIronTerminalIosApp; });
/* harmony export (immutable) */ __webpack_exports__["a"] = iOSAppPostMessage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isIronTerminal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportEmail; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idx__);
var parseDate=function parseDate(ddMmYyyy){var items=ddMmYyyy.split("/");if(items.length===3){return{d:items[0],m:items[1],y:items[2]};}return{};};var twoDigits=function twoDigits(value){return Math.floor(value*100)/100;};var isAndroidCloaca="irontrade"==="irontrade"&&/provider.*IronTrade.*AndroidCloak/g.test(navigator.userAgent);var isAndroid=function isAndroid(){return /android \d\.\d/.test(navigator.userAgent.toLowerCase());};var isWebKitWebViewIOSApp=function isWebKitWebViewIOSApp(){return /wkwebview/.test(navigator.userAgent.toLowerCase());};var isIphone8=function isIphone8(){var lc=navigator.userAgent.toLowerCase();return /iphone os 8_\d/.test(lc)&&/version\/8\.\d/.test(lc);};var isVietnam=function isVietnam(code){return typeof code==="string"&&code.toLowerCase()==="vn";};var androidAppRegExp=/\bos\b.*\bAndroidWeb\b.*\bapplication_id\b.*com\.full\.iron.*\bversion\b: (\d+).*\bprovider\b.*\bIronTrade\b.*wvbo_full/;var ironTerminalIosAppRegExp=/\bprovider\b.*\bIronTrade\b.*\bos\b.*\biOS\b.*\bapplication_id\b.*com\.ironterminal\.ios.*\bversion\b: (\d+)/;var isAndroidApp="irontrade"==="irontrade"&&androidAppRegExp.test(navigator.userAgent);var androidAppVersion=function(){if(false)return null;var r=androidAppRegExp.exec(navigator.userAgent);return r?parseInt(r[1],10):null;}();var isIronTerminalIosApp="irontrade"==="irontrade"&&ironTerminalIosAppRegExp.test(window.navigator.userAgent);function iOSAppPostMessage(message){var wk=window.webkit;var mh=wk&&wk.messageHandlers;var ch=mh&&mh.callbackHandler;var pm=ch&&typeof ch.postMessage==="function";if(pm){ch.postMessage(message);return true;}else{console.log("postMessage is undefined");return false;}}var isIronTerminal=function isIronTerminal(){return /ironterminal/.test(navigator.userAgent.toLowerCase());};var supportEmail=function supportEmail(serverData,profile){if(serverData!=null){if(true){if(profile==null){return __WEBPACK_IMPORTED_MODULE_0_idx___default()(serverData,function(d){return d.supportInfoList.country[serverData.geo].email;})||__WEBPACK_IMPORTED_MODULE_0_idx___default()(serverData,function(d){return d.supportInfoList.default.email;})||serverData.supportEmail;}return __WEBPACK_IMPORTED_MODULE_0_idx___default()(serverData,function(d){return d.supportInfoList.currency[profile.currency].email;})||__WEBPACK_IMPORTED_MODULE_0_idx___default()(serverData,function(d){return d.supportInfoList.default.email;})||serverData.supportEmail;}else{return idx(serverData,function(d){return d.supportInfoList.country[serverData.geo].email;})||idx(serverData,function(d){return d.supportInfoList.default.email;})||serverData.supportEmail;}}return null;};

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dataLayer=function dataLayer(event){if(window.location.host==="test.siamoption.com"){if(false){return false;}}var dataLayer=window.dataLayer||[];try{dataLayer.push(event);}catch(error){console.warn("GA error ",error);}};/* harmony default export */ __webpack_exports__["a"] = (dataLayer);

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(21);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 84 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 85 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(3);
var core = __webpack_require__(72);
var fails = __webpack_require__(20);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(73);
var IObject = __webpack_require__(182);
var toObject = __webpack_require__(42);
var toLength = __webpack_require__(35);
var asc = __webpack_require__(343);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony export (immutable) */ __webpack_exports__["d"] = is_viable_phone_number;
/* harmony export (immutable) */ __webpack_exports__["b"] = extract_formatted_phone_number;
/* harmony export (immutable) */ __webpack_exports__["e"] = strip_national_prefix_and_carrier_code;
/* harmony export (immutable) */ __webpack_exports__["c"] = find_country_code;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parseIncompletePhoneNumber__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getCountryCallingCode__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getNumberType__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isPossibleNumber__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RFC3966__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PhoneNumber__ = __webpack_require__(192);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of 17th November, 2016.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js

















// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2;

// We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.
var MAX_INPUT_STRING_LENGTH = 250;

/**
 * Regexp of all possible ways to write extensions, for use when parsing. This
 * will be run as a case-insensitive regexp match. Wide character versions are
 * also provided after each ASCII version. There are three regular expressions
 * here. The first covers RFC 3966 format, where the extension is added using
 * ';ext='. The second more generic one starts with optional white space and
 * ends with an optional full stop (.), followed by zero or more spaces/tabs
 * /commas and then the numbers themselves. The other one covers the special
 * case of American numbers where the extension is written with a hash at the
 * end, such as '- 503#'. Note that the only capturing groups should be around
 * the digits that you want to capture as part of the extension, or else parsing
 * will fail! We allow two options for representing the accented o - the
 * character itself, and one in the unicode decomposed form with the combining
 * acute accent.
 */
var EXTN_PATTERNS_FOR_PARSING = Object(__WEBPACK_IMPORTED_MODULE_0__common__["g" /* create_extension_pattern */])('parsing');

// Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.
var EXTN_PATTERN = new RegExp('(?:' + EXTN_PATTERNS_FOR_PARSING + ')$', 'i');

//  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + __WEBPACK_IMPORTED_MODULE_0__common__["d" /* VALID_DIGITS */] + ']{' + MIN_LENGTH_FOR_NSN + '}';
//
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//
var VALID_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_0__common__["c" /* PLUS_CHARS */] + ']{0,1}' + '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_0__common__["e" /* VALID_PUNCTUATION */] + ']*' + '[' + __WEBPACK_IMPORTED_MODULE_0__common__["d" /* VALID_DIGITS */] + ']' + '){3,}' + '[' + __WEBPACK_IMPORTED_MODULE_0__common__["e" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_0__common__["d" /* VALID_DIGITS */] + ']*';

// The combined regular expression for valid phone numbers:
//
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
// Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' +
// Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER +
// Phone number extensions
'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?' + '$', 'i');

// This consists of the plus symbol, digits, and arabic-indic digits.
var PHONE_NUMBER_START_PATTERN = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_0__common__["c" /* PLUS_CHARS */] + __WEBPACK_IMPORTED_MODULE_0__common__["d" /* VALID_DIGITS */] + ']');

// Regular expression of trailing characters that we want to remove.
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_0__common__["d" /* VALID_DIGITS */] + ']+$');

var default_options = {
	country: {}

	// `options`:
	//  {
	//    country:
	//    {
	//      restrict - (a two-letter country code)
	//                 the phone number must be in this country
	//
	//      default - (a two-letter country code)
	//                default country to use for phone number parsing and validation
	//                (if no country code could be derived from the phone number)
	//    }
	//  }
	//
	// Returns `{ country, number }`
	//
	// Example use cases:
	//
	// ```js
	// parse('8 (800) 555-35-35', 'RU')
	// parse('8 (800) 555-35-35', 'RU', metadata)
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
	// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
	// parse('+7 800 555 35 35')
	// parse('+7 800 555 35 35', metadata)
	// ```
	//
};function parse(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	// Validate `defaultCountry`.


	if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
		if (options.v2) {
			throw new Error('INVALID_COUNTRY');
		}
		throw new Error('Unknown country: ' + options.defaultCountry);
	}

	// Parse the phone number.

	var _parse_input = parse_input(text, options.v2),
	    formatted_phone_number = _parse_input.number,
	    ext = _parse_input.ext;

	// If the phone number is not viable then return nothing.


	if (!formatted_phone_number) {
		if (options.v2) {
			throw new Error('NOT_A_NUMBER');
		}
		return {};
	}

	var _parse_phone_number = parse_phone_number(formatted_phone_number, options.defaultCountry, metadata),
	    country = _parse_phone_number.country,
	    nationalNumber = _parse_phone_number.national_number,
	    countryCallingCode = _parse_phone_number.countryCallingCode,
	    carrierCode = _parse_phone_number.carrierCode;

	if (!metadata.selectedCountry()) {
		if (options.v2) {
			throw new Error('INVALID_COUNTRY');
		}
		return {};
	}

	// Validate national (significant) number length.
	if (nationalNumber.length < MIN_LENGTH_FOR_NSN) {
		// Won't throw here because the regexp already demands length > 1.
		/* istanbul ignore if */
		if (options.v2) {
			throw new Error('TOO_SHORT');
		}
		// Google's demo just throws an error in this case.
		return {};
	}

	// Validate national (significant) number length.
	//
	// A sidenote:
	//
	// They say that sometimes national (significant) numbers
	// can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
	// https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
	// Such numbers will just be discarded.
	//
	if (nationalNumber.length > __WEBPACK_IMPORTED_MODULE_0__common__["b" /* MAX_LENGTH_FOR_NSN */]) {
		if (options.v2) {
			throw new Error('TOO_LONG');
		}
		// Google's demo just throws an error in this case.
		return {};
	}

	if (options.v2) {
		var phoneNumber = new __WEBPACK_IMPORTED_MODULE_7__PhoneNumber__["a" /* default */](countryCallingCode, nationalNumber, metadata.metadata);

		if (country) {
			phoneNumber.country = country;
		}
		if (carrierCode) {
			phoneNumber.carrierCode = carrierCode;
		}
		if (ext) {
			phoneNumber.ext = ext;
		}

		return phoneNumber;
	}

	// Check if national phone number pattern matches the number
	// National number pattern is different for each country,
	// even for those ones which are part of the "NANPA" group.
	var valid = country && Object(__WEBPACK_IMPORTED_MODULE_0__common__["i" /* matches_entirely */])(nationalNumber, metadata.nationalNumberPattern()) ? true : false;

	if (!options.extended) {
		return valid ? result(country, nationalNumber, ext) : {};
	}

	return {
		country: country,
		countryCallingCode: countryCallingCode,
		carrierCode: carrierCode,
		valid: valid,
		possible: valid ? true : options.extended === true && metadata.possibleLengths() && Object(__WEBPACK_IMPORTED_MODULE_5__isPossibleNumber__["b" /* is_possible_number */])(nationalNumber, countryCallingCode !== undefined, metadata),
		phone: nationalNumber,
		ext: ext
	};
}

// Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//
function is_viable_phone_number(number) {
	return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}

/**
 * Extracts a parseable phone number.
 * @param  {string} text - Input.
 * @return {string}.
 */
function extract_formatted_phone_number(text, v2) {
	if (!text) {
		return;
	}

	if (text.length > MAX_INPUT_STRING_LENGTH) {
		if (v2) {
			throw new Error('TOO_LONG');
		}
		return;
	}

	// Attempt to extract a possible number from the string passed in

	var starts_at = text.search(PHONE_NUMBER_START_PATTERN);

	if (starts_at < 0) {
		return;
	}

	return text
	// Trim everything to the left of the phone number
	.slice(starts_at)
	// Remove trailing non-numerical characters
	.replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}

// Strips any national prefix (such as 0, 1) present in the number provided.
// "Carrier codes" are only used  in Colombia and Brazil,
// and only when dialing within those countries from a mobile phone to a fixed line number.
function strip_national_prefix_and_carrier_code(number, metadata) {
	if (!number || !metadata.nationalPrefixForParsing()) {
		return { number: number };
	}

	// Attempt to parse the first digits as a national prefix
	var national_prefix_pattern = new RegExp('^(?:' + metadata.nationalPrefixForParsing() + ')');
	var national_prefix_matcher = national_prefix_pattern.exec(number);

	// If no national prefix is present in the phone number,
	// but the national prefix is optional for this country,
	// then consider this phone number valid.
	//
	// Google's reference `libphonenumber` implementation
	// wouldn't recognize such phone numbers as valid,
	// but I think it would perfectly make sense
	// to consider such phone numbers as valid
	// because if a national phone number was originally
	// formatted without the national prefix
	// then it must be parseable back into the original national number.
	// In other words, `parse(format(number))`
	// must always be equal to `number`.
	//
	if (!national_prefix_matcher) {
		return { number: number };
	}

	var national_significant_number = void 0;

	// `national_prefix_for_parsing` capturing groups
	// (used only for really messy cases: Argentina, Brazil, Mexico, Somalia)
	var captured_groups_count = national_prefix_matcher.length - 1;

	// If the national number tranformation is needed then do it.
	//
	// I don't know what did they mean by `&& national_prefix_matcher[captured_groups_count]`.
	// https://github.com/googlei18n/libphonenumber/blob/d978e59c2e6b1ddfb6816cd190e1b62d9a96bc3b/javascript/i18n/phonenumbers/phonenumberutil.js#L3885
	// https://github.com/googlei18n/libphonenumber/blob/d978e59c2e6b1ddfb6816cd190e1b62d9a96bc3b/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2906
	//
	if (metadata.nationalPrefixTransformRule() && national_prefix_matcher[captured_groups_count]) {
		national_significant_number = number.replace(national_prefix_pattern, metadata.nationalPrefixTransformRule());
	}
	// Else, no transformation is necessary,
	// and just strip the national prefix.
	else {
			national_significant_number = number.slice(national_prefix_matcher[0].length);
		}

	var carrierCode = void 0;
	if (captured_groups_count > 0) {
		carrierCode = national_prefix_matcher[1];
	}

	// The following is done in `get_country_and_national_number_for_local_number()` instead.
	//
	// // Verify the parsed national (significant) number for this country
	// const national_number_rule = new RegExp(metadata.nationalNumberPattern())
	// //
	// // If the original number (before stripping national prefix) was viable,
	// // and the resultant number is not, then prefer the original phone number.
	// // This is because for some countries (e.g. Russia) the same digit could be both
	// // a national prefix and a leading digit of a valid national phone number,
	// // like `8` is the national prefix for Russia and both
	// // `8 800 555 35 35` and `800 555 35 35` are valid numbers.
	// if (matches_entirely(number, national_number_rule) &&
	// 		!matches_entirely(national_significant_number, national_number_rule))
	// {
	// 	return number
	// }

	// Return the parsed national (significant) number
	return {
		number: national_significant_number,
		carrierCode: carrierCode
	};
}

function find_country_code(country_calling_code, national_phone_number, metadata) {
	// Is always non-empty, because `country_calling_code` is always valid
	var possible_countries = metadata.countryCallingCodes()[country_calling_code];

	// If there's just one country corresponding to the country code,
	// then just return it, without further phone number digits validation.
	if (possible_countries.length === 1) {
		return possible_countries[0];
	}

	return _find_country_code(possible_countries, national_phone_number, metadata.metadata);
}

// Changes `metadata` `country`.
function _find_country_code(possible_countries, national_phone_number, metadata) {
	metadata = new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata);

	for (var _iterator = possible_countries, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var country = _ref;

		metadata.country(country);

		// Leading digits check would be the simplest one
		if (metadata.leadingDigits()) {
			if (national_phone_number && national_phone_number.search(metadata.leadingDigits()) === 0) {
				return country;
			}
		}
		// Else perform full validation with all of those
		// fixed-line/mobile/etc regular expressions.
		else if (Object(__WEBPACK_IMPORTED_MODULE_4__getNumberType__["b" /* default */])({ phone: national_phone_number, country: country }, metadata.metadata)) {
				return country;
			}
	}
}

// Sort out arguments
function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
	var text = void 0;
	var options = void 0;
	var metadata = void 0;

	// If the phone number is passed as a string.
	// `parse('88005553535', ...)`.
	if (typeof arg_1 === 'string') {
		text = arg_1;
	} else throw new TypeError('A phone number for parsing must be a string.');

	// If "default country" argument is being passed
	// then move it to `options`.
	// `parse('88005553535', 'RU', [options], metadata)`.
	if ((typeof arg_2 === 'undefined' ? 'undefined' : _typeof(arg_2)) !== 'object') {
		if (arg_4) {
			options = _extends({ defaultCountry: arg_2 }, arg_3);
			metadata = arg_4;
		} else {
			options = { defaultCountry: arg_2 };
			metadata = arg_3;
		}
	}
	// No "default country" argument is being passed.
	// International phone number is passed.
	// `parse('+78005553535', [options], metadata)`.
	else {
			if (arg_3) {
				options = arg_2;
				metadata = arg_3;
			} else {
				metadata = arg_2;
			}
		}

	// Apply default options.
	if (options) {
		options = _extends({}, default_options, options);
	} else {
		options = default_options;
	}

	return { text: text, options: options, metadata: new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata) };
}

// Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.
function strip_extension(number) {
	var start = number.search(EXTN_PATTERN);
	if (start < 0) {
		return {};
	}

	// If we find a potential extension, and the number preceding this is a viable
	// number, we assume it is an extension.
	var number_without_extension = number.slice(0, start);
	/* istanbul ignore if - seems a bit of a redundant check */
	if (!is_viable_phone_number(number_without_extension)) {
		return {};
	}

	var matches = number.match(EXTN_PATTERN);
	var i = 1;
	while (i < matches.length) {
		if (matches[i] != null && matches[i].length > 0) {
			return {
				number: number_without_extension,
				ext: matches[i]
			};
		}
		i++;
	}
}

/**
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?ext }`.
 */
function parse_input(text, v2) {
	// Parse RFC 3966 phone number URI.
	if (text && text.indexOf('tel:') === 0) {
		return Object(__WEBPACK_IMPORTED_MODULE_6__RFC3966__["b" /* parseRFC3966 */])(text);
	}

	var number = extract_formatted_phone_number(text, v2);

	// If the phone number is not viable, then abort.
	if (!number || !is_viable_phone_number(number)) {
		return {};
	}

	// Attempt to parse extension first, since it doesn't require region-specific
	// data and we want to have the non-normalised number here.
	var with_extension_stripped = strip_extension(number);
	if (with_extension_stripped.ext) {
		return with_extension_stripped;
	}

	return { number: number };
}

/**
 * Creates `parse()` result object.
 */
function result(country, national_number, ext) {
	var result = {
		country: country,
		phone: national_number
	};

	if (ext) {
		result.ext = ext;
	}

	return result;
}

/**
 * Parses a viable phone number.
 * Returns `{ country, countryCallingCode, national_number }`.
 */
function parse_phone_number(formatted_phone_number, default_country, metadata) {
	var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_0__common__["h" /* extractCountryCallingCode */])(formatted_phone_number, default_country, metadata.metadata),
	    countryCallingCode = _extractCountryCallin.countryCallingCode,
	    number = _extractCountryCallin.number;

	if (!number) {
		return { countryCallingCode: countryCallingCode };
	}

	var country = void 0;

	if (countryCallingCode) {
		metadata.chooseCountryByCountryCallingCode(countryCallingCode);
	} else if (default_country) {
		metadata.country(default_country);
		country = default_country;
		countryCallingCode = Object(__WEBPACK_IMPORTED_MODULE_3__getCountryCallingCode__["a" /* default */])(default_country, metadata.metadata);
	} else return {};

	var _parse_national_numbe = parse_national_number(number, metadata),
	    national_number = _parse_national_numbe.national_number,
	    carrier_code = _parse_national_numbe.carrier_code;

	// Sometimes there are several countries
	// corresponding to the same country phone code
	// (e.g. NANPA countries all having `1` country phone code).
	// Therefore, to reliably determine the exact country,
	// national (significant) number should have been parsed first.
	//
	// When `metadata.json` is generated, all "ambiguous" country phone codes
	// get their countries populated with the full set of
	// "phone number type" regular expressions.
	//


	var exactCountry = find_country_code(countryCallingCode, national_number, metadata);
	if (exactCountry) {
		country = exactCountry;
		metadata.country(country);
	}

	return {
		country: country,
		countryCallingCode: countryCallingCode,
		national_number: national_number,
		carrierCode: carrier_code
	};
}

function parse_national_number(number, metadata) {
	var national_number = Object(__WEBPACK_IMPORTED_MODULE_1__parseIncompletePhoneNumber__["a" /* default */])(number);
	var carrier_code = void 0;

	// Only strip national prefixes for non-international phone numbers
	// because national prefixes can't be present in international phone numbers.
	// Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
	// first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
	// and then it would assume that's a valid number which it isn't.
	// So no forgiveness for grandmas here.
	// The issue asking for this fix:
	// https://github.com/catamphetamine/libphonenumber-js/issues/159

	var _strip_national_prefi = strip_national_prefix_and_carrier_code(national_number, metadata),
	    potential_national_number = _strip_national_prefi.number,
	    carrierCode = _strip_national_prefi.carrierCode;

	// If metadata has "possible lengths" then employ the new algorythm.


	if (metadata.possibleLengths()) {
		// We require that the NSN remaining after stripping the national prefix and
		// carrier code be long enough to be a possible length for the region.
		// Otherwise, we don't do the stripping, since the original number could be
		// a valid short number.
		switch (Object(__WEBPACK_IMPORTED_MODULE_4__getNumberType__["a" /* check_number_length_for_type */])(potential_national_number, undefined, metadata)) {
			case 'TOO_SHORT':
			// case 'IS_POSSIBLE_LOCAL_ONLY':
			case 'INVALID_LENGTH':
				break;
			default:
				national_number = potential_national_number;
				carrier_code = carrierCode;
		}
	} else {
		// If the original number (before stripping national prefix) was viable,
		// and the resultant number is not, then prefer the original phone number.
		// This is because for some countries (e.g. Russia) the same digit could be both
		// a national prefix and a leading digit of a valid national phone number,
		// like `8` is the national prefix for Russia and both
		// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
		if (Object(__WEBPACK_IMPORTED_MODULE_0__common__["i" /* matches_entirely */])(national_number, metadata.nationalNumberPattern()) && !Object(__WEBPACK_IMPORTED_MODULE_0__common__["i" /* matches_entirely */])(potential_national_number, metadata.nationalNumberPattern())) {
			// Keep the number without stripping national prefix.
		} else {
			national_number = potential_national_number;
			carrier_code = carrierCode;
		}
	}

	return {
		national_number: national_number,
		carrier_code: carrier_code
	};
}

// Determines the country for a given (possibly incomplete) phone number.
// export function get_country_from_phone_number(number, metadata)
// {
// 	return parse_phone_number(number, null, metadata).country
// }
//# sourceMappingURL=parse.js.map

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(55);
var core = __webpack_require__(40);
var ctx = __webpack_require__(197);
var hide = __webpack_require__(138);
var has = __webpack_require__(137);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(117);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(612);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return News; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TitleLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Money; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Subscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Spinner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Timestamp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Buttons_FlatButton__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Date__ = __webpack_require__(828);
var _templateObject=_taggedTemplateLiteral(["\n  padding: 17px;\n  background-color: #fff;\n  border-radius: 2px 2px 0 0;\n\n  @media (max-width: 365px) {\n    padding: 17px 10px;\n    border-radius: 0;\n  }\n\n  :not(:first-child) {\n    border-top: 1px solid #ccc;\n  }\n"],["\n  padding: 17px;\n  background-color: #fff;\n  border-radius: 2px 2px 0 0;\n\n  @media (max-width: 365px) {\n    padding: 17px 10px;\n    border-radius: 0;\n  }\n\n  :not(:first-child) {\n    border-top: 1px solid #ccc;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: ",";\n  line-height: 1.2;\n  color: #252525;//",";\n  text-decoration: none;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n    text-decoration: underline;\n  }\n"],["\n  font-weight: bold;\n  font-size: ",";\n  line-height: 1.2;\n  color: #252525;//",";\n  text-decoration: none;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n    text-decoration: underline;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n  font-size: ",";\n  color: #99959d;//",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  margin-bottom: 16px;\n  font-size: ",";\n  color: #99959d;//",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  color: ",";\n  text-decoration: underline;\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n  }\n"],["\n  color: ",";\n  text-decoration: underline;\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n"],["\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  min-width: 0px;\n  width: 100%;\n  padding: 7px 10px;\n  line-height: 1.25;\n"],["\n  min-width: 0px;\n  width: 100%;\n  padding: 7px 10px;\n  line-height: 1.25;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  text-transform: lowercase;\n\n  ",";\n"],["\n  text-transform: lowercase;\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      ::first-letter {\n        text-transform: uppercase;\n      }\n    "],["\n      ::first-letter {\n        text-transform: uppercase;\n      }\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  width: 1em;\n  height: 1em;\n  line-height: 1;\n"],["\n  width: 1em;\n  height: 1em;\n  line-height: 1;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var News=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var TitleLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14),function(_ref){var theme=_ref.theme;return theme.indexMajor;},function(_ref2){var theme=_ref2.theme;return theme.mainLink;});var TimestampView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12),function(_ref3){var theme=_ref3.theme;return theme.textMuted;});var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.mainLink;});var Money=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */])(_templateObject5,function(_ref5){var theme=_ref5.theme;return theme.upper;});var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Buttons_FlatButton__["a" /* default */])(_templateObject6);var Subscribe=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7,function(_ref6){var theme=_ref6.theme;return theme.lang!=="ar"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var SpinnerWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject9);var Spinner=function Spinner(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SpinnerWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinners_SimpleSpinner__["c" /* default */],null));};var Timestamp=function Timestamp(_ref7){var children=_ref7.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimestampView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Icons_Date__["a" /* StyledDateIcon */],null),children);};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bisect__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__bisect__["a"]; });
/* unused harmony reexport bisectRight */
/* unused harmony reexport bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(168);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ascending__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bisector__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__bisector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cross__ = __webpack_require__(1874);
/* unused harmony reexport cross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__descending__ = __webpack_require__(1875);
/* unused harmony reexport descending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deviation__ = __webpack_require__(724);
/* unused harmony reexport deviation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extent__ = __webpack_require__(726);
/* unused harmony reexport extent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__histogram__ = __webpack_require__(1876);
/* unused harmony reexport histogram */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__threshold_freedmanDiaconis__ = __webpack_require__(1879);
/* unused harmony reexport thresholdFreedmanDiaconis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__threshold_scott__ = __webpack_require__(1880);
/* unused harmony reexport thresholdScott */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__threshold_sturges__ = __webpack_require__(730);
/* unused harmony reexport thresholdSturges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__max__ = __webpack_require__(1881);
/* unused harmony reexport max */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__mean__ = __webpack_require__(1882);
/* unused harmony reexport mean */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__median__ = __webpack_require__(1883);
/* unused harmony reexport median */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__merge__ = __webpack_require__(1884);
/* unused harmony reexport merge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__min__ = __webpack_require__(731);
/* unused harmony reexport min */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pairs__ = __webpack_require__(723);
/* unused harmony reexport pairs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__permute__ = __webpack_require__(1885);
/* unused harmony reexport permute */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__quantile__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_18__quantile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__range__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_19__range__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__scan__ = __webpack_require__(1886);
/* unused harmony reexport scan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__shuffle__ = __webpack_require__(1887);
/* unused harmony reexport shuffle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__sum__ = __webpack_require__(1888);
/* unused harmony reexport sum */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ticks__ = __webpack_require__(729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_23__ticks__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__transpose__ = __webpack_require__(732);
/* unused harmony reexport transpose */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__variance__ = __webpack_require__(725);
/* unused harmony reexport variance */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__zip__ = __webpack_require__(1889);
/* unused harmony reexport zip */





























/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Row__ = __webpack_require__(1980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Button__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input__ = __webpack_require__(1982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Select__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectColor__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SelectWidth__ = __webpack_require__(166);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Row__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__Button__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Input__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Select__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__SelectColor__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__SelectWidth__["b"]; });
/* harmony default export */ __webpack_exports__["g"] = (__WEBPACK_IMPORTED_MODULE_0__Popup__["a" /* default */]);

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REGISTER_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LOGIN_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PASSWORD_RESTORE_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SOCIAL_REGISTER_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SOCIAL_PASSWORD_TAB_ID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RawAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tabs_RegisterMain__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tabs_SocialRegister__ = __webpack_require__(1634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tabs_SocialPassword__ = __webpack_require__(1636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tabs_LoginMain__ = __webpack_require__(1637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tabs_PasswordRestore__ = __webpack_require__(1638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BlockedCountry__ = __webpack_require__(1639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PhoneErrorsLogger__ = __webpack_require__(1641);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RegisterMain=Object(__WEBPACK_IMPORTED_MODULE_12__PhoneErrorsLogger__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Tabs_RegisterMain__["a" /* default */]);var SocialRegister=Object(__WEBPACK_IMPORTED_MODULE_12__PhoneErrorsLogger__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Tabs_SocialRegister__["a" /* default */]);var REGISTER_TAB_ID="register";var LOGIN_TAB_ID="login";var PASSWORD_RESTORE_TAB_ID="password_restore";var SOCIAL_REGISTER_TAB_ID="social_register";var SOCIAL_PASSWORD_TAB_ID="social_password";// export const PHONE_CONFIRM_TAB_ID = "phone_confirm";
// export const PHONE_CHANGE_TAB_ID = "phone_change";
var Auth=function(_React$Component){_inherits(Auth,_React$Component);function Auth(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Auth);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Auth.__proto__||Object.getPrototypeOf(Auth)).call.apply(_ref,[this].concat(args))),_this),_this.state={restricted:null,prevScreen:null,authTab:_this.props.activeTab||LOGIN_TAB_ID,email:"",tel:"",password:"",agree:false,agreeDailyMail:true,country:_this.props.apiCountries?null:{currency:"THB"},notification:null,notificationType:null,socialError:null,restoreType:"email"},_this.setSocialError=function(error){_this.setState({socialError:error});},_this.handleInputChange=function(_ref2){var target=_ref2.target;if(target instanceof HTMLInputElement&&target.type==="checkbox"){var _this$setState;var name=target.name,checked=target.checked;_this.setState((_this$setState={},_defineProperty(_this$setState,name,checked),_defineProperty(_this$setState,"notification",null),_this$setState));}else{var _this$setState2;var _name=target.name,value=target.value;_this.setState((_this$setState2={},_defineProperty(_this$setState2,_name,value),_defineProperty(_this$setState2,"notification",null),_this$setState2));}},_this.handlePhoneInputChange=function(_ref3){var _this$setState3;var target=_ref3.target;var name=target.name,value=target.value;_this.setState((_this$setState3={},_defineProperty(_this$setState3,name,/^\+?(\d+)?$/.test(value)?value:_this.state[name]),_defineProperty(_this$setState3,"notification",null),_this$setState3));},_this.handleTabChange=function(nextScreen,restoreType){if(restoreType){_this.setState({restoreType:restoreType});}if(typeof nextScreen==="string"){_this.props.dispatch({type:"DISPLAY_AUTH_TAB",payload:nextScreen});}else{var payload=_this.state.prevScreen||LOGIN_TAB_ID;_this.props.dispatch({type:"DISPLAY_AUTH_TAB",payload:payload});}},_this.handleNotification=function(notification,notificationType){_this.setState({notification:notification});if(notificationType==="restorePasswordWithEmail"){_this.setState({notificationType:notificationType});}else{_this.setState({notificationType:null});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Auth,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var chucknorris="";if(window.location.search.indexOf("chucknorris=yes")>0){chucknorris="?chuck-norris=yes";}else if(window.location.search.indexOf("chucknorris=no")>0){chucknorris="?chuck-norris=no";}this.props.fetch("/api/is-restricted"+chucknorris,{unstable_dontInferResponse:true}).then(function(_ref4){var restricted=_ref4.restricted;_this2.setState({restricted:restricted});});this.props.fetch("/api/geo").then(function(_ref5){var country=_ref5.country;_this2.setState({myCountry:country});});}},{key:"render",value:function render(){var _props=this.props,_props$apiCountries=_props.apiCountries,apiCountries=_props$apiCountries===undefined?[]:_props$apiCountries,ref_user=_props.ref_user,profile=_props.profile,isAppLogin=_props.isAppLogin,isDarkPage=_props.isDarkPage;var _state=this.state,email=_state.email,tel=_state.tel,password=_state.password,agree=_state.agree,agreeDailyMail=_state.agreeDailyMail,country=_state.country,notification=_state.notification,notificationType=_state.notificationType;var countryList=apiCountries.map(function(country){var name=country.name,currency=country.currency,flag=country.flag,code=country.code;return{value:name,currency:currency,label:name,code:code==="XX"?"world":flag.alpha2code};});if(this.state.restricted){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__BlockedCountry__["a" /* default */],{projectName:this.props.projectTitle,email:this.props.supportEmail,country:this.state.myCountry});}else if(this.state.restricted===null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["c" /* default */],{accent:true});}// При соц реге, когда дозапрашиваем поля для регистрации,
// во избежание unmount компонента, мы храним ошибку в стейте
// и если ошибка есть, то мы по умолчанию делаем активной табу соц реги
switch(this.state.socialError!=null?SOCIAL_REGISTER_TAB_ID:this.props.activeTab){case REGISTER_TAB_ID:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RegisterMain,{noRedirect:this.props.noRedirect,apiCountries:apiCountries,geo:this.props.geo,email:email,tel:tel,password:password,agree:agree,agreeDailyMail:agreeDailyMail,onInputChange:this.handleInputChange,onPhoneInputChange:this.handlePhoneInputChange,onLeave:this.handleTabChange,countryList:countryList,country:country,ref_user:ref_user,showSocial:this.props.showSocial,locale:this.props.locale,isIOS:this.props.isIOS,isDarkPage:isDarkPage,onDismissPopup:this.props.onDismissPopup});case LOGIN_TAB_ID:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Tabs_LoginMain__["a" /* default */],{noRedirect:this.props.noRedirect,email:email,agree:agree,password:password,notification:notification,notificationType:notificationType,onInputChange:this.handleInputChange,onLeave:this.handleTabChange,country:country,showSocial:this.props.showSocial,locale:this.props.locale,ref_user:ref_user,isIOS:this.props.isIOS,isDarkPage:isDarkPage});case PASSWORD_RESTORE_TAB_ID:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Tabs_PasswordRestore__["a" /* default */],{email:email,onInputChange:this.handleInputChange,onLeave:this.handleTabChange,onNotification:this.handleNotification,locale:this.props.locale,isDarkPage:isDarkPage,apiCountries:apiCountries,onPhoneInputChange:this.handlePhoneInputChange,tel:tel,geo:this.props.geo,restoreType:this.state.restoreType});case SOCIAL_REGISTER_TAB_ID:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SocialRegister,{email:email,tel:tel,agree:agree,agreeDailyMail:agreeDailyMail,apiCountries:apiCountries,onInputChange:this.handleInputChange,onPhoneInputChange:this.handlePhoneInputChange,onLeave:this.handleTabChange,countryList:countryList,country:country,profile:profile,isAppLogin:isAppLogin,geo:this.props.geo,isDarkPage:isDarkPage,onDismissPopup:this.props.onDismissPopup,setSocialError:this.setSocialError,socialError:this.state.socialError});case SOCIAL_PASSWORD_TAB_ID:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tabs_SocialPassword__["a" /* default */],{email:this.props.email,agree:agree,agreeDailyMail:agreeDailyMail,password:password,notification:notification,onInputChange:this.handleInputChange,onLeave:this.handleTabChange,country:country,showSocial:this.props.showSocial,locale:this.props.locale,query:this.props.query,location:this.props.location,history:this.props.history,isDarkPage:isDarkPage});default:return null;}}}]);return Auth;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{projectTitle:state.serverData&&state.serverData.projectTitle,supportEmail:state.serverData&&state.serverData.supportEmail,isIOS:state.serverData.isIOS,geo:state.serverData.geo,locale:Object(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["d" /* inferLocale */])(state)};}function mapDispatchToProps(dispatch,ownProps){// Это надо чтобы пользователь компонента мог перехватить экшен
// и исполнить с ним что-нибудь своё
return{dispatch:ownProps.dispatch||dispatch};}var RawAuth=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Auth);var requirements= true?{required:["serverData","apiCountries"],spinner:"simple"}:{required:["serverData"]};/* harmony default export */ __webpack_exports__["g"] = (Object(__WEBPACK_IMPORTED_MODULE_3__withData__["a" /* default */])(requirements)(Object(__WEBPACK_IMPORTED_MODULE_10__common_fetch__["h" /* withFetch */])(RawAuth)));

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FailureScreen__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_thProject_spinner_inner_png__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__spinner_thProject_spinner_inner_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__spinner_thProject_spinner_inner_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_thProject_spinner_outer_png__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_thProject_spinner_outer_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__spinner_thProject_spinner_outer_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThemeProvider__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"],["\n  0% {\n    transform: rotate(0);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  ",";\n  ",";\n  ",";\n  ",";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999999;\n"],["\n  ",";\n  ",";\n  ",";\n  ",";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 999999;\n"]),_templateObject3=_taggedTemplateLiteral(["\n      background-color: ",";\n    "],["\n      background-color: ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      background-color: #222127;\n    "],["\n      background-color: #222127;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      background-image: linear-gradient(#1b546a 0%, #399177 100%);\n    "],["\n      background-image: linear-gradient(#1b546a 0%, #399177 100%);\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  background: center no-repeat;\n  background-size: contain;\n"],["\n  background: center no-repeat;\n  background-size: contain;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: relative;\n  width: 108px;\n  height: 108px;\n  min-width: 108px;\n  ",";\n  ",";\n"],["\n  position: relative;\n  width: 108px;\n  height: 108px;\n  min-width: 108px;\n  ",";\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      background-image: url(",");\n      border-radius: 50%;\n    "],["\n      background-image: url(",");\n      border-radius: 50%;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "],["\n      display: flex;\n      align-items: center;\n      justify-content: center;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: ",";\n  animation: "," 1.2s ease-out infinite;\n  transform-origin: 50%;\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-image: ",";\n  animation: "," 1.2s ease-out infinite;\n  transform-origin: 50%;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IronOuter=function IronOuter(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"#fff":_ref$fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 304 303.999"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath",{id:"clip-path"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-3550,129c-83.813,0-152-68.187-152-152s68.187-152,152-152,152,68.186,152,152S-3466.187,129-3550,129Zm0-297c-79.954,0-145,65.046-145,145s65.047,145,145,145,145-65.047,145-145S-3470.047-168-3550-168Z",transform:"translate(3702 175)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{id:"linear-gradient",x1:"0.5",x2:"0.5",y2:"1",gradientUnits:"objectBoundingBox"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"0",stopColor:fill,stopOpacity:"0"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"1",stopColor:fill}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-531 -398)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{clipPath:"url(#clip-path)",transform:"translate(531 398)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"url(#linear-gradient)",d:"M0,0H160.1V304H0Z",transform:"translate(143.9)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:fill,d:"M0,0H152V304H0Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"url(#linear-gradient)",d:"M0,0H160.1V128.2H0Z",transform:"translate(143.9 175.8)"})))));};var IronInner=function IronInner(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?65:_ref2$width,_ref2$height=_ref2.height,height=_ref2$height===undefined?65:_ref2$height,_ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"#fff":_ref2$fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 31.55 31.549",fill:fill,width:width,height:height},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2829.083-806.423l-1.452-1.452,3.224-3.223-2.617-2.617,6.924-6.924,2.617,2.616,3.209-3.21,1.452,1.453-3.209,3.209,2.617,2.617-6.924,6.924-2.616-2.616-3.223,3.223Zm2.109-7.341,3.78,3.78,3.915-3.915-3.78-3.78Z",transform:"translate(-2810.891 833.72)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2456.1-982.553l3.227-3.227-2.618-2.62,15.258-15.258,2.618,2.62,3.107-3.107,1.456,1.456-3.107,3.107,2.609,2.611-15.258,15.258-2.61-2.611-3.227,3.227Z",transform:"translate(-2456.101 1008.391)"})));};var EzInner=function EzInner(_ref3){var _ref3$fill=_ref3.fill,fill=_ref3$fill===undefined?"#FFD503":_ref3$fill,_ref3$width=_ref3.width,width=_ref3$width===undefined?65:_ref3$width,_ref3$height=_ref3.height,height=_ref3$height===undefined?65:_ref3$height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",width:width,height:height,viewBox:"0 0 25.8 25.7",fill:fill},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"25.6,12.5 24.3,11.2 14.5,1.5 13,0 11.5,1.5 8.5,4.5 7.6,5.4 8.9,6.7 9.4,6.7 12.3,6.7 10.9,5.2  11.5,4.5 13,3 22.7,12.6 21.9,13.4 20.6,14.7 12.8,14.7 11.4,13.2 8.4,13.2 9.8,14.7 11.9,16.8 13.2,16.8 21.5,16.8 22.8,15.5  22.8,15.5 23.6,14.7 25,13.3 25.8,12.6 \t"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"16.8,19 16.3,19 13.5,19 14.8,20.5 14.3,21.1 12.8,22.7 3,13 5.1,10.9 5.3,10.8 13,10.8 14.5,12.2  17.5,12.2 16.1,10.8 14,8.7 12.8,8.7 4.3,8.7 4.3,8.8 2.3,10.9 2.1,11 0,13 0.1,13.1 1.5,14.5 11.3,24.2 12.8,25.7 14.3,24.2  17.3,21.1 18.1,20.2 \t"})));};var rotate360=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,"irontrade"==="siamoption"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(_ref4){var theme=_ref4.theme;return theme.main;}),"irontrade"==="eztrader"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4),"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(_ref5){var currency=_ref5.currency;return currency==="THB"?"#362f42":"#fff";}),function(_ref6){var currency=_ref6.currency;return "irontrade"==="irontrade"&&currency!=null&&currency!=="THB"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);});var Bg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var Spinner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Bg)(_templateObject7,function(){return "irontrade"==="siamoption"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8,__WEBPACK_IMPORTED_MODULE_5__spinner_thProject_spinner_inner_png___default.a);},function(){return("irontrade"==="irontrade"||"irontrade"==="eztrader")&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});var Inner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Bg)(_templateObject10,function(){return  true?"none":"url("+thProjectOuter+")";},rotate360);var BrandSpinner=function(_React$Component){_inherits(BrandSpinner,_React$Component);function BrandSpinner(props){_classCallCheck(this,BrandSpinner);var _this=_possibleConstructorReturn(this,(BrandSpinner.__proto__||Object.getPrototypeOf(BrandSpinner)).call(this,props));_this.state={timeout:false};var timeout=30000;_this.timer=setTimeout(function(){_this.setState({timeout:true});},timeout);return _this;}_createClass(BrandSpinner,[{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timer);this.timer=null;}},{key:"render",value:function render(){if(this.state.timeout){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FailureScreen__["a" /* default */],null);}var currency=__WEBPACK_IMPORTED_MODULE_3_idx___default()(this.props,function(_){return _.profile.currency;});var ironThemeLikeTh="irontrade"==="irontrade"&&currency==="THB";var ironSpinnerColor=currency==null||this.props.isColor?"#3b9478":ironThemeLikeTh?"#FEAC00":"#fff";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ThemeProvider__["e" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{currency:currency},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Spinner,null,"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IronInner,{width:65,height:65,fill:ironSpinnerColor}),"irontrade"==="eztrader"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EzInner,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Inner,null,"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IronOuter,{fill:ironSpinnerColor})))));}}]);return BrandSpinner;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{profile:state.profile};})(BrandSpinner));

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FinalPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Final__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Join__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Leave__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Refill__ = __webpack_require__(1532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__Final__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Join__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Leave__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__Refill__["a"]; });
var FinalPopup=__WEBPACK_IMPORTED_MODULE_0__FeatureFlags__["a" /* default */].enableNewFinalPopup?__WEBPACK_IMPORTED_MODULE_1__Final__["a" /* NewFinalPopup */]:__WEBPACK_IMPORTED_MODULE_1__Final__["c" /* default */];

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(33)) {
  var LIBRARY = __webpack_require__(113);
  var global = __webpack_require__(17);
  var fails = __webpack_require__(20);
  var $export = __webpack_require__(3);
  var $typed = __webpack_require__(242);
  var $buffer = __webpack_require__(349);
  var ctx = __webpack_require__(73);
  var anInstance = __webpack_require__(131);
  var propertyDesc = __webpack_require__(124);
  var hide = __webpack_require__(59);
  var redefineAll = __webpack_require__(133);
  var toInteger = __webpack_require__(85);
  var toLength = __webpack_require__(35);
  var toIndex = __webpack_require__(520);
  var toAbsoluteIndex = __webpack_require__(127);
  var toPrimitive = __webpack_require__(83);
  var has = __webpack_require__(66);
  var classof = __webpack_require__(184);
  var isObject = __webpack_require__(21);
  var toObject = __webpack_require__(42);
  var isArrayIter = __webpack_require__(340);
  var create = __webpack_require__(128);
  var getPrototypeOf = __webpack_require__(69);
  var gOPN = __webpack_require__(129).f;
  var getIterFn = __webpack_require__(342);
  var uid = __webpack_require__(125);
  var wks = __webpack_require__(28);
  var createArrayMethod = __webpack_require__(87);
  var createArrayIncludes = __webpack_require__(232);
  var speciesConstructor = __webpack_require__(239);
  var ArrayIterators = __webpack_require__(345);
  var Iterators = __webpack_require__(155);
  var $iterDetect = __webpack_require__(236);
  var setSpecies = __webpack_require__(130);
  var arrayFill = __webpack_require__(344);
  var arrayCopyWithin = __webpack_require__(510);
  var $DP = __webpack_require__(34);
  var $GOPD = __webpack_require__(68);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

var Map = __webpack_require__(515);
var $export = __webpack_require__(3);
var shared = __webpack_require__(231)('metadata');
var store = shared.store || (shared.store = new (__webpack_require__(518))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};


/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 103 */
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  flex: 1;\n  width: 100%;\n"],["\n  direction: ",";\n  position: relative;\n  display: flex;\n  overflow: hidden;\n  flex: 1;\n  width: 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  flex: 1;\n  -webkit-overflow-scrolling: touch;\n  \n  @media (max-width: 959px) {\n    overflow-y: ",";\n  }\n"],["\n  position: relative;\n  overflow-y: scroll;\n  overflow-x: hidden;\n  flex: 1;\n  -webkit-overflow-scrolling: touch;\n  \n  @media (max-width: 959px) {\n    overflow-y: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  width: auto;\n  ",";\n"],["\n  position: absolute;\n  width: auto;\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  flex: 1;\n  width: 6px;\n  margin: 2px;\n  background-color: ",";\n  opacity: 0.75;\n  border-radius: 4px;\n"],["\n  flex: 1;\n  width: 6px;\n  margin: 2px;\n  background-color: ",";\n  opacity: 0.75;\n  border-radius: 4px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;});var Inner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref2){var disableOverflow=_ref2.disableOverflow;return disableOverflow?"hidden":"scroll";});var Track=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_2__styled_mixins__["c" /* rtl */])("right",0));var Bar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref3){var theme=_ref3.theme;return theme.scrollColor;});var defaultBar=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bar,null);var Scrollable=function(_React$Component){_inherits(Scrollable,_React$Component);function Scrollable(){var _ref4;var _temp,_this,_ret;_classCallCheck(this,Scrollable);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref4=Scrollable.__proto__||Object.getPrototypeOf(Scrollable)).call.apply(_ref4,[this].concat(args))),_this),_this.state={nativeScrollbarWidth:17},_this.containerRef=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](),_this.barRef=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](),_this.tracking=false,_this.top=0,_this.height=0,_this.measure=function(){if(_this.containerRef.current){if(_this.containerRef.current.clientHeight===_this.containerRef.current.scrollHeight){_this.top=0;_this.height=0;}else{var proportion=_this.containerRef.current.clientHeight/_this.containerRef.current.scrollHeight;_this.top=_this.containerRef.current.scrollTop*proportion+"px";_this.height=_this.containerRef.current.clientHeight*proportion+"px";}}},_this.flush=function(){if(_this.barRef.current){_this.barRef.current.style.top=_this.top;_this.barRef.current.style.height=_this.height;}},_this.align=function(e){_this.measure();_this.flush();if(typeof _this.props.scrollFunc==="function"){_this.props.scrollFunc(e);}},_this.track=function(){var raf=null;if(_this.tracking){var prevTop=_this.top;var prevHeight=_this.height;_this.measure();if(_this.top!==prevTop||_this.height!==prevHeight){_this.flush();}raf=window.requestAnimationFrame&&window.requestAnimationFrame(_this.track);}return function(){return window.cancelAnimationFrame&&window.cancelAnimationFrame(raf);};},_this.dragged=false,_this.takeoffPageY=0,_this.takeoffScrollTop=0,_this.handleMouseDown=function(event){event.preventDefault();_this.dragged=true;_this.takeoffPageY=event.pageY;if(_this.containerRef.current){_this.takeoffScrollTop=_this.containerRef.current.scrollTop;}},_this.handleMouseMove=function(event){if(_this.dragged&&_this.containerRef.current){var dy=event.pageY-_this.takeoffPageY;var proportion=_this.containerRef.current.clientHeight/_this.containerRef.current.scrollHeight;_this.containerRef.current.scrollTop=_this.takeoffScrollTop+dy/proportion;}},_this.handleMouseUp=function(){_this.dragged=false;_this.takeoffPageY=0;_this.takeoffScrollTop=0;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Scrollable,[{key:"componentDidMount",value:function componentDidMount(){this.tracking=true;this.cancelRaf=this.track();document.addEventListener("mousemove",this.handleMouseMove);document.addEventListener("mouseup",this.handleMouseUp);if(this.containerRef.current){this.setState({nativeScrollbarWidth:this.containerRef.current.offsetWidth-this.containerRef.current.clientWidth});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.tracking=false;this.cancelRaf();document.removeEventListener("mousemove",this.handleMouseMove);document.removeEventListener("mouseup",this.handleMouseUp);}},{key:"render",value:function render(){var _props=this.props,_props$bar=_props.bar,bar=_props$bar===undefined?defaultBar:_props$bar,className=_props.className;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{className:className,style:Object.assign({},this.props.style)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Inner,{disableOverflow:this.props.disableOverflow,style:this.props.theme.direction==="rtl"?{left:-this.state.nativeScrollbarWidth,marginRight:-this.state.nativeScrollbarWidth}:{right:-this.state.nativeScrollbarWidth,marginLeft:-this.state.nativeScrollbarWidth},ref:this.containerRef,onScroll:this.align},this.props.children),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Track,{style:{top:this.top,display:this.state.nativeScrollbarWidth>0?"flex":"none",height:this.height},ref:this.barRef,onMouseDown:this.handleMouseDown},bar));}}]);return Scrollable;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Scrollable,Object.assign({},props,{theme:theme}));});});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
var _templateObject=_taggedTemplateLiteral(["\n  margin-top: 15px;\n  align-self: center;\n  text-align: center;\n"],["\n  margin-top: 15px;\n  align-self: center;\n  text-align: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n  }\n"],["\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n      font-size: 16px;\n    "],["\n      font-size: 16px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n  background: transparent;\n  border: none;\n  border-radius: none;\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n    text-decoration: none;\n  }\n"],["\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n  background: transparent;\n  border: none;\n  border-radius: none;\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n    text-decoration: none;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LinkContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var LinkView=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */])(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.alternativeAccent;},function(_ref3){var theme=_ref3.theme;return theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var LinkButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref5){var theme=_ref5.theme;return theme.accent;},function(_ref6){var theme=_ref6.theme;return theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(_ref7){var theme=_ref7.theme;return theme.accent;});function Link(_ref8){var to=_ref8.to,onClick=_ref8.onClick,children=_ref8.children,props=_objectWithoutProperties(_ref8,["to","onClick","children"]);var LinkComponent=to!==undefined?LinkView:LinkButton;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkContainer,props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkComponent,{to:to,onClick:onClick,target:props.target||"_blank"},children));}/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TABS_LIMIT; });
/* unused harmony export receiveStockAssets */
/* unused harmony export initialState */
/* harmony export (immutable) */ __webpack_exports__["c"] = getViewedStock;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var TABS_LIMIT=4;function setActiveStock(state,payload){var stockID=payload.newStock;if(typeof stockID!=="string"){throw new TypeError("StockID must be specified");}var currentStock=state.tabs[state.activeTab];var isCryptoDismissed=currentStock==="CRYPTOINDEX"?true:state.isCryptoDismissed;var tabs=state.tabs.slice();tabs.splice(state.activeTab,1,stockID);return Object.assign({},state,{tabs:tabs,isCryptoDismissed:isCryptoDismissed});}function switchToStock(state,stock){var index=state.tabs.indexOf(stock);if(index===-1){return setActiveStock(state,{newStock:stock});}else{return Object.assign({},state,{activeTab:index});}}function removeTab(state,index){if(typeof index!=="number"){throw new TypeError("Tab index must be a number");}// Бездействуем, если остался всего один таб,
// или удаляемый индекс не попадает в набор.
if(state.tabs.length<=1||index<0||state.tabs.length<=index){return state;}var stock=state.tabs[index];var isCryptoDismissed=stock==="CRYPTOINDEX"?true:state.isCryptoDismissed;// Режем табы на две части: до и после
// удаляемого элелента.
var prefix=state.tabs.slice(0,index);var suffix=state.tabs.slice(index+1);if(index===state.activeTab){// Если удаляем активный таб, то нужно
// грамотно передать активность на соседний.
return{tabs:[].concat(_toConsumableArray(prefix),_toConsumableArray(suffix)),activeTab:suffix.length>0?prefix.length:prefix.length-1,isCryptoDismissed:isCryptoDismissed};}else{// Если удаляем таб, который стоит перед активным,
// то надо учесть смещение его индекса.
return{tabs:[].concat(_toConsumableArray(prefix),_toConsumableArray(suffix)),activeTab:state.activeTab<prefix.length?state.activeTab:state.activeTab-1,isCryptoDismissed:isCryptoDismissed};}}function receiveSocketMessage(state,payload){switch(payload.op){case"operationOpened":if(state.tabs.includes(payload.stock)){return state;}return Object.assign({},state,{tabs:[].concat(_toConsumableArray(state.tabs),[payload.stock])});default:return state;}}function receiveStockAssets(state,payload){var isCryptoAvailable=false;var defaultTab=null;var pickOfTheDayTab=null;// В списке доступных стоков можен не оказаться тех, которые
// пользователь выбирал ранее. Нам надо их отфильтровать. Для
// этого сначала мы соберём список доступных.
var currentTabs=state.tabs;var allowedTabs=new Set();var categories=Object.keys(payload);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=categories[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var category=_step.value;var assets=payload[category];var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=assets[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var asset=_step2.value;allowedTabs.add(asset.stock);if(asset.stock==="CRYPTOINDEX"&&asset.enabled){isCryptoAvailable=true;}if(defaultTab==null&&asset.default&&asset.enabled){defaultTab=asset.stock;}if(pickOfTheDayTab==null&&asset.pickOfTheDay&&asset.enabled){pickOfTheDayTab=asset.stock;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}// Актив дня преобладает над активом по-умолчанию в праве занять первый таб у
// нового клиента.
}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}defaultTab=pickOfTheDayTab||defaultTab;var nextTabs=currentTabs.filter(function(tab){return allowedTabs.has(tab);});if(defaultTab==null){defaultTab=[].concat(_toConsumableArray(allowedTabs))[0]||"EURUSD";}if(nextTabs.length===0){nextTabs=[defaultTab];}return Object.assign({},state,{isCryptoAvailable:isCryptoAvailable,tabs:nextTabs,activeTab:Math.min(state.activeTab,nextTabs.length-1)});}function receivePreservedTabs(state,preservedState){// Мы (зря) полагаемся на то, что localStorage синхронный,
// и сохранённые табы обязательно появятся раньше любых апи
// ответов. В будущем механика может поменяться.
// Если ты читаешь это когда она поменялась (например, табы
// теперь сохраняются на сервере), то в receiveStockAssets
// тебе придётся сохранять список доступных пар, чтобы позже
// пересечь его со списком табов пользователя.
// Я не сделал этого заранее потому, что в текущей ситуации
// весь список стоков сохранится в LS, а я этого не хочу.
return preservedState;}var initialState={isCryptoAvailable:false,isCryptoDismissed:false,tabs:[],activeTab:0};function tabs(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);case"RECEIVE_TABS":return receivePreservedTabs(state,action.payload);case"SET_ACTIVE_STOCK":return setActiveStock(state,action.payload);case"SET_ACTIVE_TAB":return Object.assign({},state,{activeTab:action.payload});case"PUSH_TAB":if(typeof action.payload!=="string"){throw new TypeError("StockID must be specified");}return{activeTab:state.tabs.length,tabs:[].concat(_toConsumableArray(state.tabs),[action.payload])};case"REMOVE_TAB":return removeTab(state,action.payload);case"RECEIVE_STOCK_ASSETS":return receiveStockAssets(state,action.payload);case"SWITCH_TO_STOCK":return switchToStock(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["b"] = (tabs);function getViewedStock(state){return state.tabs[state.activeTab];}

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__color__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lab__ = __webpack_require__(1897);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__lab__["b"]; });
/* unused harmony reexport lch */
/* unused harmony reexport gray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cubehelix__ = __webpack_require__(1898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__cubehelix__["a"]; });





/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return durationSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return durationMinute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return durationHour; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return durationDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return durationWeek; });
var durationSecond = 1e3;
var durationMinute = 6e4;
var durationHour = 36e5;
var durationDay = 864e5;
var durationWeek = 6048e5;


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  display: inline-block;\n  width: 100%;\n  padding: 11.5px 14px;\n  box-sizing: border-box;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    color: #fff;\n    outline: none;\n  }\n\n  background-color: #706281;\n  background: linear-gradient(to bottom, #877c95 0%, #706281 100%);\n  :hover {\n    background-color: #877c95;\n    background: linear-gradient(to bottom, #706281 0%, #877c95 100%);\n  }\n\n  ",";\n\n  ","\n\n    ","\n\n  ","\n\n  ","\n\n  ",";\n\n  ","\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ","\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ","\n"],["\n  direction: ",";\n  display: inline-block;\n  width: 100%;\n  padding: 11.5px 14px;\n  box-sizing: border-box;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    color: #fff;\n    outline: none;\n  }\n\n  background-color: #706281;\n  background: linear-gradient(to bottom, #877c95 0%, #706281 100%);\n  :hover {\n    background-color: #877c95;\n    background: linear-gradient(to bottom, #706281 0%, #877c95 100%);\n  }\n\n  ",";\n\n  ","\n\n    ","\n\n  ","\n\n  ","\n\n  ",";\n\n  ","\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ","\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n      min-width: 0;\n      width: auto;\n      padding: 12px 25px;\n      font-size: ",";\n      font-weight: bold;\n      text-transform: uppercase;\n      background: none;\n      border: 2px solid #ffffff !important;\n      border-radius: 32px;\n      box-shadow: none;\n      text-shadow: none !important;\n      &:hover {\n        color: #3b9478;\n        background: #fff;\n      }\n    "],["\n      min-width: 0;\n      width: auto;\n      padding: 12px 25px;\n      font-size: ",";\n      font-weight: bold;\n      text-transform: uppercase;\n      background: none;\n      border: 2px solid #ffffff !important;\n      border-radius: 32px;\n      box-shadow: none;\n      text-shadow: none !important;\n      &:hover {\n        color: #3b9478;\n        background: #fff;\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      width: auto;\n      padding-left: 25px;\n      padding-right: 25px;\n    "],["\n      width: auto;\n      padding-left: 25px;\n      padding-right: 25px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n        min-width: 0px;\n        width: auto;\n        height: 68px;\n        min-height: 68px;\n        line-height: 44px;\n        font-weight: 400;\n        font-size: 27px;\n\n        @media (max-width: 959px) {\n          margin-top: 20px;\n        }\n        @media screen and (max-width: 540px) {\n          line-height: 1;\n          margin-top: 26px;\n          font-size: 19px;\n          padding-top: 16px;\n          padding-bottom: 16px;\n          height: 40px;\n          min-height: 40px;\n        }\n        @media screen and (max-width: 480px) {\n          margin-top: 13px;\n          font-size: ",";\n          padding-top: 12px;\n          padding-bottom: 12px;\n        }\n        @media (min-width: 1000px) {\n          margin-top: 26px;\n        }\n      "],["\n        min-width: 0px;\n        width: auto;\n        height: 68px;\n        min-height: 68px;\n        line-height: 44px;\n        font-weight: 400;\n        font-size: 27px;\n\n        @media (max-width: 959px) {\n          margin-top: 20px;\n        }\n        @media screen and (max-width: 540px) {\n          line-height: 1;\n          margin-top: 26px;\n          font-size: 19px;\n          padding-top: 16px;\n          padding-bottom: 16px;\n          height: 40px;\n          min-height: 40px;\n        }\n        @media screen and (max-width: 480px) {\n          margin-top: 13px;\n          font-size: ",";\n          padding-top: 12px;\n          padding-bottom: 12px;\n        }\n        @media (min-width: 1000px) {\n          margin-top: 26px;\n        }\n      "]),_templateObject5=_taggedTemplateLiteral(["\n      padding-left: 65px;\n      padding-right: 65px;\n    "],["\n      padding-left: 65px;\n      padding-right: 65px;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      @media (max-width: 959px) {\n        padding-top: 11px;\n        padding-bottom: 11px;\n      }\n      @media (max-width: 480px) {\n        padding-top: 8px;\n        padding-bottom: 8px;\n      }\n    "],["\n      @media (max-width: 959px) {\n        padding-top: 11px;\n        padding-bottom: 11px;\n      }\n      @media (max-width: 480px) {\n        padding-top: 8px;\n        padding-bottom: 8px;\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      background-color: #df5441;\n      background: linear-gradient(to bottom, #f0654c 0%, #df5441 100%);\n      :hover {\n        background-color: #f0654c;\n        background: linear-gradient(to bottom, #df5441 0%, #f0654c 100%);\n      }\n    "],["\n      background-color: #df5441;\n      background: linear-gradient(to bottom, #f0654c 0%, #df5441 100%);\n      :hover {\n        background-color: #f0654c;\n        background: linear-gradient(to bottom, #df5441 0%, #f0654c 100%);\n      }\n    "]),_templateObject8=_taggedTemplateLiteral(["\n      background-color: #61ad12;\n      background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);\n      :hover {\n        background-color: #68c604;\n        background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);\n      }\n\n      ",";\n    "],["\n      background-color: #61ad12;\n      background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);\n      :hover {\n        background-color: #68c604;\n        background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);\n      }\n\n      ",";\n    "]),_templateObject9=_taggedTemplateLiteral(["\n          position: relative;\n          padding: 9px 40px;\n          font-weight: bold;\n          color: #ffffff;\n          text-decoration: none;\n          background: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n          border: none !important;\n          border-radius: 32px;\n          cursor: pointer;\n          z-index: 2;\n\n          ::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            right: 0;\n            display: block;\n            background: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n            border-radius: inherit;\n            z-index: -1;\n            opacity: 0;\n          }\n\n          :hover {\n            color: #ffffff;\n            background: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n            ::before {\n              opacity: 1;\n            }\n          }\n        "],["\n          position: relative;\n          padding: 9px 40px;\n          font-weight: bold;\n          color: #ffffff;\n          text-decoration: none;\n          background: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n          border: none !important;\n          border-radius: 32px;\n          cursor: pointer;\n          z-index: 2;\n\n          ::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            right: 0;\n            display: block;\n            background: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n            border-radius: inherit;\n            z-index: -1;\n            opacity: 0;\n          }\n\n          :hover {\n            color: #ffffff;\n            background: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n            ::before {\n              opacity: 1;\n            }\n          }\n        "]),_templateObject10=_taggedTemplateLiteral(["\n      background-color: ",";\n      background: linear-gradient(\n        to bottom,\n        "," 0%,\n        "," 100%\n      );\n      :hover {\n        background-color: #fd9500;\n        background: linear-gradient(\n          to bottom,\n          "," 0%,\n          "," 100%\n        );\n      }\n\n      ",";\n    "],["\n      background-color: ",";\n      background: linear-gradient(\n        to bottom,\n        "," 0%,\n        "," 100%\n      );\n      :hover {\n        background-color: #fd9500;\n        background: linear-gradient(\n          to bottom,\n          "," 0%,\n          "," 100%\n        );\n      }\n\n      ",";\n    "]),_templateObject11=_taggedTemplateLiteral(["\n          padding: 12px 25px;\n          font-size: ",";\n          font-weight: bold;\n          text-transform: uppercase;\n          background: none;\n          border: 2px solid #ffffff !important;\n          border-radius: 32px;\n          box-shadow: none;\n          text-shadow: none !important;\n          :hover {\n            color: #3b9478;\n            background: #fff;\n          }\n\n          ",";\n        "],["\n          padding: 12px 25px;\n          font-size: ",";\n          font-weight: bold;\n          text-transform: uppercase;\n          background: none;\n          border: 2px solid #ffffff !important;\n          border-radius: 32px;\n          box-shadow: none;\n          text-shadow: none !important;\n          :hover {\n            color: #3b9478;\n            background: #fff;\n          }\n\n          ",";\n        "]),_templateObject12=_taggedTemplateLiteral(["\n              color: #3b9478;\n              border: 2px solid #3b9478 !important;\n              &:hover {\n                color: #ffffff;\n                background: #3b9478;\n              }\n            "],["\n              color: #3b9478;\n              border: 2px solid #3b9478 !important;\n              &:hover {\n                color: #ffffff;\n                background: #3b9478;\n              }\n            "]),_templateObject13=_taggedTemplateLiteral(["\n      @media (max-width: 479px) {\n        font-size: ",";\n      }\n    "],["\n      @media (max-width: 479px) {\n        font-size: ",";\n      }\n    "]),_templateObject14=_taggedTemplateLiteral(["\n      font-weight: 500;\n      text-shadow: -1px -1px rgba(0, 0, 0, 0.2);\n      border: none;\n      border-bottom: 2px solid;\n      border-bottom-color: rgba(0, 0, 0, 0.3);\n    "],["\n      font-weight: 500;\n      text-shadow: -1px -1px rgba(0, 0, 0, 0.2);\n      border: none;\n      border-bottom: 2px solid;\n      border-bottom-color: rgba(0, 0, 0, 0.3);\n    "]),_templateObject15=_taggedTemplateLiteral(["\n      background-color: #a4a7b4 !important;\n      background: linear-gradient(\n        to bottom,\n        #bdc0cf 0%,\n        #a4a7b4 100%\n      ) !important;\n      pointer-events: none !important;\n      user-select: none !important;\n      cursor: default !important;\n    "],["\n      background-color: #a4a7b4 !important;\n      background: linear-gradient(\n        to bottom,\n        #bdc0cf 0%,\n        #a4a7b4 100%\n      ) !important;\n      pointer-events: none !important;\n      user-select: none !important;\n      cursor: default !important;\n    "]),_templateObject16=_taggedTemplateLiteral(["\n      width: auto;\n    "],["\n      width: auto;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n      font-size: 16px;\n      font-weight: bold;\n      color: #fff;\n      background: #3b9478;\n      border-radius: 8px;\n\n      :hover {\n        color: #fff;\n        background: #2e735d;\n      }\n    "],["\n      font-size: 16px;\n      font-weight: bold;\n      color: #fff;\n      background: #3b9478;\n      border-radius: 8px;\n\n      :hover {\n        color: #fff;\n        background: #2e735d;\n      }\n    "]),_templateObject18=_taggedTemplateLiteral(["\n      background: #bebebe !important;\n    "],["\n      background: #bebebe !important;\n    "]),_templateObject19=_taggedTemplateLiteral(["\n      background: #0085eb !important;\n      min-height: 40px !important;\n      line-height: 20px !important;\n\n      :before {\n        display: none;\n      }\n\n      :after {\n        display: none;\n      }\n    "],["\n      background: #0085eb !important;\n      min-height: 40px !important;\n      line-height: 20px !important;\n\n      :before {\n        display: none;\n      }\n\n      :after {\n        display: none;\n      }\n    "]),_templateObject20=_taggedTemplateLiteral(["\n      min-width: ",";\n    "],["\n      min-width: ",";\n    "]),_templateObject21=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n\n  ",";\n"]),_templateObject22=_taggedTemplateLiteral(["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "],["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var isIronButton="irontrade"==="irontrade"||"irontrade"==="eztrader";var ButtonView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(16),function(_ref){var newStyle=_ref.newStyle;return isIronButton&&newStyle&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(props){return props.big&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(15));},function(props){return props.wide&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.confirm&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);},function(props){return props.color==="red"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);},function(_ref2){var color=_ref2.color;return color==="green"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8,function(_ref3){var newStyle=_ref3.newStyle;return isIronButton&&newStyle&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});},function(_ref4){var color=_ref4.color,theme=_ref4.theme,themeLightGreen=_ref4.themeLightGreen;return color==="yellow"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10,function(props){return props.theme.accent;},function(props){return props.theme.tradeHeaderGradientTop;},function(props){return props.theme.tradeHeaderGradientBottom;},function(props){return props.theme.tradeHeaderGradientBottom;},function(props){return props.theme.tradeHeaderGradientTop;},function(_ref5){var newStyle=_ref5.newStyle;return isIronButton&&newStyle&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),themeLightGreen&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12));});},function(props){return props.smallFont&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14));},function(props){return props.withShadow&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject15);},function(props){return props.fixshit&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject16);},function(_ref6){var color=_ref6.color;return color==="mint"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);},function(_ref7){var color=_ref7.color,disabled=_ref7.disabled;return color==="mint"&&disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject18);},function(_ref8){var invited=_ref8.invited;return invited&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject19);},function(_ref9){var minWidth=_ref9.minWidth;return minWidth&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject20,minWidth);});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject21,function(_ref10){var theme=_ref10.theme;return theme.locale!=="ar"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject22);});var Button=function(_Component){_inherits(Button,_Component);function Button(){var _ref11;var _temp,_this,_ret;_classCallCheck(this,Button);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref11=Button.__proto__||Object.getPrototypeOf(Button)).call.apply(_ref11,[this].concat(args))),_this),_this.onClick=function(e){e.preventDefault();if(!_this.props.disabled&&_this.props.onClick!==undefined){_this.props.onClick(e);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Button,[{key:"render",value:function render(){var _props=this.props,title=_props.title,wide=_props.wide,big=_props.big,mobile=_props.mobile,_props$color=_props.color,color=_props$color===undefined?"violet":_props$color,confirm=_props.confirm,showSpinner=_props.showSpinner,smallFont=_props.smallFont,withShadow=_props.withShadow,newStyle=_props.newStyle,minWidth=_props.minWidth,className=_props.className,other=_objectWithoutProperties(_props,["title","wide","big","mobile","color","confirm","showSpinner","smallFont","withShadow","newStyle","minWidth","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonView,Object.assign({title:title,wide:wide,big:big,mobile:mobile,confirm:confirm,color:color,onClick:this.onClick,smallFont:smallFont,withShadow:withShadow,newStyle:newStyle,minWidth:minWidth,className:className},other),showSpinner===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Spinners_SimpleSpinner__["c" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,this.props.children||title));}}]);return Button;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["j"] = getSectionKey;
/* harmony export (immutable) */ __webpack_exports__["i"] = getSectionBoundaries;
/* harmony export (immutable) */ __webpack_exports__["m"] = isShortHistoryStock;
/* harmony export (immutable) */ __webpack_exports__["g"] = getHistoryLength;
/* unused harmony export whatTimeIsIt */
/* unused harmony export intervals */
/* harmony export (immutable) */ __webpack_exports__["n"] = parseTime;
/* harmony export (immutable) */ __webpack_exports__["o"] = stringifyTime;
/* harmony export (immutable) */ __webpack_exports__["l"] = getTimeSpanRange;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCommonSectionProps; });
/* harmony export (immutable) */ __webpack_exports__["e"] = generateSections;
/* unused harmony export getSections */
/* harmony export (immutable) */ __webpack_exports__["k"] = getSectionType;
/* unused harmony export groupRealtimePoints */
/* unused harmony export getSectionPoints */
/* harmony export (immutable) */ __webpack_exports__["h"] = getPoints;
/* harmony export (immutable) */ __webpack_exports__["d"] = generateRenderablePoints;
/* harmony export (immutable) */ __webpack_exports__["b"] = generateCandles;
/* harmony export (immutable) */ __webpack_exports__["c"] = generateHeikenAshiCandles;
/* harmony export (immutable) */ __webpack_exports__["a"] = generateBars;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_binary_search__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_binary_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_binary_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_memoize__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_memoize__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Каждый сегмент получает уникальный ключ
// на основе масштаба и позиции относительно
// нулевой даты. Так мы можем агрессивно ке-
// шировать точки.
function getSectionKey(_ref){var stock=_ref.stock,interval=_ref.interval,length=_ref.length,offset=_ref.offset;return stock+"-"+interval+"-"+length+"-"+offset;}function getSectionBoundaries(section){return[section.length*section.offset,section.length*(section.offset+1)];}var NORMAL_HISTORY_LENGTH=1000*60*60*24*365/2;var SHORT_HISTORY_LENGTH=1000*60*60*3;function isShortHistoryStock(stock){return stock.longHistory===false;}function getHistoryLength(stock){return isShortHistoryStock(stock)?SHORT_HISTORY_LENGTH:NORMAL_HISTORY_LENGTH;}function whatTimeIsIt(props){return props.realtimeCache[props.realtimeCache.length-1].date;}var intervals=[1000,// Секунда
1000*5,1000*10,1000*15,1000*30,1000*60,// Минута
1000*60*2,1000*60*5,1000*60*10,1000*60*15,1000*60*30,1000*60*60,// Час
1000*60*60*2,1000*60*60*4,1000*60*60*8,1000*60*60*12,1000*60*60*24,// День
1000*60*60*24*7,// Неделя
1000*60*60*24*30// Месяц
];var multipliers={s:1000,m:1000*60,h:1000*60*60,D:1000*60*60*24,W:1000*60*60*24*7,M:1000*60*60*24*30,Y:1000*60*60*24*365};function parseTime(timeAsString){var quantity=parseInt(timeAsString,10);var multiplier=multipliers[timeAsString.slice(-1)];return quantity*multiplier;}function stringifyTime(timeAsNumber){var keys=Object.keys(multipliers);for(var i=0;i<keys.length-1;i++){if(timeAsNumber>=multipliers[keys[i]]&&timeAsNumber<multipliers[keys[i+1]]){return Math.floor(timeAsNumber/multipliers[keys[i]])+keys[i];}}return Math.floor(timeAsNumber/multipliers["Y"])+"Y";}function getTimeSpanRange(stock,interval){// Ограничиваем таймфреймы так,
// чтобы на экране никогда не оказалось
// меньше 10 свечей и больше 50.
return[interval*8,Math.min(interval*100,getHistoryLength(stock))];}var getCommonSectionProps=__WEBPACK_IMPORTED_MODULE_3_lodash_memoize___default()(function(props){var actualInterval=void 0;if(props.type==="line"){// Для начала, сколько точек вмещает экран?
var pointsPerScreen=props.width*props.density;// Если бы интервал изменялся плавно, мы бы
// просто вычислили его так:
var idealInterval=props.timeSpan/pointsPerScreen;// Однако наши интервалы изменяются степенями
// двойки, чтобы не делать много разнообразных
// запросов к серверу.
actualInterval=intervals[0];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=intervals[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var candidate=_step.value;if(actualInterval>=idealInterval){break;}actualInterval=candidate;}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}else{actualInterval=props.interval*1000;}// От этого и точек на экране не всегда столько,
// сколько хотелось бы. Но это ничего!
// const actualPPS = Math.ceil(props.timeSpan / actualInterval);
// Зная, сколько мы хотим точек, можно поровну
// разбить их по секциям. Округляем в большую
// сторону, чтобы не обрывать график перед кра-
// ем экрана.
var actualTimeSpan=props.scaleX.invert(props.width)-props.scaleX.invert(0);var sectionLength=actualInterval*props.sectionSize;var sections=Math.ceil(actualTimeSpan/sectionLength);return{interval:actualInterval,length:sectionLength,quantity:sections};});function generateSections(common,props){// Время в левой части экрана.
var earliestVisibleTime=props.scaleX.invert(0);// Индекс крайней левой секции относительно нулевого времени!
var section0Offset=Math.floor(earliestVisibleTime/common.length)-1;var sections=[];for(var index=0;index<=common.quantity+1;index++){var section={interval:common.interval,length:common.length,stock:props.stock,offset:section0Offset+index};var type=getSectionType(section,props);switch(type){case"past":sections.push(section);break;case"present":sections.push(section);break;case"future":case"weekend":default:break;}}return sections;}function getSections(props){var common=getCommonSectionProps(props);return generateSections(common,props);}function getSectionType(section,props){var now=whatTimeIsIt(props);var _getSectionBoundaries=getSectionBoundaries(section),_getSectionBoundaries2=_slicedToArray(_getSectionBoundaries,2),start=_getSectionBoundaries2[0],end=_getSectionBoundaries2[1];if(now>start&&now<end){return"present";}else if(now>=end){if(props.checkpoints.length===0){return"past";}var bisectedIndex=__WEBPACK_IMPORTED_MODULE_0_binary_search___default()(props.checkpoints,start,function(checkpoint,value){return checkpoint.value-value;});switch(true){case bisectedIndex===-1:// Начало секции раньше любого выходного
return"past";case bisectedIndex>-1:{// Начало секции попадает на начало или конец выходного
var checkpoint=props.checkpoints[bisectedIndex];if(checkpoint.type==="negative"&&end<=checkpoint.source[1]){return"weekend";}else{return"past";}}default:{// Начало секции где-то между чекпоинтами
var _checkpoint=props.checkpoints[-bisectedIndex-2];if(_checkpoint.type==="negative"&&end<=_checkpoint.source[1]){return"weekend";}else{return"past";}}}}else{return"future";}}function groupRealtimePoints(section,points){if(points.length===0){return[];}var result=[];var nextMilestone=Math.ceil(points[0].date/section.interval)*section.interval;var currentBatch={epoch:nextMilestone/1000,open:points[0].value,close:points[0].value,min:points[0].value,max:points[0].value};result.push(currentBatch);var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=points[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var point=_step2.value;if(point.date>nextMilestone){nextMilestone=Math.ceil(point.date/section.interval)*section.interval;currentBatch={epoch:nextMilestone/1000,open:point.value,close:point.value,min:point.value,max:point.value};result.push(currentBatch);}currentBatch.close=point.value;currentBatch.min=Math.min(point.value,currentBatch.min);currentBatch.max=Math.max(point.value,currentBatch.max);}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return result;}function getPresentSectionPoints(section,cache,props){var key=getSectionKey(section);var history=cache[key]==="void"||cache[key]==="darkness"||cache[key]==null?[]:cache[key];if(history.length>0){// Junction это точка, соединяющая реальное время с историей.
var junctionHistoryIndex=history.length-1;var junctionDate=history[junctionHistoryIndex].epoch*1000;// Для поиска нужной точки в кеше мы используем бинарный поиск.
var potentialJunctionRealtimeIndex=__WEBPACK_IMPORTED_MODULE_0_binary_search___default()(props.realtimeCache,junctionDate,function(item,date){return item.date-date;});// Если бинарный поиск не нашёл точный результат, он возвращает
// индекс, где этот результат должен был лежать, только в виде от-
// рицательного заначения.
// Нам неточный результат тоже сгодится.
var junctionRealtimeIndex=potentialJunctionRealtimeIndex>0?potentialJunctionRealtimeIndex:-potentialJunctionRealtimeIndex;return[].concat(_toConsumableArray(history),_toConsumableArray(groupRealtimePoints(section,props.realtimeCache.slice(junctionRealtimeIndex))));}else{var _getSectionBoundaries3=getSectionBoundaries(section),_getSectionBoundaries4=_slicedToArray(_getSectionBoundaries3,1),_junctionDate=_getSectionBoundaries4[0];// TODO: спрятать дублирование
var _potentialJunctionRealtimeIndex=__WEBPACK_IMPORTED_MODULE_0_binary_search___default()(props.realtimeCache,_junctionDate,function(item,date){return item.date-date;});var _junctionRealtimeIndex=_potentialJunctionRealtimeIndex>0?_potentialJunctionRealtimeIndex:-_potentialJunctionRealtimeIndex;return groupRealtimePoints(section,props.realtimeCache.slice(_junctionRealtimeIndex));}}function getPointsFromCache(section,cache){var key=getSectionKey(section);return cache[key]||[];}var getSectionPointsWithRealtimePriority=function getSectionPointsWithRealtimePriority(section,cache,realtimeCache){var _getSectionBoundaries5=getSectionBoundaries(section),_getSectionBoundaries6=_slicedToArray(_getSectionBoundaries5,2),start=_getSectionBoundaries6[0],end=_getSectionBoundaries6[1];var historical=getPointsFromCache(section,cache);if(realtimeCache.length===0){// Кеша нет и мы идём по простому пути
return historical;}else{var firstAvailableRealtimePoint=realtimeCache[0];if(firstAvailableRealtimePoint.date>end){// Зелёная историческая секция
return historical;}else if(firstAvailableRealtimePoint.date<=start){// Секцию можно построить целиком из риалтайма (красная)
return groupRealtimePoints(section,realtimeCache.filter(function(point){return point.date>=start&&point.date<=end;}));}else{// Секцию придётся клеить из двух источников (жёлтая)
return getPresentSectionPoints(section,cache,{realtimeCache:realtimeCache});}}// That's all folks
};window.prioritizeRealtime=true;function getSectionPoints(section,cache,props){var type=getSectionType(section,props);switch(type){case"past":return window.prioritizeRealtime?getSectionPointsWithRealtimePriority(section,cache,props.realtimeCache):getPointsFromCache(section,cache);case"future":return[];case"present":return window.prioritizeRealtime?getSectionPointsWithRealtimePriority(section,cache,props.realtimeCache):getPresentSectionPoints(section,cache,props);default:return[];}}function expensive_getOperationPoints(operations){var points=[];var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=operations[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var operation=_step3.value;points.push({epoch:operation.open_timestamp,open:operation.value,close:operation.value,min:operation.value,max:operation.value});if(operation.close_value!=null&&operation.close_timestamp!=null){points.push({epoch:operation.close_timestamp,open:operation.close_value,close:operation.close_value,min:operation.close_value,max:operation.close_value});}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return points.sort(function(pointA,pointB){return pointA.epoch-pointB.epoch;});}var getOperationPoints=Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["default"])(expensive_getOperationPoints);function sortedMerge(a,b){if(a.length===0){return b;}else if(b.length===0){return a;}var result=[];var indexInA=0;var indexInB=0;while(indexInA<a.length){var milestone=a[indexInA];var skipMilestone=false;while(indexInB<b.length){var candidate=b[indexInB];if(candidate["epoch"]<milestone["epoch"]){result.push(candidate);indexInB++;}else if(candidate["epoch"]===milestone["epoch"]){result.push(candidate);indexInB++;skipMilestone=true;break;}else{break;}}if(!skipMilestone){result.push(milestone);}indexInA++;}while(indexInB<b.length){result.push(b[indexInB]);indexInB++;}return result;}function getPoints(sections,cache,props,deals){// TODO: есть потенциал оптимизировать память и итерации
var result=[];var emptySections=[];var isDarkArea=false;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=sections[Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var section=_step4.value;var _points=getSectionPoints(section,cache,props);if(_points==="void"){emptySections.push(section);}else if(_points==="darkness"){isDarkArea=true;}else{var _iteratorNormalCompletion5=true;var _didIteratorError5=false;var _iteratorError5=undefined;try{for(var _iterator5=_points[Symbol.iterator](),_step5;!(_iteratorNormalCompletion5=(_step5=_iterator5.next()).done);_iteratorNormalCompletion5=true){var point=_step5.value;var length=result.length;if(length===0||point.epoch>result[length-1].epoch){result.push(point);}}}catch(err){_didIteratorError5=true;_iteratorError5=err;}finally{try{if(!_iteratorNormalCompletion5&&_iterator5.return){_iterator5.return();}}finally{if(_didIteratorError5){throw _iteratorError5;}}}}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}if(props.type==="line"){var operationPoints=getOperationPoints(deals);return{points:sortedMerge(result,operationPoints),rawPoints:result,emptySections:emptySections,isDarkArea:isDarkArea};}else{return{points:result,emptySections:emptySections,isDarkArea:isDarkArea};}}function generateRenderablePoints(points,scaleX,scaleY,stock,interval,present,deals){var result=[];// let dealIndexToStartWith = deals.length;
for(var i=0;i<points.length;i++){var p=points[i];var date=p.epoch*1000;var open=p.open;var low=p.min;var high=p.max;var value=p.close;// Это условие одновременно не позволяет сгруппированным точкам залезать
// в будущее, а также анимирует нам последнюю точку, ведь значения в present
// интерполируются перед попаданием сюда.
if(date>=present.date){date=present.date;value=present.value;}result.push([scaleX(date),scaleY(value),{stock:stock,date:date,open:open,low:low,high:high,value:value}]);// for (let j = dealIndexToStartWith - 1; j >= 0; j--) {
//   const deal = deals[j];
//   const dealDate = Number(deal.open_timestamp) * 1000;
//
//   if (
//     dealDate > date &&
//     points[i + 1] != null &&
//     dealDate < points[i + 1].epoch * 1000
//   ) {
//     result.push([
//       scaleX(dealDate),
//       scaleY(deal.value),
//       {
//         stock,
//         date: dealDate,
//         value: deal.value
//       }
//     ]);
//
//     dealIndexToStartWith = j;
//   }
// }
}return result;}function generateCandles(points,scaleX,scaleY,stock,interval){return points.map(function(point,index,points){var previous=index===0?{epoch:point.epoch-interval/1000,open:point.open,min:point.open,max:point.open,close:point.open}:points[index-1];return{range:[scaleX(previous.epoch*1000),scaleX(point.epoch*1000)],open:[scaleX(previous.epoch),scaleY(previous.close),{stock:stock,date:previous.epoch,value:previous.close}],close:[scaleX(point.epoch*1000),scaleY(point.close),{stock:stock,date:point.epoch*1000,value:point.close}],minimum:[scaleX(point.epoch*1000),scaleY(Math.min(point.min,previous.close)),{stock:stock,date:point.epoch*1000,value:point.min}],maximum:[scaleX(point.epoch*1000),scaleY(Math.max(point.max,previous.close)),{stock:stock,date:point.epoch*1000,value:point.max}]};});}function generateHeikenAshiCandles(points,scaleX,scaleY,stock,interval){var lastHA=void 0;return points.map(function(point,index,points){var previous=index===0?{epoch:point.epoch-interval/1000,open:point.open,min:point.min,max:point.max,close:point.close}:points[index-1];var maxValue=Math.max(previous.open,previous.close,previous.min,previous.max);var maxLength=maxValue.toString().length;var lengthFixer=function lengthFixer(value){if(value.toString().length>maxLength){return+value.toFixed(4);}return value;};var previousHA=previous;if(lastHA){previousHA={open:lastHA.open[2].value,close:lastHA.close[2].value};}var open=(previousHA.open+previousHA.close)/2;var close=(point.open+point.close+point.min+point.max)/4;var min=Math.min(point.min,open,close);var max=Math.max(point.max,open,close);lastHA={range:[scaleX(previous.epoch*1000),scaleX(point.epoch*1000)],open:[scaleX(previous.epoch),scaleY(open),{stock:stock,date:previous.epoch,value:lengthFixer(open)}],close:[scaleX(point.epoch*1000),scaleY(close),{stock:stock,date:point.epoch*1000,value:lengthFixer(close)}],minimum:[scaleX(point.epoch*1000),scaleY(min),{stock:stock,date:point.epoch*1000,value:lengthFixer(min)}],maximum:[scaleX(point.epoch*1000),scaleY(max),{stock:stock,date:point.epoch*1000,value:lengthFixer(max)}]};return lastHA;});}function generateBars(points,scaleX,scaleY,interval){return points.map(function(point,index,points){var _point=_slicedToArray(point,2),date=_point[0],value=_point[1];var previous=index===0?[date-interval/1000,value]:points[index-1];return{range:[scaleX(previous[0]),scaleX(date)],point:[scaleX(previous[0]),scaleY(previous[1]),{date:previous[0],value:previous[1]}]};});}

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Popup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MobileWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloseContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Footer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MoneyContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Currency; });
/* unused harmony export Kuchka */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Content; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Free; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icons_Kuchka__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.75);\n  user-select: none;\n  z-index: 20000;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n  @media (max-width: 567px) {\n    font-size: 7px;\n  }\n"],["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.75);\n  user-select: none;\n  z-index: 20000;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n  @media (max-width: 567px) {\n    font-size: 7px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  min-height: auto;\n  width: 480px;\n  padding: 35px 65px;\n  font-size: ",";\n  line-height: 18px;\n  color: #96949b;\n  text-align: center;\n  background-color: ",";\n\n  @media (min-width: 960px) {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    min-height: 328px;\n  }\n"],["\n  direction: ",";\n  position: relative;\n  min-height: auto;\n  width: 480px;\n  padding: 35px 65px;\n  font-size: ",";\n  line-height: 18px;\n  color: #96949b;\n  text-align: center;\n  background-color: ",";\n\n  @media (min-width: 960px) {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: wrap;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n    min-height: 328px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: ",";\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n  height: ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: ",";\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n  height: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0 auto 20px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 960px) {\n    max-width: 300px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-right: 32px;\n    padding-left: 32px;\n  }\n"],["\n  width: 100%;\n  margin: 0 auto 20px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 960px) {\n    max-width: 300px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-right: 32px;\n    padding-left: 32px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #96949b;\n  transition: color 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #96949b;\n  transition: color 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  padding-top: 9px;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n  }\n"],["\n  padding-top: 9px;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin: 0 auto;\n  margin-bottom: 26px;\n  font-size: 32px;\n  line-height: 38px;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    text-align: center;\n    font-size: 28px;\n  }\n  \n  @media (max-height: 360px) {\n    margin-bottom: 0;\n  }\n"],["\n  margin: 0 auto;\n  margin-bottom: 26px;\n  font-size: 32px;\n  line-height: 38px;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    text-align: center;\n    font-size: 28px;\n  }\n  \n  @media (max-height: 360px) {\n    margin-bottom: 0;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-weight: 700;\n  margin: 0 2px;\n  color: ",";\n"],["\n  font-weight: 700;\n  margin: 0 2px;\n  color: ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  margin-bottom: 20px;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    line-height: 1.5;\n    color: #96949b;\n    text-align: center;\n  }\n"],["\n  margin-bottom: 20px;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    line-height: 1.5;\n    color: #96949b;\n    text-align: center;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  font-weight: 700;\n  text-transform: uppercase;\n  color: ",";\n"],["\n  font-weight: 700;\n  text-transform: uppercase;\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// styled
var Flex=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject);var Overlay=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Flex)(_templateObject2);var Popup=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.direction;},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref3){var theme=_ref3.theme;return theme.mainHighlight;});var Wrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject4,function(_ref4){var nowrap=_ref4.nowrap;return nowrap?"nowrap":"wrap";},function(_ref5){var nowrap=_ref5.nowrap;return nowrap?"auto":"100%";});var MobileWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject5);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h3(_templateObject6,function(_ref6){var theme=_ref6.theme;return theme.foreground;});var CloseContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Flex)(_templateObject7,function(_ref7){var theme=_ref7.theme;return theme.foreground;});var Footer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject8);var MoneyContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject9);var Value=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Money__["b" /* default */].Value)(_templateObject10,function(_ref8){var theme=_ref8.theme;return theme.alternativeAccent;});var Currency=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Money__["b" /* default */].Symbol)(_templateObject10,function(_ref9){var theme=_ref9.theme;return theme.alternativeAccent;});var Kuchka=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Icons_Kuchka__["a" /* default */])(_templateObject10,function(_ref10){var theme=_ref10.theme;return theme.accent;});var Content=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].p(_templateObject11,function(_ref11){var theme=_ref11.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Free=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject12,function(_ref12){var theme=_ref12.theme;return theme.accent;});

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(125)('meta');
var isObject = __webpack_require__(21);
var has = __webpack_require__(66);
var setDesc = __webpack_require__(34).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(20)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 113 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(28)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(59)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = get_number_type;
/* unused harmony export is_of_type */
/* harmony export (immutable) */ __webpack_exports__["c"] = sort_out_arguments;
/* harmony export (immutable) */ __webpack_exports__["a"] = check_number_length_for_type;
/* unused harmony export merge_arrays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__metadata__ = __webpack_require__(78);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };







var non_fixed_line_types = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL'];

// Finds out national phone number type (fixed line, mobile, etc)
function get_number_type(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    input = _sort_out_arguments.input,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	// When `parse()` returned `{}`
	// meaning that the phone number is not a valid one.


	if (!input.country) {
		return;
	}

	if (!metadata.hasCountry(input.country)) {
		throw new Error('Unknown country: ' + input.country);
	}

	var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
	metadata.country(input.country);

	// The following is copy-pasted from the original function:
	// https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835

	// Is this national number even valid for this country
	if (!Object(__WEBPACK_IMPORTED_MODULE_1__common__["i" /* matches_entirely */])(nationalNumber, metadata.nationalNumberPattern())) {
		return;
	}

	// Is it fixed line number
	if (is_of_type(nationalNumber, 'FIXED_LINE', metadata)) {
		// Because duplicate regular expressions are removed
		// to reduce metadata size, if "mobile" pattern is ""
		// then it means it was removed due to being a duplicate of the fixed-line pattern.
		//
		if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
			return 'FIXED_LINE_OR_MOBILE';
		}

		// v1 metadata.
		// Legacy.
		// Deprecated.
		if (!metadata.type('MOBILE')) {
			return 'FIXED_LINE_OR_MOBILE';
		}

		// Check if the number happens to qualify as both fixed line and mobile.
		// (no such country in the minimal metadata set)
		/* istanbul ignore if */
		if (is_of_type(nationalNumber, 'MOBILE', metadata)) {
			return 'FIXED_LINE_OR_MOBILE';
		}

		return 'FIXED_LINE';
	}

	for (var _iterator = non_fixed_line_types, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var _type = _ref;

		if (is_of_type(nationalNumber, _type, metadata)) {
			return _type;
		}
	}
}

function is_of_type(nationalNumber, type, metadata) {
	type = metadata.type(type);

	if (!type || !type.pattern()) {
		return false;
	}

	// Check if any possible number lengths are present;
	// if so, we use them to avoid checking
	// the validation pattern if they don't match.
	// If they are absent, this means they match
	// the general description, which we have
	// already checked before a specific number type.
	if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
		return false;
	}

	return Object(__WEBPACK_IMPORTED_MODULE_1__common__["i" /* matches_entirely */])(nationalNumber, type.pattern());
}

// Sort out arguments
function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
	var input = void 0;
	var options = {};
	var metadata = void 0;

	// If the phone number is passed as a string.
	// `getNumberType('88005553535', ...)`.
	if (typeof arg_1 === 'string') {
		// If "default country" argument is being passed
		// then convert it to an `options` object.
		// `getNumberType('88005553535', 'RU', metadata)`.
		if ((typeof arg_2 === 'undefined' ? 'undefined' : _typeof(arg_2)) !== 'object') {
			if (arg_4) {
				options = arg_3;
				metadata = arg_4;
			} else {
				metadata = arg_3;
			}

			// `parse` extracts phone numbers from raw text,
			// therefore it will cut off all "garbage" characters,
			// while this `validate` function needs to verify
			// that the phone number contains no "garbage"
			// therefore the explicit `is_viable_phone_number` check.
			if (Object(__WEBPACK_IMPORTED_MODULE_0__parse__["d" /* is_viable_phone_number */])(arg_1)) {
				input = Object(__WEBPACK_IMPORTED_MODULE_0__parse__["a" /* default */])(arg_1, arg_2, metadata);
			} else {
				input = {};
			}
		}
		// No "resrict country" argument is being passed.
		// International phone number is passed.
		// `getNumberType('+78005553535', metadata)`.
		else {
				if (arg_3) {
					options = arg_2;
					metadata = arg_3;
				} else {
					metadata = arg_2;
				}

				// `parse` extracts phone numbers from raw text,
				// therefore it will cut off all "garbage" characters,
				// while this `validate` function needs to verify
				// that the phone number contains no "garbage"
				// therefore the explicit `is_viable_phone_number` check.
				if (Object(__WEBPACK_IMPORTED_MODULE_0__parse__["d" /* is_viable_phone_number */])(arg_1)) {
					input = Object(__WEBPACK_IMPORTED_MODULE_0__parse__["a" /* default */])(arg_1, metadata);
				} else {
					input = {};
				}
			}
	}
	// If the phone number is passed as a parsed phone number.
	// `getNumberType({ phone: '88005553535', country: 'RU' }, ...)`.
	else if (is_object(arg_1)) {
			input = arg_1;

			if (arg_3) {
				options = arg_2;
				metadata = arg_3;
			} else {
				metadata = arg_2;
			}
		} else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');

	return { input: input, options: options, metadata: new __WEBPACK_IMPORTED_MODULE_2__metadata__["a" /* default */](metadata) };
}

// Should only be called for the "new" metadata which has "possible lengths".
function check_number_length_for_type(nationalNumber, type, metadata) {
	var type_info = metadata.type(type);

	// There should always be "<possiblePengths/>" set for every type element.
	// This is declared in the XML schema.
	// For size efficiency, where a sub-description (e.g. fixed-line)
	// has the same "<possiblePengths/>" as the "general description", this is missing,
	// so we fall back to the "general description". Where no numbers of the type
	// exist at all, there is one possible length (-1) which is guaranteed
	// not to match the length of any real phone number.
	var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
	// let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()

	if (type === 'FIXED_LINE_OR_MOBILE') {
		// No such country in metadata.
		/* istanbul ignore next */
		if (!metadata.type('FIXED_LINE')) {
			// The rare case has been encountered where no fixedLine data is available
			// (true for some non-geographical entities), so we just check mobile.
			return check_number_length_for_type(nationalNumber, 'MOBILE', metadata);
		}

		var mobile_type = metadata.type('MOBILE');

		if (mobile_type) {
			// Merge the mobile data in if there was any. "Concat" creates a new
			// array, it doesn't edit possible_lengths in place, so we don't need a copy.
			// Note that when adding the possible lengths from mobile, we have
			// to again check they aren't empty since if they are this indicates
			// they are the same as the general desc and should be obtained from there.
			possible_lengths = merge_arrays(possible_lengths, mobile_type.possibleLengths());
			// The current list is sorted; we need to merge in the new list and
			// re-sort (duplicates are okay). Sorting isn't so expensive because
			// the lists are very small.

			// if (local_lengths)
			// {
			// 	local_lengths = merge_arrays(local_lengths, mobile_type.possibleLengthsLocal())
			// }
			// else
			// {
			// 	local_lengths = mobile_type.possibleLengthsLocal()
			// }
		}
	}
	// If the type doesn't exist then return 'INVALID_LENGTH'.
	else if (type && !type_info) {
			return 'INVALID_LENGTH';
		}

	var actual_length = nationalNumber.length;

	// In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
	// // This is safe because there is never an overlap beween the possible lengths
	// // and the local-only lengths; this is checked at build time.
	// if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
	// {
	// 	return 'IS_POSSIBLE_LOCAL_ONLY'
	// }

	var minimum_length = possible_lengths[0];

	if (minimum_length === actual_length) {
		return 'IS_POSSIBLE';
	}

	if (minimum_length > actual_length) {
		return 'TOO_SHORT';
	}

	if (possible_lengths[possible_lengths.length - 1] < actual_length) {
		return 'TOO_LONG';
	}

	// We skip the first element since we've already checked it.
	return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var is_object = function is_object(_) {
	return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
};

function merge_arrays(a, b) {
	var merged = a.slice();

	for (var _iterator2 = b, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
		var _ref2;

		if (_isArray2) {
			if (_i2 >= _iterator2.length) break;
			_ref2 = _iterator2[_i2++];
		} else {
			_i2 = _iterator2.next();
			if (_i2.done) break;
			_ref2 = _i2.value;
		}

		var element = _ref2;

		if (a.indexOf(element) < 0) {
			merged.push(element);
		}
	}

	return merged.sort(function (a, b) {
		return a - b;
	});

	// ES6 version, requires Set polyfill.
	// let merged = new Set(a)
	// for (const element of b)
	// {
	// 	merged.add(i)
	// }
	// return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=getNumberType.js.map

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(90);
var IE8_DOM_DEFINE = __webpack_require__(600);
var toPrimitive = __webpack_require__(388);
var dP = Object.defineProperty;

exports.f = __webpack_require__(118) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(161)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fade__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SlideUpDown__ = __webpack_require__(1468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fade__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__SlideUpDown__["a"]; });


/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Svg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InfoBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  padding: 12px;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    max-width: calc(100% - 140px);\n    max-height: 100%;\n    padding: 0 10px;\n    ",";\n    overflow: auto;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n  height: 100%;\n  padding: 12px;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    max-width: calc(100% - 140px);\n    max-height: 100%;\n    padding: 0 10px;\n    ",";\n    overflow: auto;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 9px 11px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  border-bottom: 1px solid ",";\n  font-weight: 500;\n\n  @media (min-width: 960px) {\n    height: 25px;\n    padding: 0 9px;\n  }\n  @media (max-width: 345px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 9px 11px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  border-bottom: 1px solid ",";\n  font-weight: 500;\n\n  @media (min-width: 960px) {\n    height: 25px;\n    padding: 0 9px;\n  }\n  @media (max-width: 345px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  padding: 8px 0 0;\n  width: 100%;\n\n  @media (min-width: 960px) {\n    overflow: hidden;\n  }\n\n  @media (max-width: 959px) {\n    overflow: auto;\n  }\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  padding: 8px 0 0;\n  width: 100%;\n\n  @media (min-width: 960px) {\n    overflow: hidden;\n  }\n\n  @media (max-width: 959px) {\n    overflow: auto;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  width: 100%;\n  min-height: 44px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  ",";\n  font-size: ",";\n  line-height: 16px;\n  color: ",";\n  white-space: normal;\n  ",";\n\n  @media (max-width: 959px) {\n    min-height: 56px;\n  }\n"],["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  width: 100%;\n  min-height: 44px;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  ",";\n  font-size: ",";\n  line-height: 16px;\n  color: ",";\n  white-space: normal;\n  ",";\n\n  @media (max-width: 959px) {\n    min-height: 56px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 4px;\n  ",";\n"],["\n  position: absolute;\n  top: 4px;\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n  display: inline-block;\n\n  a {\n    color: ",";\n    text-decoration: underline;\n\n    :hover {\n      text-decoration: none;\n    }\n  }\n"],["\n  direction: ",";\n  display: inline-block;\n\n  a {\n    color: ",";\n    text-decoration: underline;\n\n    :hover {\n      text-decoration: none;\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.mode==="light"?theme.popupDarkBackground:"transparent";},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-left","auto"));var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.theme.accent;},function(props){return props.theme.mainSeparator;});var InnerContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Info=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("padding-left","25px"),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(11),function(props){return props.isOverhead?"tomato":"#99959d";},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("text-align","left"));var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("left",0));var InfoIcon=function InfoIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"18",viewBox:"0 0 18 18",fill:"currentColor",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z",transform:"translate(-933.016 -299)"}));};var InfoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.direction;},function(_ref2){var theme=_ref2.theme;return theme.accent;});var InfoBlock=function InfoBlock(_ref3){var children=_ref3.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoIcon,null)," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,children));};function ToolsContent(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,props.activeTool&&props.activeTool.title,props.activeTool&&props.activeTool.key==="indicators"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Tools__["d" /* RemoveIndicators */],{indicators:props.settings.indicators,onRemoveAll:function onRemoveAll(){props.dispatch({type:"REMOVE_ALL_INDICATORS"});},key:"remove"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InnerContent,null,props.isMobile===true?props.children:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Scrollable__["a" /* default */],{style:{height:194}},props.children)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoBlock,null,props.activeTool&&props.activeTool.info));}/* harmony default export */ __webpack_exports__["d"] = (ToolsContent);

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ClockIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return InstrumentsIcon; });
/* unused harmony export BackToIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SettingsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return ThemesIcon; });
/* unused harmony export FullScreenIcon */
/* unused harmony export NotFullScreenIcon */
/* unused harmony export FontsIcon */
/* unused harmony export LanguageIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return SoundIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SoundIconMute; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ChartIconZone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ChartIconCandlestick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ChartIconBars; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HorizontalLineIcon; });
/* unused harmony export IntervalIcon1s */
/* unused harmony export IntervalIcon5s */
/* unused harmony export IntervalIcon10s */
/* unused harmony export IntervalIcon15s */
/* unused harmony export IntervalIcon30s */
/* unused harmony export IntervalIcon1m */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TradersMoodIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LineColorIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LineThicknessIcon1px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LineThicknessIcon2px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LineThicknessIcon3px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LineThicknessIcon4px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LineThicknessIcon5px; });
/* unused harmony export AddIndicatorsIconDots */
/* unused harmony export AddIndicatorsIconArrows */
/* unused harmony export AddIndicatorsIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return IndicatorsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RemoveIndicatorsIcon; });
/* unused harmony export BackIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DeleteIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HideIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return InstrumentIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TrashIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return VisibleIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HiddenIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LockIcon; });
/* unused harmony export LeftAngleBracket */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return Timer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IconsTournament__ = __webpack_require__(1746);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: ",";\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :hover {\n    color: ",";\n  }\n\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: ",";\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :hover {\n    color: ",";\n  }\n\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      width: 16px;\n      height: 15px;\n    "],["\n      width: 16px;\n      height: 15px;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  user-select: none;\n  color: inherit;\n\n  :hover,\n  :focus,\n  :active {\n    color: inherit;\n  }\n\n  ",";\n"],["\n  position: relative;\n  user-select: none;\n  color: inherit;\n\n  :hover,\n  :focus,\n  :active {\n    color: inherit;\n  }\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      color: ",";\n\n      :hover,\n      :focus,\n      :active {\n        color: ",";\n      }\n\n      @media (max-width: 959px) {\n        :focus,\n        :active {\n          color: ",";\n        }\n\n        ",";\n      }\n    "],["\n      color: ",";\n\n      :hover,\n      :focus,\n      :active {\n        color: ",";\n      }\n\n      @media (max-width: 959px) {\n        :focus,\n        :active {\n          color: ",";\n        }\n\n        ",";\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n            color: ",";\n          "],["\n            color: ",";\n          "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FakeButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#919191",0.59),function(_ref){var theme=_ref.theme;return theme.foreground;},function(_ref2){var theme=_ref2.theme;return theme.accent;},function(props){return props.isSubButton&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2);});var IconView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].svg(_templateObject3,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,function(_ref3){var theme=_ref3.theme,activeColor=_ref3.activeColor;return activeColor||theme.foreground;},function(_ref4){var theme=_ref4.theme,activeColor=_ref4.activeColor;return activeColor||theme.foreground;},function(_ref5){var theme=_ref5.theme,activeColor=_ref5.activeColor;return activeColor||theme.foreground;},function(props){return props.isTool&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5,function(_ref6){var theme=_ref6.theme;return theme.accent;});});});// helper functions to reduce code dublications
function Icon(_ref7){var children=_ref7.children,width=_ref7.width,height=_ref7.height,onClick=_ref7.onClick,isSubButton=_ref7.isSubButton,isChartButton=_ref7.isChartButton,styleButton=_ref7.styleButton,other=_objectWithoutProperties(_ref7,["children","width","height","onClick","isSubButton","isChartButton","styleButton"]);var basicIcon=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconView,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:width,height:height,viewBox:"0 0 "+width+" "+height,fillRule:"evenodd",fill:"currentColor"},other),children);return isChartButton?basicIcon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FakeButton,{onClick:onClick,isSubButton:isSubButton,style:styleButton},basicIcon);}// icons
var ClockIcon=function ClockIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:18,height:18},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__IconsTournament__["a" /* RawClock */],{width:18}));};var InstrumentsIcon=function InstrumentsIcon(_ref8){var _ref8$width=_ref8.width,width=_ref8$width===undefined?"24":_ref8$width,props=_objectWithoutProperties(_ref8,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:width,height:width,viewBox:"-2 -2 22 22"},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"currentColor",d:"M15.533,9.994l-.307-.727c1.05-2.373.98-2.443.776-2.649l-1.341-1.31L14.528,5.2h-.155a8.643,8.643,0,0,0-2.365.925l-.75-.3c-.97-2.4-1.069-2.4-1.353-2.4H8.012c-.284,0-.394,0-1.293,2.412l-.747.3a12.558,12.558,0,0,0-2.4-.876l-.179.006L1.947,6.674c-.219.206-.3.278.815,2.615l-.305.724C0,10.962,0,11.054,0,11.344V13.2c0,.291,0,.394,2.464,1.276l.305.723c-1.05,2.372-.979,2.443-.775,2.647l1.341,1.312.133.115h.156a8.708,8.708,0,0,0,2.364-.927l.749.3c.97,2.4,1.07,2.4,1.354,2.4H9.984c.289,0,.392,0,1.294-2.412l.751-.3a12.606,12.606,0,0,0,2.4.877l.18-.005,1.454-1.423c.207-.209.279-.281-.825-2.607l.3-.725C18,13.5,18,13.4,18,13.121V11.268C18,10.976,18,10.874,15.533,9.994ZM9,15.319a3.087,3.087,0,1,1,3.144-3.087A3.122,3.122,0,0,1,9,15.319Z",transform:"translate(0 -3.414)"}));};var BackToIcon=function BackToIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:22,height:21},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M412.515,1670a10.485,10.485,0,1,1-10.485,10.49A10.483,10.483,0,0,1,412.515,1670Zm-8.95,10.49a8.951,8.951,0,1,0,8.951-8.95A8.953,8.953,0,0,0,403.565,1680.49Zm4.276-.47,4.114-4.11a0.876,0.876,0,0,1,1.236,0l4.114,4.11a0.876,0.876,0,0,1-1.237,1.24l-2.639-2.64v5.88a0.875,0.875,0,0,1-1.749,0v-5.84l-2.6,2.6A0.876,0.876,0,0,1,407.841,1680.02Z",transform:"translate(-402.031 -1670)"}));};var SettingsIcon=function SettingsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:20},props),props.title&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title",null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M413.11,5156.01h-2.162c-0.607,0-.786-0.18-1.861-2.84l-0.535-.22c-2.263,1.02-2.54,1.02-2.709,1.02H405.5l-0.274-.24-1.528-1.5c-0.445-.44-0.445-0.68.721-3.32l-0.208-.5c-2.733-.98-2.919-1.16-2.919-1.78v-2.12c0-.62.167-0.78,2.908-1.85l0.208-.49c-1.183-2.5-1.242-2.83-.772-3.29l1.774-1.73,0.372-.01c0.158,0,.443,0,2.746.97l0.531-.22c1-2.67,1.178-2.85,1.8-2.85h2.162c0.613,0,.777.16,1.86,2.84l0.531,0.22c2.26-1.03,2.541-1.03,2.712-1.03h0.342l0.272,0.25,1.536,1.49c0.442,0.45.442,0.68-.724,3.33l0.21,0.5c2.751,0.98,2.918,1.15,2.918,1.78v2.12c0,0.62-.167.78-2.909,1.84l-0.208.5c1.224,2.58,1.227,2.83.779,3.28l-1.78,1.74-0.374.01c-0.156,0-.441,0-2.741-0.97l-0.533.22C413.909,5155.83,413.73,5156.01,413.11,5156.01Zm-1.68-1.7h1.185c0.213-.48.556-1.35,0.835-2.1l0.13-.35,1.879-.76,0.325,0.14c0.768,0.33,1.674.69,2.174,0.87l0.826-.8c-0.2-.49-0.578-1.33-0.921-2.04l-0.165-.35,0.787-1.86,0.335-.13c0.773-.3,1.671-0.67,2.157-0.88v-1.12c-0.489-.21-1.378-0.55-2.141-0.82l-0.354-.12-0.784-1.87,0.149-.33c0.329-.74.7-1.61,0.881-2.11l-0.825-.8c-0.493.19-1.373,0.57-2.118,0.91l-0.332.15-1.878-.76-0.134-.33c-0.3-.76-0.678-1.64-0.9-2.11h-1.184c-0.212.48-.554,1.35-0.833,2.1l-0.13.34-1.874.76-0.325-.13c-0.77-.33-1.68-0.7-2.181-0.87l-0.824.8c0.2,0.49.58,1.33,0.921,2.04l0.163,0.35-0.786,1.86-0.336.13c-0.772.3-1.669,0.66-2.156,0.88v1.12c0.49,0.21,1.379.54,2.144,0.82l0.352,0.12,0.782,1.86-0.148.34c-0.327.73-.695,1.61-0.881,2.1l0.823,0.81c0.5-.19,1.374-0.57,2.117-0.91l0.335-.16,1.877,0.76,0.135,0.34C410.833,5152.96,411.205,5153.84,411.43,5154.31Zm0.553-4.85a3.936,3.936,0,1,1,4.006-3.94A3.972,3.972,0,0,1,411.983,5149.46Zm0-6.17a2.236,2.236,0,1,0,2.308,2.23A2.272,2.272,0,0,0,411.983,5143.29Z",transform:"translate(-401.281 -5135.03)"}));};//Настройки
var ThemesIcon=function ThemesIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:18,height:19},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M17.816,9.067 L15.746,10.724 L12.813,7.072 L14.883,5.415 C14.976,5.341 15.093,5.299 15.211,5.299 C15.372,5.299 15.521,5.371 15.621,5.496 L17.897,8.331 C18.078,8.556 18.042,8.886 17.816,9.067 ZM11.276,6.328 L7.188,4.037 L8.487,1.727 C8.580,1.562 8.755,1.459 8.944,1.459 C9.034,1.459 9.123,1.482 9.201,1.526 L12.375,3.305 C12.497,3.374 12.585,3.485 12.623,3.620 C12.661,3.755 12.644,3.896 12.575,4.018 L11.276,6.328 ZM9.134,10.138 L6.002,8.382 L6.002,6.144 L6.702,4.900 L10.791,7.191 L9.134,10.138 ZM6.679,17.044 L6.679,16.617 L7.219,15.657 L8.143,16.808 L6.073,18.465 C5.980,18.539 5.863,18.580 5.745,18.580 C5.585,18.580 5.435,18.509 5.335,18.384 L4.999,17.964 L5.756,17.964 C6.265,17.964 6.679,17.551 6.679,17.044 ZM4.442,16.963 L0.538,16.963 C0.235,16.963 -0.012,16.717 -0.012,16.415 L-0.012,11.958 L4.993,11.958 L4.993,16.415 C4.993,16.717 4.746,16.963 4.442,16.963 ZM2.459,14.787 C2.180,14.787 1.952,15.014 1.952,15.293 C1.952,15.571 2.180,15.798 2.459,15.798 C2.739,15.798 2.966,15.571 2.966,15.293 C2.966,15.014 2.739,14.787 2.459,14.787 ZM-0.012,8.032 L4.993,8.032 L4.993,10.955 L-0.012,10.955 L-0.012,8.032 ZM-0.012,4.009 L4.993,4.009 L4.993,7.029 L-0.012,7.029 L-0.012,4.009 ZM-0.012,0.556 C-0.012,0.252 0.235,0.006 0.538,0.006 L4.442,0.006 C4.746,0.006 4.993,0.252 4.993,0.556 L4.993,3.055 L-0.012,3.055 L-0.012,0.556 ZM6.002,14.527 L6.506,14.810 L6.002,15.706 L6.002,14.527 ZM6.002,9.517 L8.649,11.000 L6.992,13.947 L6.002,13.392 L6.002,9.517 ZM9.529,11.549 L11.557,14.076 L8.917,16.189 L7.742,14.726 L9.529,11.549 ZM11.420,8.186 L12.039,7.691 L12.079,7.741 L14.972,11.343 L12.331,13.457 L10.053,10.619 L11.420,8.186 Z"}));};var FullScreenIcon=function FullScreenIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:17,height:17},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M10.964,16.970 L10.964,15.446 L14.394,15.446 L10.173,11.225 L11.251,10.148 L15.472,14.368 L15.472,10.970 L16.996,10.970 L16.996,16.970 L10.964,16.970 ZM15.472,2.663 L11.251,6.883 L10.173,5.806 L14.394,1.585 L10.964,1.585 L10.964,0.061 L16.996,0.061 L16.996,6.061 L15.472,6.061 L15.472,2.663 ZM6.034,15.446 L6.034,16.970 L0.002,16.970 L0.002,10.970 L1.526,10.970 L1.526,14.368 L5.747,10.148 L6.825,11.225 L2.604,15.446 L6.034,15.446 ZM5.747,6.883 L1.526,2.663 L1.526,6.061 L0.002,6.061 L0.002,0.061 L6.034,0.061 L6.034,1.585 L2.604,1.585 L6.825,5.806 L5.747,6.883 Z"}));};var NotFullScreenIcon=function NotFullScreenIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:17,height:17},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M16.034,5.446 L16.034,6.970 L10.002,6.970 L10.002,0.970 L11.526,0.970 L11.526,4.368 L15.747,0.147 L16.825,1.225 L12.604,5.446 L16.034,5.446 ZM5.474,12.630 L1.252,16.851 L0.174,15.774 L4.396,11.553 L0.966,11.553 L0.966,10.029 L6.998,10.029 L6.998,16.029 L5.474,16.029 L5.474,12.630 ZM0.966,5.446 L4.396,5.446 L0.174,1.225 L1.252,0.147 L5.474,4.368 L5.474,0.970 L6.998,0.970 L6.998,6.970 L0.966,6.970 L0.966,5.446 ZM16.034,11.553 L12.604,11.553 L16.825,15.774 L15.747,16.851 L11.526,12.630 L11.526,16.029 L10.002,16.029 L10.002,10.029 L16.034,10.029 L16.034,11.553 Z"}));};var FontsIcon=function FontsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:21,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18.434,12.977 C18.368,12.769 18.314,12.567 18.271,12.370 C18.228,12.173 18.199,11.975 18.184,11.778 C17.931,12.162 17.598,12.485 17.186,12.746 C16.774,13.006 16.312,13.136 15.802,13.136 C14.947,13.136 14.291,12.916 13.833,12.476 C13.375,12.036 13.146,11.432 13.146,10.663 C13.146,9.869 13.460,9.251 14.087,8.808 C14.714,8.366 15.597,8.144 16.735,8.144 L18.169,8.144 L18.169,7.424 C18.169,6.994 18.042,6.658 17.789,6.415 C17.536,6.172 17.175,6.051 16.704,6.051 C16.285,6.051 15.951,6.151 15.703,6.354 C15.455,6.556 15.331,6.817 15.331,7.135 L13.556,7.135 L13.549,7.090 C13.513,6.442 13.803,5.868 14.417,5.368 C15.032,4.867 15.832,4.617 16.818,4.617 C17.774,4.617 18.545,4.859 19.132,5.345 C19.719,5.830 20.012,6.529 20.012,7.439 L20.012,11.087 C20.012,11.427 20.035,11.751 20.080,12.063 C20.126,12.374 20.199,12.678 20.300,12.977 L18.434,12.977 ZM18.169,9.297 L16.704,9.297 C16.168,9.297 15.749,9.430 15.445,9.696 C15.142,9.961 14.990,10.273 14.990,10.633 C14.990,10.946 15.092,11.195 15.297,11.380 C15.502,11.565 15.794,11.657 16.173,11.657 C16.639,11.657 17.057,11.540 17.429,11.308 C17.801,11.075 18.047,10.810 18.169,10.511 L18.169,9.297 ZM8.228,9.965 L3.218,9.965 L2.198,12.953 L0.036,12.953 L4.739,0.156 L6.760,0.156 L11.409,12.953 L9.238,12.953 L8.228,9.965 ZM5.767,2.714 L5.714,2.714 L3.833,8.180 L7.621,8.180 L5.767,2.714 Z"}));};var LanguageIcon=function LanguageIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:19,height:19},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M15.914,3.087 C17.630,4.803 18.576,7.085 18.576,9.513 C18.576,11.940 17.630,14.221 15.914,15.938 C14.198,17.654 11.916,18.599 9.489,18.599 C7.062,18.599 4.780,17.654 3.064,15.938 C1.348,14.221 0.403,11.940 0.403,9.513 C0.403,7.085 1.348,4.803 3.064,3.087 C4.780,1.371 7.062,0.426 9.489,0.426 C11.916,0.426 14.198,1.371 15.914,3.087 ZM14.761,14.786 C15.811,13.736 16.508,12.428 16.796,11.006 C16.572,11.337 16.357,11.459 16.225,10.720 C16.088,9.515 14.981,10.285 14.285,9.857 C13.553,10.350 11.907,8.897 12.187,10.537 C12.618,11.276 14.517,9.547 13.570,11.111 C12.967,12.204 11.363,14.621 11.572,15.875 C11.598,17.702 9.705,16.256 9.053,15.650 C8.615,14.436 8.904,12.315 7.757,11.721 C6.512,11.667 5.443,11.554 4.961,10.162 C4.671,9.167 5.270,7.684 6.337,7.456 C7.899,6.474 8.457,8.605 9.922,8.644 C10.376,8.168 11.616,8.017 11.719,7.483 C10.758,7.314 12.938,6.675 11.627,6.312 C10.903,6.397 10.437,7.062 10.822,7.626 C9.420,7.953 9.375,5.597 8.027,6.340 C7.993,7.515 5.827,6.721 7.278,6.483 C7.776,6.265 6.465,5.634 7.173,5.749 C7.521,5.730 8.693,5.319 8.376,5.043 C9.029,4.637 9.577,6.013 10.216,5.012 C10.677,4.241 10.023,4.099 9.444,4.490 C9.119,4.125 10.020,3.337 10.815,2.996 C11.080,2.883 11.333,2.821 11.526,2.838 C11.927,3.301 12.667,3.381 12.706,2.783 C11.714,2.308 10.621,2.057 9.489,2.057 C7.864,2.057 6.319,2.573 5.040,3.528 C5.384,3.685 5.579,3.881 5.248,4.132 C4.991,4.899 3.947,5.927 3.031,5.781 C2.555,6.602 2.241,7.506 2.108,8.454 C2.875,8.707 3.052,9.210 2.887,9.378 C2.496,9.719 2.256,10.202 2.132,10.731 C2.382,12.260 3.100,13.668 4.217,14.786 C5.625,16.193 7.497,16.969 9.489,16.969 C11.480,16.969 13.353,16.193 14.761,14.786 Z"}));};var SoundIcon=function SoundIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:21,height:21},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M961.713,5766.32a0.769,0.769,0,0,0-.826.17l-4.574,4.59h-3.527a0.749,0.749,0,0,0-.756.75v5.44a0.749,0.749,0,0,0,.756.75h3.506l4.6,4.59a0.776,0.776,0,0,0,.536.22,0.746,0.746,0,0,0,.29-0.06,0.617,0.617,0,0,0,.282-0.69v-15.06A0.63,0.63,0,0,0,961.713,5766.32Zm-4.685,10.11a0.7,0.7,0,0,0-.48-0.19H953.8v-3.53h2.762a0.7,0.7,0,0,0,.481-0.19l3.137-3.15v10.21Zm12.566-1.9a7.031,7.031,0,0,0-4.3-6.48,0.751,0.751,0,1,0-.594,1.38,5.528,5.528,0,0,1,.017,10.18,0.756,0.756,0,0,0,.3,1.45,0.786,0.786,0,0,0,.3-0.06A7.05,7.05,0,0,0,969.594,5774.53Zm-3.352,0a3.7,3.7,0,0,0-2.27-3.42,0.766,0.766,0,0,0-.994.4,0.757,0.757,0,0,0,.4.99,2.2,2.2,0,0,1,.014,4.05,0.747,0.747,0,0,0-.392.99,0.76,0.76,0,0,0,.7.45,0.8,0.8,0,0,0,.3-0.06A3.713,3.713,0,0,0,966.242,5774.53Zm0.34-9.47a0.757,0.757,0,0,0-.6,1.39A8.771,8.771,0,0,1,966,5782.6a0.752,0.752,0,0,0-.4.99,0.76,0.76,0,0,0,.7.45,0.79,0.79,0,0,0,.3-0.06A10.276,10.276,0,0,0,966.582,5765.06Z",transform:"translate(-952.031 -5764.015)"}));};var SoundIconMute=function SoundIconMute(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:21},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M962.713,5871.32a0.769,0.769,0,0,0-.826.17l-4.574,4.59h-3.527a0.749,0.749,0,0,0-.756.75v5.44a0.749,0.749,0,0,0,.756.75h3.506l4.6,4.59a0.776,0.776,0,0,0,.536.22,0.746,0.746,0,0,0,.29-0.06,0.617,0.617,0,0,0,.282-0.69v-15.06A0.63,0.63,0,0,0,962.713,5871.32Zm-4.685,10.12a0.67,0.67,0,0,0-.48-0.2H954.8v-3.53h2.762a0.7,0.7,0,0,0,.481-0.19l3.137-3.15v10.22Zm7.986-4.26,1.173-1.17,5.807,5.8-1.174,1.18Zm1.174,5.81-1.174-1.18,5.807-5.8,1.173,1.17Z",transform:"translate(-953.031 -5869.06)"}));};//Инструменты
var ChartIconZone=function ChartIconZone(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:19,height:21},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18.554,16.303 L3.156,16.303 L5.665,13.588 L5.711,13.602 C5.835,13.641 5.964,13.661 6.094,13.661 C6.732,13.661 7.272,13.184 7.350,12.551 L7.356,12.503 L10.015,11.784 L10.045,11.823 C10.287,12.140 10.654,12.321 11.051,12.321 C11.750,12.321 12.318,11.753 12.318,11.054 C12.318,10.537 12.009,10.077 11.530,9.881 L11.486,9.863 L12.577,7.249 L12.622,7.231 C13.099,7.036 13.408,6.577 13.410,6.062 C13.410,6.058 13.410,6.054 13.409,6.051 L13.407,5.979 L15.816,4.446 L15.851,4.480 C16.088,4.711 16.401,4.838 16.732,4.838 C17.431,4.838 17.999,4.269 17.999,3.571 C17.999,2.872 17.431,2.304 16.732,2.304 C16.036,2.304 15.468,2.871 15.466,3.567 C15.466,3.571 15.466,3.574 15.466,3.578 L15.468,3.650 L13.060,5.182 L13.025,5.148 C12.787,4.918 12.474,4.790 12.143,4.790 C11.445,4.790 10.877,5.359 10.877,6.058 C10.877,6.574 11.186,7.035 11.664,7.231 L11.709,7.249 L10.617,9.862 L10.572,9.881 C10.149,10.054 9.851,10.444 9.795,10.897 L9.789,10.945 L7.130,11.664 L7.101,11.625 C6.859,11.309 6.492,11.127 6.094,11.127 C5.396,11.127 4.828,11.695 4.828,12.393 C4.828,12.604 4.877,12.803 4.975,12.988 L4.998,13.031 L2.699,15.495 L2.699,0.410 C2.699,0.197 2.526,0.024 2.313,0.024 L1.375,0.024 C1.162,0.024 0.989,0.197 0.989,0.410 L0.992,3.077 L0.450,3.077 C0.237,3.077 0.064,3.249 0.064,3.463 L0.064,3.560 C0.064,3.773 0.237,3.946 0.450,3.946 L0.992,3.946 L0.992,7.083 L0.450,7.083 C0.237,7.083 0.064,7.256 0.064,7.469 L0.064,7.566 C0.064,7.779 0.237,7.952 0.450,7.952 L0.992,7.952 L0.992,11.089 L0.450,11.089 C0.237,11.089 0.064,11.262 0.064,11.475 L0.064,11.572 C0.064,11.785 0.237,11.958 0.450,11.958 L0.992,11.958 L0.992,15.095 L0.450,15.095 C0.237,15.095 0.064,15.268 0.064,15.481 L0.064,15.578 C0.064,15.791 0.237,15.964 0.450,15.964 L0.992,15.964 L0.992,17.598 C0.992,17.810 1.164,17.984 1.378,17.984 L3.944,17.984 L3.944,18.659 C3.944,18.872 4.117,19.045 4.330,19.045 L4.427,19.045 C4.640,19.045 4.813,18.872 4.813,18.659 L4.813,17.984 L8.061,17.984 L8.061,18.659 C8.061,18.872 8.234,19.045 8.447,19.045 L8.543,19.045 C8.757,19.045 8.929,18.872 8.929,18.659 L8.929,17.984 L12.027,17.984 L12.027,18.659 C12.027,18.872 12.200,19.045 12.413,19.045 L12.509,19.045 C12.722,19.045 12.895,18.872 12.895,18.659 L12.895,17.984 L16.030,17.984 L16.030,18.659 C16.030,18.872 16.203,19.045 16.416,19.045 L16.513,19.045 C16.726,19.045 16.899,18.872 16.899,18.659 L16.899,17.984 L18.554,17.984 C18.767,17.984 18.940,17.810 18.940,17.598 L18.940,16.689 C18.940,16.476 18.767,16.303 18.554,16.303 Z"}));};var ChartIconCandlestick=function ChartIconCandlestick(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:19,height:21},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18.554,17.983 L16.899,17.983 L16.899,18.658 C16.899,18.872 16.726,19.045 16.513,19.045 L16.416,19.045 C16.203,19.045 16.030,18.872 16.030,18.658 L16.030,17.983 L12.895,17.983 L12.895,18.658 C12.895,18.872 12.722,19.045 12.509,19.045 L12.413,19.045 C12.200,19.045 12.027,18.872 12.027,18.658 L12.027,17.983 L8.929,17.983 L8.929,18.658 C8.929,18.872 8.757,19.045 8.543,19.045 L8.447,19.045 C8.234,19.045 8.061,18.872 8.061,18.658 L8.061,17.983 L4.813,17.983 L4.813,18.658 C4.813,18.872 4.640,19.045 4.427,19.045 L4.330,19.045 C4.117,19.045 3.944,18.872 3.944,18.658 L3.944,17.983 L1.378,17.983 C1.164,17.983 0.992,17.811 0.992,17.597 L0.992,15.964 L0.450,15.964 C0.237,15.964 0.064,15.791 0.064,15.578 L0.064,15.481 C0.064,15.268 0.237,15.095 0.450,15.095 L0.992,15.095 L0.992,11.958 L0.450,11.958 C0.237,11.958 0.064,11.785 0.064,11.572 L0.064,11.475 C0.064,11.262 0.237,11.089 0.450,11.089 L0.992,11.089 L0.992,7.952 L0.450,7.952 C0.237,7.952 0.064,7.779 0.064,7.566 L0.064,7.469 C0.064,7.256 0.237,7.083 0.450,7.083 L0.992,7.083 L0.992,3.946 L0.450,3.946 C0.237,3.946 0.064,3.773 0.064,3.560 L0.064,3.463 C0.064,3.250 0.237,3.077 0.450,3.077 L0.992,3.077 L0.989,0.410 C0.989,0.197 1.162,0.024 1.375,0.024 L2.313,0.024 C2.526,0.024 2.699,0.197 2.699,0.410 L2.699,15.494 L3.156,16.303 L18.554,16.303 C18.767,16.303 18.940,16.476 18.940,16.689 L18.940,17.597 C18.940,17.811 18.767,17.983 18.554,17.983 ZM16.885,13.953 L16.085,13.953 L16.085,11.001 L15.006,11.001 L15.006,4.955 L16.085,4.955 L16.085,2.935 L16.885,2.935 L16.885,4.955 L18.014,4.955 L18.014,11.001 L16.885,11.001 L16.885,13.953 ZM11.873,10.002 L11.072,10.002 L11.072,6.014 L9.993,6.014 L9.993,2.930 L11.072,2.930 L11.072,0.973 L11.873,0.973 L11.873,2.930 L13.001,2.930 L13.001,6.014 L11.873,6.014 L11.873,10.002 ZM6.870,14.989 L6.070,14.989 L6.070,10.968 L4.991,10.968 L4.991,6.926 L6.070,6.926 L6.070,4.978 L6.870,4.978 L6.870,6.926 L7.999,6.926 L7.999,10.968 L6.870,10.968 L6.870,14.989 Z"}));};var ChartIconBars=function ChartIconBars(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:19,height:20},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18.553,17.981 L16.898,17.981 L16.898,18.657 C16.898,18.871 16.726,19.043 16.513,19.043 L16.416,19.043 C16.203,19.043 16.030,18.871 16.030,18.657 L16.030,17.981 L12.895,17.981 L12.895,18.657 C12.895,18.871 12.722,19.043 12.509,19.043 L12.413,19.043 C12.199,19.043 12.026,18.871 12.026,18.657 L12.026,17.981 L8.929,17.981 L8.929,18.657 C8.929,18.871 8.756,19.043 8.543,19.043 L8.447,19.043 C8.234,19.043 8.061,18.871 8.061,18.657 L8.061,17.981 L4.813,17.981 L4.813,18.657 C4.813,18.871 4.640,19.043 4.427,19.043 L4.330,19.043 C4.117,19.043 3.944,18.871 3.944,18.657 L3.944,17.981 L1.378,17.981 C1.164,17.981 0.992,17.809 0.992,17.596 L0.992,15.962 L0.450,15.962 C0.237,15.962 0.064,15.790 0.064,15.577 L0.064,15.480 C0.064,15.266 0.237,15.094 0.450,15.094 L0.992,15.094 L0.992,11.956 L0.450,11.956 C0.237,11.956 0.064,11.784 0.064,11.570 L0.064,11.474 C0.064,11.260 0.237,11.088 0.450,11.088 L0.992,11.088 L0.992,7.951 L0.450,7.951 C0.237,7.951 0.064,7.778 0.064,7.565 L0.064,7.467 C0.064,7.255 0.237,7.082 0.450,7.082 L0.992,7.082 L0.992,3.944 L0.450,3.944 C0.237,3.944 0.064,3.771 0.064,3.558 L0.064,3.462 C0.064,3.248 0.237,3.075 0.450,3.075 L0.992,3.075 L0.989,0.409 C0.989,0.196 1.162,0.022 1.375,0.022 L2.313,0.022 C2.526,0.022 2.699,0.196 2.699,0.409 L2.699,15.493 L3.156,16.301 L18.553,16.301 C18.767,16.301 18.939,16.474 18.939,16.688 L18.939,17.596 C18.939,17.809 18.767,17.981 18.553,17.981 ZM17.010,13.952 L15.991,13.952 L15.991,5.977 L15.006,5.977 L15.006,4.953 L15.991,4.953 L15.991,2.934 L17.010,2.934 L17.010,10.027 L18.014,10.027 L18.014,10.999 L17.010,10.999 L17.010,13.952 ZM11.997,10.000 L11.009,10.000 L11.009,7.013 L9.993,7.013 L9.993,5.958 L11.009,5.958 L11.009,0.971 L11.997,0.971 L11.997,3.995 L13.001,3.995 L13.001,4.948 L11.997,4.948 L11.997,10.000 ZM6.995,14.987 L6.007,14.987 L6.007,11.935 L4.991,11.935 L4.991,10.988 L6.007,10.988 L6.007,4.976 L6.995,4.976 L6.995,6.924 L7.999,6.924 L7.999,8.024 L6.995,8.024 L6.995,14.987 Z"}));};var HorizontalLineIcon=function HorizontalLineIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:6},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M6.172,4H-1V2H6.172a3,3,0,0,1,5.658,0H19V4H11.829A3,3,0,0,1,6.172,4ZM9,5a2,2,0,0,0,2-1.942V2.941A2,2,0,1,0,9,5Z",transform:"translate(1)"}));};var IntervalIcon1s=function IntervalIcon1s(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:16,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M12.954,6.312 C12.954,5.929 12.808,5.600 12.516,5.325 C12.224,5.050 11.823,4.912 11.313,4.912 C10.809,4.912 10.426,5.025 10.162,5.252 C9.899,5.478 9.767,5.755 9.767,6.081 C9.767,6.407 9.892,6.667 10.141,6.858 C10.390,7.050 10.895,7.220 11.657,7.369 C12.825,7.610 13.691,7.949 14.255,8.387 C14.819,8.825 15.101,9.422 15.101,10.178 C15.101,11.014 14.756,11.693 14.066,12.214 C13.376,12.735 12.467,12.995 11.339,12.995 C10.131,12.995 9.177,12.686 8.479,12.068 C7.780,11.449 7.448,10.739 7.482,9.937 L7.500,9.886 L9.441,9.886 C9.463,10.424 9.658,10.816 10.025,11.063 C10.391,11.309 10.838,11.432 11.365,11.432 C11.903,11.432 12.318,11.329 12.610,11.123 C12.902,10.917 13.048,10.639 13.048,10.290 C13.048,9.969 12.911,9.703 12.636,9.491 C12.361,9.279 11.849,9.093 11.099,8.932 C9.987,8.698 9.147,8.364 8.577,7.932 C8.008,7.499 7.723,6.911 7.723,6.166 C7.723,5.388 8.052,4.724 8.711,4.173 C9.369,3.624 10.237,3.349 11.313,3.349 C12.447,3.349 13.348,3.628 14.015,4.187 C14.682,4.745 15.001,5.436 14.972,6.261 L14.955,6.312 L12.954,6.312 ZM2.917,2.293 L0.374,2.293 L0.374,0.755 L5.004,0.308 L5.004,12.815 L2.917,12.815 L2.917,2.293 Z"}));};var IntervalIcon5s=function IntervalIcon5s(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:19,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M15.954,6.312 C15.954,5.929 15.808,5.600 15.516,5.325 C15.224,5.050 14.823,4.913 14.313,4.913 C13.809,4.913 13.426,5.026 13.162,5.252 C12.899,5.478 12.767,5.754 12.767,6.080 C12.767,6.407 12.892,6.666 13.141,6.858 C13.390,7.050 13.895,7.220 14.657,7.369 C15.825,7.609 16.691,7.949 17.255,8.387 C17.819,8.825 18.101,9.422 18.101,10.178 C18.101,11.014 17.756,11.693 17.066,12.214 C16.376,12.735 15.467,12.995 14.339,12.995 C13.131,12.995 12.177,12.686 11.479,12.068 C10.780,11.449 10.448,10.739 10.482,9.937 L10.499,9.886 L12.441,9.886 C12.464,10.424 12.658,10.816 13.025,11.063 C13.391,11.309 13.838,11.432 14.365,11.432 C14.903,11.432 15.318,11.329 15.610,11.123 C15.902,10.917 16.048,10.639 16.048,10.289 C16.048,9.969 15.911,9.703 15.636,9.491 C15.361,9.279 14.849,9.093 14.099,8.933 C12.987,8.698 12.147,8.364 11.577,7.932 C11.007,7.500 10.723,6.911 10.723,6.166 C10.723,5.388 11.052,4.723 11.711,4.174 C12.369,3.624 13.237,3.349 14.313,3.349 C15.447,3.349 16.348,3.629 17.015,4.186 C17.682,4.745 18.001,5.437 17.972,6.261 L17.955,6.312 L15.954,6.312 ZM5.097,4.603 C6.270,4.592 7.189,4.964 7.854,5.720 C8.518,6.475 8.850,7.510 8.850,8.820 C8.850,10.046 8.501,11.048 7.802,11.827 C7.104,12.606 6.093,12.995 4.770,12.995 C3.671,12.995 2.741,12.693 1.983,12.089 C1.224,11.485 0.859,10.627 0.888,9.517 L0.905,9.474 L2.855,9.405 C2.855,10.009 3.032,10.480 3.387,10.816 C3.742,11.152 4.203,11.320 4.770,11.320 C5.417,11.320 5.911,11.093 6.252,10.637 C6.592,10.182 6.763,9.579 6.763,8.829 C6.763,8.073 6.588,7.460 6.239,6.987 C5.890,6.514 5.391,6.278 4.744,6.278 C4.172,6.278 3.746,6.372 3.469,6.560 C3.191,6.747 2.989,7.017 2.863,7.369 L1.068,7.223 L1.790,0.309 L8.395,0.309 L8.395,2.112 L3.525,2.112 L3.147,5.248 C3.393,5.064 3.678,4.913 4.001,4.797 C4.325,4.679 4.690,4.614 5.097,4.603 Z"}));};var IntervalIcon10s=function IntervalIcon10s(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:26,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M22.952,6.313 C22.952,5.929 22.806,5.600 22.514,5.325 C22.222,5.050 21.821,4.912 21.312,4.912 C20.808,4.912 20.424,5.025 20.161,5.251 C19.897,5.478 19.766,5.754 19.766,6.081 C19.766,6.407 19.890,6.666 20.139,6.858 C20.388,7.050 20.894,7.220 21.655,7.369 C22.823,7.610 23.690,7.949 24.254,8.387 C24.818,8.825 25.100,9.422 25.100,10.178 C25.100,11.014 24.755,11.692 24.065,12.214 C23.374,12.735 22.465,12.996 21.337,12.996 C20.129,12.996 19.176,12.686 18.477,12.068 C17.778,11.449 17.446,10.739 17.481,9.937 L17.498,9.885 L19.439,9.885 C19.462,10.424 19.657,10.817 20.023,11.062 C20.390,11.309 20.836,11.432 21.363,11.432 C21.901,11.432 22.317,11.329 22.609,11.122 C22.901,10.916 23.047,10.639 23.047,10.290 C23.047,9.969 22.909,9.703 22.635,9.491 C22.360,9.279 21.847,9.093 21.097,8.932 C19.986,8.698 19.146,8.364 18.576,7.932 C18.006,7.499 17.721,6.911 17.721,6.166 C17.721,5.388 18.050,4.723 18.709,4.174 C19.367,3.624 20.235,3.349 21.312,3.349 C22.445,3.349 23.346,3.628 24.013,4.186 C24.680,4.745 24.999,5.437 24.971,6.261 L24.954,6.313 L22.952,6.313 ZM11.734,12.996 C10.469,12.996 9.466,12.569 8.728,11.715 C7.989,10.862 7.620,9.622 7.620,7.996 L7.620,5.136 C7.620,3.515 7.986,2.275 8.719,1.417 C9.452,0.557 10.451,0.128 11.717,0.128 C12.977,0.128 13.976,0.557 14.715,1.417 C15.453,2.275 15.823,3.515 15.823,5.136 L15.823,7.996 C15.823,9.622 15.456,10.862 14.723,11.715 C13.990,12.569 12.994,12.996 11.734,12.996 ZM13.736,4.815 C13.736,3.791 13.564,3.033 13.220,2.541 C12.877,2.049 12.375,1.803 11.717,1.803 C11.058,1.803 10.559,2.049 10.218,2.541 C9.877,3.033 9.707,3.791 9.707,4.815 L9.707,8.291 C9.707,9.321 9.880,10.083 10.227,10.578 C10.573,11.073 11.076,11.320 11.734,11.320 C12.393,11.320 12.891,11.075 13.229,10.582 C13.567,10.090 13.736,9.326 13.736,8.291 L13.736,4.815 ZM2.891,2.293 L0.349,2.293 L0.349,0.755 L4.978,0.309 L4.978,12.815 L2.891,12.815 L2.891,2.293 Z"}));};var IntervalIcon15s=function IntervalIcon15s(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:25,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M21.952,6.312 C21.952,5.929 21.806,5.600 21.514,5.325 C21.222,5.050 20.821,4.913 20.312,4.913 C19.808,4.913 19.424,5.026 19.161,5.251 C18.897,5.478 18.766,5.754 18.766,6.080 C18.766,6.407 18.890,6.666 19.139,6.858 C19.388,7.050 19.894,7.220 20.655,7.369 C21.823,7.610 22.690,7.949 23.254,8.387 C23.818,8.825 24.100,9.422 24.100,10.178 C24.100,11.014 23.755,11.692 23.065,12.213 C22.374,12.734 21.465,12.995 20.337,12.995 C19.129,12.995 18.176,12.686 17.477,12.068 C16.778,11.449 16.446,10.739 16.481,9.937 L16.498,9.886 L18.439,9.886 C18.462,10.425 18.657,10.816 19.023,11.063 C19.390,11.309 19.836,11.432 20.363,11.432 C20.901,11.432 21.317,11.329 21.609,11.123 C21.901,10.916 22.047,10.639 22.047,10.290 C22.047,9.969 21.909,9.703 21.635,9.491 C21.360,9.279 20.847,9.093 20.097,8.933 C18.986,8.698 18.146,8.364 17.576,7.932 C17.006,7.500 16.721,6.911 16.721,6.167 C16.721,5.388 17.050,4.724 17.709,4.174 C18.367,3.624 19.235,3.349 20.312,3.349 C21.445,3.349 22.346,3.628 23.013,4.187 C23.680,4.745 23.999,5.436 23.971,6.261 L23.954,6.312 L21.952,6.312 ZM11.095,4.603 C12.269,4.592 13.188,4.964 13.852,5.720 C14.516,6.476 14.849,7.509 14.849,8.821 C14.849,10.046 14.499,11.049 13.801,11.827 C13.102,12.606 12.091,12.995 10.768,12.995 C9.669,12.995 8.740,12.693 7.981,12.089 C7.222,11.485 6.857,10.627 6.886,9.517 L6.903,9.473 L8.853,9.405 C8.853,10.009 9.030,10.480 9.386,10.816 C9.741,11.152 10.202,11.321 10.768,11.321 C11.416,11.321 11.910,11.093 12.250,10.637 C12.591,10.182 12.761,9.579 12.761,8.829 C12.761,8.073 12.587,7.459 12.237,6.987 C11.888,6.514 11.390,6.278 10.743,6.278 C10.170,6.278 9.745,6.372 9.467,6.559 C9.189,6.747 8.988,7.017 8.862,7.369 L7.066,7.223 L7.788,0.308 L14.393,0.308 L14.393,2.112 L9.523,2.112 L9.145,5.248 C9.391,5.064 9.676,4.914 10.000,4.796 C10.323,4.679 10.688,4.615 11.095,4.603 ZM2.903,2.292 L0.361,2.292 L0.361,0.755 L4.991,0.308 L4.991,12.815 L2.903,12.815 L2.903,2.292 Z"}));};var IntervalIcon30s=function IntervalIcon30s(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:29,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M25.952,6.313 C25.952,5.929 25.806,5.599 25.514,5.325 C25.222,5.050 24.821,4.913 24.312,4.913 C23.808,4.913 23.424,5.026 23.161,5.252 C22.897,5.478 22.766,5.754 22.766,6.081 C22.766,6.407 22.890,6.666 23.139,6.858 C23.388,7.050 23.894,7.220 24.655,7.369 C25.823,7.610 26.690,7.949 27.254,8.387 C27.818,8.825 28.100,9.422 28.100,10.178 C28.100,11.014 27.755,11.692 27.065,12.214 C26.374,12.735 25.465,12.995 24.337,12.995 C23.129,12.995 22.176,12.686 21.477,12.067 C20.778,11.449 20.446,10.739 20.481,9.938 L20.498,9.886 L22.439,9.886 C22.462,10.424 22.657,10.817 23.023,11.062 C23.390,11.309 23.836,11.432 24.363,11.432 C24.901,11.432 25.317,11.329 25.609,11.123 C25.901,10.917 26.047,10.639 26.047,10.290 C26.047,9.969 25.909,9.702 25.634,9.490 C25.360,9.279 24.847,9.093 24.097,8.932 C22.986,8.697 22.146,8.364 21.576,7.932 C21.006,7.499 20.721,6.911 20.721,6.166 C20.721,5.388 21.050,4.723 21.709,4.174 C22.367,3.624 23.235,3.349 24.312,3.349 C25.445,3.349 26.346,3.628 27.013,4.186 C27.680,4.745 27.999,5.436 27.971,6.261 L27.954,6.313 L25.952,6.313 ZM14.734,12.995 C13.469,12.995 12.466,12.569 11.728,11.715 C10.989,10.862 10.620,9.623 10.620,7.996 L10.620,5.136 C10.620,3.515 10.986,2.275 11.719,1.416 C12.452,0.558 13.451,0.128 14.717,0.128 C15.977,0.128 16.976,0.558 17.715,1.416 C18.453,2.275 18.823,3.515 18.823,5.136 L18.823,7.996 C18.823,9.623 18.456,10.862 17.723,11.715 C16.990,12.569 15.994,12.995 14.734,12.995 ZM16.736,4.815 C16.736,3.791 16.564,3.033 16.220,2.541 C15.877,2.049 15.375,1.803 14.717,1.803 C14.058,1.803 13.559,2.049 13.218,2.541 C12.877,3.033 12.707,3.791 12.707,4.815 L12.707,8.291 C12.707,9.321 12.880,10.083 13.227,10.578 C13.573,11.073 14.076,11.320 14.734,11.320 C15.393,11.320 15.891,11.074 16.229,10.583 C16.567,10.090 16.736,9.326 16.736,8.291 L16.736,4.815 ZM8.713,9.310 C8.713,10.456 8.319,11.356 7.532,12.012 C6.744,12.668 5.738,12.995 4.512,12.995 C3.356,12.995 2.384,12.687 1.596,12.072 C0.809,11.457 0.432,10.605 0.467,9.516 L0.484,9.465 L2.494,9.465 C2.494,10.018 2.680,10.465 3.052,10.807 C3.424,11.150 3.920,11.320 4.538,11.320 C5.185,11.320 5.695,11.146 6.067,10.797 C6.439,10.449 6.626,9.955 6.626,9.315 C6.626,8.612 6.455,8.093 6.114,7.759 C5.774,7.425 5.245,7.258 4.530,7.258 L3.078,7.258 L3.078,5.617 L4.530,5.617 C5.205,5.617 5.692,5.449 5.990,5.114 C6.288,4.779 6.437,4.305 6.437,3.693 C6.437,3.091 6.276,2.626 5.955,2.297 C5.635,1.968 5.162,1.803 4.538,1.803 C3.971,1.803 3.509,1.964 3.151,2.288 C2.793,2.612 2.614,3.037 2.614,3.564 L0.604,3.564 L0.587,3.512 C0.553,2.556 0.909,1.753 1.656,1.103 C2.404,0.453 3.356,0.128 4.512,0.128 C5.732,0.128 6.706,0.437 7.433,1.056 C8.160,1.674 8.524,2.553 8.524,3.693 C8.524,4.225 8.361,4.741 8.034,5.239 C7.708,5.737 7.244,6.124 6.643,6.398 C7.353,6.650 7.875,7.034 8.210,7.550 C8.545,8.065 8.713,8.652 8.713,9.310 Z"}));};var IntervalIcon1m=function IntervalIcon1m(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:13},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M17.838,12.815 L17.838,7.206 C17.838,6.416 17.702,5.860 17.430,5.540 C17.158,5.219 16.750,5.058 16.206,5.058 C15.759,5.058 15.381,5.179 15.072,5.419 C14.763,5.660 14.539,5.983 14.402,6.390 C14.402,6.475 14.405,6.550 14.411,6.613 C14.416,6.677 14.419,6.736 14.419,6.793 L14.419,12.815 L12.332,12.815 L12.332,7.206 C12.332,6.444 12.193,5.896 11.915,5.561 C11.637,5.226 11.229,5.058 10.691,5.058 C10.267,5.058 9.908,5.140 9.613,5.303 C9.318,5.467 9.085,5.697 8.913,5.995 L8.913,12.815 L6.826,12.815 L6.826,3.521 L8.733,3.521 L8.844,4.732 C9.148,4.291 9.529,3.950 9.987,3.710 C10.445,3.469 10.975,3.349 11.576,3.349 C12.183,3.349 12.704,3.487 13.139,3.761 C13.574,4.036 13.901,4.448 14.118,4.998 C14.405,4.483 14.783,4.079 15.252,3.787 C15.722,3.495 16.272,3.349 16.902,3.349 C17.835,3.349 18.572,3.668 19.113,4.307 C19.655,4.946 19.925,5.915 19.925,7.215 L19.925,12.815 L17.838,12.815 ZM2.898,2.293 L0.355,2.293 L0.355,0.755 L4.985,0.308 L4.985,12.815 L2.898,12.815 L2.898,2.293 Z"}));};var TradersMoodIcon=function TradersMoodIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:10,height:17},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M4.996,3.119 L1.492,6.622 L0.092,5.223 L4.987,0.328 L4.996,0.337 L5.005,0.328 L9.899,5.223 L8.499,6.622 L4.996,3.119 ZM4.996,13.908 L8.499,10.404 L9.899,11.804 L5.005,16.699 L4.996,16.689 L4.987,16.699 L0.092,11.804 L1.492,10.404 L4.996,13.908 Z"}));};var LineColorIcon=function LineColorIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:15,height:17},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M0.007,16.044 L0.007,0.961 L15.005,0.961 L15.005,16.044 L0.007,16.044 ZM13.181,2.798 L1.799,2.798 L1.799,14.180 L13.181,14.180 L13.181,2.798 Z"}));};//Ширина линии
var LineThicknessIcon1px=function LineThicknessIcon1px(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:15},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M19.694,12.810 L18.029,12.810 L16.768,10.518 L15.506,12.810 L13.829,12.810 L15.941,9.510 L13.889,6.282 L15.555,6.282 L16.743,8.520 L17.950,6.282 L19.634,6.282 L17.582,9.510 L19.694,12.810 ZM10.685,12.937 C10.315,12.937 9.987,12.871 9.701,12.738 C9.416,12.605 9.170,12.410 8.965,12.153 L8.965,15.321 L7.499,15.321 L7.499,6.282 L8.736,6.282 L8.881,7.102 C9.090,6.797 9.342,6.563 9.638,6.402 C9.934,6.241 10.277,6.161 10.667,6.161 C11.471,6.161 12.098,6.479 12.547,7.117 C12.995,7.755 13.219,8.595 13.219,9.636 L13.219,9.763 C13.219,10.712 12.996,11.479 12.550,12.062 C12.103,12.646 11.481,12.937 10.685,12.937 ZM11.759,9.633 C11.759,8.967 11.633,8.421 11.382,7.997 C11.130,7.573 10.755,7.361 10.256,7.361 C9.951,7.361 9.691,7.427 9.478,7.557 C9.265,7.688 9.094,7.870 8.965,8.102 L8.965,11.050 C9.094,11.278 9.265,11.454 9.478,11.577 C9.691,11.699 9.955,11.761 10.269,11.761 C10.767,11.761 11.141,11.577 11.388,11.209 C11.635,10.842 11.759,10.359 11.759,9.760 L11.759,9.633 ZM2.876,2.161 L0.303,2.161 L0.303,0.605 L4.989,0.153 L4.989,12.810 L2.876,12.810 L2.876,2.161 Z"}));};var LineThicknessIcon2px=function LineThicknessIcon2px(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:23,height:15},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M22.694,13.811 L21.029,13.811 L19.768,11.517 L18.506,13.811 L16.829,13.811 L18.941,10.510 L16.889,7.281 L18.555,7.281 L19.743,9.520 L20.950,7.281 L22.634,7.281 L20.582,10.510 L22.694,13.811 ZM13.685,13.937 C13.315,13.937 12.987,13.871 12.701,13.738 C12.416,13.605 12.170,13.410 11.965,13.153 L11.965,16.321 L10.499,16.321 L10.499,7.281 L11.736,7.281 L11.881,8.102 C12.090,7.796 12.342,7.563 12.638,7.402 C12.934,7.241 13.277,7.161 13.667,7.161 C14.471,7.161 15.098,7.479 15.547,8.117 C15.995,8.754 16.219,9.595 16.219,10.636 L16.219,10.763 C16.219,11.713 15.996,12.479 15.550,13.062 C15.103,13.646 14.481,13.937 13.685,13.937 ZM14.759,10.633 C14.759,9.967 14.633,9.421 14.382,8.997 C14.130,8.574 13.755,8.362 13.256,8.362 C12.951,8.362 12.691,8.427 12.478,8.558 C12.265,8.688 12.094,8.869 11.965,9.103 L11.965,12.049 C12.094,12.279 12.265,12.454 12.478,12.577 C12.691,12.699 12.955,12.760 13.269,12.760 C13.767,12.760 14.141,12.577 14.388,12.209 C14.635,11.842 14.759,11.358 14.759,10.760 L14.759,10.633 ZM0.555,12.351 L4.676,7.864 C5.348,7.128 5.811,6.524 6.066,6.052 C6.322,5.579 6.449,5.117 6.449,4.665 C6.449,4.097 6.284,3.622 5.954,3.240 C5.623,2.857 5.177,2.666 4.615,2.666 C3.873,2.666 3.322,2.874 2.963,3.291 C2.604,3.708 2.424,4.282 2.424,5.013 L0.381,5.013 L0.364,4.961 C0.335,3.837 0.703,2.890 1.468,2.122 C2.233,1.354 3.282,0.971 4.615,0.971 C5.832,0.971 6.794,1.307 7.501,1.979 C8.208,2.651 8.562,3.529 8.562,4.613 C8.562,5.337 8.357,6.030 7.949,6.691 C7.540,7.352 6.907,8.154 6.049,9.099 L3.233,12.064 L3.259,12.115 L8.961,12.115 L8.961,13.811 L0.555,13.811 L0.555,12.351 Z"}));};var LineThicknessIcon3px=function LineThicknessIcon3px(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:23,height:15},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M22.694,13.810 L21.029,13.810 L19.768,11.517 L18.506,13.810 L16.829,13.810 L18.941,10.510 L16.889,7.282 L18.555,7.282 L19.743,9.520 L20.950,7.282 L22.634,7.282 L20.582,10.510 L22.694,13.810 ZM13.685,13.937 C13.315,13.937 12.987,13.871 12.701,13.738 C12.416,13.605 12.170,13.410 11.965,13.153 L11.965,16.320 L10.499,16.320 L10.499,7.282 L11.736,7.282 L11.881,8.102 C12.090,7.796 12.342,7.563 12.638,7.402 C12.934,7.241 13.277,7.160 13.667,7.160 C14.471,7.160 15.098,7.480 15.547,8.117 C15.995,8.755 16.219,9.595 16.219,10.636 L16.219,10.763 C16.219,11.712 15.996,12.479 15.550,13.062 C15.103,13.645 14.481,13.937 13.685,13.937 ZM14.759,10.633 C14.759,9.966 14.633,9.421 14.382,8.997 C14.130,8.573 13.755,8.362 13.256,8.362 C12.951,8.362 12.691,8.427 12.478,8.557 C12.265,8.688 12.094,8.870 11.965,9.103 L11.965,12.049 C12.094,12.278 12.265,12.454 12.478,12.577 C12.691,12.699 12.955,12.760 13.269,12.760 C13.767,12.760 14.141,12.577 14.388,12.209 C14.635,11.842 14.759,11.359 14.759,10.759 L14.759,10.633 ZM8.192,8.482 C8.531,9.003 8.701,9.597 8.701,10.263 C8.701,11.423 8.302,12.334 7.505,12.998 C6.708,13.661 5.690,13.993 4.450,13.993 C3.279,13.993 2.295,13.681 1.498,13.058 C0.701,12.435 0.320,11.573 0.355,10.472 L0.372,10.420 L2.407,10.420 C2.407,10.979 2.595,11.432 2.972,11.778 C3.348,12.125 3.850,12.298 4.476,12.298 C5.130,12.298 5.646,12.121 6.023,11.768 C6.400,11.416 6.588,10.916 6.588,10.268 C6.588,9.557 6.416,9.031 6.071,8.693 C5.726,8.355 5.191,8.186 4.467,8.186 L2.998,8.186 L2.998,6.525 L4.467,6.525 C5.151,6.525 5.643,6.356 5.945,6.016 C6.246,5.678 6.397,5.198 6.397,4.578 C6.397,3.969 6.235,3.499 5.910,3.165 C5.585,2.832 5.107,2.666 4.476,2.666 C3.902,2.666 3.434,2.829 3.072,3.156 C2.709,3.485 2.528,3.914 2.528,4.448 L0.494,4.448 L0.477,4.396 C0.442,3.428 0.803,2.614 1.559,1.957 C2.315,1.300 3.279,0.970 4.450,0.970 C5.684,0.970 6.669,1.283 7.405,1.909 C8.141,2.535 8.509,3.425 8.509,4.578 C8.509,5.117 8.344,5.639 8.014,6.143 C7.684,6.647 7.214,7.038 6.605,7.316 C7.324,7.572 7.853,7.959 8.192,8.482 Z"}));};var LineThicknessIcon4px=function LineThicknessIcon4px(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:23,height:15},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M22.694,12.811 L21.029,12.811 L19.768,10.518 L18.506,12.811 L16.829,12.811 L18.941,9.509 L16.889,6.281 L18.555,6.281 L19.743,8.520 L20.950,6.281 L22.634,6.281 L20.582,9.509 L22.694,12.811 ZM13.685,12.937 C13.315,12.937 12.987,12.871 12.701,12.738 C12.416,12.606 12.170,12.411 11.965,12.153 L11.965,15.321 L10.499,15.321 L10.499,6.281 L11.736,6.281 L11.881,7.101 C12.090,6.796 12.342,6.563 12.638,6.402 C12.934,6.241 13.277,6.161 13.667,6.161 C14.471,6.161 15.098,6.480 15.547,7.117 C15.995,7.755 16.219,8.595 16.219,9.637 L16.219,9.763 C16.219,10.713 15.996,11.479 15.550,12.062 C15.103,12.646 14.481,12.937 13.685,12.937 ZM14.759,9.633 C14.759,8.967 14.633,8.421 14.382,7.998 C14.130,7.573 13.755,7.361 13.256,7.361 C12.951,7.361 12.691,7.426 12.478,7.557 C12.265,7.688 12.094,7.870 11.965,8.103 L11.965,11.050 C12.094,11.278 12.265,11.454 12.478,11.576 C12.691,11.699 12.955,11.761 13.269,11.761 C13.767,11.761 14.141,11.576 14.388,11.210 C14.635,10.842 14.759,10.359 14.759,9.760 L14.759,9.633 ZM7.684,12.811 L5.580,12.811 L5.580,9.993 L0.146,9.993 L0.094,8.705 L5.510,0.153 L7.684,0.153 L7.684,8.298 L9.283,8.298 L9.283,9.993 L7.684,9.993 L7.684,12.811 ZM5.580,3.161 L5.528,3.143 L5.354,3.517 L2.181,8.298 L5.580,8.298 L5.580,3.161 Z"}));};var LineThicknessIcon5px=function LineThicknessIcon5px(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:23,height:15},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M22.694,12.810 L21.029,12.810 L19.768,10.517 L18.506,12.810 L16.829,12.810 L18.941,9.510 L16.889,6.281 L18.555,6.281 L19.743,8.520 L20.950,6.281 L22.634,6.281 L20.582,9.510 L22.694,12.810 ZM13.685,12.937 C13.315,12.937 12.987,12.871 12.701,12.738 C12.416,12.605 12.170,12.410 11.965,12.153 L11.965,15.321 L10.499,15.321 L10.499,6.281 L11.736,6.281 L11.881,7.102 C12.090,6.796 12.342,6.563 12.638,6.402 C12.934,6.241 13.277,6.161 13.667,6.161 C14.471,6.161 15.098,6.480 15.547,7.117 C15.995,7.755 16.219,8.594 16.219,9.636 L16.219,9.763 C16.219,10.713 15.996,11.479 15.550,12.063 C15.103,12.646 14.481,12.937 13.685,12.937 ZM14.759,9.633 C14.759,8.966 14.633,8.421 14.382,7.997 C14.130,7.574 13.755,7.362 13.256,7.362 C12.951,7.362 12.691,7.427 12.478,7.557 C12.265,7.688 12.094,7.870 11.965,8.103 L11.965,11.049 C12.094,11.278 12.265,11.454 12.478,11.577 C12.691,11.699 12.955,11.760 13.269,11.760 C13.767,11.760 14.141,11.577 14.388,11.209 C14.635,10.842 14.759,10.358 14.759,9.760 L14.759,9.633 ZM5.041,4.500 C6.229,4.488 7.159,4.865 7.831,5.630 C8.504,6.395 8.840,7.441 8.840,8.768 C8.840,10.008 8.486,11.022 7.779,11.811 C7.072,12.599 6.049,12.993 4.710,12.993 C3.598,12.993 2.657,12.687 1.889,12.076 C1.121,11.464 0.752,10.596 0.781,9.472 L0.798,9.429 L2.772,9.359 C2.772,9.971 2.951,10.447 3.311,10.787 C3.670,11.127 4.137,11.298 4.710,11.298 C5.365,11.298 5.865,11.068 6.210,10.606 C6.555,10.146 6.727,9.536 6.727,8.777 C6.727,8.012 6.550,7.390 6.197,6.912 C5.843,6.434 5.339,6.195 4.684,6.195 C4.105,6.195 3.674,6.290 3.393,6.480 C3.112,6.670 2.908,6.943 2.780,7.299 L0.964,7.151 L1.694,0.153 L8.379,0.153 L8.379,1.978 L3.450,1.978 L3.067,5.152 C3.316,4.966 3.605,4.814 3.932,4.695 C4.260,4.576 4.629,4.511 5.041,4.500 Z"}));};var AddIndicatorsIconDots=function AddIndicatorsIconDots(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:19},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M17.593,4.759 C17.184,4.759 16.805,4.647 16.468,4.465 L12.558,8.375 C12.740,8.712 12.852,9.091 12.852,9.500 C12.852,10.819 11.784,11.887 10.465,11.887 C10.049,11.887 9.662,11.770 9.321,11.582 L5.421,15.483 C5.609,15.825 5.725,16.211 5.725,16.628 C5.725,17.946 4.656,19.015 3.338,19.015 C2.020,19.015 0.951,17.946 0.951,16.628 C0.951,15.309 2.020,14.241 3.338,14.241 C3.642,14.241 3.931,14.303 4.198,14.407 L8.245,10.360 C8.141,10.093 8.079,9.804 8.079,9.500 C8.079,8.182 9.147,7.113 10.465,7.113 C10.778,7.113 11.075,7.177 11.348,7.286 L15.379,3.255 C15.270,2.982 15.206,2.685 15.206,2.372 C15.206,1.054 16.275,-0.015 17.593,-0.015 C18.911,-0.015 19.980,1.054 19.980,2.372 C19.980,3.691 18.911,4.759 17.593,4.759 ZM10.465,8.092 C9.688,8.092 9.059,8.721 9.059,9.498 C9.059,10.274 9.688,10.903 10.465,10.903 C11.241,10.903 11.871,10.274 11.871,9.498 C11.871,8.721 11.241,8.092 10.465,8.092 Z"}));};var AddIndicatorsIconArrows=function AddIndicatorsIconArrows(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:21},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M17.418,5.834 L17.418,2.692 L11.684,8.426 C11.865,8.762 11.977,9.140 11.977,9.548 C11.977,10.862 10.911,11.928 9.597,11.928 C9.181,11.928 8.796,11.812 8.456,11.625 L4.568,15.512 C4.756,15.852 4.872,16.237 4.872,16.653 C4.872,17.968 3.806,19.034 2.492,19.034 C1.177,19.034 0.111,17.968 0.111,16.653 C0.111,15.338 1.177,14.273 2.492,14.273 C2.795,14.273 3.083,14.335 3.350,14.438 L7.382,10.406 C7.279,10.139 7.216,9.851 7.216,9.548 C7.216,8.233 8.282,7.168 9.597,7.168 C9.908,7.168 10.204,7.231 10.477,7.340 L16.109,1.708 L13.292,1.708 L13.292,0.060 L19.056,0.060 L19.056,0.071 L19.066,0.071 L19.066,5.834 L17.418,5.834 ZM9.596,8.143 C8.822,8.143 8.194,8.771 8.194,9.546 C8.194,10.320 8.822,10.947 9.596,10.947 C10.370,10.947 10.998,10.320 10.998,9.546 C10.998,8.771 10.370,8.143 9.596,8.143 Z"}));};var AddIndicatorsIcon=function AddIndicatorsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:25,height:7,title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Indecies")},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M24.327,3.756 L15.061,3.756 C14.938,4.167 14.726,4.558 14.401,4.883 C13.354,5.929 11.657,5.929 10.611,4.883 C10.279,4.552 10.065,4.153 9.944,3.732 L0.691,3.732 L0.691,1.907 L10.060,1.907 C10.190,1.612 10.369,1.334 10.611,1.092 C11.657,0.046 13.354,0.046 14.401,1.092 C14.649,1.340 14.834,1.627 14.964,1.930 L24.327,1.930 L24.327,3.756 ZM13.623,1.869 C13.007,1.252 12.007,1.252 11.391,1.869 C10.774,2.485 10.774,3.485 11.391,4.101 C12.007,4.718 13.007,4.718 13.623,4.101 C14.240,3.485 14.240,2.485 13.623,1.869 Z"}));};var IndicatorsIcon=function IndicatorsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:25,height:20},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M21.700,5.345 C21.519,5.345 21.342,5.326 21.172,5.291 L17.230,12.353 C17.580,12.806 17.797,13.367 17.797,13.983 C17.797,15.463 16.597,16.663 15.116,16.663 C13.636,16.663 12.436,15.463 12.436,13.983 C12.436,13.661 12.502,13.356 12.607,13.069 L9.985,10.643 C9.650,10.793 9.281,10.881 8.891,10.881 C8.700,10.881 8.515,10.860 8.336,10.822 L4.849,14.810 C5.203,15.264 5.422,15.829 5.422,16.449 C5.422,17.929 4.222,19.129 2.742,19.129 C1.262,19.129 0.062,17.929 0.062,16.449 C0.062,14.969 1.262,13.769 2.742,13.769 C2.944,13.769 3.139,13.795 3.328,13.837 L6.803,9.863 C6.438,9.405 6.210,8.832 6.210,8.201 C6.210,6.721 7.410,5.521 8.891,5.521 C10.371,5.521 11.571,6.721 11.571,8.201 C11.571,8.621 11.466,9.013 11.293,9.367 L13.783,11.671 C14.177,11.443 14.628,11.303 15.116,11.303 C15.314,11.303 15.505,11.327 15.690,11.368 L19.617,4.332 C19.249,3.873 19.020,3.299 19.020,2.665 C19.020,1.185 20.220,-0.015 21.700,-0.015 C23.180,-0.015 24.380,1.185 24.380,2.665 C24.380,4.145 23.180,5.345 21.700,5.345 ZM2.741,14.868 C1.869,14.868 1.162,15.575 1.162,16.447 C1.162,17.318 1.869,18.025 2.741,18.025 C3.613,18.025 4.320,17.318 4.320,16.447 C4.320,15.575 3.613,14.868 2.741,14.868 ZM8.890,6.620 C8.018,6.620 7.311,7.327 7.311,8.198 C7.311,9.070 8.018,9.777 8.890,9.777 C9.762,9.777 10.468,9.070 10.468,8.198 C10.468,7.327 9.762,6.620 8.890,6.620 ZM15.115,12.402 C14.243,12.402 13.537,13.109 13.537,13.980 C13.537,14.852 14.243,15.559 15.115,15.559 C15.987,15.559 16.694,14.852 16.694,13.980 C16.694,13.109 15.987,12.402 15.115,12.402 ZM21.699,1.083 C20.827,1.083 20.120,1.790 20.120,2.662 C20.120,3.534 20.827,4.241 21.699,4.241 C22.571,4.241 23.278,3.534 23.278,2.662 C23.278,1.790 22.571,1.083 21.699,1.083 Z"}));};var RemoveIndicatorsIcon=function RemoveIndicatorsIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:25,height:20},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M21.700,5.345 C21.402,5.345 21.121,5.285 20.853,5.195 L18.219,7.830 L16.804,6.416 L19.330,3.891 C19.138,3.522 19.020,3.109 19.020,2.665 C19.020,1.185 20.220,-0.015 21.700,-0.015 C23.180,-0.015 24.380,1.185 24.380,2.665 C24.380,4.145 23.180,5.345 21.700,5.345 ZM21.699,1.084 C20.827,1.084 20.121,1.790 20.121,2.662 C20.121,3.534 20.827,4.241 21.699,4.241 C22.571,4.241 23.278,3.534 23.278,2.662 C23.278,1.790 22.571,1.084 21.699,1.084 ZM22.676,8.004 L24.021,9.349 L19.848,13.522 L23.995,17.669 L22.650,19.014 L18.503,14.867 L14.356,19.014 L13.011,17.669 L17.158,13.522 L12.986,9.349 L14.331,8.004 L18.503,12.177 L22.676,8.004 ZM13.136,13.459 L11.721,14.873 L8.724,11.876 C8.352,12.072 7.934,12.194 7.484,12.194 C7.308,12.194 7.136,12.174 6.969,12.142 L4.828,14.786 C5.194,15.244 5.422,15.817 5.422,16.449 C5.422,17.929 4.222,19.130 2.742,19.130 C1.262,19.130 0.062,17.929 0.062,16.449 C0.062,14.969 1.262,13.769 2.742,13.769 C2.930,13.769 3.114,13.789 3.291,13.826 L5.417,11.200 C5.040,10.738 4.804,10.156 4.804,9.513 C4.804,8.033 6.004,6.833 7.484,6.833 C8.965,6.833 10.165,8.033 10.165,9.513 C10.165,9.805 10.106,10.081 10.020,10.343 L13.136,13.459 ZM2.741,14.868 C1.869,14.868 1.162,15.575 1.162,16.447 C1.162,17.319 1.869,18.025 2.741,18.025 C3.613,18.025 4.320,17.319 4.320,16.447 C4.320,15.575 3.613,14.868 2.741,14.868 ZM7.483,7.932 C6.612,7.932 5.905,8.639 5.905,9.511 C5.905,10.383 6.612,11.089 7.483,11.089 C8.355,11.089 9.062,10.383 9.062,9.511 C9.062,8.639 8.355,7.932 7.483,7.932 Z"}));};var BackIcon=function BackIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:19},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M19.695,17.931 C17.625,14.684 16.474,12.155 9.005,12.155 L9.005,17.280 L0.639,8.632 L9.005,-0.015 L9.005,5.089 C17.073,5.089 20.530,11.846 19.695,17.931 ZM11.671,7.062 C10.503,6.770 8.991,6.769 7.394,6.769 L7.394,4.256 L2.991,8.659 L7.394,13.063 L7.394,10.355 C9.430,10.355 11.313,10.500 12.709,10.703 C14.927,11.025 16.267,11.712 17.707,12.785 C17.005,10.520 15.205,7.943 11.671,7.062 Z"}));};var DeleteIcon=function DeleteIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:16,height:15},props),props.title&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title",null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M15.021,1.349 L8.848,7.521 L14.995,13.669 L13.650,15.014 L7.503,8.866 L1.356,15.014 L0.011,13.669 L6.158,7.521 L-0.014,1.349 L1.331,0.004 L7.503,6.177 L13.676,0.004 L15.021,1.349 Z"}));};var HideIcon=function HideIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:16,height:16,viewBox:"0 0 24 24"},props),props.title&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title",null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M11.83,9L15,12.16C15,12.11 15,12.05 15,12A3,3 0 0,0 12,9C11.94,9 11.89,9 11.83,9M7.53,9.8L9.08,11.35C9.03,11.56 9,11.77 9,12A3,3 0 0,0 12,15C12.22,15 12.44,14.97 12.65,14.92L14.2,16.47C13.53,16.8 12.79,17 12,17A5,5 0 0,1 7,12C7,11.21 7.2,10.47 7.53,9.8M2,4.27L4.28,6.55L4.73,7C3.08,8.3 1.78,10 1,12C2.73,16.39 7,19.5 12,19.5C13.55,19.5 15.03,19.2 16.38,18.66L16.81,19.08L19.73,22L21,20.73L3.27,3M12,7A5,5 0 0,1 17,12C17,12.64 16.87,13.26 16.64,13.82L19.57,16.75C21.07,15.5 22.27,13.86 23,12C21.27,7.61 17,4.5 12,4.5C10.6,4.5 9.26,4.75 8,5.2L10.17,7.35C10.74,7.13 11.35,7 12,7Z"}));};var AddIcon=function AddIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:18.032,height:18.031},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18.060,8.066 L18.060,9.942 L9.981,9.942 L9.981,18.017 L8.105,18.017 L8.105,9.942 L0.029,9.942 L0.029,8.066 L8.105,8.066 L8.105,-0.013 L9.981,-0.013 L9.981,8.066 L18.060,8.066 Z"}));};var InstrumentIcon=function InstrumentIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:16,height:20},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M9.638,13H8v1H6V13H4.4L2.58,18.012.7,17.328,2.276,13H0V11H3L4.554,6.736A3,3,0,0,1,6,2.171V0H8V2.171A3,3,0,0,1,9.473,6.7L11.039,11H14v2H11.768l1.576,4.328-1.88.684ZM8.91,11,7.78,7.9a3.01,3.01,0,0,1-1.524.01L5.131,11H6V10H8v1ZM7,7a2,2,0,0,0,.437-.048l-.079-.217L8.5,6.318A2,2,0,1,0,5.478,6.3l1.2.439L6.6,6.96A2,2,0,0,0,7,7Z"}));};var TrashIcon=function TrashIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:12,height:14},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-1622.752-2308.6a.673.673,0,0,1-.674-.643l-.45-9.443h8.552l-.45,9.443a.673.673,0,0,1-.675.643Zm4.578-7.741v5.4a.273.273,0,0,0,.274.272h.439a.273.273,0,0,0,.275-.272v-5.4a.274.274,0,0,0-.275-.273h-.439A.274.274,0,0,0-1618.174-2316.344Zm-1.919,0v5.4a.272.272,0,0,0,.274.272h.439a.272.272,0,0,0,.274-.272v-5.4a.273.273,0,0,0-.274-.273h-.439A.273.273,0,0,0-1620.093-2316.344Zm-1.92,0v5.4a.273.273,0,0,0,.274.272h.438a.273.273,0,0,0,.275-.272v-5.4a.274.274,0,0,0-.275-.273h-.438A.274.274,0,0,0-1622.013-2316.344Zm-2.587-3.161v-1.323a.423.423,0,0,1,.424-.422h2.908v-.546a.14.14,0,0,1,.141-.141h3.053a.14.14,0,0,1,.141.141v.546h2.908a.423.423,0,0,1,.424.422v1.323Z",transform:"translate(1624.6 2321.936)"}));};var VisibleIcon=function VisibleIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:16,height:10},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-3279.907-960.1a.568.568,0,0,1,0-.625c.125-.188,2.75-4.687,7.438-4.687s7.313,4.5,7.438,4.688a1.065,1.065,0,0,1,0,.625c-.125.187-2.75,4.687-7.437,4.687S-3279.782-959.918-3279.907-960.1Zm4.313-.313a3.1,3.1,0,0,0,3.126,3.125,3.1,3.1,0,0,0,3.125-3.125,3.1,3.1,0,0,0-3.125-3.125A3.1,3.1,0,0,0-3275.594-960.418Zm1.25,0a1.842,1.842,0,0,1,1.875-1.875,1.842,1.842,0,0,1,1.875,1.875,1.841,1.841,0,0,1-1.875,1.875A1.842,1.842,0,0,1-3274.344-960.418Z",transform:"translate(3280.001 965.417)"}));};var HiddenIcon=function HiddenIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:16,height:12},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-4795.929-2783.979l2.17-2.17a11.322,11.322,0,0,1-3.126-3.28.592.592,0,0,1-.025-.665c.689-1.1,3.259-4.688,7.438-4.688a7.358,7.358,0,0,1,3.467.878l2.1-2.1.707.707-1.923,1.923h0l-1.783,1.783h0l-8.314,8.315Zm3.331-5.8a3.161,3.161,0,0,0,.605,1.866l4.386-4.386a3.158,3.158,0,0,0-1.866-.606A3.093,3.093,0,0,0-4792.6-2789.782Zm.714,4.587,1.571-1.571a3.26,3.26,0,0,0,.84.11,3.092,3.092,0,0,0,3.125-3.125,3.2,3.2,0,0,0-.111-.839l2.135-2.135a11.67,11.67,0,0,1,2.263,2.622,1.012,1.012,0,0,1,.025.665c-.688,1.1-3.256,4.688-7.437,4.688A7.251,7.251,0,0,1-4791.884-2785.2Z",transform:"translate(4797 2796)"}));};var LockIcon=function LockIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:10,height:12,activeColor:theme.accent},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M9.369,5.854H8.7V4.45a3.651,3.651,0,0,0-7.3,0v1.4H.624a.632.632,0,0,0-.632.631v5.876a.632.632,0,0,0,.632.631H9.369A.632.632,0,0,0,10,12.362V6.486a.632.632,0,0,0-.631-.632ZM2.935,4.45a2.118,2.118,0,1,1,4.236,0v1.4H2.935ZM5.741,9.8v1.132a.688.688,0,1,1-1.377,0V9.8a1.109,1.109,0,1,1,1.377,0Z",transform:"translate(0.008 -0.884)"}));});};var LeftAngleBracket=function LeftAngleBracket(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:6,height:10},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"currentColor",d:"M5,.328l4.9,4.9-1.4,1.4L5,3.119l-3.5,3.5L.1,5.219,4.986.328,5,.337Z",transform:"translate(-0.328 9.9) rotate(-90)"}));};var Timer=function Timer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,Object.assign({width:20,height:20},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"currentColor",d:"M-1472-725a10.012,10.012,0,0,1,10-10,10.012,10.012,0,0,1,10,10,10.012,10.012,0,0,1-10,10A10.012,10.012,0,0,1-1472-725Zm2,0a8.008,8.008,0,0,0,8,8,8.008,8.008,0,0,0,8-8,8.008,8.008,0,0,0-8-8A8.008,8.008,0,0,0-1470-725Zm7.5,5h1v1h-1Zm2.566-.419.866-.5.5.867-.866.5Zm-5.5.367.5-.868.866.5-.5.866Zm-2.013-2.379.867-.5.5.866-.866.5Zm9.526.365.5-.866.867.5-.5.865ZM-1468-725.5h1v1h-1Zm6,.5v-6a6,6,0,0,1,6,6Zm-5.445-2.567.5-.867.866.5-.5.866Zm2.012-2.379.866-.5.5.867-.867.5Z",transform:"translate(1472 735)"}));};

/***/ }),
/* 122 */,
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledPopup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradeMobile_Popup__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles__ = __webpack_require__(111);
var _templateObject=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    padding: 64px 16px;\n    background-color: ",";\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    padding: 32px 16px;\n  }\n  \n  @media (max-width: 959px) {\n  ",";\n  }\n \n"],["\n  @media (max-width: 959px) {\n    display: flex;\n    width: 100%;\n    height: 100%;\n    padding: 64px 16px;\n    background-color: ",";\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    padding: 32px 16px;\n  }\n  \n  @media (max-width: 959px) {\n  ",";\n  }\n \n"]),_templateObject2=_taggedTemplateLiteral(["\n      padding:0;\n    "],["\n      padding:0;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function DesktopPopup(_ref){var style=_ref.style,onDismiss=_ref.onDismiss,className=_ref.className,children=_ref.children,big=_ref.big;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["h" /* Overlay */],{style:style},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_ClickOutside__["a" /* default */],{onOutsideClick:onDismiss},function(_ref2){var innerRef=_ref2.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["i" /* Popup */],{big:big,ref:innerRef,className:className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__styles__["a" /* CloseContainer */],{onClick:onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Close__["a" /* default */],null)),children);}));}function StatelessPopup(props){var children=props.children,className=props.className,_props$in=props.in,inProp=_props$in===undefined?true:_props$in,style=props.style,_props$fades=props.fades,fades=_props$fades===undefined?true:_props$fades,onDismiss=props.onDismiss;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?fades===true?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Animations__["a" /* Fade */],{"in":inProp},function(_ref3){var style=_ref3.style;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DesktopPopup,{style:style,className:className,onDismiss:onDismiss,big:props.big},children);}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DesktopPopup,{style:style,className:className,onDismiss:onDismiss},children):inProp===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__TradeMobile_Popup__["a" /* default */],{type:"tournaments",onClick:onDismiss,title:null,className:className,nowrap:props.nowrap,mobileColumn:props.mobileColumn,big:props.big},children);});}var Popup=Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(StatelessPopup);/* harmony default export */ __webpack_exports__["b"] = (Popup);var StyledPopup=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Popup)(_templateObject,function(_ref4){var theme=_ref4.theme;return theme.mainDark;},function(_ref5){var full=_ref5.full;return full&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2);});

/***/ }),
/* 124 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 125 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(496);
var enumBugKeys = __webpack_require__(327);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(85);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(15);
var dPs = __webpack_require__(497);
var enumBugKeys = __webpack_require__(327);
var IE_PROTO = __webpack_require__(326)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(324)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(328).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(496);
var hiddenKeys = __webpack_require__(327).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var dP = __webpack_require__(34);
var DESCRIPTORS = __webpack_require__(33);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(73);
var call = __webpack_require__(508);
var isArrayIter = __webpack_require__(340);
var anObject = __webpack_require__(15);
var toLength = __webpack_require__(35);
var getIterFn = __webpack_require__(342);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(60);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(1135),
    getValue = __webpack_require__(1140);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(157),
    getRawTag = __webpack_require__(1136),
    objectToString = __webpack_require__(1137);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(187);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(116);
var createDesc = __webpack_require__(261);
module.exports = __webpack_require__(118) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(606);
var defined = __webpack_require__(383);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return warning; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var HEY_LISTEN = 'Hey, listen! ';
var warning = function () { };
var invariant = function () { };
if (false) {
    warning = function (check, message) {
        if (!check && typeof console !== 'undefined') {
            console.warn(HEY_LISTEN + message);
        }
    };
    invariant = function (check, message) {
        if (!check) {
            throw new Error(HEY_LISTEN.toUpperCase() + message);
        }
    };
}




/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(653);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
var array = Array.prototype;

var map = array.map;
var slice = array.slice;


/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function constant() {
    return x;
  };
});


/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loglevel__ = __webpack_require__(2049);
/* unused harmony reexport LogLevel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__severity__ = __webpack_require__(2050);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__severity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__status__ = __webpack_require__(2051);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__status__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isProfileComplete;
/* harmony export (immutable) */ __webpack_exports__["a"] = Private;
/* unused harmony export Public */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spinners_BrandSpinner__ = __webpack_require__(98);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function isProfileComplete(profile){return profile!=null&&profile.currency!=null&&profile.currency!==""&&profile.email!=null&&profile.email!==""&&(profile.sub0==="ml_01en_2"||profile.phone!=null);}function mapStateToProps(state){var s=state.dataRequirementsStatus;var p=state.profile;return{isAvailable:["profile","serverData","settings"].every(function(key){return s[key]==="AVAILABLE"||state[key]!==null;}),isInvalid:s.profile==="INVALID",profile:p};}function Private(WrappedComponent){var stock=void 0;function C(_ref){var isAvailable=_ref.isAvailable,isInvalid=_ref.isInvalid,profile=_ref.profile,props=_objectWithoutProperties(_ref,["isAvailable","isInvalid","profile"]);if(isAvailable){if(isProfileComplete(profile)){if(props.stock){stock=props.stock;}var _C=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent,Object.assign({},props,{stock:stock}));stock=null;return _C;}else{stock=props.stock;var urlParams=window.location.search||"";var to= false?"/login":"/";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{to:""+to+urlParams});}}else if(isInvalid){stock=props.stock;var _urlParams=window.location.search||"";var pathname=window.location.pathname+_urlParams;if(pathname){if(_urlParams){_urlParams+="&redirect="+encodeURIComponent(pathname);}else{_urlParams="?redirect="+encodeURIComponent(pathname);}}var _to= false?"/login":"/";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{to:""+_to+_urlParams});}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Spinners_BrandSpinner__["a" /* default */],null);}}C.displayName="Private("+(WrappedComponent.displayName||WrappedComponent.name)+")";return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C,WrappedComponent));}function Public(WrappedComponent){function C(_ref2){var isAvailable=_ref2.isAvailable,isInvalid=_ref2.isInvalid,props=_objectWithoutProperties(_ref2,["isAvailable","isInvalid"]);if(isAvailable){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent,props);}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Spinners_BrandSpinner__["a" /* default */],null);}}C.displayName="Private("+(WrappedComponent.displayName||WrappedComponent.name)+")";return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C,WrappedComponent));}

/***/ }),
/* 147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return VerifiedIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UnverifiedIcon; });
/* unused harmony export WarningIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PendingIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PhoneIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MailIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return InfoIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TimeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TimeIconUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TimeIconDown; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TimefaceIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-left: ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n  margin-left: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 5px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  margin-top: -2px;\n  margin-right: 0px;\n"],["\n  position: relative;\n  margin-top: -2px;\n  margin-right: 0px;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,function(props){return props.theme.direction==="rtl"?"5px":0;});var IconSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject2);var PopupIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(IconSvg)(_templateObject3);var VerifiedIcon=function VerifiedIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:{margin:0,verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"16.094",height:"16.125",viewBox:"0 0 16.094 16.125",fill:"#3B9478",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm4.621,6.053-4.318,4.318,0.013,0.013-1.305,1.306-3.3-3.3,1.305-1.306,1.978,1.978,4.317-4.318Z",transform:"translate(-241.969 -378.938)"})));};var UnverifiedIcon=function UnverifiedIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:{margin:0,verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"16.094",height:"16.125",viewBox:"0 0 16.094 16.125",fill:"#e74c3c",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm0.982,12.027h-2.006V389h2.006v1.975Zm-1.985-7.969h2v4.956h-2.017Z",transform:"translate(-241.969 -378.938)"})));};var WarningIcon=function WarningIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:{margin:0,verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"16",viewBox:"0 0 18 16",fill:props.color||"#d05353",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-400.999 -569.95)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M17.7,42.525,10.62,30.759A2.1,2.1,0,0,0,7,30.768L.3,42.52a2.121,2.121,0,0,0,1.812,3.209H15.886A2.121,2.121,0,0,0,17.7,42.525ZM8.811,43.607a1.061,1.061,0,1,1,1.055-1.061A1.059,1.059,0,0,1,8.811,43.607ZM9.88,38.3a1.071,1.071,0,0,1-1.069,1.061A1.053,1.053,0,0,1,7.764,38.3V34.061A1.053,1.053,0,0,1,8.811,33,1.071,1.071,0,0,1,9.88,34.061Z",transform:"translate(400.999 540.221)"}))));};var PendingIcon=function PendingIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{style:{margin:0,verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"16.094",height:"16.125",viewBox:"0 0 16.094 16.125",fill:"#e7d23c",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm0.982,12.027h-2.006V389h2.006v1.975Zm-1.985-7.969h2v4.956h-2.017Z",transform:"translate(-241.969 -378.938)"})));};var PhoneIcon=function PhoneIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopupIcon,{xmlns:"http://www.w3.org/2000/svg",width:"19",height:"19",viewBox:"0 0 19 19",fill:"#cccccc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0.8,11.663l6.4,6.4a1.055,1.055,0,0,0,1.492,0l9.569-9.569a1.055,1.055,0,0,0,0-1.492l-6.4-6.4a1.055,1.055,0,0,0-1.492,0L0.8,10.17A1.055,1.055,0,0,0,.8,11.663Zm4.169,2.206a0.664,0.664,0,1,1,.939,0A0.664,0.664,0,0,1,4.968,13.869ZM10.685,2.69a0.29,0.29,0,0,1,.411,0l5.075,5.076a0.29,0.29,0,0,1,0,.411L9.9,14.45a0.29,0.29,0,0,1-.411,0L4.411,9.375a0.291,0.291,0,0,1,0-.411L10.685,2.69h0Z"}));};var MailIcon=function MailIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopupIcon,{xmlns:"http://www.w3.org/2000/svg",width:"19",height:"14",viewBox:"0 0 19 14",fill:"#cccccc"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M17.7,0.491H1.313a0.819,0.819,0,0,0-.819.819V13.187a0.819,0.819,0,0,0,.819.819H17.7a0.819,0.819,0,0,0,.819-0.819V1.31A0.819,0.819,0,0,0,17.7.491ZM2.133,3.1L6.891,7.228,2.133,11.352V3.1ZM9.507,7.327l-6-5.2h12ZM8.139,8.31L8.971,9.03a0.819,0.819,0,0,0,1.073,0l0.831-.72,4.684,4.057H3.455Zm3.985-1.082L16.882,3.1v8.248Z"}));};var InfoIcon=function InfoIcon(_ref){var fill=_ref.fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"18",viewBox:"0 0 18 18",fill:fill||"#b5b5b5",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M247.01,200.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,247.01,200.952Zm-1,4.038h2.006v1.975h-2.006V204.99Zm2.978,7.969H245v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z",transform:"translate(-238.016 -200)"}));};var DateIcon=function DateIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,{xmlns:"http://www.w3.org/2000/svg",width:"21",height:"20",viewBox:"0 0 21 20",fill:"#a5a4a4",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M609.988,389h3v2.967h-3V389Zm13.018-5.97V381h-2v2.027h-9.02V381h-1.97v2.027H606V401h21.014V383.025h-4.008Zm2,15.932H608V384.972h2.017v1.015h1.97v-1.015h9.02v1.015h2v-1.015h2v13.985ZM619.988,389h3v2.967h-3V389Zm-5,0h3v2.967h-3V389Zm-5,5h3v2.967h-3V394Zm10,0h3v2.967h-3V394Zm-5,0h3v2.967h-3V394Z",transform:"translate(-606 -381)"}));};var TimeIcon=function TimeIcon(_ref2){var onUp=_ref2.onUp,onDown=_ref2.onDown,props=_objectWithoutProperties(_ref2,["onUp","onDown"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"21",height:"20",viewBox:"0 0 21 20",fill:"#717171",fillRule:"evenodd"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M616.008,465.952l-4.037-5.012h8.075l-4.038,5.012",transform:"translate(-606 -444.938)",onClick:function onClick(){return typeof onDown==="function"&&onDown();}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M616.008,444.923l-4.037,5.012h8.075l-4.038-5.012",transform:"translate(-606 -444.938)",onClick:function onClick(){return typeof onUp==="function"&&onUp();}}));};var TimeIconUp=function TimeIconUp(_ref3){var onClick=_ref3.onClick,props=_objectWithoutProperties(_ref3,["onClick"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"21",height:"15",viewBox:"0 -5 21 15",fill:"#717171",fillRule:"evenodd"},props,{onClick:onClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M616.008,444.923l-4.037,5.012h8.075l-4.038-5.012",transform:"translate(-606 -444.938)"}));};var TimeIconDown=function TimeIconDown(_ref4){var onClick=_ref4.onClick,props=_objectWithoutProperties(_ref4,["onClick"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"21",height:"15",viewBox:"0 10 21 15",fill:"#717171",fillRule:"evenodd"},props,{onClick:onClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M616.008,465.952l-4.037-5.012h8.075l-4.038,5.012",transform:"translate(-606 -444.938)"}));};var TimefaceIcon=function TimefaceIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconSvg,{xmlns:"http://www.w3.org/2000/svg",width:"20.031",height:"20.031",viewBox:"0 0 20.031 20.031",fill:"#a5a4a4",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M287.977,546.042A8.019,8.019,0,1,1,296,538.023a8.042,8.042,0,0,1-8.018,8.019m0-18.042A10.024,10.024,0,1,0,298,538.023,10.053,10.053,0,0,0,287.977,528m0.5,5.012h-1.5v6.014l5.212,3.207,0.8-1.3-4.51-2.706v-5.212",transform:"translate(-277.969 -528)"}));};

/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mapStateToTime; });
/* harmony export (immutable) */ __webpack_exports__["d"] = timer;
/* harmony export (immutable) */ __webpack_exports__["c"] = percentage;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RadialTimer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  transition: stroke-dashoffset 0.15s linear;\n"],["\n  transition: stroke-dashoffset 0.15s linear;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function zero(value){if(typeof value!=="number"){return value;}return value<10?"0"+value:value;}var mapStateToTime=function mapStateToTime(state){return{time:state.time||Date.now()};};function timer(props){var start=props.unix?__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(props.start):__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.start);var end=props.unix?__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(props.end):__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.end);var duration=__WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(end.diff(start));if(!duration){return"00:00:00";}var days=duration.days()>0?duration.days()+"d ":"";var hours=zero(Math.max(0,duration.hours()));var minutes=zero(Math.max(0,duration.minutes()));var seconds=zero(Math.max(0,duration.seconds()));var timer=""+days+hours+":"+minutes+":"+seconds;return timer;}function percentage(partial,total,props){var percentage=100*partial/total;return props.direction==="from"?percentage:100-percentage;}var ProgressCircle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].circle(_templateObject);function determineOffset(_ref){var radius=_ref.radius,progress=_ref.progress;var strokeDasharray=Math.round(Math.PI*(radius*2));// = длина окружности
// оффсет не округляем, а обрезаем все дробные кусочки,
// чтобы не показывать заполненный на 100% круг раньше времени
var strokeDashoffset=Math.trunc((100-progress)/100*strokeDasharray);return{strokeDasharray:strokeDasharray,strokeDashoffset:strokeDashoffset};}var RadialTimer=function RadialTimer(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?100:_ref2$width,_ref2$strokeWidth=_ref2.strokeWidth,strokeWidth=_ref2$strokeWidth===undefined?4:_ref2$strokeWidth,props=_objectWithoutProperties(_ref2,["width","strokeWidth"]);var center=width/2;var radius=(width-strokeWidth)/2;var _determineOffset=determineOffset({radius:radius,progress:props.progress||0}),strokeDasharray=_determineOffset.strokeDasharray,strokeDashoffset=_determineOffset.strokeDashoffset;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{viewBox:"0 0 "+width+" "+width,width:width+"px",className:props.className},props.full!=null&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",Object.assign({r:radius,cx:center,cy:center,strokeWidth:strokeWidth,fill:"none"},props.full)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProgressCircle,{r:radius,cx:center,cy:center,fill:"none",stroke:props.stroke||theme.accent// нам нужно повернуть этот круг, чтобы точка отсчета была сверху;
// для этого мы должны дать координаты точки поворота. Считаем мы
// от центра - значит, x и y должны совпадать с x и y центра
,transform:"rotate(-90 "+center+" "+center+")",strokeWidth:strokeWidth,strokeDasharray:strokeDasharray,strokeDashoffset:strokeDashoffset}));});};

/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Buttons_FlatButton__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_crashLog__ = __webpack_require__(376);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  margin: 20px auto;\n  text-align: center;\n  max-width: 800px;\n"],["\n  margin: 20px auto;\n  text-align: center;\n  max-width: 800px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"],["\n  display: flex;\n  justify-content: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin: 0 5px;\n"],["\n  margin: 0 5px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  margin-bottom: 10px;\n"],["\n  margin-bottom: 10px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  padding: 20px 0;\n"],["\n  padding: 20px 0;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  font-weight: 700;\n  text-align: left;\n"],["\n  margin-bottom: 10px;\n  font-weight: 700;\n  text-align: left;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  text-align: left;\n  margin-bottom: 10px;\n"],["\n  text-align: left;\n  margin-bottom: 10px;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  text-align: left;\n  font-size: 12px;\n  line-height: 1.2;\n  font-family: monospace;\n  background-color: #eee;\n  padding: 10px;\n"],["\n  text-align: left;\n  font-size: 12px;\n  line-height: 1.2;\n  font-family: monospace;\n  background-color: #eee;\n  padding: 10px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ErrorWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Buttons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var ErrorText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var ErrorMessage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var ErrorMessageName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var ErrorMessageText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var ErrorMessageStack=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].pre(_templateObject8);var withErrorCatch=function withErrorCatch(Component){var ErrorBoundary=function(_React$Component){_inherits(ErrorBoundary,_React$Component);function ErrorBoundary(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ErrorBoundary);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ErrorBoundary.__proto__||Object.getPrototypeOf(ErrorBoundary)).call.apply(_ref,[this].concat(args))),_this),_this.state={error:null,info:null,showError:false},_this.toggleShow=function(){_this.setState(function(prevState){return{showError:!prevState.showError};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ErrorBoundary,[{key:"componentDidCatch",value:function componentDidCatch(error,info){this.setState({error:error,info:info});this.props.crashLog({error:{message:error.name+" "+error.message,info:{url:document.location.href,stack:error.stack}}});}},{key:"render",value:function render(){if(this.state.error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"We're sorry, an error has occurred.")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Buttons,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Buttons_FlatButton__["a" /* default */],{onClick:this.toggleShow},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"More"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Buttons_FlatButton__["a" /* default */],{onClick:function onClick(){window.location.reload();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Refresh")))),this.state.showError&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorMessage,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorMessageName,null,this.state.error.name),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorMessageText,null,this.state.error.message),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorMessageStack,null,this.state.error.stack)));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,this.props);}}]);return ErrorBoundary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_4__common_crashLog__["a" /* default */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorBoundary,props);});};/* harmony default export */ __webpack_exports__["a"] = (withErrorCatch);

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(356);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_index__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tour__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: 100%;\n  transform: translate3d(0, 0, 0);\n  overflow: auto;\n  background-color: ",";\n  color: white;\n  z-index: ",";\n\n  ",";\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  max-height: 100%;\n  transform: translate3d(0, 0, 0);\n  overflow: auto;\n  background-color: ",";\n  color: white;\n  z-index: ",";\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      @media (min-width: 960px) {\n        top: 50%;\n        left: 50%;\n        right: auto;\n        bottom: auto;\n        transform: translateX(-50%) translateY(-50%);\n        border: 2px solid #ededed;\n      }\n    "],["\n      @media (min-width: 960px) {\n        top: 50%;\n        left: 50%;\n        right: auto;\n        bottom: auto;\n        transform: translateX(-50%) translateY(-50%);\n        border: 2px solid #ededed;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 45px;\n  padding: 0 15px;\n  padding-right: 60px;\n  background-color: ",";\n  border-bottom: ",";\n"],["\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 45px;\n  padding: 0 15px;\n  padding-right: 60px;\n  background-color: ",";\n  border-bottom: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: 16px;\n  line-height: 1;\n  color: ",";\n"],["\n  font-size: 16px;\n  line-height: 1;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  width: 22px;\n  height: 21px;\n  color: #99959d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: absolute;\n  top: 12px;\n  right: 15px;\n  width: 22px;\n  height: 21px;\n  color: #99959d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n\n  ",";\n\n  ",";\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n\n  ",";\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n          @media (orientation: portrait) {\n            min-height: 100%;\n          }\n        "],["\n          @media (orientation: portrait) {\n            min-height: 100%;\n          }\n        "]),_templateObject9=_taggedTemplateLiteral(["\n          height: 100%;\n          max-height: calc(100% - 45px);\n        "],["\n          height: 100%;\n          max-height: calc(100% - 45px);\n        "]),_templateObject10=_taggedTemplateLiteral(["\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    "],["\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  ",";\n\n  ",";\n"],["\n  ",";\n\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n      max-height: 100%;\n    "],["\n      max-height: 100%;\n    "]),_templateObject13=_taggedTemplateLiteral(["\n      align-content: center;\n      align-items: center;\n      height: auto;\n      max-height: none;\n      min-height: 100%;\n    "],["\n      align-content: center;\n      align-items: center;\n      height: auto;\n      max-height: none;\n      min-height: 100%;\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Flex=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var Container=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject2,function(_ref){var darkMode=_ref.darkMode,theme=_ref.theme;return darkMode?theme.popupDarkBackground:theme.toggleAccountDarkBg;},function(_ref2){var tour=_ref2.tour;return tour?"auto":"100000";},function(_ref3){var isCompensation=_ref3.isCompensation;return isCompensation&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject3);});var Header=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject4,function(_ref4){var darkMode=_ref4.darkMode,theme=_ref4.theme;return darkMode?theme.popupDarkBackground:theme.toggleAccountDarkBg;},function(_ref5){var darkMode=_ref5.darkMode,theme=_ref5.theme;return darkMode?"none":"1px solid "+theme.mainSeparator;});var Heading=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].h2(_templateObject5,function(_ref6){var theme=_ref6.theme;return theme.foreground;});var IconContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].i(_templateObject6,function(_ref7){var theme=_ref7.theme;return theme.foreground;});var Inner=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject7,function(props){return props.big?Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8):Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);},function(_ref8){var mobileColumn=_ref8.mobileColumn;return mobileColumn&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);});var TournamentsInner=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Inner)(_templateObject11,function(_ref9){var big=_ref9.big;return!big&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject12);},function(_ref10){var nowrap=_ref10.nowrap;return nowrap&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject13);});function Button(_ref11){var onClick=_ref11.onClick;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icons_index__["a" /* CloseIcon */],{width:"21px",onClick:onClick}));}function CloseButton(_ref12){var onClick=_ref12.onClick;if(typeof onClick==="function"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{onClick:onClick});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Link__["a" /* Link */],{replace:true,to:"/trade"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,null));}var Popup=function(_React$Component){_inherits(Popup,_React$Component);function Popup(){_classCallCheck(this,Popup);return _possibleConstructorReturn(this,(Popup.__proto__||Object.getPrototypeOf(Popup)).apply(this,arguments));}_createClass(Popup,[{key:"componentDidMount",value:function componentDidMount(){if(document.body)document.body.style.overflow="hidden";}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(document.body)document.body.style.overflow="";}},{key:"render",value:function render(){var _props=this.props,title=_props.title,onClick=_props.onClick,children=_props.children,type=_props.type,isTour=_props.isTour,darkMode=_props.darkMode,isCompensation=_props.isCompensation,mobileColumn=_props.mobileColumn;var tour=this.context;switch(type){case"tournaments":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{className:this.props.className,tour:tour},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseButton,{onClick:onClick}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TournamentsInner,{mobileColumn:mobileColumn,nowrap:this.props.nowrap,big:this.props.big},children));default:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{tour:tour,ref:this.props.forwardedRef,darkMode:darkMode,isCompensation:isCompensation},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,{darkMode:darkMode},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,title),!isTour&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseButton,{onClick:onClick})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Inner,{mobileColumn:mobileColumn},children));}}}]);return Popup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Popup.contextType=__WEBPACK_IMPORTED_MODULE_4__Tour__["a" /* TourContext */];/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,Object.assign({},props,{forwardedRef:ref}));}));

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ContainerInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Flex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CalendarContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CalendarInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MobilePeriodInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  font-size: 16px;\n  font-family: Roboto, Arial, sans-serif;\n"],["\n  position: relative;\n  width: 100%;\n  font-size: 16px;\n  font-family: Roboto, Arial, sans-serif;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 33px 10px 0;\n\n  @media (max-width: 959px) {\n    padding-top: 0;\n  }\n"],["\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n  padding: 33px 10px 0;\n\n  @media (max-width: 959px) {\n    padding-top: 0;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"],["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  height: 3.167em;\n  font-size: 30px;\n  line-height: 1;\n\n  @media (max-width: 959px) {\n    height: 2.611em;\n  }\n\n  @media (max-width: 736px) {\n    font-size: 26px;\n  }\n\n  @media (max-width: 640px) {\n    font-size: 24px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 18px;\n  }\n\n  @media (max-width: 414px) {\n    font-size: 26px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: 24px;\n  }\n\n  @media (max-width: 320px) {\n    font-size: 18px;\n  }\n"],["\n  height: 3.167em;\n  font-size: 30px;\n  line-height: 1;\n\n  @media (max-width: 959px) {\n    height: 2.611em;\n  }\n\n  @media (max-width: 736px) {\n    font-size: 26px;\n  }\n\n  @media (max-width: 640px) {\n    font-size: 24px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 18px;\n  }\n\n  @media (max-width: 414px) {\n    font-size: 26px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: 24px;\n  }\n\n  @media (max-width: 320px) {\n    font-size: 18px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n  font-weight: 300;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: center;\n  color: #a5a4a4;\n"],["\n  margin: 0;\n  padding: 0;\n  font-weight: 300;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: center;\n  color: #a5a4a4;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  min-height: 90px;\n  padding: 0 29px;\n  background-color: ",";\n  border-radius: 4px;\n\n  @media (min-width: 960px) and (-ms-high-contrast: none),\n    (-ms-high-contrast: active) {\n    height: 90px;\n  }\n\n  @media (max-width: 959px) {\n    min-height: 73px;\n    padding: 16px 14px 7px;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    justify-content: flex-start;\n    padding-bottom: 14px;\n  }\n"],["\n  min-height: 90px;\n  padding: 0 29px;\n  background-color: ",";\n  border-radius: 4px;\n\n  @media (min-width: 960px) and (-ms-high-contrast: none),\n    (-ms-high-contrast: active) {\n    height: 90px;\n  }\n\n  @media (max-width: 959px) {\n    min-height: 73px;\n    padding: 16px 14px 7px;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    justify-content: flex-start;\n    padding-bottom: 14px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex: 0 1 882px;\n\n  @media (max-width: 959px) {\n    justify-content: space-around;\n    flex: 1 1 auto;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n"],["\n  flex: 0 1 882px;\n\n  @media (max-width: 959px) {\n    justify-content: space-around;\n    flex: 1 1 auto;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  width: 150px;\n  min-height: 39px;\n  margin-left: auto;\n  font-weight: 700;\n  font-size: ",";\n  text-align: center;\n  color: #fff;\n  background-color: #887d96;\n  background: linear-gradient(to bottom, #887d96, #605073);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  :hover {\n    color: #fff;\n    background-color: #605073;\n    background: linear-gradient(to bottom, #605073, #887d96);\n    outline: none;\n  }\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    outline: none;\n  }\n\n  @media (max-width: 959px) {\n    flex: 1 0 auto;\n    width: auto;\n  }\n\n  @media (max-width: 736px) {\n    min-height: 36px;\n    padding: 0 6px;\n  }\n\n  @media (max-width: 640px) {\n    min-height: 32px;\n    font-size: ",";\n  }\n\n  @media (max-width: 414px) {\n    min-height: 36px;\n    padding: 0 4px;\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    min-height: 32px;\n    font-size: ",";\n    margin: 5px auto;\n    flex: 0 0 auto;\n  }\n"],["\n  width: 150px;\n  min-height: 39px;\n  margin-left: auto;\n  font-weight: 700;\n  font-size: ",";\n  text-align: center;\n  color: #fff;\n  background-color: #887d96;\n  background: linear-gradient(to bottom, #887d96, #605073);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  :hover {\n    color: #fff;\n    background-color: #605073;\n    background: linear-gradient(to bottom, #605073, #887d96);\n    outline: none;\n  }\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    outline: none;\n  }\n\n  @media (max-width: 959px) {\n    flex: 1 0 auto;\n    width: auto;\n  }\n\n  @media (max-width: 736px) {\n    min-height: 36px;\n    padding: 0 6px;\n  }\n\n  @media (max-width: 640px) {\n    min-height: 32px;\n    font-size: ",";\n  }\n\n  @media (max-width: 414px) {\n    min-height: 36px;\n    padding: 0 4px;\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    min-height: 32px;\n    font-size: ",";\n    margin: 5px auto;\n    flex: 0 0 auto;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n      color: #ffffff;\n      background: none;\n      border: 2px solid #ffffff;\n\n      :hover {\n        color: #1b546a;\n        background: #ffffff;\n      }\n    "],["\n      color: #ffffff;\n      background: none;\n      border: 2px solid #ffffff;\n\n      :hover {\n        color: #1b546a;\n        background: #ffffff;\n      }\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  direction: ",";\n  ",";\n  font-weight: 400;\n  font-size: ",";\n  color: ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    text-align: left;\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n    margin-right: 0.286em;\n  }\n\n  @media (max-width: 414px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n\n  ",";\n"],["\n  direction: ",";\n  ",";\n  font-weight: 400;\n  font-size: ",";\n  color: ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    text-align: left;\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n    margin-right: 0.286em;\n  }\n\n  @media (max-width: 414px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n      @media (min-width: 960px) {\n        flex-basis: ",";\n        margin-right: 0;\n        padding-bottom: 0.5em;\n      }\n    "],["\n      @media (min-width: 960px) {\n        flex-basis: ",";\n        margin-right: 0;\n        padding-bottom: 0.5em;\n      }\n    "]),_templateObject12=_taggedTemplateLiteral(["\n      @media (max-width: 640px) {\n        margin-right: 0;\n        margin-left: 0.286em;\n      }\n    "],["\n      @media (max-width: 640px) {\n        margin-right: 0;\n        margin-left: 0.286em;\n      }\n    "]),_templateObject13=_taggedTemplateLiteral(["\n  min-height: 51px;\n"],["\n  min-height: 51px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject);var ContainerInner=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject2);var Flex=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject3);var Top=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Flex)(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h1(_templateObject5);var CalendarContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Flex)(_templateObject6,function(_ref){var theme=_ref.theme;return theme.calendarContainerBackground?"rgba(255, 255, 255, 0.05)":"#f6f6f6";});var CalendarInner=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Flex)(_templateObject7);var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].button(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_1__common_styled_mixins__["a" /* fontSize */])(16),function(_ref2){var theme=_ref2.theme;return theme.isHistoryPopup&&theme.mode==="dark"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject9);},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Header=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject10,function(_ref5){var theme=_ref5.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_1__common_styled_mixins__["c" /* rtl */])("margin-right","0.625em"),Object(__WEBPACK_IMPORTED_MODULE_1__common_styled_mixins__["a" /* fontSize */])(16),function(_ref6){var theme=_ref6.theme;return theme.calendarTitle||"#343434";},function(props){return props.headerWidth&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject11,props.headerWidth?props.headerWidth:"auto");},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref8){var theme=_ref8.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject12);});var MobilePeriodInner=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Flex)(_templateObject13);

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(34).f;
var has = __webpack_require__(66);
var TAG = __webpack_require__(28)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var defined = __webpack_require__(84);
var fails = __webpack_require__(20);
var spaces = __webpack_require__(330);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(48);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(54),
    isKey = __webpack_require__(361),
    stringToPath = __webpack_require__(554),
    toString = __webpack_require__(555);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNumberType__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(70);



/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isValidNumber(arg_1, arg_2, arg_3, arg_4) {
  var _sort_out_arguments = Object(__WEBPACK_IMPORTED_MODULE_0__getNumberType__["c" /* sort_out_arguments */])(arg_1, arg_2, arg_3, arg_4),
      input = _sort_out_arguments.input,
      options = _sort_out_arguments.options,
      metadata = _sort_out_arguments.metadata;

  // This is just to support `isValidNumber({})`
  // for cases when `parseNumber()` returns `{}`.


  if (!input.country) {
    return false;
  }

  if (!metadata.hasCountry(input.country)) {
    throw new Error('Unknown country: ' + input.country);
  }

  metadata.country(input.country);

  // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.
  if (metadata.hasTypes()) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__getNumberType__["b" /* default */])(input, options, metadata.metadata) !== undefined;
  }

  // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.
  var national_number = options.v2 ? input.nationalNumber : input.phone;
  return Object(__WEBPACK_IMPORTED_MODULE_1__common__["i" /* matches_entirely */])(national_number, metadata.nationalNumberPattern());
}
//# sourceMappingURL=validate.js.map

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = findPhoneNumbers;
/* harmony export (immutable) */ __webpack_exports__["c"] = searchPhoneNumbers;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneNumberSearch; });
/* harmony export (immutable) */ __webpack_exports__["d"] = sort_out_arguments;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findNumbers_parsePreCandidate__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findNumbers_isValidPreCandidate__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__findNumbers_isValidCandidate__ = __webpack_require__(594);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










// Copy-pasted from `./parse.js`.
var VALID_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_2__common__["c" /* PLUS_CHARS */] + ']{0,1}' + '(?:' + '[' + __WEBPACK_IMPORTED_MODULE_2__common__["e" /* VALID_PUNCTUATION */] + ']*' + '[' + __WEBPACK_IMPORTED_MODULE_2__common__["d" /* VALID_DIGITS */] + ']' + '){3,}' + '[' + __WEBPACK_IMPORTED_MODULE_2__common__["e" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_2__common__["d" /* VALID_DIGITS */] + ']*';

var EXTN_PATTERNS_FOR_PARSING = Object(__WEBPACK_IMPORTED_MODULE_2__common__["g" /* create_extension_pattern */])('parsing');

var WHITESPACE_IN_THE_BEGINNING_PATTERN = new RegExp('^[' + __WEBPACK_IMPORTED_MODULE_2__common__["f" /* WHITESPACE */] + ']+');
var PUNCTUATION_IN_THE_END_PATTERN = new RegExp('[' + __WEBPACK_IMPORTED_MODULE_2__common__["e" /* VALID_PUNCTUATION */] + ']+$');

// // Regular expression for getting opening brackets for a valid number
// // found using `PHONE_NUMBER_START_PATTERN` for prepending those brackets to the number.
// const BEFORE_NUMBER_DIGITS_PUNCTUATION = new RegExp('[' + OPENING_BRACKETS + ']+' + '[' + WHITESPACE + ']*' + '$')

var VALID_PRECEDING_CHARACTER_PATTERN = /[^a-zA-Z0-9]/;

function findPhoneNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	var search = new PhoneNumberSearch(text, options, metadata.metadata);

	var phones = [];

	while (search.hasNext()) {
		phones.push(search.next());
	}

	return phones;
}

/**
 * @return ES6 `for ... of` iterator.
 */
function searchPhoneNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments2 = sort_out_arguments(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments2.text,
	    options = _sort_out_arguments2.options,
	    metadata = _sort_out_arguments2.metadata;

	var search = new PhoneNumberSearch(text, options, metadata.metadata);

	return _defineProperty({}, Symbol.iterator, function () {
		return {
			next: function next() {
				if (search.hasNext()) {
					return {
						done: false,
						value: search.next()
					};
				}
				return {
					done: true
				};
			}
		};
	});
}

/**
 * Extracts a parseable phone number including any opening brackets, etc.
 * @param  {string} text - Input.
 * @return {object} `{ ?number, ?startsAt, ?endsAt }`.
 */
var PhoneNumberSearch = function () {
	function PhoneNumberSearch(text) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var metadata = arguments[2];

		_classCallCheck(this, PhoneNumberSearch);

		this.state = 'NOT_READY';

		this.text = text;
		this.options = options;
		this.metadata = metadata;

		this.regexp = new RegExp(VALID_PHONE_NUMBER +
		// Phone number extensions
		'(?:' + EXTN_PATTERNS_FOR_PARSING + ')?', 'ig');

		// this.searching_from = 0
	}
	// Iteration tristate.


	_createClass(PhoneNumberSearch, [{
		key: 'find',
		value: function find() {
			var matches = this.regexp.exec(this.text);

			if (!matches) {
				return;
			}

			var number = matches[0];
			var startsAt = matches.index;

			number = number.replace(WHITESPACE_IN_THE_BEGINNING_PATTERN, '');
			startsAt += matches[0].length - number.length;
			// Fixes not parsing numbers with whitespace in the end.
			// Also fixes not parsing numbers with opening parentheses in the end.
			// https://github.com/catamphetamine/libphonenumber-js/issues/252
			number = number.replace(PUNCTUATION_IN_THE_END_PATTERN, '');

			number = Object(__WEBPACK_IMPORTED_MODULE_3__findNumbers_parsePreCandidate__["a" /* default */])(number);

			var result = this.parseCandidate(number, startsAt);

			if (result) {
				return result;
			}

			// Tail recursion.
			// Try the next one if this one is not a valid phone number.
			return this.find();
		}
	}, {
		key: 'parseCandidate',
		value: function parseCandidate(number, startsAt) {
			if (!Object(__WEBPACK_IMPORTED_MODULE_4__findNumbers_isValidPreCandidate__["a" /* default */])(number, startsAt, this.text)) {
				return;
			}

			// Don't parse phone numbers which are non-phone numbers
			// due to being part of something else (e.g. a UUID).
			// https://github.com/catamphetamine/libphonenumber-js/issues/213
			// Copy-pasted from Google's `PhoneNumberMatcher.js` (`.parseAndValidate()`).
			if (!Object(__WEBPACK_IMPORTED_MODULE_5__findNumbers_isValidCandidate__["b" /* default */])(number, startsAt, this.text, this.options.extended ? 'POSSIBLE' : 'VALID')) {
				return;
			}

			// // Prepend any opening brackets left behind by the
			// // `PHONE_NUMBER_START_PATTERN` regexp.
			// const text_before_number = text.slice(this.searching_from, startsAt)
			// const full_number_starts_at = text_before_number.search(BEFORE_NUMBER_DIGITS_PUNCTUATION)
			// if (full_number_starts_at >= 0)
			// {
			// 	number   = text_before_number.slice(full_number_starts_at) + number
			// 	startsAt = full_number_starts_at
			// }
			//
			// this.searching_from = matches.lastIndex

			var result = Object(__WEBPACK_IMPORTED_MODULE_0__parse__["a" /* default */])(number, this.options, this.metadata);

			if (!result.phone) {
				return;
			}

			result.startsAt = startsAt;
			result.endsAt = startsAt + number.length;

			return result;
		}
	}, {
		key: 'hasNext',
		value: function hasNext() {
			if (this.state === 'NOT_READY') {
				this.last_match = this.find();

				if (this.last_match) {
					this.state = 'READY';
				} else {
					this.state = 'DONE';
				}
			}

			return this.state === 'READY';
		}
	}, {
		key: 'next',
		value: function next() {
			// Check the state and find the next match as a side-effect if necessary.
			if (!this.hasNext()) {
				throw new Error('No next element');
			}

			// Don't retain that memory any longer than necessary.
			var result = this.last_match;
			this.last_match = null;
			this.state = 'NOT_READY';
			return result;
		}
	}]);

	return PhoneNumberSearch;
}();

function sort_out_arguments(arg_1, arg_2, arg_3, arg_4) {
	var text = void 0;
	var options = void 0;
	var metadata = void 0;

	// If the phone number is passed as a string.
	// `parse('88005553535', ...)`.
	if (typeof arg_1 === 'string') {
		text = arg_1;
	} else throw new TypeError('A text for parsing must be a string.');

	// If "default country" argument is being passed
	// then move it to `options`.
	// `findNumbers('88005553535', 'RU', [options], metadata)`.
	if ((typeof arg_2 === 'undefined' ? 'undefined' : _typeof(arg_2)) !== 'object') {
		if (arg_4) {
			options = _extends({ defaultCountry: arg_2 }, arg_3);
			metadata = arg_4;
		} else {
			options = { defaultCountry: arg_2 };
			metadata = arg_3;
		}
	}
	// No "default country" argument is being passed.
	// Only international phone numbers are passed.
	// `findNumbers('+78005553535', [options], metadata)`.
	else {
			if (arg_3) {
				options = arg_2;
				metadata = arg_3;
			} else {
				metadata = arg_2;
			}
		}

	if (!options) {
		options = {};
	}

	// // Apply default options.
	// if (options)
	// {
	// 	options = { ...default_options, ...options }
	// }
	// else
	// {
	// 	options = default_options
	// }

	return { text: text, options: options, metadata: new __WEBPACK_IMPORTED_MODULE_1__metadata__["a" /* default */](metadata) };
}
//# sourceMappingURL=findPhoneNumbers.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_Index */
/* unused harmony export bpfrpt_proptype_PositionInfo */
/* unused harmony export bpfrpt_proptype_ScrollPosition */
/* unused harmony export bpfrpt_proptype_SizeAndPositionInfo */
/* unused harmony export bpfrpt_proptype_SizeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_Index =  true ? null : {
  index: PropTypes.number.isRequired
};
var bpfrpt_proptype_PositionInfo =  true ? null : {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_ScrollPosition =  true ? null : {
  scrollLeft: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeAndPositionInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired
};
var bpfrpt_proptype_SizeInfo =  true ? null : {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired
};







/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Popup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Wrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TextContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Text; });
/* unused harmony export Container */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LinkContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Link; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Info; });
/* unused harmony export InfoItems */
/* unused harmony export MoneyContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Currency; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_tournament_description_bg_png__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_tournament_description_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_tournament_description_bg_png__);
var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  background-image: url(",");\n  background-color: ",";\n  background-size: cover;\n  overflow: hidden;\n\n  @media (min-width: 960px) {\n    max-width: 691px;\n    padding: 25px 0;\n  }\n\n  @media (max-width: 959px) {\n    padding: 16px 0;\n  }\n"],["\n  width: 100%;\n  background-image: url(",");\n  background-color: ",";\n  background-size: cover;\n  overflow: hidden;\n\n  @media (min-width: 960px) {\n    max-width: 691px;\n    padding: 25px 0;\n  }\n\n  @media (max-width: 959px) {\n    padding: 16px 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    align-content: space-between;\n    justify-content: space-between;\n    flex: 1;\n    height: 100%;\n    overflow: auto;\n  }\n"],["\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    align-content: space-between;\n    justify-content: space-between;\n    flex: 1;\n    height: 100%;\n    overflow: auto;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 16px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  color: ",";\n"],["\n  width: 100%;\n  padding: 0 16px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  color: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"],["\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  flex-shrink: 0;\n  align-self: flex-end;\n"],["\n  flex-shrink: 0;\n  align-self: flex-end;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-top: 0;\n"],["\n  margin-top: 0;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  padding: 14px 32px;\n  margin-bottom: 27px;\n  background-color: ",";\n\n  @media (max-width: 479px) {\n    padding: 14px 20px;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"],["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  padding: 14px 32px;\n  margin-bottom: 27px;\n  background-color: ",";\n\n  @media (max-width: 479px) {\n    padding: 14px 20px;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"],["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  margin: 0 5px;\n  font-size: 14px;\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    font-size: 12px;\n  }\n"],["\n  margin: 0 5px;\n  font-size: 14px;\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    font-size: 12px;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-weight: 700;\n  margin: 0 2px;\n  color: ",";\n"],["\n  font-weight: 700;\n  margin: 0 2px;\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Popup=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Popup__["b" /* default */])(_templateObject,__WEBPACK_IMPORTED_MODULE_4__images_tournament_description_bg_png___default.a,function(_ref){var theme=_ref.theme;return theme.tournamentPopupBgDark;});var Wrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject2);var TextContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject3);var Text=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.lightWhiteForeground;});var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject5);var LinkContainer=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Container)(_templateObject6);var Link=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */])(_templateObject7);var Info=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject8,function(_ref3){var theme=_ref3.theme;return theme.tournamentPopupBgLight;});var InfoItems=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject9);var MoneyContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject10);var Value=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */].Value)(_templateObject11,function(_ref4){var theme=_ref4.theme;return theme.foreground;});var Currency=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */].Symbol)(_templateObject11,function(_ref5){var theme=_ref5.theme;return theme.accent;});

/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLORS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Select__ = __webpack_require__(430);
var COLORS=["#feac00","#00fe83","#00cbfe","#fe00e9","#fe003c","#39ae00","#a100fe","#fe4e00","#afafaf","#ffffff"];var SelectColor=function SelectColor(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Select__["a" /* default */],Object.assign({type:"color",values:COLORS},props));};/* harmony default export */ __webpack_exports__["b"] = (SelectColor);

/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WIDTHS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Select__ = __webpack_require__(430);
var WIDTHS=[1,2,3];var SelectWidth=function SelectWidth(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Select__["a" /* default */],Object.assign({type:"pixels",values:WIDTHS},props));};/* harmony default export */ __webpack_exports__["b"] = (SelectWidth);

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _toCss = __webpack_require__(438);

var _toCss2 = _interopRequireDefault(_toCss);

var _toCssValue = __webpack_require__(282);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StyleRule = function () {
  function StyleRule(key, style, options) {
    _classCallCheck(this, StyleRule);

    this.type = 'style';
    this.isProcessed = false;
    var sheet = options.sheet,
        Renderer = options.Renderer,
        selector = options.selector;

    this.key = key;
    this.options = options;
    this.style = style;
    if (selector) this.selectorText = selector;
    this.renderer = sheet ? sheet.renderer : new Renderer();
  }

  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  _createClass(StyleRule, [{
    key: 'prop',


    /**
     * Get or set a style property.
     */
    value: function prop(name, value) {
      // It's a getter.
      if (value === undefined) return this.style[name];

      // Don't do anything if the value has not changed.
      if (this.style[name] === value) return this;

      value = this.options.jss.plugins.onChangeValue(value, name, this);

      var isEmpty = value == null || value === false;
      var isDefined = name in this.style;

      // Value is empty and wasn't defined before.
      if (isEmpty && !isDefined) return this;

      // We are going to remove this value.
      var remove = isEmpty && isDefined;

      if (remove) delete this.style[name];else this.style[name] = value;

      // Renderable is defined if StyleSheet option `link` is true.
      if (this.renderable) {
        if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, value);
        return this;
      }

      var sheet = this.options.sheet;

      if (sheet && sheet.attached) {
        (0, _warning2['default'])(false, 'Rule is not linked. Missing sheet option "link: true".');
      }
      return this;
    }

    /**
     * Apply rule to an element inline.
     */

  }, {
    key: 'applyTo',
    value: function applyTo(renderable) {
      var json = this.toJSON();
      for (var prop in json) {
        this.renderer.setProperty(renderable, prop, json[prop]);
      }return this;
    }

    /**
     * Returns JSON representation of the rule.
     * Fallbacks are not supported.
     * Useful for inline styles.
     */

  }, {
    key: 'toJSON',
    value: function toJSON() {
      var json = {};
      for (var prop in this.style) {
        var value = this.style[prop];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
      }
      return json;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;
      var opts = link ? _extends({}, options, { allowEmpty: true }) : options;
      return (0, _toCss2['default'])(this.selector, this.style, opts);
    }
  }, {
    key: 'selector',
    set: function set(selector) {
      if (selector === this.selectorText) return;

      this.selectorText = selector;

      if (!this.renderable) return;

      var hasChanged = this.renderer.setSelector(this.renderable, selector);

      // If selector setter is not implemented, rerender the rule.
      if (!hasChanged && this.renderable) {
        var renderable = this.renderer.replaceRule(this.renderable, this);
        if (renderable) this.renderable = renderable;
      }
    }

    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}();

exports['default'] = StyleRule;

/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
});


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = hue;
/* harmony export (immutable) */ __webpack_exports__["b"] = gamma;
/* harmony export (immutable) */ __webpack_exports__["a"] = nogamma;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(737);


function linear(a, d) {
  return function(t) {
    return a + t * d;
  };
}

function exponential(a, b, y) {
  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
    return Math.pow(a + t * b, y);
  };
}

function hue(a, b) {
  var d = b - a;
  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}

function gamma(y) {
  return (y = +y) === 1 ? nogamma : function(a, b) {
    return b - a ? exponential(a, b, y) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
  };
}

function nogamma(a, b) {
  var d = b - a;
  return d ? linear(a, d) : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(isNaN(a) ? b : a);
}


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tournaments_Api__ = __webpack_require__(14);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var ABTest=function ABTest(_ref){var campaign=_ref.campaign,props=_objectWithoutProperties(_ref,["campaign"]);var features=props.api.readEntity("/api/features/list");var show=function show(){if(false){return false;}if(campaign!=null){var currentCampaign=features.value&&features.value.find(function(feature){return feature.name===campaign;});// если кампания активна, то показываем деток
if(currentCampaign){return true;}return false;}// если кампания не указана, то тоже показываем деток
return true;};if(typeof props.children==="function"){return props.children(show);}if(show===false){return null;}return props.children;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__common_fetch__["h" /* withFetch */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ABTest,Object.assign({},props,{api:api}));});}));

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(1123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useBonusTimerStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useBonusTimerApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Timers__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DepositBonus__ = __webpack_require__(1567);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var useBonusTimerStorage=function useBonusTimerStorage(){var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](function(){// проверяем, есть ли запись hideBonusTimer в sessionStorage;
// если да, то по дефолту не показываем ничего,
// потому что юзер уже спрятал напоминалку про бонус
try{var timerView=sessionStorage.getItem("hideBonusTimer");if(timerView!=null){return false;}}catch(e){console.warn("sessionStorage error");}return true;}),_React$useState2=_slicedToArray(_React$useState,2),showTimer=_React$useState2[0],toggleTimer=_React$useState2[1];__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){try{if(showTimer===false){sessionStorage.setItem("hideBonusTimer","true");}}catch(e){console.warn("sessionStorage error");}},[showTimer]);return[showTimer,toggleTimer];};var useBonusTimerApi=function useBonusTimerApi(_ref){var time=_ref.time;var api=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_3__Tournaments_Api__["c" /* default */]);// componentWillUnmount
__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){return function(){api.clearEntities("/api/reg-bonus");};},[]);var features=__WEBPACK_IMPORTED_MODULE_1_idx___default()(api.readEntity("/api/features/list"),function(features){return features.value;});if(!features||!features.find(function(feature){return feature.name==="first_deposit_bonus";})){return null;}var bonus=__WEBPACK_IMPORTED_MODULE_1_idx___default()(api.readEntity("/api/reg-bonus"),function(bonus){return bonus.value;});if(bonus==null){return null;}var expire_time=bonus.expire_time,creation_time=bonus.creation_time,percent=bonus.percent,promo=bonus.promo,status=bonus.status;var currentTime=__WEBPACK_IMPORTED_MODULE_2_moment___default()(time);var creationTime=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(creation_time);var expireTime=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(expire_time);var duration=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(expireTime.diff(currentTime)).asMilliseconds();if(duration<0||status!=="available"){return null;}var ticker=Object(__WEBPACK_IMPORTED_MODULE_4__Timers__["d" /* timer */])({start:currentTime,end:expireTime});var progress=Object(__WEBPACK_IMPORTED_MODULE_5__DepositBonus__["a" /* calcBonusDuration */])({currentTime:currentTime,creationTime:creationTime,expireTime:expireTime});return{percent:percent,promo:promo,status:status,duration:duration,progress:progress,ticker:ticker,expire_time:expire_time};};

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(561),
    baseKeys = __webpack_require__(486),
    isArrayLike = __webpack_require__(318);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CurrencyFlag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flag_icon_css_css_flag_icon_min_css__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_flag_icon_css_css_flag_icon_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_flag_icon_css_css_flag_icon_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_flags_dist_currency_flags_min_css__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_currency_flags_dist_currency_flags_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_currency_flags_dist_currency_flags_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_currency_XAG2_svg__ = __webpack_require__(1272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_currency_XAG2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_currency_XAG2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_currency_XAU2_svg__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_currency_XAU2_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_currency_XAU2_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_currency_BCH_svg__ = __webpack_require__(1274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_currency_BCH_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_currency_BCH_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_currency_BTC_svg__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_currency_BTC_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_currency_BTC_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_currency_ETH_svg__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_currency_ETH_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_currency_ETH_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_currency_LTC_svg__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_currency_LTC_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_currency_LTC_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_world_flag_svg__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_world_flag_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_world_flag_svg__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_5__images_currency_XAG2_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__images_currency_XAU2_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_7__images_currency_BCH_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__images_currency_BTC_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__images_currency_ETH_svg___default.a; });
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__images_currency_LTC_svg___default.a; });
var _templateObject=_taggedTemplateLiteral(["\n  height: ",";\n  ",";\n\n  &.flag-icon-world {\n    background-image: url(",");\n    background-size: ",";\n  }\n\n  &&& {\n    width: 28px;\n  }\n"],["\n  height: ",";\n  ",";\n\n  &.flag-icon-world {\n    background-image: url(",");\n    background-size: ",";\n  }\n\n  &&& {\n    width: 28px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var View=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,function(_ref){var country=_ref.country;return country==="flag-icon-world"?"24px !important":"15px";},Object(__WEBPACK_IMPORTED_MODULE_2__styled_mixins__["c" /* rtl */])("margin-right","6px"),__WEBPACK_IMPORTED_MODULE_11__images_world_flag_svg___default.a,function(_ref2){var country=_ref2.country;return country==="flag-icon-world"?"cover":"contain";});function Flag(props){var country="";switch(props.country){case"en":country="flag-icon-gb";break;case"hi":country="flag-icon-in";break;case"world":country="flag-icon-world";break;default:country="flag-icon-"+props.country;break;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](View,{className:"flag-icon "+country+" "+(props.className||""),country:country});}/* harmony default export */ __webpack_exports__["h"] = (Flag);var CurrencyFlag=function CurrencyFlag(_ref3){var currency=_ref3.currency,className=_ref3.className,style=_ref3.style;var finalClassName="currency-flag currency-flag-"+currency+" "+(className||"");return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{className:finalClassName,style:style});};

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Buttons__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Popups_Error__ = __webpack_require__(661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Buttons_DemoTournamentButton__ = __webpack_require__(1519);
var _templateObject=_taggedTemplateLiteral(["\n  margin: 0 5px;\n  font-size: ",";\n  color: ",";\n  text-shadow: none;\n\n  ",";\n"],["\n  margin: 0 5px;\n  font-size: ",";\n  color: ",";\n  text-shadow: none;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      color: inherit;\n    "],["\n      color: inherit;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  font-size: ",";\n\n  ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  font-size: ",";\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      flex-direction: column;\n\n      "," {\n        margin-top: 5px;\n      }\n    "],["\n      flex-direction: column;\n\n      "," {\n        margin-top: 5px;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  min-height: 37px;\n  padding: 0 14px;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 14px;\n  color: ",";\n  text-align: center;\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  min-height: 37px;\n  padding: 0 14px;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 14px;\n  color: ",";\n  text-align: center;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      font-size: 22px;\n      line-height: 1.2;\n      font-weight: bold;\n      color: ",";\n      text-align: center;\n      text-transform: uppercase;\n    "],["\n      font-size: 22px;\n      line-height: 1.2;\n      font-weight: bold;\n      color: ",";\n      text-align: center;\n      text-transform: uppercase;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  margin-left: 5px;\n  padding: 0;\n  font-weight: inherit;\n  color: currentColor;\n"],["\n  margin-left: 5px;\n  padding: 0;\n  font-weight: inherit;\n  color: currentColor;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Cost=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject,function(props){return props.type==="free"?Object(__WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__["a" /* fontSize */])(16,16):Object(__WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__["a" /* fontSize */])(10,10);},function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#ffffff":theme.indexMajor;},function(_ref2){var isCardButton=_ref2.isCardButton,isTradePageCard=_ref2.isTradePageCard;return(isTradePageCard||isCardButton)&&"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject2);});var ButtonContent=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__["a" /* fontSize */])( true?12:16),function(_ref3){var flat=_ref3.flat;return!flat&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject4,Cost);});var ButtonPlaceholder=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__["a" /* fontSize */])(12),function(_ref4){var theme=_ref4.theme;return theme.tournamentCardPlaceholder;},function(_ref5){var isTradePageCard=_ref5.isTradePageCard;return isTradePageCard&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])("#ffffff",0.44));});var NotAllowedPlaceholder=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject7);function RawBtnSwitcher(_ref6){var api=_ref6.api,_ref6$usePlaceholders=_ref6.usePlaceholders,usePlaceholders=_ref6$usePlaceholders===undefined?false:_ref6$usePlaceholders,_ref6$flat=_ref6.flat,flat=_ref6$flat===undefined?false:_ref6$flat,className=_ref6.className,accounts=_ref6.accounts,_ref6$enabledStock=_ref6.enabledStock,enabledStock=_ref6$enabledStock===undefined?true:_ref6$enabledStock,newStyle=_ref6.newStyle,subtype=_ref6.subtype,props=_objectWithoutProperties(_ref6,["api","usePlaceholders","flat","className","accounts","enabledStock","newStyle","subtype"]);var active_tournament_id=__WEBPACK_IMPORTED_MODULE_1_idx___default()(api.readEntity("/api/tournaments/stats"),function(stats){return stats.value.active_tournament.id;});var realAccount=accounts&&accounts.find(function(account){return account.type==="real";})||null;var active=props.active?props.active:Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["d" /* getActive */])(props);var ButtonComponent=subtype==="demo"&&props.participation_status!==1?__WEBPACK_IMPORTED_MODULE_15__Buttons_DemoTournamentButton__["a" /* default */]:flat?__WEBPACK_IMPORTED_MODULE_8__Buttons__["a" /* FlatButton */]:__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */];var isCardButton=props.isCardButton&&"irontrade"==="irontrade";var isTradePageCard=props.isTradePageCard&&"irontrade"==="irontrade";if(!(props.is_limited&&props.limited_for_money||props.invited||props.subtype==="demo")){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NotAllowedPlaceholder,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Available by invitation only"));}var tournamentType=props.type;if(props.is_limited&&props.invited){tournamentType="free";}if(props.participation_status!==1){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref7){var showModal=_ref7.showModal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonComponent,{invited:props.is_limited&&props.invited,subtype:props.subtype,isCardButton:isCardButton,isTradePageCard:isTradePageCard,color:"green",type:"deposit",withShadow:!flat,className:className,newStyle:newStyle,participation_price:props.participation_price,onClick:function onClick(){if(tournamentType!=="free"){if(realAccount!=null){var balance=realAccount.balance;if(props.participation_price&&balance<props.participation_price){showModal(__WEBPACK_IMPORTED_MODULE_13__Popups_Error__["b" /* NoRealAcc */],{id:props.id});return;}}else{showModal(__WEBPACK_IMPORTED_MODULE_13__Popups_Error__["b" /* NoRealAcc */],{id:props.id});return;}}props.onJoinClick();},forBell:props.forBell},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContent,{flat:flat},props.is_limited&&props.invited?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Use the invitation"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Join")," ",props.is_limited&&props.invited?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cost,{type:tournamentType,isCardButton:isCardButton,isTradePageCard:isTradePageCard},tournamentType==="free"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Free"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__HowMuchInBucks__["a" /* default */],{value:props.participation_price,valueUSD:props.participation_price_usd}))));});}if(props.participation_status===1&&active===true){var current=active_tournament_id===props.id;if(current&&usePlaceholders){if(isTradePageCard){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonPlaceholder,{isTradePageCard:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You Are Trading"));}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonPlaceholder,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You are participating in this tournament"));}}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonComponent,{isCardButton:isCardButton,color:"yellow",themeLightGreen:props.themeLightGreen,type:"trade",disabled:!enabledStock,withShadow:!flat,onClick:current?props.onActiveTradeClick:props.onTradeClick,className:className,newStyle:newStyle,isTradePageCard:isTradePageCard},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Trade"));}if(props.participation_status===1&&active===false){if(usePlaceholders){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonPlaceholder,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"The tournament has not started yet"));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonComponent,{isCardButton:isCardButton,className:className,newStyle:newStyle,onClick:function onClick(){props.onLeaveClick();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Quit"));}return null;}var ButtonSwitcher=Object(__WEBPACK_IMPORTED_MODULE_6__withData__["a" /* default */])({required:["stocks"],optional:["accounts"],spinner:"simple"})(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_11__Timer__["i" /* mapStateToTime */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RawBtnSwitcher,Object.assign({api:api},props,{className:"intercept-noauth"}));});}));/* harmony default export */ __webpack_exports__["a"] = (ButtonSwitcher);

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(1200),
    Map = __webpack_require__(359),
    Promise = __webpack_require__(1201),
    Set = __webpack_require__(549),
    WeakMap = __webpack_require__(570),
    baseGetTag = __webpack_require__(135),
    toSource = __webpack_require__(545);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolate", function() { return __WEBPACK_IMPORTED_MODULE_0__value__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateArray", function() { return __WEBPACK_IMPORTED_MODULE_1__array__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basis__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasis", function() { return __WEBPACK_IMPORTED_MODULE_2__basis__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__basisClosed__ = __webpack_require__(736);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_3__basisClosed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__date__ = __webpack_require__(739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDate", function() { return __WEBPACK_IMPORTED_MODULE_4__date__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__discrete__ = __webpack_require__(1899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateDiscrete", function() { return __WEBPACK_IMPORTED_MODULE_5__discrete__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hue__ = __webpack_require__(1900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHue", function() { return __WEBPACK_IMPORTED_MODULE_6__hue__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__number__ = __webpack_require__(287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateNumber", function() { return __WEBPACK_IMPORTED_MODULE_7__number__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__object__ = __webpack_require__(740);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateObject", function() { return __WEBPACK_IMPORTED_MODULE_8__object__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__round__ = __webpack_require__(1901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRound", function() { return __WEBPACK_IMPORTED_MODULE_9__round__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__string__ = __webpack_require__(741);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateString", function() { return __WEBPACK_IMPORTED_MODULE_10__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transform_index__ = __webpack_require__(1902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformCss", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateTransformSvg", function() { return __WEBPACK_IMPORTED_MODULE_11__transform_index__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zoom__ = __webpack_require__(1905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateZoom", function() { return __WEBPACK_IMPORTED_MODULE_12__zoom__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rgb__ = __webpack_require__(735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgb", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasis", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateRgbBasisClosed", function() { return __WEBPACK_IMPORTED_MODULE_13__rgb__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hsl__ = __webpack_require__(1906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHsl", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHslLong", function() { return __WEBPACK_IMPORTED_MODULE_14__hsl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__lab__ = __webpack_require__(1907);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateLab", function() { return __WEBPACK_IMPORTED_MODULE_15__lab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hcl__ = __webpack_require__(1908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHcl", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateHclLong", function() { return __WEBPACK_IMPORTED_MODULE_16__hcl__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__cubehelix__ = __webpack_require__(1909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelix", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "interpolateCubehelixLong", function() { return __WEBPACK_IMPORTED_MODULE_17__cubehelix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__piecewise__ = __webpack_require__(1910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "piecewise", function() { return __WEBPACK_IMPORTED_MODULE_18__piecewise__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__quantize__ = __webpack_require__(1911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "quantize", function() { return __WEBPACK_IMPORTED_MODULE_19__quantize__["a"]; });






















/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useServerTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useCompensations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Modal__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tournaments_Api__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var useInterval=function useInterval(callback,delay){var savedCallback=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();// Remember the latest callback.
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){savedCallback.current=callback;},[callback]);// Set up the interval.
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){function tick(){savedCallback.current();}if(delay!==null){var id=setInterval(tick,delay);return function(){return clearInterval(id);};}},[delay]);};var useServerTime=function useServerTime(deps){var _useReducer=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useReducer"])(function(state,_ref){var _ref2=_slicedToArray(_ref,2),type=_ref2[0],payload=_ref2[1];switch(type){case"receiveTime":return{time:payload,count:0};case"tick":return{time:state.time,count:state.count+1};default:return{time:Date.now(),count:0};}},{time:Date.now(),count:0}),_useReducer2=_slicedToArray(_useReducer,2),state=_useReducer2[0],dispatch=_useReducer2[1];useInterval(function(){dispatch(["tick"]);},1000);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_1__common_fetch__["d" /* get */])("/api/server-time").then(function(data){dispatch(["receiveTime",parseInt(data.time,10)]);});},deps);return state.time+state.count;};var useCompensations=function useCompensations(deps){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),compensations=_useState2[0],setCompensations=_useState2[1];var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_5__Tournaments_Api__["c" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){api.fetchEntity("/api/compensations/info").then(function(data){return setCompensations(data.value);});},deps);return compensations;};var chooseDealToCompensate=function chooseDealToCompensate(deals,compensationsData,currentTime,onCompensation,accountType){var compensations=compensationsData&&compensationsData[accountType];if(deals.length===0||compensations==null||compensations.items&&compensations.items.length===0){return null;}for(var i=0;i<deals.length;i++){var currentDeal=deals[i];var compensateCountdown=currentDeal.can_compensate_countdown||57;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=compensations.items[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var compensation=_step.value;if(currentDeal.close_time>currentTime-compensateCountdown&&compensation.available>0&&compensation.amount_limit>=Math.abs(currentDeal.profit)){return currentDeal;}else if(currentDeal.close_time<=currentTime-compensateCountdown){onCompensation(currentDeal);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}return null;};function sleep(ms){return new Promise(function(resolve){setTimeout(resolve,ms);});}var Protection=function Protection(props){var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("Compensate"),_useState4=_slicedToArray(_useState3,2),screen=_useState4[0],setScreen=_useState4[1];// "Compensate" | "Congratulations"
var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState6=_slicedToArray(_useState5,2),info=_useState6[0],setInfo=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),loading=_useState8[0],setLoading=_useState8[1];var compensations=useCompensations([props.dealsToCompensate,props.compensationUpdated,props.compensationCreated]);var accountType=props.activeAccount.type;var currentTime=useServerTime([props.dealsToCompensate]);// если в сокет прилетело сообщение о создании компенсации,
// то показываем попап о начислении компенсаций
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(props.compensationCreated!=null){setInfo(false);setScreen("Refill");}},[props.compensationCreated]);var deal=chooseDealToCompensate(props.dealsToCompensate,compensations,currentTime,props.onCompensation,accountType);var handleCompensation=function handleCompensation(){if(deal!=null){setLoading(true);props.fetch("/api/compensate/?op_id="+deal.id).then(function(){Object(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaReducer */])("DEAL_COMPENSATED",{amount:Math.abs(deal.profit)});return sleep(1000);}).then(function(){setLoading(false);setScreen("Congratulations");props.onCompensation(deal);}).catch(function(err){setLoading(false);props.onCompensation(deal);console.error("#",err);});}};var handleDismissCompensation=function handleDismissCompensation(){props.onCompensation(deal);};var handleDismissCongratulations=function handleDismissCongratulations(){setScreen("Compensate");};var handleRefillCompensations=function handleRefillCompensations(){setInfo(false);setScreen("Compensate");};var handleDetails=function handleDetails(){setInfo(true);setScreen("Refill");};var compensateCountdown=deal!=null&&deal.can_compensate_countdown||57;// Попап виден, если мы поздравляем клиента с успехом, или если ему есть чего
// компенсировать.
switch(screen){case"Compensate":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Modal__["a" /* Modal */],{mode:deal!=null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* default */],{deal:deal,time:deal!=null&&compensateCountdown-(currentTime-deal.close_time),onCompensation:handleCompensation,onDismiss:handleDismissCompensation,loading:loading,popupType:"compensate",compensations:compensations,isDesktop:props.isDesktop,disableOutside:true,compensateCountdown:compensateCountdown,activeAccount:props.activeAccount}));case"Congratulations":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Modal__["a" /* Modal */],{mode:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* default */],{onDismiss:handleDismissCongratulations,onCompensation:handleCompensation,onDetails:handleDetails,popupType:"success",compensations:compensations,isDesktop:props.isDesktop,disableOutside:false,activeAccount:props.activeAccount}));case"Refill":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Modal__["a" /* Modal */],{mode:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* default */],{onDismiss:handleRefillCompensations,onCompensation:handleCompensation,compensationCreated:props.compensationCreated,onCompensationCreated:props.onCompensationCreated,popupType:"refill",compensations:compensations,isDesktop:props.isDesktop,disableOutside:false,isInfo:info,activeAccount:props.activeAccount}));default:return null;}};/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(Object(__WEBPACK_IMPORTED_MODULE_1__common_fetch__["h" /* withFetch */])(Protection)));

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = __webpack_require__(1465);

var _CSSTransition2 = _interopRequireDefault(_CSSTransition);

var _ReplaceTransition = __webpack_require__(1466);

var _ReplaceTransition2 = _interopRequireDefault(_ReplaceTransition);

var _TransitionGroup = __webpack_require__(659);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _Transition = __webpack_require__(657);

var _Transition2 = _interopRequireDefault(_Transition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition2.default,
  TransitionGroup: _TransitionGroup2.default,
  ReplaceTransition: _ReplaceTransition2.default,
  CSSTransition: _CSSTransition2.default
};

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InfoIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GiftIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdviceIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return HotIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.3s ease;\n  fill: #99959d;\n  fill-rule: evenodd;\n"],["\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n  transition: all 0.3s ease;\n  fill: #99959d;\n  fill-rule: evenodd;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);//Основные иконки
var InfoIcon=function InfoIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"18",viewBox:"0 0 18 18"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z",transform:"translate(-933.016 -299)"}));};var GiftIcon=function GiftIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18.002",height:"18.002",viewBox:"0 0 18.002 18.002"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M21970,22216h-14v-7h-1v-7h3.5a2.475,2.475,0,0,1-.5-1.5,2.508,2.508,0,0,1,2.5-2.5h2a2.492,2.492,0,0,0,3,0h2a2.5,2.5,0,0,1,2,4h3.5v7h-1v7Zm0-2v-5h-5v5Zm-7,0v-5h-5v5Zm8-7v-3h-14v3Zm-6-6.5v.5h2.5a.5.5,0,0,0,.5-.5.508.508,0,0,0-.5-.5h-2A.508.508,0,0,0,21965,22200.5Zm-5,0a.5.5,0,0,0,.5.5h2.5v-.5c0-.021,0-.043,0-.064a.51.51,0,0,0-.5-.437h-2A.508.508,0,0,0,21960,22200.5Z",transform:"translate(-21954.998 -22198.002)",fill:"currentColor"}));};var AdviceIcon=function AdviceIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"18",viewBox:"0 0 18 18"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0,18,9,0l9,18Zm3.236-2H14.764L9,4.472ZM8,15V13h2v2Zm0-3V8h2v4Z",fill:"currentColor"}));};var HotIcon=function HotIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"42",height:"42",viewBox:"0 0 42 42"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath",{id:"a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{width:"42",height:"42",fill:"none"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{clipPath:"url(#a)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M.5.5h42v42Z",transform:"translate(-0.5 -0.5)",fill:"#9c0401"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(18.208 10.258) rotate(45)",fill:"#fff",fontSize:"11",fontFamily:"Roboto-Black, Roboto",fontWeight:"800"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"0",y:"0"},"HOT"))));};

/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(74);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 183 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(74);
var TAG = __webpack_require__(28)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 186 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(135),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(251),
    baseAssignValue = __webpack_require__(556);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(22);
var _templateObject=_taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"],["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  :before {\n    position: absolute;\n    display: none;\n\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: silver;\n    border-radius: 8px;\n    content: \"\";\n  }\n\n  :after {\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    margin-top: -14px;\n    margin-left: -14px;\n    box-sizing: border-box;\n    width: 28px;\n    height: 28px;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-top: 2px solid #fff;\n    border-radius: 50%;\n    animation: "," 0.5s linear infinite;\n    content: \"\";\n  }\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  display: inline-block;\n\n  :before {\n    position: absolute;\n    display: none;\n\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: silver;\n    border-radius: 8px;\n    content: \"\";\n  }\n\n  :after {\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    margin-top: -14px;\n    margin-left: -14px;\n    box-sizing: border-box;\n    width: 28px;\n    height: 28px;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-top: 2px solid #fff;\n    border-radius: 50%;\n    animation: "," 0.5s linear infinite;\n    content: \"\";\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      :before,\n      :after {\n        display: block;\n      }\n    "],["\n      :before,\n      :after {\n        display: block;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      ::before {\n        background-color: #fff;\n        border-radius: 32px;\n      }\n\n      ::after {\n        border-color: ",";\n        border-top-color: #3b9478;\n      }\n\n      @media (max-width: 374px) {\n        display: block;\n        margin-bottom: 10px;\n        text-align: center;\n      }\n    "],["\n      ::before {\n        background-color: #fff;\n        border-radius: 32px;\n      }\n\n      ::after {\n        border-color: ",";\n        border-top-color: #3b9478;\n      }\n\n      @media (max-width: 374px) {\n        display: block;\n        margin-bottom: 10px;\n        text-align: center;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 28px;\n  margin: 0;\n  border: 0;\n  border-radius: 8px;\n  font-size: ",";\n  font-weight: 700;\n  line-height: 39px;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  user-select: none;\n  cursor: pointer;\n  background-color: #60a31c;\n  background: linear-gradient(to bottom, #68c703 0%, #60a31c 100%);\n\n  :hover {\n    background-color: #68c703;\n    background: linear-gradient(to bottom, #60a31c 0%, #68c703 100%);\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  @media (max-width: 480px) {\n    padding: 0 10px;\n  }\n\n  ",";\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 28px;\n  margin: 0;\n  border: 0;\n  border-radius: 8px;\n  font-size: ",";\n  font-weight: 700;\n  line-height: 39px;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  user-select: none;\n  cursor: pointer;\n  background-color: #60a31c;\n  background: linear-gradient(to bottom, #68c703 0%, #60a31c 100%);\n\n  :hover {\n    background-color: #68c703;\n    background: linear-gradient(to bottom, #60a31c 0%, #68c703 100%);\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  @media (max-width: 480px) {\n    padding: 0 10px;\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      margin-right: 10px;\n      background: linear-gradient(\n        to bottom,\n        rgb(95, 80, 115),\n        rgb(136, 125, 150)\n      );\n\n      :hover {\n        background: linear-gradient(\n          to bottom,\n          rgb(136, 125, 150),\n          rgb(95, 80, 115)\n        );\n      }\n    "],["\n      margin-right: 10px;\n      background: linear-gradient(\n        to bottom,\n        rgb(95, 80, 115),\n        rgb(136, 125, 150)\n      );\n\n      :hover {\n        background: linear-gradient(\n          to bottom,\n          rgb(136, 125, 150),\n          rgb(95, 80, 115)\n        );\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      min-width: 150px;\n      padding: 14px 20px;\n      font-size: 18px;\n      line-height: 1;\n      font-weight: bold;\n      color: #ffffff;\n      text-transform: uppercase;\n      background: transparent;\n      border: 2px solid #ffffff;\n      border-radius: 32px;\n\n      &:hover,\n      &:focus {\n        background-image: none;\n        background-color: #ffffff;\n        color: ",";\n      }\n      ",";\n      @media (max-width: 480px) {\n        min-width: 100px;\n        padding: 10px;\n      }\n    "],["\n      min-width: 150px;\n      padding: 14px 20px;\n      font-size: 18px;\n      line-height: 1;\n      font-weight: bold;\n      color: #ffffff;\n      text-transform: uppercase;\n      background: transparent;\n      border: 2px solid #ffffff;\n      border-radius: 32px;\n\n      &:hover,\n      &:focus {\n        background-image: none;\n        background-color: #ffffff;\n        color: ",";\n      }\n      ",";\n      @media (max-width: 480px) {\n        min-width: 100px;\n        padding: 10px;\n      }\n    "]),_templateObject8=_taggedTemplateLiteral(["\n          padding: 14px 10px;\n        "],["\n          padding: 14px 10px;\n        "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var isIronButton="irontrade"==="irontrade"||"irontrade"==="eztrader";var spin=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Loader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,spin,function(props){return props.loader&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(props){return props.isIntlProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#3B9478",0.5));});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16),function(props){return props.cancelButton&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);},function(_ref){var buttonType=_ref.buttonType;return isIronButton&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7, false?"#FFD503":"#3b9478",buttonType==="register"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8));});function BtnFormSubmit(_ref2){var id=_ref2.id,loader=_ref2.loader,className=_ref2.className,props=_objectWithoutProperties(_ref2,["id","loader","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Loader,{className:className,loader:loader,isIntlProject:isIronButton},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,Object.assign({type:"submit",buttonType:id,id:"s-submit-"+id},props)));}/* harmony default export */ __webpack_exports__["a"] = (BtnFormSubmit);

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Message__ = __webpack_require__(377);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  line-height: 18px;\n  color: #fff;\n  background-color: tomato;\n  border-radius: 15px;\n  padding: 5px 10px;\n  margin: 0 15px 10px 15px;\n\n  ",";\n"],["\n  direction: ",";\n  font-size: ",";\n  line-height: 18px;\n  color: #fff;\n  background-color: tomato;\n  border-radius: 15px;\n  padding: 5px 10px;\n  margin: 0 15px 10px 15px;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n    text-align: center;\n  "],["\n    text-align: center;\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;}, true?Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(12):fontSize(10),"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2));var ErrorMessage=function ErrorMessage(props){if(true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{style:props.style},props.message);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Message__["a" /* default */],{error:props.message});};/* harmony default export */ __webpack_exports__["a"] = (ErrorMessage);

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_libphonenumber_js__ = __webpack_require__(470);
var i18n={agree_error: false?React.createElement(Gettext,null,"To continue, you have to be at least 18 years old"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"To continue, you must agree with the terms or leave the site"),email_address_incorrect:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Incorrect e-mail address!"),email_address_uncorrect:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Incorrect e-mail address!"),error_pass_min_length:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Error! The password must be at least 6 characters!"),error_pass_must_contain_letters_numbers:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Error! The password must contain only numbers and Latin characters!"),error_repeat_pass_wrong:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Error! The verification code does not match!"),inser_all_fields:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Please fill in all of the required fields!"),operation_completed_with_errror:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Sorry, an error has occurred"),phone_format_incorrect:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Incorrect phone number format!"),register_choose_currency:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Choose currency")};/* harmony default export */ __webpack_exports__["a"] = ({regexprs:{emailInvalidSymbols:/[а-яА-Я]/,email:/^[a-zA-Z0-9-_.]+@[a-z0-9-_.]+\.[a-z-_.]{2,6}$/,password:/[^а-яА-Я]/,phone:/^\+?(\d+){6,}$/},email:function email(val){if(this.regexprs.emailInvalidSymbols.test(val)){return i18n.email_address_uncorrect;}else return null;},password:function password(val){if(val.length<6){return i18n.error_pass_min_length;}else if(!this.regexprs.password.test(val)){return i18n.error_pass_must_contain_letters_numbers;}else return null;},tel:function tel(val){var isValid=__WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].useCoolPhoneInputOnAuth?Object(__WEBPACK_IMPORTED_MODULE_3_libphonenumber_js__["a" /* isValidNumber */])(val):this.regexprs.phone.test(val);if(!isValid){return i18n.phone_format_incorrect;}else return null;},emailFull:function emailFull(val){if(!this.regexprs.email.test(val)){return i18n.email_address_incorrect;}else return null;},emptyFields:function emptyFields(){for(var _len=arguments.length,fields=Array(_len),_key=0;_key<_len;_key++){fields[_key]=arguments[_key];}fields.forEach(function(field){if(field==null){return i18n.inser_all_fields;}else return null;});},country:function country(_country){if(_country==null||typeof _country.currency!=="string"){return i18n.register_choose_currency;}else return null;},agree:function agree(_agree){return _agree?null:i18n.agree_error;}});

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPossibleNumber__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validate__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getNumberType__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(193);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var PhoneNumber = function () {
	function PhoneNumber(countryCallingCode, nationalNumber, metadata) {
		_classCallCheck(this, PhoneNumber);

		if (!countryCallingCode) {
			throw new TypeError('`countryCallingCode` not passed');
		}
		if (!nationalNumber) {
			throw new TypeError('`nationalNumber` not passed');
		}
		// If country code is passed then derive `countryCallingCode` from it.
		// Also store the country code as `.country`.
		if (isCountryCode(countryCallingCode)) {
			this.country = countryCallingCode;
			var _metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
			_metadata.country(countryCallingCode);
			countryCallingCode = _metadata.countryCallingCode();
		}
		this.countryCallingCode = countryCallingCode;
		this.nationalNumber = nationalNumber;
		this.number = '+' + this.countryCallingCode + this.nationalNumber;
		this.metadata = metadata;
	}

	_createClass(PhoneNumber, [{
		key: 'isPossible',
		value: function isPossible() {
			return Object(__WEBPACK_IMPORTED_MODULE_1__isPossibleNumber__["a" /* default */])(this, { v2: true }, this.metadata);
		}
	}, {
		key: 'isValid',
		value: function isValid() {
			return Object(__WEBPACK_IMPORTED_MODULE_2__validate__["a" /* default */])(this, { v2: true }, this.metadata);
		}
	}, {
		key: 'getType',
		value: function getType() {
			return Object(__WEBPACK_IMPORTED_MODULE_3__getNumberType__["b" /* default */])(this, { v2: true }, this.metadata);
		}
	}, {
		key: 'format',
		value: function format(_format, options) {
			return Object(__WEBPACK_IMPORTED_MODULE_4__format__["b" /* default */])(this, _format, options ? _extends({}, options, { v2: true }) : { v2: true }, this.metadata);
		}
	}, {
		key: 'formatNational',
		value: function formatNational(options) {
			return this.format('NATIONAL', options);
		}
	}, {
		key: 'formatInternational',
		value: function formatInternational(options) {
			return this.format('INTERNATIONAL', options);
		}
	}, {
		key: 'getURI',
		value: function getURI(options) {
			return this.format('RFC3966', options);
		}
	}]);

	return PhoneNumber;
}();

/* harmony default export */ __webpack_exports__["a"] = (PhoneNumber);


var isCountryCode = function isCountryCode(value) {
	return (/^[A-Z]{2}$/.test(value)
	);
};
//# sourceMappingURL=PhoneNumber.js.map

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = format;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FIRST_GROUP_PATTERN; });
/* harmony export (immutable) */ __webpack_exports__["c"] = format_national_number_using_format;
/* unused harmony export choose_format_for_number */
/* harmony export (immutable) */ __webpack_exports__["d"] = local_to_international_style;
/* unused harmony export formatIDDSameCountryCallingCodeNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IDD__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RFC3966__ = __webpack_require__(380);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of 17th November, 2016.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js











var defaultOptions = {
	formatExtension: function formatExtension(number, extension, metadata) {
		return '' + number + metadata.ext() + extension;
	}

	// Formats a phone number
	//
	// Example use cases:
	//
	// ```js
	// format('8005553535', 'RU', 'INTERNATIONAL')
	// format('8005553535', 'RU', 'INTERNATIONAL', metadata)
	// format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL')
	// format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', metadata)
	// format('+78005553535', 'NATIONAL')
	// format('+78005553535', 'NATIONAL', metadata)
	// ```
	//
};function format(arg_1, arg_2, arg_3, arg_4, arg_5) {
	var _sort_out_arguments = sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5),
	    input = _sort_out_arguments.input,
	    format_type = _sort_out_arguments.format_type,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	if (input.country) {
		// Validate `input.country`.
		if (!metadata.hasCountry(input.country)) {
			throw new Error('Unknown country: ' + input.country);
		}
		metadata.country(input.country);
	} else if (input.countryCallingCode) {
		metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
	} else return input.phone || '';

	var countryCallingCode = metadata.countryCallingCode();

	var nationalNumber = options.v2 ? input.nationalNumber : input.phone;

	// This variable should have been declared inside `case`s
	// but Babel has a bug and it says "duplicate variable declaration".
	var number = void 0;

	switch (format_type) {
		case 'INTERNATIONAL':
			// Legacy argument support.
			// (`{ country: ..., phone: '' }`)
			if (!nationalNumber) {
				return '+' + countryCallingCode;
			}
			number = format_national_number(nationalNumber, 'INTERNATIONAL', false, metadata);
			number = '+' + countryCallingCode + ' ' + number;
			return add_extension(number, input.ext, metadata, options.formatExtension);

		case 'E.164':
			// `E.164` doesn't define "phone number extensions".
			return '+' + countryCallingCode + nationalNumber;

		case 'RFC3966':
			return Object(__WEBPACK_IMPORTED_MODULE_4__RFC3966__["a" /* formatRFC3966 */])({
				number: '+' + countryCallingCode + nationalNumber,
				ext: input.ext
			});

		case 'IDD':
			if (!options.fromCountry) {
				return;
				// throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
			}
			var IDDPrefix = Object(__WEBPACK_IMPORTED_MODULE_2__IDD__["a" /* getIDDPrefix */])(options.fromCountry, metadata.metadata);
			if (!IDDPrefix) {
				return;
			}
			if (options.humanReadable) {
				var formattedForSameCountryCallingCode = countryCallingCode && formatIDDSameCountryCallingCodeNumber(nationalNumber, metadata.countryCallingCode(), options.fromCountry, metadata);
				if (formattedForSameCountryCallingCode) {
					number = formattedForSameCountryCallingCode;
				} else {
					number = IDDPrefix + ' ' + countryCallingCode + ' ' + format_national_number(nationalNumber, 'INTERNATIONAL', false, metadata);
				}
				return add_extension(number, input.ext, metadata, options.formatExtension);
			}
			return '' + IDDPrefix + countryCallingCode + nationalNumber;

		case 'NATIONAL':
			// Legacy argument support.
			// (`{ country: ..., phone: '' }`)
			if (!nationalNumber) {
				return '';
			}
			number = format_national_number(nationalNumber, 'NATIONAL', true, metadata);
			return add_extension(number, input.ext, metadata, options.formatExtension);
	}
}

// This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly.  Therefore, we use \d, so that the first
// group actually used in the pattern will be matched.
var FIRST_GROUP_PATTERN = /(\$\d)/;

function format_national_number_using_format(number, format, international, enforce_national_prefix, metadata) {
	var format_pattern_matcher = new RegExp(format.pattern());

	// National prefix is omitted if there's no national prefix formatting rule
	// set for this country, or when this rule is set but
	// national prefix is optional for this phone number format
	// (and it is not enforced explicitly)
	var national_prefix_may_be_omitted = !format.nationalPrefixFormattingRule() || format.nationalPrefixFormattingRule() && format.nationalPrefixIsOptionalWhenFormatting() && !enforce_national_prefix;

	if (!international && !national_prefix_may_be_omitted) {
		return number.replace(format_pattern_matcher, format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()));
	}

	var formatted_number = number.replace(format_pattern_matcher, international ? format.internationalFormat() : format.format());

	if (international) {
		return local_to_international_style(formatted_number);
	}

	return formatted_number;
}

function format_national_number(number, format_as, enforce_national_prefix, metadata) {
	var format = choose_format_for_number(metadata.formats(), number);

	if (!format) {
		return number;
	}

	return format_national_number_using_format(number, format, format_as === 'INTERNATIONAL', enforce_national_prefix, metadata);
}

function choose_format_for_number(available_formats, national_number) {
	for (var _iterator = available_formats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var _format = _ref;

		// Validate leading digits
		if (_format.leadingDigitsPatterns().length > 0) {
			// The last leading_digits_pattern is used here, as it is the most detailed
			var last_leading_digits_pattern = _format.leadingDigitsPatterns()[_format.leadingDigitsPatterns().length - 1];

			// If leading digits don't match then move on to the next phone number format
			if (national_number.search(last_leading_digits_pattern) !== 0) {
				continue;
			}
		}

		// Check that the national number matches the phone number format regular expression
		if (Object(__WEBPACK_IMPORTED_MODULE_0__common__["i" /* matches_entirely */])(national_number, _format.pattern())) {
			return _format;
		}
	}
}

// Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
function local_to_international_style(local) {
	return local.replace(new RegExp('[' + __WEBPACK_IMPORTED_MODULE_0__common__["e" /* VALID_PUNCTUATION */] + ']+', 'g'), ' ').trim();
}

// Sort out arguments
function sort_out_arguments(arg_1, arg_2, arg_3, arg_4, arg_5) {
	var input = void 0;
	var format_type = void 0;
	var options = void 0;
	var metadata = void 0;

	// Sort out arguments.

	// If the phone number is passed as a string.
	// `format('8005553535', ...)`.
	if (typeof arg_1 === 'string') {
		// If country code is supplied.
		// `format('8005553535', 'RU', 'NATIONAL', [options], metadata)`.
		if (typeof arg_3 === 'string') {
			format_type = arg_3;

			if (arg_5) {
				options = arg_4;
				metadata = arg_5;
			} else {
				metadata = arg_4;
			}

			input = Object(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* default */])(arg_1, { defaultCountry: arg_2, extended: true }, metadata);
		}
		// Just an international phone number is supplied
		// `format('+78005553535', 'NATIONAL', [options], metadata)`.
		else {
				if (typeof arg_2 !== 'string') {
					throw new Error('`format` argument not passed to `formatNumber(number, format)`');
				}

				format_type = arg_2;

				if (arg_4) {
					options = arg_3;
					metadata = arg_4;
				} else {
					metadata = arg_3;
				}

				input = Object(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* default */])(arg_1, { extended: true }, metadata);
			}
	}
	// If the phone number is passed as a parsed number object.
	// `format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', [options], metadata)`.
	else if (is_object(arg_1)) {
			input = arg_1;
			format_type = arg_2;

			if (arg_4) {
				options = arg_3;
				metadata = arg_4;
			} else {
				metadata = arg_3;
			}
		} else throw new TypeError('A phone number must either be a string or an object of shape { phone, [country] }.');

	if (format_type === 'International') {
		format_type = 'INTERNATIONAL';
	} else if (format_type === 'National') {
		format_type = 'NATIONAL';
	}

	// Validate `format_type`.
	switch (format_type) {
		case 'E.164':
		case 'INTERNATIONAL':
		case 'NATIONAL':
		case 'RFC3966':
		case 'IDD':
			break;
		default:
			throw new Error('Unknown format type argument passed to "format()": "' + format_type + '"');
	}

	// Apply default options.
	if (options) {
		options = _extends({}, defaultOptions, options);
	} else {
		options = defaultOptions;
	}

	return { input: input, format_type: format_type, options: options, metadata: new __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* default */](metadata) };
}

// Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var is_object = function is_object(_) {
	return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
};

function add_extension(number, ext, metadata, formatExtension) {
	return ext ? formatExtension(number, ext, metadata) : number;
}

function formatIDDSameCountryCallingCodeNumber(number, toCountryCallingCode, fromCountry, toCountryMetadata) {
	var fromCountryMetadata = new __WEBPACK_IMPORTED_MODULE_3__metadata__["a" /* default */](toCountryMetadata.metadata);
	fromCountryMetadata.country(fromCountry);

	// If calling within the same country calling code.
	if (toCountryCallingCode === fromCountryMetadata.countryCallingCode()) {
		// For NANPA regions, return the national format for these regions
		// but prefix it with the country calling code.
		if (toCountryCallingCode === '1') {
			return toCountryCallingCode + ' ' + format_national_number(number, 'NATIONAL', false, toCountryMetadata);
		}

		// If regions share a country calling code, the country calling code need
		// not be dialled. This also applies when dialling within a region, so this
		// if clause covers both these cases. Technically this is the case for
		// dialling from La Reunion to other overseas departments of France (French
		// Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
		// this edge case for now and for those cases return the version including
		// country calling code. Details here:
		// http://www.petitfute.com/voyage/225-info-pratiques-reunion
		return format_national_number(number, 'NATIONAL', false, toCountryMetadata);
	}
}
//# sourceMappingURL=format.js.map

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  font-size: 0;\n  line-height: 0;\n"],["\n  width: 100%;\n  font-size: 0;\n  line-height: 0;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_email_png__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_email_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_email_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_phone_png__ = __webpack_require__(1289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_phone_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_phone_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_pass_png__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_pass_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_pass_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  padding: ",";\n\n  @media (max-width: 959px) {\n    padding: ",";\n  }\n\n  ",";\n"],["\n  direction: ",";\n  position: relative;\n  padding: ",";\n\n  @media (max-width: 959px) {\n    padding: ",";\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      padding: 9px 0;\n    "],["\n      padding: 9px 0;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 36px;\n  ",";\n  ",";\n  font-size: ",";\n  line-height: 36px;\n  pointer-events: auto;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  color: ",";\n  background-color: #f6f6f6;\n  box-shadow: inset 0 2px 0 0 #e3e3e3;\n\n  @media (max-width: 959px) {\n    height: 32px;\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  ",";\n"],["\n  width: 100%;\n  min-height: 36px;\n  ",";\n  ",";\n  font-size: ",";\n  line-height: 36px;\n  pointer-events: auto;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  color: ",";\n  background-color: #f6f6f6;\n  box-shadow: inset 0 2px 0 0 #e3e3e3;\n\n  @media (max-width: 959px) {\n    height: 32px;\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      height: 50px;\n      ",";\n      background-color: rgba(255, 255, 255, 0.25);\n      border: none;\n      border-radius: 25px;\n      box-shadow: none;\n\n      @media (max-width: 959px) {\n        height: 40px;\n      }\n\n      :focus {\n        border: 1px solid #ffffff;\n        ",";\n      }\n\n      &::placeholder {\n        color: #ffffff;\n      }\n\n      &:-webkit-autofill,\n      &:-webkit-autofill:hover,\n      &:-webkit-autofill:focus {\n        color: #ffffff;\n        border: 1px solid yellow;\n        box-shadow: 0 0 0px 1000px rgba(255, 255, 0, 0.5) inset;\n        transition: background-color 5000s ease-in-out 0s;\n      }\n    "],["\n      height: 50px;\n      ",";\n      background-color: rgba(255, 255, 255, 0.25);\n      border: none;\n      border-radius: 25px;\n      box-shadow: none;\n\n      @media (max-width: 959px) {\n        height: 40px;\n      }\n\n      :focus {\n        border: 1px solid #ffffff;\n        ",";\n      }\n\n      &::placeholder {\n        color: #ffffff;\n      }\n\n      &:-webkit-autofill,\n      &:-webkit-autofill:hover,\n      &:-webkit-autofill:focus {\n        color: #ffffff;\n        border: 1px solid yellow;\n        box-shadow: 0 0 0px 1000px rgba(255, 255, 0, 0.5) inset;\n        transition: background-color 5000s ease-in-out 0s;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  position: absolute;\n  top: ",";\n  ",";\n  min-height: 38px;\n  ",";\n  font: 16px/38px Roboto, Arial, sans-serif;\n  ",";\n  pointer-events: none;\n  background: url(",") no-repeat 12px center;\n\n  @media (max-width: 959px) {\n    top: ",";\n  }\n\n  ",";\n"],["\n  display: block;\n  width: 100%;\n  position: absolute;\n  top: ",";\n  ",";\n  min-height: 38px;\n  ",";\n  font: 16px/38px Roboto, Arial, sans-serif;\n  ",";\n  pointer-events: none;\n  background: url(",") no-repeat 12px center;\n\n  @media (max-width: 959px) {\n    top: ",";\n  }\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      display: none;\n    "],["\n      display: none;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var bg={email:__WEBPACK_IMPORTED_MODULE_2__images_email_png___default.a,password:__WEBPACK_IMPORTED_MODULE_4__images_pass_png___default.a,tel:__WEBPACK_IMPORTED_MODULE_3__images_phone_png___default.a};var InputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},function(props){return props.tab==="register"?"4px 0":"12px 0";},function(props){return props.tab==="register"?"4px 0":"8px 0";},function(_ref2){var theme=_ref2.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var InputView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("padding-right","7px"),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("padding-left","47px"),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(16),function(props){return props.theme.inputColor;},function(_ref3){var theme=_ref3.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("padding-left","20px"),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("padding-left","19px"));});var InputLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].label(_templateObject5,function(props){return props.tab==="register"?"4px":"11px";},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("left",0),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("padding-left","47px"),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["c" /* rtl */])("text-align","left"),function(props){return bg[props.type];},function(props){return props.tab==="register"?"1px":"5px";},function(_ref4){var theme=_ref4.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});function Input(_ref5){var tab=_ref5.tab,type=_ref5.type,name=_ref5.name,placeholder=_ref5.placeholder,id=_ref5.id,onChange=_ref5.onChange,value=_ref5.value,autocomplete=_ref5.autocomplete,required=_ref5.required;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputContainer,{tab:tab},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputView,{type:type,name:name,placeholder:placeholder,id:id,onChange:onChange,value:value,required:required,autocomplete:autocomplete}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputLabel,{tab:tab,type:type,htmlFor:id}));}/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(260);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(605);
var enumBugKeys = __webpack_require__(391);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 199 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelAnimationTimeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return requestAnimationTimeout; });
/* unused harmony export bpfrpt_proptype_AnimationTimeoutId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__animationFrame__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



var bpfrpt_proptype_AnimationTimeoutId =  true ? null : {
  id: PropTypes.number.isRequired
};


var cancelAnimationTimeout = function cancelAnimationTimeout(frame) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["a" /* caf */])(frame.id);
};

/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */
var requestAnimationTimeout = function requestAnimationTimeout(callback, delay) {
  var start = void 0;
  // wait for end of processing current event handler, because event handler may be long
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
    start = Date.now();
  });

  var timeout = function timeout() {
    if (Date.now() - start >= delay) {
      callback.call();
    } else {
      frame.id = Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout);
    }
  };

  var frame = {
    id: Object(__WEBPACK_IMPORTED_MODULE_1__animationFrame__["b" /* raf */])(timeout)
  };

  return frame;
};



/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellDataGetterParams */
/* unused harmony export bpfrpt_proptype_CellRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRowRendererParams */
/* unused harmony export bpfrpt_proptype_HeaderRendererParams */
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellDataGetterParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_CellRendererParams =  true ? null : {
  cellData: PropTypes.any,
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  rowIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_HeaderRowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};
var bpfrpt_proptype_HeaderRendererParams =  true ? null : {
  columnData: PropTypes.any,
  dataKey: PropTypes.string.isRequired,
  disableSort: PropTypes.bool,
  label: PropTypes.any,
  sortBy: PropTypes.string,
  sortDirection: PropTypes.string
};
var bpfrpt_proptype_RowRendererParams =  true ? null : {
  className: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(function (props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }).isRequired,
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  onRowClick: PropTypes.func,
  onRowDoubleClick: PropTypes.func,
  onRowMouseOver: PropTypes.func,
  onRowMouseOut: PropTypes.func,
  rowData: function rowData(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  },
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error("Prop `" + propName + "` has type 'any' or 'mixed', but was not provided to `" + componentName + "`. Pass undefined or any other value.");
    }
  }
};







/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTimezoneOffsetInMilliseconds;
var MILLISECONDS_IN_MINUTE = 60000;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */

function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = date.getTimezoneOffset();
  date.setSeconds(0, 0);
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE;
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FlatButton__ = __webpack_require__(272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FlatButton__["a"]; });


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Sticker;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_free_3x_png__ = __webpack_require__(1504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_free_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_free_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_invite_3x_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_invite_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_invite_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_new_3x_png__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_new_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_new_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_new_iron_3x_png__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_new_iron_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_new_iron_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_demo2xIcon_png__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_demo2xIcon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_demo2xIcon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  ",";\n  ",";\n  width: ",";\n  height: ",";\n  background-repeat: no-repeat;\n  background-image: url(",");\n  background-position: center;\n  background-size: contain;\n"],["\n  position: absolute;\n  top: 0;\n  ",";\n  ",";\n  width: ",";\n  height: ",";\n  background-repeat: no-repeat;\n  background-image: url(",");\n  background-position: center;\n  background-size: contain;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var View=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].i(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("right",0),Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("transform","none","rotate(-90deg)"),function(_ref){var width=_ref.width;return width?width:"43px";},function(_ref2){var height=_ref2.height;return height?height:"42px";},function(props){return props.bgIcon;});function Sticker(_ref3){var _ref3$type=_ref3.type,type=_ref3$type===undefined?"pay":_ref3$type,_ref3$active=_ref3.active,active=_ref3$active===undefined?false:_ref3$active,_ref3$limited=_ref3.limited,limited=_ref3$limited===undefined?false:_ref3$limited,_ref3$isNew=_ref3.isNew,isNew=_ref3$isNew===undefined?false:_ref3$isNew,subtype=_ref3.subtype;if(subtype==="demo"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View,{bgIcon:__WEBPACK_IMPORTED_MODULE_6__images_demo2xIcon_png___default.a,width:"42px",height:"43px"});}if(limited){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View,{bgIcon:__WEBPACK_IMPORTED_MODULE_3__images_invite_3x_png___default.a});}if(type==="free"||isNew===true&&active===false){switch(type){case"free":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View,{bgIcon:__WEBPACK_IMPORTED_MODULE_2__images_free_3x_png___default.a});default:return  true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View,{bgIcon:__WEBPACK_IMPORTED_MODULE_5__images_new_iron_3x_png___default.a}):React.createElement(View,{bgIcon:newIcon});}}return null;}

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return scale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alpha; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return degrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return percent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return px; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return vw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return vh; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return rgba; });
/* unused harmony export rgbUnit */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return hex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hsla; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return color; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return complex; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var clamp = function (min, max) { return function (v) {
    return Math.max(Math.min(v, max), min);
}; };
var isFirstChars = function (term) { return function (v) {
    return typeof v === 'string' && v.indexOf(term) === 0;
}; };
var getValueFromFunctionString = function (value) {
    return value.substring(value.indexOf('(') + 1, value.lastIndexOf(')'));
};
var splitCommaDelimited = function (value) {
    return typeof value === 'string' ? value.split(/,\s*/) : [value];
};
var sanitize = function (v) { return (v % 1 ? Number(v.toFixed(5)) : v); };

var number = {
    test: function (v) { return typeof v === 'number'; },
    parse: parseFloat,
    transform: function (v) { return v; }
};
var alpha = __assign({}, number, { transform: clamp(0, 1) });
var scale = __assign({}, number, { default: 1 });

var createUnitType = function (unit) { return ({
    test: function (v) {
        return typeof v === 'string' && v.endsWith(unit) && v.split(' ').length === 1;
    },
    parse: parseFloat,
    transform: function (v) { return "" + v + unit; }
}); };
var degrees = createUnitType('deg');
var percent = createUnitType('%');
var px = createUnitType('px');
var vh = createUnitType('vh');
var vw = createUnitType('vw');

var clampRgbUnit = clamp(0, 255);
var onlyColorRegex = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))$/i;
var isRgba = function (v) { return v.red !== undefined; };
var isHsla = function (v) { return v.hue !== undefined; };
var splitColorValues = function (terms) {
    var numTerms = terms.length;
    return function (v) {
        if (typeof v !== 'string')
            return v;
        var values = {};
        var valuesArray = splitCommaDelimited(getValueFromFunctionString(v));
        for (var i = 0; i < numTerms; i++) {
            values[terms[i]] =
                valuesArray[i] !== undefined ? parseFloat(valuesArray[i]) : 1;
        }
        return values;
    };
};
var rgbaTemplate = function (_a) {
    var red = _a.red, green = _a.green, blue = _a.blue, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
    return "rgba(" + red + ", " + green + ", " + blue + ", " + alpha$$1 + ")";
};
var hslaTemplate = function (_a) {
    var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, _b = _a.alpha, alpha$$1 = _b === void 0 ? 1 : _b;
    return "hsla(" + hue + ", " + saturation + ", " + lightness + ", " + alpha$$1 + ")";
};
var rgbUnit = __assign({}, number, { transform: function (v) { return Math.round(clampRgbUnit(v)); } });
var testRgbaString = isFirstChars('rgb');
var rgba = {
    test: function (v) { return (typeof v === 'string' ? testRgbaString(v) : isRgba(v)); },
    parse: splitColorValues(['red', 'green', 'blue', 'alpha']),
    transform: function (_a) {
        var red = _a.red, green = _a.green, blue = _a.blue, alpha$$1 = _a.alpha;
        return rgbaTemplate({
            red: rgbUnit.transform(red),
            green: rgbUnit.transform(green),
            blue: rgbUnit.transform(blue),
            alpha: sanitize(alpha$$1)
        });
    }
};
var testHslaString = isFirstChars('hsl');
var hsla = {
    test: function (v) { return (typeof v === 'string' ? testHslaString(v) : isHsla(v)); },
    parse: splitColorValues(['hue', 'saturation', 'lightness', 'alpha']),
    transform: function (_a) {
        var hue = _a.hue, saturation = _a.saturation, lightness = _a.lightness, alpha$$1 = _a.alpha;
        return hslaTemplate({
            hue: Math.round(hue),
            saturation: percent.transform(sanitize(saturation)),
            lightness: percent.transform(sanitize(lightness)),
            alpha: sanitize(alpha$$1)
        });
    }
};
var hex = __assign({}, rgba, { test: isFirstChars('#'), parse: function (v) {
        var r = '';
        var g = '';
        var b = '';
        if (v.length > 4) {
            r = v.substr(1, 2);
            g = v.substr(3, 2);
            b = v.substr(5, 2);
        }
        else {
            r = v.substr(1, 1);
            g = v.substr(2, 1);
            b = v.substr(3, 1);
            r += r;
            g += g;
            b += b;
        }
        return {
            red: parseInt(r, 16),
            green: parseInt(g, 16),
            blue: parseInt(b, 16),
            alpha: 1
        };
    } });
var color = {
    test: function (v) {
        return (typeof v === 'string' && onlyColorRegex.test(v)) ||
            rgba.test(v) ||
            hsla.test(v) ||
            hex.test(v);
    },
    parse: function (v) {
        if (rgba.test(v)) {
            return rgba.parse(v);
        }
        else if (hsla.test(v)) {
            return hsla.parse(v);
        }
        else if (hex.test(v)) {
            return hex.parse(v);
        }
        return v;
    },
    transform: function (v) {
        if (isRgba(v)) {
            return rgba.transform(v);
        }
        else if (isHsla(v)) {
            return hsla.transform(v);
        }
        return v;
    }
};

var floatRegex = /(-)?(\d[\d\.]*)/g;
var colorRegex = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?\d+%?[,\s]+){2,3}\s*[\d\.]+%?\))/gi;
var COLOR_TOKEN = '${c}';
var NUMBER_TOKEN = '${n}';
var complex = {
    test: function (v) {
        if (typeof v !== 'string' || !isNaN(v))
            return false;
        var numValues = 0;
        var foundNumbers = v.match(floatRegex);
        var foundColors = v.match(colorRegex);
        if (foundNumbers)
            numValues += foundNumbers.length;
        if (foundColors)
            numValues += foundColors.length;
        return numValues > 0;
    },
    parse: function (v) {
        var input = v;
        var parsed = [];
        var foundColors = input.match(colorRegex);
        if (foundColors) {
            input = input.replace(colorRegex, COLOR_TOKEN);
            parsed.push.apply(parsed, foundColors.map(color.parse));
        }
        var foundNumbers = input.match(floatRegex);
        if (foundNumbers) {
            parsed.push.apply(parsed, foundNumbers.map(number.parse));
        }
        return parsed;
    },
    createTransformer: function (prop) {
        var template = prop;
        var token = 0;
        var foundColors = prop.match(colorRegex);
        var numColors = foundColors ? foundColors.length : 0;
        if (foundColors) {
            for (var i = 0; i < numColors; i++) {
                template = template.replace(foundColors[i], COLOR_TOKEN);
                token++;
            }
        }
        var foundNumbers = template.match(floatRegex);
        var numNumbers = foundNumbers ? foundNumbers.length : 0;
        if (foundNumbers) {
            for (var i = 0; i < numNumbers; i++) {
                template = template.replace(foundNumbers[i], NUMBER_TOKEN);
                token++;
            }
        }
        return function (v) {
            var output = template;
            for (var i = 0; i < token; i++) {
                output = output.replace(i < numColors ? COLOR_TOKEN : NUMBER_TOKEN, i < numColors ? color.transform(v[i]) : sanitize(v[i]));
            }
            return output;
        };
    }
};




/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reversed", function() { return reversed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mirrored", function() { return mirrored; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createReversedEasing", function() { return createReversedEasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createMirroredEasing", function() { return createMirroredEasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createExpoIn", function() { return createExpoIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createBackIn", function() { return createBackIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createAnticipateEasing", function() { return createAnticipateEasing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "linear", function() { return linear; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeIn", function() { return easeIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeOut", function() { return easeOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "easeInOut", function() { return easeInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circIn", function() { return circIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circOut", function() { return circOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "circInOut", function() { return circInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backIn", function() { return backIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backOut", function() { return backOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "backInOut", function() { return backInOut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "anticipate", function() { return anticipate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cubicBezier", function() { return cubicBezier; });
var DEFAULT_OVERSHOOT_STRENGTH = 1.525;
var reversed = function (easing) {
    return function (p) {
        return 1 - easing(1 - p);
    };
};
var mirrored = function (easing) {
    return function (p) {
        return p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;
    };
};
var createReversedEasing = reversed;
var createMirroredEasing = mirrored;
var createExpoIn = function (power) {
    return function (p) {
        return Math.pow(p, power);
    };
};
var createBackIn = function (power) {
    return function (p) {
        return p * p * ((power + 1) * p - power);
    };
};
var createAnticipateEasing = function (power) {
    var backEasing = createBackIn(power);
    return function (p) {
        return (p *= 2) < 1 ? 0.5 * backEasing(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));
    };
};
var linear = function (p) {
    return p;
};
var easeIn = /*#__PURE__*/createExpoIn(2);
var easeOut = /*#__PURE__*/reversed(easeIn);
var easeInOut = /*#__PURE__*/mirrored(easeIn);
var circIn = function (p) {
    return 1 - Math.sin(Math.acos(p));
};
var circOut = /*#__PURE__*/reversed(circIn);
var circInOut = /*#__PURE__*/mirrored(circOut);
var backIn = /*#__PURE__*/createBackIn(DEFAULT_OVERSHOOT_STRENGTH);
var backOut = /*#__PURE__*/reversed(backIn);
var backInOut = /*#__PURE__*/mirrored(backIn);
var anticipate = /*#__PURE__*/createAnticipateEasing(DEFAULT_OVERSHOOT_STRENGTH);
var NEWTON_ITERATIONS = 8;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var K_SPLINE_TABLE_SIZE = 11;
var K_SAMPLE_STEP_SIZE = 1.0 / (K_SPLINE_TABLE_SIZE - 1.0);
var FLOAT_32_SUPPORTED = typeof Float32Array !== 'undefined';
var a = function (a1, a2) {
    return 1.0 - 3.0 * a2 + 3.0 * a1;
};
var b = function (a1, a2) {
    return 3.0 * a2 - 6.0 * a1;
};
var c = function (a1) {
    return 3.0 * a1;
};
var getSlope = function (t, a1, a2) {
    return 3.0 * a(a1, a2) * t * t + 2.0 * b(a1, a2) * t + c(a1);
};
var calcBezier = function (t, a1, a2) {
    return ((a(a1, a2) * t + b(a1, a2)) * t + c(a1)) * t;
};
function cubicBezier(mX1, mY1, mX2, mY2) {
    var sampleValues = FLOAT_32_SUPPORTED ? new Float32Array(K_SPLINE_TABLE_SIZE) : new Array(K_SPLINE_TABLE_SIZE);
    var binarySubdivide = function (aX, aA, aB) {
        var i = 0;
        var currentX;
        var currentT;
        do {
            currentT = aA + (aB - aA) / 2.0;
            currentX = calcBezier(currentT, mX1, mX2) - aX;
            if (currentX > 0.0) {
                aB = currentT;
            } else {
                aA = currentT;
            }
        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
        return currentT;
    };
    var newtonRaphsonIterate = function (aX, aGuessT) {
        var i = 0;
        var currentSlope = 0;
        var currentX;
        for (; i < NEWTON_ITERATIONS; ++i) {
            currentSlope = getSlope(aGuessT, mX1, mX2);
            if (currentSlope === 0.0) {
                return aGuessT;
            }
            currentX = calcBezier(aGuessT, mX1, mX2) - aX;
            aGuessT -= currentX / currentSlope;
        }
        return aGuessT;
    };
    var calcSampleValues = function () {
        for (var i = 0; i < K_SPLINE_TABLE_SIZE; ++i) {
            sampleValues[i] = calcBezier(i * K_SAMPLE_STEP_SIZE, mX1, mX2);
        }
    };
    var getTForX = function (aX) {
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = K_SPLINE_TABLE_SIZE - 1;
        var dist = 0.0;
        var guessForT = 0.0;
        var initialSlope = 0.0;
        for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
            intervalStart += K_SAMPLE_STEP_SIZE;
        }
        --currentSample;
        dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
        guessForT = intervalStart + dist * K_SAMPLE_STEP_SIZE;
        initialSlope = getSlope(guessForT, mX1, mX2);
        if (initialSlope >= NEWTON_MIN_SLOPE) {
            return newtonRaphsonIterate(aX, guessForT);
        } else if (initialSlope === 0.0) {
            return guessForT;
        } else {
            return binarySubdivide(aX, intervalStart, intervalStart + K_SAMPLE_STEP_SIZE);
        }
    };
    calcSampleValues();
    var resolver = function (aX) {
        var returnValue;
        if (mX1 === mY1 && mX2 === mY2) {
            returnValue = aX;
        } else if (aX === 0) {
            returnValue = 0;
        } else if (aX === 1) {
            returnValue = 1;
        } else {
            returnValue = calcBezier(getTForX(aX), mY1, mY2);
        }
        return returnValue;
    };
    return resolver;
}




/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveDeals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeatureFlags__ = __webpack_require__(41);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function receiveTradingHistory(tradingHistory){if((typeof tradingHistory==="undefined"?"undefined":_typeof(tradingHistory))!=="object"){throw new TypeError("Deals must be an object");}return[].concat(_toConsumableArray(tradingHistory.open),_toConsumableArray(tradingHistory.closed));}function receiveSocketMessage(state,message){if(message.op==="operationOpened"){var lookupId=message.id;if(state.some(function(deal){return deal.id===lookupId;})){// Существует рейс кондишн, при котором возможно,
// что об открытой сделке мы знаем до того, как
// об этом нам сообщит сокет!
// Чтобы не было дубликатов, первым делом проверяем
// отсутствие сделки с таким айди.
return state;}var nextDeal={id:message.id,stock:message.stock,amount:message.bidAmnt,bTime:message.bidTime,time:message.bidTime,bidType:message.isBidUp,percent:message.profitPercent,// profit?: number,
timestamp:Math.floor(message.openTimestamp/1000),open_timestamp:Math.floor(message.openTimestamp/1000),value:message.bidValue,accountType:message.real===1?"real":"demo"};return[].concat(_toConsumableArray(state),[nextDeal]);}if(message.op==="operationClosed"){// По сообщению о закрытии попробуем найти у нас такую операцию
// и руками превратить её в "закрытую". "Закрытые" отличаются
// отсутствием поля time и наличием поля profit.
var id=message.id,profit=message.profit;return state.map(function(deal){return deal.id===id?Object.assign({},deal,{time:null,profit:profit}):deal;});}return state;}function deals(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"REQUEST_DEAL_OPENING":return __WEBPACK_IMPORTED_MODULE_0__FeatureFlags__["a" /* default */].enableOptimisticDeals?[].concat(_toConsumableArray(state),[action.payload]):state;case"RECEIVE_DEAL_HISTORY":return receiveTradingHistory(action.payload);case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);case"RECEIVE_DEAL_OPENING_SUCCESS":case"RECEIVE_DEAL_OPENING_FAILURE":default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (deals);function getActiveDeals(stock,time,state){return state.filter(function(deal){return Boolean(deal)&&deal.stock===stock&&deal.time!==undefined&&deal.timestamp*1000<=time&&time-deal.timestamp*1000<deal.bTime*1000;});}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createRule = __webpack_require__(283);

var _createRule2 = _interopRequireDefault(_createRule);

var _linkRule = __webpack_require__(701);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _StyleRule = __webpack_require__(167);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _escape = __webpack_require__(1789);

var _escape2 = _interopRequireDefault(_escape);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Contains rules objects and allows adding/removing etc.
 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
 */
var RuleList = function () {

  // Original styles object.
  function RuleList(options) {
    var _this = this;

    _classCallCheck(this, RuleList);

    this.map = {};
    this.raw = {};
    this.index = [];

    this.update = function (name, data) {
      var _options = _this.options,
          plugins = _options.jss.plugins,
          sheet = _options.sheet;

      if (typeof name === 'string') {
        plugins.onUpdate(data, _this.get(name), sheet);
      } else {
        for (var index = 0; index < _this.index.length; index++) {
          plugins.onUpdate(name, _this.index[index], sheet);
        }
      }
    };

    this.options = options;
    this.classes = options.classes;
  }

  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  // Used to ensure correct rules order.

  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.


  _createClass(RuleList, [{
    key: 'add',
    value: function add(name, decl, options) {
      var _options2 = this.options,
          parent = _options2.parent,
          sheet = _options2.sheet,
          jss = _options2.jss,
          Renderer = _options2.Renderer,
          generateClassName = _options2.generateClassName;


      options = _extends({
        classes: this.classes,
        parent: parent,
        sheet: sheet,
        jss: jss,
        Renderer: Renderer,
        generateClassName: generateClassName
      }, options);

      if (!options.selector && this.classes[name]) {
        options.selector = '.' + (0, _escape2['default'])(this.classes[name]);
      }

      this.raw[name] = decl;

      var rule = (0, _createRule2['default'])(name, decl, options);

      var className = void 0;

      if (!options.selector && rule instanceof _StyleRule2['default']) {
        className = generateClassName(rule, sheet);
        rule.selector = '.' + (0, _escape2['default'])(className);
      }

      this.register(rule, className);

      var index = options.index === undefined ? this.index.length : options.index;
      this.index.splice(index, 0, rule);

      return rule;
    }

    /**
     * Get a rule.
     */

  }, {
    key: 'get',
    value: function get(name) {
      return this.map[name];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'remove',
    value: function remove(rule) {
      this.unregister(rule);
      this.index.splice(this.indexOf(rule), 1);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.index.indexOf(rule);
    }

    /**
     * Run `onProcessRule()` plugins on every rule.
     */

  }, {
    key: 'process',
    value: function process() {
      var plugins = this.options.jss.plugins;
      // We need to clone array because if we modify the index somewhere else during a loop
      // we end up with very hard-to-track-down side effects.

      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
    }

    /**
     * Register a rule in `.map` and `.classes` maps.
     */

  }, {
    key: 'register',
    value: function register(rule, className) {
      this.map[rule.key] = rule;
      if (rule instanceof _StyleRule2['default']) {
        this.map[rule.selector] = rule;
        if (className) this.classes[rule.key] = className;
      }
    }

    /**
     * Unregister a rule.
     */

  }, {
    key: 'unregister',
    value: function unregister(rule) {
      delete this.map[rule.key];
      if (rule instanceof _StyleRule2['default']) {
        delete this.map[rule.selector];
        delete this.classes[rule.key];
      }
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'link',


    /**
     * Link renderable rules with CSSRuleList.
     */
    value: function link(cssRules) {
      var map = this.options.sheet.renderer.getUnescapedKeysMap(this.index);

      for (var i = 0; i < cssRules.length; i++) {
        var cssRule = cssRules[i];
        var _key = this.options.sheet.renderer.getKey(cssRule);
        if (map[_key]) _key = map[_key];
        var rule = this.map[_key];
        if (rule) (0, _linkRule2['default'])(rule, cssRule);
      }
    }

    /**
     * Convert rules to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      var str = '';
      var sheet = this.options.sheet;

      var link = sheet ? sheet.options.link : false;

      for (var index = 0; index < this.index.length; index++) {
        var rule = this.index[index];
        var css = rule.toString(options);

        // No need to render an empty rule.
        if (!css && !link) continue;

        if (str) str += '\n';
        str += css;
      }

      return str;
    }
  }]);

  return RuleList;
}();

exports['default'] = RuleList;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pushHash = function pushHash(hash) {
  hash = hash ? hash.indexOf('#') === 0 ? hash : '#' + hash : '';

  if (history.pushState) {
    var loc = window.location;
    history.pushState(null, null, hash ? loc.pathname + loc.search + hash
    // remove hash
    : loc.pathname + loc.search);
  } else {
    location.hash = hash;
  }
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, '');
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t) {
  return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position === "relative" ? t.offsetTop : t.getBoundingClientRect().top + c.scrollTop;
};

exports.default = {
  pushHash: pushHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x === null ? NaN : +x;
});


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = linearish;
/* harmony export (immutable) */ __webpack_exports__["a"] = linear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tickFormat__ = __webpack_require__(1912);





function linearish(scale) {
  var domain = scale.domain;

  scale.ticks = function(count) {
    var d = domain();
    return Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(d[0], d[d.length - 1], count == null ? 10 : count);
  };

  scale.tickFormat = function(count, specifier) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__tickFormat__["a" /* default */])(domain(), count, specifier);
  };

  scale.nice = function(count) {
    if (count == null) count = 10;

    var d = domain(),
        i0 = 0,
        i1 = d.length - 1,
        start = d[i0],
        stop = d[i1],
        step;

    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }

    step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);

    if (step > 0) {
      start = Math.floor(start / step) * step;
      stop = Math.ceil(stop / step) * step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    } else if (step < 0) {
      start = Math.ceil(start * step) / step;
      stop = Math.floor(stop * step) / step;
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["f" /* tickIncrement */])(start, stop, count);
    }

    if (step > 0) {
      d[i0] = Math.floor(start / step) * step;
      d[i1] = Math.ceil(stop / step) * step;
      domain(d);
    } else if (step < 0) {
      d[i0] = Math.ceil(start * step) / step;
      d[i1] = Math.floor(stop * step) / step;
      domain(d);
    }

    return scale;
  };

  return scale;
}

function linear() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_2__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]);

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, linear());
  };

  return linearish(scale);
}


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* unused harmony reexport timeInterval */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__millisecond__ = __webpack_require__(1928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["a"]; });
/* unused harmony reexport timeMilliseconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__millisecond__["a"]; });
/* unused harmony reexport utcMilliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__second__ = __webpack_require__(1929);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["a"]; });
/* unused harmony reexport timeSeconds */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__second__["a"]; });
/* unused harmony reexport utcSeconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__minute__ = __webpack_require__(1930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__minute__["a"]; });
/* unused harmony reexport timeMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hour__ = __webpack_require__(1931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__hour__["a"]; });
/* unused harmony reexport timeHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__day__ = __webpack_require__(1932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__day__["a"]; });
/* unused harmony reexport timeDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__week__ = __webpack_require__(1933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["b"]; });
/* unused harmony reexport timeWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["b"]; });
/* unused harmony reexport timeSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["a"]; });
/* unused harmony reexport timeMondays */
/* unused harmony reexport timeTuesday */
/* unused harmony reexport timeTuesdays */
/* unused harmony reexport timeWednesday */
/* unused harmony reexport timeWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_6__week__["c"]; });
/* unused harmony reexport timeThursdays */
/* unused harmony reexport timeFriday */
/* unused harmony reexport timeFridays */
/* unused harmony reexport timeSaturday */
/* unused harmony reexport timeSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__month__ = __webpack_require__(1934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__month__["a"]; });
/* unused harmony reexport timeMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__year__ = __webpack_require__(1935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_8__year__["a"]; });
/* unused harmony reexport timeYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utcMinute__ = __webpack_require__(1936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_9__utcMinute__["a"]; });
/* unused harmony reexport utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utcHour__ = __webpack_require__(1937);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_10__utcHour__["a"]; });
/* unused harmony reexport utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utcDay__ = __webpack_require__(1938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_11__utcDay__["a"]; });
/* unused harmony reexport utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utcWeek__ = __webpack_require__(1939);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["b"]; });
/* unused harmony reexport utcWeeks */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["b"]; });
/* unused harmony reexport utcSundays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["a"]; });
/* unused harmony reexport utcMondays */
/* unused harmony reexport utcTuesday */
/* unused harmony reexport utcTuesdays */
/* unused harmony reexport utcWednesday */
/* unused harmony reexport utcWednesdays */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_12__utcWeek__["c"]; });
/* unused harmony reexport utcThursdays */
/* unused harmony reexport utcFriday */
/* unused harmony reexport utcFridays */
/* unused harmony reexport utcSaturday */
/* unused harmony reexport utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utcMonth__ = __webpack_require__(1940);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_13__utcMonth__["a"]; });
/* unused harmony reexport utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utcYear__ = __webpack_require__(1941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_14__utcYear__["a"]; });
/* unused harmony reexport utcYears */































/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
});


/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__path__ = __webpack_require__(1955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__path__["a"]; });



/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return atan2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return cos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return sin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return sqrt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return epsilon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return pi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return halfPi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tau; });
/* harmony export (immutable) */ __webpack_exports__["b"] = acos;
/* harmony export (immutable) */ __webpack_exports__["c"] = asin;
var abs = Math.abs;
var atan2 = Math.atan2;
var cos = Math.cos;
var max = Math.max;
var min = Math.min;
var sin = Math.sin;
var sqrt = Math.sqrt;

var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau = 2 * pi;

function acos(x) {
  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}

function asin(x) {
  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}


/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j = 0; j < m; ++j) {
      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
  }
});


/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var n = series.length, o = new Array(n);
  while (--n >= 0) o[n] = n;
  return o;
});


/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scope__ = __webpack_require__(795);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__scope__["b"]; });
/* unused harmony reexport Scope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hub__ = __webpack_require__(2062);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__hub__["a"]; });
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getMainCarrier */
/* unused harmony reexport Hub */
/* unused harmony reexport makeMain */
/* unused harmony reexport setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(801);
/* unused harmony reexport Span */
/* unused harmony reexport TRACEPARENT_REGEXP */



//# sourceMappingURL=index.js.map

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TradeButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UnitedHeaderLogic__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Timers__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Navigation_Language__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Navigation_Navigation__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Navigation_Hamburger__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__HeaderMain__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Private__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Helpdesk_Header__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__withErrorCatch__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Bell_Labels__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__hooks_useBonusTimer__ = __webpack_require__(172);
var _templateObject=_taggedTemplateLiteral(["\n  background-color: #1b546a;\n  color: #feac00;\n\n"],["\n  background-color: #1b546a;\n  color: #feac00;\n\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  max-width: 1300px;\n  height: 48px;\n  margin: 0 auto;\n  padding: 0 5px;\n\n  ",";\n\n  @media (min-width: 960px) {\n    height: 75px;\n    padding-left: 25px;\n  }\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: space-between;\n  max-width: 1300px;\n  height: 48px;\n  margin: 0 auto;\n  padding: 0 5px;\n\n  ",";\n\n  @media (min-width: 960px) {\n    height: 75px;\n    padding-left: 25px;\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      @media (max-width: 959px) {\n        height: 96px;\n        padding-bottom: 48px;\n      }\n    "],["\n      @media (max-width: 959px) {\n        height: 96px;\n        padding-bottom: 48px;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      @media (min-width: 960px) {\n        padding-left: 10px;\n      }\n\n      @media (min-width: 1100px) {\n        padding-left: 25px;\n      }\n    "],["\n      @media (min-width: 960px) {\n        padding-left: 10px;\n      }\n\n      @media (min-width: 1100px) {\n        padding-left: 25px;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      @media (max-width: 959px) {\n        height: 55px;\n        padding: 0;\n      }\n    "],["\n      @media (max-width: 959px) {\n        height: 55px;\n        padding: 0;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n"],["\n  position: relative;\n  display: flex;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  @media (min-width: 960px) {\n    margin-left: 10px;\n  }\n"],["\n  @media (min-width: 960px) {\n    margin-left: 10px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 75px;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: center;\n  align-content: center;\n\n  @media (max-width: 959px) {\n    height: 55px;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  @media (min-width: 960px) {\n    position: static;\n    flex-grow: 1;\n  }\n"],["\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  height: 75px;\n  display: flex;\n  flex-direction: row;\n  align-items: stretch;\n  justify-content: center;\n  align-content: center;\n\n  @media (max-width: 959px) {\n    height: 55px;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  @media (min-width: 960px) {\n    position: static;\n    flex-grow: 1;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 10px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: ",";\n  box-shadow: inset 0 -4px 0 0 transparent;\n\n  ",";\n\n  \n  ",";\n \n\n  &."," {\n    color: #fff;\n    box-shadow: inset 0 4px 0 0 ",";\n\n    ",";\n  }\n\n  @media (min-width: 960px) {\n    font-size: ",";\n    margin-left: 10px;\n  }\n\n  @media (max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 0;\n    width: 25%;\n    height: 100%;\n\n   \n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 10px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: ",";\n  box-shadow: inset 0 -4px 0 0 transparent;\n\n  ",";\n\n  \n  ",";\n \n\n  &."," {\n    color: #fff;\n    box-shadow: inset 0 4px 0 0 ",";\n\n    ",";\n  }\n\n  @media (min-width: 960px) {\n    font-size: ",";\n    margin-left: 10px;\n  }\n\n  @media (max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 0;\n    width: 25%;\n    height: 100%;\n\n   \n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n      color: rgba(255, 255, 255, 0.9);\n      box-shadow: none;\n      text-decoration: underline;\n    "],["\n      color: rgba(255, 255, 255, 0.9);\n      box-shadow: none;\n      text-decoration: underline;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n        color: #fff;\n        box-shadow: inset 0 4px 0 0 ",";\n    \n        ",";\n  "],["\n        color: #fff;\n        box-shadow: inset 0 4px 0 0 ",";\n    \n        ",";\n  "]),_templateObject12=_taggedTemplateLiteral(["\n        box-shadow: none;\n      "],["\n        box-shadow: none;\n      "]),_templateObject13=_taggedTemplateLiteral(["\n  &."," {\n    ",";\n\n    ",";\n  }\n"],["\n  &."," {\n    ",";\n\n    ",";\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n        color: ",";\n        box-shadow: inset 0 -4px 0 0 transparent;\n      "],["\n        color: ",";\n        box-shadow: inset 0 -4px 0 0 transparent;\n      "]),_templateObject15=_taggedTemplateLiteral(["\n        color: rgba(255, 255, 255, 0.5);\n        box-shadow: none;\n      "],["\n        color: rgba(255, 255, 255, 0.5);\n        box-shadow: none;\n      "]),_templateObject16=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  align-content: center;\n  flex-grow: 1;\n  height: 100%;\n\n  @media (min-width: 960px) {\n    ",";\n\n    ",";\n  }\n\n  @media (min-width: 1100px) {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    justify-content: space-between;\n  }\n"],["\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  align-content: center;\n  flex-grow: 1;\n  height: 100%;\n\n  @media (min-width: 960px) {\n    ",";\n\n    ",";\n  }\n\n  @media (min-width: 1100px) {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    justify-content: space-between;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n        margin-left: 56px;\n\n        & "," {\n          box-shadow: none;\n        }\n      "],["\n        margin-left: 56px;\n\n        & "," {\n          box-shadow: none;\n        }\n      "]),_templateObject18=_taggedTemplateLiteral(["\n        margin-left: 0;\n\n        > a {\n          margin-left: 5px;\n        }\n      "],["\n        margin-left: 0;\n\n        > a {\n          margin-left: 5px;\n        }\n      "]),_templateObject19=_taggedTemplateLiteral(["\n        margin-left: 0;\n\n        > a {\n          margin-left: 10px;\n        }\n      "],["\n        margin-left: 0;\n\n        > a {\n          margin-left: 10px;\n        }\n      "]),_templateObject20=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  align-self: center;\n  width: 88px;\n  height: 39px;\n  margin-right: 4px;\n  margin-left: 20px;\n  font-size: ",";\n  line-height: 1;\n  color: #fff;\n  text-transform: uppercase;\n  cursor: pointer;\n  user-select: none;\n  z-index: 11;\n\n  @media (max-width: 480px) {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ",";\n"],["\n  direction: ",";\n  position: relative;\n  align-self: center;\n  width: 88px;\n  height: 39px;\n  margin-right: 4px;\n  margin-left: 20px;\n  font-size: ",";\n  line-height: 1;\n  color: #fff;\n  text-transform: uppercase;\n  cursor: pointer;\n  user-select: none;\n  z-index: 11;\n\n  @media (max-width: 480px) {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n      @media (min-width: 960px) {\n        margin-left: 5px;\n      }\n\n      @media (min-width: 1100px) {\n        margin-left: 20px;\n      }\n    "],["\n      @media (min-width: 960px) {\n        margin-left: 5px;\n      }\n\n      @media (min-width: 1100px) {\n        margin-left: 20px;\n      }\n    "]),_templateObject22=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 17px;\n  height: 19px;\n  margin-right: 12px;\n  margin-top: 3px;\n\n  @media (max-width: 959px) {\n    width: 17px;\n    height: 22px;\n    margin-right: 5px;\n  }\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 17px;\n  height: 19px;\n  margin-right: 12px;\n  margin-top: 3px;\n\n  @media (max-width: 959px) {\n    width: 17px;\n    height: 22px;\n    margin-right: 5px;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  height: 47px;\n  padding: 0 20px;\n  margin-right: 0;\n  font-weight: 400;\n  font-size: 18px;\n  text-shadow: -1px -1px rgba(0, 0, 0, 0.2);\n  text-decoration: none;\n  color: #fff;\n  border-radius: 8px;\n  border: none;\n  border-bottom: 2px solid;\n  cursor: pointer;\n\n  :hover,\n  :active,\n  :focus {\n    color: #fff;\n  }\n\n  ",";\n  ",";\n\n  @media (max-width: 959px) {\n    min-width: 0;\n    height: 30px;\n    padding: 0 10px;\n    font-size: ",";\n    border-radius: 4px;\n    color: #fff;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  height: 47px;\n  padding: 0 20px;\n  margin-right: 0;\n  font-weight: 400;\n  font-size: 18px;\n  text-shadow: -1px -1px rgba(0, 0, 0, 0.2);\n  text-decoration: none;\n  color: #fff;\n  border-radius: 8px;\n  border: none;\n  border-bottom: 2px solid;\n  cursor: pointer;\n\n  :hover,\n  :active,\n  :focus {\n    color: #fff;\n  }\n\n  ",";\n  ",";\n\n  @media (max-width: 959px) {\n    min-width: 0;\n    height: 30px;\n    padding: 0 10px;\n    font-size: ",";\n    border-radius: 4px;\n    color: #fff;\n  }\n"]),_templateObject24=_taggedTemplateLiteral(["\n          border-bottom-color: ",";\n          background: #60a31c;\n          background: linear-gradient(to top, #60a31c, #68c703);\n\n          :hover,\n          :active,\n          :focus {\n            background: #68c703;\n            background: linear-gradient(to top, #68c703, #60a31c);\n          }\n        "],["\n          border-bottom-color: ",";\n          background: #60a31c;\n          background: linear-gradient(to top, #60a31c, #68c703);\n\n          :hover,\n          :active,\n          :focus {\n            background: #68c703;\n            background: linear-gradient(to top, #68c703, #60a31c);\n          }\n        "]),_templateObject25=_taggedTemplateLiteral(["\n          border-bottom-color: #cd7900;\n          background: #fd9500;\n          background: linear-gradient(\n            to top,\n            #fd9500,\n            ","\n          );\n\n          :hover,\n          :active,\n          :focus {\n            background: ",";\n            background: linear-gradient(\n              to top,\n              ",",\n              #fd9500\n            );\n          }\n        "],["\n          border-bottom-color: #cd7900;\n          background: #fd9500;\n          background: linear-gradient(\n            to top,\n            #fd9500,\n            ","\n          );\n\n          :hover,\n          :active,\n          :focus {\n            background: ",";\n            background: linear-gradient(\n              to top,\n              ",",\n              #fd9500\n            );\n          }\n        "]),_templateObject26=_taggedTemplateLiteral(["\n      background: none;\n      border: 2px solid #ffffff;\n      box-shadow: none;\n      text-shadow: none;\n\n      :hover,\n      :active,\n      :focus {\n        background: #ffffff;\n        color: #1b546a;\n        box-shadow: none;\n        text-shadow: none;\n\n        "," {\n          color: #1b546a;\n        }\n      }\n\n      @media (max-width: 959px) {\n        font-weight: 700;\n      }\n    "],["\n      background: none;\n      border: 2px solid #ffffff;\n      box-shadow: none;\n      text-shadow: none;\n\n      :hover,\n      :active,\n      :focus {\n        background: #ffffff;\n        color: #1b546a;\n        box-shadow: none;\n        text-shadow: none;\n\n        "," {\n          color: #1b546a;\n        }\n      }\n\n      @media (max-width: 959px) {\n        font-weight: 700;\n      }\n    "]),_templateObject27=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"],["\n  display: flex;\n  align-items: center;\n"]),_templateObject28=_taggedTemplateLiteral(["\n  display: flex;\n  margin-left: -19px;\n"],["\n  display: flex;\n  margin-left: -19px;\n"]),_templateObject29=_taggedTemplateLiteral(["\n  display: flex;\n  align-self: center;\n  margin-top: -4px;\n  margin-left: 5px;\n"],["\n  display: flex;\n  align-self: center;\n  margin-top: -4px;\n  margin-left: 5px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var activeClassName="active";var HeaderContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.showLinks&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(_ref){var isLoggedIn=_ref.isLoggedIn,isHelpdesk=_ref.isHelpdesk;return isLoggedIn&&isHelpdesk&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);},function(props){return props.isApp&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);});var LeftContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var RightContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(LeftContainer)(_templateObject7);var MiddleContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var LinkItem=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__common_Link__["c" /* OptionalLink */]).attrs({activeClassName:activeClassName})(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.theme.lightWhiteForeground;},function(props){return props.isMainPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11,function(props){return props.theme.accent;},function(props){return props.isMainPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);});},activeClassName,function(props){return props.theme.accent;},function(props){return props.isMainPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);},Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(14));var AboutLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(LinkItem).attrs({activeClassName:activeClassName})(_templateObject13,activeClassName,function(props){return!props.isAbout&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14,function(props){return props.theme.staticHeaderLink;});},function(props){return props.isMainPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject15);});var LinksContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.isHelpdesk&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17,LinkItem);},function(_ref2){var noMargin=_ref2.noMargin;return noMargin&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject18);},function(_ref3){var noMargin=_ref3.noMargin;return noMargin&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject19);});var ChooseLanguage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20,function(_ref4){var theme=_ref4.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(12),function(_ref5){var noMargin=_ref5.noMargin;return noMargin&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject21);});var TradeIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22);var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__common_Link__["a" /* Link */])(_templateObject23,function(_ref6){var theme=_ref6.theme,type=_ref6.type;switch(type){case"deposit":return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject24,function(props){return props.theme.upperBorder;});case"trade":default:return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject25,function(props){return props.theme.accent;},function(props){return props.theme.accent;},function(props){return props.theme.accent;});}},"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject26,TradeIcon),Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(12));var ButtonsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject27);var ToggleNavContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject28);var ToggleNavMobile=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject29);var ApplicationMiddleLinks=function ApplicationMiddleLinks(_ref7){var isHelpdesk=_ref7.isHelpdesk,pathname=_ref7.pathname,isMainPage=_ref7.isMainPage;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinksContainer,{isHelpdesk:isHelpdesk},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkItem,{to:"/",active:pathname==="/"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Analytics")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkItem,{to:"/contacts",href:__WEBPACK_IMPORTED_MODULE_6__common_fetch__["a" /* NEWS_LINK */],active:pathname.indexOf('contacts')>0},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Contacts")));};var ApplicationHeader=function ApplicationHeader(_ref8){var isMainPage=_ref8.isMainPage,showLinks=_ref8.showLinks;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderContainer,{isMainPage:isMainPage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,{showLinks:showLinks(),isApp:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MiddleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ApplicationMiddleLinks,{pathname:window.location.pathname}))));};function TradeButton(props){return null;}var DepositButton=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_8__Timers__["b" /* mapStateToTime */])(function(_ref9){var suggestedPromoCode=_ref9.suggestedPromoCode,time=_ref9.time;var bonus=Object(__WEBPACK_IMPORTED_MODULE_21__hooks_useBonusTimer__["a" /* useBonusTimerApi */])({time:time});if(bonus==null||bonus.duration<0||bonus.status!=="available"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{type:"deposit",to:suggestedPromoCode!=null?"/fillup?promocode="+suggestedPromoCode:"/fillup",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_18__GA__["a" /* gaReducer */])("CLICKLINK_TRADE_DEPOSIT_HEADER",{linkText:e.currentTarget.textContent,pageUrl:window.document.location.href});},className:"intercept-noauth"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Deposit"));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{type:"deposit",to:bonus.promo!=null?"/fillup?promocode="+bonus.promo:"/fillup",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_18__GA__["a" /* gaReducer */])("CLICKLINK_TRADE_DEPOSIT_HEADER",{linkText:e.currentTarget.textContent,pageUrl:window.document.location.href});},className:"intercept-noauth"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Deposit"));});function MiddleLinks(_ref10){var isHelpdesk=_ref10.isHelpdesk,isNews=_ref10.isNews,pathname=_ref10.pathname,isMainPage=_ref10.isMainPage,noMargin=_ref10.noMargin;var isAbout=pathname.split("/")[1]==="aboutus";var isContacts=pathname.split("/")[1]==="contacts";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinksContainer,{isHelpdesk:isHelpdesk,noMargin:noMargin},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkItem,{to:"/",active:isMainPage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"News")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AboutLink,{to:"/aboutus",active:isAbout,isMainPage:isMainPage},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"About us")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkItem,{to:"/contacts",href:__WEBPACK_IMPORTED_MODULE_6__common_fetch__["a" /* NEWS_LINK */],active:isContacts},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Contacts"))));}window.isApp=/wvbo/g.test(window.navigator.userAgent)&&!/wvbo_full/g.test(window.navigator.userAgent);window.isFullAndroidApp=/wvbo_full/g.test(window.navigator.userAgent);function UnitedHeader(props){var suggestedPromoCode=Object(__WEBPACK_IMPORTED_MODULE_20__Bell_Labels__["c" /* useSuggestedPromoCode */])();if(/ironterminal/g.test(window.navigator.userAgent.toLowerCase())||__WEBPACK_IMPORTED_MODULE_9__utils__["d" /* isIronTerminalIosApp */])return null;var shouldDisplayMenuButton=window.location.pathname!=="/password-update";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__UnitedHeaderLogic__["a" /* default */],props,function(_ref11){var dispatch=_ref11.dispatch,onLocaleChange=_ref11.onLocaleChange,match=_ref11.match,location=_ref11.location,history=_ref11.history,query=_ref11.query,isIOS=_ref11.isIOS,appVersion=_ref11.appVersion,currencySettings=_ref11.currencySettings,isAndroidApp=_ref11.isAndroidApp,isVIP=_ref11.isVIP,geo=_ref11.geo,locale=_ref11.locale,locales=_ref11.locales,profile=_ref11.profile,profileStatus=_ref11.profileStatus,authTab=_ref11.authTab,shouldDisplayMainHeader=_ref11.shouldDisplayMainHeader,showMainHeader=_ref11.showMainHeader,showDeposit=_ref11.showDeposit,changeLocaleFetching=_ref11.changeLocaleFetching,isNavActive=_ref11.isNavActive,isLoggedIn=_ref11.isLoggedIn,isAppLogin=_ref11.isAppLogin,isHelpdesk=_ref11.isHelpdesk,isNews=_ref11.isNews,isMainPage=_ref11.isMainPage,showLangSelect=_ref11.showLangSelect,isMobileApp=_ref11.isMobileApp,isInnerHeader=_ref11.isInnerHeader,toggle=_ref11.toggle,hide=_ref11.hide,showTopLinks=_ref11.showTopLinks,showLinks=_ref11.showLinks,showLoginForm=_ref11.showLoginForm,changeXLocaleWithLocale=_ref11.changeXLocaleWithLocale;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ThemeProvider__["a" /* IronRedesignThemeProvider */],{isInnerHeader:isInnerHeader,theme:profile&&profile.currency==="THB"?"thProjectTrade":null},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,window.isApp?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ApplicationHeader,{isMainPage:isMainPage,showLinks:showLinks,isLoggedIn:isLoggedIn,isHelpdesk:isHelpdesk,isNews:isNews,pathname:location.pathname}):(!isAndroidApp||window.isFullAndroidApp)&&!(isIOS&&appVersion>=2000000)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderContainer,{isMainPage:isMainPage,isTransparent:props.isTransparent},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,{showLinks:showLinks(),isLoggedIn:isLoggedIn,isHelpdesk:isHelpdesk},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LeftContainer,null,shouldDisplayMenuButton&&isLoggedIn&&Object(__WEBPACK_IMPORTED_MODULE_14__Private__["b" /* isProfileComplete */])(profile)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(max-width: 959px)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToggleNavMobile,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Navigation_Hamburger__["a" /* default */],{active:isNavActive,onClick:toggle,isIOS:isIOS})))),showLinks()&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MiddleContainer,null,isHelpdesk||isNews?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Helpdesk_Header__["b" /* HelpdeskSearch */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MiddleLinks,{isMainPage:isMainPage,isHelpdesk:isHelpdesk,noMargin:isLoggedIn,isNews:isNews,pathname:location.pathname})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MiddleLinks,{pathname:location.pathname,isMainPage:isMainPage})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightContainer,null,showTopLinks()&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonsContainer,null,props.hideTradeButton!==true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TradeButton,{className:"intercept-noauth"}),isLoggedIn&&Object(__WEBPACK_IMPORTED_MODULE_14__Private__["b" /* isProfileComplete */])(profile)&&match.path!=="/fillup"&&match.path!=="/billing/offline"&&showDeposit===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositButton,{suggestedPromoCode:suggestedPromoCode})),showLangSelect&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ChooseLanguage,{noMargin:isLoggedIn&&(isHelpdesk||isNews)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Navigation_Language__["a" /* LangSelect */],{locale:locale,locales:locales,showLoader:changeLocaleFetching,onLocaleChange:changeXLocaleWithLocale})),shouldDisplayMenuButton&&isLoggedIn&&Object(__WEBPACK_IMPORTED_MODULE_14__Private__["b" /* isProfileComplete */])(profile)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 960px)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToggleNavContainer,{className:"intercept-noauth"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Navigation_Hamburger__["a" /* default */],{active:isNavActive,onClick:toggle,isIOS:isIOS})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Navigation_Navigation__["a" /* default */],{open:isNavActive,onClose:hide,profile:profile,changeLocaleFetching:changeLocaleFetching,onLocaleChange:changeXLocaleWithLocale,isVIP:isVIP,hideLangSelect:true}))),isHelpdesk&&"irontrade"!=="eztrader"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Helpdesk_Header__["a" /* HelpdeskHeader */],{showContactUs:profile&&profile.real===1}),shouldDisplayMainHeader&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__HeaderMain__["b" /* default */],{query:query,authTab:authTab,geo:geo,isVIP:isVIP,profile:profile,isLoggedIn:isLoggedIn,currencySettings:currencySettings,profileStatus:profileStatus,dispatch:dispatch,isAppLogin:isAppLogin,location:location,history:history,isHelpdesk:isHelpdesk})));});}/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_19__withErrorCatch__["a" /* default */])(UnitedHeader));

/***/ }),
/* 220 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Info;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoTour; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Info(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"18px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 18 18",width:width,fill:fill,fillRule:"evenodd"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z",transform:"translate(-933.016 -299)"}));}var InfoTour=function InfoTour(_ref2){var _ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"currentColor":_ref2$fill,_ref2$width=_ref2.width,width=_ref2$width===undefined?"30px":_ref2$width,props=_objectWithoutProperties(_ref2,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 30 30",width:width,fill:fill},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0,30V15A15,15,0,1,1,15,30ZM3.8,15A11.2,11.2,0,1,0,15,3.8,11.217,11.217,0,0,0,3.8,15Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(12.545 7.965)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0.447)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"1.782",cy:"1.782",r:"1.782"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 5.253)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M209.81,224.716H204.9v-2.382h.9v-4.053h-.888V215.9h4v6.435h.9Z",transform:"translate(-204.9 -215.9)"}))));};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(1499),
    isObject = __webpack_require__(76);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_select__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  height: 40px;\n  min-width: 180px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n\n  ",";\n\n  @media (max-width: 959px) {\n    height: 32px;\n    font-size: ",";\n  }\n\n  .react-select__control {\n    height: 100%;\n    font-size: inherit;\n    line-height: inherit;\n    border: 1px solid #cccccc;\n    border-radius: 4px;\n    background-color: ",";\n    color: ",";\n  }\n\n  .react-select__single-value {\n    color: ",";\n  }\n\n  .react-select__value-container,\n  .react-select__placeholder {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-content: flex-start;\n    align-items: center;\n    font-size: inherit;\n    line-height: inherit;\n    height: 100%;\n    color: rgb(207, 207, 207);\n  }\n\n  .react-select__value-container--has-value {\n    color: #4e2a81;\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__dropdown-indicator {\n    ",";\n  }\n\n  .react-select__menu {\n    background-color: ",";\n    margin-top: 0;\n  }\n\n  .react-select__option {\n    background-color: ",";\n    color: ",";\n    &--is-selected {\n      background-color: ",";\n      color: ",";\n    }\n\n    &--is-focused {\n      background-color: ",";\n      color: ",";\n    }\n  }\n"],["\n  height: 40px;\n  min-width: 180px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n\n  ",";\n\n  @media (max-width: 959px) {\n    height: 32px;\n    font-size: ",";\n  }\n\n  .react-select__control {\n    height: 100%;\n    font-size: inherit;\n    line-height: inherit;\n    border: 1px solid #cccccc;\n    border-radius: 4px;\n    background-color: ",";\n    color: ",";\n  }\n\n  .react-select__single-value {\n    color: ",";\n  }\n\n  .react-select__value-container,\n  .react-select__placeholder {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-content: flex-start;\n    align-items: center;\n    font-size: inherit;\n    line-height: inherit;\n    height: 100%;\n    color: rgb(207, 207, 207);\n  }\n\n  .react-select__value-container--has-value {\n    color: #4e2a81;\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__dropdown-indicator {\n    ",";\n  }\n\n  .react-select__menu {\n    background-color: ",";\n    margin-top: 0;\n  }\n\n  .react-select__option {\n    background-color: ",";\n    color: ",";\n    &--is-selected {\n      background-color: ",";\n      color: ",";\n    }\n\n    &--is-focused {\n      background-color: ",";\n      color: ",";\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      width: ",";\n    "],["\n      width: ",";\n    "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Select=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_select__["b" /* default */])(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(16),function(_ref){var width=_ref.width;return width&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,width);},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref2){var theme=_ref2.theme;return theme.calendarBackground?theme.mainDark:"#fff";},function(_ref3){var theme=_ref3.theme;return theme.calendarInputColor?theme.calendarInputColor+" !important":"#4e2a81";},function(_ref4){var theme=_ref4.theme;return theme.calendarInputColor?theme.calendarInputColor+" !important":"#4e2a81";},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["c" /* rtl */])("padding-left",0),function(_ref5){var theme=_ref5.theme;return theme.calendarBackground&&theme.mainDark;},function(_ref6){var theme=_ref6.theme;return theme.calendarBackground&&theme.mainDark;},function(_ref7){var theme=_ref7.theme;return theme.calendarBackground&&"rgba(255, 255, 255, 0.58)";},function(_ref8){var theme=_ref8.theme;return theme.calendarBackground&&theme.mainLight;},function(_ref9){var theme=_ref9.theme;return theme.calendarBackground&&"#ffffff";},function(_ref10){var theme=_ref10.theme;return theme.calendarBackground&&theme.mainLight;},function(_ref11){var theme=_ref11.theme;return theme.calendarBackground&&"#ffffff";});/* harmony default export */ __webpack_exports__["a"] = (function(_ref12){var options=_ref12.options,className=_ref12.className,onChange=_ref12.onChange,minWidth=_ref12.minWidth,other=_objectWithoutProperties(_ref12,["options","className","onChange","minWidth"]);var logChange=function logChange(val){console.log("selected value: "+val.value);};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Select,Object.assign({className:className,classNamePrefix:"react-select",options:options,onChange:onChange||logChange,isClearable:false,isSearchable:false,isMulti:false},other));});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isLandscape;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Orientation=function(_Component){_inherits(Orientation,_Component);function Orientation(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Orientation);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Orientation.__proto__||Object.getPrototypeOf(Orientation)).call.apply(_ref,[this].concat(args))),_this),_this.state={orientation:window.innerWidth>window.innerHeight},_this.handleOrientationChange=function(){_this.setState({orientation:window.innerWidth>window.innerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Orientation,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var loop=function loop(){if(_this2.active){var _orientation=_this2.state.orientation;if(window.innerHeight>=320){var nextOrientation=window.innerWidth>window.innerHeight;if(_orientation!==nextOrientation){_this2.setState({orientation:nextOrientation});}}requestAnimationFrame(loop);}};this.active=true;loop();}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.active=false;}},{key:"render",value:function render(){if(typeof this.props.children!=="function"){return null;}return this.props.children(this.state.orientation);}}]);return Orientation;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Orientation);function isLandscape(isLandscape){return isLandscape;}

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  from {\n    transform: rotateX(-60deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n"],["\n  from {\n    transform: rotateX(-60deg);\n    opacity: 0;\n  }\n\n  to {\n    transform: rotateX(0deg);\n    opacity: 1;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  @media (min-width: 960px) {\n    perspective: ",";\n    backface-visibility: hidden;\n\n    > div {\n      transform-style: preserve-3d;\n      transform-origin: 50% 0;\n      animation: "," ",";\n    }\n  }\n"],["\n  @media (min-width: 960px) {\n    perspective: ",";\n    backface-visibility: hidden;\n\n    > div {\n      transform-style: preserve-3d;\n      transform-origin: 50% 0;\n      animation: "," ",";\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var show=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["e" /* keyframes */])(_templateObject);var AnimationWrapper=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.perspective;},show,function(props){return props.theme.showAnimation;});/* harmony default export */ __webpack_exports__["a"] = (AnimationWrapper);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoIcon; });
/* unused harmony export ErrorIcon */
/* unused harmony export BackIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: 7px;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  fill: ",";\n\n  ",";\n"],["\n  display: inline-block;\n  margin-right: 7px;\n  width: 16px;\n  min-width: 16px;\n  height: 16px;\n  fill: ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      margin-right: 0;\n      margin-left: 7px;\n    "],["\n      margin-right: 0;\n      margin-left: 7px;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  flex-shrink: 0;\n  width: 18px;\n  height: 17px;\n  margin-right: 10px;\n  fill: ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  flex-shrink: 0;\n  width: 18px;\n  height: 17px;\n  margin-right: 10px;\n  fill: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: inline-block;\n  width: 19px;\n  height: 16px;\n  margin-right: 7px;\n  fill: #a5a4a4;\n  fill-rule: evenodd;\n"],["\n  display: inline-block;\n  width: 19px;\n  height: 16px;\n  margin-right: 7px;\n  fill: #a5a4a4;\n  fill-rule: evenodd;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InfoSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject,function(_ref){var fillColor=_ref.fillColor;return fillColor||"rgb(165, 164, 164)";},function(props){return props.verification&&props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var ErrorSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject3,function(props){return props.theme.lower;});var BackSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject4);var InfoIcon=function InfoIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",fillColor:props.fill},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.006,0.011 C3.590,0.011 0.010,3.591 0.010,8.007 C0.010,12.423 3.590,16.002 8.006,16.002 C12.422,16.002 16.001,12.423 16.001,8.007 C16.001,3.591 12.422,0.011 8.006,0.011 ZM7.007,3.990 L9.014,3.990 L9.014,5.965 L7.007,5.965 L7.007,3.990 ZM9.986,11.959 L6.004,11.959 L6.004,10.956 L7.007,10.956 L7.007,8.006 L6.004,8.006 L6.004,7.003 L9.014,7.003 L9.014,10.956 L9.986,10.956 L9.986,11.959 Z"}));};var ErrorIcon=function ErrorIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 18 17"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M17.465,12.999 L11.262,2.256 C10.249,0.481 7.686,0.481 6.677,2.256 L0.470,12.999 C-0.543,14.774 0.718,16.978 2.763,16.978 L15.151,16.978 C17.195,16.978 18.478,14.752 17.465,12.999 ZM8.966,14.595 C8.426,14.595 7.978,14.147 7.978,13.608 C7.978,13.068 8.426,12.620 8.966,12.620 C9.505,12.620 9.953,13.068 9.932,13.633 C9.957,14.147 9.483,14.595 8.966,14.595 ZM9.866,8.210 C9.822,8.976 9.775,9.737 9.731,10.503 C9.709,10.750 9.709,10.976 9.709,11.221 C9.687,11.625 9.370,11.938 8.966,11.938 C8.561,11.938 8.248,11.647 8.222,11.242 C8.157,10.051 8.087,8.881 8.022,7.689 C8.000,7.376 7.978,7.059 7.953,6.746 C7.953,6.228 8.244,5.802 8.718,5.667 C9.192,5.554 9.662,5.780 9.866,6.228 C9.935,6.385 9.957,6.541 9.957,6.724 C9.935,7.223 9.888,7.719 9.866,8.210 Z"}));};var BackIcon=function BackIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BackSvg,{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 19 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.043,0.485 L1.241,7.287 C0.845,7.683 0.845,8.326 1.241,8.722 L8.043,15.524 C8.439,15.920 9.082,15.920 9.478,15.524 C9.874,15.127 9.874,14.485 9.478,14.088 L4.386,8.997 L17.972,8.997 C18.532,8.997 18.987,8.543 18.987,7.982 C18.987,7.422 18.532,6.968 17.972,6.968 L4.431,6.968 L9.478,1.920 C9.874,1.524 9.874,0.882 9.478,0.485 C9.082,0.089 8.439,0.089 8.043,0.485 Z"}));};

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var simpleIsEqual = function simpleIsEqual(a, b) {
  return a === b;
};

function index (resultFn, isEqual) {
  if (isEqual === void 0) {
    isEqual = simpleIsEqual;
  }

  var lastThis;
  var lastArgs = [];
  var lastResult;
  var calledOnce = false;

  var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
    return isEqual(newArg, lastArgs[index]);
  };

  var result = function result() {
    for (var _len = arguments.length, newArgs = new Array(_len), _key = 0; _key < _len; _key++) {
      newArgs[_key] = arguments[_key];
    }

    if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
      return lastResult;
    }

    lastResult = resultFn.apply(this, newArgs);
    calledOnce = true;
    lastThis = this;
    lastArgs = newArgs;
    return lastResult;
  };

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (index);


/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AnimationWrapper__ = __webpack_require__(225);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n  user-select: none;\n  z-index: 20000;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n  @media (max-width: 568px) {\n    font-size: 7px;\n  }\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n  user-select: none;\n  z-index: 20000;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n  @media (max-width: 568px) {\n    font-size: 7px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 1;\n  width: 100%;\n  max-width: 74em;\n  max-height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  background-color: ",";\n  border-radius: 0.5em;\n  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 1);\n\n  @media (max-width: 959px) {\n    max-width: 50em;\n  }\n"],["\n  position: relative;\n  flex-shrink: 1;\n  width: 100%;\n  max-width: 74em;\n  max-height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  background-color: ",";\n  border-radius: 0.5em;\n  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 1);\n\n  @media (max-width: 959px) {\n    max-width: 50em;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 18px;\n  height: 18px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  z-index: 1;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0;\n    height: 24px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n\n  @media (max-width: 959px) {\n    top: 14px;\n    right: 14px;\n    width: 26px;\n    height: 26px;\n\n    :before,\n    :after {\n      top: -4px;\n      height: 36px;\n    }\n  }\n"],["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 18px;\n  height: 18px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.15s ease;\n  cursor: pointer;\n  z-index: 1;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0;\n    height: 24px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n\n  @media (max-width: 959px) {\n    top: 14px;\n    right: 14px;\n    width: 26px;\n    height: 26px;\n\n    :before,\n    :after {\n      top: -4px;\n      height: 36px;\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.popupBackground;});var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);function Modal(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,{key:props.key},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_ClickOutside__["a" /* default */],{onOutsideClick:props.disableOutside?null:props.onDismiss},function(_ref2){var innerRef=_ref2.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__AnimationWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,{ref:innerRef,className:props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:props.onDismiss}),props.children));}));}/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  cursor: pointer;\n"],["\n  display: inline-block;\n  cursor: pointer;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Link=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject);/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(72);
var global = __webpack_require__(17);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(113) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(35);
var toAbsoluteIndex = __webpack_require__(127);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 233 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(74);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(21);
var cof = __webpack_require__(74);
var MATCH = __webpack_require__(28)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(28)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(15);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var hide = __webpack_require__(59);
var redefine = __webpack_require__(60);
var fails = __webpack_require__(20);
var defined = __webpack_require__(84);
var wks = __webpack_require__(28);

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(15);
var aFunction = __webpack_require__(47);
var SPECIES = __webpack_require__(28)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(60);
var redefineAll = __webpack_require__(133);
var meta = __webpack_require__(112);
var forOf = __webpack_require__(132);
var anInstance = __webpack_require__(131);
var isObject = __webpack_require__(21);
var fails = __webpack_require__(20);
var $iterDetect = __webpack_require__(236);
var setToStringTag = __webpack_require__(153);
var inheritIfRequired = __webpack_require__(331);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var hide = __webpack_require__(59);
var uid = __webpack_require__(125);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Forced replacement prototype accessors methods
module.exports = __webpack_require__(113) || !__webpack_require__(20)(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete __webpack_require__(17)[K];
});


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-setmap-offrom/
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(47);
var ctx = __webpack_require__(73);
var forOf = __webpack_require__(132);

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(1145),
    listCacheDelete = __webpack_require__(1146),
    listCacheGet = __webpack_require__(1147),
    listCacheHas = __webpack_require__(1148),
    listCacheSet = __webpack_require__(1149);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(358);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(1151);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(158),
    toKey = __webpack_require__(136);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(556),
    eq = __webpack_require__(358);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = readSignInParameters;
/* harmony export (immutable) */ __webpack_exports__["b"] = flushSignInParameters;
/* unused harmony export readLogInParameters */
/* unused harmony export flushLogInParameters */
/* harmony export (immutable) */ __webpack_exports__["c"] = getSub0;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Белый список параметров, которые следует отправить при регистрации
var SIGN_IN_PARAMETERS=["subid","site_domain","clickid","sub0","sub1","sub2","sub3","sub4","sub5","sub6","sub7","sub8","sub9"];// Белый список параметров, которые мы шлём в стату при каждом посещении
var LOG_IN_PARAMETERS=["sub7","sub8","sub9","notification_id"];// Клеим рандом строку к ключу стораджа чтобы если что — ретироваться
var HASHED_STORAGE_KEY_SIGN_IN="subzero_dgetwbcl";var HASHED_STORAGE_KEY_LOG_IN="subzero_gvrh3pfk";function readSignInParameters(){var payload=null;try{payload=localStorage.getItem(HASHED_STORAGE_KEY_SIGN_IN);}catch(error){}try{return payload!=null?__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(payload):{};}catch(error){return{};}}function flushSignInParameters(){try{localStorage.removeItem(HASHED_STORAGE_KEY_SIGN_IN);}catch(error){}}function readLogInParameters(){var payload=null;try{payload=localStorage.getItem(HASHED_STORAGE_KEY_LOG_IN);}catch(error){}try{return payload!=null?__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(payload):{};}catch(error){return{};}}function flushLogInParameters(){try{localStorage.removeItem(HASHED_STORAGE_KEY_LOG_IN);}catch(error){}}function getSub0(location,serverData){var payload=readSignInParameters();if(!payload.sub0){payload=readLogInParameters();}if(payload.sub0){return payload.sub0;}var isHelpdesk=location.pathname.includes("helpdesk");var ua=window.navigator.userAgent.toLowerCase();// iOS Terminal
var isIosTerminal=/com.ironterminal.ios/g.test(ua);// Android Webview full app
var isWebView=/wvbo_full/g.test(ua);// Android Webview analytics
var isAnalyticsWebView="irontrade"==="irontrade"&&/androidweb.*com\.irontrade\.analytics.*wvbo/g.test(ua)&&!isWebView;// iOS Webview Analytics
var isIosAnalyticsWebView=/iosweb.*com\.full\.iron.*wvbo_full/.test(ua);switch(true){case isHelpdesk&&serverData.isIOS:return"ios_helpdesk";case serverData.isIOS&&serverData.app_version>0:return"webview-ios";case isIosTerminal:return"webview-ios-terminal";case isIosAnalyticsWebView:return"webview-ios-analytics";case isWebView:return"webview-android";case isAnalyticsWebView:return"webview-android-analytics";case isHelpdesk:return"helpdesk";case serverData.isMobile:return"web-mobile";default:return"web-desktop";}}var PersistLogInParameters=function(_React$Component){_inherits(PersistLogInParameters,_React$Component);function PersistLogInParameters(){_classCallCheck(this,PersistLogInParameters);return _possibleConstructorReturn(this,(PersistLogInParameters.__proto__||Object.getPrototypeOf(PersistLogInParameters)).apply(this,arguments));}_createClass(PersistLogInParameters,[{key:"componentDidMount",value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(this.props.location.search.slice(1));var toPersist=Object.keys(query).filter(function(p){return LOG_IN_PARAMETERS.includes(p);});if(toPersist.length>0){var payload=toPersist.reduce(function(payload,p){payload[p]=query[p];return payload;},{});if(!("sub0"in payload)){payload.sub0=getSub0(this.props.location,this.props.serverData);}try{localStorage.setItem(HASHED_STORAGE_KEY_LOG_IN,__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify(payload));}catch(error){}}}},{key:"render",value:function render(){return null;}}]);return PersistLogInParameters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PersistSignInParameters=function(_React$Component2){_inherits(PersistSignInParameters,_React$Component2);function PersistSignInParameters(){_classCallCheck(this,PersistSignInParameters);return _possibleConstructorReturn(this,(PersistSignInParameters.__proto__||Object.getPrototypeOf(PersistSignInParameters)).apply(this,arguments));}_createClass(PersistSignInParameters,[{key:"componentDidMount",value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(this.props.location.search.slice(1));var toPersist=Object.keys(query).filter(function(p){return SIGN_IN_PARAMETERS.includes(p);});if(toPersist.length>0){var payload=toPersist.reduce(function(payload,p){payload[p]=query[p];return payload;},{});if(!("sub0"in payload)){payload.sub0=getSub0(this.props.location,this.props.serverData);}try{localStorage.setItem(HASHED_STORAGE_KEY_SIGN_IN,__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify(payload));}catch(error){}}}},{key:"render",value:function render(){return null;}}]);return PersistSignInParameters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var SubmitLogInParameters=function(_React$Component3){_inherits(SubmitLogInParameters,_React$Component3);function SubmitLogInParameters(){_classCallCheck(this,SubmitLogInParameters);return _possibleConstructorReturn(this,(SubmitLogInParameters.__proto__||Object.getPrototypeOf(SubmitLogInParameters)).apply(this,arguments));}_createClass(SubmitLogInParameters,[{key:"componentDidMount",value:function componentDidMount(){var query=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(this.props.location.search.slice(1));var toSubmit=Object.keys(query).filter(function(p){return LOG_IN_PARAMETERS.includes(p);});if(toSubmit.length>0){var payload=toSubmit.reduce(function(payload,p){payload[p]=query[p];return payload;},{});if(!("sub0"in payload)){payload.sub0=getSub0(this.props.location,this.props.serverData);}Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/api/rewrite-sub?"+__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify(payload));}else{var _payload=readLogInParameters();if(Object.keys(_payload).length>0){Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/api/rewrite-sub?"+__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify(_payload)).then(function(){flushLogInParameters();});}}}},{key:"render",value:function render(){return null;}}]);return SubmitLogInParameters;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function Subzero(props){if(props.serverData==null){return null;}else{if(props.profile==null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PersistLogInParameters,{serverData:props.serverData,location:props.location}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PersistSignInParameters,{serverData:props.serverData,location:props.location}));}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubmitLogInParameters,{serverData:props.serverData,location:props.location});}}}function mapStateToProps(state){return{serverData:state.serverData,profile:state.profile};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Subzero)));

/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseIncompletePhoneNumber;
/* unused harmony export parsePhoneNumberCharacter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(70);


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * // Outputs '+7800555'.
 * ```
 */
function parseIncompletePhoneNumber(string) {
	var result = '';

	// Using `.split('')` here instead of normal `for ... of`
	// because the importing application doesn't neccessarily include an ES6 polyfill.
	// The `.split('')` approach discards "exotic" UTF-8 characters
	// (the ones consisting of four bytes) but digits
	// (including non-European ones) don't fall into that range
	// so such "exotic" characters would be discarded anyway.
	for (var _iterator = string.split(''), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var character = _ref;

		result += parsePhoneNumberCharacter(character, result) || '';
	}

	return result;
}

/**
 * `input-format` `parse()` function.
 * https://github.com/catamphetamine/input-format
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string} value - The value parsed so far.
 * @param  {object} meta - Optional custom use-case-specific metadata.
 * @return {string?} The parsed character.
 */
function parsePhoneNumberCharacter(character, value) {
	// Only allow a leading `+`.
	if (character === '+') {
		// If this `+` is not the first parsed character
		// then discard it.
		if (value) {
			return;
		}

		return '+';
	}

	// Allow digits.
	return Object(__WEBPACK_IMPORTED_MODULE_0__common__["j" /* parseDigit */])(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = limit;
/* harmony export (immutable) */ __webpack_exports__["d"] = trimAfterFirstMatch;
/* harmony export (immutable) */ __webpack_exports__["c"] = startsWith;
/* harmony export (immutable) */ __webpack_exports__["a"] = endsWith;
/** Returns a regular expression quantifier with an upper and lower limit. */
function limit(lower, upper) {
	if (lower < 0 || upper <= 0 || upper < lower) {
		throw new TypeError();
	}
	return "{" + lower + "," + upper + "}";
}

/**
 * Trims away any characters after the first match of {@code pattern} in {@code candidate},
 * returning the trimmed version.
 */
function trimAfterFirstMatch(regexp, string) {
	var index = string.search(regexp);

	if (index >= 0) {
		return string.slice(0, index);
	}

	return string;
}

function startsWith(string, substring) {
	return string.indexOf(substring) === 0;
}

function endsWith(string, substring) {
	return string.indexOf(substring, string.length - substring.length) === string.length - substring.length;
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(383);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1299)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(603)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(116).f;
var has = __webpack_require__(137);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1304);
var global = __webpack_require__(55);
var hide = __webpack_require__(138);
var Iterators = __webpack_require__(162);
var TO_STRING_TAG = __webpack_require__(56)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 265 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_RowRendererParams */
/* unused harmony export bpfrpt_proptype_RowRenderer */
/* unused harmony export bpfrpt_proptype_RenderedRows */
/* unused harmony export bpfrpt_proptype_Scroll */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);


var bpfrpt_proptype_RowRendererParams =  true ? null : {
  index: PropTypes.number.isRequired,
  isScrolling: PropTypes.bool.isRequired,
  isVisible: PropTypes.bool.isRequired,
  key: PropTypes.string.isRequired,
  parent: PropTypes.object.isRequired,
  style: PropTypes.object.isRequired
};
var bpfrpt_proptype_RowRenderer =  true ? null : PropTypes.func;
var bpfrpt_proptype_RenderedRows =  true ? null : {
  overscanStartIndex: PropTypes.number.isRequired,
  overscanStopIndex: PropTypes.number.isRequired,
  startIndex: PropTypes.number.isRequired,
  stopIndex: PropTypes.number.isRequired
};
var bpfrpt_proptype_Scroll =  true ? null : {
  clientHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollTop: PropTypes.number.isRequired
};






/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 270 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 271 */
/***/ (function(module, exports) {

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

module.exports = _inheritsLoose;

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  display: inline-block;\n  min-width: 130px;\n  min-height: 33px;\n  box-sizing: border-box;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  color: #fff;\n  background-color: #877c95;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    background-color: #706281;\n    outline: none;\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  direction: ",";\n  display: inline-block;\n  min-width: 130px;\n  min-height: 33px;\n  box-sizing: border-box;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  color: #fff;\n  background-color: #877c95;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    background-color: #706281;\n    outline: none;\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "],["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      position: relative;\n      font-weight: bold;\n      color: #ffffff;\n      text-decoration: none;\n      background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n      border-radius: 32px;\n      cursor: pointer;\n      z-index: 2;\n\n      ::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        display: block;\n        background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n        border-radius: inherit;\n        z-index: -1;\n        opacity: 0;\n        transition: opacity 0.5s;\n      }\n\n      :hover {\n        color: #ffffff;\n        ::before {\n          opacity: 1;\n        }\n      }\n    "],["\n      position: relative;\n      font-weight: bold;\n      color: #ffffff;\n      text-decoration: none;\n      background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n      border-radius: 32px;\n      cursor: pointer;\n      z-index: 2;\n\n      ::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        display: block;\n        background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n        border-radius: inherit;\n        z-index: -1;\n        opacity: 0;\n        transition: opacity 0.5s;\n      }\n\n      :hover {\n        color: #ffffff;\n        ::before {\n          opacity: 1;\n        }\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      color: #ffffff;\n      background-color: ",";\n\n      :hover,\n      :focus,\n      :active {\n        color: #362f41;\n        background-color: #e48900;\n      }\n    "],["\n      color: #ffffff;\n      background-color: ",";\n\n      :hover,\n      :focus,\n      :active {\n        color: #362f41;\n        background-color: #e48900;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      background-color: #60a31c;\n\n      :hover,\n      :focus,\n      :active {\n        background-color: #477f14;\n      }\n    "],["\n      background-color: #60a31c;\n\n      :hover,\n      :focus,\n      :active {\n        background-color: #477f14;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      color: #ffffff;\n      background: transparent;\n      border: 2px solid #ffffff;\n      border-radius: 20px;\n\n      :hover,\n      :focus,\n      :active {\n        color: #3b9478;\n        background: #ffffff;\n\n        ::before {\n          display: none;\n        }\n      }\n    "],["\n      color: #ffffff;\n      background: transparent;\n      border: 2px solid #ffffff;\n      border-radius: 20px;\n\n      :hover,\n      :focus,\n      :active {\n        color: #3b9478;\n        background: #ffffff;\n\n        ::before {\n          display: none;\n        }\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      color: #fff;\n      background-color: #97959a;\n      pointer-events: none;\n      user-select: none;\n      cursor: default;\n\n      :hover {\n        color: #fff;\n        background-color: #97959a;\n      }\n\n      ",";\n    "],["\n      color: #fff;\n      background-color: #97959a;\n      pointer-events: none;\n      user-select: none;\n      cursor: default;\n\n      :hover {\n        color: #fff;\n        background-color: #97959a;\n      }\n\n      ",";\n    "]),_templateObject8=_taggedTemplateLiteral(["\n          color: #fff;\n          background-color: #47c0c8;\n          background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n          border-radius: 32px;\n          opacity: 0.59;\n        "],["\n          color: #fff;\n          background-color: #47c0c8;\n          background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n          border-radius: 32px;\n          opacity: 0.59;\n        "]),_templateObject9=_taggedTemplateLiteral(["\n      background: #0085eb !important;\n\n      :before {\n        display: none;\n      }\n\n      :after {\n        display: none;\n      }\n    "],["\n      background: #0085eb !important;\n\n      :before {\n        display: none;\n      }\n\n      :after {\n        display: none;\n      }\n    "]),_templateObject10=_taggedTemplateLiteral(["\n      min-width: 0;\n      width: auto;\n      padding: 12px 18px;\n      font-size: ",";\n      font-weight: bold;\n      text-transform: uppercase;\n      background: none;\n      border: 2px solid #ffffff !important;\n      border-radius: 32px;\n      box-shadow: none;\n      text-shadow: none !important;\n      &:hover {\n        color: #3b9478;\n        background: #fff;\n\n        &::before {\n          display: none;\n        }\n      }\n    "],["\n      min-width: 0;\n      width: auto;\n      padding: 12px 18px;\n      font-size: ",";\n      font-weight: bold;\n      text-transform: uppercase;\n      background: none;\n      border: 2px solid #ffffff !important;\n      border-radius: 32px;\n      box-shadow: none;\n      text-shadow: none !important;\n      &:hover {\n        color: #3b9478;\n        background: #fff;\n\n        &::before {\n          display: none;\n        }\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin: 0 auto;\n"],["\n  text-decoration: none;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin: 0 auto;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref2){var theme=_ref2.theme;return theme.locale!=="ar"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3),function(_ref3){var type=_ref3.type;return type==="trade"&&!"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.accent;});},function(_ref5){var type=_ref5.type;return type==="deposit"&&!"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(_ref6){var isCardButton=_ref6.isCardButton;return isCardButton&&"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);},function(_ref7){var disabled=_ref7.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8));},function(_ref8){var invited=_ref8.invited;return invited&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);},function(_ref9){var isTradePageCard=_ref9.isTradePageCard;return isTradePageCard&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));});var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Button)(_templateObject11);var FlatButton=function FlatButton(_ref10){var children=_ref10.children,type=_ref10.type,color=_ref10.color,isCardButton=_ref10.isCardButton,isTradePageCard=_ref10.isTradePageCard,props=_objectWithoutProperties(_ref10,["children","type","color","isCardButton","isTradePageCard"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,Object.assign({as:props.to!=null?__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */]:Button,isCardButton:isCardButton,type:type,isTradePageCard:isTradePageCard},props),children);};/* harmony default export */ __webpack_exports__["a"] = (FlatButton);

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HamburgerIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PersonIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TournamentsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TradingIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TradingHistoryIcon; });
/* unused harmony export CabinetIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DepositeIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return WithdrawIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return WithdrawHistoryIcon; });
/* unused harmony export FaqIcon */
/* unused harmony export AboutIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return QuitIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LangIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SupportIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NewsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HelpCenterIcon; });
/* unused harmony export BellIcon */
/* unused harmony export PresentIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  flex-shrink: 0;\n  fill-rule: evenodd;\n"],["\n  flex-shrink: 0;\n  fill-rule: evenodd;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: block;\n  flex-shrink: 0;\n  position: relative;\n  user-select: none;\n  transition: all 0.3s ease;\n  fill: currentColor;\n\n  ",";\n"],["\n  display: block;\n  flex-shrink: 0;\n  position: relative;\n  user-select: none;\n  transition: all 0.3s ease;\n  fill: currentColor;\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      fill: ",";\n    "],["\n      fill: ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -2px;\n  flex-shrink: 0;\n"],["\n  position: absolute;\n  top: -2px;\n  flex-shrink: 0;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SvgSimple=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var SvgStyled=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject2,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(_ref){var theme=_ref.theme;return theme.foreground;});});var SvgCentered=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject4);// helper functions to reduce code dublication
function Svg(_ref2){var width=_ref2.width,height=_ref2.height,type=_ref2.type,d=_ref2.d,transform=_ref2.transform,other=_objectWithoutProperties(_ref2,["width","height","type","d","transform"]);var RenderedSvg=SvgSimple;switch(type){case"styled":RenderedSvg=SvgStyled;break;case"centered":RenderedSvg=SvgCentered;break;default:break;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RenderedSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:width,height:height,viewBox:"0 0 "+width+" "+height,fill:"currentColor"},other),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:d,transform:transform}));}var HamburgerIcon=function HamburgerIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{type:"styled",width:38.78,height:20.063,d:"M1306.08,34.791a4.41,4.41,0,1,0-4.41-4.41A4.414,4.414,0,0,0,1306.08,34.791Zm0-6.711a2.3,2.3,0,1,1-2.3,2.3A2.309,2.309,0,0,1,1306.08,28.08Zm0,8.819a8.087,8.087,0,0,0-8.08,8.081,1.052,1.052,0,0,0,1.05,1.054h14.05a1.052,1.052,0,0,0,1.05-1.054A8.085,8.085,0,0,0,1306.08,36.9Zm-5.88,7.027a5.968,5.968,0,0,1,11.75,0H1300.2Zm35.54-6.9h-15.75a1.03,1.03,0,1,1,0-2.06h15.75A1.03,1.03,0,1,1,1335.74,37.022Zm0-6h-15.75a1.03,1.03,0,1,1,0-2.06h15.75A1.03,1.03,0,1,1,1335.74,31.022Zm-15.75,9.94h15.75a1.03,1.03,0,1,1,0,2.06h-15.75A1.03,1.03,0,1,1,1319.99,40.962Z",transform:"translate(-1298 -25.969)"});};var PersonIcon=function PersonIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{type:"styled",width:20,height:21,fill:"#fff",d:"M19.732,20.730 C19.586,20.901 19.373,21.000 19.148,21.000 L1.732,21.000 C1.508,21.000 1.294,20.901 1.149,20.730 C1.004,20.559 0.942,20.332 0.978,20.111 L1.235,18.570 C1.779,15.312 4.573,12.946 7.879,12.946 L13.002,12.946 C16.308,12.946 19.102,15.312 19.645,18.570 L19.902,20.111 C19.939,20.332 19.877,20.559 19.732,20.730 ZM9.958,14.474 L10.440,14.883 L10.923,14.474 L9.958,14.474 ZM18.138,18.821 C17.733,16.392 15.709,14.606 13.274,14.481 L10.935,16.467 C10.793,16.589 10.616,16.649 10.440,16.649 C10.264,16.649 10.088,16.589 9.946,16.467 L7.607,14.481 C5.171,14.606 3.148,16.392 2.743,18.821 L2.634,19.473 L4.234,19.473 L4.234,18.061 C4.234,17.639 4.576,17.297 4.998,17.297 C5.420,17.297 5.762,17.639 5.762,18.061 L5.762,19.473 L15.119,19.473 L15.119,18.061 C15.119,17.639 15.461,17.297 15.883,17.297 C16.305,17.297 16.647,17.639 16.647,18.061 L16.647,19.473 L18.247,19.473 L18.138,18.821 ZM10.440,12.298 C9.079,12.298 7.768,11.543 6.748,10.172 C5.855,8.971 5.322,7.448 5.322,6.096 C5.322,3.276 7.618,0.982 10.440,0.982 C13.263,0.982 15.559,3.276 15.559,6.096 C15.559,7.448 15.025,8.971 14.133,10.172 C13.113,11.543 11.801,12.298 10.440,12.298 ZM10.440,2.509 C8.461,2.509 6.850,4.118 6.850,6.096 C6.850,8.157 8.541,10.771 10.440,10.771 C12.340,10.771 14.030,8.157 14.030,6.096 C14.030,4.118 12.420,2.509 10.440,2.509 Z"});};var TournamentsIcon=function TournamentsIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{type:"styled",width:20,height:20,d:"M19.219,2.969h-3.75V.781A.781.781,0,0,0,14.688,0H5.313a.781.781,0,0,0-.781.781V2.969H.781A.781.781,0,0,0,0,3.75V6.094a4.693,4.693,0,0,0,4.688,4.688h.106A3.921,3.921,0,0,0,7.656,13.2v2.266H6.094a.781.781,0,0,0-.756.582L4.557,19.02a.781.781,0,0,0,.756.98h9.375a.781.781,0,0,0,.756-.98l-.781-2.969a.781.781,0,0,0-.756-.582H12.344V13.2a3.921,3.921,0,0,0,2.863-2.421h.106A4.693,4.693,0,0,0,20,6.094V3.75A.781.781,0,0,0,19.219,2.969ZM4.531,9.215A3.129,3.129,0,0,1,1.563,6.094V4.531H4.531ZM13.3,17.031l.37,1.406H6.326l.37-1.406ZM9.219,15.469V13.281h1.562v2.188Zm4.687-6.094a2.347,2.347,0,0,1-2.344,2.344H8.438A2.347,2.347,0,0,1,6.094,9.375V1.563h7.813Zm4.531-3.281a3.129,3.129,0,0,1-2.969,3.121V4.531h2.969Z"});};var TradingIcon=function TradingIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:19,height:17,d:"M17.989,0.011h-17V12.964h17V0.011ZM16.514,11.455H2.495v-10H16.514v10Zm-4.442,2.833V15H6.9V14.288H-0.01v1.756H19V14.288H12.072ZM5.408,9.234a1.016,1.016,0,0,0,1-1.029A1.089,1.089,0,0,0,6.4,8.059l0.95-.93a0.916,0.916,0,0,0,.683-0.045L9.578,8.37c0,0.025-.008.049-0.008,0.074a1,1,0,1,0,2,0,1.1,1.1,0,0,0-.028-0.235l2.115-2.587a1.09,1.09,0,0,0,.122.013,1.031,1.031,0,1,0-1-1.032,1.075,1.075,0,0,0,.021.21L10.668,7.423a0.81,0.81,0,0,0-.1-0.01,0.946,0.946,0,0,0-.25.036L8.615,6.032a1,1,0,0,0-1.994.11c0,0.013,0,.026,0,0.039L5.593,7.191a0.973,0.973,0,0,0-.184-0.018A1.031,1.031,0,0,0,5.408,9.234Z"});};var TradingHistoryIcon=function TradingHistoryIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:23,height:24,d:"M2.928,3.634V0.706a0.732,0.732,0,1,1,1.464,0V3.634A0.732,0.732,0,1,1,2.928,3.634Zm10.4,0.732a0.731,0.731,0,0,0,.732-0.732V0.706a0.732,0.732,0,1,0-1.464,0V3.634A0.731,0.731,0,0,0,13.33,4.365ZM22.421,17.54a5.855,5.855,0,1,1-5.855-5.856A5.855,5.855,0,0,1,22.421,17.54Zm-1.464,0a4.392,4.392,0,1,0-4.391,4.391A4.4,4.4,0,0,0,20.957,17.54ZM1.441,16.354V6.446H15.526V10.22H16.99V4.511A1.6,1.6,0,0,0,15.4,2.9h-0.61V3.634a1.464,1.464,0,1,1-2.928,0V2.9H5.123V3.634a1.464,1.464,0,1,1-2.928,0V2.9H1.586A1.6,1.6,0,0,0,0,4.511V16.354a1.6,1.6,0,0,0,1.586,1.61H9.247V16.5H1.563A0.139,0.139,0,0,1,1.441,16.354ZM19.056,18.5a0.551,0.551,0,0,0-.552-0.551H17.062V15.526a0.551,0.551,0,0,0-1.1,0V18.5a0.55,0.55,0,0,0,.551.551H18.5A0.551,0.551,0,0,0,19.056,18.5ZM3.009,15V14H4v1H3.009Zm0-6V8H4V9H3.009Zm0,2V10H4v1H3.009Zm0,1.969v-1H4v1H3.009ZM4.978,15V14H5.972v1H4.978Zm0-6V8H5.972V9H4.978Zm0,2V10H5.972v1H4.978Zm0,1.969v-1H5.972v1H4.978ZM7.009,15V14H8v1H7.009Zm0-6V8H8V9H7.009Zm0,2V10H8v1H7.009Zm0,1.969v-1H8v1H7.009Zm2,2.031V14H10v1H9.009Zm0-6V8H10V9H9.009Zm0,2V10H10v1H9.009Zm0,1.969v-1H10v1H9.009Zm2-3.969V8H12V9H11.009Zm0,2V10H12v1H11.009Zm0,1.969v-1H12v1H11.009Zm2-3.969V8H14V9H13.009Zm0,2V10H14v1H13.009Z"});};var CabinetIcon=function CabinetIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:19,height:15,d:"M17.1,0H1.9A1.905,1.905,0,0,0,0,1.9V13.082a1.906,1.906,0,0,0,1.9,1.9H17.1a1.906,1.906,0,0,0,1.9-1.9V1.9A1.905,1.905,0,0,0,17.1,0Zm0.406,13.489H1.495V1.515H17.509V13.489ZM7.989,9.783h-4v1.46h4V9.783Zm0-3.038h-4V8.237h4V6.745Zm0-3.007h-4V5.292h4V3.738ZM14.9,9.747S13.2,9.3,13.2,8.433c0-.83,1.1-1.18,1.1-2.875,0-1.377-.419-2.1-1.8-2.1s-1.8.818-1.8,2.195c0,1.7,1.1,2.046,1.1,2.876,0,0.871-1.7,1.314-1.7,1.314a6.59,6.59,0,0,0-.1,1.4H15A7.552,7.552,0,0,0,14.9,9.747Z"});};var DepositeIcon=function DepositeIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:20,height:19,d:"M9.527-.033a9.527,9.527,0,1,0,9.527,9.527A9.527,9.527,0,0,0,9.527-.033Zm0,17.588a8.061,8.061,0,1,1,8.062-8.061A8.061,8.061,0,0,1,9.527,17.555ZM12.119,5.967H12.055v-1H10.878v1H10.814c-0.865,0-1.961.62-1.961,1.441v1.23c0,0.72,1.041,1.3,1.873,1.3h0.152v2a1.042,1.042,0,0,1-.822-0.492v-0.5h-1.2v0.64c0,0.821,1.1,1.44,1.961,1.44h0.063v1h1.178v-1h0.063c0.865,0,1.961-.63,1.961-1.44v-1.37a1.387,1.387,0,0,0-1.45-1.291H12.055V7.055a1.043,1.043,0,0,1,.823.481V8.057h1.2V7.406C14.08,6.616,12.983,5.967,12.119,5.967ZM10.878,8.913a1.026,1.026,0,0,1-.822-0.426V7.537a1.049,1.049,0,0,1,.822-0.482V8.913Zm2,1.524v1.011a1.026,1.026,0,0,1-.823.491V9.967A1.117,1.117,0,0,1,12.878,10.437ZM5.9,9.9v1.819a0.106,0.106,0,0,1-.107.107H5.149a0.106,0.106,0,0,1-.107-0.107V9.9H3.223A0.107,0.107,0,0,1,3.116,9.8V9.155a0.107,0.107,0,0,1,.107-0.107H5.042V7.23a0.107,0.107,0,0,1,.107-0.107H5.79A0.107,0.107,0,0,1,5.9,7.23V9.048H7.714a0.107,0.107,0,0,1,.107.107V9.8a0.107,0.107,0,0,1-.107.107H5.9Z"});};var WithdrawIcon=function WithdrawIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:19,height:15,d:"M14.413,13.39H4.6V3.168H3.011V14.974H16V3.168H14.413V13.39ZM0,0V5.992H2.376V4.5H1.584V1.583H17.425V4.5H16.633v1.49h2.376V0H0ZM7.746,7.178A1.132,1.132,0,0,1,7.567,6.49a1.307,1.307,0,0,1,.214-0.772,0.8,0.8,0,0,1,.707-0.3v-1.4L8.47,4a1.358,1.358,0,0,0-1.229.582,2.362,2.362,0,0,0-.488,1.337H6.027V7.076h0.73A2.117,2.117,0,0,0,7.21,8.324a1.2,1.2,0,0,0,1.025.527,1.173,1.173,0,0,0,1.021-.525A5.8,5.8,0,0,0,9.94,6.712a2.464,2.464,0,0,1,.352-0.806,0.572,0.572,0,0,1,.466-0.22,0.616,0.616,0,0,1,.485.207,0.936,0.936,0,0,1,.182.632,0.889,0.889,0,0,1-.236.653,0.9,0.9,0,0,1-.671.24v1.4l0.018,0.014a1.455,1.455,0,0,0,1.157-.486,1.948,1.948,0,0,0,.542-1.223h0.8v-1.2H12.244a1.785,1.785,0,0,0-.466-1.148,1.215,1.215,0,0,0-1.015-.53,1.184,1.184,0,0,0-1.034.53A5.485,5.485,0,0,0,9.063,6.4a2.314,2.314,0,0,1-.35.786,0.6,0.6,0,0,1-.486.23A0.569,0.569,0,0,1,7.746,7.178Z"});};var WithdrawHistoryIcon=function WithdrawHistoryIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:23,height:24,d:"M2.928,3.633V0.706a0.732,0.732,0,1,1,1.464,0V3.633A0.732,0.732,0,1,1,2.928,3.633Zm10.4,0.732a0.731,0.731,0,0,0,.732-0.732V0.706a0.732,0.732,0,1,0-1.464,0V3.633A0.731,0.731,0,0,0,13.33,4.365ZM22.421,17.54a5.855,5.855,0,1,1-5.855-5.855A5.855,5.855,0,0,1,22.421,17.54Zm-1.464,0a4.392,4.392,0,1,0-4.391,4.392A4.4,4.4,0,0,0,20.957,17.54ZM1.441,16.354V6.446H15.526v3.775H16.99V4.511A1.6,1.6,0,0,0,15.4,2.9h-0.61V3.633a1.464,1.464,0,1,1-2.928,0V2.9H5.123V3.633a1.464,1.464,0,1,1-2.928,0V2.9H1.586A1.6,1.6,0,0,0,0,4.511V16.354a1.6,1.6,0,0,0,1.586,1.61H9.247V16.5H1.563A0.139,0.139,0,0,1,1.441,16.354ZM3.009,15V14H4v1H3.009Zm0-6V8H4V9H3.009Zm0,2V10H4v1H3.009Zm0,1.969v-1H4v1H3.009ZM4.978,15V14H5.972v1H4.978Zm0-6V8H5.972V9H4.978Zm0,2V10H5.972v1H4.978Zm0,1.969v-1H5.972v1H4.978ZM7.009,15V14H8v1H7.009Zm0-6V8H8V9H7.009Zm0,2V10H8v1H7.009Zm0,1.969v-1H8v1H7.009Zm2,2.031V14H10v1H9.009Zm0-6V8H10V9H9.009Zm0,2V10H10v1H9.009Zm0,1.969v-1H10v1H9.009Zm2-3.969V8H12V9H11.009Zm0,2V10H12v1H11.009Zm0,1.969v-1H12v1H11.009Zm2-3.969V8H14V9H13.009Zm0,2V10H14v1H13.009Zm5.053,4.982a2.315,2.315,0,0,0-1.133-.37v1.377l0.942,0.125a1.02,1.02,0,0,1,1.116.931v1.336c0,0.623-1.344.827-2.009,0.827H16.929v0.773H16.022V20.209H15.974c-0.665,0-1.947-.29-1.947-0.921v-0.68h0.925v0.386a2.045,2.045,0,0,0,1.07.379V17.83H15.905c-0.64,0-1.879-.228-1.879-0.781V15.7c0-.631,1.281-0.921,1.947-0.921h0.049V14h0.906v0.773h0.049c0.665,0,2.009.343,2.01,0.951v0.657H18.062v-0.4Zm-2.04-.37a2.059,2.059,0,0,0-1.07.371v0.731a2.137,2.137,0,0,0,1.07.265V15.612Zm0.905,3.757a2.233,2.233,0,0,0,1.133-.377V18.214a2.71,2.71,0,0,0-1.133-.238v1.393Z"});};var FaqIcon=function FaqIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:19,height:17,d:"M17.007,16.522a34.294,34.294,0,0,1-3.658-2.2A1.826,1.826,0,0,0,12.387,14c-2.13-.029-4.262-0.007-6.393-0.024a7.454,7.454,0,0,1-1.1-.169c0-.056-0.008-0.112-0.012-0.169,0.532-.4,1.057-0.545,1.6-0.926a0.863,0.863,0,0,1,.459-0.078c2.059-.006,4.12-0.012,6.179.008a1.4,1.4,0,0,1,.718.257c0.594,0.4,1.162.579,1.835,1.077V12.633h1.781V4.527c-0.74,0-1.491-.017-2.194.02A0.576,0.576,0,0,0,15,4.987C14.98,6.128,15,8.067,14.989,9.209a1.626,1.626,0,0,1-1.84,1.814c-2.13.006-4.571-.013-6.7,0.015a1.807,1.807,0,0,0-.962.32c-1.2.847-1.835,1.381-3.015,2.254-0.121.089-.252,0.165-0.466,0.3,0-.967-0.011-1.484.006-2.352a0.809,0.809,0,0,0-.8-0.606,1.5,1.5,0,0,1-1.187-1.5c-0.013-2.477-.016-5.4,0-7.872A1.558,1.558,0,0,1,1.607.005c3.889-.014,7.91-0.014,11.8,0a1.576,1.576,0,0,1,1.576,1.542,6.267,6.267,0,0,1,0,.937c-0.032.42,0.084,0.6,0.555,0.567,0.618-.042,1.11-0.017,1.73-0.006a1.592,1.592,0,0,1,1.709,1.632c0.026,2.44.02,5.237,0,7.677a1.547,1.547,0,0,1-1.295,1.585A0.712,0.712,0,0,0,17,14.4c0.012,0.738,0,.766,0,1.5C17.007,16.067,17.007,16.235,17.007,16.522ZM13.4,9.415a1,1,0,0,0,.066-0.183c0.006-2.262,0-5.056.018-7.319,0-.366-0.2-0.381-0.475-0.381-3.531,0-7.459.008-10.99,0a0.414,0.414,0,0,0-.508.511c0.018,2.123.009,4.777,0.013,6.9,0,0.149.026,0.3,0.044,0.494H3.473v1.58c0.676-.5,1.11-0.948,1.706-1.349A1.421,1.421,0,0,1,5.9,9.423C6.877,9.4,7.852,9.413,8.828,9.415H13.4ZM4,4.956H4.965V5.968H4V4.956Zm2,0H6.965V5.968H6V4.956Zm2,0H8.965V5.968H8V4.956Zm2,0h0.965V5.968H10V4.956Z"});};var AboutIcon=function AboutIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:21,height:21,d:"M3.516,5.013H15.458a0.526,0.526,0,1,0,0-1.052H3.516A0.526,0.526,0,1,0,3.516,5.013ZM20.11,19.627l-1.743-3.449,0.674-.269a0.58,0.58,0,0,0,.338-0.465l0.057-.865a1.274,1.274,0,0,1,.161-0.494l0.462-.734a0.58,0.58,0,0,0,0-.575L19.6,12.042a1.269,1.269,0,0,1-.16-0.494l-0.057-.865a0.588,0.588,0,0,0-.264-0.427V1.332A1.334,1.334,0,0,0,17.783,0H1.333A1.334,1.334,0,0,0,0,1.332V13.654a1.335,1.335,0,0,0,1.333,1.332H11.818l0.03,0.456a0.581,0.581,0,0,0,.338.465L12.82,16.16l-1.751,3.466a0.2,0.2,0,0,0-.018.206,29.211,29.211,0,0,0,2.957.382,0.24,0.24,0,0,0,.227-0.164l1.35-2.911h0.009l1.35,2.911a2.581,2.581,0,0,1,.227.164c2.157-.235.1-0.009,2.839-0.322a0.4,0.4,0,0,1,.118-0.059A0.2,0.2,0,0,0,20.11,19.627ZM1.458,1.488H17.5V9.176l-0.24-.251a0.589,0.589,0,0,0-.433-0.192,0.445,0.445,0,0,0-.114.014l-0.841.214a1.327,1.327,0,0,1-.519,0l-0.841-.214A0.445,0.445,0,0,0,14.4,8.733a0.589,0.589,0,0,0-.433.192l-0.554.667a1.267,1.267,0,0,1-.42.3l-0.806.322a0.581,0.581,0,0,0-.338.465l-0.057.865a1.271,1.271,0,0,1-.16.494l-0.462.734a0.58,0.58,0,0,0,0,.575l0.191,0.116h-9.9V1.488ZM15.614,15.9a2.833,2.833,0,1,1,2.834-2.834A2.834,2.834,0,0,1,15.614,15.9ZM3.516,8.013H15.458a0.527,0.527,0,0,0,0-1.053H3.516A0.527,0.527,0,0,0,3.516,8.013Zm0,3h5.91a0.527,0.527,0,1,0,0-1.053H3.516A0.527,0.527,0,0,0,3.516,11.013Z"});};var QuitIcon=function QuitIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:19,height:17,d:"M5.113,12l-0.8.8L0,8.482l4.291-4.29L5.113,4.964,2.293,7.783H14v1.4H2.293ZM17.319,0.915H8.677A1.686,1.686,0,0,0,7,2.6V5.958H8.49V2.472h9.017V14.488H8.458V11H7v3.362a1.686,1.686,0,0,0,1.681,1.68h8.642A1.686,1.686,0,0,0,19,14.363V2.6A1.686,1.686,0,0,0,17.319.915Z"});};var LangIcon=function LangIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{type:"centered",width:19,height:19,d:"M15.914,3.086 C17.630,4.802 18.576,7.084 18.576,9.512 C18.576,11.939 17.630,14.220 15.914,15.937 C14.198,17.653 11.916,18.598 9.489,18.598 C7.062,18.598 4.780,17.653 3.064,15.937 C1.348,14.220 0.403,11.939 0.403,9.512 C0.403,7.084 1.348,4.802 3.064,3.086 C4.780,1.371 7.062,0.425 9.489,0.425 C11.916,0.425 14.198,1.371 15.914,3.086 ZM14.761,14.785 C15.811,13.735 16.508,12.428 16.796,11.006 C16.572,11.336 16.357,11.458 16.225,10.720 C16.088,9.514 14.981,10.284 14.285,9.856 C13.553,10.349 11.907,8.896 12.187,10.536 C12.618,11.274 14.517,9.546 13.570,11.110 C12.967,12.203 11.363,14.621 11.572,15.875 C11.598,17.701 9.705,16.255 9.053,15.650 C8.615,14.436 8.904,12.314 7.757,11.720 C6.512,11.667 5.443,11.553 4.961,10.161 C4.671,9.166 5.270,7.684 6.337,7.455 C7.899,6.473 8.457,8.604 9.922,8.643 C10.376,8.168 11.616,8.017 11.719,7.483 C10.758,7.313 12.938,6.675 11.627,6.311 C10.903,6.397 10.437,7.061 10.822,7.626 C9.420,7.953 9.375,5.597 8.027,6.340 C7.993,7.514 5.827,6.721 7.278,6.483 C7.776,6.265 6.465,5.633 7.173,5.748 C7.521,5.729 8.693,5.319 8.376,5.042 C9.029,4.637 9.577,6.013 10.216,5.012 C10.677,4.240 10.022,4.099 9.444,4.489 C9.119,4.124 10.020,3.337 10.815,2.996 C11.080,2.882 11.333,2.820 11.526,2.837 C11.927,3.300 12.667,3.381 12.706,2.782 C11.714,2.307 10.621,2.057 9.489,2.057 C7.864,2.057 6.319,2.573 5.040,3.527 C5.384,3.685 5.579,3.881 5.248,4.131 C4.991,4.898 3.947,5.927 3.031,5.781 C2.555,6.601 2.241,7.506 2.108,8.453 C2.875,8.707 3.052,9.210 2.887,9.377 C2.496,9.718 2.256,10.201 2.132,10.730 C2.382,12.259 3.100,13.667 4.217,14.785 C5.625,16.193 7.497,16.969 9.489,16.969 C11.480,16.969 13.353,16.193 14.761,14.785 Z"});};var SupportIcon=function SupportIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{type:"centered",width:19,height:20,d:"M13.977,19.994 L12.992,19.994 L8.977,19.994 L7.990,19.994 L4.979,19.994 L3.980,19.994 L-0.008,19.994 L-0.008,6.000 L3.980,6.000 L3.980,3.969 L7.990,3.969 L7.990,0.926 L13.977,0.926 L13.977,6.000 L18.979,6.000 L18.979,19.994 L13.977,19.994 ZM3.522,7.426 L1.450,7.426 L1.450,18.568 L3.522,18.568 L3.522,7.426 ZM7.519,5.395 L5.437,5.395 L5.437,18.568 L7.519,18.568 L7.519,5.395 ZM12.519,2.352 L9.448,2.352 L9.448,3.991 L12.519,3.991 L12.519,2.352 ZM12.519,4.963 L9.448,4.963 L9.448,5.991 L12.519,5.991 L12.519,4.963 ZM12.519,6.963 L9.448,6.963 L9.448,18.568 L12.519,18.568 L12.519,6.963 ZM17.522,7.426 L14.450,7.426 L14.450,18.568 L17.522,18.568 L17.522,7.426 ZM16.856,14.932 L15.116,14.932 L15.116,11.960 L16.856,11.960 L16.856,14.932 ZM11.853,16.963 L10.113,16.963 L10.113,14.960 L11.853,14.960 L11.853,16.963 ZM6.853,7.981 L6.103,7.981 L6.103,7.027 L6.853,7.027 L6.853,7.981 ZM6.853,17.713 L6.103,17.713 L6.103,14.741 L6.853,14.741 L6.853,17.713 ZM2.856,14.932 L2.116,14.932 L2.116,11.960 L2.856,11.960 L2.856,14.932 Z"});};var NewsIcon=function NewsIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:20,height:20,fill:"currentColor",viewBox:"-1717.999 12000.999 19.999 20.002",d:"M1720.344-11981a2.348,2.348,0,0,1-2.343-2.344V-12001h16.875v17.658a.78.78,0,0,0,.78.78.78.78,0,0,0,.78-.78v-10.625H1738v10.625a2.348,2.348,0,0,1-2.343,2.344Zm-.78-2.344a.78.78,0,0,0,.78.78h13.1a2.4,2.4,0,0,1-.133-.78v-16.095h-13.749Zm7.7-.782v-1.563h4.491v1.563Zm-6.132,0v-1.563h4.569v1.563Zm6.132-3.088v-1.562h4.491v1.563Zm-6.132,0v-1.562h4.569v1.563Zm6.132-3.123v-1.563h4.491v1.563Zm-6.132,0v-4.647h4.569v4.647Zm1.563-1.561h1.443v-1.523h-1.443Zm4.569-1.562v-1.563h4.491v1.563Zm-6.132-2.853v-1.563h10.623v1.563Z",transform:"translate(-3436 24002)"});};var HelpCenterIcon=function HelpCenterIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:20,height:20,fill:"currentColor",viewBox:"0 0 18.998 18.999",d:"M-10883-2796.5a9.494,9.494,0,0,1,9.5-9.5,9.5,9.5,0,0,1,9.5,9.5,9.5,9.5,0,0,1-9.5,9.5A9.5,9.5,0,0,1-10883-2796.5Zm1.461,0a8.037,8.037,0,0,0,8.035,8.038,8.037,8.037,0,0,0,8.035-8.038,8.034,8.034,0,0,0-8.035-8.035A8.034,8.034,0,0,0-10881.539-2796.5Zm6.039,4.416v-1.486h1.485v-2.972h-1.485v-1.483h2.972v4.455h1.485v1.486Zm1.485-7.429V-2801h1.486v1.483Z",transform:"translate(10883 2806.001)"});};var BellIcon=function BellIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:20,height:20,fill:"currentColor",viewBox:"0 0 18.998 18.999",d:"M-10883-2796.5a9.494,9.494,0,0,1,9.5-9.5,9.5,9.5,0,0,1,9.5,9.5,9.5,9.5,0,0,1-9.5,9.5A9.5,9.5,0,0,1-10883-2796.5Zm1.461,0a8.037,8.037,0,0,0,8.035,8.038,8.037,8.037,0,0,0,8.035-8.038,8.034,8.034,0,0,0-8.035-8.035A8.034,8.034,0,0,0-10881.539-2796.5Zm6.039,4.416v-1.486h1.485v-2.972h-1.485v-1.483h2.972v4.455h1.485v1.486Zm1.485-7.429V-2801h1.486v1.483Z",transform:"translate(10883 2806.001)"});};var PresentIcon=function PresentIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{width:20,height:30,fill:"currentColor",viewBox:"0 0 512 512",d:"M480,143.686H378.752c7.264-4.96,13.504-9.888,17.856-14.304c25.792-25.952,25.792-68.192,0-94.144 c-25.056-25.216-68.768-25.248-93.856,0c-13.856,13.92-50.688,70.592-45.6,108.448h-2.304 c5.056-37.856-31.744-94.528-45.6-108.448c-25.088-25.248-68.8-25.216-93.856,0C89.6,61.19,89.6,103.43,115.36,129.382 c4.384,4.416,10.624,9.344,17.888,14.304H32c-17.632,0-32,14.368-32,32v80c0,8.832,7.168,16,16,16h16v192 c0,17.632,14.368,32,32,32h384c17.632,0,32-14.368,32-32v-192h16c8.832,0,16-7.168,16-16v-80 C512,158.054,497.632,143.686,480,143.686z M138.08,57.798c6.496-6.528,15.104-10.112,24.256-10.112 c9.12,0,17.728,3.584,24.224,10.112c21.568,21.696,43.008,77.12,35.552,84.832c0,0-1.344,1.056-5.92,1.056 c-22.112,0-64.32-22.976-78.112-36.864C124.672,93.318,124.672,71.302,138.08,57.798z M240,463.686H64v-192h176V463.686z M240,239.686H32v-64h184.192H240V239.686z M325.44,57.798c12.992-13.024,35.52-12.992,48.48,0 c13.408,13.504,13.408,35.52,0,49.024c-13.792,13.888-56,36.864-78.112,36.864c-4.576,0-5.92-1.024-5.952-1.056 C282.432,134.918,303.872,79.494,325.44,57.798z M448,463.686H272v-192h176V463.686z M480,239.686H272v-64h23.808H480V239.686z",transform:"translate(0 -80)"});};

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = useSuggestedPromoCode;
/* harmony export (immutable) */ __webpack_exports__["b"] = useRelevantTournamentInvitationsCount;
/* harmony export (immutable) */ __webpack_exports__["a"] = useRelevantTournamentInvitations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tournaments_Api__ = __webpack_require__(14);
function useSuggestedPromoCode(){// Первый из списка промокодов, пришедших в анонсе, который успешно пройдёт
// валидацию
var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__Tournaments_Api__["c" /* default */]);var announcementsEntity=api.readEntity("/api/bell-tolls-items",{follow:"/api/notifications/viewed"});var profileEntity=api.readEntity("/api/profile");var code=null;if(announcementsEntity.status!=="Resolved"&&announcementsEntity.value==null||profileEntity.status!=="Resolved"&&profileEntity.value==null){return code;}var announcements=announcementsEntity.value.payload.data;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{enumerationOfCodes:for(var _iterator=announcements[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var announcement=_step.value;if(announcement.type==="promocode"){var codeInfoEntity=api.readEntity("/api/promo-code-info?code="+announcement.info.code+"&lang="+profileEntity.value.locale);switch(codeInfoEntity.status){case"Pending":break enumerationOfCodes;case"Resolved":code=announcement.info.code;break enumerationOfCodes;case"Rejected":default:continue enumerationOfCodes;}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return code;}function useRelevantTournamentInvitationsCount(){// Пересчитываем уместные приглашения в турниры среди тех, что пришли в виде
// анонсов
var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__Tournaments_Api__["c" /* default */]);var announcementsEntity=api.readEntity("/api/bell-tolls-items",{follow:"/api/notifications/viewed"});var relevantInvitations=0;if(announcementsEntity.value!=null){var announcements=announcementsEntity.value.payload.data;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=announcements[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var announcement=_step2.value;if(announcement.type==="invited-tournament"){var tournament=announcement.info;if(tournament.participation_status!==1&&tournament.state<2){relevantInvitations++;}}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}return relevantInvitations;}function useRelevantTournamentInvitations(){// Пересчитываем уместные приглашения в турниры среди тех, что пришли в виде
// анонсов
var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__Tournaments_Api__["c" /* default */]);var announcementsEntity=api.readEntity("/api/bell-tolls-items",{follow:"/api/notifications/viewed"});var activeTournamentsEntity=api.readEntity("/api/tournaments/list?status=1");var relevantInvitations=[];if(announcementsEntity.status!=="Resolved"&&announcementsEntity.value==null||activeTournamentsEntity.status!=="Resolved"&&activeTournamentsEntity.value==null){return relevantInvitations;}var announcements=announcementsEntity.value.payload.data;var activeTournaments=activeTournamentsEntity.value.items;var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=announcements[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var announcement=_step3.value;if(announcement.type==="invited-tournament"){(function(){var tournament=announcement.info;if(tournament.participation_status!==1&&activeTournaments.some(function(t){return t.id===tournament.id;})){relevantInvitations.push(tournament);}})();}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}var sort=function sort(a,b){if(a>b)return 1;if(a<b)return-1;};return relevantInvitations.sort(sort);}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAABHNCSVQICAgIfAhkiAAABEJJREFUWIXV2V1MW2UYwPH/OT0UWvoF4hjMmZkp3CyKgeiSOTSRGeP8GLq5ZXMOs7i5bN5NbzAZM5KYeOGMXolzuhl0bpkwoMwoyyCgF5iARBKcJRO5YAsCLe36caDneNGVD3sOtNBC91z1PWne8zvP+7wfpxWoHa0BTpDmIQDcDVgRgOp7a4CTS+3Enikky6Mb4synJWKLcw0MHM7hzZKsZLpiQpzXShBbnGugfb+DfItIKKymNLNizJU4scW5Bjpfd7AmW6CqyUv70BT9h3I4/rgpFU4NKCyKjSLvMc8iuw44WGcVeW1TakpAGwq62AKLqIlca4l01TooA+BIchnoQ3WwIz6FFpc8D1lgEanp8APgHJR5KMdA/+HklsHCUB1sVbMXp0um64CDQqtIVZOX8YCCJ6TiCSn8WuWg8M4ES9ZqYIjrW1c/usbT7wrAU9FL/ml4wGHgdG+QM30hqreYyZIEjpWZyDUJvP2jjyGPQv0OK8OTCj23ppcFTayQdHYwSQD38TyyMyLtQ04fdb1Beg46KMmXeOyMm+6R5UEXH/q5oTPBNq0xxCCff9BISb7E132hGWR+9tInWHxDPzc0yuDmbZU8k8gXvUHqeoMAnK+0km0U2H7eQ55Z5NQ2C2dftDKlqHQOJ57dpT/iAgeZ5zYaadlt44NOP+aMSN0aDfDzjSlqu/yIAlwdmloh6ALYaG0GpsEkQbNL5mSHn99uTvPpMxaOlWWx/7KXb/4IxX2rxGr0/6FTs43XZRQVWlwyD9dN8ML3k/OQf46FcQdV3no0/qUrOduHRmYLLCIjPmWmPRf5xFk3ZQUSTa/aeaftNqe6A4veIvHJpBUaE8wnqzHI/tEw5efc/BtQcU0oWI0C7z9pJtMAbX8vXLPJ3ZA1MltZZOTSThv9o2G2nnMzEYw8QMWGDFp225HDKqYMgc97ghy94kPV6pdkZTQaGpkdGAujqHDkim8GWb4+A+ceO2EVKuo9tA7KvLfFTLNLZtSvTU3NSXeBpWtzoUTbPgeSCNvqPXQMR4b8PqtIwy4bfbemOdgSm9nlzXq90FkNNjpEftprx2iAyouTM0izBBdetlG6VuKNR7I4vd0Sk8HUQHWwN9wKl/+S2XVpEuedc6tRhNY9djavk/jy9yD7Gr1UaWBTB9XAKsC+Ri8N1yNISYAfdtoovz9yUPBPQX1/iL0NXl4qymS9bZaX+vdc0KxZgwAXX7Gxo8iI0yXzVV+Q7yptfPiLn+p2P45MAXdotlJTm9FoaJSBosJ4ILIhfNId4MJA5K1BEiO5m4uElcpoNDQy+3FFNkdKTTz7rYdr/+gv+isLBU3sia1mjpaa2PDZGH6dE+DKQ0ETm5slMB7U25dWCwoJ/zC3elBICLu6UIgbu/pQiAubHlBYFJs+UFgQm15Q0MWmHxQ0sekJhRhs+kJhHja9oXBX/LU0G7WjNf8BPyTBkT4GG2QAAAAASUVORK5CYII="

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(254),
    isObject = __webpack_require__(76);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),
/* 277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return OtcImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StocksTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Stock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StockCategory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StockName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StockPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Otc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_timer_svg__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_polished__ = __webpack_require__(22);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 100px 15px 15px;\n  overflow: auto;\n\n  @media (max-height: 800px) {\n    padding-top: 30px;\n  }\n\n  @media (max-height: 700px) {\n    padding-top: 0;\n  }\n"],["\n  width: 100%;\n  padding: 100px 15px 15px;\n  overflow: auto;\n\n  @media (max-height: 800px) {\n    padding-top: 30px;\n  }\n\n  @media (max-height: 700px) {\n    padding-top: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: block;\n  width: 52px;\n  margin: 0 auto 22px;\n\n  @media (max-width: 959px) {\n    width: 36px;\n    margin-bottom: 15px;\n  }\n\n  @media (max-width: 959px) and (orientation: landscape) {\n    display: none;\n  }\n"],["\n  display: block;\n  width: 52px;\n  margin: 0 auto 22px;\n\n  @media (max-width: 959px) {\n    width: 36px;\n    margin-bottom: 15px;\n  }\n\n  @media (max-width: 959px) and (orientation: landscape) {\n    display: none;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  text-align: center;\n"],["\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  text-align: center;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 288px;\n  margin: 18px auto 23px;\n  padding: 15px 5px;\n  background-color: ",";\n  border-radius: 5px;\n\n  @media (max-width: 959px) {\n    margin-bottom: 14px;\n  }\n"],["\n  width: 288px;\n  margin: 18px auto 23px;\n  padding: 15px 5px;\n  background-color: ",";\n  border-radius: 5px;\n\n  @media (max-width: 959px) {\n    margin-bottom: 14px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-top: 5px;\n  font-size: 16px;\n  line-height: 1.2;\n  text-align: center;\n  color: ",";\n"],["\n  margin-top: 5px;\n  font-size: 16px;\n  line-height: 1.2;\n  text-align: center;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  max-width: 558px;\n  height: 1px;\n  margin: 0 auto 23px;\n  background-color: rgba(145, 145, 145, 0.59);\n  border: none;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  max-width: 558px;\n  height: 1px;\n  margin: 0 auto 23px;\n  background-color: rgba(145, 145, 145, 0.59);\n  border: none;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 303px;\n  margin: 18px auto 0;\n\n  @media (max-width: 959px) {\n    margin-top: 10px;\n  }\n"],["\n  width: 100%;\n  max-width: 303px;\n  margin: 18px auto 0;\n\n  @media (max-width: 959px) {\n    margin-top: 10px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 9px;\n  padding: 8px 12px;\n  background-color: rgba(145, 145, 145, 0.3);\n  cursor: pointer;\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n\n  :hover {\n    color: #feac00;\n\n    > div {\n      color: #feac00;\n    }\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 9px;\n  padding: 8px 12px;\n  background-color: rgba(145, 145, 145, 0.3);\n  cursor: pointer;\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n\n  :hover {\n    color: #feac00;\n\n    > div {\n      color: #feac00;\n    }\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  width: 40px;\n  white-space: nowrap;\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n"],["\n  width: 40px;\n  white-space: nowrap;\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: relative;\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n"],["\n  position: relative;\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n"],["\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  position: absolute;\n  right: 75px;\n  top: 50%;\n  width: 20px;\n  height: 12px;\n  margin-top: -7px;\n  font-size: 0;\n  line-height: 0;\n\n  ",";\n\n  @media (max-width: 359px) {\n    right: 55px;\n  }\n"],["\n  position: absolute;\n  right: 75px;\n  top: 50%;\n  width: 20px;\n  height: 12px;\n  margin-top: -7px;\n  font-size: 0;\n  line-height: 0;\n\n  ",";\n\n  @media (max-width: 359px) {\n    right: 55px;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n      right: 9px;\n      top: auto;\n      bottom: 7px;\n      margin-top: 0;\n    "],["\n      right: 9px;\n      top: auto;\n      bottom: 7px;\n      margin-top: 0;\n    "]),_templateObject14=_taggedTemplateLiteral(["\n  text-align: center;\n"],["\n  text-align: center;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  width: 30px;\n  height: 30px;\n  margin: 0 auto;\n  color: rgba(145, 145, 145, 0.59);\n"],["\n  width: 30px;\n  height: 30px;\n  margin: 0 auto;\n  color: rgba(145, 145, 145, 0.59);\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var OtcImage=function OtcImage(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?20:_ref$width,_ref$height=_ref.height,height=_ref$height===undefined?12:_ref$height,tab=_ref.tab;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Otc,{tab:tab},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 12",width:width,height:height,fill:"#3B9478"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M8.066,6.649a2.611,2.611,0,0,0-.638-1.8A2.112,2.112,0,0,0,5.772,4.13a2.077,2.077,0,0,0-1.639.716,2.633,2.633,0,0,0-.633,1.8v.623a2.622,2.622,0,0,0,.631,1.806,2.086,2.086,0,0,0,1.641.713A2.111,2.111,0,0,0,7.43,9.078a2.613,2.613,0,0,0,.636-1.806Zm-1.1.632a1.951,1.951,0,0,1-.315,1.152,1.016,1.016,0,0,1-.879.445A1,1,0,0,1,4.9,8.433a1.968,1.968,0,0,1-.3-1.155V6.641A1.963,1.963,0,0,1,4.9,5.5a.994.994,0,0,1,.867-.443,1.022,1.022,0,0,1,.879.445,1.911,1.911,0,0,1,.319,1.14v.637Zm5.613-3.066H8.4v.914H9.94V9.706h1.1V5.129h1.547V4.212Zm3.552,3.474a1.382,1.382,0,0,1-.246.89.924.924,0,0,1-.76.3.954.954,0,0,1-.822-.434A1.9,1.9,0,0,1,14,7.327V6.583a1.956,1.956,0,0,1,.289-1.105.894.894,0,0,1,.781-.434.988.988,0,0,1,.807.312,1.38,1.38,0,0,1,.259.9H17.2l.008-.025a2.023,2.023,0,0,0-.551-1.534,2.152,2.152,0,0,0-1.584-.565,1.968,1.968,0,0,0-1.562.693,2.611,2.611,0,0,0-.6,1.773v.733A2.562,2.562,0,0,0,13.527,9.1a2.048,2.048,0,0,0,1.6.689,2.057,2.057,0,0,0,1.537-.562,2.027,2.027,0,0,0,.539-1.52l0-.025H16.135ZM1.112.963H18.883a1.072,1.072,0,0,1,.79.354A1.265,1.265,0,0,1,20,2.174v9.579a1.166,1.166,0,0,1-1.115,1.211H1.112A1.166,1.166,0,0,1,0,11.752V2.174A1.166,1.166,0,0,1,1.112.963Z"})));};var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Timer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject2);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref3){var theme=_ref3.theme;return theme.foreground;});var TimeToOpen=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.mainDark;});var TimeText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref5){var theme=_ref5.theme;return theme.stockCloseTimeColor;});var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].hr(_templateObject6);var StocksTable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var Stock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var StockCategory=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref7){var theme=_ref7.theme;return Object(__WEBPACK_IMPORTED_MODULE_8_polished__["a" /* rgba */])(theme.foreground,0.7);});var StockName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(_ref8){var theme=_ref8.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref9){var theme=_ref9.theme;return theme.foreground;});var StockPercent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,function(_ref10){var theme=_ref10.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref11){var theme=_ref11.theme;return Object(__WEBPACK_IMPORTED_MODULE_8_polished__["a" /* rgba */])(theme.foreground,0.7);});var Otc=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(props){return props.tab&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13);});var AnotherContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var SimpleSpinner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var StockClose=function(_React$Component){_inherits(StockClose,_React$Component);function StockClose(){var _ref12;var _temp,_this,_ret;_classCallCheck(this,StockClose);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref12=StockClose.__proto__||Object.getPrototypeOf(StockClose)).call.apply(_ref12,[this].concat(args))),_this),_this.state={ready:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StockClose,[{key:"refresh",value:function refresh(){var _this2=this;return Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/api/getAssets").then(function(payload){_this2.props.dispatch({type:"RECEIVE_STOCK_ASSETS",payload:payload});return payload;});}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;if(this.props.stock.enabled===false){this.refresh().then(function(){_this3.setState({ready:true});});}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var _this4=this;// Бывает такое, что мы показываем экран оптимистично, по таймеру.
// После этого мы получим актуальный апдейт и сделаем запрос для всех
// остальных котировок.
if(prevProps.stock.enabled===true&&this.props.stock.enabled===false){this.refresh().then(function(){_this4.setState({ready:true});});}}},{key:"render",value:function render(){var props=this.props;var recommendations=this.state.ready?Object.keys(props.stocks).map(function(symbol){return props.stocks[symbol];}).filter(function(stock){return stock.enabled&&!props.tabs.includes(stock.stock);}).sort(function(a,b){return props.activeAccount.type==="real"?b.realProfit-a.realProfit:b.demoProfit-a.demoProfit;}).slice(0,6):[];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Timer,{src:__WEBPACK_IMPORTED_MODULE_6__images_timer_svg___default.a,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"The asset trading is closed now")),props.stock.state_changed_at!=null?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeToOpen,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Trading will be opened at"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeText,null,__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.stock.state_changed_at*1000).format("MMMM Do, HH:mm"))):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Line,null),recommendations.length>0?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You can use the following assets"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StocksTable,null,recommendations.map(function(stock){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Stock,{key:stock.stock,onClick:function onClick(){if(typeof props.onStockClick==="function"){props.onStockClick(stock.stock);}}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StockCategory,null,stock.category),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StockName,null,stock.stock.replace("_OTC","")),stock.otc?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OtcImage,null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Otc,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StockPercent,null,props.activeAccount.type==="real"?stock.realProfit+"%":stock.demoProfit+"%"));}))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AnotherContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SimpleSpinner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Spinners_SimpleSpinner__["b" /* NewSimpleSpinnerIcon */],{width:"30px",height:"30px"}))));}}]);return StockClose;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){return{tabs:state.tabs&&state.tabs.tabs};}/* harmony default export */ __webpack_exports__["h"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(StockClose));

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _pure = _interopRequireDefault(__webpack_require__(1764));

var _SvgIcon = _interopRequireDefault(__webpack_require__(1770));

function createSvgIcon(path, displayName) {
  var Icon = function Icon(props) {
    return _react.default.createElement(_SvgIcon.default, props, path);
  };

  Icon.displayName = "".concat(displayName, "Icon");
  Icon = (0, _pure.default)(Icon);
  Icon.muiName = 'SvgIcon';
  return Icon;
}

;
var _default = createSvgIcon;
exports.default = _default;

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__componentPropType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__componentPropType__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "componentPropType", function() { return __WEBPACK_IMPORTED_MODULE_0__componentPropType___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(1774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "chainPropTypes", function() { return __WEBPACK_IMPORTED_MODULE_1__chainPropTypes___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp__ = __webpack_require__(1775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__exactProp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__exactProp__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "exactProp", function() { return __WEBPACK_IMPORTED_MODULE_2__exactProp___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName__ = __webpack_require__(1776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__getDisplayName__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return __WEBPACK_IMPORTED_MODULE_3__getDisplayName___default.a; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__ = __webpack_require__(1777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal__);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "ponyfillGlobal", function() { return __WEBPACK_IMPORTED_MODULE_4__ponyfillGlobal___default.a; });
/** @license Material-UI v3.0.0-alpha.3
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */







/***/ }),
/* 281 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCssValue;
var join = function join(value, by) {
  var result = '';
  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }
  return result;
};

/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */
function toCssValue(value) {
  var ignoreImportant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!Array.isArray(value)) return value;

  var cssValue = '';

  // Support space separated values via `[['5px', '10px']]`.
  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', ');

  // Add !important, because it was ignored.
  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = createRule;

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _StyleRule = __webpack_require__(167);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _cloneStyle = __webpack_require__(1788);

var _cloneStyle2 = _interopRequireDefault(_cloneStyle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Create a rule instance.
 */
function createRule() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'unnamed';
  var decl = arguments[1];
  var options = arguments[2];
  var jss = options.jss;

  var declCopy = (0, _cloneStyle2['default'])(decl);

  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule;

  // It is an at-rule and it has no instance.
  if (name[0] === '@') {
    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
  }

  return new _StyleRule2['default'](name, declCopy, options);
}

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isBrowser", function() { return isBrowser; });
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["default"] = (isBrowser);


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.deepmerge = factory());
}(this, (function () { 'use strict';

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

return deepmerge_1;

})));


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(209);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(710);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(444);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    if (_scrollEvents2.default.registered.begin) {
      _scrollEvents2.default.registered.begin(to, target);
    }

    props.absolute = true;

    var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (containerElement === document) {
        window.scrollTo(0, scrollOffset);
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return a + b * t;
  };
});


/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = deinterpolateLinear;
/* harmony export (immutable) */ __webpack_exports__["a"] = copy;
/* harmony export (immutable) */ __webpack_exports__["b"] = continuous;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constant__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(742);






var unit = [0, 1];

function deinterpolateLinear(a, b) {
  return (b -= (a = +a))
      ? function(x) { return (x - a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_3__constant__["a" /* default */])(b);
}

function deinterpolateClamp(deinterpolate) {
  return function(a, b) {
    var d = deinterpolate(a = +a, b = +b);
    return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
  };
}

function reinterpolateClamp(reinterpolate) {
  return function(a, b) {
    var r = reinterpolate(a = +a, b = +b);
    return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
  };
}

function bimap(domain, range, deinterpolate, reinterpolate) {
  var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
  if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
  else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
  return function(x) { return r0(d0(x)); };
}

function polymap(domain, range, deinterpolate, reinterpolate) {
  var j = Math.min(domain.length, range.length) - 1,
      d = new Array(j),
      r = new Array(j),
      i = -1;

  // Reverse descending domains.
  if (domain[j] < domain[0]) {
    domain = domain.slice().reverse();
    range = range.slice().reverse();
  }

  while (++i < j) {
    d[i] = deinterpolate(domain[i], domain[i + 1]);
    r[i] = reinterpolate(range[i], range[i + 1]);
  }

  return function(x) {
    var i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 1, j) - 1;
    return r[i](d[i](x));
  };
}

function copy(source, target) {
  return target
      .domain(source.domain())
      .range(source.range())
      .interpolate(source.interpolate())
      .clamp(source.clamp());
}

// deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
function continuous(deinterpolate, reinterpolate) {
  var domain = unit,
      range = unit,
      interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolate"],
      clamp = false,
      piecewise,
      output,
      input;

  function rescale() {
    piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }

  function scale(x) {
    return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate) : deinterpolate, interpolate)))(+x);
  }

  scale.invert = function(y) {
    return (input || (input = piecewise(range, domain, deinterpolateLinear, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
  };

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_2__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]), rescale()) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = __WEBPACK_IMPORTED_MODULE_2__array__["b" /* slice */].call(_), interpolate = __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateRound"], rescale();
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, rescale()) : clamp;
  };

  scale.interpolate = function(_) {
    return arguments.length ? (interpolate = _, rescale()) : interpolate;
  };

  return rescale();
}


/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(452);


/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(Math.abs(x)), x ? x[1] : NaN;
});


/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return availableOscillators; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getRelativeHeight;
/* harmony export (immutable) */ __webpack_exports__["c"] = getOscillatorHeightInPercents;
/* harmony export (immutable) */ __webpack_exports__["e"] = getScaleModifier;
/* harmony export (immutable) */ __webpack_exports__["b"] = OscillatorVisuals;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_scale__ = __webpack_require__(314);
var ATR=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 2099));});var RSI=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 2100));});var MACD=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 2101));});var Stochastic=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 2102));});var ROC=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 2103));});var HeikenAshi=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 2104));});var availableOscillators=["RSI","MACD","Stoch","ROC","ATR","HeikenAshi"];function getRelativeHeight(height,relativeHeightInPercents){return Math.floor(height*(relativeHeightInPercents/100));}function getOscillatorHeightInPercents(itemsNumber){var MAX_HEIGHT_IN_PERCENTS=60;var MIN_HEIGHT_IN_PERCENTS=20;var HEIGHT_PER_ITEM_IN_PERCENTS=20;if(!itemsNumber){return 0;}var heightInPercents=Math.min(MIN_HEIGHT_IN_PERCENTS+HEIGHT_PER_ITEM_IN_PERCENTS*(itemsNumber-1),MAX_HEIGHT_IN_PERCENTS);return heightInPercents;}function getScaleModifier(indicators){var enabledIndicators=indicators.filter(function(indicator){return indicator.enabled!==false;});var oscillators=[];if(enabledIndicators&&enabledIndicators.length){oscillators=enabledIndicators.filter(function(indicator){return indicator.isOscillator===true&&availableOscillators.indexOf(indicator.type)>-1;});}var oscillatorHeightInPercents=getOscillatorHeightInPercents(oscillators.length);var scaleModifier=1-oscillatorHeightInPercents/100;return scaleModifier;}function OscillatorVisuals(props){var stock=props.stock,width=props.width,height=props.height,oscillatorHeight=props.oscillatorHeight,points=props.points,rawData=props.rawData,indicators=props.indicators,scaleX=props.scaleX,scaleY=props.scaleY,interval=props.interval,onRemove=props.onRemove,onHide=props.onHide,onEdit=props.onEdit,mobile=props.mobile;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:null},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{height:height,cursor:"default"}},indicators.map(function(indicator,index){if(!indicator.isOscillator||indicator.enabled===false){return null;}switch(indicator.type){case"HeikenAshi":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeikenAshi,{key:index,stock:stock,indicatorIndex:index,width:width,config:indicator,height:oscillatorHeight,points:rawData,scaleX:scaleX,scaleY:scaleY,onHide:onHide,onEdit:onEdit,onRemove:onRemove,interval:interval,mobile:mobile,mouseX:props.mouseX,isHovered:props.isHovered});case"ATR":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ATR,{key:index,indicatorIndex:index,width:width,height:oscillatorHeight,config:indicator,points:points,scaleX:scaleX,onRemove:onRemove,onHide:onHide,onEdit:onEdit,interval:interval,mobile:mobile});case"RSI":var scaleYRSI=Object(__WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleLinear */])().domain([0,100]).range([oscillatorHeight-10,10]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RSI,{key:index,indicatorIndex:index,width:width,height:oscillatorHeight,config:indicator,points:points,scaleX:scaleX,scaleY:scaleYRSI,onRemove:onRemove,onHide:onHide,onEdit:onEdit,interval:interval,mobile:mobile});case"MACD":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MACD,{key:index,stock:stock,indicatorIndex:index,width:width,height:oscillatorHeight,config:indicator,points:points,scaleX:scaleX,onRemove:onRemove,onHide:onHide,onEdit:onEdit,interval:interval,mobile:mobile});case"ROC":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ROC,{key:index,stock:stock,indicatorIndex:index,width:width,height:oscillatorHeight,config:indicator,points:points,scaleX:scaleX,onRemove:onRemove,onHide:onHide,onEdit:onEdit,interval:interval,mobile:mobile});case"Stoch":var scaleYStoch=Object(__WEBPACK_IMPORTED_MODULE_1_d3_scale__["a" /* scaleLinear */])().domain([0,100]).range([oscillatorHeight-10,10]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Stochastic,{key:index,indicatorIndex:index,width:width,height:oscillatorHeight,config:indicator,points:points,scaleX:scaleX,scaleY:scaleYStoch,onRemove:onRemove,onHide:onHide,onEdit:onEdit,interval:interval,mobile:mobile});default:return null;}})));}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Linear(context) {
  this._context = context;
}

Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: this._context.lineTo(x, y); break;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (function(context) {
  return new Linear(context);
});


/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function() {});


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Basis;
function point(that, x, y) {
  that._context.bezierCurveTo(
    (2 * that._x0 + that._x1) / 3,
    (2 * that._y0 + that._y1) / 3,
    (that._x0 + 2 * that._x1) / 3,
    (that._y0 + 2 * that._y1) / 3,
    (that._x0 + 4 * that._x1 + x) / 6,
    (that._y0 + 4 * that._y1 + y) / 6
  );
}

function Basis(context) {
  this._context = context;
}

Basis.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3: point(this, this._x1, this._y1); // proceed
      case 2: this._context.lineTo(this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Basis(context);
});


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = point;
/* harmony export (immutable) */ __webpack_exports__["a"] = Cardinal;
function point(that, x, y) {
  that._context.bezierCurveTo(
    that._x1 + that._k * (that._x2 - that._x0),
    that._y1 + that._k * (that._y2 - that._y0),
    that._x2 + that._k * (that._x1 - x),
    that._y2 + that._k * (that._y1 - y),
    that._x2,
    that._y2
  );
}

function Cardinal(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

Cardinal.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: point(this, this._x1, this._y1); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new Cardinal(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return dealDuplicatesReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LeftIndicatorView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return dealCloser; });
/* harmony export (immutable) */ __webpack_exports__["e"] = getRefundPercent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tooltip_NextGenTooltip__ = __webpack_require__(1984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layers__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__layout_Mobile__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__layout_Desktop__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icons_Close__ = __webpack_require__(65);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 1px;\n  background-color: ",";\n\n  "," ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 1px;\n  background-color: ",";\n\n  "," ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      top: 23px;\n      left: 1px;\n      width: 1px;\n      height: calc(100% - 65px);\n    "],["\n      top: 23px;\n      left: 1px;\n      width: 1px;\n      height: calc(100% - 65px);\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      background-color: ",";\n    "],["\n      background-color: ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      bottom: 0;\n      height: calc(100% - 23px);\n    "],["\n      bottom: 0;\n      height: calc(100% - 23px);\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -8px;\n  left: -8px;\n  width: 16px;\n  height: 17px;\n  "," z-index: ",";\n  text-align: center;\n  -webkit-backface-visibility: hidden;\n\n  ",";\n"],["\n  position: absolute;\n  top: -8px;\n  left: -8px;\n  width: 16px;\n  height: 17px;\n  "," z-index: ",";\n  text-align: center;\n  -webkit-backface-visibility: hidden;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      top: -6px;\n      left: -6px;\n      width: 12px;\n      height: 13px;\n    "],["\n      top: -6px;\n      left: -6px;\n      width: 12px;\n      height: 13px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  fill-rule: evenodd;\n  fill: ",";\n"],["\n  fill-rule: evenodd;\n  fill: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -5px;\n  left: -4px;\n  width: 9px;\n  height: 9px;\n  background-color: ",";\n  background-clip: padding-box;\n  border: 1px solid ",";\n  border-radius: 50%;\n  z-index: ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: -5px;\n  left: -4px;\n  width: 9px;\n  height: 9px;\n  background-color: ",";\n  background-clip: padding-box;\n  border: 1px solid ",";\n  border-radius: 50%;\n  z-index: ",";\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n      top: -3px;\n      left: -2px;\n      width: 5px;\n      height: 5px;\n    "],["\n      top: -3px;\n      left: -2px;\n      width: 5px;\n      height: 5px;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 85px;\n  padding: 14px 5px;\n  background-color: ",";\n  border: 1px solid ",";\n\n  @media (min-width: 960px) {\n    min-width: 130px;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 85px;\n  padding: 14px 5px;\n  background-color: ",";\n  border: 1px solid ",";\n\n  @media (min-width: 960px) {\n    min-width: 130px;\n  }\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n            bottom: calc(100% + 2px);\n            border-radius: 4px;\n          "],["\n            bottom: calc(100% + 2px);\n            border-radius: 4px;\n          "]),_templateObject12=_taggedTemplateLiteral(["\n            top: calc(100% + 2px);\n            border-radius: 4px;\n          "],["\n            top: calc(100% + 2px);\n            border-radius: 4px;\n          "]),_templateObject13=_taggedTemplateLiteral(["\n          top: calc(100% + 2px);\n          border-radius: 4px;\n        "],["\n          top: calc(100% + 2px);\n          border-radius: 4px;\n        "]),_templateObject14=_taggedTemplateLiteral(["\n          bottom: calc(100% + 2px);\n          border-radius: 4px;\n        "],["\n          bottom: calc(100% + 2px);\n          border-radius: 4px;\n        "]),_templateObject15=_taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 7px;\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n  text-align: center;\n"],["\n  display: block;\n  margin-bottom: 7px;\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n  text-align: center;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  display: block;\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n  text-align: center;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"],["\n  display: block;\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n  text-align: center;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  font-size: 0.75em;\n"],["\n  font-size: 0.75em;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// СЛОВАРЬ
// positive/negative: Ставка на удорожание или удешевление стока
// profitable: Сбывается ли предсказание в данный момент
var dealDuplicatesReducer=function dealDuplicatesReducer(result,deal,index,deals){if(result.length>0){var last=result[result.length-1];if(deal.timestamp===last.timestamp&&deal.bidType===last.bidType&&deal.amount===last.amount){last.multiplier+=1;var duplicates=last.duplicates||[];duplicates.push(deal);last.duplicates=duplicates;}else{result.push(Object.assign({},deal,{multiplier:1}));}}else{result.push(Object.assign({},deal,{multiplier:1}));}return result;};var BarView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.isPositive?"rgb(96,163,28)":"rgb(230,76,60)";},function(props){return props.vertical&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(props){return props.isPositive?"rgba(96,163,28,.75)":"rgba(230,76,60,.75)";});},function(props){return props.vertical&&props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var RightIndicatorView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject5,""/* border-radius: 8px; */,__WEBPACK_IMPORTED_MODULE_3__Layers__["a" /* default */].INDICATOR,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var RightIndicatorBg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].path(_templateObject7,function(props){return props.theme.main;});var RightIndicatorBorder=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].path(_templateObject7,function(props){return props.isPositive?"rgb(96,163,28)":"rgb(230,76,60)";});var RightIndicatorIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].path(_templateObject7,function(props){return props.theme.accent;});var LeftIndicatorView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(props){return props.theme.main;},function(_ref){var theme=_ref.theme;return theme.foreground;},__WEBPACK_IMPORTED_MODULE_3__Layers__["a" /* default */].TOOLTIP,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});var SellDealBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_8_polished__["a" /* rgba */])(theme.sellDealBg,0.9);},function(_ref3){var theme=_ref3.theme;return theme.sellDealBorder;},function(_ref4){var isPositive=_ref4.isPositive,isRevert=_ref4.isRevert;return isPositive?isRevert?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12):isRevert?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14);});var SellDealProfit=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12),function(_ref5){var theme=_ref5.theme;return theme.sellDealProfitColor;});var SellDealButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12),function(_ref6){var theme=_ref6.theme;return theme.sellDealButtonColor;});var SellDeal=function SellDeal(_ref7){var isPositive=_ref7.isPositive,profit=_ref7.profit,onClick=_ref7.onClick,y=_ref7.y,chartHeight=_ref7.chartHeight,props=_objectWithoutProperties(_ref7,["isPositive","profit","onClick","y","chartHeight"]);var isRevert=isPositive?chartHeight-y-70<0:y-70<0;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealBlock,{isPositive:isPositive,isRevert:isRevert},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealProfit,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,props.multiplier*profit)),props.refundFetching.has(props.dealId)?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Spinners_SimpleSpinner__["a" /* NewSimpleSpinner */],null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealButton,{onClick:onClick,onTouchStart:function onTouchStart(e){e.target.refundClick=true;onClick(e);}},props.multiplier>1?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_Gettext__["b" /* default */],null,"Close ",props.multiplier," deals"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_Gettext__["b" /* default */],null,"Close the deal")));};function HorizontalBar(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BarView,{style:{width:props.x+props.width+"px",WebkitTransform:"translate3d(0, "+props.y+"px, 0)",transform:"translate3d(0, "+props.y+"px, 0)"},mobile:props.mobile,isPositive:props.isPositive});}function VerticalBar(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BarView,{vertical:true,style:{WebkitTransform:"translateX("+(props.x+props.width)+"px)",transform:"translateX("+(props.x+props.width)+"px)"},mobile:props.mobile,isPositive:props.isPositive});}function RightIndicator(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightIndicatorView,{style:{WebkitTransform:"translate3d("+props.x+"px, "+props.y+"px, 0) scale(1.0, 1.0)",transform:"translate3d("+props.x+"px, "+props.y+"px, 0) scale(1.0, 1.0)",borderColor:props.isPositive?"rgb(96,163,28)":"rgb(230,76,60)"},width:"16px",height:"17px",viewBox:"0 0 16 17",mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightIndicatorBg,{d:"M8.529,1.738 C12.260,1.738 15.284,4.763 15.284,8.493 C15.284,12.224 12.260,15.249 8.529,15.249 C4.798,15.249 1.774,12.224 1.774,8.493 C1.774,4.763 4.798,1.738 8.529,1.738 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightIndicatorBorder,{isPositive:props.isPositive,d:"M16.008,8.501 C16.008,12.655 12.641,16.021 8.488,16.021 C4.335,16.021 0.968,12.655 0.968,8.501 C0.968,4.348 4.335,0.981 8.488,0.981 C12.641,0.981 16.008,4.348 16.008,8.501 ZM8.483,2.143 C4.971,2.143 2.124,4.990 2.124,8.501 C2.124,12.013 4.971,14.860 8.483,14.860 C11.994,14.860 14.841,12.013 14.841,8.501 C14.841,4.990 11.994,2.143 8.483,2.143 Z"}),props.isProfitable!==null&&(props.isProfitable?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightIndicatorIcon,{d:"M12.000,9.000 L9.000,9.000 L9.000,12.000 L8.000,12.000 L8.000,9.000 L5.000,9.000 L5.000,8.000 L8.000,8.000 L8.000,5.000 L9.000,5.000 L9.000,8.000 L12.000,8.000 L12.000,9.000 Z"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightIndicatorIcon,{d:"M5.732,9.032 L5.732,8.032 L11.290,8.032 L11.290,9.032 L5.732,9.032 Z"})));}var Currency=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */].Symbol)(_templateObject17);var dealCloser=function dealCloser(deal,closeFn){if(deal.id){closeFn(deal.id);}if(deal.duplicates){deal.duplicates.forEach(function(duplicate){return dealCloser(duplicate,closeFn);});}};function LeftIndicator(_ref8){var _ref8$tooltip=_ref8.tooltip,tooltip=_ref8$tooltip===undefined?true:_ref8$tooltip,props=_objectWithoutProperties(_ref8,["tooltip"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LeftIndicatorView,{style:{WebkitTransform:"translate3d("+props.x+"px, "+props.y+"px, 0)",transform:"translate3d("+props.x+"px, "+props.y+"px, 0)",backgroundColor:props.isPositive?"rgb(96,163,28)":"rgb(230,76,60)"},mobile:props.mobile},tooltip&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tooltip_NextGenTooltip__["a" /* default */],{mobile:props.mobile,isPositive:props.isPositive},props.multiplier>1&&props.multiplier+" \u2715\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],{Symbol:Currency,currency:props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_7__Icons_Kuchka__["b" /* tournamentCurrency */]:null},props.amount),props.isRefundable&&!props.isDealMid&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__layout_Mobile__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Close__["a" /* default */],{width:10,height:10,strokeWidth:3,style:{marginLeft:5,marginTop:2,opacity:0.6},onClick:props.refundClickHandler,onTouchStart:function onTouchStart(e){e.target.refundClick=true;props.refundClickHandler(e);}}))),props.isRefundable&&!props.isDealMid&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__layout_Desktop__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDeal,{multiplier:props.multiplier,dealId:props.dealId,profit:props.refundProfit,onClick:props.refundClickHandler,refundFetching:props.refundFetching,isPositive:props.isPositive,y:props.y,chartHeight:props.chartHeight})));}function getRefundPercent(returnK,bidType,refundPoints){var refundPercent=void 0;if(bidType){if(returnK<refundPoints.refund_10){refundPercent=0;}else if(returnK>=refundPoints.refund_10&&returnK<refundPoints.refund_30){refundPercent=0.1;}else if(returnK>=refundPoints.refund_30&&returnK<refundPoints.refund_95){refundPercent=0.3;}else if(returnK>=refundPoints.refund_95&&returnK<refundPoints.refund_100){refundPercent=0.95;}else if(returnK>=refundPoints.refund_100&&returnK<refundPoints.refund_105){refundPercent=1;}else if(returnK>=refundPoints.refund_105&&returnK<refundPoints.refund_110){refundPercent=1.05;}else if(returnK>=refundPoints.refund_110&&returnK<refundPoints.refund_115){refundPercent=1.1;}else{refundPercent=1.15;}}else{if(returnK<=refundPoints.refund_115){refundPercent=1.15;}else if(returnK>refundPoints.refund_115&&returnK<=refundPoints.refund_110){refundPercent=1.1;}else if(returnK>refundPoints.refund_110&&returnK<=refundPoints.refund_105){refundPercent=1.05;}else if(returnK>refundPoints.refund_105&&returnK<=refundPoints.refund_100){refundPercent=1;}else if(returnK>refundPoints.refund_100&&returnK<=refundPoints.refund_95){refundPercent=0.95;}else if(returnK>refundPoints.refund_95&&returnK<=refundPoints.refund_30){refundPercent=0.3;}else if(returnK>refundPoints.refund_30&&returnK<=refundPoints.refund_10){refundPercent=0.1;}else{refundPercent=0;}}return refundPercent;}var Deal=function Deal(props){var start=props.scaleX(props.open_timestamp*1000);var end=props.scaleX((props.open_timestamp+props.bTime)*1000);var dealMid=(props.open_timestamp+props.bTime/2)*1000;var isDealMid=dealMid<props.now;// const features = api.readEntity("/api/features/list");
// const closeEarly = features.value && features.value.find(feature => feature.name === "operation_early_close");
var isRefundable=props.refund_10!=null&&props.refund_30!=null&&props.refund_95!=null&&props.refund_100!=null&&props.refund_105!=null&&props.refund_110!=null&&props.refund_115!=null;var refundProfit=void 0;if(isRefundable){var returnK=(props.lastPoint[2].value-props.value)/props.value;var refundPercent=getRefundPercent(returnK,props.bidType,{refund_10:props.refund_10,refund_30:props.refund_30,refund_95:props.refund_95,refund_100:props.refund_100,refund_105:props.refund_105,refund_110:props.refund_110,refund_115:props.refund_115});refundProfit=props.amount*refundPercent;}var valueY=props.scaleY(props.value);var endsOffscreen=end>props.viewportWidth;var width=endsOffscreen?Math.floor(props.viewportWidth-start):Math.floor(end-start);var isProfitable=null;if(props.lastPoint.value!==props.value){isProfitable=props.bidType?props.lastPoint[2].value>=props.value:props.lastPoint[2].value<=props.value;}var dealIsActive=props.profit===undefined;var shouldShowTimer=!endsOffscreen&&dealIsActive;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalBar,{x:start,y:valueY,width:width,isPositive:props.bidType,mobile:props.mobile}),!endsOffscreen&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerticalBar,{x:start,y:valueY,width:width,isPositive:props.bidType,mobile:props.mobile}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LeftIndicator,{x:start,y:valueY,dealId:props.id,tooltip:props.tooltip,isPositive:props.bidType,amount:props.amount,mobile:props.mobile,multiplier:props.multiplier,tradeMode:props.tradeMode,isDealMid:isDealMid,isRefundable:isRefundable,refundProfit:refundProfit,chartHeight:props.chartHeight,refundClickHandler:function refundClickHandler(){return dealCloser(props,props.refundClickHandler);},refundFetching:props.refundFetching}),shouldShowTimer&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RightIndicator,{x:end,y:valueY,isPositive:props.bidType,isProfitable:isProfitable,mobile:props.mobile}));};/* harmony default export */ __webpack_exports__["d"] = (Object(__WEBPACK_IMPORTED_MODULE_6__common_fetch__["h" /* withFetch */])(Deal));

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Будем раскладывать элементы по слоям с помощью
// CSS свойства z-index.
var Layers=["BACKGROUND","CHART","COVER","INDICATOR","TOOLTIP","ZOOM","SENTIMENTS"].reduce(function(result,layer,index){result[layer]=index+1;return result;},{});/* harmony default export */ __webpack_exports__["a"] = (Layers);

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = formatTimeInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_timer_svg__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_timer_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_timer_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AnimationWrapper__ = __webpack_require__(225);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 25px;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 0;\n  }\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 25px;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n"],["\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  max-width: 477px;\n  margin: 0 auto;\n  text-align: center;\n  background-color: ",";\n  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100%;\n    height: 100%;\n    max-width: 100%;\n    box-shadow: none;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  max-width: 477px;\n  margin: 0 auto;\n  text-align: center;\n  background-color: ",";\n  box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: 100%;\n    height: 100%;\n    max-width: 100%;\n    box-shadow: none;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  right: 12px;\n  width: 19px;\n  height: 19px;\n  color: #96949b;\n  transition: color 0.15s ease;\n  cursor: pointer;\n\n  @media (max-width: 959px) {\n    top: 12px;\n\n    > svg {\n      stroke-width: 2px;\n    }\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"],["\n  position: absolute;\n  top: 16px;\n  right: 12px;\n  width: 19px;\n  height: 19px;\n  color: #96949b;\n  transition: color 0.15s ease;\n  cursor: pointer;\n\n  @media (max-width: 959px) {\n    top: 12px;\n\n    > svg {\n      stroke-width: 2px;\n    }\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  padding: 25px;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    height: 100%;\n    max-height: 470px;\n  }\n"],["\n  padding: 25px;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-around;\n    height: 100%;\n    max-height: 470px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  max-width: 390px;\n  margin: 0 auto 22px;\n  font-weight: 500;\n  font-size: 22px;\n  text-align: center;\n  color: #e74c3c;\n\n  @media (max-width: 959px) {\n    font-size: 18px;\n  }\n"],["\n  max-width: 390px;\n  margin: 0 auto 22px;\n  font-weight: 500;\n  font-size: 22px;\n  text-align: center;\n  color: #e74c3c;\n\n  @media (max-width: 959px) {\n    font-size: 18px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: block;\n  width: 52px;\n  margin: 0 auto 25px;\n"],["\n  display: block;\n  width: 52px;\n  margin: 0 auto 25px;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  margin-bottom: 5px;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n  color: #feac00;\n"],["\n  margin-bottom: 5px;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n  color: #feac00;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-bottom: 32px;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n  color: #fff;\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n  }\n"],["\n  margin-bottom: 32px;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n  color: #fff;\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 18px;\n  text-align: center;\n  color: ",";\n"],["\n  font-size: ",";\n  line-height: 18px;\n  text-align: center;\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var PopupTable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].table(_templateObject2);var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.mainHighlight;});var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var Timer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject7);var TimeText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Disclamer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.ticksFontColor;});function formatTimeInterval(ms){var time=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(ms);var h=("0"+time.hours()).slice(-2);var m=("0"+time.minutes()).slice(-2);var s=("0"+time.seconds()).slice(-2);return h+":"+m+":"+s;}function TradeIsClosing(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PopupTable,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__AnimationWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 19.707 19.707"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{x2:"19",y2:"19",stroke:"currentColor",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{x1:"19",y2:"19",stroke:"currentColor",fill:"none"})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The opening of a trade is not possible")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Timer,{src:__WEBPACK_IMPORTED_MODULE_4__images_timer_svg___default.a,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeText,null,formatTimeInterval(props.time)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"left till the market closure"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Disclamer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Trading with this asset will be closed soon. Please choose the earlier expiration time."))))))))));}/* harmony default export */ __webpack_exports__["a"] = (TradeIsClosing);

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Gettext__ = __webpack_require__(2);
var Refund=function Refund(_ref){var className=_ref.className,style=_ref.style;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",{style:Object.assign({textTransform:"uppercase"},style)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Gettext__["b" /* default */],null,"refund"));};/* harmony default export */ __webpack_exports__["a"] = (Refund);

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = isError;
/* harmony export (immutable) */ __webpack_exports__["d"] = isErrorEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = isDOMError;
/* harmony export (immutable) */ __webpack_exports__["b"] = isDOMException;
/* harmony export (immutable) */ __webpack_exports__["h"] = isString;
/* harmony export (immutable) */ __webpack_exports__["f"] = isPrimitive;
/* harmony export (immutable) */ __webpack_exports__["e"] = isPlainObject;
/* harmony export (immutable) */ __webpack_exports__["g"] = isRegExp;
/* harmony export (immutable) */ __webpack_exports__["j"] = isThenable;
/* harmony export (immutable) */ __webpack_exports__["i"] = isSyntheticEvent;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (Object.prototype.toString.call(wat)) {
        case '[object Error]':
            return true;
        case '[object Exception]':
            return true;
        case '[object DOMException]':
            return true;
        default:
            return wat instanceof Error;
    }
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return Object.prototype.toString.call(wat) === '[object ErrorEvent]';
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMError]';
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return Object.prototype.toString.call(wat) === '[object DOMException]';
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return Object.prototype.toString.call(wat) === '[object String]';
}
/**
 * Checks whether given value's is a primitive (undefined, null, number, boolean, string)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return Object.prototype.toString.call(wat) === '[object Object]';
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return Object.prototype.toString.call(wat) === '[object RegExp]';
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // tslint:disable:no-unsafe-any
    return Boolean(wat && wat.then && typeof wat.then === 'function');
    // tslint:enable:no-unsafe-any
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    // tslint:disable-next-line:no-unsafe-any
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
//# sourceMappingURL=is.js.map

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (immutable) */ __webpack_exports__["b"] = __read;
/* harmony export (immutable) */ __webpack_exports__["c"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return _subscribe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _installGlobalHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _installGlobalUnhandledRejectionHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _computeStackTrace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);
// tslint:disable


/**
 * TraceKit - Cross brower stack traces
 *
 * This was originally forked from github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 *
 * NOTE: Last merge with upstream repository
 * Jul 11,2018 - #f03357c
 *
 * https://github.com/csnover/TraceKit
 * @license MIT
 * @namespace TraceKit
 */
var window = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
var TraceKit = {
    _report: false,
    _collectWindowErrors: false,
    _computeStackTrace: false,
    _linesOfContext: false,
};
// var TraceKit: TraceKitInterface = {};
// var TraceKit = {};
// global reference to slice
var UNKNOWN_FUNCTION = '?';
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/;
/**
 * A better form of hasOwnProperty<br/>
 * Example: `_has(MainHostObject, property) === true/false`
 *
 * @param {Object} object to check property
 * @param {string} key to check
 * @return {Boolean} true if the object has the key and it is not inherited
 */
function _has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
/**
 * A safe form of location.href<br/>
 *
 * @return {string} location.href
 */
function getLocationHref() {
    if (typeof document === 'undefined' || document.location == null)
        return '';
    return document.location.href;
}
/**
 * Cross-browser processing of unhandled exceptions
 *
 * Syntax:
 * ```js
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 * ```
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *     on top frame; column number is not guaranteed
 *   - Opera: full stack trace with line and column numbers
 *   - Chrome: full stack trace with line and column numbers
 *   - Safari: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *   - IE: line and column number for the top frame only; some frames
 *     may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit._computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a TraceKit.StackTrace object as described in the
 * TraceKit._computeStackTrace docs.
 *
 * @memberof TraceKit
 * @namespace
 */
TraceKit._report = (function reportModuleWrapper() {
    var handlers = [], lastException = null, lastExceptionStack = null;
    /**
     * Add a crash handler.
     * @param {Function} handler
     * @memberof TraceKit.report
     */
    function _subscribe(handler) {
        // NOTE: We call both handlers manually in browser/integrations/globalhandler.ts
        // So user can choose which one he wants to attach
        // installGlobalHandler();
        // installGlobalUnhandledRejectionHandler();
        handlers.push(handler);
    }
    /**
     * Dispatch stack information to all handlers.
     * @param {TraceKit.StackTrace} stack
     * @param {boolean} isWindowError Is this a top-level window error?
     * @param {Error=} error The error that's being handled (if available, null otherwise)
     * @memberof TraceKit.report
     * @throws An exception if an error occurs while calling an handler.
     */
    function _notifyHandlers(stack, isWindowError, error) {
        var exception = null;
        if (isWindowError && !TraceKit._collectWindowErrors) {
            return;
        }
        for (var i in handlers) {
            if (_has(handlers, i)) {
                try {
                    handlers[i](stack, isWindowError, error);
                }
                catch (inner) {
                    exception = inner;
                }
            }
        }
        if (exception) {
            throw exception;
        }
    }
    var _oldOnerrorHandler, _onErrorHandlerInstalled;
    /**
     * Ensures all global unhandled exceptions are recorded.
     * Supported by Gecko and IE.
     * @param {string} message Error message.
     * @param {string} url URL of script that generated the exception.
     * @param {(number|string)} lineNo The line number at which the error occurred.
     * @param {(number|string)=} columnNo The column number at which the error occurred.
     * @param {Error=} errorObj The actual Error object.
     * @memberof TraceKit.report
     */
    function _traceKitWindowOnError(message, url, lineNo, columnNo, errorObj) {
        var stack = null;
        // If 'errorObj' is ErrorEvent, get real Error from inside
        errorObj = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* isErrorEvent */])(errorObj) ? errorObj.error : errorObj;
        // If 'message' is ErrorEvent, get real message from inside
        message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["m" /* isErrorEvent */])(message) ? message.message : message;
        if (lastExceptionStack) {
            TraceKit._computeStackTrace._augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
            processLastException();
        }
        else if (errorObj && Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["l" /* isError */])(errorObj)) {
            stack = TraceKit._computeStackTrace(errorObj);
            stack.mechanism = 'onerror';
            _notifyHandlers(stack, true, errorObj);
        }
        else {
            var location = {
                url: url,
                line: lineNo,
                column: columnNo,
            };
            var name;
            var msg = message; // must be new var or will modify original `arguments`
            if ({}.toString.call(message) === '[object String]') {
                var groups = message.match(ERROR_TYPES_RE);
                if (groups) {
                    name = groups[1];
                    msg = groups[2];
                }
            }
            location.func = UNKNOWN_FUNCTION;
            location.context = null;
            stack = {
                name: name,
                message: msg,
                mode: 'onerror',
                mechanism: 'onerror',
                stack: [
                    __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, location, { 
                        // Firefox sometimes doesn't return url correctly and this is an old behavior
                        // that I prefer to port here as well.
                        // It can be altered only here, as previously it's using `location.url` for other things — Kamil
                        url: location.url || getLocationHref() }),
                ],
            };
            _notifyHandlers(stack, true, null);
        }
        if (_oldOnerrorHandler) {
            // @ts-ignore
            return _oldOnerrorHandler.apply(this, arguments);
        }
        return false;
    }
    /**
     * Ensures all unhandled rejections are recorded.
     * @param {PromiseRejectionEvent} e event.
     * @memberof TraceKit.report
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onunhandledrejection
     * @see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
     */
    function _traceKitWindowOnUnhandledRejection(e) {
        var err = e;
        // You cannot itterate over non-objects, but we want to check
        // for the existence in any value, not for the value itself
        try {
            err = e && 'reason' in e ? e.reason : e;
        }
        catch (_oO) { }
        var stack = TraceKit._computeStackTrace(err);
        stack.mechanism = 'onunhandledrejection';
        _notifyHandlers(stack, true, err);
    }
    /**
     * Install a global onerror handler
     * @memberof TraceKit.report
     */
    function _installGlobalHandler() {
        if (_onErrorHandlerInstalled === true) {
            return;
        }
        _oldOnerrorHandler = window.onerror;
        window.onerror = _traceKitWindowOnError;
        _onErrorHandlerInstalled = true;
    }
    /**
     * Install a global onunhandledrejection handler
     * @memberof TraceKit.report
     */
    function _installGlobalUnhandledRejectionHandler() {
        window.onunhandledrejection = _traceKitWindowOnUnhandledRejection;
    }
    /**
     * Process the most recent exception
     * @memberof TraceKit.report
     */
    function processLastException() {
        var _lastExceptionStack = lastExceptionStack, _lastException = lastException;
        lastExceptionStack = null;
        lastException = null;
        _notifyHandlers(_lastExceptionStack, false, _lastException);
    }
    /**
     * Reports an unhandled Error to TraceKit.
     * @param {Error} ex
     * @memberof TraceKit.report
     * @throws An exception if an incomplete stack trace is detected (old IE browsers).
     */
    function _report(ex) {
        if (lastExceptionStack) {
            if (lastException === ex) {
                return; // already caught by an inner catch block, ignore
            }
            else {
                processLastException();
            }
        }
        var stack = TraceKit._computeStackTrace(ex);
        lastExceptionStack = stack;
        lastException = ex;
        // If the stack trace is incomplete, wait for 2 seconds for
        // slow slow IE to see if onerror occurs or not before reporting
        // this exception; otherwise, we will end up with an incomplete
        // stack trace
        setTimeout(function () {
            if (lastException === ex) {
                processLastException();
            }
        }, stack.incomplete ? 2000 : 0);
        throw ex; // re-throw to propagate to the top level (and cause window.onerror)
    }
    _report._subscribe = _subscribe;
    _report._installGlobalHandler = _installGlobalHandler;
    _report._installGlobalUnhandledRejectionHandler = _installGlobalUnhandledRejectionHandler;
    return _report;
})();
/**
 * An object representing a single stack frame.
 * @typedef {Object} StackFrame
 * @property {string} url The JavaScript or HTML file URL.
 * @property {string} func The function name, or empty for anonymous functions (if guessing did not work).
 * @property {string[]?} args The arguments passed to the function, if known.
 * @property {number=} line The line number, if known.
 * @property {number=} column The column number, if known.
 * @property {string[]} context An array of source code lines; the middle element corresponds to the correct line#.
 * @memberof TraceKit
 */
/**
 * An object representing a JavaScript stack trace.
 * @typedef {Object} StackTrace
 * @property {string} name The name of the thrown exception.
 * @property {string} message The exception error message.
 * @property {TraceKit.StackFrame[]} stack An array of stack frames.
 * @property {string} mode 'stack', 'stacktrace', 'multiline', 'callers', 'onerror', or 'failed' -- method used to collect the stack trace.
 * @memberof TraceKit
 */
/**
 * TraceKit._computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   ```js
 *   s = TraceKit._computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 *   ```
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit._computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit._computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 * @memberof TraceKit
 * @namespace
 */
TraceKit._computeStackTrace = (function _computeStackTraceWrapper() {
    // Contents of Exception in various browsers.
    //
    // SAFARI:
    // ex.message = Can't find variable: qq
    // ex.line = 59
    // ex.sourceId = 580238192
    // ex.sourceURL = http://...
    // ex.expressionBeginOffset = 96
    // ex.expressionCaretOffset = 98
    // ex.expressionEndOffset = 98
    // ex.name = ReferenceError
    //
    // FIREFOX:
    // ex.message = qq is not defined
    // ex.fileName = http://...
    // ex.lineNumber = 59
    // ex.columnNumber = 69
    // ex.stack = ...stack trace... (see the example below)
    // ex.name = ReferenceError
    //
    // CHROME:
    // ex.message = qq is not defined
    // ex.name = ReferenceError
    // ex.type = not_defined
    // ex.arguments = ['aa']
    // ex.stack = ...stack trace...
    //
    // INTERNET EXPLORER:
    // ex.message = ...
    // ex.name = ReferenceError
    //
    // OPERA:
    // ex.message = ...message... (see the example below)
    // ex.name = ReferenceError
    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
    /**
     * Computes stack trace information from the stack property.
     * Chrome and Gecko use this property.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceFromStackProp(ex) {
        if (!ex || !ex.stack) {
            return null;
        }
        // Chromium based browsers: Chrome, Brave, new Opera, new Edge
        var chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|native|eval|webpack|<anonymous>|[-a-z]+:|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, 
        // gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
        // generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
        // We need this specific case for now because we want no other regex to match.
        gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js))(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, 
        // Used to additionally parse URL/line/column from eval frames
        isEval, geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i, chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/, lines = ex.stack.split('\n'), stack = [], submatch, parts, element, reference = /^(.*) is undefined$/.exec(ex.message);
        for (var i = 0, j = lines.length; i < j; ++i) {
            if ((parts = chrome.exec(lines[i]))) {
                var isNative = parts[2] && parts[2].indexOf('native') === 0; // start of line
                isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
                if (isEval && (submatch = chromeEval.exec(parts[2]))) {
                    // throw out eval line/column and use top-most line/column number
                    parts[2] = submatch[1]; // url
                    parts[3] = submatch[2]; // line
                    parts[4] = submatch[3]; // column
                }
                element = {
                    url: parts[2],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: isNative ? [parts[2]] : [],
                    line: parts[3] ? +parts[3] : null,
                    column: parts[4] ? +parts[4] : null,
                };
            }
            else if ((parts = winjs.exec(lines[i]))) {
                element = {
                    url: parts[2],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: [],
                    line: +parts[3],
                    column: parts[4] ? +parts[4] : null,
                };
            }
            else if ((parts = gecko.exec(lines[i]))) {
                isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
                if (isEval && (submatch = geckoEval.exec(parts[3]))) {
                    // throw out eval line/column and use top-most line number
                    parts[1] = parts[1] || "eval";
                    parts[3] = submatch[1];
                    parts[4] = submatch[2];
                    parts[5] = ''; // no column when eval
                }
                else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) {
                    // FireFox uses this awesome columnNumber property for its top frame
                    // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                    // so adding 1
                    // NOTE: this hack doesn't work if top-most frame is eval
                    stack[0].column = ex.columnNumber + 1;
                }
                element = {
                    url: parts[3],
                    func: parts[1] || UNKNOWN_FUNCTION,
                    args: parts[2] ? parts[2].split(',') : [],
                    line: parts[4] ? +parts[4] : null,
                    column: parts[5] ? +parts[5] : null,
                };
            }
            else {
                continue;
            }
            if (!element.func && element.line) {
                element.func = UNKNOWN_FUNCTION;
            }
            element.context = null;
            stack.push(element);
        }
        if (!stack.length) {
            return null;
        }
        if (stack[0] && stack[0].line && !stack[0].column && reference) {
            stack[0].column = null;
        }
        return {
            mode: 'stack',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
    }
    /**
     * Computes stack trace information from the stacktrace property.
     * Opera 10+ uses this property.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack trace information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceFromStacktraceProp(ex) {
        // Access and store the stacktrace property before doing ANYTHING
        // else to it because Opera is not very good at providing it
        // reliably in other circumstances.
        var stacktrace = ex.stacktrace;
        if (!stacktrace) {
            return;
        }
        var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i, opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^\)]+))\((.*)\))? in (.*):\s*$/i, lines = stacktrace.split('\n'), stack = [], parts;
        for (var line = 0; line < lines.length; line += 2) {
            var element = null;
            if ((parts = opera10Regex.exec(lines[line]))) {
                element = {
                    url: parts[2],
                    line: +parts[1],
                    column: null,
                    func: parts[3],
                    args: [],
                };
            }
            else if ((parts = opera11Regex.exec(lines[line]))) {
                element = {
                    url: parts[6],
                    line: +parts[1],
                    column: +parts[2],
                    func: parts[3] || parts[4],
                    args: parts[5] ? parts[5].split(',') : [],
                };
            }
            if (element) {
                if (!element.func && element.line) {
                    element.func = UNKNOWN_FUNCTION;
                }
                if (element.line) {
                    element.context = null;
                }
                if (!element.context) {
                    element.context = [lines[line + 1]];
                }
                stack.push(element);
            }
        }
        if (!stack.length) {
            return null;
        }
        return {
            mode: 'stacktrace',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
    }
    /**
     * NOT TESTED.
     * Computes stack trace information from an error message that includes
     * the stack trace.
     * Opera 9 and earlier use this method if the option to show stack
     * traces is turned on in opera:config.
     * @param {Error} ex
     * @return {?TraceKit.StackTrace} Stack information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceFromOperaMultiLineMessage(ex) {
        // TODO: Clean this function up
        // Opera includes a stack trace into the exception message. An example is:
        //
        // Statement on line 3: Undefined variable: undefinedFunc
        // Backtrace:
        //   Line 3 of linked script file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.js: In function zzz
        //         undefinedFunc(a);
        //   Line 7 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function yyy
        //           zzz(x, y, z);
        //   Line 3 of inline#1 script in file://localhost/Users/andreyvit/Projects/TraceKit/javascript-client/sample.html: In function xxx
        //           yyy(a, a, a);
        //   Line 1 of function script
        //     try { xxx('hi'); return false; } catch(ex) { TraceKit.report(ex); }
        //   ...
        var lines = ex.message.split('\n');
        if (lines.length < 4) {
            return null;
        }
        var lineRE1 = /^\s*Line (\d+) of linked script ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i, lineRE2 = /^\s*Line (\d+) of inline#(\d+) script in ((?:file|https?|blob)\S+)(?:: in function (\S+))?\s*$/i, lineRE3 = /^\s*Line (\d+) of function script\s*$/i, stack = [], scripts = window && window.document && window.document.getElementsByTagName('script'), inlineScriptBlocks = [], parts;
        for (var s in scripts) {
            if (_has(scripts, s) && !scripts[s].src) {
                inlineScriptBlocks.push(scripts[s]);
            }
        }
        for (var line = 2; line < lines.length; line += 2) {
            var item = null;
            if ((parts = lineRE1.exec(lines[line]))) {
                item = {
                    url: parts[2],
                    func: parts[3],
                    args: [],
                    line: +parts[1],
                    column: null,
                };
            }
            else if ((parts = lineRE2.exec(lines[line]))) {
                item = {
                    url: parts[3],
                    func: parts[4],
                    args: [],
                    line: +parts[1],
                    column: null,
                };
            }
            else if ((parts = lineRE3.exec(lines[line]))) {
                var url = getLocationHref().replace(/#.*$/, '');
                item = {
                    url: url,
                    func: '',
                    args: [],
                    line: parts[1],
                    column: null,
                };
            }
            if (item) {
                if (!item.func) {
                    item.func = UNKNOWN_FUNCTION;
                }
                // if (context) alert("Context mismatch. Correct midline:\n" + lines[i+1] + "\n\nMidline:\n" + midline + "\n\nContext:\n" + context.join("\n") + "\n\nURL:\n" + item.url);
                item.context = [lines[line + 1]];
                stack.push(item);
            }
        }
        if (!stack.length) {
            return null; // could not parse multiline exception message as Opera stack trace
        }
        return {
            mode: 'multiline',
            name: ex.name,
            message: lines[0],
            stack: stack,
        };
    }
    /**
     * Adds information about the first frame to incomplete stack traces.
     * Safari and IE require this to get complete data on the first frame.
     * @param {TraceKit.StackTrace} stackInfo Stack trace information from
     * one of the compute* methods.
     * @param {string} url The URL of the script that caused an error.
     * @param {(number|string)} lineNo The line number of the script that
     * caused an error.
     * @param {string=} message The error generated by the browser, which
     * hopefully contains the name of the object that caused the error.
     * @return {boolean} Whether or not the stack information was
     * augmented.
     * @memberof TraceKit._computeStackTrace
     */
    function _augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
        var initial = {
            url: url,
            line: lineNo,
        };
        if (initial.url && initial.line) {
            stackInfo.incomplete = false;
            if (!initial.func) {
                initial.func = UNKNOWN_FUNCTION;
            }
            if (!initial.context) {
                initial.context = null;
            }
            var reference = / '([^']+)' /.exec(message);
            if (reference) {
                initial.column = null;
            }
            if (stackInfo.stack.length > 0) {
                if (stackInfo.stack[0].url === initial.url) {
                    if (stackInfo.stack[0].line === initial.line) {
                        return false; // already in stack trace
                    }
                    else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                        stackInfo.stack[0].line = initial.line;
                        stackInfo.stack[0].context = initial.context;
                        return false;
                    }
                }
            }
            stackInfo.stack.unshift(initial);
            stackInfo.partial = true;
            return true;
        }
        else {
            stackInfo.incomplete = true;
        }
        return false;
    }
    /**
     * Computes stack trace information by walking the arguments.caller
     * chain at the time the exception occurred. This will cause earlier
     * frames to be missed but is the only way to get any stack trace in
     * Safari and IE. The top frame is restored by
     * {@link augmentStackTraceWithInitialElement}.
     * @param {Error} ex
     * @return {TraceKit.StackTrace=} Stack trace information.
     * @memberof TraceKit._computeStackTrace
     */
    function _computeStackTraceByWalkingCallerChain(ex, depth) {
        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, stack = [], funcs = {}, recursion = false, parts, item;
        for (var curr = _computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller) {
            if (curr === _computeStackTrace || curr === TraceKit._report) {
                continue;
            }
            item = {
                url: null,
                func: UNKNOWN_FUNCTION,
                args: [],
                line: null,
                column: null,
            };
            if (curr.name) {
                item.func = curr.name;
            }
            else if ((parts = functionName.exec(curr.toString()))) {
                item.func = parts[1];
            }
            if (typeof item.func === 'undefined') {
                try {
                    item.func = parts.input.substring(0, parts.input.indexOf('{'));
                }
                catch (e) { }
            }
            if (funcs['' + curr]) {
                recursion = true;
            }
            else {
                funcs['' + curr] = true;
            }
            stack.push(item);
        }
        if (depth) {
            stack.splice(0, depth);
        }
        var result = {
            mode: 'callers',
            name: ex.name,
            message: ex.message,
            stack: stack,
        };
        _augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
        return result;
    }
    /**
     * Computes a stack trace for an exception.
     * @param {Error} ex
     * @param {(string|number)=} depth
     * @memberof TraceKit._computeStackTrace
     */
    function computeStackTrace(ex, depth) {
        var stack = null;
        var popSize = ex && ex.framesToPop;
        depth = depth == null ? 0 : +depth;
        try {
            // This must be tried first because Opera 10 *destroys*
            // its stacktrace property if you try to access the stack
            // property first!!
            stack = _computeStackTraceFromStacktraceProp(ex);
            if (stack) {
                return popFrames(stack, popSize);
            }
        }
        catch (e) { }
        try {
            stack = _computeStackTraceFromStackProp(ex);
            if (stack) {
                return popFrames(stack, popSize);
            }
        }
        catch (e) { }
        try {
            stack = _computeStackTraceFromOperaMultiLineMessage(ex);
            if (stack) {
                return popFrames(stack, popSize);
            }
        }
        catch (e) { }
        try {
            stack = _computeStackTraceByWalkingCallerChain(ex, depth + 1);
            if (stack) {
                return popFrames(stack, popSize);
            }
        }
        catch (e) { }
        return {
            original: ex,
            name: ex && ex.name,
            message: ex && ex.message,
            mode: 'failed',
        };
    }
    function popFrames(stacktrace, popSize) {
        if (Number.isNaN(popSize)) {
            return stacktrace;
        }
        try {
            return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, stacktrace, { stack: stacktrace.stack.slice(popSize) });
        }
        catch (e) {
            return stacktrace;
        }
    }
    computeStackTrace._augmentStackTraceWithInitialElement = _augmentStackTraceWithInitialElement;
    computeStackTrace._computeStackTraceFromStackProp = _computeStackTraceFromStackProp;
    return computeStackTrace;
})();
TraceKit._collectWindowErrors = true;
TraceKit._linesOfContext = 11;
var _subscribe = TraceKit._report._subscribe;
var _installGlobalHandler = TraceKit._report._installGlobalHandler;
var _installGlobalUnhandledRejectionHandler = TraceKit._report._installGlobalUnhandledRejectionHandler;
var _computeStackTrace = TraceKit._computeStackTrace;

//# sourceMappingURL=tracekit.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = shouldIgnoreOnError;
/* unused harmony export ignoreNextOnError */
/* harmony export (immutable) */ __webpack_exports__["d"] = wrap;
/* harmony export (immutable) */ __webpack_exports__["a"] = breadcrumbEventHandler;
/* harmony export (immutable) */ __webpack_exports__["b"] = keypressEventHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(29);



var debounceDuration = 1000;
var keypressTimeout;
var lastCapturedEvent;
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    if (options === void 0) { options = {}; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) {
            return fn;
        }
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) {
            return fn.__sentry_wrapped__;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    var sentryWrapped = function () {
        // tslint:disable-next-line:strict-type-predicates
        if (before && typeof before === 'function') {
            before.apply(this, arguments);
        }
        var args = Array.prototype.slice.call(arguments);
        // tslint:disable:no-unsafe-any
        try {
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            if (fn.handleEvent) {
                // Attempt to invoke user-land function
                // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
                //       means the sentry.javascript SDK caught an error invoking your application code. This
                //       is expected behavior and NOT indicative of a bug with sentry.javascript.
                return fn.handleEvent.apply(this, wrappedArguments);
            }
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
            // tslint:enable:no-unsafe-any
        }
        catch (ex) {
            ignoreNextOnError();
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["i" /* withScope */])(function (scope) {
                scope.addEventProcessor(function (event) {
                    var processedEvent = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
                    if (options.mechanism) {
                        Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["d" /* addExceptionTypeValue */])(processedEvent, undefined, undefined, options.mechanism);
                    }
                    processedEvent.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, processedEvent.extra, { arguments: Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["u" /* normalize */])(args, 3) });
                    return processedEvent;
                });
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["f" /* captureException */])(ex);
            });
            throw ex;
        }
    };
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // tslint:disable-line:no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, '__sentry_wrapped__', {
        enumerable: false,
        value: sentryWrapped,
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true,
        },
        __sentry_original__: {
            enumerable: false,
            value: fn,
        },
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
    }
    catch (_oO) {
        /*no-empty*/
    }
    return sentryWrapped;
}
var debounceTimer = 0;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param eventName the event name (e.g. "click")
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function breadcrumbEventHandler(eventName, debounce) {
    if (debounce === void 0) { debounce = false; }
    return function (event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        lastCapturedEvent = event;
        var captureBreadcrumb = function () {
            // try/catch both:
            // - accessing event.target (see getsentry/raven-js#838, #768)
            // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
            //   can throw an exception in some circumstances.
            var target;
            try {
                target = event.target ? _htmlTreeAsString(event.target) : _htmlTreeAsString(event);
            }
            catch (e) {
                target = '<unknown>';
            }
            if (target.length === 0) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb({
                category: "ui." + eventName,
                message: target,
            }, {
                event: event,
                name: eventName,
            });
        };
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }
        if (debounce) {
            debounceTimer = setTimeout(captureBreadcrumb);
        }
        else {
            captureBreadcrumb();
        }
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @returns wrapped keypress events handler
 * @hidden
 */
function keypressEventHandler() {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function (event) {
        var target;
        try {
            target = event.target;
        }
        catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || (tagName !== 'INPUT' && tagName !== 'TEXTAREA' && !target.isContentEditable)) {
            return;
        }
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!keypressTimeout) {
            breadcrumbEventHandler('input')(event);
        }
        clearTimeout(keypressTimeout);
        keypressTimeout = setTimeout(function () {
            keypressTimeout = undefined;
        }, debounceDuration);
    };
}
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlTreeAsString(elem) {
    var currentElem = elem;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    var height = 0;
    var len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    var nextStr;
    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
        nextStr = _htmlElementAsString(currentElem);
        // bail out if
        // - nextStr is the 'html' element
        // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
        //   (ignore this limit if we are on the first iteration)
        if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
            break;
        }
        out.push(nextStr);
        len += nextStr.length;
        currentElem = currentElem.parentNode;
    }
    return out.reverse().join(separator);
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(elem) {
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    if (elem.id) {
        out.push("#" + elem.id);
    }
    className = elem.className;
    if (className && Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["q" /* isString */])(className)) {
        classes = className.split(/\s+/);
        for (i = 0; i < classes.length; i++) {
            out.push("." + classes[i]);
        }
    }
    var attrWhitelist = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < attrWhitelist.length; i++) {
        key = attrWhitelist[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
//# sourceMappingURL=helpers.js.map

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(81);
/* harmony default export */ __webpack_exports__["a"] = (function(){if(Object(__WEBPACK_IMPORTED_MODULE_2__utils__["c" /* isIronTerminal */])()){return"IronTerminal";}switch("irontrade"){case"siamoption":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"SiamOption");case"irontrade":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"IronTrade");default:return"Rosco Solutions LTD";}});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export checkLeadingZero */
/* harmony export (immutable) */ __webpack_exports__["c"] = getLeadingZeroError;
/* harmony export (immutable) */ __webpack_exports__["e"] = ripOffLeadingZero;
/* unused harmony export ripOffDuplicatedCountryCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhoneInputHint; });
/* harmony export (immutable) */ __webpack_exports__["d"] = parsePhone;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_libphonenumber_js_metadata_min_json__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_libphonenumber_js_metadata_min_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_libphonenumber_js_metadata_min_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_build_country_names__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_build_country_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_build_country_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_virtualized_styles_css__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_virtualized_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_virtualized_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Flag__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CountrySelect__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Input__ = __webpack_require__(1633);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  vertical-align: middle;\n"],["\n  vertical-align: middle;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  white-space: nowrap;\n"],["\n  white-space: nowrap;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex: 1;\n"],["\n  flex: 1;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  margin-right: 4px;\n  color: #aaa;\n  vertical-align: middle;\n"],["\n  margin-right: 4px;\n  color: #aaa;\n  vertical-align: middle;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  color: #4e2a81;\n  vertical-align: middle;\n"],["\n  color: #4e2a81;\n  vertical-align: middle;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Flag=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_6__common_Flag__["h" /* default */])(_templateObject);var Unbreakable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2);var WORLD_OPTION={value:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Other"),label:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Other"),phoneCode:"",phoneNumber:"",code:"world"};var COUNTRY_LIST=__WEBPACK_IMPORTED_MODULE_4_react_phone_number_input_build_country_names___default.a.map(function(_ref){var _ref2=_slicedToArray(_ref,2),countryCode=_ref2[0],countryName=_ref2[1];var _ref3=__WEBPACK_IMPORTED_MODULE_3_libphonenumber_js_metadata_min_json___default.a.countries[countryCode.toUpperCase()]||[],_ref4=_slicedToArray(_ref3,1),phoneCode=_ref4[0];if(phoneCode){return{value:countryName,label:countryName,phoneCode:phoneCode,code:countryCode};}return null;}).filter(function(item){return item!==null;});COUNTRY_LIST.push(WORLD_OPTION);var InputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var DisplayMode=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var CodePart=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject4);var PhonePart=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5);function checkLeadingZero(phoneNumber){return /^\+?0\d*$/.test(phoneNumber);}function getLeadingZeroError(phoneNumber,phoneExample){if(checkLeadingZero(phoneNumber)){return phoneExample?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Incorrect number! It seems like you type your local number. Please, use international format, see an example:")," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Unbreakable,null,phoneExample)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Incorrect number! It seems like you type your local number. Please, use international format.");}return"";}function ripOffLeadingZero(phoneCode,phoneNumber){var number=phoneNumber;var r=new RegExp("^\\+"+phoneCode+"0(\\d*)$");var x=r.exec(number);if(x&&x[1]){number="+"+phoneCode+x[1];}return number;}function ripOffDuplicatedCountryCode(phoneCode,phoneNumber){var PLUS_LENGTH=1;var MAX_NUMBER_LENGTH=11;// Due to https://jgit.me/binary-options/irontrade-web/issues/158
var number=phoneNumber;var phoneCodeLength=(phoneCode||"").toString().length;if(phoneCode&&number.length>MAX_NUMBER_LENGTH+phoneCodeLength+PLUS_LENGTH){var r=new RegExp("^\\+"+phoneCode+phoneCode+"(0?)\\d*$");var x=r.exec(number);if(x){var l=PLUS_LENGTH+2*phoneCodeLength;// double of phone code size (actual code + duplicate code)
if(x[1]){l+=1;// Increase length for national "0"
}number="+"+phoneCode+number.slice(l);// rewrite number without duplicated country code
}}return number;}var PhoneInputHint=function PhoneInputHint(props){if(props.hint)return props.hint;if(props.countryCode==="world"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"We recommend you to choose a country code.");}if(props.phoneExample){// Use wrapping span so the text wouldn't be splitted by flex in profile
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Please, choose your country code and enter your local number without 0 at the beginning. Example:"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Unbreakable,null," ",props.phoneExample));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Please choose your country and enter your phone number in international format.");};function parsePhone(phone,defaultCountry){var parsedAsIs=Object(__WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["b" /* parse */])(phone);var parsedPlus=Object(__WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["b" /* parse */])("+"+phone);var parsed=parsedAsIs;var country=void 0;var value="";if(parsedPlus&&parsedPlus.country){parsed=parsedPlus;}if(parsed&&parsed.country){value=parsed.phone;country=COUNTRY_LIST.find(function(country){return country.code.toUpperCase()===parsed.country.toUpperCase();});}else if(defaultCountry){country=COUNTRY_LIST.find(function(country){return country.code.toUpperCase()===defaultCountry.toUpperCase();});}if(!country){country=WORLD_OPTION;}return{value:value,country:country};}var PhoneInput=function(_React$Component){_inherits(PhoneInput,_React$Component);function PhoneInput(props){_classCallCheck(this,PhoneInput);var _this=_possibleConstructorReturn(this,(PhoneInput.__proto__||Object.getPrototypeOf(PhoneInput)).call(this,props));_initialiseProps.call(_this);var _parsePhone=parsePhone(props.value,_this.props.defaultCountry),value=_parsePhone.value,country=_parsePhone.country;if(!value){value=props.value;}if(country&&_this.checkPlus(value)){value=value.slice(1+country.phoneCode.length);}_this.state={countryAutoSwitched:false,country:country,value:value};return _this;}_createClass(PhoneInput,[{key:"render",value:function render(){var _this2=this;var _props=this.props,_props$Container=_props.Container,Container=_props$Container===undefined?__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"]:_props$Container,lockCountry=_props.lockCountry,errorMessage=_props.errorMessage,placeholder=_props.placeholder,focus=_props.focus,id=_props.id,onBlur=_props.onBlur,onFocus=_props.onFocus,showInfo=_props.showInfo,displayMode=_props.displayMode,isProfile=_props.isProfile,showPhoneInfo=_props.showPhoneInfo,version=_props.version,isWithdraw=_props.isWithdraw;var blurHandler=typeof onBlur==="function"?onBlur:null;var focusHandler=typeof onFocus==="function"?onFocus:null;var selectError=this.state.country.phoneCode===undefined&&errorMessage;var inputError=this.state.country.phoneCode!==undefined&&errorMessage;if(displayMode){var _value=this.state.value||this.props.value;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DisplayMode,null,this.state.country.phoneCode&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{country:this.state.country.code}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CodePart,null,"+",this.state.country.phoneCode)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PhonePart,null,_value)));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__CountrySelect__["a" /* default */],{value:this.state.country,options:this.props.countries?COUNTRY_LIST.filter(function(item){return _this2.props.countries.includes(item.code);}):COUNTRY_LIST,onChange:lockCountry?null:this.selectChangeHandler,invalid:selectError,error:!!inputError,showInfo:showInfo,isProfile:isProfile,version:version,isWithdraw:isWithdraw})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Input__["a" /* default */],{id:id||"phone-input",focus:focus,type:"tel",placeholder:placeholder,value:this.state.value,label:"",error:inputError,onChange:this.inputChangeHandler,onFocus:focusHandler,onBlur:blurHandler,wide:true,isProfile:isProfile,isWithdraw:isWithdraw,showPhoneInfo:showPhoneInfo,version:version,autocomplete:"tel"})));}}]);return PhoneInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this3=this;this.checkPlus=function(value){return value.charAt(0)==="+"?1:0;};this.selectChangeHandler=function(e){var value=_this3.state.value;var country=e.target.value;var code=country.phoneCode;if(code&&_this3.checkPlus(value)){value=value.slice(1);}if(!code&&!_this3.checkPlus(value)){value="+"+value;}_this3.setState({selectChanged:true,countryAutoSwitched:false,value:value,country:country},_this3.onChange);};this.inputChangeHandler=function(e){var regular=/^\+?\d*$/;var unplusable=/^\d*$/;var r=unplusable;var r1=e.currentTarget.value;var r2=_this3.state.value;var countryAutoSwitched=false;var country=_this3.state.country;if(country===WORLD_OPTION){r=regular;r1=_this3.checkPlus(e.currentTarget.value)?e.currentTarget.value:"+"+e.currentTarget.value;}var value=r.test(e.currentTarget.value)?r1:r2;if(_this3.checkPlus(value)){// If user puts the plus sign in then try to re-parse input value
var parsed=Object(__WEBPACK_IMPORTED_MODULE_2_libphonenumber_js__["b" /* parse */])(value);if(parsed&&parsed.country){value=parsed.phone;country=COUNTRY_LIST.find(function(country){return country.code.toUpperCase()===parsed.country.toUpperCase();});if(country){countryAutoSwitched=true;}}}_this3.setState({selectChanged:false,countryAutoSwitched:countryAutoSwitched,value:value,country:country},_this3.onChange);};this.onChange=function(){var _state=_this3.state,selectChanged=_state.selectChanged,countryAutoSwitched=_state.countryAutoSwitched,country=_state.country,value=_state.value;if(country.phoneCode!==undefined){var sign=country.phoneCode?"+":"";var phone=value?""+sign+country.phoneCode+value:"";_this3.props.onChange({selectChanged:selectChanged,countryAutoSwitched:countryAutoSwitched,number:value,country:country,fullNumber:phone});}};};/* harmony default export */ __webpack_exports__["b"] = (PhoneInput);

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SingleInput */
/* unused harmony export Container */
/* unused harmony export Tabs */
/* unused harmony export Content */
/* unused harmony export MainHeading */
/* unused harmony export Subheading */
/* unused harmony export Heading */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FieldContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FakeLink; });
/* unused harmony export CodeContainer */
/* unused harmony export CodeInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  margin: 0 7px;\n  width: 185px;\n  min-width: 185px;\n  height: 44px;\n  letter-spacing: 15px;\n  font-size: 22px;\n  text-align: center;\n  padding-left: 15px;\n  color: #4e2a81;\n  border: none;\n  border-bottom: 2px solid\n    ",";\n  border-radius: 0;\n  background-color: transparent;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  @media (min-width: 960px) {\n    width: 100px;\n    font-size: 20px;\n    height: 30px;\n    border-bottom-width: 1px;\n  }\n"],["\n  margin: 0 7px;\n  width: 185px;\n  min-width: 185px;\n  height: 44px;\n  letter-spacing: 15px;\n  font-size: 22px;\n  text-align: center;\n  padding-left: 15px;\n  color: #4e2a81;\n  border: none;\n  border-bottom: 2px solid\n    ",";\n  border-radius: 0;\n  background-color: transparent;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  @media (min-width: 960px) {\n    width: 100px;\n    font-size: 20px;\n    height: 30px;\n    border-bottom-width: 1px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-grow: 1;\n  flex-grow: 1;\n  -webkit-align-self: stretch;\n  align-self: stretch;\n  width: 100%;\n  max-width: 1179px;\n  margin: 0 auto 20px auto;\n"],["\n  display: flex;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-grow: 1;\n  flex-grow: 1;\n  -webkit-align-self: stretch;\n  align-self: stretch;\n  width: 100%;\n  max-width: 1179px;\n  margin: 0 auto 20px auto;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  max-width: 1179px;\n  min-height: 48px;\n  margin: 0 auto;\n  background: #fff;\n  user-select: none;\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  width: 100%;\n  max-width: 1179px;\n  min-height: 48px;\n  margin: 0 auto;\n  background: #fff;\n  user-select: none;\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  text-align: left;\n\n  @media (max-width: 959px) {\n    padding: 0 16px;\n  }\n\n  @media (min-width: 960px) {\n    -webkit-flex-grow: 0;\n    flex-grow: 0;\n    -webkit-align-self: auto;\n    align-self: auto;\n    margin-top: 33px;\n    padding: 24px;\n    background-color: #f6f6f6;\n    border-radius: 4px;\n  }\n"],["\n  text-align: left;\n\n  @media (max-width: 959px) {\n    padding: 0 16px;\n  }\n\n  @media (min-width: 960px) {\n    -webkit-flex-grow: 0;\n    flex-grow: 0;\n    -webkit-align-self: auto;\n    align-self: auto;\n    margin-top: 33px;\n    padding: 24px;\n    background-color: #f6f6f6;\n    border-radius: 4px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  padding-top: 1em;\n  font-weight: 300;\n  font-size: 30px;\n  line-height: 1.25;\n  text-align: center;\n  color: #343434;\n"],["\n  padding-top: 1em;\n  font-weight: 300;\n  font-size: 30px;\n  line-height: 1.25;\n  text-align: center;\n  color: #343434;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n  margin-bottom: 2em;\n  padding-top: 0.5em;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.45;\n  text-align: center;\n  color: #a7a7a7;\n"],["\n  direction: ",";\n  margin-bottom: 2em;\n  padding-top: 0.5em;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.45;\n  text-align: center;\n  color: #a7a7a7;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  padding-bottom: ",";\n  font-size: 16px;\n  line-height: 1.375;\n  text-align: center;\n  color: #343434;\n\n  @media (min-width: 960px) {\n    font-size: 20px;\n  }\n"],["\n  padding-bottom: ",";\n  font-size: 16px;\n  line-height: 1.375;\n  text-align: center;\n  color: #343434;\n\n  @media (min-width: 960px) {\n    font-size: 20px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  margin: 0 auto 0;\n\n  @media (min-width: 960px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    align-content: space-between;\n    justify-content: space-around;\n    max-width: 460px;\n  }\n"],["\n  width: 100%;\n  text-align: center;\n  margin: 0 auto 0;\n\n  @media (min-width: 960px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: flex-start;\n    align-content: space-between;\n    justify-content: space-around;\n    max-width: 460px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  cursor: pointer;\n  text-decoration: underline;\n  color: #3498db;\n  @media (max-width: 959px) {\n    margin-bottom: 15px;\n  }\n"],["\n  cursor: pointer;\n  text-decoration: underline;\n  color: #3498db;\n  @media (max-width: 959px) {\n    margin-bottom: 15px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-content: space-between;\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px 0;\n\n  @media (min-width: 960px) {\n    margin-top: 20px;\n  }\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n  }\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-content: space-between;\n  width: 100%;\n  margin: 0 auto;\n  padding: 10px 0;\n\n  @media (min-width: 960px) {\n    margin-top: 20px;\n  }\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n  }\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n      margin-top: 0;\n      padding: 5px 0;\n\n      @media (min-width: 960px) {\n        margin-top: 0;\n      }\n    "],["\n      margin-top: 0;\n      padding: 5px 0;\n\n      @media (min-width: 960px) {\n        margin-top: 0;\n      }\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  margin: 0 7px;\n  width: 37px;\n  min-width: 37px;\n  height: 44px;\n  font-size: 22px;\n  text-align: center;\n  color: #4e2a81;\n  border: none;\n  border-bottom: 2px solid\n    ",";\n  border-radius: 0;\n  background-color: transparent;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  @media (min-width: 960px) {\n    width: 20px;\n    font-size: 20px;\n    height: 30px;\n    border-bottom-width: 1px;\n  }\n\n  ",";\n"],["\n  margin: 0 7px;\n  width: 37px;\n  min-width: 37px;\n  height: 44px;\n  font-size: 22px;\n  text-align: center;\n  color: #4e2a81;\n  border: none;\n  border-bottom: 2px solid\n    ",";\n  border-radius: 0;\n  background-color: transparent;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  @media (min-width: 960px) {\n    width: 20px;\n    font-size: 20px;\n    height: 30px;\n    border-bottom-width: 1px;\n  }\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      font-size: 18px;\n      width: 20px;\n      min-width: 20px;\n\n      @media (min-width: 960px) {\n        font-size: 18px;\n        width: 20px;\n        min-width: 20px;\n      }\n    "],["\n      font-size: 18px;\n      width: 20px;\n      min-width: 20px;\n\n      @media (min-width: 960px) {\n        font-size: 18px;\n        width: 20px;\n        min-width: 20px;\n      }\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SingleInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].input(_templateObject,function(props){return props.invalid?props.theme.lower:"#cccccc";});var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject2);var Tabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.direction;});var Content=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(Container)(_templateObject4);var MainHeading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h1(_templateObject5);var Subheading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.direction;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Heading=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h2(_templateObject7,function(props){return props.noPadding?0:"1.25em";});var FieldContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject8);var FakeLink=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject9);var CodeContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject10,function(props){return props.compact&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject11);});var CodeInput=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].input.attrs({type:"tel",maxLength:"1"})(_templateObject12,function(props){return props.invalid?props.theme.lower:"#cccccc";},function(props){return props.compact&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject13);});

/***/ }),
/* 306 */
/***/ (function(module, exports) {

module.exports = function(haystack, needle, comparator, low, high) {
  var mid, cmp;

  if(low === undefined)
    low = 0;

  else {
    low = low|0;
    if(low < 0 || low >= haystack.length)
      throw new RangeError("invalid lower bound");
  }

  if(high === undefined)
    high = haystack.length - 1;

  else {
    high = high|0;
    if(high < low || high >= haystack.length)
      throw new RangeError("invalid upper bound");
  }

  while(low <= high) {
    /* Note that "(low + high) >>> 1" may overflow, and results in a typecast
     * to double (which gives the wrong results). */
    mid = low + (high - low >> 1);
    cmp = +comparator(haystack[mid], needle, mid, haystack);

    /* Too low. */
    if(cmp < 0.0)
      low  = mid + 1;

    /* Too high. */
    else if(cmp > 0.0)
      high = mid - 1;

    /* Key found. */
    else
      return mid;
  }

  /* Key not found. */
  return ~low;
}


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76),
    isSymbol = __webpack_require__(187);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InputView; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ltr !important;\n  position: relative;\n  display: block;\n  min-height: 38px;\n  max-height: 38px;\n  @media (max-width: 480px) {\n    min-height: 32px;\n    max-height: 32px;\n  }\n\n  "," ",";\n"],["\n  direction: ltr !important;\n  position: relative;\n  display: block;\n  min-height: 38px;\n  max-height: 38px;\n  @media (max-width: 480px) {\n    min-height: 32px;\n    max-height: 32px;\n  }\n\n  "," ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      min-height: 39px;\n      max-height: 39px;\n    "],["\n      min-height: 39px;\n      max-height: 39px;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      display: table;\n      width: 100%;\n    "],["\n      display: table;\n      width: 100%;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  vertical-align: top;\n  width: 100%;\n  min-height: 38px;\n  padding: ",";\n  margin: 0px;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: #4e2a81;\n  background-color: #fff;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);\n  :focus {\n    outline: none;\n  }\n  @media (max-width: 480px) {\n    min-height: 32px;\n    font-size: ",";\n  }\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ",";\n"],["\n  vertical-align: top;\n  width: 100%;\n  min-height: 38px;\n  padding: ",";\n  margin: 0px;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: #4e2a81;\n  background-color: #fff;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);\n  :focus {\n    outline: none;\n  }\n  @media (max-width: 480px) {\n    min-height: 32px;\n    font-size: ",";\n  }\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      min-height: 39px;\n      border-color: #cfcfcf;\n      color: #4e2a81;\n    "],["\n      min-height: 39px;\n      border-color: #cfcfcf;\n      color: #4e2a81;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      padding-left: 30px;\n    "],["\n      padding-left: 30px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      display: table-cell;\n      width: 100%;\n      border-radius: 3px 0 0 3px;\n      border-right: none;\n    "],["\n      display: table-cell;\n      width: 100%;\n      border-radius: 3px 0 0 3px;\n      border-right: none;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n      border-color: #e85747;\n      color: #e74c3c;\n    "],["\n      border-color: #e85747;\n      color: #e74c3c;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n      background-color: #fff;\n      color: #4e2a81;\n      pointer-events: none;\n      user-select: none;\n      cursor: default;\n    "],["\n      background-color: #fff;\n      color: #4e2a81;\n      pointer-events: none;\n      user-select: none;\n      cursor: default;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n      background-color: #f6f6f6;\n    "],["\n      background-color: #f6f6f6;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n      font-size: 16px;\n      color: #1b546a;\n      text-align: center;\n      border-radius: 4px;\n      border-color: #ccc;\n      box-shadow: none;\n    "],["\n      font-size: 16px;\n      color: #1b546a;\n      text-align: center;\n      border-radius: 4px;\n      border-color: #ccc;\n      box-shadow: none;\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  display: ",";\n  width: 100%;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: #797979;\n  direction: ",";\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n  @media (max-width: 320px) {\n    font-size: ",";\n  }\n"],["\n  display: ",";\n  width: 100%;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: #797979;\n  direction: ",";\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n  @media (max-width: 320px) {\n    font-size: ",";\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 0px;\n  transform: translateY(-50%);\n  padding: 0 7px;\n  line-height: 39px;\n  z-index: 99;\n  pointer-events: none;\n  @media (max-width: 959px) {\n    line-height: 38px;\n    padding: 0 5px;\n  }\n  @media (max-width: 480px) {\n    line-height: 32px;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  top: 50%;\n  left: 0px;\n  transform: translateY(-50%);\n  padding: 0 7px;\n  line-height: 39px;\n  z-index: 99;\n  pointer-events: none;\n  @media (max-width: 959px) {\n    line-height: 38px;\n    padding: 0 5px;\n  }\n  @media (max-width: 480px) {\n    line-height: 32px;\n  }\n\n  ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n      left: 100%;\n      transform: translate(-100%, -50%);\n      margin-left: -1px;\n    "],["\n      left: 100%;\n      transform: translate(-100%, -50%);\n      margin-left: -1px;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n  height: 39px;\n  width: 1px;\n  padding: 0 9px;\n  box-sizing: border-box;\n  font-weight: 400;\n  line-height: 0;\n  border-top: 1px solid #cfcfcf;\n  border-right: 1px solid #cfcfcf;\n  border-bottom: 1px solid #cfcfcf;\n  border-left: none;\n  border-radius: 0 3px 3px 0;\n  box-shadow: inset 0px 2px 0px 0px rgba(227, 227, 227, 1);\n  background-color: #f6f6f6;\n  background-clip: padding-box;\n\n  "," ",";\n"],["\n  display: table-cell;\n  vertical-align: middle;\n  height: 39px;\n  width: 1px;\n  padding: 0 9px;\n  box-sizing: border-box;\n  font-weight: 400;\n  line-height: 0;\n  border-top: 1px solid #cfcfcf;\n  border-right: 1px solid #cfcfcf;\n  border-bottom: 1px solid #cfcfcf;\n  border-left: none;\n  border-radius: 0 3px 3px 0;\n  box-shadow: inset 0px 2px 0px 0px rgba(227, 227, 227, 1);\n  background-color: #f6f6f6;\n  background-clip: padding-box;\n\n  "," ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n      height: auto;\n      line-height: 1;\n      font-size: 16px;\n      white-space: nowrap;\n      @media (max-width: 480px) {\n        font-size: ",";\n      }\n    "],["\n      height: auto;\n      line-height: 1;\n      font-size: 16px;\n      white-space: nowrap;\n      @media (max-width: 480px) {\n        font-size: ",";\n      }\n    "]),_templateObject17=_taggedTemplateLiteral(["\n      border-top: 1px solid #e85747;\n      border-right: 1px solid #e85747;\n      border-bottom: 1px solid #e85747;\n    "],["\n      border-top: 1px solid #e85747;\n      border-right: 1px solid #e85747;\n      border-bottom: 1px solid #e85747;\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DatePicker=Object(__WEBPACK_IMPORTED_MODULE_0_react__["lazy"])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 489));});function debounce(fn,delay){var timer=null;return function(){var context=this,args=arguments;clearTimeout(timer);timer=setTimeout(function(){fn.apply(context,args);},delay);};}var InputWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].label(_templateObject,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.currency&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject3);});var InputView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].input(_templateObject4,function(props){return props.type==="date"?"0 29px 0 7px":"0 7px";},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.Icon&&props.type!=="date"&&props.type!=="time"&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6);},function(props){return props.currency&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject7);},function(props){return props.invalid&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);},function(props){return props.offlinePopup&&props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.promo&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject11);});var Label=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject12,function(props){return props.desktop?"none":"inline-block";},function(props){return props.theme.direction;},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var LabelIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject13,function(props){return props.type==="date"|props.type==="time"&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject14);});var LabelCurrency=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject15,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject16,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});},function(props){return props.invalid&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject17);});var Input=function(_Component){_inherits(Input,_Component);function Input(props){_classCallCheck(this,Input);var _this=_possibleConstructorReturn(this,(Input.__proto__||Object.getPrototypeOf(Input)).call(this,props));_this.onChange=_this.onChange.bind(_this);_this.focus=_this.focus.bind(_this);return _this;}_createClass(Input,[{key:"onChangeDeb",value:function onChangeDeb(value){this.props.onChangeDeb(value);}},{key:"onChange",value:function onChange(e){e.persist();var value=e.target.value;if(typeof this.props.onChange==="function"){this.props.onChange(value);}else if(typeof this.props.onChangeDeb==="function"){this.onChangeDeb(value);}}},{key:"UNSAFE_componentWillMount",value:function UNSAFE_componentWillMount(){this.onChangeDeb=debounce(this.onChangeDeb,1000);}},{key:"componentDidMount",value:function componentDidMount(){this.props.focus&&this.input.focus();}},{key:"focus",value:function focus(){this.input&&this.input.focus();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,_props$type=_props.type,type=_props$type===undefined?"text":_props$type,id=_props.id,label=_props.label,defaultValue=_props.defaultValue,value=_props.value,placeholder=_props.placeholder,desktop=_props.desktop,invalid=_props.invalid,disabled=_props.disabled,Icon=_props.Icon,currency=_props.currency,onFocus=_props.onFocus,onBlur=_props.onBlur,offlinePopup=_props.offlinePopup,readOnly=_props.readOnly,onChange=_props.onChange,maxDate=_props.maxDate,autoComplete=_props.autoComplete,pattern=_props.pattern,inputMode=_props.inputMode,promo=_props.promo;var valueF=value;var isDesktopDate=type==="date"&&desktop;var isMobileDate=type==="date"&&!desktop;if(isMobileDate&&value&&typeof value.format==="function"){// Format moment.js object to string
valueF=value.format("YYYY-MM-DD");}var isAndroid=/Android 4\.\d/.test(navigator.userAgent);var isWebview=/Version\/4\.\d/.test(navigator.userAgent);var isAndroidWebview=isAndroid&&isWebview;var dateTimeType=type==="date"||type==="time";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,label&&id&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{desktop:desktop,htmlFor:id},label,":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputWrapper,{htmlFor:id,desktop:desktop,currency:currency},id&&Icon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelIcon,{type:type},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null)),isDesktopDate?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputView,{as:DatePicker,type:"date",selected:value,onChange:onChange,dateFormat:"dd.MM.yyyy",desktop:desktop,Icon:Icon,invalid:invalid,offlinePopup:offlinePopup,disabled:disabled,maxDate:maxDate,autoComplete:autoComplete})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputView,{ref:function ref(input){return _this2.input=input;},type:isAndroidWebview&&dateTimeType?"text":type,id:id,placeholder:placeholder,desktop:desktop,Icon:Icon,currency:currency,invalid:invalid,offlinePopup:offlinePopup,defaultValue:defaultValue,value:valueF,disabled:disabled,onChange:this.onChange,onFocus:onFocus,onBlur:onBlur,readOnly:readOnly,autoComplete:autoComplete,pattern:pattern,inputMode:inputMode,promo:promo}),id&&currency&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LabelCurrency,{desktop:desktop,invalid:invalid},currency)));}}]);return Input;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["b"] = (Input);Input.propTypes={type:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,id:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,label:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,val:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,placeholder:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,desktop:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,invalid:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,onChangeDeb:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Surface(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",Object.assign({fill:"none",style:{flex:1,zIndex:1}},props));}/* harmony default export */ __webpack_exports__["a"] = (Surface);

/***/ }),
/* 310 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transition__ = __webpack_require__(1464);
var duration=200;var defaultStyles={transition:"opacity "+duration+"ms ease-in-out",opacity:0};var transitionStyles={entered:{opacity:1}};function Fade(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__Transition__["a" /* default */],Object.assign({},props,{timeout:duration,defaultStyles:defaultStyles,transitionStyles:transitionStyles}));}/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__UpdateScreen__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Timing__ = __webpack_require__(580);
function LoadingComponent(props){if(props.isLoading){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__["a" /* default */],null);}if(props.error){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__UpdateScreen__["a" /* default */],null);}return null;}function Loadable(_loader,label){return __WEBPACK_IMPORTED_MODULE_1_react_loadable___default()({LoadingComponent:LoadingComponent,loader:function loader(){return Object(__WEBPACK_IMPORTED_MODULE_4__common_Timing__["a" /* trackOnTimeline */])(_loader(),"Lazy Component: "+label);}});}/* harmony default export */ __webpack_exports__["a"] = (Loadable);

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layout_Layout__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(53);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  vertical-align: middle;\n  margin-left: 29px;\n  margin-right: 14px;\n  padding-right: 14px;\n  color: ",";\n  background-color: transparent;\n  border: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  @media (max-width: 959px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-content: center;\n    width: ",";\n    height: ",";\n    margin-left: 0;\n    margin-right: ",";\n    padding-right: 0;\n    font-size: 24px;\n\n    :hover,\n    :focus,\n    :active {\n      color: ",";\n    }\n\n    ",";\n  }\n\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  vertical-align: middle;\n  margin-left: 29px;\n  margin-right: 14px;\n  padding-right: 14px;\n  color: ",";\n  background-color: transparent;\n  border: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  @media (max-width: 959px) {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    align-content: center;\n    width: ",";\n    height: ",";\n    margin-left: 0;\n    margin-right: ",";\n    padding-right: 0;\n    font-size: 24px;\n\n    :hover,\n    :focus,\n    :active {\n      color: ",";\n    }\n\n    ",";\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n        margin-right: 5px;\n      "],["\n        margin-right: 5px;\n      "]),_templateObject3=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 36px;\n  height: 16px;\n\n  @media (max-width: 959px) {\n    width: 26px;\n    height: 12px;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 36px;\n  height: 16px;\n\n  @media (max-width: 959px) {\n    width: 26px;\n    height: 12px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.staticHeaderLink;},function(props){return props.theme.accent;},function(_ref2){var trade=_ref2.trade;return trade===true?"48px":"auto";},function(_ref3){var trade=_ref3.trade;return trade===true?"48px":"auto";},function(_ref4){var trade=_ref4.trade;return trade===true?0:"14px";},function(_ref5){var theme=_ref5.theme;return theme.staticHeaderLink;},function(props){return!props.trade&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(props){return props.theme.accent;});});var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);function Icon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"625.885 3407 16 16",width:"16",height:"16",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M0,370v-2c0-2.2,3.6-4,8-4s8,1.8,8,4v2Zm4-12a4,4,0,1,1,4,4A4,4,0,0,1,4,358Z",transform:"translate(625.885 3053)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"645 3409 16 14",width:"16",height:"14",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-6160,14V12h10v2Zm0-6V6h16V8Zm0-6V0h16V2Z",transform:"translate(6805 3409)"}))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"-2382.067 2864.3 25.019 11.4",width:"26",height:"12",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{transform:"translate(-2382.067 2864.3)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-6160,9.975V8.549h7.125V9.975Zm0-4.275V4.275h11.4V5.7Zm0-4.275V0h11.4V1.425Z",transform:"translate(6173.619 1.425)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M0,365.4v-1.425c0-1.568,2.565-2.85,5.7-2.85s5.7,1.282,5.7,2.85V365.4Zm2.85-8.549A2.85,2.85,0,1,1,5.7,359.7,2.85,2.85,0,0,1,2.85,356.85Z",transform:"translate(0 -354)"}))));});}function ToggleNav(props){if(props.isIOS){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{as:"a",role:"button",href:"ios://toggle_menu",active:props.active,trade:props.trade,onClick:props.onClick,className:props.className},props.icon||__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null));}var ABTest=props.userId%2;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["a" /* IronRedesignThemeProvider */],null,ABTest?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__layout_Layout__["a" /* Desktop */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{role:"button",onClick:function onClick(){return props.onClick(true);},active:props.active,trade:props.trade,className:props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{marginRight:5,textTransform:"uppercase"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Menu")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,props.icon||__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null)))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__layout_Layout__["b" /* Mobile */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{role:"button",onClick:props.onClick,active:props.active,trade:props.trade,className:props.className},props.icon||__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null)))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{role:"button",onClick:props.onClick,active:props.active,trade:props.trade,className:props.className},props.icon||__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null)));}/* harmony default export */ __webpack_exports__["a"] = (ToggleNav);

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_band__ = __webpack_require__(1873);
/* unused harmony reexport scaleBand */
/* unused harmony reexport scalePoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_identity__ = __webpack_require__(1896);
/* unused harmony reexport scaleIdentity */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_linear__ = __webpack_require__(211);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__src_linear__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_log__ = __webpack_require__(1923);
/* unused harmony reexport scaleLog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_ordinal__ = __webpack_require__(733);
/* unused harmony reexport scaleOrdinal */
/* unused harmony reexport scaleImplicit */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_pow__ = __webpack_require__(1924);
/* unused harmony reexport scalePow */
/* unused harmony reexport scaleSqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_quantile__ = __webpack_require__(1925);
/* unused harmony reexport scaleQuantile */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_quantize__ = __webpack_require__(1926);
/* unused harmony reexport scaleQuantize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_threshold__ = __webpack_require__(1927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__src_threshold__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_time__ = __webpack_require__(748);
/* unused harmony reexport scaleTime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_utcTime__ = __webpack_require__(1943);
/* unused harmony reexport scaleUtc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_category10__ = __webpack_require__(1944);
/* unused harmony reexport schemeCategory10 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__src_category20b__ = __webpack_require__(1945);
/* unused harmony reexport schemeCategory20b */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__src_category20c__ = __webpack_require__(1946);
/* unused harmony reexport schemeCategory20c */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__src_category20__ = __webpack_require__(1947);
/* unused harmony reexport schemeCategory20 */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__src_cubehelix__ = __webpack_require__(1948);
/* unused harmony reexport interpolateCubehelixDefault */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__src_rainbow__ = __webpack_require__(1949);
/* unused harmony reexport interpolateRainbow */
/* unused harmony reexport interpolateWarm */
/* unused harmony reexport interpolateCool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__src_viridis__ = __webpack_require__(1950);
/* unused harmony reexport interpolateViridis */
/* unused harmony reexport interpolateMagma */
/* unused harmony reexport interpolateInferno */
/* unused harmony reexport interpolatePlasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__src_sequential__ = __webpack_require__(1951);
/* unused harmony reexport scaleSequential */







































/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(1179),
    isObjectLike = __webpack_require__(77);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(48),
    stubFalse = __webpack_require__(1191);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 317 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(357),
    isLength = __webpack_require__(362);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Warning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Warning(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"16.094px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16.094 16.125",width:width,fill:fill,fillRule:"evenodd"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M250.01,378.952a8.055,8.055,0,1,0,8.055,8.054A8.054,8.054,0,0,0,250.01,378.952Zm0.982,12.027h-2.006V389h2.006v1.975Zm-1.985-7.969h2v4.956h-2.017Z",transform:"translate(-241.969 -378.938)"}));}

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ModalRoot */
/* harmony export (immutable) */ __webpack_exports__["b"] = ModalRootProvider;
/* harmony export (immutable) */ __webpack_exports__["a"] = Modal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var ModalRoot=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();function ModalRootProvider(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),queue=_useState2[0],setQueue=_useState2[1];var context=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return{enqueue:function enqueue(modal){return setQueue(function(q){return[].concat(_toConsumableArray(q),[modal]);});},dequeue:function dequeue(modal){return setQueue(function(q){return q.filter(function(r){return r!==modal;});});}};},[queue]);var modal=null;if(queue.length>0){var ref=queue[queue.length-1];modal=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:queue.length-1,ref:ref});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ModalRoot.Provider,{value:context},modal,props.children);}function Modal(props){var mode=props.mode;var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isMounted=_useState4[0],setIsMounted=_useState4[1];var container=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var modalRoot=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(ModalRoot);var callback=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return function(node){container.current=node;setIsMounted(node!=null);};},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(mode){modalRoot.enqueue(callback);}else{setIsMounted(false);modalRoot.dequeue(callback);}var prevMode=mode;return function(){if(prevMode===true){setIsMounted(false);modalRoot.dequeue(callback);}};},[mode]);return mode&&isMounted?__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(props.children,container.current):null;}

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function withLanguage(WrappedComponent){var Lang=function(_React$Component){_inherits(Lang,_React$Component);function Lang(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Lang);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Lang.__proto__||Object.getPrototypeOf(Lang)).call.apply(_ref,[this].concat(args))),_this),_this.state={changeLocaleFetching:false},_this.handleLocaleChange=function(nextLocale){if(typeof nextLocale!=="string"){return;}if(_this.props.profile!=null){var prevLocale=_this.props.profile.locale;_this.setState({changeLocaleFetching:true});return _this.props.fetch("/api/change-locale?locale="+nextLocale,{unstable_dontInferResponse:true}).then(function(res){return res.status==="OK"?nextLocale:prevLocale;}).catch(function(){return prevLocale;}).then(function(locale){var momentLocale={en:"en",jp:"jv",ph:"tl-ph",ru:"ru",th:"th",hi:"hi",vn:"vi",ar:"ar"};__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale(momentLocale[locale]||"en");_this.setState({changeLocaleFetching:false});_this.props.dispatch({type:"UPDATE_LOCALE",payload:locale});}).then(function(){return _this.props.fetch("/api/profile");}).then(function(profile){_this.props.dispatch({type:"RECEIVE_PROFILE",payload:profile});});}else{_this.props.dispatch({type:"UPDATE_LOCALE",payload:nextLocale});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Lang,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent,Object.assign({},this.props,{showLoader:this.state.changeLocaleFetching,onLocaleChange:this.handleLocaleChange}));}}]);return Lang;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_4__common_fetch__["e" /* mapDispatchToFetch */])(Lang);}function mapStateToProps(state){return{locale:Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["d" /* inferLocale */])(state),locales:state.apiConfigs&&state.apiConfigs.locales,profile:state.profile};}/* harmony default export */ __webpack_exports__["a"] = (withLanguage);

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getRefillCosts;
/* unused harmony export calcBalancePercentage */
/* harmony export (immutable) */ __webpack_exports__["a"] = disableRefill;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idx__);
function getRefillCosts(_ref){var account=_ref.account,_ref$refill_costs=_ref.refill_costs,refill_costs=_ref$refill_costs===undefined?[]:_ref$refill_costs;var count=0;var length=refill_costs.length;// TODO: what should we do here? Return null? 0? Check length earlier?
if(!length)return{cost_usd:null,cost:null};var refill_count=__WEBPACK_IMPORTED_MODULE_0_idx___default()(account,function(acc){return acc.refill_count;});if(refill_count!=null){count=refill_count;if(count>=length){count=length-1;}}var _refill_costs$count=refill_costs[count],cost_usd=_refill_costs$count.cost_usd,cost=_refill_costs$count.cost;return{cost_usd:cost_usd,cost:cost};}function calcBalancePercentage(props){var refill=props.refill,account_money=props.account_money;if(refill===false){return 0;}return parseFloat(account_money)*parseFloat(refill)/100;}function disableRefill(_ref2){var _ref2$tournament=_ref2.tournament,tournament=_ref2$tournament===undefined?null:_ref2$tournament,api=_ref2.api;// true - рефилл невозможен,
// false - рефилл возможен
var active_tournament=__WEBPACK_IMPORTED_MODULE_0_idx___default()(api.readEntity("/api/tournaments/stats"),function(stats){return stats.value.active_tournament;});if(active_tournament==null){return true;}if(tournament==null){tournament=active_tournament;}else if(tournament.id!==active_tournament.id){return true;}var _tournament=tournament,account=_tournament.account;if(tournament.refill!==false&&account!=null){if(tournament.refill_limit!==false&&account.refill_count>=tournament.refill_limit){return true;}var openOperationsSum=0;var opsData=api.readEntity("/api/tournaments/operations?account_id="+account.id);if(opsData.status==="Pending"){return true;}var ops=__WEBPACK_IMPORTED_MODULE_0_idx___default()(opsData,function(data){return data.value.open;});if(ops==null){return true;}openOperationsSum=ops.reduce(function(acc,op){return acc+op.amount;},0);var _refill=calcBalancePercentage(tournament);var _getRefillCosts=getRefillCosts(tournament),cost_usd=_getRefillCosts.cost_usd,cost=_getRefillCosts.cost;if(parseFloat(account.balance)+openOperationsSum<=_refill&&cost_usd!==null&&cost!==null){return false;}}return true;}

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

var _Motion = __webpack_require__(1758);

exports.Motion = _interopRequire(_Motion);

var _StaggeredMotion = __webpack_require__(1759);

exports.StaggeredMotion = _interopRequire(_StaggeredMotion);

var _TransitionMotion = __webpack_require__(1760);

exports.TransitionMotion = _interopRequire(_TransitionMotion);

var _spring = __webpack_require__(1762);

exports.spring = _interopRequire(_spring);

var _presets = __webpack_require__(694);

exports.presets = _interopRequire(_presets);

var _stripStyle = __webpack_require__(278);

exports.stripStyle = _interopRequire(_stripStyle);

// deprecated, dummy warning function

var _reorderKeys = __webpack_require__(1763);

exports.reorderKeys = _interopRequire(_reorderKeys);

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
var document = __webpack_require__(17).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var core = __webpack_require__(72);
var LIBRARY = __webpack_require__(113);
var wksExt = __webpack_require__(495);
var defineProperty = __webpack_require__(34).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(231)('keys');
var uid = __webpack_require__(125);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 327 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(17).document;
module.exports = document && document.documentElement;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(21);
var anObject = __webpack_require__(15);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(73)(Function.call, __webpack_require__(68).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
var setPrototypeOf = __webpack_require__(329).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(85);
var defined = __webpack_require__(84);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 334 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(85);
var defined = __webpack_require__(84);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(60);
var hide = __webpack_require__(59);
var Iterators = __webpack_require__(155);
var $iterCreate = __webpack_require__(337);
var setToStringTag = __webpack_require__(153);
var getPrototypeOf = __webpack_require__(69);
var ITERATOR = __webpack_require__(28)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(128);
var descriptor = __webpack_require__(124);
var setToStringTag = __webpack_require__(153);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(59)(IteratorPrototype, __webpack_require__(28)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(235);
var defined = __webpack_require__(84);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(28)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(155);
var ITERATOR = __webpack_require__(28)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(34);
var createDesc = __webpack_require__(124);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(184);
var ITERATOR = __webpack_require__(28)('iterator');
var Iterators = __webpack_require__(155);
module.exports = __webpack_require__(72).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(979);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(35);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(114);
var step = __webpack_require__(511);
var Iterators = __webpack_require__(155);
var toIObject = __webpack_require__(67);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(336)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(73);
var invoke = __webpack_require__(501);
var html = __webpack_require__(328);
var cel = __webpack_require__(324);
var global = __webpack_require__(17);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(74)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var macrotask = __webpack_require__(346).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(74)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(47);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var DESCRIPTORS = __webpack_require__(33);
var LIBRARY = __webpack_require__(113);
var $typed = __webpack_require__(242);
var hide = __webpack_require__(59);
var redefineAll = __webpack_require__(133);
var fails = __webpack_require__(20);
var anInstance = __webpack_require__(131);
var toInteger = __webpack_require__(85);
var toLength = __webpack_require__(35);
var toIndex = __webpack_require__(520);
var gOPN = __webpack_require__(129).f;
var dP = __webpack_require__(34).f;
var arrayFill = __webpack_require__(344);
var setToStringTag = __webpack_require__(153);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(1121);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 355 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(1132),
    mapCacheDelete = __webpack_require__(1150),
    mapCacheGet = __webpack_require__(1152),
    mapCacheHas = __webpack_require__(1153),
    mapCacheSet = __webpack_require__(1154);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(135),
    isObject = __webpack_require__(76);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(54),
    isSymbol = __webpack_require__(187);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(1180),
    overRest = __webpack_require__(819),
    setToString = __webpack_require__(475);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 364 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 365 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(367),
    arrayEach = __webpack_require__(368),
    assignValue = __webpack_require__(251),
    baseAssign = __webpack_require__(560),
    baseAssignIn = __webpack_require__(1194),
    cloneBuffer = __webpack_require__(1197),
    copyArray = __webpack_require__(253),
    copySymbols = __webpack_require__(1198),
    copySymbolsIn = __webpack_require__(1199),
    getAllKeys = __webpack_require__(567),
    getAllKeysIn = __webpack_require__(569),
    getTag = __webpack_require__(176),
    initCloneArray = __webpack_require__(1202),
    initCloneByTag = __webpack_require__(1203),
    initCloneObject = __webpack_require__(1208),
    isArray = __webpack_require__(54),
    isBuffer = __webpack_require__(316),
    isMap = __webpack_require__(1209),
    isObject = __webpack_require__(76),
    isSet = __webpack_require__(1211),
    keys = __webpack_require__(173);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });

    return result;
  }

  if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });

    return result;
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(247),
    stackClear = __webpack_require__(1185),
    stackDelete = __webpack_require__(1186),
    stackGet = __webpack_require__(1187),
    stackHas = __webpack_require__(1188),
    stackSet = __webpack_require__(1189);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(544);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(564),
    stubArray = __webpack_require__(565);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(562);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(571);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return richblue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return light; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logo_svg__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_small_png__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_logo_svg__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__index_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__index_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_logo_text_svg__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_logo_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_logo_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_jpg__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__header_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_siam_png__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_siam_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_siam_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_howto_bg_jpg__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_howto_bg_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_howto_bg_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_desktop_tour_bg_th_jpg__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_desktop_tour_bg_th_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_desktop_tour_bg_th_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_polished__ = __webpack_require__(22);
// import errorBg from "./error-bg.png";
var basic={direction:"ltr",// основной шрифт
fontFamily:"Roboto, Arial, sans-serif",// логотип
logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* default */],null),logoImg:__WEBPACK_IMPORTED_MODULE_2__logo_svg___default.a,logoImgMobile:__WEBPACK_IMPORTED_MODULE_3__logo_small_png___default.a,// errorBg: errorBg,
// ЦВЕТА
// основной
main:"#362f42",mainDark:"#332b3b",// шапка
mainLight:"#463e54",// сайдбар
mainHighlight:"#3c3446",mainFontColor:"#38465d",mainSeparator:"#403949",mode:"dark",foreground:"#fff",alternativeForeground:"#ffffff",lightWhiteForeground:"#ffffff",background:"#000",mainColorBackground:"#362f42",secondaryColorBackground:"#362f42",ticksFontColor:"#7c7686",borderMainColor:"#6b6575",ticksBorderColor:"#6e6976",accent:"#feac00",alternativeAccent:"#feac00",lightWhiteAccent:"#feac00",accentOpacity:"rgba(254, 172, 0, .5)",secondaryTextColor:"#99959d",upper:"#60a31c",// positive ставки
alternativeUpper:"#60a31c",upperAccent:"#72c121",upperBorder:"#4f8618",upperBoxShadow:"#62bb03",lower:"#e74c3c",// negative ставки
lowerAccent:"#da5c5c",lowerBorder:"#af3333",lowerBoxShadow:"#d45757",// анимации для попапов
perspective:"1300px",showAnimation:".15s linear 1",// переменные для вёб морды
indexMajor:"#4e2a81",indexMinor:"#30174e",indexLogo:__WEBPACK_IMPORTED_MODULE_4__index_logo_svg___default.a,indexLogoText:__WEBPACK_IMPORTED_MODULE_5__index_logo_text_svg___default.a,headerLogoText:__WEBPACK_IMPORTED_MODULE_5__index_logo_text_svg___default.a,indexHeaderBackground:__WEBPACK_IMPORTED_MODULE_6__header_jpg___default.a,howToBg:__WEBPACK_IMPORTED_MODULE_8__images_howto_bg_jpg___default.a,// переменные хелпдеска
helpdeskSeparator:"#514268",helpdeskMobileMenuSeparator:"#452e61",helpdeskNavlinks:"#9b8baf",// переменные для страницы /regbonus
refHeader:"#30174e",refLogo:__WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_siam_png___default.a,refLogoText:null,refFooterBorder:"#7b61a2",refFooterColor:"#d7cde5",refConditionBg:"#4c297e",refInvestmentBg:"#3e2166",//попап досрочной продажи
sellDealBg:"#55476d",sellDealBorder:"#41335d",sellDealProfitColor:"#ffffff",sellDealButtonColor:"#ffcc00",sellDealHistoryBg:"#3d4149",sellDealHistoryColor:"#ffcc00",sellDealHistoryProgress:"#5d6067",// переменные статичных страниц
staticHeaderLink:"#9b8baf",toggleAccountLightBg:"#3c3446",toggleAccountDarkBg:"#332b3b",popupBackground:"#332b3b",popupDarkBackground:"#3c3446",desktopTourBg:__WEBPACK_IMPORTED_MODULE_9__images_desktop_tour_bg_th_jpg___default.a,minFontSize:"16px",textMuted:"#99959d",mainLink:"#0085eb",tradeHeaderAccent:"#feac00",dealsBackground:"#332b3b",dealIconColor:"#ffffff",barCaption:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])("#feac00",0.28),cursorBarCaption:"#5D6067",bottomNavigationBg:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])("#ffffff",0.4),stockInfoBg:"#3c3446",tournamentPopupBgLight:"#3c3446",tournamentPopupBgDark:"#332b3b",tournamentCardBg:"#332b3b",tournamentCardMainColor:"#ffffff",tournamentCardSecondaryColor:"#feac00",tournamentCardPlaceholder:"#feac00",scrollColor:"rgba(255, 255, 255, 0.5)",currencyColor:"#feac00",navigationBg:"#332B3B",navigationItemColor:"#9b8baf",navigationItemIcon:"#9b8baf",navigationItemActiveBg:"#3c3446",navigationItemIconActive:"#ffffff",operationChequeqColor:"#99959d",operationChequeColor:"#d2d2d2",bellNewsLinkColor:"#4e2a81",inputColor:"#4e2a81",oneSignalHeaderBg:"#4e2a81",languageBackground:"#3c3446",languageColor:"#ffffff",languageArrowColor:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])("#fff",0.7),sightseeingBigBg:"rgba(255, 255, 255, 0.1)",sightseeingSmallBg:"rgba(255, 255, 255, 0.05)",sightSeeingImageShadow:"rgba(255, 255, 255, 0.2)",sightseeingBg:"linear-gradient(to bottom, #32273e 0%, #453950 100%)",sightSeeingBgShadow:"transparent",sightSeeingStartButtonBg:"#feac00",sightSeeingStartButtonColor:"#000",sightseeingLater:"rgba(255, 255, 255, 0.5)",dotColor:"rgba(255, 255, 255, 0.5)",dotActiveColor:"#fff",suggestingInputBg:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])("#ffffff",0.1),suggestingInputBgDisabled:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])("#ffffff",0.25),suggestingInputButtonSymbol:"#ffffff",suggestingInputButtonSymbolDisabled:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])("#919191",0.59),mobileSwitchStockBackground:"#919191",mobileSwitchStockArrow:"#ffffff",socialTradingButtonBg:"#5E5968",socialTradingButtonBgHover:"#5E5968",socialTradingButtonBgActive:"#86828E",socialTradingHiddenLink:"#99959D",socialTradingHiddenLinkHover:"#FEAC00",socialTradingBg:"#463E54",socialTradingTableHeaderBg:"#3B3446",socialTradingSubtitleColor:"#99959D",tabsTournamentsCategoryTitle:"#ffffff",freeBonusPopupFontColor:"#ffffff",tourWitdrawMethodHover:"#feac00",authCurrencyCodeColor:"#1B546A"};/* harmony default export */ __webpack_exports__["a"] = (basic);// дополнительные темы забирают
// недостающие настройки и цвета
// из базовых
var richblue=Object.assign({},basic,{mode:"dark",foreground:"#fff",background:"#000",// основной цвет
main:"#061424",mainDark:"#0A131E",// шапка
mainLight:"#121B27",// сайдбар
mainHighlight:"#162130",mainFontColor:"#38465d",mainSeparator:"#2D3244",secondaryTextColor:"#99959d",borderMainColor:"#2D3244",ticksBorderColor:"#2D3244",popupBackground:"#0A131E",popupDarkBackground:"#0A131E"});var light=Object.assign({},basic,{// основной цвет
main:"#443B54",mainDark:"#3F374F",// шапка
mainLight:"#4E4360",// сайдбар
mainHighlight:"#51446B",mainFontColor:"#38465d",mainSeparator:"#5D4E7A",secondaryTextColor:"#99959d",borderMainColor:"#5D4E7A",ticksBorderColor:"#6e6976",popupBackground:"#3F374F",popupDarkBackground:"#3F374F"});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export log */
/* harmony export (immutable) */ __webpack_exports__["a"] = error;
var shared="font-size: 14px; line-height: 1.5; color: #fff;";var styles={error:shared+" background: maroon;",log:shared+" background: navy;"};function log(log){return console.log("%c "+log+" ",styles.log);}function error(error){return console.log("%c "+error+" ",styles.error);}

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = logCrash;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dataLayer__ = __webpack_require__(82);
function getCookie(name){var matches=document.cookie.match(new RegExp("(?:^|; )"+name.replace(/([.$?*|{}()[\]\\/+^])/g,'\\$1')+"=([^;]*)"));return matches?decodeURIComponent(matches[1]):undefined;}function logCrash(fetch){return function(json){var log=Object.assign({},json);var userId=getCookie("user_id");log.user_id=userId&&parseInt(userId,10);log.user_key=getCookie("user_key");if(log.error&&log.error.info){log.error.info.user_agent=window.navigator.userAgent;}else{log.error={info:{user_agent:window.navigator.userAgent}};}if(false){console.warn(log);return null;}Object(__WEBPACK_IMPORTED_MODULE_2__dataLayer__["a" /* default */])({event:"exception-to-ga",exDescription:JSON.stringify(log),exFatal:true});return fetch("crashlog://log",{method:"POST",headers:{"Accept":"application/json","Content-Type":"application/json"},body:JSON.stringify(log)});};};function withCrashLog(Component){function CrashLog(props){var crashLog=logCrash(props.fetch);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},props,{crashLog:crashLog}));}return Object(__WEBPACK_IMPORTED_MODULE_1__fetch__["h" /* withFetch */])(CrashLog);};/* harmony default export */ __webpack_exports__["a"] = (withCrashLog);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Auth__ = __webpack_require__(96);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  line-height: 18px;\n  color: ",";\n\n  ",";\n"],["\n  direction: ",";\n  font-size: ",";\n  line-height: 18px;\n  color: ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      padding: 7px;\n      border-radius: 30px;\n      background-color: #ffffff;\n      text-align: center;\n    "],["\n      padding: 7px;\n      border-radius: 30px;\n      background-color: #ffffff;\n      text-align: center;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  padding: 0;\n  border: 0;\n  color: inherit;\n  font-size: inherit;\n  background: none;\n  font-weight: bold;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"],["\n  padding: 0;\n  border: 0;\n  color: inherit;\n  font-size: inherit;\n  background: none;\n  font-weight: bold;\n  text-decoration: underline;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: none;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;}, true?Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14):fontSize(12),function(props){return props.error? true?"red":"tomato": true?"green":"rgb(96, 163, 28)";},"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2));var ToggleTabButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject3);function Message(props){if(props.error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{style:props.style,error:true},props.error);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{style:props.style},props.notification,props.notificationType==="restorePasswordWithEmail"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleTabButton,{onClick:function onClick(){return props.toggleTab(__WEBPACK_IMPORTED_MODULE_4__Auth__["b" /* PASSWORD_RESTORE_TAB_ID */],"phone");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Don't have an access to your email?")));}/* harmony default export */ __webpack_exports__["a"] = (Message);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPossibleNumber;
/* harmony export (immutable) */ __webpack_exports__["b"] = is_possible_number;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNumberType__ = __webpack_require__(115);


/**
 * Checks if a given phone number is possible.
 * Which means it only checks phone number length
 * and doesn't test any regular expressions.
 *
 * Examples:
 *
 * ```js
 * isPossibleNumber('+78005553535', metadata)
 * isPossibleNumber('8005553535', 'RU', metadata)
 * isPossibleNumber('88005553535', 'RU', metadata)
 * isPossibleNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */
function isPossibleNumber(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = Object(__WEBPACK_IMPORTED_MODULE_0__getNumberType__["c" /* sort_out_arguments */])(arg_1, arg_2, arg_3, arg_4),
	    input = _sort_out_arguments.input,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	if (options.v2) {
		if (!input.countryCallingCode) {
			throw new Error('Invalid phone number object passed');
		}
		metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
	} else {
		if (!input.phone) {
			return false;
		}
		if (input.country) {
			if (!metadata.hasCountry(input.country)) {
				throw new Error('Unknown country: ' + input.country);
			}
			metadata.country(input.country);
		} else {
			if (!input.countryCallingCode) {
				throw new Error('Invalid phone number object passed');
			}
			metadata.chooseCountryByCountryCallingCode(input.countryCallingCode);
		}
	}

	if (!metadata.possibleLengths()) {
		throw new Error('Metadata too old');
	}

	return is_possible_number(input.phone || input.nationalNumber, undefined, metadata);
}

function is_possible_number(national_number, is_international, metadata) {
	switch (Object(__WEBPACK_IMPORTED_MODULE_0__getNumberType__["a" /* check_number_length_for_type */])(national_number, undefined, metadata)) {
		case 'IS_POSSIBLE':
			return true;
		// case 'IS_POSSIBLE_LOCAL_ONLY':
		// 	return !is_international
		default:
			return false;
	}
}
//# sourceMappingURL=isPossibleNumber.js.map

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(78);


/* harmony default export */ __webpack_exports__["a"] = (function (country, metadata) {
	metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);

	if (!metadata.hasCountry(country)) {
		throw new Error('Unknown country: ' + country);
	}

	return metadata.country(country).countryCallingCode();
});
//# sourceMappingURL=getCountryCallingCode.js.map

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRFC3966;
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRFC3966;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse__ = __webpack_require__(88);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();



// https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */
function parseRFC3966(text) {
	var number = void 0;
	var ext = void 0;

	// Replace "tel:" with "tel=" for parsing convenience.
	text = text.replace(/^tel:/, 'tel=');

	for (var _iterator = text.split(';'), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var part = _ref;

		var _part$split = part.split('='),
		    _part$split2 = _slicedToArray(_part$split, 2),
		    name = _part$split2[0],
		    value = _part$split2[1];

		switch (name) {
			case 'tel':
				number = value;
				break;
			case 'ext':
				ext = value;
				break;
			case 'phone-context':
				// Only "country contexts" are supported.
				// "Domain contexts" are ignored.
				if (value[0] === '+') {
					number = value + number;
				}
				break;
		}
	}

	// If the phone number is not viable, then abort.
	if (!Object(__WEBPACK_IMPORTED_MODULE_0__parse__["d" /* is_viable_phone_number */])(number)) {
		return {};
	}

	var result = { number: number };
	if (ext) {
		result.ext = ext;
	}
	return result;
}

/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */
function formatRFC3966(_ref2) {
	var number = _ref2.number,
	    ext = _ref2.ext;

	if (!number) {
		return '';
	}

	if (number[0] !== '+') {
		throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
	}

	return 'tel:' + number + (ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__findNumbers_util__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__findNumbers_Leniency__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__findNumbers_parsePreCandidate__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__findNumbers_isValidPreCandidate__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__findNumbers_isValidCandidate__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__format__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validate__ = __webpack_require__(159);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * A port of Google's `PhoneNumberMatcher.java`.
 * https://github.com/googlei18n/libphonenumber/blob/master/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberMatcher.java
 * Date: 08.03.2018.
 */


















/**
 * Patterns used to extract phone numbers from a larger phone-number-like pattern. These are
 * ordered according to specificity. For example, white-space is last since that is frequently
 * used in numbers, not just to separate two numbers. We have separate patterns since we don't
 * want to break up the phone-number-like text on more than one different kind of symbol at one
 * time, although symbols of the same type (e.g. space) can be safely grouped together.
 *
 * Note that if there is a match, we will always check any text found up to the first match as
 * well.
 */
var INNER_MATCHES = [
// Breaks on the slash - e.g. "651-234-2345/332-445-1234"
'\\/+(.*)/',

// Note that the bracket here is inside the capturing group, since we consider it part of the
// phone number. Will match a pattern like "(650) 223 3345 (754) 223 3321".
'(\\([^(]*)',

// Breaks on a hyphen - e.g. "12345 - 332-445-1234 is my number."
// We require a space on either side of the hyphen for it to be considered a separator.
'(?:' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["g" /* pZ */] + '-|-' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["g" /* pZ */] + ')' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["g" /* pZ */] + '*(.+)',

// Various types of wide hyphens. Note we have decided not to enforce a space here, since it's
// possible that it's supposed to be used to break two numbers without spaces, and we haven't
// seen many instances of it used within a number.
'[\u2012-\u2015\uFF0D]' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["g" /* pZ */] + '*(.+)',

// Breaks on a full stop - e.g. "12345. 332-445-1234 is my number."
'\\.+' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["g" /* pZ */] + '*([^.]+)',

// Breaks on space - e.g. "3324451234 8002341234"
__WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["g" /* pZ */] + '+(' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["a" /* PZ */] + '+)'];

// Limit on the number of leading (plus) characters.
var leadLimit = Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_util__["b" /* limit */])(0, 2);

// Limit on the number of consecutive punctuation characters.
var punctuationLimit = Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_util__["b" /* limit */])(0, 4);

/* The maximum number of digits allowed in a digit-separated block. As we allow all digits in a
 * single block, set high enough to accommodate the entire national number and the international
 * country code. */
var digitBlockLimit = __WEBPACK_IMPORTED_MODULE_1__common__["b" /* MAX_LENGTH_FOR_NSN */] + __WEBPACK_IMPORTED_MODULE_1__common__["a" /* MAX_LENGTH_COUNTRY_CODE */];

// Limit on the number of blocks separated by punctuation.
// Uses digitBlockLimit since some formats use spaces to separate each digit.
var blockLimit = Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_util__["b" /* limit */])(0, digitBlockLimit);

/* A punctuation sequence allowing white space. */
var punctuation = '[' + __WEBPACK_IMPORTED_MODULE_1__common__["e" /* VALID_PUNCTUATION */] + ']' + punctuationLimit;

// A digits block without punctuation.
var digitSequence = __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["f" /* pNd */] + Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_util__["b" /* limit */])(1, digitBlockLimit);

/**
 * Phone number pattern allowing optional punctuation.
 * The phone number pattern used by `find()`, similar to
 * VALID_PHONE_NUMBER, but with the following differences:
 * <ul>
 *   <li>All captures are limited in order to place an upper bound to the text matched by the
 *       pattern.
 * <ul>
 *   <li>Leading punctuation / plus signs are limited.
 *   <li>Consecutive occurrences of punctuation are limited.
 *   <li>Number of digits is limited.
 * </ul>
 *   <li>No whitespace is allowed at the start or end.
 *   <li>No alpha digits (vanity numbers such as 1-800-SIX-FLAGS) are currently supported.
 * </ul>
 */
var PATTERN = '(?:' + __WEBPACK_IMPORTED_MODULE_7__findNumbers_isValidCandidate__["a" /* LEAD_CLASS */] + punctuation + ')' + leadLimit + digitSequence + '(?:' + punctuation + digitSequence + ')' + blockLimit + '(?:' + Object(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* create_extension_pattern */])('matching') + ')?';

// Regular expression of trailing characters that we want to remove.
// We remove all characters that are not alpha or numerical characters.
// The hash character is retained here, as it may signify
// the previous block was an extension.
//
// // Don't know what does '&&' mean here.
// const UNWANTED_END_CHAR_PATTERN = new RegExp(`[[\\P{N}&&\\P{L}]&&[^#]]+$`)
//
var UNWANTED_END_CHAR_PATTERN = new RegExp('[^' + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["c" /* _pN */] + __WEBPACK_IMPORTED_MODULE_3__findNumbers_utf_8__["b" /* _pL */] + '#]+$');

var NON_DIGITS_PATTERN = /(\D+)/;

var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;

/**
 * A stateful class that finds and extracts telephone numbers from {@linkplain CharSequence text}.
 * Instances can be created using the {@linkplain PhoneNumberUtil#findNumbers factory methods} in
 * {@link PhoneNumberUtil}.
 *
 * <p>Vanity numbers (phone numbers using alphabetic digits such as <tt>1-800-SIX-FLAGS</tt> are
 * not found.
 *
 * <p>This class is not thread-safe.
 */

var PhoneNumberMatcher = function () {

  /**
   * Creates a new instance. See the factory methods in {@link PhoneNumberUtil} on how to obtain a
   * new instance.
   *
   * @param util  the phone number util to use
   * @param text  the character sequence that we will search, null for no text
   * @param country  the country to assume for phone numbers not written in international format
   *     (with a leading plus, or with the international dialing prefix of the specified region).
   *     May be null or "ZZ" if only numbers with a leading plus should be
   *     considered.
   * @param leniency  the leniency to use when evaluating candidate phone numbers
   * @param maxTries  the maximum number of invalid numbers to try before giving up on the text.
   *     This is to cover degenerate cases where the text has a lot of false positives in it. Must
   *     be {@code >= 0}.
   */

  /** The iteration tristate. */
  function PhoneNumberMatcher() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var metadata = arguments[2];

    _classCallCheck(this, PhoneNumberMatcher);

    this.state = 'NOT_READY';
    this.searchIndex = 0;

    options = _extends({}, options, {
      leniency: options.leniency || options.extended ? 'POSSIBLE' : 'VALID',
      maxTries: options.maxTries || MAX_SAFE_INTEGER
    });

    if (!options.leniency) {
      throw new TypeError('`Leniency` not supplied');
    }

    if (options.maxTries < 0) {
      throw new TypeError('`maxTries` not supplied');
    }

    this.text = text;
    this.options = options;
    this.metadata = metadata;

    /** The degree of validation requested. */
    this.leniency = __WEBPACK_IMPORTED_MODULE_4__findNumbers_Leniency__["a" /* default */][options.leniency];

    if (!this.leniency) {
      throw new TypeError('Unknown leniency: ' + options.leniency + '.');
    }

    /** The maximum number of retries after matching an invalid number. */
    this.maxTries = options.maxTries;

    this.PATTERN = new RegExp(PATTERN, 'ig');
  }

  /**
   * Attempts to find the next subsequence in the searched sequence on or after {@code searchIndex}
   * that represents a phone number. Returns the next match, null if none was found.
   *
   * @param index  the search index to start searching at
   * @return  the phone number match found, null if none can be found
   */


  /** The next index to start searching at. Undefined in {@link State#DONE}. */


  _createClass(PhoneNumberMatcher, [{
    key: 'find',
    value: function find() // (index)
    {
      // // Reset the regular expression.
      // this.PATTERN.lastIndex = index

      var matches = void 0;
      while (this.maxTries > 0 && (matches = this.PATTERN.exec(this.text)) !== null) {
        var candidate = matches[0];
        var offset = matches.index;

        candidate = Object(__WEBPACK_IMPORTED_MODULE_5__findNumbers_parsePreCandidate__["a" /* default */])(candidate);

        if (Object(__WEBPACK_IMPORTED_MODULE_6__findNumbers_isValidPreCandidate__["a" /* default */])(candidate, offset, this.text)) {
          var match =
          // Try to come up with a valid match given the entire candidate.
          this.parseAndVerify(candidate, offset, this.text)
          // If that failed, try to find an "inner match" -
          // there might be a phone number within this candidate.
          || this.extractInnerMatch(candidate, offset, this.text);

          if (match) {
            if (this.options.v2) {
              var phoneNumber = new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a" /* default */](match.country, match.phone, this.metadata.metadata);
              if (match.ext) {
                phoneNumber.ext = match.ext;
              }
              return {
                startsAt: match.startsAt,
                endsAt: match.endsAt,
                number: phoneNumber
              };
            }
            return match;
          }
        }

        this.maxTries--;
      }
    }

    /**
     * Attempts to extract a match from `candidate`
     * if the whole candidate does not qualify as a match.
     */

  }, {
    key: 'extractInnerMatch',
    value: function extractInnerMatch(candidate, offset, text) {
      for (var _iterator = INNER_MATCHES, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var innerMatchPattern = _ref;

        var isFirstMatch = true;
        var matches = void 0;
        var possibleInnerMatch = new RegExp(innerMatchPattern, 'g');
        while ((matches = possibleInnerMatch.exec(candidate)) !== null && this.maxTries > 0) {
          if (isFirstMatch) {
            // We should handle any group before this one too.
            var _group = Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_util__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, candidate.slice(0, matches.index));

            var _match = this.parseAndVerify(_group, offset, text);
            if (_match) {
              return _match;
            }

            this.maxTries--;
            isFirstMatch = false;
          }

          var group = Object(__WEBPACK_IMPORTED_MODULE_2__findNumbers_util__["d" /* trimAfterFirstMatch */])(UNWANTED_END_CHAR_PATTERN, matches[1]);

          // Java code does `groupMatcher.start(1)` here,
          // but there's no way in javascript to get a group match start index,
          // therefore using the overall match start index `matches.index`.
          var match = this.parseAndVerify(group, offset + matches.index, text);
          if (match) {
            return match;
          }

          this.maxTries--;
        }
      }
    }

    /**
     * Parses a phone number from the `candidate` using `parseNumber` and
     * verifies it matches the requested `leniency`. If parsing and verification succeed,
     * a corresponding `PhoneNumberMatch` is returned, otherwise this method returns `null`.
     *
     * @param candidate  the candidate match
     * @param offset  the offset of {@code candidate} within {@link #text}
     * @return  the parsed and validated phone number match, or null
     */

  }, {
    key: 'parseAndVerify',
    value: function parseAndVerify(candidate, offset, text) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_7__findNumbers_isValidCandidate__["b" /* default */])(candidate, offset, text, this.options.leniency)) {
        return;
      }

      var number = Object(__WEBPACK_IMPORTED_MODULE_9__parse__["a" /* default */])(candidate, {
        extended: true,
        defaultCountry: this.options.defaultCountry
      }, this.metadata.metadata);

      if (!number.possible) {
        return;
      }

      if (this.leniency(number, candidate, this.metadata.metadata)) {
        // // We used parseAndKeepRawInput to create this number,
        // // but for now we don't return the extra values parsed.
        // // TODO: stop clearing all values here and switch all users over
        // // to using rawInput() rather than the rawString() of PhoneNumberMatch.
        // number.clearCountryCodeSource()
        // number.clearRawInput()
        // number.clearPreferredDomesticCarrierCode()

        var result = {
          startsAt: offset,
          endsAt: offset + candidate.length,
          country: number.country,
          phone: number.phone
        };

        if (number.ext) {
          result.ext = number.ext;
        }

        return result;
      }
    }
  }, {
    key: 'hasNext',
    value: function hasNext() {
      if (this.state === 'NOT_READY') {
        this.lastMatch = this.find(); // (this.searchIndex)

        if (this.lastMatch) {
          // this.searchIndex = this.lastMatch.endsAt
          this.state = 'READY';
        } else {
          this.state = 'DONE';
        }
      }

      return this.state === 'READY';
    }
  }, {
    key: 'next',
    value: function next() {
      // Check the state and find the next match as a side-effect if necessary.
      if (!this.hasNext()) {
        throw new Error('No next element');
      }

      // Don't retain that memory any longer than necessary.
      var result = this.lastMatch;
      this.lastMatch = null;
      this.state = 'NOT_READY';
      return result;
    }
  }]);

  return PhoneNumberMatcher;
}();

/* harmony default export */ __webpack_exports__["a"] = (PhoneNumberMatcher);
//# sourceMappingURL=PhoneNumberMatcher.js.map

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DIGIT_PLACEHOLDER */
/* unused harmony export strip_dangling_braces */
/* unused harmony export cut_stripping_dangling_braces */
/* unused harmony export close_dangling_braces */
/* unused harmony export count_occurences */
/* unused harmony export repeat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__format__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getNumberType__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parseIncompletePhoneNumber__ = __webpack_require__(256);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// This is an enhanced port of Google Android `libphonenumber`'s
// `asyoutypeformatter.js` of 17th November, 2016.
//
// https://github.com/googlei18n/libphonenumber/blob/8d21a365061de2ba0675c878a710a7b24f74d2ae/javascript/i18n/phonenumbers/asyoutypeformatter.js















// Used in phone number format template creation.
// Could be any digit, I guess.
var DUMMY_DIGIT = '9';
// I don't know why is it exactly `15`
var LONGEST_NATIONAL_PHONE_NUMBER_LENGTH = 15;
// Create a phone number consisting only of the digit 9 that matches the
// `number_pattern` by applying the pattern to the "longest phone number" string.
var LONGEST_DUMMY_PHONE_NUMBER = repeat(DUMMY_DIGIT, LONGEST_NATIONAL_PHONE_NUMBER_LENGTH);

// The digits that have not been entered yet will be represented by a \u2008,
// the punctuation space.
var DIGIT_PLACEHOLDER = 'x'; // '\u2008' (punctuation space)
var DIGIT_PLACEHOLDER_MATCHER = new RegExp(DIGIT_PLACEHOLDER);

// A pattern that is used to match character classes in regular expressions.
// An example of a character class is "[1-4]".
var CREATE_CHARACTER_CLASS_PATTERN = function CREATE_CHARACTER_CLASS_PATTERN() {
	return (/\[([^\[\]])*\]/g
	);
};

// Any digit in a regular expression that actually denotes a digit. For
// example, in the regular expression "80[0-2]\d{6,10}", the first 2 digits
// (8 and 0) are standalone digits, but the rest are not.
// Two look-aheads are needed because the number following \\d could be a
// two-digit number, since the phone number can be as long as 15 digits.
var CREATE_STANDALONE_DIGIT_PATTERN = function CREATE_STANDALONE_DIGIT_PATTERN() {
	return (/\d(?=[^,}][^,}])/g
	);
};

// A pattern that is used to determine if a `format` is eligible
// to be used by the "as you type formatter".
// It is eligible when the `format` contains groups of the dollar sign
// followed by a single digit, separated by valid phone number punctuation.
// This prevents invalid punctuation (such as the star sign in Israeli star numbers)
// getting into the output of the "as you type formatter".
var ELIGIBLE_FORMAT_PATTERN = new RegExp('^' + '[' + __WEBPACK_IMPORTED_MODULE_2__common__["e" /* VALID_PUNCTUATION */] + ']*' + '(\\$\\d[' + __WEBPACK_IMPORTED_MODULE_2__common__["e" /* VALID_PUNCTUATION */] + ']*)+' + '$');

// This is the minimum length of the leading digits of a phone number
// to guarantee the first "leading digits pattern" for a phone number format
// to be preemptive.
var MIN_LEADING_DIGITS_LENGTH = 3;

var VALID_INCOMPLETE_PHONE_NUMBER = '[' + __WEBPACK_IMPORTED_MODULE_2__common__["c" /* PLUS_CHARS */] + ']{0,1}' + '[' + __WEBPACK_IMPORTED_MODULE_2__common__["e" /* VALID_PUNCTUATION */] + __WEBPACK_IMPORTED_MODULE_2__common__["d" /* VALID_DIGITS */] + ']*';

var VALID_INCOMPLETE_PHONE_NUMBER_PATTERN = new RegExp('^' + VALID_INCOMPLETE_PHONE_NUMBER + '$', 'i');

var AsYouType = function () {

	/**
  * @param {string} [country_code] - The default country used for parsing non-international phone numbers.
  * @param {Object} metadata
  */
	function AsYouType(country_code, metadata) {
		_classCallCheck(this, AsYouType);

		this.options = {};

		this.metadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);

		if (country_code && this.metadata.hasCountry(country_code)) {
			this.default_country = country_code;
		}

		this.reset();
	}
	// Not setting `options` to a constructor argument
	// not to break backwards compatibility
	// for older versions of the library.


	_createClass(AsYouType, [{
		key: 'input',
		value: function input(text) {
			// Parse input

			var extracted_number = Object(__WEBPACK_IMPORTED_MODULE_3__parse__["b" /* extract_formatted_phone_number */])(text) || '';

			// Special case for a lone '+' sign
			// since it's not considered a possible phone number.
			if (!extracted_number) {
				if (text && text.indexOf('+') >= 0) {
					extracted_number = '+';
				}
			}

			// Validate possible first part of a phone number
			if (!VALID_INCOMPLETE_PHONE_NUMBER_PATTERN.test(extracted_number)) {
				return this.current_output;
			}

			return this.process_input(Object(__WEBPACK_IMPORTED_MODULE_6__parseIncompletePhoneNumber__["a" /* default */])(extracted_number));
		}
	}, {
		key: 'process_input',
		value: function process_input(input) {
			// If an out of position '+' sign detected
			// (or a second '+' sign),
			// then just drop it from the input.
			if (input[0] === '+') {
				if (!this.parsed_input) {
					this.parsed_input += '+';

					// If a default country was set
					// then reset it because an explicitly international
					// phone number is being entered
					this.reset_countriness();
				}

				input = input.slice(1);
			}

			// Raw phone number
			this.parsed_input += input;

			// // Reset phone number validation state
			// this.valid = false

			// Add digits to the national number
			this.national_number += input;

			// TODO: Deprecated: rename `this.national_number`
			// to `this.nationalNumber` and remove `.getNationalNumber()`.

			// Try to format the parsed input

			if (this.is_international()) {
				if (!this.countryCallingCode) {
					// No need to format anything
					// if there's no national phone number.
					// (e.g. just the country calling code)
					if (!this.national_number) {
						// Return raw phone number
						return this.parsed_input;
					}

					// If one looks at country phone codes
					// then he can notice that no one country phone code
					// is ever a (leftmost) substring of another country phone code.
					// So if a valid country code is extracted so far
					// then it means that this is the country code.

					// If no country phone code could be extracted so far,
					// then just return the raw phone number,
					// because it has no way of knowing
					// how to format the phone number so far.
					if (!this.extract_country_calling_code()) {
						// Return raw phone number
						return this.parsed_input;
					}

					// Initialize country-specific data
					this.initialize_phone_number_formats_for_this_country_calling_code();
					this.reset_format();
					this.determine_the_country();
				}
				// `this.country` could be `undefined`,
				// for instance, when there is ambiguity
				// in a form of several different countries
				// each corresponding to the same country phone code
				// (e.g. NANPA: USA, Canada, etc),
				// and there's not enough digits entered
				// to reliably determine the country
				// the phone number belongs to.
				// Therefore, in cases of such ambiguity,
				// each time something is input,
				// try to determine the country
				// (if it's not determined yet).
				else if (!this.country) {
						this.determine_the_country();
					}
			} else {
				// Some national prefixes are substrings of other national prefixes
				// (for the same country), therefore try to extract national prefix each time
				// because a longer national prefix might be available at some point in time.

				var previous_national_prefix = this.national_prefix;
				this.national_number = this.national_prefix + this.national_number;

				// Possibly extract a national prefix
				this.extract_national_prefix();

				if (this.national_prefix !== previous_national_prefix) {
					// National number has changed
					// (due to another national prefix been extracted)
					// therefore national number has changed
					// therefore reset all previous formatting data.
					// (and leading digits matching state)
					this.matching_formats = undefined;
					this.reset_format();
				}
			}

			// if (!this.should_format())
			// {
			// 	return this.format_as_non_formatted_number()
			// }

			if (!this.national_number) {
				return this.format_as_non_formatted_number();
			}

			// Check the available phone number formats
			// based on the currently available leading digits.
			this.match_formats_by_leading_digits();

			// Format the phone number (given the next digits)
			var formatted_national_phone_number = this.format_national_phone_number(input);

			// If the phone number could be formatted,
			// then return it, possibly prepending with country phone code
			// (for international phone numbers only)
			if (formatted_national_phone_number) {
				return this.full_phone_number(formatted_national_phone_number);
			}

			// If the phone number couldn't be formatted,
			// then just fall back to the raw phone number.
			return this.format_as_non_formatted_number();
		}
	}, {
		key: 'format_as_non_formatted_number',
		value: function format_as_non_formatted_number() {
			// Strip national prefix for incorrectly inputted international phones.
			if (this.is_international() && this.countryCallingCode) {
				return '+' + this.countryCallingCode + this.national_number;
			}

			return this.parsed_input;
		}
	}, {
		key: 'format_national_phone_number',
		value: function format_national_phone_number(next_digits) {
			// Format the next phone number digits
			// using the previously chosen phone number format.
			//
			// This is done here because if `attempt_to_format_complete_phone_number`
			// was placed before this call then the `template`
			// wouldn't reflect the situation correctly (and would therefore be inconsistent)
			//
			var national_number_formatted_with_previous_format = void 0;
			if (this.chosen_format) {
				national_number_formatted_with_previous_format = this.format_next_national_number_digits(next_digits);
			}

			// See if the input digits can be formatted properly already. If not,
			// use the results from format_next_national_number_digits(), which does formatting
			// based on the formatting pattern chosen.

			var formatted_number = this.attempt_to_format_complete_phone_number();

			// Just because a phone number doesn't have a suitable format
			// that doesn't mean that the phone is invalid
			// because phone number formats only format phone numbers,
			// they don't validate them and some (rare) phone numbers
			// are meant to stay non-formatted.
			if (formatted_number) {
				return formatted_number;
			}

			// For some phone number formats national prefix

			// If the previously chosen phone number format
			// didn't match the next (current) digit being input
			// (leading digits pattern didn't match).
			if (this.choose_another_format()) {
				// And a more appropriate phone number format
				// has been chosen for these `leading digits`,
				// then format the national phone number (so far)
				// using the newly selected phone number pattern.

				// Will return `undefined` if it couldn't format
				// the supplied national number
				// using the selected phone number pattern.

				return this.reformat_national_number();
			}

			// If could format the next (current) digit
			// using the previously chosen phone number format
			// then return the formatted number so far.

			// If no new phone number format could be chosen,
			// and couldn't format the supplied national number
			// using the selected phone number pattern,
			// then it will return `undefined`.

			return national_number_formatted_with_previous_format;
		}
	}, {
		key: 'reset',
		value: function reset() {
			// Input stripped of non-phone-number characters.
			// Can only contain a possible leading '+' sign and digits.
			this.parsed_input = '';

			this.current_output = '';

			// This contains the national prefix that has been extracted. It contains only
			// digits without formatting.
			this.national_prefix = '';

			this.national_number = '';
			this.carrierCode = '';

			this.reset_countriness();

			this.reset_format();

			// this.valid = false

			return this;
		}
	}, {
		key: 'reset_country',
		value: function reset_country() {
			if (this.is_international()) {
				this.country = undefined;
			} else {
				this.country = this.default_country;
			}
		}
	}, {
		key: 'reset_countriness',
		value: function reset_countriness() {
			this.reset_country();

			if (this.default_country && !this.is_international()) {
				this.metadata.country(this.default_country);
				this.countryCallingCode = this.metadata.countryCallingCode();

				this.initialize_phone_number_formats_for_this_country_calling_code();
			} else {
				this.metadata.country(undefined);
				this.countryCallingCode = undefined;

				this.available_formats = [];
				this.matching_formats = undefined;
			}
		}
	}, {
		key: 'reset_format',
		value: function reset_format() {
			this.chosen_format = undefined;
			this.template = undefined;
			this.partially_populated_template = undefined;
			this.last_match_position = -1;
		}

		// Format each digit of national phone number (so far)
		// using the newly selected phone number pattern.

	}, {
		key: 'reformat_national_number',
		value: function reformat_national_number() {
			// Format each digit of national phone number (so far)
			// using the selected phone number pattern.
			return this.format_next_national_number_digits(this.national_number);
		}
	}, {
		key: 'initialize_phone_number_formats_for_this_country_calling_code',
		value: function initialize_phone_number_formats_for_this_country_calling_code() {
			// Get all "eligible" phone number formats for this country
			this.available_formats = this.metadata.formats().filter(function (format) {
				return ELIGIBLE_FORMAT_PATTERN.test(format.internationalFormat());
			});

			this.matching_formats = undefined;
		}
	}, {
		key: 'match_formats_by_leading_digits',
		value: function match_formats_by_leading_digits() {
			var leading_digits = this.national_number;

			// "leading digits" pattern list starts with a
			// "leading digits" pattern fitting a maximum of 3 leading digits.
			// So, after a user inputs 3 digits of a national (significant) phone number
			// this national (significant) number can already be formatted.
			// The next "leading digits" pattern is for 4 leading digits max,
			// and the "leading digits" pattern after it is for 5 leading digits max, etc.

			// This implementation is different from Google's
			// in that it searches for a fitting format
			// even if the user has entered less than
			// `MIN_LEADING_DIGITS_LENGTH` digits of a national number.
			// Because some leading digits patterns already match for a single first digit.
			var index_of_leading_digits_pattern = leading_digits.length - MIN_LEADING_DIGITS_LENGTH;
			if (index_of_leading_digits_pattern < 0) {
				index_of_leading_digits_pattern = 0;
			}

			// If at least `MIN_LEADING_DIGITS_LENGTH` digits of a national number are available
			// then format matching starts narrowing down the list of possible formats
			// (only previously matched formats are considered for next digits).
			var available_formats = this.had_enough_leading_digits && this.matching_formats || this.available_formats;
			this.had_enough_leading_digits = this.should_format();

			this.matching_formats = available_formats.filter(function (format) {
				var leading_digits_patterns_count = format.leadingDigitsPatterns().length;

				// If this format is not restricted to a certain
				// leading digits pattern then it fits.
				if (leading_digits_patterns_count === 0) {
					return true;
				}

				var leading_digits_pattern_index = Math.min(index_of_leading_digits_pattern, leading_digits_patterns_count - 1);
				var leading_digits_pattern = format.leadingDigitsPatterns()[leading_digits_pattern_index];

				// Brackets are required for `^` to be applied to
				// all or-ed (`|`) parts, not just the first one.
				return new RegExp('^(' + leading_digits_pattern + ')').test(leading_digits);
			});

			// If there was a phone number format chosen
			// and it no longer holds given the new leading digits then reset it.
			// The test for this `if` condition is marked as:
			// "Reset a chosen format when it no longer holds given the new leading digits".
			// To construct a valid test case for this one can find a country
			// in `PhoneNumberMetadata.xml` yielding one format for 3 `<leadingDigits>`
			// and yielding another format for 4 `<leadingDigits>` (Australia in this case).
			if (this.chosen_format && this.matching_formats.indexOf(this.chosen_format) === -1) {
				this.reset_format();
			}
		}
	}, {
		key: 'should_format',
		value: function should_format() {
			// Start matching any formats at all when the national number
			// entered so far is at least 3 digits long,
			// otherwise format matching would give false negatives
			// like when the digits entered so far are `2`
			// and the leading digits pattern is `21` –
			// it's quite obvious in this case that the format could be the one
			// but due to the absence of further digits it would give false negative.
			//
			// Presumably the limitation of "3 digits min"
			// is imposed to exclude false matches,
			// e.g. when there are two different formats
			// each one fitting one or two leading digits being input.
			// But for this case I would propose a specific `if/else` condition.
			//
			return this.national_number.length >= MIN_LEADING_DIGITS_LENGTH;
		}

		// Check to see if there is an exact pattern match for these digits. If so, we
		// should use this instead of any other formatting template whose
		// `leadingDigitsPattern` also matches the input.

	}, {
		key: 'attempt_to_format_complete_phone_number',
		value: function attempt_to_format_complete_phone_number() {
			for (var _iterator = this.matching_formats, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref = _i.value;
				}

				var format = _ref;

				var matcher = new RegExp('^(?:' + format.pattern() + ')$');

				if (!matcher.test(this.national_number)) {
					continue;
				}

				if (!this.is_format_applicable(format)) {
					continue;
				}

				// To leave the formatter in a consistent state
				this.reset_format();
				this.chosen_format = format;

				var formatted_number = Object(__WEBPACK_IMPORTED_MODULE_4__format__["c" /* format_national_number_using_format */])(this.national_number, format, this.is_international(), this.national_prefix.length > 0, this.metadata);

				// Set `this.template` and `this.partially_populated_template`.
				//
				// `else` case doesn't ever happen
				// with the current metadata,
				// but just in case.
				//
				/* istanbul ignore else */
				if (this.create_formatting_template(format)) {
					// Populate `this.partially_populated_template`
					this.reformat_national_number();
				} else {
					// Prepend `+CountryCode` in case of an international phone number
					var full_number = this.full_phone_number(formatted_number);
					this.template = full_number.replace(/[\d\+]/g, DIGIT_PLACEHOLDER);
					this.partially_populated_template = full_number;
				}

				return formatted_number;
			}
		}

		// Prepends `+CountryCode` in case of an international phone number

	}, {
		key: 'full_phone_number',
		value: function full_phone_number(formatted_national_number) {
			if (this.is_international()) {
				return '+' + this.countryCallingCode + ' ' + formatted_national_number;
			}

			return formatted_national_number;
		}

		// Extracts the country calling code from the beginning
		// of the entered `national_number` (so far),
		// and places the remaining input into the `national_number`.

	}, {
		key: 'extract_country_calling_code',
		value: function extract_country_calling_code() {
			var _extractCountryCallin = Object(__WEBPACK_IMPORTED_MODULE_2__common__["h" /* extractCountryCallingCode */])(this.parsed_input, this.default_country, this.metadata.metadata),
			    countryCallingCode = _extractCountryCallin.countryCallingCode,
			    number = _extractCountryCallin.number;

			if (!countryCallingCode) {
				return;
			}

			this.countryCallingCode = countryCallingCode;

			// Sometimes people erroneously write national prefix
			// as part of an international number, e.g. +44 (0) ....
			// This violates the standards for international phone numbers,
			// so "As You Type" formatter assumes no national prefix
			// when parsing a phone number starting from `+`.
			// Even if it did attempt to filter-out that national prefix
			// it would look weird for a user trying to enter a digit
			// because from user's perspective the keyboard "wouldn't be working".
			this.national_number = number;

			this.metadata.chooseCountryByCountryCallingCode(countryCallingCode);
			return this.metadata.selectedCountry() !== undefined;
		}
	}, {
		key: 'extract_national_prefix',
		value: function extract_national_prefix() {
			this.national_prefix = '';

			if (!this.metadata.selectedCountry()) {
				return;
			}

			// Only strip national prefixes for non-international phone numbers
			// because national prefixes can't be present in international phone numbers.
			// Otherwise, while forgiving, it would parse a NANPA number `+1 1877 215 5230`
			// first to `1877 215 5230` and then, stripping the leading `1`, to `877 215 5230`,
			// and then it would assume that's a valid number which it isn't.
			// So no forgiveness for grandmas here.
			// The issue asking for this fix:
			// https://github.com/catamphetamine/libphonenumber-js/issues/159

			var _strip_national_prefi = Object(__WEBPACK_IMPORTED_MODULE_3__parse__["e" /* strip_national_prefix_and_carrier_code */])(this.national_number, this.metadata),
			    potential_national_number = _strip_national_prefi.number,
			    carrierCode = _strip_national_prefi.carrierCode;

			if (carrierCode) {
				this.carrierCode = carrierCode;
			}

			// We require that the NSN remaining after stripping the national prefix and
			// carrier code be long enough to be a possible length for the region.
			// Otherwise, we don't do the stripping, since the original number could be
			// a valid short number.
			if (!this.metadata.possibleLengths() || this.is_possible_number(this.national_number) && !this.is_possible_number(potential_national_number)) {
				// Verify the parsed national (significant) number for this country
				//
				// If the original number (before stripping national prefix) was viable,
				// and the resultant number is not, then prefer the original phone number.
				// This is because for some countries (e.g. Russia) the same digit could be both
				// a national prefix and a leading digit of a valid national phone number,
				// like `8` is the national prefix for Russia and both
				// `8 800 555 35 35` and `800 555 35 35` are valid numbers.
				if (Object(__WEBPACK_IMPORTED_MODULE_2__common__["i" /* matches_entirely */])(this.national_number, this.metadata.nationalNumberPattern()) && !Object(__WEBPACK_IMPORTED_MODULE_2__common__["i" /* matches_entirely */])(potential_national_number, this.metadata.nationalNumberPattern())) {
					return;
				}
			}

			this.national_prefix = this.national_number.slice(0, this.national_number.length - potential_national_number.length);
			this.national_number = potential_national_number;

			return this.national_prefix;
		}
	}, {
		key: 'is_possible_number',
		value: function is_possible_number(number) {
			var validation_result = Object(__WEBPACK_IMPORTED_MODULE_5__getNumberType__["a" /* check_number_length_for_type */])(number, undefined, this.metadata);
			switch (validation_result) {
				case 'IS_POSSIBLE':
					return true;
				// case 'IS_POSSIBLE_LOCAL_ONLY':
				// 	return !this.is_international()
				default:
					return false;
			}
		}
	}, {
		key: 'choose_another_format',
		value: function choose_another_format() {
			// When there are multiple available formats, the formatter uses the first
			// format where a formatting template could be created.
			for (var _iterator2 = this.matching_formats, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
				var _ref2;

				if (_isArray2) {
					if (_i2 >= _iterator2.length) break;
					_ref2 = _iterator2[_i2++];
				} else {
					_i2 = _iterator2.next();
					if (_i2.done) break;
					_ref2 = _i2.value;
				}

				var format = _ref2;

				// If this format is currently being used
				// and is still possible, then stick to it.
				if (this.chosen_format === format) {
					return;
				}

				// If this `format` is suitable for "as you type",
				// then extract the template from this format
				// and use it to format the phone number being input.

				if (!this.is_format_applicable(format)) {
					continue;
				}

				if (!this.create_formatting_template(format)) {
					continue;
				}

				this.chosen_format = format;

				// With a new formatting template, the matched position
				// using the old template needs to be reset.
				this.last_match_position = -1;

				return true;
			}

			// No format matches the phone number,
			// therefore set `country` to `undefined`
			// (or to the default country).
			this.reset_country();

			// No format matches the national phone number entered
			this.reset_format();
		}
	}, {
		key: 'is_format_applicable',
		value: function is_format_applicable(format) {
			// If national prefix is mandatory for this phone number format
			// and the user didn't input the national prefix,
			// then this phone number format isn't suitable.
			if (!this.is_international() && !this.national_prefix && format.nationalPrefixIsMandatoryWhenFormatting()) {
				return false;
			}

			return true;
		}
	}, {
		key: 'create_formatting_template',
		value: function create_formatting_template(format) {
			// The formatter doesn't format numbers when numberPattern contains '|', e.g.
			// (20|3)\d{4}. In those cases we quickly return.
			// (Though there's no such format in current metadata)
			/* istanbul ignore if */
			if (format.pattern().indexOf('|') >= 0) {
				return;
			}

			// Get formatting template for this phone number format
			var template = this.get_template_for_phone_number_format_pattern(format);

			// If the national number entered is too long
			// for any phone number format, then abort.
			if (!template) {
				return;
			}

			// This one is for national number only
			this.partially_populated_template = template;

			// For convenience, the public `.template` property
			// contains the whole international number
			// if the phone number being input is international:
			// 'x' for the '+' sign, 'x'es for the country phone code,
			// a spacebar and then the template for the formatted national number.
			if (this.is_international()) {
				this.template = DIGIT_PLACEHOLDER + repeat(DIGIT_PLACEHOLDER, this.countryCallingCode.length) + ' ' + template;
			}
			// For local numbers, replace national prefix
			// with a digit placeholder.
			else {
					this.template = template.replace(/\d/g, DIGIT_PLACEHOLDER);
				}

			// This one is for the full phone number
			return this.template;
		}

		// Generates formatting template for a phone number format

	}, {
		key: 'get_template_for_phone_number_format_pattern',
		value: function get_template_for_phone_number_format_pattern(format) {
			// A very smart trick by the guys at Google
			var number_pattern = format.pattern()
			// Replace anything in the form of [..] with \d
			.replace(CREATE_CHARACTER_CLASS_PATTERN(), '\\d')
			// Replace any standalone digit (not the one in `{}`) with \d
			.replace(CREATE_STANDALONE_DIGIT_PATTERN(), '\\d');

			// This match will always succeed,
			// because the "longest dummy phone number"
			// has enough length to accomodate any possible
			// national phone number format pattern.
			var dummy_phone_number_matching_format_pattern = LONGEST_DUMMY_PHONE_NUMBER.match(number_pattern)[0];

			// If the national number entered is too long
			// for any phone number format, then abort.
			if (this.national_number.length > dummy_phone_number_matching_format_pattern.length) {
				return;
			}

			// Prepare the phone number format
			var number_format = this.get_format_format(format);

			// Get a formatting template which can be used to efficiently format
			// a partial number where digits are added one by one.

			// Below `strict_pattern` is used for the
			// regular expression (with `^` and `$`).
			// This wasn't originally in Google's `libphonenumber`
			// and I guess they don't really need it
			// because they're not using "templates" to format phone numbers
			// but I added `strict_pattern` after encountering
			// South Korean phone number formatting bug.
			//
			// Non-strict regular expression bug demonstration:
			//
			// this.national_number : `111111111` (9 digits)
			//
			// number_pattern : (\d{2})(\d{3,4})(\d{4})
			// number_format : `$1 $2 $3`
			// dummy_phone_number_matching_format_pattern : `9999999999` (10 digits)
			//
			// '9999999999'.replace(new RegExp(/(\d{2})(\d{3,4})(\d{4})/g), '$1 $2 $3') = "99 9999 9999"
			//
			// template : xx xxxx xxxx
			//
			// But the correct template in this case is `xx xxx xxxx`.
			// The template was generated incorrectly because of the
			// `{3,4}` variability in the `number_pattern`.
			//
			// The fix is, if `this.national_number` has already sufficient length
			// to satisfy the `number_pattern` completely then `this.national_number` is used
			// instead of `dummy_phone_number_matching_format_pattern`.

			var strict_pattern = new RegExp('^' + number_pattern + '$');
			var national_number_dummy_digits = this.national_number.replace(/\d/g, DUMMY_DIGIT);

			// If `this.national_number` has already sufficient length
			// to satisfy the `number_pattern` completely then use it
			// instead of `dummy_phone_number_matching_format_pattern`.
			if (strict_pattern.test(national_number_dummy_digits)) {
				dummy_phone_number_matching_format_pattern = national_number_dummy_digits;
			}

			// Generate formatting template for this phone number format
			return dummy_phone_number_matching_format_pattern
			// Format the dummy phone number according to the format
			.replace(new RegExp(number_pattern), number_format)
			// Replace each dummy digit with a DIGIT_PLACEHOLDER
			.replace(new RegExp(DUMMY_DIGIT, 'g'), DIGIT_PLACEHOLDER);
		}
	}, {
		key: 'format_next_national_number_digits',
		value: function format_next_national_number_digits(digits) {
			// Using `.split('')` to iterate through a string here
			// to avoid requiring `Symbol.iterator` polyfill.
			// `.split('')` is generally not safe for Unicode,
			// but in this particular case for `digits` it is safe.
			// for (const digit of digits)
			for (var _iterator3 = digits.split(''), _isArray3 = Array.isArray(_iterator3), _i3 = 0, _iterator3 = _isArray3 ? _iterator3 : _iterator3[Symbol.iterator]();;) {
				var _ref3;

				if (_isArray3) {
					if (_i3 >= _iterator3.length) break;
					_ref3 = _iterator3[_i3++];
				} else {
					_i3 = _iterator3.next();
					if (_i3.done) break;
					_ref3 = _i3.value;
				}

				var digit = _ref3;

				// If there is room for more digits in current `template`,
				// then set the next digit in the `template`,
				// and return the formatted digits so far.

				// If more digits are entered than the current format could handle
				if (this.partially_populated_template.slice(this.last_match_position + 1).search(DIGIT_PLACEHOLDER_MATCHER) === -1) {
					// Reset the current format,
					// so that the new format will be chosen
					// in a subsequent `this.choose_another_format()` call
					// later in code.
					this.chosen_format = undefined;
					this.template = undefined;
					this.partially_populated_template = undefined;
					return;
				}

				this.last_match_position = this.partially_populated_template.search(DIGIT_PLACEHOLDER_MATCHER);
				this.partially_populated_template = this.partially_populated_template.replace(DIGIT_PLACEHOLDER_MATCHER, digit);
			}

			// Return the formatted phone number so far.
			return cut_stripping_dangling_braces(this.partially_populated_template, this.last_match_position + 1);

			// The old way which was good for `input-format` but is not so good
			// for `react-phone-number-input`'s default input (`InputBasic`).
			// return close_dangling_braces(this.partially_populated_template, this.last_match_position + 1)
			// 	.replace(DIGIT_PLACEHOLDER_MATCHER_GLOBAL, ' ')
		}
	}, {
		key: 'is_international',
		value: function is_international() {
			return this.parsed_input && this.parsed_input[0] === '+';
		}
	}, {
		key: 'get_format_format',
		value: function get_format_format(format) {
			if (this.is_international()) {
				return Object(__WEBPACK_IMPORTED_MODULE_4__format__["d" /* local_to_international_style */])(format.internationalFormat());
			}

			// If national prefix formatting rule is set
			// for this phone number format
			if (format.nationalPrefixFormattingRule()) {
				// If the user did input the national prefix
				// (or if the national prefix formatting rule does not require national prefix)
				// then maybe make it part of the phone number template
				if (this.national_prefix || !format.usesNationalPrefix()) {
					// Make the national prefix part of the phone number template
					return format.format().replace(__WEBPACK_IMPORTED_MODULE_4__format__["a" /* FIRST_GROUP_PATTERN */], format.nationalPrefixFormattingRule());
				}
			}

			return format.format();
		}

		// Determines the country of the phone number
		// entered so far based on the country phone code
		// and the national phone number.

	}, {
		key: 'determine_the_country',
		value: function determine_the_country() {
			this.country = Object(__WEBPACK_IMPORTED_MODULE_3__parse__["c" /* find_country_code */])(this.countryCallingCode, this.national_number, this.metadata);
		}
	}, {
		key: 'getNumber',
		value: function getNumber() {
			if (!this.countryCallingCode || !this.national_number) {
				return undefined;
			}
			var phoneNumber = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumber__["a" /* default */](this.country || this.countryCallingCode, this.national_number, this.metadata.metadata);
			if (this.carrierCode) {
				phoneNumber.carrierCode = this.carrierCode;
			}
			// Phone number extensions are not supported by "As You Type" formatter.
			return phoneNumber;
		}
	}, {
		key: 'getNationalNumber',
		value: function getNationalNumber() {
			return this.national_number;
		}
	}, {
		key: 'getTemplate',
		value: function getTemplate() {
			if (!this.template) {
				return;
			}

			var index = -1;

			var i = 0;
			while (i < this.parsed_input.length) {
				index = this.template.indexOf(DIGIT_PLACEHOLDER, index + 1);
				i++;
			}

			return cut_stripping_dangling_braces(this.template, index + 1);
		}
	}]);

	return AsYouType;
}();

/* harmony default export */ __webpack_exports__["a"] = (AsYouType);


function strip_dangling_braces(string) {
	var dangling_braces = [];
	var i = 0;
	while (i < string.length) {
		if (string[i] === '(') {
			dangling_braces.push(i);
		} else if (string[i] === ')') {
			dangling_braces.pop();
		}
		i++;
	}

	var start = 0;
	var cleared_string = '';
	dangling_braces.push(string.length);
	for (var _iterator4 = dangling_braces, _isArray4 = Array.isArray(_iterator4), _i4 = 0, _iterator4 = _isArray4 ? _iterator4 : _iterator4[Symbol.iterator]();;) {
		var _ref4;

		if (_isArray4) {
			if (_i4 >= _iterator4.length) break;
			_ref4 = _iterator4[_i4++];
		} else {
			_i4 = _iterator4.next();
			if (_i4.done) break;
			_ref4 = _i4.value;
		}

		var index = _ref4;

		cleared_string += string.slice(start, index);
		start = index + 1;
	}

	return cleared_string;
}

function cut_stripping_dangling_braces(string, cut_before_index) {
	if (string[cut_before_index] === ')') {
		cut_before_index++;
	}
	return strip_dangling_braces(string.slice(0, cut_before_index));
}

function close_dangling_braces(template, cut_before) {
	var retained_template = template.slice(0, cut_before);

	var opening_braces = count_occurences('(', retained_template);
	var closing_braces = count_occurences(')', retained_template);

	var dangling_braces = opening_braces - closing_braces;
	while (dangling_braces > 0 && cut_before < template.length) {
		if (template[cut_before] === ')') {
			dangling_braces--;
		}
		cut_before++;
	}

	return template.slice(0, cut_before);
}

// Counts all occurences of a symbol in a string.
// Unicode-unsafe (because using `.split()`).
function count_occurences(symbol, string) {
	var count = 0;

	// Using `.split('')` to iterate through a string here
	// to avoid requiring `Symbol.iterator` polyfill.
	// `.split('')` is generally not safe for Unicode,
	// but in this particular case for counting brackets it is safe.
	// for (const character of string)
	for (var _iterator5 = string.split(''), _isArray5 = Array.isArray(_iterator5), _i5 = 0, _iterator5 = _isArray5 ? _iterator5 : _iterator5[Symbol.iterator]();;) {
		var _ref5;

		if (_isArray5) {
			if (_i5 >= _iterator5.length) break;
			_ref5 = _iterator5[_i5++];
		} else {
			_i5 = _iterator5.next();
			if (_i5.done) break;
			_ref5 = _i5.value;
		}

		var character = _ref5;

		if (character === symbol) {
			count++;
		}
	}

	return count;
}

// Repeats a string (or a symbol) N times.
// http://stackoverflow.com/questions/202605/repeat-string-javascript
function repeat(string, times) {
	if (times < 1) {
		return '';
	}

	var result = '';

	while (times > 1) {
		if (times & 1) {
			result += string;
		}

		times >>= 1;
		string += string;
	}

	return result + string;
}
//# sourceMappingURL=AsYouType.js.map

/***/ }),
/* 383 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(385)('keys');
var uid = __webpack_require__(259);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(40);
var global = __webpack_require__(55);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(196) ? 'pure' : 'global',
  copyright: '© 2018 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(89);
var core = __webpack_require__(40);
var fails = __webpack_require__(161);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(117);
var document = __webpack_require__(55).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(117);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 389 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(90);
var dPs = __webpack_require__(1301);
var enumBugKeys = __webpack_require__(391);
var IE_PROTO = __webpack_require__(384)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(387)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(608).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 391 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(56);


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(55);
var core = __webpack_require__(40);
var LIBRARY = __webpack_require__(196);
var wksExt = __webpack_require__(392);
var defineProperty = __webpack_require__(116).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 394 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(265);
var createDesc = __webpack_require__(261);
var toIObject = __webpack_require__(139);
var toPrimitive = __webpack_require__(388);
var has = __webpack_require__(137);
var IE8_DOM_DEFINE = __webpack_require__(600);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(118) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__types__ = __webpack_require__(18);









/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */
var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize,
        maxScrollSize = _ref$maxScrollSize === undefined ? Object(__WEBPACK_IMPORTED_MODULE_4__maxElementSize_js__["a" /* getMaxElementSize */])() : _ref$maxScrollSize,
        params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
    }
  }, {
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scaled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize,
          offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize,
          offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize,
          offset = _ref5.offset,
          totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize,
          offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize,
          offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);




/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback,
        indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(199);
var TAG = __webpack_require__(56)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(260);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* unused harmony export bpfrpt_proptype_CellMeasurerCache */
/* unused harmony export bpfrpt_proptype_Positioner */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(1370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PositionCache__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types__);













var emptyObject = {};

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * This component efficiently displays arbitrarily positioned cells using windowing techniques.
 * Cell position is determined by an injected `cellPositioner` property.
 * Windowing is vertical; this component does not support horizontal scrolling.
 *
 * Rendering occurs in two phases:
 * 1) First pass uses estimated cell sizes (provided by the cache) to determine how many cells to measure in a batch.
 *    Batch size is chosen using a fast, naive layout algorithm that stacks images in order until the viewport has been filled.
 *    After measurement is complete (componentDidMount or componentDidUpdate) this component evaluates positioned cells
 *    in order to determine if another measurement pass is required (eg if actual cell sizes were less than estimated sizes).
 *    All measurements are permanently cached (keyed by `keyMapper`) for performance purposes.
 * 2) Second pass uses the external `cellPositioner` to layout cells.
 *    At this time the positioner has access to cached size measurements for all cells.
 *    The positions it returns are cached by Masonry for fast access later.
 *    Phase one is repeated if the user scrolls beyond the current layout's bounds.
 *    If the layout is invalidated due to eg a resize, cached positions can be cleared using `recomputeCellPositions()`.
 *
 * Animation constraints:
 *   Simple animations are supported (eg translate/slide into place on initial reveal).
 *   More complex animations are not (eg flying from one position to another on resize).
 *
 * Layout constraints:
 *   This component supports multi-column layout.
 *   The height of each item may vary.
 *   The width of each item must not exceed the width of the column it is "in".
 *   The left position of all items within a column must align.
 *   (Items may not span multiple columns.)
 */

var Masonry = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Masonry, _React$PureComponent);

  function Masonry() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Masonry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Masonry.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Masonry)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isScrolling: false,
      scrollTop: 0
    }, _this._invalidateOnUpdateStartIndex = null, _this._invalidateOnUpdateStopIndex = null, _this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */](), _this._startIndex = null, _this._startIndexMemoized = null, _this._stopIndex = null, _this._stopIndexMemoized = null, _this._debounceResetIsScrollingCallback = function () {
      _this.setState({
        isScrolling: false
      });
    }, _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    }, _this._onScroll = function (event) {
      var height = _this.props.height;


      var eventScrollTop = event.target.scrollTop;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
      var scrollTop = Math.min(Math.max(0, _this._getEstimatedTotalHeight() - height), eventScrollTop);

      // On iOS, we can arrive at negative offsets by swiping past the start or end.
      // Avoid re-rendering in this case as it can cause problems; see #532 for more.
      if (eventScrollTop !== scrollTop) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._debounceResetIsScrolling();

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollTop !== scrollTop) {
        _this.setState({
          isScrolling: true,
          scrollTop: scrollTop
        });
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Masonry, [{
    key: 'clearCellPositions',
    value: function clearCellPositions() {
      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this.forceUpdate();
    }

    // HACK This method signature was intended for Grid

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var index = _ref2.rowIndex;

      if (this._invalidateOnUpdateStartIndex === null) {
        this._invalidateOnUpdateStartIndex = index;
        this._invalidateOnUpdateStopIndex = index;
      } else {
        this._invalidateOnUpdateStartIndex = Math.min(this._invalidateOnUpdateStartIndex, index);
        this._invalidateOnUpdateStopIndex = Math.max(this._invalidateOnUpdateStopIndex, index);
      }
    }
  }, {
    key: 'recomputeCellPositions',
    value: function recomputeCellPositions() {
      var stopIndex = this._positionCache.count - 1;

      this._positionCache = new __WEBPACK_IMPORTED_MODULE_10__PositionCache__["a" /* default */]();
      this._populatePositionCache(0, stopIndex);

      this.forceUpdate();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      this._checkInvalidateOnUpdate();
      this._invokeOnScrollCallback();
      this._invokeOnCellsRenderedCallback();

      if (this.props.scrollTop !== prevProps.scrollTop) {
        this._debounceResetIsScrolling();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          autoHeight = _props.autoHeight,
          cellCount = _props.cellCount,
          cellMeasurerCache = _props.cellMeasurerCache,
          cellRenderer = _props.cellRenderer,
          className = _props.className,
          height = _props.height,
          id = _props.id,
          keyMapper = _props.keyMapper,
          overscanByPixels = _props.overscanByPixels,
          role = _props.role,
          style = _props.style,
          tabIndex = _props.tabIndex,
          width = _props.width,
          rowDirection = _props.rowDirection;
      var _state = this.state,
          isScrolling = _state.isScrolling,
          scrollTop = _state.scrollTop;


      var children = [];

      var estimateTotalHeight = this._getEstimatedTotalHeight();

      var shortestColumnSize = this._positionCache.shortestColumnSize;
      var measuredCellCount = this._positionCache.count;

      var startIndex = 0;
      var stopIndex = void 0;

      this._positionCache.range(Math.max(0, scrollTop - overscanByPixels), height + overscanByPixels * 2, function (index, left, top) {
        var _style;

        if (typeof stopIndex === 'undefined') {
          startIndex = index;
          stopIndex = index;
        } else {
          startIndex = Math.min(startIndex, index);
          stopIndex = Math.max(stopIndex, index);
        }

        children.push(cellRenderer({
          index: index,
          isScrolling: isScrolling,
          key: keyMapper(index),
          parent: _this2,
          style: (_style = {
            height: cellMeasurerCache.getHeight(index)
          }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, rowDirection === 'ltr' ? 'left' : 'right', left), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'position', 'absolute'), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'top', top), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_style, 'width', cellMeasurerCache.getWidth(index)), _style)
        }));
      });

      // We need to measure additional cells for this layout
      if (shortestColumnSize < scrollTop + height + overscanByPixels && measuredCellCount < cellCount) {
        var batchSize = Math.min(cellCount - measuredCellCount, Math.ceil((scrollTop + height + overscanByPixels - shortestColumnSize) / cellMeasurerCache.defaultHeight * width / cellMeasurerCache.defaultWidth));

        for (var _index = measuredCellCount; _index < measuredCellCount + batchSize; _index++) {
          stopIndex = _index;

          children.push(cellRenderer({
            index: _index,
            isScrolling: isScrolling,
            key: keyMapper(_index),
            parent: this,
            style: {
              width: cellMeasurerCache.getWidth(_index)
            }
          }));
        }
      }

      this._startIndex = startIndex;
      this._stopIndex = stopIndex;

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Masonry', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            boxSizing: 'border-box',
            direction: 'ltr',
            height: autoHeight ? 'auto' : height,
            overflowX: 'hidden',
            overflowY: estimateTotalHeight < height ? 'hidden' : 'auto',
            position: 'relative',
            width: width,
            WebkitOverflowScrolling: 'touch',
            willChange: 'transform'
          }, style),
          tabIndex: tabIndex },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Masonry__innerScrollContainer',
            style: {
              width: '100%',
              height: estimateTotalHeight,
              maxWidth: '100%',
              maxHeight: estimateTotalHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            } },
          children
        )
      );
    }
  }, {
    key: '_checkInvalidateOnUpdate',
    value: function _checkInvalidateOnUpdate() {
      if (typeof this._invalidateOnUpdateStartIndex === 'number') {
        var _startIndex = this._invalidateOnUpdateStartIndex;
        var _stopIndex = this._invalidateOnUpdateStopIndex;

        this._invalidateOnUpdateStartIndex = null;
        this._invalidateOnUpdateStopIndex = null;

        // Query external layout logic for position of newly-measured cells
        this._populatePositionCache(_startIndex, _stopIndex);

        this.forceUpdate();
      }
    }
  }, {
    key: '_debounceResetIsScrolling',
    value: function _debounceResetIsScrolling() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._debounceResetIsScrollingId) {
        Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._debounceResetIsScrollingId);
      }

      this._debounceResetIsScrollingId = Object(__WEBPACK_IMPORTED_MODULE_11__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceResetIsScrollingCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_getEstimatedTotalHeight',
    value: function _getEstimatedTotalHeight() {
      var _props2 = this.props,
          cellCount = _props2.cellCount,
          cellMeasurerCache = _props2.cellMeasurerCache,
          width = _props2.width;


      var estimatedColumnCount = Math.max(1, Math.floor(width / cellMeasurerCache.defaultWidth));

      return this._positionCache.estimateTotalHeight(cellCount, estimatedColumnCount, cellMeasurerCache.defaultHeight);
    }
  }, {
    key: '_invokeOnScrollCallback',
    value: function _invokeOnScrollCallback() {
      var _props3 = this.props,
          height = _props3.height,
          onScroll = _props3.onScroll;
      var scrollTop = this.state.scrollTop;


      if (this._onScrollMemoized !== scrollTop) {
        onScroll({
          clientHeight: height,
          scrollHeight: this._getEstimatedTotalHeight(),
          scrollTop: scrollTop
        });

        this._onScrollMemoized = scrollTop;
      }
    }
  }, {
    key: '_invokeOnCellsRenderedCallback',
    value: function _invokeOnCellsRenderedCallback() {
      if (this._startIndexMemoized !== this._startIndex || this._stopIndexMemoized !== this._stopIndex) {
        var _onCellsRendered = this.props.onCellsRendered;


        _onCellsRendered({
          startIndex: this._startIndex,
          stopIndex: this._stopIndex
        });

        this._startIndexMemoized = this._startIndex;
        this._stopIndexMemoized = this._stopIndex;
      }
    }
  }, {
    key: '_populatePositionCache',
    value: function _populatePositionCache(startIndex, stopIndex) {
      var _props4 = this.props,
          cellMeasurerCache = _props4.cellMeasurerCache,
          cellPositioner = _props4.cellPositioner;


      for (var _index2 = startIndex; _index2 <= stopIndex; _index2++) {
        var _cellPositioner = cellPositioner(_index2),
            _left = _cellPositioner.left,
            _top = _cellPositioner.top;

        this._positionCache.setPosition(_index2, _left, _top, cellMeasurerCache.getHeight(_index2));
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollTop !== undefined && prevState.scrollTop !== nextProps.scrollTop) {
        return {
          isScrolling: true,
          scrollTop: nextProps.scrollTop
        };
      }

      return null;
    }
  }]);

  return Masonry;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Masonry.defaultProps = {
  autoHeight: false,
  keyMapper: identity,
  onCellsRendered: noop,
  onScroll: noop,
  overscanByPixels: 20,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  style: emptyObject,
  tabIndex: 0,
  rowDirection: 'ltr'
};
Masonry.propTypes =  true ? null : {
  autoHeight: PropTypes.bool.isRequired,
  cellCount: PropTypes.number.isRequired,
  cellMeasurerCache: function cellMeasurerCache() {
    return (typeof CellMeasurerCache === 'function' ? PropTypes.instanceOf(CellMeasurerCache).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellPositioner: function cellPositioner() {
    return (typeof Positioner === 'function' ? PropTypes.instanceOf(Positioner).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  cellRenderer: function cellRenderer() {
    return (typeof CellRenderer === 'function' ? PropTypes.instanceOf(CellRenderer).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  className: PropTypes.string,
  height: PropTypes.number.isRequired,
  id: PropTypes.string,
  keyMapper: function keyMapper() {
    return (typeof KeyMapper === 'function' ? PropTypes.instanceOf(KeyMapper).isRequired : PropTypes.any.isRequired).apply(this, arguments);
  },
  onCellsRendered: function onCellsRendered() {
    return (typeof OnCellsRenderedCallback === 'function' ? PropTypes.instanceOf(OnCellsRenderedCallback) : PropTypes.any).apply(this, arguments);
  },
  onScroll: function onScroll() {
    return (typeof OnScrollCallback === 'function' ? PropTypes.instanceOf(OnScrollCallback) : PropTypes.any).apply(this, arguments);
  },
  overscanByPixels: PropTypes.number.isRequired,
  role: PropTypes.string.isRequired,
  scrollingResetTimeInterval: PropTypes.number.isRequired,
  style: function style(props, propName, componentName) {
    if (!Object.prototype.hasOwnProperty.call(props, propName)) {
      throw new Error('Prop `' + propName + '` has type \'any\' or \'mixed\', but was not provided to `' + componentName + '`. Pass undefined or any other value.');
    }
  },
  tabIndex: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  rowDirection: PropTypes.string.isRequired
};


function identity(value) {
  return value;
}

function noop() {}

var bpfrpt_proptype_CellMeasurerCache =  true ? null : {
  defaultHeight: PropTypes.number.isRequired,
  defaultWidth: PropTypes.number.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(Masonry);

/* harmony default export */ __webpack_exports__["a"] = (Masonry);

var bpfrpt_proptype_Positioner =  true ? null : PropTypes.func;





/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var timestamp = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate).getTime();
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return new Date(timestamp + amount);
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(269);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(648);



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var desiredMonth = date.getMonth() + amount;
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()));
  return date;
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Manager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_context__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_create_react_context__);






var ManagerContext = __WEBPACK_IMPORTED_MODULE_5_create_react_context___default()({
  setReferenceNode: undefined,
  referenceNode: undefined
});

var Manager =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(Manager, _React$Component);

  function Manager() {
    var _this;

    _this = _React$Component.call(this) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "setReferenceNode", function (referenceNode) {
      if (!referenceNode || _this.state.context.referenceNode === referenceNode) {
        return;
      }

      _this.setState(function (_ref) {
        var context = _ref.context;
        return {
          context: __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({}, context, {
            referenceNode: referenceNode
          })
        };
      });
    });

    _this.state = {
      context: {
        setReferenceNode: _this.setReferenceNode,
        referenceNode: undefined
      }
    };
    return _this;
  }

  var _proto = Manager.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](ManagerContext.Provider, {
      value: this.state.context
    }, this.props.children);
  };

  return Manager;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);



/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:props.width||"24.414",height:props.height||"15.557",viewBox:"0 0 24.414 15.557"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M6255.584-14750.192l-6.362-6.362,1.413-1.417,5.365,5.365v-20.584h2v20.587l5.365-5.368,1.416,1.417-6.366,6.362-1.413,1.416Z",transform:"translate(14773.19 6264.779) rotate(-90)",fill:"currentColor"}));});

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/timer.05b3439d.svg";

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Measure=function(_React$PureComponent){_inherits(Measure,_React$PureComponent);function Measure(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Measure);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Measure.__proto__||Object.getPrototypeOf(Measure)).call.apply(_ref,[this].concat(args))),_this),_this.state={width:0,height:0,didMeasure:false},_this.shouldMeasure=false,_this.prevWidth=0,_this.prevHeight=0,_this.takeMeasurements=function(){if(_this.shouldMeasure){requestAnimationFrame(_this.takeMeasurements);if(_this.node!=null){var _this$node=_this.node,clientWidth=_this$node.clientWidth,clientHeight=_this$node.clientHeight;if(clientWidth!==_this.prevWidth||clientHeight!==_this.prevHeight){_this.prevWidth=clientWidth;_this.prevHeight=clientHeight;if(_this.props.onMeasure){_this.props.onMeasure({width:clientWidth,height:clientHeight,didMeasure:true});}else{_this.setState({width:clientWidth,height:clientHeight,didMeasure:true});}}}}},_this.registerRef=function(node){_this.node=node;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Measure,[{key:"componentDidMount",value:function componentDidMount(){this.shouldMeasure=true;this.takeMeasurements();}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.shouldMeasure=false;}},{key:"render",value:function render(){return this.props.children(Object.assign({innerRef:this.registerRef},this.state));}}]);return Measure;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Measure);

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default-tournament-bg-iron.49ac5e79.jpg";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/default-tournament-bg-th.8a4b0cbf.jpg";

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TournamentIdProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TournamentId=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);/* harmony default export */ __webpack_exports__["b"] = (TournamentId);var TournamentIdProvider=function(_React$Component){_inherits(TournamentIdProvider,_React$Component);function TournamentIdProvider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TournamentIdProvider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TournamentIdProvider.__proto__||Object.getPrototypeOf(TournamentIdProvider)).call.apply(_ref,[this].concat(args))),_this),_this.changeTournamentId=function(tournamentId){_this.setState(function(state){return{tournamentId:tournamentId};});},_this.state={tournamentId:null,changeTournamentId:_this.changeTournamentId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TournamentIdProvider,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TournamentId.Provider,{value:this.state},this.props.children);}}]);return TournamentIdProvider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(415);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(1549),
    isObjectLike = __webpack_require__(77);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_error_png__ = __webpack_require__(1568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_error_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_error_png__);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n  //user-select: none;\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 5px;\n  }\n"],["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.5);\n  //user-select: none;\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 5px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 1;\n  flex-direction: row;\n  align-items: stretch;\n  width: 100%;\n  max-width: 65em;\n  max-height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 0.5em;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n  overflow: hidden;\n"],["\n  position: relative;\n  flex-shrink: 1;\n  flex-direction: row;\n  align-items: stretch;\n  width: 100%;\n  max-width: 65em;\n  max-height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 0.5em;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n  overflow: hidden;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  flex: 0 0 20%;\n  padding: 15px;\n  background-color: #e6e6e6;\n"],["\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  flex: 0 0 20%;\n  padding: 15px;\n  background-color: #e6e6e6;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  width: 100%;\n  align-self: stretch;\n  background: url(",") center no-repeat;\n  background-size: contain;\n"],["\n  width: 100%;\n  align-self: stretch;\n  background: url(",") center no-repeat;\n  background-size: contain;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  justify-content: space-around;\n  flex: 1 1 80%;\n  align-self: stretch;\n  padding: 30px 30px 25px;\n\n  @media (max-height: 200px) {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n"],["\n  justify-content: space-around;\n  flex: 1 1 80%;\n  align-self: stretch;\n  padding: 30px 30px 25px;\n\n  @media (max-height: 200px) {\n    padding-top: 10px;\n    padding-bottom: 10px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  padding-bottom: 1em;\n  font-weight: 400;\n  font-size: 3em;\n  line-height: 1.25;\n  text-align: center;\n  color: #343434;\n\n  @media (max-height: 200px) {\n    padding-bottom: 10px;\n    font-size: 20px;\n  }\n\n  @media (max-width: 640px) {\n    font-size: 14px;\n  }\n"],["\n  padding-bottom: 1em;\n  font-weight: 400;\n  font-size: 3em;\n  line-height: 1.25;\n  text-align: center;\n  color: #343434;\n\n  @media (max-height: 200px) {\n    padding-bottom: 10px;\n    font-size: 20px;\n  }\n\n  @media (max-width: 640px) {\n    font-size: 14px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  @media (min-width: 568px) {\n    flex-direction: row;\n  }\n"],["\n  @media (min-width: 568px) {\n    flex-direction: row;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  min-width: 165px;\n  min-height: 39px;\n  margin: 0 auto;\n  padding: 0 10px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1;\n  color: #fff;\n  background-color: #887d96;\n  background: linear-gradient(to bottom, #887d96, #605073);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  :hover {\n    color: #fff;\n    background-color: #605073;\n    background: linear-gradient(to bottom, #605073, #887d96);\n    outline: none;\n  }\n\n  :hover,\n  :focus,\n  :active {\n    outline: none;\n  }\n\n  @media (min-width: 568px) {\n    :not(:first-of-type) {\n      margin-left: 10px;\n    }\n  }\n  @media (max-width: 567px) {\n    :not(:first-of-type) {\n      margin-top: 5px;\n    }\n  }\n"],["\n  min-width: 165px;\n  min-height: 39px;\n  margin: 0 auto;\n  padding: 0 10px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 1;\n  color: #fff;\n  background-color: #887d96;\n  background: linear-gradient(to bottom, #887d96, #605073);\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  :hover {\n    color: #fff;\n    background-color: #605073;\n    background: linear-gradient(to bottom, #605073, #887d96);\n    outline: none;\n  }\n\n  :hover,\n  :focus,\n  :active {\n    outline: none;\n  }\n\n  @media (min-width: 568px) {\n    :not(:first-of-type) {\n      margin-left: 10px;\n    }\n  }\n  @media (max-width: 567px) {\n    :not(:first-of-type) {\n      margin-top: 5px;\n    }\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 18px;\n  height: 18px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  @media (max-width: 480px) {\n    top: 15px;\n    right: 15px;\n  }\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"],["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 18px;\n  height: 18px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  @media (max-width: 480px) {\n    top: 15px;\n    right: 15px;\n  }\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// styled
var Flex=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Flex)(_templateObject2);var Popup=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Flex)(_templateObject3);var ExclamationContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var ExclamationPoint=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,__WEBPACK_IMPORTED_MODULE_3__images_error_png___default.a);var Content=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Flex)(_templateObject6);var Message=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var ButtonContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Flex)(_templateObject8);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject9);var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);function PopupFailed(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,{style:props.style},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:props.onDismiss}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExclamationContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExclamationPoint,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Message,null,props.message),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"OK")),props.children))));}/* harmony default export */ __webpack_exports__["b"] = (PopupFailed);

/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(670),
    createBind = __webpack_require__(1587),
    createCurry = __webpack_require__(1588),
    createHybrid = __webpack_require__(672),
    createPartial = __webpack_require__(1599),
    getData = __webpack_require__(676),
    mergeData = __webpack_require__(1600),
    setData = __webpack_require__(678),
    setWrapToString = __webpack_require__(679),
    toInteger = __webpack_require__(421);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(254),
    baseLodash = __webpack_require__(419);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 419 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 420 */
/***/ (function(module, exports) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(1601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(1607),
    baseMatchesProperty = __webpack_require__(1610),
    identity = __webpack_require__(220),
    isArray = __webpack_require__(54),
    property = __webpack_require__(1612);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cancelSync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFrameData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hey_listen__ = __webpack_require__(140);


var prevTime = 0;
var onNextFrame = typeof window !== 'undefined' && window.requestAnimationFrame !== undefined
    ? function (callback) { return window.requestAnimationFrame(callback); }
    : function (callback) {
        var timestamp = Date.now();
        var timeToCall = Math.max(0, 16.7 - (timestamp - prevTime));
        prevTime = timestamp + timeToCall;
        setTimeout(function () { return callback(prevTime); }, timeToCall);
    };

var createStep = (function (setRunNextFrame) {
    var processToRun = [];
    var processToRunNextFrame = [];
    var numThisFrame = 0;
    var isProcessing = false;
    var i = 0;
    var cancelled = new WeakSet();
    var toKeepAlive = new WeakSet();
    var renderStep = {
        cancel: function (process) {
            var indexOfCallback = processToRunNextFrame.indexOf(process);
            cancelled.add(process);
            if (indexOfCallback !== -1) {
                processToRunNextFrame.splice(indexOfCallback, 1);
            }
        },
        process: function (frame) {
            var _a;
            isProcessing = true;
            _a = [
                processToRunNextFrame,
                processToRun
            ], processToRun = _a[0], processToRunNextFrame = _a[1];
            processToRunNextFrame.length = 0;
            numThisFrame = processToRun.length;
            if (numThisFrame) {
                var process_1;
                for (i = 0; i < numThisFrame; i++) {
                    process_1 = processToRun[i];
                    process_1(frame);
                    if (toKeepAlive.has(process_1) === true && !cancelled.has(process_1)) {
                        renderStep.schedule(process_1);
                        setRunNextFrame(true);
                    }
                }
            }
            isProcessing = false;
        },
        schedule: function (process, keepAlive, immediate) {
            Object(__WEBPACK_IMPORTED_MODULE_0_hey_listen__["a" /* invariant */])(typeof process === 'function', 'Argument must be a function');
            var addToCurrentBuffer = immediate && isProcessing;
            var buffer = addToCurrentBuffer ? processToRun : processToRunNextFrame;
            if (keepAlive)
                toKeepAlive.add(process);
            if (buffer.indexOf(process) === -1) {
                buffer.push(process);
                if (addToCurrentBuffer)
                    numThisFrame = processToRun.length;
            }
        }
    };
    return renderStep;
});

var StepId;
(function (StepId) {
    StepId["Read"] = "read";
    StepId["Update"] = "update";
    StepId["Render"] = "render";
    StepId["PostRender"] = "postRender";
    StepId["FixedUpdate"] = "fixedUpdate";
})(StepId || (StepId = {}));

var maxElapsed = 40;
var defaultElapsed = (1 / 60) * 1000;
var useDefaultElapsed = true;
var willRunNextFrame = false;
var isProcessing = false;
var frame = {
    delta: 0,
    timestamp: 0
};
var stepsOrder = [
    StepId.Read,
    StepId.Update,
    StepId.Render,
    StepId.PostRender
];
var setWillRunNextFrame = function (willRun) { return (willRunNextFrame = willRun); };
var _a = stepsOrder.reduce(function (acc, key) {
    var step = createStep(setWillRunNextFrame);
    acc.sync[key] = function (process, keepAlive, immediate) {
        if (keepAlive === void 0) { keepAlive = false; }
        if (immediate === void 0) { immediate = false; }
        if (!willRunNextFrame)
            startLoop();
        step.schedule(process, keepAlive, immediate);
        return process;
    };
    acc.cancelSync[key] = function (process) { return step.cancel(process); };
    acc.steps[key] = step;
    return acc;
}, {
    steps: {},
    sync: {},
    cancelSync: {}
}), steps = _a.steps, sync = _a.sync, cancelSync = _a.cancelSync;
var processStep = function (stepId) { return steps[stepId].process(frame); };
var processFrame = function (timestamp) {
    willRunNextFrame = false;
    frame.delta = useDefaultElapsed
        ? defaultElapsed
        : Math.max(Math.min(timestamp - frame.timestamp, maxElapsed), 1);
    if (!useDefaultElapsed)
        defaultElapsed = frame.delta;
    frame.timestamp = timestamp;
    isProcessing = true;
    stepsOrder.forEach(processStep);
    isProcessing = false;
    if (willRunNextFrame) {
        useDefaultElapsed = false;
        onNextFrame(processFrame);
    }
};
var startLoop = function () {
    willRunNextFrame = true;
    useDefaultElapsed = true;
    if (!isProcessing)
        onNextFrame(processFrame);
};
var getFrameData = function () { return frame; };

/* harmony default export */ __webpack_exports__["b"] = (sync);



/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return submitAppsFlyerParameters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}//брат сабзиро
/*
Приложение андроид которое просто показывает веб через вебвью, ему нужны параметры из AppsFlyer для трэкинга траффика
отправляется на апи для андроида
*/var ua=window.navigator.userAgent;var isWebView=/wvbo_full/g.test(ua);var isAnalyticsWebView=/wvbo/g.test(ua)&&!isWebView;var search=window.location.search.slice(1);var submitAppsFlyerParameters=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var parsedSearch,promiseTraffic,promiseAvd;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!((isAnalyticsWebView||isWebView)&&search!=null)){_context.next=8;break;}parsedSearch=__WEBPACK_IMPORTED_MODULE_1_querystring___default.a.parse(search);//мы просто подменим название ключа из урла вебвью на то которое просит бэкенд и отправим
promiseTraffic=Promise.resolve();promiseTraffic=Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["d" /* get */])("/api/setTrafficSource",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:"full_ref="+encodeURIComponent(search)+"&site_url="+encodeURIComponent(window.location.href)});promiseAvd=parsedSearch.apps_flyer_uid&&parsedSearch.android_advertising_id&&parsedSearch.application_fingerprint?Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["d" /* get */])("/api/android-adv-id",{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:__WEBPACK_IMPORTED_MODULE_1_querystring___default.a.stringify({appsflyer_id:parsedSearch.apps_flyer_uid,android_adv_id:parsedSearch.android_advertising_id,application_fingerprint:parsedSearch.application_fingerprint})}):null;_context.next=7;return Promise.all([promiseTraffic,promiseAvd]);case 7:return _context.abrupt("return",_context.sent);case 8:case"end":return _context.stop();}}},_callee,this);}));return function submitAppsFlyerParameters(){return _ref.apply(this,arguments);};}();

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getTimeUntilNextLockToggle;
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function stocksById(stocks,category){return stocks.reduce(function(result,stock){return Object.assign({},result,_defineProperty({},stock.stock,Object.assign({},stock,{category:category})));},{});}function receiveStockAssets(assets){if(typeof assets==="undefined"){throw new TypeError("Assets must be an object");}var categories=Object.keys(assets);return categories.reduce(function(result,category){return Object.assign({},result,stocksById(assets?assets[category]:[],category));},{});}function receiveSocketMessage(state,message){if(state==null){return state;}switch(message.op){case"percent-updated":{var prevStock=state[message.channel];if(prevStock==null){return state;}return Object.assign({},state,_defineProperty({},message.channel,Object.assign({},prevStock,{realProfit:message["profit-percent"]+prevStock.profit_vip})));}case"schedule-updated":return Object.assign({},state,_defineProperty({},message.channel,Object.assign({},state[message.channel],{enabled:message.enabled,state_changed_at:message.state_changed_at})));default:return state;}}function stocks(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_STOCK_ASSETS":return receiveStockAssets(action.payload);case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (stocks);function getTimeUntilNextLockToggle(time,stock){if(stock&&stock.state_changed_at!=null){return Math.max(0,stock.state_changed_at*1000-time);}else{return Infinity;}}

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getServerTime;
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function pushStockPoint(state,point){var currentPoints=state[point.stock]||[];var nextPoints=currentPoints.slice(-4*60*60);if(currentPoints.length>0){if(currentPoints[currentPoints.length-1].date>=point.date){// Пропускаем точки в той же дате и точки,
// не соотыветствующие порядку сортировки.
return state;}}nextPoints.push(point);return Object.assign({},state,_defineProperty({},point.stock,nextPoints));}function receiveSocketMessage(state,payload){switch(payload.op){case"stockPush":return pushStockPoint(state,{stock:payload.stock,date:payload.serverTime*1000,value:parseFloat(payload.value)});default:return state;}}function receiveStockHistory(state,payload){if((typeof payload==="undefined"?"undefined":_typeof(payload))!=="object"){throw new TypeError("Unexpected stock history payload");}var stock=payload.stock,history=payload.history;var pointsByDate=new Map();if(state[stock]){state[stock].forEach(function(point){pointsByDate.set(point.date,point);});}var dates=Object.keys(history);dates.forEach(function(date){// HACK: Чиним формат дат чтобы они корректно парсились в сафари
var correctDate=new Date(date.replace(" ","T")+"+00:00").valueOf();pointsByDate.set(correctDate,{stock:stock,date:correctDate,value:Number(history[date])});});var nextPoints=[].concat(_toConsumableArray(pointsByDate.values())).sort(function(a,b){return a.date-b.date;});return Object.assign({},state,_defineProperty({},stock,nextPoints));}function stocks(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"RECEIVE_STOCK_HISTORY":return receiveStockHistory(state,action.payload);case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (stocks);function getServerTime(activeStock,state){var points=state[activeStock];if(Array.isArray(points)&&points.length>0){var lastPoint=points[points.length-1];return lastPoint.date;}return null;}

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(5);
var connected=function connected(Component){return function(mapStateToProps,mapDispatchToProps){return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Component);};};/* harmony default export */ __webpack_exports__["a"] = (connected);

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StockMenu__ = __webpack_require__(1741);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__StockMenu__["a" /* default */]);

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CheckedIcon */
/* harmony export (immutable) */ __webpack_exports__["e"] = SwitchChartType;
/* harmony export (immutable) */ __webpack_exports__["h"] = SwitchLineThickness;
/* harmony export (immutable) */ __webpack_exports__["f"] = SwitchInterval;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivateIndicator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HorizontalLine; });
/* harmony export (immutable) */ __webpack_exports__["d"] = RemoveIndicators;
/* harmony export (immutable) */ __webpack_exports__["c"] = Remove;
/* harmony export (immutable) */ __webpack_exports__["i"] = SwitchSentiments;
/* harmony export (immutable) */ __webpack_exports__["g"] = SwitchLineColor;
/* harmony export (immutable) */ __webpack_exports__["k"] = SwitchTheme;
/* harmony export (immutable) */ __webpack_exports__["j"] = SwitchSound;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToggleTool__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HideTool__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LockTool__ = __webpack_require__(1747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup_ColorGrid__ = __webpack_require__(1748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popup_ThicknessGrid__ = __webpack_require__(1749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TradeModals_IntervalsModal__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Chart_NextGenChartMath__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  height: 20px;\n  width: 34px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"],["\n  height: 20px;\n  width: 34px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  height: ","px;\n  background-color: ",";\n  margin: auto;\n  border-radius: 5px;\n"],["\n  width: 100%;\n  height: ","px;\n  background-color: ",";\n  margin: auto;\n  border-radius: 5px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n  margin: 8px;\n"],["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  text-align: center;\n  margin: 8px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 9px;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  pointer-events: none;\n"],["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 9px;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  pointer-events: none;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: relative;\n  min-height: 30px;\n  padding: 5px 9px;\n  background-color: ",";\n  margin-bottom: 8px;\n  font-size: ",";\n  line-height: 14px;\n  color: #99959d;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  :focus {\n    color: ",";\n  }\n\n  :hover,\n  :active {\n    color: ",";\n  }\n\n  ",";\n"],["\n  position: relative;\n  min-height: 30px;\n  padding: 5px 9px;\n  background-color: ",";\n  margin-bottom: 8px;\n  font-size: ",";\n  line-height: 14px;\n  color: #99959d;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n\n  :focus {\n    color: ",";\n  }\n\n  :hover,\n  :active {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  padding-right: 35px;\n"],["\n  padding-right: 35px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  min-height: auto;\n  font-size: ",";\n  line-height: 16px;\n  background: transparent;\n\n  @media (max-width: 345px) {\n    align-self: flex-end;\n  }\n"],["\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  min-height: auto;\n  font-size: ",";\n  line-height: 16px;\n  background: transparent;\n\n  @media (max-width: 345px) {\n    align-self: flex-end;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  padding-left: 40px;\n  padding-right: 35px;\n"],["\n  padding-left: 40px;\n  padding-right: 35px;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  direction: ltr;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-content: space-between;\n  width: 100%;\n\n  :after {\n    content: \"\";\n    flex: 1;\n  }\n\n  @supports (display: grid) {\n    display: grid;\n    grid-template-columns: repeat(",", 1fr);\n    grid-column-gap: 8px;\n\n    :after {\n      display: none;\n    }\n\n    @media (max-width: 479px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n"],["\n  direction: ltr;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-content: space-between;\n  width: 100%;\n\n  :after {\n    content: \"\";\n    flex: 1;\n  }\n\n  @supports (display: grid) {\n    display: grid;\n    grid-template-columns: repeat(",", 1fr);\n    grid-column-gap: 8px;\n\n    :after {\n      display: none;\n    }\n\n    @media (max-width: 479px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 1;\n  flex-basis: calc(1 / 4 * 100% - (1 - 1 / 4) * 8px);\n  padding-left: 13px;\n  text-transform: lowercase;\n\n  :not(:nth-of-type(4n + 1)) {\n    margin-left: 8px;\n  }\n\n  @media (max-width: 479px) {\n    flex-basis: calc(1 / 2 * 100% - (1 - 1 / 2) * 8px);\n\n    :not(:nth-of-type(4n + 1)) {\n      margin-left: 0;\n    }\n    :not(:nth-of-type(2n + 1)) {\n      margin-left: 8px;\n    }\n  }\n\n  @supports (display: grid) {\n    :not(:nth-of-type(4n + 1)) {\n      margin-left: 0;\n    }\n    :not(:nth-of-type(2n + 1)) {\n      margin-left: 0;\n    }\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 1;\n  flex-basis: calc(1 / 4 * 100% - (1 - 1 / 4) * 8px);\n  padding-left: 13px;\n  text-transform: lowercase;\n\n  :not(:nth-of-type(4n + 1)) {\n    margin-left: 8px;\n  }\n\n  @media (max-width: 479px) {\n    flex-basis: calc(1 / 2 * 100% - (1 - 1 / 2) * 8px);\n\n    :not(:nth-of-type(4n + 1)) {\n      margin-left: 0;\n    }\n    :not(:nth-of-type(2n + 1)) {\n      margin-left: 8px;\n    }\n  }\n\n  @supports (display: grid) {\n    :not(:nth-of-type(4n + 1)) {\n      margin-left: 0;\n    }\n    :not(:nth-of-type(2n + 1)) {\n      margin-left: 0;\n    }\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding-left: 9px;\n\n  :focus {\n    color: ",";\n  }\n\n  :hover,\n  :active {\n    color: ",";\n  }\n\n  @media (hover: none) {\n    :focus,\n    :hover,\n    :active {\n      color: #99959d;\n    }\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding-left: 9px;\n\n  :focus {\n    color: ",";\n  }\n\n  :hover,\n  :active {\n    color: ",";\n  }\n\n  @media (hover: none) {\n    :focus,\n    :hover,\n    :active {\n      color: #99959d;\n    }\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  margin-right: ","px;\n  color: inherit;\n"],["\n  margin-right: ","px;\n  color: inherit;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 9px;\n  display: flex;\n  align-items: center;\n  color: rgb(153, 149, 157);\n"],["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  right: 9px;\n  display: flex;\n  align-items: center;\n  color: rgb(153, 149, 157);\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ",";\n\n  ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n      @media (min-width: 480px) {\n        height: 100%;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        flex-grow: 1;\n      }\n      @media (max-width: 479px) {\n        padding-top: 15px;\n      }\n    "],["\n      @media (min-width: 480px) {\n        height: 100%;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n        flex-grow: 1;\n      }\n      @media (max-width: 479px) {\n        padding-top: 15px;\n      }\n    "]),_templateObject18=_taggedTemplateLiteral(["\n      @media (min-width: 480px) {\n        flex-direction: row;\n        align-items: center;\n      }\n\n      @media (max-width: 479px) {\n        margin-top: 20px;\n      }\n    "],["\n      @media (min-width: 480px) {\n        flex-direction: row;\n        align-items: center;\n      }\n\n      @media (max-width: 479px) {\n        margin-top: 20px;\n      }\n    "]),_templateObject19=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  line-height: 1.5;\n  text-align: center;\n  color: ",";\n\n  @media (min-width: 480px) {\n    flex-grow: ",";\n    text-align: ",";\n  }\n  @media (max-width: 479px) {\n    padding-bottom: 15px;\n  }\n"],["\n  direction: ",";\n  font-size: ",";\n  line-height: 1.5;\n  text-align: center;\n  color: ",";\n\n  @media (min-width: 480px) {\n    flex-grow: ",";\n    text-align: ",";\n  }\n  @media (max-width: 479px) {\n    padding-bottom: 15px;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["\n  position: relative;\n  width: 20px;\n  height: 20px;\n  transition: all 0.3s ease;\n  pointer-events: none;\n  z-index: 1;\n"],["\n  position: relative;\n  width: 20px;\n  height: 20px;\n  transition: all 0.3s ease;\n  pointer-events: none;\n  z-index: 1;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  > div {\n    border-bottom: 1px solid #4c4555;\n  }\n\n  > div:first-of-type {\n    margin-top: -8px;\n  }\n\n  > div:last-of-type {\n    border-bottom: none;\n  }\n"],["\n  > div {\n    border-bottom: 1px solid #4c4555;\n  }\n\n  > div:first-of-type {\n    margin-top: -8px;\n  }\n\n  > div:last-of-type {\n    border-bottom: none;\n  }\n"]),_templateObject22=_taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: ",";\n  font-size: ",";\n  color: #99959d;\n"],["\n  display: flex;\n  width: 100%;\n  align-items: center;\n  justify-content: space-between;\n  padding-right: ",";\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject23=_taggedTemplateLiteral(["\n  direction: ltr;\n  display: flex;\n  align-items: center;\n  padding: ",";\n  cursor: pointer;\n  opacity: ",";\n"],["\n  direction: ltr;\n  display: flex;\n  align-items: center;\n  padding: ",";\n  cursor: pointer;\n  opacity: ",";\n"]),_templateObject24=_taggedTemplateLiteral(["\n  display: flex;\n"],["\n  display: flex;\n"]),_templateObject25=_taggedTemplateLiteral(["\n  width: 15px;\n  height: 15px;\n  margin-right: 8px;\n"],["\n  width: 15px;\n  height: 15px;\n  margin-right: 8px;\n"]),_templateObject26=_taggedTemplateLiteral(["\n  background-color: ",";\n"],["\n  background-color: ",";\n"]),_templateObject27=_taggedTemplateLiteral(["\n  background: linear-gradient(\n    to right,\n    "," 0%,\n    "," 50%,\n    "," 50.1%,\n    "," 100%\n  );\n"],["\n  background: linear-gradient(\n    to right,\n    "," 0%,\n    "," 50%,\n    "," 50.1%,\n    "," 100%\n  );\n"]),_templateObject28=_taggedTemplateLiteral(["\n  background: linear-gradient(\n    to right,\n    "," 0%,\n    "," 33.3%,\n    "," 33.4%,\n    "," 66.6%,\n    "," 67.7%,\n    "," 100%\n  );\n"],["\n  background: linear-gradient(\n    to right,\n    "," 0%,\n    "," 33.3%,\n    "," 33.4%,\n    "," 66.6%,\n    "," 67.7%,\n    "," 100%\n  );\n"]),_templateObject29=_taggedTemplateLiteral(["\n  margin-right: 5px;\n\n  ",";\n"],["\n  margin-right: 5px;\n\n  ",";\n"]),_templateObject30=_taggedTemplateLiteral(["\n      margin-right: 0;\n      margin-left: 5px;\n    "],["\n      margin-right: 0;\n      margin-left: 5px;\n    "]),_templateObject31=_taggedTemplateLiteral(["\n  padding-right: 10px;\n"],["\n  padding-right: 10px;\n"]),_templateObject32=_taggedTemplateLiteral(["\n  height: 24px;\n  margin: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n"],["\n  height: 24px;\n  margin: 4px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  align-items: center;\n"]),_templateObject33=_taggedTemplateLiteral(["Toggle"],["Toggle"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var CoolTool=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var CoolToolMool=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.width;},function(props){return props.color;});var EditLiner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var FlexContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Option=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.mainHighlight;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.accent;},function(props){return props.theme.accent;},function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,function(_ref3){var theme=_ref3.theme;return theme.accent;});});var ThemeOption=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Option)(_templateObject8);var RemoveIndicesOption=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Option)(_templateObject9,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});/* prettier-ignore */var ChartTypeOption=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Option)(_templateObject10);var OptionInlineContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,function(props){return props.col||4;});var OptionInline=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Option)(_templateObject12);var IndeciesOption=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Option)(_templateObject13,function(_ref5){var theme=_ref5.theme;return theme.foreground;},function(props){return props.theme.accent;});var IndeciesTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?24:0;});var ChosenSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var SwitchWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.sentimentsWrapper&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);},function(props){return props.chartWrapper&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject18);});var SwitchHeading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject19,function(props){return props.theme.direction;},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref8){var theme=_ref8.theme;return theme.foreground;},function(props){return props.theme.direction==="ltr"?1:0;},function(props){return props.theme.direction==="ltr"?"left":"right";});var Color=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20);var ActiveIndicators=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject21);var ActiveIndicator=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22,function(props){return props.noPadding?0:"9px";},function(_ref9){var theme=_ref9.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var IndicatorInfo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject23,function(props){return props.noPadding?0:"10px 5px";},function(props){return props.enabled?1:0.7;});var IndicatorControls=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject24);var Colors=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject25);var IndicatorColor=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Colors)(_templateObject26,function(props){return props.color;});var TwoColors=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Colors)(_templateObject27,function(props){return props.colors[0];},function(props){return props.colors[0];},function(props){return props.colors[1];},function(props){return props.colors[1];});var ThreeColors=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Colors)(_templateObject28,function(props){return props.colors[0];},function(props){return props.colors[0];},function(props){return props.colors[1];},function(props){return props.colors[1];},function(props){return props.colors[2];},function(props){return props.colors[2];});var RemoveText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject29,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject30);});var ActiveTools=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject31);var ActiveTool=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject32);var CheckedIcon=function CheckedIcon(_ref10){var style=_ref10.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"13",viewBox:"0 0 18 13",style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fillRule:"evenodd",fill:"currentColor",d:"M17.124,1.659 L7.379,11.404 L7.391,11.416 L6.239,12.568 L0.190,6.519 L1.342,5.367 L6.227,10.252 L15.973,0.507 L17.124,1.659 Z"}));};var ChosenOption=function ChosenOption(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenSvg,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CheckedIcon,null));};var ActiveItem=function ActiveItem(_ref11){var children=_ref11.children,inHead=_ref11.inHead,enabled=_ref11.enabled,toggleTitle=_ref11.toggleTitle,onRemove=_ref11.onRemove,onClick=_ref11.onClick,onToggle=_ref11.onToggle;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveIndicator,{noPadding:inHead},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorInfo,{enabled:enabled,onClick:onClick,noPadding:inHead},children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorControls,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HideTool__["a" /* default */],{value:enabled,onClick:onToggle,style:{marginRight:5,marginTop:-1}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Remove,{onClick:onRemove})));};// Каждый инструмент работает как контролируемый инпут.
// Нужно дать ему текущее значение и функцию чтобы его менять.
// Инструмент для смены типа графика
var CHART_TYPES=[{key:"line",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Zone Chart"),Icon:__WEBPACK_IMPORTED_MODULE_11__Icons__["d" /* ChartIconZone */]},{key:"candlestick",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Candlestick Chart"),Icon:__WEBPACK_IMPORTED_MODULE_11__Icons__["c" /* ChartIconCandlestick */]},{key:"bar",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Bars Chart"),Icon:__WEBPACK_IMPORTED_MODULE_11__Icons__["b" /* ChartIconBars */]}];function SwitchChartType(_ref12){var value=_ref12.value,onChange=_ref12.onChange,animated=_ref12.animated,onChangeAnimated=_ref12.onChangeAnimated;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,CHART_TYPES.map(function(tool){var title=tool.title,Icon=tool.Icon,key=tool.key;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartTypeOption,{key:key,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_12__GA__["a" /* gaReducer */])("CLICKBTN_CHART_TYPE",{buttonText:e.currentTarget.textContent});onChange(key);},isActive:value===key},Icon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{isActive:value===key,isTool:true}))," ",title,value===key&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenOption,null));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchWrapper,{chartWrapper:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchHeading,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Chart animation")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToggleTool__["a" /* default */],{value:animated,onChange:onChangeAnimated})));}// Инструмент выбора толщины линии
var LINE_THICKNESSES=[1,2,3,4,5];function SwitchLineThickness(_ref13){var value=_ref13.value,onChange=_ref13.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionInlineContainer,null,LINE_THICKNESSES.map(function(thickness){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionInline,{key:thickness,isActive:thickness===value,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_12__GA__["a" /* gaReducer */])("CLICKBTN_LINE",{buttonText:e.currentTarget.textContent});onChange(thickness);}},thickness,"px",thickness===value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenOption,null));}));}function SwitchInterval(_ref14){var value=_ref14.value,onChange=_ref14.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionInlineContainer,{col:3},__WEBPACK_IMPORTED_MODULE_9__TradeModals_IntervalsModal__["c" /* normalHistoryIntervals */].map(function(int){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionInline,{key:int,isActive:__WEBPACK_IMPORTED_MODULE_10__Chart_NextGenChartMath__["n" /* parseTime */](int)/1000===value,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_12__GA__["a" /* gaReducer */])("CLICKBTN_INTERVAL",{buttonText:e.currentTarget.textContent});onChange(__WEBPACK_IMPORTED_MODULE_10__Chart_NextGenChartMath__["n" /* parseTime */](int)/1000);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TradeModals_IntervalsModal__["a" /* HumanInterval */],null,int),__WEBPACK_IMPORTED_MODULE_10__Chart_NextGenChartMath__["n" /* parseTime */](int)/1000===value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenOption,null));}));}// Инструмент для активации индикаторов
var INDICATORS=[{key:"RSI",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"RSI (Relative Strength Index)"),displayColors:function displayColors(indicator){return[indicator.color];},displayInfo:function displayInfo(indicator){return"("+indicator.period+"; "+indicator.algorithm+") "+indicator.strokeWidth+"px";}},{key:"ATR",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"ATR (Average True Range)"),displayColors:function displayColors(indicator){return[indicator.color];},displayInfo:function displayInfo(indicator){return"("+indicator.period+") "+indicator.strokeWidth+"px";}},{key:"MACD",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"MACD"),displayColors:function displayColors(indicator){return indicator.likeAPro?[indicator.color]:[indicator.color,indicator.macdColor];},displayInfo:function displayInfo(indicator){return"("+indicator.fastPeriod+"; "+indicator.slowPeriod+"; "+indicator.period+") "+indicator.strokeWidth+"px "+(indicator.likeAPro?"":indicator.macdWidth+"px");}},{key:"HeikenAshi",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Heiken-Ashi"),displayColors:function displayColors(){return[];},displayInfo:function displayInfo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Heiken-Ashi");}},{key:"ROC",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"ROC (Rate of Change)"),displayColors:function displayColors(indicator){return[indicator.color];},displayInfo:function displayInfo(indicator){return"("+indicator.period+") "+indicator.strokeWidth+"px";}},{key:"Stoch",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Stochastic Oscillator"),displayColors:function displayColors(indicator){return[indicator.colorK,indicator.colorD];},displayInfo:function displayInfo(indicator){return"("+indicator.periodK+"; "+indicator.periodD+"; "+indicator.slowing+") "+indicator.strokeWidth+"px";}},{key:"MovingAverage",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Moving average"),displayColors:function displayColors(indicator){return[indicator.color];},displayInfo:function displayInfo(indicator){return"("+indicator.period+"; "+indicator.algorithm+") "+indicator.strokeWidth+"px";}},{key:"ParabolicSAR",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Parabolic SAR"),displayColors:function displayColors(indicator){return[indicator.color];},displayInfo:function displayInfo(indicator){return"("+indicator.accelerationStep+"; "+indicator.accelerationMaxValue+") "+indicator.size+"px";}},{key:"Alligator",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Alligator"),displayColors:function displayColors(indicator){return[indicator.jaws.color,indicator.teeths.color,indicator.lips.color];},displayInfo:function displayInfo(indicator){return"("+indicator.jaws.period+"; "+indicator.teeths.period+"; "+indicator.lips.period+") "+indicator.jaws.strokeWidth+"px "+indicator.teeths.strokeWidth+"px "+indicator.lips.strokeWidth+"px";}},{key:"BollingerLines",title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Bollinger Lines"),displayColors:function displayColors(indicator){return[indicator.upper.color,indicator.middle.color,indicator.lower.color];},displayInfo:function displayInfo(indicator){return"("+indicator.upper.period+"; "+indicator.upper.rejection+") "+indicator.upper.strokeWidth+"px "+indicator.middle.strokeWidth+"px "+indicator.lower.strokeWidth+"px";}}];var ActivateIndicatorWithoutGettext=function(_Component){_inherits(ActivateIndicatorWithoutGettext,_Component);function ActivateIndicatorWithoutGettext(){_classCallCheck(this,ActivateIndicatorWithoutGettext);return _possibleConstructorReturn(this,(ActivateIndicatorWithoutGettext.__proto__||Object.getPrototypeOf(ActivateIndicatorWithoutGettext)).apply(this,arguments));}_createClass(ActivateIndicatorWithoutGettext,[{key:"render",value:function render(){var _this2=this;var HeikenTools=void 0;var heikenIndex=this.props.indicators.findIndex(function(indicator){return indicator.type==="HeikenAshi";});var heiken=heikenIndex>-1&&this.props.indicators[heikenIndex];if(heiken){HeikenTools=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveItem,{key:heikenIndex,enabled:heiken.enabled!==false,toggleTitle:this.props.gettext(_templateObject33),onClick:function onClick(){return _this2.props.handlePopupOpen("HeikenAshi",heiken);},onToggle:function onToggle(){return _this2.props.onToggle(heikenIndex);},onRemove:function onRemove(){return _this2.props.onRemove(heikenIndex);},inHead:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Heiken-Ashi"));}return INDICATORS.map(function(indicator,index){var key=indicator.key,title=indicator.title,displayColors=indicator.displayColors,displayInfo=indicator.displayInfo;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndeciesOption,{key:key,active:false,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_12__GA__["a" /* gaReducer */])("CLICKBTN_INDICATOR",{buttonText:e.currentTarget.textContent});return _this2.props.handlePopupOpen(key);}},key==="HeikenAshi"&&heiken?HeikenTools:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndeciesTitle,null,title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenSvg,{as:__WEBPACK_IMPORTED_MODULE_11__Icons__["a" /* AddIcon */]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveIndicators,null,_this2.props.indicators.map(function(indicator,id){return Object.assign({},indicator,{id:id});}).filter(function(indicator){return key!=="HeikenAshi"&&indicator.type===key;}).map(function(indicator,index){var ColorsIcon=void 0;var colors=displayColors(indicator);switch(colors.length){case 1:ColorsIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndicatorColor,{color:colors[0]});break;case 2:ColorsIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TwoColors,{colors:colors});break;case 3:ColorsIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThreeColors,{colors:colors});break;default:ColorsIcon=null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveItem,{key:index,enabled:indicator.enabled!==false,toggleTitle:_this2.props.gettext(_templateObject33),onClick:function onClick(){return _this2.props.handlePopupOpen(key,indicator);},onToggle:function onToggle(){return _this2.props.onToggle(indicator.id);},onRemove:function onRemove(){return _this2.props.onRemove(indicator.id);}},ColorsIcon,displayInfo(indicator));})));});}}]);return ActivateIndicatorWithoutGettext;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ActivateIndicator=Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["g" /* withGettext */])(ActivateIndicatorWithoutGettext);var HorizontalLine=function HorizontalLine(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndeciesOption,{onClick:props.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IndeciesTitle,null,props.graphicalMode.graphicalTool?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Click somewhere on the chart"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FlexContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons__["i" /* HorizontalLineIcon */],{isActive:true,isChartButton:true,style:{marginRight:10,pointerEvents:"none"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Add line"))),props.graphicalMode.graphicalTool?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenSvg,{as:__WEBPACK_IMPORTED_MODULE_11__Icons__["f" /* DeleteIcon */]}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenSvg,{as:__WEBPACK_IMPORTED_MODULE_11__Icons__["a" /* AddIcon */]})),props.editMode!=null?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EditLiner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Edit line"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons__["f" /* DeleteIcon */],{onClick:function onClick(){return props.onToolCoolClick();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Popup_ColorGrid__["a" /* default */],{value:props.editMode.tool.color,onChange:function onChange(color){return props.dispatch({type:"UPDATE_GRAPHICAL_TOOL",payload:{stock:props.editMode.tool.stock,index:props.editMode.index,color:color}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Popup_ThicknessGrid__["a" /* default */],{value:props.editMode.tool.width,color:props.editMode.tool.color,onChange:function onChange(width){return props.dispatch({type:"UPDATE_GRAPHICAL_TOOL",payload:{stock:props.editMode.tool.stock,index:props.editMode.index,width:width}});}})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Scrollable__["a" /* default */],{style:{maxHeight:228}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveTools,null,props.tools.map(function(tool,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActiveTool,{key:index},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CoolTool,{onClick:function onClick(){return props.onToolCoolClick(tool,index);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CoolToolMool,{color:tool.color,width:tool.width})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__LockTool__["a" /* default */],{value:tool.locked===true,onClick:function onClick(value){return props.dispatch({type:"UPDATE_GRAPHICAL_TOOL",payload:{stock:tool.stock,index:index,locked:value}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HideTool__["a" /* default */],{value:tool.enabled!==false,onClick:function onClick(value){return props.dispatch({type:"UPDATE_GRAPHICAL_TOOL",payload:{stock:tool.stock,index:index,enabled:value}});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Remove,{onClick:function onClick(){return props.dispatch({type:"REMOVE_GRAPHICAL_TOOL",payload:{stock:tool.stock,index:index}});}}));}))));};// Инструмент для выпила индикаторов
function RemoveIndicators(props){if(props.indicators&&props.indicators.length>0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemoveIndicesOption,{key:"rmv-all",onClick:props.onRemoveAll},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemoveText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Remove all")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons__["A" /* TrashIcon */],null));}else{return null;}}function Remove(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RemoveIndicesOption,{onClick:props.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons__["A" /* TrashIcon */],null));}function SwitchSentiments(_ref15){var value=_ref15.value,onChange=_ref15.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchWrapper,{sentimentsWrapper:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchHeading,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Show indicator")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToggleTool__["a" /* default */],{value:value,onChange:onChange}));}function SwitchLineColor(_ref16){var value=_ref16.value,onChange=_ref16.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionInlineContainer,null,["#feac00","#00fe83","#00cbfe","#fe00e9","#fe003c","#39ae00","#a100fe","#fe4e00","#afafaf",theme.foreground].map(function(color){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionInline,{key:color,isActive:color===value,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_12__GA__["a" /* gaReducer */])("CLICKBTN_SETTINGS_COLOR");return onChange(color);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Color,{style:{backgroundColor:color}}),color===value&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenOption,null));}));});}// Инструмент выбора темы
var THEMES=[{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Main"),key:"default"},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Light"),key:"light"},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Rich blue"),key:"richblue"}];function SwitchTheme(_ref17){var value=_ref17.value,onChange=_ref17.onChange;return THEMES.map(function(theme){var isActive=theme.key===value;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ThemeOption,{key:theme.key,isActive:isActive,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_12__GA__["a" /* gaReducer */])("CLICKBTN_THEME",{buttonText:e.currentTarget.textContent});onChange(theme.key);}},theme.title,isActive&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChosenOption,null));});}function SwitchSound(_ref18){var value=_ref18.value,onChange=_ref18.onChange;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchWrapper,{sentimentsWrapper:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchHeading,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Use sound effects to indicate different actions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToggleTool__["a" /* default */],{value:value,onChange:onChange}));}// // инструмент фуллскрина
// export function ToggleFullscreen({ value, onClick }: ToolProps<number>) {
//   return (
//     <SwitchWrapper>
//       <ToggleSwitch value={value} onClick={onClick} />
//     </SwitchWrapper>
//   );
// }
// // Инструмент для смены языка
// const LANGUAGES = [
//   {
//     locale: "en",
//     title: "English"
//   },
//   {
//     locale: "th",
//     title: "Tiếng Thái"
//   }
// ];
//
// export function SwitchLanguage({ value, onChange }: ToolProps<string>) {
//   const languages = LANGUAGES.map(language =>
//     <Option
//       active={language.locale === value}
//       onClick={() => {
//         onChange(language.locale);
//       }}
//     >
//       {language.title}
//     </Option>
//   );
//
//   return (
//     <DropdownTool Icon={LanguageIcon} title={<Gettext>Language</Gettext>}>
//       {() => <div>{languages}</div>}
//     </DropdownTool>
//   );
// }
// // Инструмент для включения/выключения звука
// export function SwitchSound({ value, onChange }: ToolProps<boolean>) {
//   const icon = value
//     ? <SoundIcon onClick={() => onChange(false)} />
//     : <SoundIconMute onClick={() => onChange(true)} />;
//
//   return <ToggleTool>{icon}</ToggleTool>;
// }

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ClickOutside__ = __webpack_require__(58);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: bottom;\n  width: 104px;\n  padding: 0 6px;\n  box-sizing: border-box;\n  text-align: left;\n\n  @media(max-width: 639px) {\n    width: 79px;\n  }\n\n  @media(max-width: 567px) {\n    width: 69px;\n  }\n"],["\n  display: inline-block;\n  vertical-align: bottom;\n  width: 104px;\n  padding: 0 6px;\n  box-sizing: border-box;\n  text-align: left;\n\n  @media(max-width: 639px) {\n    width: 79px;\n  }\n\n  @media(max-width: 567px) {\n    width: 69px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  box-sizing: border-box;\n  height: 29px;\n  border: 1px solid ",";\n  border-radius: 3px;\n  font-weight: 300;\n  font-size: ",";\n  font-family: Roboto, Arial, sans-serif;\n  line-height: 27px;\n  color: ",";\n  padding: 0px;\n  background-color: ",";\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAYAAACXU8ZrAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAACpJREFUCJljnDl17n8GAoCJgYGBkYAaRiYYA5cCmEkMOBTC+Uw4JFA0AAADHALciUEQ5gAAAABJRU5ErkJggg==');\n  background-position: calc(100% - 7px) 11px;\n  background-size: 9px 5px;\n  background-repeat: no-repeat;\n  box-shadow: inset 0px 2px 0px 0px rgba(0,0,0,.15);\n"],["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  box-sizing: border-box;\n  height: 29px;\n  border: 1px solid ",";\n  border-radius: 3px;\n  font-weight: 300;\n  font-size: ",";\n  font-family: Roboto, Arial, sans-serif;\n  line-height: 27px;\n  color: ",";\n  padding: 0px;\n  background-color: ",";\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAYAAACXU8ZrAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAACpJREFUCJljnDl17n8GAoCJgYGBkYAaRiYYA5cCmEkMOBTC+Uw4JFA0AAADHALciUEQ5gAAAABJRU5ErkJggg==');\n  background-position: calc(100% - 7px) 11px;\n  background-size: 9px 5px;\n  background-repeat: no-repeat;\n  box-shadow: inset 0px 2px 0px 0px rgba(0,0,0,.15);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 0 7px;\n\n  :hover {\n    background-color: ",";\n  }\n"],["\n  cursor: pointer;\n  padding: 0 7px;\n\n  :hover {\n    background-color: ",";\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  top: 25px;\n  left: 50%;\n  box-sizing: border-box;\n  padding: 2px 0 0;\n  transform: translateX(-50%);\n  width: calc(100% + 2px);\n  max-height: 200px;\n  overflow: auto;\n  background-color: ",";\n  border: 1px solid ",";\n  border-top: none;\n  border-radius: 0 0 3px 3px;\n  z-index: 250;\n"],["\n  display: block;\n  position: absolute;\n  top: 25px;\n  left: 50%;\n  box-sizing: border-box;\n  padding: 2px 0 0;\n  transform: translateX(-50%);\n  width: calc(100% + 2px);\n  max-height: 200px;\n  overflow: auto;\n  background-color: ",";\n  border: 1px solid ",";\n  border-top: none;\n  border-radius: 0 0 3px 3px;\n  z-index: 250;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  top: -1px;\n  width: 15px;\n  height: 15px;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  position: relative;\n  top: -1px;\n  width: 15px;\n  height: 15px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0 7px;\n"],["\n  margin: 0;\n  padding: 0 7px;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  direction: ",";\n  margin: 5px 0;\n  padding: 0;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n\n  ",";\n"],["\n  direction: ",";\n  margin: 5px 0;\n  padding: 0;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n    text-align: right;\n  "],["\n    text-align: right;\n  "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SelectContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var SelectView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.borderMainColor;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(props){return props.theme.mainHighlight;});var Option=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].li(_templateObject3,function(props){return props.theme.mainDark;});var OptionContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].ul(_templateObject4,function(props){return props.theme.mainHighlight;},function(props){return props.theme.borderMainColor;});var ColorSwatch=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5);var Selected=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject6);var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.theme.direction;},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});function Color(_ref4){var children=_ref4.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ColorSwatch,{style:{backgroundColor:children}});}function Pixels(_ref5){var children=_ref5.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,children," px");}var Select=function(_React$Component){_inherits(Select,_React$Component);function Select(){var _ref6;var _temp,_this,_ret;_classCallCheck(this,Select);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref6=Select.__proto__||Object.getPrototypeOf(Select)).call.apply(_ref6,[this].concat(args))),_this),_this.state={isOpen:false},_this.open=function(e){e.preventDefault();e.stopPropagation();_this.setState({isOpen:true});},_this.close=function(e){e.preventDefault();e.stopPropagation();_this.setState({isOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Select,[{key:"render",value:function render(){var _this2=this;var _props=this.props,type=_props.type,name=_props.name,label=_props.label,value=_props.value,values=_props.values,onChange=_props.onChange,width=_props.width;var Value="span";switch(type){case"color":Value=Color;break;case"pixels":Value=Pixels;break;default:break;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectContainer,{width:width},label&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Label,null,label,":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Selected,{onClick:this.open},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Value,null,value)),this.state.isOpen&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_ClickOutside__["a" /* default */],{onOutsideClick:this.close},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OptionContainer,{type:type},values.map(function(value){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Option,{type:type,key:value,onClick:function onClick(){return _this2.setState({isOpen:false},function(){return onChange({target:{name:name,value:value}});});}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Value,{active:value===_this2.props.value},value));})))));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HumanInterval;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalHistoryIntervals; });
/* unused harmony export isShortHistoryIntervals */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_candle_arrow_svg__ = __webpack_require__(1750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_candle_arrow_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_candle_arrow_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__ = __webpack_require__(110);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 20000;\n  overflow: auto;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 0;\n  background-color: rgba(0, 0, 0, 0.4);\n  z-index: 20000;\n  overflow: auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n"],["\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n  min-height: 100%;\n  height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  overflow: hidden;\n  background-color: ",";\n"],["\n  position: relative;\n  max-width: 100%;\n  width: 100%;\n  min-height: 100%;\n  height: 100%;\n  margin: 0 auto;\n  text-align: center;\n  overflow: hidden;\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: ",";\n  right: 12px;\n  width: 20px;\n  height: 20px;\n  color: #96949b;\n  transition: color 0.15s ease;\n  cursor: pointer;\n\n  :hover {\n    color: #60a31c;\n  }\n"],["\n  position: absolute;\n  top: ",";\n  right: 12px;\n  width: 20px;\n  height: 20px;\n  color: #96949b;\n  transition: color 0.15s ease;\n  cursor: pointer;\n\n  :hover {\n    color: #60a31c;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: calc(100% + 30px);\n  min-height: 45px;\n  margin-left: -15px;\n  margin-right: -15px;\n  padding-left: 15px;\n  padding-right: 40px;\n  background-color: ",";\n  border-bottom: 1px solid ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: calc(100% + 30px);\n  min-height: 45px;\n  margin-left: -15px;\n  margin-right: -15px;\n  padding-left: 15px;\n  padding-right: 40px;\n  background-color: ",";\n  border-bottom: 1px solid ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 16px;\n  color: ",";\n"],["\n  font-weight: 400;\n  font-size: 16px;\n  color: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 100%;\n  padding: 0 15px 10px 15px;\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  min-height: 100%;\n  padding: 0 15px 10px 15px;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  bottom: 100%;\n  width: 312px;\n  margin-bottom: 10px;\n  padding: 10px 12px;\n  transform: translateX(-50%);\n  background-color: ",";\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  z-index: 5;\n"],["\n  position: absolute;\n  left: 50%;\n  bottom: 100%;\n  width: 312px;\n  margin-bottom: 10px;\n  padding: 10px 12px;\n  transform: translateX(-50%);\n  background-color: ",";\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  z-index: 5;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  padding-left: 8px;\n  padding-right: 25px;\n  padding-bottom: 10px;\n  text-align: left;\n  border-bottom: 1px solid ",";\n\n  @media (max-width: 959px) {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    min-height: 38px;\n    padding-bottom: 0;\n  }\n"],["\n  margin-bottom: 8px;\n  padding-left: 8px;\n  padding-right: 25px;\n  padding-bottom: 10px;\n  text-align: left;\n  border-bottom: 1px solid ",";\n\n  @media (max-width: 959px) {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    width: 100%;\n    min-height: 38px;\n    padding-bottom: 0;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2;\n  color: #feac00;\n"],["\n  font-size: ",";\n  line-height: 1.2;\n  color: #feac00;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n"],["\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  width: 288px;\n  height: ",";\n  margin-bottom: 5px;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media (min-width: 420px) {\n    width: 388px;\n    height: ",";\n  }\n\n  @media (min-width: 520px) {\n    width: 488px;\n    height: 152px;\n    height: ",";\n  }\n\n  @media (min-width: 960px) {\n    width: 288px;\n    height: 228px;\n    height: ",";\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  width: 288px;\n  height: ",";\n  margin-bottom: 5px;\n  margin-left: auto;\n  margin-right: auto;\n\n  @media (min-width: 420px) {\n    width: 388px;\n    height: ",";\n  }\n\n  @media (min-width: 520px) {\n    width: 488px;\n    height: 152px;\n    height: ",";\n  }\n\n  @media (min-width: 960px) {\n    width: 288px;\n    height: 228px;\n    height: ",";\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  min-width: 88px;\n  width: 88px;\n  height: 30px;\n  margin-right: 12px;\n  margin-bottom: 8px;\n  padding: 0;\n  padding-left: 12px;\n  padding-right: 26px;\n  font-size: ",";\n  color: #99959d;\n  text-align: left;\n  text-transform: lowercase;\n  background-color: ",";\n  border: none;\n  cursor: pointer;\n\n  :hover {\n    color: #feac00;\n  }\n\n  ",";\n"],["\n  min-width: 88px;\n  width: 88px;\n  height: 30px;\n  margin-right: 12px;\n  margin-bottom: 8px;\n  padding: 0;\n  padding-left: 12px;\n  padding-right: 26px;\n  font-size: ",";\n  color: #99959d;\n  text-align: left;\n  text-transform: lowercase;\n  background-color: ",";\n  border: none;\n  cursor: pointer;\n\n  :hover {\n    color: #feac00;\n  }\n\n  ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n      color: ",";\n      background-image: url(",");\n      background-repeat: no-repeat;\n      background-position: 62px 50%;\n    "],["\n      color: ",";\n      background-image: url(",");\n      background-repeat: no-repeat;\n      background-position: 62px 50%;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  margin-left: auto;\n  margin-right: auto;\n  color: ",";\n  text-align: left;\n\n  @media (min-width: 420px) {\n    width: 388px;\n  }\n\n  @media (min-width: 520px) {\n    width: 488px;\n  }\n\n  @media (min-width: 960px) {\n    width: auto;\n  }\n"],["\n  display: flex;\n  justify-content: space-between;\n  margin-left: auto;\n  margin-right: auto;\n  color: ",";\n  text-align: left;\n\n  @media (min-width: 420px) {\n    width: 388px;\n  }\n\n  @media (min-width: 520px) {\n    width: 488px;\n  }\n\n  @media (min-width: 960px) {\n    width: auto;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  flex-basis: 17px;\n  width: 17px;\n  min-width: 17px;\n  height: 17px;\n  margin-top: -2px;\n  margin-right: 7px;\n  line-height: 0;\n\n  > svg {\n    flex-basis: 17px;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n  }\n"],["\n  flex-basis: 17px;\n  width: 17px;\n  min-width: 17px;\n  height: 17px;\n  margin-top: -2px;\n  margin-right: 7px;\n  line-height: 0;\n\n  > svg {\n    flex-basis: 17px;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  width: calc(100% - 26px);\n  font-size: ",";\n  line-height: 18px;\n\n  > p {\n    max-width: 500px;\n  }\n"],["\n  width: calc(100% - 26px);\n  font-size: ",";\n  line-height: 18px;\n\n  > p {\n    max-width: 500px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InfoSvg=function InfoSvg(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"2294.453 672.95 16 16",width:"16",height:"16",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M2302.508 672.95a8.056 8.056 0 1 0 8.055 8.056 8.059 8.059 0 0 0-8.055-8.056zm-1 4.04h2.009v1.974h-2.01v-1.974zm2.981 7.97h-3.989v-1h1v-2.952h-1v-1h3.011v3.954h.972v1z"}));};var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var PopupTable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].table(_templateObject2);var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.popupBackground;});var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.desktop?"9px":"12px";});var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.theme.popupDarkBackground;},function(props){return props.theme.mainSeparator;});var HeaderTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref){var theme=_ref.theme;return theme.foreground;});var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var CandleModal=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(props){return props.theme.popupBackground;});var CandleTitleContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(props){return props.theme.mainSeparator;});var CandleTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject10,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var CandleText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject11,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref4){var theme=_ref4.theme;return theme.secondaryTextColor;});var CandleItems=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(props){return props.short?"76px":"228px";},function(props){return props.short?"64px":"190px";},function(props){return props.short?"51px":"152px";},function(props){return props.short?"76px":"228px";});var CandleItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject13,function(_ref5){var theme=_ref5.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.popupDarkBackground;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14,function(_ref6){var theme=_ref6.theme;return theme.foreground;},__WEBPACK_IMPORTED_MODULE_4__images_candle_arrow_svg___default.a);});var CandleInfo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,function(_ref7){var theme=_ref7.theme;return theme.secondaryTextColor;});var InfoIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16);var InfoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject17,function(_ref8){var theme=_ref8.theme;return theme.locale==="ar"?theme.minFontSize:"11px";});/* prettier-ignore */var candleIntervals={"5s":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"5\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"sec")),"10s":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"10\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"sec")),"15s":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"15\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"sec")),"30s":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"30\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"sec")),"1m":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"1\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min")),"2m":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"2\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min")),"5m":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"5\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min")),"10m":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"10\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min")),"15m":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"15\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min")),"30m":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"30\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min")),"1h":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"1\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"hour")),"2h":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"2\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"hour")),"4h":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"4\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"hours")),"8h":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"8\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"hours")),"12h":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"12\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"hours")),"1D":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"1\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Day")),"1W":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"1\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"week")),"1M":__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"1\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Month"))};function HumanInterval(props){return candleIntervals[props.children]||props.children;}var normalHistoryIntervals=Object.keys(candleIntervals);var isShortHistoryIntervals=normalHistoryIntervals.slice(0,6);function DesktopModal(props){var intervals=__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)?isShortHistoryIntervals:normalHistoryIntervals;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleModal,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleTitleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleTitle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Time interval"))," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"only for bars & candles")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:props.onToggle,desktop:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21.414 21.414"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{stroke:"currentColor",strokeWidth:"2",x2:"20",y2:"20"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{stroke:"currentColor",strokeWidth:"2",x1:"20",y2:"20"}))))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleItems,{short:__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)},intervals.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleItem,{key:item,active:item===__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["o" /* stringifyTime */](props.value),onClick:function onClick(){return props.onChange(__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["n" /* parseTime */](item));}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HumanInterval,null,item));})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleInfo,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoIcon,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoSvg,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The top and bottom of each bar/candle indicate the highest and lowest prices of an instrument for a specified period of time. The opening and closing prices are displayed on the left and right side of a bar.")))));}function MobileModal(props){var intervals=__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)?isShortHistoryIntervals:normalHistoryIntervals;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PopupTable,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{verticalAlign:"middle"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:props.onToggle},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21.414 21.414"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{stroke:"currentColor",strokeWidth:"2",x2:"20",y2:"20"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{stroke:"currentColor",strokeWidth:"2",x1:"20",y2:"20"})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderTitle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Interval selection"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleTitleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleTitle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Time interval"))," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"only for bars & candles")))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleItems,{short:__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)},intervals.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleItem,{key:item,active:item===__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["o" /* stringifyTime */](props.value),onClick:function onClick(){return props.onChange(__WEBPACK_IMPORTED_MODULE_5__Chart_NextGenChartMath__["n" /* parseTime */](item));}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HumanInterval,null,item));}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleInfo,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoIcon,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoSvg,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("p",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The top and bottom of each bar/candle indicate the highest and lowest prices of an instrument for a specified period of time. The opening and closing prices are displayed on the left and right side of a bar.")))))))))));}function IntervalsModal(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DesktopModal,props):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MobileModal,props);});}/* harmony default export */ __webpack_exports__["b"] = (IntervalsModal);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function() {
  var getNanoSeconds, hrtime, loadTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(185)))

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(584)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(279));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
})), 'RefreshOutlined');

exports.default = _default;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = toCss;

var _toCssValue = __webpack_require__(282);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';
  for (var index = 0; index < indent; index++) {
    result += '  ';
  }return result + str;
}

/**
 * Converts a Rule to CSS string.
 */

function toCss(selector, style) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var result = '';

  if (!style) return result;

  var _options$indent = options.indent,
      indent = _options$indent === undefined ? 0 : _options$indent;
  var fallbacks = style.fallbacks;


  indent++;

  // Apply fallbacks first.
  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];
        for (var prop in fallback) {
          var value = fallback[prop];
          if (value != null) {
            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];
        if (_value != null) {
          result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];
    if (_value2 != null && _prop2 !== 'fallbacks') {
      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
    }
  }

  // Allow empty style in this case, because properties will be added dynamically.
  if (!result && !options.allowEmpty) return result;

  indent--;
  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);

  return result;
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SheetsRegistry = __webpack_require__(699);

var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */
exports['default'] = new _SheetsRegistry2['default']();

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInBrowser = __webpack_require__(284);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var js = ''; /**
              * Export javascript style and css style vendor prefixes.
              * Based on "transform" support test.
              */

var css = '';

// We should not do anything if required serverside.
if (_isInBrowser2['default']) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    // IE did it wrong again ...
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  }
}

/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String}}
 * @api public
 */
exports['default'] = { js: js, css: css };

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _utils = __webpack_require__(209);

var _utils2 = _interopRequireDefault(_utils);

var _scrollSpy = __webpack_require__(442);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(286);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(711);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (y) {

      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var to = _this2.props.to;
      var element = null;
      var elemTopBound = 0;
      var elemBottomBound = 0;
      var containerTop = 0;

      if (scrollSpyContainer.getBoundingClientRect) {
        var containerCords = scrollSpyContainer.getBoundingClientRect();
        containerTop = containerCords.top;
      }

      if (!element || _this2.props.isDynamic) {
        element = scroller.get(to);
        if (!element) {
          return;
        }

        var cords = element.getBoundingClientRect();
        elemTopBound = cords.top - containerTop + y;
        elemBottomBound = elemTopBound + cords.height;
      }

      var offsetY = y - _this2.props.offset;
      var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
      var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          _scrollHash2.default.changeHash();
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(1854);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(443);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(210);


/* harmony default export */ __webpack_exports__["a"] = (function(values, p, valueof) {
  if (valueof == null) valueof = __WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */];
  if (!(n = values.length)) return;
  if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
  if (p >= 1) return +valueof(values[n - 1], n - 1, values);
  var n,
      i = (n - 1) * p,
      i0 = Math.floor(i),
      value0 = +valueof(values[i0], i0, values),
      value1 = +valueof(values[i0 + 1], i0 + 1, values);
  return value0 + (value1 - value0) * (i - i0);
});


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefix; });
var prefix = "$";

function Map() {}

Map.prototype = map.prototype = {
  constructor: Map,
  has: function(key) {
    return (prefix + key) in this;
  },
  get: function(key) {
    return this[prefix + key];
  },
  set: function(key, value) {
    this[prefix + key] = value;
    return this;
  },
  remove: function(key) {
    var property = prefix + key;
    return property in this && delete this[property];
  },
  clear: function() {
    for (var property in this) if (property[0] === prefix) delete this[property];
  },
  keys: function() {
    var keys = [];
    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
    return keys;
  },
  values: function() {
    var values = [];
    for (var property in this) if (property[0] === prefix) values.push(this[property]);
    return values;
  },
  entries: function() {
    var entries = [];
    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
    return entries;
  },
  size: function() {
    var size = 0;
    for (var property in this) if (property[0] === prefix) ++size;
    return size;
  },
  empty: function() {
    for (var property in this) if (property[0] === prefix) return false;
    return true;
  },
  each: function(f) {
    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
  }
};

function map(object, f) {
  var map = new Map;

  // Copy constructor.
  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });

  // Index array by numeric index or specified key function.
  else if (Array.isArray(object)) {
    var i = -1,
        n = object.length,
        o;

    if (f == null) while (++i < n) map.set(i, object[i]);
    else while (++i < n) map.set(f(o = object[i], i, object), o);
  }

  // Convert object to map.
  else if (object) for (var key in object) map.set(key, object[key]);

  return map;
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rgb__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__array__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__date__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__number__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__object__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__string__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__constant__ = __webpack_require__(737);









/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var t = typeof b, c;
  return b == null || t === "boolean" ? Object(__WEBPACK_IMPORTED_MODULE_7__constant__["a" /* default */])(b)
      : (t === "number" ? __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */]
      : t === "string" ? ((c = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */])(b)) ? (b = c, __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]) : __WEBPACK_IMPORTED_MODULE_6__string__["a" /* default */])
      : b instanceof __WEBPACK_IMPORTED_MODULE_0_d3_color__["a" /* color */] ? __WEBPACK_IMPORTED_MODULE_1__rgb__["a" /* default */]
      : b instanceof Date ? __WEBPACK_IMPORTED_MODULE_3__date__["a" /* default */]
      : Array.isArray(b) ? __WEBPACK_IMPORTED_MODULE_2__array__["a" /* default */]
      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? __WEBPACK_IMPORTED_MODULE_5__object__["a" /* default */]
      : __WEBPACK_IMPORTED_MODULE_4__number__["a" /* default */])(a, b);
});


/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Color;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return darker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return brighter; });
/* harmony export (immutable) */ __webpack_exports__["e"] = color;
/* harmony export (immutable) */ __webpack_exports__["h"] = rgbConvert;
/* harmony export (immutable) */ __webpack_exports__["g"] = rgb;
/* harmony export (immutable) */ __webpack_exports__["b"] = Rgb;
/* unused harmony export hslConvert */
/* harmony export (immutable) */ __webpack_exports__["f"] = hsl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(449);


function Color() {}

var darker = 0.7;
var brighter = 1 / darker;

var reI = "\\s*([+-]?\\d+)\\s*",
    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
    reHex3 = /^#([0-9a-f]{3})$/,
    reHex6 = /^#([0-9a-f]{6})$/,
    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");

var named = {
  aliceblue: 0xf0f8ff,
  antiquewhite: 0xfaebd7,
  aqua: 0x00ffff,
  aquamarine: 0x7fffd4,
  azure: 0xf0ffff,
  beige: 0xf5f5dc,
  bisque: 0xffe4c4,
  black: 0x000000,
  blanchedalmond: 0xffebcd,
  blue: 0x0000ff,
  blueviolet: 0x8a2be2,
  brown: 0xa52a2a,
  burlywood: 0xdeb887,
  cadetblue: 0x5f9ea0,
  chartreuse: 0x7fff00,
  chocolate: 0xd2691e,
  coral: 0xff7f50,
  cornflowerblue: 0x6495ed,
  cornsilk: 0xfff8dc,
  crimson: 0xdc143c,
  cyan: 0x00ffff,
  darkblue: 0x00008b,
  darkcyan: 0x008b8b,
  darkgoldenrod: 0xb8860b,
  darkgray: 0xa9a9a9,
  darkgreen: 0x006400,
  darkgrey: 0xa9a9a9,
  darkkhaki: 0xbdb76b,
  darkmagenta: 0x8b008b,
  darkolivegreen: 0x556b2f,
  darkorange: 0xff8c00,
  darkorchid: 0x9932cc,
  darkred: 0x8b0000,
  darksalmon: 0xe9967a,
  darkseagreen: 0x8fbc8f,
  darkslateblue: 0x483d8b,
  darkslategray: 0x2f4f4f,
  darkslategrey: 0x2f4f4f,
  darkturquoise: 0x00ced1,
  darkviolet: 0x9400d3,
  deeppink: 0xff1493,
  deepskyblue: 0x00bfff,
  dimgray: 0x696969,
  dimgrey: 0x696969,
  dodgerblue: 0x1e90ff,
  firebrick: 0xb22222,
  floralwhite: 0xfffaf0,
  forestgreen: 0x228b22,
  fuchsia: 0xff00ff,
  gainsboro: 0xdcdcdc,
  ghostwhite: 0xf8f8ff,
  gold: 0xffd700,
  goldenrod: 0xdaa520,
  gray: 0x808080,
  green: 0x008000,
  greenyellow: 0xadff2f,
  grey: 0x808080,
  honeydew: 0xf0fff0,
  hotpink: 0xff69b4,
  indianred: 0xcd5c5c,
  indigo: 0x4b0082,
  ivory: 0xfffff0,
  khaki: 0xf0e68c,
  lavender: 0xe6e6fa,
  lavenderblush: 0xfff0f5,
  lawngreen: 0x7cfc00,
  lemonchiffon: 0xfffacd,
  lightblue: 0xadd8e6,
  lightcoral: 0xf08080,
  lightcyan: 0xe0ffff,
  lightgoldenrodyellow: 0xfafad2,
  lightgray: 0xd3d3d3,
  lightgreen: 0x90ee90,
  lightgrey: 0xd3d3d3,
  lightpink: 0xffb6c1,
  lightsalmon: 0xffa07a,
  lightseagreen: 0x20b2aa,
  lightskyblue: 0x87cefa,
  lightslategray: 0x778899,
  lightslategrey: 0x778899,
  lightsteelblue: 0xb0c4de,
  lightyellow: 0xffffe0,
  lime: 0x00ff00,
  limegreen: 0x32cd32,
  linen: 0xfaf0e6,
  magenta: 0xff00ff,
  maroon: 0x800000,
  mediumaquamarine: 0x66cdaa,
  mediumblue: 0x0000cd,
  mediumorchid: 0xba55d3,
  mediumpurple: 0x9370db,
  mediumseagreen: 0x3cb371,
  mediumslateblue: 0x7b68ee,
  mediumspringgreen: 0x00fa9a,
  mediumturquoise: 0x48d1cc,
  mediumvioletred: 0xc71585,
  midnightblue: 0x191970,
  mintcream: 0xf5fffa,
  mistyrose: 0xffe4e1,
  moccasin: 0xffe4b5,
  navajowhite: 0xffdead,
  navy: 0x000080,
  oldlace: 0xfdf5e6,
  olive: 0x808000,
  olivedrab: 0x6b8e23,
  orange: 0xffa500,
  orangered: 0xff4500,
  orchid: 0xda70d6,
  palegoldenrod: 0xeee8aa,
  palegreen: 0x98fb98,
  paleturquoise: 0xafeeee,
  palevioletred: 0xdb7093,
  papayawhip: 0xffefd5,
  peachpuff: 0xffdab9,
  peru: 0xcd853f,
  pink: 0xffc0cb,
  plum: 0xdda0dd,
  powderblue: 0xb0e0e6,
  purple: 0x800080,
  rebeccapurple: 0x663399,
  red: 0xff0000,
  rosybrown: 0xbc8f8f,
  royalblue: 0x4169e1,
  saddlebrown: 0x8b4513,
  salmon: 0xfa8072,
  sandybrown: 0xf4a460,
  seagreen: 0x2e8b57,
  seashell: 0xfff5ee,
  sienna: 0xa0522d,
  silver: 0xc0c0c0,
  skyblue: 0x87ceeb,
  slateblue: 0x6a5acd,
  slategray: 0x708090,
  slategrey: 0x708090,
  snow: 0xfffafa,
  springgreen: 0x00ff7f,
  steelblue: 0x4682b4,
  tan: 0xd2b48c,
  teal: 0x008080,
  thistle: 0xd8bfd8,
  tomato: 0xff6347,
  turquoise: 0x40e0d0,
  violet: 0xee82ee,
  wheat: 0xf5deb3,
  white: 0xffffff,
  whitesmoke: 0xf5f5f5,
  yellow: 0xffff00,
  yellowgreen: 0x9acd32
};

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Color, color, {
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: function() {
    return this.rgb().hex();
  },
  toString: function() {
    return this.rgb() + "";
  }
});

function color(format) {
  var m;
  format = (format + "").trim().toLowerCase();
  return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
      : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
      : named.hasOwnProperty(format) ? rgbn(named[format])
      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
      : null;
}

function rgbn(n) {
  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}

function rgba(r, g, b, a) {
  if (a <= 0) r = g = b = NaN;
  return new Rgb(r, g, b, a);
}

function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb;
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}

function rgb(r, g, b, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}

function Rgb(r, g, b, opacity) {
  this.r = +r;
  this.g = +g;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Rgb, rgb, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return (0 <= this.r && this.r <= 255)
        && (0 <= this.g && this.g <= 255)
        && (0 <= this.b && this.b <= 255)
        && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: function() {
    return "#" + hex(this.r) + hex(this.g) + hex(this.b);
  },
  toString: function() {
    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(")
        + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
        + Math.max(0, Math.min(255, Math.round(this.b) || 0))
        + (a === 1 ? ")" : ", " + a + ")");
  }
}));

function hex(value) {
  value = Math.max(0, Math.min(255, Math.round(value) || 0));
  return (value < 16 ? "0" : "") + value.toString(16);
}

function hsla(h, s, l, a) {
  if (a <= 0) h = s = l = NaN;
  else if (l <= 0 || l >= 1) h = s = NaN;
  else if (s <= 0) h = NaN;
  return new Hsl(h, s, l, a);
}

function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl;
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      min = Math.min(r, g, b),
      max = Math.max(r, g, b),
      h = NaN,
      s = max - min,
      l = (max + min) / 2;
  if (s) {
    if (r === max) h = (g - b) / s + (g < b) * 6;
    else if (g === max) h = (b - r) / s + 2;
    else h = (r - g) / s + 4;
    s /= l < 0.5 ? max + min : 2 - max - min;
    h *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h;
  }
  return new Hsl(h, s, l, o.opacity);
}

function hsl(h, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}

function Hsl(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hsl, hsl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(Color, {
  brighter: function(k) {
    k = k == null ? brighter : Math.pow(brighter, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? darker : Math.pow(darker, k);
    return new Hsl(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = this.h % 360 + (this.h < 0) * 360,
        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
        l = this.l,
        m2 = l + (l < 0.5 ? l : 1 - l) * s,
        m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
      hsl2rgb(h, m1, m2),
      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
        && (0 <= this.l && this.l <= 1)
        && (0 <= this.opacity && this.opacity <= 1);
  }
}));

/* From FvD 13.37, CSS Color Module Level 3 */
function hsl2rgb(h, m1, m2) {
  return (h < 60 ? m1 + (m2 - m1) * h / 60
      : h < 180 ? m2
      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
      : m1) * 255;
}


/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = extend;
/* harmony default export */ __webpack_exports__["a"] = (function(constructor, factory, prototype) {
  constructor.prototype = factory.prototype = prototype;
  prototype.constructor = constructor;
});

function extend(parent, definition) {
  var prototype = Object.create(parent.prototype);
  for (var key in definition) prototype[key] = definition[key];
  return prototype;
}


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = basis;
function basis(t1, v0, v1, v2, v3) {
  var t2 = t1 * t1, t3 = t2 * t1;
  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
      + (4 - 6 * t2 + 3 * t3) * v1
      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
      + t3 * v3) / 6;
}

/* harmony default export */ __webpack_exports__["b"] = (function(values) {
  var n = values.length - 1;
  return function(t) {
    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
        v1 = values[i],
        v2 = values[i + 1],
        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
    return basis((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimal(1.23) returns ["123", 0].
/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
  var i, coefficient = x.slice(0, i);

  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x.slice(i + 1)
  ];
});


/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(454);
/* unused harmony reexport timeFormatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"]; });
/* unused harmony reexport timeParse */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b"]; });
/* unused harmony reexport utcParse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(749);
/* unused harmony reexport timeFormatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isoFormat__ = __webpack_require__(750);
/* unused harmony reexport isoFormat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isoParse__ = __webpack_require__(1942);
/* unused harmony reexport isoParse */






/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeFormat; });
/* unused harmony export timeParse */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcFormat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcParse; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(749);


var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;

defaultLocale({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  timeFormat = locale.format;
  timeParse = locale.parse;
  utcFormat = locale.utcFormat;
  utcParse = locale.utcParse;
  return locale;
}


/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(456);





/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function line(data) {
    var i,
        n = data.length,
        d,
        defined0 = false,
        buffer;

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x(d, i, data), +y(d, i, data));
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  line.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : x;
  };

  line.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), line) : y;
  };

  line.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), line) : defined;
  };

  line.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
  };

  line.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
  };

  return line;
});


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = x;
/* harmony export (immutable) */ __webpack_exports__["b"] = y;
function x(p) {
  return p[0];
}

function y(p) {
  return p[1];
}


/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = point;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(294);



function point(that, x, y) {
  var x1 = that._x1,
      y1 = that._y1,
      x2 = that._x2,
      y2 = that._y2;

  if (that._l01_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
  }

  if (that._l23_a > __WEBPACK_IMPORTED_MODULE_0__math__["f" /* epsilon */]) {
    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
  }

  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}

function CatmullRom(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRom.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x2, this._y2); break;
      case 3: this.point(this._x2, this._y2); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; // proceed
      default: point(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRom(context, alpha) : new __WEBPACK_IMPORTED_MODULE_1__cardinal__["a" /* Cardinal */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = sum;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(217);


/* harmony default export */ __webpack_exports__["a"] = (function(series) {
  var sums = series.map(sum);
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[a] - sums[b]; });
});

function sum(series) {
  var s = 0, i = -1, n = series.length, v;
  while (++i < n) if (v = +series[i][1]) s += v;
  return s;
}


/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HorizontalTicks;
/* harmony export (immutable) */ __webpack_exports__["b"] = VerticalTicks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time_format__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time__ = __webpack_require__(212);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  right: 3px;\n  left: 0px;\n  height: 24px;\n  padding-right: 30px;\n  background-color: ",";\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    left: 28px;\n    right: 30px;\n    bottom: 0px;\n    border-bottom: 1px solid ",";\n  }\n"],["\n  position: absolute;\n  top: 0px;\n  right: 3px;\n  left: 0px;\n  height: 24px;\n  padding-right: 30px;\n  background-color: ",";\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    left: 28px;\n    right: 30px;\n    bottom: 0px;\n    border-bottom: 1px solid ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  padding-left: 0;\n  padding-right: 0;\n\n  &:after {\n    left: 0;\n    right: 0;\n    border-bottom-color: ",";\n  }\n"],["\n  width: 100%;\n  padding-left: 0;\n  padding-right: 0;\n\n  &:after {\n    left: 0;\n    right: 0;\n    border-bottom-color: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: ",";\n"],["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  top: auto;\n  bottom: 0px;\n  height: 43px;\n\n  &:after {\n    top: 0px;\n    bottom: auto;\n  }\n"],["\n  top: auto;\n  bottom: 0px;\n  height: 43px;\n\n  &:after {\n    top: 0px;\n    bottom: auto;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  right: 50px;\n  bottom: 0px;\n  width: 120px;\n"],["\n  position: absolute;\n  top: 0px;\n  right: 50px;\n  bottom: 0px;\n  width: 120px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 120px;\n  height: 24px;\n  color: ",";\n  font-size: ",";\n  line-height: 20px;\n  user-select: none;\n"],["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 120px;\n  height: 24px;\n  color: ",";\n  font-size: ",";\n  line-height: 20px;\n  user-select: none;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-left: -60px;\n  text-align: center;\n\n  &:after {\n    position: absolute;\n    left: 50%;\n    bottom: 1px;\n    display: block;\n    width: 1px;\n    height: 2px;\n    background-color: ",";\n    content: \"\";\n  }\n"],["\n  margin-left: -60px;\n  text-align: center;\n\n  &:after {\n    position: absolute;\n    left: 50%;\n    bottom: 1px;\n    display: block;\n    width: 1px;\n    height: 2px;\n    background-color: ",";\n    content: \"\";\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  margin-top: 5px;\n  font-size: ",";\n  color: ",";\n\n  &:after {\n    bottom: 6px;\n    background-color: ",";\n  }\n"],["\n  margin-top: 5px;\n  font-size: ",";\n  color: ",";\n\n  &:after {\n    bottom: 6px;\n    background-color: ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  line-height: 30px;\n  margin-left: -60px;\n  text-align: center;\n\n  &:after {\n    position: absolute;\n    left: 50%;\n    top: 0px;\n    bottom: auto;\n    display: block;\n    width: 1px;\n    height: 2px;\n    background-color: ",";\n    content: \"\";\n  }\n"],["\n  line-height: 30px;\n  margin-left: -60px;\n  text-align: center;\n\n  &:after {\n    position: absolute;\n    left: 50%;\n    top: 0px;\n    bottom: auto;\n    display: block;\n    width: 1px;\n    height: 2px;\n    background-color: ",";\n    content: \"\";\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  text-align: right;\n"],["\n  text-align: right;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* prettier-ignore */var formatMillisecond=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])(".%L"),formatSecond=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%H:%M:%S"),formatMinute=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%H:%M"),formatHour=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%H:%M"),formatDay=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%d/%m"),formatWeek=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%d/%m"),formatMonth=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%B %Y"),formatYear=Object(__WEBPACK_IMPORTED_MODULE_2_d3_time_format__["a" /* timeFormat */])("%Y");/* prettier-ignore */function multiFormat(date){return(__WEBPACK_IMPORTED_MODULE_3_d3_time__["g" /* timeSecond */](date)<date?formatMillisecond:__WEBPACK_IMPORTED_MODULE_3_d3_time__["d" /* timeMinute */](date)<date?formatSecond:__WEBPACK_IMPORTED_MODULE_3_d3_time__["b" /* timeHour */](date)<date?formatMinute:__WEBPACK_IMPORTED_MODULE_3_d3_time__["a" /* timeDay */](date)<date?formatHour:__WEBPACK_IMPORTED_MODULE_3_d3_time__["f" /* timeMonth */](date)<date?__WEBPACK_IMPORTED_MODULE_3_d3_time__["j" /* timeWeek */](date)<date?formatDay:formatWeek:__WEBPACK_IMPORTED_MODULE_3_d3_time__["k" /* timeYear */](date)<date?formatMonth:formatYear)(date);}var HorizontalContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.main;},function(props){return props.theme.ticksBorderColor;});var MobileHorizontalContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(HorizontalContainer)(_templateObject2,function(props){return props.theme.ticksBorderColor;});var HorizontalInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.main;});var HorizontalContainerBottom=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(HorizontalContainer)(_templateObject4);var VerticalContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);/*const MobileVerticalContainer = styled(VerticalContainer)`
  right: 21px;
`;*/var Tick=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.ticksFontColor;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?"11px":"11px";});var HorizontalTick=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Tick)(_templateObject7,function(props){return props.theme.ticksBorderColor;});var MobileHorizontalTick=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(HorizontalTick)(_templateObject8,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?"10px":"10px";},function(props){return props.theme.ticksFontColor;},function(props){return props.theme.ticksBorderColor;});var HorizontalTickBottom=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Tick)(_templateObject9,function(props){return props.theme.ticksBorderColor;});var VerticalTick=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Tick)(_templateObject10);/*const MobileVerticalTick = styled(VerticalTick)`
  font-size: ${({theme}) => theme.locale === "ar" ? "10px" : "10px"};
`;*/var Ticks=function(_React$Component){_inherits(Ticks,_React$Component);function Ticks(){_classCallCheck(this,Ticks);return _possibleConstructorReturn(this,(Ticks.__proto__||Object.getPrototypeOf(Ticks)).apply(this,arguments));}_createClass(Ticks,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){// console.log(nextProps);
//return +nextProps.ticks[0] !== +this.props.ticks[0];
return true;}},{key:"render",value:function render(){var _this2=this;var Component=this.props.component;return this.props.ticks.map(function(tick){return{value:tick,x:_this2.props.scaleX(tick)};}).filter(function(tick,index,ticks){return index===ticks.length-1||tick.x!==ticks[index+1].x;}).map(function(tick){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,{key:+tick.value,style:{left:Math.floor(tick.x)-_this2.props.offset+"px"}},multiFormat(tick.value));});}}]);return Ticks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function HorizontalTicks(props){var offset=Math.floor(props.scaleX(props.ticks[0]));if(props.mobile){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MobileHorizontalContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{position:"relative",willChange:"transform",WebkitTransform:"translateX("+offset+"px",transform:"translateX("+offset+"px"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Ticks,{component:MobileHorizontalTick,offset:offset,scaleX:props.scaleX,ticks:props.ticks}))));}return[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalContainer,{key:"top",style:{cursor:"default",zIndex:2}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{position:"relative",//willChange: "transform",
WebkitTransform:"translateX("+offset+"px",transform:"translateX("+offset+"px"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Ticks,{component:HorizontalTick,offset:offset,scaleX:props.scaleX,ticks:props.ticks})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalContainerBottom,{key:"bottom",style:{cursor:"default",zIndex:2}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{position:"relative",//willChange: "transform",
WebkitTransform:"translateX("+offset+"px",transform:"translateX("+offset+"px"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Ticks,{component:HorizontalTickBottom,offset:offset,scaleX:props.scaleX,ticks:props.ticks}))))];}function VerticalTicks(_ref3){var scaleY=_ref3.scaleY,ticks=_ref3.ticks,mobile=_ref3.mobile;if(mobile){return null;/*const visuals = ticks.map(tick => (
      <MobileVerticalTick
        key={tick}
        style={{
          WebkitTransform: `translateY(${scaleY(tick).toFixed(2)}px`,
          transform: `translateY(${scaleY(tick).toFixed(2)}px`
        }}
      >
        {`${Math.round(tick * 10000) / 10000}`}
      </MobileVerticalTick>
    ));

    return <MobileVerticalContainer>{visuals}</MobileVerticalContainer>;*/}var visuals=ticks.map(function(tick){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerticalTick,{key:tick,style:{WebkitTransform:"translateY("+scaleY(tick).toFixed(2)+"px",transform:"translateY("+scaleY(tick).toFixed(2)+"px"}},""+Math.round(tick*10000)/10000);});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerticalContainer,null,visuals);}

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Path__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextGenChartTypes__ = __webpack_require__(45);
/**
 * The chart
 * 
 */var Curve=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(_ref){var data=_ref.data,displayGradient=_ref.displayGradient,width=_ref.width,height=_ref.height,scaleX=_ref.scaleX,scaleY=_ref.scaleY,strokeWidth=_ref.strokeWidth,color=_ref.color;var id=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){var i=Math.random().toString(36).slice(2,8);return i;},[]);if(data.length<2){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{id:id,gradientUnits:"userSpaceOnUse",x1:"0%",y1:"0%",x2:"0%",y2:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"0%",stopColor:color,stopOpacity:0.25}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"100%",stopColor:color,stopOpacity:0}))),displayGradient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Path__["a" /* default */],{data:data,curved:false,shadow:true,viewportWidth:width,viewportHeight:height,fill:"url(#"+id+")"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Path__["a" /* default */],{data:data,curved:false,shadow:false,viewportWidth:width,viewportHeight:height,stroke:color,strokeWidth:strokeWidth}));});/* harmony default export */ __webpack_exports__["a"] = (Curve);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SocialTradingContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_SocialTrading__ = __webpack_require__(775);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n  color: ",";\n  background-color: ",";\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 210;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 30px;\n  margin-right: 10px;\n  color: ",";\n  background-color: ",";\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  z-index: 210;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SocialTradingContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"]([false,function(){}]);var SocialTradingIcon=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Icons_SocialTrading__["a" /* default */])(_templateObject);var Button=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].button(_templateObject2,function(_ref){var theme=_ref.theme,isOpen=_ref.isOpen;return isOpen?"#fff":Object(__WEBPACK_IMPORTED_MODULE_1_polished__["a" /* rgba */])(theme.foreground,0.5);},function(_ref2){var theme=_ref2.theme,isOpen=_ref2.isOpen;return isOpen?theme.bottomNavigationBg:Object(__WEBPACK_IMPORTED_MODULE_1_polished__["a" /* rgba */])("#919191",0.59);},function(_ref3){var theme=_ref3.theme,isOpen=_ref3.isOpen;return isOpen?"#fff":theme.foreground;});var ToggleSocial=function ToggleSocial(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{className:props.className,as:props.as,isOpen:props.isOpen,onClick:props.onClick,replace:props.replace,to:props.to},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SocialTradingIcon,{width:"18px"}));};/* harmony default export */ __webpack_exports__["b"] = (ToggleSocial);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OfflineBadge; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  background: rgb(189, 59, 59);\n  color: white;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 5px;\n  border-radius: 5px;\n  z-index: 9999;\n\n  @media (min-width: 960px) {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n"],["\n  position: absolute;\n  top: 5px;\n  right: 10px;\n  background: rgb(189, 59, 59);\n  color: white;\n  font-size: 9px;\n  font-weight: 700;\n  padding: 5px;\n  border-radius: 5px;\n  z-index: 9999;\n\n  @media (min-width: 960px) {\n    font-size: 12px;\n    padding: 5px 10px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StyledBadge=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var OfflineBadge=function OfflineBadge(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledBadge,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"You are currently offline"));};var OnLine=function OnLine(props){var onStatusChange=function onStatusChange(){if(typeof props.onChange==="function"){props.onChange(window.navigator.onLine);}};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){window.addEventListener("online",onStatusChange);return function(){return window.removeEventListener("online",onStatusChange);};});Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){window.addEventListener("offline",onStatusChange);return function(){return window.removeEventListener("offline",onStatusChange);};});if(window.navigator.onLine===undefined)return null;return typeof props.children==="function"?props.children(window.navigator.onLine):null;};/* harmony default export */ __webpack_exports__["b"] = (OnLine);

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TableItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_SocialTrading__ = __webpack_require__(775);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 0 14px;\n  padding-bottom: 12px;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 0 14px;\n  padding-bottom: 12px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-bottom: 5px;\n  color: #feac00;\n"],["\n  margin-bottom: 5px;\n  color: #feac00;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-bottom: 5px;\n  font-size: ",";\n  color: ",";\n"],["\n  margin-bottom: 5px;\n  font-size: ",";\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #99959d;\n"],["\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  flex-grow: 2;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"],["\n  flex-grow: 2;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 30px;\n  padding: 0 16px 0 21px;\n  background-color: ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  min-height: 30px;\n  padding: 0 16px 0 21px;\n  background-color: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  font-size: ",";\n  color: #99959d;\n  box-sizing: border-box;\n\n  ",";\n\n  &:not(:last-of-type) {\n    ",";\n  }\n\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  font-size: ",";\n  color: #99959d;\n  box-sizing: border-box;\n\n  ",";\n\n  &:not(:last-of-type) {\n    ",";\n  }\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "],["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "]),_templateObject9=_taggedTemplateLiteral(["\n          display: flex;\n          flex-flow: row nowrap;\n          align-items: center;\n          min-width: 98px;\n        "],["\n          display: flex;\n          flex-flow: row nowrap;\n          align-items: center;\n          min-width: 98px;\n        "]),_templateObject10=_taggedTemplateLiteral(["\n          min-width: 45px;\n        "],["\n          min-width: 45px;\n        "]),_templateObject11=_taggedTemplateLiteral(["\n          flex-grow: 1;\n          ",";\n        "],["\n          flex-grow: 1;\n          ",";\n        "]),_templateObject12=_taggedTemplateLiteral([""],[""]),_templateObject13=_taggedTemplateLiteral(["\n  flex-grow: 2;\n"],["\n  flex-grow: 2;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: 4px;\n  margin: 2px;\n  background-color: #feac00;\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  width: 4px;\n  margin: 2px;\n  background-color: #feac00;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  padding: 0 16px;\n"],["\n  padding: 0 16px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16),function(_ref){var theme=_ref.theme;return theme.foreground;});var Subtitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(12));var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var TableHeader=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?theme.background:theme.mainDark;}));var TableItem=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(10),function(_ref3){var theme=_ref3.theme;return theme.locale!=="ar"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);},Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("margin-right","10px"),function(_ref4){var column=_ref4.column;switch(column){case"assets":return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);case"trader":return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);case"profit":return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("text-align","right"));default:return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);}}));var Scrollable=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Scrollable__["a" /* default */])(_templateObject13);var Bar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var Sidebar=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](function(_ref5){var children=_ref5.children,hide=_ref5.hide;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_SocialTrading__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Successful traders")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Subtitle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Trader activity in real time"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Table,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableHeader,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableItem,{column:"assets"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Assets")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableItem,{column:"trader"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"trader")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableItem,{column:"profit"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"PROFIT"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Scrollable,{bar:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bar,null)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](List,null,children))),hide);});/* harmony default export */ __webpack_exports__["b"] = (Sidebar);

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AmountIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DealsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArrowIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SettingsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TradingHistoryIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var AmountIcon=function AmountIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"15",viewBox:"0 0 18 15",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M7.032,1.953V1.7A0.759,0.759,0,0,0,6.275.944H3.754A0.759,0.759,0,0,0,3,1.7V1.953H0V3.97H3V4.223a0.759,0.759,0,0,0,.756.756H6.275a0.759,0.759,0,0,0,.756-0.756V3.97H17.953V1.953H7.032ZM4.006,3.97V1.953H6.023V3.97H4.006Zm6.931,2.983V6.7a0.759,0.759,0,0,1,.757-0.756h2.522a0.759,0.759,0,0,1,.756.756V6.953h2.995V8.97H14.972V9.222a0.759,0.759,0,0,1-.756.757H11.693a0.759,0.759,0,0,1-.757-0.757V8.97H0.016V6.953H10.937ZM13.963,8.97V6.953H11.946V8.97h2.017ZM7.032,11.953V11.7a0.759,0.759,0,0,0-.756-0.757H3.754A0.759,0.759,0,0,0,3,11.7v0.252H0V13.97H3v0.252a0.759,0.759,0,0,0,.756.756H6.275a0.759,0.759,0,0,0,.756-0.756V13.97H17.953V11.953H7.032ZM4.006,13.97V11.953H6.023V13.97H4.006Z"}));};var DealsIcon=function DealsIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"24",viewBox:"0 0 24 24",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2.928,3.634V0.706a0.732,0.732,0,0,1,1.464,0V3.634A0.732,0.732,0,0,1,2.928,3.634Zm11.4,0.732a0.731,0.731,0,0,0,.732-0.732V0.706a0.732,0.732,0,1,0-1.464,0V3.634A0.731,0.731,0,0,0,14.33,4.366ZM23.421,17.54a5.855,5.855,0,1,1-5.855-5.855A5.856,5.856,0,0,1,23.421,17.54Zm-1.464,0a4.391,4.391,0,1,0-4.392,4.392A4.4,4.4,0,0,0,21.957,17.54ZM1.441,16.355V6.446H16.526v3.775H17.99V4.512A1.6,1.6,0,0,0,16.4,2.9h-0.61V3.634a1.464,1.464,0,0,1-2.928,0V2.9H5.123V3.634a1.464,1.464,0,1,1-2.928,0V2.9H1.586A1.6,1.6,0,0,0,0,4.512V16.355a1.6,1.6,0,0,0,1.586,1.61h8.661V16.5H1.564A0.139,0.139,0,0,1,1.441,16.355Zm18.466-.49a0.551,0.551,0,0,0-.78,0l-1.95,1.95-1.17-1.17a0.551,0.551,0,1,0-.78.78l1.56,1.56a0.551,0.551,0,0,0,.78,0l2.339-2.339A0.551,0.551,0,0,0,19.907,15.864ZM3.384,8.573V7.854H14.413V8.573H3.384Zm0,2.156V10.01H14.413v0.719H3.384Zm0,2.178V12.188h8.243v0.719H3.384Zm0,2.156V14.344H10.19v0.719H3.384Z"}));};var ArrowIcon=function ArrowIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"10",height:"7",viewBox:"0 0 10 7",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5,6.609L9.9,1.715l-1.4-1.4L5,3.818l-3.5-3.5-1.4,1.4L4.986,6.609,5,6.6Z"}));};var SettingsIcon=function SettingsIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"15",viewBox:"0 0 18 15",fillRule:"evenodd",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M14.972,8.970 L14.972,9.222 C14.972,9.639 14.631,9.979 14.215,9.979 L11.693,9.979 C11.277,9.979 10.937,9.639 10.937,9.222 L10.937,8.970 L0.015,8.970 L0.015,6.953 L10.937,6.953 L10.937,6.701 C10.937,6.285 11.277,5.944 11.693,5.944 L14.215,5.944 C14.631,5.944 14.972,6.285 14.972,6.701 L14.972,6.953 L17.966,6.953 L17.966,8.970 L14.972,8.970 ZM13.963,6.953 L11.946,6.953 L11.946,8.970 L13.963,8.970 L13.963,6.953 ZM7.032,4.222 C7.032,4.639 6.691,4.979 6.275,4.979 L3.754,4.979 C3.338,4.979 2.997,4.639 2.997,4.222 L2.997,3.970 L0.002,3.970 L0.002,1.953 L2.997,1.953 L2.997,1.701 C2.997,1.285 3.338,0.944 3.754,0.944 L6.275,0.944 C6.691,0.944 7.032,1.285 7.032,1.701 L7.032,1.953 L17.953,1.953 L17.953,3.970 L7.032,3.970 L7.032,4.222 ZM6.023,1.953 L4.006,1.953 L4.006,3.970 L6.023,3.970 L6.023,1.953 ZM2.997,11.701 C2.997,11.285 3.338,10.944 3.754,10.944 L6.275,10.944 C6.691,10.944 7.032,11.285 7.032,11.701 L7.032,11.953 L17.953,11.953 L17.953,13.970 L7.032,13.970 L7.032,14.222 C7.032,14.639 6.691,14.979 6.275,14.979 L3.754,14.979 C3.338,14.979 2.997,14.639 2.997,14.222 L2.997,13.970 L0.002,13.970 L0.002,11.953 L2.997,11.953 L2.997,11.701 ZM4.006,13.970 L6.023,13.970 L6.023,11.953 L4.006,11.953 L4.006,13.970 Z"}));};var TradingHistoryIcon=function TradingHistoryIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 22.417 23.425"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"currentColor",d:"M94.563,189.4a5.855,5.855,0,1,1,5.856-5.855,5.855,5.855,0,0,1-5.856,5.855Zm0-10.249a4.393,4.393,0,1,0,4.392,4.393,4.393,4.393,0,0,0-4.392-4.393Zm1.944,5.9h-2a.546.546,0,0,1-.551-.552v-2.975a.551.551,0,0,1,1.1,0v2.424h1.446a.552.552,0,0,1,0,1.1Zm-2.981-12.608H79.443v9.911a.133.133,0,0,0,.118.142h7.688v1.464H79.585A1.6,1.6,0,0,1,78,182.355V170.512a1.6,1.6,0,0,1,1.583-1.612h.61v.735a1.464,1.464,0,1,0,2.928,0V168.9h6.745v.735a1.464,1.464,0,1,0,2.928,0V168.9h.6a1.6,1.6,0,0,1,1.588,1.612v5.708H93.524v-3.776Zm-2.193-2.081a.73.73,0,0,1-.735-.729v-2.928a.732.732,0,1,1,1.464,0v2.928a.728.728,0,0,1-.729.729Zm-9.673,0a.729.729,0,0,1-.729-.729v-2.928a.729.729,0,1,1,1.458,0v2.928a.728.728,0,0,1-.729.729ZM81.007,181v-1h1v1Zm0-6v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1ZM82.975,181v-1h1v1Zm0-6v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1ZM85.008,181v-1h1v1Zm0-6v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1Zm2,2.027v-1H88v1Zm0-6v-1H88v1Zm0,2v-1H88v1Zm0,1.968v-1H88v1Zm2-3.971v-1h1v1Zm0,2v-1h1v1Zm0,1.968v-1h1v1Zm2-3.971v-1h1v1Zm0,2v-1h1v1Z",transform:"translate(-78.002 -165.971)"}));};

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_memoize__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Refund__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Chart_Layers__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Chart_ClickhouseChart__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Chart_Surface__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Chart_Line__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Chart_NextGenTicks__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Chart_Deal__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Chart_NextGenChartMath__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Icons_Bet__ = __webpack_require__(2008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ThemeProvider__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  max-height: 100%;\n  transform: translate3d(0, 0, 0);\n  background: rgba(0, 0, 0, 0.54);\n  z-index: 500;\n  overflow: auto;\n"],["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  max-height: 100%;\n  transform: translate3d(0, 0, 0);\n  background: rgba(0, 0, 0, 0.54);\n  z-index: 500;\n  overflow: auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: block;\n  width: 568px;\n  line-height: 1.2;\n\n  @media (max-width: 829px) {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n  }\n"],["\n  display: block;\n  width: 568px;\n  line-height: 1.2;\n\n  @media (max-width: 829px) {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    max-height: 100%;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  font-size: 12px;\n  line-height: 19px;\n  padding: 10px;\n  padding-left: 22px;\n  padding-right: 52px;\n  color: ",";\n  background-color: ",";\n\n  @media (max-width: 829px) {\n    padding: 15px;\n    padding-left: 15px;\n    padding-right: 42px;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  font-size: 12px;\n  line-height: 19px;\n  padding: 10px;\n  padding-left: 22px;\n  padding-right: 52px;\n  color: ",";\n  background-color: ",";\n\n  @media (max-width: 829px) {\n    padding: 15px;\n    padding-left: 15px;\n    padding-right: 42px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n\n  @media (max-width: 479px) {\n    flex-direction: column;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n\n  @media (max-width: 479px) {\n    flex-direction: column;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row wrap;\n  align-items: baseline;\n  font-weight: 700;\n\n  @media (min-width: 480px) {\n    ",";\n  }\n"],["\n  display: flex;\n  flex-flow: row wrap;\n  align-items: baseline;\n  font-weight: 700;\n\n  @media (min-width: 480px) {\n    ",";\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n          margin-left: auto;\n        "],["\n          margin-left: auto;\n        "]),_templateObject7=_taggedTemplateLiteral(["\n        margin-right: auto;\n      "],["\n        margin-right: auto;\n      "]),_templateObject8=_taggedTemplateLiteral(["\n  @media (min-width: 480px) {\n    ",";\n  }\n"],["\n  @media (min-width: 480px) {\n    ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n          margin-left: 10px;\n        "],["\n          margin-left: 10px;\n        "]),_templateObject10=_taggedTemplateLiteral(["\n        margin-right: 10px;\n      "],["\n        margin-right: 10px;\n      "]),_templateObject11=_taggedTemplateLiteral(["\n  font-size: 16px;\n  color: ",";\n  text-transform: uppercase;\n\n  @media (min-width: 480px) {\n    ",";\n  }\n"],["\n  font-size: 16px;\n  color: ",";\n  text-transform: uppercase;\n\n  @media (min-width: 480px) {\n    ",";\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  @media (max-width: 479px) {\n    margin: 0 10px;\n  }\n"],["\n  @media (max-width: 479px) {\n    margin: 0 10px;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 21px;\n  height: 22px;\n  margin-left: auto;\n  color: #99959d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 21px;\n  height: 22px;\n  margin-left: auto;\n  color: #99959d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  @media (max-width: 829px) {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-shrink: 1;\n    background-color: ",";\n  }\n"],["\n  @media (max-width: 829px) {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    flex-shrink: 1;\n    background-color: ",";\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: ",";\n  "," @media (min-width: 830px) {\n    height: 245px;\n  }\n\n  @media (max-width: 829px) {\n    flex-grow: 1;\n    flex-shrink: 1;\n    overflow: hidden;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: ",";\n  "," @media (min-width: 830px) {\n    height: 245px;\n  }\n\n  @media (max-width: 829px) {\n    flex-grow: 1;\n    flex-shrink: 1;\n    overflow: hidden;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 10px 22px;\n  background-color: ",";\n"],["\n  display: flex;\n  flex-flow: row wrap;\n  justify-content: space-between;\n  flex-grow: 0;\n  flex-shrink: 0;\n  padding: 10px 22px;\n  background-color: ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n  padding: 12px 0;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: 500;\n  color: ",";\n\n  @media (max-width: 479px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0 5px;\n  }\n"],["\n  padding: 12px 0;\n  font-size: 16px;\n  line-height: 19px;\n  font-weight: 500;\n  color: ",";\n\n  @media (max-width: 479px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin: 0 5px;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n  font-size: 12px;\n  color: ",";\n"],["\n  font-size: 12px;\n  color: ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject20=_taggedTemplateLiteral(["\n          color: ",";\n        "],["\n          color: ",";\n        "]),_templateObject21=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 1px;\n  left: 0;\n  z-index: ",";\n"],["\n  position: absolute;\n  top: 1px;\n  left: 0;\n  z-index: ",";\n"]),_templateObject22=_taggedTemplateLiteral(["\n  position: absolute;\n  left: -4px;\n  top: 0;\n  width: 0;\n  height: 0;\n  border: 6px solid transparent;\n  border-top: none;\n\n  ",";\n"],["\n  position: absolute;\n  left: -4px;\n  top: 0;\n  width: 0;\n  height: 0;\n  border: 6px solid transparent;\n  border-top: none;\n\n  ",";\n"]),_templateObject23=_taggedTemplateLiteral(["\n          border-bottom-color: ",";\n        "],["\n          border-bottom-color: ",";\n        "]),_templateObject24=_taggedTemplateLiteral(["\n  position: relative;\n  top: 6px;\n  left: -50%;\n  padding: 5px 10px;\n  font-weight: bold;\n  font-size: 14px;\n  color: #fff;\n  border-radius: 4px;\n\n  ",";\n\n  @media (max-width: 959px) {\n    ",";\n  }\n"],["\n  position: relative;\n  top: 6px;\n  left: -50%;\n  padding: 5px 10px;\n  font-weight: bold;\n  font-size: 14px;\n  color: #fff;\n  border-radius: 4px;\n\n  ",";\n\n  @media (max-width: 959px) {\n    ",";\n  }\n"]),_templateObject25=_taggedTemplateLiteral(["\n          background-color: ",";\n          border-bottom-color: ",";\n        "],["\n          background-color: ",";\n          border-bottom-color: ",";\n        "]),_templateObject26=_taggedTemplateLiteral(["\n            left: -80%;\n          "],["\n            left: -80%;\n          "]),_templateObject27=_taggedTemplateLiteral(["\n            left: -20%;\n          "],["\n            left: -20%;\n          "]),_templateObject28=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import ForexIcon from "../Icons/Forex";
// import { InstrumentsIcon } from "../Toolbar/Icons";
var Overlay=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var Popup=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.operationChequeColor;},function(_ref2){var theme=_ref2.theme;return theme.popupDarkBackground;});var HeaderContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4);var StockContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject7);});var StockItem=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject8,function(_ref4){var theme=_ref4.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);});var Stock=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(StockItem)(_templateObject11,function(_ref5){var theme=_ref5.theme;return theme.foreground;},function(_ref6){var theme=_ref6.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);});var Percent=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(StockItem)(_templateObject12);var CloseButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject13,function(_ref7){var theme=_ref7.theme;return theme.foreground;});var MainContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject14,function(_ref8){var theme=_ref8.theme;return theme.main;});var ChartContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject15,function(_ref9){var theme=_ref9.theme;return theme.main;},""/* border-top: 1px solid ${({ theme }) => theme.ticksBorderColor};
  border-bottom: 1px solid ${({ theme }) => theme.ticksBorderColor}; */);var Info=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject16,function(_ref10){var theme=_ref10.theme;return theme.popupDarkBackground;});var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject17,function(_ref11){var theme=_ref11.theme;return theme.foreground;});var Caption=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject18,function(_ref12){var theme=_ref12.theme;return theme.operationChequeColor;});var WinningsWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject19,function(_ref13){var theme=_ref13.theme,winner=_ref13.winner;switch(winner){case false:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject20,theme.lower);case true:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject20,theme.upper);case null:default:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject20,theme.ticksFontColor);}});var ValueContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject21,__WEBPACK_IMPORTED_MODULE_12__Chart_Layers__["a" /* default */].TOOLTIP);var Pointer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject22,function(_ref14){var theme=_ref14.theme,positive=_ref14.positive;switch(positive){case false:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject23,theme.lower);case true:case null:default:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject23,theme.upper);}});var ValueView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject24,function(_ref15){var theme=_ref15.theme,positive=_ref15.positive;switch(positive){case false:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject25,theme.lower,theme.lower);case true:case null:default:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject25,theme.upper,theme.upper);}},function(_ref16){var alignment=_ref16.alignment;switch(alignment){case"right":return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject26);case"left":default:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject27);}});var Value=function Value(_ref17){var x=_ref17.x,y=_ref17.y,positive=_ref17.positive,alignment=_ref17.alignment,children=_ref17.children;var style={WebkitTransform:"translateX("+(x-1)+"px) translateY("+y+"px)",transform:"translateX("+(x-1)+"px) translateY("+y+"px)"};return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ValueContainer,{style:style},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ValueView,{positive:positive,alignment:alignment},children),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Pointer,{positive:positive}));};var Cell=function Cell(_ref18){var caption=_ref18.caption,children=_ref18.children;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Caption,null,caption,":"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,"\xA0");}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,children));};var SimplifiedOperationChartVisuals=function SimplifiedOperationChartVisuals(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeConsumer */],null,function(theme){var lineColor=props.settings.lineColor===theme.background?theme.foreground:props.settings.lineColor;var operationView=null;if(props.deals!=null&&props.deals.length>0){var _operation=props.deals[0];var start=props.scaleX(_operation.open_timestamp*1000);var end=props.scaleX(_operation.close_timestamp*1000);var open=props.scaleY(_operation.value);var close=props.scaleY(_operation.close_value);var profitable=null;if(_operation.close_value!==_operation.value){profitable=_operation.bidType?_operation.close_value>_operation.value:_operation.close_value<_operation.value;}operationView=__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Chart_Deal__["d" /* default */],Object.assign({mobile:true,tooltip:false},_operation,{scaleX:props.scaleX,scaleY:props.scaleY,viewportWidth:props.width,lastPoint:props.lastPoint,tradeMode:props.tradeMode})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Chart_Deal__["a" /* LeftIndicatorView */],{style:{WebkitTransform:"translate3d("+end+"px, "+close+"px, 0)",transform:"translate3d("+end+"px, "+close+"px, 0)",backgroundColor:profitable?"rgb(96,163,28)":"rgb(230,76,60)"},mobile:true}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Value,{x:start,y:open,positive:_operation.bidType,alignment:"left"},_operation.value&&_operation.value.toFixed(6)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Value,{x:end,y:close,positive:profitable,alignment:"right"},_operation.close_value&&_operation.close_value.toFixed(6)));}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChartContainer,Object.assign({},props.containerProps,{ref:props.containerProps.ref// ref={undefined}
}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Chart_Surface__["a" /* default */],{width:props.width,height:props.height},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Chart_Line__["a" /* default */],{data:props.points,width:props.width,height:props.height,scaleX:props.scaleX,scaleY:props.scaleY,color:lineColor,strokeWidth:2,displayGradient:true})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Chart_NextGenTicks__["a" /* HorizontalTicks */],{mobile:true,scaleX:props.scaleX,ticks:props.scaleX.ticks(4)}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Chart_NextGenTicks__["b" /* VerticalTicks */],{mobile:true,scaleY:props.scaleY,ticks:props.scaleY.ticks(2)}),operationView);});};var mapStockHistoryToPoints=__WEBPACK_IMPORTED_MODULE_4_lodash_memoize___default()(function(history){if(history==null){return[];}var dates=Object.keys(history);var points=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=dates[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var date=_step.value;// HACK: Чиним формат дат чтобы они корректно парсились в сафари
var correctDate=new Date(date.replace(" ","T")+"+00:00").valueOf();points.push({date:correctDate,value:Number(history[date])});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return points;});// Скопировано из Chart/SectionData и изменено под наши нужды
var fetchSection=function fetchSection(operation,type){return function(){var _ref19=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(section,profile){var interval,symbol,_Helpers$getSectionBo,_Helpers$getSectionBo2,start,end,operation_type,response,text,lines,data,_iteratorNormalCompletion2,_didIteratorError2,_iteratorError2,_iterator2,_step2,line,_line$split,_line$split2,epoch,open,close,min,max;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;interval=section.interval/1000;symbol=section.stock;_Helpers$getSectionBo=__WEBPACK_IMPORTED_MODULE_22__Chart_NextGenChartMath__["i" /* getSectionBoundaries */](section).map(function(b){return b/1000;}),_Helpers$getSectionBo2=_slicedToArray(_Helpers$getSectionBo,2),start=_Helpers$getSectionBo2[0],end=_Helpers$getSectionBo2[1];operation_type=type==="tournament"?"tournament":"binary";_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_21__common_fetch__["c" /* apiCall */])("/api/stocks/history/csv?symbol="+symbol+"&interval="+interval+"&start="+start+"&end="+end+"&user_id="+profile.id+"&operation_id="+operation.id+"&operation_type="+operation_type);case 7:response=_context.sent;if(!(response.status!==200)){_context.next=15;break;}_context.t0=response.status;_context.next=_context.t0===400?12:_context.t0===403?13:14;break;case 12:return _context.abrupt("return",{section:section,data:[]});case 13:return _context.abrupt("return",{section:section,data:"darkness"});case 14:throw new TypeError("Failed to load the history for "+symbol+" from "+new Date(start*1000).toString()+" to "+new Date(end*1000).toString()+" due to HTTP status code mismatch ("+response.status+")");case 15:_context.next=17;return response.text();case 17:text=_context.sent;lines=text.split("\n");data=[];_iteratorNormalCompletion2=true;_didIteratorError2=false;_iteratorError2=undefined;_context.prev=23;for(_iterator2=lines[Symbol.iterator]();!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){line=_step2.value;if(line.length>0){_line$split=line.split(","),_line$split2=_slicedToArray(_line$split,5),epoch=_line$split2[0],open=_line$split2[1],close=_line$split2[2],min=_line$split2[3],max=_line$split2[4];data.push({epoch:parseInt(epoch,10),open:parseFloat(open),close:parseFloat(close),min:parseFloat(min),max:parseFloat(max)});}}_context.next=31;break;case 27:_context.prev=27;_context.t1=_context["catch"](23);_didIteratorError2=true;_iteratorError2=_context.t1;case 31:_context.prev=31;_context.prev=32;if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}case 34:_context.prev=34;if(!_didIteratorError2){_context.next=37;break;}throw _iteratorError2;case 37:return _context.finish(34);case 38:return _context.finish(31);case 39:if(!(data.length===0)){_context.next=41;break;}return _context.abrupt("return",{section:section,data:"void"});case 41:return _context.abrupt("return",{section:section,data:data});case 44:_context.prev=44;_context.t2=_context["catch"](0);console.log(_context.t2);return _context.abrupt("return",{section:section,data:[]});case 48:case"end":return _context.stop();}}},_callee,_this,[[0,44],[23,27,31,39],[32,,34,38]]);}));return function(_x,_x2){return _ref19.apply(this,arguments);};}();};var fetchData=function fetchData(_ref20){var url=_ref20.url,errorHandler=_ref20.errorHandler,options=_objectWithoutProperties(_ref20,["url","errorHandler"]);return window.fetch(url,options).then(function(response){return response.json();}).catch(errorHandler);};var OperationChart=function(_React$Component){_inherits(OperationChart,_React$Component);function OperationChart(){var _ref21;var _temp,_this2,_ret;_classCallCheck(this,OperationChart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this2=_possibleConstructorReturn(this,(_ref21=OperationChart.__proto__||Object.getPrototypeOf(OperationChart)).call.apply(_ref21,[this].concat(args))),_this2),_this2.state={isFetching:true,stockHistory:null,isError:false},_temp),_possibleConstructorReturn(_this2,_ret);}_createClass(OperationChart,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;//TODO remake with new api
var props=this.props;var host=window.API_URL||"irontrade"==="irontrade"&&"https://testapp.irontrade.com";fetchData({url:host+"/ajax/stockHistory?stock="+props.stock.stock+"&limit="+7200+"&tz=UTC",errorHandler:function errorHandler(){_this3.setState({isError:true});}}).then(function(stockHistory){return _this3.setState({stockHistory:stockHistory,isFetching:false});});}},{key:"render",value:function render(){var props=this.props;var _state=this.state,stockHistory=_state.stockHistory,isFetching=_state.isFetching,isError=_state.isError;var points=mapStockHistoryToPoints(stockHistory);if(isFetching){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChartContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Spinners_SimpleSpinner__["c" /* default */],{accent:true}));}if(isError){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChartContainer,null,"Sorry, error occured");}if(points.length<5){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ChartContainer,null,"No data for view");}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Chart_ClickhouseChart__["default"],{"static":true,key:props.stock.stock,stock:props.stock,tradeMode:"binary",points:points,settings:{indicators:[],timeSpan:props.operation.bTime*1000/0.8,interval:1,chartType:"line",lineColor:props.lineColor},cursor:{date:props.operation.open_timestamp*1000,ratio:0.1,follow:false,animate:false},stats:null,profile:props.profile,deals:[props.operation],intent:null,timeUntilNextLockToggle:null,dispatch:props.dispatch,onEditIndicator:function onEditIndicator(){return void 0;},interactive:false,visuals:SimplifiedOperationChartVisuals,fetchSection:fetchSection(props.operation,props.type),allowShortHistorySections:true});}}]);return OperationChart;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var UpperColoredText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject28,function(_ref22){var theme=_ref22.theme;return theme.upper;});var LowerColoredText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject28,function(_ref23){var theme=_ref23.theme;return theme.lower;});var BidType=function BidType(props){if(props.operation.bidType===true){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](UpperColoredText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__Icons_Bet__["b" /* UpIcon */],null),"\xA0",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Upper"));}else{return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LowerColoredText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__Icons_Bet__["a" /* DownIcon */],null),"\xA0",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"lower"));}};function findAsset(assets,stock){if(stock==="CRYPTO"){stock="CRYPTOINDEX";}var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=Object.keys(assets)[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var category=_step3.value;var _iteratorNormalCompletion4=true;var _didIteratorError4=false;var _iteratorError4=undefined;try{for(var _iterator4=assets[category][Symbol.iterator](),_step4;!(_iteratorNormalCompletion4=(_step4=_iterator4.next()).done);_iteratorNormalCompletion4=true){var _asset=_step4.value;if(_asset.stock===stock){return _asset;}}}catch(err){_didIteratorError4=true;_iteratorError4=err;}finally{try{if(!_iteratorNormalCompletion4&&_iterator4.return){_iterator4.return();}}finally{if(_didIteratorError4){throw _iteratorError4;}}}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}throw new TypeError("Unknown asset "+stock);}var Cheque=function Cheque(props){var operation=props.operation,onDismiss=props.onDismiss,style=props.style,api=props.api;var start=operation.open_timestamp*1000;var end=operation.close_timestamp*1000;var currency=props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_19__Icons_Kuchka__["b" /* tournamentCurrency */]:null;var winner=Math.sign(parseFloat(operation.profit))>=0;if(operation.close_value===operation.value){winner=null;}var profile=api.readEntity("/api/profile").value;var assets=api.readEntity("/api/getAssets").value;if(profile==null||assets==null){return null;}var asset=findAsset(assets,operation.stock);var times=__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"](function(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_5_moment___default()(start).format("ll HH:mm:ss"),"\xA0\u2013\xA0",__WEBPACK_IMPORTED_MODULE_5_moment___default()(end).format("ll HH:mm:ss"));},[start,end]);var MemoHeader=__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"](function(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](HeaderContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StockContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Stock,null,operation.stock),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Percent,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"PROFIT"),": ",operation.percent,"%")),times,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CloseButton,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Icons_Close__["a" /* default */],{onClick:onDismiss}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"ID")," ",operation.id));},[operation,times,onDismiss]);var MemoOperationChart=__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"](function(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OperationChart,{api:api,stock:asset,profile:profile,operation:operation,type:props.type,lineColor:props.lineColor});},[api,asset,profile,operation,props.type,props.lineColor]);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Overlay,{style:style},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_ClickOutside__["a" /* default */],{onOutsideClick:onDismiss},function(_ref24){var innerRef=_ref24.innerRef;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Popup,{ref:innerRef},MemoHeader,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MainContainer,null,MemoOperationChart,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cell,{caption:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Result")},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WinningsWrapper,{winner:winner},operation.profit===0?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__common_Refund__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,winner&&"+",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},operation.profit)))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cell,{caption:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Amount")},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},operation.amount)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cell,{caption:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Type")},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BidType,{operation:operation})))));}));};var ApiedCheque=function ApiedCheque(props){var api=__WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_18__Tournaments_Api__["c" /* default */]);var theme=__WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_24__ThemeProvider__["b" /* TradeThemeContext */]);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* ThemeProvider */],{theme:theme},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cheque,Object.assign({},props,{api:api})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function(state){return{tradeMode:state.settings.mode,lineColor:state.settings.lineColor};})(ApiedCheque));

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, global) {/* harmony export (immutable) */ __webpack_exports__["c"] = dynamicRequire;
/* unused harmony export isNodeEnv */
/* harmony export (immutable) */ __webpack_exports__["e"] = getGlobalObject;
/* harmony export (immutable) */ __webpack_exports__["g"] = uuid4;
/* harmony export (immutable) */ __webpack_exports__["f"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["d"] = getEventDescription;
/* harmony export (immutable) */ __webpack_exports__["b"] = consoleSandbox;
/* harmony export (immutable) */ __webpack_exports__["a"] = addExceptionTypeValue;
/**
 * Requires a module which is protected _against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    // tslint:disable-next-line: no-unsafe-any
    return mod.require(request);
}
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // tslint:disable:strict-type-predicates
    return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
}
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // tslint:disable-next-line:no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // tslint:disable-next-line:no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // tslint:disable-next-line:no-bitwise
        var r = (Math.random() * 16) | 0;
        // tslint:disable-next-line:no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:\/?#]+):)?(\/\/([^\/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    if (event.message) {
        return event.message;
    }
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) {
            return exception.type + ": " + exception.value;
        }
        return exception.type || exception.value || event.event_id || '<unknown>';
    }
    return event.event_id || '<unknown>';
}
/** JSDoc */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        if (level in global.console && originalConsole[level].__sentry__) {
            wrappedLevels[level] = originalConsole[level].__sentry_wrapped__;
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @param mechanism Mechanism of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type, mechanism) {
    if (mechanism === void 0) { mechanism = {
        handled: true,
        type: 'generic',
    }; }
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || '';
    event.exception.values[0].type = event.exception.values[0].type || type || 'Error';
    event.exception.values[0].mechanism = event.exception.values[0].mechanism || mechanism;
}
//# sourceMappingURL=misc.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(185), __webpack_require__(27)))

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dsn; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w\.-]+)(?::(\d+))?\/(.+)/;
/** Error message */
var ERROR_MESSAGE = 'Invalid Dsn';
/** The Sentry Dsn, identifying a Sentry instance and project. */
var Dsn = /** @class */ (function () {
    /** Creates a new Dsn component */
    function Dsn(from) {
        if (typeof from === 'string') {
            this._fromString(from);
        }
        else {
            this._fromComponents(from);
        }
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private _representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */
    Dsn.prototype.toString = function (withPassword) {
        if (withPassword === void 0) { withPassword = false; }
        // tslint:disable-next-line:no-this-assignment
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return (protocol + "://" + user + (withPassword && pass ? ":" + pass : '') +
            ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
    };
    /** Parses a string into this Dsn. */
    Dsn.prototype._fromString = function (str) {
        var match = DSN_REGEX.exec(str);
        if (!match) {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
        }
        var _a = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __read */](match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
        var path = '';
        var projectId = lastPath;
        var split = projectId.split('/');
        if (split.length > 1) {
            path = split.slice(0, -1).join('/');
            projectId = split.pop();
        }
        Object.assign(this, { host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, user: user });
    };
    /** Maps Dsn components into this instance. */
    Dsn.prototype._fromComponents = function (components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || '';
        this.host = components.host;
        this.port = components.port || '';
        this.path = components.path || '';
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */
    Dsn.prototype._validate = function () {
        var _this = this;
        ['protocol', 'user', 'host', 'projectId'].forEach(function (component) {
            if (!_this[component]) {
                throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
            }
        });
        if (this.protocol !== 'http' && this.protocol !== 'https') {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
        }
        if (this.port && Number.isNaN(parseInt(this.port, 10))) {
            throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */](ERROR_MESSAGE);
        }
    };
    return Dsn;
}());

//# sourceMappingURL=dsn.js.map

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = exceptionFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["a"] = eventFromPlainObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = eventFromStacktrace;
/* harmony export (immutable) */ __webpack_exports__["d"] = prepareFramesForEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tracekit__ = __webpack_require__(301);


var STACKTRACE_LIMIT = 50;
/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromStacktrace(stacktrace) {
    var frames = prepareFramesForEvent(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message,
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    // tslint:disable-next-line:strict-type-predicates
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException) {
    var exceptionKeys = Object.keys(exception).sort();
    var event = {
        extra: {
            __serialized__: Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["v" /* normalizeToSize */])(exception),
        },
        message: "Non-Error exception captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["s" /* keysToEventMessage */])(exceptionKeys),
    };
    if (syntheticException) {
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_1__tracekit__["a" /* _computeStackTrace */])(syntheticException);
        var frames_1 = prepareFramesForEvent(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1,
        };
    }
    return event;
}
/**
 * @hidden
 */
function eventFromStacktrace(stacktrace) {
    var exception = exceptionFromStacktrace(stacktrace);
    return {
        exception: {
            values: [exception],
        },
    };
}
/**
 * @hidden
 */
function prepareFramesForEvent(stack) {
    if (!stack || !stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || '';
    var lastFrameFunction = localStack[localStack.length - 1].func || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.includes('captureMessage') || firstFrameFunction.includes('captureException')) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.includes('sentryWrapped')) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .map(function (frame) { return ({
        colno: frame.column,
        filename: frame.url || localStack[0].url,
        function: frame.func || '?',
        in_app: true,
        lineno: frame.line,
    }); })
        .slice(0, STACKTRACE_LIMIT)
        .reverse();
}
//# sourceMappingURL=parsers.js.map

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);


/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["a" /* PromiseBuffer */](30);
        this.url = new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["a" /* API */](this.options.dsn).getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (_) {
        throw new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["b" /* SentryError */]('Transport Class has to implement `sendEvent` method');
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    return BaseTransport;
}());

//# sourceMappingURL=base.js.map

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parsePhoneNumber */
/* unused harmony export parseNumber */
/* harmony export (immutable) */ __webpack_exports__["b"] = parse;
/* unused harmony export formatNumber */
/* unused harmony export format */
/* unused harmony export getNumberType */
/* unused harmony export getExampleNumber */
/* unused harmony export isPossibleNumber */
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumber;
/* unused harmony export isValidNumberForRegion */
/* unused harmony export findPhoneNumbers */
/* unused harmony export searchPhoneNumbers */
/* unused harmony export PhoneNumberSearch */
/* unused harmony export findNumbers */
/* unused harmony export searchNumbers */
/* unused harmony export PhoneNumberMatcher */
/* unused harmony export AsYouType */
/* unused harmony export getExtPrefix */
/* unused harmony export parseRFC3966 */
/* unused harmony export formatRFC3966 */
/* unused harmony export formatIncompletePhoneNumber */
/* unused harmony export getCountryCallingCode */
/* unused harmony export getPhoneCode */
/* unused harmony export getPhoneCodeCustom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__es6_parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__es6_format__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__es6_getNumberType__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__es6_getExampleNumber__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__es6_isPossibleNumber__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__es6_validate__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__es6_isValidNumberForRegion__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbers__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__es6_findNumbers__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__es6_searchNumbers__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__es6_PhoneNumberMatcher__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__es6_AsYouType__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__es6_getCountryCallingCode__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__es6_metadata__ = __webpack_require__(78);
/* unused harmony reexport Metadata */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__es6_RFC3966__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__es6_formatIncompletePhoneNumber__ = __webpack_require__(1287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__es6_parseIncompletePhoneNumber__ = __webpack_require__(256);
/* unused harmony reexport parseIncompletePhoneNumber */
/* unused harmony reexport parsePhoneNumberCharacter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__es6_common__ = __webpack_require__(70);
/* unused harmony reexport DIGITS */
/* unused harmony reexport parseCustom */
/* unused harmony reexport formatCustom */
/* unused harmony reexport isValidNumberCustom */
/* unused harmony reexport findPhoneNumbersCustom */
/* unused harmony reexport searchPhoneNumbersCustom */
/* unused harmony reexport PhoneNumberSearchCustom */
/* unused harmony reexport getNumberTypeCustom */
/* unused harmony reexport getCountryCallingCodeCustom */
/* unused harmony reexport AsYouTypeCustom */
/* unused harmony reexport DIGIT_PLACEHOLDER */












// Deprecated















function parsePhoneNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_1__es6_parsePhoneNumber__["a" /* default */].apply(this, parameters)
}

function parseNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_2__es6_parse__["a" /* default */].apply(this, parameters)
}

// Deprecated: remove `parse()` export in 2.0.0.
// (renamed to `parseNumber()`)
function parse()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_2__es6_parse__["a" /* default */].apply(this, parameters)
}

function formatNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_3__es6_format__["b" /* default */].apply(this, parameters)
}

// Deprecated: remove `format()` export in 2.0.0.
// (renamed to `formatNumber()`)
function format()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_3__es6_format__["b" /* default */].apply(this, parameters)
}

function getNumberType()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_4__es6_getNumberType__["b" /* default */].apply(this, parameters)
}

function getExampleNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_5__es6_getExampleNumber__["a" /* default */].apply(this, parameters)
}

function isPossibleNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_6__es6_isPossibleNumber__["a" /* default */].apply(this, parameters)
}

function isValidNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_7__es6_validate__["a" /* default */].apply(this, parameters)
}

function isValidNumberForRegion()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_8__es6_isValidNumberForRegion__["a" /* default */].apply(this, parameters)
}

// Deprecated.
function findPhoneNumbers()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbers__["b" /* default */].apply(this, parameters)
}

// Deprecated.
function searchPhoneNumbers()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbers__["c" /* searchPhoneNumbers */].apply(this, parameters)
}

// Deprecated.
function PhoneNumberSearch(text, options)
{
	__WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbers__["a" /* PhoneNumberSearch */].call(this, text, options, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

// Deprecated.
PhoneNumberSearch.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_9__es6_findPhoneNumbers__["a" /* PhoneNumberSearch */].prototype, {})
PhoneNumberSearch.prototype.constructor = PhoneNumberSearch

function findNumbers()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_10__es6_findNumbers__["a" /* default */].apply(this, parameters)
}

function searchNumbers()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_11__es6_searchNumbers__["a" /* default */].apply(this, parameters)
}

function PhoneNumberMatcher(text, options)
{
	__WEBPACK_IMPORTED_MODULE_12__es6_PhoneNumberMatcher__["a" /* default */].call(this, text, options, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

PhoneNumberMatcher.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_12__es6_PhoneNumberMatcher__["a" /* default */].prototype, {})
PhoneNumberMatcher.prototype.constructor = PhoneNumberMatcher

function AsYouType(country)
{
	__WEBPACK_IMPORTED_MODULE_13__es6_AsYouType__["a" /* default */].call(this, country, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

AsYouType.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_13__es6_AsYouType__["a" /* default */].prototype, {})
AsYouType.prototype.constructor = AsYouType

function getExtPrefix()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_15__es6_metadata__["b" /* getExtPrefix */].apply(this, parameters)
}

function parseRFC3966()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_16__es6_RFC3966__["b" /* parseRFC3966 */].apply(this, parameters)
}

function formatRFC3966()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_16__es6_RFC3966__["a" /* formatRFC3966 */].apply(this, parameters)
}

function formatIncompletePhoneNumber()
{
	var parameters = Array.prototype.slice.call(arguments)
	parameters.push(__WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
	return __WEBPACK_IMPORTED_MODULE_17__es6_formatIncompletePhoneNumber__["a" /* default */].apply(this, parameters)
}

// Deprecated: remove DIGITS export in 2.0.0 (unused).


// Deprecated: remove this in 2.0.0 and make `custom.js` in ES6
// (the old `custom.js` becomes `custom.commonjs.js`).











function getCountryCallingCode(country)
{
	return Object(__WEBPACK_IMPORTED_MODULE_14__es6_getCountryCallingCode__["a" /* default */])(country, __WEBPACK_IMPORTED_MODULE_0__metadata_min_json___default.a)
}

// `getPhoneCode` name is deprecated, use `getCountryCallingCode` instead.
function getPhoneCode(country)
{
	return getCountryCallingCode(country)
}

// `getPhoneCodeCustom` name is deprecated, use `getCountryCallingCodeCustom` instead.
function getPhoneCodeCustom(country, metadata)
{
	return Object(__WEBPACK_IMPORTED_MODULE_14__es6_getCountryCallingCode__["a" /* default */])(country, metadata)
}

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Transition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PoseGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_popmotion_pose__ = __webpack_require__(1619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_is_prop_valid__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hey_listen__ = __webpack_require__(140);






var hasChanged = function (prev, next) {
    if (prev === next)
        return false;
    var prevIsArray = Array.isArray(prev);
    var nextIsArray = Array.isArray(next);
    if (prevIsArray !== nextIsArray || (!prevIsArray && !nextIsArray)) {
        return true;
    }
    else if (prevIsArray && nextIsArray) {
        var numPrev = prev.length;
        var numNext = next.length;
        if (numPrev !== numNext)
            return true;
        for (var i = 0; i < numPrev; i++) {
            if (prev[i] !== next[i])
                return true;
        }
    }
    return false;
};

var pickAssign = function (shouldPick, sources) {
    return sources.reduce(function (picked, source) {
        for (var key in source) {
            if (shouldPick(key)) {
                picked[key] = source[key];
            }
        }
        return picked;
    }, {});
};

var _a = Object(__WEBPACK_IMPORTED_MODULE_1_react__["createContext"])({}), PoseParentConsumer = _a.Consumer, PoseParentProvider = _a.Provider;
var calcPopFromFlowStyle = function (el) {
    var offsetTop = el.offsetTop, offsetLeft = el.offsetLeft, offsetWidth = el.offsetWidth, offsetHeight = el.offsetHeight;
    return {
        position: 'absolute',
        top: offsetTop,
        left: offsetLeft,
        width: offsetWidth,
        height: offsetHeight
    };
};
var hasPose = function (pose, key) {
    return Array.isArray(pose) ? pose.indexOf(key) !== -1 : pose === key;
};
var objectToMap = function (obj) {
    return Object.keys(obj).reduce(function (map, key) {
        map.set(key, { raw: obj[key] });
        return map;
    }, new Map());
};
var testAlwaysTrue = function () { return true; };
var filterProps = function (_a) {
    var elementType = _a.elementType, poseConfig = _a.poseConfig, onValueChange = _a.onValueChange, innerRef = _a.innerRef, _pose = _a._pose, pose = _a.pose, initialPose = _a.initialPose, poseKey = _a.poseKey, onPoseComplete = _a.onPoseComplete, getParentPoseConfig = _a.getParentPoseConfig, registerChild = _a.registerChild, onUnmount = _a.onUnmount, getInitialPoseFromParent = _a.getInitialPoseFromParent, popFromFlow = _a.popFromFlow, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["elementType", "poseConfig", "onValueChange", "innerRef", "_pose", "pose", "initialPose", "poseKey", "onPoseComplete", "getParentPoseConfig", "registerChild", "onUnmount", "getInitialPoseFromParent", "popFromFlow", "values", "parentValues", "onDragStart", "onDragEnd", "onPressStart", "onPressEnd"]);
    return props;
};
var PoseElement = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PoseElement, _super);
    function PoseElement(props) {
        var _this = _super.call(this, props) || this;
        _this.children = new Set();
        _this.childrenHandlers = {
            registerChild: function (props) {
                _this.children.add(props);
                if (_this.poser)
                    _this.flushChildren();
            },
            onUnmount: function (child) { return _this.poser.removeChild(child); },
            getParentPoseConfig: function () { return _this.poseConfig; },
            getInitialPoseFromParent: function () { return _this.getInitialPose(); }
        };
        _this.setRef = function (ref) {
            Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["b" /* warning */])(ref === null || (ref instanceof Element && _this.ref === undefined), 'ref must be provided to the same DOM component for the entire lifecycle of a posed component.');
            _this.ref = ref;
            var innerRef = _this.props.innerRef;
            if (!innerRef)
                return;
            if (typeof innerRef === 'function') {
                innerRef(ref);
            }
            else {
                innerRef.current = ref;
            }
        };
        _this.shouldForwardProp =
            typeof _this.props.elementType === 'string' ? __WEBPACK_IMPORTED_MODULE_3__emotion_is_prop_valid__["a" /* default */] : testAlwaysTrue;
        var poseConfig = _this.props.poseConfig;
        _this.poseConfig =
            typeof poseConfig === 'function'
                ? poseConfig(filterProps(props))
                : poseConfig;
        return _this;
    }
    PoseElement.prototype.getInitialPose = function () {
        var _a = this.props, getInitialPoseFromParent = _a.getInitialPoseFromParent, pose = _a.pose, _pose = _a._pose, initialPose = _a.initialPose;
        if (initialPose) {
            return initialPose;
        }
        else {
            var parentPose = getInitialPoseFromParent && getInitialPoseFromParent();
            var initialPoses = (Array.isArray(parentPose)
                ? parentPose
                : [parentPose])
                .concat(pose, _pose)
                .filter(Boolean);
            return initialPoses.length > 0 ? initialPoses : undefined;
        }
    };
    PoseElement.prototype.getFirstPose = function () {
        var _a = this.props, initialPose = _a.initialPose, pose = _a.pose, _pose = _a._pose;
        if (!initialPose)
            return;
        var firstPose = (Array.isArray(pose) ? pose : [pose])
            .concat(_pose)
            .filter(Boolean);
        return firstPose.length === 1 ? firstPose[0] : firstPose;
    };
    PoseElement.prototype.getSetProps = function () {
        var props = filterProps(this.props);
        if (this.props.popFromFlow && this.ref && this.ref instanceof HTMLElement) {
            if (!this.popStyle) {
                props.style = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props.style, calcPopFromFlowStyle(this.ref));
                this.popStyle = props.style;
            }
            else {
                props.style = this.popStyle;
            }
        }
        else {
            this.popStyle = null;
        }
        return props;
    };
    PoseElement.prototype.componentDidMount = function () {
        var _this = this;
        Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(this.ref instanceof Element, "No valid DOM ref found. If you're converting an existing component via posed(Component), you must ensure you're passing the ref to the host DOM node via the React.forwardRef function.");
        var _a = this.props, onValueChange = _a.onValueChange, registerChild = _a.registerChild, values = _a.values, parentValues = _a.parentValues, onDragStart = _a.onDragStart, onDragEnd = _a.onDragEnd, onPressStart = _a.onPressStart, onPressEnd = _a.onPressEnd;
        var config = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.poseConfig, { initialPose: this.getInitialPose(), values: values || this.poseConfig.values, parentValues: parentValues ? objectToMap(parentValues) : undefined, props: this.getSetProps(), onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            onPressStart: onPressStart,
            onPressEnd: onPressEnd, onChange: onValueChange });
        if (!registerChild) {
            this.initPoser(Object(__WEBPACK_IMPORTED_MODULE_2_popmotion_pose__["a" /* default */])(this.ref, config));
        }
        else {
            registerChild({
                element: this.ref,
                poseConfig: config,
                onRegistered: function (poser) { return _this.initPoser(poser); }
            });
        }
    };
    PoseElement.prototype.getSnapshotBeforeUpdate = function () {
        var _a = this.props, pose = _a.pose, _pose = _a._pose;
        if (hasPose(pose, 'flip') || hasPose(_pose, 'flip'))
            this.poser.measure();
        return null;
    };
    PoseElement.prototype.componentDidUpdate = function (prevProps) {
        var _a = this.props, pose = _a.pose, _pose = _a._pose, poseKey = _a.poseKey;
        this.poser.setProps(this.getSetProps());
        if (poseKey !== prevProps.poseKey ||
            hasChanged(prevProps.pose, pose) ||
            pose === 'flip') {
            this.setPose(pose);
        }
        if (_pose !== prevProps._pose || _pose === 'flip')
            this.setPose(_pose);
    };
    PoseElement.prototype.componentWillUnmount = function () {
        if (!this.poser)
            return;
        var onUnmount = this.props.onUnmount;
        if (onUnmount)
            onUnmount(this.poser);
        this.poser.destroy();
    };
    PoseElement.prototype.initPoser = function (poser) {
        this.poser = poser;
        this.flushChildren();
        var firstPose = this.getFirstPose();
        if (firstPose)
            this.setPose(firstPose);
    };
    PoseElement.prototype.setPose = function (pose) {
        var _this = this;
        var onPoseComplete = this.props.onPoseComplete;
        var poseList = Array.isArray(pose) ? pose : [pose];
        Promise.all(poseList.map(function (key) { return key && _this.poser.set(key); })).then(function () { return onPoseComplete && onPoseComplete(pose); });
    };
    PoseElement.prototype.flushChildren = function () {
        var _this = this;
        this.children.forEach(function (_a) {
            var element = _a.element, poseConfig = _a.poseConfig, onRegistered = _a.onRegistered;
            return onRegistered(_this.poser.addChild(element, poseConfig));
        });
        this.children.clear();
    };
    PoseElement.prototype.render = function () {
        var elementType = this.props.elementType;
        return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PoseParentProvider, { value: this.childrenHandlers }, Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(elementType, pickAssign(this.shouldForwardProp, [
            this.getSetProps(),
            { ref: this.setRef }
        ]))));
    };
    return PoseElement;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]));

var supportedElements = [
    'a',
    'article',
    'aside',
    'audio',
    'b',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dialog',
    'div',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'i',
    'iframe',
    'img',
    'input',
    'label',
    'legend',
    'li',
    'nav',
    'object',
    'ol',
    'option',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'section',
    'select',
    'span',
    'strong',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'ul',
    'video',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];

var componentCache = new Map();
var createComponentFactory = function (key) {
    var componentFactory = function (poseConfig) {
        if (poseConfig === void 0) { poseConfig = {}; }
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["forwardRef"])(function (_a, ref) {
            var _b = _a.withParent, withParent = _b === void 0 ? true : _b, props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["withParent"]);
            Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["b" /* warning */])(props.innerRef === undefined, 'innerRef is deprecated. Please use ref instead.');
            return !withParent || props.parentValues ? (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PoseElement, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ poseConfig: poseConfig, innerRef: ref, elementType: key }, props))) : (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PoseParentConsumer, null, function (parentCtx) { return (__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PoseElement, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ poseConfig: poseConfig, elementType: key, innerRef: ref }, props, parentCtx))); }));
        });
    };
    componentCache.set(key, componentFactory);
    return componentFactory;
};
var getComponentFactory = function (key) {
    return componentCache.has(key)
        ? componentCache.get(key)
        : createComponentFactory(key);
};
var posed = (function (component) {
    return getComponentFactory(component);
});
supportedElements.reduce(function (acc, key) {
    acc[key] = createComponentFactory(key);
    return acc;
}, posed);

var getKey = function (child) {
    Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(child && child.key !== null, 'Every child of Transition must be given a unique key');
    var childKey = typeof child.key === 'number' ? child.key.toString() : child.key;
    return childKey.replace('.$', '');
};
var prependProps = function (element, props) {
    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(element.type, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ key: element.key, ref: element.ref }, props, element.props));
};
var handleTransition = function (_a, _b) {
    var displayedChildren = _b.displayedChildren, finishedLeaving = _b.finishedLeaving, hasInitialized = _b.hasInitialized, indexedChildren = _b.indexedChildren, scheduleChildRemoval = _b.scheduleChildRemoval;
    var incomingChildren = _a.children, preEnterPose = _a.preEnterPose, enterPose = _a.enterPose, exitPose = _a.exitPose, animateOnMount = _a.animateOnMount, enterAfterExit = _a.enterAfterExit, flipMove = _a.flipMove, onRest = _a.onRest, propsForChildren = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["children", "preEnterPose", "enterPose", "exitPose", "animateOnMount", "enterAfterExit", "flipMove", "onRest"]);
    var targetChildren = makeChildList(incomingChildren);
    var nextState = {
        displayedChildren: []
    };
    if (false) {
        warning(!propsForChildren.onPoseComplete, "<Transition/> (or <PoseGroup/>) doesn't accept onPoseComplete prop.");
    }
    var prevKeys = displayedChildren.map(getKey);
    var nextKeys = targetChildren.map(getKey);
    var hasPropsForChildren = Object.keys(propsForChildren).length !== 0;
    var entering = new Set(nextKeys.filter(function (key) { return finishedLeaving.hasOwnProperty(key) || prevKeys.indexOf(key) === -1; }));
    entering.forEach(function (key) { return delete finishedLeaving[key]; });
    var leaving = [];
    var newlyLeaving = {};
    prevKeys.forEach(function (key) {
        if (entering.has(key)) {
            return;
        }
        var isLeaving = finishedLeaving.hasOwnProperty(key);
        if (!isLeaving && nextKeys.indexOf(key) !== -1) {
            return;
        }
        leaving.push(key);
        if (!isLeaving) {
            finishedLeaving[key] = false;
            newlyLeaving[key] = true;
        }
    });
    var moving = new Set(prevKeys.filter(function (key, i) {
        return !entering.has(key) || leaving.indexOf(key) === -1;
    }));
    targetChildren.forEach(function (child) {
        var newChildProps = {};
        if (entering.has(child.key)) {
            if (hasInitialized || animateOnMount) {
                newChildProps.initialPose = preEnterPose;
            }
            newChildProps._pose = enterPose;
        }
        else if (moving.has(child.key) && flipMove) {
            newChildProps._pose = [enterPose, 'flip'];
        }
        else {
            newChildProps._pose = enterPose;
        }
        var newChild = Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, newChildProps);
        indexedChildren[child.key] = newChild;
        nextState.displayedChildren.push(hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
    });
    leaving.forEach(function (key) {
        var child = indexedChildren[key];
        var newChild = newlyLeaving[key]
            ? Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(child, {
                _pose: exitPose,
                onPoseComplete: function (pose) {
                    scheduleChildRemoval(key);
                    var onPoseComplete = child.props.onPoseComplete;
                    if (onPoseComplete)
                        onPoseComplete(pose);
                },
                popFromFlow: flipMove
            })
            : child;
        var insertionIndex = prevKeys.indexOf(key);
        indexedChildren[child.key] = newChild;
        nextState.displayedChildren.splice(insertionIndex, 0, hasPropsForChildren ? prependProps(newChild, propsForChildren) : newChild);
    });
    return nextState;
};
var handleChildrenTransitions = (function (props, state) {
    var newState = handleTransition(props, state);
    newState.hasInitialized = true;
    return newState;
});
var makeChildList = function (children) {
    var list = [];
    __WEBPACK_IMPORTED_MODULE_1_react__["Children"].forEach(children, function (child) { return child && list.push(child); });
    return list;
};

var Transition = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Transition, _super);
    function Transition() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            displayedChildren: [],
            finishedLeaving: {},
            hasInitialized: false,
            indexedChildren: {},
            scheduleChildRemoval: function (key) { return _this.removeChild(key); }
        };
        return _this;
    }
    Transition.prototype.removeChild = function (key) {
        var _a = this.state, displayedChildren = _a.displayedChildren, finishedLeaving = _a.finishedLeaving;
        var _b = this.props, enterAfterExit = _b.enterAfterExit, onRest = _b.onRest;
        if (!finishedLeaving.hasOwnProperty(key))
            return;
        finishedLeaving[key] = true;
        if (!Object.keys(finishedLeaving).every(function (leavingKey) { return finishedLeaving[leavingKey]; })) {
            return;
        }
        var targetChildren = displayedChildren.filter(function (child) { return !finishedLeaving.hasOwnProperty(child.key); });
        var newState = enterAfterExit
            ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ finishedLeaving: {} }, handleChildrenTransitions(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { enterAfterExit: false }), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.state, { displayedChildren: targetChildren }))) : {
            finishedLeaving: {},
            displayedChildren: targetChildren
        };
        this.setState(newState, onRest);
    };
    Transition.prototype.shouldComponentUpdate = function (nextProps, nextState) {
        return this.state !== nextState;
    };
    Transition.prototype.render = function () {
        return this.state.displayedChildren;
    };
    Transition.defaultProps = {
        flipMove: false,
        enterAfterExit: false,
        preEnterPose: 'exit',
        enterPose: 'enter',
        exitPose: 'exit'
    };
    Transition.getDerivedStateFromProps = handleChildrenTransitions;
    return Transition;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

var PoseGroup = (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PoseGroup, _super);
    function PoseGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PoseGroup.prototype.render = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(Transition, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props));
    };
    PoseGroup.defaultProps = {
        flipMove: true
    };
    return PoseGroup;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]));

/* harmony default export */ __webpack_exports__["b"] = (posed);



/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PromoContext", function() { return PromoContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnauthorizedView", function() { return UnauthorizedView; });
/* harmony export (immutable) */ __webpack_exports__["default"] = FillupPage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Loadable__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_UnitedHeader__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_ErrorPopup_Error__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Auth_Auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Private__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_OfflinePopup_OfflinePopup__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_Chat__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Icons_Warning__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_Spinners_BrandSpinner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_utils__ = __webpack_require__(81);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  margin: 40px;\n  text-align: center;\n"],["\n  margin: 40px;\n  text-align: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  border: 2px solid #e74c3c;\n  margin: 30px auto 30px;\n  padding: 30px;\n  max-width: 800px;\n  box-sizing: border-box;\n\n  @media (max-width: 425px) {\n    border: none;\n    margin: 30px 0;\n  }\n"],["\n  border: 2px solid #e74c3c;\n  margin: 30px auto 30px;\n  padding: 30px;\n  max-width: 800px;\n  box-sizing: border-box;\n\n  @media (max-width: 425px) {\n    border: none;\n    margin: 30px 0;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 30px;\n  color: #e74c3c;\n"],["\n  width: 60px;\n  height: 60px;\n  margin: 0 auto 30px;\n  color: #e74c3c;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-size: 25px;\n  color: #e74c3c;\n"],["\n  font-size: 25px;\n  color: #e74c3c;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow-x: auto;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow-x: auto;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  padding-top: 50px;\n  text-align: center;\n  background: ",";\n  background-size: cover;\n\n  @media (max-width: 959px) {\n    padding-top: 25px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-bottom: 25px;\n  }\n"],["\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  padding-top: 50px;\n  text-align: center;\n  background: ",";\n  background-size: cover;\n\n  @media (max-width: 959px) {\n    padding-top: 25px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-bottom: 25px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin: 0 auto;\n  min-width: 450px;\n  width: 450px;\n\n  @media (max-width: 480px) {\n    min-width: 340px;\n    width: 340px;\n  }\n\n  @media (max-width: 360px) {\n    min-width: 300px;\n    width: 300px;\n  }\n"],["\n  margin: 0 auto;\n  min-width: 450px;\n  width: 450px;\n\n  @media (max-width: 480px) {\n    min-width: 340px;\n    width: 340px;\n  }\n\n  @media (max-width: 360px) {\n    min-width: 300px;\n    width: 300px;\n  }\n"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function writePromoCode(code){try{localStorage.setItem("promocode",code.toUpperCase());}catch(error){}}function readPromoCode(){var query=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(window.location.search.slice(1));if(query.promocode){return query.promocode;}else{var code=null;try{code=localStorage.getItem("promocode");}catch(error){}return code||"";}}var PromoContext=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createContext({onValidatePromo:function onValidatePromo(){},isPromoApplied:false,isFetchPromoInProgress:false,promoCode:"",onInputPromo:function onInputPromo(){},promo_error:false,promo:{}});var Center=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].h1(_templateObject);var ErrorWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].h1(_templateObject2);var IconWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3);var ErrorMess=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject4);// Делаем лэйауты асинхронными
var defaultDesktopLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 2090));},"components/Fillup/Desktop365Variant1/Layout");var defaultMobileLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 2091));},"components/Fillup/MobileWalkthrough11/Layout");var alwaysPortraitMobileLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 2092));},"components/Fillup/MobileWalkthrough11/PortraitLayout");var alwaysLandscapeMobileLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 2087));},"components/Fillup/MobileWalkthrough11/LandscapeLayout");var oldDesktopLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 2093));},"components/Fillup/Desktop/Desktop");var newDesktopLayout2=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 2083));},"components/Fillup/Desktop365Variant2/Layout");var newMobileLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 2094));},"components/Fillup/Mobile365/Layout");var desktopStepsLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 2095));});var mobileAmountInputLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 2096));});var mobileWithTipsLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 2097));});var payTotalLayout=Object(__WEBPACK_IMPORTED_MODULE_10__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 2098));});var layouts={"4":oldDesktopLayout,"5":defaultDesktopLayout,"6":newDesktopLayout2,"7":desktopStepsLayout,"8":newDesktopLayout2,"9":defaultMobileLayout,"10":defaultMobileLayout,"11":defaultMobileLayout,"12":defaultMobileLayout,"13":newMobileLayout,"14":mobileAmountInputLayout,"15":mobileWithTipsLayout,"16":newMobileLayout,"17":mobileWithTipsLayout,"20":alwaysPortraitMobileLayout,"21":alwaysLandscapeMobileLayout,"22":payTotalLayout,"23":newDesktopLayout2,"24":newMobileLayout,"25":oldDesktopLayout,"26":defaultMobileLayout,"27":newDesktopLayout2,"28":mobileWithTipsLayout,"29":newDesktopLayout2,"30":mobileWithTipsLayout};function toDefault(value,defaultValue){if(value!=null){return value;}return defaultValue;}function animatedScrollTo(destination){var startTime=Date.now();var startY=window.scrollY;var acceleration=startY/(destination*destination);var startSpeed=-startY/destination-acceleration*destination;requestAnimationFrame(function scroll(){var now=Date.now();var elapsedTime=now-startTime;var y=startY+startSpeed*elapsedTime+acceleration*elapsedTime*elapsedTime;window.scrollTo(0,y);if(elapsedTime<500){requestAnimationFrame(scroll);}});}function isValidTextValue(value){return typeof value==="string"&&value.trim()!=="";}function submitPost(url){var _url$split=url.split("?"),_url$split2=_slicedToArray(_url$split,2),action=_url$split2[0],query=_url$split2[1];var params=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(query);var form=document.createElement("form");form.action=action;form.method="post";var keys=Object.keys(params);var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=keys[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;var input=document.createElement("input");input.type="text";input.name=key;input.value=params[key];form.appendChild(input);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}document.body.appendChild(form);form.submit();}// Лэйауты наследуют большинство стейта, но, в отличие от стейта
var Fillup=function(_React$Component){_inherits(Fillup,_React$Component);function Fillup(props){var _this2=this;_classCallCheck(this,Fillup);var _this=_possibleConstructorReturn(this,(Fillup.__proto__||Object.getPrototypeOf(Fillup)).call(this,props));_this.shouldAnimateChatButton=true;_this.promoErrorCount=0;_this.userPlatform=function(){var ua=window.navigator.userAgent.toLowerCase();// iOS Terminal
var isIosTerminal=/com.ironterminal.ios/g.test(ua);// Android Webview full app
var isWebView=/wvbo_full/g.test(ua);// Android Webview analytics
var isAnalyticsWebView="irontrade"==="irontrade"&&/androidweb.*com\.irontrade\.analytics.*wvbo/g.test(ua)&&!isWebView;// iOS Webview Analytics
var isIosAnalyticsWebView=/iosweb.*com\.full\.iron.*wvbo_full/.test(ua);switch(true){case _this.props.serverData.isIOS&&_this.props.serverData.app_version>0:return"webview-ios";case isIosTerminal:return"webview-ios-terminal";case isIosAnalyticsWebView:return"webview-ios-analytics";case isWebView:case _this.props.serverData.isAndroidApp:return"webview-android";case isAnalyticsWebView:return"webview-android-analytics";case Object(__WEBPACK_IMPORTED_MODULE_22__components_common_Link__["e" /* isWebApp */])():return"webapp";case _this.props.serverData.isMobile:return"web-mobile";default:return"web-desktop";}};_this.setShowOfflinePopup=function(show){_this.setState({showOfflinePopup:show});};_this.handleNextPaymentValue=function(deposit){_this.setState({deposit:deposit});};_this.handleNextPanValue=function(customer_pan_number){_this.setState({customer_pan_number:customer_pan_number});};_this.handleNextBillingType=function(billingType){_this.setState({billingType:billingType,scratchCardProvider:null,bank:null});};_this.handleNextBank=function(bank){_this.setState({bank:bank,general_error:null});};_this.handleRequestPhone=function(val){_this.setState({requestPhone:val});};_this.handleVodafoneCode=function(code){_this.setState({vodafoneCode:code});};_this.handleFullNameChange=function(fullName){_this.setState({fullName:fullName,fullName_error:null});};_this.handleErrorPopupDismiss=function(){_this.setState({server_error:null});};_this.handlePhoneNumberChange=function(phoneNumber){_this.setState({phoneNumber:phoneNumber,phoneNumber_error:null});};_this.validatePhoneNumber=function(phoneVerified){_this.setState({phoneVerified:phoneVerified});_this.props.dispatch({type:"REQUEST_PROFILE"});};_this.handleScratchCardProviderChange=function(scratchCardProvider){_this.setState({scratchCardProvider:scratchCardProvider});};_this.handleScratchCardNumberChange=function(scratchCardNumber){_this.setState({scratchCardNumber:scratchCardNumber.replace(/[^0-9a-zA-Z]/g,""),scratchCard_error:false});};_this.handleScratchCardPINChange=function(scratchCardPIN){_this.setState({scratchCardPIN:scratchCardPIN.replace(/[^0-9a-zA-Z]/g,""),scratchCard_error:false});};_this.handleBonusSwitch=function(isBonusApplied){_this.setState({isBonusApplied:isBonusApplied});};_this.handleCreditCard=function(creditCardData){_this.setState({creditCardData:creditCardData},function(){_this.hanldleFormSubmission();});};_this.hanldleFormSubmission=function(){if(_this.state.isFetchInProgress){return false;}var currentBillingType=toDefault(_this.state.billingType,_this.props.config.defaultBilling);var currentBilling=_this.props.config.billings[currentBillingType];if(!currentBilling){return;}var profileFieldsContainer=document.getElementById("field_container");if(currentBillingType==="ipaytotal"&&!_this.state.displayCreditCardForm){_this.setState({displayCreditCardForm:true});return false;}_this.setState({isFetchInProgress:true},function(){// Валидации
if(currentBilling.needsPanNumber){if(!_this.state.customer_pan_number){_this.setState({isFetchInProgress:false,pan_error:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Fill in PAN")});animatedScrollTo(800);return;}else{var rExp=/^([a-zA-Z]{5})[0-9]{4}[a-zA-Z]{1}$/;var test=rExp.test(_this.state.customer_pan_number);if(!test){_this.setState({isFetchInProgress:false,pan_error:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Fill in correct PAN")});animatedScrollTo(800);return;}}}// Если надо было выбрать банк,
// а ты ничего даже и не выбрал
if(_this.props.config.banksSettings&&_this.props.config.banksSettings[currentBillingType]!=null&&_this.state.bank===null){var settings=_this.props.config.banksSettings[currentBillingType];if(settings.banks!=null&&_this.state.bank==null){_this.setState({isFetchInProgress:false,general_error:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Choose bank")});animatedScrollTo(800);return;}else if(settings.payment_points!=null&&_this.state.bank==null){_this.setState({isFetchInProgress:false,general_error:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Choose payment point")});animatedScrollTo(800);return;}else if(settings.provider!=null&&_this.state.bank==null){_this.setState({isFetchInProgress:false,general_error:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Choose phone provider")});animatedScrollTo(800);return;}}if(currentBilling.is_scratch===true){if(!_this.state.scratchCardNumber.trim()||!_this.state.scratchCardPIN.trim()){_this.setState({isFetchInProgress:false,scratchCard_error:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"All fields are required")});return;}}// Когда надо было дополнить данные профиля
if(currentBilling.needsFullName||currentBilling.needsPhoneNumber){var errors={};// А ты ни имени своего,
if(currentBilling.needsFullName&&typeof _this.state.fullName==="string"&&_this.state.fullName.trim()===""){errors.fullName_error=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Error! Fill in all fields!");}// Ни телефона не указал
if(currentBilling.needsPhoneNumber&&typeof _this.state.phoneNumber==="string"&&_this.state.phoneNumber.trim()===""){errors.phoneNumber_error=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Gettext__["b" /* default */],null,"Enter your phone!");}// Ну что же ты за человек?
// Вот и смотри теперь на ошибки.
if(Object.keys(errors).length>0){_this.setState(Object.assign({isFetchInProgress:false},errors));if(profileFieldsContainer){profileFieldsContainer.scrollIntoView({block:"start",behavior:"smooth"});}return;}_this.props.fetch("/api/update-profile-payment?first_name="+(_this.state.fullName||"")+"&phone="+(_this.state.phoneNumber||""),{unstable_dontInferResponse:true}).then(function(json){if(json.status==="OK"){_this.submit();return;}//TODO Костыль на скорую руку, ошибка приходит с сервера, мы ее расчленяем жутким хардкодом, так как образца для телефона нет
if(!_this.state.general_error){return _this.setState({phoneNumber_error:json.message.split("!")[0]+"!"});}_this.setState({general_error:json.message});});return;}// На этом месте все валидации либо
// прошли, либо не нужны. Отправляем.
_this.submit();});};_this.success_RBKpayment=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var realAccount,data,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:console.log("Payment successful finished");realAccount=_this.props.accounts.find(function(acc){return acc.type==="real";});// просто редиректим на трейд если нету реального аккаунта,
// или он уже активен
if(!(!realAccount||realAccount.isActive===true)){_context.next=5;break;}_this.setState({isFetchInProgress:false});return _context.abrupt("return",_this.props.history.push("/trade"));case 5:_context.next=7;return _this.props.fetch("/ajax/setAccount?id="+realAccount.id);case 7:data=_context.sent;if(data.status==="OK"){_this.props.dispatch({type:"SWITCH_ACCOUNTS"});}_context.next=11;return _this.props.fetch("/api/profile");case 11:payload=_context.sent;_this.props.dispatch({type:"RECEIVE_PROFILE",payload:payload});_this.setState({isFetchInProgress:false});_this.props.history.push("/trade");case 15:case"end":return _context.stop();}}},_callee,_this2);}));_this.special_fetchRBKInvoice=function(){// Форк функции aubmit, специфичный для метода оплаты RBK
var currentBilling=toDefault(_this.state.billingType,_this.props.config.defaultBilling);var currentDeposit=toDefault(_this.state.deposit,parseFloat(_this.props.config.defaultDeposit)||_this.props.config.getDefaultValue(currentBilling));var isPredefinedValue=_this.props.config.deposits.some(function(deposit){return deposit.amount===currentDeposit;});var bonus=_this.state.isBonusApplied?Object(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["g" /* getPaymentBonus */])(_this.props.config,currentDeposit)+Object(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["e" /* getBillingBonus */])(_this.props.config,currentBilling):0;var params={src_layout:"fillup"+_this.props.config.layout,amountPercent:bonus,amount:currentDeposit,billing:_this.props.config.billings[currentBilling].inputValue,radio:isPredefinedValue?"on":"off",bank_code:__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this.props.config.banksSettings,function(_){return _[currentBilling].banks;})&&_this.state.bank,payment_point:__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this.props.config.banksSettings,function(_){return _[currentBilling].payment_points;})&&_this.state.bank,no_bonus:_this.state.isBonusApplied?0:1,ptest:_this.props.config.ptest?1:0,coupon:_this.state.isBonusApplied&&_this.state.promo!=null?_this.state.promoCode:undefined};var fetchParams={method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(params)};return _this.props.fetch("/billing",fetchParams).then(function(data){if(data.status!=="OK"){_this.setState({server_error:data.message||data.msg,isFetchInProgress:false});return console.error("ServerError: "+(data.message||data.msg));}else{return data.data.widget?data.data.widget:data.data;}});};_this.special_RBKonSubmit=function(invoice){var currentBilling=toDefault(_this.state.billingType,_this.props.config.defaultBilling);var currentDeposit=toDefault(_this.state.deposit,parseFloat(_this.props.config.defaultDeposit)||_this.props.config.getDefaultValue(currentBilling));var bonus=_this.state.isBonusApplied?Object(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["g" /* getPaymentBonus */])(_this.props.config,currentDeposit)+Object(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["e" /* getBillingBonus */])(_this.props.config,currentBilling):0;Object(__WEBPACK_IMPORTED_MODULE_17__components_GA__["a" /* gaReducer */])("CLICKBTN_FILLUP",{paymentMethod:currentBilling,amount:currentDeposit,bonusAmount:bonus});window.RbkmoneyCheckout.configure(Object.assign({},invoice,{opened:function opened(){console.log("Checkout opened");},closed:function closed(){console.log("Checkout closed");_this.setState({isFetchInProgress:false});},finished:function finished(){_this.success_RBKpayment();},popupMode:!Object(__WEBPACK_IMPORTED_MODULE_23__components_utils__["c" /* isIronTerminal */])()})).open();};_this.submit=function(){_this.shouldAnimateChatButton=false;var billingAtNewWindow=_this.userPlatform()==="web-mobile"||_this.userPlatform()==="web-desktop";var currentBilling=toDefault(_this.state.billingType,_this.props.config.defaultBilling);var currentDeposit=toDefault(_this.state.deposit,parseFloat(_this.props.config.defaultDeposit)||_this.props.config.getDefaultValue(currentBilling));var isPredefinedValue=_this.props.config.deposits.some(function(deposit){return deposit.amount===currentDeposit;});var bonus=_this.state.isBonusApplied?Object(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["g" /* getPaymentBonus */])(_this.props.config,currentDeposit)+Object(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["e" /* getBillingBonus */])(_this.props.config,currentBilling):0;if(currentBilling!=="kerry"){Object(__WEBPACK_IMPORTED_MODULE_17__components_GA__["a" /* gaReducer */])("CLICKBTN_FILLUP",{paymentMethod:currentBilling,amount:currentDeposit,bonusAmount:bonus});}var params=void 0;if(currentBilling==="ipaytotal"){params=Object.assign({src_layout:"fillup"+_this.props.config.layout,amountPercent:bonus,amount:currentDeposit,billing:_this.props.config.billings[currentBilling].inputValue,no_bonus:_this.state.isBonusApplied?0:1,coupon:_this.state.isBonusApplied&&_this.state.promo!=null?_this.state.promoCode:undefined},_this.state.creditCardData);}else if(_this.props.config.billings[currentBilling].is_scratch===true){// Особенные параметры для типа оплаты "скретч-карта"
var _this$state=_this.state,scratchCardProvider=_this$state.scratchCardProvider,scratchCardNumber=_this$state.scratchCardNumber,scratchCardPIN=_this$state.scratchCardPIN;var providersKeys=Object.keys(_this.props.config.billings[currentBilling].providers);var firstScratchProvider=providersKeys[0];params={src_layout:"fillup"+_this.props.config.layout,provider:scratchCardProvider||firstScratchProvider,serial_number:scratchCardNumber,pin_code:scratchCardPIN,billing:_this.props.config.billings[currentBilling].inputValue,no_bonus:_this.state.isBonusApplied?0:1};}else{params={src_layout:"fillup"+_this.props.config.layout,amountPercent:bonus,amount:currentDeposit,billing:_this.props.config.billings[currentBilling].inputValue,radio:isPredefinedValue?"on":"off",bank_code:__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this.props.config.banksSettings,function(_){return _[currentBilling].banks;})&&_this.state.bank,payment_point:__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this.props.config.banksSettings,function(_){return _[currentBilling].payment_points;})&&_this.state.bank,no_bonus:_this.state.isBonusApplied?0:1,ptest:_this.props.config.ptest?1:0,coupon:_this.state.isBonusApplied&&_this.state.promo!=null?_this.state.promoCode:undefined,provider:__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this.props.config.banksSettings,function(_){return _[currentBilling].providers;})&&_this.state.bank,customer_pan_number:_this.state.customer_pan_number,vodafoneCode:_this.state.vodafoneCode||undefined};}// кастомный редирект для Kerry Express
if(currentBilling==="kerry"){_this.props.history.push("/billing/kerry-express?"+__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(params),Object.assign({},params,{bonus:bonus}));return;}var fetchParams={method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(params)};_this.props.fetch("/billing",fetchParams).then(function(data){if(data.status!=="OK"){_this.setState({server_error:data.message||data.msg,isFetchInProgress:false});return console.error("ServerError: "+(data.message||data.msg));}//хардкод ключей из биллинг-конфига для редиректа на страницу оффлайн-платежа, если продолжаешь хардкодить сюда, то не забудь и про offline-billing.js
if(["offline","offline_vnd","offline_php","atm","offlineBankingVND","offlineBankingPHP","offlineBanking"].some(function(type){return type===currentBilling;})){var query=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify({type:currentBilling,payment_id:data.payment_id});_this.setState({redirectTo:"/billing/offline?"+query+"&"+__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(params),isFetchInProgress:true// Keep it true to still block buttons until redirect
});}else if(currentBilling==="rbkmoney"){var invoice=data.data.widget?data.data.widget:data.data;window.RbkmoneyCheckout.configure(Object.assign({},invoice,{opened:function opened(){console.log("Checkout opened");},closed:function closed(){console.log("Checkout closed");_this.setState({isFetchInProgress:false});},finished:function finished(){_this.success_RBKpayment();}})).open();}else if(currentBilling==="ipaytotal"){// Биллинг ipaytotal требует передачи данных карты, поэтому из осто-
// рожности мы договорились перенаправлять клиента запросом POST
submitPost(data.redirect);}else if(currentBilling==="dusupay_mobile_money"){if(billingAtNewWindow&&window.open(data.redirect)){_this.setState({isFetchInProgress:false});}else{window.location.href=data.redirect;}}else{// this.setState({
//   redirectTo: data.redirect
// })
if(billingAtNewWindow&&window.open(data.redirect)){_this.setState({isFetchInProgress:false});}else{window.location.href=data.redirect;}}}).catch(function(error){console.log(error);_this.setState({isFetchInProgress:false});});};_this.handleRemovePromo=function(){_this.setState({promoCode:"",promo:null});try{if(localStorage.getItem("promocode")!=null){localStorage.removeItem("promocode");}}catch(error){console.error(error);}};_this.handleShowPromoModal=function(){_this.setState({isPromoModalActive:true});if(document.body)document.body.style.overflow="hidden";};_this.toggleInfoModal=function(){_this.setState({isInfoModalShown:!_this.state.isInfoModalShown},function(){if(_this.state.isInfoModalShown){if(document.body)document.body.style.overflow="hidden";}else{if(document.body)document.body.style.overflow="";}});};_this.handleHidePromoModal=function(){_this.state.promo_error===null?_this.setState({isPromoModalActive:false}):_this.setState({isPromoModalActive:false,promoCode:"",promo_error:null});if(document.body)document.body.style.overflow="";};_this.handlePromoCode=function(value){var val=value.trim();var matched=val.match(/[a-zA-Z0-9]+/g)||[];_this.setState({promoCode:matched.join("")});if(matched.length>0){_this.setState({promo_error:null});}};_this.handleValidatePromo=function(){var promoCode=_this.state.promoCode;var locale=__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this.props.profile,function(profile){return profile.locale;})||"en";_this.setState({isFetchPromoInProgress:true});return _this.props.api.fetchEntity("/api/promo-code-info?code="+promoCode+"&lang="+locale).then(function(entity){if(entity.status!=="Rejected"&&entity.value.status==="ERROR"){_this.promoErrorCount++;if(_this.promoErrorCount>1&&_this.shouldAnimateChatButton){Object(__WEBPACK_IMPORTED_MODULE_18__components_Chat__["a" /* animateChatButton */])();_this.shouldAnimateChatButton=false;}_this.setState({promo_error:entity.value.message,isFetchPromoInProgress:false,promo:null,promoCode:""},function(){_this.setState({isPromoModalActive:true});});writePromoCode("");return entity.value;}else{_this.promoErrorCount=0;_this.setState({isFetchPromoInProgress:false,promo:entity.value});writePromoCode(promoCode);return entity.value;}});};_this.closeInrModal=function(){_this.setState({showInrInfo:false});};var _ref2=props.profile!=null?props.profile:{first_name:null,phone:null,phone_confirmed:0},first_name=_ref2.first_name,phone=_ref2.phone,phone_confirmed=_ref2.phone_confirmed;//Если поля существуют и не пустые строки то в стейте ставим
//их в null(!) для дальнейшего перфоманса с проверками
_this.state={showOfflinePopup:false,offlineBanks:null,deposit:null,billingType:null,bank:props.config.defaultBank,requestPhone:false,vodafoneCode:null,fullName:isValidTextValue(first_name)?null:"",phoneNumber:isValidTextValue(phone)?null:"",phoneVerified:phone_confirmed===1,scratchCardProvider:null,scratchCardNumber:"",scratchCardPIN:"",isBonusApplied:true,server_error:null,general_error:null,fullName_error:null,pan_error:null,phoneNumber_error:null,redirectTo:null,isFetchInProgress:false,isPromoModalActive:false,isFetchPromoInProgress:false,isInitialFetchPromoInProgress:false,promoCode:readPromoCode(),promo_error:null,promo:null,isInfoModalShown:false,displayCreditCardForm:false,creditCardData:null,showInrInfo:true,customer_pan_number:null};return _this;}// componentWillReceiveProps(nextProps) {
//   if (nextProps.profile !== this.props.profile && nextProps.profile != null) {
//     const { first_name, phone } = nextProps.profile;
//     //Если поля существуют и не пустые строки то в стейте ставим
//     //их в null(!) для дальнейшего перфоманса с проверками
//
//     this.setState({
//       fullName: isValidTextValue(first_name) ? null : "",
//       phoneNumber: isValidTextValue(phone) ? null : ""
//     });
//   }
// }
_createClass(Fillup,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;var layout=this.props.config&&this.props.config.layout;if(layout){this.props.fetch("/api/track-deposit-form?layout="+layout);}if(this.state.promoCode!==""){this.setState({isInitialFetchPromoInProgress:true});var query=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(window.location.search.slice(1));if(query.promocode){this.handleValidatePromo().then(function(){_this3.setState({isPromoModalActive:true,isInitialFetchPromoInProgress:false});},function(){_this3.setState({isPromoModalActive:true,isInitialFetchPromoInProgress:false});});}else{this.handleValidatePromo().then(function(){_this3.setState({isPromoModalActive:false,// <--- отличие!
isInitialFetchPromoInProgress:false});},function(){_this3.setState({isPromoModalActive:true,isInitialFetchPromoInProgress:false});});}}if(this.props.profile!=null){var _props$profile=this.props.profile,first_name=_props$profile.first_name,phone=_props$profile.phone;//Если поля существуют и не пустые строки то в стейте ставим
//их в null(!) для дальнейшего перфоманса с проверками
this.setState({fullName:isValidTextValue(first_name)?null:"",phoneNumber:isValidTextValue(phone)?null:""});}if(window.androidApp&&typeof window.androidApp.depositReady==="function"){window.androidApp.depositReady();}this.chatAnimationTimer=setTimeout(function(){if(_this3.shouldAnimateChatButton){Object(__WEBPACK_IMPORTED_MODULE_18__components_Chat__["a" /* animateChatButton */])();}},90000);this.props.fetch("/api/incomplete-offline-payments/",{unstable_dontInferResponse:true}).then(function(data){_this3.setState({offlinePaymentId:data.status==="OK"&&data.latest||null});});this.props.fetch("/api/offline-payment/banks",{unstable_dontInferResponse:true}).then(function(offlineBanks){return _this3.setState({offlineBanks:offlineBanks});});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(__WEBPACK_IMPORTED_MODULE_2_idx___default()(prevProps.profile,function(profile){return profile.locale;})!==__WEBPACK_IMPORTED_MODULE_2_idx___default()(this.props.profile,function(profile){return profile.locale;})&&this.state.promoCode!==""){this.handleValidatePromo();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.chatAnimationTimer);}},{key:"render",value:function render(){var _this4=this;if(Object.keys(this.props.config.billings).length===0){return[__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_UnitedHeader__["b" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ErrorWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IconWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__components_Icons_Warning__["a" /* default */],{width:"100%"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ErrorMess,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Center,null,"Sorry, but it seems like your currency is not payable.")))];}if(this.props.profile==null){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_UnitedHeader__["b" /* default */],null),"Login please.");}var currentBilling=toDefault(this.state.billingType,this.props.config.defaultBilling);var currentDeposit=toDefault(this.state.deposit,parseFloat(this.props.config.defaultDeposit)||this.props.config.getDefaultValue(currentBilling));var devLayout=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(window.location.search.slice(1)).layout&&__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(window.location.search.slice(1)).layout;var layoutNumber=devLayout||this.props.config.layout||"4";var Layout=this.state.displayCreditCardForm?payTotalLayout:layouts[layoutNumber];var currency=this.props.profile.currency;var currencySettings=this.props.apiConfigs.currencySettings;var settingsForCurrency=currencySettings[currency];var billing=this.props.config.billings[currentBilling];var minimumValue=0;if(billing!=null&&billing.min_amount!=null){minimumValue=billing.min_amount;}else if(settingsForCurrency){minimumValue=settingsForCurrency.minFillup||0;}var fillup={error:this.state.server_error,isSlipActive:this.state.offlineBanks&&this.state.offlinePaymentId,setShowOfflinePopup:this.setShowOfflinePopup,locale:this.props.profile&&this.props.profile.locale,deposit_count:this.props.profile&&this.props.profile.finance&&this.props.profile.finance.deposit_count,config:this.props.config,isIOS:this.props.serverData&&this.props.serverData.isIOS,appVersion:this.props.serverData&&this.props.serverData.appVersion,currencyData:{currency:currency,symbol:settingsForCurrency&&settingsForCurrency.rawSymbol},currency:currency,minimumValue:minimumValue,deposit:layoutNumber==="14"&&this.state.deposit==null?0:currentDeposit,// депозит и способ оплаты должны
billingType:currentBilling,// быть определены однозначно
customer_pan_number:this.state.customer_pan_number,bank:this.state.bank,requestPhone:this.state.requestPhone,vodafoneCode:this.state.vodafoneCode,fullName:this.state.fullName,phoneNumber:this.state.phoneNumber,phoneNumberProps:this.props.profile&&this.props.profile.phone,phoneVerified:this.state.phoneVerified,scratchCardProviders:billing&&billing.providers||{},scratchCardProvider:this.state.scratchCardProvider,scratchCardNumber:this.state.scratchCardNumber,scratchCardPIN:this.state.scratchCardPIN,isBonusApplied:this.state.isBonusApplied,scratchCard_error:this.state.scratchCard_error,general_error:this.state.general_error,fullName_error:this.state.fullName_error,pan_error:this.state.pan_error,phoneNumber_error:this.state.phoneNumber_error,onNextPaymentValue:this.handleNextPaymentValue,onNextPanValue:this.handleNextPanValue,onNextBillingType:this.handleNextBillingType,onNextBank:this.handleNextBank,onRequestPhone:this.handleRequestPhone,onVodafoneCode:this.handleVodafoneCode,onFullNameChange:this.handleFullNameChange,onPhoneNumberChange:this.handlePhoneNumberChange,onScratchCardProviderChange:this.handleScratchCardProviderChange,onScratchCardNumberChange:this.handleScratchCardNumberChange,onScratchCardPINChange:this.handleScratchCardPINChange,onBonusSwitch:this.handleBonusSwitch,onSubmit:this.hanldleFormSubmission,onPayTotalSubmit:this.handleCreditCard,validatePhoneNumber:this.validatePhoneNumber,isFetchInProgress:this.state.isFetchInProgress,onRemovePromo:this.handleRemovePromo,onShowPromoModal:this.handleShowPromoModal,isPromoModalActive:this.state.isPromoModalActive,onDismissPromoModal:this.handleHidePromoModal,onValidatePromo:this.handleValidatePromo,isFetchPromoInProgress:this.state.isFetchPromoInProgress,promoCode:this.state.promoCode,onInputPromo:this.handlePromoCode,promo_error:this.state.promo_error,promo:this.state.promo,toggleInfoModal:this.toggleInfoModal,isInfoModalShown:this.state.isInfoModalShown,special_fetchRBKInvoice:this.special_fetchRBKInvoice,special_RBKonSubmit:this.special_RBKonSubmit};var layoutProps=Object.assign({},fillup,{fillup:fillup,history:this.props.history});if(this.state.isInitialFetchPromoInProgress){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_Spinners_BrandSpinner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",{style:{display:"none"},qa_attr:"layout_"+this.props.config.layout}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_UnitedHeader__["b" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PromoContext.Provider,{value:{onValidatePromo:this.handleValidatePromo,isPromoApplied:this.state.promo!=null,isFetchPromoInProgress:this.state.isFetchPromoInProgress,promoCode:this.state.promoCode,onInputPromo:this.handlePromoCode,promo_error:this.state.promo_error,promo:this.state.promo}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Layout,Object.assign({},layoutProps,{offlineBanks:this.state.offlineBanks,offlinePaymentId:this.state.offlinePaymentId})),this.state.showOfflinePopup&&this.state.offlineBanks&&this.state.offlinePaymentId&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_OfflinePopup_OfflinePopup__["a" /* default */],{lang:fillup.locale,isiOSApp:fillup.isIOS,appVersion:fillup.appVersion,recipient:this.state.offlineBanks.account.full_name,banks:this.state.offlineBanks.banks,paymentId:this.state.offlinePaymentId,currency:fillup.currencyData&&fillup.currencyData.currency,currencySymbol:fillup.currencyData.symbol,desktop:false,onClose:function onClose(){return _this4.setShowOfflinePopup(false);}})),this.state.redirectTo!=null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["d" /* Redirect */],{push:true,to:this.state.redirectTo}),this.state.server_error!=null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_ErrorPopup_Error__["b" /* default */],{message:this.state.server_error,onDismiss:this.handleErrorPopupDismiss}));}}]);return Fillup;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function ConfiguredFillup(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_FillupConfiguration__["a" /* FillupConfiguration */],{locale:props.profile.locale,currency:props.profile.currency,location:props.location},function(config){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fillup,{config:config,key:__WEBPACK_IMPORTED_MODULE_2_idx___default()(props.profile,function(profile){return profile.id;}),apiConfigs:props.apiConfigs,serverData:props.serverData,currencySettings:props.serverData,profile:props.profile,location:props.location,match:props.match,history:props.history,fetch:__WEBPACK_IMPORTED_MODULE_8__components_common_fetch__["d" /* get */],api:api,accounts:props.accounts,dispatch:props.dispatch});});});}var Wrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5);var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject6,function(_ref3){var theme=_ref3.theme;return  true?"#3B9478 linear-gradient( to top, #55c784 0%, #1b546a 100% );":"url("+theme.indexHeaderBackground+") no-repeat 50% 0";});var FormContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject7);var UnauthorizedView=function(_React$Component2){_inherits(UnauthorizedView,_React$Component2);function UnauthorizedView(){var _ref4;var _temp,_this5,_ret;_classCallCheck(this,UnauthorizedView);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this5=_possibleConstructorReturn(this,(_ref4=UnauthorizedView.__proto__||Object.getPrototypeOf(UnauthorizedView)).call.apply(_ref4,[this].concat(args))),_this5),_this5.state={activeTab:_this5.props.defaultTab||"login"},_this5.dispatch=function(action){if(action.type==="DISPLAY_AUTH_TAB"){_this5.setState({activeTab:action.payload});}},_temp),_possibleConstructorReturn(_this5,_ret);}_createClass(UnauthorizedView,[{key:"componentDidMount",value:function componentDidMount(){if(window.androidApp&&typeof window.androidApp.depositReady==="function"){window.androidApp.depositReady();}}},{key:"render",value:function render(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_UnitedHeader__["b" /* default */],{hideTradeButton:true}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FormContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_fetch__["b" /* Server */].Consumer,{preload:["/api/server-data","/api/countries"]},function(api){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_Auth_Auth__["d" /* RawAuth */],{geo:api.get("/api/server-data").geo,apiCountries: false?undefined:api.get("/api/countries"),isVIP:false,activeTab:_this6.state.activeTab,showSocial:true,ref_user:null,dispatch:_this6.dispatch,profile:_this6.props.profile,query:_this6.props.query,email:_this6.props.query.email,location:_this6.props.location,history:_this6.props.history,type:"irontrade"==="irontrade"&&"newIndex"});}))));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps){if(this==null||nextProps.defaultTab!==this.props.defaultTab){return{activeTab:nextProps.defaultTab};}else{return null;}}}]);return UnauthorizedView;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);function _AuthorizedView(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ConfiguredFillup,{serverData:props.serverData,apiConfigs:props.apiConfigs,profile:props.profile,location:props.location,match:props.match,history:props.history,accounts:props.accounts,dispatch:props.dispatch});}var AuthorizedView=Object(__WEBPACK_IMPORTED_MODULE_15__components_Private__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_7__components_withData__["a" /* default */])(["serverData","apiConfigs","profile","remoteTradeSettings","accounts"])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])()(_AuthorizedView)));function FillupPage(props){var MemoFillupPage=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AuthorizedView,{location:props.location,match:props.match,history:props.history});},[]);return MemoFillupPage;}

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_proptype_conditional_require__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_proptype_conditional_require___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_proptype_conditional_require__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_popper_js__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exenv__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_exenv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_exenv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_lite__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_deepmerge__ = __webpack_require__(1473);









function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

var DEFAULTS = {flip:{padding:20},preventOverflow:{padding:10}};

var STATUS = {INIT:'init',IDLE:'idle',OPENING:'opening',OPEN:'open',CLOSING:'closing',ERROR:'error'};

var canUseDOM=__WEBPACK_IMPORTED_MODULE_2_exenv___default.a.canUseDOM;var isReact16=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.createPortal!==undefined;function comparator(data,nextData){return {changedFrom:function changedFrom(key,previous,actual){return data[key]===previous&&nextData[key]===actual;},changedTo:function changedTo(key,actual){return data[key]!==actual&&nextData[key]===actual;},changed:function changed(key){return data[key]!==nextData[key];}};}function isMobile(){return 'ontouchstart'in window&&/Mobi/.test(navigator.userAgent);}/**
 * Log method calls if debug is enabled
 *
 * @private
 * @param {Object}       arg
 * @param {string}       arg.title    - The title the logger was called from
 * @param {Object|Array} [arg.data]   - The data to be logged
 * @param {boolean}      [arg.warn]  - If true, the message will be a warning
 * @param {boolean}      [arg.debug] - Nothing will be logged unless debug is true
 */function log(_ref){var title=_ref.title,data=_ref.data,_ref$warn=_ref.warn,warn=_ref$warn===void 0?false:_ref$warn,_ref$debug=_ref.debug,debug=_ref$debug===void 0?false:_ref$debug;/* eslint-disable no-console */var logFn=warn?console.warn||console.error:console.log;if(debug&&title&&data){console.groupCollapsed("%creact-floater: ".concat(title),'color: #9b00ff; font-weight: bold; font-size: 12px;');if(Array.isArray(data)){data.forEach(function(d){if(__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].plainObject(d)&&d.key){logFn.apply(console,[d.key,d.value]);}else{logFn.apply(console,[d]);}});}else{logFn.apply(console,[data]);}console.groupEnd();}/* eslint-enable */}function on(element,event,cb){var capture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;element.addEventListener(event,cb,capture);}function off(element,event,cb){var capture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;element.removeEventListener(event,cb,capture);}function once(element,event,cb){var capture=arguments.length>3&&arguments[3]!==undefined?arguments[3]:false;var _nextCB;_nextCB=function nextCB(e){//eslint-disable-line prefer-const
cb(e);off(element,event,_nextCB);};on(element,event,_nextCB,capture);}function noop(){}

var ReactFloaterPortal=/*#__PURE__*/function(_React$Component){_inherits(ReactFloaterPortal,_React$Component);function ReactFloaterPortal(props){var _this;_classCallCheck(this,ReactFloaterPortal);_this=_possibleConstructorReturn(this,_getPrototypeOf(ReactFloaterPortal).call(this,props));if(!canUseDOM)return _possibleConstructorReturn(_this);_this.node=document.createElement('div');if(props.id){_this.node.id=props.id;}if(props.zIndex){_this.node.style.zIndex=props.zIndex;}document.body.appendChild(_this.node);return _this;}_createClass(ReactFloaterPortal,[{key:"componentDidMount",value:function componentDidMount(){if(!canUseDOM)return;if(!isReact16){this.renderPortal();}}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(!canUseDOM)return;if(!isReact16){this.renderPortal();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!canUseDOM||!this.node)return;if(!isReact16){__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unmountComponentAtNode(this.node);}document.body.removeChild(this.node);}},{key:"renderPortal",value:function renderPortal(){if(!canUseDOM)return null;var _this$props=this.props,children=_this$props.children,setRef=_this$props.setRef;/* istanbul ignore else */if(isReact16){return __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.createPortal(children,this.node);}var portal=__WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.unstable_renderSubtreeIntoContainer(this,children.length>1?__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",null,children):children[0],this.node);setRef(portal);return null;}},{key:"renderReact16",value:function renderReact16(){var _this$props2=this.props,hasChildren=_this$props2.hasChildren,placement=_this$props2.placement,target=_this$props2.target;if(!hasChildren){if(target||placement==='center'){return this.renderPortal();}return null;}return this.renderPortal();}},{key:"render",value:function render(){if(!isReact16){return null;}return this.renderReact16();}}]);return ReactFloaterPortal;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);_defineProperty(ReactFloaterPortal,"propTypes",{children:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array]),hasChildren:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),placement:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,setRef:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,target:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),zIndex:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number});

var FloaterArrow=/*#__PURE__*/function(_React$Component){_inherits(FloaterArrow,_React$Component);function FloaterArrow(){_classCallCheck(this,FloaterArrow);return _possibleConstructorReturn(this,_getPrototypeOf(FloaterArrow).apply(this,arguments));}_createClass(FloaterArrow,[{key:"render",value:function render(){var _this$props=this.props,placement=_this$props.placement,setArrowRef=_this$props.setArrowRef,styles=_this$props.styles;var _styles$arrow=styles.arrow,color=_styles$arrow.color,display=_styles$arrow.display,length=_styles$arrow.length,position=_styles$arrow.position,spread=_styles$arrow.spread;var arrowStyles={display:display,position:position};var points;var x=spread;var y=length;/* istanbul ignore else */if(placement.startsWith('top')){points="0,0 ".concat(x/2,",").concat(y," ").concat(x,",0");arrowStyles.bottom=0;}else if(placement.startsWith('bottom')){points="".concat(x,",").concat(y," ").concat(x/2,",0 0,").concat(y);arrowStyles.top=0;}else if(placement.startsWith('left')){y=spread;x=length;points="0,0 ".concat(x,",").concat(y/2," 0,").concat(y);arrowStyles.right=0;}else if(placement.startsWith('right')){y=spread;x=length;points="".concat(x,",").concat(y," ").concat(x,",0 0,").concat(y/2);arrowStyles.left=0;}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"__floater__arrow",style:this.parentStyle},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",{ref:setArrowRef,style:arrowStyles},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("svg",{width:x,height:y,version:"1.1",xmlns:"http://www.w3.org/2000/svg"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("polygon",{points:points,fill:color}))));}},{key:"parentStyle",get:function get(){var _this$props2=this.props,placement=_this$props2.placement,styles=_this$props2.styles;var length=styles.arrow.length;var arrow={position:'absolute'};/* istanbul ignore else */if(placement.startsWith('top')){arrow.bottom=0;arrow.left=0;arrow.right=0;arrow.height=length;}else if(placement.startsWith('bottom')){arrow.left=0;arrow.right=0;arrow.top=0;arrow.height=length;}else if(placement.startsWith('left')){arrow.right=0;arrow.top=0;arrow.bottom=0;}else if(placement.startsWith('right')){arrow.left=0;arrow.top=0;}return arrow;}}]);return FloaterArrow;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);_defineProperty(FloaterArrow,"propTypes",{placement:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,setArrowRef:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,styles:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired});

var FloaterCloseBtn=function FloaterCloseBtn(_ref){var handleClick=_ref.handleClick,styles=_ref.styles;var color=styles.color,height=styles.height,width=styles.width,style=_objectWithoutProperties(styles,["color","height","width"]);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button",{"aria-label":"close",onClick:handleClick,style:style,type:"button"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("svg",{width:"".concat(width,"px"),height:"".concat(height,"px"),viewBox:"0 0 18 18",version:"1.1",xmlns:"http://www.w3.org/2000/svg",preserveAspectRatio:"xMidYMid"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("path",{d:"M8.13911129,9.00268191 L0.171521827,17.0258467 C-0.0498027049,17.248715 -0.0498027049,17.6098394 0.171521827,17.8327545 C0.28204354,17.9443526 0.427188206,17.9998706 0.572051765,17.9998706 C0.71714958,17.9998706 0.862013139,17.9443526 0.972581703,17.8327545 L9.0000937,9.74924618 L17.0276057,17.8327545 C17.1384085,17.9443526 17.2832721,17.9998706 17.4281356,17.9998706 C17.5729992,17.9998706 17.718097,17.9443526 17.8286656,17.8327545 C18.0499901,17.6098862 18.0499901,17.2487618 17.8286656,17.0258467 L9.86135722,9.00268191 L17.8340066,0.973848225 C18.0553311,0.750979934 18.0553311,0.389855532 17.8340066,0.16694039 C17.6126821,-0.0556467968 17.254037,-0.0556467968 17.0329467,0.16694039 L9.00042166,8.25611765 L0.967006424,0.167268345 C0.745681892,-0.0553188426 0.387317931,-0.0553188426 0.165993399,0.167268345 C-0.0553311331,0.390136635 -0.0553311331,0.751261038 0.165993399,0.974176179 L8.13920499,9.00268191 L8.13911129,9.00268191 Z",fill:color}))));};FloaterCloseBtn.propTypes={handleClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,styles:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired};

var FloaterContainer=function FloaterContainer(_ref){var content=_ref.content,footer=_ref.footer,handleClick=_ref.handleClick,open=_ref.open,positionWrapper=_ref.positionWrapper,showCloseButton=_ref.showCloseButton,title=_ref.title,styles=_ref.styles;var output={content:__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(content)?content:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"__floater__content",style:styles.content},content)};if(title){output.title=__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(title)?title:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"__floater__title",style:styles.title},title);}if(footer){output.footer=__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(footer)?footer:__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"__floater__footer",style:styles.footer},footer);}if((showCloseButton||positionWrapper)&&!__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].boolean(open)){output.close=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(FloaterCloseBtn,{styles:styles.close,handleClick:handleClick});}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"__floater__container",style:styles.container},output.close,output.title,output.content,output.footer);};FloaterContainer.propTypes={content:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired,footer:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,handleClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,open:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,positionWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,showCloseButton:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,styles:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node};

var Floater=/*#__PURE__*/function(_React$Component){_inherits(Floater,_React$Component);function Floater(){_classCallCheck(this,Floater);return _possibleConstructorReturn(this,_getPrototypeOf(Floater).apply(this,arguments));}_createClass(Floater,[{key:"render",value:function render(){var _this$props=this.props,component=_this$props.component,closeFn=_this$props.handleClick,hideArrow=_this$props.hideArrow,setFloaterRef=_this$props.setFloaterRef,status=_this$props.status;var output={};var classes=['__floater'];if(component){if(__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(component)){output.content=__WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(component,{closeFn:closeFn});}else{output.content=component({closeFn:closeFn});}}else{output.content=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(FloaterContainer,this.props);}if(status===STATUS.OPEN){classes.push('__floater__open');}if(!hideArrow){output.arrow=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(FloaterArrow,this.props);}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{ref:setFloaterRef,className:classes.join(' '),style:this.style},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"__floater__body"},output.content,output.arrow));}},{key:"style",get:function get(){var _this$props2=this.props,disableAnimation=_this$props2.disableAnimation,component=_this$props2.component,placement=_this$props2.placement,hideArrow=_this$props2.hideArrow,isPositioned=_this$props2.isPositioned,status=_this$props2.status,styles=_this$props2.styles;var length=styles.arrow.length,floater=styles.floater,floaterCentered=styles.floaterCentered,floaterClosing=styles.floaterClosing,floaterOpening=styles.floaterOpening,floaterWithAnimation=styles.floaterWithAnimation,floaterWithComponent=styles.floaterWithComponent;var element={};if(!hideArrow){if(placement.startsWith('top')){element.padding="0 0 ".concat(length,"px");}else if(placement.startsWith('bottom')){element.padding="".concat(length,"px 0 0");}else if(placement.startsWith('left')){element.padding="0 ".concat(length,"px 0 0");}else if(placement.startsWith('right')){element.padding="0 0 0 ".concat(length,"px");}}if([STATUS.OPENING,STATUS.OPEN].indexOf(status)!==-1){element=_objectSpread({},element,floaterOpening);}if(status===STATUS.CLOSING){element=_objectSpread({},element,floaterClosing);}if(status===STATUS.OPEN&&!disableAnimation&&!isPositioned){element=_objectSpread({},element,floaterWithAnimation);}if(placement==='center'){element=_objectSpread({},element,floaterCentered);}if(component){element=_objectSpread({},element,floaterWithComponent);}return _objectSpread({},floater,element);}}]);return Floater;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);_defineProperty(Floater,"propTypes",{component:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element]),content:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,disableAnimation:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,footer:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,handleClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,hideArrow:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,isPositioned:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,open:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,placement:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,positionWrapper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool.isRequired,setArrowRef:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,setFloaterRef:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,showCloseButton:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,status:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired,styles:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,title:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node});

var ReactFloaterWrapper=/*#__PURE__*/function(_React$Component){_inherits(ReactFloaterWrapper,_React$Component);function ReactFloaterWrapper(){_classCallCheck(this,ReactFloaterWrapper);return _possibleConstructorReturn(this,_getPrototypeOf(ReactFloaterWrapper).apply(this,arguments));}_createClass(ReactFloaterWrapper,[{key:"render",value:function render(){var _this$props=this.props,children=_this$props.children,handleClick=_this$props.handleClick,handleMouseEnter=_this$props.handleMouseEnter,handleMouseLeave=_this$props.handleMouseLeave,setChildRef=_this$props.setChildRef,setWrapperRef=_this$props.setWrapperRef,style=_this$props.style,styles=_this$props.styles;var element;/* istanbul ignore else */if(children){if(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(children)===1){if(!__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(children)){element=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",null,children);}else{var refProp=__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].function(children.type)?'innerRef':'ref';element=__WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children),_defineProperty({},refProp,setChildRef));}}else{element=children;}}if(!element){return null;}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",{ref:setWrapperRef,style:_objectSpread({},styles,style),onClick:handleClick,onMouseEnter:handleMouseEnter,onMouseLeave:handleMouseLeave},element);}}]);return ReactFloaterWrapper;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);_defineProperty(ReactFloaterWrapper,"propTypes",{children:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,handleClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,handleMouseEnter:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,handleMouseLeave:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,setChildRef:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,setWrapperRef:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired,style:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,styles:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired});

var defaultOptions={zIndex:100};function getStyles(styles){var options=Object(__WEBPACK_IMPORTED_MODULE_7_deepmerge__["a" /* default */])(defaultOptions,styles.options||{});return {wrapper:{cursor:'help',display:'inline-flex',flexDirection:'column',zIndex:options.zIndex},wrapperPosition:{left:-1000,position:'absolute',top:-1000,visibility:'hidden'},floater:{display:'inline-block',filter:'drop-shadow(0 0 3px rgba(0, 0, 0, 0.3))',maxWidth:300,opacity:0,position:'relative',transition:'opacity 0.3s',visibility:'hidden',zIndex:options.zIndex},floaterOpening:{opacity:1,visibility:'visible'},floaterWithAnimation:{opacity:1,transition:'opacity 0.3s, transform 0.2s',visibility:'visible'},floaterWithComponent:{maxWidth:'100%'},floaterClosing:{opacity:0,visibility:'visible'},floaterCentered:{left:'50%',position:'fixed',top:'50%',transform:'translate(-50%, -50%)'},container:{backgroundColor:'#fff',color:'#666',minHeight:60,minWidth:200,padding:20,position:'relative'},title:{borderBottom:'1px solid #555',color:'#555',fontSize:18,marginBottom:5,paddingBottom:6,paddingRight:18},content:{fontSize:15},close:{backgroundColor:'transparent',border:0,borderRadius:0,color:'#555',fontSize:0,height:15,outline:'none',padding:10,position:'absolute',right:0,top:0,width:15,WebkitAppearance:'none'},footer:{borderTop:'1px solid #ccc',fontSize:13,marginTop:10,paddingTop:5},arrow:{color:'#fff',display:'inline-flex',length:16,position:'absolute',spread:32},options:options};}

var POSITIONING_PROPS=['position','top','right','bottom','left'];var ReactFloater=/*#__PURE__*/function(_React$Component){_inherits(ReactFloater,_React$Component);function ReactFloater(props){var _this;_classCallCheck(this,ReactFloater);_this=_possibleConstructorReturn(this,_getPrototypeOf(ReactFloater).call(this,props));/* istanbul ignore else */_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"setArrowRef",function(ref){_this.arrowRef=ref;});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"setChildRef",function(ref){_this.childRef=ref;});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"setFloaterRef",function(ref){if(!_this.floaterRef){_this.floaterRef=ref;}});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"setWrapperRef",function(ref){_this.wrapperRef=ref;});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"handleTransitionEnd",function(){var status=_this.state.status;var callback=_this.props.callback;/* istanbul ignore else */if(_this.wrapperPopper){_this.wrapperPopper.instance.update();}_this.setState({status:status===STATUS.OPENING?STATUS.OPEN:STATUS.IDLE},function(){var newStatus=_this.state.status;callback(newStatus===STATUS.OPEN?'open':'close',_this.props);});});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"handleClick",function(){var _this$props=_this.props,event=_this$props.event,open=_this$props.open;if(__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].boolean(open))return;var _this$state=_this.state,positionWrapper=_this$state.positionWrapper,status=_this$state.status;/* istanbul ignore else */if(_this.event==='click'||_this.event==='hover'&&positionWrapper){log({title:'click',data:[{event:event,status:status===STATUS.OPEN?'closing':'opening'}],debug:_this.debug});_this.toggle();}});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"handleMouseEnter",function(){var _this$props2=_this.props,event=_this$props2.event,open=_this$props2.open;if(__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].boolean(open)||isMobile())return;var status=_this.state.status;/* istanbul ignore else */if(_this.event==='hover'&&status===STATUS.IDLE){log({title:'mouseEnter',data:[{key:'originalEvent',value:event}],debug:_this.debug});clearTimeout(_this.eventDelayTimeout);_this.toggle();}});_defineProperty(_assertThisInitialized(_assertThisInitialized(_this)),"handleMouseLeave",function(){var _this$props3=_this.props,event=_this$props3.event,eventDelay=_this$props3.eventDelay,open=_this$props3.open;if(__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].boolean(open)||isMobile())return;var _this$state2=_this.state,status=_this$state2.status,positionWrapper=_this$state2.positionWrapper;/* istanbul ignore else */if(_this.event==='hover'){log({title:'mouseLeave',data:[{key:'originalEvent',value:event}],debug:_this.debug});if(!eventDelay){_this.toggle(STATUS.IDLE);}else if([STATUS.OPENING,STATUS.OPEN].indexOf(status)!==-1&&!positionWrapper&&!_this.eventDelayTimeout){_this.eventDelayTimeout=setTimeout(function(){delete _this.eventDelayTimeout;_this.toggle();},eventDelay*1000);}}});_this.state={currentPlacement:props.placement,positionWrapper:props.wrapperOptions.position&&!!props.target,status:STATUS.INIT,statusWrapper:STATUS.INIT};_this._isMounted=false;return _this;}_createClass(ReactFloater,[{key:"componentDidMount",value:function componentDidMount(){if(!canUseDOM)return;var positionWrapper=this.state.positionWrapper;var _this$props5=this.props,children=_this$props5.children,open=_this$props5.open,target=_this$props5.target;this._isMounted=true;log({title:'init',data:{hasChildren:!!children,hasTarget:!!target,isControlled:__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].boolean(open),positionWrapper:positionWrapper,target:this.target,floater:this.floaterRef},debug:this.debug});this.initPopper();if(!children&&target&&!__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].boolean(open));}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(!canUseDOM)return;var _this$props6=this.props,open=_this$props6.open,target=_this$props6.target,wrapperOptions=_this$props6.wrapperOptions;if(open!==nextProps.open){this.toggle();}if(wrapperOptions.position!==nextProps.wrapperOptions.position||target!==nextProps.target){this.changeWrapperPosition(nextProps);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){if(!canUseDOM)return;var _this$props7=this.props,autoOpen=_this$props7.autoOpen,open=_this$props7.open;var _comparator=comparator(prevState,this.state),changedFrom=_comparator.changedFrom,changedTo=_comparator.changedTo;if(changedTo('status',STATUS.IDLE)&&open){this.toggle(STATUS.OPEN);}else if(changedFrom('status',STATUS.INIT,STATUS.IDLE)&&autoOpen){this.toggle(STATUS.OPEN);}if(this.floaterRef&&(changedTo('status',STATUS.OPENING)||changedTo('status',STATUS.CLOSING))){once(this.floaterRef,'transitionend',this.handleTransitionEnd);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(!canUseDOM)return;this._isMounted=false;if(this.popper){this.popper.instance.destroy();}if(this.wrapperPopper){this.wrapperPopper.instance.destroy();}}},{key:"initPopper",value:function initPopper(){var _this2=this;var target=arguments.length>0&&arguments[0]!==undefined?arguments[0]:this.target;var positionWrapper=this.state.positionWrapper;var _this$props8=this.props,disableFlip=_this$props8.disableFlip,getPopper=_this$props8.getPopper,hideArrow=_this$props8.hideArrow,offset=_this$props8.offset,placement=_this$props8.placement,wrapperOptions=_this$props8.wrapperOptions;var flipBehavior=placement==='top'||placement==='bottom'?'flip':['right','bottom-end','top-end','left','top-start','bottom-start'];/* istanbul ignore else */if(placement==='center'){this.setState({status:STATUS.IDLE});}else if(target&&this.floaterRef){new __WEBPACK_IMPORTED_MODULE_1_popper_js__["a" /* default */](target,this.floaterRef,{placement:placement,modifiers:{arrow:_objectSpread({enabled:!hideArrow,element:this.arrowRef},this.options.arrow),computeStyle:this.options.computeStyle,flip:_objectSpread({enabled:!disableFlip,behavior:flipBehavior},this.options.flip),keepTogether:this.options.keepTogether,hide:this.options.hide,inner:this.options.inner,offset:_objectSpread({offset:"0, ".concat(offset,"px")},this.options.offset),preventOverflow:this.options.preventOverflow,shift:this.options.shift},onCreate:function onCreate(data){_this2.popper=data;getPopper(data,'floater');if(_this2._isMounted){_this2.setState({currentPlacement:data.placement,status:STATUS.IDLE});}if(placement!==data.placement){setTimeout(function(){data.instance.update();},1);}},onUpdate:function onUpdate(data){_this2.popper=data;var currentPlacement=_this2.state.currentPlacement;if(_this2._isMounted&&data.placement!==currentPlacement){_this2.setState({currentPlacement:data.placement});}}});}if(positionWrapper){var wrapperOffset=!__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].undefined(wrapperOptions.offset)?wrapperOptions.offset:0;new __WEBPACK_IMPORTED_MODULE_1_popper_js__["a" /* default */](this.target,this.wrapperRef,{placement:wrapperOptions.placement||placement,modifiers:{arrow:{enabled:false},offset:{offset:"0, ".concat(wrapperOffset,"px")},flip:{enabled:false}},onCreate:function onCreate(data){_this2.wrapperPopper=data;if(_this2._isMounted){_this2.setState({statusWrapper:STATUS.IDLE});}getPopper(data,'wrapper');if(placement!==data.placement){setTimeout(function(){data.instance.update();},1);}}});}}},{key:"changeWrapperPosition",value:function changeWrapperPosition(_ref){var target=_ref.target,wrapperOptions=_ref.wrapperOptions;this.setState({positionWrapper:wrapperOptions.position&&!!target});}},{key:"toggle",value:function toggle(forceStatus){var status=this.state.status;var nextStatus=status===STATUS.OPEN?STATUS.CLOSING:STATUS.OPENING;if(!__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].undefined(forceStatus)){nextStatus=forceStatus;}this.setState({status:nextStatus});}},{key:"render",value:function render(){var _this$state3=this.state,currentPlacement=_this$state3.currentPlacement,positionWrapper=_this$state3.positionWrapper,status=_this$state3.status;var _this$props9=this.props,children=_this$props9.children,component=_this$props9.component,content=_this$props9.content,disableAnimation=_this$props9.disableAnimation,footer=_this$props9.footer,hideArrow=_this$props9.hideArrow,id=_this$props9.id,isPositioned=_this$props9.isPositioned,open=_this$props9.open,showCloseButton=_this$props9.showCloseButton,style=_this$props9.style,target=_this$props9.target,title=_this$props9.title;var wrapper=__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ReactFloaterWrapper,{handleClick:this.handleClick,handleMouseEnter:this.handleMouseEnter,handleMouseLeave:this.handleMouseLeave,setChildRef:this.setChildRef,setWrapperRef:this.setWrapperRef,style:style,styles:this.styles.wrapper},children);var output={};if(positionWrapper){output.wrapperInPortal=wrapper;}else{output.wrapperAsChildren=wrapper;}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ReactFloaterPortal,{hasChildren:!!children,id:id,placement:currentPlacement,setRef:this.setFloaterRef,status:status,zIndex:this.styles.options.zIndex,target:target},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Floater,{component:component,content:content,disableAnimation:disableAnimation,footer:footer,handleClick:this.handleClick,hideArrow:hideArrow||currentPlacement==='center',isPositioned:isPositioned,open:open,placement:currentPlacement,positionWrapper:positionWrapper,setArrowRef:this.setArrowRef,setFloaterRef:this.setFloaterRef,showCloseButton:showCloseButton,status:status,styles:this.styles,title:title}),output.wrapperInPortal),output.wrapperAsChildren);}},{key:"debug",get:function get(){var debug=this.props.debug;return debug||!!global.ReactFloaterDebug;}},{key:"event",get:function get(){var _this$props10=this.props,disableHoverToClick=_this$props10.disableHoverToClick,event=_this$props10.event;if(event==='hover'&&isMobile()&&!disableHoverToClick){return 'click';}return event;}},{key:"options",get:function get(){var options=this.props.options;return Object(__WEBPACK_IMPORTED_MODULE_7_deepmerge__["a" /* default */])(DEFAULTS,options||{});}},{key:"styles",get:function get(){var _this3=this;var _this$state4=this.state,status=_this$state4.status,positionWrapper=_this$state4.positionWrapper,statusWrapper=_this$state4.statusWrapper;var styles=this.props.styles;var nextStyles=Object(__WEBPACK_IMPORTED_MODULE_7_deepmerge__["a" /* default */])(getStyles(styles),styles);if(positionWrapper){var wrapperStyles;if(!([STATUS.IDLE].indexOf(status)!==-1)||!([STATUS.IDLE].indexOf(statusWrapper)!==-1)){wrapperStyles=nextStyles.wrapperPosition;}else{wrapperStyles=this.wrapperPopper.styles;}nextStyles.wrapper=_objectSpread({},nextStyles.wrapper,wrapperStyles);}/* istanbul ignore else */if(this.target){var targetStyles=window.getComputedStyle(this.target);/* istanbul ignore else */if(this.wrapperStyles){nextStyles.wrapper=_objectSpread({},nextStyles.wrapper,this.wrapperStyles);}else if(!(['relative','static'].indexOf(targetStyles.position)!==-1)){this.wrapperStyles={};if(!positionWrapper){POSITIONING_PROPS.forEach(function(d){_this3.wrapperStyles[d]=targetStyles[d];});nextStyles.wrapper=_objectSpread({},nextStyles.wrapper,this.wrapperStyles);this.target.style.position='relative';this.target.style.top='auto';this.target.style.right='auto';this.target.style.bottom='auto';this.target.style.left='auto';}}}return nextStyles;}},{key:"target",get:function get(){var target=this.props.target;if(target){if(__WEBPACK_IMPORTED_MODULE_6_is_lite__["a" /* default */].domElement(target)){return target;}return document.querySelector(target);}return this.childRef||this.wrapperRef;}}]);return ReactFloater;}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);_defineProperty(ReactFloater,"propTypes",{autoOpen:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,callback:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,children:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,component:__WEBPACK_IMPORTED_MODULE_0_react_proptype_conditional_require___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element]),function(props){return !props.content;}),content:__WEBPACK_IMPORTED_MODULE_0_react_proptype_conditional_require___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,function(props){return !props.component;}),debug:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,disableAnimation:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,disableFlip:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,disableHoverToClick:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,event:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['hover','click']),eventDelay:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,footer:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,getPopper:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,hideArrow:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,id:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number]),isPositioned:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,offset:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,open:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,options:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,placement:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top','top-start','top-end','bottom','bottom-start','bottom-end','left','left-start','left-end','right','right-start','right-end','auto','center']),showCloseButton:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,style:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,styles:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,target:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),title:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,wrapperOptions:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({offset:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,placement:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top','top-start','top-end','bottom','bottom-start','bottom-end','left','left-start','left-end','right','right-start','right-end','auto']),position:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool})});_defineProperty(ReactFloater,"defaultProps",{autoOpen:false,callback:noop,debug:false,disableAnimation:false,disableFlip:false,disableHoverToClick:false,event:'click',eventDelay:0.4,getPopper:noop,hideArrow:false,offset:15,placement:'bottom',showCloseButton:false,styles:{},target:null,wrapperOptions:{position:false}});

/* harmony default export */ __webpack_exports__["a"] = (ReactFloater);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryRouter */
/* unused harmony export Prompt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Redirect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Route; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Router; });
/* unused harmony export StaticRouter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Switch; });
/* unused harmony export generatePath */
/* unused harmony export matchPath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return withRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_context___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_context__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_warning__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_history__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_tiny_invariant__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_path_to_regexp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__ = __webpack_require__(1105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics__);













// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = __WEBPACK_IMPORTED_MODULE_0_create_react_context___default()();
  context.Provider.displayName = name + ".Provider";
  context.Consumer.displayName = name + ".Consumer";
  return context;
};

var context =
/*#__PURE__*/
createNamedContext('Router');

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
      children: this.props.children || null,
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    });
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Router.propTypes = {
    children: PropTypes.node,
    history: PropTypes.object.isRequired,
    staticContext: PropTypes.object
  };

  Router.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(prevProps.history === this.props.history, "You cannot change <Router history>") : void 0;
  };
}

/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = Object(__WEBPACK_IMPORTED_MODULE_5_history__["d" /* createMemoryHistory */])(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  MemoryRouter.propTypes = {
    initialEntries: PropTypes.array,
    initialIndex: PropTypes.number,
    getUserConfirmation: PropTypes.func,
    keyLength: PropTypes.number,
    children: PropTypes.node
  };

  MemoryRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.") : void 0;
  };
}

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/**
 * The public API for prompting the user before navigating away from a screen.
 */

function Prompt(_ref) {
  var message = _ref.message,
      _ref$when = _ref.when,
      when = _ref$when === void 0 ? true : _ref$when;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Prompt> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    if (!when || context$$1.staticContext) return null;
    var method = context$$1.history.block;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount(self) {
        self.release = method(message);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (prevProps.message !== message) {
          self.release();
          self.release = method(message);
        }
      },
      onUnmount: function onUnmount(self) {
        self.release();
      },
      message: message
    });
  });
}

if (false) {
  var messageType = PropTypes.oneOfType([PropTypes.func, PropTypes.string]);
  Prompt.propTypes = {
    when: PropTypes.bool,
    message: messageType.isRequired
  };
}

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default.a.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
    !context$$1 ?  false ? invariant(false, "You should not use <Redirect> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
    var history = context$$1.history,
        staticContext = context$$1.staticContext;
    var method = push ? history.push : history.replace;
    var location = Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_5_history__["f" /* locationsAreEqual */])(prevProps.to, location)) {
          method(location);
        }
      },
      to: to
    });
  });
}

if (false) {
  Redirect.propTypes = {
    push: PropTypes.bool,
    from: PropTypes.string,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired
  };
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = __WEBPACK_IMPORTED_MODULE_7_path_to_regexp___default()(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string") options = {
    path: options
  };
  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}

function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Route> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$$1.match;

      var props = Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, context$$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      if (typeof children === "function") {
        children = children(props);

        if (children === undefined) {
          if (false) {
            var path = _this.props.path;
            process.env.NODE_ENV !== "production" ? warning(false, "You returned `undefined` from the `children` function of " + ("<Route" + (path ? " path=\"" + path + "\"" : "") + ">, but you ") + "should have returned a React element or `null`") : void 0;
          }

          children = null;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Provider, {
        value: props
      }, children && !isEmptyChildren(children) ? children : props.match ? component ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : render ? render(props) : null : null);
    });
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Route.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    component: function component(props, propName) {
      if (props[propName] && !isValidElementType(props[propName])) {
        return new Error("Invalid prop 'component' supplied to 'Route': the prop is not a valid React component");
      }
    },
    exact: PropTypes.bool,
    location: PropTypes.object,
    path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    render: PropTypes.func,
    sensitive: PropTypes.bool,
    strict: PropTypes.bool
  };

  Route.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.component), "You should not use <Route component> and <Route children> in the same route; <Route component> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.children && !isEmptyChildren(this.props.children) && this.props.render), "You should not use <Route render> and <Route children> in the same route; <Route render> will be ignored") : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored") : void 0;
  };

  Route.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_5_history__["e" /* createPath */])(location);
}

function staticHandler(methodName) {
  return function () {
     false ? invariant(false, "You cannot %s with <StaticRouter>", methodName) : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false);
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


var StaticRouter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        context = _this$props.context;
    context.action = action;
    context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_5_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Router, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  StaticRouter.propTypes = {
    basename: PropTypes.string,
    context: PropTypes.object,
    location: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  };

  StaticRouter.prototype.componentDidMount = function () {
    process.env.NODE_ENV !== "production" ? warning(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.") : void 0;
  };
}

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(context.Consumer, null, function (context$$1) {
      !context$$1 ?  false ? invariant(false, "You should not use <Switch> outside a <Router>") : Object(__WEBPACK_IMPORTED_MODULE_6_tiny_invariant__["a" /* default */])(false) : void 0;
      var location = _this.props.location || context$$1.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(_this.props.children, function (child) {
        if (match == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, child.props, {
            path: path
          })) : context$$1.match;
        }
      });
      return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

if (false) {
  Switch.propTypes = {
    children: PropTypes.node,
    location: PropTypes.object
  };

  Switch.prototype.componentDidUpdate = function (prevProps) {
    process.env.NODE_ENV !== "production" ? warning(!(this.props.location && !prevProps.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.') : void 0;
    process.env.NODE_ENV !== "production" ? warning(!(!this.props.location && prevProps.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.') : void 0;
  };
}

/**
 * A public higher-order component to access the imperative API
 */

function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = Object(__WEBPACK_IMPORTED_MODULE_10__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Route, {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_extends__["a" /* default */])({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;

  if (false) {
    C.propTypes = {
      wrappedComponentRef: PropTypes.func
    };
  }

  return __WEBPACK_IMPORTED_MODULE_11_hoist_non_react_statics___default()(C, Component);
}

if (false) {
  if (typeof window !== "undefined") {
    var global = window;
    var key = "__react_router_build__";
    var buildNames = {
      cjs: "CommonJS",
      esm: "ES modules",
      umd: "UMD"
    };

    if (global[key] && global[key] !== "esm") {
      var initialBuildName = buildNames[global[key]];
      var secondaryBuildName = buildNames["esm"]; // TODO: Add link to article that explains in detail how to avoid
      // loading 2 different builds.

      throw new Error("You are loading the " + secondaryBuildName + " build of React Router " + ("on a page that is already running the " + initialBuildName + " ") + "build, so things won't work right.");
    }

    global[key] = "esm";
  }
}




/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(1182),
    shortOut = __webpack_require__(559);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppStore__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GooglePlay__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IronTrade__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EzTrader__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Hamburger__ = __webpack_require__(1243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AppStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__GooglePlay__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__IronTrade__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__IronTrade__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Hamburger__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__EzTrader__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__EzTrader__["b"]; });


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return richblue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return light; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return newIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return thProjectTrade; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logo_png__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_small_png__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_bg_png__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__error_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_index_logo_svg__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_index_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__new_index_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header_iron_jpg__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__header_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__header_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_png__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Regbonus_images_ref_img_logo_text_png__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Regbonus_images_ref_img_logo_text_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_Regbonus_images_ref_img_logo_text_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_howto_bg_iron_jpg__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_howto_bg_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_howto_bg_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_dark_jpg__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_dark_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_dark_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_desktop_tour_bg_light_jpg__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_desktop_tour_bg_light_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_desktop_tour_bg_light_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Icons_Index_index__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__siamoption_siamoption__ = __webpack_require__(374);
var basic={direction:"ltr",// основной шрифт
fontFamily:"Roboto, Arial, sans-serif",// логотип
logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* default */],null),logoImg:__WEBPACK_IMPORTED_MODULE_2__logo_png___default.a,logoImgMobile:__WEBPACK_IMPORTED_MODULE_3__logo_small_png___default.a,errorBg:__WEBPACK_IMPORTED_MODULE_4__error_bg_png___default.a,// ЦВЕТА
// основной цвет
main:"#272B34",mainDark:"#1D2027",// шапка
mainLight:"#272B34",// сайдбар
mainHighlight:"#272B34",mainFontColor:"#38465d",mainSeparator:"#393939",newIndex:true,mode:"dark",foreground:"#ffffff",alternativeForeground:"#ffffff",lightWhiteForeground:"#ffffff",background:"#000",mainColorBackground:"#272B34",secondaryColorBackground:"#272B34",ticksFontColor:"#8d8d8d",ticksBorderColor:"#4e4e4e",borderMainColor:"#555555",accent:"#feac00",alternativeAccent:"#feac00",lightAccent:"#ffcc00",lightWhiteAccent:"#feac00",accentOpacity:"rgba(254, 172, 0, .5)",secondaryTextColor:"#99959d",upper:"#3B9478",// positive ставки
alternativeUpper:"#60a31c",upperAccent:"#48AE7E",upperBorder:"#2E735D",upperBoxShadow:"#48AE7E",lower:"#D05353",// negative ставки
lowerAccent:"#EE7F7F",lowerBorder:"#A34141",lowerBoxShadow:"#EE7F7F",// анимации для попапов
perspective:"1300px",showAnimation:".15s linear 1",// цвета для вёб морды
indexMajor:"#252525",indexMinor:"#363636",indexLogo:__WEBPACK_IMPORTED_MODULE_5__new_index_logo_svg___default.a,indexLogoText:__WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg___default.a,headerLogoText:__WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg___default.a,indexHeaderBackground:__WEBPACK_IMPORTED_MODULE_7__header_iron_jpg___default.a,howToBg:__WEBPACK_IMPORTED_MODULE_10__images_howto_bg_iron_jpg___default.a,// переменные хелпдеска
helpdeskSeparator:"#676767",helpdeskMobileMenuSeparator:"#555555",helpdeskNavlinks:"#a7a7a7",// переменные для страницы /regbonus
refHeader:"#252525",refLogo:__WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_png___default.a,refLogoText:__WEBPACK_IMPORTED_MODULE_9__components_Regbonus_images_ref_img_logo_text_png___default.a,refFooterBorder:"#363636",refFooterColor:"#fff",refConditionBg:"#363636",refInvestmentBg:"#252525",// переменные статичных страниц
staticHeaderLink:"#a7a7a7",toggleAccountLightBg:"#272B34",toggleAccountDarkBg:"#1D2027",popupBackground:"#1D2027",popupDarkBackground:"#272B34",desktopTourBg:__WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_dark_jpg___default.a,minFontSize:"18px",textMuted:"#99959d",mainLink:"#0085eb",tradeHeaderAccent:"#feac00",dealsBackground:"#1D2027",dealIconColor:"#3B9478",barCaption:"#5D6067",cursorBarCaption:"#272B34",stockInfoBg:"#3D4149",tournamentPopupBgLight:"#272B34",tournamentPopupBgDark:"#1D2027",tournamentCardBg:"#1B546A",tournamentCardMainColor:"#ffffff",tournamentCardSecondaryColor:"#ffffff",tournamentCardPlaceholder:"#ffffff",scrollColor:"rgba(255, 255, 255, 0.5)",currencyColor:"#feac00",themeToggleActive:"#ffffff",bottomNavigationBg:"#3B9478",chartTimeOtcColor:"#1B546A",navigationBg:"#1D2027",navigationItemColor:"#919191",navigationItemIcon:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#919191",0.59),navigationItemActiveBg:"#272B34",navigationItemIconActive:"#cccccc",operationChequeqColor:"#99959d",operationChequeColor:"#d2d2d2",bellNewsLinkColor:"#0085eb",oneSignalHeaderBg:"#399177",languageBackground:"rgba(19, 56, 64, 0.9)",languageColor:"#ffffff",stockCloseTimeColor:"#feac00",languageArrowColor:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#fff",0.7),sightseeingBg:"linear-gradient(to bottom, #282c33 0%, #3d3f42 100%)",sightseeingTitle:"#fff",sightseeingIron:"#feac00",sightseeingLater:"rgba(255, 255, 255, 0.5)",sightSeeingImageShadow:"rgba(255, 255, 255, 0.2)",sightSeeingBgShadow:"transparent",sightseeingBigBg:"rgba(255, 255, 255, 0.1)",sightseeingSmallBg:"rgba(255, 255, 255, 0.05)",sightSeeingStartButtonBg:"#feac00",sightSeeingStartButtonColor:"#000",sightSeeingBorder:"#9b9b9b",dotColor:"rgba(255, 255, 255, 0.5)",dotActiveColor:"#fff",suggestingInputBg:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#ffffff",0.1),suggestingInputBgDisabled:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#ffffff",0.25),suggestingInputButtonSymbol:"#ffffff",suggestingInputButtonSymbolDisabled:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#919191",0.59),mobileSwitchStockBackground:"#3D4149",mobileSwitchStockArrow:"#ffffff",socialTradingButtonBg:"#5E5968",socialTradingButtonBgHover:"rgba(255, 255, 255, 0.1)",socialTradingButtonBgActive:"#3B9478",socialTradingHiddenLink:"#1592E6",socialTradingHiddenLinkHover:"#1592E6",socialTradingBg:"#272B34",socialTradingTableHeaderBg:"#1D2027",socialTradingSubtitleColor:"#919191",sellDealBg:"#3D4149",sellDealBorder:"#797979",sellDealProfitColor:"#ffffff",sellDealButtonColor:"#ffcc00",sellDealHistoryBg:"#3d4149",sellDealHistoryColor:"#ffcc00",sellDealHistoryProgress:"#5d6067",//compensations
compensationInfoIcon:"#919191",compensationSuccessTitle:"#FFCC00",compensationRefillTitle:"#ffffff",compensationSubtitle:"#ffffff",compensationAmountOfDeals:"#ffcc00",compensationActionButton:"#feac00",freeBonusPopupFontColor:"#ffffff",freeBonusPopupHintColor:"#cccccc",freeBonusPopupArrowColor:"#ffcc00",freeBonusPopupPercentColor:"#ffcc00",navigationUserName:"#ffffff",navigationMoney:"#ffffff",navigationId:"#FFCC00",navigationCall:"#FFCC00",navigationBorder:"#4B4F57",tabsTournamentsCategoryTitle:"#ffffff",sightSeeingWithdrawTitle:"#FFCC00",tourWitdrawMethodHover:"#3b9478",suspiciousActivityPopupBg:"#272B34",suspiciousActivityPopupText:"#FFFFFF",suspiciousActivityPopupButton:"#FFFFFF",suspiciousActivityPopupButtonHoverColor:"#0085EB",suspiciousActivityPopupLink:"#FFCC00",authCurrencyCodeColor:"#1B546A"};/* harmony default export */ __webpack_exports__["a"] = (basic);// дополнительные темы забирают
// недостающие настройки и цвета
// из базовых
var richblue=Object.assign({},basic,{// основной цвет
main:"#061424",mainDark:"#0A131E",// шапка
mainLight:"#121B27",// сайдбар
mainHighlight:"#162130",mainFontColor:"#38465d",mainSeparator:"#2D3244",secondaryTextColor:"#99959d",borderMainColor:"#2D3244",ticksBorderColor:"#2D3244",popupBackground:"#0A131E",popupDarkBackground:"#162130",tradeHeaderAccent:"#feac00"});var light=Object.assign({},basic,{compensationInfoIcon:"#BABABA",compensationSuccess:"#3B9478",compensationActionButton:"#0085eb",compensationSubtitle:"#1B546A",// основной цвет
isIntlProjectLight:true,main:"#f9f9f9",mainDark:"#D4D4D4",// шапка
mainLight:"#f5f5f5",// сайдбар
mainHighlight:"#fff",mainFontColor:"#38465d",mainSeparator:"#D4D4D4",indexMajor:"#ffffff",mode:"light",foreground:"#1B546A",alternativeForeground:"#feac00",lightWhiteForeground:"#ffffff",background:"#ffffff",mainColorBackground:"#1B546A",secondaryColorBackground:"#399177",textMuted:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#fff",0.5),tradeHeaderGradientTop:"#1B546A",tradeHeaderGradientBottom:"#399177",ticksFontColor:"#484848",borderMainColor:"#D4D4D4",ticksBorderColor:"#D4D4D4",alternativeUpper:"#27c191",accent:"#1B546A",alternativeAccent:"#feac00",lightAccent:"#0085eb",lightWhiteAccent:"#ffffff",secondaryTextColor:"#ffffff",staticHeaderLink:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#000",0.5),popupBackground:"#ffffff",popupDarkBackground:"#f5f5f5",desktopTourBg:__WEBPACK_IMPORTED_MODULE_12__images_desktop_tour_bg_light_jpg___default.a,tradeHeaderAccent:"#feac00",dealsBackground:"#ffffff",dealIconColor:"#3B9478",scrollColor:"#3B9478",barCaption:"#d4d4d4",cursorBarCaption:"#ffffff",stockInfoBg:"#e4e4e4",toggleAccountLightBg:"#F5F5F5",toggleAccountDarkBg:"#ffffff",chartTimeOtcColor:"#ffffff",tournamentPopupBgLight:"#3B9478",tournamentPopupBgDark:"#1B546A",currencyColor:"#3B9478",themeToggleActive:"#3B9478",navigationBg:"#e4e4e4",navigationItemColor:"#417581",navigationItemIcon:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#919191",0.59),navigationItemActiveBg:"#ffffff",navigationItemIconActive:"#3B9478",operationChequeColor:"#484848",bellNewsLinkColor:"#0085eb",oneSignalHeaderBg:"#1b546a",languageBackground:"rgba(19, 56, 64, 0.9)",stockCloseTimeColor:"#3B9478",sightseeingBg:"#F6F6F6",sightseeingTitle:"#000",sightseeingIron:"#000",sightseeingLater:"#3B9478",sightSeeingImageShadow:"rgba(0, 0, 0, 0.2)",sightSeeingBgShadow:"rgba(0, 0, 0, 0.2)",sightseeingBigBg:"#fff",sightseeingSmallBg:"#fff",sightSeeingStartButtonBg:"linear-gradient(to left, #47c0c8 0%, #5D67C0 100%)",sightSeeingStartButtonColor:"#fff",sightSeeingBorder:"#c7d9d8",dotColor:"rgba(24, 20, 28, 0.5)",dotActiveColor:"#2c7671",suggestingInputBg:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#000000",0.15),suggestingInputBgDisabled:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#000000",0.3),suggestingInputButtonSymbol:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#919191",0.8),suggestingInputButtonSymbolDisabled:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#919191",0.2),mobileSwitchStockBackground:"#ffffff",mobileSwitchStockArrow:"#1B546A",sellDealBg:"#ffffff",sellDealBorder:"#d2d2d2",sellDealProfitColor:"#1B546A",sellDealButtonColor:"#0085EB",sellDealHistoryBg:"#E5E5E5",sellDealHistoryColor:"#0085EB",sellDealHistoryProgress:"#D4D4D4",compensationSuccessTitle:"#3B9478",compensationRefillTitle:"#3B9478",compensationAmountOfDeals:"#3B9478",freeBonusPopupFontColor:"#343434",freeBonusPopupHintColor:"#919191",freeBonusPopupArrowColor:"#0085EB",freeBonusPopupPercentColor:"#3B9478",navigationUserName:"#1B546A",navigationMoney:"#1B546A",navigationId:"#0085EB",navigationCall:"#0085EB",navigationBorder:"#D4D4D4",tabsTournamentsCategoryTitle:"#343434",sightSeeingWithdrawTitle:"#1B546A",suspiciousActivityPopupBg:"#ffffff",suspiciousActivityPopupText:"#272B34",suspiciousActivityPopupButton:"#0085EB",suspiciousActivityPopupLink:"#0085EB"});var newIndex={newIndex:true,// ...dark,
mode:"light",logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_Icons_Index_index__["f" /* IronTradeFlat */],null),main:"#3B9478",mainHighlight:"#133840",mainDark:"#0F2E31",upper:"#3B9478",alternativeUpper:"#27c191",lower:"#D05353",accent:"#FFCC00",lightWhiteForeground:"#ffffff",indexMajor:"#1b546a",indexMinor:"#133840",staticHeaderLink:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#fff",0.7),inputColor:"#ffffff",mainGradientDark:"#1b546a",mainGradientLight:"#55c784",gradientLight:"#399177",mainText:"#fff",mainLink:"#0085eb",mainDarkText:"#222222",tradeHeaderAccent:"#feac00",scrollColor:"rgba(255, 255, 255, 0.5)",bellNewsLinkColor:"#0085eb",oneSignalHeaderBg:"#399177",languageBackground:"rgba(19, 56, 64, 0.9)",refFooterBorder:"#919191",refFooterColor:"#919191",refConditionBg:"#1b546a",navigationBg:"#1D2027",navigationItemColor:"#919191",navigationItemIcon:Object(__WEBPACK_IMPORTED_MODULE_14_polished__["a" /* rgba */])("#919191",0.59),navigationItemActiveBg:"#272B34",navigationItemIconActive:"#cccccc",navigationUserName:"#ffffff",navigationMoney:"#3B9478",navigationId:"#FFCC00",navigationCall:"#FFCC00",navigationBorder:"#4B4F57"};var thProjectTrade=Object.assign({},basic,__WEBPACK_IMPORTED_MODULE_15__siamoption_siamoption__["a" /* default */],{logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* default */],null),logoImg:__WEBPACK_IMPORTED_MODULE_2__logo_png___default.a,logoImgMobile:__WEBPACK_IMPORTED_MODULE_3__logo_small_png___default.a,indexLogo:__WEBPACK_IMPORTED_MODULE_5__new_index_logo_svg___default.a,indexLogoText:__WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg___default.a,headerLogoText:__WEBPACK_IMPORTED_MODULE_6__new_indexLogo_text_svg___default.a,refLogo:__WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_png___default.a,refLogoText:__WEBPACK_IMPORTED_MODULE_9__components_Regbonus_images_ref_img_logo_text_png___default.a,indexHeaderBackground:__WEBPACK_IMPORTED_MODULE_7__header_iron_jpg___default.a,howToBg:__WEBPACK_IMPORTED_MODULE_10__images_howto_bg_iron_jpg___default.a,errorBg:__WEBPACK_IMPORTED_MODULE_4__error_bg_png___default.a,desktopTourBg:__WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_dark_jpg___default.a});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LangSelect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IconsLanguage__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  font-size: 0;\n  line-height: 0;\n  z-index: 2;\n"],["\n  position: relative;\n  font-size: 0;\n  line-height: 0;\n  z-index: 2;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 132px;\n  margin-bottom: 3px;\n  padding: 9px;\n  ",";\n  ",";\n  font-size: ",";\n  line-height: 19px;\n  text-decoration: none;\n  white-space: nowrap;\n  color: inherit;\n  cursor: pointer;\n\n  :hover {\n    color: inherit;\n    cursor: default;\n  }\n"],["\n  display: inline-block;\n  vertical-align: top;\n  width: 132px;\n  margin-bottom: 3px;\n  padding: 9px;\n  ",";\n  ",";\n  font-size: ",";\n  line-height: 19px;\n  text-decoration: none;\n  white-space: nowrap;\n  color: inherit;\n  cursor: pointer;\n\n  :hover {\n    color: inherit;\n    cursor: default;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 2px;\n  display: inline-block;\n  vertical-align: top;\n  width: 88px;\n  font-size: ",";\n  line-height: 19px;\n  cursor: pointer;\n\n  ",";\n\n  @media (max-width: 959px) {\n    ",";\n    z-index: 1;\n  }\n"],["\n  position: absolute;\n  top: 2px;\n  display: inline-block;\n  vertical-align: top;\n  width: 88px;\n  font-size: ",";\n  line-height: 19px;\n  cursor: pointer;\n\n  ",";\n\n  @media (max-width: 959px) {\n    ",";\n    z-index: 1;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n      background-color: ",";\n      color: ",";\n      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n    "],["\n      background-color: ",";\n      color: ",";\n      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.75);\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 19px;\n  height: 17px;\n  ",";\n  color: ",";\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 19px;\n  height: 17px;\n  ",";\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  width: 100%;\n  padding-bottom: 6px;\n  text-transform: uppercase;\n  text-decoration: none;\n  color: inherit;\n  line-height: inherit;\n  cursor: pointer;\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n"],["\n  width: 100%;\n  padding-bottom: 6px;\n  text-transform: uppercase;\n  text-decoration: none;\n  color: inherit;\n  line-height: inherit;\n  cursor: pointer;\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      position: relative;\n\n      :before {\n        content: \"\";\n        position: absolute;\n        width: 75px;\n        left: 50%;\n        bottom: 0;\n        transform: translateX(-50%);\n        border-bottom: 1px solid ",";\n      }\n    "],["\n      position: relative;\n\n      :before {\n        content: \"\";\n        position: absolute;\n        width: 75px;\n        left: 50%;\n        bottom: 0;\n        transform: translateX(-50%);\n        border-bottom: 1px solid ",";\n      }\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 8px 10px 6px;\n  ",";\n  backface-visibility: hidden;\n"],["\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 8px 10px 6px;\n  ",";\n  backface-visibility: hidden;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  ",";\n  transform: translateY(-50%) rotate(0deg);\n  transform-origin: 50%;\n  border: 4px solid transparent;\n  border-top: 6px solid currentColor;\n  border-bottom: none;\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n\n  ",";\n"],["\n  position: absolute;\n  top: 50%;\n  ",";\n  transform: translateY(-50%) rotate(0deg);\n  transform-origin: 50%;\n  border: 4px solid transparent;\n  border-top: 6px solid currentColor;\n  border-bottom: none;\n  transition: transform 0.3s ease;\n  backface-visibility: hidden;\n\n  ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n      transform: translateY(-50%) rotate(-180deg);\n      transform-origin: 50%;\n    "],["\n      transform: translateY(-50%) rotate(-180deg);\n      transform-origin: 50%;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 13px 10px;\n  line-height: 1;\n  ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  :visited {\n    color: ",";\n  }\n\n  ",";\n"],["\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 13px 10px;\n  line-height: 1;\n  ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  color: inherit;\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  :visited {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n      background-color: ",";\n    "],["\n      background-color: ",";\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LanguageView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var MenuItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("padding-left","14px"),Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("padding-right","11px"),Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(14));var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(12,12),function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(_ref){var theme=_ref.theme;return theme.languageBackground;},function(_ref2){var theme=_ref2.theme;return theme.languageColor;});},Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("right",0));var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("margin-right","10px"),function(_ref3){var theme=_ref3.theme;return theme.staticHeaderLink;});var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.alternativeAccent;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,function(props){return props.theme.mainSeparator;});});var HeaderInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("text-align","left"));var Arrow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("right","11px"),function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);});var Item=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("text-align","left"),function(props){return props.theme.alternativeAccent;},function(_ref4){var theme=_ref4.theme;return theme.staticHeaderLink;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12,function(props){return props.theme.main;});});var langMap=[{key:"en",title:"ENG",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["c" /* ENG */],null)},{key:"ru",title:"RUS",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["h" /* RUS */],null)},{key:"vn",title:"VNM",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["k" /* VNM */],null)},{key:"ph",title:"PHL",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["g" /* PHL */],null)},{key:"th",title:"THA",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["i" /* THA */],null)},{key:"id",title:"IDN",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["f" /* IDN */],null)},{key:"hi",title:"HIN",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["e" /* HIN */],null)},{key:"ar",title:"ARA",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["a" /* ARA */],null)},{key:"es",title:"ESP",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["d" /* ESP */],null)},{key:"cn",title:"中文",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["b" /* CHN */],null)},{key:"tr",title:"TUR",icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IconsLanguage__["j" /* TUR */],null)}];var defaultLang=langMap[0];function LangItem(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,{onClick:props.onClick,active:props.active===props.locale},props.title," ",props.Icon);}var RoutelessLanguageSelect=function(_React$Component){_inherits(RoutelessLanguageSelect,_React$Component);function RoutelessLanguageSelect(){var _ref5;var _temp,_this,_ret;_classCallCheck(this,RoutelessLanguageSelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref5=RoutelessLanguageSelect.__proto__||Object.getPrototypeOf(RoutelessLanguageSelect)).call.apply(_ref5,[this].concat(args))),_this),_this.state={isLangOpen:false},_this.toggleLang=function(){_this.setState({isLangOpen:!_this.state.isLangOpen});},_this.chooseLang=function(key){_this.toggleLang();var query=__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.parse(_this.props.location.search.slice(1));if(typeof query.lang==="string"){_this.props.history.replace(Object.assign({},_this.props.location,{search:__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(Object.assign({},query,{lang:key}))}));}Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("CLICKBTN_CHANGE_LANG",{lang:key});_this.props.onLocaleChange(key);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RoutelessLanguageSelect,[{key:"render",value:function render(){var _this2=this;var _props=this.props,locales=_props.locales,showLoader=_props.showLoader,className=_props.className,_props$HeaderComponen=_props.HeaderComponent,HeaderComponent=_props$HeaderComponen===undefined?Header:_props$HeaderComponen;var query=__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.parse(this.props.location.search.slice(1));var locale=query.lang!=null?query.lang==="vi"?"vn":query.lang==="tl"?"ph":query.lang:this.props.locale;if(!locales)return false;var availableLanguages=langMap.filter(function(el){return locales.includes(el.key);});var activeLang=availableLanguages.find(function(el){return el.key===locale;})||defaultLang;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{className:className,active:this.state.isLangOpen},showLoader?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{paddingTop:7,textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Spinners_SimpleSpinner__["c" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderComponent,{active:this.state.isLangOpen,onClick:this.toggleLang},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderInner,null,activeLang&&activeLang.title," ",activeLang&&activeLang.icon,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Arrow,{active:this.state.isLangOpen}))),activeLang&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{overflow:"hidden",height:this.state.isLangOpen?"100%":0}},availableLanguages.map(function(lang){var key=lang.key,title=lang.title,icon=lang.icon;return key===activeLang.key?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LangItem,{key:key,locale:key,title:title,Icon:icon,onClick:function onClick(){_this2.chooseLang(key);},active:locale});})));}}]);return RoutelessLanguageSelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var LangSelect=Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(RoutelessLanguageSelect);function Language(props){if(props.hideLangSelect)return null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LanguageView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuItem,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons__["c" /* LangIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Languages"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LangSelect,{locale:props.locale,locales:props.locales,onLocaleChange:props.onLocaleChange,showLoader:props.showLoader}));}/* harmony default export */ __webpack_exports__["b"] = (Language);

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = VerticalBar;
/* harmony export (immutable) */ __webpack_exports__["a"] = HorizontalBar;
/* harmony export (immutable) */ __webpack_exports__["b"] = Scope;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n"],["\n  position: absolute;\n  height: 100%;\n  top: 0px;\n  left: 0px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 29px;\n  bottom: 48px;\n  left: 0px;\n  border-left: 1px solid ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: 29px;\n  bottom: 48px;\n  left: 0px;\n  border-left: 1px solid ",";\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      top: 24px;\n      bottom: 0px;\n\n      ",";\n    "],["\n      top: 24px;\n      bottom: 0px;\n\n      ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n          top: 29px;\n          bottom: 3px;\n          width: 1px;\n          background-image: linear-gradient(\n            to top,\n            "," 60%,\n            rgba(255, 255, 255, 0) 0%\n          );\n          background-position: right;\n          background-size: 1px 10px;\n          background-repeat: repeat-y;\n          border-left: none;\n        "],["\n          top: 29px;\n          bottom: 3px;\n          width: 1px;\n          background-image: linear-gradient(\n            to top,\n            "," 60%,\n            rgba(255, 255, 255, 0) 0%\n          );\n          background-position: right;\n          background-size: 1px 10px;\n          background-repeat: repeat-y;\n          border-left: none;\n        "]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  right: ","px;\n  top: 31px;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  white-space: nowrap;\n  transform: rotate(-90deg);\n  transform-origin: right;\n  color: ",";\n  user-select: none;\n\n  ",";\n"],["\n  position: absolute;\n  right: ","px;\n  top: 31px;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  white-space: nowrap;\n  transform: rotate(-90deg);\n  transform-origin: right;\n  color: ",";\n  user-select: none;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      top: 26px;\n      right: ","px;\n      font-size: ",";\n      letter-spacing: 0.5px;\n    "],["\n      top: 26px;\n      right: ","px;\n      font-size: ",";\n      letter-spacing: 0.5px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  top: 0px;\n  opacity: 0.9;\n"],["\n  position: absolute;\n  width: 100%;\n  top: 0px;\n  opacity: 0.9;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  right: ",";\n  height: 0;\n  border-top: ",";\n\n  ",";\n"],["\n  position: absolute;\n  left: 0;\n  right: ",";\n  height: 0;\n  border-top: ",";\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n      right: 60px;\n    "],["\n      right: 60px;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 100%;\n  top: -10px;\n  margin-left: ",";\n  transition: margin-left 0.3s ease;\n  min-width: 79px;\n  height: 21px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding-right: 10px;\n  padding-left: 3px;\n  text-align: right;\n  font-weight: 300;\n  font-size: ",";\n  background-color: ",";\n  color: ",";\n  white-space: nowrap;\n\n  :after {\n    position: absolute;\n    right: 100%;\n    top: 50%;\n    width: 0;\n    height: 0;\n    margin-top: -11px;\n    border: solid transparent;\n    border-top-width: 11px;\n    border-bottom-width: 10px;\n    border-right-width: 6px;\n    border-right-color: ",";\n    pointer-events: none;\n    content: \"\";\n  }\n\n  ",";\n"],["\n  position: absolute;\n  left: 100%;\n  top: -10px;\n  margin-left: ",";\n  transition: margin-left 0.3s ease;\n  min-width: 79px;\n  height: 21px;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding-right: 10px;\n  padding-left: 3px;\n  text-align: right;\n  font-weight: 300;\n  font-size: ",";\n  background-color: ",";\n  color: ",";\n  white-space: nowrap;\n\n  :after {\n    position: absolute;\n    right: 100%;\n    top: 50%;\n    width: 0;\n    height: 0;\n    margin-top: -11px;\n    border: solid transparent;\n    border-top-width: 11px;\n    border-bottom-width: 10px;\n    border-right-width: 6px;\n    border-right-color: ",";\n    pointer-events: none;\n    content: \"\";\n  }\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n      top: -8px;\n      min-width: 55px;\n      max-width: 61px;\n      margin-left: -55px;\n      height: 16px;\n      padding: 0 4px;\n      font-size: 10px;\n      line-height: 16px;\n      background-color: ",";\n\n      :after {\n        margin-top: -8px;\n        border-top-width: 8px;\n        border-bottom-width: 8px;\n        border-right-width: 5px;\n        border-right-color: ",";\n      }\n    "],["\n      top: -8px;\n      min-width: 55px;\n      max-width: 61px;\n      margin-left: -55px;\n      height: 16px;\n      padding: 0 4px;\n      font-size: 10px;\n      line-height: 16px;\n      background-color: ",";\n\n      :after {\n        margin-top: -8px;\n        border-top-width: 8px;\n        border-bottom-width: 8px;\n        border-right-width: 5px;\n        border-right-color: ",";\n      }\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 29px;\n  top: 28px;\n  color: ",";\n  font-size: ",";\n  line-height: 15px;\n  user-select: none;\n"],["\n  position: absolute;\n  left: 29px;\n  top: 28px;\n  color: ",";\n  font-size: ",";\n  line-height: 15px;\n  user-select: none;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { timeFormat } from "d3-time-format";
var VerticalBarView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var VerticalBarLine=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.ticksBorderColor;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(props){return!props.opening&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(props){return props.theme.ticksBorderColor;});});});var VerticalBarCaption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.switchSide?-15:15;},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(9,16),function(props){return props.theme.ticksFontColor;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(props){return props.switchSide?-7:7;},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(8,11));});var HorizontalBarView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var HorizontalBarLine=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(props){return props.noFit?"88px":"171px";},function(_ref){var theme=_ref.theme;return"1px dashed "+Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.accent,0.7);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});var HorizontalBarCaption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(props){return props.fits?props.noFit?"-82px":"-166px":"-112px";},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14,14),function(_ref2){var theme=_ref2.theme;return theme.barCaption;},function(_ref3){var theme=_ref3.theme;return theme.foreground;},function(_ref4){var theme=_ref4.theme;return theme.barCaption;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11,function(_ref5){var theme=_ref5.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.barCaption,0.7);},function(_ref6){var theme=_ref6.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.barCaption,0.7);});});/*const CursorBar = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
`;*//*const CursorBarHLine = styled.div`
  position: absolute;
  left: 0px;
  right: 163px;
  border-top: 1px solid ${({ theme }) => theme.foreground};
  opacity: 0.29;
  pointer-events: none;
`;*//*const CursorBarVLine = styled.div`
  position: absolute;
  top: 29px;
  bottom: 71px;
  border-left: 1px solid ${({ theme }) => theme.foreground};
  opacity: 0.29;
  pointer-events: none;
`;*//*const CursorBarCaption = styled.div`
  position: absolute;
  height: auto;
  font-weight: 300;
  font-size: ${fontSize(12, 12)};
  line-height: 20px;
  background-color: ${({ theme }) => rgba(theme.foreground, 0.8)};
  color: ${({ theme }) => theme.cursorBarCaption};
  white-space: nowrap;
  pointer-events: none;
`;*//*const CursorBarHCaption = styled(CursorBarCaption)`
  right: 85px;
  top: -9px;
  width: 69px;
  text-align: right;
  padding-right: 10px;

  :after {
    content: "";
    position: absolute;
    right: 100%;
    top: 50%;
    width: 0px;
    height: 0px;
    margin-top: -9px;
    border: solid transparent;
    border-top-width: 9px;
    border-bottom-width: 9px;
    border-right-width: 6px;
    border-right-color: ${({ theme }) => rgba(theme.foreground, 0.8)};
    pointer-events: none;
  }
`;*//*const CursorBarVCaption = styled(CursorBarCaption)`
  margin-left: -50px;
  bottom: 48px;
  width: 100px;
  padding: 0 10px;
  text-align: center;
  z-index: 1;
`;*/var CandleCursorCaption=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(props){return props.theme.ticksFontColor;},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(11));function VerticalBar(props){var positionX=Math.floor(props.x);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerticalBarView,{style:{WebkitTransform:"translateX("+positionX+"px)",transform:"translateX("+positionX+"px)"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerticalBarLine,{mobile:props.mobile,opening:props.opening}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerticalBarCaption,{mobile:props.mobile,switchSide:props.switchSide},props.children));}function HorizontalBar(_ref7){var value=_ref7.value,y=_ref7.y,_ref7$noFit=_ref7.noFit,noFit=_ref7$noFit===undefined?false:_ref7$noFit,_ref7$toFixed=_ref7.toFixed,toFixed=_ref7$toFixed===undefined?6:_ref7$toFixed,viewportHeight=_ref7.viewportHeight,mobile=_ref7.mobile;var positionY=noFit?y:Math.max(10,Math.min(viewportHeight-30,y));var fits=noFit||positionY===y;var caption=value.toFixed(toFixed);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalBarView,{style:{WebkitTransform:"translateY("+positionY+"px)",transform:"translateY("+positionY+"px)"}},fits&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalBarLine,{mobile:mobile,noFit:noFit}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HorizontalBarCaption,{mobile:mobile,fits:fits,noFit:noFit},caption));}function Scope(props){/*const captionX = props.scaleX.invert(props.x);
  const captionY =
    props.type === "line" ? props.value[2].value : props.value.close[2].value;

  const y = props.type === "line" ? props.value[1] : props.value.close[1];*/return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.type!=="line"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CandleCursorCaption,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("table",{border:"none"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{paddingRight:5}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Open")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,props.value.open[2].value)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{paddingRight:5}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"High")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,props.value.maximum[2].value)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{paddingRight:5}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Low")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,props.value.minimum[2].value)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{paddingRight:5}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Close")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",null,props.value.close[2].value))))));}

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SelectBase */
/* unused harmony export Async */
/* unused harmony export AsyncCreatable */
/* unused harmony export Creatable */
/* unused harmony export createFilter */
/* unused harmony export makeAnimated */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return components; });
/* unused harmony export mergeStyles */
/* unused harmony export defaultTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_raf__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_emotion__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_autosize__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_input_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_input_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_memoize_one__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__);









var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

// ==============================
// NO OP
// ==============================

var noop = function noop() {};

// ==============================
// Class Name Prefixer
// ==============================

/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/
function applyPrefixToName(prefix, name) {
  if (!name) {
    return prefix;
  } else if (name[0] === '-') {
    return prefix + name;
  } else {
    return prefix + '__' + name;
  }
}

function classNames(prefix, cssKey, state, className) {
  var arr = [cssKey, className];
  if (state && prefix) {
    for (var key in state) {
      if (state.hasOwnProperty(key) && state[key]) {
        arr.push('' + applyPrefixToName(prefix, key));
      }
    }
  }

  return arr.filter(function (i) {
    return i;
  }).map(function (i) {
    return String(i).trim();
  }).join(' ');
}
// ==============================
// Clean Value
// ==============================

var cleanValue = function cleanValue(value) {
  if (Array.isArray(value)) return value.filter(Boolean);
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) return [value];
  return [];
};

// ==============================
// Handle Input Change
// ==============================

function handleInputChange(inputValue, actionMeta, onInputChange) {
  if (onInputChange) {
    var newValue = onInputChange(inputValue, actionMeta);
    if (typeof newValue === 'string') return newValue;
  }
  return inputValue;
}

// ==============================
// Scroll Helpers
// ==============================

function isDocumentElement(el) {
  return [document.documentElement, document.body, window].indexOf(el) > -1;
}

// Normalized scrollTo & scrollTop
// ------------------------------

function getScrollTop(el) {
  if (isDocumentElement(el)) {
    return window.pageYOffset;
  }
  return el.scrollTop;
}

function scrollTo(el, top) {
  // with a scroll distance, we perform scroll on the element
  if (isDocumentElement(el)) {
    window.scrollTo(0, top);
    return;
  }

  el.scrollTop = top;
}

// Get Scroll Parent
// ------------------------------

function getScrollParent(element) {
  var style = getComputedStyle(element);
  var excludeStaticParent = style.position === 'absolute';
  var overflowRx = /(auto|scroll)/;
  var docEl = document.documentElement; // suck it, flow...

  if (style.position === 'fixed') return docEl;

  for (var parent = element; parent = parent.parentElement;) {
    style = getComputedStyle(parent);
    if (excludeStaticParent && style.position === 'static') {
      continue;
    }
    if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
      return parent;
    }
  }

  return docEl;
}

// Animated Scroll To
// ------------------------------

/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/
function easeOutCubic(t, b, c, d) {
  return c * ((t = t / d - 1) * t * t + 1) + b;
}

function animatedScrollTo(element, to) {
  var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
  var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noop;

  var start = getScrollTop(element);
  var change = to - start;
  var increment = 10;
  var currentTime = 0;

  function animateScroll() {
    currentTime += increment;
    var val = easeOutCubic(currentTime, start, change, duration);
    scrollTo(element, val);
    if (currentTime < duration) {
      __WEBPACK_IMPORTED_MODULE_0_raf___default()(animateScroll);
    } else {
      callback(element);
    }
  }
  animateScroll();
}

// Scroll Into View
// ------------------------------

function scrollIntoView(menuEl, focusedEl) {
  var menuRect = menuEl.getBoundingClientRect();
  var focusedRect = focusedEl.getBoundingClientRect();
  var overScroll = focusedEl.offsetHeight / 3;

  if (focusedRect.bottom + overScroll > menuRect.bottom) {
    scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
  } else if (focusedRect.top - overScroll < menuRect.top) {
    scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
  }
}

// ==============================
// Get bounding client object
// ==============================

// cannot get keys using array notation with DOMRect
function getBoundingClientObj(element) {
  var rect = element.getBoundingClientRect();
  return {
    bottom: rect.bottom,
    height: rect.height,
    left: rect.left,
    right: rect.right,
    top: rect.top,
    width: rect.width
  };
}

// ==============================
// Touch Capability Detector
// ==============================

function isTouchCapable() {
  try {
    document.createEvent('TouchEvent');
    return true;
  } catch (e) {
    return false;
  }
}

// ==============================
// Mobile Device Detector
// ==============================

function isMobileDevice() {
  try {
    return (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    );
  } catch (e) {
    return false;
  }
}

// ==============================
// Menu
// ==============================

// Get Menu Placement
// ------------------------------

function getMenuPlacement(_ref) {
  var maxHeight = _ref.maxHeight,
      menuEl = _ref.menuEl,
      minHeight = _ref.minHeight,
      placement = _ref.placement,
      shouldScroll = _ref.shouldScroll,
      isFixedPosition = _ref.isFixedPosition,
      theme = _ref.theme;
  var spacing = theme.spacing;

  var scrollParent = getScrollParent(menuEl);
  var defaultState = { placement: 'bottom', maxHeight: maxHeight };

  // something went wrong, return default state
  if (!menuEl || !menuEl.offsetParent) return defaultState;

  // we can't trust `scrollParent.scrollHeight` --> it may increase when
  // the menu is rendered

  var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
      scrollHeight = _scrollParent$getBoun.height;

  var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
      menuBottom = _menuEl$getBoundingCl.bottom,
      menuHeight = _menuEl$getBoundingCl.height,
      menuTop = _menuEl$getBoundingCl.top;

  // $FlowFixMe function returns above if there's no offsetParent


  var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
      containerTop = _menuEl$offsetParent$.top;

  var viewHeight = window.innerHeight;
  var scrollTop = getScrollTop(scrollParent);

  var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
  var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
  var viewSpaceAbove = containerTop - marginTop;
  var viewSpaceBelow = viewHeight - menuTop;
  var scrollSpaceAbove = viewSpaceAbove + scrollTop;
  var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;

  var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
  var scrollUp = scrollTop + menuTop - marginTop;
  var scrollDuration = 160;

  switch (placement) {
    case 'auto':
    case 'bottom':
      // 1: the menu will fit, do nothing
      if (viewSpaceBelow >= menuHeight) {
        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        return { placement: 'bottom', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollDown, scrollDuration);
        }

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;

        return {
          placement: 'bottom',
          maxHeight: constrainedHeight
        };
      }

      // 4. Forked beviour when there isn't enough space below

      // AUTO: flip the menu, render above
      if (placement === 'auto' || isFixedPosition) {
        // may need to be constrained after flipping
        var _constrainedHeight = maxHeight;

        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight = isFixedPosition ? viewSpaceAbove - marginBottom - spacing.controlHeight : scrollSpaceAbove - marginBottom - spacing.controlHeight;
        }

        return { placement: 'top', maxHeight: _constrainedHeight };
      }

      // BOTTOM: allow browser to increase scrollable area and immediately set scroll
      if (placement === 'bottom') {
        scrollTo(scrollParent, scrollDown);
        return { placement: 'bottom', maxHeight: maxHeight };
      }
      break;
    case 'top':
      // 1: the menu will fit, do nothing
      if (viewSpaceAbove >= menuHeight) {
        return { placement: 'top', maxHeight: maxHeight };
      }

      // 2: the menu will fit, if scrolled
      if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return { placement: 'top', maxHeight: maxHeight };
      }

      // 3: the menu will fit, if constrained
      if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
        var _constrainedHeight2 = maxHeight;

        // we want to provide as much of the menu as possible to the user,
        // so give them whatever is available below rather than the minHeight.
        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
        }

        if (shouldScroll) {
          animatedScrollTo(scrollParent, scrollUp, scrollDuration);
        }

        return {
          placement: 'top',
          maxHeight: _constrainedHeight2
        };
      }

      // 4. not enough space, the browser WILL NOT increase scrollable area when
      // absolutely positioned element rendered above the viewport (only below).
      // Flip the menu, render below
      return { placement: 'bottom', maxHeight: maxHeight };
    default:
      throw new Error('Invalid placement provided "' + placement + '".');
  }

  // fulfil contract with flow: implicit return value of undefined
  return defaultState;
}

// Menu Component
// ------------------------------

function alignToControl(placement) {
  var placementToCSSProp = { bottom: 'top', top: 'bottom' };
  return placement ? placementToCSSProp[placement] : 'bottom';
}
var coercePlacement = function coercePlacement(p) {
  return p === 'auto' ? 'bottom' : p;
};

var menuCSS = function menuCSS(_ref2) {
  var _ref3;

  var placement = _ref2.placement,
      _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      spacing = _ref2$theme.spacing,
      colors = _ref2$theme.colors;
  return _ref3 = {}, defineProperty(_ref3, alignToControl(placement), '100%'), defineProperty(_ref3, 'backgroundColor', colors.neutral0), defineProperty(_ref3, 'borderRadius', borderRadius), defineProperty(_ref3, 'boxShadow', '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)'), defineProperty(_ref3, 'marginBottom', spacing.menuGutter), defineProperty(_ref3, 'marginTop', spacing.menuGutter), defineProperty(_ref3, 'position', 'absolute'), defineProperty(_ref3, 'width', '100%'), defineProperty(_ref3, 'zIndex', 1), _ref3;
};

// NOTE: internal only
var MenuPlacer = function (_Component) {
  inherits(MenuPlacer, _Component);

  function MenuPlacer() {
    var _ref4;

    var _temp, _this, _ret;

    classCallCheck(this, MenuPlacer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref4 = MenuPlacer.__proto__ || Object.getPrototypeOf(MenuPlacer)).call.apply(_ref4, [this].concat(args))), _this), _this.state = {
      maxHeight: _this.props.maxMenuHeight,
      placement: null
    }, _this.getPlacement = function (ref) {
      var _this$props = _this.props,
          minMenuHeight = _this$props.minMenuHeight,
          maxMenuHeight = _this$props.maxMenuHeight,
          menuPlacement = _this$props.menuPlacement,
          menuPosition = _this$props.menuPosition,
          menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
          theme = _this$props.theme;
      var getPortalPlacement = _this.context.getPortalPlacement;


      if (!ref) return;

      // DO NOT scroll if position is fixed
      var isFixedPosition = menuPosition === 'fixed';
      var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;

      var state = getMenuPlacement({
        maxHeight: maxMenuHeight,
        menuEl: ref,
        minHeight: minMenuHeight,
        placement: menuPlacement,
        shouldScroll: shouldScroll,
        isFixedPosition: isFixedPosition,
        theme: theme
      });

      if (getPortalPlacement) getPortalPlacement(state);

      _this.setState(state);
    }, _this.getUpdatedProps = function () {
      var menuPlacement = _this.props.menuPlacement;

      var placement = _this.state.placement || coercePlacement(menuPlacement);

      return _extends({}, _this.props, { placement: placement, maxHeight: _this.state.maxHeight });
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(MenuPlacer, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    }
  }]);
  return MenuPlacer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MenuPlacer.contextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
var Menu = function Menu(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  var cn = cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('menu', props)), { menu: true }, className);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({ className: cn }, innerProps, { ref: innerRef }),
    children
  );
};

// ==============================
// Menu List
// ==============================

var menuListCSS = function menuListCSS(_ref5) {
  var maxHeight = _ref5.maxHeight,
      baseUnit = _ref5.theme.spacing.baseUnit;
  return {
    maxHeight: maxHeight,
    overflowY: 'auto',
    paddingBottom: baseUnit,
    paddingTop: baseUnit,
    position: 'relative', // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: 'touch'
  };
};
var MenuList = function MenuList(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isMulti = props.isMulti,
      innerRef = props.innerRef;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('menuList', props)), {
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    },
    children
  );
};

// ==============================
// Menu Notices
// ==============================

var noticeCSS = function noticeCSS(_ref6) {
  var _ref6$theme = _ref6.theme,
      baseUnit = _ref6$theme.spacing.baseUnit,
      colors = _ref6$theme.colors;
  return {
    color: colors.neutral40,
    padding: baseUnit * 2 + 'px ' + baseUnit * 3 + 'px',
    textAlign: 'center'
  };
};
var noOptionsMessageCSS = noticeCSS;
var loadingMessageCSS = noticeCSS;

var NoOptionsMessage = function NoOptionsMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('noOptionsMessage', props)), {
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps),
    children
  );
};
NoOptionsMessage.defaultProps = {
  children: 'No options'
};

var LoadingMessage = function LoadingMessage(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('loadingMessage', props)), {
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps),
    children
  );
};
LoadingMessage.defaultProps = {
  children: 'Loading...'
};

// ==============================
// Menu Portal
// ==============================

var menuPortalCSS = function menuPortalCSS(_ref7) {
  var rect = _ref7.rect,
      offset = _ref7.offset,
      position = _ref7.position;
  return {
    left: rect.left,
    position: position,
    top: offset,
    width: rect.width,
    zIndex: 1
  };
};

var MenuPortal = function (_Component2) {
  inherits(MenuPortal, _Component2);

  function MenuPortal() {
    var _ref8;

    var _temp2, _this2, _ret2;

    classCallCheck(this, MenuPortal);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp2 = (_this2 = possibleConstructorReturn(this, (_ref8 = MenuPortal.__proto__ || Object.getPrototypeOf(MenuPortal)).call.apply(_ref8, [this].concat(args))), _this2), _this2.state = { placement: null }, _this2.getPortalPlacement = function (_ref9) {
      var placement = _ref9.placement;

      var initialPlacement = coercePlacement(_this2.props.menuPlacement);

      // avoid re-renders if the placement has not changed
      if (placement !== initialPlacement) {
        _this2.setState({ placement: placement });
      }
    }, _temp2), possibleConstructorReturn(_this2, _ret2);
  }

  createClass(MenuPortal, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    }

    // callback for occassions where the menu must "flip"

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          appendTo = _props.appendTo,
          children = _props.children,
          controlElement = _props.controlElement,
          menuPlacement = _props.menuPlacement,
          position = _props.menuPosition,
          getStyles = _props.getStyles;

      var isFixed = position === 'fixed';

      // bail early if required elements aren't present
      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = { offset: offset, position: position, rect: rect };

      // same wrapper element whether fixed or portalled
      var menuWrapper = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: /*#__PURE__*/ /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('menuPortal', state)) },
        children
      );

      return appendTo ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(menuWrapper, appendTo) : menuWrapper;
    }
  }]);
  return MenuPortal;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
MenuPortal.childContextTypes = {
  getPortalPlacement: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) {
        if (!equal(a[i], b[i])) return false;
      }
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length) {
      return false;
    }

    for (i = length; i-- !== 0;) {
      if (!hasProp.call(b, keys[i])) return false;
    }
    // end fast-deep-equal

    // Custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (error.message && error.message.match(/stack|recursion/i)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
}

var diacritics = [{ base: 'A', letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g }, { base: 'AA', letters: /[\uA732]/g }, { base: 'AE', letters: /[\u00C6\u01FC\u01E2]/g }, { base: 'AO', letters: /[\uA734]/g }, { base: 'AU', letters: /[\uA736]/g }, { base: 'AV', letters: /[\uA738\uA73A]/g }, { base: 'AY', letters: /[\uA73C]/g }, { base: 'B', letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g }, { base: 'C', letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g }, { base: 'D', letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g }, { base: 'DZ', letters: /[\u01F1\u01C4]/g }, { base: 'Dz', letters: /[\u01F2\u01C5]/g }, { base: 'E', letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g }, { base: 'F', letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g }, { base: 'G', letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g }, { base: 'H', letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g }, { base: 'I', letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g }, { base: 'J', letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g }, { base: 'K', letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g }, { base: 'L', letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g }, { base: 'LJ', letters: /[\u01C7]/g }, { base: 'Lj', letters: /[\u01C8]/g }, { base: 'M', letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g }, { base: 'N', letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g }, { base: 'NJ', letters: /[\u01CA]/g }, { base: 'Nj', letters: /[\u01CB]/g }, { base: 'O', letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g }, { base: 'OI', letters: /[\u01A2]/g }, { base: 'OO', letters: /[\uA74E]/g }, { base: 'OU', letters: /[\u0222]/g }, { base: 'P', letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g }, { base: 'Q', letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g }, { base: 'R', letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g }, { base: 'S', letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g }, { base: 'T', letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g }, { base: 'TZ', letters: /[\uA728]/g }, { base: 'U', letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g }, { base: 'V', letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g }, { base: 'VY', letters: /[\uA760]/g }, { base: 'W', letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g }, { base: 'X', letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g }, { base: 'Y', letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g }, { base: 'Z', letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g }, { base: 'a', letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g }, { base: 'aa', letters: /[\uA733]/g }, { base: 'ae', letters: /[\u00E6\u01FD\u01E3]/g }, { base: 'ao', letters: /[\uA735]/g }, { base: 'au', letters: /[\uA737]/g }, { base: 'av', letters: /[\uA739\uA73B]/g }, { base: 'ay', letters: /[\uA73D]/g }, { base: 'b', letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g }, { base: 'c', letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g }, { base: 'd', letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g }, { base: 'dz', letters: /[\u01F3\u01C6]/g }, { base: 'e', letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g }, { base: 'f', letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g }, { base: 'g', letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g }, { base: 'h', letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g }, { base: 'hv', letters: /[\u0195]/g }, { base: 'i', letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g }, { base: 'j', letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g }, { base: 'k', letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g }, { base: 'l', letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g }, { base: 'lj', letters: /[\u01C9]/g }, { base: 'm', letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g }, { base: 'n', letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g }, { base: 'nj', letters: /[\u01CC]/g }, { base: 'o', letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g }, { base: 'oi', letters: /[\u01A3]/g }, { base: 'ou', letters: /[\u0223]/g }, { base: 'oo', letters: /[\uA74F]/g }, { base: 'p', letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g }, { base: 'q', letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g }, { base: 'r', letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g }, { base: 's', letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g }, { base: 't', letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g }, { base: 'tz', letters: /[\uA729]/g }, { base: 'u', letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g }, { base: 'v', letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g }, { base: 'vy', letters: /[\uA761]/g }, { base: 'w', letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g }, { base: 'x', letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g }, { base: 'y', letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g }, { base: 'z', letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g }];

var stripDiacritics = function stripDiacritics(str) {
	for (var i = 0; i < diacritics.length; i++) {
		str = str.replace(diacritics[i].letters, diacritics[i].base);
	}
	return str;
};

var trimString = function trimString(str) {
  return str.replace(/^\s+|\s+$/g, '');
};
var defaultStringify = function defaultStringify(option) {
  return option.label + ' ' + option.value;
};

var createFilter = function createFilter(config) {
  return function (option, rawInput) {
    var _ignoreCase$ignoreAcc = _extends({
      ignoreCase: true,
      ignoreAccents: true,
      stringify: defaultStringify,
      trim: true,
      matchFrom: 'any'
    }, config),
        ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
        ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
        stringify = _ignoreCase$ignoreAcc.stringify,
        trim = _ignoreCase$ignoreAcc.trim,
        matchFrom = _ignoreCase$ignoreAcc.matchFrom;

    var input = trim ? trimString(rawInput) : rawInput;
    var candidate = trim ? trimString(stringify(option)) : stringify(option);
    if (ignoreCase) {
      input = input.toLowerCase();
      candidate = candidate.toLowerCase();
    }
    if (ignoreAccents) {
      input = stripDiacritics(input);
      candidate = stripDiacritics(candidate);
    }
    return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
  };
};

// Assistive text to describe visual elements. Hidden for sighted users.
var A11yText = function A11yText(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({
    className: Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
      zIndex: 9999,
      border: 0,
      clip: 'rect(1px, 1px, 1px, 1px)',
      height: 1,
      width: 1,
      position: 'absolute',
      overflow: 'hidden',
      padding: 0,
      whiteSpace: 'nowrap',
      backgroundColor: 'red',
      color: 'blue'
    })
  }, props));
};

var DummyInput = function (_Component) {
  inherits(DummyInput, _Component);

  function DummyInput() {
    classCallCheck(this, DummyInput);
    return possibleConstructorReturn(this, (DummyInput.__proto__ || Object.getPrototypeOf(DummyInput)).apply(this, arguments));
  }

  createClass(DummyInput, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          inProp = _props.in,
          out = _props.out,
          onExited = _props.onExited,
          appear = _props.appear,
          enter = _props.enter,
          exit = _props.exit,
          innerRef = _props.innerRef,
          props = objectWithoutProperties(_props, ['in', 'out', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', _extends({
        ref: innerRef
      }, props, {
        className: Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
          // get rid of any default styles
          background: 0,
          border: 0,
          fontSize: 'inherit',
          outline: 0,
          padding: 0,

          // important! without `width` browsers won't allow focus
          width: 1,

          // remove cursor on desktop
          color: 'transparent',

          // remove cursor on mobile whilst maintaining "scroll into view" behaviour
          left: -100,
          opacity: 0,
          position: 'relative',
          transform: 'scale(0)'
        })
      }));
    }
  }]);
  return DummyInput;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var NodeResolver = function (_Component) {
  inherits(NodeResolver, _Component);

  function NodeResolver() {
    classCallCheck(this, NodeResolver);
    return possibleConstructorReturn(this, (NodeResolver.__proto__ || Object.getPrototypeOf(NodeResolver)).apply(this, arguments));
  }

  createClass(NodeResolver, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.innerRef(Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["findDOMNode"])(this));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.innerRef(null);
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return NodeResolver;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];

var LOCK_STYLES = {
  boxSizing: 'border-box', // account for possible declaration `width: 100%;` on body
  overflow: 'hidden',
  position: 'relative',
  height: '100%'
};

function preventTouchMove(e) {
  e.preventDefault();
}

function allowTouchMove(e) {
  e.stopPropagation();
}

function preventInertiaScroll() {
  var top = this.scrollTop;
  var totalScroll = this.scrollHeight;
  var currentScroll = top + this.offsetHeight;

  if (top === 0) {
    this.scrollTop = 1;
  } else if (currentScroll === totalScroll) {
    this.scrollTop = top - 1;
  }
}

// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var activeScrollLocks = 0;

var ScrollLock = function (_Component) {
  inherits(ScrollLock, _Component);

  function ScrollLock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollLock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollLock.__proto__ || Object.getPrototypeOf(ScrollLock)).call.apply(_ref, [this].concat(args))), _this), _this.originalStyles = {}, _this.listenerOptions = {
      capture: false,
      passive: false
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollLock, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;

      var _props = this.props,
          accountForScrollbars = _props.accountForScrollbars,
          touchScrollTarget = _props.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      }

      // apply the lock styles and padding if this is the first scroll lock
      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;

        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + 'px';
        }
      }

      // account for touch devices
      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions);

        // Allow scroll on provided target
        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }

      // increment active scroll locks
      activeScrollLocks += 1;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;

      var _props2 = this.props,
          accountForScrollbars = _props2.accountForScrollbars,
          touchScrollTarget = _props2.touchScrollTarget;

      var target = document.body;
      var targetStyle = target && target.style;

      // safely decrement active scroll locks
      activeScrollLocks = Math.max(activeScrollLocks - 1, 0);

      // reapply original body styles, if any
      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];
          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      }

      // remove touch listeners
      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return ScrollLock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollLock.defaultProps = {
  accountForScrollbars: true
};

// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref

var ScrollBlock = function (_PureComponent) {
  inherits(ScrollBlock, _PureComponent);

  function ScrollBlock() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollBlock);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollBlock.__proto__ || Object.getPrototypeOf(ScrollBlock)).call.apply(_ref, [this].concat(args))), _this), _this.state = { touchScrollTarget: null }, _this.getScrollTarget = function (ref) {
      if (ref === _this.state.touchScrollTarget) return;
      _this.setState({ touchScrollTarget: ref });
    }, _this.blurSelectInput = function () {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // must be in state to trigger a re-render, only runs once per instance


  // this will close the menu when a user clicks outside


  createClass(ScrollBlock, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          isEnabled = _props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget;

      // bail early if not enabled

      if (!isEnabled) return children;

      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        null,
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', {
          onClick: this.blurSelectInput,
          className: Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({ position: 'fixed', left: 0, bottom: 0, right: 0, top: 0 })
        }),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NodeResolver,
          { innerRef: this.getScrollTarget },
          children
        ),
        touchScrollTarget ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollLock, { touchScrollTarget: touchScrollTarget }) : null
      );
    }
  }]);
  return ScrollBlock;
}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);

var ScrollCaptor = function (_Component) {
  inherits(ScrollCaptor, _Component);

  function ScrollCaptor() {
    var _ref;

    var _temp, _this, _ret;

    classCallCheck(this, ScrollCaptor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = ScrollCaptor.__proto__ || Object.getPrototypeOf(ScrollCaptor)).call.apply(_ref, [this].concat(args))), _this), _this.isBottom = false, _this.isTop = false, _this.cancelScroll = function (event) {
      event.preventDefault();
      event.stopPropagation();
    }, _this.handleEventDelta = function (event, delta) {
      var _this$props = _this.props,
          onBottomArrive = _this$props.onBottomArrive,
          onBottomLeave = _this$props.onBottomLeave,
          onTopArrive = _this$props.onTopArrive,
          onTopLeave = _this$props.onTopLeave;
      var _this$scrollTarget = _this.scrollTarget,
          scrollTop = _this$scrollTarget.scrollTop,
          scrollHeight = _this$scrollTarget.scrollHeight,
          clientHeight = _this$scrollTarget.clientHeight;

      var target = _this.scrollTarget;
      var isDeltaPositive = delta > 0;
      var availableScroll = scrollHeight - clientHeight - scrollTop;
      var shouldCancelScroll = false;

      // reset bottom/top flags
      if (availableScroll > delta && _this.isBottom) {
        if (onBottomLeave) onBottomLeave(event);
        _this.isBottom = false;
      }
      if (isDeltaPositive && _this.isTop) {
        if (onTopLeave) onTopLeave(event);
        _this.isTop = false;
      }

      // bottom limit
      if (isDeltaPositive && delta > availableScroll) {
        if (onBottomArrive && !_this.isBottom) {
          onBottomArrive(event);
        }
        target.scrollTop = scrollHeight;
        shouldCancelScroll = true;
        _this.isBottom = true;

        // top limit
      } else if (!isDeltaPositive && -delta > scrollTop) {
        if (onTopArrive && !_this.isTop) {
          onTopArrive(event);
        }
        target.scrollTop = 0;
        shouldCancelScroll = true;
        _this.isTop = true;
      }

      // cancel scroll
      if (shouldCancelScroll) {
        _this.cancelScroll(event);
      }
    }, _this.onWheel = function (event) {
      _this.handleEventDelta(event, event.deltaY);
    }, _this.onTouchStart = function (event) {
      // set touch start so we can calculate touchmove delta
      _this.touchStart = event.changedTouches[0].clientY;
    }, _this.onTouchMove = function (event) {
      var deltaY = _this.touchStart - event.changedTouches[0].clientY;
      _this.handleEventDelta(event, deltaY);
    }, _this.getScrollTarget = function (ref) {
      _this.scrollTarget = ref;
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  createClass(ScrollCaptor, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListening(this.scrollTarget);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    }
  }, {
    key: 'startListening',
    value: function startListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'stopListening',
    value: function stopListening(el) {
      // bail early if no scroll available
      if (el.scrollHeight <= el.clientHeight) return;

      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        NodeResolver,
        { innerRef: this.getScrollTarget },
        this.props.children
      );
    }
  }]);
  return ScrollCaptor;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var ScrollCaptorSwitch = function (_Component2) {
  inherits(ScrollCaptorSwitch, _Component2);

  function ScrollCaptorSwitch() {
    classCallCheck(this, ScrollCaptorSwitch);
    return possibleConstructorReturn(this, (ScrollCaptorSwitch.__proto__ || Object.getPrototypeOf(ScrollCaptorSwitch)).apply(this, arguments));
  }

  createClass(ScrollCaptorSwitch, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isEnabled = _props.isEnabled,
          props = objectWithoutProperties(_props, ['isEnabled']);

      return isEnabled ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ScrollCaptor, props) : this.props.children;
    }
  }]);
  return ScrollCaptorSwitch;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ScrollCaptorSwitch.defaultProps = { isEnabled: true };

var instructionsAriaMessage = function instructionsAriaMessage(event) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isSearchable = context.isSearchable,
      isMulti = context.isMulti,
      label = context.label;

  switch (event) {
    case 'menu':
      return 'Use Up and Down to choose options, press Backspace to select the currently focused option, press Escape to exit the menu, press Tab to select the option and exit the menu.';
    case 'input':
      return (label ? label : 'Select') + ' is focused ' + (isSearchable ? ',type to refine list' : '') + ', press Down to open the menu, ' + (isMulti ? ' press left to focus selected values' : '');
    case 'value':
      return 'Use left and right to toggle between focused values, press Enter to remove the currently focused value';
  }
};

var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
  var value = context.value;

  if (!value) return;
  switch (event) {
    case 'deselect-option':
    case 'pop-value':
    case 'remove-value':
      return 'option ' + value + ', deselected.';
    case 'select-option':
      return 'option ' + value + ', selected.';
  }
};

var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
  var focusedValue = _ref.focusedValue,
      getOptionLabel = _ref.getOptionLabel,
      selectValue = _ref.selectValue;
  return 'value ' + getOptionLabel(focusedValue) + ' focused, ' + (selectValue.indexOf(focusedValue) + 1) + ' of ' + selectValue.length + '.';
};
var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
  var focusedOption = _ref2.focusedOption,
      getOptionLabel = _ref2.getOptionLabel,
      options = _ref2.options;
  return 'option ' + getOptionLabel(focusedOption) + ' focused, ' + (options.indexOf(focusedOption) + 1) + ' of ' + options.length + '.';
};
var resultsAriaMessage = function resultsAriaMessage(_ref3) {
  var inputValue = _ref3.inputValue,
      screenReaderMessage = _ref3.screenReaderMessage;
  return '' + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + '.';
};

var formatGroupLabel = function formatGroupLabel(group) {
  return group.label;
};

var getOptionLabel = function getOptionLabel(option) {
  return option.label;
};

var getOptionValue = function getOptionValue(option) {
  return option.value;
};

var isOptionDisabled = function isOptionDisabled(option) {
  return !!option.isDisabled;
};

// ==============================
// Root Container
// ==============================

var containerCSS = function containerCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : null,
    pointerEvents: isDisabled ? 'none' : null, // cancel mouse events when disabled
    position: 'relative'
  };
};
var SelectContainer = function SelectContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isDisabled = props.isDisabled,
      isRtl = props.isRtl;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('container', props)), {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps),
    children
  );
};

// ==============================
// Value Container
// ==============================

var valueContainerCSS = function valueContainerCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexWrap: 'wrap',
    padding: spacing.baseUnit / 2 + 'px ' + spacing.baseUnit * 2 + 'px',
    WebkitOverflowScrolling: 'touch',
    position: 'relative',
    overflow: 'hidden'
  };
};
var ValueContainer = function (_Component) {
  inherits(ValueContainer, _Component);

  function ValueContainer() {
    classCallCheck(this, ValueContainer);
    return possibleConstructorReturn(this, (ValueContainer.__proto__ || Object.getPrototypeOf(ValueContainer)).apply(this, arguments));
  }

  createClass(ValueContainer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          cx = _props.cx,
          isMulti = _props.isMulti,
          getStyles = _props.getStyles,
          hasValue = _props.hasValue;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        {
          className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('valueContainer', this.props)), {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
          }, className)
        },
        children
      );
    }
  }]);
  return ValueContainer;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// ==============================
// Indicator Container
// ==============================

var indicatorsContainerCSS = function indicatorsContainerCSS() {
  return {
    alignItems: 'center',
    alignSelf: 'stretch',
    display: 'flex',
    flexShrink: 0
  };
};
var IndicatorsContainer = function IndicatorsContainer(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles;


  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('indicatorsContainer', props)), {
        'indicators': true
      }, className)
    },
    children
  );
};

// ==============================
// Dropdown & Clear Icons
// ==============================

var Svg = function Svg(_ref) {
  var size = _ref.size,
      props = objectWithoutProperties(_ref, ['size']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('svg', _extends({
    height: size,
    width: size,
    viewBox: '0 0 20 20',
    'aria-hidden': 'true',
    focusable: 'false',
    className: /*#__PURE__*/ /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
      display: 'inline-block',
      fill: 'currentColor',
      lineHeight: 1,
      stroke: 'currentColor',
      strokeWidth: 0
    })
  }, props));
};

var CrossIcon = function CrossIcon(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z' })
  );
};
var DownChevron = function DownChevron(props) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    Svg,
    _extends({ size: 20 }, props),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('path', { d: 'M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z' })
  );
};

// ==============================
// Dropdown & Clear Buttons
// ==============================

var baseCSS = function baseCSS(_ref2) {
  var isFocused = _ref2.isFocused,
      _ref2$theme = _ref2.theme,
      baseUnit = _ref2$theme.spacing.baseUnit,
      colors = _ref2$theme.colors;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',

    ':hover': {
      color: isFocused ? colors.neutral80 : colors.neutral40
    }
  };
};

var dropdownIndicatorCSS = baseCSS;
var DropdownIndicator = function DropdownIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('dropdownIndicator', props)), {
        'indicator': true,
        'dropdown-indicator': true
      }, className)
    }),
    children
  );
};
DropdownIndicator.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DownChevron, null)
};

var clearIndicatorCSS = baseCSS;
var ClearIndicator = function ClearIndicator(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('clearIndicator', props)), {
        'indicator': true,
        'clear-indicator': true
      }, className)
    }),
    children
  );
};

ClearIndicator.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, null)
};

// ==============================
// Separator
// ==============================

var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref3) {
  var isDisabled = _ref3.isDisabled,
      _ref3$theme = _ref3.theme,
      baseUnit = _ref3$theme.spacing.baseUnit,
      colors = _ref3$theme.colors;
  return {
    alignSelf: 'stretch',
    backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
    marginBottom: baseUnit * 2,
    marginTop: baseUnit * 2,
    width: 1
  };
};

var IndicatorSeparator = function IndicatorSeparator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', _extends({}, innerProps, {
    className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('indicatorSeparator', props)), { 'indicator-separator': true }, className)
  }));
};

// ==============================
// Loading
// ==============================

var keyframesName = 'react-select-loading-indicator';

var loadingIndicatorCSS = function loadingIndicatorCSS(_ref4) {
  var isFocused = _ref4.isFocused,
      size = _ref4.size,
      _ref4$theme = _ref4.theme,
      colors = _ref4$theme.colors,
      baseUnit = _ref4$theme.spacing.baseUnit;
  return {
    color: isFocused ? colors.neutral60 : colors.neutral20,
    display: 'flex',
    padding: baseUnit * 2,
    transition: 'color 150ms',
    alignSelf: 'center',
    fontSize: size,
    lineHeight: 1,
    marginRight: size,
    textAlign: 'center',
    verticalAlign: 'middle'
  };
};

var LoadingDot = function LoadingDot(_ref5) {
  var color = _ref5.color,
      delay = _ref5.delay,
      offset = _ref5.offset;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('span', {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])({
      animationDuration: '1s',
      animationDelay: delay + 'ms',
      animationIterationCount: 'infinite',
      animationName: keyframesName,
      animationTimingFunction: 'ease-in-out',
      backgroundColor: color,
      borderRadius: '1em',
      display: 'inline-block',
      marginLeft: offset ? '1em' : null,
      height: '1em',
      verticalAlign: 'top',
      width: '1em'
    })
  });
};

// eslint-disable-next-line no-unused-expressions
Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["injectGlobal"])('@keyframes ', keyframesName, '{0%,80%,100%{opacity:0;}40%{opacity:1;}};');

var LoadingIndicator = function LoadingIndicator(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps,
      isFocused = props.isFocused,
      isRtl = props.isRtl,
      colors = props.theme.colors;

  var color = isFocused ? colors.neutral80 : colors.neutral20;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({}, innerProps, {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('loadingIndicator', props)), {
        'indicator': true,
        'loading-indicator': true
      }, className)
    }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 0, offset: isRtl }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 160, offset: true }),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingDot, { color: color, delay: 320, offset: !isRtl })
  );
};
LoadingIndicator.defaultProps = { size: 4 };

var css$1 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      _ref$theme = _ref.theme,
      colors = _ref$theme.colors,
      borderRadius = _ref$theme.borderRadius,
      spacing = _ref$theme.spacing;
  return {
    alignItems: 'center',
    backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
    borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
    borderRadius: borderRadius,
    borderStyle: 'solid',
    borderWidth: 1,
    boxShadow: isFocused ? '0 0 0 1px ' + colors.primary : null,
    cursor: 'default',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    minHeight: spacing.controlHeight,
    outline: '0 !important',
    position: 'relative',
    transition: 'all 100ms',

    '&:hover': {
      borderColor: isFocused ? colors.primary : colors.neutral30
    }
  };
};

var Control = function Control(props) {
  var children = props.children,
      cx = props.cx,
      getStyles = props.getStyles,
      className = props.className,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('control', props)), {
        'control': true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused
      }, className)
    }, innerProps),
    children
  );
};

var groupCSS = function groupCSS(_ref) {
  var spacing = _ref.theme.spacing;
  return {
    paddingBottom: spacing.baseUnit * 2,
    paddingTop: spacing.baseUnit * 2
  };
};

var Group = function Group(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      Heading = props.Heading,
      headingProps = props.headingProps,
      label = props.label,
      theme = props.theme;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('group', props)), { 'group': true }, className)
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Heading,
      _extends({}, headingProps, { theme: theme, getStyles: getStyles, cx: cx }),
      label
    ),
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      'div',
      null,
      children
    )
  );
};

var groupHeadingCSS = function groupHeadingCSS(_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    color: '#999',
    cursor: 'default',
    display: 'block',
    fontSize: '75%',
    fontWeight: '500',
    marginBottom: '0.25em',
    paddingLeft: spacing.baseUnit * 3,
    paddingRight: spacing.baseUnit * 3,
    textTransform: 'uppercase'
  };
};

var GroupHeading = function GroupHeading(props) {
  var className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      theme = props.theme,
      cleanProps = objectWithoutProperties(props, ['className', 'cx', 'getStyles', 'theme']);

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', _extends({
    className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('groupHeading', _extends({ theme: theme }, cleanProps))), { 'group-heading': true }, className)
  }, cleanProps));
};

var inputCSS = function inputCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    margin: spacing.baseUnit / 2,
    paddingBottom: spacing.baseUnit / 2,
    paddingTop: spacing.baseUnit / 2,
    visibility: isDisabled ? 'hidden' : 'visible',
    color: colors.neutral80
  };
};
var inputStyle = function inputStyle(isHidden) {
  return {
    background: 0,
    border: 0,
    fontSize: 'inherit',
    opacity: isHidden ? 0 : 1,
    outline: 0,
    padding: 0,
    color: 'inherit'
  };
};

var Input = function Input(_ref2) {
  var className = _ref2.className,
      cx = _ref2.cx,
      getStyles = _ref2.getStyles,
      innerRef = _ref2.innerRef,
      isHidden = _ref2.isHidden,
      isDisabled = _ref2.isDisabled,
      theme = _ref2.theme,
      props = objectWithoutProperties(_ref2, ['className', 'cx', 'getStyles', 'innerRef', 'isHidden', 'isDisabled', 'theme']);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    {
      className: Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('input', _extends({ theme: theme }, props)))
    },
    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_input_autosize___default.a, _extends({
      className: cx(null, { 'input': true }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props))
  );
};

var multiValueCSS = function multiValueCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      borderRadius = _ref$theme.borderRadius,
      colors = _ref$theme.colors;
  return {
    backgroundColor: colors.neutral10,
    borderRadius: borderRadius / 2,
    display: 'flex',
    margin: spacing.baseUnit / 2,
    minWidth: 0 // resolves flex/text-overflow bug
  };
};

var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
  var _ref2$theme = _ref2.theme,
      borderRadius = _ref2$theme.borderRadius,
      colors = _ref2$theme.colors,
      cropWithEllipsis = _ref2.cropWithEllipsis;
  return {
    borderRadius: borderRadius / 2,
    color: colors.neutral80,
    fontSize: '85%',
    overflow: 'hidden',
    padding: 3,
    paddingLeft: 6,
    textOverflow: cropWithEllipsis ? 'ellipsis' : null,
    whiteSpace: 'nowrap'
  };
};

var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
  var _ref3$theme = _ref3.theme,
      spacing = _ref3$theme.spacing,
      borderRadius = _ref3$theme.borderRadius,
      colors = _ref3$theme.colors,
      isFocused = _ref3.isFocused;
  return {
    alignItems: 'center',
    borderRadius: borderRadius / 2,
    backgroundColor: isFocused && colors.dangerLight,
    display: 'flex',
    paddingLeft: spacing.baseUnit,
    paddingRight: spacing.baseUnit,
    ':hover': {
      backgroundColor: colors.dangerLight,
      color: colors.danger
    }
  };
};

var MultiValueGeneric = function MultiValueGeneric(_ref4) {
  var children = _ref4.children,
      innerProps = _ref4.innerProps;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    innerProps,
    children
  );
};

var MultiValueContainer = MultiValueGeneric;
var MultiValueLabel = MultiValueGeneric;

var MultiValueRemove = function (_Component) {
  inherits(MultiValueRemove, _Component);

  function MultiValueRemove() {
    classCallCheck(this, MultiValueRemove);
    return possibleConstructorReturn(this, (MultiValueRemove.__proto__ || Object.getPrototypeOf(MultiValueRemove)).apply(this, arguments));
  }

  createClass(MultiValueRemove, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          innerProps = _props.innerProps;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        innerProps,
        children
      );
    }
  }]);
  return MultiValueRemove;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValueRemove.defaultProps = {
  children: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CrossIcon, { size: 14 })
};

var MultiValue = function (_Component2) {
  inherits(MultiValue, _Component2);

  function MultiValue() {
    classCallCheck(this, MultiValue);
    return possibleConstructorReturn(this, (MultiValue.__proto__ || Object.getPrototypeOf(MultiValue)).apply(this, arguments));
  }

  createClass(MultiValue, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          className = _props2.className,
          components = _props2.components,
          cx = _props2.cx,
          data = _props2.data,
          getStyles = _props2.getStyles,
          innerProps = _props2.innerProps,
          isDisabled = _props2.isDisabled,
          removeProps = _props2.removeProps,
          selectProps = _props2.selectProps;
      var Container = components.Container,
          Label = components.Label,
          Remove = components.Remove;


      var containerInnerProps = _extends({
        className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('multiValue', this.props)), {
          'multi-value': true,
          'multi-value--is-disabled': isDisabled
        }, className)
      }, innerProps);

      var labelInnerProps = {
        className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('multiValueLabel', this.props)), {
          'multi-value__label': true
        }, className)
      };

      var removeInnerProps = _extends({
        className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('multiValueRemove', this.props)), {
          'multi-value__remove': true
        }, className)
      }, removeProps);

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        Container,
        {
          data: data,
          innerProps: containerInnerProps,
          selectProps: selectProps
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Label,
          {
            data: data,
            innerProps: labelInnerProps,
            selectProps: selectProps
          },
          children
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Remove, {
          data: data,
          innerProps: removeInnerProps,
          selectProps: selectProps
        })
      );
    }
  }]);
  return MultiValue;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

MultiValue.defaultProps = {
  cropWithEllipsis: true
};

var optionCSS = function optionCSS(_ref) {
  var isDisabled = _ref.isDisabled,
      isFocused = _ref.isFocused,
      isSelected = _ref.isSelected,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
    color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
    cursor: 'default',
    display: 'block',
    fontSize: 'inherit',
    padding: spacing.baseUnit * 2 + 'px ' + spacing.baseUnit * 3 + 'px',
    width: '100%',
    userSelect: 'none',
    WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',

    // provide some affordance on touch devices
    ':active': {
      backgroundColor: isSelected ? colors.primary : colors.primary50
    }
  };
};

var Option = function Option(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      isFocused = props.isFocused,
      isSelected = props.isSelected,
      innerRef = props.innerRef,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      ref: innerRef,
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('option', props)), {
        'option': true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className)
    }, innerProps),
    children
  );
};

var placeholderCSS = function placeholderCSS(_ref) {
  var _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: colors.neutral50,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var Placeholder = function Placeholder(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('placeholder', props)), {
        'placeholder': true
      }, className)
    }, innerProps),
    children
  );
};

var css$2 = function css$$1(_ref) {
  var isDisabled = _ref.isDisabled,
      _ref$theme = _ref.theme,
      spacing = _ref$theme.spacing,
      colors = _ref$theme.colors;
  return {
    color: isDisabled ? colors.neutral40 : colors.neutral80,
    marginLeft: spacing.baseUnit / 2,
    marginRight: spacing.baseUnit / 2,
    maxWidth: 'calc(100% - ' + spacing.baseUnit * 2 + 'px)',
    overflow: 'hidden',
    position: 'absolute',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    top: '50%',
    transform: 'translateY(-50%)'
  };
};

var SingleValue = function SingleValue(props) {
  var children = props.children,
      className = props.className,
      cx = props.cx,
      getStyles = props.getStyles,
      isDisabled = props.isDisabled,
      innerProps = props.innerProps;

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    _extends({
      className: cx( /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_2_emotion__["css"])(getStyles('singleValue', props)), {
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps),
    children
  );
};

var components = {
  ClearIndicator: ClearIndicator,
  Control: Control,
  DropdownIndicator: DropdownIndicator,
  DownChevron: DownChevron,
  CrossIcon: CrossIcon,
  Group: Group,
  GroupHeading: GroupHeading,
  IndicatorsContainer: IndicatorsContainer,
  IndicatorSeparator: IndicatorSeparator,
  Input: Input,
  LoadingIndicator: LoadingIndicator,
  Menu: Menu,
  MenuList: MenuList,
  MenuPortal: MenuPortal,
  LoadingMessage: LoadingMessage,
  NoOptionsMessage: NoOptionsMessage,
  MultiValue: MultiValue,
  MultiValueContainer: MultiValueContainer,
  MultiValueLabel: MultiValueLabel,
  MultiValueRemove: MultiValueRemove,
  Option: Option,
  Placeholder: Placeholder,
  SelectContainer: SelectContainer,
  SingleValue: SingleValue,
  ValueContainer: ValueContainer
};

var defaultComponents = function defaultComponents(props) {
  return _extends({}, components, props.components);
};

var defaultStyles = {
  clearIndicator: clearIndicatorCSS,
  container: containerCSS,
  control: css$1,
  dropdownIndicator: dropdownIndicatorCSS,
  group: groupCSS,
  groupHeading: groupHeadingCSS,
  indicatorsContainer: indicatorsContainerCSS,
  indicatorSeparator: indicatorSeparatorCSS,
  input: inputCSS,
  loadingIndicator: loadingIndicatorCSS,
  loadingMessage: loadingMessageCSS,
  menu: menuCSS,
  menuList: menuListCSS,
  menuPortal: menuPortalCSS,
  multiValue: multiValueCSS,
  multiValueLabel: multiValueLabelCSS,
  multiValueRemove: multiValueRemoveCSS,
  noOptionsMessage: noOptionsMessageCSS,
  option: optionCSS,
  placeholder: placeholderCSS,
  singleValue: css$2,
  valueContainer: valueContainerCSS
};

// Merge Utility
// Allows consumers to extend a base Select with additional styles

function mergeStyles(source) {
  var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // initialize with source styles
  var styles = _extends({}, source);

  // massage in target styles
  Object.keys(target).forEach(function (key) {
    if (source[key]) {
      styles[key] = function (rsCss, props) {
        return target[key](source[key](rsCss, props), props);
      };
    } else {
      styles[key] = target[key];
    }
  });

  return styles;
}

var colors = {
  primary: '#2684FF',
  primary75: '#4C9AFF',
  primary50: '#B2D4FF',
  primary25: '#DEEBFF',

  danger: '#DE350B',
  dangerLight: '#FFBDAD',

  neutral0: 'hsl(0, 0%, 100%)',
  neutral5: 'hsl(0, 0%, 95%)',
  neutral10: 'hsl(0, 0%, 90%)',
  neutral20: 'hsl(0, 0%, 80%)',
  neutral30: 'hsl(0, 0%, 70%)',
  neutral40: 'hsl(0, 0%, 60%)',
  neutral50: 'hsl(0, 0%, 50%)',
  neutral60: 'hsl(0, 0%, 40%)',
  neutral70: 'hsl(0, 0%, 30%)',
  neutral80: 'hsl(0, 0%, 20%)',
  neutral90: 'hsl(0, 0%, 10%)'
};

var borderRadius = 4;
var baseUnit = 4; /* Used to calculate consistent margin/padding on elements */
var controlHeight = 38; /* The minimum height of the control */
var menuGutter = baseUnit * 2; /* The amount of space between the control and menu */

var spacing = {
  baseUnit: baseUnit,
  controlHeight: controlHeight,
  menuGutter: menuGutter
};

var defaultTheme = {
  borderRadius: borderRadius,
  colors: colors,
  spacing: spacing
};

var defaultProps = {
  backspaceRemovesValue: true,
  blurInputOnSelect: isTouchCapable(),
  captureMenuScroll: !isTouchCapable(),
  closeMenuOnSelect: true,
  closeMenuOnScroll: false,
  components: {},
  controlShouldRenderValue: true,
  escapeClearsValue: false,
  filterOption: createFilter(),
  formatGroupLabel: formatGroupLabel,
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  isDisabled: false,
  isLoading: false,
  isMulti: false,
  isRtl: false,
  isSearchable: true,
  isOptionDisabled: isOptionDisabled,
  loadingMessage: function loadingMessage() {
    return 'Loading...';
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: false,
  menuPlacement: 'bottom',
  menuPosition: 'absolute',
  menuShouldBlockScroll: false,
  menuShouldScrollIntoView: !isMobileDevice(),
  noOptionsMessage: function noOptionsMessage() {
    return 'No options';
  },
  openMenuOnFocus: false,
  openMenuOnClick: true,
  options: [],
  pageSize: 5,
  placeholder: 'Select...',
  screenReaderStatus: function screenReaderStatus(_ref) {
    var count = _ref.count;
    return count + ' result' + (count !== 1 ? 's' : '') + ' available';
  },
  styles: {},
  tabIndex: '0',
  tabSelectsValue: true
};

var instanceId = 1;

var Select = function (_Component) {
  inherits(Select, _Component);

  // Lifecycle
  // ------------------------------

  // Refs
  // ------------------------------

  // Misc. Instance Properties
  // ------------------------------

  function Select(props) {
    classCallCheck(this, Select);

    var _this = possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

    _initialiseProps.call(_this);

    var value = props.value;

    _this.cacheComponents = Object(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["default"])(_this.cacheComponents, exportedEqual).bind(_this);
    _this.cacheComponents(props.components);
    _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

    var selectValue = cleanValue(value);
    var menuOptions = _this.buildMenuOptions(props, selectValue);

    _this.state.menuOptions = menuOptions;
    _this.state.selectValue = selectValue;
    return _this;
  } // TODO


  createClass(Select, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          options = _props.options,
          value = _props.value,
          inputValue = _props.inputValue;
      // re-cache custom components

      this.cacheComponents(nextProps.components);
      // rebuild the menu options
      if (nextProps.value !== value || nextProps.options !== options || nextProps.inputValue !== inputValue) {
        var _selectValue = cleanValue(nextProps.value);
        var _menuOptions = this.buildMenuOptions(nextProps, _selectValue);
        var _focusedValue = this.getNextFocusedValue(_selectValue);
        var _focusedOption = this.getNextFocusedOption(_menuOptions.focusable);
        this.setState({ menuOptions: _menuOptions, selectValue: _selectValue, focusedOption: _focusedOption, focusedValue: _focusedValue });
      }
      // some updates should toggle the state of the input visibility
      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          isDisabled = _props2.isDisabled,
          menuIsOpen = _props2.menuIsOpen;
      var isFocused = this.state.isFocused;


      if (
      // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled ||
      // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      }

      // scroll the focused option into view if necessary
      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
      }
      this.scrollToFocusedOptionOnUpdate = false;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'onMenuOpen',

    // ==============================
    // Consumer Handlers
    // ==============================

    value: function onMenuOpen() {
      this.props.onMenuOpen();
    }
  }, {
    key: 'onMenuClose',
    value: function onMenuClose() {
      var _props3 = this.props,
          isSearchable = _props3.isSearchable,
          isMulti = _props3.isMulti;

      this.announceAriaLiveContext({
        event: 'input',
        context: { isSearchable: isSearchable, isMulti: isMulti }
      });
      this.onInputChange('', { action: 'menu-close' });
      this.props.onMenuClose();
    }
  }, {
    key: 'onInputChange',
    value: function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    }

    // ==============================
    // Methods
    // ==============================

  }, {
    key: 'focusInput',
    value: function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    }
  }, {
    key: 'blurInput',
    value: function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    }

    // aliased for consumers

  }, {
    key: 'openMenu',
    value: function openMenu(focusOption) {
      var _state = this.state,
          menuOptions = _state.menuOptions,
          selectValue = _state.selectValue;
      var isMulti = this.props.isMulti;

      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.inputIsHiddenAfterUpdate = false;

      this.onMenuOpen();
      this.setState({
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      });

      this.announceAriaLiveContext({ event: 'menu' });
    }
  }, {
    key: 'focusValue',
    value: function focusValue(direction) {
      var _props4 = this.props,
          isMulti = _props4.isMulti,
          isSearchable = _props4.isSearchable;
      var _state2 = this.state,
          selectValue = _state2.selectValue,
          focusedValue = _state2.focusedValue;

      // Only multiselects support value focusing

      if (!isMulti) return;

      this.setState({
        focusedOption: null
      });

      var focusedIndex = selectValue.indexOf(focusedValue);
      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'value' });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }
          break;
        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }
          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: { isSearchable: isSearchable, isMulti: isMulti }
        });
      }

      this.setState({
        inputIsHidden: nextFocus === -1 ? false : true,
        focusedValue: selectValue[nextFocus]
      });
    }
  }, {
    key: 'focusOption',
    value: function focusOption() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
      var pageSize = this.props.pageSize;
      var _state3 = this.state,
          focusedOption = _state3.focusedOption,
          menuOptions = _state3.menuOptions;

      var options = menuOptions.focusable;

      if (!options.length) return;
      var nextFocus = 0; // handles 'first'
      var focusedIndex = options.indexOf(focusedOption);
      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({ event: 'menu' });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }
      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
    }
  }, {
    key: 'getTheme',


    // ==============================
    // Getters
    // ==============================

    value: function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      }
      // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.
      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      }
      // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.
      return _extends({}, defaultTheme, this.props.theme);
    }
  }, {
    key: 'getCommonProps',
    value: function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;

      var hasValue = this.hasValue();
      var getValue = function getValue() {
        return selectValue;
      };
      var cxPrefix = classNamePrefix;

      var cx = classNames.bind(null, cxPrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    }
  }, {
    key: 'getNextFocusedValue',
    value: function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }
      var _state4 = this.state,
          focusedValue = _state4.focusedValue,
          lastSelectValue = _state4.selectValue;

      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }
      return null;
    }
  }, {
    key: 'getNextFocusedOption',
    value: function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;

      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }

    // ==============================
    // Helpers
    // ==============================

  }, {
    key: 'hasValue',
    value: function hasValue() {
      var selectValue = this.state.selectValue;

      return selectValue.length > 0;
    }
  }, {
    key: 'hasOptions',
    value: function hasOptions() {
      return !!this.state.menuOptions.render.length;
    }
  }, {
    key: 'countOptions',
    value: function countOptions() {
      return this.state.menuOptions.focusable.length;
    }
  }, {
    key: 'isClearable',
    value: function isClearable() {
      var _props5 = this.props,
          isClearable = _props5.isClearable,
          isMulti = _props5.isMulti;

      // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;

      return isClearable;
    }
  }, {
    key: 'isOptionDisabled',
    value: function isOptionDisabled$$1(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    }
  }, {
    key: 'isOptionSelected',
    value: function isOptionSelected(option, selectValue) {
      var _this2 = this;

      if (selectValue.indexOf(option) > -1) return true;
      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }
      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this2.getOptionValue(i) === candidate;
      });
    }
  }, {
    key: 'filterOption',
    value: function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    }
  }, {
    key: 'formatOptionLabel',
    value: function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var _inputValue = this.props.inputValue;
        var _selectValue2 = this.state.selectValue;

        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: _inputValue,
          selectValue: _selectValue2
        });
      } else {
        return this.getOptionLabel(data);
      }
    }
  }, {
    key: 'formatGroupLabel',
    value: function formatGroupLabel$$1(data) {
      return this.props.formatGroupLabel(data);
    }

    // ==============================
    // Mouse Handlers
    // ==============================

  }, {
    key: 'startListeningComposition',


    // ==============================
    // Composition Handlers
    // ==============================

    value: function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    }
  }, {
    key: 'stopListeningComposition',
    value: function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    }
  }, {
    key: 'startListeningToTouch',


    // ==============================
    // Touch Handlers
    // ==============================

    value: function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    }
  }, {
    key: 'stopListeningToTouch',
    value: function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    }

    // ==============================
    // Focus Handlers
    // ==============================

    // ==============================
    // Keyboard Handlers
    // ==============================

  }, {
    key: 'buildMenuOptions',


    // ==============================
    // Menu Options
    // ==============================

    value: function buildMenuOptions(props, selectValue) {
      var _this3 = this;

      var _props$inputValue = props.inputValue,
          inputValue = _props$inputValue === undefined ? '' : _props$inputValue,
          options = props.options;


      var toOption = function toOption(option, id) {
        var isDisabled = _this3.isOptionDisabled(option, selectValue);
        var isSelected = _this3.isOptionSelected(option, selectValue);
        var label = _this3.getOptionLabel(option);
        var value = _this3.getOptionValue(option);

        if (_this3.shouldHideSelectedOptions() && isSelected || !_this3.filterOption({ label: label, value: value, data: option }, inputValue)) {
          return;
        }

        var onHover = isDisabled ? undefined : function () {
          return _this3.onOptionHover(option);
        };
        var onSelect = isDisabled ? undefined : function () {
          return _this3.selectOption(option);
        };
        var optionId = _this3.getElementId('option') + '-' + id;

        return {
          innerProps: {
            id: optionId,
            onClick: onSelect,
            onMouseMove: onHover,
            onMouseOver: onHover,
            role: 'option',
            tabIndex: -1
          },
          data: option,
          isDisabled: isDisabled,
          isSelected: isSelected,
          key: optionId,
          label: label,
          type: 'option',
          value: value
        };
      };

      return options.reduce(function (acc, item, itemIndex) {
        if (item.options) {
          // TODO needs a tidier implementation
          if (!_this3.hasGroups) _this3.hasGroups = true;

          var items = item.options;

          var children = items.map(function (child, i) {
            var option = toOption(child, itemIndex + '-' + i);
            if (option && !option.isDisabled) acc.focusable.push(child);
            return option;
          }).filter(Boolean);
          if (children.length) {
            var groupId = _this3.getElementId('group') + '-' + itemIndex;
            acc.render.push({
              type: 'group',
              key: groupId,
              data: item,
              options: children
            });
          }
        } else {
          var option = toOption(item, '' + itemIndex);
          if (option) {
            acc.render.push(option);
            if (!option.isDisabled) acc.focusable.push(item);
          }
        }
        return acc;
      }, { render: [], focusable: [] });
    }

    // ==============================
    // Renderers
    // ==============================

  }, {
    key: 'constructAriaLiveMessage',
    value: function constructAriaLiveMessage() {
      var _state5 = this.state,
          ariaLiveContext = _state5.ariaLiveContext,
          selectValue = _state5.selectValue,
          focusedValue = _state5.focusedValue,
          focusedOption = _state5.focusedOption;
      var _props6 = this.props,
          options = _props6.options,
          menuIsOpen = _props6.menuIsOpen,
          inputValue = _props6.inputValue,
          screenReaderStatus = _props6.screenReaderStatus;

      // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : '';
      // An aria live message representing the currently focused option in the select.
      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : '';
      // An aria live message representing the set of focusable results and current searchterm/inputvalue.
      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({ count: this.countOptions() })
      });

      return focusedValueMsg + ' ' + focusedOptionMsg + ' ' + resultsMsg + ' ' + ariaLiveContext;
    }
  }, {
    key: 'renderInput',
    value: function renderInput() {
      var _props7 = this.props,
          isDisabled = _props7.isDisabled,
          isSearchable = _props7.isSearchable,
          inputId = _props7.inputId,
          inputValue = _props7.inputValue,
          tabIndex = _props7.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;


      var id = inputId || this.getElementId('input');

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DummyInput, {
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          tabIndex: tabIndex,
          value: ''
        });
      }

      // aria attributes makes the JSX "noisy", separated for clarity
      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      var _commonProps = this.commonProps,
          cx = _commonProps.cx,
          theme = _commonProps.theme;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input, _extends({
        autoCapitalize: 'none',
        autoComplete: 'off',
        autoCorrect: 'off',
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        spellCheck: 'false',
        tabIndex: tabIndex,
        theme: theme,
        type: 'text',
        value: inputValue
      }, ariaAttributes));
    }
  }, {
    key: 'renderPlaceholderOrValue',
    value: function renderPlaceholderOrValue() {
      var _this4 = this;

      var _components = this.components,
          MultiValue = _components.MultiValue,
          MultiValueContainer = _components.MultiValueContainer,
          MultiValueLabel = _components.MultiValueLabel,
          MultiValueRemove = _components.MultiValueRemove,
          SingleValue = _components.SingleValue,
          Placeholder = _components.Placeholder;
      var commonProps = this.commonProps;
      var _props8 = this.props,
          controlShouldRenderValue = _props8.controlShouldRenderValue,
          isDisabled = _props8.isDisabled,
          isMulti = _props8.isMulti,
          inputValue = _props8.inputValue,
          placeholder = _props8.placeholder;
      var _state6 = this.state,
          selectValue = _state6.selectValue,
          focusedValue = _state6.focusedValue;


      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Placeholder,
          _extends({}, commonProps, { key: 'placeholder', isDisabled: isDisabled }),
          placeholder
        );
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt) {
          var isFocused = opt === focusedValue;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            MultiValue,
            _extends({}, commonProps, {
              components: {
                Container: MultiValueContainer,
                Label: MultiValueLabel,
                Remove: MultiValueRemove
              },
              isFocused: isFocused,
              isDisabled: isDisabled,
              key: _this4.getOptionValue(opt),
              removeProps: {
                onClick: function onClick() {
                  return _this4.removeValue(opt);
                },
                onTouchEnd: function onTouchEnd() {
                  return _this4.removeValue(opt);
                },
                onMouseDown: function onMouseDown(e) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              },
              data: opt
            }),
            _this4.formatOptionLabel(opt, 'value')
          );
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SingleValue,
        _extends({}, commonProps, { data: singleValue, isDisabled: isDisabled }),
        this.formatOptionLabel(singleValue, 'value')
      );
    }
  }, {
    key: 'renderClearIndicator',
    value: function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _props9 = this.props,
          isDisabled = _props9.isDisabled,
          isLoading = _props9.isLoading;
      var isFocused = this.state.isFocused;


      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ClearIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderLoadingIndicator',
    value: function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _props10 = this.props,
          isDisabled = _props10.isDisabled,
          isLoading = _props10.isLoading;
      var isFocused = this.state.isFocused;


      if (!LoadingIndicator || !isLoading) return null;

      var innerProps = { 'aria-hidden': 'true' };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderIndicatorSeparator',
    value: function renderIndicatorSeparator() {
      var _components2 = this.components,
          DropdownIndicator = _components2.DropdownIndicator,
          IndicatorSeparator = _components2.IndicatorSeparator;

      // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;

      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IndicatorSeparator, _extends({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderDropdownIndicator',
    value: function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;

      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;


      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DropdownIndicator, _extends({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    }
  }, {
    key: 'renderMenu',
    value: function renderMenu() {
      var _this5 = this;

      var _components3 = this.components,
          Group = _components3.Group,
          GroupHeading = _components3.GroupHeading,
          Menu$$1 = _components3.Menu,
          MenuList$$1 = _components3.MenuList,
          MenuPortal$$1 = _components3.MenuPortal,
          LoadingMessage$$1 = _components3.LoadingMessage,
          NoOptionsMessage$$1 = _components3.NoOptionsMessage,
          Option = _components3.Option;
      var commonProps = this.commonProps;
      var _state7 = this.state,
          focusedOption = _state7.focusedOption,
          menuOptions = _state7.menuOptions;
      var _props11 = this.props,
          captureMenuScroll = _props11.captureMenuScroll,
          inputValue = _props11.inputValue,
          isLoading = _props11.isLoading,
          loadingMessage = _props11.loadingMessage,
          minMenuHeight = _props11.minMenuHeight,
          maxMenuHeight = _props11.maxMenuHeight,
          menuIsOpen = _props11.menuIsOpen,
          menuPlacement = _props11.menuPlacement,
          menuPosition = _props11.menuPosition,
          menuPortalTarget = _props11.menuPortalTarget,
          menuShouldBlockScroll = _props11.menuShouldBlockScroll,
          menuShouldScrollIntoView = _props11.menuShouldScrollIntoView,
          noOptionsMessage = _props11.noOptionsMessage,
          onMenuScrollToTop = _props11.onMenuScrollToTop,
          onMenuScrollToBottom = _props11.onMenuScrollToBottom;


      if (!menuIsOpen) return null;

      // TODO: Internal Option Type here
      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Option,
          _extends({}, commonProps, props, { isFocused: isFocused }),
          _this5.formatOptionLabel(props.data, 'menu')
        );
      };

      var menuUI = void 0;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = objectWithoutProperties(item, ['type']);

            var headingId = item.key + '-heading';

            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              Group,
              _extends({}, commonProps, group, {
                Heading: GroupHeading,
                headingProps: {
                  id: headingId
                },
                label: _this5.formatGroupLabel(item.data)
              }),
              item.options.map(function (option) {
                return render(option);
              })
            );
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({ inputValue: inputValue });
        if (message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          LoadingMessage$$1,
          commonProps,
          message
        );
      } else {
        var _message = noOptionsMessage({ inputValue: inputValue });
        if (_message === null) return null;
        menuUI = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          NoOptionsMessage$$1,
          commonProps,
          _message
        );
      }
      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };

      var menuElement = __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPlacer,
        _extends({}, commonProps, menuPlacementProps),
        function (_ref2) {
          var ref = _ref2.ref,
              _ref2$placerProps = _ref2.placerProps,
              placement = _ref2$placerProps.placement,
              maxHeight = _ref2$placerProps.maxHeight;
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            Menu$$1,
            _extends({}, commonProps, menuPlacementProps, {
              innerRef: ref,
              innerProps: {
                onMouseDown: _this5.onMenuMouseDown,
                onMouseMove: _this5.onMenuMouseMove
              },
              isLoading: isLoading,
              placement: placement
            }),
            __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              ScrollCaptorSwitch,
              {
                isEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom
              },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                ScrollBlock,
                { isEnabled: menuShouldBlockScroll },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  MenuList$$1,
                  _extends({}, commonProps, {
                    innerRef: _this5.getMenuListRef,
                    isLoading: isLoading,
                    maxHeight: maxHeight
                  }),
                  menuUI
                )
              )
            )
          );
        }
      );

      // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`
      return menuPortalTarget || menuPosition === 'fixed' ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        MenuPortal$$1,
        _extends({}, commonProps, {
          appendTo: menuPortalTarget,
          controlElement: this.controlRef,
          menuPlacement: menuPlacement,
          menuPosition: menuPosition
        }),
        menuElement
      ) : menuElement;
    }
  }, {
    key: 'renderFormField',
    value: function renderFormField() {
      var _this6 = this;

      var _props12 = this.props,
          delimiter = _props12.delimiter,
          isDisabled = _props12.isDisabled,
          isMulti = _props12.isMulti,
          name = _props12.name;
      var selectValue = this.state.selectValue;


      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var _value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
              key: 'i-' + i,
              name: name,
              type: 'hidden',
              value: _this6.getOptionValue(opt)
            });
          }) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden' });

          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            null,
            input
          );
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', { name: name, type: 'hidden', value: _value2 });
      }
    }
  }, {
    key: 'renderLiveRegion',
    value: function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        A11yText,
        { 'aria-live': 'assertive' },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-selection-event' },
          '\xA0',
          this.state.ariaLiveSelection
        ),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'p',
          { id: 'aria-context' },
          '\xA0',
          this.constructAriaLiveMessage()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _components4 = this.components,
          Control = _components4.Control,
          IndicatorsContainer = _components4.IndicatorsContainer,
          SelectContainer = _components4.SelectContainer,
          ValueContainer = _components4.ValueContainer;
      var _props13 = this.props,
          className = _props13.className,
          id = _props13.id,
          isDisabled = _props13.isDisabled;
      var isFocused = this.state.isFocused;


      var commonProps = this.commonProps = this.getCommonProps();

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        SelectContainer,
        _extends({}, commonProps, {
          className: className,
          innerProps: {
            id: id,
            onKeyDown: this.onKeyDown
          },
          isDisabled: isDisabled,
          isFocused: isFocused
        }),
        this.renderLiveRegion(),
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          Control,
          _extends({}, commonProps, {
            innerRef: this.getControlRef,
            innerProps: {
              onMouseDown: this.onControlMouseDown,
              onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused
          }),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            ValueContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderPlaceholderOrValue(),
            this.renderInput()
          ),
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            IndicatorsContainer,
            _extends({}, commonProps, { isDisabled: isDisabled }),
            this.renderClearIndicator(),
            this.renderLoadingIndicator(),
            this.renderIndicatorSeparator(),
            this.renderDropdownIndicator()
          )
        ),
        this.renderMenu(),
        this.renderFormField()
      );
    }
  }]);
  return Select;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

Select.defaultProps = defaultProps;

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.state = {
    ariaLiveSelection: '',
    ariaLiveContext: '',
    focusedOption: null,
    focusedValue: null,
    inputIsHidden: false,
    isFocused: false,
    isComposing: false,
    menuOptions: { render: [], focusable: [] },
    selectValue: []
  };
  this.blockOptionHover = false;
  this.clearFocusValueOnUpdate = false;
  this.hasGroups = false;
  this.initialTouchX = 0;
  this.initialTouchY = 0;
  this.instancePrefix = '';
  this.openAfterFocus = false;
  this.scrollToFocusedOptionOnUpdate = false;
  this.controlRef = null;

  this.getControlRef = function (ref) {
    _this7.controlRef = ref;
  };

  this.focusedOptionRef = null;

  this.getFocusedOptionRef = function (ref) {
    _this7.focusedOptionRef = ref;
  };

  this.menuListRef = null;

  this.getMenuListRef = function (ref) {
    _this7.menuListRef = ref;
  };

  this.inputRef = null;

  this.getInputRef = function (ref) {
    _this7.inputRef = ref;
  };

  this.cacheComponents = function (components$$1) {
    _this7.components = defaultComponents({ components: components$$1 });
  };

  this.focus = this.focusInput;
  this.blur = this.blurInput;

  this.setValue = function (newValue) {
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'set-value';
    var option = arguments[2];
    var _props14 = _this7.props,
        closeMenuOnSelect = _props14.closeMenuOnSelect,
        isMulti = _props14.isMulti,
        onChange = _props14.onChange;

    _this7.onInputChange('', { action: 'set-value' });
    if (closeMenuOnSelect) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    }
    // when the select value should change, we should reset focusedValue
    _this7.clearFocusValueOnUpdate = true;
    onChange(newValue, { action: action, option: option });
  };

  this.selectOption = function (newValue) {
    var _props15 = _this7.props,
        blurInputOnSelect = _props15.blurInputOnSelect,
        isMulti = _props15.isMulti;


    if (isMulti) {
      var _selectValue3 = _this7.state.selectValue;

      if (_this7.isOptionSelected(newValue, _selectValue3)) {
        var candidate = _this7.getOptionValue(newValue);
        _this7.setValue(_selectValue3.filter(function (i) {
          return _this7.getOptionValue(i) !== candidate;
        }), 'deselect-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'deselect-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      } else {
        _this7.setValue([].concat(toConsumableArray(_selectValue3), [newValue]), 'select-option', newValue);
        _this7.announceAriaLiveSelection({
          event: 'select-option',
          context: { value: _this7.getOptionLabel(newValue) }
        });
      }
    } else {
      _this7.setValue(newValue, 'select-option');
      _this7.announceAriaLiveSelection({
        event: 'select-option',
        context: { value: _this7.getOptionLabel(newValue) }
      });
    }

    if (blurInputOnSelect) {
      _this7.blurInput();
    }
  };

  this.removeValue = function (removedValue) {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var candidate = _this7.getOptionValue(removedValue);
    onChange(selectValue.filter(function (i) {
      return _this7.getOptionValue(i) !== candidate;
    }), {
      action: 'remove-value',
      removedValue: removedValue
    });
    _this7.announceAriaLiveSelection({
      event: 'remove-value',
      context: {
        value: removedValue ? _this7.getOptionLabel(removedValue) : undefined
      }
    });
    _this7.focusInput();
  };

  this.clearValue = function () {
    var _props16 = _this7.props,
        isMulti = _props16.isMulti,
        onChange = _props16.onChange;

    onChange(isMulti ? [] : null, { action: 'clear' });
  };

  this.popValue = function () {
    var onChange = _this7.props.onChange;
    var selectValue = _this7.state.selectValue;

    var lastSelectedValue = selectValue[selectValue.length - 1];
    _this7.announceAriaLiveSelection({
      event: 'pop-value',
      context: {
        value: lastSelectedValue ? _this7.getOptionLabel(lastSelectedValue) : undefined
      }
    });
    onChange(selectValue.slice(0, selectValue.length - 1), {
      action: 'pop-value',
      removedValue: lastSelectedValue
    });
  };

  this.getOptionLabel = function (data) {
    return _this7.props.getOptionLabel(data);
  };

  this.getOptionValue = function (data) {
    return _this7.props.getOptionValue(data);
  };

  this.getStyles = function (key, props) {
    var base = defaultStyles[key](props);
    base.boxSizing = 'border-box';
    var custom = _this7.props.styles[key];
    return custom ? custom(base, props) : base;
  };

  this.getElementId = function (element) {
    return _this7.instancePrefix + '-' + element;
  };

  this.getActiveDescendentId = function () {
    var menuIsOpen = _this7.props.menuIsOpen;
    var _state8 = _this7.state,
        menuOptions = _state8.menuOptions,
        focusedOption = _state8.focusedOption;


    if (!focusedOption || !menuIsOpen) return undefined;

    var index = menuOptions.focusable.indexOf(focusedOption);
    var option = menuOptions.render[index];

    return option && option.key;
  };

  this.announceAriaLiveSelection = function (_ref3) {
    var event = _ref3.event,
        context = _ref3.context;

    _this7.setState({
      ariaLiveSelection: valueEventAriaMessage(event, context)
    });
  };

  this.announceAriaLiveContext = function (_ref4) {
    var event = _ref4.event,
        context = _ref4.context;

    _this7.setState({
      ariaLiveContext: instructionsAriaMessage(event, _extends({}, context, {
        label: _this7.props['aria-label']
      }))
    });
  };

  this.onMenuMouseDown = function (event) {
    if (event.button !== 0) {
      return;
    }
    event.stopPropagation();
    event.preventDefault();
    _this7.focusInput();
  };

  this.onMenuMouseMove = function (event) {
    _this7.blockOptionHover = false;
  };

  this.onControlMouseDown = function (event) {
    var openMenuOnClick = _this7.props.openMenuOnClick;

    if (!_this7.state.isFocused) {
      if (openMenuOnClick) {
        _this7.openAfterFocus = true;
      }
      _this7.focusInput();
    } else if (!_this7.props.menuIsOpen) {
      _this7.openMenu('first');
    } else {
      _this7.onMenuClose();
    }
    // $FlowFixMe HTMLElement type does not have tagName property
    if (event.target.tagName !== 'INPUT') {
      event.preventDefault();
    }
  };

  this.onDropdownIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    if (_this7.props.isDisabled) return;
    var _props17 = _this7.props,
        isMulti = _props17.isMulti,
        menuIsOpen = _props17.menuIsOpen;

    _this7.focusInput();
    if (menuIsOpen) {
      _this7.inputIsHiddenAfterUpdate = !isMulti;
      _this7.onMenuClose();
    } else {
      _this7.openMenu('first');
    }
    event.preventDefault();
    event.stopPropagation();
  };

  this.onClearIndicatorMouseDown = function (event) {
    // ignore mouse events that weren't triggered by the primary button
    if (event && event.type === 'mousedown' && event.button !== 0) {
      return;
    }
    _this7.clearValue();
    event.stopPropagation();
    _this7.openAfterFocus = false;
    setTimeout(function () {
      return _this7.focusInput();
    });
  };

  this.onScroll = function (event) {
    if (typeof _this7.props.closeMenuOnScroll === 'boolean') {
      if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
        _this7.props.onMenuClose();
      }
    } else if (typeof _this7.props.closeMenuOnScroll === 'function') {
      if (_this7.props.closeMenuOnScroll(event)) {
        _this7.props.onMenuClose();
      }
    }
  };

  this.onCompositionStart = function () {
    _this7.setState({
      isComposing: true
    });
  };

  this.onCompositionEnd = function () {
    _this7.setState({
      isComposing: false
    });
  };

  this.onTouchStart = function (_ref5) {
    var _ref5$touches = slicedToArray(_ref5.touches, 1),
        touch = _ref5$touches[0];

    _this7.initialTouchX = touch.clientX;
    _this7.initialTouchY = touch.clientY;
    _this7.userIsDragging = false;
  };

  this.onTouchMove = function (_ref6) {
    var _ref6$touches = slicedToArray(_ref6.touches, 1),
        touch = _ref6$touches[0];

    var deltaX = Math.abs(touch.clientX - _this7.initialTouchX);
    var deltaY = Math.abs(touch.clientY - _this7.initialTouchY);
    var moveThreshold = 5;

    _this7.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
  };

  this.onTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    // type cast the EventTarget
    var target = event.target;

    // close the menu if the user taps outside
    if (_this7.controlRef && !_this7.controlRef.contains(target) && _this7.menuListRef && !_this7.menuListRef.contains(target)) {
      _this7.blurInput();
    }

    // reset move vars
    _this7.initialTouchX = 0;
    _this7.initialTouchY = 0;
  };

  this.onControlTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onControlMouseDown(event);
  };

  this.onClearIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onClearIndicatorMouseDown(event);
  };

  this.onDropdownIndicatorTouchEnd = function (event) {
    if (_this7.userIsDragging) return;

    _this7.onDropdownIndicatorMouseDown(event);
  };

  this.handleInputChange = function (event) {
    var inputValue = event.currentTarget.value;
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.onInputChange(inputValue, { action: 'input-change' });
    _this7.onMenuOpen();
  };

  this.onInputFocus = function (event) {
    var _props18 = _this7.props,
        isSearchable = _props18.isSearchable,
        isMulti = _props18.isMulti;

    if (_this7.props.onFocus) {
      _this7.props.onFocus(event);
    }
    _this7.inputIsHiddenAfterUpdate = false;
    _this7.announceAriaLiveContext({
      event: 'input',
      context: { isSearchable: isSearchable, isMulti: isMulti }
    });
    _this7.setState({
      isFocused: true
    });
    if (_this7.openAfterFocus || _this7.props.openMenuOnFocus) {
      _this7.openMenu('first');
    }
    _this7.openAfterFocus = false;
  };

  this.onInputBlur = function (event) {
    if (_this7.props.onBlur) {
      _this7.props.onBlur(event);
    }
    _this7.onInputChange('', { action: 'input-blur' });
    _this7.onMenuClose();
    _this7.setState({
      focusedValue: null,
      isFocused: false
    });
  };

  this.onOptionHover = function (focusedOption) {
    if (_this7.blockOptionHover || _this7.state.focusedOption === focusedOption) {
      return;
    }
    _this7.setState({ focusedOption: focusedOption });
  };

  this.shouldHideSelectedOptions = function () {
    var _props19 = _this7.props,
        hideSelectedOptions = _props19.hideSelectedOptions,
        isMulti = _props19.isMulti;

    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
  };

  this.onKeyDown = function (event) {
    var _props20 = _this7.props,
        isMulti = _props20.isMulti,
        backspaceRemovesValue = _props20.backspaceRemovesValue,
        escapeClearsValue = _props20.escapeClearsValue,
        inputValue = _props20.inputValue,
        isClearable = _props20.isClearable,
        isDisabled = _props20.isDisabled,
        menuIsOpen = _props20.menuIsOpen,
        onKeyDown = _props20.onKeyDown,
        tabSelectsValue = _props20.tabSelectsValue,
        openMenuOnFocus = _props20.openMenuOnFocus;
    var _state9 = _this7.state,
        isComposing = _state9.isComposing,
        focusedOption = _state9.focusedOption,
        focusedValue = _state9.focusedValue,
        selectValue = _state9.selectValue;


    if (isDisabled) return;

    if (typeof onKeyDown === 'function') {
      onKeyDown(event);
      if (event.defaultPrevented) {
        return;
      }
    }

    // Block option hover events when the user has just pressed a key
    _this7.blockOptionHover = true;
    switch (event.key) {
      case 'ArrowLeft':
        if (!isMulti || inputValue) return;
        _this7.focusValue('previous');
        break;
      case 'ArrowRight':
        if (!isMulti || inputValue) return;
        _this7.focusValue('next');
        break;
      case 'Delete':
      case 'Backspace':
        if (inputValue) return;
        if (focusedValue) {
          _this7.removeValue(focusedValue);
        } else {
          if (!backspaceRemovesValue) return;
          _this7.popValue();
        }
        break;
      case 'Tab':
        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption ||
        // don't capture the event if the menu opens on focus and the focused
        // option is already selected; it breaks the flow of navigation
        openMenuOnFocus && _this7.isOptionSelected(focusedOption, selectValue)) {
          return;
        }
        _this7.selectOption(focusedOption);
        break;
      case 'Enter':
        if (menuIsOpen) {
          if (!focusedOption) return;
          if (isComposing) return;
          _this7.selectOption(focusedOption);
        } else {
          _this7.focusOption('first');
        }
        break;
      case 'Escape':
        if (menuIsOpen) {
          _this7.inputIsHiddenAfterUpdate = false;
          _this7.onInputChange('', { action: 'menu-close' });
          _this7.onMenuClose();
        } else if (isClearable && escapeClearsValue) {
          _this7.clearValue();
        }
        break;
      case ' ':
        // space
        if (inputValue) {
          return;
        }
        if (!menuIsOpen) {
          _this7.openMenu('first');
          break;
        }
        if (!focusedOption) return;
        _this7.selectOption(focusedOption);
        break;
      case 'ArrowUp':
        if (menuIsOpen) {
          _this7.focusOption('up');
        } else {
          _this7.openMenu('last');
        }
        break;
      case 'ArrowDown':
        if (menuIsOpen) {
          _this7.focusOption('down');
        } else {
          _this7.openMenu('first');
        }
        break;
      case 'PageUp':
        if (!menuIsOpen) return;
        _this7.focusOption('pageup');
        break;
      case 'PageDown':
        if (!menuIsOpen) return;
        _this7.focusOption('pagedown');
        break;
      case 'Home':
        if (!menuIsOpen) return;
        _this7.focusOption('first');
        break;
      case 'End':
        if (!menuIsOpen) return;
        _this7.focusOption('last');
        break;
      default:
        return;
    }
    event.preventDefault();
  };
};

var manageState = function manageState(SelectComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    inherits(StateManager, _Component);

    function StateManager() {
      var _ref;

      var _temp, _this, _ret;

      classCallCheck(this, StateManager);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = StateManager.__proto__ || Object.getPrototypeOf(StateManager)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
        menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
        value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
      }, _this.onChange = function (value, actionMeta) {
        _this.callProp('onChange', value, actionMeta);
        _this.setState({ value: value });
      }, _this.onInputChange = function (value, actionMeta) {
        // TODO: for backwards compatibility, we allow the prop to return a new
        // value, but now inputValue is a controllable prop we probably shouldn't
        var newValue = _this.callProp('onInputChange', value, actionMeta);
        _this.setState({
          inputValue: newValue !== undefined ? newValue : value
        });
      }, _this.onMenuOpen = function () {
        _this.callProp('onMenuOpen');
        _this.setState({ menuIsOpen: true });
      }, _this.onMenuClose = function () {
        _this.callProp('onMenuClose');
        _this.setState({ menuIsOpen: false });
      }, _temp), possibleConstructorReturn(_this, _ret);
    }

    createClass(StateManager, [{
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'getProp',
      value: function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      }
    }, {
      key: 'callProp',
      value: function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _props;

          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_props = this.props)[name].apply(_props, toConsumableArray(args));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, this.props, {
          ref: function ref(_ref2) {
            _this2.select = _ref2;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      }
    }]);
    return StateManager;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  }, _temp2;
};

var defaultProps$1 = {
  cacheOptions: false,
  defaultOptions: false
};

var makeAsyncSelect = function makeAsyncSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Async, _Component);

    function Async(props) {
      classCallCheck(this, Async);

      var _this = possibleConstructorReturn(this, (Async.__proto__ || Object.getPrototypeOf(Async)).call(this));

      _this.mounted = false;
      _this.optionsCache = {};

      _this.handleInputChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            cacheOptions = _this$props.cacheOptions,
            onInputChange = _this$props.onInputChange;
        // TODO

        var inputValue = handleInputChange(newValue, actionMeta, onInputChange);
        if (!inputValue) {
          delete _this.lastRequest;
          _this.setState({
            inputValue: '',
            loadedInputValue: '',
            loadedOptions: [],
            isLoading: false,
            passEmptyOptions: false
          });
          return;
        }
        if (cacheOptions && _this.optionsCache[inputValue]) {
          _this.setState({
            inputValue: inputValue,
            loadedInputValue: inputValue,
            loadedOptions: _this.optionsCache[inputValue],
            isLoading: false,
            passEmptyOptions: false
          });
        } else {
          var request = _this.lastRequest = {};
          _this.setState({
            inputValue: inputValue,
            isLoading: true,
            passEmptyOptions: !_this.state.loadedInputValue
          }, function () {
            _this.loadOptions(inputValue, function (options) {
              if (!_this.mounted) return;
              if (options) {
                _this.optionsCache[inputValue] = options;
              }
              if (request !== _this.lastRequest) return;
              delete _this.lastRequest;
              _this.setState({
                isLoading: false,
                loadedInputValue: inputValue,
                loadedOptions: options || [],
                passEmptyOptions: false
              });
            });
          });
        }
        return inputValue;
      };

      _this.state = {
        defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
        inputValue: '',
        isLoading: props.defaultOptions === true ? true : false,
        loadedOptions: [],
        passEmptyOptions: false
      };
      return _this;
    }

    createClass(Async, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.mounted = true;
        var defaultOptions = this.props.defaultOptions;

        if (defaultOptions === true) {
          this.loadOptions('', function (options) {
            if (!_this2.mounted) return;
            var isLoading = !!_this2.lastRequest;
            _this2.setState({ defaultOptions: options || [], isLoading: isLoading });
          });
        }
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        // if the cacheOptions prop changes, clear the cache
        if (nextProps.cacheOptions !== this.props.cacheOptions) {
          this.optionsCache = {};
        }
        if (nextProps.defaultOptions !== this.props.defaultOptions) {
          this.setState({
            defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.mounted = false;
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'loadOptions',
      value: function loadOptions(inputValue, callback) {
        var loadOptions = this.props.loadOptions;

        if (!loadOptions) return callback();
        var loader = loadOptions(inputValue, callback);
        if (loader && typeof loader.then === 'function') {
          loader.then(callback, function () {
            return callback();
          });
        }
      }
    }, {
      key: 'render',
      value: function render() {
        var _this3 = this;

        var _props = this.props,
            loadOptions = _props.loadOptions,
            props = objectWithoutProperties(_props, ['loadOptions']);
        var _state = this.state,
            defaultOptions = _state.defaultOptions,
            inputValue = _state.inputValue,
            isLoading = _state.isLoading,
            loadedInputValue = _state.loadedInputValue,
            loadedOptions = _state.loadedOptions,
            passEmptyOptions = _state.passEmptyOptions;

        var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return (
          // $FlowFixMe
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
            filterOption: this.props.filterOption || null,
            ref: function ref(_ref) {
              _this3.select = _ref;
            },
            options: options,
            isLoading: isLoading,
            onInputChange: this.handleInputChange
          }))
        );
      }
    }]);
    return Async;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$1, _temp;
};
var Async = makeAsyncSelect(manageState(Select));

var compareOption = function compareOption(inputValue, option) {
  var candidate = inputValue.toLowerCase();
  return option.value.toLowerCase() === candidate || option.label.toLowerCase() === candidate;
};

var builtins = {
  formatCreateLabel: function formatCreateLabel(inputValue) {
    return 'Create "' + inputValue + '"';
  },
  isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
    return !(!inputValue || selectValue.some(function (option) {
      return compareOption(inputValue, option);
    }) || selectOptions.some(function (option) {
      return compareOption(inputValue, option);
    }));
  },
  getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
    return {
      label: optionLabel,
      value: inputValue,
      __isNew__: true
    };
  }
};

var defaultProps$2 = _extends({
  allowCreateWhileLoading: false,
  createOptionPosition: 'last'
}, builtins);

var makeCreatableSelect = function makeCreatableSelect(SelectComponent) {
  var _class, _temp;

  return _temp = _class = function (_Component) {
    inherits(Creatable, _Component);

    function Creatable(props) {
      classCallCheck(this, Creatable);

      var _this = possibleConstructorReturn(this, (Creatable.__proto__ || Object.getPrototypeOf(Creatable)).call(this, props));

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            getNewOptionData = _this$props.getNewOptionData,
            inputValue = _this$props.inputValue,
            isMulti = _this$props.isMulti,
            onChange = _this$props.onChange,
            onCreateOption = _this$props.onCreateOption,
            value = _this$props.value;

        if (actionMeta.action !== 'select-option') {
          return onChange(newValue, actionMeta);
        }
        var newOption = _this.state.newOption;

        var valueArray = Array.isArray(newValue) ? newValue : [newValue];

        if (valueArray[valueArray.length - 1] === newOption) {
          if (onCreateOption) onCreateOption(inputValue);else {
            var newOptionData = getNewOptionData(inputValue, inputValue);
            var newActionMeta = { action: 'create-option' };
            if (isMulti) {
              onChange([].concat(toConsumableArray(cleanValue(value)), [newOptionData]), newActionMeta);
            } else {
              onChange(newOptionData, newActionMeta);
            }
          }
          return;
        }
        onChange(newValue, actionMeta);
      };

      var options = props.options || [];
      _this.state = {
        newOption: undefined,
        options: options
      };
      return _this;
    }

    createClass(Creatable, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var allowCreateWhileLoading = nextProps.allowCreateWhileLoading,
            createOptionPosition = nextProps.createOptionPosition,
            formatCreateLabel = nextProps.formatCreateLabel,
            getNewOptionData = nextProps.getNewOptionData,
            inputValue = nextProps.inputValue,
            isLoading = nextProps.isLoading,
            isValidNewOption = nextProps.isValidNewOption,
            value = nextProps.value;

        var options = nextProps.options || [];
        var newOption = this.state.newOption;

        if (isValidNewOption(inputValue, cleanValue(value), options)) {
          newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
        } else {
          newOption = undefined;
        }
        this.setState({
          newOption: newOption,
          options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [newOption].concat(toConsumableArray(options)) : [].concat(toConsumableArray(options), [newOption]) : options
        });
      }
    }, {
      key: 'focus',
      value: function focus() {
        this.select.focus();
      }
    }, {
      key: 'blur',
      value: function blur() {
        this.select.blur();
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var props = objectWithoutProperties(this.props, []);
        var options = this.state.options;

        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SelectComponent, _extends({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          options: options,
          onChange: this.onChange
        }));
      }
    }]);
    return Creatable;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]), _class.defaultProps = defaultProps$2, _temp;
};
var Creatable = manageState(makeCreatableSelect(Select));

var AsyncCreatable = makeAsyncSelect(manageState(makeCreatableSelect(Select)));

// ==============================
// Fade Transition
// ==============================

var Fade = function Fade(_ref) {
  var Tag = _ref.component,
      _ref$duration = _ref.duration,
      duration = _ref$duration === undefined ? 1 : _ref$duration,
      inProp = _ref.in,
      onExited = _ref.onExited,
      props = objectWithoutProperties(_ref, ['component', 'duration', 'in', 'onExited']);

  var transition = {
    entering: { opacity: 0 },
    entered: { opacity: 1, transition: 'opacity ' + duration + 'ms' },
    exiting: { opacity: 0 },
    exited: { opacity: 0 }
  };

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
    { mountOnEnter: true, unmountOnExit: true, 'in': inProp, timeout: duration },
    function (state) {
      var innerProps = {
        style: _extends({}, transition[state])
      };
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tag, _extends({ innerProps: innerProps }, props));
    }
  );
};
var collapseDuration = 260;

// wrap each MultiValue with a collapse transition; decreases width until
// finally removing from DOM
var Collapse = function (_Component) {
  inherits(Collapse, _Component);

  function Collapse() {
    var _ref2;

    var _temp, _this, _ret;

    classCallCheck(this, Collapse);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref2 = Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call.apply(_ref2, [this].concat(args))), _this), _this.duration = collapseDuration, _this.state = { width: 'auto' }, _this.transition = {
      exiting: { width: 0, transition: 'width ' + _this.duration + 'ms ease-out' },
      exited: { width: 0 }
    }, _this.getWidth = function (ref) {
      if (ref && isNaN(_this.state.width)) {
        // cannot use `offsetWidth` because it is rounded
        var _ref$getBoundingClien = ref.getBoundingClientRect(),
            _width = _ref$getBoundingClien.width;

        _this.setState({ width: _width });
      }
    }, _this.getStyle = function (width) {
      return {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: width
      };
    }, _this.getTransition = function (state) {
      return _this.transition[state];
    }, _temp), possibleConstructorReturn(_this, _ret);
  }

  // width must be calculated; cannot transition from `undefined` to `number`


  // get base styles


  // get transition styles


  createClass(Collapse, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          inProp = _props.in;
      var width = this.state.width;


      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_react_transition_group__["Transition"],
        {
          enter: false,
          mountOnEnter: true,
          unmountOnExit: true,
          'in': inProp,
          timeout: this.duration
        },
        function (state) {
          var style = _extends({}, _this2.getStyle(width), _this2.getTransition(state));
          return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { ref: _this2.getWidth, style: style },
            children
          );
        }
      );
    }
  }]);
  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

// strip transition props off before spreading onto select component
// note we need to be explicit about innerRef for flow
var AnimatedInput = function AnimatedInput(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        props = objectWithoutProperties(_ref, ['in', 'onExited', 'appear', 'enter', 'exit', 'innerRef']);
    return (
      // $FlowFixMe
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ innerRef: innerRef }, props))
    );
  };
};

// strip transition props off before spreading onto actual component


var AnimatedMultiValue = function AnimatedMultiValue(WrappedComponent) {
  return function (_ref) {
    var inProp = _ref.in,
        onExited = _ref.onExited,
        props = objectWithoutProperties(_ref, ['in', 'onExited']);
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      Collapse,
      { 'in': inProp, onExited: onExited },
      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, _extends({ cropWithEllipsis: inProp }, props))
    );
  };
};

// fade in when last multi-value removed, otherwise instant
var AnimatedPlaceholder = function AnimatedPlaceholder(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({
      component: WrappedComponent,
      duration: props.isMulti ? collapseDuration : 1
    }, props));
  };
};

// instant fade; all transition-group children must be transitions

var AnimatedSingleValue = function AnimatedSingleValue(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Fade, _extends({ component: WrappedComponent }, props));
  };
};

// make ValueContainer a transition group
var AnimatedValueContainer = function AnimatedValueContainer(WrappedComponent) {
  return function (props) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react_transition_group__["TransitionGroup"], _extends({ component: WrappedComponent }, props));
  };
};

var makeAnimated = function makeAnimated(externalComponents) {
  var components$$1 = defaultComponents({ components: externalComponents });
  var Input = components$$1.Input,
      MultiValue = components$$1.MultiValue,
      Placeholder = components$$1.Placeholder,
      SingleValue = components$$1.SingleValue,
      ValueContainer = components$$1.ValueContainer,
      rest = objectWithoutProperties(components$$1, ['Input', 'MultiValue', 'Placeholder', 'SingleValue', 'ValueContainer']);

  return _extends({
    Input: AnimatedInput(Input),
    MultiValue: AnimatedMultiValue(MultiValue),
    Placeholder: AnimatedPlaceholder(Placeholder),
    SingleValue: AnimatedSingleValue(SingleValue),
    ValueContainer: AnimatedValueContainer(ValueContainer)
  }, rest);
};

var AnimatedComponents = makeAnimated();

var Input$1 = AnimatedComponents.Input;
var MultiValue$1 = AnimatedComponents.MultiValue;
var Placeholder$1 = AnimatedComponents.Placeholder;
var SingleValue$1 = AnimatedComponents.SingleValue;
var ValueContainer$1 = AnimatedComponents.ValueContainer;

var index = Object(__WEBPACK_IMPORTED_MODULE_6_memoize_one__["default"])(makeAnimated, exportedEqual);

var index$1 = manageState(Select);

/* harmony default export */ __webpack_exports__["b"] = (index$1);



/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony export (immutable) */ __webpack_exports__["b"] = SupportLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-content: center;\n  align-items: center;\n  flex: 0 0 auto;\n  margin-left: auto;\n  font-size: ",";\n  line-height: 17px;\n  white-space: nowrap;\n  text-decoration: none;\n  color: ",";\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: underline;\n    color: ",";\n  }\n"],["\n  direction: ",";\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-content: center;\n  align-items: center;\n  flex: 0 0 auto;\n  margin-left: auto;\n  font-size: ",";\n  line-height: 17px;\n  white-space: nowrap;\n  text-decoration: none;\n  color: ",";\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: underline;\n    color: ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 17px;\n  height: 17px;\n  ",";\n  fill: #a5a4a4;\n"],["\n  width: 17px;\n  height: 17px;\n  ",";\n  fill: #a5a4a4;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Support=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* Link */])(_templateObject,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_5__styled_mixins__["a" /* fontSize */])(14),function(_ref){var theme=_ref.theme;return theme.mainLink;},function(_ref2){var theme=_ref2.theme;return theme.accent;});var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_5__styled_mixins__["c" /* rtl */])("margin-left","10px"));var Icon=function Icon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{xmlns:"http://www.w3.org/2000/svg",viewBox:"1132.1 517.1 19.9 19.9"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M1142.05 517.1a9.95 9.95 0 1 0 9.95 9.95 9.949 9.949 0 0 0-9.95-9.95zm0 4.64a1.249 1.249 0 1 1-1.25 1.25 1.249 1.249 0 0 1 1.25-1.25zm2.186 10.62h-4.372v-1.874h.936v-3.748h-.936v-1.874h3.436v5.622h.937v1.874z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M1134.472 532.301l-1.17 4.366 4.366-1.17z"}));};function SupportLink(_ref3){var _ref3$to=_ref3.to,to=_ref3$to===undefined?"/helpdesk":_ref3$to,children=_ref3.children,props=_objectWithoutProperties(_ref3,["to","children"]);var onClick=props.onClick||null;if(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* isIronTerminal */])()){onClick=function onClick(e){if(e)e.preventDefault();if(props.onClick&&typeof props.onClick==="function"){props.onClick(e);}Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* iOSAppPostMessage */])("gotoSupport");};}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Support,Object.assign({},props,{to:to,onClick:onClick}),children||__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Gettext__["b" /* default */],null,"Need any help?"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null));}

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__User__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withErrorCatch__ = __webpack_require__(149);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: flex-start;\n  align-content: stretch;\n  justify-content: flex-start;\n  min-width: 276px;\n  max-width: 276px;\n  background-color: ",";\n  z-index: 100000;\n  cursor: default;\n  transform: translateX(0);\n  transition: transform 0.3s;\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n  }\n"],["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: flex-start;\n  align-content: stretch;\n  justify-content: flex-start;\n  min-width: 276px;\n  max-width: 276px;\n  background-color: ",";\n  z-index: 100000;\n  cursor: default;\n  transform: translateX(0);\n  transition: transform 0.3s;\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      top: 74px;\n      max-height: 100%;\n    "],["\n      top: 74px;\n      max-height: 100%;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      transform: ",";\n    "],["\n      transform: ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n  overflow: hidden;\n  opacity: 1;\n  transition: 0.3s;\n\n  @media (max-width: 959px) {\n    cursor: pointer;\n  }\n\n  ",";\n\n  ",";\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 10000;\n  overflow: hidden;\n  opacity: 1;\n  transition: 0.3s;\n\n  @media (max-width: 959px) {\n    cursor: pointer;\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      opacity: 0;\n      z-index: -1;\n    "],["\n      opacity: 0;\n      z-index: -1;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      background-color: ",";\n\n      @media (max-width: 959px) {\n        background-color: rgba(0, 0, 0, 0.5);\n      }\n    "],["\n      background-color: ",";\n\n      @media (max-width: 959px) {\n        background-color: rgba(0, 0, 0, 0.5);\n      }\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.mainDark;},function(props){return props.trade&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return!props.open&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,window.innerWidth<960?"translateX(-100%)":"translateX(100%)");}));var Overlay=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return!props.open&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.trade&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(_ref){var overflow=_ref.overflow;return overflow?"rgba(0, 0, 0, 0.5)":"transparent";});}));var CommonNav=function(_Component){_inherits(CommonNav,_Component);function CommonNav(){_classCallCheck(this,CommonNav);return _possibleConstructorReturn(this,(CommonNav.__proto__||Object.getPrototypeOf(CommonNav)).apply(this,arguments));}_createClass(CommonNav,[{key:"render",value:function render(){var _this2=this;var _props=this.props,className=_props.className,onClose=_props.onClose,trade=_props.trade,profile=_props.profile,isVIP=_props.isVIP,hideLangSelect=_props.hideLangSelect,open=_props.open,bellActive=_props.bellActive,setBellActive=_props.setBellActive;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_ClickOutside__["a" /* default */],{onOutsideClick:onClose},function(_ref2){var innerRef=_ref2.innerRef;return(// обычный ref для стильного компонента отдает не элемент DOMа,
// поэтому для элемента DOMа нам нужен innerRef
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{ref:innerRef,className:className,trade:trade,open:open},profile&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__User__["a" /* default */],Object.assign({},profile,{trade:trade,onClick:onClose,isVIP:isVIP,changeLocaleFetching:_this2.props.changeLocaleFetching,onLocaleChange:_this2.props.onLocaleChange,hideLangSelect:hideLangSelect})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Menu__["a" /* default */],{locale:profile?profile.locale:null,currency:profile?profile.currency:null,changeLocaleFetching:_this2.props.changeLocaleFetching,onLocaleChange:_this2.props.onLocaleChange,onClick:onClose,isLoggedIn:!!profile,hideLangSelect:hideLangSelect,bellActive:bellActive,onBellClick:setBellActive,isRealAcc:Boolean(profile&&profile.real&&profile.real===1)})));});}}]);return CommonNav;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Navigation=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),bellActive=_useState2[0],setBellActive=_useState2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{trade:props.trade,open:props.open,overflow:bellActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CommonNav,Object.assign({},props,{setBellActive:setBellActive,bellActive:bellActive})));});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__withErrorCatch__["a" /* default */])(Navigation));

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 18px;\n  color: #e74c3c;\n  @media(max-width: 959px) {\n    font-size: ",";\n  }\n  @media(max-width: 480px) {\n    font-size: ",";\n  }\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 18px;\n  color: #e74c3c;\n  @media(max-width: 959px) {\n    font-size: ",";\n  }\n  @media(max-width: 480px) {\n    font-size: ",";\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Invalid=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Invalid,null,props.children);});

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(1128);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(1192),
    baseUnary = __webpack_require__(369),
    nodeUtil = __webpack_require__(370);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(317),
    nativeKeys = __webpack_require__(1193);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_Gettext__ = __webpack_require__(2);
var RtlProvider=function RtlProvider(_ref){var locale=_ref.locale,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* ThemeProvider */],{theme:{direction:locale==="ar"?"rtl":"ltr",locale:locale}},children);};var mapStateToProps=function mapStateToProps(state){return{locale:Object(__WEBPACK_IMPORTED_MODULE_3__components_common_Gettext__["d" /* inferLocale */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(RtlProvider));

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayoutSwitcher__ = __webpack_require__(769);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LayoutSwitcher__["a" /* default */],{mobile:children,desktop:null});});

/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports,__webpack_require__(0),__webpack_require__(1392),__webpack_require__(97),__webpack_require__(1395),__webpack_require__(636),__webpack_require__(1396),__webpack_require__(645),__webpack_require__(646),__webpack_require__(404),__webpack_require__(647),__webpack_require__(405),__webpack_require__(649),__webpack_require__(1411),__webpack_require__(1412),__webpack_require__(1413),__webpack_require__(1414),__webpack_require__(1415),__webpack_require__(1416),__webpack_require__(1417),__webpack_require__(1418),__webpack_require__(1419),__webpack_require__(1420),__webpack_require__(1421),__webpack_require__(1422),__webpack_require__(1423),__webpack_require__(1424),__webpack_require__(1425),__webpack_require__(1426),__webpack_require__(1427),__webpack_require__(1428),__webpack_require__(650),__webpack_require__(1429),__webpack_require__(1430),__webpack_require__(1431),__webpack_require__(1432),__webpack_require__(1433),__webpack_require__(1434),__webpack_require__(1435),__webpack_require__(406),__webpack_require__(651),__webpack_require__(1436),__webpack_require__(652),__webpack_require__(1437),__webpack_require__(1438),__webpack_require__(1439),__webpack_require__(1440),__webpack_require__(1441),__webpack_require__(1442),__webpack_require__(1443),__webpack_require__(1444),__webpack_require__(1445),__webpack_require__(1446),__webpack_require__(1447),__webpack_require__(1448),__webpack_require__(7),__webpack_require__(1449),__webpack_require__(1456),__webpack_require__(1457),__webpack_require__(1458)):"function"==typeof define&&define.amd?define(["exports","react","prop-types","classnames","date-fns/isDate","date-fns/isValid","date-fns/format","date-fns/addMinutes","date-fns/addHours","date-fns/addDays","date-fns/addWeeks","date-fns/addMonths","date-fns/addYears","date-fns/subMinutes","date-fns/subHours","date-fns/subDays","date-fns/subWeeks","date-fns/subMonths","date-fns/subYears","date-fns/getSeconds","date-fns/getMinutes","date-fns/getHours","date-fns/getDay","date-fns/getDate","date-fns/getMonth","date-fns/getQuarter","date-fns/getYear","date-fns/getTime","date-fns/setSeconds","date-fns/setMinutes","date-fns/setHours","date-fns/setMonth","date-fns/setQuarter","date-fns/setYear","date-fns/min","date-fns/max","date-fns/differenceInCalendarDays","date-fns/differenceInCalendarMonths","date-fns/differenceInCalendarWeeks","date-fns/startOfDay","date-fns/startOfWeek","date-fns/startOfMonth","date-fns/startOfQuarter","date-fns/startOfYear","date-fns/endOfDay","date-fns/endOfWeek","date-fns/endOfMonth","date-fns/isEqual","date-fns/isSameDay","date-fns/isSameMonth","date-fns/isSameYear","date-fns/isSameQuarter","date-fns/isAfter","date-fns/isBefore","date-fns/isWithinInterval","date-fns/toDate","date-fns/parse","date-fns/parseISO","react-onclickoutside","react-popper"],t):t((e=e||self).DatePicker={},e.React,e.PropTypes,e.classNames,e.isDate,e.isValidDate,e.format,e.addMinutes,e.addHours,e.utils,e.utils$1,e.addMonths,e.addYears,e.subMinutes,e.subHours,e.subDays,e.subWeeks,e.subMonths,e.subYears,e.getSeconds,e.getMinutes,e.getHours,e.getDay,e.getDate,e.getMonth,e.getQuarter,e.getYear,e.getTime,e.setSeconds,e.setMinutes,e.setHours,e.utils$2,e.utils$3,e.setYear,e.min,e.max,e.differenceInCalendarDays,e.differenceInCalendarMonths,e.differenceInCalendarWeeks,e.startOfDay,e.startOfWeek,e.startOfMonth,e.startOfQuarter,e.startOfYear,e.endOfDay,e.endOfWeek,e.endOfMonth,e.dfIsEqual,e.dfIsSameDay,e.dfIsSameMonth,e.dfIsSameYear,e.dfIsSameQuarter,e.isAfter,e.isBefore,e.isWithinInterval,e.toDate,e.parse,e.parseISO,e.onClickOutside,e.ReactPopper)}(this,function(e,t,r,n,a,o,s,i,p,c,d,l,u,h,f,m,y,v,D,w,g,k,_,C,b,S,M,O,P,E,N,Y,T,x,I,q,L,W,F,B,R,j,H,Q,V,A,K,U,$,z,G,J,X,Z,ee,te,re,ne,ae,oe){"use strict";function se(e){return(se="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function ie(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function pe(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}function ce(e,t,r){return t&&pe(e.prototype,t),r&&pe(e,r),e}function de(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function le(){return(le=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n])}return e}).apply(this,arguments)}function ue(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,n)}return r}function he(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&me(e,t)}function fe(e){return(fe=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function me(e,t){return(me=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ye(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function ve(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?ye(e):t}t=t&&t.hasOwnProperty("default")?t.default:t,r=r&&r.hasOwnProperty("default")?r.default:r,n=n&&n.hasOwnProperty("default")?n.default:n,a=a&&a.hasOwnProperty("default")?a.default:a,o=o&&o.hasOwnProperty("default")?o.default:o,s=s&&s.hasOwnProperty("default")?s.default:s,i=i&&i.hasOwnProperty("default")?i.default:i,p=p&&p.hasOwnProperty("default")?p.default:p,c=c&&c.hasOwnProperty("default")?c.default:c,d=d&&d.hasOwnProperty("default")?d.default:d,l=l&&l.hasOwnProperty("default")?l.default:l,u=u&&u.hasOwnProperty("default")?u.default:u,h=h&&h.hasOwnProperty("default")?h.default:h,f=f&&f.hasOwnProperty("default")?f.default:f,m=m&&m.hasOwnProperty("default")?m.default:m,y=y&&y.hasOwnProperty("default")?y.default:y,v=v&&v.hasOwnProperty("default")?v.default:v,D=D&&D.hasOwnProperty("default")?D.default:D,w=w&&w.hasOwnProperty("default")?w.default:w,g=g&&g.hasOwnProperty("default")?g.default:g,k=k&&k.hasOwnProperty("default")?k.default:k,_=_&&_.hasOwnProperty("default")?_.default:_,C=C&&C.hasOwnProperty("default")?C.default:C,b=b&&b.hasOwnProperty("default")?b.default:b,S=S&&S.hasOwnProperty("default")?S.default:S,M=M&&M.hasOwnProperty("default")?M.default:M,O=O&&O.hasOwnProperty("default")?O.default:O,P=P&&P.hasOwnProperty("default")?P.default:P,E=E&&E.hasOwnProperty("default")?E.default:E,N=N&&N.hasOwnProperty("default")?N.default:N,Y=Y&&Y.hasOwnProperty("default")?Y.default:Y,T=T&&T.hasOwnProperty("default")?T.default:T,x=x&&x.hasOwnProperty("default")?x.default:x,I=I&&I.hasOwnProperty("default")?I.default:I,q=q&&q.hasOwnProperty("default")?q.default:q,L=L&&L.hasOwnProperty("default")?L.default:L,W=W&&W.hasOwnProperty("default")?W.default:W,F=F&&F.hasOwnProperty("default")?F.default:F,B=B&&B.hasOwnProperty("default")?B.default:B,R=R&&R.hasOwnProperty("default")?R.default:R,j=j&&j.hasOwnProperty("default")?j.default:j,H=H&&H.hasOwnProperty("default")?H.default:H,Q=Q&&Q.hasOwnProperty("default")?Q.default:Q,V=V&&V.hasOwnProperty("default")?V.default:V,A=A&&A.hasOwnProperty("default")?A.default:A,K=K&&K.hasOwnProperty("default")?K.default:K,U=U&&U.hasOwnProperty("default")?U.default:U,$=$&&$.hasOwnProperty("default")?$.default:$,z=z&&z.hasOwnProperty("default")?z.default:z,G=G&&G.hasOwnProperty("default")?G.default:G,J=J&&J.hasOwnProperty("default")?J.default:J,X=X&&X.hasOwnProperty("default")?X.default:X,Z=Z&&Z.hasOwnProperty("default")?Z.default:Z,ee=ee&&ee.hasOwnProperty("default")?ee.default:ee,te=te&&te.hasOwnProperty("default")?te.default:te,re=re&&re.hasOwnProperty("default")?re.default:re,ne=ne&&ne.hasOwnProperty("default")?ne.default:ne,ae=ae&&ae.hasOwnProperty("default")?ae.default:ae;var De,we=function(e,t){return e(t={exports:{}},t.exports),t.exports}(function(e,t){function r(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});case"PPPP":default:return t.date({width:"full"})}}function n(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});case"pppp":default:return t.time({width:"full"})}}Object.defineProperty(t,"__esModule",{value:!0}),t.default=void 0;var a={p:n,P:function(e,t){var a,o=e.match(/(P+)(p+)?/),s=o[1],i=o[2];if(!i)return r(e,t);switch(s){case"P":a=t.dateTime({width:"short"});break;case"PP":a=t.dateTime({width:"medium"});break;case"PPP":a=t.dateTime({width:"long"});break;case"PPPP":default:a=t.dateTime({width:"full"})}return a.replace("{{date}}",r(s,t)).replace("{{time}}",n(i,t))}};t.default=a,e.exports=t.default}),ge=(De=we)&&De.__esModule&&Object.prototype.hasOwnProperty.call(De,"default")?De.default:De,ke=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function _e(e){var t=e?"string"==typeof e||e instanceof String?ne(e):te(e):new Date;return be(t)?t:null}function Ce(e,t,r,n){var a=null,o=Le(r)||qe(),i=!0;return Array.isArray(t)?(t.forEach(function(t){var r=re(e,t,new Date,{locale:o});n&&(i=be(r)&&e===s(r,t,{awareOfUnicodeTokens:!0})),be(r)&&i&&(a=r)}),a):(a=re(e,t,new Date,{locale:o}),n?i=be(a)&&e===s(a,t,{awareOfUnicodeTokens:!0}):be(a)||(t=t.match(ke).map(function(e){var t=e[0];if("p"===t||"P"===t){var r=ge[t];return o?r(e,o.formatLong):t}return e}).join(""),e.length>0&&(a=re(e,t.slice(0,e.length),new Date)),be(a)||(a=new Date(e))),be(a)&&i?a:null)}function be(e){return o(e)&&X(e,new Date("1/1/1000"))}function Se(e,t,r){if("en"===r)return s(e,t,{awareOfUnicodeTokens:!0});var n=Le(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&qe()&&Le(qe())&&(n=Le(qe())),s(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Me(e,t){var r=t.hour,n=void 0===r?0:r,a=t.minute,o=void 0===a?0:a,s=t.second;return N(E(P(e,void 0===s?0:s),o),n)}function Oe(e,t){var r=Le(t||qe());return R(e,{locale:r})}function Pe(e){return j(e)}function Ee(e,t){return e&&t?G(e,t):!e&&!t}function Ne(e,t){return e&&t?z(e,t):!e&&!t}function Ye(e,t){return e&&t?J(e,t):!e&&!t}function Te(e,t){return e&&t?$(e,t):!e&&!t}function xe(e,t){return e&&t?U(e,t):!e&&!t}function Ie(e,t,r){var n,a=B(t),o=V(r);try{n=ee(e,{start:a,end:o})}catch(e){n=!1}return n}function qe(){return("undefined"!=typeof window?window:global).__localeId__}function Le(e){if("string"==typeof e){var t="undefined"!=typeof window?window:global;return t.__localeData__?t.__localeData__[e]:null}return e}function We(e,t){return Se(Y(_e(),e),"LLL",t)}function Fe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Qe(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Te(e,t)})||o&&!o.some(function(t){return Te(e,t)})||s&&!s(_e(e))||!1}function Be(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Qe(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Ne(e,t)})||o&&!o.some(function(t){return Ne(e,t)})||s&&!s(_e(e))||!1}function Re(e,t,r,n){var a=M(e),o=b(e),s=M(t),i=b(t),p=M(n);return a===s&&a===p?o<=r&&r<=i:a<s?p===a&&o<=r||p===s&&i>=r||p<s&&p>a:void 0}function je(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,a=t.excludeDates,o=t.includeDates,s=t.filterDate;return Qe(e,{minDate:r,maxDate:n})||a&&a.some(function(t){return Ye(e,t)})||o&&!o.some(function(t){return Ye(e,t)})||s&&!s(_e(e))||!1}function He(e,t,r,n){var a=M(e),o=S(e),s=M(t),i=S(t),p=M(n);return a===s&&a===p?o<=r&&r<=i:a<s?p===a&&o<=r||p===s&&i>=r||p<s&&p>a:void 0}function Qe(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&L(e,r)<0||n&&L(e,n)>0}function Ve(e,t){for(var r=t.length,n=0;n<r;n++)if(k(t[n])===k(e)&&g(t[n])===g(e))return!0;return!1}function Ae(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var a,o=_e(),s=N(E(o,g(e)),k(e)),i=N(E(o,g(r)),k(r)),p=N(E(o,g(n)),k(n));try{a=!ee(s,{start:i,end:p})}catch(e){a=!1}return a}function Ke(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,a=v(e,1);return r&&W(r,a)>0||n&&n.every(function(e){return W(e,a)>0})||!1}function Ue(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,a=l(e,1);return r&&W(a,r)>0||n&&n.every(function(e){return W(a,e)>0})||!1}function $e(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter(function(e){return L(e,t)>=0});return I(n)}return r?I(r):t}function ze(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter(function(e){return L(e,t)<=0});return q(n)}return r?q(r):t}function Ge(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,n=0,o=e.length;n<o;n++){var s=e[n];if(a(s)){var i=Se(s,"MM.dd.yyyy"),p=r.get(i)||[];p.includes(t)||(p.push(t),r.set(i,p))}else if("object"===se(s)){var c=Object.keys(s),d=c[0],l=s[c[0]];if("string"==typeof d&&l.constructor===Array)for(var u=0,h=l.length;u<h;u++){var f=Se(l[u],"MM.dd.yyyy"),m=r.get(f)||[];m.includes(d)||(m.push(d),r.set(f,m))}}}return r}function Je(e,t,r,n,a){for(var o=a.length,s=[],c=0;c<o;c++){var d=i(p(e,k(a[c])),g(a[c])),l=i(e,(r+1)*n);X(d,t)&&Z(d,l)&&s.push(a[c])}return s}function Xe(e){return e<10?"0".concat(e):"".concat(e)}function Ze(e,t,r,n){for(var a=[],o=0;o<2*t+1;o++){var s=e+t-o,i=!0;r&&(i=M(r)<=s),n&&i&&(i=M(n)>=s),i&&a.push(s)}return a}var et=ae(function(e){function r(e){var n;ie(this,r),de(ye(n=ve(this,fe(r).call(this,e))),"renderOptions",function(){var e=n.props.year,r=n.state.yearsList.map(function(r){return t.createElement("div",{className:e===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,ref:r,onClick:n.onChange.bind(ye(n),r)},e===r?t.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)}),a=n.props.minDate?M(n.props.minDate):null,o=n.props.maxDate?M(n.props.maxDate):null;return o&&n.state.yearsList.find(function(e){return e===o})||r.unshift(t.createElement("div",{className:"react-datepicker__year-option",ref:"upcoming",key:"upcoming",onClick:n.incrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),a&&n.state.yearsList.find(function(e){return e===a})||r.push(t.createElement("div",{className:"react-datepicker__year-option",ref:"previous",key:"previous",onClick:n.decrementYears},t.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r}),de(ye(n),"onChange",function(e){n.props.onChange(e)}),de(ye(n),"handleClickOutside",function(){n.props.onCancel()}),de(ye(n),"shiftYears",function(e){var t=n.state.yearsList.map(function(t){return t+e});n.setState({yearsList:t})}),de(ye(n),"incrementYears",function(){return n.shiftYears(1)}),de(ye(n),"decrementYears",function(){return n.shiftYears(-1)});var a=e.yearDropdownItemNumber,o=e.scrollableYearDropdown,s=a||(o?10:5);return n.state={yearsList:Ze(n.props.year,s,n.props.minDate,n.props.maxDate)},n}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e=n({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}()),tt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(n=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),de(ye(n),"renderSelectOptions",function(){for(var e=n.props.minDate?M(n.props.minDate):1900,r=n.props.maxDate?M(n.props.maxDate):2100,a=[],o=e;o<=r;o++)a.push(t.createElement("option",{key:o,value:o},o));return a}),de(ye(n),"onSelectChange",function(e){n.onChange(e.target.value)}),de(ye(n),"renderSelectMode",function(){return t.createElement("select",{value:n.props.year,className:"react-datepicker__year-select",onChange:n.onSelectChange},n.renderSelectOptions())}),de(ye(n),"renderReadView",function(e){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},n.props.year))}),de(ye(n),"renderDropdown",function(){return t.createElement(et,{key:"dropdown",ref:"options",year:n.props.year,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})}),de(ye(n),"renderScrollMode",function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t}),de(ye(n),"onChange",function(e){n.toggleDropdown(),e!==n.props.year&&n.props.onChange(e)}),de(ye(n),"toggleDropdown",function(e){n.setState({dropdownVisible:!n.state.dropdownVisible},function(){n.props.adjustDateOnChange&&n.handleYearChange(n.props.date,e)})}),de(ye(n),"handleYearChange",function(e,t){n.onSelect(e,t),n.setOpen()}),de(ye(n),"onSelect",function(e,t){n.props.onSelect&&n.props.onSelect(e,t)}),de(ye(n),"setOpen",function(){n.props.setOpen&&n.props.setOpen(!0)}),n}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(),rt=ae(function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(n=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"renderOptions",function(){return n.props.monthNames.map(function(e,r){return t.createElement("div",{className:n.props.month===r?"react-datepicker__month-option --selected_month":"react-datepicker__month-option",key:e,ref:e,onClick:n.onChange.bind(ye(n),r)},n.props.month===r?t.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",e)})}),de(ye(n),"onChange",function(e){return n.props.onChange(e)}),de(ye(n),"handleClickOutside",function(){return n.props.onCancel()}),n}return he(r,t.Component),ce(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),r}()),nt=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(n=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),de(ye(n),"renderSelectOptions",function(e){return e.map(function(e,r){return t.createElement("option",{key:r,value:r},e)})}),de(ye(n),"renderSelectMode",function(e){return t.createElement("select",{value:n.props.month,className:"react-datepicker__month-select",onChange:function(e){return n.onChange(e.target.value)}},n.renderSelectOptions(e))}),de(ye(n),"renderReadView",function(e,r){return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:n.toggleDropdown},t.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},r[n.props.month]))}),de(ye(n),"renderDropdown",function(e){return t.createElement(rt,{key:"dropdown",ref:"options",month:n.props.month,monthNames:e,onChange:n.onChange,onCancel:n.toggleDropdown})}),de(ye(n),"renderScrollMode",function(e){var t=n.state.dropdownVisible,r=[n.renderReadView(!t,e)];return t&&r.unshift(n.renderDropdown(e)),r}),de(ye(n),"onChange",function(e){n.toggleDropdown(),e!==n.props.month&&n.props.onChange(e)}),de(ye(n),"toggleDropdown",function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})}),n}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return We(e,r.props.locale)}:function(e){return t=e,n=r.props.locale,Se(Y(_e(),t),"LLLL",n);var t,n});switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode(n);break;case"select":e=this.renderSelectMode(n)}return t.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}();function at(e,t){for(var r=[],n=Pe(e),a=Pe(t);!X(n,a);)r.push(_e(n)),n=l(n,1);return r}var ot=ae(function(e){function r(e){var n;return ie(this,r),de(ye(n=ve(this,fe(r).call(this,e))),"renderOptions",function(){return n.state.monthYearsList.map(function(e){var r=O(e),a=Ee(n.props.date,e)&&Ne(n.props.date,e);return t.createElement("div",{className:a?"react-datepicker__month-year-option --selected_month-year":"react-datepicker__month-year-option",key:r,ref:r,onClick:n.onChange.bind(ye(n),r)},a?t.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Se(e,n.props.dateFormat))})}),de(ye(n),"onChange",function(e){return n.props.onChange(e)}),de(ye(n),"handleClickOutside",function(){n.props.onCancel()}),n.state={monthYearsList:at(n.props.minDate,n.props.maxDate)},n}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e=n({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return t.createElement("div",{className:e},this.renderOptions())}}]),r}()),st=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(n=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"state",{dropdownVisible:!1}),de(ye(n),"renderSelectOptions",function(){for(var e=Pe(n.props.minDate),r=Pe(n.props.maxDate),a=[];!X(e,r);){var o=O(e);a.push(t.createElement("option",{key:o,value:o},Se(e,n.props.dateFormat,n.props.locale))),e=l(e,1)}return a}),de(ye(n),"onSelectChange",function(e){n.onChange(e.target.value)}),de(ye(n),"renderSelectMode",function(){return t.createElement("select",{value:O(Pe(n.props.date)),className:"react-datepicker__month-year-select",onChange:n.onSelectChange},n.renderSelectOptions())}),de(ye(n),"renderReadView",function(e){var r=Se(n.props.date,n.props.dateFormat,n.props.locale);return t.createElement("div",{key:"read",style:{visibility:e?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return n.toggleDropdown(e)}},t.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),t.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},r))}),de(ye(n),"renderDropdown",function(){return t.createElement(ot,{key:"dropdown",ref:"options",date:n.props.date,dateFormat:n.props.dateFormat,onChange:n.onChange,onCancel:n.toggleDropdown,minDate:n.props.minDate,maxDate:n.props.maxDate,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})}),de(ye(n),"renderScrollMode",function(){var e=n.state.dropdownVisible,t=[n.renderReadView(!e)];return e&&t.unshift(n.renderDropdown()),t}),de(ye(n),"onChange",function(e){n.toggleDropdown();var t=_e(parseInt(e));Ee(n.props.date,t)&&Ne(n.props.date,t)||n.props.onChange(t)}),de(ye(n),"toggleDropdown",function(){return n.setState({dropdownVisible:!n.state.dropdownVisible})}),n}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e;switch(this.props.dropdownMode){case"scroll":e=this.renderScrollMode();break;case"select":e=this.renderSelectMode()}return t.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},e)}}]),r}(),it=function(e){function r(){var e,t;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(t=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"handleClick",function(e){!t.isDisabled()&&t.props.onClick&&t.props.onClick(e)}),de(ye(t),"handleMouseEnter",function(e){!t.isDisabled()&&t.props.onMouseEnter&&t.props.onMouseEnter(e)}),de(ye(t),"isSameDay",function(e){return Te(t.props.day,e)}),de(ye(t),"isKeyboardSelected",function(){return!t.props.disabledKeyboardNavigation&&!t.props.inline&&!t.isSameDay(t.props.selected)&&t.isSameDay(t.props.preSelection)}),de(ye(t),"isDisabled",function(){return Fe(t.props.day,t.props)}),de(ye(t),"isExcluded",function(){return function(e){var t=(arguments.length>1&&void 0!==arguments[1]?arguments[1]:{}).excludeDates;return t&&t.some(function(t){return Te(e,t)})||!1}(t.props.day,t.props)}),de(ye(t),"getHighLightedClass",function(e){var r=t.props,n=r.day,a=r.highlightDates;if(!a)return!1;var o=Se(n,"MM.dd.yyyy");return a.get(o)}),de(ye(t),"isInRange",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&Ie(r,n,a)}),de(ye(t),"isInSelectingRange",function(){var e=t.props,r=e.day,n=e.selectsStart,a=e.selectsEnd,o=e.selectingDate,s=e.startDate,i=e.endDate;return!(!n&&!a||!o||t.isDisabled())&&(n&&i&&(Z(o,i)||xe(o,i))?Ie(r,o,i):!(!a||!s||!X(o,s)&&!xe(o,s))&&Ie(r,s,o))}),de(ye(t),"isSelectingRangeStart",function(){if(!t.isInSelectingRange())return!1;var e=t.props,r=e.day,n=e.selectingDate,a=e.startDate;return Te(r,e.selectsStart?n:a)}),de(ye(t),"isSelectingRangeEnd",function(){if(!t.isInSelectingRange())return!1;var e=t.props,r=e.day,n=e.selectingDate,a=e.endDate;return Te(r,e.selectsEnd?n:a)}),de(ye(t),"isRangeStart",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&Te(n,r)}),de(ye(t),"isRangeEnd",function(){var e=t.props,r=e.day,n=e.startDate,a=e.endDate;return!(!n||!a)&&Te(a,r)}),de(ye(t),"isWeekend",function(){var e=_(t.props.day);return 0===e||6===e}),de(ye(t),"isOutsideMonth",function(){return void 0!==t.props.month&&t.props.month!==b(t.props.day)}),de(ye(t),"getClassNames",function(e){var r,a=t.props.dayClassName?t.props.dayClassName(e):void 0;return n("react-datepicker__day",a,"react-datepicker__day--"+Se(t.props.day,"ddd",r),{"react-datepicker__day--disabled":t.isDisabled(),"react-datepicker__day--excluded":t.isExcluded(),"react-datepicker__day--selected":t.isSameDay(t.props.selected),"react-datepicker__day--keyboard-selected":t.isKeyboardSelected(),"react-datepicker__day--range-start":t.isRangeStart(),"react-datepicker__day--range-end":t.isRangeEnd(),"react-datepicker__day--in-range":t.isInRange(),"react-datepicker__day--in-selecting-range":t.isInSelectingRange(),"react-datepicker__day--selecting-range-start":t.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":t.isSelectingRangeEnd(),"react-datepicker__day--today":t.isSameDay(_e()),"react-datepicker__day--weekend":t.isWeekend(),"react-datepicker__day--outside-month":t.isOutsideMonth()},t.getHighLightedClass("react-datepicker__day--highlighted"))}),t}return he(r,t.Component),ce(r,[{key:"render",value:function(){return t.createElement("div",{className:this.getClassNames(this.props.day),onClick:this.handleClick,onMouseEnter:this.handleMouseEnter,"aria-label":"day-".concat(C(this.props.day)),role:"option","aria-disabled":this.isDisabled()},this.props.renderDayContents?this.props.renderDayContents(C(this.props.day),this.props.day):C(this.props.day))}}]),r}(),pt=function(e){function r(){var e,t;ie(this,r);for(var n=arguments.length,a=new Array(n),o=0;o<n;o++)a[o]=arguments[o];return de(ye(t=ve(this,(e=fe(r)).call.apply(e,[this].concat(a)))),"handleClick",function(e){t.props.onClick&&t.props.onClick(e)}),t}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!this.props.onClick};return t.createElement("div",{className:n(e),"aria-label":"week-".concat(this.props.weekNumber),onClick:this.handleClick},this.props.weekNumber)}}]),r}(),ct=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(n=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"handleDayClick",function(e,t){n.props.onDayClick&&n.props.onDayClick(e,t)}),de(ye(n),"handleDayMouseEnter",function(e){n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)}),de(ye(n),"handleWeekClick",function(e,t,r){"function"==typeof n.props.onWeekSelect&&n.props.onWeekSelect(e,t,r),n.props.shouldCloseOnSelect&&n.props.setOpen(!1)}),de(ye(n),"formatWeekNumber",function(e){return n.props.formatWeekNumber?n.props.formatWeekNumber(e):function(e){return Ee(A(e),e)?F(e,Q(e))+1:1}(e)}),de(ye(n),"renderDays",function(){var e=Oe(n.props.day,n.props.locale),r=[],a=n.formatWeekNumber(e);if(n.props.showWeekNumber){var o=n.props.onWeekSelect?n.handleWeekClick.bind(ye(n),e,a):void 0;r.push(t.createElement(pt,{key:"W",weekNumber:a,onClick:o}))}return r.concat([0,1,2,3,4,5,6].map(function(r){var a=c(e,r);return t.createElement(it,{key:r,day:a,month:n.props.month,onClick:n.handleDayClick.bind(ye(n),a),onMouseEnter:n.handleDayMouseEnter.bind(ye(n),a),minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,includeDates:n.props.includeDates,inline:n.props.inline,highlightDates:n.props.highlightDates,selectingDate:n.props.selectingDate,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,startDate:n.props.startDate,endDate:n.props.endDate,dayClassName:n.props.dayClassName,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation})}))}),n}return he(r,t.Component),ce(r,[{key:"render",value:function(){return t.createElement("div",{className:"react-datepicker__week"},this.renderDays())}}],[{key:"defaultProps",get:function(){return{shouldCloseOnSelect:!0}}}]),r}(),dt=6,lt=function(e){function r(){var e,a;ie(this,r);for(var o=arguments.length,s=new Array(o),i=0;i<o;i++)s[i]=arguments[i];return de(ye(a=ve(this,(e=fe(r)).call.apply(e,[this].concat(s)))),"handleDayClick",function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t,a.props.orderInDisplay)}),de(ye(a),"handleDayMouseEnter",function(e){a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e)}),de(ye(a),"handleMouseLeave",function(){a.props.onMouseLeave&&a.props.onMouseLeave()}),de(ye(a),"isRangeStartMonth",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ne(Y(r,e),n)}),de(ye(a),"isRangeStartQuarter",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ye(T(r,e),n)}),de(ye(a),"isRangeEndMonth",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ne(Y(r,e),o)}),de(ye(a),"isRangeEndQuarter",function(e){var t=a.props,r=t.day,n=t.startDate,o=t.endDate;return!(!n||!o)&&Ye(T(r,e),o)}),de(ye(a),"isWeekInMonth",function(e){var t=a.props.day,r=c(e,6);return Ne(e,t)||Ne(r,t)}),de(ye(a),"renderWeeks",function(){for(var e=[],r=a.props.fixedHeight,n=Oe(Pe(a.props.day),a.props.locale),o=0,s=!1;e.push(t.createElement(ct,{key:o,day:n,month:b(a.props.day),onDayClick:a.handleDayClick,onDayMouseEnter:a.handleDayMouseEnter,onWeekSelect:a.props.onWeekSelect,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,includeDates:a.props.includeDates,inline:a.props.inline,highlightDates:a.props.highlightDates,selectingDate:a.props.selectingDate,filterDate:a.props.filterDate,preSelection:a.props.preSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,showWeekNumber:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,dayClassName:a.props.dayClassName,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,renderDayContents:a.props.renderDayContents})),!s;){o++,n=d(n,1);var i=r&&o>=dt,p=!r&&!a.isWeekInMonth(n);if(i||p){if(!a.props.peekNextMonth)break;s=!0}}return e}),de(ye(a),"onMonthClick",function(e,t){a.handleDayClick(Pe(Y(a.props.day,t)),e)}),de(ye(a),"onQuarterClick",function(e,t){var r;a.handleDayClick((r=T(a.props.day,t),H(r)),e)}),de(ye(a),"getMonthClassNames",function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,i=t.selected,p=t.minDate,c=t.maxDate;return n("react-datepicker__month-text","react-datepicker__month-".concat(e),{"react-datepicker__month--disabled":(p||c)&&Be(Y(r,e),a.props),"react-datepicker__month--selected":b(r)===e&&M(r)===M(i),"react-datepicker__month--in-range":Re(o,s,e,r),"react-datepicker__month--range-start":a.isRangeStartMonth(e),"react-datepicker__month--range-end":a.isRangeEndMonth(e)})}),de(ye(a),"getQuarterClassNames",function(e){var t=a.props,r=t.day,o=t.startDate,s=t.endDate,i=t.selected,p=t.minDate,c=t.maxDate;return n("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter--disabled":(p||c)&&je(T(r,e),a.props),"react-datepicker__quarter--selected":S(r)===e&&M(r)===M(i),"react-datepicker__quarter--in-range":He(o,s,e,r),"react-datepicker__quarter--range-start":a.isRangeStartQuarter(e),"react-datepicker__quarter--range-end":a.isRangeEndQuarter(e)})}),de(ye(a),"renderMonths",function(){return[[0,1,2],[3,4,5],[6,7,8],[9,10,11]].map(function(e,r){return t.createElement("div",{className:"react-datepicker__month-wrapper",key:r},e.map(function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onMonthClick(t,e)},className:a.getMonthClassNames(e)},We(e,a.props.locale))}))})}),de(ye(a),"renderQuarters",function(){return t.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map(function(e,r){return t.createElement("div",{key:r,onClick:function(t){a.onQuarterClick(t,e)},className:a.getQuarterClassNames(e)},(n=e,o=a.props.locale,Se(T(_e(),n),"QQQ",o)));var n,o}))}),de(ye(a),"getClassNames",function(){var e=a.props,t=e.selectingDate,r=e.selectsStart,o=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker;return n("react-datepicker__month",{"react-datepicker__month--selecting-range":t&&(r||o)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i})}),a}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e=this.props,r=e.showMonthYearPicker,n=e.showQuarterYearPicker;return t.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,role:"listbox","aria-label":"month-"+Se(this.props.day,"yyyy-MM")},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),r}(),ut=function(e){function r(){var e,n;ie(this,r);for(var a=arguments.length,o=new Array(a),s=0;s<a;s++)o[s]=arguments[s];return de(ye(n=ve(this,(e=fe(r)).call.apply(e,[this].concat(o)))),"state",{height:null}),de(ye(n),"handleClick",function(e){(n.props.minTime||n.props.maxTime)&&Ae(e,n.props)||n.props.excludeTimes&&Ve(e,n.props.excludeTimes)||n.props.includeTimes&&!Ve(e,n.props.includeTimes)||n.props.onChange(e)}),de(ye(n),"liClasses",function(e,t,r){var a=["react-datepicker__time-list-item"];return t===k(e)&&r===g(e)&&a.push("react-datepicker__time-list-item--selected"),((n.props.minTime||n.props.maxTime)&&Ae(e,n.props)||n.props.excludeTimes&&Ve(e,n.props.excludeTimes)||n.props.includeTimes&&!Ve(e,n.props.includeTimes))&&a.push("react-datepicker__time-list-item--disabled"),n.props.injectTimes&&(60*k(e)+g(e))%n.props.intervals!=0&&a.push("react-datepicker__time-list-item--injected"),a.join(" ")}),de(ye(n),"renderTimes",function(){for(var e,r=[],a=n.props.format?n.props.format:"p",o=n.props.intervals,s=n.props.selected?n.props.selected:_e(),p=k(s),c=g(s),d=(e=_e(),B(e)),l=1440/o,u=n.props.injectTimes&&n.props.injectTimes.sort(function(e,t){return e-t}),h=0;h<l;h++){var f=i(d,h*o);if(r.push(f),u){var m=Je(d,f,h,o,u);r=r.concat(m)}}return r.map(function(e,r){return t.createElement("li",{key:r,onClick:n.handleClick.bind(ye(n),e),className:n.liClasses(e,p,c),ref:function(t){(p===k(e)&&c===g(e)||p===k(e)&&!n.centerLi)&&(n.centerLi=t)}},Se(e,a,n.props.locale))})}),n}return he(r,t.Component),ce(r,[{key:"componentDidMount",value:function(){this.list.scrollTop=r.calcCenterPosition(this.props.monthRef?this.props.monthRef.clientHeight-this.header.clientHeight:this.list.clientHeight,this.centerLi),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight})}},{key:"render",value:function(){var e=this,r=this.state.height;return t.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},t.createElement("div",{className:"react-datepicker__header react-datepicker__header--time",ref:function(t){e.header=t}},t.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),t.createElement("div",{className:"react-datepicker__time"},t.createElement("div",{className:"react-datepicker__time-box"},t.createElement("ul",{className:"react-datepicker__time-list",ref:function(t){e.list=t},style:r?{height:r}:{}},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return{intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),r}();de(ut,"calcCenterPosition",function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)});var ht=function(e){function r(e){var t;return ie(this,r),de(ye(t=ve(this,fe(r).call(this,e))),"onTimeChange",function(e){t.setState({time:e});var r=new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),t.props.onChange(r)}),t.state={time:t.props.timeString},t}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e=this,r=this.state.time,n=this.props.timeString;return t.createElement("div",{className:"react-datepicker__input-time-container"},t.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),t.createElement("div",{className:"react-datepicker-time__input-container"},t.createElement("div",{className:"react-datepicker-time__input"},t.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:r,onChange:function(t){e.onTimeChange(t.target.value||n)}}))))}}]),r}();function ft(e){var r=e.className,n=e.children,a=e.arrowProps,o=void 0===a?{}:a;return t.createElement("div",{className:r},t.createElement("div",le({className:"react-datepicker__triangle"},o)),n)}var mt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],yt=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=(e.className||"").split(/\s+/);return mt.some(function(e){return t.indexOf(e)>=0})},vt=function(e){function r(e){var n;return ie(this,r),de(ye(n=ve(this,fe(r).call(this,e))),"handleClickOutside",function(e){n.props.onClickOutside(e)}),de(ye(n),"setClickOutsideRef",function(){return n.containerRef.current}),de(ye(n),"handleDropdownFocus",function(e){yt(e.target)&&n.props.onDropdownFocus()}),de(ye(n),"getDateInView",function(){var e=n.props,t=e.preSelection,r=e.selected,a=e.openToDate,o=$e(n.props),s=ze(n.props),i=_e(),p=a||r||t;return p||(o&&Z(i,o)?o:s&&X(i,s)?s:i)}),de(ye(n),"increaseMonth",function(){n.setState(function(e){var t=e.date;return{date:l(t,1)}},function(){return n.handleMonthChange(n.state.date)})}),de(ye(n),"decreaseMonth",function(){n.setState(function(e){var t=e.date;return{date:v(t,1)}},function(){return n.handleMonthChange(n.state.date)})}),de(ye(n),"handleDayClick",function(e,t,r){return n.props.onSelect(e,t,r)}),de(ye(n),"handleDayMouseEnter",function(e){n.setState({selectingDate:e}),n.props.onDayMouseEnter&&n.props.onDayMouseEnter(e)}),de(ye(n),"handleMonthMouseLeave",function(){n.setState({selectingDate:null}),n.props.onMonthMouseLeave&&n.props.onMonthMouseLeave()}),de(ye(n),"handleYearChange",function(e){n.props.onYearChange&&n.props.onYearChange(e)}),de(ye(n),"handleMonthChange",function(e){n.props.onMonthChange&&n.props.onMonthChange(e),n.props.adjustDateOnChange&&(n.props.onSelect&&n.props.onSelect(e),n.props.setOpen&&n.props.setOpen(!0))}),de(ye(n),"handleMonthYearChange",function(e){n.handleYearChange(e),n.handleMonthChange(e)}),de(ye(n),"changeYear",function(e){n.setState(function(t){var r=t.date;return{date:x(r,e)}},function(){return n.handleYearChange(n.state.date)})}),de(ye(n),"changeMonth",function(e){n.setState(function(t){var r=t.date;return{date:Y(r,e)}},function(){return n.handleMonthChange(n.state.date)})}),de(ye(n),"changeMonthYear",function(e){n.setState(function(t){var r=t.date;return{date:x(Y(r,b(e)),M(e))}},function(){return n.handleMonthYearChange(n.state.date)})}),de(ye(n),"header",function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=Oe(e,n.props.locale),a=[];return n.props.showWeekNumbers&&a.push(t.createElement("div",{key:"W",className:"react-datepicker__day-name"},n.props.weekLabel||"#")),a.concat([0,1,2,3,4,5,6].map(function(e){var a=c(r,e),o=n.formatWeekday(a,n.props.locale);return t.createElement("div",{key:e,className:"react-datepicker__day-name"},o)}))}),de(ye(n),"formatWeekday",function(e,t){return n.props.formatWeekDay?function(e,t,r){return t(Se(e,"EEEE",r))}(e,n.props.formatWeekDay,t):n.props.useWeekdaysShort?function(e,t){return Se(e,"EEE",t)}(e,t):function(e,t){return Se(e,"EEEEEE",t)}(e,t)}),de(ye(n),"decreaseYear",function(){n.setState(function(e){var t=e.date;return{date:D(t,1)}},function(){return n.handleYearChange(n.state.date)})}),de(ye(n),"renderPreviousButton",function(){if(!n.props.renderCustomHeader){var e=Ke(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],a=n.decreaseMonth;return(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.decreaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),a=null),t.createElement("button",{type:"button",className:r.join(" "),onClick:a},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.props.previousYearButtonLabel:n.props.previousMonthButtonLabel)}}}),de(ye(n),"increaseYear",function(){n.setState(function(e){var t=e.date;return{date:u(t,1)}},function(){return n.handleYearChange(n.state.date)})}),de(ye(n),"renderNextButton",function(){if(!n.props.renderCustomHeader){var e=Ue(n.state.date,n.props);if((n.props.forceShowMonthNavigation||n.props.showDisabledMonthNavigation||!e)&&!n.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];n.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),n.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var a=n.increaseMonth;return(n.props.showMonthYearPicker||n.props.showQuarterYearPicker)&&(a=n.increaseYear),e&&n.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),a=null),t.createElement("button",{type:"button",className:r.join(" "),onClick:a},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.props.nextYearButtonLabel:n.props.nextMonthButtonLabel)}}}),de(ye(n),"renderCurrentMonth",function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:n.state.date,r=["react-datepicker__current-month"];return n.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),n.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),n.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),t.createElement("div",{className:r.join(" ")},Se(e,n.props.dateFormat,n.props.locale))}),de(ye(n),"renderYearDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showYearDropdown&&!e)return t.createElement(tt,{adjustDateOnChange:n.props.adjustDateOnChange,date:n.state.date,onSelect:n.props.onSelect,setOpen:n.props.setOpen,dropdownMode:n.props.dropdownMode,onChange:n.changeYear,minDate:n.props.minDate,maxDate:n.props.maxDate,year:M(n.state.date),scrollableYearDropdown:n.props.scrollableYearDropdown,yearDropdownItemNumber:n.props.yearDropdownItemNumber})}),de(ye(n),"renderMonthDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthDropdown&&!e)return t.createElement(nt,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,onChange:n.changeMonth,month:b(n.state.date),useShortMonthInDropdown:n.props.useShortMonthInDropdown})}),de(ye(n),"renderMonthYearDropdown",function(){var e=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(n.props.showMonthYearDropdown&&!e)return t.createElement(st,{dropdownMode:n.props.dropdownMode,locale:n.props.locale,dateFormat:n.props.dateFormat,onChange:n.changeMonthYear,minDate:n.props.minDate,maxDate:n.props.maxDate,date:n.state.date,scrollableMonthYearDropdown:n.props.scrollableMonthYearDropdown})}),de(ye(n),"renderTodayButton",function(){if(n.props.todayButton&&!n.props.showTimeSelectOnly)return t.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return n.props.onSelect(B(_e()),e)}},n.props.todayButton)}),de(ye(n),"renderDefaultHeader",function(e){var r=e.monthDate,a=e.i;return t.createElement("div",{className:"react-datepicker__header"},n.renderCurrentMonth(r),t.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(n.props.dropdownMode),onFocus:n.handleDropdownFocus},n.renderMonthDropdown(0!==a),n.renderMonthYearDropdown(0!==a),n.renderYearDropdown(0!==a)),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))}),de(ye(n),"renderCustomHeader",function(e){var r=e.monthDate;if(0!==e.i)return null;var a=Ke(n.state.date,n.props),o=Ue(n.state.date,n.props);return t.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:n.props.onDropdownFocus},n.props.renderCustomHeader(function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?ue(r,!0).forEach(function(t){de(e,t,r[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):ue(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))})}return e}({},n.state,{changeMonth:n.changeMonth,changeYear:n.changeYear,decreaseMonth:n.decreaseMonth,increaseMonth:n.increaseMonth,prevMonthButtonDisabled:a,nextMonthButtonDisabled:o})),t.createElement("div",{className:"react-datepicker__day-names"},n.header(r)))}),de(ye(n),"renderYearHeader",function(){return t.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},M(n.state.date))}),de(ye(n),"renderMonths",function(){if(!n.props.showTimeSelectOnly){for(var e=[],r=0;r<n.props.monthsShown;++r){var a=r-n.props.monthSelectedIn,o=l(n.state.date,a),s="month-".concat(r);e.push(t.createElement("div",{key:s,ref:function(e){n.monthContainer=e},className:"react-datepicker__month-container"},n.props.showMonthYearPicker||n.props.showQuarterYearPicker?n.renderYearHeader({monthDate:o,i:r}):n.props.renderCustomHeader?n.renderCustomHeader({monthDate:o,i:r}):n.renderDefaultHeader({monthDate:o,i:r}),t.createElement(lt,{onChange:n.changeMonthYear,day:o,dayClassName:n.props.dayClassName,onDayClick:n.handleDayClick,onDayMouseEnter:n.handleDayMouseEnter,onMouseLeave:n.handleMonthMouseLeave,onWeekSelect:n.props.onWeekSelect,orderInDisplay:r,formatWeekNumber:n.props.formatWeekNumber,locale:n.props.locale,minDate:n.props.minDate,maxDate:n.props.maxDate,excludeDates:n.props.excludeDates,highlightDates:n.props.highlightDates,selectingDate:n.state.selectingDate,includeDates:n.props.includeDates,inline:n.props.inline,fixedHeight:n.props.fixedHeight,filterDate:n.props.filterDate,preSelection:n.props.preSelection,selected:n.props.selected,selectsStart:n.props.selectsStart,selectsEnd:n.props.selectsEnd,showWeekNumbers:n.props.showWeekNumbers,startDate:n.props.startDate,endDate:n.props.endDate,peekNextMonth:n.props.peekNextMonth,setOpen:n.props.setOpen,shouldCloseOnSelect:n.props.shouldCloseOnSelect,renderDayContents:n.props.renderDayContents,disabledKeyboardNavigation:n.props.disabledKeyboardNavigation,showMonthYearPicker:n.props.showMonthYearPicker,showQuarterYearPicker:n.props.showQuarterYearPicker})))}return e}}),de(ye(n),"renderTimeSection",function(){if(n.props.showTimeSelect&&(n.state.monthContainer||n.props.showTimeSelectOnly))return t.createElement(ut,{selected:n.props.selected,onChange:n.props.onTimeChange,format:n.props.timeFormat,includeTimes:n.props.includeTimes,intervals:n.props.timeIntervals,minTime:n.props.minTime,maxTime:n.props.maxTime,excludeTimes:n.props.excludeTimes,timeCaption:n.props.timeCaption,todayButton:n.props.todayButton,showMonthDropdown:n.props.showMonthDropdown,showMonthYearDropdown:n.props.showMonthYearDropdown,showYearDropdown:n.props.showYearDropdown,withPortal:n.props.withPortal,monthRef:n.state.monthContainer,injectTimes:n.props.injectTimes,locale:n.props.locale})}),de(ye(n),"renderInputTimeSection",function(){var e=new Date(n.props.selected),r="".concat(Xe(e.getHours()),":").concat(Xe(e.getMinutes()));if(n.props.showTimeInput)return t.createElement(ht,{timeString:r,timeInputLabel:n.props.timeInputLabel,onChange:n.props.onTimeChange})}),n.containerRef=t.createRef(),n.state={date:n.getDateInView(),selectingDate:null,monthContainer:null},n}return he(r,t.Component),ce(r,null,[{key:"defaultProps",get:function(){return{onDropdownFocus:function(){},monthsShown:1,monthSelectedIn:0,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month"}}}]),ce(r,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}))}},{key:"componentDidUpdate",value:function(e){this.props.preSelection&&!Te(this.props.preSelection,e.preSelection)?this.setState({date:this.props.preSelection}):this.props.openToDate&&!Te(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate})}},{key:"render",value:function(){var e=this.props.container||ft;return t.createElement("div",{ref:this.containerRef},t.createElement(e,{className:n("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly})},this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.props.children))}}]),r}(),Dt=function(e){function r(){return ie(this,r),ve(this,fe(r).apply(this,arguments))}return he(r,t.Component),ce(r,[{key:"render",value:function(){var e,r=this.props,a=r.className,o=r.wrapperClassName,s=r.hidePopper,i=r.popperComponent,p=r.popperModifiers,c=r.popperPlacement,d=r.popperProps,l=r.targetComponent;if(!s){var u=n("react-datepicker-popper",a);e=t.createElement(oe.Popper,le({modifiers:p,placement:c},d),function(e){var r=e.ref,n=e.style,a=e.placement,o=e.arrowProps;return t.createElement("div",le({ref:r,style:n},{className:u,"data-placement":a}),t.cloneElement(i,{arrowProps:o}))})}this.props.popperContainer&&(e=t.createElement(this.props.popperContainer,{},e));var h=n("react-datepicker-wrapper",o);return t.createElement(oe.Manager,null,t.createElement(oe.Reference,null,function(e){var r=e.ref;return t.createElement("div",{ref:r,className:h},l)}),e)}}],[{key:"defaultProps",get:function(){return{hidePopper:!0,popperModifiers:{preventOverflow:{enabled:!0,escapeWithReference:!0,boundariesElement:"viewport"}},popperProps:{},popperPlacement:"bottom-start"}}}]),r}(),wt="react-datepicker-ignore-onclickoutside",gt=ae(vt);var kt="Date input not valid.",_t=function(e){function r(e){var o;return ie(this,r),de(ye(o=ve(this,fe(r).call(this,e))),"getPreSelection",function(){return o.props.openToDate?o.props.openToDate:o.props.selectsEnd&&o.props.startDate?o.props.startDate:o.props.selectsStart&&o.props.endDate?o.props.endDate:_e()}),de(ye(o),"calcInitialState",function(){var e=o.getPreSelection(),t=$e(o.props),r=ze(o.props),n=t&&Z(e,t)?t:r&&X(e,r)?r:e;return{open:o.props.startOpen||!1,preventFocus:!1,preSelection:o.props.selected?o.props.selected:n,highlightDates:Ge(o.props.highlightDates),focused:!1}}),de(ye(o),"clearPreventFocusTimeout",function(){o.preventFocusTimeout&&clearTimeout(o.preventFocusTimeout)}),de(ye(o),"setFocus",function(){o.input&&o.input.focus&&o.input.focus()}),de(ye(o),"setBlur",function(){o.input&&o.input.blur&&o.input.blur(),o.cancelFocusInput()}),de(ye(o),"setOpen",function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];o.setState({open:e,preSelection:e&&o.state.open?o.state.preSelection:o.calcInitialState().preSelection,lastPreSelectChange:bt},function(){e||o.setState(function(e){return{focused:!!t&&e.focused}},function(){!t&&o.setBlur(),o.setState({inputValue:null})})})}),de(ye(o),"inputOk",function(){return a(o.state.preSelection)}),de(ye(o),"isCalendarOpen",function(){return void 0===o.props.open?o.state.open&&!o.props.disabled&&!o.props.readOnly:o.props.open}),de(ye(o),"handleFocus",function(e){o.state.preventFocus||(o.props.onFocus(e),o.props.preventOpenOnFocus||o.props.readOnly||o.setOpen(!0)),o.setState({focused:!0})}),de(ye(o),"cancelFocusInput",function(){clearTimeout(o.inputFocusTimeout),o.inputFocusTimeout=null}),de(ye(o),"deferFocusInput",function(){o.cancelFocusInput(),o.inputFocusTimeout=setTimeout(function(){return o.setFocus()},1)}),de(ye(o),"handleDropdownFocus",function(){o.cancelFocusInput()}),de(ye(o),"handleBlur",function(e){!o.state.open||o.props.withPortal||o.props.showTimeInput?o.props.onBlur(e):o.deferFocusInput(),o.setState({focused:!1})}),de(ye(o),"handleCalendarClickOutside",function(e){o.props.inline||o.setOpen(!1),o.props.onClickOutside(e),o.props.withPortal&&e.preventDefault()}),de(ye(o),"handleChange",function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!o.props.onChangeRaw||(o.props.onChangeRaw.apply(ye(o),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){o.setState({inputValue:n.target.value,lastPreSelectChange:Ct});var a=Ce(n.target.value,o.props.dateFormat,o.props.locale,o.props.strictParsing);!a&&n.target.value||o.setSelected(a,n,!0)}}),de(ye(o),"handleSelect",function(e,t,r){o.setState({preventFocus:!0},function(){return o.preventFocusTimeout=setTimeout(function(){return o.setState({preventFocus:!1})},50),o.preventFocusTimeout}),o.setSelected(e,t,void 0,r),!o.props.shouldCloseOnSelect||o.props.showTimeSelect?o.setPreSelection(e):o.props.inline||o.setOpen(!1)}),de(ye(o),"setSelected",function(e,t,r,n){var a=e;if(null===a||!Fe(a,o.props)){if(!xe(o.props.selected,a)||o.props.allowSameDay){if(null!==a){if(o.props.selected){var s=o.props.selected;r&&(s=_e(a)),a=Me(a,{hour:k(s),minute:g(s),second:w(s)})}o.props.inline||o.setState({preSelection:a}),o.props.inline&&o.props.monthsShown>1&&!o.props.inlineFocusSelectedMonth&&o.setState({monthSelectedIn:n})}o.props.onChange(a,t)}o.props.onSelect(a,t),r||o.setState({inputValue:null})}}),de(ye(o),"setPreSelection",function(e){var t=void 0!==o.props.minDate,r=void 0!==o.props.maxDate,n=!0;e&&(t&&r?n=Ie(e,o.props.minDate,o.props.maxDate):t?n=X(e,o.props.minDate):r&&(n=Z(e,o.props.maxDate))),n&&o.setState({preSelection:e})}),de(ye(o),"handleTimeChange",function(e){var t=Me(o.props.selected?o.props.selected:o.getPreSelection(),{hour:k(e),minute:g(e)});o.setState({preSelection:t}),o.props.onChange(t),o.props.shouldCloseOnSelect&&o.setOpen(!1),o.props.showTimeInput&&o.setOpen(!0),o.setState({inputValue:null})}),de(ye(o),"onInputClick",function(){o.props.disabled||o.props.readOnly||o.setOpen(!0),o.props.onInputClick()}),de(ye(o),"onInputKeyDown",function(e){o.props.onKeyDown(e);var t=e.key;if(o.state.open||o.props.inline||o.props.preventOpenOnFocus){var r=_e(o.state.preSelection);if("Enter"===t)e.preventDefault(),o.inputOk()&&o.state.lastPreSelectChange===bt?(o.handleSelect(r,e),!o.props.shouldCloseOnSelect&&o.setPreSelection(r)):o.setOpen(!1);else if("Escape"===t)e.preventDefault(),o.setOpen(!1),o.inputOk()||o.props.onInputError({code:1,msg:kt});else if("Tab"===t)o.setOpen(!1,!0);else if(!o.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=m(r,1);break;case"ArrowRight":n=c(r,1);break;case"ArrowUp":n=y(r,1);break;case"ArrowDown":n=d(r,1);break;case"PageUp":n=v(r,1);break;case"PageDown":n=l(r,1);break;case"Home":n=D(r,1);break;case"End":n=u(r,1)}if(!n)return void(o.props.onInputError&&o.props.onInputError({code:1,msg:kt}));e.preventDefault(),o.setState({lastPreSelectChange:bt}),o.props.adjustDateOnChange&&o.setSelected(n),o.setPreSelection(n)}}else"ArrowDown"!==t&&"ArrowUp"!==t||o.onInputClick()}),de(ye(o),"onClearClick",function(e){e&&e.preventDefault&&e.preventDefault(),o.props.onChange(null,e),o.setState({inputValue:null})}),de(ye(o),"clear",function(){o.onClearClick()}),de(ye(o),"renderCalendar",function(){return o.props.inline||o.isCalendarOpen()?t.createElement(gt,{ref:function(e){o.calendar=e},locale:o.props.locale,adjustDateOnChange:o.props.adjustDateOnChange,setOpen:o.setOpen,shouldCloseOnSelect:o.props.shouldCloseOnSelect,dateFormat:o.props.dateFormatCalendar,useWeekdaysShort:o.props.useWeekdaysShort,formatWeekDay:o.props.formatWeekDay,dropdownMode:o.props.dropdownMode,selected:o.props.selected,preSelection:o.state.preSelection,onSelect:o.handleSelect,onWeekSelect:o.props.onWeekSelect,openToDate:o.props.openToDate,minDate:o.props.minDate,maxDate:o.props.maxDate,selectsStart:o.props.selectsStart,selectsEnd:o.props.selectsEnd,startDate:o.props.startDate,endDate:o.props.endDate,excludeDates:o.props.excludeDates,filterDate:o.props.filterDate,onClickOutside:o.handleCalendarClickOutside,formatWeekNumber:o.props.formatWeekNumber,highlightDates:o.state.highlightDates,includeDates:o.props.includeDates,includeTimes:o.props.includeTimes,injectTimes:o.props.injectTimes,inline:o.props.inline,peekNextMonth:o.props.peekNextMonth,showMonthDropdown:o.props.showMonthDropdown,useShortMonthInDropdown:o.props.useShortMonthInDropdown,showMonthYearDropdown:o.props.showMonthYearDropdown,showWeekNumbers:o.props.showWeekNumbers,showYearDropdown:o.props.showYearDropdown,withPortal:o.props.withPortal,forceShowMonthNavigation:o.props.forceShowMonthNavigation,showDisabledMonthNavigation:o.props.showDisabledMonthNavigation,scrollableYearDropdown:o.props.scrollableYearDropdown,scrollableMonthYearDropdown:o.props.scrollableMonthYearDropdown,todayButton:o.props.todayButton,weekLabel:o.props.weekLabel,outsideClickIgnoreClass:wt,fixedHeight:o.props.fixedHeight,monthsShown:o.props.monthsShown,monthSelectedIn:o.state.monthSelectedIn,onDropdownFocus:o.handleDropdownFocus,onMonthChange:o.props.onMonthChange,onYearChange:o.props.onYearChange,dayClassName:o.props.dayClassName,showTimeSelect:o.props.showTimeSelect,showTimeSelectOnly:o.props.showTimeSelectOnly,onTimeChange:o.handleTimeChange,timeFormat:o.props.timeFormat,timeIntervals:o.props.timeIntervals,minTime:o.props.minTime,maxTime:o.props.maxTime,excludeTimes:o.props.excludeTimes,timeCaption:o.props.timeCaption,className:o.props.calendarClassName,container:o.props.calendarContainer,yearDropdownItemNumber:o.props.yearDropdownItemNumber,previousMonthButtonLabel:o.props.previousMonthButtonLabel,nextMonthButtonLabel:o.props.nextMonthButtonLabel,previousYearButtonLabel:o.props.previousYearButtonLabel,nextYearButtonLabel:o.props.nextYearButtonLabel,timeInputLabel:o.props.timeInputLabel,disabledKeyboardNavigation:o.props.disabledKeyboardNavigation,renderCustomHeader:o.props.renderCustomHeader,popperProps:o.props.popperProps,renderDayContents:o.props.renderDayContents,onDayMouseEnter:o.props.onDayMouseEnter,onMonthMouseLeave:o.props.onMonthMouseLeave,showTimeInput:o.props.showTimeInput,showMonthYearPicker:o.props.showMonthYearPicker,showQuarterYearPicker:o.props.showQuarterYearPicker},o.props.children):null}),de(ye(o),"renderDateInput",function(){var e,r,a,s,i,p=n(o.props.className,de({},wt,o.state.open)),c=o.props.customInput||t.createElement("input",{type:"text"}),d=o.props.customInputRef||"ref",l="string"==typeof o.props.value?o.props.value:"string"==typeof o.state.inputValue?o.state.inputValue:(r=o.props.selected,a=o.props,s=a.dateFormat,i=a.locale,r&&Se(r,Array.isArray(s)?s[0]:s,i)||"");return t.cloneElement(c,(de(e={},d,function(e){o.input=e}),de(e,"value",l),de(e,"onBlur",o.handleBlur),de(e,"onChange",o.handleChange),de(e,"onClick",o.onInputClick),de(e,"onFocus",o.handleFocus),de(e,"onKeyDown",o.onInputKeyDown),de(e,"id",o.props.id),de(e,"name",o.props.name),de(e,"autoFocus",o.props.autoFocus),de(e,"placeholder",o.props.placeholderText),de(e,"disabled",o.props.disabled),de(e,"autoComplete",o.props.autoComplete),de(e,"className",n(c.props.className,p)),de(e,"title",o.props.title),de(e,"readOnly",o.props.readOnly),de(e,"required",o.props.required),de(e,"tabIndex",o.props.tabIndex),e))}),de(ye(o),"renderClearButton",function(){return o.props.isClearable&&null!=o.props.selected?t.createElement("button",{type:"button",className:"react-datepicker__close-icon","aria-label":"Close",onClick:o.onClearClick,title:o.props.clearButtonTitle,tabIndex:-1}):null}),o.state=o.calcInitialState(),o}return he(r,t.Component),ce(r,null,[{key:"defaultProps",get:function(){return{allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showMonthYearPicker:!1,showQuarterYearPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",renderDayContents:function(e){return e},inlineFocusSelectedMonth:!1}}}]),ce(r,[{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?b(r)!==b(n)||M(r)!==M(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:Ge(this.props.highlightDates)}),t.focused||xe(e.selected,this.props.selected)||this.setState({inputValue:null})}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout()}},{key:"render",value:function(){var e=this.renderCalendar();return this.props.inline&&!this.props.withPortal?e:this.props.withPortal?t.createElement("div",null,this.props.inline?null:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),this.state.open||this.props.inline?t.createElement("div",{className:"react-datepicker__portal"},e):null):t.createElement(Dt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),popperModifiers:this.props.popperModifiers,targetComponent:t.createElement("div",{className:"react-datepicker__input-container"},this.renderDateInput(),this.renderClearButton()),popperContainer:this.props.popperContainer,popperComponent:e,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps})}}]),r}(),Ct="input",bt="navigate";e.CalendarContainer=ft,e.default=_t,e.getDefaultLocale=qe,e.registerLocale=function(e,t){var r="undefined"!=typeof window?window:global;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t},e.setDefaultLocale=function(e){("undefined"!=typeof window?window:global).__localeId__=e},Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RatePopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return localStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.61);\n  z-index: 99999;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.61);\n  z-index: 99999;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  width: 87%;\n  max-width: 320px;\n  padding: 21px 21px 16px 21px;\n  border-radius: 3px;\n  background-color: #fff;\n"],["\n  position: relative;\n  width: 87%;\n  max-width: 320px;\n  padding: 21px 21px 16px 21px;\n  border-radius: 3px;\n  background-color: #fff;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-bottom: 21px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #222;\n\n  ",";\n"],["\n  margin-bottom: 21px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #222;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      margin-top: 17px;\n      text-align: center;\n    "],["\n      margin-top: 17px;\n      text-align: center;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: 14px;\n  color: #000;\n  line-height: 19px;\n"],["\n  font-size: 14px;\n  color: #000;\n  line-height: 19px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  padding: 5px 10px;\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: bold;\n  color: #3b9478;\n  text-transform: uppercase;\n\n  ",";\n"],["\n  padding: 5px 10px;\n  font-size: 14px;\n  line-height: 1.2;\n  font-weight: bold;\n  color: #3b9478;\n  text-transform: uppercase;\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      opacity: 0.45;\n      pointer-events: none;\n    "],["\n      opacity: 0.45;\n      pointer-events: none;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  width: 226px;\n  margin: 20px auto 28px auto;\n"],["\n  display: flex;\n  flex-direction: row-reverse;\n  justify-content: space-between;\n  width: 226px;\n  margin: 20px auto 28px auto;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  ~ label {\n    color: #ccc;\n  }\n\n  :checked ~ label {\n    color: #ffcc00;\n  }\n"],["\n  ~ label {\n    color: #ccc;\n  }\n\n  :checked ~ label {\n    color: #ffcc00;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 50%;\n  top: -26px;\n  width: 46px;\n  height: 46px;\n  margin-left: -23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  background-color: #3b9478;\n"],["\n  position: absolute;\n  left: 50%;\n  top: -26px;\n  width: 46px;\n  height: 46px;\n  margin-left: -23px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 3px solid #fff;\n  border-radius: 50%;\n  background-color: #3b9478;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var centred=_ref.centred;return centred&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref2){var disabled=_ref2.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);});var StarsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Input=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject9);var ButtonsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var Success=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var Star=function Star(_ref3){var value=_ref3.value,rate=_ref3.rate,setRate=_ref3.setRate;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input,{type:"radio",id:"id-"+value,value:value,name:"rating",style:{display:"none"},defaultChecked:value===rate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("label",{htmlFor:"id-"+value,onClick:function onClick(){setRate&&setRate(value);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"30",height:"30",viewBox:"0 0 30 30"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M15,0l4.688,9.605L30,11.142l-7.5,7.492L24.187,29.2,15,24.206,5.812,29.2,7.5,18.634,0,11.142,10.313,9.605Z",fill:"currentColor"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{width:"30",height:"30",fill:"none"}))));};var RatePopup=function RatePopup(_ref4,resetCounter){var onHide=_ref4.onHide,_ref4$clearTimer=_ref4.clearTimer,clearTimer=_ref4$clearTimer===undefined?function(){return void 0;}:_ref4$clearTimer;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),rate=_useState2[0],setRate=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),successPopup=_useState4[0],setSuccessPopup=_useState4[1];var _localStorage=localStorage(),_localStorage2=_slicedToArray(_localStorage,2),error=_localStorage2[0],store=_localStorage2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("SHOW_RATE_APP_POPUP");},[]);if(error)return null;var later=function later(){Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("LATER_APP_RATING");var rateLater=store.get(RATE_LATER);if(rateLater){store.set(RATE_LATER,"never");clearTimer();onHide();return;}store.set(RATE_LATER,Date.now());store.set(KEY_DEALS_COUNT,resetCounter?0:COUNT);onHide();};if(successPopup){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{onClick:function onClick(){setSuccessPopup(null);clearTimer();onHide();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Success,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"20.216",height:"15.072",viewBox:"0 0 20.216 15.072"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 -5.814)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 5.814)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M9.151,20.2a2.348,2.348,0,0,1-3.32,0L.687,15.055a2.347,2.347,0,1,1,3.32-3.319L7.072,14.8a.594.594,0,0,0,.839,0l8.3-8.3a2.347,2.347,0,1,1,3.32,3.319Z",transform:"translate(0 -5.814)",fill:"#fff"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{centred:true},rate>3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Thank you for your feedback!"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Thank you!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StarsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:5,rate:successPopup}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:4,rate:successPopup}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:3,rate:successPopup}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:2,rate:successPopup}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:1,rate:successPopup}))));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Rate IronTrade app")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"If you enjoy using Iron Trade app, please take a moment to rate it!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StarsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:5,setRate:setRate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:4,setRate:setRate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:3,setRate:setRate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:2,setRate:setRate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Star,{value:1,setRate:setRate})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:later},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Later")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{disabled:rate==null,onClick:function onClick(){if(rate>3){Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("SET_POSITIVE_APP_RATING",{rate:rate});try{window.nativeInterface&&window.nativeInterface.redirectToMarket();setTimeout(function(){return setSuccessPopup(rate);},2000);}catch(e){setSuccessPopup(rate);Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("RATE_APP_ERROR",{error:e.message});}}else{Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("SET_NEGATIVE_APP_RATING",{rate:rate});setSuccessPopup(rate);}setRate(null);store.set(RATE_LATER,"never");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Submit")))));};var KEY_DEALS_COUNT="__it_dealscount";var COUNT=1;var RATE_LATER="rate_later";// повторно показать попап не ранее чем через сутки
var SHOW_AFTER=8640000;var localStorage=function localStorage(){var store={};try{store.set=function(key,value){return window.localStorage.setItem(key,value);};store.get=function(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:KEY_DEALS_COUNT;return window.localStorage.getItem(key);};store.rm=function(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:KEY_DEALS_COUNT;return window.localStorage.removeItem(key);};return[null,store];}catch(ex){return[ex];}};localStorage.keys={KEY_DEALS_COUNT:KEY_DEALS_COUNT};// словарь ключей, которые пишет эта ф-я в localStorage
localStorage.flush=function(){//очистка всех ключей которые может юзать эта ф-я
Object.keys(localStorage.keys).forEach(function(k){var _localStorage3=localStorage(),_localStorage4=_slicedToArray(_localStorage3,2),error=_localStorage4[0],store=_localStorage4[1];if(error){console.log(error);return;}store.rm(k);});};var Rate=function(_PureComponent){_inherits(Rate,_PureComponent);function Rate(){var _ref5;var _temp,_this,_ret;_classCallCheck(this,Rate);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref5=Rate.__proto__||Object.getPrototypeOf(Rate)).call.apply(_ref5,[this].concat(args))),_this),_this.ls=localStorage(),_this.state={isReadyForPopup:false,error:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Rate,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var _ls=_slicedToArray(this.ls,2),error=_ls[0],store=_ls[1];if(error){return this.setState({error:error});}var rateLater=store.get(RATE_LATER);var dealsCount=store.get(KEY_DEALS_COUNT);if(rateLater==="never"&&dealsCount==="WASTED"){return null;}//Таймер смотрит каждые полсекунды на кол-во сделок успешных, как только их стало COUNT, он запускает интервал на 10 сек и сам обнуляется
//по истечении интервала выскакивает попап с рейтингом
this.timer=window.setInterval(function(){var rateLater=store.get(RATE_LATER);var dealsCount=store.get(KEY_DEALS_COUNT);if(dealsCount!=="WASTED"&&Number(dealsCount)>=Number(COUNT)&&(!rateLater||rateLater&&rateLater!=="never"&&Number(rateLater)+SHOW_AFTER<Date.now())){store.set(KEY_DEALS_COUNT,"WASTED");_this2.timeout=window.setTimeout(function(){_this2.setState({isReadyForPopup:true},function(){window.clearInterval(_this2.timeout);});},10000);}},1000);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.clearInterval(this.timer);}},{key:"componentDidCatch",value:function componentDidCatch(error,info){console.log(error,info);}},{key:"render",value:function render(){var _this3=this;var _state=this.state,error=_state.error,isReadyForPopup=_state.isReadyForPopup;if(error){console.log(error);return null;}return isReadyForPopup&&"irontrade"==="irontrade"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RatePopup,{clearTimer:function clearTimer(){return window.clearInterval(_this3.timer);},onHide:function onHide(){return _this3.setState({isReadyForPopup:false});}}):null;}}]);return Rate;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextGenChartTypes__ = __webpack_require__(45);
function Candlestick(props){var openY=props.open[1];var closeY=props.close[1];var minimumY=props.minimum[1];var maximumY=props.maximum[1];var top=maximumY;var height=minimumY-maximumY||1;var left=props.range[0];var width=props.range[1]-left;var bodyHeight=Math.abs(closeY-openY)||1;var bodyTop=Math.min(closeY,openY)-maximumY;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",width:width,height:height,WebkitTransform:"translateX("+left+"px) translateY("+top+"px)",transform:"translateX("+left+"px) translateY("+top+"px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:2,height:height,background:props.close[2].value>props.open[2].value?props.alternateColors?"#00cbfe":"#6cb032":"#e74c3c",margin:"0 auto"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",top:bodyTop,left:"10%",right:"10%",height:bodyHeight,background:props.close[2].value>props.open[2].value?props.alternateColors?"#00cbfe":"#6cb032":"#e74c3c",borderRadius:2}}));}function CandlestickChart(props){return props.candles.filter(function(candle){return candle.close[0]>0&&candle.open[0]<props.viewportWidth;}).map(function(candle,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Candlestick,Object.assign({key:""+i+candle.open[2].date},candle,{alternateColors:props.alternateColors}));});}/* harmony default export */ __webpack_exports__["a"] = (CandlestickChart);

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useLocalStorage;
/* harmony export (immutable) */ __webpack_exports__["b"] = useWindowSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function useLocalStorage(key,initialValue){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){try{var item=window.localStorage.getItem(key);if(item){return JSON.parse(item);}else{window.localStorage.setItem(key,JSON.stringify(initialValue));return initialValue;}}catch(error){console.log(error);return initialValue;}}),_useState2=_slicedToArray(_useState,2),storedValue=_useState2[0],setStoredValue=_useState2[1];var setValue=function setValue(value){try{var valueToStore=value instanceof Function?value(storedValue):value;setStoredValue(valueToStore);window.localStorage.setItem(key,JSON.stringify(valueToStore));}catch(error){console.log(error);}};return[storedValue,setValue];}function useWindowSize(){var isClient=(typeof window==="undefined"?"undefined":_typeof(window))==="object";function getSize(){return{width:isClient?window.innerWidth:undefined,height:isClient?window.innerHeight:undefined};}var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(getSize),_useState4=_slicedToArray(_useState3,2),windowSize=_useState4[0],setWindowSize=_useState4[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!isClient){return false;}function handleResize(){setWindowSize(getSize());}window.addEventListener("resize",handleResize);return function(){return window.removeEventListener("resize",handleResize);};},[]);// Empty array ensures that effect is only run on mount and unmount
return windowSize;}

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(883);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(33) && !__webpack_require__(20)(function () {
  return Object.defineProperty(__webpack_require__(324)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(28);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(66);
var toIObject = __webpack_require__(67);
var arrayIndexOf = __webpack_require__(232)(false);
var IE_PROTO = __webpack_require__(326)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34);
var anObject = __webpack_require__(15);
var getKeys = __webpack_require__(126);

module.exports = __webpack_require__(33) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(67);
var gOPN = __webpack_require__(129).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(233);
var pIE = __webpack_require__(183);
var toObject = __webpack_require__(42);
var IObject = __webpack_require__(182);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(20)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(47);
var isObject = __webpack_require__(21);
var invoke = __webpack_require__(501);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 501 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(17).parseInt;
var $trim = __webpack_require__(154).trim;
var ws = __webpack_require__(330);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(17).parseFloat;
var $trim = __webpack_require__(154).trim;

module.exports = 1 / $parseFloat(__webpack_require__(330) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(74);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(21);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 506 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(333);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(15);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(47);
var toObject = __webpack_require__(42);
var IObject = __webpack_require__(182);
var toLength = __webpack_require__(35);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(42);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(35);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(33) && /./g.flags != 'g') __webpack_require__(34).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(237)
});


/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(15);
var isObject = __webpack_require__(21);
var newPromiseCapability = __webpack_require__(348);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(516);
var validate = __webpack_require__(156);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(241)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(34).f;
var create = __webpack_require__(128);
var redefineAll = __webpack_require__(133);
var ctx = __webpack_require__(73);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var $iterDefine = __webpack_require__(336);
var step = __webpack_require__(511);
var setSpecies = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(33);
var fastKey = __webpack_require__(112).fastKey;
var validate = __webpack_require__(156);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(516);
var validate = __webpack_require__(156);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(241)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var each = __webpack_require__(87)(0);
var redefine = __webpack_require__(60);
var meta = __webpack_require__(112);
var assign = __webpack_require__(499);
var weak = __webpack_require__(519);
var isObject = __webpack_require__(21);
var fails = __webpack_require__(20);
var validate = __webpack_require__(156);
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(241)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(133);
var getWeak = __webpack_require__(112).getWeak;
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(21);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var createArrayMethod = __webpack_require__(87);
var $has = __webpack_require__(66);
var validate = __webpack_require__(156);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(85);
var toLength = __webpack_require__(35);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(129);
var gOPS = __webpack_require__(233);
var anObject = __webpack_require__(15);
var Reflect = __webpack_require__(17).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(234);
var isObject = __webpack_require__(21);
var toLength = __webpack_require__(35);
var ctx = __webpack_require__(73);
var IS_CONCAT_SPREADABLE = __webpack_require__(28)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(35);
var repeat = __webpack_require__(332);
var defined = __webpack_require__(84);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys = __webpack_require__(126);
var toIObject = __webpack_require__(67);
var isEnum = __webpack_require__(183).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = __webpack_require__(184);
var from = __webpack_require__(526);
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

var forOf = __webpack_require__(132);

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};


/***/ }),
/* 527 */
/***/ (function(module, exports) {

// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};


/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return store; });
/* harmony export (immutable) */ __webpack_exports__["a"] = TopLevelShit;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_createStore__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_reducer_serverFaults__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_withLocaleChange__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ErrorPopup_Error__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_FailureScreen__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_TradeModals_ReferralBonus__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_helmet__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_Subzero__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_DataPlease__ = __webpack_require__(1678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_ReconnectableSocket__ = __webpack_require__(1680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_Loadable__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_FirebaseCloudMessaging__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__routes__ = __webpack_require__(1700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_Spinners_BrandSpinner__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Audio__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_RtlProvider__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_AddToHomeScreen__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_Tournaments_TournamentId__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_common_Modal__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_AddToHomescreenPopup__ = __webpack_require__(2042);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_OnLine__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_common_crashLog__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_webview_Rate__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_ABTest__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_Chart_ChartEventHandlers__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_Scorpion__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_TournamentInvite__ = __webpack_require__(2047);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["Internet connection failed!"],["Internet connection failed!"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function fetchDictionary(language){switch(language){case"en":// MomentJS uses EN locale as default so no need to load it
return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 879));case"vn":case"vi":return Promise.all([__webpack_require__.e/* import() */(82).then(__webpack_require__.bind(null, 2150)),__webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 2151))]).then(function(_ref){var _ref2=_slicedToArray(_ref,2),a=_ref2[0],b=_ref2[1];return b;});case"ru":return Promise.all([__webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 2152)),__webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 2153))]).then(function(_ref3){var _ref4=_slicedToArray(_ref3,2),a=_ref4[0],b=_ref4[1];return b;});case"jp":return Promise.all([__webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 2154)),__webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 2155))]).then(function(_ref5){var _ref6=_slicedToArray(_ref5,2),a=_ref6[0],b=_ref6[1];return b;});case"ph":case"tl":return Promise.all([__webpack_require__.e/* import() */(84).then(__webpack_require__.bind(null, 2156)),__webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 2157))]).then(function(_ref7){var _ref8=_slicedToArray(_ref7,2),a=_ref8[0],b=_ref8[1];return b;});case"th":return Promise.all([__webpack_require__.e/* import() */(85).then(__webpack_require__.bind(null, 2158)),__webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 2159))]).then(function(_ref9){var _ref10=_slicedToArray(_ref9,2),a=_ref10[0],b=_ref10[1];return b;});case"id":return Promise.all([__webpack_require__.e/* import() */(88).then(__webpack_require__.bind(null, 2160)),__webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 2161))]).then(function(_ref11){var _ref12=_slicedToArray(_ref11,2),a=_ref12[0],b=_ref12[1];return b;});case"hi":return Promise.all([__webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 2162)),__webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 2163))]).then(function(_ref13){var _ref14=_slicedToArray(_ref13,2),a=_ref14[0],b=_ref14[1];return b;});case"ar":return Promise.all([__webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 2164)),__webpack_require__.e/* import() */(70).then(__webpack_require__.bind(null, 2165))]).then(function(_ref15){var _ref16=_slicedToArray(_ref15,2),a=_ref16[0],b=_ref16[1];return b;});case"es":return Promise.all([__webpack_require__.e/* import() */(90).then(__webpack_require__.bind(null, 2166)),__webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 2167))]).then(function(_ref17){var _ref18=_slicedToArray(_ref17,2),a=_ref18[0],b=_ref18[1];return b;});case"cn":return Promise.all([__webpack_require__.e/* import() */(81).then(__webpack_require__.bind(null, 2168)),__webpack_require__.e/* import() */(69).then(__webpack_require__.bind(null, 2169))]).then(function(_ref19){var _ref20=_slicedToArray(_ref19,2),a=_ref20[0],b=_ref20[1];return b;});case"tr":return Promise.all([__webpack_require__.e/* import() */(83).then(__webpack_require__.bind(null, 2170)),__webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 2171))]).then(function(_ref21){var _ref22=_slicedToArray(_ref21,2),a=_ref22[0],b=_ref22[1];return b;});default:return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 879));}}var Error404=Object(__WEBPACK_IMPORTED_MODULE_16__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"404");var store=Object(__WEBPACK_IMPORTED_MODULE_4__redux_createStore__["a" /* default */])();var ChangeLocalePlease=function(_React$Component){_inherits(ChangeLocalePlease,_React$Component);function ChangeLocalePlease(){var _ref23;var _temp,_this,_ret;_classCallCheck(this,ChangeLocalePlease);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref23=ChangeLocalePlease.__proto__||Object.getPrototypeOf(ChangeLocalePlease)).call.apply(_ref23,[this].concat(args))),_this),_this.sent=false,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ChangeLocalePlease,[{key:"render",value:function render(){if(!this.props.profile||this.sent){return null;}var langInURL=/lang=([a-zA-Z]{2})/.exec(window.location.search);if(langInURL){var lang=langInURL[1];this.props.onLocaleChange(lang);this.sent=true;}return null;}}]);return ChangeLocalePlease;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var ChangeLocalePleaseWhenReady=Object(__WEBPACK_IMPORTED_MODULE_6__components_withData__["a" /* default */])({optional:["profile"]})(Object(__WEBPACK_IMPORTED_MODULE_7__components_withLocaleChange__["a" /* default */])(ChangeLocalePlease));var _App=function(_React$Component2){_inherits(_App,_React$Component2);function _App(){var _ref24;var _temp2,_this2,_ret2;_classCallCheck(this,_App);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref24=_App.__proto__||Object.getPrototypeOf(_App)).call.apply(_ref24,[this].concat(args))),_this2),_this2.state={isOnline:true,isAlive:true,errors:null},_this2.onApiProviderLogout=function(){if(_this2.props.profile!=null){_this2.props.dispatch({type:"INVALIDATE_PROFILE"});}},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(_App,[{key:"UNSAFE_componentWillMount",value:function UNSAFE_componentWillMount(){var _this3=this;//for compatibility with the Android app
if(false){window.androidApp=window.siamoption;}this.unsubscribeFromHistory=this.props.history.listen(function(location,action){// if not helpdesk
if(!/\bhelpdesk\b/.test(location.pathname)){// scroll to top on page change
window.scrollTo(0,0);}_this3.props.dispatch({type:"DISPLAY_AUTH_TAB",payload:""});});if(true){// Костыль с таймзоной для бэкенда только для айрона
var tz=new Date().getTimezoneOffset()/60;this.props.fetch("/ajax/setTimezone?tz="+tz);}}},{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_37__components_Scorpion__["a" /* submitAppsFlyerParameters */])();}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(typeof this.unsubscribeFromHistory==="function"){this.unsubscribeFromHistory();}}},{key:"UNSAFE_componentWillUpdate",value:function UNSAFE_componentWillUpdate(prevState){if(prevState.location.pathname!==this.props.location.pathname){this.props.dispatch({type:"DISPLAY_AUTH_FORM",payload:false});Object(__WEBPACK_IMPORTED_MODULE_36__components_Chart_ChartEventHandlers__["a" /* clearSnapshot */])();}}},{key:"componentDidCatch",value:function componentDidCatch(error,info){this.setState({isAlive:false,errors:error.message+"\n"+error.stack+"\n"+info.componentStack});this.props.crashLog({error:{message:error.name+" "+error.message,info:{url:document.location.href,stack:error.stack}}});Object(__WEBPACK_IMPORTED_MODULE_17__components_common_dataLayer__["a" /* default */])({event:"exception-to-ga",exDescription:error.message+info.componentStack,exFatal:true});}},{key:"render",value:function render(){var _this4=this;if(!this.state.isAlive){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__components_FailureScreen__["a" /* default */],{errors:this.state.errors});}if(this.props.profileStatus==="PENDING"&&this.props.profile==null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__components_Spinners_BrandSpinner__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_DataPlease__["a" /* ProfilePlease */],null));}var sideEffects=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],{key:"sideEffects"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_32__components_OnLine__["b" /* default */],{onChange:function onChange(isOnline){return _this4.setState({isOnline:isOnline});}}),this.props.soundsEnabled&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__components_Audio__["b" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__components_common_Gettext__["a" /* DictionaryUpdater */],{fetchDictionary:fetchDictionary}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ChangeLocalePleaseWhenReady,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_DataPlease__["b" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_DataPlease__["a" /* ProfilePlease */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_helmet__["a" /* Helmet */],null,"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("title",null,this.props.gettext(["Trading with Irontrade.com, safe and easy start."])),"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta",{name:"description",content:this.props.gettext(["Trade with one of the most rapidly growing trading platforms. Easy withdrawals, stable quotations, low spreads, and excellent support service with Irontrade."])}), true?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("meta",{name:"google-site-verification",content:"7NBEJHU048g1GKn9SCunSEVaeqIPa83T5oEQZciUAV0"}):React.createElement("meta",{name:"google-site-verification",content:"qZV-8wLeVxlWTpZHPG7qupDj_CKSUn37e1pDZXgSGn8"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__components_ReconnectableSocket__["a" /* default */],{pass:!this.props.profile||!this.props.profile.active_account_id}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_Subzero__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_26__components_AddToHomeScreen__["a" /* default */],{isMobile:this.props.isMobile}));var visuals=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__components_AddToHomescreenPopup__["a" /* default */],{key:this.props.location.pathname,sessionCount:this.props.profile&&this.props.profile.session_count||null}),__WEBPACK_IMPORTED_MODULE_22__FeatureFlags__["a" /* default */].enableOneSignal&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__components_FirebaseCloudMessaging__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* Switch */],null,"irontrade"==="app"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{exact:true,path:"/",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:"/trade"});}}),__WEBPACK_IMPORTED_MODULE_20__routes__["a" /* default */].map(function(route){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],Object.assign({key:route.path},route));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Route */],{component:Error404})),this.props.errorMessage&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_ErrorPopup_Error__["b" /* default */],{onDismiss:this.props.dismissErrorMessage,message:this.props.errorMessage}),!this.state.isOnline&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_ErrorPopup_Error__["b" /* default */],{onDismiss:function onDismiss(){return _this4.setState({isOnline:true});},message:this.props.gettext(_templateObject)}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_38__components_TournamentInvite__["a" /* default */],null));var referralBonus=this.props.referralBonus&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__components_TradeModals_ReferralBonus__["a" /* default */],Object.assign({},this.props.referralBonus,{onDismiss:this.props.dismissReferralBonusMessage}));var id=__WEBPACK_IMPORTED_MODULE_2_idx___default()(this.props,function(props){return props.profile.id;})||"";var ua=window.navigator.userAgent.toLowerCase();// Android Webview full app
var isWebView=/wvbo_full/g.test(ua);// Android Webview analytics
var isAnalyticsWebView="irontrade"==="irontrade"&&/androidweb.*com\.irontrade\.analytics.*wvbo/g.test(ua)&&!isWebView;var showRate=(isWebView||isAnalyticsWebView)&&window.nativeInterface&&window.nativeInterface.redirectToMarket;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30__components_common_Modal__["b" /* ModalRootProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29__components_common_ModalProvider__["b" /* ModalProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__components_Tournaments_TournamentId__["a" /* TournamentIdProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__components_Tournaments_Api__["b" /* TournamentAPIProvider */],{onLogout:this.onApiProviderLogout,key:id,profile:this.props.profile,locale:this.props.locale,currency:this.props.currency},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29__components_common_ModalProvider__["c" /* ModalRoot */],null),"irontrade"==="irontrade"&&showRate&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_35__components_ABTest__["a" /* default */],{campaign:"rating_from_push"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_34__components_webview_Rate__["a" /* Rate */],null)),sideEffects,visuals,referralBonus)))));}}]);return _App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state){var currency=state.serverData?state.serverData.currency:state.apiConfigs&&state.apiConfigs.defaultCurrency||"USD";return{soundsEnabled:state.audio.enabled,isMobile:state.serverData&&state.serverData.isMobile,projectTitle:state.serverData&&state.serverData.projectTitle,supportEmail:state.serverData&&state.serverData.supportEmail,errorMessage:Object(__WEBPACK_IMPORTED_MODULE_5__redux_reducer_serverFaults__["b" /* getErrorMessage */])(state.serverFaults),referralBonus:state.referralBonus,profile:state.profile,locale:Object(__WEBPACK_IMPORTED_MODULE_11__components_common_Gettext__["d" /* inferLocale */])(state),currency:currency,profileStatus:state.dataRequirementsStatus.profile};}function mapDispatchToProps(dispatch){return Object.assign({dismissErrorMessage:function dismissErrorMessage(){dispatch({type:"DISMISS_SERVER_FAULT"});},dismissReferralBonusMessage:function dismissReferralBonusMessage(){dispatch({type:"DISMISS_REFERRAL_BONUS"});}},Object(__WEBPACK_IMPORTED_MODULE_18__components_common_fetch__["e" /* mapDispatchToFetch */])(dispatch));}var App=Object(__WEBPACK_IMPORTED_MODULE_11__components_common_Gettext__["g" /* withGettext */])(Object(__WEBPACK_IMPORTED_MODULE_33__components_common_crashLog__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(_App))));function TopLevelShit(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_redux__["a" /* Provider */],{store:store},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__components_ThemeProvider__["e" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__components_RtlProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__components_ThemeProvider__["c" /* TradeThemeContextProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](App,null))))));}

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(352);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');
  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    return '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(533);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + (methodName + '. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(537);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["default"]] = observable, _ref2;
}

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(1115);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(1122);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["default"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27), __webpack_require__(355)(module)))

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(541);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(353);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

var baseUniq = __webpack_require__(1131);

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? baseUniq(array) : [];
}

module.exports = uniq;


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(356),
    setCacheAdd = __webpack_require__(1155),
    setCacheHas = __webpack_require__(1156);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 545 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(1157);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 547 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 548 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 550 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(1172),
    flatRest = __webpack_require__(363);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(1174);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(1175);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(557);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(1177),
    hasPath = __webpack_require__(1178);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 559 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(188),
    keys = __webpack_require__(173);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(1190),
    isArguments = __webpack_require__(315),
    isArray = __webpack_require__(54),
    isBuffer = __webpack_require__(316),
    isIndex = __webpack_require__(252),
    isTypedArray = __webpack_require__(485);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 562 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(561),
    baseKeysIn = __webpack_require__(1195),
    isArrayLike = __webpack_require__(318);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 564 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 565 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(364),
    getPrototype = __webpack_require__(372),
    getSymbols = __webpack_require__(371),
    stubArray = __webpack_require__(565);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(568),
    getSymbols = __webpack_require__(371),
    keys = __webpack_require__(173);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(364),
    isArray = __webpack_require__(54);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(568),
    getSymbolsIn = __webpack_require__(566),
    keysIn = __webpack_require__(563);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(48);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(135),
    getPrototype = __webpack_require__(372),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_Error__ = __webpack_require__(1220);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-top: 40px;\n  text-align: center;\n  color: #fff;\n  background-color: ",";\n  background-size: cover;\n  overflow: auto;\n"],["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding-top: 40px;\n  text-align: center;\n  color: #fff;\n  background-color: ",";\n  background-size: cover;\n  overflow: auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto 40px;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 1.3;\n  text-align: center;\n  color: ",";\n\n  @media (max-width: 959px) {\n    padding: 0 30px;\n    font-size: 18px;\n  }\n"],["\n  direction: ",";\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto 40px;\n  font-weight: 400;\n  font-size: 24px;\n  line-height: 1.3;\n  text-align: center;\n  color: ",";\n\n  @media (max-width: 959px) {\n    padding: 0 30px;\n    font-size: 18px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 50px;\n  height: 50px;\n  margin: 0 auto 20px;\n"],["\n  width: 50px;\n  height: 50px;\n  margin: 0 auto 20px;\n"]),_templateObject4=_taggedTemplateLiteral([""],[""]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n"],["\n  display: flex;\n  justify-content: center;\n  padding: 40px 0;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  text-align: left;\n  font-family: monospace;\n  max-width: 100%;\n"],["\n  text-align: left;\n  font-family: monospace;\n  max-width: 100%;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: inline-block;\n  height: 2.611em;\n  line-height: 2.611em;\n  margin-left: 0.556em;\n  padding: 0 0.944em;\n  font-weight: 700;\n  font-size: 20px;\n  color: ",";\n  border-radius: 0.5em;\n  border: 1px solid ",";\n  cursor: pointer;\n  transition: .5s;\n  :hover,\n  :focus,\n  :active {\n    background-color: ",";\n    color: #fff;\n  }\n\n  @media (max-width: 959px) {\n    font-size: 18px;\n  }\n"],["\n  display: inline-block;\n  height: 2.611em;\n  line-height: 2.611em;\n  margin-left: 0.556em;\n  padding: 0 0.944em;\n  font-weight: 700;\n  font-size: 20px;\n  color: ",";\n  border-radius: 0.5em;\n  border: 1px solid ",";\n  cursor: pointer;\n  transition: .5s;\n  :hover,\n  :focus,\n  :active {\n    background-color: ",";\n    color: #fff;\n  }\n\n  @media (max-width: 959px) {\n    font-size: 18px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Screen=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.main;});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.direction;},function(props){return props.theme.accent;});var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var ButtonsWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var ErrorWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var ErrorPre=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].pre(_templateObject6);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.theme.accent;},function(props){return props.theme.accent;},function(props){return props.theme.accent;});function FailureScreen(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showError=_useState2[0],setShowError=_useState2[1];var errors=props.errors;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Screen,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_Error__["a" /* default */],{width:"100%",fill:"#D75A4A"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Sorry, something went wrong on our end. Please try refreshing this page.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonsWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:function onClick(event){event.stopPropagation();window.location.reload();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Refresh")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:function onClick(){return setShowError(!showError);}},!showError?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Show error"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Hide error"))),showError&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ErrorPre,null,errors)));}/* harmony default export */ __webpack_exports__["a"] = (FailureScreen);

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.52e69859.png";

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/howto-bg-iron.9965f593.jpg";

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/desktop-tour-bg-dark.c74e93c7.jpg";

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/desktop-tour-bg-light.55602cb1.jpg";

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getPhoneExample;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Subzero__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tab__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SocialLink__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BtnFormSubmit__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ErrorMessage__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CountrySelect__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__validators__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__loginWith__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__StyledComponents_Container__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Input__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ReVerification_Phone_PhoneInput__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__ReVerification_style__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__ReVerification_Icons__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__StyledComponents_FakeLink__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Scorpion__ = __webpack_require__(424);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  white-space: nowrap;\n"],["\n  white-space: nowrap;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: auto;\n  font-size: 0;\n  line-height: 0;\n  vertical-align: bottom;\n  border-bottom: 2px solid ",";\n"],["\n  width: 100%;\n  margin-bottom: auto;\n  font-size: 0;\n  line-height: 0;\n  vertical-align: bottom;\n  border-bottom: 2px solid ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  padding-top: 4px;\n"],["\n  padding-top: 4px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  padding: 4px 0;\n  position: relative;\n\n  ",";\n"],["\n  padding: 4px 0;\n  position: relative;\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      padding: 9px 0;\n    "],["\n      padding: 9px 0;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  padding: 8px 0;\n"],["\n  padding: 8px 0;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: none;\n"],["\n  display: none;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: block;\n  ",";\n  font-size: ",";\n  line-height: 1.2;\n  ",";\n  color: #8d8d8d !important;\n  user-select: none;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    ",";\n    transform: translateY(-50%);\n    width: 19px;\n    height: 19px;\n    border: 1px solid #cfcfcf;\n    border-radius: 3px;\n    color: #252525;\n    background: none;\n    background-color: #f6f6f6;\n    box-shadow: inset 0 2px 0 0 #e3e3e3;\n    cursor: pointer;\n  }\n\n  :after {\n    ",";\n  }\n\n  ",";\n"],["\n  direction: ",";\n  position: relative;\n  display: block;\n  ",";\n  font-size: ",";\n  line-height: 1.2;\n  ",";\n  color: #8d8d8d !important;\n  user-select: none;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    ",";\n    transform: translateY(-50%);\n    width: 19px;\n    height: 19px;\n    border: 1px solid #cfcfcf;\n    border-radius: 3px;\n    color: #252525;\n    background: none;\n    background-color: #f6f6f6;\n    box-shadow: inset 0 2px 0 0 #e3e3e3;\n    cursor: pointer;\n  }\n\n  :after {\n    ",";\n  }\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        ",";\n        transform: rotate(45deg);\n        width: 8px;\n        height: 12px;\n        margin-top: -8px;\n        border-right: 3px solid #56496e;\n        border-bottom: 3px solid #56496e;\n        cursor: pointer;\n      "],["\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        ",";\n        transform: rotate(45deg);\n        width: 8px;\n        height: 12px;\n        margin-top: -8px;\n        border-right: 3px solid #56496e;\n        border-bottom: 3px solid #56496e;\n        cursor: pointer;\n      "]),_templateObject10=_taggedTemplateLiteral(["\n      color: #ffffff !important;\n      ",";\n\n      &::before {\n        width: 30px;\n        height: 30px;\n        background-color: rgba(255, 255, 255, 0.25);\n        border: none;\n        border-radius: 8px;\n        box-shadow: none;\n      }\n\n      &:after {\n        ",";\n      }\n    "],["\n      color: #ffffff !important;\n      ",";\n\n      &::before {\n        width: 30px;\n        height: 30px;\n        background-color: rgba(255, 255, 255, 0.25);\n        border: none;\n        border-radius: 8px;\n        box-shadow: none;\n      }\n\n      &:after {\n        ",";\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n            ",";\n            border-right-color: ",";\n            border-bottom-color: ",";\n          "],["\n            ",";\n            border-right-color: ",";\n            border-bottom-color: ",";\n          "]),_templateObject12=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2 !important;\n  text-decoration: none !important;\n  color: #feac00 !important;\n  transition: all 0.2s ease !important;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n\n  ",";\n"],["\n  font-size: ",";\n  line-height: 1.2 !important;\n  text-decoration: none !important;\n  color: #feac00 !important;\n  transition: all 0.2s ease !important;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      color: "," !important;\n\n      &:hover {\n        color: "," !important;\n      }\n    "],["\n      color: "," !important;\n\n      &:hover {\n        color: "," !important;\n      }\n    "]),_templateObject14=_taggedTemplateLiteral(["\n  direction: ",";\n  padding: 4px 0;\n  height: 56px;\n  position: relative;\n  text-align: justify;\n  vertical-align: middle;\n\n  ",";\n\n  :after {\n    content: \"\";\n    display: inline-block;\n    width: 100%;\n  }\n\n  ",";\n"],["\n  direction: ",";\n  padding: 4px 0;\n  height: 56px;\n  position: relative;\n  text-align: justify;\n  vertical-align: middle;\n\n  ",";\n\n  :after {\n    content: \"\";\n    display: inline-block;\n    width: 100%;\n  }\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n      text-align: center !important;\n    "],["\n      text-align: center !important;\n    "]),_templateObject16=_taggedTemplateLiteral(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      ::after {\n        display: none;\n      }\n\n      @media (max-width: 374px) {\n        height: auto;\n        text-align: center;\n      }\n    "],["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n\n      ::after {\n        display: none;\n      }\n\n      @media (max-width: 374px) {\n        height: auto;\n        text-align: center;\n      }\n    "]),_templateObject17=_taggedTemplateLiteral(["\n  ",";\n  display: inline-block;\n  vertical-align: middle;\n  font-size: ",";\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #fff;\n\n  ",";\n"],["\n  ",";\n  display: inline-block;\n  vertical-align: middle;\n  font-size: ",";\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #fff;\n\n  ",";\n"]),_templateObject18=_taggedTemplateLiteral(["\n      text-transform: lowercase;\n      margin: 0 5px !important;\n    "],["\n      text-transform: lowercase;\n      margin: 0 5px !important;\n    "]),_templateObject19=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 4px 0;\n\n  ",";\n"],["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 4px 0;\n\n  ",";\n"]),_templateObject20=_taggedTemplateLiteral(["\n      margin: 9px 0;\n    "],["\n      margin: 9px 0;\n    "]),_templateObject21=_taggedTemplateLiteral(["\n  @media (max-width: 767px) {\n    :first-of-type {\n      margin-bottom: 4px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex: 1;\n    flex-basis: 50%;\n    max-width: 220px;\n  }\n"],["\n  @media (max-width: 767px) {\n    :first-of-type {\n      margin-bottom: 4px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex: 1;\n    flex-basis: 50%;\n    max-width: 220px;\n  }\n"]),_templateObject22=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n  }\n"],["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  margin-bottom: 8px;\n  padding: 27px 20px 20px 30px;\n  background: #ebebeb;\n  border-radius: 4px;\n\n  :after {\n    top: 100%;\n    left: 18px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(235, 235, 235, 0);\n    border-top-color: #ebebeb;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n"],["\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  margin-bottom: 8px;\n  padding: 27px 20px 20px 30px;\n  background: #ebebeb;\n  border-radius: 4px;\n\n  :after {\n    top: 100%;\n    left: 18px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(235, 235, 235, 0);\n    border-top-color: #ebebeb;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n"]),_templateObject24=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 16px;\n  min-width: 16px;\n  margin-right: 7px;\n  top: 10px;\n  left: 9px;\n"],["\n  position: absolute;\n  width: 16px;\n  min-width: 16px;\n  margin-right: 7px;\n  top: 10px;\n  left: 9px;\n"]),_templateObject25=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 14px;\n  color: #343434;\n  text-align: left;\n"],["\n  font-size: ",";\n  line-height: 14px;\n  color: #343434;\n  text-align: left;\n"]),_templateObject26=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 11px;\n  height: 11px;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 11px;\n  height: 11px;\n  cursor: pointer;\n"]),_templateObject27=_taggedTemplateLiteral(["\n  padding: 0 20px 9px 20px;\n  margin: 0;\n  font-size: ",";\n  line-height: 24px;\n  font-weight: bold;\n  color: ",";\n  text-align: center;\n  ",";\n"],["\n  padding: 0 20px 9px 20px;\n  margin: 0;\n  font-size: ",";\n  line-height: 24px;\n  font-weight: bold;\n  color: ",";\n  text-align: center;\n  ",";\n"]),_templateObject28=_taggedTemplateLiteral(["\n      color: #ffffff;\n      font-size: 28px;\n      line-height: 1.2;\n\n      @media (max-width: 479px) {\n        font-size: 20px;\n      }\n    "],["\n      color: #ffffff;\n      font-size: 28px;\n      line-height: 1.2;\n\n      @media (max-width: 479px) {\n        font-size: 20px;\n      }\n    "]),_templateObject29=_taggedTemplateLiteral(["\n  margin-top: 10px;\n  font-size: ",";\n  color: #fff;\n  line-height: 1;\n  ",";\n"],["\n  margin-top: 10px;\n  font-size: ",";\n  color: #fff;\n  line-height: 1;\n  ",";\n"]),_templateObject30=_taggedTemplateLiteral(["\n      font-size: ",";\n      text-align: center;\n      line-height: 1.2;\n      font-weight: bold;\n      color: ",";\n    "],["\n      font-size: ",";\n      text-align: center;\n      line-height: 1.2;\n      font-weight: bold;\n      color: ",";\n    "]),_templateObject31=_taggedTemplateLiteral(["\n  text-decoration: none !important;\n  color: "," !important;\n  transition: all 0.2s ease;\n  font-size: ",";\n  line-height: 1;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n  cursor: pointer;\n  ",";\n"],["\n  text-decoration: none !important;\n  color: "," !important;\n  transition: all 0.2s ease;\n  font-size: ",";\n  line-height: 1;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n  cursor: pointer;\n  ",";\n"]),_templateObject32=_taggedTemplateLiteral(["\n      color: "," !important;\n      &:hover {\n        color: #ffffff !important;\n      }\n    "],["\n      color: "," !important;\n      &:hover {\n        color: #ffffff !important;\n      }\n    "]),_templateObject33=_taggedTemplateLiteral(["Incorrect phone number format!"],["Incorrect phone number format!"]),_templateObject34=_taggedTemplateLiteral(["Email"],["Email"]),_templateObject35=_taggedTemplateLiteral(["Phone"],["Phone"]),_templateObject36=_taggedTemplateLiteral(["Password"],["Password"]),_templateObject37=_taggedTemplateLiteral(["Terms and Conditions"],["Terms and Conditions"]),_templateObject38=_taggedTemplateLiteral(["Return and Refund Policy"],["Return and Refund Policy"]),_templateObject39=_taggedTemplateLiteral(["Privacy Policy"],["Privacy Policy"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var isIronForm="irontrade"==="irontrade"||"irontrade"==="eztrader";var Unbreakable=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].span(_templateObject);var TabContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.accent;});var RegisterContainer=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_20__StyledComponents_Container__["a" /* default */])(_templateObject3);var InputContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject5);});var CheckContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject6);var Checkbox=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].input(_templateObject7);var CheckboxLabel=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].label(_templateObject8,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("padding-left","31px"),Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(12,16),Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("text-align","left"),Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("left",0),function(_ref3){var checked=_ref3.checked;return checked&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("left","5px"));},function(_ref4){var theme=_ref4.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("padding-left","47px"),function(_ref5){var checked=_ref5.checked,isDarkPage=_ref5.isDarkPage;return checked&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("left","11px"),isDarkPage?"#ffffff":"#56496e",isDarkPage?"#ffffff":"#56496e");});});var TermsLink=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_10__common_Link__["a" /* Link */])(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(12,16),function(_ref6){var theme=_ref6.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject13,theme.accent,theme.mainLink);});var SubmitContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject14,function(props){return props.theme.direction;},function(props){return!props.showSocial&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject15);},function(props){return props.isIntlProject&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject16);});var Text=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].span(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["c" /* rtl */])("margin-left","4px"),Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.isIntlProject&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject18);});var PhoneContainer=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(InputContainer)(_templateObject19,function(_ref7){var theme=_ref7.theme;return theme.direction;},function(_ref8){var theme=_ref8.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject20);});var PhoneInputContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject21);var PhoneFieldContainer=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_23__ReVerification_style__["b" /* FieldContainer */])(_templateObject22);var PhoneInfo=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject23);var IconContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject24);var InfoText=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject25,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(12));var CloseInfo=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject26);var FormText=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].p(_templateObject27,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(18),function(_ref9){var theme=_ref9.theme;return theme.mainDarkText;},function(_ref10){var theme=_ref10.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject28);});var BackContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject29,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(15),function(_ref11){var theme=_ref11.theme,isDarkPage=_ref11.isDarkPage;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject30,Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(18),isDarkPage?"#ffffff":"rgba(34, 34, 34, 0.59)");});var BackToLogin=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_26__StyledComponents_FakeLink__["a" /* default */])(_templateObject31,function(_ref12){var theme=_ref12.theme;return theme.accent;},Object(__WEBPACK_IMPORTED_MODULE_25__common_styled_mixins__["a" /* fontSize */])(18),function(_ref13){var theme=_ref13.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject32,theme.accent);});function getPhoneExample(telCountry,apiCountries){var phoneExample=void 0;if(telCountry){var apiCountry=apiCountries.find(function(country){return country.code.toUpperCase()===telCountry.code.toUpperCase();});phoneExample=apiCountry&&apiCountry["phone-number"];var code="+"+telCountry.phoneCode;if(phoneExample&&phoneExample.indexOf(code)>-1){phoneExample=phoneExample.slice(code.length).trim();}}return phoneExample;}function isAndroidAppMessagingAvailable(){return window.nativeInterface!=null&&window.nativeInterface.onFacebookLoginClick!=null;}function isIOSAppMessagingAvailable(){return window.webkit!=null&&window.webkit.messageHandlers!=null&&window.webkit.messageHandlers["nativeInterface"]!=null;}var useNativeInterface=function useNativeInterface(){var fnName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var data=arguments[1];try{if(window.nativeInterface!=null&&typeof window.nativeInterface[fnName]==="function"){window.nativeInterface[fnName](data);}if(isIOSAppMessagingAvailable()){window.webkit.messageHandlers["nativeInterface"].postMessage(JSON.stringify({function:fnName,param:data}));}}catch(error){console.log(error);}};var RegisterMain=function(_React$Component){_inherits(RegisterMain,_React$Component);function RegisterMain(){var _ref14,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RegisterMain);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref14=RegisterMain.__proto__||Object.getPrototypeOf(RegisterMain)).call.apply(_ref14,[this].concat(args))),_this),_this.state={shouldShowPhoneHint:true,pending:null,submitTimeError:null,responseTimeError:null,showPhoneInfo:false,agreeError:null,emailError:null,countryError:null,telError:null,passwordError:null},_this.register=function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _this$props,email,phone,password,agree,agreeDailyMail,country,ref_user,location,locale,phoneCode,tel,telValidation,submitTimeError,errors,phoneExample,apiCountry,origin,statistics,credentials,response,query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this$props=_this.props,email=_this$props.email,phone=_this$props.tel,password=_this$props.password,agree=_this$props.agree,agreeDailyMail=_this$props.agreeDailyMail,country=_this$props.country,ref_user=_this$props.ref_user,location=_this$props.location,locale=_this$props.locale;phoneCode=_this.state.telCountry&&_this.state.telCountry.phoneCode;tel=phone;if(phoneCode){tel=Object(__WEBPACK_IMPORTED_MODULE_22__ReVerification_Phone_PhoneInput__["e" /* ripOffLeadingZero */])(phoneCode,phone);}Object(__WEBPACK_IMPORTED_MODULE_27__GA__["a" /* gaReducer */])("CLICKBTN_REGISTER_MAINPAGE",{userId:"N/A"});telValidation=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].tel(tel);submitTimeError=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].agree(agree)||__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].emptyFields(email,country,password,tel)||__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].emailFull(email)||__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].country(country)||telValidation||__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].password(password);errors={};errors.agreeError=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].agree(agree);errors.emailError=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].emailFull(email);errors.countryError=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].country(country);errors.passwordError=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].password(password);errors.telError=telValidation;if(!submitTimeError){_context.next=17;break;}if(submitTimeError===telValidation){phoneExample="";if(_this.state.telCountry){apiCountry=_this.props.apiCountries.find(function(country){return country.code.toUpperCase()===_this.state.telCountry.code.toUpperCase();});phoneExample=apiCountry&&apiCountry["phone-number"];}if(typeof _this.props.logPhoneErrors==="function"){_this.props.logPhoneErrors({phone:tel,error_msg:"auth: Invalid phone number",source:"registration",phone_example:phoneExample||""});}/* prettier-ignore */_this.setState({telError:phoneExample?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Incorrect phone format! Example: ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Unbreakable,null,phoneExample)):_this.props.gettext(_templateObject33)});}else{_this.setState(errors);}return _context.abrupt("return");case 17:_this.setState({pending:"host"});origin=window.location.hostname+location.pathname;statistics=Object(__WEBPACK_IMPORTED_MODULE_11__Subzero__["d" /* readSignInParameters */])();credentials=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(Object.assign({},statistics,{sub0:Object(__WEBPACK_IMPORTED_MODULE_11__Subzero__["c" /* getSub0 */])(window.location,_this.props.serverData),email:email,password:password,password2:password,currency:country.currency,agree:agree?"on":"off",daily_mail:agreeDailyMail?1:0,phone:tel,locale:locale},location.pathname==="/regbonus"?{origin:origin}:null,ref_user?{ref_user:ref_user}:null,{site_url:window.location.href// reg_scenario: "reg_phone_confirm"
}));_context.prev=21;_context.next=24;return _this.props.fetch("/register?"+credentials,{unstable_dontInferResponse:true});case 24:response=_context.sent;_this.setState({pending:null});_context.t0=response.status;_context.next=_context.t0==="OK"?29:_context.t0==="ERROR"?36:38;break;case 29:_this.props.dispatch({type:"REQUEST_PROFILE"});Object(__WEBPACK_IMPORTED_MODULE_11__Subzero__["b" /* flushSignInParameters */])();Object(__WEBPACK_IMPORTED_MODULE_28__Scorpion__["a" /* submitAppsFlyerParameters */])();if(agreeDailyMail){_this.props.fetch("/profile-update?daily_mail=1",{unstable_dontInferResponse:true});}// if (this.props.match.url === "/regbonus") {
//   this.props.history.push("/");
// }
if(!_this.props.noRedirect){query=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(window.location.search.substring(1));if(!query.redirect||query.redirect==="false"){_this.props.history.push("/trade");}}useNativeInterface("setUserKey",response.user_key);return _context.abrupt("break",39);case 36:_this.setState({responseTimeError:response.message});return _context.abrupt("break",39);case 38:return _context.abrupt("break",39);case 39:_context.next=44;break;case 41:_context.prev=41;_context.t1=_context["catch"](21);console.error(_context.t1);case 44:try{window.oSpP&&window.oSpP.push("Email",email);}catch(error){console.log("Error from sendpulse push service",error);}case 45:case"end":return _context.stop();}}},_callee,_this2,[[21,41]]);}));return function(_x2){return _ref15.apply(this,arguments);};}(),_this.handleInputChange=function(event){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,event.target.name+"Error",null),_defineProperty(_this$setState,"submitTimeError",null),_defineProperty(_this$setState,"responseTimeError",null),_this$setState));_this.props.onInputChange(event);},_this.handlePhoneInputChange=function(event){_this.setState({telError:null,submitTimeError:null,responseTimeError:null});_this.props.onPhoneInputChange(event);},_this.socialAuthGate=function(network,event){//для веб-вью приложения авторизация через FB SDK, которую делает Малышев и редиректит с токеном фб на бэк, где получает наш токен и редиректит на платформу с этим токеном, где авторизуется.
if(network==="fb"){if(isAndroidAppMessagingAvailable()){event.preventDefault();window.nativeInterface.onFacebookLoginClick();}else if(isIOSAppMessagingAvailable()){event.preventDefault();window.webkit.messageHandlers["nativeInterface"].postMessage(JSON.stringify({function:"onFacebookLoginClick"}));}}_this.setState({pending:network});},_this.showInfo=function(){return _this.setState({showPhoneInfo:true});},_this.hideInfo=function(){return _this.setState({showPhoneInfo:false});},_this.getPhoneExample=function(){return getPhoneExample(_this.state.telCountry,_this.props.apiCountries);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RegisterMain,[{key:"render",value:function render(){var _this3=this;var _props=this.props,agree=_props.agree,agreeDailyMail=_props.agreeDailyMail,tel=_props.tel,email=_props.email,password=_props.password,country=_props.country,countryList=_props.countryList,showSocial=_props.showSocial,showDeposit=_props.showDeposit,isDarkPage=_props.isDarkPage;var _state=this.state,pending=_state.pending,agreeError=_state.agreeError,countryError=_state.countryError,emailError=_state.emailError,telError=_state.telError,passwordError=_state.passwordError,submitTimeError=_state.submitTimeError,responseTimeError=_state.responseTimeError;var inputTimeError=__WEBPACK_IMPORTED_MODULE_18__validators__["a" /* default */].email(email);var errorMessage=responseTimeError||submitTimeError||inputTimeError;var urlParams=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.parse(window.location.search.substring(1));var tabs=__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TabContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Tab__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_12__Auth__["c" /* REGISTER_TAB_ID */],isActive:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Registration")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Tab__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_12__Auth__["a" /* LOGIN_TAB_ID */],isActive:false,onClick:function onClick(){return _this3.props.onLeave(__WEBPACK_IMPORTED_MODULE_12__Auth__["a" /* LOGIN_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Log in")));var phoneExample=this.getPhoneExample();return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,!isIronForm&&tabs,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RegisterContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form",{method:"post",id:"registerForm"},isIronForm&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FormText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Create your free account"))),urlParams.subid&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input",{type:"hidden",name:"subid",defaultValue:encodeURIComponent(urlParams.subid)}),urlParams.site_domain&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input",{type:"hidden",name:"site_domain",defaultValue:encodeURIComponent(urlParams.site_domain)}),urlParams.clickid&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input",{type:"hidden",name:"clickid",defaultValue:encodeURIComponent(urlParams.clickid)})," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__Input__["a" /* default */],{tab:"register",type:"email",name:"email",id:"register-email",required:"required",placeholder:this.props.gettext(_templateObject34),value:email,onChange:this.handleInputChange,autocomplete:"email"}),emailError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorMessage__["a" /* default */],{message:emailError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input",{className:"sp_push_custom_data",type:"hidden",name:"Email",value:email}),isIronForm&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InputContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__CountrySelect__["a" /* default */],{name:"country",value:country,options:countryList,onChange:this.handleInputChange})),countryError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorMessage__["a" /* default */],{message:countryError}),__WEBPACK_IMPORTED_MODULE_6__FeatureFlags__["a" /* default */].useCoolPhoneInputOnAuth?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PhoneFieldContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PhoneContainer,null,this.state.showPhoneInfo&&this.state.shouldShowPhoneHint&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PhoneInfo,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__ReVerification_Icons__["a" /* InfoIcon */],null)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InfoText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__ReVerification_Phone_PhoneInput__["a" /* PhoneInputHint */],{countryCode:this.state.telCountry&&this.state.telCountry.code,phoneExample:phoneExample})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CloseInfo,{onClick:this.hideInfo},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"4454.792 3403.601 10.606 10.607"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g",{transform:"translate(3350 3251)"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect",{width:"1",height:"14",fill:"#b5b5b5",transform:"translate(1114.691 152.601) rotate(45)"}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect",{width:"1",height:"14",fill:"#b5b5b5",transform:"translate(1115.398 162.5) rotate(135)"}))))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__ReVerification_Phone_PhoneInput__["b" /* default */],{SelectContainer:PhoneInputContainer,InputContainer:PhoneInputContainer,defaultCountry:this.props.geo,value:tel,onChange:function onChange(_ref16){var country=_ref16.country,phone=_ref16.fullNumber,countryAutoSwitched=_ref16.countryAutoSwitched;_this3.handleInputChange({target:{name:"tel",value:phone}});var countryCode=_this3.state.telCountry&&_this3.state.telCountry.code;var shouldShowPhoneHint=countryAutoSwitched?false:_this3.state.shouldShowPhoneHint;if(!countryAutoSwitched&&country.code!==countryCode){shouldShowPhoneHint=true;}_this3.setState({shouldShowPhoneHint:shouldShowPhoneHint,telCountry:country});}// errorMessage={errorMessage}
,placeholder:this.props.gettext(_templateObject35),showInfo:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__ReVerification_Phone_PhoneInput__["a" /* PhoneInputHint */],null),onFocus:this.showInfo,onBlur:this.hideInfo}))):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__Input__["a" /* default */],{tab:"register",type:"tel",name:"tel",id:"register-phone",required:"required",placeholder:this.props.gettext(_templateObject35),value:tel,onChange:this.handlePhoneInputChange,autocomplete:"tel"}),telError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorMessage__["a" /* default */],{message:telError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__Input__["a" /* default */],{tab:"register",type:"password",name:"password",id:"register-pass",required:"required",placeholder:this.props.gettext(_templateObject36),value:password,onChange:this.handleInputChange}),passwordError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorMessage__["a" /* default */],{message:passwordError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Checkbox,{id:"agreeChk",type:"checkbox",checked:agree,name:"agree",onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckboxLabel,{checked:agree,htmlFor:"agreeChk",isDarkPage:isDarkPage}, false?React.createElement(Gettext,null,"I'm over 18 years old"):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"I'm over 18 years old and I agree with")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TermsLink,{to:"/conditions",target:"_blank",title:this.props.gettext(_templateObject37),onClick:Object(__WEBPACK_IMPORTED_MODULE_10__common_Link__["e" /* isWebApp */])()?this.props.onDismissPopup:null},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Terms and Conditions"))," ",showDeposit&&[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],{key:0},"and")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TermsLink,{key:1,to:"/return-refund-policy",target:"_blank",title:this.props.gettext(_templateObject38),onClick:Object(__WEBPACK_IMPORTED_MODULE_10__common_Link__["e" /* isWebApp */])()?this.props.onDismissPopup:null},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Return and Refund Policy"))," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],{key:2},"and")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TermsLink,{key:3,to:"/privacy-policy",target:"_blank",title:this.props.gettext(_templateObject39),onClick:Object(__WEBPACK_IMPORTED_MODULE_10__common_Link__["e" /* isWebApp */])()?this.props.onDismissPopup:null},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Privacy Policy"))]))),agreeError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorMessage__["a" /* default */],{message:agreeError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckContainer,{style:{margin:"8px 0"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Checkbox,{id:"agreeDailyChk",type:"checkbox",checked:agreeDailyMail,name:"agreeDailyMail",onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckboxLabel,{checked:agreeDailyMail,htmlFor:"agreeDailyChk",isDarkPage:isDarkPage},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Subscribe me to special offers and tutorial content"))),errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__ErrorMessage__["a" /* default */],{message:errorMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SubmitContainer,{showSocial:showSocial,isIntlProject:isIronForm},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__BtnFormSubmit__["a" /* default */],{id:"register",onClick:this.register,loader:pending==="host"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Register"))," ",(showSocial||isIronForm)&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Text,{isIntlProject:isIronForm},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"or register with"))," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__SocialLink__["a" /* default */],{network:"fb",pending:pending==="fb",href:Object(__WEBPACK_IMPORTED_MODULE_19__loginWith__["a" /* default */])("fb",this.props),onClick:function onClick(event){return _this3.socialAuthGate("fb",event);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__SocialLink__["a" /* default */],{network:"gp",pending:pending==="gp",href:Object(__WEBPACK_IMPORTED_MODULE_19__loginWith__["a" /* default */])("gp",this.props),onClick:function onClick(event){return _this3.socialAuthGate("gp",event);}}))),isIronForm&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BackContainer,{isDarkPage:isDarkPage},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Already have an account? Then")," "),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BackToLogin,{onClick:function onClick(){return _this3.props.onLeave(__WEBPACK_IMPORTED_MODULE_12__Auth__["a" /* LOGIN_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"login"))))));}}]);return RegisterMain;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["f" /* mapStateToGettext */])(state),{serverData:state.serverData});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_9__common_withDeposit__["b" /* withDeposit */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_8__common_fetch__["e" /* mapDispatchToFetch */])(RegisterMain))));

/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = trackOnTimeline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ua_parser_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_ua_parser_js__);
var parser=new __WEBPACK_IMPORTED_MODULE_0_ua_parser_js__();var getPlatform=function getPlatform(){try{var os=parser.getOS();switch(os.name){case"iOS":return"iOS";case"Android":return"Android";default:return"Web";}}catch(error){console.log("Get platform error",error);return"No platform";}};var RECORD_DURATION=30*1000;var live=true;// Очень важно, чтобы вначале html странички была строка:
// <script>window.PAGE_LOAD_TIMESTAMP = Date.now();</script>
var pageId=String(Math.random());var platform=getPlatform();var timeline=[{id:pageId,info:"Page Load",type:0,timestamp:window.PAGE_LOAD_TIMESTAMP,platform:platform},{id:pageId,info:"Page Load",type:1,timestamp:Date.now(),platform:platform}];function trackOnTimeline(promise,info){var id=String(Math.random());if(live){timeline.push({id:id,info:info,type:0,timestamp:Date.now(),platform:platform});return promise.then(function(value){timeline.push({id:id,info:info,type:1,timestamp:Date.now(),platform:platform});return value;},function(error){timeline.push({id:id,info:info,type:1,timestamp:Date.now(),platform:platform});throw error;});}else{return promise;}}var timer=window.setTimeout(function(){live=false;fetch(window.CRASH_LOGGER_API_URL+"/wmetrics",{method:"POST",body:JSON.stringify(timeline)}).catch(function(error){console.log(error);window.clearTimeout(timer);});timeline=[];},RECORD_DURATION);

/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: bottom;\n  width: 50%;\n  padding-top: 12px;\n  padding-bottom: 8px;\n  font-size: 0;\n  line-height: 0;\n  box-sizing: border-box;\n  text-align: center;\n  color: #fff;\n  cursor: pointer;\n  opacity: 0.57;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  user-select: none;\n\n  :hover {\n    opacity: 1;\n    background: ",";\n  }\n\n  :first-of-type:hover {\n    border-right-color: ",";\n  }\n\n  :last-of-type:hover {\n    border-left-color: ",";\n  }\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: bottom;\n  width: 50%;\n  padding-top: 12px;\n  padding-bottom: 8px;\n  font-size: 0;\n  line-height: 0;\n  box-sizing: border-box;\n  text-align: center;\n  color: #fff;\n  cursor: pointer;\n  opacity: 0.57;\n  border-left: 1px solid transparent;\n  border-right: 1px solid transparent;\n  user-select: none;\n\n  :hover {\n    opacity: 1;\n    background: ",";\n  }\n\n  :first-of-type:hover {\n    border-right-color: ",";\n  }\n\n  :last-of-type:hover {\n    border-left-color: ",";\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      padding-top: 9px;\n      background: ",";\n      font-size: 0;\n      line-height: 0;\n      color: ",";\n      opacity: 1;\n\n      :hover,\n      :first-of-type:hover,\n      :last-of-type:hover {\n        background: ",";\n        border-color: transparent;\n      }\n    "],["\n      padding-top: 9px;\n      background: ",";\n      font-size: 0;\n      line-height: 0;\n      color: ",";\n      opacity: 1;\n\n      :hover,\n      :first-of-type:hover,\n      :last-of-type:hover {\n        background: ",";\n        border-color: transparent;\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: 18px;\n  line-height: 1.1;\n\n  ",";\n"],["\n  font-size: 18px;\n  line-height: 1.1;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      font-size: 20px;\n    "],["\n      font-size: 20px;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TabView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.accent,0.42);},function(_ref2){var theme=_ref2.theme;return theme.mainDark;},function(_ref3){var theme=_ref3.theme;return theme.mainDark;},function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(_ref4){var theme=_ref4.theme;return theme.accent;},function(_ref5){var theme=_ref5.theme;return theme.mainDark;},function(_ref6){var theme=_ref6.theme;return theme.accent;});});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject3,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});function Tab(_ref7){var id=_ref7.id,isActive=_ref7.isActive,onClick=_ref7.onClick,children=_ref7.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabView,{id:id+"-form-link","data-tab":id,isActive:isActive,onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,{isActive:isActive},children));}/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SocialLink;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_fb_icon_svg__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_fb_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_fb_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_gp_icon_svg__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_gp_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_gp_icon_svg__);
var _templateObject=_taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"],["\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n\n  :before {\n    position: absolute;\n    display: none;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \"\";\n    width: 34px;\n    height: 34px;\n    margin-top: 4px;\n    margin-left: 4px;\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n\n  :after {\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    margin-top: -14px;\n    margin-left: -12px;\n    box-sizing: border-box;\n    width: 28px;\n    height: 28px;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-top: 2px solid #fff;\n    border-radius: 50%;\n    animation: "," 0.5s linear infinite;\n    content: \"\";\n  }\n\n  ",";\n"],["\n  position: relative;\n  display: inline-block;\n\n  :before {\n    position: absolute;\n    display: none;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \"\";\n    width: 34px;\n    height: 34px;\n    margin-top: 4px;\n    margin-left: 4px;\n    border-radius: 4px;\n    background-color: rgba(0, 0, 0, 0.5);\n  }\n\n  :after {\n    position: absolute;\n    display: none;\n    top: 50%;\n    left: 50%;\n    margin-top: -14px;\n    margin-left: -12px;\n    box-sizing: border-box;\n    width: 28px;\n    height: 28px;\n    border: 2px solid rgba(255, 255, 255, 0.5);\n    border-top: 2px solid #fff;\n    border-radius: 50%;\n    animation: "," 0.5s linear infinite;\n    content: \"\";\n  }\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      :before,\n      :after {\n        display: block;\n      }\n    "],["\n      :before,\n      :after {\n        display: block;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  margin: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 34px;\n  height: 34px;\n  text-indent: 100%;\n  border-radius: 4px;\n  background: #9e9e9e;\n  cursor: pointer;\n\n  :disabled {\n    cursor: default;\n    opacity: 0.9;\n  }\n\n  :last-of-type {\n    margin-right: 0;\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  margin: 4px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 34px;\n  height: 34px;\n  text-indent: 100%;\n  border-radius: 4px;\n  background: #9e9e9e;\n  cursor: pointer;\n\n  :disabled {\n    cursor: default;\n    opacity: 0.9;\n  }\n\n  :last-of-type {\n    margin-right: 0;\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      background: #4e66a9 url(",") center no-repeat;\n      background-size: 7px 14px;\n    "],["\n      background: #4e66a9 url(",") center no-repeat;\n      background-size: 7px 14px;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      background: #d54934 url(",") center no-repeat;\n      background-size: 18px 12px;\n    "],["\n      background: #d54934 url(",") center no-repeat;\n      background-size: 18px 12px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      background: url(",") center no-repeat;\n      background-size: 11px 22px;\n    "],["\n      background: url(",") center no-repeat;\n      background-size: 11px 22px;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n      background: url(",") center no-repeat;\n      background-size: 34px 22px;\n    "],["\n      background: url(",") center no-repeat;\n      background-size: 34px 22px;\n    "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import Facebook2 from "../../images/fb-icon-2.svg";
// import Google2 from "../../images/gp-icon-2.svg";
var spin=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Loader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,spin,function(props){return props.pending&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var SocialButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].a(_templateObject4,function(props){return props.network==="fb"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,__WEBPACK_IMPORTED_MODULE_2__images_fb_icon_svg___default.a);},function(props){return props.network==="gp"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,__WEBPACK_IMPORTED_MODULE_3__images_gp_icon_svg___default.a);},function(_ref){var theme=_ref.theme,network=_ref.network;return theme.newIndex&&network==="fb"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,__WEBPACK_IMPORTED_MODULE_2__images_fb_icon_svg___default.a);},function(_ref2){var theme=_ref2.theme,network=_ref2.network;return theme.newIndex&&network==="gp"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8,__WEBPACK_IMPORTED_MODULE_3__images_gp_icon_svg___default.a);});function SocialLink(_ref3){var network=_ref3.network,pending=_ref3.pending,props=_objectWithoutProperties(_ref3,["network","pending"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Loader,{pending:pending},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SocialButton,Object.assign({network:network},props,{rel:"nofollow"}),network));}

/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HistoryPages_Select__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Flag__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_country_svg__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_country_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_country_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  height: ",";\n  min-width: 11.25em;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n\n  .react-select__menu {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .react-select__control {\n    height: 100%;\n    width: 100%;\n    font-size: inherit;\n    line-height: inherit;\n    color: ",";\n    border: 1px solid #cccccc;\n    border-radius: 3px;\n    background-color: #f6f6f6;\n    box-shadow: inset 0px 2px 0px 0px #e3e3e3;\n\n    :hover {\n      box-shadow: inset 0px 2px 0px 0px #e3e3e3;\n    }\n\n    ",";\n  }\n\n  .react-select__value-container {\n    height: 100%;\n    align-content: center;\n  }\n\n  .react-select__dropdown-indicator {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    height: 40px;\n    font-size: ",";\n  }\n"],["\n  height: ",";\n  min-width: 11.25em;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n\n  .react-select__menu {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .react-select__control {\n    height: 100%;\n    width: 100%;\n    font-size: inherit;\n    line-height: inherit;\n    color: ",";\n    border: 1px solid #cccccc;\n    border-radius: 3px;\n    background-color: #f6f6f6;\n    box-shadow: inset 0px 2px 0px 0px #e3e3e3;\n\n    :hover {\n      box-shadow: inset 0px 2px 0px 0px #e3e3e3;\n    }\n\n    ",";\n  }\n\n  .react-select__value-container {\n    height: 100%;\n    align-content: center;\n  }\n\n  .react-select__dropdown-indicator {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    height: 40px;\n    font-size: ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n        min-height: 50px;\n        background-color: rgba(255, 255, 255, 0.25);\n        border-color: transparent;\n        border-radius: 25px;\n        box-shadow: none;\n\n        :hover,\n        :focus,\n        :active {\n          border-color: transparent;\n          box-shadow: none;\n        }\n\n        @media (max-width: 959px) {\n          min-height: 0;\n        }\n\n        ",";\n      "],["\n        min-height: 50px;\n        background-color: rgba(255, 255, 255, 0.25);\n        border-color: transparent;\n        border-radius: 25px;\n        box-shadow: none;\n\n        :hover,\n        :focus,\n        :active {\n          border-color: transparent;\n          box-shadow: none;\n        }\n\n        @media (max-width: 959px) {\n          min-height: 0;\n        }\n\n        ",";\n      "]),_templateObject3=_taggedTemplateLiteral(["\n            background-color: rgba(255, 255, 255, 0.25) !important;\n            border-color: #fff;\n            border-radius: 25px 25px 0 0;\n\n            :hover,\n            :focus,\n            :active {\n              border-color: #fff;\n            }\n          "],["\n            background-color: rgba(255, 255, 255, 0.25) !important;\n            border-color: #fff;\n            border-radius: 25px 25px 0 0;\n\n            :hover,\n            :focus,\n            :active {\n              border-color: #fff;\n            }\n          "]),_templateObject4=_taggedTemplateLiteral(["\n        color: #fff;\n        opacity: 0.5;\n\n        :hover {\n          color: #fff;\n          opacity: 1;\n        }\n\n        ",";\n      "],["\n        color: #fff;\n        opacity: 0.5;\n\n        :hover {\n          color: #fff;\n          opacity: 1;\n        }\n\n        ",";\n      "]),_templateObject5=_taggedTemplateLiteral(["\n            color: #fff;\n            opacity: 1;\n          "],["\n            color: #fff;\n            opacity: 1;\n          "]),_templateObject6=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  ",";\n  font-weight: 600;\n  font-size: ",";\n  color: ",";\n"],["\n  ",";\n  font-weight: 600;\n  font-size: ",";\n  color: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  ",";\n  font-size: ",";\n  line-height: 20px;\n  ",";\n  color: #757575;\n  background: url(",") no-repeat 2px 50%;\n\n  ",";\n"],["\n  display: flex;\n  ",";\n  font-size: ",";\n  line-height: 20px;\n  ",";\n  color: #757575;\n  background: url(",") no-repeat 2px 50%;\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n      ",";\n      color: #ffffff;\n      background: none;\n    "],["\n      ",";\n      color: #ffffff;\n      background: none;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: center;\n  text-align: left;\n\n  ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: center;\n  text-align: left;\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n      color: #fff;\n    "],["\n      color: #fff;\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  padding: ",";\n  color: #343434;\n  box-sizing: border-box;\n  cursor: pointer;\n\n  :hover {\n    color: #fff;\n    background-color: #3498db;\n\n    "," {\n      color: #fff;\n    }\n  }\n\n  ",";\n"],["\n  padding: ",";\n  color: #343434;\n  box-sizing: border-box;\n  cursor: pointer;\n\n  :hover {\n    color: #fff;\n    background-color: #3498db;\n\n    "," {\n      color: #fff;\n    }\n  }\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      background-color: #e3e3e3;\n      pointer-events: none;\n    "],["\n      background-color: #e3e3e3;\n      pointer-events: none;\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Select=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__HistoryPages_Select__["a" /* default */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.newIndex?"50px":"40px";},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(16),function(_ref2){var theme=_ref2.theme;return theme.inputColor;},function(_ref3){var theme=_ref3.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2,function(_ref4){var menuIsOpen=_ref4.menuIsOpen;return menuIsOpen&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject3);});},function(_ref5){var theme=_ref5.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,function(_ref6){var menuIsOpen=_ref6.menuIsOpen;return menuIsOpen&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5);});},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14));var Flag=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Flag__["h" /* default */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-right","17px"));var Currency=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-left","6px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12),function(_ref7){var theme=_ref7.theme,isOption=_ref7.isOption;return isOption?theme.mode==="light"?"#1B546A":"#959595":theme.mode==="light"?theme.authCurrencyCodeColor:"#959595";});var PlaceholderView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("padding-left","37px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("text-align","left"),__WEBPACK_IMPORTED_MODULE_5__images_country_svg___default.a,function(_ref8){var theme=_ref8.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("padding-left","10px"));});var ValueOption=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10,function(_ref9){var theme=_ref9.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject11);});var _Option=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(ValueOption)(_templateObject12,function(_ref10){var code=_ref10.code;return code==="world"?"4px 10px":"8px 10px";},Currency,function(_ref11){var isSelected=_ref11.isSelected;return isSelected&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject13);});var Placeholder=function Placeholder(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PlaceholderView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Country/Region"));};var CountryOption=function CountryOption(_ref12){var label=_ref12.label,currency=_ref12.currency,code=_ref12.code,isOption=_ref12.isOption;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{country:code}),label,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Currency,{isOption:isOption},"(",currency,")"));};var CountrySelect=function(_React$Component){_inherits(CountrySelect,_React$Component);function CountrySelect(){var _ref13;var _temp,_this,_ret;_classCallCheck(this,CountrySelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref13=CountrySelect.__proto__||Object.getPrototypeOf(CountrySelect)).call.apply(_ref13,[this].concat(args))),_this),_this.state={menuIsOpen:false},_this.handleMenuEvent=function(menuIsOpen){_this.setState({menuIsOpen:menuIsOpen});},_this.handleChange=function(value){_this.props.onChange({target:{name:_this.props.name,value:value}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CountrySelect,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Select,{classNamePrefix:"react-select",isRtl:theme.direction==="rtl",value:_this2.props.value,options:_this2.props.options,menuIsOpen:_this2.state.menuIsOpen,onMenuOpen:function onMenuOpen(){return _this2.handleMenuEvent(true);},onMenuClose:function onMenuClose(){return _this2.handleMenuEvent(false);},components:{SingleValue:function SingleValue(_ref14){var innerProps=_ref14.innerProps,data=_ref14.data;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValueOption,innerProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CountryOption,data));},Option:function Option(_ref15){var innerProps=_ref15.innerProps,isSelected=_ref15.isSelected,data=_ref15.data;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](_Option,Object.assign({},innerProps,{isSelected:isSelected,code:data.code}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CountryOption,Object.assign({},data,{isOption:true})));}},onChange:_this2.handleChange,placeholder:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,null)});});}}]);return CountrySelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CountrySelect);

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(185)))

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addClass;

var _hasClass = __webpack_require__(1266);

var _hasClass2 = _interopRequireDefault(_hasClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass2.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}
module.exports = exports['default'];

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(30));

var _reactLifecyclesCompat = __webpack_require__(102);

var _PropTypes = __webpack_require__(588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts(); // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing); // FIXME: appear timeout?


      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    var pt = process.env.NODE_ENV !== "production" ? _PropTypes.timeoutsShape : {};;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.transitionTimeout = transitionTimeout;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(6));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;
  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.'); // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number
}).isRequired]);

exports.timeoutsShape = timeoutsShape;

var classNamesShape = _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]);

exports.classNamesShape = classNamesShape;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(102);

var _ChildMapping = __webpack_require__(1268);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes.default.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes.default.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes.default.func
} : {};;
var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: {
        isMounting: !this.appeared
      }
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return {
        children: children
      };
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);

    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }

    return _react.default.createElement(Component, props, children);
  };

  return TransitionGroup;
}(_react.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes.default.object.isRequired
};
TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

var _default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"version":"1.6.4","country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"800":["001"],"808":["001"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"870":["001"],"878":["001"],"880":["BD"],"881":["001"],"882":["001"],"883":["001"],"886":["TW"],"888":["001"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"979":["001"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[136-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[136-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"264"],"AL":["355","00","(?:(?:[2-58]|6\\d)\\d\\d|700)\\d{5}|(?:8\\d{2,3}|900)\\d{3}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[23]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-7]|88|9[13-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]"],"0 $1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|(?:[2368]|9\\d)\\d)\\d{8}",[10,11],[["([68]\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"]],["(9)(11)(\\d{4})(\\d{4})","$2 15-$3-$4",["911"],0,0,"$1 $2 $3-$4"],["(9)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9(?:2[2-4689]|3[3-8])","9(?:2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578]))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))","9(?:2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45])))"],0,0,"$1 $2 $3-$4"],["(9)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9[23]"],0,0,"$1 $2 $3-$4"],["(11)(\\d{4})(\\d{4})","$1 $2-$3",["11"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["2(?:2[013]|3[067]|49|6[01346]|8|9[147-9])|3(?:36|4[1-358]|5[138]|6|7[069]|8[013578])","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3[4-6]|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))","2(?:2(?:0[013-9]|[13])|3(?:0[013-9]|[67])|49|6(?:[0136]|4[0-59])|8|9(?:[19]|44|7[013-9]|8[14]))|3(?:36|4(?:[12]|3(?:4|5[014]|6[1-39])|[58]4)|5(?:1|3[0-24-689]|8[46])|6|7[069]|8(?:[01]|34|[578][45]))"],0,1],["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["[23]"],0,1]],"0","0$1","0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))?15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,0,0,0,"684"],"AT":["43","00","[1-35-9]\\d{8,12}|4(?:[0-24-9]\\d{4,11}|3(?:[05]\\d{3,10}|[2-467]\\d{3,4}|8\\d{3,6}|9\\d{3,7}))|[1-35-8]\\d{7}|[1-35-7]\\d{5,6}|[15]\\d{4}|1\\d{3}",[4,5,6,7,8,9,10,11,12,13],[["(116\\d{3})","$1",["116"],"$1"],["(1)(\\d{3,12})","$1 $2",["1"]],["(5\\d)(\\d{3,5})","$1 $2",["5[079]"]],["(5\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["5[079]"]],["(5\\d)(\\d{4})(\\d{4,7})","$1 $2 $3",["5[079]"]],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:[28]0|32)|[89]"]],["(\\d{3})(\\d{2})","$1 $2",["517"]],["(\\d{4})(\\d{3,9})","$1 $2",["2|3(?:1[1-578]|[3-8])|4[2378]|5[2-6]|6(?:[12]|4[1-9]|5[468])|7(?:[24][1-8]|35|[5-79])"]]],"0","0$1"],"AU":["61","(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011)|001[14-689]","1\\d{4,9}|(?:[2-478]\\d\\d|550)\\d{6}",[5,6,7,8,9,10],[["([2378])(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|[45]"],"0$1"],["(16)(\\d{3,4})","$1 $2",["16"],"0$1"],["(16)(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(1[389]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["1[389]0","1(?:[38]0|9)0"]],["(180)(2\\d{3})","$1 $2",["180","1802"]],["(19\\d)(\\d{3})","$1 $2",["19[13]"]],["(19\\d{2})(\\d{4})","$1 $2",["19[679]"]],["(13)(\\d{2})(\\d{2})","$1 $2 $3",["13[1-9]"]]],"0",0,0,0,0,0,[["[237]\\d{8}|8(?:51(?:0(?:0[03-9]|[1247]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-6])|1(?:1[69]|[23]\\d|4[0-4]))|[6-8]\\d{4}|9(?:[02-9]\\d{3}|1(?:[0-57-9]\\d{2}|6[0135-9]\\d)))\\d{3}",[9]],["4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2457-9]|9[017-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["19(?:0[0126]\\d|[679])\\d{5}",[8,10]],0,0,0,["16\\d{3,7}",[5,6,7,8,9]],["(?:14(?:5\\d|71)|550\\d)\\d{5}",[9]],["13(?:00\\d{3}|45[0-4]|\\d)\\d{3}",[6,8,10]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:11|3[23]|41|5[59]|77|88|9[09]))","(?:(?:[1247]\\d|3[0-46-9]|[56]0)\\d\\d|800)\\d{4,6}|(?:[1-47]\\d|50)\\d{4,5}|2\\d{4}",[5,6,7,8,9,10],0,"0",0,0,0,0,0,[["18[1-8]\\d{3,6}",[6,7,8,9]],["(?:4[0-8]|50)\\d{4,8}",[6,7,8,9,10]],["800\\d{4,6}",[7,8,9]],["[67]00\\d{5,6}",[8,9]],0,0,["10\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|3[09]\\d{4,8}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})"]],"00"],"AZ":["994","00","(?:(?:(?:[12457]\\d|60|88)\\d|365)\\d{3}|900200)\\d{3}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|365","[12]|365","[12]|365(?:[0-46-9]|5[0-35-9])"],"(0$1)"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[3-8]"],"0$1"]],"0"],"BA":["387","00","(?:[3589]\\d|49|6\\d\\d?|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-356]|[7-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"246"],"BD":["880","00","[13469]\\d{9}|8[0-79]\\d{7,8}|[2-7]\\d{8}|[2-9]\\d{7}|[3-689]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(2)(\\d{7,8})","$1-$2",["2"]],["(\\d{2})(\\d{4,6})","$1-$2",["[3-79]1"]],["(\\d{4})(\\d{3,6})","$1-$2",["1|3(?:0|[2-58]2)|4(?:0|[25]2|3[23]|[4689][25])|5(?:[02-578]2|6[25])|6(?:[0347-9]2|[26][25])|7[02-9]2|8(?:[023][23]|[4-7]2)|9(?:[02][23]|[458]2|6[01367])"]],["(\\d{3})(\\d{3,7})","$1-$2",["[3-79][2-9]|8"]]],"0","0$1"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4[23]|9[2-4]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-7]|8(?:0[2-8]|[1-79])"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[25-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[25-7]"]]]],"BG":["359","00","[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|70[1-9]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["7|80"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1367]|8[047]|9[014578]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|6[189]|7[125-9]"]]]],"BJ":["229","00","[2689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"]]]],"BL":["590","00","(?:590|69\\d)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(1\\d)?","(?:[2-467]\\d{3}|80017)\\d{4}",[8,9],[["([234])(\\d{7})","$1 $2",["[2-4]"]],["([67]\\d{7})","$1",["[67]"]],["(800)(\\d{2})(\\d{4})","$1 $2 $3",["800"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-24679]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","300|4(?:0(?:0|20)|370)"]],["([3589]00)(\\d{2,3})(\\d{4})","$1 $2 $3",["[3589]00"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["[1-9][1-9]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[1-9][1-9]9"],"($1)"]],"0",0,"0(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[23568]|4[5-7]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:(?:[2-6]|7\\d)\\d|90)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-6]"]],["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["17[0-3589]|2[4-9]|[34]","17(?:[02358]|1[0-2]|9[0189])|2[4-9]|[34]"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:5[24]|6[235]|7[467])|2(?:1[246]|2[25]|3[26])","1(?:5[24]|6(?:2|3[04-9]|5[0346-9])|7(?:[46]|7[37-9]))|2(?:1[246]|2[25]|3[26])"],"8 0$1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["([89]\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[01]|9"],"8 $1"],["(82\\d)(\\d{4})(\\d{4})","$1 $2 $3",["82"],"8 $1"],["(800)(\\d{3})","$1 $2",["800"],"8 $1"],["(800)(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"]],"8",0,"8?0?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}",[10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50)|3(?:06|43|65)|4(?:03|1[68]|3[178]|50)|5(?:06|1[49]|48|79|8[17])|6(?:04|13|39|47)|7(?:0[59]|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["(?:5(?:00|2[12]|33|44|66|77|88)|622)[2-9]\\d{6}"],0,0,0,["600[2-9]\\d{6}"]]],"CC":["61","(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","1\\d{5,9}|(?:[48]\\d\\d|550)\\d{6}",[6,7,8,9,10],0,"0",0,0,0,0,0,[["8(?:51(?:0(?:02|31|60)|118)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:08|22|68)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2547-9]|9[017-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["19(?:0[0126]\\d|[679])\\d{5}",[8,10]],0,0,0,0,["(?:14(?:5\\d|71)|550\\d)\\d{5}",[9]],["13(?:00\\d{3}|45[0-4]|\\d)\\d{3}",[6,8,10]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","(?:(?:0\\d|80)\\d|222)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["801"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]|[89]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|9"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02-8]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[02-8]"]]]],"CK":["682","00","[2-8]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-8]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[0-57]|5[13-58]|69|7[0167]|8[018]))0","(?:1230|[2-57-9]\\d|6\\d{1,3})\\d{7}",[9,10,11],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[23]"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[357]|4[1-35]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(9)(\\d{4})(\\d{4})","$1 $2 $3",["9"]],["(44)(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["([68]00)(\\d{3})(\\d{3,4})","$1 $2 $3",["[68]00"]],["(600)(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["600"]],["(1230)(\\d{3})(\\d{4})","$1 $2 $3",["123","1230"]],["(\\d{5})(\\d{4})","$1 $2",["219"],"($1)"]]],"CM":["237","00","(?:[26]\\d\\d|88)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]"]]]],"CN":["86","(?:1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))?00","(?:(?:(?:1[03-68]|2\\d)\\d\\d|[3-79])\\d|8[0-57-9])\\d{7}|[1-579]\\d{10}|8[0-57-9]\\d{8,9}|[1-79]\\d{9}|[1-9]\\d{7}|[12]\\d{6}",[7,8,9,10,11,12],[["([48]00)(\\d{3})(\\d{4})","$1 $2 $3",["[48]00"]],["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2\\d)[19]","(?:10|2\\d)(?:10|9[56])","(?:10|2\\d)(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["[3-9]","[3-9]\\d\\d[19]","[3-9]\\d\\d(?:10|9[56])"],"0$1"],["(21)(\\d{4})(\\d{4,6})","$1 $2 $3",["21"],"0$1",1],["([12]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["10[1-9]|2[02-9]","10[1-9]|2[02-9]","10(?:[1-79]|8(?:0[1-9]|[1-9]))|2[02-9]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:1[02-9]|35|49|5|7[02-68]|9[1-68])|4(?:1[02-9]|2[179]|[35][2-9]|6[47-9]|7|8[23])|5(?:3[03-9]|4[36]|5[02-9]|6[1-46]|7[028]|80|9[2-46-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[04-9]|4[3-6]|6[2368])|8(?:1[236-8]|2[5-7]|3|5[1-9]|7[02-9]|8[36-8]|9[1-7])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3(?:11|7[179])|4(?:[15]1|3[1-35])|5(?:1|2[37]|3[12]|51|7[13-79]|9[15])|7(?:[39]1|5[457]|6[09])|8(?:[57]1|98)"],"0$1",1],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["807","8078"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1(?:[3-57-9]|66)"]],["(10800)(\\d{3})(\\d{4})","$1 $2 $3",["108","1080","10800"]],["(\\d{3})(\\d{7,8})","$1 $2",["950"]]],"0",0,"0|(1(?:[12]\\d{3}|79\\d{2}|9[0-7]\\d{2}))",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:1\\d|3)\\d{9}|[124-8]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1 $2",["1(?:[2-7]|8[2-9]|9[0-3])|[24-8]","1(?:[2-7]|8[2-9]|9(?:09|[1-3]))|[24-8]"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3"]],["(1)(\\d{3})(\\d{7})","$1-$2-$3",["1(?:80|9[04])","1(?:800|9(?:0[01]|4[78]))"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:44|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|[24-8]\\d{7}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[24-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]0"]]],0,0,"(19(?:0[012468]|1[09]|20|66|77|99))"],"CU":["53","119","[2-57]\\d{7}|[2-47]\\d{6}|[34]\\d{5}",[6,7,8],[["(\\d)(\\d{6,7})","$1 $2",["7"]],["(\\d{2})(\\d{4,6})","$1 $2",["[2-4]"]],["(\\d)(\\d{7})","$1 $2",["5"],"0$1"]],"0","(0$1)"],"CV":["238","0","[2-59]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-59]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","(?:14(?:1[14]|34|4[17]|[56]6|7[47]|88))?001[14-689]","1\\d{5,9}|(?:[48]\\d\\d|550)\\d{6}",[6,7,8,9,10],0,"0",0,0,0,0,0,[["8(?:51(?:0(?:01|30|59)|117)|91(?:00[6-9]|1(?:21|49|78|81)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[6-9]|7[02-9]|8[0-2547-9]|9[017-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["19(?:0[0126]\\d|[679])\\d{5}",[8,10]],0,0,0,0,["(?:14(?:5\\d|71)|550\\d)\\d{5}",[9]],["13(?:00\\d{3}|45[0-4]|\\d)\\d{3}",[6,8,10]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60|9\\d{1,4})\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9[36]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["96"]]]],"DE":["49","00","(?:1|[358]\\d{11})\\d{3}|[1-35689]\\d{13}|4(?:[0-8]\\d{5,12}|9(?:[05]\\d|44|6[1-8])\\d{9})|[1-35-9]\\d{6,12}|49(?:[0-357]\\d|[46][1-8])\\d{4,8}|49(?:[0-3579]\\d|4[1-9]|6[0-8])\\d{3}|[1-9]\\d{5}|[13-68]\\d{4}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(1\\d{2})(\\d{7,8})","$1 $2",["1[67]"]],["(15\\d{3})(\\d{6})","$1 $2",["15[0568]"]],["(1\\d{3})(\\d{7})","$1 $2",["15"]],["(\\d{2})(\\d{3,11})","$1 $2",["3[02]|40|[68]9"]],["(\\d{3})(\\d{3,11})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)","2(?:0[1-389]|1(?:[14]|2[0-8])|2[18]|3[14]|[4-9]1)|3(?:[35-9][15]|4[015])|[4-8][1-9]1|9(?:06|[1-9]1)"]],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|[7-9](?:0[1-9]|[1-9])","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|[46][1246]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|3[1357]|4[13578]|6[1246]|7[1356]|9[1346])|5(?:0[14]|2[1-3589]|3[1357]|[49][1246]|6[1-4]|7[13468]|8[13568])|6(?:0[1356]|2[1-489]|3[124-6]|4[1347]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|3[1357]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|4[1347]|6[0135-9]|7[1467]|8[136])|9(?:0[12479]|2[1358]|3[1357]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|[7-9](?:0[1-9]|[1-9])"]],["(3\\d{4})(\\d{1,10})","$1 $2",["3"]],["(800)(\\d{7,12})","$1 $2",["800"]],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:37|80)|900","1(?:37|80)|900[1359]"]],["(1\\d{2})(\\d{5,11})","$1 $2",["181"]],["(18\\d{3})(\\d{6})","$1 $2",["185","1850","18500"]],["(18\\d{2})(\\d{7})","$1 $2",["18[68]"]],["(18\\d)(\\d{8})","$1 $2",["18[2-579]"]],["(700)(\\d{4})(\\d{4})","$1 $2 $3",["700"]],["(138)(\\d{4})","$1 $2",["138"]],["(15[013-68])(\\d{2})(\\d{8})","$1 $2 $3",["15[013-68]"]],["(15[279]\\d)(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"]],["(1[67]\\d)(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"]]],"0","0$1"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,0,0,0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"]],"0"],"EC":["593","00","1800\\d{6,7}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[247]|[356][2-8]"],0,0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(1800)(\\d{3})(\\d{3,4})","$1 $2 $3",["180","1800"],"$1"]],"0","(0$1)"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d\\d|900)\\d{4}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-4])","[45]|8(?:00[1-9]|[1-4])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["80"]]]],"EG":["20","00","(?:[189]\\d?|[24-6])\\d{8}|[13]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"]],["(\\d{2})(\\d{6,7})","$1 $2",["1(?:3|5[239])|[4-6]|[89][2-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1[0-25]|[89]00"]]],"0","0$1"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3"]],"0","0$1"],"ES":["34","00","(?:51|[6-9]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[568]|7[0-48]|9(?:0[12]|[1-8])"]]]],"ET":["251","00","(?:11|[2-59]\\d)\\d{7}",[9],[["([1-59]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[1-59]"]]],"0","0$1"],"FI":["358","00|99(?:[01469]|5(?:11|3[23]|41|5[59]|77|88|9[09]))","(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}|[1-35689]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[6-8])0"]],["(75\\d{3})","$1",["75[12]"]],["(116\\d{3})","$1",["116"],"$1"],["(\\d{2})(\\d{4,10})","$1 $2",["[14]|2[09]|50|7[135]"]],["(\\d)(\\d{4,11})","$1 $2",["[25689][1-8]|3"]]],"0","0$1",0,0,0,0,[["(?:1[3-79][1-8]|[235689][1-8]\\d)\\d{2,6}",[5,6,7,8,9]],["(?:4[0-8]|50)\\d{4,8}",[6,7,8,9,10]],["800\\d{4,6}",[7,8,9]],["[67]00\\d{5,6}",[8,9]],0,0,["10\\d{4,8}|2(?:0(?:[016-8]\\d{3,7}|[2-59]\\d{2,7})|9\\d{4,8})|3[09]\\d{4,8}|60(?:[12]\\d{5,6}|6\\d{7})|7(?:1\\d{7}|3\\d{8}|5[03-9]\\d{3,7})"]],"00"],"FJ":["679","0(?:0|52)","(?:(?:0800\\d|[235-9])\\d|45)\\d{5}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","[39]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3(?:20|[357])|9","3(?:20[1-9]|[357])|9"]]]],"FO":["298","00","(?:[2-8]\\d|90)\\d{4}",[6],[["(\\d{6})","$1"]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["([1-79])(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"]],["(8\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"]],"0","0$1"],"GA":["241","00","(?:0\\d|[2-7])\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]]]],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(7\\d{3})(\\d{6})","$1 $2",["7(?:[1-57-9]|62)","7(?:[1-57-9]|624)"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2|5[56]|7[06]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:[02-9]1|1)|3|9[018]"]],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"]],["(1\\d{3})(\\d{5,6})","$1 $2",["1"]],["(800)(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"]],["(845)(46)(4\\d)","$1 $2 $3",["845","8454","84546","845464"]],["(8\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8(?:4[2-5]|7[0-3])"]],["(80\\d)(\\d{3})(\\d{4})","$1 $2 $3",["80"]],["(800)(\\d{6})","$1 $2",["800"]]],"0","0$1",0,0,0,0,[["2(?:0[01378]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{7}|1(?:1(?:3[0-58]|4[0-5]|5[0-26-9]|6[0-4]|[78][0-49])|21[0-7]|31[0-8]|[4-69]1\\d)\\d{6}|1(?:2(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)|3(?:0\\d|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[28][02-57-9]|[37]\\d|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|2[024-9]|3[015689]|4[02-9]|5[03-9]|6\\d|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0124578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|8\\d|9[2-57]))\\d{6}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[345])))|3(?:638[2-5]|647[23]|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[123]))|5(?:24(?:3[2-79]|6\\d)|276\\d|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[567]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|955[0-4])|7(?:26(?:6[13-9]|7[0-7])|442\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|84(?:3[2-58]))|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}|176888[2-46-8]\\d{2}|16977[23]\\d{3}",[9,10]],["7(?:[1-3]\\d{3}|4(?:[0-46-9]\\d{2}|5(?:[0-689]\\d|7[0-57-9]))|5(?:0[0-8]|[13-9]\\d|2[0-35-9])\\d|7(?:0(?:0[01]|[1-9]\\d)|[1-7]\\d{2}|8[02-9]\\d|9[0-689]\\d)|8(?:[014-9]\\d|[23][0-8])\\d|9(?:[024-9]\\d{2}|1(?:[02-9]\\d|1[028])|3[0-689]\\d))\\d{5}",[10]],["80(?:0(?:1111|\\d{6,7})|8\\d{7})"],["(?:87[123]|9(?:[01]\\d|8[2349]))\\d{7}",[10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",[10]],["56\\d{8}",[10]],["8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",[7,10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5|790"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"GF":["594","00","[56]94\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,0,0,0,0,[["1481[25-9]\\d{5}",[10]],["7(?:781\\d|839\\d|911[17])\\d{5}",[10]],["80(?:0(?:1111|\\d{6,7})|8\\d{7})"],["(?:87[123]|9(?:[01]\\d|8[0-3]))\\d{7}",[10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}",[10]],["56\\d{8}",[10]],["8(?:4(?:5464\\d|[2-5]\\d{7})|70\\d{7})",[7,10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{5})","$1 $2",["8"]]],"0","0$1"],"GI":["350","00","(?:[25]\\d\\d|629)\\d{5}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-689]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","(?:30|6\\d\\d|722)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","(?:590|69\\d)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|1[0-2]|2[0-68]|3[1289]|4[0-24-9]|5[3-579]|6[0189]|7[08]|8[0-689]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"]]],"GQ":["240","00","(?:222|(?:3\\d|55|[89]0)\\d)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","(?:[268]\\d|[79]0)\\d{8}",[10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["2[3-8]1|[689]"]],["(\\d{4})(\\d{6})","$1 $2",["2"]]]],"GT":["502","00","(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,0,0,0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:(?:(?:[2-46]\\d|77)\\d|862)\\d|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-46-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4}(?:\\d(?:\\d(?:\\d{4})?)?)?|(?:[235-79]\\d|46)\\d{6}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","[237-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(1)(\\d{4})(\\d{3})","$1 $2 $3",["1"]],["([2-5]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"]],["(9\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]],["(6[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"]],["([67]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"]],["(80[01])(\\d{2})(\\d{2,3})","$1 $2 $3",["80[01]"]],["(80[01])(\\d{3})(\\d{3})","$1 $2 $3",["80[01]"]]],"0","0$1"],"HT":["509","00","[2-489]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-489]"]]]],"HU":["36","00","[2357]\\d{8}|[1-9]\\d{7}",[8,9],[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"]]],"06","($1)"],"ID":["62","0(?:0[17-9]|10(?:00|1[67]))","(?:[1-36]|8\\d{5})\\d{6}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,8})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-579]|6[2-5]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","[148]\\d{9}|[124-9]\\d{8}|[124-69]\\d{7}|[24-69]\\d{6}",[7,8,9,10],[["(1)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"]],["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"]],["(\\d{3})(\\d{5})","$1 $2",["40[24]|50[45]"]],["(48)(\\d{4})(\\d{4})","$1 $2 $3",["48"]],["(818)(\\d{3})(\\d{3})","$1 $2 $3",["818"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[24-69]|7[14]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["76|8[35-9]"],"0$1"],["(8\\d)(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8[35-9]5"],"0$1"],["(700)(\\d{3})(\\d{3})","$1 $2 $3",["700"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:5|8[059])","1(?:5|8[059]0)"],"$1"]],"0","(0$1)"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["([2-489])(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["([57]\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(153)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["153"]],["(1)([7-9]\\d{2})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(1255)(\\d{3})","$1-$2",["125","1255"]],["(1200)(\\d{3})(\\d{3})","$1-$2-$3",["120","1200"]],["(1212)(\\d{2})(\\d{2})","$1-$2-$3",["121","1212"]],["(1599)(\\d{6})","$1-$2",["159","1599"]],["(151)(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["151"]]],"0"],"IM":["44","00","(?:1624|(?:[3578]\\d|90)\\d\\d)\\d{6}",[10],0,"0",0,0,0,0,0,[["1624[5-8]\\d{5}"],["7(?:4576|[59]24\\d|624[0-4689])\\d{5}"],["808162\\d{4}"],["(?:872299|90[0167]624)\\d{4}"],["70\\d{8}"],0,["3(?:08162\\d|3\\d{5}|4(?:40[49]06|5624\\d)|7(?:0624\\d|2299\\d))\\d{3}|55\\d{8}"],0,["56\\d{8}"],["8(?:4(?:40[49]06|5624\\d)|70624\\d)\\d{3}"]]],"IN":["91","00","(?:00800|1\\d{0,5}|[2-9]\\d\\d)\\d{7}",[8,9,10,11,12,13],[["(\\d{8})","$1",["561","5616","56161"],"$1"],["(\\d{5})(\\d{5})","$1 $2",["6(?:0[023]|12|2[03689]|3[05-9]|9[019])|7(?:[02-8]|19|9[037-9])|8(?:0[015-9]|[1-9])|9","6(?:0(?:0|26|33)|127|2(?:[06]|3[02589]|8[0-379]|9[0-4679])|3(?:0[0-79]|5[0-46-9]|6[0-4679]|7[0-24-9]|[89])|9[019])|7(?:[07]|19[0-5]|2(?:[0235-9]|[14][017-9])|3(?:[025-9]|[134][017-9])|4(?:[0-35689]|[47][017-9])|5(?:[02-46-9]|[15][017-9])|6(?:[02-9]|1[0-257-9])|8(?:[0-79]|8[0189])|9(?:[089]|31|7[02-9]))|8(?:0(?:[01589]|6[67]|7[02-9])|1(?:[0-57-9]|6[07-9])|2(?:[014][07-9]|[235-9])|3(?:[03-57-9]|[126][07-9])|[45]|6(?:[02457-9]|[136][07-9])|7(?:[078][07-9]|[1-69])|8(?:[0-25-9]|3[07-9]|4[047-9])|9(?:[02-9]|1[027-9]))|9","6(?:0(?:0|26|33)|1279|2(?:[06]|3[02589]|8[0-379]|9[0-4679])|3(?:0[0-79]|5[0-46-9]|6[0-4679]|7[0-24-9]|[89])|9[019])|7(?:0|19[0-5]|2(?:[0235-79]|[14][017-9]|8(?:[0-69]|[78][089]))|3(?:[05-8]|1(?:[0189]|7[02-9])|2(?:[0-49][089]|[5-8])|3[017-9]|4(?:[07-9]|11)|9(?:[01689]|[2-5][089]|7[0189]))|4(?:[056]|1(?:[0135-9]|[24][089])|[29](?:[0-7][089]|[89])|3(?:[0-8][089]|9)|[47](?:[089]|11|7[02-8])|8(?:[0-24-7][089]|[389]))|5(?:[0346-9]|[15][017-9]|2(?:[03-9]|[12][089]))|6(?:[0346-9]|1[0-257-9]|2(?:[0-4]|[5-9][089])|5(?:[0-367][089]|[4589]))|7(?:0(?:[02-9]|1[089])|[1-9])|8(?:[0-79]|8(?:0[0189]|11|8[013-9]|9))|9(?:[089]|313|7(?:[02-8]|9[07-9])))|8(?:0(?:[01589]|6[67]|7(?:[02-8]|9[04-9]))|1(?:[0-57-9]|6(?:[089]|7[02-8]))|2(?:[014](?:[089]|7[02-8])|[235-9])|3(?:[03-57-9]|[126](?:[089]|7[02-8]))|[45]|6(?:[02457-9]|[136](?:[089]|7[02-8]))|7(?:0[07-9]|[1-69]|[78](?:[089]|7[02-8]))|8(?:[0-25-9]|3(?:[089]|7[02-8])|4(?:[0489]|7[02-8]))|9(?:[02-9]|1(?:[0289]|7[02-8])))|9"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-9]|80[2-46]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[59][14]|[68][1-9]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1|9[15])|6(?:12|[2-4]1|5[17]|6[13]|7[14]|80)|7(?:12|2[14]|3[134]|4[47]|5[15]|[67]1|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[23579]|[468][1-9])|[2-8]"]],["(\\d{2})(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3 $4",["008"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],"$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["160","1600"],"$1"],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],"$1"],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["180","1800"],"$1"],["(\\d{4})(\\d{3,4})(\\d{4})","$1 $2 $3",["186","1860"],"$1"],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18[06]"],"$1"]],"0","0$1",0,0,1],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|[2-6]\\d?|7\\d\\d)\\d{7}",[8,9,10],[["(1)(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["([2-6]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"IR":["98","00","[1-9]\\d{9}|[1-8]\\d{5,6}",[6,7,10],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"]],["(\\d{2})(\\d{4,5})","$1 $2",["[1-8]"]],["(\\d{4,5})","$1",["96"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"]]],"0","0$1"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{6}(?:\\d{4})?|3[0-8]\\d{9}|(?:[0138]\\d?|55)\\d{8}|[08]\\d{5}(?:\\d{2})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[245])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[67]|99)|[38]"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["3"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,[["0(?:(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d|6(?:[0-57-9]\\d\\d|6(?:[0-8]\\d|9[0-79])))\\d{1,6}"],["33\\d{9}|3[1-9]\\d{8}|3[2-9]\\d{7}",[9,10,11]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:(?:0878|1(?:44|6[346])\\d)\\d\\d|89(?:2|(?:4[5-9]|(?:5[5-9]|9)\\d\\d)\\d))\\d{3}|89[45][0-4]\\d\\d",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","(?:1534|(?:[3578]\\d|90)\\d\\d)\\d{6}",[10],0,"0",0,0,0,0,0,[["1534[0-24-8]\\d{5}"],["7(?:509\\d|7(?:00[378]|97[7-9])|829\\d|937\\d)\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:871206|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))\\d{4}|55\\d{8}"],["76(?:0[012]|2[356]|4[0134]|5[49]|6[0-369]|77|81|9[39])\\d{6}"],["56\\d{8}"],["8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|70002)\\d{4}"]]],"JM":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"876"],"JO":["962","00","(?:(?:(?:[268]|7\\d)\\d|32|53)\\d|900)\\d{5}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7[457-9]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51|63)|9(?:49|80|9[16])","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[78]|96)|477|51[24]|636)|9(?:496|802|9(?:1[23]|69))","1(?:267|3(?:7[247]|9[278])|4(?:5[67]|66)|5(?:47|58|64|8[67])|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[78]|96[2457-9])|477|51[24]|636[2-57-9])|9(?:496|802|9(?:1[23]|69))"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["1(?:[2-46]|5[2-8]|7[2-689]|8[2-7]|9[1-578])|2(?:2[03-689]|3[3-58]|4[0-468]|5[04-8]|6[013-8]|7[06-9]|8[02-57-9]|9[13])|4(?:2[28]|3[689]|6[035-7]|7[05689]|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9[4-9])|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9[014-9])|8(?:2[49]|3[3-8]|4[5-8]|5[2-9]|6[35-9]|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9[3-7])","1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9[2-8])|3(?:[3-6][2-9]|7[2-6]|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5[4-7]|6[2-9]|8[2-8]|9[236-9])|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3[34]|4[2-69]|[5-7]))","1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6[56]))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))","1(?:[2-46]|5(?:[236-8]|[45][2-69])|7[2-689]|8[2-7]|9[1-578])|2(?:2(?:[04-689]|3[23])|3[3-58]|4[0-468]|5(?:[0468][2-9]|5[78]|7[2-4])|6(?:[0135-8]|4[2-5])|7(?:[0679]|8[2-7])|8(?:[024578]|3[25-9]|9[6-9])|9(?:11|3[2-4]))|4(?:2(?:2[2-9]|8[237-9])|3[689]|6[035-7]|7(?:[059][2-8]|[68])|80|9[3-5])|5(?:3[1-36-9]|4[4578]|5[013-8]|[67]|8[14-7]|9(?:[4-7]|[89][2-8]))|7(?:2[15]|3[5-9]|4|6[135-8]|7[0-4689]|9(?:[017-9]|4[6-8]|5[2-478]|6[2-589]))|8(?:2(?:4[4-8]|9(?:20|[3578]|4[04-9]|6(?:5[25]|60)))|3(?:[3-6][2-9]|7(?:[2-5]|6[0-59])|8[2-5])|4[5-8]|5[2-9]|6(?:[37]|5(?:[467]|5[014-9])|6(?:[2-8]|9[02-69])|8[2-8]|9(?:[236-8]|9[23]))|7[579]|8[03-579]|9[2-8])|9(?:[23]0|4[02-46-9]|5[024-79]|6[4-9]|7[2-47-9]|8[02-7]|9(?:3(?:3[02-9]|4[0-24689])|4[2-69]|[5-7]))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1|2(?:2[37]|5[5-9]|64|78|8[39]|91)|4(?:2[2689]|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93)","1|2(?:2[37]|5(?:[57]|[68]0|9[19])|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])","1|2(?:2[37]|5(?:[57]|[68]0|9(?:17|99))|64|78|8[39]|917)|4(?:2(?:20|[68]|9[178])|64|7[347])|5[2-589]|60|8(?:2[124589]|3[279]|[46-9])|9(?:[235-8]|93[34])"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["2(?:[34]7|[56]9|74|9[14-79])|82|993"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["2[2-9]|4|7[235-9]|9[49]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[2579]|80"],"0$1"]],"0"],"KE":["254","000","(?:(?:2|80)0\\d?|[4-7]\\d\\d|900)\\d{6}|[4-6]\\d{6,7}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"]],["(\\d{3})(\\d{6})","$1 $2",["7"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"]]],"0","0$1"],"KG":["996","00","(?:[235-7]\\d|99)\\d{7}|800\\d{6,7}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[25-79]|31[25]"]],["(\\d{4})(\\d{5})","$1 $2",["3(?:1[36]|[2-9])"]],["(\\d{3})(\\d{3})(\\d)(\\d{3})","$1 $2 $3 $4",["8"]]],"0","0$1"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["1\\d[1-9]|[2-9]"],"0$1"],["(1[89]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[89]0","1[89]00"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,0,0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"869"],"KP":["850","00|99","(?:(?:19\\d|2)\\d|85)\\d{6}",[8,10],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]],"0","0$1"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","(?:00[1-9]\\d{2,4}|[12]|5\\d{3})\\d{7}|(?:(?:00|[13-6])\\d|70)\\d{8}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"]],["(\\d{4})(\\d{4})","$1-$2",["1(?:5[246-9]|6[046-8]|8[03579])","1(?:5(?:22|44|66|77|88|99)|6(?:[07]0|44|6[16]|88)|8(?:00|33|55|77|99))"],"$1"],["(\\d{5})","$1",["1[016-9]1","1[016-9]11","1[016-9]114"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2[1-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60[2-9]|80"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["1[0-25-9]|(?:3[1-3]|[46][1-4]|5[1-5])[1-9]"]],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]0"]],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["50"]]],"0","0$1","0(8[1-46-8]|85\\d{2})?"],"KW":["965","00","(?:18|[2569]\\d\\d)\\d{5}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[25]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"345"],"KZ":["7","810","(?:33622|(?:7\\d|80)\\d{3})\\d{5}",[10],0,"8",0,0,0,0,0,[["33622\\d{5}|7(?:1(?:0(?:[23]\\d|4[0-3]|59|63)|1(?:[23]\\d|4[0-79]|59)|2(?:[23]\\d|59)|3(?:2\\d|3[0-79]|4[0-35-9]|59)|4(?:[24]\\d|3[013-9]|5[1-9])|5(?:2\\d|3[1-9]|4[0-7]|59)|6(?:[234]\\d|5[19]|61)|72\\d|8(?:[27]\\d|3[1-46-9]|4[0-5]))|2(?:1(?:[23]\\d|4[46-9]|5[3469])|2(?:2\\d|3[0679]|46|5[12679])|3(?:[234]\\d|5[139])|4(?:2\\d|3[1235-9]|59)|5(?:[23]\\d|4[01246-8]|59|61)|6(?:2\\d|3[1-9]|4[0-4]|59)|7(?:[2379]\\d|40|5[279])|8(?:[23]\\d|4[0-3]|59)|9(?:2\\d|3[124578]|59)))\\d{5}"],["7(?:0[012578]|47|6[02-4]|7[15-8]|85)\\d{7}"],["800\\d{7}"],["809\\d{7}"],["808\\d{7}"],0,0,0,["751\\d{7}"]],"8~10"],"LA":["856","00","(?:2\\d|3)\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(20)(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["20"]],["([2-8]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"]],["(30)(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30"]]],"0","0$1"],"LB":["961","00","[7-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,0,0,0,"758"],"LI":["423","00","(?:(?:[2378]|6\\d\\d)\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[237-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[56]"]],["(69)(7\\d{2})(\\d{4})","$1 $2 $3",["697"]]],"0",0,"0|10(?:01|20|66)"],"LK":["94","00","(?:[1-7]\\d|[89]1)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"0","0$1"],"LR":["231","00","(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[45])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[45]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["([34]\\d)(\\d{6})","$1 $2",["37|4(?:1|5[45]|6[2-4])"]],["([3-6]\\d{2})(\\d{5})","$1 $2",["3[148]|4(?:[24]|6[09])|528|6"]],["([7-9]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1"],["(5)(2\\d{2})(\\d{4})","$1 $2 $3",["52[0-79]"]]],"8","(8-$1)","[08]",0,1],"LU":["352","00","[2457-9]\\d{3,10}|3(?:[0-46-9]\\d{2,9}|5(?:[013-9]\\d{1,8}|2\\d{1,3}))|6\\d{8}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[2-5]|7[1-9]|[89](?:0[2-9]|[1-9])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,4})","$1 $2 $3 $4",["2(?:[12589]|4[12])|[3-5]|7[1-9]|8(?:0[2-9]|[1-9])|9(?:0[2-46-9]|[1-9])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["70|80[01]|90[015]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],0,0,"(15(?:0[06]|1[12]|35|4[04]|55|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","(?:[2569]\\d|71)\\d{7}",[9],[["([25-79]\\d)(\\d{7})","$1-$2",["[25-79]"]]],"0","0$1"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{6})","$1-$2",["5(?:2[015-7]|3[0-4])|[67]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|892","5(?:2(?:[2-48]|9[0-7])|3(?:[5-79]|8[0-7])|9)|892"],"0$1"],["(\\d{5})(\\d{4})","$1-$2",["5[23]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[015-79]\\d|2[02-9]|3[2-57]|4[2-8]|8[235-7])|3(?:[0-48]\\d|[57][2-9]|6[2-8]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:0[067]|6[1267]|7[017]))\\d{6}"],["80\\d{7}"],["89\\d{7}"],0,0,0,0,["5924[01]\\d{4}"]]],"MC":["377","00","(?:(?:[349]|6\\d)\\d\\d|870)\\d{5}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[39]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["8"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d|80\\d?)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-57-9]|6[036-9]"]]],"0","0$1"],"MF":["590","00","(?:590|69\\d)\\d{6}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|30|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[29]|3[0-5]))\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["([23]\\d)(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"]]],"0","0$1"],"MH":["692","011","(?:(?:[256]\\d|45)\\d|329)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"]],["([347]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[347]"]],["([58]\\d{2})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"]]],"0","0$1"],"ML":["223","00","(?:[246-9]\\d|50)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","(?:1|[24-7]\\d)\\d{5,7}|8\\d{6,9}|9(?:[0-46-9]\\d{6,8}|5\\d{6})|2\\d{5}",[6,7,8,9,10],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["1|2[245]"]],["(2)(\\d{4})(\\d{4})","$1 $2 $3",["251"]],["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[4-8]"]],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-8]"]],["(9)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"]],["(9)([34]\\d{4})(\\d{4})","$1 $2 $3",["9(?:3[0-36]|4[0-57-9])"]],["(9)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92[56]"]],["(9)(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["93"]]],"0","0$1"],"MN":["976","001","[12]\\d{8,9}|[1257-9]\\d{7}",[8,9,10],[["([12]\\d)(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"]],["([12]2\\d)(\\d{5,6})","$1 $2",["[12]2[1-3]"]],["([12]\\d{3})(\\d{5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)2"]],["(\\d{4})(\\d{4})","$1 $2",["[57-9]"],"$1"],["([12]\\d{4})(\\d{4,5})","$1 $2",["[12](?:27|[3-5])","[12](?:27|[3-5]\\d)[4-9]"]]],"0","0$1"],"MO":["853","00","(?:28|[68]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","(?:[58]\\d\\d|(?:67|90)0)\\d{7}",[10],0,"1",0,0,0,0,"670"],"MQ":["596","00","(?:596|69\\d)\\d{6}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:(?:[58]\\d\\d|900)\\d\\d|66449)\\d{5}",[10],0,"1",0,0,0,0,"664"],"MT":["356","00","(?:(?:[2579]\\d\\d|800)\\d|3550)\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[2-7]0|33)","(?:[2-468]|5\\d)\\d{6}",[7,8],[["([2-46-9]\\d{2})(\\d{4})","$1 $2",["[2-46-9]"]],["(5\\d{3})(\\d{4})","$1 $2",["5"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[367]|4(?:00|[56])|9[14-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","1\\d{6}(?:\\d{2})?|(?:[23]1|77|88|99)\\d{7}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[17-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3"],"0$1"]],"0"],"MX":["52","0[09]","(?:1\\d|[2-9])\\d{9}",[10,11],[["([358]\\d)(\\d{4})(\\d{4})","$1 $2 $3",["33|55|81"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2467]|3[0-2457-9]|5[089]|8[02-9]|9[0-35-9]"]],["(1)([358]\\d)(\\d{4})(\\d{4})","044 $2 $3 $4",["1(?:33|55|81)"],"$1",0,"$1 $2 $3 $4"],["(1)(\\d{3})(\\d{3})(\\d{4})","044 $2 $3 $4",["1(?:[2467]|3[0-2457-9]|5[089]|8[2-9]|9[1-35-9])"],"$1",0,"$1 $2 $3 $4"]],"01","01 $1","0[12]|04[45](\\d{10})","1$1",1],"MY":["60","00","(?:1\\d\\d?|3\\d|[4-9])\\d{7}",[8,9,10],[["([4-79])(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(3)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["([18]\\d)(\\d{3})(\\d{3,4})","$1-$2 $3",["1[02-46-9][1-9]|8"],"0$1"],["(1)([36-8]00)(\\d{2})(\\d{4})","$1-$2-$3-$4",["1[36-8]0","1[36-8]00"]],["(11)(\\d{4})(\\d{4})","$1-$2 $3",["11"],"0$1"],["(15[49])(\\d{3})(\\d{4})","$1-$2 $3",["15[49]"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-7]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8[0-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","[2-57-9]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[247-9]|3[0-6]|5[0-4]"]]]],"NE":["227","00","[0289]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["09|[289]"]],["(08)(\\d{3})(\\d{3})","$1 $2 $3",["08"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1"]],["(\\d)(\\d{5})","$1 $2",["3"]]]],"NG":["234","009","[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",[7,8,10,11,12,13,14],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"]],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-6]|7(?:0[1-9]|[1-79])|8[2-9]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["70|8[01]|90[235-9]"]],["([78]00)(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]00"]],["([78]00)(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]00"]],["(78)(\\d{2})(\\d{3})","$1 $2 $3",["78"]]],"0","0$1"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8])|[89]\\d{0,3})\\d{6}|1\\d{4,5}",[5,6,7,8,9,10],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1[035]|2[0346]|3[03568]|4[0356]|5[0358]|[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-5]"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6[1-58]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["6"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["([489]\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[489]"]],["([235-7]\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-7]"]]],0,0,0,0,0,0,[["(?:2[1-4]|3[1-3578]|5[1-35-7]|6[1-4679]|7[0-8])\\d{6}",[8]],["(?:4[015-8]|5[89]|9\\d)\\d{6}",[8]],["80[01]\\d{5}",[8]],["82[09]\\d{5}",[8]],["880\\d{5}",[8]],0,["0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}"],0,["85[0-5]\\d{5}",[8]],["810(?:0[0-6]|[2-8]\\d)\\d{3}",[8]]]],"NP":["977","00","9\\d{9}|[1-9]\\d{7}",[8,10],[["(1)(\\d{7})","$1-$2",["1[2-6]"]],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-69]|7[15-9])"]],["(9\\d{2})(\\d{7})","$1-$2",["9(?:6[013]|7[245]|8)"],"$1"]],"0","0$1"],"NR":["674","00","(?:444|55\\d|888)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[458]"]]]],"NU":["683","00","(?:[47]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[28]\\d{7,9}|[346]\\d{7}|(?:508|[79]\\d)\\d{6,7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["240|[346]|7[2-57-9]|9[1-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["21"]],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:1[1-9]|[69]|7[0-35-9])|70|86"]],["(2\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["2[028]"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["90"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|5|[89]0"]]],"0","0$1",0,0,0,0,0,"00"],"OM":["968","00","(?:[279]\\d{3}|500|8007\\d?)\\d{4}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[79]"]]]],"PA":["507","00","(?:[1-57-9]|6\\d)\\d{6}",[7,8],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["6"]]]],"PE":["51","19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(1)(\\d{7})","$1 $2",["1"]],["([4-8]\\d)(\\d{6})","$1 $2",["[4-7]|8[2-4]"]],["(\\d{3})(\\d{5})","$1 $2",["80"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"$1"]],"0","(0$1)",0,0,0,0,0,0," Anexo "],"PF":["689","00","[48]\\d{7}|4\\d{5}",[6,8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4[09]|8[79]"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]]]],"PG":["675","140[1-3]|00","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[13-689]|27"]],["(\\d{4})(\\d{4})","$1 $2",["20|[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:1800\\d{2,4}|2|[89]\\d{4})\\d{5}|[3-8]\\d{8}|[28]\\d{7}",[6,8,9,10,11,12,13],[["(2)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(2)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|5(?:22|44)|642|8(?:62|8[245])","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["([3-8]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[3-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["81|9"],"0$1"],["(1800)(\\d{3})(\\d{4})","$1 $2 $3",["180","1800"]],["(1800)(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["180","1800"]]],"0"],"PK":["92","00","(?:122|[24-8]\\d{4,5}|9(?:[013-9]\\d{2,4}|2(?:[01]\\d\\d|2(?:[025-8]\\d|1[01]))\\d))\\d{6}|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["([89]00)(\\d{3})(\\d{2})","$1 $2 $3",["[89]00"],"0$1"],["(1\\d{3})(\\d{5})","$1 $2",["1"],"$1"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"]],["(\\d{3})(\\d{6,7})","$1 $2",["2[349]|45|54|60|72|8[2-5]|9[2-469]","(?:2[349]|45|54|60|72|8[2-5]|9[2-469])\\d[2-9]"]],["(58\\d{3})(\\d{5})","$1 $2",["58[126]"]],["(3\\d{2})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)1","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)11","(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)111"]],["(\\d{3})(111)(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[349]|45|54|60|72|8[2-5]|9[2-9]","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d1","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d11","(?:2[349]|45|54|60|72|8[2-5]|9[2-9])\\d111"]]],"0","(0$1)"],"PL":["48","00","[1-9]\\d{6}(?:\\d{2})?|6\\d{5}(?:\\d{2})?",[6,7,8,9],[["(\\d{3})(\\d{3})","$1 $2",["11[68]|64"]],["(\\d{5})","$1",["19"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["26|39|45|5[0137]|6[0469]|7[02389]|8[08]"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[14]|2[0-57-9]|3[2-4]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145]"]]]],"PM":["508","00","[45]\\d{5}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","(?:(?:1\\d|5)\\d\\d|[2489]2)\\d{6}",[8,9,10],[["([2489])(2\\d{2})(\\d{4})","$1 $2 $3",["[2489]2"]],["(5[69]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["5[69]"]],["(1[78]00)(\\d{3})(\\d{3})","$1 $2 $3",["1[78]0","1[78]00"],"$1"]],"0","0$1"],"PT":["351","00","(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"]]]],"PW":["680","01[12]","(?:[25-8]\\d\\d|345|488|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","(?:[2-46-9]\\d|5[0-8])\\d{7}|[2-9]\\d{5,7}",[6,7,8,9],[["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["9[1-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["870","8700"]],["(\\d{3})(\\d{4,5})","$1 $2",["[2-8][1-9]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8][1-9]"],"0$1"]],"0"],"QA":["974","00","(?:(?:2|[3-7]\\d)\\d\\d|800)\\d{4}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["2[126]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","(?:26|[68]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[268]"],"0$1"]],"0",0,0,0,0,"262|69|8"],"RO":["40","00","(?:[237]\\d|[89]0)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[237-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","[127]\\d{6,11}|3(?:[0-79]\\d{5,10}|8(?:[02-9]\\d{4,9}|1\\d{4,5}))|6\\d{7,9}|800\\d{3,9}|90\\d{4,8}|7\\d{5}",[6,7,8,9,10,11,12],[["([23]\\d{2})(\\d{4,9})","$1 $2",["(?:2[389]|39)0"]],["([1-3]\\d)(\\d{5,10})","$1 $2",["1|2(?:[0-24-7]|[389][1-9])|3(?:[0-8]|9[1-9])"]],["(6\\d)(\\d{6,8})","$1 $2",["6"]],["([89]\\d{2})(\\d{3,9})","$1 $2",["[89]"]],["(7[26])(\\d{4,9})","$1 $2",["7[26]"]],["(7[08]\\d)(\\d{4,9})","$1 $2",["7[08]"]]],"0","0$1"],"RU":["7","810","[347-9]\\d{9}",[10],[["([3489]\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[3489]"]],["(7\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"]]],"8","8 ($1)",0,0,1,0,[["(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15]|6[1-35-79]|7[1-37-9]))\\d{7}"],["9\\d{9}"],["80[04]\\d{7}"],["80[39]\\d{7}"],["808\\d{7}"]],"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","(?:(?:[15]|8\\d)\\d|92)\\d{7}",[9,10],[["(1\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1[1-467]"]],["(5\\d)(\\d{3})(\\d{4})","$1 $2 $3",["5"]],["(92\\d{2})(\\d{5})","$1 $2",["92"],"$1"],["(800)(\\d{3})(\\d{4})","$1 $2 $3",["800"],"$1"],["(811)(\\d{3})(\\d{3,4})","$1 $2 $3",["811"]]],"0","0$1"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7[1-9]|8[4-9]|9(?:1[2-9]|2[013-9]|3[0-2]|[46]|5[0-46-9]|7[0-689]|8[0-79]|9[0-8])"]]]],"SC":["248","0(?:[02]|10?)","(?:(?:(?:[24]\\d|64)\\d|971)\\d|8000)\\d{3}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3"]],"0","0$1"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|[27]\\d{5}",[6,7,8,9,10],[["([1-469]\\d)(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],0,0,"$1 $2 $3"],["(9[034]\\d)(\\d{4})","$1-$2",["9(?:00|39|44)"],0,0,"$1 $2"],["(8)(\\d{2,3})(\\d{2,3})(\\d{2})","$1-$2 $3 $4",["8"],0,0,"$1 $2 $3 $4"],["([1-69]\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[013689]|2[0136]|3[1356]|4[0246]|54|6[03]|90"],0,0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],0,0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[0-5]|4[0-3])"],0,0,"$1 $2 $3"],["(7\\d)(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["7"],0,0,"$1 $2 $3 $4"],["(77)(\\d{2})(\\d{2})","$1-$2$3",["77"],0,0,"$1 $2 $3"],["(20)(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],0,0,"$1 $2 $3"],["(9[034]\\d)(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9[034]"],0,0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["25[245]|67[3-68]"],0,0,"$1 $2 $3 $4 $5"]],"0","0$1"],"SG":["65","0[0-3]\\d","(?:1\\d{3}|[369]|7000|8(?:\\d{2})?)\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8[1-8]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1[89]"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["70"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00","[1-8]\\d{7}|90\\d{4,6}|8\\d{4,6}",[5,6,7,8],[["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[12]|[34][24-8]|5[2-8]|7[3-8]"],"(0$1)"],["([3-7]\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"]],["([89][09])(\\d{3,6})","$1 $2",["[89][09]"]],["([58]\\d{2})(\\d{5})","$1 $2",["59|8[1-3]"]]],"0","0$1"],"SJ":["47","00","(?:0|(?:[4589]\\d|79)\\d\\d)\\d{4}",[5,8],0,0,0,0,0,0,0,[["79\\d{6}",[8]],["(?:4[015-8]|5[89]|9\\d)\\d{6}",[8]],["80[01]\\d{5}",[8]],["82[09]\\d{5}",[8]],["880\\d{5}",[8]],0,["0\\d{4}|81(?:0(?:0[7-9]|1\\d)|5\\d{2})\\d{3}"],0,["85[0-5]\\d{5}",[8]],["810(?:0[0-6]|[2-8]\\d)\\d{3}",[8]]]],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d{4})(\\d{3})","$1 $2",["909","9090"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"]],"0"],"SL":["232","00","(?:[2-578]\\d|66|99)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2"]],"0","(0$1)"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(0549)(\\d{6})","$1 $2",["054","0549"],0,0,"($1) $2"],["(\\d{6})","0549 $1",["[89]"],0,0,"(0549) $1"]],0,0,"([89]\\d{5})","0549$1"],"SN":["221","00","(?:[378]\\d{4}|93330)\\d{4}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|(?:[1-4]\\d|59)\\d{5}|[1348]\\d{5}",[6,7,8,9],[["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[13-5]|2[0-79]"]],["(\\d)(\\d{7})","$1 $2",["24|[67]"]],["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{2})(\\d{5,7})","$1 $2",["15|28|6[1-35-9]|799|9[2-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3[59]|4[89]|6[24-6]|79|8[08]|90"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{3})(\\d{3})","$1-$2",["[2-4]|5[2-58]"]],["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["5"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","(?:(?:[58]\\d\\d|900)\\d|7215)\\d{6}",[10],0,"1",0,0,0,0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0","0$1",0,0,1],"SZ":["268","00","(?:0800|(?:[237]\\d|900)\\d\\d)\\d{4}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,0,0,0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:1\\d\\d?|[2-57]|[689]\\d)\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["14|[3-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","(?:[3-59]\\d|77|88)\\d{7}",[9],[["([349]\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[34]7|91[78]"]],["([457-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[148]|[578]|9(?:[0235-9]|1[59])"]],["(331700)(\\d)(\\d{2})","$1 $2 $3",["331","3317","33170","331700"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]","3(?:[1245]|3(?:[02-9]|1[0-589]))"]]],"8",0,0,0,1,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","(?:[2-4]\\d|7\\d\\d?|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"]],"8"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:(?:080|[56])0|[2-4]\\d|[78]\\d(?:\\d{2})?)\\d{3}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-6]|7[014]|8[05]"]],["(\\d{3})(\\d{4})","$1 $2",["7[578]|8"]],["(\\d{4})(\\d{3})","$1 $2",["0"]]]],"TR":["90","00","(?:[2-58]\\d\\d|900)\\d{7}|4\\d{6}",[7,10],[["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[23]|4(?:[0-35-9]|4[0-35-9])"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[02-69]|1[06])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["51|[89]"],"0$1"],["(444)(\\d{1})(\\d{3})","$1 $2 $3",["444"]]],"0",0,0,0,1],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7]],"TW":["886","0(?:0[25679]|19)","(?:[24589]|7\\d)\\d{8}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10],[["(20)(\\d)(\\d{4})","$1 $2 $3",["202"]],["([258]0)(\\d{3})(\\d{4})","$1 $2 $3",["20[013-9]|50[0-46-9]|80[0-79]"]],["([2-8])(\\d{3,4})(\\d{4})","$1 $2 $3",["[25][2-8]|[346]|[78][1-9]"]],["(9\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"]],["(70)(\\d{4})(\\d{4})","$1 $2 $3",["70"]]],"0","0$1",0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[26-8]\\d|41|90)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"UA":["380","00","[3-9]\\d{8}",[9],[["([3-9]\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[38]9|4(?:[45][0-5]|87)|5(?:0|[67][37])|6[36-8]|7|9[1-9]","[38]9|4(?:[45][0-5]|87)|5(?:0|6(?:3[14-7]|7)|7[37])|6[36-8]|7|9[1-9]"]],["([3-689]\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["(?:3[1-8]|4[136-8])2|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90","3(?:[1-46-8]2[013-9]|52)|4(?:[1378]2|62[013-9])|5(?:[12457]2|6[24])|6(?:[12][29]|[49]2|5[24])|8[0-8]|90"]],["([3-6]\\d{3})(\\d{5})","$1 $2",["3(?:[1-46-8]|5[013-9])|4(?:[137][013-9]|[45][6-9]|6|8[4-6])|5(?:[1245][013-9]|3|6[0135689]|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])","3(?:[1-46-8](?:[013-9]|22)|5[013-9])|4(?:[137][013-9]|[45][6-9]|6(?:[013-9]|22)|8[4-6])|5(?:[1245][013-9]|3|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][13-8]|[49][013-9]|5[0135-9])"]]],"0","0$1",0,0,0,0,0,"0~0"],"UG":["256","00[057]","(?:(?:[29]0|[347]\\d)\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{6})","$1 $2",["20[0-8]|4(?:6[45]|[7-9])|[7-9]","20(?:[013-8]|2[5-9])|4(?:6[45]|[7-9])|[7-9]"]],["(\\d{2})(\\d{7})","$1 $2",["3|4(?:[1-5]|6[0-36-9])"]],["(2024)(\\d{5})","$1 $2",["202","2024"]]],"0","0$1"],"US":["1","011","[2-9]\\d{9}",[10],[["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:2(?:0[1-35-9]|1[02-9]|2[03-589]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[0135]|3[0-24679]|4[67]|5[12]|6[014]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[0235]|58|6[39]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[19]|6[1-47]|7[013-5]|8[056])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[017]|6[0-279]|78|8[0-2])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[02-59]|8[156])|8(?:0[1-68]|1[02-8]|2[08]|3[0-28]|4[3578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[0179]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["5(?:00|2[12]|33|44|66|77|88)[2-9]\\d{6}"],0,["710[2-9]\\d{6}"]]],"UY":["598","0(?:1[3-9]\\d|0)","(?:[249]\\d\\d|80)\\d{5}|9\\d{6}",[7,8],[["(\\d{4})(\\d{4})","$1 $2",["[24]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9[1-9]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["[89]0"],"0$1"]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","[679]\\d{8}",[9],[["([679]\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[679]"]]],"8","8 $1",0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{6}(?:\\d{4})?|3[0-8]\\d{9}|(?:[0138]\\d?|55)\\d{8}|[08]\\d{5}(?:\\d{2})?",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,0,0,0,"784"],"VE":["58","00","(?:(?:[24]\\d|50)\\d|[89]00)\\d{7}",[10],[["(\\d{3})(\\d{7})","$1-$2"]],"0","0$1"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"284"],"VI":["1","011","(?:(?:34|90)0|[58]\\d\\d)\\d{7}",[10],0,"1",0,0,0,0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|(?:[16]\\d?|[78])\\d{6}",[7,8,9,10],[["(\\d{3})(\\d{4})","$1 $2",["[17]99"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1"],["(\\d{3})(\\d{4,5})","$1 $2",["69"],"0$1"],["(\\d{4})(\\d{4,6})","$1 $2",["1[89]0"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[69]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[3578]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1"],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0",0,0,0,1],"VU":["678","00","(?:(?:[23]|[57]\\d\\d|900)\\d|[48]8)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[579]"]]]],"WF":["681","00","(?:[45]0|68|72|8\\d)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[4-8]"]]]],"WS":["685","0","(?:[2-6]|8\\d(?:\\d{4})?)\\d{4}|[78]\\d{6}",[5,6,7,10],[["(\\d{5})","$1",["[2-6]"]],["(\\d{3})(\\d{3,7})","$1 $2",["8"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","(?:[23]\\d{2,3}|4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["([1-7])(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7[24-68]"]],["(7\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["7[0137]"]]],"0","0$1"],"YT":["262","00","(?:(?:26|63)9|80\\d)\\d{6}",[9],0,"0",0,0,0,0,"269|63"],"ZA":["27","00","[1-9]\\d{8}|8\\d{4,7}",[5,6,7,8,9],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"]],"0"],"ZM":["260","00","(?:(?:21|9\\d)\\d|800)\\d{6}",[9],[["(\\d{2})(\\d{4})","$1 $2",0,"$1"],["([1-8])(\\d{2})(\\d{4})","$1 $2 $3",["[1-8]"],"$1"],["([29]\\d)(\\d{7})","$1 $2",["[29]"]],["(800)(\\d{3})(\\d{3})","$1 $2 $3",["800"]]],"0","0$1"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{2})(\\d{7})","($1) $2",["(?:2[04-79]|39|5[45]|6[15-8]|8[13-59])2","2(?:02[014]|[49]2|[56]20|72[03])|392|5(?:42|525)|6(?:[16-8]21|52[013])|8(?:[1349]28|523)"]],["([49])(\\d{3})(\\d{2,4})","$1 $2 $3",["4|9[2-9]"]],["(7\\d)(\\d{3})(\\d{4})","$1 $2 $3",["7"]],["(86\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["86[24]"]],["([2356]\\d{2})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8|[78])|3(?:[09]8|17|3[78]|7[1569]|8[37])|5[15][78]|6(?:[29]8|37|[68][78]|75)"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|31|[56][14]|7[35]|84)|329"]],["([1-356]\\d)(\\d{3,5})","$1 $2",["1[3-9]|2[02569]|3[0-69]|5[05689]|6"]],["([235]\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[23]9|54"]],["([25]\\d{3})(\\d{3,5})","$1 $2",["(?:25|54)8","258[23]|5483"]],["(8\\d{3})(\\d{6})","$1 $2",["86"]],["(80\\d)(\\d{4})","$1 $2",["80"]]],"0","0$1"],"001":["979",0,"\\d{9}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3"]]]}}

/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIDDPrefix;
/* harmony export (immutable) */ __webpack_exports__["b"] = stripIDDPrefix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metadata__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(70);



var CAPTURING_DIGIT_PATTERN = new RegExp('([' + __WEBPACK_IMPORTED_MODULE_1__common__["d" /* VALID_DIGITS */] + '])');

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */
var SINGLE_IDD_PREFIX = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;

// For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.
function getIDDPrefix(country, metadata) {
	var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
	countryMetadata.country(country);

	if (SINGLE_IDD_PREFIX.test(countryMetadata.IDDPrefix())) {
		return countryMetadata.IDDPrefix();
	}

	return countryMetadata.defaultIDDPrefix();
}

function stripIDDPrefix(number, country, metadata) {
	if (!country) {
		return;
	}

	// Check if the number is IDD-prefixed.

	var countryMetadata = new __WEBPACK_IMPORTED_MODULE_0__metadata__["a" /* default */](metadata);
	countryMetadata.country(country);

	var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

	if (number.search(IDDPrefixPattern) !== 0) {
		return;
	}

	// Strip IDD prefix.
	number = number.slice(number.match(IDDPrefixPattern)[0].length);

	// Some kind of a weird edge case.
	// No explanation from Google given.
	var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
	/* istanbul ignore next */
	if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
		if (matchedGroups[1] === '0') {
			return;
		}
	}

	return number;
}
//# sourceMappingURL=IDD.js.map

/***/ }),
/* 592 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePreCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util__ = __webpack_require__(257);


// Regular expression of characters typically used to start a second phone number for the purposes
// of parsing. This allows us to strip off parts of the number that are actually the start of
// another number, such as for: (530) 583-6985 x302/x2303 -> the second extension here makes this
// actually two phone numbers, (530) 583-6985 x302 and (530) 583-6985 x2303. We remove the second
// extension so that the first number is parsed correctly.
//
// Matches a slash (\ or /) followed by a space followed by an `x`.
//
var SECOND_NUMBER_START_PATTERN = /[\\/] *x/;

function parsePreCandidate(candidate) {
	// Check for extra numbers at the end.
	// TODO: This is the place to start when trying to support extraction of multiple phone number
	// from split notations (+41 79 123 45 67 / 68).
	return Object(__WEBPACK_IMPORTED_MODULE_0__util__["d" /* trimAfterFirstMatch */])(SECOND_NUMBER_START_PATTERN, candidate);
}
//# sourceMappingURL=parsePreCandidate.js.map

/***/ }),
/* 593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidPreCandidate;
// Matches strings that look like dates using "/" as a separator.
// Examples: 3/10/2011, 31/10/96 or 08/31/95.
var SLASH_SEPARATED_DATES = /(?:(?:[0-3]?\d\/[01]?\d)|(?:[01]?\d\/[0-3]?\d))\/(?:[12]\d)?\d{2}/;

// Matches timestamps.
// Examples: "2012-01-02 08:00".
// Note that the reg-ex does not include the
// trailing ":\d\d" -- that is covered by TIME_STAMPS_SUFFIX.
var TIME_STAMPS = /[12]\d{3}[-/]?[01]\d[-/]?[0-3]\d +[0-2]\d$/;
var TIME_STAMPS_SUFFIX_LEADING = /^:[0-5]\d/;

function isValidPreCandidate(candidate, offset, text) {
	// Skip a match that is more likely to be a date.
	if (SLASH_SEPARATED_DATES.test(candidate)) {
		return false;
	}

	// Skip potential time-stamps.
	if (TIME_STAMPS.test(candidate)) {
		var followingText = text.slice(offset + candidate.length);
		if (TIME_STAMPS_SUFFIX_LEADING.test(followingText)) {
			return false;
		}
	}

	return true;
}
//# sourceMappingURL=isValidPreCandidate.js.map

/***/ }),
/* 594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LEAD_CLASS; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidCandidate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utf_8__ = __webpack_require__(595);
// Copy-pasted from `PhoneNumberMatcher.js`.







var OPENING_PARENS = '(\\[\uFF08\uFF3B';
var CLOSING_PARENS = ')\\]\uFF09\uFF3D';
var NON_PARENS = '[^' + OPENING_PARENS + CLOSING_PARENS + ']';

var LEAD_CLASS = '[' + OPENING_PARENS + __WEBPACK_IMPORTED_MODULE_0__common__["c" /* PLUS_CHARS */] + ']';

// Punctuation that may be at the start of a phone number - brackets and plus signs.
var LEAD_CLASS_LEADING = new RegExp('^' + LEAD_CLASS);

// Limit on the number of pairs of brackets in a phone number.
var BRACKET_PAIR_LIMIT = Object(__WEBPACK_IMPORTED_MODULE_1__util__["b" /* limit */])(0, 3);

/**
 * Pattern to check that brackets match. Opening brackets should be closed within a phone number.
 * This also checks that there is something inside the brackets. Having no brackets at all is also
 * fine.
 *
 * An opening bracket at the beginning may not be closed, but subsequent ones should be.  It's
 * also possible that the leading bracket was dropped, so we shouldn't be surprised if we see a
 * closing bracket first. We limit the sets of brackets in a phone number to four.
 */
var MATCHING_BRACKETS_ENTIRE = new RegExp('^' + "(?:[" + OPENING_PARENS + "])?" + "(?:" + NON_PARENS + "+" + "[" + CLOSING_PARENS + "])?" + NON_PARENS + "+" + "(?:[" + OPENING_PARENS + "]" + NON_PARENS + "+[" + CLOSING_PARENS + "])" + BRACKET_PAIR_LIMIT + NON_PARENS + "*" + '$');

/**
 * Matches strings that look like publication pages. Example:
 * <pre>Computing Complete Answers to Queries in the Presence of Limited Access Patterns.
 * Chen Li. VLDB J. 12(3): 211-227 (2003).</pre>
 *
 * The string "211-227 (2003)" is not a telephone number.
 */
var PUB_PAGES = /\d{1,5}-+\d{1,5}\s{0,4}\(\d{1,4}/;

function isValidCandidate(candidate, offset, text, leniency) {
	// Check the candidate doesn't contain any formatting
	// which would indicate that it really isn't a phone number.
	if (!MATCHING_BRACKETS_ENTIRE.test(candidate) || PUB_PAGES.test(candidate)) {
		return;
	}

	// If leniency is set to VALID or stricter, we also want to skip numbers that are surrounded
	// by Latin alphabetic characters, to skip cases like abc8005001234 or 8005001234def.
	if (leniency !== 'POSSIBLE') {
		// If the candidate is not at the start of the text,
		// and does not start with phone-number punctuation,
		// check the previous character.
		if (offset > 0 && !LEAD_CLASS_LEADING.test(candidate)) {
			var previousChar = text[offset - 1];
			// We return null if it is a latin letter or an invalid punctuation symbol.
			if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["d" /* isInvalidPunctuationSymbol */])(previousChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["e" /* isLatinLetter */])(previousChar)) {
				return false;
			}
		}

		var lastCharIndex = offset + candidate.length;
		if (lastCharIndex < text.length) {
			var nextChar = text[lastCharIndex];
			if (Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["d" /* isInvalidPunctuationSymbol */])(nextChar) || Object(__WEBPACK_IMPORTED_MODULE_2__utf_8__["e" /* isLatinLetter */])(nextChar)) {
				return false;
			}
		}
	}

	return true;
}
//# sourceMappingURL=isValidCandidate.js.map

/***/ }),
/* 595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PZ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return _pN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return pNd; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _pL; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isLatinLetter;
/* harmony export (immutable) */ __webpack_exports__["d"] = isInvalidPunctuationSymbol;
// Javascript doesn't support UTF-8 regular expressions.
// So mimicking them here.

// Copy-pasted from `PhoneNumberMatcher.js`.

/**
 * "\p{Z}" is any kind of whitespace or invisible separator ("Separator").
 * http://www.regular-expressions.info/unicode.html
 * "\P{Z}" is the reverse of "\p{Z}".
 * "\p{N}" is any kind of numeric character in any script ("Number").
 * "\p{Nd}" is a digit zero through nine in any script except "ideographic scripts" ("Decimal_Digit_Number").
 * "\p{Sc}" is a currency symbol ("Currency_Symbol").
 * "\p{L}" is any kind of letter from any language ("Letter").
 * "\p{Mn}" is "non-spacing mark".
 *
 * Javascript doesn't support Unicode Regular Expressions
 * so substituting it with this explicit set of characters.
 *
 * https://stackoverflow.com/questions/13210194/javascript-regex-equivalent-of-a-za-z-using-pl
 * https://github.com/danielberndt/babel-plugin-utf-8-regex/blob/master/src/transformer.js
 */

var _pZ = ' \xA0\u1680\u180E\u2000-\u200A\u2028\u2029\u202F\u205F\u3000';
var pZ = '[' + _pZ + ']';
var PZ = '[^' + _pZ + ']';

var _pN = '0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
// const pN = `[${_pN}]`

var _pNd = '0-9\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0BE6-\u0BEF\u0C66-\u0C6F\u0CE6-\u0CEF\u0D66-\u0D6F\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F29\u1040-\u1049\u1090-\u1099\u17E0-\u17E9\u1810-\u1819\u1946-\u194F\u19D0-\u19D9\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\uA620-\uA629\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19';
var pNd = '[' + _pNd + ']';

var _pL = 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC';
var pL = '[' + _pL + ']';
var pL_regexp = new RegExp(pL);

var _pSc = '$\xA2-\xA5\u058F\u060B\u09F2\u09F3\u09FB\u0AF1\u0BF9\u0E3F\u17DB\u20A0-\u20B9\uA838\uFDFC\uFE69\uFF04\uFFE0\uFFE1\uFFE5\uFFE6';
var pSc = '[' + _pSc + ']';
var pSc_regexp = new RegExp(pSc);

var _pMn = '\u0300-\u036F\u0483-\u0487\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u0610-\u061A\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E4-\u08FE\u0900-\u0902\u093A\u093C\u0941-\u0948\u094D\u0951-\u0957\u0962\u0963\u0981\u09BC\u09C1-\u09C4\u09CD\u09E2\u09E3\u0A01\u0A02\u0A3C\u0A41\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A70\u0A71\u0A75\u0A81\u0A82\u0ABC\u0AC1-\u0AC5\u0AC7\u0AC8\u0ACD\u0AE2\u0AE3\u0B01\u0B3C\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B62\u0B63\u0B82\u0BC0\u0BCD\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C62\u0C63\u0CBC\u0CBF\u0CC6\u0CCC\u0CCD\u0CE2\u0CE3\u0D41-\u0D44\u0D4D\u0D62\u0D63\u0DCA\u0DD2-\u0DD4\u0DD6\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9\u0EBB\u0EBC\u0EC8-\u0ECD\u0F18\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86\u0F87\u0F8D-\u0F97\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039\u103A\u103D\u103E\u1058\u1059\u105E-\u1060\u1071-\u1074\u1082\u1085\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17B4\u17B5\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193B\u1A17\u1A18\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1B00-\u1B03\u1B34\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80\u1B81\u1BA2-\u1BA5\u1BA8\u1BA9\u1BAB\u1BE6\u1BE8\u1BE9\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1DC0-\u1DE6\u1DFC-\u1DFF\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2CEF-\u2CF1\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u3099\u309A\uA66F\uA674-\uA67D\uA69F\uA6F0\uA6F1\uA802\uA806\uA80B\uA825\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC\uAA29-\uAA2E\uAA31\uAA32\uAA35\uAA36\uAA43\uAA4C\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAEC\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE26';
var pMn = '[' + _pMn + ']';
var pMn_regexp = new RegExp(pMn);

var _InBasic_Latin = '\0-\x7F';
var _InLatin_1_Supplement = '\x80-\xFF';
var _InLatin_Extended_A = '\u0100-\u017F';
var _InLatin_Extended_Additional = '\u1E00-\u1EFF';
var _InLatin_Extended_B = '\u0180-\u024F';
var _InCombining_Diacritical_Marks = '\u0300-\u036F';

var latinLetterRegexp = new RegExp('[' + _InBasic_Latin + _InLatin_1_Supplement + _InLatin_Extended_A + _InLatin_Extended_Additional + _InLatin_Extended_B + _InCombining_Diacritical_Marks + ']');

/**
 * Helper method to determine if a character is a Latin-script letter or not.
 * For our purposes, combining marks should also return true since we assume
 * they have been added to a preceding Latin character.
 */
function isLatinLetter(letter) {
  // Combining marks are a subset of non-spacing-mark.
  if (!pL_regexp.test(letter) && !pMn_regexp.test(letter)) {
    return false;
  }

  return latinLetterRegexp.test(letter);
}

function isInvalidPunctuationSymbol(character) {
  return character === '%' || pSc_regexp.test(character);
}
//# sourceMappingURL=utf-8.js.map

/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Subzero__ = __webpack_require__(255);
function getOAuthSpec(network){switch(network){case"fb":return{dialog:"https://www.facebook.com/v2.10/dialog/oauth",client_id:window.FACEBOOK_CLIENT_ID,redirect_uri:window.FACEBOOK_REDIRECT_URI,scope:"email"};case"gp":return{dialog:"https://accounts.google.com/o/oauth2/v2/auth",client_id:window.GOOGLE_CLIENT_ID,redirect_uri:window.GOOGLE_REDIRECT_URI,scope:"https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile"};default:throw new TypeError("Unknown network type");}}function loginWith(network,props){var _getOAuthSpec=getOAuthSpec(network),dialog=_getOAuthSpec.dialog,client_id=_getOAuthSpec.client_id,redirect_uri=_getOAuthSpec.redirect_uri,scope=_getOAuthSpec.scope;var _window$location=window.location,origin=_window$location.origin,pathname=_window$location.pathname,search=_window$location.search;var parsedSearch=__WEBPACK_IMPORTED_MODULE_0_querystring___default.a.parse(search.slice(1))||{};//сабы которые мы привыкли видеть в Сабзиро в этом урле спрятаны под такими именами
var sub1=parsedSearch.media_source;var sub2=parsedSearch.campaign;var authSearchParams=Object.assign({},parsedSearch,{sub0:Object(__WEBPACK_IMPORTED_MODULE_1__Subzero__["c" /* getSub0 */])(window.location,{isIOS:props.isIOS})});if(sub1!=null){authSearchParams.sub1=sub1;}if(sub2!=null){authSearchParams.sub2=sub2;}var query={client_id:client_id,redirect_uri:redirect_uri,scope:scope,response_type:"code",state:JSON.stringify({redirect:origin+pathname+"?"+__WEBPACK_IMPORTED_MODULE_0_querystring___default.a.stringify(authSearchParams),// TODO: Сделать более предсказуемо
ref_user:props.ref_user,locale:props.locale,currency: false?"THB":undefined// Страны может не быть только если это irontrade,
// и пользователь её пока не выбрал. При этом соци-
// альная регистрация доступна только для гео Вьет-
// нама, поэтому VND это наш дефолт.
/*currency: props.country != null
        ? props.country.currency
        : "VND"*/})};return dialog+"?"+__WEBPACK_IMPORTED_MODULE_0_querystring___default.a.stringify(query);}/* harmony default export */ __webpack_exports__["a"] = (loginWith);

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = [["af","Afghanistan (‫افغانستان‬‎)"],["ax","Åland Islands"],["al","Albania (Shqipëri)"],["dz","Algeria (‫الجزائر‬‎)"],["as","American Samoa (Amerika Sāmoa)"],["ad","Andorra"],["ao","Angola"],["ai","Anguilla"],["ag","Antigua and Barbuda"],["ar","Argentina"],["am","Armenia (Հայաստան)"],["aw","Aruba"],["au","Australia"],["at","Austria (Österreich)"],["az","Azerbaijan (Azərbaycan)"],["bs","Bahamas"],["bh","Bahrain (‫البحرين‬‎)"],["bd","Bangladesh (বাংলাদেশ)"],["bb","Barbados"],["by","Belarus (Беларусь)"],["be","Belgium (België)"],["bz","Belize"],["bj","Benin (Bénin)"],["bm","Bermuda"],["bt","Bhutan (འབྲུག)"],["bo","Bolivia"],["ba","Bosnia and Herzegovina"],["bw","Botswana"],["br","Brazil (Brasil)"],["io","British Indian Ocean Territory"],["vg","British Virgin Islands"],["bn","Brunei (Negara Brunei Darussalam)"],["bg","Bulgaria (България)"],["bf","Burkina Faso"],["bi","Burundi (Uburundi)"],["kh","Cambodia (កម្ពុជា)"],["cm","Cameroon (Cameroun)"],["ca","Canada"],["cv","Cape Verde (Kabu Verdi)"],["bq","Caribbean Netherlands"],["ky","Cayman Islands"],["cf","Central African Republic"],["td","Chad (Tchad)"],["cl","Chile"],["cn","China (中国)"],["cx","Christmas Island"],["cc","Cocos (Keeling) Islands"],["co","Colombia"],["km","Comoros (‫جزر القمر‬‎)"],["cd","Congo (DRC) (Kongo)"],["cg","Congo (Republic) (Congo-Brazzaville)"],["ck","Cook Islands"],["cr","Costa Rica"],["ci","Côte d’Ivoire"],["hr","Croatia (Hrvatska)"],["cu","Cuba"],["cw","Curaçao"],["cy","Cyprus (Κύπρος)"],["cz","Czech Republic (Česká republika)"],["dk","Denmark (Danmark)"],["dj","Djibouti"],["dm","Dominica"],["do","Dominican Republic"],["ec","Ecuador"],["eg","Egypt (‫مصر‬‎)"],["sv","El Salvador"],["gq","Equatorial Guinea (Guinea Ecuatorial)"],["er","Eritrea"],["ee","Estonia (Eesti)"],["et","Ethiopia"],["fk","Falkland Islands (Islas Malvinas)"],["fo","Faroe Islands (Føroyar)"],["fj","Fiji (Matanitu Tugalala o Viti)"],["fi","Finland (Suomi)"],["fr","France (République française)"],["gf","French Guiana (Guyane française)"],["pf","French Polynesia (Polynésie française)"],["ga","Gabon (République gabonaise)"],["gm","Gambia"],["ge","Georgia (საქართველო)"],["de","Germany (Deutschland)"],["gh","Ghana (Gaana)"],["gi","Gibraltar"],["gr","Greece (Ελλάδα)"],["gl","Greenland (Kalaallit Nunaat)"],["gd","Grenada"],["gp","Guadeloupe"],["gu","Guam (Guåhån)"],["gt","Guatemala"],["gg","Guernsey"],["gn","Guinea (Guinée)"],["gw","Guinea-Bissau (Guiné Bissau)"],["gy","Guyana"],["ht","Haiti (République d'Haïti)"],["hn","Honduras"],["hk","Hong Kong (香港)"],["hu","Hungary (Magyarország)"],["is","Iceland (Ísland)"],["in","India (भारत)"],["id","Indonesia"],["ir","Iran (‫ایران‬‎)"],["iq","Iraq (‫العراق‬‎)"],["ie","Ireland"],["im","Isle of Man"],["il","Israel (‫ישראל‬‎)"],["it","Italy (Italia)"],["jm","Jamaica"],["jp","Japan (日本)"],["je","Jersey"],["jo","Jordan (‫الأردن‬‎)"],["kz","Kazakhstan (Казахстан)"],["ke","Kenya"],["ki","Kiribati"],["kw","Kuwait (‫الكويت‬‎)"],["kg","Kyrgyzstan (Кыргызстан)"],["la","Laos (ລາວ)"],["lv","Latvia (Latvija)"],["lb","Lebanon (‫لبنان‬‎)"],["ls","Lesotho"],["lr","Liberia"],["ly","Libya (‫ليبيا‬‎)"],["li","Liechtenstein"],["lt","Lithuania (Lietuva)"],["lu","Luxembourg (Lëtzebuerg)"],["mo","Macau (澳門)"],["mk","Macedonia (FYROM) (Македонија)"],["mg","Madagascar (Madagasikara)"],["mw","Malawi (Malaŵi)"],["my","Malaysia"],["mv","Maldives"],["ml","Mali"],["mt","Malta"],["mh","Marshall Islands"],["mq","Martinique"],["mr","Mauritania (‫موريتانيا‬‎)"],["mu","Mauritius (Moris)"],["yt","Mayotte"],["mx","Mexico (México)"],["fm","Micronesia"],["md","Moldova (Republica Moldova)"],["mc","Monaco"],["mn","Mongolia (Монгол)"],["me","Montenegro (Crna Gora)"],["ms","Montserrat"],["ma","Morocco (‫المغرب‬‎)"],["mz","Mozambique (Moçambique)"],["mm","Myanmar (Burma) (မြန်မာ)"],["na","Namibia (Namibië)"],["nr","Nauru (Repubrikin Naoero)"],["np","Nepal (नेपाल)"],["nl","Netherlands (Nederland)"],["nc","New Caledonia (Nouvelle-Calédonie)"],["nz","New Zealand"],["ni","Nicaragua"],["ne","Niger (Nijar)"],["ng","Nigeria"],["nu","Niue (Niuē)"],["nf","Norfolk Island"],["kp","North Korea (조선 민주주의 인민 공화국)"],["mp","Northern Mariana Islands"],["no","Norway (Norge)"],["om","Oman (‫عُمان‬‎)"],["pk","Pakistan (‫پاکستان‬‎)"],["pw","Palau (Beluu er a Belau)"],["ps","Palestine (‫فلسطين‬‎)"],["pa","Panama (Panamá)"],["pg","Papua New Guinea"],["py","Paraguay (Tetã Paraguái)"],["pe","Peru (Perú)"],["ph","Philippines (Republika ng Pilipinas)"],["pl","Poland (Polska)"],["pt","Portugal (República Portuguesa)"],["pr","Puerto Rico"],["qa","Qatar (‫قطر‬‎)"],["re","Réunion (La Réunion)"],["ro","Romania (România)"],["ru","Russia (Россия)"],["rw","Rwanda"],["bl","Saint Barthélemy (Saint-Barthélemy)"],["sh","Saint Helena"],["kn","Saint Kitts and Nevis"],["lc","Saint Lucia"],["mf","Saint Martin (Saint-Martin)"],["pm","Saint Pierre and Miquelon"],["vc","Saint Vincent and the Grenadines"],["ws","Samoa (Sāmoa)"],["sm","San Marino"],["st","São Tomé and Príncipe"],["sa","Saudi Arabia (‫المملكة العربية السعودية‬‎)"],["sn","Senegal (Sénégal)"],["rs","Serbia (Србија)"],["sc","Seychelles (Repiblik Sesel)"],["sl","Sierra Leone"],["sg","Singapore (Singapura) (新加坡共和国)"],["sx","Sint Maarten"],["sk","Slovakia (Slovensko)"],["si","Slovenia (Slovenija)"],["sb","Solomon Islands"],["so","Somalia (Soomaaliya)"],["za","South Africa"],["kr","South Korea (대한민국)"],["ss","South Sudan (‫جنوب السودان‬‎)"],["es","Spain (España)"],["lk","Sri Lanka (ශ්‍රී ලංකාව)"],["sd","Sudan (‫السودان‬‎)"],["sr","Suriname"],["sj","Svalbard and Jan Mayen"],["sz","Swaziland (Umbuso weSwatini)"],["se","Sweden (Sverige)"],["ch","Switzerland (Schweiz)"],["sy","Syria (‫سوريا‬‎)"],["tw","Taiwan (台灣)"],["tj","Tajikistan (Ҷумҳурии Тоҷикистон)"],["tz","Tanzania"],["th","Thailand (ไทย)"],["tl","Timor-Leste (Timór-Leste)"],["tg","Togo (République togolaise)"],["tk","Tokelau"],["to","Tonga"],["tt","Trinidad and Tobago"],["tn","Tunisia (‫تونس‬‎)"],["tr","Turkey (Türkiye)"],["tm","Turkmenistan (Türkmenistan)"],["tc","Turks and Caicos Islands"],["tv","Tuvalu"],["vi","U.S. Virgin Islands"],["ug","Uganda"],["ua","Ukraine (Україна)"],["ae","United Arab Emirates (‫الإمارات العربية المتحدة‬‎)"],["gb","United Kingdom"],["us","United States"],["uy","Uruguay"],["uz","Uzbekistan (Oʻzbekiston)"],["vu","Vanuatu"],["va","Vatican City (Città del Vaticano)"],["ve","Venezuela"],["vn","Vietnam (Việt Nam)"],["wf","Wallis and Futuna (Wallis-et-Futuna)"],["eh","Western Sahara (‫الصحراء الغربية‬‎)"],["ye","Yemen (‫اليمن‬‎)"],["zm","Zambia"],["zw","Zimbabwe"]]

/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__types__ = __webpack_require__(622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _React$PureComponent);

  function ArrowKeyStepper() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      scrollToColumn: 0,
      scrollToRow: 0
    }, _this._columnStartIndex = 0, _this._columnStopIndex = 0, _this._rowStartIndex = 0, _this._rowStopIndex = 0, _this._onKeyDown = function (event) {
      var _this$props = _this.props,
          columnCount = _this$props.columnCount,
          disabled = _this$props.disabled,
          mode = _this$props.mode,
          rowCount = _this$props.rowCount;


      if (disabled) {
        return;
      }

      var _this$_getScrollState = _this._getScrollState(),
          scrollToColumnPrevious = _this$_getScrollState.scrollToColumn,
          scrollToRowPrevious = _this$_getScrollState.scrollToRow;

      var _this$_getScrollState2 = _this._getScrollState(),
          scrollToColumn = _this$_getScrollState2.scrollToColumn,
          scrollToRow = _this$_getScrollState2.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.


      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(_this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(_this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(_this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(_this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        _this._updateScrollState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }, _this._onSectionRendered = function (_ref2) {
      var columnStartIndex = _ref2.columnStartIndex,
          columnStopIndex = _ref2.columnStopIndex,
          rowStartIndex = _ref2.rowStartIndex,
          rowStopIndex = _ref2.rowStopIndex;

      _this._columnStartIndex = columnStartIndex;
      _this._columnStopIndex = columnStopIndex;
      _this._rowStartIndex = rowStartIndex;
      _this._rowStopIndex = rowStopIndex;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'setScrollIndexes',
    value: function setScrollIndexes(_ref3) {
      var scrollToColumn = _ref3.scrollToColumn,
          scrollToRow = _ref3.scrollToRow;

      this.setState({
        scrollToRow: scrollToRow,
        scrollToColumn: scrollToColumn
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      var _getScrollState2 = this._getScrollState(),
          scrollToColumn = _getScrollState2.scrollToColumn,
          scrollToRow = _getScrollState2.scrollToRow;

      return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](
        'div',
        { className: className, onKeyDown: this._onKeyDown },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: '_getScrollState',
    value: function _getScrollState() {
      return this.props.isControlled ? this.props : this.state;
    }
  }, {
    key: '_updateScrollState',
    value: function _updateScrollState(_ref4) {
      var scrollToColumn = _ref4.scrollToColumn,
          scrollToRow = _ref4.scrollToRow;
      var _props2 = this.props,
          isControlled = _props2.isControlled,
          onScrollToChange = _props2.onScrollToChange;


      if (typeof onScrollToChange === 'function') {
        onScrollToChange({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }

      if (!isControlled) {
        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.isControlled) {
        return null;
      }

      if (nextProps.scrollToColumn !== prevState.scrollToColumn || nextProps.scrollToRow !== prevState.scrollToRow) {
        return {
          scrollToColumn: nextProps.scrollToColumn,
          scrollToRow: nextProps.scrollToRow
        };
      }

      return null;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  isControlled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
ArrowKeyStepper.propTypes =  true ? null : {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  isControlled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']).isRequired,
  onScrollToChange: PropTypes.func,
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_6_react_lifecycles_compat__["polyfill"])(ArrowKeyStepper);

/* unused harmony default export */ var _unused_webpack_default_export = (ArrowKeyStepper);




/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(137);
var toObject = __webpack_require__(258);
var IE_PROTO = __webpack_require__(384)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(118) && !__webpack_require__(161)(function () {
  return Object.defineProperty(__webpack_require__(387)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1295), __esModule: true };

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1297);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1307);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(196);
var $export = __webpack_require__(89);
var redefine = __webpack_require__(604);
var hide = __webpack_require__(138);
var Iterators = __webpack_require__(162);
var $iterCreate = __webpack_require__(1300);
var setToStringTag = __webpack_require__(263);
var getPrototypeOf = __webpack_require__(599);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(138);


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(137);
var toIObject = __webpack_require__(139);
var arrayIndexOf = __webpack_require__(1302)(false);
var IE_PROTO = __webpack_require__(384)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(199);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(389);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(55).document;
module.exports = document && document.documentElement;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(605);
var hiddenKeys = __webpack_require__(391).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 610 */
/***/ (function(module, exports) {



/***/ }),
/* 611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__ = __webpack_require__(614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__ = __webpack_require__(615);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_prop_types__);



















/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

var renderNull = function renderNull() {
  return null;
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */
var Grid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Grid, _React$PureComponent);

  // Invokes onSectionRendered callback only when start/stop row or column indices change
  function Grid(props) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props));

    _this._onGridRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createCallbackMemoizer__["a" /* default */])(false);
    _this._deferredInvalidateColumnIndex = null;
    _this._deferredInvalidateRowIndex = null;
    _this._recomputeScrollLeftFlag = false;
    _this._recomputeScrollTopFlag = false;
    _this._horizontalScrollBarSize = 0;
    _this._verticalScrollBarSize = 0;
    _this._scrollbarPresenceChanged = false;
    _this._renderedColumnStartIndex = 0;
    _this._renderedColumnStopIndex = 0;
    _this._renderedRowStartIndex = 0;
    _this._renderedRowStopIndex = 0;
    _this._styleCache = {};
    _this._cellCache = {};

    _this._debounceScrollEndedCallback = function () {
      _this._disablePointerEventsTimeoutId = null;
      // isScrolling is used to determine if we reset styleCache
      _this.setState({
        isScrolling: false,
        needToResetStyleCache: false
      });
    };

    _this._invokeOnGridRenderedHelper = function () {
      var onSectionRendered = _this.props.onSectionRendered;


      _this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: _this._columnStartIndex,
          columnOverscanStopIndex: _this._columnStopIndex,
          columnStartIndex: _this._renderedColumnStartIndex,
          columnStopIndex: _this._renderedColumnStopIndex,
          rowOverscanStartIndex: _this._rowStartIndex,
          rowOverscanStopIndex: _this._rowStopIndex,
          rowStartIndex: _this._renderedRowStartIndex,
          rowStopIndex: _this._renderedRowStopIndex
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target === _this._scrollingContainer) {
        _this.handleScrollEvent(event.target);
      }
    };

    var columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.columnWidth)(params);
      },
      estimatedCellSize: Grid._getEstimatedColumnSize(props)
    });
    var rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_10__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return Grid._wrapSizeGetter(props.rowHeight)(params);
      },
      estimatedCellSize: Grid._getEstimatedRowSize(props)
    });

    _this.state = {
      instanceProps: {
        columnSizeAndPositionManager: columnSizeAndPositionManager,
        rowSizeAndPositionManager: rowSizeAndPositionManager,

        prevColumnWidth: props.columnWidth,
        prevRowHeight: props.rowHeight,
        prevColumnCount: props.columnCount,
        prevRowCount: props.rowCount,
        prevIsScrolling: props.isScrolling === true,
        prevScrollToColumn: props.scrollToColumn,
        prevScrollToRow: props.scrollToRow,

        scrollbarSize: 0,
        scrollbarSizeMeasured: false
      },
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0,
      scrollPositionChangeReason: null,

      needToResetStyleCache: false
    };

    if (props.scrollToRow > 0) {
      _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
    }
    if (props.scrollToColumn > 0) {
      _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
    }
    return _this;
  }

  /**
   * Gets offsets for a given cell and alignment.
   */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'getOffsetForCell',
    value: function getOffsetForCell() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$alignment = _ref.alignment,
          alignment = _ref$alignment === undefined ? this.props.scrollToAlignment : _ref$alignment,
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? this.props.scrollToColumn : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? this.props.scrollToRow : _ref$rowIndex;

      var offsetProps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.props, {
        scrollToAlignment: alignment,
        scrollToColumn: columnIndex,
        scrollToRow: rowIndex
      });

      return {
        scrollLeft: this._getCalculatedScrollLeft(offsetProps),
        scrollTop: this._getCalculatedScrollTop(offsetProps)
      };
    }

    /**
     * Gets estimated total rows' height.
     */

  }, {
    key: 'getTotalRowsHeight',
    value: function getTotalRowsHeight() {
      return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
    }

    /**
     * Gets estimated total columns' width.
     */

  }, {
    key: 'getTotalColumnsWidth',
    value: function getTotalColumnsWidth() {
      return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
    }

    /**
     * This method handles a scroll event originating from an external scroll control.
     * It's an advanced method and should probably not be used unless you're implementing a custom scroll-bar solution.
     */

  }, {
    key: 'handleScrollEvent',
    value: function handleScrollEvent(_ref2) {
      var _ref2$scrollLeft = _ref2.scrollLeft,
          scrollLeftParam = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft,
          _ref2$scrollTop = _ref2.scrollTop,
          scrollTopParam = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop;

      // On iOS, we can arrive at negative offsets by swiping past the start.
      // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
      if (scrollTopParam < 0) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      var _props = this.props,
          autoHeight = _props.autoHeight,
          autoWidth = _props.autoWidth,
          height = _props.height,
          width = _props.width;
      var instanceProps = this.state.instanceProps;

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.

      var scrollbarSize = instanceProps.scrollbarSize;
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        // Don't change direction for an axis unless scroll offset has changed.
        var _scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionHorizontal;
        var _scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */] : this.state.scrollDirectionVertical;

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: _scrollDirectionHorizontal,
          scrollDirectionVertical: _scrollDirectionVertical,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        if (!autoWidth) {
          newState.scrollLeft = scrollLeft;
        }

        newState.needToResetStyleCache = false;
        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalColumnsWidth: totalColumnsWidth,
        totalRowsHeight: totalRowsHeight
      });
    }

    /**
     * Invalidate Grid size and recompute visible cells.
     * This is a deferred wrapper for recomputeGridSize().
     * It sets a flag to be evaluated on cDM/cDU to avoid unnecessary renders.
     * This method is intended for advanced use-cases like CellMeasurer.
     */
    // @TODO (bvaughn) Add automated test coverage for this.

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref3) {
      var columnIndex = _ref3.columnIndex,
          rowIndex = _ref3.rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /**
     * Pre-measure all columns and rows in a Grid.
     * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
     * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
     */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props2 = this.props,
          columnCount = _props2.columnCount,
          rowCount = _props2.rowCount;
      var instanceProps = this.state.instanceProps;

      instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref4$columnIndex = _ref4.columnIndex,
          columnIndex = _ref4$columnIndex === undefined ? 0 : _ref4$columnIndex,
          _ref4$rowIndex = _ref4.rowIndex,
          rowIndex = _ref4$rowIndex === undefined ? 0 : _ref4$rowIndex;

      var _props3 = this.props,
          scrollToColumn = _props3.scrollToColumn,
          scrollToRow = _props3.scrollToRow;
      var instanceProps = this.state.instanceProps;


      instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
      instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);

      // Cell sizes may be determined by a function property.
      // In this case the cDU handler can't know if they changed.
      // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
      this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
      this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._styleCache = {};
      this._cellCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref5) {
      var columnIndex = _ref5.columnIndex,
          rowIndex = _ref5.rowIndex;
      var columnCount = this.props.columnCount;


      var props = this.props;

      // Don't adjust scroll offset for single-column grids (eg List, Table).
      // This can cause a funky scroll offset because of the vertical scrollbar width.
      if (columnCount > 1 && columnIndex !== undefined) {
        this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToColumn: columnIndex
        }));
      }

      if (rowIndex !== undefined) {
        this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, props, {
          scrollToRow: rowIndex
        }));
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props4 = this.props,
          getScrollbarSize = _props4.getScrollbarSize,
          height = _props4.height,
          scrollLeft = _props4.scrollLeft,
          scrollToColumn = _props4.scrollToColumn,
          scrollTop = _props4.scrollTop,
          scrollToRow = _props4.scrollToRow,
          width = _props4.width;
      var instanceProps = this.state.instanceProps;

      // Reset initial offsets to be ignored in browser

      this._initialScrollTop = 0;
      this._initialScrollLeft = 0;

      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.
      this._handleInvalidatedGridSize();

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.
      if (!instanceProps.scrollbarSizeMeasured) {
        this.setState(function (prevState) {
          var stateUpdate = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, prevState, { needToResetStyleCache: false });
          stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
          stateUpdate.instanceProps.scrollbarSizeMeasured = true;
          return stateUpdate;
        });
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
        var stateUpdate = Grid._getScrollToPositionStateUpdate({
          prevState: this.state,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        });
        if (stateUpdate) {
          stateUpdate.needToResetStyleCache = false;
          this.setState(stateUpdate);
        }
      }

      // refs don't work in `react-test-renderer`
      if (this._scrollingContainer) {
        // setting the ref's scrollLeft and scrollTop.
        // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
        if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) {
          this._scrollingContainer.scrollLeft = this.state.scrollLeft;
        }
        if (this._scrollingContainer.scrollTop !== this.state.scrollTop) {
          this._scrollingContainer.scrollTop = this.state.scrollTop;
        }
      }

      // Don't update scroll offset if the size is 0; we don't render any cells in this case.
      // Setting a state may cause us to later thing we've updated the offce when we haven't.
      var sizeIsBiggerThanZero = height > 0 && width > 0;
      if (scrollToColumn >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollLeftForScrollToColumn();
      }
      if (scrollToRow >= 0 && sizeIsBiggerThanZero) {
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
      });

      this._maybeCallOnScrollbarPresenceChange();
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props5 = this.props,
          autoHeight = _props5.autoHeight,
          autoWidth = _props5.autoWidth,
          columnCount = _props5.columnCount,
          height = _props5.height,
          rowCount = _props5.rowCount,
          scrollToAlignment = _props5.scrollToAlignment,
          scrollToColumn = _props5.scrollToColumn,
          scrollToRow = _props5.scrollToRow,
          width = _props5.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop,
          instanceProps = _state.instanceProps;
      // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
      // We must do this at the start of the method as we may calculate and update scroll position below.

      this._handleInvalidatedGridSize();

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218
      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
        if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Special case where the previous size was 0:
      // In this case we don't show any windowed cells at all.
      // So we should always recalculate offset afterwards.
      var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      if (this._recomputeScrollLeftFlag) {
        this._recomputeScrollLeftFlag = false;
        this._updateScrollLeftForScrollToColumn(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          previousCellsCount: prevProps.columnCount,
          previousCellSize: prevProps.columnWidth,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToColumn,
          previousSize: prevProps.width,
          scrollOffset: scrollLeft,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToColumn,
          size: width,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollLeftForScrollToColumn(_this2.props);
          }
        });
      }

      if (this._recomputeScrollTopFlag) {
        this._recomputeScrollTopFlag = false;
        this._updateScrollTopForScrollToRow(this.props);
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_13__utils_updateScrollIndexHelper__["a" /* default */])({
          cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          previousCellsCount: prevProps.rowCount,
          previousCellSize: prevProps.rowHeight,
          previousScrollToAlignment: prevProps.scrollToAlignment,
          previousScrollToIndex: prevProps.scrollToRow,
          previousSize: prevProps.height,
          scrollOffset: scrollTop,
          scrollToAlignment: scrollToAlignment,
          scrollToIndex: scrollToRow,
          size: height,
          sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
          updateScrollIndexCallback: function updateScrollIndexCallback() {
            return _this2._updateScrollTopForScrollToRow(_this2.props);
          }
        });
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          totalColumnsWidth: totalColumnsWidth,
          totalRowsHeight: totalRowsHeight
        });
      }

      this._maybeCallOnScrollbarPresenceChange();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'render',
    value: function render() {
      var _props6 = this.props,
          autoContainerWidth = _props6.autoContainerWidth,
          autoHeight = _props6.autoHeight,
          autoWidth = _props6.autoWidth,
          className = _props6.className,
          containerProps = _props6.containerProps,
          containerRole = _props6.containerRole,
          containerStyle = _props6.containerStyle,
          height = _props6.height,
          id = _props6.id,
          noContentRenderer = _props6.noContentRenderer,
          role = _props6.role,
          style = _props6.style,
          tabIndex = _props6.tabIndex,
          width = _props6.width;
      var _state2 = this.state,
          instanceProps = _state2.instanceProps,
          needToResetStyleCache = _state2.needToResetStyleCache;


      var isScrolling = this._isScrolling();

      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: autoWidth ? 'auto' : width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      if (needToResetStyleCache) {
        this._styleCache = {};
      }

      // calculate _styleCache here
      // if state.isScrolling (not from _isScrolling) then reset
      if (!this.state.isScrolling) {
        this._resetStyleCache();
      }

      // calculate children to render here
      this._calculateChildrenToRender(this.props, this.state);

      var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

      if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
        this._horizontalScrollBarSize = horizontalScrollBarSize;
        this._verticalScrollBarSize = verticalScrollBarSize;
        this._scrollbarPresenceChanged = true;
      }

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
        'div',
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
          ref: this._setScrollingContainerRef
        }, containerProps, {
          'aria-label': this.props['aria-label'],
          'aria-readonly': this.props['aria-readonly'],
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: role,
          style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex }),
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_7_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            role: containerRole,
            style: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              position: 'relative'
            }, containerStyle) },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer,
          cellRangeRenderer = props.cellRangeRenderer,
          columnCount = props.columnCount,
          deferredMeasurementCache = props.deferredMeasurementCache,
          height = props.height,
          overscanColumnCount = props.overscanColumnCount,
          overscanIndicesGetter = props.overscanIndicesGetter,
          overscanRowCount = props.overscanRowCount,
          rowCount = props.rowCount,
          width = props.width,
          isScrollingOptOut = props.isScrollingOptOut;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal,
          scrollDirectionVertical = state.scrollDirectionVertical,
          instanceProps = state.instanceProps;


      var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
      var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;

      var isScrolling = this._isScrolling(props, state);

      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = overscanIndicesGetter({
          direction: 'horizontal',
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
          stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
        });

        var overscanRowIndices = overscanIndicesGetter({
          direction: 'vertical',
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
          stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
        });

        // Store for _invokeOnGridRenderedHelper()
        var columnStartIndex = overscanColumnIndices.overscanStartIndex;
        var columnStopIndex = overscanColumnIndices.overscanStopIndex;
        var rowStartIndex = overscanRowIndices.overscanStartIndex;
        var rowStopIndex = overscanRowIndices.overscanStopIndex;

        // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
        if (deferredMeasurementCache) {
          // If rows have a dynamic height, scan the rows we are about to render.
          // If any have not yet been measured, then we need to render all columns initially,
          // Because the height of the row is equal to the tallest cell within that row,
          // (And so we can't know the height without measuring all column-cells first).
          if (!deferredMeasurementCache.hasFixedHeight()) {
            for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
              if (!deferredMeasurementCache.has(rowIndex, 0)) {
                columnStartIndex = 0;
                columnStopIndex = columnCount - 1;
                break;
              }
            }
          }

          // If columns have a dynamic width, scan the columns we are about to render.
          // If any have not yet been measured, then we need to render all rows initially,
          // Because the width of the column is equal to the widest cell within that column,
          // (And so we can't know the width without measuring all row-cells first).
          if (!deferredMeasurementCache.hasFixedWidth()) {
            for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
              if (!deferredMeasurementCache.has(0, columnIndex)) {
                rowStartIndex = 0;
                rowStopIndex = rowCount - 1;
                break;
              }
            }
          }
        }

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
          columnStartIndex: columnStartIndex,
          columnStopIndex: columnStopIndex,
          deferredMeasurementCache: deferredMeasurementCache,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          isScrollingOptOut: isScrollingOptOut,
          parent: this,
          rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
          rowStartIndex: rowStartIndex,
          rowStopIndex: rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });

        // update the indices
        this._columnStartIndex = columnStartIndex;
        this._columnStopIndex = columnStopIndex;
        this._rowStartIndex = rowStartIndex;
        this._rowStopIndex = rowStopIndex;
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_17__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_handleInvalidatedGridSize',


    /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({ columnIndex: columnIndex, rowIndex: rowIndex });
      }
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref6) {
      var _this3 = this;

      var scrollLeft = _ref6.scrollLeft,
          scrollTop = _ref6.scrollTop,
          totalColumnsWidth = _ref6.totalColumnsWidth,
          totalRowsHeight = _ref6.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref7) {
          var scrollLeft = _ref7.scrollLeft,
              scrollTop = _ref7.scrollTop;
          var _props7 = _this3.props,
              height = _props7.height,
              onScroll = _props7.onScroll,
              width = _props7.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_isScrolling',
    value: function _isScrolling() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      // If isScrolling is defined in props, use it to override the value in state
      // This is a performance optimization for WindowScroller + Grid
      return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
    }
  }, {
    key: '_maybeCallOnScrollbarPresenceChange',
    value: function _maybeCallOnScrollbarPresenceChange() {
      if (this._scrollbarPresenceChanged) {
        var _onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;


        this._scrollbarPresenceChanged = false;

        _onScrollbarPresenceChange({
          horizontal: this._horizontalScrollBarSize > 0,
          size: this.state.instanceProps.scrollbarSize,
          vertical: this._verticalScrollBarSize > 0
        });
      }
    }
  }, {
    key: 'scrollToPosition',


    /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */
    value: function scrollToPosition(_ref8) {
      var scrollLeft = _ref8.scrollLeft,
          scrollTop = _ref8.scrollTop;

      var stateUpdate = Grid._getScrollToPositionStateUpdate({
        prevState: this.state,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });

      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollLeft(props, state);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      return Grid._getCalculatedScrollTop(props, state);
    }
  }, {
    key: '_resetStyleCache',
    value: function _resetStyleCache() {
      var styleCache = this._styleCache;
      var cellCache = this._cellCache;
      var isScrollingOptOut = this.props.isScrollingOptOut;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
      // This keeps the cellCache to a resonable size.

      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];

          if (isScrollingOptOut) {
            this._cellCache[key] = cellCache[key];
          }
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;

      var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
      if (stateUpdate) {
        stateUpdate.needToResetStyleCache = false;
        this.setState(stateUpdate);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var newState = {};

      if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
        newState.scrollLeft = 0;
        newState.scrollTop = 0;

        // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
        // scrollTo{Column,Row} should override scroll{Left,Top}
      } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        }));
      }

      var instanceProps = prevState.instanceProps;

      // Initially we should not clearStyleCache

      newState.needToResetStyleCache = false;
      if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) {
        // Reset cache. set it to {} in render
        newState.needToResetStyleCache = true;
      }

      instanceProps.columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
      });

      instanceProps.rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
        cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
      });

      if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
        instanceProps.prevColumnCount = 0;
        instanceProps.prevRowCount = 0;
      }

      // If scrolling is controlled outside this component, clear cache when scrolling stops
      if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(newState, {
          isScrolling: false
        });
      }

      var maybeStateA = void 0;
      var maybeStateB = void 0;

      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevColumnCount,
        cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: instanceProps.prevScrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
        }
      });
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: instanceProps.prevRowCount,
        cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
        computeMetadataCallback: function computeMetadataCallback() {
          return instanceProps.rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: instanceProps.prevScrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
        }
      });

      instanceProps.prevColumnCount = nextProps.columnCount;
      instanceProps.prevColumnWidth = nextProps.columnWidth;
      instanceProps.prevIsScrolling = nextProps.isScrolling === true;
      instanceProps.prevRowCount = nextProps.rowCount;
      instanceProps.prevRowHeight = nextProps.rowHeight;
      instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
      instanceProps.prevScrollToRow = nextProps.scrollToRow;

      // getting scrollBarSize (moved from componentWillMount)
      instanceProps.scrollbarSize = nextProps.getScrollbarSize();
      if (instanceProps.scrollbarSize === undefined) {
        instanceProps.scrollbarSizeMeasured = false;
        instanceProps.scrollbarSize = 0;
      } else {
        instanceProps.scrollbarSizeMeasured = true;
      }

      newState.instanceProps = instanceProps;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, newState, maybeStateA, maybeStateB);
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_getScrollToPositionStateUpdate',


    /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */
    value: function _getScrollToPositionStateUpdate(_ref9) {
      var prevState = _ref9.prevState,
          scrollLeft = _ref9.scrollLeft,
          scrollTop = _ref9.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (typeof scrollTop === 'number' && scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["b" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["a" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) {
        return newState;
      }
      return null;
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(value) {
      return typeof value === 'function' ? value : function () {
        return value;
      };
    }
  }, {
    key: '_getCalculatedScrollLeft',
    value: function _getCalculatedScrollLeft(nextProps, prevState) {
      var columnCount = nextProps.columnCount,
          height = nextProps.height,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToColumn = nextProps.scrollToColumn,
          width = nextProps.width;
      var scrollLeft = prevState.scrollLeft,
          instanceProps = prevState.instanceProps;


      if (columnCount > 0) {
        var finalColumn = columnCount - 1;
        var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
        var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;

        return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width - scrollBarSize,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollLeftForScrollToColumnStateUpdate',
    value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState) {
      var scrollLeft = prevState.scrollLeft;

      var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);

      if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: calculatedScrollLeft,
          scrollTop: -1
        });
      }
      return null;
    }
  }, {
    key: '_getCalculatedScrollTop',
    value: function _getCalculatedScrollTop(nextProps, prevState) {
      var height = nextProps.height,
          rowCount = nextProps.rowCount,
          scrollToAlignment = nextProps.scrollToAlignment,
          scrollToRow = nextProps.scrollToRow,
          width = nextProps.width;
      var scrollTop = prevState.scrollTop,
          instanceProps = prevState.instanceProps;


      if (rowCount > 0) {
        var finalRow = rowCount - 1;
        var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
        var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
        var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;

        return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height - scrollBarSize,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });
      }
      return 0;
    }
  }, {
    key: '_getScrollTopForScrollToRowStateUpdate',
    value: function _getScrollTopForScrollToRowStateUpdate(nextProps, prevState) {
      var scrollTop = prevState.scrollTop;

      var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);

      if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) {
        return Grid._getScrollToPositionStateUpdate({
          prevState: prevState,
          scrollLeft: -1,
          scrollTop: calculatedScrollTop
        });
      }
      return null;
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  'aria-readonly': true,
  autoContainerWidth: false,
  autoHeight: false,
  autoWidth: false,
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_14__defaultCellRangeRenderer__["a" /* default */],
  containerRole: 'rowgroup',
  containerStyle: {},
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  getScrollbarSize: __WEBPACK_IMPORTED_MODULE_15_dom_helpers_util_scrollbarSize___default.a,
  noContentRenderer: renderNull,
  onScroll: function onScroll() {},
  onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
  onSectionRendered: function onSectionRendered() {},
  overscanColumnCount: 0,
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_12__defaultOverscanIndicesGetter__["c" /* default */],
  overscanRowCount: 10,
  role: 'grid',
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  tabIndex: 0,
  isScrollingOptOut: false
};
Grid.propTypes =  true ? null : {
  "aria-label": PropTypes.string.isRequired,
  "aria-readonly": PropTypes.bool,


  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool.isRequired,


  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   */
  autoWidth: PropTypes.bool.isRequired,


  /** Responsible for rendering a cell given an row and column index.  */
  cellRenderer: function cellRenderer() {
    return (typeof bpfrpt_proptype_CellRenderer === 'function' ? bpfrpt_proptype_CellRenderer.isRequired ? bpfrpt_proptype_CellRenderer.isRequired : bpfrpt_proptype_CellRenderer : PropTypes.shape(bpfrpt_proptype_CellRenderer).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a group of cells given their index ranges.  */
  cellRangeRenderer: function cellRangeRenderer() {
    return (typeof bpfrpt_proptype_CellRangeRenderer === 'function' ? bpfrpt_proptype_CellRangeRenderer.isRequired ? bpfrpt_proptype_CellRangeRenderer.isRequired : bpfrpt_proptype_CellRangeRenderer : PropTypes.shape(bpfrpt_proptype_CellRangeRenderer).isRequired).apply(this, arguments);
  },


  /** Optional custom CSS class name to attach to root Grid element.  */
  className: PropTypes.string,


  /** Number of columns in grid.  */
  columnCount: PropTypes.number.isRequired,


  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  */
  columnWidth: function columnWidth() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Unfiltered props for the Grid container. */
  containerProps: PropTypes.object,


  /** ARIA role for the cell-container.  */
  containerRole: PropTypes.string.isRequired,


  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object.isRequired,


  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   */
  deferredMeasurementCache: PropTypes.object,


  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,


  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Exposed for testing purposes only.  */
  getScrollbarSize: PropTypes.func.isRequired,


  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  */
  height: PropTypes.number.isRequired,


  /** Optional custom id to attach to root Grid element.  */
  id: PropTypes.string,


  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   */
  isScrolling: PropTypes.bool,


  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   */
  isScrollingOptOut: PropTypes.bool.isRequired,


  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  */
  noContentRenderer: function noContentRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   */
  onScrollbarPresenceChange: PropTypes.func.isRequired,


  /** Callback invoked with information about the section of the Grid that was just rendered.  */
  onSectionRendered: PropTypes.func.isRequired,


  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,


  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** ARIA role for the grid element.  */
  role: PropTypes.string.isRequired,


  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Number of rows in grid.  */
  rowCount: PropTypes.number.isRequired,


  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Horizontal offset. */
  scrollLeft: PropTypes.number,


  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Column index to ensure visible (by forcefully scrolling if necessary) */
  scrollToColumn: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToRow: PropTypes.number.isRequired,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  */
  width: PropTypes.number.isRequired
};


Object(__WEBPACK_IMPORTED_MODULE_16_react_lifecycles_compat__["polyfill"])(Grid);
/* harmony default export */ __webpack_exports__["a"] = (Grid);
















/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1323), __esModule: true };

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1329), __esModule: true };

/***/ }),
/* 614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SCROLL_DIRECTION_FORWARD; });
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["c"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(18);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
  }
}



/***/ }),
/* 615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(18);


/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */

function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache,
      cellRenderer = _ref.cellRenderer,
      columnSizeAndPositionManager = _ref.columnSizeAndPositionManager,
      columnStartIndex = _ref.columnStartIndex,
      columnStopIndex = _ref.columnStopIndex,
      deferredMeasurementCache = _ref.deferredMeasurementCache,
      horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment,
      isScrolling = _ref.isScrolling,
      isScrollingOptOut = _ref.isScrollingOptOut,
      parent = _ref.parent,
      rowSizeAndPositionManager = _ref.rowSizeAndPositionManager,
      rowStartIndex = _ref.rowStartIndex,
      rowStopIndex = _ref.rowStopIndex,
      styleCache = _ref.styleCache,
      verticalOffsetAdjustment = _ref.verticalOffsetAdjustment,
      visibleColumnIndices = _ref.visibleColumnIndices,
      visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];

  // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
  // User cannot scroll beyond these size limitations.
  // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
  // We should never cache styles for compressed offsets though as this can lead to bugs.
  // See issue #576 for more.
  var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();

  var canCacheStyle = !isScrolling && !areOffsetsAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        // In deferred mode, cells will be initially rendered before we know their size.
        // Don't interfere with CellMeasurer's measurements by setting an invalid size.
        if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) {
          // Position not-yet-measured cells at top/left 0,0,
          // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
          // Positioning them further to the right/bottom influences their measured size.
          style = {
            height: 'auto',
            left: 0,
            position: 'absolute',
            top: 0,
            width: 'auto'
          };
        } else {
          style = {
            height: rowDatum.size,
            left: columnDatum.offset + horizontalOffsetAdjustment,
            position: 'absolute',
            top: rowDatum.offset + verticalOffsetAdjustment,
            width: columnDatum.size
          };

          styleCache[key] = style;
        }
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      //
      // If isScrollingOptOut is specified, we always cache cells.
      // For more info refer to issue #1028
      if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      if (false) {
        warnAboutMissingStyle(parent, renderedCell);
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

function warnAboutMissingStyle(parent, renderedCell) {
  if (false) {
    if (renderedCell) {
      // If the direct child is a CellMeasurer, then we should check its child
      // See issue #611
      if (renderedCell.type && renderedCell.type.__internalCellMeasurerFlag) {
        renderedCell = renderedCell.props.children;
      }

      if (renderedCell && renderedCell.props && renderedCell.props.style === undefined && parent.__warnedAboutMissingStyle !== true) {
        parent.__warnedAboutMissingStyle = true;

        console.warn('Rendered cell should include style property for positioning.');
      }
    }
  }
}


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM2.default) {
      var scrollDiv = document.createElement('div');

      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';

      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
};

var _inDOM = __webpack_require__(1332);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var size = void 0;

module.exports = exports['default'];

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(399);
var ITERATOR = __webpack_require__(56)('iterator');
var Iterators = __webpack_require__(162);
module.exports = __webpack_require__(40).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(90);
var aFunction = __webpack_require__(260);
var SPECIES = __webpack_require__(56)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(197);
var invoke = __webpack_require__(1340);
var html = __webpack_require__(608);
var cel = __webpack_require__(387);
var global = __webpack_require__(55);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(199)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(90);
var isObject = __webpack_require__(117);
var newPromiseCapability = __webpack_require__(400);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_ScrollIndices */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_ScrollIndices =  true ? null : {
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
};



/***/ }),
/* 623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);









var AutoSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AutoSizer, _React$PureComponent);

  function AutoSizer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      height: _this.props.defaultHeight || 0,
      width: _this.props.defaultWidth || 0
    }, _this._onResize = function () {
      var _this$props = _this.props,
          disableHeight = _this$props.disableHeight,
          disableWidth = _this$props.disableWidth,
          onResize = _this$props.onResize;


      if (_this._parentNode) {
        // Guard against AutoSizer component being removed from the DOM immediately after being added.
        // This can result in invalid style values which can result in NaN values if we don't handle them.
        // See issue #150 for more context.

        var _height = _this._parentNode.offsetHeight || 0;
        var _width = _this._parentNode.offsetWidth || 0;

        var _style = window.getComputedStyle(_this._parentNode) || {};
        var paddingLeft = parseInt(_style.paddingLeft, 10) || 0;
        var paddingRight = parseInt(_style.paddingRight, 10) || 0;
        var paddingTop = parseInt(_style.paddingTop, 10) || 0;
        var paddingBottom = parseInt(_style.paddingBottom, 10) || 0;

        var newHeight = _height - paddingTop - paddingBottom;
        var newWidth = _width - paddingLeft - paddingRight;

        if (!disableHeight && _this.state.height !== newHeight || !disableWidth && _this.state.width !== newWidth) {
          _this.setState({
            height: _height - paddingTop - paddingBottom,
            width: _width - paddingLeft - paddingRight
          });

          onResize({ height: _height, width: _width });
        }
      }
    }, _this._setRef = function (autoSizer) {
      _this._autoSizer = autoSizer;
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var nonce = this.props.nonce;

      if (this._autoSizer && this._autoSizer.parentNode && this._autoSizer.parentNode.ownerDocument && this._autoSizer.parentNode.ownerDocument.defaultView && this._autoSizer.parentNode instanceof this._autoSizer.parentNode.ownerDocument.defaultView.HTMLElement) {
        // Delay access of parentNode until mount.
        // This handles edge-cases where the component has already been unmounted before its ref has been set,
        // As well as libraries like react-lite which have a slightly different lifecycle.
        this._parentNode = this._autoSizer.parentNode;

        // Defer requiring resize handler in order to support server-side rendering.
        // See issue #41
        this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])(nonce);
        this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

        this._onResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize && this._parentNode) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeight = _props.disableHeight,
          disableWidth = _props.disableWidth,
          style = _props.style;
      var _state = this.state,
          height = _state.height,
          width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };
      var childParams = {};

      if (!disableHeight) {
        outerStyle.height = 0;
        childParams.height = height;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
        childParams.width = width;
      }

      /**
       * TODO: Avoid rendering children before the initial measurements have been collected.
       * At best this would just be wasting cycles.
       * Add this check into version 10 though as it could break too many ref callbacks in version 9.
       * Note that if default width/height props were provided this would still work with SSR.
      if (
        height !== 0 &&
        width !== 0
      ) {
        child = children({ height, width })
      }
      */

      return __WEBPACK_IMPORTED_MODULE_6_react__["createElement"](
        'div',
        {
          className: className,
          ref: this._setRef,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, outerStyle, style) },
        children(childParams)
      );
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {},
  disableHeight: false,
  disableWidth: false,
  style: {}
};
AutoSizer.propTypes =  true ? null : {
  /** Function responsible for rendering children.*/
  children: PropTypes.func.isRequired,


  /** Optional custom CSS class name to attach to root AutoSizer element.  */
  className: PropTypes.string,


  /** Default height to use for initial render; useful for SSR */
  defaultHeight: PropTypes.number,


  /** Default width to use for initial render; useful for SSR */
  defaultWidth: PropTypes.number,


  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool.isRequired,


  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool.isRequired,


  /** Nonce of the inlined stylesheet for Content Security Policy */
  nonce: PropTypes.string,


  /** Callback to be invoked on-resize */
  onResize: PropTypes.func.isRequired,


  /** Optional inline style */
  style: PropTypes.object
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);


/***/ }),
/* 624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 * 4) Add nonce for style element.
 **/

function createDetectElementResize(nonce) {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = global;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) {
        cancelFrame(this.__resizeRAF__);
      }
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles(doc) {
    if (!doc.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = doc.head || doc.getElementsByTagName('head')[0],
          style = doc.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';

      if (nonce != null) {
        style.setAttribute('nonce', nonce);
      }

      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(doc.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) {
      element.attachEvent('onresize', fn);
    } else {
      if (!element.__resizeTriggers__) {
        var doc = element.ownerDocument;
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles(doc);
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = doc.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) {
              resetTriggers(element);
            }
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) {
      element.detachEvent('onresize', fn);
    } else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CellMeasurerCache__ = __webpack_require__(1352);
/* unused harmony reexport CellMeasurer */
/* unused harmony reexport CellMeasurerCache */



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a" /* default */]);


/***/ }),
/* 626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bpfrpt_proptype_CellMeasureCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
var bpfrpt_proptype_CellMeasureCache =  true ? null : {
  hasFixedWidth: PropTypes.func.isRequired,
  hasFixedHeight: PropTypes.func.isRequired,
  has: PropTypes.func.isRequired,
  set: PropTypes.func.isRequired,
  getHeight: PropTypes.func.isRequired,
  getWidth: PropTypes.func.isRequired
};



/***/ }),
/* 627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Grid__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__types__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);











/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(List, _React$PureComponent);

  function List() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, List);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = List.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(List)).call.apply(_ref, [this].concat(args))), _this), _this._cellRenderer = function (_ref2) {
      var parent = _ref2.parent,
          rowIndex = _ref2.rowIndex,
          style = _ref2.style,
          isScrolling = _ref2.isScrolling,
          isVisible = _ref2.isVisible,
          key = _ref2.key;
      var rowRenderer = _this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width'),
          writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer({
        index: rowIndex,
        style: style,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        parent: parent
      });
    }, _this._setRef = function (ref) {
      _this.Grid = ref;
    }, _this._onScroll = function (_ref3) {
      var clientHeight = _ref3.clientHeight,
          scrollHeight = _ref3.scrollHeight,
          scrollTop = _ref3.scrollTop;
      var onScroll = _this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }, _this._onSectionRendered = function (_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref4.rowOverscanStopIndex,
          rowStartIndex = _ref4.rowStartIndex,
          rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = _this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref5) {
      var alignment = _ref5.alignment,
          index = _ref5.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index,
          columnIndex: 0
        }),
            _scrollTop = _Grid$getOffsetForCel.scrollTop;

        return _scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref6) {
      var columnIndex = _ref6.columnIndex,
          rowIndex = _ref6.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref7 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref7$columnIndex = _ref7.columnIndex,
          columnIndex = _ref7$columnIndex === undefined ? 0 : _ref7$columnIndex,
          _ref7$rowIndex = _ref7.rowIndex,
          rowIndex = _ref7$rowIndex === undefined ? 0 : _ref7$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index,
          columnIndex: 0
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          noRowsRenderer = _props.noRowsRenderer,
          scrollToIndex = _props.scrollToIndex,
          width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: this._setRef,
        scrollToRow: scrollToIndex
      }));
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

List.defaultProps = {
  autoHeight: false,
  estimatedRowSize: 30,
  onScroll: function onScroll() {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {},
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_7__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
List.propTypes =  true ? null : {
  "aria-label": PropTypes.string,


  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool.isRequired,


  /** Optional CSS class name */
  className: PropTypes.string,


  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,


  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,


  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: function noRowsRenderer() {
    return (typeof bpfrpt_proptype_NoContentRenderer === 'function' ? bpfrpt_proptype_NoContentRenderer.isRequired ? bpfrpt_proptype_NoContentRenderer.isRequired : bpfrpt_proptype_NoContentRenderer : PropTypes.shape(bpfrpt_proptype_NoContentRenderer).isRequired).apply(this, arguments);
  },


  /** Callback invoked with information about the slice of rows that were just rendered.  */

  onRowsRendered: PropTypes.func.isRequired,


  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   */
  onScroll: PropTypes.func.isRequired,


  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: function overscanIndicesGetter() {
    return (typeof bpfrpt_proptype_OverscanIndicesGetter === 'function' ? bpfrpt_proptype_OverscanIndicesGetter.isRequired ? bpfrpt_proptype_OverscanIndicesGetter.isRequired : bpfrpt_proptype_OverscanIndicesGetter : PropTypes.shape(bpfrpt_proptype_OverscanIndicesGetter).isRequired).apply(this, arguments);
  },


  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,


  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  */
  rowHeight: function rowHeight() {
    return (typeof bpfrpt_proptype_CellSize === 'function' ? bpfrpt_proptype_CellSize.isRequired ? bpfrpt_proptype_CellSize.isRequired : bpfrpt_proptype_CellSize : PropTypes.shape(bpfrpt_proptype_CellSize).isRequired).apply(this, arguments);
  },


  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: function rowRenderer() {
    return (typeof bpfrpt_proptype_RowRenderer === 'function' ? bpfrpt_proptype_RowRenderer.isRequired ? bpfrpt_proptype_RowRenderer.isRequired : bpfrpt_proptype_RowRenderer : PropTypes.shape(bpfrpt_proptype_RowRenderer).isRequired).apply(this, arguments);
  },


  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,


  /** See Grid#scrollToAlignment */
  scrollToAlignment: function scrollToAlignment() {
    return (typeof bpfrpt_proptype_Alignment === 'function' ? bpfrpt_proptype_Alignment.isRequired ? bpfrpt_proptype_Alignment.isRequired : bpfrpt_proptype_Alignment : PropTypes.shape(bpfrpt_proptype_Alignment).isRequired).apply(this, arguments);
  },


  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,


  /** Vertical offset. */
  scrollTop: PropTypes.number,


  /** Optional inline style */
  style: PropTypes.object.isRequired,


  /** Tab index for focus */
  tabIndex: PropTypes.number,


  /** Width of list */
  width: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (List);













/***/ }),
/* 628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(201);


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var dataKey = _ref.dataKey,
      rowData = _ref.rowData;

  if (typeof rowData.get === 'function') {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}


/***/ }),
/* 629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(201);


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}


/***/ }),
/* 630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);



function defaultHeaderRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      style = _ref.style;

  return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'div',
    { className: className, role: 'row', style: style },
    columns
  );
}
defaultHeaderRowRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRowRendererParams;



/***/ }),
/* 631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var dataKey = _ref.dataKey,
      label = _ref.label,
      sortBy = _ref.sortBy,
      sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: label },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], { key: 'SortIndicator', sortDirection: sortDirection }));
  }

  return children;
}
defaultHeaderRenderer.propTypes =  true ? null : bpfrpt_proptype_HeaderRendererParams === PropTypes.any ? {} : bpfrpt_proptype_HeaderRendererParams;



/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SortDirection__ = __webpack_require__(267);





/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = __WEBPACK_IMPORTED_MODULE_0_classnames___default()('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_2_react__["createElement"](
    'svg',
    { className: classNames, width: 18, height: 18, viewBox: '0 0 24 24' },
    sortDirection === __WEBPACK_IMPORTED_MODULE_3__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_2_react__["createElement"]('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

SortIndicator.propTypes =  false ? {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : {};

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      index = _ref.index,
      key = _ref.key,
      onRowClick = _ref.onRowClick,
      onRowDoubleClick = _ref.onRowDoubleClick,
      onRowMouseOut = _ref.onRowMouseOut,
      onRowMouseOver = _ref.onRowMouseOver,
      onRowRightClick = _ref.onRowRightClick,
      rowData = _ref.rowData,
      style = _ref.style;

  var a11yProps = {};

  if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
    a11yProps['aria-label'] = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function (event) {
        return onRowClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function (event) {
        return onRowDoubleClick({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function (event) {
        return onRowMouseOut({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function (event) {
        return onRowMouseOver({ event: event, index: index, rowData: rowData });
      };
    }
    if (onRowRightClick) {
      a11yProps.onContextMenu = function (event) {
        return onRowRightClick({ event: event, index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      role: 'row',
      style: style }),
    columns
  );
}
defaultRowRenderer.propTypes =  true ? null : bpfrpt_proptype_RowRendererParams === PropTypes.any ? {} : bpfrpt_proptype_RowRendererParams;



/***/ }),
/* 634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SortDirection__ = __webpack_require__(267);











/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _React$Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_8__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_7__defaultCellRenderer__["a" /* default */],
  defaultSortDirection: __WEBPACK_IMPORTED_MODULE_9__SortDirection__["a" /* default */].ASC,
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
Column.propTypes =  false ? {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute corresponding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** Optional direction to be used when clicked the first time */
  defaultSortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: node, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Optional inline style to apply to this column's header */
  headerStyle: PropTypes.object,

  /** Optional id to set on the column header */
  id: PropTypes.string,

  /** Header label for this column */
  label: PropTypes.node,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__ = __webpack_require__(624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types__);












/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

var getWindow = function getWindow() {
  return typeof window !== 'undefined' ? window : undefined;
};

var WindowScroller = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(WindowScroller, _React$PureComponent);

  function WindowScroller() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call.apply(_ref, [this].concat(args))), _this), _this._window = getWindow(), _this._isMounted = false, _this._positionFromTop = 0, _this._positionFromLeft = 0, _this.state = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(_this.props.scrollElement, _this.props), {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    }), _this._registerChild = function (element) {
      if (element && !(element instanceof Element)) {
        console.warn('WindowScroller registerChild expects to be passed Element or null');
      }
      _this._child = element;
      _this.updatePosition();
    }, _this._onChildScroll = function (_ref2) {
      var scrollTop = _ref2.scrollTop;

      if (_this.state.scrollTop === scrollTop) {
        return;
      }

      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        if (typeof scrollElement.scrollTo === 'function') {
          scrollElement.scrollTo(0, scrollTop + _this._positionFromTop);
        } else {
          scrollElement.scrollTop = scrollTop + _this._positionFromTop;
        }
      }
    }, _this._registerResizeListener = function (element) {
      if (element === window) {
        window.addEventListener('resize', _this._onResize, false);
      } else {
        _this._detectElementResize.addResizeListener(element, _this._onResize);
      }
    }, _this._unregisterResizeListener = function (element) {
      if (element === window) {
        window.removeEventListener('resize', _this._onResize, false);
      } else if (element) {
        _this._detectElementResize.removeResizeListener(element, _this._onResize);
      }
    }, _this._onResize = function () {
      _this.updatePosition();
    }, _this.__handleWindowScrollEvent = function () {
      if (!_this._isMounted) {
        return;
      }

      var onScroll = _this.props.onScroll;


      var scrollElement = _this.props.scrollElement;
      if (scrollElement) {
        var scrollOffset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollOffset */])(scrollElement);
        var _scrollLeft = Math.max(0, scrollOffset.left - _this._positionFromLeft);
        var _scrollTop = Math.max(0, scrollOffset.top - _this._positionFromTop);

        _this.setState({
          isScrolling: true,
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });

        onScroll({
          scrollLeft: _scrollLeft,
          scrollTop: _scrollTop
        });
      }
    }, _this.__resetIsScrolling = function () {
      _this.setState({
        isScrolling: false
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition() {
      var scrollElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.scrollElement;
      var onResize = this.props.onResize;
      var _state = this.state,
          height = _state.height,
          width = _state.width;


      var thisNode = this._child || __WEBPACK_IMPORTED_MODULE_7_react_dom__["findDOMNode"](this);
      if (thisNode instanceof Element && scrollElement) {
        var offset = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionOffset */])(thisNode, scrollElement);
        this._positionFromTop = offset.top;
        this._positionFromLeft = offset.left;
      }

      var dimensions = Object(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getDimensions */])(scrollElement, this.props);
      if (height !== dimensions.height || width !== dimensions.width) {
        this.setState({
          height: dimensions.height,
          width: dimensions.width
        });
        onResize({
          height: dimensions.height,
          width: dimensions.width
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement;

      this._detectElementResize = Object(__WEBPACK_IMPORTED_MODULE_10__vendor_detectElementResize__["a" /* default */])();

      this.updatePosition(scrollElement);

      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);
        this._registerResizeListener(scrollElement);
      }

      this._isMounted = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var scrollElement = this.props.scrollElement;
      var prevScrollElement = prevProps.scrollElement;


      if (prevScrollElement !== scrollElement && prevScrollElement != null && scrollElement != null) {
        this.updatePosition(scrollElement);

        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, prevScrollElement);
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

        this._unregisterResizeListener(prevScrollElement);
        this._registerResizeListener(scrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var scrollElement = this.props.scrollElement;
      if (scrollElement) {
        Object(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        this._unregisterResizeListener(scrollElement);
      }

      this._isMounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollTop = _state2.scrollTop,
          scrollLeft = _state2.scrollLeft,
          height = _state2.height,
          width = _state2.width;


      return children({
        onChildScroll: this._onChildScroll,
        registerChild: this._registerChild,
        height: height,
        isScrolling: isScrolling,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        width: width
      });
    }

    // Referenced by utils/onScroll


    // Referenced by utils/onScroll

  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {},
  scrollingResetTimeInterval: IS_SCROLLING_TIMEOUT,
  scrollElement: getWindow(),
  serverHeight: 0,
  serverWidth: 0
};
WindowScroller.propTypes =  true ? null : {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollLeft, scrollTop, width }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,


  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired,


  /** Callback to be invoked on-scroll: ({ scrollLeft, scrollTop }) */
  onScroll: PropTypes.func.isRequired,


  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.oneOfType([PropTypes.any, function () {
    return (typeof Element === 'function' ? PropTypes.instanceOf(Element) : PropTypes.any).apply(this, arguments);
  }]),

  /**
   * Wait this amount of time after the last scroll event before resetting child `pointer-events`.
   */
  scrollingResetTimeInterval: PropTypes.number.isRequired,


  /** Height used for server-side rendering */
  serverHeight: PropTypes.number.isRequired,


  /** Width used for server-side rendering */
  serverWidth: PropTypes.number.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);


/***/ }),
/* 636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isValid;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `true`        |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  return !isNaN(date);
}

/***/ }),
/* 637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__ = __webpack_require__(1401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__ = __webpack_require__(1403);





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  formatDistance: __WEBPACK_IMPORTED_MODULE_0__lib_formatDistance_index_js__["a" /* default */],
  formatLong: __WEBPACK_IMPORTED_MODULE_1__lib_formatLong_index_js__["a" /* default */],
  formatRelative: __WEBPACK_IMPORTED_MODULE_2__lib_formatRelative_index_js__["a" /* default */],
  localize: __WEBPACK_IMPORTED_MODULE_3__lib_localize_index_js__["a" /* default */],
  match: __WEBPACK_IMPORTED_MODULE_4__lib_match_index_js__["a" /* default */],
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ __webpack_exports__["a"] = (locale);

/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = subMilliseconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(402);


/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, -amount);
}

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__ = __webpack_require__(1409);



var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(date).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCISOWeekYear_index_js__["a" /* default */])(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(268);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__ = __webpack_require__(1410);



var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCWeek_index_js__["a" /* default */])(date, options).getTime() - Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeekYear_index_js__["a" /* default */])(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["a"] = (longFormatters);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isProtectedDayOfYearToken;
/* harmony export (immutable) */ __webpack_exports__["b"] = isProtectedWeekYearToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token) {
  if (token === 'YYYY') {
    throw new RangeError('Use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'YY') {
    throw new RangeError('Use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr');
  } else if (token === 'D') {
    throw new RangeError('Use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr');
  } else if (token === 'DD') {
    throw new RangeError('Use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr');
  }
}

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(402);


var MILLISECONDS_IN_MINUTE = 60000;
/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */

function addMinutes(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__ = __webpack_require__(402);


var MILLISECONDS_IN_HOUR = 3600000;
/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */

function addHours(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMilliseconds_index_js__["a" /* default */])(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/***/ }),
/* 647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(404);


/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */

function addWeeks(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  var days = amount * 7;
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["default"])(dirtyDate, days);
}

/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDaysInMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */

function getDaysInMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = addYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(405);


/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["default"])(dirtyDate, amount * 12);
}

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__ = __webpack_require__(648);



/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */

function setMonth(dirtyDate, dirtyMonth) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var month = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = Object(__WEBPACK_IMPORTED_MODULE_2__getDaysInMonth_index_js__["a" /* default */])(dateWithDesiredMonth); // Set the last day of the new month
  // if the original date was the last day of the longer month

  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(19);


/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */

function startOfQuarter(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 653 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return safeInvoke; });
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === "function") {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};

/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Shields; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return comps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TradeMobile_Popup__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TradeModals_Modal__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ShieldIcon__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shieldImage_svg__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shieldImage_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__shieldImage_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__protected_svg__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__protected_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__protected_svg__);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  min-height: 100%;\n  margin: 0 auto;\n  padding: 15px;\n  direction: ",";\n\n  @media (min-width: 960px) {\n    padding: 35px;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  min-height: 100%;\n  margin: 0 auto;\n  padding: 15px;\n  direction: ",";\n\n  @media (min-width: 960px) {\n    padding: 35px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-bottom: 17px;\n"],["\n  margin-bottom: 17px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: 171px;\n  margin-bottom: 8px;\n\n  > div {\n    font-size: 18px !important;\n  }\n"],["\n  display: inline-block;\n  min-width: 171px;\n  margin-bottom: 8px;\n\n  > div {\n    font-size: 18px !important;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: bold;\n  line-height: 20px;\n  font-size: ",";\n  vertical-align: middle;\n"],["\n  font-weight: bold;\n  line-height: 20px;\n  font-size: ",";\n  vertical-align: middle;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  text-align: center;\n  font-size: ",";\n  color: ",";\n"],["\n  margin-bottom: 10px;\n  text-align: center;\n  font-size: ",";\n  color: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  color: ",";\n"],["\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  color: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: center;\n  align-items: center;\n  margin-top: 17px;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: center;\n  align-items: center;\n  margin-top: 17px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n\n  :first-of-type {\n    width: 43px;\n    margin-right: -10px;\n    z-index: 1;\n  }\n\n  :last-of-type {\n    width: 43px;\n    margin-left: -10px;\n    z-index: 1;\n  }\n"],["\n  position: relative;\n  z-index: 2;\n\n  :first-of-type {\n    width: 43px;\n    margin-right: -10px;\n    z-index: 1;\n  }\n\n  :last-of-type {\n    width: 43px;\n    margin-left: -10px;\n    z-index: 1;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  margin: 17px 0;\n  font-size: ",";\n  line-height: 1.71;\n  font-weight: bold;\n  color: ",";\n  text-align: center;\n"],["\n  margin: 17px 0;\n  font-size: ",";\n  line-height: 1.71;\n  font-weight: bold;\n  color: ",";\n  text-align: center;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  height: 12px;\n\n  > svg {\n    ",";\n\n    :last-of-type {\n      ",";\n    }\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  height: 12px;\n\n  > svg {\n    ",";\n\n    :last-of-type {\n      ",";\n    }\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  @media (max-width: 959px) and (orientation: landscape) {\n    display: flex;\n    justify-content: center;\n  }\n"],["\n  @media (max-width: 959px) and (orientation: landscape) {\n    display: flex;\n    justify-content: center;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  text-align: center;\n  font-size: ",";\n  color: #919191;\n\n  @media (max-width: 959px) and (orientation: landscape) {\n    margin-right: 6px;\n  }\n"],["\n  margin-bottom: 8px;\n  text-align: center;\n  font-size: ",";\n  color: #919191;\n\n  @media (max-width: 959px) and (orientation: landscape) {\n    margin-right: 6px;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n  cursor: pointer;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n"],["\n  font-size: ",";\n  color: ",";\n  cursor: pointer;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  margin: 16px 0 24px;\n  font-size: 22px;\n  line-height: 1.2;\n  font-weight: 700;\n  color: ",";\n  text-align: center;\n"],["\n  margin: 16px 0 24px;\n  font-size: 22px;\n  line-height: 1.2;\n  font-weight: 700;\n  color: ",";\n  text-align: center;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  margin-top: 24px;\n  font-size: ",";\n  line-height: 1.2;\n  color: #919191;\n  text-align: center;\n"],["\n  margin-top: 24px;\n  font-size: ",";\n  line-height: 1.2;\n  color: #919191;\n  text-align: center;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  padding: 10px;\n  background: ",";\n  border-radius: 5px 0 5px 0;\n  font-size: ",";\n  color: ",";\n  text-transform: uppercase;\n\n  @media (max-width: 959px) {\n    border-radius: 0;\n  }\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  padding: 10px;\n  background: ",";\n  border-radius: 5px 0 5px 0;\n  font-size: ",";\n  color: ",";\n  text-transform: uppercase;\n\n  @media (max-width: 959px) {\n    border-radius: 0;\n  }\n"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;});var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var BottomContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4);var ButtonText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12));var TimerContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14),function(_ref2){var theme=_ref2.theme;return theme.compensationSubtitle;});var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7,function(_ref3){var type=_ref3.type,theme=_ref3.theme;switch(type){case"success":return theme.compensationSuccessTitle;case"refill":return theme.compensationRefillTitle;case"compensate":return"#E74C3C";default:return null;}});var ImageContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject8);var ShieldImage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].img(_templateObject9);var Subtitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14),function(_ref4){var theme=_ref4.theme;return theme.compensationSubtitle;});var ShieldsContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("margin-right","4px"),Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("margin-right",0));var DealsCountContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject12);var DealsCountText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12));var ActionButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject14,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12),function(_ref5){var theme=_ref5.theme;return theme.compensationActionButton;});var AmountOfDealsBlock=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject15,function(_ref6){var theme=_ref6.theme;return theme.compensationSubtitle;});var RefillDescription=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].p(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12));var AccountType=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject17,function(_ref7){var isReal=_ref7.isReal;return isReal?"#27c191":"#ffcc00";},Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12),function(_ref8){var isReal=_ref8.isReal;return isReal?"white":"black";});var Shields=function Shields(props){try{var MAX_COUNT=5;var available=Array.from({length:props.availableCompensations});var used=Array.from({length:props.usedCompensations});var total=Number(props.availableCompensations)+Number(props.usedCompensations);var shields=available.map(function(_,key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ShieldIcon__["a" /* default */],{isActive:true,key:key});}).concat(used.map(function(_,key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__ShieldIcon__["a" /* default */],{isActive:false,key:key+MAX_COUNT});}));if(total>MAX_COUNT){return shields.slice(0,MAX_COUNT);}else{return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,shields);}}catch(error){console.log(error);return null;}};var PopupLayout=function PopupLayout(props){return props.isDesktop?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TradeModals_Modal__["a" /* default */],{key:props.deal&&props.deal.id,onDismiss:props.closeModal,disableOutside:props.disableOutside},props.children):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Animations__["a" /* Fade */],{"in":true},function(_ref9){var style=_ref9.style;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__TradeMobile_Popup__["a" /* default */],{title:null,onClick:props.closeModal,style:style,darkMode:true,isCompensation:true},props.children);});};var Timer=function Timer(_ref10){var time=_ref10.time,compensateCountdown=_ref10.compensateCountdown;var duration=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(time,"seconds");var h=duration.hours()<10?"0"+duration.hours():duration.hours();var m=duration.minutes()<10?"0"+duration.minutes():duration.minutes();var s=duration.seconds()<10?"0"+duration.seconds():duration.seconds();if(compensateCountdown>=3600){return h+":"+m+":"+s;}return m+":"+s;};var comps=function comps(compensations,type,typeAccount){if(compensations!=null&&compensations[typeAccount]!=null&&typeAccount){return compensations[typeAccount].items.reduce(function(acc,item){return type==="available"?acc+item.available:acc+item.used;},0);}};var Popup=__WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(function(props){var onDismiss=props.onDismiss,onCompensation=props.onCompensation,popupType=props.popupType,loading=props.loading,deal=props.deal,compensations=props.compensations,time=props.time,isDesktop=props.isDesktop,compensationCreated=props.compensationCreated,onCompensationCreated=props.onCompensationCreated,onDetails=props.onDetails,disableOutside=props.disableOutside,compensateCountdown=props.compensateCountdown,isInfo=props.isInfo,activeAccount=props.activeAccount;var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),spinner=_useState2[0],setSpinner=_useState2[1];var isCompensationCreated=popupType==="refill"&&!isInfo&&compensationCreated!=null;var typeAccount=popupType==="refill"&&!isInfo&&compensationCreated!=null?compensationCreated.payload.real===1?"real":"demo":activeAccount&&activeAccount.type;var availableCompensations=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return comps(compensations,"available",typeAccount);},[compensations,typeAccount]);var usedCompensations=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useMemo"])(function(){return comps(compensations,"used",typeAccount);},[compensations,typeAccount]);var amount_limit=__WEBPACK_IMPORTED_MODULE_4_idx___default()(compensations,function(_){return _[typeAccount].items[0].amount_limit;})||0;var closeModal=function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(type){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(popupType==="compensate"){type==="timeout"?Object(__WEBPACK_IMPORTED_MODULE_10__GA__["a" /* gaReducer */])("COMPENSATE_TIMEOUT",{amount:Math.abs(deal.profit)}):Object(__WEBPACK_IMPORTED_MODULE_10__GA__["a" /* gaReducer */])("CANCEL_COMPENSATE",{amount:Math.abs(deal.profit)});}if(!(popupType==="refill"&&compensationCreated!=null)){_context.next=9;break;}if(!(type==="simpleClose")){_context.next=5;break;}onDismiss();return _context.abrupt("return");case 5:setSpinner(true);_context.next=8;return onCompensationCreated();case 8:setSpinner(false);case 9:onDismiss();case 10:case"end":return _context.stop();}}},_callee,_this);}));return function closeModal(_x){return _ref11.apply(this,arguments);};}();if(popupType==="compensate"&&time<0){closeModal("timeout");}var titleText=function titleText(){switch(popupType){case"success":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Your trade is covered!");case"compensate":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Your trade was unsuccessful!");default:return null;}};var subtitle=function subtitle(){switch(popupType){case"success":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Subtitle,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You've used ",usedCompensations," out of ",availableCompensations+usedCompensations," risk-free trades. Now the money will be credited back to your account."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Please be more careful in the future!"));case"compensate":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Subtitle,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Do you want to apply a risk-free trade to cover your losses of ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Money__["b" /* default */],null,Math.abs(deal.profit)),"?"));default:return null;}};return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PopupLayout,{closeModal:isCompensationCreated&&compensationCreated.payload.real===1?function(){return closeModal("simpleClose");}:closeModal,isDesktop:isDesktop,disableOutside:disableOutside||isCompensationCreated&&compensationCreated.payload.real===1,deal:deal},isCompensationCreated&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AccountType,{isReal:typeAccount==="real"},typeAccount==="demo"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Demo account"):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Real account")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Content,null,popupType!=="refill"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,{type:popupType},titleText()),popupType==="refill"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AmountOfDealsBlock,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Hey! Don't worry about making mistakes from now!"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"We will return your money for the next ",availableCompensations," unlucky trades.")),popupType!=="refill"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ImageContainer,null,popupType==="success"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_15__protected_svg___default.a,alt:""}):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShieldImage,{src:__WEBPACK_IMPORTED_MODULE_14__shieldImage_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShieldImage,{src:__WEBPACK_IMPORTED_MODULE_14__shieldImage_svg___default.a}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShieldImage,{src:__WEBPACK_IMPORTED_MODULE_14__shieldImage_svg___default.a}))),subtitle(),popupType==="refill"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DealsCountContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShieldsContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Shields,{availableCompensations:availableCompensations,usedCompensations:0}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DealsCountContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(DealsCountText,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Available risk-free trades:")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ShieldsContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Shields,{availableCompensations:availableCompensations,usedCompensations:usedCompensations}))),popupType==="refill"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(RefillDescription,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"This is the number of risk-free trades you can apply to cover your losses in case of bad deals."),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"We can refund any trades worth up to ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Money__["b" /* default */],null,amount_limit),". Don't invest more until you get more confident."))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BottomContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Button__["a" /* default */],{color:"green",isIron:true,newStyle:true,onClick:popupType==="success"||popupType==="refill"?closeModal:onCompensation,showSpinner:loading||spinner},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ButtonText,null,popupType==="success"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Trade"):popupType==="refill"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Good luck"):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Apply")))),popupType==="compensate"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TimerContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Timer,{time:time,compensateCountdown:compensateCountdown})),popupType!=="refill"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ActionButton,{onClick:popupType==="success"?onDetails:closeModal},popupType==="compensate"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Cancel"):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Details")))));});/* harmony default export */ __webpack_exports__["c"] = (Popup);

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = undefined;

var _propTypes = __webpack_require__(6);

var PropTypes = _interopRequireWildcard(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactLifecyclesCompat = __webpack_require__(102);

var _PropTypes = __webpack_require__(658);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UNMOUNTED = exports.UNMOUNTED = 'unmounted';
var EXITED = exports.EXITED = 'exited';
var ENTERING = exports.ENTERING = 'entering';
var ENTERED = exports.ENTERED = 'entered';
var EXITING = exports.EXITING = 'exiting';

/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the components.
 * It's up to you to give meaning and effect to those states. For example we can
 * add styles to a component when it enters or exits:
 *
 * ```jsx
 * import Transition from 'react-transition-group/Transition';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {(state) => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * As noted the `Transition` component doesn't _do_ anything by itself to its child component.
 * What it does do is track transition states over time so you can update the
 * component (such as by adding styles or classes) when it changes states.
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component begins the
 * "Enter" stage. During this stage, the component will shift from its current transition state,
 * to `'entering'` for the duration of the transition and then to the `'entered'` stage once
 * it's complete. Let's take the following example:
 *
 * ```jsx
 * state = { in: false };
 *
 * toggleEnterState = () => {
 *   this.setState({ in: true });
 * }
 *
 * render() {
 *   return (
 *     <div>
 *       <Transition in={this.state.in} timeout={500} />
 *       <button onClick={this.toggleEnterState}>Click to Enter</button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state and
 * stay there for 500ms (the value of `timeout`) before it finally switches to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from `'exiting'` to `'exited'`.
 *
 * ## Timing
 *
 * Timing is often the trickiest part of animation, mistakes can result in slight delays
 * that are hard to pin down. A common example is when you want to add an exit transition,
 * you should set the desired final styles when the state is `'exiting'`. That's when the
 * transition to those styles will start and, if you matched the `timeout` prop with the
 * CSS Transition duration, it will end exactly when the state changes to `'exited'`.
 *
 * > **Note**: For simpler transitions the `Transition` component might be enough, but
 * > take into account that it's platform-agnostic, while the `CSSTransition` component
 * > [forces reflows](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * > in order to make more complex transitions more predictable. For example, even though
 * > classes `example-enter` and `example-enter-active` are applied immediately one after
 * > another, you can still transition from one to the other because of the forced reflow
 * > (read [this issue](https://github.com/reactjs/react-transition-group/issues/159#issuecomment-322761171)
 * > for more info). Take this into account when choosing between `Transition` and
 * > `CSSTransition`.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/741op4mmj0?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 *
 */

var Transition = function (_React$Component) {
  _inherits(Transition, _React$Component);

  function Transition(props, context) {
    _classCallCheck(this, Transition);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var parentGroup = context.transitionGroup;
    // In the context of a TransitionGroup all enters are really appears
    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;

    var initialStatus = void 0;

    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = { status: initialStatus };

    _this.nextCallback = null;
    return _this;
  }

  Transition.prototype.getChildContext = function getChildContext() {
    return { transitionGroup: null // allows for nested Transitions
    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return { status: EXITED };
    }
    return null;
  };

  // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null

  //   if (prevProps !== this.props) {
  //     const { status } = this.state

  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }

  //   return { nextStatus }
  // }

  Transition.prototype.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  Transition.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;
    if (prevProps !== this.props) {
      var status = this.state.status;


      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }
    this.updateStatus(false, nextStatus);
  };

  Transition.prototype.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  Transition.prototype.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;

    var exit = void 0,
        enter = void 0,
        appear = void 0;

    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter;
      appear = timeout.appear;
    }
    return { exit: exit, enter: enter, appear: appear };
  };

  Transition.prototype.updateStatus = function updateStatus() {
    var mounting = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var nextStatus = arguments[1];

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = _reactDom2.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({ status: UNMOUNTED });
    }
  };

  Transition.prototype.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;

    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;

    var timeouts = this.getTimeouts();

    // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set
    if (!mounting && !enter) {
      this.safeSetState({ status: ENTERED }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);

    this.safeSetState({ status: ENTERING }, function () {
      _this2.props.onEntering(node, appearing);

      // FIXME: appear timeout?
      _this2.onTransitionEnd(node, timeouts.enter, function () {
        _this2.safeSetState({ status: ENTERED }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  Transition.prototype.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;

    var timeouts = this.getTimeouts();

    // no exit animation skip right to EXITED
    if (!exit) {
      this.safeSetState({ status: EXITED }, function () {
        _this3.props.onExited(node);
      });
      return;
    }
    this.props.onExit(node);

    this.safeSetState({ status: EXITING }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({ status: EXITED }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  Transition.prototype.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  Transition.prototype.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  Transition.prototype.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;

        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  Transition.prototype.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);

    if (node) {
      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }
      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    } else {
      setTimeout(this.nextCallback, 0);
    }
  };

  Transition.prototype.render = function render() {
    var status = this.state.status;
    if (status === UNMOUNTED) {
      return null;
    }

    var _props = this.props,
        children = _props.children,
        childProps = _objectWithoutProperties(_props, ['children']);
    // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react2.default.Children.only(children);
    return _react2.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react2.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};


Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element.
   * This function is called with the current transition status
   * ('entering', 'entered', 'exiting', 'exited', 'unmounted'), which can be used
   * to apply context specific props to a component.
   *
   * ```jsx
   * <Transition timeout={150}>
   *   {(status) => (
   *     <MyComponent className={`fade fade-${status}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided
   *
   * You may specify a single timeout for all transitions like: `timeout={500}`,
   * or individually like:
   *
   * ```jsx
   * timeout={{
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * @type {number | { enter?: number, exit?: number }}
   */
  timeout: function timeout(props) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;
    return pt.apply(undefined, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func

  // Name the function so it is clearer in the documentation
} : {};function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,

  onEnter: noop,
  onEntering: noop,
  onEntered: noop,

  onExit: noop,
  onExiting: noop,
  onExited: noop
};

Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

exports.default = (0, _reactLifecyclesCompat.polyfill)(Transition);

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var timeoutsShape = exports.timeoutsShape = _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.shape({
  enter: _propTypes2.default.number,
  exit: _propTypes2.default.number
}).isRequired]);

var classNamesShape = exports.classNamesShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterDone: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  exit: _propTypes2.default.string,
  exitDone: _propTypes2.default.string,
  exitActive: _propTypes2.default.string
})]);

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactLifecyclesCompat = __webpack_require__(102);

var _ChildMapping = __webpack_require__(1467);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var propTypes = {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: _propTypes2.default.any,
  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   */
  children: _propTypes2.default.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: _propTypes2.default.bool,
  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: _propTypes2.default.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: _propTypes2.default.func
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }

  /**
   * The `<TransitionGroup>` component manages a set of `<Transition>` components
   * in a list. Like with the `<Transition>` component, `<TransitionGroup>`, is a
   * state machine for managing the mounting and unmounting of components over
   * time.
   *
   * Consider the example below using the `Fade` CSS transition from before.
   * As items are removed or added to the TodoList the `in` prop is toggled
   * automatically by the `<TransitionGroup>`. You can use _any_ `<Transition>`
   * component in a `<TransitionGroup>`, not just css.
   *
   * ## Example
   *
   * <iframe src="https://codesandbox.io/embed/00rqyo26kn?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual `<Transition>`
   * components. This means you can mix and match animations across different
   * list items.
   */
};
var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    var handleExited = _this.handleExited.bind(_this);

    // Initial children should all be entering, dependent on appear
    _this.state = {
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  TransitionGroup.prototype.getChildContext = function getChildContext() {
    return {
      transitionGroup: { isMounting: !this.appeared }
    };
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;

    return {
      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  TransitionGroup.prototype.handleExited = function handleExited(child, node) {
    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);

    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    this.setState(function (state) {
      var children = _extends({}, state.children);

      delete children[child.key];
      return { children: children };
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _props = this.props,
        Component = _props.component,
        childFactory = _props.childFactory,
        props = _objectWithoutProperties(_props, ['component', 'childFactory']);

    var children = values(this.state.children).map(childFactory);

    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return children;
    }
    return _react2.default.createElement(
      Component,
      props,
      children
    );
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.childContextTypes = {
  transitionGroup: _propTypes2.default.object.isRequired
};


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = (0, _reactLifecyclesCompat.polyfill)(TransitionGroup);
module.exports = exports['default'];

/***/ }),
/* 660 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var isActive=_ref.isActive;var fillColor=isActive?"#3b9478":"#5D6067";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"12",height:"12",viewBox:"0 0 12 12"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M11.545,9.507a2.839,2.839,0,0,1,2.806-2.871,2.414,2.414,0,0,1,.759.107.154.154,0,0,0,.222-.122,4.66,4.66,0,0,0,.158-1.181c0-.027-.015-3.415-.015-3.457,0-.334-.187-.333-.271-.333a6.212,6.212,0,0,1-1.854-.186C12.015,1.07,10.827,0,10.376,0S9.057,1.07,7.721,1.464a6.284,6.284,0,0,1-2.151.149c-.079,0-.206-.025-.246.256-.01.071-.062,3.533-.062,3.571C5.262,8.823,9.352,12,10.376,12a3.252,3.252,0,0,0,1.565-.81c.095-.084.044-.139.016-.186A2.905,2.905,0,0,1,11.545,9.507Z",transform:"translate(-5.262)",fill:fillColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M185.564,205.017a.285.285,0,0,1-.375.036l-1.777-1.344a.26.26,0,0,1-.051-.36l.228-.31a.253.253,0,0,1,.356-.054l1.14.856a.286.286,0,0,0,.375-.037l1.608-1.722a.249.249,0,0,1,.357-.013l.277.264a.264.264,0,0,1,.013.366Z",transform:"translate(-175.782 -194.045)",fill:fillColor})))));});

/***/ }),
/* 661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NotRunningTournament */
/* unused harmony export NoRefillNoBid */
/* unused harmony export NotHaveMoneyRefill */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoRealAcc; });
/* unused harmony export InsufficientFunds */
/* unused harmony export BalanceNotLowRefill */
/* unused harmony export UnknownError */
/* harmony export (immutable) */ __webpack_exports__["a"] = DetermineErrorPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Warning__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Buttons__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SuspiciousActivityError__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_ModalProvider__ = __webpack_require__(38);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 68px;\n  margin: 0 auto;\n  margin-bottom: 26px;\n"],["\n  width: 68px;\n  margin: 0 auto;\n  margin-bottom: 26px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  color: #e74c3c;\n"],["\n  color: #e74c3c;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Message=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__styles__["j" /* Title */])(_templateObject2);function ErrorPopup(_ref){var onDismiss=_ref.onDismiss,callback=_ref.callback,style=_ref.style,icon=_ref.icon,message=_ref.message,children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* StyledPopup */],{onDismiss:function(_onDismiss){function onDismiss(){return _onDismiss.apply(this,arguments);}onDismiss.toString=function(){return _onDismiss.toString();};return onDismiss;}(function(){return onDismiss({callback:callback});}),style:style,fades:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["l" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["f" /* MobileWrapper */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Message,null,message),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__styles__["d" /* Footer */],null,icon!=null&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,icon),children))));}var NotRunningTournament=function NotRunningTournament(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({},props,{message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Tournament is not currently running!"),icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Warning__["a" /* default */],{width:"68px",fill:"#e74c3c"})}));};var NoRefillNoBid=function NoRefillNoBid(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({},props,{message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Unfortunately, you can not place such trade at this moment: insufficient tournament balance."),icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons_Tournaments__["h" /* PaymentError */],null)}));};var NotHaveMoneyRefill=function NotHaveMoneyRefill(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({},props,{message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"You do not have enough money to refill"),icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons_Tournaments__["h" /* PaymentError */],null)}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Buttons__["a" /* FlatButton */],{type:"deposit",to:"/fillup",onClick:function onClick(){return props.onDismiss({all:true,callback:props.callback});}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Deposit")));};var NoRealAcc=function NoRealAcc(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({},props,{message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Please top up your balance to join the tournament"),icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons_Tournaments__["h" /* PaymentError */],null)}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Buttons__["a" /* FlatButton */],{type:"deposit",to:"/fillup",onClick:function onClick(){return props.onDismiss({all:true,callback:props.callback});}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Deposit")));};var InsufficientFunds=function InsufficientFunds(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({},props,{message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Insufficient funds on the account!"),icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons_Tournaments__["h" /* PaymentError */],null)}));};var BalanceNotLowRefill=function BalanceNotLowRefill(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Unfortunately, at this moment buying more tournament coins is not possible by the tournament rules"),icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons_Tournaments__["h" /* PaymentError */],null)},props));};var UnknownError=function UnknownError(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorPopup,Object.assign({},props,{message:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"An error has occured.")}));};var CreateErrorPopup=function(_React$Component){_inherits(CreateErrorPopup,_React$Component);function CreateErrorPopup(){_classCallCheck(this,CreateErrorPopup);return _possibleConstructorReturn(this,(CreateErrorPopup.__proto__||Object.getPrototypeOf(CreateErrorPopup)).apply(this,arguments));}_createClass(CreateErrorPopup,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,errorCode=_props.errorCode,showModal=_props.showModal,api=_props.api;if(errorCode!=null){var modalComponent=null;switch(errorCode){case"not_running_tournament":modalComponent=NotRunningTournament;break;case"no_refill_no_bid":modalComponent=NoRefillNoBid;break;case"not_have_money_refill":modalComponent=NotHaveMoneyRefill;break;case"no_real_acc":modalComponent=NoRealAcc;break;case"insufficient_funds":modalComponent=InsufficientFunds;break;case"balance_not_low_refill":modalComponent=BalanceNotLowRefill;break;case"suspicious":modalComponent=__WEBPACK_IMPORTED_MODULE_9__SuspiciousActivityError__["a" /* default */];break;default:modalComponent=UnknownError;break;}showModal(modalComponent,{id:errorCode,callback:api.dismissError});}}},{key:"render",value:function render(){return null;}}]);return CreateErrorPopup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function DetermineErrorPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref2){var showModal=_ref2.showModal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CreateErrorPopup,Object.assign({key:props.errorCode,showModal:showModal,api:api},props));});});}

/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ColorfulCup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function ColorfulCup(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"28px":_ref$width,className=_ref.className,props=_objectWithoutProperties(_ref,["fill","width","className"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 28.008 34.232",fill:fill,width:width,className:className},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-46.545 0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9792a1",d:"M135.035,385.556A1.561,1.561,0,0,0,133.479,384h-15.56a1.561,1.561,0,0,0-1.556,1.556v3.89h18.672Z",transform:"translate(-65.15 -358.327)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7c7688",d:"M114.1,465.455a.837.837,0,0,1,.778.778v1.556a.837.837,0,0,1-.778.778H93.869a.837.837,0,0,1-.778-.778v-1.556a.837.837,0,0,1,.778-.778Z",transform:"translate(-43.434 -434.336)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M184.66,314.036a.735.735,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v2.567a.735.735,0,0,1-.778.778.735.735,0,0,0-.778.778v.778h10.892v-.778A.735.735,0,0,0,184.66,314.036Z",transform:"translate(-119.443 -289.919)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#787382",d:"M319.627,389.446v-3.89A1.561,1.561,0,0,0,318.071,384h-3.89v5.446Z",transform:"translate(-249.742 -358.327)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M193.961,410.384h-6.224a1.561,1.561,0,0,1-1.556-1.556h0a1.561,1.561,0,0,1,1.556-1.556h6.224a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,193.961,410.384Z",transform:"translate(-130.3 -380.043)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(59.771 27.229)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M245.92,410.385h-1.556l1.556-3.112h1.556Z",transform:"translate(-244.364 -407.273)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M282.384,408.828a1.561,1.561,0,0,0-1.556-1.556l-1.556,3.112h1.556A1.56,1.56,0,0,0,282.384,408.828Z",transform:"translate(-276.938 -407.272)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#635d6e",d:"M114.1,465.455h-5.446v.778a1.561,1.561,0,0,1-1.556,1.556H94.648a.735.735,0,0,1-.778-.778v-1.556a.735.735,0,0,0-.778.778v1.556a.78.78,0,0,0,.778.778H114.1a.837.837,0,0,0,.778-.778v-1.556A.837.837,0,0,0,114.1,465.455Z",transform:"translate(-43.435 -434.336)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M186.571,360.727H188.9a.368.368,0,0,1,.389.389h0a.367.367,0,0,1-.389.389h-2.334a.367.367,0,0,1-.389-.389h0A.368.368,0,0,1,186.571,360.727Z",transform:"translate(-130.301 -336.61)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M53.547,82.267H51.758A3.649,3.649,0,0,1,49.035,81.1l-1.323-1.323a3.532,3.532,0,0,1-1.167-2.723v-4.9a2.292,2.292,0,0,1,2.334-2.334h3.89a.778.778,0,0,1,0,1.556h-3.89a.735.735,0,0,0-.778.778v4.9a2.119,2.119,0,0,0,.7,1.634l1.323,1.323a2.239,2.239,0,0,0,1.634.7h1.789a.778.778,0,0,1,0,1.556Z",transform:"translate(0 -65.152)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M351.658,82.268h-1.789a.778.778,0,1,1,0-1.556h1.789a2.119,2.119,0,0,0,1.634-.7l1.323-1.323a2.239,2.239,0,0,0,.7-1.634v-4.9a.735.735,0,0,0-.778-.778h-3.89a.778.778,0,1,1,0-1.556h3.89a2.292,2.292,0,0,1,2.334,2.334v4.9a3.649,3.649,0,0,1-1.167,2.723L354.381,81.1A3.532,3.532,0,0,1,351.658,82.268Z",transform:"translate(-282.318 -65.153)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(66.773 4.667)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M352.2,231.564c-.156,0-.311.078-.545.078h-1.789a.778.778,0,1,0,0,1.556h2.1a5.529,5.529,0,0,0,.233-1.634Z",transform:"translate(-349.091 -220.75)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M360.727,70.6a.735.735,0,0,0,.778.778h1.556V69.818H361.5A.735.735,0,0,0,360.727,70.6Z",transform:"translate(-359.949 -69.818)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffca5d",d:"M149.75,64.439h-4.668a5.413,5.413,0,0,1-5.446-5.446V46.545H155.2V58.993A5.412,5.412,0,0,1,149.75,64.439Z",transform:"translate(-86.867 -43.434)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(56.659 7.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M206.376,314.036a.837.837,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v.778a5.017,5.017,0,0,0,1.556.233h2.334a1.561,1.561,0,0,1,1.556,1.556h0a.78.78,0,0,0,.778.778.735.735,0,0,1,.778.778v.778h2.334v-.778A.78.78,0,0,0,206.376,314.036Z",transform:"translate(-197.818 -296.92)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M454.6,105.116v3.112a.367.367,0,0,1-.389.389h0a.367.367,0,0,1-.389-.389v-3.112a.367.367,0,0,1,.389-.389h0A.368.368,0,0,1,454.6,105.116Z",transform:"translate(-436.703 -104.727)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(51.213 -0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M139.636,46.545v.778h10.892a1.561,1.561,0,0,1,1.556,1.556V58.993c0,3.034-1.634,5.446-4.668,5.446h2.334a5.413,5.413,0,0,0,5.446-5.446V46.545Z",transform:"translate(-138.08 -43.433)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M133.479,3.111h-15.56a1.561,1.561,0,0,1-1.556-1.556h0A1.561,1.561,0,0,1,117.919,0h15.56a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,133.479,3.111Z",transform:"translate(-116.363 0.001)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M133.48,0h0a1.561,1.561,0,0,1-1.556,1.556h-15.56a1.561,1.561,0,0,0,1.556,1.556H133.4a1.665,1.665,0,0,0,1.634-1.323A1.576,1.576,0,0,0,133.48,0Z",transform:"translate(-65.151 -0.001)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(54.325 5.445)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffe27a",d:"M163.687,87.679h0a.735.735,0,0,1-.778-.778V82.233a.735.735,0,0,1,.778-.778h0a.735.735,0,0,1,.778.778V86.9A.735.735,0,0,1,163.687,87.679Z",transform:"translate(-162.909 -81.455)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#ffe27a",cx:"0.778",cy:"0.778",r:"0.778",transform:"translate(0 7.002)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#847f8e",d:"M117.919,384a1.561,1.561,0,0,0-1.556,1.556v3.89h1.556Z",transform:"translate(-65.15 -358.327)"})));}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = Loadable;
exports.flushServerSideRequirePaths = flushServerSideRequirePaths;
exports.flushWebpackRequireWeakIds = flushWebpackRequireWeakIds;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SERVER_SIDE_REQUIRE_PATHS = new Set();
var WEBPACK_REQUIRE_WEAK_IDS = new Set();

var isWebpack = typeof __webpack_require__ !== "undefined";
var requireFn = isWebpack ? __webpack_require__ : module.require.bind(module);

var babelInterop = function babelInterop(obj) {
  // $FlowIgnore
  return obj && obj.__esModule ? obj.default : obj;
};

var tryRequire = function tryRequire(resolveModuleFn, pathOrId) {
  try {
    // $FlowIgnore
    return resolveModuleFn(requireFn(pathOrId));
  } catch (err) {}
  return null;
};

function Loadable(opts) {
  var loader = opts.loader;
  var LoadingComponent = opts.LoadingComponent;
  var delay = opts.delay || 200;
  var serverSideRequirePath = opts.serverSideRequirePath;
  var webpackRequireWeakId = opts.webpackRequireWeakId;
  var resolveModuleFn = opts.resolveModule ? opts.resolveModule : babelInterop;

  var isLoading = false;

  var outsideComponent = null;
  var outsidePromise = null;
  var outsideError = null;

  if (!isWebpack && serverSideRequirePath) {
    outsideComponent = tryRequire(resolveModuleFn, serverSideRequirePath);
  }

  var load = function load() {
    if (!outsidePromise) {
      isLoading = true;
      outsidePromise = loader().then(function (Component) {
        isLoading = false;
        outsideComponent = resolveModuleFn(Component);
      }).catch(function (error) {
        isLoading = false;
        outsideError = error;
      });
    }
    return outsidePromise;
  };

  return function (_React$Component) {
    _inherits(Loadable, _React$Component);

    _createClass(Loadable, null, [{
      key: "preload",
      value: function preload() {
        load();
      }
    }]);

    function Loadable(props) {
      _classCallCheck(this, Loadable);

      var _this = _possibleConstructorReturn(this, (Loadable.__proto__ || Object.getPrototypeOf(Loadable)).call(this, props));

      if (!outsideComponent && isWebpack && webpackRequireWeakId) {
        var weakId = webpackRequireWeakId();
        if (__webpack_require__.m[weakId]) {
          // if it's not in webpack modules, we wont be able
          // to load it. If we attempt to, we mess up webpack's
          // internal state, so only tryRequire if it's already
          // in webpack modules.
          outsideComponent = tryRequire(resolveModuleFn, weakId);
        }
      }

      _this.state = {
        error: outsideError,
        pastDelay: false,
        Component: outsideComponent
      };
      return _this;
    }

    _createClass(Loadable, [{
      key: "componentWillMount",
      value: function componentWillMount() {
        var _this2 = this;

        this._mounted = true;

        if (this.state.Component) {
          return;
        }

        this._timeout = setTimeout(function () {
          _this2.setState({ pastDelay: true });
        }, delay);

        load().then(function () {
          if (!_this2._mounted) return;
          clearTimeout(_this2._timeout);
          _this2.setState({
            error: outsideError,
            pastDelay: false,
            Component: outsideComponent
          });
        });
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this._mounted = false;
        clearTimeout(this._timeout);
      }
    }, {
      key: "render",
      value: function render() {
        var _state = this.state,
            pastDelay = _state.pastDelay,
            error = _state.error,
            Component = _state.Component;


        if (!isWebpack && serverSideRequirePath) {
          SERVER_SIDE_REQUIRE_PATHS.add(serverSideRequirePath);
        }

        if (isWebpack && webpackRequireWeakId) {
          WEBPACK_REQUIRE_WEAK_IDS.add(webpackRequireWeakId());
        }

        if (isLoading || error) {
          return _react2.default.createElement(LoadingComponent, {
            isLoading: isLoading,
            pastDelay: pastDelay,
            error: error
          });
        } else if (Component) {
          return _react2.default.createElement(Component, this.props);
        } else {
          return null;
        }
      }
    }]);

    return Loadable;
  }(_react2.default.Component);
}

function flushServerSideRequirePaths() {
  var arr = Array.from(SERVER_SIDE_REQUIRE_PATHS);
  SERVER_SIDE_REQUIRE_PATHS.clear();
  return arr;
}

function flushWebpackRequireWeakIds() {
  var arr = Array.from(WEBPACK_REQUIRE_WEAK_IDS);
  WEBPACK_REQUIRE_WEAK_IDS.clear();
  return arr;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VERIFICATION_STATUS_UNVERIFIED */
/* unused harmony export VERIFICATION_STATUS_SENT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VERIFICATION_STATUS_APPROVED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VERIFICATION_STATUS_DECLINED; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getVerificationStatusText;
/* harmony export (immutable) */ __webpack_exports__["c"] = getVerificationStatusIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tooltipy__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Floatipy__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons__ = __webpack_require__(147);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n"],["\n  display: inline-block;\n  position: relative;\n  vertical-align: middle;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var VERIFICATION_STATUS_UNVERIFIED=0;var VERIFICATION_STATUS_SENT=1;var VERIFICATION_STATUS_APPROVED=2;var VERIFICATION_STATUS_DECLINED=3;function getVerificationStatusText(status){switch(status){case VERIFICATION_STATUS_APPROVED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Account is verified");case VERIFICATION_STATUS_UNVERIFIED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Account is not verified");case VERIFICATION_STATUS_SENT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Pending confirmation");case VERIFICATION_STATUS_DECLINED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Verification of your account has been rejected!");default:return null;}}function getVerificationStatusIcon(status){switch(status){case VERIFICATION_STATUS_APPROVED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons__["k" /* VerifiedIcon */],null);case VERIFICATION_STATUS_UNVERIFIED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons__["j" /* UnverifiedIcon */],null);case VERIFICATION_STATUS_SENT:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons__["d" /* PendingIcon */],null);case VERIFICATION_STATUS_DECLINED:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons__["j" /* UnverifiedIcon */],null);default:return null;}}var VerificationIcon=function VerificationIcon(_ref){var status=_ref.status,floatipy=_ref.floatipy,notooltip=_ref.notooltip;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconContainer,null,notooltip?getVerificationStatusIcon(status):floatipy?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Floatipy__["a" /* default */],{tooltip:getVerificationStatusText(status)},getVerificationStatusIcon(status)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Tooltipy__["a" /* default */],{tooltip:getVerificationStatusText(status)},getVerificationStatusIcon(status)));};/* unused harmony default export */ var _unused_webpack_default_export = (VerificationIcon);

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1514)


/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Timer__ = __webpack_require__(46);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-basis: auto;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding: 0 15px;\n"],["\n  flex-grow: 0;\n  flex-basis: auto;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding: 0 15px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: 24px;\n\n  @media (max-width: 959px) {\n    padding-top: 20px;\n    padding-bottom: 0;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n  }\n"],["\n  width: 100%;\n  margin-bottom: 24px;\n\n  @media (max-width: 959px) {\n    padding-top: 20px;\n    padding-bottom: 0;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ",";\n"],["\n  font-weight: 400;\n  font-size: ",";\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TextWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* TextContainer */])(_templateObject);var Container=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__styles__["g" /* TextContainer */])(_templateObject2);var TimeWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__styles__["f" /* Text */])(_templateObject3,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});function Header(_ref2){var Cup=_ref2.Cup,children=_ref2.children,className=_ref2.className,props=_objectWithoutProperties(_ref2,["Cup","children","className"]);var _getTimes=Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["h" /* getTimes */])(props),startTime=_getTimes.startTime,endTime=_getTimes.endTime;var start=startTime.format("LLL");var finish=endTime.format("LLL");return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,{className:className},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cup,null),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TextWrapper,null,children,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TimeWrapper,null,start," / ",finish)));}/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/demo-tournament-bg.a13c15d3.png";

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(543),
    arraySome = __webpack_require__(1550),
    cacheHas = __webpack_require__(548);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 669 */
/***/ (function(module, exports) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(220),
    metaMap = __webpack_require__(671);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

var WeakMap = __webpack_require__(570);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(673),
    composeArgsRight = __webpack_require__(674),
    countHolders = __webpack_require__(1589),
    createCtor = __webpack_require__(276),
    createRecurry = __webpack_require__(675),
    getHolder = __webpack_require__(680),
    reorder = __webpack_require__(1598),
    replaceHolders = __webpack_require__(420),
    root = __webpack_require__(48);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),
/* 673 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),
/* 674 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var isLaziable = __webpack_require__(1590),
    setData = __webpack_require__(678),
    setWrapToString = __webpack_require__(679);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var metaMap = __webpack_require__(671),
    noop = __webpack_require__(550);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(254),
    baseLodash = __webpack_require__(419);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetData = __webpack_require__(670),
    shortOut = __webpack_require__(559);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(1595),
    insertWrapDetails = __webpack_require__(1596),
    setToString = __webpack_require__(475),
    updateWrapDetails = __webpack_require__(1597);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),
/* 680 */
/***/ (function(module, exports) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 682 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createStylerFactory */
/* unused harmony export buildStyleProperty */
/* unused harmony export isTransformProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_framesync__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_style_value_types__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hey_listen__ = __webpack_require__(140);




/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    return t;
}

var createStyler = function (_a) {
    var onRead = _a.onRead,
        onRender = _a.onRender,
        _b = _a.uncachedValues,
        uncachedValues = _b === void 0 ? new Set() : _b,
        _c = _a.useCache,
        useCache = _c === void 0 ? true : _c;
    return function (props) {
        var state = {};
        var changedValues = [];
        var hasChanged = false;
        var setValue = function (key, value) {
            var currentValue = state[key];
            state[key] = value;
            if (state[key] !== currentValue) {
                if (changedValues.indexOf(key) === -1) {
                    changedValues.push(key);
                }
                if (!hasChanged) {
                    hasChanged = true;
                    __WEBPACK_IMPORTED_MODULE_0_framesync__["b" /* default */].render(render);
                }
            }
        };
        function render(forceRender) {
            if (forceRender === void 0) {
                forceRender = false;
            }
            if (forceRender === true || hasChanged) {
                onRender(state, props, changedValues);
                hasChanged = false;
                changedValues.length = 0;
            }
            return this;
        }
        return {
            get: function (key) {
                return key ? useCache && !uncachedValues.has(key) && state[key] !== undefined ? state[key] : onRead(key, props) : state;
            },
            set: function (values, value) {
                if (typeof values === 'string') {
                    if (value !== undefined) {
                        setValue(values, value);
                    } else {
                        return function (v) {
                            return setValue(values, v);
                        };
                    }
                } else {
                    for (var key in values) {
                        if (values.hasOwnProperty(key)) {
                            setValue(key, values[key]);
                        }
                    }
                }
                return this;
            },
            render: render
        };
    };
};

var CAMEL_CASE_PATTERN = /([a-z])([A-Z])/g;
var REPLACE_TEMPLATE = '$1-$2';
var camelToDash = function (str) {
    return str.replace(CAMEL_CASE_PATTERN, REPLACE_TEMPLATE).toLowerCase();
};
var setDomAttrs = function (element, attrs) {
    for (var key in attrs) {
        if (attrs.hasOwnProperty(key)) {
            element.setAttribute(key, attrs[key]);
        }
    }
};

var camelCache = /*#__PURE__*/new Map();
var dashCache = /*#__PURE__*/new Map();
var prefixes = ['Webkit', 'Moz', 'O', 'ms', ''];
var numPrefixes = prefixes.length;
var isBrowser = typeof document !== 'undefined';
var testElement;
var setDashPrefix = function (key, prefixed) {
    return dashCache.set(key, camelToDash(prefixed));
};
var testPrefix = function (key) {
    testElement = testElement || document.createElement('div');
    for (var i = 0; i < numPrefixes; i++) {
        var prefix = prefixes[i];
        var noPrefix = prefix === '';
        var prefixedPropertyName = noPrefix ? key : prefix + key.charAt(0).toUpperCase() + key.slice(1);
        if (prefixedPropertyName in testElement.style || noPrefix) {
            camelCache.set(key, prefixedPropertyName);
            setDashPrefix(key, "" + (noPrefix ? '' : '-') + camelToDash(prefixedPropertyName));
        }
    }
};
var setServerProperty = function (key) {
    return setDashPrefix(key, key);
};
var prefixer = function (key, asDashCase) {
    if (asDashCase === void 0) {
        asDashCase = false;
    }
    var cache = asDashCase ? dashCache : camelCache;
    if (!cache.has(key)) isBrowser ? testPrefix(key) : setServerProperty(key);
    return cache.get(key) || key;
};

var axes = ['', 'X', 'Y', 'Z'];
var order = ['scale', 'rotate', 'skew', 'transformPerspective'];
var transformProps = /*#__PURE__*/order.reduce(function (acc, key) {
    return axes.reduce(function (axesAcc, axesKey) {
        axesAcc.push(key + axesKey);
        return axesAcc;
    }, acc);
}, ['x', 'y', 'z']);
var transformPropDictionary = /*#__PURE__*/transformProps.reduce(function (dict, key) {
    dict[key] = true;
    return dict;
}, {});
var isTransformProp = function (key) {
    return transformPropDictionary[key] === true;
};
var sortTransformProps = function (a, b) {
    return transformProps.indexOf(a) - transformProps.indexOf(b);
};
var isTransformOriginProp = function (key) {
    return key === 'originX' || key === 'originY';
};

var valueTypes = {
    color: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    backgroundColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    outlineColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    fill: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    stroke: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    borderColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    borderTopColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    borderRightColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    borderBottomColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    borderLeftColor: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    borderWidth: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderTopWidth: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderRightWidth: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderBottomWidth: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderLeftWidth: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderRadius: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderTopLeftRadius: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderTopRightRadius: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderBottomRightRadius: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    borderBottomLeftRadius: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    width: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    maxWidth: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    height: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    maxHeight: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    top: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    right: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    bottom: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    left: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    padding: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    paddingTop: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    paddingRight: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    paddingBottom: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    paddingLeft: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    margin: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    marginTop: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    marginRight: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    marginBottom: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    marginLeft: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    rotate: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    rotateX: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    rotateY: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    rotateZ: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    scale: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    scaleX: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    scaleY: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    scaleZ: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    skew: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    skewX: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    skewY: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["d" /* degrees */],
    distance: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    x: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    y: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    z: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    perspective: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */],
    opacity: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["a" /* alpha */],
    originX: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["h" /* percent */],
    originY: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["h" /* percent */],
    originZ: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["i" /* px */]
};
var getValueType = function (key) {
    return valueTypes[key];
};

var SCROLL_LEFT = 'scrollLeft';
var SCROLL_TOP = 'scrollTop';
var scrollKeys = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP]);

var blacklist = /*#__PURE__*/new Set([SCROLL_LEFT, SCROLL_TOP, 'transform']);
var aliasMap = {
    x: 'translateX',
    y: 'translateY',
    z: 'translateZ'
};
var isCustomTemplate = function (v) {
    return typeof v === 'function';
};
var buildStyleProperty = function (state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, isDashCase) {
    if (enableHardwareAcceleration === void 0) {
        enableHardwareAcceleration = true;
    }
    if (styles === void 0) {
        styles = {};
    }
    if (transform === void 0) {
        transform = {};
    }
    if (transformOrigin === void 0) {
        transformOrigin = {};
    }
    if (transformKeys === void 0) {
        transformKeys = [];
    }
    if (isDashCase === void 0) {
        isDashCase = false;
    }
    var transformIsDefault = true;
    var hasTransform = false;
    var hasTransformOrigin = false;
    for (var key in state) {
        var value = state[key];
        var valueType = getValueType(key);
        var valueAsType = typeof value === 'number' && valueType ? valueType.transform(value) : value;
        if (isTransformProp(key)) {
            hasTransform = true;
            transform[key] = valueAsType;
            transformKeys.push(key);
            if (transformIsDefault) {
                if (valueType.default && value !== valueType.default || !valueType.default && value !== 0) {
                    transformIsDefault = false;
                }
            }
        } else if (isTransformOriginProp(key)) {
            transformOrigin[key] = valueAsType;
            hasTransformOrigin = true;
        } else if (!blacklist.has(key) || !isCustomTemplate(valueAsType)) {
            styles[prefixer(key, isDashCase)] = valueAsType;
        }
    }
    if (!transformIsDefault) {
        var transformString = '';
        if (isCustomTemplate(state.transform)) {
            transformString = state.transform(transform);
        } else {
            var transformHasZ = false;
            transformKeys.sort(sortTransformProps);
            var numTransformKeys = transformKeys.length;
            for (var i = 0; i < numTransformKeys; i++) {
                var key = transformKeys[i];
                transformString += (aliasMap[key] || key) + "(" + transform[key] + ") ";
                transformHasZ = key === 'z' ? true : transformHasZ;
            }
            if (!transformHasZ && enableHardwareAcceleration) {
                transformString += 'translateZ(0)';
            } else {
                transformString = transformString.trim();
            }
        }
        styles.transform = transformString;
    } else if (hasTransform) {
        styles.transform = 'none';
    }
    if (hasTransformOrigin) {
        styles.transformOrigin = (transformOrigin.originX || 0) + " " + (transformOrigin.originY || 0) + " " + (transformOrigin.originZ || 0);
    }
    return styles;
};
var createStyleBuilder = function (enableHardwareAcceleration) {
    if (enableHardwareAcceleration === void 0) {
        enableHardwareAcceleration = true;
    }
    var styles = {};
    var transform = {};
    var transformOrigin = {};
    var transformKeys = [];
    return function (state) {
        transformKeys.length = 0;
        buildStyleProperty(state, enableHardwareAcceleration, styles, transform, transformOrigin, transformKeys, true);
        return styles;
    };
};

var cssStyler = /*#__PURE__*/createStyler({
    onRead: function (key, _a) {
        var element = _a.element,
            preparseOutput = _a.preparseOutput;
        var valueType = getValueType(key);
        if (isTransformProp(key)) {
            return valueType ? valueType.default || 0 : 0;
        } else if (scrollKeys.has(key)) {
            return element[key];
        } else {
            var domValue = window.getComputedStyle(element, null).getPropertyValue(prefixer(key, true)) || 0;
            return preparseOutput && valueType && valueType.parse ? valueType.parse(domValue) : domValue;
        }
    },
    onRender: function (state, _a, changedValues) {
        var element = _a.element,
            buildStyles = _a.buildStyles;
        Object.assign(element.style, buildStyles(state));
        if (changedValues.indexOf(SCROLL_LEFT) !== -1) element.scrollLeft = state.scrollLeft;
        if (changedValues.indexOf(SCROLL_TOP) !== -1) element.scrollTop = state.scrollTop;
    },
    uncachedValues: scrollKeys
});
var css = function (element, _a) {
    if (_a === void 0) {
        _a = {};
    }
    var enableHardwareAcceleration = _a.enableHardwareAcceleration,
        props = __rest(_a, ["enableHardwareAcceleration"]);
    return cssStyler(__assign({ element: element, buildStyles: createStyleBuilder(enableHardwareAcceleration), preparseOutput: true }, props));
};

var ZERO_NOT_ZERO = 0.0000001;
var percentToPixels = function (percent$$1, length) {
    return percent$$1 / 100 * length + 'px';
};
var build = function (state, dimensions, isPath, pathLength) {
    var hasTransform = false;
    var hasDashArray = false;
    var props = {};
    var dashArrayStyles = isPath ? {
        pathLength: '0',
        pathSpacing: "" + pathLength
    } : undefined;
    var scale$$1 = state.scale !== undefined ? state.scale || ZERO_NOT_ZERO : state.scaleX || 1;
    var scaleY = state.scaleY !== undefined ? state.scaleY || ZERO_NOT_ZERO : scale$$1 || 1;
    var transformOriginX = dimensions.width * ((state.originX || 50) / 100) + dimensions.x;
    var transformOriginY = dimensions.height * ((state.originY || 50) / 100) + dimensions.y;
    var scaleTransformX = -transformOriginX * (scale$$1 * 1);
    var scaleTransformY = -transformOriginY * (scaleY * 1);
    var scaleReplaceX = transformOriginX / scale$$1;
    var scaleReplaceY = transformOriginY / scaleY;
    var transform = {
        translate: "translate(" + state.x + ", " + state.y + ") ",
        scale: "translate(" + scaleTransformX + ", " + scaleTransformY + ") scale(" + scale$$1 + ", " + scaleY + ") translate(" + scaleReplaceX + ", " + scaleReplaceY + ") ",
        rotate: "rotate(" + state.rotate + ", " + transformOriginX + ", " + transformOriginY + ") ",
        skewX: "skewX(" + state.skewX + ") ",
        skewY: "skewY(" + state.skewY + ") "
    };
    for (var key in state) {
        if (state.hasOwnProperty(key)) {
            var value = state[key];
            if (isTransformProp(key)) {
                hasTransform = true;
            } else if (isPath && (key === 'pathLength' || key === 'pathSpacing') && typeof value === 'number') {
                hasDashArray = true;
                dashArrayStyles[key] = percentToPixels(value, pathLength);
            } else if (isPath && key === 'pathOffset') {
                props['stroke-dashoffset'] = percentToPixels(-value, pathLength);
            } else {
                props[camelToDash(key)] = value;
            }
        }
    }
    if (hasDashArray) {
        props['stroke-dasharray'] = dashArrayStyles.pathLength + ' ' + dashArrayStyles.pathSpacing;
    }
    if (hasTransform) {
        props.transform = '';
        for (var key in transform) {
            if (transform.hasOwnProperty(key)) {
                var defaultValue = key === 'scale' ? '1' : '0';
                props.transform += transform[key].replace(/undefined/g, defaultValue);
            }
        }
    }
    return props;
};

var valueTypes$1 = {
    fill: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    stroke: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["b" /* color */],
    scale: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    scaleX: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    scaleY: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["k" /* scale */],
    opacity: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["a" /* alpha */],
    fillOpacity: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["a" /* alpha */],
    strokeOpacity: __WEBPACK_IMPORTED_MODULE_1_style_value_types__["a" /* alpha */]
};
var getValueType$1 = function (key) {
    return valueTypes$1[key];
};

var getDimensions = function (element) {
    return typeof element.getBBox === 'function' ? element.getBBox() : element.getBoundingClientRect();
};
var getSVGElementDimensions = function (element) {
    try {
        return getDimensions(element);
    } catch (e) {
        return { x: 0, y: 0, width: 0, height: 0 };
    }
};

var svgStyler = /*#__PURE__*/createStyler({
    onRead: function (key, _a) {
        var element = _a.element;
        if (!isTransformProp(key)) {
            return element.getAttribute(key);
        } else {
            var valueType = getValueType$1(key);
            return valueType ? valueType.default : 0;
        }
    },
    onRender: function (state, _a) {
        var dimensions = _a.dimensions,
            element = _a.element,
            isPath = _a.isPath,
            pathLength = _a.pathLength;
        setDomAttrs(element, build(state, dimensions, isPath, pathLength));
    }
});
var svg = function (element) {
    var dimensions = getSVGElementDimensions(element);
    var props = {
        element: element,
        dimensions: dimensions,
        isPath: false
    };
    if (element.tagName === 'path') {
        props.isPath = true;
        props.pathLength = element.getTotalLength();
    }
    return svgStyler(props);
};

var viewport = /*#__PURE__*/createStyler({
    useCache: false,
    onRead: function (key) {
        return key === 'scrollTop' ? window.pageYOffset : window.pageXOffset;
    },
    onRender: function (_a) {
        var _b = _a.scrollTop,
            scrollTop = _b === void 0 ? 0 : _b,
            _c = _a.scrollLeft,
            scrollLeft = _c === void 0 ? 0 : _c;
        return window.scrollTo(scrollLeft, scrollTop);
    }
});

var cache = /*#__PURE__*/new WeakMap();
var createDOMStyler = function (node, props) {
    var styler;
    if (node instanceof HTMLElement) {
        styler = css(node, props);
    } else if (node instanceof SVGElement) {
        styler = svg(node);
    } else if (node === window) {
        styler = viewport(node);
    }
    Object(__WEBPACK_IMPORTED_MODULE_2_hey_listen__["a" /* invariant */])(styler !== undefined, 'No valid node provided. Node must be HTMLElement, SVGElement or window.');
    cache.set(node, styler);
    return styler;
};
var getStyler = function (node, props) {
    return cache.has(node) ? cache.get(node) : createDOMStyler(node, props);
};
function index(nodeOrSelector, props) {
    var node = typeof nodeOrSelector === 'string' ? document.querySelector(nodeOrSelector) : nodeOrSelector;
    return getStyler(node, props);
}

/* harmony default export */ __webpack_exports__["a"] = (index);



/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = decryptConnectionState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FeatureFlags__ = __webpack_require__(41);
var inittialState={connectionState:WebSocket.CONNECTING,failedReconnects:0,untilNextReconnect:0};function connect(state){__WEBPACK_IMPORTED_MODULE_0__FeatureFlags__["a" /* default */].logSocket&&console.log("sock: connecting");return Object.assign({},state,{connectionState:WebSocket.CONNECTING});}function reconnectTick(state){if(state.connectionState!==WebSocket.CLOSED){return state;}if(state.untilNextReconnect>0){__WEBPACK_IMPORTED_MODULE_0__FeatureFlags__["a" /* default */].logSocket&&console.log("sock: reconnect in "+(state.untilNextReconnect-1));return Object.assign({},state,{untilNextReconnect:state.untilNextReconnect-1});}else{return connect(state);}}function onConnectSuccess(state){__WEBPACK_IMPORTED_MODULE_0__FeatureFlags__["a" /* default */].logSocket&&console.log("sock: connected");return{connectionState:WebSocket.OPEN,failedReconnects:0,untilNextReconnect:0};}function onConnectFailure(state){__WEBPACK_IMPORTED_MODULE_0__FeatureFlags__["a" /* default */].logSocket&&console.log("sock: failed");return{connectionState:WebSocket.CLOSED,failedReconnects:state.failedReconnects+1,untilNextReconnect:Math.pow(2,state.failedReconnects+1)};}function onSocketStateChange(state,connectionState){switch(connectionState){case WebSocket.OPEN:return onConnectSuccess(state);case WebSocket.CLOSED:return onConnectFailure(state);default:return Object.assign({},state,{connectionState:connectionState});}}function socket(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:inittialState;var action=arguments[1];switch(action.type){case"SOCKET_CONNECT":return connect(state);case"SOCKET_RECONNECT_TICK":return reconnectTick(state);case"SOCKET_CONNECT_SUCCESS":return onConnectSuccess(state);case"SOCKET_CONNECT_FAILURE":return onConnectFailure(state);case"SOCKET_STATE_CHANGE":return onSocketStateChange(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["b"] = (socket);// Дочерним компонентам не следует знать,
// что мы используем WebSocket для связи
// с сервером. Поэтому мы расшифровываем
// сокетные статусы в обычные строчки.
function decryptConnectionState(readyState){switch(readyState){case WebSocket.CONNECTING:return"CONNECTING";case WebSocket.OPEN:return"OPEN";case WebSocket.CLOSING:return"CLOSING";case WebSocket.CLOSED:default:return"CLOSED";}}

/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getErrorMessage;
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={isVisible:false,faults:[]};function serverFaults(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"RECORD_SERVER_FAULT":return{isVisible:action.payload.isVisible,faults:[].concat(_toConsumableArray(state.faults),[action.payload.fault])};case"DISMISS_SERVER_FAULT":return Object.assign({},state,{isVisible:false});default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (serverFaults);function getErrorMessage(state){if(!state.isVisible||state.faults.length===0){return null;}return state.faults[state.faults.length-1].message;}

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var util = __webpack_require__(687);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, config, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = config.name;
        this._automaticDataCollectionEnabled =
            config.automaticDataCollectionEnabled || false;
        this.options_ = util.deepCopy(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "automaticDataCollectionEnabled", {
        get: function () {
            this.checkDestroyed_();
            return this._automaticDataCollectionEnabled;
        },
        set: function (val) {
            this.checkDestroyed_();
            this._automaticDataCollectionEnabled = val;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        util.deepExtend(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '5.0.4',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: util.createSubscribe,
            ErrorFactory: util.ErrorFactory,
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: util.deepExtend
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    util.patchProperty(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    util.patchProperty(app, 'App', FirebaseAppImpl);
    function initializeApp(options, rawConfig) {
        if (rawConfig === void 0) { rawConfig = {}; }
        if (typeof rawConfig !== 'object' || rawConfig === null) {
            var name_1 = rawConfig;
            rawConfig = { name: name_1 };
        }
        var config = rawConfig;
        if (config.name === undefined) {
            config.name = DEFAULT_ENTRY_NAME;
        }
        var name = config.name;
        if (typeof name !== 'string' || !name) {
            error('bad-app-name', { name: name + '' });
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, config, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) { return apps_[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function (appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            util.deepExtend(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        util.deepExtend(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
        'account is only allowed in a Node.js environment. On client ' +
        'devices, you should instead initialize the SDK with an api key and ' +
        'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.'
};
var appErrors = new util.ErrorFactory('app', 'Firebase', errors);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firebase = createFirebaseNamespace();

exports.firebase = firebase;
exports.default = firebase;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var tslib_1 = __webpack_require__(688);

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
var CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
var assert = function (assertion, message) {
    if (!assertion) {
        throw assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
var assertionError = function (message) {
    return new Error('Firebase Database (' +
        CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
var base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
var base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
var base64Decode = function (str) {
    try {
        return base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
var getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
var isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
var isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
var isNodeSdk = function () {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
};

var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            try {
                // In case of IE11, stack will be set only after error is raised.
                // https://docs.microsoft.com/en-us/scripting/javascript/reference/stack-property-error-javascript
                throw Error.apply(this, arguments);
            }
            catch (err) {
                this.name = ERROR_NAME;
                // Make non-enumerable getter for the property.
                Object.defineProperty(this, 'stack', {
                    get: function () {
                        return err.stack;
                    }
                });
            }
        }
    }
    return FirebaseError;
}());
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
var decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidTimestamp = function (token) {
    var claims = decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
var issuedAtTime = function (token) {
    var claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isValidFormat = function (token) {
    var decoded = decode(token), claims = decoded.claims;
    return (!!decoded.signature &&
        !!claims &&
        typeof claims === 'object' &&
        claims.hasOwnProperty('iat'));
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
var isAdmin = function (token) {
    var claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
var extend = function (objTo, objFrom) {
    forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
var clone = function (obj) {
    return extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
var isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
var isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
var getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
var map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
var findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
var findValue = function (obj, fn, opt_this) {
    var key = findKey(obj, fn, opt_this);
    return key && obj[key];
};
var getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
var getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
var every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
var querystring = function (querystringParams) {
    var params = [];
    forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
var querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    tslib_1.__extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(Hash));

/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
var validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
var stringToByteArray$1 = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
var stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

exports.assert = assert;
exports.assertionError = assertionError;
exports.base64 = base64;
exports.base64Decode = base64Decode;
exports.base64Encode = base64Encode;
exports.CONSTANTS = CONSTANTS;
exports.deepCopy = deepCopy;
exports.deepExtend = deepExtend;
exports.patchProperty = patchProperty;
exports.Deferred = Deferred;
exports.getUA = getUA;
exports.isMobileCordova = isMobileCordova;
exports.isNodeSdk = isNodeSdk;
exports.isReactNative = isReactNative;
exports.ErrorFactory = ErrorFactory;
exports.FirebaseError = FirebaseError;
exports.patchCapture = patchCapture;
exports.jsonEval = jsonEval;
exports.stringify = stringify;
exports.decode = decode;
exports.isAdmin = isAdmin;
exports.issuedAtTime = issuedAtTime;
exports.isValidFormat = isValidFormat;
exports.isValidTimestamp = isValidTimestamp;
exports.clone = clone;
exports.contains = contains;
exports.every = every;
exports.extend = extend;
exports.findKey = findKey;
exports.findValue = findValue;
exports.forEach = forEach;
exports.getAnyKey = getAnyKey;
exports.getCount = getCount;
exports.getValues = getValues;
exports.isEmpty = isEmpty;
exports.isNonNullObject = isNonNullObject;
exports.map = map;
exports.safeGet = safeGet;
exports.querystring = querystring;
exports.querystringDecode = querystringDecode;
exports.Sha1 = Sha1;
exports.async = async;
exports.createSubscribe = createSubscribe;
exports.errorPrefix = errorPrefix;
exports.validateArgCount = validateArgCount;
exports.validateCallback = validateCallback;
exports.validateContextObject = validateContextObject;
exports.validateNamespace = validateNamespace;
exports.stringLength = stringLength;
exports.stringToByteArray = stringToByteArray$1;


/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(1703),
    toNumber = __webpack_require__(307);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(1737);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Header__["a" /* default */]);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToggleTool;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex-shrink: 0;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex-shrink: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 63px;\n  height: 30px;\n  padding: 4px;\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n  text-align: center;\n  background-color: ",";\n  border-radius: 30px;\n  cursor: pointer;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 63px;\n  height: 30px;\n  padding: 4px;\n  font-size: ",";\n  text-transform: uppercase;\n  color: ",";\n  text-align: center;\n  background-color: ",";\n  border-radius: 30px;\n  cursor: pointer;\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      width: 30px;\n      height: 20px;\n      padding: 2px;\n    "],["\n      width: 30px;\n      height: 20px;\n      padding: 2px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 5px;\n  left: 0;\n  transform: translateX(4px);\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  background-color: ",";\n  border-radius: 50%;\n  transition: transform 0.3s ease, background-color 0.3s ease-in-out;\n  z-index: 10;\n\n  "," ",";\n"],["\n  position: absolute;\n  top: 5px;\n  left: 0;\n  transform: translateX(4px);\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  background-color: ",";\n  border-radius: 50%;\n  transition: transform 0.3s ease, background-color 0.3s ease-in-out;\n  z-index: 10;\n\n  "," ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      transform: translateX(calc(200% - 4px));\n      background-color: ",";\n    "],["\n      transform: translateX(calc(200% - 4px));\n      background-color: ",";\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      width: 10px;\n      height: 10px;\n    "],["\n      width: 10px;\n      height: 10px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  text-align: center;\n  padding-left: 20px;\n\n  ",";\n"],["\n  flex-grow: 1;\n  text-align: center;\n  padding-left: 20px;\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      padding-left: 0;\n      padding-right: 20px;\n    "],["\n      padding-left: 0;\n      padding-right: 20px;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Switch=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(props){return props.theme.mainHighlight;},function(props){return props.compactMode&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var Toggle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref3){var theme=_ref3.theme;return theme.foreground;},function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,function(props){return props.theme.accent;});},function(props){return props.compactMode&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.isActive&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});function ToggleTool(_ref4){var compactMode=_ref4.compactMode,value=_ref4.value,onChange=_ref4.onChange,title=_ref4.title;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{title:title},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Switch,{compactMode:compactMode,onClick:function onClick(){return onChange(!value);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Toggle,{compactMode:compactMode,isActive:value}),!compactMode&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,{isActive:value},value?"On":"Off")));}

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icons__ = __webpack_require__(121);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",Object.assign({},props,{onClick:function onClick(){return props.onClick(!props.value);}}),props.value?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icons__["B" /* VisibleIcon */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icons__["g" /* HiddenIcon */],null));});

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatTime;
function addZero(time){return(time<10?"0":"")+time;}function formatTime(time){var seconds=Math.floor(time/1000)%60;var minutes=Math.floor(time/(60*1000))%60;var hours=Math.floor(time/(1000*60*60)%24);var hh=addZero(hours);var mm=addZero(minutes);var ss=addZero(seconds);if(hours>0){return hh+":"+mm+":"+ss;}return mm+":"+ss;}

/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

exports.__esModule = true;
exports.default = void 0;

var _setStatic = _interopRequireDefault(__webpack_require__(1766));

var setDisplayName = function setDisplayName(displayName) {
  return (0, _setStatic.default)('displayName', displayName);
};

var _default = setDisplayName;
exports.default = _default;

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

exports.__esModule = true;
exports.default = void 0;

var _getDisplayName = _interopRequireDefault(__webpack_require__(1767));

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + "(" + (0, _getDisplayName.default)(BaseComponent) + ")";
};

var _default = wrapDisplayName;
exports.default = _default;

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1773);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports.createGenerateClassName = exports.sheets = exports.RuleList = exports.SheetsManager = exports.SheetsRegistry = exports.toCssValue = exports.getDynamicStyles = undefined;

var _getDynamicStyles = __webpack_require__(1786);

Object.defineProperty(exports, 'getDynamicStyles', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDynamicStyles)['default'];
  }
});

var _toCssValue = __webpack_require__(282);

Object.defineProperty(exports, 'toCssValue', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_toCssValue)['default'];
  }
});

var _SheetsRegistry = __webpack_require__(699);

Object.defineProperty(exports, 'SheetsRegistry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsRegistry)['default'];
  }
});

var _SheetsManager = __webpack_require__(1787);

Object.defineProperty(exports, 'SheetsManager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SheetsManager)['default'];
  }
});

var _RuleList = __webpack_require__(208);

Object.defineProperty(exports, 'RuleList', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RuleList)['default'];
  }
});

var _sheets = __webpack_require__(439);

Object.defineProperty(exports, 'sheets', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_sheets)['default'];
  }
});

var _createGenerateClassName = __webpack_require__(702);

Object.defineProperty(exports, 'createGenerateClassName', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_createGenerateClassName)['default'];
  }
});

var _Jss = __webpack_require__(1791);

var _Jss2 = _interopRequireDefault(_Jss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Creates a new instance of Jss.
 */
var create = exports.create = function create(options) {
  return new _Jss2['default'](options);
};

/**
 * A global Jss instance.
 */
exports['default'] = create();

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry = function () {
  function SheetsRegistry() {
    _classCallCheck(this, SheetsRegistry);

    this.registry = [];
  }

  _createClass(SheetsRegistry, [{
    key: 'add',


    /**
     * Register a Style Sheet.
     */
    value: function add(sheet) {
      var registry = this.registry;
      var index = sheet.options.index;


      if (registry.indexOf(sheet) !== -1) return;

      if (registry.length === 0 || index >= this.index) {
        registry.push(sheet);
        return;
      }

      // Find a position.
      for (var i = 0; i < registry.length; i++) {
        if (registry[i].options.index > index) {
          registry.splice(i, 0, sheet);
          return;
        }
      }
    }

    /**
     * Reset the registry.
     */

  }, {
    key: 'reset',
    value: function reset() {
      this.registry = [];
    }

    /**
     * Remove a Style Sheet.
     */

  }, {
    key: 'remove',
    value: function remove(sheet) {
      var index = this.registry.indexOf(sheet);
      this.registry.splice(index, 1);
    }

    /**
     * Convert all attached sheets to a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString(options) {
      return this.registry.filter(function (sheet) {
        return sheet.attached;
      }).map(function (sheet) {
        return sheet.toString(options);
      }).join('\n');
    }
  }, {
    key: 'index',


    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

exports['default'] = SheetsRegistry;

/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _symbolObservable = __webpack_require__(537);

var _symbolObservable2 = _interopRequireDefault(_symbolObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = function (value) {
  return value && value[_symbolObservable2['default']] && value === value[_symbolObservable2['default']]();
};

/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = linkRule;
/**
 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
 */
function linkRule(rule, cssRule) {
  rule.renderable = cssRule;
  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
}

/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _StyleSheet = __webpack_require__(703);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _moduleId = __webpack_require__(1790);

var _moduleId2 = _interopRequireDefault(_moduleId);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var maxRules = 1e10;


var env = "production";

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */

exports['default'] = function () {
  var ruleCounter = 0;
  var defaultPrefix = env === 'production' ? 'c' : '';

  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
      (0, _warning2['default'])(false, '[JSS] You might have a memory leak. Rule counter is at %s.', ruleCounter);
    }

    var prefix = defaultPrefix;
    var jssId = '';

    if (sheet) {
      prefix = sheet.options.classNamePrefix || defaultPrefix;
      if (sheet.options.jss.id != null) jssId += sheet.options.jss.id;
    }

    if (env === 'production') {
      return '' + prefix + _moduleId2['default'] + jssId + ruleCounter;
    }

    return prefix + rule.key + '-' + _moduleId2['default'] + (jssId && '-' + jssId) + '-' + ruleCounter;
  };
};

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _linkRule = __webpack_require__(701);

var _linkRule2 = _interopRequireDefault(_linkRule);

var _RuleList = __webpack_require__(208);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable-next-line no-use-before-define */
var StyleSheet = function () {
  function StyleSheet(styles, options) {
    var _this = this;

    _classCallCheck(this, StyleSheet);

    this.update = function (name, data) {
      if (typeof name === 'string') {
        _this.rules.update(name, data);
      } else {
        _this.rules.update(name);
      }
      return _this;
    };

    this.attached = false;
    this.deployed = false;
    this.linked = false;
    this.classes = {};
    this.options = _extends({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes
    });
    this.renderer = new options.Renderer(this);
    this.rules = new _RuleList2['default'](this.options);

    for (var _name in styles) {
      this.rules.add(_name, styles[_name]);
    }

    this.rules.process();
  }

  /**
   * Attach renderable to the render tree.
   */


  _createClass(StyleSheet, [{
    key: 'attach',
    value: function attach() {
      if (this.attached) return this;
      if (!this.deployed) this.deploy();
      this.renderer.attach();
      if (!this.linked && this.options.link) this.link();
      this.attached = true;
      return this;
    }

    /**
     * Remove renderable from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      if (!this.attached) return this;
      this.renderer.detach();
      this.attached = false;
      return this;
    }

    /**
     * Add a rule to the current stylesheet.
     * Will insert a rule also after the stylesheet has been rendered first time.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, decl, options) {
      var queue = this.queue;

      // Plugins can create rules.
      // In order to preserve the right order, we need to queue all `.addRule` calls,
      // which happen after the first `rules.add()` call.

      if (this.attached && !queue) this.queue = [];

      var rule = this.rules.add(name, decl, options);
      this.options.jss.plugins.onProcessRule(rule);

      if (this.attached) {
        if (!this.deployed) return rule;
        // Don't insert rule directly if there is no stringified version yet.
        // It will be inserted all together when .attach is called.
        if (queue) queue.push(rule);else {
          this.insertRule(rule);
          if (this.queue) {
            this.queue.forEach(this.insertRule, this);
            this.queue = undefined;
          }
        }
        return rule;
      }

      // We can't add rules to a detached style node.
      // We will redeploy the sheet once user will attach it.
      this.deployed = false;

      return rule;
    }

    /**
     * Insert rule into the StyleSheet
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule) {
      var renderable = this.renderer.insertRule(rule);
      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
    }

    /**
     * Create and add rules.
     * Will render also after Style Sheet was rendered the first time.
     */

  }, {
    key: 'addRules',
    value: function addRules(styles, options) {
      var added = [];
      for (var _name2 in styles) {
        added.push(this.addRule(_name2, styles[_name2], options));
      }
      return added;
    }

    /**
     * Get a rule by name.
     */

  }, {
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Delete a rule by name.
     * Returns `true`: if rule has been deleted from the DOM.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(name) {
      var rule = this.rules.get(name);

      if (!rule) return false;

      this.rules.remove(rule);

      if (this.attached && rule.renderable) {
        return this.renderer.deleteRule(rule.renderable);
      }

      return true;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Deploy pure CSS string to a renderable.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      this.renderer.deploy();
      this.deployed = true;
      return this;
    }

    /**
     * Link renderable CSS rules from sheet with their corresponding models.
     */

  }, {
    key: 'link',
    value: function link() {
      var cssRules = this.renderer.getRules();

      // Is undefined when VirtualRenderer is used.
      if (cssRules) this.rules.link(cssRules);
      this.linked = true;
      return this;
    }

    /**
     * Update the function values with a new data.
     */

  }, {
    key: 'toString',


    /**
     * Convert rules to a CSS string.
     */
    value: function toString(options) {
      return this.rules.toString(options);
    }
  }]);

  return StyleSheet;
}();

exports['default'] = StyleSheet;

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AccountTab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  align-content: center;\n  justify-content: flex-start;\n  align-self: stretch;\n  min-width: 33%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  padding: 12px 18px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  background-clip: padding-box;\n  cursor: pointer;\n\n  :not(:first-of-type) {\n    border-left: 1px solid transparent;\n  }\n\n  :hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media (max-width: 959px) {\n    padding: 17px 18px;\n    font-size: ",";\n    white-space: normal;\n    align-items: center;\n    background-color: ",";\n  }\n\n  @media (max-width: 360px) {\n    padding: 15px 13px;\n  }\n\n  @media (max-width: 320px) {\n    padding: 13px 11px;\n  }\n\n  ",";\n"],["\n  display: flex;\n  flex-flow: column wrap;\n  align-items: flex-start;\n  align-content: center;\n  justify-content: flex-start;\n  align-self: stretch;\n  min-width: 33%;\n  flex-grow: 1;\n  flex-shrink: 1;\n  padding: 12px 18px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  background-clip: padding-box;\n  cursor: pointer;\n\n  :not(:first-of-type) {\n    border-left: 1px solid transparent;\n  }\n\n  :hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media (max-width: 959px) {\n    padding: 17px 18px;\n    font-size: ",";\n    white-space: normal;\n    align-items: center;\n    background-color: ",";\n  }\n\n  @media (max-width: 360px) {\n    padding: 15px 13px;\n  }\n\n  @media (max-width: 320px) {\n    padding: 13px 11px;\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      background-color: ",";\n\n      @media (max-width: 959px) {\n        background-color: ",";\n      }\n    "],["\n      background-color: ",";\n\n      @media (max-width: 959px) {\n        background-color: ",";\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  font-weight: 400;\n  line-height: inherit;\n  text-transform: capitalize;\n  pointer-events: none;\n\n  @media (min-width: 959px) {\n    line-height: 20px;\n  }\n\n  @media (max-width: 959px) {\n    margin-bottom: 0;\n    font-size: ",";\n    text-align: center;\n  }\n\n  color: ",";\n"],["\n  font-weight: 400;\n  line-height: inherit;\n  text-transform: capitalize;\n  pointer-events: none;\n\n  @media (min-width: 959px) {\n    line-height: 20px;\n  }\n\n  @media (max-width: 959px) {\n    margin-bottom: 0;\n    font-size: ",";\n    text-align: center;\n  }\n\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Tab=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref){var theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.alternativeForeground,0.8);},function(props){return props.theme.toggleAccountLightBg;},function(_ref2){var theme=_ref2.theme;return theme.foreground;},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.theme.toggleAccountDarkBg;},function(_ref3){var active=_ref3.active,theme=_ref3.theme;return active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,theme.toggleAccountLightBg,function(props){return props.theme.toggleAccountLightBg;});}));var Heading=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h3(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),function(_ref4){var tab=_ref4.tab,theme=_ref4.theme;switch(tab){case"tournament":return theme.mode==="dark"?"#ffffff":theme.foreground;case"real":return"#3B9478";case"demo":return"#FFCC00";default:return"#919191";}}));function AccountTab(_ref5){var currentTab=_ref5.currentTab,tab=_ref5.tab,onClick=_ref5.onClick,children=_ref5.children;var isActive=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return currentTab===tab||currentTab==="real_stub"&&tab==="real";},[currentTab,tab]);var clickHandler=__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function(){return onClick(tab);},[tab]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab,{active:isActive,onClick:clickHandler},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,{tab:tab,active:isActive},children));}

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  height: 31px;\n  width: auto;\n  padding: 0 18px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n  white-space: nowrap;\n  text-align: center;\n  border: none;\n  border-radius: 3px;\n  color: #fff;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  hover,\n  :active,\n  :focus {\n    color: #fff;\n    text-decoration: none;\n  }\n\n  ",";\n  ",";\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  height: 31px;\n  width: auto;\n  padding: 0 18px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n  white-space: nowrap;\n  text-align: center;\n  border: none;\n  border-radius: 3px;\n  color: #fff;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  hover,\n  :active,\n  :focus {\n    color: #fff;\n    text-decoration: none;\n  }\n\n  ",";\n  ",";\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      background-color: #60a31c;\n\n      :hover,\n      :active,\n      :focus {\n        background-color: #427f03;\n      }\n    "],["\n      background-color: #60a31c;\n\n      :hover,\n      :active,\n      :focus {\n        background-color: #427f03;\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      background-color: #97959a;\n      margin-left: 12px;\n\n      :hover,\n      :active,\n      :focus {\n        background-color: #756886;\n      }\n    "],["\n      background-color: #97959a;\n      margin-left: 12px;\n\n      :hover,\n      :active,\n      :focus {\n        background-color: #756886;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      color: #ffffff;\n      background-color: ",";\n\n      :hover,\n      :active,\n      :focus {\n        color: #362f41;\n        background-color: #eb8a00;\n      }\n\n      ",";\n    "],["\n      color: #ffffff;\n      background-color: ",";\n\n      :hover,\n      :active,\n      :focus {\n        color: #362f41;\n        background-color: #eb8a00;\n      }\n\n      ",";\n    "]),_templateObject5=_taggedTemplateLiteral(["\n          position: relative;\n          font-size: ",";\n          font-weight: bold;\n          color: #ffffff;\n          text-decoration: none;\n          text-transform: uppercase;\n          background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n          border-radius: 32px;\n          cursor: pointer;\n          z-index: 2;\n\n          ::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            right: 0;\n            display: block;\n            background-image: linear-gradient(\n              to left,\n              #5c6cc0 0%,\n              #47c0c8 100%\n            );\n            border-radius: inherit;\n            z-index: -1;\n            opacity: 0;\n            transition: opacity 0.5s;\n          }\n\n          :hover {\n            color: #ffffff;\n            ::before {\n              opacity: 1;\n            }\n          }\n        "],["\n          position: relative;\n          font-size: ",";\n          font-weight: bold;\n          color: #ffffff;\n          text-decoration: none;\n          text-transform: uppercase;\n          background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n          border-radius: 32px;\n          cursor: pointer;\n          z-index: 2;\n\n          ::before {\n            content: \"\";\n            position: absolute;\n            top: 0;\n            left: 0;\n            bottom: 0;\n            right: 0;\n            display: block;\n            background-image: linear-gradient(\n              to left,\n              #5c6cc0 0%,\n              #47c0c8 100%\n            );\n            border-radius: inherit;\n            z-index: -1;\n            opacity: 0;\n            transition: opacity 0.5s;\n          }\n\n          :hover {\n            color: #ffffff;\n            ::before {\n              opacity: 1;\n            }\n          }\n        "]),_templateObject6=_taggedTemplateLiteral(["\n      font-size: ",";\n      font-weight: bold;\n      color: ",";\n      text-decoration: none;\n      text-transform: uppercase;\n      background: none;\n      border: 2px solid\n        ",";\n      border-radius: 32px;\n      cursor: pointer;\n      transition: all 0.5s;\n\n      :hover {\n        color: ",";\n        background-color: ",";\n      }\n    "],["\n      font-size: ",";\n      font-weight: bold;\n      color: ",";\n      text-decoration: none;\n      text-transform: uppercase;\n      background: none;\n      border: 2px solid\n        ",";\n      border-radius: 32px;\n      cursor: pointer;\n      transition: all 0.5s;\n\n      :hover {\n        color: ",";\n        background-color: ",";\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      min-height: 58px;\n      font-weight: 700;\n      font-size: 24px;\n      text-shadow: -1px -1px #ca7700;\n      background-color: #fea600;\n      background: linear-gradient(to bottom, #fea600, #fd9600);\n      box-shadow: inset 0px -1px 0px 0px #fea600;\n      border-bottom: 2px solid #ca7700;\n      border-radius: 8px;\n      color: #fff;\n\n      :hover,\n      :active,\n      :focus {\n        background-color: #fd9600;\n        background: linear-gradient(to bottom, #fd9600, #fea600);\n      }\n    "],["\n      min-height: 58px;\n      font-weight: 700;\n      font-size: 24px;\n      text-shadow: -1px -1px #ca7700;\n      background-color: #fea600;\n      background: linear-gradient(to bottom, #fea600, #fd9600);\n      box-shadow: inset 0px -1px 0px 0px #fea600;\n      border-bottom: 2px solid #ca7700;\n      border-radius: 8px;\n      color: #fff;\n\n      :hover,\n      :active,\n      :focus {\n        background-color: #fd9600;\n        background: linear-gradient(to bottom, #fd9600, #fea600);\n      }\n    "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.type==="refill"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.type==="withdraw"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(props){return props.type==="trade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(props){return props.theme.accent;},"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12)));},function(_ref){var type=_ref.type,theme=_ref.theme;return "irontrade"==="irontrade"&&(type==="withdraw"||type==="refill"||type==="tradeCardRefill")&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),theme.mode==="light"&&type!=="tradeCardRefill"?"#3B9478":"#ffffff",theme.mode==="light"&&type!=="tradeCardRefill"?"#3B9478":"#ffffff",theme.mode==="light"&&type!=="tradeCardRefill"?"#ffffff":"#3B9478",theme.mode==="light"&&type!=="tradeCardRefill"?"#3B9478":"#ffffff");},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);});var AccountButton=function AccountButton(_ref2){var type=_ref2.type,props=_objectWithoutProperties(_ref2,["type"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,Object.assign({as:props.to!=null?__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */]:Button,type:type},props));};/* harmony default export */ __webpack_exports__["a"] = (AccountButton);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PrizeFund;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"],["\n  display: flex;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline;\n  font-size: ",";\n  color: #99959d;\n"],["\n  display: inline;\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-top: 5px;\n  font-size: ",";\n  color: #99959d;\n"],["\n  margin-top: 5px;\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 28px;\n  height: 35px;\n  margin-right: ",";\n  margin-left: ",";\n  color: ",";\n"],["\n  width: 28px;\n  height: 35px;\n  margin-right: ",";\n  margin-left: ",";\n  color: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: 700;\n  margin: 0 2px;\n  color: ",";\n"],["\n  font-weight: 700;\n  margin: 0 2px;\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12));var TimeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?"15px":"14px";});var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.direction==="rtl"?"0":"4px";},function(_ref3){var theme=_ref3.theme;return theme.direction==="rtl"?"4px":"0";},function(_ref4){var theme=_ref4.theme,isTradePage=_ref4.isTradePage;return isTradePage?"#ffffff":theme.foreground;});var Value=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */].Value)(_templateObject5,function(_ref5){var theme=_ref5.theme,istradepage=_ref5.istradepage;return istradepage?"#ffffff":theme.foreground;});var Currency=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */].Symbol)(_templateObject5,function(_ref6){var theme=_ref6.theme,istradepage=_ref6.istradepage;return istradepage?"#feac00":theme.accent;});function PrizeFund(_ref7){var prize_fund=_ref7.prize_fund,prize_fund_usd=_ref7.prize_fund_usd,isTradePage=_ref7.isTradePage;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconContainer,{isTradePage:isTradePage},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_Tournaments__["e" /* Cup */],{width:28,height:35})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Prize fund"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TimeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HowMuchInBucks__["a" /* default */],{value:prize_fund,valueUSD:prize_fund_usd,valueStyle:Value,symbolStyle:Currency,divider:"\xA0/\xA0",isTradePage:isTradePage}))));}

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return InvitedTournamentName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return Title; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AboutToggle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AboutTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Container; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return UserInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AccountInfo; });
/* unused harmony export Status */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return UserEmail; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return UserId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return Counts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return Count; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Numbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return Tabs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Tab; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return Tournaments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PaginationSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return SelectText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return HelpContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return HelpLink; });
/* unused harmony export Pagination */
/* unused harmony export Arrow */
/* unused harmony export PaginationItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SpinnerContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Bar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PageContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Link__ = __webpack_require__(8);
var _templateObject=_taggedTemplateLiteral(["\n  background-color: #ffffff;\n"],["\n  background-color: #ffffff;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  padding: 25px 0;\n  font-weight: 600;\n  font-size: 36px;\n  text-align: center;\n  color: #343434;\n\n  @media (max-width: 959px) {\n    padding: 10px;\n    font-size: 24px;\n  }\n"],["\n  padding: 25px 0;\n  font-weight: 600;\n  font-size: 36px;\n  text-align: center;\n  color: #343434;\n\n  @media (max-width: 959px) {\n    padding: 10px;\n    font-size: 24px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  margin-top: 20px;\n  padding: 18px 10px;\n  border-radius: 4px;\n  background-color: #f6f6f6;\n  user-select: none;\n  cursor: pointer;\n\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    ",";\n    transform: rotate(-45deg) translateY(-50%);\n    transform-origin: 50%;\n    display: block;\n    width: 14px;\n    height: 14px;\n    border-right: 3px solid #b5b5b5;\n    border-bottom: 3px solid #b5b5b5;\n    transition: all 0.3s ease;\n  }\n\n  ",";\n"],["\n  position: relative;\n  margin-top: 20px;\n  padding: 18px 10px;\n  border-radius: 4px;\n  background-color: #f6f6f6;\n  user-select: none;\n  cursor: pointer;\n\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    ",";\n    transform: rotate(-45deg) translateY(-50%);\n    transform-origin: 50%;\n    display: block;\n    width: 14px;\n    height: 14px;\n    border-right: 3px solid #b5b5b5;\n    border-bottom: 3px solid #b5b5b5;\n    transition: all 0.3s ease;\n  }\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n            left: 23px;\n          "],["\n            left: 23px;\n          "]),_templateObject5=_taggedTemplateLiteral(["\n            right: 23px;\n          "],["\n            right: 23px;\n          "]),_templateObject6=_taggedTemplateLiteral(["\n      color: #a5a4a4;\n      :before {\n        content: \"\";\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translateY(-50%);\n        transform-origin: 0%;\n        display: block;\n        margin-top: 3px;\n        font-size: ",";\n        line-height: 1;\n        font-family: Tahoma, sans-serif;\n        text-transform: lowercase;\n      }\n      :after {\n        transform: rotate(45deg) translateY(-50%);\n        transform-origin: 100%;\n      }\n    "],["\n      color: #a5a4a4;\n      :before {\n        content: \"\";\n        position: absolute;\n        left: 50%;\n        top: 50%;\n        transform: translateY(-50%);\n        transform-origin: 0%;\n        display: block;\n        margin-top: 3px;\n        font-size: ",";\n        line-height: 1;\n        font-family: Tahoma, sans-serif;\n        text-transform: lowercase;\n      }\n      :after {\n        transform: rotate(45deg) translateY(-50%);\n        transform-origin: 100%;\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  font-size: 36px;\n  font-weight: bold;\n  color: #a7a7a7;\n  text-align: center;\n  user-select: none;\n  cursor: pointer;\n\n  @media (max-width: 959px) {\n    font-size: 24px;\n  }\n"],["\n  font-size: 36px;\n  font-weight: bold;\n  color: #a7a7a7;\n  text-align: center;\n  user-select: none;\n  cursor: pointer;\n\n  @media (max-width: 959px) {\n    font-size: 24px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto;\n  margin-bottom: 24px;\n  padding: 0 10px;\n\n  @media (max-width: 959px) {\n    padding: 0 15px;\n  }\n"],["\n  width: 100%;\n  max-width: 980px;\n  margin: 0 auto;\n  margin-bottom: 24px;\n  padding: 0 10px;\n\n  @media (max-width: 959px) {\n    padding: 0 15px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 25px 20px;\n  background-color: #f6f6f6;\n  border-radius: 4px;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 15px 0;\n    background-color: transparent;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 25px 20px;\n  background-color: #f6f6f6;\n  border-radius: 4px;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 15px 0;\n    background-color: transparent;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  min-width: 200px;\n\n  @media (max-width: 959px) {\n    direction: ",";\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 2px;\n    padding: 8px 14px;\n    background-color: #f6f6f6;\n    border-radius: 4px;\n  }\n"],["\n  min-width: 200px;\n\n  @media (max-width: 959px) {\n    direction: ",";\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 2px;\n    padding: 8px 14px;\n    background-color: #f6f6f6;\n    border-radius: 4px;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  direction: ",";\n  padding-left: 50px;\n  border-left: 3px solid #a7a7a7;\n  list-style: disc;\n\n  @media (max-width: 959px) {\n    width: 100%;\n    padding: 8px 14px 8px 30px;\n    background-color: #f6f6f6;\n    border-radius: 4px;\n    border-left: none;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"],["\n  direction: ",";\n  padding-left: 50px;\n  border-left: 3px solid #a7a7a7;\n  list-style: disc;\n\n  @media (max-width: 959px) {\n    width: 100%;\n    padding: 8px 14px 8px 30px;\n    background-color: #f6f6f6;\n    border-radius: 4px;\n    border-left: none;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  direction: ",";\n  font-weight: 700;\n  font-size: ",";\n"],["\n  direction: ",";\n  font-weight: 700;\n  font-size: ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #343434;\n\n  @media (max-width: 959px) {\n    margin-right: ",";\n    margin-left: ",";\n    margin-bottom: 0;\n  }\n\n  > a {\n    font-size: 16px;\n    font-weight: 700;\n    color: #343434;\n    text-decoration: none;\n\n    @media (max-width: 959px) {\n      font-size: ",";\n    }\n\n    @media (max-width: 479px) {\n      font-size: ",";\n      font-weight: 400;\n    }\n\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"],["\n  margin-bottom: 5px;\n  font-size: 16px;\n  font-weight: 700;\n  color: #343434;\n\n  @media (max-width: 959px) {\n    margin-right: ",";\n    margin-left: ",";\n    margin-bottom: 0;\n  }\n\n  > a {\n    font-size: 16px;\n    font-weight: 700;\n    color: #343434;\n    text-decoration: none;\n\n    @media (max-width: 959px) {\n      font-size: ",";\n    }\n\n    @media (max-width: 479px) {\n      font-size: ",";\n      font-weight: 400;\n    }\n\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #95989a;\n\n  @media (max-width: 959px) {\n    > svg:first-of-type {\n      display: none;\n    }\n  }\n\n  > a {\n    font-size: ",";\n    color: #95989a;\n    text-decoration: none;\n\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"],["\n  font-size: ",";\n  color: #95989a;\n\n  @media (max-width: 959px) {\n    > svg:first-of-type {\n      display: none;\n    }\n  }\n\n  > a {\n    font-size: ",";\n    color: #95989a;\n    text-decoration: none;\n\n    :hover {\n      text-decoration: underline;\n    }\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  line-height: 1.2;\n\n  :last-child {\n    margin-bottom: 0;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n    margin-top: 9px;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n"],["\n  margin-bottom: 12px;\n  line-height: 1.2;\n\n  :last-child {\n    margin-bottom: 0;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n    margin-top: 9px;\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  display: inline;\n  font-size: 18px;\n  font-weight: 700;\n  color: ",";\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  display: inline;\n  font-size: 18px;\n  font-weight: 700;\n  color: ",";\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  display: inline;\n  font-weight: 700;\n  color: ",";\n"],["\n  display: inline;\n  font-weight: 700;\n  color: ",";\n"]),_templateObject18=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  color: #a7a7a7;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    max-width: 100%;\n  }\n"],["\n  direction: ",";\n  font-size: ",";\n  color: #a7a7a7;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    max-width: 100%;\n  }\n"]),_templateObject19=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-start;\n  width: 100%;\n  height: 52px;\n  margin-top: 37px;\n  border-bottom: 4px solid #f6f6f6;\n\n  @media (max-width: 959px) {\n    margin-top: 25px;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  align-items: stretch;\n  justify-content: flex-start;\n  width: 100%;\n  height: 52px;\n  margin-top: 37px;\n  border-bottom: 4px solid #f6f6f6;\n\n  @media (max-width: 959px) {\n    margin-top: 25px;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 25%;\n  flex-basis: 25%;\n  text-align: center;\n  font-size: ",";\n  font-weight: 700;\n  color: #343434;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 4px 4px 0 0;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    font-size: 12px;\n  }\n\n  :hover {\n    background-color: #f6f6f6;\n  }\n\n  ",";\n"],["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 25%;\n  flex-basis: 25%;\n  text-align: center;\n  font-size: ",";\n  font-weight: 700;\n  color: #343434;\n  cursor: pointer;\n  user-select: none;\n  border-radius: 4px 4px 0 0;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    font-size: 12px;\n  }\n\n  :hover {\n    background-color: #f6f6f6;\n  }\n\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n      color: ",";\n      background-color: #f6f6f6;\n    "],["\n      color: ",";\n      background-color: #f6f6f6;\n    "]),_templateObject22=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n  padding-top: 24px;\n\n  @media (max-width: 969px) {\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n  }\n"],["\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n  padding-top: 24px;\n\n  @media (max-width: 969px) {\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (max-width: 959px) {\n    justify-content: center;\n  }\n\n  ",";\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (max-width: 959px) {\n    justify-content: center;\n  }\n\n  ",";\n"]),_templateObject24=_taggedTemplateLiteral(["\n      justify-content: flex-end !important;\n    "],["\n      justify-content: flex-end !important;\n    "]),_templateObject25=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  > div:last-of-type {\n    min-width: 79px;\n  }\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  > div:last-of-type {\n    min-width: 79px;\n  }\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject26=_taggedTemplateLiteral(["\n  margin-right: 25px;\n  ",";\n  font-size: ",";\n  color: #717171;\n"],["\n  margin-right: 25px;\n  ",";\n  font-size: ",";\n  color: #717171;\n"]),_templateObject27=_taggedTemplateLiteral(["\n          margin-left: 25px;\n        "],["\n          margin-left: 25px;\n        "]),_templateObject28=_taggedTemplateLiteral(["\n          margin-right: 25px;\n        "],["\n          margin-right: 25px;\n        "]),_templateObject29=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject30=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n  text-decoration: none;\n\n  :hover {\n    text-decoration: underline;\n  }\n"],["\n  font-size: ",";\n  color: ",";\n  text-decoration: none;\n\n  :hover {\n    text-decoration: underline;\n  }\n"]),_templateObject31=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]),_templateObject32=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n  color: #a7a7a7;\n  user-select: none;\n\n  :hover {\n    color: #717171;\n  }\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  cursor: pointer;\n  color: #a7a7a7;\n  user-select: none;\n\n  :hover {\n    color: #717171;\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject33=_taggedTemplateLiteral(["\n      transform: rotate(180deg);\n    "],["\n      transform: rotate(180deg);\n    "]),_templateObject34=_taggedTemplateLiteral(["\n      cursor: default;\n      color: #a7a7a7;\n      opacity: 0.5;\n\n      :hover {\n        color: #a7a7a7;\n      }\n    "],["\n      cursor: default;\n      color: #a7a7a7;\n      opacity: 0.5;\n\n      :hover {\n        color: #a7a7a7;\n      }\n    "]),_templateObject35=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  font-size: ",";\n  color: #a7a7a7;\n  border: 3px solid transparent;\n  cursor: pointer;\n  user-select: none;\n\n  :hover {\n    font-weight: 700;\n    color: ",";\n  }\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  font-size: ",";\n  color: #a7a7a7;\n  border: 3px solid transparent;\n  cursor: pointer;\n  user-select: none;\n\n  :hover {\n    font-weight: 700;\n    color: ",";\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject36=_taggedTemplateLiteral(["\n      font-weight: 700;\n      color: #717171;\n      border-color: #efefef;\n      cursor: default;\n    "],["\n      font-weight: 700;\n      color: #717171;\n      border-color: #efefef;\n      cursor: default;\n    "]),_templateObject37=_taggedTemplateLiteral(["\n      color: #a7a7a7 !important;\n      font-weight: 400 !important;\n      cursor: default;\n    "],["\n      color: #a7a7a7 !important;\n      font-weight: 400 !important;\n      cursor: default;\n    "]),_templateObject38=_taggedTemplateLiteral(["\n  height: ","px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-bottom: 20px;\n\n  @media (max-width: 959px) {\n    height: auto !important;\n  }\n"],["\n  height: ","px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  padding-bottom: 20px;\n\n  @media (max-width: 959px) {\n    height: auto !important;\n  }\n"]),_templateObject39=_taggedTemplateLiteral(["\n  position: relative;\n  flex: 1;\n  width: 6px;\n  margin-right: 3px;\n  background-color: ",";\n  z-index: 1;\n"],["\n  position: relative;\n  flex: 1;\n  width: 6px;\n  margin-right: 3px;\n  background-color: ",";\n  z-index: 1;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PageContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject);var Title=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h1(_templateObject2);var AboutToggle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject4):Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject5);},function(_ref2){var isOpen=_ref2.isOpen;return isOpen&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject6,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});});var AboutTitle=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h2(_templateObject7);var Container=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject8);var UserInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject9);var AccountInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject10,function(_ref4){var theme=_ref4.theme;return theme.direction;});var Counts=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].ul(_templateObject11,function(_ref5){var theme=_ref5.theme;return theme.direction;});var Status=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject12,function(_ref6){var theme=_ref6.theme;return theme.direction;},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var UserEmail=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject13,function(_ref8){var theme=_ref8.theme;return theme.direction==="rtl"?"0":"7px";},function(_ref9){var theme=_ref9.theme;return theme.direction==="rtl"?"7px":"0";},function(_ref10){var theme=_ref10.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref11){var theme=_ref11.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var UserId=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject14,function(_ref12){var theme=_ref12.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref13){var theme=_ref13.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Count=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].li(_templateObject15);var Numbers=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.theme.indexMajor;},function(_ref14){var theme=_ref14.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var InvitedTournamentName=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject17,function(props){return props.theme.indexMajor;});var Text=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject18,function(_ref15){var theme=_ref15.theme;return theme.direction;},function(_ref16){var theme=_ref16.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref17){var theme=_ref17.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Tabs=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject19,function(_ref18){var theme=_ref18.theme;return theme.direction;});var Tab=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject20,function(_ref19){var theme=_ref19.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref20){var theme=_ref20.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject21,function(props){return props.theme.indexMajor;});});var Tournaments=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject22);var Bottom=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject23,function(_ref21){var theme=_ref21.theme;return theme.direction;},function(_ref22){var activeTab=_ref22.activeTab;return activeTab==="activeFreeTournaments"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject24);});var PaginationSelect=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject25,function(props){return props.theme.direction;});var SelectText=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject26,function(_ref23){var theme=_ref23.theme;return theme.locale==="ar"?Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject27):Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject28);},function(_ref24){var theme=_ref24.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var HelpContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject29,function(props){return props.theme.direction;});var HelpLink=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1__common_Link__["a" /* Link */])(_templateObject30,function(_ref25){var theme=_ref25.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.theme.indexMajor;});var Pagination=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject31);var Arrow=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject32,function(props){return props.right&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject33);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject34);});var PaginationItem=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject35,function(_ref26){var theme=_ref26.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.theme.indexMajor;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject36);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject37);});var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject38,function(props){return props.spinnerHeight;});var Bar=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject39,function(_ref27){var theme=_ref27.theme;return theme.accent;});

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAmountLimit; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Shield__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccountType_Icons__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Money__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  color: #272b34;\n  background-color: #ffcc00;\n  text-align: center;\n  background-image: url(\"img/compensation-popup_bg.png\");\n  background-repeat: no-repeat;\n  background-position: center 9px;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n  @media (max-width: 425px) {\n    background-image: url(\"img/compensation-popup_bg_mob.png\");\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  color: #272b34;\n  background-color: #ffcc00;\n  text-align: center;\n  background-image: url(\"img/compensation-popup_bg.png\");\n  background-repeat: no-repeat;\n  background-position: center 9px;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n  @media (max-width: 425px) {\n    background-image: url(\"img/compensation-popup_bg_mob.png\");\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.3;\n  text-transform: uppercase;\n  margin-bottom: 24px;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n  }\n"],["\n  font-size: ",";\n  line-height: 1.3;\n  text-transform: uppercase;\n  margin-bottom: 24px;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: ",";\n  margin-bottom: 24px;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n  }\n"],["\n  font-size: ",";\n  margin-bottom: 24px;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  border: 2px solid\n    ",";\n  border-radius: 19px;\n  font-size: ",";\n  line-height: 1;\n  padding: 10px 46px;\n  background-color: transparent;\n  color: ",";\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.3s;\n  text-transform: uppercase;\n  text-decoration: none;\n  :hover:not([disabled]) {\n    background-color: ",";\n    color: ",";\n  }\n  :disabled {\n    opacity: 0.4;\n  }\n"],["\n  border: 2px solid\n    ",";\n  border-radius: 19px;\n  font-size: ",";\n  line-height: 1;\n  padding: 10px 46px;\n  background-color: transparent;\n  color: ",";\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.3s;\n  text-transform: uppercase;\n  text-decoration: none;\n  :hover:not([disabled]) {\n    background-color: ",";\n    color: ",";\n  }\n  :disabled {\n    opacity: 0.4;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  padding: 38px 30px 0;\n  text-align: center;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  @media (max-width: 768px) {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n"],["\n  padding: 38px 30px 0;\n  text-align: center;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  @media (max-width: 768px) {\n    padding-right: 16px;\n    padding-left: 16px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  position: relative;\n  background-color: ",";\n  padding: 26px 37px;\n  @media (max-width: 768px) {\n    padding: 24px 16px 16px;\n  }\n"],["\n  position: relative;\n  background-color: ",";\n  padding: 26px 37px;\n  @media (max-width: 768px) {\n    padding: 24px 16px 16px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  max-width: 580px;\n  margin: 0 auto 25px;\n  text-align: center;\n  color: ",";\n  font-size: ",";\n  line-height: 1.3;\n  mark {\n    background-color: unset;\n    color: ",";\n  }\n"],["\n  max-width: 580px;\n  margin: 0 auto 25px;\n  text-align: center;\n  color: ",";\n  font-size: ",";\n  line-height: 1.3;\n  mark {\n    background-color: unset;\n    color: ",";\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  margin-bottom: 18px;\n"],["\n  margin-bottom: 18px;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  width: 30px;\n  height: 40px;\n  display: inline-block;\n"],["\n  width: 30px;\n  height: 40px;\n  display: inline-block;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid rgba(52, 52, 52, 0.15);\n  padding-top: 15px;\n  padding-bottom: 17px;\n  @media (max-width: 768px) {\n    justify-content: space-around;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  border-top: 1px solid rgba(52, 52, 52, 0.15);\n  padding-top: 15px;\n  padding-bottom: 17px;\n  @media (max-width: 768px) {\n    justify-content: space-around;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  margin: 0 35px;\n  @media (max-width: 768px) {\n    margin: 0;\n  }\n"],["\n  margin: 0 35px;\n  @media (max-width: 768px) {\n    margin: 0;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  color: #272b34;\n  opacity: 0.55;\n  margin-bottom: 4px;\n  font-size: ",";\n  font-weight: 700;\n"],["\n  color: #272b34;\n  opacity: 0.55;\n  margin-bottom: 4px;\n  font-size: ",";\n  font-weight: 700;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #272b34;\n  font-weight: 700;\n"],["\n  font-size: ",";\n  color: #272b34;\n  font-weight: 700;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  color: ",";\n  position: absolute;\n  left: 0;\n  top: 10px;\n  font-size: ",";\n  @media (max-width: 959px) {\n    position: relative;\n  }\n"],["\n  color: ",";\n  position: absolute;\n  left: 0;\n  top: 10px;\n  font-size: ",";\n  @media (max-width: 959px) {\n    position: relative;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n  position: relative;\n  @media (max-width: 959px) {\n    display: flex;\n    justify-content: center;\n  }\n"],["\n  position: relative;\n  @media (max-width: 959px) {\n    display: flex;\n    justify-content: center;\n  }\n"]),_templateObject19=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(28),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(18));var Profit=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(49),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(22));var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__common_Link__["a" /* Link */])(_templateObject7,function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#3B9478":"#FFFFFF";},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12),function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?"#3B9478":"#FFFFFF";},function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?"#3B9478":"#FFFFFF";},function(_ref4){var theme=_ref4.theme;return theme.mode==="light"?"#FFFFFF":"#3B9478";});var Body=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Footer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref5){var theme=_ref5.theme;return theme.mode==="light"?"#F5F5F5":"#272B34";});var FooterText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(_ref6){var theme=_ref6.theme;return theme.mode==="light"?"#919191":"#FFFFFF";},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14),function(_ref7){var theme=_ref7.theme;return theme.mode==="light"?"#1B546A":"#FFCC00";});var Shields=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var ShieldItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var TableItem=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var TableLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12));var TableValue=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(18));var Details=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__common_Link__["a" /* Link */])(_templateObject17,function(_ref8){var theme=_ref8.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12));var FooterButtons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject18);var BonusSticker=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject19);var getAmountLimit=function getAmountLimit(compensations){if(compensations!=null&&compensations["demo"]){var sorted=compensations["demo"].items.sort(function(a,b){return+new Date(b.created)-+new Date(a.created);});return sorted.length>0?sorted[0]["amount_limit"]:0;}};var CompensationPopup=function CompensationPopup(props){var memoizedHotIcon=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__AccountType_Icons__["c" /* HotIcon */],null);},[]);var memoizedShieldIcon=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShieldItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Icons_Shield__["a" /* default */],null));},[]);var amountLimit=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return getAmountLimit(props.compensations);},[props.compensations]);var haveUserRealAccount=props.real===1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{onClick:props.onClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You have used all risk-free trades!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Shields,null,memoizedShieldIcon,memoizedShieldIcon,memoizedShieldIcon,memoizedShieldIcon,memoizedShieldIcon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Profit,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Your profit"),": ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Money__["b" /* default */],null,props.profit)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableItem,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableLabel,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You've saved"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableValue,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Money__["b" /* default */],null,props.compensated))))),!haveUserRealAccount&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusSticker,null,memoizedHotIcon),amountLimit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Don't worry about losing real money! Now we give newbie traders, who made their first deposit, ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("mark",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"5 risk-free trades that can be used for all deals up to ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Money__["b" /* default */],null,amountLimit))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterButtons,null,false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Details,{to:"#"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"details")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{to:"/fillup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Use bonus"))))));};function mapStateToProps(state){return{real:state.profile.real};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(CompensationPopup));

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Account;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_RefreshOutlined__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_RefreshOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_RefreshOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  color: ",";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 175px;\n\n  ",";\n\n  @media (min-width: 960px) {\n    margin-bottom: 4px;\n  }\n"],["\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  color: ",";\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 175px;\n\n  ",";\n\n  @media (min-width: 960px) {\n    margin-bottom: 4px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  padding-right: 20px;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1;\n  color: #fff;\n  cursor: pointer;\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding-top: 2px;\n    font-size: 15px;\n\n    :after {\n      border-width: 4px;\n    }\n  }\n  @media (max-width: 375px) {\n    padding-right: 12px;\n  }\n"],["\n  position: relative;\n  padding-right: 20px;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1;\n  color: #fff;\n  cursor: pointer;\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding-top: 2px;\n    font-size: 15px;\n\n    :after {\n      border-width: 4px;\n    }\n  }\n  @media (max-width: 375px) {\n    padding-right: 12px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n      :after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: 50%;\n        right: 0;\n        transform: translateY(-50%)\n          rotate(","deg);\n        transform-origin: 50%;\n        border: 5px solid transparent;\n        border-top-color: ",";\n        border-bottom: none;\n        transition: transform 0.3s ease;\n      }\n    "],["\n      :after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        top: 50%;\n        right: 0;\n        transform: translateY(-50%)\n          rotate(","deg);\n        transform-origin: 50%;\n        border: 5px solid transparent;\n        border-top-color: ",";\n        border-bottom: none;\n        transition: transform 0.3s ease;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n\n  @media (min-width: 960px) {\n    margin-top: 4px;\n  }\n"],["\n  direction: ",";\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n\n  @media (min-width: 960px) {\n    margin-top: 4px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: ",";\n\n  .value {\n    color: rgba(255, 255, 255, 0.44);\n    margin-left: 7px;\n    font-size: 12px;\n    &.active {\n      color: #ffcc00;\n    }\n    @media (max-width: 375px) {\n      margin-left: ",";\n    }\n  }\n\n  .label {\n    @media (max-width: 375px) {\n      font-size: ",";\n      white-space: ",";\n      text-align: ",";\n      line-height: ",";\n    }\n  }\n\n  .infinity {\n    color: #ffcc00;\n    margin: 0 4px;\n    width: 12px;\n    height: 12px;\n    display: flex;\n    align-items: center;\n  }\n\n  .count {\n    font-weight: 400;\n    font-size: 12px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  font-size: ",";\n\n  .value {\n    color: rgba(255, 255, 255, 0.44);\n    margin-left: 7px;\n    font-size: 12px;\n    &.active {\n      color: #ffcc00;\n    }\n    @media (max-width: 375px) {\n      margin-left: ",";\n    }\n  }\n\n  .label {\n    @media (max-width: 375px) {\n      font-size: ",";\n      white-space: ",";\n      text-align: ",";\n      line-height: ",";\n    }\n  }\n\n  .infinity {\n    color: #ffcc00;\n    margin: 0 4px;\n    width: 12px;\n    height: 12px;\n    display: flex;\n    align-items: center;\n  }\n\n  .count {\n    font-weight: 400;\n    font-size: 12px;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InfinityIcon=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 17.502 17.502",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M13.182 4.431a4.282 4.282 0 0 0-3.036 1.246L8.75 7.017l-1.375-1.32C6.56 4.88 5.474 4.431 4.32 4.431s-2.239.451-3.053 1.266A4.288 4.288 0 0 0 0 8.752c0 1.152.449 2.238 1.266 3.053a4.285 4.285 0 0 0 3.054 1.266 4.272 4.272 0 0 0 3.036-1.248l1.395-1.338 1.376 1.32c.815.816 1.901 1.266 3.055 1.266s2.238-.449 3.053-1.266c.817-.814 1.267-1.9 1.267-3.055s-.449-2.238-1.266-3.055a4.296 4.296 0 0 0-3.054-1.264zm-7.576 5.605c-.687.688-1.884.688-2.572 0a1.807 1.807 0 0 1-.533-1.285c0-.486.189-.941.535-1.287.342-.344.799-.533 1.284-.533s.942.189 1.305.551l1.321 1.27-1.34 1.284zm8.861 0c-.687.689-1.866.705-2.59-.018l-1.321-1.27 1.339-1.285c.688-.688 1.886-.688 2.573-.002.344.346.533.801.533 1.287s-.19.944-.534 1.288z",fill:"currentColor"}));});var Type=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(10),function(props){return props.theme.accent;},function(props){return props.type==="real"&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2,function(props){return props.theme.alternativeUpper;});});var Balance=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.showDeposit&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,function(props){return props.open?-180:0;},function(props){return props.theme.accent;});});var Currency=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */].Symbol)(_templateObject5,function(_ref){var type=_ref.type,theme=_ref.theme;return type==="real"?theme.alternativeUpper:theme.accent;});var TradingVolume=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(10),function(_ref2){var theme=_ref2.theme;return theme.textMuted;});var RefillContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12),function(_ref3){var theme=_ref3.theme;return theme.locale==="th"||theme.locale==="ar"?"3px":"5px";},function(_ref4){var theme=_ref4.theme;return(theme.locale==="th"||theme.locale==="ar")&&Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(10);},function(_ref5){var theme=_ref5.theme;return theme.locale==="th"&&"initial";},function(_ref6){var theme=_ref6.theme;return theme.locale==="th"&&"left";},function(_ref7){var theme=_ref7.theme;return theme.locale==="th"&&".8";});function Account(_ref8){var refillAvailable=_ref8.refillAvailable,onRefillClick=_ref8.onRefillClick,activeAccount=_ref8.activeAccount,isOpen=_ref8.isOpen,showDeposit=_ref8.showDeposit,children=_ref8.children,tournamentType=_ref8.tournamentType,totalCountRefill=_ref8.totalCountRefill,usedCountRefill=_ref8.usedCountRefill;var type=activeAccount.type,balance=activeAccount.balance;var _children=_toArray(children),title=_children[0],content=_children.slice(1);if(!Array.isArray(children)){title=children;}var RefillInfo=function RefillInfo(){if(tournamentType==="free"&&!totalCountRefill){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"infinity"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfinityIcon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"count"},"(",usedCountRefill,")"));}else if(tournamentType==="free"&&totalCountRefill){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:totalCountRefill>usedCountRefill?"value active":"value"},usedCountRefill,"/",totalCountRefill);}return null;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Type,{type:type},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Balance,{isOpen:isOpen,showDeposit:showDeposit},refillAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RefillContainer,{onClick:onRefillClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_RefreshOutlined___default.a,{color:"inherit",style:{fontSize:16}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"label"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Refill")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RefillInfo,null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],{currency:type==="tournament"?__WEBPACK_IMPORTED_MODULE_7__Icons_Kuchka__["b" /* tournamentCurrency */]:null,Symbol:function Symbol(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Currency,Object.assign({type:type},props));}},balance)),content);}function AccountPicker(props){var _props$type=props.type,type=_props$type===undefined?"demo":_props$type,accountProps=_objectWithoutProperties(props,["type"]);switch(type){case"tournament":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Tournaments__["a" /* TournamentAccount */],accountProps);case"real":var bonus=__WEBPACK_IMPORTED_MODULE_1_idx___default()(props,function(props){return props.profile.bonus;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Account,accountProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Real account"),bonus!=null&&bonus.bonus_sum!==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingVolume,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Trading volume"),": ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,bonus.turnover)));case"demo":default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Account,accountProps,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Demo account"));}}/* harmony default export */ __webpack_exports__["b"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Tournaments_Api__["a" /* ActiveTournament */],null,function(tournament){var actualType="";var refillProps={};if(tournament.value!=null&&props.tradeMode==="tournament"){actualType="tournament";refillProps={totalCountRefill:tournament.value.refill_limit,usedCountRefill:tournament.value.account&&tournament.value.account.refill_count,tournamentType:tournament.value.type};}else actualType=props.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountPicker,Object.assign({},Object.assign({},props,refillProps),{type:actualType}));});});

/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(209);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(1855);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(1856);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(444);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPositionY: 0,
    startPositionY: 0,
    targetPositionY: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    deltaTop: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return Math.max(containerElement.scrollHeight, containerElement.offsetHeight, containerElement.clientHeight);
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    data.containerElement.scrollTop = data.currentPositionY;
  } else {
    window.scrollTo(0, data.currentPositionY);
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(y, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPositionY = currentPositionY(options);
  options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;

  if (options.data.startPositionY === options.data.targetPositionY) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
    }
    return;
  }

  options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);

  options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toY, options) {
  animateTopScroll(toY, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toY, options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(currentPositionY(options) + toY, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(443);

var _utils = __webpack_require__(209);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.pushHash(to);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(286);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (this.props.name !== nextProps.name) {
          this.registerElems(nextProps.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaginationBoxView = __webpack_require__(1860);

var _PaginationBoxView2 = _interopRequireDefault(_PaginationBoxView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PaginationBoxView2.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cup */
/* unused harmony export Timer */
/* unused harmony export CupIcon */
/* unused harmony export PlainCupIcon */
/* harmony export (immutable) */ __webpack_exports__["b"] = TimerIcon;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PaginationArrow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  width: 28px;\n  height: auto;\n\n  @media (max-width: 959px) {\n    width: 22px;\n  }\n"],["\n  width: 28px;\n  height: auto;\n\n  @media (max-width: 959px) {\n    width: 22px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  width: 16px;\n  height: auto;\n  fill: ",";\n"],["\n  display: inline-block;\n  width: 16px;\n  height: auto;\n  fill: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 1em;\n  height: auto;\n  margin-right: 0.5em;\n  font-size: 8px;\n"],["\n  width: 1em;\n  height: auto;\n  margin-right: 0.5em;\n  font-size: 8px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Cup=function Cup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:props.width,height:props.height,viewBox:"0 0 28 35",fill:props.fill?props.fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M716.27 464h3.8v9.3h-1c-.6 0-1.13-.23-1.58-.7l-1.29-1.31c-.46-.4-.68-1.01-.68-1.63v-4.88c0-.47.3-.78.75-.78zm18.95 9.3V464H739c.45 0 .75.31.75.78v4.88c0 .62-.22 1.16-.68 1.63l-1.29 1.31c-.37.47-.98.7-1.59.7zm2.27 18.6c.38 0 .76-.4.76-.8v-1.59c0-.4-.38-.8-.76-.8h-.76v-3.78c0-.86-.68-1.56-1.51-1.56h-2.27v-.66c0-.5-.3-.82-.76-.82s-.76-.33-.76-.82v-2.56a5.31 5.31 0 0 0 3.57-3.66h1.2a3.4 3.4 0 0 0 2.65-1.16l1.3-1.32c.75-.7 1.13-1.7 1.13-2.71v-4.88c0-1.32-.99-2.33-2.27-2.33h-3.8v-1.43c.84 0 1.52-.72 1.52-1.61 0-.88-.68-1.61-1.51-1.61h-15.16c-.83 0-1.51.73-1.51 1.61 0 .89.68 1.61 1.51 1.61v1.43h-3.79c-1.28 0-2.27 1-2.27 2.33v4.88c0 1.08.38 2.01 1.14 2.71l1.29 1.32a3.52 3.52 0 0 0 2.65 1.16h1.2a5.32 5.32 0 0 0 3.57 3.66v2.56c0 .49-.3.82-.76.82-.45 0-.75.33-.75.82v.66h-2.28c-.83 0-1.51.7-1.51 1.56v3.78h-.76c-.38 0-.76.4-.76.8v1.6c0 .4.38.79.76.79z",transform:"translate(-714 -457)"}));};var Timer=function Timer(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:props.width,height:props.height,viewBox:"0 0 27 33",fill:props.fill?props.fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M258.33 765.53a8.22 8.22 0 0 0-8.22-8.13h-.06v8.13zm-8.22-9.88c5.5 0 9.97 4.47 9.97 9.95a9.97 9.97 0 0 1-19.93 0 9.97 9.97 0 0 1 9.96-9.95zm-13.1 9.95a13.12 13.12 0 0 0 26.22 0c0-3.7-1.55-7.05-4.04-9.44l1.44-2.02a.81.81 0 0 0-.2-1.14l-2.16-1.53a.82.82 0 0 0-1.14.2l-1.47 2.07a12.86 12.86 0 0 0-3.48-1.06v-.85c0-.53.45-.98.99-.98h.54a1 1 0 0 0 .98-.98v-2.99a.99.99 0 0 0-.98-.98h-7.19a.99.99 0 0 0-.99.98v3a1 1 0 0 0 .99.97h.54c.54 0 .99.45.99.98v.85c-1.32.2-2.56.6-3.71 1.17l-1.46-2.05a.82.82 0 0 0-1.14-.2l-2.16 1.53a.8.8 0 0 0-.2 1.14l1.47 2.07a13.04 13.04 0 0 0-3.85 9.26z",transform:"translate(-237 -746)"}));};var CupSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg.attrs({style:function style(_ref){var width=_ref.width,height=_ref.height;return{width:width,height:height};}})(_templateObject);function CupIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CupSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28.008 34.232"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-46.545 0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9792a1",d:"M135.035,385.556A1.561,1.561,0,0,0,133.479,384h-15.56a1.561,1.561,0,0,0-1.556,1.556v3.89h18.672Z",transform:"translate(-65.15 -358.327)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7c7688",d:"M114.1,465.455a.837.837,0,0,1,.778.778v1.556a.837.837,0,0,1-.778.778H93.869a.837.837,0,0,1-.778-.778v-1.556a.837.837,0,0,1,.778-.778Z",transform:"translate(-43.434 -434.336)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M184.66,314.036a.735.735,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v2.567a.735.735,0,0,1-.778.778.735.735,0,0,0-.778.778v.778h10.892v-.778A.735.735,0,0,0,184.66,314.036Z",transform:"translate(-119.443 -289.919)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#787382",d:"M319.627,389.446v-3.89A1.561,1.561,0,0,0,318.071,384h-3.89v5.446Z",transform:"translate(-249.742 -358.327)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M193.961,410.384h-6.224a1.561,1.561,0,0,1-1.556-1.556h0a1.561,1.561,0,0,1,1.556-1.556h6.224a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,193.961,410.384Z",transform:"translate(-130.3 -380.043)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(59.771 27.229)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M245.92,410.385h-1.556l1.556-3.112h1.556Z",transform:"translate(-244.364 -407.273)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M282.384,408.828a1.561,1.561,0,0,0-1.556-1.556l-1.556,3.112h1.556A1.56,1.56,0,0,0,282.384,408.828Z",transform:"translate(-276.938 -407.272)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#635d6e",d:"M114.1,465.455h-5.446v.778a1.561,1.561,0,0,1-1.556,1.556H94.648a.735.735,0,0,1-.778-.778v-1.556a.735.735,0,0,0-.778.778v1.556a.78.78,0,0,0,.778.778H114.1a.837.837,0,0,0,.778-.778v-1.556A.837.837,0,0,0,114.1,465.455Z",transform:"translate(-43.435 -434.336)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M186.571,360.727H188.9a.368.368,0,0,1,.389.389h0a.367.367,0,0,1-.389.389h-2.334a.367.367,0,0,1-.389-.389h0A.368.368,0,0,1,186.571,360.727Z",transform:"translate(-130.301 -336.61)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M53.547,82.267H51.758A3.649,3.649,0,0,1,49.035,81.1l-1.323-1.323a3.532,3.532,0,0,1-1.167-2.723v-4.9a2.292,2.292,0,0,1,2.334-2.334h3.89a.778.778,0,0,1,0,1.556h-3.89a.735.735,0,0,0-.778.778v4.9a2.119,2.119,0,0,0,.7,1.634l1.323,1.323a2.239,2.239,0,0,0,1.634.7h1.789a.778.778,0,0,1,0,1.556Z",transform:"translate(0 -65.152)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M351.658,82.268h-1.789a.778.778,0,1,1,0-1.556h1.789a2.119,2.119,0,0,0,1.634-.7l1.323-1.323a2.239,2.239,0,0,0,.7-1.634v-4.9a.735.735,0,0,0-.778-.778h-3.89a.778.778,0,1,1,0-1.556h3.89a2.292,2.292,0,0,1,2.334,2.334v4.9a3.649,3.649,0,0,1-1.167,2.723L354.381,81.1A3.532,3.532,0,0,1,351.658,82.268Z",transform:"translate(-282.318 -65.153)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(66.773 4.667)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M352.2,231.564c-.156,0-.311.078-.545.078h-1.789a.778.778,0,1,0,0,1.556h2.1a5.529,5.529,0,0,0,.233-1.634Z",transform:"translate(-349.091 -220.75)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M360.727,70.6a.735.735,0,0,0,.778.778h1.556V69.818H361.5A.735.735,0,0,0,360.727,70.6Z",transform:"translate(-359.949 -69.818)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffca5d",d:"M149.75,64.439h-4.668a5.413,5.413,0,0,1-5.446-5.446V46.545H155.2V58.993A5.412,5.412,0,0,1,149.75,64.439Z",transform:"translate(-86.867 -43.434)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(56.659 7.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M206.376,314.036a.837.837,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v.778a5.017,5.017,0,0,0,1.556.233h2.334a1.561,1.561,0,0,1,1.556,1.556h0a.78.78,0,0,0,.778.778.735.735,0,0,1,.778.778v.778h2.334v-.778A.78.78,0,0,0,206.376,314.036Z",transform:"translate(-197.818 -296.92)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M454.6,105.116v3.112a.367.367,0,0,1-.389.389h0a.367.367,0,0,1-.389-.389v-3.112a.367.367,0,0,1,.389-.389h0A.368.368,0,0,1,454.6,105.116Z",transform:"translate(-436.703 -104.727)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(51.213 -0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M139.636,46.545v.778h10.892a1.561,1.561,0,0,1,1.556,1.556V58.993c0,3.034-1.634,5.446-4.668,5.446h2.334a5.413,5.413,0,0,0,5.446-5.446V46.545Z",transform:"translate(-138.08 -43.433)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M133.479,3.111h-15.56a1.561,1.561,0,0,1-1.556-1.556h0A1.561,1.561,0,0,1,117.919,0h15.56a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,133.479,3.111Z",transform:"translate(-116.363 0.001)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M133.48,0h0a1.561,1.561,0,0,1-1.556,1.556h-15.56a1.561,1.561,0,0,0,1.556,1.556H133.4a1.665,1.665,0,0,0,1.634-1.323A1.576,1.576,0,0,0,133.48,0Z",transform:"translate(-65.151 -0.001)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(54.325 5.445)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffe27a",d:"M163.687,87.679h0a.735.735,0,0,1-.778-.778V82.233a.735.735,0,0,1,.778-.778h0a.735.735,0,0,1,.778.778V86.9A.735.735,0,0,1,163.687,87.679Z",transform:"translate(-162.909 -81.455)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#ffe27a",cx:"0.778",cy:"0.778",r:"0.778",transform:"translate(0 7.002)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#847f8e",d:"M117.919,384a1.561,1.561,0,0,0-1.556,1.556v3.89h1.556Z",transform:"translate(-65.15 -358.327)"})));}var PlainSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject2,function(_ref2){var theme=_ref2.theme;return theme.foreground;});function PlainCupIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PlainSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 20"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-40.735 5.869)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-2295.042-119.769a.49.49,0,0,1-.445-.467v-.934a.49.49,0,0,1,.445-.467h.444v-2.222a.9.9,0,0,1,.889-.909h1.333v-.39a.439.439,0,0,1,.445-.482.439.439,0,0,0,.445-.482v-1.5a3.119,3.119,0,0,1-2.1-2.144h-.7a2.064,2.064,0,0,1-1.555-.681l-.755-.773a2.087,2.087,0,0,1-.667-1.591v-2.864a1.325,1.325,0,0,1,1.334-1.364h2.222v-.839a.921.921,0,0,1-.889-.944.921.921,0,0,1,.889-.944h8.888a.921.921,0,0,1,.889.944.92.92,0,0,1-.889.944v.839h2.222a1.325,1.325,0,0,1,1.334,1.364v2.864a2.157,2.157,0,0,1-.667,1.591l-.756.773a2,2,0,0,1-1.555.681h-.7a3.117,3.117,0,0,1-2.1,2.144v1.5a.438.438,0,0,0,.444.482.439.439,0,0,1,.445.482v.39h1.333a.9.9,0,0,1,.889.909v2.222h.444a.491.491,0,0,1,.444.467v.934a.491.491,0,0,1-.444.467Zm10.8-10.909a1.2,1.2,0,0,0,.933-.409l.756-.773a1.324,1.324,0,0,0,.4-.954v-2.864a.425.425,0,0,0-.444-.455h-2.222v5.455Zm-12.133-5v2.864a1.251,1.251,0,0,0,.4.954l.755.773a1.266,1.266,0,0,0,.933.409h.578v-5.455h-2.222A.425.425,0,0,0-2296.376-135.678Z",transform:"translate(2338 133.9)"})));}var TimerSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg.attrs({style:function style(_ref3){var width=_ref3.width,height=_ref3.height;return{width:width,height:height};}})(_templateObject3);function TimerIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TimerSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 8 10.002",fill:"#ffffff"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M1238-12043.681a3.976,3.976,0,0,1,1.175-2.825l-.448-.632a.245.245,0,0,1,.059-.345l.659-.468a.25.25,0,0,1,.348.062l.445.625a3.954,3.954,0,0,1,1.131-.358v-.257a.3.3,0,0,0-.3-.3h-.165a.3.3,0,0,1-.3-.3v-.911a.3.3,0,0,1,.3-.3h2.193a.3.3,0,0,1,.3.3v.911a.3.3,0,0,1-.3.3h-.165a.3.3,0,0,0-.3.3v.257a3.924,3.924,0,0,1,1.06.323l.449-.632a.25.25,0,0,1,.348-.06l.659.468a.246.246,0,0,1,.061.345l-.439.618a3.975,3.975,0,0,1,1.231,2.879,4,4,0,0,1-4,3.993A4,4,0,0,1,1238-12043.681Zm.96,0a3.038,3.038,0,0,0,3.04,3.033,3.04,3.04,0,0,0,3.041-3.033,3.043,3.043,0,0,0-3.041-3.035A3.041,3.041,0,0,0,1238.962-12043.681Zm3.02-.021v-2.481h.02a2.508,2.508,0,0,1,2.507,2.481Z",transform:"translate(-1238.001 12049.689)"}));}var PaginationArrow=function PaginationArrow(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 6.167 10",fill:"currentColor",width:"6.167",height:"10"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M87.767,180.867,86.6,179.7l-5,5,5,5,1.167-1.167L83.933,184.7Z",transform:"translate(-81.599 -179.7)"}));};

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Provider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RatingExpander=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](null);/* harmony default export */ __webpack_exports__["b"] = (RatingExpander);var Provider=function(_React$Component){_inherits(Provider,_React$Component);function Provider(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Provider);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Provider.__proto__||Object.getPrototypeOf(Provider)).call.apply(_ref,[this].concat(args))),_this),_this.toggleExpanded=function(){_this.setState(function(state){return{expanded:!state.expanded};});},_this.switchExpanded=function(key){_this.setState(function(state){return{expanded:key};});},_this.state={expanded:false,toggleExpanded:_this.toggleExpanded,switchExpanded:_this.switchExpanded},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Provider,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingExpander.Provider,{value:this.state},this.props.children);}}]);return Provider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StockInTools; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StockMenu__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Animations_Fade__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tour__ = __webpack_require__(44);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: inline-block;\n  vertical-align: top;\n  height: 100%;\n  z-index: 102;\n"],["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  display: inline-block;\n  vertical-align: top;\n  height: 100%;\n  z-index: 102;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 22px;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 22px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n  margin-left: 25px;\n  padding: 0;\n  padding-right: 17px;\n  font-size: 24px;\n  font-weight: 400;\n  color: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  border: none;\n  background-color: ",";\n  cursor: pointer;\n  \n  ",";\n\n  @media (max-width: 959px) {\n    z-index: 1;\n  }\n\n  ",";\n\n  @media (max-width: 959px) {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 4px;\n    padding-right: 21px;\n    font-size: 16px;\n    background-color: ",";\n    border-radius: 4px;\n  }\n\n  @media (max-width: 425px) {\n    font-size: 13px;\n    padding-right: 18px;\n  }\n\n  ",";\n\n  :after {\n    ",";\n\n    ",";\n  }\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 100%;\n  margin-left: 25px;\n  padding: 0;\n  padding-right: 17px;\n  font-size: 24px;\n  font-weight: 400;\n  color: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  border: none;\n  background-color: ",";\n  cursor: pointer;\n  \n  ",";\n\n  @media (max-width: 959px) {\n    z-index: 1;\n  }\n\n  ",";\n\n  @media (max-width: 959px) {\n    margin-left: 0;\n    margin-right: 0;\n    padding: 4px;\n    padding-right: 21px;\n    font-size: 16px;\n    background-color: ",";\n    border-radius: 4px;\n  }\n\n  @media (max-width: 425px) {\n    font-size: 13px;\n    padding-right: 18px;\n  }\n\n  ",";\n\n  :after {\n    ",";\n\n    ",";\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n      z-index: 103;\n    "],["\n      z-index: 103;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      background-color: ",";\n    "],["\n      background-color: ",";\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      margin-left: 0 !important;\n      background-color: initial !important;\n    "],["\n      margin-left: 0 !important;\n      background-color: initial !important;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n        position: absolute;\n        left: -10px;\n        top: -10px;\n        right: -10px;\n        bottom: -10px;\n        border-radius: 6px;\n        ",";\n        content: \"\";\n      "],["\n        position: absolute;\n        left: -10px;\n        top: -10px;\n        right: -10px;\n        bottom: -10px;\n        border-radius: 6px;\n        ",";\n        content: \"\";\n      "]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%) rotate(0deg);\n  transform-origin: 50%;\n  border: 5px solid transparent;\n  border-top-color: #99959d;\n  border-bottom: none;\n  transition: all 0.3s ease;\n\n  ",";\n\n  @media (max-width: 959px) {\n    right: 4px;\n    border-top-color: ",";\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  right: 0;\n  transform: translateY(-50%) rotate(0deg);\n  transform-origin: 50%;\n  border: 5px solid transparent;\n  border-top-color: #99959d;\n  border-bottom: none;\n  transition: all 0.3s ease;\n\n  ",";\n\n  @media (max-width: 959px) {\n    right: 4px;\n    border-top-color: ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n      transform: translateY(-50%) rotate(-180deg);\n      transform-origin: 50%;\n    "],["\n      transform: translateY(-50%) rotate(-180deg);\n      transform-origin: 50%;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  display: inline-block;\n  height: 450px;\n  width: 100%;\n  padding-top: 53px;\n  padding-left: 28px;\n  padding-right: 13px;\n  padding-bottom: 13px;\n  background-color: ",";\n  z-index: 1;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 53px;\n    left: 28px;\n    width: calc(100% - 41px);\n    border-top: 1px solid ",";\n  }\n"],["\n  display: inline-block;\n  height: 450px;\n  width: 100%;\n  padding-top: 53px;\n  padding-left: 28px;\n  padding-right: 13px;\n  padding-bottom: 13px;\n  background-color: ",";\n  z-index: 1;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 53px;\n    left: 28px;\n    width: calc(100% - 41px);\n    border-top: 1px solid ",";\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 7px;\n  margin-right: 4px;\n  padding: 4px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: 700;\n  color: ",";\n  background-color: ",";\n  border-radius: 2px;\n\n  @media (max-width: 959px) {\n    vertical-align: text-top;\n    padding: 2px;\n    font-size: ",";\n  }\n"],["\n  display: inline-block;\n  vertical-align: top;\n  margin-left: 7px;\n  margin-right: 4px;\n  padding: 4px;\n  font-size: 16px;\n  line-height: 1;\n  font-weight: 700;\n  color: ",";\n  background-color: ",";\n  border-radius: 2px;\n\n  @media (max-width: 959px) {\n    vertical-align: text-top;\n    padding: 2px;\n    font-size: ",";\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var StockContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Stock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject3,function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.theme.main;},function(_ref2){var active=_ref2.active;return active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,function(props){return props.theme.popupBackground;});},function(_ref3){var theme=_ref3.theme;return theme.mobileSwitchStockBackground;},function(_ref4){var isTour=_ref4.isTour;return isTour&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);},function(_ref5){var tourBorder=_ref5.tourBorder;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,tourBorder.border);},function(_ref6){var tourBorderAnimation=_ref6.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation(tourBorderAnimation.keyframe);});var StockArrow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);},function(_ref7){var theme=_ref7.theme;return theme.mobileSwitchStockArrow;});var Menu=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(props){return props.theme.popupBackground;},function(props){return props.theme.mainSeparator;});var Otc=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject11,function(props){return props.theme.main;},function(_ref8){var theme=_ref8.theme;return theme.accent;},function(_ref9){var theme=_ref9.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var StockInTools=function StockInTools(props){var original=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isClicked=_useState2[0],click=_useState2[1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tour__["b" /* default */],{step:"showStockSelect",originalRef:original},function(_ref10){var next=_ref10.next,isOriginal=_ref10.isOriginal,isTourActive=_ref10.isTourActive,tour=_ref10.tour;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stock,{tourBorder:!isOriginal&&tour&&tour.borderStyles,tourBorderAnimation:!isOriginal&&tour&&tour.outside&&tour.borderStyles,onClick:function onClick(){setTimeout(next,0);if(isTourActive){click(true);}if(!isClicked){if(typeof props.onClick==="function"){props.onClick();}}},active:props.active,isTour:!isOriginal,ref:isOriginal?original:null},props.value.replace("_OTC","").slice(0,6),props.value.endsWith("_OTC")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Otc,null,"OTC"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockArrow,{active:props.active}));});};var SwitchStock=function(_Component){_inherits(SwitchStock,_Component);function SwitchStock(){var _ref11;var _temp,_this,_ret;_classCallCheck(this,SwitchStock);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref11=SwitchStock.__proto__||Object.getPrototypeOf(SwitchStock)).call.apply(_ref11,[this].concat(args))),_this),_this.state={isActive:false},_this.toggle=function(){_this.setState({isActive:!_this.state.isActive});},_this.hide=function(e){if(e&&typeof e.preventDefault==="function"&&typeof e.stopPropagation==="function"){e.preventDefault();e.stopPropagation();}_this.setState({isActive:false});},_this.handleStockChange=function(stock){var tabIndex=_this.props.tabs.indexOf(stock);_this.hide();if(tabIndex===-1){_this.props.onChange(stock);}else{_this.props.onNextActiveTab(tabIndex);}},_this.original=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(null),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SwitchStock,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockInTools,{onClick:this.toggle,active:this.state.isActive,value:this.props.value}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Animations_Fade__["a" /* default */],{"in":this.state.isActive},function(_ref12){var style=_ref12.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tour__["b" /* default */],{step:["stockSelect","allStocksSelect"],disabled:true,originalRef:_this2.original},function(_ref13){var next=_ref13.next,isOriginal=_ref13.isOriginal,isTourActive=_ref13.isTourActive,step=_ref13.step;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Menu,{ref:isOriginal?_this2.original:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StockMenu__["a" /* default */],{isTour:!isOriginal,defaultCategory:isTourActive&&step==="stockSelect"?"popular":null,disabledOutside:isOriginal&&isTourActive,onStockSelect:function onStockSelect(a){step!=="stockSelect"&&next(a);_this2.handleStockChange(a);},onClose:isOriginal?_this2.hide:null}));}));}));}}]);return SwitchStock;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["b"] = (SwitchStock);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var BonusTimer=function BonusTimer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 120 124.002",width:props.width||"120px",className:props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fillOpacity:"0.1",d:"M117.638,53.153a10.033,10.033,0,0,1-1.766-8.88,11.107,11.107,0,0,0-5.242-12.656,10.03,10.03,0,0,1-5.03-7.528A11.106,11.106,0,0,0,95.914,14.4a10.031,10.031,0,0,1-7.528-5.03A11.106,11.106,0,0,0,75.73,4.131a10.031,10.031,0,0,1-8.88-1.766,11.106,11.106,0,0,0-13.7,0,10.031,10.031,0,0,1-8.88,1.766A11.107,11.107,0,0,0,31.617,9.373a10.03,10.03,0,0,1-7.528,5.03A11.107,11.107,0,0,0,14.4,24.089a10.031,10.031,0,0,1-5.03,7.528A11.106,11.106,0,0,0,4.131,44.273a10.032,10.032,0,0,1-1.766,8.88,11.107,11.107,0,0,0,0,13.7,10.032,10.032,0,0,1,1.766,8.88A11.107,11.107,0,0,0,9.373,88.387a10.03,10.03,0,0,1,5.03,7.528,11.106,11.106,0,0,0,9.686,9.686,10.032,10.032,0,0,1,7.528,5.03,11.106,11.106,0,0,0,12.656,5.242,10.031,10.031,0,0,1,8.88,1.766,11.106,11.106,0,0,0,13.7,0,10.031,10.031,0,0,1,8.88-1.766,11.106,11.106,0,0,0,12.656-5.242,10.03,10.03,0,0,1,7.528-5.03,11.106,11.106,0,0,0,9.686-9.686,10.031,10.031,0,0,1,5.03-7.528,11.106,11.106,0,0,0,5.242-12.656,10.032,10.032,0,0,1,1.766-8.88A11.107,11.107,0,0,0,117.638,53.153Z",transform:"translate(-0.001 3.999)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"currentColor",d:"M117.638,53.153a10.033,10.033,0,0,1-1.766-8.88,11.107,11.107,0,0,0-5.242-12.656,10.03,10.03,0,0,1-5.03-7.528A11.106,11.106,0,0,0,95.914,14.4a10.031,10.031,0,0,1-7.528-5.03A11.106,11.106,0,0,0,75.73,4.131a10.031,10.031,0,0,1-8.88-1.766,11.106,11.106,0,0,0-13.7,0,10.031,10.031,0,0,1-8.88,1.766A11.107,11.107,0,0,0,31.617,9.373a10.03,10.03,0,0,1-7.528,5.03A11.107,11.107,0,0,0,14.4,24.089a10.031,10.031,0,0,1-5.03,7.528A11.106,11.106,0,0,0,4.131,44.273a10.032,10.032,0,0,1-1.766,8.88,11.107,11.107,0,0,0,0,13.7,10.032,10.032,0,0,1,1.766,8.88A11.107,11.107,0,0,0,9.373,88.387a10.03,10.03,0,0,1,5.03,7.528,11.106,11.106,0,0,0,9.686,9.686,10.032,10.032,0,0,1,7.528,5.03,11.106,11.106,0,0,0,12.656,5.242,10.031,10.031,0,0,1,8.88,1.766,11.106,11.106,0,0,0,13.7,0,10.031,10.031,0,0,1,8.88-1.766,11.106,11.106,0,0,0,12.656-5.242,10.03,10.03,0,0,1,7.528-5.03,11.106,11.106,0,0,0,9.686-9.686,10.031,10.031,0,0,1,5.03-7.528,11.106,11.106,0,0,0,5.242-12.656,10.032,10.032,0,0,1,1.766-8.88A11.107,11.107,0,0,0,117.638,53.153Z",transform:"translate(-0.001 -0.001)"}));};/* harmony default export */ __webpack_exports__["a"] = (BonusTimer);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable__ = __webpack_require__(663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_loadable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_loadable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Spinners_BrandSpinner_index__ = __webpack_require__(98);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_loadable___default()({loader:function loader(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 719));},delay:2000,LoadingComponent:__WEBPACK_IMPORTED_MODULE_1__Spinners_BrandSpinner_index__["a" /* default */]}));

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Measure__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SectionData__ = __webpack_require__(1872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Scales__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NextGenMobileVisuals__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NextGenDesktopVisuals__ = __webpack_require__(1988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OscillatorVisuals__ = __webpack_require__(290);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function makeHandler(component,updateState){return function(event){updateState(event,function(fn){return component.setState(fn);});};}var Chart=function(_React$Component){_inherits(Chart,_React$Component);function Chart(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Chart);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Chart.__proto__||Object.getPrototypeOf(Chart)).call.apply(_ref,[this].concat(args))),_this),_this.state=__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["b" /* getInitialState */](_this.props),_this.eventHandlers=_this.props.interactive===false?{}:{onDragOver:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["f" /* onDrop */]),onDrop:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["f" /* onDrop */]),onWheel:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["o" /* onWheel */]),onMouseDown:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["g" /* onMouseDown */]),onMouseUp:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["k" /* onMouseUp */]),onMouseMove:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["j" /* onMouseMove */]),onMouseEnter:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["h" /* onMouseEnter */]),onMouseLeave:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["i" /* onMouseLeave */]),onTouchStart:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["n" /* onTouchStart */]),onTouchMove:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["m" /* onTouchMove */]),onTouchEnd:makeHandler(_this,__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["l" /* onTouchEnd */])},_this.containerNode=null,_this.attachEventListeners=function(){var node=_this.containerNode;var handlers=_this.eventHandlers;// Третий аргумент — `capture`. Нужен чтобы отобрать
// событие из лап нативного зума в сафари.
node.addEventListener("dragover",handlers.onDragOver,false);node.addEventListener("drop",handlers.onDrop,false);node.addEventListener("wheel",handlers.onWheel,false);node.addEventListener("mousedown",handlers.onMouseDown,false);node.addEventListener("mouseup",handlers.onMouseUp,false);node.addEventListener("mousemove",handlers.onMouseMove,false);node.addEventListener("mouseenter",handlers.onMouseEnter,false);node.addEventListener("mouseleave",handlers.onMouseLeave,false);node.addEventListener("touchstart",handlers.onTouchStart,true);node.addEventListener("touchmove",handlers.onTouchMove,true);node.addEventListener("touchend",handlers.onTouchEnd,true);},_this.detachEventListeners=function(){var node=_this.containerNode;var handlers=_this.eventHandlers;if(node==null){return;}// Третий аргумент — `capture`. Нужен чтобы отобрать
// событие из лап нативного зума в сафари.
node.removeEventListener("dragover",handlers.onDragOver,false);node.removeEventListener("drop",handlers.onDrop,false);node.removeEventListener("wheel",handlers.onWheel,false);node.removeEventListener("mousedown",handlers.onMouseDown,false);node.removeEventListener("mouseup",handlers.onMouseUp,false);node.removeEventListener("mousemove",handlers.onMouseMove,false);node.removeEventListener("mouseenter",handlers.onMouseEnter,false);node.removeEventListener("mouseleave",handlers.onMouseLeave,false);node.removeEventListener("touchstart",handlers.onTouchStart,true);node.removeEventListener("touchmove",handlers.onTouchMove,true);node.removeEventListener("touchend",handlers.onTouchEnd,true);},_this.handleMeasure=function(measures){_this.setState(measures);},_this.preserveTimeSpan=function(){_this.props.dispatch({type:"UPDATE_SETTINGS",payload:{timeSpan:_this.state.timeSpan}});},_this.handleTimeSpanChange=function(fn){_this.setState(function(){return{isEngaged:true,lastEngagementTime:Date.now()};});_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["p" /* resetCursor */]);_this.setState(fn);_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["d" /* normalizeTimeSpan */]);_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["q" /* saveSnapshot */]);},_this.handleBackToReality=function(){_this.setState(function(state,props){var present=props.points[props.points.length-1];return{cursor:{date:present.date,ratio:0.68,animate:true,follow:true}};});_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["a" /* clearSnapshot */]);},_this.handleData=function(payload){__WEBPACK_IMPORTED_MODULE_1_react_dom__["unstable_batchedUpdates"](function(){var key=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["j" /* getSectionKey */](payload.section);var _Helpers$getSectionBo=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["i" /* getSectionBoundaries */](payload.section),_Helpers$getSectionBo2=_slicedToArray(_Helpers$getSectionBo,2),start=_Helpers$getSectionBo2[0],end=_Helpers$getSectionBo2[1];_this.setState(function(state,props){var relevantCheckpoints=state.checkpoints.filter(function(checkpoint){return checkpoint.source[0]<=end&&checkpoint.source[1]>=start;});var data=payload.data;if(relevantCheckpoints.length>0&&Array.isArray(data)){data=data.filter(function(point){return relevantCheckpoints.every(function(checkpoint){return!(checkpoint.source[0]<point.epoch*1000&&checkpoint.source[1]>point.epoch*1000);});});}return{cache:Object.assign({},state.cache,_defineProperty({},key,data))};});_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["s" /* updateIsLoading */]);_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["r" /* updateExtent */]);});},_this.handleIntervalChange=function(interval){__WEBPACK_IMPORTED_MODULE_1_react_dom__["unstable_batchedUpdates"](function(){_this.props.dispatch({type:"UPDATE_SETTINGS",payload:{interval:interval/1000}});_this.setState({interval:interval/1000});_this.setState({animateTimeSpan:false});_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["d" /* normalizeTimeSpan */]);_this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["q" /* saveSnapshot */]);});},_this.handleMouseUp=function(){_this.setState({isActive:false});},_this.engagementTimer=null,_this.scrollingTimer=null,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Chart,[{key:"UNSAFE_componentWillReceiveProps",value:function UNSAFE_componentWillReceiveProps(nextProps){if(nextProps.stock!==this.props.stock&&nextProps.points.length>1){this.setState(function(state,props){return __WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["s" /* updateIsLoading */](state,nextProps);});}if(nextProps.points.length>1&&nextProps.points[nextProps.points.length-1]!==this.props.points[this.props.points.length-1]){this.setState(function(state,props){return __WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["r" /* updateExtent */](state,nextProps);});var present=nextProps.points[nextProps.points.length-1];this.setState(function(state,props){if(state.cursor.follow===true){var interval=props.settings.chartType==="line"?1:state.interval;if(state.lastMovementTime+interval*1000<=present.date){return{lastMovementTime:present.date,cursor:Object.assign({},state.cursor,{animate:true,date:state.cursor.date+(present.date-state.lastMovementTime)})};}else{return null;}}else{return null;}});}if(nextProps.settings.chartType!==this.props.settings.chartType&&nextProps.points.length>1){this.setState({animateTimeSpan:false});this.setState(function(state,props){return __WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["d" /* normalizeTimeSpan */](state,nextProps);});}}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;document.addEventListener("mouseup",this.handleMouseUp);// По идее этого тут быть не должно, график должен был инициализироваться
// с правильными экстентами. Но этого не делал.
this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["r" /* updateExtent */]);var twoWeekTime=60*60*24*14;var till=Math.ceil(this.props.points[this.props.points.length-1].date/1000/twoWeekTime)*twoWeekTime+twoWeekTime;var from=till-twoWeekTime*13;// полгода тому назад
Object(__WEBPACK_IMPORTED_MODULE_3__common_fetch__["d" /* get */])("/api/stock-locked-schedule?asset="+this.props.stock.stock+"&from="+from+"&till="+till).then(function(payload){var ranges=payload.data.map(function(weekend){return[1000*weekend.from,1000*weekend.till];});var checkpoints=[];for(var i=0;i<ranges.length;i++){var range=ranges[i];if(checkpoints.length===0){checkpoints.push({type:"negative",source:range,value:range[0],offset:range[0]});checkpoints.push({type:"positive",source:range,value:range[1],offset:range[0]});}else{var lastCheckpoint=checkpoints[checkpoints.length-1];var offset=lastCheckpoint.offset+(range[0]-lastCheckpoint.source[1]);checkpoints.push({type:"negative",source:range,value:range[0],offset:offset});checkpoints.push({type:"positive",source:range,value:range[1],offset:offset});}}_this2.setState({checkpoints:checkpoints});});}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.removeEventListener("mouseup",this.handleMouseUp);if(this.engagementTimer!=null){clearTimeout(this.engagementTimer);}if(this.scrollingTimer!=null){clearTimeout(this.scrollingTimer);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var _this3=this;if(this.state.isEngaged===true&&this.state.lastEngagementTime!==prevState.lastEngagementTime){if(this.engagementTimer!=null){clearTimeout(this.engagementTimer);}this.engagementTimer=setTimeout(function(){_this3.setState(function(){return{isEngaged:false};});},5000);}if(this.state.lastScrollTime!==prevState.lastScrollTime){if(this.scrollingTimer!=null){clearTimeout(this.scrollingTimer);}this.scrollingTimer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_1_react_dom__["unstable_batchedUpdates"](function(){_this3.setState(function(state){return{isScrolled:false};});_this3.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["e" /* normalizeViewport */]);_this3.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["q" /* saveSnapshot */]);});},100);}if(this.props.settings.interval!==prevProps.settings.interval&&this.props.points.length>1){this.setState(function(state,props){return{interval:__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["b" /* getInitialState */](props).interval};});this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["d" /* normalizeTimeSpan */]);this.setState(__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["q" /* saveSnapshot */]);}}},{key:"render",value:function render(){var _this4=this;if(this.props.points.length<2){return null;}var indicators=this.props.settings.indicators.filter(function(indicator){return indicator.enabled!==false;});var oscillators=[];if(indicators&&indicators.length){oscillators=indicators.filter(function(indicator){return indicator.isOscillator===true&&__WEBPACK_IMPORTED_MODULE_11__OscillatorVisuals__["a" /* availableOscillators */].indexOf(indicator.type)>-1;});}var scaleModifier=Object(__WEBPACK_IMPORTED_MODULE_11__OscillatorVisuals__["e" /* getScaleModifier */])(this.props.settings.indicators);var present=this.props.points[this.props.points.length-1];var payloadProps=__WEBPACK_IMPORTED_MODULE_8__ChartEventHandlers__["c" /* makePayloadProps */](this.state,this.props);var relevantSectionProps=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["f" /* getCommonSectionProps */](payloadProps);var relevantSections=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["e" /* generateSections */](relevantSectionProps,payloadProps);var displayedSections=this.state.isLoading&&this.state.lastLoadedSections!=null?__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["e" /* generateSections */](Object.assign({},this.state.lastLoadedSections,{quantity:Math.ceil(this.state.timeSpan/this.state.lastLoadedSections.length)}),payloadProps):relevantSections;var _Helpers$getPoints=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["h" /* getPoints */](displayedSections,this.state.cache,payloadProps,this.props.deals),points=_Helpers$getPoints.points,emptySections=_Helpers$getPoints.emptySections,isDarkArea=_Helpers$getPoints.isDarkArea,rawPoints=_Helpers$getPoints.rawPoints;// Второй круг для тёмных областей графика
if(isDarkArea){relevantSections=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["e" /* generateSections */](Object.assign({},relevantSectionProps,{interval:5000}),payloadProps);var fallback=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["h" /* getPoints */](relevantSections,this.state.cache,payloadProps,this.props.deals);points=fallback.points;emptySections=fallback.emptySections;isDarkArea=fallback.isDarkArea;}var payload={stock:this.props.stock.stock,data:points,emptySections:emptySections,isLoading:this.state.isLoading,interval:relevantSectionProps.interval};var allowSideEffects=!__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["m" /* isShortHistoryStock */](this.props.stock)||this.props.allowShortHistorySections;var sideEffects=!allowSideEffects||this.state.width===0?null:relevantSections.filter(function(section){return __WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["k" /* getSectionType */](section,payloadProps)!=="weekend"&&__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["i" /* getSectionBoundaries */](section)[0]<=_this4.props.points[0].date;}).map(function(section){var key=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["j" /* getSectionKey */](section);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__SectionData__["a" /* default */],{key:key,type:__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["k" /* getSectionType */](section,payloadProps),cache:_this4.state.cache[key],section:section,onData:_this4.handleData,profile:_this4.props.profile,fetchSection:_this4.props.fetchSection||__WEBPACK_IMPORTED_MODULE_4__SectionData__["b" /* fetchSection */]});});var Scales=__WEBPACK_IMPORTED_MODULE_5__Scales__["a" /* AnimatedScales */];if(this.props.animated!==true){Scales=__WEBPACK_IMPORTED_MODULE_5__Scales__["b" /* NotAnimatedScales */];}else if(this.state.extent[0]===0&&this.state.extent[1]===0){Scales=__WEBPACK_IMPORTED_MODULE_5__Scales__["b" /* NotAnimatedScales */];}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,sideEffects,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Scales,{scaleModifier:scaleModifier,cursor:this.state.cursor,present:present,timeSpan:this.state.timeSpan,animateTimeSpan:this.state.animateTimeSpan,width:this.state.width,extent:this.state.extent,height:this.state.height,onRest:this.preserveTimeSpan,checkpoints:this.state.checkpoints},function(scales){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Measure__["a" /* default */],{onMeasure:_this4.handleMeasure},function(measure){var Visuals=_this4.props.visuals;switch(_this4.props.visuals){case"mobile":Visuals=__WEBPACK_IMPORTED_MODULE_9__NextGenMobileVisuals__["a" /* default */];break;case"desktop":Visuals=__WEBPACK_IMPORTED_MODULE_10__NextGenDesktopVisuals__["a" /* default */];break;default:break;}var points=__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["d" /* generateRenderablePoints */](payload.data,scales.scaleX,scales.scaleY,payload.stock,payload.interval,scales.present,_this4.props.deals);var candles=_this4.props.settings.chartType==="line"?[]:__WEBPACK_IMPORTED_MODULE_7__NextGenChartMath__["b" /* generateCandles */](payload.data,scales.scaleX,scales.scaleY,payload.stock,payload.interval);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Visuals,{time:_this4.props.time,lastPoint:[scales.scaleX(scales.present.date),scales.scaleY(scales.present.value),scales.present],rawData:rawPoints||payload.data,points:points,candles:candles,emptySections:payload.emptySections,sections:relevantSections,realtimeThreshold:_this4.props.points[0].date,scaleX:scales.scaleX,scaleY:scales.scaleY,loading:_this4.state.isLoading,width:_this4.state.width,height:_this4.state.height,mouseX:_this4.state.mouseX,mouseY:_this4.state.mouseY,isHovered:_this4.state.isHovered,isActive:_this4.state.isActive,deals:_this4.props.deals,settings:_this4.props.settings,intent:_this4.props.intent,stats:_this4.props.stats,timeSpan:_this4.state.timeSpan,onBackToReality:_this4.handleBackToReality,onTimeSpanChange:_this4.handleTimeSpanChange,onIntervalChange:_this4.handleIntervalChange,interval:payload.interval,containerProps:{ref:function ref(node){measure.innerRef(node);if(_this4.props.interactive!==false){if(node!=null){_this4.containerNode=node;_this4.attachEventListeners();}else{_this4.detachEventListeners();_this4.containerNode=node;}}}},stock:_this4.props.stock,isEngaged:_this4.state.isEngaged,oscillators:oscillators,dispatch:_this4.props.dispatch,cursor:_this4.state.cursor,checkpoints:_this4.state.checkpoints,onEditIndicator:_this4.props.onEditIndicator,tradeMode:_this4.props.tradeMode,graphicalMode:_this4.props.graphicalMode,rectTop:_this4.state.rectTop,outerCountainerRef:_this4.props.forwardedRef,interactive:_this4.props.interactive!==false,refundClickHandler:_this4.props.refundClickHandler,refundFetching:_this4.props.refundFetching});});}));}}]);return Chart;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function ResillientToLackOfCacheChart(props){if(props.points.length<2){return null;}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Chart,props);}}/* harmony default export */ __webpack_exports__["default"] = (ResillientToLackOfCacheChart);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getScaleX;
/* harmony export (immutable) */ __webpack_exports__["d"] = getScaleY;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnimatedScales; });
/* harmony export (immutable) */ __webpack_exports__["b"] = NotAnimatedScales;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__discontinuousScale__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_memoize__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_d3_time__ = __webpack_require__(212);
// d3 ticks bullshit
// https://github.com/d3/d3-scale/blob/master/src/time.js
var durationSecond=1000,durationMinute=durationSecond*60,durationHour=durationMinute*60,durationDay=durationHour*24,durationWeek=durationDay*7,durationMonth=durationDay*30,durationYear=durationDay*365;// prettier-ignore
var tickIntervals=[[__WEBPACK_IMPORTED_MODULE_7_d3_time__["g" /* timeSecond */],1,durationSecond],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["g" /* timeSecond */],5,5*durationSecond],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["g" /* timeSecond */],15,15*durationSecond],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["g" /* timeSecond */],30,30*durationSecond],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["d" /* timeMinute */],1,durationMinute],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["d" /* timeMinute */],5,5*durationMinute],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["d" /* timeMinute */],15,15*durationMinute],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["d" /* timeMinute */],30,30*durationMinute],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["b" /* timeHour */],1,durationHour],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["b" /* timeHour */],3,3*durationHour],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["b" /* timeHour */],6,6*durationHour],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["b" /* timeHour */],12,12*durationHour],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["a" /* timeDay */],1,durationDay],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["a" /* timeDay */],2,2*durationDay],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["j" /* timeWeek */],1,durationWeek],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["f" /* timeMonth */],1,durationMonth],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["f" /* timeMonth */],3,3*durationMonth],[__WEBPACK_IMPORTED_MODULE_7_d3_time__["k" /* timeYear */],1,durationYear]];function tickInterval(interval,start,stop,step){if(interval==null)interval=10;// If a desired tick count is specified, pick a reasonable tick interval
// based on the extent of the domain and a rough estimate of tick size.
// Otherwise, assume interval is already a time interval and use it.
if(typeof interval==="number"){var target=Math.abs(stop-start)/interval,i=Object(__WEBPACK_IMPORTED_MODULE_6_d3_array__["c" /* bisector */])(function(i){return i[2];}).right(tickIntervals,target);if(i===tickIntervals.length){step=Object(__WEBPACK_IMPORTED_MODULE_6_d3_array__["g" /* tickStep */])(start/durationYear,stop/durationYear,interval);interval=__WEBPACK_IMPORTED_MODULE_7_d3_time__["k" /* timeYear */];}else if(i){i=tickIntervals[target/tickIntervals[i-1][2]<tickIntervals[i][2]/target?i-1:i];step=i[1];interval=i[0];}else{step=Math.max(Object(__WEBPACK_IMPORTED_MODULE_6_d3_array__["g" /* tickStep */])(start,stop,interval),1);interval=__WEBPACK_IMPORTED_MODULE_7_d3_time__["c" /* timeMillisecond */];}}return step==null?interval:interval.every(step);}function ticks(domain,interval,step){var d=domain,t0=d[0],t1=d[d.length-1],r=t1<t0,t;// eslint-disable-next-line
if(r)t=t0,t0=t1,t1=t;t=tickInterval(interval,t0,t1,step);t=t?t.range(t0,t1+1):[];// inclusive stop
return r?t.reverse():t;}// на этом паста заканчивается
var memoizedDiscontinuousScale=__WEBPACK_IMPORTED_MODULE_4_lodash_memoize___default()(function(checkpoints){return Object(__WEBPACK_IMPORTED_MODULE_3__discontinuousScale__["a" /* default */])(checkpoints);});function getScaleX(props){var dateToPlane=memoizedDiscontinuousScale(props.checkpoints);var planeToScreen=Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])().domain([dateToPlane(props.cursor.date)-props.timeSpan*props.cursor.ratio,dateToPlane(props.cursor.date)+props.timeSpan*(1-props.cursor.ratio)]).range([0,props.width]);var scaleX=function scaleX(date){return planeToScreen(dateToPlane(date));};scaleX.invert=function(point){return dateToPlane.invert(planeToScreen.invert(point));};scaleX.ticks=ticks.bind(null,[dateToPlane.invert(dateToPlane(props.cursor.date)-props.timeSpan*props.cursor.ratio),dateToPlane.invert(dateToPlane(props.cursor.date)+props.timeSpan*(1-props.cursor.ratio))]);return scaleX;}function getScaleY(props){return Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["a" /* scaleLinear */])().domain(props.extent).range([(props.modifier||1)*props.height-50,50]);}var highPrecisionSpring={stiffness:170,damping:26,precision:0.00001};var lowPrecisionSpring={stiffness:170,damping:26,precision:1};var AnimatedScales=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](function(props){var style={cursor_ratio:props.cursor.animate?Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.cursor.ratio,highPrecisionSpring):props.cursor.ratio,cursor_date:props.cursor.animate?Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.cursor.date,lowPrecisionSpring):props.cursor.date,presentDate:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.present.date,lowPrecisionSpring),presentValue:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.present.value,highPrecisionSpring),timeSpan:props.animateTimeSpan?Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.timeSpan,lowPrecisionSpring):props.timeSpan,extent_0:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.extent[0],highPrecisionSpring),extent_1:Object(__WEBPACK_IMPORTED_MODULE_1_react_motion__["spring"])(props.extent[1],highPrecisionSpring)};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_motion__["Motion"],{style:style,onRest:props.onRest},function(interpolated){var present={date:interpolated.presentDate,value:interpolated.presentValue,stock:props.present.stock};return props.children({scaleX:getScaleX({cursor:{ratio:interpolated.cursor_ratio,date:interpolated.cursor_date,follow:props.cursor.follow,animate:props.cursor.animate},timeSpan:interpolated.timeSpan,width:props.width,checkpoints:props.checkpoints}),scaleY:getScaleY({extent:[interpolated.extent_0,interpolated.extent_1],modifier:props.scaleModifier,height:props.height}),present:present});});});function NotAnimatedScales(props){return props.children({scaleX:getScaleX(props),scaleY:getScaleY(props),present:props.present});}

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export bisectRight */
/* unused harmony export bisectLeft */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisector__ = __webpack_require__(722);



var ascendingBisect = Object(__WEBPACK_IMPORTED_MODULE_1__bisector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]);
var bisectRight = ascendingBisect.right;
var bisectLeft = ascendingBisect.left;
/* harmony default export */ __webpack_exports__["a"] = (bisectRight);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(168);


/* harmony default export */ __webpack_exports__["a"] = (function(compare) {
  if (compare.length === 1) compare = ascendingComparator(compare);
  return {
    left: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) < 0) lo = mid + 1;
        else hi = mid;
      }
      return lo;
    },
    right: function(a, x, lo, hi) {
      if (lo == null) lo = 0;
      if (hi == null) hi = a.length;
      while (lo < hi) {
        var mid = lo + hi >>> 1;
        if (compare(a[mid], x) > 0) hi = mid;
        else lo = mid + 1;
      }
      return lo;
    }
  };
});

function ascendingComparator(f) {
  return function(d, x) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(f(d), x);
  };
}


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = pair;
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, f) {
  if (f == null) f = pair;
  var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
  while (i < n) pairs[i] = f(p, p = array[++i]);
  return pairs;
});

function pair(a, b) {
  return [a, b];
}


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__variance__ = __webpack_require__(725);


/* harmony default export */ __webpack_exports__["a"] = (function(array, f) {
  var v = Object(__WEBPACK_IMPORTED_MODULE_0__variance__["a" /* default */])(array, f);
  return v ? Math.sqrt(v) : v;
});


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(210);


/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      m = 0,
      i = -1,
      mean = 0,
      value,
      delta,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) {
        delta = value - mean;
        mean += delta / ++m;
        sum += delta * (value - mean);
      }
    }
  }

  if (m > 1) return sum / (m - 1);
});


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null) {
            if (min > value) min = value;
            if (max < value) max = value;
          }
        }
      }
    }
  }

  return [min, max];
});


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return slice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return map; });
var array = Array.prototype;

var slice = array.slice;
var map = array.map;


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, step) {
  start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;

  var i = -1,
      n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
      range = new Array(n);

  while (++i < n) {
    range[i] = start + i * step;
  }

  return range;
});


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = tickIncrement;
/* harmony export (immutable) */ __webpack_exports__["c"] = tickStep;
var e10 = Math.sqrt(50),
    e5 = Math.sqrt(10),
    e2 = Math.sqrt(2);

/* harmony default export */ __webpack_exports__["a"] = (function(start, stop, count) {
  var reverse,
      i = -1,
      n,
      ticks,
      step;

  stop = +stop, start = +start, count = +count;
  if (start === stop && count > 0) return [start];
  if (reverse = stop < start) n = start, start = stop, stop = n;
  if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];

  if (step > 0) {
    start = Math.ceil(start / step);
    stop = Math.floor(stop / step);
    ticks = new Array(n = Math.ceil(stop - start + 1));
    while (++i < n) ticks[i] = (start + i) * step;
  } else {
    start = Math.floor(start * step);
    stop = Math.ceil(stop * step);
    ticks = new Array(n = Math.ceil(start - stop + 1));
    while (++i < n) ticks[i] = (start - i) / step;
  }

  if (reverse) ticks.reverse();

  return ticks;
});

function tickIncrement(start, stop, count) {
  var step = (stop - start) / Math.max(0, count),
      power = Math.floor(Math.log(step) / Math.LN10),
      error = step / Math.pow(10, power);
  return power >= 0
      ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power)
      : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}

function tickStep(start, stop, count) {
  var step0 = Math.abs(stop - start) / Math.max(0, count),
      step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
      error = step0 / step1;
  if (error >= e10) step1 *= 10;
  else if (error >= e5) step1 *= 5;
  else if (error >= e2) step1 *= 2;
  return stop < start ? -step1 : step1;
}


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
});


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      min;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        min = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && min > value) {
            min = value;
          }
        }
      }
    }
  }

  return min;
});


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__min__ = __webpack_require__(731);


/* harmony default export */ __webpack_exports__["a"] = (function(matrix) {
  if (!(n = matrix.length)) return [];
  for (var i = -1, m = Object(__WEBPACK_IMPORTED_MODULE_0__min__["a" /* default */])(matrix, length), transpose = new Array(m); ++i < m;) {
    for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
      row[j] = matrix[j][i];
    }
  }
  return transpose;
});

function length(d) {
  return d.length;
}


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export implicit */
/* harmony export (immutable) */ __webpack_exports__["a"] = ordinal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_collection__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(143);



var implicit = {name: "implicit"};

function ordinal(range) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])(),
      domain = [],
      unknown = implicit;

  range = range == null ? [] : __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(range);

  function scale(d) {
    var key = d + "", i = index.get(key);
    if (!i) {
      if (unknown !== implicit) return unknown;
      index.set(key, i = domain.push(d));
    }
    return range[(i - 1) % range.length];
  }

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [], index = Object(__WEBPACK_IMPORTED_MODULE_0_d3_collection__["a" /* map */])();
    var i = -1, n = _.length, d, key;
    while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
    return scale;
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), scale) : range.slice();
  };

  scale.unknown = function(_) {
    return arguments.length ? (unknown = _, scale) : unknown;
  };

  scale.copy = function() {
    return ordinal()
        .domain(domain)
        .range(range)
        .unknown(unknown);
  };

  return scale;
}


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deg2rad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rad2deg; });
var deg2rad = Math.PI / 180;
var rad2deg = 180 / Math.PI;


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return rgbBasis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rgbBasisClosed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basisClosed__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__color__ = __webpack_require__(169);





/* harmony default export */ __webpack_exports__["a"] = ((function rgbGamma(y) {
  var color = Object(__WEBPACK_IMPORTED_MODULE_3__color__["b" /* gamma */])(y);

  function rgb(start, end) {
    var r = color((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(start)).r, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(end)).r),
        g = color(start.g, end.g),
        b = color(start.b, end.b),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_3__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g(t);
      start.b = b(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }

  rgb.gamma = rgbGamma;

  return rgb;
})(1));

function rgbSpline(spline) {
  return function(colors) {
    var n = colors.length,
        r = new Array(n),
        g = new Array(n),
        b = new Array(n),
        i, color;
    for (i = 0; i < n; ++i) {
      color = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["f" /* rgb */])(colors[i]);
      r[i] = color.r || 0;
      g[i] = color.g || 0;
      b[i] = color.b || 0;
    }
    r = spline(r);
    g = spline(g);
    b = spline(b);
    color.opacity = 1;
    return function(t) {
      color.r = r(t);
      color.g = g(t);
      color.b = b(t);
      return color + "";
    };
  };
}

var rgbBasis = rgbSpline(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* default */]);
var rgbBasisClosed = rgbSpline(__WEBPACK_IMPORTED_MODULE_2__basisClosed__["a" /* default */]);


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(450);


/* harmony default export */ __webpack_exports__["a"] = (function(values) {
  var n = values.length;
  return function(t) {
    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
        v0 = values[(i + n - 1) % n],
        v1 = values[i % n],
        v2 = values[(i + 1) % n],
        v3 = values[(i + 2) % n];
    return Object(__WEBPACK_IMPORTED_MODULE_0__basis__["a" /* basis */])((t - i / n) * n, v0, v1, v2, v3);
  };
});


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(447);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var nb = b ? b.length : 0,
      na = a ? Math.min(nb, a.length) : 0,
      x = new Array(na),
      c = new Array(nb),
      i;

  for (i = 0; i < na; ++i) x[i] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[i], b[i]);
  for (; i < nb; ++i) c[i] = b[i];

  return function(t) {
    for (i = 0; i < na; ++i) c[i] = x[i](t);
    return c;
  };
});


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var d = new Date;
  return a = +a, b -= a, function(t) {
    return d.setTime(a + b * t), d;
  };
});


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__value__ = __webpack_require__(447);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = {},
      c = {},
      k;

  if (a === null || typeof a !== "object") a = {};
  if (b === null || typeof b !== "object") b = {};

  for (k in b) {
    if (k in a) {
      i[k] = Object(__WEBPACK_IMPORTED_MODULE_0__value__["a" /* default */])(a[k], b[k]);
    } else {
      c[k] = b[k];
    }
  }

  return function(t) {
    for (k in i) c[k] = i[k](t);
    return c;
  };
});


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(287);


var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
    reB = new RegExp(reA.source, "g");

function zero(b) {
  return function() {
    return b;
  };
}

function one(b) {
  return function(t) {
    return b(t) + "";
  };
}

/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
      am, // current match in a
      bm, // current match in b
      bs, // string preceding current number in b, if any
      i = -1, // index in s
      s = [], // string constants and placeholders
      q = []; // number interpolators

  // Coerce inputs to strings.
  a = a + "", b = b + "";

  // Interpolate pairs of numbers in a & b.
  while ((am = reA.exec(a))
      && (bm = reB.exec(b))) {
    if ((bs = bm.index) > bi) { // a string precedes the next number in b
      bs = b.slice(bi, bs);
      if (s[i]) s[i] += bs; // coalesce with previous string
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
      if (s[i]) s[i] += bm; // coalesce with previous string
      else s[++i] = bm;
    } else { // interpolate non-matching numbers
      s[++i] = null;
      q.push({i: i, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(am, bm)});
    }
    bi = reB.lastIndex;
  }

  // Add remains of b.
  if (bi < b.length) {
    bs = b.slice(bi);
    if (s[i]) s[i] += bs; // coalesce with previous string
    else s[++i] = bs;
  }

  // Special optimization for only a single match.
  // Otherwise, interpolate each of the numbers and rejoin the string.
  return s.length < 2 ? (q[0]
      ? one(q[0].x)
      : zero(b))
      : (b = q.length, function(t) {
          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
          return s.join("");
        });
});


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return +x;
});


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(1913);
/* unused harmony reexport formatDefaultLocale */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale__ = __webpack_require__(744);
/* unused harmony reexport formatLocale */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatSpecifier__ = __webpack_require__(745);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__formatSpecifier__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__precisionFixed__ = __webpack_require__(1920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__precisionFixed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__precisionPrefix__ = __webpack_require__(1921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__precisionPrefix__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__precisionRound__ = __webpack_require__(1922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__precisionRound__["a"]; });








/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatGroup__ = __webpack_require__(1914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__formatNumerals__ = __webpack_require__(1915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatSpecifier__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__formatTrim__ = __webpack_require__(1916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__formatTypes__ = __webpack_require__(1917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity__ = __webpack_require__(1919);









var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];

/* harmony default export */ __webpack_exports__["a"] = (function(locale) {
  var group = locale.grouping && locale.thousands ? Object(__WEBPACK_IMPORTED_MODULE_1__formatGroup__["a" /* default */])(locale.grouping, locale.thousands) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      currency = locale.currency,
      decimal = locale.decimal,
      numerals = locale.numerals ? Object(__WEBPACK_IMPORTED_MODULE_2__formatNumerals__["a" /* default */])(locale.numerals) : __WEBPACK_IMPORTED_MODULE_7__identity__["a" /* default */],
      percent = locale.percent || "%";

  function newFormat(specifier) {
    specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier);

    var fill = specifier.fill,
        align = specifier.align,
        sign = specifier.sign,
        symbol = specifier.symbol,
        zero = specifier.zero,
        width = specifier.width,
        comma = specifier.comma,
        precision = specifier.precision,
        trim = specifier.trim,
        type = specifier.type;

    // The "n" type is an alias for ",g".
    if (type === "n") comma = true, type = "g";

    // The "" type, and any invalid type, is an alias for ".12~g".
    else if (!__WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type]) precision == null && (precision = 12), trim = true, type = "g";

    // If zero fill is specified, padding goes after sign and before digits.
    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";

    // Compute the prefix and suffix.
    // For SI-prefix, the suffix is lazily computed.
    var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
        suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? percent : "";

    // What format function should we use?
    // Is this an integer type?
    // Can this type generate exponential notation?
    var formatType = __WEBPACK_IMPORTED_MODULE_5__formatTypes__["a" /* default */][type],
        maybeSuffix = /[defgprs%]/.test(type);

    // Set the default precision if not specified,
    // or clamp the specified precision to the supported range.
    // For significant precision, it must be in [1, 21].
    // For fixed precision, it must be in [0, 20].
    precision = precision == null ? 6
        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
        : Math.max(0, Math.min(20, precision));

    function format(value) {
      var valuePrefix = prefix,
          valueSuffix = suffix,
          i, n, c;

      if (type === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;

        // Perform the initial formatting.
        var valueNegative = value < 0;
        value = formatType(Math.abs(value), precision);

        // Trim insignificant zeros.
        if (trim) value = Object(__WEBPACK_IMPORTED_MODULE_4__formatTrim__["a" /* default */])(value);

        // If a negative value rounds to zero during formatting, treat as positive.
        if (valueNegative && +value === 0) valueNegative = false;

        // Compute the prefix and suffix.
        valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
        valueSuffix = (type === "s" ? prefixes[8 + __WEBPACK_IMPORTED_MODULE_6__formatPrefixAuto__["b" /* prefixExponent */] / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");

        // Break the formatted value into the integer “value” part that can be
        // grouped, and fractional or exponential “suffix” part that is not.
        if (maybeSuffix) {
          i = -1, n = value.length;
          while (++i < n) {
            if (c = value.charCodeAt(i), 48 > c || c > 57) {
              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }

      // If the fill character is not "0", grouping is applied before padding.
      if (comma && !zero) value = group(value, Infinity);

      // Compute the padding.
      var length = valuePrefix.length + value.length + valueSuffix.length,
          padding = length < width ? new Array(width - length + 1).join(fill) : "";

      // If the fill character is "0", grouping is applied after padding.
      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";

      // Reconstruct the final output based on the desired alignment.
      switch (align) {
        case "<": value = valuePrefix + value + valueSuffix + padding; break;
        case "=": value = valuePrefix + padding + value + valueSuffix; break;
        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
        default: value = padding + valuePrefix + value + valueSuffix; break;
      }

      return numerals(value);
    }

    format.toString = function() {
      return specifier + "";
    };

    return format;
  }

  function formatPrefix(specifier, value) {
    var f = newFormat((specifier = Object(__WEBPACK_IMPORTED_MODULE_3__formatSpecifier__["a" /* default */])(specifier), specifier.type = "f", specifier)),
        e = Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3,
        k = Math.pow(10, -e),
        prefix = prefixes[8 + e / 3];
    return function(value) {
      return f(k * value) + prefix;
    };
  }

  return {
    format: newFormat,
    formatPrefix: formatPrefix
  };
});


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;

function formatSpecifier(specifier) {
  return new FormatSpecifier(specifier);
}

formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof

function FormatSpecifier(specifier) {
  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match;
  this.fill = match[1] || " ";
  this.align = match[2] || ">";
  this.sign = match[3] || "-";
  this.symbol = match[4] || "";
  this.zero = !!match[5];
  this.width = match[6] && +match[6];
  this.comma = !!match[7];
  this.precision = match[8] && +match[8].slice(1);
  this.trim = !!match[9];
  this.type = match[10] || "";
}

FormatSpecifier.prototype.toString = function() {
  return this.fill
      + this.align
      + this.sign
      + this.symbol
      + (this.zero ? "0" : "")
      + (this.width == null ? "" : Math.max(1, this.width | 0))
      + (this.comma ? "," : "")
      + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
      + (this.trim ? "~" : "")
      + this.type;
};


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return prefixExponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(452);


var prefixExponent;

/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1],
      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
      n = coefficient.length;
  return i === n ? coefficient
      : i > n ? coefficient + new Array(i - n + 1).join("0")
      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
      : "0." + new Array(1 - i).join("0") + Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, Math.max(0, p + i - 1))[0]; // less than 1y!
});


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(domain, interval) {
  domain = domain.slice();

  var i0 = 0,
      i1 = domain.length - 1,
      x0 = domain[i0],
      x1 = domain[i1],
      t;

  if (x1 < x0) {
    t = i0, i0 = i1, i1 = t;
    t = x0, x0 = x1, x1 = t;
  }

  domain[i0] = interval.floor(x0);
  domain[i1] = interval.ceil(x1);
  return domain;
});


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calendar;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_d3_time_format__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__array__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__continuous__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nice__ = __webpack_require__(747);








var durationSecond = 1000,
    durationMinute = durationSecond * 60,
    durationHour = durationMinute * 60,
    durationDay = durationHour * 24,
    durationWeek = durationDay * 7,
    durationMonth = durationDay * 30,
    durationYear = durationDay * 365;

function date(t) {
  return new Date(t);
}

function number(t) {
  return t instanceof Date ? +t : +new Date(+t);
}

function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["b" /* default */])(__WEBPACK_IMPORTED_MODULE_5__continuous__["c" /* deinterpolateLinear */], __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateNumber"]),
      invert = scale.invert,
      domain = scale.domain;

  var formatMillisecond = format(".%L"),
      formatSecond = format(":%S"),
      formatMinute = format("%I:%M"),
      formatHour = format("%I %p"),
      formatDay = format("%a %d"),
      formatWeek = format("%b %d"),
      formatMonth = format("%B"),
      formatYear = format("%Y");

  var tickIntervals = [
    [second,  1,      durationSecond],
    [second,  5,  5 * durationSecond],
    [second, 15, 15 * durationSecond],
    [second, 30, 30 * durationSecond],
    [minute,  1,      durationMinute],
    [minute,  5,  5 * durationMinute],
    [minute, 15, 15 * durationMinute],
    [minute, 30, 30 * durationMinute],
    [  hour,  1,      durationHour  ],
    [  hour,  3,  3 * durationHour  ],
    [  hour,  6,  6 * durationHour  ],
    [  hour, 12, 12 * durationHour  ],
    [   day,  1,      durationDay   ],
    [   day,  2,  2 * durationDay   ],
    [  week,  1,      durationWeek  ],
    [ month,  1,      durationMonth ],
    [ month,  3,  3 * durationMonth ],
    [  year,  1,      durationYear  ]
  ];

  function tickFormat(date) {
    return (second(date) < date ? formatMillisecond
        : minute(date) < date ? formatSecond
        : hour(date) < date ? formatMinute
        : day(date) < date ? formatHour
        : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
        : year(date) < date ? formatMonth
        : formatYear)(date);
  }

  function tickInterval(interval, start, stop, step) {
    if (interval == null) interval = 10;

    // If a desired tick count is specified, pick a reasonable tick interval
    // based on the extent of the domain and a rough estimate of tick size.
    // Otherwise, assume interval is already a time interval and use it.
    if (typeof interval === "number") {
      var target = Math.abs(stop - start) / interval,
          i = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["c" /* bisector */])(function(i) { return i[2]; }).right(tickIntervals, target);
      if (i === tickIntervals.length) {
        step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start / durationYear, stop / durationYear, interval);
        interval = year;
      } else if (i) {
        i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        step = i[1];
        interval = i[0];
      } else {
        step = Math.max(Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, interval), 1);
        interval = millisecond;
      }
    }

    return step == null ? interval : interval.every(step);
  }

  scale.invert = function(y) {
    return new Date(invert(y));
  };

  scale.domain = function(_) {
    return arguments.length ? domain(__WEBPACK_IMPORTED_MODULE_4__array__["a" /* map */].call(_, number)) : domain().map(date);
  };

  scale.ticks = function(interval, step) {
    var d = domain(),
        t0 = d[0],
        t1 = d[d.length - 1],
        r = t1 < t0,
        t;
    if (r) t = t0, t0 = t1, t1 = t;
    t = tickInterval(interval, t0, t1, step);
    t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
    return r ? t.reverse() : t;
  };

  scale.tickFormat = function(count, specifier) {
    return specifier == null ? tickFormat : format(specifier);
  };

  scale.nice = function(interval, step) {
    var d = domain();
    return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
        ? domain(Object(__WEBPACK_IMPORTED_MODULE_6__nice__["a" /* default */])(d, interval))
        : scale;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_5__continuous__["a" /* copy */])(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
  };

  return scale;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return calendar(__WEBPACK_IMPORTED_MODULE_2_d3_time__["k" /* timeYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["f" /* timeMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["j" /* timeWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["a" /* timeDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["b" /* timeHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["d" /* timeMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["g" /* timeSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["c" /* timeMillisecond */], __WEBPACK_IMPORTED_MODULE_3_d3_time_format__["a" /* timeFormat */]).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
});


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatLocale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_time__ = __webpack_require__(212);


function localDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
    date.setFullYear(d.y);
    return date;
  }
  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}

function utcDate(d) {
  if (0 <= d.y && d.y < 100) {
    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
    date.setUTCFullYear(d.y);
    return date;
  }
  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}

function newYear(y) {
  return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
}

function formatLocale(locale) {
  var locale_dateTime = locale.dateTime,
      locale_date = locale.date,
      locale_time = locale.time,
      locale_periods = locale.periods,
      locale_weekdays = locale.days,
      locale_shortWeekdays = locale.shortDays,
      locale_months = locale.months,
      locale_shortMonths = locale.shortMonths;

  var periodRe = formatRe(locale_periods),
      periodLookup = formatLookup(locale_periods),
      weekdayRe = formatRe(locale_weekdays),
      weekdayLookup = formatLookup(locale_weekdays),
      shortWeekdayRe = formatRe(locale_shortWeekdays),
      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
      monthRe = formatRe(locale_months),
      monthLookup = formatLookup(locale_months),
      shortMonthRe = formatRe(locale_shortMonths),
      shortMonthLookup = formatLookup(locale_shortMonths);

  var formats = {
    "a": formatShortWeekday,
    "A": formatWeekday,
    "b": formatShortMonth,
    "B": formatMonth,
    "c": null,
    "d": formatDayOfMonth,
    "e": formatDayOfMonth,
    "f": formatMicroseconds,
    "H": formatHour24,
    "I": formatHour12,
    "j": formatDayOfYear,
    "L": formatMilliseconds,
    "m": formatMonthNumber,
    "M": formatMinutes,
    "p": formatPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatSeconds,
    "u": formatWeekdayNumberMonday,
    "U": formatWeekNumberSunday,
    "V": formatWeekNumberISO,
    "w": formatWeekdayNumberSunday,
    "W": formatWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatYear,
    "Y": formatFullYear,
    "Z": formatZone,
    "%": formatLiteralPercent
  };

  var utcFormats = {
    "a": formatUTCShortWeekday,
    "A": formatUTCWeekday,
    "b": formatUTCShortMonth,
    "B": formatUTCMonth,
    "c": null,
    "d": formatUTCDayOfMonth,
    "e": formatUTCDayOfMonth,
    "f": formatUTCMicroseconds,
    "H": formatUTCHour24,
    "I": formatUTCHour12,
    "j": formatUTCDayOfYear,
    "L": formatUTCMilliseconds,
    "m": formatUTCMonthNumber,
    "M": formatUTCMinutes,
    "p": formatUTCPeriod,
    "Q": formatUnixTimestamp,
    "s": formatUnixTimestampSeconds,
    "S": formatUTCSeconds,
    "u": formatUTCWeekdayNumberMonday,
    "U": formatUTCWeekNumberSunday,
    "V": formatUTCWeekNumberISO,
    "w": formatUTCWeekdayNumberSunday,
    "W": formatUTCWeekNumberMonday,
    "x": null,
    "X": null,
    "y": formatUTCYear,
    "Y": formatUTCFullYear,
    "Z": formatUTCZone,
    "%": formatLiteralPercent
  };

  var parses = {
    "a": parseShortWeekday,
    "A": parseWeekday,
    "b": parseShortMonth,
    "B": parseMonth,
    "c": parseLocaleDateTime,
    "d": parseDayOfMonth,
    "e": parseDayOfMonth,
    "f": parseMicroseconds,
    "H": parseHour24,
    "I": parseHour24,
    "j": parseDayOfYear,
    "L": parseMilliseconds,
    "m": parseMonthNumber,
    "M": parseMinutes,
    "p": parsePeriod,
    "Q": parseUnixTimestamp,
    "s": parseUnixTimestampSeconds,
    "S": parseSeconds,
    "u": parseWeekdayNumberMonday,
    "U": parseWeekNumberSunday,
    "V": parseWeekNumberISO,
    "w": parseWeekdayNumberSunday,
    "W": parseWeekNumberMonday,
    "x": parseLocaleDate,
    "X": parseLocaleTime,
    "y": parseYear,
    "Y": parseFullYear,
    "Z": parseZone,
    "%": parseLiteralPercent
  };

  // These recursive directive definitions must be deferred.
  formats.x = newFormat(locale_date, formats);
  formats.X = newFormat(locale_time, formats);
  formats.c = newFormat(locale_dateTime, formats);
  utcFormats.x = newFormat(locale_date, utcFormats);
  utcFormats.X = newFormat(locale_time, utcFormats);
  utcFormats.c = newFormat(locale_dateTime, utcFormats);

  function newFormat(specifier, formats) {
    return function(date) {
      var string = [],
          i = -1,
          j = 0,
          n = specifier.length,
          c,
          pad,
          format;

      if (!(date instanceof Date)) date = new Date(+date);

      while (++i < n) {
        if (specifier.charCodeAt(i) === 37) {
          string.push(specifier.slice(j, i));
          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
          else pad = c === "e" ? " " : "0";
          if (format = formats[c]) c = format(date, pad);
          string.push(c);
          j = i + 1;
        }
      }

      string.push(specifier.slice(j, i));
      return string.join("");
    };
  }

  function newParse(specifier, newDate) {
    return function(string) {
      var d = newYear(1900),
          i = parseSpecifier(d, specifier, string += "", 0),
          week, day;
      if (i != string.length) return null;

      // If a UNIX timestamp is specified, return it.
      if ("Q" in d) return new Date(d.Q);

      // The am-pm flag is 0 for AM, and 1 for PM.
      if ("p" in d) d.H = d.H % 12 + d.p * 12;

      // Convert day-of-week and week-of-year to day-of-year.
      if ("V" in d) {
        if (d.V < 1 || d.V > 53) return null;
        if (!("w" in d)) d.w = 1;
        if ("Z" in d) {
          week = utcDate(newYear(d.y)), day = week.getUTCDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getUTCFullYear();
          d.m = week.getUTCMonth();
          d.d = week.getUTCDate() + (d.w + 6) % 7;
        } else {
          week = newDate(newYear(d.y)), day = week.getDay();
          week = day > 4 || day === 0 ? __WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].ceil(week) : Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */])(week);
          week = __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].offset(week, (d.V - 1) * 7);
          d.y = week.getFullYear();
          d.m = week.getMonth();
          d.d = week.getDate() + (d.w + 6) % 7;
        }
      } else if ("W" in d || "U" in d) {
        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
        day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
        d.m = 0;
        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
      }

      // If a time zone is specified, all fields are interpreted as UTC and then
      // offset according to the specified time zone.
      if ("Z" in d) {
        d.H += d.Z / 100 | 0;
        d.M += d.Z % 100;
        return utcDate(d);
      }

      // Otherwise, all fields are in local time.
      return newDate(d);
    };
  }

  function parseSpecifier(d, specifier, string, j) {
    var i = 0,
        n = specifier.length,
        m = string.length,
        c,
        parse;

    while (i < n) {
      if (j >= m) return -1;
      c = specifier.charCodeAt(i++);
      if (c === 37) {
        c = specifier.charAt(i++);
        parse = parses[c in pads ? specifier.charAt(i++) : c];
        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
      } else if (c != string.charCodeAt(j++)) {
        return -1;
      }
    }

    return j;
  }

  function parsePeriod(d, string, i) {
    var n = periodRe.exec(string.slice(i));
    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortWeekday(d, string, i) {
    var n = shortWeekdayRe.exec(string.slice(i));
    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseWeekday(d, string, i) {
    var n = weekdayRe.exec(string.slice(i));
    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseShortMonth(d, string, i) {
    var n = shortMonthRe.exec(string.slice(i));
    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseMonth(d, string, i) {
    var n = monthRe.exec(string.slice(i));
    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
  }

  function parseLocaleDateTime(d, string, i) {
    return parseSpecifier(d, locale_dateTime, string, i);
  }

  function parseLocaleDate(d, string, i) {
    return parseSpecifier(d, locale_date, string, i);
  }

  function parseLocaleTime(d, string, i) {
    return parseSpecifier(d, locale_time, string, i);
  }

  function formatShortWeekday(d) {
    return locale_shortWeekdays[d.getDay()];
  }

  function formatWeekday(d) {
    return locale_weekdays[d.getDay()];
  }

  function formatShortMonth(d) {
    return locale_shortMonths[d.getMonth()];
  }

  function formatMonth(d) {
    return locale_months[d.getMonth()];
  }

  function formatPeriod(d) {
    return locale_periods[+(d.getHours() >= 12)];
  }

  function formatUTCShortWeekday(d) {
    return locale_shortWeekdays[d.getUTCDay()];
  }

  function formatUTCWeekday(d) {
    return locale_weekdays[d.getUTCDay()];
  }

  function formatUTCShortMonth(d) {
    return locale_shortMonths[d.getUTCMonth()];
  }

  function formatUTCMonth(d) {
    return locale_months[d.getUTCMonth()];
  }

  function formatUTCPeriod(d) {
    return locale_periods[+(d.getUTCHours() >= 12)];
  }

  return {
    format: function(specifier) {
      var f = newFormat(specifier += "", formats);
      f.toString = function() { return specifier; };
      return f;
    },
    parse: function(specifier) {
      var p = newParse(specifier += "", localDate);
      p.toString = function() { return specifier; };
      return p;
    },
    utcFormat: function(specifier) {
      var f = newFormat(specifier += "", utcFormats);
      f.toString = function() { return specifier; };
      return f;
    },
    utcParse: function(specifier) {
      var p = newParse(specifier, utcDate);
      p.toString = function() { return specifier; };
      return p;
    }
  };
}

var pads = {"-": "", "_": " ", "0": "0"},
    numberRe = /^\s*\d+/, // note: ignores next directive
    percentRe = /^%/,
    requoteRe = /[\\^$*+?|[\]().{}]/g;

function pad(value, fill, width) {
  var sign = value < 0 ? "-" : "",
      string = (sign ? -value : value) + "",
      length = string.length;
  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}

function requote(s) {
  return s.replace(requoteRe, "\\$&");
}

function formatRe(names) {
  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}

function formatLookup(names) {
  var map = {}, i = -1, n = names.length;
  while (++i < n) map[names[i].toLowerCase()] = i;
  return map;
}

function parseWeekdayNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.w = +n[0], i + n[0].length) : -1;
}

function parseWeekdayNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 1));
  return n ? (d.u = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberSunday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.U = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberISO(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.V = +n[0], i + n[0].length) : -1;
}

function parseWeekNumberMonday(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.W = +n[0], i + n[0].length) : -1;
}

function parseFullYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 4));
  return n ? (d.y = +n[0], i + n[0].length) : -1;
}

function parseYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}

function parseZone(d, string, i) {
  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}

function parseMonthNumber(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}

function parseDayOfMonth(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.d = +n[0], i + n[0].length) : -1;
}

function parseDayOfYear(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}

function parseHour24(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.H = +n[0], i + n[0].length) : -1;
}

function parseMinutes(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.M = +n[0], i + n[0].length) : -1;
}

function parseSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 2));
  return n ? (d.S = +n[0], i + n[0].length) : -1;
}

function parseMilliseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 3));
  return n ? (d.L = +n[0], i + n[0].length) : -1;
}

function parseMicroseconds(d, string, i) {
  var n = numberRe.exec(string.slice(i, i + 6));
  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}

function parseLiteralPercent(d, string, i) {
  var n = percentRe.exec(string.slice(i, i + 1));
  return n ? i + n[0].length : -1;
}

function parseUnixTimestamp(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = +n[0], i + n[0].length) : -1;
}

function parseUnixTimestampSeconds(d, string, i) {
  var n = numberRe.exec(string.slice(i));
  return n ? (d.Q = (+n[0]) * 1000, i + n[0].length) : -1;
}

function formatDayOfMonth(d, p) {
  return pad(d.getDate(), p, 2);
}

function formatHour24(d, p) {
  return pad(d.getHours(), p, 2);
}

function formatHour12(d, p) {
  return pad(d.getHours() % 12 || 12, p, 2);
}

function formatDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["a" /* timeDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 3);
}

function formatMilliseconds(d, p) {
  return pad(d.getMilliseconds(), p, 3);
}

function formatMicroseconds(d, p) {
  return formatMilliseconds(d, p) + "000";
}

function formatMonthNumber(d, p) {
  return pad(d.getMonth() + 1, p, 2);
}

function formatMinutes(d, p) {
  return pad(d.getMinutes(), p, 2);
}

function formatSeconds(d, p) {
  return pad(d.getSeconds(), p, 2);
}

function formatWeekdayNumberMonday(d) {
  var day = d.getDay();
  return day === 0 ? 7 : day;
}

function formatWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["h" /* timeSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatWeekNumberISO(d, p) {
  var day = d.getDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["i" /* timeThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d).getDay() === 4), p, 2);
}

function formatWeekdayNumberSunday(d) {
  return d.getDay();
}

function formatWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["e" /* timeMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["k" /* timeYear */])(d), d), p, 2);
}

function formatYear(d, p) {
  return pad(d.getFullYear() % 100, p, 2);
}

function formatFullYear(d, p) {
  return pad(d.getFullYear() % 10000, p, 4);
}

function formatZone(d) {
  var z = d.getTimezoneOffset();
  return (z > 0 ? "-" : (z *= -1, "+"))
      + pad(z / 60 | 0, "0", 2)
      + pad(z % 60, "0", 2);
}

function formatUTCDayOfMonth(d, p) {
  return pad(d.getUTCDate(), p, 2);
}

function formatUTCHour24(d, p) {
  return pad(d.getUTCHours(), p, 2);
}

function formatUTCHour12(d, p) {
  return pad(d.getUTCHours() % 12 || 12, p, 2);
}

function formatUTCDayOfYear(d, p) {
  return pad(1 + __WEBPACK_IMPORTED_MODULE_0_d3_time__["l" /* utcDay */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 3);
}

function formatUTCMilliseconds(d, p) {
  return pad(d.getUTCMilliseconds(), p, 3);
}

function formatUTCMicroseconds(d, p) {
  return formatUTCMilliseconds(d, p) + "000";
}

function formatUTCMonthNumber(d, p) {
  return pad(d.getUTCMonth() + 1, p, 2);
}

function formatUTCMinutes(d, p) {
  return pad(d.getUTCMinutes(), p, 2);
}

function formatUTCSeconds(d, p) {
  return pad(d.getUTCSeconds(), p, 2);
}

function formatUTCWeekdayNumberMonday(d) {
  var dow = d.getUTCDay();
  return dow === 0 ? 7 : dow;
}

function formatUTCWeekNumberSunday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["s" /* utcSunday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCWeekNumberISO(d, p) {
  var day = d.getUTCDay();
  d = (day >= 4 || day === 0) ? Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */])(d) : __WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].ceil(d);
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["t" /* utcThursday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d) + (Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d).getUTCDay() === 4), p, 2);
}

function formatUTCWeekdayNumberSunday(d) {
  return d.getUTCDay();
}

function formatUTCWeekNumberMonday(d, p) {
  return pad(__WEBPACK_IMPORTED_MODULE_0_d3_time__["p" /* utcMonday */].count(Object(__WEBPACK_IMPORTED_MODULE_0_d3_time__["v" /* utcYear */])(d), d), p, 2);
}

function formatUTCYear(d, p) {
  return pad(d.getUTCFullYear() % 100, p, 2);
}

function formatUTCFullYear(d, p) {
  return pad(d.getUTCFullYear() % 10000, p, 4);
}

function formatUTCZone() {
  return "+0000";
}

function formatLiteralPercent() {
  return "%";
}

function formatUnixTimestamp(d) {
  return +d;
}

function formatUnixTimestampSeconds(d) {
  return Math.floor(+d / 1000);
}


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isoSpecifier; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultLocale__ = __webpack_require__(454);


var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";

function formatIsoNative(date) {
  return date.toISOString();
}

var formatIso = Date.prototype.toISOString
    ? formatIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_0__defaultLocale__["b" /* utcFormat */])(isoSpecifier);

/* unused harmony default export */ var _unused_webpack_default_export = (formatIso);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return saveSnapshot; });
/* harmony export (immutable) */ __webpack_exports__["a"] = clearSnapshot;
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialState;
/* harmony export (immutable) */ __webpack_exports__["c"] = makePayloadProps;
/* harmony export (immutable) */ __webpack_exports__["s"] = updateIsLoading;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return updateExtent; });
/* harmony export (immutable) */ __webpack_exports__["d"] = normalizeTimeSpan;
/* harmony export (immutable) */ __webpack_exports__["e"] = normalizeViewport;
/* harmony export (immutable) */ __webpack_exports__["p"] = resetCursor;
/* harmony export (immutable) */ __webpack_exports__["f"] = onDrop;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return onWheel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return onMouseDown; });
/* harmony export (immutable) */ __webpack_exports__["k"] = onMouseUp;
/* harmony export (immutable) */ __webpack_exports__["j"] = onMouseMove;
/* harmony export (immutable) */ __webpack_exports__["h"] = onMouseEnter;
/* harmony export (immutable) */ __webpack_exports__["i"] = onMouseLeave;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return onTouchStart; });
/* harmony export (immutable) */ __webpack_exports__["l"] = onTouchEnd;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return onTouchMove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clamp__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Scales__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OscillatorVisuals__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_throttle__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var SNAPSHOT_KEY="chartEventHandlersLastState";var saveSnapshot=__WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(function(state){try{sessionStorage.setItem(SNAPSHOT_KEY,JSON.stringify({cursor:state.cursor.follow?undefined:Object.assign({},state.cursor),timeSpan:state.timeSpan,interval:state.interval}));}catch(e){console.error(e);};},500);function getSnapshot(){var lastState=void 0;try{var item=sessionStorage.getItem(SNAPSHOT_KEY);if(item){lastState=JSON.parse(item);}}catch(e){}return lastState;}function clearSnapshot(){try{sessionStorage.removeItem(SNAPSHOT_KEY);}catch(e){console.error(e);};}function getInitialState(props){// const present = props.points[props.points.length - 1];
var interval=__WEBPACK_IMPORTED_MODULE_0_lodash_clamp___default()(props.settings.interval,1,__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)?1*60*2:1*60*60*24*30);var snapshot=props.static?{}:getSnapshot()||{};var state=Object.assign({timeSpan:props.settings.timeSpan,animateTimeSpan:true,cursor:props.cursor!=null?props.cursor:{ratio:0.68,date:props.points[props.points.length-1].date,follow:true,animate:true},mouseX:0,mouseY:0,isHovered:false,isActive:false,width:0,height:0,pinchRatio:0,extent:[0,0],cache:{},lastLoadedSections:null,isLoading:false,isEngaged:false,isScrolled:false,lastEngagementTime:0,lastScrollTime:0,interval:interval,checkpoints:[],lastMovementTime:props.points[props.points.length-1].date},snapshot);return Object.assign({},state,normalizeTimeSpan(state,props));}function makePayloadProps(state,props){return{stock:props.stock.stock,realtimeCache:props.points,width:state.width,height:state.height,timeSpan:state.timeSpan,sectionSize:props.settings.chartType==="line"?100:20,scaleX:Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state),type:props.settings.chartType,density:1/5,interval:props.settings.interval,checkpoints:state.checkpoints};}function updateIsLoading(state,props){// В режиме OTC нет нужды следить за состоянием загрузки
if(__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)){var _isLoading=false;if(_isLoading!==state.isLoading){return{isLoading:_isLoading};}else{return null;}}var payloadProps=makePayloadProps(state,props);var relevantSectionProps=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["f" /* getCommonSectionProps */](payloadProps);var relevantSections=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["e" /* generateSections */](relevantSectionProps,payloadProps);var _Helpers$getPoints=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["h" /* getPoints */](relevantSections,state.cache,payloadProps,props.deals),isDarkArea=_Helpers$getPoints.isDarkArea;var isLoading=false;if(isDarkArea){relevantSections=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["e" /* generateSections */](Object.assign({},relevantSectionProps,{interval:5000}),payloadProps);}isLoading=relevantSections.some(function(section){return __WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["i" /* getSectionBoundaries */](section)[0]<props.points[0].date&&__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["k" /* getSectionType */](section,payloadProps)==="past"&&state.cache[__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["j" /* getSectionKey */](section)]==null;});if(isLoading!==state.isLoading){return{isLoading:isLoading};}else{return null;}}var updateExtent=function updateExtent(state,props){if(state.isLoading){return null;}else{var payloadProps=makePayloadProps(state,props);var relevantSectionProps=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["f" /* getCommonSectionProps */](payloadProps);var relevantSections=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["e" /* generateSections */](relevantSectionProps,payloadProps);var _Helpers$getPoints2=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["h" /* getPoints */](relevantSections,state.cache,payloadProps,props.deals),points=_Helpers$getPoints2.points,isDarkArea=_Helpers$getPoints2.isDarkArea;// Второй круг для тёмных областей графика
if(isDarkArea){relevantSections=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["e" /* generateSections */](Object.assign({},relevantSectionProps,{interval:5000}),payloadProps);var fallback=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["h" /* getPoints */](relevantSections,state.cache,payloadProps,props.deals);points=fallback.points;// emptySections = fallback.emptySections;
isDarkArea=fallback.isDarkArea;}var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);var oldestRelevantDate=scaleX.invert(0).valueOf();var newestRelevantDate=scaleX.invert(state.width).valueOf();var length=points.length;if(length>1){var minimum=null;var maximum=null;for(var i=1;i<length;i++){if(points[i].epoch*1000<oldestRelevantDate){continue;}if(points[i].epoch*1000>newestRelevantDate){break;}if(minimum==null||points[i].min<minimum){minimum=points[i].min;}if(maximum==null||points[i].max>maximum){maximum=points[i].max;}}if(minimum==null||maximum==null){return null;}else{return{extent:[minimum,maximum]};}}else{return null;}}};function normalizeTimeSpan(state,props){var fittingTimeSpan=props.settings.chartType==="line"?__WEBPACK_IMPORTED_MODULE_0_lodash_clamp___default()(state.timeSpan,30000,__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["g" /* getHistoryLength */](props.stock)):__WEBPACK_IMPORTED_MODULE_0_lodash_clamp___default.a.apply(undefined,[state.timeSpan].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["l" /* getTimeSpanRange */](props.stock,state.interval*1000))));if(fittingTimeSpan===state.timeSpan){return null;}else{return{timeSpan:fittingTimeSpan};}}function normalizeViewport(state,props){// Так мы проверяем, можно ли двигать график
var present=props.points[props.points.length-1];var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);var historyLenth=__WEBPACK_IMPORTED_MODULE_3__NextGenChartMath__["g" /* getHistoryLength */](props.stock);switch(true){case scaleX(present.date-historyLenth)>0:return{cursor:{date:state.cursor.date,ratio:(state.cursor.ratio*state.width-scaleX(present.date-historyLenth))/state.width,follow:false,animate:false}};case scaleX(present.date)<=100&&(state.isActive||state.isScrolled):return{cursor:{date:state.cursor.date,ratio:(state.cursor.ratio*state.width+100-scaleX(present.date))/state.width,follow:false,animate:false}};case scaleX(present.date)<state.width&&!(state.isActive||state.isScrolled):return{cursor:{date:state.cursor.date,ratio:state.cursor.ratio,follow:true,animate:true}};default:return null;}}function resetCursor(state,props){var present=props.points[props.points.length-1];var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);var presentX=scaleX(present.date);if(presentX>=0&&presentX<=state.width){return{cursor:{date:present.date,ratio:presentX/state.width,follow:true,animate:false}};}else{return null;}}function onDrop(event,setState){event.preventDefault();}var onWheel=function onWheel(event,setState){event.preventDefault();var timeStamp=event.timeStamp;setState(function(){return{isScrolled:true,lastScrollTime:timeStamp};});// Мы не хотим запутать клиента одновременным скроллом и зумом, поэтому
// выбираем одно из двух.
// Оси инвертируются с зажатой клавишей Shift.
var _ref=event.shiftKey?Math.abs(event.deltaY)>Math.abs(event.deltaX)?[event.deltaY,0]:[0,event.deltaX]:Math.abs(event.deltaX)>Math.abs(event.deltaY)?[event.deltaX,0]:[0,event.deltaY],_ref2=_slicedToArray(_ref,2),deltaX=_ref2[0],deltaY=_ref2[1];var clientX=event.clientX;if(deltaX!==0){setState(function(state,props){return{cursor:{date:state.cursor.date,ratio:(state.cursor.ratio*state.width-deltaX)/state.width,follow:false,animate:false}};});}if(deltaY!==0){setState(function(state,props){var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);return{cursor:{date:scaleX.invert(clientX).valueOf(),ratio:clientX/state.width,animate:false,follow:false},timeSpan:deltaY>0?state.timeSpan*(1+Math.abs(deltaY)/500):state.timeSpan/(1+Math.abs(deltaY)/500),animateTimeSpan:true};});setState(normalizeTimeSpan);}setState(normalizeViewport);setState(updateIsLoading);setState(updateExtent);setState(saveSnapshot);};var isDragHandleDown=false;var dragHandleHandler=null;function graphicalModeClick(event,state,props){var target=event.currentTarget||event.target;var rect=target.getBoundingClientRect();if(props.graphicalMode&&props.graphicalMode.graphicalTool!==null){var clientY=event.type==="touchstart"?event.touches[0].clientY:event.clientY;var mouseY=clientY-rect.top;var scaleY=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["d" /* getScaleY */])(Object.assign({},state,{modifier:Object(__WEBPACK_IMPORTED_MODULE_2__OscillatorVisuals__["e" /* getScaleModifier */])(props.settings.indicators)}));var minLevel=scaleY.domain()[0];var value=scaleY.invert(mouseY).valueOf();var ticksHeight=24;if(mouseY<ticksHeight||value<minLevel){return props.dispatch({type:"SET_GRAPHICAL_MODE",payload:null});}props.dispatch({type:"PUSH_GRAPHICAL_TOOL",payload:{enabled:true,stock:props.stock.stock,tool:props.graphicalMode.graphicalTool,color:"#00cbfe",width:2,anchorValue:value}});}}var onMouseDown=function onMouseDown(event,setState){event.preventDefault();// Закомментировано пока мы не работаем в синтетической системе событий реакта
// event.persist();
if(event.target.isDragHandleDown){isDragHandleDown=true;dragHandleHandler=event.target.dragHandleHandler;}var clientX=event.clientX;setState(function(state,props){graphicalModeClick(event,state,props);if(isDragHandleDown){return state;}var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);return{isActive:true,cursor:{date:Math.round(scaleX.invert(clientX).valueOf()),ratio:clientX/state.width,animate:false,follow:false}};});};function onMouseUp(event,setState){event.preventDefault();isDragHandleDown=false;dragHandleHandler=null;setState(function(){return{isActive:false};});setState(normalizeViewport);setState(updateIsLoading);setState(updateExtent);setState(saveSnapshot);}function onMouseMove(event,setState){event.preventDefault();if(isDragHandleDown&&typeof dragHandleHandler==="function"){dragHandleHandler(event);return;}var target=event.currentTarget||event.target;var rect=target.getBoundingClientRect();var clientX=event.clientX,clientY=event.clientY;var mouseX=clientX-rect.left;var mouseY=clientY-rect.top;setState(function(state,props){if(!state.isActive){return{rectTop:rect.top,isHovered:true,mouseX:mouseX,mouseY:mouseY};}return{rectTop:rect.top,isHovered:true,mouseX:clientX,mouseY:clientY,cursor:{date:state.cursor.date,ratio:clientX/state.width,animate:false,follow:false}};});setState(function(state,props){return state.isActive?normalizeViewport(state,props):null;});}function onPanStart(touch,setState){setState(function(state,props){var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);return{isActive:true,cursor:{date:scaleX.invert(touch.clientX).valueOf(),ratio:touch.clientX/state.width,animate:false,follow:false}};});}function onMouseEnter(_,setState){setState(function(){return{isHovered:true};});}function onMouseLeave(_,setState){isDragHandleDown=false;dragHandleHandler=null;setState(function(){return{isHovered:false};});}function onPanMove(touch,setState){setState(function(state){if(!state.isActive){return{mouseX:touch.clientX,mouseY:touch.clientY};}return{mouseX:touch.clientX,mouseY:touch.clientY,cursor:{date:state.cursor.date,ratio:touch.clientX/state.width,animate:false,follow:false}};});setState(function(state,props){return state.isActive?normalizeViewport(state,props):null;});}function onPinchStart(_ref3,setState){var _ref4=_slicedToArray(_ref3,2),touchOne=_ref4[0],touchTwo=_ref4[1];setState(function(state,props){var clientX=(touchOne.clientX+touchTwo.clientX)/2;var pinch=Math.abs(touchOne.clientX-touchTwo.clientX);var scaleX=Object(__WEBPACK_IMPORTED_MODULE_1__Scales__["c" /* getScaleX */])(state);return{isActive:true,pinchRatio:state.timeSpan*pinch,cursor:{date:scaleX.invert(clientX).valueOf(),ratio:clientX/state.width,animate:false,follow:false},animateTimeSpan:false};});}function onPinchMove(_ref5,setState){var _ref6=_slicedToArray(_ref5,2),touchOne=_ref6[0],touchTwo=_ref6[1];var clientX=(touchOne.clientX+touchTwo.clientX)/2;var pinch=Math.abs(touchOne.clientX-touchTwo.clientX);setState(function(state,props){return{isActive:true,cursor:{date:state.cursor.date,ratio:clientX/state.width,animate:false,follow:false},timeSpan:state.pinchRatio/pinch,animateTimeSpan:false};});setState(normalizeTimeSpan);setState(function(state,props){return state.isActive?normalizeViewport(state,props):null;});}var onTouchStart=function onTouchStart(event,setState){if(event.target.refundClick){return false;}event.preventDefault();// Закомментировано пока мы не работаем в синтетической системе событий реакта
// event.persist();
if(event.target.isDragHandleDown){isDragHandleDown=true;dragHandleHandler=event.target.dragHandleHandler;}setState(function(state,props){graphicalModeClick(event,state,props);return{isEngaged:true,lastEngagementTime:Date.now()};});switch(event.touches.length){case 1:return onPanStart(event.touches.item(0),setState);case 2:return onPinchStart([event.touches.item(0),event.touches.item(1)],setState);default:return;}};function onTouchEnd(event,setState){return onMouseUp(event,setState);}var onTouchMove=function onTouchMove(event,setState){event.preventDefault();if(isDragHandleDown&&typeof dragHandleHandler==="function"){dragHandleHandler(event);return;}switch(event.touches.length){case 1:return onPanMove(event.touches.item(0),setState);case 2:return onPinchMove([event.touches.item(0),event.touches.item(1)],setState);default:return;}};

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__curve_linear__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__line__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__point__ = __webpack_require__(456);






/* harmony default export */ __webpack_exports__["a"] = (function() {
  var x0 = __WEBPACK_IMPORTED_MODULE_4__point__["a" /* x */],
      x1 = null,
      y0 = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      y1 = __WEBPACK_IMPORTED_MODULE_4__point__["b" /* y */],
      defined = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(true),
      context = null,
      curve = __WEBPACK_IMPORTED_MODULE_2__curve_linear__["a" /* default */],
      output = null;

  function area(data) {
    var i,
        j,
        k,
        n = data.length,
        d,
        defined0 = false,
        buffer,
        x0z = new Array(n),
        y0z = new Array(n);

    if (context == null) output = curve(buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])());

    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }

    if (buffer) return output = null, buffer + "" || null;
  }

  function arealine() {
    return Object(__WEBPACK_IMPORTED_MODULE_3__line__["a" /* default */])().defined(defined).curve(curve).context(context);
  }

  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), x1 = null, area) : x0;
  };

  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x0;
  };

  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : x1;
  };

  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), y1 = null, area) : y0;
  };

  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y0;
  };

  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), area) : y1;
  };

  area.lineX0 =
  area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };

  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };

  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };

  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(!!_), area) : defined;
  };

  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };

  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };

  return area;
});


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return curveRadialLinear; });
/* harmony export (immutable) */ __webpack_exports__["b"] = curveRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(291);


var curveRadialLinear = curveRadial(__WEBPACK_IMPORTED_MODULE_0__linear__["a" /* default */]);

function Radial(curve) {
  this._curve = curve;
}

Radial.prototype = {
  areaStart: function() {
    this._curve.areaStart();
  },
  areaEnd: function() {
    this._curve.areaEnd();
  },
  lineStart: function() {
    this._curve.lineStart();
  },
  lineEnd: function() {
    this._curve.lineEnd();
  },
  point: function(a, r) {
    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
  }
};

function curveRadial(curve) {

  function radial(context) {
    return new Radial(curve(context));
  }

  radial._curve = curve;

  return radial;
}


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lineRadial;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__line__ = __webpack_require__(455);



function lineRadial(l) {
  var c = l.curve;

  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;

  l.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return l;
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return lineRadial(Object(__WEBPACK_IMPORTED_MODULE_1__line__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]));
});


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x, y) {
  return [(y = +y) * Math.cos(x -= Math.PI / 2), y * Math.sin(x)];
});


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return slice; });
var slice = Array.prototype.slice;


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(215);


/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */]);
    context.moveTo(r, 0);
    context.arc(0, 0, r, 0, __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */]);
  }
});


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / 5) / 2;
    context.moveTo(-3 * r, -r);
    context.lineTo(-r, -r);
    context.lineTo(-r, -3 * r);
    context.lineTo(r, -3 * r);
    context.lineTo(r, -r);
    context.lineTo(3 * r, -r);
    context.lineTo(3 * r, r);
    context.lineTo(r, r);
    context.lineTo(r, 3 * r);
    context.lineTo(-r, 3 * r);
    context.lineTo(-r, r);
    context.lineTo(-3 * r, r);
    context.closePath();
  }
});


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tan30 = Math.sqrt(1 / 3),
    tan30_2 = tan30 * 2;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = Math.sqrt(size / tan30_2),
        x = y * tan30;
    context.moveTo(0, -y);
    context.lineTo(x, 0);
    context.lineTo(0, y);
    context.lineTo(-x, 0);
    context.closePath();
  }
});


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math__ = __webpack_require__(215);


var ka = 0.89081309152928522810,
    kr = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10) / Math.sin(7 * __WEBPACK_IMPORTED_MODULE_0__math__["j" /* pi */] / 10),
    kx = Math.sin(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr,
    ky = -Math.cos(__WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] / 10) * kr;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size * ka),
        x = kx * r,
        y = ky * r;
    context.moveTo(0, -r);
    context.lineTo(x, y);
    for (var i = 1; i < 5; ++i) {
      var a = __WEBPACK_IMPORTED_MODULE_0__math__["m" /* tau */] * i / 5,
          c = Math.cos(a),
          s = Math.sin(a);
      context.lineTo(s * r, -c * r);
      context.lineTo(c * x - s * y, s * x + c * y);
    }
    context.closePath();
  }
});


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var w = Math.sqrt(size),
        x = -w / 2;
    context.rect(x, x, w, w);
  }
});


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var sqrt3 = Math.sqrt(3);

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var y = -Math.sqrt(size / (sqrt3 * 3));
    context.moveTo(0, y * 2);
    context.lineTo(-sqrt3 * y, -y);
    context.lineTo(sqrt3 * y, -y);
    context.closePath();
  }
});


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var c = -0.5,
    s = Math.sqrt(3) / 2,
    k = 1 / Math.sqrt(12),
    a = (k / 2 + 1) * 3;

/* harmony default export */ __webpack_exports__["a"] = ({
  draw: function(context, size) {
    var r = Math.sqrt(size / a),
        x0 = r / 2,
        y0 = r * k,
        x1 = x0,
        y1 = r * k + r,
        x2 = -x1,
        y2 = y1;
    context.moveTo(x0, y0);
    context.lineTo(x1, y1);
    context.lineTo(x2, y2);
    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
    context.closePath();
  }
});


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalClosed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cardinal__ = __webpack_require__(294);



function CardinalClosed(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalClosed(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CardinalOpen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinal__ = __webpack_require__(294);


function CardinalOpen(context, tension) {
  this._context = context;
  this._k = (1 - tension) / 6;
}

CardinalOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__cardinal__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(tension) {

  function cardinal(context) {
    return new CardinalOpen(context, tension);
  }

  cardinal.tension = function(tension) {
    return custom(+tension);
  };

  return cardinal;
})(0));


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tournaments_Api__ = __webpack_require__(14);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  flex-grow: 1;\n  flex-shrink: 1;\n  align-self: stretch;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-weight: 300;\n  color: ",";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  opacity: 0.1;\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  flex-grow: 1;\n  flex-shrink: 1;\n  align-self: stretch;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-weight: 300;\n  color: ",";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  opacity: 0.1;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  font-size: ","px;\n  letter-spacing: 5px;\n\n  ",";\n"],["\n  font-size: ","px;\n  letter-spacing: 5px;\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      font-size: 92.5px;\n      letter-spacing: 2px;\n      text-size-adjust: 100%;\n\n      @media (max-width: 578px) {\n        font-size: 75px;\n      }\n\n      @media (max-width: 320px) {\n        font-size: 60px;\n      }\n    "],["\n      font-size: 92.5px;\n      letter-spacing: 2px;\n      text-size-adjust: 100%;\n\n      @media (max-width: 578px) {\n        font-size: 75px;\n      }\n\n      @media (max-width: 320px) {\n        font-size: 60px;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral([""],[""]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"],["\n  font-weight: 700;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: 70px;\n\n  @media (max-width: 959px) {\n    font-size: 42px;\n  }\n\n  ",", "," {\n    margin-top: 0.715em;\n\n    @media (max-width: 959px) {\n      margin-top: 0.25em;\n    }\n  }\n"],["\n  font-size: 70px;\n\n  @media (max-width: 959px) {\n    font-size: 42px;\n  }\n\n  ",", "," {\n    margin-top: 0.715em;\n\n    @media (max-width: 959px) {\n      margin-top: 0.25em;\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Div=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.ticksFontColor;});var Watermark=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Div)(_templateObject2,function(props){return props.size||150;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject3);});var Stock=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject5);var TournamentWatermark=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Div)(_templateObject6,Stock,Title);function ActiveStock(_ref){var mobile=_ref.mobile,children=_ref.children,tradeMode=_ref.tradeMode,active_tournament=_ref.active_tournament;if(tradeMode==="tournament"&&active_tournament!=null&&active_tournament.value!=null){var tournament=active_tournament.value;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TournamentWatermark,{mobile:mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icons_Tournaments__["e" /* Cup */],{width:"48px"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,tournament.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Stock,null,children));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Watermark,{mobile:mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Stock,null,children));}var mapStateToProps=function mapStateToProps(state){return{tradeMode:state.settings.mode};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Tournaments_Api__["a" /* ActiveTournament */],null,function(active_tournament){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActiveStock,Object.assign({active_tournament:active_tournament},props));});}));

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextGenChartTypes__ = __webpack_require__(45);
var THICKNESS=2;function Bar(props){var openY=Math.floor(props.open[1]);var closeY=Math.floor(props.close[1]);var minimumY=Math.floor(props.minimum[1]);var maximumY=Math.floor(props.maximum[1]);var top=maximumY;var height=minimumY-maximumY||1;var left=Math.floor(props.range[0]);var width=Math.floor(props.range[1])-left;var padding=width/8;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",width:width,height:height,WebkitTransform:"translateX("+left+"px) translateY("+top+"px)",transform:"translateX("+left+"px) translateY("+top+"px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{width:THICKNESS,height:height+THICKNESS,background:props.close[2].value>props.open[2].value?"#6cb032":"#e74c3c",margin:"0 auto"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",top:openY-maximumY,left:padding,width:width/2-padding,height:THICKNESS,background:props.close[2].value>props.open[2].value?"#6cb032":"#e74c3c"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"absolute",top:closeY-maximumY,left:width/2,width:width/2-padding,height:THICKNESS,background:props.close[2].value>props.open[2].value?"#6cb032":"#e74c3c"}}));}function BarChart(props){return props.candles.filter(function(candle){return candle.close[0]>0&&candle.open[0]<props.viewportWidth;}).map(function(candle){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bar,Object.assign({key:candle.open[2].date},candle));});}/* harmony default export */ __webpack_exports__["a"] = (BarChart);

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextGenChartTypes__ = __webpack_require__(45);
var MovingAverage=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 2086));});var ParabolicSAR=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 2105));});var Alligator=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 2106));});var BollingerLines=__WEBPACK_IMPORTED_MODULE_0_react__["lazy"](function(){return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 2107));});function Indicator(props){switch(props.config.type){case"Alligator":// $FlowFixMe React 16 feature
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Alligator,props);case"MovingAverage":// $FlowFixMe React 16 feature
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MovingAverage,props);case"ParabolicSAR":// $FlowFixMe React 16 feature
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ParabolicSAR,props);case"BollingerLines":// $FlowFixMe React 16 feature
return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BollingerLines,props);default:return null;}}/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:null},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Indicator,props));});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var mobile=_ref.mobile,desktop=_ref.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?//Mobile component
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,mobile)://Desktop component
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,desktop);});});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_color__ = __webpack_require__(107);
var _templateObject=_taggedTemplateLiteral(["\n  from {\n    transform: scale(1.1);\n  }\n\n  to {\n    transform: scale(0.6);\n  }\n"],["\n  from {\n    transform: scale(1.1);\n  }\n\n  to {\n    transform: scale(0.6);\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-clip: padding-box;\n  border-radius: 50%;\n  box-shadow: 0px 0px 6px 4px;\n  animation: "," 1s linear infinite alternate;\n"],["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-clip: padding-box;\n  border-radius: 50%;\n  box-shadow: 0px 0px 6px 4px;\n  animation: "," 1s linear infinite alternate;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -7px;\n  left: -7px;\n  width: 14px;\n  height: 14px;\n  background-clip: padding-box;\n  border-radius: 50%;\n  z-index: 99;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n    background-clip: padding-box;\n    border-radius: 50%;\n    box-shadow: 0px 0px 5px 3px;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  top: -7px;\n  left: -7px;\n  width: 14px;\n  height: 14px;\n  background-clip: padding-box;\n  border-radius: 50%;\n  z-index: 99;\n\n  &:after {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    width: 100%;\n    height: 100%;\n    background-color: transparent;\n    background-clip: padding-box;\n    border-radius: 50%;\n    box-shadow: 0px 0px 5px 3px;\n  }\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      top: -5px;\n      left: -5px;\n      width: 10px;\n      height: 10px;\n    "],["\n      top: -5px;\n      left: -5px;\n      width: 10px;\n      height: 10px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: inherit;\n  background-clip: padding-box;\n  border: 2px solid;\n  border-radius: 50%;\n  z-index: 100;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 50%;\n    height: 50%;\n    background-color: transparent;\n    background-clip: padding-box;\n    border: 3px solid;\n    border-radius: 50%;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: inherit;\n  background-clip: padding-box;\n  border: 2px solid;\n  border-radius: 50%;\n  z-index: 100;\n\n  &:before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 50%;\n    height: 50%;\n    background-color: transparent;\n    background-clip: padding-box;\n    border: 3px solid;\n    border-radius: 50%;\n  }\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      border: 1px solid;\n\n      &:before {\n        border: 2px solid;\n      }\n    "],["\n      border: 1px solid;\n\n      &:before {\n        border: 2px solid;\n      }\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function fade(color,alpha){color.opacity=alpha;return color.toString();}var pulse=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Shadow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,pulse);var DotView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Center=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});function Dot(_ref){var x=_ref.x,y=_ref.y,color=_ref.color,mobile=_ref.mobile,theme=_ref.theme;var bgColor=Object(__WEBPACK_IMPORTED_MODULE_2_d3_color__["a" /* color */])(theme.main);var rgbaColor=Object(__WEBPACK_IMPORTED_MODULE_2_d3_color__["a" /* color */])(color);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DotView,{style:{WebkitTransform:"translateX("+x+"px) translateY("+y+"px)",transform:"translateX("+x+"px) translateY("+y+"px)",backgroundColor:fade(bgColor,1),color:fade(bgColor,0.25)// is needed in order for boxShadow to inherit color
},mobile:mobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Shadow,{style:{backgroundColor:fade(rgbaColor,0.59),color:fade(rgbaColor,0.59)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Center,{style:{color:fade(rgbaColor,1)// is needed in order for border to inherit color
},mobile:mobile}));}/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Dot,Object.assign({},props,{theme:theme}));});});

/***/ }),
/* 771 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHYAAAB3CAYAAADW+7S0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOkJEQkEwRkZGOEYzOTExRTY4OTA0OEUxNDg3OThDNDIwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOkJEQkExMDAwOEYzOTExRTY4OTA0OEUxNDg3OThDNDIwIj4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6QkRCQTBGRkQ4RjM5MTFFNjg5MDQ4RTE0ODc5OEM0MjAiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6QkRCQTBGRkU4RjM5MTFFNjg5MDQ4RTE0ODc5OEM0MjAiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz7DZjIyAAABi0lEQVR42uzYuwlCURBFUT+tGNl/GS8W7EYDAy1gGNysDSaGb8EdOOfjOE6f7u/f4/Sb//70v/MXrEJd3r+rz9CEvfkMTdinz9CEFViB1Trs3Wdowj58Bk+xwGob1vIUhbU8RWEtT26swAqsZmAtT1FYy5OnWGC1Dmt5isJanqKwlic3VmAFVjOwlqcorOXJUyywWoe1PEVhLU9RWMuTGyuwAqsZWMtTFNby5CkWWK3DWp6isJanKKzlyY0VWIHVDKzlKQprefIUC6zWYS1PUVjLUxTW8uTGCqzAagbW8hSFtTx5igVW67CWpyis5SkKa3lyYwVWYDUDa3mKwlqePMUCq3VYy1MU1vIUhbU8ubECK7CagbU8RWEtT55igdU6rOUpCmt5isJantxYgRVYzcBanqKwlidPscBqHdbyFIW1PEVhLU9urMAKrGZgLU9RWMuTp1hgtQ5reYrCWp6isJYnN1ZgBVYzsJanKKzlyVMssFqHtTxFYS1PUVjLkxsrsAKrGVjLU7CXAAMAXdE0Cawr4RQAAAAASUVORK5CYII="

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Layers__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -84px;\n  right: 0;\n  width: 42px;\n  height: 100%;\n  padding-bottom: 84px;\n  box-sizing: content-box;\n  z-index: ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: -84px;\n  right: 0;\n  width: 42px;\n  height: 100%;\n  padding-bottom: 84px;\n  box-sizing: content-box;\n  z-index: ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      right: auto;\n      left: 0;\n      top: 24px;\n      height: calc(100% - 24px);\n      padding-bottom: 0;\n    "],["\n      right: auto;\n      left: 0;\n      top: 24px;\n      height: calc(100% - 24px);\n      padding-bottom: 0;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  \n  ",";\n"],["\n  position: absolute;\n  right: 0;\n  height: 100%;\n  width: 100%;\n  \n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n    right: auto;\n    left: 0;\n  "],["\n    right: auto;\n    left: 0;\n  "]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  transform: translateY(-7px);\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n\n  ",";\n"],["\n  position: absolute;\n  left: 0;\n  transform: translateY(-7px);\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      right: auto;\n      left: 5px;\n      transform: translateY(-13.5px);\n      padding: 2px;\n      font-size: ",";\n      background-color: ",";\n      border-radius: 2px;\n    "],["\n      right: auto;\n      left: 5px;\n      transform: translateY(-13.5px);\n      padding: 2px;\n      font-size: ",";\n      background-color: ",";\n      border-radius: 2px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      display: block;\n      text-align: center;\n    "],["\n      display: block;\n      text-align: center;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n      display: block;\n      margin: 1px 0;\n      border-bottom: 1px solid ",";\n    "],["\n      display: block;\n      margin: 1px 0;\n      border-bottom: 1px solid ",";\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 3px;\n  height: 100%;\n  background-color: ",";\n  \n  ",";\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 3px;\n  height: 100%;\n  background-color: ",";\n  \n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  width: 3px;\n  height: 50%;\n  background-color: ",";\n  border-bottom: 1px solid ",";\n"],["\n  width: 3px;\n  height: 50%;\n  background-color: ",";\n  border-bottom: 1px solid ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,__WEBPACK_IMPORTED_MODULE_3__Layers__["a" /* default */].SENTIMENTS,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var ContainerCell=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var mobile=_ref.mobile;return mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(13,13),function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.foreground,0.5);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(10,10),function(props){return props.theme.mainDark;});});var UpDown=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var UpText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(UpDown)(_templateObject9,function(_ref3){var theme=_ref3.theme;return theme.upper;});var DownText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(UpDown)(_templateObject9,function(_ref4){var theme=_ref4.theme;return theme.lower;});var Divider=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10,function(_ref5){var theme=_ref5.theme;return theme.background;});});var BarContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,function(_ref6){var theme=_ref6.theme;return theme.upper;},function(_ref7){var mobile=_ref7.mobile;return mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Bar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(_ref8){var theme=_ref8.theme;return theme.lower;},function(_ref9){var theme=_ref9.theme;return theme.main;});function Sentiments(props){var up=Math.round(props.positive*1e5)/10e2;var down=100-up;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerCell,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,{style:{top:down+"%"},mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DownText,{mobile:props.mobile},Math.round(down)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Divider,{mobile:props.mobile},!props.mobile?"/":null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UpText,{mobile:props.mobile},Math.round(up))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BarContainer,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bar,{style:{height:down+"%"}}))));}var AnimatedSentiments=function(_Component){_inherits(AnimatedSentiments,_Component);function AnimatedSentiments(){_classCallCheck(this,AnimatedSentiments);return _possibleConstructorReturn(this,(AnimatedSentiments.__proto__||Object.getPrototypeOf(AnimatedSentiments)).apply(this,arguments));}_createClass(AnimatedSentiments,[{key:"render",value:function render(){var _this2=this;var stats=this.props.stats;// если stats отсутствует,
// проставляем 0.5 (=50%)
var positive=(typeof stats==="undefined"?"undefined":_typeof(stats))!=="object"?0.5:(stats.upper+1)/(stats.upper+stats.lower+2);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_motion__["Motion"],{style:{positive:Object(__WEBPACK_IMPORTED_MODULE_2_react_motion__["spring"])(positive)}},function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sentiments,Object.assign({positive:props.positive},_this2.props));});}}]);return AnimatedSentiments;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AnimatedSentiments);

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TheClock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_scale__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradeModals_IntervalsModal__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__redux_reducer_stocks__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TradeModals_TradeIsClosing__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Toolbar_Icons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GA__ = __webpack_require__(11);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  height: 30px;\n  margin-bottom: 10px;\n\n  @media (min-width: 960px) {\n    padding-left: 25px;\n  }\n\n  @media (max-width: 959px) {\n    position: relative;\n    height: 26px;\n    margin-left: 16px;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  height: 30px;\n  margin-bottom: 10px;\n\n  @media (min-width: 960px) {\n    padding-left: 25px;\n  }\n\n  @media (max-width: 959px) {\n    position: relative;\n    height: 26px;\n    margin-left: 16px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  justify-content: center;\n"],["\n  width: 100%;\n  min-width: 0;\n  display: flex;\n  justify-content: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 92px;\n  min-width: 92px;\n  margin-left: 10px;\n  display: flex;\n  justify-content: center;\n\n  > button {\n    width: 30px;\n    min-width: 30px;\n    margin-left: 1px;\n    font-size: 0;\n    line-height: 0;\n\n    :first-of-type {\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: 959px) {\n    width: auto;\n    min-width: auto;\n    margin-left: 4px;\n  }\n"],["\n  width: 92px;\n  min-width: 92px;\n  margin-left: 10px;\n  display: flex;\n  justify-content: center;\n\n  > button {\n    width: 30px;\n    min-width: 30px;\n    margin-left: 1px;\n    font-size: 0;\n    line-height: 0;\n\n    :first-of-type {\n      margin-left: 0;\n    }\n  }\n\n  @media (max-width: 959px) {\n    width: auto;\n    min-width: auto;\n    margin-left: 4px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 100%;\n  min-width: 0;\n  padding: 0 5px;\n  font-size: ",";\n  font-weight: bold;\n  color: ",";\n  background-color: ",";\n  white-space: nowrap;\n  border: none;\n  cursor: pointer;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  :first-of-type {\n    border-radius: 4px 0 0 4px;\n  }\n\n  :last-of-type {\n    border-radius: 0 4px 4px 0;\n  }\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    ",";\n\n    ",";\n\n    ",";\n  }\n"],["\n  width: 100%;\n  min-width: 0;\n  padding: 0 5px;\n  font-size: ",";\n  font-weight: bold;\n  color: ",";\n  background-color: ",";\n  white-space: nowrap;\n  border: none;\n  cursor: pointer;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  :first-of-type {\n    border-radius: 4px 0 0 4px;\n  }\n\n  :last-of-type {\n    border-radius: 0 4px 4px 0;\n  }\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    ",";\n\n    ",";\n\n    ",";\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-left: 12px;\n      padding-right: 8px;\n      font-weight: 400;\n      text-transform: none;\n      border-radius: 4px !important;\n    "],["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      padding-left: 12px;\n      padding-right: 8px;\n      font-weight: 400;\n      text-transform: none;\n      border-radius: 4px !important;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-right: 4px;\n      padding-left: 6px;\n      padding-right: 8px;\n      font-weight: 400;\n      font-size: ",";\n      text-transform: none;\n      border-radius: 4px !important;\n    "],["\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-right: 4px;\n      padding-left: 6px;\n      padding-right: 8px;\n      font-weight: 400;\n      font-size: ",";\n      text-transform: none;\n      border-radius: 4px !important;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      color: #ffffff;\n      background-color: ",";\n      &:hover {\n        color: #ffffff;\n      }\n    "],["\n      color: #ffffff;\n      background-color: ",";\n      &:hover {\n        color: #ffffff;\n      }\n    "]),_templateObject8=_taggedTemplateLiteral(["\n        position: absolute;\n        top: -41px;\n        left: 0;\n        width: 26px;\n        height: 26px;\n        border-radius: 4px !important;\n        z-index: 10;\n      "],["\n        position: absolute;\n        top: -41px;\n        left: 0;\n        width: 26px;\n        height: 26px;\n        border-radius: 4px !important;\n        z-index: 10;\n      "]),_templateObject9=_taggedTemplateLiteral(["\n        position: absolute;\n        top: -41px;\n        right: 16px;\n        width: 26px;\n        height: 26px;\n        border-radius: 4px !important;\n        z-index: 10;\n      "],["\n        position: absolute;\n        top: -41px;\n        right: 16px;\n        width: 26px;\n        height: 26px;\n        border-radius: 4px !important;\n        z-index: 10;\n      "]),_templateObject10=_taggedTemplateLiteral(["\n        border-radius: 4px !important;\n      "],["\n        border-radius: 4px !important;\n      "]),_templateObject11=_taggedTemplateLiteral(["\n  width: 25px;\n  min-width: 25px;\n  align-self: center;\n  margin-left: 5px;\n  font-size: 16px;\n\n  @media (max-width: 959px) {\n    margin-left: 2px;\n    margin-right: 1px;\n    width: 13px;\n    min-width: 13px;\n    font-size: ",";\n  }\n"],["\n  width: 25px;\n  min-width: 25px;\n  align-self: center;\n  margin-left: 5px;\n  font-size: 16px;\n\n  @media (max-width: 959px) {\n    margin-left: 2px;\n    margin-right: 1px;\n    width: 13px;\n    min-width: 13px;\n    font-size: ",";\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  margin-left: 10px;\n  min-width: 120px;\n\n  @media (max-width: 959px) {\n    margin-left: 0;\n    min-width: auto;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  margin-left: 10px;\n  min-width: 120px;\n\n  @media (max-width: 959px) {\n    margin-left: 0;\n    min-width: auto;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-right: 5px;\n"],["\n  margin-right: 5px;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  margin-left: 5px;\n  font-size: 0;\n  line-height: 0;\n  transform-origin: 50% 50%;\n  transition: transform 0.15s linear;\n\n  ",";\n"],["\n  margin-left: 5px;\n  font-size: 0;\n  line-height: 0;\n  transform-origin: 50% 50%;\n  transition: transform 0.15s linear;\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n      transform: rotate(180deg);\n    "],["\n      transform: rotate(180deg);\n    "]),_templateObject16=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  bottom: 100%;\n  transform: translateY(-10px);\n  padding: 0 8px;\n  font-size: ",";\n  background-color: ",";\n  color: ",";\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n  pointer-events: none;\n\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 9px;\n    border: 7px solid transparent;\n    border-top: 7px solid ",";\n    border-bottom: none;\n  }\n"],["\n  position: absolute;\n  left: 0;\n  bottom: 100%;\n  transform: translateY(-10px);\n  padding: 0 8px;\n  font-size: ",";\n  background-color: ",";\n  color: ",";\n  border-radius: 4px;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  z-index: -1;\n  pointer-events: none;\n\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 100%;\n    left: 9px;\n    border: 7px solid transparent;\n    border-top: 7px solid ",";\n    border-bottom: none;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  margin-right: 10px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 27px;\n  white-space: nowrap;\n  transform: translateZ(0);\n  z-index: 5;\n\n  @media (max-width: 959px) {\n    color: ",";\n    margin-right: 4px;\n  }\n\n  ",";\n\n  &:hover "," {\n    opacity: 1;\n    z-index: 1;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  margin-right: 10px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 27px;\n  white-space: nowrap;\n  transform: translateZ(0);\n  z-index: 5;\n\n  @media (max-width: 959px) {\n    color: ",";\n    margin-right: 4px;\n  }\n\n  ",";\n\n  &:hover "," {\n    opacity: 1;\n    z-index: 1;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n      position: absolute;\n      left: 27px;\n      bottom: 12px;\n\n      @media (max-width: 959px) {\n        left: 12px;\n      }\n    "],["\n      position: absolute;\n      left: 27px;\n      bottom: 12px;\n\n      @media (max-width: 959px) {\n        left: 12px;\n      }\n    "]),_templateObject19=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 8px;\n  text-transform: none;\n  font-weight: 400;\n  color: ",";\n  border-radius: 4px !important;\n  cursor: default;\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    padding: 0 7px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 8px;\n  text-transform: none;\n  font-weight: 400;\n  color: ",";\n  border-radius: 4px !important;\n  cursor: default;\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    padding: 0 7px;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["\n      background-color: ",";\n    "],["\n      background-color: ",";\n    "]),_templateObject21=_taggedTemplateLiteral(["\n      color: ",";\n      background-color: ",";\n\n      &:hover {\n        color: ",";\n      }\n    "],["\n      color: ",";\n      background-color: ",";\n\n      &:hover {\n        color: ",";\n      }\n    "]),_templateObject22=_taggedTemplateLiteral(["\n  margin-right: 7px;\n  font-size: 0;\n  line-height: 0;\n  color: ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  margin-right: 7px;\n  font-size: 0;\n  line-height: 0;\n  color: ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var TimeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var ControlsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(14,14),function(_ref){var theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_11_polished__["a" /* rgba */])(theme.foreground,0.5);},Object(__WEBPACK_IMPORTED_MODULE_11_polished__["a" /* rgba */])("#919191",0.59),Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(10,10),function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(props){return props.candle&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.candleMobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(12));},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,function(_ref3){var theme=_ref3.theme;return theme.bottomNavigationBg;});},function(props){return props.minus&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);},function(props){return props.plus&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);},function(props){return props.now&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);});var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(12));var CandleButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var CandleImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var ArrowImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject15);});var ClockText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_11_polished__["a" /* rgba */])("#919191",0.59),function(_ref4){var theme=_ref4.theme;return theme.foreground;},Object(__WEBPACK_IMPORTED_MODULE_11_polished__["a" /* rgba */])("#919191",0.59));var ClockContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(10),function(_ref5){var theme=_ref5.theme;return theme.foreground;},function(props){return props.oldClock&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject18);},ClockText);var Clock=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Button)(_templateObject19,function(_ref6){var theme=_ref6.theme;return theme.foreground;},function(props){return props.oldClock&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject20,function(props){return props.theme.ticksFontColor;});},function(props){return props.timeOtc&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject21,function(_ref7){var theme=_ref7.theme;return theme.chartTimeOtcColor;},function(_ref8){var theme=_ref8.theme;return theme.accent;},function(_ref9){var theme=_ref9.theme;return theme.chartTimeOtcColor;});},Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["a" /* fontSize */])(12));var ClockIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22,function(_ref10){var theme=_ref10.theme;return Object(__WEBPACK_IMPORTED_MODULE_11_polished__["a" /* rgba */])(theme.foreground,0.4);},function(props){return props.timeOtc&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject23,function(_ref11){var theme=_ref11.theme;return theme.chartTimeOtcColor;});});function TheClock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClockContainer,{oldClock:props.oldClock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Clock,{as:"div",timeOtc:props.otc,oldClock:props.oldClock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClockIcon,{timeOtc:props.otc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"-5651.999 5637.688 15.997 20.001",width:"16",height:"20",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M1238-12037.673a7.953,7.953,0,0,1,2.35-5.649l-.9-1.264a.493.493,0,0,1,.118-.692l1.318-.932a.5.5,0,0,1,.7.118l.889,1.252a7.939,7.939,0,0,1,2.262-.717v-.514a.6.6,0,0,0-.6-.6h-.33a.6.6,0,0,1-.6-.6v-1.823a.6.6,0,0,1,.6-.6h4.385a.6.6,0,0,1,.6.6v1.823a.6.6,0,0,1-.6.6h-.33a.6.6,0,0,0-.6.6v.514a7.854,7.854,0,0,1,2.12.65l.9-1.268a.5.5,0,0,1,.7-.117l1.318.934a.5.5,0,0,1,.121.693l-.877,1.233a7.948,7.948,0,0,1,2.462,5.758,8,8,0,0,1-8,7.983A8,8,0,0,1,1238-12037.673Zm1.92,0a6.078,6.078,0,0,0,6.078,6.066,6.081,6.081,0,0,0,6.081-6.066,6.083,6.083,0,0,0-6.081-6.069A6.081,6.081,0,0,0,1239.922-12037.673Zm6.039-.042v-4.96l.039,0a5.016,5.016,0,0,1,5.014,4.963Z",transform:"translate(-6890 17687.379)"}))),Object(__WEBPACK_IMPORTED_MODULE_9__TradeModals_TradeIsClosing__["b" /* formatTimeInterval */])(props.children)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ClockText,{timeOtc:props.otc,oldClock:props.oldClock},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"left till the market closure"));}}));}});}function DesktopCandleIntervalPicker(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CandleButton,null,props.active&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TradeModals_IntervalsModal__["b" /* default */],{value:props.value,onChange:props.onChange,onToggle:props.onToggle,stock:props.stock}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{candle:true,active:props.active,onClick:props.onToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CandleImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Toolbar_Icons__["y" /* Timer */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TradeModals_IntervalsModal__["a" /* HumanInterval */],null,__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["o" /* stringifyTime */](props.value)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowImage,{active:props.active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 9.8 6.295",fill:"currentColor",width:"9.8",height:"6.3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5,.328l4.9,4.9-1.4,1.4L5,3.119l-3.5,3.5L.1,5.219,4.986.328,5,.337Z"})))));}function MobileCandleIntervalPicker(props){var MemoCandleButton=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CandleButton,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{candleMobile:true,active:props.active,onClick:props.onToggle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CandleImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Toolbar_Icons__["y" /* Timer */],null)),__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["o" /* stringifyTime */](props.value),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowImage,{active:props.active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 9.8 6.295",fill:"currentColor",width:"9.8",height:"6.3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5,.328l4.9,4.9-1.4,1.4L5,3.119l-3.5,3.5L.1,5.219,4.986.328,5,.337Z"})))));},[props.active,props.onToggle,props.value]);return MemoCandleButton;}var ChartBottomNavigation=function ChartBottomNavigation(props){// Возможность зума ограничена текущим выбранным интервалом свечей. Мы рассчи-
// тываем показать пять вариантов масштаба на выбор, но на некоторых интерва-
// лах количество кнопок придётся уменьшить.
var timeSpanRange=__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["l" /* getTimeSpanRange */](props.stock,props.interval);var candleTimeSpans=[props.interval*10,props.interval*20,props.interval*50,props.interval*75,props.interval*100].filter(function(t){return t>=timeSpanRange[0]&&t<=timeSpanRange[1];});var timeSpans=props.chartType==="line"?__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["m" /* isShortHistoryStock */](props.stock)?["2m","10m","20m","45m","1h","2h"].map(__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["n" /* parseTime */]):["2m","1h","4h","1D","1W","1M"].map(__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["n" /* parseTime */]):candleTimeSpans;// Если тебе всегда хотелось узнать, как выглядит оверинжениринг,
// то вот он. Здесь мы используем d3.scaleThreshold() для того,
// чтобы выбитать наиболее близкий к произвольному значению зум
// из списка предустановленнызх значений!
// range это просто список индексов, но т.к. наш набор отсортиро-
// ван в обратную сторону, мы его разворачиваем.
// domain это набор из N-1 зачения зумов. Каждое значение это среднее
// арифметическое меджду двумя соседними зумами.
// Такие дела.
var approximateTimeSpan=Object(__WEBPACK_IMPORTED_MODULE_2_d3_scale__["b" /* scaleThreshold */])().domain(timeSpans.reduce(function(acc,item,index,input){if(index<input.length-1){acc.push((item+input[index+1])/2);}return acc;},[])).range(timeSpans.map(function(item,index){return index;}));var activeTimeSpanIndex=approximateTimeSpan(props.timeSpan);var timeUntilToggle=Object(__WEBPACK_IMPORTED_MODULE_8__redux_reducer_stocks__["b" /* getTimeUntilNextLockToggle */])(props.now,props.stock);var memoDesktopCandleIntervalPicker=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesktopCandleIntervalPicker,{active:props.isShownCandleModal,onToggle:props.toggleCandleModal,value:props.interval,onChange:props.onIntervalChange,stock:props.stock});},[props.isShownCandleModal,props.toggleCandleModal,props.interval,props.onIntervalChange,props.stock]);var memoGAMinus=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_TIME_MINUS",{stock:props.stock.stock});props.onTimeSpanChange(function(prev){return{timeSpan:prev.timeSpan*1.5,animateTimeSpan:true};});},[props.stock,props.onTimeSpanChange]);var memoGAPlus=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_TIME_PLUS",{stock:props.stock.stock});props.onTimeSpanChange(function(prev){return{timeSpan:prev.timeSpan/1.5,animateTimeSpan:true};});},[props.stock,props.onTimeSpanChange]);var memoGATimeNow=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_TIME_NOW",{stock:props.stock.stock});props.onBackToReality();},[props.stock,props.onBackToReality]);var memoScaleButtons=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ControlsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:memoGAMinus,minus:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 12 2",width:"12",height:"2",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{width:"12",height:"2"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:memoGAPlus,plus:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 12 12",width:"12",height:"12",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5,12V7H0V5H5V0H7V5h5V7H7v5Z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:memoGATimeNow,now:true,title:"Go back to now"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 18 18",width:"18",height:"18",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8,18V15.929A7.017,7.017,0,0,1,2.071,10H0V8H2.071A7.017,7.017,0,0,1,8,2.071V0h2V2.071A7.017,7.017,0,0,1,15.929,8H18v2H15.929A7.017,7.017,0,0,1,10,15.929V18Zm0-3.084V12h2v2.916A6.015,6.015,0,0,0,14.916,10H12V8h2.916A6.016,6.016,0,0,0,10,3.083V6H8V3.083A6.017,6.017,0,0,0,3.083,8H6v2H3.083A6.016,6.016,0,0,0,8,14.916ZM8,9a1,1,0,1,1,1,1A1,1,0,0,1,8,9Z"}))));},[memoGAMinus,memoGAPlus,memoGATimeNow]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,props.chartType!=="line"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileCandleIntervalPicker,{active:props.isShownCandleModal,onToggle:props.toggleCandleModal,value:props.interval,onChange:props.onIntervalChange,stock:props.stock});}}),props.social,timeUntilToggle<1000*60*60*12&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TheClock,{otc:props.stock.otc,oldClock:false},timeUntilToggle),props.chartType==="line"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TimeContainer,null,[].concat(_toConsumableArray(timeSpans)).reverse().map(function(item,index,spans){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{key:item,active:index===spans.length-1-activeTimeSpanIndex,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_CHART_TIME",{buttonText:e.currentTarget.textContent,stock:props.stock.stock});props.onTimeSpanChange(function(){return{timeSpan:item,animateTimeSpan:true};});}},index===0?__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["o" /* stringifyTime */](Math.max(item,props.timeSpan)):index===spans.length-1?__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["o" /* stringifyTime */](Math.min(item,props.timeSpan)):__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["o" /* stringifyTime */](item));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TimeContainer,null,[].concat(_toConsumableArray(timeSpans)).reverse().map(function(timeSpan,index,set){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{key:index,active:activeTimeSpanIndex===set.length-1-index,onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_CHART_TIME",{buttonText:e.currentTarget.textContent,stock:props.stock.stock});props.onTimeSpanChange(function(){return{timeSpan:timeSpan,animateTimeSpan:true};});}},__WEBPACK_IMPORTED_MODULE_6__NextGenChartMath__["o" /* stringifyTime */](timeSpan));})),props.chartType!=="line"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 960px)",render:memoDesktopCandleIntervalPicker}),memoScaleButtons,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpinnerContainer,null,props.loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Spinners_SimpleSpinner__["c" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (ChartBottomNavigation);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  color: ",";\n"],["\n  direction: ",";\n  font-size: ",";\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.direction;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.foreground;});function Profit(props){var activeStock=props.stocks[props.tabs.tabs[props.tabs.activeTab]];var activeAccount=props.accounts.find(function(account){return account.id===props.profile.active_account_id;});var percent=null;if(activeAccount){percent=activeAccount.type==="real"?activeStock.realProfit:activeStock.demoProfit;if(props.tradeMode==="tournament"){percent=activeStock.realProfit-activeStock.profit_vip;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Profit: ",percent),"%");}function mapStateToProps(state){return{tradeMode:state.settings.mode,tabs:state.tabs,stocks:state.stocks};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__withData__["a" /* default */])(["accounts","profile"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Profit)));

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var SocialTrading=function SocialTrading(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"21.334",height:"16",viewBox:"0 0 21.334 16"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10.667,43.812c1.87,0,3.325-1.94,3.325-3.947v-.629a3.326,3.326,0,1,0-6.649,0v.629C7.342,41.872,8.8,43.812,10.667,43.812Zm-6.661.649a2.28,2.28,0,0,0,2-2.133V41.261a2,2,0,1,0-4,0v1.067A2.3,2.3,0,0,0,4.006,44.461Zm11.971,2.667c0-.01,0-.02-.005-.031a2.571,2.571,0,0,0-.073-.369,0,0,0,0,0,0,0,2.281,2.281,0,0,0-.364-.745h0a4.282,4.282,0,0,0-1.431-1.2,1.578,1.578,0,0,0-.77-.306c-.368,0-.689.286-1.229.782h0l-.492.452c-.018.017-.548.766-.945.766s-.927-.749-.945-.766l-.492-.452h0c-.541-.5-.861-.782-1.229-.782a1.446,1.446,0,0,0-.77.306,5.011,5.011,0,0,0-1.43,1.2h0l0,0a2.281,2.281,0,0,0-.36.74l0,.007a2.641,2.641,0,0,0-.072.365c0,.012,0,.022-.005.034a3.7,3.7,0,0,0-.023.407c0,.016,0,2.92,0,2.933,0,.948.357,1.333,1.333,1.333h8c.984,0,1.333-.365,1.333-1.333,0-.014,0-2.918,0-2.933A3.75,3.75,0,0,0,15.977,47.129Zm1.362-2.667a2.28,2.28,0,0,0,2-2.133V41.261a2,2,0,1,0-4,0v1.067A2.3,2.3,0,0,0,17.34,44.461ZM1.517,45.905A2.885,2.885,0,0,0,0,48.47c0,.011,0,1.323,0,1.333,0,.968.325,1.333,1.333,1.333H4v-4l-.667-.667C2.628,45.848,2.034,45.611,1.517,45.905ZM4,47.136c.015.013,0-.317,0,0ZM21.334,48.47a2.885,2.885,0,0,0-1.517-2.565c-.517-.294-1.111-.057-1.817.565l-.667.667v4H20c1.008,0,1.333-.366,1.333-1.333C21.335,49.793,21.334,48.481,21.334,48.47Zm-4-1.333c0-.317-.015.013,0,0Z",transform:"translate(0 -35.803)",fill:"currentColor"}));};/* harmony default export */ __webpack_exports__["a"] = (SocialTrading);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Social__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Flags__ = __webpack_require__(1997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_fetch__ = __webpack_require__(9);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: 46px;\n  background-color: ",";\n  border-bottom: 1px solid transparent;\n  overflow: hidden;\n  cursor: pointer;\n\n  &:not(:last-of-type) {\n    border-bottom-color: ",";\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: 46px;\n  background-color: ",";\n  border-bottom: 1px solid transparent;\n  overflow: hidden;\n  cursor: pointer;\n\n  &:not(:last-of-type) {\n    border-bottom-color: ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  flex: 1;\n  font-size: 12px;\n  color: ",";\n  text-transform: uppercase;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  flex: 1;\n  font-size: 12px;\n  color: ",";\n  text-transform: uppercase;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  width: 28px;\n  height: 28px;\n  ",";\n  color: ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  width: 28px;\n  height: 28px;\n  ",";\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  flex: 0;\n  width: 7px;\n  height: 6px;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n\n  ",";\n"],["\n  flex: 0;\n  width: 7px;\n  height: 6px;\n  border-left: 3px solid transparent;\n  border-right: 3px solid transparent;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n          border-bottom: 7px solid ",";\n        "],["\n          border-bottom: 7px solid ",";\n        "]),_templateObject7=_taggedTemplateLiteral(["\n          border-top: 7px solid ",";\n        "],["\n          border-top: 7px solid ",";\n        "]),_templateObject8=_taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #99959d;\n"],["\n  font-size: 12px;\n  color: #99959d;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  width: 100%;\n  font-weight: 700;\n  font-size: 12px;\n  ",";\n  color: ",";\n"],["\n  width: 100%;\n  font-weight: 700;\n  font-size: 12px;\n  ",";\n  color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: relative;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 15px;\n  padding-top: 45px;\n  font-size: ",";\n  color: ",";\n  overflow-y: hidden;\n"],["\n  position: relative;\n  align-self: stretch;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 100%;\n  padding: 15px;\n  padding-top: 45px;\n  font-size: ",";\n  color: ",";\n  overflow-y: hidden;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Item=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.main;},function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.foreground,0.2);});var Stock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,function(_ref3){var theme=_ref3.theme;return theme.foreground;});var FlagsContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("margin-right","6px"),function(_ref4){var theme=_ref4.theme;return theme.mainDark;});var Title=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("margin-right","6px"));var BidType=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5,function(_ref5){var isBidUp=_ref5.isBidUp,theme=_ref5.theme;return isBidUp===true?Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject6,theme.upper):Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7,theme.lower);});var TraderID=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject8);var MoneyContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("text-align","right"),function(_ref6){var theme=_ref6.theme,isPositive=_ref6.isPositive;switch(isPositive){case 1:return theme.upper;case-1:return theme.lower;case 0:default:return theme.foreground;}});var Placeholder=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14),function(_ref7){var theme=_ref7.theme;return theme.foreground;});var SocialItem=function SocialItem(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Social__["a" /* TableItem */],{column:"assets"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Stock,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FlagsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Flags__["a" /* default */],{stock:props.stock})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,props.stock)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BidType,{isBidUp:props.isBidUp})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Social__["a" /* TableItem */],{column:"trader"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TraderID,null,props.user_id)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Social__["a" /* TableItem */],{column:"profit"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,{isPositive:Math.sign(props.profit)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:"USD"},props.profit))));};var merge=function merge(data){return Object.keys(data).reduce(function(acc,curr){return acc.concat(data[curr]);},[]);};var SocialItems=function SocialItems(props){return __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.social.length<1&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,{withParent:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"No items to show")),props.social.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,{key:item.id+item.timestamp,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__common_fetch__["d" /* get */])("/api/getAssets").then(merge).then(function(stocksInfo){var stock=stocksInfo.find(function(info){return item.stock.toUpperCase()===info.stock;});var isCorrectStock=stock&&stock.enabled;Object(__WEBPACK_IMPORTED_MODULE_5__GA__["a" /* gaReducer */])("CLICK_SOCIAL_TRADING_ASSET",{asset:item.stock});if(!isCorrectStock)return false;var tabIndex=props.tabs.tabs.indexOf(item.stock);var tabsLength=props.tabs.tabs.length;if(tabIndex!==-1){props.dispatch({type:"SET_ACTIVE_TAB",payload:tabIndex});if(props.onItemClick)props.onItemClick();return;}if(tabsLength<__WEBPACK_IMPORTED_MODULE_10__redux_reducer_tabs__["a" /* TABS_LIMIT */]){props.dispatch({type:"PUSH_TAB",payload:item.stock});if(props.onItemClick)props.onItemClick();return;}props.dispatch({type:"SET_ACTIVE_STOCK",payload:{newStock:item.stock,activeStock:item.stock}});if(props.onItemClick)props.onItemClick();}).catch(function(error){console.log(error);return false;});}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SocialItem,{stock:item.stock,isBidUp:item.isBidUp,user_id:item.user_id,profit:item.profit}));}));},[props.social.length>0?props.social[0].timestamp:null]);};var mapStateToProps=function mapStateToProps(state){return{tabs:state.tabs,social:state.socialTrading,assets:state.stocks};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(SocialItems));

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(279));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"
})), 'CloseOutlined');

exports.default = _default;

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ArtificialTourDeals; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buttons__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CollapsibleSection__ = __webpack_require__(2001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__History__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Settings__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Trade_OperationCheque__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HistoryPopup_HistoryPopup__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Protection_ProtectionInfo__ = __webpack_require__(783);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  @media (min-width: 960px) {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n"],["\n  @media (min-width: 960px) {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background-color: ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  background-color: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background-color: ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  overflow: hidden;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 18px;\n  padding-bottom: 18px;\n  text-align: center;\n  border-bottom: 1px dashed ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-top: 18px;\n  padding-bottom: 18px;\n  text-align: center;\n  border-bottom: 1px dashed ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: column;\n\n  ",";\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      margin-top: -5px;\n      margin-bottom: -5px;\n      padding: 5px;\n      border-radius: 4px;\n      ",";\n    "],["\n      margin-top: -5px;\n      margin-bottom: -5px;\n      padding: 5px;\n      border-radius: 4px;\n      ",";\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 43px;\n  font-size: ",";\n  color: #96929a;\n  text-align: left;\n  background-color: ",";\n  border: none;\n  cursor: pointer;\n  transition: all 0.35s;\n  direction: ",";\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n"],["\n  display: flex;\n  align-items: center;\n  height: 43px;\n  font-size: ",";\n  color: #96929a;\n  text-align: left;\n  background-color: ",";\n  border: none;\n  cursor: pointer;\n  transition: all 0.35s;\n  direction: ",";\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  min-width: 23px;\n  width: 23px;\n  height: 24px;\n  margin-left: 8px;\n  margin-right: 6px;\n  color: #99959d;\n  transition: all 0.35s;\n"],["\n  min-width: 23px;\n  width: 23px;\n  height: 24px;\n  margin-left: 8px;\n  margin-right: 6px;\n  color: #99959d;\n  transition: all 0.35s;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 30;\n  opacity: 0.73;\n  background-color: ",";\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 30;\n  opacity: 0.73;\n  background-color: ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.mainLight;});// const CollapsibleWrapper = styled.div`
//   display: flex;
//   flex-direction: column;
//   flex: 1;
//   background-color: ${props => props.theme.mainDark};
// `;
var Scrollable=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Scrollable__["a" /* default */])(_templateObject3,function(props){return props.theme.dealsBackground;});var CollapsibleContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Buttons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.theme.borderMainColor;});var ButtonsInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref){var tourBorder=_ref.tourBorder;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,tourBorder.border);},function(_ref2){var tourBorderAnimation=_ref2.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation(tourBorderAnimation.keyframe);});var HistoryButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject8,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref4){var theme=_ref4.theme;return theme.mainLight;},function(_ref5){var theme=_ref5.theme;return theme.direction==="rtl"&&"rtl";},function(_ref6){var theme=_ref6.theme;return theme.accent;});var HistoryIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var StockClose=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(props){return props.theme.main;});var ArtificialTourDeals=function ArtificialTourDeals(props){var tour=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_17__Tour__["a" /* TourContext */]);return tour.deals.map(function(deal){if(tour.activeDeal===deal){var present=tour.points[tour.points.length-1];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__History__["b" /* OpenOperation */],Object.assign({},deal,{tradeMode:"binary",mobile:props.mobile,now:present.date,pointsByStock:{}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__History__["a" /* ClosedOperation */],Object.assign({},deal,{tradeMode:"binary",mobile:props.mobile,profit:deal.amount*0.9}));}});};var TradeControls=function(_React$Component){_inherits(TradeControls,_React$Component);function TradeControls(){var _ref7;var _temp,_this,_ret;_classCallCheck(this,TradeControls);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref7=TradeControls.__proto__||Object.getPrototypeOf(TradeControls)).call.apply(_ref7,[this].concat(args))),_this),_this.state={popupIsOpen:false,tourInterval:30},_this.openPopup=function(){return _this.setState({popupIsOpen:true});},_this.closePopup=function(){return _this.setState({popupIsOpen:false});},_this.handleSettingsUpdate=function(nextSettings){_this.props.dispatch({type:"UPDATE_SETTINGS",payload:nextSettings});},_this.original=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(null),_this.originalDeals=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(null),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TradeControls,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps,nextState){var isThereAnyOpenDeals=nextProps.deals&&nextProps.deals.some(function(deal){return deal.time!=null;});var isSomethingValuableChanged=nextProps.disabled!==this.props.disabled||nextProps.currentBid!==this.props.currentBid||nextProps.possibleIntervals!==this.props.possibleIntervals||nextProps.suggestedBids!==this.props.suggestedBids||nextProps.percentBids!==this.props.percentBids||nextProps.accountType!==this.props.accountType||nextProps.currentInterval!==this.props.currentInterval||nextProps.deals!==this.props.deals||nextState.tourInterval!==this.state.tourInterval||nextProps.compensationUpdated!==this.props.compensationUpdated||nextProps.compensationCreated!==this.props.compensationCreated;return isThereAnyOpenDeals||isSomethingValuableChanged;}},{key:"_submit",value:function _submit(type){var _props=this.props,currentBid=_props.currentBid,currentInterval=_props.currentInterval,point=_props.point,accountType=_props.accountType;if(!point){return;// Или может throw?
}type==="UP"?Object(__WEBPACK_IMPORTED_MODULE_16__GA__["a" /* gaReducer */])("CLICKBTN_UPPER_BET"):Object(__WEBPACK_IMPORTED_MODULE_16__GA__["a" /* gaReducer */])("CLICKBTN_LOWER_BET");this.props.onSubmit({id:null,time:1337,percent:null,bidType:type==="UP",amount:currentBid,bTime:currentInterval,stock:point.stock,value:point.value,accountType:accountType,timestamp:Number(point.date/1000),open_timestamp:Number(point.date/1000),date:point.date});}},{key:"render",value:function render(){var _this2=this;var _props2=this.props,activeAccount=_props2.activeAccount,deals=_props2.deals,percentBids=_props2.percentBids,percentBidThreshold=_props2.percentBidThreshold,suggestedBids=_props2.suggestedBids,possibleIntervals=_props2.possibleIntervals,currentBid=_props2.currentBid,currentInterval=_props2.currentInterval,showIncreaseBidLimitMessage=_props2.showIncreaseBidLimitMessage,isDealAmountValid=_props2.isDealAmountValid,validateDealAmount=_props2.validateDealAmount,tradeMode=_props2.tradeMode,dealsToCompensate=_props2.dealsToCompensate,compensationUpdated=_props2.compensationUpdated,compensationCreated=_props2.compensationCreated,onCompensationCreated=_props2.onCompensationCreated;var tourInterval=this.state.tourInterval;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,tradeMode==="binary"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Protection_ProtectionInfo__["a" /* default */],{isDesktop:true,dealsToCompensate:dealsToCompensate,compensationUpdated:compensationUpdated,compensationCreated:compensationCreated,onCompensationCreated:onCompensationCreated,activeAccount:activeAccount}),this.props.disabled&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockClose,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Settings__["a" /* default */],{tradeMode:this.props.tradeMode,activeAccount:activeAccount,suggestedBids:suggestedBids,percentBids:percentBids,percentBidThreshold:percentBidThreshold,possibleIntervals:possibleIntervals,currentBid:currentBid,currentInterval:currentInterval,onSettingsUpdate:this.handleSettingsUpdate,maxBidVolume:this.props.maxBidVolume,showIncreaseBidLimitMessage:showIncreaseBidLimitMessage,isDealAmountValid:isDealAmountValid,validateDealAmount:validateDealAmount,tourInterval:tourInterval,onTourIntervalChange:function onTourIntervalChange(value){_this2.setState({tourInterval:value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Tour__["b" /* default */],{step:"makeDeal",originalRef:this.original},function(_ref8){var next=_ref8.next,isOriginal=_ref8.isOriginal,tour=_ref8.tour;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Buttons,{ref:isOriginal?_this2.original:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonsInner,{tourBorder:!isOriginal&&tour&&tour.borderStyles,tourBorderAnimation:!isOriginal&&tour&&tour.outside&&tour.borderStyles},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Buttons__["b" /* CastUp */],{onClick:function onClick(){if(isOriginal){_this2._submit("UP");}else{next(["UP",currentBid,tourInterval]);}},onMouseEnter:function onMouseEnter(){_this2.props.onIntentUpdate("CAST_UP");},onMouseLeave:function onMouseLeave(){_this2.props.onIntentUpdate("");}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Buttons__["a" /* CastDown */],{onClick:function onClick(){if(isOriginal){_this2._submit("DOWN");}else{next(["DOWN",currentBid,tourInterval]);}},onMouseEnter:function onMouseEnter(){_this2.props.onIntentUpdate("CAST_DOWN");},onMouseLeave:function onMouseLeave(){_this2.props.onIntentUpdate("");}})));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CollapsibleSection__["a" /* default */],{Icon:__WEBPACK_IMPORTED_MODULE_6__Icons__["b" /* DealsIcon */],title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Deals"),isOpenByDefault:true},function(_ref9){var isOpen=_ref9.isOpen;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref10){var showModal=_ref10.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Animations__["a" /* Fade */],{"in":isOpen},function(_ref11){var style=_ref11.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CollapsibleContainer,{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Scrollable,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Tour__["b" /* default */],{step:"chartWithDeals",originalRef:_this2.originalDeals,zIndex:110},function(_ref12){var next=_ref12.next,isOriginal=_ref12.isOriginal,isTourActive=_ref12.isTourActive,isTourMode=_ref12.isTourMode,tour=_ref12.tour;return!isTourMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__History__["c" /* default */],{tradeMode:_this2.props.tradeMode,deals:deals,now:_this2.props.now,point:_this2.props.point,pointsByStock:_this2.props.pointsByStock,isOperationClickable:function isOperationClickable(operation){if(__WEBPACK_IMPORTED_MODULE_14__FeatureFlags__["a" /* default */].OperationCheque&&operation.profit!=null){return true;}else{return operation.stock!==_this2.props.stock.stock;}},onOperationClick:function onOperationClick(operation){if(__WEBPACK_IMPORTED_MODULE_14__FeatureFlags__["a" /* default */].OperationCheque&&operation.profit!=null){showModal(__WEBPACK_IMPORTED_MODULE_13__Trade_OperationCheque__["a" /* default */],{type:tradeMode,id:operation.id,operation:operation});}else{_this2.props.dispatch({type:"SWITCH_TO_STOCK",payload:operation.stock});}},refundClickHandler:_this2.props.refundClickHandler,refundFetching:_this2.props.refundFetching}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:_this2.originalDeals,style:{pointerEvents:"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArtificialTourDeals,{mobile:_this2.props.mobile}));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HistoryButton,{type:"button",onClick:_this2.openPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HistoryIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons__["d" /* TradingHistoryIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Trading history")),_this2.state.popupIsOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HistoryPopup_HistoryPopup__["a" /* default */],{type:"widget",themeName:_this2.props.theme==="light"&&"irontrade"==="irontrade"?"whitePopup":"darkPopup",onClose:_this2.closePopup}));});});}));}}]);return TradeControls;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{theme:state.settings.theme};};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["h" /* withFetch */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TradeControls)));

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = CastUp;
/* harmony export (immutable) */ __webpack_exports__["a"] = CastDown;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  height: 58px;\n  margin: 0 auto;\n  text-align: center;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  @media (min-width: 960px) {\n    min-width: 132px;\n  }\n\n  "," "," @media(max-width: 959px) {\n    width: 100%;\n    height: 37px;\n    margin: 0;\n    border-radius: 4px;\n    flex: 1 1 auto;\n  }\n"],["\n  position: relative;\n  height: 58px;\n  margin: 0 auto;\n  text-align: center;\n  color: #fff;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n\n  @media (min-width: 960px) {\n    min-width: 132px;\n  }\n\n  "," "," @media(max-width: 959px) {\n    width: 100%;\n    height: 37px;\n    margin: 0;\n    border-radius: 4px;\n    flex: 1 1 auto;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      margin-bottom: 10px;\n      background-color: ",";\n      background: linear-gradient(\n        0deg,\n        "," 0%,\n        "," 100%\n      );\n      border-bottom: 2px solid ",";\n      box-shadow: inset 0px -1px 0px 0px ",";\n      \n      :hover,\n      :active {\n        background-color: ",";\n        background: linear-gradient(\n          0deg,\n          "," 0%,\n          "," 100%\n        );\n        ",";\n      }\n\n      :active {\n        transform: translateY(1px);\n      }\n\n      @media (max-width: 959px) {\n        :focus,\n        :active {\n          background-color: ",";\n          background: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n          box-shadow: inset 0px -1px 0px 0px ",";\n          transform: translateY(0);\n        }\n      }\n\n      @media (hover: none), (hover: on-demand) {\n        :hover {\n          background-color: ",";\n          background: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n          box-shadow: inset 0px -1px 0px 0px ",";\n        }\n      }\n    "],["\n      margin-bottom: 10px;\n      background-color: ",";\n      background: linear-gradient(\n        0deg,\n        "," 0%,\n        "," 100%\n      );\n      border-bottom: 2px solid ",";\n      box-shadow: inset 0px -1px 0px 0px ",";\n      \n      :hover,\n      :active {\n        background-color: ",";\n        background: linear-gradient(\n          0deg,\n          "," 0%,\n          "," 100%\n        );\n        ",";\n      }\n\n      :active {\n        transform: translateY(1px);\n      }\n\n      @media (max-width: 959px) {\n        :focus,\n        :active {\n          background-color: ",";\n          background: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n          box-shadow: inset 0px -1px 0px 0px ",";\n          transform: translateY(0);\n        }\n      }\n\n      @media (hover: none), (hover: on-demand) {\n        :hover {\n          background-color: ",";\n          background: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n          box-shadow: inset 0px -1px 0px 0px ",";\n        }\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n            box-shadow: 0 0 10px 4px rgba(96, 162, 29, 0.37);\n          "],["\n            box-shadow: 0 0 10px 4px rgba(96, 162, 29, 0.37);\n          "]),_templateObject4=_taggedTemplateLiteral(["\n      box-shadow: inset 0px -1px 0px 0px ",";\n      background-color: ",";\n      background-image: linear-gradient(\n        0deg,\n        "," 0%,\n        "," 100%\n      );\n      border-bottom: 2px solid ",";\n\n      :hover,\n      :active {\n        background-color: ",";\n        background-image: linear-gradient(\n          0deg,\n          "," 0%,\n          "," 100%\n        );\n\n        ",";\n      }\n\n      :active {\n        transform: translateY(1px);\n      }\n\n      @media (max-width: 959px) {\n        :focus,\n        :active {\n          box-shadow: inset 0px -1px 0px 0px ",";\n          background-color: ",";\n          background-image: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n          transform: translateY(0);\n        }\n      }\n\n      @media (hover: none), (hover: on-demand) {\n        :hover {\n          box-shadow: inset 0px -1px 0px 0px ",";\n          background-color: ",";\n          background-image: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n        }\n      }\n    "],["\n      box-shadow: inset 0px -1px 0px 0px ",";\n      background-color: ",";\n      background-image: linear-gradient(\n        0deg,\n        "," 0%,\n        "," 100%\n      );\n      border-bottom: 2px solid ",";\n\n      :hover,\n      :active {\n        background-color: ",";\n        background-image: linear-gradient(\n          0deg,\n          "," 0%,\n          "," 100%\n        );\n\n        ",";\n      }\n\n      :active {\n        transform: translateY(1px);\n      }\n\n      @media (max-width: 959px) {\n        :focus,\n        :active {\n          box-shadow: inset 0px -1px 0px 0px ",";\n          background-color: ",";\n          background-image: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n          transform: translateY(0);\n        }\n      }\n\n      @media (hover: none), (hover: on-demand) {\n        :hover {\n          box-shadow: inset 0px -1px 0px 0px ",";\n          background-color: ",";\n          background-image: linear-gradient(\n            0deg,\n            "," 0%,\n            "," 100%\n          );\n        }\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n            box-shadow: 0 0 10px 4px rgba(214, 88, 88, 0.37);\n          "],["\n            box-shadow: 0 0 10px 4px rgba(214, 88, 88, 0.37);\n          "]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: ",";\n  text-align: center;\n  text-transform: uppercase;\n  text-shadow: -1px -1px rgba(0, 0, 0, 0.22);\n  color: #fff;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  font-weight: 700;\n  font-size: ",";\n  text-align: center;\n  text-transform: uppercase;\n  text-shadow: -1px -1px rgba(0, 0, 0, 0.22);\n  color: #fff;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 14px;\n  margin-right: 7px;\n\n  @media (max-width: 479px) {\n    left: 11px;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 14px;\n  margin-right: 7px;\n\n  @media (max-width: 479px) {\n    left: 11px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var deployTarget="irontrade";var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject,function(props){return props.up&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(props){return props.theme.upper;},function(props){return props.theme.upper;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upperBorder;},function(props){return props.theme.upperBoxShadow;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upper;},function(){return deployTarget==="siamoption"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(props){return props.theme.upper;},function(props){return props.theme.upper;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upperBoxShadow;},function(props){return props.theme.upper;},function(props){return props.theme.upper;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upperBoxShadow;});},function(props){return props.down&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(props){return props.theme.lowerBoxShadow;},function(props){return props.theme.lower;},function(props){return props.theme.lower;},function(props){return props.theme.lowerAccent;},function(props){return props.theme.lowerBorder;},function(props){return props.theme.lowerAccent;},function(props){return props.theme.lowerAccent;},function(props){return props.theme.lower;},function(){return deployTarget==="siamoption"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.theme.lowerBoxShadow;},function(props){return props.theme.lower;},function(props){return props.theme.lower;},function(props){return props.theme.lowerAccent;},function(props){return props.theme.lowerBoxShadow;},function(props){return props.theme.lower;},function(props){return props.theme.lower;},function(props){return props.theme.lowerAccent;});});var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject6);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14));var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject8);function Icon(_ref){var d=_ref.d;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{xmlns:"http://www.w3.org/2000/svg",width:"14px",height:"14px",viewBox:"0 0 16 16",fill:"rgba(255, 255, 255, .55)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:d}));}function CastUp(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,Object.assign({up:true},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{d:"M15.992,13.993 L15.992,0.001 L1.999,0.001 L1.999,3.998 L9.426,3.998 L0.618,12.807 L3.186,15.376 L11.995,6.567 L11.995,13.993 L15.992,13.993 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Upper"))));}function CastDown(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,Object.assign({down:true},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{d:"M15.992,1.990 L15.992,15.982 L1.999,15.982 L1.999,11.985 L9.426,11.985 L0.618,3.176 L3.186,0.607 L11.995,9.416 L11.995,1.990 L15.992,1.990 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"lower"))));}

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = OpenOperation;
/* harmony export (immutable) */ __webpack_exports__["a"] = ClosedOperation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Chart_Deal__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Refund__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Close__ = __webpack_require__(2002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Close___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Close__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  font-size: ",";\n\n  @media (max-width: 479px) {\n    order: 2;\n    width: 30%;\n    text-align: right;\n  }\n"],["\n  font-size: ",";\n\n  @media (max-width: 479px) {\n    order: 2;\n    width: 30%;\n    text-align: right;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  font-size: ",";\n  text-transform: uppercase;\n\n  ",";\n"],["\n  font-size: ",";\n  text-transform: uppercase;\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      font-size: ",";\n      color: ",";\n\n      @media (max-width: 479px) {\n        order: 0;\n        width: 45px;\n        margin-right: 5px;\n      }\n    "],["\n      font-size: ",";\n      color: ",";\n\n      @media (max-width: 479px) {\n        order: 0;\n        width: 45px;\n        margin-right: 5px;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: space-between;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 68px;\n  padding: 10px;\n  color: #817c86;\n  background-color: ",";\n  background-repeat: no-repeat;\n  background-position: 100% 0;\n  border-bottom: 1px dashed ",";\n  user-select: none;\n  cursor: ",";\n\n  :active {\n    opacity: 0.75;\n  }\n\n  "," {\n    transition: color 0.3s ease;\n  }\n\n  :hover {\n    "," {\n      color: ",";\n    }\n  }\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: space-between;\n  justify-content: space-between;\n  align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 68px;\n  padding: 10px;\n  color: #817c86;\n  background-color: ",";\n  background-repeat: no-repeat;\n  background-position: 100% 0;\n  border-bottom: 1px dashed ",";\n  user-select: none;\n  cursor: ",";\n\n  :active {\n    opacity: 0.75;\n  }\n\n  "," {\n    transition: color 0.3s ease;\n  }\n\n  :hover {\n    "," {\n      color: ",";\n    }\n  }\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      width: 100%;\n      height: auto;\n      padding: 7px 10px;\n      background-color: transparent;\n      border-bottom: 1px solid ",";\n\n      @media (max-width: 479px) {\n        padding: 7px 5px;\n\n        ",";\n      }\n    "],["\n      width: 100%;\n      height: auto;\n      padding: 7px 10px;\n      background-color: transparent;\n      border-bottom: 1px solid ",";\n\n      @media (max-width: 479px) {\n        padding: 7px 5px;\n\n        ",";\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n            flex-wrap: nowrap;\n            padding: 0 0 0 5px;\n          "],["\n            flex-wrap: nowrap;\n            padding: 0 0 0 5px;\n          "]),_templateObject7=_taggedTemplateLiteral(["\n  width: 100%;\n  padding-bottom: 6px;\n  font-size: ",";\n  line-height: 1;\n  text-align: right;\n"],["\n  width: 100%;\n  padding-bottom: 6px;\n  font-size: ",";\n  line-height: 1;\n  text-align: right;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 700;\n  text-align: right;\n  color: ",";\n\n  ",";\n  ",";\n"],["\n  font-size: ",";\n  font-weight: 700;\n  text-align: right;\n  color: ",";\n\n  ",";\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n          color: ",";\n        "],["\n          color: ",";\n        "]),_templateObject10=_taggedTemplateLiteral(["\n      font-size: ",";\n\n      @media (max-width: 479px) {\n        order: 2;\n        width: 30%;\n      }\n    "],["\n      font-size: ",";\n\n      @media (max-width: 479px) {\n        order: 2;\n        width: 30%;\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  padding-top: 5px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n"],["\n  display: table;\n  width: 100%;\n  padding-top: 5px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: top;\n"],["\n  display: table-cell;\n  vertical-align: top;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 9px;\n  height: 7px;\n  margin-right: 4px;\n  line-height: 0;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 9px;\n  height: 7px;\n  margin-right: 4px;\n  line-height: 0;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  /* color: ","; */\n  color: #99959d;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  /* color: ","; */\n  color: #99959d;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: top;\n  padding-top: 1px;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  ",";\n  /* color: ","; */\n  color: #99959d;\n"],["\n  display: table-cell;\n  vertical-align: top;\n  padding-top: 1px;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  ",";\n  /* color: ","; */\n  color: #99959d;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  height: 4px;\n  background-color: ",";\n\n  ",";\n"],["\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  height: 4px;\n  background-color: ",";\n\n  ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n      height: 2px;\n    "],["\n      height: 2px;\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  height: 4px;\n  width: 0%;\n  background-color: ",";\n  transition: all 0.1s ease;\n\n  ",";\n"],["\n  height: 4px;\n  width: 0%;\n  background-color: ",";\n  transition: all 0.1s ease;\n\n  ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: space-between;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: 7px;\n\n  @media (max-width: 479px) {\n    order: 1;\n    width: 45%;\n    margin-top: 0;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-content: space-between;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  margin-top: 7px;\n\n  @media (max-width: 479px) {\n    order: 1;\n    width: 45%;\n    margin-top: 0;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["\n  width: auto;\n  padding-bottom: 0;\n  font-size: ",";\n  line-height: 1;\n  text-align: right;\n"],["\n  width: auto;\n  padding-bottom: 0;\n  font-size: ",";\n  line-height: 1;\n  text-align: right;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  padding: 10px;\n  font-size: ",";\n  text-align: center;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  padding: 10px;\n  font-size: ",";\n  text-align: center;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject22=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject23=_taggedTemplateLiteral(["\n  @media (max-width: 479px) {\n    margin-left: 10px;\n    order: 3;\n  }\n"],["\n  @media (max-width: 479px) {\n    margin-left: 10px;\n    order: 3;\n  }\n"]),_templateObject24=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px;\n  background-color: ",";\n\n  @media (max-width: 479px) {\n    padding: 5px;\n  }\n"],["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 7px;\n  background-color: ",";\n\n  @media (max-width: 479px) {\n    padding: 5px;\n  }\n"]),_templateObject25=_taggedTemplateLiteral(["\n  font-size: 12px;\n  color: ",";\n"],["\n  font-size: 12px;\n  color: ",";\n"]),_templateObject26=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"],["\n  display: flex;\n  align-items: center;\n"]),_templateObject27=_taggedTemplateLiteral(["\n  font-size: 12px;\n  font-weight: 700;\n  color: ",";\n\n  @media (max-width: 479px) {\n    margin-left: 5px;\n  }\n"],["\n  font-size: 12px;\n  font-weight: 700;\n  color: ",";\n\n  @media (max-width: 479px) {\n    margin-left: 5px;\n  }\n"]),_templateObject28=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 2px;\n  background-color: ",";\n"],["\n  position: relative;\n  width: 100%;\n  height: 2px;\n  background-color: ",";\n"]),_templateObject29=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  height: 100%;\n  background-color: ",";\n"],["\n  position: absolute;\n  left: 0;\n  height: 100%;\n  background-color: ",";\n"]),_templateObject30=_taggedTemplateLiteral(["\n  margin-left: 5px;\n  font-size: 15px;\n  color: #919191;\n  cursor: pointer;\n"],["\n  margin-left: 5px;\n  font-size: 15px;\n  color: #919191;\n  cursor: pointer;\n"]),_templateObject31=_taggedTemplateLiteral(["Close "," deals"],["Close "," deals"]),_templateObject32=_taggedTemplateLiteral(["Close the deal"],["Close the deal"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var RefundContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(10,10));var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(14,14),function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(9,9),function(_ref){var theme=_ref.theme;return theme.foreground;});});var OperationView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.dealsBackground;},function(props){return props.theme.mainSeparator;},function(props){return props.isClickable?"pointer":"default";},Title,Title,function(props){return props.isClickable?props.theme.accent:"inherit";},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,function(props){return props.theme.borderMainColor;},function(_ref2){var sellEnabled=_ref2.sellEnabled;return sellEnabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});});var Time=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(11,11));var Bet=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(14,14),function(_ref3){var theme=_ref3.theme;return theme.ticksFontColor;},function(_ref4){var theme=_ref4.theme,isWinning=_ref4.isWinning;switch(isWinning){case true:return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9,theme.upper);case false:return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9,theme.lower);case null:default:break;}},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(12,12));});var BetCount=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(12,12));var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var BetDirection=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var BetDirectionText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(_ref5){var theme=_ref5.theme;return theme.foreground;});var BetCountText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["c" /* rtl */])("text-align","right"),function(_ref6){var theme=_ref6.theme;return theme.foreground;});var ProgressBar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.theme.mainLight;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);});var Progress=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject18,function(props){return props.theme.accent;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);});/* Mobile-only thigs */var DealTypeandTimeView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject19);var TimeOnMobile=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(10,10));// no open trades
var NoOpenTrades=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject21,Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_11__common_styled_mixins__["a" /* fontSize */])(12));var BetIconWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject22,function(_ref7){var theme=_ref7.theme,bidType=_ref7.bidType;return bidType?theme.upper:theme.lower;});var SellDealBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject23);var SellDealBlockTop=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject24,function(_ref8){var theme=_ref8.theme;return theme.sellDealHistoryBg;});var SellDealTimer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject25,function(_ref9){var theme=_ref9.theme;return theme.sellDealHistoryColor;});var SellDealRight=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject26);var SellDealMoney=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject27,function(_ref10){var theme=_ref10.theme;return theme.sellDealHistoryColor;});var SellDealProgressBar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject28,function(_ref11){var theme=_ref11.theme;return theme.sellDealHistoryProgress;});var SellDealProgress=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject29,function(_ref12){var theme=_ref12.theme;return theme.sellDealHistoryColor;});var SellDealClose=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject30);var BetIcon=function BetIcon(_ref13){var bidType=_ref13.bidType;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetIconWrapper,{bidType:bidType},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"9",height:"7",viewBox:"0 0 9 7",fill:"currentColor"},bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M4.5,0.494L0.779,6.921H8.226L4.5,0.494"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M4.5,7.384L0.779,0.958H8.226L4.5,7.384"})));};var Icon=function Icon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"8",height:"8",viewBox:"0 0 8 8",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fillRule:"evenodd",fillOpacity:"0.549",d:props.d}));};function OpenOperation(props){if(typeof props.percent!=="number"){return null;}var progress=Math.min((props.now-props.open_timestamp*1000)/(props.bTime*1000),1);var sellProgress=Math.min((props.now-props.open_timestamp*1000)/(props.bTime*1000/2),1);var sellTime=props.bTime*1000/2+props.open_timestamp*1000-props.now;var sellHoursCount=parseInt(sellTime/(1000*60*60)%24,10);var sellMinutesCount=parseInt(sellTime/(1000*60)%60,10);var sellSecondsCount=parseInt(sellTime/1000%60,10);var sellHours=sellHoursCount>=1?sellHoursCount+":":"";var sellMinutes=sellMinutesCount<10?"0"+sellMinutesCount:sellMinutesCount;var sellSeconds=sellSecondsCount<10?"0"+sellSecondsCount:sellSecondsCount;var sellTimer=""+sellHours+sellMinutes+":"+sellSeconds;var date=__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.open_timestamp*1000).format("DD/MM HH:mm:ss");var quote=props.pointsByStock&&props.pointsByStock[props.stock];var currency=props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_8__Icons_Kuchka__["b" /* tournamentCurrency */]:null;var windowWidth=document.documentElement.clientWidth;var profit=null;if(props.now-props.open_timestamp*1000>=props.bTime*1000||quote==null){profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["a" /* NewSimpleSpinner */],null);}else{var deviation=props.bidType?quote.value-props.value:props.value-quote.value;switch(Math.sign(deviation)){case 1:profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bet,{mobile:props.mobile,isWinning:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},props.multiplier*(props.amount*props.percent)/100));break;case-1:profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bet,{mobile:props.mobile,isWinning:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},-1*props.amount*props.multiplier));break;default:profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bet,{mobile:props.mobile,isWinning:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},"0"));break;}}var current=props.pointsByStock&&props.pointsByStock[props.stock]&&props.pointsByStock[props.stock].value;// const features = api.readEntity("/api/features/list");
// const closeEarly = features.value && features.value.find(feature => feature.name === "operation_early_close");
var isRefundable=props.refund_10!=null&&props.refund_30!=null&&props.refund_95!=null&&props.refund_100!=null&&props.refund_105!=null&&props.refund_110!=null&&props.refund_115!=null;var refundProfit=void 0;if(isRefundable){var returnK=(current-props.value)/props.value;var refundPercent=Object(__WEBPACK_IMPORTED_MODULE_4__Chart_Deal__["e" /* getRefundPercent */])(returnK,props.bidType,{refund_10:props.refund_10,refund_30:props.refund_30,refund_95:props.refund_95,refund_100:props.refund_100,refund_105:props.refund_105,refund_110:props.refund_110,refund_115:props.refund_115});refundProfit=props.amount*refundPercent;}var SellDeal=function SellDeal(){if(!isRefundable||sellProgress>=1)return null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealBlock,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealBlockTop,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealTimer,null,sellTimer),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealRight,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealMoney,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,props.multiplier*refundProfit)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealClose,{onClick:props.refundClickHandler,title:props.multiplier>1?props.gettext(_templateObject31,props.multiplier):props.gettext(_templateObject32)},props.refundFetching.has(props.id)?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["a" /* NewSimpleSpinner */],null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Close___default.a,{color:"inherit",fontSize:"inherit"})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealProgressBar,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDealProgress,{style:{width:Math.floor(sellProgress*100)+"%"}}));}}));};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OperationView,{isClickable:props.isClickable,onClick:props.onClick,mobile:props.mobile,sellEnabled:isRefundable&&sellProgress<1},props.mobile?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,null,date),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{mobile:props.mobile},props.multiplier>1&&props.multiplier+"\u2715",props.stock.slice(0,6)),profit,props.mobile?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealTypeandTimeView,null,props.bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{d:"M7.996,7.032 L7.996,0.048 L1.012,0.048 L1.012,2.043 L4.719,2.043 L0.322,6.440 L1.604,7.722 L6.001,3.325 L6.001,7.032 L7.996,7.032 Z"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{d:"M7.996,1.023 L7.996,8.007 L1.012,8.007 L1.012,6.011 L4.719,6.011 L0.322,1.615 L1.604,0.333 L6.001,4.730 L6.001,1.023 L7.996,1.023 Z"}),(!isRefundable||sellProgress>=1||windowWidth>479)&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeOnMobile,null,date)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetCount,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetDirection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetIcon,{bidType:props.bidType})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetDirectionText,null,props.bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Upper"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"lower"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetCountText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},props.multiplier*props.amount))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProgressBar,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Progress,{mobile:props.mobile,style:{width:Math.floor(progress*100)+"%"}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 479px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDeal,null);}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SellDeal,null);}}));}function ClosedOperation(props){if(typeof props.percent!=="number"){return null;}var date=__WEBPACK_IMPORTED_MODULE_3_moment___default()(props.open_timestamp*1000).format("DD/MM HH:mm:ss");var currency=props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_8__Icons_Kuchka__["b" /* tournamentCurrency */]:null;var profit=null;switch(Math.sign(props.profit)){case 1:profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bet,{mobile:props.mobile,isWinning:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},props.multiplier*props.profit));break;case-1:profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bet,{mobile:props.mobile,isWinning:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},props.multiplier*props.profit));break;default:profit=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefundContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Refund__["a" /* default */],null));break;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OperationView,{isClickable:props.isClickable,onClick:props.onClick,mobile:props.mobile},props.mobile?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,null,date),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{mobile:props.mobile},props.multiplier>1&&props.multiplier+"\u2715",props.stock.slice(0,6)),profit,props.mobile?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealTypeandTimeView,null,props.bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{d:"M7.996,7.032 L7.996,0.048 L1.012,0.048 L1.012,2.043 L4.719,2.043 L0.322,6.440 L1.604,7.722 L6.001,3.325 L6.001,7.032 L7.996,7.032 Z"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{d:"M7.996,1.023 L7.996,8.007 L1.012,8.007 L1.012,6.011 L4.719,6.011 L0.322,1.615 L1.604,0.333 L6.001,4.730 L6.001,1.023 L7.996,1.023 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeOnMobile,null,date)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetCount,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetDirection,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetIcon,{bidType:props.bidType})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetDirectionText,null,props.bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Upper"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"lower"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetCountText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],{currency:currency},props.multiplier*props.amount))));}function Operation(props){return props.profit==null&&props.time!=null?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OpenOperation,props):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClosedOperation,props);}function TradeHistory(props){var activeDealsLength=props.deals.filter(function(deal){return deal.profit==null&&deal.time!=null;}).length;var deals=props.deals.slice(0,activeDealsLength>10?activeDealsLength:10);if(props.deals.length>0){return deals.reduce(__WEBPACK_IMPORTED_MODULE_4__Chart_Deal__["c" /* dealDuplicatesReducer */],[]).map(function(deal,i){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Operation,Object.assign({key:deal.id||i},deal,{tradeMode:props.tradeMode,now:props.now,point:props.point,pointsByStock:props.pointsByStock,mobile:props.mobile,isClickable:props.isOperationClickable?props.isOperationClickable(deal):true,onClick:function onClick(){return props.onOperationClick(deal);},refundClickHandler:function refundClickHandler(){return Object(__WEBPACK_IMPORTED_MODULE_4__Chart_Deal__["b" /* dealCloser */])(deal,props.refundClickHandler);},refundFetching:props.refundFetching,gettext:props.gettext}));});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NoOpenTrades,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You have no open trades"));}/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["g" /* withGettext */])(TradeHistory));

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniq__ = __webpack_require__(2003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Select__ = __webpack_require__(2004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SelectWithInput__ = __webpack_require__(2005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Profit__ = __webpack_require__(2006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SuggestingInput__ = __webpack_require__(2007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Tour__ = __webpack_require__(44);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: -1px;\n  padding: 1px 28px 18px;\n\n  @media (max-width: 479px) {\n    width: 100%;\n    align-items: center;\n  }\n\n  @media (max-width: 959px) {\n    padding: 0 0 11px;\n  }\n"],["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  margin-top: -1px;\n  padding: 1px 28px 18px;\n\n  @media (max-width: 479px) {\n    width: 100%;\n    align-items: center;\n  }\n\n  @media (max-width: 959px) {\n    padding: 0 0 11px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n\n  @media (max-width: 479px) {\n    margin-bottom: ",";\n\n    ",";\n  }\n"],["\n  width: 100%;\n\n  @media (max-width: 479px) {\n    margin-bottom: ",";\n\n    ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n        width: auto;\n        margin-left: 8px;\n        margin-right: 8px;\n      "],["\n        width: auto;\n        margin-left: 8px;\n        margin-right: 8px;\n      "]),_templateObject4=_taggedTemplateLiteral(["\n  direction: ",";\n  margin-top: 15px;\n  margin-bottom: 7px;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    margin-top: 9px;\n    margin-bottom: 3px;\n  }\n\n  @media (max-width: 479px) {\n    margin-top: 23px;\n  }\n"],["\n  direction: ",";\n  margin-top: 15px;\n  margin-bottom: 7px;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    margin-top: 9px;\n    margin-bottom: 3px;\n  }\n\n  @media (max-width: 479px) {\n    margin-top: 23px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0 auto;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n  }\n"],["\n  width: 100%;\n  margin: 0 auto;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    flex-grow: 1;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  :after {\n    ",";\n\n    ",";\n  }\n"],["\n  :after {\n    ",";\n\n    ",";\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        border-radius: 6px;\n        ",";\n        content: \"\";\n      "],["\n        position: absolute;\n        left: 0;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        border-radius: 6px;\n        ",";\n        content: \"\";\n      "]),_templateObject8=_taggedTemplateLiteral(["min"],["min"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var OptionsView=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject);var OptionContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var last=_ref.last;return last?0:"4px";},function(_ref2){var isTourMode=_ref2.isTourMode;return isTourMode&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject3);});var Heading=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].h3(_templateObject4,function(props){return props.theme.direction;},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5);var MobileTourContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject6,function(_ref5){var tourBorder=_ref5.tourBorder;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7,tourBorder.border);},function(_ref6){var tourBorderAnimation=_ref6.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation(tourBorderAnimation.keyframe);});function formatSecondsToMinutes(seconds){var sec=parseInt(seconds||0,10);if(sec<60)return sec;return Math.floor(sec/60);}function calculateBids(_ref7){var balance=_ref7.balance,suggestedBids=_ref7.suggestedBids,percentBidThreshold=_ref7.percentBidThreshold,percentBids=_ref7.percentBids,maxBid=_ref7.maxBid,tradeMode=_ref7.tradeMode;if(tradeMode==="tournament"){return[1,5,25,50,100,300,500,1000,10000];}// если у нас есть минимум баланса и процентная сетка
if(percentBidThreshold&&percentBids){// баланс меньше threshold
// - возвращаем обычные suggestedBids
if(balance<percentBidThreshold){return suggestedBids;}// в противном случае выстраиваем сетку
var updatedSuggestedBids=percentBids.reduce(function(bids,percentage){var bid=Math.trunc(balance/100*percentage);bids.push(bid<maxBid?bid:maxBid);return bids;},[]);return __WEBPACK_IMPORTED_MODULE_6_lodash_uniq___default()(updatedSuggestedBids);}return suggestedBids;}function getNeighbourValues(value,list){var i=list.indexOf(value);var l=list.length;if(i<0){var min=null;var max=null;list.forEach(function(item){if(value>item){min=item;}else if(max===null){max=item;}});return[min===null?null:Math.max(list[0],min),max===null?null:Math.min(list[l-1],max)];}else if(i<1){return[null,l>i+1?list[i+1]:null];}else if(i+1<l){return[list[i-1],list[i+1]];}else{return[list[i-1],null];}}var Settings=function(_React$Component){_inherits(Settings,_React$Component);function Settings(){var _ref8,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Settings);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref8=Settings.__proto__||Object.getPrototypeOf(Settings)).call.apply(_ref8,[this].concat(args))),_this),_this.state={localTimeDiff:0,localTime:Date.now()},_this.getServerTime=function(){return Object(__WEBPACK_IMPORTED_MODULE_8__common_fetch__["d" /* get */])("/api/server-time").catch(console.log);},_this.synchronizeOurWatches=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var serverTime,diff;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return _this.getServerTime();case 3:serverTime=_context.sent;diff=Date.now()-Number(serverTime.time)*1000;_this.setState({localTimeDiff:diff});_context.next=11;break;case 8:_context.prev=8;_context.t0=_context["catch"](0);console.log(_context.t0);case 11:case"end":return _context.stop();}}},_callee,_this2,[[0,8]]);})),_this.tick=function(){_this.setState({localTime:Date.now()});},_this.originalAmount=__WEBPACK_IMPORTED_MODULE_1_react__["createRef"](null),_this.originalTime=__WEBPACK_IMPORTED_MODULE_1_react__["createRef"](null),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Settings,[{key:"componentDidMount",value:function componentDidMount(){this.synchronizeOurWatches();this.timer=setInterval(this.tick,1000);if(this.props.isDealAmountValid===false){this.props.validateDealAmount(true);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.timer);}},{key:"render",value:function render(){var _this3=this;var _props=this.props,activeAccount=_props.activeAccount,active_tournament=_props.active_tournament,percentBids=_props.percentBids,suggestedBids=_props.suggestedBids,percentBidThreshold=_props.percentBidThreshold,intervals=_props.possibleIntervals,currentBid=_props.currentBid,currentInterval=_props.currentInterval,onSettingsUpdate=_props.onSettingsUpdate,className=_props.className,tradeMode=_props.tradeMode,children=_props.children,tourInterval=_props.tourInterval,onTourIntervalChange=_props.onTourIntervalChange;var MIN_BID_VALUE=0;var MAX_BID_VALUE=tradeMode==="tournament"?50000:activeAccount&&activeAccount.type==="demo"?Infinity:this.props.maxBidVolume;var bidsToPopulate=calculateBids({percentBids:percentBids,percentBidThreshold:percentBidThreshold,suggestedBids:suggestedBids,tradeMode:tradeMode,maxBid:MAX_BID_VALUE,balance:activeAccount&&parseFloat(activeAccount.balance)});var possibleIntervals=intervals;if(tradeMode==="tournament"){var finish_date=__WEBPACK_IMPORTED_MODULE_2_idx___default()(active_tournament,function(t){return t.value.finish_date;});if(finish_date!=null){var endTime=__WEBPACK_IMPORTED_MODULE_5_moment___default()(finish_date*1000);var maxTime=__WEBPACK_IMPORTED_MODULE_5_moment___default.a.duration(endTime.diff(__WEBPACK_IMPORTED_MODULE_5_moment___default()(this.state.localTime-this.state.localTimeDiff))).asSeconds();if(maxTime>0){possibleIntervals=intervals.filter(function(item){return item<maxTime;});if(maxTime<currentInterval){onSettingsUpdate({currentInterval:possibleIntervals[possibleIntervals.length-1]});}}}}var _getNeighbourValues=getNeighbourValues(currentBid,bidsToPopulate),_getNeighbourValues2=_slicedToArray(_getNeighbourValues,2),prevBid=_getNeighbourValues2[0],nextBid=_getNeighbourValues2[1];var _getNeighbourValues3=getNeighbourValues(currentInterval,possibleIntervals),_getNeighbourValues4=_slicedToArray(_getNeighbourValues3,2),prevInterval=_getNeighbourValues4[0],nextInterval=_getNeighbourValues4[1];return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OptionsView,{className:className},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Tour__["b" /* default */],{step:["selectAmount","amountRecommendation"],originalRef:this.originalAmount},function(_ref10){var next=_ref10.next,isOriginal=_ref10.isOriginal,isTourMode=_ref10.isTourMode,tour=_ref10.tour;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OptionContainer,{ref:isOriginal?_this3.originalAmount:null,isTourMode:isTourMode},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Amount"),":");}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__SelectWithInput__["a" /* default */],{tour:tour,isOriginal:isOriginal,ref:isOriginal?_this3.originalAmount:null,disabled:isTourMode,tradeMode:tradeMode,invalid:!_this3.props.isDealAmountValid,value:currentBid.toString(),onChange:function onChange(value){var v=parseInt(value||0,10);if(_this3.props.isDealAmountValid===false){_this3.props.validateDealAmount(true);}if(!isNaN(v)&&v>=MIN_BID_VALUE&&v<=MAX_BID_VALUE){next(v);onSettingsUpdate({currentBid:v});}else if(v>MAX_BID_VALUE){onSettingsUpdate({currentBid:MAX_BID_VALUE});}}},function(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["b" /* Options */],null,bidsToPopulate&&bidsToPopulate.map(function(bid){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Option */],{key:bid,value:bid},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Money__["b" /* default */],{currency:tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_14__Icons_Kuchka__["b" /* tournamentCurrency */]:null},bid));}));}):isOriginal?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SuggestingInput__["a" /* default */],{title:"Amount",ref:isOriginal?_this3.originalAmount:null,tradeMode:tradeMode,invalid:!_this3.props.isDealAmountValid,value:currentBid.toString(),prevValue:prevBid,nextValue:nextBid,onChange:function onChange(e){var v=parseInt(e.target.value||0,10);if(_this3.props.isDealAmountValid===false){_this3.props.validateDealAmount(true);}if(!isNaN(v)&&v>=MIN_BID_VALUE&&v<=MAX_BID_VALUE){onSettingsUpdate({currentBid:v});next();}else if(v>MAX_BID_VALUE){onSettingsUpdate({currentBid:MAX_BID_VALUE});}},useNativeSelect:true,suggestedValues:bidsToPopulate}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MobileTourContainer,{tourBorder:!isOriginal&&tour&&tour.borderStyles,tourBorderAnimation:!isOriginal&&tour&&tour.outside&&tour.borderStyles,onClick:tour.analyticsID!=="3001"?function(){return next(currentBid);}:null},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SuggestingInput__["a" /* default */],{title:"Amount",disableInput:true,isTourMode:isTourMode,ref:isOriginal?_this3.originalAmount:null,tradeMode:tradeMode,invalid:!_this3.props.isDealAmountValid,value:currentBid.toString(),prevValue:prevBid,nextValue:nextBid,onChange:function onChange(e){var v=parseInt(e.target.value||0,10);if(_this3.props.isDealAmountValid===false){_this3.props.validateDealAmount(true);}if(!isNaN(v)&&v>=MIN_BID_VALUE&&v<=MAX_BID_VALUE){onSettingsUpdate({currentBid:v});next(v);}else if(v>MAX_BID_VALUE){onSettingsUpdate({currentBid:MAX_BID_VALUE});}},useNativeSelect:true,suggestedValues:bidsToPopulate})));}));}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Tour__["b" /* default */],{step:["selectTime","timeRecommendation"],originalRef:this.originalTime},function(_ref11){var next=_ref11.next,isOriginal=_ref11.isOriginal,isTourMode=_ref11.isTourMode,tour=_ref11.tour;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OptionContainer,{ref:isOriginal?_this3.originalTime:null,isTourMode:isTourMode,last:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Time"),":");}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["c" /* default */],{tour:tour,isOriginal:isOriginal,value:isOriginal?isTourMode?formatSecondsToMinutes(tourInterval):formatSecondsToMinutes(currentInterval):formatSecondsToMinutes(tourInterval),onChange:function onChange(value){next();if(isOriginal){onSettingsUpdate({currentInterval:value});}else{onTourIntervalChange(value);}},currentInterval:parseInt(currentInterval||0,10)},function(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["b" /* Options */],null,isOriginal?possibleIntervals.map(function(interval){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Option */],{key:interval,value:interval},formatSecondsToMinutes(interval)," ",parseInt(interval||0,10)<60?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"sec"):parseInt(interval||0,10)<120||parseInt(interval||0,10)>600?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"min"):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"mins"));}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Option */],{key:10,value:10},formatSecondsToMinutes(10)," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"sec")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Option */],{key:15,value:15},formatSecondsToMinutes(15)," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"sec")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Select__["a" /* Option */],{key:30,value:30},formatSecondsToMinutes(30)," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"sec"))));}):isOriginal?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SuggestingInput__["a" /* default */],{disableInput:true,valueFormatFn:function valueFormatFn(value){return formatSecondsToMinutes(value);},value:isTourMode?tourInterval:currentInterval,prevValue:prevInterval,nextValue:nextInterval,onChange:function onChange(e){if(e.target instanceof HTMLSelectElement)next();onSettingsUpdate({currentInterval:parseInt(e.target.value,10)});},suffix:_this3.props.gettext(_templateObject8),useNativeSelect:true,suggestedValues:possibleIntervals}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MobileTourContainer,{tourBorder:tour&&tour.borderStyles,tourBorderAnimation:tour&&tour.outside&&tour.borderStyles,onClick:tour.analyticsID!=="3001"?next:null},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SuggestingInput__["a" /* default */],{disableInput:true,valueFormatFn:function valueFormatFn(value){return formatSecondsToMinutes(value);},value:tourInterval,isTourMode:isTourMode,prevValue:prevInterval,nextValue:nextInterval,onChange:function onChange(e){if(e.target instanceof HTMLSelectElement)next();if(isOriginal){onSettingsUpdate({currentInterval:parseInt(e.target.value,10)});}else{onTourIntervalChange(parseInt(e.target.value,10));}},suffix:_this3.props.gettext(_templateObject8),useNativeSelect:true,suggestedValues:[10,15,30]})));}));})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Profit__["a" /* default */],{tradeMode:tradeMode,bid:currentBid});}}),children);}}]);return Settings;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["g" /* withGettext */])(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Tournaments_Api__["a" /* ActiveTournament */],null,function(active_tournament){var key=props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_2_idx___default()(active_tournament,function(stats){return stats.value.account.id;}):props.activeAccount&&props.activeAccount.id||0;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Settings,Object.assign({},props,{active_tournament:active_tournament,key:key}));});}));

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Private__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_common_Refund__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_HistoryPages_HistoryPage__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_HistoryPages_Period__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_HistoryPages_HistorySelect__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_HistoryPages_Statistics__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_HistoryPages_HistoryTable__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_Trade_OperationCheque__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_HistoryPages_shared_styles__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_Icons_Kuchka__ = __webpack_require__(39);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  font-weight: 700;\n  color: ",";\n"],["\n  font-weight: 700;\n  color: ",";\n"]);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BidType=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].span(_templateObject,function(_ref){var theme=_ref.theme,bidType=_ref.bidType;switch(bidType){case true:return theme.upper;case false:return theme.lower;default:return theme.ticksFontColor;}});function TradingHistory(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState2=_slicedToArray(_useState,2),data=_useState2[0],setData=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])("empty"),_useState4=_slicedToArray(_useState3,2),status=_useState4[0],setStatus=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(15),_useState6=_slicedToArray(_useState5,2),page_size=_useState6[0],setPageSize=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(-1),_useState8=_slicedToArray(_useState7,2),pages=_useState8[0],setPages=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState10=_slicedToArray(_useState9,2),page=_useState10[0],setPage=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState12=_slicedToArray(_useState11,2),loading=_useState12[0],setLoading=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_4_moment___default()().subtract(14,"days")),_useState14=_slicedToArray(_useState13,2),startDate=_useState14[0],setStartDate=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(__WEBPACK_IMPORTED_MODULE_4_moment___default()()),_useState16=_slicedToArray(_useState15,2),endDate=_useState16[0],setEndDate=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState18=_slicedToArray(_useState17,2),selectedAccount=_useState18[0],setSelectedAccount=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])([]),_useState20=_slicedToArray(_useState19,2),options=_useState20[0],setOptions=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(window.innerWidth),_useState22=_slicedToArray(_useState21,2),windowWidth=_useState22[0],setWindowWidth=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState24=_slicedToArray(_useState23,2),errorText=_useState24[0],setErrorText=_useState24[1];var _useState25=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),isTournament=_useState26[0],setIsTournament=_useState26[1];function updateState(){var _data=Array.from(arguments);_data.forEach(function(state){switch(state.key){default:case"startDate":setStartDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(state.value));break;case"endDate":setEndDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(state.value));break;}});}var requestBinaryHistory=function requestBinaryHistory(){setLoading(true);var params={page:page,page_size:page_size,date_from:startDate.locale("en").format("DD/MM/YYYY"),date_till:endDate.locale("en").format("DD/MM/YYYY")};Object(__WEBPACK_IMPORTED_MODULE_10__components_common_fetch__["d" /* get */])("/api/trading-history?"+__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(params)).then(function(json){var _json$data=json.data,_data=_json$data===undefined?[]:_json$data,_json$pages=json.pages,_pages=_json$pages===undefined?-1:_json$pages,status=json.status;if(status==="ERROR"){var _errorText=json["0"];setErrorText(_errorText);}else{setErrorText(null);}setStatus("resolved");setLoading(false);setData(_data);setPages(_pages);setIsTournament(false);})// если у API ошибка, мы делаем catch
// и убираем лоадер, чтобы не смущал
.catch(function(error){setStatus("rejected");setLoading(false);setData([]);setPages(-1);setIsTournament(false);// а также логируем полученную ошибку
console.error(error);});};var requestTournamentHistory=function requestTournamentHistory(){setLoading(true);var params={limit:page_size,offset:page_size*page,date_from:startDate.unix(),date_till:endDate.unix()};Object(__WEBPACK_IMPORTED_MODULE_10__components_common_fetch__["d" /* get */])("/api/tournaments/trading-history?"+__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(params)).then(function(json){var _json$payload=json.payload,payload=_json$payload===undefined?{}:_json$payload,status=json.status;if(status==="ERROR"){var _errorText=json["0"];setErrorText(_errorText);}else{setErrorText(null);}var _payload$items=payload.items,items=_payload$items===undefined?[]:_payload$items,_payload$count=payload.count,count=_payload$count===undefined?0:_payload$count;var _pages=Math.ceil(count/page_size);setStatus("resolved");setData(items);setPages(_pages);setLoading(false);setIsTournament(true);})// если у API ошибка, мы делаем catch
// и убираем лоадер, чтобы не смущал
.catch(function(error){setStatus("rejected");setData([]);setPages(-1);setLoading(false);setIsTournament(true);// а также логируем полученную ошибку
console.error(error);});};var setAccount=function setAccount(val){var value=val.value;var _selectedAccount=options.find(function(acc){return acc.value===value;});setSelectedAccount(Array.isArray(_selectedAccount)?_selectedAccount[0]:_selectedAccount);};var handleResize=function handleResize(e){setWindowWidth(window.innerWidth);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){setPage(0);},[startDate,endDate,page_size,selectedAccount]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){window.addEventListener("resize",handleResize);return function(){window.removeEventListener("resize",handleResize);if(document.body)document.body.style.overflow="";};},[windowWidth]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_10__components_common_fetch__["d" /* get */])("/api/getAccounts").then(function(json){var _selectedAccount=void 0;var _options=json.accounts.reduce(function(acc,curr,i){var label=curr.type==="demo"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Demo account"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Real account");if(curr.isActive)_selectedAccount={value:curr.id,label:label};acc.push({value:curr.id,label:label});return acc;},[]);if(__WEBPACK_IMPORTED_MODULE_18__FeatureFlags__["a" /* default */].enableTournaments===true){if(props.tradeMode==="tournament"){_selectedAccount={value:"tournament",label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Tournaments")};}setSelectedAccount(_selectedAccount);setIsTournament(_selectedAccount==="tournament");setOptions([].concat(_toConsumableArray(_options),[{value:"tournament",label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Tournaments")}]));}else{setSelectedAccount(_selectedAccount);setIsTournament(false);setOptions([].concat(_toConsumableArray(_options)));}});},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(selectedAccount!=null){if(__WEBPACK_IMPORTED_MODULE_18__FeatureFlags__["a" /* default */].enableTournaments===true&&selectedAccount.value==="tournament"){return requestTournamentHistory();}Object(__WEBPACK_IMPORTED_MODULE_10__components_common_fetch__["d" /* get */])("/ajax/setAccount?id="+selectedAccount.value).then(function(){return requestBinaryHistory();});}},[page,page_size,selectedAccount,startDate,endDate]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(selectedAccount!=null&&status==="empty"){if(__WEBPACK_IMPORTED_MODULE_18__FeatureFlags__["a" /* default */].enableTournaments===true&&selectedAccount.value==="tournament"){requestTournamentHistory();}else{requestBinaryHistory();}}},[status]);if(selectedAccount===""){return null;}var currency=isTournament?__WEBPACK_IMPORTED_MODULE_22__components_Icons_Kuchka__["b" /* tournamentCurrency */]:null;// колонки, в которые потом рендерятся наши замечательные данные
var columns=[{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"ID"),accessor:"id",show:windowWidth<960?false:true,style:{fontFamily:"Tahoma, Roboto, Arial, sans-serif"}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Period"),accessor:"op_interval",show:windowWidth<480?false:true,minWidth:windowWidth<960?62:74,Cell:function Cell(_ref2){var row=_ref2.row;var op_interval=row.op_interval;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,op_interval>59?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,op_interval/60,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"min")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,op_interval,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"sec")));}},{Header:windowWidth<960?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Opening"),"-",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Closing")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Opening"),accessor:"open_timestamp",minWidth:114,style:{overflow:"visible",flexWrap:"wrap",whiteSpace:"normal"},Cell:function Cell(_ref3){var row=_ref3.row;var open_timestamp=row.open_timestamp,close_timestamp=row.close_timestamp;// Я убрал проверку на наличие времени закрытия, потому что не заметил
// чтобы апи отдавал незакрытые сделки
var openTime=__WEBPACK_IMPORTED_MODULE_4_moment___default()(open_timestamp*1000);var closeTime=__WEBPACK_IMPORTED_MODULE_4_moment___default()(close_timestamp*1000);if(windowWidth<960){if(openTime.isSame(closeTime,"day")){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,openTime.format("DD/MM/YYYY"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),openTime.format("HH:mm")," \u2014 ",closeTime.format("HH:mm"));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,openTime.format("DD/MM/YYYY HH:mm")," \u2014"," ",closeTime.format("DD/MM/YYYY HH:mm"));}}else{return openTime.format("DD/MM/YYYY HH:mm");}}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Closing"),accessor:"close_timestamp",minWidth:114,style:{whiteSpace:"normal"},show:windowWidth<960?false:true,Cell:function Cell(_ref4){var row=_ref4.row;var close_timestamp=row.close_timestamp;var closeTime=__WEBPACK_IMPORTED_MODULE_4_moment___default()(close_timestamp*1000);return closeTime.format("DD/MM/YYYY HH:mm");}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Asset"),accessor:"stock",style:{fontWeight:windowWidth<960?700:400,color:"#000"}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Type"),accessor:"op_type",minWidth:windowWidth<960?34:74,Cell:function Cell(_ref5){var row=_ref5.row;var BID_TYPE_MOBILE=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",fillRule:"evenodd",width:"16px",height:"16px",viewBox:"0 0 16 16",fill:"currentColor"},row.op_type===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M15.992,13.993 L15.992,0.001 L1.999,0.001 L1.999,3.998 L9.426,3.998 L0.618,12.807 L3.186,15.376 L11.995,6.567 L11.995,13.993 L15.992,13.993 Z"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M15.992,1.990 L15.992,15.982 L1.999,15.982 L1.999,11.985 L9.426,11.985 L0.618,3.176 L3.186,0.607 L11.995,9.416 L11.995,1.990 L15.992,1.990 Z"}));var BID_TYPE_DESKTOP=row.op_type===1?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Upper"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"lower");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BidType,{bidType:row.op_type===1},windowWidth<960?BID_TYPE_MOBILE:BID_TYPE_DESKTOP);}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Difference"),accessor:"diff",show:windowWidth<960?false:true},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Amount"),accessor:"amount",show:windowWidth<480?false:true,style:{fontWeight:"bold",color:"#000"},Cell:function Cell(_ref6){var row=_ref6.row;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Money__["b" /* default */],{currency:currency},row.amount);}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Result"),accessor:"profit",Cell:function Cell(_ref7){var row=_ref7.row;var profit=row.profit;var bidType=Math.sign(profit)!==-1;if(profit===0){bidType=null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BidType,{bidType:bidType},profit!==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Money__["b" /* default */],{currency:currency},profit):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_common_Refund__["a" /* default */],null));}},{Header:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Balance"),accessor:"balance",show:windowWidth<480?false:true,style:{color:"#4e2a81"},Cell:function Cell(_ref8){var row=_ref8.row;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Money__["b" /* default */],{currency:currency},row.balance);}}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_HistoryPages_HistoryPage__["a" /* default */],{type:props.type,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Trading history")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_HistoryPages_shared_styles__["b" /* CalendarContainer */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_HistoryPages_shared_styles__["c" /* CalendarInner */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 959px)",render:function render(){return(/* DESKTOP */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HistoryPages_Period__["a" /* default */],{windowWidth:windowWidth,startDate:startDate,endDate:endDate,updateState:updateState}));}}),props.showDeposit===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_HistoryPages_HistorySelect__["b" /* default */]// async
,{name:"account-select",value:selectedAccount,options:options,onChange:setAccount,disabled:!props.showDeposit},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Account"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_HistoryPages_shared_styles__["a" /* Button */],{onClick:function onClick(){setPage(0);setStatus("empty");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Show")):/* MOBILE */props.showDeposit===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HistoryPages_Statistics__["a" /* default */],null);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 959px)"},function(matches){return matches?/* DESKTOP */props.showDeposit===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_HistoryPages_Statistics__["a" /* default */],null):/* MOBILE */__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_HistoryPages_shared_styles__["h" /* MobilePeriodInner */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components_HistoryPages_Period__["a" /* default */],{windowWidth:windowWidth,startDate:startDate,endDate:endDate,updateState:updateState}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__components_HistoryPages_shared_styles__["a" /* Button */],{onClick:function onClick(){setPage(0);setStatus("empty");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_common_Gettext__["b" /* default */],null,"Show")));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_HistoryPages_HistoryTable__["a" /* default */],{type:props.type,columns:columns,column:{minWidth:windowWidth<960?62:94},loading:loading,pages:pages,data:data,manual:true,startDate:startDate,endDate:endDate,errorText:errorText,page:page,pageSize:page_size,onPageChange:function onPageChange(_ref9){var selected=_ref9.selected;setPage(selected);},onPageSizeChange:function onPageSizeChange(pageSize){setPageSize(pageSize);},onClick:function onClick(e,handleOriginal){props.showModal(__WEBPACK_IMPORTED_MODULE_19__components_Trade_OperationCheque__["a" /* default */],{operation:e,type:selectedAccount.value==="tournament"?"tournament":"binary"});if(handleOriginal){handleOriginal();}}}));}var _TradingHistory=function _TradingHistory(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__components_common_ModalProvider__["a" /* ModalConsumer */],null,function(modal){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradingHistory,Object.assign({},props,{showModal:modal.showModal}));});};var mapStateToProps=function mapStateToProps(state){return{tradeMode:state.settings.mode};};/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_7__components_Private__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11__components_withData__["a" /* default */])(["profile"])(Object(__WEBPACK_IMPORTED_MODULE_12__components_common_withDeposit__["b" /* withDeposit */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(_TradingHistory)))));

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getStats */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_hooks__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Info__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Modal__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TradeModals_CompensationPopup__ = __webpack_require__(708);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n"],["\n  width: 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: ",";\n  margin-top: -16px;\n  padding: 0 16px;\n"],["\n  direction: ",";\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: ",";\n  margin-top: -16px;\n  padding: 0 16px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n"],["\n  font-size: ",";\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 21px;\n  padding-top: 5px;\n\n  ",";\n\n  > svg {\n    ",";\n\n    :last-of-type {\n      ",";\n    }\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 21px;\n  padding-top: 5px;\n\n  ",";\n\n  > svg {\n    ",";\n\n    :last-of-type {\n      ",";\n    }\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n      justify-content: flex-start;\n      padding-left: 16px;\n      padding-right: 16px;\n    "],["\n      justify-content: flex-start;\n      padding-left: 16px;\n      padding-right: 16px;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  height: 16px;\n  color: ",";\n"],["\n  height: 16px;\n  color: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  justify-content: flex-start;\n  height: 16px;\n  padding-top: 0;\n"],["\n  justify-content: flex-start;\n  height: 16px;\n  padding-top: 0;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  padding: 15px 28px 0 28px;\n"],["\n  padding: 15px 28px 0 28px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  margin-top: 8px;\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  margin-top: 8px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var ProtectionContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.direction;},function(_ref2){var isLandscape=_ref2.isLandscape;return isLandscape?"flex-end":"space-between";});var ProtectionText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref3){var theme=_ref3.theme;return theme.compensationSubtitle;});var ShieldsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref4){var isLandscape=_ref4.isLandscape;return isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["c" /* rtl */])("margin-right","4px"),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["c" /* rtl */])("margin-right",0));var InfoIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref5){var theme=_ref5.theme;return theme.compensationInfoIcon;});var DesktopShieldsContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(ShieldsContainer)(_templateObject7);var DesktopContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var DesktopInfoContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var InfoIcon=function InfoIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_Info__["b" /* default */],{width:16,height:16,style:{cursor:"pointer",marginLeft:3},onClick:props.onClick});};var getStats=function getStats(compensations,typeAccount){if(compensations!=null&&compensations[typeAccount]&&typeAccount){return compensations[typeAccount].stats;}};var ProtectionInfo=__WEBPACK_IMPORTED_MODULE_0_react___default.a.memo(function(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),showPopup=_useState2[0],setShowPopup=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),showAllUsedPopup=_useState4[0],setShowAllUsedPopup=_useState4[1];var compensationUpdated=props.compensationUpdated,compensationCreated=props.compensationCreated,isDesktop=props.isDesktop,isLandscape=props.isLandscape,activeAccount=props.activeAccount;var typeAccount=activeAccount&&activeAccount.type;var compensations=Object(__WEBPACK_IMPORTED_MODULE_6__index__["b" /* useCompensations */])([compensationUpdated,compensationCreated]);var availableCompensations=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_7__Popup__["b" /* comps */])(compensations,"available",typeAccount);},[typeAccount,compensations]);var usedCompensations=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_7__Popup__["b" /* comps */])(compensations,"used",typeAccount);},[typeAccount,compensations]);var compensationsStats=getStats(compensations,typeAccount);var _useLocalStorage=Object(__WEBPACK_IMPORTED_MODULE_4__common_hooks__["a" /* useLocalStorage */])("showed_all_used_compensations_popup",false),_useLocalStorage2=_slicedToArray(_useLocalStorage,2),allUsedPopupIsShowed=_useLocalStorage2[0],setAllUsedPopupIsShowed=_useLocalStorage2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(Number(availableCompensations)===0&&Number(usedCompensations)>0&&typeAccount==="demo"&&!allUsedPopupIsShowed){setShowAllUsedPopup(true);setAllUsedPopupIsShowed(true);}},[availableCompensations]);if(compensations==null||compensations.items&&compensations.items.length===0||availableCompensations<1&&(typeAccount==="real"||showAllUsedPopup===false)){return null;}return isDesktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesktopContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtectionText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Protection:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Modal__["a" /* Modal */],{mode:showAllUsedPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TradeModals_CompensationPopup__["a" /* default */],{availableCompensations:availableCompensations,usedCompensations:usedCompensations,profit:compensationsStats&&compensationsStats.profit,compensated:compensationsStats&&compensationsStats.compensated,onClose:function onClose(){return setShowAllUsedPopup(false);},compensations:compensations})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesktopInfoContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesktopShieldsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* Shields */],{availableCompensations:availableCompensations,usedCompensations:usedCompensations})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIcon,{onClick:function onClick(){return setShowPopup(true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Modal__["a" /* Modal */],{mode:showPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Popup__["c" /* default */],{onDismiss:function onDismiss(){return setShowPopup(false);},popupType:"refill",compensations:compensations,isDesktop:isDesktop,isInfo:true,activeAccount:activeAccount}))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShieldsContainer,{isLandscape:isLandscape},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* Shields */],{availableCompensations:availableCompensations,usedCompensations:usedCompensations})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtectionContainer,{isLandscape:isLandscape},!isLandscape&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProtectionText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Protection:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Modal__["a" /* Modal */],{mode:showAllUsedPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TradeModals_CompensationPopup__["a" /* default */],{availableCompensations:availableCompensations,usedCompensations:usedCompensations,profit:compensationsStats&&compensationsStats.profit,compensated:compensationsStats&&compensationsStats.compensated,onClose:function onClose(){return setShowAllUsedPopup(false);},compensations:compensations})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InfoIcon,{onClick:function onClick(){return setShowPopup(true);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Modal__["a" /* Modal */],{mode:showPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Popup__["c" /* default */],{onDismiss:function onDismiss(){return setShowPopup(false);},popupType:"refill",compensations:compensations,isDesktop:isDesktop,disableOutside:false,isInfo:true,activeAccount:activeAccount})))));});/* harmony default export */ __webpack_exports__["a"] = (ProtectionInfo);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__News__ = __webpack_require__(2013);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__News__["a" /* default */]);

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sound; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coins_mp3__ = __webpack_require__(2014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__coins_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__coins_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paper_mp3__ = __webpack_require__(2015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__paper_mp3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__paper_mp3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iosAudioContext__ = __webpack_require__(2016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__iosAudioContext___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__iosAudioContext__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Audio=function(_React$Component){_inherits(Audio,_React$Component);function Audio(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Audio);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Audio.__proto__||Object.getPrototypeOf(Audio)).call.apply(_ref,[this].concat(args))),_this),_this.state={stavkaBuffer:null,stavkaLoaded:false,looseBuffer:null,looseLoaded:false},_this.load=function(url){return new Promise(function(resolve,reject){var request=new XMLHttpRequest();request.open('GET',url,true);request.responseType='arraybuffer';request.onload=function(){_this.audioContext.decodeAudioData(request.response,resolve,reject);};request.send();});},_this.play=function(buffer){var source=_this.audioContext.createBufferSource();source.buffer=buffer;source.connect(_this.audioContext.destination);source.start(0);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Audio,[{key:"UNSAFE_componentWillMount",value:function UNSAFE_componentWillMount(){var _this2=this;this.audioContext=new(window.AudioContext||window.webkitAudioContext)();window.audioctx=this.audioContext;this.load(__WEBPACK_IMPORTED_MODULE_2__coins_mp3___default.a).then(function(buffer){return _this2.setState({stavkaBuffer:buffer,stavkaLoaded:true});}).catch(function(error){return console.error(error);});this.load(__WEBPACK_IMPORTED_MODULE_3__paper_mp3___default.a).then(function(buffer){return _this2.setState({looseBuffer:buffer,looseLoaded:true});}).catch(function(error){return console.error(error);});}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.audioContext&&typeof this.audioContext.close==="function"&&this.audioContext.close();}},{key:"render",value:function render(){var _this3=this;var _state=this.state,stavkaBuffer=_state.stavkaBuffer,stavkaLoaded=_state.stavkaLoaded,looseBuffer=_state.looseBuffer,looseLoaded=_state.looseLoaded;if(!(stavkaLoaded&&looseLoaded))return null;if(this.props.queue.length){this.audioContext&&typeof this.audioContext.resume==="function"&&this.audioContext.resume();this.props.queue.forEach(function(soundEvent){switch(soundEvent.type){case"PLAY_WIN_SOUND":_this3.play(stavkaBuffer);_this3.props.finishSound(soundEvent.id);break;case"PLAY_LOOSE_SOUND":_this3.play(looseBuffer);_this3.props.finishSound(soundEvent.id);break;default:return null;}});}return null;}}]);return Audio;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);;var _Sound=function(_React$Component2){_inherits(_Sound,_React$Component2);function _Sound(){_classCallCheck(this,_Sound);return _possibleConstructorReturn(this,(_Sound.__proto__||Object.getPrototypeOf(_Sound)).apply(this,arguments));}_createClass(_Sound,[{key:"UNSAFE_componentWillMount",value:function UNSAFE_componentWillMount(){this.props.dispatch({type:this.props.play,id:Date.now()});}},{key:"render",value:function render(){return null;}}]);return _Sound;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);;var Sound=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(_Sound);/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){if(state.settings.sound){return{queue:state.audio.queue};}return{queue:[]};},function(dispatch){return{finishSound:function finishSound(timestamp){dispatch({type:"REMOVE_SOUND",payload:timestamp});}};})(Audio));

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IndicatorPopup__ = __webpack_require__(2019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ATRPopup__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MovingAveragePopup__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ParabolicSARPopup__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AlligatorPopup__ = __webpack_require__(2020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__BollingerLinesPopup__ = __webpack_require__(2021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RSIPopup__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__MACDPopup__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ROCPopup__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StochasticPopup__ = __webpack_require__(866);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var OverheadInfo=function OverheadInfo(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ToolsContent__["a" /* Info */],{isOverhead:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ToolsContent__["c" /* Svg */],{version:"1.1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 1000 1000",fill:"currentColor",width:"22",height:"22"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M929.9,344.8c0-57-66.5-101.7-151.3-101.7c-36.5,0-70.7,8.4-97.8,23.7c-26.6-19.7-56.6-35.2-88.8-45.4c12-27.2,18.8-58.2,18.8-87.6C610.7,48.3,555.1,10,500,10c-55.1,0-110.7,38.3-110.7,123.8c0,29.5,6.7,60.4,18.8,87.6c-32.2,10.2-62.2,25.7-88.8,45.4c-27.2-15.4-61.4-23.8-97.8-23.8c-84.9,0-151.3,44.7-151.3,101.7c0,26.3,21.4,44,63.7,52.6c24.3,4.9,54,6.7,81.2,7.4c-12.5,33.3-19.4,69.3-19.4,106.9c0,49.2,11.8,104.9,32.7,159c-16.1,4.8-32.2,11.7-47.3,20.5c-33.8,19.5-61,46.5-76.4,75.8c-16.8,31.9-18.1,63.1-3.8,87.9c5.6,9.8,14.6,16.6,26,19.6c4.8,1.3,9.9,1.9,15.4,1.9c39.4,0,96.4-31.1,160.8-68.5c0.7-0.4,1.3-0.8,2-1.2c52.9,67.1,114.9,106.1,178.3,112v54.5c0,9.3,7.6,16.9,16.9,16.9s16.9-7.6,16.9-16.9v-54.5c63.4-5.9,125.4-44.9,178.3-112c0.7,0.4,1.3,0.8,2,1.2c64.3,37.4,121.4,68.5,160.8,68.5c5.5,0,10.6-0.6,15.4-1.9c11.4-3,20.4-9.8,26-19.6c28.5-49.4-6.7-121.3-80.2-163.7c-15.2-8.7-31.2-15.7-47.3-20.5c20.9-54,32.7-109.8,32.7-159c0-37.6-6.9-73.6-19.4-106.9c27.2-0.7,56.9-2.4,81.2-7.4C908.5,388.8,929.9,371.1,929.9,344.8z M770.6,511.6c0,6-0.2,12.1-0.6,18.3H643.6L584.7,428l107.1-107.1C740.5,369.9,770.6,437.3,770.6,511.6z M689.1,757.5L588.2,656.6l53.7-93h124.3C756,627.6,728.3,698.5,689.1,757.5z M233.6,562.3h123.8l54.5,94.3L310.9,757.5C271.4,698.1,243.6,626.6,233.6,562.3z M229.4,511.6c0-72.2,28.4-137.9,74.7-186.5l108.2,108.2l-55,95.3H229.9C229.5,522.8,229.4,517.1,229.4,511.6z M500,241c62.8,0,120.6,21.5,166.5,57.5L551.7,413.3H440L328.9,302.1C375.5,263.9,435.1,241,500,241z M443.3,643.6l-56.7-98.3l56.7-98.3h113.5l56.7,98.3l-56.7,98.3H443.3L443.3,643.6z M423.1,133.8c0-55.5,29.5-90,76.9-90c47.4,0,76.9,34.5,76.9,90c0,26.4-6.7,55.1-18.3,79.1c-19-3.7-38.6-5.7-58.6-5.7s-39.6,2-58.6,5.7C429.8,188.9,423.1,160.1,423.1,133.8z M140.5,364.3c-22.9-4.7-36.6-12-36.6-19.5c0-36.8,53.8-67.9,117.6-67.9c25.2,0,49.5,4.9,69.6,13.6c-24.6,23.2-45.3,50.5-61.1,80.8C200.7,370.9,166.5,369.6,140.5,364.3z M142.9,842.6c-2.7,0-5.3-0.3-7.5-0.9c-3.4-0.9-4.6-2.4-5.5-3.8c-8.3-14.4-6.7-34.1,4.4-55.3c12.5-23.8,35-45.9,63.4-62.3c14-8.1,28.9-14.3,43.6-18.4c11.8,25.8,25.6,50.8,41.2,74.1c0.7,1.1,1.4,2.1,2.2,3.2C242.7,803.7,175.4,842.6,142.9,842.6z M500,885.7c-63.9,0-122.7-41.5-169-100.5l107.8-107.8h122.4L669,785.2C622.7,844.2,563.9,885.7,500,885.7z M802.2,720.3c55.2,31.9,86.3,85.7,67.9,117.6c-0.8,1.5-2.1,2.9-5.5,3.8c-28.4,7.6-103.7-36-149.4-62.6c0.7-1.1,1.5-2.1,2.2-3.2c15.5-23.3,29.4-48.3,41.2-74.1C773.3,706,788.2,712.2,802.2,720.3z M770.1,371.2c-15.8-30.3-36.5-57.5-61.1-80.8c20.1-8.8,44.4-13.6,69.6-13.6c63.7,0,117.6,31.1,117.6,67.9c0,7.6-13.7,14.9-36.6,19.5C833.5,369.6,799.2,370.9,770.1,371.2z"}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Usage of a large quantity of analysis instruments may lead to performance losses and incorrect displaying of a chart.")));};var ToolWrapper=function(_React$Component){_inherits(ToolWrapper,_React$Component);function ToolWrapper(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ToolWrapper);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ToolWrapper.__proto__||Object.getPrototypeOf(ToolWrapper)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeTool:_this.props.activeToolInitial||"chartType",instruments:_this.props.instrumentsInitial||"settings",settings:_this.props.activeToolParams?_this.props.settings.indicators.map(function(indicator,id){return Object.assign({},indicator,{id:id});}).filter(function(indicator){return indicator.id===parseInt(_this.props.activeToolParams[1],10);})[0]:null},_this.changeActiveTool=function(key){_this.setState({activeTool:key});},_this.addHeikenAshi=function(){var newPayload={type:"HeikenAshi",isOscillator:true};_this.onSubmit(newPayload);},_this.handlePopupOpen=function(key,settings){if(key==="HeikenAshi"){return _this.addHeikenAshi();}_this.setState({instruments:key,settings:settings});},_this.handlePopupClose=function(){_this.setState({instruments:"settings"});if(_this.props.instrumentsInitial){_this.props.onCompletelyClose();}},_this.onSubmit=function(payload){var indicators=_this.props.settings.indicators.filter(function(ind){return ind.type===payload.type;});// При редактировании существующего идтикатора
// (если получили this.props.settings)
// у объекта удаляем id, что бы сравнение корректно отработало
// после сравнения, id опять добавляем
// Желающие могут отрефакторить =)
var cleanIndicator=function cleanIndicator(_indicator){var indicator=Object.assign({},_indicator);if("id"in indicator){delete indicator.id;}if("enabled"in indicator){delete indicator.enabled;}return indicator;};if(_this.state.settings!=null){if(payload===indicators[payload.id]){_this.handlePopupClose();}else{for(var i=0;i<indicators.length;i++){if(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(cleanIndicator(payload),cleanIndicator(indicators[i])))return _this.handlePopupClose();}payload.id=_this.state.settings.id;payload.enabled=true;_this.props.dispatch({type:"UPDATE_INDICATOR",payload:payload});_this.handlePopupClose();}}else{for(var _i=0;_i<indicators.length;_i++){if(__WEBPACK_IMPORTED_MODULE_3_lodash_isEqual___default()(cleanIndicator(payload),cleanIndicator(indicators[_i])))return _this.handlePopupClose();}_this.props.dispatch({type:"PUSH_INDICATOR",payload:payload});_this.handlePopupClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ToolWrapper,[{key:"render",value:function render(){var _this2=this;var changeActiveTool=this.changeActiveTool,handlePopupOpen=this.handlePopupOpen;var TOOLS=[{key:"chartType",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Chart type"),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Each chart type allows you to use some specific strategies.")," ","irontrade"!=="eztrader"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */],{to:"/helpdesk/skilled#strategy",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Learn more about strategies.")))},{key:"lineThickness",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Chart line"),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Choose the thickness of a chart line in pixels.")},{key:"lineColor",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Chart color"),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Choose a color of a chart line or zone in pixels.")},{key:"interval",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Intervals"),info:this.props.settings.chartType==="bar"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Choose time interval for building one bar."):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Choose time interval for building one candle.")},{key:"sentiments",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"\"Traders' mood\""),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"The indicator shows a rough percentage of people choosing Upper or Lower options.")},{key:"indicators",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Indicators"),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"These tools will help you to determine how the price of an asset will move further.")," ","irontrade"!=="eztrader"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */],{to:"/helpdesk/knowledge_base#kb_i",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Learn more about indicators.")))},{key:"theme",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Themes"),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Choose the preferable color theme for you."),hide:"irontrade"==="eztrader"},{key:"sound",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Sound effects"),info:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"E.g. sound is used on operation closing events")}];var activeToolObj=TOOLS.find(function(tool){return tool.key===_this2.state.activeTool;});var POPUPS={ATR:{template:__WEBPACK_IMPORTED_MODULE_7__ATRPopup__["a" /* default */],title:__WEBPACK_IMPORTED_MODULE_7__ATRPopup__["b" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_7__ATRPopup__["c" /* initialState */],validation:{period:function period(_period){return _period>0;}},onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"ATR",isOscillator:true});_this2.onSubmit(newPayload);}},RSI:{template:__WEBPACK_IMPORTED_MODULE_12__RSIPopup__["a" /* default */],title:__WEBPACK_IMPORTED_MODULE_12__RSIPopup__["b" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_12__RSIPopup__["c" /* initialState */],validation:{period:function period(_period2){return _period2>0;},oversold:function oversold(_oversold){return _oversold>0&&_oversold<100;},overbought:function overbought(_overbought){return _overbought>0&&_overbought<100;}},onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"RSI",isOscillator:true});_this2.onSubmit(newPayload);}},MACD:{template:__WEBPACK_IMPORTED_MODULE_13__MACDPopup__["a" /* default */],title:__WEBPACK_IMPORTED_MODULE_13__MACDPopup__["b" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_13__MACDPopup__["c" /* initialState */],validation:{fastPeriod:function fastPeriod(_fastPeriod){return _fastPeriod>0;},slowPeriod:function slowPeriod(_slowPeriod){return _slowPeriod>0;},period:function period(_period3){return _period3>0;}},onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"MACD",isOscillator:true});_this2.onSubmit(newPayload);}},ROC:{template:__WEBPACK_IMPORTED_MODULE_14__ROCPopup__["a" /* default */],title:__WEBPACK_IMPORTED_MODULE_14__ROCPopup__["b" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_14__ROCPopup__["c" /* initialState */],validation:{period:function period(_period4){return _period4>0;}},onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"ROC",isOscillator:true});_this2.onSubmit(newPayload);}},Stoch:{template:__WEBPACK_IMPORTED_MODULE_15__StochasticPopup__["a" /* default */],title:__WEBPACK_IMPORTED_MODULE_15__StochasticPopup__["b" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_15__StochasticPopup__["c" /* initialState */],validation:{periodK:function periodK(_periodK){return _periodK>0;},periodD:function periodD(_periodD){return _periodD>0;},slowing:function slowing(_slowing){return _slowing>0;},overbought:function overbought(_overbought2){return _overbought2>0&&_overbought2<100;},oversold:function oversold(_oversold2){return _oversold2>0&&_oversold2<100;}},onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"Stoch",isOscillator:true});_this2.onSubmit(newPayload);}},MovingAverage:{template:__WEBPACK_IMPORTED_MODULE_8__MovingAveragePopup__["b" /* default */],title:__WEBPACK_IMPORTED_MODULE_8__MovingAveragePopup__["c" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_8__MovingAveragePopup__["d" /* initialState */],validation:{period:function period(_period5){return _period5>0;}},info:__WEBPACK_IMPORTED_MODULE_8__MovingAveragePopup__["a" /* Info */],onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"MovingAverage",shift:0,rejection:0});_this2.onSubmit(newPayload);}},ParabolicSAR:{template:__WEBPACK_IMPORTED_MODULE_9__ParabolicSARPopup__["b" /* default */],title:__WEBPACK_IMPORTED_MODULE_9__ParabolicSARPopup__["c" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_9__ParabolicSARPopup__["d" /* initialState */],info:__WEBPACK_IMPORTED_MODULE_9__ParabolicSARPopup__["a" /* Info */],validation:{accelerationStep:function accelerationStep(_accelerationStep){return parseFloat(_accelerationStep)>0;},accelerationMaxValue:function accelerationMaxValue(_accelerationMaxValue){return parseFloat(_accelerationMaxValue)>0;}},onSubmit:function onSubmit(payload){var newPayload=Object.assign({},payload,{type:"ParabolicSAR",shift:0,rejection:0});_this2.onSubmit(newPayload);}},Alligator:{template:__WEBPACK_IMPORTED_MODULE_10__AlligatorPopup__["b" /* default */],title:__WEBPACK_IMPORTED_MODULE_10__AlligatorPopup__["c" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_10__AlligatorPopup__["d" /* initialState */],validation:{jaws_period:function jaws_period(_jaws_period){return _jaws_period>0;},jaws_shift:function jaws_shift(_jaws_shift){return _jaws_shift>0;},teeths_period:function teeths_period(_teeths_period){return _teeths_period>0;},teeths_shift:function teeths_shift(_teeths_shift){return _teeths_shift>0;},lips_period:function lips_period(_lips_period){return _lips_period>0;},lips_shift:function lips_shift(_lips_shift){return _lips_shift>0;}},info:__WEBPACK_IMPORTED_MODULE_10__AlligatorPopup__["a" /* Info */],onSubmit:function onSubmit(payload){var defaultLine={type:"MovingAverage",algorithm:"SMA",period:0,shift:0,rejection:0};var newPayload={type:"Alligator",enabled:payload.enabled,jaws:Object.assign({},defaultLine,payload.jaws),teeths:Object.assign({},defaultLine,payload.teeths),lips:Object.assign({},defaultLine,payload.lips)};_this2.onSubmit(newPayload);}},BollingerLines:{template:__WEBPACK_IMPORTED_MODULE_11__BollingerLinesPopup__["b" /* default */],title:__WEBPACK_IMPORTED_MODULE_11__BollingerLinesPopup__["c" /* indicatorTitle */],initialState:__WEBPACK_IMPORTED_MODULE_11__BollingerLinesPopup__["d" /* initialState */],validation:{period:function period(_period6){return _period6>0;},rejection:function rejection(_rejection){return _rejection>0;}},info:__WEBPACK_IMPORTED_MODULE_11__BollingerLinesPopup__["a" /* Info */],onSubmit:function onSubmit(payload){var defaultLine={type:"MovingAverage",algorithm:"SMA",period:payload.period,shift:0,rejection:0};var newPayload={type:"BollingerLines",enabled:payload.enabled,period:payload.period,rejection:payload.rejection,upper:Object.assign({},defaultLine,{rejection:payload.rejection,strokeWidth:payload.upper.strokeWidth,color:payload.upper.color}),middle:Object.assign({},defaultLine,{strokeWidth:payload.middle.strokeWidth,color:payload.middle.color}),lower:Object.assign({},defaultLine,{rejection:-payload.rejection,strokeWidth:payload.lower.strokeWidth,color:payload.lower.color})};_this2.onSubmit(newPayload);}}};var activeIndicatorsLength=this.props.settings.indicators.filter(function(indicator){return indicator.enabled!==false;}).length;var isOverhead=this.props.isMobile&&activeIndicatorsLength>=2||activeIndicatorsLength>=3;var Popup=POPUPS[this.state.instruments]||null;var popup=Popup&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__IndicatorPopup__["a" /* default */],{onClose:this.handlePopupClose,mobile:this.props.isMobile,onSubmit:Popup.onSubmit,info:isOverhead?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OverheadInfo,null):Popup.info||null,initialState:this.state.settings||Popup.initialState,title:Popup.title,validation:Popup.validation},function(_ref2){var indicator=_ref2.indicator,errors=_ref2.errors,activeSelect=_ref2.activeSelect,handleClick=_ref2.handleClick,handleChange=_ref2.handleChange,handleAsIsChange=_ref2.handleAsIsChange,handleNumberChange=_ref2.handleNumberChange,handleNestedChange=_ref2.handleNestedChange;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup.template,{indicator:indicator,errors:errors,activeSelect:activeSelect,handleClick:handleClick,handleChange:handleChange,handleAsIsChange:handleAsIsChange,handleNumberChange:handleNumberChange,handleNestedChange:handleNestedChange});});return this.props.children&&typeof this.props.children==="function"?this.props.children(Object.assign({TOOLS:TOOLS,changeActiveTool:changeActiveTool,activeToolObj:activeToolObj,handlePopupOpen:handlePopupOpen,popup:popup},this.state,this.props)):null;}}]);return ToolWrapper;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(_ref3){var settings=_ref3.settings;return{settings:settings};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ToolWrapper));

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons__ = __webpack_require__(121);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: stretch;\n  width: 178px;\n  height: 100%;\n  overflow: hidden;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    width: 138px;\n    overflow: auto;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: stretch;\n  width: 178px;\n  height: 100%;\n  overflow: hidden;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    width: 138px;\n    overflow: auto;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  padding: 11px 17px 10px 49px;\n  margin-bottom: 3px;\n  font-weight: 300;\n  font-size: ",";\n  line-height: 14px;\n  color: #99959d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n\n  :hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  ",";\n"],["\n  position: relative;\n  padding: 11px 17px 10px 49px;\n  margin-bottom: 3px;\n  font-weight: 300;\n  font-size: ",";\n  line-height: 14px;\n  color: #99959d;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n\n  :hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      pointer-events: none;\n      background-color: ",";\n      color: ",";\n      font-weight: 500;\n    "],["\n      pointer-events: none;\n      background-color: ",";\n      color: ",";\n      font-weight: 500;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  direction: ",";\n"],["\n  direction: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 17px;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  text-align: center;\n"],["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  left: 17px;\n  width: 24px;\n  height: 24px;\n  color: inherit;\n  text-align: center;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Menu=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.mainHighlight;});var Tool=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?theme.popupDarkBackground:theme.mainDark;},function(props){return props.theme.accent;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?theme.popupDarkBackground:theme.mainDark;},function(_ref4){var theme=_ref4.theme;return theme.accent;});});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.direction;});var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);function ToolsMenu(props){var _props$settings=props.settings,indicators=_props$settings.indicators,chartType=_props$settings.chartType,lineThickness=_props$settings.lineThickness,sound=_props$settings.sound;var toolsMap=props.tools.map(function(tool){if(tool.hide){return null;}var title=tool.title,key=tool.key;var showRemoveIndicators=indicators.length>0;var showLineTools=chartType==="line";// выбор иконки
var Icon=null;switch(key){// тип чарта
case"chartType":switch(chartType){case"bar":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["b" /* ChartIconBars */];break;case"candlestick":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["c" /* ChartIconCandlestick */];break;default:Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["d" /* ChartIconZone */];break;}break;// толщина линии
case"lineThickness":switch(lineThickness){case 1:Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["n" /* LineThicknessIcon1px */];break;case 3:Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["p" /* LineThicknessIcon3px */];break;case 4:Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["q" /* LineThicknessIcon4px */];break;case 5:Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["r" /* LineThicknessIcon5px */];break;default:Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["o" /* LineThicknessIcon2px */];break;}break;// интервал
case"interval":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["e" /* ClockIcon */];break;case"lineColor":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["m" /* LineColorIcon */];break;case"sentiments":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["z" /* TradersMoodIcon */];break;case"indicators":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["j" /* IndicatorsIcon */];break;case"removeindicators":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["t" /* RemoveIndicatorsIcon */];break;case"theme":Icon=__WEBPACK_IMPORTED_MODULE_4__Icons__["x" /* ThemesIcon */];break;case"sound":Icon=sound?__WEBPACK_IMPORTED_MODULE_4__Icons__["v" /* SoundIcon */]:__WEBPACK_IMPORTED_MODULE_4__Icons__["w" /* SoundIconMute */];break;default:break;}var toolItem=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tool,{key:key,active:props.activeTool===key,onClick:function onClick(){return props.changeActiveTool(key);}},Icon!==null&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{isActive:props.activeTool===key}))," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,title));switch(key){case"lineThickness":case"lineColor":if(!showLineTools)toolItem=null;break;case"interval":if(showLineTools)toolItem=null;break;case"removeindicators":if(!showRemoveIndicators)toolItem=null;break;default:break;}return toolItem;});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Menu,null,props.isMobile?toolsMap:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Scrollable__["a" /* default */],{style:{height:277}},toolsMap));}function mapStateToProps(state){return{settings:state.settings};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(ToolsMenu));

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToolsActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tools__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(11);
function ToolsActive(props){function updateSettings(payload){props.dispatch({type:"UPDATE_SETTINGS",payload:payload});}var tool=null;switch(props.activeTool){case"chartType":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["e" /* SwitchChartType */],{value:props.settings.chartType,onChange:function onChange(chartType){return updateSettings({chartType:chartType});},animated:props.settings.animatedChart===undefined?true:props.settings.animatedChart,onChangeAnimated:function onChangeAnimated(animatedChart){return updateSettings({animatedChart:animatedChart});}});break;case"lineThickness":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["h" /* SwitchLineThickness */],{value:props.settings.lineThickness,onChange:function onChange(lineThickness){return updateSettings({lineThickness:lineThickness});}});break;case"lineColor":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["g" /* SwitchLineColor */],{value:props.settings.lineColor,onChange:function onChange(lineColor){return updateSettings({lineColor:lineColor});}});break;case"interval":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["f" /* SwitchInterval */],{value:props.settings.interval,onChange:function onChange(interval){return updateSettings({interval:interval});}});break;case"indicators":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["a" /* ActivateIndicator */],{indicators:props.settings.indicators,handlePopupOpen:props.handlePopupOpen,mobile:props.isMobile,onToggle:function onToggle(index){props.dispatch({type:"TOGGLE_INDICATOR",payload:index});},onRemove:function onRemove(index){props.dispatch({type:"REMOVE_INDICATOR",payload:index});},key:"activate"});break;case"sentiments":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["i" /* SwitchSentiments */],{value:props.settings.sentiments,onChange:function onChange(){Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("CLICKBTN_MOOD",{value:props.settings.sentiments?"off":"on"});return updateSettings({sentiments:!props.settings.sentiments});}});break;case"theme":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["k" /* SwitchTheme */],{value:props.settings.theme,onChange:function onChange(theme){return updateSettings({theme:theme});}});break;case"sound":tool=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Tools__["j" /* SwitchSound */],{value:props.settings.sound,onChange:function onChange(sound){Object(__WEBPACK_IMPORTED_MODULE_1__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Sound switch",eventAction:"Switch: "+(sound?"on":"off"),eventLabel:""});Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("CLICKBTN_SOUND",{value:sound?"on":"off"});updateSettings({sound:sound});}});break;default:break;}return tool;}

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.85);\n  user-select: none;\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n  @media (max-width: 567px) {\n    font-size: 7px;\n  }\n"],["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.85);\n  user-select: none;\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n  @media (max-width: 567px) {\n    font-size: 7px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 1;\n  width: 100%;\n  max-width: 74em;\n  max-height: 100%;\n  margin: 0 auto;\n  padding: 3.5em 7em 6em;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 0.5em;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n\n  @media (max-width: 959px) {\n    max-width: 100%;\n    padding: 0 2.8em;\n    background-color: transparent;\n    box-shadow: none;\n  }\n"],["\n  position: relative;\n  flex-shrink: 1;\n  width: 100%;\n  max-width: 74em;\n  max-height: 100%;\n  margin: 0 auto;\n  padding: 3.5em 7em 6em;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 0.5em;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n\n  @media (max-width: 959px) {\n    max-width: 100%;\n    padding: 0 2.8em;\n    background-color: transparent;\n    box-shadow: none;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    flex: 1 1 100%;\n    padding: 0;\n  }\n"],["\n  @media (max-width: 959px) {\n    flex: 1 1 100%;\n    padding: 0;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: 200;\n  font-size: 3.1em;\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #717171;\n\n  @media (max-width: 959px) {\n    font-size: 2.4em;\n    color: #fd9500;\n  }\n"],["\n  font-weight: 200;\n  font-size: 3.1em;\n  line-height: 1;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  color: #717171;\n\n  @media (max-width: 959px) {\n    font-size: 2.4em;\n    color: #fd9500;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n  padding: 7px 0;\n  font-weight: 300;\n  font-size: 1.7em;\n  line-height: 1.2;\n  letter-spacing: 0.6px;\n  color: #717171;\n\n  @media (max-width: 959px) {\n    padding: 7px 36px 17px;\n    font-size: 1.8em;\n    line-height: 1.2;\n    letter-spacing: 0.13px;\n    color: #fff;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding: 2px 36px 7px;\n  }\n"],["\n  direction: ",";\n  padding: 7px 0;\n  font-weight: 300;\n  font-size: 1.7em;\n  line-height: 1.2;\n  letter-spacing: 0.6px;\n  color: #717171;\n\n  @media (max-width: 959px) {\n    padding: 7px 36px 17px;\n    font-size: 1.8em;\n    line-height: 1.2;\n    letter-spacing: 0.13px;\n    color: #fff;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding: 2px 36px 7px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  text-align: center;\n\n  @media (min-width: 960px) {\n    flex-wrap: nowrap;\n  }\n"],["\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: flex-start;\n  text-align: center;\n\n  @media (min-width: 960px) {\n    flex-wrap: nowrap;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex: 1 1 50%;\n  max-width: 25em;\n  padding-top: 4.5em;\n  color: ",";\n\n  @media (min-width: 960px) {\n    max-width: 50%;\n  }\n\n  @media (max-width: 959px) {\n    flex: 1 1 100%;\n    max-width: 100%;\n    padding: 1.5em 2.5em;\n\n    :last-of-type {\n      margin-bottom: 1.5em;\n    }\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding: 1em 2.5em;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  "," ",";\n"],["\n  flex: 1 1 50%;\n  max-width: 25em;\n  padding-top: 4.5em;\n  color: ",";\n\n  @media (min-width: 960px) {\n    max-width: 50%;\n  }\n\n  @media (max-width: 959px) {\n    flex: 1 1 100%;\n    max-width: 100%;\n    padding: 1.5em 2.5em;\n\n    :last-of-type {\n      margin-bottom: 1.5em;\n    }\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding: 1em 2.5em;\n    flex-direction: row;\n    justify-content: space-between;\n  }\n\n  "," ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n      color: #fd9500;\n\n      @media (max-width: 959px) {\n        background-color: #f6f6f6;\n      }\n    "],["\n      color: #fd9500;\n\n      @media (max-width: 959px) {\n        background-color: #f6f6f6;\n      }\n    "]),_templateObject10=_taggedTemplateLiteral(["\n      color: #64b410;\n\n      @media (max-width: 959px) {\n        background-color: #fff;\n      }\n    "],["\n      color: #64b410;\n\n      @media (max-width: 959px) {\n        background-color: #fff;\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  width: 100%;\n  font-weight: 500;\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n"],["\n  width: 100%;\n  font-weight: 500;\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  width: inherit;\n  font-weight: inherit;\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    width: auto;\n  }\n"],["\n  width: inherit;\n  font-weight: inherit;\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    width: auto;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  font-size: 2.2em;\n  color: ",";\n"],["\n  font-size: 2.2em;\n  color: ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n  padding-bottom: 0.6em;\n  font-size: 3.5em;\n  line-height: 1.4;\n  color: currentColor;\n  border-bottom: 1px solid #e2e2e2;\n\n  @media (max-width: 959px) {\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex: 0 1 45%;\n    padding-left: 0.6em;\n    text-align: center;\n  }\n"],["\n  padding-bottom: 0.6em;\n  font-size: 3.5em;\n  line-height: 1.4;\n  color: currentColor;\n  border-bottom: 1px solid #e2e2e2;\n\n  @media (max-width: 959px) {\n    padding-bottom: 0;\n    border-bottom: none;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex: 0 1 45%;\n    padding-left: 0.6em;\n    text-align: center;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  padding: 2.2em 0 2.3em 5.7em;\n  text-align: left;\n\n  @media (max-width: 959px) {\n    padding-top: 0;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 4em;\n    flex: 1 1 45%;\n  }\n"],["\n  padding: 2.2em 0 2.3em 5.7em;\n  text-align: left;\n\n  @media (max-width: 959px) {\n    padding-top: 0;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-top: 0;\n    padding-bottom: 0;\n    padding-left: 4em;\n    flex: 1 1 45%;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: relative;\n  padding: 0.471em 0;\n  font-weight: 300;\n  font-size: 1.7em;\n  line-height: 1.2;\n  letter-spacing: 0.6px;\n"],["\n  position: relative;\n  padding: 0.471em 0;\n  font-weight: 300;\n  font-size: 1.7em;\n  line-height: 1.2;\n  letter-spacing: 0.6px;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject18=_taggedTemplateLiteral(["\n  position: absolute;\n  left: -2.235em;\n  top: 50%;\n  transform: translateY(-50%) rotate(-45deg);\n  transform-origin: 25%;\n  display: block;\n  width: 17px;\n  height: 10px;\n  border-bottom: 2px solid;\n  border-left: 2px solid;\n  border-color: currentColor;\n"],["\n  position: absolute;\n  left: -2.235em;\n  top: 50%;\n  transform: translateY(-50%) rotate(-45deg);\n  transform-origin: 25%;\n  display: block;\n  width: 17px;\n  height: 10px;\n  border-bottom: 2px solid;\n  border-left: 2px solid;\n  border-color: currentColor;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  font-weight: 700;\n"],["\n  font-weight: 700;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex: 0 1 45%;\n    padding-left: 2em;\n  }\n"],["\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex: 0 1 45%;\n    padding-left: 2em;\n  }\n"]),_templateObject21=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 11.364em;\n  height: 3.091em;\n  margin: 0 auto;\n  padding: 0;\n  font-weight: 500;\n  font-size: 2em;\n  letter-spacing: 0.2px;\n  text-decoration: none;\n  color: #fff;\n  border: 0;\n  border-radius: 9px;\n  cursor: pointer;\n"],["\n  width: 100%;\n  max-width: 11.364em;\n  height: 3.091em;\n  margin: 0 auto;\n  padding: 0;\n  font-weight: 500;\n  font-size: 2em;\n  letter-spacing: 0.2px;\n  text-decoration: none;\n  color: #fff;\n  border: 0;\n  border-radius: 9px;\n  cursor: pointer;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  background-color: ",";\n  background: linear-gradient(",", #fd9500);\n\n  :hover {\n    background-color: #fd9500;\n    background: linear-gradient(#fd9500, ",");\n  }\n\n  ","\n"],["\n  background-color: ",";\n  background: linear-gradient(",", #fd9500);\n\n  :hover {\n    background-color: #fd9500;\n    background: linear-gradient(#fd9500, ",");\n  }\n\n  ","\n"]),_templateObject23=_taggedTemplateLiteral(["\n    background-color: #8a8a8a;\n    background: linear-gradient(to bottom, #8a8a8a 0%, #a5a5a5 100%);\n    cursor: default;\n    :hover {\n      background-color: #8a8a8a;\n      background: linear-gradient(to bottom, #8a8a8a 0%, #a5a5a5 100%);\n    }\n  "],["\n    background-color: #8a8a8a;\n    background: linear-gradient(to bottom, #8a8a8a 0%, #a5a5a5 100%);\n    cursor: default;\n    :hover {\n      background-color: #8a8a8a;\n      background: linear-gradient(to bottom, #8a8a8a 0%, #a5a5a5 100%);\n    }\n  "]),_templateObject24=_taggedTemplateLiteral(["\n  background-color: #68c703;\n  background: linear-gradient(#68c703, #60a21d);\n\n  :hover {\n    background-color: #60a21d;\n    background: linear-gradient(#60a21d, #68c703);\n  }\n"],["\n  background-color: #68c703;\n  background: linear-gradient(#68c703, #60a21d);\n\n  :hover {\n    background-color: #60a21d;\n    background: linear-gradient(#60a21d, #68c703);\n  }\n"]),_templateObject25=_taggedTemplateLiteral(["\n  direction: ",";\n  padding: 0.588em 0;\n  font-weight: 300;\n  font-size: 1.7em;\n  line-height: 1.2;\n  letter-spacing: 0.13px;\n  color: #717171;\n"],["\n  direction: ",";\n  padding: 0.588em 0;\n  font-weight: 300;\n  font-size: 1.7em;\n  line-height: 1.2;\n  letter-spacing: 0.13px;\n  color: #717171;\n"]),_templateObject26=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 18px;\n  height: 18px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n\n  @media (max-width: 959px) {\n    top: 0;\n    width: 26px;\n    height: 26px;\n\n    :before,\n    :after {\n      top: -4px;\n      height: 36px;\n    }\n  }\n"],["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 18px;\n  height: 18px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n\n  @media (max-width: 959px) {\n    top: 0;\n    width: 26px;\n    height: 26px;\n\n    :before,\n    :after {\n      top: -4px;\n      height: 36px;\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// styled
var Flex=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var Overlay=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject2);var Popup=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3);var Header=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].h1(_templateObject5);var Subtitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].p(_templateObject6,function(_ref){var theme=_ref.theme;return theme.direction;});var Content=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject7);var Column=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject8,function(props){return props.theme.mainFontColor;},function(props){return props.demo&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9);},function(props){return props.real&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);});var ColumnHeader=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject11);var ColumnHeaderItem=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].p(_templateObject12);var ColumnTitle=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(ColumnHeaderItem)(_templateObject13,function(props){return props.theme.mainFontColor;});var ColumnBalance=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(ColumnHeaderItem)(_templateObject14);var ColumnFeatures=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].ul(_templateObject15);var Feature=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].li(_templateObject16);// prettier-ignore
var FeatureText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject17,function(props){return props.theme.mainFontColor;});var Tick=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject18);var Strong=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].strong(_templateObject19);var ColumnButtonContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject20);var Button=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Flex)(_templateObject21);var ButtonDemo=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Button)(_templateObject22,function(props){return props.theme.accent;},function(props){return props.theme.accent;},function(props){return props.theme.accent;},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject23);});var ButtonReal=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Button)(_templateObject24);var ActionDesc=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].p(_templateObject25,function(_ref2){var theme=_ref2.theme;return theme.direction;});var Close=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject26);function Features(_ref3){var arr=_ref3.arr;return arr.map(function(feat,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Feature,{key:"feat"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tick,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FeatureText,null,feat));});}var PopupDeposit=function(_React$Component){_inherits(PopupDeposit,_React$Component);function PopupDeposit(){_classCallCheck(this,PopupDeposit);return _possibleConstructorReturn(this,(PopupDeposit.__proto__||Object.getPrototypeOf(PopupDeposit)).apply(this,arguments));}_createClass(PopupDeposit,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_8__GA__["a" /* gaReducer */])("CLICKBTN_PPP_DEPOSIT_SHOW");}},{key:"render",value:function render(){var props=this.props;var accounts=props.accounts,minFillup=props.minFillup,initialDeposit=props.initialDeposit;var demo=accounts.find(function(acc){return acc.type==="demo";});var real=accounts.find(function(acc){return acc.type==="real";});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{style:props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_ClickOutside__["a" /* default */],{onOutsideClick:props.onDismiss},function(_ref4){var innerRef=_ref4.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Popup,{ref:innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Close,{onClick:props.onDismiss}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Make a deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subtitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"You can switch between your accounts at any moment!"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Column,{demo:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnHeader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Fill Up Demo Account"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Demo account");})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnBalance,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,demo?demo.balance:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnFeatures,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Features,{arr:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Strong,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"No withdrawals")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"All assets are available"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Full-fledged platform")]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ThemeProvider__["a" /* IronRedesignThemeProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonDemo,{as:"button",disabled:props.isFetching,onClick:function onClick(){props.onRefillDemoClick().then(props.onDismiss).then(function(){return Object(__WEBPACK_IMPORTED_MODULE_8__GA__["a" /* gaReducer */])("CLICKBTN_PPP_DEPOSIT_REFILL");});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Practice trading"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionDesc,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Free Refill with")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,initialDeposit)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Column,{real:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnHeader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Fill Up Real Account"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Real account");})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnBalance,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,real?real.balance:0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnFeatures,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Features,{arr:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Strong,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Easy withdrawals")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"All assets are available"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Full-fledged platform")]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ColumnButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonReal,{as:__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */],to:"/fillup",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_8__GA__["a" /* gaReducer */])("CLICKBTN_PPP_DEPOSIT_FILLUP");props.onDismiss();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Add Money")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ActionDesc,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Minimum deposit is")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,minFillup))))));}));}}]);return PopupDeposit;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (PopupDeposit);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(2024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StyledComponents__ = __webpack_require__(791);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InsufficientPopup=function(_React$Component){_inherits(InsufficientPopup,_React$Component);function InsufficientPopup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,InsufficientPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=InsufficientPopup.__proto__||Object.getPrototypeOf(InsufficientPopup)).call.apply(_ref,[this].concat(args))),_this),_this.gaEvent=function(props){var screen=props.screen,action=props.action;var popup="insuffient";var profileId=_this.props.profileId;var label=props.label;if(!label){switch(action){case"refill":label="Пополнение реального счета с";break;case"refillDemo":label="Пополнение демо-счета с";break;default:label="Закрытие";break;}}Object(__WEBPACK_IMPORTED_MODULE_5__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Insufficient Popup",eventAction:popup+"-"+action+"_screen-"+screen+"_profileId-"+profileId,eventLabel:label+" \u043F\u043E\u043F\u0430\u043F\u0430 \"\u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0441\u0440\u0435\u0434\u0441\u0442\u0432\", \u044D\u043A\u0440\u0430\u043D "+screen});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(InsufficientPopup,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_5__common_dataLayer__["a" /* default */])({event:"for_ga-disp-popup-demorefill",eventCategory:"disp-popup-demorefill",eventAction:"cl_popup1_show"});}},{key:"render",value:function render(){var _this2=this;var _props=this.props,isActiveAccountReal=_props.isActiveAccountReal,onDismiss=_props.onDismiss;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* default */],{onDismiss:function(_onDismiss){function onDismiss(){return _onDismiss.apply(this,arguments);}onDismiss.toString=function(){return _onDismiss.toString();};return onDismiss;}(function(){_this2.gaEvent({screen:isActiveAccountReal?"real":"demo",action:"close"});onDismiss();})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["j" /* Title */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Insufficient funds on the account!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["i" /* Subtitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Top up your account to start trading")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["e" /* InlineContainer */],null,!isActiveAccountReal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["d" /* InlineBlock */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["a" /* Button */],{demo:true,as:"span",disabled:this.props.isFetching,onClick:function onClick(){_this2.props.onRefillDemoClick().then(function(){Object(__WEBPACK_IMPORTED_MODULE_5__common_dataLayer__["a" /* default */])({event:"for_ga-disp-popup-demorefill",eventCategory:"disp-popup-demorefill",eventAction:"cl_popup1_refill"});onDismiss();});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Refill Demo")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["b" /* ButtonDesc */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Free Refill demo account with")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],null,this.props.initialDeposit))),this.props.showDeposit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["d" /* InlineBlock */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["a" /* Button */],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_5__common_dataLayer__["a" /* default */])({event:"for_ga-disp-popup-demorefill",eventCategory:"disp-popup-demorefill",eventAction:"cl_popup1_fillup"});},to:"/fillup",green:true,demo:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Add Money")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StyledComponents__["b" /* ButtonDesc */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Minimum deposit is")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],null,this.props.minFillup)))));}}]);return InsufficientPopup;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__common_withDeposit__["b" /* withDeposit */])(InsufficientPopup));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PopupView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Close; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return Title; });
/* unused harmony export Bold */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SafeImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Subtitle; });
/* unused harmony export Info */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return InlineContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return InlineBlock; });
/* unused harmony export RealContainer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* unused harmony export HelpContainer */
/* unused harmony export HelpLink */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ButtonDesc; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.85);\n  user-select: none;\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 7px;\n  }\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 2.5em;\n  font-size: 10px;\n  line-height: 1;\n  background-color: rgba(0, 0, 0, 0.85);\n  user-select: none;\n  z-index: 20000;\n  overflow: auto;\n\n  @media (max-width: 959px) {\n    padding: 1.5em;\n    font-size: 8px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 7px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  flex-shrink: 1;\n  width: 70em;\n  max-width: 90%;\n  max-height: 100%;\n  margin: 0 auto;\n  padding: 3.5em 4em 2em;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 1);\n  overflow: auto;\n\n  @media (max-width: 760px) {\n    width: 95%;\n    max-width: 95%;\n    padding: 25px 10px 15px 10px;\n  }\n"],["\n  position: relative;\n  flex-shrink: 1;\n  width: 70em;\n  max-width: 90%;\n  max-height: 100%;\n  margin: 0 auto;\n  padding: 3.5em 4em 2em;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 0 17px 0 rgba(0, 0, 0, 1);\n  overflow: auto;\n\n  @media (max-width: 760px) {\n    width: 95%;\n    max-width: 95%;\n    padding: 25px 10px 15px 10px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 20px;\n  height: 20px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0;\n    height: 25px;\n    border-left: 1px solid currentColor;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"],["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 20px;\n  height: 20px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0;\n    height: 25px;\n    border-left: 1px solid currentColor;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  padding-top: 30px;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 1.42;\n  color: #feac00;\n  text-align: center;\n\n  @media (max-width: 760px) {\n    padding-top: 20px;\n    font-size: 18px;\n    line-height: 1.2;\n  }\n"],["\n  margin-bottom: 20px;\n  padding-top: 30px;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 1.42;\n  color: #feac00;\n  text-align: center;\n\n  @media (max-width: 760px) {\n    padding-top: 20px;\n    font-size: 18px;\n    line-height: 1.2;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: bold;\n  color: #60a31c;\n"],["\n  font-weight: bold;\n  color: #60a31c;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  @media (max-width: 760px) {\n    width: 64px;\n  }\n\n  @media (max-width: 760px) and (orientation: landscape) {\n    display: none;\n  }\n"],["\n  @media (max-width: 760px) {\n    width: 64px;\n  }\n\n  @media (max-width: 760px) and (orientation: landscape) {\n    display: none;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  max-width: 500px;\n  margin: 0 auto;\n  font-size: 20px;\n  line-height: 1.3;\n  color: #343434;\n\n  @media (max-width: 760px) {\n    font-size: 18px;\n    line-height: 1.2;\n  }\n"],["\n  max-width: 500px;\n  margin: 0 auto;\n  font-size: 20px;\n  line-height: 1.3;\n  color: #343434;\n\n  @media (max-width: 760px) {\n    font-size: 18px;\n    line-height: 1.2;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  max-width: 500px;\n  margin: 3px auto 0;\n  font-size: ",";\n  color: #717171;\n  line-height: 1.2;\n  text-align: center;\n\n  @media (max-width: 760px) {\n    font-size: ",";\n  }\n"],["\n  max-width: 500px;\n  margin: 3px auto 0;\n  font-size: ",";\n  color: #717171;\n  line-height: 1.2;\n  text-align: center;\n\n  @media (max-width: 760px) {\n    font-size: ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 100%;\n  padding-top: 30px;\n  font-size: 0.1px;\n  line-height: 0;\n\n  @media (max-width: 760px) {\n    padding-top: 20px;\n  }\n"],["\n  display: inline-block;\n  vertical-align: top;\n  width: 100%;\n  padding-top: 30px;\n  font-size: 0.1px;\n  line-height: 0;\n\n  @media (max-width: 760px) {\n    padding-top: 20px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 50%;\n\n  @media (max-width: 479px) {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n"],["\n  display: inline-block;\n  vertical-align: top;\n  width: 50%;\n\n  @media (max-width: 479px) {\n    width: 100%;\n    margin-bottom: 15px;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 25px;\n  margin-bottom: ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 25px;\n  margin-bottom: ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 119px;\n  min-height: 39px;\n  margin-left: ",";\n  padding: 0 5px;\n  font-weight: bold;\n  font-size: 16px;\n  color: #fff;\n  cursor: pointer;\n  border-radius: 8px;\n  background: linear-gradient(\n    to bottom,\n    ","\n  );\n  text-decoration: none;\n\n  @media (max-width: 359px) {\n    font-size: ",";\n  }\n\n  :hover,\n  :focus {\n    background: linear-gradient(\n      to bottom,\n      ","\n    );\n  }\n\n  :active {\n    background: linear-gradient(\n      to bottom,\n      ","\n    );\n  }\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 119px;\n  min-height: 39px;\n  margin-left: ",";\n  padding: 0 5px;\n  font-weight: bold;\n  font-size: 16px;\n  color: #fff;\n  cursor: pointer;\n  border-radius: 8px;\n  background: linear-gradient(\n    to bottom,\n    ","\n  );\n  text-decoration: none;\n\n  @media (max-width: 359px) {\n    font-size: ",";\n  }\n\n  :hover,\n  :focus {\n    background: linear-gradient(\n      to bottom,\n      ","\n    );\n  }\n\n  :active {\n    background: linear-gradient(\n      to bottom,\n      ","\n    );\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      background: linear-gradient(\n        to bottom,\n        #8a8a8a 0%,\n        #a5a5a5 100%\n      ) !important;\n      cursor: not-allowed !important;\n      pointer-events: none !important;\n    "],["\n      background: linear-gradient(\n        to bottom,\n        #8a8a8a 0%,\n        #a5a5a5 100%\n      ) !important;\n      cursor: not-allowed !important;\n      pointer-events: none !important;\n    "]),_templateObject14=_taggedTemplateLiteral(["\n      width: 90%;\n      margin: 0 auto;\n    "],["\n      width: 90%;\n      margin: 0 auto;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #717171;\n  text-align: center;\n\n  @media (max-width: 760px) {\n    font-size: ",";\n  }\n"],["\n  font-size: ",";\n  color: #717171;\n  text-align: center;\n\n  @media (max-width: 760px) {\n    font-size: ",";\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  color: #3598db;\n  text-decoration: underline;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: none;\n  }\n"],["\n  color: #3598db;\n  text-decoration: underline;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: none;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  padding-top: 12px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 20px;\n  text-align: center;\n  color: #717171;\n\n  @media (max-width: 760px) {\n    padding-top: 5px;\n  }\n"],["\n  padding-top: 12px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 20px;\n  text-align: center;\n  color: #717171;\n\n  @media (max-width: 760px) {\n    padding-top: 5px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var PopupView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h3(_templateObject4);var Bold=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5);// prettier-ignore
var SafeImg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject6);var Subtitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject7);var Info=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject8,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var InlineContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var InlineBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var RealContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,function(props){return props.margin?"25px":"10px";});var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_0__common_Link__["a" /* Link */])(_templateObject12,function(props){return props.real?"12px":0;},function(props){return props.green?"#68C703, #60A31D":"#FEAC00, #FD9600";},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.green?"#60A31D, #68C703":"#FD9600, #FEAC00";},function(props){return props.green?"#68C703, #60A31D":"#FEAC00, #FD9600";},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13);},function(props){return props.demo&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14);});var HelpContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref5){var theme=_ref5.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var HelpLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_0__common_Link__["a" /* Link */])(_templateObject16);var ButtonDesc=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject17,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(228);
var _templateObject=_taggedTemplateLiteral(["\n  max-width: 68em;\n  padding: 4em 4em 3.5em;\n  color: ",";\n\n  @media (max-width: 959px) {\n    max-width: 60em;\n    padding: 3.143em 5em;\n    border-radius: 0px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding: 2em 3.5em;\n  }\n"],["\n  max-width: 68em;\n  padding: 4em 4em 3.5em;\n  color: ",";\n\n  @media (max-width: 959px) {\n    max-width: 60em;\n    padding: 3.143em 5em;\n    border-radius: 0px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding: 2em 3.5em;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 0.5em 0.5em;\n  font-weight: 300;\n  font-size: 3em;\n  text-transform: uppercase;\n  color: ",";\n\n  @media (max-width: 959px) {\n    padding: 0 1em 0.75em;\n    font-size: 3.429em;\n    line-height: 1.2;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-bottom: 0.25em;\n  }\n"],["\n  width: 100%;\n  padding: 0 0.5em 0.5em;\n  font-weight: 300;\n  font-size: 3em;\n  text-transform: uppercase;\n  color: ",";\n\n  @media (max-width: 959px) {\n    padding: 0 1em 0.75em;\n    font-size: 3.429em;\n    line-height: 1.2;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-bottom: 0.25em;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 1.8em;\n  line-height: 1.333;\n  color: inherit;\n\n  @media (max-width: 959px) {\n    font-size: 1.714em;\n    line-height: 1.5;\n  }\n"],["\n  font-weight: 400;\n  font-size: 1.8em;\n  line-height: 1.333;\n  color: inherit;\n\n  @media (max-width: 959px) {\n    font-size: 1.714em;\n    line-height: 1.5;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: fit-content;\n  max-width: 77.5%;\n  margin: 0 auto;\n  padding: 3em 0 3.5em;\n  text-align: left;\n\n  @media (max-width: 959px) {\n    padding-top: 1em;\n    padding-bottom: 1em;\n  }\n"],["\n  width: fit-content;\n  max-width: 77.5%;\n  margin: 0 auto;\n  padding: 3em 0 3.5em;\n  text-align: left;\n\n  @media (max-width: 959px) {\n    padding-top: 1em;\n    padding-bottom: 1em;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  margin: 0;\n  padding: 0 0 0 1.5em;\n  font-weight: 700;\n  font-size: 1.8em;\n  line-height: 1.667;\n  color: ",";\n\n  :before {\n    content: \"*\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    font-weight: inherit;\n    font-size: 34px;\n    line-height: 1.2;\n  }\n\n  "," @media (max-width: 959px) {\n    padding-top: 0.5em;\n    padding-bottom: 0.5em;\n    padding-left: 1.75em;\n    font-size: 2em;\n    line-height: 1.2;\n\n    :before {\n      top: 2px;\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-top: 0.25em;\n    padding-bottom: 0.25em;\n\n    :before {\n      top: -1px;\n    }\n  }\n"],["\n  position: relative;\n  margin: 0;\n  padding: 0 0 0 1.5em;\n  font-weight: 700;\n  font-size: 1.8em;\n  line-height: 1.667;\n  color: ",";\n\n  :before {\n    content: \"*\";\n    position: absolute;\n    top: 0px;\n    left: 0px;\n    font-weight: inherit;\n    font-size: 34px;\n    line-height: 1.2;\n  }\n\n  "," @media (max-width: 959px) {\n    padding-top: 0.5em;\n    padding-bottom: 0.5em;\n    padding-left: 1.75em;\n    font-size: 2em;\n    line-height: 1.2;\n\n    :before {\n      top: 2px;\n      font-size: 28px;\n    }\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-top: 0.25em;\n    padding-bottom: 0.25em;\n\n    :before {\n      top: -1px;\n    }\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n      color: ",";\n\n      :before {\n        content: \"\";\n        left: 2px;\n        width: 0.35em;\n        height: 0.6em;\n        border-right: 3px solid ",";\n        border-bottom: 3px solid ",";\n        transform: rotate(45deg);\n      }\n    "],["\n      color: ",";\n\n      :before {\n        content: \"\";\n        left: 2px;\n        width: 0.35em;\n        height: 0.6em;\n        border-right: 3px solid ",";\n        border-bottom: 3px solid ",";\n        transform: rotate(45deg);\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  display: table;\n  width: fit-content;\n  max-width: 20em;\n  margin: 0 auto;\n  padding: 1.045em 2.75em;\n  font-weight: 700;\n  font-size: 2.2em;\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  border: none;\n  border-radius: 0.364em;\n  background-color: #61ad12;\n  background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);\n  cursor: pointer;\n\n  :hover {\n    background-color: #68c604;\n    background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);\n  }\n\n  @media (max-width: 959px) {\n    padding-left: 1.75em;\n    padding-right: 1.75em;\n    font-size: 2.286em; /* 16px */\n    border-radius: 0.25em;\n  }\n"],["\n  display: table;\n  width: fit-content;\n  max-width: 20em;\n  margin: 0 auto;\n  padding: 1.045em 2.75em;\n  font-weight: 700;\n  font-size: 2.2em;\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  border: none;\n  border-radius: 0.364em;\n  background-color: #61ad12;\n  background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);\n  cursor: pointer;\n\n  :hover {\n    background-color: #68c604;\n    background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);\n  }\n\n  @media (max-width: 959px) {\n    padding-left: 1.75em;\n    padding-right: 1.75em;\n    font-size: 2.286em; /* 16px */\n    border-radius: 0.25em;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Modal=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */])(_templateObject,function(_ref){var theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.foreground,0.75);});var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h3(_templateObject2,function(props){return props.theme.lower;});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var VerifiedContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].ul(_templateObject4);var Verified=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].li(_templateObject5,function(props){return props.theme.lower;},function(props){return props.isVerified&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(props){return props.theme.upper;},function(props){return props.theme.upper;},function(props){return props.theme.upper;});});var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject7);var FIELDS=[{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Confirm phone"),key:"phone"},{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Confirm Email"),key:"email"},{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Fill in all profile fields"),key:"profile"},{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Attach a copy of your ID or passport"),key:"passport"}];function VerificationRequired(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Modal,{onDismiss:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Verification is necessary!")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"You have to verify your account to comply with financial regulation rules. Verify your account on the Profile page to keep the information about your deposits and withdrawals safe and secure.")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerifiedContainer,null,FIELDS.map(function(field){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Verified,{isVerified:props.validation[field.key]===1,key:field.key},field.title);}),props.validation.idconfirmation!==undefined&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Verified,{isVerified:props.validation.idconfirmation===1,key:"idconfirmation"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Attach your photo with your ID"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/verification"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Verify")));}/* harmony default export */ __webpack_exports__["a"] = (VerificationRequired);

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ErrorPopup_Error__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var IncreaseBidLimit=function(_Component){_inherits(IncreaseBidLimit,_Component);function IncreaseBidLimit(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IncreaseBidLimit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IncreaseBidLimit.__proto__||Object.getPrototypeOf(IncreaseBidLimit)).call.apply(_ref,[this].concat(args))),_this),_this.state={isRequestInProgress:false,serverMessage:""},_this.handleRequest=function(){_this.setState({isRequestInProgress:true});_this.props.fetch("/ajax/request-bid-limit").then(function(json){_this.setState({isRequestInProgress:false,serverMessage:json.message});}).catch(function(error){return console.log(error);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IncreaseBidLimit,[{key:"componentDidMount",value:function componentDidMount(){this.button.focus();}},{key:"render",value:function render(){var _this2=this;var _state=this.state,serverMessage=_state.serverMessage,isRequestInProgress=_state.isRequestInProgress;var limit=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,this.props.bid_limit);var message=serverMessage?serverMessage:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Maximum bid is ",limit);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ErrorPopup_Error__["b" /* default */],{message:message,onDismiss:this.props.onDismiss},!serverMessage&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ErrorPopup_Error__["a" /* Button */],{onClick:this.handleRequest,ref:function ref(button){return _this2.button=button;}},isRequestInProgress&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Spinners_SimpleSpinner__["c" /* default */],null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Increase limit")));}}]);return IncreaseBidLimit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["h" /* withFetch */])(IncreaseBidLimit));

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tournaments_images_invite_3x_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tournaments_images_invite_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Tournaments_images_invite_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_demo_tournament_bg_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_demo_tournament_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_demo_tournament_bg_png__);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  color: #272b34;\n  background-color: ",";\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n  @media (max-height: 500px) {\n    display: block;\n    overflow-y: auto;\n    position: relative;\n    padding-top: 50px;\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  color: #272b34;\n  background-color: ",";\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    border-radius: 0;\n  }\n  @media (max-height: 500px) {\n    display: block;\n    overflow-y: auto;\n    position: relative;\n    padding-top: 50px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.3;\n  text-transform: uppercase;\n  margin-bottom: 11px;\n  font-weight: 700;\n  color: ",";\n  @media (max-width: 768px) {\n    font-size: ",";\n  }\n"],["\n  font-size: ",";\n  line-height: 1.3;\n  text-transform: uppercase;\n  margin-bottom: 11px;\n  font-weight: 700;\n  color: ",";\n  @media (max-width: 768px) {\n    font-size: ",";\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n  margin-bottom: 42px;\n  @media (max-width: 768px) {\n    margin-bottom: 18px;\n  }\n"],["\n  font-size: ",";\n  color: ",";\n  margin-bottom: 42px;\n  @media (max-width: 768px) {\n    margin-bottom: 18px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  background-color: #0085eb;\n  color: #fff;\n  font-size: ",";\n  padding: 11px 22px;\n  border-radius: 19px;\n  border: none;\n  text-transform: uppercase;\n  font-weight: 900;\n  text-transform: uppercase;\n  transition: 0.3s;\n  cursor: pointer;\n  :hover:not([disabled]) {\n    background-color: #0468b5;\n  }\n  :disabled {\n    opacity: 0.4;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 20px;\n  }\n"],["\n  position: relative;\n  z-index: 1;\n  background-color: #0085eb;\n  color: #fff;\n  font-size: ",";\n  padding: 11px 22px;\n  border-radius: 19px;\n  border: none;\n  text-transform: uppercase;\n  font-weight: 900;\n  text-transform: uppercase;\n  transition: 0.3s;\n  cursor: pointer;\n  :hover:not([disabled]) {\n    background-color: #0468b5;\n  }\n  :disabled {\n    opacity: 0.4;\n  }\n  @media (max-width: 768px) {\n    margin-bottom: 20px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  padding: 36px 0 40px;\n  text-align: center;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"],["\n  padding: 36px 0 40px;\n  text-align: center;\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  color: ",";\n  font-size: ",";\n  text-transform: lowercase;\n  ","\n"],["\n  color: ",";\n  font-size: ",";\n  text-transform: lowercase;\n  ","\n"]),_templateObject10=_taggedTemplateLiteral(["\n      color: #ffcc00;\n    "],["\n      color: #ffcc00;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  position: relative;\n  margin-right: 49px;\n  margin-left: 49px;\n\n  @media (max-width: 768px) {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n"],["\n  position: relative;\n  margin-right: 49px;\n  margin-left: 49px;\n\n  @media (max-width: 768px) {\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  @media (max-width: 768px) {\n    position: relative;\n    top: unset;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: absolute;\n  top: 10px;\n  left: 0;\n  right: 0;\n  width: 100%;\n  @media (max-width: 768px) {\n    position: relative;\n    top: unset;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-bottom: 36px;\n  background-color: #000;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n\n  @media (max-width: 768px) {\n    margin-bottom: 14px;\n  }\n"],["\n  margin-bottom: 36px;\n  background-color: #000;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n\n  @media (max-width: 768px) {\n    margin-bottom: 14px;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  text-align: center;\n  padding: 23px;\n  position: relative;\n  @media (max-width: 768px) {\n    padding: 18px;\n  }\n"],["\n  text-align: center;\n  padding: 23px;\n  position: relative;\n  @media (max-width: 768px) {\n    padding: 18px;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  color: #ffffff;\n  margin-bottom: 22px;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n    margin-bottom: 16px;\n  }\n"],["\n  color: #ffffff;\n  margin-bottom: 22px;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n    margin-bottom: 16px;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  color: #ffcc00;\n  margin-bottom: 22px;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n    margin-bottom: 16px;\n  }\n"],["\n  color: #ffcc00;\n  margin-bottom: 22px;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: 700;\n  @media (max-width: 768px) {\n    font-size: ",";\n    margin-bottom: 16px;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  color: #ffffff;\n  font-size: ",";\n  line-height: 1.2;\n"],["\n  color: #ffffff;\n  font-size: ",";\n  line-height: 1.2;\n"]),_templateObject18=_taggedTemplateLiteral(["\n  color: #ffffff;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: 700;\n"],["\n  color: #ffffff;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: 700;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#F5F5F5":"#272B34";});var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(28),function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?"#3B9478":"#FFCC00";},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(18));var SubTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?"#919191":"#FFFFFF";});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var Body=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Details=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject9,function(_ref4){var theme=_ref4.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.yellow&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);});var FooterButtons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var FooterLinks=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var TournamentBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13,__WEBPACK_IMPORTED_MODULE_11__images_demo_tournament_bg_png___default.a);var TournamentContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var TournamentTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(28),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(18));var TournamentFund=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(28),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(18));var TournamentStartLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var TournamentStartTime=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject18,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(18));var TournamentSticker=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject19);function DemoTournamentPopup(_ref5){var tournament=_ref5.tournament,onDismiss=_ref5.onDismiss;var memoizedInviteSticker=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_10__Tournaments_images_invite_3x_png___default.a,alt:""});},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{onClick:onDismiss}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:onDismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Body,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Congratulations")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"You have enough DEMO money to purchase a tournament invitation!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentSticker,null,memoizedInviteSticker),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentTitle,null,tournament.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentFund,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Prize fund"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,tournament.prize_fund)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["c" /* default */],{days:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(tournament,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(tournament,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(tournament,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(tournament,"seconds"),active:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["d" /* getActive */])(tournament),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["e" /* getCompleted */])(tournament),labelOnTop:true,flexDirection:"column",alignItems:"center",noIcon:true,TimeStyle:TournamentStartTime,TextStyle:TournamentStartLabel})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterButtons,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref6){var showModal=_ref6.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:function onClick(){showModal(__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups__["b" /* JoinPopup */],tournament);onDismiss();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Buy for ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,tournament.participation_price)," demo money"));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterLinks,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Details,{to:"/news/doubleup",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Details")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Details,{to:"/tournaments",yellow:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Other tournaments")))))));}/* harmony default export */ __webpack_exports__["a"] = (DemoTournamentPopup);

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Scope; });
/* harmony export (immutable) */ __webpack_exports__["b"] = addGlobalEventProcessor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__span__ = __webpack_require__(801);



/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifiying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._context = {};
    }
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            setTimeout(function () {
                _this._scopeListeners.forEach(function (callback) {
                    callback(_this);
                });
                _this._notifyingListeners = false;
            });
        }
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */](function (resolve, reject) {
            var processor = processors[index];
            // tslint:disable-next-line:strict-type-predicates
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event), hint);
                if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* isThenable */])(result)) {
                    result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .catch(reject);
                }
                else {
                    _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .catch(reject);
                }
            }
        });
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(user);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(tags));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(value), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extra) {
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(extra));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, (_a = {}, _a[key] = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(extra), _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(fingerprint);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(level);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransaction = function (transaction) {
        this._transaction = transaction;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (name, context) {
        this._context[name] = context ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(context) : undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.startSpan = function (parentSpan) {
        var span = new __WEBPACK_IMPORTED_MODULE_2__span__["a" /* Span */]();
        span.setParent(parentSpan);
        this.setSpan(span);
        return span;
    };
    /**
     * Internal getter for Span, used in Hub.
     * @hidden
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        Object.assign(newScope, scope, {
            _scopeListeners: [],
        });
        if (scope) {
            newScope._breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](scope._breadcrumbs);
            newScope._tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._tags);
            newScope._extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._extra);
            newScope._context = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, scope._context);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._transaction = scope._transaction;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._context = {};
        this._level = undefined;
        this._transaction = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        this._breadcrumbs =
            maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                ? __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(mergedBreadcrumb)]).slice(-maxBreadcrumbs)
                : __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](this._breadcrumbs, [Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["u" /* normalize */])(mergedBreadcrumb)]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._extra, event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._tags, event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._user, event.user);
        }
        if (this._context && Object.keys(this._context).length) {
            event.contexts = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._context, event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transaction) {
            event.transaction = this._transaction;
        }
        if (this._span) {
            event.contexts = event.contexts || {};
            event.contexts.trace = this._span;
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */]((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    return Scope;
}());

/**
 * Retruns the global event processors.
 */
function getGlobalEventProcessors() {
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}
//# sourceMappingURL=scope.js.map

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["b"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["a"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["c"] = __generator;
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SentryError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill__ = __webpack_require__(2055);


/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        // tslint:disable:no-unsafe-any
        _this.name = _newTarget.prototype.constructor.name;
        Object(__WEBPACK_IMPORTED_MODULE_1__polyfill__["a" /* setPrototypeOf */])(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

//# sourceMappingURL=error.js.map

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__misc__ = __webpack_require__(466);

// TODO: Implement different loggers for different environments
var global = Object(__WEBPACK_IMPORTED_MODULE_0__misc__["e" /* getGlobalObject */])();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["b" /* consoleSandbox */])(function () {
            global.console.log(PREFIX + "[Log]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["b" /* consoleSandbox */])(function () {
            global.console.warn(PREFIX + "[Warn]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__misc__["b" /* consoleSandbox */])(function () {
            global.console.error(PREFIX + "[Error]: " + args.join(' ')); // tslint:disable-line:no-console
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global.__SENTRY__ = global.__SENTRY__ || {};
var logger = global.__SENTRY__.logger || (global.__SENTRY__.logger = new Logger());

//# sourceMappingURL=logger.js.map

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Memo; });
// tslint:disable:no-unsafe-any
/**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */
var Memo = /** @class */ (function () {
    function Memo() {
        // tslint:disable-next-line
        this._hasWeakSet = typeof WeakSet === 'function';
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */
    Memo.prototype.memoize = function (obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) {
                return true;
            }
            this._inner.add(obj);
            return false;
        }
        // tslint:disable-next-line:prefer-for-of
        for (var i = 0; i < this._inner.length; i++) {
            var value = this._inner[i];
            if (value === obj) {
                return true;
            }
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */
    Memo.prototype.unmemoize = function (obj) {
        if (this._hasWeakSet) {
            this._inner.delete(obj);
        }
        else {
            for (var i = 0; i < this._inner.length; i++) {
                if (this._inner[i] === obj) {
                    this._inner.splice(i, 1);
                    break;
                }
            }
        }
    };
    return Memo;
}());

//# sourceMappingURL=memo.js.map

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TRACEPARENT_REGEXP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Span; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(29);

var TRACEPARENT_REGEXP = /^[ \t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \t]*$/;
/**
 * Span containg all data about a span
 */
var Span = /** @class */ (function () {
    function Span(_traceId, _spanId, _sampled, _parent) {
        if (_traceId === void 0) { _traceId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* uuid4 */])(); }
        if (_spanId === void 0) { _spanId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["E" /* uuid4 */])().substring(16); }
        this._traceId = _traceId;
        this._spanId = _spanId;
        this._sampled = _sampled;
        this._parent = _parent;
    }
    /**
     * Setter for parent
     */
    Span.prototype.setParent = function (parent) {
        this._parent = parent;
        return this;
    };
    /**
     * Setter for sampled
     */
    Span.prototype.setSampled = function (sampled) {
        this._sampled = sampled;
        return this;
    };
    /**
     * Continues a trace
     * @param traceparent Traceparent string
     */
    Span.fromTraceparent = function (traceparent) {
        var matches = traceparent.match(TRACEPARENT_REGEXP);
        if (matches) {
            var sampled = void 0;
            if (matches[3] === '1') {
                sampled = true;
            }
            else if (matches[3] === '0') {
                sampled = false;
            }
            var parent_1 = new Span(matches[1], matches[2], sampled);
            return new Span(matches[1], undefined, sampled, parent_1);
        }
        return undefined;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampled = '';
        if (this._sampled === true) {
            sampled = '-1';
        }
        else if (this._sampled === false) {
            sampled = '-0';
        }
        return this._traceId + "-" + this._spanId + sampled;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return {
            parent: (this._parent && this._parent.toJSON()) || undefined,
            sampled: this._sampled,
            span_id: this._spanId,
            trace_id: this._traceId,
        };
    };
    return Span;
}());

//# sourceMappingURL=span.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_types__ = __webpack_require__(145);

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return Promise.resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: __WEBPACK_IMPORTED_MODULE_0__sentry_types__["b" /* Status */].Skipped,
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return Promise.resolve(true);
    };
    return NoopTransport;
}());

//# sourceMappingURL=noop.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__backend__ = __webpack_require__(2071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__version__ = __webpack_require__(805);





/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        return _super.call(this, __WEBPACK_IMPORTED_MODULE_3__backend__["a" /* BrowserBackend */], options) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        event.sdk = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event.sdk, { name: __WEBPACK_IMPORTED_MODULE_4__version__["a" /* SDK_NAME */], packages: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](((event.sdk && event.sdk.packages) || []), [
                {
                    name: 'npm:@sentry/browser',
                    version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */],
                },
            ]), version: __WEBPACK_IMPORTED_MODULE_4__version__["b" /* SDK_VERSION */] });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* getGlobalObject */])().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error('Trying to call showReportDialog with Sentry Client is disabled');
            return;
        }
        var dsn = options.dsn || this.getDsn();
        if (!options.eventId) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error('Missing `eventId` option in showReportDialog call');
            return;
        }
        if (!dsn) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error('Missing `Dsn` option in showReportDialog call');
            return;
        }
        var script = document.createElement('script');
        script.async = true;
        script.src = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getReportDialogEndpoint(options);
        if (options.onLoad) {
            script.onload = options.onLoad;
        }
        (document.head || document.body).appendChild(script);
    };
    return BrowserClient;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["c" /* BaseClient */]));

//# sourceMappingURL=client.js.map

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__(469);
/* unused harmony reexport BaseTransport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fetch__ = __webpack_require__(2072);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__fetch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__xhr__ = __webpack_require__(2073);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__xhr__["a"]; });



//# sourceMappingURL=index.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SDK_VERSION; });
var SDK_NAME = 'sentry.javascript.browser';
var SDK_VERSION = '5.6.3';
//# sourceMappingURL=version.js.map

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalhandlers__ = __webpack_require__(2075);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GlobalHandlers", function() { return __WEBPACK_IMPORTED_MODULE_0__globalhandlers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trycatch__ = __webpack_require__(2076);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TryCatch", function() { return __WEBPACK_IMPORTED_MODULE_1__trycatch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__ = __webpack_require__(2077);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumbs", function() { return __WEBPACK_IMPORTED_MODULE_2__breadcrumbs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__linkederrors__ = __webpack_require__(2078);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LinkedErrors", function() { return __WEBPACK_IMPORTED_MODULE_3__linkederrors__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useragent__ = __webpack_require__(2079);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UserAgent", function() { return __WEBPACK_IMPORTED_MODULE_4__useragent__["a"]; });





//# sourceMappingURL=index.js.map

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FillupConfiguration; });
/* unused harmony export withConfiguration */
/* harmony export (immutable) */ __webpack_exports__["g"] = getPaymentBonus;
/* harmony export (immutable) */ __webpack_exports__["h"] = getPromoBonus;
/* harmony export (immutable) */ __webpack_exports__["e"] = getBillingBonus;
/* unused harmony export getRegularBonus */
/* harmony export (immutable) */ __webpack_exports__["d"] = getAbsoluteRegularBonus;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAbsolutePromoBonus;
/* harmony export (immutable) */ __webpack_exports__["f"] = getBonus;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAbsoluteBonus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__configs_FillupConfig_default__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Spinners_BrandSpinner__ = __webpack_require__(98);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function unrollBilling(billing,props){if(billing.min_amount==null){return Object.assign({},billing,{min_amount:null,paymentImages:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,billing.paymentImages)});}else{return Object.assign({},billing,{min_amount:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,billing.min_amount),paymentImages:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,billing.paymentImages)});}}function unrollConfig(config,props){var allowedBillings={};var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=Object.keys(config.billings)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var type=_step.value;if(config.billings[type].allowedPlatforms.includes(props.platform)){allowedBillings[type]=unrollBilling(config.billings[type],props);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}var defaultBilling=void 0;var defaultBank=null;var defaultDeposit=null;// Поле defaults — новее, мы используем его по-умолчанию
if(config.defaults!=null){defaultBilling=config.defaults.billing;defaultBank=config.defaults.bank||null;defaultDeposit=config.defaults.amount||null;}else{defaultBilling=Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["b" /* getByPlatform */])(props.platform,config.defaultBilling);}var billingTypes=Object.keys(allowedBillings);var billingDeposits=billingTypes.reduce(function(accumulated,billingType){var deposits=config.billings[billingType].deposits;var defaultDeposits=void 0;if(deposits){defaultDeposits=Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["b" /* getByPlatform */])(props.platform,deposits));}return Object.assign({},accumulated,_defineProperty({},billingType,defaultDeposits));},{});var deposits=Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["b" /* getByPlatform */])(props.platform,config.deposits));var getDefaultValue=function getDefaultValue(billingType){var billing=config.billings[billingType];if(billing&&billing.deposits&&billing.deposits.default&&billing.deposits.default[props.currency]){var values=billing.deposits.default[props.currency];var lastItem=values[values.length-1];if(lastItem&&lastItem.amount){return lastItem.amount;}}return Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,config.defaultValue);};var banksSettings=config.banksSettings===0?0:Object.assign({},config.banksSettings);if(banksSettings!==0){// Обратная совместимость со старым форматом
if(typeof banksSettings.forBilling==="string"){banksSettings=_defineProperty({},banksSettings.forBilling,banksSettings);}banksSettings=Object.keys(banksSettings).reduce(function(banksSettings,billing){var settings=banksSettings[billing];if(settings.banks!=null){var banks=settings.banks;banksSettings[billing]=Object.assign({},settings,{banks:Array.isArray(banks)?banks:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,banks)});}else if(settings.payment_points!=null){var payment_points=settings.payment_points;banksSettings[billing]={payment_points:Array.isArray(payment_points)?payment_points:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,payment_points)};}else if(settings.providers!=null){var providers=settings.providers;banksSettings[billing]=Object.assign({},settings,{providers:Array.isArray(providers)?providers:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,providers)});}return banksSettings;},banksSettings);}return{billingDeposits:billingDeposits,deposits:deposits,defaultBilling:defaultBilling,defaultBank:defaultBank,defaultDeposit:defaultDeposit,banksSettings:banksSettings,platform:props.platform,layout:props.layout,billings:allowedBillings,defaultValue:Object(__WEBPACK_IMPORTED_MODULE_4__configs_FillupConfigTypes__["a" /* getByCurrency */])(props.currency,config.defaultValue),getDefaultValue:getDefaultValue,ptest:props.ptest};}var FillupConfiguration=function(_React$Component){_inherits(FillupConfiguration,_React$Component);function FillupConfiguration(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FillupConfiguration);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FillupConfiguration.__proto__||Object.getPrototypeOf(FillupConfiguration)).call.apply(_ref,[this].concat(args))),_this),_this.state={isFetched:false,desktop:null,mobile:null,ptest:false},_this.renderChildren=function(isMobile){if(isMobile){if(!_this.state.mobile){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinners_BrandSpinner__["a" /* default */],null);}var mobileLayouts=Object.keys(_this.state.mobile);var mobileLayout=mobileLayouts[0];var _config=unrollConfig(_this.state.mobile[mobileLayout],{currency:_this.props.currency,platform:"mobile",layout:mobileLayout,ptest:_this.state.ptest});return _this.props.children(_config);}else{if(!_this.state.desktop){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinners_BrandSpinner__["a" /* default */],null);}var desktopLayouts=Object.keys(_this.state.desktop);var desktopLayout=desktopLayouts[0];var _config2=unrollConfig(_this.state.desktop[desktopLayout],{currency:_this.props.currency,platform:"desktop",layout:desktopLayout,ptest:_this.state.ptest});return _this.props.children(_config2);}},_this.receiveConfigs=function(configs){var _configs=_slicedToArray(configs,2),desktop=_configs[0],mobile=_configs[1];_this.setState({desktop:desktop,mobile:mobile});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FillupConfiguration,[{key:"fetch",value:function fetch(){var _this2=this;var isPaymentTest=this.props.location.search.indexOf("ptest")>-1;Object(__WEBPACK_IMPORTED_MODULE_3__common_fetch__["d" /* get */])("/api/billings/full?locale="+this.props.locale).then(this.receiveConfigs).catch(function(){console.warn("Running /fillup on default configuration");_this2.receiveConfigs(__WEBPACK_IMPORTED_MODULE_5__configs_FillupConfig_default__["a" /* default */]);}).then(function(){return _this2.setState({isFetched:true,ptest:isPaymentTest});});}},{key:"componentDidMount",value:function componentDidMount(){var _this3=this;this.fetch();window.ptest=function(){return _this3.setState({ptest:true});};}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(prevProps.locale!==this.props.locale){this.fetch();}}},{key:"render",value:function render(){if(!this.state.isFetched){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinners_BrandSpinner__["a" /* default */],null);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)"},this.renderChildren);}}]);return FillupConfiguration;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var FillupConfigurationWithCurrency=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{currency:state.profile?state.profile.currency:"USD"};})(FillupConfiguration);/* unused harmony default export */ var _unused_webpack_default_export = (FillupConfigurationWithCurrency);function withConfiguration(Component){return function Configured(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FillupConfigurationWithCurrency,null,function(config){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},props,{config:config}));});};}function getPaymentBonus(config,value){var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=config.deposits[Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var deposit=_step2.value;if(value>=Number(deposit.amount)){return deposit.bonus;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}return 0;}function getPromoBonus(promo,value){var _iteratorNormalCompletion3=true;var _didIteratorError3=false;var _iteratorError3=undefined;try{for(var _iterator3=promo.size_of_bonus[Symbol.iterator](),_step3;!(_iteratorNormalCompletion3=(_step3=_iterator3.next()).done);_iteratorNormalCompletion3=true){var deposit=_step3.value;var _min_dep=deposit.min_dep===null?0:deposit.min_dep;var _max_dep=deposit.max_dep===null?Infinity:deposit.max_dep;if(value>=_min_dep&&value<_max_dep){return deposit.bonus;}}}catch(err){_didIteratorError3=true;_iteratorError3=err;}finally{try{if(!_iteratorNormalCompletion3&&_iterator3.return){_iterator3.return();}}finally{if(_didIteratorError3){throw _iteratorError3;}}}return 0;}function getBillingBonus(config,billingType){var billing=config.billings[billingType];if(billing){return billing.bonus;}return 0;}// Второе поколение хелперов основано на единственом параметре - FillupObject
function getRegularBonus(fillup){return getPaymentBonus(fillup.config,fillup.deposit)+getBillingBonus(fillup.config,fillup.billingType);}function getAbsoluteRegularBonus(fillup){return fillup.deposit*getRegularBonus(fillup)/100;}function getAbsolutePromoBonus(fillup){if(fillup.promo!=null){switch(fillup.promo.type_of_bonus){case"money":return getPromoBonus(fillup.promo,fillup.deposit);case"percent":return fillup.deposit*getPromoBonus(fillup.promo,fillup.deposit)/100;default:throw new TypeError("Unknown promo bonus type");}}else{return 0;}}function getBonus(fillup){return fillup.promo!=null?getPromoBonus(fillup.promo,fillup.deposit):getRegularBonus(fillup);}function getAbsoluteBonus(fillup){return fillup.promo!=null?getAbsolutePromoBonus(fillup):getAbsoluteRegularBonus(fillup);}

/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(1853);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(1857);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(1858);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(286);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(444);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(442);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(710);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(441);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(712);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(1859);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BonusTable; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FullPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Input__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Protection__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_fillup__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_promocode_coupon_svg__ = __webpack_require__(1627);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_promocode_coupon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_promocode_coupon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_promocode_promo_dots_svg__ = __webpack_require__(1628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_promocode_promo_dots_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_promocode_promo_dots_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_promocode_coupon_icon_svg__ = __webpack_require__(1629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_promocode_coupon_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_promocode_coupon_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_promocode_info_icon_svg__ = __webpack_require__(1630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_promocode_info_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_promocode_info_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_promocode_timer_icon_svg__ = __webpack_require__(1631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_promocode_timer_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_promocode_timer_icon_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_promocode_wallet_icon_svg__ = __webpack_require__(1632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_promocode_wallet_icon_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_promocode_wallet_icon_svg__);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 25px;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 20000;\n  overflow: auto;\n\n  ",";\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  padding: 25px;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 20000;\n  overflow: auto;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      @media (max-width: 767px) {\n        padding: 0;\n      }\n    "],["\n      @media (max-width: 767px) {\n        padding: 0;\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n"],["\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  margin: 0 auto;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: stretch;\n  width: 100%;\n  min-height: ",";\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 16);\n  overflow: hidden;\n\n  ",";\n"],["\n  direction: ",";\n  position: relative;\n  display: inline-flex;\n  justify-content: flex-start;\n  align-items: stretch;\n  width: 100%;\n  min-height: ",";\n  margin: 0 auto;\n  text-align: center;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 16);\n  overflow: hidden;\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n      @media (max-width: 767px) {\n        min-height: 100%;\n        height: 100%;\n        max-width: 100%;\n        border-radius: 0;\n        box-shadow: none;\n        background-color: #f6f6f6;\n      }\n\n      @media (min-width: 960px) {\n        width: auto;\n        min-width: 620px;\n        max-width: 700px;\n      }\n    "],["\n      @media (max-width: 767px) {\n        min-height: 100%;\n        height: 100%;\n        max-width: 100%;\n        border-radius: 0;\n        box-shadow: none;\n        background-color: #f6f6f6;\n      }\n\n      @media (min-width: 960px) {\n        width: auto;\n        min-width: 620px;\n        max-width: 700px;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 14px;\n  ",";\n  width: 16px;\n  height: 16px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  z-index: 1;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0;\n    height: 22px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"],["\n  position: absolute;\n  top: 14px;\n  ",";\n  width: 16px;\n  height: 16px;\n  color: #a0a7b2;\n  background-size: cover;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  z-index: 1;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    width: 0;\n    height: 22px;\n    border-left: 2px solid;\n  }\n\n  :before {\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n  }\n\n  :after {\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0;\n  }\n\n  :hover {\n    color: #60a31c;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n\n  @media (max-width: 567px) {\n    flex-direction: column;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n\n  @media (max-width: 567px) {\n    flex-direction: column;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n\n  @media (min-width: 568px) {\n    width: 175px;\n    min-width: 175px;\n\n    :after {\n      position: absolute;\n      ",";\n      top: 4px;\n      bottom: 0;\n      height: 100%;\n      width: 4px;\n      background: url(",");\n      background-repeat: repeat-y;\n      content: \"\";\n    }\n  }\n  @media (min-width: 960px) {\n    width: 225px;\n    min-width: 225px;\n  }\n  @media (max-width: 767px) {\n    padding: 30px 35px;\n  }\n  @media (max-width: 567px) {\n    background-color: #f6f6f6;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #fff;\n\n  @media (min-width: 568px) {\n    width: 175px;\n    min-width: 175px;\n\n    :after {\n      position: absolute;\n      ",";\n      top: 4px;\n      bottom: 0;\n      height: 100%;\n      width: 4px;\n      background: url(",");\n      background-repeat: repeat-y;\n      content: \"\";\n    }\n  }\n  @media (min-width: 960px) {\n    width: 225px;\n    min-width: 225px;\n  }\n  @media (max-width: 767px) {\n    padding: 30px 35px;\n  }\n  @media (max-width: 567px) {\n    background-color: #f6f6f6;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: block;\n  width: 177px;\n\n  @media (min-width: 568px) and (max-width: 959px) {\n    width: 127px;\n  }\n"],["\n  display: block;\n  width: 177px;\n\n  @media (min-width: 568px) and (max-width: 959px) {\n    width: 127px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 25px;\n  padding-bottom: 16px;\n  background-color: #f6f6f6;\n\n  @media (max-width: 959px) {\n    padding: 25px 15px;\n  }\n\n  @media (max-width: 567px) {\n    flex: 1;\n    align-items: center;\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 0;\n  }\n\n  @media (max-width: 359px) {\n    padding: 25px 10px;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 25px;\n  padding-bottom: 16px;\n  background-color: #f6f6f6;\n\n  @media (max-width: 959px) {\n    padding: 25px 15px;\n  }\n\n  @media (max-width: 567px) {\n    flex: 1;\n    align-items: center;\n    max-width: 500px;\n    margin-left: auto;\n    margin-right: auto;\n    padding-top: 0;\n  }\n\n  @media (max-width: 359px) {\n    padding: 25px 10px;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 288px;\n  padding-top: 11px;\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-width: 288px;\n  padding-top: 11px;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  font-size: 16px;\n  font-weight: bold;\n  color: #343434;\n\n  @media (max-width: 567px) {\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    text-align: center;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  font-size: 16px;\n  font-weight: bold;\n  color: #343434;\n\n  @media (max-width: 567px) {\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    text-align: center;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 288px;\n  margin: 18px auto 28px auto;\n\n  @media (max-width: 567px) {\n    max-width: 280px;\n  }\n\n  @media (max-width: 479px) {\n    max-width: 177px;\n  }\n\n  input {\n    text-transform: uppercase;\n  }\n"],["\n  width: 100%;\n  max-width: 288px;\n  margin: 18px auto 28px auto;\n\n  @media (max-width: 567px) {\n    max-width: 280px;\n  }\n\n  @media (max-width: 479px) {\n    max-width: 177px;\n  }\n\n  input {\n    text-transform: uppercase;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  margin-bottom: 28px;\n\n  @media (max-width: 567px) {\n    display: inline-block;\n    margin-top: 16px;\n  }\n"],["\n  margin-bottom: 28px;\n\n  @media (max-width: 567px) {\n    display: inline-block;\n    margin-top: 16px;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 20px;\n  color: #919191;\n  text-align: center;\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  font-size: ",";\n  line-height: 20px;\n  color: #919191;\n  text-align: center;\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n      text-align: right;\n    "],["\n      text-align: right;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n      @media (max-width: 567px) {\n        display: none;\n      }\n    "],["\n      @media (max-width: 567px) {\n        display: none;\n      }\n    "]),_templateObject18=_taggedTemplateLiteral(["\n      @media (min-width: 960px) {\n        display: none;\n      }\n    "],["\n      @media (min-width: 960px) {\n        display: none;\n      }\n    "]),_templateObject19=_taggedTemplateLiteral(["\n  display: flex;\n  color: #e74c3c;\n"],["\n  display: flex;\n  color: #e74c3c;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  width: 20px;\n  margin-left: 7px;\n\n  ",";\n"],["\n  width: 20px;\n  margin-left: 7px;\n\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n      margin-left: 0;\n      margin-right: 7px;\n    "],["\n      margin-left: 0;\n      margin-right: 7px;\n    "]),_templateObject22=_taggedTemplateLiteral(["\n  margin-top: 10px;\n"],["\n  margin-top: 10px;\n"]),_templateObject23=_taggedTemplateLiteral(["\n  width: 18px;\n  min-width: 18px;\n  margin-right: 7px;\n"],["\n  width: 18px;\n  min-width: 18px;\n  margin-right: 7px;\n"]),_templateObject24=_taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  text-align: center;\n  display: ",";\n"],["\n  width: 100%;\n  margin-top: 15px;\n  margin-bottom: 15px;\n  text-align: center;\n  display: ",";\n"]),_templateObject25=_taggedTemplateLiteral(["\n  display: inline;\n  padding: 0;\n  font-weight: normal;\n  font-size: ",";\n  color: #3598db;\n  text-decoration: underline;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: none;\n  }\n"],["\n  display: inline;\n  padding: 0;\n  font-weight: normal;\n  font-size: ",";\n  color: #3598db;\n  text-decoration: underline;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: none;\n  }\n"]),_templateObject26=_taggedTemplateLiteral(["\n  padding: 17px;\n  background-color: #f6f6f6;\n"],["\n  padding: 17px;\n  background-color: #f6f6f6;\n"]),_templateObject27=_taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  margin-bottom: 20px;\n  text-align: left;\n"],["\n  display: block;\n  width: 100%;\n  margin-bottom: 20px;\n  text-align: left;\n"]),_templateObject28=_taggedTemplateLiteral(["\n  ",";\n  font-size: ",";\n  line-height: 1.2;\n  color: #343434;\n"],["\n  ",";\n  font-size: ",";\n  line-height: 1.2;\n  color: #343434;\n"]),_templateObject29=_taggedTemplateLiteral(["\n  margin-top: 5px;\n"],["\n  margin-top: 5px;\n"]),_templateObject30=_taggedTemplateLiteral(["\n  padding: 5px 8px;\n  font-size: ",";\n  font-weight: bold;\n  line-height: 1.3;\n  border: 1px solid #717171;\n"],["\n  padding: 5px 8px;\n  font-size: ",";\n  font-weight: bold;\n  line-height: 1.3;\n  border: 1px solid #717171;\n"]),_templateObject31=_taggedTemplateLiteral(["\n  padding: 5px 8px;\n  font-size: ",";\n  line-height: 1.2;\n  border: 1px solid #717171;\n"],["\n  padding: 5px 8px;\n  font-size: ",";\n  line-height: 1.2;\n  border: 1px solid #717171;\n"]),_templateObject32=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  min-height: 27px;\n  margin-bottom: 7px;\n\n  @media (max-width: 475px) {\n    ",";\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  width: 100%;\n  min-height: 27px;\n  margin-bottom: 7px;\n\n  @media (max-width: 475px) {\n    ",";\n  }\n"]),_templateObject33=_taggedTemplateLiteral(["\n        flex-wrap: wrap;\n      "],["\n        flex-wrap: wrap;\n      "]),_templateObject34=_taggedTemplateLiteral(["\n  width: 20px;\n  ",";\n  flex: 0 0 auto;\n\n  @media (max-width: 639px) {\n    ",";\n  }\n"],["\n  width: 20px;\n  ",";\n  flex: 0 0 auto;\n\n  @media (max-width: 639px) {\n    ",";\n  }\n"]),_templateObject35=_taggedTemplateLiteral(["\n  max-width: 100%;\n"],["\n  max-width: 100%;\n"]),_templateObject36=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: 16px;\n  font-weight: bold;\n  color: #343434;\n  flex: 0 0 auto;\n  ",";\n  white-space: nowrap;\n\n  @media (max-width: 639px) {\n    ",";\n  }\n\n  @media (max-width: 375px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 359px) {\n    flex-shrink: 1;\n    white-space: normal;\n    ",";\n    line-height: 1.2;\n  }\n"],["\n  direction: ",";\n  font-size: 16px;\n  font-weight: bold;\n  color: #343434;\n  flex: 0 0 auto;\n  ",";\n  white-space: nowrap;\n\n  @media (max-width: 639px) {\n    ",";\n  }\n\n  @media (max-width: 375px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 359px) {\n    flex-shrink: 1;\n    white-space: normal;\n    ",";\n    line-height: 1.2;\n  }\n"]),_templateObject37=_taggedTemplateLiteral(["\n  width: ",";\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.2;\n  ",";\n  text-transform: ",";\n  color: ",";\n\n  @media (max-width: 375px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 359px) {\n    flex: 1;\n    white-space: ",";\n  }\n"],["\n  width: ",";\n  font-size: 16px;\n  font-weight: bold;\n  line-height: 1.2;\n  ",";\n  text-transform: ",";\n  color: ",";\n\n  @media (max-width: 375px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 359px) {\n    flex: 1;\n    white-space: ",";\n  }\n"]),_templateObject38=_taggedTemplateLiteral(["\n  display: flex;\n"],["\n  display: flex;\n"]),_templateObject39=_taggedTemplateLiteral(["Confirm"],["Confirm"]),_templateObject40=_taggedTemplateLiteral(["Apply"],["Apply"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ErrorIcon=function ErrorIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"6341 408.95 18 16",fill:"#e74c3c",width:"18",height:"16"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M17.7,42.525,10.62,30.759A2.1,2.1,0,0,0,7,30.768L.3,42.52a2.121,2.121,0,0,0,1.812,3.209H15.886A2.121,2.121,0,0,0,17.7,42.525ZM8.811,43.607a1.061,1.061,0,1,1,1.055-1.061A1.059,1.059,0,0,1,8.811,43.607ZM9.88,38.3a1.071,1.071,0,0,1-1.069,1.061A1.053,1.053,0,0,1,7.764,38.3V34.061A1.053,1.053,0,0,1,8.811,33,1.071,1.071,0,0,1,9.88,34.061Z",transform:"translate(6340.999 379.221)"}));};var BonusDeposit=function BonusDeposit(_ref){var bonus=_ref.bonus;if(bonus.min_dep===null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Td,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"up to ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,bonus.max_dep)));}else if(bonus.max_dep===null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Td,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"from ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,bonus.min_dep)));}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Td,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"from ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,bonus.min_dep))," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"up to ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,bonus.max_dep)));}};var BonusTable=function BonusTable(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Table,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Th,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Deposit amount")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Th,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Bonus amount"))),props.promo.size_of_bonus.map(function(bonus){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BonusDeposit,{bonus:bonus}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Td,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,bonus.bonus)));})));};var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return!props.info&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var PopupTable=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].table(_templateObject3);var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.direction;},function(_ref3){var info=_ref3.info;return info?"auto":"260px";},function(props){return!props.info&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);});var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("right","14px"));var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var ImgContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("right","-2px"),__WEBPACK_IMPORTED_MODULE_11__images_promocode_promo_dots_svg___default.a);var CouponImg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject9);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var ContentWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(props){return props.theme.direction;});var InputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var PromoInfo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject16);},function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject18);});var PromoError=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(PromoInfo)(_templateObject19);var ValidImg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject21);});var ContinueContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22);var ErrorIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject23);var CancelContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject24,function(props){return props.hide?"none":"block";});var Cancel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject25,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));var InfoContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject26);var InfoIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject27);var InfoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject28,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("text-align","left"),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].table(_templateObject29);var Th=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].th(_templateObject30,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));var Td=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].td(_templateObject31,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));var Row=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject32,function(_ref4){var isPromo=_ref4.isPromo,theme=_ref4.theme;return theme.locale==="es"&&isPromo&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject33);});var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject34,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-right","20px"),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-right","10px"));var IconImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject35);var TitleText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject36,function(_ref5){var theme=_ref5.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-right","20px"),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-right","10px"),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14,16),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("text-align","left"));var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject37,function(_ref6){var upper=_ref6.upper;return upper?"auto":"100%";},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("text-align","left"),function(_ref7){var upper=_ref7.upper;return upper?"uppercase":"none";},function(_ref8){var timer=_ref8.timer;return timer?"#0085EB":"#3B9478";},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14,16),function(_ref9){var timer=_ref9.timer;return timer?"nowrap":"normal";});var PromoCodeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject38);var Bonus=function Bonus(_ref10){var promo=_ref10.promo;if(promo.size_of_bonus==null){return null;}if(promo.size_of_bonus.length===1){// type_of_bonus === "money" | "percent"
if(promo.type_of_bonus==="percent"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"",promo.size_of_bonus[0].bonus+"%"," for any sum");}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,promo.size_of_bonus[0].bonus)," for any sum");}var l=promo.size_of_bonus.length-1;var sortedBonus=promo.size_of_bonus.sort(function(a,b){return a.bonus>b.bonus?1:-1;});if(promo.type_of_bonus==="percent"){return(// prettier-ignore
__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"From ",sortedBonus[0].bonus+"%"," to ",sortedBonus[l].bonus+"%"));}return(// prettier-ignore
__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"From ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,sortedBonus[0].bonus)," to ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Money__["b" /* default */],null,sortedBonus[l].bonus)));};var Timer=function Timer(_ref11){var time=_ref11.time;var duration=__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(time,"seconds");var d=duration.days();var h=duration.hours();var m=duration.minutes();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,d,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"d")," : ",h,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"h")," : ",m,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"m"));};var FullPage=function FullPage(_ref12){var children=_ref12.children,info=_ref12.info;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,{info:info},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PopupTable,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("td",{style:{verticalAlign:"middle",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,{info:info},children))))));};var ModalPromo=function ModalPromo(props){var promoContext=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__pages_fillup__["PromoContext"]);var currentTime=Object(__WEBPACK_IMPORTED_MODULE_8__Protection__["c" /* useServerTime */])([]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FullPage,{info:props.info},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:props.info?props.toggleInfoModal:function(){props.onRemovePromo();props.onDismiss();}}),props.info?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoIcon,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"2025 3000 36 36",fill:"#feac00",width:"36",height:"36"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"information",transform:"translate(2025 3000)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0Zm0,8.394a2.26,2.26,0,1,1-2.26,2.26A2.26,2.26,0,0,1,18,8.394Zm3.955,19.211h-7.91v-3.39H15.74v-6.78H14.045v-3.39H20.26v10.17h1.695v3.39h0Z",transform:"translate(0)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M325.935,331.7l7.9,2.116-2.116-7.9Z",transform:"translate(-298.434 -298.419)"})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,promoContext.isPromoApplied?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,promoContext.promo.description," ",promoContext.promo.type_of_bonus==="money"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BonusTable,{promo:promoContext.promo})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"A promo code is a special set of symbols that allows you to receive a bonus."),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("br",null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Enter a code into the field and press \"Confirm\". The promo code will activate extra funds to your account.")))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ImgContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CouponImg,{src:__WEBPACK_IMPORTED_MODULE_10__images_promocode_coupon_svg___default.a,alt:""})),promoContext.isPromoApplied?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Row,{isPromo:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconImage,{src:__WEBPACK_IMPORTED_MODULE_12__images_promocode_coupon_icon_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TitleText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Promo Code"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PromoCodeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,{upper:true},promoContext.promoCode),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValidImg,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"13.487",height:"10.209",viewBox:"0 0 13.487 10.209"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M5.694,30.593l-3.35-3.374L1,28.573,5.694,33.3l8.793-8.856-1.344-1.353Z",transform:"translate(-1 -23.091)",fill:"#3b9478"}))))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Row,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconImage,{src:__WEBPACK_IMPORTED_MODULE_15__images_promocode_wallet_icon_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TitleText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Bonus"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bonus,{promo:promoContext.promo}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Row,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconImage,{src:__WEBPACK_IMPORTED_MODULE_14__images_promocode_timer_icon_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TitleText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Bonus lifetime"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,{timer:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Timer,{time:promoContext.promo.expire_time-currentTime}))),promoContext.promo.description&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Row,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconImage,{src:__WEBPACK_IMPORTED_MODULE_13__images_promocode_info_icon_svg___default.a})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,promoContext.promo.description)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContinueContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */],{onClick:props.onDismiss,title:props.gettext(_templateObject39),wide:true,color:"mint"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CancelContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cancel,{onClick:function onClick(){props.onRemovePromo();props.onDismiss();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Cancel"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PromoInfo,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"A promo code is a special set of symbols that allows you to receive a bonus.")))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Promo Code"),":")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Input__["b" /* default */],{onChange:promoContext.onInputPromo,invalid:!!promoContext.promo_error,value:promoContext.promoCode,focus:true,promo:true})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */],{onClick:promoContext.onValidatePromo,title:props.gettext(_templateObject40),showSpinner:promoContext.isFetchPromoInProgress,disabled:promoContext.isFetchPromoInProgress||promoContext.promo_error||promoContext.promoCode.length<1,color:"mint",wide:true})),promoContext.promo_error?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PromoError,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ErrorIcon,null)),promoContext.promo_error):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PromoInfo,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"A promo code is a special set of symbols that allows you to receive a bonus.")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CancelContainer,{hide:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cancel,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Cancel")))))));};/* harmony default export */ __webpack_exports__["c"] = (Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["g" /* withGettext */])(ModalPromo));

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return animateChatButton; });
/* unused harmony export ChatSchedule */
/* unused harmony export ScheduledChat */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_pick__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_fp_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_chat_help_svg__ = __webpack_require__(1617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_chat_help_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_chat_help_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(81);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  margin-top: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  position: fixed;\n  z-index: 16000001;\n  right: 10px;\n  bottom: 0;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  display: block;\n  width: 290px;\n  height: 400px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 0 3px 2px;\n\n  ",";\n"],["\n  direction: ",";\n  margin-top: 0;\n  margin-right: 0;\n  margin-bottom: 0;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n  position: fixed;\n  z-index: 16000001;\n  right: 10px;\n  bottom: 0;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  display: block;\n  width: 290px;\n  height: 400px;\n  box-shadow: rgba(0, 0, 0, 0.1) 0 0 3px 2px;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      min-width: 100%;\n      max-width: 100%;\n      min-height: 100%;\n      max-height: 100%;\n      border-radius: 0;\n    "],["\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      min-width: 100%;\n      max-width: 100%;\n      min-height: 100%;\n      max-height: 100%;\n      border-radius: 0;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  width: 290px;\n  height: 400px;\n  padding-top: 24px;\n  font-size: ",";\n  color: #666;\n\n  ",";\n"],["\n  width: 290px;\n  height: 400px;\n  padding-top: 24px;\n  font-size: ",";\n  color: #666;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      width: 100%;\n      height: 100%;\n      padding-top: 44px;\n      font-size: ",";\n      background-color: ",";\n    "],["\n      width: 100%;\n      height: 100%;\n      padding-top: 44px;\n      font-size: ",";\n      background-color: ",";\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  height: 376px;\n  padding: 20px 20px 0;\n  background-color: ",";\n\n  ",";\n"],["\n  height: 376px;\n  padding: 20px 20px 0;\n  background-color: ",";\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      width: 100%;\n      max-width: 360px;\n      height: auto;\n      margin-left: auto;\n      margin-right: auto;\n      padding: 10px 10px 0;\n    "],["\n      width: 100%;\n      max-width: 360px;\n      height: auto;\n      margin-left: auto;\n      margin-right: auto;\n      padding: 10px 10px 0;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  z-index: 10;\n  height: 24px;\n  color: #e0edd3;\n  background: #6cae1e;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  user-select: none;\n\n  ",";\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  overflow: hidden;\n  z-index: 10;\n  height: 24px;\n  color: #e0edd3;\n  background: #6cae1e;\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  user-select: none;\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      height: 44px;\n      border-radius: 0;\n    "],["\n      height: 44px;\n      border-radius: 0;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  position: relative;\n  padding-left: 25px;\n  padding-right: 25px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: inherit;\n  text-align: center;\n  font-size: ",";\n  line-height: 24px;\n  font-weight: bold;\n\n  ",";\n"],["\n  position: relative;\n  padding-left: 25px;\n  padding-right: 25px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  cursor: inherit;\n  text-align: center;\n  font-size: ",";\n  line-height: 24px;\n  font-weight: bold;\n\n  ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n      font-size: ",";\n      line-height: 44px;\n    "],["\n      font-size: ",";\n      line-height: 44px;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 25px;\n  height: 24px;\n  padding-top: 2px;\n  padding-right: 3px;\n  cursor: pointer;\n\n  ",";\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 25px;\n  height: 24px;\n  padding-top: 2px;\n  padding-right: 3px;\n  cursor: pointer;\n\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n      width: 44px;\n      height: 44px;\n      padding: 0;\n    "],["\n      width: 44px;\n      height: 44px;\n      padding: 0;\n    "]),_templateObject13=_taggedTemplateLiteral(["\n  width: 10px;\n  height: 2px;\n  margin: auto;\n  background-color: #e0edd3;\n\n  ",";\n"],["\n  width: 10px;\n  height: 2px;\n  margin: auto;\n  background-color: #e0edd3;\n\n  ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n      width: 16px;\n    "],["\n      width: 16px;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  width: 100%;\n  text-align: center;\n  padding: 10px 20px 0;\n  height: 40px;\n  border: 0 solid #eee;\n  border-top-width: 1px;\n\n  ",";\n"],["\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  width: 100%;\n  text-align: center;\n  padding: 10px 20px 0;\n  height: 40px;\n  border: 0 solid #eee;\n  border-top-width: 1px;\n\n  ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n      position: static;\n      padding: 0;\n      padding-top: 20px;\n      border: none;\n    "],["\n      position: static;\n      padding: 0;\n      padding-top: 20px;\n      border: none;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n  display: block;\n  text-decoration: none;\n  -webkit-appearance: none;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #ffffff;\n  background: #6cae1e;\n  font-size: ",";\n  padding: 8px 3px;\n  border: 1px solid #5ca101;\n  border-radius: 3px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n  font-weight: bold;\n  word-wrap: normal;\n  cursor: pointer;\n\n  ",";\n\n  :hover {\n    background: #5ca101;\n  }\n"],["\n  display: block;\n  text-decoration: none;\n  -webkit-appearance: none;\n  width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #ffffff;\n  background: #6cae1e;\n  font-size: ",";\n  padding: 8px 3px;\n  border: 1px solid #5ca101;\n  border-radius: 3px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.25);\n  font-weight: bold;\n  word-wrap: normal;\n  cursor: pointer;\n\n  ",";\n\n  :hover {\n    background: #5ca101;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n      padding: 10px 3px;\n      font-size: ",";\n    "],["\n      padding: 10px 3px;\n      font-size: ",";\n    "]),_templateObject19=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2;\n  margin-bottom: 10px;\n"],["\n  font-size: ",";\n  line-height: 1.2;\n  margin-bottom: 10px;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  padding-top: 30px;\n  ",";\n"],["\n  position: relative;\n  display: inline-block;\n  padding-top: 30px;\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  ",";\n  display: block;\n  width: 36px;\n  height: 36px;\n"],["\n  position: absolute;\n  top: 0;\n  ",";\n  display: block;\n  width: 36px;\n  height: 36px;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  font-size: 16px;\n  font-weight: bold;\n  color: #0085eb;\n  cursor: pointer;\n  ",";\n  text-decoration: underline;\n  user-select: none;\n\n  :hover {\n    text-decoration: none;\n  }\n"],["\n  font-size: 16px;\n  font-weight: bold;\n  color: #0085eb;\n  cursor: pointer;\n  ",";\n  text-decoration: underline;\n  user-select: none;\n\n  :hover {\n    text-decoration: none;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["Chat support"],["Chat support"]),_templateObject24=_taggedTemplateLiteral(["Chat with us"],["Chat with us"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2);});var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14),function(_ref2){var theme=_ref2.theme;return theme.foreground;});});var ContentWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.foreground;},function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6);});var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8);});var HeaderText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(11),function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12));});var HeaderClose=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject11,function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject12);});var CloseLine=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject13,function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject14);});var HelpButtonContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject15,function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject16);});var HelpButton=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */])(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.isMobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject18,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});});var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].p(_templateObject19,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14));var UniversalContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("padding-right","29px"));var UniversalImage=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].img(_templateObject21,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("right",0));var UniversalButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject22,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("text-align","left"));var useUserDepartment=function useUserDepartment(departments,lang,currency){var department="";// для юзеров с валютой назначем департамент по валюте
if(currency){switch(currency){case"VND":department="VN";break;case"PHP":department="PH";break;case"IDR":department="ID";break;case"INR":department="HI";break;case"THB":department="TH";break;case"UGX":case"KES":case"GHS":case"NGN":case"XAF":case"ZAR":case"TZS":department="AF";break;default:// назначаем департамент по языку юзера, если ниодна валюта не подошла
if(departments.name&&departments.name.some(function(l){return l.toLowerCase()===lang;})){department=lang.toUpperCase();}else{department="EN";break;}}}else{// здесь определяем департамент для незалогиненных юзеров
if(// назначаем департамент по соответсвующему языку юзера, кроме английского языка
departments.filter(function(d){return d.name.toLowerCase()!=="en";}).some(function(l){return l.name.toLowerCase()===lang;})){department=lang.toUpperCase();}else{department="Other";}}return departments.find(function(dept){return dept.name===department;});};var animateChatButton=function animateChatButton(){var colors=["#60A41B","#8e53c6","#9a5ad7","#8e53c6","#60A41B","#8e53c6","#9a5ad7","#8e53c6","#60A41B"];var run=function run(i){if(colors.length>i){window.$zopim.livechat.theme.setColor(colors[i]);window.$zopim.livechat.theme.reload();setTimeout(function(){return run(i+1);},150);}};if(window.$zopim){run(0);}};var OnlineButton=function OnlineButton(_ref5){var showButton=_ref5.showButton,onClick=_ref5.onClick;if(!showButton)return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UniversalContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UniversalButton,{onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Need help?")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Chat with us"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UniversalImage,{src:__WEBPACK_IMPORTED_MODULE_10__images_chat_help_svg___default.a})));};var OfflineButton=function OfflineButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UniversalContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UniversalButton,{onClick:props.showForm},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Need help?")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Chat with us"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UniversalImage,{src:__WEBPACK_IMPORTED_MODULE_10__images_chat_help_svg___default.a})));};var OfflineForm=function OfflineForm(props){var isAuth=props.profile!=null;var isReal=isAuth&&props.profile.real===1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderText,{isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Offline")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HeaderClose,{onClick:props.hideForm,isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseLine,{isMobile:props.isMobile}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContentWrapper,{isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"All our operators are offline at this moment.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,isAuth&&!isReal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"In the meantime, here is the link to our HelpCenter that you might find helpful."):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You can email us and we'll answer as soon as possible")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpButtonContainer,{isMobile:props.isMobile},isAuth&&!isReal?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpButton,{to:"/helpdesk/faq",target:"_blank",onClick:props.goToFaq,isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"FAQ")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpButton,{to:"/helpdesk/contacts",target:"_blank",onClick:props.goToFaq,isMobile:props.isMobile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Send email"))))));};var Chat=function(_React$PureComponent){_inherits(Chat,_React$PureComponent);function Chat(){var _ref6;var _temp,_this,_ret;_classCallCheck(this,Chat);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref6=Chat.__proto__||Object.getPrototypeOf(Chat)).call.apply(_ref6,[this].concat(args))),_this),_this.state={isChatting:false,showOnlineButton:false,isChatOpening:false,showOfflineButton:false,showOfflineForm:false},_this.showOfflineForm=function(){_this.setState({showOfflineForm:true});if(_this.props.isMobile&&document.body){document.body.style.cssText="position: fixed;\n"+"overflow-y: hidden;\n"+"width: 100%;\n"+"min-height: 100%;\n"+"margin: 0px;";}},_this.hideOfflineForm=function(){_this.setState({showOfflineForm:false});if(_this.props.isMobile&&document.body){document.body.style.position="";document.body.style.overflowY="";document.body.style.width="";document.body.style.minHeight="";document.body.style.margin="";}},_this.goToFaq=function(){_this.hideOfflineForm();},_this.showOnlineForm=function(){window.$zopim.livechat.window.show();_this.setState({showOnlineButton:false,isChatOpening:true});},_this.setDepartment=function(lang,prevLang){if(!window.$zopim)return null;if(typeof prevLang!=="undefined"){window.$zopim.livechat.departments.clearVisitorDepartment();}if(_this.props.userDepartment){window.$zopim.livechat.departments.setVisitorDepartment(_this.props.userDepartment.name);}},_this.mounted=false,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Chat,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.mounted=true;var phone=this.props.profile&&this.props.profile.phone;var id=this.props.profile&&this.props.profile.id;var email=this.props.profile&&this.props.profile.email;var first_name=this.props.profile&&this.props.profile.first_name;var last_name=this.props.profile&&this.props.profile.last_name;var $zopim=window.$zopim;if(typeof $zopim!=="function")return null;window.zE(function(){$zopim(function(){$zopim.livechat.setOnChatStart(function(){if(!_this2.mounted){return;}if(id){try{window.fetch(window.API_URL+"/api/user-support-log",{method:"POST",body:JSON.stringify({id:Date.now(),user_id:id,channel:"chat",answered:1})}).catch(console.log);}catch(e){console.error(e);}}_this2.setState({isChatting:true});});$zopim.livechat.setOnChatEnd(function(){if(!_this2.mounted){return;}_this2.setState({isChatting:false});});$zopim.livechat.window.onHide(function(){if(!_this2.mounted){return;}$zopim.livechat.hideAll();_this2.setState({showOnlineButton:true,isChatOpening:false});if(typeof _this2.props.onHide==="function"){_this2.props.onHide();}});$zopim.livechat.theme.setColor("#60A41B");$zopim.livechat.theme.reload();// apply new theme settings
phone!=null&&$zopim.livechat.setPhone(phone);email!=null&&$zopim.livechat.setEmail(email);if(first_name!=null&&last_name!=null){id!=null?$zopim.livechat.setName(first_name+" "+last_name+" / "+String(id)):$zopim.livechat.setName(first_name+" "+last_name);}else if(first_name!=null){id!=null?$zopim.livechat.setName(first_name+" / "+String(id)):$zopim.livechat.setName(""+first_name);}if(id!=null&&first_name==null&&last_name==null){$zopim.livechat.setName("/ "+String(id));}});});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState,snapshot){if(window.$zopim&&window.$zopim.livechat){if(this.props.profile!=null){window.$zopim.livechat.removeTags("unauthorized");}if(prevProps.lang!==this.props.lang){this.setDepartment(this.props.lang,prevProps.lang);window.$zopim.livechat.removeTags(prevProps.lang);window.$zopim.livechat.addTags(this.props.lang);}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.mounted=false;var $zopim=window.$zopim;if(typeof $zopim!=="function")return null;window.zE(function(){$zopim(function(){$zopim.livechat.hideAll();});});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,lang=_props.lang,showWindow=_props.showWindow;var isAvailable=this.props.isAvailableBySchedule||this.state.isChatting;var $zopim=window.$zopim;if($zopim!=null){window.zE(function(){$zopim(function(){// устанавливаем язык чата
var supportedLangs=["en","vn","th","id","hi","ar"];if(supportedLangs.some(function(l){return l===lang;})){lang==="vn"?$zopim.livechat.setLanguage("vi"):$zopim.livechat.setLanguage(lang);}else{$zopim.livechat.setLanguage("en");}// устанавливаем текста для элементов интерфейса чата
$zopim.livechat.setGreetings({online:_this3.props.gettext(_templateObject23),offline:_this3.props.gettext(_templateObject23),away:_this3.props.gettext(_templateObject23)});$zopim.livechat.window.setTitle(_this3.props.gettext(_templateObject23));$zopim.livechat.concierge.setTitle(_this3.props.gettext(_templateObject24));if(true){$zopim.livechat.concierge.setName(_this3.props.gettext(["IronTrade chat support"]));}// устанавливаем тэги и департаменты
_this3.setDepartment(lang,undefined);$zopim.livechat.addTags(lang);if(_this3.props.profile==null){$zopim.livechat.addTags("unauthorized");}if(!isAvailable){_this3.setState({showOnlineButton:false});$zopim.livechat.hideAll();}if(isAvailable&&!_this3.state.isChatOpening){_this3.setState({showOnlineButton:true});}if(showWindow&&isAvailable){$zopim.livechat.window.show();_this3.setState({showOnlineButton:false,isChatOpening:true});}});});}return isAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OnlineButton,{showButton:this.state.showOnlineButton,onClick:this.showOnlineForm,buttonPosition:this.props.buttonPosition}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OfflineButton,{isMobile:this.props.isMobile,isHelpdesk:this.props.isHelpdesk,showForm:this.showOfflineForm}),this.state.showOfflineForm&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OfflineForm,{isActive:this.state.showOfflineForm,hideForm:this.hideOfflineForm,isMobile:this.props.isMobile,goToFaq:this.goToFaq,lang:lang,profile:this.props.profile}));}}]);return Chat;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);var ChatSchedule=function ChatSchedule(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return window.zE("webWidget:get","chat:departments")||[];}),_useState2=_slicedToArray(_useState,2),departments=_useState2[0],setDepartments=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var active=true;// коллбэк после подключения к чату
window.zE("webWidget:on","chat:connected",function(){if(!active){return;}// получаем список департаментов при подключении виджета
setDepartments(window.zE("webWidget:get","chat:departments"));});return function(){active=false;};},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(departments.length>0){var active=true;window.zE("webWidget:on","chat:departmentStatus",function(dept){if(!active){return;}setDepartments(function(prevState){var nextState=[];var updated=false;var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=prevState[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var d=_step.value;if(d.id===dept.id){nextState.push(dept);updated=true;}else{nextState.push(d);}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}if(!updated){nextState.push(dept);}return nextState;});});return function(){active=false;};}},[departments.length>0]);var userDepartment=useUserDepartment(departments,props.lang,__WEBPACK_IMPORTED_MODULE_3_idx___default()(props,function(_){return _.profile.currency;}));if(departments.length<1){return null;}var isAvailableBySchedule=userDepartment!=null&&userDepartment.status==="online";return props.children({isAvailableBySchedule:isAvailableBySchedule,userDepartment:userDepartment});};var ScheduledChat=function ScheduledChat(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChatSchedule,{profile:props.profile,lang:props.lang},function(_ref7){var isAvailableBySchedule=_ref7.isAvailableBySchedule,userDepartment=_ref7.userDepartment;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Chat,{profile:props.profile,isMobile:props.isMobile,lang:props.lang,isHelpdesk:props.isHelpdesk,gettext:props.gettext,showWindow:props.showWindow,isAvailableBySchedule:isAvailableBySchedule,userDepartment:userDepartment,onHide:props.onHide,buttonPosition:props.buttonPosition}));});};var Routes=function Routes(props){if(props.serverData&&!props.serverData.isIOS&&"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_11__FeatureFlags__["a" /* default */].enableChat&&!Object(__WEBPACK_IMPORTED_MODULE_12__utils__["c" /* isIronTerminal */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScheduledChat,{profile:props.profile,isMobile:props.serverData.isMobile,lang:Object(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["d" /* inferLocale */])(props),gettext:props.gettext,buttonPosition:props.buttonPosition});}else{return null;}};/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["g" /* withGettext */])(Object(__WEBPACK_IMPORTED_MODULE_4__withData__["a" /* default */])({optional:["profile","serverData"]})(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux_es_connect_connect__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_7_lodash_fp_pick___default()(["fallbackLocale"]))(Routes)))));

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectTitle__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IndexPage_IronFooter__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withErrorCatch__ = __webpack_require__(149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  background: ##f5f5f5;\n  padding: 50px 0 20px 0;\n"],["\n  background: ##f5f5f5;\n  padding: 50px 0 20px 0;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 940px;\n  margin: 0 auto;\n  position: relative;\n\n  @media screen and (max-width: 960px) and (min-width: 800px) {\n    width: 780px;\n  }\n\n  @media screen and (max-width: 799px) {\n    width: 100%;\n  }\n"],["\n  width: 940px;\n  margin: 0 auto;\n  position: relative;\n\n  @media screen and (max-width: 960px) and (min-width: 800px) {\n    width: 780px;\n  }\n\n  @media screen and (max-width: 799px) {\n    width: 100%;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  font-weight: 400;\n  font-size: ",";\n  color: #919191;\n  text-align: center;\n"],["\n  direction: ",";\n  font-weight: 400;\n  font-size: ",";\n  color: #919191;\n  text-align: center;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FooterView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].footer(_templateObject);var CenterContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Copyright=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));function getSupportInfo(serverData){if(serverData==null||serverData.supportInfo===null){return{};}else{return Object.keys(serverData.supportInfo).filter(function(key){return key!=="en"&&key!=="ru";}).reduce(function(info,key){if(serverData!=null){info[key]=serverData.supportInfo[key];}return info;},{});}}var DEFAULT_COUNTRY= false?"th":"vn";var Footer=function(_React$Component){_inherits(Footer,_React$Component);function Footer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Footer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Footer.__proto__||Object.getPrototypeOf(Footer)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedOption:""},_this.CurrentYear=function(){var date=new Date();return date.getFullYear();},_this.handleChange=function(selectedOption){_this.setState({selectedOption:selectedOption});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Footer,[{key:"componentDidMount",value:function componentDidMount(){var serverData=this.props.serverData;var supportInfo=getSupportInfo(serverData);var geo=serverData.geo.toLowerCase();var lang=null;switch(geo){case"in":lang="hi";break;default:lang=geo;break;}var geoPhone=supportInfo[lang]||supportInfo[DEFAULT_COUNTRY];if(geoPhone){this.setState({selectedOption:{value:""+geo,label:""+geoPhone.phone[0]}});}}},{key:"render",value:function render(){var className=this.props.className;var CurrentYear=this.CurrentYear;// prettier-ignore
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterView,{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Copyright,null,"\xA9 ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentYear,null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__ProjectTitle__["a" /* default */],null),"."," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"All rights reserved"),".")));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var mapStateToProps=function mapStateToProps(state){return{serverData:state.serverData,isMobileApp:state.serverData&&(state.serverData.isIOS||state.serverData.isAndroidApp)||false,locale:Object(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["d" /* inferLocale */])(state),profile:state.profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__withErrorCatch__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_5__common_withDeposit__["b" /* withDeposit */])(function(props){return  true?props.isMobileApp?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IndexPage_IronFooter__["a" /* default */],props):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IndexPage_IronFooter__["a" /* default */],props):React.createElement(Footer,props);}))));

/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

var convert = __webpack_require__(1582),
    func = convert('pick', __webpack_require__(553));

func.placeholder = __webpack_require__(669);
module.exports = func;


/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flush", function() { return flush; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hydrate", function() { return hydrate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "cx", function() { return cx; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return merge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRegisteredStyles", function() { return getRegisteredStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sheet", function() { return sheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "caches", function() { return caches; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_emotion__ = __webpack_require__(1260);


var context = typeof global !== 'undefined' ? global : {};

var _createEmotion = Object(__WEBPACK_IMPORTED_MODULE_0_create_emotion__["a" /* default */])(context),
    flush = _createEmotion.flush,
    hydrate = _createEmotion.hydrate,
    cx = _createEmotion.cx,
    merge = _createEmotion.merge,
    getRegisteredStyles = _createEmotion.getRegisteredStyles,
    injectGlobal = _createEmotion.injectGlobal,
    keyframes = _createEmotion.keyframes,
    css = _createEmotion.css,
    sheet = _createEmotion.sheet,
    caches = _createEmotion.caches;



/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* harmony default export */ __webpack_exports__["b"] = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_shape__ = __webpack_require__(1953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NextGenChartTypes__ = __webpack_require__(45);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var defaultLine=Object(__WEBPACK_IMPORTED_MODULE_1_d3_shape__["b" /* line */])();var curvedLine=Object(__WEBPACK_IMPORTED_MODULE_1_d3_shape__["b" /* line */])().curve(__WEBPACK_IMPORTED_MODULE_1_d3_shape__["a" /* curveMonotoneX */]);function filterButLeavePadding(data,iteratee){var result=[];var previous=false;for(var i=0;i<data.length;i++){var current=iteratee(data[i],i,data);if(previous===false&&current===true&&i>0){result.push(data[i-1]);}if(current===true||previous===true){result.push(data[i]);}previous=current;}return result;}var Path=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](function(_ref){var data=_ref.data,curved=_ref.curved,shadow=_ref.shadow,viewportWidth=_ref.viewportWidth,viewportHeight=_ref.viewportHeight,props=_objectWithoutProperties(_ref,["data","curved","shadow","viewportWidth","viewportHeight"]);var windowedData=filterButLeavePadding(data,function(point){return point[0]>=0&&point[0]<=viewportWidth;});var displayedData=windowedData;if(shadow&&windowedData.length>0){var _windowedData$=_slicedToArray(windowedData[0],3),firstX=_windowedData$[0],firstSource=_windowedData$[2];var _windowedData=_slicedToArray(windowedData[windowedData.length-1],3),lastX=_windowedData[0],lastSource=_windowedData[2];displayedData=[].concat(_toConsumableArray(windowedData),[[lastX,viewportHeight,lastSource],[firstX,viewportHeight,firstSource]]);}var d=curved?curvedLine(displayedData):defaultLine(displayedData);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",Object.assign({d:d},props));});/* harmony default export */ __webpack_exports__["a"] = (Path);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = inferHelpdeskLocale;
/* harmony export (immutable) */ __webpack_exports__["c"] = withSlugFetch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinner__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var getApi=function getApi(){return window.HELPDESK_API_URL;};var API=getApi();function inferHelpdeskLocale(locale){// helpdesk locales
var availableXLocales=new Set(["en","th","vn","ph","hi","ar","id","es","cn","tr","ru"]);var xLocaleObj={en:"en_US",th:"th_TH",vn:"vi_VN",ph:"fil_PH",hi:"hi_HI",ar:"ar_AR",ru:"ru_RU",id:"id_ID",es:"es_AR",cn:"cn",tr:"tr_TR"};return xLocaleObj[availableXLocales.has(locale)?locale:"en"];}var mapStateToProps=function mapStateToProps(state){var helpdesk=state.helpdesk,apiConfigs=state.apiConfigs,serverData=state.serverData;return Object.assign({},helpdesk,{currency:serverData?serverData.currency:apiConfigs&&apiConfigs.defaultCurrency||"USD",locale:Object(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["d" /* inferLocale */])(state)});};// проверяем, едут ли к нам данные
var inFlight=new Set();function withFetch(WrappedComponent){var spinner=arguments.length>1&&arguments[1]!==undefined?arguments[1]:null;var Fetch=function(_React$Component){_inherits(Fetch,_React$Component);function Fetch(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Fetch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Fetch.__proto__||Object.getPrototypeOf(Fetch)).call.apply(_ref,[this].concat(args))),_this),_this.commonData=function(page){var object=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{headers:{}};var headers=object.headers,etc=_objectWithoutProperties(object,["headers"]);var locale=_this.props.locale;var fetchObject=Object.assign({headers:Object.assign({"X-LOCALE":inferHelpdeskLocale(locale),"X-CURRENCY":_this.props.currency.toUpperCase(),accept:"application/json"},headers)},etc);return fetch(""+API+page,fetchObject);},_this.getData=function(page,headers){return _this.commonData(page,headers).then(function(response){var status=response.status;switch(status){case 200:return response.json();default:return{status:status};}}).catch(function(){throw new TypeError("Expected response with status 200");});},_this.requestCurrentSlug=function(_ref2){var slug=_ref2.slug,type=_ref2.type;var _this$props=_this.props,locale=_this$props.locale,currency=_this$props.currency;// если данные не в процессе приезда
// и если locale установилась
if(!inFlight.has(slug)&&locale!==null){inFlight.add(slug);var queries={lang:inferHelpdeskLocale(locale),currency:currency};if(_this.props.profile!==null){queries.tags=4;}var url="page/"+slug;switch(type){case"news":url=slug;break;default:break;}try{_this.getData("/api/"+url+"?"+__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(queries)).then(function(payload){switch(type){case"news":_this.props.dispatch({type:"RECEIVE_HELPDESK_NEWS",payload:payload});break;default:_this.props.dispatch({type:"RECEIVE_HELPDESK_PAGE",payload:payload});break;}inFlight.delete(slug);});}catch(error){console.error(error);}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Fetch,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent,Object.assign({getData:this.getData,requestCurrentSlug:this.requestCurrentSlug},this.props));}}]);return Fetch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_6__withData__["a" /* default */])({required:["serverData"],optional:["profile"],spinner:spinner})(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Fetch));}function withSlugFetch(WrappedComponent,_ref3){var slug=_ref3.slug,type=_ref3.type,_ref3$spinner=_ref3.spinner,spinner=_ref3$spinner===undefined?null:_ref3$spinner;var SlugFetch=function(_React$Component2){_inherits(SlugFetch,_React$Component2);function SlugFetch(){_classCallCheck(this,SlugFetch);return _possibleConstructorReturn(this,(SlugFetch.__proto__||Object.getPrototypeOf(SlugFetch)).apply(this,arguments));}_createClass(SlugFetch,[{key:"componentDidMount",value:function componentDidMount(){if(!this.props[slug]){this.props.requestCurrentSlug({slug:slug,type:type});}}},{key:"render",value:function render(){if(this.props.locale&&this.props[slug]){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WrappedComponent,this.props);}if(spinner==="none"){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Spinner__["a" /* default */],{height:"300px"});}}]);return SlugFetch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(withFetch(function(props){var id=__WEBPACK_IMPORTED_MODULE_1_idx___default()(props,function(props){return props.profile.id;})||0;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SlugFetch,Object.assign({},props,{key:slug+id+props.locale+props.currency+props.location.pathname}));}));}/* harmony default export */ __webpack_exports__["a"] = (withFetch);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Private__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withLocaleChange__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Auth_Auth__ = __webpack_require__(96);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _Logic=function(_React$Component){_inherits(_Logic,_React$Component);function _Logic(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_Logic);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_Logic.__proto__||Object.getPrototypeOf(_Logic)).call.apply(_ref,[this].concat(args))),_this),_this.state={changeLocaleFetching:false,isNavActive:false,isIndexNavActive:false},_this.toggle=function(){_this.setState({isNavActive:!_this.state.isNavActive});},_this.indexToggle=function(){_this.setState({isIndexNavActive:!_this.state.isIndexNavActive});},_this.hide=function(){_this.setState({isNavActive:false});},_this.showTopLinks=function(){if(_this.props.location.pathname==="/"||_this.props.location.pathname==="/register"||_this.props.location.pathname==="/password-update"||_this.props.isIOS&&_this.props.appVersion<=2000000){return false;}return true;},_this.showLinks=function(){if(false){return false;}if(_this.props.isIOS&&_this.props.appVersion<=2000000){return false;}if(_this.props.location.pathname.startsWith("/fillup")){return false;}switch(_this.props.location.pathname){case"/trade":case"/trading-history":case"/profile":case"/profile2":case"/fillup":case"/withdraw":case"/finance-history":case"/billing/offline":case"/verification":case"/password-update":return false;default:return true;}},_this.showLoginForm=function(payload){_this.props.dispatch({type:"DISPLAY_AUTH_TAB",payload:payload});_this.props.dispatch({type:"DISPLAY_AUTH_FORM",payload:true});},_this.changeXLocaleWithLocale=function(locale){_this.props.onLocaleChange(locale);_this.props.dispatch({type:"UPDATE_HELPDESK_LOCALE",payload:locale});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_Logic,[{key:"componentDidMount",value:function componentDidMount(){if(window.isFullAndroidApp){this.props.dispatch({type:"DISPLAY_AUTH_TAB",payload:__WEBPACK_IMPORTED_MODULE_10__Auth_Auth__["c" /* REGISTER_TAB_ID */]});}}},{key:"render",value:function render(){var _props=this.props,children=_props.children,props=_objectWithoutProperties(_props,["children"]);var appVersion=props.appVersion,isIOS=props.isIOS,profile=props.profile;var path=props.match.path;var isLoggedIn=profile!=null;var isAppLogin=isIOS&&appVersion<=2000000;var isHelpdesk=path.startsWith("/helpdesk")||path.startsWith("/test-for-users");var isMainPage=props.location.pathname==="/";var isNews=__WEBPACK_IMPORTED_MODULE_5__FeatureFlags__["a" /* default */].enableHelpdeskNews===true&&__WEBPACK_IMPORTED_MODULE_5__FeatureFlags__["a" /* default */].showHelpdeskNewsRoute===true&&path.startsWith("/news");var isMobileApp=isIOS||props.isAndroidApp;var showLangSelect=isIOS&&path==="/login"||!isIOS;var query=__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.parse(props.location.search.slice(1));var authTab=props.authTab;switch(props.profileStatus){case"AVAILABLE":{if(Object(__WEBPACK_IMPORTED_MODULE_4__Private__["b" /* isProfileComplete */])(props.profile)){authTab="loggedin";}else{authTab="social_register";}break;}case"INVALID":if(query.action==="password"){authTab="social_password";}break;default:authTab=props.authTab;}if(typeof children==="function"){return children(Object.assign({},props,this.state,{isLoggedIn:isLoggedIn,isAppLogin:isAppLogin,isHelpdesk:isHelpdesk,isMainPage:isMainPage,isNews:isNews,showLangSelect:showLangSelect,isMobileApp:isMobileApp,authTab:authTab,activeTab:authTab,query:query,email:query.email,toggle:this.toggle,hide:this.hide,indexToggle:this.indexToggle,showTopLinks:this.showTopLinks,showLinks:this.showLinks,showLoginForm:this.showLoginForm,changeXLocaleWithLocale:this.changeXLocaleWithLocale}));}return children;}}]);return _Logic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(state,props){return{appVersion:state.serverData&&state.serverData.app_version,currencySettings:state.serverData&&state.serverData.currency_settings,isIOS:state.serverData&&state.serverData.isIOS,isAndroidApp:state.serverData&&state.serverData.isAndroidApp,isVIP:state.serverData&&state.serverData.isVIP,geo:state.serverData&&state.serverData.geo,locale:Object(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["d" /* inferLocale */])(state),locales:state.apiConfigs&&state.apiConfigs.locales,profile:state.profile,profileStatus:state.dataRequirementsStatus.profile,authTab:state.authForm.displayTab||"login",shouldDisplayMainHeader:state.authForm.displayForm||props.showMainHeader};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_8__common_fetch__["e" /* mapDispatchToFetch */])(Object(__WEBPACK_IMPORTED_MODULE_9__common_withDeposit__["b" /* withDeposit */])(Object(__WEBPACK_IMPORTED_MODULE_6__withLocaleChange__["a" /* default */])(_Logic)))));

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getByPlatform;
/* harmony export (immutable) */ __webpack_exports__["a"] = getByCurrency;
// TODO: Унести эти функции куда-нибудь
function getByPlatform(platform,input){return input.hasOwnProperty(platform)?input[platform]:input["default"];}function getByCurrency(currency,input){return input.hasOwnProperty(currency)?input[currency]:input["default"];}

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(365);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ReferralsPopup__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReferralsLink__ = __webpack_require__(1522);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"],["\n  display: flex;\n  justify-content: flex-end;\n"]),_templateObject2=_taggedTemplateLiteral(["Send"],["Send"]),_templateObject3=_taggedTemplateLiteral(["I invite you to get a bonus on ",""],["I invite you to get a bonus on ",""]),_templateObject4=_taggedTemplateLiteral(["Good news everyone! Now you can register on "," using my link ",", trade and make money. If you deposit more than "," in a one-time payment during 7 days after registration, then both of us will get "," as a bonus."],["Good news everyone! Now you can register on "," using my link ",", trade and make money. If you deposit more than "," in a one-time payment during 7 days after registration, then both of us will get "," as a bonus."]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);function getParameterByName(name,url){if(!url){url=window.location.href;}name=name.replace(/[[\]]/g,"\\$&");var regex=new RegExp("[?&]"+name+"(=([^&#]*)|&|#|$)"),results=regex.exec(url);if(!results)return null;if(!results[2])return"";return decodeURIComponent(results[2].replace(/\+/g," "));}var ReferralsShareLinks=function(_Component){_inherits(ReferralsShareLinks,_Component);function ReferralsShareLinks(props){_classCallCheck(this,ReferralsShareLinks);var _this=_possibleConstructorReturn(this,(ReferralsShareLinks.__proto__||Object.getPrototypeOf(ReferralsShareLinks)).call(this,props));_this.state={showPopup:false,popupData:{},popupSuccess:"",popupResponse:""};_this.onShowPopup=_this.onShowPopup.bind(_this);_this.onHidePopup=_this.onHidePopup.bind(_this);_this.onPopupSubmit=_this.onPopupSubmit.bind(_this);_this.sendLinkOnEmail=_this.sendLinkOnEmail.bind(_this);_this.sendLinkViaSMS=_this.sendLinkViaSMS.bind(_this);return _this;}_createClass(ReferralsShareLinks,[{key:"componentDidMount",value:function componentDidMount(){var share=getParameterByName("share_param");if(share&&(share==="phone"||share==="email")){var title="Enter friend's email";if(share==="phone"){title="Enter friend's phone";}this.onShowPopup({title:this.props.gettext(title),submitTitle:this.props.gettext(_templateObject2),type:share==="phone"?"tel":"email"});}}},{key:"openWindow",value:function openWindow(url,title,params){window.open(url,title,params);}},{key:"sendLinkOnEmail",value:function sendLinkOnEmail(value){var _this2=this;this.setState({sendingEmail:true});Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["d" /* get */])("/ajax/shareRefEmail?email="+value).catch(function(error){return error;}).then(function(data){_this2.setState({sendingEmail:false,popupSuccess:data.status==="OK",popupResponse:data.message});});}},{key:"sendLinkViaSMS",value:function sendLinkViaSMS(value){var _this3=this;this.setState({sendingText:true});Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["d" /* get */])("/ajax/shareRefSms?phone="+value).catch(function(error){return error;}).then(function(data){_this3.setState({sendingText:false,popupSuccess:data.status==="OK",popupResponse:data.message});});}},{key:"onShowPopup",value:function onShowPopup(popupData){this.setState({showPopup:true,popupData:popupData});}},{key:"onHidePopup",value:function onHidePopup(){this.setState({showPopup:false,sendingEmail:false,sendingText:false,popupData:{},popupSuccess:"",popupResponse:""});}},{key:"onPopupSubmit",value:function onPopupSubmit(value){switch(this.state.popupData.type){case"email":this.sendLinkOnEmail(value);break;case"tel":{this.sendLinkViaSMS(value);break;}default:break;}}},{key:"render",value:function render(){var _this4=this;var _props=this.props,projectName=_props.projectName,minDepo=_props.minDepo,refBonus=_props.refBonus,desktop=_props.desktop,isIndexPage=_props.isIndexPage,isTournament=_props.isTournament,link=_props.link,prize=_props.prize,tournamentTitle=_props.tournamentTitle,hideName=_props.hideName,hideEmail=_props.hideEmail;var shareTitle=this.props.shareTitle?this.props.shareTitle:this.props.gettext(_templateObject3,projectName);var shareText=this.props.shareText?this.props.shareText:isTournament&&"irontrade"==="irontrade"?this.props.gettext(["I earn ",' in "','" tournament on IronTrade! Register by my referal link ',", trade, invest and try tournaments!"],prize,tournamentTitle,link):this.props.gettext(_templateObject4,projectName,link,minDepo,refBonus);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,this.state.showPopup&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ReferralsPopup__["a" /* default */],{onClose:this.onHidePopup,onSubmit:this.onPopupSubmit,title:this.state.popupData.title,submitTitle:this.state.popupData.submitTitle,type:this.state.popupData.type,requestSuccess:this.state.popupSuccess,responseMessage:this.state.popupResponse,sending:this.state.popupData.type==="email"?this.state.sendingEmail:this.state.sendingText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReferralsLink__["a" /* default */],{id:"facebook",name:"Share",onClick:function onClick(){var u=encodeURIComponent(link);var quote=encodeURIComponent(shareText);if(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* isWebKitWebViewIOSApp */])()){var value=encodeURIComponent("https://www.facebook.com/sharer/sharer.php?u="+u+"&quote="+quote);window.location.href="ios://sharing?value="+value;}else{_this4.openWindow("https://www.facebook.com/sharer/sharer.php?u="+u+"&quote="+quote,"Facebook","width=626,height=436");}},desktop:desktop,isIndexPage:isIndexPage||isTournament,hideName:hideName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReferralsLink__["a" /* default */],{id:"twitter",name:"TWEET",onClick:function onClick(){var text=encodeURIComponent(shareText);if(Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* isWebKitWebViewIOSApp */])()){var value=encodeURIComponent("http://twitter.com/intent/tweet?text="+text);window.location.href="ios://sharing?value="+value;}else{_this4.openWindow("http://twitter.com/intent/tweet?text="+text,"Twitter","toolbar=0,status=0,width=626,height=436");}},desktop:desktop,isIndexPage:isIndexPage||isTournament,hideName:hideName}),!isTournament&&!hideEmail&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReferralsLink__["a" /* default */],{id:"email",name:"EMAIL",onClick:function onClick(){var title=encodeURIComponent(shareTitle);var text=encodeURIComponent(shareText);window.location.href="mailto:?subject="+title+"&body="+text;},desktop:desktop,isIndexPage:isIndexPage,hideName:hideName}));}}]);return ReferralsShareLinks;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["g" /* withGettext */])(ReferralsShareLinks));

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__UnitedHeader__ = __webpack_require__(219);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 97.5%;\n  left: 50%;\n  transform: translateY(-97.5%);\n  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);\n  z-index: 8;\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n\n  @media (min-width: 960px) {\n    margin-left: -480px;\n\n    :hover {\n      box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  ",";\n"],["\n  position: fixed;\n  top: 97.5%;\n  left: 50%;\n  transform: translateY(-97.5%);\n  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);\n  z-index: 8;\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n\n  @media (min-width: 960px) {\n    margin-left: -480px;\n\n    :hover {\n      box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      opacity: 0;\n      pointer-events: none;\n    "],["\n      opacity: 0;\n      pointer-events: none;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 97.5%;\n  left: 50%;\n  transform: translateY(-97.5%);\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 57px;\n  width: 57px;\n  height: 57px;\n  border: none;\n  border-radius: 50%;\n  background-color: ",";\n  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);\n  appearance: none;\n  cursor: pointer;\n  z-index: 8;\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n\n  @media (min-width: 960px) {\n    margin-left: 480px;\n\n    :hover {\n      background-color: #fd9600;\n      box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  @media (max-width: 959px) {\n    left: 100%;\n    transform: translate(-100%, -250%);\n    margin-left: -10px;\n  }\n\n  ",";\n"],["\n  position: fixed;\n  top: 97.5%;\n  left: 50%;\n  transform: translateY(-97.5%);\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 57px;\n  width: 57px;\n  height: 57px;\n  border: none;\n  border-radius: 50%;\n  background-color: ",";\n  box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.1);\n  appearance: none;\n  cursor: pointer;\n  z-index: 8;\n  opacity: 1;\n  transition: all 0.3s ease-in-out;\n\n  @media (min-width: 960px) {\n    margin-left: 480px;\n\n    :hover {\n      background-color: #fd9600;\n      box-shadow: 0px 15px 15px 0px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  @media (max-width: 959px) {\n    left: 100%;\n    transform: translate(-100%, -250%);\n    margin-left: -10px;\n  }\n\n  ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TradeButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__UnitedHeader__["a" /* TradeButton */])(_templateObject,function(props){return props.isHidden&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject3,function(props){return props.theme.accent;},function(props){return props.isHidden&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var ToTopButton=function(_React$Component){_inherits(ToTopButton,_React$Component);function ToTopButton(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ToTopButton);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ToTopButton.__proto__||Object.getPrototypeOf(ToTopButton)).call.apply(_ref,[this].concat(args))),_this),_this.state={isHidden:true},_this.handleTradeClick=function(){var topNode=document.querySelectorAll(".js-anchor")[0];if(topNode){_this.props.history.replace("#"+topNode.id);}window.scrollTo(0,0);},_this.handleScroll=function(){var isHidden=_this.state.isHidden;if(window.pageYOffset>73){if(isHidden===true){_this.setState({isHidden:false});return;}}else{if(isHidden===false){_this.setState({isHidden:true});}return;}},_this.throttleScroll=__WEBPACK_IMPORTED_MODULE_3_lodash_throttle___default()(function(){return _this.handleScroll();},150),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ToTopButton,[{key:"componentDidMount",value:function componentDidMount(){window.addEventListener("scroll",this.throttleScroll);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("scroll",this.throttleScroll);}},{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,!this.props.hideTrade&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TradeButton,{isHidden:_this2.state.isHidden,onClick:_this2.handleTradeClick,isFixedButton:true});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{isHidden:this.state.isHidden,onClick:this.props.onClick,isFixedButton:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"25px",height:"28px"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fillRule:"evenodd",fill:"rgb(255, 255, 255)",d:"M23.573,11.136 L13.515,1.078 C12.929,0.492 11.979,0.492 11.393,1.078 L1.335,11.136 C0.749,11.722 0.749,12.672 1.335,13.258 C1.921,13.844 2.871,13.844 3.457,13.258 L10.986,5.729 L10.986,25.819 C10.986,26.648 11.658,27.320 12.486,27.320 C13.315,27.320 13.987,26.648 13.987,25.819 L13.987,5.794 L21.451,13.258 C22.037,13.844 22.987,13.844 23.573,13.258 C24.159,12.672 24.159,11.722 23.573,11.136 Z"}))));}}]);return ToTopButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(ToTopButton));

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Footer__ = __webpack_require__(862);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Footer__["a" /* default */]);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return indicatorTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__ = __webpack_require__(166);
var ALGORITHMS=["SMA","EMA"];var initialState={period:13,algorithm:"SMA",color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][0],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Moving average");var Info=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToolsContent__["b" /* InfoBlock */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"The indicator shows an average price of an asset for the time period. ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Link__["a" /* Link */],{to:"/helpdesk/knowledge_base#kb_i"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Learn more about the indicator."))));var MovingAveragePopup=function MovingAveragePopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Period"),name:"period",value:props.indicator.period,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["d" /* Select */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Type"),name:"algorithm",value:props.indicator.algorithm,values:ALGORITHMS,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"color",value:props.indicator.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"strokeWidth",value:props.indicator.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}));};/* harmony default export */ __webpack_exports__["b"] = (MovingAveragePopup);

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(364),
    isFlattenable = __webpack_require__(1181);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__List__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icons_Bell__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ThemeProvider__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  margin-bottom: 3px;\n  @media (min-width: 960px) {\n    position: relative;\n  }\n"],["\n  margin-bottom: 3px;\n  @media (min-width: 960px) {\n    position: relative;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  color: ",";\n\n  transition: all 200ms ease-in-out;\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  color: ",";\n\n  transition: all 200ms ease-in-out;\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n          background-color: ",";\n        "],["\n          background-color: ",";\n        "]),_templateObject4=_taggedTemplateLiteral(["\n          background-color: transparent;\n        "],["\n          background-color: transparent;\n        "]),_templateObject5=_taggedTemplateLiteral(["\n  padding: 9px;\n  font-size: ",";\n  line-height: 19px;\n  color: ",";\n  text-decoration: none;\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n  ",";\n\n  :hover,\n  :focus {\n    color: ",";\n    text-decoration: none;\n    outline: none;\n  }\n"],["\n  padding: 9px;\n  font-size: ",";\n  line-height: 19px;\n  color: ",";\n  text-decoration: none;\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n  ",";\n\n  :hover,\n  :focus {\n    color: ",";\n    text-decoration: none;\n    outline: none;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n        padding-right: 14px;\n        padding-left: 11px;\n      "],["\n        padding-right: 14px;\n        padding-left: 11px;\n      "]),_templateObject7=_taggedTemplateLiteral(["\n      padding-left: 14px;\n      padding-right: 11px;\n    "],["\n      padding-left: 14px;\n      padding-right: 11px;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 19px;\n  height: 19px;\n  color: ",";\n  backface-visibility: hidden;\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 19px;\n  height: 19px;\n  color: ",";\n  backface-visibility: hidden;\n\n  ",";\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n        margin-left: 10px;\n      "],["\n        margin-left: 10px;\n      "]),_templateObject10=_taggedTemplateLiteral(["\n      margin-right: 10px;\n    "],["\n      margin-right: 10px;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  fill: currentColor;\n\n  @media (max-width: 959px) {\n    width: 20px;\n  }\n"],["\n  fill: currentColor;\n\n  @media (max-width: 959px) {\n    width: 20px;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  flex-grow: 1;\n"],["\n  flex-grow: 1;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  background-color: #0085eb;\n  min-width: 20px;\n  padding: 0 5px;\n  border-radius: 5px 5px 5px 0;\n  color: #fff;\n  text-align: center;\n  font-size: ",";\n  font-weight: 400;\n"],["\n  flex: 0 0 auto;\n  background-color: #0085eb;\n  min-width: 20px;\n  padding: 0 5px;\n  border-radius: 5px 5px 5px 0;\n  color: #fff;\n  text-align: center;\n  font-size: ",";\n  font-weight: 400;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 364px;\n  cursor: default;\n  z-index: 200;\n\n  ","\n"],["\n  display: flex;\n  flex-direction: column;\n  width: 364px;\n  cursor: default;\n  z-index: 200;\n\n  ","\n"]),_templateObject16=_taggedTemplateLiteral(["\n          position: absolute;\n          top: 100%;\n          left: 0;\n          max-height: ","px;\n          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.42);\n          border-radius: 2px 2px 0 0;\n\n          :after {\n            position: absolute;\n            top: 0;\n            left: 26px;\n            content: \" \";\n            height: 0;\n            width: 0;\n            margin-left: -8px;\n            margin-top: -18px;\n            pointer-events: none;\n            border: 9px solid transparent;\n            border-bottom-color: #fff;\n          }\n\n          @media (max-width: 959px) {\n            position: absolute;\n            top: 62px;\n            left: 50%;\n            transform: translate3d(-50%, 0, 0);\n            backface-visibility: hidden;\n            align-self: center;\n\n            :after {\n              left: 50%;\n              transform: translateX(-50%);\n              margin-left: 0;\n            }\n          }\n\n          @media (max-width: 375px) {\n            width: 100vw;\n            left: 0;\n            transform: none;\n\n            :after {\n            }\n          }\n        "],["\n          position: absolute;\n          top: 100%;\n          left: 0;\n          max-height: ","px;\n          box-shadow: 0 6px 10px rgba(0, 0, 0, 0.42);\n          border-radius: 2px 2px 0 0;\n\n          :after {\n            position: absolute;\n            top: 0;\n            left: 26px;\n            content: \" \";\n            height: 0;\n            width: 0;\n            margin-left: -8px;\n            margin-top: -18px;\n            pointer-events: none;\n            border: 9px solid transparent;\n            border-bottom-color: #fff;\n          }\n\n          @media (max-width: 959px) {\n            position: absolute;\n            top: 62px;\n            left: 50%;\n            transform: translate3d(-50%, 0, 0);\n            backface-visibility: hidden;\n            align-self: center;\n\n            :after {\n              left: 50%;\n              transform: translateX(-50%);\n              margin-left: 0;\n            }\n          }\n\n          @media (max-width: 375px) {\n            width: 100vw;\n            left: 0;\n            transform: none;\n\n            :after {\n            }\n          }\n        "]),_templateObject17=_taggedTemplateLiteral(["\n          position: fixed;\n          top: 0;\n          right: 276px;\n          bottom: 0;\n\n          :after {\n            position: absolute;\n            top: ",";\n            right: -26px;\n            content: \" \";\n            height: 0;\n            width: 0;\n            pointer-events: none;\n            border: 13px solid transparent;\n            border-left-color: #fff;\n          }\n\n          @media (max-width: 959px) {\n            top: 0;\n            left: 0;\n            backface-visibility: hidden;\n            align-self: center;\n            width: 100vw;\n            background-color: #f6f6f6;\n            :after {\n              display: none;\n            }\n          }\n\n          @media (max-width: 375px) {\n            width: 100vw;\n            left: 0;\n            transform: none;\n          }\n        "],["\n          position: fixed;\n          top: 0;\n          right: 276px;\n          bottom: 0;\n\n          :after {\n            position: absolute;\n            top: ",";\n            right: -26px;\n            content: \" \";\n            height: 0;\n            width: 0;\n            pointer-events: none;\n            border: 13px solid transparent;\n            border-left-color: #fff;\n          }\n\n          @media (max-width: 959px) {\n            top: 0;\n            left: 0;\n            backface-visibility: hidden;\n            align-self: center;\n            width: 100vw;\n            background-color: #f6f6f6;\n            :after {\n              display: none;\n            }\n          }\n\n          @media (max-width: 375px) {\n            width: 100vw;\n            left: 0;\n            transform: none;\n          }\n        "]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  color: #fff;\n  background-color: #fff;\n  overflow: hidden;\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n  @media (max-width: 365px) {\n    border-radius: 0;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  color: #fff;\n  background-color: #fff;\n  overflow: hidden;\n  max-width: 400px;\n  width: 100%;\n  margin: 0 auto;\n  @media (max-width: 365px) {\n    border-radius: 0;\n  }\n"]),_templateObject19=_taggedTemplateLiteral(["\n  flex: 1;\n  width: 6px;\n  margin: 2px;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0.5;\n  border-radius: 4px;\n"],["\n  flex: 1;\n  width: 6px;\n  margin: 2px;\n  background-color: rgba(0, 0, 0, 0.5);\n  opacity: 0.5;\n  border-radius: 4px;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  height: 40px;\n  padding: 10px 0;\n  position: relative;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    background-color: #f6f6f6;\n  }\n\n  button {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    background: transparent;\n    margin: 0;\n    padding: 0;\n    width: 20px;\n    height: 20px;\n    border: none;\n    cursor: pointer;\n    transition: 0.4s;\n    :before,\n    :after {\n      content: \"\";\n      position: absolute;\n      top: -1px;\n      left: 50%;\n      width: 0px;\n      height: 20px;\n      border-left: 2px solid #919191;\n    }\n\n    :before {\n      transform: translateX(-50%) rotate(45deg);\n      transform-origin: 100%;\n    }\n\n    :after {\n      transform: translateX(-50%) rotate(-45deg);\n      transform-origin: 0%;\n    }\n\n    :hover {\n      opacity: 0.7;\n    }\n  }\n"],["\n  height: 40px;\n  padding: 10px 0;\n  position: relative;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    background-color: #f6f6f6;\n  }\n\n  button {\n    position: absolute;\n    right: 10px;\n    top: 10px;\n    background: transparent;\n    margin: 0;\n    padding: 0;\n    width: 20px;\n    height: 20px;\n    border: none;\n    cursor: pointer;\n    transition: 0.4s;\n    :before,\n    :after {\n      content: \"\";\n      position: absolute;\n      top: -1px;\n      left: 50%;\n      width: 0px;\n      height: 20px;\n      border-left: 2px solid #919191;\n    }\n\n    :before {\n      transform: translateX(-50%) rotate(45deg);\n      transform-origin: 100%;\n    }\n\n    :after {\n      transform: translateX(-50%) rotate(-45deg);\n      transform-origin: 0%;\n    }\n\n    :hover {\n      opacity: 0.7;\n    }\n  }\n"]),_templateObject21=_taggedTemplateLiteral(["\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 19px;\n  color: #343434;\n  text-align: center;\n  font-weight: bold;\n"],["\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 19px;\n  color: #343434;\n  text-align: center;\n  font-weight: bold;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// TODO: refactor icons file in /components and get back to this import after
var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject);var Inner=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.navigationItemColor;},function(_ref2){var isIronHeader=_ref2.isIronHeader,active=_ref2.active,theme=_ref2.theme;return!isIronHeader&&active?Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject3,theme.navigationItemActiveBg):Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject4);});var BellWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref4){var theme=_ref4.theme;return theme.navigationItemColor;},function(_ref5){var theme=_ref5.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject6);}return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7);},function(props){return props.theme.accent;});var BellIconWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject8,function(_ref6){var theme=_ref6.theme;return theme.navigationItemIcon;},function(_ref7){var theme=_ref7.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject9);}return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject11,function(_ref8){var theme=_ref8.theme;return theme.navigationItemIconActive;});});var BellIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_16__Icons_Bell__["a" /* default */])(_templateObject12);var BellTitle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject13);var Count=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject14,Object(__WEBPACK_IMPORTED_MODULE_14__common_styled_mixins__["a" /* fontSize */])(12));var ListContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject15,function(_ref9){var isIronHeader=_ref9.isIronHeader;return isIronHeader?Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject16,function(_ref10){var maxHeight=_ref10.maxHeight;return maxHeight;}):Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject17,function(_ref11){var arrowTop=_ref11.arrowTop,trade=_ref11.trade;return arrowTop&&arrowTop-(trade?74:0)+6+"px";});});var ListWrapper=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject18);var Bar=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject19);var BellHead=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject20,function(_ref12){var theme=_ref12.theme;return theme.mode==="light"?"#fff":"#f6f6f6";});var BellH=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject21);var Announcements=function Announcements(_ref13){var style=_ref13.style,children=_ref13.children,close=_ref13.close,arrowTop=_ref13.arrowTop,isIronHeader=_ref13.isIronHeader,api=_ref13.api;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(304),_useState2=_slicedToArray(_useState,2),height=_useState2[0],setHeight=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(window.innerHeight),_useState4=_slicedToArray(_useState3,2),windowHeight=_useState4[0],setWindowHeight=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){return __WEBPACK_IMPORTED_MODULE_1_idx___default()(api.readEntity("/api/bell-tolls-items"),function(n){return n.value.payload;});}),_useState6=_slicedToArray(_useState5,2),announcements=_useState6[0],setAnnouncements=_useState6[1];var _useState7=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState8=_slicedToArray(_useState7,2),loading=_useState8[0],setLoading=_useState8[1];var ref=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"])(function(){if(ref.current!=null){var heightCalc=function heightCalc(){var listTop=ref.current.getBoundingClientRect().top+window.pageYOffset;return windowHeight-listTop-15;};setHeight(heightCalc());}},[windowHeight]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var windowHeightFunc=__WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function(){setWindowHeight(window.innerHeight);},150);window.addEventListener("resize",windowHeightFunc);return function(){return window.removeEventListener("resize",windowHeightFunc);};},[]);var updateDataFunc=function updateDataFunc(e){var el=e.target;var isBottomOfList=el.scrollHeight-el.scrollTop-el.clientHeight<10;var currPage=Number(announcements.currPage);var notLastPage=announcements.pages===1?false:currPage<announcements.pages;if(isBottomOfList&&!loading&&notLastPage){setLoading(true);Object(__WEBPACK_IMPORTED_MODULE_15__common_fetch__["d" /* get */])("/api/bell-tolls-items?page="+(currPage===0?currPage+2:currPage+1)+"&page_size=10").then(function(data){if(data.status==="OK"){setAnnouncements(function(prevState){data.payload.data=prevState.data.concat(data.payload.data);return data.payload;});}}).then(function(){return setLoading(false);});}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__ThemeProvider__["e" /* default */],{themeOverride:"default"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListContainer,{isIronHeader:isIronHeader,style:style,maxHeight:height,ref:ref,arrowTop:arrowTop,trade:window.location.pathname==="/trade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ListWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BellHead,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BellH,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Notifications")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){return close();}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Scrollable__["a" /* default */],{bar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bar,null),scrollFunc:updateDataFunc},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,children(announcements.data),loading&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:"center",marginBottom:7}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Spinners_SimpleSpinner__["c" /* default */],{accent:true})))))));};var StatefulBell=function(_React$Component){_inherits(StatefulBell,_React$Component);function StatefulBell(){var _ref14;var _temp,_this,_ret;_classCallCheck(this,StatefulBell);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref14=StatefulBell.__proto__||Object.getPrototypeOf(StatefulBell)).call.apply(_ref14,[this].concat(args))),_this),_this.state={active:false,arrowTop:255},_this.viewed=function(){_this.props.api.fetchEntity("/api/notifications/viewed");},_this.open=function(){_this.props.onBellClick&&_this.props.onBellClick(true);_this.setState({active:true});Object(__WEBPACK_IMPORTED_MODULE_17__GA__["a" /* gaReducer */])("BELL_OPEN");var bellNav=__WEBPACK_IMPORTED_MODULE_1_idx___default()(_this.bellRef,function(_){return _.current;});if(bellNav){_this.setState({arrowTop:bellNav.getBoundingClientRect().top});}},_this.close=function(){_this.props.onBellClick&&_this.props.onBellClick(false);_this.setState({active:false},_this.viewed);},_this.bellRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StatefulBell,[{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.state.active===true){this.viewed();}}},{key:"render",value:function render(){var _this2=this;if(window.location.pathname==="/password-update"){return null;}var api=this.props.api;var unitedNotifications=__WEBPACK_IMPORTED_MODULE_1_idx___default()(api.readEntity("/api/bell-tolls-items"),function(n){return n.value.payload;});if(unitedNotifications==null){return null;}var new_count=unitedNotifications.new_count;var active=this.state.active;var disable=!active||this.props.modalQueue.length>0;var announcementsView=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Animations__["a" /* Fade */],{"in":active},function(_ref15){var style=_ref15.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Announcements,{isIronHeader:_this2.props.isIronHeader,style:style,close:_this2.close,arrowTop:_this2.state.arrowTop,api:api},function(announcements){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__List__["a" /* default */],{announcements:announcements,api:api,close:_this2.close});});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ClickOutside__["a" /* default */],{onOutsideClick:this.close,disabled:disable},function(_ref16){var innerRef=_ref16.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{className:_this2.props.className,ref:innerRef,noMargin:_this2.props.noMargin},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Inner,{active:active,ref:_this2.bellRef,isIronHeader:_this2.props.isIronHeader},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BellWrapper,{onClick:active?_this2.close:_this2.open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BellIconWrapper,{active:active||_this2.props.isIronHeader&&unitedNotifications.data.length>0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BellIcon,null)),!_this2.props.isIronHeader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BellTitle,null,"Notifications"),new_count>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Count,null,new_count):null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return announcementsView;}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return announcementsView;}}));});}}]);return StatefulBell;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _Bell=function _Bell(props){var key=__WEBPACK_IMPORTED_MODULE_1_idx___default()(props,function(props){return props.profile.id;});if(key==null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref17){var queue=_ref17.queue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StatefulBell,Object.assign({key:key||"",api:api,modalQueue:queue},props));});});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__withData__["a" /* default */])({required:["serverData"],optional:["profile"],spinner:"none"})(_Bell));

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinners_SimpleSpinner__ = __webpack_require__(26);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 100%;\n  height: ",";\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 100%;\n  height: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.height?props.height:"100px";});function Spinner(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{height:props.height},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_SimpleSpinner__["c" /* default */],{accent:true}));}/* harmony default export */ __webpack_exports__["a"] = (Spinner);

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StyledDateIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n        margin-left: 12px;\n      "],["\n        margin-left: 12px;\n      "]),_templateObject3=_taggedTemplateLiteral(["\n      margin-right: 12px;\n    "],["\n      margin-right: 12px;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function DateIcon(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"18px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 17.828 15.2",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0,15.2V1.6H2.674V0H4.457V1.6H6.24V0H8.023V1.6H9.806V0h1.783V1.6h1.783V0h1.783V1.6h2.674V15.2Zm1.783-1.6H16.046V3.2h-.892V4H13.371V3.2H11.588V4H9.806V3.2H8.023V4H6.24V3.2H4.457V4H2.674V3.2H1.783Zm9.805-2.4V9.6h1.783v1.6Zm-3.566,0V9.6H9.806v1.6Zm-3.566,0V9.6H6.24v1.6ZM11.588,8V6.4h1.783V8ZM8.023,8V6.4H9.806V8ZM4.457,8V6.4H6.24V8Z"}));}var StyledDateIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(DateIcon)(_templateObject,function(_ref2){var theme=_ref2.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export List */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ItemPrizeFund; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ItemResult; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ItemCost; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ItemParticipants; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ItemRate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ItemBalance; });
/* unused harmony export Duration */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DurationTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups_styles__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tournaments_Timer__ = __webpack_require__(46);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  padding-top: 23px;\n  padding-bottom: 26px;\n  border-top: 1px solid #95989a;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"],["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n  padding-top: 23px;\n  padding-bottom: 26px;\n  border-top: 1px solid #95989a;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-right: ",";\n  margin-left: ",";\n  font-size: ",";\n  text-align: ",";\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n\n    :last-child {\n      margin-bottom: 0;\n    }\n\n    ",";\n  }\n"],["\n  direction: ",";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-right: ",";\n  margin-left: ",";\n  font-size: ",";\n  text-align: ",";\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n\n    :last-child {\n      margin-bottom: 0;\n    }\n\n    ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n          flex-direction: row;\n          align-items: center;\n          margin-bottom: 10px;\n        "],["\n          flex-direction: row;\n          align-items: center;\n          margin-bottom: 10px;\n        "]),_templateObject4=_taggedTemplateLiteral(["\n        margin-left: 10px;\n      "],["\n        margin-left: 10px;\n      "]),_templateObject5=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  color: #99959d;\n  text-transform: capitalize;\n\n  ",";\n"],["\n  direction: ",";\n  font-size: ",";\n  color: #99959d;\n  text-transform: capitalize;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n        min-width: 110px;\n        margin-right: 5px;\n      "],["\n        min-width: 110px;\n        margin-right: 5px;\n      "]),_templateObject7=_taggedTemplateLiteral(["\n      margin-bottom: 5px;\n    "],["\n      margin-bottom: 5px;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  font-size: ",";\n  color: #99959d;\n"],["\n  display: flex;\n  align-items: center;\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  font-weight: 700;\n"],["\n  font-weight: 700;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  margin-right: ",";\n  margin-left: ",";\n  color: ",";\n"],["\n  margin-right: ",";\n  margin-left: ",";\n  color: ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  color: #99959d;\n"],["\n  display: flex;\n  color: #99959d;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n"],["\n  font-size: ",";\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var ItemWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.direction;},function(_ref){var theme=_ref.theme;return theme.direction==="rtl"?"0":"10px";},function(_ref2){var theme=_ref2.theme;return theme.direction==="rtl"?"10px":"0";},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref4){var theme=_ref4.theme;return theme.direction==="rtl"?"right":"left";},function(props){if(props.horizontal){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h4(_templateObject5,function(props){return props.theme.direction;},function(_ref5){var theme=_ref5.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){if(props.horizontal){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);});var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Strong=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].strong(_templateObject9);var ExtraStrong=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Strong)(_templateObject10,function(_ref7){var theme=_ref7.theme;return theme.foreground;});var IconWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,function(_ref8){var theme=_ref8.theme;return theme.direction==="rtl"?0:"6px";},function(_ref9){var theme=_ref9.theme;return theme.direction==="rtl"?"6px":0;},function(_ref10){var theme=_ref10.theme;return theme.foreground;});var MoneyContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var Free=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13,function(_ref11){var theme=_ref11.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref12){var theme=_ref12.theme;return theme.foreground;});var ItemPrizeFund=function ItemPrizeFund(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},props.finished?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Your Winnings"),":"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Prize fund"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["e" /* Cup */],{width:"16px"})),props.finished?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:props.value,valueUSD:props.valueUSD,divider:"\xA0/\xA0"})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{currency:props.currency,value:props.value,valueUSD:props.valueUSD,valueStyle:__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups_styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups_styles__["c" /* Currency */],divider:"\xA0/\xA0"}))));};var ItemResult=function ItemResult(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Your results"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["e" /* Cup */],{width:"16px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Strong,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:props.value,valueUSD:props.valueUSD})))));};var ItemCost=function ItemCost(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Participation fee"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["b" /* Coins */],{width:"26px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,!props.is_limited&&props.type==="free"||props.is_limited&&props.invited?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Free,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Free")):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:props.participation_price,valueUSD:props.participation_price_usd,valueStyle:__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups_styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups_styles__["c" /* Currency */],divider:"\xA0/\xA0"}))));};var ItemParticipants=function ItemParticipants(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Participants"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["i" /* Person */],{width:"16px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["a" /* MoneyBlock */],{size:"14px"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* MoneyValue */],null,props.count||props.participant_count))));};var ItemRate=function ItemRate(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Your rating"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["k" /* Rating */],{width:"18px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,"# ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExtraStrong,null,props.current_place)," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"of")," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExtraStrong,null,props.participant_count))));};var ItemBalance=function ItemBalance(props){var isParticipate=props.participation_status===1&&props.account!=null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},isParticipate?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Tournament balance"),":"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Starting balance"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["m" /* Wallet */],{width:"18px"})),isParticipate?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Money__["b" /* default */],{currency:__WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__["b" /* tournamentCurrency */],Symbol:__WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__["a" /* default */]},props.account.balance):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Money__["b" /* default */],{currency:__WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__["b" /* tournamentCurrency */],Symbol:__WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__["a" /* default */]},props.account_money)));};var Duration=function Duration(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Duration"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["l" /* Timer */],{width:"16px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ExtraStrong,null,__WEBPACK_IMPORTED_MODULE_2_moment___default.a.duration(__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.finish_date*1000).diff(__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.start_date*1000))).humanize())));};var DurationTime=function DurationTime(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemWrapper,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{horizontal:props.horizontal},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Duration"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["l" /* Timer */],{width:"16px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Tournaments_Timer__["a" /* IncompletedTime */],Object.assign({},props,{days:Object(__WEBPACK_IMPORTED_MODULE_10__Tournaments_Timer__["f" /* getDuration */])(props,"days","toStart"),hours:Object(__WEBPACK_IMPORTED_MODULE_10__Tournaments_Timer__["f" /* getDuration */])(props,"hours","toStart"),minutes:Object(__WEBPACK_IMPORTED_MODULE_10__Tournaments_Timer__["f" /* getDuration */])(props,"minutes","toStart"),seconds:Object(__WEBPACK_IMPORTED_MODULE_10__Tournaments_Timer__["f" /* getDuration */])(props,"seconds","toStart"),active:false,isCompleted:false,labelOnTop:false}))));};

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input_datepicker_css__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Input_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Input_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ErrorText__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SettingsHeader__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PassportFile__ = __webpack_require__(1572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PassportScanInput__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StyledComponents__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OfflineConfirmed__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__OfflineFilePreview__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TimeSelector__ = __webpack_require__(1578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Select__ = __webpack_require__(1581);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["Invalid date"],["Invalid date"]),_templateObject2=_taggedTemplateLiteral(["Invalid time"],["Invalid time"]),_templateObject3=_taggedTemplateLiteral(["Please, grant access to Storage for the browser"],["Please, grant access to Storage for the browser"]),_templateObject4=_taggedTemplateLiteral(["Required field"],["Required field"]),_templateObject5=_taggedTemplateLiteral(["Your bonus"],["Your bonus"]),_templateObject6=_taggedTemplateLiteral(["Bank"],["Bank"]),_templateObject7=_taggedTemplateLiteral(["The bank name where you have transferred your money"],["The bank name where you have transferred your money"]),_templateObject8=_taggedTemplateLiteral(["ATM card number"],["ATM card number"]),_templateObject9=_taggedTemplateLiteral(["Account \u2116"],["Account \u2116"]),_templateObject10=_taggedTemplateLiteral(["Check the ATM card number. If it's not correct, choose another bank."],["Check the ATM card number. If it's not correct, choose another bank."]),_templateObject11=_taggedTemplateLiteral(["Check the bank account number. If it's not correct, choose another bank"],["Check the bank account number. If it's not correct, choose another bank"]),_templateObject12=_taggedTemplateLiteral(["Recipient name"],["Recipient name"]),_templateObject13=_taggedTemplateLiteral(["Amount"],["Amount"]),_templateObject14=_taggedTemplateLiteral(["Enter the amount you have transferred (excluding the commission)."],["Enter the amount you have transferred (excluding the commission)."]),_templateObject15=_taggedTemplateLiteral(["Will be credited"],["Will be credited"]),_templateObject16=_taggedTemplateLiteral(["Enter the amount you have transferred (excluding the commission)"],["Enter the amount you have transferred (excluding the commission)"]),_templateObject17=_taggedTemplateLiteral(["Date of payment"],["Date of payment"]),_templateObject18=_taggedTemplateLiteral(["Should be same as the date on your payslip"],["Should be same as the date on your payslip"]),_templateObject19=_taggedTemplateLiteral(["Time of payment"],["Time of payment"]),_templateObject20=_taggedTemplateLiteral(["Should be same as the time on your payslip"],["Should be same as the time on your payslip"]),_templateObject21=_taggedTemplateLiteral(["The photo of a payslip"],["The photo of a payslip"]),_templateObject22=_taggedTemplateLiteral(["Your payment request is successfully sent"],["Your payment request is successfully sent"]),_templateObject23=_taggedTemplateLiteral(["We wish you a successful trading!"],["We wish you a successful trading!"]),_templateObject24=_taggedTemplateLiteral(["Trading"],["Trading"]),_templateObject25=_taggedTemplateLiteral(["Cancel"],["Cancel"]),_templateObject26=_taggedTemplateLiteral(["Send"],["Send"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DONG="₫";var KDONG="k₫";var Row=function Row(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["t" /* RowContainerView */],{inlineRow:props.inlineRow,desktop:props.desktop},(props.desktop||props.showHeader)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SettingsHeader__["a" /* default */],{title:props.title,subtitle:props.subtitle,showColon:props.desktop,desktop:props.desktop}),props.nowrap?props.children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["o" /* MainView */],{desktop:props.desktop},props.children));};var HelpText=function HelpText(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["g" /* HelpTextView */],null,props.children);};var InputItem=function InputItem(_ref){var children=_ref.children,desktop=_ref.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["i" /* InputItemView */],{desktop:desktop},children);};var Section=function Section(_ref2){var children=_ref2.children,desktop=_ref2.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["w" /* SectionView */],{desktop:desktop},children);};var Main=function Main(_ref3){var children=_ref3.children,desktop=_ref3.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["o" /* MainView */],{desktop:desktop},children);};var RowContainer=function RowContainer(_ref4){var children=_ref4.children,noInputItem=_ref4.noInputItem,desktop=_ref4.desktop,title=_ref4.title,desc=_ref4.desc,nowrap=_ref4.nowrap,inlineRow=_ref4.inlineRow,showAlternateHelp=_ref4.showAlternateHelp,alternateHelp=_ref4.alternateHelp,error=_ref4.error,style=_ref4.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{title:title,desktop:desktop,nowrap:nowrap,inlineRow:inlineRow,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Main,{desktop:desktop},noInputItem?children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,children&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},children),!!error&&!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["h" /* InputItem1 */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorText__["a" /* default */],null,error)),!!(desc||showAlternateHelp&&alternateHelp)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},showAlternateHelp?alternateHelp:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpText,null,desc)))),!!error&&desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["h" /* InputItem1 */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorText__["a" /* default */],null,error)));};var OfflinePopup=function(_Component){_inherits(OfflinePopup,_Component);function OfflinePopup(props){_classCallCheck(this,OfflinePopup);var _this=_possibleConstructorReturn(this,(OfflinePopup.__proto__||Object.getPrototypeOf(OfflinePopup)).call(this,props));_this.onAmountChange=_this.onAmountChange.bind(_this);_this.onDateChange=_this.onDateChange.bind(_this);_this.onDateBlur=_this.onDateBlur.bind(_this);_this.onTimeChange=_this.onTimeChange.bind(_this);_this.onTimeBlur=_this.onTimeBlur.bind(_this);_this.focusBonus=_this.focusBonus.bind(_this);_this.defocusBonus=_this.defocusBonus.bind(_this);_this.toggleFile=_this.toggleFile.bind(_this);_this.sendInfo=_this.sendInfo.bind(_this);_this.onFileUpload=_this.onFileUpload.bind(_this);_this.onFileDelete=_this.onFileDelete.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);// Default locale for moment is EN so no need to set it again
if(props.lang&&props.lang!=="en"){__WEBPACK_IMPORTED_MODULE_2_moment___default.a.locale(props.lang);}var bank="";var amount="";if(props.offlinePayment){bank=props.offlinePayment.bank;if(props.currency==="VND"){amount=props.offlinePayment.amount*1000;// Make dongs out of kilodongs
}else{amount=props.offlinePayment.amount;}}_this.state={bank:bank,showBonus:false,showFilePreview:false,sentData:false,amount:amount,amountError:"",date:"",dateError:"",time:"",timeError:"",file:props.file,fileImg:null,fileError:"",done:false,sending:false,error:""};return _this;}_createClass(OfflinePopup,[{key:"componentDidMount",value:function componentDidMount(){document.body.style.setProperty("overflow","hidden","important");var _props=this.props,isiOSApp=_props.isiOSApp,appVersion=_props.appVersion;if(isiOSApp&&appVersion>=2000000){var el=__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);if(el){el.style.setProperty("top",0);}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){document.body.style.overflow="";}},{key:"onAmountChange",value:function onAmountChange(data){var value=parseInt(data||0,10);if(isNaN(value)){return false;}this.setState({amount:value,amountError:""});}},{key:"onDateChange",value:function onDateChange(data){var date=data;if(this.isDateFieldWorks()){// date = typeof data === "string" ? moment(data) : data;
}else{// If input[type=date] doesn't work properly then simply leave date
// as raw input value
}this.setState({date:date,dateError:""});}},{key:"onDateBlur",value:function onDateBlur(){var d=this.state.date;var date=d;var wrongInput=false;if(typeof d==="string"){var dateFormat=void 0;var split=void 0;if(d.indexOf(".")>0){dateFormat="DD.MM.YYYY";split=".";}else if(d.indexOf("-")>0){dateFormat="YYYY-MM-DD";split="-";}else{wrongInput=true;}if(!wrongInput){var _d$split=d.split(split),_d$split2=_slicedToArray(_d$split,3),_d=_d$split2[0],_m=_d$split2[1],_y=_d$split2[2];wrongInput=isNaN(+_d)||isNaN(+_m)||isNaN(+_y);date=__WEBPACK_IMPORTED_MODULE_2_moment___default()(d,dateFormat);}}var day=void 0;var month=void 0;var year=void 0;if((typeof date==="undefined"?"undefined":_typeof(date))==="object"){day=date.date();month=date.month();year=date.year();}var isValidDate=!wrongInput&&this.validateDate(date);var dateError="";if(wrongInput||!isValidDate||day>31||month>12||year>__WEBPACK_IMPORTED_MODULE_2_moment___default()().year()||year<__WEBPACK_IMPORTED_MODULE_2_moment___default()().year()-1){dateError=this.props.gettext(_templateObject);}this.setState({dateError:dateError});}},{key:"onTimeChange",value:function onTimeChange(data){this.setState({time:data,timeError:""});}},{key:"onTimeBlur",value:function onTimeBlur(){var _split=(this.state.time||":").split(":"),_split2=_slicedToArray(_split,2),hours=_split2[0],minutes=_split2[1];var timeError="";var h=+hours;var m=+minutes;if(hours===""||minutes===""||isNaN(h)||isNaN(m)||h<0||m<0||h>23||m>59){timeError=this.props.gettext(_templateObject2);}this.setState({timeError:timeError});}/**
   * Validate date.
   * @param  {Object} date Moment.js date object.
   * @return {Boolean}
   */},{key:"validateDate",value:function validateDate(date){// Within 3 days offline payment expires
// UPD. It's not true at all.
/*
    const dateValidForDays = 3;

    const dateAfter = moment().subtract(dateValidForDays, 'days');
    const dateBefore = moment();
    const isValidDate = date.isBetween(dateAfter, dateBefore);
    */var dateBefore=__WEBPACK_IMPORTED_MODULE_2_moment___default()();var isValidDate=date.isBefore(dateBefore);return isValidDate;}},{key:"isDateFieldWorks",value:function isDateFieldWorks(){return!!(this.dateInput&&this.dateInput.input&&this.dateInput.input.type==="date");}},{key:"onFileUpload",value:function onFileUpload(files){var _this2=this;var file=files&&files[0];if(file&&FileReader&&typeof FileReader==="function"){var reader=new FileReader();reader.addEventListener("load",function(event){_this2.setState({file:file,fileImg:reader.result,fileError:""});});reader.addEventListener("error",function(event){var fileError="";var err=reader.error.name;if(err==="SecurityError"){fileError=_this2.props.gettext(_templateObject3);_this2.setState({file:null,fileError:fileError});}else{_this2.setState({file:file,fileError:fileError});}});reader.readAsDataURL(file);}else{this.setState({file:file,fileError:""});}}},{key:"onFileDelete",value:function onFileDelete(){this.setState({file:null,error:"",showFilePreview:false});}/**
   * @deprecated
   */},{key:"onSubmit",value:function onSubmit(){var _this3=this;var formData=new FormData();formData.append("old_pid",this.props.paymentId);formData.append("wireless_scan",this.state.file);this.setState({sending:true,error:""});Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/upload-invoice",{mode:"cors",credentials:"include",method:"POST",body:formData}).catch(function(error){return error;}).then(function(data){_this3.setState({sending:false,done:data.status==="OK",error:data.status!=="OK"&&data.message});});}},{key:"focusBonus",value:function focusBonus(){this.setState({showBonus:true});}},{key:"defocusBonus",value:function defocusBonus(){this.setState({showBonus:false});}},{key:"shouldConvertDongToKdong",value:function shouldConvertDongToKdong(){return this.props.currency==="VND";}},{key:"toggleFile",value:function toggleFile(e){e&&e.preventDefault();this.setState({showFilePreview:!this.state.showFilePreview});}},{key:"getDateFormatted",value:function getDateFormatted(date){// If date is moment object, call it's format method
if(date&&typeof date.format==="function"){return date.locale("en").format("DD/MM/YYYY");}else if(typeof date.indexOf==="function"){return __WEBPACK_IMPORTED_MODULE_2_moment___default()(date).locale("en").format("DD/MM/YYYY");}else{var d=__WEBPACK_IMPORTED_MODULE_2_moment___default()(date);return d.locale("en").format("DD/MM/YYYY");}}},{key:"sendInfo",value:function sendInfo(e){var _this4=this;e&&e.preventDefault();var errors={};if(!this.state.amount){errors.amountError=this.props.gettext(_templateObject4);}if(!this.state.date){errors.dateError=this.props.gettext(_templateObject4);}if(this.state.dateError){errors.dateError=this.state.dateError;}if(!this.state.time){errors.timeError=this.props.gettext(_templateObject4);}if(this.state.timeError){errors.timeError=this.state.timeError;}if(!this.state.file){errors.fileError=this.props.gettext(_templateObject4);}if(Object.keys(errors).length){this.setState(Object.assign({},errors,{showFilePreview:false}));return false;}var date=this.getDateFormatted(this.state.date);var formData=new FormData();formData.append("orderId",this.props.paymentId);var bank=this.state.bank;var recipient=void 0;if(bank){var selectedBank=this.props.banks.find(function(bank){return bank["bank-code"]===_this4.state.bank;});if(selectedBank){recipient=selectedBank["bank-acc-name"];}}else{bank=this.props.banks[0]["bank-code"];recipient=this.props.banks[0]["bank-acc-name"];}formData.append("bankCode",bank);formData.append("recipientName",recipient);if(this.shouldConvertDongToKdong()){// Amount in dongs, should send kdongs
formData.append("amount",this.state.amount/1000);}else{formData.append("amount",this.state.amount);}formData.append("date",date);formData.append("time",this.state.time);formData.append("wireless_scan",this.state.file);this.setState({sending:true,error:""});Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/ajax/offline-payment-modal",{mode:"cors",credentials:"include",method:"POST",body:formData}).catch(function(error){return error;}).then(function(data){var OK=data.status==="OK";_this4.setState({sentData:OK,sending:false,done:OK,// Still need this?
error:!OK&&data.message});var clb=_this4.props.onConfirm;if(typeof clb==="function"&&OK){clb();}if(!OK&&typeof _this4.props.onFail==="function"){_this4.props.onFail();}});}},{key:"render",value:function render(){var _this5=this;var _props2=this.props,banks=_props2.banks,recipientProp=_props2.recipient,isATM=_props2.isATM,currencySymbol=_props2.currencySymbol,desktop=_props2.desktop,isiOSApp=_props2.isiOSApp,isAndroidApp=_props2.isAndroidApp,appVersion=_props2.appVersion;var isIOSApp=isiOSApp&&appVersion>=2000000;var file=this.state.file;var selectedBank=banks[0];if(this.state.bank){selectedBank=banks.find(function(bank){return bank["bank-code"]===_this5.state.bank;});}var account=void 0;var recipient=recipientProp;if(selectedBank){account=selectedBank["bank-acc-number"];recipient=selectedBank["bank-acc-name"];}var alternateAmountHelpBox=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["a" /* BonusHeader */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Your bonus")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["b" /* BonusSelect */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Select__["a" /* default */],{id:"bonus",value:"50% (12500 Baht)",label:this.props.gettext(_templateObject5),desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"1"},"50% (12500 Baht)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{value:"2"},"No bonus"))));var FormFields=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:this.props.gettext(_templateObject6),desc:this.props.gettext(_templateObject7),desktop:desktop,nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Select__["a" /* default */],{id:"banks",value:this.state.bank,label:this.props.gettext(_templateObject6),desktop:desktop,onChange:function onChange(data){return _this5.setState({bank:data});}},banks.map(function(bank,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("option",{key:index,value:bank["bank-code"]},bank["bank-name"]);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:isATM?this.props.gettext(_templateObject8):this.props.gettext(_templateObject9),desc:isATM?this.props.gettext(_templateObject10):this.props.gettext(_templateObject11),desktop:desktop,nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["b" /* default */],{type:"text",id:"bank-acc",value:account,label:isATM?this.props.gettext(_templateObject8):this.props.gettext(_templateObject9),desktop:desktop,invalid:false,disabled:true,offlinePopup:true})),recipient&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{noInputItem:true,title:this.props.gettext(_templateObject12),desktop:desktop,nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["b" /* default */],{type:"text",id:"bank-name",value:recipient// value={this.state.first_name}
// onChange={this.onValueChange('first_name')}
,label:this.props.gettext(_templateObject12),desktop:desktop// invalid={!!this.state.first_nameValueError}
,invalid:false,disabled:true,offlinePopup:true})),this.shouldConvertDongToKdong()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:this.props.gettext(_templateObject13),desc:this.props.gettext(_templateObject14),desktop:desktop,nowrap:true,showAlternateHelp:this.state.showBonus,alternateHelp:alternateAmountHelpBox,error:this.state.amountError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["b" /* default */],{type:"number",id:"sum-of-order",value:this.state.amount,label:this.props.gettext(_templateObject13),desktop:desktop,invalid:!!this.state.amountError,currency:DONG,onChange:this.onAmountChange,inputMode:"numeric",pattern:"[0-9]*",offlinePopup:true})),desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:this.props.gettext(_templateObject15),desc:"1000 "+DONG+" = 1 "+KDONG,desktop:desktop,nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["j" /* KdongAmount */],null,(this.state.amount||0)/1000)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["m" /* KdongKdong */],null,KDONG)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{title:this.props.gettext(_templateObject15),desktop:desktop,nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Main,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["n" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Will be credited"),":")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["k" /* KdongContainer */],{desktop:desktop,style:{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["j" /* KdongAmount */],{desktop:desktop,style:{fontSize:22}},(this.state.amount||0)/1000)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["m" /* KdongKdong */],{style:{fontSize:22}},KDONG)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["l" /* KdongInfo */],{desktop:desktop},"1000 "+DONG+" = 1 "+KDONG)))))))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:this.props.gettext(_templateObject13),desc:this.props.gettext(_templateObject16),desktop:desktop,nowrap:true,showAlternateHelp:this.state.showBonus,alternateHelp:alternateAmountHelpBox,error:this.state.amountError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["b" /* default */],{type:"number",id:"sum-of-order",value:this.state.amount,label:this.props.gettext(_templateObject13),desktop:desktop,invalid:!!this.state.amountError,currency:currencySymbol,onChange:this.onAmountChange,inputMode:"numeric",pattern:"[0-9]*",offlinePopup:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:this.props.gettext(_templateObject17),desc:desktop&&this.props.gettext(_templateObject18),desktop:desktop,nowrap:true,inlineRow:true,error:desktop&&this.state.dateError},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["b" /* default */],{type:"date",ref:function ref(input){return _this5.dateInput=input;},maxDate:__WEBPACK_IMPORTED_MODULE_2_moment___default()(),id:"date-of-order",placeholder:"31.12.2017",value:this.state.date,onChange:this.onDateChange,label:this.props.gettext(_templateObject17),desktop:desktop,invalid:!!this.state.dateError,Icon:__WEBPACK_IMPORTED_MODULE_12__Icons__["a" /* DateIcon */],offlinePopup:true,onBlur:this.onDateBlur,autoComplete:"off"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{title:this.props.gettext(_templateObject19),desc:desktop&&this.props.gettext(_templateObject20),desktop:desktop,nowrap:true,inlineRow:true,error:desktop&&this.state.timeError},desktop?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__TimeSelector__["a" /* default */],{value:this.state.time,onChange:this.onTimeChange,invalid:!!this.state.timeError,onBlur:this.onTimeBlur,autoComplete:"off"}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Input__["b" /* default */],{type:"time",id:"time-of-order",placeholder:"23:59",defaultValue:this.state.time,onChange:this.onTimeChange,label:this.props.gettext(_templateObject19),desktop:desktop,invalid:!!this.state.timeError,Icon:desktop?__WEBPACK_IMPORTED_MODULE_12__Icons__["f" /* TimeIcon */]:__WEBPACK_IMPORTED_MODULE_12__Icons__["i" /* TimefaceIcon */],offlinePopup:true,onBlur:this.onTimeBlur,autoComplete:"off"})),!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{desktop:false,nowrap:true,inlineRow:true,error:this.state.dateError,style:{verticalAlign:"top !important"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RowContainer,{desktop:false,nowrap:true,inlineRow:true,error:this.state.timeError,style:{verticalAlign:"top !important"}})),!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Main,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Date and time should match with the date and time on a receipt."))))));var FileFields=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{desktop:desktop,style:!file&&{marginBottom:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{title:this.props.gettext(_templateObject21),desktop:desktop,nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Main,{desktop:desktop},!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["n" /* Label */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"The photo of a payslip"),":")),!!file?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__PassportFile__["a" /* default */],{name:file.name,offpay:true,desktop:true,viewable:this.state.fileImg!==null,activeView:this.state.showFilePreview,onClick:this.toggleFile,onDelete:this.onFileDelete}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["u" /* ScanItemContainer */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PassportScanInput__["a" /* default */],{id:"trans-order-copy",desktop:true,offlinePopup:true,onChange:this.onFileUpload}))),!!this.state.fileError&&!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["h" /* InputItem1 */],{style:{textAlign:"center",width:"100%",marginBottom:14}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorText__["a" /* default */],null,this.state.fileError)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputItem,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["v" /* ScanItemInfo */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Attach the photo/scan of your payment slip")))))),!!this.state.fileError&&desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["h" /* InputItem1 */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorText__["a" /* default */],null,this.state.fileError))));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["p" /* Overlay */],{desktop:desktop,isIOSApp:isIOSApp,isAndroidApp:isAndroidApp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["q" /* Popup */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["s" /* PopupTableCell */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["r" /* PopupInner */],{desktop:desktop},desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["e" /* Close */],{onClick:this.props.onClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["f" /* Header */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Payment's details")),this.state.sentData?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__OfflineConfirmed__["a" /* default */],{isIOS2:isIOSApp,desktop:desktop,title:this.props.gettext(_templateObject22),message:this.props.gettext(_templateObject23),tradeTitle:this.props.gettext(_templateObject24)}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,!desktop||desktop&&!this.state.showFilePreview?FormFields:null,this.state.showFilePreview&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__OfflineFilePreview__["a" /* default */],{file:this.state.fileImg,Row:Row,desktop:desktop,onClose:this.toggleFile}),FileFields,this.state.error&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["h" /* InputItem1 */],{style:{marginBottom:20,width:"100%",textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ErrorText__["a" /* default */],null,this.state.error)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["d" /* ButtonWrapper */],{desktop:desktop},!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["c" /* ButtonContainer */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Button__["a" /* default */],{color:"violet",title:this.props.gettext(_templateObject25),onClick:this.props.onClose})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__StyledComponents__["c" /* ButtonContainer */],{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Button__["a" /* default */],{color:"green",title:this.props.gettext(_templateObject26),disabled:this.state.sending,big:desktop,wide:desktop,onClick:this.sendInfo,showSpinner:this.state.sending}))))))));}}]);return OfflinePopup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["g" /* withGettext */])(OfflinePopup));

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_inputmask_core__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_inputmask_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_inputmask_core__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var KEYCODE_Z = 90;
var KEYCODE_Y = 89;

function isUndo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
}

function isRedo(e) {
  return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
}

function getSelection(el) {
  var start = void 0,
      end = void 0;
  if (el.selectionStart !== undefined) {
    start = el.selectionStart;
    end = el.selectionEnd;
  } else {
    try {
      el.focus();
      var rangeEl = el.createTextRange();
      var clone = rangeEl.duplicate();

      rangeEl.moveToBookmark(document.selection.createRange().getBookmark());
      clone.setEndPoint('EndToStart', rangeEl);

      start = clone.text.length;
      end = start + rangeEl.text.length;
    } catch (e) {/* not focused or not visible */}
  }

  return { start: start, end: end };
}

function setSelection(el, selection) {
  try {
    if (el.selectionStart !== undefined) {
      el.focus();
      el.setSelectionRange(selection.start, selection.end);
    } else {
      el.focus();
      var rangeEl = el.createTextRange();
      rangeEl.collapse(true);
      rangeEl.moveStart('character', selection.start);
      rangeEl.moveEnd('character', selection.end - selection.start);
      rangeEl.select();
    }
  } catch (e) {/* not focused or not visible */}
}

var MaskedInput = (_temp2 = _class = function (_React$Component) {
  _inherits(MaskedInput, _React$Component);

  function MaskedInput() {
    var _temp, _this, _ret;

    _classCallCheck(this, MaskedInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._onChange = function (e) {
      // console.log('onChange', JSON.stringify(getSelection(this.input)), e.target.value)

      var maskValue = _this.mask.getValue();
      var incomingValue = e.target.value;
      if (incomingValue !== maskValue) {
        // only modify mask if form contents actually changed
        _this._updateMaskSelection();
        _this.mask.setValue(incomingValue); // write the whole updated value into the mask
        e.target.value = _this._getDisplayValue(); // update the form with pattern applied to the value
        _this._updateInputSelection();
      }

      if (_this.props.onChange) {
        _this.props.onChange(e);
      }
    }, _this._onKeyDown = function (e) {
      // console.log('onKeyDown', JSON.stringify(getSelection(this.input)), e.key, e.target.value)

      if (isUndo(e)) {
        e.preventDefault();
        if (_this.mask.undo()) {
          e.target.value = _this._getDisplayValue();
          _this._updateInputSelection();
          if (_this.props.onChange) {
            _this.props.onChange(e);
          }
        }
        return;
      } else if (isRedo(e)) {
        e.preventDefault();
        if (_this.mask.redo()) {
          e.target.value = _this._getDisplayValue();
          _this._updateInputSelection();
          if (_this.props.onChange) {
            _this.props.onChange(e);
          }
        }
        return;
      }

      if (e.key === 'Backspace') {
        e.preventDefault();
        _this._updateMaskSelection();
        if (_this.mask.backspace()) {
          var value = _this._getDisplayValue();
          e.target.value = value;
          if (value) {
            _this._updateInputSelection();
          }
          if (_this.props.onChange) {
            _this.props.onChange(e);
          }
        }
      }
    }, _this._onKeyPress = function (e) {
      // console.log('onKeyPress', JSON.stringify(getSelection(this.input)), e.key, e.target.value)

      // Ignore modified key presses
      // Ignore enter key to allow form submission
      if (e.metaKey || e.altKey || e.ctrlKey || e.key === 'Enter') {
        return;
      }

      e.preventDefault();
      _this._updateMaskSelection();
      if (_this.mask.input(e.key || e.data)) {
        e.target.value = _this.mask.getValue();
        _this._updateInputSelection();
        if (_this.props.onChange) {
          _this.props.onChange(e);
        }
      }
    }, _this._onPaste = function (e) {
      // console.log('onPaste', JSON.stringify(getSelection(this.input)), e.clipboardData.getData('Text'), e.target.value)

      e.preventDefault();
      _this._updateMaskSelection();
      // getData value needed for IE also works in FF & Chrome
      if (_this.mask.paste(e.clipboardData.getData('Text'))) {
        e.target.value = _this.mask.getValue();
        // Timeout needed for IE
        setTimeout(function () {
          return _this._updateInputSelection();
        }, 0);
        if (_this.props.onChange) {
          _this.props.onChange(e);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  MaskedInput.prototype.componentWillMount = function componentWillMount() {
    var options = {
      pattern: this.props.mask,
      value: this.props.value,
      formatCharacters: this.props.formatCharacters
    };
    if (this.props.placeholderChar) {
      options.placeholderChar = this.props.placeholderChar;
    }
    this.mask = new __WEBPACK_IMPORTED_MODULE_2_inputmask_core___default.a(options);
  };

  MaskedInput.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.mask !== nextProps.mask && this.props.value !== nextProps.mask) {
      // if we get a new value and a new mask at the same time
      // check if the mask.value is still the initial value
      // - if so use the nextProps value
      // - otherwise the `this.mask` has a value for us (most likely from paste action)
      if (this.mask.getValue() === this.mask.emptyValue) {
        this.mask.setPattern(nextProps.mask, { value: nextProps.value });
      } else {
        this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
      }
    } else if (this.props.mask !== nextProps.mask) {
      this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
    } else if (this.props.value !== nextProps.value) {
      this.mask.setValue(nextProps.value);
    }
  };

  MaskedInput.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    if (nextProps.mask !== this.props.mask) {
      this._updatePattern(nextProps);
    }
  };

  MaskedInput.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.mask !== this.props.mask && this.mask.selection.start) {
      this._updateInputSelection();
    }
  };

  MaskedInput.prototype._updatePattern = function _updatePattern(props) {
    this.mask.setPattern(props.mask, {
      value: this.mask.getRawValue(),
      selection: getSelection(this.input)
    });
  };

  MaskedInput.prototype._updateMaskSelection = function _updateMaskSelection() {
    this.mask.selection = getSelection(this.input);
  };

  MaskedInput.prototype._updateInputSelection = function _updateInputSelection() {
    setSelection(this.input, this.mask.selection);
  };

  MaskedInput.prototype._getDisplayValue = function _getDisplayValue() {
    var value = this.mask.getValue();
    return value === this.mask.emptyValue ? '' : value;
  };

  MaskedInput.prototype._keyPressPropName = function _keyPressPropName() {
    if (typeof navigator !== 'undefined') {
      return navigator.userAgent.match(/Android/i) ? 'onBeforeInput' : 'onKeyPress';
    }
    return 'onKeyPress';
  };

  MaskedInput.prototype._getEventHandlers = function _getEventHandlers() {
    var _ref;

    return _ref = {
      onChange: this._onChange,
      onKeyDown: this._onKeyDown,
      onPaste: this._onPaste
    }, _ref[this._keyPressPropName()] = this._onKeyPress, _ref;
  };

  MaskedInput.prototype.focus = function focus() {
    this.input.focus();
  };

  MaskedInput.prototype.blur = function blur() {
    this.input.blur();
  };

  MaskedInput.prototype.render = function render() {
    var _this2 = this;

    var ref = function ref(r) {
      _this2.input = r;
    };
    var maxLength = this.mask.pattern.length;
    var value = this._getDisplayValue();
    var eventHandlers = this._getEventHandlers();
    var _props = this.props,
        _props$size = _props.size,
        size = _props$size === undefined ? maxLength : _props$size,
        _props$placeholder = _props.placeholder,
        placeholder = _props$placeholder === undefined ? this.mask.emptyValue : _props$placeholder;

    var _props2 = this.props,
        placeholderChar = _props2.placeholderChar,
        formatCharacters = _props2.formatCharacters,
        cleanedProps = _objectWithoutProperties(_props2, ['placeholderChar', 'formatCharacters']); // eslint-disable-line no-unused-vars


    var inputProps = _extends({}, cleanedProps, eventHandlers, { ref: ref, maxLength: maxLength, value: value, size: size, placeholder: placeholder });
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', inputProps);
  };

  return MaskedInput;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component), _class.defaultProps = {
  value: ''
}, _temp2);
MaskedInput.propTypes =  false ? {
  mask: PropTypes.string.isRequired,

  formatCharacters: PropTypes.object,
  placeholderChar: PropTypes.string
} : {};


/* harmony default export */ __webpack_exports__["a"] = (MaskedInput);

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProjectTitle__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(81);
var _templateObject=_taggedTemplateLiteral(["\n  padding: 50px 0 20px 0;\n  color: #919191;\n  background-color: #f5f5f5;\n"],["\n  padding: 50px 0 20px 0;\n  color: #919191;\n  background-color: #f5f5f5;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 940px;\n  margin: 0 auto;\n  position: relative;\n\n  @media screen and (max-width: 960px) and (min-width: 800px) {\n    width: 780px;\n  }\n\n  @media screen and (max-width: 799px) {\n    width: 100%;\n  }\n"],["\n  width: 940px;\n  margin: 0 auto;\n  position: relative;\n\n  @media screen and (max-width: 960px) and (min-width: 800px) {\n    width: 780px;\n  }\n\n  @media screen and (max-width: 799px) {\n    width: 100%;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  font-weight: 400;\n  font-size: ",";\n  text-align: center;\n"],["\n  direction: ",";\n  font-weight: 400;\n  font-size: ",";\n  text-align: center;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FooterView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].footer(_templateObject);var CenterContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Copyright=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));function Footer(props){var className=props.className;var CurrentYear=function CurrentYear(){var date=new Date();return date.getFullYear();};try{if(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* isIronTerminal */])())return null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FooterView,{className:className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Copyright,null,"\xA9 ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentYear,null)," ", false?React.createElement(ProjectTitle,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Rosco Solutions LTD"),". ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"All rights reserved"),".")));}catch(err){return null;}}var mapStateToProps=function mapStateToProps(state){return{serverData:state.serverData,apiConfigs:state.apiConfigs,profile:state.profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_5__Money__["c" /* mapStateToCurrency */])(Object(__WEBPACK_IMPORTED_MODULE_6__common_withDeposit__["b" /* withDeposit */])(Footer))));

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayoutSwitcher__ = __webpack_require__(769);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__LayoutSwitcher__["a" /* default */],{mobile:null,desktop:children});});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_paginate__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SupportLink__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HistoryPages_Select__ = __webpack_require__(223);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (min-width: 960px) {\n    > div {\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-basis: 30%;\n    }\n  }\n\n  @media (max-width: 959px) {\n    justify-content: center;\n  }\n\n  @media (max-width: 425px) {\n    flex-wrap: wrap;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  @media (min-width: 960px) {\n    > div {\n      flex-grow: 0;\n      flex-shrink: 0;\n      flex-basis: 30%;\n    }\n  }\n\n  @media (max-width: 959px) {\n    justify-content: center;\n  }\n\n  @media (max-width: 425px) {\n    flex-wrap: wrap;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  color: #a7a7a7;\n  font-weight: 400;\n  cursor: default;\n"],["\n  color: #a7a7a7;\n  font-weight: 400;\n  cursor: default;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  ",";\n\n  @media (min-width: 960px) {\n    flex-basis: 40%;\n  }\n\n  @media (max-width: 425px) {\n    margin-left: 0;\n  }\n\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .break {\n    pointer-events: none;\n    user-select: none;\n    cursor: default !important;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n    color: #a7a7a7;\n    border: 3px solid transparent;\n    cursor: pointer;\n    user-select: none;\n  }\n\n  li:hover {\n    font-weight: 700;\n  color: ",";\n  }\n\n  li.active {\n    font-weight: 700;\n    color: #717171;\n    border-color: #efefef;\n    cursor: default;\n  }\n\n  li > a {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  li > a:focus {\n    outline: none;\n  }\n\n  li.previous,\n  li.next {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    color: #717171;\n    user-select: none;\n  }\n\n  li.previous:hover,\n  li.next:hover {\n    background-color: #efefef;\n  }\n\n  li.next {\n    transform: rotate(180deg);\n  }\n\n  li.previous.disabled,\n  li.next.disabled {\n    opacity: 0.5;\n    cursor: default !important;\n    color: #717171 !important;\n    background-color: transparent;\n  }\n"],["\n  ",";\n\n  @media (min-width: 960px) {\n    flex-basis: 40%;\n  }\n\n  @media (max-width: 425px) {\n    margin-left: 0;\n  }\n\n  ul {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .break {\n    pointer-events: none;\n    user-select: none;\n    cursor: default !important;\n  }\n\n  li {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    font-size: 14px;\n    color: #a7a7a7;\n    border: 3px solid transparent;\n    cursor: pointer;\n    user-select: none;\n  }\n\n  li:hover {\n    font-weight: 700;\n  color: ",";\n  }\n\n  li.active {\n    font-weight: 700;\n    color: #717171;\n    border-color: #efefef;\n    cursor: default;\n  }\n\n  li > a {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n  }\n\n  li > a:focus {\n    outline: none;\n  }\n\n  li.previous,\n  li.next {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n    color: #717171;\n    user-select: none;\n  }\n\n  li.previous:hover,\n  li.next:hover {\n    background-color: #efefef;\n  }\n\n  li.next {\n    transform: rotate(180deg);\n  }\n\n  li.previous.disabled,\n  li.next.disabled {\n    opacity: 0.5;\n    cursor: default !important;\n    color: #717171 !important;\n    background-color: transparent;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  ","\n  font-size: ",";\n  color: #717171;\n"],["\n  ","\n  font-size: ",";\n  color: #717171;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  > div:last-of-type {\n    min-width: 79px;\n  }\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n\n  > div:last-of-type {\n    min-width: 79px;\n  }\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;});var Break=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2);var PaginationContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-left","auto"),function(_ref2){var theme=_ref2.theme;return theme.tablePaginationHover||"#252525";});var SelectText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-right","25px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14));var SelectContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var PaginationArrow=function PaginationArrow(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 6.167 10",fill:"currentColor",width:"6.167",height:"10"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M87.767,180.867,86.6,179.7l-5,5,5,5,1.167-1.167L83.933,184.7Z",transform:"translate(-81.599 -179.7)"}));};function pageSizeOptionsReducer(options){return options.reduce(function(acc,option){acc.push({label:option,value:option});return acc;},[]);}var Pagination=function Pagination(_ref3){var _ref3$pageSizeOptions=_ref3.pageSizeOptions,pageSizeOptions=_ref3$pageSizeOptions===undefined?[5,10,15,30]:_ref3$pageSizeOptions,props=_objectWithoutProperties(_ref3,["pageSizeOptions"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Rows per page"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HistoryPages_Select__["a" /* default */],{name:"news-page-rows-select",options:pageSizeOptionsReducer(pageSizeOptions),value:{value:props.pageSize,label:props.pageSize},onChange:function onChange(e){return props.onPageSizeChange(Number(e.value));}})),props.pages!=null&&props.pages>1&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PaginationContainer,{style:__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* isAndroidCloaca */]?{marginLeft:"unset"}:null},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_paginate___default.a,Object.assign({initialPage:props.page,forcePage:props.page,previousLabel:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PaginationArrow,null),nextLabel:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PaginationArrow,null),breakLabel:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Break,null,"..."),breakClass:"break",pageCount:Number(props.pages),marginPagesDisplayed:1,pageRangeDisplayed:5,onPageChange:props.onPageChange,activeClassName:"active"},props.paginateProps))),!__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* isAndroidCloaca */]&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_SupportLink__["b" /* default */],{target:"_blank"})));};/* harmony default export */ __webpack_exports__["a"] = (Pagination);

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = CloseButton;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolsMenu__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ToolsActive__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToolWrapper__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AnimationWrapper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  max-height: 100%;\n  transform: translate3d(0, 0, 0);\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: ",";\n  z-index: 100000;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  max-height: 100%;\n  transform: translate3d(0, 0, 0);\n  overflow: auto;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: ",";\n  z-index: 100000;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  width: 510px;\n  min-height: 198px;\n  height: auto;\n  background-color: ",";\n"],["\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  width: 510px;\n  min-height: 198px;\n  height: auto;\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 45px;\n  padding: 0 15px;\n  background-color: ",";\n  border-bottom: 1px solid ",";\n"],["\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 45px;\n  padding: 0 15px;\n  background-color: ",";\n  border-bottom: 1px solid ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n"],["\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  color: ",";\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  color: ",";\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  flex-wrap: nowrap;\n  align-self: stretch;\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n  height: auto;\n"],["\n  justify-content: flex-start;\n  align-items: flex-start;\n  align-content: flex-start;\n  flex-wrap: nowrap;\n  align-self: stretch;\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n  height: auto;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import ClickOutside from "../common/ClickOutside";
var FlexRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(FlexRow)(_templateObject2,function(_ref){var theme=_ref.theme;return theme.foreground;});var Popup=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(FlexRow)(_templateObject3,function(props){return props.theme.popupBackground;});var Header=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(FlexRow)(_templateObject4,function(props){return props.theme.popupDarkBackground;},function(props){return props.theme.mainSeparator;});var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h2(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(16),function(_ref2){var theme=_ref2.theme;return theme.foreground;});var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject6,function(_ref3){var theme=_ref3.theme;return Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])(theme.foreground,0.5);},function(_ref4){var theme=_ref4.theme;return theme.foreground;});var Inner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(FlexRow)(_templateObject7);function CloseButton(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{xmlns:"http://www.w3.org/2000/svg",width:"21px",height:"22px",viewBox:"0 0 21 22",onClick:props.onClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fillRule:"evenodd",fill:"currentColor",d:"M20.086,2.293 L11.367,11.012 L20.071,19.716 L18.744,21.043 L10.040,12.339 L1.337,21.043 L0.010,19.716 L8.714,11.012 L-0.005,2.293 L1.321,0.967 L10.040,9.686 L18.760,0.967 L20.086,2.293 Z"}));}function ToolsPopup(props){var activeTool=void 0;var activeToolParams=void 0;if(props.instruments){var split=props.instruments.split("?");activeTool=split[0];activeToolParams=split.length>1&&split[1].split(":");}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,{onClick:props.close},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__AnimationWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,{onClick:function onClick(e){return e.stopPropagation();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Settings")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseButton,{onClick:props.onClick})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ToolWrapper__["a" /* default */],{activeToolInitial:activeTool,instrumentsInitial:activeToolParams&&activeToolParams[0],activeToolParams:activeToolParams,onCompletelyClose:props.onClick},function(tools){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Inner,null,tools.instruments==="settings"?[__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ToolsMenu__["a" /* default */],{key:1,tools:tools.TOOLS,activeTool:tools.activeTool,changeActiveTool:tools.changeActiveTool}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ToolsContent__["d" /* default */],{activeTool:tools.activeToolObj,key:2,dispatch:tools.dispatch,settings:tools.settings},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ToolsActive__["a" /* default */],{tools:tools.TOOLS,handlePopupOpen:tools.handlePopupOpen,activeTool:tools.activeTool,dispatch:tools.dispatch,settings:tools.settings}))]:tools.popup);}))));}/* harmony default export */ __webpack_exports__["b"] = (ToolsPopup);

/***/ }),
/* 837 */,
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = IronTradeFlat;
/* harmony export (immutable) */ __webpack_exports__["a"] = IronTradeFull;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function IronTradeFlat(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"35px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 34.921 25.661",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-0.066 0.097)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2829.238-804.746l-1.608-1.616,3.568-3.588-2.9-2.913,7.664-7.708,2.9,2.913,3.552-3.573,1.607,1.617-3.552,3.573,2.9,2.913-7.664,7.708-2.9-2.913-3.567,3.588Zm2.334-8.173,4.184,4.208,4.334-4.358-4.184-4.208Z",transform:"translate(-2809.036 830.31)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2456.1-980.107l3.572-3.593-2.9-2.917,16.889-16.986,2.9,2.917,3.439-3.459,1.611,1.62-3.439,3.459,2.888,2.907-16.889,16.986-2.888-2.907-3.572,3.592Z",transform:"translate(-2456.035 1004.048)"})));}function IronTradeFull(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?"153px":_ref2$width,_ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"currentColor":_ref2$fill,props=_objectWithoutProperties(_ref2,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 153.002 25.661",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-0.066 0.097)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2829.238-804.746l-1.608-1.616,3.568-3.588-2.9-2.913,7.664-7.708,2.9,2.913,3.552-3.573,1.607,1.617-3.552,3.573,2.9,2.913-7.664,7.708-2.9-2.913-3.567,3.588Zm2.334-8.173,4.184,4.208,4.334-4.358-4.184-4.208Z",transform:"translate(-2809.036 830.31)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2456.1-980.107l3.572-3.593-2.9-2.917,16.889-16.986,2.9,2.917,3.439-3.459,1.611,1.62-3.439,3.459,2.888,2.907-16.889,16.986-2.888-2.907-3.572,3.592Z",transform:"translate(-2456.035 1004.048)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-350.9-111.573h3.006v16.626H-350.9Zm13.93,6.693a9.163,9.163,0,0,0-.99-.252,7.24,7.24,0,0,0-1.467-.132,5.769,5.769,0,0,0-1.014.1,6.064,6.064,0,0,0-.751.168v10.052h-2.886v-11.947a15.8,15.8,0,0,1,2.087-.588,12.94,12.94,0,0,1,2.779-.276q.286,0,.668.036t.763.1q.382.06.74.144t.572.156Zm13.787,3.647a8.141,8.141,0,0,1-.429,2.711,6.008,6.008,0,0,1-1.216,2.087,5.47,5.47,0,0,1-1.9,1.343,6.093,6.093,0,0,1-2.445.48,6.009,6.009,0,0,1-2.433-.48,5.5,5.5,0,0,1-1.884-1.343,6.158,6.158,0,0,1-1.228-2.087,7.941,7.941,0,0,1-.441-2.711,7.839,7.839,0,0,1,.441-2.7,6.078,6.078,0,0,1,1.24-2.075,5.483,5.483,0,0,1,1.9-1.331,6.081,6.081,0,0,1,2.409-.468,6.167,6.167,0,0,1,2.421.468,5.336,5.336,0,0,1,1.9,1.331,6.177,6.177,0,0,1,1.228,2.075A7.839,7.839,0,0,1-323.182-101.233Zm-2.958,0a4.917,4.917,0,0,0-.8-2.963,2.607,2.607,0,0,0-2.23-1.092,2.607,2.607,0,0,0-2.23,1.092,4.917,4.917,0,0,0-.8,2.963,5.019,5.019,0,0,0,.8,3,2.6,2.6,0,0,0,2.23,1.1,2.6,2.6,0,0,0,2.23-1.1A5.019,5.019,0,0,0-326.14-101.233Zm5.939-5.854a19.242,19.242,0,0,1,2.171-.456,18.612,18.612,0,0,1,2.958-.216,6.767,6.767,0,0,1,2.552.42,3.983,3.983,0,0,1,1.634,1.176,4.5,4.5,0,0,1,.859,1.823,10.24,10.24,0,0,1,.251,2.339v7.053h-2.886v-6.6a9.581,9.581,0,0,0-.131-1.715,3.051,3.051,0,0,0-.429-1.152,1.716,1.716,0,0,0-.811-.648,3.4,3.4,0,0,0-1.252-.2,9.562,9.562,0,0,0-1.145.072q-.6.072-.883.12v10.124H-320.2Z",transform:"translate(399.227 116.704)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-46.621-122.945v2.615H-51.7v14.011h-3.029V-120.33h-5.081v-2.615Zm8.4,6.693a9.154,9.154,0,0,0-.99-.252,7.239,7.239,0,0,0-1.467-.132,5.77,5.77,0,0,0-1.014.1,6.067,6.067,0,0,0-.751.168v10.052h-2.886v-11.947a15.8,15.8,0,0,1,2.087-.588,12.939,12.939,0,0,1,2.779-.276q.286,0,.668.036t.763.1q.382.06.739.144t.572.156Zm6.894,7.893A10.68,10.68,0,0,0-29.3-108.5v-3.215a5.587,5.587,0,0,0-.692-.144,6.41,6.41,0,0,0-1-.072,6.625,6.625,0,0,0-.966.072,3,3,0,0,0-.883.264,1.6,1.6,0,0,0-.632.54,1.514,1.514,0,0,0-.239.876,1.539,1.539,0,0,0,.644,1.427A3.307,3.307,0,0,0-31.33-108.358Zm-.239-10.82a7.024,7.024,0,0,1,2.409.36,3.845,3.845,0,0,1,1.562,1.008,3.782,3.782,0,0,1,.835,1.571,7.732,7.732,0,0,1,.25,2.027v7.605q-.668.144-2.016.348a20.468,20.468,0,0,1-3.041.2,9.079,9.079,0,0,1-2.051-.216,4.3,4.3,0,0,1-1.586-.7,3.279,3.279,0,0,1-1.026-1.248,4.349,4.349,0,0,1-.37-1.9,3.677,3.677,0,0,1,.417-1.823,3.438,3.438,0,0,1,1.133-1.212,4.889,4.889,0,0,1,1.658-.672,9.279,9.279,0,0,1,1.968-.2,8.829,8.829,0,0,1,1,.06,9.289,9.289,0,0,1,1.121.2v-.48a3.777,3.777,0,0,0-.119-.96,1.993,1.993,0,0,0-.417-.8,1.953,1.953,0,0,0-.787-.54,3.389,3.389,0,0,0-1.228-.192,10.84,10.84,0,0,0-1.837.144,8.037,8.037,0,0,0-1.36.336l-.358-2.351a11.31,11.31,0,0,1,1.6-.384A12.462,12.462,0,0,1-31.569-119.178Zm10.853,6.549a4.576,4.576,0,0,0,.906,3.011,3.079,3.079,0,0,0,2.5,1.092,9.9,9.9,0,0,0,1.181-.06,7.92,7.92,0,0,0,.8-.132v-7.2a4.459,4.459,0,0,0-1.014-.492,3.943,3.943,0,0,0-1.348-.228,2.577,2.577,0,0,0-2.3,1.08A5.171,5.171,0,0,0-20.716-112.629Zm8.277,5.926a17.013,17.013,0,0,1-2.159.48,16.661,16.661,0,0,1-2.731.216,7.242,7.242,0,0,1-2.648-.456,5.515,5.515,0,0,1-1.992-1.307,5.764,5.764,0,0,1-1.264-2.063,7.915,7.915,0,0,1-.441-2.723,9.225,9.225,0,0,1,.37-2.7,5.916,5.916,0,0,1,1.085-2.075,4.841,4.841,0,0,1,1.741-1.331,5.636,5.636,0,0,1,2.361-.468,5.371,5.371,0,0,1,1.6.216,7.126,7.126,0,0,1,1.193.48v-6.022l2.886-.48Zm2.982-5.83a7.924,7.924,0,0,1,.489-2.9,6.1,6.1,0,0,1,1.3-2.075,5.379,5.379,0,0,1,1.861-1.248,5.732,5.732,0,0,1,2.147-.42,5.124,5.124,0,0,1,4.019,1.607,6.982,6.982,0,0,1,1.443,4.8q0,.24-.012.54t-.036.54H-6.475a3.317,3.317,0,0,0,1.061,2.339,4.017,4.017,0,0,0,2.731.828,8.931,8.931,0,0,0,1.92-.192,7.875,7.875,0,0,0,1.372-.408l.382,2.375a4.6,4.6,0,0,1-.656.252,9.223,9.223,0,0,1-.954.24q-.537.108-1.157.18a10.958,10.958,0,0,1-1.264.072A7.611,7.611,0,0,1-5.9-106.5a5.329,5.329,0,0,1-2-1.367,5.612,5.612,0,0,1-1.169-2.063A8.469,8.469,0,0,1-9.457-112.533Zm8.373-1.3a3.834,3.834,0,0,0-.167-1.14,2.754,2.754,0,0,0-.489-.936,2.315,2.315,0,0,0-.787-.624,2.5,2.5,0,0,0-1.109-.228,2.57,2.57,0,0,0-1.169.252,2.666,2.666,0,0,0-.847.66,3.02,3.02,0,0,0-.537.936,5.093,5.093,0,0,0-.262,1.08Z",transform:"translate(151.266 128.081)"})));}

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export richblue */
/* unused harmony export light */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return newIndex; });
/* unused harmony export thProjectTrade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logo__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_small_png__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logo_small_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__logo_small_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_bg_png__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__error_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_index_logo_text_svg__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__new_index_logo_text_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__new_index_logo_text_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_iron_jpg__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__header_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__header_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_png__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_text_png__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_text_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_text_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_howto_bg_iron_jpg__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_howto_bg_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_howto_bg_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_desktop_tour_bg_dark_jpg__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_desktop_tour_bg_dark_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_desktop_tour_bg_dark_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_light_jpg__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_light_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_light_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Icons_Index_index__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__siamoption_siamoption__ = __webpack_require__(374);
var basic={direction:"ltr",// основной шрифт
fontFamily:"Roboto, Arial, sans-serif",// логотип
logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* default */],null),logoImg:__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default.a,logoImgMobile:__WEBPACK_IMPORTED_MODULE_3__logo_small_png___default.a,errorBg:__WEBPACK_IMPORTED_MODULE_4__error_bg_png___default.a,// ЦВЕТА
// основной цвет
main:"#272B34",mainDark:"#1D2027",// шапка
mainLight:"#272B34",// сайдбар
mainHighlight:"#272B34",mainFontColor:"#38465d",mainSeparator:"#393939",newIndex:true,mode:"dark",foreground:"#ffffff",alternativeForeground:"#ffffff",lightWhiteForeground:"#ffffff",background:"#000",mainColorBackground:"#272B34",secondaryColorBackground:"#272B34",ticksFontColor:"#8d8d8d",ticksBorderColor:"#4e4e4e",borderMainColor:"#555555",accent:"#feac00",alternativeAccent:"#feac00",lightAccent:"#ffcc00",lightWhiteAccent:"#feac00",accentOpacity:"rgba(254, 172, 0, .5)",secondaryTextColor:"#99959d",upper:"#3B9478",// positive ставки
alternativeUpper:"#60a31c",upperAccent:"#48AE7E",upperBorder:"#2E735D",upperBoxShadow:"#48AE7E",lower:"#D05353",// negative ставки
lowerAccent:"#EE7F7F",lowerBorder:"#A34141",lowerBoxShadow:"#EE7F7F",// анимации для попапов
perspective:"1300px",showAnimation:".15s linear 1",// цвета для вёб морды
indexMajor:"#252525",indexMinor:"#363636",indexLogo:__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default.a,indexLogoText:__WEBPACK_IMPORTED_MODULE_5__new_index_logo_text_svg___default.a,headerLogoText:__WEBPACK_IMPORTED_MODULE_5__new_index_logo_text_svg___default.a,indexHeaderBackground:__WEBPACK_IMPORTED_MODULE_6__header_iron_jpg___default.a,howToBg:__WEBPACK_IMPORTED_MODULE_9__images_howto_bg_iron_jpg___default.a,// переменные хелпдеска
helpdeskSeparator:"#676767",helpdeskMobileMenuSeparator:"#555555",helpdeskNavlinks:"#a7a7a7",// переменные для страницы /regbonus
refHeader:"#252525",refLogo:__WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_png___default.a,refLogoText:__WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_text_png___default.a,refFooterBorder:"#363636",refFooterColor:"#fff",refConditionBg:"#363636",refInvestmentBg:"#252525",// переменные статичных страниц
staticHeaderLink:"#a7a7a7",toggleAccountLightBg:"#272B34",toggleAccountDarkBg:"#1D2027",popupBackground:"#1D2027",popupDarkBackground:"#272B34",desktopTourBg:__WEBPACK_IMPORTED_MODULE_10__images_desktop_tour_bg_dark_jpg___default.a,minFontSize:"18px",textMuted:"#99959d",mainLink:"#0085eb",tradeHeaderAccent:"#feac00",dealsBackground:"#1D2027",dealIconColor:"#3B9478",barCaption:"#5D6067",cursorBarCaption:"#272B34",stockInfoBg:"#3D4149",tournamentPopupBgLight:"#272B34",tournamentPopupBgDark:"#1D2027",tournamentCardBg:"#1B546A",tournamentCardMainColor:"#ffffff",tournamentCardSecondaryColor:"#ffffff",tournamentCardPlaceholder:"#ffffff",scrollColor:"rgba(255, 255, 255, 0.5)",currencyColor:"#feac00",themeToggleActive:"#ffffff",bottomNavigationBg:"#3B9478",chartTimeOtcColor:"#1B546A",navigationBg:"#1D2027",navigationItemColor:"#919191",navigationItemIcon:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#919191",0.59),navigationItemActiveBg:"#272B34",navigationItemIconActive:"#cccccc",operationChequeqColor:"#99959d",operationChequeColor:"#d2d2d2",bellNewsLinkColor:"#0085eb",oneSignalHeaderBg:"#399177",languageBackground:"rgba(19, 56, 64, 0.9)",languageColor:"#ffffff",stockCloseTimeColor:"#feac00",languageArrowColor:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#fff",0.7),sightseeingBg:"linear-gradient(to bottom, #282c33 0%, #3d3f42 100%)",sightseeingTitle:"#fff",sightseeingIron:"#feac00",sightseeingLater:"rgba(255, 255, 255, 0.5)",sightSeeingImageShadow:"rgba(255, 255, 255, 0.2)",sightSeeingBgShadow:"transparent",sightseeingBigBg:"rgba(255, 255, 255, 0.1)",sightseeingSmallBg:"rgba(255, 255, 255, 0.05)",sightSeeingStartButtonBg:"#feac00",sightSeeingStartButtonColor:"#000",sightSeeingBorder:"#9b9b9b",dotColor:"rgba(255, 255, 255, 0.5)",dotActiveColor:"#fff",suggestingInputBg:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#ffffff",0.1),suggestingInputBgDisabled:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#ffffff",0.25),suggestingInputButtonSymbol:"#ffffff",suggestingInputButtonSymbolDisabled:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#919191",0.59),mobileSwitchStockBackground:"#3D4149",mobileSwitchStockArrow:"#ffffff",socialTradingButtonBg:"#5E5968",socialTradingButtonBgHover:"rgba(255, 255, 255, 0.1)",socialTradingButtonBgActive:"#3B9478",socialTradingHiddenLink:"#1592E6",socialTradingHiddenLinkHover:"#1592E6",socialTradingBg:"#272B34",socialTradingTableHeaderBg:"#1D2027",socialTradingSubtitleColor:"#919191",sellDealBg:"#3D4149",sellDealBorder:"#797979",sellDealProfitColor:"#ffffff",sellDealButtonColor:"#ffcc00",sellDealHistoryBg:"#3d4149",sellDealHistoryColor:"#ffcc00",sellDealHistoryProgress:"#5d6067",//compensations
compensationInfoIcon:"#919191",compensationSuccessTitle:"#FFCC00",compensationRefillTitle:"#ffffff",compensationSubtitle:"#ffffff",compensationAmountOfDeals:"#ffcc00",compensationActionButton:"#feac00",freeBonusPopupFontColor:"#ffffff",freeBonusPopupHintColor:"#cccccc",freeBonusPopupArrowColor:"#ffcc00",freeBonusPopupPercentColor:"#ffcc00",navigationUserName:"#ffffff",navigationMoney:"#ffffff",navigationId:"#FFCC00",navigationCall:"#FFCC00",navigationBorder:"#4B4F57",tabsTournamentsCategoryTitle:"#ffffff",sightSeeingWithdrawTitle:"#FFCC00",tourWitdrawMethodHover:"#3b9478",suspiciousActivityPopupBg:"#272B34",suspiciousActivityPopupText:"#FFFFFF",suspiciousActivityPopupButton:"#FFFFFF",suspiciousActivityPopupButtonHoverColor:"#0085EB",suspiciousActivityPopupLink:"#FFCC00",authCurrencyCodeColor:"#FFCC00"};/* harmony default export */ __webpack_exports__["a"] = (basic);// дополнительные темы забирают
// недостающие настройки и цвета
// из базовых
var richblue=Object.assign({},basic,{// основной цвет
main:"#061424",mainDark:"#0A131E",// шапка
mainLight:"#121B27",// сайдбар
mainHighlight:"#162130",mainFontColor:"#38465d",mainSeparator:"#2D3244",secondaryTextColor:"#99959d",borderMainColor:"#2D3244",ticksBorderColor:"#2D3244",popupBackground:"#0A131E",popupDarkBackground:"#162130",tradeHeaderAccent:"#feac00"});var light=Object.assign({},basic,{compensationInfoIcon:"#BABABA",compensationSuccess:"#3B9478",compensationActionButton:"#0085eb",compensationSubtitle:"#1B546A",// основной цвет
isIntlProjectLight:true,main:"#f9f9f9",mainDark:"#D4D4D4",// шапка
mainLight:"#f5f5f5",// сайдбар
mainHighlight:"#fff",mainFontColor:"#38465d",mainSeparator:"#D4D4D4",indexMajor:"#ffffff",mode:"light",foreground:"#1B546A",alternativeForeground:"#feac00",lightWhiteForeground:"#ffffff",background:"#ffffff",mainColorBackground:"#1B546A",secondaryColorBackground:"#399177",textMuted:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#fff",0.5),tradeHeaderGradientTop:"#1B546A",tradeHeaderGradientBottom:"#399177",ticksFontColor:"#484848",borderMainColor:"#D4D4D4",ticksBorderColor:"#D4D4D4",alternativeUpper:"#27c191",accent:"#1B546A",alternativeAccent:"#feac00",lightAccent:"#0085eb",lightWhiteAccent:"#ffffff",secondaryTextColor:"#ffffff",staticHeaderLink:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#000",0.5),popupBackground:"#ffffff",popupDarkBackground:"#f5f5f5",desktopTourBg:__WEBPACK_IMPORTED_MODULE_11__images_desktop_tour_bg_light_jpg___default.a,tradeHeaderAccent:"#feac00",dealsBackground:"#ffffff",dealIconColor:"#3B9478",scrollColor:"#3B9478",barCaption:"#d4d4d4",cursorBarCaption:"#ffffff",stockInfoBg:"#e4e4e4",toggleAccountLightBg:"#F5F5F5",toggleAccountDarkBg:"#ffffff",chartTimeOtcColor:"#ffffff",tournamentPopupBgLight:"#3B9478",tournamentPopupBgDark:"#1B546A",currencyColor:"#3B9478",themeToggleActive:"#3B9478",navigationBg:"#e4e4e4",navigationItemColor:"#417581",navigationItemIcon:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#919191",0.59),navigationItemActiveBg:"#ffffff",navigationItemIconActive:"#3B9478",operationChequeColor:"#484848",bellNewsLinkColor:"#0085eb",oneSignalHeaderBg:"#1b546a",languageBackground:"rgba(19, 56, 64, 0.9)",stockCloseTimeColor:"#3B9478",sightseeingBg:"#F6F6F6",sightseeingTitle:"#000",sightseeingIron:"#000",sightseeingLater:"#3B9478",sightSeeingImageShadow:"rgba(0, 0, 0, 0.2)",sightSeeingBgShadow:"rgba(0, 0, 0, 0.2)",sightseeingBigBg:"#fff",sightseeingSmallBg:"#fff",sightSeeingStartButtonBg:"linear-gradient(to left, #47c0c8 0%, #5D67C0 100%)",sightSeeingStartButtonColor:"#fff",sightSeeingBorder:"#c7d9d8",dotColor:"rgba(24, 20, 28, 0.5)",dotActiveColor:"#2c7671",suggestingInputBg:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#000000",0.15),suggestingInputBgDisabled:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#000000",0.3),suggestingInputButtonSymbol:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#919191",0.8),suggestingInputButtonSymbolDisabled:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#919191",0.2),mobileSwitchStockBackground:"#ffffff",mobileSwitchStockArrow:"#1B546A",sellDealBg:"#ffffff",sellDealBorder:"#d2d2d2",sellDealProfitColor:"#1B546A",sellDealButtonColor:"#0085EB",sellDealHistoryBg:"#E5E5E5",sellDealHistoryColor:"#0085EB",sellDealHistoryProgress:"#D4D4D4",compensationSuccessTitle:"#3B9478",compensationRefillTitle:"#3B9478",compensationAmountOfDeals:"#3B9478",freeBonusPopupFontColor:"#343434",freeBonusPopupHintColor:"#919191",freeBonusPopupArrowColor:"#0085EB",freeBonusPopupPercentColor:"#3B9478",navigationUserName:"#1B546A",navigationMoney:"#1B546A",navigationId:"#0085EB",navigationCall:"#0085EB",navigationBorder:"#D4D4D4",tabsTournamentsCategoryTitle:"#343434",sightSeeingWithdrawTitle:"#1B546A",suspiciousActivityPopupBg:"#ffffff",suspiciousActivityPopupText:"#272B34",suspiciousActivityPopupButton:"#0085EB",suspiciousActivityPopupLink:"#0085EB"});var newIndex={newIndex:true,// ...dark,
mode:"light",logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Icons_Index_index__["f" /* IronTradeFlat */],null),main:"#3B9478",mainHighlight:"#133840",mainDark:"#0F2E31",upper:"#3B9478",alternativeUpper:"#27c191",lower:"#D05353",accent:"#FFCC00",lightWhiteForeground:"#ffffff",indexMajor:"#1b546a",indexMinor:"#133840",staticHeaderLink:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#fff",0.7),inputColor:"#ffffff",mainGradientDark:"#ffd503",mainGradientLight:"#232227",gradientLight:"#399177",mainText:"#fff",mainLink:"#0085eb",mainDarkText:"#222222",tradeHeaderAccent:"#feac00",scrollColor:"rgba(255, 255, 255, 0.5)",bellNewsLinkColor:"#0085eb",oneSignalHeaderBg:"#399177",languageBackground:"rgba(19, 56, 64, 0.9)",refFooterBorder:"#919191",refFooterColor:"#919191",refConditionBg:"#1b546a",navigationBg:"#1D2027",navigationItemColor:"#919191",navigationItemIcon:Object(__WEBPACK_IMPORTED_MODULE_13_polished__["a" /* rgba */])("#919191",0.59),navigationItemActiveBg:"#272B34",navigationItemIconActive:"#cccccc",navigationUserName:"#ffffff",navigationMoney:"#3B9478",navigationId:"#FFCC00",navigationCall:"#FFCC00",navigationBorder:"#4B4F57"};var thProjectTrade=Object.assign({},basic,__WEBPACK_IMPORTED_MODULE_14__siamoption_siamoption__["a" /* default */],{logo:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Logo__["a" /* default */],null),logoImg:__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default.a,logoImgMobile:__WEBPACK_IMPORTED_MODULE_3__logo_small_png___default.a,indexLogo:__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default.a,indexLogoText:__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default.a,// todo indexLogoText
headerLogoText:__WEBPACK_IMPORTED_MODULE_2__new_index_logo_svg___default.a,// todo indexLogoText
refLogo:__WEBPACK_IMPORTED_MODULE_7__components_Regbonus_images_ref_img_logo_png___default.a,refLogoText:__WEBPACK_IMPORTED_MODULE_8__components_Regbonus_images_ref_img_logo_text_png___default.a,indexHeaderBackground:__WEBPACK_IMPORTED_MODULE_6__header_iron_jpg___default.a,howToBg:__WEBPACK_IMPORTED_MODULE_9__images_howto_bg_iron_jpg___default.a,errorBg:__WEBPACK_IMPORTED_MODULE_4__error_bg_png___default.a,desktopTourBg:__WEBPACK_IMPORTED_MODULE_10__images_desktop_tour_bg_dark_jpg___default.a});

/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(584)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sizerStyle = {
	position: 'absolute',
	top: 0,
	left: 0,
	visibility: 'hidden',
	height: 0,
	overflow: 'scroll',
	whiteSpace: 'pre'
};

var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

var cleanInputProps = function cleanInputProps(inputProps) {
	INPUT_PROPS_BLACKLIST.forEach(function (field) {
		return delete inputProps[field];
	});
	return inputProps;
};

var copyStyles = function copyStyles(styles, node) {
	node.style.fontSize = styles.fontSize;
	node.style.fontFamily = styles.fontFamily;
	node.style.fontWeight = styles.fontWeight;
	node.style.fontStyle = styles.fontStyle;
	node.style.letterSpacing = styles.letterSpacing;
	node.style.textTransform = styles.textTransform;
};

var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

var generateId = function generateId() {
	// we only need an auto-generated ID for stylesheet injection, which is only
	// used for IE. so if the browser is not IE, this should return undefined.
	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
};

var AutosizeInput = function (_Component) {
	_inherits(AutosizeInput, _Component);

	function AutosizeInput(props) {
		_classCallCheck(this, AutosizeInput);

		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

		_this.inputRef = function (el) {
			_this.input = el;
			if (typeof _this.props.inputRef === 'function') {
				_this.props.inputRef(el);
			}
		};

		_this.placeHolderSizerRef = function (el) {
			_this.placeHolderSizer = el;
		};

		_this.sizerRef = function (el) {
			_this.sizer = el;
		};

		_this.state = {
			inputWidth: props.minWidth,
			inputId: props.id || generateId()
		};
		return _this;
	}

	_createClass(AutosizeInput, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.mounted = true;
			this.copyInputStyles();
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			var id = nextProps.id;

			if (id !== this.props.id) {
				this.setState({ inputId: id || generateId() });
			}
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			if (prevState.inputWidth !== this.state.inputWidth) {
				if (typeof this.props.onAutosize === 'function') {
					this.props.onAutosize(this.state.inputWidth);
				}
			}
			this.updateInputWidth();
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			this.mounted = false;
		}
	}, {
		key: 'copyInputStyles',
		value: function copyInputStyles() {
			if (!this.mounted || !window.getComputedStyle) {
				return;
			}
			var inputStyles = this.input && window.getComputedStyle(this.input);
			if (!inputStyles) {
				return;
			}
			copyStyles(inputStyles, this.sizer);
			if (this.placeHolderSizer) {
				copyStyles(inputStyles, this.placeHolderSizer);
			}
		}
	}, {
		key: 'updateInputWidth',
		value: function updateInputWidth() {
			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
				return;
			}
			var newInputWidth = void 0;
			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
			} else {
				newInputWidth = this.sizer.scrollWidth + 2;
			}
			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
			newInputWidth += extraWidth;
			if (newInputWidth < this.props.minWidth) {
				newInputWidth = this.props.minWidth;
			}
			if (newInputWidth !== this.state.inputWidth) {
				this.setState({
					inputWidth: newInputWidth
				});
			}
		}
	}, {
		key: 'getInput',
		value: function getInput() {
			return this.input;
		}
	}, {
		key: 'focus',
		value: function focus() {
			this.input.focus();
		}
	}, {
		key: 'blur',
		value: function blur() {
			this.input.blur();
		}
	}, {
		key: 'select',
		value: function select() {
			this.input.select();
		}
	}, {
		key: 'renderStyles',
		value: function renderStyles() {
			// this method injects styles to hide IE's clear indicator, which messes
			// with input size detection. the stylesheet is only injected when the
			// browser is IE, and can also be disabled by the `injectStyles` prop.
			var injectStyles = this.props.injectStyles;

			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
				} }) : null;
		}
	}, {
		key: 'render',
		value: function render() {
			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
				if (previousValue !== null && previousValue !== undefined) {
					return previousValue;
				}
				return currentValue;
			});

			var wrapperStyle = _extends({}, this.props.style);
			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

			var inputStyle = _extends({
				boxSizing: 'content-box',
				width: this.state.inputWidth + 'px'
			}, this.props.inputStyle);

			var inputProps = _objectWithoutProperties(this.props, []);

			cleanInputProps(inputProps);
			inputProps.className = this.props.inputClassName;
			inputProps.id = this.state.inputId;
			inputProps.style = inputStyle;

			return _react2.default.createElement(
				'div',
				{ className: this.props.className, style: wrapperStyle },
				this.renderStyles(),
				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
				_react2.default.createElement(
					'div',
					{ ref: this.sizerRef, style: sizerStyle },
					sizerValue
				),
				this.props.placeholder ? _react2.default.createElement(
					'div',
					{ ref: this.placeHolderSizerRef, style: sizerStyle },
					this.props.placeholder
				) : null
			);
		}
	}]);

	return AutosizeInput;
}(_react.Component);

AutosizeInput.propTypes = {
	className: _propTypes2.default.string, // className for the outer element
	defaultValue: _propTypes2.default.any, // default field value
	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
	inputClassName: _propTypes2.default.string, // className for the input element
	inputRef: _propTypes2.default.func, // ref callback for the input element
	inputStyle: _propTypes2.default.object, // css styles for the input element
	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
	_propTypes2.default.number, _propTypes2.default.string]),
	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
	placeholder: _propTypes2.default.string, // placeholder text
	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
	style: _propTypes2.default.object, // css styles for the outer element
	value: _propTypes2.default.any // field value
};
AutosizeInput.defaultProps = {
	minWidth: 1,
	injectStyles: true
};

exports.default = AutosizeInput;

/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(1292);
/* unused harmony reexport ArrowKeyStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(1350);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(625);
/* unused harmony reexport CellMeasurer */
/* unused harmony reexport CellMeasurerCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(1353);
/* unused harmony reexport Collection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(1360);
/* unused harmony reexport ColumnSizer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Grid__ = __webpack_require__(57);
/* unused harmony reexport accessibilityOverscanIndicesGetter */
/* unused harmony reexport defaultCellRangeRenderer */
/* unused harmony reexport defaultOverscanIndicesGetter */
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__ = __webpack_require__(1362);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__InfiniteLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List__ = __webpack_require__(1364);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Masonry__ = __webpack_require__(1368);
/* unused harmony reexport createMasonryCellPositioner */
/* unused harmony reexport Masonry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(1381);
/* unused harmony reexport MultiGrid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(1384);
/* unused harmony reexport ScrollSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table__ = __webpack_require__(1386);
/* unused harmony reexport createTableMultiSort */
/* unused harmony reexport defaultTableCellDataGetter */
/* unused harmony reexport defaultTableCellRenderer */
/* unused harmony reexport defaultTableHeaderRenderer */
/* unused harmony reexport defaultTableHeaderRowRenderer */
/* unused harmony reexport defaultTableRowRenderer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_11__Table__["a"]; });
/* unused harmony reexport SortDirection */
/* unused harmony reexport SortIndicator */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__WindowScroller__ = __webpack_require__(1389);
/* unused harmony reexport WindowScroller */














/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_floater__ = __webpack_require__(473);
var Floatipy=function Floatipy(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_floater__["a" /* default */],{event:"hover",content:props.tooltip,offset:5,placement:"bottom",styles:{wrapper:{cursor:"default"},container:{textAlign:"center",minHeight:"auto",padding:20,borderRadius:5},floater:{zIndex:5000000},arrow:{margin:4}}},props.children);};/* harmony default export */ __webpack_exports__["a"] = (Floatipy);

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tournament-description-bg.79f437f2.png";

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InfoWireframe */
/* harmony export (immutable) */ __webpack_exports__["a"] = Balance;
/* harmony export (immutable) */ __webpack_exports__["b"] = Cost;
/* harmony export (immutable) */ __webpack_exports__["c"] = Participants;
/* harmony export (immutable) */ __webpack_exports__["e"] = Rating;
/* harmony export (immutable) */ __webpack_exports__["f"] = Refills;
/* harmony export (immutable) */ __webpack_exports__["d"] = PrizeFund;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__ = __webpack_require__(71);
var _templateObject=_taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: ",";\n  color: #fff;\n  display: flex;\n  align-items: center;\n"],["\n  font-weight: bold;\n  font-size: ",";\n  color: #fff;\n  display: flex;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-left: ","px;\n  color: ",";\n  font-weight: 700;\n"],["\n  margin-left: ","px;\n  color: ",";\n  font-weight: 700;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin: 0 4px;\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  color: #ffcc00;\n"],["\n  margin: 0 4px;\n  width: 12px;\n  height: 12px;\n  display: flex;\n  align-items: center;\n  color: #ffcc00;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-weight: 400;\n"],["\n  font-weight: 400;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  font-size: 16px;\n  line-height: 1.25;\n\n  @media (max-width: 959px) {\n    :not(:first-of-type) {\n      margin-top: 15px;\n    }\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  font-size: 16px;\n  line-height: 1.25;\n\n  @media (max-width: 959px) {\n    :not(:first-of-type) {\n      margin-top: 15px;\n    }\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 0;\n\n  @media (max-width: 959px) {\n    flex-basis: 62px;\n    width: 62px;\n  }\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 0;\n\n  @media (max-width: 959px) {\n    flex-basis: 62px;\n    width: 62px;\n  }\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n        margin-left: 10px;\n      "],["\n        margin-left: 10px;\n      "]),_templateObject8=_taggedTemplateLiteral(["\n      margin-right: 10px;\n    "],["\n      margin-right: 10px;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  font-size: 12px;\n  margin-bottom: 5px;\n"],["\n  font-size: 12px;\n  margin-bottom: 5px;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n"],["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  align-items: flex-start;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-weight: 700;\n"],["\n  font-weight: 700;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n  font-weight: 700;\n  color: #ffcc00;\n"],["\n  font-weight: 700;\n  color: #ffcc00;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InfinityIcon=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](function(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 17.502 17.502",width:"100%"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M13.182 4.431a4.282 4.282 0 0 0-3.036 1.246L8.75 7.017l-1.375-1.32C6.56 4.88 5.474 4.431 4.32 4.431s-2.239.451-3.053 1.266A4.288 4.288 0 0 0 0 8.752c0 1.152.449 2.238 1.266 3.053a4.285 4.285 0 0 0 3.054 1.266 4.272 4.272 0 0 0 3.036-1.248l1.395-1.338 1.376 1.32c.815.816 1.901 1.266 3.055 1.266s2.238-.449 3.053-1.266c.817-.814 1.267-1.9 1.267-3.055s-.449-2.238-1.266-3.055a4.296 4.296 0 0 0-3.054-1.264zm-7.576 5.605c-.687.688-1.884.688-2.572 0a1.807 1.807 0 0 1-.533-1.285c0-.486.189-.941.535-1.287.342-.344.799-.533 1.284-.533s.942.189 1.305.551l1.321 1.27-1.34 1.284zm8.861 0c-.687.689-1.866.705-2.59-.018l-1.321-1.27 1.339-1.285c.688-.688 1.886-.688 2.573-.002.344.346.533.801.533 1.287s-.19.944-.534 1.288z",fill:"currentColor"}));});var WhiteFree=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"16px";});var RefillValue=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2,function(_ref2){var marginLeft=_ref2.marginLeft;return marginLeft;},function(_ref3){var isActive=_ref3.isActive;return isActive?"#ffcc00":"rgba(255, 255, 255, 0.44)";});var RefillInfinity=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject3);var RefillCount=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject4);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref4){var theme=_ref4.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var Strong=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject11);var Placeholder=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Strong)(_templateObject12,function(_ref5){var theme=_ref5.theme;return theme.lightWhiteForeground;});var Accent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject12,function(_ref6){var theme=_ref6.theme;return theme.alternativeAccent;});var RefillLimit=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject13);function InfoWireframe(_ref7){var className=_ref7.className,icon=_ref7.icon,_ref7$IconWrapper=_ref7.IconWrapper,IconWrapper=_ref7$IconWrapper===undefined?IconContainer:_ref7$IconWrapper,title=_ref7.title,children=_ref7.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{className:className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconWrapper,null,icon),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,title,":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,children)));}function Balance(_ref8){var balance=_ref8.balance,participation_status=_ref8.participation_status,props=_objectWithoutProperties(_ref8,["balance","participation_status"]);if(balance==null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoWireframe,Object.assign({},props,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["m" /* Wallet */],{width:"45px"}),title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Tournament balance")}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],{Value:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["k" /* Value */],Symbol:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["c" /* Currency */],currency:__WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__["b" /* tournamentCurrency */]},balance));}function Cost(_ref9){var participation_price=_ref9.participation_price,participation_price_usd=_ref9.participation_price_usd,type=_ref9.type,props=_objectWithoutProperties(_ref9,["participation_price","participation_price_usd","type"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoWireframe,Object.assign({},props,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["b" /* Coins */],{width:"62px"}),title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Participation fee")}),props.subtype==="demo"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],{Value:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["k" /* Value */],Symbol:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["c" /* Currency */]},participation_price):!props.is_limited&&type==="free"||props.is_limited&&props.invited?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Free")):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:participation_price,valueUSD:participation_price_usd,valueStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["c" /* Currency */],divider:"\xA0/\xA0"}));}function Participants(_ref10){var participant_count=_ref10.participant_count,props=_objectWithoutProperties(_ref10,["participant_count"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoWireframe,Object.assign({},props,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["i" /* Person */],{width:"42px"}),title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Participants")}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,null,participant_count));}function Rating(_ref11){var current_place=_ref11.current_place,participant_count=_ref11.participant_count,props=_objectWithoutProperties(_ref11,["current_place","participant_count"]);if(current_place==null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoWireframe,Object.assign({},props,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["j" /* Podium */],{width:"54px"}),title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Your rating")}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Accent,null,"# ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Strong,null,current_place)," "),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"of"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,null," ",participant_count));}var RefillInfo=function RefillInfo(_ref12){var refillLimit=_ref12.refillLimit,refillCount=_ref12.refillCount,_ref12$marginLeft=_ref12.marginLeft,marginLeft=_ref12$marginLeft===undefined?7:_ref12$marginLeft;if(refillLimit){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillValue,{isActive:refillLimit>refillCount,marginLeft:marginLeft},"(",refillCount,"/",refillLimit,")");}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillInfinity,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfinityIcon,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillCount,null,"(",refillCount,")"));};function Refills(_ref13){var refill=_ref13.refill,refillLimit=_ref13.refillLimit,refillAccount=_ref13.refillAccount,refillCosts=_ref13.refillCosts,tournamentType=_ref13.tournamentType,cost=_ref13.cost,cost_usd=_ref13.cost_usd,props=_objectWithoutProperties(_ref13,["refill","refillLimit","refillAccount","refillCosts","tournamentType","cost","cost_usd"]);var refillCount=refillAccount!==null?refillAccount.refill_count:0;var no_purchases=refill===false||cost==null||cost_usd==null||refillAccount!=null&&refillLimit!==false&&refillAccount.refill_count>=refillLimit;var limit=refillLimit?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillLimit,null,refillLimit," "):null;var refillCountByType=function refillCountByType(){if(refillType()!=="mixed"){return refillCount;}var reducedObj=refillCosts.reduce(function(acc,el){if(parseFloat(el.cost_usd)===0){return{free:acc.free+1,paid:acc.paid};}return{free:acc.free,paid:acc.paid+1};},{free:0,paid:0});if(refillCosts.length<refillLimit){parseFloat(refillCosts[refillCosts.length-1].cost_usd)===0?reducedObj.free=reducedObj.free+(refillLimit-refillCosts.length):reducedObj.paid=reducedObj.paid+(refillLimit-refillCosts.length);}return reducedObj;};var usedRefillByType=function usedRefillByType(){if(refillAccount==null||refillAccount.refill_count===0)return{free:0,paid:0};if(refillType()!=="mixed"){return refillCount;}var reducedObj=refillCosts.reduce(function(acc,el,index){if(parseFloat(el.cost_usd)===0){return{free:refillAccount.refill_count>index?acc.free+1:acc.free,paid:acc.paid};}return{free:acc.free,paid:refillAccount.refill_count>index?acc.paid+1:acc.paid};},{free:0,paid:0});if(refillCosts.length<refillAccount.refill_count){parseFloat(refillCosts[refillCosts.length-1].cost_usd)===0?reducedObj.free=reducedObj.free+(refillAccount.refill_count-refillCosts.length):reducedObj.paid=reducedObj.paid+(refillAccount.refill_count-refillCosts.length);}return reducedObj;};var refillType=function refillType(){if(no_purchases||refillCosts.length<1){return"no purchases";}if(refillCosts.every(function(el){return parseFloat(el.cost)===0&&parseFloat(el.cost_usd)===0;})){return"all free";}if(refillCosts.every(function(el){return parseFloat(el.cost)>0&&parseFloat(el.cost_usd)>0;})){return"all paid";}return"mixed";};var freeRefillLimit=refillType()==="mixed"?refillLimit?refillCountByType()["free"]:!(parseFloat(refillCosts[refillCosts.length-1].cost_usd)===0)?refillCosts.filter(function(el){return parseFloat(el.cost_usd)===0;}).length:false:refillLimit;var paidRefillLimit=refillType()==="mixed"?refillLimit?refillCountByType()["paid"]:!(parseFloat(refillCosts[refillCosts.length-1].cost_usd)>0)?refillCosts.filter(function(el){return parseFloat(el.cost_usd)>0;}).length:false:refillLimit;var currentPaidRefill=function currentPaidRefill(){if(refillAccount==null||refillCount===0){return refillCosts.find(function(el){return el.cost_usd>0;});}if(refillCount>=refillCosts.length){return refillCosts[refillCosts.length-1];}for(var i=refillCount;refillCosts.length-1;i++){if(refillCosts[i].cost_usd>0){return refillCosts[i];}}};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoWireframe,Object.assign({},props,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["c" /* CoinsPlus */],{width:"62px"}),title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,limit,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Refill fee"))}),no_purchases?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"No refill available")):refillType()==="all free"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WhiteFree,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Free"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillInfo,{refillLimit:refillLimit,refillCount:refillCount})):refillType()==="all paid"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:cost||"0.00",valueUSD:cost_usd||"0.00",valueStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["c" /* Currency */],divider:"\xA0/\xA0"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WhiteFree,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Free"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillInfo,{refillLimit:freeRefillLimit,refillCount:usedRefillByType()["free"]})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{marginLeft:-2}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:currentPaidRefill()["cost"]||"0.00",valueUSD:currentPaidRefill()["cost_usd"]||"0.00",valueStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["c" /* Currency */],divider:"\xA0/\xA0"}),paidRefillLimit&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RefillInfo,{refillCount:usedRefillByType()["paid"],refillLimit:paidRefillLimit,marginLeft:5}))));}function PrizeFund(_ref14){var prize_fund=_ref14.prize_fund,prize_fund_usd=_ref14.prize_fund_usd,props=_objectWithoutProperties(_ref14,["prize_fund","prize_fund_usd"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoWireframe,Object.assign({},props,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["e" /* Cup */],{width:"27px"}),title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Prize fund")}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:prize_fund,valueUSD:prize_fund_usd,valueStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_styles__["c" /* Currency */]}));}

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ReferralsShareLinks__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Copy__ = __webpack_require__(1527);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 40px;\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 40px;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      margin-top: 20px;\n      padding-bottom: 10px;\n    "],["\n      margin-top: 20px;\n      padding-bottom: 10px;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  margin-right: 10px;\n  font-size: ",";\n  color: ",";\n\n  @media (max-width: 579px) {\n    width: 110px;\n    text-align: right;\n  }\n"],["\n  margin-right: 10px;\n  font-size: ",";\n  color: ",";\n\n  @media (max-width: 579px) {\n    width: 110px;\n    text-align: right;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 579px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 579px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      margin-right: 68px;\n\n      @media (max-width: 579px) {\n        margin-right: 0;\n        margin-bottom: 20px;\n      }\n    "],["\n      margin-right: 68px;\n\n      @media (max-width: 579px) {\n        margin-right: 0;\n        margin-bottom: 20px;\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 49px;\n  height: 49px;\n  background-color: #3b9478;\n  border-radius: 50%;\n  cursor: pointer;\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 49px;\n  height: 49px;\n  background-color: #3b9478;\n  border-radius: 50%;\n  cursor: pointer;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  color: #ffffff;\n"],["\n  color: #ffffff;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var isPopup=_ref.isPopup;return isPopup&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h3(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14),function(_ref2){var theme=_ref2.theme,isPopup=_ref2.isPopup;return theme.mode==="dark"||!isPopup?"#ffffff":"#feac00";});var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Item=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var type=_ref3.type;return type==="socialShare"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var CopyUrlButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var CopyIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var ShareTournament=function ShareTournament(_ref4){var title=_ref4.title,currentPlace=_ref4.currentPlace,prize=_ref4.prize,profile=_ref4.profile,prizePlacesCount=_ref4.prizePlacesCount,tournamentId=_ref4.tournamentId,isPopup=_ref4.isPopup,props=_objectWithoutProperties(_ref4,["title","currentPlace","prize","profile","prizePlacesCount","tournamentId","isPopup"]);if(!profile||!currentPlace){return null;}var referalLink=profile.ref_bonus.link;function copyUrl(){var temporaryInput=document.createElement("INPUT");var tournamentLink=window.location.origin+"/tournaments/"+tournamentId;temporaryInput.value= true?tournamentLink+" "+props.gettext(["I earn "," in \"","\" tournament on IronTrade! Register by my referal link ",", trade, invest and try tournaments!"],props.money(prize),title,referalLink):"";document.body.appendChild(temporaryInput);temporaryInput.select();document.execCommand("copy");document.body.removeChild(temporaryInput);}return currentPlace<=prizePlacesCount?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,{isPopup:isPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{type:"socialShare"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{isPopup:isPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Share results"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ReferralsShareLinks__["a" /* default */],{isTournament:true,prize:props.money(prize),tournamentTitle:title,link:referalLink})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{isPopup:isPopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Copy link"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyUrlButton,{onClick:copyUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CopyIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Icons_Copy__["a" /* default */],null)))))):null;};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withData__["a" /* default */])({optional:["profile"]})(Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["g" /* withGettext */])(Object(__WEBPACK_IMPORTED_MODULE_4__Money__["d" /* withMoney */])(ShareTournament))));

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Authentication;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Auth_Auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Auth_Tabs_LoggedIn__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_web_itunes_btn_png__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_web_itunes_btn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_web_itunes_btn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_web_itunes_btn_2_png__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_web_itunes_btn_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_web_itunes_btn_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_web_itunes_btn_3_png__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_web_itunes_btn_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_web_itunes_btn_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_web_google_play_btn_png__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_web_google_play_btn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_web_google_play_btn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_web_google_play_btn_2_png__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_web_google_play_btn_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_web_google_play_btn_2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_web_google_play_btn_3_png__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_web_google_play_btn_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_web_google_play_btn_3_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__withErrorCatch__ = __webpack_require__(149);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  -webkit-display: flex;\n  display: flex;\n  -webkit-align-items: center;\n  align-items: center;\n  -webkit-align-self: center;\n  align-self: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n  float: right;\n  width: 450px;\n  height: 420px;\n  margin: 0 auto;\n  font-size: 36px;\n\n  @media (max-width: 900px) {\n    float: none;\n    width: 325px;\n  }\n\n  @media (max-width: 360px) {\n    width: 300px;\n  }\n"],["\n  position: relative;\n  -webkit-display: flex;\n  display: flex;\n  -webkit-align-items: center;\n  align-items: center;\n  -webkit-align-self: center;\n  align-self: center;\n  -webkit-justify-content: center;\n  justify-content: center;\n  float: right;\n  width: 450px;\n  height: 420px;\n  margin: 0 auto;\n  font-size: 36px;\n\n  @media (max-width: 900px) {\n    float: none;\n    width: 325px;\n  }\n\n  @media (max-width: 360px) {\n    width: 300px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: ",";\n  vertical-align: top;\n  float: ",";\n\n  ",";\n\n  @media (max-width: 900px) {\n    display: block;\n    float: none;\n  }\n"],["\n  position: relative;\n  display: ",";\n  vertical-align: top;\n  float: ",";\n\n  ",";\n\n  @media (max-width: 900px) {\n    display: block;\n    float: none;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n      margin-bottom: 50px;\n    "],["\n      margin-bottom: 50px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  width: 450px;\n  height: ",";\n  margin: 0 auto;\n  margin-bottom: ","px;\n  text-align: center;\n\n  @media (max-width: 900px) {\n    height: auto;\n  }\n\n  @media (max-width: 480px) {\n    width: 340px;\n  }\n\n  @media (max-width: 360px) {\n    width: 300px;\n  }\n"],["\n  position: relative;\n  width: 450px;\n  height: ",";\n  margin: 0 auto;\n  margin-bottom: ","px;\n  text-align: center;\n\n  @media (max-width: 900px) {\n    height: auto;\n  }\n\n  @media (max-width: 480px) {\n    width: 340px;\n  }\n\n  @media (max-width: 360px) {\n    width: 300px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: table;\n  width: 335px;\n  padding-top: 52px;\n\n  @media (max-width: 900px) {\n    height: auto;\n    padding: 20px 0;\n    padding-top: 32px;\n  }\n\n  @media (max-width: 359px) {\n    width: 325px;\n  }\n"],["\n  display: table;\n  width: 335px;\n  padding-top: 52px;\n\n  @media (max-width: 900px) {\n    height: auto;\n    padding: 20px 0;\n    padding-top: 32px;\n  }\n\n  @media (max-width: 359px) {\n    width: 325px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding-top: 52px;\n\n  @media (max-width: 900px) {\n    padding-top: 32px;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding-top: 52px;\n\n  @media (max-width: 900px) {\n    padding-top: 32px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding-top: 20px;\n\n  @media (max-width: 900px) {\n    padding-top: 10px;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  padding-top: 20px;\n\n  @media (max-width: 900px) {\n    padding-top: 10px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n  width: 100%;\n  padding: 0;\n  color: #a79eaa;\n  text-align: left;\n\n  @media (max-width: 900px) {\n    display: block;\n    padding-left: 0;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n  width: 100%;\n  padding: 0;\n  color: #a79eaa;\n  text-align: left;\n\n  @media (max-width: 900px) {\n    display: block;\n    padding-left: 0;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  width: 100%;\n  padding-bottom: 10px;\n  background-image: ",";\n  background-repeat: no-repeat;\n  background-position: 50% 0;\n  background-size: cover;\n  background-color: ",";\n\n  @media (max-width: 900px) {\n    padding-bottom: 20px;\n  }\n\n  ",";\n\n  ",";\n"],["\n  width: 100%;\n  padding-bottom: 10px;\n  background-image: ",";\n  background-repeat: no-repeat;\n  background-position: 50% 0;\n  background-size: cover;\n  background-color: ",";\n\n  @media (max-width: 900px) {\n    padding-bottom: 20px;\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n      margin-top: -75px;\n      padding-top: 75px;\n\n      @media (max-width: 959px) {\n        margin-top: -96px;\n        padding-top: 96px;\n      }\n    "],["\n      margin-top: -75px;\n      padding-top: 75px;\n\n      @media (max-width: 959px) {\n        margin-top: -96px;\n        padding-top: 96px;\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n      position: fixed;\n      top: 48px;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      overflow: auto;\n\n      @media (min-width: 960px) {\n        top: 75px;\n      }\n    "],["\n      position: fixed;\n      top: 48px;\n      left: 0;\n      right: 0;\n      bottom: 0;\n      overflow: auto;\n\n      @media (min-width: 960px) {\n        top: 75px;\n      }\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  max-width: 960px;\n  min-width: 320px;\n  margin: 0 auto;\n  padding: 0 10px;\n  font-size: 0;\n  line-height: 0;\n  text-align: justify;\n  clear: both;\n\n  ",";\n\n  :after {\n    display: inline-block;\n    width: 100%;\n    content: \"\";\n  }\n"],["\n  display: table;\n  width: 100%;\n  max-width: 960px;\n  min-width: 320px;\n  margin: 0 auto;\n  padding: 0 10px;\n  font-size: 0;\n  line-height: 0;\n  text-align: justify;\n  clear: both;\n\n  ",";\n\n  :after {\n    display: inline-block;\n    width: 100%;\n    content: \"\";\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n      text-align: center;\n    "],["\n      text-align: center;\n    "]),_templateObject14=_taggedTemplateLiteral(["\n  float: left;\n  display: table;\n  vertical-align: top;\n  width: 390px;\n  height: 420px;\n  margin-top: 0;\n  font-size: 16px;\n  line-height: 1;\n\n  @media (min-width: 960px) {\n    margin-left: 60px;\n  }\n\n  @media (max-width: 900px) {\n    float: none;\n    display: block;\n    height: auto;\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 325px;\n  }\n\n  @media (max-width: 480px) {\n    width: 325px;\n    margin-top: 10px;\n  }\n\n  @media (max-width: 360px) {\n    width: 300px;\n  }\n"],["\n  float: left;\n  display: table;\n  vertical-align: top;\n  width: 390px;\n  height: 420px;\n  margin-top: 0;\n  font-size: 16px;\n  line-height: 1;\n\n  @media (min-width: 960px) {\n    margin-left: 60px;\n  }\n\n  @media (max-width: 900px) {\n    float: none;\n    display: block;\n    height: auto;\n    margin-top: 20px;\n    margin-left: auto;\n    margin-right: auto;\n    width: 325px;\n  }\n\n  @media (max-width: 480px) {\n    width: 325px;\n    margin-top: 10px;\n  }\n\n  @media (max-width: 360px) {\n    width: 300px;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n\n  @media (max-width: 480px) {\n    display: block;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n\n  @media (max-width: 480px) {\n    display: block;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  width: 108px;\n  height: 82px;\n  margin: 0 auto 14px;\n  background: url(",") no-repeat 50% 50%;\n  background-size: cover;\n\n  @media (max-width: 900px) {\n    width: 109px;\n    height: 83px;\n  }\n\n  @media (max-width: 480px) {\n    width: 60px;\n    height: 44px;\n  }\n\n  ",";\n"],["\n  width: 108px;\n  height: 82px;\n  margin: 0 auto 14px;\n  background: url(",") no-repeat 50% 50%;\n  background-size: cover;\n\n  @media (max-width: 900px) {\n    width: 109px;\n    height: 83px;\n  }\n\n  @media (max-width: 480px) {\n    width: 60px;\n    height: 44px;\n  }\n\n  ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n      width: 130px;\n      height: 82px;\n\n      @media (max-width: 900px) {\n        width: 130px;\n        height: 82px;\n      }\n\n      @media (max-width: 480px) {\n        width: 70px;\n        height: 44px;\n      }\n    "],["\n      width: 130px;\n      height: 82px;\n\n      @media (max-width: 900px) {\n        width: 130px;\n        height: 82px;\n      }\n\n      @media (max-width: 480px) {\n        width: 70px;\n        height: 44px;\n      }\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  display: block;\n  width: 202px;\n  height: 26px;\n  margin: 0 auto 15px;\n  background: url(",") no-repeat 50% 50%;\n  background-size: cover;\n\n  @media (max-width: 900px) {\n    width: 193px;\n    height: 25px;\n    margin-bottom: 10px;\n  }\n\n  @media (max-width: 480px) {\n    width: 165px;\n    height: 22px;\n    margin-bottom: 15px;\n  }\n\n  ",";\n"],["\n  display: block;\n  width: 202px;\n  height: 26px;\n  margin: 0 auto 15px;\n  background: url(",") no-repeat 50% 50%;\n  background-size: cover;\n\n  @media (max-width: 900px) {\n    width: 193px;\n    height: 25px;\n    margin-bottom: 10px;\n  }\n\n  @media (max-width: 480px) {\n    width: 165px;\n    height: 22px;\n    margin-bottom: 15px;\n  }\n\n  ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n      width: 161px;\n      height: 30px;\n\n      @media (max-width: 900px) {\n        width: 161px;\n        height: 30px;\n      }\n\n      @media (max-width: 480px) {\n        width: 161px;\n        height: 30px;\n        margin-bottom: 5px;\n      }\n    "],["\n      width: 161px;\n      height: 30px;\n\n      @media (max-width: 900px) {\n        width: 161px;\n        height: 30px;\n      }\n\n      @media (max-width: 480px) {\n        width: 161px;\n        height: 30px;\n        margin-bottom: 5px;\n      }\n    "]),_templateObject20=_taggedTemplateLiteral(["\n  margin-bottom: 26px;\n  font-size: 24px;\n  text-align: center;\n  color: #feac00;\n\n  @media (max-width: 900px) {\n    margin-bottom: 10px;\n    font-size: 24px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 22px;\n  }\n"],["\n  margin-bottom: 26px;\n  font-size: 24px;\n  text-align: center;\n  color: #feac00;\n\n  @media (max-width: 900px) {\n    margin-bottom: 10px;\n    font-size: 24px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: 22px;\n  }\n"]),_templateObject21=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n  color: #fdfdfd;\n"],["\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n  color: #fdfdfd;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  margin-top: 20px;\n  overflow: hidden;\n  font-size: 0;\n  line-height: 0;\n"],["\n  margin-top: 20px;\n  overflow: hidden;\n  font-size: 0;\n  line-height: 0;\n"]),_templateObject23=_taggedTemplateLiteral(["\n  float: right;\n  display: block;\n  width: 180px;\n  height: 49px;\n  margin: 0 auto;\n  font-size: 0;\n  line-height: 0;\n  text-decoration: none;\n\n  @media (max-width: 900px) {\n    width: 140px;\n    height: 39px;\n  }\n\n  :first-child {\n    float: left;\n  }\n\n  > img {\n    display: block;\n    max-width: 100%;\n  }\n"],["\n  float: right;\n  display: block;\n  width: 180px;\n  height: 49px;\n  margin: 0 auto;\n  font-size: 0;\n  line-height: 0;\n  text-decoration: none;\n\n  @media (max-width: 900px) {\n    width: 140px;\n    height: 39px;\n  }\n\n  :first-child {\n    float: left;\n  }\n\n  > img {\n    display: block;\n    max-width: 100%;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var isIronAuth="irontrade"==="irontrade"||"irontrade"==="eztrader";var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var AuthWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,isIronAuth?"block":"inline-block",function(props){return props.isAppLogin||isIronAuth?"none":"right";},isIronAuth&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3));var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,isIronAuth?"auto":"420px",function(props){return props.bigBottomMargin?100:0;});var LoggedInWrapper=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Wrapper)(_templateObject5);var LoginContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var SocialContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var LoggedInContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref){var theme=_ref.theme;return  true?"linear-gradient(to bottom, #1B546A 0%, #399177 100%)":"url("+theme.indexHeaderBackground+")";},function(props){return props.theme.main;},function(props){return props.isMainPage&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.isAppLogin&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);});var HeaderWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(props){return props.isAppLogin&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13);});var BrandContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var BrandContainerInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var BrandLogo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.theme.indexLogo;},function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);});var BrandLogoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject18,function(props){return props.theme.indexLogoText;},function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject19);});var BrandTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20);var BrandText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject21,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?"20px":"16px";});var AppLinks=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22);var AppLink=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].a(_templateObject23);// const AppLinkOnly = AppLink.extend`float: none !important;`;
function Authentication(props){var query=props.query;window.isFullAndroidApp=/wvbo_full/g.test(window.navigator.userAgent);var chucknorris="";if(window.location.search.indexOf("chucknorris=yes")>0){chucknorris="?chuck-norris=yes";}else if(window.location.search.indexOf("chucknorris=no")>0){chucknorris="?chuck-norris=no";}var restrictedEntity=props.api.readEntity("/api/is-restricted"+chucknorris);var isRestricted=restrictedEntity.value&&restrictedEntity.value.restricted;var loggedin=__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LoggedInWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LoggedInContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Auth_Tabs_LoggedIn__["a" /* default */],{isVIP:props.isVIP,geo:props.geo,currencySettings:props.currencySettings,profile:props.profile})));if(props.profileStatus==="AVAILABLE"){// return loggedin;
}switch(props.authTab){case"loggedin":return loggedin;case"social_register":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,{isAppLogin:props.isAppLogin,bigBottomMargin:isRestricted},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SocialContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Auth_Auth__["g" /* default */],{geo:props.geo,isVIP:props.isVIP,activeTab:"social_register",showSocial:false,profile:props.profile,isAppLogin:props.isAppLogin})));case"social_password":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,{isAppLogin:props.isAppLogin,bigBottomMargin:isRestricted},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LoginContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Auth_Auth__["g" /* default */],{geo:props.geo,isVIP:props.isVIP,activeTab:"social_password",email:query.email,query:query,location:props.location,history:props.history,ref_user:props.ref_user,isDarkPage:true})));case"register":case"login":case"password_restore":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,{isAppLogin:props.isAppLogin,bigBottomMargin:isRestricted},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LoginContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Auth_Auth__["g" /* default */],{geo:props.geo,isVIP:props.isVIP,activeTab:props.authTab,showSocial:!window.isFullAndroidApp,ref_user:props.ref_user,isDarkPage:true})));default:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SpinnerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Spinners_SimpleSpinner__["c" /* default */],null));}}function HeaderMain(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,{isAppLogin:props.isAppLogin,isMainPage:props.location&&props.location.pathname==="/"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderWrapper,{isAppLogin:props.isAppLogin},!props.isAppLogin&&"irontrade"==="siamoption"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BrandContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BrandContainerInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BrandLogo,{thProject:"irontrade"==="siamoption"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BrandLogoText,{thProject:"irontrade"==="siamoption"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BrandTitle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Binary Options Broker")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BrandText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Predict price movements and get profit on ups and downs")),"irontrade"==="siamoption"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AppLinks,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AppLink,{href:props.isHelpdesk?"https://app.appsflyer.com/id1169036197?pid=helpdesk&media_source=helpdesk&campaign=appstore_button":"https://app.appsflyer.com/id1169036197?pid=main_page&media_source=main_page&campaign=appstore_button",onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_DOWNLOADAPP_MAINPAGE",{appSrc:e.currentTarget.href});}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img",{src:__WEBPACK_IMPORTED_MODULE_7__images_web_itunes_btn_png___default.a,srcSet:__WEBPACK_IMPORTED_MODULE_8__images_web_itunes_btn_2_png___default.a+" 2x, "+__WEBPACK_IMPORTED_MODULE_9__images_web_itunes_btn_3_png___default.a+" 3x",alt:"Itunes"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AppLink,{href:props.isHelpdesk?"https://play.google.com/store/apps/details?id=com.full.iron&referrer=sub1%3Dmainpage":"https://app.appsflyer.com/com.siamtrade.mobile?pid=main_page&media_source=main_page&c=googleplay_button",onClick:function onClick(e){return Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("CLICKBTN_DOWNLOADAPP_MAINPAGE",{appSrc:e.currentTarget.href});}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("img",{src:__WEBPACK_IMPORTED_MODULE_10__images_web_google_play_btn_png___default.a,srcSet:__WEBPACK_IMPORTED_MODULE_11__images_web_google_play_btn_2_png___default.a+" 2x, "+__WEBPACK_IMPORTED_MODULE_12__images_web_google_play_btn_3_png___default.a+" 3x",alt:"Google Play"}))))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AuthWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Authentication,Object.assign({},props,{api:api}));}))));}/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_14__withErrorCatch__["a" /* default */])(HeaderMain));

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SearchLogic=function(_React$Component){_inherits(SearchLogic,_React$Component);function SearchLogic(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SearchLogic);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SearchLogic.__proto__||Object.getPrototypeOf(SearchLogic)).call.apply(_ref,[this].concat(args))),_this),_this.state={searchQuery:""},_this.updateState=function(e){var value=e.target.value;_this.setState({searchQuery:value});},_this.redirect=function(field){var searchQuery=_this.state.searchQuery;var pathname=_this.props.location.pathname;Object(__WEBPACK_IMPORTED_MODULE_3__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Helpdesk Search",eventAction:"Search "+pathname+"#"+field,eventLabel:"\u0420\u0435\u0434\u0438\u0440\u0435\u043A\u0442 \u043D\u0430 \u0440\u0435\u0437\u0443\u043B\u044C\u0442\u0430\u0442\u044B \u043F\u043E\u0438\u0441\u043A\u0430 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \""+searchQuery+"\" \u0438\u0437 \u043F\u043E\u043B\u044F "+field+" \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B "+pathname});Object(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaReducer */])("CLICKBTN_SEARCH",{searchQuery:searchQuery});_this.props.history.push("/helpdesk/search?"+searchQuery,{searchQuery:searchQuery});// очищаем поле после редиректа
_this.setState({searchQuery:""});if(_this.inputFieldRef&&typeof _this.inputFieldRef.blur==="function"){_this.inputFieldRef.blur();}},_this.handleEnter=function(e,field){if(e.keyCode===13){_this.redirect(field);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SearchLogic,[{key:"render",value:function render(){var _this2=this;return this.props.children({inputFieldRef:function inputFieldRef(input){return _this2.inputFieldRef=input;},searchQuery:this.state.searchQuery,updateSearchQuery:this.updateState,redirectToSearch:this.redirect,redirectOnEnter:this.handleEnter});}}]);return SearchLogic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])()(SearchLogic)));

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UnitedSearchIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UnitedSearchCloseIcon; });
/* unused harmony export BackIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  fill-rule: evenodd;\n  fill: ",";\n\n  @media (min-width: 960px) {\n    width: 24px;\n    height: 24px;\n    fill: rgb(255, 255, 255);\n\n    :hover {\n      fill: ",";\n    }\n  }\n"],["\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n  fill-rule: evenodd;\n  fill: ",";\n\n  @media (min-width: 960px) {\n    width: 24px;\n    height: 24px;\n    fill: rgb(255, 255, 255);\n\n    :hover {\n      fill: ",";\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 26px;\n  margin-left: 14px;\n  margin-right: 5px;\n"],["\n  width: 26px;\n  margin-left: 14px;\n  margin-right: 5px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  fill-rule: evenodd;\n  fill: ",";\n\n  :hover {\n    fill: ",";\n  }\n"],["\n  width: 16px;\n  height: 16px;\n  cursor: pointer;\n  fill-rule: evenodd;\n  fill: ",";\n\n  :hover {\n    fill: ",";\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject,function(props){return props.theme.helpdeskNavlinks;},function(props){return props.theme.accent;});var BackSvg=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Svg)(_templateObject2);var UnitedSearchSvg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject3,function(props){return props.theme.staticHeaderLink;},function(props){return props.theme.accent;});var SearchIcon=function SearchIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"24px",height:"24px",viewBox:"0 0 24 24"},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M22.578,20.798 L18.567,16.846 C19.755,15.201 20.460,13.195 20.460,11.027 C20.460,5.468 15.870,0.947 10.228,0.947 C4.587,0.947 -0.003,5.468 -0.003,11.027 C-0.003,16.584 4.587,21.106 10.228,21.106 C12.585,21.106 14.751,20.310 16.483,18.986 L20.450,22.894 C20.744,23.183 21.130,23.328 21.514,23.328 C21.899,23.328 22.284,23.184 22.578,22.894 C23.166,22.316 23.166,21.377 22.578,20.798 ZM2.405,11.027 C2.405,6.777 5.915,3.319 10.229,3.319 C14.543,3.319 18.053,6.777 18.053,11.027 C18.053,12.795 17.440,14.422 16.419,15.724 C16.081,16.154 15.702,16.551 15.281,16.902 C13.917,18.043 12.155,18.735 10.229,18.735 C5.915,18.734 2.405,15.277 2.405,11.027 Z"}));};var UnitedSearchIcon=function UnitedSearchIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnitedSearchSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"213 3409 15.9 15.9"},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M15.9,14.5l-3.3-3.3A6.847,6.847,0,0,0,14,7,6.957,6.957,0,0,0,7,0,6.957,6.957,0,0,0,0,7a6.957,6.957,0,0,0,7,7,6.847,6.847,0,0,0,4.2-1.4l3.3,3.3ZM2,7A4.951,4.951,0,0,1,7,2a4.951,4.951,0,0,1,5,5,4.951,4.951,0,0,1-5,5A4.951,4.951,0,0,1,2,7Z",transform:"translate(213 3409)"}));};var UnitedSearchCloseIcon=function UnitedSearchCloseIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UnitedSearchSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"167 4126 15.557 15.557"},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M7.778,9.192,1.414,15.557,0,14.142,6.364,7.778,0,1.414,1.414,0,7.778,6.364,14.142,0l1.415,1.414L9.192,7.778l6.364,6.364-1.415,1.415Z",transform:"translate(167 4126)"}));};var BackIcon=function BackIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BackSvg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"19px",height:"16px",viewBox:"0 0 19 16"},props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M7.543,0.485 L0.741,7.287 C0.345,7.683 0.345,8.326 0.741,8.722 L7.543,15.524 C7.939,15.920 8.582,15.920 8.978,15.524 C9.374,15.127 9.374,14.485 8.978,14.088 L3.886,8.997 L17.472,8.997 C18.032,8.997 18.487,8.543 18.487,7.982 C18.487,7.422 18.032,6.968 17.472,6.968 L3.931,6.968 L8.978,1.920 C9.374,1.524 9.374,0.882 8.978,0.485 C8.582,0.089 7.939,0.089 7.543,0.485 Z"}));};

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAAH7+Yj7AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAsVJREFUeNpiXLpkCQsDAwMvAxIACfwGYkZkQSYkthqyShD4jySZBRNE0Q4QQIxAiwQZ0ABI5Xs0sUswi+Sw2f4Qatl/ZEFGJMwAEEAgi0CyZxnwAy2YM03QJFKAeDaS8y8h+/wVkv08UEX/sQWRKBK7H0lRJq5gQwfTQARAAGENNWwAZOI7InxtjMvX6OA/Ey4JIN6PbjW6Akb06EcPnv9oNMi3d3CZyIAruJgYiATIJjISo/A/IRMBAgiWzKgGmNCcSAm+TFLgQL0NS9YGxLiQEPgDLUJA4BapBnYguQaE3aDibFDvfQNiPULRzIAnJndC6QVArALENkhyGUA8k1BKxAUSCPmSiQop5QchLzNSYjrIwEvQAKZKAgcIIKLLMCLBZ1hZRzUAC8MvQHyTQrOMkQ28AMS2FBr4n1rJhuy8fArqih/UMtAUSrNTy8A8KH2QXAOPA/F9JP5kaC5yILZSQRb7hZQFP6O3raCAB5rc8LpQFUs7DKTxHxKfGRo5IIsUCRnogiuLQg0RhZbcMHCPkkiBNZeolg6pnrDJMvArtQ1cREYFT1svwxK2DbWqAGq78BxAgIHqFFAjR4dhcIKLTIPYcSCgjx4lR6jQ7KRKs5VmqXrQlzRQwA/E3UB8DIhXEdFTI6l+ohR4AvE2NLFQIF4GxNGDIQTvo9WPMHCbniHICg2VvUD8Ek3uBrTSVgZiS2gdewKHo6nuQG8gXgjEwkhir6Hip9HU3oVimmcSaSA+BK1qtqA5DjaUAmqD/gTiKAJm1UJDEtSDkaCGA0HdwSdENuNB/dOlUI90INXUHEC8DireBBXXBeLnQPwUiOUpcSC5nb1yaEiBWqHfgTgQhzopIPYaiHIQBrgHa0E96GsSqjcIcYGFUE/w0Mj+L1A7yHYgaMRo6mAKQVDbcPcAx6oiPgcK4OkuDlgIMkObR4MRfAQAhSSKl/zkR7cAAAAASUVORK5CYII="

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAmCAYAAAGkHhv0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAchJREFUeNpiXLpkCQMQ/AViJiBmZAES/0EMBihgQuaAJJkY0ACGAEAAMUIN/Q/js0DNYEQ24x+MA5LAayhYG0AAwQxlQHMgnM2ERRKm+z9WdyJpYMCnAA5YsOlCBgABhO5IGFgBxJHoxsNCJAJm939k/yKxP+FzGC+y5Ad0h+H1EvmSyAEhgE3yAK4QAggg5BDCG5To8Q9z016ohv9EaGRAVgvS7MRAJmDCEi0gLIjEhmEhdLW4gvIBFv+/IykeiHH2wGhmwRPH//GIgQFAAKEnktVAHILDot9AzIbP2SF4XMlKyNkMWLIkziTLgkPiP6GCBwgOsuCxjVD6tmchITdhdTYjjuKHgYDTsaZtQSLFsKawd1hseTe40vaoZipoZsTCZiS1JKGZsw+CCIAAw1ZXIYN/JGZVdF8wketqRgrigpFQcCkC8X5ok/A/iZUt0ZUxFP+FBrUiKJJvoUX2J6gCagKQB/mhtB0Q32bBksL4GGgPmJkYBgiwoDWeqZWw8OVRRlLy4n9oQxZbwiEkRv2ya8AKzVGLRy0elBazUFDTECtGso+ZqVEmE+Pjf2gO+UODEP6HzcfKQLwbiL/TwEKQmVuAWB4mAACHjmKTN7StlwAAAABJRU5ErkJggg=="

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAmCAYAAAGkHhv0AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAiFJREFUeNpiNJlxm4GRgeH/fwYwYGRhgHAYGaCAiQGJA5JkYkADGAIAAcQIMhSkFMZnsmB7CjOHEWzGiV/Sf2EGglXgMxRsPUAAwQyFa0FnM2GRhOn+j9WdSBoY8CmAAxZsupABQAChOxIMZJk/PXr8l0+eBV0xiABKwB33H1kCxmZl/PsPp8N+/2dGBB0bUCW6w/B6iXxJuFd+/WfGjDpxpq8foA5BxwwAAYQcQniDEj2gYCa/QzeRAICrZXr5j1uQgUzAhCVRMZqzPVVAStUwMSV0tViD8vxvifvo/j/5S/oeSfFAjLMHRjMLtjgGphZk//7HlQYAAgglkcgwf3r85C+fDHYn/mf4x8DIiNPZuDSCwD+UWMLubAYsWRJnkmXBIfGfUMEjBswwLHhsw5u+X/3jFmAhITdhdTYjjuKHgYDTMdM2MAMoEiOGNYWhZYD/uDLFEM4Yo5qxVHL4Uh4LibUF5c4Wg9RfDAABhq2uYqAkpxEoVKgT2BRFlCnbMztgJfueEUf1TSFAMQ9kByioQXYyms249R+5QAY2Zv4zUtl3/yFVECMi/P8zsKDXAsgKaAX+A+0csDhmQWs8E5UiyQhpDHOJ9fF/aEMWW8IhJDbIstOoxaMWDzuLWYit3qDNfUIFDCPFPrZge8pGqa/wmcGCMZYABSd+Sf+k1GKgGRjB8R/dxyZsz2wlmL+8ZWH4R4P4/Mcgxfz5JdAOM5gYAOY7rhvTwQakAAAAAElFTkSuQmCC"

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_trading_button_bg_png__ = __webpack_require__(1576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_trading_button_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_trading_button_bg_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n  padding: 0 14px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 39px;\n  text-decoration: none;\n  white-space: nowrap;\n  color: #fff;\n  border: none;\n  perspective: 1000px;\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n    color: #fff;\n  }\n\n  background-color: #61ad12;\n  background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);\n  :hover {\n    background-color: #68c604;\n    background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);\n  }\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: auto;\n  padding: 0 14px;\n  box-sizing: border-box;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 39px;\n  text-decoration: none;\n  white-space: nowrap;\n  color: #fff;\n  border: none;\n  perspective: 1000px;\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n    color: #fff;\n  }\n\n  background-color: #61ad12;\n  background: linear-gradient(to bottom, #68c604 0%, #61ad12 100%);\n  :hover {\n    background-color: #68c604;\n    background: linear-gradient(to bottom, #61ad12 0%, #68c604 100%);\n  }\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n      display: inline-block;\n      width: 100%;\n      text-align: center;\n      padding-left: 20px;\n      padding-right: 20px;\n    "],["\n      display: inline-block;\n      width: 100%;\n      text-align: center;\n      padding-left: 20px;\n      padding-right: 20px;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      min-width: 220px;\n      max-width: 290px;\n      padding: 12px 15px;\n      min-height: 51px;\n      line-height: 1;\n      font-size: 24px;\n      text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.22);\n      box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),\n        inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);\n      white-space: normal;\n      @media (max-width: 480px) {\n        line-height: 1;\n        font-size: 22px;\n        padding: 13px 15px;\n        margin: 0 auto 0;\n      }\n    "],["\n      min-width: 220px;\n      max-width: 290px;\n      padding: 12px 15px;\n      min-height: 51px;\n      line-height: 1;\n      font-size: 24px;\n      text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.22);\n      box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),\n        inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);\n      white-space: normal;\n      @media (max-width: 480px) {\n        line-height: 1;\n        font-size: 22px;\n        padding: 13px 15px;\n        margin: 0 auto 0;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      min-width: 0px;\n      width: 100%;\n      height: 68px;\n      min-height: 68px;\n      line-height: 44px;\n      font-weight: 700;\n      font-size: 27px;\n      @media (max-width: 959px) {\n        line-height: 1;\n        font-size: 22px;\n        height: 48px;\n        min-height: 48px;\n      }\n    "],["\n      min-width: 0px;\n      width: 100%;\n      height: 68px;\n      min-height: 68px;\n      line-height: 44px;\n      font-weight: 700;\n      font-size: 27px;\n      @media (max-width: 959px) {\n        line-height: 1;\n        font-size: 22px;\n        height: 48px;\n        min-height: 48px;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      margin: 0px;\n      padding: 0 18px;\n      line-height: 47px;\n      border-radius: 8px;\n      box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),\n        inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);\n    "],["\n      margin: 0px;\n      padding: 0 18px;\n      line-height: 47px;\n      border-radius: 8px;\n      box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),\n        inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      margin-right: 0px;\n      background-color: ",";\n      background: linear-gradient(\n        to bottom,\n        "," 0%,\n        #fd9500 100%\n      );\n      @media (max-width: 480px) {\n        margin-right: 0px;\n      }\n      :hover {\n        background-color: #fd9500;\n        background: linear-gradient(\n          to bottom,\n          #fd9500 0%,\n          "," 100%\n        );\n      }\n    "],["\n      margin-right: 0px;\n      background-color: ",";\n      background: linear-gradient(\n        to bottom,\n        "," 0%,\n        #fd9500 100%\n      );\n      @media (max-width: 480px) {\n        margin-right: 0px;\n      }\n      :hover {\n        background-color: #fd9500;\n        background: linear-gradient(\n          to bottom,\n          #fd9500 0%,\n          "," 100%\n        );\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n      background-color: #706281;\n      background: linear-gradient(to bottom, #877c95 0%, #706281 100%);\n      :hover {\n        background-color: #877c95;\n        background: linear-gradient(to bottom, #706281 0%, #877c95 100%);\n      }\n    "],["\n      background-color: #706281;\n      background: linear-gradient(to bottom, #877c95 0%, #706281 100%);\n      :hover {\n        background-color: #877c95;\n        background: linear-gradient(to bottom, #706281 0%, #877c95 100%);\n      }\n    "]),_templateObject8=_taggedTemplateLiteral(["\n      @media (max-width: 479px) {\n        padding-left: 5px;\n        padding-right: 5px;\n        font-size: ",";\n      }\n\n      @media (max-width: 359px) {\n        font-size: ",";\n      }\n    "],["\n      @media (max-width: 479px) {\n        padding-left: 5px;\n        padding-right: 5px;\n        font-size: ",";\n      }\n\n      @media (max-width: 359px) {\n        font-size: ",";\n      }\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  margin-right: 7px;\n  position: relative;\n  top: 3px;\n  width: 20px;\n  height: auto;\n  @media (max-width: 480px) {\n    margin-right: 6px;\n    top: 1px;\n    width: 17px;\n  }\n"],["\n  margin-right: 7px;\n  position: relative;\n  top: 3px;\n  width: 20px;\n  height: auto;\n  @media (max-width: 480px) {\n    margin-right: 6px;\n    top: 1px;\n    width: 17px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: inline-block;\n\n  ",";\n"],["\n  display: inline-block;\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "],["\n      :first-letter {\n        text-transform: uppercase;\n      }\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LinkView=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */])(_templateObject,function(props){return props.wide&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(props){return props.big&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);},function(props){return props.bigfckinbutton&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.type==="yellow"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(props){return props.theme.accent;},function(props){return props.theme.accent;},function(props){return props.theme.accent;});},function(props){return props.type==="violet"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);},function(props){return props.longText&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});});var Image=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject9);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject10,function(_ref3){var theme=_ref3.theme;return theme.locale!=="ar"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);});var LinkButton=function(_Component){_inherits(LinkButton,_Component);function LinkButton(){_classCallCheck(this,LinkButton);return _possibleConstructorReturn(this,(LinkButton.__proto__||Object.getPrototypeOf(LinkButton)).apply(this,arguments));}_createClass(LinkButton,[{key:"render",value:function render(){var _props=this.props,text=_props.text,type=_props.type,to=_props.to,wide=_props.wide,big=_props.big,mobile=_props.mobile,onClick=_props.onClick,showSpinner=_props.showSpinner,longText=_props.longText,bigfckinbutton=_props.bigfckinbutton,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkView,{to:to,onClick:onClick,wide:wide,mobile:mobile,big:big,type:type,longText:longText,bigfckinbutton:bigfckinbutton},type==="yellow"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:__WEBPACK_IMPORTED_MODULE_4__images_trading_button_bg_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_4__images_trading_button_bg_png___default.a}),showSpinner&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Spinners_SimpleSpinner__["c" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,text||children));}}]);return LinkButton;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (LinkButton);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterFCMToken;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app__ = __webpack_require__(1682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase_messaging__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_filter__ = __webpack_require__(1689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__OneSignal_Popup__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Firebase__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_transition_group__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_animate_height__ = __webpack_require__(1699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react_animate_height___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react_animate_height__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_redux__ = __webpack_require__(5);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// const API_URL = "https://notifications-pusher-service.siamoption-staging.local";
// const API_URL = "https://notifications-pusher-service.irontrade-staging.local";
function createArtificialMessaging(){var token=null;var onTokenRefreshCallbacks=new Set();var messaging={requestPermission:function requestPermission(){return Promise.resolve();},getToken:function getToken(){if(token!=null){return Promise.resolve(token);}else{return new Promise(function(resolve){function callback(){resolve(token);onTokenRefreshCallbacks.delete(callback);}onTokenRefreshCallbacks.add(callback);});}},onTokenRefresh:function onTokenRefresh(callback){onTokenRefreshCallbacks.add(callback);return function(){onTokenRefreshCallbacks.delete(callback);};},onMessage:function onMessage(){return function(){return void 0;};}};window.NATIVE_APP_FIREBASE_UPDATE_TOKEN=function(freshToken){token=freshToken;onTokenRefreshCallbacks.forEach(function(callback){callback();});};return messaging;}function isAndroidAppMessagingAvailable(){return window.nativeInterface!=null&&window.nativeInterface.getFirebaseToken!=null;}function isIOSAppMessagingAvailable(){return window.webkit!=null&&window.webkit.messageHandlers!=null&&window.webkit.messageHandlers["nativeInterface"]!=null;}var messaging=null;try{if(isAndroidAppMessagingAvailable()){messaging=createArtificialMessaging();window.nativeInterface.getFirebaseToken("window.NATIVE_APP_FIREBASE_UPDATE_TOKEN('%VALUE%')");}else if(isIOSAppMessagingAvailable()){messaging=createArtificialMessaging();window.webkit.messageHandlers["nativeInterface"].postMessage(JSON.stringify({function:"getFirebaseToken",param:"window.NATIVE_APP_FIREBASE_UPDATE_TOKEN('%VALUE%')"}));}else{switch("irontrade"){case"siamoption":__WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.initializeApp({apiKey:"AIzaSyBF3xYH9XJl7Hgpw7yLkjV68YwnRPwfwHM",authDomain:"siamtrade-b960e.firebaseapp.com",databaseURL:"https://siamtrade-b960e.firebaseio.com",projectId:"siamtrade-b960e",storageBucket:"siamtrade-b960e.appspot.com",messagingSenderId:"383961510884"});break;case"irontrade":__WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.initializeApp({apiKey:"AIzaSyCUVFxVwGLWD8SwVDaR4GeBAWbimWbk84U",authDomain:"iron-trade.firebaseapp.com",databaseURL:"https://iron-trade.firebaseio.com/",projectId:"iron-trade",storageBucket:"iron-trade.appspot.com",messagingSenderId:"242226853705"});break;case"eztrader":__WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.initializeApp({apiKey:"AIzaSyDKuIh80mr48AKhZPn2cM7UrXHNVZU_nyE",authDomain:"ez-trader.firebaseapp.com",databaseURL:"https://ez-trader.firebaseio.com",projectId:"ez-trader",storageBucket:"ez-trader.appspot.com",messagingSenderId:"166212058336"});break;default:break;}messaging=__WEBPACK_IMPORTED_MODULE_4_firebase_app___default.a.messaging();}}catch(error){console.warn("Failed initializing Firebase Cloud Messaging APIs");}// Функции для отправки вещей на наши серверы
function submitFCMToken(token,user_key){console.log("yo token = "+token);return Object(__WEBPACK_IMPORTED_MODULE_8__common_fetch__["c" /* apiCall */])("/push/register?"+__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify({type:"fcm",device:token,user:user_key}));}function unregisterFCMToken(token,user_key){return Object(__WEBPACK_IMPORTED_MODULE_8__common_fetch__["c" /* apiCall */])("/push/unregister?"+__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify({type:"fcm",device:token,user:user_key}));}function submitSubscriptionReport(pathname){console.log("subscribed @ "+pathname);// return apiCall("/api/fcm/subscription?page=" + encodeURIComponent(pathname));
}function submitDismissalReport(pathname){console.log("dismissed @ "+pathname);// return apiCall("/api/fcm/dismissal?page=" + encodeURIComponent(pathname));
}// Показываем попап оповещений первые 2 раза, а после —
// каждый пятый
function shouldProposeSubscription(attempt){return attempt===0||attempt===1||(attempt-1)%5===0;}// Безопасное чтение-запись локал стораджа
function getProposalCount(){try{var stored=localStorage.getItem("__FCMProposalCounter");if(stored!=null){return parseInt(stored,10);}else{return 0;}}catch(error){return 0;}}function setProposalCount(value){try{localStorage.setItem("__FCMProposalCounter",value.toString(10));}catch(error){// Ну нет так нет
}}// Компонент невидим по умолчанию, но рендерится в попап,
// когда приходит время
var FirebaseCloudMessaging=function(_React$Component){_inherits(FirebaseCloudMessaging,_React$Component);function FirebaseCloudMessaging(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FirebaseCloudMessaging);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FirebaseCloudMessaging.__proto__||Object.getPrototypeOf(FirebaseCloudMessaging)).call.apply(_ref,[this].concat(args))),_this),_this.state={shouldPropose:false,messages:[]},_this.subscribe=function(){_this.setState({shouldPropose:false},function(){submitSubscriptionReport(_this.props.location.pathname);_this.requestPermission();});},_this.dismiss=function(){_this.setState({shouldPropose:false},function(){submitDismissalReport(_this.props.location.pathname);});},_this.unsubscribeFromTokenRefresh=null,_this.unsubscribeFromMessages=null,_this.submitPushStat=function(_ref2){var push_id=_ref2.push_id,action=_ref2.action;try{Object(__WEBPACK_IMPORTED_MODULE_8__common_fetch__["c" /* apiCall */])("/api/send-push-stat?"+__WEBPACK_IMPORTED_MODULE_3_querystring___default.a.stringify({push_id:push_id,action:action}));}catch(error){console.error(error);}},_this.filterMessageFromState=function(message){var filtered=__WEBPACK_IMPORTED_MODULE_6_lodash_filter___default()(_this.state.messages,function(msg){return msg!==message;});_this.setState({messages:filtered});},_this.clickMessage=function(e,message){_this.submitPushStat({push_id:message.data.push_id,action:"click"});var redirect=__WEBPACK_IMPORTED_MODULE_2_idx___default()(message,function(message){return message.fcmOptions.link;});if(redirect!=null){window.open(redirect,"_blank");_this.filterMessageFromState(message);}},_this.removeMessage=function(e,message){e.stopPropagation();_this.filterMessageFromState(message);_this.submitPushStat({push_id:message.data.push_id,action:"close"});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FirebaseCloudMessaging,[{key:"refreshToken",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var token;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return messaging.getToken();case 2:token=_context.sent;if(!(token!=null)){_context.next=7;break;}this.props.dispatch({type:"PRESERVE_FIREBASE_TOKEN",payload:token});_context.next=7;return submitFCMToken(token,this.props.user_key);case 7:case"end":return _context.stop();}}},_callee,this);}));function refreshToken(){return _ref3.apply(this,arguments);}return refreshToken;}()},{key:"requestPermission",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return messaging.requestPermission();case 3:this.refreshToken();_context2.next=9;break;case 6:_context2.prev=6;_context2.t0=_context2["catch"](0);console.warn("Welp, no luck with notifications",_context2.t0);case 9:case"end":return _context2.stop();}}},_callee2,this,[[0,6]]);}));function requestPermission(){return _ref4.apply(this,arguments);}return requestPermission;}()},{key:"probe",value:function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(){var _token,proposalCount;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return messaging.getToken();case 3:_token=_context3.sent;if(_token==null){proposalCount=getProposalCount();if(shouldProposeSubscription(proposalCount)){this.setState({shouldPropose:true});}setProposalCount(proposalCount+1);}else{this.props.dispatch({type:"PRESERVE_FIREBASE_TOKEN",payload:_token});submitFCMToken(_token,this.props.user_key);}_context3.next=10;break;case 7:_context3.prev=7;_context3.t0=_context3["catch"](0);console.warn(_context3.t0);// Пользователь заблокировал уведомления, не будем тревожить
case 10:case"end":return _context3.stop();}}},_callee3,this,[[0,7]]);}));function probe(){return _ref5.apply(this,arguments);}return probe;}()// Токен с течением времени может меняться, подписываемся на
// messaging.onTokenRefresh, чтобы следить за этим процессом
},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;this.probe();this.unsubscribeFromTokenRefresh=messaging.onTokenRefresh(function(){_this2.refreshToken();});var typesNotForTrade=["demo_opclose","real_opclose","place_tourn"];var restrictedTypes=["start_tourn","finish_tourn","add_news"];this.unsubscribeFromMessages=messaging.onMessage(function(payload){if(window.location.pathname==="/trade"&&typesNotForTrade.includes(payload.data.type)||restrictedTypes.includes(payload.data.type)){return null;}_this2.setState(function(state){return{messages:[].concat(_toConsumableArray(state.messages),[payload])};});});}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.unsubscribeFromTokenRefresh!=null){this.unsubscribeFromTokenRefresh();}if(this.unsubscribeFromMessages!=null){this.unsubscribeFromMessages();}}},{key:"render",value:function render(){var _this3=this;var renderPopup=function renderPopup(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__OneSignal_Popup__["a" /* default */],{onAccept:_this3.subscribe,onDismiss:_this3.dismiss});};return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,this.state.shouldPropose&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["f" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/",exact:true,render:renderPopup}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/profile",render:renderPopup}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/analytics",render:renderPopup}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],{path:"/helpdesk",render:renderPopup})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Firebase__["b" /* Messages */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12_react_transition_group__["TransitionGroup"],{component:null,exit:false},this.state.messages.map(function(message,i){var title=__WEBPACK_IMPORTED_MODULE_2_idx___default()(message,function(message){return message.notification.title;});var body=__WEBPACK_IMPORTED_MODULE_2_idx___default()(message,function(message){return message.notification.body;});var icon=__WEBPACK_IMPORTED_MODULE_2_idx___default()(message,function(message){return message.notification.icon;});return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__common_Animations__["b" /* SlideUpDown */],{key:i},function(animationState){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14_react_animate_height___default.a,{height:animationState==="entered"?"auto":0,duration:animationState==="exiting"?0:200,animateOpacity:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Firebase__["a" /* Message */],{title:title,icon:icon,onClick:function onClick(e){return _this3.clickMessage(e,message);},onDismiss:function onDismiss(e){return _this3.removeMessage(e,message);}},body));});}))));}}]);return FirebaseCloudMessaging;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);// Всё это нам нужно лишь на определённых страницах
// и только когда есть активный профиль
function RoutedFirebaseCloudMessaging(props){var user_key=__WEBPACK_IMPORTED_MODULE_2_idx___default()(props,function(props){return props.profile.user_key;});if(messaging!=null&&user_key!=null){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7_react_router_dom__["e" /* Route */],null,function(route){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FirebaseCloudMessaging,{location:route.location,user_key:user_key,dispatch:props.dispatch});});}return null;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__withData__["a" /* default */])({optional:["profile"]})(Object(__WEBPACK_IMPORTED_MODULE_15_react_redux__["b" /* connect */])()(RoutedFirebaseCloudMessaging)));

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Header__ = __webpack_require__(1696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 20px);\n  height: 190px;\n  background-color: #fff;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  z-index: 100;\n\n  @media (min-width: 568px) {\n    max-width: 395px;\n  }\n"],["\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  display: flex;\n  flex-direction: column;\n  width: calc(100% - 20px);\n  height: 190px;\n  background-color: #fff;\n  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);\n  z-index: 100;\n\n  @media (min-width: 568px) {\n    max-width: 395px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n  padding: 1.5em;\n  font-size: ",";\n  line-height: 1.5;\n  color: #414141;\n\n  @media (max-width: 479px) {\n    font-size: ",";\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n  padding: 1.5em;\n  font-size: ",";\n  line-height: 1.5;\n  color: #414141;\n\n  @media (max-width: 479px) {\n    font-size: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  width: 100%;\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  width: 100%;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  color: #a7a7a7;\n  text-decoration: underline;\n  cursor: pointer;\n"],["\n  color: #a7a7a7;\n  text-decoration: underline;\n  cursor: pointer;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  width: auto;\n  min-width: 8.75em;\n  margin-left: auto;\n"],["\n  width: auto;\n  min-width: 8.75em;\n  margin-left: auto;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14));var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Buttons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var CancelButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5);var AllowButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */])(_templateObject6);function OneSignalPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Header__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"We'd like to show you notifications for the latest news and updates.")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Buttons,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CancelButton,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"NO THANKS")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AllowButton,{color:"green",onClick:props.onAccept},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"ALLOW")))));}/* harmony default export */ __webpack_exports__["a"] = (OneSignalPopup);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return debugMode; });
var API="";if(false){API="https://desktop.siamoption.com";}// Set `window.batman` to `true` to complete debug mode
var debugMode=true;

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexLogo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return IndexLogoText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var IndexLogo=function IndexLogo(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 31.55 31.549",fill:props.fill||"#fff",width:props.width?props.width:"auto",height:props.height?props.height:"auto"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M2829.083-806.423l-1.452-1.452,3.224-3.223-2.617-2.617,6.924-6.924,2.617,2.616,3.209-3.21,1.452,1.453-3.209,3.209,2.617,2.617-6.924,6.924-2.616-2.616-3.223,3.223Zm2.109-7.341,3.78,3.78,3.915-3.915-3.78-3.78Z",transform:"translate(-2810.891 833.72)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M2456.1-982.553l3.227-3.227-2.618-2.62,15.258-15.258,2.618,2.62,3.107-3.107,1.456,1.456-3.107,3.107,2.609,2.611-15.258,15.258-2.61-2.611-3.227,3.227Z",transform:"translate(-2456.101 1008.391)"})));};var IndexLogoText=function IndexLogoText(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 82.581 14.853",fill:props.fill||"#fff",width:props.width?props.width:"auto",height:props.height?props.height:"auto"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{transform:"translate(-484.474 -516.072)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-350.9-111.573h2.37V-98.54h-2.37Zm10.983,5.247a7.257,7.257,0,0,0-.78-.2,5.741,5.741,0,0,0-1.157-.1,4.573,4.573,0,0,0-.8.075,4.8,4.8,0,0,0-.592.132v7.88h-2.276v-9.366a12.507,12.507,0,0,1,1.646-.461,10.258,10.258,0,0,1,2.191-.216q.226,0,.527.028t.6.075q.3.047.583.113t.451.122Zm10.87,2.859a6.35,6.35,0,0,1-.339,2.125,4.7,4.7,0,0,1-.959,1.636,4.313,4.313,0,0,1-1.5,1.053,4.828,4.828,0,0,1-1.928.376,4.761,4.761,0,0,1-1.918-.376,4.335,4.335,0,0,1-1.486-1.053,4.821,4.821,0,0,1-.969-1.636,6.193,6.193,0,0,1-.348-2.125,6.113,6.113,0,0,1,.348-2.116,4.758,4.758,0,0,1,.978-1.627,4.323,4.323,0,0,1,1.5-1.044,4.818,4.818,0,0,1,1.9-.367,4.887,4.887,0,0,1,1.909.367,4.208,4.208,0,0,1,1.5,1.044,4.839,4.839,0,0,1,.969,1.627A6.114,6.114,0,0,1-329.046-103.467Zm-2.332,0a3.838,3.838,0,0,0-.63-2.323,2.059,2.059,0,0,0-1.758-.856,2.059,2.059,0,0,0-1.758.856,3.839,3.839,0,0,0-.63,2.323,3.918,3.918,0,0,0,.63,2.351,2.052,2.052,0,0,0,1.758.865,2.052,2.052,0,0,0,1.758-.865A3.917,3.917,0,0,0-331.378-103.467Zm4.683-4.589a15.242,15.242,0,0,1,1.711-.357,14.757,14.757,0,0,1,2.332-.169,5.364,5.364,0,0,1,2.012.329,3.14,3.14,0,0,1,1.288.922,3.52,3.52,0,0,1,.677,1.429,7.985,7.985,0,0,1,.2,1.834v5.529h-2.276v-5.172a7.467,7.467,0,0,0-.1-1.345,2.384,2.384,0,0,0-.339-.9,1.352,1.352,0,0,0-.639-.508,2.693,2.693,0,0,0-.987-.16,7.581,7.581,0,0,0-.9.056q-.47.056-.7.094v7.937H-326.7Z",transform:"translate(835.373 629.201)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-49.411-123.375v2.05h-4.006v10.983h-2.388v-10.983h-4.006v-2.05Zm6.62,5.247a7.253,7.253,0,0,0-.78-.2,5.74,5.74,0,0,0-1.157-.1,4.574,4.574,0,0,0-.8.075,4.8,4.8,0,0,0-.592.132v7.88H-48.4v-9.366a12.508,12.508,0,0,1,1.646-.461,10.258,10.258,0,0,1,2.191-.216q.226,0,.527.028t.6.075q.3.047.583.113t.451.122Zm5.435,6.188a8.468,8.468,0,0,0,1.6-.113v-2.52a4.427,4.427,0,0,0-.545-.113,5.084,5.084,0,0,0-.79-.056,5.254,5.254,0,0,0-.762.056,2.373,2.373,0,0,0-.7.207,1.262,1.262,0,0,0-.5.423,1.182,1.182,0,0,0-.188.686,1.2,1.2,0,0,0,.508,1.119A2.62,2.62,0,0,0-37.356-111.94Zm-.188-8.482a5.567,5.567,0,0,1,1.9.282,3.033,3.033,0,0,1,1.232.79,2.959,2.959,0,0,1,.658,1.232,6.029,6.029,0,0,1,.2,1.589v5.962q-.527.113-1.589.273a16.23,16.23,0,0,1-2.4.16,7.2,7.2,0,0,1-1.617-.169,3.4,3.4,0,0,1-1.251-.545,2.573,2.573,0,0,1-.809-.978,3.393,3.393,0,0,1-.292-1.486,2.869,2.869,0,0,1,.329-1.429,2.7,2.7,0,0,1,.893-.95,3.868,3.868,0,0,1,1.307-.527,7.358,7.358,0,0,1,1.552-.16,7,7,0,0,1,.79.047,7.366,7.366,0,0,1,.884.16v-.376a2.945,2.945,0,0,0-.094-.752,1.559,1.559,0,0,0-.329-.63,1.54,1.54,0,0,0-.621-.423,2.686,2.686,0,0,0-.969-.15,8.6,8.6,0,0,0-1.448.113,6.366,6.366,0,0,0-1.072.263l-.282-1.843a8.958,8.958,0,0,1,1.26-.3A9.879,9.879,0,0,1-37.544-120.422Zm8.557,5.134a3.573,3.573,0,0,0,.715,2.36,2.434,2.434,0,0,0,1.975.856,7.845,7.845,0,0,0,.931-.047,6.271,6.271,0,0,0,.63-.1v-5.642a3.524,3.524,0,0,0-.8-.386,3.125,3.125,0,0,0-1.063-.179,2.036,2.036,0,0,0-1.815.846A4.036,4.036,0,0,0-28.987-115.288Zm6.526,4.645a13.479,13.479,0,0,1-1.7.376,13.208,13.208,0,0,1-2.153.169,5.739,5.739,0,0,1-2.088-.357,4.35,4.35,0,0,1-1.57-1.025,4.514,4.514,0,0,1-1-1.617,6.173,6.173,0,0,1-.348-2.135,7.194,7.194,0,0,1,.292-2.116,4.629,4.629,0,0,1,.856-1.627,3.814,3.814,0,0,1,1.373-1.044,4.465,4.465,0,0,1,1.862-.367,4.257,4.257,0,0,1,1.26.169,5.638,5.638,0,0,1,.94.376v-4.721l2.276-.376Zm2.351-4.57a6.18,6.18,0,0,1,.386-2.276,4.779,4.779,0,0,1,1.025-1.627,4.243,4.243,0,0,1,1.467-.978,4.543,4.543,0,0,1,1.693-.329,4.052,4.052,0,0,1,3.169,1.26,5.452,5.452,0,0,1,1.138,3.761q0,.188-.009.423t-.028.423h-6.488a2.594,2.594,0,0,0,.837,1.834,3.18,3.18,0,0,0,2.153.649,7.08,7.08,0,0,0,1.514-.15,6.235,6.235,0,0,0,1.081-.32l.3,1.862a3.642,3.642,0,0,1-.517.2,7.307,7.307,0,0,1-.752.188q-.423.085-.912.141a8.692,8.692,0,0,1-1,.056,6.032,6.032,0,0,1-2.257-.386,4.2,4.2,0,0,1-1.58-1.072,4.393,4.393,0,0,1-.922-1.617A6.6,6.6,0,0,1-20.11-115.213Zm6.6-1.016a2.99,2.99,0,0,0-.132-.893,2.155,2.155,0,0,0-.386-.733,1.823,1.823,0,0,0-.621-.489,1.979,1.979,0,0,0-.875-.179,2.036,2.036,0,0,0-.922.2,2.1,2.1,0,0,0-.668.517,2.364,2.364,0,0,0-.423.733,3.974,3.974,0,0,0-.207.846Z",transform:"translate(578.288 641.008)"})));};

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Card;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Account_Card__ = __webpack_require__(1845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TournamentCard__ = __webpack_require__(1849);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Card(_ref){var layout=_ref.layout,props=_objectWithoutProperties(_ref,["layout"]);switch(layout){case"vertical":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Account_Card__["a" /* default */],props);case"horizontal":default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__TournamentCard__["a" /* default */],props);}}

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export tournamentJoinType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tournaments__ = __webpack_require__(1852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Account__ = __webpack_require__(1868);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Account__["a"]; });
function tournamentJoinType(_ref){var is_limited=_ref.is_limited,invited=_ref.invited,limited_for_money=_ref.limited_for_money,type=_ref.type;if(!is_limited){return type;// free | pay
}else if(invited){return"free";}else if(limited_for_money){return"pay";}else{return"invite";}}/* harmony default export */ __webpack_exports__["b"] = (__WEBPACK_IMPORTED_MODULE_0__Tournaments__["a" /* default */]);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StaticPage_Footer__ = __webpack_require__(811);
var _templateObject=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    margin-bottom: 32px;\n  }\n"],["\n  @media (max-width: 959px) {\n    margin-bottom: 32px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var StaticFooter=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__StaticPage_Footer__["a" /* default */])(_templateObject);function Footer(_ref){var match=_ref.match,showContactUs=_ref.showContactUs;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StaticFooter,null));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Footer));

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return indicatorTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(95);
var initialState={period:14,strokeWidth:1,color:"#feac00"};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"ATR (Average True Range)");var ATRPopup=function ATRPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Period"),name:"period",value:props.indicator.period,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Colour"),name:"color",value:props.indicator.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Width of lines"),name:"strokeWidth",value:props.indicator.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}));};/* harmony default export */ __webpack_exports__["a"] = (ATRPopup);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return indicatorTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(95);
var ALGORITHMS=["SMA","EMA"];var initialState={period:14,algorithm:"SMA",strokeWidth:1,color:"#feac00",overbought:70,oversold:30};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"RSI (Relative Strength Index)");var RSIPopup=function RSIPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Period"),name:"period",value:props.indicator.period,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["d" /* Select */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Type"),name:"algorithm",value:props.indicator.algorithm,values:ALGORITHMS,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Overbought"),name:"overbought",value:props.indicator.overbought,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.overbought}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Oversold"),name:"oversold",value:props.indicator.oversold,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.oversold}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Colour"),name:"color",value:props.indicator.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Width of lines"),name:"strokeWidth",value:props.indicator.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}));};/* harmony default export */ __webpack_exports__["a"] = (RSIPopup);

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return indicatorTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToggleTool__ = __webpack_require__(691);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 300px;\n  align-items: center;\n  margin: 10px auto 5px;\n  color: #99959d;\n  direction: ",";\n  margin-bottom: 15px;\n\n  @media (min-width: 480px) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    flex-grow: 1;\n    margin-bottom: 0px;\n  }\n  @media (max-width: 479px) {\n    padding-top: 15px;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  width: 300px;\n  align-items: center;\n  margin: 10px auto 5px;\n  color: #99959d;\n  direction: ",";\n  margin-bottom: 15px;\n\n  @media (min-width: 480px) {\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    flex-grow: 1;\n    margin-bottom: 0px;\n  }\n  @media (max-width: 479px) {\n    padding-top: 15px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  line-height: 1.5;\n  text-align: center;\n\n  @media (min-width: 480px) {\n    flex-grow: ",";\n    text-align: left;\n  }\n  @media (max-width: 479px) {\n    padding-bottom: 15px;\n  }\n"],["\n  direction: ",";\n  font-size: ",";\n  line-height: 1.5;\n  text-align: center;\n\n  @media (min-width: 480px) {\n    flex-grow: ",";\n    text-align: left;\n  }\n  @media (max-width: 479px) {\n    padding-bottom: 15px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: ",";\n"],["\n  flex-grow: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import AnimationWrapper from "../AnimationWrapper";
var SwitchWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.direction;});var SwitchHeading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.direction;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.direction==="ltr"?1:0;});var ToggleWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.direction==="ltr"?0:1;});var initialState={fastPeriod:12,slowPeriod:26,period:9,strokeWidth:2,macdWidth:2,color:"#feac00",macdColor:"#fe003c",likeAPro:true};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"MACD");var MACDPopup=function MACDPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Fast MA"),name:"fastPeriod",value:props.indicator.fastPeriod,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.fastPeriod}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Slow MA"),name:"slowPeriod",value:props.indicator.slowPeriod,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.slowPeriod}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Signal line"),name:"period",value:props.indicator.period,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Signal color"),name:"color",value:props.indicator.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Signal width"),name:"strokeWidth",value:props.indicator.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SwitchHeading,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"MACD PRO mode")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToggleTool__["a" /* default */],{value:props.indicator.likeAPro,onChange:function onChange(){return props.handleAsIsChange({target:{name:"likeAPro",value:!props.indicator.likeAPro}});}}))),!props.indicator.likeAPro&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"MACD color"),name:"macdColor",value:props.indicator.macdColor,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"MACD width"),name:"macdWidth",value:props.indicator.macdWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange})));};/* harmony default export */ __webpack_exports__["a"] = (MACDPopup);

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return indicatorTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(95);
var _templateObject=_taggedTemplateLiteral([""," Period"],[""," Period"]),_templateObject2=_taggedTemplateLiteral(["Slowing"],["Slowing"]),_templateObject3=_taggedTemplateLiteral(["Overbought"],["Overbought"]),_templateObject4=_taggedTemplateLiteral(["Oversold"],["Oversold"]),_templateObject5=_taggedTemplateLiteral([""," Color"],[""," Color"]),_templateObject6=_taggedTemplateLiteral(["Width of lines"],["Width of lines"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var initialState={periodK:5,periodD:3,algorithm:"EMA",slowing:3,strokeWidth:1,colorK:"#39ae00",colorD:"#fe003c",overbought:80,oversold:20};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Stochastic Oscillator");var StochasticPopup=function StochasticPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:props.gettext(_templateObject,"%K"),name:"periodK",value:props.indicator.periodK,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.periodK}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:props.gettext(_templateObject,"%D"),name:"periodD",value:props.indicator.periodD,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.periodD}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:props.gettext(_templateObject2),name:"slowing",value:props.indicator.slowing,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.slowing}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:props.gettext(_templateObject3),name:"overbought",value:props.indicator.overbought,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.overbought}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:props.gettext(_templateObject4),name:"oversold",value:props.indicator.oversold,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.oversold}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["e" /* SelectColor */],{label:props.gettext(_templateObject5,"%K"),name:"colorK",value:props.indicator.colorK,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["e" /* SelectColor */],{label:props.gettext(_templateObject5,"%D"),name:"colorD",value:props.indicator.colorD,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["f" /* SelectWidth */],{label:props.gettext(_templateObject6),name:"strokeWidth",value:props.indicator.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["g" /* withGettext */])(StochasticPopup));

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return indicatorTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Popup__ = __webpack_require__(95);
var initialState={period:14,strokeWidth:1,color:"#feac00"};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"ROC (Rate of Change)");var ROCPopup=function ROCPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Period"),name:"period",value:props.indicator.period,onChange:props.handleNumberChange,invalid:props.errors&&props.errors.period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Colour"),name:"color",value:props.indicator.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Gettext__["b" /* default */],null,"Width of lines"),name:"strokeWidth",value:props.indicator.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}));};/* harmony default export */ __webpack_exports__["a"] = (ROCPopup);

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_binary_search__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_binary_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_binary_search__);
function magnify(dataset,sample,compare){// Для поиска нужной точки в кеше мы используем бинарный поиск.
var potentialIndex=__WEBPACK_IMPORTED_MODULE_0_binary_search___default()(dataset,sample,compare);// Если бинарный поиск не нашёл точный результат, он возвращает
// индекс, где этот результат должен был лежать, только в виде от-
// рицательного заначения.
// Нам неточный результат тоже сгодится.
var index=potentialIndex>0?potentialIndex:-potentialIndex;return dataset[index-1];}/* harmony default export */ __webpack_exports__["a"] = (magnify);

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return indicatorTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__ = __webpack_require__(166);
var initialState={accelerationFactor:0.02,accelerationStep:0.02,accelerationMaxValue:0.2,color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][0],size:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][1]};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Parabolic SAR");var Info=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToolsContent__["b" /* InfoBlock */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Parabolic SAR is similar to Moving Average but moves with higher boost and can change its position corresponding to the current price. ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Link__["a" /* Link */],{to:"/helpdesk/knowledge_base#kb_i"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Learn more about the indicator."))));var ParabolicSARPopup=function ParabolicSARPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Step"),name:"accelerationStep",value:props.indicator.accelerationStep,onChange:props.handleAsIsChange,invalid:props.errors&&props.errors.accelerationStep}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Maximum step"),name:"accelerationMaxValue",value:props.indicator.accelerationMaxValue,onChange:props.handleAsIsChange,invalid:props.errors&&props.errors.accelerationMaxValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"color",value:props.indicator.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Point size"),name:"size",value:props.indicator.size,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleAsIsChange}));};/* harmony default export */ __webpack_exports__["b"] = (ParabolicSARPopup);

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UnitedHeader__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shared_styles__ = __webpack_require__(152);
var HistoryPage=function HistoryPage(_ref){var title=_ref.title,children=_ref.children,type=_ref.type;var header=type==="widget"?null:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__UnitedHeader__["b" /* default */],null);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_styles__["d" /* Container */],null,header,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_styles__["e" /* ContainerInner */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_styles__["j" /* Top */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__shared_styles__["i" /* Title */],null,title)),children));};/* harmony default export */ __webpack_exports__["a"] = (HistoryPage);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_datepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_datepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_styles__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker_dist_react_datepicker_css__ = __webpack_require__(2010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_datepicker_dist_react_datepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_datepicker_dist_react_datepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  justify-content: flex-start;\n  align-content: flex-start;\n\n  @media (min-width: 960px) {\n    max-width: ",";\n  }\n\n  @media (max-width: 959px) {\n    flex: 1 0 auto;\n    margin-right: 6px;\n  }\n\n  @media (max-width: 414px) {\n    margin-right: 4px;\n  }\n  @media (max-width: 360px) {\n    margin: 5px auto;\n  }\n"],["\n  direction: ",";\n  justify-content: flex-start;\n  align-content: flex-start;\n\n  @media (min-width: 960px) {\n    max-width: ",";\n  }\n\n  @media (max-width: 959px) {\n    flex: 1 0 auto;\n    margin-right: 6px;\n  }\n\n  @media (max-width: 414px) {\n    margin-right: 4px;\n  }\n  @media (max-width: 360px) {\n    margin: 5px auto;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  height: 2px;\n  width: 16px;\n  margin: 0 10px;\n  background-color: #b5b5b5;\n\n  @media (max-width: 479px) {\n    display: none;\n  }\n"],["\n  height: 2px;\n  width: 16px;\n  margin: 0 10px;\n  background-color: #b5b5b5;\n\n  @media (max-width: 479px) {\n    display: none;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  background: none;\n  max-width: 139px;\n  height: 40px;\n  padding: 0 39px 0 11px;\n  font-size: 16px;\n  color: ",";\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  ",";\n  cursor: default;\n\n  @media (max-width: 959px) {\n    max-width: 8em;\n    height: 2.25em;\n    padding-left: 0.625em;\n    padding-right: 2.125em;\n    font-size: 16px;\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 414px) {\n    max-width: 5.786em;\n    padding: 0 4px;\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"],["\n  background: none;\n  max-width: 139px;\n  height: 40px;\n  padding: 0 39px 0 11px;\n  font-size: 16px;\n  color: ",";\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  ",";\n  cursor: default;\n\n  @media (max-width: 959px) {\n    max-width: 8em;\n    height: 2.25em;\n    padding-left: 0.625em;\n    padding-right: 2.125em;\n    font-size: 16px;\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 414px) {\n    max-width: 5.786em;\n    padding: 0 4px;\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n          background-color: ",";\n        "],["\n          background-color: ",";\n        "]),_templateObject5=_taggedTemplateLiteral(["\n          box-shadow: inset 0 2px 0 0 #ebebeb;\n        "],["\n          box-shadow: inset 0 2px 0 0 #ebebeb;\n        "]),_templateObject6=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  font-weight: 400;\n  background: #fff;\n\n  &:not(:last-of-type) {\n    @media (max-width: 959px) {\n      ",";\n    }\n\n    @media (max-width: 479px) {\n      ",";\n    }\n  }\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  font-weight: 400;\n  background: #fff;\n\n  &:not(:last-of-type) {\n    @media (max-width: 959px) {\n      ",";\n    }\n\n    @media (max-width: 479px) {\n      ",";\n    }\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 21px;\n  height: 20px;\n  cursor: pointer;\n  pointer-events: none;\n\n  @media (max-width: 959px) {\n    right: 6px;\n  }\n\n  @media (max-width: 479px) {\n    display: none;\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  width: 21px;\n  height: 20px;\n  cursor: pointer;\n  pointer-events: none;\n\n  @media (max-width: 959px) {\n    right: 6px;\n  }\n\n  @media (max-width: 479px) {\n    display: none;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__shared_styles__["f" /* Flex */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},function(props){return props.headerWidth?"322px":"auto";});var Separator=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2);var DateInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.calendarInputColor?theme.calendarInputColor+" !important":"#4e2a81";},function(_ref3){var theme=_ref3.theme;return theme.calendarBackground?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,theme.mainDark):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14));var PickerView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("margin-right","6px"),Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("margin-right","4px"));var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject7);function _Picker(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PickerView,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_datepicker___default.a,Object.assign({dateFormat:"dd.MM.yyyy",maxDate:new Date()},props)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 21 20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fillRule:"evenodd",fill:"rgb(165, 164, 164)",d:"M0.000,20.000 L0.000,2.026 L4.015,2.026 L4.015,-0.001 L5.985,-0.001 L5.985,2.026 L15.005,2.026 L15.005,-0.001 L17.006,-0.001 L17.006,2.025 L21.014,2.025 L21.014,20.000 L0.000,20.000 ZM19.002,3.972 L17.006,3.972 L17.006,4.987 L15.005,4.987 L15.005,3.972 L5.985,3.972 L5.985,4.987 L4.015,4.987 L4.015,3.972 L1.998,3.972 L1.998,17.957 L19.002,17.957 L19.002,3.972 ZM6.989,10.962 L3.988,10.962 L3.988,7.995 L6.989,7.995 L6.989,10.962 ZM6.989,15.962 L3.988,15.962 L3.988,12.995 L6.989,12.995 L6.989,15.962 ZM11.989,10.962 L8.988,10.962 L8.988,7.995 L11.989,7.995 L11.989,10.962 ZM11.989,15.962 L8.988,15.962 L8.988,12.995 L11.989,12.995 L11.989,15.962 ZM16.989,10.962 L13.988,10.962 L13.988,7.995 L16.989,7.995 L16.989,10.962 ZM16.989,15.962 L13.988,15.962 L13.988,12.995 L16.989,12.995 L16.989,15.962 Z"})));}var mapStateToProps=function mapStateToProps(state){return{locale:Object(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["e" /* inferMomentLocale */])(state)};};var Picker=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(_Picker);var CustomInputToDisableMobileKeyboards=function CustomInputToDisableMobileKeyboards(_ref4){var value=_ref4.value,onClick=_ref4.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DateInput,{onClick:onClick},value);};var Period=function Period(_ref5){var windowWidth=_ref5.windowWidth,headerWidth=_ref5.headerWidth,startDate=_ref5.startDate,endDate=_ref5.endDate,updateState=_ref5.updateState;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{headerWidth:headerWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__shared_styles__["g" /* Header */],{headerWidth:headerWidth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Period"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picker,{withPortal:windowWidth<=959,className:"needsclick",selected:startDate.valueOf(),selectsStart:true,startDate:startDate.valueOf(),endDate:endDate.valueOf(),onChange:function onChange(value){return updateState({key:"startDate",value:value});},customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomInputToDisableMobileKeyboards,null)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Separator,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Picker,{withPortal:windowWidth<=959,className:"needsclick",selected:endDate.valueOf(),selectsEnd:true,startDate:startDate.valueOf(),endDate:endDate.valueOf(),onChange:function onChange(value){return updateState({key:"endDate",value:value});},popoverAttachment:"top right",popoverTargetAttachment:"bottom right",customInput:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CustomInputToDisableMobileKeyboards,null)}));};/* harmony default export */ __webpack_exports__["a"] = (Period);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SelectsContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shared_styles__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  margin-left: auto;\n\n  :not(:first-of-type) {\n    margin-right: auto;\n  }\n\n  @media (min-width: 960px) {\n    max-width: ",";\n  }\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  @media (min-width: 667px) and (max-width: 959px) {\n    :not(:first-of-type) {\n      margin-left: 0.286em;\n    }\n  }\n\n  @media (min-width: 480px) and (max-width: 666px) {\n    :first-of-type {\n      margin-bottom: 0.286em;\n    }\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 0.286em;\n  }\n"],["\n  direction: ",";\n  margin-left: auto;\n\n  :not(:first-of-type) {\n    margin-right: auto;\n  }\n\n  @media (min-width: 960px) {\n    max-width: ",";\n  }\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    align-items: flex-start;\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  @media (min-width: 667px) and (max-width: 959px) {\n    :not(:first-of-type) {\n      margin-left: 0.286em;\n    }\n  }\n\n  @media (min-width: 480px) and (max-width: 666px) {\n    :first-of-type {\n      margin-bottom: 0.286em;\n    }\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    align-items: center;\n    width: 100%;\n    margin-bottom: 0.286em;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex: 1;\n\n  @media (min-width: 667px) {\n    display: flex;\n  }\n\n  @media (min-width: 960px) {\n    flex-direction: row;\n    flex-shrink: 0;\n  }\n"],["\n  flex: 1;\n\n  @media (min-width: 667px) {\n    display: flex;\n  }\n\n  @media (min-width: 960px) {\n    flex-direction: row;\n    flex-shrink: 0;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: block;\n\n  @media (max-width: 959px) {\n    padding-left: 0.286em;\n    font-size: ",";\n    line-height: 1.125em;\n    color: #717171;\n  }\n\n  @media (max-width: 666px) {\n    font-size: ",";\n  }\n\n  @media (min-width: 480px) and (max-width: 666px) {\n    margin-bottom: 0.286em;\n  }\n\n  @media (max-width: 479px) {\n    margin-right: 0;\n    padding-left: 0;\n    flex: 0 1 30%;\n  }\n"],["\n  display: block;\n\n  @media (max-width: 959px) {\n    padding-left: 0.286em;\n    font-size: ",";\n    line-height: 1.125em;\n    color: #717171;\n  }\n\n  @media (max-width: 666px) {\n    font-size: ",";\n  }\n\n  @media (min-width: 480px) and (max-width: 666px) {\n    margin-bottom: 0.286em;\n  }\n\n  @media (max-width: 479px) {\n    margin-right: 0;\n    padding-left: 0;\n    flex: 0 1 30%;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  @media (max-width: 479px) {\n    flex: 1 1 auto;\n  }\n"],["\n  @media (max-width: 479px) {\n    flex: 1 1 auto;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__shared_styles__["f" /* Flex */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},function(props){return props.headerWidth?"180px":"auto";});var SelectsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Header=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__shared_styles__["g" /* Header */])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);function HistorySelect(_ref2){var children=_ref2.children,headerWidth=_ref2.headerWidth,props=_objectWithoutProperties(_ref2,["children","headerWidth"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{headerWidth:headerWidth},children&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,{headerWidth:headerWidth},children),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,{className:"needsclick"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */],props)));}/* harmony default export */ __webpack_exports__["b"] = (HistorySelect);

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_styles__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  justify-content: flex-start;\n  min-height: 94px;\n  padding: 0 30px;\n\n  @media (min-width: 960px) and (-ms-high-contrast: none),\n    (-ms-high-contrast: active) {\n    height: 94px;\n  }\n\n  @media (max-width: 959px) {\n    justify-content: space-around;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: auto;\n    padding: 0;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n"],["\n  direction: ",";\n  justify-content: flex-start;\n  min-height: 94px;\n  padding: 0 30px;\n\n  @media (min-width: 960px) and (-ms-high-contrast: none),\n    (-ms-high-contrast: active) {\n    height: 94px;\n  }\n\n  @media (max-width: 959px) {\n    justify-content: space-around;\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: auto;\n    padding: 0;\n  }\n\n  @media (max-width: 479px) {\n    flex-direction: row;\n    justify-content: flex-start;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  font-size: ",";\n  line-height: 1.125em;\n  color: #717171;\n\n  :not(:last-of-type) {\n    ",";\n  }\n\n  :last-of-type {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    text-align: center;\n\n    :not(:last-of-type),\n    :last-of-type {\n      ",";\n    }\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    width: 100%;\n    text-align: left;\n\n    :not(:first-of-type) {\n      padding-top: 11px;\n    }\n  }\n\n  @media (max-width: 414px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"],["\n  direction: ",";\n  font-size: ",";\n  line-height: 1.125em;\n  color: #717171;\n\n  :not(:last-of-type) {\n    ",";\n  }\n\n  :last-of-type {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    text-align: center;\n\n    :not(:last-of-type),\n    :last-of-type {\n      ",";\n    }\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    position: relative;\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: row;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    width: 100%;\n    text-align: left;\n\n    :not(:first-of-type) {\n      padding-top: 11px;\n    }\n  }\n\n  @media (max-width: 414px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  @media (max-width: 479px) {\n    flex: 0 1 30%;\n  }\n"],["\n  @media (max-width: 479px) {\n    flex: 0 1 30%;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1;\n  color: ",";\n\n  ",";\n  @media (max-width: 959px) {\n    display: block;\n    width: 100%;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 0.643em 0;\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    flex: 1 1 auto;\n    display: inline-block;\n    width: auto;\n    padding: 0;\n    padding-left: 0.786em;\n  }\n\n  @media (max-width: 414px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"],["\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1;\n  color: ",";\n\n  ",";\n  @media (max-width: 959px) {\n    display: block;\n    width: 100%;\n    font-weight: 700;\n    font-size: 16px;\n    padding: 0.643em 0;\n  }\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    flex: 1 1 auto;\n    display: inline-block;\n    width: auto;\n    padding: 0;\n    padding-left: 0.786em;\n  }\n\n  @media (max-width: 414px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n      font-weight: 400;\n      color: #4e2a81;\n    "],["\n      font-weight: 400;\n      color: #4e2a81;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Stats=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__shared_styles__["f" /* Flex */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;});var Block=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-right","2.438em"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-right","auto"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-right","0"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14));var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject3);var Item=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.money||"#000";},function(props){return props.primary&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14));function StatsBlock(_ref3){var children=_ref3.children,_ref3$amount=_ref3.amount,amount=_ref3$amount===undefined?0:_ref3$amount;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Block,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,children,":")," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],null,amount)));}function Statistics(_ref4){var profile=_ref4.profile,accounts=_ref4.accounts,children=_ref4.children;var active_account_id=profile.active_account_id;var currentAccount=accounts.find(function(_ref5){var id=_ref5.id;return id===active_account_id;});var type="demo";if(currentAccount!==undefined&&currentAccount!==null){type=currentAccount.type;}var deposit=type==="demo"?"refill_sum":"deposit";if(profile){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Stats,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatsBlock,{amount:profile.finance[deposit]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Investments")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatsBlock,{amount:profile.finance.withdraw},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Withdrawal")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StatsBlock,{amount:profile.balance[type]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Balance")),children);}return null;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withData__["a" /* default */])(["profile","accounts"])(Statistics));

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pagination__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NoData__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_styles__ = __webpack_require__(152);
var _templateObject=_taggedTemplateLiteral(["\n  margin-top: 34px;\n  margin-bottom: 30px;\n\n  ",";\n\n  ","\n"],["\n  margin-top: 34px;\n  margin-bottom: 30px;\n\n  ",";\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n      :before {\n        content: \"\";\n        position: absolute;\n        top: -34px;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 880px;\n        border-top: 1px solid ",";\n\n        @media (max-width: 959px) {\n          width: 100%;\n          left: 0;\n          transform: translateX(0);\n        }\n      }\n    "],["\n      :before {\n        content: \"\";\n        position: absolute;\n        top: -34px;\n        left: 50%;\n        transform: translateX(-50%);\n        width: 880px;\n        border-top: 1px solid ",";\n\n        @media (max-width: 959px) {\n          width: 100%;\n          left: 0;\n          transform: translateX(0);\n        }\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      :after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        height: 100%;\n        background: hsla(0, 0%, 100%, 0.8);\n        transition: 0.3s;\n      }\n    "],["\n      :after {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n        height: 100%;\n        background: hsla(0, 0%, 100%, 0.8);\n        transition: 0.3s;\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  font-size: 26px;\n  z-index: 1;\n"],["\n  position: absolute;\n  font-size: 26px;\n  z-index: 1;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  width: 100%;\n  ","\n"],["\n  width: 100%;\n  ","\n"]),_templateObject6=_taggedTemplateLiteral(["\n      max-height: 400px;\n      overflow-x: hidden;\n\n      table th {\n        position: sticky;\n        top: 0;\n        z-index: 2;\n        background-color: ",";\n      }\n    "],["\n      max-height: 400px;\n      overflow-x: hidden;\n\n      table th {\n        position: sticky;\n        top: 0;\n        z-index: 2;\n        background-color: ",";\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  width: 100%;\n"],["\n  width: 100%;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: ",";\n  text-transform: uppercase;\n  color: #a5a4a4;\n  box-shadow: none;\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 414px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"],["\n  font-weight: 400;\n  font-size: ",";\n  text-transform: uppercase;\n  color: #a5a4a4;\n  box-shadow: none;\n\n  @media (max-width: 640px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 414px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 360px) {\n    font-size: ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  padding: 5px;\n"],["\n  padding: 5px;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  border-bottom: 1px solid #fff;\n\n  &:nth-child(odd) {\n    background-color: ",";\n    border-bottom: 1px solid\n      ",";\n  }\n  &:nth-child(even) {\n    background-color: ",";\n    border-bottom: 1px solid\n      ",";\n  }\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.25);\n  }\n  ","\n"],["\n  border-bottom: 1px solid #fff;\n\n  &:nth-child(odd) {\n    background-color: ",";\n    border-bottom: 1px solid\n      ",";\n  }\n  &:nth-child(even) {\n    background-color: ",";\n    border-bottom: 1px solid\n      ",";\n  }\n  &:hover {\n    background-color: rgba(255, 255, 255, 0.25);\n  }\n  ","\n"]),_templateObject11=_taggedTemplateLiteral(["\n      cursor: pointer;\n    "],["\n      cursor: pointer;\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  min-height: 4.429em;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  color: ",";\n  padding: 15px 5px;\n"],["\n  min-height: 4.429em;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  color: ",";\n  padding: 15px 5px;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 20px 0;\n"],["\n  width: 100%;\n  padding: 20px 0;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__shared_styles__["f" /* Flex */])(_templateObject,function(props){return props.showDeposit&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(_ref){var theme=_ref.theme;return theme.tableBefore||"#cccccc";});},function(props){return props.loading&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var Spinner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Spinners_SimpleSpinner__["c" /* default */])(_templateObject4);var TableWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.type==="widget"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(_ref2){var theme=_ref2.theme;return theme.tableRowOdd?theme.mainHighlight:"#f5f5f5";});});var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].table(_templateObject7);var THead=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].thead(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(10),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12),Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(10));var TableHeadRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].th(_templateObject9);var TableRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].tr(_templateObject10,function(_ref3){var theme=_ref3.theme;return theme.tableRowOdd?theme.mainHighlight:"#f6f6f6";},function(_ref4){var theme=_ref4.theme;return theme.tableCellBorder||"#ffffff";},function(_ref5){var theme=_ref5.theme;return theme.tableRowEven?theme.mainDark:"#efefef";},function(_ref6){var theme=_ref6.theme;return theme.tableCellBorder||"#ffffff";},function(props){return props.clickable&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);});var TableCol=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].td(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref7){var theme=_ref7.theme;return theme.tableCellColor||"#717171";});var PaginationWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);function HistoryTable(props){var showDeposit=props.showDeposit,columns=props.columns,errorText=props.errorText,startDate=props.startDate,endDate=props.endDate,data=props.data,onClick=props.onClick,loading=props.loading,rest=_objectWithoutProperties(props,["showDeposit","columns","errorText","startDate","endDate","data","onClick","loading"]);var dataWithShortCryptoIndex=data.map(function(item){if(item.stock&&item.stock.toLowerCase()==="cryptoindex"){item.stock="CRYPTO";}return item;});var makeColumns=function makeColumns(row){return columns.map(function(column,i){return column.show!==false&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCol,{key:i,style:column.style},column.Cell?column.Cell({row:row}):row[column.accessor]);});};var TableHead=function TableHead(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](THead,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tr",null,columns.map(function(column,i){return column.show!==false&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableHeadRow,{key:i,show:column.show},column.Header);})));};var TableBody=function TableBody(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("tbody",null,dataWithShortCryptoIndex.map(function(element,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableRow,{clickable:onClick?true:false,key:index,onClick:onClick?function(){return onClick(element);}:function(){return false;}},makeColumns(element));}));};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{showDeposit:showDeposit,loading:loading},loading&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Spinner,{accent:true}),data.length===0?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__NoData__["a" /* default */],{loading:loading,error:errorText,startDate:startDate,endDate:endDate}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableWrapper,{type:rest.type},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Table,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableHead,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableBody,null))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PaginationWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Pagination__["a" /* default */],{page:rest.page,pages:rest.pages,pageSize:rest.pageSize,onPageChange:rest.onPageChange,onPageSizeChange:rest.onPageSizeChange}))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__common_withDeposit__["b" /* withDeposit */])(HistoryTable));

/***/ }),
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(881);
module.exports = __webpack_require__(886);


/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(882).enable();
  window.Promise = __webpack_require__(884);
}

// fetch() polyfill for making API calls.
__webpack_require__(885);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(230);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(493);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(493);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 885 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sentry_browser__ = __webpack_require__(2048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__ = __webpack_require__(2080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__registerServiceWorkerForElectron__ = __webpack_require__(2081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css__ = __webpack_require__(2082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__index_css__);
startSentry();__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */],null),document.getElementById("root"));function startSentry(){try{if(true){__WEBPACK_IMPORTED_MODULE_4__sentry_browser__["a" /* init */]({dsn:window.SENTRY_DSN,environment:window.SENTRY_ENV,release:window.SENTRY_REL});}}catch(error){console.log("Init error Sentry service",error);}}function isElectron(){var userAgent=navigator.userAgent.toLowerCase();return userAgent.indexOf(" electron/")>-1;}if(isElectron()){Object(__WEBPACK_IMPORTED_MODULE_6__registerServiceWorkerForElectron__["a" /* default */])();}else{Object(__WEBPACK_IMPORTED_MODULE_5__registerServiceWorker__["a" /* default */])();}

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(888);

__webpack_require__(1085);

__webpack_require__(1086);

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(889);
__webpack_require__(891);
__webpack_require__(892);
__webpack_require__(893);
__webpack_require__(894);
__webpack_require__(895);
__webpack_require__(896);
__webpack_require__(897);
__webpack_require__(898);
__webpack_require__(899);
__webpack_require__(900);
__webpack_require__(901);
__webpack_require__(902);
__webpack_require__(903);
__webpack_require__(904);
__webpack_require__(905);
__webpack_require__(907);
__webpack_require__(908);
__webpack_require__(909);
__webpack_require__(910);
__webpack_require__(911);
__webpack_require__(912);
__webpack_require__(913);
__webpack_require__(914);
__webpack_require__(915);
__webpack_require__(916);
__webpack_require__(917);
__webpack_require__(918);
__webpack_require__(919);
__webpack_require__(920);
__webpack_require__(921);
__webpack_require__(922);
__webpack_require__(923);
__webpack_require__(924);
__webpack_require__(925);
__webpack_require__(926);
__webpack_require__(927);
__webpack_require__(928);
__webpack_require__(929);
__webpack_require__(930);
__webpack_require__(931);
__webpack_require__(932);
__webpack_require__(933);
__webpack_require__(934);
__webpack_require__(935);
__webpack_require__(936);
__webpack_require__(937);
__webpack_require__(938);
__webpack_require__(939);
__webpack_require__(940);
__webpack_require__(941);
__webpack_require__(942);
__webpack_require__(943);
__webpack_require__(944);
__webpack_require__(945);
__webpack_require__(946);
__webpack_require__(947);
__webpack_require__(948);
__webpack_require__(949);
__webpack_require__(950);
__webpack_require__(951);
__webpack_require__(952);
__webpack_require__(953);
__webpack_require__(954);
__webpack_require__(955);
__webpack_require__(956);
__webpack_require__(957);
__webpack_require__(958);
__webpack_require__(959);
__webpack_require__(960);
__webpack_require__(961);
__webpack_require__(962);
__webpack_require__(963);
__webpack_require__(964);
__webpack_require__(965);
__webpack_require__(966);
__webpack_require__(967);
__webpack_require__(969);
__webpack_require__(970);
__webpack_require__(972);
__webpack_require__(973);
__webpack_require__(974);
__webpack_require__(975);
__webpack_require__(976);
__webpack_require__(977);
__webpack_require__(978);
__webpack_require__(980);
__webpack_require__(981);
__webpack_require__(982);
__webpack_require__(983);
__webpack_require__(984);
__webpack_require__(985);
__webpack_require__(986);
__webpack_require__(987);
__webpack_require__(988);
__webpack_require__(989);
__webpack_require__(990);
__webpack_require__(991);
__webpack_require__(992);
__webpack_require__(345);
__webpack_require__(993);
__webpack_require__(994);
__webpack_require__(512);
__webpack_require__(995);
__webpack_require__(996);
__webpack_require__(997);
__webpack_require__(998);
__webpack_require__(999);
__webpack_require__(515);
__webpack_require__(517);
__webpack_require__(518);
__webpack_require__(1000);
__webpack_require__(1001);
__webpack_require__(1002);
__webpack_require__(1003);
__webpack_require__(1004);
__webpack_require__(1005);
__webpack_require__(1006);
__webpack_require__(1007);
__webpack_require__(1008);
__webpack_require__(1009);
__webpack_require__(1010);
__webpack_require__(1011);
__webpack_require__(1012);
__webpack_require__(1013);
__webpack_require__(1014);
__webpack_require__(1015);
__webpack_require__(1016);
__webpack_require__(1017);
__webpack_require__(1018);
__webpack_require__(1019);
__webpack_require__(1020);
__webpack_require__(1021);
__webpack_require__(1022);
__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
__webpack_require__(1026);
__webpack_require__(1027);
__webpack_require__(1028);
__webpack_require__(1029);
__webpack_require__(1030);
__webpack_require__(1031);
__webpack_require__(1032);
__webpack_require__(1033);
__webpack_require__(1034);
__webpack_require__(1035);
__webpack_require__(1036);
__webpack_require__(1037);
__webpack_require__(1038);
__webpack_require__(1039);
__webpack_require__(1040);
__webpack_require__(1041);
__webpack_require__(1042);
__webpack_require__(1043);
__webpack_require__(1044);
__webpack_require__(1045);
__webpack_require__(1046);
__webpack_require__(1047);
__webpack_require__(1048);
__webpack_require__(1049);
__webpack_require__(1050);
__webpack_require__(1051);
__webpack_require__(1052);
__webpack_require__(1053);
__webpack_require__(1054);
__webpack_require__(1055);
__webpack_require__(1056);
__webpack_require__(1057);
__webpack_require__(1058);
__webpack_require__(1059);
__webpack_require__(1060);
__webpack_require__(1061);
__webpack_require__(1062);
__webpack_require__(1063);
__webpack_require__(1064);
__webpack_require__(1065);
__webpack_require__(1066);
__webpack_require__(1067);
__webpack_require__(1068);
__webpack_require__(1069);
__webpack_require__(1070);
__webpack_require__(1071);
__webpack_require__(1072);
__webpack_require__(1073);
__webpack_require__(1074);
__webpack_require__(1075);
__webpack_require__(1076);
__webpack_require__(1077);
__webpack_require__(1078);
__webpack_require__(1079);
__webpack_require__(1080);
__webpack_require__(1081);
__webpack_require__(1082);
__webpack_require__(1083);
__webpack_require__(1084);
module.exports = __webpack_require__(72);


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(17);
var has = __webpack_require__(66);
var DESCRIPTORS = __webpack_require__(33);
var $export = __webpack_require__(3);
var redefine = __webpack_require__(60);
var META = __webpack_require__(112).KEY;
var $fails = __webpack_require__(20);
var shared = __webpack_require__(231);
var setToStringTag = __webpack_require__(153);
var uid = __webpack_require__(125);
var wks = __webpack_require__(28);
var wksExt = __webpack_require__(495);
var wksDefine = __webpack_require__(325);
var enumKeys = __webpack_require__(890);
var isArray = __webpack_require__(234);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(21);
var toIObject = __webpack_require__(67);
var toPrimitive = __webpack_require__(83);
var createDesc = __webpack_require__(124);
var _create = __webpack_require__(128);
var gOPNExt = __webpack_require__(498);
var $GOPD = __webpack_require__(68);
var $DP = __webpack_require__(34);
var $keys = __webpack_require__(126);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(129).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(183).f = $propertyIsEnumerable;
  __webpack_require__(233).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(113)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(59)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(126);
var gOPS = __webpack_require__(233);
var pIE = __webpack_require__(183);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(128) });


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperty: __webpack_require__(34).f });


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(33), 'Object', { defineProperties: __webpack_require__(497) });


/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(67);
var $getOwnPropertyDescriptor = __webpack_require__(68).f;

__webpack_require__(86)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(42);
var $getPrototypeOf = __webpack_require__(69);

__webpack_require__(86)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(42);
var $keys = __webpack_require__(126);

__webpack_require__(86)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(86)('getOwnPropertyNames', function () {
  return __webpack_require__(498).f;
});


/***/ }),
/* 898 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(21);
var meta = __webpack_require__(112).onFreeze;

__webpack_require__(86)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(21);
var meta = __webpack_require__(112).onFreeze;

__webpack_require__(86)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 900 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(21);
var meta = __webpack_require__(112).onFreeze;

__webpack_require__(86)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 901 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(21);

__webpack_require__(86)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(21);

__webpack_require__(86)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(21);

__webpack_require__(86)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(3);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(499) });


/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { is: __webpack_require__(906) });


/***/ }),
/* 906 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(3);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(329).set });


/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(184);
var test = {};
test[__webpack_require__(28)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(60)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(3);

$export($export.P, 'Function', { bind: __webpack_require__(500) });


/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(34).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(33) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(21);
var getPrototypeOf = __webpack_require__(69);
var HAS_INSTANCE = __webpack_require__(28)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(34).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(502);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(503);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(17);
var has = __webpack_require__(66);
var cof = __webpack_require__(74);
var inheritIfRequired = __webpack_require__(331);
var toPrimitive = __webpack_require__(83);
var fails = __webpack_require__(20);
var gOPN = __webpack_require__(129).f;
var gOPD = __webpack_require__(68).f;
var dP = __webpack_require__(34).f;
var $trim = __webpack_require__(154).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(128)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(33) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(60)(global, NUMBER, $Number);
}


/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toInteger = __webpack_require__(85);
var aNumberValue = __webpack_require__(504);
var repeat = __webpack_require__(332);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(20)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $fails = __webpack_require__(20);
var aNumberValue = __webpack_require__(504);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(3);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(3);
var _isFinite = __webpack_require__(17).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', { isInteger: __webpack_require__(505) });


/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(3);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(3);
var isInteger = __webpack_require__(505);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(3);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseFloat = __webpack_require__(503);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 925 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $parseInt = __webpack_require__(502);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(3);
var log1p = __webpack_require__(506);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(3);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(3);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(3);
var sign = __webpack_require__(333);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(3);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(3);
var $expm1 = __webpack_require__(334);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { fround: __webpack_require__(507) });


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(3);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(3);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(20)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { log1p: __webpack_require__(506) });


/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', { sign: __webpack_require__(333) });


/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(334);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(20)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(3);
var expm1 = __webpack_require__(334);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toAbsoluteIndex = __webpack_require__(127);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(67);
var toLength = __webpack_require__(35);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(154)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(335)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(336)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $at = __webpack_require__(335)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(35);
var context = __webpack_require__(338);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(339)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(3);
var context = __webpack_require__(338);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(339)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(332)
});


/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(3);
var toLength = __webpack_require__(35);
var context = __webpack_require__(338);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(339)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(61)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(61)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(61)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(61)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(61)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(61)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(61)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(61)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(61)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 961 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(61)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(61)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(61)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(61)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 965 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(3);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(42);
var toPrimitive = __webpack_require__(83);

$export($export.P + $export.F * __webpack_require__(20)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 967 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(3);
var toISOString = __webpack_require__(968);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(20);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 969 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(60)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(28)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(59)(proto, TO_PRIMITIVE, __webpack_require__(971));


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(83);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(3);

$export($export.S, 'Array', { isArray: __webpack_require__(234) });


/***/ }),
/* 973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(73);
var $export = __webpack_require__(3);
var toObject = __webpack_require__(42);
var call = __webpack_require__(508);
var isArrayIter = __webpack_require__(340);
var toLength = __webpack_require__(35);
var createProperty = __webpack_require__(341);
var getIterFn = __webpack_require__(342);

$export($export.S + $export.F * !__webpack_require__(236)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var createProperty = __webpack_require__(341);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(20)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(3);
var toIObject = __webpack_require__(67);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(182) != Object || !__webpack_require__(75)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var html = __webpack_require__(328);
var cof = __webpack_require__(74);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(35);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(20)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var aFunction = __webpack_require__(47);
var toObject = __webpack_require__(42);
var fails = __webpack_require__(20);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(75)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $forEach = __webpack_require__(87)(0);
var STRICT = __webpack_require__(75)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(21);
var isArray = __webpack_require__(234);
var SPECIES = __webpack_require__(28)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $map = __webpack_require__(87)(1);

$export($export.P + $export.F * !__webpack_require__(75)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $filter = __webpack_require__(87)(2);

$export($export.P + $export.F * !__webpack_require__(75)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $some = __webpack_require__(87)(3);

$export($export.P + $export.F * !__webpack_require__(75)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $every = __webpack_require__(87)(4);

$export($export.P + $export.F * !__webpack_require__(75)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(509);

$export($export.P + $export.F * !__webpack_require__(75)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $reduce = __webpack_require__(509);

$export($export.P + $export.F * !__webpack_require__(75)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $indexOf = __webpack_require__(232)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(75)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toIObject = __webpack_require__(67);
var toInteger = __webpack_require__(85);
var toLength = __webpack_require__(35);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(75)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { copyWithin: __webpack_require__(510) });

__webpack_require__(114)('copyWithin');


/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(3);

$export($export.P, 'Array', { fill: __webpack_require__(344) });

__webpack_require__(114)('fill');


/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(87)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(114)(KEY);


/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(3);
var $find = __webpack_require__(87)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(114)(KEY);


/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(130)('Array');


/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(17);
var inheritIfRequired = __webpack_require__(331);
var dP = __webpack_require__(34).f;
var gOPN = __webpack_require__(129).f;
var isRegExp = __webpack_require__(235);
var $flags = __webpack_require__(237);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(33) && (!CORRECT_NEW || __webpack_require__(20)(function () {
  re2[__webpack_require__(28)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(60)(global, 'RegExp', $RegExp);
}

__webpack_require__(130)('RegExp');


/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(512);
var anObject = __webpack_require__(15);
var $flags = __webpack_require__(237);
var DESCRIPTORS = __webpack_require__(33);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(60)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(20)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

// @@match logic
__webpack_require__(238)('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});


/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

// @@replace logic
__webpack_require__(238)('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});


/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

// @@search logic
__webpack_require__(238)('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});


/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

// @@split logic
__webpack_require__(238)('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = __webpack_require__(235);
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});


/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(113);
var global = __webpack_require__(17);
var ctx = __webpack_require__(73);
var classof = __webpack_require__(184);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(21);
var aFunction = __webpack_require__(47);
var anInstance = __webpack_require__(131);
var forOf = __webpack_require__(132);
var speciesConstructor = __webpack_require__(239);
var task = __webpack_require__(346).set;
var microtask = __webpack_require__(347)();
var newPromiseCapabilityModule = __webpack_require__(348);
var perform = __webpack_require__(513);
var userAgent = __webpack_require__(240);
var promiseResolve = __webpack_require__(514);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(28)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(133)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(153)($Promise, PROMISE);
__webpack_require__(130)(PROMISE);
Wrapper = __webpack_require__(72)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(236)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(519);
var validate = __webpack_require__(156);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(241)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var $typed = __webpack_require__(242);
var buffer = __webpack_require__(349);
var anObject = __webpack_require__(15);
var toAbsoluteIndex = __webpack_require__(127);
var toLength = __webpack_require__(35);
var isObject = __webpack_require__(21);
var ArrayBuffer = __webpack_require__(17).ArrayBuffer;
var speciesConstructor = __webpack_require__(239);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(20)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(130)(ARRAY_BUFFER);


/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
$export($export.G + $export.W + $export.F * !__webpack_require__(242).ABV, {
  DataView: __webpack_require__(349).DataView
});


/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(100)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(3);
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(15);
var rApply = (__webpack_require__(17).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(20)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(3);
var create = __webpack_require__(128);
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(21);
var fails = __webpack_require__(20);
var bind = __webpack_require__(500);
var rConstruct = (__webpack_require__(17).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(34);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(15);
var toPrimitive = __webpack_require__(83);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(20)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(3);
var gOPD = __webpack_require__(68).f;
var anObject = __webpack_require__(15);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(15);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(337)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(68);
var getPrototypeOf = __webpack_require__(69);
var has = __webpack_require__(66);
var $export = __webpack_require__(3);
var isObject = __webpack_require__(21);
var anObject = __webpack_require__(15);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(68);
var $export = __webpack_require__(3);
var anObject = __webpack_require__(15);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(3);
var getProto = __webpack_require__(69);
var anObject = __webpack_require__(15);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(15);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(3);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(521) });


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(3);
var anObject = __webpack_require__(15);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(34);
var gOPD = __webpack_require__(68);
var getPrototypeOf = __webpack_require__(69);
var has = __webpack_require__(66);
var $export = __webpack_require__(3);
var createDesc = __webpack_require__(124);
var anObject = __webpack_require__(15);
var isObject = __webpack_require__(21);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(3);
var setProto = __webpack_require__(329);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(3);
var $includes = __webpack_require__(232)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(114)('includes');


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(522);
var toObject = __webpack_require__(42);
var toLength = __webpack_require__(35);
var aFunction = __webpack_require__(47);
var arraySpeciesCreate = __webpack_require__(343);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(114)('flatMap');


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = __webpack_require__(3);
var flattenIntoArray = __webpack_require__(522);
var toObject = __webpack_require__(42);
var toLength = __webpack_require__(35);
var toInteger = __webpack_require__(85);
var arraySpeciesCreate = __webpack_require__(343);

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

__webpack_require__(114)('flatten');


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/mathiasbynens/String.prototype.at
var $export = __webpack_require__(3);
var $at = __webpack_require__(335)(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(523);
var userAgent = __webpack_require__(240);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(3);
var $pad = __webpack_require__(523);
var userAgent = __webpack_require__(240);

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(154)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(154)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/String.prototype.matchAll/
var $export = __webpack_require__(3);
var defined = __webpack_require__(84);
var toLength = __webpack_require__(35);
var isRegExp = __webpack_require__(235);
var getFlags = __webpack_require__(237);
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

__webpack_require__(337)($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(325)('asyncIterator');


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(325)('observable');


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(3);
var ownKeys = __webpack_require__(521);
var toIObject = __webpack_require__(67);
var gOPD = __webpack_require__(68);
var createProperty = __webpack_require__(341);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $values = __webpack_require__(524)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(3);
var $entries = __webpack_require__(524)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(42);
var aFunction = __webpack_require__(47);
var $defineProperty = __webpack_require__(34);

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
__webpack_require__(33) && $export($export.P + __webpack_require__(243), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(42);
var aFunction = __webpack_require__(47);
var $defineProperty = __webpack_require__(34);

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
__webpack_require__(33) && $export($export.P + __webpack_require__(243), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});


/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(42);
var toPrimitive = __webpack_require__(83);
var getPrototypeOf = __webpack_require__(69);
var getOwnPropertyDescriptor = __webpack_require__(68).f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(243), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(3);
var toObject = __webpack_require__(42);
var toPrimitive = __webpack_require__(83);
var getPrototypeOf = __webpack_require__(69);
var getOwnPropertyDescriptor = __webpack_require__(68).f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
__webpack_require__(33) && $export($export.P + __webpack_require__(243), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});


/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(525)('Map') });


/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = __webpack_require__(3);

$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(525)('Set') });


/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
__webpack_require__(244)('Map');


/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
__webpack_require__(244)('Set');


/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
__webpack_require__(244)('WeakMap');


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
__webpack_require__(244)('WeakSet');


/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
__webpack_require__(245)('Map');


/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
__webpack_require__(245)('Set');


/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
__webpack_require__(245)('WeakMap');


/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
__webpack_require__(245)('WeakSet');


/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.G, { global: __webpack_require__(17) });


/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(3);

$export($export.S, 'System', { global: __webpack_require__(17) });


/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/ljharb/proposal-is-error
var $export = __webpack_require__(3);
var cof = __webpack_require__(74);

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});


/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});


/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var scale = __webpack_require__(527);
var fround = __webpack_require__(507);

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});


/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});


/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

// https://rwaldron.github.io/proposal-math-extensions/
var $export = __webpack_require__(3);

$export($export.S, 'Math', { scale: __webpack_require__(527) });


/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = __webpack_require__(3);

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});


/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

// http://jfbastien.github.io/papers/Math.signbit.html
var $export = __webpack_require__(3);

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });


/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(3);
var core = __webpack_require__(72);
var global = __webpack_require__(17);
var speciesConstructor = __webpack_require__(239);
var promiseResolve = __webpack_require__(514);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(3);
var newPromiseCapability = __webpack_require__(348);
var perform = __webpack_require__(513);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });


/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });


/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var getPrototypeOf = __webpack_require__(69);
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(517);
var from = __webpack_require__(526);
var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var getPrototypeOf = __webpack_require__(69);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });


/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var getPrototypeOf = __webpack_require__(69);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });


/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

var $metadata = __webpack_require__(101);
var anObject = __webpack_require__(15);
var aFunction = __webpack_require__(47);
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });


/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = __webpack_require__(3);
var microtask = __webpack_require__(347)();
var process = __webpack_require__(17).process;
var isNode = __webpack_require__(74)(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});


/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/zenparsing/es-observable
var $export = __webpack_require__(3);
var global = __webpack_require__(17);
var core = __webpack_require__(72);
var microtask = __webpack_require__(347)();
var OBSERVABLE = __webpack_require__(28)('observable');
var aFunction = __webpack_require__(47);
var anObject = __webpack_require__(15);
var anInstance = __webpack_require__(131);
var redefineAll = __webpack_require__(133);
var hide = __webpack_require__(59);
var forOf = __webpack_require__(132);
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

__webpack_require__(130)('Observable');


/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(17);
var $export = __webpack_require__(3);
var userAgent = __webpack_require__(240);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(3);
var $task = __webpack_require__(346);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(345);
var getKeys = __webpack_require__(126);
var redefine = __webpack_require__(60);
var global = __webpack_require__(17);
var hide = __webpack_require__(59);
var Iterators = __webpack_require__(155);
var wks = __webpack_require__(28);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1087);
module.exports = __webpack_require__(72).RegExp.escape;


/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/benjamingr/RexExp.escape
var $export = __webpack_require__(3);
var $re = __webpack_require__(1088)(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};


/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(230),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),m=__webpack_require__(230),q=__webpack_require__(1091);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;if(fa.hasOwnProperty(g))throw t(Error(99),g);fa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],h,g);e=!0}else f.registrationName?(ha(f.registrationName,h,g),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,h,g,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,h,g,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,h,g,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
return c}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Ma(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}
function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);
function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),ab=Wa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,db=null,eb=null;
function fb(){if(eb)return eb;var a,b=db,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);return eb=e.slice(a,1<d?1-d:void 0)}function gb(){return!0}function hb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?gb:hb;this.isPropagationStopped=hb;return this}
m(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=gb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=gb)},persist:function(){this.isPersistent=gb},isPersistent:hb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=hb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;m(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=m({},d.Interface,a);c.extend=d.extend;ib(c);return c};ib(y);function jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function kb(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function ib(a){a.eventPool=[];a.getPooled=jb;a.release=kb}var lb=y.extend({data:null}),mb=y.extend({data:null}),nb=[9,13,27,32],ob=Ra&&"CompositionEvent"in window,pb=null;Ra&&"documentMode"in document&&(pb=document.documentMode);
var qb=Ra&&"TextEvent"in window&&!pb,sb=Ra&&(!ob||pb&&8<pb&&11>=pb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==nb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function Ab(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Bb(a,b){if(yb)return"compositionend"===a||!ob&&wb(a,b)?(a=fb(),eb=db=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Cb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(ob)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=fb()):(cb=d,db="value"in cb?cb.value:cb.textContent,yb=
!0)),e=lb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=qb?Ab(a,c):Bb(a,c))?(b=mb.getPooled(ub.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=ta(a)){if("function"!==typeof Db)throw t(Error(280));var b=sa(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
function Jb(a,b){return a(b)}function Kb(a,b,c,d){return a(b,c,d)}function Lb(){}var Mb=Jb,Nb=!1;function Ob(){if(null!==Eb||null!==Fb)Lb(),Ib()}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Xb.hasOwnProperty("ReactCurrentDispatcher")||(Xb.ReactCurrentDispatcher={current:null});Xb.hasOwnProperty("ReactCurrentBatchConfig")||(Xb.ReactCurrentBatchConfig={suspense:null});
var Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):60113,ic=B?Symbol.for("react.suspense_list"):
60120,jc=B?Symbol.for("react.memo"):60115,kc=B?Symbol.for("react.lazy"):60116;B&&Symbol.for("react.fundamental");B&&Symbol.for("react.responder");var lc="function"===typeof Symbol&&Symbol.iterator;function mc(a){if(null===a||"object"!==typeof a)return null;a=lc&&a[lc]||a["@@iterator"];return"function"===typeof a?a:null}
function oc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense";case ic:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jc:return oc(a.type);case kc:if(a=1===a._status?a._result:null)return oc(a)}return null}function pc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=oc(a.type);c=null;d&&(c=oc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var qc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,rc=Object.prototype.hasOwnProperty,sc={},tc={};
function uc(a){if(rc.call(tc,a))return!0;if(rc.call(sc,a))return!1;if(qc.test(a))return tc[a]=!0;sc[a]=!0;return!1}function vc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function wc(a,b,c,d){if(null===b||"undefined"===typeof b||vc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new D(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new D(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new D(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new D(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new D(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){F[a]=new D(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){F[a]=new D(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){F[a]=new D(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){F[a]=new D(a,5,!1,a.toLowerCase(),null,!1)});var xc=/[\-:]([a-z])/g;function yc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(xc,
yc);F[b]=new D(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!1)});
F.xlinkHref=new D("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!0)});
function zc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(wc(b,c,e,d)&&(c=null),d||null===e?uc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Ac(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Bc(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Cc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ac(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Dc(a,b){b=b.checked;null!=b&&zc(a,"checked",b,!1)}
function Ec(a,b){Dc(a,b);var c=Ac(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fc(a,b.type,Ac(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Hc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Ic(a,b,c){a=y.getPooled(Hc.change,a,b,c);a.type="change";Hb(c);Qa(a);return a}var Jc=null,Kc=null;function Lc(a){Ba(a)}
function Mc(a){var b=Ja(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Ra&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){if("value"===a.propertyName&&Mc(Kc))if(a=Ic(Kc,a,Rb(a)),Nb)Ba(a);else{Nb=!0;try{Jb(Lc,a)}finally{Nb=!1,Ob()}}}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}
function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Hc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,h=Rc):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Ic(f,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fc(e,"number",e.value)}},Wc=y.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var h=void 0,g=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)h=dd,g=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)h=ed,g=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var n=null==f?e:Ja(f);e=null==b?e:Ja(b);a=h.getPooled(g,f,c,d);a.type=l+"leave";a.target=n;a.relatedTarget=e;c=h.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=n;d=b;if(f&&d)a:{b=f;e=d;l=0;for(h=b;h;h=La(h))l++;h=0;for(k=e;k;k=La(k))h++;for(;0<l-h;)b=La(b),l--;for(;0<h-l;)e=La(e),h--;for(;l--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function hd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var id=Object.prototype.hasOwnProperty;
function jd(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!id.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a,b){return{responder:a,props:b}}new Map;new Map;new Set;new Map;
function ld(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function od(a){if(2!==ld(a))throw t(Error(188));}
function pd(a){var b=a.alternate;if(!b){b=ld(a);if(3===b)throw t(Error(188));return 1===b?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return od(e),a;if(f===d)return od(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var h=!1,g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===
c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}if(!h)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function qd(a){a=pd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var rd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),sd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),td=Wc.extend({relatedTarget:null});function ud(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var vd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},wd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},xd=Wc.extend({key:function(a){if(a.key){var b=vd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ud(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?wd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?ud(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ud(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),yd=dd.extend({dataTransfer:null}),zd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),Ad=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Bd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Cd=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],
["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",
1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[Xa,"animationEnd",2],[Ya,"animationIteration",2],[Za,"animationStart",2],["canplay","canPlay",2],["canplaythrough",
"canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",
2],[ab,"transitionEnd",2],["waiting","waiting",2]],Dd={},Ed={},Fd=0;for(;Fd<Cd.length;Fd++){var Gd=Cd[Fd],Hd=Gd[0],Id=Gd[1],Jd=Gd[2],Kd="on"+(Id[0].toUpperCase()+Id.slice(1)),Ld={phasedRegistrationNames:{bubbled:Kd,captured:Kd+"Capture"},dependencies:[Hd],eventPriority:Jd};Dd[Id]=Ld;Ed[Hd]=Ld}
var Md={eventTypes:Dd,getEventPriority:function(a){a=Ed[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=Ed[a];if(!e)return null;switch(a){case "keypress":if(0===ud(c))return null;case "keydown":case "keyup":a=xd;break;case "blur":case "focus":a=td;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
yd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=zd;break;case Xa:case Ya:case Za:a=rd;break;case ab:a=Ad;break;case "scroll":a=Wc;break;case "wheel":a=Bd;break;case "copy":case "cut":case "paste":a=sd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},Nd=Md.getEventPriority,Od=[];
function Pd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,h=null,g=0;g<ea.length;g++){var k=ea[g];k&&(k=k.extractEvents(d,b,f,e))&&(h=xa(h,k))}Ba(h)}}var Qd=!0;function G(a,b){Rd(b,a,!1)}
function Rd(a,b,c){switch(Nd(b)){case 0:var d=Sd.bind(null,b,1);break;case 1:d=Td.bind(null,b,1);break;default:d=Ud.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Sd(a,b,c){Nb||Lb();var d=Ud,e=Nb;Nb=!0;try{Kb(d,a,b,c)}finally{(Nb=e)||Ob()}}function Td(a,b,c){Ud(a,b,c)}
function Ud(a,b,c){if(Qd){b=Rb(c);b=Ha(b);null===b||"number"!==typeof b.tag||2===ld(b)||(b=null);if(Od.length){var d=Od.pop();d.topLevelType=a;d.nativeEvent=c;d.targetInst=b;a=d}else a={topLevelType:a,nativeEvent:c,targetInst:b,ancestors:[]};try{if(c=a,Nb)Pd(c,void 0);else{Nb=!0;try{Mb(Pd,c,void 0)}finally{Nb=!1,Ob()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Od.length&&Od.push(a)}}}var Vd=new ("function"===typeof WeakMap?WeakMap:Map);
function Wd(a){var b=Vd.get(a);void 0===b&&(b=new Set,Vd.set(a,b));return b}function Xd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Yd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Zd(a,b){var c=Yd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Yd(c)}}function $d(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?$d(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function ae(){for(var a=window,b=Xd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xd(a.document)}return b}function be(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var ce=Ra&&"documentMode"in document&&11>=document.documentMode,de={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ee=null,fe=null,ge=null,he=!1;
function ie(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(he||null==ee||ee!==Xd(c))return null;c=ee;"selectionStart"in c&&be(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return ge&&jd(ge,c)?null:(ge=c,a=y.getPooled(de.select,fe,a,b),a.type="select",a.target=ee,Qa(a),a)}
var je={eventTypes:de,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Wd(e);f=ja.onSelect;for(var h=0;h<f.length;h++)if(!e.has(f[h])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)ee=e,fe=b,ge=null;break;case "blur":ge=fe=ee=null;break;case "mousedown":he=!0;break;case "contextmenu":case "mouseup":case "dragend":return he=!1,ie(c,d);case "selectionchange":if(ce)break;
case "keydown":case "keyup":return ie(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=Ka;ta=Ia;va=Ja;Ca.injectEventPluginsByName({SimpleEventPlugin:Md,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:je,BeforeInputEventPlugin:Cb});function ke(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function le(a,b){a=m({children:void 0},b);if(b=ke(b.children))a.children=b;return a}function me(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Ac(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ne(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function oe(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:Ac(c)}}
function pe(a,b){var c=Ac(b.value),d=Ac(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function qe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var re={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function se(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function te(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?se(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ue=void 0,ve=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==re.svg||"innerHTML"in a)a.innerHTML=b;else{ue=ue||document.createElement("div");ue.innerHTML="<svg>"+b+"</svg>";for(b=ue.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function we(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var xe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ye=["Webkit","ms","Moz","O"];Object.keys(xe).forEach(function(a){ye.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);xe[b]=xe[a]})});function ze(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||xe.hasOwnProperty(a)&&xe[a]?(""+b).trim():b+"px"}
function Ae(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ze(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ce=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function De(a,b){if(b){if(Ce[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
function Ee(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function Fe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Wd(a);b=ja[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.has(e)){switch(e){case "scroll":Rd(a,"scroll",!0);break;case "focus":case "blur":Rd(a,"focus",!0);Rd(a,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Sb(e)&&Rd(a,e,!0);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c.add(e)}}}function Ge(){}var He=null,Ie=null;
function Je(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ke(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Le="function"===typeof setTimeout?setTimeout:void 0,Me="function"===typeof clearTimeout?clearTimeout:void 0;
function Ne(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}new Set;var Oe=[],Pe=-1;function H(a){0>Pe||(a.current=Oe[Pe],Oe[Pe]=null,Pe--)}function J(a,b){Pe++;Oe[Pe]=a.current;a.current=b}var Qe={},L={current:Qe},M={current:!1},Re=Qe;
function Se(a,b){var c=a.type.contextTypes;if(!c)return Qe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Te(a){H(M,a);H(L,a)}function Ue(a){H(M,a);H(L,a)}
function Ve(a,b,c){if(L.current!==Qe)throw t(Error(168));J(L,b,a);J(M,c,a)}function We(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),oc(b)||"Unknown",e);return m({},c,d)}function Xe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Qe;Re=L.current;J(L,b,a);J(M,M.current,a);return!0}
function Ye(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=We(a,b,Re),d.__reactInternalMemoizedMergedChildContext=b,H(M,a),H(L,a),J(L,b,a)):H(M,a);J(M,c,a)}
var Ze=q.unstable_runWithPriority,$e=q.unstable_scheduleCallback,af=q.unstable_cancelCallback,bf=q.unstable_shouldYield,cf=q.unstable_requestPaint,df=q.unstable_now,ef=q.unstable_getCurrentPriorityLevel,ff=q.unstable_ImmediatePriority,hf=q.unstable_UserBlockingPriority,jf=q.unstable_NormalPriority,kf=q.unstable_LowPriority,lf=q.unstable_IdlePriority,mf={},nf=void 0!==cf?cf:function(){},of=null,pf=null,qf=!1,rf=df(),sf=1E4>rf?df:function(){return df()-rf};
function tf(){switch(ef()){case ff:return 99;case hf:return 98;case jf:return 97;case kf:return 96;case lf:return 95;default:throw t(Error(332));}}function uf(a){switch(a){case 99:return ff;case 98:return hf;case 97:return jf;case 96:return kf;case 95:return lf;default:throw t(Error(332));}}function vf(a,b){a=uf(a);return Ze(a,b)}function wf(a,b,c){a=uf(a);return $e(a,b,c)}function xf(a){null===of?(of=[a],pf=$e(ff,yf)):of.push(a);return mf}function O(){null!==pf&&af(pf);yf()}
function yf(){if(!qf&&null!==of){qf=!0;var a=0;try{var b=of;vf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});of=null}catch(c){throw null!==of&&(of=of.slice(a+1)),$e(ff,O),c;}finally{qf=!1}}}function zf(a,b){if(1073741823===b)return 99;if(1===b)return 95;a=10*(1073741821-b)-10*(1073741821-a);return 0>=a?99:250>=a?98:5250>=a?97:95}function Af(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function Bf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var Cf={current:null},Df=null,Ef=null,Ff=null;function Gf(){Ff=Ef=Df=null}
function Hf(a,b){var c=a.type._context;J(Cf,c._currentValue,a);c._currentValue=b}function If(a){var b=Cf.current;H(Cf,a);a.type._context._currentValue=b}function Jf(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function Kf(a,b){Df=a;Ff=Ef=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(Lf=!0),a.firstContext=null)}function Mf(a,b){if(Ff!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Ff=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Ef){if(null===Df)throw t(Error(308));Ef=b;Df.dependencies={expirationTime:0,firstContext:b,responders:null}}else Ef=Ef.next=b}return a._currentValue}var Nf=!1;
function Of(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Pf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Qf(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Rf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Sf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Of(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Of(a.memoizedState),e=c.updateQueue=Of(c.memoizedState)):d=a.updateQueue=Pf(e):null===e&&(e=c.updateQueue=Pf(d));null===e||d===e?Rf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Rf(d,b),Rf(e,b)):(Rf(d,b),e.lastUpdate=b)}
function Tf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Of(a.memoizedState):Uf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Uf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Pf(b));return b}
function Vf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return m({},d,e);case 2:Nf=!0}return d}
function Wf(a,b,c,d,e){Nf=!1;b=Uf(a,b);for(var f=b.baseState,h=null,g=0,k=b.firstUpdate,l=f;null!==k;){var n=k.expirationTime;n<e?(null===h&&(h=k,f=l),g<n&&(g=n)):(Xf(n,k.suspenseConfig),l=Vf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}n=null;for(k=b.firstCapturedUpdate;null!==k;){var z=k.expirationTime;z<e?(null===n&&(n=k,null===h&&(f=l)),g<z&&(g=z)):(l=Vf(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===h&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===h&&null===n&&(f=l);b.baseState=f;b.firstUpdate=h;b.firstCapturedUpdate=n;a.expirationTime=g;a.memoizedState=l}
function Yf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Zf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Zf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Zf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
var $f=Xb.ReactCurrentBatchConfig,ag=(new aa.Component).refs;function bg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var fg={isMounted:function(a){return(a=a._reactInternalFiber)?2===ld(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=cg(),d=$f.suspense;
c=dg(c,a,d);d=Qf(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Sf(a,d);eg(a,c)}};function gg(a,b,c,d,e,f,h){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,h):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function hg(a,b,c){var d=!1,e=Qe;var f=b.contextType;"object"===typeof f&&null!==f?f=Mf(f):(e=N(b)?Re:L.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Se(a,e):Qe);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=fg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function ig(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&fg.enqueueReplaceState(b,b.state,null)}
function jg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=ag;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Mf(f):(f=N(b)?Re:L.current,e.context=Se(a,f));f=a.updateQueue;null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(bg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&fg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var kg=Array.isArray;
function lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;if(c){if(1!==c.tag)throw t(Error(309));d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===ag&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
function mg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
function ng(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=og(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=pg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=lg(a,b,c),d.return=a,d;d=qg(c.type,c.key,c.props,null,a.mode,d);d.ref=lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=rg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=sg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=pg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=qg(b.type,b.key,b.props,null,a.mode,c),c.ref=lg(a,null,b),c.return=a,c;case $b:return b=rg(b,a.mode,c),b.return=a,b}if(kg(b)||
mc(b))return b=sg(b,a.mode,c,null),b.return=a,b;mg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(kg(c)||mc(c))return null!==e?null:n(a,b,c,d,null);mg(a,c)}return null}function v(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(kg(d)||mc(d))return a=a.get(c)||null,n(b,a,d,e,null);mg(b,d)}return null}function rb(e,h,g,k){for(var l=null,u=null,n=h,w=h=0,C=null;null!==n&&w<g.length;w++){n.index>w?(C=n,n=null):C=n.sibling;var p=x(e,n,g[w],k);if(null===p){null===n&&(n=C);break}a&&
n&&null===p.alternate&&b(e,n);h=f(p,h,w);null===u?l=p:u.sibling=p;u=p;n=C}if(w===g.length)return c(e,n),l;if(null===n){for(;w<g.length;w++)n=z(e,g[w],k),null!==n&&(h=f(n,h,w),null===u?l=n:u.sibling=n,u=n);return l}for(n=d(e,n);w<g.length;w++)C=v(n,e,w,g[w],k),null!==C&&(a&&null!==C.alternate&&n.delete(null===C.key?w:C.key),h=f(C,h,w),null===u?l=C:u.sibling=C,u=C);a&&n.forEach(function(a){return b(e,a)});return l}function Be(e,h,g,k){var l=mc(g);if("function"!==typeof l)throw t(Error(150));g=l.call(g);
if(null==g)throw t(Error(151));for(var n=l=null,u=h,w=h=0,C=null,p=g.next();null!==u&&!p.done;w++,p=g.next()){u.index>w?(C=u,u=null):C=u.sibling;var r=x(e,u,p.value,k);if(null===r){null===u&&(u=C);break}a&&u&&null===r.alternate&&b(e,u);h=f(r,h,w);null===n?l=r:n.sibling=r;n=r;u=C}if(p.done)return c(e,u),l;if(null===u){for(;!p.done;w++,p=g.next())p=z(e,p.value,k),null!==p&&(h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);return l}for(u=d(e,u);!p.done;w++,p=g.next())p=v(u,e,w,p.value,k),null!==p&&(a&&null!==
p.alternate&&u.delete(null===p.key?w:p.key),h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,g){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,g);d.ref=lg(a,k,f);d.return=a;a=d;break a}c(a,
k);break}else b(a,k);k=k.sibling}f.type===ac?(d=sg(f.props.children,a.mode,g,f.key),d.return=a,a=d):(g=qg(f.type,f.key,f.props,null,a.mode,g),g.ref=lg(a,d,f),g.return=a,a=g)}return h(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=rg(f,a.mode,g);d.return=a;a=d}return h(a)}if("string"===typeof f||
"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,g),d.return=a,a=d):(c(a,d),d=pg(f,a.mode,g),d.return=a,a=d),h(a);if(kg(f))return rb(a,d,f,g);if(mc(f))return Be(a,d,f,g);l&&mg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var tg=ng(!0),ug=ng(!1),vg={},wg={current:vg},xg={current:vg},yg={current:vg};function zg(a){if(a===vg)throw t(Error(174));return a}
function Ag(a,b){J(yg,b,a);J(xg,a,a);J(wg,vg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:te(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=te(b,c)}H(wg,a);J(wg,b,a)}function Bg(a){H(wg,a);H(xg,a);H(yg,a)}function Cg(a){zg(yg.current);var b=zg(wg.current);var c=te(b,a.type);b!==c&&(J(xg,a,a),J(wg,c,a))}function Dg(a){xg.current===a&&(H(wg,a),H(xg,a))}var Eg=1,Fg=1,Gg=2,P={current:0};
function Hg(a){for(var b=a;null!==b;){if(13===b.tag){if(null!==b.memoizedState)return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}
var Ig=0,Jg=2,Kg=4,Lg=8,Mg=16,Ng=32,Og=64,Pg=128,Qg=Xb.ReactCurrentDispatcher,Rg=0,Sg=null,Q=null,Tg=null,Ug=null,R=null,Vg=null,Wg=0,Xg=null,Yg=0,Zg=!1,$g=null,ah=0;function bh(){throw t(Error(321));}function ch(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!hd(a[c],b[c]))return!1;return!0}
function dh(a,b,c,d,e,f){Rg=f;Sg=b;Tg=null!==a?a.memoizedState:null;Qg.current=null===Tg?eh:fh;b=c(d,e);if(Zg){do Zg=!1,ah+=1,Tg=null!==a?a.memoizedState:null,Vg=Ug,Xg=R=Q=null,Qg.current=fh,b=c(d,e);while(Zg);$g=null;ah=0}Qg.current=hh;a=Sg;a.memoizedState=Ug;a.expirationTime=Wg;a.updateQueue=Xg;a.effectTag|=Yg;a=null!==Q&&null!==Q.next;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;if(a)throw t(Error(300));return b}
function ih(){Qg.current=hh;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;Zg=!1;$g=null;ah=0}function jh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?Ug=R=a:R=R.next=a;return R}function kh(){if(null!==Vg)R=Vg,Vg=R.next,Q=Tg,Tg=null!==Q?Q.next:null;else{if(null===Tg)throw t(Error(310));Q=Tg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?Ug=a:R.next=a;Tg=Q.next}return R}
function lh(a,b){return"function"===typeof b?b(a):b}
function mh(a){var b=kh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<ah){var d=c.dispatch;if(null!==$g){var e=$g.get(c);if(void 0!==e){$g.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var h=b.baseUpdate;f=b.baseState;null!==h?(null!==d&&(d.next=null),d=h.next):d=null!==d?d.next:null;if(null!==
d){var g=e=null,k=d,l=!1;do{var n=k.expirationTime;n<Rg?(l||(l=!0,g=h,e=f),n>Wg&&(Wg=n)):(Xf(n,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));h=k;k=k.next}while(null!==k&&k!==d);l||(g=h,e=f);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate=g;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function nh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Xg?(Xg={lastEffect:null},Xg.lastEffect=a.next=a):(b=Xg.lastEffect,null===b?Xg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Xg.lastEffect=a));return a}function oh(a,b,c,d){var e=jh();Yg|=a;e.memoizedState=nh(b,c,void 0,void 0===d?null:d)}
function ph(a,b,c,d){var e=kh();d=void 0===d?null:d;var f=void 0;if(null!==Q){var h=Q.memoizedState;f=h.destroy;if(null!==d&&ch(d,h.deps)){nh(Ig,c,f,d);return}}Yg|=a;e.memoizedState=nh(b,c,f,d)}function qh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function rh(){}
function sh(a,b,c){if(!(25>ah))throw t(Error(301));var d=a.alternate;if(a===Sg||null!==d&&d===Sg)if(Zg=!0,a={expirationTime:Rg,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===$g&&($g=new Map),c=$g.get(b),void 0===c)$g.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=cg(),f=$f.suspense;e=dg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var h=b.last;if(null===h)f.next=f;else{var g=h.next;null!==g&&
(f.next=g);h.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(hd(l,k))return}catch(n){}finally{}eg(a,e)}}
var hh={readContext:Mf,useCallback:bh,useContext:bh,useEffect:bh,useImperativeHandle:bh,useLayoutEffect:bh,useMemo:bh,useReducer:bh,useRef:bh,useState:bh,useDebugValue:bh,useResponder:bh},eh={readContext:Mf,useCallback:function(a,b){jh().memoizedState=[a,void 0===b?null:b];return a},useContext:Mf,useEffect:function(a,b){return oh(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return oh(4,Kg|Ng,qh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return oh(4,
Kg|Ng,a,b)},useMemo:function(a,b){var c=jh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=jh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=sh.bind(null,Sg,a);return[d.memoizedState,a]},useRef:function(a){var b=jh();a={current:a};return b.memoizedState=a},useState:function(a){var b=jh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue=
{last:null,dispatch:null,lastRenderedReducer:lh,lastRenderedState:a};a=a.dispatch=sh.bind(null,Sg,a);return[b.memoizedState,a]},useDebugValue:rh,useResponder:kd},fh={readContext:Mf,useCallback:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Mf,useEffect:function(a,b){return ph(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ph(4,Kg|Ng,qh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return ph(4,Kg|Ng,a,b)},useMemo:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:mh,useRef:function(){return kh().memoizedState},useState:function(a){return mh(lh,a)},useDebugValue:rh,useResponder:kd},th=null,uh=null,vh=!1;
function wh(a,b){var c=xh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function yh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function zh(a){if(vh){var b=uh;if(b){var c=b;if(!yh(a,b)){b=Ne(c.nextSibling);if(!b||!yh(a,b)){a.effectTag|=2;vh=!1;th=a;return}wh(th,c)}th=a;uh=Ne(b.firstChild)}else a.effectTag|=2,vh=!1,th=a}}function Ah(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;th=a}
function Bh(a){if(a!==th)return!1;if(!vh)return Ah(a),vh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ke(b,a.memoizedProps))for(b=uh;b;)wh(a,b),b=Ne(b.nextSibling);Ah(a);uh=th?Ne(a.stateNode.nextSibling):null;return!0}function Ch(){uh=th=null;vh=!1}var Dh=Xb.ReactCurrentOwner,Lf=!1;function S(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Eh(a,b,c,d,e){c=c.render;var f=b.ref;Kf(b,e);d=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Gh(a,b,c,d,e,f){if(null===a){var h=c.type;if("function"===typeof h&&!Hh(h)&&void 0===h.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=h,Ih(a,b,h,d,e,f);a=qg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}h=a.child;if(e<f&&(e=h.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return Fh(a,b,f);b.effectTag|=1;a=og(h,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Ih(a,b,c,d,e,f){return null!==a&&jd(a.memoizedProps,d)&&a.ref===b.ref&&(Lf=!1,e<f)?Fh(a,b,f):Jh(a,b,c,d,f)}function Kh(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Jh(a,b,c,d,e){var f=N(c)?Re:L.current;f=Se(b,f);Kf(b,e);c=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Lh(a,b,c,d,e){if(N(c)){var f=!0;Xe(b)}else f=!1;Kf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),hg(b,c,d,e),jg(b,c,d,e),d=!0;else if(null===a){var h=b.stateNode,g=b.memoizedProps;h.props=g;var k=h.context,l=c.contextType;"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate;z||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&
"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l);Nf=!1;var x=b.memoizedState;k=h.state=x;var v=b.updateQueue;null!==v&&(Wf(b,v,d,h,e),k=b.memoizedState);g!==d||x!==k||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),k=b.memoizedState),(g=Nf||gg(b,c,g,d,x,k,l))?(z||"function"!==typeof h.UNSAFE_componentWillMount&&"function"!==typeof h.componentWillMount||("function"===typeof h.componentWillMount&&h.componentWillMount(),"function"===typeof h.UNSAFE_componentWillMount&&
h.UNSAFE_componentWillMount()),"function"===typeof h.componentDidMount&&(b.effectTag|=4)):("function"===typeof h.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),h.props=d,h.state=k,h.context=l,d=g):("function"===typeof h.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.stateNode,g=b.memoizedProps,h.props=b.type===b.elementType?g:Af(b.type,g),k=h.context,l=c.contextType,"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l)),n=c.getDerivedStateFromProps,(z=
"function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate)||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l),Nf=!1,k=b.memoizedState,x=h.state=k,v=b.updateQueue,null!==v&&(Wf(b,v,d,h,e),x=b.memoizedState),g!==d||k!==x||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),x=b.memoizedState),(n=Nf||gg(b,c,g,d,k,x,l))?(z||"function"!==typeof h.UNSAFE_componentWillUpdate&&"function"!==typeof h.componentWillUpdate||
("function"===typeof h.componentWillUpdate&&h.componentWillUpdate(d,x,l),"function"===typeof h.UNSAFE_componentWillUpdate&&h.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof h.componentDidUpdate&&(b.effectTag|=4),"function"===typeof h.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),h.props=d,h.state=x,h.context=l,d=n):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return Mh(a,b,c,d,f,e)}
function Mh(a,b,c,d,e,f){Kh(a,b);var h=0!==(b.effectTag&64);if(!d&&!h)return e&&Ye(b,c,!1),Fh(a,b,f);d=b.stateNode;Dh.current=b;var g=h&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&h?(b.child=tg(b,a.child,null,f),b.child=tg(b,null,g,f)):S(a,b,g,f);b.memoizedState=d.state;e&&Ye(b,c,!0);return b.child}function Nh(a){var b=a.stateNode;b.pendingContext?Ve(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ve(a,b.context,!1);Ag(a,b.containerInfo)}
var Oh={};
function Ph(a,b,c){var d=b.mode,e=b.pendingProps,f=P.current,h=null,g=!1,k;(k=0!==(b.effectTag&64))||(k=0!==(f&Gg)&&(null===a||null!==a.memoizedState));k?(h=Oh,g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=Fg);f&=Eg;J(P,f,b);if(null===a)if(g){e=e.fallback;a=sg(null,d,0,null);a.return=b;if(0===(b.mode&2))for(g=null!==b.memoizedState?b.child.child:b.child,a.child=g;null!==g;)g.return=a,g=g.sibling;c=sg(e,d,c,null);c.return=b;a.sibling=
c;d=a}else d=c=ug(b,null,e.children,c);else{if(null!==a.memoizedState)if(f=a.child,d=f.sibling,g){e=e.fallback;c=og(f,f.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==f.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;e=og(d,e,d.expirationTime);e.return=b;c.sibling=e;d=c;c.childExpirationTime=0;c=e}else d=c=tg(b,f.child,e.children,c);else if(f=a.child,g){g=e.fallback;e=sg(null,d,0,null);e.return=b;e.child=f;null!==f&&(f.return=e);if(0===(b.mode&
2))for(f=null!==b.memoizedState?b.child.child:b.child,e.child=f;null!==f;)f.return=e,f=f.sibling;c=sg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;d=e;e.childExpirationTime=0}else c=d=tg(b,f,e.children,c);b.stateNode=a.stateNode}b.memoizedState=h;b.child=d;return c}function Qh(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
function Rh(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;S(a,b,d.children,c);d=P.current;if(0!==(d&Gg))d=d&Eg|Gg,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var h=a.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);Jf(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===
b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=Eg}J(P,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===Hg(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qh(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===Hg(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}Qh(b,!0,c,null,f);break;case "together":Qh(b,
!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function Fh(a,b,c){null!==a&&(b.dependencies=a.dependencies);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=og(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=og(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Sh(a){a.effectTag|=4}
var Th=void 0,Uh=void 0,Vh=void 0,Wh=void 0;Th=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(20===c.tag)a.appendChild(c.stateNode.instance);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Uh=function(){};
Vh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var h=b.stateNode;zg(wg.current);a=null;switch(c){case "input":f=Bc(h,f);d=Bc(h,d);a=[];break;case "option":f=le(h,f);d=le(h,d);a=[];break;case "select":f=m({},f,{value:void 0});d=m({},d,{value:void 0});a=[];break;case "textarea":f=ne(h,f);d=ne(h,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(h.onclick=Ge)}De(c,d);h=c=void 0;var g=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(h in k)k.hasOwnProperty(h)&&(g||(g={}),g[h]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ia.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(h in k)!k.hasOwnProperty(h)||l&&l.hasOwnProperty(h)||(g||(g={}),g[h]="");for(h in l)l.hasOwnProperty(h)&&k[h]!==l[h]&&(g||
(g={}),g[h]=l[h])}else g||(a||(a=[]),a.push(c,g)),g=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ia.hasOwnProperty(c)?(null!=l&&Fe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}g&&(a=a||[]).push("style",g);e=a;(b.updateQueue=e)&&Sh(b)}};Wh=function(a,b,c,d){c!==d&&Sh(b)};
function $h(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function ai(a){switch(a.tag){case 1:N(a.type)&&Te(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:Bg(a);Ue(a);b=a.effectTag;if(0!==(b&64))throw t(Error(285));a.effectTag=b&-2049|64;return a;case 5:return Dg(a),null;case 13:return H(P,a),b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 19:return H(P,a),null;case 4:return Bg(a),null;case 10:return If(a),null;default:return null}}function bi(a,b){return{value:a,source:b,stack:pc(b)}}
var ci="function"===typeof WeakSet?WeakSet:Set;function di(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=pc(c));null!==c&&oc(c.type);b=b.value;null!==a&&1===a.tag&&oc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ei(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){fi(a,c)}}function gi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){fi(a,c)}else b.current=null}
function hi(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Ig){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Ig&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function ii(a,b){"function"===typeof ji&&ji(a);switch(a.tag){case 0:case 11:case 14:case 15:var c=a.updateQueue;if(null!==c&&(c=c.lastEffect,null!==c)){var d=c.next;vf(97<b?97:b,function(){var b=d;do{var c=b.destroy;if(void 0!==c){var h=a;try{c()}catch(g){fi(h,g)}}b=b.next}while(b!==d)})}break;case 1:gi(a);b=a.stateNode;"function"===typeof b.componentWillUnmount&&ei(a,b);break;case 5:gi(a);break;case 4:ki(a,b)}}
function li(a,b){for(var c=a;;)if(ii(c,b),null!==c.child&&4!==c.tag)c.child.return=c,c=c.child;else{if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}function mi(a){return 5===a.tag||3===a.tag||4===a.tag}
function ni(a){a:{for(var b=a.return;null!==b;){if(mi(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(we(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||mi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f||20===e.tag){var h=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var g=h;h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(h,c);else d?(g=b,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=Ge)):
b.appendChild(h)}else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ki(a,b){for(var c=a,d=!1,e=void 0,f=void 0;;){if(!d){d=c.return;a:for(;;){if(null===d)throw t(Error(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag)if(li(c,b),f){var h=e,g=c.stateNode;8===h.nodeType?h.parentNode.removeChild(g):h.removeChild(g)}else e.removeChild(c.stateNode);else if(20===c.tag)g=c.stateNode.instance,li(c,b),f?(h=e,8===h.nodeType?h.parentNode.removeChild(g):
h.removeChild(g)):e.removeChild(g);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(ii(c,b),null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function oi(a,b){switch(b.tag){case 0:case 11:case 14:case 15:hi(Kg,Lg,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ga]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Dc(c,d);Ee(a,e);b=Ee(a,d);for(e=0;e<f.length;e+=2){var h=f[e],g=f[e+1];"style"===h?Ae(c,g):"dangerouslySetInnerHTML"===h?ve(c,g):"children"===h?we(c,g):zc(c,h,g,b)}switch(a){case "input":Ec(c,d);break;case "textarea":pe(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?me(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?me(c,!!d.multiple,d.defaultValue,!0):me(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,pi=sf());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=
f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ze("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===
a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}qi(b);break;case 19:qi(b);break;case 17:break;case 20:break;default:throw t(Error(163));}}function qi(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ci);b.forEach(function(b){var d=ri.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var si="function"===typeof WeakMap?WeakMap:Map;
function ti(a,b,c){c=Qf(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){ui||(ui=!0,vi=d);di(a,b)};return c}
function wi(a,b,c){c=Qf(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){di(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===xi?xi=new Set([this]):xi.add(this),di(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var yi=Math.ceil,zi=Xb.ReactCurrentDispatcher,Ai=Xb.ReactCurrentOwner,T=0,Bi=8,Ci=16,Di=32,Ei=0,Fi=1,Gi=2,Hi=3,Ii=4,U=T,Ji=null,V=null,W=0,X=Ei,Ki=1073741823,Li=1073741823,Mi=null,Ni=!1,pi=0,Oi=500,Y=null,ui=!1,vi=null,xi=null,Pi=!1,Qi=null,Ri=90,Si=0,Ti=null,Ui=0,Vi=null,Wi=0;function cg(){return(U&(Ci|Di))!==T?1073741821-(sf()/10|0):0!==Wi?Wi:Wi=1073741821-(sf()/10|0)}
function dg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=tf();if(0===(b&4))return 99===d?1073741823:1073741822;if((U&Ci)!==T)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=1;break;default:throw t(Error(326));}null!==Ji&&a===W&&--a;return a}var Xi=0;
function eg(a,b){if(50<Ui)throw Ui=0,Vi=null,t(Error(185));a=Yi(a,b);if(null!==a){a.pingTime=0;var c=tf();if(1073741823===b)if((U&Bi)!==T&&(U&(Ci|Di))===T)for(var d=Z(a,1073741823,!0);null!==d;)d=d(!0);else Zi(a,99,1073741823),U===T&&O();else Zi(a,c,b);(U&4)===T||98!==c&&99!==c||(null===Ti?Ti=new Map([[a,b]]):(c=Ti.get(a),(void 0===c||c>b)&&Ti.set(a,b)))}}
function Yi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(b>e.firstPendingTime&&(e.firstPendingTime=b),a=e.lastPendingTime,0===a||b<a)&&(e.lastPendingTime=
b);return e}function Zi(a,b,c){if(a.callbackExpirationTime<c){var d=a.callbackNode;null!==d&&d!==mf&&af(d);a.callbackExpirationTime=c;1073741823===c?a.callbackNode=xf($i.bind(null,a,Z.bind(null,a,c))):(d=null,1!==c&&(d={timeout:10*(1073741821-c)-sf()}),a.callbackNode=wf(b,$i.bind(null,a,Z.bind(null,a,c)),d))}}function $i(a,b,c){var d=a.callbackNode,e=null;try{return e=b(c),null!==e?$i.bind(null,a,e):null}finally{null===e&&d===a.callbackNode&&(a.callbackNode=null,a.callbackExpirationTime=0)}}
function aj(){(U&(1|Ci|Di))===T&&(bj(),cj())}function dj(a,b){var c=a.firstBatch;return null!==c&&c._defer&&c._expirationTime>=b?(wf(97,function(){c._onComplete();return null}),!0):!1}function bj(){if(null!==Ti){var a=Ti;Ti=null;a.forEach(function(a,c){xf(Z.bind(null,c,a))});O()}}function ej(a,b){var c=U;U|=1;try{return a(b)}finally{U=c,U===T&&O()}}function fj(a,b,c,d){var e=U;U|=4;try{return vf(98,a.bind(null,b,c,d))}finally{U=e,U===T&&O()}}
function gj(a,b){var c=U;U&=-2;U|=Bi;try{return a(b)}finally{U=c,U===T&&O()}}
function hj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Me(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Te(d);break;case 3:Bg(d);Ue(d);break;case 5:Dg(d);break;case 4:Bg(d);break;case 13:H(P,d);break;case 19:H(P,d);break;case 10:If(d)}c=c.return}Ji=a;V=og(a.current,null,b);W=b;X=Ei;Li=Ki=1073741823;Mi=null;Ni=!1}
function Z(a,b,c){if((U&(Ci|Di))!==T)throw t(Error(327));if(a.firstPendingTime<b)return null;if(c&&a.finishedExpirationTime===b)return ij.bind(null,a);cj();if(a!==Ji||b!==W)hj(a,b);else if(X===Hi)if(Ni)hj(a,b);else{var d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d)}if(null!==V){d=U;U|=Ci;var e=zi.current;null===e&&(e=hh);zi.current=hh;if(c){if(1073741823!==b){var f=cg();if(f<b)return U=d,Gf(),zi.current=e,Z.bind(null,a,f)}}else Wi=0;do try{if(c)for(;null!==V;)V=jj(V);else for(;null!==V&&!bf();)V=
jj(V);break}catch(rb){Gf();ih();f=V;if(null===f||null===f.return)throw hj(a,b),U=d,rb;a:{var h=a,g=f.return,k=f,l=rb,n=W;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===typeof l&&"function"===typeof l.then){var z=l,x=0!==(P.current&Fg);l=g;do{var v;if(v=13===l.tag)null!==l.memoizedState?v=!1:(v=l.memoizedProps,v=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:x?!1:!0);if(v){g=l.updateQueue;null===g?(g=new Set,g.add(z),l.updateQueue=g):g.add(z);if(0===(l.mode&
2)){l.effectTag|=64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(n=Qf(1073741823,null),n.tag=2,Sf(k,n)));k.expirationTime=1073741823;break a}k=h;h=n;x=k.pingCache;null===x?(x=k.pingCache=new si,g=new Set,x.set(z,g)):(g=x.get(z),void 0===g&&(g=new Set,x.set(z,g)));g.has(h)||(g.add(h),k=kj.bind(null,k,z,h),z.then(k,k));l.effectTag|=2048;l.expirationTime=n;break a}l=l.return}while(null!==l);l=Error((oc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
pc(k))}X!==Ii&&(X=Fi);l=bi(l,k);k=g;do{switch(k.tag){case 3:k.effectTag|=2048;k.expirationTime=n;n=ti(k,l,n);Tf(k,n);break a;case 1:if(z=l,h=k.type,g=k.stateNode,0===(k.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==g&&"function"===typeof g.componentDidCatch&&(null===xi||!xi.has(g)))){k.effectTag|=2048;k.expirationTime=n;n=wi(k,z,n);Tf(k,n);break a}}k=k.return}while(null!==k)}V=lj(f)}while(1);U=d;Gf();zi.current=e;if(null!==V)return Z.bind(null,a,b)}a.finishedWork=a.current.alternate;
a.finishedExpirationTime=b;if(dj(a,b))return null;Ji=null;switch(X){case Ei:throw t(Error(328));case Fi:return d=a.lastPendingTime,d<b?Z.bind(null,a,d):c?ij.bind(null,a):(hj(a,b),xf(Z.bind(null,a,b)),null);case Gi:if(1073741823===Ki&&!c&&(c=pi+Oi-sf(),10<c)){if(Ni)return hj(a,b),Z.bind(null,a,b);d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d);a.timeoutHandle=Le(ij.bind(null,a),c);return null}return ij.bind(null,a);case Hi:if(!c){if(Ni)return hj(a,b),Z.bind(null,a,b);c=a.lastPendingTime;if(c<b)return Z.bind(null,
a,c);1073741823!==Li?c=10*(1073741821-Li)-sf():1073741823===Ki?c=0:(c=10*(1073741821-Ki)-5E3,d=sf(),b=10*(1073741821-b)-d,c=d-c,0>c&&(c=0),c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>c?4320:1960*yi(c/1960))-c,b<c&&(c=b));if(10<c)return a.timeoutHandle=Le(ij.bind(null,a),c),null}return ij.bind(null,a);case Ii:return!c&&1073741823!==Ki&&null!==Mi&&(d=Ki,e=Mi,b=e.busyMinDurationMs|0,0>=b?b=0:(c=e.busyDelayMs|0,d=sf()-(10*(1073741821-d)-(e.timeoutMs|0||5E3)),b=d<=c?0:c+b-d),10<b)?(a.timeoutHandle=
Le(ij.bind(null,a),b),null):ij.bind(null,a);default:throw t(Error(329));}}function Xf(a,b){a<Ki&&1<a&&(Ki=a);null!==b&&a<Li&&1<a&&(Li=a,Mi=b)}function jj(a){var b=mj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=lj(a));Ai.current=null;return b}
function lj(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&1024)){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&Te(b);break;case 3:Bg(b);Ue(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===c||null===c.child)Bh(b),b.effectTag&=-3;Uh(b);break;case 5:Dg(b);d=zg(yg.current);var f=b.type;if(null!==c&&null!=b.stateNode)Vh(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var h=
zg(wg.current);if(Bh(b)){c=b;e=void 0;f=c.stateNode;var g=c.type,k=c.memoizedProps;f[Fa]=c;f[Ga]=k;switch(g){case "iframe":case "object":case "embed":G("load",f);break;case "video":case "audio":for(var l=0;l<bb.length;l++)G(bb[l],f);break;case "source":G("error",f);break;case "img":case "image":case "link":G("error",f);G("load",f);break;case "form":G("reset",f);G("submit",f);break;case "details":G("toggle",f);break;case "input":Cc(f,k);G("invalid",f);Fe(d,"onChange");break;case "select":f._wrapperState=
{wasMultiple:!!k.multiple};G("invalid",f);Fe(d,"onChange");break;case "textarea":oe(f,k),G("invalid",f),Fe(d,"onChange")}De(g,k);l=null;for(e in k)k.hasOwnProperty(e)&&(h=k[e],"children"===e?"string"===typeof h?f.textContent!==h&&(l=["children",h]):"number"===typeof h&&f.textContent!==""+h&&(l=["children",""+h]):ia.hasOwnProperty(e)&&null!=h&&Fe(d,e));switch(g){case "input":Vb(f);Gc(f,k,!0);break;case "textarea":Vb(f);qe(f,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(f.onclick=Ge)}d=l;c.updateQueue=d;null!==d&&Sh(b)}else{k=f;c=e;g=b;l=9===d.nodeType?d:d.ownerDocument;h===re.html&&(h=se(k));h===re.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(h,k);k=l;k[Fa]=g;k[Ga]=c;c=k;Th(c,b,!1,!1);g=c;var n=d,z=Ee(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
g);d=e;break;case "video":case "audio":for(d=0;d<bb.length;d++)G(bb[d],g);d=e;break;case "source":G("error",g);d=e;break;case "img":case "image":case "link":G("error",g);G("load",g);d=e;break;case "form":G("reset",g);G("submit",g);d=e;break;case "details":G("toggle",g);d=e;break;case "input":Cc(g,e);d=Bc(g,e);G("invalid",g);Fe(n,"onChange");break;case "option":d=le(g,e);break;case "select":g._wrapperState={wasMultiple:!!e.multiple};d=m({},e,{value:void 0});G("invalid",g);Fe(n,"onChange");break;case "textarea":oe(g,
e);d=ne(g,e);G("invalid",g);Fe(n,"onChange");break;default:d=e}De(f,d);k=void 0;l=f;h=g;var x=d;for(k in x)if(x.hasOwnProperty(k)){var v=x[k];"style"===k?Ae(h,v):"dangerouslySetInnerHTML"===k?(v=v?v.__html:void 0,null!=v&&ve(h,v)):"children"===k?"string"===typeof v?("textarea"!==l||""!==v)&&we(h,v):"number"===typeof v&&we(h,""+v):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ia.hasOwnProperty(k)?null!=v&&Fe(n,k):null!=v&&zc(h,k,v,z))}switch(f){case "input":Vb(g);
Gc(g,e,!1);break;case "textarea":Vb(g);qe(g,e);break;case "option":null!=e.value&&g.setAttribute("value",""+Ac(e.value));break;case "select":d=g;g=e;d.multiple=!!g.multiple;k=g.value;null!=k?me(d,!!g.multiple,k,!1):null!=g.defaultValue&&me(d,!!g.multiple,g.defaultValue,!0);break;default:"function"===typeof d.onClick&&(g.onclick=Ge)}Je(f,e)&&Sh(b);b.stateNode=c}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)Wh(c,b,c.memoizedProps,
e);else{if("string"!==typeof e&&null===b.stateNode)throw t(Error(166));c=zg(yg.current);zg(wg.current);Bh(b)?(d=b.stateNode,c=b.memoizedProps,d[Fa]=b,d.nodeValue!==c&&Sh(b)):(d=b,c=(9===c.nodeType?c:c.ownerDocument).createTextNode(e),c[Fa]=b,d.stateNode=c)}break;case 11:break;case 13:H(P,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Bh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=
f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&Fg))X===Ei&&(X=Gi);else if(X===Ei||X===Gi)X=Hi;if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Bg(b);Uh(b);break;case 10:If(b);break;case 9:break;case 14:break;case 17:N(b.type)&&Te(b);break;case 18:break;case 19:H(P,b);e=b.memoizedState;if(null===e)break;f=0!==(b.effectTag&64);g=e.rendering;
if(null===g)if(f)$h(e,!1);else{if(X!==Ei||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){g=Hg(c);if(null!==g){b.effectTag|=64;$h(e,!1);c=g.updateQueue;null!==c&&(b.updateQueue=c,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(c=b.child;null!==c;)e=c,f=d,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,g=e.alternate,null===g?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=
g.childExpirationTime,e.expirationTime=g.expirationTime,e.child=g.child,e.memoizedProps=g.memoizedProps,e.memoizedState=g.memoizedState,e.updateQueue=g.updateQueue,f=g.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),c=c.sibling;J(P,P.current&Eg|Gg,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=Hg(g),null!==c){if(b.effectTag|=64,f=!0,$h(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else sf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,$h(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(g.sibling=b.child,b.child=g):(d=e.last,null!==d?d.sibling=g:b.child=g,e.last=g)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=sf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;c=P.current;c=f?c&Eg|Gg:c&Eg;J(P,c,b);b=d;break a}break;case 20:break;
default:throw t(Error(156));}b=null}d=V;if(1===W||1!==d.childExpirationTime){c=0;for(e=d.child;null!==e;)f=e.expirationTime,g=e.childExpirationTime,f>c&&(c=f),g>c&&(c=g),e=e.sibling;d.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&1024)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,
a.lastEffect=V))}else{b=ai(V,W);if(null!==b)return b.effectTag&=1023,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=1024)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===Ei&&(X=Ii);return null}function ij(a){var b=tf();vf(99,nj.bind(null,a,b));null!==Qi&&wf(97,function(){cj();return null});return null}
function nj(a,b){cj();if((U&(Ci|Di))!==T)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;var e=c.expirationTime,f=c.childExpirationTime;e=f>e?f:e;a.firstPendingTime=e;e<a.lastPendingTime&&(a.lastPendingTime=e);a===Ji&&(V=Ji=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;
if(null!==e){f=U;U|=Di;Ai.current=null;He=Qd;var h=ae();if(be(h)){if("selectionStart"in h)var g={start:h.selectionStart,end:h.selectionEnd};else a:{g=(g=h.ownerDocument)&&g.defaultView||window;var k=g.getSelection&&g.getSelection();if(k&&0!==k.rangeCount){g=k.anchorNode;var l=k.anchorOffset,n=k.focusNode;k=k.focusOffset;try{g.nodeType,n.nodeType}catch(zb){g=null;break a}var z=0,x=-1,v=-1,rb=0,Be=0,u=h,w=null;b:for(;;){for(var C;;){u!==g||0!==l&&3!==u.nodeType||(x=z+l);u!==n||0!==k&&3!==u.nodeType||
(v=z+k);3===u.nodeType&&(z+=u.nodeValue.length);if(null===(C=u.firstChild))break;w=u;u=C}for(;;){if(u===h)break b;w===g&&++rb===l&&(x=z);w===n&&++Be===k&&(v=z);if(null!==(C=u.nextSibling))break;u=w;w=u.parentNode}u=C}g=-1===x||-1===v?null:{start:x,end:v}}else g=null}g=g||{start:0,end:0}}else g=null;Ie={focusedElem:h,selectionRange:g};Qd=!1;Y=e;do try{for(;null!==Y;){if(0!==(Y.effectTag&256)){var I=Y.alternate;h=Y;switch(h.tag){case 0:case 11:case 15:hi(Jg,Ig,h);break;case 1:if(h.effectTag&256&&null!==
I){var E=I.memoizedProps,ua=I.memoizedState,gh=h.stateNode,oj=gh.getSnapshotBeforeUpdate(h.elementType===h.type?E:Af(h.type,E),ua);gh.__reactInternalSnapshotBeforeUpdate=oj}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(I=b;null!==Y;){var A=Y.effectTag;A&16&&we(Y.stateNode,"");if(A&128){var p=Y.alternate;if(null!==p){var r=p.ref;null!==r&&("function"===typeof r?
r(null):r.current=null)}}switch(A&14){case 2:ni(Y);Y.effectTag&=-3;break;case 6:ni(Y);Y.effectTag&=-3;oi(Y.alternate,Y);break;case 4:oi(Y.alternate,Y);break;case 8:E=Y;ki(E,I);E.return=null;E.child=null;E.memoizedState=null;E.updateQueue=null;E.dependencies=null;var K=E.alternate;null!==K&&(K.return=null,K.child=null,K.memoizedState=null,K.updateQueue=null,K.dependencies=null)}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);r=Ie;p=ae();A=r.focusedElem;
I=r.selectionRange;if(p!==A&&A&&A.ownerDocument&&$d(A.ownerDocument.documentElement,A)){null!==I&&be(A)&&(p=I.start,r=I.end,void 0===r&&(r=p),"selectionStart"in A?(A.selectionStart=p,A.selectionEnd=Math.min(r,A.value.length)):(r=(p=A.ownerDocument||document)&&p.defaultView||window,r.getSelection&&(r=r.getSelection(),E=A.textContent.length,K=Math.min(I.start,E),I=void 0===I.end?K:Math.min(I.end,E),!r.extend&&K>I&&(E=I,I=K,K=E),E=Zd(A,K),ua=Zd(A,I),E&&ua&&(1!==r.rangeCount||r.anchorNode!==E.node||r.anchorOffset!==
E.offset||r.focusNode!==ua.node||r.focusOffset!==ua.offset)&&(p=p.createRange(),p.setStart(E.node,E.offset),r.removeAllRanges(),K>I?(r.addRange(p),r.extend(ua.node,ua.offset)):(p.setEnd(ua.node,ua.offset),r.addRange(p))))));p=[];for(r=A;r=r.parentNode;)1===r.nodeType&&p.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<p.length;A++)r=p[A],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}Ie=null;Qd=!!He;He=null;a.current=c;Y=e;do try{for(A=d;null!==
Y;){var $a=Y.effectTag;if($a&36){var nc=Y.alternate;p=Y;r=A;switch(p.tag){case 0:case 11:case 15:hi(Mg,Ng,p);break;case 1:var md=p.stateNode;if(p.effectTag&4)if(null===nc)md.componentDidMount();else{var Fj=p.elementType===p.type?nc.memoizedProps:Af(p.type,nc.memoizedProps);md.componentDidUpdate(Fj,nc.memoizedState,md.__reactInternalSnapshotBeforeUpdate)}var Xh=p.updateQueue;null!==Xh&&Yf(p,Xh,md,r);break;case 3:var Yh=p.updateQueue;if(null!==Yh){K=null;if(null!==p.child)switch(p.child.tag){case 5:K=
p.child.stateNode;break;case 1:K=p.child.stateNode}Yf(p,Yh,K,r)}break;case 5:var Gj=p.stateNode;null===nc&&p.effectTag&4&&(r=Gj,Je(p.type,p.memoizedProps)&&r.focus());break;case 6:break;case 4:break;case 12:break;case 13:case 19:case 17:case 20:break;default:throw t(Error(163));}}if($a&128){var nd=Y.ref;if(null!==nd){var Zh=Y.stateNode;switch(Y.tag){case 5:var gf=Zh;break;default:gf=Zh}"function"===typeof nd?nd(gf):nd.current=gf}}$a&512&&(Pi=!0);Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));
fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=null;nf();U=f}else a.current=c;if(Pi)Pi=!1,Qi=a,Si=d,Ri=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0!==b?($a=cg(),$a=zf($a,b),Zi(a,$a,b)):xi=null;"function"===typeof pj&&pj(c.stateNode,d);1073741823===b?a===Vi?Ui++:(Ui=0,Vi=a):Ui=0;if(ui)throw ui=!1,a=vi,vi=null,a;if((U&Bi)!==T)return null;O();return null}
function cj(){if(null===Qi)return!1;var a=Qi,b=Si,c=Ri;Qi=null;Si=0;Ri=90;return vf(97<c?97:c,qj.bind(null,a,b))}function qj(a){if((U&(Ci|Di))!==T)throw t(Error(331));var b=U;U|=Di;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:hi(Pg,Ig,c),hi(Ig,Og,c)}}catch(d){if(null===a)throw t(Error(330));fi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}U=b;O();return!0}
function rj(a,b,c){b=bi(c,b);b=ti(a,b,1073741823);Sf(a,b);a=Yi(a,1073741823);null!==a&&Zi(a,99,1073741823)}function fi(a,b){if(3===a.tag)rj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){rj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===xi||!xi.has(d))){a=bi(b,a);a=wi(c,a,1073741823);Sf(c,a);c=Yi(c,1073741823);null!==c&&Zi(c,99,1073741823);break}}c=c.return}}
function kj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);Ji===a&&W===c?X===Hi||X===Gi&&1073741823===Ki&&sf()-pi<Oi?hj(a,W):Ni=!0:a.lastPendingTime<c||(b=a.pingTime,0!==b&&b<c||(a.pingTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),b=cg(),b=zf(b,c),Zi(a,b,c)))}function ri(a,b){var c=a.stateNode;null!==c&&c.delete(b);c=cg();b=dg(c,a,null);c=zf(c,b);a=Yi(a,b);null!==a&&Zi(a,c,b)}var mj=void 0;
mj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||M.current)Lf=!0;else if(d<c){Lf=!1;switch(b.tag){case 3:Nh(b);Ch();break;case 5:Cg(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Xe(b);break;case 4:Ag(b,b.stateNode.containerInfo);break;case 10:Hf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Ph(a,b,c);J(P,P.current&
Eg,b);b=Fh(a,b,c);return null!==b?b.sibling:null}J(P,P.current&Eg,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Rh(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);J(P,P.current,b);if(!d)return null}return Fh(a,b,c)}}else Lf=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Se(b,L.current);Kf(b,c);e=dh(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;ih();if(N(d)){var f=!0;Xe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var h=d.getDerivedStateFromProps;"function"===typeof h&&bg(b,d,h,a);e.updater=fg;b.stateNode=e;e._reactInternalFiber=b;jg(b,d,a,c);b=Mh(null,b,d,!0,f,c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Bf(e);b.type=e;f=b.tag=sj(e);
a=Af(e,a);switch(f){case 0:b=Jh(null,b,e,a,c);break;case 1:b=Lh(null,b,e,a,c);break;case 11:b=Eh(null,b,e,a,c);break;case 14:b=Gh(null,b,e,Af(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Jh(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Lh(a,b,d,e,c);case 3:Nh(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:null;Wf(b,d,b.pendingProps,
null,c);d=b.memoizedState.element;if(d===e)Ch(),b=Fh(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)uh=Ne(b.stateNode.containerInfo.firstChild),th=b,e=vh=!0;e?(b.effectTag|=2,b.child=ug(b,null,d,c)):(S(a,b,d,c),Ch());b=b.child}return b;case 5:return Cg(b),null===a&&zh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,h=e.children,Ke(d,e)?h=null:null!==f&&Ke(d,f)&&(b.effectTag|=16),Kh(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):
(S(a,b,h,c),b=b.child),b;case 6:return null===a&&zh(b),null;case 13:return Ph(a,b,c);case 4:return Ag(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=tg(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Eh(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;h=b.memoizedProps;
f=e.value;Hf(b,f);if(null!==h){var g=h.value;f=hd(g,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(g,f):1073741823)|0;if(0===f){if(h.children===e.children&&!M.current){b=Fh(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Qf(c,null),l.tag=2,Sf(g,l));g.expirationTime<c&&(g.expirationTime=c);l=g.alternate;null!==l&&l.expirationTime<
c&&(l.expirationTime=c);Jf(g.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else h=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Kf(b,c),e=Mf(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=Af(e,b.pendingProps),
f=Af(e.type,f),Gh(a,b,e,f,d,c);case 15:return Ih(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,N(d)?(a=!0,Xe(b)):a=!1,Kf(b,c),hg(b,d,e,c),jg(b,d,e,c),Mh(null,b,d,!0,a,c);case 19:return Rh(a,b,c)}throw t(Error(156));};var pj=null,ji=null;
function tj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);pj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ji=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function uj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function xh(a,b,c,d){return new uj(a,b,c,d)}
function Hh(a){a=a.prototype;return!(!a||!a.isReactComponent)}function sj(a){if("function"===typeof a)return Hh(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===jc)return 14}return 2}
function og(a,b){var c=a.alternate;null===c?(c=xh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function qg(a,b,c,d,e,f){var h=2;d=a;if("function"===typeof a)Hh(a)&&(h=1);else if("string"===typeof a)h=5;else a:switch(a){case ac:return sg(c.children,e,f,b);case fc:h=8;e|=7;break;case bc:h=8;e|=1;break;case cc:return a=xh(12,c,b,e|8),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=xh(13,c,b,e),a.type=hc,a.elementType=hc,a.expirationTime=f,a;case ic:return a=xh(19,c,b,e),a.elementType=ic,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:h=
10;break a;case ec:h=9;break a;case gc:h=11;break a;case jc:h=14;break a;case kc:h=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=xh(h,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function sg(a,b,c,d){a=xh(7,a,d,b);a.expirationTime=c;return a}function pg(a,b,c){a=xh(6,a,null,b);a.expirationTime=c;return a}
function rg(a,b,c){b=xh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function vj(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function wj(a,b,c){a=new vj(a,b,c);b=xh(3,null,null,2===b?7:1===b?3:0);a.current=b;return b.stateNode=a}
function xj(a,b,c,d,e,f){var h=b.current;a:if(c){c=c._reactInternalFiber;b:{if(2!==ld(c)||1!==c.tag)throw t(Error(170));var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(N(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=We(c,k,g);break a}}c=g}else c=Qe;null===b.context?b.context=c:b.pendingContext=c;b=f;e=Qf(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
(e.callback=b);Sf(h,e);eg(h,d);return d}function yj(a,b,c,d){var e=b.current,f=cg(),h=$f.suspense;e=dg(f,e,h);return xj(a,b,c,e,h,d)}function zj(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Aj(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Db=function(a,b,c){switch(b){case "input":Ec(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);if(!e)throw t(Error(90));Wb(d);Ec(d,e)}}}break;case "textarea":pe(a,c);break;case "select":b=c.value,null!=b&&me(a,!!c.multiple,b,!1)}};
function Bj(a){var b=1073741821-25*(((1073741821-cg()+500)/25|0)+1);b<=Xi&&--b;this._expirationTime=Xi=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bj.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Cj;xj(a,b,null,c,null,d._onCommit);return d};
Bj.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Bj.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((U&(Ci|Di))!==T)throw t(Error(253));xf(Z.bind(null,a,b));O();b=this._next;this._next=
null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bj.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Cj(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Cj.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Cj.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function Dj(a,b,c){this._internalRoot=wj(a,b,c)}function Ej(a,b){this._internalRoot=wj(a,2,b)}Ej.prototype.render=Dj.prototype.render=function(a,b){var c=this._internalRoot,d=new Cj;b=void 0===b?null:b;null!==b&&d.then(b);yj(a,c,null,d._onCommit);return d};
Ej.prototype.unmount=Dj.prototype.unmount=function(a){var b=this._internalRoot,c=new Cj;a=void 0===a?null:a;null!==a&&c.then(a);yj(null,b,null,c._onCommit);return c};Ej.prototype.createBatch=function(){var a=new Bj(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};
function Hj(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=ej;Kb=fj;Lb=aj;Mb=function(a,b){var c=U;U|=2;try{return a(b)}finally{U=c,U===T&&O()}};function Ij(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dj(a,0,b)}
function Jj(a,b,c,d,e){var f=c._reactRootContainer,h=void 0;if(f){h=f._internalRoot;if("function"===typeof e){var g=e;e=function(){var a=zj(h);g.call(a)}}yj(b,h,a,e)}else{f=c._reactRootContainer=Ij(c,d);h=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zj(h);k.call(a)}}gj(function(){yj(b,h,a,e)})}return zj(h)}function Kj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hj(b))throw t(Error(200));return Aj(a,b,null,c)}
var Nj={createPortal:Kj,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=qd(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!0,c)},render:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!Hj(c))throw t(Error(200));
if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return Jj(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!Hj(a))throw t(Error(40));return a._reactRootContainer?(gj(function(){Jj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Kj.apply(void 0,arguments)},unstable_batchedUpdates:ej,unstable_interactiveUpdates:function(a,b,c,d){aj();return fj(a,b,c,d)},unstable_discreteUpdates:fj,unstable_flushDiscreteUpdates:aj,flushSync:function(a,
b){if((U&(Ci|Di))!==T)throw t(Error(187));var c=U;U|=1;try{return vf(99,a.bind(null,b))}finally{U=c,O()}},unstable_createRoot:Lj,unstable_createSyncRoot:Mj,unstable_flushControlled:function(a){var b=U;U|=1;try{vf(99,a)}finally{U=b,U===T&&O()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ca.injectEventPluginsByName,fa,Qa,function(a){ya(a,Pa)},Hb,Ib,Ud,Ba,cj,{current:!1}]}};
function Lj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Ej(a,null!=b&&!0===b.hydrate)}function Mj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Dj(a,1,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return tj(m({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=qd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.9.0",
rendererPackageName:"react-dom"});var Oj={default:Nj},Pj=Oj&&Nj||Oj;module.exports=Pj.default||Pj;


/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1092);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.15.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=void 0,e=void 0,g=void 0,m=void 0,n=void 0;exports.unstable_now=void 0;exports.unstable_forceFrameRate=void 0;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,r=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(r,0),b;}};exports.unstable_now=function(){return Date.now()};d=function(a){null!==p?setTimeout(d,0,a):(p=a,setTimeout(r,0))};e=function(a,b){q=setTimeout(a,b)};g=function(){clearTimeout(q)};m=function(){return!1};n=exports.unstable_forceFrameRate=function(){}}else{var t=window.performance,u=window.Date,v=window.setTimeout,
w=window.clearTimeout,x=window.requestAnimationFrame,y=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof x&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof y&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));exports.unstable_now="object"===typeof t&&
"function"===typeof t.now?function(){return t.now()}:function(){return u.now()};var z=!1,A=null,B=-1,C=-1,D=33.33,E=-1,F=-1,G=0,H=!1;m=function(){return exports.unstable_now()>=G};n=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<a?(D=Math.floor(1E3/a),H=!0):(D=33.33,H=!1)};var J=function(){if(null!==A){var a=exports.unstable_now(),b=0<G-a;try{A(b,
a)||(A=null)}catch(c){throw I.postMessage(null),c;}}},K=new MessageChannel,I=K.port2;K.port1.onmessage=J;var L=function(a){if(null===A)F=E=-1,z=!1;else{z=!0;x(function(a){w(B);L(a)});var b=function(){G=exports.unstable_now()+D/2;J();B=v(b,3*D)};B=v(b,3*D);if(-1!==E&&.1<a-E){var c=a-E;!H&&-1!==F&&c<D&&F<D&&(D=c<F?F:c,8.33>D&&(D=8.33));F=c}E=a;G=a+D;I.postMessage(null)}};d=function(a){A=a;z||(z=!0,x(function(a){L(a)}))};e=function(a,b){C=v(function(){a(exports.unstable_now())},b)};g=function(){w(C);
C=-1}}var M=null,N=null,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a,b){var c=a.next;if(c===a)M=null;else{a===M&&(M=c);var f=a.previous;f.next=c;c.previous=f}a.next=a.previous=null;c=a.callback;f=P;var l=O;P=a.priorityLevel;O=a;try{var h=a.expirationTime<=b;switch(P){case 1:var k=c(h);break;case 2:k=c(h);break;case 3:k=c(h);break;case 4:k=c(h);break;case 5:k=c(h)}}catch(Z){throw Z;}finally{P=f,O=l}if("function"===typeof k)if(b=a.expirationTime,a.callback=k,null===M)M=a.next=a.previous=a;else{k=null;h=M;do{if(b<=h.expirationTime){k=h;break}h=h.next}while(h!==
M);null===k?k=M:k===M&&(M=a);b=k.previous;b.next=k.previous=a;a.next=k;a.previous=b}}function U(a){if(null!==N&&N.startTime<=a){do{var b=N,c=b.next;if(b===c)N=null;else{N=c;var f=b.previous;f.next=c;c.previous=f}b.next=b.previous=null;V(b,b.expirationTime)}while(null!==N&&N.startTime<=a)}}function W(a){S=!1;U(a);R||(null!==M?(R=!0,d(X)):null!==N&&e(W,N.startTime-a))}
function X(a,b){R=!1;S&&(S=!1,g());U(b);Q=!0;try{if(!a)for(;null!==M&&M.expirationTime<=b;)T(M,b),b=exports.unstable_now(),U(b);else if(null!==M){do T(M,b),b=exports.unstable_now(),U(b);while(null!==M&&!m())}if(null!==M)return!0;null!==N&&e(W,N.startTime-b);return!1}finally{Q=!1}}function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}
function V(a,b){if(null===M)M=a.next=a.previous=a;else{var c=null,f=M;do{if(b<f.expirationTime){c=f;break}f=f.next}while(f!==M);null===c?c=M:c===M&&(M=a);b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}}var aa=n;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var f=exports.unstable_now();if("object"===typeof c&&null!==c){var l=c.delay;l="number"===typeof l&&0<l?f+l:f;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),l=f;c=l+c;a={callback:b,priorityLevel:a,startTime:l,expirationTime:c,next:null,previous:null};if(l>f){c=l;if(null===N)N=a.next=a.previous=a;else{b=null;var h=N;do{if(c<h.startTime){b=h;break}h=h.next}while(h!==N);null===b?b=N:b===N&&(N=a);c=b.previous;c.next=b.previous=a;a.next=b;a.previous=
c}null===M&&N===a&&(S?g():S=!0,e(W,l-f))}else V(a,c),R||Q||(R=!0,d(X));return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(a===b)a===M?M=null:a===N&&(N=null);else{a===M?M=b:a===N&&(N=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};exports.unstable_getCurrentPriorityLevel=function(){return P};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();U(a);return null!==O&&null!==M&&M.startTime<=a&&M.expirationTime<O.expirationTime||m()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){R||Q||(R=!0,d(X))};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M};


/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1094);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(530);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(1097);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1096);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1098);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(1102)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1104);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.6
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(1106);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1107);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(353);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(540);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(1118);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1116);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(536);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1120);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(538);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(539);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(540);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(541);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(1129);
function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(353);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpecificStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducer__ = __webpack_require__(1162);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var persistor=function persistor(store){var initialState=store.getState();if(initialState.profile==null){try{var stored=localStorage.getItem("locale");if(stored!=null){store.dispatch({type:"UPDATE_LOCALE",payload:stored});}}catch(error){// TODO: Отчитаться о проблеме с localStorage
}}return function(next){return function(action){var prevState=store.getState();var result=next(action);var nextState=store.getState();if(action.type==="UPDATE_WATCHED_VIDEOS"){try{var _stored=localStorage.getItem("watchedVideos");if(_stored===null){localStorage.setItem("watchedVideos",JSON.stringify([action.payload]));}if(_stored!==null){localStorage.setItem("watchedVideos",JSON.stringify(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()([].concat(_toConsumableArray(JSON.parse(_stored)),[action.payload]))));}}catch(error){}}if(action.type==="UPDATE_LOCALE"){try{localStorage.setItem("locale",action.payload);}catch(error){// TODO: Отчитаться о проблеме с localStorage
}}if(action.type==="RECEIVE_PROFILE"){var id=action.payload.id;try{var _stored2=localStorage.getItem("persist:"+id+":settings");if(_stored2!=null){store.dispatch({type:"RECEIVE_SETTINGS",payload:JSON.parse(_stored2)});}else{store.dispatch({type:"DROP_SETTINGS",currency:action.payload.currency});}}catch(error){// TODO: Отчитаться о проблеме с localStorage
}try{var _stored3=localStorage.getItem("persist:"+id+":tabs");if(_stored3!=null){store.dispatch({type:"RECEIVE_TABS",payload:JSON.parse(_stored3)});}}catch(error){// TODO: Отчитаться о проблеме с localStorage
}}else if(nextState.profile){var _id=nextState.profile.id;if(nextState.settings!==prevState.settings){try{localStorage.setItem("persist:"+_id+":settings",JSON.stringify(nextState.settings));}catch(error){// TODO: Отчитаться о проблеме с localStorage
}}if(nextState.tabs!==prevState.tabs){try{localStorage.setItem("persist:"+_id+":tabs",JSON.stringify(nextState.tabs));}catch(error){// TODO: Отчитаться о проблеме с localStorage
}}}if(nextState.fallbackLocale!==prevState.fallbackLocale){try{localStorage.setItem("locale",nextState.fallbackLocale);}catch(error){// TODO: Отчитаться о проблеме с localStorage
}}return result;};};};function createSpecificStore(){var initialState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var middleware=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(persistor);var store=null;if(false){var composeEnhancers=window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__||compose;store=createStore(reducer,initialState,composeEnhancers(middleware));}else{store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["e" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducer__["a" /* default */],initialState,middleware);}var listeners=[];store.subscribeToActions=function(listener){listeners.push(listener);return function(){listeners=listeners.filter(function(l){return l!==listener;});};};var originalDispatch=store.dispatch.bind(store);store.dispatch=function(action){listeners.forEach(function(listener){listener(action);});return originalDispatch(action);};return store;}

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(543),
    arrayIncludes = __webpack_require__(546),
    arrayIncludesWith = __webpack_require__(1160),
    cacheHas = __webpack_require__(548),
    createSet = __webpack_require__(1161),
    setToArray = __webpack_require__(360);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(1133),
    ListCache = __webpack_require__(247),
    Map = __webpack_require__(359);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(1134),
    hashDelete = __webpack_require__(1141),
    hashGet = __webpack_require__(1142),
    hashHas = __webpack_require__(1143),
    hashSet = __webpack_require__(1144);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(357),
    isMasked = __webpack_require__(1138),
    isObject = __webpack_require__(76),
    toSource = __webpack_require__(545);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(157);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(1139);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(48);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 1140 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 1141 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(246);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 1145 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(248);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(248);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(248);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(248);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(249);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 1151 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(249);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(249);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(249);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 1156 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(547),
    baseIsNaN = __webpack_require__(1158),
    strictIndexOf = __webpack_require__(1159);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 1158 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 1159 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(549),
    noop = __webpack_require__(550),
    setToArray = __webpack_require__(360);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__audio__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__authForm__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__graphicalMode__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stockCategories__ = __webpack_require__(1643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stocks__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__points__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__deals__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__news__ = __webpack_require__(1644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__settings__ = __webpack_require__(1645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__remoteTradeSettings__ = __webpack_require__(1646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__profile__ = __webpack_require__(1647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__phoneCallVerification__ = __webpack_require__(1648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__dataRequirementsStatus__ = __webpack_require__(1649);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__accounts__ = __webpack_require__(1650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__serverData__ = __webpack_require__(1651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__time__ = __webpack_require__(1652);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__stats__ = __webpack_require__(1653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__dictionaries__ = __webpack_require__(1654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__socket__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__referralBonus__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__apiConfigs__ = __webpack_require__(1656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__apiCountries__ = __webpack_require__(1657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__fallbackLocale__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__serverFaults__ = __webpack_require__(685);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__helpdesk__ = __webpack_require__(1659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__iOSShowDeposit__ = __webpack_require__(1661);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__withdrawOutputMethods__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__firebaseMessaging__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__socialTrading__ = __webpack_require__(1664);
var reducers={audio:__WEBPACK_IMPORTED_MODULE_1__audio__["a" /* default */],authForm:__WEBPACK_IMPORTED_MODULE_2__authForm__["a" /* default */],graphicalMode:__WEBPACK_IMPORTED_MODULE_3__graphicalMode__["a" /* default */],stockCategories:__WEBPACK_IMPORTED_MODULE_4__stockCategories__["a" /* default */],stocks:__WEBPACK_IMPORTED_MODULE_5__stocks__["a" /* default */],points:__WEBPACK_IMPORTED_MODULE_6__points__["a" /* default */],deals:__WEBPACK_IMPORTED_MODULE_7__deals__["a" /* default */],tabs:__WEBPACK_IMPORTED_MODULE_8__tabs__["b" /* default */],news:__WEBPACK_IMPORTED_MODULE_9__news__["a" /* default */],settings:__WEBPACK_IMPORTED_MODULE_10__settings__["a" /* default */],remoteTradeSettings:__WEBPACK_IMPORTED_MODULE_11__remoteTradeSettings__["a" /* default */],profile:__WEBPACK_IMPORTED_MODULE_12__profile__["a" /* default */],phoneCallVerification:__WEBPACK_IMPORTED_MODULE_13__phoneCallVerification__["a" /* default */],dataRequirementsStatus:__WEBPACK_IMPORTED_MODULE_14__dataRequirementsStatus__["a" /* default */],accounts:__WEBPACK_IMPORTED_MODULE_15__accounts__["a" /* default */],serverData:__WEBPACK_IMPORTED_MODULE_16__serverData__["a" /* default */],time:__WEBPACK_IMPORTED_MODULE_17__time__["a" /* default */],stats:__WEBPACK_IMPORTED_MODULE_18__stats__["a" /* default */],dictionaries:__WEBPACK_IMPORTED_MODULE_19__dictionaries__["a" /* default */],socket:__WEBPACK_IMPORTED_MODULE_20__socket__["b" /* default */],referralBonus:__WEBPACK_IMPORTED_MODULE_21__referralBonus__["a" /* default */],apiConfigs:__WEBPACK_IMPORTED_MODULE_22__apiConfigs__["a" /* default */],apiCountries:__WEBPACK_IMPORTED_MODULE_23__apiCountries__["a" /* default */],fallbackLocale:__WEBPACK_IMPORTED_MODULE_24__fallbackLocale__["a" /* default */],serverFaults:__WEBPACK_IMPORTED_MODULE_25__serverFaults__["a" /* default */],helpdesk:__WEBPACK_IMPORTED_MODULE_26__helpdesk__["a" /* default */],iOSShowDeposit:__WEBPACK_IMPORTED_MODULE_27__iOSShowDeposit__["a" /* default */],withdrawOutputMethods:__WEBPACK_IMPORTED_MODULE_28__withdrawOutputMethods__["a" /* default */],firebaseMessaging:__WEBPACK_IMPORTED_MODULE_29__firebaseMessaging__["a" /* default */],socialTrading:__WEBPACK_IMPORTED_MODULE_30__socialTrading__["a" /* default */]};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])(reducers));

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var DefaultState={enabled:false,// This may be set to true
queue:[]};var DisabledState={enabled:false,// This mustn't be set to true
queue:[]};function addSoundToQueue(state,action){if(!state.enabled)return DisabledState;var newState=Object.assign({},state,{queue:[].concat(_toConsumableArray(state.queue))});var shouldAdd=newState.queue.reduce(function(shouldAdd,sound){if(!shouldAdd)return false;// Do not add new sound into the queue if there's already the same sound
if(sound.type===action.type){return false;}return shouldAdd;},true);if(shouldAdd){newState.queue.push({type:action.type,id:action.id});return newState;}return state;}function removeSoundFromQueue(state,payload){if(!state.enabled)return DisabledState;var newState=Object.assign({},state,{queue:[].concat(_toConsumableArray(state.queue))});var index=newState.queue.findIndex(function(item){return item.id===payload;});if(index>-1){newState.queue.splice(index,1);}return newState;}function processSettingsUpdate(state,settings){if(settings.sound!==undefined){// Reset queue on settings change
return{enabled:settings.sound,queue:[]};}return state;}function audio(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:DefaultState;var action=arguments[1];switch(action.type){case"PLAY_WIN_SOUND":case"PLAY_LOOSE_SOUND":return addSoundToQueue(state,action);case"REMOVE_SOUND":return removeSoundFromQueue(state,action.payload);case"RECEIVE_SETTINGS":case"UPDATE_SETTINGS":return processSettingsUpdate(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (audio);

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__ = __webpack_require__(96);
var signUpParam=/^#signup/.test(window.location.hash);var initialState={displayForm:false,displayTab:signUpParam?__WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["c" /* REGISTER_TAB_ID */]:__WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["a" /* LOGIN_TAB_ID */]};function displayTab(state,payload){switch(payload){case __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["c" /* REGISTER_TAB_ID */]:case __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["a" /* LOGIN_TAB_ID */]:case __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["b" /* PASSWORD_RESTORE_TAB_ID */]:case __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["f" /* SOCIAL_REGISTER_TAB_ID */]:case __WEBPACK_IMPORTED_MODULE_0__components_Auth_Auth__["e" /* SOCIAL_PASSWORD_TAB_ID */]:return Object.assign({},state,{displayTab:payload});default:return state;}}function displayForm(state,payload){return Object.assign({},state,{displayForm:!!payload});}function authForm(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"DISPLAY_AUTH_TAB":return displayTab(state,action.payload);case"DISPLAY_AUTH_FORM":return displayForm(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (authForm);

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

!function(e){ true?module.exports=e(null):"function"==typeof define&&define.amd?define(e(null)):window.stylis=e(null)}(function e(a){"use strict";var c=/^\0+/g,r=/[\0\r\f]/g,s=/: */g,t=/zoo|gra/,i=/([,: ])(transform)/g,f=/,+\s*(?![^(]*[)])/g,n=/ +\s*(?![^(]*[)])/g,l=/ *[\0] */g,o=/,\r+?/g,h=/([\t\r\n ])*\f?&/g,u=/:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g,d=/\W+/g,b=/@(k\w+)\s*(\S*)\s*/,k=/::(place)/g,p=/:(read-only)/g,g=/\s+(?=[{\];=:>])/g,A=/([[}=:>])\s+/g,C=/(\{[^{]+?);(?=\})/g,w=/\s{2,}/g,v=/([^\(])(:+) */g,m=/[svh]\w+-[tblr]{2}/,x=/\(\s*(.*)\s*\)/g,$=/([\s\S]*?);/g,y=/-self|flex-/g,O=/[^]*?(:[rp][el]a[\w-]+)[^]*/,j=/stretch|:\s*\w+\-(?:conte|avail)/,z=/([^-])(image-set\()/,F="-webkit-",N="-moz-",S="-ms-",B=59,W=125,q=123,D=40,E=41,G=91,H=93,I=10,J=13,K=9,L=64,M=32,P=38,Q=45,R=95,T=42,U=44,V=58,X=39,Y=34,Z=47,_=62,ee=43,ae=126,ce=0,re=12,se=11,te=107,ie=109,fe=115,ne=112,le=111,oe=105,he=99,ue=100,de=112,be=1,ke=1,pe=0,ge=1,Ae=1,Ce=1,we=0,ve=0,me=0,xe=[],$e=[],ye=0,Oe=null,je=-2,ze=-1,Fe=0,Ne=1,Se=2,Be=3,We=0,qe=1,De="",Ee="",Ge="";function He(e,a,s,t,i){for(var f,n,o=0,h=0,u=0,d=0,g=0,A=0,C=0,w=0,m=0,$=0,y=0,O=0,j=0,z=0,R=0,we=0,$e=0,Oe=0,je=0,ze=s.length,Je=ze-1,Re="",Te="",Ue="",Ve="",Xe="",Ye="";R<ze;){if(C=s.charCodeAt(R),R===Je)if(h+d+u+o!==0){if(0!==h)C=h===Z?I:Z;d=u=o=0,ze++,Je++}if(h+d+u+o===0){if(R===Je){if(we>0)Te=Te.replace(r,"");if(Te.trim().length>0){switch(C){case M:case K:case B:case J:case I:break;default:Te+=s.charAt(R)}C=B}}if(1===$e)switch(C){case q:case W:case B:case Y:case X:case D:case E:case U:$e=0;case K:case J:case I:case M:break;default:for($e=0,je=R,g=C,R--,C=B;je<ze;)switch(s.charCodeAt(je++)){case I:case J:case B:++R,C=g,je=ze;break;case V:if(we>0)++R,C=g;case q:je=ze}}switch(C){case q:for(g=(Te=Te.trim()).charCodeAt(0),y=1,je=++R;R<ze;){switch(C=s.charCodeAt(R)){case q:y++;break;case W:y--;break;case Z:switch(A=s.charCodeAt(R+1)){case T:case Z:R=Qe(A,R,Je,s)}break;case G:C++;case D:C++;case Y:case X:for(;R++<Je&&s.charCodeAt(R)!==C;);}if(0===y)break;R++}if(Ue=s.substring(je,R),g===ce)g=(Te=Te.replace(c,"").trim()).charCodeAt(0);switch(g){case L:if(we>0)Te=Te.replace(r,"");switch(A=Te.charCodeAt(1)){case ue:case ie:case fe:case Q:f=a;break;default:f=xe}if(je=(Ue=He(a,f,Ue,A,i+1)).length,me>0&&0===je)je=Te.length;if(ye>0)if(f=Ie(xe,Te,Oe),n=Pe(Be,Ue,f,a,ke,be,je,A,i,t),Te=f.join(""),void 0!==n)if(0===(je=(Ue=n.trim()).length))A=0,Ue="";if(je>0)switch(A){case fe:Te=Te.replace(x,Me);case ue:case ie:case Q:Ue=Te+"{"+Ue+"}";break;case te:if(Ue=(Te=Te.replace(b,"$1 $2"+(qe>0?De:"")))+"{"+Ue+"}",1===Ae||2===Ae&&Le("@"+Ue,3))Ue="@"+F+Ue+"@"+Ue;else Ue="@"+Ue;break;default:if(Ue=Te+Ue,t===de)Ve+=Ue,Ue=""}else Ue="";break;default:Ue=He(a,Ie(a,Te,Oe),Ue,t,i+1)}Xe+=Ue,O=0,$e=0,z=0,we=0,Oe=0,j=0,Te="",Ue="",C=s.charCodeAt(++R);break;case W:case B:if((je=(Te=(we>0?Te.replace(r,""):Te).trim()).length)>1){if(0===z)if((g=Te.charCodeAt(0))===Q||g>96&&g<123)je=(Te=Te.replace(" ",":")).length;if(ye>0)if(void 0!==(n=Pe(Ne,Te,a,e,ke,be,Ve.length,t,i,t)))if(0===(je=(Te=n.trim()).length))Te="\0\0";switch(g=Te.charCodeAt(0),A=Te.charCodeAt(1),g){case ce:break;case L:if(A===oe||A===he){Ye+=Te+s.charAt(R);break}default:if(Te.charCodeAt(je-1)===V)break;Ve+=Ke(Te,g,A,Te.charCodeAt(2))}}O=0,$e=0,z=0,we=0,Oe=0,Te="",C=s.charCodeAt(++R)}}switch(C){case J:case I:if(h+d+u+o+ve===0)switch($){case E:case X:case Y:case L:case ae:case _:case T:case ee:case Z:case Q:case V:case U:case B:case q:case W:break;default:if(z>0)$e=1}if(h===Z)h=0;else if(ge+O===0&&t!==te&&Te.length>0)we=1,Te+="\0";if(ye*We>0)Pe(Fe,Te,a,e,ke,be,Ve.length,t,i,t);be=1,ke++;break;case B:case W:if(h+d+u+o===0){be++;break}default:switch(be++,Re=s.charAt(R),C){case K:case M:if(d+o+h===0)switch(w){case U:case V:case K:case M:Re="";break;default:if(C!==M)Re=" "}break;case ce:Re="\\0";break;case re:Re="\\f";break;case se:Re="\\v";break;case P:if(d+h+o===0&&ge>0)Oe=1,we=1,Re="\f"+Re;break;case 108:if(d+h+o+pe===0&&z>0)switch(R-z){case 2:if(w===ne&&s.charCodeAt(R-3)===V)pe=w;case 8:if(m===le)pe=m}break;case V:if(d+h+o===0)z=R;break;case U:if(h+u+d+o===0)we=1,Re+="\r";break;case Y:case X:if(0===h)d=d===C?0:0===d?C:d;break;case G:if(d+h+u===0)o++;break;case H:if(d+h+u===0)o--;break;case E:if(d+h+o===0)u--;break;case D:if(d+h+o===0){if(0===O)switch(2*w+3*m){case 533:break;default:y=0,O=1}u++}break;case L:if(h+u+d+o+z+j===0)j=1;break;case T:case Z:if(d+o+u>0)break;switch(h){case 0:switch(2*C+3*s.charCodeAt(R+1)){case 235:h=Z;break;case 220:je=R,h=T}break;case T:if(C===Z&&w===T&&je+2!==R){if(33===s.charCodeAt(je+2))Ve+=s.substring(je,R+1);Re="",h=0}}}if(0===h){if(ge+d+o+j===0&&t!==te&&C!==B)switch(C){case U:case ae:case _:case ee:case E:case D:if(0===O){switch(w){case K:case M:case I:case J:Re+="\0";break;default:Re="\0"+Re+(C===U?"":"\0")}we=1}else switch(C){case D:if(z+7===R&&108===w)z=0;O=++y;break;case E:if(0==(O=--y))we=1,Re+="\0"}break;case K:case M:switch(w){case ce:case q:case W:case B:case U:case re:case K:case M:case I:case J:break;default:if(0===O)we=1,Re+="\0"}}if(Te+=Re,C!==M&&C!==K)$=C}}m=w,w=C,R++}if(je=Ve.length,me>0)if(0===je&&0===Xe.length&&0===a[0].length==false)if(t!==ie||1===a.length&&(ge>0?Ee:Ge)===a[0])je=a.join(",").length+2;if(je>0){if(f=0===ge&&t!==te?function(e){for(var a,c,s=0,t=e.length,i=Array(t);s<t;++s){for(var f=e[s].split(l),n="",o=0,h=0,u=0,d=0,b=f.length;o<b;++o){if(0===(h=(c=f[o]).length)&&b>1)continue;if(u=n.charCodeAt(n.length-1),d=c.charCodeAt(0),a="",0!==o)switch(u){case T:case ae:case _:case ee:case M:case D:break;default:a=" "}switch(d){case P:c=a+Ee;case ae:case _:case ee:case M:case E:case D:break;case G:c=a+c+Ee;break;case V:switch(2*c.charCodeAt(1)+3*c.charCodeAt(2)){case 530:if(Ce>0){c=a+c.substring(8,h-1);break}default:if(o<1||f[o-1].length<1)c=a+Ee+c}break;case U:a="";default:if(h>1&&c.indexOf(":")>0)c=a+c.replace(v,"$1"+Ee+"$2");else c=a+c+Ee}n+=c}i[s]=n.replace(r,"").trim()}return i}(a):a,ye>0)if(void 0!==(n=Pe(Se,Ve,f,e,ke,be,je,t,i,t))&&0===(Ve=n).length)return Ye+Ve+Xe;if(Ve=f.join(",")+"{"+Ve+"}",Ae*pe!=0){if(2===Ae&&!Le(Ve,2))pe=0;switch(pe){case le:Ve=Ve.replace(p,":"+N+"$1")+Ve;break;case ne:Ve=Ve.replace(k,"::"+F+"input-$1")+Ve.replace(k,"::"+N+"$1")+Ve.replace(k,":"+S+"input-$1")+Ve}pe=0}}return Ye+Ve+Xe}function Ie(e,a,c){var r=a.trim().split(o),s=r,t=r.length,i=e.length;switch(i){case 0:case 1:for(var f=0,n=0===i?"":e[0]+" ";f<t;++f)s[f]=Je(n,s[f],c,i).trim();break;default:f=0;var l=0;for(s=[];f<t;++f)for(var h=0;h<i;++h)s[l++]=Je(e[h]+" ",r[f],c,i).trim()}return s}function Je(e,a,c,r){var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);switch(t){case P:switch(ge+r){case 0:case 1:if(0===e.trim().length)break;default:return s.replace(h,"$1"+e.trim())}break;case V:switch(s.charCodeAt(1)){case 103:if(Ce>0&&ge>0)return s.replace(u,"$1").replace(h,"$1"+Ge);break;default:return e.trim()+s.replace(h,"$1"+e.trim())}default:if(c*ge>0&&s.indexOf("\f")>0)return s.replace(h,(e.charCodeAt(0)===V?"":"$1")+e.trim())}return e+s}function Ke(e,a,c,r){var l,o=0,h=e+";",u=2*a+3*c+4*r;if(944===u)return function(e){var a=e.length,c=e.indexOf(":",9)+1,r=e.substring(0,c).trim(),s=e.substring(c,a-1).trim();switch(e.charCodeAt(9)*qe){case 0:break;case Q:if(110!==e.charCodeAt(10))break;default:for(var t=s.split((s="",f)),i=0,c=0,a=t.length;i<a;c=0,++i){for(var l=t[i],o=l.split(n);l=o[c];){var h=l.charCodeAt(0);if(1===qe&&(h>L&&h<90||h>96&&h<123||h===R||h===Q&&l.charCodeAt(1)!==Q))switch(isNaN(parseFloat(l))+(-1!==l.indexOf("("))){case 1:switch(l){case"infinite":case"alternate":case"backwards":case"running":case"normal":case"forwards":case"both":case"none":case"linear":case"ease":case"ease-in":case"ease-out":case"ease-in-out":case"paused":case"reverse":case"alternate-reverse":case"inherit":case"initial":case"unset":case"step-start":case"step-end":break;default:l+=De}}o[c++]=l}s+=(0===i?"":",")+o.join(" ")}}if(s=r+s+";",1===Ae||2===Ae&&Le(s,1))return F+s+s;return s}(h);else if(0===Ae||2===Ae&&!Le(h,1))return h;switch(u){case 1015:return 97===h.charCodeAt(10)?F+h+h:h;case 951:return 116===h.charCodeAt(3)?F+h+h:h;case 963:return 110===h.charCodeAt(5)?F+h+h:h;case 1009:if(100!==h.charCodeAt(4))break;case 969:case 942:return F+h+h;case 978:return F+h+N+h+h;case 1019:case 983:return F+h+N+h+S+h+h;case 883:if(h.charCodeAt(8)===Q)return F+h+h;if(h.indexOf("image-set(",11)>0)return h.replace(z,"$1"+F+"$2")+h;return h;case 932:if(h.charCodeAt(4)===Q)switch(h.charCodeAt(5)){case 103:return F+"box-"+h.replace("-grow","")+F+h+S+h.replace("grow","positive")+h;case 115:return F+h+S+h.replace("shrink","negative")+h;case 98:return F+h+S+h.replace("basis","preferred-size")+h}return F+h+S+h+h;case 964:return F+h+S+"flex-"+h+h;case 1023:if(99!==h.charCodeAt(8))break;return l=h.substring(h.indexOf(":",15)).replace("flex-","").replace("space-between","justify"),F+"box-pack"+l+F+h+S+"flex-pack"+l+h;case 1005:return t.test(h)?h.replace(s,":"+F)+h.replace(s,":"+N)+h:h;case 1e3:switch(o=(l=h.substring(13).trim()).indexOf("-")+1,l.charCodeAt(0)+l.charCodeAt(o)){case 226:l=h.replace(m,"tb");break;case 232:l=h.replace(m,"tb-rl");break;case 220:l=h.replace(m,"lr");break;default:return h}return F+h+S+l+h;case 1017:if(-1===h.indexOf("sticky",9))return h;case 975:switch(o=(h=e).length-10,u=(l=(33===h.charCodeAt(o)?h.substring(0,o):h).substring(e.indexOf(":",7)+1).trim()).charCodeAt(0)+(0|l.charCodeAt(7))){case 203:if(l.charCodeAt(8)<111)break;case 115:h=h.replace(l,F+l)+";"+h;break;case 207:case 102:h=h.replace(l,F+(u>102?"inline-":"")+"box")+";"+h.replace(l,F+l)+";"+h.replace(l,S+l+"box")+";"+h}return h+";";case 938:if(h.charCodeAt(5)===Q)switch(h.charCodeAt(6)){case 105:return l=h.replace("-items",""),F+h+F+"box-"+l+S+"flex-"+l+h;case 115:return F+h+S+"flex-item-"+h.replace(y,"")+h;default:return F+h+S+"flex-line-pack"+h.replace("align-content","").replace(y,"")+h}break;case 973:case 989:if(h.charCodeAt(3)!==Q||122===h.charCodeAt(4))break;case 931:case 953:if(true===j.test(e))if(115===(l=e.substring(e.indexOf(":")+1)).charCodeAt(0))return Ke(e.replace("stretch","fill-available"),a,c,r).replace(":fill-available",":stretch");else return h.replace(l,F+l)+h.replace(l,N+l.replace("fill-",""))+h;break;case 962:if(h=F+h+(102===h.charCodeAt(5)?S+h:"")+h,c+r===211&&105===h.charCodeAt(13)&&h.indexOf("transform",10)>0)return h.substring(0,h.indexOf(";",27)+1).replace(i,"$1"+F+"$2")+h}return h}function Le(e,a){var c=e.indexOf(1===a?":":"{"),r=e.substring(0,3!==a?c:10),s=e.substring(c+1,e.length-1);return Oe(2!==a?r:r.replace(O,"$1"),s,a)}function Me(e,a){var c=Ke(a,a.charCodeAt(0),a.charCodeAt(1),a.charCodeAt(2));return c!==a+";"?c.replace($," or ($1)").substring(4):"("+a+")"}function Pe(e,a,c,r,s,t,i,f,n,l){for(var o,h=0,u=a;h<ye;++h)switch(o=$e[h].call(Te,e,u,c,r,s,t,i,f,n,l)){case void 0:case false:case true:case null:break;default:u=o}switch(u){case void 0:case false:case true:case null:case a:break;default:return u}}function Qe(e,a,c,r){for(var s=a+1;s<c;++s)switch(r.charCodeAt(s)){case Z:if(e===T)if(r.charCodeAt(s-1)===T&&a+2!==s)return s+1;break;case I:if(e===Z)return s+1}return s}function Re(e){for(var a in e){var c=e[a];switch(a){case"keyframe":qe=0|c;break;case"global":Ce=0|c;break;case"cascade":ge=0|c;break;case"compress":we=0|c;break;case"semicolon":ve=0|c;break;case"preserve":me=0|c;break;case"prefix":if(Oe=null,!c)Ae=0;else if("function"!=typeof c)Ae=1;else Ae=2,Oe=c}}return Re}function Te(a,c){if(void 0!==this&&this.constructor===Te)return e(a);var s=a,t=s.charCodeAt(0);if(t<33)t=(s=s.trim()).charCodeAt(0);if(qe>0)De=s.replace(d,t===G?"":"-");if(t=1,1===ge)Ge=s;else Ee=s;var i,f=[Ge];if(ye>0)if(void 0!==(i=Pe(ze,c,f,f,ke,be,0,0,0,0))&&"string"==typeof i)c=i;var n=He(xe,f,c,0,0);if(ye>0)if(void 0!==(i=Pe(je,n,f,f,ke,be,n.length,0,0,0))&&"string"!=typeof(n=i))t=0;return De="",Ge="",Ee="",pe=0,ke=1,be=1,we*t==0?n:n.replace(r,"").replace(g,"").replace(A,"$1").replace(C,"$1").replace(w," ")}if(Te.use=function e(a){switch(a){case void 0:case null:ye=$e.length=0;break;default:switch(a.constructor){case Array:for(var c=0,r=a.length;c<r;++c)e(a[c]);break;case Function:$e[ye++]=a;break;case Boolean:We=0|!!a}}return e},Te.set=Re,void 0!==a)Re(a);return Te});
//# sourceMappingURL=stylis.min.js.map

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1167);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.4.2
 * react-is.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.forward_ref"):60112,n=b?Symbol.for("react.timeout"):60113;
function q(a){if("object"===typeof a&&null!==a){var p=a.$$typeof;switch(p){case c:switch(a=a.type,a){case l:case e:case g:case f:return a;default:switch(a=a&&a.$$typeof,a){case k:case m:case h:return a;default:return p}}case d:return p}}}exports.typeOf=q;exports.AsyncMode=l;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=m;exports.Fragment=e;exports.Profiler=g;exports.Portal=d;exports.StrictMode=f;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===l||a===g||a===f||a===n||"object"===typeof a&&null!==a&&(a.$$typeof===h||a.$$typeof===k||a.$$typeof===m)};exports.isAsyncMode=function(a){return q(a)===l};exports.isContextConsumer=function(a){return q(a)===k};exports.isContextProvider=function(a){return q(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return q(a)===m};
exports.isFragment=function(a){return q(a)===e};exports.isProfiler=function(a){return q(a)===g};exports.isPortal=function(a){return q(a)===d};exports.isStrictMode=function(a){return q(a)===f};


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(552);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class)|(on[A-Z].*)|((data|aria|x)-.*))$/i;
var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(reactPropsRegex.test.bind(reactPropsRegex));

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(1173),
    hasIn = __webpack_require__(558);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(250),
    baseSet = __webpack_require__(1176),
    castPath = __webpack_require__(158);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(150);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(157),
    arrayMap = __webpack_require__(310),
    isArray = __webpack_require__(54),
    isSymbol = __webpack_require__(187);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(251),
    castPath = __webpack_require__(158),
    isIndex = __webpack_require__(252),
    isObject = __webpack_require__(76),
    toKey = __webpack_require__(136);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 1177 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(158),
    isArguments = __webpack_require__(315),
    isArray = __webpack_require__(54),
    isIndex = __webpack_require__(252),
    isLength = __webpack_require__(362),
    toKey = __webpack_require__(136);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(135),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(824);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(157),
    isArguments = __webpack_require__(315),
    isArray = __webpack_require__(54);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(1183),
    defineProperty = __webpack_require__(557),
    identity = __webpack_require__(220);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 1183 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(310),
    baseClone = __webpack_require__(366),
    baseUnset = __webpack_require__(1213),
    castPath = __webpack_require__(158),
    copyObject = __webpack_require__(188),
    customOmitClone = __webpack_require__(1217),
    flatRest = __webpack_require__(363),
    getAllKeysIn = __webpack_require__(569);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(247);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 1186 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 1187 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 1188 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(247),
    Map = __webpack_require__(359),
    MapCache = __webpack_require__(356);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 1190 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(135),
    isLength = __webpack_require__(362),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(562);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(188),
    keysIn = __webpack_require__(563);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76),
    isPrototype = __webpack_require__(317),
    nativeKeysIn = __webpack_require__(1196);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 1196 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(48);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(186)(module)))

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(188),
    getSymbols = __webpack_require__(371);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(188),
    getSymbolsIn = __webpack_require__(566);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(134),
    root = __webpack_require__(48);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 1202 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(373),
    cloneDataView = __webpack_require__(1204),
    cloneRegExp = __webpack_require__(1205),
    cloneSymbol = __webpack_require__(1206),
    cloneTypedArray = __webpack_require__(1207);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(373);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 1205 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(157);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(373);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(254),
    getPrototype = __webpack_require__(372),
    isPrototype = __webpack_require__(317);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(1210),
    baseUnary = __webpack_require__(369),
    nodeUtil = __webpack_require__(370);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(176),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(1212),
    baseUnary = __webpack_require__(369),
    nodeUtil = __webpack_require__(370);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(176),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(158),
    last = __webpack_require__(1214),
    parent = __webpack_require__(1215),
    toKey = __webpack_require__(136);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 1214 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(250),
    baseSlice = __webpack_require__(1216);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 1216 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(572);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(251),
    baseZipObject = __webpack_require__(1219);

/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */
function zipObject(props, values) {
  return baseZipObject(props || [], values || [], assignValue);
}

module.exports = zipObject;


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */
function baseZipObject(props, values, assignFunc) {
  var index = -1,
      length = props.length,
      valsLength = values.length,
      result = {};

  while (++index < length) {
    var value = index < valsLength ? values[index] : undefined;
    assignFunc(result, props[index], value);
  }
  return result;
}

module.exports = baseZipObject;


/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Warning;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Warning(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"#D75A4A":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"50px":_ref$width;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 50 50",width:width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"25",cy:"25",r:"25",fill:fill}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{points:"16,34 25,25 34,16  ",stroke:"#fff","stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{points:"16,16 25,25 34,34  ",stroke:"#fff","stroke-width":"2","stroke-linecap":"round","stroke-miterlimit":"10"}));}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__siamoption_siamoption__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__irontrade_irontrade__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eztrader_eztrader__ = __webpack_require__(839);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultThProject", function() { return __WEBPACK_IMPORTED_MODULE_0__siamoption_siamoption__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "richblueThProject", function() { return __WEBPACK_IMPORTED_MODULE_0__siamoption_siamoption__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lightThProject", function() { return __WEBPACK_IMPORTED_MODULE_0__siamoption_siamoption__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultiron", function() { return __WEBPACK_IMPORTED_MODULE_1__irontrade_irontrade__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "richblueiron", function() { return __WEBPACK_IMPORTED_MODULE_1__irontrade_irontrade__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "lightiron", function() { return __WEBPACK_IMPORTED_MODULE_1__irontrade_irontrade__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "thProjectTrade", function() { return __WEBPACK_IMPORTED_MODULE_1__irontrade_irontrade__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaulteztrader", function() { return __WEBPACK_IMPORTED_MODULE_2__eztrader_eztrader__["a"]; });


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Logo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"69.438",height:"37.188",viewBox:"0 0 69.438 37.188",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#feac00",d:"M74.983,26.5s3.324,2.743,3.987,5.393a11.418,11.418,0,0,1-.916,7.186H71.637a4.554,4.554,0,0,0-.123-4.624c-1.11-1.746-3.559-3.292-5.222-4.843a21.884,21.884,0,0,1-3.082-3.53V26.072l0,0,0,0V26.08a21.9,21.9,0,0,1-3.083,3.53c-1.664,1.551-4.113,3.1-5.222,4.843a4.554,4.554,0,0,0-.123,4.624H48.359a11.419,11.419,0,0,1-.916-7.186c0.662-2.65,3.987-5.393,3.987-5.393a8.85,8.85,0,0,1,.271,2.046,6.891,6.891,0,0,1-.374,2.1s2.769,0.688,4.1-.814,0.065-5.435,1.288-7.246c1-1.476,2.585-1.917,3.922-2.573a25.756,25.756,0,0,0,2.571-1.47,25.73,25.73,0,0,0,2.571,1.47c1.337,0.656,2.926,1.1,3.922,2.573,1.223,1.811-.053,5.731,1.288,7.246s4.1,0.814,4.1.814a6.9,6.9,0,0,1-.374-2.1A8.863,8.863,0,0,1,74.983,26.5Z",transform:"translate(-28 -18.531)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#feac00",d:"M33,51.37a1.9,1.9,0,0,1-1.187.32,2.338,2.338,0,0,1-1.445-.395,1.461,1.461,0,0,1-.518-1.242H28l-0.013.039a2.5,2.5,0,0,0,1.122,2.24,4.638,4.638,0,0,0,2.707.8,4.2,4.2,0,0,0,2.54-.7,2.257,2.257,0,0,0,.962-1.924,2.4,2.4,0,0,0-.809-1.885,5.989,5.989,0,0,0-2.381-1.154,6.174,6.174,0,0,1-1.542-.656,0.931,0.931,0,0,1-.447-0.792,1.068,1.068,0,0,1,.417-0.867,1.827,1.827,0,0,1,1.181-.339,1.75,1.75,0,0,1,1.236.408,1.385,1.385,0,0,1,.44,1.066h1.846l0.013-.039a2.489,2.489,0,0,0-.952-2.051,3.817,3.817,0,0,0-2.55-.832,4.141,4.141,0,0,0-2.54.74,2.278,2.278,0,0,0-.995,1.908,2.2,2.2,0,0,0,.867,1.839,7.742,7.742,0,0,0,2.563,1.161,3.925,3.925,0,0,1,1.36.626,1.1,1.1,0,0,1,.388.88A1.027,1.027,0,0,1,33,51.37Zm5.6-5.433H36.7v7.057h1.9V45.937Zm0-3.117H36.7v1.428h1.9V42.82Zm7.611,10.174a4.664,4.664,0,0,1-.238-0.867,5.512,5.512,0,0,1-.075-0.933V48.279a2.224,2.224,0,0,0-.789-1.829,3.152,3.152,0,0,0-2.054-.642,3.383,3.383,0,0,0-2.159.649A1.792,1.792,0,0,0,40.123,48l0.006,0.039,1.839,0.007a0.794,0.794,0,0,1,.251-0.623,1.248,1.248,0,0,1,1.5.056,1.1,1.1,0,0,1,.267.789v0.561H42.927A3.99,3.99,0,0,0,40.6,49.4,1.861,1.861,0,0,0,39.8,51a2.044,2.044,0,0,0,.6,1.556,2.383,2.383,0,0,0,1.709.571,1.931,1.931,0,0,0,1.145-.339,2.622,2.622,0,0,0,.773-0.854,3.535,3.535,0,0,0,.108.548,3.964,3.964,0,0,0,.179.509h1.9Zm-4.285-1.487a0.733,0.733,0,0,1-.235-0.567,0.984,0.984,0,0,1,.313-0.734,1.271,1.271,0,0,1,.92-0.3H43.99v1a1.291,1.291,0,0,1-.528.574,1.633,1.633,0,0,1-.894.248A0.91,0.91,0,0,1,41.929,51.507Zm5.413-5.57v7.057h1.9V47.837a1.3,1.3,0,0,1,.479-0.415,1.473,1.473,0,0,1,.675-0.147,0.946,0.946,0,0,1,.783.324,1.8,1.8,0,0,1,.261,1.108v4.288h1.9V48.346q0-.091-0.007-0.18t-0.007-.213a1.308,1.308,0,0,1,.473-0.5,1.326,1.326,0,0,1,.7-0.18,0.952,0.952,0,0,1,.776.314,1.792,1.792,0,0,1,.261,1.118v4.288h1.9V48.722a3.365,3.365,0,0,0-.6-2.195,2.034,2.034,0,0,0-1.647-.721,2.3,2.3,0,0,0-1.226.32,2.446,2.446,0,0,0-.848.887,1.851,1.851,0,0,0-.73-0.907,2.156,2.156,0,0,0-1.161-.3,2.447,2.447,0,0,0-1.184.277,2.369,2.369,0,0,0-.851.786l-0.078-.933H47.343Z",transform:"translate(-28 -18.531)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M66.693,47.392a3.98,3.98,0,0,0-1.109-2.886,3.826,3.826,0,0,0-2.876-1.145,3.757,3.757,0,0,0-2.847,1.145,4.013,4.013,0,0,0-1.092,2.886V49.1a4,4,0,0,0,1.1,2.889,3.773,3.773,0,0,0,2.85,1.141,3.821,3.821,0,0,0,2.873-1.141A3.984,3.984,0,0,0,66.693,49.1V47.392Zm-1.9,1.717a2.938,2.938,0,0,1-.548,1.843,1.816,1.816,0,0,1-1.526.712,1.785,1.785,0,0,1-1.507-.712,2.961,2.961,0,0,1-.541-1.843V47.384a2.951,2.951,0,0,1,.535-1.826,1.777,1.777,0,0,1,1.507-.709,1.828,1.828,0,0,1,1.526.712,2.881,2.881,0,0,1,.554,1.823v1.725Zm9.6,0.416a4.571,4.571,0,0,0-.724-2.694,2.349,2.349,0,0,0-2.035-1.024,2.038,2.038,0,0,0-1.027.251,2.264,2.264,0,0,0-.753.714l-0.111-.835H68.024v9.77h1.9V52.322a2.022,2.022,0,0,0,.737.6,2.261,2.261,0,0,0,.985.205,2.4,2.4,0,0,0,2.022-.952,4.053,4.053,0,0,0,.724-2.517V49.524Zm-1.9.127a2.865,2.865,0,0,1-.323,1.47,1.1,1.1,0,0,1-1.014.542,1.613,1.613,0,0,1-.747-0.157,1.168,1.168,0,0,1-.479-0.457v-3.1a1.257,1.257,0,0,1,.479-0.5,1.436,1.436,0,0,1,.734-0.176,1.085,1.085,0,0,1,1.017.62,3.423,3.423,0,0,1,.333,1.62v0.137Zm3.437-5.443v1.728H74.891v1.337h1.031v3.6a2.373,2.373,0,0,0,.531,1.715,2.029,2.029,0,0,0,1.516.541,3.381,3.381,0,0,0,.593-0.049,3.814,3.814,0,0,0,.561-0.147l-0.163-1.376a2.252,2.252,0,0,1-.251.056,1.746,1.746,0,0,1-.258.016A0.6,0.6,0,0,1,78,51.455a0.831,0.831,0,0,1-.169-0.587V47.274h1.187V45.937H77.826V44.209h-1.9Zm6.307,1.728h-1.9v7.057h1.9V45.937Zm0-3.117h-1.9v1.428h1.9V42.82ZM83.5,49.537a3.772,3.772,0,0,0,.884,2.593,3.488,3.488,0,0,0,4.891,0,3.772,3.772,0,0,0,.884-2.593V49.4a3.767,3.767,0,0,0-.887-2.589,3.1,3.1,0,0,0-2.452-1,3.069,3.069,0,0,0-2.439,1.008A3.787,3.787,0,0,0,83.5,49.4v0.137Zm1.9-.14a3.038,3.038,0,0,1,.342-1.527,1.156,1.156,0,0,1,1.079-.6,1.17,1.17,0,0,1,1.089.593,3.011,3.011,0,0,1,.346,1.53v0.137a3.042,3.042,0,0,1-.342,1.543,1.3,1.3,0,0,1-2.175,0,3.062,3.062,0,0,1-.339-1.547V49.4Zm5.9-3.46v7.057h1.9V47.863a1.4,1.4,0,0,1,.5-0.435,1.467,1.467,0,0,1,.678-0.154,1.154,1.154,0,0,1,.867.3,1.433,1.433,0,0,1,.287,1.01v4.412h1.911V48.585a3.1,3.1,0,0,0-.6-2.107,2.123,2.123,0,0,0-1.67-.672,2.252,2.252,0,0,0-1.154.3,2.582,2.582,0,0,0-.867.841l-0.085-1.011H91.3Z",transform:"translate(-28 -18.531)"}));}

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.0dc3e8ff.svg";

/***/ }),
/* 1226 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/index-logo.af5a1903.svg";

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/index-logo-text.6655d2a0.svg";

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/header.2466fa9a.jpg";

/***/ }),
/* 1230 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/howto-bg.2baae06a.jpg";

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/desktop-tour-bg-th.ec072075.jpg";

/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  width: 83px;\n  height: auto;\n  max-height: 47px;\n"],["\n  width: 83px;\n  height: auto;\n  max-height: 47px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 82.581 47.256",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-484.474 -483.669)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(509.621 483.669)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{opacity:"0",width:"31.549",height:"31.549",transform:"translate(0 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2829.083-806.423l-1.452-1.452,3.224-3.223-2.617-2.617,6.924-6.924,2.617,2.616,3.209-3.21,1.452,1.453-3.209,3.209,2.617,2.617-6.924,6.924-2.616-2.616-3.223,3.223Zm2.109-7.341,3.78,3.78,3.915-3.915-3.78-3.78Z",transform:"translate(-2810.891 833.72)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2456.1-982.553l3.227-3.227-2.618-2.62,15.258-15.258,2.618,2.62,3.107-3.107,1.456,1.456-3.107,3.107,2.609,2.611-15.258,15.258-2.61-2.611-3.227,3.227Z",transform:"translate(-2456.101 1008.391)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-350.9-111.573h2.37V-98.54h-2.37Zm10.983,5.247a7.257,7.257,0,0,0-.78-.2,5.741,5.741,0,0,0-1.157-.1,4.573,4.573,0,0,0-.8.075,4.8,4.8,0,0,0-.592.132v7.88h-2.276v-9.366a12.507,12.507,0,0,1,1.646-.461,10.258,10.258,0,0,1,2.191-.216q.226,0,.527.028t.6.075q.3.047.583.113t.451.122Zm10.87,2.859a6.35,6.35,0,0,1-.339,2.125,4.7,4.7,0,0,1-.959,1.636,4.313,4.313,0,0,1-1.5,1.053,4.828,4.828,0,0,1-1.928.376,4.761,4.761,0,0,1-1.918-.376,4.335,4.335,0,0,1-1.486-1.053,4.821,4.821,0,0,1-.969-1.636,6.193,6.193,0,0,1-.348-2.125,6.113,6.113,0,0,1,.348-2.116,4.758,4.758,0,0,1,.978-1.627,4.323,4.323,0,0,1,1.5-1.044,4.818,4.818,0,0,1,1.9-.367,4.887,4.887,0,0,1,1.909.367,4.208,4.208,0,0,1,1.5,1.044,4.839,4.839,0,0,1,.969,1.627A6.114,6.114,0,0,1-329.046-103.467Zm-2.332,0a3.838,3.838,0,0,0-.63-2.323,2.059,2.059,0,0,0-1.758-.856,2.059,2.059,0,0,0-1.758.856,3.839,3.839,0,0,0-.63,2.323,3.918,3.918,0,0,0,.63,2.351,2.052,2.052,0,0,0,1.758.865,2.052,2.052,0,0,0,1.758-.865A3.917,3.917,0,0,0-331.378-103.467Zm4.683-4.589a15.242,15.242,0,0,1,1.711-.357,14.757,14.757,0,0,1,2.332-.169,5.364,5.364,0,0,1,2.012.329,3.14,3.14,0,0,1,1.288.922,3.52,3.52,0,0,1,.677,1.429,7.985,7.985,0,0,1,.2,1.834v5.529h-2.276v-5.172a7.467,7.467,0,0,0-.1-1.345,2.384,2.384,0,0,0-.339-.9,1.352,1.352,0,0,0-.639-.508,2.693,2.693,0,0,0-.987-.16,7.581,7.581,0,0,0-.9.056q-.47.056-.7.094v7.937H-326.7Z",transform:"translate(835.373 629.201)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-49.411-123.375v2.05h-4.006v10.983h-2.388v-10.983h-4.006v-2.05Zm6.62,5.247a7.253,7.253,0,0,0-.78-.2,5.74,5.74,0,0,0-1.157-.1,4.574,4.574,0,0,0-.8.075,4.8,4.8,0,0,0-.592.132v7.88H-48.4v-9.366a12.508,12.508,0,0,1,1.646-.461,10.258,10.258,0,0,1,2.191-.216q.226,0,.527.028t.6.075q.3.047.583.113t.451.122Zm5.435,6.188a8.468,8.468,0,0,0,1.6-.113v-2.52a4.427,4.427,0,0,0-.545-.113,5.084,5.084,0,0,0-.79-.056,5.254,5.254,0,0,0-.762.056,2.373,2.373,0,0,0-.7.207,1.262,1.262,0,0,0-.5.423,1.182,1.182,0,0,0-.188.686,1.2,1.2,0,0,0,.508,1.119A2.62,2.62,0,0,0-37.356-111.94Zm-.188-8.482a5.567,5.567,0,0,1,1.9.282,3.033,3.033,0,0,1,1.232.79,2.959,2.959,0,0,1,.658,1.232,6.029,6.029,0,0,1,.2,1.589v5.962q-.527.113-1.589.273a16.23,16.23,0,0,1-2.4.16,7.2,7.2,0,0,1-1.617-.169,3.4,3.4,0,0,1-1.251-.545,2.573,2.573,0,0,1-.809-.978,3.393,3.393,0,0,1-.292-1.486,2.869,2.869,0,0,1,.329-1.429,2.7,2.7,0,0,1,.893-.95,3.868,3.868,0,0,1,1.307-.527,7.358,7.358,0,0,1,1.552-.16,7,7,0,0,1,.79.047,7.366,7.366,0,0,1,.884.16v-.376a2.945,2.945,0,0,0-.094-.752,1.559,1.559,0,0,0-.329-.63,1.54,1.54,0,0,0-.621-.423,2.686,2.686,0,0,0-.969-.15,8.6,8.6,0,0,0-1.448.113,6.366,6.366,0,0,0-1.072.263l-.282-1.843a8.958,8.958,0,0,1,1.26-.3A9.879,9.879,0,0,1-37.544-120.422Zm8.557,5.134a3.573,3.573,0,0,0,.715,2.36,2.434,2.434,0,0,0,1.975.856,7.845,7.845,0,0,0,.931-.047,6.271,6.271,0,0,0,.63-.1v-5.642a3.524,3.524,0,0,0-.8-.386,3.125,3.125,0,0,0-1.063-.179,2.036,2.036,0,0,0-1.815.846A4.036,4.036,0,0,0-28.987-115.288Zm6.526,4.645a13.479,13.479,0,0,1-1.7.376,13.208,13.208,0,0,1-2.153.169,5.739,5.739,0,0,1-2.088-.357,4.35,4.35,0,0,1-1.57-1.025,4.514,4.514,0,0,1-1-1.617,6.173,6.173,0,0,1-.348-2.135,7.194,7.194,0,0,1,.292-2.116,4.629,4.629,0,0,1,.856-1.627,3.814,3.814,0,0,1,1.373-1.044,4.465,4.465,0,0,1,1.862-.367,4.257,4.257,0,0,1,1.26.169,5.638,5.638,0,0,1,.94.376v-4.721l2.276-.376Zm2.351-4.57a6.18,6.18,0,0,1,.386-2.276,4.779,4.779,0,0,1,1.025-1.627,4.243,4.243,0,0,1,1.467-.978,4.543,4.543,0,0,1,1.693-.329,4.052,4.052,0,0,1,3.169,1.26,5.452,5.452,0,0,1,1.138,3.761q0,.188-.009.423t-.028.423h-6.488a2.594,2.594,0,0,0,.837,1.834,3.18,3.18,0,0,0,2.153.649,7.08,7.08,0,0,0,1.514-.15,6.235,6.235,0,0,0,1.081-.32l.3,1.862a3.642,3.642,0,0,1-.517.2,7.307,7.307,0,0,1-.752.188q-.423.085-.912.141a8.692,8.692,0,0,1-1,.056,6.032,6.032,0,0,1-2.257-.386,4.2,4.2,0,0,1-1.58-1.072,4.393,4.393,0,0,1-.922-1.617A6.6,6.6,0,0,1-20.11-115.213Zm6.6-1.016a2.99,2.99,0,0,0-.132-.893,2.155,2.155,0,0,0-.386-.733,1.823,1.823,0,0,0-.621-.489,1.979,1.979,0,0,0-.875-.179,2.036,2.036,0,0,0-.922.2,2.1,2.1,0,0,0-.668.517,2.364,2.364,0,0,0-.423.733,3.974,3.974,0,0,0-.207.846Z",transform:"translate(578.288 641.008)"})));};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo.1fa10cfe.png";

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logo-small.52e69859.png";

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/error-bg.48c70e55.png";

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/new-index-logo.990afa64.svg";

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/new-indexLogo-text.59feeb9e.svg";

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/header-iron.36774929.jpg";

/***/ }),
/* 1240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AppStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function AppStore(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"29px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 29.97 36.826",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M76.227,44.459a8.368,8.368,0,0,1,3.987-7.021,8.574,8.574,0,0,0-6.752-3.649c-2.84-.3-5.6,1.7-7.042,1.7-1.476,0-3.7-1.67-6.1-1.621a8.989,8.989,0,0,0-7.566,4.613c-3.272,5.663-.832,13.985,2.3,18.562,1.568,2.243,3.4,4.745,5.8,4.657,2.346-.1,3.223-1.494,6.054-1.494,2.806,0,3.629,1.494,6.075,1.438,2.518-.039,4.1-2.252,5.617-4.514a18.5,18.5,0,0,0,2.569-5.23,8.1,8.1,0,0,1-4.938-7.44ZM71.607,30.777a8.235,8.235,0,0,0,1.886-5.9,8.393,8.393,0,0,0-5.426,2.806,7.837,7.837,0,0,0-1.935,5.685A6.933,6.933,0,0,0,71.607,30.777Z",transform:"translate(-51.195 -24.875)"}));}

/***/ }),
/* 1241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = GooglePlay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function GooglePlay(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"28px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28.287 30.175",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1.903 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M52.042.483A3.831,3.831,0,0,0,48.3.492L62.05,13.174l4.618-4.618Z",transform:"translate(-48.302 0)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 1.789)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16.542,30.365a3.517,3.517,0,0,0-.528,1.842V55.112a3.528,3.528,0,0,0,.492,1.8L30.331,43.085Z",transform:"translate(-16.014 -30.365)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(17.036 9.504)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M314.457,163.708l-4.405-2.431-4.95,4.948,6.067,5.6L314.459,170a3.563,3.563,0,0,0,0-6.3Z",transform:"translate(-305.102 -161.277)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1.841 15.788)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M61.109,267.9,47.246,281.764a3.823,3.823,0,0,0,3.8.036l15.722-8.677Z",transform:"translate(-47.246 -267.901)"})))));}

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EzTraderIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EzTraderText; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n  line-height: 1;\n"],["\n  display: block;\n  line-height: 1;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var EzTraderIcon=function EzTraderIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 25.8 25.7",xmlSpace:"preserve",fill:"#FFD503"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"25.6,12.5 24.3,11.2 14.5,1.5 13,0 11.5,1.5 8.5,4.5 7.6,5.4 8.9,6.7 9.4,6.7 12.3,6.7 10.9,5.2  11.5,4.5 13,3 22.7,12.6 21.9,13.4 20.6,14.7 12.8,14.7 11.4,13.2 8.4,13.2 9.8,14.7 11.9,16.8 13.2,16.8 21.5,16.8 22.8,15.5  22.8,15.5 23.6,14.7 25,13.3 25.8,12.6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"16.8,19 16.3,19 13.5,19 14.8,20.5 14.3,21.1 12.8,22.7 3,13 5.1,10.9 5.3,10.8 13,10.8 14.5,12.2  17.5,12.2 16.1,10.8 14,8.7 12.8,8.7 4.3,8.7 4.3,8.8 2.3,10.9 2.1,11 0,13 0.1,13.1 1.5,14.5 11.3,24.2 12.8,25.7 14.3,24.2  17.3,21.1 18.1,20.2"})));};var EzTraderText=function EzTraderText(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{width:"100",height:"30",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 92.6 25.7",xmlSpace:"preserve",fill:"#ffffff"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFD503",d:"M0.1,19.5V6.2H9v2.5H3v2.6h5.3v2.4H3v3.2h6.4v2.5H0.1V19.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFD503",d:"M21.3,8.3c-0.4,0.4-0.9,1-1.5,1.6c-0.6,0.7-1.1,1.4-1.7,2.2c-0.6,0.8-1.2,1.6-1.8,2.4 c-0.6,0.8-1.1,1.6-1.6,2.4h6.8v2.5H11v-1.8c0.4-0.6,0.8-1.4,1.3-2.2s1.1-1.6,1.6-2.4c0.6-0.8,1.1-1.6,1.7-2.4 c0.6-0.8,1.1-1.4,1.6-2h-5.9V6.2h9.9v2.1H21.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M32.3,6.2v1.1H28v12.1h-1.3V7.3h-4.2V6.2H32.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M43.2,10.2c0,1-0.3,1.8-0.8,2.4s-1.2,1-2.1,1.2c0.2,0.3,0.5,0.6,0.8,1s0.7,0.9,1,1.4c0.3,0.5,0.7,1.1,1,1.6 c0.3,0.6,0.6,1.1,0.8,1.6h-1.4c-0.3-0.5-0.6-1-0.9-1.5s-0.6-1-1-1.5c-0.3-0.5-0.6-0.9-0.9-1.3c-0.3-0.4-0.6-0.8-0.8-1.1 c-0.4,0-0.8,0.1-1.2,0.1h-2.1v5.4h-1.3v-13c0.5-0.1,1-0.2,1.6-0.3c0.6-0.1,1.2-0.1,1.7-0.1c1.8,0,3.2,0.3,4.1,1 C42.7,7.8,43.2,8.8,43.2,10.2z M37.8,7.2c-0.5,0-0.9,0-1.3,0s-0.7,0.1-0.9,0.1V13h1.8c0.6,0,1.2,0,1.7-0.1s1-0.2,1.4-0.4 s0.7-0.5,0.9-0.9c0.2-0.4,0.3-0.9,0.3-1.5S41.6,9,41.3,8.6c-0.2-0.4-0.5-0.7-0.9-0.9c-0.4-0.2-0.8-0.4-1.3-0.5 C38.8,7.3,38.3,7.2,37.8,7.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M55.6,19.5c-0.3-0.7-0.5-1.3-0.7-1.9s-0.4-1.2-0.6-1.8h-6.5c-0.2,0.6-0.4,1.2-0.6,1.8s-0.4,1.2-0.7,1.9h-1.4 c0.5-1.4,1-2.7,1.4-3.9s0.9-2.3,1.3-3.4s0.9-2.1,1.3-3.1s0.9-2,1.3-2.9h1.1c0.5,1,0.9,2,1.3,2.9c0.4,1,0.8,2,1.3,3.1 c0.4,1.1,0.9,2.2,1.3,3.4s0.9,2.5,1.5,3.9H55.6z M50.9,7.7C50.4,8.8,50,9.9,49.5,11s-0.9,2.4-1.4,3.7h5.7c-0.5-1.3-1-2.5-1.4-3.7 C51.9,9.9,51.4,8.8,50.9,7.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M69.3,12.8c0,1.1-0.2,2.1-0.5,3c-0.4,0.8-0.9,1.5-1.5,2.1s-1.4,1-2.3,1.3s-1.9,0.4-2.9,0.4 c-0.5,0-1.1,0-1.7-0.1s-1.1-0.1-1.5-0.3V6.5c0.4-0.1,1-0.2,1.5-0.3c0.6-0.1,1.1-0.1,1.7-0.1c1.1,0,2.1,0.1,2.9,0.4 c0.9,0.3,1.7,0.7,2.3,1.3c0.6,0.6,1.1,1.3,1.5,2.1C69.3,10.7,69.3,11.7,69.3,12.8z M60.2,18.3c0.1,0,0.3,0,0.6,0.1 c0.3,0,0.8,0.1,1.5,0.1c1,0,1.8-0.1,2.5-0.4s1.3-0.6,1.8-1.1s0.8-1.1,1.1-1.8c0.2-0.7,0.4-1.5,0.4-2.3c0-0.9-0.1-1.6-0.4-2.3 c-0.2-0.7-0.6-1.3-1.1-1.8s-1.1-0.9-1.8-1.1c-0.7-0.3-1.5-0.5-2.5-0.5c-0.7,0-1.2,0-1.5,0.1c-0.3,0-0.5,0.1-0.6,0.1V18.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M72.3,19.5V6.2h7.6v1.1h-6.3v4.6h5.7V13h-5.7v5.3h6.8v1.1h-8.1V19.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M91.8,10.2c0,1-0.3,1.8-0.8,2.4s-1.2,1-2.1,1.2c0.2,0.3,0.5,0.6,0.8,1s0.7,0.9,1,1.4c0.3,0.5,0.7,1.1,1,1.6 c0.3,0.6,0.6,1.1,0.8,1.6h-1.4c-0.3-0.5-0.6-1-0.9-1.5s-0.6-1-1-1.5c-0.3-0.5-0.6-0.9-0.9-1.3c-0.3-0.4-0.6-0.8-0.8-1.1 c-0.4,0-0.8,0.1-1.2,0.1h-2v5.4h-1.3v-13c0.5-0.1,1-0.2,1.6-0.3c0.6-0.1,1.2-0.1,1.7-0.1c1.8,0,3.2,0.3,4.1,1 C91.3,7.8,91.8,8.8,91.8,10.2z M86.3,7.2c-0.5,0-0.9,0-1.3,0s-0.7,0.1-0.9,0.1V13h1.8c0.6,0,1.2,0,1.7-0.1s1-0.2,1.4-0.4 s0.7-0.5,0.9-0.9c0.2-0.4,0.3-0.9,0.3-1.5S90.2,9,89.9,8.6c-0.2-0.4-0.5-0.7-0.9-0.9c-0.4-0.2-0.8-0.4-1.3-0.5 C87.3,7.3,86.8,7.2,86.3,7.2z"})));};

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = HamburgerMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function HamburgerMenu(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"16px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 14",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-6160,14V12h10v2Zm0-6V6h16V8Zm0-6V0h16V2Z",transform:"translate(6160)"}));}

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n"],["\n  display: block;\n  max-width: 100%;\n  max-height: 100%;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{width:"480",height:"369",viewBox:"19.983 75 480.017 369.467"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("clipPath",{id:"a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h520v520H0z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{"data-name":"ez 1 \u2013 2"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{"data-name":"\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 876","clip-path":"url(#a)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{"data-name":"\u041A\u043E\u043D\u0442\u0443\u0440 2270",d:"M257.378 335L128.999 206.617l44.051-44.051h96.55l35.3 35.3h-30.822l-13.488-13.485h-79.076l-21.837 21.834 97.646 97.643 21.364-21.364-15.255-15.251h34.177l13.768 13.766-53.994 53.995zm89.879-89.878h-99.626l-36.623-36.619h33.115l14.48 14.482h76.917l20.7-20.7-95.634-95.637-21.9 21.9 13.894 13.893h-34.127l-12.638-12.639 54.8-54.8L388.999 203.38l-41.742 41.743z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{"data-name":"\u0421\u0433\u0440\u0443\u043F\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C 877"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{"data-name":"\u041A\u043E\u043D\u0442\u0443\u0440 2272",d:"M196.225 375.591v5.813h-21.368v62.445h-6.541v-62.445h-21.372v-5.811zm54.864 20.487q0 7.683-3.946 12.115a22.263 22.263 0 0 1-10.4 6.4q1.54 1.97 3.994 5.319t5.053 7.338q2.6 3.989 5.1 8.323a85.322 85.322 0 0 1 4.235 8.274h-7.019q-2.021-3.94-4.38-7.88t-4.81-7.632q-2.454-3.694-4.765-6.845l-4.045-5.516q-3.08.3-6.16.3h-10.78v27.575h-6.55v-66.978a45.866 45.866 0 0 1 8.133-1.428q4.668-.443 8.615-.443 13.764 0 20.742 5.319t6.984 15.759zm-26.95-15.267q-3.658 0-6.4.246t-4.573.447v29.056h9.05a78.7 78.7 0 0 0 8.567-.443 20.151 20.151 0 0 0 7.026-1.97 11.581 11.581 0 0 0 4.716-4.383 14.959 14.959 0 0 0 1.733-7.781 14.625 14.625 0 0 0-1.733-7.486 13.3 13.3 0 0 0-4.524-4.679 18.058 18.058 0 0 0-6.4-2.364 42.643 42.643 0 0 0-7.462-.643zm89.608 63.038q-1.907-5.029-3.511-9.672t-3.066-9.042h-32.586q-1.668 4.422-3.268 9.069t-3.383 9.646h-6.834q3.8-10.659 7.179-19.864t6.629-17.418q3.249-8.214 6.453-15.787t6.735-15.188h5.771q3.53 7.581 6.7 15.168t6.428 15.8q3.26 8.21 6.608 17.428t7.369 19.865zm-22.953-60.575q-3.622 8.5-7.053 17.26t-7.1 18.888h28.471q-3.696-10.147-7.196-18.918t-7.122-17.23zm92.643 26.4a39.684 39.684 0 0 1-2.7 15.267 29.292 29.292 0 0 1-7.551 10.831 31.816 31.816 0 0 1-11.6 6.5 48.209 48.209 0 0 1-14.823 2.167q-4.043 0-8.47-.443a50.749 50.749 0 0 1-7.8-1.33v-65.8a43.346 43.346 0 0 1 7.8-1.428q4.428-.443 8.47-.443a48.209 48.209 0 0 1 14.823 2.167 31.816 31.816 0 0 1 11.6 6.5 29.292 29.292 0 0 1 7.556 10.842 39.4 39.4 0 0 1 2.695 15.166zm-46.394 28.265q.577.1 2.936.394a67.975 67.975 0 0 0 7.556.3 35.88 35.88 0 0 0 12.609-2.019 24.41 24.41 0 0 0 9.048-5.762 23.806 23.806 0 0 0 5.486-9.111 37.279 37.279 0 0 0 1.829-12.066 36.832 36.832 0 0 0-1.829-12.016 23.858 23.858 0 0 0-5.486-9.062 24.41 24.41 0 0 0-9.048-5.762 35.881 35.881 0 0 0-12.609-2.019 67.972 67.972 0 0 0-7.556.3q-2.358.3-2.936.394zm61.024 5.91v-68.258h38.5v5.813h-31.951v23.737h28.491v5.713h-28.491v27.183h34.459v5.812zm97.889-47.77q0 7.683-3.946 12.115a22.263 22.263 0 0 1-10.4 6.4q1.54 1.97 3.995 5.319t5.053 7.338q2.6 3.989 5.1 8.323a85.337 85.337 0 0 1 4.235 8.274h-7.026q-2.021-3.94-4.379-7.88t-4.813-7.633q-2.454-3.694-4.764-6.845l-4.043-5.516q-3.08.3-6.16.3h-10.78v27.575h-6.545v-66.978a45.864 45.864 0 0 1 8.133-1.428q4.668-.443 8.615-.443 13.764 0 20.743 5.319t6.983 15.759zm-26.95-15.268q-3.658 0-6.4.246t-4.572.443v29.056h9.048a78.7 78.7 0 0 0 8.567-.443 20.15 20.15 0 0 0 7.026-1.97 11.581 11.581 0 0 0 4.716-4.383 14.958 14.958 0 0 0 1.733-7.781 14.624 14.624 0 0 0-1.733-7.486 13.3 13.3 0 0 0-4.524-4.679 18.058 18.058 0 0 0-6.4-2.364 42.642 42.642 0 0 0-7.461-.639z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{"data-name":"\u041A\u043E\u043D\u0442\u0443\u0440 2271",d:"M20 444.439V375h50.035v13.128H36.678v13.627h29.615v12.826H36.678v16.734h35.816v13.124zm118.245-58.617q-3.425 3.306-8.125 8.567t-9.733 11.473q-5.027 6.212-9.947 12.826t-8.776 12.625h37.756v13.126H81.154v-9.318q2.994-5.11 7.324-11.373t9.034-12.625q4.7-6.363 9.569-12.325t9.033-10.67H82.865V375h55.381z",fill:"#fff"})))));};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/new-index-logo.cd694d94.svg";

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/error-bg.48c70e55.png";

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/new-index-logo-text.91fe259c.svg";

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/header-iron.36774929.jpg";

/***/ }),
/* 1250 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1251 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1253);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createReactCache;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_cache_provider__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_simple_cache_provider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_simple_cache_provider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__ = __webpack_require__(98);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeadlineAwareCacheConsumer=function(_React$Component){_inherits(DeadlineAwareCacheConsumer,_React$Component);function DeadlineAwareCacheConsumer(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeadlineAwareCacheConsumer);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeadlineAwareCacheConsumer.__proto__||Object.getPrototypeOf(DeadlineAwareCacheConsumer)).call.apply(_ref,[this].concat(args))),_this),_this.state={pastDeadline:false,pastPendingThreshold:false},_this.available=false,_this.suspender=null,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeadlineAwareCacheConsumer,[{key:"trackDeadlines",value:function trackDeadlines(){var _this2=this;setTimeout(function(){// Типа если через секунду зарезолвимся, то можно не потеть
if(_this2.available&&_this2.suspender!=null){_this2.setState({pastDeadline:true},function(){setTimeout(function(){if(_this2.available){_this2.setState(function(state){if(state.pastDeadline){return{pastPendingThreshold:true};}else{return null;}});}},1000);});}},1000);}},{key:"componentDidMount",value:function componentDidMount(){this.available=true;if(this.suspender!=null){this.trackDeadlines();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.available=false;}},{key:"render",value:function render(){var _this3=this;if(this.props.preload!=null){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=this.props.preload[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var key=_step.value;this.props.resource.preload(this.props.cache,key);}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}var rendered=null;if(this.suspender==null){try{rendered=this.props.children({get:function get(key){return _this3.props.resource.read(_this3.props.cache,key);}});if(this.state.pastDeadline&&!this.state.pastPendingThreshold){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__["a" /* default */],null);}else{return rendered;}}catch(thing){if((typeof thing==="undefined"?"undefined":_typeof(thing))==="object"&&typeof thing.then==="function"){this.suspender=thing.then(function(){_this3.suspender=null;_this3.forceUpdate();},function(){_this3.suspender=null;_this3.forceUpdate();});if(this.state.pastDeadline){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__["a" /* default */],null);// TODO: дождаться Suspense в реакте
}}else{throw thing;}}}else{if(this.state.pastDeadline){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__["a" /* default */],null);}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Spinners_BrandSpinner__["a" /* default */],null);// TODO: дождаться Suspense в реакте
}}}}]);return DeadlineAwareCacheConsumer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function createReactCache(options){var resource=Object(__WEBPACK_IMPORTED_MODULE_1_simple_cache_provider__["createResource"])(options.load);var cache=Object(__WEBPACK_IMPORTED_MODULE_1_simple_cache_provider__["createCache"])();var CacheContext=__WEBPACK_IMPORTED_MODULE_0_react__["createContext"](cache);function CacheConsumer(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CacheContext.Consumer,null,function(cache){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DeadlineAwareCacheConsumer,{cache:cache,resource:resource,preload:props.preload,children:props.children});});}return{Provider:CacheContext.Provider,Consumer:CacheConsumer};}

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(1256);
} else {
  module.exports = require('./cjs/simple-cache-provider.development.js');
}


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.0
 * simple-cache-provider.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var h=__webpack_require__(0);
function k(g){function f(a,c){var b=d.get(a);if(void 0!==b){if(a=b.get(c),void 0!==a)return a}else b=new Map,d.set(a,b);a={status:0,suspender:null,value:null,error:null};b.set(c,a);return a}function e(a,c){a.status=1;a.suspender=c;c.then(function(b){a.status=2;a.suspender=null;a.value=b},function(b){a.status=3;a.suspender=null;a.error=b})}var d=new Map;return{invalidate:function(){g()},preload:function(a,c,b,d){a=f(a,c);switch(a.status){case 0:b=b(d),e(a,b)}},read:function(a,c,b,d){a=f(a,c);switch(a.status){case 0:throw b=
b(d),e(a,b),b;case 1:throw a.suspender;case 2:return a.value;default:throw a.error;}}}}var l=k(function(){}),m=h.createContext(l);exports.createCache=k;exports.createResource=function(g,f){var e={read:function(d,a){if(void 0===f)return d.read(e,a,g,a);var c=f(a);return d.read(e,c,g,a)},preload:function(d,a){if(void 0===f)d.preload(e,a,g,a);else{var c=f(a);d.preload(e,c,g,a)}}};return e};exports.SimpleCache=m;


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.20
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.20',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            ], [NAME, VERSION], [

            /(konqueror)\/([\w\.]+)/i                                           // Konqueror
            ], [[NAME, 'Konqueror'], VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
            ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
            ], [[NAME, 'Sailfish Browser'], VERSION], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            /(lenovo)[_\s-]?([\w-]+)/i
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
                                                                                // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            /(mz)-([\w-]{2,})/i
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
            ], [[TYPE, SMARTTV]], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /webkit\/537\.36.+chrome\/(?!27)/i                                  // Blink
            ], [[NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
                                                                                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/fb-icon.dd4a9bf5.svg";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/gp-icon.5c4b24a2.svg";

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emotion_unitless__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__emotion_hash__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet__);






var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (__WEBPACK_IMPORTED_MODULE_1__emotion_unitless__["a" /* default */][key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};

if (false) {
  var contentValuePattern = /(attr|calc|counters?|url)\(/;
  var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
  var oldProcessStyleValue = processStyleValue;

  processStyleValue = function processStyleValue(key, value) {
    if (key === 'content') {
      if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
        console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
      }
    }

    return oldProcessStyleValue(key, value);
  };
}

var classnames = function classnames(args) {
  var len = args.length;
  var i = 0;
  var cls = '';

  for (; i < len; i++) {
    var arg = args[i];
    if (arg == null) continue;
    var toAdd = void 0;

    switch (typeof arg) {
      case 'boolean':
        break;

      case 'function':
        if (false) {
          console.error('Passing functions to cx is deprecated and will be removed in the next major version of Emotion.\n' + 'Please call the function before passing it to cx.');
        }

        toAdd = classnames([arg()]);
        break;

      case 'object':
        {
          if (Array.isArray(arg)) {
            toAdd = classnames(arg);
          } else {
            toAdd = '';

            for (var k in arg) {
              if (arg[k] && k) {
                toAdd && (toAdd += ' ');
                toAdd += k;
              }
            }
          }

          break;
        }

      default:
        {
          toAdd = arg;
        }
    }

    if (toAdd) {
      cls && (cls += ' ');
      cls += toAdd;
    }
  }

  return cls;
};
var isBrowser = typeof document !== 'undefined';

/*

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance
- 'polyfills' on server side

// usage

import StyleSheet from 'glamor/lib/sheet'
let styleSheet = new StyleSheet()

styleSheet.inject()
- 'injects' the stylesheet into the page (or into memory if on server)

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function makeStyleTag(opts) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', opts.key || '');

  if (opts.nonce !== undefined) {
    tag.setAttribute('nonce', opts.nonce);
  }

  tag.appendChild(document.createTextNode('')) // $FlowFixMe
  ;
  (opts.container !== undefined ? opts.container : document.head).appendChild(tag);
  return tag;
}

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(options) {
    this.isSpeedy = "production" === 'production'; // the big drawback here is that the css won't be editable in devtools

    this.tags = [];
    this.ctr = 0;
    this.opts = options;
  }

  var _proto = StyleSheet.prototype;

  _proto.inject = function inject() {
    if (this.injected) {
      throw new Error('already injected!');
    }

    this.tags[0] = makeStyleTag(this.opts);
    this.injected = true;
  };

  _proto.speedy = function speedy(bool) {
    if (this.ctr !== 0) {
      // cannot change speedy mode after inserting any rule to sheet. Either call speedy(${bool}) earlier in your app, or call flush() before speedy(${bool})
      throw new Error("cannot change speedy now");
    }

    this.isSpeedy = !!bool;
  };

  _proto.insert = function insert(rule, sourceMap) {
    // this is the ultrafast version, works across browsers
    if (this.isSpeedy) {
      var tag = this.tags[this.tags.length - 1];
      var sheet = sheetForTag(tag);

      try {
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
        if (false) {
          console.warn('illegal rule', rule); // eslint-disable-line no-console
        }
      }
    } else {
      var _tag = makeStyleTag(this.opts);

      this.tags.push(_tag);

      _tag.appendChild(document.createTextNode(rule + (sourceMap || '')));
    }

    this.ctr++;

    if (this.ctr % 65000 === 0) {
      this.tags.push(makeStyleTag(this.opts));
    }
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0; // todo - look for remnants in document.styleSheets

    this.injected = false;
  };

  return StyleSheet;
}();

function createEmotion(context, options) {
  if (context.__SECRET_EMOTION__ !== undefined) {
    return context.__SECRET_EMOTION__;
  }

  if (options === undefined) options = {};
  var key = options.key || 'css';

  if (false) {
    if (/[^a-z-]/.test(key)) {
      throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
    }
  }

  var current;

  function insertRule(rule) {
    current += rule;

    if (isBrowser) {
      sheet.insert(rule, currentSourceMap);
    }
  }

  var insertionPlugin = __WEBPACK_IMPORTED_MODULE_4_stylis_rule_sheet___default()(insertRule);
  var stylisOptions;

  if (options.prefix !== undefined) {
    stylisOptions = {
      prefix: options.prefix
    };
  }

  var caches = {
    registered: {},
    inserted: {},
    nonce: options.nonce,
    key: key
  };
  var sheet = new StyleSheet(options);

  if (isBrowser) {
    // 🚀
    sheet.inject();
  }

  var stylis = new __WEBPACK_IMPORTED_MODULE_3__emotion_stylis__["a" /* default */](stylisOptions);
  stylis.use(options.stylisPlugins)(insertionPlugin);
  var currentSourceMap = '';

  function handleInterpolation(interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    switch (typeof interpolation) {
      case 'boolean':
        return '';

      case 'function':
        if (interpolation.__emotion_styles !== undefined) {
          var selector = interpolation.toString();

          if (selector === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          return selector;
        }

        if (this === undefined && "production" !== 'production') {
          console.error('Interpolating functions in css calls is deprecated and will be removed in the next major version of Emotion.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
        }

        return handleInterpolation.call(this, this === undefined ? interpolation() : // $FlowFixMe
        interpolation(this.mergedProps, this.context), couldBeSelectorInterpolation);

      case 'object':
        return createStringFromObject.call(this, interpolation);

      default:
        var cached = caches.registered[interpolation];
        return couldBeSelectorInterpolation === false && cached !== undefined ? cached : interpolation;
    }
  }

  var objectToStringCache = new WeakMap();

  function createStringFromObject(obj) {
    if (objectToStringCache.has(obj)) {
      // $FlowFixMe
      return objectToStringCache.get(obj);
    }

    var string = '';

    if (Array.isArray(obj)) {
      obj.forEach(function (interpolation) {
        string += handleInterpolation.call(this, interpolation, false);
      }, this);
    } else {
      Object.keys(obj).forEach(function (key) {
        if (typeof obj[key] !== 'object') {
          if (caches.registered[obj[key]] !== undefined) {
            string += key + "{" + caches.registered[obj[key]] + "}";
          } else {
            string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
          }
        } else {
          if (key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(obj[key]) && typeof obj[key][0] === 'string' && caches.registered[obj[key][0]] === undefined) {
            obj[key].forEach(function (value) {
              string += processStyleName(key) + ":" + processStyleValue(key, value) + ";";
            });
          } else {
            string += key + "{" + handleInterpolation.call(this, obj[key], false) + "}";
          }
        }
      }, this);
    }

    objectToStringCache.set(obj, string);
    return string;
  }

  var name;
  var stylesWithLabel;
  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;

  var createClassName = function createClassName(styles, identifierName) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__emotion_hash__["a" /* default */])(styles + identifierName) + identifierName;
  };

  if (false) {
    var oldCreateClassName = createClassName;
    var sourceMappingUrlPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g;

    createClassName = function createClassName(styles, identifierName) {
      return oldCreateClassName(styles.replace(sourceMappingUrlPattern, function (sourceMap) {
        currentSourceMap = sourceMap;
        return '';
      }), identifierName);
    };
  }

  var createStyles = function createStyles(strings) {
    var stringMode = true;
    var styles = '';
    var identifierName = '';

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation.call(this, strings, false);
    } else {
      styles += strings[0];
    }

    for (var _len = arguments.length, interpolations = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    interpolations.forEach(function (interpolation, i) {
      styles += handleInterpolation.call(this, interpolation, styles.charCodeAt(styles.length - 1) === 46 // .
      );

      if (stringMode === true && strings[i + 1] !== undefined) {
        styles += strings[i + 1];
      }
    }, this);
    stylesWithLabel = styles;
    styles = styles.replace(labelPattern, function (match, p1) {
      identifierName += "-" + p1;
      return '';
    });
    name = createClassName(styles, identifierName);
    return styles;
  };

  if (false) {
    var oldStylis = stylis;

    stylis = function stylis(selector, styles) {
      oldStylis(selector, styles);
      currentSourceMap = '';
    };
  }

  function insert(scope, styles) {
    if (caches.inserted[name] === undefined) {
      current = '';
      stylis(scope, styles);
      caches.inserted[name] = current;
    }
  }

  var css = function css() {
    var styles = createStyles.apply(this, arguments);
    var selector = key + "-" + name;

    if (caches.registered[selector] === undefined) {
      caches.registered[selector] = stylesWithLabel;
    }

    insert("." + selector, styles);
    return selector;
  };

  var keyframes = function keyframes() {
    var styles = createStyles.apply(this, arguments);
    var animation = "animation-" + name;
    insert('', "@keyframes " + animation + "{" + styles + "}");
    return animation;
  };

  var injectGlobal = function injectGlobal() {
    var styles = createStyles.apply(this, arguments);
    insert('', styles);
  };

  function getRegisteredStyles(registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (caches.registered[className] !== undefined) {
        registeredStyles.push(className);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }

  function merge(className, sourceMap) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles, sourceMap);
  }

  function cx() {
    for (var _len2 = arguments.length, classNames = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      classNames[_key2] = arguments[_key2];
    }

    return merge(classnames(classNames));
  }

  function hydrateSingleId(id) {
    caches.inserted[id] = true;
  }

  function hydrate(ids) {
    ids.forEach(hydrateSingleId);
  }

  function flush() {
    if (isBrowser) {
      sheet.flush();
      sheet.inject();
    }

    caches.inserted = {};
    caches.registered = {};
  }

  if (isBrowser) {
    var chunks = document.querySelectorAll("[data-emotion-" + key + "]");
    Array.prototype.forEach.call(chunks, function (node) {
      // $FlowFixMe
      sheet.tags[0].parentNode.insertBefore(node, sheet.tags[0]); // $FlowFixMe

      node.getAttribute("data-emotion-" + key).split(' ').forEach(hydrateSingleId);
    });
  }

  var emotion = {
    flush: flush,
    hydrate: hydrate,
    cx: cx,
    merge: merge,
    getRegisteredStyles: getRegisteredStyles,
    injectGlobal: injectGlobal,
    keyframes: keyframes,
    css: css,
    sheet: sheet,
    caches: caches
  };
  context.__SECRET_EMOTION__ = emotion;
  return emotion;
}

/* harmony default export */ __webpack_exports__["a"] = (createEmotion);


/***/ }),
/* 1261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ __webpack_exports__["a"] = (unitlessKeys);


/***/ }),
/* 1262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash2_32_gc(str) {
  var l = str.length,
      h = l ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return (h >>> 0).toString(36);
}

/* harmony default export */ __webpack_exports__["a"] = (murmurhash2_32_gc);


/***/ }),
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e, m).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e, m).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        switch (d.constructor) {
          case Array:
            for (var c = 0, e = d.length; c < e; ++c) {
              T(d[c]);
            }

            break;

          case Function:
            S[A++] = d;
            break;

          case Boolean:
            Y = !!d | 0;
        }

    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ __webpack_exports__["a"] = (stylis_min);


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransition = _interopRequireDefault(__webpack_require__(1265));

var _ReplaceTransition = _interopRequireDefault(__webpack_require__(1267));

var _TransitionGroup = _interopRequireDefault(__webpack_require__(589));

var _Transition = _interopRequireDefault(__webpack_require__(587));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  Transition: _Transition.default,
  TransitionGroup: _TransitionGroup.default,
  ReplaceTransition: _ReplaceTransition.default,
  CSSTransition: _CSSTransition.default
};

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(6));

var _addClass = _interopRequireDefault(__webpack_require__(585));

var _removeClass = _interopRequireDefault(__webpack_require__(586));

var _react = _interopRequireDefault(__webpack_require__(0));

var _Transition = _interopRequireDefault(__webpack_require__(587));

var _PropTypes = __webpack_require__(588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass.default)(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass.default)(node, c);
  });
};

var propTypes =  false ? _extends({}, _Transition.default.propTypes, {
  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};;
/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 */

var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');

      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    };

    _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    };

    _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');

      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    };

    _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');

      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;
      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';
      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';
      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$getClassNames7 = this.getClassNames(type),
        className = _this$getClassNames7.className,
        activeClassName = _this$getClassNames7.activeClassName,
        doneClassName = _this$getClassNames7.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */

      addClass(node, className);
    }
  };

  _proto.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;
    return _react.default.createElement(_Transition.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};
var _default = CSSTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = exports["default"];

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = __webpack_require__(30);

var _TransitionGroup = _interopRequireDefault(__webpack_require__(589));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var propTypes =  false ? {
  in: _propTypes.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};;
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);

    var _React$Children$toArr = _react.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : _react.default.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(_react.default.Component);

ReplaceTransition.propTypes =  false ? propTypes : {};
var _default = ReplaceTransition;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */


function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!(0, _react.isValidElement)(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, {
        in: false
      });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 1269 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1270 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 1271 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/XAG2.5b0fb6af.svg";

/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/XAU2.b25f33fa.svg";

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BCH.9e6eabb1.svg";

/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/BTC.70e23ad5.svg";

/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ETH.28bb188b.svg";

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/LTC.e52f856a.svg";

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/world_flag.5bcf8e75.svg";

/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/country.bc6e867b.svg";

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parsePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(88);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };




function parsePhoneNumber(text, defaultCountry, metadata) {
	if (isObject(defaultCountry)) {
		metadata = defaultCountry;
		defaultCountry = undefined;
	}
	return Object(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* default */])(text, { defaultCountry: defaultCountry, v2: true }, metadata);
}

// so istanbul will show this as "branch not covered".
/* istanbul ignore next */
var isObject = function isObject(_) {
	return (typeof _ === 'undefined' ? 'undefined' : _typeof(_)) === 'object';
};
//# sourceMappingURL=parsePhoneNumber.js.map

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

module.exports = function cmp (a, b) {
    var pa = a.split('.');
    var pb = b.split('.');
    for (var i = 0; i < 3; i++) {
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    return 0;
};


/***/ }),
/* 1282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getExampleNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__ = __webpack_require__(192);


function getExampleNumber(country, examples, metadata) {
	return new __WEBPACK_IMPORTED_MODULE_0__PhoneNumber__["a" /* default */](country, examples[country], metadata);
}
//# sourceMappingURL=getExampleNumber.js.map

/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNumberForRegion;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNumberType__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__(159);



/**
 * Checks if a given phone number is valid.
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters.
 * If the `number` is an object, it is used as is.
 *
 * The `country` argument is the country the number must belong to.
 * This is a stricter version of `isValidNumber(number, defaultCountry)`.
 * Though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Doesn't accept `number` object, only `number` string with a `country` string.
 */
function isValidNumberForRegion(number, country, _metadata) {
  if (typeof number !== 'string') {
    throw new TypeError('number must be a string');
  }

  if (typeof country !== 'string') {
    throw new TypeError('country must be a string');
  }

  var _sort_out_arguments = Object(__WEBPACK_IMPORTED_MODULE_0__getNumberType__["c" /* sort_out_arguments */])(number, country, _metadata),
      input = _sort_out_arguments.input,
      metadata = _sort_out_arguments.metadata;

  return input.country === country && Object(__WEBPACK_IMPORTED_MODULE_1__validate__["a" /* default */])(input, metadata.metadata);
}
//# sourceMappingURL=isValidNumberForRegion.js.map

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = findNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findPhoneNumbers__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__ = __webpack_require__(381);



function findNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = Object(__WEBPACK_IMPORTED_MODULE_0__findPhoneNumbers__["d" /* sort_out_arguments */])(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	var matcher = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__["a" /* default */](text, options, metadata);

	var results = [];
	while (matcher.hasNext()) {
		results.push(matcher.next());
	}
	return results;
}
//# sourceMappingURL=findNumbers.js.map

/***/ }),
/* 1285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export containsMoreThanOneSlashInNationalNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__parse__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validate__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util__ = __webpack_require__(257);






/**
 * Leniency when finding potential phone numbers in text segments
 * The levels here are ordered in increasing strictness.
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  /**
   * Phone numbers accepted are "possible", but not necessarily "valid".
   */
  POSSIBLE: function POSSIBLE(number, candidate, metadata) {
    return true;
  },


  /**
   * Phone numbers accepted are "possible" and "valid".
   * Numbers written in national format must have their national-prefix
   * present if it is usually written for a number of this type.
   */
  VALID: function VALID(number, candidate, metadata) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_1__validate__["a" /* default */])(number, metadata) || !containsOnlyValidXChars(number, candidate.toString(), metadata)) {
      return false;
    }

    // Skipped for simplicity.
    // return isNationalPrefixPresentIfRequired(number, metadata)
    return true;
  },


  /**
   * Phone numbers accepted are "valid" and
   * are grouped in a possible way for this locale. For example, a US number written as
   * "65 02 53 00 00" and "650253 0000" are not accepted at this leniency level, whereas
   * "650 253 0000", "650 2530000" or "6502530000" are.
   * Numbers with more than one '/' symbol in the national significant number
   * are also dropped at this level.
   *
   * Warning: This level might result in lower coverage especially for regions outside of
   * country code "+1". If you are not sure about which level to use,
   * email the discussion group libphonenumber-discuss@googlegroups.com.
   */
  STRICT_GROUPING: function STRICT_GROUPING(number, candidate, metadata) {
    var candidateString = candidate.toString();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__validate__["a" /* default */])(number, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsRemainGrouped);
  },


  /**
   * Phone numbers accepted are {@linkplain PhoneNumberUtil#isValidNumber(PhoneNumber) valid} and
   * are grouped in the same way that we would have formatted it, or as a single block. For
   * example, a US number written as "650 2530000" is not accepted at this leniency level, whereas
   * "650 253 0000" or "6502530000" are.
   * Numbers with more than one '/' symbol are also dropped at this level.
   * <p>
   * Warning: This level might result in lower coverage especially for regions outside of country
   * code "+1". If you are not sure about which level to use, email the discussion group
   * libphonenumber-discuss@googlegroups.com.
   */
  EXACT_GROUPING: function EXACT_GROUPING(number, candidate, metadata) {
    var candidateString = candidate.toString();

    if (!Object(__WEBPACK_IMPORTED_MODULE_1__validate__["a" /* default */])(number, metadata) || !containsOnlyValidXChars(number, candidateString, metadata) || containsMoreThanOneSlashInNationalNumber(number, candidateString) || !isNationalPrefixPresentIfRequired(number, metadata)) {
      return false;
    }

    return checkNumberGroupingIsValid(number, candidate, metadata, allNumberGroupsAreExactlyPresent);
  }
});

function containsOnlyValidXChars(number, candidate, metadata) {
  // The characters 'x' and 'X' can be (1) a carrier code, in which case they always precede the
  // national significant number or (2) an extension sign, in which case they always precede the
  // extension number. We assume a carrier code is more than 1 digit, so the first case has to
  // have more than 1 consecutive 'x' or 'X', whereas the second case can only have exactly 1 'x'
  // or 'X'. We ignore the character if it appears as the last character of the string.
  for (var index = 0; index < candidate.length - 1; index++) {
    var charAtIndex = candidate.charAt(index);

    if (charAtIndex === 'x' || charAtIndex === 'X') {
      var charAtNextIndex = candidate.charAt(index + 1);

      if (charAtNextIndex === 'x' || charAtNextIndex === 'X') {
        // This is the carrier code case, in which the 'X's always precede the national
        // significant number.
        index++;
        if (util.isNumberMatch(number, candidate.substring(index)) != MatchType.NSN_MATCH) {
          return false;
        }
        // This is the extension sign case, in which the 'x' or 'X' should always precede the
        // extension number.
      } else if (parseDigits(candidate.substring(index)) !== number.ext) {
        return false;
      }
    }
  }

  return true;
}

function isNationalPrefixPresentIfRequired(number, _metadata) {
  // First, check how we deduced the country code. If it was written in international format, then
  // the national prefix is not required.
  if (number.getCountryCodeSource() != 'FROM_DEFAULT_COUNTRY') {
    return true;
  }

  var phoneNumberRegion = util.getRegionCodeForCountryCode(number.getCountryCode());

  var metadata = util.getMetadataForRegion(phoneNumberRegion);
  if (metadata == null) {
    return true;
  }

  // Check if a national prefix should be present when formatting this number.
  var nationalNumber = util.getNationalSignificantNumber(number);
  var formatRule = util.chooseFormattingPatternForNumber(metadata.numberFormats(), nationalNumber);

  // To do this, we check that a national prefix formatting rule was present
  // and that it wasn't just the first-group symbol ($1) with punctuation.
  if (formatRule && formatRule.getNationalPrefixFormattingRule().length > 0) {
    if (formatRule.getNationalPrefixOptionalWhenFormatting()) {
      // The national-prefix is optional in these cases, so we don't need to check if it was
      // present.
      return true;
    }

    if (PhoneNumberUtil.formattingRuleHasFirstGroupOnly(formatRule.getNationalPrefixFormattingRule())) {
      // National Prefix not needed for this number.
      return true;
    }

    // Normalize the remainder.
    var rawInputCopy = PhoneNumberUtil.normalizeDigitsOnly(number.getRawInput());

    // Check if we found a national prefix and/or carrier code at the start of the raw input, and
    // return the result.
    return util.maybeStripNationalPrefixAndCarrierCode(rawInputCopy, metadata, null);
  }

  return true;
}

function containsMoreThanOneSlashInNationalNumber(number, candidate) {
  var firstSlashInBodyIndex = candidate.indexOf('/');
  if (firstSlashInBodyIndex < 0) {
    // No slashes, this is okay.
    return false;
  }

  // Now look for a second one.
  var secondSlashInBodyIndex = candidate.indexOf('/', firstSlashInBodyIndex + 1);
  if (secondSlashInBodyIndex < 0) {
    // Only one slash, this is okay.
    return false;
  }

  // If the first slash is after the country calling code, this is permitted.
  var candidateHasCountryCode = number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITH_PLUS_SIGN || number.getCountryCodeSource() === CountryCodeSource.FROM_NUMBER_WITHOUT_PLUS_SIGN;

  if (candidateHasCountryCode && PhoneNumberUtil.normalizeDigitsOnly(candidate.substring(0, firstSlashInBodyIndex)) === String(number.getCountryCode())) {
    // Any more slashes and this is illegal.
    return candidate.slice(secondSlashInBodyIndex + 1).indexOf('/') >= 0;
  }

  return true;
}

function checkNumberGroupingIsValid(number, candidate, metadata, checkGroups) {
  // TODO: Evaluate how this works for other locales (testing has been limited to NANPA regions)
  // and optimise if necessary.
  var normalizedCandidate = normalizeDigits(candidate, true /* keep non-digits */);
  var formattedNumberGroups = getNationalNumberGroups(metadata, number, null);
  if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
    return true;
  }

  // If this didn't pass, see if there are any alternate formats, and try them instead.
  var alternateFormats = MetadataManager.getAlternateFormatsForCountry(number.getCountryCode());

  if (alternateFormats) {
    for (var _iterator = alternateFormats.numberFormats(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var alternateFormat = _ref;

      formattedNumberGroups = getNationalNumberGroups(metadata, number, alternateFormat);

      if (checkGroups(metadata, number, normalizedCandidate, formattedNumberGroups)) {
        return true;
      }
    }
  }

  return false;
}

/**
 * Helper method to get the national-number part of a number, formatted without any national
 * prefix, and return it as a set of digit blocks that would be formatted together.
 */
function getNationalNumberGroups(metadata, number, formattingPattern) {
  if (formattingPattern) {
    // We format the NSN only, and split that according to the separator.
    var nationalSignificantNumber = util.getNationalSignificantNumber(number);
    return util.formatNsnUsingPattern(nationalSignificantNumber, formattingPattern, 'RFC3966', metadata).split('-');
  }

  // This will be in the format +CC-DG;ext=EXT where DG represents groups of digits.
  var rfc3966Format = formatNumber(number, 'RFC3966', metadata);

  // We remove the extension part from the formatted string before splitting it into different
  // groups.
  var endIndex = rfc3966Format.indexOf(';');
  if (endIndex < 0) {
    endIndex = rfc3966Format.length;
  }

  // The country-code will have a '-' following it.
  var startIndex = rfc3966Format.indexOf('-') + 1;
  return rfc3966Format.slice(startIndex, endIndex).split('-');
}

function allNumberGroupsAreExactlyPresent(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var candidateGroups = normalizedCandidate.split(NON_DIGITS_PATTERN);

  // Set this to the last group, skipping it if the number has an extension.
  var candidateNumberGroupIndex = number.hasExtension() ? candidateGroups.length - 2 : candidateGroups.length - 1;

  // First we check if the national significant number is formatted as a block.
  // We use contains and not equals, since the national significant number may be present with
  // a prefix such as a national number prefix, or the country code itself.
  if (candidateGroups.length == 1 || candidateGroups[candidateNumberGroupIndex].contains(util.getNationalSignificantNumber(number))) {
    return true;
  }

  // Starting from the end, go through in reverse, excluding the first group, and check the
  // candidate and number groups are the same.
  var formattedNumberGroupIndex = formattedNumberGroups.length - 1;
  while (formattedNumberGroupIndex > 0 && candidateNumberGroupIndex >= 0) {
    if (candidateGroups[candidateNumberGroupIndex] !== formattedNumberGroups[formattedNumberGroupIndex]) {
      return false;
    }
    formattedNumberGroupIndex--;
    candidateNumberGroupIndex--;
  }

  // Now check the first group. There may be a national prefix at the start, so we only check
  // that the candidate group ends with the formatted number group.
  return candidateNumberGroupIndex >= 0 && Object(__WEBPACK_IMPORTED_MODULE_3__util__["a" /* endsWith */])(candidateGroups[candidateNumberGroupIndex], formattedNumberGroups[0]);
}

function allNumberGroupsRemainGrouped(metadata, number, normalizedCandidate, formattedNumberGroups) {
  var fromIndex = 0;
  if (number.getCountryCodeSource() !== CountryCodeSource.FROM_DEFAULT_COUNTRY) {
    // First skip the country code if the normalized candidate contained it.
    var countryCode = String(number.getCountryCode());
    fromIndex = normalizedCandidate.indexOf(countryCode) + countryCode.length();
  }

  // Check each group of consecutive digits are not broken into separate groupings in the
  // {@code normalizedCandidate} string.
  for (var i = 0; i < formattedNumberGroups.length; i++) {
    // Fails if the substring of {@code normalizedCandidate} starting from {@code fromIndex}
    // doesn't contain the consecutive digits in formattedNumberGroups[i].
    fromIndex = normalizedCandidate.indexOf(formattedNumberGroups[i], fromIndex);
    if (fromIndex < 0) {
      return false;
    }
    // Moves {@code fromIndex} forward.
    fromIndex += formattedNumberGroups[i].length();
    if (i == 0 && fromIndex < normalizedCandidate.length()) {
      // We are at the position right after the NDC. We get the region used for formatting
      // information based on the country code in the phone number, rather than the number itself,
      // as we do not need to distinguish between different countries with the same country
      // calling code and this is faster.
      var region = util.getRegionCodeForCountryCode(number.getCountryCode());
      if (util.getNddPrefixForRegion(region, true) != null && Character.isDigit(normalizedCandidate.charAt(fromIndex))) {
        // This means there is no formatting symbol after the NDC. In this case, we only
        // accept the number if there is no formatting symbol at all in the number, except
        // for extensions. This is only important for countries with national prefixes.
        var nationalSignificantNumber = util.getNationalSignificantNumber(number);
        return Object(__WEBPACK_IMPORTED_MODULE_3__util__["c" /* startsWith */])(normalizedCandidate.slice(fromIndex - formattedNumberGroups[i].length), nationalSignificantNumber);
      }
    }
  }

  // The check here makes sure that we haven't mistakenly already used the extension to
  // match the last group of the subscriber number. Note the extension cannot have
  // formatting in-between digits.
  return normalizedCandidate.slice(fromIndex).contains(number.getExtension());
}

function parseDigits(string) {
  var result = '';

  // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.
  for (var _iterator2 = string.split(''), _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
    var _ref2;

    if (_isArray2) {
      if (_i2 >= _iterator2.length) break;
      _ref2 = _iterator2[_i2++];
    } else {
      _i2 = _iterator2.next();
      if (_i2.done) break;
      _ref2 = _i2.value;
    }

    var character = _ref2;

    var digit = Object(__WEBPACK_IMPORTED_MODULE_2__common__["j" /* parseDigit */])(character);
    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=Leniency.js.map

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = searchNumbers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__findPhoneNumbers__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__ = __webpack_require__(381);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/**
 * @return ES6 `for ... of` iterator.
 */
function searchNumbers(arg_1, arg_2, arg_3, arg_4) {
	var _sort_out_arguments = Object(__WEBPACK_IMPORTED_MODULE_0__findPhoneNumbers__["d" /* sort_out_arguments */])(arg_1, arg_2, arg_3, arg_4),
	    text = _sort_out_arguments.text,
	    options = _sort_out_arguments.options,
	    metadata = _sort_out_arguments.metadata;

	var matcher = new __WEBPACK_IMPORTED_MODULE_1__PhoneNumberMatcher__["a" /* default */](text, options, metadata);

	return _defineProperty({}, Symbol.iterator, function () {
		return {
			next: function next() {
				if (matcher.hasNext()) {
					return {
						done: false,
						value: matcher.next()
					};
				}
				return {
					done: true
				};
			}
		};
	});
}
//# sourceMappingURL=searchNumbers.js.map

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatIncompletePhoneNumber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsYouType__ = __webpack_require__(382);


/**
 * Formats a (possibly incomplete) phone number.
 * The phone number can be either in E.164 format
 * or in a form of national number digits.
 * @param {string} value - A possibly incomplete phone number. Either in E.164 format or in a form of national number digits.
 * @param {string?} country - Two-letter ("ISO 3166-1 alpha-2") country code.
 * @return {string} Formatted (possibly incomplete) phone number.
 */
function formatIncompletePhoneNumber(value, country, metadata) {
  if (!metadata) {
    metadata = country;
    country = undefined;
  }
  return new __WEBPACK_IMPORTED_MODULE_0__AsYouType__["a" /* default */](country, metadata).input(value);
}
//# sourceMappingURL=formatIncompletePhoneNumber.js.map

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAASCAYAAAHZKUU2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgJJREFUeNpivHz5MhMDA8NfBghgYgESvEAsDsRSQMwHEvgCxB9gKgACiBGo5T8DjAfEjEA8F0SDlMJkkgECCKSMH8goBeI+IH4HxOxA3AjE7UxQVRxIVv+D8hkAAgjFAmTAhMRmhGIUCUaoA/7DJFmgEv+RVP9HlmBAcjIYAAQQzNkw7wqjK0ACb6BWC6A7TAXqXw0gfg/EQlC+ERAzY/MNCLBB6V/QAP+LJs6A7u5/SOEPAjxILgCBHzCFAAEE8tMlIK3LQBw4z4SkeAbU/dhwCVSNIQuSn0Du1gFiWzRTlwJxFBALggIFOWJAmp4C8WsgFoWK3wBiMahf+NE9DgLS0KD9B/UoG7oadA0voQqrgFgRiD2A+BMogaNrAEXQHyDeC8QuSAaUQZP5f2iqgEcgSHEtmmIYSAbiaCB+C4uH69BkQQy4BBBgLGiJkRZAAD0drkNir4DmSUYiMMicViS923FlXRAIhmoCJYgAaMzcAmJlHK4EpbaD0OgGRUQqVH8kPktgYDkQcwKxLDTK7wDxdyAOgcpbQJPHW6gaHWh6moPNMBYC4cmClGVBDlqNJPcLSrPicSxenyRCg+o+VI08tFBFjgcQXwCIQSntEjR55hBjyVZo4p4HxMugvgAFxSMcjvkIxG5QS+uBeBJU/1p85SlNkjAL1DVMUK9TG4Ac/x8ALuVyPyqdXwsAAAAASUVORK5CYII="

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAYCAYAAAFme1bjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlpJREFUeNpivHz5MgMMMEFpNxDBAuXsAOIPAAHECFXGCsS/Qcq4QAwg/g/ifIUqZQQIIEYk00AqbIB4J0gCpuU/EH8D4l0gQSB+xwQVYIRKvoPqFgIIIGSjQIATiL8jO5IBqmMlEAsjO/g/1DgQ2ATEiUxogiCgAMRvQRLPgLgBKngJiPVgdkgDcSpUpx5MG0AAobsK2bOwUBABGY0epMgK/0NDhhGK50PFUHwBM9EdzeEg4Ael/wHxbZANh5Gs34HFeZegIQtSqw6ywRYq8RSI+aDWgzDIc7Kg4EfWzYLElkbSCIoSfWyhARBAuEKJAWrzYWQBJhwKDwLxISA+R0gxSKEpELMDsSEQn8elGKYQFLS/oBoMYBpYcCiEAZiGnyANLHgUImsABeVjFqhCOyDOwOFZUZBCIDZhgioEgRlAnIZF4SuQQiA+C1KsAZW4D8STkDTAFBqDFMJC4yYo/oFYEeqZmdDED1N4Dj3obkE1wEA9ukL0cEbWgKEQBAACDF/awJWztgGxPTSiXJFzFzpgIsHQg9A8YwZ1JSjpvIGyhckxHNlQU2jO5YIGAyiwNyNZch7dEiYSDd2FltL8kCwxQLeEiQxDsSVnbJbsQS6wtiOlXg9o2U8K4IeWzCDwHojLQS5fBnWpHZLC7ViyBgOevHUJmshloFlHCJZ9GqFVAEoSheaMf3gswWkocoTehBaYGkiWLAFiNiB+iMUSkKEXkQw1RjcUXyZSA+L9QCyFJyhAYeqCLVcSSoq3oD5RxxJc75Fceo5QZLDgkYNZAkoBcUC8Goivk5J8AL3lnZYtuLUIAAAAAElFTkSuQmCC"

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAASCAYAAAHOC9X/AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAaZJREFUeNpivHz5MgMU8LBAGf9BBIzDCCIAAogRquwzE1T0GwtUHSNAADEimfAfqv4/E5JAIswggABCVhkJxFVArAuzBgQWAbEgEJ9GthvE/gTEXixQgX8wR4EAE7oACAAEELJFMDAbiFPQxHiYGDABSNF9qIkwU28hK2SEhRAQKELZINwFxNIoQQgEz4FYCostDAABhM2NIJP3ArEVELcCcTM2Rf/R+HfQPdEApS2gJt4DYhV0RTJQ+hSU3occ5egAFMB3QKbAQhwGZgFxMhIfpOAPyCAmJAWpQLwNiKOQApUViP+CFPVAFTwE4h1AvBzdbpCbspF89AKbAwECDFs4oQN2IF4JxP445O8CsQfIoywEDNIF4otIieML1J8fgDgWiFWBWBmIbwNxGRMBw8qQDDoNxLxAXAyKeiBWA+J2JLXlhAw7jsQ2BeImpOhyAuICJPnDuMIM5JqZ0FghBswDpQEWEgzpBuKrQGwMxNxAfBOI10IjgAG95JmFJdv2A3ERmthCXM6DGQbK0vJI4lxA/J2BRMACDVBmIH4LxK+AeCk5BoEAAFbJXa1IYPnYAAAAAElFTkSuQmCC"

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Info */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_select__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_virtualized__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Fillup_ModalPromo__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Flag__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons__ = __webpack_require__(226);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: stretch;\n  width: 100%;\n  margin-top: 8px;\n  font-size: ",";\n  line-height: 14px;\n  color: #a7a7a7;\n  ",";\n\n  @media (min-width: 960px) {\n    width: 304px;\n    ",";\n    margin-left: 212px;\n  }\n"],["\n  display: flex;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: stretch;\n  width: 100%;\n  margin-top: 8px;\n  font-size: ",";\n  line-height: 14px;\n  color: #a7a7a7;\n  ",";\n\n  @media (min-width: 960px) {\n    width: 304px;\n    ",";\n    margin-left: 212px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 16px;\n  min-width: 16px;\n  ",";\n"],["\n  width: 16px;\n  min-width: 16px;\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: inherit;\n  color: inherit;\n  ",";\n\n  ",";\n"],["\n  font-size: inherit;\n  color: inherit;\n  ",";\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      font-weight: 700;\n      color: #919191;\n    "],["\n      font-weight: 700;\n      color: #919191;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: static !important;\n  width: 100%;\n  font-weight: 400;\n  line-height: 15px;\n\n  :focus {\n    outline: none;\n  }\n\n  .react-select__control {\n    height: 39px;\n    font-weight: 400;\n    font-size: ",";\n    line-height: 15px;\n    color: #a7a7a7;\n    background-color: rgb(255, 255, 255);\n    ",";\n    border: 1px solid rgb(204, 204, 204);\n    ",";\n    box-shadow: inset 0px 2px 0px 0px rgb(235, 235, 235);\n\n    :hover {\n      box-shadow: inset 0px 2px 0px 0px rgb(235, 235, 235);\n    }\n\n    ","\n\n    @media (max-width: 959px) {\n      font-size: ",";\n      height: 39px;\n      min-height: 0;\n      ","\n    }\n\n    ",";\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__menu {\n    margin-top: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .react-select__dropdown-indicator {\n    padding: 0;\n    ",";\n    ",";\n\n    ",";\n  }\n"],["\n  position: static !important;\n  width: 100%;\n  font-weight: 400;\n  line-height: 15px;\n\n  :focus {\n    outline: none;\n  }\n\n  .react-select__control {\n    height: 39px;\n    font-weight: 400;\n    font-size: ",";\n    line-height: 15px;\n    color: #a7a7a7;\n    background-color: rgb(255, 255, 255);\n    ",";\n    border: 1px solid rgb(204, 204, 204);\n    ",";\n    box-shadow: inset 0px 2px 0px 0px rgb(235, 235, 235);\n\n    :hover {\n      box-shadow: inset 0px 2px 0px 0px rgb(235, 235, 235);\n    }\n\n    ","\n\n    @media (max-width: 959px) {\n      font-size: ",";\n      height: 39px;\n      min-height: 0;\n      ","\n    }\n\n    ",";\n  }\n\n  .react-select__indicator-separator {\n    display: none;\n  }\n\n  .react-select__menu {\n    margin-top: 0;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n\n  .react-select__dropdown-indicator {\n    padding: 0;\n    ",";\n    ",";\n\n    ",";\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n        box-shadow: none;\n        &:hover {\n          box-shadow: none;\n        }\n      "],["\n        box-shadow: none;\n        &:hover {\n          box-shadow: none;\n        }\n      "]),_templateObject7=_taggedTemplateLiteral(["\n          height: 39px;\n        "],["\n          height: 39px;\n        "]),_templateObject8=_taggedTemplateLiteral(["\n        min-height: 50px;\n        color: #fff;\n        background-color: rgba(255, 255, 255, 0.25);\n        border-color: transparent;\n        ",";\n        box-shadow: none;\n\n        :hover,\n        :focus,\n        :active {\n          border-color: transparent;\n          box-shadow: none;\n        }\n\n        @media (max-width: 959px) {\n          min-height: 40px;\n        }\n\n        ",";\n      "],["\n        min-height: 50px;\n        color: #fff;\n        background-color: rgba(255, 255, 255, 0.25);\n        border-color: transparent;\n        ",";\n        box-shadow: none;\n\n        :hover,\n        :focus,\n        :active {\n          border-color: transparent;\n          box-shadow: none;\n        }\n\n        @media (max-width: 959px) {\n          min-height: 40px;\n        }\n\n        ",";\n      "]),_templateObject9=_taggedTemplateLiteral(["\n            background-color: rgba(255, 255, 255, 0.25) !important;\n            border-color: #fff;\n            border-bottom-color: transparent;\n            ",";\n\n            :hover,\n            :focus,\n            :active {\n              border-color: #fff;\n              border-bottom-color: transparent;\n            }\n          "],["\n            background-color: rgba(255, 255, 255, 0.25) !important;\n            border-color: #fff;\n            border-bottom-color: transparent;\n            ",";\n\n            :hover,\n            :focus,\n            :active {\n              border-color: #fff;\n              border-bottom-color: transparent;\n            }\n          "]),_templateObject10=_taggedTemplateLiteral(["\n        color: #fff;\n        opacity: 0.5;\n\n        :hover {\n          color: #fff;\n          opacity: 1;\n        }\n\n        ",";\n      "],["\n        color: #fff;\n        opacity: 0.5;\n\n        :hover {\n          color: #fff;\n          opacity: 1;\n        }\n\n        ",";\n      "]),_templateObject11=_taggedTemplateLiteral(["\n            color: #fff;\n            opacity: 1;\n          "],["\n            color: #fff;\n            opacity: 1;\n          "]),_templateObject12=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 100%;\n  @media (max-width: 959px) {\n    display: none !important;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 100%;\n  @media (max-width: 959px) {\n    display: none !important;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 200px;\n  max-height: 200px;\n  z-index: 20;\n  background: #fff;\n  border: 1px solid #cccccc;\n  border-top: none;\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  overflow: hidden;\n"],["\n  width: 100%;\n  height: 200px;\n  max-height: 200px;\n  z-index: 20;\n  background: #fff;\n  border: 1px solid #cccccc;\n  border-top: none;\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  overflow: hidden;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  cursor: pointer;\n"],["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  cursor: pointer;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  direction: ",";\n  padding: 8px 10px;\n  color: #343434;\n\n  "," {\n    color: #a7a7a7;\n  }\n\n  @media (max-width: 959px) {\n    border-bottom: 1px solid #ccc;\n  }\n\n  :hover {\n    color: #fff;\n    background-color: #3498db;\n\n    ",", "," {\n      color: #fff;\n    }\n  }\n\n  ",";\n"],["\n  direction: ",";\n  padding: 8px 10px;\n  color: #343434;\n\n  "," {\n    color: #a7a7a7;\n  }\n\n  @media (max-width: 959px) {\n    border-bottom: 1px solid #ccc;\n  }\n\n  :hover {\n    color: #fff;\n    background-color: #3498db;\n\n    ",", "," {\n      color: #fff;\n    }\n  }\n\n  ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n      color: #fff;\n      background-color: #3498db;\n\n      ",", "," {\n        color: #fff;\n      }\n    "],["\n      color: #fff;\n      background-color: #3498db;\n\n      ",", "," {\n        color: #fff;\n      }\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  font-size: ",";\n"],["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  font-size: ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n  direction: ltr;\n  font-size: 14px;\n"],["\n  direction: ltr;\n  font-size: 14px;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  width: 100%;\n  height: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1 0 auto;\n  width: 100%;\n  height: 100%;\n  padding-left: 15px;\n  padding-right: 15px;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 50px;\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 50px;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 auto;\n"]),_templateObject23=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2;\n  color: #343434;\n  text-align: center;\n"],["\n  font-size: ",";\n  line-height: 1.2;\n  color: #343434;\n  text-align: center;\n"]),_templateObject24=_taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n"],["\n  width: 16px;\n  height: 16px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n"]),_templateObject25=_taggedTemplateLiteral(["\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n"],["\n  width: 20px;\n  min-width: 20px;\n  height: 20px;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n"]),_templateObject26=_taggedTemplateLiteral(["\n  padding-bottom: 10px;\n"],["\n  padding-bottom: 10px;\n"]),_templateObject27=_taggedTemplateLiteral(["\n  &&&:hover,\n  &&&:focus,\n  &&&:active {\n    outline: none;\n  }\n"],["\n  &&&:hover,\n  &&&:focus,\n  &&&:active {\n    outline: none;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var PhoneInfo=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("text-align","left"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-left","212px"));var IconContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-right","7px"));var Info=function Info(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PhoneInfo,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Icons__["a" /* InfoIcon */],{verification:true})),children);};var SelectCode=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-left","5px"),function(_ref2){var version=_ref2.version;return version===2&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject4);});var Select=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_1_react_select__["b" /* default */])(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("border-radius","3px 0px 0px 3px","0px 3px 3px 0px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("border-right","none"),function(props){return props.isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject6);},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7);},function(_ref3){var theme=_ref3.theme,isProfile=_ref3.isProfile,isWithdraw=_ref3.isWithdraw;return theme.newIndex&&!isProfile&&!isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("border-radius","25px 0 0 25px","0 25px 25px 0"),function(_ref4){var menuIsOpen=_ref4.menuIsOpen;return menuIsOpen&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("border-radius","25px 0 0 0","0 25px 0 0"));});},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("padding-left",0),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("padding-right","8px"),function(_ref5){var theme=_ref5.theme,isProfile=_ref5.isProfile,isWithdraw=_ref5.isWithdraw;return theme.newIndex&&!isProfile&&!isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject10,function(_ref6){var menuIsOpen=_ref6.menuIsOpen;return menuIsOpen&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject11);});});var Flag=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__common_Flag__["h" /* default */])(_templateObject12);var Menu=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject13);var OptionInner=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject14,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("text-align","left"));var ValueOption=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject15);var Option=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(ValueOption)(_templateObject16,function(_ref7){var theme=_ref7.theme;return theme.direction;},SelectCode,OptionInner,SelectCode,function(_ref8){var isFocused=_ref8.isFocused;return isFocused&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject17,OptionInner,SelectCode);});var OptionContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject18,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14));var OptionLabel=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject19);var MobileContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject20);var MobileHeader=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject21);var SizerContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject22);var HeaderText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject23,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(16));var BackButton=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].button(_templateObject24);var CloseButton=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].button(_templateObject25);var InfoContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject26);var List=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_virtualized__["d" /* List */])(_templateObject27);var Placeholder=function Placeholder(_ref9){var isProfile=_ref9.isProfile;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValueOption,{isWorld:true,isProfile:isProfile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Country/Region"));};function ValueView(_ref10){var innerProps=_ref10.innerProps,data=_ref10.data,isProfile=_ref10.isProfile,version=_ref10.version;var label=data.label,code=data.code,phoneCode=data.phoneCode;var value=code==="world"?label:"+"+phoneCode;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValueOption,innerProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{country:code}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectCode,{version:version,isProfile:isProfile},value));}var MobileMenu=function MobileMenu(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Fillup_ModalPromo__["b" /* FullPage */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MobileContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MobileHeader,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BackButton,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"-89.999 596.249 15.999 15.554",fill:"#99959d"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-923.583-12226.809l0,0-1.413-1.416v0l1.413-1.415,0,0,6.363-6.363,1.413,1.416-5.334,5.334H-909v2h-12.2l5.389,5.387-1.413,1.415Z",transform:"translate(835 12832.249)"}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Select the country code")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseButton,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 22 22"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{x2:"20",y2:"20",fill:"none",stroke:"#96949b",strokeWidth:"2"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("line",{x1:"20",y2:"20",fill:"none",stroke:"#96949b",strokeWidth:"2"}))))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SizerContainer,null,props.children),props.showInfo&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,null,props.showInfo))));};var MenuWrapper=function MenuWrapper(_ref11){var isDesktop=_ref11.isDesktop,children=_ref11.children,props=_objectWithoutProperties(_ref11,["isDesktop","children"]);return isDesktop?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Menu,{className:"react-select__menu"},children):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MobileMenu,props,children);};var ListRow=function ListRow(_ref12){var rowKey=_ref12.rowKey,index=_ref12.index,isScrolling=_ref12.isScrolling,isVisible=_ref12.isVisible,style=_ref12.style,optionProps=_ref12.optionProps,props=_objectWithoutProperties(_ref12,["rowKey","index","isScrolling","isVisible","style","optionProps"]);var currentOption=props.options[index];var label=currentOption.label,code=currentOption.code,phoneCode=currentOption.phoneCode;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Option,Object.assign({},optionProps.innerProps,{key:label,style:style,onClick:function onClick(){return optionProps.setValue(currentOption);},isProfile:props.isProfile}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OptionContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OptionInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{country:code}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](OptionLabel,null,label)),code!=="world"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SelectCode,null,"+",phoneCode)));};var CountrySelect=function(_React$Component){_inherits(CountrySelect,_React$Component);function CountrySelect(){var _ref13;var _temp,_this,_ret;_classCallCheck(this,CountrySelect);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref13=CountrySelect.__proto__||Object.getPrototypeOf(CountrySelect)).call.apply(_ref13,[this].concat(args))),_this),_this.state={menuIsOpen:false},_this.handleMediaChange=function(){if(document.body){if(_this.props.desktop===false){document.body.style.overflow=_this.state.menuIsOpen===true?"hidden":"";}else{document.body.style.overflow="";}}},_this.handleMenuEvent=function(menuIsOpen){_this.setState({menuIsOpen:menuIsOpen},_this.handleMediaChange);},_this.handleChange=function(value){_this.props.onChange({target:{name:_this.props.name,value:value}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CountrySelect,[{key:"componentDidMount",value:function componentDidMount(){if(this.state.menuIsOpen===true){this.handleMediaChange();}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(prevProps.desktop!==this.props.desktop){this.handleMediaChange();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(document.body){document.body.style.overflow="";}}},{key:"render",value:function render(){var _this2=this;var isLocked=typeof this.props.onChange!=="function";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Select,{classNamePrefix:"react-select",isDisabled:isLocked,invalid:_this2.props.error,value:_this2.props.value,options:_this2.props.options,onChange:_this2.handleChange,placeholder:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Placeholder,{isProfile:_this2.props.isProfile}),isRtl:theme.direction==="rtl",isLoading:false,isClearable:false,isSearchable:false,isMulti:false,ignoreAccents:true,ignoreCase:true,isProfile:_this2.props.isProfile,isWithdraw:_this2.props.isWithdraw,components:{SingleValue:function SingleValue(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValueView,Object.assign({},props,{isProfile:_this2.props.isProfile,version:_this2.props.version}));},Menu:function Menu(menuProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_select__["a" /* components */].Menu,menuProps,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MenuWrapper,{isDesktop:_this2.props.desktop,onDismiss:function onDismiss(){return menuProps.setValue(_this2.props.value);},showInfo:_this2.props.showInfo},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_virtualized__["a" /* AutoSizer */],null,function(_ref14){var width=_ref14.width,height=_ref14.height;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](List,{width:width,height:height,overscanRowCount:10,rowCount:_this2.props.options.length,rowHeight:_this2.props.desktop?36:46,rowRenderer:function rowRenderer(rowProps){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ListRow,Object.assign({},rowProps,{rowKey:rowProps.key},_this2.props,{optionProps:menuProps}));},scrollToAlignment:"start",scrollToIndex:_this2.props.options.indexOf(_this2.props.value)});})));}},menuIsOpen:_this2.state.menuIsOpen,onMenuOpen:function onMenuOpen(){return _this2.handleMenuEvent(true);},onMenuClose:function onMenuClose(){return _this2.handleMenuEvent(false);},version:_this2.props.version});});}}]);return CountrySelect;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 768px)"},function(desktop){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CountrySelect,Object.assign({},props,{desktop:desktop}));});});

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(598);
/* unused harmony reexport default */
/* unused harmony reexport ArrowKeyStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(622);
/* unused harmony reexport bpfrpt_proptype_ScrollIndices */








/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1294);
module.exports = __webpack_require__(40).Object.getPrototypeOf;


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(258);
var $getPrototypeOf = __webpack_require__(599);

__webpack_require__(386)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1296);
var $Object = __webpack_require__(40).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(89);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(118), 'Object', { defineProperty: __webpack_require__(116).f });


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1298), __esModule: true };

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(262);
__webpack_require__(264);
module.exports = __webpack_require__(392).f('iterator');


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(389);
var defined = __webpack_require__(383);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(390);
var descriptor = __webpack_require__(261);
var setToStringTag = __webpack_require__(263);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(138)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(116);
var anObject = __webpack_require__(90);
var getKeys = __webpack_require__(198);

module.exports = __webpack_require__(118) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(139);
var toLength = __webpack_require__(607);
var toAbsoluteIndex = __webpack_require__(1303);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(389);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(1305);
var step = __webpack_require__(1306);
var Iterators = __webpack_require__(162);
var toIObject = __webpack_require__(139);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(603)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 1305 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 1306 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1308), __esModule: true };

/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1309);
__webpack_require__(610);
__webpack_require__(1314);
__webpack_require__(1315);
module.exports = __webpack_require__(40).Symbol;


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(55);
var has = __webpack_require__(137);
var DESCRIPTORS = __webpack_require__(118);
var $export = __webpack_require__(89);
var redefine = __webpack_require__(604);
var META = __webpack_require__(1310).KEY;
var $fails = __webpack_require__(161);
var shared = __webpack_require__(385);
var setToStringTag = __webpack_require__(263);
var uid = __webpack_require__(259);
var wks = __webpack_require__(56);
var wksExt = __webpack_require__(392);
var wksDefine = __webpack_require__(393);
var enumKeys = __webpack_require__(1311);
var isArray = __webpack_require__(1312);
var anObject = __webpack_require__(90);
var isObject = __webpack_require__(117);
var toIObject = __webpack_require__(139);
var toPrimitive = __webpack_require__(388);
var createDesc = __webpack_require__(261);
var _create = __webpack_require__(390);
var gOPNExt = __webpack_require__(1313);
var $GOPD = __webpack_require__(395);
var $DP = __webpack_require__(116);
var $keys = __webpack_require__(198);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(609).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(265).f = $propertyIsEnumerable;
  __webpack_require__(394).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(196)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(138)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(259)('meta');
var isObject = __webpack_require__(117);
var has = __webpack_require__(137);
var setDesc = __webpack_require__(116).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(161)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(198);
var gOPS = __webpack_require__(394);
var pIE = __webpack_require__(265);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(199);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(139);
var gOPN = __webpack_require__(609).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(393)('asyncIterator');


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(393)('observable');


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1317), __esModule: true };

/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1318);
module.exports = __webpack_require__(40).Object.setPrototypeOf;


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(89);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1319).set });


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(117);
var anObject = __webpack_require__(90);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(197)(Function.call, __webpack_require__(395).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1321), __esModule: true };

/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1322);
var $Object = __webpack_require__(40).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(89);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(390) });


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1324);
module.exports = __webpack_require__(40).Object.assign;


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(89);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1325) });


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__(198);
var gOPS = __webpack_require__(394);
var pIE = __webpack_require__(265);
var toObject = __webpack_require__(258);
var IObject = __webpack_require__(606);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(161)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;


function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount,
      cellSize = _ref.cellSize,
      computeMetadataCallback = _ref.computeMetadataCallback,
      computeMetadataCallbackProps = _ref.computeMetadataCallbackProps,
      nextCellsCount = _ref.nextCellsCount,
      nextCellSize = _ref.nextCellSize,
      nextScrollToIndex = _ref.nextScrollToIndex,
      scrollToIndex = _ref.scrollToIndex,
      updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/**
 * Helper method that determines when to recalculate row or column metadata.
 */

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(18);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */

var CellSizeAndPositionManager = function () {

  // Used in deferred mode to track which cells have been queued for measurement.

  // Cache of size and position data for cells, mapped by cell index.
  // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount,
        cellSizeGetter = _ref.cellSizeGetter,
        estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeAndPositionData = {};
    this._lastMeasuredIndex = -1;
    this._lastBatchedIndex = -1;

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;
  }

  // Measurements for cells up to this index can be trusted; cells afterward should be estimated.


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'areOffsetsAdjusted',
    value: function areOffsetsAdjusted() {
      return false;
    }
  }, {
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount,
          estimatedCellSize = _ref2.estimatedCellSize,
          cellSizeGetter = _ref2.cellSizeGetter;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
      this._cellSizeGetter = cellSizeGetter;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }
  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment() {
      return 0;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          // undefined or NaN probably means a logic error in the size getter.
          // null means we're using CellMeasurer and haven't yet measured a given index.
          if (_size === undefined || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          } else if (_size === null) {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: 0
            };

            this._lastBatchedIndex = index;
          } else {
            this._cellSizeAndPositionData[i] = {
              offset: _offset,
              size: _size
            };

            _offset += _size;

            this._lastMeasuredIndex = index;
          }
        }
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completely estimated initially.
     * As cells are measured, the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
      var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
      var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
      return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align,
          align = _ref3$align === undefined ? 'auto' : _ref3$align,
          containerSize = _ref3.containerSize,
          currentOffset = _ref3.currentOffset,
          targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(params) {
      var containerSize = params.containerSize,
          offset = params.offset;


      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(high, low, offset) {
      while (low <= high) {
        var middle = low + Math.floor((high - low) / 2);
        var _currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (_currentOffset === offset) {
          return middle;
        } else if (_currentOffset < offset) {
          low = middle + 1;
        } else if (_currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      } else {
        return 0;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(index, offset) {
      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch(lastMeasuredIndex, 0, offset);
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch(lastMeasuredIndex, offset);
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);




/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMaxElementSize; });
var DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var CHROME_MAX_ELEMENT_SIZE = 1.67771e7;

var isBrowser = function isBrowser() {
  return typeof window !== 'undefined';
};

var isChrome = function isChrome() {
  return !!window.chrome && !!window.chrome.webstore;
};

var getMaxElementSize = function getMaxElementSize() {
  if (isBrowser()) {
    if (isChrome()) {
      return CHROME_MAX_ELEMENT_SIZE;
    }
  }
  return DEFAULT_MAX_ELEMENT_SIZE;
};

/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1330);
module.exports = __webpack_require__(40).Object.keys;


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(258);
var $keys = __webpack_require__(198);

__webpack_require__(386)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScalingCellSizeAndPositionManager_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(18);




/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */

function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize,
      cellSizeAndPositionManager = _ref.cellSizeAndPositionManager,
      previousCellsCount = _ref.previousCellsCount,
      previousCellSize = _ref.previousCellSize,
      previousScrollToAlignment = _ref.previousScrollToAlignment,
      previousScrollToIndex = _ref.previousScrollToIndex,
      previousSize = _ref.previousSize,
      scrollOffset = _ref.scrollOffset,
      scrollToAlignment = _ref.scrollToAlignment,
      scrollToIndex = _ref.scrollToIndex,
      size = _ref.size,
      sizeJustIncreasedFromZero = _ref.sizeJustIncreasedFromZero,
      updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}



/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1334), __esModule: true };

/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(610);
__webpack_require__(262);
__webpack_require__(264);
__webpack_require__(1335);
__webpack_require__(1346);
__webpack_require__(1347);
module.exports = __webpack_require__(40).Promise;


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(196);
var global = __webpack_require__(55);
var ctx = __webpack_require__(197);
var classof = __webpack_require__(399);
var $export = __webpack_require__(89);
var isObject = __webpack_require__(117);
var aFunction = __webpack_require__(260);
var anInstance = __webpack_require__(1336);
var forOf = __webpack_require__(1337);
var speciesConstructor = __webpack_require__(618);
var task = __webpack_require__(619).set;
var microtask = __webpack_require__(1341)();
var newPromiseCapabilityModule = __webpack_require__(400);
var perform = __webpack_require__(620);
var userAgent = __webpack_require__(1342);
var promiseResolve = __webpack_require__(621);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(56)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(1343)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(263)($Promise, PROMISE);
__webpack_require__(1344)(PROMISE);
Wrapper = __webpack_require__(40)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(1345)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(197);
var call = __webpack_require__(1338);
var isArrayIter = __webpack_require__(1339);
var anObject = __webpack_require__(90);
var toLength = __webpack_require__(607);
var getIterFn = __webpack_require__(617);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(90);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(162);
var ITERATOR = __webpack_require__(56)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1340 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(55);
var macrotask = __webpack_require__(619).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(199)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(55);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(138);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(55);
var core = __webpack_require__(40);
var dP = __webpack_require__(116);
var DESCRIPTORS = __webpack_require__(118);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(56)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(89);
var core = __webpack_require__(40);
var global = __webpack_require__(55);
var speciesConstructor = __webpack_require__(618);
var promiseResolve = __webpack_require__(621);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(89);
var newPromiseCapability = __webpack_require__(400);
var perform = __webpack_require__(620);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return raf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return caf; });


// Properly handle server-side rendering.
var win = void 0;

if (typeof window !== 'undefined') {
  win = window;
} else if (typeof self !== 'undefined') {
  win = self;
} else {
  win = {};
}

// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var request = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (callback) {
  return win.setTimeout(callback, 1000 / 60);
};

var cancel = win.cancelAnimationFrame || win.webkitCancelAnimationFrame || win.mozCancelAnimationFrame || win.oCancelAnimationFrame || win.msCancelAnimationFrame || function (id) {
  win.clearTimeout(id);
};

var raf = request;
var caf = cancel;

/***/ }),
/* 1349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SCROLL_DIRECTION_BACKWARD */
/* unused harmony export SCROLL_DIRECTION_FORWARD */
/* unused harmony export SCROLL_DIRECTION_HORIZONTAL */
/* unused harmony export SCROLL_DIRECTION_VERTICAL */
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultOverscanIndicesGetter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(18);


var SCROLL_DIRECTION_BACKWARD = -1;

var SCROLL_DIRECTION_FORWARD = 1;

var SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var SCROLL_DIRECTION_VERTICAL = 'vertical';

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */

function defaultOverscanIndicesGetter(_ref) {
  var cellCount = _ref.cellCount,
      overscanCellsCount = _ref.overscanCellsCount,
      scrollDirection = _ref.scrollDirection,
      startIndex = _ref.startIndex,
      stopIndex = _ref.stopIndex;

  // Make sure we render at least 1 cell extra before and after (except near boundaries)
  // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
  // For more info see issues #625
  overscanCellsCount = Math.max(1, overscanCellsCount);

  if (scrollDirection === SCROLL_DIRECTION_FORWARD) {
    return {
      overscanStartIndex: Math.max(0, startIndex - 1),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
  } else {
    return {
      overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
      overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
  }
}



/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(623);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });



/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);








/**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */
var CellMeasurer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _React$PureComponent);

  function CellMeasurer() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call.apply(_ref, [this].concat(args))), _this), _this._measure = function () {
      var _this$props = _this.props,
          cache = _this$props.cache,
          _this$props$columnInd = _this$props.columnIndex,
          columnIndex = _this$props$columnInd === undefined ? 0 : _this$props$columnInd,
          parent = _this$props.parent,
          _this$props$rowIndex = _this$props.rowIndex,
          rowIndex = _this$props$rowIndex === undefined ? _this.props.index || 0 : _this$props$rowIndex;

      var _this$_getCellMeasure = _this._getCellMeasurements(),
          height = _this$_getCellMeasure.height,
          width = _this$_getCellMeasure.width;

      if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
        cache.set(rowIndex, columnIndex, width, height);

        if (parent && typeof parent.recomputeGridSize === 'function') {
          parent.recomputeGridSize({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._maybeMeasureCell();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return typeof children === 'function' ? children({ measure: this._measure }) : children;
    }
  }, {
    key: '_getCellMeasurements',
    value: function _getCellMeasurements() {
      var cache = this.props.cache;


      var node = Object(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(this);

      // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height

      if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
        var styleWidth = node.style.width;
        var styleHeight = node.style.height;

        // If we are re-measuring a cell that has already been measured,
        // It will have a hard-coded width/height from the previous measurement.
        // The fact that we are measuring indicates this measurement is probably stale,
        // So explicitly clear it out (eg set to "auto") so we can recalculate.
        // See issue #593 for more info.
        // Even if we are measuring initially- if we're inside of a MultiGrid component,
        // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
        // eg top/left Grid renders before bottom/right Grid
        // Since the CellMeasurerCache is shared between them this taints derived cell size values.
        if (!cache.hasFixedWidth()) {
          node.style.width = 'auto';
        }
        if (!cache.hasFixedHeight()) {
          node.style.height = 'auto';
        }

        var height = Math.ceil(node.offsetHeight);
        var width = Math.ceil(node.offsetWidth);

        // Reset after measuring to avoid breaking styles; see #660
        if (styleWidth) {
          node.style.width = styleWidth;
        }
        if (styleHeight) {
          node.style.height = styleHeight;
        }

        return { height: height, width: width };
      } else {
        return { height: 0, width: 0 };
      }
    }
  }, {
    key: '_maybeMeasureCell',
    value: function _maybeMeasureCell() {
      var _props = this.props,
          cache = _props.cache,
          _props$columnIndex = _props.columnIndex,
          columnIndex = _props$columnIndex === undefined ? 0 : _props$columnIndex,
          parent = _props.parent,
          _props$rowIndex = _props.rowIndex,
          rowIndex = _props$rowIndex === undefined ? this.props.index || 0 : _props$rowIndex;


      if (!cache.has(rowIndex, columnIndex)) {
        var _getCellMeasurements2 = this._getCellMeasurements(),
            height = _getCellMeasurements2.height,
            width = _getCellMeasurements2.width;

        cache.set(rowIndex, columnIndex, width, height);

        // If size has changed, let Grid know to re-render.
        if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') {
          parent.invalidateCellSizeAfterRender({
            columnIndex: columnIndex,
            rowIndex: rowIndex
          });
        }
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

// Used for DEV mode warning check


CellMeasurer.__internalCellMeasurerFlag = false;
CellMeasurer.propTypes =  true ? null : {
  cache: function cache() {
    return (typeof bpfrpt_proptype_CellMeasureCache === 'function' ? bpfrpt_proptype_CellMeasureCache.isRequired ? bpfrpt_proptype_CellMeasureCache.isRequired : bpfrpt_proptype_CellMeasureCache : PropTypes.shape(bpfrpt_proptype_CellMeasureCache).isRequired).apply(this, arguments);
  },
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
  columnIndex: PropTypes.number,
  index: PropTypes.number,
  parent: PropTypes.shape({
    invalidateCellSizeAfterRender: PropTypes.func,
    recomputeGridSize: PropTypes.func
  }).isRequired,
  rowIndex: PropTypes.number
};
/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
if (false) {
  CellMeasurer.__internalCellMeasurerFlag = true;
}



/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_HEIGHT */
/* unused harmony export DEFAULT_WIDTH */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(626);




var DEFAULT_HEIGHT = 30;

var DEFAULT_WIDTH = 100;

// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.

/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCache = function () {
  function CellMeasurerCache() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCache);

    this._cellHeightCache = {};
    this._cellWidthCache = {};
    this._columnWidthCache = {};
    this._rowHeightCache = {};
    this._columnCount = 0;
    this._rowCount = 0;

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      var key = _this._keyMapper(0, index);

      return _this._columnWidthCache.hasOwnProperty(key) ? _this._columnWidthCache[key] : _this._defaultWidth;
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      var key = _this._keyMapper(index, 0);

      return _this._rowHeightCache.hasOwnProperty(key) ? _this._rowHeightCache[key] : _this._defaultHeight;
    };

    var defaultHeight = params.defaultHeight,
        defaultWidth = params.defaultWidth,
        fixedHeight = params.fixedHeight,
        fixedWidth = params.fixedWidth,
        keyMapper = params.keyMapper,
        minHeight = params.minHeight,
        minWidth = params.minWidth;


    this._hasFixedHeight = fixedHeight === true;
    this._hasFixedWidth = fixedWidth === true;
    this._minHeight = minHeight || 0;
    this._minWidth = minWidth || 0;
    this._keyMapper = keyMapper || defaultKeyMapper;

    this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : DEFAULT_HEIGHT);
    this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : DEFAULT_WIDTH);

    if (false) {
      if (this._hasFixedHeight === false && this._hasFixedWidth === false) {
        console.warn("CellMeasurerCache should only measure a cell's width or height. " + 'You have configured CellMeasurerCache to measure both. ' + 'This will result in poor performance.');
      }

      if (this._hasFixedHeight === false && this._defaultHeight === 0) {
        console.warn('Fixed height CellMeasurerCache should specify a :defaultHeight greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }

      if (this._hasFixedWidth === false && this._defaultWidth === 0) {
        console.warn('Fixed width CellMeasurerCache should specify a :defaultWidth greater than 0. ' + 'Failing to do so will lead to unnecessary layout and poor performance.');
      }
    }
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCache, [{
    key: 'clear',
    value: function clear(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      delete this._cellHeightCache[key];
      delete this._cellWidthCache[key];

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellHeightCache = {};
      this._cellWidthCache = {};
      this._columnWidthCache = {};
      this._rowHeightCache = {};
      this._rowCount = 0;
      this._columnCount = 0;
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._hasFixedHeight;
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._hasFixedWidth;
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedHeight) {
        return this._defaultHeight;
      } else {
        var _key = this._keyMapper(rowIndex, columnIndex);

        return this._cellHeightCache.hasOwnProperty(_key) ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
      }
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (this._hasFixedWidth) {
        return this._defaultWidth;
      } else {
        var _key2 = this._keyMapper(rowIndex, columnIndex);

        return this._cellWidthCache.hasOwnProperty(_key2) ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
      }
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var key = this._keyMapper(rowIndex, columnIndex);

      return this._cellHeightCache.hasOwnProperty(key);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      var key = this._keyMapper(rowIndex, columnIndex);

      if (columnIndex >= this._columnCount) {
        this._columnCount = columnIndex + 1;
      }
      if (rowIndex >= this._rowCount) {
        this._rowCount = rowIndex + 1;
      }

      // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
      this._cellHeightCache[key] = height;
      this._cellWidthCache[key] = width;

      this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
    }
  }, {
    key: '_updateCachedColumnAndRowSizes',
    value: function _updateCachedColumnAndRowSizes(rowIndex, columnIndex) {
      // :columnWidth and :rowHeight are derived based on all cells in a column/row.
      // Pre-cache these derived values for faster lookup later.
      // Reads are expected to occur more frequently than writes in this case.
      // Only update non-fixed dimensions though to avoid doing unnecessary work.
      if (!this._hasFixedWidth) {
        var columnWidth = 0;
        for (var i = 0; i < this._rowCount; i++) {
          columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
        }
        var columnKey = this._keyMapper(0, columnIndex);
        this._columnWidthCache[columnKey] = columnWidth;
      }
      if (!this._hasFixedHeight) {
        var rowHeight = 0;
        for (var _i = 0; _i < this._columnCount; _i++) {
          rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
        }
        var rowKey = this._keyMapper(rowIndex, 0);
        this._rowHeightCache[rowKey] = rowHeight;
      }
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._defaultWidth;
    }
  }]);

  return CellMeasurerCache;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (CellMeasurerCache);


function defaultKeyMapper(rowIndex, columnIndex) {
  return rowIndex + '-' + columnIndex;
}


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(1354);
/* unused harmony reexport Collection */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__Collection__["a" /* default */]);


/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CollectionView__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__ = __webpack_require__(1356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__types__ = __webpack_require__(163);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _React$PureComponent);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    _this._setCollectionViewRef = _this._setCollectionViewRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'forceUpdate',
    value: function forceUpdate() {
      if (this._collectionView !== undefined) {
        this._collectionView.forceUpdate();
      }
    }

    /** See Collection#recomputeCellSizesAndPositions */

  }, {
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: this._setCollectionViewRef
      }, props));
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props,
          cellCount = _props.cellCount,
          cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter,
          sectionSize = _props.sectionSize;


      var data = Object(__WEBPACK_IMPORTED_MODULE_10__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref) {
      var align = _ref.align,
          cellIndex = _ref.cellIndex,
          height = _ref.height,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          width = _ref.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = Object(__WEBPACK_IMPORTED_MODULE_11__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref2) {
      var _this2 = this;

      var height = _ref2.height,
          isScrolling = _ref2.isScrolling,
          width = _ref2.width,
          x = _ref2.x,
          y = _ref2.y;
      var _props2 = this.props,
          cellGroupRenderer = _props2.cellGroupRenderer,
          cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref3) {
          var index = _ref3.index;
          return _this2._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }, {
    key: '_setCollectionViewRef',
    value: function _setCollectionViewRef(ref) {
      this._collectionView = ref;
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
Collection.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : {};


function defaultCellGroupRenderer(_ref4) {
  var cellCache = _ref4.cellCache,
      cellRenderer = _ref4.cellRenderer,
      cellSizeAndPositionGetter = _ref4.cellSizeAndPositionGetter,
      indices = _ref4.indices,
      isScrolling = _ref4.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}



/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize__ = __webpack_require__(616);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize__);













// @TODO Merge Collection and CollectionView

/**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _React$PureComponent);

  // Invokes callbacks only when their values have changed.
  function CollectionView() {
    var _ref;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // If this component is being rendered server-side, getScrollbarSize() will return undefined.
    // We handle this case in componentDidMount()
    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call.apply(_ref, [this].concat(args)));

    _this.state = {
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };
    _this._calculateSizeAndPositionDataOnNextUpdate = false;
    _this._onSectionRenderedMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    _this._invokeOnSectionRenderedHelper = function () {
      var _this$props = _this.props,
          cellLayoutManager = _this$props.cellLayoutManager,
          onSectionRendered = _this$props.onSectionRendered;


      _this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    };

    _this._setScrollingContainerRef = function (ref) {
      _this._scrollingContainer = ref;
    };

    _this._updateScrollPositionForScrollToCell = function () {
      var _this$props2 = _this.props,
          cellLayoutManager = _this$props2.cellLayoutManager,
          height = _this$props2.height,
          scrollToAlignment = _this$props2.scrollToAlignment,
          scrollToCell = _this$props2.scrollToCell,
          width = _this$props2.width;
      var _this$state = _this.state,
          scrollLeft = _this$state.scrollLeft,
          scrollTop = _this$state.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          _this._setScrollPosition(scrollPosition);
        }
      }
    };

    _this._onScroll = function (event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== _this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      _this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _this$props3 = _this.props,
          cellLayoutManager = _this$props3.cellLayoutManager,
          height = _this$props3.height,
          isScrollingChange = _this$props3.isScrollingChange,
          width = _this$props3.width;

      var scrollbarSize = _this._scrollbarSize;

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge.height,
          totalWidth = _cellLayoutManager$ge.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (_this.state.scrollLeft !== scrollLeft || _this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!_this.state.isScrolling) {
          isScrollingChange(true);
        }

        _this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      _this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    };

    _this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default()();
    if (_this._scrollbarSize === undefined) {
      _this._scrollbarSizeMeasured = false;
      _this._scrollbarSize = 0;
    } else {
      _this._scrollbarSizeMeasured = true;
    }
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._calculateSizeAndPositionDataOnNextUpdate = true;
      this.forceUpdate();
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          cellLayoutManager = _props.cellLayoutManager,
          scrollLeft = _props.scrollLeft,
          scrollToCell = _props.scrollToCell,
          scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_11_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge2.height,
          totalWidth = _cellLayoutManager$ge2.width;

      // Initialize onScroll callback.


      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props,
          height = _props2.height,
          scrollToAlignment = _props2.scrollToAlignment,
          scrollToCell = _props2.scrollToCell,
          width = _props2.width;
      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollPositionChangeReason = _state.scrollPositionChangeReason,
          scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          autoHeight = _props3.autoHeight,
          cellCount = _props3.cellCount,
          cellLayoutManager = _props3.cellLayoutManager,
          className = _props3.className,
          height = _props3.height,
          horizontalOverscanSize = _props3.horizontalOverscanSize,
          id = _props3.id,
          noContentRenderer = _props3.noContentRenderer,
          style = _props3.style,
          verticalOverscanSize = _props3.verticalOverscanSize,
          width = _props3.width;
      var _state2 = this.state,
          isScrolling = _state2.isScrolling,
          scrollLeft = _state2.scrollLeft,
          scrollTop = _state2.scrollTop;

      // Memoization reset

      if (this._lastRenderedCellCount !== cellCount || this._lastRenderedCellLayoutManager !== cellLayoutManager || this._calculateSizeAndPositionDataOnNextUpdate) {
        this._lastRenderedCellCount = cellCount;
        this._lastRenderedCellLayoutManager = cellLayoutManager;
        this._calculateSizeAndPositionDataOnNextUpdate = false;

        cellLayoutManager.calculateSizeAndPositionData();
      }

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize(),
          totalHeight = _cellLayoutManager$ge3.height,
          totalWidth = _cellLayoutManager$ge3.width;

      // Safely expand the rendered area by the specified overscan amount


      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        {
          ref: this._setScrollingContainerRef,
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0 },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            } },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this2 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this2.props.isScrollingChange;


        isScrollingChange(false);

        _this2._disablePointerEventsTimeoutId = null;
        _this2.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this3 = this;

      var scrollLeft = _ref2.scrollLeft,
          scrollTop = _ref2.scrollTop,
          totalHeight = _ref2.totalHeight,
          totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft,
              scrollTop = _ref3.scrollTop;
          var _props4 = _this3.props,
              height = _props4.height,
              onScroll = _props4.onScroll,
              width = _props4.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft,
          scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.cellCount === 0 && (prevState.scrollLeft !== 0 || prevState.scrollTop !== 0)) {
        return {
          scrollLeft: 0,
          scrollTop: 0
        };
      } else if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  scrollToCell: -1,
  style: {},
  verticalOverscanSize: 0
};
CollectionView.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number.isRequired,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(CollectionView);

/* harmony default export */ __webpack_exports__["a"] = (CollectionView);

/***/ }),
/* 1356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(1357);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount,
      cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter,
      sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(1358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__types__ = __webpack_require__(163);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height,
          width = _ref.width,
          x = _ref.x,
          y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height,
          width = _ref3.width,
          x = _ref3.x,
          y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum,
          index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);



/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(163);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height,
        width = _ref.width,
        x = _ref.x,
        y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}();

/* harmony default export */ __webpack_exports__["a"] = (Section);



/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === undefined ? 'auto' : _ref$align,
      cellOffset = _ref.cellOffset,
      cellSize = _ref.cellSize,
      containerSize = _ref.containerSize,
      currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(1361);
/* unused harmony reexport ColumnSizer */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a" /* default */]);


/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _React$PureComponent);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          columnMaxWidth = _props.columnMaxWidth,
          columnMinWidth = _props.columnMinWidth,
          columnCount = _props.columnCount,
          width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          children = _props2.children,
          columnMaxWidth = _props2.columnMaxWidth,
          columnMinWidth = _props2.columnMinWidth,
          columnCount = _props2.columnCount,
          width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        columnWidth: columnWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
ColumnSizer.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : {};

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(1363);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a"]; });


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a" /* default */]);


/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__ = __webpack_require__(398);









/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfiniteLoader, _React$PureComponent);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'resetLoadMoreRowsCache',
    value: function resetLoadMoreRowsCache(autoReload) {
      this._loadMoreRowsMemoizer = Object(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

      if (autoReload) {
        this._doStuff(this._lastRenderedStartIndex, this._lastRenderedStopIndex);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild, _this2._lastRenderedStartIndex);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var startIndex = _ref.startIndex,
          stopIndex = _ref.stopIndex;

      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      this._doStuff(startIndex, stopIndex);
    }
  }, {
    key: '_doStuff',
    value: function _doStuff(startIndex, stopIndex) {
      var _this3 = this;

      var _props = this.props,
          isRowLoaded = _props.isRowLoaded,
          minimumBatchSize = _props.minimumBatchSize,
          rowCount = _props.rowCount,
          threshold = _props.threshold;


      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
      }, []);

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["PureComponent"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
InfiniteLoader.propTypes =  false ? {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : {};
function isRangeVisible(_ref2) {
  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex,
      lastRenderedStopIndex = _ref2.lastRenderedStopIndex,
      startIndex = _ref2.startIndex,
      stopIndex = _ref2.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref3) {
  var isRowLoaded = _ref3.isRowLoaded,
      minimumBatchSize = _ref3.minimumBatchSize,
      rowCount = _ref3.rowCount,
      startIndex = _ref3.startIndex,
      stopIndex = _ref3.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var currentIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component, currentIndex);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 1364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(627);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(266);
/* unused harmony reexport bpfrpt_proptype_RowRendererParams */








/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1366), __esModule: true };

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1367);
var $Object = __webpack_require__(40).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(139);
var $getOwnPropertyDescriptor = __webpack_require__(395).f;

__webpack_require__(386)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCellPositioner__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Masonry__ = __webpack_require__(401);
/* unused harmony reexport createCellPositioner */
/* unused harmony reexport Masonry */



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__Masonry__["a" /* default */]);


/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Masonry__ = __webpack_require__(401);


function createCellPositioner(_ref) {
  var cellMeasurerCache = _ref.cellMeasurerCache,
      columnCount = _ref.columnCount,
      columnWidth = _ref.columnWidth,
      _ref$spacer = _ref.spacer,
      spacer = _ref$spacer === undefined ? 0 : _ref$spacer;

  var columnHeights = void 0;

  initOrResetDerivedValues();

  function cellPositioner(index) {
    // Find the shortest column and use it.
    var columnIndex = 0;
    for (var i = 1; i < columnHeights.length; i++) {
      if (columnHeights[i] < columnHeights[columnIndex]) {
        columnIndex = i;
      }
    }

    var left = columnIndex * (columnWidth + spacer);
    var top = columnHeights[columnIndex] || 0;

    columnHeights[columnIndex] = top + cellMeasurerCache.getHeight(index) + spacer;

    return {
      left: left,
      top: top
    };
  }

  function initOrResetDerivedValues() {
    // Track the height of each column.
    // Layout algorithm below always inserts into the shortest column.
    columnHeights = [];
    for (var i = 0; i < columnCount; i++) {
      columnHeights[i] = 0;
    }
  }

  function reset(params) {
    columnCount = params.columnCount;
    columnWidth = params.columnWidth;
    spacer = params.spacer;

    initOrResetDerivedValues();
  }

  cellPositioner.reset = reset;

  return cellPositioner;
}



/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(601);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__ = __webpack_require__(1379);





// Position cache requirements:
//   O(log(n)) lookup of cells to render for a given viewport size
//   O(1) lookup of shortest measured column (so we know when to enter phase 1)
var PositionCache = function () {
  function PositionCache() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PositionCache);

    this._columnSizeMap = {};
    this._intervalTree = Object(__WEBPACK_IMPORTED_MODULE_3__vendor_intervalTree__["a" /* default */])();
    this._leftMap = {};
  }
  // Tracks the height of each column


  // Store tops and bottoms of each cell for fast intersection lookup.


  // Maps cell index to x coordinates for quick lookup.


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PositionCache, [{
    key: 'estimateTotalHeight',
    value: function estimateTotalHeight(cellCount, columnCount, defaultCellHeight) {
      var unmeasuredCellCount = cellCount - this.count;
      return this.tallestColumnSize + Math.ceil(unmeasuredCellCount / columnCount) * defaultCellHeight;
    }

    // Render all cells visible within the viewport range defined.

  }, {
    key: 'range',
    value: function range(scrollTop, clientHeight, renderCallback) {
      var _this = this;

      this._intervalTree.queryInterval(scrollTop, scrollTop + clientHeight, function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_ref, 3),
            top = _ref2[0],
            _ = _ref2[1],
            index = _ref2[2];

        return renderCallback(index, _this._leftMap[index], top);
      });
    }
  }, {
    key: 'setPosition',
    value: function setPosition(index, left, top, height) {
      this._intervalTree.insert([top, top + height, index]);
      this._leftMap[index] = left;

      var columnSizeMap = this._columnSizeMap;
      var columnHeight = columnSizeMap[left];
      if (columnHeight === undefined) {
        columnSizeMap[left] = top + height;
      } else {
        columnSizeMap[left] = Math.max(columnHeight, top + height);
      }
    }
  }, {
    key: 'count',
    get: function get() {
      return this._intervalTree.count;
    }
  }, {
    key: 'shortestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = size === 0 ? height : Math.min(size, height);
      }

      return size;
    }
  }, {
    key: 'tallestColumnSize',
    get: function get() {
      var columnSizeMap = this._columnSizeMap;

      var size = 0;

      for (var i in columnSizeMap) {
        var height = columnSizeMap[i];
        size = Math.max(size, height);
      }

      return size;
    }
  }]);

  return PositionCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (PositionCache);

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(1373);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(1376);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1374), __esModule: true };

/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(264);
__webpack_require__(262);
module.exports = __webpack_require__(1375);


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(399);
var ITERATOR = __webpack_require__(56)('iterator');
var Iterators = __webpack_require__(162);
module.exports = __webpack_require__(40).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1377), __esModule: true };

/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(264);
__webpack_require__(262);
module.exports = __webpack_require__(1378);


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(90);
var get = __webpack_require__(617);
module.exports = __webpack_require__(40).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createWrapper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__ = __webpack_require__(1380);
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/interval-tree-1d
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax in an upstream dependency.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/



var NOT_FOUND = 0;
var SUCCESS = 1;
var EMPTY = 2;

function IntervalTreeNode(mid, left, right, leftPoints, rightPoints) {
  this.mid = mid;
  this.left = left;
  this.right = right;
  this.leftPoints = leftPoints;
  this.rightPoints = rightPoints;
  this.count = (left ? left.count : 0) + (right ? right.count : 0) + leftPoints.length;
}

var proto = IntervalTreeNode.prototype;

function copy(a, b) {
  a.mid = b.mid;
  a.left = b.left;
  a.right = b.right;
  a.leftPoints = b.leftPoints;
  a.rightPoints = b.rightPoints;
  a.count = b.count;
}

function rebuild(node, intervals) {
  var ntree = createIntervalTree(intervals);
  node.mid = ntree.mid;
  node.left = ntree.left;
  node.right = ntree.right;
  node.leftPoints = ntree.leftPoints;
  node.rightPoints = ntree.rightPoints;
  node.count = ntree.count;
}

function rebuildWithInterval(node, interval) {
  var intervals = node.intervals([]);
  intervals.push(interval);
  rebuild(node, intervals);
}

function rebuildWithoutInterval(node, interval) {
  var intervals = node.intervals([]);
  var idx = intervals.indexOf(interval);
  if (idx < 0) {
    return NOT_FOUND;
  }
  intervals.splice(idx, 1);
  rebuild(node, intervals);
  return SUCCESS;
}

proto.intervals = function (result) {
  result.push.apply(result, this.leftPoints);
  if (this.left) {
    this.left.intervals(result);
  }
  if (this.right) {
    this.right.intervals(result);
  }
  return result;
};

proto.insert = function (interval) {
  var weight = this.count - this.leftPoints.length;
  this.count += 1;
  if (interval[1] < this.mid) {
    if (this.left) {
      if (4 * (this.left.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.left.insert(interval);
      }
    } else {
      this.left = createIntervalTree([interval]);
    }
  } else if (interval[0] > this.mid) {
    if (this.right) {
      if (4 * (this.right.count + 1) > 3 * (weight + 1)) {
        rebuildWithInterval(this, interval);
      } else {
        this.right.insert(interval);
      }
    } else {
      this.right = createIntervalTree([interval]);
    }
  } else {
    var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin);
    var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd);
    this.leftPoints.splice(l, 0, interval);
    this.rightPoints.splice(r, 0, interval);
  }
};

proto.remove = function (interval) {
  var weight = this.count - this.leftPoints;
  if (interval[1] < this.mid) {
    if (!this.left) {
      return NOT_FOUND;
    }
    var rw = this.right ? this.right.count : 0;
    if (4 * rw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.left.remove(interval);
    if (r === EMPTY) {
      this.left = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else if (interval[0] > this.mid) {
    if (!this.right) {
      return NOT_FOUND;
    }
    var lw = this.left ? this.left.count : 0;
    if (4 * lw > 3 * (weight - 1)) {
      return rebuildWithoutInterval(this, interval);
    }
    var r = this.right.remove(interval);
    if (r === EMPTY) {
      this.right = null;
      this.count -= 1;
      return SUCCESS;
    } else if (r === SUCCESS) {
      this.count -= 1;
    }
    return r;
  } else {
    if (this.count === 1) {
      if (this.leftPoints[0] === interval) {
        return EMPTY;
      } else {
        return NOT_FOUND;
      }
    }
    if (this.leftPoints.length === 1 && this.leftPoints[0] === interval) {
      if (this.left && this.right) {
        var p = this;
        var n = this.left;
        while (n.right) {
          p = n;
          n = n.right;
        }
        if (p === this) {
          n.right = this.right;
        } else {
          var l = this.left;
          var r = this.right;
          p.count -= n.count;
          p.right = n.left;
          n.left = l;
          n.right = r;
        }
        copy(this, n);
        this.count = (this.left ? this.left.count : 0) + (this.right ? this.right.count : 0) + this.leftPoints.length;
      } else if (this.left) {
        copy(this, this.left);
      } else {
        copy(this, this.right);
      }
      return SUCCESS;
    }
    for (var l = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.leftPoints, interval, compareBegin); l < this.leftPoints.length; ++l) {
      if (this.leftPoints[l][0] !== interval[0]) {
        break;
      }
      if (this.leftPoints[l] === interval) {
        this.count -= 1;
        this.leftPoints.splice(l, 1);
        for (var r = __WEBPACK_IMPORTED_MODULE_0__binarySearchBounds__["a" /* default */].ge(this.rightPoints, interval, compareEnd); r < this.rightPoints.length; ++r) {
          if (this.rightPoints[r][1] !== interval[1]) {
            break;
          } else if (this.rightPoints[r] === interval) {
            this.rightPoints.splice(r, 1);
            return SUCCESS;
          }
        }
      }
    }
    return NOT_FOUND;
  }
};

function reportLeftRange(arr, hi, cb) {
  for (var i = 0; i < arr.length && arr[i][0] <= hi; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRightRange(arr, lo, cb) {
  for (var i = arr.length - 1; i >= 0 && arr[i][1] >= lo; --i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

function reportRange(arr, cb) {
  for (var i = 0; i < arr.length; ++i) {
    var r = cb(arr[i]);
    if (r) {
      return r;
    }
  }
}

proto.queryPoint = function (x, cb) {
  if (x < this.mid) {
    if (this.left) {
      var r = this.left.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportLeftRange(this.leftPoints, x, cb);
  } else if (x > this.mid) {
    if (this.right) {
      var r = this.right.queryPoint(x, cb);
      if (r) {
        return r;
      }
    }
    return reportRightRange(this.rightPoints, x, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

proto.queryInterval = function (lo, hi, cb) {
  if (lo < this.mid && this.left) {
    var r = this.left.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi > this.mid && this.right) {
    var r = this.right.queryInterval(lo, hi, cb);
    if (r) {
      return r;
    }
  }
  if (hi < this.mid) {
    return reportLeftRange(this.leftPoints, hi, cb);
  } else if (lo > this.mid) {
    return reportRightRange(this.rightPoints, lo, cb);
  } else {
    return reportRange(this.leftPoints, cb);
  }
};

function compareNumbers(a, b) {
  return a - b;
}

function compareBegin(a, b) {
  var d = a[0] - b[0];
  if (d) {
    return d;
  }
  return a[1] - b[1];
}

function compareEnd(a, b) {
  var d = a[1] - b[1];
  if (d) {
    return d;
  }
  return a[0] - b[0];
}

function createIntervalTree(intervals) {
  if (intervals.length === 0) {
    return null;
  }
  var pts = [];
  for (var i = 0; i < intervals.length; ++i) {
    pts.push(intervals[i][0], intervals[i][1]);
  }
  pts.sort(compareNumbers);

  var mid = pts[pts.length >> 1];

  var leftIntervals = [];
  var rightIntervals = [];
  var centerIntervals = [];
  for (var i = 0; i < intervals.length; ++i) {
    var s = intervals[i];
    if (s[1] < mid) {
      leftIntervals.push(s);
    } else if (mid < s[0]) {
      rightIntervals.push(s);
    } else {
      centerIntervals.push(s);
    }
  }

  //Split center intervals
  var leftPoints = centerIntervals;
  var rightPoints = centerIntervals.slice();
  leftPoints.sort(compareBegin);
  rightPoints.sort(compareEnd);

  return new IntervalTreeNode(mid, createIntervalTree(leftIntervals), createIntervalTree(rightIntervals), leftPoints, rightPoints);
}

//User friendly wrapper that makes it possible to support empty trees
function IntervalTree(root) {
  this.root = root;
}

var tproto = IntervalTree.prototype;

tproto.insert = function (interval) {
  if (this.root) {
    this.root.insert(interval);
  } else {
    this.root = new IntervalTreeNode(interval[0], null, null, [interval], [interval]);
  }
};

tproto.remove = function (interval) {
  if (this.root) {
    var r = this.root.remove(interval);
    if (r === EMPTY) {
      this.root = null;
    }
    return r !== NOT_FOUND;
  }
  return false;
};

tproto.queryPoint = function (p, cb) {
  if (this.root) {
    return this.root.queryPoint(p, cb);
  }
};

tproto.queryInterval = function (lo, hi, cb) {
  if (lo <= hi && this.root) {
    return this.root.queryInterval(lo, hi, cb);
  }
};

Object.defineProperty(tproto, 'count', {
  get: function get() {
    if (this.root) {
      return this.root.count;
    }
    return 0;
  }
});

Object.defineProperty(tproto, 'intervals', {
  get: function get() {
    if (this.root) {
      return this.root.intervals([]);
    }
    return [];
  }
});

function createWrapper(intervals) {
  if (!intervals || intervals.length === 0) {
    return new IntervalTree(null);
  }
  return new IntervalTree(createIntervalTree(intervals));
}

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Binary Search Bounds
 * https://github.com/mikolalysenko/binary-search-bounds
 * Mikola Lysenko
 *
 * Inlined because of Content Security Policy issue caused by the use of `new Function(...)` syntax.
 * Issue reported here: https://github.com/mikolalysenko/binary-search-bounds/issues/5
 **/

function _GEA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x >= y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GEP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) >= 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _GTA(a, l, h, y) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x > y) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function _GTP(a, l, h, y, c) {
  var i = h + 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) > 0) {
      i = m;
      h = m - 1;
    } else {
      l = m + 1;
    }
  }
  return i;
}
function dispatchBsearchGT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _GTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _GTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LTA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x < y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LTP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) < 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLT(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LTP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LTA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _LEA(a, l, h, y) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x <= y) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function _LEP(a, l, h, y, c) {
  var i = l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (c(x, y) <= 0) {
      i = m;
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return i;
}
function dispatchBsearchLE(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _LEP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _LEA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

function _EQA(a, l, h, y) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    if (x === y) {
      return m;
    } else if (x <= y) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function _EQP(a, l, h, y, c) {
  l - 1;
  while (l <= h) {
    var m = l + h >>> 1,
        x = a[m];
    var p = c(x, y);
    if (p === 0) {
      return m;
    } else if (p <= 0) {
      l = m + 1;
    } else {
      h = m - 1;
    }
  }
  return -1;
}
function dispatchBsearchEQ(a, y, c, l, h) {
  if (typeof c === 'function') {
    return _EQP(a, l === void 0 ? 0 : l | 0, h === void 0 ? a.length - 1 : h | 0, y, c);
  } else {
    return _EQA(a, c === void 0 ? 0 : c | 0, l === void 0 ? a.length - 1 : l | 0, y);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  ge: dispatchBsearchGE,
  gt: dispatchBsearchGT,
  lt: dispatchBsearchLT,
  le: dispatchBsearchLE,
  eq: dispatchBsearchEQ
});

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(1382);
/* unused harmony reexport MultiGrid */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a" /* default */]);


/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(57);













var SCROLLBAR_SIZE_BUFFER = 20;

/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _React$PureComponent);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _initialiseProps.call(_this);

    var deferredMeasurementCache = props.deferredMeasurementCache,
        fixedColumnCount = props.fixedColumnCount,
        fixedRowCount = props.fixedRowCount;


    _this._maybeCalculateCachedStyles(true);

    if (deferredMeasurementCache) {
      _this._deferredMeasurementCacheBottomLeftGrid = fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: 0,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheBottomRightGrid = fixedColumnCount > 0 || fixedRowCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: fixedRowCount
      }) : deferredMeasurementCache;

      _this._deferredMeasurementCacheTopRightGrid = fixedColumnCount > 0 ? new __WEBPACK_IMPORTED_MODULE_10__CellMeasurerCacheDecorator__["a" /* default */]({
        cellMeasurerCache: deferredMeasurementCache,
        columnIndexOffset: fixedColumnCount,
        rowIndexOffset: 0
      }) : deferredMeasurementCache;
    }
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'forceUpdateGrids',
    value: function forceUpdateGrids() {
      this._bottomLeftGrid && this._bottomLeftGrid.forceUpdate();
      this._bottomRightGrid && this._bottomRightGrid.forceUpdate();
      this._topLeftGrid && this._topLeftGrid.forceUpdate();
      this._topRightGrid && this._topRightGrid.forceUpdate();
    }

    /** See Grid#invalidateCellSizeAfterRender */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref$columnIndex = _ref.columnIndex,
          columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex,
          _ref$rowIndex = _ref.rowIndex,
          rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
      this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$columnIndex = _ref2.columnIndex,
          columnIndex = _ref2$columnIndex === undefined ? 0 : _ref2$columnIndex,
          _ref2$rowIndex = _ref2.rowIndex,
          rowIndex = _ref2$rowIndex === undefined ? 0 : _ref2$rowIndex;

      var _props = this.props,
          fixedColumnCount = _props.fixedColumnCount,
          fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(true);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          scrollLeft = _props2.scrollLeft,
          scrollTop = _props2.scrollTop;


      if (scrollLeft > 0 || scrollTop > 0) {
        var newState = {};

        if (scrollLeft > 0) {
          newState.scrollLeft = scrollLeft;
        }

        if (scrollTop > 0) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._handleInvalidatedGridSize();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props,
          onScroll = _props3.onScroll,
          onSectionRendered = _props3.onSectionRendered,
          onScrollbarPresenceChange = _props3.onScrollbarPresenceChange,
          scrollLeftProp = _props3.scrollLeft,
          scrollToColumn = _props3.scrollToColumn,
          scrollTopProp = _props3.scrollTop,
          scrollToRow = _props3.scrollToRow,
          rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'onScrollbarPresenceChange', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      this._prepareForRender();

      // Don't render any of our Grids if there are no cells.
      // This mirrors what Grid does,
      // And prevents us from recording inaccurage measurements when used with CellMeasurer.
      if (this.props.width === 0 || this.props.height === 0) {
        return null;
      }

      // scrollTop and scrollLeft props are explicitly filtered out and ignored

      var _state = this.state,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount,
          columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (typeof columnWidth === 'function') {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount,
          rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (typeof rowHeight === 'function') {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }
  }, {
    key: '_handleInvalidatedGridSize',
    value: function _handleInvalidatedGridSize() {
      if (typeof this._deferredInvalidateColumnIndex === 'number') {
        var columnIndex = this._deferredInvalidateColumnIndex;
        var rowIndex = this._deferredInvalidateRowIndex;

        this._deferredInvalidateColumnIndex = null;
        this._deferredInvalidateRowIndex = null;

        this.recomputeGridSize({
          columnIndex: columnIndex,
          rowIndex: rowIndex
        });
        this.forceUpdate();
      }
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(resetAll) {
      var _props4 = this.props,
          columnWidth = _props4.columnWidth,
          enableFixedColumnScroll = _props4.enableFixedColumnScroll,
          enableFixedRowScroll = _props4.enableFixedRowScroll,
          height = _props4.height,
          fixedColumnCount = _props4.fixedColumnCount,
          fixedRowCount = _props4.fixedRowCount,
          rowHeight = _props4.rowHeight,
          style = _props4.style,
          styleBottomLeftGrid = _props4.styleBottomLeftGrid,
          styleBottomRightGrid = _props4.styleBottomRightGrid,
          styleTopLeftGrid = _props4.styleTopLeftGrid,
          styleTopRightGrid = _props4.styleTopRightGrid,
          width = _props4.width;


      var sizeChange = resetAll || height !== this._lastRenderedHeight || width !== this._lastRenderedWidth;
      var leftSizeChange = resetAll || columnWidth !== this._lastRenderedColumnWidth || fixedColumnCount !== this._lastRenderedFixedColumnCount;
      var topSizeChange = resetAll || fixedRowCount !== this._lastRenderedFixedRowCount || rowHeight !== this._lastRenderedRowHeight;

      if (resetAll || sizeChange || style !== this._lastRenderedStyle) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          overflow: 'visible', // Let :focus outline show through
          width: width
        }, style);
      }

      if (resetAll || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(this.props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(this.props),
          overflow: 'visible', // Let :focus outline show through
          position: 'relative',
          width: width
        };
      }

      if (resetAll || styleBottomLeftGrid !== this._lastRenderedStyleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: enableFixedColumnScroll ? 'auto' : 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (resetAll || leftSizeChange || styleBottomRightGrid !== this._lastRenderedStyleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (resetAll || styleTopLeftGrid !== this._lastRenderedStyleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (resetAll || leftSizeChange || styleTopRightGrid !== this._lastRenderedStyleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(this.props),
          overflowX: enableFixedRowScroll ? 'auto' : 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }

      this._lastRenderedColumnWidth = columnWidth;
      this._lastRenderedFixedColumnCount = fixedColumnCount;
      this._lastRenderedFixedRowCount = fixedRowCount;
      this._lastRenderedHeight = height;
      this._lastRenderedRowHeight = rowHeight;
      this._lastRenderedStyle = style;
      this._lastRenderedStyleBottomLeftGrid = styleBottomLeftGrid;
      this._lastRenderedStyleBottomRightGrid = styleBottomRightGrid;
      this._lastRenderedStyleTopLeftGrid = styleTopLeftGrid;
      this._lastRenderedStyleTopRightGrid = styleTopRightGrid;
      this._lastRenderedWidth = width;
    }
  }, {
    key: '_prepareForRender',
    value: function _prepareForRender() {
      if (this._lastRenderedColumnWidth !== this.props.columnWidth || this._lastRenderedFixedColumnCount !== this.props.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (this._lastRenderedFixedRowCount !== this.props.fixedRowCount || this._lastRenderedRowHeight !== this.props.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles();

      this._lastRenderedColumnWidth = this.props.columnWidth;
      this._lastRenderedFixedColumnCount = this.props.fixedColumnCount;
      this._lastRenderedFixedRowCount = this.props.fixedRowCount;
      this._lastRenderedRowHeight = this.props.rowHeight;
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var enableFixedColumnScroll = props.enableFixedColumnScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          hideBottomLeftGridScrollbar = props.hideBottomLeftGridScrollbar;
      var showVerticalScrollbar = this.state.showVerticalScrollbar;


      if (!fixedColumnCount) {
        return null;
      }

      var additionalRowCount = showVerticalScrollbar ? 1 : 0,
          height = this._getBottomGridHeight(props),
          width = this._getLeftGridWidth(props),
          scrollbarSize = this.state.showVerticalScrollbar ? this.state.scrollbarSize : 0,
          gridWidth = hideBottomLeftGridScrollbar ? width + scrollbarSize : width;

      var bottomLeftGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        className: this.props.classNameBottomLeftGrid,
        columnCount: fixedColumnCount,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomLeftGrid,
        height: height,
        onScroll: enableFixedColumnScroll ? this._onScrollTop : undefined,
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount) + additionalRowCount,
        rowHeight: this._rowHeightBottomGrid,
        style: this._bottomLeftGridStyle,
        tabIndex: null,
        width: gridWidth
      }));

      if (hideBottomLeftGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'BottomLeftGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._bottomLeftGridStyle, {
              height: height,
              width: width,
              overflowY: 'hidden'
            }) },
          bottomLeftGrid
        );
      }
      return bottomLeftGrid;
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          rowCount = props.rowCount,
          scrollToColumn = props.scrollToColumn,
          scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        className: this.props.classNameBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheBottomRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        onScrollbarPresenceChange: this._onScrollbarPresenceChange,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        className: this.props.classNameTopLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        tabIndex: null,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount,
          enableFixedRowScroll = props.enableFixedRowScroll,
          fixedColumnCount = props.fixedColumnCount,
          fixedRowCount = props.fixedRowCount,
          scrollLeft = props.scrollLeft,
          hideTopRightGridScrollbar = props.hideTopRightGridScrollbar;
      var _state2 = this.state,
          showHorizontalScrollbar = _state2.showHorizontalScrollbar,
          scrollbarSize = _state2.scrollbarSize;


      if (!fixedRowCount) {
        return null;
      }

      var additionalColumnCount = showHorizontalScrollbar ? 1 : 0,
          height = this._getTopGridHeight(props),
          width = this._getRightGridWidth(props),
          additionalHeight = showHorizontalScrollbar ? scrollbarSize : 0;

      var gridHeight = height,
          style = this._topRightGridStyle;

      if (hideTopRightGridScrollbar) {
        gridHeight = height + additionalHeight;
        style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
          left: 0
        });
      }

      var topRightGrid = __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        className: this.props.classNameTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount) + additionalColumnCount,
        columnWidth: this._columnWidthRightGrid,
        deferredMeasurementCache: this._deferredMeasurementCacheTopRightGrid,
        height: gridHeight,
        onScroll: enableFixedRowScroll ? this._onScrollLeft : undefined,
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: style,
        tabIndex: null,
        width: width
      }));

      if (hideTopRightGridScrollbar) {
        return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"](
          'div',
          {
            className: 'TopRightGrid_ScrollWrapper',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this._topRightGridStyle, {
              height: height,
              width: width,
              overflowX: 'hidden'
            }) },
          topRightGrid
        );
      }
      return topRightGrid;
    }
  }], [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (nextProps.scrollLeft !== prevState.scrollLeft || nextProps.scrollTop !== prevState.scrollTop) {
        return {
          scrollLeft: nextProps.scrollLeft != null && nextProps.scrollLeft >= 0 ? nextProps.scrollLeft : prevState.scrollLeft,
          scrollTop: nextProps.scrollTop != null && nextProps.scrollTop >= 0 ? nextProps.scrollTop : prevState.scrollTop
        };
      }

      return null;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_8_react__["PureComponent"]);

MultiGrid.defaultProps = {
  classNameBottomLeftGrid: '',
  classNameBottomRightGrid: '',
  classNameTopLeftGrid: '',
  classNameTopRightGrid: '',
  enableFixedColumnScroll: false,
  enableFixedRowScroll: false,
  fixedColumnCount: 0,
  fixedRowCount: 0,
  scrollToColumn: -1,
  scrollToRow: -1,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {},
  hideTopRightGridScrollbar: false,
  hideBottomLeftGridScrollbar: false
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = {
    scrollLeft: 0,
    scrollTop: 0,
    scrollbarSize: 0,
    showHorizontalScrollbar: false,
    showVerticalScrollbar: false
  };
  this._deferredInvalidateColumnIndex = null;
  this._deferredInvalidateRowIndex = null;

  this._bottomLeftGridRef = function (ref) {
    _this2._bottomLeftGrid = ref;
  };

  this._bottomRightGridRef = function (ref) {
    _this2._bottomRightGrid = ref;
  };

  this._cellRendererBottomLeftGrid = function (_ref3) {
    var rowIndex = _ref3.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['rowIndex']);

    var _props5 = _this2.props,
        cellRenderer = _props5.cellRenderer,
        fixedRowCount = _props5.fixedRowCount,
        rowCount = _props5.rowCount;


    if (rowIndex === rowCount - fixedRowCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          height: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        parent: _this2,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  };

  this._cellRendererBottomRightGrid = function (_ref4) {
    var columnIndex = _ref4.columnIndex,
        rowIndex = _ref4.rowIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex', 'rowIndex']);

    var _props6 = _this2.props,
        cellRenderer = _props6.cellRenderer,
        fixedColumnCount = _props6.fixedColumnCount,
        fixedRowCount = _props6.fixedRowCount;


    return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
      columnIndex: columnIndex + fixedColumnCount,
      parent: _this2,
      rowIndex: rowIndex + fixedRowCount
    }));
  };

  this._cellRendererTopRightGrid = function (_ref5) {
    var columnIndex = _ref5.columnIndex,
        rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref5, ['columnIndex']);

    var _props7 = _this2.props,
        cellRenderer = _props7.cellRenderer,
        columnCount = _props7.columnCount,
        fixedColumnCount = _props7.fixedColumnCount;


    if (columnIndex === columnCount - fixedColumnCount) {
      return __WEBPACK_IMPORTED_MODULE_8_react__["createElement"]('div', {
        key: rest.key,
        style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest.style, {
          width: SCROLLBAR_SIZE_BUFFER
        })
      });
    } else {
      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        parent: _this2
      }));
    }
  };

  this._columnWidthRightGrid = function (_ref6) {
    var index = _ref6.index;
    var _props8 = _this2.props,
        columnCount = _props8.columnCount,
        fixedColumnCount = _props8.fixedColumnCount,
        columnWidth = _props8.columnWidth;
    var _state3 = _this2.state,
        scrollbarSize = _state3.scrollbarSize,
        showHorizontalScrollbar = _state3.showHorizontalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showHorizontalScrollbar && index === columnCount - fixedColumnCount) {
      return scrollbarSize;
    }

    return typeof columnWidth === 'function' ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
  };

  this._onScroll = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft,
        scrollTop = scrollInfo.scrollTop;

    _this2.setState({
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    });
    var onScroll = _this2.props.onScroll;
    if (onScroll) {
      onScroll(scrollInfo);
    }
  };

  this._onScrollbarPresenceChange = function (_ref7) {
    var horizontal = _ref7.horizontal,
        size = _ref7.size,
        vertical = _ref7.vertical;
    var _state4 = _this2.state,
        showHorizontalScrollbar = _state4.showHorizontalScrollbar,
        showVerticalScrollbar = _state4.showVerticalScrollbar;


    if (horizontal !== showHorizontalScrollbar || vertical !== showVerticalScrollbar) {
      _this2.setState({
        scrollbarSize: size,
        showHorizontalScrollbar: horizontal,
        showVerticalScrollbar: vertical
      });

      var onScrollbarPresenceChange = _this2.props.onScrollbarPresenceChange;

      if (typeof onScrollbarPresenceChange === 'function') {
        onScrollbarPresenceChange({
          horizontal: horizontal,
          size: size,
          vertical: vertical
        });
      }
    }
  };

  this._onScrollLeft = function (scrollInfo) {
    var scrollLeft = scrollInfo.scrollLeft;

    _this2._onScroll({
      scrollLeft: scrollLeft,
      scrollTop: _this2.state.scrollTop
    });
  };

  this._onScrollTop = function (scrollInfo) {
    var scrollTop = scrollInfo.scrollTop;

    _this2._onScroll({
      scrollTop: scrollTop,
      scrollLeft: _this2.state.scrollLeft
    });
  };

  this._rowHeightBottomGrid = function (_ref8) {
    var index = _ref8.index;
    var _props9 = _this2.props,
        fixedRowCount = _props9.fixedRowCount,
        rowCount = _props9.rowCount,
        rowHeight = _props9.rowHeight;
    var _state5 = _this2.state,
        scrollbarSize = _state5.scrollbarSize,
        showVerticalScrollbar = _state5.showVerticalScrollbar;

    // An extra cell is added to the count
    // This gives the smaller Grid extra room for offset,
    // In case the main (bottom right) Grid has a scrollbar
    // If no scrollbar, the extra space is overflow:hidden anyway

    if (showVerticalScrollbar && index === rowCount - fixedRowCount) {
      return scrollbarSize;
    }

    return typeof rowHeight === 'function' ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
  };

  this._topLeftGridRef = function (ref) {
    _this2._topLeftGrid = ref;
  };

  this._topRightGridRef = function (ref) {
    _this2._topRightGrid = ref;
  };
};

MultiGrid.propTypes =  false ? {
  classNameBottomLeftGrid: PropTypes.string.isRequired,
  classNameBottomRightGrid: PropTypes.string.isRequired,
  classNameTopLeftGrid: PropTypes.string.isRequired,
  classNameTopRightGrid: PropTypes.string.isRequired,
  enableFixedColumnScroll: PropTypes.bool.isRequired,
  enableFixedRowScroll: PropTypes.bool.isRequired,
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  onScrollbarPresenceChange: PropTypes.func,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired,
  hideTopRightGridScrollbar: PropTypes.bool,
  hideBottomLeftGridScrollbar: PropTypes.bool
} : {};


Object(__WEBPACK_IMPORTED_MODULE_9_react_lifecycles_compat__["polyfill"])(MultiGrid);

/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(625);




/**
 * Caches measurements for a given cell.
 */
var CellMeasurerCacheDecorator = function () {
  function CellMeasurerCacheDecorator() {
    var _this = this;

    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurerCacheDecorator);

    this.columnWidth = function (_ref) {
      var index = _ref.index;

      _this._cellMeasurerCache.columnWidth({
        index: index + _this._columnIndexOffset
      });
    };

    this.rowHeight = function (_ref2) {
      var index = _ref2.index;

      _this._cellMeasurerCache.rowHeight({
        index: index + _this._rowIndexOffset
      });
    };

    var cellMeasurerCache = params.cellMeasurerCache,
        _params$columnIndexOf = params.columnIndexOffset,
        columnIndexOffset = _params$columnIndexOf === undefined ? 0 : _params$columnIndexOf,
        _params$rowIndexOffse = params.rowIndexOffset,
        rowIndexOffset = _params$rowIndexOffse === undefined ? 0 : _params$rowIndexOffse;


    this._cellMeasurerCache = cellMeasurerCache;
    this._columnIndexOffset = columnIndexOffset;
    this._rowIndexOffset = rowIndexOffset;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellMeasurerCacheDecorator, [{
    key: 'clear',
    value: function clear(rowIndex, columnIndex) {
      this._cellMeasurerCache.clear(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'clearAll',
    value: function clearAll() {
      this._cellMeasurerCache.clearAll();
    }
  }, {
    key: 'hasFixedHeight',
    value: function hasFixedHeight() {
      return this._cellMeasurerCache.hasFixedHeight();
    }
  }, {
    key: 'hasFixedWidth',
    value: function hasFixedWidth() {
      return this._cellMeasurerCache.hasFixedWidth();
    }
  }, {
    key: 'getHeight',
    value: function getHeight(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getHeight(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'getWidth',
    value: function getWidth(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.getWidth(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'has',
    value: function has(rowIndex) {
      var columnIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      return this._cellMeasurerCache.has(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset);
    }
  }, {
    key: 'set',
    value: function set(rowIndex, columnIndex, width, height) {
      this._cellMeasurerCache.set(rowIndex + this._rowIndexOffset, columnIndex + this._columnIndexOffset, width, height);
    }
  }, {
    key: 'defaultHeight',
    get: function get() {
      return this._cellMeasurerCache.defaultHeight;
    }
  }, {
    key: 'defaultWidth',
    get: function get() {
      return this._cellMeasurerCache.defaultWidth;
    }
  }]);

  return CellMeasurerCacheDecorator;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurerCacheDecorator);

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(1385);
/* unused harmony reexport ScrollSync */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a" /* default */]);


/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _React$PureComponent);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state,
          clientHeight = _state.clientHeight,
          clientWidth = _state.clientWidth,
          scrollHeight = _state.scrollHeight,
          scrollLeft = _state.scrollLeft,
          scrollTop = _state.scrollTop,
          scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight,
          clientWidth = _ref.clientWidth,
          scrollHeight = _ref.scrollHeight,
          scrollLeft = _ref.scrollLeft,
          scrollTop = _ref.scrollTop,
          scrollWidth = _ref.scrollWidth;

      this.setState({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_6_react__["PureComponent"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
ScrollSync.propTypes =  false ? {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : {};

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMultiSort__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(628);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(629);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRowRenderer_js__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultHeaderRenderer__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRowRenderer__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Column__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortDirection__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SortIndicator__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table__ = __webpack_require__(1388);
/* unused harmony reexport createMultiSort */
/* unused harmony reexport defaultCellDataGetter */
/* unused harmony reexport defaultCellRenderer */
/* unused harmony reexport defaultHeaderRowRenderer */
/* unused harmony reexport defaultHeaderRenderer */
/* unused harmony reexport defaultRowRenderer */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__Column__["a"]; });
/* unused harmony reexport SortDirection */
/* unused harmony reexport SortIndicator */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__Table__["a"]; });











/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_9__Table__["a" /* default */]);


/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */


function createMultiSort(sortCallback) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      defaultSortBy = _ref.defaultSortBy,
      _ref$defaultSortDirec = _ref.defaultSortDirection,
      defaultSortDirection = _ref$defaultSortDirec === undefined ? {} : _ref$defaultSortDirec;

  if (!sortCallback) {
    throw Error('Required parameter "sortCallback" not specified');
  }

  var sortBy = defaultSortBy || [];
  var sortDirection = {};

  sortBy.forEach(function (dataKey) {
    sortDirection[dataKey] = defaultSortDirection.hasOwnProperty(dataKey) ? defaultSortDirection[dataKey] : 'ASC';
  });

  function sort(_ref2) {
    var defaultSortDirection = _ref2.defaultSortDirection,
        event = _ref2.event,
        dataKey = _ref2.sortBy;

    if (event.shiftKey) {
      // Shift + click appends a column to existing criteria
      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
        sortBy.push(dataKey);
      }
    } else if (event.ctrlKey || event.metaKey) {
      // Control + click removes column from sort (if pressent)
      var index = sortBy.indexOf(dataKey);
      if (index >= 0) {
        sortBy.splice(index, 1);
        delete sortDirection[dataKey];
      }
    } else {
      sortBy.length = 0;
      sortBy.push(dataKey);

      if (sortDirection.hasOwnProperty(dataKey)) {
        sortDirection[dataKey] = sortDirection[dataKey] === 'ASC' ? 'DESC' : 'ASC';
      } else {
        sortDirection[dataKey] = defaultSortDirection;
      }
    }

    // Notify application code
    sortCallback({
      sortBy: sortBy,
      sortDirection: sortDirection
    });
  }

  return {
    sort: sort,
    sortBy: sortBy,
    sortDirection: sortDirection
  };
}

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(634);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(633);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__ = __webpack_require__(630);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__SortDirection__ = __webpack_require__(267);




















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _React$PureComponent);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      if (this.Grid) {
        this.Grid.forceUpdate();
      }
    }

    /** See Grid#getOffsetForCell */

  }, {
    key: 'getOffsetForRow',
    value: function getOffsetForRow(_ref) {
      var alignment = _ref.alignment,
          index = _ref.index;

      if (this.Grid) {
        var _Grid$getOffsetForCel = this.Grid.getOffsetForCell({
          alignment: alignment,
          rowIndex: index
        }),
            scrollTop = _Grid$getOffsetForCel.scrollTop;

        return scrollTop;
      }
      return 0;
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'invalidateCellSizeAfterRender',
    value: function invalidateCellSizeAfterRender(_ref2) {
      var columnIndex = _ref2.columnIndex,
          rowIndex = _ref2.rowIndex;

      if (this.Grid) {
        this.Grid.invalidateCellSizeAfterRender({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      if (this.Grid) {
        this.Grid.measureAllCells();
      }
    }

    /** CellMeasurer compatibility */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$columnIndex = _ref3.columnIndex,
          columnIndex = _ref3$columnIndex === undefined ? 0 : _ref3$columnIndex,
          _ref3$rowIndex = _ref3.rowIndex,
          rowIndex = _ref3$rowIndex === undefined ? 0 : _ref3$rowIndex;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: rowIndex,
          columnIndex: columnIndex
        });
      }
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.recomputeGridSize({
          rowIndex: index
        });
      }
    }

    /** See Grid#scrollToPosition */

  }, {
    key: 'scrollToPosition',
    value: function scrollToPosition() {
      var scrollTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToPosition({ scrollTop: scrollTop });
      }
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.Grid) {
        this.Grid.scrollToCell({
          columnIndex: 0,
          rowIndex: index
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          children = _props.children,
          className = _props.className,
          disableHeader = _props.disableHeader,
          gridClassName = _props.gridClassName,
          gridStyle = _props.gridStyle,
          headerHeight = _props.headerHeight,
          headerRowRenderer = _props.headerRowRenderer,
          height = _props.height,
          id = _props.id,
          noRowsRenderer = _props.noRowsRenderer,
          rowClassName = _props.rowClassName,
          rowStyle = _props.rowStyle,
          scrollToIndex = _props.scrollToIndex,
          style = _props.style,
          width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flexStyles, {
          overflow: 'hidden'
        });
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table', className),
          id: id,
          role: 'grid',
          style: style },
        !disableHeader && headerRowRenderer({
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerRow', rowClass),
          columns: this._getHeaderColumns(),
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rowStyleObject, {
            height: headerHeight,
            overflow: 'hidden',
            paddingRight: scrollbarWidth,
            width: width
          })
        }),
        __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Grid__["b" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          autoContainerWidth: true,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: this._setRef,
          role: 'rowgroup',
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref4) {
      var column = _ref4.column,
          columnIndex = _ref4.columnIndex,
          isScrolling = _ref4.isScrolling,
          parent = _ref4.parent,
          rowData = _ref4.rowData,
          rowIndex = _ref4.rowIndex;
      var _column$props = column.props,
          cellDataGetter = _column$props.cellDataGetter,
          cellRenderer = _column$props.cellRenderer,
          className = _column$props.className,
          columnData = _column$props.columnData,
          dataKey = _column$props.dataKey,
          id = _column$props.id;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({
        cellData: cellData,
        columnData: columnData,
        columnIndex: columnIndex,
        dataKey: dataKey,
        isScrolling: isScrolling,
        parent: parent,
        rowData: rowData,
        rowIndex: rowIndex
      });

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-describedby': id,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__rowColumn', className),
          key: 'Row' + rowIndex + '-' + 'Col' + columnIndex,
          role: 'gridcell',
          style: style,
          title: title },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref5) {
      var column = _ref5.column,
          index = _ref5.index;
      var _props2 = this.props,
          headerClassName = _props2.headerClassName,
          headerStyle = _props2.headerStyle,
          onHeaderClick = _props2.onHeaderClick,
          sort = _props2.sort,
          sortBy = _props2.sortBy,
          sortDirection = _props2.sortDirection;
      var _column$props2 = column.props,
          columnData = _column$props2.columnData,
          dataKey = _column$props2.dataKey,
          defaultSortDirection = _column$props2.defaultSortDirection,
          disableSort = _column$props2.disableSort,
          headerRenderer = _column$props2.headerRenderer,
          id = _column$props2.id,
          label = _column$props2.label;

      var sortEnabled = !disableSort && sort;

      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        ReactVirtualized__Table__sortableHeaderColumn: sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, headerStyle, column.props.headerStyle));

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var headerOnClick = void 0,
          headerOnKeyDown = void 0,
          headerTabIndex = void 0,
          headerAriaSort = void 0,
          headerAriaLabel = void 0;

      if (sortEnabled || onHeaderClick) {
        // If this is a sortable header, clicking it should update the table data's sorting.
        var isFirstTimeSort = sortBy !== dataKey;

        // If this is the firstTime sort of this column, use the column default sort order.
        // Otherwise, invert the direction of the sort.
        var newSortDirection = isFirstTimeSort ? defaultSortDirection : sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].DESC;

        var onClick = function onClick(event) {
          sortEnabled && sort({
            defaultSortDirection: defaultSortDirection,
            event: event,
            sortBy: dataKey,
            sortDirection: newSortDirection
          });
          onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey, event: event });
        };

        var onKeyDown = function onKeyDown(event) {
          if (event.key === 'Enter' || event.key === ' ') {
            onClick(event);
          }
        };

        headerAriaLabel = column.props['aria-label'] || label || dataKey;
        headerTabIndex = 0;
        headerOnClick = onClick;
        headerOnKeyDown = onKeyDown;
      }

      if (sortBy === dataKey) {
        headerAriaSort = sortDirection === __WEBPACK_IMPORTED_MODULE_14__SortDirection__["a" /* default */].ASC ? 'ascending' : 'descending';
      }

      // Avoid using object-spread syntax with multiple objects here,
      // Since it results in an extra method call to 'babel-runtime/helpers/extends'
      // See PR https://github.com/bvaughn/react-virtualized/pull/942
      return __WEBPACK_IMPORTED_MODULE_9_react__["createElement"](
        'div',
        {
          'aria-label': headerAriaLabel,
          'aria-sort': headerAriaSort,
          className: classNames,
          id: id,
          key: 'Header-Col' + index,
          onClick: headerOnClick,
          onKeyDown: headerOnKeyDown,
          role: 'columnheader',
          style: style,
          tabIndex: headerTabIndex },
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref6) {
      var _this3 = this;

      var index = _ref6.rowIndex,
          isScrolling = _ref6.isScrolling,
          key = _ref6.key,
          parent = _ref6.parent,
          style = _ref6.style;
      var _props3 = this.props,
          children = _props3.children,
          onRowClick = _props3.onRowClick,
          onRowDoubleClick = _props3.onRowDoubleClick,
          onRowRightClick = _props3.onRowRightClick,
          onRowMouseOver = _props3.onRowMouseOver,
          onRowMouseOut = _props3.onRowMouseOut,
          rowClassName = _props3.rowClassName,
          rowGetter = _props3.rowGetter,
          rowRenderer = _props3.rowRenderer,
          rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = typeof rowClassName === 'function' ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = typeof rowStyle === 'function' ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          parent: parent,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, rowStyleObject, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      });

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowRightClick: onRowRightClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getHeaderColumns',
    value: function _getHeaderColumns() {
      var _this4 = this;

      var _props4 = this.props,
          children = _props4.children,
          disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_9_react__["Children"].toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return typeof rowHeight === 'function' ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref7) {
      var clientHeight = _ref7.clientHeight,
          scrollHeight = _ref7.scrollHeight,
          scrollTop = _ref7.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref8) {
      var rowOverscanStartIndex = _ref8.rowOverscanStartIndex,
          rowOverscanStopIndex = _ref8.rowOverscanStopIndex,
          rowStartIndex = _ref8.rowStartIndex,
          rowStopIndex = _ref8.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setRef',
    value: function _setRef(ref) {
      this.Grid = ref;
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      if (this.Grid) {
        var _Grid = Object(__WEBPACK_IMPORTED_MODULE_10_react_dom__["findDOMNode"])(this.Grid);
        var clientWidth = _Grid.clientWidth || 0;
        var offsetWidth = _Grid.offsetWidth || 0;
        var scrollbarWidth = offsetWidth - clientWidth;

        this.setState({ scrollbarWidth: scrollbarWidth });
      }
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_9_react__["PureComponent"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanIndicesGetter: __WEBPACK_IMPORTED_MODULE_11__Grid__["a" /* accessibilityOverscanIndicesGetter */],
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  headerRowRenderer: __WEBPACK_IMPORTED_MODULE_13__defaultHeaderRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  scrollToIndex: -1,
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
Table.propTypes =  false ? {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      var childType = children[i].type;
      if (childType !== Column && !(childType.prototype instanceof Column)) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: any[],
   *   style: any
   * }): PropTypes.node
   */
  headerRowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
   * Optional callback when a column's header is clicked.
   * ({ columnData: any, dataKey: string }): void
   */
  onHeaderClick: PropTypes.func,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked when a user right-clicks on a table row.
   * ({ index: number }): void
   */
  onRowRightClick: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /** See Grid#overscanIndicesGetter */
  overscanIndicesGetter: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number.isRequired,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * Should implement the following interface: ({
   *   defaultSortDirection: 'ASC' | 'DESC',
   *   event: MouseEvent,
   *   sortBy: string,
   *   sortDirection: SortDirection
   * }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : {};


/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(635);
/* unused harmony reexport WindowScroller */
/* unused harmony reexport IS_SCROLLING_TIMEOUT */


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a" /* default */]);


/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WindowScroller_js__ = __webpack_require__(635);



var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    if (document.body && originalBodyPointerEvents != null) {
      document.body.style.pointerEvents = originalBodyPointerEvents;
    }

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
  }

  var maximumTimeout = 0;
  mountedInstances.forEach(function (instance) {
    maximumTimeout = Math.max(maximumTimeout, instance.props.scrollingResetTimeInterval);
  });

  disablePointerEventsTimeoutId = Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["b" /* requestAnimationTimeout */])(enablePointerEventsAfterDelayCallback, maximumTimeout);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null && document.body) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.props.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent();
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.props.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_requestAnimationTimeout__["a" /* cancelAnimationTimeout */])(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}


/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDimensions;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionOffset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollOffset;


/**
 * Gets the dimensions of the element, accounting for API differences between
 * `window` and other DOM elements.
 */

var isWindow = function isWindow(element) {
  return element === window;
};

// TODO Move this into WindowScroller and import from there


var getBoundingBox = function getBoundingBox(element) {
  return element.getBoundingClientRect();
};

function getDimensions(scrollElement, props) {
  if (!scrollElement) {
    return {
      height: props.serverHeight,
      width: props.serverWidth
    };
  } else if (isWindow(scrollElement)) {
    var _window = window,
        innerHeight = _window.innerHeight,
        innerWidth = _window.innerWidth;

    return {
      height: typeof innerHeight === 'number' ? innerHeight : 0,
      width: typeof innerWidth === 'number' ? innerWidth : 0
    };
  } else {
    return getBoundingBox(scrollElement);
  }
}

/**
 * Gets the vertical and horizontal position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top or left position will be a negative number and this element’s top or left will be increased (by that amount).
 */
function getPositionOffset(element, container) {
  if (isWindow(container) && document.documentElement) {
    var containerElement = document.documentElement;
    var elementRect = getBoundingBox(element);
    var containerRect = getBoundingBox(containerElement);
    return {
      top: elementRect.top - containerRect.top,
      left: elementRect.left - containerRect.left
    };
  } else {
    var scrollOffset = getScrollOffset(container);
    var _elementRect = getBoundingBox(element);
    var _containerRect = getBoundingBox(container);
    return {
      top: _elementRect.top + scrollOffset.top - _containerRect.top,
      left: _elementRect.left + scrollOffset.left - _containerRect.left
    };
  }
}

/**
 * Gets the vertical and horizontal scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollOffset(element) {
  if (isWindow(element) && document.documentElement) {
    return {
      top: 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop,
      left: 'scrollX' in window ? window.scrollX : document.documentElement.scrollLeft
    };
  } else {
    return {
      top: element.scrollTop,
      left: element.scrollLeft
    };
  }
}

/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1393)();
}


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1394);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isDate;
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * var result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * var result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * var result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * var result = isDate({})
 * //=> false
 */
function isDate(value) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  return value instanceof Date || typeof value === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = format;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid_index_js__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__ = __webpack_require__(19);








 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_1__locale_en_US_index_js__["a" /* default */];
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_8__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = Object(__WEBPACK_IMPORTED_MODULE_3__toDate_index_js__["default"])(dirtyDate);

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isValid_index_js__["default"])(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = Object(__WEBPACK_IMPORTED_MODULE_6__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(originalDate);
  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_2__subMilliseconds_index_js__["a" /* default */])(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_5__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_formatters_index_js__["a" /* default */][firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring);
      }

      if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(substring)) {
        Object(__WEBPACK_IMPORTED_MODULE_7__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(substring);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__ = __webpack_require__(1399);

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildFormatLongFn_index_js__["a" /* default */])({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (formatLong);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formatRelative;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__ = __webpack_require__(1402);

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildLocalizeFn_index_js__["a" /* default */])({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (localize);

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__ = __webpack_require__(1405);


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: Object(__WEBPACK_IMPORTED_MODULE_0__lib_buildMatchPatternFn_index_js__["a" /* default */])({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: Object(__WEBPACK_IMPORTED_MODULE_1__lib_buildMatchFn_index_js__["a" /* default */])({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

/***/ }),
/* 1405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildMatchFn;
function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = parsePatterns.findIndex(function (pattern) {
        return pattern.test(string);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(string);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__ = __webpack_require__(639);







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = Object(__WEBPACK_IMPORTED_MODULE_5__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = Object(__WEBPACK_IMPORTED_MODULE_3__lib_getUTCISOWeekYear_index_js__["a" /* default */])(date); // Padding

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = Object(__WEBPACK_IMPORTED_MODULE_4__lib_getUTCWeek_index_js__["a" /* default */])(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_2__lib_getUTCISOWeek_index_js__["a" /* default */])(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getUTCDayOfYear_index_js__["a" /* default */])(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return __WEBPACK_IMPORTED_MODULE_0__lightFormatters_index_js__["a" /* default */].S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(Math.floor(absOffset / 60), 2);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_6__addLeadingZeros_index_js__["a" /* default */])(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__ = __webpack_require__(639);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
      case 'aaa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return Object(__WEBPACK_IMPORTED_MODULE_0__addLeadingZeros_index_js__["a" /* default */])(fractionalSeconds, token.length);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (formatters);

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUTCDayOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCISOWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__ = __webpack_require__(268);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var year = Object(__WEBPACK_IMPORTED_MODULE_0__getUTCISOWeekYear_index_js__["a" /* default */])(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__startOfUTCISOWeek_index_js__["a" /* default */])(fourthOfJanuary);
  return date;
}

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = startOfUTCWeekYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__ = __webpack_require__(269);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_1__getUTCWeekYear_index_js__["a" /* default */])(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__startOfUTCWeek_index_js__["a" /* default */])(firstWeek, dirtyOptions);
  return date;
}

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__ = __webpack_require__(645);


/**
 * @name subMinutes
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the minutes subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */

function subMinutes(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMinutes_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addHours_index_js__ = __webpack_require__(646);


/**
 * @name subHours
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */

function subHours(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addHours_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addDays_index_js__ = __webpack_require__(404);


/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addDays_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__ = __webpack_require__(647);


/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */

function subWeeks(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addWeeks_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__ = __webpack_require__(405);


/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addMonths_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = subYears;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addYears_index_js__ = __webpack_require__(649);


/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var amount = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyAmount);
  return Object(__WEBPACK_IMPORTED_MODULE_1__addYears_index_js__["default"])(dirtyDate, -amount);
}

/***/ }),
/* 1417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */

function getSeconds(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */

function getMinutes(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */

function getHours(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */

function getDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  return day;
}

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getDate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */

function getDate(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */

function getMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var month = date.getMonth();
  return month;
}

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */

function getQuarter(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */

function getYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var year = date.getFullYear();
  return year;
}

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = getTime;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */

function getTime(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setSeconds;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */

function setSeconds(dirtyDate, dirtySeconds) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var seconds = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setMinutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */

function setMinutes(dirtyDate, dirtyMinutes) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var minutes = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setHours;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */

function setHours(dirtyDate, dirtyHours) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var hours = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyHours);
  date.setHours(hours);
  return date;
}

/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__ = __webpack_require__(650);



/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */

function setQuarter(dirtyDate, dirtyQuarter) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var quarter = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return Object(__WEBPACK_IMPORTED_MODULE_2__setMonth_index_js__["default"])(date, date.getMonth() + diff * 3);
}

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = setYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);


/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */

function setYear(dirtyDate, dirtyYear) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var year = Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(dirtyYear); // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date

  if (isNaN(date)) {
    return new Date(NaN);
  }

  date.setFullYear(year);
  return date;
}

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = min;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name min
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `min` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var minDate = min(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var minDate = min(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */

function min(dirtyDatesArray) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);

    if (result === undefined || result > currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = max;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - `max` function now accepts an array of dates rather than spread arguments.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   var date1 = new Date(1989, 6, 10)
 *   var date2 = new Date(1987, 1, 11)
 *   var maxDate = max(date1, date2)
 *
 *   // v2.0.0 onward:
 *   var dates = [new Date(1989, 6, 10), new Date(1987, 1, 11)]
 *   var maxDate = max(dates)
 *   ```
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */

function max(dirtyDatesArray) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var datesArray; // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method

  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray; // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (typeof dirtyDatesArray === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }

  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);

    if (result === undefined || result < currentDate || isNaN(currentDate)) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__ = __webpack_require__(406);


var MILLISECONDS_IN_DAY = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var startOfDayLeft = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["default"])(dirtyDateLeft);
  var startOfDayRight = Object(__WEBPACK_IMPORTED_MODULE_1__startOfDay_index_js__["default"])(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_0__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarMonths;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */

function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = differenceInCalendarWeeks;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__ = __webpack_require__(651);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(202);


var MILLISECONDS_IN_WEEK = 604800000;
/**
 * @name differenceInCalendarWeeks
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   { weekStartsOn: 1 }
 * )
 * //=> 2
 */

function differenceInCalendarWeeks(dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var startOfWeekLeft = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDateLeft, dirtyOptions);
  var startOfWeekRight = Object(__WEBPACK_IMPORTED_MODULE_0__startOfWeek_index_js__["default"])(dirtyDateRight, dirtyOptions);
  var timestampLeft = startOfWeekLeft.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekLeft);
  var timestampRight = startOfWeekRight.getTime() - Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(startOfWeekRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK);
}

/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */

function startOfMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = startOfYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */

function startOfYear(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var cleanDate = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */

function endOfDay(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__ = __webpack_require__(19);


/**
 * @name endOfWeek
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 23:59:59.999
 */

function endOfWeek(dirtyDate, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_1__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  date.setDate(date.getDate() + diff);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = endOfMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */

function endOfMonth(dirtyDate) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isEqual;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */

function isEqual(dirtyLeftDate, dirtyRightDate) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyLeftDate);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__ = __webpack_require__(406);

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 */

function isSameDay(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeftStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["default"])(dirtyDateLeft);
  var dateRightStartOfDay = Object(__WEBPACK_IMPORTED_MODULE_0__startOfDay_index_js__["default"])(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameMonth;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameYear;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */

function isSameYear(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeft = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateLeft);
  var dateRight = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isSameQuarter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__ = __webpack_require__(652);

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 */

function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var dateLeftStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["default"])(dirtyDateLeft);
  var dateRightStartOfQuarter = Object(__WEBPACK_IMPORTED_MODULE_0__startOfQuarter_index_js__["default"])(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isAfter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */

function isAfter(dirtyDate, dirtyDateToCompare) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */

function isBefore(dirtyDate, dirtyDateToCompare) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate);
  var dateToCompare = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = isWithinInterval;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toDate_index_js__ = __webpack_require__(7);

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval?
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `isWithinRange` to `isWithinInterval`.
 *   This change was made to mirror the use of the word "interval" in standard ISO 8601:2004 terminology:
 *
 *   ```
 *   2.1.3
 *   time interval
 *   part of the time axis limited by two instants
 *   ```
 *
 *   Also, this function now accepts an object with `start` and `end` properties
 *   instead of two arguments as an interval.
 *   This function now throws `RangeError` if the start of the interval is after its end
 *   or if any date in the interval is `Invalid Date`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   isWithinRange(
 *     new Date(2014, 0, 3),
 *     new Date(2014, 0, 1), new Date(2014, 0, 7)
 *   )
 *
 *   // v2.0.0 onward
 *
 *   isWithinInterval(
 *     new Date(2014, 0, 3),
 *     { start: new Date(2014, 0, 1), end: new Date(2014, 0, 7) }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 */

function isWithinInterval(dirtyDate, dirtyInterval) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var interval = dirtyInterval || {};
  var time = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(dirtyDate).getTime();
  var startTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(interval.start).getTime();
  var endTime = Object(__WEBPACK_IMPORTED_MODULE_0__toDate_index_js__["default"])(interval.end).getTime(); // Throw an exception if start date is after end date or if any date is `Invalid Date`

  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }

  return time >= startTime && time <= endTime;
}

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parse;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__ = __webpack_require__(637);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__ = __webpack_require__(638);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__ = __webpack_require__(644);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__ = __webpack_require__(1451);









var TIMEZONE_UNIT_PRIORITY = 10; // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Su            | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 0001, ..., 999               |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `backupDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `backupDate` which works as a context of parsing.
 *
 * `backupDate` must be passed for correct work of the function.
 * If you're not sure which `backupDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `backupDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `backupDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Old `parse` was renamed to `toDate`.
 *   Now `parse` is a new function which parses a string using a provided format.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   toDate('2016-01-01')
 *   parse('2016-01-01', 'yyyy-MM-dd', new Date())
 *   ```
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} backupDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */

function parse(dirtyDateString, dirtyFormatString, dirtyBackupDate, dirtyOptions) {
  if (arguments.length < 3) {
    throw new TypeError('3 arguments required, but only ' + arguments.length + ' present');
  }

  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var options = dirtyOptions || {};
  var locale = options.locale || __WEBPACK_IMPORTED_MODULE_0__locale_en_US_index_js__["a" /* default */];

  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }

  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_7__lib_toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (formatString === '') {
    if (dateString === '') {
      return Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["default"])(dirtyBackupDate);
    } else {
      return new Date(NaN);
    }
  }

  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale // If timezone isn't specified, it will be set to the system timezone

  };
  var setters = [{
    priority: TIMEZONE_UNIT_PRIORITY,
    set: dateToSystemTimezone,
    index: 0
  }];
  var i;
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = __WEBPACK_IMPORTED_MODULE_4__lib_format_longFormatters_index_js__["a" /* default */][firstCharacter];
      return longFormatter(substring, locale.formatLong, subFnOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];

  for (i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (!options.useAdditionalWeekYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["b" /* isProtectedWeekYearToken */])(token)) {
      Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token);
    }

    if (!options.useAdditionalDayOfYearTokens && Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["a" /* isProtectedDayOfYearToken */])(token)) {
      Object(__WEBPACK_IMPORTED_MODULE_6__lib_protectedTokens_index_js__["c" /* throwProtectedError */])(token);
    }

    var firstCharacter = token[0];
    var parser = __WEBPACK_IMPORTED_MODULE_8__lib_parsers_index_js__["a" /* default */][firstCharacter];

    if (parser) {
      var incompatibleTokens = parser.incompatibleTokens;

      if (Array.isArray(incompatibleTokens)) {
        var incompatibleToken = void 0;

        for (var _i = 0; _i < usedTokens.length; _i++) {
          var usedToken = usedTokens[_i].token;

          if (incompatibleTokens.indexOf(usedToken) !== -1 || usedToken === firstCharacter) {
            incompatibleToken = usedTokens[_i];
            break;
          }
        }

        if (incompatibleToken) {
          throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
        }
      } else if (parser.incompatibleTokens === '*' && usedTokens.length) {
        throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
      }

      usedTokens.push({
        token: firstCharacter,
        fullToken: token
      });
      var parseResult = parser.parse(dateString, token, locale.match, subFnOptions);

      if (!parseResult) {
        return new Date(NaN);
      }

      setters.push({
        priority: parser.priority,
        set: parser.set,
        validate: parser.validate,
        value: parseResult.value,
        index: setters.length
      });
      dateString = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
      } // Replace two single quote characters with one single quote character


      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      } // Cut token from string, or, if string doesn't match the token, return Invalid Date


      if (dateString.indexOf(token) === 0) {
        dateString = dateString.slice(token.length);
      } else {
        return new Date(NaN);
      }
    }
  } // Check if the remaining input contains something other than whitespace


  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }

  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).reverse();
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = Object(__WEBPACK_IMPORTED_MODULE_2__toDate_index_js__["default"])(dirtyBackupDate);

  if (isNaN(date)) {
    return new Date(NaN);
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/37


  var utcDate = Object(__WEBPACK_IMPORTED_MODULE_1__subMilliseconds_index_js__["a" /* default */])(date, Object(__WEBPACK_IMPORTED_MODULE_5__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(date));
  var flags = {};

  for (i = 0; i < uniquePrioritySetters.length; i++) {
    var setter = uniquePrioritySetters[i];

    if (setter.validate && !setter.validate(utcDate, setter.value, subFnOptions)) {
      return new Date(NaN);
    }

    var result = setter.set(utcDate, flags, setter.value, subFnOptions); // Result is tuple (date, flags)

    if (result[0]) {
      utcDate = result[0];
      Object(__WEBPACK_IMPORTED_MODULE_3__lib_assign_index_js__["a" /* default */])(flags, result[1]); // Result is date
    } else {
      utcDate = result;
    }
  }

  return utcDate;
}

function dateToSystemTimezone(date, flags) {
  if (flags.timestampIsSet) {
    return date;
  }

  var convertedDate = new Date(0);
  convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
  return convertedDate;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = assign;
function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__ = __webpack_require__(269);







var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var MILLISECONDS_IN_SECOND = 1000;
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999

};
var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function parseNumericPattern(pattern, string, valueCallback) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  }

  var value = parseInt(matchResult[0], 10);
  return {
    value: valueCallback ? valueCallback(value) : value,
    rest: string.slice(matchResult[0].length)
  };
}

function parseTimezonePattern(pattern, string) {
  var matchResult = string.match(pattern);

  if (!matchResult) {
    return null;
  } // Input is 'Z'


  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: string.slice(1)
    };
  }

  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * MILLISECONDS_IN_SECOND),
    rest: string.slice(matchResult[0].length)
  };
}

function parseAnyDigitsSigned(string, valueCallback) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, string, valueCallback);
}

function parseNDigits(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), string, valueCallback);
  }
}

function parseNDigitsSigned(n, string, valueCallback) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, string, valueCallback);

    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, string, valueCallback);

    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, string, valueCallback);

    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, string, valueCallback);

    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), string, valueCallback);
  }
}

function dayPeriodEnumToHours(enumValue) {
  switch (enumValue) {
    case 'morning':
      return 4;

    case 'evening':
      return 17;

    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;

    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}

function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0; // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC

  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;

  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }

  return isCommonEra ? result : 1 - result;
}

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]; // User for validation

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */


var parsers = {
  // Era
  G: {
    priority: 140,
    parse: function (string, token, match, _options) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
        // A, B

        case 'GGGGG':
          return match.era(string, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ

        case 'GGGG':
        default:
          return match.era(string, {
            width: 'wide'
          }) || match.era(string, {
            width: 'abbreviated'
          }) || match.era(string, {
            width: 'narrow'
          });
      }
    },
    set: function (date, flags, value, _options) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['R', 'u', 't', 'T']
  },
  // Year
  y: {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };

      switch (token) {
        case 'y':
          return parseNDigits(4, string, valueCallback);

        case 'yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, _options) {
      var currentYear = date.getUTCFullYear();

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Local week-numbering year
  Y: {
    priority: 130,
    parse: function (string, token, match, _options) {
      var valueCallback = function (year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };

      switch (token) {
        case 'Y':
          return parseNDigits(4, string, valueCallback);

        case 'Yo':
          return match.ordinalNumber(string, {
            unit: 'year',
            valueCallback: valueCallback
          });

        default:
          return parseNDigits(token.length, string, valueCallback);
      }
    },
    validate: function (_date, value, _options) {
      return value.isTwoDigitYear || value.year > 0;
    },
    set: function (date, flags, value, options) {
      var currentYear = Object(__WEBPACK_IMPORTED_MODULE_0__lib_getUTCWeekYear_index_js__["a" /* default */])(date, options);

      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
      }

      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(date, options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week-numbering year
  R: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'R') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (_date, _flags, value, _options) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a" /* default */])(firstWeekOfYear);
    },
    incompatibleTokens: ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Extended year
  u: {
    priority: 130,
    parse: function (string, token, _match, _options) {
      if (token === 'u') {
        return parseNDigitsSigned(4, string);
      }

      return parseNDigitsSigned(token.length, string);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']
  },
  // Quarter
  Q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'Qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'QQQ':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'QQQQQ':
          return match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...

        case 'QQQQ':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone quarter
  q: {
    priority: 120,
    parse: function (string, token, match, _options) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, string);
        // 1st, 2nd, 3rd, 4th

        case 'qo':
          return match.ordinalNumber(string, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4

        case 'qqq':
          return match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)

        case 'qqqqq':
          return match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...

        case 'qqqq':
        default:
          return match.quarter(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 4;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Month
  M: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'MM':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Mo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'MMM':
          return match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D

        case 'MMMMM':
          return match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December

        case 'MMMM':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Stand-alone month
  L: {
    priority: 110,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        return value - 1;
      };

      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return parseNumericPattern(numericPatterns.month, string, valueCallback);
        // 01, 02, ..., 12

        case 'LL':
          return parseNDigits(2, string, valueCallback);
        // 1st, 2nd, ..., 12th

        case 'Lo':
          return match.ordinalNumber(string, {
            unit: 'month',
            valueCallback: valueCallback
          });
        // Jan, Feb, ..., Dec

        case 'LLL':
          return match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D

        case 'LLLLL':
          return match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December

        case 'LLLL':
        default:
          return match.month(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Local week of year
  w: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, string);

        case 'wo':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_6__lib_startOfUTCWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__lib_setUTCWeek_index_js__["a" /* default */])(date, value, options), options);
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']
  },
  // ISO week of year
  I: {
    priority: 100,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, string);

        case 'Io':
          return match.ordinalNumber(string, {
            unit: 'week'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 53;
    },
    set: function (date, _flags, value, options) {
      return Object(__WEBPACK_IMPORTED_MODULE_5__lib_startOfUTCISOWeek_index_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__lib_setUTCISOWeek_index_js__["a" /* default */])(date, value, options), options);
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']
  },
  // Day of the month
  d: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, string);

        case 'do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();

      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']
  },
  // Day of year
  D: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, string);

        case 'Do':
          return match.ordinalNumber(string, {
            unit: 'date'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (date, value, _options) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);

      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']
  },
  // Day of week
  E: {
    priority: 90,
    parse: function (string, token, match, _options) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'EEEEE':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'EEEEEE':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'EEEE':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['D', 'i', 'e', 'c', 't', 'T']
  },
  // Local day of week
  e: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'eo':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'eee':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // T

        case 'eeeee':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu

        case 'eeeeee':
          return match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday

        case 'eeee':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(string, {
            width: 'short',
            context: 'formatting'
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']
  },
  // Stand-alone local day of week
  c: {
    priority: 90,
    parse: function (string, token, match, options) {
      var valueCallback = function (value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };

      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return parseNDigits(token.length, string, valueCallback);
        // 3rd

        case 'co':
          return match.ordinalNumber(string, {
            unit: 'day',
            valueCallback: valueCallback
          });
        // Tue

        case 'ccc':
          return match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // T

        case 'ccccc':
          return match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu

        case 'cccccc':
          return match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday

        case 'cccc':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(string, {
            width: 'short',
            context: 'standalone'
          }) || match.day(string, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 6;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_1__lib_setUTCDay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']
  },
  // ISO day of week
  i: {
    priority: 90,
    parse: function (string, token, match, _options) {
      var valueCallback = function (value) {
        if (value === 0) {
          return 7;
        }

        return value;
      };

      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, string);
        // 2nd

        case 'io':
          return match.ordinalNumber(string, {
            unit: 'day'
          });
        // Tue

        case 'iii':
          return match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // T

        case 'iiiii':
          return match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tu

        case 'iiiiii':
          return match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
        // Tuesday

        case 'iiii':
        default:
          return match.day(string, {
            width: 'wide',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'abbreviated',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'short',
            context: 'formatting',
            valueCallback: valueCallback
          }) || match.day(string, {
            width: 'narrow',
            context: 'formatting',
            valueCallback: valueCallback
          });
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 7;
    },
    set: function (date, _flags, value, options) {
      date = Object(__WEBPACK_IMPORTED_MODULE_2__lib_setUTCISODay_index_js__["a" /* default */])(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']
  },
  // AM or PM
  a: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaaa':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'aaaa':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['b', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // AM, PM, midnight
  b: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbbb':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'bbbb':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'B', 'H', 'K', 'k', 't', 'T']
  },
  // in the morning, in the afternoon, in the evening, at night
  B: {
    priority: 80,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBBB':
          return match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });

        case 'BBBB':
        default:
          return match.dayPeriod(string, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(string, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 't', 'T']
  },
  // Hour [1-12]
  h: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, string);

        case 'ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 12;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['H', 'K', 'k', 't', 'T']
  },
  // Hour [0-23]
  H: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, string);

        case 'Ho':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 23;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'K', 'k', 't', 'T']
  },
  // Hour [0-11]
  K: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, string);

        case 'Ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 11;
    },
    set: function (date, _flags, value, _options) {
      var isPM = date.getUTCHours() >= 12;

      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }

      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'k', 't', 'T']
  },
  // Hour [1-24]
  k: {
    priority: 70,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, string);

        case 'ko':
          return match.ordinalNumber(string, {
            unit: 'hour'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 1 && value <= 24;
    },
    set: function (date, _flags, value, _options) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    },
    incompatibleTokens: ['a', 'b', 'h', 'H', 'K', 't', 'T']
  },
  // Minute
  m: {
    priority: 60,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, string);

        case 'mo':
          return match.ordinalNumber(string, {
            unit: 'minute'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Second
  s: {
    priority: 50,
    parse: function (string, token, match, _options) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, string);

        case 'so':
          return match.ordinalNumber(string, {
            unit: 'second'
          });

        default:
          return parseNDigits(token.length, string);
      }
    },
    validate: function (_date, value, _options) {
      return value >= 0 && value <= 59;
    },
    set: function (date, _flags, value, _options) {
      date.setUTCSeconds(value, 0);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Fraction of second
  S: {
    priority: 30,
    parse: function (string, token, _match, _options) {
      var valueCallback = function (value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };

      return parseNDigits(token.length, string, valueCallback);
    },
    set: function (date, _flags, value, _options) {
      date.setUTCMilliseconds(value);
      return date;
    },
    incompatibleTokens: ['t', 'T']
  },
  // Timezone (ISO-8601. +00:00 is `'Z'`)
  X: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'x']
  },
  // Timezone (ISO-8601)
  x: {
    priority: 10,
    parse: function (string, token, _match, _options) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, string);

        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, string);

        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, string);

        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, string);

        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, string);
      }
    },
    set: function (date, flags, value, _options) {
      if (flags.timestampIsSet) {
        return date;
      }

      return new Date(date.getTime() - value);
    },
    incompatibleTokens: ['t', 'T', 'X']
  },
  // Seconds timestamp
  t: {
    priority: 40,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  },
  // Milliseconds timestamp
  T: {
    priority: 20,
    parse: function (string, _token, _match, _options) {
      return parseAnyDigitsSigned(string);
    },
    set: function (_date, _flags, value, _options) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    },
    incompatibleTokens: '*'
  }
};
/* harmony default export */ __webpack_exports__["a"] = (parsers);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCDay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCDay(dirtyDate, dirtyDay, dirtyOptions) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var day = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISODay;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);

 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISODay(dirtyDate, dirtyDay) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var day = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyDay);

  if (day % 7 === 0) {
    day = day - 7;
  }

  var weekStartsOn = 1;
  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCISOWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__ = __webpack_require__(640);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var isoWeek = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyISOWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCISOWeek_index_js__["a" /* default */])(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setUTCWeek;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toDate_index_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__ = __webpack_require__(642);


 // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  if (arguments.length < 2) {
    throw new TypeError('2 arguments required, but only ' + arguments.length + ' present');
  }

  var date = Object(__WEBPACK_IMPORTED_MODULE_1__toDate_index_js__["default"])(dirtyDate);
  var week = Object(__WEBPACK_IMPORTED_MODULE_0__toInteger_index_js__["a" /* default */])(dirtyWeek);
  var diff = Object(__WEBPACK_IMPORTED_MODULE_2__getUTCWeek_index_js__["a" /* default */])(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = parseISO;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__ = __webpack_require__(202);


var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Object(__WEBPACK_IMPORTED_MODULE_0__lib_toInteger_index_js__["a" /* default */])(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var fullTime = timestamp + time;
    var fullTimeDate = new Date(fullTime);
    offset = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(fullTimeDate); // Adjust time when it's coming from DST

    var fullTimeDateNextDay = new Date(fullTime);
    fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1);
    var offsetDiff = Object(__WEBPACK_IMPORTED_MODULE_1__lib_getTimezoneOffsetInMilliseconds_index_js__["a" /* default */])(fullTimeDateNextDay) - offset;

    if (offsetDiff > 0) {
      offset += offsetDiff;
    }
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IGNORE_CLASS_NAME", function() { return IGNORE_CLASS_NAME; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);



function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.


  while (current.parentNode) {
    if (isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}

// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = null;
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions = {
      passive: !instance.props.preventDefault
    };
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return Object(__WEBPACK_IMPORTED_MODULE_1_react_dom__["findDOMNode"])(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_this, eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_this, eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (!WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    };
    /**
     * Remove all document's event listeners for this component
     */


    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    };
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */


    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _props = this.props,
          excludeScrollbar = _props.excludeScrollbar,
          props = _objectWithoutProperties(_props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(WrappedComponent, props);
    };

    return onClickOutside;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}


/* harmony default export */ __webpack_exports__["default"] = (onClickOutsideHOC);


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(1463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popper", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "placements", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Manager", function() { return __WEBPACK_IMPORTED_MODULE_1__Manager__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reference", function() { return __WEBPACK_IMPORTED_MODULE_2__Reference__["a"]; });
// Public components



 // Public types

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InnerPopper */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return placements; });
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_popper_js__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Manager__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(655);









var initialStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  opacity: 0,
  pointerEvents: 'none'
};
var initialArrowStyle = {};
var InnerPopper =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_inheritsLoose___default()(InnerPopper, _React$Component);

  function InnerPopper() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "state", {
      data: undefined,
      placement: undefined
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperInstance", void 0);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "popperNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "arrowNode", null);

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setPopperNode", function (popperNode) {
      if (!popperNode || _this.popperNode === popperNode) return;
      Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* safeInvoke */])(_this.props.innerRef, popperNode);
      _this.popperNode = popperNode;

      _this.updatePopperInstance();
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "setArrowNode", function (arrowNode) {
      _this.arrowNode = arrowNode;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updateStateModifier", {
      enabled: true,
      order: 900,
      fn: function fn(data) {
        var placement = data.placement;

        _this.setState({
          data: data,
          placement: placement
        });

        return data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOptions", function () {
      return {
        placement: _this.props.placement,
        eventsEnabled: _this.props.eventsEnabled,
        positionFixed: _this.props.positionFixed,
        modifiers: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers, {
          arrow: __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({}, _this.props.modifiers && _this.props.modifiers.arrow, {
            enabled: !!_this.arrowNode,
            element: _this.arrowNode
          }),
          applyStyle: {
            enabled: false
          },
          updateStateModifier: _this.updateStateModifier
        })
      };
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperStyle", function () {
      return !_this.popperNode || !_this.state.data ? initialStyle : __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
        position: _this.state.data.offsets.popper.position
      }, _this.state.data.styles);
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getPopperPlacement", function () {
      return !_this.state.data ? undefined : _this.state.placement;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getArrowStyle", function () {
      return !_this.arrowNode || !_this.state.data ? initialArrowStyle : _this.state.data.arrowStyles;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "getOutOfBoundariesState", function () {
      return _this.state.data ? _this.state.data.hide : undefined;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "destroyPopperInstance", function () {
      if (!_this.popperInstance) return;

      _this.popperInstance.destroy();

      _this.popperInstance = null;
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "updatePopperInstance", function () {
      _this.destroyPopperInstance();

      var _assertThisInitialize = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this),
          popperNode = _assertThisInitialize.popperNode;

      var referenceElement = _this.props.referenceElement;
      if (!referenceElement || !popperNode) return;
      _this.popperInstance = new __WEBPACK_IMPORTED_MODULE_6_popper_js__["a" /* default */](referenceElement, popperNode, _this.getOptions());
    });

    __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_assertThisInitialized___default()(_this), "scheduleUpdate", function () {
      if (_this.popperInstance) {
        _this.popperInstance.scheduleUpdate();
      }
    });

    return _this;
  }

  var _proto = InnerPopper.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // If the Popper.js options have changed, update the instance (destroy + create)
    if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed) {
      this.updatePopperInstance();
    } else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) {
      this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
    } // A placement difference in state means popper determined a new placement
    // apart from the props value. By the time the popper element is rendered with
    // the new position Popper has already measured it, if the place change triggers
    // a size change it will result in a misaligned popper. So we schedule an update to be sure.


    if (prevState.placement !== this.state.placement) {
      this.scheduleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_8__utils__["a" /* safeInvoke */])(this.props.innerRef, null);
    this.destroyPopperInstance();
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.setPopperNode,
      style: this.getPopperStyle(),
      placement: this.getPopperPlacement(),
      outOfBoundaries: this.getOutOfBoundariesState(),
      scheduleUpdate: this.scheduleUpdate,
      arrowProps: {
        ref: this.setArrowNode,
        style: this.getArrowStyle()
      }
    });
  };

  return InnerPopper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_defineProperty___default()(InnerPopper, "defaultProps", {
  placement: 'bottom',
  eventsEnabled: true,
  referenceElement: undefined,
  positionFixed: false
});

var placements = __WEBPACK_IMPORTED_MODULE_6_popper_js__["a" /* default */].placements;

function Popper(_ref) {
  var referenceElement = _ref.referenceElement,
      props = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutPropertiesLoose___default()(_ref, ["referenceElement"]);

  return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Manager__["a" /* ManagerContext */].Consumer, null, function (_ref2) {
    var referenceNode = _ref2.referenceNode;
    return __WEBPACK_IMPORTED_MODULE_5_react__["createElement"](InnerPopper, __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_extends___default()({
      referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
    }, props));
  });
}

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 1461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(1462);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(530);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(654);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Reference;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Manager__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(655);









var InnerReference =
/*#__PURE__*/
function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_inheritsLoose___default()(InnerReference, _React$Component);

  function InnerReference() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_defineProperty___default()(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_assertThisInitialized___default()(_this), "refHandler", function (node) {
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.innerRef, node);
      Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(_this.props.setReferenceNode, node);
    });

    return _this;
  }

  var _proto = InnerReference.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    Object(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* safeInvoke */])(this.props.innerRef, null);
  };

  _proto.render = function render() {
    __WEBPACK_IMPORTED_MODULE_5_warning___default()(Boolean(this.props.setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* unwrapArray */])(this.props.children)({
      ref: this.refHandler
    });
  };

  return InnerReference;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

function Reference(props) {
  return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Manager__["a" /* ManagerContext */].Consumer, null, function (_ref) {
    var setReferenceNode = _ref.setReferenceNode;
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](InnerReference, __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_extends___default()({
      setReferenceNode: setReferenceNode
    }, props));
  });
}

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function TransitionWrapper(_ref){var timeout=_ref.timeout,children=_ref.children,defaultStyles=_ref.defaultStyles,transitionStyles=_ref.transitionStyles,props=_objectWithoutProperties(_ref,["timeout","children","defaultStyles","transitionStyles"]);if(typeof children==="function"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["Transition"],Object.assign({timeout:timeout,mountOnEnter:true,unmountOnExit:true},props),function(state){return children({style:Object.assign({},defaultStyles,transitionStyles[state])});});}return null;}/* harmony default export */ __webpack_exports__["a"] = (TransitionWrapper);

/***/ }),
/* 1465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(6);

var PropTypes = _interopRequireWildcard(_propTypes);

var _addClass = __webpack_require__(585);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(586);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Transition = __webpack_require__(657);

var _Transition2 = _interopRequireDefault(_Transition);

var _PropTypes = __webpack_require__(658);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _addClass2.default)(node, c);
  });
};
var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return (0, _removeClass2.default)(node, c);
  });
};

var propTypes = _extends({}, _Transition2.default.propTypes, {

  /**
   * The animation classNames applied to the component as it enters, exits or has finished the transition.
   * A single name can be provided and it will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, `fade-exit-done`, `fade-appear`, and `fade-appear-active`.
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply spread
   * them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: _PropTypes.classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
});

/**
 * A `Transition` component using CSS transitions and animations.
 * It's inspired by the excellent [ng-animate](http://www.nganimate.org/) library.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` stages of the transition. The first class is applied and then a
 * second "active" class in order to activate the css animation. After the animation,
 * matching `done` class names are applied to persist the animation state.
 *
 * When the `in` prop is toggled to `true` the Component will get
 * the `example-enter` CSS class and the `example-enter-active` CSS class
 * added in the next tick. This is a convention based on the `classNames` prop.
 *
 * ## Example
 *
 * <iframe src="https://codesandbox.io/embed/m77l2vp00x?fontsize=14" style="width:100%; height:500px; border:0; border-radius: 4px; overflow:hidden;" sandbox="allow-modals allow-forms allow-popups allow-scripts allow-same-origin"></iframe>
 */

var CSSTransition = function (_React$Component) {
  _inherits(CSSTransition, _React$Component);

  function CSSTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.onEnter = function (node, appearing) {
      var _this$getClassNames = _this.getClassNames(appearing ? 'appear' : 'enter'),
          className = _this$getClassNames.className;

      _this.removeClasses(node, 'exit');
      addClass(node, className);

      if (_this.props.onEnter) {
        _this.props.onEnter(node);
      }
    }, _this.onEntering = function (node, appearing) {
      var _this$getClassNames2 = _this.getClassNames(appearing ? 'appear' : 'enter'),
          activeClassName = _this$getClassNames2.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onEntering) {
        _this.props.onEntering(node);
      }
    }, _this.onEntered = function (node, appearing) {
      var _this$getClassNames3 = _this.getClassNames('enter'),
          doneClassName = _this$getClassNames3.doneClassName;

      _this.removeClasses(node, appearing ? 'appear' : 'enter');
      addClass(node, doneClassName);

      if (_this.props.onEntered) {
        _this.props.onEntered(node);
      }
    }, _this.onExit = function (node) {
      var _this$getClassNames4 = _this.getClassNames('exit'),
          className = _this$getClassNames4.className;

      _this.removeClasses(node, 'appear');
      _this.removeClasses(node, 'enter');
      addClass(node, className);

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    }, _this.onExiting = function (node) {
      var _this$getClassNames5 = _this.getClassNames('exit'),
          activeClassName = _this$getClassNames5.activeClassName;

      _this.reflowAndAddClass(node, activeClassName);

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    }, _this.onExited = function (node) {
      var _this$getClassNames6 = _this.getClassNames('exit'),
          doneClassName = _this$getClassNames6.doneClassName;

      _this.removeClasses(node, 'exit');
      addClass(node, doneClassName);

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    }, _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;


      var className = typeof classNames !== 'string' ? classNames[type] : classNames + '-' + type;

      var activeClassName = typeof classNames !== 'string' ? classNames[type + 'Active'] : className + '-active';

      var doneClassName = typeof classNames !== 'string' ? classNames[type + 'Done'] : className + '-done';

      return {
        className: className,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransition.prototype.removeClasses = function removeClasses(node, type) {
    var _getClassNames = this.getClassNames(type),
        className = _getClassNames.className,
        activeClassName = _getClassNames.activeClassName,
        doneClassName = _getClassNames.doneClassName;

    className && removeClass(node, className);
    activeClassName && removeClass(node, activeClassName);
    doneClassName && removeClass(node, doneClassName);
  };

  CSSTransition.prototype.reflowAndAddClass = function reflowAndAddClass(node, className) {
    // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.
    if (className) {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
      /* eslint-enable no-unused-expressions */
      addClass(node, className);
    }
  };

  CSSTransition.prototype.render = function render() {
    var props = _extends({}, this.props);

    delete props.classNames;

    return _react2.default.createElement(_Transition2.default, _extends({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(_react2.default.Component);

CSSTransition.propTypes =  false ? propTypes : {};

exports.default = CSSTransition;
module.exports = exports['default'];

/***/ }),
/* 1466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _TransitionGroup = __webpack_require__(659);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  in: _propTypes2.default.bool.isRequired,
  children: function children(props, propName) {
    if (_react2.default.Children.count(props[propName]) !== 2) return new Error('"' + propName + '" must be exactly two transition components.');

    return null;
  }
};

/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition = function (_React$Component) {
  _inherits(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _temp, _this, _ret;

    _classCallCheck(this, ReplaceTransition);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ReplaceTransition.prototype.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;

    var child = _react2.default.Children.toArray(children)[idx];

    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler]((0, _reactDom.findDOMNode)(this));
  };

  ReplaceTransition.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        inProp = _props.in,
        props = _objectWithoutProperties(_props, ['children', 'in']);

    var _React$Children$toArr = _react2.default.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;

    return _react2.default.createElement(
      _TransitionGroup2.default,
      props,
      inProp ? _react2.default.cloneElement(first, {
        key: 'first',
        onEnter: this.handleEnter,
        onEntering: this.handleEntering,
        onEntered: this.handleEntered

      }) : _react2.default.cloneElement(second, {
        key: 'second',
        onEnter: this.handleExit,
        onEntering: this.handleExiting,
        onEntered: this.handleExited
      })
    );
  };

  return ReplaceTransition;
}(_react2.default.Component);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleEnter = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _this2.handleLifecycle('onEnter', 0, args);
  };

  this.handleEntering = function () {
    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    return _this2.handleLifecycle('onEntering', 0, args);
  };

  this.handleEntered = function () {
    for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    return _this2.handleLifecycle('onEntered', 0, args);
  };

  this.handleExit = function () {
    for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    return _this2.handleLifecycle('onExit', 1, args);
  };

  this.handleExiting = function () {
    for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    return _this2.handleLifecycle('onExiting', 1, args);
  };

  this.handleExited = function () {
    for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    return _this2.handleLifecycle('onExited', 1, args);
  };
};

ReplaceTransition.propTypes =  false ? propTypes : {};

exports.default = ReplaceTransition;
module.exports = exports['default'];

/***/ }),
/* 1467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;
exports.getInitialChildMapping = getInitialChildMapping;
exports.getNextChildMapping = getNextChildMapping;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _react.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = Object.create(null);

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return (0, _react.cloneElement)(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}

function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);

  Object.keys(children).forEach(function (key) {
    var child = children[key];

    if (!(0, _react.isValidElement)(child)) return;

    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;

    var prevChild = prevChildMapping[key];
    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in;

    // item is new (entering)
    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = (0, _react.cloneElement)(child, { in: false });
    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = (0, _react.cloneElement)(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });

  return children;
}

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
var duration=200;var defaultStyles={transition:"all "+duration+"ms ease-in-out",transform:"translate(0,100%,0)"};var transitionStyles={entered:{transform:"translate(0,0,0)"}};function SlideUpDown(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["Transition"],Object.assign({},props,{timeout:duration,defaultStyles:defaultStyles,transitionStyles:transitionStyles}));}/* harmony default export */ __webpack_exports__["a"] = (SlideUpDown);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Forex(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"22px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 22 15",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19.882,14.988 L2.117,14.988 C0.951,14.988 0.006,14.088 0.006,12.977 L0.006,2.005 C0.006,0.895 0.951,-0.006 2.117,-0.006 L19.882,-0.006 C21.048,-0.006 21.993,0.895 21.993,2.005 L21.993,12.977 C21.993,14.088 21.048,14.988 19.882,14.988 ZM9.643,2.993 L3.151,2.993 L3.151,11.961 L5.039,11.961 L5.039,8.235 L8.984,8.235 L8.984,6.849 L5.039,6.849 L5.039,4.379 L9.643,4.379 L9.643,2.993 ZM18.075,2.993 L15.877,2.993 L14.111,6.172 L12.372,2.993 L10.186,2.993 L12.980,7.440 L10.115,11.961 L12.320,11.961 L14.137,8.728 L15.954,11.961 L18.237,11.961 L15.282,7.440 L18.075,2.993 Z"}));}

/***/ }),
/* 1470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,'__esModule',{value:!0});var VALIDATOR_ARG_ERROR_MESSAGE='The typeValidator argument must be a function with the signature function(props, propName, componentName).',MESSAGE_ARG_ERROR_MESSAGE='The error message is optional, but must be a string if provided.',propIsRequired=function propIsRequired(a,b,c,d){if('boolean'==typeof a)return a;return'function'==typeof a?a(b,c,d):!(!0!==!!a)&&!!a},propExists=function propExists(a,b){return Object.hasOwnProperty.call(a,b)},missingPropError=function missingPropError(a,b,c,d){return d?new Error(d):new Error('Required '+a[b]+' `'+b+'`'+(' was not specified in `'+c+'`.'))},guardAgainstInvalidArgTypes=function guardAgainstInvalidArgTypes(a,b){if('function'!=typeof a)throw new TypeError(VALIDATOR_ARG_ERROR_MESSAGE);if(!!b&&'string'!=typeof b)throw new TypeError(MESSAGE_ARG_ERROR_MESSAGE)},isRequiredIf=function isRequiredIf(a,b,c){return guardAgainstInvalidArgTypes(a,c),function(d,e,f){for(var _len=arguments.length,g=Array(3<_len?_len-3:0),_key=3;_key<_len;_key++)g[_key-3]=arguments[_key];return propIsRequired(b,d,e,f)?propExists(d,e)?a.apply(void 0,[d,e,f].concat(g)):missingPropError(d,e,f,c):a.apply(void 0,[d,e,f].concat(g));// Is not required, so just run typeValidator.
}};exports.default=isRequiredIf;

//# sourceMappingURL=isRequiredIf.js.map

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.14.6
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
var timeoutDuration = 0;
for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
  if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
    timeoutDuration = 1;
    break;
  }
}

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.right - result.left;
  var height = sizes.height || element.clientHeight || result.bottom - result.top;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  return isFixed(getParentNode(element));
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, reference);
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicity asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;


  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthOddness = reference.width % 2 === popper.width % 2;
  var bothOddWidth = reference.width % 2 === 1 && popper.width % 2 === 1;
  var noRound = function noRound(v) {
    return v;
  };

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthOddness ? Math.round : Math.floor;
  var verticalToInteger = !shouldRound ? noRound : Math.round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
    var flippedVariation = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport'
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {HTMLElement|referenceObject} reference - The reference element used to position the popper
   * @param {HTMLElement} popper - The HTML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var getObjectType = function getObjectType(value) {
  return Object.prototype.toString.call(value).slice(8, -1);
};
var isObject = function isObject(value) {
  return _typeof(value) === 'object';
};
var index = {
  null: function _null(value) {
    return value === null;
  },
  undefined: function undefined(value) {
    return typeof value === 'undefined';
  },
  nullOrUndefined: function nullOrUndefined(value) {
    return this.null(value) || this.undefined(value);
  },
  string: function string(value) {
    return typeof value === 'string';
  },
  number: function number(value) {
    return typeof value === 'number';
  },
  function: function _function(value) {
    return typeof value === 'function';
  },
  boolean: function boolean(value) {
    return value === true || value === false;
  },
  array: Array.isArray,
  object: function object(value) {
    return !this.nullOrUndefined(value) && (this.function(value) || isObject(value));
  },
  plainObject: function plainObject(value) {
    var prototype;
    return getObjectType(value) === 'Object' && (prototype = Object.getPrototypeOf(value), prototype === null || prototype === Object.getPrototypeOf({}));
  },
  date: function date(value) {
    return getObjectType(value) === 'Date';
  },
  promise: function promise(value) {
    return getObjectType(value) === 'Promise';
  },
  iterable: function iterable(value) {
    return !this.nullOrUndefined(value) && this.function(value[Symbol.iterator]);
  },
  generator: function generator(value) {
    return this.iterable(value) && this.function(value.next) && this.function(value.throw);
  },
  regexp: function regexp(value) {
    return getObjectType(value) === 'RegExp';
  },
  symbol: function symbol(value) {
    return getObjectType(value) === 'Symbol';
  },
  domElement: function domElement(value) {
    var DOM_PROPERTIES_TO_CHECK = ['innerHTML', 'ownerDocument', 'style', 'attributes', 'nodeValue'];
    return this.object(value) && !this.plainObject(value) && value.nodeType === 1 && this.string(value.nodeName) && DOM_PROPERTIES_TO_CHECK.every(function (property) {
      return property in value;
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useGenerativeData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_fetch__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function mapStockHistoryToPoints(history){if(history==null){return[];}var dates=Object.keys(history);var points=[];var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{for(var _iterator=dates[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var date=_step.value;// HACK: Чиним формат дат чтобы они корректно парсились в сафари
var correctDate=new Date(date.replace(" ","T")+"+00:00").valueOf();points.push({date:correctDate,value:Number(history[date])});}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}return points;}function fetchRecentHistory(stock){return Object(__WEBPACK_IMPORTED_MODULE_1__common_fetch__["c" /* apiCall */])("/ajax/stockHistory?stock="+stock+"&limit="+7200+"&tz=UTC").then(function(r){return r.json();}).then(mapStockHistoryToPoints);}function flip(points){var base=points[0];return points.map(function(point){return{date:point.date,value:base.value+(base.value-point.value)};});}function useGenerativeData(ref,_ref){var stock=_ref.stock,isRunning=_ref.isRunning,deals=_ref.deals,next=_ref.next,attempt=_ref.attempt;// Курсор — это индекс в истории, на котором мы сейчас находимся
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(0),_useState2=_slicedToArray(_useState,2),cursor=_useState2[0],setCursor=_useState2[1];// Курсор будет плюсоваться в секундном интервале, но только когда isRunning
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isRunning){var interval=setInterval(function(){setCursor(function(c){return c+1;});},1000);return function(){clearInterval(interval);};}},[isRunning]);// isReady нужен чтобы не оперировать над историей пока её нет.
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),isReady=_useState4[0],setIsReady=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),fullHistory=_useState6[0],setFullHistory=_useState6[1];// Безопасный запас истории — максимум по 30 сек на каждую сделку, а их две.
var safeHistoryStash=30+2;// Эффект запроса истории
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){fetchRecentHistory(stock).then(function(history){setFullHistory(history);setCursor(history.length-1-safeHistoryStash);setIsReady(true);});},[stock,attempt]);// Вызываем следующий шаг когда время сделки подходит к концу. Надеемся на то,
// что это приведёт к isRunning === false, иначе всё развалится!
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){switch(deals.length){case 0:break;case 1:{if(cursor===fullHistory.length-1-safeHistoryStash+deals[0].bTime+3){next();}break;}case 2:{if(cursor===fullHistory.length-1-safeHistoryStash+deals[1].bTime+3){next();}break;}default:break;}},[deals,cursor]);// Самое интересное: при сдвиге курсора надо собрать точки, да так чтобы
// клиент 100%  победил.
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(!isReady){return void 0;}var past=fullHistory.slice(0,fullHistory.length-1-safeHistoryStash);var game=[];switch(deals.length){case 0:{ref.current=past;break;}case 1:{var direction0=deals[0].bidType?"UP":"DOWN";var deal0start=fullHistory[fullHistory.length-1-safeHistoryStash];var deal0end=fullHistory[fullHistory.length-1-safeHistoryStash+deals[0].bTime];game=fullHistory.slice(fullHistory.length-1-safeHistoryStash,cursor);if(deal0start.value>deal0end.value){if(direction0==="UP"){game=flip(game);}}else{if(direction0==="DOWN"){game=flip(game);}}ref.current=[].concat(_toConsumableArray(past),_toConsumableArray(game));break;}case 2:{var _direction=deals[1].bidType?"UP":"DOWN";var _deal0start=fullHistory[fullHistory.length-1-safeHistoryStash];var _deal0end=fullHistory[fullHistory.length-1-safeHistoryStash+deals[1].bTime];game=fullHistory.slice(fullHistory.length-1-safeHistoryStash,cursor);if(_deal0start.value>_deal0end.value){if(_direction==="UP"){game=flip(game);}}else{if(_direction==="DOWN"){game=flip(game);}}ref.current=[].concat(_toConsumableArray(past),_toConsumableArray(game));break;}default:{ref.current=past;break;}}},[cursor,isReady,fullHistory]);}

/***/ }),
/* 1475 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/shieldImage.467405c6.svg";

/***/ }),
/* 1476 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/protected.e799caa7.svg";

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function applyUpdate(value,update){if(value==null){return value;}else{return Object.assign({},value,update.updater(value));}}var Optimistic=function(_React$Component){_inherits(Optimistic,_React$Component);function Optimistic(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Optimistic);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Optimistic.__proto__||Object.getPrototypeOf(Optimistic)).call.apply(_ref,[this].concat(args))),_this),_this.state={value:_this.props.value,pendingUpdates:[]},_this.update=function(updater,promise){var update=_this.stage(updater);promise.then(function(){_this.commit(update);},function(){_this.drop(update);});},_this.invalidate=function(options){var update=_this.stage(function(){return null;});return _this.props.onInvalidate(options).then(function(value){_this.rebase(update,value);},function(error){_this.drop(update);throw error;});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Optimistic,[{key:"stage",value:function stage(updater){var update={updater:updater};this.setState(function(state){return{pendingUpdates:[].concat(_toConsumableArray(state.pendingUpdates),[update])};});return update;}},{key:"checkout",value:function checkout(){return this.state.pendingUpdates.reduce(applyUpdate,this.state.value);}},{key:"commit",value:function commit(update){this.setState(function(state){return{value:applyUpdate(state.value,update),pendingUpdates:state.pendingUpdates.filter(function(u){return u!==update;})};});}},{key:"drop",value:function drop(update){this.setState(function(state){return{pendingUpdates:state.pendingUpdates.filter(function(u){return u!==update;})};});}},{key:"rebase",value:function rebase(update,value){this.setState(function(state){var index=state.pendingUpdates.indexOf(update);return{value:value,pendingUpdates:state.pendingUpdates.filter(function(u,i){return i>index;})};});}},{key:"UNSAFE_componentWillReceiveProps",value:function UNSAFE_componentWillReceiveProps(nextProps){var shouldFlushState=false;if(nextProps.value==null||this.props.value==null){shouldFlushState=nextProps.value!==this.props.value;}else{shouldFlushState=nextProps.value.id!==this.props.value.id;}if(shouldFlushState){this.setState({value:nextProps.value,pendingUpdates:[]});}}},{key:"render",value:function render(){return this.props.children({value:this.checkout(),update:this.update,invalidate:this.invalidate});}}]);return Optimistic;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Optimistic);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Cup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Cup(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"16px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 28 35",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M716.27 464h3.8v9.3h-1c-.6 0-1.13-.23-1.58-.7l-1.29-1.31c-.46-.4-.68-1.01-.68-1.63v-4.88c0-.47.3-.78.75-.78zm18.95 9.3V464H739c.45 0 .75.31.75.78v4.88c0 .62-.22 1.16-.68 1.63l-1.29 1.31c-.37.47-.98.7-1.59.7zm2.27 18.6c.38 0 .76-.4.76-.8v-1.59c0-.4-.38-.8-.76-.8h-.76v-3.78c0-.86-.68-1.56-1.51-1.56h-2.27v-.66c0-.5-.3-.82-.76-.82s-.76-.33-.76-.82v-2.56a5.31 5.31 0 0 0 3.57-3.66h1.2a3.4 3.4 0 0 0 2.65-1.16l1.3-1.32c.75-.7 1.13-1.7 1.13-2.71v-4.88c0-1.32-.99-2.33-2.27-2.33h-3.8v-1.43c.84 0 1.52-.72 1.52-1.61 0-.88-.68-1.61-1.51-1.61h-15.16c-.83 0-1.51.73-1.51 1.61 0 .89.68 1.61 1.51 1.61v1.43h-3.79c-1.28 0-2.27 1-2.27 2.33v4.88c0 1.08.38 2.01 1.14 2.71l1.29 1.32a3.52 3.52 0 0 0 2.65 1.16h1.2a5.32 5.32 0 0 0 3.57 3.66v2.56c0 .49-.3.82-.76.82-.45 0-.75.33-.75.82v.66h-2.28c-.83 0-1.51.7-1.51 1.56v3.78h-.76c-.38 0-.76.4-.76.8v1.6c0 .4.38.79.76.79z",transform:"translate(-714 -457)"}));}

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LineCup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function LineCup(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"20px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 20 20",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19.219,2.969h-3.75V.781A.781.781,0,0,0,14.688,0H5.313a.781.781,0,0,0-.781.781V2.969H.781A.781.781,0,0,0,0,3.75V6.094a4.693,4.693,0,0,0,4.688,4.688h.106A3.921,3.921,0,0,0,7.656,13.2v2.266H6.094a.781.781,0,0,0-.756.582L4.557,19.02a.781.781,0,0,0,.756.98h9.375a.781.781,0,0,0,.756-.98l-.781-2.969a.781.781,0,0,0-.756-.582H12.344V13.2a3.921,3.921,0,0,0,2.863-2.421h.106A4.693,4.693,0,0,0,20,6.094V3.75A.781.781,0,0,0,19.219,2.969ZM4.531,9.215A3.129,3.129,0,0,1,1.563,6.094V4.531H4.531ZM13.3,17.031l.37,1.406H6.326l.37-1.406ZM9.219,15.469V13.281h1.562v2.188Zm4.687-6.094a2.347,2.347,0,0,1-2.344,2.344H8.438A2.347,2.347,0,0,1,6.094,9.375V1.563h7.813Zm4.531-3.281a3.129,3.129,0,0,1-2.969,3.121V4.531h2.969Z"}));}

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WinnerCup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var FinalCup=function FinalCup(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"123px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 123.881 66",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-11.119 0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(99.342 0.755) rotate(30)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f2f2f2",d:"M39.264,29.056c-13.088-9.977-26.176,9.977-39.264,0C0,20.367,0,11.57,0,2.88c13.088,9.977,26.176-9.977,39.264,0C39.264,11.57,39.264,20.26,39.264,29.056Z",transform:"translate(1.931 0.038)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1.931 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z",transform:"translate(0 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.961,16.961,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(6.544 11.607)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z",transform:"translate(0 16.006)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.962,16.962,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(6.544 24.696)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z",transform:"translate(13.088 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A52.526,52.526,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253A52.512,52.512,0,0,1,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(19.632 7.209)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z",transform:"translate(13.088 16.006)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A52.52,52.52,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253,2.146,1.395,4.4.644,6.544,0,6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(19.632 20.297)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.673A16.961,16.961,0,0,0,0,7.209V.665A16.961,16.961,0,0,1,6.544.128Z",transform:"translate(26.176 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z",transform:"translate(32.72 6.673)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.673A16.961,16.961,0,0,0,0,7.209C0,5.063,0,2.81,0,.665A16.961,16.961,0,0,1,6.544.128Z",transform:"translate(26.176 13.088)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z",transform:"translate(32.72 19.761)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#231f20",style:{opacity:0.1},d:"M3.648,2.038A12.489,12.489,0,0,1,0,0C0,8.69,0,17.487,0,26.176a12.489,12.489,0,0,0,3.648,2.038Z",transform:"translate(1.931 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7058",d:"M2.038,51.494H1.717A1.7,1.7,0,0,1,0,49.778V1.717A1.7,1.7,0,0,1,1.717,0h.322A1.7,1.7,0,0,1,3.755,1.717V49.778A1.7,1.7,0,0,1,2.038,51.494Z",transform:"translate(0 0.021)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(11.101 21.098) rotate(-30)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f2f2f2",d:"M0,29.058c13.089-9.978,26.178,9.978,39.267,0,0-8.69,0-17.488,0-26.178C26.178,12.858,13.089-7.1,0,2.88,0,11.57,0,20.261,0,29.058Z",transform:"translate(0 0.038)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z",transform:"translate(32.722 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545a16.962,16.962,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(26.178 11.608)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z",transform:"translate(32.722 16.007)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545a16.961,16.961,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(26.178 24.697)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.545A52.527,52.527,0,0,1,0,0C0,2.146,0,4.291,0,6.545Z",transform:"translate(19.633 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.544A52.517,52.517,0,0,0,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(13.089 7.209)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.544C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.544A52.535,52.535,0,0,1,0,0C0,2.146,0,4.291,0,6.544Z",transform:"translate(19.633 16.007)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.544A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.545C4.4,1.395,2.146.644,0,0,0,2.253,0,4.4,0,6.544Z",transform:"translate(13.089 20.298)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.673a16.962,16.962,0,0,1,6.544.536V.665A16.962,16.962,0,0,0,0,.128Z",transform:"translate(6.544 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z",transform:"translate(0 6.673)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.673a16.962,16.962,0,0,1,6.544.536c0-2.146,0-4.4,0-6.545A16.961,16.961,0,0,0,0,.128Z",transform:"translate(6.544 13.089)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z",transform:"translate(0 19.762)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#231f20",style:{opacity:0.1},d:"M0,2.038A12.49,12.49,0,0,0,3.648,0c0,8.69,0,17.488,0,26.178A12.49,12.49,0,0,1,0,28.216Z",transform:"translate(35.619 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7058",d:"M1.717,51.5h.322a1.7,1.7,0,0,0,1.717-1.717V1.717A1.7,1.7,0,0,0,2.038,0H1.717A1.7,1.7,0,0,0,0,1.717V49.781A1.7,1.7,0,0,0,1.717,51.5Z",transform:"translate(37.443 0.021)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9792a1",d:"M152.363,387a3.009,3.009,0,0,0-3-3h-30a3.009,3.009,0,0,0-3,3v7.5h36Z",transform:"translate(-60.818 -334.501)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7c7688",d:"M133.591,465.455a1.613,1.613,0,0,1,1.5,1.5v3a1.613,1.613,0,0,1-1.5,1.5h-39a1.613,1.613,0,0,1-1.5-1.5v-3a1.613,1.613,0,0,1,1.5-1.5Z",transform:"translate(-40.546 -405.456)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M194.046,317.141a1.417,1.417,0,0,1-1.5-1.5v-4.95a9.674,9.674,0,0,1-3,.45h-9a9.674,9.674,0,0,1-3-.45v4.95a1.417,1.417,0,0,1-1.5,1.5,1.417,1.417,0,0,0-1.5,1.5v1.5h21v-1.5A1.417,1.417,0,0,0,194.046,317.141Z",transform:"translate(-111.501 -270.642)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#787382",d:"M324.681,394.5V387a3.009,3.009,0,0,0-3-3h-7.5v10.5Z",transform:"translate(-233.136 -334.501)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M201.181,413.272h-12a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h12a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,201.181,413.272Z",transform:"translate(-121.636 -354.773)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(72.045 52.499)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M247.364,413.273h-3l3-6h3Z",transform:"translate(-244.364 -407.273)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M285.272,410.272a3.009,3.009,0,0,0-3-3l-3,6h3A3.009,3.009,0,0,0,285.272,410.272Z",transform:"translate(-274.772 -407.272)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#635d6e",d:"M133.592,465.455h-10.5v1.5a3.009,3.009,0,0,1-3,3h-24a1.417,1.417,0,0,1-1.5-1.5v-3a1.417,1.417,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h39a1.613,1.613,0,0,0,1.5-1.5v-3A1.613,1.613,0,0,0,133.592,465.455Z",transform:"translate(-40.547 -405.456)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M186.932,360.727h4.5a.709.709,0,0,1,.75.75h0a.708.708,0,0,1-.75.75h-4.5a.708.708,0,0,1-.75-.75h0A.709.709,0,0,1,186.932,360.727Z",transform:"translate(-121.637 -314.228)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M60.045,93.819H56.6a7.036,7.036,0,0,1-5.25-2.25l-2.55-2.55a6.809,6.809,0,0,1-2.25-5.25v-9.45a4.42,4.42,0,0,1,4.5-4.5h7.5a1.5,1.5,0,0,1,0,3h-7.5a1.417,1.417,0,0,0-1.5,1.5v9.45a4.085,4.085,0,0,0,1.35,3.15l2.55,2.55a4.317,4.317,0,0,0,3.15,1.35h3.45a1.5,1.5,0,0,1,0,3Z",transform:"translate(0 -60.82)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M354.041,93.82h-3.45a1.5,1.5,0,1,1,0-3h3.45a4.085,4.085,0,0,0,3.15-1.35l2.55-2.55a4.317,4.317,0,0,0,1.35-3.15V74.32a1.417,1.417,0,0,0-1.5-1.5h-7.5a1.5,1.5,0,0,1,0-3h7.5a4.42,4.42,0,0,1,4.5,4.5v9.45a7.036,7.036,0,0,1-2.25,5.25l-2.55,2.55A6.809,6.809,0,0,1,354.041,93.82Z",transform:"translate(-263.546 -60.821)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(85.545 8.999)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M355.091,231.564c-.3,0-.6.15-1.05.15h-3.45a1.5,1.5,0,1,0,0,3h4.05a10.662,10.662,0,0,0,.45-3.15Z",transform:"translate(-349.091 -210.714)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M360.727,71.318a1.417,1.417,0,0,0,1.5,1.5h3v-3h-3A1.417,1.417,0,0,0,360.727,71.318Z",transform:"translate(-359.227 -69.818)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffca5d",d:"M159.136,81.045h-9a10.435,10.435,0,0,1-10.5-10.5v-24h30v24A10.435,10.435,0,0,1,159.136,81.045Z",transform:"translate(-81.091 -40.546)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(66.045 13.499)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M214.318,317.141a1.613,1.613,0,0,1-1.5-1.5v-4.95a9.673,9.673,0,0,1-3,.45h-9a9.674,9.674,0,0,1-3-.45v1.5a9.674,9.674,0,0,0,3,.45h4.5a3.009,3.009,0,0,1,3,3h0a1.5,1.5,0,0,0,1.5,1.5,1.417,1.417,0,0,1,1.5,1.5v1.5h4.5v-1.5A1.5,1.5,0,0,0,214.318,317.141Z",transform:"translate(-197.818 -284.141)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M455.319,105.477v6a.708.708,0,0,1-.75.75h0a.708.708,0,0,1-.75-.75v-6a.708.708,0,0,1,.75-.75h0A.709.709,0,0,1,455.319,105.477Z",transform:"translate(-420.819 -104.727)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(55.545 -0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M139.636,46.545v1.5h21a3.009,3.009,0,0,1,3,3v19.5c0,5.85-3.15,10.5-9,10.5h4.5a10.435,10.435,0,0,0,10.5-10.5v-24Z",transform:"translate(-136.636 -40.545)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M149.363,6h-30a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h30a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,149.363,6Z",transform:"translate(-116.363 0.001)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M149.364,0h0a3.009,3.009,0,0,1-3,3h-30a3.009,3.009,0,0,0,3,3h29.85a3.21,3.21,0,0,0,3.15-2.55A3.038,3.038,0,0,0,149.364,0Z",transform:"translate(-60.819 -0.001)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(61.545 10.499)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffe27a",d:"M164.409,93.455h0a1.417,1.417,0,0,1-1.5-1.5v-9a1.417,1.417,0,0,1,1.5-1.5h0a1.417,1.417,0,0,1,1.5,1.5v9A1.417,1.417,0,0,1,164.409,93.455Z",transform:"translate(-162.909 -81.455)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#ffe27a",cx:"1.5",cy:"1.5",r:"1.5",transform:"translate(0 13.5)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#847f8e",d:"M119.363,384a3.009,3.009,0,0,0-3,3v7.5h3Z",transform:"translate(-60.818 -334.501)"})));};var WinnerCup=function WinnerCup(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?"464px":_ref2$width,props=_objectWithoutProperties(_ref2,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 464.861 67.4",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(156.763 1.368)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(99.342 0.755) rotate(30)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f2f2f2",d:"M39.264,29.056c-13.088-9.977-26.176,9.977-39.264,0C0,20.367,0,11.57,0,2.88c13.088,9.977,26.176-9.977,39.264,0C39.264,11.57,39.264,20.26,39.264,29.056Z",transform:"translate(1.931 0.038)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1.931 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z",transform:"translate(0 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.961,16.961,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(6.544 11.607)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z",transform:"translate(0 16.006)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.962,16.962,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(6.544 24.696)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z",transform:"translate(13.088 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A52.526,52.526,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253A52.512,52.512,0,0,1,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(19.632 7.209)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z",transform:"translate(13.088 16.006)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A52.52,52.52,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253,2.146,1.395,4.4.644,6.544,0,6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(19.632 20.297)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.673A16.961,16.961,0,0,0,0,7.209V.665A16.961,16.961,0,0,1,6.544.128Z",transform:"translate(26.176 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z",transform:"translate(32.72 6.673)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.673A16.961,16.961,0,0,0,0,7.209C0,5.063,0,2.81,0,.665A16.961,16.961,0,0,1,6.544.128Z",transform:"translate(26.176 13.088)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z",transform:"translate(32.72 19.761)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#231f20",style:{opacity:0.1},d:"M3.648,2.038A12.489,12.489,0,0,1,0,0C0,8.69,0,17.487,0,26.176a12.489,12.489,0,0,0,3.648,2.038Z",transform:"translate(1.931 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7058",d:"M2.038,51.494H1.717A1.7,1.7,0,0,1,0,49.778V1.717A1.7,1.7,0,0,1,1.717,0h.322A1.7,1.7,0,0,1,3.755,1.717V49.778A1.7,1.7,0,0,1,2.038,51.494Z",transform:"translate(0 0.021)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(11.101 21.098) rotate(-30)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f2f2f2",d:"M0,29.058c13.089-9.978,26.178,9.978,39.267,0,0-8.69,0-17.488,0-26.178C26.178,12.858,13.089-7.1,0,2.88,0,11.57,0,20.261,0,29.058Z",transform:"translate(0 0.038)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z",transform:"translate(32.722 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545a16.962,16.962,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(26.178 11.608)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z",transform:"translate(32.722 16.007)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545a16.961,16.961,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(26.178 24.697)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.545A52.527,52.527,0,0,1,0,0C0,2.146,0,4.291,0,6.545Z",transform:"translate(19.633 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.544A52.517,52.517,0,0,0,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(13.089 7.209)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.544C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.544A52.535,52.535,0,0,1,0,0C0,2.146,0,4.291,0,6.544Z",transform:"translate(19.633 16.007)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.544A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.545C4.4,1.395,2.146.644,0,0,0,2.253,0,4.4,0,6.544Z",transform:"translate(13.089 20.298)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.673a16.962,16.962,0,0,1,6.544.536V.665A16.962,16.962,0,0,0,0,.128Z",transform:"translate(6.544 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z",transform:"translate(0 6.673)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.673a16.962,16.962,0,0,1,6.544.536c0-2.146,0-4.4,0-6.545A16.961,16.961,0,0,0,0,.128Z",transform:"translate(6.544 13.089)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z",transform:"translate(0 19.762)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#231f20",style:{opacity:0.1},d:"M0,2.038A12.49,12.49,0,0,0,3.648,0c0,8.69,0,17.488,0,26.178A12.49,12.49,0,0,1,0,28.216Z",transform:"translate(35.619 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7058",d:"M1.717,51.5h.322a1.7,1.7,0,0,0,1.717-1.717V1.717A1.7,1.7,0,0,0,2.038,0H1.717A1.7,1.7,0,0,0,0,1.717V49.781A1.7,1.7,0,0,0,1.717,51.5Z",transform:"translate(37.443 0.021)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(25.698 -32.635)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#fdb62f",cx:"11.2",cy:"11.2",r:"11.2",transform:"translate(65.6 49.067)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(36.8 58.667)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(33.6 65.067)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(36.8 71.467)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(36.8 77.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(40 84.267)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(36.8 90.667)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(4.8 65.067)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(4.8 71.467)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(8 77.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(4.8 84.267)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(8 71.467)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(0 19.2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(57.6)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(68.8 77.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fdb62f",width:"22.4",height:"6.4",transform:"translate(68.8 84.267)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(68.8 53.867)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#ffa83d",width:"22.4",height:"6.4",transform:"translate(0 36.8)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#ffa83d",cx:"6.4",cy:"6.4",r:"6.4",transform:"translate(1.6)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(70.4 53.867)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fd7b2f",d:"M409.6,309.333v-3.2a3.2,3.2,0,0,0,3.2-3.2H416A6.4,6.4,0,0,1,409.6,309.333Z",transform:"translate(-403.2 -296.533)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fd7b2f",d:"M378.666,275.2h-3.2a6.4,6.4,0,0,1,6.4-6.4V272A3.2,3.2,0,0,0,378.666,275.2Z",transform:"translate(-375.466 -268.8)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(9.6 7.467)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M398.934,34.134h0a7.775,7.775,0,0,0-6.4-6.4h0a7.775,7.775,0,0,0,6.4-6.4h0a7.775,7.775,0,0,0,6.4,6.4h0A7.775,7.775,0,0,0,398.934,34.134Z",transform:"translate(-259.534 2.666)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M57.6,221.867h0a7.775,7.775,0,0,0-6.4-6.4h0a7.775,7.775,0,0,0,6.4-6.4h0a7.775,7.775,0,0,0,6.4,6.4h0A7.775,7.775,0,0,0,57.6,221.867Z",transform:"translate(-145.2 -149.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M57.6,221.867h0a7.775,7.775,0,0,0-6.4-6.4h0a7.775,7.775,0,0,0,6.4-6.4h0a7.775,7.775,0,0,0,6.4,6.4h0A7.775,7.775,0,0,0,57.6,221.867Z",transform:"translate(208.8 -162.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M54.3,215.267h0a3.766,3.766,0,0,0-3.1-3.1h0a3.766,3.766,0,0,0,3.1-3.1h0a3.766,3.766,0,0,0,3.1,3.1h0A3.766,3.766,0,0,0,54.3,215.267Z",transform:"translate(-182.2 -183.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M54.3,215.267h0a3.766,3.766,0,0,0-3.1-3.1h0a3.766,3.766,0,0,0,3.1-3.1h0a3.766,3.766,0,0,0,3.1,3.1h0A3.766,3.766,0,0,0,54.3,215.267Z",transform:"translate(161.8 -167.867)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M456.533,179.733h-4.8v-4.8h-3.2v4.8h-4.8v3.2h4.8v4.8h3.2v-4.8h4.8Z",transform:"translate(-411.133 -151.133)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M451.194,177.731h-2.8v-2.8h-1.865v2.8h-2.8V179.6h2.8v2.8H448.4v-2.8h2.8Z",transform:"translate(-507.794 -137.795)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M451.194,177.731h-2.8v-2.8h-1.865v2.8h-2.8V179.6h2.8v2.8H448.4v-2.8h2.8Z",transform:"translate(-287.794 -109.795)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M455.794,179.456h-4.523v-4.523h-3.015v4.523h-4.523v3.015h4.523v4.523h3.015v-4.523h4.523Z",transform:"translate(-635.794 -127.795)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 29.867)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#dbdbdb",width:"96",height:"3.2",transform:"translate(0 65.6)"})))));};/* harmony default export */ __webpack_exports__["b"] = (FinalCup);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Cup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Cup(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"16px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 27 33",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M258.33 765.53a8.22 8.22 0 0 0-8.22-8.13h-.06v8.13zm-8.22-9.88c5.5 0 9.97 4.47 9.97 9.95a9.97 9.97 0 0 1-19.93 0 9.97 9.97 0 0 1 9.96-9.95zm-13.1 9.95a13.12 13.12 0 0 0 26.22 0c0-3.7-1.55-7.05-4.04-9.44l1.44-2.02a.81.81 0 0 0-.2-1.14l-2.16-1.53a.82.82 0 0 0-1.14.2l-1.47 2.07a12.86 12.86 0 0 0-3.48-1.06v-.85c0-.53.45-.98.99-.98h.54a1 1 0 0 0 .98-.98v-2.99a.99.99 0 0 0-.98-.98h-7.19a.99.99 0 0 0-.99.98v3a1 1 0 0 0 .99.97h.54c.54 0 .99.45.99.98v.85c-1.32.2-2.56.6-3.71 1.17l-1.46-2.05a.82.82 0 0 0-1.14-.2l-2.16 1.53a.8.8 0 0 0-.2 1.14l1.47 2.07a13.04 13.04 0 0 0-3.85 9.26z",transform:"translate(-237 -746)"}));}

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Wallet;
/* unused harmony export WalletPlus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Wallet(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"17px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 17.574 16.197",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-5152.823-2891.833a1.178,1.178,0,0,1-1.177-1.178v-10.641a1.177,1.177,0,0,1,1.177-1.177h14.6a1.177,1.177,0,0,1,1.176,1.177v2.527h-4.051a1.528,1.528,0,0,0-1.527,1.526v2.537a1.529,1.529,0,0,0,1.527,1.527h4.051v2.526a1.178,1.178,0,0,1-1.176,1.178Zm11.727-4.54a.69.69,0,0,1-.69-.69v-2.537a.69.69,0,0,1,.69-.69h3.979a.691.691,0,0,1,.69.69v2.537a.691.691,0,0,1-.69.69Zm.375-1.958a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,0,0-1-1A1,1,0,0,0-5140.722-2898.332Zm-7.455-7.645,5.983-1.976a1.52,1.52,0,0,1,1.92.966l.333,1.01Z",transform:"translate(5154 2908.03)"}));}function WalletPlus(_ref2){var _ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"currentColor":_ref2$fill,_ref2$width=_ref2.width,width=_ref2$width===undefined?"28px":_ref2$width,props=_objectWithoutProperties(_ref2,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 28.001 18.852",width:width,fill:fill},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-12095.176-27.148a16.515,16.515,0,0,1-4.6-.575c-1.283-.4-1.545-.8-1.545-.891l-.03-1.77a7.634,7.634,0,0,0,1.509.55,18.53,18.53,0,0,0,4.549.523,17.989,17.989,0,0,0,5.006-.636,7.636,7.636,0,0,0,1.271-.517v1.819c.007.066-.233.49-1.551.9A16.2,16.2,0,0,1-12095.176-27.148Zm-15.787-1.256a6.042,6.042,0,0,1-4.464-1.974,6,6,0,0,1-1.567-4.35,6,6,0,0,1,1.966-4.183,6.086,6.086,0,0,1,4.065-1.569,6.142,6.142,0,0,1,1.788.268,6.085,6.085,0,0,1,4.133,4.553,6.255,6.255,0,0,1,.122,1.216,6.024,6.024,0,0,1-1.977,4.467A6.026,6.026,0,0,1-12110.963-28.4Zm-4.038-6.843v2h3v3h2v-3h3v-2h-3v-3h-2v3Zm12.45,5.65h0a18.921,18.921,0,0,1-2.806-.249,7.2,7.2,0,0,0,1.164-1.992c.515.043,1.05.073,1.606.079v.109l.036,2.052Zm7.266-.934c-3.455,0-5.641-.786-6.089-1.344l-.006-.508-.024-1.4a7.418,7.418,0,0,0,1.319.511,18,18,0,0,0,4.806.587,18.2,18.2,0,0,0,4.951-.617,6.894,6.894,0,0,0,1.328-.517v1.606a1.008,1.008,0,0,0-.042.2c0,.082-.283.5-1.594.9A16.74,16.74,0,0,1-12095.285-30.53Zm-7.32-2.448h0c-.423,0-.842-.018-1.24-.055a7.3,7.3,0,0,0,.137-1.417c0-.237-.012-.471-.027-.715.351.024.721.036,1.1.043l.036,2.143Zm7.332-.9a16.836,16.836,0,0,1-4.465-.538c-1.239-.364-1.651-.762-1.7-.921.054-.235.538-.628,1.73-.964a16.6,16.6,0,0,1,4.321-.514h.1a17.093,17.093,0,0,1,4.665.575c1.3.393,1.594.793,1.6.879s-.3.515-1.651.915A16.819,16.819,0,0,1-12095.273-33.875Zm-6.974-2.454h-.061c-.584,0-1.146-.024-1.666-.061a7.185,7.185,0,0,0-1.086-2.253,21.871,21.871,0,0,0,2.746.176,18.141,18.141,0,0,0,5.023-.636,7.634,7.634,0,0,0,1.308-.523v1.587c-2.335.066-5.206.548-6.264,1.709Zm-.055-3.357a17.294,17.294,0,0,1-4.127-.453,7.839,7.839,0,0,0-1.946-1.086l-.042-1.709a6.668,6.668,0,0,0,1.311.5,17.983,17.983,0,0,0,4.8.587,18.075,18.075,0,0,0,5.015-.636,7.155,7.155,0,0,0,1.317-.529v1.587a.32.32,0,0,0-.061.228c0,.112-.295.522-1.606.919A17.063,17.063,0,0,1-12102.3-39.687Zm-.006-3.357a16.557,16.557,0,0,1-4.464-.544c-1.309-.374-1.671-.792-1.7-.921,0-.16.33-.529,1.557-.9a16.436,16.436,0,0,1,4.607-.587,16.961,16.961,0,0,1,4.665.587c1.32.4,1.605.811,1.605.891s-.287.5-1.611.9A17.1,17.1,0,0,1-12102.308-43.044Z",transform:"translate(12117.001 46)"}));}

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Rating;
/* harmony export (immutable) */ __webpack_exports__["a"] = Podium;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Rating(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"18px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 18 14",width:width,fill:fill},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-1268-215h-11v-9h6v-5h6v8h6v6Z",transform:"translate(1279 229)"}));}function Podium(_ref2){var _ref2$width=_ref2.width,width=_ref2$width===undefined?"18px":_ref2$width,_ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"currentColor":_ref2$fill,props=_objectWithoutProperties(_ref2,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 56 42",width:width,fill:fill},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 -64)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 64)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M395.543,213.977a1.169,1.169,0,0,0-1.043-.644H384v2.333h12.388Z",transform:"translate(-342 -197)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M183.338,64.644A1.169,1.169,0,0,0,182.3,64H165.962a1.169,1.169,0,0,0-1.043.644l-.845,1.689h20.109Z",transform:"translate(-146.128 -64)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M55.947,123.9a1.3,1.3,0,0,0-.058-.217A1.165,1.165,0,0,0,54.834,123H39.667V107.834a1.139,1.139,0,0,0-.054-.268,1.3,1.3,0,0,0-.058-.217,1.165,1.165,0,0,0-1.055-.681h-21a1.168,1.168,0,0,0-1.055.681,1.1,1.1,0,0,0-.058.217,1.142,1.142,0,0,0-.054.268v12.833H1.167a1.168,1.168,0,0,0-1.055.681,1.1,1.1,0,0,0-.058.217,1.143,1.143,0,0,0-.054.268v21A1.169,1.169,0,0,0,1.167,144H54.834A1.169,1.169,0,0,0,56,142.834V124.167A1.147,1.147,0,0,0,55.947,123.9Zm-44.28,10.766h0v0a1.167,1.167,0,1,1,0,2.333H7a1.168,1.168,0,0,1-.826-1.993l3.017-3.017a4.449,4.449,0,0,0,1.309-3.159,1.167,1.167,0,0,0-2.333,0,1.167,1.167,0,1,1-2.333,0,3.5,3.5,0,0,1,7,0,6.761,6.761,0,0,1-1.993,4.809l-1.024,1.024ZM30.336,126.5h0a1.167,1.167,0,1,1-2.333,0v-8.85l-.341.341a1.167,1.167,0,1,1-1.65-1.65l2.333-2.333a1.168,1.168,0,0,1,1.993.826V126.5Zm19.831,9.333a3.5,3.5,0,0,1-7,0,1.167,1.167,0,1,1,2.333,0,1.167,1.167,0,1,0,1.167-1.167,1.167,1.167,0,1,1,0-2.333,1.167,1.167,0,1,0-1.167-1.167,1.167,1.167,0,1,1-2.333,0,3.5,3.5,0,1,1,6.106,2.333A3.487,3.487,0,0,1,50.167,135.834Z",transform:"translate(0 -102)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M27.129,192h-10.5a1.169,1.169,0,0,0-1.043.644l-.845,1.689H27.129Z",transform:"translate(-13.129 -178)"}))));}

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Person;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Person(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"16px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 16 16",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0,370v-2c0-2.2,3.6-4,8-4s8,1.8,8,4v2Zm4-12a4,4,0,1,1,4,4A4,4,0,0,1,4,358Z",transform:"translate(0 -354)"}));}

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Coins;
/* harmony export (immutable) */ __webpack_exports__["a"] = CoinsPlus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Coins(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"16px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 28 18.852",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-5394.775-808.251c-1.278-.394-1.545-.8-1.545-.891v-.012l-.03-1.757a7.887,7.887,0,0,0,1.509.551,18.645,18.645,0,0,0,4.551.521,17.922,17.922,0,0,0,5.006-.636,7.748,7.748,0,0,0,1.272-.515v1.818h.006c0,.085-.279.5-1.557.9a16.179,16.179,0,0,1-4.612.594A16.494,16.494,0,0,1-5394.775-808.251Zm-15.652-2.654a6.043,6.043,0,0,1,.4-8.532,6.1,6.1,0,0,1,4.066-1.569,6.169,6.169,0,0,1,1.788.267,6.083,6.083,0,0,1,4.133,4.551,6.311,6.311,0,0,1,.121,1.218,6,6,0,0,1-1.975,4.466,6.028,6.028,0,0,1-4.067,1.572A6.014,6.014,0,0,1-5410.428-810.9Zm10.071.533a7.3,7.3,0,0,0,1.164-1.994c.515.042,1.048.073,1.605.079v.109l.036,2.054A18.944,18.944,0,0,1-5400.357-810.372Zm3.982-2.03-.006-.509-.024-1.394a7.434,7.434,0,0,0,1.321.509,17.913,17.913,0,0,0,4.806.588,18.143,18.143,0,0,0,4.951-.618,6.93,6.93,0,0,0,1.327-.515v1.606h-.006c0,.061-.037.133-.037.2,0,.085-.285.5-1.594.9a16.759,16.759,0,0,1-4.648.582C-5393.642-811.056-5395.9-811.814-5396.375-812.4Zm-2.473-1.157a7.417,7.417,0,0,0,.14-1.418c0-.236-.012-.473-.03-.715.351.024.721.036,1.1.042l.037,2.145C-5398.03-813.5-5398.448-813.523-5398.848-813.559Zm4.108-1.382c-1.3-.382-1.66-.794-1.7-.921l-.012-.024a.047.047,0,0,1,.006-.024c.055-.164.485-.564,1.739-.915a16.488,16.488,0,0,1,4.321-.515h.1a16.981,16.981,0,0,1,4.666.576c1.291.388,1.594.788,1.6.879v.006c-.006.091-.309.509-1.654.909a16.834,16.834,0,0,1-4.605.57A16.909,16.909,0,0,1-5394.739-814.941Zm-2.569-1.915c-.582,0-1.145-.024-1.667-.06a7.171,7.171,0,0,0-1.085-2.254,21.839,21.839,0,0,0,2.746.176,18.082,18.082,0,0,0,5.023-.636,7.634,7.634,0,0,0,1.31-.521v1.588c-2.6.073-5.273.618-6.266,1.709Zm-4.121-3.812c-.019-.006-.03-.006-.048-.012a6.991,6.991,0,0,0-1.9-1.073l-.042-1.709a6.722,6.722,0,0,0,1.31.5,17.909,17.909,0,0,0,4.805.588,18.069,18.069,0,0,0,5.018-.636,7.24,7.24,0,0,0,1.314-.527v1.588a.35.35,0,0,0-.061.249c0,.079-.29.5-1.605.9a17.148,17.148,0,0,1-4.666.588A17.338,17.338,0,0,1-5401.429-820.667Zm-.345-3.448c-1.3-.376-1.667-.788-1.7-.921,0-.012-.007-.012-.007-.012.007-.121.285-.5,1.564-.891a16.37,16.37,0,0,1,4.6-.588,16.926,16.926,0,0,1,4.667.588c1.315.4,1.605.812,1.605.891s-.3.5-1.611.9a17.127,17.127,0,0,1-4.661.582A16.628,16.628,0,0,1-5401.774-824.115Z",transform:"translate(5412 826.527)"}));}function CoinsPlus(_ref2){var _ref2$fill=_ref2.fill,fill=_ref2$fill===undefined?"currentColor":_ref2$fill,_ref2$width=_ref2.width,width=_ref2$width===undefined?"26px":_ref2$width,props=_objectWithoutProperties(_ref2,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 26 17.505",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-12096.735-28.5a15.341,15.341,0,0,1-4.271-.534c-1.191-.368-1.435-.746-1.435-.827l-.027-1.643a7.093,7.093,0,0,0,1.4.511,17.209,17.209,0,0,0,4.224.486,16.706,16.706,0,0,0,4.648-.59,7.1,7.1,0,0,0,1.181-.48v1.689c.007.062-.217.455-1.439.839A15.044,15.044,0,0,1-12096.735-28.5Zm-14.659-1.166a5.608,5.608,0,0,1-4.145-1.833,5.576,5.576,0,0,1-1.456-4.039,5.57,5.57,0,0,1,1.826-3.885,5.65,5.65,0,0,1,3.774-1.457,5.7,5.7,0,0,1,1.66.248,5.65,5.65,0,0,1,3.838,4.227,5.813,5.813,0,0,1,.113,1.13,5.6,5.6,0,0,1-1.835,4.148A5.6,5.6,0,0,1-12111.395-29.662Zm-3.749-6.354v1.855h2.786v2.787h1.858V-34.16h2.784v-1.855h-2.784V-38.8h-1.858v2.787Zm11.561,5.247h0a17.558,17.558,0,0,1-2.605-.232,6.678,6.678,0,0,0,1.081-1.85c.478.04.975.068,1.491.073v.1l.034,1.905Zm6.746-.867c-3.208,0-5.237-.73-5.654-1.248l0-.472-.022-1.3a6.869,6.869,0,0,0,1.225.474,16.711,16.711,0,0,0,4.462.545,16.9,16.9,0,0,0,4.6-.573,6.387,6.387,0,0,0,1.233-.48v1.491a.9.9,0,0,0-.039.186c0,.076-.263.462-1.479.833A15.548,15.548,0,0,1-12096.837-31.635Zm-6.8-2.273h0c-.393,0-.782-.017-1.152-.051a6.725,6.725,0,0,0,.127-1.316c0-.22-.011-.438-.025-.664.326.023.67.034,1.018.04l.034,1.99Zm6.808-.833a15.625,15.625,0,0,1-4.146-.5c-1.151-.338-1.533-.707-1.575-.856.05-.218.5-.584,1.606-.9a15.412,15.412,0,0,1,4.013-.477h.1a15.872,15.872,0,0,1,4.332.534c1.212.365,1.479.737,1.485.816s-.28.479-1.533.85A15.616,15.616,0,0,1-12096.826-34.742Zm-6.476-2.279h-.056c-.542,0-1.064-.023-1.547-.056a6.669,6.669,0,0,0-1.009-2.092,20.306,20.306,0,0,0,2.55.164,16.851,16.851,0,0,0,4.665-.59,7.09,7.09,0,0,0,1.214-.486v1.474c-2.168.061-4.834.509-5.816,1.587Zm-.051-3.117a16.064,16.064,0,0,1-3.832-.421,7.269,7.269,0,0,0-1.807-1.008l-.039-1.587a6.187,6.187,0,0,0,1.217.469,16.693,16.693,0,0,0,4.461.545,16.78,16.78,0,0,0,4.656-.59,6.646,6.646,0,0,0,1.224-.491v1.474a.3.3,0,0,0-.057.212c0,.1-.273.485-1.491.853A15.846,15.846,0,0,1-12103.353-40.138Zm0-3.117a15.383,15.383,0,0,1-4.146-.505c-1.215-.347-1.551-.735-1.578-.856,0-.148.307-.491,1.445-.839a15.257,15.257,0,0,1,4.278-.545,15.746,15.746,0,0,1,4.331.545c1.227.373,1.491.753,1.491.827s-.267.466-1.5.833A15.879,15.879,0,0,1-12103.357-43.255Z",transform:"translate(12117.001 46)"}));}

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function DownArrow(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"10px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 10 5",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M7,10l5,5,5-5Z",transform:"translate(-7 -10)"}));}

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PaymentError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(63);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function PaymentError(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"68px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["b" /* default */],Object.assign({viewBox:"0 0 67.5 67.5",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{fill:"none",stroke:"#ef3522",strokeWidth:"6px",transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{stroke:"none",cx:"33.75",cy:"33.75",r:"33.75"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"none",cx:"33.75",cy:"33.75",r:"30.75"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"coins",transform:"translate(13.297 14.301)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fcc62d",d:"M36.53,29.211v.82c0,4.589-7.707,8.31-17.214,8.31a27.489,27.489,0,0,1-13.1-2.922c1.065,4.135,8.3,7.557,17.073,7.557,9.507,0,17.214-4.017,17.214-8.607,0-2.018-1.494-3.8-3.972-5.157",transform:"translate(-2.099 -9.871)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#e4af18",d:"M23.217,45.607C13.71,45.607,6,41.589,6,37v5.593c0,4.589,7.707,8.31,17.214,8.31s17.214-3.721,17.214-8.31V37c0,4.589-7.707,8.607-17.214,8.607",transform:"translate(-2.028 -12.504)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M9,48.528a10.761,10.761,0,0,0,1.324,1.023V44.061A11,11,0,0,1,9,43Z",transform:"translate(-3.041 -14.531)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M53,44.061V49.55a10.7,10.7,0,0,0,1.324-1.023V43A10.9,10.9,0,0,1,53,44.061",transform:"translate(-17.911 -14.531)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M13,51.276q.628.325,1.324.615V46.467q-.7-.306-1.324-.646Z",transform:"translate(-4.393 -15.485)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M49,51.89q.7-.29,1.324-.615V45.82q-.628.34-1.324.646Z",transform:"translate(-16.559 -15.484)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M17,52.99q.642.219,1.324.41V48.028q-.682-.2-1.324-.434Z",transform:"translate(-5.745 -16.084)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M45,53.4q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z",transform:"translate(-15.207 -16.084)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M22,54.358c.432.087.875.166,1.324.235V49.267c-.45-.075-.892-.158-1.324-.251Z",transform:"translate(-7.435 -16.564)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M40,54.592c.45-.07.892-.148,1.324-.235V49.015c-.432.093-.875.176-1.324.252Z",transform:"translate(-13.517 -16.564)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M28,55.192c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z",transform:"translate(-9.462 -16.859)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M34,55.263c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z",transform:"translate(-11.49 -16.859)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#e4af18",d:"M17.217,30.6C7.71,30.6,0,26.582,0,21.993v5.593C0,32.176,7.71,35.9,17.217,35.9s17.214-3.721,17.214-8.31V21.993c0,4.589-7.707,8.607-17.214,8.607",transform:"translate(0 -7.432)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M3,33.521a10.761,10.761,0,0,0,1.324,1.023V29.055A11.064,11.064,0,0,1,3,27.994v5.527Z",transform:"translate(-1.014 -9.46)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M47,29.054v5.489a10.7,10.7,0,0,0,1.324-1.023V27.993A10.9,10.9,0,0,1,47,29.054",transform:"translate(-15.883 -9.46)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M7,36.269q.628.325,1.324.615V31.46q-.7-.306-1.324-.646v5.455Z",transform:"translate(-2.366 -10.413)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M43,36.883q.7-.29,1.324-.615V30.813q-.628.34-1.324.646Z",transform:"translate(-14.531 -10.413)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M11,37.983q.642.219,1.324.41V33.021q-.682-.2-1.324-.434Z",transform:"translate(-3.717 -11.012)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M39,38.393q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z",transform:"translate(-13.179 -11.012)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M16,39.351c.432.087.875.166,1.324.235V34.26c-.45-.075-.892-.158-1.324-.251Z",transform:"translate(-5.407 -11.493)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M34,39.586c.45-.07.892-.148,1.324-.235V34.009c-.432.093-.875.176-1.324.252Z",transform:"translate(-11.49 -11.493)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M22,40.186c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z",transform:"translate(-7.435 -11.788)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M28,40.256c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z",transform:"translate(-9.462 -11.788)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffd949",d:"M38.48,33.3c-1.772,3.678-8.6,6.421-16.761,6.421a32.494,32.494,0,0,1-8.393-1.055c2.4,1.631,6.677,3.018,12.365,3.018,9.058,0,14.565-3.516,14.565-5.936A3.316,3.316,0,0,0,38.48,33.3",transform:"translate(-4.502 -11.254)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffd949",d:"M20.527,26.848c-9.507,0-17.214-3.721-17.214-8.31V14.8C1.234,16.1,0,17.734,0,19.566c0,4.589,7.707,8.607,17.214,8.607a27.934,27.934,0,0,0,11.817-2.411,32.377,32.377,0,0,1-8.507,1.087",transform:"translate(0 -5)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#e4af18",d:"M22.217,20.6C12.71,20.6,5,16.582,5,11.993v5.593c0,4.589,7.707,8.31,17.214,8.31s17.214-3.721,17.214-8.31V11.993c0,4.589-7.707,8.607-17.214,8.607",transform:"translate(-1.69 -4.053)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M8,23.521a10.761,10.761,0,0,0,1.324,1.023V19.055A11.064,11.064,0,0,1,8,17.994Z",transform:"translate(-2.703 -6.081)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M52,19.054v5.489a10.7,10.7,0,0,0,1.324-1.023V17.993A10.9,10.9,0,0,1,52,19.054",transform:"translate(-17.573 -6.08)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M12,26.269q.628.325,1.324.615V21.46q-.7-.306-1.324-.646Z",transform:"translate(-4.055 -7.034)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M48,26.883q.7-.29,1.324-.615V20.813q-.628.34-1.324.646Z",transform:"translate(-16.221 -7.033)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M16,27.983q.642.219,1.324.41V23.021q-.682-.2-1.324-.434Z",transform:"translate(-5.407 -7.633)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M44,28.393q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z",transform:"translate(-14.869 -7.633)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M21,29.351c.432.087.875.166,1.324.235V24.26c-.45-.075-.892-.158-1.324-.251Z",transform:"translate(-7.097 -8.113)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M39,29.586c.45-.07.892-.148,1.324-.235V24.009c-.432.093-.875.176-1.324.252Z",transform:"translate(-13.179 -8.113)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M27,30.186c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z",transform:"translate(-9.124 -8.409)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ce9912",d:"M33,30.256c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z",transform:"translate(-11.152 -8.408)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fcc62d",d:"M39.43,7.945c0,4.589-7.707,8.607-17.214,8.607S5,12.534,5,7.945,12.71,0,22.217,0,39.43,3.355,39.43,7.945",transform:"translate(-1.69)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffd949",d:"M23.568,14.895C14.51,14.895,9,11.379,9,8.959S14.51,3,23.568,3,38.134,6.539,38.134,8.959s-5.507,5.936-14.565,5.936",transform:"translate(-3.041 -1.014)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:"#ef3522",strokeWidth:"6px",x1:"47.582",y2:"43.156",transform:"translate(9.406 11.619)"}));}

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Caution=function Caution(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"100%":_ref$width;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:"http://www.w3.org/2000/svg",width:width,height:"auto",viewBox:"0 0 130 120"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-0.003 -18.258)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M124.4,138.258H5.546a5.509,5.509,0,0,1-4.868-8.126l59.427-109a5.557,5.557,0,0,1,9.736,0c64.444,118.2,60.1,109.618,60.1,111.62A5.52,5.52,0,0,1,124.4,138.258Z",transform:"translate(0 0)",fill:"#f2d422"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M149.779,171.847H49.523a3.021,3.021,0,0,1-2.67-4.457L96.98,75.448a3.049,3.049,0,0,1,5.341,0l50.128,91.943A3.021,3.021,0,0,1,149.779,171.847ZM54.623,165.81h90.055L99.651,83.221Z",transform:"translate(-34.678 -41.578)",fill:"#585a60"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(60.087 71.368)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M243.758,228.708h-3.817a2.881,2.881,0,0,0-2.889,2.872l.723,21.359a2.881,2.881,0,0,0,2.889,2.872h2.372a2.881,2.881,0,0,0,2.89-2.872l.722-21.359A2.881,2.881,0,0,0,243.758,228.708Z",transform:"translate(-236.948 -228.708)",fill:"#585a60"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{cx:"4.99",cy:"4.96",rx:"4.99",ry:"4.96",transform:"translate(0 33.357)",fill:"#585a60"}))));};/* harmony default export */ __webpack_exports__["a"] = (Caution);

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-bottom: 55px;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffcc00;\n  text-transform: uppercase;\n\n  @media (max-width: 959px) {\n    margin-bottom: 35px;\n    font-size: 18px;\n  }\n\n  @media (orientation: landscape) and (max-width: 959px) {\n    margin-bottom: 17px;\n  }\n"],["\n  margin-bottom: 55px;\n  font-size: 28px;\n  font-weight: 700;\n  color: #ffcc00;\n  text-transform: uppercase;\n\n  @media (max-width: 959px) {\n    margin-bottom: 35px;\n    font-size: 18px;\n  }\n\n  @media (orientation: landscape) and (max-width: 959px) {\n    margin-bottom: 17px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 130px;\n  margin-bottom: 56px;\n\n  @media (max-width: 959px) {\n    margin-bottom: 45px;\n  }\n\n  @media (orientation: landscape) and (max-width: 959px) {\n    width: 94px;\n    margin-bottom: 18px;\n  }\n"],["\n  width: 130px;\n  margin-bottom: 56px;\n\n  @media (max-width: 959px) {\n    margin-bottom: 45px;\n  }\n\n  @media (orientation: landscape) and (max-width: 959px) {\n    width: 94px;\n    margin-bottom: 18px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  margin-bottom: 36px;\n  color: ",";\n  font-size: 18px;\n  font-size: 700;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    margin-bottom: 18px;\n  }\n"],["\n  margin-bottom: 36px;\n  color: ",";\n  font-size: 18px;\n  font-size: 700;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    margin-bottom: 18px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  margin-bottom: 20px;\n\n  @media (max-width: 479px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"],["\n  display: grid;\n  grid-template-columns: 1fr 2fr 1fr;\n  margin-bottom: 20px;\n\n  @media (max-width: 479px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 163px;\n  min-height: 37px;\n  padding: 8px 20px;\n  font-size: 12px;\n  font-weight: 900;\n  color: ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  background-color: transparent;\n  border: 2px solid ",";\n  border-radius: 18px;\n  transition: all 0.15s;\n\n  &:hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media (max-width: 479px) {\n    margin-bottom: 16px;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 163px;\n  min-height: 37px;\n  padding: 8px 20px;\n  font-size: 12px;\n  font-weight: 900;\n  color: ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  background-color: transparent;\n  border: 2px solid ",";\n  border-radius: 18px;\n  transition: all 0.15s;\n\n  &:hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media (max-width: 479px) {\n    margin-bottom: 16px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n"],["\n  display: flex;\n  justify-content: flex-end;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: block;\n  padding: 0;\n  font-size: 12px;\n  color: ",";\n  text-decoration: underline;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  transition: all 0.15s;\n\n  &:hover {\n    text-decoration: none;\n  }\n"],["\n  display: block;\n  padding: 0;\n  font-size: 12px;\n  color: ",";\n  text-decoration: underline;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  transition: all 0.15s;\n\n  &:hover {\n    text-decoration: none;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Message=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject4,function(_ref){var theme=_ref.theme;return theme.suspiciousActivityPopupText;});var Footer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */])(_templateObject6,function(_ref2){var theme=_ref2.theme;return theme.suspiciousActivityPopupButton;},function(_ref3){var theme=_ref3.theme;return theme.suspiciousActivityPopupButton;},function(_ref4){var theme=_ref4.theme;return theme.suspiciousActivityPopupButton;},function(_ref5){var theme=_ref5.theme;return theme.suspiciousActivityPopupButtonHoverColor;});var LaterButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var LaterButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject8,function(_ref6){var theme=_ref6.theme;return theme.suspiciousActivityPopupLink;});var SuspiciousActivityError=function SuspiciousActivityError(_ref7){var _onDismiss=_ref7.onDismiss,onDismissAll=_ref7.onDismissAll,callback=_ref7.callback;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Popup__["a" /* StyledPopup */],{onDismiss:function onDismiss(){return _onDismiss({callback:callback});},fades:false,withWhiteTheme:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Caution")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["a" /* Caution */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Message,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"We have detected some suspicious activity on your account. Please verify your account on the verification page to join tournaments.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{to:"/verification",onClick:function onClick(){_onDismiss({callback:callback});onDismissAll();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Verify")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LaterButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LaterButton,{onClick:function onClick(){_onDismiss({callback:callback});onDismissAll();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Later"))))));};/* harmony default export */ __webpack_exports__["a"] = (SuspiciousActivityError);

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_Gettext__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  -webkit-display: flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  align-items: center;\n  -webkit-align-content: flex-start;\n  align-content: flex-start;\n  -webkit-justify-content: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100%;\n  padding-top: 62px;\n  text-align: center;\n  color: #fff;\n  background-color: ",";\n  background-size: cover;\n\n  @media (max-width: 959px) {\n    -webkit-align-content: center;\n    align-content: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    padding-top: 0;\n  }\n"],["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  -webkit-display: flex;\n  display: flex;\n  -webkit-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-align-items: center;\n  align-items: center;\n  -webkit-align-content: flex-start;\n  align-content: flex-start;\n  -webkit-justify-content: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n  height: 100%;\n  padding-top: 62px;\n  text-align: center;\n  color: #fff;\n  background-color: ",";\n  background-size: cover;\n\n  @media (max-width: 959px) {\n    -webkit-align-content: center;\n    align-content: center;\n    -webkit-justify-content: center;\n    justify-content: center;\n    padding-top: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  height: 79px;\n  width: 100%;\n  margin-bottom: 62px;\n  background: url(",") center no-repeat;\n  background-size: contain;\n\n  @media (max-width: 959px) {\n    height: 45px;\n    margin-bottom: 33px;\n  }\n"],["\n  height: 79px;\n  width: 100%;\n  margin-bottom: 62px;\n  background: url(",") center no-repeat;\n  background-size: contain;\n\n  @media (max-width: 959px) {\n    height: 45px;\n    margin-bottom: 33px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: block;\n  width: 105px;\n  height: auto;\n  margin-bottom: 40px;\n  fill: none;\n  stroke: ",";\n  stroke-linejoin: round;\n  stroke-width: 2px;\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    width: 55px;\n    margin-bottom: 23px;\n  }\n"],["\n  display: block;\n  width: 105px;\n  height: auto;\n  margin-bottom: 40px;\n  fill: none;\n  stroke: ",";\n  stroke-linejoin: round;\n  stroke-width: 2px;\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    width: 55px;\n    margin-bottom: 23px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto 40px;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.5;\n  text-align: center;\n  color: ",";\n\n  @media (max-width: 959px) {\n    padding: 0 30px;\n    font-size: 18px;\n  }\n"],["\n  width: 100%;\n  max-width: 500px;\n  margin: 0 auto 40px;\n  font-weight: 400;\n  font-size: 20px;\n  line-height: 1.5;\n  text-align: center;\n  color: ",";\n\n  @media (max-width: 959px) {\n    padding: 0 30px;\n    font-size: 18px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 2.611em;\n  margin-left: 0.556em;\n  padding: 0 0.944em;\n  font-weight: 700;\n  font-size: 20px;\n  color: #fff;\n  text-shadow: -1px -1px #56a008;\n  border-radius: 0.5em;\n  border: none;\n  border-bottom: 2px solid #4e8418;\n  box-shadow: inset 0px -1px 0px 0px ",";\n  background-color: ",";\n  background: linear-gradient(\n    to top,\n    ",",\n    ","\n  );\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    box-shadow: inset 0px -1px 0px 0px rgba(99, 191, 0, 1);\n    background-color: ",";\n    background: linear-gradient(\n      to top,\n      ",",\n      ","\n    );\n  }\n\n  @media (max-width: 959px) {\n    font-size: 18px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 2.611em;\n  margin-left: 0.556em;\n  padding: 0 0.944em;\n  font-weight: 700;\n  font-size: 20px;\n  color: #fff;\n  text-shadow: -1px -1px #56a008;\n  border-radius: 0.5em;\n  border: none;\n  border-bottom: 2px solid #4e8418;\n  box-shadow: inset 0px -1px 0px 0px ",";\n  background-color: ",";\n  background: linear-gradient(\n    to top,\n    ",",\n    ","\n  );\n  cursor: pointer;\n\n  :hover,\n  :focus,\n  :active {\n    box-shadow: inset 0px -1px 0px 0px rgba(99, 191, 0, 1);\n    background-color: ",";\n    background: linear-gradient(\n      to top,\n      ",",\n      ","\n    );\n  }\n\n  @media (max-width: 959px) {\n    font-size: 18px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.main;});var Logo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.logoImg;});var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject3,function(props){return props.theme.accent;});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.accent;});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.theme.upperBoxShadow;},function(props){return props.theme.upper;},function(props){return props.theme.upper;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upper;});function Icon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Svg,{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 32 32"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{cx:"16",cy:"16",r:"15"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{points:"8 16 13 21 24 10"})));}function UpdateScreen(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Logo,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Gettext__["b" /* default */],null,"The application was updated while you were trading. Please refresh this page to continue.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:function onClick(){document.location.reload();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_common_Gettext__["b" /* default */],null,"Reload")));}/* harmony default export */ __webpack_exports__["a"] = (UpdateScreen);

/***/ }),
/* 1491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ENG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return THA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return VNM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PHL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return IDN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return HIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ESP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ARA; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_flag_of_the_Arab_League_png__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_flag_of_the_Arab_League_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_flag_of_the_Arab_League_png__);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 17px;\n  height: 13px;\n  pointer-events: none;\n\n  ",";\n"],["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 17px;\n  height: 13px;\n  pointer-events: none;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n        right: 45px;\n      "],["\n        right: 45px;\n      "]),_templateObject3=_taggedTemplateLiteral(["\n      left: 45px;\n    "],["\n      left: 45px;\n    "]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject,function(_ref){var theme=_ref.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});function Flag(_ref2){var children=_ref2.children,props=_objectWithoutProperties(_ref2,["children"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,Object.assign({xmlns:"http://www.w3.org/2000/svg",width:"640",height:"480",viewBox:"0 0 640 480"},props),children);}var RUS=function RUS(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{fillRule:"evenodd",strokeWidth:"1pt"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#fff",d:"M0 0h640v480H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#0039a6",d:"M0 160.003h640V480H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#d52b1e",d:"M0 319.997h640V480H0z"})));};var ENG=function ENG(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("defs",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("clipPath",{id:"clipPath8673",clipPathUnits:"userSpaceOnUse"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{fillOpacity:"0.67",height:"512",width:"682.67",y:"-.0000028613",x:"-85.333"}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{clipPath:"url(#clipPath8673)",transform:"matrix(.93750 0 0 .93750 80 .0000026825)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{strokeWidth:"1pt",transform:"matrix(17.067 0 0 17.067 -256 -0.0000024)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{height:"30",width:"60",y:"0",x:"0",fill:"#006"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"m0 0v3.3541l53.292 26.646h6.708v-3.354l-53.292-26.646h-6.708zm60 0v3.354l-53.292 26.646h-6.708v-3.354l53.292-26.646h6.708z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"m25 0v30h10v-30h-10zm-25 10v10h60v-10h-60z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"m0 12v6h60v-6h-60zm27-12v30h6v-30h-6z",fill:"#c00"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"m0 30 20-10h4.472l-20 10h-4.472zm0-30 20 10h-4.472l-15.528-7.7639v-2.2361zm35.528 10 20-10h4.472l-20 10h-4.472zm24.472 20-20-10h4.472l15.528 7.764v2.236z",fill:"#c00"})))));};var THA=function THA(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{fillRule:"evenodd",strokeWidth:"1pt"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#fff",d:"M0 0h640v480H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#001b9a",d:"M0 162.544h640v160.003H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#e70000",d:"M0 .042h640v82.5H0zM0 400.003h640v80H0z"})));};var VNM=function VNM(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("defs",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("clipPath",{id:"clipPath4024",clipPathUnits:"userSpaceOnUse"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{fillOpacity:"0.67",height:"512",width:"682.67",y:".0000024116",x:"-85.334"}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"flag",fillRule:"evenodd",clipPath:"url(#clipPath4024)",transform:"matrix(.9375 0 0 .9375 80.001 -.0000022609)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{height:"512",width:"768",y:".0000024116",x:"-128",strokeWidth:"1pt",fill:"#ec0015"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"m349.59 381.05-89.576-66.893-89.137 67.55 33.152-109.77-88.973-67.784 110.08-0.94507 34.142-109.44 34.873 109.19 110.08 0.14401-88.517 68.423 33.884 109.53z",strokeWidth:".11287",fill:"#ff0"})));};var PHL=function PHL(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#0038a8",d:"M0 0h640v240H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#ce1126",d:"M0 240h640v240H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M415.692 240L0 480V0",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{transform:"translate(149.333 240) scale(5.33333)",fill:"#fcd116"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{r:"9"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"d"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"c"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"b"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M-1 0l.062.062L0 0l-.938-.062z",transform:"scale(19)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{id:"a",d:"M-.884.116l.05.05L0 0z",transform:"scale(19.2381)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"scale(1 -1)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"rotate(45)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"rotate(90)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"scale(-1)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{transform:"translate(-2.02)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"f",transform:"translate(37.962)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{id:"e",d:"M5 0L1.618 1.176l-.073 3.58-2.163-2.854-3.427 1.037L-2 0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"scale(1 -1)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"rotate(120)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{height:"100%",width:"100%",transform:"rotate(-120)"}))));};var IDN=function IDN(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{xmlns:"http://www.w3.org/2000/svg",height:"480",width:"640",viewBox:"0 0 640 480"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{fillRule:"evenodd",strokeWidth:"1pt"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#e70011",d:"M0 0h639.958v248.947H0z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#fff",d:"M0 240h639.958v240H0z"})));};var HIN=function HIN(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{xmlns:"http://www.w3.org/2000/svg",height:"900",width:"1350",viewBox:"0 0 225 150"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"225",height:"150",fill:"#f93"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"225",height:"50",y:"50",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"225",height:"50",y:"100",fill:"#128807"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{transform:"translate(112.5,75)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{r:"20",fill:"#008"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{r:"17.5",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{r:"3.5",fill:"#008"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"d"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"c"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"b"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{id:"a"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{r:"0.875",fill:"#008",transform:"rotate(7.5) translate(17.5)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{fill:"#008",d:"M 0,17.5 0.6,7 C 0.6,7 0,2 0,2 0,2 -0.6,7 -0.6,7 L 0,17.5 z"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#a",transform:"rotate(15)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#b",transform:"rotate(30)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#c",transform:"rotate(60)"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#d",transform:"rotate(120)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#d",transform:"rotate(-120)"})));};var ESP=function ESP(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{xmlns:"http://www.w3.org/2000/svg",width:"30",height:"20",viewBox:"0 0 30 20"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"30",height:"20",fill:"#c60b1e"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"30",height:"10",transform:"translate(0 5)",fill:"#ffc400"}));};var CHN=function CHN(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{xmlns:"http://www.w3.org/2000/svg",width:"900",height:"600",viewBox:"0 0 30 20"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("defs",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{id:"s",d:"M0,-1 0.587785,0.809017 -0.951057,-0.309017H0.951057L-0.587785,0.809017z",fill:"#ffde00"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"30",height:"20",fill:"#de2910"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#s",transform:"translate(5,5) scale(3)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#s",transform:"translate(10,2) rotate(23.036243)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#s",transform:"translate(12,4) rotate(45.869898)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#s",transform:"translate(12,7) rotate(69.945396)"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("use",{xlinkHref:"#s",transform:"translate(10,9) rotate(20.659808)"}));};var TUR=function TUR(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{xmlns:"http://www.w3.org/2000/svg",width:"1200",height:"800",viewBox:"0 0 1200 800"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("rect",{width:"1200",height:"800",fill:"#E30A17"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{cx:"425",cy:"400",r:"200",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("circle",{cx:"475",cy:"400",r:"160",fill:"#E30A17"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("polygon",{points:"583.334,400 764.235,458.779 652.431,304.894 652.431,495.106 764.235,341.221",fill:"#fff"}));};var ARA=function ARA(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{as:"img",src:__WEBPACK_IMPORTED_MODULE_2__images_flag_of_the_Arab_League_png___default.a,alt:""});};

/***/ }),
/* 1493 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAWCAYAAABOm/V6AAAACXBIWXMAAC4jAAAuIwF4pT92AAADiklEQVR42sWWX0zTVxTH22KyRFmMmYmLLiogCgWqA9xgzgBbiA4WTFT8Q4vQYh0tnYQ/AlqshqwyxBb/UCuwIiDKPzspk47sZS4suGW+bHva+94Wswf/JMaHz+7vFoUR/1Qp28PJ+d1zvufe7z33d8+5KpUpjf9dXi8wFZUxLSRzv/8zEsaZxTRl6aiFzLUvLAm5UHpIG1JQ6bUhPdu+YCSmJ9eUbUZVrCXalEHFmUb0p6qwtTmINr4v7Ekh/6tmJVwCMuXGd1Ht38BKSw5HLp7mxugY3v7LBCe+o+qck5XWj6RfwYXwqREgoUzyJM3FySwxZ2BzObg03EtTVyO5jjziLMnkHv+Epq8ceIVd8Ss4Bf/0eF5G5mUs1Yo+oGNVRQ7nr/i4eL2ThM+TeaNsvVhI2bWOKNNGokpjSDicQvtIJxcEbpU1R8apI5EJZZKo4hTq2ptxXfHwjiWOtw5nseHYHhLthRScr2aXp54PnGaW2bYI/zpa+zzUeZplnDqc/+PFJNJkWtfXFjAUCKC1vUf2l/vY7q5Cd7yQjC9KKPWdRGvfTV6bTRCqI6t5N4kCp+DjawpCx2KcRybUypkatOSfOETP8AAxFUmcDHjFro183FqO82Y3+g47RUJqhtqEbsTuP0usLYXuoQHyHWYZL+d5XRJKIVLpE8k/ZeXy14MsNa3m2k/jYteVrKn9lKaxLqoH3bQEe8lqMVN5zUX/VEDg1tDtHxRxFhmvKUufTyaELtGx2pJL3/UR4m2pmLqqefDoMdtcVrRHd4rjMRNfv4PiTjt/3buH2VdNbEUafSMjMk6JV8/7ipZsYumhLfQGhjnR0cKbxrfxTfq5e/8+V6fGqbnaSs/kGH8/fEjPj37pd3Scpk/glTglfp4/5nSR0iewtaGIqds/c8BdyZKSFRR5yhn/9Ra///kH3/72gxh/RrSwG1yV3Ba4Dxv0Mi6sohVWtRSySIjBXcs3ExOcG/aR59zDWlGoYqw6YoTeLsZnhf2m8BtctRKvDqdQhVe2U2euWGEsmfX7+eXOHYKT3zNww8/oRFDq4OQtac+s3ydwcTNX3BQJErPeDJrSTSy3ZHNptB9nhxtLcwNHvE1SK2OvsC8vz5a4f701ItXAnohGufP6JBYfzERVKhra3nVSy7Gwa2b3i4g0sOccz9OOKr41BzdP73i6c5oW/D3xjB3O/Z6NW9g3ZmTlH0A3AF9rqBHdAAAAAElFTkSuQmCC"

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Hamburger__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__VerificationStatus__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tournaments_Api__ = __webpack_require__(14);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background-color: ",";\n  width: 100%;\n\n  @media (min-width: 960px) {\n    border-left: 1px solid ",";\n  }\n"],["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background-color: ",";\n  width: 100%;\n\n  @media (min-width: 960px) {\n    border-left: 1px solid ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  display: block;\n  text-decoration: none;\n  padding-top: 25px;\n  padding-bottom: 26px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding-top: 17px;\n    padding-bottom: 16px;\n\n    ",";\n  }\n"],["\n  direction: ",";\n  display: block;\n  text-decoration: none;\n  padding-top: 25px;\n  padding-bottom: 26px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding-top: 17px;\n    padding-bottom: 16px;\n\n    ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n        padding-left: 20px;\n        padding-right: 68px;\n        text-align: right;\n      "],["\n        padding-left: 20px;\n        padding-right: 68px;\n        text-align: right;\n      "]),_templateObject4=_taggedTemplateLiteral(["\n      padding-right: 20px;\n      padding-left: 68px;\n      text-align: left;\n    "],["\n      padding-right: 20px;\n      padding-left: 68px;\n      text-align: left;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n          padding-left: 17px;\n          margin-right: 48px;\n          padding-right: 0;\n        "],["\n          padding-left: 17px;\n          margin-right: 48px;\n          padding-right: 0;\n        "]),_templateObject6=_taggedTemplateLiteral(["\n        padding-right: 17px;\n        margin-left: 48px;\n        padding-left: 0;\n      "],["\n        padding-right: 17px;\n        margin-left: 48px;\n        padding-left: 0;\n      "]),_templateObject7=_taggedTemplateLiteral(["\n\n"],["\n\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.2;\n  color: ",";\n  margin-bottom: 7px;\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n  min-width: 0;\n  font-size: 14px;\n  line-height: 1.2;\n  color: ",";\n  margin-bottom: 7px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  align-self: flex-start;\n  flex-basis: 100%;\n  min-width: 0;\n  max-width: 187px;\n  line-height: 1.2;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: ",";\n  margin-bottom: 6px;\n  font-size: 14px;\n  display: inline-block;\n  text-decoration: none;\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  align-self: flex-start;\n  flex-basis: 100%;\n  min-width: 0;\n  max-width: 187px;\n  line-height: 1.2;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  color: ",";\n  margin-bottom: 6px;\n  font-size: 14px;\n  display: inline-block;\n  text-decoration: none;\n"]),_templateObject10=_taggedTemplateLiteral(["\n"],["\n"]),_templateObject11=_taggedTemplateLiteral(["\n  color: #a7a7a7;\n  vertical-align: middle;\n  display: flex;\n  align-items: center;\n"],["\n  color: #a7a7a7;\n  vertical-align: middle;\n  display: flex;\n  align-items: center;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  font-size: 12px;\n\n  ",";\n\n  ","\n"],["\n  font-size: 12px;\n\n  ",";\n\n  ","\n"]),_templateObject13=_taggedTemplateLiteral(["\n          margin-right: 8px;\n        "],["\n          margin-right: 8px;\n        "]),_templateObject14=_taggedTemplateLiteral(["\n        margin-left: 8px;\n      "],["\n        margin-left: 8px;\n      "]),_templateObject15=_taggedTemplateLiteral(["\n      color: #e74c3c;\n    "],["\n      color: #e74c3c;\n    "]),_templateObject16=_taggedTemplateLiteral(["\n      color: #FFCC00;\n    "],["\n      color: #FFCC00;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n      color: #60a21d;\n    "],["\n      color: #60a21d;\n    "]),_templateObject18=_taggedTemplateLiteral(["\n      color: inherit;\n    "],["\n      color: inherit;\n    "]),_templateObject19=_taggedTemplateLiteral(["\n  line-height: 0;\n"],["\n  line-height: 0;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 21px;\n  color: #3B9478;\n  ",";\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  position: absolute;\n  top: 21px;\n  color: #3B9478;\n  ",";\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject21=_taggedTemplateLiteral(["\n        right: 38px;\n      "],["\n        right: 38px;\n      "]),_templateObject22=_taggedTemplateLiteral(["\n      left: 38px;\n    "],["\n      left: 38px;\n    "]),_templateObject23=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  margin-left: 0;\n  margin-right: 0;\n  color: ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: 16px;\n  margin-left: 0;\n  margin-right: 0;\n  color: ",";\n\n  ",";\n"]),_templateObject24=_taggedTemplateLiteral(["\n        right: 10px;\n      "],["\n        right: 10px;\n      "]),_templateObject25=_taggedTemplateLiteral(["\n      left: 10px;\n    "],["\n      left: 10px;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.mainHighlight;},function(_ref){var theme=_ref.theme;return theme.navigationBg;});var ProfileLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject2,function(_ref2){var theme=_ref2.theme;return theme.direction;},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref4){var theme=_ref4.theme;return theme.foreground;},function(_ref5){var theme=_ref5.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject3);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4);},function(_ref6){var theme=_ref6.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6);});var FlexContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7);var ProfileID=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].h2(_templateObject8,function(_ref7){var theme=_ref7.theme;return theme.navigationId;});var Email=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject9,function(_ref8){var theme=_ref8.theme;return theme.navigationUserName;});var ProfileInfo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10);var VerificationWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject11);var VerificationText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject12,function(_ref9){var theme=_ref9.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject13);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject14);},function(props){return props.status===0||props.status===3?Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject15):props.status===1?Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject16):props.status===2?Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject17):Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject18);});var VerificationIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject19);var ProfileIcon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].i(_templateObject20,function(_ref10){var theme=_ref10.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject21);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject22);});var NavWrapper=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__Hamburger__["a" /* default */])(_templateObject23,function(_ref11){var theme=_ref11.theme;return theme.navigationUserName;},function(_ref12){var theme=_ref12.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject24);}return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject25);});function User(props){var api=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__Tournaments_Api__["c" /* default */]);var features=api.readEntity("/api/features/list");var voluntaryVerification=features.status==="Pending"?null:features.value&&features.value.find(function(feature){return feature.name==="voluntary_verification";});var onProfileClick=function onProfileClick(){if(window.location.pathname.indexOf("/profile")===0){props.onClick();}};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NavWrapper,{onClick:props.onClick});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProfileLink,{to:"/profile",onClick:onProfileClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProfileIcon,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons__["e" /* PersonIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FlexContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Email,null,props.email),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProfileInfo,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProfileID,{hideLangSelect:props.hideLangSelect},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Profile id")," ",props.id),(voluntaryVerification===undefined||props.status===__WEBPACK_IMPORTED_MODULE_9__VerificationStatus__["a" /* VERIFICATION_STATUS_APPROVED */])&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerificationWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerificationIcon,null,Object(__WEBPACK_IMPORTED_MODULE_9__VerificationStatus__["c" /* getVerificationStatusIcon */])(props.status)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](VerificationText,{status:props.status},Object(__WEBPACK_IMPORTED_MODULE_9__VerificationStatus__["d" /* getVerificationStatusText */])(props.status)))))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__withData__["a" /* default */])(["apiConfigs"])(Object(__WEBPACK_IMPORTED_MODULE_5__common_withDeposit__["b" /* withDeposit */])(User)));

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Desktop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Mobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
function Desktop(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?children:null;});}function Mobile(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?children:null;});}

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 34px;\n  left: -24px;\n  width: auto;\n  white-space: nowrap;\n  padding: ","px;\n  font-family: Tahoma, sans-serif;\n  font-size: ",";\n  line-height: 1;\n  color: #717171;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 0 1.5px rgb(207, 207, 207), 0 3px 8px rgba(0, 0, 0, .25);\n  z-index: 100;\n  :after {\n    content: \"\";\n    width: 0px;\n    height: 0px;\n    position: absolute;\n    bottom: -12px;\n    left: 21.5px;\n    background-color: transparent;\n    border: 11px solid transparent;\n    border-top: 12px solid #fff;\n    border-bottom: none;\n  }\n  :before {\n    content: \"\";\n    width: 0px;\n    height: 0px;\n    position: absolute;\n    bottom: -14px;\n    left: 19px;\n    background-color: transparent;\n    border: 14px solid transparent;\n    border-top: 14px solid rgb(207, 207, 207);\n    border-bottom: none;\n  }\n"],["\n  position: absolute;\n  bottom: 34px;\n  left: -24px;\n  width: auto;\n  white-space: nowrap;\n  padding: ","px;\n  font-family: Tahoma, sans-serif;\n  font-size: ",";\n  line-height: 1;\n  color: #717171;\n  background-color: #fff;\n  border-radius: 5px;\n  box-shadow: 0 0 0 1.5px rgb(207, 207, 207), 0 3px 8px rgba(0, 0, 0, .25);\n  z-index: 100;\n  :after {\n    content: \"\";\n    width: 0px;\n    height: 0px;\n    position: absolute;\n    bottom: -12px;\n    left: 21.5px;\n    background-color: transparent;\n    border: 11px solid transparent;\n    border-top: 12px solid #fff;\n    border-bottom: none;\n  }\n  :before {\n    content: \"\";\n    width: 0px;\n    height: 0px;\n    position: absolute;\n    bottom: -14px;\n    left: 19px;\n    background-color: transparent;\n    border: 14px solid transparent;\n    border-top: 14px solid rgb(207, 207, 207);\n    border-bottom: none;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IconTip=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.small?10:23;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Tooltipy=function(_Component){_inherits(Tooltipy,_Component);function Tooltipy(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,Tooltipy);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=Tooltipy.__proto__||Object.getPrototypeOf(Tooltipy)).call.apply(_ref2,[this].concat(args))),_this),_this.state={showTooltip:false},_this.onHover=function(){_this.setState({showTooltip:true});},_this.onUnhover=function(){_this.setState({showTooltip:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tooltipy,[{key:"render",value:function render(){var _props=this.props,tooltip=_props.tooltip,small=_props.small,children=_props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,this.state.showTooltip&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconTip,{small:small},tooltip),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{onMouseOver:this.onHover,onMouseLeave:this.onUnhover},children));}}]);return Tooltipy;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Tooltipy);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ItemView */
/* unused harmony export IconView */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Language__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icons__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Bell_Labels__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Bell__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Bell_helpers__ = __webpack_require__(1548);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  padding: 14px 21px;\n  background-color: ",";\n  color: ",";\n  overflow: hidden;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  padding: 14px 21px;\n  background-color: ",";\n  color: ",";\n  overflow: hidden;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n        padding-right: 28px;\n        padding-left: 11px;\n      "],["\n        padding-right: 28px;\n        padding-left: 11px;\n      "]),_templateObject3=_taggedTemplateLiteral(["\n      padding-left: 28px;\n      padding-right: 11px;\n    "],["\n      padding-left: 28px;\n      padding-right: 11px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  padding-right: ",";\n  padding-left: ",";\n"],["\n  position: relative;\n  padding-right: ",";\n  padding-left: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  padding: 7px 0 10px;\n  height: auto;\n"],["\n  padding: 7px 0 10px;\n  height: auto;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-bottom: 3px;\n  color: inherit;\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  margin-bottom: 3px;\n  color: inherit;\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      color: ",";\n      background-color: ",";\n    "],["\n      color: ",";\n      background-color: ",";\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  padding: 9px;\n  font-size: ",";\n  line-height: 19px;\n  color: ",";\n  text-decoration: none;\n\n  ",";\n\n  :hover,\n  :focus {\n    color: ",";\n    text-decoration: none;\n    outline: none;\n  }\n"],["\n  padding: 9px;\n  font-size: ",";\n  line-height: 19px;\n  color: ",";\n  text-decoration: none;\n\n  ",";\n\n  :hover,\n  :focus {\n    color: ",";\n    text-decoration: none;\n    outline: none;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n        padding-right: 14px;\n        padding-left: 11px;\n      "],["\n        padding-right: 14px;\n        padding-left: 11px;\n      "]),_templateObject10=_taggedTemplateLiteral(["\n      padding-left: 14px;\n      padding-right: 11px;\n    "],["\n      padding-left: 14px;\n      padding-right: 11px;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 19px;\n  height: 19px;\n  color: ",";\n  backface-visibility: hidden;\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 19px;\n  height: 19px;\n  color: ",";\n  backface-visibility: hidden;\n\n  ",";\n\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n        margin-left: 10px;\n      "],["\n        margin-left: 10px;\n      "]),_templateObject13=_taggedTemplateLiteral(["\n      margin-right: 10px;\n    "],["\n      margin-right: 10px;\n    "]),_templateObject14=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 100%;\n  padding: 6px;\n  font-size: ",";\n  line-height: 1;\n  text-align: left;\n  text-decoration: none;\n  color: ",";\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus {\n    color: ",";\n    text-decoration: none;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: 100%;\n  padding: 6px;\n  font-size: ",";\n  line-height: 1;\n  text-align: left;\n  text-decoration: none;\n  color: ",";\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus {\n    color: ",";\n    text-decoration: none;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n        padding-right: 41px;\n        padding-left: 15px;\n      "],["\n        padding-right: 41px;\n        padding-left: 15px;\n      "]),_templateObject17=_taggedTemplateLiteral(["\n      padding-left: 41px;\n      padding-right: 15px;\n    "],["\n      padding-left: 41px;\n      padding-right: 15px;\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  padding: 9px;\n  line-height: 19px;\n\n  ",";\n"],["\n  padding: 9px;\n  line-height: 19px;\n\n  ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%) rotate(0deg);\n    transform-origin: 50%;\n    margin-top: 1px;\n    border: 4px solid transparent;\n    border-top: 6px solid ",";\n    border-bottom: none;\n    transition: transform 0.3s ease;\n    backface-visibility: hidden;\n\n    ",";\n  }\n\n  ",";\n"],["\n  position: relative;\n  cursor: pointer;\n  user-select: none;\n\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%) rotate(0deg);\n    transform-origin: 50%;\n    margin-top: 1px;\n    border: 4px solid transparent;\n    border-top: 6px solid ",";\n    border-bottom: none;\n    transition: transform 0.3s ease;\n    backface-visibility: hidden;\n\n    ",";\n  }\n\n  ",";\n"]),_templateObject20=_taggedTemplateLiteral(["\n          left: 11px;\n        "],["\n          left: 11px;\n        "]),_templateObject21=_taggedTemplateLiteral(["\n        right: 11px;\n      "],["\n        right: 11px;\n      "]),_templateObject22=_taggedTemplateLiteral(["\n      :after {\n        transform: translateY(-50%) rotate(-180deg);\n      }\n    "],["\n      :after {\n        transform: translateY(-50%) rotate(-180deg);\n      }\n    "]),_templateObject23=_taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  background-color: #0085eb;\n  min-width: 20px;\n  padding: 0 5px;\n  border-radius: 5px 5px 5px 0;\n  color: #fff;\n  text-align: center;\n  font-size: ",";\n  font-weight: 400;\n"],["\n  flex: 0 0 auto;\n  background-color: #0085eb;\n  min-width: 20px;\n  padding: 0 5px;\n  border-radius: 5px 5px 5px 0;\n  color: #fff;\n  text-align: center;\n  font-size: ",";\n  font-weight: 400;\n"]),_templateObject24=_taggedTemplateLiteral(["\n  flex-grow: 1;\n"],["\n  flex-grow: 1;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var isEztrader="irontrade"==="eztrader";var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.navigationBg;},function(_ref2){var theme=_ref2.theme;return theme.navigationItemColor;},function(_ref3){var theme=_ref3.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var ScrollableInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.direction==="rtl"?0:"15px";},function(_ref5){var theme=_ref5.theme;return theme.direction==="rtl"?"15px":0;});var Submenu=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var ItemView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,function(_ref6){var theme=_ref6.theme;return theme.navigationItemColor;},function(props){return props.theme.navigationItemActiveBg;});});var StyledItemView=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(ItemView)(_templateObject8,function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref8){var theme=_ref8.theme;return theme.navigationItemColor;},function(_ref9){var theme=_ref9.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.theme.accent;});var IconView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].i(_templateObject11,function(_ref10){var theme=_ref10.theme;return theme.navigationItemIcon;},function(_ref11){var theme=_ref11.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14,function(_ref12){var theme=_ref12.theme;return theme.navigationItemIconActive;});});var StyledLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["c" /* OptionalLink */])(_templateObject15,function(_ref13){var theme=_ref13.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref14){var theme=_ref14.theme;return theme.navigationItemColor;},function(_ref15){var theme=_ref15.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject16);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);},function(props){return props.theme.accent;});var StyledItemLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(StyledLink)(_templateObject18,function(_ref16){var theme=_ref16.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);});var SupportItem=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(StyledItemView)(_templateObject19,function(_ref17){var theme=_ref17.theme;return theme.staticHeaderLink;},function(_ref18){var theme=_ref18.theme;if(theme.direction==="rtl"){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject20);}return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject21);},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject22);});var Indicator=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject23,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12));var MenuTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject24);function Item(_ref19){var pathname=_ref19.pathname,href=_ref19.href,externalHref=_ref19.externalHref,title=_ref19.title,Icon=_ref19.Icon,indicator=_ref19.indicator,onClick=_ref19.onClick,bellActive=_ref19.bellActive,rest=_objectWithoutProperties(_ref19,["pathname","href","externalHref","title","Icon","indicator","onClick","bellActive"]);var isActive=bellActive?false:pathname===href;var isNews=href==="/news";var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_17__Tournaments_Api__["c" /* default */]);var news=isNews&&__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/helpdesk/api/news"),function(n){return n.value.data;});var newsTimestamp=isNews&&__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/news"),function(n){return n.value;});if(isNews&&(news==null||newsTimestamp==null)){return null;}var new_news_count=0;if(isNews){new_news_count=Object(__WEBPACK_IMPORTED_MODULE_19__Bell_helpers__["a" /* allNews */])({news:news,lastViewTimestamp:newsTimestamp.lastViewTimestamp});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemView,{active:isActive,onClick:function(_onClick){function onClick(_x){return _onClick.apply(this,arguments);}onClick.toString=function(){return _onClick.toString();};return onClick;}(function(e){Object(__WEBPACK_IMPORTED_MODULE_15__GA__["a" /* gaReducer */])("CLICKLINK_NAVIGATION",{linkUrl:href,linkText:e.currentTarget.textContent});return isActive?onClick():null;})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledItemLink,Object.assign({to:externalHref?null:href,href:externalHref},rest),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconView,{active:isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MenuTitle,null,title),indicator&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Indicator,null,indicator),isNews&&new_news_count>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Indicator,null,new_news_count)));}function ItemTournaments(props){var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_17__Tournaments_Api__["c" /* default */]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){api.fetchEntity("/api/bell-tolls-items");},[]);var invitations=Object(__WEBPACK_IMPORTED_MODULE_16__Bell_Labels__["b" /* useRelevantTournamentInvitationsCount */])();if(invitations==null||invitations===0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,props);}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,Object.assign({},props,{indicator:invitations}));}}function ItemFillup(props){var promocode=Object(__WEBPACK_IMPORTED_MODULE_16__Bell_Labels__["c" /* useSuggestedPromoCode */])();if(promocode==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,Object.assign({},props,{href:"/fillup"}));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,Object.assign({},props,{href:"/fillup?promocode="+promocode,indicator:"%"}));}}function SimpleLink(props){var isActive=props.pathname===props.href;return isActive?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{as:"div",onClick:props.onClick},props.title):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{to:props.href},props.title);}function Menu(props){var location=props.location,locale=props.locale,onClick=props.onClick,isLoggedIn=props.isLoggedIn,showDeposit=props.showDeposit,isRealAcc=props.isRealAcc;var pathname=location.pathname;var items=[{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Trading"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["j" /* TradingIcon */],href:"/trade"},{component:ItemTournaments,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Tournaments"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["h" /* TournamentsIcon */],href:"/tournaments",show:!isEztrader},{component:__WEBPACK_IMPORTED_MODULE_18__Bell__["a" /* default */]},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Trading history"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["i" /* TradingHistoryIcon */],href:"/trading-history"},{component:ItemFillup,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Deposit"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["a" /* DepositeIcon */],href:"/fillup",showDeposit:showDeposit},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Withdrawal"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["l" /* WithdrawIcon */],href:"/withdraw",showDeposit:showDeposit},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Financial history"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["k" /* WithdrawHistoryIcon */],href:"/finance-history",showDeposit:showDeposit},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"News"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["d" /* NewsIcon */],href:__WEBPACK_IMPORTED_MODULE_4__common_fetch__["a" /* NEWS_LINK */]?__WEBPACK_IMPORTED_MODULE_4__common_fetch__["a" /* NEWS_LINK */]:"/news",externalHref:__WEBPACK_IMPORTED_MODULE_4__common_fetch__["a" /* NEWS_LINK */]+("?lang="+Object(__WEBPACK_IMPORTED_MODULE_5__common_Link__["d" /* getCompleteLocale */])(locale)),show:!isEztrader,showDeposit:showDeposit},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Help Center"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["b" /* HelpCenterIcon */],href:"/helpdesk",showDeposit:showDeposit}];var simpleItems=[{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Analytics"),href:"/analytics",show:isRealAcc},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Video Tutorial"),href:"/helpdesk/video"},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"FAQ"),href:"/helpdesk/faq"},{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"About us"),href:"/helpdesk/safety#about"}];var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isSubmenuOpen=_useState2[0],setIsSubmenuOpen=_useState2[1];var submenuRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();var toggleOpen=function toggleOpen(){setIsSubmenuOpen(!isSubmenuOpen);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(isSubmenuOpen){submenuRef.current.scrollIntoView({block:"nearest",behavior:"smooth"});}},[isSubmenuOpen]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Scrollable__["a" /* default */],{disableOverflow:props.bellActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ScrollableInner,null,locale&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Language__["b" /* default */],{locale:locale,locales:props.apiConfigs.locales,showLoader:!!props.changeLocaleFetching,onLocaleChange:props.onLocaleChange,hideLangSelect:props.hideLangSelect}),items.map(function(item,i){var ItemComponent=item.component||Item;if(item.show!==undefined&&item.show===false){return null;}if(item.showDeposit!==undefined&&item.showDeposit===false){return null;}if(__WEBPACK_IMPORTED_MODULE_11__FeatureFlags__["a" /* default */].enableTournaments===false){if(item.href==="/tournaments"){return null;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemComponent,{key:i,pathname:pathname,onClick:onClick,title:item.title,Icon:item.Icon,href:item.href,externalHref:item.externalHref,bellActive:props.bellActive,onBellClick:props.onBellClick});}),!isEztrader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SupportItem,{active:isSubmenuOpen,onClick:toggleOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconView,{active:isSubmenuOpen},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Icons__["g" /* SupportIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Education / Support")),isSubmenuOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Submenu,{ref:submenuRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StyledLink,{to:"/sightseeing",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_15__GA__["a" /* gaReducer */])("ACTIVATE_TOUR_FROM_SIDEBAR");if(__WEBPACK_IMPORTED_MODULE_12__utils__["d" /* isIronTerminalIosApp */]){e&&e.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_12__utils__["a" /* iOSAppPostMessage */])("gotoTutorial");}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Start Welcome Tour")),simpleItems.map(function(item,i){if(item.show!==undefined&&item.show===false){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SimpleLink,{key:i,title:item.title,href:item.href,onClick:onClick,pathname:pathname});}))),isLoggedIn===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{pathname:pathname,href:"/logout",replace:true,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Logout"),Icon:__WEBPACK_IMPORTED_MODULE_14__Icons__["f" /* QuitIcon */]}))));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_10__withData__["a" /* default */])(["apiConfigs"])(Object(__WEBPACK_IMPORTED_MODULE_8__common_withDeposit__["b" /* withDeposit */])(Menu))));

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Bell__ = __webpack_require__(825);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Bell__["a" /* default */]);

/***/ }),
/* 1499 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(76),
    now = __webpack_require__(1500),
    toNumber = __webpack_require__(307);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 1500 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(48);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemInfo__ = __webpack_require__(1502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemTournament__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ItemNews__ = __webpack_require__(1508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ItemAdvice__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemCongratulations__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ButtonTradeReal__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ButtonSubscribe__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Tournaments_Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Tournaments_Account_Card_ButtonSwitcher__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ItemNotification__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Icons_Coupon__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icons_Compensation__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GA__ = __webpack_require__(11);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function List(_ref){var _this=this;var announcements=_ref.announcements,api=_ref.api,onJoinClick=_ref.onJoinClick,close=_ref.close,dispatch=_ref.dispatch,props=_objectWithoutProperties(_ref,["announcements","api","onJoinClick","close","dispatch"]);if(announcements==null){// такого как бы быть не может
return"YOU SPIN ME RIGHT ROUND BABY RIGHT ROUND";}if(announcements.length<1){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["d" /* News */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"No new announcements"));}return announcements.map(function(item,index){switch(item.type){case"tournament":case"invited-tournament":if(false){return null;}var isCompleted=Object(__WEBPACK_IMPORTED_MODULE_15__Tournaments_Timer__["e" /* getCompleted */])(Object.assign({time:props.time},item.info));if(item.info["2x_demo_balance_invite"]&&item.info.participation_status!==1){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ItemCongratulations__["a" /* default */],{key:item.type+item.info.id+index,tournament:item.info});}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ItemTournament__["a" /* default */],Object.assign({key:item.type+item.info.id+index},item.info,props),isCompleted?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"The tournament is finished"):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref2){var showModal=_ref2.showModal;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Tournaments_Account_Card_ButtonSwitcher__["a" /* default */],Object.assign({},item.info,{onTradeClick:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var activate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_TOURNAMENT",{type:"trade"});_context.next=3;return api.fetchEntity("/api/tournaments/activate?id="+id);case 3:activate=_context.sent;if(!(activate!==null)){_context.next=11;break;}api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");_context.next=9;return api.fetchEntity("/api/tournaments/stats");case 9:dispatch({type:"ENGAGE_TOURNAMENT_MODE"});close();case 11:case"end":return _context.stop();}}},_callee,_this);}));return function(_x){return _ref3.apply(this,arguments);};}(),onActiveTradeClick:function onActiveTradeClick(){Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_TOURNAMENT",{type:"trade"});close();props.history.push("/trade");},onJoinClick:function onJoinClick(){props.history.push("/tournaments/"+item.info.id);Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_TOURNAMENT",{type:"join"});},flat:true,forBell:true}));}));case"news":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ItemNews__["a" /* default */],Object.assign({key:item.type+item.news.slug},item.news));case"verification":if(item.info.status==="success"){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["f" /* VerificationSuccess */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Congratulations! You've successfully passed verification!"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ButtonTradeReal__["a" /* default */],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_SUCCESS_VERIFICATION");close();}})},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Now withdrawal of funds and trading on a real account become available!"));}if(item.info.status==="additional_verifiaction"){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["e" /* VerificationError */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Additional verification is necessary!"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* Button */],{type:"trade",to:"/verification",onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Check out"))},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Please check the verification page."));}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["e" /* VerificationError */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Verification has been refused"),details:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["b" /* Link */],{to:"/helpdesk/faq#verification",onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"What can I do?")),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* Button */],{type:"trade",to:"/verification",onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Try again"))},item.info&&item.info.message);case"deposit":if(item.info.status==="success"){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["b" /* DepositSuccess */],null)// prettier-ignore
,title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You've received funds in the amount of ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["c" /* Money */],{currency:item.info.currency||null},item.info.amount||300),"!"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ButtonTradeReal__["a" /* default */],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_SUCCESS_DEPOSIT");close();}})});}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["a" /* DepositError */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Your deposit was not credited to your account"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* Button */],{type:"trade",to:"/fillup",onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Try again"))},item.info&&item.info.message);case"withdraw":if(item.info.status==="success"){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["h" /* WithdrawSuccess */],null)// prettier-ignore
,title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"The funds in the amount of ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["c" /* Money */],{currency:item.info.currency||null},item.info.amount||300)," have been successfully withdrawn!"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__ButtonTradeReal__["a" /* default */],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_SUCCESS_WITHDRAWAL");close();}})});}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["g" /* WithdrawError */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Unfortunately, your withdrawal request has been refused."),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* Button */],{type:"trade",to:"/withdraw",onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Try again"))},item.info&&item.info.message);case"unconfirmed_push_subscription":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["d" /* PushSubscription */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Still not receiving our push notifications about the most important events on our platform?"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* Button */],{type:"trade",to:"/helpdesk/skilled#news_emails",onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"How to subscribe?"))},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Act fast and subscribe!"));case"unconfirmed_email_subscription":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ItemInfo__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Icons_Announcements__["c" /* EmailSubscription */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Still not receiving our e-mails about the most important events on our platform?"),action:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__ButtonSubscribe__["a" /* default */],{onClick:function onClick(){return close();}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["f" /* Subscribe */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"SUBSCRIBE")))},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Act fast and subscribe!")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"We have prepared strategies, trading signals and more for your successful trading."));case"promocode":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__ItemNotification__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Icons_Coupon__["a" /* default */],null),title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["b" /* Link */],{to:"/fillup?promocode="+item.info.code,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_PROMO");}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"We give you a promo code for the special bonus on depositing."))});case"compensations":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__ItemNotification__["a" /* default */],{key:item.type+item.timestamp+index,timestamp:item.timestamp,icon:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__Icons_Compensation__["a" /* default */],null)// prettier-ignore
,title:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["b" /* Link */],{to:"/trade",onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_20__GA__["a" /* gaReducer */])("BELL_GO_TO_SAFE_DEALS");}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You have been granted ",item.info.used+item.info.available," safe trades."))});case"2x_demo_money":return  true?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ItemAdvice__["a" /* default */],{key:item.type+item.timestamp+index,api:api}):null;default:return null;}});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_15__Tournaments_Timer__["i" /* mapStateToTime */])(List)));

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  align-content: stretch;\n  justify-content: space-between;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  align-content: stretch;\n  justify-content: space-between;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n"],["\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: flex-start;\n  width: 90px;\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: flex-start;\n  width: 90px;\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-bottom: 11px;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-bottom: 11px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: ",";\n"],["\n  margin-bottom: 16px;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n"],["\n  flex-grow: 1;\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  min-height: 33px;\n  margin-top: auto;\n  font-size: ",";\n  line-height: 1.5;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  min-height: 33px;\n  margin-top: auto;\n  font-size: ",";\n  line-height: 1.5;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var News=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Item__["d" /* News */])(_templateObject);var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var Sidebar=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-left","14px"));var Icon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14),function(_ref){var theme=_ref.theme;return theme.indexMajor;});var Info=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12),function(_ref2){var theme=_ref2.theme;return theme.textMuted;});var Action=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var ItemInfo=function ItemInfo(_ref3){var icon=_ref3.icon,action=_ref3.action,title=_ref3.title,children=_ref3.children,details=_ref3.details,timestamp=_ref3.timestamp;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](News,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Item__["g" /* Timestamp */],null,__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(timestamp).format("lll")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,null,children),details&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Action,null,details)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sidebar,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null,icon),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Action,null,action)));};/* harmony default export */ __webpack_exports__["a"] = (ItemInfo);

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tournaments_Sticker__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GA__ = __webpack_require__(11);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  flex-flow: row nowrap;\n  font-size: ",";\n  line-height: 1.2;\n  color: #919191;\n"],["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  flex-flow: row nowrap;\n  font-size: ",";\n  line-height: 1.2;\n  color: #919191;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex: 1;\n"],["\n  flex: 1;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-end;\n  flex-grow: 0;\n  flex-shrink: 0;\n  /* flex-basis: 163px;*/\n  max-width: 163px;\n  padding-top: 15px;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-end;\n  flex-grow: 0;\n  flex-shrink: 0;\n  /* flex-basis: 163px;*/\n  max-width: 163px;\n  padding-top: 15px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  flex: 1;\n  width: 100%;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 72px;\n  align-self: flex-start;\n  width: 72px;\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 72px;\n  align-self: flex-start;\n  width: 72px;\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 20px;\n  width: 20px;\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 20px;\n  width: 20px;\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-top: 15px;\n"],["\n  margin-top: 15px;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n"],["\n  display: flex;\n  flex-direction: column;\n  margin-top: 15px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-bottom: 5px;\n"],["\n  margin-bottom: 5px;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-size: ",";\n"],["\n  font-size: ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-weight: 700;\n  color: ",";\n"],["\n  font-weight: 700;\n  color: ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  font-weight: 700;\n  color: #343434;\n"],["\n  font-weight: 700;\n  color: #343434;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: flex-end;\n  min-height: 33px;\n  margin-top: auto;\n  padding-top: 15px;\n  max-width: 200px;\n\n  ",";\n\n  button {\n    width: 100%;\n    margin: 0;\n    min-height: 37px;\n  }\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: flex-end;\n  min-height: 33px;\n  margin-top: auto;\n  padding-top: 15px;\n  max-width: 200px;\n\n  ",";\n\n  button {\n    width: 100%;\n    margin: 0;\n    min-height: 37px;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n      min-height: 37px;\n      padding-top: 0;\n      align-items: center;\n    "],["\n      min-height: 37px;\n      padding-top: 0;\n      align-items: center;\n    "]),_templateObject15=_taggedTemplateLiteral([""],[""]),_templateObject16=_taggedTemplateLiteral(["\n  color: #3b9478;\n  text-decoration: none;\n"],["\n  color: #3b9478;\n  text-decoration: none;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  color: #3b9478;\n  font-size: ",";\n  font-weight: 700;\n  margin-bottom: 15px;\n  text-decoration: none;\n"],["\n  color: #3b9478;\n  font-size: ",";\n  font-weight: 700;\n  margin-bottom: 15px;\n  text-decoration: none;\n"]),_templateObject18=_taggedTemplateLiteral(["\n  background-color: #0085eb;\n  color: #fff;\n  font-size: ",";\n  height: 37px;\n  width: 100%;\n  border-radius: 19px;\n  border: 0;\n  margin: 0;\n  padding: 0 10px;\n  font-weight: 700;\n  cursor: pointer;\n  text-transform: uppercase;\n"],["\n  background-color: #0085eb;\n  color: #fff;\n  font-size: ",";\n  height: 37px;\n  width: 100%;\n  border-radius: 19px;\n  border: 0;\n  margin: 0;\n  padding: 0 10px;\n  font-weight: 700;\n  cursor: pointer;\n  text-transform: uppercase;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  display: flex;\n  min-height: 37px;\n  margin-top: auto;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  min-width: 72px;\n"],["\n  display: flex;\n  min-height: 37px;\n  margin-top: auto;\n  text-align: center;\n  justify-content: center;\n  align-items: center;\n  min-width: 72px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Item__["d" /* News */])(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(12,12));var Contents=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Side=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("margin-left","auto"));var LineCupIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["g" /* LineCup */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["c" /* rtl */])("margin-right","12px"));var InnerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var InnerFlexContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(InnerContainer)(_templateObject8);var PrizeFund=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var MoneyContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(14,14));var MoneySpan=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject11,function(_ref){var theme=_ref.theme;return theme.mode==="light"?theme.upper:theme.indexMajor;});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject12);var Time=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Text)(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(14,14));var Actions=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13,function(_ref2){var needInvitation=_ref2.needInvitation;return needInvitation&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14);});var InvititionWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var LinkInvitation=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Item__["b" /* Link */])(_templateObject16);var InvititionText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(12));var InvititionButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject18,Object(__WEBPACK_IMPORTED_MODULE_8__common_styled_mixins__["a" /* fontSize */])(12));var InvititionMore=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject19);function ItemTournament(props){var title=props.title,id=props.id,participation_status=props.participation_status,prize_fund=props.prize_fund,prize_fund_usd=props.prize_fund_usd,children=props.children;if(participation_status===1){return null;}// режим приглашения в турнир включаем у ограниченных турниров, в которые
// приглашен пользователь
var invitation=props.is_limited&&props.invited;var needInvitation=!(props.is_limited&&props.limited_for_money||props.invited);var gaEvent=function gaEvent(type){return function(){return Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("BELL_GO_TO_TOURNAMENT",{type:type});};};return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Contents,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LineCupIcon,null)," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Item__["h" /* TitleLink */],{to:"/tournaments/"+id,onClick:gaEvent("title")},title)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InnerFlexContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["c" /* default */],{days:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(props,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(props,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(props,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["f" /* getDuration */])(props,"seconds"),active:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["d" /* getActive */])(props),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["e" /* getCompleted */])(props),labelOnTop:true,flexDirection:"column",alignItems:"flex-start",noIcon:true,TimeStyle:Time,TextStyle:Text}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InnerFlexContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PrizeFund,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Prize fund"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__HowMuchInBucks__["a" /* default */],{value:prize_fund,valueUSD:prize_fund_usd,valueStyle:MoneySpan,symbolStyle:MoneySpan}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InnerContainer,null,invitation?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InvititionWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkInvitation,{to:"/tournaments/"+id,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("BELL_GO_TO_TOURNAMENT_INVITE");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InvititionText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"You have a special invitation for this tournament")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InvititionButton,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Use the invitation")))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Actions,{needInvitation:needInvitation},children))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Side,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["d" /* ColorfulCup */],{width:"72px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InvititionMore,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Item__["b" /* Link */],{to:"/tournaments/"+id,onClick:gaEvent("details")},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Details")))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Tournaments_Sticker__["a" /* default */],{limited:props.is_limited,isNew:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["g" /* getNew */])(props),active:Object(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Timer__["d" /* getActive */])(props),type:props.type,subtype:props.subtype}));}/* harmony default export */ __webpack_exports__["a"] = (ItemTournament);

/***/ }),
/* 1504 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1505 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1506 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1507 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArCAYAAAAOnxr+AAAEJUlEQVRYhc3Yb0xVdRjA8e+596LXP8FVIDQbYrVILXLNZTpNIiQKjMitFrW6tXm3EhU3TNcSN2xErFzXFzWLWptWRhOGmNlyQm+IEpIX9KI/Emytf+iYXfFeQO5p5/w4x0u75/6DA+fZzot7znPPPnvu83t+9xxJ3s4egtRi8ZBkN05uoAkotDLVJn1EAB+lBDmNDAkfrkxYUZz496McNkWrYocmgVWQO9vA0wQ5j5sH1bFXKUWOE6sgK9ogdRn0toP7KCzIMg+aEDYU+XkFvJ0Pw1fgoVfMhepYfwxtoCB3tUHaMmiogLNecDghGARnsvlQHTscpbKP7BPIr98SSCkJnvBCcgZcaL+ed+MdUwKVIo0EdXTNMhhdjtnwUjPcth7ON0LWvbAoG/q74PU1II9B0T4oqoL3nxQ5k4iIUB3roAkpDNaeBHk7IK9c3OrcMThZDSNXBbKkGvyXYdY8eG9y2KhQHWs3wIaL4nHkpX6ouQ8e3gsPbIPDiWMdsSQpPSu7KVWx0XYwDekbANcS0RrHKsS11KWi5xKImCqqhVpZWwTsmjLwfAx//QRv5MLGrbC5Ct7Mh5+/ETnLH4TB30VOHBF21RuFOg2ClAKnw6Z0HYeer2B+GqQsgpYDUP8s9HaI6ysLYOdJ2N0KGbebByUUG27Ojg7DoRLo64TKM3DzKvjuU3F+RQFsb4YkJ7gWwxzX5OdoTFgM5qyC8pbAb+fg1rXinILc0Qy+i/DPBehugd7vzYfGhD1YBGffHf+5m2HEDydeg/RboLFK5C3Jga1HICPbPKiOlQzaQNlKscPTXhi7JuCrt0DncRgJwIufwYFuWPcM7G2FlJvMg+pYuxF2DOoKoa4AgjLcuQkWZkJND6RmwsV+cZPuL2DwT3OhOtZh0AYK5pdvYVO5SB71w8FH4fLfkJ4FbfXwgQdkOfG9Pt5Q5+yowZxVhn3aUuj7AV4+BdkboHUcqUg2uGH1YyK3pRZ+7ZhYjKmEKqFihyNst9s+gXVPCWS9B2x22NUI92yGoUFR6cXZUFsAPWfMg+rYgAFWqWqeBxpeFZUs3g1lddB1Ag6/AFcuQXWHaIX9a82FTsBG+2/wzh8QvAaVKyHgA8kONZ1gs8Geu/W0KVlM4UJdYM4YnhSc8+H8KfD7xOct+yFrFfzYat5iChdqZYci9Kz7EKwvgy+9sPx+uCsfBvqgMkdUeDxMh6rYXJykG7TBnGR43gsbnwNJgvYG+LAc/h2YkDYtUB2bFqFn57pgNCCOMDFtUB27MI4nhZCYVigadkH82GmHEoqN48XcjEDRsCmxV3bGoGjY5NiwMwolFBulDWYcioaN8jLZElA07DzjNrAMFA07NzzWUlBCsf9rA8tB0bDOiZW1JBQNO/s61rJQQrFQaGmoEipWvEy2fsi5OP8Ddl16AV0G7aoAAAAASUVORK5CYII="

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Newspaper__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GA__ = __webpack_require__(11);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: space-between;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n"],["\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  ",";\n  svg {\n    height: 45px;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  ",";\n  svg {\n    height: 45px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var News=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Item__["d" /* News */])(_templateObject);var Content=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2);var Sidebar=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-left","10px"));var ItemNews=function ItemNews(_ref){var createdAt=_ref.createdAt,publishedAt=_ref.publishedAt,title=_ref.title,slug=_ref.slug;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](News,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item__["g" /* Timestamp */],null,__WEBPACK_IMPORTED_MODULE_1_moment___default()(publishedAt!=null?publishedAt:createdAt,__WEBPACK_IMPORTED_MODULE_1_moment___default.a.ISO_8601).format("lll")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Item__["h" /* TitleLink */],{to:"/news/"+slug,onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_6__GA__["a" /* gaReducer */])("BELL_GO_TO_NEWS",{title:title});}},title)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sidebar,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Newspaper__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (ItemNews);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Newspaper=function Newspaper(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"55",height:"69",viewBox:"0 0 55 69"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"News",transform:"translate(-52.397)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1940","data-name":"Path 1940",d:"M56.038,35.93a3.646,3.646,0,0,0-3.64,3.632V95.246h48.125V35.93Z",transform:"translate(-0.001 -31.088)",fill:"#dadada"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1941","data-name":"Path 1941",d:"M107.078,395.317v7.251H65.02a3.632,3.632,0,1,0,0,7.263h41.654a7.262,7.262,0,0,0,.4-14.514Z",transform:"translate(-7.77 -342.042)",fill:"#c2c2c2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1942","data-name":"Path 1942",d:"M100.118,0H58.868V53.263a1.212,1.212,0,0,0,1.213,1.21H98.9a6.053,6.053,0,1,1,0,12.105H57.25a2.421,2.421,0,1,1,0-4.842H98.1a1.21,1.21,0,1,0,0-2.421H57.25a4.842,4.842,0,1,0,0,9.684H98.9a8.493,8.493,0,0,0,8.493-8.474V7.263A7.293,7.293,0,0,0,100.118,0Z",fill:"#efefef"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_64792","data-name":"Group 64792",transform:"translate(65.743 6.86)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1943","data-name":"Path 1943",d:"M152.418,90.445a1.212,1.212,0,0,1-1.213-1.21V52.111a1.213,1.213,0,0,1,2.426,0V89.234A1.212,1.212,0,0,1,152.418,90.445Z",transform:"translate(-151.205 -50.901)",fill:"#c2c2c2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1944","data-name":"Path 1944",d:"M200.325,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,200.325,245.883Z",transform:"translate(-192.641 -206.34)",fill:"#c2c2c2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1945","data-name":"Path 1945",d:"M248.231,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,248.231,245.883Z",transform:"translate(-234.077 -206.34)",fill:"#c2c2c2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1946","data-name":"Path 1946",d:"M296.137,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,296.137,245.883Z",transform:"translate(-275.512 -206.34)",fill:"#c2c2c2"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"Rectangle_2552","data-name":"Rectangle 2552",width:"19.412",height:"19.368",transform:"translate(73.427 8.07)",fill:"#c2c2c2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_64793","data-name":"Group 64793",transform:"translate(91.625 6.86)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1947","data-name":"Path 1947",d:"M344.044,245.883a1.212,1.212,0,0,1-1.213-1.21V231.76a1.213,1.213,0,0,1,2.426,0v12.912A1.212,1.212,0,0,1,344.044,245.883Z",transform:"translate(-342.831 -206.34)",fill:"#c2c2c2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_1948","data-name":"Path 1948",d:"M391.95,90.445a1.212,1.212,0,0,1-1.213-1.21V52.111a1.213,1.213,0,0,1,2.426,0V89.234A1.212,1.212,0,0,1,391.95,90.445Z",transform:"translate(-384.266 -50.901)",fill:"#c2c2c2"}))));};/* harmony default export */ __webpack_exports__["a"] = (Newspaper);

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccountType_Icons__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Gettext__ = __webpack_require__(2);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral([""],[""]),_templateObject2=_taggedTemplateLiteral(["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: #bebebe;\n"],["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: #bebebe;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: ",";\n  margin-bottom: 17px;\n  color: #919191;\n  text-transform: uppercase;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"],["\n  font-size: ",";\n  margin-bottom: 17px;\n  color: #919191;\n  text-transform: uppercase;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #343434;\n  font-weight: 700;\n  margin-bottom: 16px;\n"],["\n  font-size: ",";\n  color: #343434;\n  font-weight: 700;\n  margin-bottom: 16px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #3b9478;\n  font-weight: 700;\n  margin-bottom: 11px;\n"],["\n  font-size: ",";\n  color: #3b9478;\n  font-weight: 700;\n  margin-bottom: 11px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  color: #0085eb;\n  font-size: ",";\n  text-transform: lowercase;\n"],["\n  color: #0085eb;\n  font-size: ",";\n  text-transform: lowercase;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Advice=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Item__["d" /* News */])(_templateObject);var TitleIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));var Info=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14));var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["b" /* NewsLink */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var ItemAdvice=function ItemAdvice(){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),money=_useState2[0],setMoney=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["d" /* get */])("/api/features/list").then(function(list){list.payload&&list.payload.forEach(function(item){if(item.name==="participation_fee"){setMoney(item.info.participation_fee);}});});},[]);if(money==null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Advice,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__AccountType_Icons__["a" /* AdviceIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Advice")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Don't know what to do with your DEMO money?")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"And we know!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Earn ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Money__["b" /* default */],null,money)," and get a paid tournament invitation!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{to:"/doubleup",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Details")));};/* harmony default export */ __webpack_exports__["a"] = (ItemAdvice);

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccountType_Icons__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_images_invite_3x_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_images_invite_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Tournaments_images_invite_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tournaments_Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_demo_tournament_bg_png__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_demo_tournament_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_demo_tournament_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__GA__ = __webpack_require__(11);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n"],["\n  position: relative;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: #bebebe;\n"],["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: #bebebe;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: ",";\n  margin-bottom: 17px;\n  color: #919191;\n  text-transform: uppercase;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"],["\n  font-size: ",";\n  margin-bottom: 17px;\n  color: #919191;\n  text-transform: uppercase;\n  font-weight: 700;\n  display: flex;\n  align-items: center;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #343434;\n  font-weight: 700;\n  margin-bottom: 16px;\n  line-height: 1.3;\n"],["\n  font-size: ",";\n  color: #343434;\n  font-weight: 700;\n  margin-bottom: 16px;\n  line-height: 1.3;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  color: #0085eb;\n  font-size: ",";\n"],["\n  color: #0085eb;\n  font-size: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  margin-bottom: 14px;\n  padding: 21px 10px;\n  background-color: #000;\n  margin-right: -17px;\n  margin-left: -17px;\n  text-align: center;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n"],["\n  margin-bottom: 14px;\n  padding: 21px 10px;\n  background-color: #000;\n  margin-right: -17px;\n  margin-left: -17px;\n  text-align: center;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-bottom: 7px;\n  font-size: ",";\n  font-weight: 700;\n  color: #fff;\n  position: relative;\n"],["\n  margin-bottom: 7px;\n  font-size: ",";\n  font-weight: 700;\n  color: #fff;\n  position: relative;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 700;\n  color: #ffcc00;\n  position: relative;\n"],["\n  font-size: ",";\n  font-weight: 700;\n  color: #ffcc00;\n  position: relative;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  color: #919191;\n  font-size: ",";\n  margin-bottom: 5px;\n"],["\n  color: #919191;\n  font-size: ",";\n  margin-bottom: 5px;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  color: #343434;\n  font-weight: 700;\n  font-size: ",";\n"],["\n  color: #343434;\n  font-weight: 700;\n  font-size: ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  width: 100%;\n  background-color: #0085eb;\n  color: #fff;\n  font-size: ",";\n  padding: 11px;\n  border-radius: 19px;\n  margin-bottom: 14px;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 900;\n  cursor: pointer;\n  :hover {\n    background-color: #0468b5;\n  }\n"],["\n  width: 100%;\n  background-color: #0085eb;\n  color: #fff;\n  font-size: ",";\n  padding: 11px;\n  border-radius: 19px;\n  margin-bottom: 14px;\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: 900;\n  cursor: pointer;\n  :hover {\n    background-color: #0468b5;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  text-transform: lowercase;\n"],["\n  display: flex;\n  justify-content: space-between;\n  text-transform: lowercase;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  text-align: center;\n  color: #919191;\n"],["\n  margin-bottom: 16px;\n  text-align: center;\n  color: #919191;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Congratulation=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Item__["d" /* News */])(_templateObject);var TitleIcon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14));var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var TournamentBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,__WEBPACK_IMPORTED_MODULE_12__images_demo_tournament_bg_png___default.a);var TournamentText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14));var TournamentPrize=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var StartLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var StartTime=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14));var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var Links=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var TournamentStart=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var Sticker=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var ItemCongratulations=function ItemCongratulations(_ref){var tournament=_ref.tournament;if(tournament==null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Congratulation,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sticker,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__Tournaments_images_invite_3x_png___default.a,alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccountType_Icons__["b" /* GiftIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Congratulations")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"You have enough DEMO money to purchase a tournament invitation!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentText,null,tournament.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentPrize,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Prize fund"),": ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Money__["b" /* default */],null,tournament.prize_fund))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentStart,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["c" /* default */],{days:Object(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["f" /* getDuration */])(tournament,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["f" /* getDuration */])(tournament,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["f" /* getDuration */])(tournament,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["f" /* getDuration */])(tournament,"seconds"),active:Object(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["d" /* getActive */])(tournament),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Timer__["e" /* getCompleted */])(tournament),labelOnTop:true,flexDirection:"column",alignItems:"center",noIcon:true,TimeStyle:StartTime,TextStyle:StartLabel})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref2){var showModal=_ref2.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_13__GA__["a" /* gaReducer */])("BELL_GO_TO_TOURNAMENT",{type:"join"});showModal(__WEBPACK_IMPORTED_MODULE_11__Tournaments_Popups__["b" /* JoinPopup */],tournament);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Buy for ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Money__["b" /* default */],null,tournament.participation_price)," demo money"));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Links,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{to:"/news/doubleup",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Details")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{to:"/tournaments"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__common_Gettext__["b" /* default */],null,"Other tournaments"))));};/* harmony default export */ __webpack_exports__["a"] = (ItemCongratulations);

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Final__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NewFinal__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Start__ = __webpack_require__(1528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Start__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__NewFinal__["a"]; });
/* harmony default export */ __webpack_exports__["c"] = (__WEBPACK_IMPORTED_MODULE_0__Final__["a" /* default */]);

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confetti__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confetti___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_confetti__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Measure__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tournament_PersonalInfo__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tournament_DarkRateTable__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Header__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles__ = __webpack_require__(164);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n  flex-shrink: 0;\n\n  @media (min-width: 960px), (max-width: 479px) {\n    margin: 0 auto 25px;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    align-self: center;\n    flex-basis: 123px;\n  }\n"],["\n  display: block;\n  flex-shrink: 0;\n\n  @media (min-width: 960px), (max-width: 479px) {\n    margin: 0 auto 25px;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    align-self: center;\n    flex-basis: 123px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 16px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  color: ",";\n"],["\n  width: 100%;\n  padding: 0 16px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  color: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-bottom: 6px;\n  color: ",";\n"],["\n  margin-bottom: 6px;\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  margin-bottom: 9px;\n\n  @media (max-width: 959px) {\n    line-height: 2;\n  }\n"],["\n  margin-bottom: 9px;\n\n  @media (max-width: 959px) {\n    line-height: 2;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  padding: 14px 32px;\n  margin-bottom: 27px;\n  background-color: ",";\n\n  @media (max-width: 479px) {\n    padding: 14px 20px;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"],["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  padding: 14px 32px;\n  margin-bottom: 27px;\n  background-color: ",";\n\n  @media (max-width: 479px) {\n    padding: 14px 20px;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  align-self: center;\n  width: 100%;\n  max-width: 100px;\n  font-size: ",";\n  line-height: 23px;\n  font-weight: 700;\n  color: ",";\n\n  @media (min-width: 960px) {\n    padding-right: 20px;\n  }\n\n  @media (max-width: 479px) {\n    max-width: none;\n    margin-bottom: 10px;\n  }\n"],["\n  align-self: center;\n  width: 100%;\n  max-width: 100px;\n  font-size: ",";\n  line-height: 23px;\n  font-weight: 700;\n  color: ",";\n\n  @media (min-width: 960px) {\n    padding-right: 20px;\n  }\n\n  @media (max-width: 479px) {\n    max-width: none;\n    margin-bottom: 10px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"],["\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"],["\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  padding: 0 20px;\n\n  @media (max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 0;\n  }\n"],["\n  padding: 0 20px;\n\n  @media (max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 0;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  flex-shrink: 0;\n  align-self: flex-end;\n"],["\n  flex-shrink: 0;\n  align-self: flex-end;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  margin-top: 0;\n"],["\n  margin-top: 0;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FinalCup=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__Icons_Tournaments__["f" /* FinalCup */])(_templateObject);var Text=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.foreground;});var Heading=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Text)(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.accent;});var Title=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Text)(_templateObject4);var InfoBlock=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.mainDark;});var InfoTitle=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject6,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref5){var theme=_ref5.theme;return theme.foreground;});var InfoBlockItems=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject7);var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject8);var TableContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Container)(_templateObject9);var LinkContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Container)(_templateObject10);var Link=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_10__Link__["a" /* default */])(_templateObject11);var FinalPopup=function(_React$Component){_inherits(FinalPopup,_React$Component);function FinalPopup(){var _ref6;var _temp,_this,_ret;_classCallCheck(this,FinalPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref6=FinalPopup.__proto__||Object.getPrototypeOf(FinalPopup)).call.apply(_ref6,[this].concat(args))),_this),_this.state={limit:5},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FinalPopup,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var tournamentInfo=function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _props,api,tournamentId,info;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_props=_this2.props,api=_props.api,tournamentId=_props.id;if(!(tournamentId!=null)){_context.next=6;break;}_context.next=4;return api.fetchEntity("/api/tournaments/info?id="+tournamentId);case 4:info=_context.sent;if(info!=null){_this2.setState({limit:info.value&&info.value.prizes&&info.value.prizes.length||5},function(){return api.fetchEntity("/api/tournaments/leaderboard?tournament_id="+tournamentId+"&limit="+_this2.state.limit);});}case 6:case"end":return _context.stop();}}},_callee,_this2);}));return function tournamentInfo(){return _ref7.apply(this,arguments);};}();tournamentInfo();}},{key:"render",value:function render(){var _props2=this.props,inProp=_props2.in,onDismiss=_props2.onDismiss,style=_props2.style,api=_props2.api,props=_objectWithoutProperties(_props2,["in","onDismiss","style","api"]);var tournamentId=props.id;if(tournamentId==null){return null;}var leaderboard=api.readEntity("/api/tournaments/leaderboard?tournament_id="+tournamentId+"&limit="+this.state.limit);var info=api.readEntity("/api/tournaments/info?id="+tournamentId);if(info.value==null){return null;}var tournament=info.value;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles__["e" /* Popup */],{"in":inProp,style:style,onDismiss:onDismiss,fades:false},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__styles__["i" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Header__["a" /* default */],Object.assign({Cup:function Cup(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 479px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FinalCup,{width:matches?"61px":"123px"});});}},tournament),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Heading,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"The tournament is finished")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,tournament.title)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InfoBlock,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InfoTitle,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Your results"),":"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InfoBlockItems,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Tournament_PersonalInfo__["b" /* ItemBalance */],{horizontal:true,balance:tournament.account&&tournament.account.balance,participation_status:tournament.participation_status,account:tournament.account}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Tournament_PersonalInfo__["f" /* ItemRate */],{horizontal:true,current_place:tournament.current_place,participant_count:tournament.participant_count}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Tournament_PersonalInfo__["g" /* ItemResult */],{horizontal:true,value:props.prize,valueUSD:props.prizeUSD}))),leaderboard.value!=null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(TableContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Tournament_DarkRateTable__["a" /* default */],{leaderboard:leaderboard.value})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LinkContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Link,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Learn more")))),tournament.current_place===1&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Measure__["a" /* default */],null,function(_ref8){var width=_ref8.width,height=_ref8.height,innerRef=_ref8.innerRef,didMeasure=_ref8.didMeasure;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{ref:innerRef,style:{position:"absolute",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none"}},didMeasure&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_confetti___default.a,{width:width,height:height,numberOfPieces:100,recycle:false,gravity:0.5}));}));}}]);return FinalPopup;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (function(props){var api=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_11__Api__["c" /* default */]);var theme=__WEBPACK_IMPORTED_MODULE_1_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_12__ThemeProvider__["b" /* TradeThemeContext */]);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* ThemeProvider */],{theme:theme},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(FinalPopup,Object.assign({},props,{api:api,key:props.id})));});

/***/ }),
/* 1514 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory(__webpack_require__(0)) :
  typeof define === 'function' && define.amd ? define(['react'], factory) :
  (global.ReactConfetti = factory(global.React));
}(this, (function (React) { 'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;

  function degreesToRads(degrees) {
    return degrees / (180 * Math.PI);
  }

  function randomRange(min, max) {
    return min + Math.random() * (max - min);
  }

  function randomInt(min, max) {
    return Math.floor(min + Math.random() * (max - min + 1));
  }

  /**
   * Most of this was coppied directly from the pen at http://codepen.io/Gthibaud/pen/BoaBZK
   * and halfheartedly converted to es6.
   */
  function confetti(canvas) {
    var numberOfPieces = 200;
    var confettiSource = {
      x: 0,
      y: 0,
      w: canvas.width,
      h: 0
    };
    var friction = 0.99;
    var wind = 0;
    var gravity = 0.1;
    var colors = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548'];
    var opacity = 1.0;
    var recycle = true;
    var run = true;

    function self() {
      var context = canvas.getContext('2d');

      function Particle(x, y) {
        this.radius = randomRange(0.1, 1);
        this.x = x;
        this.y = y;
        this.vx = randomRange(-4, 4);
        this.vy = randomRange(-10, -0);
        this.type = randomInt(0, 1);

        this.w = randomRange(5, 20);
        this.h = randomRange(5, 20);

        this.r = randomRange(5, 10);

        this.angle = degreesToRads(randomRange(0, 360));
        this.anglespin = randomRange(-0.2, 0.2);
        this.color = colors[Math.floor(Math.random() * colors.length)];

        this.rotateY = randomRange(0, 1);
      }

      Particle.prototype.update = function updateParticle() {
        this.x += this.vx;
        this.y += this.vy;
        this.vy += gravity;
        this.vx += wind;
        this.vx *= friction;
        this.vy *= friction;
        this.radius -= 0.02;
        if (this.rotateY < 1) {
          this.rotateY += 0.1;
        } else {
          this.rotateY = -1;
        }
        this.angle += this.anglespin;
        context.save();
        context.translate(this.x, this.y);
        context.rotate(this.angle);
        context.scale(1, this.rotateY);
        context.rotate(this.angle);
        context.beginPath();
        context.fillStyle = this.color;
        context.strokeStyle = this.color;
        context.globalAlpha = opacity;
        context.lineCap = 'round';
        context.lineWidth = 2;
        if (this.type === 0) {
          context.beginPath();
          context.arc(0, 0, this.r, 0, 2 * Math.PI);
          context.fill();
        } else if (this.type === 2) {
          context.beginPath();
          for (var i = 0; i < 22; i++) {
            var angle = 0.5 * i;
            var x = (0.2 + 1.5 * angle) * Math.cos(angle);
            var y = (0.2 + 1.5 * angle) * Math.sin(angle);
            context.lineTo(x, y);
          }
          context.stroke();
        } else if (this.type === 1) {
          context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
        }
        context.closePath();
        context.restore();
      };

      function ParticleGenerator(source, number, text) {
        // particle will spawn in this aera
        this.x = source.x;
        this.y = source.y;
        this.w = source.w;
        this.h = source.h;
        this.number = number;
        this.particles = [];
        this.particlesGenerated = 0;
        this.text = text;
        this.recycle = recycle;
      }
      ParticleGenerator.prototype.removeParticleAt = function removeParticleAt(i) {
        this.particles.splice(i, 1);
      };
      ParticleGenerator.prototype.getParticle = function addParticle() {
        var newParticleX = randomRange(this.x, this.w + this.x);
        var newParticleY = randomRange(this.y, this.h + this.y);
        return new Particle(newParticleX, newParticleY, this.text);
      };
      ParticleGenerator.prototype.animate = function animateParticle() {
        var _this = this;

        if (!run) {
          return false;
        }
        var nP = this.particles.length;
        var limit = this.recycle ? nP : this.particlesGenerated;
        if (limit < this.number) {
          this.particles.push(this.getParticle());
          this.particlesGenerated += 1;
        }

        this.particles.forEach(function (p, i) {
          p.update();
          if (p.y > canvas.height || p.y < -100 || p.x > canvas.width + 100 || p.x < -100) {
            if (recycle && limit <= _this.number) {
              // a brand new particle replacing the dead one
              _this.particles[i] = _this.getParticle();
            } else {
              _this.removeParticleAt(i);
            }
          }
        });
        return nP > 0 || limit < this.number;
      };

      self.particleGenerator = new ParticleGenerator(confettiSource, numberOfPieces);

      self.update = function () {
        if (run) {
          self.particleGenerator.number = numberOfPieces;
          // context.globalAlpha=.5;
          context.fillStyle = 'white';
          context.clearRect(0, 0, canvas.width, canvas.height);
        }
        if (self.particleGenerator.animate()) {
          requestAnimationFrame(self.update);
        } else {
          run = false;
        }
      };

      self.update();

      return self;
    }

    self.numberOfPieces = function () {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!args.length) {
        return numberOfPieces;
      }
      numberOfPieces = args[0];

      if (self.particleGenerator) {
        self.particleGenerator.number = numberOfPieces;
      }
      return self;
    };

    self.friction = function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      if (!args.length) {
        return friction;
      }
      friction = args[0];

      return self;
    };

    self.wind = function () {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      if (!args.length) {
        return wind;
      }
      wind = args[0];

      return self;
    };

    self.gravity = function () {
      for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      if (!args.length) {
        return gravity;
      }
      gravity = args[0];

      return self;
    };

    self.colors = function () {
      for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      if (!args.length) {
        return colors;
      }
      colors = args[0];

      return self;
    };

    self.opacity = function () {
      for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      if (!args.length) {
        return opacity;
      }
      opacity = args[0];

      return self;
    };

    self.recycle = function () {
      for (var _len7 = arguments.length, args = Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      if (!args.length) {
        return recycle;
      }
      recycle = args[0];

      if (self.particleGenerator) {
        self.particleGenerator.recycle = recycle;
      }
      return self;
    };

    self.confettiSource = function () {
      if (!arguments.length) {
        return confettiSource;
      }
      confettiSource = Object.assign(confettiSource, arguments.length <= 0 ? undefined : arguments[0]);
      return self;
    };

    self.run = function () {
      for (var _len8 = arguments.length, args = Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
        args[_key8] = arguments[_key8];
      }

      if (!args.length) {
        return run;
      }
      var wasRunning = run;
      var isRunning = args[0];

      run = isRunning;
      if (!wasRunning && run) {
        self.update();
      }
      return self;
    };

    return self;
  }

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  var ReactConfetti = function (_React$PureComponent) {
    _inherits(ReactConfetti, _React$PureComponent);

    function ReactConfetti() {
      _classCallCheck(this, ReactConfetti);

      return _possibleConstructorReturn(this, (ReactConfetti.__proto__ || Object.getPrototypeOf(ReactConfetti)).apply(this, arguments));
    }

    _createClass(ReactConfetti, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.confetti = confetti(this.canvas).numberOfPieces(this.props.numberOfPieces).confettiSource(this.props.confettiSource).friction(this.props.friction).wind(this.props.wind).gravity(this.props.gravity).colors(this.props.colors).opacity(this.props.opacity).recycle(this.props.recycle).run(this.props.run)();
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.confetti.numberOfPieces(nextProps.numberOfPieces).confettiSource(nextProps.confettiSource).friction(nextProps.friction).wind(nextProps.wind).gravity(nextProps.gravity).colors(nextProps.colors).opacity(nextProps.opacity).recycle(nextProps.recycle).run(nextProps.run);
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var _props = this.props,
            width = _props.width,
            height = _props.height,
            style = _props.style,
            numberOfPieces = _props.numberOfPieces,
            friction = _props.friction,
            wind = _props.wind,
            gravity = _props.gravity,
            colors = _props.colors,
            opacity = _props.opacity,
            recycle = _props.recycle,
            confettiSource = _props.confettiSource,
            run = _props.run,
            passedProps = _objectWithoutProperties(_props, ['width', 'height', 'style', 'numberOfPieces', 'friction', 'wind', 'gravity', 'colors', 'opacity', 'recycle', 'confettiSource', 'run']);

        var canvasStyles = Object.assign({}, {
          zIndex: 2,
          position: 'absolute',
          top: 0,
          left: 0,
          pointerEvents: 'none',
          WebkitPointerEvents: 'none',
          MozPointerEvents: 'none'
        }, style);

        return React.createElement('canvas', _extends({
          width: width,
          height: height,
          ref: function ref(c) {
            _this2.canvas = c;
          },
          style: canvasStyles
        }, passedProps));
      }
    }]);

    return ReactConfetti;
  }(React.PureComponent);

  ReactConfetti.defaultProps = {
    numberOfPieces: 200,
    confettiSource: {},
    friction: 0.99,
    wind: 0,
    gravity: 0.1,
    colors: ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722', '#795548'],
    opacity: 1.0,
    recycle: true,
    run: true
  };

  return ReactConfetti;

})));
//# sourceMappingURL=react-confetti.js.map


/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MoneyBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MoneyValue; });
/* unused harmony export MoneyCurrency */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  margin: 0 5px;\n  font-weight: 700;\n  font-size: ",";\n  \n  @media (max-width: 959px) {\n    ",";\n  }\n  \n  @media (max-width: 479px) {\n    ",";\n  }\n"],["\n  display: flex;\n  margin: 0 5px;\n  font-weight: 700;\n  font-size: ",";\n  \n  @media (max-width: 959px) {\n    ",";\n  }\n  \n  @media (max-width: 479px) {\n    ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      font-size: 20px;\n    "],["\n      font-size: 20px;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      font-size: 18px;\n    "],["\n      font-size: 18px;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  margin: 0 2px;\n  color: ",";\n"],["\n  margin: 0 2px;\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MoneyBlock=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject,function(props){return props.size||"14px";},function(props){return props.size==="24px"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.size==="24px"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3);});var MoneyValue=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject4,function(_ref){var theme=_ref.theme;return theme.foreground;});var MoneyCurrency=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.accent;});

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Kuchka__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(["\n  display: table;\n  border-collapse: separate;\n  border-spacing: 0 4px;\n  width: 100%;\n  margin-bottom: 30px;\n"],["\n  display: table;\n  border-collapse: separate;\n  border-spacing: 0 4px;\n  width: 100%;\n  margin-bottom: 30px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: table-row;\n  font-size: ",";\n  color: #99959d;\n"],["\n  display: table-row;\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: table-cell;\n  ","\n  ","\n  ","\n"],["\n  display: table-cell;\n  ","\n  ","\n  ","\n"]),_templateObject4=_taggedTemplateLiteral(["\n      padding-left: 10px;\n    "],["\n      padding-left: 10px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      @media (max-width: 959px) {\n        display: none;\n      }\n    "],["\n      @media (max-width: 959px) {\n        display: none;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      @media (max-width: 480px) {\n        display: none;\n      }\n    "],["\n      @media (max-width: 480px) {\n        display: none;\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  @media (max-width: 480px) {\n    display: none;\n  }\n"],["\n  @media (max-width: 480px) {\n    display: none;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: table-row;\n  width: 100%;\n  height: 32px;\n  font-size: ",";\n  color: ",";\n  background-color: ",";\n\n  "," "," ",";\n\n"],["\n  display: table-row;\n  width: 100%;\n  height: 32px;\n  font-size: ",";\n  color: ",";\n  background-color: ",";\n\n  "," "," ",";\n\n"]),_templateObject9=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject10=_taggedTemplateLiteral(["\n    color: #bebebe;\n  "],["\n    color: #bebebe;\n  "]),_templateObject11=_taggedTemplateLiteral(["\n    color: #df9784;\n  "],["\n    color: #df9784;\n  "]),_templateObject12=_taggedTemplateLiteral(["\n  display: table-cell;\n  min-width: 35px;\n  margin-right: 8px;\n  padding-left: 10px;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: bold;\n  color: inherit;\n"],["\n  display: table-cell;\n  min-width: 35px;\n  margin-right: 8px;\n  padding-left: 10px;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: bold;\n  color: inherit;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: table-cell;\n  margin-right: 10px;\n  vertical-align: middle;\n  color: inherit;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  display: table-cell;\n  margin-right: 10px;\n  vertical-align: middle;\n  color: inherit;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: table-cell;\n  margin-right: 8px;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 400;\n  color: inherit;\n"],["\n  display: table-cell;\n  margin-right: 8px;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 400;\n  color: inherit;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 400;\n  color: inherit;\n\n  @media (max-width: 480px) {\n    display: none;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 400;\n  color: inherit;\n\n  @media (max-width: 480px) {\n    display: none;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  display: table-cell;\n  margin-right: auto;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 700;\n"],["\n  display: table-cell;\n  margin-right: auto;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 700;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n  font-size: ",";\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var TableTitles=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.type==="number"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);},function(props){return props.resolution==="onlyDesktop"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(props){return props.resolution==="onlyMobile"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var TraderTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7);var ItemWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref3){var theme=_ref3.theme;return theme.foreground;},function(_ref4){var theme=_ref4.theme;return theme.mainDark;},function(props){return props.place===1&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9,function(_ref5){var theme=_ref5.theme;return theme.accent;});},function(props){return props.place===2&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.place===3&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);});var ItemNumber=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var IconBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var Id=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Name=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,function(_ref8){var theme=_ref8.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Balance=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(_ref9){var theme=_ref9.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Reward=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject17,function(_ref10){var theme=_ref10.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Item=function Item(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemWrapper,{place:props.place},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ItemNumber,null,"#",props.place),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Icons_Tournaments__["e" /* Cup */],{width:"16px"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Id,null,props.id),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Name,null,props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Balance,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:__WEBPACK_IMPORTED_MODULE_6__Icons_Kuchka__["b" /* tournamentCurrency */],Symbol:__WEBPACK_IMPORTED_MODULE_6__Icons_Kuchka__["a" /* default */]},props.balance)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Reward,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HowMuchInBucks__["a" /* default */],{currency:props.currency,value:props.reward,valueUSD:props.rewardUSD})));};var DarkRateTable=function DarkRateTable(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableTitles,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{type:"number"},"#"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{resolution:"onlyDesktop"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,"id",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TraderTitle,null,"/",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"trader"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{resolution:"onlyMobile"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Balance")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{resolution:"onlyDesktop"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Reward"))),props.leaderboard.items.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,{key:item.place,place:item.place,id:item.user_id,name:item.user_name,balance:item.funds_available,currency:item.currency,reward:item.prize,rewardUSD:item.prize_usd});}));};/* harmony default export */ __webpack_exports__["a"] = (DarkRateTable);

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confetti__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_confetti___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_confetti__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Measure__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NextTournament__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Leaderboard__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Tournament_ShareTournament__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles__ = __webpack_require__(164);
var _templateObject=_taggedTemplateLiteral(["\n  background-image: none;\n\n  @media (min-width: 960px) {\n    padding: 25px 0 0;\n  }\n\n  @media (max-width: 959px) {\n    padding: 16px 0 0;\n  }\n"],["\n  background-image: none;\n\n  @media (min-width: 960px) {\n    padding: 25px 0 0;\n  }\n\n  @media (max-width: 959px) {\n    padding: 16px 0 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  flex: 1;\n  height: 100%;\n"],["\n  direction: ",";\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  flex: 1;\n  height: 100%;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin: auto 0;\n  width: 100%;\n  line-height: 1.25;\n"],["\n  margin: auto 0;\n  width: 100%;\n  line-height: 1.25;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  min-height: 86px;\n  padding: 0 10px;\n  box-sizing: border-box;\n  overflow: hidden;\n\n  @media (min-width: 960px) {\n    margin-top: 15px;\n    padding: 0 15px;\n    min-height: 122px;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  min-height: 86px;\n  padding: 0 10px;\n  box-sizing: border-box;\n  overflow: hidden;\n\n  @media (min-width: 960px) {\n    margin-top: 15px;\n    padding: 0 15px;\n    min-height: 122px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 959px) {\n    flex-flow: row wrap;\n    padding: 10px 10px 0;\n  }\n"],["\n  display: flex;\n  flex-flow: column nowrap;\n  align-content: center;\n  justify-content: center;\n  align-items: center;\n\n  @media (max-width: 959px) {\n    flex-flow: row wrap;\n    padding: 10px 10px 0;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    padding: 0 10px;\n  }\n\n  ",";\n"],["\n  @media (max-width: 959px) {\n    padding: 0 10px;\n  }\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n        @media (max-width: 479px) {\n          flex-grow: 0;\n          flex-shrink: 1;\n          flex-basis: 70%;\n        }\n      "],["\n        @media (max-width: 479px) {\n          flex-grow: 0;\n          flex-shrink: 1;\n          flex-basis: 70%;\n        }\n      "]),_templateObject8=_taggedTemplateLiteral(["\n  margin: 15px auto;\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    margin: 10px 0;\n    text-align: center;\n  }\n\n  @media (max-width: 479px) {\n    font-size: 14px;\n  }\n"],["\n  margin: 15px auto;\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    margin: 10px 0;\n    text-align: center;\n  }\n\n  @media (max-width: 479px) {\n    font-size: 14px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin: 15px auto;\n  font-weight: 700;\n  font-size: 32px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    margin: 10px 0;\n    font-size: 18px;\n    text-align: center;\n  }\n"],["\n  margin: 15px auto;\n  font-weight: 700;\n  font-size: 32px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    margin: 10px 0;\n    font-size: 18px;\n    text-align: center;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    margin-top: 10px;\n  }\n"],["\n  @media (max-width: 959px) {\n    margin-top: 10px;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Popup=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_14__styles__["e" /* Popup */])(_templateObject);var Wrapper=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_14__styles__["i" /* Wrapper */])(_templateObject2,function(_ref){var theme=_ref.theme;return theme.direction;});var ContentView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var LeaderboardContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var HeaderContents=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref2){var winner=_ref2.winner;if(winner===false){return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);}});var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref3){var theme=_ref3.theme;return theme.accent;});var Info=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref4){var theme=_ref4.theme;return theme.foreground;});var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */])(_templateObject10);function Content(_ref5){var _ref5$winner=_ref5.winner,winner=_ref5$winner===undefined?false:_ref5$winner,props=_objectWithoutProperties(_ref5,["winner"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,props.icon),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeaderContents,{winner:winner},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"The tournament ",props.title," is finished")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,null,props.children))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LeaderboardContainer,null,props.leaderboard),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"All results")));}function Final(_ref6){var style=_ref6.style,onDismiss=_ref6.onDismiss,api=_ref6.api,tournament=_ref6.tournament,props=_objectWithoutProperties(_ref6,["style","onDismiss","api","tournament"]);if(tournament==null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,{onDismiss:onDismiss,style:style,fades:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Spinners_SimpleSpinner__["c" /* default */],null)));}var place=props.place||tournament.current_place;var winner=false;if(props.prize!=null){winner=true;}else{winner=tournament.current_place!=null&&tournament.prizes.length>=tournament.current_place&&tournament.prizes[tournament.current_place-1].user_id!=null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,{onDismiss:onDismiss,style:style,fades:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){if(winner===true){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,Object.assign({},tournament,{winner:true,icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Icons_Tournaments__["n" /* WinnerCup */],{width:matches?"300px":"464px"}),leaderboard:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Leaderboard__["a" /* default */],Object.assign({},tournament,{api:api,limit:1,winner:true}))}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"YOU WIN"));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,Object.assign({},tournament,{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Icons_Tournaments__["f" /* FinalCup */],{width:matches?"61px":"123px"}),leaderboard:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Leaderboard__["a" /* default */],Object.assign({},tournament,{api:api,limit:3}))}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Your results"),":");}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Tournament_ShareTournament__["a" /* default */],{title:tournament.title,currentPlace:tournament.current_place,prize:tournament.current_place&&tournament.prizes[tournament.current_place-1]&&tournament.prizes[tournament.current_place-1].prize,tournamentId:tournament.id,prizePlacesCount:tournament.prizes.length,isPopup:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__NextTournament__["a" /* default */],{onDismiss:onDismiss})),winner&&place===1&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Measure__["a" /* default */],null,function(_ref7){var width=_ref7.width,height=_ref7.height,innerRef=_ref7.innerRef,didMeasure=_ref7.didMeasure;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{ref:innerRef,style:{position:"absolute",top:0,left:0,width:"100%",height:"100%",pointerEvents:"none"}},didMeasure&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_confetti___default.a,{width:width,height:height,numberOfPieces:100,recycle:false,gravity:0.5}));}));}/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Api__["c" /* default */].Consumer,null,function(api){var tournament=__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/tournaments/info?id="+props.id),function(tournament){return tournament.value;});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Final,Object.assign({key:props.id,api:api,tournament:tournament},props));});});

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tournament_Info__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Account_Card_ButtonSwitcher__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Sticker__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15____ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_default_tournament_bg_iron_jpg__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_default_tournament_bg_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_default_tournament_bg_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_default_tournament_bg_th_jpg__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_default_tournament_bg_th_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_default_tournament_bg_th_jpg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-flow: row wrap;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  width: 100%;\n  margin-top: 10px;\n  background-color: ",";\n  background-image: url(\"","\");\n    background-repeat: no-repeat;\n    background-position: center;\n  background-size: cover;\n  background-position: 50%;\n\n  @media(min-width: 960px) {\n    min-height: 100px;\n    margin-top: 15px;\n  }\n"],["\n  position: relative;\n  display: flex;\n  flex-flow: row wrap;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  width: 100%;\n  margin-top: 10px;\n  background-color: ",";\n  background-image: url(\"","\");\n    background-repeat: no-repeat;\n    background-position: center;\n  background-size: cover;\n  background-position: 50%;\n\n  @media(min-width: 960px) {\n    min-height: 100px;\n    margin-top: 15px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  min-height: 100px;\n"],["\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  min-height: 100px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  align-items: flex-start;\n  padding: 15px;\n\n  @media (max-width: 959px) {\n    padding: 10px 15px;\n  }\n"],["\n  align-items: flex-start;\n  padding: 15px;\n\n  @media (max-width: 959px) {\n    padding: 10px 15px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n"],["\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n\n  :not(:first-of-type) {\n    margin-top: 15px;\n  }\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  width: 100%;\n\n  :not(:first-of-type) {\n    margin-top: 15px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-start;\n    align-content: flex-start;\n  }\n"],["\n  @media (max-width: 959px) {\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-start;\n    align-content: flex-start;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  flex-basis: 163px;\n  min-width: 163px;\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  flex-basis: 163px;\n  min-width: 163px;\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n        margin-right: auto;\n      "],["\n        margin-right: auto;\n      "]),_templateObject9=_taggedTemplateLiteral(["\n      margin-left: auto;\n    "],["\n      margin-left: auto;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  @media (min-width: 640px) {\n    ",";\n  }\n\n  @media (max-width: 639px) {\n    margin: 0 auto;\n  }\n"],["\n  @media (min-width: 640px) {\n    ",";\n  }\n\n  @media (max-width: 639px) {\n    margin: 0 auto;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n          margin-right: auto;\n        "],["\n          margin-right: auto;\n        "]),_templateObject12=_taggedTemplateLiteral(["\n        margin-left: auto;\n      "],["\n        margin-left: auto;\n      "]),_templateObject13=_taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 1;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    margin-bottom: 10px;\n  }\n"],["\n  font-size: 14px;\n  line-height: 1;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    margin-bottom: 10px;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 0;\n\n  @media (max-width: 959px) {\n    flex-basis: 27px;\n    min-width: 27px;\n  }\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 0;\n\n  @media (max-width: 959px) {\n    flex-basis: 27px;\n    min-width: 27px;\n  }\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n        margin-left: 10px;\n      "],["\n        margin-left: 10px;\n      "]),_templateObject16=_taggedTemplateLiteral(["\n      margin-right: 10px;\n    "],["\n      margin-right: 10px;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 1;\n\n  @media (min-width: 480px) {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    margin-bottom: 10px;\n  }\n"],["\n  font-size: 12px;\n  line-height: 1;\n\n  @media (min-width: 480px) {\n    ",";\n  }\n\n  @media (max-width: 959px) {\n    margin-bottom: 10px;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n          margin-right: 15px;\n          text-align: right;\n        "],["\n          margin-right: 15px;\n          text-align: right;\n        "]),_templateObject19=_taggedTemplateLiteral(["\n        margin-left: 15px;\n        text-align: left;\n      "],["\n        margin-left: 15px;\n        text-align: left;\n      "]),_templateObject20=_taggedTemplateLiteral(["\n  margin-top: 5px;\n\n  @media (min-width: 960px) {\n    margin-top: 0;\n  }\n"],["\n  margin-top: 5px;\n\n  @media (min-width: 960px) {\n    margin-top: 0;\n  }\n"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SharedContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.main;},function(props){return props.bg?props.bg: false?tournamentBgSiam:__WEBPACK_IMPORTED_MODULE_17__images_default_tournament_bg_iron_jpg___default.a;});var SpinnerContainer=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(SharedContainer)(_templateObject2);var Container=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(SharedContainer)(_templateObject3);var Title=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.alternativeForeground;});var Row=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject5);var Info=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(Row)(_templateObject6);var ActionContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject7,function(_ref3){var theme=_ref3.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject8);return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject9);});var ButtonActionContainer=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(ActionContainer)(_templateObject10,function(_ref4){var theme=_ref4.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject11);return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject12);});var PrizeFund=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_11__Tournament_Info__["d" /* PrizeFund */])(_templateObject13);var IconContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject14,function(_ref5){var theme=_ref5.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject15);return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject16);});var Timer=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_16__Timer__["c" /* default */])(_templateObject17,function(_ref6){var theme=_ref6.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject18);return Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject19);});var Link=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Link__["a" /* default */])(_templateObject20);var LearnMore=function LearnMore(_ref7){var to=_ref7.to;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Link,{to:to},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"Learn more"));};var NextTournament=function(_React$Component){_inherits(NextTournament,_React$Component);function NextTournament(){var _ref8,_this2=this;var _temp,_this,_ret;_classCallCheck(this,NextTournament);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref8=NextTournament.__proto__||Object.getPrototypeOf(NextTournament)).call.apply(_ref8,[this].concat(args))),_this),_this.onTradeClick=function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var _this$props,api,onDismiss,activate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,api=_this$props.api,onDismiss=_this$props.onDismiss;_context.next=3;return api.fetchEntity("/api/tournaments/activate?id="+id);case 3:activate=_context.sent;if(!(activate!==null)){_context.next=11;break;}api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/info?id="+id);_context.next=9;return api.fetchEntity("/api/tournaments/stats");case 9:_this.props.dispatch({type:"ENGAGE_TOURNAMENT_MODE"});onDismiss();case 11:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref9.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NextTournament,[{key:"componentDidMount",value:function componentDidMount(){this.props.api.fetchEntity("/api/tournaments/list?status=1");}},{key:"render",value:function render(){var _this3=this;var _props=this.props,api=_props.api,time=_props.time,onDismiss=_props.onDismiss,dispatch=_props.dispatch,showModal=_props.showModal;var list=api.readEntity("/api/tournaments/list?status=1");var tournament=__WEBPACK_IMPORTED_MODULE_7_idx___default()(list,function(list){return list.value.items[0];});if(tournament==null){var status=list.status;switch(status){case"Resolved":case"Rejected":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SpinnerContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Gettext__["b" /* default */],null,"There are no tournaments available."));default:return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SpinnerContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["c" /* default */],{accent:true,height:"100px"}));}}var bg=__WEBPACK_IMPORTED_MODULE_7_idx___default()(tournament,function(tournament){return tournament.images.bar;});var timerProps=Object.assign({},tournament,{time:time});var isAndroid=window.androidApp!==undefined;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,{bg:bg},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Row,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Title,null,tournament.title),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LearnMore,{to:"/tournaments/"+tournament.id}));}})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PrizeFund,Object.assign({},tournament,{IconWrapper:IconContainer})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Timer,{completedTimer:__WEBPACK_IMPORTED_MODULE_2_moment___default.a.unix(tournament.finish_date).format("LLL"),days:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["f" /* getDuration */])(timerProps,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["f" /* getDuration */])(timerProps,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["f" /* getDuration */])(timerProps,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["f" /* getDuration */])(timerProps,"seconds"),active:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["d" /* getActive */])(timerProps),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["e" /* getCompleted */])(timerProps)}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ButtonActionContainer,null,Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["e" /* getCompleted */])(timerProps)?null:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Account_Card_ButtonSwitcher__["a" /* default */],Object.assign({flat:true},tournament,{onActiveTradeClick:isAndroid?function(){return window.androidApp.tournamentTrade(tournament.id);}:onDismiss,onJoinClick:function onJoinClick(){return showModal(__WEBPACK_IMPORTED_MODULE_15____["b" /* JoinPopup */],Object.assign({},tournament,{dispatch:dispatch}));},onLeaveClick:function onLeaveClick(){return showModal(__WEBPACK_IMPORTED_MODULE_15____["c" /* LeavePopup */],Object.assign({},tournament,{dispatch:dispatch}));},onTradeClick:isAndroid?function(){return window.androidApp.tournamentTrade(tournament.id);}:function(){return _this3.onTradeClick(tournament.id);}})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LearnMore,{to:"/tournaments/"+tournament.id});}}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Sticker__["a" /* default */],Object.assign({},tournament,{active:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["d" /* getActive */])(timerProps),isNew:Object(__WEBPACK_IMPORTED_MODULE_16__Timer__["g" /* getNew */])(timerProps)})));}}]);return NextTournament;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_16__Timer__["i" /* mapStateToTime */])(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref10){var showModal=_ref10.showModal;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](NextTournament,Object.assign({api:api,showModal:showModal},props));});});}));

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-width: 163px;\n  min-height: ",";\n  font-size: ",";\n  font-weight: 900;\n  line-height: 16px;\n  background-color: transparent;\n  border: 2px solid #fff;\n  border-radius: 19px;\n  cursor: pointer;\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-width: 163px;\n  min-height: ",";\n  font-size: ",";\n  font-weight: 900;\n  line-height: 16px;\n  background-color: transparent;\n  border: 2px solid #fff;\n  border-radius: 19px;\n  cursor: pointer;\n\n  ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      :hover {\n        background-color: #fff;\n        color: #3b9478;\n\n        > div {\n          color: #3b9478;\n        }\n      }\n    "],["\n      :hover {\n        background-color: #fff;\n        color: #3b9478;\n\n        > div {\n          color: #3b9478;\n        }\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      position: relative;\n      background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n      z-index: 2;\n\n      ::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        display: block;\n        background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n        border-radius: inherit;\n        z-index: -1;\n        opacity: 0;\n        transition: opacity 0.5s;\n      }\n\n      :hover {\n        ::before {\n          opacity: 1;\n        }\n      }\n    "],["\n      position: relative;\n      background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n      z-index: 2;\n\n      ::before {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        display: block;\n        background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n        border-radius: inherit;\n        z-index: -1;\n        opacity: 0;\n        transition: opacity 0.5s;\n      }\n\n      :hover {\n        ::before {\n          opacity: 1;\n        }\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  color: #fff;\n"],["\n  color: #fff;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  color: #ffcc00;\n"],["\n  color: #ffcc00;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var isCardButton=_ref.isCardButton;return isCardButton?"40px":"37px";},Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(12),function(_ref2){var forBell=_ref2.forBell;return!forBell&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(_ref3){var forBell=_ref3.forBell;return forBell&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var JoinText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Cost=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var DemoButton=function DemoButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{onClick:props.onClick,isCardButton:props.isCardButton,forBell:props.forBell},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(JoinText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"JOIN demo")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cost,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],null,props.participation_price)));};/* harmony default export */ __webpack_exports__["a"] = (DemoButton);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(164);
var _templateObject=_taggedTemplateLiteral(["\n  flex: 1;\n  padding: 16px;\n  text-align: center;\n"],["\n  flex: 1;\n  padding: 16px;\n  text-align: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n\n  @media (min-height: 960px) {\n    padding: 15px 25px;\n  }\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n\n  @media (min-height: 960px) {\n    padding: 15px 25px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    font-size: 12px;\n  }\n\n  & > div {\n    flex: 3.5;\n    min-width: 70px;\n  }\n\n  & > div:nth-of-type(2) {\n    padding: 0 10px;\n  }\n\n  & > div:first-of-type {\n    flex: 1;\n\n    @media(max-width: 959px) {\n      flex: 0.5;\n      min-width: 50px;\n    }\n\n    ",";\n  }\n\n  & > div:last-of-type {\n    flex: 1;\n\n    ",";\n  }\n}\n\n  ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    font-size: 12px;\n  }\n\n  & > div {\n    flex: 3.5;\n    min-width: 70px;\n  }\n\n  & > div:nth-of-type(2) {\n    padding: 0 10px;\n  }\n\n  & > div:first-of-type {\n    flex: 1;\n\n    @media(max-width: 959px) {\n      flex: 0.5;\n      min-width: 50px;\n    }\n\n    ",";\n  }\n\n  & > div:last-of-type {\n    flex: 1;\n\n    ",";\n  }\n}\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n          text-align: right;\n        "],["\n          text-align: right;\n        "]),_templateObject5=_taggedTemplateLiteral(["\n        text-align: left;\n      "],["\n        text-align: left;\n      "]),_templateObject6=_taggedTemplateLiteral(["\n          text-align: left;\n        "],["\n          text-align: left;\n        "]),_templateObject7=_taggedTemplateLiteral(["\n        text-align: right;\n      "],["\n        text-align: right;\n      "]),_templateObject8=_taggedTemplateLiteral(["\n  padding: 5px 15px;\n  font-size: 10px;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: 10px;\n  }\n"],["\n  padding: 5px 15px;\n  font-size: 10px;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: 10px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  padding: 15px;\n  background-color: ",";\n"],["\n  padding: 15px;\n  background-color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-weight: 700;\n  color: ",";\n"],["\n  font-weight: 700;\n  color: ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  font-size: 18px;\n\n  @media (min-width: 960px) {\n    font-size: 32px;\n    text-align: center;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  font-size: 18px;\n\n  @media (min-width: 960px) {\n    font-size: 32px;\n    text-align: center;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  padding: 5px 15px;\n  font-size: 10px;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  padding: 5px 15px;\n  font-size: 10px;\n  color: #99959d;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n"],["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  position: relative;\n  min-height: 32px;\n  padding: 0 15px;\n  background-color: ",";\n  opacity: 0.9;\n\n  :not(:last-of-type) {\n    margin-bottom: 4px;\n  }\n\n  ",";\n"],["\n  position: relative;\n  min-height: 32px;\n  padding: 0 15px;\n  background-color: ",";\n  opacity: 0.9;\n\n  :not(:last-of-type) {\n    margin-bottom: 4px;\n  }\n\n  ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n      min-height: 44px;\n      color: ",";\n      opacity: 1;\n    "],["\n      min-height: 44px;\n      color: ",";\n      opacity: 1;\n    "]),_templateObject17=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 34px;\n\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 34px;\n\n  ",";\n"]),_templateObject18=_taggedTemplateLiteral(["\n        margin-left: 8px;\n        text-align: right;\n      "],["\n        margin-left: 8px;\n        text-align: right;\n      "]),_templateObject19=_taggedTemplateLiteral(["\n      margin-right: 8px;\n      text-align: left;\n    "],["\n      margin-right: 8px;\n      text-align: left;\n    "]),_templateObject20=_taggedTemplateLiteral(["\n  flex: 3;\n  display: flex;\n  flex-flow: row nowrap;\n\n  ",";\n"],["\n  flex: 3;\n  display: flex;\n  flex-flow: row nowrap;\n\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n        margin-left: auto;\n      "],["\n        margin-left: auto;\n      "]),_templateObject22=_taggedTemplateLiteral(["\n      margin-right: auto;\n    "],["\n      margin-right: auto;\n    "]),_templateObject23=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  color: ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  color: ",";\n"]),_templateObject24=_taggedTemplateLiteral(["\n  flex: 0;\n  flex-basis: 70px;\n  min-width: 70px;\n\n  ",";\n"],["\n  flex: 0;\n  flex-basis: 70px;\n  min-width: 70px;\n\n  ",";\n"]),_templateObject25=_taggedTemplateLiteral(["\n        text-align: right;\n        padding-left: 8px;\n      "],["\n        text-align: right;\n        padding-left: 8px;\n      "]),_templateObject26=_taggedTemplateLiteral(["\n      padding-right: 8px;\n      text-align: left;\n    "],["\n      padding-right: 8px;\n      text-align: left;\n    "]),_templateObject27=_taggedTemplateLiteral(["\n  flex: 1;\n  text-align: center;\n"],["\n  flex: 1;\n  text-align: center;\n"]),_templateObject28=_taggedTemplateLiteral(["\n  flex: 2;\n\n  ",";\n"],["\n  flex: 2;\n\n  ",";\n"]),_templateObject29=_taggedTemplateLiteral(["\n        text-align: left;\n        padding-right: 8px;\n      "],["\n        text-align: left;\n        padding-right: 8px;\n      "]),_templateObject30=_taggedTemplateLiteral(["\n      padding-left: 8px;\n      text-align: right;\n    "],["\n      padding-left: 8px;\n      text-align: right;\n    "]),_templateObject31=_taggedTemplateLiteral(["\n  width: 14px;\n  height: 2px;\n  background-color: #99959d;\n\n  ",";\n"],["\n  width: 14px;\n  height: 2px;\n  background-color: #99959d;\n\n  ",";\n"]),_templateObject32=_taggedTemplateLiteral(["\n        margin-right: auto;\n      "],["\n        margin-right: auto;\n      "]),_templateObject33=_taggedTemplateLiteral(["\n      margin-left: auto;\n    "],["\n      margin-left: auto;\n    "]),_templateObject34=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  fill: ",";\n\n  ",";\n"],["\n  position: absolute;\n  top: 50%;\n  fill: ",";\n\n  ",";\n"]),_templateObject35=_taggedTemplateLiteral(["\n        transform: translateY(-50%) rotate(180deg);\n        right: -15px;\n      "],["\n        transform: translateY(-50%) rotate(180deg);\n        right: -15px;\n      "]),_templateObject36=_taggedTemplateLiteral(["\n      transform: translateY(-50%);\n      left: -15px;\n    "],["\n      transform: translateY(-50%);\n      left: -15px;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SpinnerContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Grid=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(_ref2){var theme=_ref2.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);},""/* @supports (display: grid) {
    display: grid;
    grid-template-columns: 1fr minmax(min-content, 3.5fr) 1fr;
    grid-gap: 15px;

    @media (max-width: 959px) {
      grid-template-columns: 0.5fr minmax(min-content, 3.5fr) 1fr;
      grid-gap: 10px;
    }

    & > div:first-of-type {
      ${({ theme }) => {
        if (theme.direction === "rtl")
          return css`
            text-align: right;
          `;

        return css`
          text-align: left;
        `;
      }};
    }

    & > div:last-of-type {
      ${({ theme }) => {
        if (theme.direction === "rtl")
          return css`
            text-align: left;
          `;

        return css`
          text-align: right;
        `;
      }};
    }
  } */);var WinnerHeader=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Grid)(_templateObject8);var WinnerContents=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Grid)(_templateObject9,function(_ref3){var theme=_ref3.theme;return theme.mainLight;});var WinnerPlace=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(_ref4){var theme=_ref4.theme;return theme.accent;});var WinnerReward=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var RatingRowGrid=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(_ref5){var theme=_ref5.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var RatingHeader=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(RatingRowGrid)(_templateObject13,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"10px";});var RatingContents=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var RatingRow=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(RatingRowGrid)(_templateObject15,function(_ref7){var theme=_ref7.theme;return theme.mainLight;},function(_ref8){var current=_ref8.current,theme=_ref8.theme;return current===true&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject16,theme.accent);});var RatingNumber=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject17,function(_ref9){var theme=_ref9.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject18);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject19);});var RatingName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20,function(_ref10){var theme=_ref10.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject21);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject22);});var RatingNameContents=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject23,function(_ref11){var current=_ref11.current,theme=_ref11.theme;return current?theme.accent:Object(__WEBPACK_IMPORTED_MODULE_10_polished__["a" /* rgba */])(theme.foreground,0.5);});var RatingID=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject24,function(_ref12){var theme=_ref12.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject25);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject26);});var RatingBalance=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject27);var RatingReward=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject28,function(_ref13){var theme=_ref13.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject29);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject30);});var Minus=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject31,function(_ref14){var theme=_ref14.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject32);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject33);});var Arrow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject34,function(_ref15){var theme=_ref15.theme;return theme.accent;},function(_ref16){var theme=_ref16.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject35);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject36);});function Reward(_ref17){var prize=_ref17.prize,prize_usd=_ref17.prize_usd;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__HowMuchInBucks__["a" /* default */],{value:prize||"0.00",valueUSD:prize_usd||"0.00",symbolStyle:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* Currency */],valueStyle:__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Value */]}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:"USD",Symbol:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* Currency */],Value:__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Value */]},prize_usd||"0.00");});}function ItemRow(_ref18){var place=_ref18.place,user_id=_ref18.user_id,user_name=_ref18.user_name,funds_available=_ref18.funds_available,prize=_ref18.prize,prize_usd=_ref18.prize_usd,current_place=_ref18.current_place;var current=place===current_place;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingRow,{current:current},current?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Arrow,{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 19.799 19.799",width:"20px"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M14,0V14H0Z",transform:"translate(0 9.9) rotate(-45)"})):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingNumber,null,place),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingName,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingNameContents,{current:current},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingID,null,user_id),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return user_name;}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingBalance,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:__WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__["b" /* tournamentCurrency */],Symbol:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* Currency */],Value:__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Value */]},funds_available)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingReward,null,current===true||prize!=null||prize_usd!=null?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Reward,{prize:prize,prize_usd:prize_usd}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Minus,null)));}function RatingTable(_ref19){var children=_ref19.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingHeader,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingNumber,null,"#"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingName,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(max-width: 479px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"id"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"id/trader");})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingBalance,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Balance")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingReward,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Reward"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingContents,null,children));}function WinnerTable(_ref20){var place=_ref20.place,prize=_ref20.prize,prize_usd=_ref20.prize_usd,funds_available=_ref20.funds_available;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WinnerHeader,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,"#"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Reward")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Balance"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WinnerContents,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WinnerPlace,null,place),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WinnerReward,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Icons_Tournaments__["d" /* ColorfulCup */],{width:"28px"}),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Reward,{prize:prize,prize_usd:prize_usd})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:__WEBPACK_IMPORTED_MODULE_9__Icons_Kuchka__["b" /* tournamentCurrency */],Symbol:__WEBPACK_IMPORTED_MODULE_11__styles__["a" /* Currency */],Value:__WEBPACK_IMPORTED_MODULE_11__styles__["h" /* Value */]},funds_available))));}var Spinner=function Spinner(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SpinnerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Spinners_SimpleSpinner__["c" /* default */],{accent:true}));};function Leaderboard(_ref21){var api=_ref21.api,id=_ref21.id,limit=_ref21.limit,current_place=_ref21.current_place,participant_count=_ref21.participant_count,winner=_ref21.winner;var leaderboard=null;var offset=0;if(id==null){return null;}if(current_place!=null&&Number.isNaN(current_place)===false){offset=current_place-2;// запрашиваем с оффсетом -1
switch(true){case winner:// если юзер - победитель, запрашиваем с оффсетом 0
offset=current_place-1;break;case current_place===participant_count:// если юзер в самом конце, запрашиваем с оффсетом -2
offset=current_place-3;break;default:break;}if(offset<0){// места меньше 0 быть не может
offset=0;}}leaderboard=__WEBPACK_IMPORTED_MODULE_2_idx___default()(api.readEntity("/api/tournaments/leaderboard?tournament_id="+id+"&limit="+limit+"&offset="+offset),function(leaderboard){return leaderboard.value.items;});if(leaderboard==null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Spinner,null);}if(winner===true){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](WinnerTable,leaderboard[0]);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RatingTable,null,leaderboard.map(function(item){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemRow,Object.assign({key:item.user_id+item.place,current_place:current_place},item));}));}/* harmony default export */ __webpack_exports__["a"] = (Leaderboard);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Input__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ErrorText__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons__ = __webpack_require__(147);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.5);\n  z-index: 10000;\n"],["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0,0,0,0.5);\n  z-index: 10000;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 500px;\n  padding: 10px 35px 25px;\n  border-radius: 5px;\n  font-size: ",";\n  text-align: center;\n  background: #f6f6f6;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 90%;\n  max-width: 500px;\n  padding: 10px 35px 25px;\n  border-radius: 5px;\n  font-size: ",";\n  text-align: center;\n  background: #f6f6f6;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 1.2;\n  padding: 0 11px;\n  color: #343434;\n  text-align: center;\n  margin: 20px 0;\n  @media (max-width: 959px) {\n    font-size: 19px;\n  }\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n"],["\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 1.2;\n  padding: 0 11px;\n  color: #343434;\n  text-align: center;\n  margin: 20px 0;\n  @media (max-width: 959px) {\n    font-size: 19px;\n  }\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  width: 90%;\n  max-width: 350px;\n  margin: 0 auto 20px;\n"],["\n  width: 90%;\n  max-width: 350px;\n  margin: 0 auto 20px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: inline-block;\n  min-width: 100px;\n  text-align: center;\n"],["\n  display: inline-block;\n  min-width: 100px;\n  text-align: center;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 16px;\n  height: 16px;\n  background-size: cover;\n  cursor: pointer;\n  :before {\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n    content: \"\";\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :after {\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n    content: \"\";\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :hover {\n    :before {\n      border-left-color: #60a31c;\n    }\n    :after {\n      border-left-color: #60a31c;\n    }\n  }\n"],["\n  position: absolute;\n  top: 18px;\n  right: 18px;\n  width: 16px;\n  height: 16px;\n  background-size: cover;\n  cursor: pointer;\n  :before {\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n    content: \"\";\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :after {\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n    content: \"\";\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :hover {\n    :before {\n      border-left-color: #60a31c;\n    }\n    :after {\n      border-left-color: #60a31c;\n    }\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  ","\n\n  ","\n"],["\n  ","\n\n  ","\n"]),_templateObject8=_taggedTemplateLiteral(["\n    margin-top: 5px;\n    text-align: center;\n  "],["\n    margin-top: 5px;\n    text-align: center;\n  "]),_templateObject9=_taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 1.2;\n  "],["\n    font-size: 16px;\n    line-height: 1.2;\n  "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h2(_templateObject3);var InputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Close=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var Notification=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.type==="error"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);},function(props){return props.type==="success"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});var ReferralsPopup=function(_Component){_inherits(ReferralsPopup,_Component);function ReferralsPopup(props){_classCallCheck(this,ReferralsPopup);var _this=_possibleConstructorReturn(this,(ReferralsPopup.__proto__||Object.getPrototypeOf(ReferralsPopup)).call(this,props));_this.state={value:""};_this.onChange=_this.onChange.bind(_this);_this.onSubmit=_this.onSubmit.bind(_this);return _this;}_createClass(ReferralsPopup,[{key:"onChange",value:function onChange(value){this.setState({value:value.trim()});}},{key:"onSubmit",value:function onSubmit(){if(typeof this.props.onSubmit==="function"&&this.state.value){this.props.onSubmit(this.state.value);}}},{key:"render",value:function render(){var _props=this.props,title=_props.title,submitTitle=_props.submitTitle,type=_props.type,sending=_props.sending,onClose=_props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Popup,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Close,{onClick:onClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,title,":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Input__["b" /* default */],{type:type,id:"popup-input",label:title,onChange:this.onChange,value:this.state.value,desktop:true,focus:true,Icon:type==="email"&&__WEBPACK_IMPORTED_MODULE_5__Icons__["c" /* MailIcon */]||__WEBPACK_IMPORTED_MODULE_5__Icons__["e" /* PhoneIcon */]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,null,!this.props.requestSuccess&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Button__["a" /* default */],{title:submitTitle,onClick:this.onSubmit,disabled:!this.state.value||sending,showSpinner:sending}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Notification,{type:this.props.requestSuccess?"success":"error"},this.props.requestSuccess?this.props.responseMessage:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ErrorText__["a" /* default */],null,this.props.responseMessage))));}}]);return ReferralsPopup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReferralsPopup);

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Social_Facebook__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Social_Twitter__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Social_Email__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Social_SMS__ = __webpack_require__(1526);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n  padding: 0;\n  font-size: ",";\n  line-height: 2;\n  text-transform: uppercase;\n  text-decoration: none;\n  color: #797979;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  @media (max-width: 320px) {\n    font-size: ",";\n  }\n\n  &:not(:last-child) {\n    margin-right: 38px;\n  }\n\n  @media (max-width: 540px) {\n    &:not(:last-child) {\n      margin-right: 20px;\n    }\n  }\n"],["\n  display: block;\n  padding: 0;\n  font-size: ",";\n  line-height: 2;\n  text-transform: uppercase;\n  text-decoration: none;\n  color: #797979;\n  background: none;\n  border: none;\n  cursor: pointer;\n\n  @media (max-width: 320px) {\n    font-size: ",";\n  }\n\n  &:not(:last-child) {\n    margin-right: 38px;\n  }\n\n  @media (max-width: 540px) {\n    &:not(:last-child) {\n      margin-right: 20px;\n    }\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 49px;\n  height: 49px;\n  border-radius: 50%;\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 49px;\n  height: 49px;\n  border-radius: 50%;\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n"]),_templateObject3=_taggedTemplateLiteral(["\n      background-color: #3b5998;\n    "],["\n      background-color: #3b5998;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      background-color: #55acee;\n    "],["\n      background-color: #55acee;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      background-color: #dc4e41;\n    "],["\n      background-color: #dc4e41;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      background-color: #8dc700;\n    "],["\n      background-color: #8dc700;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  width: 9px;\n  height: 19px;\n  color: #ffffff;\n"],["\n  width: 9px;\n  height: 19px;\n  color: #ffffff;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  width: 23px;\n  height: 19px;\n  color: #ffffff;\n"],["\n  width: 23px;\n  height: 19px;\n  color: #ffffff;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  width: 24px;\n  height: 16px;\n  color: #ffffff;\n"],["\n  width: 24px;\n  height: 16px;\n  color: #ffffff;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  width: 25px;\n  height: 22px;\n  color: #ffffff;\n"],["\n  width: 25px;\n  height: 22px;\n  color: #ffffff;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"10px";});var TopContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref3){var id=_ref3.id;return id==="facebook"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);},function(_ref4){var id=_ref4.id;return id==="twitter"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);},function(_ref5){var id=_ref5.id;return id==="email"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);},function(_ref6){var id=_ref6.id;return id==="sms"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var FacebookIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var TwitterIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var EmailIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var SMSIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var ReferralsLink=function(_Component){_inherits(ReferralsLink,_Component);function ReferralsLink(props){_classCallCheck(this,ReferralsLink);var _this=_possibleConstructorReturn(this,(ReferralsLink.__proto__||Object.getPrototypeOf(ReferralsLink)).call(this,props));_this.onClick=_this.onClick.bind(_this);return _this;}_createClass(ReferralsLink,[{key:"onClick",value:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("CLICKBTN_REF_SHARE",{clickId:e.currentTarget.id,pagePath:window.document.location.pathname});e.preventDefault();if(typeof this.props.onClick==="function"){this.props.onClick();}}},{key:"render",value:function render(){var _props=this.props,name=_props.name,id=_props.id,desktop=_props.desktop,isIndexPage=_props.isIndexPage,hideName=_props.hideName;var icon=function icon(){switch(id){case"facebook":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FacebookIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_Social_Facebook__["a" /* default */],null));case"twitter":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TwitterIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_Social_Twitter__["a" /* default */],null));case"email":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EmailIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Social_Email__["a" /* default */],null));case"sms":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SMSIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Icons_Social_SMS__["a" /* default */],null));default:return;}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{desktop:desktop,title:id,id:id,onClick:this.onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopContainer,{id:id},icon()),!desktop&&!isIndexPage&&!hideName&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,name));}}]);return ReferralsLink;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ReferralsLink);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var FacebookIcon=function FacebookIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"8.564",height:"18.576",viewBox:"0 0 8.564 18.576",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M46.031,31.033h-2.54v9.306H39.642V31.033h-1.83v-3.27h1.83V25.646a3.609,3.609,0,0,1,3.883-3.883l2.851.012v3.174H44.307a.783.783,0,0,0-.816.891v1.925h2.876Z",transform:"translate(-37.812 -21.763)"}));};/* harmony default export */ __webpack_exports__["a"] = (FacebookIcon);

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var TwitterIcon=function TwitterIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"22.719",height:"18.463",viewBox:"0 0 22.719 18.463",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M47.822,36.214a9.3,9.3,0,0,1-2.677.733,4.674,4.674,0,0,0,2.05-2.578,9.331,9.331,0,0,1-2.96,1.131,4.665,4.665,0,0,0-7.943,4.252,13.231,13.231,0,0,1-9.607-4.871A4.666,4.666,0,0,0,28.126,41.1a4.628,4.628,0,0,1-2.111-.584c0,.02,0,.04,0,.059a4.664,4.664,0,0,0,3.739,4.57,4.679,4.679,0,0,1-2.1.081A4.666,4.666,0,0,0,32,48.467a9.409,9.409,0,0,1-6.9,1.93A13.255,13.255,0,0,0,45.509,39.229c0-.2,0-.4-.014-.6a9.452,9.452,0,0,0,2.326-2.412Z",transform:"translate(-25.103 -34.028)"})));};/* harmony default export */ __webpack_exports__["a"] = (TwitterIcon);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var EmailIcon=function EmailIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"24",height:"15.859",viewBox:"0 0 24 15.859",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-1120.975-17899.666a2.6,2.6,0,0,1-.652-.131l5.984-5.93,1.174,1.16a4,4,0,0,0,2.828,1.16,4,4,0,0,0,2.828-1.16l1.174-1.16,5.984,5.93a2.6,2.6,0,0,1-.652.131Zm15.22-7.932,5.981-5.928a2.494,2.494,0,0,1,.132.643v10.574a2.545,2.545,0,0,1-.131.641Zm-17.887,5.289v-10.574a2.554,2.554,0,0,1,.131-.643l5.982,5.928-5.982,5.928A2.524,2.524,0,0,1-1123.642-17902.309Zm11.057-4.125-9.04-8.961a2.571,2.571,0,0,1,.649-.131h18.667a2.587,2.587,0,0,1,.649.131l-9.04,8.961a1.338,1.338,0,0,1-.943.387A1.334,1.334,0,0,1-1112.585-17906.434Z",transform:"translate(1123.642 17915.525)"}));};/* harmony default export */ __webpack_exports__["a"] = (EmailIcon);

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var SMSIcon=function SMSIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"24.9",height:"21.723",viewBox:"0 0 24.9 21.723",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19.541,31.26H5.359A5.425,5.425,0,0,0,0,36.736V42.16a5.425,5.425,0,0,0,5.359,5.476h8.964l6.517,5.347V47.471A5.454,5.454,0,0,0,24.9,42.16V36.736A5.425,5.425,0,0,0,19.541,31.26ZM5.734,41.787a3.43,3.43,0,0,1-1.566-.337l.267-1.081a2.943,2.943,0,0,0,1.3.367c.456,0,.644-.159.644-.407s-.149-.367-.714-.555c-1-.337-1.388-.882-1.378-1.457,0-.9.774-1.586,1.973-1.586a3.249,3.249,0,0,1,1.369.277L7.36,38.05a2.374,2.374,0,0,0-1.051-.278c-.367,0-.575.149-.575.4,0,.228.188.347.783.555.922.317,1.309.783,1.318,1.5C7.836,41.123,7.122,41.787,5.734,41.787Zm10.34-.1H14.607V39.051c0-.7-.229-1.111-.714-1.111a.737.737,0,0,0-.694.526,1.262,1.262,0,0,0-.059.387v2.835H11.672V38.971c0-.615-.218-1.031-.695-1.031a.767.767,0,0,0-.7.546,1,1,0,0,0-.059.377v2.825H8.747v-3.3c0-.6-.02-1.12-.04-1.546H9.977l.069.654h.03a1.682,1.682,0,0,1,1.467-.763,1.374,1.374,0,0,1,1.328.822h.02a2.164,2.164,0,0,1,.625-.584,1.75,1.75,0,0,1,.923-.238c.932,0,1.636.654,1.636,2.1v2.856Zm2.486.1a3.43,3.43,0,0,1-1.566-.337l.267-1.081a2.943,2.943,0,0,0,1.3.367c.456,0,.644-.159.644-.407s-.149-.367-.714-.555c-1-.337-1.388-.882-1.378-1.457,0-.9.774-1.586,1.973-1.586a3.252,3.252,0,0,1,1.369.277l-.267,1.041a2.374,2.374,0,0,0-1.051-.278c-.367,0-.575.149-.575.4,0,.228.188.347.783.555.922.317,1.309.783,1.318,1.5C20.662,41.123,19.948,41.787,18.56,41.787Z",transform:"translate(0 -31.26)"}));};/* harmony default export */ __webpack_exports__["a"] = (SMSIcon);

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Copy=function Copy(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"18.792",height:"18.793",viewBox:"0 0 18.792 18.793",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M17.825,11.472l-2.4-2.4a3.336,3.336,0,0,0-4.744.046L9.673,8.11A3.239,3.239,0,0,0,10.686,5.7,3.179,3.179,0,0,0,9.73,3.365L7.358.982A3.155,3.155,0,0,0,5.009,0,3.18,3.18,0,0,0,2.671.959L.979,2.64A3.142,3.142,0,0,0,0,4.978,3.2,3.2,0,0,0,.967,7.327l2.4,2.4a3.2,3.2,0,0,0,2.349.967,3.225,3.225,0,0,0,2.4-1.013L9.12,10.689A3.239,3.239,0,0,0,8.107,13.1a3.18,3.18,0,0,0,.956,2.338l2.372,2.383a3.322,3.322,0,0,0,4.686.023l1.693-1.681a3.143,3.143,0,0,0,.979-2.338A3.2,3.2,0,0,0,17.825,11.472ZM8.107,6.544l-.213-.219q-.178-.184-.247-.248A2.784,2.784,0,0,0,7.427,5.9a.928.928,0,0,0-.294-.15,1.173,1.173,0,0,0-.317-.04A1.1,1.1,0,0,0,5.712,6.82a1.173,1.173,0,0,0,.04.317.924.924,0,0,0,.15.294,2.77,2.77,0,0,0,.173.219q.063.069.247.248l.219.213a1.113,1.113,0,0,1-.829.357,1.062,1.062,0,0,1-.783-.311l-2.4-2.4a1.067,1.067,0,0,1-.322-.783,1.052,1.052,0,0,1,.322-.771L4.226,2.525a1.112,1.112,0,0,1,.783-.311,1.066,1.066,0,0,1,.783.322L8.164,4.92a1.066,1.066,0,0,1,.322.783A1.118,1.118,0,0,1,8.107,6.544Zm8.153,8.048-1.693,1.681a1.11,1.11,0,0,1-.783.3A1.061,1.061,0,0,1,13,16.262l-2.372-2.384a1.066,1.066,0,0,1-.322-.783,1.117,1.117,0,0,1,.38-.841l.213.219q.178.184.248.248a2.734,2.734,0,0,0,.219.173.923.923,0,0,0,.294.15,1.171,1.171,0,0,0,.317.04,1.1,1.1,0,0,0,1.106-1.105,1.18,1.18,0,0,0-.04-.317.921.921,0,0,0-.15-.294,2.781,2.781,0,0,0-.173-.219q-.063-.069-.248-.248l-.219-.213a1.1,1.1,0,0,1,.829-.369,1.065,1.065,0,0,1,.783.322l2.4,2.395a1.066,1.066,0,0,1,.322.783A1.052,1.052,0,0,1,16.26,14.592Z",transform:"translate(18.795) rotate(90)"}));};/* harmony default export */ __webpack_exports__["a"] = (Copy);

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Header__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Button__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StartInfo__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ThemeProvider__ = __webpack_require__(53);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    align-content: center;\n    justify-content: center;\n  }\n"],["\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    align-content: center;\n    justify-content: center;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: block;\n  flex-shrink: 0;\n\n  @media (min-width: 960px) {\n    margin: 0 auto 36px;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    align-self: center;\n    flex-basis: 54px;\n  }\n\n  @media (max-width: 479px) {\n    margin: 0 auto 15px;\n  }\n"],["\n  display: block;\n  flex-shrink: 0;\n\n  @media (min-width: 960px) {\n    margin: 0 auto 36px;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    align-self: center;\n    flex-basis: 54px;\n  }\n\n  @media (max-width: 479px) {\n    margin: 0 auto 15px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  @media (min-width: 480px) and (max-width: 959px) {\n    margin-bottom: 15px;\n  }\n"],["\n  @media (min-width: 480px) and (max-width: 959px) {\n    margin-bottom: 15px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  margin-bottom: 1em;\n  font-size: 36px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    font-size: 24px;\n    margin-bottom: 0.5em;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    font-size: 18px;\n  }\n"],["\n  margin-bottom: 1em;\n  font-size: 36px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    font-size: 24px;\n    margin-bottom: 0.5em;\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    font-size: 18px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: table;\n  min-width: 163px;\n  margin: 15px auto;\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    margin: 9px auto;\n  }\n"],["\n  display: table;\n  min-width: 163px;\n  margin: 15px auto;\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    margin: 9px auto;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  margin-bottom: 9px;\n\n  @media (max-width: 959px) {\n    line-height: 1.25;\n    margin-bottom: 0.5em;\n  }\n"],["\n  margin-bottom: 9px;\n\n  @media (max-width: 959px) {\n    line-height: 1.25;\n    margin-bottom: 0.5em;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    margin-bottom: 15px;\n  }\n"],["\n  @media (max-width: 959px) {\n    margin-bottom: 15px;\n  }\n"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__styles__["i" /* Wrapper */])(_templateObject);var CupIcon=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_12__Icons_Tournaments__["d" /* ColorfulCup */])(_templateObject2);var Header=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__Header__["a" /* default */])(_templateObject3);var Heading=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* Text */])(_templateObject4,function(_ref){var theme=_ref.theme;return theme.lightWhiteAccent;});var ButtonContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject5);var Title=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* Text */])(_templateObject6);var Info=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* Info */])(_templateObject7);var StartPopup=function(_React$Component){_inherits(StartPopup,_React$Component);function StartPopup(){var _ref2,_this2=this;var _temp,_this,_ret;_classCallCheck(this,StartPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=StartPopup.__proto__||Object.getPrototypeOf(StartPopup)).call.apply(_ref2,[this].concat(args))),_this),_this.activateTournament=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var _this$props,api,location,history,activate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,api=_this$props.api,location=_this$props.location,history=_this$props.history;_context.next=3;return api.fetchEntity("/api/tournaments/activate?id="+id);case 3:activate=_context.sent;if(!(activate!=null)){_context.next=13;break;}api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");api.fetchEntity("/api/tournaments/info?id="+id);_context.next=10;return api.fetchEntity("/api/tournaments/stats");case 10:_this.props.dispatch({type:"ENGAGE_TOURNAMENT_MODE"});_this.props.onDismiss();if(location.pathname!=="/trade"){history.push("/trade");}case 13:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(StartPopup,[{key:"componentDidMount",value:function componentDidMount(){var _props=this.props,api=_props.api,id=_props.id;if(typeof id==="number"){api.fetchEntity("/api/tournaments/info?id="+id);}}},{key:"render",value:function render(){var _this3=this;var _props2=this.props,onDismiss=_props2.onDismiss,api=_props2.api,style=_props2.style,id=_props2.id,location=_props2.location;switch(location.pathname){case"/withdraw":case"/fillup":case"/verification":return null;default:break;}if(id==null){return null;}var tournament=__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/tournaments/info?id="+id),function(info){return info.value;});if(tournament==null){return null;}var isAndroid=window.androidApp!==undefined;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["e" /* Popup */],{onDismiss:onDismiss,style:style,fades:false},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Header,Object.assign({Cup:function Cup(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CupIcon,{width:"54px"});}},tournament),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"GO!")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Tournament"),": ",tournament.title))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__StartInfo__["a" /* InfoBlock */],tournament)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Button__["a" /* default */],{color:"yellow",withShadow:true,onClick:isAndroid?function(){return window.androidApp.tournamentTrade(tournament.id);}:function(){return _this3.activateTournament(tournament.id);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Trade"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* LinkContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* Link */],{to:"/tournaments/"+tournament.id,onClick:onDismiss},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Learn more")))));}}]);return StartPopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])()(function(props){var api=__WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_8__Api__["c" /* default */]);var theme=__WEBPACK_IMPORTED_MODULE_1_react__["useContext"](__WEBPACK_IMPORTED_MODULE_13__ThemeProvider__["b" /* TradeThemeContext */]);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5_styled_components__["b" /* ThemeProvider */],{theme:theme},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](StartPopup,Object.assign({},props,{api:api,key:props.id})));})));

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBlock; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles__ = __webpack_require__(111);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n  }\n"],["\n  display: flex;\n  justify-content: space-between;\n  flex-grow: 1;\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    flex-direction: row;\n    font-size: ",";\n\n    :not(:last-child) {\n      margin-bottom: 5px;\n    }\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    flex-direction: row;\n    font-size: ",";\n\n    :not(:last-child) {\n      margin-bottom: 5px;\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: 10px;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    margin-right: ","px;\n    margin-left: ","px;\n  }\n\n  @media (min-width: 960px) {\n    margin-bottom: 5px;\n  }\n"],["\n  font-size: 10px;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    margin-right: ","px;\n    margin-left: ","px;\n  }\n\n  @media (min-width: 960px) {\n    margin-bottom: 5px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"],["\n  display: flex;\n  align-items: center;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin: 0 9px;\n  color: ",";\n"],["\n  margin: 0 9px;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  color: ",";\n\n  ",";\n"],["\n  color: ",";\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n        margin-right: 5px;\n      "],["\n        margin-right: 5px;\n      "]),_templateObject8=_taggedTemplateLiteral(["\n      margin-left: 5px;\n    "],["\n      margin-left: 5px;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    text-align: center;\n  }\n"],["\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    text-align: center;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Info=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Item=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var InfoTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.direction==="rtl"?0:5;},function(_ref3){var theme=_ref3.theme;return theme.direction==="rtl"?5:0;});var InfoItemContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Rating=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref4){var theme=_ref4.theme;return theme.accent;});var HowManyParticipants=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref5){var theme=_ref5.theme;return theme.lightWhiteForeground;},function(_ref6){var theme=_ref6.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var MoneyContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(HowManyParticipants)(_templateObject9);function ItemConstructor(_ref7){var children=_ref7.children,title=_ref7.title;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoTitle,null,title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoItemContent,null,children));}function Participants(_ref8){var participation_status=_ref8.participation_status,participant_count=_ref8.participant_count,current_place=_ref8.current_place,_ref8$show_rating=_ref8.show_rating,show_rating=_ref8$show_rating===undefined?false:_ref8$show_rating;if(participation_status===1&&show_rating===true){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemConstructor,{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Your rating"),":")},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["k" /* Rating */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Rating,null,"# ",current_place),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"of"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HowManyParticipants,null,participant_count));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemConstructor,{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Participants"),":")},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["i" /* Person */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HowManyParticipants,null,participant_count));}var InfoBlock=function InfoBlock(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemConstructor,{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Tournament balance"),":")},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["m" /* Wallet */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Money__["b" /* default */],{Value:__WEBPACK_IMPORTED_MODULE_6__styles__["k" /* Value */],Symbol:__WEBPACK_IMPORTED_MODULE_6__styles__["c" /* Currency */],currency:"USD"},props.account_money))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ItemConstructor,{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("span",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Prize fund"),":")},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["e" /* Cup */],{width:"16px",height:"20px"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HowMuchInBucks__["a" /* default */],{value:props.prize_fund,valueUSD:props.prize_fund_usd,valueStyle:__WEBPACK_IMPORTED_MODULE_6__styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_6__styles__["c" /* Currency */]}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Participants,props));};

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Buttons__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Bell_Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_Link__ = __webpack_require__(8);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  font-weight: 700;\n  text-transform: uppercase;\n  color: ",";\n"],["\n  font-weight: 700;\n  text-transform: uppercase;\n  color: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: block;\n  margin-top: 20px;\n  text-align: center;\n  font-size: 16px;\n  color: tomato;\n"],["\n  display: block;\n  margin-top: 20px;\n  text-align: center;\n  font-size: 16px;\n  color: tomato;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  @media (min-width: 960px) {\n    min-height: 650px;\n    width: 740px;\n    padding: 0;\n  }\n\n  @media (max-width: 959px) {\n    align-items: stretch;\n    align-content: stretch;\n  }\n"],["\n  @media (min-width: 960px) {\n    min-height: 650px;\n    width: 740px;\n    padding: 0;\n  }\n\n  @media (max-width: 959px) {\n    align-items: stretch;\n    align-content: stretch;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  align-items: stretch;\n  align-content: stretch;\n\n  @media (max-width: 959px) {\n    justify-content: stretch;\n  }\n"],["\n  align-items: stretch;\n  align-content: stretch;\n\n  @media (max-width: 959px) {\n    justify-content: stretch;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    min-height: 100%;\n  }\n"],["\n  @media (max-width: 959px) {\n    min-height: 100%;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  background-color: #272b34;\n\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  background-color: #272b34;\n\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 33px 0 40px;\n\n  //@media (max-width: 959px) {\n  //  padding: 72px 0 35px;\n  //}\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 33px 0 40px;\n\n  //@media (max-width: 959px) {\n  //  padding: 72px 0 35px;\n  //}\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  padding: 44px 16px 40px;\n  background-color: #181b20;\n  flex-grow: 1;\n\n  @media (max-width: 959px) {\n    padding: 36px 16px 45px;\n    margin-bottom: -80%;\n  }\n"],["\n  display: flex;\n  align-items: stretch;\n  flex-direction: column;\n  padding: 44px 16px 40px;\n  background-color: #181b20;\n  flex-grow: 1;\n\n  @media (max-width: 959px) {\n    padding: 36px 16px 45px;\n    margin-bottom: -80%;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  align-items: stretch;\n\n  //@media (max-width: 959px) {\n  //  align-items: center;\n  //}\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  align-items: stretch;\n\n  //@media (max-width: 959px) {\n  //  align-items: center;\n  //}\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  @media (min-width: 960px) {\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n\n  @media (min-width: 960px) {\n    flex-grow: 1;\n    flex-basis: 0;\n  }\n\n  @media (max-width: 959px) {\n    width: 100%;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 80px;\n  align-items: center;\n\n  @media (max-height: 959px) {\n    min-height: 60%;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 80px;\n  align-items: center;\n\n  @media (max-height: 959px) {\n    min-height: 60%;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  font-size: 18px;\n  text-align: left;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    text-align: center;\n  }\n"],["\n  font-size: 18px;\n  text-align: left;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    text-align: center;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 300px;\n  min-height: 37px;\n  padding: 8px 20px;\n  font-size: 12px;\n  font-weight: 900;\n  color: ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  background-color: transparent;\n  border: 2px solid ",";\n  border-radius: 18px;\n  transition: all 0.15s;\n\n  &:hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media (max-width: 959px) {\n    margin-top: 27px;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  max-width: 300px;\n  min-height: 37px;\n  padding: 8px 20px;\n  font-size: 12px;\n  font-weight: 900;\n  color: ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  background-color: transparent;\n  border: 2px solid ",";\n  border-radius: 18px;\n  transition: all 0.15s;\n\n  &:hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media (max-width: 959px) {\n    margin-top: 27px;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: 31px;\n\n  @media (max-width: 959px) {\n    margin-top: 23px;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  margin-top: 31px;\n\n  @media (max-width: 959px) {\n    margin-top: 23px;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: flex-start;\n  text-align: left;\n  font-size: 12px;\n  line-height: 18px;\n"],["\n  display: flex;\n  align-items: flex-start;\n  text-align: left;\n  font-size: 12px;\n  line-height: 18px;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  margin-right: 6px;\n"],["\n  display: flex;\n  flex-direction: column;\n  margin-right: 6px;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  width: 510px;\n  text-align: center;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    width: 80%;\n  }\n\n  @media (max-width: 959px) and (orientation: landscape) {\n    margin-top: 5vh;\n  }\n"],["\n  width: 510px;\n  text-align: center;\n  font-size: 28px;\n  font-weight: 500;\n  line-height: 28px;\n  color: #ffffff;\n\n  @media (max-width: 959px) {\n    width: 80%;\n  }\n\n  @media (max-width: 959px) and (orientation: landscape) {\n    margin-top: 5vh;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n  width: 312px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  color: #ffcc00;\n  margin-top: 33px;\n"],["\n  width: 312px;\n  text-align: center;\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 21px;\n  color: #ffcc00;\n  margin-top: 33px;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 70%;\n  margin: 32px 0 36px;\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 70%;\n  margin: 32px 0 36px;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  border-top: 1px solid;\n  height: 1px;\n"],["\n  flex-grow: 1;\n  border-top: 1px solid;\n  height: 1px;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  font-size: 20px;\n  margin: 0 7px;\n"],["\n  font-size: 20px;\n  margin: 0 7px;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toArray(arr){return Array.isArray(arr)?arr:Array.from(arr);}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Free=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject,function(_ref){var theme=_ref.theme;return theme.accent;});var Error=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var FreeLoaderPopup=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__Popup__["a" /* StyledPopup */])(_templateObject3);var MobileWrapper=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* MobileWrapper */])(_templateObject4);var Wrapper=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__styles__["l" /* Wrapper */])(_templateObject5);var Header=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6);var HeaderWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7);var ActionsWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject8);var Actions=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject9);var ActionBox=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10);var ActionBoxHeader=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject11);var ActionBoxTitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].h5(_templateObject12);var ActionBoxButton=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_17__common_Link__["a" /* Link */])(_templateObject13,function(_ref2){var color=_ref2.color;return color?color:"#ffffff";},function(_ref3){var color=_ref3.color;return color?color:"#ffffff";},function(_ref4){var color=_ref4.color;return color?color:"#ffffff";},function(_ref5){var hoverColor=_ref5.hoverColor;return hoverColor?hoverColor:"#0085EB";});var ActionBoxInfo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject14);var ActionBoxInfoText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject15);// const NewsLink = styled(_NewsLink)`
//   color: #ffcc00;
//   text-decoration: underline;
//   font-size: ${fontSize(12)};
//   text-transform: lowercase;
// `;
var InfoIconWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject16);var InfoIcon=function InfoIcon(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"18",height:"18",viewBox:"0 0 18 18",fill:"currentColor",fillRule:"evenodd"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("path",{d:"M942.01,299.952a8.055,8.055,0,1,0,8.055,8.055A8.056,8.056,0,0,0,942.01,299.952Zm-1,4.038h2.006v1.975h-2.006V303.99Zm2.978,7.97H940v-1h1v-2.95h-1v-1h3.01v3.953h0.972v1Z",transform:"translate(-933.016 -299)"}));};var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].h3(_templateObject17);var Advice=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].h4(_templateObject18);var DividerWrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject19);var DividerContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject20);var Line=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject21);var Word=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject22);var Divider=function Divider(_ref6){var children=_ref6.children,style=_ref6.style;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DividerContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Line,null),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Word,null,children),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Line,null));};function OrderSensitivePopup(_ref7){var inProp=_ref7.in,fetching=_ref7.fetching,onDismiss=_ref7.onDismiss,style=_ref7.style,_ref7$fades=_ref7.fades,fades=_ref7$fades===undefined?true:_ref7$fades,onClick=_ref7.onClick,children=_ref7.children,invited=_ref7.invited,error=_ref7.error;var _children=_toArray(children),title=_children[0],price=_children[1],content=_children.slice(2);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Popup__["a" /* StyledPopup */],{"in":inProp,style:style,fades:fades,onDismiss:onDismiss,nowrap:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["l" /* Wrapper */],{nowrap:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* MobileWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["j" /* Title */],null,title),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["d" /* Footer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* MoneyContainer */],null,price),content&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* Content */],null,content),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Buttons__["a" /* FlatButton */],{type:"deposit",invited:invited,onClick:function(_onClick){function onClick(){return _onClick.apply(this,arguments);}onClick.toString=function(){return _onClick.toString();};return onClick;}(function(){Object(__WEBPACK_IMPORTED_MODULE_15__GA__["a" /* gaReducer */])("CLICKBTN_JOIN_TOURNAMENT");onClick();}),disabled:fetching},fetching&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Spinners_SimpleSpinner__["c" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Join"))),error&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Error,null,error)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Link__["a" /* default */],{to:"/conditions"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Terms & Conditions"))));}function FreeloaderShare(_ref8){var inProp=_ref8.in,onDismiss=_ref8.onDismiss,style=_ref8.style;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FreeLoaderPopup,{"in":inProp,style:style,fades:!!style?false:true,onDismiss:onDismiss,big:true,full:true,stretch:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](MobileWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](HeaderWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"We've limited your access to tournaments at this moment")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Advice,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"This happened because there was no activity on your real account"),".\xA0",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Please perform one of the following actions to get full access")))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionsWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Actions,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBox,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxHeader,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxTitle,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Top up your trading account.")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxButton,{onClick:function onClick(){onDismiss({all:true,callback:null});},to:"/fillup"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Deposit")))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](DividerWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Divider,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Or"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBox,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxHeader,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxTitle,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Share the information about us.")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxButton,{to:"/profile?tab=referral",color:"#FFCC00",hoverColor:"#181B20",onClick:function onClick(){onDismiss({all:true,callback:null});}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Read more")))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxInfo,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InfoIconWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InfoIcon,null)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ActionBoxInfoText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Send us a direct link to the post you've made on FB/Twitter or another dedicated website, and we will check it. ",""))))))));}var JoinPopup=function(_React$Component){_inherits(JoinPopup,_React$Component);function JoinPopup(){var _ref9,_this2=this;var _temp,_this,_ret;_classCallCheck(this,JoinPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref9=JoinPopup.__proto__||Object.getPrototypeOf(JoinPopup)).call.apply(_ref9,[this].concat(args))),_this),_this.state={fetching:false,errorMessage:null,freeloader:false},_this.joinTournament=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id,apiParams){var _this$props,api,onDismiss,popupCallback,dispatch,join,info;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,api=_this$props.api,onDismiss=_this$props.onDismiss,popupCallback=_this$props.popupCallback,dispatch=_this$props.dispatch;_this.setState({fetching:true,errorMessage:null});_context.next=4;return api.fetchEntity("/api/tournaments/join?tournament_id="+id);case 4:join=_context.sent;if(!(join.status==="Resolved")){_context.next=42;break;}if(!(join.value&&join.value.freeloader)){_context.next=9;break;}_this.setState({freeloader:true,fetching:false});return _context.abrupt("return");case 9:Object(__WEBPACK_IMPORTED_MODULE_13__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Tournaments",eventAction:"tournament-join",eventLabel:"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0432\u0441\u0442\u0443\u043F\u0438\u043B \u0432 \u0442\u0443\u0440\u043D\u0438\u0440 #"+id});_context.next=12;return api.fetchEntity("/api/tournaments/info?id="+id);case 12:info=_context.sent;if(!(info.status==="Resolved")){_context.next=40;break;}if(!(Object(__WEBPACK_IMPORTED_MODULE_14__Timer__["d" /* getActive */])(info.value)===true)){_context.next=27;break;}_context.next=17;return api.fetchEntity("/api/tournaments/activate?id="+id);case 17:_context.next=19;return api.fetchEntity("/api/tournaments/stats");case 19:dispatch({type:"ENGAGE_TOURNAMENT_MODE"});if(!_this.props.fromTournamentsList){_context.next=27;break;}api.fetchEntity("/api/bell-tolls-items");if(typeof apiParams==="string"){api.fetchEntity("/api/tournaments"+apiParams);}_this.setState({fetching:false});onDismiss({all:true,callback:null});_this.props.history.push("/trade");return _context.abrupt("return");case 27:if(!_this.props.fromTournamentsList){_context.next=34;break;}api.fetchEntity("/api/bell-tolls-items");if(typeof apiParams==="string"){api.fetchEntity("/api/tournaments"+apiParams);}_this.setState({fetching:false});onDismiss({all:true,callback:null});_this.props.history.push("/tournaments/"+id);return _context.abrupt("return");case 34:if(typeof apiParams==="string"){api.fetchEntity("/api/tournaments"+apiParams);}else{api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");}api.fetchEntity("/api/bell-tolls-items");api.fetchEntity("/api/tournaments/stats");_this.setState({fetching:false});onDismiss({all:true,callback:popupCallback?function(){return popupCallback("success");}:null});return _context.abrupt("return");case 40:_context.next=43;break;case 42:if(join.status==="Rejected"){_this.setState({errorMessage:join.message});}case 43:_this.setState({fetching:false});case 44:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x,_x2){return _ref10.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(JoinPopup,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_15__GA__["a" /* gaReducer */])("SHOW_TOURNAMENT_JOIN_POPUP");}},{key:"render",value:function render(){var _this3=this;var _props=this.props,inProp=_props.in,onDismiss=_props.onDismiss,onDismissAll=_props.onDismissAll,api=_props.api,style=_props.style,dontRedirect=_props.dontRedirect,apiParams=_props.apiParams,location=_props.location,history=_props.history,match=_props.match,tournament=_objectWithoutProperties(_props,["in","onDismiss","onDismissAll","api","style","dontRedirect","apiParams","location","history","match"]);var id=tournament.id;if(tournament.participation_status===1&&!dontRedirect&&location.pathname!=="/trade"){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* Redirect */],{to:"/trade"});}if(this.state.freeloader){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FreeloaderShare,{"in":inProp,onDismiss:onDismiss});}var fades=onDismissAll==null?true:false;var type=tournament.subtype==="demo"?"pay":tournament.is_limited&&tournament.invited?tournament.pay_account==="demo"?"pay":"free":tournament.type;var invited=tournament.is_limited&&tournament.invited;switch(type){case"free":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OrderSensitivePopup,{invited:invited,"in":inProp,style:style,onDismiss:onDismiss,fetching:this.state.fetching,fades:fades,error:this.state.errorMessage,onClick:function onClick(){return _this3.joinTournament(id,apiParams);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Participation in the tournament ",tournament.title," is"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Free,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Free")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"This tournament is free of charge"));case"pay":return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](OrderSensitivePopup,{invited:invited,"in":inProp,style:style,onDismiss:onDismiss,fades:fades,fetching:this.state.fetching,error:this.state.errorMessage,onClick:function onClick(){return _this3.joinTournament(id,apiParams);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,tournament.subtype==="demo"?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"The following amount will be deducted from your DEMO account for participation in the tournament"):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"The following amount will be deducted from your account for participating in the tournament"),":"),tournament.pay_account==="demo"||tournament.subtype==="demo"?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* MoneyContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Bell_Item__["c" /* Money */],{Value:__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* Value */],Symbol:__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* Currency */]},tournament.participation_price))):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__HowMuchInBucks__["a" /* default */],{value:tournament.participation_price,valueUSD:tournament.participation_price_usd,valueStyle:__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* Currency */]})));default:return null;}}}]);return JoinPopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])()(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](JoinPopup,Object.assign({},props,{api:api}));});})));

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buttons__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_customConsole__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TournamentId__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  margin: 15px 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  justify-content: space-between;\n  align-content: space-between;\n\n  @media (max-width: 959px) {\n    max-width: calc(169px * 2 + 15px);\n  }\n\n  @media (max-width: 479px) {\n    justify-content: center;\n    align-content: center;\n  }\n"],["\n  width: 100%;\n  margin: 15px 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  justify-content: space-between;\n  align-content: space-between;\n\n  @media (max-width: 959px) {\n    max-width: calc(169px * 2 + 15px);\n  }\n\n  @media (max-width: 479px) {\n    justify-content: center;\n    align-content: center;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: table;\n  min-width: 169px;\n\n  @media (max-width: 479px) {\n    :not(:last-of-type) {\n      margin-bottom: 15px;\n    }\n  }\n"],["\n  display: table;\n  min-width: 169px;\n\n  @media (max-width: 479px) {\n    :not(:last-of-type) {\n      margin-bottom: 15px;\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  color: ",";\n"],["\n  margin-bottom: 20px;\n  color: ",";\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonsWrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject);var ButtonContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject2);var Name=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.accent;});var LeavePopup=function(_React$Component){_inherits(LeavePopup,_React$Component);function LeavePopup(){var _ref2,_this2=this;var _temp,_this,_ret;_classCallCheck(this,LeavePopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=LeavePopup.__proto__||Object.getPrototypeOf(LeavePopup)).call.apply(_ref2,[this].concat(args))),_this),_this.state={fetching:false},_this.leaveTournament=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var _this$props,_api,_onDismiss,_popupCallback,leave;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_this$props=_this.props,_api=_this$props.api,_onDismiss=_this$props.onDismiss,_popupCallback=_this$props.popupCallback;_this.setState({fetching:true});_context.next=5;return _api.fetchEntity("/api/tournaments/leave?tournament_id="+id);case 5:leave=_context.sent;if(!(leave.status==="Resolved")){_context.next=18;break;}Object(__WEBPACK_IMPORTED_MODULE_11__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Tournaments",eventAction:"tournament-leave",eventLabel:"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u0443\u0448\u0435\u043B \u0438\u0437 \u0442\u0443\u0440\u043D\u0438\u0440\u0430"+id});_context.t0=_this.props.fromTournamentsList;if(!_context.t0){_context.next=12;break;}_context.next=12;return _api.fetchEntity("/api/tournaments"+_this.props.apiParams);case 12:_api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");_api.fetchEntity("/api/bell-tolls-items");_api.fetchEntity("/api/tournaments/stats");_api.fetchEntity("/api/tournaments/info?id="+id);_this.setState({fetching:false});_onDismiss({all:true,callback:_popupCallback?function(){return _popupCallback("success");}:null});case 18:_context.next=24;break;case 20:_context.prev=20;_context.t1=_context["catch"](0);_this.setState({fetching:false});__WEBPACK_IMPORTED_MODULE_12__common_customConsole__["a" /* error */]("Leaving tournament went wrong! "+_context.t1);case 24:case"end":return _context.stop();}}},_callee,_this2,[[0,20]]);}));return function(_x){return _ref3.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LeavePopup,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_15__GA__["a" /* gaReducer */])("SHOW_TOURNAMENT_LEAVE_POPUP");var path=(this.props.match,function(match){return match.path;});var id=__WEBPACK_IMPORTED_MODULE_2_idx___default()(this.props.match,function(match){return match.params.id;});if(id!=null&&path!=null&&path==="/trade/tournaments/leave/:id"){this.props.changeTournamentId(id);return;}}},{key:"render",value:function render(){var _this3=this;var _props=this.props,inProp=_props.in,onDismiss=_props.onDismiss,style=_props.style,api=_props.api,props=_objectWithoutProperties(_props,["in","onDismiss","style","api"]);var id=props.id!=null?props.id:this.props.tournamentId;var tournament=props;if(id==null){return null;}if(!props.title){var info=__WEBPACK_IMPORTED_MODULE_2_idx___default()(api.readEntity("/api/tournaments/info?id="+id),function(info){return info.value;});if(info==null){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Popup__["a" /* StyledPopup */],{"in":inProp,style:style,fades:!!style?true:false,onDismiss:onDismiss},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["l" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Spinners_SimpleSpinner__["c" /* default */],{accent:true})));}tournament=info;}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Popup__["a" /* StyledPopup */],{"in":inProp,style:style,fades:!!style?false:true,onDismiss:onDismiss},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["l" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["f" /* MobileWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__styles__["j" /* Title */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Name,null,tournament.title),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Are you sure you want to leave the tournament?")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ButtonsWrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Buttons__["a" /* FlatButton */],{disabled:this.state.fetching,onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_15__GA__["a" /* gaReducer */])("CLICKBTN_LEAVE_TOURNAMENT");return _this3.leaveTournament(id);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",null,this.state.fetching&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Spinners_SimpleSpinner__["c" /* default */],null)," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Yes")))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Buttons__["a" /* FlatButton */],{disabled:this.state.fetching,type:"trade",onClick:onDismiss},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"No")))),!this.props.dontRedirect&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Link__["a" /* default */],{to:"/tournaments"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"All tournaments")))));}}]);return LeavePopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__TournamentId__["b" /* default */].Consumer,null,function(contextId){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LeavePopup,Object.assign({},props,contextId,{api:api,key:contextId.tournamentId}));});});}));

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buttons__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_customConsole__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__helpers_refill__ = __webpack_require__(322);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var RefillPopup=function(_React$Component){_inherits(RefillPopup,_React$Component);function RefillPopup(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,RefillPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=RefillPopup.__proto__||Object.getPrototypeOf(RefillPopup)).call.apply(_ref,[this].concat(args))),_this),_this.onRefillClick=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var _this$props,api,onDismiss,refill;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,api=_this$props.api,onDismiss=_this$props.onDismiss;onDismiss();_context.prev=2;_context.next=5;return api.fetchEntity("/api/tournaments/refill?tournament_id="+id);case 5:refill=_context.sent;if(refill.value!=null){api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");api.fetchEntity("/api/tournaments/info?id="+id);api.fetchEntity("/api/tournaments/stats");onDismiss({all:true});}_context.next=12;break;case 9:_context.prev=9;_context.t0=_context["catch"](2);__WEBPACK_IMPORTED_MODULE_10__common_customConsole__["a" /* error */](_context.t0);case 12:case"end":return _context.stop();}}},_callee,_this2,[[2,9]]);}));return function(_x){return _ref2.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(RefillPopup,[{key:"componentDidMount",value:function componentDidMount(){this.props.api.fetchEntity("/api/tournaments/stats");}},{key:"render",value:function render(){var _this3=this;var _props=this.props,inProp=_props.in,onDismiss=_props.onDismiss,style=_props.style,api=_props.api;var fades=this.props.onDismissAll==null?true:false;var stats=__WEBPACK_IMPORTED_MODULE_11_idx___default()(api.readEntity("/api/tournaments/stats"),function(stats){return stats.value;});if(stats==null){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* StyledPopup */],{style:style,"in":inProp,fades:fades,onDismiss:onDismiss},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["l" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["c" /* default */],{accent:true})));}var current_tournament=__WEBPACK_IMPORTED_MODULE_11_idx___default()(stats,function(stats){return stats.active_tournament;});if(current_tournament==null||!current_tournament.refill||!current_tournament.refill_costs){return null;}var _getRefillCosts=Object(__WEBPACK_IMPORTED_MODULE_12__helpers_refill__["b" /* getRefillCosts */])(current_tournament),cost_usd=_getRefillCosts.cost_usd,cost=_getRefillCosts.cost;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Popup__["a" /* StyledPopup */],{style:style,"in":inProp,fades:fades,onDismiss:onDismiss},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["l" /* Wrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["f" /* MobileWrapper */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["j" /* Title */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Top up a tournament account balance by"),":"),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["d" /* Footer */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["g" /* MoneyContainer */],null,cost_usd!=null&&cost!=null&&Number(cost_usd)>0&&Number(cost)>0?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__HowMuchInBucks__["a" /* default */],{value:cost,valueUSD:cost_usd,valueStyle:__WEBPACK_IMPORTED_MODULE_4__styles__["k" /* Value */],symbolStyle:__WEBPACK_IMPORTED_MODULE_4__styles__["c" /* Currency */]}):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["e" /* Free */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Free"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__styles__["b" /* Content */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"The funds will be deducted from your account for use in the tournament")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Buttons__["a" /* FlatButton */],{type:"trade",onClick:function onClick(){return _this3.onRefillClick(current_tournament.id);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Refill")))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Link__["a" /* default */],{to:"/conditions"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Terms & Conditions"))));}}]);return RefillPopup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Api__["c" /* default */].Consumer,null,function(api){var stats=__WEBPACK_IMPORTED_MODULE_11_idx___default()(api.readEntity("/api/tournaments/stats"),function(stats){return stats.value;});var current_tournament=__WEBPACK_IMPORTED_MODULE_11_idx___default()(stats,function(stats){return stats.active_tournament;});if(stats==null||current_tournament==null){return null;}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RefillPopup,Object.assign({},props,{api:api,key:current_tournament.id}));});});

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Item__ = __webpack_require__(92);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ButtonTradeReal=function(_React$Component){_inherits(ButtonTradeReal,_React$Component);function ButtonTradeReal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ButtonTradeReal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ButtonTradeReal.__proto__||Object.getPrototypeOf(ButtonTradeReal)).call.apply(_ref,[this].concat(args))),_this),_this.state={fetching:false},_this.refreshProfile=function(){return Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["d" /* get */])("/api/profile").then(function(payload){_this.props.dispatch({type:"RECEIVE_PROFILE",payload:payload});return payload;});},_this.closeAndRedirect=function(){var redirect=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"/trade";var onClick=_this.props.onClick;_this.setState({fetching:false});if(onClick)onClick();_this.props.history.push(redirect);},_this.toggleRealAccount=function(){_this.setState({fetching:true});var _this$props=_this.props,accounts=_this$props.accounts,profile=_this$props.profile;var account=__WEBPACK_IMPORTED_MODULE_3_idx___default()(accounts.find(function(account){return account.type==="real";}),function(account){return account.id;});var active_account=__WEBPACK_IMPORTED_MODULE_3_idx___default()(profile,function(profile){return profile.active_account_id;});if(account!=null){if(account===active_account){// we don't need no setAccount
_this.closeAndRedirect("/trade");return;}Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["d" /* get */])("/ajax/setAccount?id="+account).then(function(data){return data.status==="OK"&&_this.refreshProfile();}).then(function(data){_this.props.dispatch({type:"SWITCH_ACCOUNTS"});_this.closeAndRedirect("/trade");}).catch(function(error){return error;});return;}// if, somehow, real account is not present, which should not be possible
_this.closeAndRedirect("/fillup");},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ButtonTradeReal,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["a" /* Button */],{type:"trade",onClick:this.toggleRealAccount,disabled:this.state.fetching},this.state.fetching?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Item__["e" /* Spinner */],null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Trade"));}}]);return ButtonTradeReal;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){return{profile:state.profile,accounts:state.accounts};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ButtonTradeReal)));

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Item__ = __webpack_require__(92);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ButtonSubscribe=function(_React$Component){_inherits(ButtonSubscribe,_React$Component);function ButtonSubscribe(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ButtonSubscribe);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ButtonSubscribe.__proto__||Object.getPrototypeOf(ButtonSubscribe)).call.apply(_ref,[this].concat(args))),_this),_this.state={fetching:false},_this.subscribe=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this.setState({fetching:true});_context.next=3;return Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/profile-update?daily_mail=1");case 3:response=_context.sent;if(!(response.status==="OK")){_context.next=10;break;}_this.props.dispatch({type:"UPDATE_PROFILE",payload:{daily_mail:1}});_this.setState({fetching:false});_this.props.onClick();_this.props.history.push(response.redirect);return _context.abrupt("return");case 10:_this.setState({fetching:false});_this.props.onClick();case 12:case"end":return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ButtonSubscribe,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Item__["a" /* Button */],{type:"trade",disabled:this.state.fetching,onClick:this.subscribe},this.state.fetching?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Item__["e" /* Spinner */],null):this.props.children);}}]);return ButtonSubscribe;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])()(ButtonSubscribe)));

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DepositError__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__DepositSuccess__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VerificationError__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VerificationSuccess__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WithdrawError__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__WithdrawSuccess__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PushSubscription__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EmailSubscription__ = __webpack_require__(1543);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DepositError__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__DepositSuccess__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__WithdrawError__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_5__WithdrawSuccess__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__VerificationError__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__VerificationSuccess__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__PushSubscription__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__EmailSubscription__["a"]; });


/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DepositError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function DepositError(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"70px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 70 70",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-526 -878)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#334d5c",d:"M0,35A35,35,0,1,1,35,70,35,35,0,0,1,0,35Z",transform:"translate(526 878)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#67aeba",d:"M113.684,189.8H62.136a.536.536,0,0,0-.536.536v9.029a.536.536,0,0,0,.536.536h51.548a.536.536,0,0,0,.536-.536v-9.029A.536.536,0,0,0,113.684,189.8Z",transform:"translate(473.09 722.879)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#4b868c",width:"46.088",height:"4.796",transform:"translate(537.963 915.331)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#b9efbd",width:"43.704",height:"13.797",transform:"translate(539.148 915.331)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#a5dba7",d:"M93.2,208.6v4.289h43.718V208.6Z",transform:"translate(445.948 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#91c691",d:"M93.2,208.6v1.566h43.718V208.6Z",transform:"translate(445.948 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#71ad71",d:"M140.709,221.536V208.6h-.367v12.485H98.867V208.6H98.5v12.936Z",transform:"translate(441.396 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(539.896 915.331)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#598e59",width:"0.381",height:"4.289"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#598e59",width:"0.381",height:"4.289",transform:"translate(41.842)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#598e59",width:"0.381",height:"2.723",transform:"translate(0 1.566)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#4f7f4f",width:"0.381",height:"1.566",transform:"translate(539.896 915.331)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#598e59",width:"0.381",height:"2.723",transform:"translate(581.738 916.897)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#4f7f4f",width:"0.381",height:"1.566",transform:"translate(581.738 915.331)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(553.537 915.331)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#71ad71",d:"M202.663,220.408a7.461,7.461,0,0,0,6.066-11.808H196.6a7.461,7.461,0,0,0,6.066,11.808Z",transform:"translate(-195.2 -208.6)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#71ad71",d:"M217.218,208.6h0Z",transform:"translate(-203.703 -208.6)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#598e59",d:"M196.6,208.6a7.417,7.417,0,0,0-1.4,4.289h14.911a7.417,7.417,0,0,0-1.4-4.289Z",transform:"translate(358.337 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4f7f4f",d:"M199.861,208.6a7.645,7.645,0,0,0-.861,1.566h13.839a7.027,7.027,0,0,0-.861-1.566Z",transform:"translate(355.073 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#71ad71",d:"M252.073,244.3a2.193,2.193,0,0,0,.4-1.312,1.858,1.858,0,0,0-.268-1.072,2.315,2.315,0,0,0-1.1-.719v3.738A1.564,1.564,0,0,0,252.073,244.3Z",transform:"translate(310.323 678.73)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#86bc88",d:"M253.851,208.967a2.507,2.507,0,0,1,.381,1.114l1.058-.183a3.2,3.2,0,0,0-.409-1.3H253.4A1.4,1.4,0,0,1,253.851,208.967Z",transform:"translate(308.348 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#b9efbd",d:"M229.637,211.448a2.055,2.055,0,0,0,.748.9,3.666,3.666,0,0,0,1.284.578v3.894a1.4,1.4,0,0,1-1.03-.719,3.72,3.72,0,0,1-.423-1.453l-1.016.226a3.921,3.921,0,0,0,.409,1.622,2.671,2.671,0,0,0,.818.959,3.135,3.135,0,0,0,1.241.409v1.227h.607v-1.241a2.284,2.284,0,0,0,1.735-.9,3.293,3.293,0,0,0,.677-2.13,3.347,3.347,0,0,0-.169-1.072,3.108,3.108,0,0,0-.451-.861,2.47,2.47,0,0,0-.776-.621,5.945,5.945,0,0,0-1.016-.367v-3.4h-.607v3.259a1.982,1.982,0,0,1-.987-.677,1.8,1.8,0,0,1-.3-1.058,1.778,1.778,0,0,1,.339-1.086,1.5,1.5,0,0,1,.508-.437h-1.467a3.143,3.143,0,0,0-.4,1.622A3.222,3.222,0,0,0,229.637,211.448Zm2.638,1.651a2.315,2.315,0,0,1,1.1.719,1.858,1.858,0,0,1,.268,1.072,2.1,2.1,0,0,1-.395,1.312,1.452,1.452,0,0,1-.988.621V213.1Z",transform:"translate(329.134 706.817)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(539.148 915.331)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#91c691",d:"M112.964,208.6h0Z",transform:"translate(-93.2 -208.6)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#91c691",d:"M244.037,208.6Z",transform:"translate(-222.383 -208.6)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#b9efbd",d:"M231.669,239.041v3.894a1.4,1.4,0,0,1-1.03-.719,3.72,3.72,0,0,1-.423-1.453l-1.016.226a3.921,3.921,0,0,0,.409,1.622,2.671,2.671,0,0,0,.818.959,3.135,3.135,0,0,0,1.241.409v1.227h.607v-1.241a2.284,2.284,0,0,0,1.735-.9,3.293,3.293,0,0,0,.677-2.13,3.347,3.347,0,0,0-.169-1.072,3.108,3.108,0,0,0-.451-.861.609.609,0,0,1-.085-.1h-2.751A1.961,1.961,0,0,0,231.669,239.041Zm.607.169a2.315,2.315,0,0,1,1.1.72,1.858,1.858,0,0,1,.268,1.072,2.1,2.1,0,0,1-.4,1.312,1.452,1.452,0,0,1-.987.621V239.21Z",transform:"translate(329.134 680.705)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#a0d8a3",d:"M234.408,221.815a5.946,5.946,0,0,0-1.016-.367v-1.834h-.607v1.679a1.981,1.981,0,0,1-.988-.677,1.761,1.761,0,0,1-.282-1.016H230.5v.056a2.988,2.988,0,0,0,.268,1.312,2.055,2.055,0,0,0,.748.9,4.994,4.994,0,0,0,.846.451H235.1A2.66,2.66,0,0,0,234.408,221.815Z",transform:"translate(328.017 697.283)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#b9efbd",d:"M234.667,208.6Z",transform:"translate(325.698 706.731)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(558.503 915.331)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#86bc88",width:"0.607",height:"1.566",transform:"translate(2.299)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#86bc88",d:"M231.768,209.023a1.415,1.415,0,0,1,.494-.423H230.8a3.218,3.218,0,0,0-.4,1.566h1.016v-.042A1.929,1.929,0,0,1,231.768,209.023Z",transform:"translate(-230.4 -208.6)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(555.749 888.442)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"none",stroke:"#67aeba",strokeWidth:"2",d:"M2540.739,888.26l5.229-5.47,5.1,5.47",transform:"translate(-2540.739 -882.79)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:"#67aeba",strokeWidth:"2",y1:"25.968",transform:"translate(5.251 0.284)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(554.15 896.019)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#f63f27",cx:"6.774",cy:"6.774",r:"6.774"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M45.515,43.717l2-2a.564.564,0,0,0-.8-.8l-2,2-2-2a.564.564,0,0,0-.8.8l2,2-2,2a.564.564,0,1,0,.8.8l2-2,2,2a.564.564,0,1,0,.8-.8Z",transform:"translate(-37.942 -36.942)"}))));}

/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = DepositSuccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function DepositSuccess(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"61px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 61 61",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fedb41",d:"M30.619,0A30.606,30.606,0,0,0,0,30.381,30.81,30.81,0,0,0,30.619,61a30.5,30.5,0,0,0,0-61Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc3",d:"M287.381,30.381A30.606,30.606,0,0,1,257,61V0A30.4,30.4,0,0,1,287.381,30.381Z",transform:"translate(-226.381)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fea832",d:"M83.471,60A23.352,23.352,0,1,0,106.7,83.232,23.483,23.483,0,0,0,83.471,60Z",transform:"translate(-52.852 -52.852)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fe9923",d:"M280.232,83.232A23.483,23.483,0,0,1,257,106.7V60A23.277,23.277,0,0,1,280.232,83.232Z",transform:"translate(-226.381 -52.852)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fedb41",d:"M192.748,134.3h-1.787v-7.148h1.787a1.77,1.77,0,0,1,1.787,1.787,1.787,1.787,0,0,0,3.574,0,5.354,5.354,0,0,0-5.361-5.361h-1.787v-1.787a1.787,1.787,0,0,0-3.574,0v1.787h-2.025A5.354,5.354,0,0,0,180,128.936v3.574a5.354,5.354,0,0,0,5.361,5.361h2.025v7.387h-2.025a1.77,1.77,0,0,1-1.787-1.787,1.787,1.787,0,0,0-3.574,0,5.354,5.354,0,0,0,5.361,5.361h2.025v1.787a1.787,1.787,0,0,0,3.574,0v-1.787h1.787a5.354,5.354,0,0,0,5.361-5.361v-3.812A5.354,5.354,0,0,0,192.748,134.3Zm-5.361,0h-2.025a1.77,1.77,0,0,1-1.787-1.787v-3.574a1.77,1.77,0,0,1,1.787-1.787h2.025Zm7.148,9.174a1.77,1.77,0,0,1-1.787,1.787h-1.787v-7.387h1.787a1.77,1.77,0,0,1,1.787,1.787Z",transform:"translate(-158.555 -105.703)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fc3",d:"M260.574,134.3h-1.787v-7.148h1.787a1.77,1.77,0,0,1,1.787,1.787,1.787,1.787,0,0,0,3.574,0,5.354,5.354,0,0,0-5.361-5.361h-1.787v-1.787A1.724,1.724,0,0,0,257,120v32.406a1.724,1.724,0,0,0,1.787-1.787v-1.787h1.787a5.354,5.354,0,0,0,5.361-5.361v-3.812A5.354,5.354,0,0,0,260.574,134.3Zm1.787,9.174a1.77,1.77,0,0,1-1.787,1.787h-1.787v-7.387h1.787a1.77,1.77,0,0,1,1.787,1.787Z",transform:"translate(-226.381 -105.703)"}));}

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VerificationError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function VerificationError(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"65px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 65 63",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 -1)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 1)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ecf0f1",d:"M19.546,46.084l-8.711,4.767a7.828,7.828,0,0,0-1.4,1,29.1,29.1,0,0,0,37.487.1,7.726,7.726,0,0,0-1.536-1.032l-9.328-4.679a3.57,3.57,0,0,1-1.967-3.192V39.371a14.126,14.126,0,0,0,.882-1.138,21.561,21.561,0,0,0,2.9-5.862,2.938,2.938,0,0,0,2.078-2.8V25.655a2.93,2.93,0,0,0-.976-2.172V17.818S40.138,9,28.236,9s-10.742,8.817-10.742,8.817v5.666a2.926,2.926,0,0,0-.976,2.172v3.919a2.941,2.941,0,0,0,1.351,2.466A19.471,19.471,0,0,0,21.4,39.371v3.581A3.574,3.574,0,0,1,19.546,46.084Z",transform:"translate(0.96 -0.158)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_1361","data-name":"Group 1361"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#556080",d:"M29.694,1A29.289,29.289,0,0,0,10.409,52.682a7.758,7.758,0,0,1,1.385-.988L20.5,46.927a3.572,3.572,0,0,0,1.854-3.133V40.213a19.453,19.453,0,0,1-3.532-7.331,2.942,2.942,0,0,1-1.351-2.466V26.5a2.93,2.93,0,0,1,.976-2.172V18.659s-1.16-8.817,10.742-8.817,10.742,8.817,10.742,8.817v5.666a2.926,2.926,0,0,1,.976,2.172v3.919a2.938,2.938,0,0,1-2.078,2.8,21.561,21.561,0,0,1-2.9,5.862,14.126,14.126,0,0,1-.882,1.138v3.672a3.569,3.569,0,0,0,1.967,3.192l9.328,4.679a7.766,7.766,0,0,1,1.531,1.03A29.3,29.3,0,0,0,29.694,1Z",transform:"translate(0 -1)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(38.559 37.474)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#f63f27",cx:"13.22",cy:"13.263",rx:"13.22",ry:"13.263"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M49.091,46.552l3.9-3.908a1.1,1.1,0,0,0-1.558-1.563l-3.9,3.908-3.9-3.908a1.1,1.1,0,1,0-1.558,1.563l3.9,3.908-3.9,3.908a1.1,1.1,0,1,0,1.558,1.563l3.9-3.908,3.9,3.908a1.1,1.1,0,0,0,1.558-1.563Z",transform:"translate(-34.313 -33.289)"}))));}

/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VerificationSuccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function VerificationSuccess(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"65px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 65 63",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 -1)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 1)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ecf0f1",d:"M19.546,46.084l-8.711,4.767a7.829,7.829,0,0,0-1.4,1,29.1,29.1,0,0,0,37.487.1,7.727,7.727,0,0,0-1.536-1.032l-9.328-4.679a3.57,3.57,0,0,1-1.967-3.192V39.371a14.126,14.126,0,0,0,.882-1.138,21.561,21.561,0,0,0,2.9-5.862,2.938,2.938,0,0,0,2.078-2.8V25.655a2.93,2.93,0,0,0-.976-2.172V17.818S40.138,9,28.236,9s-10.742,8.817-10.742,8.817v5.666a2.926,2.926,0,0,0-.976,2.172v3.919a2.941,2.941,0,0,0,1.351,2.466A19.471,19.471,0,0,0,21.4,39.371v3.581A3.574,3.574,0,0,1,19.546,46.084Z",transform:"translate(0.96 -0.158)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_1368","data-name":"Group 1368"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#556080",d:"M29.694,1A29.289,29.289,0,0,0,10.409,52.682a7.758,7.758,0,0,1,1.385-.988L20.5,46.927a3.572,3.572,0,0,0,1.854-3.133V40.213a19.453,19.453,0,0,1-3.532-7.331,2.942,2.942,0,0,1-1.351-2.466V26.5a2.93,2.93,0,0,1,.976-2.172V18.659s-1.16-8.817,10.742-8.817,10.742,8.817,10.742,8.817v5.666a2.926,2.926,0,0,1,.976,2.172v3.919a2.938,2.938,0,0,1-2.078,2.8,21.561,21.561,0,0,1-2.9,5.862,14.13,14.13,0,0,1-.882,1.138v3.672a3.569,3.569,0,0,0,1.967,3.192l9.328,4.679a7.766,7.766,0,0,1,1.531,1.03A29.3,29.3,0,0,0,29.694,1Z",transform:"translate(0 -1)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(38.559 37.474)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#40c41c",cx:"13.22",cy:"13.263",rx:"13.22",ry:"13.263"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M13.823.15a1.1,1.1,0,0,0-1.534.276L6.127,9.309,1.775,5.724a1.1,1.1,0,1,0-1.4,1.708l5.275,4.344a1.1,1.1,0,0,0,.7.251,1.166,1.166,0,0,0,.151-.01,1.106,1.106,0,0,0,.753-.463L14.1,1.689A1.11,1.11,0,0,0,13.823.15Z",transform:"translate(7.418 5.858) rotate(7)"}))));}

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WithdrawError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function WithdrawError(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"73px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 73 78",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-509.987 -1291)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(509.988 1293.066)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"atm",transform:"translate(0 18.381)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#64798a",width:"51.206",height:"14.279",transform:"translate(6.314 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3a556a",d:"M148.269,40.613h-33.21a2.087,2.087,0,0,0,0,4.175h33.21a2.087,2.087,0,0,0,0-4.175Z",transform:"translate(-99.748 -35.926)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#3ea69b",width:"28.09",height:"40.27",transform:"translate(17.871 4.692)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#44c4a1",d:"M169.786,40.656V75.773a3.133,3.133,0,0,1,3.128,3.139h17.821a3.133,3.133,0,0,1,3.128-3.139V40.656Z",transform:"translate(-149.908 -35.964)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(22.334 9.671)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#3ea69b",cx:"9.582",cy:"7.597",rx:"9.582",ry:"7.597"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#3ea69b",cx:"1.713",cy:"1.719",rx:"1.713",ry:"1.719",transform:"translate(7.869 27.394)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#44c4a1",d:"M222.155,110.53H220.8a8.126,8.126,0,0,1-2.029,4.6l-1.62-1.364a6.49,6.49,0,0,0,1.62-3.233h-3.612a7.638,7.638,0,0,1-1.322,3.093,2.985,2.985,0,0,1-2.43.981,3.393,3.393,0,0,1-2.635-1.13,4.586,4.586,0,0,1-1.117-2.944h-.931v-1.2h.949a7.829,7.829,0,0,1,1.4-3.887l1.713,1.215a6.04,6.04,0,0,0-1.08,2.672h3.5v-.056a7.591,7.591,0,0,1,1.359-3.157,3.077,3.077,0,0,1,2.486-1.01,3.374,3.374,0,0,1,2.653,1.159,4.826,4.826,0,0,1,1.117,3.064h1.34v1.2Zm-12.017,1.318a1.33,1.33,0,0,0,1.042.476,1.31,1.31,0,0,0,.986-.374,3.779,3.779,0,0,0,.7-1.42h-3.221A2.243,2.243,0,0,0,210.138,111.848Zm8.163-3.934a1.435,1.435,0,0,0-2.113-.113,4.093,4.093,0,0,0-.717,1.533h3.351A2.619,2.619,0,0,0,218.3,107.915Z",transform:"translate(-182.522 -92.851)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fcd462",d:"M60.875,157.645a2.157,2.157,0,0,0-2.573.111l-6.647,5.4a1.586,1.586,0,0,1-2.519-.752,5.488,5.488,0,0,1-.187-.913,1.581,1.581,0,0,1,1.033-1.662l.883-.326V153.57l-5.572.941a5,5,0,0,0-4.1,4.124L37.38,181.928,48.466,185c5.882-5.829,7.076-9.854,7-13.1A8.545,8.545,0,0,1,57.1,166.73l4.322-6.029A2.168,2.168,0,0,0,60.875,157.645Z",transform:"translate(-32.994 -135.619)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#64798a",d:"M0,0,20.116.019l.008,8.356L.008,8.356Z",transform:"translate(19.336 57.553) rotate(-163.936)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M1.515,0A1.519,1.519,0,1,1,0,1.518,1.522,1.522,0,0,1,1.515,0Z",transform:"translate(18.905 54.66) rotate(-163.936)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3a556a",opacity:"0.5",d:"M150.349,42.7a2.084,2.084,0,0,0-2.08-2.087h-33.21a2.084,2.084,0,0,0-2.08,2.087",transform:"translate(-99.748 -35.926)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(47.004 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#f63f27",cx:"12.998",cy:"12.998",r:"12.998"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M48.968,46.436l3.83-3.83a1.083,1.083,0,0,0-1.532-1.532l-3.83,3.83-3.83-3.83a1.083,1.083,0,1,0-1.532,1.532l3.83,3.83-3.83,3.83A1.083,1.083,0,1,0,43.606,51.8l3.83-3.83,3.83,3.83A1.083,1.083,0,1,0,52.8,50.266Z",transform:"translate(-34.438 -33.438)"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00c0f4",d:"M18.664,8.4,10.12.2A.721.721,0,0,0,9.136.187L.092,8.4a.279.279,0,0,0,.187.486H3.507a.726.726,0,0,1,.725.728v8.255a.553.553,0,0,0,.552.554h9.154a.553.553,0,0,0,.552-.554V9.611a.726.726,0,0,1,.725-.728h3.257A.279.279,0,0,0,18.664,8.4Z",transform:"translate(551.756 1309.42) rotate(180)"})));}

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = WithdrawSuccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function WithdrawSuccess(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"56px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 56 56",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 -0.063)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(9.653 0.063)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#44c4a1",d:"M124.934,91.453a2.27,2.27,0,0,0-.338-1.2l-2.153-3.466a3.8,3.8,0,0,1-.405-1.719V74.393a12.55,12.55,0,0,0-12.549-12.552H103.7A12.55,12.55,0,0,0,91.149,74.393V85.071a3.793,3.793,0,0,1-.405,1.719l-2.153,3.466a2.27,2.27,0,0,0-.338,1.2h0A2.258,2.258,0,0,0,90.5,93.7h32.182A2.258,2.258,0,0,0,124.934,91.453Z",transform:"translate(-88.253 -55.082)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#44c4a1",d:"M195.953,6.822,200.779.063H185.335l4.826,6.759V8.753h5.792Z",transform:"translate(-174.717 -0.063)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3ea69b",d:"M213.968,129.556l-2.153-3.466a3.8,3.8,0,0,1-.405-1.719V113.692a12.55,12.55,0,0,0-2.635-7.724c-2.577,14.2-11.651,22.39-20.174,27.035h23.456a2.26,2.26,0,0,0,1.931-3.447Z",transform:"translate(-167.972 -94.319)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M221.376,147.063v-.618a3.253,3.253,0,0,0-3.243-3.244h-.618V141.27h-1.931V143.2h-.618a3.244,3.244,0,0,0-1.139,6.285l1.757.656v3.679h-.618a1.313,1.313,0,0,1-1.313-1.313h0v-.618h-1.931v.618a3.253,3.253,0,0,0,3.243,3.244h3.166a3.244,3.244,0,0,0,1.139-6.285l-1.757-.657v-3.679h.618a1.313,1.313,0,0,1,1.313,1.313h0v.618Zm-2.78,4.21a1.333,1.333,0,0,1,.849,1.236,1.313,1.313,0,0,1-1.313,1.313h-.618v-2.954Zm-3.012-3.186-1.081-.406a1.333,1.333,0,0,1-.849-1.236,1.313,1.313,0,0,1,1.313-1.313h.618Z",transform:"translate(-188.557 -125.759)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 1.994)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M401.006,25.437h0a4.692,4.692,0,0,0-3.861-3.862h0a4.692,4.692,0,0,0,3.861-3.862h0a4.692,4.692,0,0,0,3.861,3.862h0A4.692,4.692,0,0,0,401.006,25.437Z",transform:"translate(-353.707 -17.713)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fdb62f",d:"M3.861,201.947h0A4.691,4.691,0,0,0,0,198.085H0a4.692,4.692,0,0,0,3.861-3.862h0a4.692,4.692,0,0,0,3.861,3.862h0A4.691,4.691,0,0,0,3.861,201.947Z",transform:"translate(0 -174.913)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fec9a3",d:"M94.872,269.547a2.9,2.9,0,0,0-3.861-1.072l-13.7,5.851a1.937,1.937,0,0,1-.763.154H59.571a1.931,1.931,0,0,1,0-3.862h7.722a5.792,5.792,0,0,0,5.792-5.793H57.023a8.776,8.776,0,0,0-6.844,3.292l-6.052,7.328,6.815,12.494,26.227-6.3a13.925,13.925,0,0,0,3.263-1.2l13.514-6.923A2.9,2.9,0,0,0,94.872,269.547Z",transform:"translate(-39.301 -235.798)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f7bb8f",d:"M86.578,380.483l2.172,3.978,26.227-6.3a13.927,13.927,0,0,0,3.263-1.2l7.307-3.756C113.4,376.92,97.283,379.237,86.578,380.483Z",transform:"translate(-77.109 -332.318)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#4398d1",d:"M0,329.5v17.379H12.549l2.9-2.9L3.861,326.605Z",transform:"translate(0 -290.818)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#3e8cc7",d:"M0,462.422H12.549l2.9-2.9-2.124-3.186A68.254,68.254,0,0,1,0,460.307Z",transform:"translate(0 -406.359)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{fill:"#d9d9d9",cx:"1.931",cy:"1.931",rx:"1.931",ry:"1.931",transform:"translate(6.757 49.307)"})));}

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PushSubscription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function PushSubscription(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"56px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 56 65",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-33.6)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7900",d:"M180.8,476a16.57,16.57,0,0,0,8.918,3.021A15.485,15.485,0,0,0,198.637,476Z",transform:"translate(-128.119 -414.021)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"SVGCleanerId_0",fill:"#ffb000",d:"M87.526,137.492H85.037c0-1.042-.207-.625-.207-.833,0-9.375-6.637.1-8.711-22.4V110.2A14.688,14.688,0,0,0,61.6,95.2c-8.193,0-14.519,6.667-14.519,15v4.063c-2.074,22.6-8.711,13.021-8.711,22.5,0,.208-.207-.208-.207.833H35.674c-1.244,0-2.074.521-2.074,1.771v1.562c0,1.146.83,1.771,2.074,1.771H87.526c1.244,0,2.074-.625,2.074-1.875v-1.562C89.6,138.012,88.77,137.492,87.526,137.492Z",transform:"translate(0 -82.804)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(33.6 12.396)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"SVGCleanerId_0_1_",fill:"#ffb000",d:"M87.526,137.492H85.037c0-1.042-.207-.625-.207-.833,0-9.375-6.637.1-8.711-22.4V110.2A14.688,14.688,0,0,0,61.6,95.2c-8.193,0-14.519,6.667-14.519,15v4.063c-2.074,22.6-8.711,13.021-8.711,22.5,0,.208-.207-.208-.207.833H35.674c-1.244,0-2.074.521-2.074,1.771v1.562c0,1.146.83,1.771,2.074,1.771H87.526c1.244,0,2.074-.625,2.074-1.875v-1.562C89.6,138.012,88.77,137.492,87.526,137.492Z",transform:"translate(-33.6 -95.2)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffb000",d:"M198.074,15.417a7.708,7.708,0,1,1,7.674-7.708A7.674,7.674,0,0,1,198.074,15.417Zm0-12.292a4.583,4.583,0,1,0,4.563,4.583A4.614,4.614,0,0,0,198.074,3.125Z",transform:"translate(-136.474)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(39.304)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffc200",d:"M85.378,113.567C83.3,131.067,79.57,129.088,77.6,131.8c15.037-.833,26.237-12.083,26.859-25.833a94.268,94.268,0,0,0,0-10.833A15.266,15.266,0,0,0,100.1,94.4a14.8,14.8,0,0,0-14.726,15Z",transform:"translate(-77.6 -82.108)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffc200",d:"M205.541,6.146a7.655,7.655,0,1,0-10.474,8.646A12.289,12.289,0,0,0,205.541,6.146Zm-7.467-3.021a4.583,4.583,0,1,1-4.563,4.583A4.614,4.614,0,0,1,198.074,3.125Z",transform:"translate(-175.778)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#e83821",d:"M284.563,269.5a9.537,9.537,0,0,1-9.541,9.583h-7.882A9.537,9.537,0,0,1,257.6,269.5v-7.917A9.537,9.537,0,0,1,267.141,252h7.882a9.537,9.537,0,0,1,9.541,9.583Z",transform:"translate(-194.963 -219.187)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f63f27",d:"M257.6,261.482A9.457,9.457,0,0,1,267.082,252h8.039c5.257,0,9.276,4.638,9.276,9.895v7.524a9.457,9.457,0,0,1-9.482,9.482",transform:"translate(-194.963 -219.187)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fff",d:"M336.776,312.9a5.759,5.759,0,0,0-3.007-.521l.207-1.25h3.941c.415,0,.415-.833.415-1.25v-1.354c0-.417,0-.521-.415-.521h-5.807c-.415,0-.726.208-.726.521l-.726,5.729a.9.9,0,0,0,.311.625.872.872,0,0,0,.726.208c.415,0,.83-.1,1.452-.1,1.763,0,2.7.625,2.7,1.875a1.91,1.91,0,0,1-2.074,1.875,4.714,4.714,0,0,1-2.178-.521,1.31,1.31,0,0,0-.622-.1c-.207.1-.415.208-.415.521l-.415,1.25a.842.842,0,0,0,.311.938,6.539,6.539,0,0,0,3.422.833,4.7,4.7,0,0,0,2.9-8.75Z",transform:"translate(-258.065 -267.896)"})));}

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = EmailSubscription;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function EmailSubscription(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"59px":_ref$width,props=_objectWithoutProperties(_ref,["width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 59 59",width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#4f5565",cx:"29.5",cy:"29.5",r:"29.5",transform:"translate(0 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#fbd303",width:"46.037",height:"29.736",transform:"translate(6.481 23.726)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f5ea0a",d:"M101.984,326.571,78.966,308.9,55.947,326.571Z",transform:"translate(-49.466 -273.11)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f8b517",d:"M78.966,47.809,55.947,66,78.966,84.144,101.984,66Z",transform:"translate(-49.466 -42.27)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#fcfcfd",d:"M144.969,91.189V70.527H111.894V91.189l16.537,13.041Z",transform:"translate(-98.931 -62.357)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(17.676 13.198)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#dededf",width:"18.03",height:"2.043"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#dededf",width:"23.254",height:"2.043",transform:"translate(0 5.539)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#dededf",width:"23.254",height:"2.043",transform:"translate(0 11.077)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{fill:"#dededf",width:"23.254",height:"2.043",transform:"translate(0 16.616)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#dededf",d:"M199.676,304.827H183.1l2.593,2.082h11.391Z",transform:"translate(-179.564 -282.712)"})));}

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export TitleLink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Item__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Link__ = __webpack_require__(8);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  align-content: stretch;\n  justify-content: space-between;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: stretch;\n  align-content: stretch;\n  justify-content: space-between;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n"],["\n  display: flex;\n  flex-flow: column nowrap;\n  flex-grow: 1;\n  flex-shrink: 1;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: flex-start;\n  width: 90px;\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row wrap;\n  align-content: center;\n  justify-content: center;\n  align-items: flex-start;\n  width: 90px;\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  text-decoration: none;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n    text-decoration: underline;\n  }\n"],["\n  font-weight: bold;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  text-decoration: none;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n    text-decoration: underline;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-weight: bold;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  text-decoration: none;\n"],["\n  font-weight: bold;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  text-decoration: none;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  min-height: 33px;\n  margin-top: auto;\n  font-size: ",";\n  line-height: 1.5;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-end;\n  display: flex;\n  align-items: flex-end;\n  width: 100%;\n  min-height: 33px;\n  margin-top: auto;\n  font-size: ",";\n  line-height: 1.5;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var News=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Item__["d" /* News */])(_templateObject);var Content=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var Sidebar=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["c" /* rtl */])("margin-left","14px"));var Icon=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4);var TitleLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["a" /* Link */])(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14),function(_ref){var theme=_ref.theme;return theme.indexMajor;},function(_ref2){var theme=_ref2.theme;return theme.mainLink;});var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14),function(_ref3){var theme=_ref3.theme;return theme.indexMajor;});var Action=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var ItemNotification=function ItemNotification(_ref4){var icon=_ref4.icon,link=_ref4.link,title=_ref4.title,details=_ref4.details,timestamp=_ref4.timestamp;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](News,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Item__["g" /* Timestamp */],null,__WEBPACK_IMPORTED_MODULE_1_moment___default.a.unix(timestamp).format("lll")),link?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TitleLink,{to:""+link},title):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,title),details&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Action,null,details)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Sidebar,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null,icon)));};/* harmony default export */ __webpack_exports__["a"] = (ItemNotification);

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Coupon=function Coupon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"69.296",height:"69.296",viewBox:"0 0 69.296 69.296"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-75.911 -32.071) rotate(-45)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M60,107.355H14v1a1,1,0,1,1-2,0v-1H2a2,2,0,0,0-2,2v8.8a1.461,1.461,0,0,0,.677,1.248A6.984,6.984,0,0,1,4,125.355,6.984,6.984,0,0,1,.677,131.3,1.462,1.462,0,0,0,0,132.552v8.8a2,2,0,0,0,2,2H12v-1a1,1,0,1,1,2,0v1H60a2,2,0,0,0,2-2v-32A2,2,0,0,0,60,107.355Zm-46,31a1,1,0,1,1-2,0v-2a1,1,0,1,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,1,1,2,0Zm0-6a1,1,0,0,1-2,0v-2a1,1,0,0,1,2,0Z",fill:"#ffc350"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M175.129,155.871h-42a1,1,0,0,1-1-1v-30a1,1,0,0,1,1-1h42a1,1,0,0,1,1,1v30A1,1,0,0,1,175.129,155.871Z",transform:"translate(-116.129 -14.516)",fill:"#ffd164"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M225.882,183.071l-5.183,3.254a1.5,1.5,0,0,1-2.247-1.632l1.493-5.935-4.7-3.924a1.5,1.5,0,0,1,.858-2.641l6.106-.414,2.281-5.679a1.5,1.5,0,0,1,2.777,0l2.281,5.679,6.106.414a1.5,1.5,0,0,1,.858,2.641l-4.7,3.924,1.493,5.935a1.5,1.5,0,0,1-2.247,1.632Z",transform:"translate(-188.71 -50.805)",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M232.662,232.127a16.986,16.986,0,0,1-14.484-10.055l-2.071.14a1.5,1.5,0,0,0-.858,2.641l4.7,3.924-1.493,5.935a1.5,1.5,0,0,0,2.247,1.632l5.183-3.254,5.183,3.254a1.5,1.5,0,0,0,2.247-1.632Z",transform:"translate(-188.709 -100.825)",fill:"#fff6d8"})));};/* harmony default export */ __webpack_exports__["a"] = (Coupon);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var Compensation=function Compensation(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"69",height:"59.071",viewBox:"0 0 69 59.071"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-1049.755 -627)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M63,288v30H0V288Zm0,0",transform:"translate(1049.755 339)",fill:"#70b48f"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M95,320v30H32V320Zm0,0",transform:"translate(1023.755 313)",fill:"#599072"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M67,370v-3H64V355h3v-3h45v3h3v12h-3v3Zm0,0",transform:"translate(997.755 287)",fill:"#70b48f"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ellipse",{cx:"9",cy:"9",rx:"9",ry:"9",transform:"translate(1078.255 639)",fill:"#599072"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M105.163,45.766l-10.794-7.2A14.3,14.3,0,0,1,88,26.67V7.151h.534a22.889,22.889,0,0,0,16.181-6.7L105.163,0",transform:"translate(982.058 640.304)",fill:"#bab8b9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M102.44,38.507l-9.082-6.054A12.035,12.035,0,0,1,88,22.44V6.016h.449A19.259,19.259,0,0,0,102.064.377L102.44,0",transform:"translate(984.781 643.934)",fill:"#454855"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M184,0l.449.449a22.883,22.883,0,0,0,16.18,6.7h.534v19.52a14.3,14.3,0,0,1-6.369,11.9L184,45.767",transform:"translate(903.221 640.304)",fill:"#999"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M184,0l.378.378a19.254,19.254,0,0,0,13.614,5.639h.449V22.44a12.035,12.035,0,0,1-5.359,10.013L184,38.507",transform:"translate(903.221 643.933)",fill:"#272b34"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M7.251,33.083,2.79,28.589,1,30.392l6.251,6.3L18.962,24.893l-1.79-1.8Z",transform:"translate(1077.639 633.648)",fill:"#fc0"})));};/* harmony default export */ __webpack_exports__["a"] = (Compensation);

/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Bell;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Bell(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"20px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 19",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M88.121,56.771V55.2a5.413,5.413,0,0,0-4.293-5.18v-1.6a1.379,1.379,0,0,0-2.752,0v1.6a5.413,5.413,0,0,0-4.293,5.18v1.573a6.158,6.158,0,0,1-1.972,4.483,1.75,1.75,0,0,0-.421,1.991,1.945,1.945,0,0,0,1.793,1.128H79.6a2.853,2.853,0,0,0,5.7,0h3.421a1.945,1.945,0,0,0,1.793-1.128,1.75,1.75,0,0,0-.421-1.991A6.158,6.158,0,0,1,88.121,56.771ZM82.451,65.5a1.165,1.165,0,0,1-1.2-1.127h2.394A1.165,1.165,0,0,1,82.451,65.5Zm6.536-2.85a.289.289,0,0,1-.267.168H76.182a.289.289,0,0,1-.267-.168.26.26,0,0,1,.063-.3,7.619,7.619,0,0,0,2.455-5.583V55.2a4.025,4.025,0,0,1,8.036,0v1.573a7.619,7.619,0,0,0,2.455,5.583A.26.26,0,0,1,88.988,62.65Z",transform:"translate(-72.451 -47.056)",fill:fill}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M61.853,75.255a.777.777,0,0,0,.485-.987,4.834,4.834,0,0,1,3.014-6.127.778.778,0,0,0-.5-1.472,6.39,6.39,0,0,0-3.984,8.1.777.777,0,0,0,.987.485Z",transform:"translate(-60.524 -66.628)",fill:fill}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M283.994,66.67a.778.778,0,0,0-.5,1.472,4.834,4.834,0,0,1,3.014,6.127.778.778,0,1,0,1.472.5A6.39,6.39,0,0,0,283.994,66.67Z",transform:"translate(-268.32 -66.628)",fill:fill})));}

/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = allNews;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_memoize_one__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual__);
function reducedNews(news){if(Array.isArray(news)){return news.reduce(function(acc,news){var date=__WEBPACK_IMPORTED_MODULE_0_moment___default()(news.publishedAt!=null?news.publishedAt:news.createdAt,__WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601);var news_obj={type:"news",timestamp:date.valueOf()/1000,news:news};acc.push(news_obj);return acc;},[]);}return[];}function allNews(props){var reducedNewsCached=Object(__WEBPACK_IMPORTED_MODULE_1_memoize_one__["default"])(reducedNews,__WEBPACK_IMPORTED_MODULE_2_lodash_isEqual___default.a);var news=props.news,lastViewTimestamp=props.lastViewTimestamp;// приводим в порядок новости
var reduced_news=reducedNewsCached(news);var latest_news=reduced_news.filter(function(news){var date=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(news.timestamp);var sevenDaysAgo=__WEBPACK_IMPORTED_MODULE_0_moment___default()().subtract(7,"days");return date.isAfter(sevenDaysAgo);});var new_news_count=latest_news.reduce(function(acc,item){var time=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(item.timestamp);var lastViewTime=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.unix(lastViewTimestamp);if(time.isAfter(lastViewTime)||time.isSame(lastViewTime)){acc++;}return acc;},0);return new_news_count;}

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(367),
    equalArrays = __webpack_require__(668),
    equalByTag = __webpack_require__(1551),
    equalObjects = __webpack_require__(1553),
    getTag = __webpack_require__(176),
    isArray = __webpack_require__(54),
    isBuffer = __webpack_require__(316),
    isTypedArray = __webpack_require__(485);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 1550 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(157),
    Uint8Array = __webpack_require__(571),
    eq = __webpack_require__(358),
    equalArrays = __webpack_require__(668),
    mapToArray = __webpack_require__(1552),
    setToArray = __webpack_require__(360);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 1552 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(567);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_logged_in_name_png__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_logged_in_name_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_logged_in_name_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_vip_icon_png__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_vip_icon_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_vip_icon_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_trade_button_png__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_trade_button_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_trade_button_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Navigation_Icons__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  margin-left: -40px;\n  padding-left: 40px;\n  font-size: 24px;\n  line-height: 1.2;\n  color: #fff;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: url(",") 0% 3px no-repeat;\n\n  ",";\n\n  @media (max-width: 899px) {\n    margin-left: 0;\n  }\n\n  @media (max-width: 479px) {\n    font-size: 18px;\n    line-height: 24px;\n  }\n"],["\n  direction: ",";\n  margin-left: -40px;\n  padding-left: 40px;\n  font-size: 24px;\n  line-height: 1.2;\n  color: #fff;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: url(",") 0% 3px no-repeat;\n\n  ",";\n\n  @media (max-width: 899px) {\n    margin-left: 0;\n  }\n\n  @media (max-width: 479px) {\n    font-size: 18px;\n    line-height: 24px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      margin-left: 0;\n      padding-left: 0;\n      padding-right: 40px;\n      text-align: right;\n      background-position-x: right;\n    "],["\n      margin-left: 0;\n      padding-left: 0;\n      padding-right: 40px;\n      text-align: right;\n      background-position-x: right;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  padding: 12px 0;\n"],["\n  padding: 12px 0;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  direction: ",";\n  ",";\n"],["\n  direction: ",";\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  direction: ",";\n  display: inline-block;\n  font-size: 16px;\n  line-height: 1;\n  vertical-align: middle;\n  ",";\n  color: #fff;\n  opacity: 0.6;\n\n  :before {\n    content: \"ID: \";\n  }\n"],["\n  direction: ",";\n  display: inline-block;\n  font-size: 16px;\n  line-height: 1;\n  vertical-align: middle;\n  ",";\n  color: #fff;\n  opacity: 0.6;\n\n  :before {\n    content: \"ID: \";\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 0;\n  line-height: 0;\n  width: 45px;\n  height: 17px;\n  background: url(",") no-repeat 0 0;\n  background-size: cover;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 0;\n  line-height: 0;\n  width: 45px;\n  height: 17px;\n  background: url(",") no-repeat 0 0;\n  background-size: cover;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: inline-block;\n  position: relative;\n  top: -2px;\n  padding: 2px 5px 2px;\n  border: 1px solid #878993;\n  border-radius: 3px;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n\n  ",";\n"],["\n  display: inline-block;\n  position: relative;\n  top: -2px;\n  padding: 2px 5px 2px;\n  border: 1px solid #878993;\n  border-radius: 3px;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      display: none;\n    "],["\n      display: none;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 32px;\n  ",";\n"],["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  height: 32px;\n  ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  max-width: 240px;\n  white-space: nowrap;\n\n  @media (max-width: 359px) {\n    max-width: 200px;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  max-width: 240px;\n  white-space: nowrap;\n\n  @media (max-width: 359px) {\n    max-width: 200px;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  direction: ",";\n  ",";\n  font-size: ",";\n  line-height: 1;\n  color: #fff;\n  opacity: 0.6;\n\n  @media (min-width: 360px) {\n    padding-top: 2px;\n  }\n"],["\n  direction: ",";\n  ",";\n  font-size: ",";\n  line-height: 1;\n  color: #fff;\n  opacity: 0.6;\n\n  @media (min-width: 360px) {\n    padding-top: 2px;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 28px;\n  margin: 0;\n  border: 0;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 48px;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  user-select: none;\n  cursor: pointer;\n\n  @media (max-width: 359px) {\n    padding: 0 15px;\n  }\n\n  :focus {\n    outline: none;\n  }\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  padding: 0 28px;\n  margin: 0;\n  border: 0;\n  border-radius: 8px;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 48px;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  user-select: none;\n  cursor: pointer;\n\n  @media (max-width: 359px) {\n    padding: 0 15px;\n  }\n\n  :focus {\n    outline: none;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  height: 32px;\n  width: 90px;\n  display: block;\n  font-size: ",";\n  line-height: 32px;\n  text-align: center;\n  padding: 0;\n  border-radius: 4px;\n  background-color: #60a31c;\n  background: linear-gradient(to bottom, #68c703 0%, #60a31c 100%);\n\n  :hover {\n    background-color: #68c703;\n    background: linear-gradient(to bottom, #60a31c 0%, #68c703 100%);\n  }\n"],["\n  height: 32px;\n  width: 90px;\n  display: block;\n  font-size: ",";\n  line-height: 32px;\n  text-align: center;\n  padding: 0;\n  border-radius: 4px;\n  background-color: #60a31c;\n  background: linear-gradient(to bottom, #68c703 0%, #60a31c 100%);\n\n  :hover {\n    background-color: #68c703;\n    background: linear-gradient(to bottom, #60a31c 0%, #68c703 100%);\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 32px;\n  width: 100px;\n  padding: 5px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-transform: uppercase;\n  color: #ffffff;\n  background: transparent;\n  border: 2px solid #ffffff;\n  border-radius: 24px;\n\n  :hover,\n  :focus {\n    background-image: none;\n    background-color: #ffffff;\n    color: #3b9478;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 32px;\n  width: 100px;\n  padding: 5px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-transform: uppercase;\n  color: #ffffff;\n  background: transparent;\n  border: 2px solid #ffffff;\n  border-radius: 24px;\n\n  :hover,\n  :focus {\n    background-image: none;\n    background-color: #ffffff;\n    color: #3b9478;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  padding: 20px 10px 20px 73px;\n  margin: 0;\n  text-align: left;\n  font: 700 28px/1 Roboto, Arial, sans-serif;\n  text-shadow: 0 -1px 1px rgba(0, 0, 0, 0.22);\n  box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.3),\n    inset 0 -2px 0 0 rgba(255, 255, 255, 0.1);\n  background-color: #feac00;\n  background: linear-gradient(to bottom, #feac00 0%, #fd9500 100%);\n\n  @media (max-width: 479px) {\n    font-size: 22px;\n    line-height: 48px;\n    width: 100%;\n    text-align: center;\n    padding: 10px;\n    padding-left: 57px;\n  }\n\n  ",";\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 22px;\n    transform: translateY(-50%);\n    width: 34px;\n    height: 34px;\n    background: url(",") center no-repeat;\n  }\n\n  :hover {\n    background-color: #fd9500;\n    background: linear-gradient(to bottom, #fd9500 0%, #feac00 100%);\n  }\n"],["\n  position: relative;\n  display: block;\n  padding: 20px 10px 20px 73px;\n  margin: 0;\n  text-align: left;\n  font: 700 28px/1 Roboto, Arial, sans-serif;\n  text-shadow: 0 -1px 1px rgba(0, 0, 0, 0.22);\n  box-shadow: inset 0 -2px 0 0 rgba(0, 0, 0, 0.3),\n    inset 0 -2px 0 0 rgba(255, 255, 255, 0.1);\n  background-color: #feac00;\n  background: linear-gradient(to bottom, #feac00 0%, #fd9500 100%);\n\n  @media (max-width: 479px) {\n    font-size: 22px;\n    line-height: 48px;\n    width: 100%;\n    text-align: center;\n    padding: 10px;\n    padding-left: 57px;\n  }\n\n  ",";\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 22px;\n    transform: translateY(-50%);\n    width: 34px;\n    height: 34px;\n    background: url(",") center no-repeat;\n  }\n\n  :hover {\n    background-color: #fd9500;\n    background: linear-gradient(to bottom, #fd9500 0%, #feac00 100%);\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n      font-size: 21px;\n\n      @media (max-width: 479px) {\n        font-size: 18px;\n      }\n    "],["\n      font-size: 21px;\n\n      @media (max-width: 479px) {\n        font-size: 18px;\n      }\n    "]),_templateObject17=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding: 8px 20px;\n  width: 100%;\n  font-size: ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  color: ",";\n  background-color: ",";\n  border-radius: 32px;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  :hover {\n    background-color: transparent;\n    color: ",";\n    box-shadow: inset 0px 0px 0px 2px;\n  }\n\n  @media (max-width: 959px) {\n    order: 0;\n    font-size: 18px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding: 8px 20px;\n  width: 100%;\n  font-size: ",";\n  text-transform: uppercase;\n  text-decoration: none;\n  color: ",";\n  background-color: ",";\n  border-radius: 32px;\n  cursor: pointer;\n  transition: all 0.3s;\n\n  :hover {\n    background-color: transparent;\n    color: ",";\n    box-shadow: inset 0px 0px 0px 2px;\n  }\n\n  @media (max-width: 959px) {\n    order: 0;\n    font-size: 18px;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1;\n\n  @media (max-width: 359px) {\n    font-size: ",";\n  }\n"],["\n  font-size: ",";\n  line-height: 1;\n\n  @media (max-width: 359px) {\n    font-size: ",";\n  }\n"]),_templateObject19=_taggedTemplateLiteral(["\n  font-weight: 700;\n  color: #fff;\n"],["\n  font-weight: 700;\n  color: #fff;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-flow: column nowrap;\n  width: 100%;\n  padding: 2px 0;\n"],["\n  direction: ",";\n  display: flex;\n  flex-flow: column nowrap;\n  width: 100%;\n  padding: 2px 0;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 19px;\n  ",";\n  backface-visibility: hidden;\n  color: currentColor;\n  opacity: 0.6;\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 19px;\n  ",";\n  backface-visibility: hidden;\n  color: currentColor;\n  opacity: 0.6;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: fit-content;\n  padding: 3px 0;\n  color: #fff;\n\n  :hover "," {\n    opacity: 1;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  width: fit-content;\n  padding: 3px 0;\n  color: #fff;\n\n  :hover "," {\n    opacity: 1;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 26px;\n  text-decoration: none;\n  color: ",";\n\n  :hover {\n    text-decoration: underline;\n  }\n"],["\n  font-size: ",";\n  line-height: 26px;\n  text-decoration: none;\n  color: ",";\n\n  :hover {\n    text-decoration: underline;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Name=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h1(_templateObject,function(props){return props.theme.direction;},__WEBPACK_IMPORTED_MODULE_5__images_logged_in_name_png___default.a,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var LineContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var IdContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("text-align","left"));var Id=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("margin-right","10px"));var Vip=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject6,__WEBPACK_IMPORTED_MODULE_6__images_vip_icon_png___default.a);var Silver=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(10),function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var Account=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("text-align","left"));var AccountContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var AccountHeader=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject11,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("margin-right","5px"),Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(16));var Button=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__common_Link__["a" /* Link */])(_templateObject12);var FillupButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Button)(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14));var FillupButtonIron=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Button)(_templateObject14,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14));var TradeButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Button)(_templateObject15,function(props){return props.smallText&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject16);},__WEBPACK_IMPORTED_MODULE_7__images_trade_button_png___default.a);var TradeButtonIron=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__common_Link__["a" /* Link */])(_templateObject17,function(_ref){var theme=_ref.theme;return theme.locale==="vn"?"22px":"24px";},function(_ref2){var theme=_ref2.theme;return theme.main;},function(_ref3){var theme=_ref3.theme;return theme.mainText;},function(_ref4){var theme=_ref4.theme;return theme.mainText;});var Money=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__Money__["b" /* default */])(_templateObject18,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(18),Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(16));var Sum=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__Money__["b" /* default */].Value)(_templateObject19);var Currency=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__Money__["b" /* default */].Symbol)(_templateObject19);var LinksWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20,function(_ref5){var theme=_ref5.theme;return theme.direction;});var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].i(_templateObject21,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("margin-right","10px"));var LinkContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22,IconContainer);var ActualLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__common_Link__["a" /* Link */])(_templateObject23,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14),function(_ref6){var theme=_ref6.theme;return theme.accent;});function LinkWithIcon(_ref7){var to=_ref7.to,replace=_ref7.replace,children=_ref7.children,Icon=_ref7.Icon;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{width:"19px"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ActualLink,{replace:replace,to:to},children));}var LoggedIn=function(_React$Component){_inherits(LoggedIn,_React$Component);function LoggedIn(){_classCallCheck(this,LoggedIn);return _possibleConstructorReturn(this,(LoggedIn.__proto__||Object.getPrototypeOf(LoggedIn)).apply(this,arguments));}_createClass(LoggedIn,[{key:"render",value:function render(){var _props=this.props,profile=_props.profile,geo=_props.geo,isVIP=_props.isVIP;var email=profile.email,_profile$first_name=profile.first_name,first_name=_profile$first_name===undefined?"":_profile$first_name,_profile$last_name=profile.last_name,last_name=_profile$last_name===undefined?"":_profile$last_name;var displayName="";if(geo==="VN"){displayName=profile.first_name;}else if(first_name||last_name){displayName=first_name+"\xA0"+last_name;}if(displayName===""){displayName=email;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Name,null,displayName),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LineContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IdContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Id,null,profile.id),isVIP?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Vip,null,"VIP"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Silver,{thProject:"irontrade"==="siamoption"},"SILVER")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Account,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AccountContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AccountHeader,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Balance"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Money,{Value:Sum,Symbol:Currency},profile.real?profile.balance.real:profile.balance.demo)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{as: true?FillupButtonIron:FillupButton,to:"/fillup",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("CLICKBTN_DEPOSIT_MAINPAGE");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Deposit"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinksWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkWithIcon,{to:"/profile",Icon:__WEBPACK_IMPORTED_MODULE_10__Navigation_Icons__["e" /* PersonIcon */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Profile")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkWithIcon,{to:"/tournaments",Icon:__WEBPACK_IMPORTED_MODULE_10__Navigation_Icons__["h" /* TournamentsIcon */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Tournaments")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkWithIcon,{to:"/trading-history",Icon:__WEBPACK_IMPORTED_MODULE_10__Navigation_Icons__["i" /* TradingHistoryIcon */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Trading history")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LinkWithIcon,{replace:true,to:"/logout",Icon:__WEBPACK_IMPORTED_MODULE_10__Navigation_Icons__["f" /* QuitIcon */]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Log out"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LineContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{as: true?TradeButtonIron:TradeButton,to:"/trade",smallText:profile.locale==="vn"||profile.locale==="ph",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("CLICKBTN_TRADE_MAINPAGE_HEADER");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Trade now")))));}}]);return LoggedIn;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["h" /* withFetch */])(LoggedIn));

/***/ }),
/* 1555 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAh5JREFUeNpi/LeGAQRmA3EqEwMEzAURMM4JIPYFCCBGqLI+mOghECMRiDcABBBMCgXAlKkB8X8olgYIIGSV/2CKYCrfQNn/kQX3Q+leZEFzqCp/EIcF2Swo+A8QQOhOegrEDkB8G4hNoZ41AEmgK8QwCaSGAU0Qxt8JVbACpghZYQoQ74Kyu6B0B5Q+A8SeMKtvADE3EC/FDEQGXyAWBAggdDfKQePkFxAbA/FbmAQLkiKQiQeBWArKBykShXoQxTOTgFgJiS8PxLXongGBe0AsgcTXAuK7MA66G78DMSe2MGVB86EqNAxBioSxJSAQmAHEj5HE38JSBLKJ4BQGxBlA/A6IvwKxLDQF/gGpA+msAmIdIPaGahKCKgKBYCD2AeIYkIkFQMwHxNFArIzm5kwgng7ELgABhjXlIyVSUAJhB+KNQPwAGmSeQPwCiB2B+A66JhYchqUC8SwgdgbifVjkE6Bp2x0p0TFgS7YwYAvNFPtwyC+BBqgdrnyNDjqgaa0ZhzyoRPkBxP3EGngNiMWBOAKIvwBxORC7AnELEP8GYnUgFkFO/biSIjpgg+YOVWhWAoXbIyD+DE0nDIRcmA31CiiNrwfibiB+CcQngbgUiC9ADQQFyXaoaz8CcQi6C0HOvw/V4AzN0MhAA1qM9AHxMzQ5fqiFIJ8owwzcC83kekB8GCmmCYGHQHwEiOOA+DUovYIMZIRKyDJQDo4BAHF7fs61rPUXAAAAAElFTkSuQmCC"

/***/ }),
/* 1556 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1557 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAdCAYAAAG4bI4sAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAoFJREFUeNpi/P//PwMQvGNAACFGqCAMgDiMTAyogBFEoAuCAUAAgbS/QxEBCjwEmQnDyNrYYFpQdAAEEEwpijZ0jGwMiP0L6tb/6K4B0X+B+CMDdgD2MQeQwcmABwAEEEjRNiBtgUsBCxDzgozDIf+fBYeEJxC/Rw/PFUDcCcRi0Og5AQuXw1D/80HpKqQw+Q9y5GGgOm0cVgliBjUWXwjiUwAQQDATQNYYAPEyBtJAGjj1QB18mFAkI+FlyB4F0Sx4bHkGxJKwdAoEXED8FVsUY0vD+6CpSApqgDKUvwHK/4Et0NCBExr/LpJr8AZsExBrMJAHwkCGVAAZ7VgkXwDxUzQxY2ymAAQQI5ZigRTwBIj1YGECSkyzSDTAA4j5kV3yn1DgYQFbgFgXiOWZSNToB8SxuMKEWJf8RyooCbqEEaphOpLYaSA+idUy5DwAxYFQ/iQg/gXNV+VA/B0tD22B5TdshoDACiT+MzR5DEOwJXthtHSjDsQp+AIKW5igJ7zPQNxPqNTCpZkQ4AHi58iGrCYz2b/BXpeRAVjQqzEkcBaNLwrEcljULWPBUxcRC34BBBiyd0Alvg0DfcEjULbBlUweQbMHLfFWYtLrgABaOkQEWsv9hzadtKjtkDhoe+wStJrFBmSA+AoQs0OrlC4gvoa/0EUUUoehhReu1gUoYc/8jwnmAjE7kpplUPEnQCyNw6wt6HYR45BOJEt/AnEQkpwDEL+Byv1BUhdLoImE4RBiouYCEP8B4m9A7AXE65DkDkDTwkwgZoaKNQLxYpIjnISooSYmK0ToArBVnnJ4yn2aAarUWNQq0CqQOnHE4HYizM0k0cyl5KQRYhw+jVRDAYVx3QnwkY0AAAAAAElFTkSuQmCC"

/***/ }),
/* 1558 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1559 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1560 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALQAAAAxCAYAAABzsINZAAAR0ElEQVR4nO2de1yUZdrHv88MB0GOyiYqiR9RBKXUV1ZFSlNWLcPchXXb0JSSXgU331ZZNz/temhL8Vjr6iulWFaeUDysgoYHTAtWgTxggicMRdAgBR0PMDDX+8cIOM2QDA5ivvP9fK7PzHPf13Pf1z38nmvu+/aZR4U67ICJwCtAAOCEFSuPLhrgBLAOiAcqAZS7le2BHUDPZgnNipUH4ygQClxS0GfmQ1jFbOWXzTGgrxqIAV5r5mCsWHlQPIEf1MA/Aa9mDsaKFUvgrgAV6KcdVqz80qlQAGnuKKxYsRSq5g7AihVLYhW0lceKx0bQcWGwcaLenu/24G0VLnrwdqw8fMwT9G9ehpiZsCAOOnVsmojMpHsbKF8Gfx0NQV0gvA/s/IdelPcjdapeuD/F5wlo3xE8XfXHkUF6v4/HWjR0K02AGpjVYO8/xEALJyi5Du9EQ5dOcPIkaG41WYD3439fhV49YN4aGP5P2PQfiH4Ggn1h9rY6v+e7we96QbkGSm7qRRo1EH7lBbfKIP1cne+NW3D8DHyVB084wX8/B/16Q9VtKCyFsyXGcUQGwZBuhu1EBkHPJ0GrhchgcLE3fa4Vy2HeLsff4+ve3/gB/tgXVAI7voR/rYRrNywf4X0oXwYunqCE15VFBsGvnGFBqv74P3+Dvr3q6ldsg+E99Fm4hnvP3zgRfj8Epn2kP54/oa5u024Ydc/H0L0NpM/QxwDAHXhtKXyaoc/q7WvKW+hfpn1UF5cVy2PelMNGXWfubWFjFohA2FBI/QKPaVHgYNtEoZqmVkjos/DGifBiD+jTSV8WF6YX86bdetHm5sEbw8BrKlz6Xu9zr5h/yoLUOmH/VMwACW/oY3htIQTEgFTAqjfq6qUCAqbUtVETl5WmwUxBqwytlSckHQGdDj9HW/xfC2PoN+vo+uYrKOqHtN68U/fW01U/j/79s/oMC/r5MMDQp/QZ068t0AL+MtQy3ffpBNcv6zPyd1dgz3eguNbVF13Tl1uz8sOh8Rm6xlq3g00ncKrQ4qwSXJ0dCHprNJFZn9Fz/Ii6+/maiNzv9a/Pd9OLymsqXLpswq8YMs5A0mF9ps0ptEz/N26Ds0Pdscvd993bWKZ9K+bxYBm6xlq3JWvrGajU4qTW4ajW0aq1C6Gzo5iWmcB//eG5poke+OQr/euGSfrpRVwYtHOvqz+cr3/1cte/v3YLnvSAXSfrfBqarZ/0MN7KS83RZ+SNE+9Ob/z1U5nvrjR6SFYegAfP0LWZui0pW85TqanAQQUtVYKjCjyfbE3Usrd4P+Nf9Hox0OIDWJCq3+EA/dbdX0frv+Zrymrq27nrF3dRz8HFUn1dyjHgjuGizxQpx/Qi7dsLxg8wrBsVD7vT9dOcv47Wf2MMm2+58VkxD/N2OZatu79PWSmTf9eGtu722KuEFiqwV+mwVwkOChQcPc0nf19NzsG8xkdtxUo9mCfojxIb5ldWyrQR7nT8lQMOd8Vsr4CdWrBXQQuVjpwDJ1j29qecPHKhcZFbsWICy0057jWPNsz/UkPZ1VsGYna4K+YWKni6lzcZk8LYM2EEfq1aNtHwrPx/w7wM/dkW81ovv8q839gS4OVYm5ntVFBRfoOe20/iJAqoVaDApvQc/mftHoo0WvP6sGLlHswT9Npt9/f5KTfK+WiQ0P1JB+xUQsXV6/T4MhdnsQH1XUHboN8t0QkrdmUS+/k+rldWm9/XLwRFUejRowcAJSUlXLp0qZkjenwwT9CJOxrXS3k5K4Lv4OtaRdDec9iigK0KVHfFrFLViVutQFUVU1fsZPG2LLO6cXBwYOjQoXTp0gUbGxuuX7/O2bNn2b9/P5WVlY2LvQmYM2cO06dPp7S0lC5dulBWVtbcIT02NM0c2mhLrxVvpOnwXZeNra0a7G3ATqU3WzXYqcH+HnNxYNGfRzY4LDc3N1atWsXBgwfp3LkzWVlZHDp0CFdXVz799FM0Gg0bN26kQ4cO5n4+TcKsWbPYvHkzqampD0XMiYmJzJw5s8n7eRQwT9C2qsbZ1RJO79yN2+Z8bp29YlrIdnVWVq4h7G+fNSikgIAAcnNzKSgoIDAwkEWLFrF//37S0tKYO3cuXl5eJCUlERYWxrBhwxrzGVmcyspKKisruX79+kPpr2XLljg4ONzf8THAxixvtdr8Hq5c4fzmnXS8eQds7an+8iI37Wxp2bNd3RTj7mvFzTu8+9ke4tako5P7z4RcXFzYtWsX//73v5k9e7ZJH51Ox5w5c9i6dSsbNmwwP34rvyjMFLSZNxxduULepi9pe7uKasUGtYBabYf99nyuSRXu/X30gtZWsXDtAf62ci8VVboGN79o0SI8PDyIjY39Wb+cnBxycnLqrQ8ICKBdu3b8+OOPZGdn/2xbfn5+tG/fnvLycrKzs5EGXHjmoFarGTBgAK6urpw6dYrc3Nx6fb29vXF2dubEiRMEBATg5+dHYWEhhw4dum9cjo6OBAcH4+TkRGFhIZmZmbV1rVu3xsfHh8OHD5uMb+DAgaSlpVl87Jag6ebQRUWc3LAXz9s6qlBTpaipVmxAUWOjtsc9+SKXM86RsC2DVi/O5i/xu80Ss52dHePGjSMzM5MbNxp3H3ZERAQpKSn079+fTp06sXr1akpKSoiOjjbyHTFiBKmpqYSEhODj40N8fDxXr141eTH169eP9evXk5aWRnV1NSJCYWEh27dvp3fv3vXGM2nSJA4fPkxgYCADBw7k22+/Zffu3djZmX7KRHR0NPHx8ezZs4cdO3bwwgsv8OGHH5Kfn0+fPn3q7WfWrFmcPn2a8PBw+vfvz4wZM7hw4QJDhuhvUXR1deWbb77BxcXF6NyxY8fyxRdfPJJirkEabAcONMzWrJVjoTFyOeR1KRk8Tq4NHiOaQX+U24NGSdVz4aJ77reypvPT8qRK3fC+f2IjRowQEZE1a9Y06vwpU6ZIYWGh2NnZ1Zap1WrJzMwUEZFp06bVlkdEREhxcbE4OzvXlimKIvv27RMRkXnz5tWWv/zyy5KXlyf29vYCyIsvvigVFRVSWFgojo6OtX7r1q2T5cuX1x5HR0fLxYsXDeJ56623REQkISHB5Bji4uJERCQjI0PUarXB2MrKysTT01MASU5Olri4OAFk0KBBUlRUZDCWmnKNRiMeHh4CSHp6ukydOtWoz3379snKlSsb/XdrarN8hi68xOH1h3G5o0N7NzNXoUar2FKNmm0lxXT7eiejzx7noq7xe80dO3Zs9Lmenp7MmTOHDz74wGA7r7q6mokTJwIwe/Zs3NzccHR0ZPny5SQkJBh8E4gI48ePR6fTMXXqVDp27IitrS3x8fEkJSVRUVEBQHJyMitXrqR9+/ZMnjzZZDwqlYr333+fNWvW1Mbj5OREQEAAx48fJyMjo96xVFVV8eqrr1JdXfdZLl68mKysLKZNm2bkX1ZWRkREhNG3WlpaGmVlZYSEhADwySefEBkZaeDTpk0bBg4cyPbt2+uNp7kxbw5t8/OLwpZn8tm37gjOFUIVNnW73IrCf64WMuu7DLIrLbOyv337NgDdupn/0+yIiAjs7e0pKCgwqsvOzubUqVN07dqVl156CUVRcHFxobDQ+Abq8+fPc+jQIYKCgggPD+f48eO4ublha2v4q50tW7YQExND165dTcbz7LPP4u7uTklJCf7+/kRFRWFvb098fDxRUVE/O5aDBw9y9uxZo/LPP/+cN99806j8yJEjAAwYMICQkBA8PT1RFP1N666urqjvLvxXr17Nhx9+SM+ePTl69CgAkZGRaLVakpOTfzam5sRMQdef0FucOc/O9d9hVwlVqBEFRBRyb5Qy7+RBvtJY9gbhmgVLjx496NChAxcuGN/kpCgKr7zyCk5OdY+61mg0+Pn5AdS7L52dnU3Xrl3x8vKq3e7y8jL9+L+srCyCgoJo164d3377LQChoaEG2bG4uBiAU6dOmWyjffv2ADz99NPs3buX6dOnN/gfgmou7J9y7tw5nnjiCaNyOzs7UlJSGDx4MJmZmZw+fdpkG5WVlWzdupXx48fXXhhjxozhwIEDVFVVNSi25sAiGbrTiTziN5zFphK0ihoBLtwsY1nuV6RcPWfynAfl+PHjnDt3Dh8fH+bOncvo0aONfEaOHImzszOdO3cmNjaWO3fu0K1bNwICAgD49a9/bbLtmv3h0tLS2oVRr169TPpqNJpa3/3795OXl4e/vz+xsbEsXLgQgMDAQL7//nuWLFliso2ioiIABg8eTGRkpFkLLpXKdJJxd3evje1eli1bhre3N/7+/kYX2PPPP29wvGrVKhITE5k8eTLdu3cnICCAFStWNDi25qLhk+6TR4zMb906SX5prux94V058MJM2fHcnyXc8+mHsgAYNWqU1DBu3Lh6/YKCgkREJCcnRwDp27eviIjcuHHDYBFWY0lJSaLVasXLy0t8fX1Fp9NJRUWFtGrVysg3ISFBdDqd+Pv7CyBt2rSRnTt3ilarlcTERFmyZImcPXtWvL29Dc67d1GoVqvl2rVrIiLy9ttvN3j8cXFx8uOPP4pKpTKq++CDD2T9+vVGi8LLly/LiBEjjPwdHByksrJSIiIiDMovXLgg4eHhsnDhQhER6dChQ7Mv/O5jZjifPm5gfhs3yObfLpLk4XGyecjf5Y8dgkWF8lAHsHTpUhERqaqqMrkqNyVoQLZs2SIiIkuWLDHwdXR0lLKyMlm8eHFt2ccffywiIqtXrzbwVavVUlxcLKtWrTLqU61Wy5QpU0REDHYz7hX0rl27ao+nT59eO47Y2FgDX1tb23oFLSIye/Zsg3IfHx/RaDQSEhJiJOjz589LeHi4gb9KpZJNmzaJiBgJ+r333pOdO3dKUVGR5OXlNbdYLSzo/BO11m/telnzuyWy7oX5MrbzcLFRjLPEw7IJEyZIaWmpiIgcO3ZMYmJipGfPnuLt7S0DBgyQhIQEqa6ulqSkJAPBJSYmiojI4sWLxc/PT4KDgyUtLU3mz59v0L6iKLJq1SrR6XSyfPly8fX1lT59+khKSoosX75cFMX0RRwYGCg6nU7u3LkjY8eONag7fPiwiIgsWLBAOnbsKIDMmzdPtFqtiIjk5+fL+vXrZfPmzTJ69Oh6BX3mzBnRaDQyc+ZMCQ4OlsmTJ0tJSYksW7as1u9eQf/pT3+S4uJimTRpkgwfPlxmzJghFy9elOTkZCktLTUSdIcOHUSn04mIyKJFi5pbrPc18+62KzgJikKfjBwmrL3K12f2szZvMxW65r+Tzc7OjlGjRhEUFETbtm2prq6mtLSUgoICsrKySE9PN7n46d69O0OHDsXV1ZWCggK2bdvG1atXTfbh6+vLsGHD8PDw4OLFi+zYsYPLlw1/Yu7m5sbrr79O7969UavVeHl50b9/fxRFYebMmbz77rsMGzaMwYMHA6DVapk7dy43b94E9IvP0NBQPD09uXz5Mhs2bODatWsm44mLi+Opp54iOjqaSZMm0alTJ65cuUJSUhJpaWm1fpGRkRQVFZGaqn+WwsiRIwkNDcXFxYVz586RmJjI0aNHmT59Otu3b+fEiRMG/Zw6dQpfX18GDhzIgQMHGvgXaT4afgX8a4H0W58orwdGi4vapdmvxkfNxowZI+Xl5fLOO+8YTBNGjRolGo1GdDqd+Pr6Wqy/uLg4SU5ObtIx1awhfvjhh2b/fBtozR7AY2He3t6i1WplxYoVJutrFrATJkywWJ9NLWhFUSQ5OVlEpN5xPWpm3radlXoZNGgQNjY2JvfDAZKSkgDqnT48aixdupR+/frRu3dvcnNz672b8VGk2a+qx8GeeeaZ2p0UU1uBQ4YMkTNnzpjcYmuseXh4GG0HWsrCwsIkJiZGgoODm/2zNces/8eKBZk/fz6xsbEUFhayevVq0tPTAX327tatG1FRUUaLSCuWRQFuU/uwVysPiq+vL2FhYXh7e6MoCvn5+aSkpBjtHFhpEq4rwEHgmeaOxIoVC/CNCvi8uaOwYsVCfKagv0HpINCvmYOxYuVBOAQ8owKqgBHA180bjxUrjeZrIBSouvdx5Cpg9F0LABybITArVhrKLeAEsOau6QD+D6Znj/jJm4lRAAAAAElFTkSuQmCC"

/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google-play-btn@2.b08a2b9c.png";

/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/google-play-btn@3.c3f1017d.png";

/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Search__ = __webpack_require__(1566);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Search__["a"]; });


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelpdeskHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  background-color: #f6f6f6;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  background-color: #f6f6f6;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  max-width: 1300px;\n  height: 46px;\n  margin: 0 auto;\n  padding: 0 5px;\n  z-index: 9;\n"],["\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  justify-content: center;\n  max-width: 1300px;\n  height: 46px;\n  margin: 0 auto;\n  padding: 0 5px;\n  z-index: 9;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 20px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: ",";\n  cursor: pointer;\n\n  @media (min-width: 960px) {\n    :hover {\n      color: #4e2a81;\n      background-color: #e7e7e7;\n      box-shadow: inset 0px -4px 0px 0px ",";\n    }\n  }\n\n  &."," {\n    font-weight: bold;\n    background-color: ",";\n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 20px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: ",";\n  cursor: pointer;\n\n  @media (min-width: 960px) {\n    :hover {\n      color: #4e2a81;\n      background-color: #e7e7e7;\n      box-shadow: inset 0px -4px 0px 0px ",";\n    }\n  }\n\n  &."," {\n    font-weight: bold;\n    background-color: ",";\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var activeClassName="navlink-active";var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Link=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */]).attrs({activeClassName:activeClassName})(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14,20),function(props){return props.theme.indexMajor;},function(props){return props.theme.accent;},activeClassName,function(props){return props.theme.accent;});var HelpdeskHeader=function HelpdeskHeader(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk",exact:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Help Center")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/sightseeing",onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("ACTIVATE_TOUR_FROM_HELPDESK");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Start Welcome Tour")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/faq"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"FAQ")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/start"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Start")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/practicing"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Practicing")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/skilled"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Skilled")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/knowledge_base"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Knowledge base")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/video"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Video")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/safety"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Safety")),props.showContactUs&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{to:"/helpdesk/contacts"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Contact us"))));};

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchLogic__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons__ = __webpack_require__(850);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n  color: rgba(255, 255, 255, 0.5);\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex: 1;\n  height: 100%;\n  color: rgba(255, 255, 255, 0.5);\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: calc(100% - 20px);\n  margin-left: 20px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 2;\n  box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.5);\n\n  @media (max-width: 959px) {\n    padding: 8px 0;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  width: calc(100% - 20px);\n  margin-left: 20px;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 2;\n  box-shadow: inset 0px -1px 0px 0px rgba(255, 255, 255, 0.5);\n\n  @media (max-width: 959px) {\n    padding: 8px 0;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n"],["\n  direction: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 1;\n  padding: 0 10px;\n  margin: 0;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: Roboto, Arial, sans-serif;\n  color: #fff;\n  background-color: transparent;\n  border: none;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  ::-webkit-search-decoration,\n  ::-webkit-search-cancel-button,\n  ::-webkit-search-results-button,\n  ::-webkit-search-results-decoration {\n    appearance: none;\n  }\n\n  @media (max-width: 959px) {\n    padding: 0;\n  }\n"],["\n  display: flex;\n  flex-grow: 1;\n  padding: 0 10px;\n  margin: 0;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: Roboto, Arial, sans-serif;\n  color: #fff;\n  background-color: transparent;\n  border: none;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  ::-webkit-search-decoration,\n  ::-webkit-search-cancel-button,\n  ::-webkit-search-results-button,\n  ::-webkit-search-results-decoration {\n    appearance: none;\n  }\n\n  @media (max-width: 959px) {\n    padding: 0;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 10px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n\n  @media (max-width: 959px) {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  @media (min-width: 960px) {\n    font-size: ",";\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 100%;\n  padding: 0 10px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n\n  @media (max-width: 959px) {\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n\n  @media (min-width: 960px) {\n    font-size: ",";\n    margin-left: 10px;\n    margin-right: 10px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["Search"],["Search"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var SearchContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Search=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject3,function(props){return props.theme.direction;});var SearchInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject4);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});function SearchButton(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,props,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons__["c" /* UnitedSearchIcon */],null));}var UnitedSearch=function(_React$Component){_inherits(UnitedSearch,_React$Component);function UnitedSearch(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,UnitedSearch);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=UnitedSearch.__proto__||Object.getPrototypeOf(UnitedSearch)).call.apply(_ref3,[this].concat(args))),_this),_this.state={isSearchActive:false},_this.toggleSearch=function(){_this.setState({isSearchActive:!_this.state.isSearchActive});},_this.hideSearch=function(){_this.setState({isSearchActive:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(UnitedSearch,[{key:"render",value:function render(){var _this2=this;if(this.state.isSearchActive===true){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SearchLogic__["a" /* default */],{key:"searchheader"},function(_ref4){var inputFieldRef=_ref4.inputFieldRef,searchQuery=_ref4.searchQuery,updateSearchQuery=_ref4.updateSearchQuery,redirectToSearch=_ref4.redirectToSearch,redirectOnEnter=_ref4.redirectOnEnter;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_ClickOutside__["a" /* default */],{onOutsideClick:_this2.toggleSearch},function(_ref5){var innerRef=_ref5.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{ref:innerRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SearchContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Search,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Search"),":");}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SearchInput,{ref:inputFieldRef,type:"search","aria-label":"Search helpdesk",id:"helpdesk-search-header",name:"helpdesk-search-header",placeholder:_this2.props.gettext(_templateObject6),value:searchQuery,onChange:function onChange(e){return updateSearchQuery(e);},onKeyDown:function onKeyDown(e){return redirectOnEnter(e,"header");}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Icons__["b" /* UnitedSearchCloseIcon */],{onClick:_this2.toggleSearch})));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SearchButton,{onClick:function onClick(){_this2.hideSearch();redirectToSearch("header");}}));});}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,this.props.children,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SearchButton,{onClick:this.toggleSearch}));}}]);return UnitedSearch;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["g" /* withGettext */])(UnitedSearch));

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return calcBonusDuration; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Timers__ = __webpack_require__(148);
var calcBonusDuration=function calcBonusDuration(_ref){var expireTime=_ref.expireTime,creationTime=_ref.creationTime,currentTime=_ref.currentTime;// рассчитываем процент для круглого прогресс-бара
// чем меньше остается времени - тем больше кругляшок заполнен
// берем за 100% duration от регистрации до expireTime в секундах
var aHundredPercent=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(expireTime.diff(creationTime)).asSeconds();// считаем difference в секундах
var fraction=__WEBPACK_IMPORTED_MODULE_0_moment___default.a.duration(expireTime.diff(currentTime)).asSeconds();var percent=Object(__WEBPACK_IMPORTED_MODULE_1__Timers__["c" /* percentage */])(fraction,aHundredPercent,{direction:"from"});return percent;};var Bonus={status:"available",creation_time:__WEBPACK_IMPORTED_MODULE_0_moment___default()("2019-01-29 16:01:37").unix(),expire_time:__WEBPACK_IMPORTED_MODULE_0_moment___default()("2019-02-01 16:01:37").unix(),percent:25,promo:"GHRK"};/* unused harmony default export */ var _unused_webpack_default_export = (Bonus);

/***/ }),
/* 1568 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{"4":{defaultValue:{USD:60,EUR:60,VND:2000,RUB:3500,HKD:450},defaultBilling:{desktop:"sterling",mac_desktop:"sterling",mobile:"sterling"},banksSettings:{mustBeSelected:1,forBilling:"help2pay","choose.bank.key":"fill45.choose.offline.billing",banks:[{title_code:"Techcombank",img_path:"/img/bank-logo/bank_techcom.png",classes:"bank","data-code":"TECHCOM"},{title_code:"Sacombank",img_path:"/img/bank-logo/bank_sacom.png",classes:"bank","data-code":"SACOM"},{title_code:"Vietcombank",img_path:"/img/bank-logo/bank_vietcom.png",classes:"bank","data-code":"VIETCOM"},{title_code:"Asia Commercial Bank",img_path:"/img/bank-logo/bank_acb.png",classes:"bank","data-code":"ACB"},{title_code:"DongA Bank",img_path:"/img/bank-logo/bank_donga.png",classes:"bank","data-code":"DONG_A"},{title_code:"Vietinbank",img_path:"/img/bank-logo/bank_vietin.png",classes:"bank","data-code":"VIETIN"},{title_code:"BIDV Bank",img_path:"/img/bank-logo/bank_bidv.png",classes:"bank","data-code":"BIDV"},{title_code:"Eximbank Vietnam",img_path:"/img/bank-logo/bank_exim.png",classes:"bank","data-code":"EXIM"}]},billings:{sterling:{allowedCurrencies:["VND","USD","HKD"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"sterling",inputValue:"sterling::sterling",bonus:10,title_key:"billing.type.cc",typeImage:{path:"/img/billing/types/card_type.png",classes:"cardIcon"},paymentImages:[{path:"/img/visa.png",classes:"visa"},{path:"/img/mastercard.png",classes:"mastercard"}],tooltips:{txtKey:"fillup.cc.tooltip"}},baokim:{allowedCurrencies:["VND"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"baokim",bonus:0,inputValue:"baokim::baokim",title_key:"billing.type.local.vietnam.banks",typeImage:{path:"/img/billing/types/bank_type.png",classses:"baokim"},paymentImages:[{path:"/img/billing/baokim2.png"}],needsFullName:true,needsPhoneNumber:true},offline:{allowedCurrencies:["VND"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"offlineBanking",inputValue:"offline_wire_transfer",bonus:0,title_key:"billing.type.offline.banking",typeImage:{path:"/img/billing/types/offline_type.png",classes:"offlineIcon"},paymentImages:[{path:"/img/billing/bank_types/vietcom_bank.png",classes:""},{path:"/img/billing/bank_types/vietin_bank.png",classes:""},{path:"/img/billing/bank_types/exim_bank.png",classes:""}],tooltips:{txtKey:"fillup.offline.banking.tooltip"},offlineContinueSection:false},atm:{allowedCurrencies:["USD","VND","RUB"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"atmBanking",inputValue:"atm",bonus:0,title_key:"billing.type.atm.banking",typeImage:{path:"/img/billing/types/atm_type.png",classes:"atmIcon"},paymentImages:[{path:"/img/billing/bank_types/donga_bank.png",classes:""},{path:"/img/billing/bank_types/acb_bank.png",classes:"acb"},{path:"/img/billing/bank_types/fillup_vietcom_bank.png",classes:""}],tooltips:{txtKey:"fillup.offline.atm.tooltip"},offlineContinueSection:false},help2pay:{allowedCurrencies:["VND"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"help2pay",bonus:0,inputValue:"help2pay::help2pay",title_key:"billing.type.online.banks",typeImage:{path:"/img/billing/types/online_type.png"},tooltips:{txtKey:"fillup.online.banking.tooltip"},paymentImages:[{path:"/img/billing/bank-types.png"}]}},deposits:{default:{USD:[{amount:900,bonus:50,vip:1},{amount:400,bonus:33,vip:0},{amount:200,bonus:30,vip:0},{amount:100,bonus:25,vip:0},{amount:90,bonus:17,vip:0},{amount:60,bonus:12,vip:0},{amount:30,bonus:10,vip:0},{amount:20,bonus:0,vip:0}],EUR:[{amount:900,bonus:50,vip:1},{amount:400,bonus:33,vip:0},{amount:200,bonus:30,vip:0},{amount:100,bonus:25,vip:0},{amount:90,bonus:17,vip:0},{amount:60,bonus:12,vip:0},{amount:30,bonus:10,vip:0},{amount:10,bonus:0,vip:0}],RUB:[{amount:52000,bonus:50,vip:1},{amount:26000,bonus:33,vip:0},{amount:12000,bonus:30,vip:0},{amount:7000,bonus:25,vip:0},{amount:3500,bonus:17,vip:0},{amount:1800,bonus:12,vip:0},{amount:1300,bonus:10,vip:0},{amount:700,bonus:0,vip:0}],VND:[{amount:20000,bonus:50,vip:1},{amount:10000,bonus:33,vip:0},{amount:5000,bonus:30,vip:0},{amount:3000,bonus:25,vip:0},{amount:2000,bonus:17,vip:0},{amount:1500,bonus:12,vip:0},{amount:700,bonus:10,vip:0},{amount:250,bonus:0,vip:0}],HKD:[{amount:7000,bonus:50,vip:1},{amount:3000,bonus:33,vip:0},{amount:1500,bonus:30,vip:0},{amount:1000,bonus:25,vip:0},{amount:700,bonus:17,vip:0},{amount:450,bonus:12,vip:0},{amount:200,bonus:10,vip:0},{amount:100,bonus:0,vip:0}]}}}},{"11":{defaultValue:{USD:60,EUR:60,VND:2000,RUB:3500,HKD:450},defaultBilling:{desktop:"sterling",mac_desktop:"sterling",mobile:"sterling"},banksSettings:{mustBeSelected:1,forBilling:"help2pay","choose.bank.key":"fill45.choose.offline.billing",banks:[{title_code:"Techcombank",img_path:"/img/bank-logo/bank_techcom.png",classes:"bank","data-code":"TECHCOM"},{title_code:"Sacombank",img_path:"/img/bank-logo/bank_sacom.png",classes:"bank","data-code":"SACOM"},{title_code:"Vietcombank",img_path:"/img/bank-logo/bank_vietcom.png",classes:"bank","data-code":"VIETCOM"},{title_code:"Asia Commercial Bank",img_path:"/img/bank-logo/bank_acb.png",classes:"bank","data-code":"ACB"},{title_code:"DongA Bank",img_path:"/img/bank-logo/bank_donga.png",classes:"bank","data-code":"DONG_A"},{title_code:"Vietinbank",img_path:"/img/bank-logo/bank_vietin.png",classes:"bank","data-code":"VIETIN"},{title_code:"BIDV Bank",img_path:"/img/bank-logo/bank_bidv.png",classes:"bank","data-code":"BIDV"},{title_code:"Eximbank Vietnam",img_path:"/img/bank-logo/bank_exim.png",classes:"bank","data-code":"EXIM"}]},billings:{sterling:{allowedCurrencies:["VND","USD","HKD"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"sterling",inputValue:"sterling::sterling",bonus:10,title_key:"billing.type.cc",typeImage:{path:"/img/billing/types/card_type.png",classes:"cardIcon"},paymentImages:[{path:"/img/visa.png",classes:"visa"},{path:"/img/mastercard.png",classes:"mastercard"}],tooltips:{txtKey:"fillup.cc.tooltip"}},baokim:{allowedCurrencies:["VND"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"baokim",bonus:0,inputValue:"baokim::baokim",title_key:"billing.type.local.vietnam.banks",typeImage:{path:"/img/billing/types/bank_type.png",classses:"baokim"},paymentImages:[{path:"/img/billing/baokim2.png"}],needsFullName:true,needsPhoneNumber:true},offline:{allowedCurrencies:["VND"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"offlineBanking",inputValue:"offline_wire_transfer",bonus:0,title_key:"billing.type.offline.banking",typeImage:{path:"/img/billing/types/offline_type.png",classes:"offlineIcon"},paymentImages:[{path:"/img/billing/bank_types/vietcom_bank.png",classes:""},{path:"/img/billing/bank_types/vietin_bank.png",classes:""},{path:"/img/billing/bank_types/exim_bank.png",classes:""}],tooltips:{txtKey:"fillup.offline.banking.tooltip"},offlineContinueSection:false},atm:{allowedCurrencies:["USD","VND","RUB"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"atmBanking",inputValue:"atm",bonus:0,title_key:"billing.type.atm.banking",typeImage:{path:"/img/billing/types/atm_type.png",classes:"atmIcon"},paymentImages:[{path:"/img/billing/bank_types/donga_bank.png",classes:""},{path:"/img/billing/bank_types/acb_bank.png",classes:"acb"},{path:"/img/billing/bank_types/fillup_vietcom_bank.png",classes:""}],tooltips:{txtKey:"fillup.offline.atm.tooltip"},offlineContinueSection:false},help2pay:{allowedCurrencies:["VND"],allowedPlatforms:["desktop","mac_desktop","mobile"],id:"help2pay",bonus:0,inputValue:"help2pay::help2pay",title_key:"billing.type.online.banks",typeImage:{path:"/img/billing/types/online_type.png"},tooltips:{txtKey:"fillup.online.banking.tooltip"},paymentImages:[{path:"/img/billing/bank-types.png"}]}},deposits:{default:{USD:[{amount:900,bonus:50,vip:1},{amount:400,bonus:33,vip:0},{amount:200,bonus:30,vip:0},{amount:100,bonus:25,vip:0},{amount:90,bonus:17,vip:0},{amount:60,bonus:12,vip:0},{amount:30,bonus:10,vip:0},{amount:20,bonus:0,vip:0}],EUR:[{amount:900,bonus:50,vip:1},{amount:400,bonus:33,vip:0},{amount:200,bonus:30,vip:0},{amount:100,bonus:25,vip:0},{amount:90,bonus:17,vip:0},{amount:60,bonus:12,vip:0},{amount:30,bonus:10,vip:0},{amount:10,bonus:0,vip:0}],RUB:[{amount:52000,bonus:50,vip:1},{amount:26000,bonus:33,vip:0},{amount:12000,bonus:30,vip:0},{amount:7000,bonus:25,vip:0},{amount:3500,bonus:17,vip:0},{amount:1800,bonus:12,vip:0},{amount:1300,bonus:10,vip:0},{amount:700,bonus:0,vip:0}],VND:[{amount:20000,bonus:50,vip:1},{amount:10000,bonus:33,vip:0},{amount:5000,bonus:30,vip:0},{amount:3000,bonus:25,vip:0},{amount:2000,bonus:17,vip:0},{amount:1500,bonus:12,vip:0},{amount:700,bonus:10,vip:0},{amount:250,bonus:0,vip:0}],HKD:[{amount:7000,bonus:50,vip:1},{amount:3000,bonus:33,vip:0},{amount:1500,bonus:30,vip:0},{amount:1000,bonus:25,vip:0},{amount:700,bonus:17,vip:0},{amount:450,bonus:12,vip:0},{amount:200,bonus:10,vip:0},{amount:100,bonus:0,vip:0}]}}}}]);

/***/ }),
/* 1570 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SettingsHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 192px;\n  margin-right: 20px;\n  padding: 0;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 39px;\n  text-align: left;\n  color: #343434;\n\n  ",";\n\n  @media(max-width: 959px) {\n    margin-right: 0;\n    padding-bottom: 5px;\n    font-size: ",";\n    line-height: 1;\n    font-weight: 400;\n    color: #797979;\n  }\n\n  ","\n"],["\n  display: inline-block;\n  vertical-align: top;\n  width: 192px;\n  margin-right: 20px;\n  padding: 0;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 39px;\n  text-align: left;\n  color: #343434;\n\n  ",";\n\n  @media(max-width: 959px) {\n    margin-right: 0;\n    padding-bottom: 5px;\n    font-size: ",";\n    line-height: 1;\n    font-weight: 400;\n    color: #797979;\n  }\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    margin-right: 0;\n    margin-left: 10px;\n    text-align: right;\n  "],["\n    margin-right: 0;\n    margin-left: 10px;\n    text-align: right;\n  "]),_templateObject3=_taggedTemplateLiteral(["\n    line-height: 16px;\n  "],["\n    line-height: 16px;\n  "]),_templateObject4=_taggedTemplateLiteral(["\n  display: block;\n  margin: 5px 0 0 0;\n  padding: 0px;\n  font-size: ",";\n\n  @media(max-width: 959px) {\n    line-height: 1;\n  }\n"],["\n  display: block;\n  margin: 5px 0 0 0;\n  padding: 0px;\n  font-size: ",";\n\n  @media(max-width: 959px) {\n    line-height: 1;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  color: #D05353;\n"],["\n  color: #D05353;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16),function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16),function(props){return props.subtitle&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var Subheading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(14));var Warning=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Subheading)(_templateObject5);function SettingsHeader(props){var title=props.title,subtitle=props.subtitle,warning=props.warning;var showColon=props.showColon&&props.locale!=="ar";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading,{subtitle:subtitle||warning},title,showColon&&":",subtitle&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subheading,null,subtitle),warning&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Warning,null,warning));}

/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_passport_img_png__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_passport_img_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_passport_img_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_passport_del_png__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_passport_del_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_passport_del_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_passport_del_hover_png__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_passport_del_hover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_passport_del_hover_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_passport_view_png__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_passport_view_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_passport_view_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_passport_view_hover_png__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_passport_view_hover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_passport_view_hover_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  box-sizing: border-box;\n  width: 100%;\n  display: table;\n  margin: 0px;\n"],["\n  box-sizing: border-box;\n  width: 100%;\n  display: table;\n  margin: 0px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n  min-width: 30px;\n  margin: 0px;\n  padding: 0px;\n  @media (max-width: 320px) {\n    min-width: 24px;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n  min-width: 30px;\n  margin: 0px;\n  padding: 0px;\n  @media (max-width: 320px) {\n    min-width: 24px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  text-align: left;\n  padding-left: 10px;\n  position: relative;\n  overflow: hidden;\n  :before {\n    content: \"......................................................................................................................................................................................................................................................................................................................\";\n    position: absolute;\n    top: 0px;\n    left: 10px;\n    display: block;\n    height: 100%;\n    width: 100%;\n    max-width: 1000px;\n    font: 16px/39px Roboto, Arial, sans-serif;\n    white-space: nowrap;\n    text-overflow: clip;\n    letter-spacing: -0.75px;\n    color: #797979;\n    overflow: hidden;\n    z-index: 0;\n    @media (max-width: 320px) {\n      left: 6px;\n      font-size: ",";\n    }\n  }\n  @media (max-width: 320px) {\n    padding-left: 6px;\n  }\n  \n  ",";\n"],["\n  width: 100%;\n  text-align: left;\n  padding-left: 10px;\n  position: relative;\n  overflow: hidden;\n  :before {\n    content: \"......................................................................................................................................................................................................................................................................................................................\";\n    position: absolute;\n    top: 0px;\n    left: 10px;\n    display: block;\n    height: 100%;\n    width: 100%;\n    max-width: 1000px;\n    font: 16px/39px Roboto, Arial, sans-serif;\n    white-space: nowrap;\n    text-overflow: clip;\n    letter-spacing: -0.75px;\n    color: #797979;\n    overflow: hidden;\n    z-index: 0;\n    @media (max-width: 320px) {\n      left: 6px;\n      font-size: ",";\n    }\n  }\n  @media (max-width: 320px) {\n    padding-left: 6px;\n  }\n  \n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n    padding-left: 0;\n    padding-right: 10px;\n    text-align: right;\n    \n    :before {\n      left: auto;\n      right: 10px;\n      \n      @media (max-width: 320px) {\n        left: auto;\n        right: 6px;\n      }\n    }\n  "],["\n    padding-left: 0;\n    padding-right: 10px;\n    text-align: right;\n    \n    :before {\n      left: auto;\n      right: 10px;\n      \n      @media (max-width: 320px) {\n        left: auto;\n        right: 6px;\n      }\n    }\n  "]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  top: 2px;\n  display: inline-block;\n  max-width: 470px;\n  margin: 0px;\n  padding-right: 1px;\n  box-sizing: border-box;\n  font: 16px/39px Roboto, Arial, sans-serif;\n  color: #797979;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: #fff;\n  @media (max-width: 640px) {\n    top: 0px;\n  }\n  @media (max-width: 320px) {\n    font-size: ",";\n  }\n\n  ","\n\n  ","\n"],["\n  position: relative;\n  top: 2px;\n  display: inline-block;\n  max-width: 470px;\n  margin: 0px;\n  padding-right: 1px;\n  box-sizing: border-box;\n  font: 16px/39px Roboto, Arial, sans-serif;\n  color: #797979;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  background: #fff;\n  @media (max-width: 640px) {\n    top: 0px;\n  }\n  @media (max-width: 320px) {\n    font-size: ",";\n  }\n\n  ","\n\n  ","\n"]),_templateObject6=_taggedTemplateLiteral(["\n    top: 0px;\n    background: #f6f6f6;\n  "],["\n    top: 0px;\n    background: #f6f6f6;\n  "]),_templateObject7=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  top: -1px;\n  display: block;\n  height: 24px;\n  width: auto;\n  @media (max-width: 320px) {\n    height: 20px;\n  }\n\n  ","\n"],["\n  position: relative;\n  top: -1px;\n  display: block;\n  height: 24px;\n  width: auto;\n  @media (max-width: 320px) {\n    height: 20px;\n  }\n\n  ","\n"]),_templateObject9=_taggedTemplateLiteral(["\n    top: 0px;\n    height: 20px;\n  "],["\n    top: 0px;\n    height: 20px;\n  "]),_templateObject10=_taggedTemplateLiteral(["\n  display: block;\n  height: 22px;\n  width: 100%;\n  background: right bottom no-repeat;\n  background-size: contain;\n  border: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  @media (max-width: 320px) {\n    height: 18px;\n  }\n  :hover {\n    outline: none;\n  }\n  :focus {\n    outline: none;\n  }\n  :active {\n    outline: none;\n  }\n"],["\n  display: block;\n  height: 22px;\n  width: 100%;\n  background: right bottom no-repeat;\n  background-size: contain;\n  border: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  @media (max-width: 320px) {\n    height: 18px;\n  }\n  :hover {\n    outline: none;\n  }\n  :focus {\n    outline: none;\n  }\n  :active {\n    outline: none;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  margin-left: auto;\n  background-image: url(",");\n  \n  ",";\n  :hover {\n    background-image: url(",");\n  }\n"],["\n  margin-left: auto;\n  background-image: url(",");\n  \n  ",";\n  :hover {\n    background-image: url(",");\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n    background-position-x: left;\n  "],["\n    background-position-x: left;\n  "]),_templateObject13=_taggedTemplateLiteral(["\n  background-image: url(",");\n  :hover {\n    background-image: url(",");\n  }\n\n  ",";\n"],["\n  background-image: url(",");\n  :hover {\n    background-image: url(",");\n  }\n\n  ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n    background-image: url(",");\n  "],["\n    background-image: url(",");\n  "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var File=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Cell=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Grow=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Cell)(_templateObject3,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var FileName=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject5,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.offpay&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);},function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var FileNameColor=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject7,function(props){return props.theme.mainFontColor;});var Img=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject8,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});var Action=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var Delete=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Action)(_templateObject11,__WEBPACK_IMPORTED_MODULE_3__images_passport_del_png___default.a,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);},__WEBPACK_IMPORTED_MODULE_4__images_passport_del_hover_png___default.a);var View=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Action)(_templateObject13,__WEBPACK_IMPORTED_MODULE_5__images_passport_view_png___default.a,__WEBPACK_IMPORTED_MODULE_6__images_passport_view_hover_png___default.a,function(props){return props.activeView&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14,__WEBPACK_IMPORTED_MODULE_6__images_passport_view_hover_png___default.a);});var PassportFile=function(_Component){_inherits(PassportFile,_Component);function PassportFile(props){_classCallCheck(this,PassportFile);var _this=_possibleConstructorReturn(this,(PassportFile.__proto__||Object.getPrototypeOf(PassportFile)).call(this,props));_this.onDeleteClick=_this.onDeleteClick.bind(_this);_this.state={fileReaderAPIisAvailable:FileReader&&typeof FileReader==="function"};return _this;}_createClass(PassportFile,[{key:"onDeleteClick",value:function onDeleteClick(e){e.preventDefault();this.props.onDelete(this.props.fileIndex);}},{key:"render",value:function render(){var _props=this.props,onClick=_props.onClick,name=_props.name,offpay=_props.offpay,desktop=_props.desktop,activeView=_props.activeView;var viewable=this.props.viewable&&/\.(jpg|jpeg|png|bmp|gif)$/i.test(name);var truncatedName=function truncatedName(name){var truncatedStr=name;var truncateTo=20;var endChars=4;var ellipsis="...";if(name.length>=truncateTo){var startChars=truncateTo-endChars-ellipsis.length;var truncatedStart=name.substring(0,startChars);var truncatedEnd=name.substring(name.length-endChars,name.length);truncatedStr=""+truncatedStart+ellipsis+truncatedEnd;}return truncatedStr;};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(File,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktop:desktop,src:__WEBPACK_IMPORTED_MODULE_2__images_passport_img_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_2__images_passport_img_png___default.a})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Grow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FileName,{offpay:offpay,desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FileNameColor,null,truncatedName(name)))),this.state.fileReaderAPIisAvailable&&viewable&&onClick&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(View,{activeView:activeView,onClick:onClick})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Delete,{onClick:this.onDeleteClick})));}}]);return PassportFile;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (PassportFile);

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  margin: 10px auto;\n  max-width: 220px;\n\n  ",";\n"],["\n  position: relative;\n  overflow: hidden;\n  margin: 10px auto;\n  max-width: 220px;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n    margin: 0px;\n    max-width: 100%;"],["\n    margin: 0px;\n    max-width: 100%;"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 38px;\n  top: 0px;\n  left: 0px;\n  margin: 0px;\n  padding: 0px;\n  z-index: 100%;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  cursor: pointer;\n  pointer-events: none;\n\n  ",";\n"],["\n  position: absolute;\n  width: 100%;\n  height: 38px;\n  top: 0px;\n  left: 0px;\n  margin: 0px;\n  padding: 0px;\n  z-index: 100%;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  cursor: pointer;\n  pointer-events: none;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n    display: inline-block;\n    height: 39px;\n  "],["\n    display: inline-block;\n    height: 39px;\n  "]),_templateObject5=_taggedTemplateLiteral(["\n  display: block;\n  border-radius: 8px;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.22);\n  box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),\n    inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);\n  font: 700 18px/38px Roboto, Arial, sans-serif;\n  cursor: pointer;\n  background-color: #706281;\n  background: linear-gradient(to bottom, #877c95 0%, #706281 100%);\n  z-index: -1;\n  @media (max-width: 320px) {\n    font-size: 22px;\n    line-height: 48px;\n    min-width: 220px;\n  }\n  :hover {\n    background-color: #877c95;\n    background: linear-gradient(to bottom, #706281 0%, #877c95 100%);\n  }\n\n  "," "," ",";\n"],["\n  display: block;\n  border-radius: 8px;\n  text-align: center;\n  text-decoration: none;\n  color: #fff;\n  text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.22);\n  box-shadow: inset 0px -2px 0px 0px rgba(0, 0, 0, 0.3),\n    inset 0px -3px 0px 0px rgba(255, 255, 255, 0.1);\n  font: 700 18px/38px Roboto, Arial, sans-serif;\n  cursor: pointer;\n  background-color: #706281;\n  background: linear-gradient(to bottom, #877c95 0%, #706281 100%);\n  z-index: -1;\n  @media (max-width: 320px) {\n    font-size: 22px;\n    line-height: 48px;\n    min-width: 220px;\n  }\n  :hover {\n    background-color: #877c95;\n    background: linear-gradient(to bottom, #706281 0%, #877c95 100%);\n  }\n\n  "," "," ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n    border-radius: 8px;\n    text-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n    line-height: 39px;\n  "],["\n    border-radius: 8px;\n    text-shadow: none;\n    box-shadow: none;\n    font-size: 16px;\n    line-height: 39px;\n  "]),_templateObject7=_taggedTemplateLiteral(["\n    @media (max-width: 320px) {\n      font-size: 16px;\n      line-height: 39px;\n      min-width: 0px;\n    }\n  "],["\n    @media (max-width: 320px) {\n      font-size: 16px;\n      line-height: 39px;\n      min-width: 0px;\n    }\n  "]),_templateObject8=_taggedTemplateLiteral(["\n    pointer-events: none;\n    cursor: default;\n    background-color: #aaadbb;\n    background: linear-gradient(to bottom, #bbbac9 0%, #aaadbb 100%);\n  "],["\n    pointer-events: none;\n    cursor: default;\n    background-color: #aaadbb;\n    background: linear-gradient(to bottom, #bbbac9 0%, #aaadbb 100%);\n  "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InputContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var Input=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject3,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].label(_templateObject5,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);},function(props){return props.offline&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var PassportScanInput=function(_Component){_inherits(PassportScanInput,_Component);function PassportScanInput(props){_classCallCheck(this,PassportScanInput);var _this=_possibleConstructorReturn(this,(PassportScanInput.__proto__||Object.getPrototypeOf(PassportScanInput)).call(this,props));_this.onUpload=_this.onUpload.bind(_this);return _this;}_createClass(PassportScanInput,[{key:"onUpload",value:function onUpload(){var files=document.querySelector("#"+this.props.id).files;this.props.onChange(files);}},{key:"render",value:function render(){var _props=this.props,id=_props.id,desktop=_props.desktop,offlinePopup=_props.offlinePopup,disabled=_props.disabled;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputContainer,{desktop:desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{desktop:desktop,offline:offlinePopup,isabled:disabled,htmlFor:id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Attach")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Input,{type:"file",id:id,accept:"image/jpeg,image/gif,image/png,application/pdf",onChange:this.onUpload}));}}]);return PassportScanInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["g" /* withGettext */])(PassportScanInput));

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return Overlay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return Popup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PopupTableCell; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PopupInner; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Close; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return Header; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return SectionView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return RowContainerView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return MainView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return InputItemView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return InputItem1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ButtonContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ButtonWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HelpTextView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BonusHeader; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BonusSelect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return Label; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ScanItemContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ScanItemInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return KdongAmount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return KdongKdong; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return KdongInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return KdongContainer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 200;\n  width: 100%;\n  height: 100%;\n  padding: 25px 0;\n  overflow: auto;\n  background-color: rgba(0,0,0,0.5);\n\n  ","\n\n  ","\n\n  ","\n"],["\n  position: fixed;\n  top: 0px;\n  left: 0px;\n  z-index: 200;\n  width: 100%;\n  height: 100%;\n  padding: 25px 0;\n  overflow: auto;\n  background-color: rgba(0,0,0,0.5);\n\n  ","\n\n  ","\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    position: fixed;\n    bottom: 0px;\n    height: auto;\n    padding: 0px;\n  "],["\n    position: fixed;\n    bottom: 0px;\n    height: auto;\n    padding: 0px;\n  "]),_templateObject3=_taggedTemplateLiteral(["\n    position: absolute;\n    top: 0px;\n    bottom: 0px;\n    height: auto;\n    padding: 0px;\n  "],["\n    position: absolute;\n    top: 0px;\n    bottom: 0px;\n    height: auto;\n    padding: 0px;\n  "]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  display: table;\n  width: 100%;\n  max-width: 940px;\n  height: 100%;\n  margin: 0 auto;\n  font-size: ",";\n  line-height: 1;\n\n  ","\n"],["\n  position: relative;\n  display: table;\n  width: 100%;\n  max-width: 940px;\n  height: 100%;\n  margin: 0 auto;\n  font-size: ",";\n  line-height: 1;\n\n  ","\n"]),_templateObject5=_taggedTemplateLiteral(["\n    position: relative;\n    display: table;\n    min-height: 100%;\n    border-radius: 0px;\n    box-shadow: none;\n  "],["\n    position: relative;\n    display: table;\n    min-height: 100%;\n    border-radius: 0px;\n    box-shadow: none;\n  "]),_templateObject6=_taggedTemplateLiteral(["\n  position: relative;\n  display: table-cell;\n  vertical-align: middle;\n\n  ","\n"],["\n  position: relative;\n  display: table-cell;\n  vertical-align: middle;\n\n  ","\n"]),_templateObject7=_taggedTemplateLiteral(["\n    display: table-cell;\n    padding: 0px;\n  "],["\n    display: table-cell;\n    padding: 0px;\n  "]),_templateObject8=_taggedTemplateLiteral(["\n  text-align: left;\n  position: relative;\n  width: 100%;\n  padding: 30px 29px 38px;\n  background: #f6f6f6;\n  border-radius: 5px;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n  overflow-x: hidden;\n\n  ","\n\n\n  ","\n"],["\n  text-align: left;\n  position: relative;\n  width: 100%;\n  padding: 30px 29px 38px;\n  background: #f6f6f6;\n  border-radius: 5px;\n  box-shadow: 0 0 17px 0px rgba(0, 0, 0, 1);\n  overflow-x: hidden;\n\n  ","\n\n\n  ","\n"]),_templateObject9=_taggedTemplateLiteral(["\n    position: relative;\n    width: 100%;\n    padding-top: 20px;\n    padding-bottom: 25px;\n    background: #f6f6f6;\n    border-radius: 0px;\n    box-shadow: none;\n    webkit-transform: translateZ(0px);\n    @media (max-width: 414px) {\n      padding: 20px;\n      padding-bottom: 30px;\n    }\n    @media (max-width: 360px) {\n      padding: 17px;\n      padding-bottom: 27px;\n    }\n    @media (max-width: 320px) {\n      padding: 15px;\n      padding-bottom: 25px;\n    }\n  "],["\n    position: relative;\n    width: 100%;\n    padding-top: 20px;\n    padding-bottom: 25px;\n    background: #f6f6f6;\n    border-radius: 0px;\n    box-shadow: none;\n    webkit-transform: translateZ(0px);\n    @media (max-width: 414px) {\n      padding: 20px;\n      padding-bottom: 30px;\n    }\n    @media (max-width: 360px) {\n      padding: 17px;\n      padding-bottom: 27px;\n    }\n    @media (max-width: 320px) {\n      padding: 15px;\n      padding-bottom: 25px;\n    }\n  "]),_templateObject10=_taggedTemplateLiteral(["\n      padding-top: 100px;\n\n      @media (max-width: 800px) {\n        padding-top: 50px;\n      }\n  "],["\n      padding-top: 100px;\n\n      @media (max-width: 800px) {\n        padding-top: 50px;\n      }\n  "]),_templateObject11=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 16px;\n  height: 16px;\n  background-size: cover;\n  cursor: pointer;\n  :before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :hover {\n    :before {\n      border-left-color: #60a31c;\n    }\n    :after {\n      border-left-color: #60a31c;\n    }\n  }\n"],["\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  width: 16px;\n  height: 16px;\n  background-size: cover;\n  cursor: pointer;\n  :before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n    width: 0px;\n    height: 20px;\n    border-left: 2px solid #a0a7b2;\n    transition: all 0.3s ease;\n  }\n  :hover {\n    :before {\n      border-left-color: #60a31c;\n    }\n    :after {\n      border-left-color: #60a31c;\n    }\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  margin: 0px;\n  margin-bottom: 6px;\n  padding: 0px;\n  font-weight: 300;\n  font-size: 30px;\n  line-height: 1;\n  color: #a5a4a4;\n  text-align: center;\n\n  ","\n"],["\n  margin: 0px;\n  margin-bottom: 6px;\n  padding: 0px;\n  font-weight: 300;\n  font-size: 30px;\n  line-height: 1;\n  color: #a5a4a4;\n  text-align: center;\n\n  ","\n"]),_templateObject13=_taggedTemplateLiteral(["\n    margin: 0px;\n    font-weight: 400;\n    font-size: 24px;\n    color: #a5a4a4;\n    text-align: center;\n    @media (max-width: 480px) {\n      font-size: 22px;\n    }\n  "],["\n    margin: 0px;\n    font-weight: 400;\n    font-size: 24px;\n    color: #a5a4a4;\n    text-align: center;\n    @media (max-width: 480px) {\n      font-size: 22px;\n    }\n  "]),_templateObject14=_taggedTemplateLiteral(["\n  margin-top: 22px;\n  border-bottom: 0px;\n  :first-of-type {\n    margin-top: 35px;\n  }\n  :nth-of-type(n+2) {\n    padding-bottom: 20px;\n  }\n  @media (max-width: 959px) {\n    margin-top: 0px;\n    border-bottom-color: #f6f6f6;\n    padding-bottom: 10px;\n  }\n\n  ","\n"],["\n  margin-top: 22px;\n  border-bottom: 0px;\n  :first-of-type {\n    margin-top: 35px;\n  }\n  :nth-of-type(n+2) {\n    padding-bottom: 20px;\n  }\n  @media (max-width: 959px) {\n    margin-top: 0px;\n    border-bottom-color: #f6f6f6;\n    padding-bottom: 10px;\n  }\n\n  ","\n"]),_templateObject15=_taggedTemplateLiteral(["\n    margin: 0 auto;\n    margin-top: 15px;\n    :first-of-type {\n      margin-top: 15px;\n    }\n    :nth-of-type(2) {\n      margin-top: 15px;\n      @media (max-width: 959px) {\n        margin-top: 20px;\n      }\n    }\n    @media (max-width: 414px) {\n      max-width: 100%;\n    }\n    @media (max-width: 480px) {\n      max-width: 290px;\n    }\n    @media (max-width: 640px) {\n      max-width: 388px;\n    }\n    @media (max-width: 736px) {\n      max-width: 446px;\n    }\n  "],["\n    margin: 0 auto;\n    margin-top: 15px;\n    :first-of-type {\n      margin-top: 15px;\n    }\n    :nth-of-type(2) {\n      margin-top: 15px;\n      @media (max-width: 959px) {\n        margin-top: 20px;\n      }\n    }\n    @media (max-width: 414px) {\n      max-width: 100%;\n    }\n    @media (max-width: 480px) {\n      max-width: 290px;\n    }\n    @media (max-width: 640px) {\n      max-width: 388px;\n    }\n    @media (max-width: 736px) {\n      max-width: 446px;\n    }\n  "]),_templateObject16=_taggedTemplateLiteral(["\n  direction: ",";\n  margin-bottom: 24px;\n\n  ",";\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n  @media(max-width: 959px) {\n    margin-bottom: 15px;\n  }\n\n  ","\n"],["\n  direction: ",";\n  margin-bottom: 24px;\n\n  ",";\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n  @media(max-width: 959px) {\n    margin-bottom: 15px;\n  }\n\n  ","\n"]),_templateObject17=_taggedTemplateLiteral(["\n    text-align: right;\n  "],["\n    text-align: right;\n  "]),_templateObject18=_taggedTemplateLiteral(["\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: 0px;\n    :nth-of-type(odd) {\n      width: 56.5%;\n      padding-right: 8px;\n    }\n    :nth-of-type(even) {\n      width: 43.5%;\n      padding-left: 8px;\n    }\n    @media(max-width: 959px) {\n      margin-bottom: 0px;\n      vertical-align: bottom;\n    }\n  "],["\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: 0px;\n    :nth-of-type(odd) {\n      width: 56.5%;\n      padding-right: 8px;\n    }\n    :nth-of-type(even) {\n      width: 43.5%;\n      padding-left: 8px;\n    }\n    @media(max-width: 959px) {\n      margin-bottom: 0px;\n      vertical-align: bottom;\n    }\n  "]),_templateObject19=_taggedTemplateLiteral(["\n  width: 100%;\n  margin-right: 0;\n\n  ","\n"],["\n  width: 100%;\n  margin-right: 0;\n\n  ","\n"]),_templateObject20=_taggedTemplateLiteral(["\n    display: inline-block;\n    vertical-align: top;\n    width: 460px;\n    margin-right: 20px;\n\n    ",";\n  "],["\n    display: inline-block;\n    vertical-align: top;\n    width: 460px;\n    margin-right: 20px;\n\n    ",";\n  "]),_templateObject21=_taggedTemplateLiteral(["\n      margin-right: 0;\n      margin-left: 20px;\n    "],["\n      margin-right: 0;\n      margin-left: 20px;\n    "]),_templateObject22=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: top;\n  width: 220px;\n  min-height: 39px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 39px;\n  color: #a5a4a4;\n  ",";\n  :first-of-type {\n    margin-right: 20px;\n    margin-bottom: 4px;\n\n    ",";\n  }\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: top;\n  width: 220px;\n  min-height: 39px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 39px;\n  color: #a5a4a4;\n  ",";\n  :first-of-type {\n    margin-right: 20px;\n    margin-bottom: 4px;\n\n    ",";\n  }\n  ",";\n"]),_templateObject23=_taggedTemplateLiteral(["\n    width: 100%;\n    min-height: 0px;\n    line-height: 1;\n    :first-of-type {\n      margin-right: 0;\n      ",";\n    }\n  "],["\n    width: 100%;\n    min-height: 0px;\n    line-height: 1;\n    :first-of-type {\n      margin-right: 0;\n      ",";\n    }\n  "]),_templateObject24=_taggedTemplateLiteral(["\n        margin-left: 0;\n      "],["\n        margin-left: 0;\n      "]),_templateObject25=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 140px;\n  margin-right: 20px;\n  line-height: 38px;\n  :nth-of-type(3) {\n    margin-right: 0px;\n  }\n\n  ","\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 140px;\n  margin-right: 20px;\n  line-height: 38px;\n  :nth-of-type(3) {\n    margin-right: 0px;\n  }\n\n  ","\n"]),_templateObject26=_taggedTemplateLiteral(["\n    width: 100%;\n    min-height: 0px;\n    line-height: 1;\n  "],["\n    width: 100%;\n    min-height: 0px;\n    line-height: 1;\n  "]),_templateObject27=_taggedTemplateLiteral(["\n  max-width: 266px;\n  margin: 20px auto 0;\n  text-align: center;\n\n  ","\n"],["\n  max-width: 266px;\n  margin: 20px auto 0;\n  text-align: center;\n\n  ","\n"]),_templateObject28=_taggedTemplateLiteral(["\n    display: inline-block;\n    vertical-align: middle;\n    width: 50%;\n    :first-of-type {\n      padding-right: 6px;\n    }\n    :last-of-type {\n      padding-left: 6px;\n    }\n  "],["\n    display: inline-block;\n    vertical-align: middle;\n    width: 50%;\n    :first-of-type {\n      padding-right: 6px;\n    }\n    :last-of-type {\n      padding-left: 6px;\n    }\n  "]),_templateObject29=_taggedTemplateLiteral(["\n  text-align: center;\n  padding-bottom: 0px;\n  :last-of-type {\n    padding-bottom: 0px;\n  }\n"],["\n  text-align: center;\n  padding-bottom: 0px;\n  :last-of-type {\n    padding-bottom: 0px;\n  }\n"]),_templateObject30=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 19px;\n  color: #a5a4a4;\n  @media (max-width: 959px) {\n    line-height: 1.25;\n  }\n  @media (max-width: 480px) {\n    font-size: ",";\n  }\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 19px;\n  color: #a5a4a4;\n  @media (max-width: 959px) {\n    line-height: 1.25;\n  }\n  @media (max-width: 480px) {\n    font-size: ",";\n  }\n"]),_templateObject31=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 80px;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 80px;\n"]),_templateObject32=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 140px;\n\n  ","\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 140px;\n\n  ","\n"]),_templateObject33=_taggedTemplateLiteral(["\n    width: 100%;\n    padding: 12px 0;\n  "],["\n    width: 100%;\n    padding: 12px 0;\n  "]),_templateObject34=_taggedTemplateLiteral(["\n  direction: ",";\n  display: block;\n  width: 100%;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: #797979;\n  text-align: center;\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n"],["\n  direction: ",";\n  display: block;\n  width: 100%;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: #797979;\n  text-align: center;\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n"]),_templateObject35=_taggedTemplateLiteral(["\n  ","\n"],["\n  ","\n"]),_templateObject36=_taggedTemplateLiteral(["\n    max-width: 180px;\n    margin: 4px auto 12px;\n  "],["\n    max-width: 180px;\n    margin: 4px auto 12px;\n  "]),_templateObject37=_taggedTemplateLiteral(["\n    max-width: 220px;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n  "],["\n    max-width: 220px;\n    margin-left: auto;\n    margin-right: auto;\n    text-align: center;\n  "]),_templateObject38=_taggedTemplateLiteral(["\n  color: #4e2a81;\n  font-size: 16px;\n  margin-left: 7px;\n\n  ","\n"],["\n  color: #4e2a81;\n  font-size: 16px;\n  margin-left: 7px;\n\n  ","\n"]),_templateObject39=_taggedTemplateLiteral(["\n    margin-left: 0px;\n  "],["\n    margin-left: 0px;\n  "]),_templateObject40=_taggedTemplateLiteral(["\n  font-size: 16px;\n  color: #717171;\n"],["\n  font-size: 16px;\n  color: #717171;\n"]),_templateObject41=_taggedTemplateLiteral(["\n  font-size: ",";\n\n  ","\n"],["\n  font-size: ",";\n\n  ","\n"]),_templateObject42=_taggedTemplateLiteral(["\n    margin-left: 5px;\n    white-space: nowrap;\n    line-height: 2;\n  "],["\n    margin-left: 5px;\n    white-space: nowrap;\n    line-height: 2;\n  "]),_templateObject43=_taggedTemplateLiteral(["\n  max-width: 180px;\n  margin: 4px auto 12px;\n  text-align: center;\n\n  ","\n"],["\n  max-width: 180px;\n  margin: 4px auto 12px;\n  text-align: center;\n\n  ","\n"]),_templateObject44=_taggedTemplateLiteral(["\n    max-width: 90%;\n  "],["\n    max-width: 90%;\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Overlay=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject,function(props){return!props.desktop&&!props.isIOSApp&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject2);},function(props){return!props.desktop&&props.isIOSApp&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3);},function(props){return!props.desktop&&props.isAndroidApp&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3);});var Popup=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject4,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject5);});var PopupTableCell=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject6,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject7);});var PopupInner=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject8,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject9);},function(props){return!props.desktop&&!props.isIOSApp&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject10);});var Close=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject11);var Header=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].h2(_templateObject12,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject13);});var SectionView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].section(_templateObject14,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject15);});var RowContainerView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.theme.direction;},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject17);},function(props){return props.inlineRow&&!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject18);});var MainView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject19,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject20,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject21);});});var InputItemView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject22,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject17);},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject21);},function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject23,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject24);});});var InputItem1=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject25,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject26);});var ButtonContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject27,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject28);});var ButtonWrapper=Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */])(SectionView)(_templateObject29);var HelpTextView=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject30,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var BonusHeader=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject31);var BonusSelect=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject32,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject33);});var Label=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject34,function(props){return props.theme.direction;});var ScanItemContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject35,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject36);});var ScanItemInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject35,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject37);});var KdongAmount=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject38,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject39);});var KdongKdong=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject40);var KdongInfo=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].span(_templateObject41,function(_ref5){var theme=_ref5.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject42);});var KdongContainer=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject43,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject44);});

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LinkButton__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(81);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: table;\n  vertical-align: top;\n  width: 480px;\n  margin-left: 212px;\n  padding: 125px 0;\n\n  ","\n"],["\n  position: relative;\n  display: table;\n  vertical-align: top;\n  width: 480px;\n  margin-left: 212px;\n  padding: 125px 0;\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    display: table;\n    vertical-align: middle;\n    width: 100%;\n    margin-top: 55px;\n    margin-left: 0px;\n    padding: 0px;\n    background: transparent;\n    @media (min-width: 480px) {\n      margin-top: 5%;\n    }\n    @media (min-width: 736px) {\n      margin-top: 8%;\n    }\n  "],["\n    display: table;\n    vertical-align: middle;\n    width: 100%;\n    margin-top: 55px;\n    margin-left: 0px;\n    padding: 0px;\n    background: transparent;\n    @media (min-width: 480px) {\n      margin-top: 5%;\n    }\n    @media (min-width: 736px) {\n      margin-top: 8%;\n    }\n  "]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  margin: 0px;\n  padding: 63px 0 0 0;\n  font-weight: 300;\n  font-size: 30px;\n  line-height: 1.5;\n  text-decoration: none;\n  text-align: center;\n  color: #60a31c;\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 50%;\n    width: 17px;\n    height: 38px;\n    border-right: 3px solid #60a31c;\n    border-bottom: 3px solid #60a31c;\n    transform: translateX(-50%) rotate(45deg);\n  }\n\n  ","\n"],["\n  position: relative;\n  margin: 0px;\n  padding: 63px 0 0 0;\n  font-weight: 300;\n  font-size: 30px;\n  line-height: 1.5;\n  text-decoration: none;\n  text-align: center;\n  color: #60a31c;\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 0px;\n    left: 50%;\n    width: 17px;\n    height: 38px;\n    border-right: 3px solid #60a31c;\n    border-bottom: 3px solid #60a31c;\n    transform: translateX(-50%) rotate(45deg);\n  }\n\n  ","\n"]),_templateObject4=_taggedTemplateLiteral(["\n    padding-top: 76px;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 1;\n    :before {\n      width: 24px;\n      height: 48px;\n      border-right: 4px solid #60a31c;\n      border-bottom: 4px solid #60a31c;\n      @media (max-width: 320px) {\n        transform: translateX(-50%) rotate(45deg) scale(0.9);\n      }\n    }\n    @media (max-width: 320px) {\n      font-size: 16px;\n    }\n  "],["\n    padding-top: 76px;\n    font-weight: 400;\n    font-size: 18px;\n    line-height: 1;\n    :before {\n      width: 24px;\n      height: 48px;\n      border-right: 4px solid #60a31c;\n      border-bottom: 4px solid #60a31c;\n      @media (max-width: 320px) {\n        transform: translateX(-50%) rotate(45deg) scale(0.9);\n      }\n    }\n    @media (max-width: 320px) {\n      font-size: 16px;\n    }\n  "]),_templateObject5=_taggedTemplateLiteral(["\n  margin: 20px 0 30px;\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  color: #343434;\n\n  ","\n"],["\n  margin: 20px 0 30px;\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  color: #343434;\n\n  ","\n"]),_templateObject6=_taggedTemplateLiteral(["\n    margin: 10px 0 20px;\n    font-size: 16px;\n    color: ",";\n    @media (max-width: 320px) {\n      font-size: ",";\n    }\n  "],["\n    margin: 10px 0 20px;\n    font-size: 16px;\n    color: ",";\n    @media (max-width: 320px) {\n      font-size: ",";\n    }\n  "]),_templateObject7=_taggedTemplateLiteral(["\n  text-align: center;\n\n  ","\n"],["\n  text-align: center;\n\n  ","\n"]),_templateObject8=_taggedTemplateLiteral(["\n    max-width: 410px;\n    margin: 0 auto;\n    @media(max-width: 479px) {\n      margin-top: 100px;\n    }\n  "],["\n    max-width: 410px;\n    margin: 0 auto;\n    @media(max-width: 479px) {\n      margin-top: 100px;\n    }\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SentContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var SentTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h2(_templateObject3,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var SentSubtitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject5,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(props){return props.theme.mainFontColor;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});});var SentButtonContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);});var OfflineConfirmed=function OfflineConfirmed(_ref2){var desktop=_ref2.desktop,title=_ref2.title,message=_ref2.message,tradeTitle=_ref2.tradeTitle,isIOS2=_ref2.isIOS2;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SentContainer,{mobile:!desktop,style:desktop?{minHeight:576}:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SentTitle,{mobile:!desktop},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SentSubtitle,{mobile:!desktop},message),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SentButtonContainer,{mobile:!desktop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__LinkButton__["a" /* default */],{onClick:function onClick(e){if(isIOS2||Object(__WEBPACK_IMPORTED_MODULE_3__utils__["c" /* isIronTerminal */])()||__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* isIronTerminalIosApp */]){e&&e.preventDefault();Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* iOSAppPostMessage */])("gotoTrade");}},to:"/trade",text:tradeTitle,type:"yellow",bigfckinbutton:desktop,style:{overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:410}})));};/* harmony default export */ __webpack_exports__["a"] = (OfflineConfirmed);

/***/ }),
/* 1576 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAeCAYAAAHVz0eBAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAlNJREFUeNpi/P//PwMQCDIgwHtGqCAMgDiMTFCOAxBzgwRAHHSVYAAQQCBBQRQRoMA0kEoobmfCpgVFACCAYEqRtSHjdhCNbgzIiIlQGsPoc0C8iwET2AOxJcjILf/xgy0AAYTpLyy++A8LGizgPxMOiWvI3v4P9WIxElsCSv9nQdJ1C2rVHyBmQXdDJw6ryrFGGTJgQQ9BdAAQQDAT8BuDHzAiB8V0qEeIxR0wjUx4bPgKxLuR+KJQF4dg8y86AAUpM1JMvgZiESCOxhW7LESIiRIMFGoELMjWFaBcjEVSAYg/IfFlgPgSFnUrAAKIEUuxQAp4T6lXGJEDj5FEzf8JpQ2iABMZttZgK8P+o5VdiljEHgPxTiQ+JBfjMOAfUqnEAsSzoQYwEDJAFMouhvLtkAxiIMYAEF6EpvAIrDjGZgByOiAnGlHSQQdZKYlaKZGR3IQEMuAdDjkhNP47fPUK2QAgwJDL/P8M9AeMuIrIg0C8jIYWBwKxB6FyGlT7zqKhIxTRHcFEQ8v8gPgtEJ8GYglqFm8goAwNUk48agyBeCU0ZZsAsTU1HdEMxHeAeB20gk9Dk2cD4iPQxt4FIGaHJr61+Asa1ELrP5Z2ZyYQX4XKgYrfXCAWA+JUIP4FFd8FxJOg7K9AbIKj7Qprv6KUvIQcwQPEn6Hiv4FYHouh4Uh6/wIxFx4HYHUEoej4AsS80CBlBeKHWNSshMqzQ5tQ32hd7+IDv4ZNicnIMECAiWEQAFBIbAFibxL0HIC243EBDiC2IcG8raA0wQNN+QMFfgMAS5SX1NkIc2QAAAAASUVORK5CYII="

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: table;\n  vertical-align: top;\n  width: 460px;\n  margin-right: 20px;\n  margin-left: 212px;\n  \n  ",";\n  \n  ","\n"],["\n  position: relative;\n  display: table;\n  vertical-align: top;\n  width: 460px;\n  margin-right: 20px;\n  margin-left: 212px;\n  \n  ",";\n  \n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    margin-right: 212px;\n    margin-left: 20px;\n  "],["\n    margin-right: 212px;\n    margin-left: 20px;\n  "]),_templateObject3=_taggedTemplateLiteral(["\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0px;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 100100;\n  "],["\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    display: block;\n    width: 100%;\n    height: 100%;\n    margin: 0px;\n    background-color: rgba(0,0,0,0.5);\n    z-index: 100100;\n  "]),_templateObject4=_taggedTemplateLiteral(["\n  ","\n"],["\n  ","\n"]),_templateObject5=_taggedTemplateLiteral(["\n    position: relative;\n    height: 100%;\n    width: 90%;\n    margin: 0 auto;\n    padding-top: 100px;\n    @media (max-width: 800px) {\n      padding-top: 50px;\n    }\n  "],["\n    position: relative;\n    height: 100%;\n    width: 90%;\n    margin: 0 auto;\n    padding-top: 100px;\n    @media (max-width: 800px) {\n      padding-top: 50px;\n    }\n  "]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-block;\n  max-height: 85%;\n  max-width: 100%;\n  border: none;\n  box-shadow: 0 0 18px 5px rgba(0, 0, 0, 0.15);\n  \n  ","\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-block;\n  max-height: 85%;\n  max-width: 100%;\n  border: none;\n  box-shadow: 0 0 18px 5px rgba(0, 0, 0, 0.15);\n  \n  ","\n"]),_templateObject7=_taggedTemplateLiteral(["\n    top: 153px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    max-height: 75%;\n    @media (max-width: 800px) {\n      top: 103px;\n    }\n    @media (min-width: 415px) and (max-width: 480px) {\n      max-height: 195px;\n      max-width: 260px;\n    }\n    @media (min-width: 481px) and (max-width: 640px) {\n      max-height: 215px;\n    }\n  "],["\n    top: 153px;\n    left: 50%;\n    transform: translate(-50%, 0);\n    max-height: 75%;\n    @media (max-width: 800px) {\n      top: 103px;\n    }\n    @media (min-width: 415px) and (max-width: 480px) {\n      max-height: 195px;\n      max-width: 260px;\n    }\n    @media (min-width: 481px) and (max-width: 640px) {\n      max-height: 215px;\n    }\n  "]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 35px;\n  right: 0px;\n  width: 18px;\n  height: 18px;\n  background-size: cover;\n  cursor: pointer;\n  z-index: 100101;\n  :before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid #fff;\n    transition: all 0.3s ease;\n  }\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid #fff;\n    transition: all 0.3s ease;\n  }\n  :hover {\n    :before {\n      border-left-color: #60a31c;\n    }\n    :after {\n      border-left-color: #60a31c;\n    }\n  }\n  \n  ","\n"],["\n  position: absolute;\n  top: 35px;\n  right: 0px;\n  width: 18px;\n  height: 18px;\n  background-size: cover;\n  cursor: pointer;\n  z-index: 100101;\n  :before {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(45deg);\n    transform-origin: 100%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid #fff;\n    transition: all 0.3s ease;\n  }\n  :after {\n    content: \"\";\n    position: absolute;\n    top: -1px;\n    left: 50%;\n    transform: translateX(-50%) rotate(-45deg);\n    transform-origin: 0%;\n    width: 0px;\n    height: 24px;\n    border-left: 2px solid #fff;\n    transition: all 0.3s ease;\n  }\n  :hover {\n    :before {\n      border-left-color: #60a31c;\n    }\n    :after {\n      border-left-color: #60a31c;\n    }\n  }\n  \n  ","\n"]),_templateObject9=_taggedTemplateLiteral(["\n    top: 115px;\n    @media (max-width: 800px) {\n      top: 65px;\n    }\n  "],["\n    top: 115px;\n    @media (max-width: 800px) {\n      top: 65px;\n    }\n  "]),_templateObject10=_taggedTemplateLiteral(["\n  margin-top: 22px;\n  border-bottom: 0px;\n  :first-of-type {\n    margin-top: 35px;\n  }\n  :nth-of-type(n+2) {\n    padding-bottom: 20px;\n  }\n  @media (max-width: 959px) {\n    margin-top: 0px;\n    border-bottom-color: #f6f6f6;\n    padding-bottom: 10px;\n  }\n  \n  ","\n  \n  ","\n"],["\n  margin-top: 22px;\n  border-bottom: 0px;\n  :first-of-type {\n    margin-top: 35px;\n  }\n  :nth-of-type(n+2) {\n    padding-bottom: 20px;\n  }\n  @media (max-width: 959px) {\n    margin-top: 0px;\n    border-bottom-color: #f6f6f6;\n    padding-bottom: 10px;\n  }\n  \n  ","\n  \n  ","\n"]),_templateObject11=_taggedTemplateLiteral(["\n    margin: 0 auto;\n    margin-top: 15px;\n    :first-of-type {\n      margin-top: 15px;\n    }\n    :nth-of-type(2) {\n      margin-top: 15px;\n      @media (max-width: 959px) {\n        margin-top: 20px;\n      }\n    }\n    @media (max-width: 414px) {\n      max-width: 100%;\n    }\n    @media (max-width: 480px) {\n      max-width: 290px;\n    }\n    @media (max-width: 640px) {\n      max-width: 388px;\n    }\n    @media (max-width: 736px) {\n      max-width: 446px;\n    }\n  "],["\n    margin: 0 auto;\n    margin-top: 15px;\n    :first-of-type {\n      margin-top: 15px;\n    }\n    :nth-of-type(2) {\n      margin-top: 15px;\n      @media (max-width: 959px) {\n        margin-top: 20px;\n      }\n    }\n    @media (max-width: 414px) {\n      max-width: 100%;\n    }\n    @media (max-width: 480px) {\n      max-width: 290px;\n    }\n    @media (max-width: 640px) {\n      max-width: 388px;\n    }\n    @media (max-width: 736px) {\n      max-width: 446px;\n    }\n  "]),_templateObject12=_taggedTemplateLiteral(["\n    :nth-of-type(2n) {\n      padding-bottom: 0px;\n    }\n  "],["\n    :nth-of-type(2n) {\n      padding-bottom: 0px;\n    }\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var FileContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var FileWrapperMobile=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);});var File=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject6,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);});var CloseImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);});var Section=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].section(_templateObject10,function(props){return!props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);},function(props){return props.file&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);});var OfflineFilePreview=function OfflineFilePreview(_ref){var Row=_ref.Row,desktop=_ref.desktop,onClose=_ref.onClose,file=_ref.file;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Section,{desktop:desktop,file:file},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Row,{nowrap:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FileContainer,{desktop:desktop,style:desktop?{height:376}:null// десктоп: такой же высоты, как предыдущая section (которая скрывается)
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FileWrapperMobile,{desktop:desktop},!desktop&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseImage,{desktop:desktop,onClick:onClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(File,{desktop:desktop,src:file||"http://placehold.it/262x361",alt:"preview"})))));};/* harmony default export */ __webpack_exports__["a"] = (OfflineFilePreview);

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_maskedinput__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeSelector_css__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TimeSelector_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__TimeSelector_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons__ = __webpack_require__(147);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ltr !important;\n  display: inline-block;\n  vertical-align: top;\n  width: 100%;\n  min-height: 39px;\n  color: #4e2a81;\n  padding: 0 7px;\n  margin: 0px;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: #4e2a81;\n  background-color: #fff;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);\n  :focus {\n    outline: none;\n  }\n  @media (max-width: 480px) {\n    min-height: 32px;\n    font-size: ",";\n  }\n  \n  ","\n"],["\n  direction: ltr !important;\n  display: inline-block;\n  vertical-align: top;\n  width: 100%;\n  min-height: 39px;\n  color: #4e2a81;\n  padding: 0 7px;\n  margin: 0px;\n  box-sizing: border-box;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: #4e2a81;\n  background-color: #fff;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);\n  :focus {\n    outline: none;\n  }\n  @media (max-width: 480px) {\n    min-height: 32px;\n    font-size: ",";\n  }\n  \n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    border-color: #e85747;\n    color: #e74c3c;\n  "],["\n    border-color: #e85747;\n    color: #e74c3c;\n  "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var InputView=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react_maskedinput__["a" /* default */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.invalid&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var TimeSelector=function(_Component){_inherits(TimeSelector,_Component);function TimeSelector(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,TimeSelector);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=TimeSelector.__proto__||Object.getPrototypeOf(TimeSelector)).call.apply(_ref2,[this].concat(args))),_this),_this.parseString=function(value){var _split=(value||":").split(":"),_split2=_slicedToArray(_split,2),hours=_split2[0],minutes=_split2[1];return{hours:hours,minutes:minutes};},_this.addZero=function(value){if(value===undefined||value==="")return value;var value_=+value;return value_<10?"0"+value_:value_;},_this.getHours=function(){return _this.parseString(_this.props.value).hours;},_this.getMinutes=function(){return _this.parseString(_this.props.value).minutes;},_this.onChange=function(e){_this.props.onChange(e.target.value);},_this.incValue=function(){var _this$parseString=_this.parseString(_this.props.value),hours=_this$parseString.hours,minutes=_this$parseString.minutes;var h=parseInt(hours,10);var m=parseInt(minutes,10);if(m<59){m+=1;}else{m="00";if(h<23){h+=1;}else{h="00";}}h=_this.addZero(h);m=_this.addZero(m);_this.props.onChange(h+":"+m);},_this.decValue=function(){var _this$parseString2=_this.parseString(_this.props.value),hours=_this$parseString2.hours,minutes=_this$parseString2.minutes;var h=parseInt(hours,10);var m=parseInt(minutes,10);if(m>0){m-=1;}else{m="59";if(h>0){h-=1;}else{h="23";}}h=_this.addZero(h);m=_this.addZero(m);_this.props.onChange(h+":"+m);},_temp),_possibleConstructorReturn(_this,_ret);}/**
   * Parse string time into {h, m} object.
   * @param  {String} value String like 'HH:MM'.
   * @return {Object}       Object with h (hours ) and m (minutes) properties.
   *//**
   * Add leading zero to value.
   * @param  {String} value
   * @return {String}
   *//**
   * Extract hours from props value.
   * @return {String}
   *//**
   * Extract minutes from props value.
   * @return {String}
   */_createClass(TimeSelector,[{key:"render",value:function render(){var _props=this.props,value=_props.value,invalid=_props.invalid,onBlur=_props.onBlur,autoComplete=_props.autoComplete;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"TimeSelector"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InputView,{mask:"11:11",name:"time",placeholder:"",onChange:this.onChange,value:value,invalid:invalid,onBlur:onBlur,autoComplete:autoComplete}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons__["h" /* TimeIconUp */],{className:"TimeSelector__icons TimeSelector__icons--up",onClick:this.incValue}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons__["g" /* TimeIconDown */],{className:"TimeSelector__icons TimeSelector__icons--down",onClick:this.decValue}));}}]);return TimeSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TimeSelector);

/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function extend(dest, src) {
  if (src) {
    var props = Object.keys(src)
    for (var i = 0, l = props.length; i < l ; i++) {
      dest[props[i]] = src[props[i]]
    }
  }
  return dest
}

function copy(obj) {
  return extend({}, obj)
}

/**
 * Merge an object defining format characters into the defaults.
 * Passing null/undefined for en existing format character removes it.
 * Passing a definition for an existing format character overrides it.
 * @param {?Object} formatCharacters.
 */
function mergeFormatCharacters(formatCharacters) {
  var merged = copy(DEFAULT_FORMAT_CHARACTERS)
  if (formatCharacters) {
    var chars = Object.keys(formatCharacters)
    for (var i = 0, l = chars.length; i < l ; i++) {
      var char = chars[i]
      if (formatCharacters[char] == null) {
        delete merged[char]
      }
      else {
        merged[char] = formatCharacters[char]
      }
    }
  }
  return merged
}

var ESCAPE_CHAR = '\\'

var DIGIT_RE = /^\d$/
var LETTER_RE = /^[A-Za-z]$/
var ALPHANNUMERIC_RE = /^[\dA-Za-z]$/

var DEFAULT_PLACEHOLDER_CHAR = '_'
var DEFAULT_FORMAT_CHARACTERS = {
  '*': {
    validate: function(char) { return ALPHANNUMERIC_RE.test(char) }
  },
  '1': {
    validate: function(char) { return DIGIT_RE.test(char) }
  },
  'a': {
    validate: function(char) { return LETTER_RE.test(char) }
  },
  'A': {
    validate: function(char) { return LETTER_RE.test(char) },
    transform: function(char) { return char.toUpperCase() }
  },
  '#': {
    validate: function(char) { return ALPHANNUMERIC_RE.test(char) },
    transform: function(char) { return char.toUpperCase() }
  }
}

/**
 * @param {string} source
 * @patam {?Object} formatCharacters
 */
function Pattern(source, formatCharacters, placeholderChar, isRevealingMask) {
  if (!(this instanceof Pattern)) {
    return new Pattern(source, formatCharacters, placeholderChar)
  }

  /** Placeholder character */
  this.placeholderChar = placeholderChar || DEFAULT_PLACEHOLDER_CHAR
  /** Format character definitions. */
  this.formatCharacters = formatCharacters || DEFAULT_FORMAT_CHARACTERS
  /** Pattern definition string with escape characters. */
  this.source = source
  /** Pattern characters after escape characters have been processed. */
  this.pattern = []
  /** Length of the pattern after escape characters have been processed. */
  this.length = 0
  /** Index of the first editable character. */
  this.firstEditableIndex = null
  /** Index of the last editable character. */
  this.lastEditableIndex = null
  /** Lookup for indices of editable characters in the pattern. */
  this._editableIndices = {}
  /** If true, only the pattern before the last valid value character shows. */
  this.isRevealingMask = isRevealingMask || false

  this._parse()
}

Pattern.prototype._parse = function parse() {
  var sourceChars = this.source.split('')
  var patternIndex = 0
  var pattern = []

  for (var i = 0, l = sourceChars.length; i < l; i++) {
    var char = sourceChars[i]
    if (char === ESCAPE_CHAR) {
      if (i === l - 1) {
        throw new Error('InputMask: pattern ends with a raw ' + ESCAPE_CHAR)
      }
      char = sourceChars[++i]
    }
    else if (char in this.formatCharacters) {
      if (this.firstEditableIndex === null) {
        this.firstEditableIndex = patternIndex
      }
      this.lastEditableIndex = patternIndex
      this._editableIndices[patternIndex] = true
    }

    pattern.push(char)
    patternIndex++
  }

  if (this.firstEditableIndex === null) {
    throw new Error(
      'InputMask: pattern "' + this.source + '" does not contain any editable characters.'
    )
  }

  this.pattern = pattern
  this.length = pattern.length
}

/**
 * @param {Array<string>} value
 * @return {Array<string>}
 */
Pattern.prototype.formatValue = function format(value) {
  var valueBuffer = new Array(this.length)
  var valueIndex = 0

  for (var i = 0, l = this.length; i < l ; i++) {
    if (this.isEditableIndex(i)) {
      if (this.isRevealingMask &&
          value.length <= valueIndex &&
          !this.isValidAtIndex(value[valueIndex], i)) {
        break
      }
      valueBuffer[i] = (value.length > valueIndex && this.isValidAtIndex(value[valueIndex], i)
                        ? this.transform(value[valueIndex], i)
                        : this.placeholderChar)
      valueIndex++
    }
    else {
      valueBuffer[i] = this.pattern[i]
      // Also allow the value to contain static values from the pattern by
      // advancing its index.
      if (value.length > valueIndex && value[valueIndex] === this.pattern[i]) {
        valueIndex++
      }
    }
  }

  return valueBuffer
}

/**
 * @param {number} index
 * @return {boolean}
 */
Pattern.prototype.isEditableIndex = function isEditableIndex(index) {
  return !!this._editableIndices[index]
}

/**
 * @param {string} char
 * @param {number} index
 * @return {boolean}
 */
Pattern.prototype.isValidAtIndex = function isValidAtIndex(char, index) {
  return this.formatCharacters[this.pattern[index]].validate(char)
}

Pattern.prototype.transform = function transform(char, index) {
  var format = this.formatCharacters[this.pattern[index]]
  return typeof format.transform == 'function' ? format.transform(char) : char
}

function InputMask(options) {
  if (!(this instanceof InputMask)) { return new InputMask(options) }
  options = extend({
    formatCharacters: null,
    pattern: null,
    isRevealingMask: false,
    placeholderChar: DEFAULT_PLACEHOLDER_CHAR,
    selection: {start: 0, end: 0},
    value: ''
  }, options)

  if (options.pattern == null) {
    throw new Error('InputMask: you must provide a pattern.')
  }

  if (typeof options.placeholderChar !== 'string' || options.placeholderChar.length > 1) {
    throw new Error('InputMask: placeholderChar should be a single character or an empty string.')
  }

  this.placeholderChar = options.placeholderChar
  this.formatCharacters = mergeFormatCharacters(options.formatCharacters)
  this.setPattern(options.pattern, {
    value: options.value,
    selection: options.selection,
    isRevealingMask: options.isRevealingMask
  })
}

// Editing

/**
 * Applies a single character of input based on the current selection.
 * @param {string} char
 * @return {boolean} true if a change has been made to value or selection as a
 *   result of the input, false otherwise.
 */
InputMask.prototype.input = function input(char) {
  // Ignore additional input if the cursor's at the end of the pattern
  if (this.selection.start === this.selection.end &&
      this.selection.start === this.pattern.length) {
    return false
  }

  var selectionBefore = copy(this.selection)
  var valueBefore = this.getValue()

  var inputIndex = this.selection.start

  // If the cursor or selection is prior to the first editable character, make
  // sure any input given is applied to it.
  if (inputIndex < this.pattern.firstEditableIndex) {
    inputIndex = this.pattern.firstEditableIndex
  }

  // Bail out or add the character to input
  if (this.pattern.isEditableIndex(inputIndex)) {
    if (!this.pattern.isValidAtIndex(char, inputIndex)) {
      return false
    }
    this.value[inputIndex] = this.pattern.transform(char, inputIndex)
  }

  // If multiple characters were selected, blank the remainder out based on the
  // pattern.
  var end = this.selection.end - 1
  while (end > inputIndex) {
    if (this.pattern.isEditableIndex(end)) {
      this.value[end] = this.placeholderChar
    }
    end--
  }

  // Advance the cursor to the next character
  this.selection.start = this.selection.end = inputIndex + 1

  // Skip over any subsequent static characters
  while (this.pattern.length > this.selection.start &&
         !this.pattern.isEditableIndex(this.selection.start)) {
    this.selection.start++
    this.selection.end++
  }

  // History
  if (this._historyIndex != null) {
    // Took more input after undoing, so blow any subsequent history away
    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
    this._historyIndex = null
  }
  if (this._lastOp !== 'input' ||
      selectionBefore.start !== selectionBefore.end ||
      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
  }
  this._lastOp = 'input'
  this._lastSelection = copy(this.selection)

  return true
}

/**
 * Attempts to delete from the value based on the current cursor position or
 * selection.
 * @return {boolean} true if the value or selection changed as the result of
 *   backspacing, false otherwise.
 */
InputMask.prototype.backspace = function backspace() {
  // If the cursor is at the start there's nothing to do
  if (this.selection.start === 0 && this.selection.end === 0) {
    return false
  }

  var selectionBefore = copy(this.selection)
  var valueBefore = this.getValue()

  // No range selected - work on the character preceding the cursor
  if (this.selection.start === this.selection.end) {
    if (this.pattern.isEditableIndex(this.selection.start - 1)) {
      this.value[this.selection.start - 1] = this.placeholderChar
    }
    this.selection.start--
    this.selection.end--
  }
  // Range selected - delete characters and leave the cursor at the start of the selection
  else {
    var end = this.selection.end - 1
    while (end >= this.selection.start) {
      if (this.pattern.isEditableIndex(end)) {
        this.value[end] = this.placeholderChar
      }
      end--
    }
    this.selection.end = this.selection.start
  }

  // History
  if (this._historyIndex != null) {
    // Took more input after undoing, so blow any subsequent history away
    this._history.splice(this._historyIndex, this._history.length - this._historyIndex)
  }
  if (this._lastOp !== 'backspace' ||
      selectionBefore.start !== selectionBefore.end ||
      this._lastSelection !== null && selectionBefore.start !== this._lastSelection.start) {
    this._history.push({value: valueBefore, selection: selectionBefore, lastOp: this._lastOp})
  }
  this._lastOp = 'backspace'
  this._lastSelection = copy(this.selection)

  return true
}

/**
 * Attempts to paste a string of input at the current cursor position or over
 * the top of the current selection.
 * Invalid content at any position will cause the paste to be rejected, and it
 * may contain static parts of the mask's pattern.
 * @param {string} input
 * @return {boolean} true if the paste was successful, false otherwise.
 */
InputMask.prototype.paste = function paste(input) {
  // This is necessary because we're just calling input() with each character
  // and rolling back if any were invalid, rather than checking up-front.
  var initialState = {
    value: this.value.slice(),
    selection: copy(this.selection),
    _lastOp: this._lastOp,
    _history: this._history.slice(),
    _historyIndex: this._historyIndex,
    _lastSelection: copy(this._lastSelection)
  }

  // If there are static characters at the start of the pattern and the cursor
  // or selection is within them, the static characters must match for a valid
  // paste.
  if (this.selection.start < this.pattern.firstEditableIndex) {
    for (var i = 0, l = this.pattern.firstEditableIndex - this.selection.start; i < l; i++) {
      if (input.charAt(i) !== this.pattern.pattern[i]) {
        return false
      }
    }

    // Continue as if the selection and input started from the editable part of
    // the pattern.
    input = input.substring(this.pattern.firstEditableIndex - this.selection.start)
    this.selection.start = this.pattern.firstEditableIndex
  }

  for (i = 0, l = input.length;
       i < l && this.selection.start <= this.pattern.lastEditableIndex;
       i++) {
    var valid = this.input(input.charAt(i))
    // Allow static parts of the pattern to appear in pasted input - they will
    // already have been stepped over by input(), so verify that the value
    // deemed invalid by input() was the expected static character.
    if (!valid) {
      if (this.selection.start > 0) {
        // XXX This only allows for one static character to be skipped
        var patternIndex = this.selection.start - 1
        if (!this.pattern.isEditableIndex(patternIndex) &&
            input.charAt(i) === this.pattern.pattern[patternIndex]) {
          continue
        }
      }
      extend(this, initialState)
      return false
    }
  }

  return true
}

// History

InputMask.prototype.undo = function undo() {
  // If there is no history, or nothing more on the history stack, we can't undo
  if (this._history.length === 0 || this._historyIndex === 0) {
    return false
  }

  var historyItem
  if (this._historyIndex == null) {
    // Not currently undoing, set up the initial history index
    this._historyIndex = this._history.length - 1
    historyItem = this._history[this._historyIndex]
    // Add a new history entry if anything has changed since the last one, so we
    // can redo back to the initial state we started undoing from.
    var value = this.getValue()
    if (historyItem.value !== value ||
        historyItem.selection.start !== this.selection.start ||
        historyItem.selection.end !== this.selection.end) {
      this._history.push({value: value, selection: copy(this.selection), lastOp: this._lastOp, startUndo: true})
    }
  }
  else {
    historyItem = this._history[--this._historyIndex]
  }

  this.value = historyItem.value.split('')
  this.selection = historyItem.selection
  this._lastOp = historyItem.lastOp
  return true
}

InputMask.prototype.redo = function redo() {
  if (this._history.length === 0 || this._historyIndex == null) {
    return false
  }
  var historyItem = this._history[++this._historyIndex]
  // If this is the last history item, we're done redoing
  if (this._historyIndex === this._history.length - 1) {
    this._historyIndex = null
    // If the last history item was only added to start undoing, remove it
    if (historyItem.startUndo) {
      this._history.pop()
    }
  }
  this.value = historyItem.value.split('')
  this.selection = historyItem.selection
  this._lastOp = historyItem.lastOp
  return true
}

// Getters & setters

InputMask.prototype.setPattern = function setPattern(pattern, options) {
  options = extend({
    selection: {start: 0, end: 0},
    value: ''
  }, options)
  this.pattern = new Pattern(pattern, this.formatCharacters, this.placeholderChar, options.isRevealingMask)
  this.setValue(options.value)
  this.emptyValue = this.pattern.formatValue([]).join('')
  this.selection = options.selection
  this._resetHistory()
}

InputMask.prototype.setSelection = function setSelection(selection) {
  this.selection = copy(selection)
  if (this.selection.start === this.selection.end) {
    if (this.selection.start < this.pattern.firstEditableIndex) {
      this.selection.start = this.selection.end = this.pattern.firstEditableIndex
      return true
    }
    // Set selection to the first editable, non-placeholder character before the selection
    // OR to the beginning of the pattern
    var index = this.selection.start
    while (index >= this.pattern.firstEditableIndex) {
      if (this.pattern.isEditableIndex(index - 1) &&
          this.value[index - 1] !== this.placeholderChar ||
          index === this.pattern.firstEditableIndex) {
        this.selection.start = this.selection.end = index
        break
      }
      index--
    }
    return true
  }
  return false
}

InputMask.prototype.setValue = function setValue(value) {
  if (value == null) {
    value = ''
  }
  this.value = this.pattern.formatValue(value.split(''))
}

InputMask.prototype.getValue = function getValue() {
  return this.value.join('')
}

InputMask.prototype.getRawValue = function getRawValue() {
  var rawValue = []
  for (var i = 0; i < this.value.length; i++) {
    if (this.pattern._editableIndices[i] === true) {
      rawValue.push(this.value[i])
    }
  }
  return rawValue.join('')
}

InputMask.prototype._resetHistory = function _resetHistory() {
  this._history = []
  this._historyIndex = null
  this._lastOp = null
  this._lastSelection = copy(this.selection)
}

InputMask.Pattern = Pattern

module.exports = InputMask


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ltr !important;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 39px;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: Roboto, Arial, sans-serif;\n  color: #4e2a81;\n  padding-left: 7px;\n  padding-right: 20px;\n  margin: 0px;\n  background-color: #fff;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAYAAAHgVPb9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEtJREFUeNpitHCL/c8ABAABxABiAAQQI5AAsUEijAABxAiTYgHxQAyAAEKWhgFGgACCK4MBJphymAoWGAMmAhBg2MxBBxi6UCyFMQCV2g4T6JPOgQAAAABJRU5ErkJggg==');\n  background-position: 95% 16px;\n  background-size: 9px auto;\n  background-repeat: no-repeat;\n  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);\n  appearance: none;\n  outline: none;\n  :hover,\n  :focus,\n  :focus > option {\n    cursor: pointer;\n  }\n  ::-ms-expand {\n    display: none;\n  }\n  @media (max-width: 959px) {\n    height: 38px;\n    background-position: 97% 16px;\n  }\n  @media (max-width: 480px) {\n    height: 32px;\n    font-size: ",";\n    background-position: 97% 13px;\n  }\n\n  ","\n"],["\n  direction: ltr !important;\n  display: inline-block;\n  box-sizing: border-box;\n  width: 100%;\n  height: 39px;\n  border: 1px solid #cfcfcf;\n  border-radius: 3px;\n  font-weight: 400;\n  font-size: 16px;\n  font-family: Roboto, Arial, sans-serif;\n  color: #4e2a81;\n  padding-left: 7px;\n  padding-right: 20px;\n  margin: 0px;\n  background-color: #fff;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAFCAYAAAHgVPb9AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAEtJREFUeNpitHCL/c8ABAABxABiAAQQI5AAsUEijAABxAiTYgHxQAyAAEKWhgFGgACCK4MBJphymAoWGAMmAhBg2MxBBxi6UCyFMQCV2g4T6JPOgQAAAABJRU5ErkJggg==');\n  background-position: 95% 16px;\n  background-size: 9px auto;\n  background-repeat: no-repeat;\n  box-shadow: inset 0px 2px 0px 0px rgba(227,227,227,1);\n  appearance: none;\n  outline: none;\n  :hover,\n  :focus,\n  :focus > option {\n    cursor: pointer;\n  }\n  ::-ms-expand {\n    display: none;\n  }\n  @media (max-width: 959px) {\n    height: 38px;\n    background-position: 97% 16px;\n  }\n  @media (max-width: 480px) {\n    height: 32px;\n    font-size: ",";\n    background-position: 97% 13px;\n  }\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    background-color: #fff;\n    color: #4e2a81;"],["\n    background-color: #fff;\n    color: #4e2a81;"]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: #797979;\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n\n  ","\n"],["\n  display: inline-block;\n  width: 100%;\n  padding-bottom: 6px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: #797979;\n  @media (max-width: 480px) {\n    font-size: 16px;\n  }\n\n  ","\n"]),_templateObject4=_taggedTemplateLiteral(["\n    display: none;"],["\n    display: none;"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SelectView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].select(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.desktop&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Select=function(_Component){_inherits(Select,_Component);function Select(props){_classCallCheck(this,Select);var _this=_possibleConstructorReturn(this,(Select.__proto__||Object.getPrototypeOf(Select)).call(this,props));_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(Select,[{key:"onChange",value:function onChange(e){this.props.onChange(e.target.value);}},{key:"render",value:function render(){var _props=this.props,children=_props.children,label=_props.label,id=_props.id,value=_props.value,desktop=_props.desktop;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Label,{desktop:desktop,htmlFor:id},label,":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectView,{desktop:desktop,id:id,placeholder:value,defaultValue:value,onChange:this.onChange},children));}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var baseConvert = __webpack_require__(1583),
    util = __webpack_require__(1585);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var mapping = __webpack_require__(1584),
    fallbackHolder = __webpack_require__(669);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var setPlaceholder,
      isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      placeholder = isLib ? func : fallbackHolder,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    if (mapping.placeholder[realName]) {
      setPlaceholder = true;
      result.placeholder = func.placeholder = placeholder;
    }
    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  if (setPlaceholder) {
    _.placeholder = placeholder;
  }
  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),
/* 1584 */
/***/ (function(module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to track methods with placeholder support */
exports.placeholder = {
  'bind': true,
  'bindKey': true,
  'curry': true,
  'curryRight': true,
  'partial': true,
  'partialRight': true
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(1586),
  'assign': __webpack_require__(560),
  'clone': __webpack_require__(1602),
  'curry': __webpack_require__(1603),
  'forEach': __webpack_require__(368),
  'isArray': __webpack_require__(54),
  'isError': __webpack_require__(1604),
  'isFunction': __webpack_require__(357),
  'isWeakMap': __webpack_require__(1605),
  'iteratee': __webpack_require__(1606),
  'keys': __webpack_require__(486),
  'rearg': __webpack_require__(1615),
  'toInteger': __webpack_require__(421),
  'toPath': __webpack_require__(1616)
};


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(417);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var createCtor = __webpack_require__(276),
    root = __webpack_require__(48);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(365),
    createCtor = __webpack_require__(276),
    createHybrid = __webpack_require__(672),
    createRecurry = __webpack_require__(675),
    getHolder = __webpack_require__(680),
    replaceHolders = __webpack_require__(420),
    root = __webpack_require__(48);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),
/* 1589 */
/***/ (function(module, exports) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(418),
    getData = __webpack_require__(676),
    getFuncName = __webpack_require__(1591),
    lodash = __webpack_require__(1593);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var realNames = __webpack_require__(1592);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(418),
    LodashWrapper = __webpack_require__(677),
    baseLodash = __webpack_require__(419),
    isArray = __webpack_require__(54),
    isObjectLike = __webpack_require__(77),
    wrapperClone = __webpack_require__(1594);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(418),
    LodashWrapper = __webpack_require__(677),
    copyArray = __webpack_require__(253);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 1595 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),
/* 1596 */
/***/ (function(module, exports) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(368),
    arrayIncludes = __webpack_require__(546);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

var copyArray = __webpack_require__(253),
    isIndex = __webpack_require__(252);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(365),
    createCtor = __webpack_require__(276),
    root = __webpack_require__(48);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var composeArgs = __webpack_require__(673),
    composeArgsRight = __webpack_require__(674),
    replaceHolders = __webpack_require__(420);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(307);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(366);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(417);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(135),
    isObjectLike = __webpack_require__(77),
    isPlainObject = __webpack_require__(572);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),
/* 1605 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(176),
    isObjectLike = __webpack_require__(77);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),
/* 1606 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(366),
    baseIteratee = __webpack_require__(422);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(1608),
    getMatchData = __webpack_require__(1609),
    matchesStrictComparable = __webpack_require__(682);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(367),
    baseIsEqual = __webpack_require__(415);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(681),
    keys = __webpack_require__(173);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(415),
    get = __webpack_require__(1611),
    hasIn = __webpack_require__(558),
    isKey = __webpack_require__(361),
    isStrictComparable = __webpack_require__(681),
    matchesStrictComparable = __webpack_require__(682),
    toKey = __webpack_require__(136);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(250);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(1613),
    basePropertyDeep = __webpack_require__(1614),
    isKey = __webpack_require__(361),
    toKey = __webpack_require__(136);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 1613 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(250);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var createWrap = __webpack_require__(417),
    flatRest = __webpack_require__(363);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(310),
    copyArray = __webpack_require__(253),
    isArray = __webpack_require__(54),
    isSymbol = __webpack_require__(187),
    stringToPath = __webpack_require__(554),
    toKey = __webpack_require__(136),
    toString = __webpack_require__(555);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/chat-help.89fbd722.svg";

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_popmotion__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_style_value_types__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_pose_core__ = __webpack_require__(1623);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hey_listen__ = __webpack_require__(140);






/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function () {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    return t;
}

var BoundingBoxDimension;
(function (BoundingBoxDimension) {
    BoundingBoxDimension["width"] = "width";
    BoundingBoxDimension["height"] = "height";
    BoundingBoxDimension["left"] = "left";
    BoundingBoxDimension["right"] = "right";
    BoundingBoxDimension["top"] = "top";
    BoundingBoxDimension["bottom"] = "bottom";
})(BoundingBoxDimension || (BoundingBoxDimension = {}));

var measureWithoutTransform = function (element) {
    var transform$$1 = element.style.transform;
    element.style.transform = '';
    var bbox = element.getBoundingClientRect();
    element.style.transform = transform$$1;
    return bbox;
};
var resolveProp = function (target, props) {
    return typeof target === 'function' ? target(props) : target;
};

var interpolate = __WEBPACK_IMPORTED_MODULE_0_popmotion__["l" /* transform */].interpolate;
var singleAxisPointer = function (axis) {
    return function (from) {
        var _a;
        return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["i" /* pointer */])((_a = {}, _a[axis] = typeof from === 'string' ? parseFloat(from) : from, _a)).pipe(function (v) {
            return v[axis];
        });
    };
};
var pointerX = /*#__PURE__*/singleAxisPointer('x');
var pointerY = /*#__PURE__*/singleAxisPointer('y');
var createPointer = function (axisPointerCreator, min, max, measurement) {
    return function (transitionProps) {
        var from = transitionProps.from,
            type = transitionProps.type,
            dimensions = transitionProps.dimensions,
            dragBounds = transitionProps.dragBounds;
        var axisPointer = axisPointerCreator(dimensions.measurementAsPixels(measurement, from, type));
        var transformQueue = [];
        if (dragBounds) {
            var resolvedDragBounds_1 = resolveProp(dragBounds, transitionProps);
            if (resolvedDragBounds_1[min] !== undefined) {
                transformQueue.push(function (v) {
                    return Math.max(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[min], type));
                });
            }
            if (resolvedDragBounds_1[max] !== undefined) {
                transformQueue.push(function (v) {
                    return Math.min(v, dimensions.measurementAsPixels(measurement, resolvedDragBounds_1[max], type));
                });
            }
        }
        if (type === __WEBPACK_IMPORTED_MODULE_2_style_value_types__["h" /* percent */]) {
            transformQueue.push(interpolate([0, dimensions.get(measurement)], [0, 100], { clamp: false }), function (v) {
                return v + '%';
            });
        }
        return transformQueue.length ? axisPointer.pipe.apply(axisPointer, transformQueue) : axisPointer;
    };
};
var just = function (from) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["a" /* action */])(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        update(from);
        complete();
    });
};
var underDampedSpring = function (_a) {
    var from = _a.from,
        velocity = _a.velocity,
        to = _a.to;
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["j" /* spring */])({
        from: from,
        to: to,
        velocity: velocity,
        stiffness: 500,
        damping: 25,
        restDelta: 0.5,
        restSpeed: 10
    });
};
var overDampedSpring = function (_a) {
    var from = _a.from,
        velocity = _a.velocity,
        to = _a.to;
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["j" /* spring */])({ from: from, to: to, velocity: velocity, stiffness: 700, damping: to === 0 ? 100 : 35 });
};
var linearTween = function (_a) {
    var from = _a.from,
        to = _a.to;
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["m" /* tween */])({ from: from, to: to, ease: __WEBPACK_IMPORTED_MODULE_1__popmotion_easing__["linear"] });
};
var intelligentTransition = {
    x: underDampedSpring,
    y: underDampedSpring,
    z: underDampedSpring,
    rotate: underDampedSpring,
    rotateX: underDampedSpring,
    rotateY: underDampedSpring,
    rotateZ: underDampedSpring,
    scaleX: overDampedSpring,
    scaleY: overDampedSpring,
    scale: overDampedSpring,
    opacity: linearTween,
    default: __WEBPACK_IMPORTED_MODULE_0_popmotion__["m" /* tween */]
};
var dragAction = /*#__PURE__*/__assign({}, intelligentTransition, { x: /*#__PURE__*/createPointer(pointerX, 'left', 'right', BoundingBoxDimension.width), y: /*#__PURE__*/createPointer(pointerY, 'top', 'bottom', BoundingBoxDimension.height) });
var justAxis = function (_a) {
    var from = _a.from;
    return just(from);
};
var intelligentDragEnd = /*#__PURE__*/__assign({}, intelligentTransition, { x: justAxis, y: justAxis });
var defaultTransitions = /*#__PURE__*/new Map([['default', intelligentTransition], ['drag', dragAction], ['dragEnd', intelligentDragEnd]]);

var auto = {
    test: function (v) {
        return v === 'auto';
    },
    parse: function (v) {
        return v;
    }
};
var valueTypeTests = [__WEBPACK_IMPORTED_MODULE_2_style_value_types__["g" /* number */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["d" /* degrees */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["h" /* percent */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["i" /* px */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["m" /* vw */], __WEBPACK_IMPORTED_MODULE_2_style_value_types__["l" /* vh */], auto];
var testValueType = function (v) {
    return function (type) {
        return type.test(v);
    };
};
var getValueType = function (v) {
    return valueTypeTests.find(testValueType(v));
};

var createPassiveValue = function (init, parent, transform$$1) {
    var raw = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["n" /* value */])(transform$$1(init));
    parent.raw.subscribe(function (v) {
        return raw.update(transform$$1(v));
    });
    return { raw: raw };
};
var createValue = function (init) {
    var type = getValueType(init);
    var raw = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["n" /* value */])(init);
    return { raw: raw, type: type };
};
var addActionDelay = function (delay$$1, transition) {
    if (delay$$1 === void 0) {
        delay$$1 = 0;
    }
    return Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["b" /* chain */])(Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["d" /* delay */])(delay$$1), transition);
};
var animationLookup = {
    tween: __WEBPACK_IMPORTED_MODULE_0_popmotion__["m" /* tween */],
    spring: __WEBPACK_IMPORTED_MODULE_0_popmotion__["j" /* spring */],
    decay: __WEBPACK_IMPORTED_MODULE_0_popmotion__["c" /* decay */],
    keyframes: __WEBPACK_IMPORTED_MODULE_0_popmotion__["f" /* keyframes */],
    physics: __WEBPACK_IMPORTED_MODULE_0_popmotion__["h" /* physics */]
};
var linear$1 = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].linear,
    easeIn = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].easeIn,
    easeOut = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].easeOut,
    easeInOut = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].easeInOut,
    circIn = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].circIn,
    circOut = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].circOut,
    circInOut = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].circInOut,
    backIn = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].backIn,
    backOut = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].backOut,
    backInOut = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].backInOut,
    anticipate = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].anticipate;
var easingLookup = {
    linear: linear$1,
    easeIn: easeIn,
    easeOut: easeOut,
    easeInOut: easeInOut,
    circIn: circIn,
    circOut: circOut,
    circInOut: circInOut,
    backIn: backIn,
    backOut: backOut,
    backInOut: backInOut,
    anticipate: anticipate
};
var getAction = function (v, _a, _b) {
    var from = _b.from,
        to = _b.to,
        velocity = _b.velocity;
    var _c = _a.type,
        type = _c === void 0 ? 'tween' : _c,
        ease = _a.ease,
        def = __rest(_a, ["type", "ease"]);
    Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(animationLookup[type] !== undefined, "Invalid transition type '" + type + "'. Valid transition types are: tween, spring, decay, physics and keyframes.");
    if (type === 'tween') {
        var typeOfEase = typeof ease;
        if (typeOfEase !== 'function') {
            if (typeOfEase === 'string') {
                Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(easingLookup[ease] !== undefined, "Invalid easing type '" + ease + "'. popmotion.io/pose/api/config");
                ease = easingLookup[ease];
            } else if (Array.isArray(ease)) {
                Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(ease.length === 4, "Cubic bezier arrays must contain four numerical values.");
                var x1 = ease[0],
                    y1 = ease[1],
                    x2 = ease[2],
                    y2 = ease[3];
                ease = __WEBPACK_IMPORTED_MODULE_0_popmotion__["e" /* easing */].cubicBezier(x1, y1, x2, y2);
            }
        }
    }
    var baseProps = type !== 'keyframes' ? {
        from: from,
        to: to,
        velocity: velocity,
        ease: ease
    } : { ease: ease };
    return animationLookup[type](__assign({}, baseProps, def));
};
var isAction = function (action$$1) {
    return typeof action$$1.start !== 'undefined';
};
var pose = function (_a) {
    var transformPose = _a.transformPose,
        addListenerToValue = _a.addListenerToValue,
        extendAPI = _a.extendAPI,
        readValueFromSource = _a.readValueFromSource,
        posePriority = _a.posePriority,
        setValueNative = _a.setValueNative;
    return Object(__WEBPACK_IMPORTED_MODULE_3_pose_core__["a" /* default */])({
        bindOnChange: function (values, onChange) {
            return function (key) {
                if (!values.has(key)) return;
                var raw = values.get(key).raw;
                raw.subscribe(onChange[key]);
            };
        },
        readValue: function (_a) {
            var raw = _a.raw;
            return raw.get();
        },
        setValue: function (_a, to) {
            var raw = _a.raw;
            return raw.update(to);
        },
        createValue: function (init, key, _a, _b) {
            var elementStyler = _a.elementStyler;
            var _c = _b === void 0 ? {} : _b,
                passiveParent = _c.passiveParent,
                passiveProps = _c.passiveProps;
            var val = passiveParent ? createPassiveValue(init, passiveParent, passiveProps) : createValue(init);
            if (addListenerToValue) {
                val.raw.subscribe(addListenerToValue(key, elementStyler));
            }
            return val;
        },
        convertValue: function (raw, key, _a) {
            var elementStyler = _a.elementStyler;
            if (addListenerToValue) {
                raw.subscribe(addListenerToValue(key, elementStyler));
            }
            return {
                raw: raw,
                type: getValueType(raw.get())
            };
        },
        getTransitionProps: function (_a, to) {
            var raw = _a.raw,
                type = _a.type;
            return {
                from: raw.get(),
                velocity: raw.getVelocity(),
                to: to,
                type: type
            };
        },
        resolveTarget: function (_, to) {
            return to;
        },
        selectValueToRead: function (_a) {
            var raw = _a.raw;
            return raw;
        },
        startAction: function (_a, action$$1, complete) {
            var raw = _a.raw;
            var reaction = {
                update: function (v) {
                    return raw.update(v);
                },
                complete: complete
            };
            return action$$1.start(reaction);
        },
        stopAction: function (action$$1) {
            return action$$1.stop();
        },
        getInstantTransition: function (_, _a) {
            var to = _a.to;
            return just(to);
        },
        convertTransitionDefinition: function (val, def, props) {
            if (isAction(def)) return def;
            var delay$$1 = def.delay,
                min = def.min,
                max = def.max,
                round = def.round,
                remainingDef = __rest(def, ["delay", "min", "max", "round"]);
            var action$$1 = getAction(val, remainingDef, props);
            var outputPipe = [];
            if (delay$$1) action$$1 = addActionDelay(delay$$1, action$$1);
            if (min !== undefined) outputPipe.push(function (v) {
                return Math.max(v, min);
            });
            if (max !== undefined) outputPipe.push(function (v) {
                return Math.min(v, max);
            });
            if (round) outputPipe.push(Math.round);
            return outputPipe.length ? action$$1.pipe.apply(action$$1, outputPipe) : action$$1;
        },
        setValueNative: setValueNative,
        addActionDelay: addActionDelay,
        defaultTransitions: defaultTransitions,
        transformPose: transformPose,
        readValueFromSource: readValueFromSource,
        posePriority: posePriority,
        extendAPI: extendAPI
    });
};

var createDimensions = function (element) {
    var hasMeasured = false;
    var current = {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
    };
    return {
        get: function (measurement) {
            return measurement ? current[measurement] : current;
        },
        measure: function () {
            current = element.getBoundingClientRect();
            hasMeasured = true;
            return current;
        },
        measurementAsPixels: function (measurement, value$$1, type) {
            return type === __WEBPACK_IMPORTED_MODULE_2_style_value_types__["h" /* percent */] ? (typeof value$$1 === 'string' ? parseFloat(value$$1) : value$$1) / 100 * current[measurement] : value$$1;
        },
        has: function () {
            return hasMeasured;
        }
    };
};

var makeUIEventApplicator = function (_a) {
    var startEvents = _a.startEvents,
        endEvents = _a.endEvents,
        startPose = _a.startPose,
        endPose = _a.endPose,
        startCallback = _a.startCallback,
        endCallback = _a.endCallback,
        useDocumentToEnd = _a.useDocumentToEnd,
        preventScroll = _a.preventScroll;
    return function (element, activeActions, poser, config) {
        var startListener = startPose + 'Start';
        var endListener = startPose + 'End';
        var moveListener = startPose + 'Move';
        var eventStartListener = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["g" /* listen */])(element, startEvents).start(function (startEvent) {
            if (preventScroll) {
                var touchMoveListener = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["g" /* listen */])(element, 'touchmove', {
                    passive: false
                }).start(function (e) {
                    e.preventDefault();
                });
                activeActions.set(moveListener, touchMoveListener);
            }
            poser.set(startPose);
            if (startCallback && config[startCallback]) config[startCallback](startEvent);
            var eventEndListener = Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["g" /* listen */])(useDocumentToEnd ? document.documentElement : element, endEvents + (useDocumentToEnd ? ' mouseenter' : '')).start(function (endEvent) {
                if (useDocumentToEnd && endEvent.type === 'mouseenter' && endEvent.buttons === 1) {
                    return;
                }
                if (preventScroll) activeActions.get(moveListener).stop();
                activeActions.get(endListener).stop();
                poser.unset(startPose);
                poser.set(endPose);
                if (endCallback && config[endCallback]) config[endCallback](endEvent);
            });
            activeActions.set(endListener, eventEndListener);
        });
        activeActions.set(startListener, eventStartListener);
    };
};
var events = {
    draggable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mousedown touchstart',
        endEvents: 'mouseup touchend',
        startPose: 'drag',
        endPose: 'dragEnd',
        startCallback: 'onDragStart',
        endCallback: 'onDragEnd',
        useDocumentToEnd: true,
        preventScroll: true
    }),
    hoverable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mouseenter',
        endEvents: 'mouseleave',
        startPose: 'hover',
        endPose: 'hoverEnd'
    }),
    focusable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'focus',
        endEvents: 'blur',
        startPose: 'focus',
        endPose: 'blur'
    }),
    pressable: /*#__PURE__*/makeUIEventApplicator({
        startEvents: 'mousedown touchstart',
        endEvents: 'mouseup touchend',
        startPose: 'press',
        endPose: 'pressEnd',
        startCallback: 'onPressStart',
        endCallback: 'onPressEnd',
        useDocumentToEnd: true
    })
};
var eventKeys = /*#__PURE__*/Object.keys(events);
var appendEventListeners = function (element, activeActions, poser, _a) {
    var props = _a.props;
    return eventKeys.forEach(function (key) {
        if (props[key]) events[key](element, activeActions, poser, props);
    });
};

var ORIGIN_START = 0;
var ORIGIN_CENTER = '50%';
var ORIGIN_END = '100%';
var findCenter = function (_a) {
    var top = _a.top,
        right = _a.right,
        bottom = _a.bottom,
        left = _a.left;
    return {
        x: (left + right) / 2,
        y: (top + bottom) / 2
    };
};
var positionalProps = ['width', 'height', 'top', 'left', 'bottom', 'right'];
var positionalPropsDict = /*#__PURE__*/new Set(positionalProps);
var checkPositionalProp = function (key) {
    return positionalPropsDict.has(key);
};
var hasPositionalProps = function (pose) {
    return Object.keys(pose).some(checkPositionalProp);
};
var isFlipPose = function (flip, key, state) {
    return state.props.element instanceof HTMLElement && (flip === true || key === 'flip');
};
var setValue = function (_a, key, to) {
    var values = _a.values,
        props = _a.props;
    if (values.has(key)) {
        var raw = values.get(key).raw;
        raw.update(to);
        raw.update(to);
    } else {
        values.set(key, {
            raw: Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["n" /* value */])(to, function (v) {
                return props.elementStyler.set(key, v);
            })
        });
    }
};
var explicitlyFlipPose = function (state, nextPose) {
    var _a = state.props,
        dimensions = _a.dimensions,
        elementStyler = _a.elementStyler;
    dimensions.measure();
    var width = nextPose.width,
        height = nextPose.height,
        top = nextPose.top,
        left = nextPose.left,
        bottom = nextPose.bottom,
        right = nextPose.right,
        position = nextPose.position,
        remainingPose = __rest(nextPose, ["width", "height", "top", "left", "bottom", "right", "position"]);
    var propsToSet = positionalProps.concat('position').reduce(function (acc, key) {
        if (nextPose[key] !== undefined) {
            acc[key] = resolveProp(nextPose[key], state.props);
        }
        return acc;
    }, {});
    elementStyler.set(propsToSet).render();
    return implicitlyFlipPose(state, remainingPose);
};
var implicitlyFlipPose = function (state, nextPose) {
    var _a = state.props,
        dimensions = _a.dimensions,
        element = _a.element,
        elementStyler = _a.elementStyler;
    if (!dimensions.has()) return {};
    var prev = dimensions.get();
    var next = measureWithoutTransform(element);
    var originX = prev.left === next.left ? ORIGIN_START : prev.right === next.right ? ORIGIN_END : ORIGIN_CENTER;
    var originY = prev.top === next.top ? ORIGIN_START : prev.bottom === next.bottom ? ORIGIN_END : ORIGIN_CENTER;
    elementStyler.set({ originX: originX, originY: originY });
    if (prev.width !== next.width) {
        setValue(state, 'scaleX', prev.width / next.width);
        nextPose.scaleX = 1;
    }
    if (prev.height !== next.height) {
        setValue(state, 'scaleY', prev.height / next.height);
        nextPose.scaleY = 1;
    }
    var prevCenter = findCenter(prev);
    var nextCenter = findCenter(next);
    if (originX === ORIGIN_CENTER) {
        setValue(state, 'x', prevCenter.x - nextCenter.x);
        nextPose.x = 0;
    }
    if (originY === ORIGIN_CENTER) {
        setValue(state, 'y', prevCenter.y - nextCenter.y);
        nextPose.y = 0;
    }
    elementStyler.render();
    return nextPose;
};
var flipPose = function (props, nextPose) {
    return hasPositionalProps(nextPose) ? explicitlyFlipPose(props, nextPose) : implicitlyFlipPose(props, nextPose);
};

var getPosFromMatrix = function (matrix, pos) {
    return parseFloat(matrix.split(', ')[pos]);
};
var getTranslateFromMatrix = function (pos2, pos3) {
    return function (element, bbox, _a) {
        var transform$$1 = _a.transform;
        if (transform$$1 === 'none') return 0;
        var matrix3d = transform$$1.match(/^matrix3d\((.+)\)$/);
        if (matrix3d) return getPosFromMatrix(matrix3d[1], pos3);
        return getPosFromMatrix(transform$$1.match(/^matrix\((.+)\)$/)[1], pos2);
    };
};
var positionalValues = {
    width: function (element, _a) {
        var width = _a.width;
        return width;
    },
    height: function (element, _a) {
        var height = _a.height;
        return height;
    },
    top: function (element, bbox, _a) {
        var top = _a.top;
        return parseFloat(top);
    },
    left: function (element, bbox, _a) {
        var left = _a.left;
        return parseFloat(left);
    },
    bottom: function (element, _a, _b) {
        var height = _a.height;
        var top = _b.top;
        return parseFloat(top) + height;
    },
    right: function (element, _a, _b) {
        var width = _a.width;
        var left = _b.left;
        return parseFloat(left) + width;
    },
    x: /*#__PURE__*/getTranslateFromMatrix(4, 13),
    y: /*#__PURE__*/getTranslateFromMatrix(5, 14)
};
var isPositionalKey = function (v) {
    return positionalValues[v] !== undefined;
};
var isPositional = function (pose) {
    return Object.keys(pose).some(isPositionalKey);
};
var convertPositionalUnits = function (state, nextPose) {
    var values = state.values,
        props = state.props;
    var element = props.element,
        elementStyler = props.elementStyler;
    var positionalPoseKeys = Object.keys(nextPose).filter(isPositionalKey);
    var changedPositionalKeys = [];
    var elementComputedStyle = getComputedStyle(element);
    var applyAtEndHasBeenCopied = false;
    positionalPoseKeys.forEach(function (key) {
        var value$$1 = values.get(key);
        var fromValueType = getValueType(value$$1.raw.get());
        var to = resolveProp(nextPose[key], props);
        var toValueType = getValueType(to);
        if (fromValueType !== toValueType) {
            changedPositionalKeys.push(key);
            if (!applyAtEndHasBeenCopied) {
                applyAtEndHasBeenCopied = true;
                nextPose.applyAtEnd = nextPose.applyAtEnd ? __assign({}, nextPose.applyAtEnd) : {};
            }
            nextPose.applyAtEnd[key] = nextPose.applyAtEnd[key] || nextPose[key];
            setValue(state, key, to);
        }
    });
    if (!changedPositionalKeys.length) return nextPose;
    var originBbox = element.getBoundingClientRect();
    var top = elementComputedStyle.top,
        left = elementComputedStyle.left,
        bottom = elementComputedStyle.bottom,
        right = elementComputedStyle.right,
        transform$$1 = elementComputedStyle.transform;
    var originComputedStyle = { top: top, left: left, bottom: bottom, right: right, transform: transform$$1 };
    elementStyler.render();
    var targetBbox = element.getBoundingClientRect();
    changedPositionalKeys.forEach(function (key) {
        setValue(state, key, positionalValues[key](element, originBbox, originComputedStyle));
        nextPose[key] = positionalValues[key](element, targetBbox, elementComputedStyle);
    });
    elementStyler.render();
    return nextPose;
};

var dragPoses = function (draggable) {
    var drag = {
        preTransition: function (_a) {
            var dimensions = _a.dimensions;
            return dimensions.measure();
        }
    };
    var dragEnd = {};
    if (draggable === true || draggable === 'x') drag.x = dragEnd.x = 0;
    if (draggable === true || draggable === 'y') drag.y = dragEnd.y = 0;
    return { drag: drag, dragEnd: dragEnd };
};
var createPoseConfig = function (element, _a) {
    var onDragStart = _a.onDragStart,
        onDragEnd = _a.onDragEnd,
        onPressStart = _a.onPressStart,
        onPressEnd = _a.onPressEnd,
        draggable = _a.draggable,
        hoverable = _a.hoverable,
        focusable = _a.focusable,
        pressable = _a.pressable,
        dragBounds = _a.dragBounds,
        config = __rest(_a, ["onDragStart", "onDragEnd", "onPressStart", "onPressEnd", "draggable", "hoverable", "focusable", "pressable", "dragBounds"]);
    var poseConfig = __assign({ flip: {} }, config, { props: __assign({}, config.props, { onDragStart: onDragStart,
            onDragEnd: onDragEnd,
            onPressStart: onPressStart,
            onPressEnd: onPressEnd,
            dragBounds: dragBounds,
            draggable: draggable,
            hoverable: hoverable,
            focusable: focusable,
            pressable: pressable,
            element: element, elementStyler: Object(__WEBPACK_IMPORTED_MODULE_0_popmotion__["k" /* styler */])(element, { preparseOutput: false }), dimensions: createDimensions(element) }) });
    if (draggable) {
        var _b = dragPoses(draggable),
            drag = _b.drag,
            dragEnd = _b.dragEnd;
        poseConfig.drag = __assign({}, poseConfig.drag, drag);
        poseConfig.dragEnd = __assign({}, poseConfig.dragEnd, dragEnd);
    }
    return poseConfig;
};
var domPose = /*#__PURE__*/pose({
    posePriority: ['drag', 'press', 'focus', 'hover'],
    transformPose: function (_a, name, state) {
        var flip = _a.flip,
            pose$$1 = __rest(_a, ["flip"]);
        if (isFlipPose(flip, name, state)) {
            return flipPose(state, pose$$1);
        } else if (isPositional(pose$$1)) {
            return convertPositionalUnits(state, pose$$1);
        }
        return pose$$1;
    },
    addListenerToValue: function (key, elementStyler) {
        return function (v) {
            return elementStyler.set(key, v);
        };
    },
    readValueFromSource: function (key, _a) {
        var elementStyler = _a.elementStyler,
            dragBounds = _a.dragBounds;
        var value$$1 = elementStyler.get(key);
        if (dragBounds && (key === 'x' || key === 'y')) {
            var bound = key === 'x' ? dragBounds.left || dragBounds.right : dragBounds.top || dragBounds.bottom;
            if (bound) {
                var boundType = getValueType(bound);
                value$$1 = boundType.transform(value$$1);
            }
        }
        return isNaN(value$$1) ? value$$1 : parseFloat(value$$1);
    },
    setValueNative: function (key, to, _a) {
        var elementStyler = _a.elementStyler;
        return elementStyler.set(key, to);
    },
    extendAPI: function (api, _a, config) {
        var props = _a.props,
            activeActions = _a.activeActions;
        var measure = props.dimensions.measure;
        var poserApi = __assign({}, api, { addChild: function (element, childConfig) {
                return api._addChild(createPoseConfig(element, childConfig), domPose);
            }, measure: measure, flip: function (op) {
                if (op) {
                    measure();
                    op();
                }
                return api.set('flip');
            } });
        props.elementStyler.render();
        appendEventListeners(props.element, activeActions, poserApi, config);
        return poserApi;
    }
});
var domPose$1 = function (element, config) {
    return domPose(createPoseConfig(element, config));
};

/* harmony default export */ __webpack_exports__["a"] = (domPose$1);


/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return action; });
/* unused harmony export multicast */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return value; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return vectorDecay; });
/* unused harmony export inertia */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return keyframes; });
/* unused harmony export everyFrame */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return vectorPhysics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return vectorSpring; });
/* unused harmony export timeline */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return tween; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return listen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return index$1; });
/* unused harmony export mouse */
/* unused harmony export multitouch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return chain; });
/* unused harmony export composite */
/* unused harmony export crossfade */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return delay; });
/* unused harmony export merge */
/* unused harmony export parallel */
/* unused harmony export schedule */
/* unused harmony export stagger */
/* unused harmony export calc */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return transformers; });
/* unused harmony export css */
/* unused harmony export svg */
/* unused harmony export Action */
/* unused harmony export ValueReaction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_framesync__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_style_value_types__ = __webpack_require__(205);
/* unused harmony reexport valueTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hey_listen__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__ = __webpack_require__(206);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_stylefire__ = __webpack_require__(683);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_6_stylefire__["a"]; });













var Chainable = /*#__PURE__*/function () {
    function Chainable(props) {
        if (props === void 0) {
            props = {};
        }
        this.props = props;
    }
    Chainable.prototype.applyMiddleware = function (middleware) {
        return this.create(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, this.props, { middleware: this.props.middleware ? [middleware].concat(this.props.middleware) : [middleware] }));
    };
    Chainable.prototype.pipe = function () {
        var funcs = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            funcs[_i] = arguments[_i];
        }
        var pipedUpdate = funcs.length === 1 ? funcs[0] : __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["m" /* pipe */].apply(void 0, funcs);
        return this.applyMiddleware(function (update) {
            return function (v) {
                return update(pipedUpdate(v));
            };
        });
    };
    Chainable.prototype.while = function (predicate) {
        return this.applyMiddleware(function (update, complete) {
            return function (v) {
                return predicate(v) ? update(v) : complete();
            };
        });
    };
    Chainable.prototype.filter = function (predicate) {
        return this.applyMiddleware(function (update) {
            return function (v) {
                return predicate(v) && update(v);
            };
        });
    };
    return Chainable;
}();

var Observer = /*#__PURE__*/function () {
    function Observer(_a, observer) {
        var middleware = _a.middleware,
            onComplete = _a.onComplete;
        var _this = this;
        this.isActive = true;
        this.update = function (v) {
            if (_this.observer.update) _this.updateObserver(v);
        };
        this.complete = function () {
            if (_this.observer.complete && _this.isActive) _this.observer.complete();
            if (_this.onComplete) _this.onComplete();
            _this.isActive = false;
        };
        this.error = function (err) {
            if (_this.observer.error && _this.isActive) _this.observer.error(err);
            _this.isActive = false;
        };
        this.observer = observer;
        this.updateObserver = function (v) {
            return observer.update(v);
        };
        this.onComplete = onComplete;
        if (observer.update && middleware && middleware.length) {
            middleware.forEach(function (m) {
                return _this.updateObserver = m(_this.updateObserver, _this.complete);
            });
        }
    }
    return Observer;
}();
var createObserver = function (observerCandidate, _a, onComplete) {
    var middleware = _a.middleware;
    if (typeof observerCandidate === 'function') {
        return new Observer({ middleware: middleware, onComplete: onComplete }, { update: observerCandidate });
    } else {
        return new Observer({ middleware: middleware, onComplete: onComplete }, observerCandidate);
    }
};

var Action = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Action, _super);
    function Action() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Action.prototype.create = function (props) {
        return new Action(props);
    };
    Action.prototype.start = function (observerCandidate) {
        if (observerCandidate === void 0) {
            observerCandidate = {};
        }
        var isComplete = false;
        var subscription = {
            stop: function () {
                return undefined;
            }
        };
        var _a = this.props,
            init = _a.init,
            observerProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["init"]);
        var observer = createObserver(observerCandidate, observerProps, function () {
            isComplete = true;
            subscription.stop();
        });
        var api = init(observer);
        subscription = api ? Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, subscription, api) : subscription;
        if (observerCandidate.registerParent) {
            observerCandidate.registerParent(subscription);
        }
        if (isComplete) subscription.stop();
        return subscription;
    };
    return Action;
}(Chainable);
var action = function (init) {
    return new Action({ init: init });
};

var BaseMulticast = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(BaseMulticast, _super);
    function BaseMulticast() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subscribers = [];
        return _this;
    }
    BaseMulticast.prototype.complete = function () {
        this.subscribers.forEach(function (subscriber) {
            return subscriber.complete();
        });
    };
    BaseMulticast.prototype.error = function (err) {
        this.subscribers.forEach(function (subscriber) {
            return subscriber.error(err);
        });
    };
    BaseMulticast.prototype.update = function (v) {
        for (var i = 0; i < this.subscribers.length; i++) {
            this.subscribers[i].update(v);
        }
    };
    BaseMulticast.prototype.subscribe = function (observerCandidate) {
        var _this = this;
        var observer = createObserver(observerCandidate, this.props);
        this.subscribers.push(observer);
        var subscription = {
            unsubscribe: function () {
                var index = _this.subscribers.indexOf(observer);
                if (index !== -1) _this.subscribers.splice(index, 1);
            }
        };
        return subscription;
    };
    BaseMulticast.prototype.stop = function () {
        if (this.parent) this.parent.stop();
    };
    BaseMulticast.prototype.registerParent = function (subscription) {
        this.stop();
        this.parent = subscription;
    };
    return BaseMulticast;
}(Chainable);

var Multicast = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(Multicast, _super);
    function Multicast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Multicast.prototype.create = function (props) {
        return new Multicast(props);
    };
    return Multicast;
}(BaseMulticast);
var multicast = function () {
    return new Multicast();
};

var stepProgress = function (steps, progress$$1) {
    var segment = 1 / (steps - 1);
    var subsegment = 1 / (2 * (steps - 1));
    var percentProgressOfTarget = Math.min(progress$$1, 1);
    var subsegmentProgressOfTarget = percentProgressOfTarget / subsegment;
    var segmentProgressOfTarget = Math.floor((subsegmentProgressOfTarget + 1) / 2);
    return segmentProgressOfTarget * segment;
};

var calc = /*#__PURE__*/Object.freeze({
    angle: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["a" /* angle */],
    degreesToRadians: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["e" /* degreesToRadians */],
    distance: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["f" /* distance */],
    isPoint3D: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["i" /* isPoint3D */],
    isPoint: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["h" /* isPoint */],
    dilate: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */],
    getValueFromProgress: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */],
    pointFromAngleAndDistance: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["n" /* pointFromVector */],
    getProgressFromValue: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["o" /* progress */],
    radiansToDegrees: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["p" /* radiansToDegrees */],
    smooth: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["r" /* smoothFrame */],
    speedPerFrame: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["w" /* velocityPerFrame */],
    speedPerSecond: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerSecond */],
    stepProgress: stepProgress
});

var isValueList = function (v) {
    return Array.isArray(v);
};
var isSingleValue = function (v) {
    var typeOfV = typeof v;
    return typeOfV === 'string' || typeOfV === 'number';
};
var ValueReaction = /*#__PURE__*/function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ValueReaction, _super);
    function ValueReaction(props) {
        var _this = _super.call(this, props) || this;
        _this.scheduleVelocityCheck = function () {
            return __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].postRender(_this.velocityCheck);
        };
        _this.velocityCheck = function (_a) {
            var timestamp = _a.timestamp;
            if (timestamp !== _this.lastUpdated) {
                _this.prev = _this.current;
            }
        };
        _this.prev = _this.current = props.value || 0;
        if (isSingleValue(_this.current)) {
            _this.updateCurrent = function (v) {
                return _this.current = v;
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getSingleVelocity(_this.current, _this.prev);
            };
        } else if (isValueList(_this.current)) {
            _this.updateCurrent = function (v) {
                return _this.current = v.slice();
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getListVelocity();
            };
        } else {
            _this.updateCurrent = function (v) {
                _this.current = {};
                for (var key in v) {
                    if (v.hasOwnProperty(key)) {
                        _this.current[key] = v[key];
                    }
                }
            };
            _this.getVelocityOfCurrent = function () {
                return _this.getMapVelocity();
            };
        }
        if (props.initialSubscription) _this.subscribe(props.initialSubscription);
        return _this;
    }
    ValueReaction.prototype.create = function (props) {
        return new ValueReaction(props);
    };
    ValueReaction.prototype.get = function () {
        return this.current;
    };
    ValueReaction.prototype.getVelocity = function () {
        return this.getVelocityOfCurrent();
    };
    ValueReaction.prototype.update = function (v) {
        _super.prototype.update.call(this, v);
        this.prev = this.current;
        this.updateCurrent(v);
        var _a = Object(__WEBPACK_IMPORTED_MODULE_2_framesync__["c" /* getFrameData */])(),
            delta = _a.delta,
            timestamp = _a.timestamp;
        this.timeDelta = delta;
        this.lastUpdated = timestamp;
        __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].postRender(this.scheduleVelocityCheck);
    };
    ValueReaction.prototype.subscribe = function (observerCandidate) {
        var sub = _super.prototype.subscribe.call(this, observerCandidate);
        this.subscribers[this.subscribers.length - 1].update(this.current);
        return sub;
    };
    ValueReaction.prototype.getSingleVelocity = function (current, prev) {
        return typeof current === 'number' && typeof prev === 'number' ? Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerSecond */])(current - prev, this.timeDelta) : Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerSecond */])(parseFloat(current) - parseFloat(prev), this.timeDelta) || 0;
    };
    ValueReaction.prototype.getListVelocity = function () {
        var _this = this;
        return this.current.map(function (c, i) {
            return _this.getSingleVelocity(c, _this.prev[i]);
        });
    };
    ValueReaction.prototype.getMapVelocity = function () {
        var velocity = {};
        for (var key in this.current) {
            if (this.current.hasOwnProperty(key)) {
                velocity[key] = this.getSingleVelocity(this.current[key], this.prev[key]);
            }
        }
        return velocity;
    };
    return ValueReaction;
}(BaseMulticast);
var value = function (value, initialSubscription) {
    return new ValueReaction({ value: value, initialSubscription: initialSubscription });
};

var multi = function (_a) {
    var getCount = _a.getCount,
        getFirst = _a.getFirst,
        getOutput = _a.getOutput,
        mapApi = _a.mapApi,
        setProp = _a.setProp,
        startActions = _a.startActions;
    return function (actions) {
        return action(function (_a) {
            var update = _a.update,
                complete = _a.complete,
                error = _a.error;
            var numActions = getCount(actions);
            var output = getOutput();
            var updateOutput = function () {
                return update(output);
            };
            var numCompletedActions = 0;
            var subs = startActions(actions, function (a, name) {
                var hasCompleted = false;
                return a.start({
                    complete: function () {
                        if (!hasCompleted) {
                            hasCompleted = true;
                            numCompletedActions++;
                            if (numCompletedActions === numActions) __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(complete);
                        }
                    },
                    error: error,
                    update: function (v) {
                        setProp(output, name, v);
                        __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updateOutput, false, true);
                    }
                });
            });
            return Object.keys(getFirst(subs)).reduce(function (api, methodName) {
                api[methodName] = mapApi(subs, methodName);
                return api;
            }, {});
        });
    };
};

var composite = /*#__PURE__*/multi({
    getOutput: function () {
        return {};
    },
    getCount: function (subs) {
        return Object.keys(subs).length;
    },
    getFirst: function (subs) {
        return subs[Object.keys(subs)[0]];
    },
    mapApi: function (subs, methodName) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return Object.keys(subs).reduce(function (output, propKey) {
                var _a;
                if (subs[propKey][methodName]) {
                    args[0] && args[0][propKey] !== undefined ? output[propKey] = subs[propKey][methodName](args[0][propKey]) : output[propKey] = (_a = subs[propKey])[methodName].apply(_a, args);
                }
                return output;
            }, {});
        };
    },
    setProp: function (output, name, v) {
        return output[name] = v;
    },
    startActions: function (actions, starter) {
        return Object.keys(actions).reduce(function (subs, key) {
            subs[key] = starter(actions[key], key);
            return subs;
        }, {});
    }
});

var parallel = /*#__PURE__*/multi({
    getOutput: function () {
        return [];
    },
    getCount: function (subs) {
        return subs.length;
    },
    getFirst: function (subs) {
        return subs[0];
    },
    mapApi: function (subs, methodName) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return subs.map(function (sub, i) {
                if (sub[methodName]) {
                    return Array.isArray(args[0]) ? sub[methodName](args[0][i]) : sub[methodName].apply(sub, args);
                }
            });
        };
    },
    setProp: function (output, name, v) {
        return output[name] = v;
    },
    startActions: function (actions, starter) {
        return actions.map(function (action, i) {
            return starter(action, i);
        });
    }
});
var parallel$1 = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return parallel(actions);
};

var createVectorTests = function (typeTests) {
    var testNames = Object.keys(typeTests);
    var isVectorProp = function (prop, key) {
        return prop !== undefined && !typeTests[key](prop);
    };
    var getVectorKeys = function (props) {
        return testNames.reduce(function (vectorKeys, key) {
            if (isVectorProp(props[key], key)) vectorKeys.push(key);
            return vectorKeys;
        }, []);
    };
    var testVectorProps = function (props) {
        return props && testNames.some(function (key) {
            return isVectorProp(props[key], key);
        });
    };
    return { getVectorKeys: getVectorKeys, testVectorProps: testVectorProps };
};
var unitTypes = [__WEBPACK_IMPORTED_MODULE_3_style_value_types__["i" /* px */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["h" /* percent */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["d" /* degrees */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["l" /* vh */], __WEBPACK_IMPORTED_MODULE_3_style_value_types__["m" /* vw */]];
var findUnitType = function (prop) {
    return unitTypes.find(function (type) {
        return type.test(prop);
    });
};
var isUnitProp = function (prop) {
    return Boolean(findUnitType(prop));
};
var createAction = function (action, props) {
    return action(props);
};
var reduceArrayValue = function (i) {
    return function (props, key) {
        props[key] = props[key][i];
        return props;
    };
};
var createArrayAction = function (action, props, vectorKeys) {
    var firstVectorKey = vectorKeys[0];
    var actionList = props[firstVectorKey].map(function (v, i) {
        var childActionProps = vectorKeys.reduce(reduceArrayValue(i), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props));
        return getActionCreator(v)(action, childActionProps);
    });
    return parallel$1.apply(void 0, actionList);
};
var reduceObjectValue = function (key) {
    return function (props, propKey) {
        props[propKey] = props[propKey][key];
        return props;
    };
};
var createObjectAction = function (action, props, vectorKeys) {
    var firstVectorKey = vectorKeys[0];
    var actionMap = Object.keys(props[firstVectorKey]).reduce(function (map, key) {
        var childActionProps = vectorKeys.reduce(reduceObjectValue(key), Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props));
        map[key] = getActionCreator(props[firstVectorKey][key])(action, childActionProps);
        return map;
    }, {});
    return composite(actionMap);
};
var createUnitAction = function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["from", "to"]);
    var unitType = findUnitType(from) || findUnitType(to);
    var transform = unitType.transform,
        parse = unitType.parse;
    return action(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { from: typeof from === 'string' ? parse(from) : from, to: typeof to === 'string' ? parse(to) : to })).pipe(transform);
};
var createColorAction = function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["from", "to"]);
    return action(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { from: 0, to: 1 })).pipe(Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["l" /* mixColor */])(from, to), __WEBPACK_IMPORTED_MODULE_3_style_value_types__["b" /* color */].transform);
};
var createComplexAction = function (action, _a) {
    var from = _a.from,
        to = _a.to,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["from", "to"]);
    var valueTemplate = __WEBPACK_IMPORTED_MODULE_3_style_value_types__["c" /* complex */].createTransformer(from);
    Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["a" /* invariant */])(valueTemplate(from) === __WEBPACK_IMPORTED_MODULE_3_style_value_types__["c" /* complex */].createTransformer(to)(from), "Values '" + from + "' and '" + to + "' are of different format, or a value might have changed value type.");
    return action(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { from: 0, to: 1 })).pipe(Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["k" /* mixArray */])(__WEBPACK_IMPORTED_MODULE_3_style_value_types__["c" /* complex */].parse(from), __WEBPACK_IMPORTED_MODULE_3_style_value_types__["c" /* complex */].parse(to)), valueTemplate);
};
var createVectorAction = function (action, typeTests) {
    var _a = createVectorTests(typeTests),
        testVectorProps = _a.testVectorProps,
        getVectorKeys = _a.getVectorKeys;
    var vectorAction = function (props) {
        var isVector = testVectorProps(props);
        if (!isVector) return action(props);
        var vectorKeys = getVectorKeys(props);
        var testKey = vectorKeys[0];
        var testProp = props[testKey];
        return getActionCreator(testProp)(action, props, vectorKeys);
    };
    return vectorAction;
};
var getActionCreator = function (prop) {
    var actionCreator = createAction;
    if (typeof prop === 'number') {
        actionCreator = createAction;
    } else if (Array.isArray(prop)) {
        actionCreator = createArrayAction;
    } else if (isUnitProp(prop)) {
        actionCreator = createUnitAction;
    } else if (__WEBPACK_IMPORTED_MODULE_3_style_value_types__["b" /* color */].test(prop)) {
        actionCreator = createColorAction;
    } else if (__WEBPACK_IMPORTED_MODULE_3_style_value_types__["c" /* complex */].test(prop)) {
        actionCreator = createComplexAction;
    } else if (typeof prop === 'object') {
        actionCreator = createObjectAction;
    }
    return actionCreator;
};

var decay = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var complete = _a.complete,
            update = _a.update;
        var _b = props.velocity,
            velocity = _b === void 0 ? 0 : _b,
            _c = props.from,
            from = _c === void 0 ? 0 : _c,
            _d = props.power,
            power = _d === void 0 ? 0.8 : _d,
            _e = props.timeConstant,
            timeConstant = _e === void 0 ? 350 : _e,
            _f = props.restDelta,
            restDelta = _f === void 0 ? 0.5 : _f,
            modifyTarget = props.modifyTarget;
        var elapsed = 0;
        var amplitude = power * velocity;
        var idealTarget = Math.round(from + amplitude);
        var target = typeof modifyTarget === 'undefined' ? idealTarget : modifyTarget(idealTarget);
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var frameDelta = _a.delta;
            elapsed += frameDelta;
            var delta = -amplitude * Math.exp(-elapsed / timeConstant);
            var isMoving = delta > restDelta || delta < -restDelta;
            var current = isMoving ? target + delta : target;
            update(current);
            if (!isMoving) {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                complete();
            }
        }, true);
        return {
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};
var vectorDecay = /*#__PURE__*/createVectorAction(decay, {
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    modifyTarget: function (func) {
        return typeof func === 'function';
    },
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var spring = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var _b = props.velocity,
            velocity = _b === void 0 ? 0.0 : _b;
        var _c = props.from,
            from = _c === void 0 ? 0.0 : _c,
            _d = props.to,
            to = _d === void 0 ? 0.0 : _d,
            _e = props.stiffness,
            stiffness = _e === void 0 ? 100 : _e,
            _f = props.damping,
            damping = _f === void 0 ? 10 : _f,
            _g = props.mass,
            mass = _g === void 0 ? 1.0 : _g,
            _h = props.restSpeed,
            restSpeed = _h === void 0 ? 0.01 : _h,
            _j = props.restDelta,
            restDelta = _j === void 0 ? 0.01 : _j;
        var initialVelocity = velocity ? -(velocity / 1000) : 0.0;
        var t = 0;
        var delta = to - from;
        var position = from;
        var prevPosition = position;
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var timeDelta = _a.delta;
            t += timeDelta;
            var dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
            var angularFreq = Math.sqrt(stiffness / mass) / 1000;
            prevPosition = position;
            if (dampingRatio < 1) {
                var envelope = Math.exp(-dampingRatio * angularFreq * t);
                var expoDecay = angularFreq * Math.sqrt(1.0 - dampingRatio * dampingRatio);
                position = to - envelope * ((initialVelocity + dampingRatio * angularFreq * delta) / expoDecay * Math.sin(expoDecay * t) + delta * Math.cos(expoDecay * t));
            } else {
                var envelope = Math.exp(-angularFreq * t);
                position = to - envelope * (delta + (initialVelocity + angularFreq * delta) * t);
            }
            velocity = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["x" /* velocityPerSecond */])(position - prevPosition, timeDelta);
            var isBelowVelocityThreshold = Math.abs(velocity) <= restSpeed;
            var isBelowDisplacementThreshold = Math.abs(to - position) <= restDelta;
            if (isBelowVelocityThreshold && isBelowDisplacementThreshold) {
                position = to;
                update(position);
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                complete();
            } else {
                update(position);
            }
        }, true);
        return {
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};
var vectorSpring = /*#__PURE__*/createVectorAction(spring, {
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    to: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    stiffness: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    damping: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    mass: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var inertia = function (_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.velocity,
        velocity = _c === void 0 ? 0 : _c,
        min = _a.min,
        max = _a.max,
        _d = _a.power,
        power = _d === void 0 ? 0.8 : _d,
        _e = _a.timeConstant,
        timeConstant = _e === void 0 ? 700 : _e,
        _f = _a.bounceStiffness,
        bounceStiffness = _f === void 0 ? 500 : _f,
        _g = _a.bounceDamping,
        bounceDamping = _g === void 0 ? 10 : _g,
        _h = _a.restDelta,
        restDelta = _h === void 0 ? 1 : _h,
        modifyTarget = _a.modifyTarget;
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var current = value(from);
        var activeAnimation;
        var isSpring = false;
        var isLessThanMin = function (v) {
            return min !== undefined && v <= min;
        };
        var isMoreThanMax = function (v) {
            return max !== undefined && v >= max;
        };
        var isOutOfBounds = function (v) {
            return isLessThanMin(v) || isMoreThanMax(v);
        };
        var isTravellingAwayFromBounds = function (v, currentVelocity) {
            return isLessThanMin(v) && currentVelocity < 0 || isMoreThanMax(v) && currentVelocity > 0;
        };
        var startAnimation = function (animation, onComplete) {
            activeAnimation && activeAnimation.stop();
            activeAnimation = animation.start({
                update: function (v) {
                    return current.update(v);
                },
                complete: function () {
                    complete();
                    onComplete && onComplete();
                }
            });
        };
        var startSpring = function (props) {
            isSpring = true;
            startAnimation(vectorSpring(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { to: isLessThanMin(props.from) ? min : max, stiffness: bounceStiffness, damping: bounceDamping, restDelta: restDelta })));
        };
        current.subscribe(function (v) {
            update(v);
            var currentVelocity = current.getVelocity();
            if (activeAnimation && !isSpring && isTravellingAwayFromBounds(v, currentVelocity)) {
                startSpring({ from: v, velocity: currentVelocity });
            }
        });
        if (isOutOfBounds(from) && velocity === 0 || isTravellingAwayFromBounds(from, velocity)) {
            startSpring({ from: from, velocity: velocity });
        } else {
            var animation = vectorDecay({
                from: from,
                velocity: velocity,
                timeConstant: timeConstant,
                power: power,
                restDelta: isOutOfBounds(from) ? 20 : restDelta,
                modifyTarget: modifyTarget
            });
            startAnimation(animation, function () {
                var v = current.get();
                if (isOutOfBounds(v)) {
                    startSpring({ from: v, velocity: current.getVelocity() });
                }
            });
        }
        return {
            stop: function () {
                return activeAnimation && activeAnimation.stop();
            }
        };
    });
};
var index = /*#__PURE__*/createVectorAction(inertia, {
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    min: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    max: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    damping: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    stiffness: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    modifyTarget: function (func) {
        return typeof func === 'function';
    }
});

var frame = function () {
    return action(function (_a) {
        var update = _a.update;
        var initialTime = 0;
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var timestamp = _a.timestamp;
            if (!initialTime) initialTime = timestamp;
            update(timestamp - initialTime);
        }, true, true);
        return {
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};

var scrubber = function (_a) {
    var _b = _a.from,
        from = _b === void 0 ? 0 : _b,
        _c = _a.to,
        to = _c === void 0 ? 1 : _c,
        _d = _a.ease,
        ease = _d === void 0 ? __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["linear"] : _d;
    return action(function (_a) {
        var update = _a.update;
        return {
            seek: function (progress$$1) {
                return update(progress$$1);
            }
        };
    }).pipe(ease, function (v) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(from, to, v);
    });
};
var vectorScrubber = /*#__PURE__*/createVectorAction(scrubber, {
    ease: function (func) {
        return typeof func === 'function';
    },
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    to: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var clampProgress = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */])(0, 1);
var tween = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var _b = props.duration,
            duration = _b === void 0 ? 300 : _b,
            _c = props.ease,
            ease = _c === void 0 ? __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["easeOut"] : _c,
            _d = props.flip,
            flip = _d === void 0 ? 0 : _d,
            _e = props.loop,
            loop = _e === void 0 ? 0 : _e,
            _f = props.yoyo,
            yoyo = _f === void 0 ? 0 : _f;
        var _g = props.from,
            from = _g === void 0 ? 0 : _g,
            _h = props.to,
            to = _h === void 0 ? 1 : _h,
            _j = props.elapsed,
            elapsed = _j === void 0 ? 0 : _j,
            _k = props.playDirection,
            playDirection = _k === void 0 ? 1 : _k,
            _l = props.flipCount,
            flipCount = _l === void 0 ? 0 : _l,
            _m = props.yoyoCount,
            yoyoCount = _m === void 0 ? 0 : _m,
            _o = props.loopCount,
            loopCount = _o === void 0 ? 0 : _o;
        var playhead = vectorScrubber({ from: from, to: to, ease: ease }).start(update);
        var currentProgress = 0;
        var process;
        var isActive = false;
        var reverseTween = function () {
            return playDirection *= -1;
        };
        var isTweenComplete = function () {
            var _a;
            var isComplete = playDirection === 1 ? isActive && elapsed >= duration : isActive && elapsed <= 0;
            if (!isComplete) return false;
            if (isComplete && !loop && !flip && !yoyo) return true;
            var isStepTaken = false;
            if (loop && loopCount < loop) {
                elapsed = 0;
                loopCount++;
                isStepTaken = true;
            } else if (flip && flipCount < flip) {
                elapsed = duration - elapsed;
                _a = [to, from], from = _a[0], to = _a[1];
                playhead = vectorScrubber({ from: from, to: to, ease: ease }).start(update);
                flipCount++;
                isStepTaken = true;
            } else if (yoyo && yoyoCount < yoyo) {
                reverseTween();
                yoyoCount++;
                isStepTaken = true;
            }
            return !isStepTaken;
        };
        var updateTween = function () {
            currentProgress = clampProgress(Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["o" /* progress */])(0, duration, elapsed));
            playhead.seek(currentProgress);
        };
        var startTimer = function () {
            isActive = true;
            process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
                var delta = _a.delta;
                elapsed += delta * playDirection;
                updateTween();
                if (isTweenComplete() && complete) {
                    __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                    __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(complete, false, true);
                }
            }, true);
        };
        var stopTimer = function () {
            isActive = false;
            if (process) __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
        };
        startTimer();
        return {
            isActive: function () {
                return isActive;
            },
            getElapsed: function () {
                return Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */])(0, duration, elapsed);
            },
            getProgress: function () {
                return currentProgress;
            },
            stop: function () {
                stopTimer();
            },
            pause: function () {
                stopTimer();
                return this;
            },
            resume: function () {
                if (!isActive) startTimer();
                return this;
            },
            seek: function (newProgress) {
                elapsed = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(0, duration, newProgress);
                __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updateTween, false, true);
                return this;
            },
            reverse: function () {
                reverseTween();
                return this;
            }
        };
    });
};

var clampProgress$1 = /*#__PURE__*/Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */])(0, 1);
var defaultEasings = function (values, easing$$1) {
    return values.map(function () {
        return easing$$1 || __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["easeOut"];
    }).splice(0, values.length - 1);
};
var defaultTimings = function (values) {
    var numValues = values.length;
    return values.map(function (value, i) {
        return i !== 0 ? i / (numValues - 1) : 0;
    });
};
var interpolateScrubbers = function (input, scrubbers, update) {
    var rangeLength = input.length;
    var finalInputIndex = rangeLength - 1;
    var finalScrubberIndex = finalInputIndex - 1;
    var subs = scrubbers.map(function (scrub) {
        return scrub.start(update);
    });
    return function (v) {
        if (v <= input[0]) {
            subs[0].seek(0);
        }
        if (v >= input[finalInputIndex]) {
            subs[finalScrubberIndex].seek(1);
        }
        var i = 1;
        for (; i < rangeLength; i++) {
            if (input[i] > v || i === finalInputIndex) break;
        }
        var progressInRange = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["o" /* progress */])(input[i - 1], input[i], v);
        subs[i - 1].seek(clampProgress$1(progressInRange));
    };
};
var keyframes = function (_a) {
    var easings = _a.easings,
        _b = _a.ease,
        ease = _b === void 0 ? __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["linear"] : _b,
        times = _a.times,
        values = _a.values,
        tweenProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["easings", "ease", "times", "values"]);
    easings = Array.isArray(easings) ? easings : defaultEasings(values, easings);
    times = times || defaultTimings(values);
    var scrubbers = easings.map(function (easing$$1, i) {
        return vectorScrubber({
            from: values[i],
            to: values[i + 1],
            ease: easing$$1
        });
    });
    return tween(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, tweenProps, { ease: ease })).applyMiddleware(function (update) {
        return interpolateScrubbers(times, scrubbers, update);
    });
};

var physics = function (props) {
    if (props === void 0) {
        props = {};
    }
    return action(function (_a) {
        var complete = _a.complete,
            update = _a.update;
        var _b = props.acceleration,
            acceleration = _b === void 0 ? 0 : _b,
            _c = props.friction,
            friction = _c === void 0 ? 0 : _c,
            _d = props.velocity,
            velocity = _d === void 0 ? 0 : _d,
            springStrength = props.springStrength,
            to = props.to;
        var _e = props.restSpeed,
            restSpeed = _e === void 0 ? 0.001 : _e,
            _f = props.from,
            from = _f === void 0 ? 0 : _f;
        var current = from;
        var process = __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(function (_a) {
            var delta = _a.delta;
            var elapsed = Math.max(delta, 16);
            if (acceleration) velocity += Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["w" /* velocityPerFrame */])(acceleration, elapsed);
            if (friction) velocity *= Math.pow(1 - friction, elapsed / 100);
            if (springStrength !== undefined && to !== undefined) {
                var distanceToTarget = to - current;
                velocity += distanceToTarget * Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["w" /* velocityPerFrame */])(springStrength, elapsed);
            }
            current += Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["w" /* velocityPerFrame */])(velocity, elapsed);
            update(current);
            var isComplete = restSpeed !== false && (!velocity || Math.abs(velocity) <= restSpeed);
            if (isComplete) {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
                complete();
            }
        }, true);
        return {
            set: function (v) {
                current = v;
                return this;
            },
            setAcceleration: function (v) {
                acceleration = v;
                return this;
            },
            setFriction: function (v) {
                friction = v;
                return this;
            },
            setSpringStrength: function (v) {
                springStrength = v;
                return this;
            },
            setSpringTarget: function (v) {
                to = v;
                return this;
            },
            setVelocity: function (v) {
                velocity = v;
                return this;
            },
            stop: function () {
                return __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(process);
            }
        };
    });
};
var vectorPhysics = /*#__PURE__*/createVectorAction(physics, {
    acceleration: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    friction: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    velocity: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    from: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    to: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test,
    springStrength: __WEBPACK_IMPORTED_MODULE_3_style_value_types__["g" /* number */].test
});

var DEFAULT_DURATION = 300;
var flattenTimings = function (instructions) {
    var flatInstructions = [];
    var lastArg = instructions[instructions.length - 1];
    var isStaggered = typeof lastArg === 'number';
    var staggerDelay = isStaggered ? lastArg : 0;
    var segments = isStaggered ? instructions.slice(0, -1) : instructions;
    var numSegments = segments.length;
    var offset = 0;
    segments.forEach(function (item, i) {
        flatInstructions.push(item);
        if (i !== numSegments - 1) {
            var duration = item.duration || DEFAULT_DURATION;
            offset += staggerDelay;
            flatInstructions.push("-" + (duration - offset));
        }
    });
    return flatInstructions;
};
var flattenArrayInstructions = function (instructions, instruction) {
    Array.isArray(instruction) ? instructions.push.apply(instructions, flattenTimings(instruction)) : instructions.push(instruction);
    return instructions;
};
var convertDefToProps = function (props, def, i) {
    var duration = props.duration,
        easings = props.easings,
        times = props.times,
        values = props.values;
    var numValues = values.length;
    var prevTimeTo = times[numValues - 1];
    var timeFrom = def.at === 0 ? 0 : def.at / duration;
    var timeTo = (def.at + def.duration) / duration;
    if (i === 0) {
        values.push(def.from);
        times.push(timeFrom);
    } else {
        if (prevTimeTo !== timeFrom) {
            if (def.from !== undefined) {
                values.push(values[numValues - 1]);
                times.push(timeFrom);
                easings.push(__WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["linear"]);
            }
            var from = def.from !== undefined ? def.from : values[numValues - 1];
            values.push(from);
            times.push(timeFrom);
            easings.push(__WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["linear"]);
        } else if (def.from !== undefined) {
            values.push(def.from);
            times.push(timeFrom);
            easings.push(__WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["linear"]);
        }
    }
    values.push(def.to);
    times.push(timeTo);
    easings.push(def.ease || __WEBPACK_IMPORTED_MODULE_5__popmotion_easing__["easeInOut"]);
    return props;
};
var timeline = function (instructions, _a) {
    var _b = _a === void 0 ? {} : _a,
        duration = _b.duration,
        elapsed = _b.elapsed,
        ease = _b.ease,
        loop = _b.loop,
        flip = _b.flip,
        yoyo = _b.yoyo;
    var playhead = 0;
    var calculatedDuration = 0;
    var flatInstructions = instructions.reduce(flattenArrayInstructions, []);
    var animationDefs = [];
    flatInstructions.forEach(function (instruction) {
        if (typeof instruction === 'string') {
            playhead += parseFloat(instruction);
        } else if (typeof instruction === 'number') {
            playhead = instruction;
        } else {
            var def = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, instruction, { at: playhead });
            def.duration = def.duration === undefined ? DEFAULT_DURATION : def.duration;
            animationDefs.push(def);
            playhead += def.duration;
            calculatedDuration = Math.max(calculatedDuration, def.at + def.duration);
        }
    });
    var tracks = {};
    var numDefs = animationDefs.length;
    for (var i = 0; i < numDefs; i++) {
        var def = animationDefs[i];
        var track = def.track;
        if (track === undefined) {
            throw new Error('No track defined');
        }
        if (!tracks.hasOwnProperty(track)) tracks[track] = [];
        tracks[track].push(def);
    }
    var trackKeyframes = {};
    for (var key in tracks) {
        if (tracks.hasOwnProperty(key)) {
            var keyframeProps = tracks[key].reduce(convertDefToProps, {
                duration: calculatedDuration,
                easings: [],
                times: [],
                values: []
            });
            trackKeyframes[key] = keyframes(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, keyframeProps, { duration: duration || calculatedDuration, ease: ease,
                elapsed: elapsed,
                loop: loop,
                yoyo: yoyo,
                flip: flip }));
        }
    }
    return composite(trackKeyframes);
};

var listen = function (element, events, options) {
    return action(function (_a) {
        var update = _a.update;
        var eventNames = events.split(' ').map(function (eventName) {
            element.addEventListener(eventName, update, options);
            return eventName;
        });
        return {
            stop: function () {
                return eventNames.forEach(function (eventName) {
                    return element.removeEventListener(eventName, update, options);
                });
            }
        };
    });
};

var defaultPointerPos = function () {
    return {
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        x: 0,
        y: 0
    };
};
var eventToPoint = function (e, point) {
    if (point === void 0) {
        point = defaultPointerPos();
    }
    point.clientX = point.x = e.clientX;
    point.clientY = point.y = e.clientY;
    point.pageX = e.pageX;
    point.pageY = e.pageY;
    return point;
};

var points = [/*#__PURE__*/defaultPointerPos()];
var isTouchDevice = false;
if (typeof document !== 'undefined') {
    var updatePointsLocation = function (_a) {
        var touches = _a.touches;
        isTouchDevice = true;
        var numTouches = touches.length;
        points.length = 0;
        for (var i = 0; i < numTouches; i++) {
            var thisTouch = touches[i];
            points.push(eventToPoint(thisTouch));
        }
    };
    listen(document, 'touchstart touchmove', {
        passive: true,
        capture: true
    }).start(updatePointsLocation);
}
var multitouch = function (_a) {
    var _b = _a === void 0 ? {} : _a,
        _c = _b.preventDefault,
        preventDefault = _c === void 0 ? true : _c,
        _d = _b.scale,
        scale = _d === void 0 ? 1.0 : _d,
        _e = _b.rotate,
        rotate = _e === void 0 ? 0.0 : _e;
    return action(function (_a) {
        var update = _a.update;
        var output = {
            touches: points,
            scale: scale,
            rotate: rotate
        };
        var initialDistance = 0.0;
        var initialRotation = 0.0;
        var isGesture = points.length > 1;
        if (isGesture) {
            var firstTouch = points[0],
                secondTouch = points[1];
            initialDistance = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["f" /* distance */])(firstTouch, secondTouch);
            initialRotation = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["a" /* angle */])(firstTouch, secondTouch);
        }
        var updatePoint = function () {
            if (isGesture) {
                var firstTouch = points[0],
                    secondTouch = points[1];
                var newDistance = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["f" /* distance */])(firstTouch, secondTouch);
                var newRotation = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["a" /* angle */])(firstTouch, secondTouch);
                output.scale = scale * (newDistance / initialDistance);
                output.rotate = rotate + (newRotation - initialRotation);
            }
            update(output);
        };
        var onMove = function (e) {
            if (preventDefault || e.touches.length > 1) e.preventDefault();
            __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        };
        var updateOnMove = listen(document, 'touchmove', {
            passive: !preventDefault
        }).start(onMove);
        if (isTouchDevice) __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        return {
            stop: function () {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(updatePoint);
                updateOnMove.stop();
            }
        };
    });
};
var getIsTouchDevice = function () {
    return isTouchDevice;
};

var point = /*#__PURE__*/defaultPointerPos();
var isMouseDevice = false;
if (typeof document !== 'undefined') {
    var updatePointLocation = function (e) {
        isMouseDevice = true;
        eventToPoint(e, point);
    };
    listen(document, 'mousedown mousemove', true).start(updatePointLocation);
}
var mouse = function (_a) {
    var _b = (_a === void 0 ? {} : _a).preventDefault,
        preventDefault = _b === void 0 ? true : _b;
    return action(function (_a) {
        var update = _a.update;
        var updatePoint = function () {
            return update(point);
        };
        var onMove = function (e) {
            if (preventDefault) e.preventDefault();
            __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        };
        var updateOnMove = listen(document, 'mousemove').start(onMove);
        if (isMouseDevice) __WEBPACK_IMPORTED_MODULE_2_framesync__["b" /* default */].update(updatePoint);
        return {
            stop: function () {
                __WEBPACK_IMPORTED_MODULE_2_framesync__["a" /* cancelSync */].update(updatePoint);
                updateOnMove.stop();
            }
        };
    });
};

var getFirstTouch = function (_a) {
    var firstTouch = _a[0];
    return firstTouch;
};
var pointer = function (props) {
    if (props === void 0) {
        props = {};
    }
    return getIsTouchDevice() ? multitouch(props).pipe(function (_a) {
        var touches = _a.touches;
        return touches;
    }, getFirstTouch) : mouse(props);
};
var index$1 = function (_a) {
    if (_a === void 0) {
        _a = {};
    }
    var x = _a.x,
        y = _a.y,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __rest */])(_a, ["x", "y"]);
    if (x !== undefined || y !== undefined) {
        var applyXOffset_1 = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["b" /* applyOffset */])(x || 0);
        var applyYOffset_1 = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["b" /* applyOffset */])(y || 0);
        var delta_1 = { x: 0, y: 0 };
        return pointer(props).pipe(function (point) {
            delta_1.x = applyXOffset_1(point.x);
            delta_1.y = applyYOffset_1(point.y);
            return delta_1;
        });
    } else {
        return pointer(props);
    }
};

var chain = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var i = 0;
        var current;
        var playCurrent = function () {
            current = actions[i].start({
                complete: function () {
                    i++;
                    i >= actions.length ? complete() : playCurrent();
                },
                update: update
            });
        };
        playCurrent();
        return {
            stop: function () {
                return current && current.stop();
            }
        };
    });
};

var crossfade = function (a, b) {
    return action(function (observer) {
        var balance = 0;
        var fadable = parallel$1(a, b).start(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, observer, { update: function (_a) {
                var va = _a[0],
                    vb = _a[1];
                observer.update(Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(va, vb, balance));
            } }));
        return {
            setBalance: function (v) {
                return balance = v;
            },
            stop: function () {
                return fadable.stop();
            }
        };
    });
};

var delay = function (timeToDelay) {
    return action(function (_a) {
        var complete = _a.complete;
        var timeout = setTimeout(complete, timeToDelay);
        return {
            stop: function () {
                return clearTimeout(timeout);
            }
        };
    });
};

var merge = function () {
    var actions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        actions[_i] = arguments[_i];
    }
    return action(function (observer) {
        var subs = actions.map(function (thisAction) {
            return thisAction.start(observer);
        });
        return {
            stop: function () {
                return subs.forEach(function (sub) {
                    return sub.stop();
                });
            }
        };
    });
};

var schedule = function (scheduler, schedulee) {
    return action(function (_a) {
        var update = _a.update,
            complete = _a.complete;
        var latest;
        var schedulerSub = scheduler.start({
            update: function () {
                return latest !== undefined && update(latest);
            },
            complete: complete
        });
        var scheduleeSub = schedulee.start({
            update: function (v) {
                return latest = v;
            },
            complete: complete
        });
        return {
            stop: function () {
                schedulerSub.stop();
                scheduleeSub.stop();
            }
        };
    });
};

var stagger = function (actions, interval) {
    var intervalIsNumber = typeof interval === 'number';
    var actionsWithDelay = actions.map(function (a, i) {
        var timeToDelay = intervalIsNumber ? interval * i : interval(i);
        return chain(delay(timeToDelay), a);
    });
    return parallel$1.apply(void 0, actionsWithDelay);
};

var appendUnit = function (unit) {
    return function (v) {
        return "" + v + unit;
    };
};
var steps = function (st, min, max) {
    if (min === void 0) {
        min = 0;
    }
    if (max === void 0) {
        max = 1;
    }
    return function (v) {
        var current = Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["o" /* progress */])(min, max, v);
        return Object(__WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["j" /* mix */])(min, max, stepProgress(st, current));
    };
};
var transformMap = function (childTransformers) {
    return function (v) {
        var output = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, v);
        for (var key in childTransformers) {
            if (childTransformers.hasOwnProperty(key)) {
                var childTransformer = childTransformers[key];
                output[key] = childTransformer(v[key]);
            }
        }
        return output;
    };
};

var transformers = /*#__PURE__*/Object.freeze({
    applyOffset: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["b" /* applyOffset */],
    clamp: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["c" /* clamp */],
    conditional: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["d" /* conditional */],
    interpolate: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["g" /* interpolate */],
    blendArray: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["k" /* mixArray */],
    blendColor: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["l" /* mixColor */],
    pipe: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["m" /* pipe */],
    smooth: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["q" /* smooth */],
    snap: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["s" /* snap */],
    generateStaticSpring: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["t" /* springForce */],
    nonlinearSpring: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["u" /* springForceExpo */],
    linearSpring: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["v" /* springForceLinear */],
    wrap: __WEBPACK_IMPORTED_MODULE_1__popmotion_popcorn__["y" /* wrap */],
    appendUnit: appendUnit,
    steps: steps,
    transformMap: transformMap
});

var css = function (element, props) {
    Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["b" /* warning */])(false, 'css() is deprecated, use styler instead');
    return Object(__WEBPACK_IMPORTED_MODULE_6_stylefire__["a" /* default */])(element, props);
};
var svg = function (element, props) {
    Object(__WEBPACK_IMPORTED_MODULE_4_hey_listen__["b" /* warning */])(false, 'svg() is deprecated, use styler instead');
    return Object(__WEBPACK_IMPORTED_MODULE_6_stylefire__["a" /* default */])(element, props);
};




/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["c"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return angle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return applyOffset; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return clamp$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return conditional; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return degreesToRadians; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return distance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return interpolate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPoint3D; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return mix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return mixArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return mixColor; });
/* unused harmony export mixComplex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return pipe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return pointFromVector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return progress; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return radiansToDegrees; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return smooth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return smoothFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return snap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return springForce; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return springForceExpo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return springForceLinear; });
/* unused harmony export steps */
/* unused harmony export toDecimal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return velocityPerFrame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return velocityPerSecond; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return wrap$1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_style_value_types__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hey_listen__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_framesync__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popmotion_easing__ = __webpack_require__(206);
/* unused harmony reexport createAnticipateEasing */
/* unused harmony reexport createBackIn */
/* unused harmony reexport createExpoIn */
/* unused harmony reexport cubicBezier */
/* unused harmony reexport linear */
/* unused harmony reexport easeIn */
/* unused harmony reexport easeOut */
/* unused harmony reexport easeInOut */
/* unused harmony reexport circIn */
/* unused harmony reexport circOut */
/* unused harmony reexport circInOut */
/* unused harmony reexport backIn */
/* unused harmony reexport backOut */
/* unused harmony reexport backInOut */
/* unused harmony reexport anticipate */
/* unused harmony reexport reversed */
/* unused harmony reexport mirrored */






var zeroPoint = {
    x: 0,
    y: 0,
    z: 0
};
var isNum = function (v) { return typeof v === 'number'; };

var radiansToDegrees = (function (radians) { return (radians * 180) / Math.PI; });

var angle = (function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    return radiansToDegrees(Math.atan2(b.y - a.y, b.x - a.x));
});

var applyOffset = (function (from, to) {
    var hasReceivedFrom = true;
    if (to === undefined) {
        to = from;
        hasReceivedFrom = false;
    }
    return function (v) {
        if (hasReceivedFrom) {
            return v - from + to;
        }
        else {
            from = v;
            hasReceivedFrom = true;
            return to;
        }
    };
});

var curryRange = (function (func) { return function (min, max, v) { return (v !== undefined ? func(min, max, v) : function (cv) { return func(min, max, cv); }); }; });

var clamp = function (min, max, v) {
    return Math.min(Math.max(v, min), max);
};
var clamp$1 = curryRange(clamp);

var conditional = (function (check, apply) { return function (v) {
    return check(v) ? apply(v) : v;
}; });

var degreesToRadians = (function (degrees) { return (degrees * Math.PI) / 180; });

var isPoint = (function (point) {
    return point.hasOwnProperty('x') && point.hasOwnProperty('y');
});

var isPoint3D = (function (point) {
    return isPoint(point) && point.hasOwnProperty('z');
});

var distance1D = function (a, b) { return Math.abs(a - b); };
var distance = (function (a, b) {
    if (b === void 0) { b = zeroPoint; }
    if (isNum(a) && isNum(b)) {
        return distance1D(a, b);
    }
    else if (isPoint(a) && isPoint(b)) {
        var xDelta = distance1D(a.x, b.x);
        var yDelta = distance1D(a.y, b.y);
        var zDelta = isPoint3D(a) && isPoint3D(b) ? distance1D(a.z, b.z) : 0;
        return Math.sqrt(Math.pow(xDelta, 2) + Math.pow(yDelta, 2) + Math.pow(zDelta, 2));
    }
    return 0;
});

var progress = (function (from, to, value) {
    var toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
});

var mix = (function (from, to, progress) {
    return -progress * from + progress * to + from;
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var mixLinearColor = function (from, to, v) {
    var fromExpo = from * from;
    var toExpo = to * to;
    return Math.sqrt(v * (toExpo - fromExpo) + fromExpo);
};
var colorTypes = [__WEBPACK_IMPORTED_MODULE_0_style_value_types__["e" /* hex */], __WEBPACK_IMPORTED_MODULE_0_style_value_types__["j" /* rgba */], __WEBPACK_IMPORTED_MODULE_0_style_value_types__["f" /* hsla */]];
var getColorType = function (v) {
    return colorTypes.find(function (type) { return type.test(v); });
};
var mixColor = (function (from, to) {
    var fromColorType = getColorType(from);
    var toColorType = getColorType(to);
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(fromColorType.transform === toColorType.transform, 'Both colors must be Hex and/or RGBA, or both must be HSLA');
    var fromColor = fromColorType.parse(from);
    var toColor = toColorType.parse(to);
    var blended = __assign({}, fromColor);
    var mixFunc = fromColorType === __WEBPACK_IMPORTED_MODULE_0_style_value_types__["f" /* hsla */] ? mix : mixLinearColor;
    return function (v) {
        for (var key in blended) {
            if (key !== 'alpha') {
                blended[key] = mixFunc(fromColor[key], toColor[key], v);
            }
        }
        blended.alpha = mix(fromColor.alpha, toColor.alpha, v);
        return fromColorType.transform(blended);
    };
});

var combineFunctions = function (a, b) { return function (v) { return b(a(v)); }; };
var pipe = (function () {
    var transformers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        transformers[_i] = arguments[_i];
    }
    return transformers.reduce(combineFunctions);
});

var mixArray = function (from, to) {
    var output = from.slice();
    var numValues = output.length;
    var blendValue = from.map(function (fromThis, i) {
        var toThis = to[i];
        if (isNum(fromThis)) {
            return function (v) { return mix(fromThis, toThis, v); };
        }
        else if (__WEBPACK_IMPORTED_MODULE_0_style_value_types__["b" /* color */].test(fromThis)) {
            return mixColor(fromThis, toThis);
        }
        else {
            return mixComplex(fromThis, toThis);
        }
    });
    return function (v) {
        for (var i = 0; i < numValues; i++) {
            output[i] = blendValue[i](v);
        }
        return output;
    };
};
var mixComplex = function (from, to) {
    var valueTemplate = __WEBPACK_IMPORTED_MODULE_0_style_value_types__["c" /* complex */].createTransformer(from);
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(valueTemplate(from) === __WEBPACK_IMPORTED_MODULE_0_style_value_types__["c" /* complex */].createTransformer(to)(from), "Values '" + from + "' and '" + to + "' are of different format, or a value might have changed value type.");
    return pipe(mixArray(__WEBPACK_IMPORTED_MODULE_0_style_value_types__["c" /* complex */].parse(from), __WEBPACK_IMPORTED_MODULE_0_style_value_types__["c" /* complex */].parse(to)), valueTemplate);
};

var mixNumber = curryRange(mix);
var getMixer = function (v) {
    return typeof v === 'number'
        ? mixNumber
        : __WEBPACK_IMPORTED_MODULE_0_style_value_types__["b" /* color */].test(v)
            ? mixColor
            : mixComplex;
};
var createMixers = function (output, ease) {
    return Array(output.length - 1)
        .fill(getMixer(output[0]))
        .map(function (factory, i) {
        var mixer = factory(output[i], output[i + 1]);
        if (ease) {
            var easingFunction = Array.isArray(ease) ? ease[i] : ease;
            return pipe(easingFunction, mixer);
        }
        else {
            return mixer;
        }
    });
};
var fastInterpolate = function (_a, _b) {
    var from = _a[0], to = _a[1];
    var mixer = _b[0];
    return function (v) { return mixer(progress(from, to, v)); };
};
var slowInterpolate = function (input, mixers) {
    var inputLength = input.length;
    var lastInputIndex = inputLength - 1;
    return function (v) {
        var mixerIndex = 0;
        var foundMixerIndex = false;
        if (v <= input[0]) {
            foundMixerIndex = true;
        }
        else if (v >= input[lastInputIndex]) {
            mixerIndex = lastInputIndex - 1;
            foundMixerIndex = true;
        }
        if (!foundMixerIndex) {
            var i = 1;
            for (; i < inputLength; i++) {
                if (input[i] > v || i === lastInputIndex) {
                    break;
                }
            }
            mixerIndex = i - 1;
        }
        var progressInRange = progress(input[mixerIndex], input[mixerIndex + 1], v);
        return mixers[mixerIndex](progressInRange);
    };
};
var interpolate = (function (input, output, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.clamp, clamp = _c === void 0 ? true : _c, ease = _b.ease;
    var inputLength = input.length;
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(inputLength === output.length, 'Both input and output ranges must be the same length');
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(!ease || !Array.isArray(ease) || ease.length === input.length - 1, 'Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values.');
    if (input[0] > input[inputLength - 1]) {
        input = input.slice();
        output = output.slice();
        input.reverse();
        output.reverse();
    }
    var mixers = createMixers(output, ease);
    var interpolate = inputLength === 2
        ? fastInterpolate(input, mixers)
        : slowInterpolate(input, mixers);
    return clamp
        ? pipe(clamp$1(input[0], input[inputLength - 1]), interpolate)
        : interpolate;
});

var pointFromVector = (function (origin, angle, distance) {
    angle = degreesToRadians(angle);
    return {
        x: distance * Math.cos(angle) + origin.x,
        y: distance * Math.sin(angle) + origin.y
    };
});

var toDecimal = (function (num, precision) {
    if (precision === void 0) { precision = 2; }
    precision = Math.pow(10, precision);
    return Math.round(num * precision) / precision;
});

var smoothFrame = (function (prevValue, nextValue, duration, smoothing) {
    if (smoothing === void 0) { smoothing = 0; }
    return toDecimal(prevValue +
        (duration * (nextValue - prevValue)) / Math.max(smoothing, duration));
});

var smooth = (function (strength) {
    if (strength === void 0) { strength = 50; }
    var previousValue = 0;
    var lastUpdated = 0;
    return function (v) {
        var currentFramestamp = Object(__WEBPACK_IMPORTED_MODULE_2_framesync__["c" /* getFrameData */])().timestamp;
        var timeDelta = currentFramestamp !== lastUpdated ? currentFramestamp - lastUpdated : 0;
        var newValue = timeDelta
            ? smoothFrame(previousValue, v, timeDelta, strength)
            : previousValue;
        lastUpdated = currentFramestamp;
        previousValue = newValue;
        return newValue;
    };
});

var snap = (function (points) {
    if (typeof points === 'number') {
        return function (v) { return Math.round(v / points) * points; };
    }
    else {
        var i_1 = 0;
        var numPoints_1 = points.length;
        return function (v) {
            var lastDistance = Math.abs(points[0] - v);
            for (i_1 = 1; i_1 < numPoints_1; i_1++) {
                var point = points[i_1];
                var distance = Math.abs(point - v);
                if (distance === 0)
                    return point;
                if (distance > lastDistance)
                    return points[i_1 - 1];
                if (i_1 === numPoints_1 - 1)
                    return point;
                lastDistance = distance;
            }
        };
    }
});

var identity = function (v) { return v; };
var springForce = function (alterDisplacement) {
    if (alterDisplacement === void 0) { alterDisplacement = identity; }
    return curryRange(function (constant, origin, v) {
        var displacement = origin - v;
        var springModifiedDisplacement = -(0 - constant + 1) * (0 - alterDisplacement(Math.abs(displacement)));
        return displacement <= 0
            ? origin + springModifiedDisplacement
            : origin - springModifiedDisplacement;
    });
};
var springForceLinear = springForce();
var springForceExpo = springForce(Math.sqrt);

var velocityPerFrame = (function (xps, frameDuration) {
    return isNum(xps) ? xps / (1000 / frameDuration) : 0;
});

var velocityPerSecond = (function (velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
});

var wrap = function (min, max, v) {
    var rangeSize = max - min;
    return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};
var wrap$1 = curryRange(wrap);

var clampProgress = clamp$1(0, 1);
var steps = (function (steps, direction) {
    if (direction === void 0) { direction = 'end'; }
    return function (progress) {
        progress =
            direction === 'end' ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        var expanded = progress * steps;
        var rounded = direction === 'end' ? Math.floor(expanded) : Math.ceil(expanded);
        return clampProgress(rounded / steps);
    };
});




/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(1624);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_hey_listen__ = __webpack_require__(140);



var getPoseValues = function (_a) {
    var transition = _a.transition,
        delay = _a.delay,
        delayChildren = _a.delayChildren,
        staggerChildren = _a.staggerChildren,
        staggerDirection = _a.staggerDirection,
        afterChildren = _a.afterChildren,
        beforeChildren = _a.beforeChildren,
        preTransition = _a.preTransition,
        applyAtStart = _a.applyAtStart,
        applyAtEnd = _a.applyAtEnd,
        props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __rest */])(_a, ["transition", "delay", "delayChildren", "staggerChildren", "staggerDirection", "afterChildren", "beforeChildren", "preTransition", "applyAtStart", "applyAtEnd"]);
    return props;
};
var selectPoses = function (_a) {
    var label = _a.label,
        props = _a.props,
        values = _a.values,
        parentValues = _a.parentValues,
        ancestorValues = _a.ancestorValues,
        onChange = _a.onChange,
        passive = _a.passive,
        initialPose = _a.initialPose,
        poses = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __rest */])(_a, ["label", "props", "values", "parentValues", "ancestorValues", "onChange", "passive", "initialPose"]);
    return poses;
};
var selectAllValues = function (values, selectValue) {
    var allValues = {};
    values.forEach(function (value, key) {
        return allValues[key] = selectValue(value);
    });
    return allValues;
};

var resolveProp = function (target, props) {
    return typeof target === 'function' ? target(props) : target;
};
var poseDefault = function (pose, prop, defaultValue, resolveProps) {
    return pose && pose[prop] !== undefined ? resolveProp(pose[prop], resolveProps) : defaultValue;
};
var startChildAnimations = function (children, next, pose, props) {
    var animations = [];
    var delay = poseDefault(pose, 'delayChildren', 0, props);
    var stagger = poseDefault(pose, 'staggerChildren', 0, props);
    var staggerDirection = poseDefault(pose, 'staggerDirection', 1, props);
    var maxStaggerDuration = (children.size - 1) * stagger;
    var generateStaggerDuration = staggerDirection === 1 ? function (i) {
        return i * stagger;
    } : function (i) {
        return maxStaggerDuration - i * stagger;
    };
    Array.from(children).forEach(function (child, i) {
        animations.push(child.set(next, Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, { delay: delay + generateStaggerDuration(i) })));
    });
    return animations;
};
var resolveTransition = function (transition, key, value, props, convertTransitionDefinition, getInstantTransition) {
    var resolvedTransition;
    if (typeof transition === 'function') {
        resolvedTransition = transition(props);
    } else if (transition[key] || transition.default) {
        var keyTransition = transition[key] || transition.default;
        if (typeof keyTransition === 'function') {
            resolvedTransition = keyTransition(props);
        } else {
            resolvedTransition = keyTransition;
        }
    } else {
        resolvedTransition = transition;
    }
    return resolvedTransition === false ? getInstantTransition(value, props) : convertTransitionDefinition(value, resolvedTransition, props);
};
var findInsertionIndex = function (poseList, priorityList, priorityIndex) {
    var insertionIndex = 0;
    for (var i = priorityIndex - 1; i >= 0; i--) {
        var nextHighestPriorityIndex = poseList.indexOf(priorityList[i]);
        if (nextHighestPriorityIndex !== -1) {
            insertionIndex = nextHighestPriorityIndex + 1;
            break;
        }
    }
    return insertionIndex;
};
var applyValues = function (toApply, values, props, setValue, setValueNative) {
    Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(typeof toApply === 'object', 'applyAtStart and applyAtEnd must be of type object');
    return Object.keys(toApply).forEach(function (key) {
        var valueToSet = resolveProp(toApply[key], props);
        values.has(key) ? setValue(values.get(key), valueToSet) : setValueNative(key, valueToSet, props);
    });
};
var createPoseSetter = function (setterProps) {
    var state = setterProps.state,
        poses = setterProps.poses,
        startAction = setterProps.startAction,
        stopAction = setterProps.stopAction,
        getInstantTransition = setterProps.getInstantTransition,
        addActionDelay = setterProps.addActionDelay,
        getTransitionProps = setterProps.getTransitionProps,
        resolveTarget = setterProps.resolveTarget,
        transformPose = setterProps.transformPose,
        posePriority = setterProps.posePriority,
        convertTransitionDefinition = setterProps.convertTransitionDefinition,
        setValue = setterProps.setValue,
        setValueNative = setterProps.setValueNative;
    return function (next, nextProps, propagate) {
        if (nextProps === void 0) {
            nextProps = {};
        }
        if (propagate === void 0) {
            propagate = true;
        }
        var children = state.children,
            values = state.values,
            props = state.props,
            activeActions = state.activeActions,
            activePoses = state.activePoses;
        var _a = nextProps.delay,
            delay = _a === void 0 ? 0 : _a;
        var hasChildren = children.size;
        var baseTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, nextProps);
        var nextPose = poses[next];
        var getChildAnimations = function () {
            return hasChildren && propagate ? startChildAnimations(children, next, nextPose, baseTransitionProps) : [];
        };
        var getParentAnimations = function () {
            if (!nextPose) return [];
            if (transformPose) nextPose = transformPose(nextPose, next, state);
            var preTransition = nextPose.preTransition,
                getTransition = nextPose.transition,
                applyAtStart = nextPose.applyAtStart,
                applyAtEnd = nextPose.applyAtEnd;
            if (preTransition) preTransition(baseTransitionProps);
            if (applyAtStart) {
                applyValues(applyAtStart, values, baseTransitionProps, setValue, setValueNative);
            }
            var animations = Object.keys(getPoseValues(nextPose)).map(function (key) {
                var valuePoses = activePoses.has(key) ? activePoses.get(key) : (activePoses.set(key, []), activePoses.get(key));
                var existingIndex = valuePoses.indexOf(next);
                if (existingIndex !== -1) valuePoses.splice(existingIndex, 1);
                var priority = posePriority ? posePriority.indexOf(next) : 0;
                var insertionIndex = priority <= 0 ? 0 : findInsertionIndex(valuePoses, posePriority, priority);
                valuePoses.splice(insertionIndex, 0, next);
                return insertionIndex === 0 ? new Promise(function (complete) {
                    var value = values.get(key);
                    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, baseTransitionProps, { key: key,
                        value: value });
                    var target = resolveTarget(value, resolveProp(nextPose[key], transitionProps));
                    if (activeActions.has(key)) stopAction(activeActions.get(key));
                    var resolveTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ to: target }, transitionProps, getTransitionProps(value, target, transitionProps));
                    var transition = resolveTransition(getTransition, key, value, resolveTransitionProps, convertTransitionDefinition, getInstantTransition);
                    var poseDelay = resolveProp(nextPose.delay, transitionProps);
                    if (delay || poseDelay) {
                        transition = addActionDelay(delay || poseDelay, transition);
                    }
                    activeActions.set(key, startAction(value, transition, complete));
                }) : Promise.resolve();
            });
            return applyAtEnd ? [Promise.all(animations).then(function () {
                applyValues(applyAtEnd, values, baseTransitionProps, setValue, setValueNative);
            })] : animations;
        };
        if (nextPose && hasChildren) {
            if (resolveProp(nextPose.beforeChildren, baseTransitionProps)) {
                return Promise.all(getParentAnimations()).then(function () {
                    return Promise.all(getChildAnimations());
                });
            } else if (resolveProp(nextPose.afterChildren, baseTransitionProps)) {
                return Promise.all(getChildAnimations()).then(function () {
                    return Promise.all(getParentAnimations());
                });
            }
        }
        return Promise.all(getParentAnimations().concat(getChildAnimations()));
    };
};

var DEFAULT_INITIAL_POSE = 'init';
var isScale = function (key) {
    return key.includes('scale');
};
var defaultReadValueFromSource = function (key) {
    return isScale(key) ? 1 : 0;
};
var getInitialValue = function (poses, key, initialPose, props, readValueFromSource, activePoses) {
    if (readValueFromSource === void 0) {
        readValueFromSource = defaultReadValueFromSource;
    }
    var posesToSearch = Array.isArray(initialPose) ? initialPose : [initialPose];
    posesToSearch.push(DEFAULT_INITIAL_POSE);
    var pose = posesToSearch.filter(Boolean).find(function (name) {
        return poses[name] && poses[name][key] !== undefined;
    });
    activePoses.set(key, [pose || DEFAULT_INITIAL_POSE]);
    return pose ? resolveProp(poses[pose][key], props) : readValueFromSource(key, props);
};
var createValues = function (values, _a) {
    var userSetValues = _a.userSetValues,
        createValue = _a.createValue,
        convertValue = _a.convertValue,
        readValueFromSource = _a.readValueFromSource,
        initialPose = _a.initialPose,
        poses = _a.poses,
        activePoses = _a.activePoses,
        props = _a.props;
    return function (key) {
        if (values.has(key)) return;
        var value;
        if (userSetValues && userSetValues[key] !== undefined) {
            value = convertValue(userSetValues[key], key, props);
        } else {
            var initValue = getInitialValue(poses, key, initialPose, props, readValueFromSource, activePoses);
            value = createValue(initValue, key, props);
        }
        values.set(key, value);
    };
};
var scrapeValuesFromPose = function (values, props) {
    return function (key) {
        var pose = props.poses[key];
        Object.keys(getPoseValues(pose)).forEach(createValues(values, props));
    };
};
var getAncestorValue = function (key, fromParent, ancestors) {
    if (fromParent === true) {
        return ancestors[0] && ancestors[0].values.get(key);
    } else {
        var foundAncestor = ancestors.find(function (_a) {
            var label = _a.label;
            return label === fromParent;
        });
        return foundAncestor && foundAncestor.values.get(key);
    }
};
var bindPassiveValues = function (values, _a) {
    var passive = _a.passive,
        ancestorValues = _a.ancestorValues,
        createValue = _a.createValue,
        readValue = _a.readValue,
        props = _a.props;
    return function (key) {
        var _a = passive[key],
            valueKey = _a[0],
            passiveProps = _a[1],
            fromParent = _a[2];
        var valueToBind = fromParent && ancestorValues.length ? getAncestorValue(valueKey, fromParent, ancestorValues) : values.has(valueKey) ? values.get(valueKey) : false;
        if (!valueToBind) return;
        var newValue = createValue(readValue(valueToBind), key, props, {
            passiveParentKey: valueKey,
            passiveParent: valueToBind,
            passiveProps: passiveProps
        });
        values.set(key, newValue);
    };
};
var createValueMap = function (props) {
    var poses = props.poses,
        passive = props.passive;
    var values = new Map();
    Object.keys(poses).forEach(scrapeValuesFromPose(values, props));
    if (passive) Object.keys(passive).forEach(bindPassiveValues(values, props));
    return values;
};

var applyDefaultTransition = function (pose, key, defaultTransitions) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, pose, { transition: defaultTransitions.has(key) ? defaultTransitions.get(key) : defaultTransitions.get('default') });
};
var generateTransitions = function (poses, defaultTransitions) {
    Object.keys(poses).forEach(function (key) {
        var pose = poses[key];
        Object(__WEBPACK_IMPORTED_MODULE_1_hey_listen__["a" /* invariant */])(typeof pose === 'object', "Pose '" + key + "' is of invalid type. All poses should be objects.");
        poses[key] = pose.transition !== undefined ? pose : applyDefaultTransition(pose, key, defaultTransitions);
    });
    return poses;
};

var sortByReversePriority = function (priorityOrder) {
    return function (a, b) {
        var aP = priorityOrder.indexOf(a);
        var bP = priorityOrder.indexOf(b);
        if (aP === -1 && bP !== -1) return -1;
        if (aP !== -1 && bP === -1) return 1;
        return aP - bP;
    };
};

var poseFactory = function (_a) {
    var getDefaultProps = _a.getDefaultProps,
        defaultTransitions = _a.defaultTransitions,
        bindOnChange = _a.bindOnChange,
        startAction = _a.startAction,
        stopAction = _a.stopAction,
        readValue = _a.readValue,
        readValueFromSource = _a.readValueFromSource,
        resolveTarget = _a.resolveTarget,
        setValue = _a.setValue,
        setValueNative = _a.setValueNative,
        createValue = _a.createValue,
        convertValue = _a.convertValue,
        getInstantTransition = _a.getInstantTransition,
        getTransitionProps = _a.getTransitionProps,
        addActionDelay = _a.addActionDelay,
        selectValueToRead = _a.selectValueToRead,
        convertTransitionDefinition = _a.convertTransitionDefinition,
        transformPose = _a.transformPose,
        posePriority = _a.posePriority,
        extendAPI = _a.extendAPI;
    return function (config) {
        var parentValues = config.parentValues,
            _a = config.ancestorValues,
            ancestorValues = _a === void 0 ? [] : _a;
        if (parentValues) ancestorValues.unshift({ values: parentValues });
        var activeActions = new Map();
        var activePoses = new Map();
        var children = new Set();
        var poses = generateTransitions(selectPoses(config), defaultTransitions);
        var props = config.props || {};
        if (getDefaultProps) props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, props, getDefaultProps(config));
        var passive = config.passive,
            userSetValues = config.values,
            _b = config.initialPose,
            initialPose = _b === void 0 ? DEFAULT_INITIAL_POSE : _b;
        var values = createValueMap({
            poses: poses,
            passive: passive,
            ancestorValues: ancestorValues,
            readValue: readValue,
            createValue: createValue,
            convertValue: convertValue,
            readValueFromSource: readValueFromSource,
            userSetValues: userSetValues,
            initialPose: initialPose,
            activePoses: activePoses,
            props: props
        });
        var state = {
            activeActions: activeActions,
            activePoses: activePoses,
            children: children,
            props: props,
            values: values
        };
        var onChange = config.onChange;
        if (onChange) Object.keys(onChange).forEach(bindOnChange(values, onChange));
        var set = createPoseSetter({
            state: state,
            poses: poses,
            getInstantTransition: getInstantTransition,
            getTransitionProps: getTransitionProps,
            convertTransitionDefinition: convertTransitionDefinition,
            setValue: setValue,
            setValueNative: setValueNative,
            startAction: startAction,
            stopAction: stopAction,
            resolveTarget: resolveTarget,
            addActionDelay: addActionDelay,
            transformPose: transformPose,
            posePriority: posePriority
        });
        var has = function (poseName) {
            return !!poses[poseName];
        };
        var api = {
            set: set,
            unset: function (poseName, poseProps) {
                var posesToSet = [];
                activePoses.forEach(function (valuePoses) {
                    var poseIndex = valuePoses.indexOf(poseName);
                    if (poseIndex === -1) return;
                    var currentPose = valuePoses[0];
                    valuePoses.splice(poseIndex, 1);
                    var nextPose = valuePoses[0];
                    if (nextPose === currentPose) return;
                    if (posesToSet.indexOf(nextPose) === -1) {
                        posesToSet.push(nextPose);
                    }
                });
                var animationsToResolve = posesToSet.sort(sortByReversePriority(posePriority)).map(function (poseToSet) {
                    return set(poseToSet, poseProps, false);
                });
                children.forEach(function (child) {
                    return animationsToResolve.push(child.unset(poseName));
                });
                return Promise.all(animationsToResolve);
            },
            get: function (valueName) {
                return valueName ? selectValueToRead(values.get(valueName)) : selectAllValues(values, selectValueToRead);
            },
            has: has,
            setProps: function (newProps) {
                return state.props = Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, state.props, newProps);
            },
            _addChild: function (childConfig, factory) {
                var child = factory(Object(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ initialPose: initialPose }, childConfig, { ancestorValues: [{ label: config.label, values: values }].concat(ancestorValues) }));
                children.add(child);
                return child;
            },
            removeChild: function (child) {
                return children.delete(child);
            },
            clearChildren: function () {
                children.forEach(function (child) {
                    return child.destroy();
                });
                children.clear();
            },
            destroy: function () {
                activeActions.forEach(stopAction);
                children.forEach(function (child) {
                    return child.destroy();
                });
            }
        };
        return extendAPI(api, state, config);
    };
};

/* harmony default export */ __webpack_exports__["a"] = (poseFactory);


/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["b"] = __rest;
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* unused harmony export __spread */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emotion_memoize__ = __webpack_require__(1626);


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|default|defer|dir|disabled|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|itemProp|itemScope|itemType|itemID|itemRef|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var index = Object(__WEBPACK_IMPORTED_MODULE_0__emotion_memoize__["a" /* default */])(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

/* harmony default export */ __webpack_exports__["a"] = (index);


/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/coupon.72e03874.svg";

/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/promo-dots.7b4e18c2.svg";

/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/coupon-icon.0ed6bddf.svg";

/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/info-icon.3d86d7f8.svg";

/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/timer-icon.84f8ce13.svg";

/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/wallet-icon.2ee21dca.svg";

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  width: 100%;\n  min-height: 39px;\n  padding: 0 0.5em;\n  font-size: ",";\n  line-height: normal;\n  color: ",";\n  background-color: #fff;\n  border: 1px solid #cccccc;\n  border-radius: 3px;\n  box-shadow: inset 0px 2px 0px 0px #ebebeb;\n\n  @media (min-width: 960px) {\n    min-height: 39px;\n    max-width: 220px;\n    font-size: 16px;\n  }\n\n  ",";\n\n  ",";\n\n  ","\n\n  ",";\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  width: 100%;\n  min-height: 39px;\n  padding: 0 0.5em;\n  font-size: ",";\n  line-height: normal;\n  color: ",";\n  background-color: #fff;\n  border: 1px solid #cccccc;\n  border-radius: 3px;\n  box-shadow: inset 0px 2px 0px 0px #ebebeb;\n\n  @media (min-width: 960px) {\n    min-height: 39px;\n    max-width: 220px;\n    font-size: 16px;\n  }\n\n  ",";\n\n  ",";\n\n  ","\n\n  ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      outline: none;\n      border-color: #e74c3c;\n    "],["\n      outline: none;\n      border-color: #e74c3c;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      max-width: 100% !important;\n      ",";\n    "],["\n      max-width: 100% !important;\n      ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      box-shadow: none;\n      min-height: 39px;\n    "],["\n      box-shadow: none;\n      min-height: 39px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      height: 50px;\n      ",";\n      background-color: #d4d4d4;\n      border: none;\n      ",";\n      box-shadow: none;\n\n      @media (max-width: 959px) {\n        height: 40px;\n      }\n\n      & input {\n        background-color: transparent;\n      }\n    "],["\n      height: 50px;\n      ",";\n      background-color: #d4d4d4;\n      border: none;\n      ",";\n      box-shadow: none;\n\n      @media (max-width: 959px) {\n        height: 40px;\n      }\n\n      & input {\n        background-color: transparent;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n      background-color: rgba(255, 255, 255, 0.25);\n      ",";\n\n      ",";\n    "],["\n      background-color: rgba(255, 255, 255, 0.25);\n      ",";\n\n      ",";\n    "]),_templateObject7=_taggedTemplateLiteral(["\n          border: 1px solid #ffffff;\n          ",";\n        "],["\n          border: 1px solid #ffffff;\n          ",";\n        "]),_templateObject8=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 100%;\n  vertical-align: middle;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  font-size: ",";\n  color: ",";\n  background-color: transparent;\n  border: none;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  ","\n\n  @media (min-width: 960px) {\n    font-size: ",";\n  }\n\n  ",";\n\n  ",";\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 100%;\n  vertical-align: middle;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  font-size: ",";\n  color: ",";\n  background-color: transparent;\n  border: none;\n  appearance: none;\n\n  :focus {\n    outline: none;\n  }\n\n  ","\n\n  @media (min-width: 960px) {\n    font-size: ",";\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n      color: #1b546a;\n      font-size: ",";\n      font-weight: bold;\n    "],["\n      color: #1b546a;\n      font-size: ",";\n      font-weight: bold;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n      &::placeholder {\n        color: #ffffff;\n      }\n    "],["\n      &::placeholder {\n        color: #ffffff;\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n      font-size: 16px;\n      font-weight: 700;\n      color: #1b546a;\n    "],["\n      font-size: 16px;\n      font-weight: 700;\n      color: #1b546a;\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  text-align: center;\n  color: #a5a4a4;\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: auto;\n  text-align: center;\n  color: #a5a4a4;\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.theme.inputColor;},function(props){return props.invalid&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.wide&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("border-radius","0 3px 3px 0","3px 0 0 3px"));},function(props){return props.isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);},function(_ref){var theme=_ref.theme,isProfile=_ref.isProfile,isWithdraw=_ref.isWithdraw;return theme.newIndex&&!isProfile&&!isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("margin-left","1px"),Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("border-radius","0 25px 25px 0","25px 0 0 25px"));},function(_ref2){var theme=_ref2.theme,isProfile=_ref2.isProfile,isWithdraw=_ref2.isWithdraw,isFocused=_ref2.isFocused;return theme.newIndex&&!isProfile&&!isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("padding-left","20px"),isFocused&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("padding-left","19px")));});var InputView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16),function(props){return props.theme.inputColor||"#1B546A";},function(props){return props.isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16));},Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(16),function(_ref3){var theme=_ref3.theme,isProfile=_ref3.isProfile,isWithdraw=_ref3.isWithdraw;return theme.newIndex&&!isProfile&&!isWithdraw&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);},function(_ref4){var version=_ref4.version;return version===2&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);});var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].label(_templateObject12);var Input=function(_React$Component){_inherits(Input,_React$Component);function Input(){var _ref5;var _temp,_this,_ret;_classCallCheck(this,Input);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref5=Input.__proto__||Object.getPrototypeOf(Input)).call.apply(_ref5,[this].concat(args))),_this),_this.input=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](),_this.onChange=function(e){if(typeof _this.props.onChange==="function"){_this.props.onChange(e.currentTarget.value);}},_this.onEnter=function(e){if(e.key==="Enter"&&typeof _this.props.onEnter==="function"){_this.props.onEnter(e.currentTarget.value);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Input,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.focus===true&&this.input.current){this.input.current.focus();}}},{key:"render",value:function render(){var _props=this.props,label=_props.label,val=_props.val,value=_props.value,placeholder=_props.placeholder,error=_props.error,id=_props.id,isProfile=_props.isProfile,isWithdraw=_props.isWithdraw,showPhoneInfo=_props.showPhoneInfo,version=_props.version,other=_objectWithoutProperties(_props,["label","val","value","placeholder","error","id","isProfile","isWithdraw","showPhoneInfo","version"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{invalid:!!error,wide:other.wide,isProfile:isProfile,isWithdraw:isWithdraw,isFocused:showPhoneInfo},label&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Label,{htmlFor:id},label),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InputView,Object.assign({id:id,name:id,ref:this.input,placeholder:placeholder,defaultValue:val,value:value,onChange:this.onChange,onKeyUp:this.onEnter,autoCorrect:"no",isProfile:isProfile,isWithdraw:isWithdraw,version:version},other)));}}]);return Input;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Subzero__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BtnFormSubmit__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ErrorMessage__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CountrySelect__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__validators__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StyledComponents_Container__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Input__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_logged_in_sprite_png__ = __webpack_require__(1635);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_logged_in_sprite_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_logged_in_sprite_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ReVerification_style__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ReVerification_Icons__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReVerification_Phone_PhoneInput__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RegisterMain__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  padding-top: 4px;\n"],["\n  padding-top: 4px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  padding-top: 4px;\n  padding-bottom: 12px;\n  position: relative;\n\n  @media (max-width: 959px) {\n    padding-bottom: 8px;\n  }\n"],["\n  padding-top: 4px;\n  padding-bottom: 12px;\n  position: relative;\n\n  @media (max-width: 959px) {\n    padding-bottom: 8px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  padding: 8px 0;\n"],["\n  padding: 8px 0;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: none;\n"],["\n  display: none;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  padding: 0 0 0 31px !important;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: left;\n  color: ",";\n  user-select: none;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    width: 19px;\n    height: 19px;\n    border: 1px solid #cfcfcf;\n    border-radius: 3px;\n    color: #252525;\n    background: none;\n    background-color: #f6f6f6;\n    box-shadow: inset 0 2px 0 0 #e3e3e3;\n    cursor: pointer;\n  }\n\n  :after {\n    ",";\n  }\n"],["\n  position: relative;\n  display: block;\n  padding: 0 0 0 31px !important;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: left;\n  color: ",";\n  user-select: none;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n    width: 19px;\n    height: 19px;\n    border: 1px solid #cfcfcf;\n    border-radius: 3px;\n    color: #252525;\n    background: none;\n    background-color: #f6f6f6;\n    box-shadow: inset 0 2px 0 0 #e3e3e3;\n    cursor: pointer;\n  }\n\n  :after {\n    ",";\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 5px;\n        transform: rotate(45deg);\n        width: 8px;\n        height: 12px;\n        margin-top: -8px;\n        border-right: 3px solid #56496e;\n        border-bottom: 3px solid #56496e;\n        cursor: pointer;\n      "],["\n        content: \"\";\n        position: absolute;\n        top: 50%;\n        left: 5px;\n        transform: rotate(45deg);\n        width: 8px;\n        height: 12px;\n        margin-top: -8px;\n        border-right: 3px solid #56496e;\n        border-bottom: 3px solid #56496e;\n        cursor: pointer;\n      "]),_templateObject7=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.2 !important;\n  text-decoration: none !important;\n  color: #feac00 !important;\n  transition: all 0.2s ease !important;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n"],["\n  font-size: ",";\n  line-height: 1.2 !important;\n  text-decoration: none !important;\n  color: #feac00 !important;\n  transition: all 0.2s ease !important;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  max-height: 56px;\n  margin-bottom: 15px;\n  padding: 4px 0;\n  text-align: center;\n\n  @media (min-width: 375px) {\n    vertical-align: middle;\n\n    :after {\n      content: \"\";\n      display: inline-block;\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 374px) {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: space-between;\n    justify-content: space-between;\n  }\n"],["\n  position: relative;\n  max-height: 56px;\n  margin-bottom: 15px;\n  padding: 4px 0;\n  text-align: center;\n\n  @media (min-width: 375px) {\n    vertical-align: middle;\n\n    :after {\n      content: \"\";\n      display: inline-block;\n      width: 100%;\n    }\n  }\n\n  @media (max-width: 374px) {\n    display: flex;\n    flex-flow: row nowrap;\n    align-items: center;\n    align-content: space-between;\n    justify-content: space-between;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n      @media (max-width: 374px) {\n        margin-bottom: 0;\n      }\n    "],["\n      @media (max-width: 374px) {\n        margin-bottom: 0;\n      }\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  direction: ",";\n  padding: 20px 20px 9px 20px;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 1.2;\n  color: #fff;\n\n  @media (max-width: 360px) {\n    font-size: 20px;\n  }\n"],["\n  direction: ",";\n  padding: 20px 20px 9px 20px;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 1.2;\n  color: #fff;\n\n  @media (max-width: 360px) {\n    font-size: 20px;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  position: relative;\n  padding-left: 30px;\n  font: 14px/26px Roboto, Arial, sans-serif;\n  text-decoration: none;\n  color: #feac00;\n  transition: all 0.2s ease;\n\n  @media (min-width: 375px) {\n    display: inline-block;\n    vertical-align: middle;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    margin-top: -13px;\n  }\n\n  @media (max-width: 374px) {\n    flex-grow: 0;\n    flex-shrink: 0;\n    align-self: center;\n  }\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 26px;\n    height: 26px;\n    background: url(",") no-repeat;\n    opacity: 0.5;\n    transition: all 0.3s ease;\n    background-position: left -75px;\n  }\n\n  :hover {\n    color: #ffc54c;\n  }\n\n  :hover:before {\n    opacity: 1;\n  }\n"],["\n  position: relative;\n  padding-left: 30px;\n  font: 14px/26px Roboto, Arial, sans-serif;\n  text-decoration: none;\n  color: #feac00;\n  transition: all 0.2s ease;\n\n  @media (min-width: 375px) {\n    display: inline-block;\n    vertical-align: middle;\n    position: absolute;\n    right: 0;\n    top: 50%;\n    margin-top: -13px;\n  }\n\n  @media (max-width: 374px) {\n    flex-grow: 0;\n    flex-shrink: 0;\n    align-self: center;\n  }\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 26px;\n    height: 26px;\n    background: url(",") no-repeat;\n    opacity: 0.5;\n    transition: all 0.3s ease;\n    background-position: left -75px;\n  }\n\n  :hover {\n    color: #ffc54c;\n  }\n\n  :hover:before {\n    opacity: 1;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n  }\n"],["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 4px 0;\n"],["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 4px 0;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  margin-bottom: 8px;\n  padding: 27px 20px 20px 30px;\n  background: #ebebeb;\n  border-radius: 4px;\n\n  :after {\n    top: 100%;\n    left: 18px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(235, 235, 235, 0);\n    border-top-color: #ebebeb;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n"],["\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  margin-bottom: 8px;\n  padding: 27px 20px 20px 30px;\n  background: #ebebeb;\n  border-radius: 4px;\n\n  :after {\n    top: 100%;\n    left: 18px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(235, 235, 235, 0);\n    border-top-color: #ebebeb;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 16px;\n  min-width: 16px;\n  margin-right: 7px;\n  top: 10px;\n  left: 9px;\n"],["\n  position: absolute;\n  width: 16px;\n  min-width: 16px;\n  margin-right: 7px;\n  top: 10px;\n  left: 9px;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 14px;\n  color: #343434;\n  text-align: left;\n"],["\n  font-size: ",";\n  line-height: 14px;\n  color: #343434;\n  text-align: left;\n"]),_templateObject18=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 11px;\n  height: 11px;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 11px;\n  height: 11px;\n  cursor: pointer;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  @media (max-width: 767px) {\n    :first-of-type {\n      margin-bottom: 4px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex: 1;\n    flex-basis: 50%;\n    max-width: 220px;\n  }\n"],["\n  @media (max-width: 767px) {\n    :first-of-type {\n      margin-bottom: 4px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex: 1;\n    flex-basis: 50%;\n    max-width: 220px;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["Email"],["Email"]),_templateObject21=_taggedTemplateLiteral(["Phone"],["Phone"]),_templateObject22=_taggedTemplateLiteral(["Terms and Conditions"],["Terms and Conditions"]),_templateObject23=_taggedTemplateLiteral(["Return and Refund Policy"],["Return and Refund Policy"]),_templateObject24=_taggedTemplateLiteral(["Privacy Policy"],["Privacy Policy"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var IS_IRON_OR_EZ="irontrade"==="irontrade"||"irontrade"==="eztrader";var RegisterContainer=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_13__StyledComponents_Container__["a" /* default */])(_templateObject);var InputContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject2);var CheckContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject3);var Checkbox=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].input(_templateObject4);var CheckboxLabel=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].label(_templateObject5,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},IS_IRON_OR_EZ?"#fff !important":"#8d8d8d !important",function(props){return props.checked&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject6);});var TermsLink=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_15__common_Link__["a" /* Link */])(_templateObject7,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"12px !important";});var SubmitContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject8);var BtnFormSubmit=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__BtnFormSubmit__["a" /* default */])(_templateObject9,function(props){return props.isIntlProject&&Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* css */])(_templateObject10);});var FormText=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].p(_templateObject11,function(_ref3){var theme=_ref3.theme;return theme.direction;});var LogoutLink=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_15__common_Link__["a" /* Link */])(_templateObject12,__WEBPACK_IMPORTED_MODULE_16__images_logged_in_sprite_png___default.a);var PhoneFieldContainer=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_18__ReVerification_style__["b" /* FieldContainer */])(_templateObject13);var PhoneContainer=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */])(InputContainer)(_templateObject14);var PhoneInfo=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject15);var IconContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject16);var InfoText=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject17,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var CloseInfo=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject18);var PhoneInputContainer=__WEBPACK_IMPORTED_MODULE_5_styled_components__["d" /* default */].div(_templateObject19);var SocialRegister=function(_React$Component){_inherits(SocialRegister,_React$Component);function SocialRegister(props){var _this2=this;_classCallCheck(this,SocialRegister);var _this=_possibleConstructorReturn(this,(SocialRegister.__proto__||Object.getPrototypeOf(SocialRegister)).call(this,props));_this.register=function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _this$props,email,phone,agree,agreeDailyMail,country,profile,phoneCode,tel,telValidation,submitTimeError,errors,c,credentials,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();_this$props=_this.props,email=_this$props.email,phone=_this$props.tel,agree=_this$props.agree,agreeDailyMail=_this$props.agreeDailyMail,country=_this$props.country,profile=_this$props.profile;phoneCode=_this.state.country&&_this.state.country.phoneCode;tel=phoneCode?Object(__WEBPACK_IMPORTED_MODULE_20__ReVerification_Phone_PhoneInput__["e" /* ripOffLeadingZero */])(phoneCode,phone):phone;telValidation=__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].tel(tel);submitTimeError=void 0;if(profile.sub0==="ml_01en_2"){submitTimeError=__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].agree(agree)||__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].emptyFields(email,country)||!profile.email&&__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].emailFull(email)||!profile.currency&&__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].country(country);}else{submitTimeError=__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].agree(agree)||__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].emptyFields(email,country,tel)||!profile.email&&__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].emailFull(email)||!profile.currency&&__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].country(country)||!profile.phone&&telValidation;}errors={};errors.emailError=!profile.email&&__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].emailFull(email);errors.countryError=!profile.currency&&__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].country(country);errors.telError=profile.sub0==="ml_01en_2"?null:!profile.phone&&telValidation;errors.agreeError=__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].agree(agree);if(!submitTimeError){_context.next=16;break;}if(profile.sub0!=="ml_01en_2"&&telValidation){if(typeof _this.props.logPhoneErrors==="function"){_this.props.logPhoneErrors({filtered_input:tel,user_input:phone,error_msg:"auth: Invalid phone number",source:"additional_info",phone_example:Object(__WEBPACK_IMPORTED_MODULE_21__RegisterMain__["b" /* getPhoneExample */])(_this.state.country,_this.props.apiCountries)||""});}}_this.setState(errors);return _context.abrupt("return");case 16:_this.setState({pending:"host"});c=function c(){var o={};o.daily_mail=agreeDailyMail?1:0;if(!profile.email){o.email=email;}if(!profile.currency){o.currency=country.currency;}if(profile.sub0!=="ml_01en_2"&&!profile.phone){o.phone=tel;}o.sub0=Object(__WEBPACK_IMPORTED_MODULE_8__Subzero__["c" /* getSub0 */])(window.location,_this.props.serverData);return o;};credentials=__WEBPACK_IMPORTED_MODULE_4_querystring___default.a.stringify(c());Object(__WEBPACK_IMPORTED_MODULE_22__GA__["a" /* gaReducer */])("CLICKBTN_SOCIALREGISTER_MAINPAGE",{userId:profile.id});_context.prev=20;_context.next=23;return _this.props.fetch("/profile-update?"+credentials,{unstable_dontInferResponse:true});case 23:response=_context.sent;_this.setState({pending:null});_context.t0=response.status;_context.next=_context.t0==="OK"?28:_context.t0==="ERROR"?32:35;break;case 28:_this.props.dispatch({type:"REQUEST_PROFILE"});_this.props.setSocialError(null);if(typeof _this.props.onDismissPopup==="function"){_this.props.onDismissPopup();}else{_this.props.history.push("/trade");}return _context.abrupt("break",36);case 32:_this.props.setSocialError(response.message);_this.setState({responseTimeError:response.message});return _context.abrupt("break",36);case 35:return _context.abrupt("break",36);case 36:_context.next=41;break;case 38:_context.prev=38;_context.t1=_context["catch"](20);console.error(_context.t1);case 41:case"end":return _context.stop();}}},_callee,_this2,[[20,38]]);}));return function(_x){return _ref5.apply(this,arguments);};}();_this.handleInputChange=function(event){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,event.target.name+"Error",null),_defineProperty(_this$setState,"submitTimeError",null),_defineProperty(_this$setState,"responseTimeError",null),_this$setState));_this.props.setSocialError(null);_this.props.onInputChange(event);};_this.handlePhoneInputChange=function(event){_this.setState({telError:null,submitTimeError:null,responseTimeError:null});_this.props.setSocialError(null);_this.props.onPhoneInputChange(event);};_this.showInfo=function(){return _this.setState({showPhoneInfo:true});};_this.hideInfo=function(){return _this.setState({showPhoneInfo:false});};var fields=[];if(_this.props.profile&&!_this.props.profile.email){fields.push("email");}if(IS_IRON_OR_EZ&&_this.props.profile&&!_this.props.profile.currency){fields.push("currency");}if(_this.props.profile&&!_this.props.profile.phone){fields.push("phone");}_this.state={country:null,pending:null,emailError:null,countryError:null,telError:null,agreeError:null,submitTimeError:null,responseTimeError:_this.props.socialError,showPhoneInfo:false,fields:fields};return _this;}_createClass(SocialRegister,[{key:"render",value:function render(){var _this3=this;var _props=this.props,agree=_props.agree,agreeDailyMail=_props.agreeDailyMail,tel=_props.tel,email=_props.email,country=_props.country,countryList=_props.countryList,profile=_props.profile,isAppLogin=_props.isAppLogin;var _state=this.state,pending=_state.pending,emailError=_state.emailError,countryError=_state.countryError,telError=_state.telError,agreeError=_state.agreeError,submitTimeError=_state.submitTimeError,responseTimeError=_state.responseTimeError;var inputTimeError=__WEBPACK_IMPORTED_MODULE_12__validators__["a" /* default */].email(email);var errorMessage=responseTimeError||submitTimeError||inputTimeError;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](RegisterContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FormText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Some required fields are missing!")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form",{method:"post",id:"socialForm"},this.state.fields.includes("email")&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{type:"email",name:"email",id:"register-email",required:"required",placeholder:this.props.gettext(_templateObject20),value:email,onChange:this.handleInputChange,autocomplete:"email"}),emailError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ErrorMessage__["a" /* default */],{message:emailError}),this.state.fields.includes("currency")&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InputContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__CountrySelect__["a" /* default */],{name:"country",value:country,options:countryList,onChange:this.handleInputChange})),countryError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ErrorMessage__["a" /* default */],{message:countryError}),profile&&profile.sub0==="ml_01en_2"?null:this.state.fields.includes("phone")&&(__WEBPACK_IMPORTED_MODULE_17__FeatureFlags__["a" /* default */].useCoolPhoneInputOnAuth?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PhoneFieldContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PhoneContainer,null,this.state.showPhoneInfo&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](PhoneInfo,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__ReVerification_Icons__["a" /* InfoIcon */],null)),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](InfoText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__ReVerification_Phone_PhoneInput__["a" /* PhoneInputHint */],{countryCode:this.state.country&&this.state.country.code,phoneExample:Object(__WEBPACK_IMPORTED_MODULE_21__RegisterMain__["b" /* getPhoneExample */])(this.state.country,this.props.apiCountries)})),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CloseInfo,{onClick:this.hideInfo},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"4454.792 3403.601 10.606 10.607"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("g",{transform:"translate(3350 3251)"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect",{width:"1",height:"14",fill:"#b5b5b5",transform:"translate(1114.691 152.601) rotate(45)"}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("rect",{width:"1",height:"14",fill:"#b5b5b5",transform:"translate(1115.398 162.5) rotate(135)"}))))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__ReVerification_Phone_PhoneInput__["b" /* default */],{SelectContainer:PhoneInputContainer,InputContainer:PhoneInputContainer,defaultCountry:this.props.geo,value:tel,onChange:function onChange(_ref6){var phone=_ref6.fullNumber,country=_ref6.country;_this3.setState({country:country});_this3.handleInputChange({target:{name:"tel",value:phone}});}// errorMessage={errorMessage}
,placeholder:this.props.gettext(_templateObject21),showInfo:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__ReVerification_Phone_PhoneInput__["a" /* PhoneInputHint */],null),onFocus:this.showInfo,onBlur:this.hideInfo}))):this.state.fields.includes("phone")&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{type:"tel",name:"tel",id:"register-phone",required:"required",placeholder:this.props.gettext(_templateObject21),value:tel,onChange:this.handlePhoneInputChange,autocomplete:"tel"})),profile&&profile.sub0!=="ml_01en_2"&&telError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ErrorMessage__["a" /* default */],{message:telError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Checkbox,{id:"agreeChk",type:"checkbox",checked:agree,name:"agree",onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckboxLabel,{checked:agree,htmlFor:"agreeChk"}, false?React.createElement(Gettext,null,"I'm over 18 years old"):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"I'm over 18 years old and I agree with")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TermsLink,{to:"/conditions",target:"_blank",title:this.props.gettext(_templateObject22)},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Terms and Conditions"))," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"and")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TermsLink,{to:"/return-refund-policy",target:"_blank",title:this.props.gettext(_templateObject23)},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Return and Refund Policy"))," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"and")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TermsLink,{to:"/privacy-policy",target:"_blank",title:this.props.gettext(_templateObject24)},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Privacy Policy"))))),agreeError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ErrorMessage__["a" /* default */],{message:agreeError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckContainer,{style:{margin:"8px 0"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Checkbox,{id:"agreeDailyChk",type:"checkbox",checked:agreeDailyMail,name:"agreeDailyMail",onChange:this.handleInputChange}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CheckboxLabel,{checked:agreeDailyMail,htmlFor:"agreeDailyChk"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Subscribe me to special offers and tutorial content"))),errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ErrorMessage__["a" /* default */],{message:errorMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SubmitContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](BtnFormSubmit,{id:"socialRegister",onClick:this.register,loader:pending==="host",isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Register")),!isAppLogin&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](LogoutLink,{replace:true,to:"/logout"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Log out"))))));}}]);return SocialRegister;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["f" /* mapStateToGettext */])(state),{serverData:state.serverData});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_7__common_fetch__["e" /* mapDispatchToFetch */])(SocialRegister)));

/***/ }),
/* 1635 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAABgCAYAAAFwAYLCAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABWhJREFUeNpi+P//f8R/KGAEEQwMDIxAzMAEY8A4cMDy588fBAdK/0fmgPT5Iet5xfj79284jxFiDarRf0GGgDhyQGwGUgUQQDDngLWAZFzxGoDpNpDMF2S38UDd9pcJScUfZBewYzX6P4xjDMQmIA5AAKG4DaqCEVkLIxqNGp44nYwMUGzHJoFsXAVy+L+D0oJALIAsIYRhOZhgYYELwByDEg7YLJ8ExAXYJPKAmANZAiCAGP5jgiiQ8TA7QIQi1D/3wDRIAohdoDTMBKyu+g9LHuiAESN1YHMu6fFBUOI/cugiu/crso5KqBMZoQkTp1GgZM/GAMxAL4H4HRBbgDITEMsD8X+QHeJIOv5Bkyg3Cy5X4vQHRugSnRjwSvyH4lZYYlBCilZ41IIYh4DYGIoJxzlAAKEUV3jAf2xpwQWKQUAFqkgZW4D8R8rhsFT1HpqvPgMxH7INoDAPRot0ZDYvlB+KM8gJASYGEgHO5Ew1G8jWAEsYT5DYj5HYGBpgWUYGKevIQulKUp20B4gt0KsxbOAx1JYrSAZ/R6nQ0MBLpCwpCE0uv/E5CabYDYitoGxWfDYQFw/I5TpR+X3wJA0G9KoNVxEL8oMSkJ4NxGVYFJ5FLwRghY4cEM+GsivQCiR42QMrmNDxLyxVGtwQgAACOekttsoWCYBqaGFkT3cjJWlsuJtQ6Qour6GtGAas1TwUuCKxmbE1L/DlBzdckYqsYTdSUbkLS1sFQwMjDjYDejPi6X/84ClyPA2R5D1iinvaa+AH4kw0uUyoOIaGCUBsAMS/kDIRCP+GivejFJWgphYRLmFET96MBBomtAslkAv8kNvi+DTMB+I1QPwAiGcA8U58hQAjtPACmf4aiEWh3QF+UCgVARk1aBpigPgFEJ+DepoL1NMC4jAGaEsWHTMD8UoomxOIuYC4A4iFcfnhL7iNzMAwD9oiqwdiZyB+S6gW5QI7g4FhAxB/gMX0YM4PoEqdUMXOgq32h/GxFRAjsqhE19CGVhD8x6hNcTURkDBKUwJmwyOkfgPBiAMpDgJiI2hdbYylNYPiB5LKe5ANStB+tjK0u8hIMC1BNREH0EKkEks9/QtZDUCA9qydpYEgCO9FNBhtLAxWWosgCFonaKEoAQtrwVIh+gMEGwVfP8A2ja02CoIIERtBEUSwE0sbi2gRYizOGe473Bx7d7ubCwbJwnBwr7l93H6P8fnSE8WtsG9M5sfDTA4+eUGxJ+m/oBqQGVKO4lriMj4RzTW79GZAijZxnNOdtWC7DIGeK2zlSxQl9NoqwWTIvbMUYxIfXAF+GCcYiNjM101nn1fRO1Ras6toNOCp2O2RNj3oJGiTBCqUVMGu7n0ykWxpD1Kixe3/JUjDs5mPeW4BNDZtstn1g5lmKUagRVQ9ZCAexr7Tx/6P8IoXkavoG8lYq5zjy85CEJ0TFChqFIsURWifdFQCFwBSthjmPNDNiRsixtl9yaPRPTpR8JnEKipFoKB1AgeilFfSG8U9esTqYwsTb51gFRPNom8oYCGxY/3M3iXFgTzJfOIGzCGsHYNDPQrP4T6RJHcFL//AuQlIvYI/yb2aX5+VfCy/fQmvblKBazYoXe82HaIHuISs9pZxriZ+C4OsaqcxJ0cUpzZzcIg/nhnzZ0BP1DF8PJRrHTxojwRKtI4CcVOPLVHakoh+71DHP0mQ0WAPvOFVbRJUAaVxWJ2HjM3EKXeu0+5SdEl+h6pUovJAVN5Ig5dQxja8IRprq01vFTwEL8Ir2RUBh65GaCfIgcm9Cq/slBLRpRvHpGeyZcTDtEOxLb3AFeqCWGLLlLH2TkNDs06eAlc1/g96VA8qPqSuuvADkVxFg+LRa9UAAAAASUVORK5CYII="

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Message__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ErrorMessage__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BtnFormSubmit__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Input__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StyledComponents_Container__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StyledComponents_FakeLink__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validators__ = __webpack_require__(191);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  vertical-align: middle;\n  padding: 11px 0;\n  height: 68px;\n"],["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  text-align: center;\n  vertical-align: middle;\n  padding: 11px 0;\n  height: 68px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  padding: 20px 20px 9px 20px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 1.2;\n  color: #fff;\n"],["\n  padding: 20px 20px 9px 20px;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 300;\n  line-height: 1.2;\n  color: #fff;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding-top: 10px;\n"],["\n  display: flex;\n  justify-content: center;\n  padding-top: 10px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: #feac00;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  :hover {\n    color: #ffc54c;\n  }\n\n  :active {\n    color: #ffc54c;\n  }\n\n  :focus {\n    color: #ffc54c;\n  }\n"],["\n  display: inline-block;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: #feac00;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  :hover {\n    color: #ffc54c;\n  }\n\n  :active {\n    color: #ffc54c;\n  }\n\n  :focus {\n    color: #ffc54c;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["Password"],["Password"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SubmitContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject);var FormText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].p(_templateObject2);var ForgotContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3);var ForgotLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_12__StyledComponents_FakeLink__["a" /* default */])(_templateObject4,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var SocialPassword=function(_React$Component){_inherits(SocialPassword,_React$Component);function SocialPassword(){var _ref2,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SocialPassword);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=SocialPassword.__proto__||Object.getPrototypeOf(SocialPassword)).call.apply(_ref2,[this].concat(args))),_this),_this.state={pending:null,submitTimeError:null,responseTimeError:null},_this.login=function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _this$props,email,password,locale,_this$props$query,fb_id,gp_id,submitTimeError,credentials,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();// TODO: validate
_this$props=_this.props,email=_this$props.email,password=_this$props.password,locale=_this$props.locale;_this$props$query=_this.props.query,fb_id=_this$props$query.fb_id,gp_id=_this$props$query.gp_id;submitTimeError=__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].emptyFields(email,password)||__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].emailFull(email)||__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].password(password);if(!submitTimeError){_context.next=7;break;}_this.setState({submitTimeError:submitTimeError});return _context.abrupt("return");case 7:_this.setState({pending:"host"});credentials=__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify(Object.assign({email:email,password:password,locale:locale},fb_id?{fb_id:fb_id}:{gp_id:gp_id}));_context.prev=9;_context.next=12;return _this.props.fetch("/auth-user?"+credentials,{unstable_dontInferResponse:true});case 12:response=_context.sent;_this.setState({pending:null});_context.t0=response.status;_context.next=_context.t0==="OK"?17:_context.t0==="ERROR"?21:23;break;case 17:_this.props.dispatch({type:"REQUEST_PROFILE"});_this.dismiss();_this.props.dispatch({type:"REQUEST_DEAL_HISTORY"});return _context.abrupt("break",24);case 21:if(response.must_confirm_phone){// this.props.onLeave(PHONE_CONFIRM_TAB_ID);
}else{_this.setState({responseTimeError:response.message});}return _context.abrupt("break",24);case 23:return _context.abrupt("break",24);case 24:_context.next=29;break;case 26:_context.prev=26;_context.t1=_context["catch"](9);console.error(_context.t1);case 29:case"end":return _context.stop();}}},_callee,_this2,[[9,26]]);}));return function(_x){return _ref3.apply(this,arguments);};}(),_this.handleInputChange=function(event){_this.setState({submitTimeError:null,responseTimeError:null});_this.props.onInputChange(event);},_this.dismiss=function(event,f){event!=null&&event.preventDefault();_this.props.history.replace(Object.assign({},_this.props.location,{search:""}));if(typeof f==="function"){f();}},_this.goToForgot=function(){_this.dismiss();_this.props.onLeave(__WEBPACK_IMPORTED_MODULE_6__Auth__["b" /* PASSWORD_RESTORE_TAB_ID */]);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SocialPassword,[{key:"render",value:function render(){var _this3=this;var _props=this.props,email=_props.email,password=_props.password,notification=_props.notification,query=_props.query;var _state=this.state,pending=_state.pending,submitTimeError=_state.submitTimeError,responseTimeError=_state.responseTimeError;if(!query)return null;var inputTimeError=__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].email(email);return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__StyledComponents_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FormText,null,query.fb_id?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"The e-mail address that you use on Facebook is already registered in our database. If you want to login using Facebook now, please enter your password below:"):__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Your e-mail address that you use on Google is already registered in our database. If you want to login using Google now, please enter your password below:"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Input__["a" /* default */],{type:"password",name:"password",placeholder:this.props.gettext(_templateObject5),id:"login-pass",onChange:this.handleInputChange,value:password}),responseTimeError?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ErrorMessage__["a" /* default */],{message:responseTimeError}):submitTimeError?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ErrorMessage__["a" /* default */],{message:submitTimeError}):notification?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Message__["a" /* default */],{notification:notification}):inputTimeError?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__ErrorMessage__["a" /* default */],{message:inputTimeError}):null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SubmitContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__BtnFormSubmit__["a" /* default */],{onClick:function onClick(e){return _this3.dismiss(e,function(){return _this3.props.onLeave(__WEBPACK_IMPORTED_MODULE_6__Auth__["a" /* LOGIN_TAB_ID */]);});},cancelButton:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Cancel")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__BtnFormSubmit__["a" /* default */],{id:"login",onClick:this.login,loader:pending==="host"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"login"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ForgotContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ForgotLink,{onClick:this.goToForgot},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Forgot password?"))));}}]);return SocialPassword;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["g" /* withGettext */])(Object(__WEBPACK_IMPORTED_MODULE_5__common_fetch__["h" /* withFetch */])(SocialPassword)));

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tab__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Message__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ErrorMessage__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SocialLink__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__BtnFormSubmit__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Input__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StyledComponents_Container__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__StyledComponents_FakeLink__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__validators__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__loginWith__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Scorpion__ = __webpack_require__(424);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  margin-bottom: auto;\n  font-size: 0;\n  line-height: 0;\n  vertical-align: bottom;\n  border-bottom: 2px solid ",";\n"],["\n  width: 100%;\n  margin-bottom: auto;\n  font-size: 0;\n  line-height: 0;\n  vertical-align: bottom;\n  border-bottom: 2px solid ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  text-align: justify;\n  vertical-align: middle;\n  padding: 11px 0;\n\n  ",";\n\n  ",";\n\n  :after {\n    content: \"\";\n    display: inline-block;\n    width: 100%;\n  }\n\n  ",";\n"],["\n  direction: ",";\n  position: relative;\n  text-align: justify;\n  vertical-align: middle;\n  padding: 11px 0;\n\n  ",";\n\n  ",";\n\n  :after {\n    content: \"\";\n    display: inline-block;\n    width: 100%;\n  }\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      text-align: center !important;\n    "],["\n      text-align: center !important;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      @media (max-width: 374px) {\n        height: auto;\n        text-align: center;\n      }\n    "],["\n      @media (max-width: 374px) {\n        height: auto;\n        text-align: center;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n      &::after {\n        display: none;\n      }\n    "],["\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      width: 100%;\n      &::after {\n        display: none;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  padding: 0 20px;\n  padding-bottom: 9px;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 34px;\n  color: #fff;\n\n  @media (max-width: 360px) {\n    font-size: 20px;\n    line-height: 28px;\n  }\n\n  ",";\n"],["\n  padding: 0 20px;\n  padding-bottom: 9px;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 34px;\n  color: #fff;\n\n  @media (max-width: 360px) {\n    font-size: 20px;\n    line-height: 28px;\n  }\n\n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      font-weight: 700;\n      font-size: ",";\n      line-height: 24px;\n      color: #ffffff;\n      text-align: center;\n    "],["\n      font-weight: 700;\n      font-size: ",";\n      line-height: 24px;\n      color: #ffffff;\n      text-align: center;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  margin: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n  font-size: ",";\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #fff;\n\n  @media (max-width: 374px) {\n    margin: 0 5px;\n  }\n\n  ",";\n"],["\n  margin: 0 10px;\n  display: inline-block;\n  vertical-align: middle;\n  font-size: ",";\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #fff;\n\n  @media (max-width: 374px) {\n    margin: 0 5px;\n  }\n\n  ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n      color: #ffffff;\n      text-transform: lowercase;\n    "],["\n      color: #ffffff;\n      text-transform: lowercase;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  padding-top: 10px;\n  ",";\n"],["\n  padding-top: 10px;\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n      text-align: center;\n    "],["\n      text-align: center;\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  display: inline-block;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: ",";\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  ",";\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c;\n    text-decoration: none;\n  }\n"],["\n  display: inline-block;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: ",";\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  ",";\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c;\n    text-decoration: none;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n      font-size: ",";\n      text-decoration: underline;\n    "],["\n      font-size: ",";\n      text-decoration: underline;\n    "]),_templateObject14=_taggedTemplateLiteral(["\n  display: block;\n  margin-top: 42px;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: bold;\n  color: ",";\n  text-align: center;\n  vertical-align: middle;\n\n  ",";\n"],["\n  display: block;\n  margin-top: 42px;\n  font-size: ",";\n  line-height: 1.2;\n  font-weight: bold;\n  color: ",";\n  text-align: center;\n  vertical-align: middle;\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n      margin-top: 20px;\n      color: ",";\n    "],["\n      margin-top: 20px;\n      color: ",";\n    "]),_templateObject16=_taggedTemplateLiteral(["\n  color: ",";\n  cursor: pointer;\n  &:hover {\n    color: ",";\n  }\n"],["\n  color: ",";\n  cursor: pointer;\n  &:hover {\n    color: ",";\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  margin-bottom: 32px;\n  font-size: 38px;\n  line-height: 46px;\n  font-weight: bold;\n  color: #ffffff;\n  text-align: center;\n\n  @media (max-width: 479px) {\n    margin-bottom: 15px;\n    font-size: 28px;\n    line-height: 1.2;\n  }\n"],["\n  margin-bottom: 32px;\n  font-size: 38px;\n  line-height: 46px;\n  font-weight: bold;\n  color: #ffffff;\n  text-align: center;\n\n  @media (max-width: 479px) {\n    margin-bottom: 15px;\n    font-size: 28px;\n    line-height: 1.2;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["Email"],["Email"]),_templateObject19=_taggedTemplateLiteral(["Password"],["Password"]);function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var isIronForm="irontrade"==="irontrade"||"irontrade"==="eztrader";var TabContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.accent;});var SubmitContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.direction;},function(props){return!props.showSocial&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject3);},isIronForm&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject4),function(_ref2){var theme=_ref2.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject5);});var FormText=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].p(_templateObject6,function(_ref3){var theme=_ref3.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(18));});var Text=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12),function(_ref4){var theme=_ref4.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject9);});var ForgotContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject10,function(_ref5){var theme=_ref5.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject11);});var ForgotLink=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_16__StyledComponents_FakeLink__["a" /* default */])(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14),function(_ref6){var theme=_ref6.theme;return theme.accent;},function(_ref7){var theme=_ref7.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(18));});var SignUpTabBlock=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject14,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(18),function(_ref8){var theme=_ref8.theme;return theme.mainDarkText;},function(_ref9){var theme=_ref9.theme,isDarkPage=_ref9.isDarkPage;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject15,isDarkPage?"#ffffff":"rgba(34, 34, 34, 0.59)");});var SignUpTab=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject16,function(_ref10){var theme=_ref10.theme;return theme.newIndex?theme.accent:theme.mainLink;},function(_ref11){var theme=_ref11.theme;return theme.newIndex?"#ffffff":theme.accent;});var WelcomeText=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject17);function isAndroidAppMessagingAvailable(){return window.nativeInterface!=null&&window.nativeInterface.onFacebookLoginClick!=null;}function isIOSAppMessagingAvailable(){return window.webkit!=null&&window.webkit.messageHandlers!=null&&window.webkit.messageHandlers["nativeInterface"]!=null;}var useNativeInterface=function useNativeInterface(){var fnName=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var data=arguments[1];try{if(window.nativeInterface!=null&&typeof window.nativeInterface[fnName]==="function"){window.nativeInterface[fnName](data);}if(isIOSAppMessagingAvailable()){window.webkit.messageHandlers["nativeInterface"].postMessage(JSON.stringify({function:fnName,param:data}));}}catch(error){console.log(error);}};var LoginMain=function(_React$Component){_inherits(LoginMain,_React$Component);function LoginMain(){var _ref12,_this2=this;var _temp,_this,_ret;_classCallCheck(this,LoginMain);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref12=LoginMain.__proto__||Object.getPrototypeOf(LoginMain)).call.apply(_ref12,[this].concat(args))),_this),_this.state={pending:null,emailError:null,passwordError:null,submitTimeError:null,responseTimeError:null},_this.login=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var _this$props,email,password,locale,submitTimeError,errors,credentials,response,query;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();// TODO: validate
_this$props=_this.props,email=_this$props.email,password=_this$props.password,locale=_this$props.locale;Object(__WEBPACK_IMPORTED_MODULE_19__GA__["a" /* gaReducer */])("CLICKBTN_LOGIN_MAINPAGE",{userId:"N/A"});submitTimeError=__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].emptyFields(email,password)||__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].emailFull(email)||__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].password(password);errors={};errors.emailError=__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].emptyFields(email)||__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].emailFull(email);errors.passwordError=__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].emptyFields(password)||__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].password(password);if(!submitTimeError){_context.next=10;break;}_this.setState(errors);return _context.abrupt("return");case 10:_this.setState({pending:"host"});credentials=__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.stringify({email:email,password:password,locale:locale});_context.prev=12;_context.next=15;return _this.props.fetch("/auth-user?"+credentials,{unstable_dontInferResponse:true});case 15:response=_context.sent;_this.setState({pending:null});_context.t0=response.status;_context.next=_context.t0==="OK"?20:_context.t0==="ERROR"?25:27;break;case 20:_this.props.dispatch({type:"REQUEST_PROFILE"});Object(__WEBPACK_IMPORTED_MODULE_20__Scorpion__["a" /* submitAppsFlyerParameters */])();// Операции запрашиваются при подключении к сокету,
// а сокет подключается при логине, т.е. нет смысла запрашивать ещё раз
// this.props.dispatch({ type: "REQUEST_DEAL_HISTORY" });
if(!_this.props.noRedirect){query=__WEBPACK_IMPORTED_MODULE_2_querystring___default.a.parse(window.location.search.substring(1));if(!query.redirect){_this.props.history.push("/trade");}}useNativeInterface("setUserKey",response.user_key);return _context.abrupt("break",28);case 25:if(response.must_confirm_phone){// this.props.onLeave(PHONE_CONFIRM_TAB_ID);
}else{_this.setState({responseTimeError:response.message});}return _context.abrupt("break",28);case 27:return _context.abrupt("break",28);case 28:_context.next=33;break;case 30:_context.prev=30;_context.t1=_context["catch"](12);console.error(_context.t1);case 33:case"end":return _context.stop();}}},_callee,_this2,[[12,30]]);}));return function(_x2){return _ref13.apply(this,arguments);};}(),_this.handleInputChange=function(event){var _this$setState;_this.setState((_this$setState={},_defineProperty(_this$setState,event.target.name+"Error",null),_defineProperty(_this$setState,"submitTimeError",null),_defineProperty(_this$setState,"responseTimeError",null),_this$setState));_this.props.onInputChange(event);},_this.socialAuthGate=function(network,event){//для веб-вью приложения авторизация через FB SDK, которую делает Малышев и редиректит с токеном фб на бэк, где получает наш токен и редиректит на платформу с этим токеном, где авторизуется.
if(network==="fb"){if(isAndroidAppMessagingAvailable()){event.preventDefault();window.nativeInterface.onFacebookLoginClick();}else if(isIOSAppMessagingAvailable()){event.preventDefault();window.webkit.messageHandlers["nativeInterface"].postMessage(JSON.stringify({function:"onFacebookLoginClick"}));}}_this.setState({pending:network});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LoginMain,[{key:"render",value:function render(){var _this3=this;var _props=this.props,email=_props.email,password=_props.password,notification=_props.notification,notificationType=_props.notificationType,showSocial=_props.showSocial,isDarkPage=_props.isDarkPage;var _state=this.state,pending=_state.pending,emailError=_state.emailError,passwordError=_state.passwordError,submitTimeError=_state.submitTimeError,responseTimeError=_state.responseTimeError;var inputTimeError=__WEBPACK_IMPORTED_MODULE_17__validators__["a" /* default */].email(email);var tabs=__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TabContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Tab__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_8__Auth__["c" /* REGISTER_TAB_ID */],isActive:false,onClick:function onClick(){return _this3.props.onLeave(__WEBPACK_IMPORTED_MODULE_8__Auth__["c" /* REGISTER_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Registration")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Tab__["a" /* default */],{id:__WEBPACK_IMPORTED_MODULE_8__Auth__["a" /* LOGIN_TAB_ID */],isActive:true},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Log in")));return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,!isIronForm&&tabs,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__StyledComponents_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("form",{action:"#",method:"post"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("div",null,isIronForm&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](WelcomeText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Welcome back")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](FormText,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Sign in to your account"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{type:"email",name:"email",placeholder:this.props.gettext(_templateObject18),id:"login-email",onChange:this.handleInputChange,value:email,autocomplete:"email"}),emailError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ErrorMessage__["a" /* default */],{message:emailError}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("input",{className:"sp_push_custom_data",type:"hidden",name:"Email",value:email}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{type:"password",name:"password",placeholder:this.props.gettext(_templateObject19),id:"login-pass",onChange:this.handleInputChange,value:password}),passwordError&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ErrorMessage__["a" /* default */],{message:passwordError}),responseTimeError?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ErrorMessage__["a" /* default */],{message:responseTimeError}):submitTimeError?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ErrorMessage__["a" /* default */],{message:submitTimeError}):notification?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Message__["a" /* default */],{notification:notification,notificationType:notificationType,toggleTab:this.props.onLeave}):inputTimeError?__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ErrorMessage__["a" /* default */],{message:inputTimeError}):null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SubmitContainer,{showSocial:showSocial},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__BtnFormSubmit__["a" /* default */],{id:"login",onClick:this.login,loader:pending==="host"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"login"))," ",(showSocial||isIronForm)&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Or login with"))," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SocialLink__["a" /* default */],{network:"fb",pending:pending==="fb",href:Object(__WEBPACK_IMPORTED_MODULE_18__loginWith__["a" /* default */])("fb",this.props),onClick:function onClick(event){return _this3.socialAuthGate("fb",event);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__SocialLink__["a" /* default */],{network:"gp",pending:pending==="gp",href:Object(__WEBPACK_IMPORTED_MODULE_18__loginWith__["a" /* default */])("gp",this.props),onClick:function onClick(event){return _this3.socialAuthGate("gp",event);}}))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ForgotContainer,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ForgotLink,{onClick:function onClick(){return _this3.props.onLeave(__WEBPACK_IMPORTED_MODULE_8__Auth__["b" /* PASSWORD_RESTORE_TAB_ID */],"email");}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Forgot password?"))),isIronForm&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SignUpTabBlock,{isDarkPage:isDarkPage},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Don't have an account?")," ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](SignUpTab,{id:__WEBPACK_IMPORTED_MODULE_8__Auth__["c" /* REGISTER_TAB_ID */],isActive:false,onClick:function onClick(){return _this3.props.onLeave(__WEBPACK_IMPORTED_MODULE_8__Auth__["c" /* REGISTER_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Sign up"))))));}}]);return LoginMain;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["g" /* withGettext */])(Object(__WEBPACK_IMPORTED_MODULE_6__common_fetch__["h" /* withFetch */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(LoginMain))));

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getPhoneExample */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ErrorMessage__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BtnFormSubmit__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ReVerification_style__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ReVerification_Icons__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StyledComponents_Container__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StyledComponents_FakeLink__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__validators__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Input__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Auth__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ReVerification_Phone_PhoneInput__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__ = __webpack_require__(4);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  padding: 20px 20px 9px 20px;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 34px;\n  color: #fff;\n\n  @media (max-width: 360px) {\n    font-size: 20px;\n    line-height: 28px;\n  }\n"],["\n  direction: ",";\n  padding: 20px 20px 9px 20px;\n  margin: 0;\n  font-size: 21px;\n  font-weight: 300;\n  line-height: 34px;\n  color: #fff;\n\n  @media (max-width: 360px) {\n    font-size: 20px;\n    line-height: 28px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  padding: 11px 0;\n  "," position: relative;\n  text-align: center;\n  vertical-align: middle;\n"],["\n  padding: 11px 0;\n  "," position: relative;\n  text-align: center;\n  vertical-align: middle;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-top: 10px;\n  font-size: ",";\n  color: #fff;\n  line-height: 1;\n  ",";\n"],["\n  margin-top: 10px;\n  font-size: ",";\n  color: #fff;\n  line-height: 1;\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      font-size: ",";\n      text-align: center;\n      line-height: 1.2;\n      font-weight: bold;\n      color: ",";\n    "],["\n      font-size: ",";\n      text-align: center;\n      line-height: 1.2;\n      font-weight: bold;\n      color: ",";\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  text-decoration: none !important;\n  color: "," !important;\n  transition: all 0.2s ease;\n  font-size: ",";\n  line-height: 1;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n  cursor: pointer;\n\n  ",";\n"],["\n  text-decoration: none !important;\n  color: "," !important;\n  transition: all 0.2s ease;\n  font-size: ",";\n  line-height: 1;\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c !important;\n  }\n  cursor: pointer;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      color: "," !important;\n      &:hover {\n        color: #ffffff !important;\n      }\n    "],["\n      color: "," !important;\n      &:hover {\n        color: #ffffff !important;\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"],["\n  display: flex;\n  justify-content: center;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: block;\n  margin: 0 auto;\n  padding: 0;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: ",";\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  ",";\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c;\n    text-decoration: none;\n  }\n"],["\n  display: block;\n  margin: 0 auto;\n  padding: 0;\n  font-size: ",";\n  line-height: 1.2;\n  text-decoration: none;\n  color: ",";\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n\n  ",";\n\n  :hover,\n  :active,\n  :focus {\n    color: #ffc54c;\n    text-decoration: none;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n      font-size: ",";\n      text-decoration: underline;\n    "],["\n      font-size: ",";\n      text-decoration: underline;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n  }\n"],["\n  position: relative;\n  width: 100%;\n\n  @media (max-width: 959px) {\n    display: flex;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  padding: 4px 0;\n  position: relative;\n\n  ",";\n"],["\n  padding: 4px 0;\n  position: relative;\n\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n      padding: 9px 0;\n    "],["\n      padding: 9px 0;\n    "]),_templateObject13=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 4px 0;\n\n  ",";\n"],["\n  direction: ",";\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  margin: 4px 0;\n\n  ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n      margin: 9px 0;\n    "],["\n      margin: 9px 0;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  margin-bottom: 8px;\n  padding: 27px 20px 20px 30px;\n  background: #ebebeb;\n  border-radius: 4px;\n\n  :after {\n    top: 100%;\n    left: 18px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(235, 235, 235, 0);\n    border-top-color: #ebebeb;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n"],["\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  width: 100%;\n  margin-bottom: 8px;\n  padding: 27px 20px 20px 30px;\n  background: #ebebeb;\n  border-radius: 4px;\n\n  :after {\n    top: 100%;\n    left: 18px;\n    border: solid transparent;\n    content: \" \";\n    height: 0;\n    width: 0;\n    position: absolute;\n    pointer-events: none;\n    border-color: rgba(235, 235, 235, 0);\n    border-top-color: #ebebeb;\n    border-width: 8px;\n    margin-left: -8px;\n  }\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 16px;\n  min-width: 16px;\n  margin-right: 7px;\n  top: 10px;\n  left: 9px;\n"],["\n  position: absolute;\n  width: 16px;\n  min-width: 16px;\n  margin-right: 7px;\n  top: 10px;\n  left: 9px;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 14px;\n  color: #343434;\n  text-align: left;\n"],["\n  font-size: ",";\n  line-height: 14px;\n  color: #343434;\n  text-align: left;\n"]),_templateObject18=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 11px;\n  height: 11px;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  width: 11px;\n  height: 11px;\n  cursor: pointer;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  @media (max-width: 767px) {\n    :first-of-type {\n      margin-bottom: 4px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex: 1;\n    flex-basis: 50%;\n    max-width: 220px;\n  }\n"],["\n  @media (max-width: 767px) {\n    :first-of-type {\n      margin-bottom: 4px;\n    }\n  }\n\n  @media (min-width: 768px) {\n    flex: 1;\n    flex-basis: 50%;\n    max-width: 220px;\n  }\n"]),_templateObject20=_taggedTemplateLiteral(["Email"],["Email"]),_templateObject21=_taggedTemplateLiteral(["Phone"],["Phone"]),_templateObject22=_taggedTemplateLiteral(["Enter code"],["Enter code"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].p(_templateObject,function(props){return props.theme.direction;});var SubmitContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2,""/* height: 68px; */);var BackContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(15),function(_ref){var theme=_ref.theme,isDarkPage=_ref.isDarkPage;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(18),isDarkPage?"#ffffff":"rgba(34, 34, 34, 0.59)");});var BackToLogin=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_11__StyledComponents_FakeLink__["a" /* default */])(_templateObject5,function(_ref2){var theme=_ref2.theme;return theme.accent;},Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(18),function(_ref3){var theme=_ref3.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6,theme.accent);});var SuppurLinkContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7);var SupportLink=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_12__common_Link__["a" /* Link */])(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(14),function(_ref4){var theme=_ref4.theme;return theme.accent;},function(_ref5){var theme=_ref5.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(18));});var PhoneFieldContainer=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__ReVerification_style__["b" /* FieldContainer */])(_templateObject10);var InputContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject11,function(_ref6){var theme=_ref6.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject12);});var PhoneContainer=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(InputContainer)(_templateObject13,function(_ref7){var theme=_ref7.theme;return theme.direction;},function(_ref8){var theme=_ref8.theme;return theme.newIndex&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject14);});var PhoneInfo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject15);var IconContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject16);var InfoText=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_17__common_styled_mixins__["a" /* fontSize */])(12));var CloseInfo=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject18);var PhoneInputContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject19);var EmailRestorePassword=function EmailRestorePassword(_ref9){var restore=function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(event){var submitTimeError,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:event.preventDefault();submitTimeError=__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].emptyFields(email)||__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].emailFull(email);if(!submitTimeError){_context.next=5;break;}setSubmitTimeError(submitTimeError);return _context.abrupt("return");case 5:setPending(true);data=JSON.stringify({type:"email",data:{email:email}});_context.prev=7;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/send-restore?locale="+locale,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:data});case 10:response=_context.sent;setPending(false);_context.t0=response.status;_context.next=_context.t0==="OK"?15:_context.t0==="ERROR"?18:20;break;case 15:props.onNotification(response.message,"restorePasswordWithEmail");props.onLeave(__WEBPACK_IMPORTED_MODULE_15__Auth__["a" /* LOGIN_TAB_ID */]);return _context.abrupt("break",21);case 18:setResponseTimeError(response.message);return _context.abrupt("break",21);case 20:return _context.abrupt("break",21);case 21:_context.next=26;break;case 23:_context.prev=23;_context.t1=_context["catch"](7);console.error(_context.t1);case 26:case"end":return _context.stop();}}},_callee,this,[[7,23]]);}));return function restore(_x){return _ref10.apply(this,arguments);};}();var email=_ref9.email,locale=_ref9.locale,isDarkPage=_ref9.isDarkPage,props=_objectWithoutProperties(_ref9,["email","locale","isDarkPage"]);var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),pending=_useState2[0],setPending=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),submitTimeError=_useState4[0],setSubmitTimeError=_useState4[1];var _useState5=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState6=_slicedToArray(_useState5,2),responseTimeError=_useState6[0],setResponseTimeError=_useState6[1];function handleInputChange(event){setSubmitTimeError(null);setResponseTimeError(null);props.onInputChange(event);}var inputTimeError=__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].email(email);var errorMessage=responseTimeError||submitTimeError||inputTimeError;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledComponents_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{action:"#",method:"post",id:"restoreForm"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Please enter your email. We will send you a password recovery link to this address."))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{type:"email",name:"email",id:"login-email2",required:"required",placeholder:props.gettext(_templateObject20),onChange:handleInputChange,value:email}),errorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorMessage__["a" /* default */],{message:errorMessage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubmitContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BtnFormSubmit__["a" /* default */],{id:"restore",onClick:restore,loader:pending},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Restore password"))),"irontrade"!=="eztrader"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SuppurLinkContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SupportLink,{to:"/helpdesk/contacts"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Email support"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BackContainer,{isDarkPage:isDarkPage},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Already have an account? Then")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BackToLogin,{onClick:function onClick(){return props.onLeave(__WEBPACK_IMPORTED_MODULE_15__Auth__["a" /* LOGIN_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"login")))));};function getPhoneExample(telCountry,apiCountries){var phoneExample=void 0;if(telCountry){var apiCountry=apiCountries.find(function(country){return country.code.toUpperCase()===telCountry.code.toUpperCase();});phoneExample=apiCountry&&apiCountry["phone-number"];var code="+"+telCountry.phoneCode;if(phoneExample&&phoneExample.indexOf(code)>-1){phoneExample=phoneExample.slice(code.length).trim();}}return phoneExample;}var SMSRestorePassword=function SMSRestorePassword(_ref11){var submitPhoneNumber=function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(event){var phoneCode,submitTimeError,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:event.preventDefault();phoneCode=telCountry&&telCountry.phoneCode;if(phoneCode){tel=Object(__WEBPACK_IMPORTED_MODULE_16__ReVerification_Phone_PhoneInput__["e" /* ripOffLeadingZero */])(phoneCode,tel);}submitTimeError=__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].emptyFields(tel)||__WEBPACK_IMPORTED_MODULE_13__validators__["a" /* default */].tel(tel);if(!submitTimeError){_context2.next=7;break;}setSubmitTimeError(submitTimeError);return _context2.abrupt("return");case 7:setPending(true);data=JSON.stringify({type:"phone",data:{phone:tel}});_context2.prev=9;_context2.next=12;return Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/send-restore?locale="+locale,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:data});case 12:response=_context2.sent;setPending(false);_context2.t0=response.status;_context2.next=_context2.t0==="OK"?17:_context2.t0==="ERROR"?19:21;break;case 17:setStep("code");return _context2.abrupt("break",22);case 19:setTelError(response.payload.msg);return _context2.abrupt("break",22);case 21:return _context2.abrupt("break",22);case 22:_context2.next=27;break;case 24:_context2.prev=24;_context2.t1=_context2["catch"](9);console.error(_context2.t1);case 27:case"end":return _context2.stop();}}},_callee2,this,[[9,24]]);}));return function submitPhoneNumber(_x2){return _ref12.apply(this,arguments);};}();var submitSmsCode=function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(event){var submitTimeError,data,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:event.preventDefault();submitTimeError=smsCode==null;if(!submitTimeError){_context3.next=5;break;}setSubmitTimeError(submitTimeError);return _context3.abrupt("return");case 5:setPending(true);data=JSON.stringify({type:"sms-code",data:{phone:tel,code:smsCode}});_context3.prev=7;_context3.next=10;return Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["d" /* get */])("/send-restore?locale="+locale,{method:"POST",headers:{"Content-Type":"application/x-www-form-urlencoded"},body:data});case 10:response=_context3.sent;setPending(false);_context3.t0=response.status;_context3.next=_context3.t0==="OK"?15:_context3.t0==="ERROR"?17:19;break;case 15:onSetRedirect();return _context3.abrupt("break",20);case 17:setCodeError(response.payload.msg);return _context3.abrupt("break",20);case 19:return _context3.abrupt("break",20);case 20:_context3.next=25;break;case 22:_context3.prev=22;_context3.t1=_context3["catch"](7);console.error(_context3.t1);case 25:case"end":return _context3.stop();}}},_callee3,this,[[7,22]]);}));return function submitSmsCode(_x3){return _ref13.apply(this,arguments);};}();var tel=_ref11.tel,email=_ref11.email,locale=_ref11.locale,isDarkPage=_ref11.isDarkPage,onSetRedirect=_ref11.onSetRedirect,props=_objectWithoutProperties(_ref11,["tel","email","locale","isDarkPage","onSetRedirect"]);var _useState7=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])("phone"),_useState8=_slicedToArray(_useState7,2),step=_useState8[0],setStep=_useState8[1];var _useState9=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState10=_slicedToArray(_useState9,2),pending=_useState10[0],setPending=_useState10[1];var _useState11=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState12=_slicedToArray(_useState11,2),submitTimeError=_useState12[0],setSubmitTimeError=_useState12[1];var _useState13=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState14=_slicedToArray(_useState13,2),telCountry=_useState14[0],setTelCountry=_useState14[1];var _useState15=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState16=_slicedToArray(_useState15,2),showPhoneInfo=_useState16[0],setShowPhoneInfo=_useState16[1];var _useState17=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState18=_slicedToArray(_useState17,2),shouldShowPhoneHint=_useState18[0],setShouldShowPhoneHint=_useState18[1];var _useState19=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState20=_slicedToArray(_useState19,2),telError=_useState20[0],setTelError=_useState20[1];var _useState21=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(""),_useState22=_slicedToArray(_useState21,2),smsCode=_useState22[0],setSmsCode=_useState22[1];var _useState23=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState24=_slicedToArray(_useState23,2),codeError=_useState24[0],setCodeError=_useState24[1];function handlePhoneInputChange(event){setTelError(null);setSubmitTimeError(null);props.onPhoneInputChange(event);}function handleSmsCodeInput(event){setCodeError(null);setSubmitTimeError(null);setSmsCode(event.target.value);}function handleInputChange(event){setTelError(null);setSubmitTimeError(null);props.onInputChange(event);}var phoneExample=getPhoneExample(telCountry,props.apiCountries);var telErrorMessage=submitTimeError||telError;var codeErrorMessage=submitTimeError||codeError;return step==="phone"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledComponents_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{action:"#",method:"post",id:"restoreForm"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Please enter your phone number, and we will send you a password recovery code."))),__WEBPACK_IMPORTED_MODULE_7__FeatureFlags__["a" /* default */].useCoolPhoneInputOnAuth?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PhoneFieldContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PhoneContainer,null,showPhoneInfo&&shouldShowPhoneHint&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(PhoneInfo,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(IconContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ReVerification_Icons__["a" /* InfoIcon */],null)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(InfoText,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ReVerification_Phone_PhoneInput__["a" /* PhoneInputHint */],{countryCode:telCountry&&telCountry.code,phoneExample:phoneExample})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(CloseInfo,{onClick:function onClick(){return setShowPhoneInfo(false);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"4454.792 3403.601 10.606 10.607"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate(3350 3251)"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{width:"1",height:"14",fill:"#b5b5b5",transform:"translate(1114.691 152.601) rotate(45)"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{width:"1",height:"14",fill:"#b5b5b5",transform:"translate(1115.398 162.5) rotate(135)"}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ReVerification_Phone_PhoneInput__["b" /* default */],{SelectContainer:PhoneInputContainer,InputContainer:PhoneInputContainer,defaultCountry:props.geo,value:tel,onChange:function onChange(_ref14){var country=_ref14.country,phone=_ref14.fullNumber,countryAutoSwitched=_ref14.countryAutoSwitched;handleInputChange({target:{name:"tel",value:phone}});var countryCode=telCountry&&telCountry.code;var shouldShowHint=countryAutoSwitched?false:shouldShowPhoneHint;if(!countryAutoSwitched&&country.code!==countryCode){shouldShowHint=true;}setTelCountry(country);setShouldShowPhoneHint(shouldShowHint);},errorMessage:telErrorMessage,placeholder:props.gettext(_templateObject21),showInfo:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__ReVerification_Phone_PhoneInput__["a" /* PhoneInputHint */],null),onFocus:function onFocus(){return setShowPhoneInfo(true);},onBlur:function onBlur(){return setShowPhoneInfo(false);}}))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{tab:"register",type:"tel",name:"tel",id:"register-phone",required:"required",placeholder:props.gettext(_templateObject21),value:tel,onChange:handlePhoneInputChange,autocomplete:"tel"}),telErrorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorMessage__["a" /* default */],{message:telErrorMessage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubmitContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BtnFormSubmit__["a" /* default */],{id:"restore",onClick:function onClick(e){return submitPhoneNumber(e);},loader:pending},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Restore password"))),"irontrade"!=="eztrader"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SuppurLinkContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SupportLink,{to:"/helpdesk/contacts"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Email support"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BackContainer,{isDarkPage:isDarkPage},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Already have an account? Then")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BackToLogin,{onClick:function onClick(){return props.onLeave(__WEBPACK_IMPORTED_MODULE_15__Auth__["a" /* LOGIN_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"login"))))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__StyledComponents_Container__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{action:"#",method:"post",id:"restoreForm"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Please, enter the verification code!"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Input__["a" /* default */],{tab:"sms-code",type:"number",name:"smscode",id:"smscode",required:"required",placeholder:props.gettext(_templateObject22),value:smsCode,onChange:handleSmsCodeInput}),codeErrorMessage&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ErrorMessage__["a" /* default */],{message:codeErrorMessage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SubmitContainer,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__BtnFormSubmit__["a" /* default */],{id:"restore",onClick:function onClick(e){return submitSmsCode(e);},loader:pending},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Submit"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BackContainer,{isDarkPage:isDarkPage},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Already have an account? Then")," "),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(BackToLogin,{onClick:function onClick(){return props.onLeave(__WEBPACK_IMPORTED_MODULE_15__Auth__["a" /* LOGIN_TAB_ID */]);}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"login")))));};var RestorePassword=function RestorePassword(props){var _useState25=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(false),_useState26=_slicedToArray(_useState25,2),redirect=_useState26[0],setRedirect=_useState26[1];function onSetRedirect(){setRedirect(true);}if(redirect){window.location.href=window.location.origin+"/password-update";}switch(props.restoreType){case"email":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(EmailRestorePassword,props);case"phone":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(SMSRestorePassword,Object.assign({onSetRedirect:onSetRedirect},props));default:return null;}};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__common_fetch__["h" /* withFetch */])(Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["g" /* withGettext */])(RestorePassword)));

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_phone_number_input_build_country_names__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_phone_number_input_build_country_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_phone_number_input_build_country_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Flag__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProjectTitle__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_BlockedCountry_png__ = __webpack_require__(1640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_BlockedCountry_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_BlockedCountry_png__);
var _templateObject=_taggedTemplateLiteral(["\n  display: table;\n  text-align: center;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  max-width: 450px;\n  // padding: 20px 0;\n  margin: auto;\n"],["\n  display: table;\n  text-align: center;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n  border-radius: 5px;\n  max-width: 450px;\n  // padding: 20px 0;\n  margin: auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n"],["\n  display: table-cell;\n  vertical-align: middle;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  max-width: 580px;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 30px 20px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: normal;\n\n  @media (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: 280px;\n  }\n\n  @media (max-width: 360px) {\n    max-width: 240px;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  max-width: 580px;\n  margin: 0 auto;\n  background-color: #fff;\n  border-radius: 5px;\n  padding: 30px 20px;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: normal;\n\n  @media (max-width: 768px) {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    max-width: 280px;\n  }\n\n  @media (max-width: 360px) {\n    max-width: 240px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  padding-top: 25px;\n  color: #e74c3c;\n  font-size: 20px;\n  font-weight: 700;\n"],["\n  padding-top: 25px;\n  color: #e74c3c;\n  font-size: 20px;\n  font-weight: 700;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-size: 20px;\n  color: #343434;\n"],["\n  padding-top: 10px;\n  padding-bottom: 10px;\n  font-size: 20px;\n  color: #343434;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  color: #95989a;\n  font-size: ",";\n  line-height: 1.4;\n"],["\n  color: #95989a;\n  font-size: ",";\n  line-height: 1.4;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #3598db;\n"],["\n  font-size: ",";\n  color: #3598db;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var countryList=__WEBPACK_IMPORTED_MODULE_2_react_phone_number_input_build_country_names___default.a.reduce(function(res,country){res[country[0]]=country[1];return res;},{});var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var PopupInner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var WarnSection=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Red=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Contact=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var A=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].a(_templateObject7,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var BlockedCountry=function BlockedCountry(props){var countryFlag=props.country&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,countryList[props.country.toLowerCase()],"\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Flag__["h" /* default */],{country:props.country.toLowerCase()}));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Popup,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopupInner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WarnSection,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_6__images_BlockedCountry_png___default.a,alt:""}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Red,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Attention!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Dear user, ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ProjectTitle__["a" /* default */],null)," is unavailable in your country.")),props.country&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Your country: ",countryFlag)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Contact,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The financial services on this website are not available to the residents of the following countries: USA, Canada, European Economic Area, Russia, Switzerland, Israel, New Zealand, Australia, Japan, North Korea, Puerto Rico, Sudan, Iran, Liberia, Pakistan, Syria.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Contact,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"If you think you see this message by mistake, please contact us at ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(A,{href:"mailto:"+props.email},props.email))))));};/* harmony default export */ __webpack_exports__["a"] = (BlockedCountry);

/***/ }),
/* 1640 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_fetch__ = __webpack_require__(9);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function PhoneErrorsLogger(Component){var PhoneErrorsLoggerHOC=function(_React$Component){_inherits(PhoneErrorsLoggerHOC,_React$Component);function PhoneErrorsLoggerHOC(){var _ref;var _temp,_this,_ret;_classCallCheck(this,PhoneErrorsLoggerHOC);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=PhoneErrorsLoggerHOC.__proto__||Object.getPrototypeOf(PhoneErrorsLoggerHOC)).call.apply(_ref,[this].concat(args))),_this),_this.query=function(data){var filtered_input=data.filtered_input,user_input=data.user_input,error_msg=data.error_msg,source=data.source,phone_example=data.phone_example;var params=[];filtered_input&&params.push("filtered_input="+encodeURIComponent(filtered_input));user_input&&params.push("user_input="+encodeURIComponent(user_input));error_msg&&params.push("error_msg="+encodeURIComponent( true?"Iron ":"Siam "+error_msg));source&&params.push("source="+encodeURIComponent(source));phone_example&&params.push("phone_example="+encodeURIComponent(phone_example));if(!params.length)return null;return _this.props.fetch("/api/stat/track-phone-error?"+params.join("&"),{unstable_dontInferResponse:true});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(PhoneErrorsLoggerHOC,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Component,Object.assign({},this.props,{logPhoneErrors:this.query}));}}]);return PhoneErrorsLoggerHOC;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);return Object(__WEBPACK_IMPORTED_MODULE_1__common_fetch__["h" /* withFetch */])(PhoneErrorsLoggerHOC);}/* harmony default export */ __webpack_exports__["a"] = (PhoneErrorsLogger);

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var DefaultState={graphicalTool:null};function setGraphicalMode(state,payload){return{graphicalTool:payload};}function graphicalMode(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:DefaultState;var action=arguments[1];switch(action.type){case"SET_GRAPHICAL_MODE":return setGraphicalMode(state,action.payload);case"PUSH_GRAPHICAL_TOOL":return{graphicalTool:null};default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (graphicalMode);

/***/ }),
/* 1643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function stockCategories(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"RECEIVE_STOCK_ASSETS":return Object.keys(action.payload||{});default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (stockCategories);

/***/ }),
/* 1644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function receiveSocketMessage(state,payload){switch(payload.op){case"operationClosed":return[].concat(_toConsumableArray(state),[{payload:payload,isDismissed:false}]);case"tournamentOperationClosed":return[].concat(_toConsumableArray(state),[{payload:payload,isDismissed:false,isTournament:true}]);default:return state;}}function dismiss(state,id){return state.map(function(news){return news.payload.id===id?Object.assign({},news,{isDismissed:true}):news;});}function news(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);case"DISMISS_NEWS":return dismiss(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (news);

/***/ }),
/* 1645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// Настройки UI, индикаторы на графике
var initialState={currentBid:1000,currentInterval:null,lineColor:"#00cbfe",lineThickness:2,interval:10,language:"en",sound:false,timeSpan:120*1000,indicators:[],graphicalTools:{},chartType:"line",sentiments:true,theme: true?"light":"default",tournamentsPerPage:10,mode:"binary",showAboutTournaments:true};// Настройки, которые мы храним
function toggleIndicator(state,index){return Object.assign({},state,{indicators:state.indicators.map(function(indicator,id){if(id===index){return Object.assign({},indicator,{// Use direct assertion to false because enabled can be undefined
// in which case the toggle would be displayed as Enabled
enabled:indicator.enabled===false?true:false});}return indicator;})});}function removeIndicator(state,index){return Object.assign({},state,{indicators:state.indicators.filter(function(_,i){return i!==index;})});}function updateSettings(state,payload){return Object.assign({},state,payload);}function updateInterval(state,payload){return Object.assign({},state,{currentInterval:state.currentInterval||payload.defaultInterval});}function receiveSocketMessage(state,message){if(message.op==="tournament-status-change"&&message.status==="ended"){return Object.assign({},state,{mode:"binary"});}return state;}function pushGraphicalTool(state,payload){var newState=Object.assign({},state);if(!newState.graphicalTools){newState.graphicalTools={};}if(!newState.graphicalTools[payload.stock]){newState.graphicalTools[payload.stock]={enabled:true,tools:[]};}var newStockTools=[].concat(_toConsumableArray(newState.graphicalTools[payload.stock].tools));newStockTools.push(payload);newState.graphicalTools[payload.stock].tools=newStockTools;// Turn tools on so user can see the result of their actions
newState.graphicalTools[payload.stock].enabled=true;return newState;}function updateGraphicalTool(state,payload){var newState=Object.assign({},state);var newStockTools=[].concat(_toConsumableArray(newState.graphicalTools[payload.stock].tools));// Reset tool's visibility so user can see the result of their actions
var newPayload=Object.assign({},payload,{enabled:payload.enabled===newStockTools[payload.index].enabled?true:payload.enabled});newStockTools[payload.index]=Object.assign({},newStockTools[payload.index],newPayload);newState.graphicalTools[payload.stock].tools=newStockTools;// Turn tools on so user can see the result of their actions
newState.graphicalTools[payload.stock].enabled=true;return newState;}function removeGraphicalTool(state,payload){var newState=Object.assign({},state);var newStockTools=[].concat(_toConsumableArray(newState.graphicalTools[payload.stock].tools));newStockTools.splice(payload.index,1);newState.graphicalTools[payload.stock].tools=newStockTools;return newState;}function purgeGraphicalTools(state,payload){var newState=Object.assign({},state);if(!newState.graphicalTools){newState.graphicalTools={};}if(!newState.graphicalTools[payload.activeStock]){return state;}newState.graphicalTools[payload.activeStock].tools=[];delete newState.graphicalTools[payload.activeStock];return newState;}function updateGraphicalToolsVisibility(state,payload){var newState=Object.assign({},state);newState.graphicalTools[payload.stock].enabled=payload.value;return newState;}function settings(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"DROP_SETTINGS":return Object.assign({},initialState,{theme:"irontrade"==="irontrade"&&action.currency!=="THB"?"light":"default"});case"RECEIVE_SETTINGS":return action.payload;case"UPDATE_SETTINGS":return updateSettings(state,action.payload);case"PUSH_INDICATOR":return Object.assign({},state,{indicators:[].concat(_toConsumableArray(state.indicators),[Object.assign({},action.payload,{enabled:true})])});case"UPDATE_INDICATOR":return Object.assign({},state,{indicators:state.indicators.map(function(indicator,id){return action.payload.id===id?action.payload:indicator;})});case"TOGGLE_INDICATOR":return toggleIndicator(state,action.payload);case"REMOVE_INDICATOR":return removeIndicator(state,action.payload);case"REMOVE_ALL_INDICATORS":return Object.assign({},state,{indicators:[]});case"PUSH_GRAPHICAL_TOOL":return pushGraphicalTool(state,action.payload);case"UPDATE_GRAPHICAL_TOOL":return updateGraphicalTool(state,action.payload);case"REMOVE_GRAPHICAL_TOOL":return removeGraphicalTool(state,action.payload);case"SET_GRAPHICAL_TOOLS_VISIBILITY":return updateGraphicalToolsVisibility(state,action.payload);case"SET_ACTIVE_STOCK":case"CLEAR_GRAPHICAL_TOOLS":return purgeGraphicalTools(state,action.payload);case"RECEIVE_TRADE_SETTINGS":return updateInterval(state,action.payload);case"ENGAGE_TOURNAMENT_MODE":return Object.assign({},state,{mode:"tournament"});case"ENGAGE_BINARY_MODE":return Object.assign({},state,{mode:"binary"});case"SWITCH_ACCOUNTS":return Object.assign({},state,{mode:"binary"});case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),
/* 1646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Настройки, приходящие с сервера
function receiveSocketMessage(state,payload){switch(payload.op){case"stockPush":// Return previous state if socket doesn't support OTC messages yet
if(payload.otc===undefined){return state;}var _isOTC=payload.otc;// Return previous state if OTC haven't change yet
if(state.isOTC===_isOTC){return state;}// Return new state on OTC change
return Object.assign({},state,{isOTC:_isOTC});default:return state;}}// function interceptBids(payload: State) {
//   switch (payload.currency) {
//     case "THB":
//       return {
//         ...payload,
//         percentBids: [1, 2, 3, 4, 5, 10, 15, 25, 50, 100] // проценты
//       };
//     default:
//       return { ...payload, percentBids: null };
//   }
// }
var initialState={defaultInterval:30,isOTC:false,bids:[],currency:"USD",initial:10000,intervals:[],intervalsDemo:[],minFillup:250,rawSymbol:"$",symbol:"$"};function settings(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case"RECEIVE_TRADE_SETTINGS":return action.payload;case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),
/* 1647 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function onSocketMessage(state,payload){if(!state){return state;// return whatever it is
}if(state.id!==payload.user_id){return state;}switch(payload.op){case"turnoverChanged":if(!state.bonus){return state;}return Object.assign({},state,{bonus:Object.assign({},state.bonus,{bonus_sum:payload.turnover===0&&state.bonus.turnover>0?0:state.bonus.bonus_sum,turnover:payload.turnover})});case"statusChanged":// Verification status change
return Object.assign({},state,{status:payload.status});default:return state;}}function settings(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_PROFILE":return action.payload;case"UPDATE_PROFILE":return Object.assign({},state,action.payload);case"UPDATE_LOCALE":return state!=null?Object.assign({},state,{locale:action.payload}):state;case"INVALIDATE_PROFILE":try{var timerView=sessionStorage.getItem("hideBonusTimer");if(timerView!=null){sessionStorage.removeItem("hideBonusTimer");}}catch(error){console.error("SessionStorage: "+error);}return null;case"RECEIVE_SOCKET_MESSAGE":return onSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),
/* 1648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function setState(state,payload){if(payload.op==="phone-confirm-call"){return payload.result?false:true;}return state;}function phoneCallVerification(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case"CLEAR_PHONE_CALL_VERIFICATION":return false;case"SET_PHONE_CALL":return true;case"RECEIVE_SOCKET_MESSAGE":return setState(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (phoneCallVerification);

/***/ }),
/* 1649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_VerificationStatus__ = __webpack_require__(664);
// Кусочек стора, который помогает
// следить за тем, все ли важные
// данные пришли и можно показать
// экран пользователю.
function profileStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"PENDING";var action=arguments[1];switch(action.type){case"REQUEST_PROFILE":case"UPDATE_CURRENCY":return"PENDING";case"RECEIVE_SOCKET_MESSAGE":if(action.payload.op==="phone-confirm-call"&&!action.payload.result||action.payload.op==="user-accounts-updated"||action.payload.op==="statusChanged"&&action.payload.status===__WEBPACK_IMPORTED_MODULE_1__components_VerificationStatus__["b" /* VERIFICATION_STATUS_DECLINED */]){return"PENDING";}else{return state;}case"RECEIVE_PROFILE":return"AVAILABLE";case"INVALIDATE_PROFILE":return"INVALID";default:return state;}}function tradeSettingsStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"PENDING";var action=arguments[1];switch(action.type){case"REQUEST_TRADE_SETTINGS":case"UPDATE_CURRENCY":case"UPDATE_LOCALE":case"REQUEST_PROFILE":return"PENDING";case"RECEIVE_TRADE_SETTINGS":return"AVAILABLE";case"INVALIDATE_TRADE_SETTINGS":return"INVALID";default:return state;}}function serverDataStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"PENDING";var action=arguments[1];switch(action.type){case"REQUEST_SERVER_DATA":case"UPDATE_LOCALE":case"UPDATE_CURRENCY":case"REQUEST_PROFILE":case"INVALIDATE_PROFILE":return"PENDING";case"RECEIVE_SERVER_DATA":return"AVAILABLE";case"INVALIDATE_SERVER_DATA":return"INVALID";default:return state;}}function accountsStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"PENDING";var action=arguments[1];switch(action.type){case"SWITCH_ACCOUNTS":case"REQUEST_ACCOUNTS":case"REQUEST_PROFILE":return"PENDING";case"RECEIVE_SOCKET_MESSAGE":if(action.payload.op==="user-accounts-updated"){return"PENDING";}else{return state;}case"RECEIVE_ACCOUNTS":return"AVAILABLE";case"INVALIDATE_PROFILE":case"INVALIDATE_ACCOUNTS":return"INVALID";default:return state;}}function operationsStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"UNAVAILABLE";var action=arguments[1];switch(action.type){case"SWITCH_ACCOUNTS":case"REQUEST_DEAL_HISTORY":return"PENDING";case"RECEIVE_DEAL_HISTORY":return"AVAILABLE";case"INVALIDATE_DEAL_HISTORY":return"INVALID";case"SOCKET_STATE_CHANGE":return action.payload===WebSocket.OPEN?"PENDING":state;case"RECEIVE_SOCKET_MESSAGE":return action.payload.op==="operationOpened"||action.payload.op==="operationClosed"?"PENDING":state;default:return state;}}function apiConfigsStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"PENDING";var action=arguments[1];switch(action.type){case"REQUEST_API_CONFIGS":return"PENDING";case"RECEIVE_API_CONFIGS":return"AVAILABLE";case"INVALIDATE_API_CONFIGS":return"INVALID";default:return state;}}function apiCountriesStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"UNAVAILABLE";var action=arguments[1];switch(action.type){case"REQUEST_API_COUNTRIES":return"PENDING";case"RECEIVE_API_COUNTRIES":return"AVAILABLE";case"INVALIDATE_API_COUNTRIES":return"INVALID";default:return state;}}function stocksStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"UNAVAILABLE";var action=arguments[1];switch(action.type){case"REQUEST_STOCK_ASSETS":case"SWITCH_ACCOUNTS":return"PENDING";case"RECEIVE_STOCK_ASSETS":return"AVAILABLE";case"INVALIDATE_STOCK_ASSETS":return"INVALID";default:return state;}}function iOSShowDepositStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"PENDING";var action=arguments[1];switch(action.type){case"REQUEST_IOS_SHOW_DEPOSIT":return"PENDING";case"RECEIVE_IOS_SHOW_DEPOSIT":return"AVAILABLE";case"INVALIDATE_IOS_SHOW_DEPOSIT":return"INVALID";default:return state;}}function withdrawOutputMethodsStatus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"UNAVAILABLE";var action=arguments[1];switch(action.type){case"REQUEST_WITHDRAW_OUTPUT_METHODS":return"PENDING";case"RECEIVE_WITHDRAW_OUTPUT_METHODS":return"AVAILABLE";case"INVALIDATE_WITHDRAW_OUTPUT_METHODS":return"INVALID";default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({profile:profileStatus,tradeSettings:tradeSettingsStatus,serverData:serverDataStatus,accounts:accountsStatus,operations:operationsStatus,apiConfigs:apiConfigsStatus,apiCountries:apiCountriesStatus,stocks:stocksStatus,iOSShowDeposit:iOSShowDepositStatus,withdrawOutputMethods:withdrawOutputMethodsStatus}));

/***/ }),
/* 1650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function receiveSocketMessage(state,payload){if(payload.op==="operationClosed"||payload.op==="operationOpened"){var accountType=payload.real===1?"real":"demo";var account=state.find(function(a){return a.type===accountType;});if(account==null){return state;}var nextBalance=payload.op==="operationClosed"?payload.balance.toFixed(2):payload.balance;var nextAccount=Object.assign({},account,{balance:nextBalance,estimatedBalance:nextBalance});return[].concat(_toConsumableArray(state.filter(function(a){return a!==account;})),[nextAccount]);}else if(payload.op==="deposit-bonus-inserted"){// Мы же не даём бонусы демо аккаунтам? Было бы странно
var _account=state.find(function(a){return a.type==="real";});if(_account==null){return state;}var _nextBalance=(parseFloat(_account.balance)+payload.amount).toFixed(2);var _nextAccount=Object.assign({},_account,{balance:_nextBalance,estimatedBalance:_nextBalance});return[].concat(_toConsumableArray(state.filter(function(a){return a!==_account;})),[_nextAccount]);}return state;}function requestDealOpening(state,payload){if(payload.accountType){var account=state.find(function(a){return a.type===payload.accountType;});if(account==null){return state;}var _estimatedBalance=parseFloat(account.estimatedBalance);var nextEstimatedBalance=_estimatedBalance-payload.amount;var nextAccount=Object.assign({},account,{estimatedBalance:nextEstimatedBalance.toFixed(2)});return[].concat(_toConsumableArray(state.filter(function(a){return a!==account;})),[nextAccount]);}return state;}function accounts(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_ACCOUNTS":return action.payload.map(function(account){return Object.assign({},account,{estimatedBalance:account.balance});});case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);case"REQUEST_DEAL_OPENING":return requestDealOpening(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (accounts);

/***/ }),
/* 1651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function serverData(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_SERVER_DATA":return Object.assign({},state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (serverData);

/***/ }),
/* 1652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function time(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:0;var action=arguments[1];if(action.type==="RECEIVE_SOCKET_MESSAGE"&&action.payload.op==="stockPush"){return action.payload.serverTime*1000;}return state;}/* harmony default export */ __webpack_exports__["a"] = (time);

/***/ }),
/* 1653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function receiveSocketMessage(state,payload){switch(payload.op){case"statPush_go":return Object.assign({},state,_defineProperty({},payload.stock,payload));default:return state;}}function stats(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (stats);

/***/ }),
/* 1654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function dictionaries(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"RECEIVE_DICTIONARY":return Object.assign({},state,_defineProperty({},action.payload.locale,action.payload.dictionary));default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (dictionaries);

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function receiveSocketMessage(state,payload){switch(payload.op){case"deposit-bonus-inserted":return payload;default:return state;}}function referralBonus(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);case"DISMISS_REFERRAL_BONUS":return null;default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (referralBonus);

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function apiConfigs(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_API_CONFIGS":return action.payload;default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (apiConfigs);

/***/ }),
/* 1657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function apiCountries(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"RECEIVE_API_COUNTRIES":return action.payload;default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (apiCountries);

/***/ }),
/* 1658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function fallbackLocale(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var action=arguments[1];switch(action.type){case"UPDATE_LOCALE":return action.payload;default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (fallbackLocale);

/***/ }),
/* 1659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__ = __webpack_require__(1660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_uniq__);
function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var initialState={watchedVideos:[],pages:[],sections:[],news:null,search:null,search_loading:true};function remakeSlug(page){var id=page.id,blocks=page.blocks,slug=page.slug;var remadeBlocks=blocks.reduce(function(obj,block){var sections=obj.sections,blocks=obj.blocks;var section=block.section;// если секция есть
if(section!=null&&section.key!=null){if(section.title==="\""){var firstLetter=block.title[1];section.key="KB_"+firstLetter;section.title=firstLetter;section.subject="KB_"+firstLetter;}// проверяем, есть ли она уже
var doesSectionExist=!!sections.find(function(existing){return existing.key===section.key;});// если ее нет - создаем новую и пушим в новую
if(doesSectionExist===false){var _key=section.key||"";var hash="#"+_key.toLowerCase().replace(/\s/g,"");sections.push(Object.assign({},section,{hash:hash,blocks:[block]}));}// если она есть - вычисляем и пушим в имеющуюся
if(doesSectionExist===true){var sectionIdx=__WEBPACK_IMPORTED_MODULE_0_lodash_findIndex___default()(sections,function(o){return o.key===section.key;});sections[sectionIdx]["blocks"].push(block);}}else{// если секции нет
blocks.push(block);}return obj;},{blocks:[],sections:[]});return Object.assign({id:id,slug:slug},remadeBlocks);}function remakeKnowledgeBase(page){var remadePage=remakeSlug(page);function sortContent(a,b){var _ref=[a.title,b.title],titleA=_ref[0],titleB=_ref[1];return titleA.localeCompare(titleB);}var sections=remadePage.sections.sort(sortContent);var sortedSections=sections.reduce(function(acc,section){var sortedBlocks=section.blocks.sort(sortContent);acc.push(Object.assign({},section,{blocks:sortedBlocks}));return acc;},[]);return Object.assign({},remadePage,{sections:sortedSections});}function remakeAllPages(pages){var remadePages=pages.reduce(function(arr,page){var remadeSlug=remakeSlug(page);arr.push(remadeSlug);return arr;},[]);return remadePages;}function receiveWatched(state,payload){var watched=[];try{var data=localStorage.getItem("watchedVideos");if(data){var stored=JSON.parse(data);if(Array.isArray(stored)){watched=stored;}}}catch(err){console.log(err);}var watchedVideos=[].concat(_toConsumableArray(state.watchedVideos),_toConsumableArray(watched));return Object.assign({},state,{watchedVideos:__WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()(watchedVideos)});}function updateWatched(state,payload){var watchedVideos=[].concat(_toConsumableArray(state.watchedVideos),[payload]);return Object.assign({},state,{watchedVideos:__WEBPACK_IMPORTED_MODULE_1_lodash_uniq___default()(watchedVideos)});}function resetAllSlugs(state){return Object.assign({},initialState,{watchedVideos:state.watchedVideos});}function helpdesk(){var _Object$assign;var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];var type=action.type,payload=action.payload;switch(type){case"RECEIVE_HELPDESK_PAGE":return Object.assign({},state,(_Object$assign={},_defineProperty(_Object$assign,payload["slug"],payload["slug"]==="knowledge_base"?remakeKnowledgeBase(payload):remakeSlug(payload)),_defineProperty(_Object$assign,payload["slug"]+"_raw",payload),_Object$assign));case"RECEIVE_HELPDESK_NEWS":return Object.assign({},state,{news:payload});case"RECEIVE_HELPDESK_SEARCH_RESULTS":return Object.assign({},state,{search_loading:false,search:payload});case"INVALIDATE_HELPDESK_SEARCH_RESULTS":return Object.assign({},state,{search_loading:true,search:null});case"RECEIVE_HELPDESK_PAGES":return Object.assign({},state,{pages:remakeAllPages(payload)});case"RECEIVE_HELPDESK_SECTIONS":return Object.assign({},state,{sections:payload});case"RECEIVE_WATCHED_VIDEOS":return receiveWatched(state,payload);case"UPDATE_WATCHED_VIDEOS":return updateWatched(state,payload);case"INVALIDATE_PROFILE":case"UPDATE_LOCALE":return resetAllSlugs(state);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (helpdesk);

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(547),
    baseIteratee = __webpack_require__(422),
    toInteger = __webpack_require__(421);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 1661 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function switchDeposit(payload){switch(payload.value){case 1:return true;case 0:default:return false;}}function iOSShowDeposit(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:false;var action=arguments[1];switch(action.type){case"RECEIVE_IOS_SHOW_DEPOSIT":return switchDeposit(action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (iOSShowDeposit);

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function withdrawOutputMethods(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var action=arguments[1];switch(action.type){case"RECEIVE_WITHDRAW_OUTPUT_METHODS":return action.payload;default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (withdrawOutputMethods);

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = firebaseMessaging;
function firebaseMessaging(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{token:null};var action=arguments[1];switch(action.type){case"PRESERVE_FIREBASE_TOKEN":console.log(action);return{token:action.payload};default:return state;}}

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}// {
//   type: "RECEIVE_SOCKET_MESSAGE",
//   payload: {
//     op: "social_trading",
//     id: 192993939,
//     stock: "EURUSD",
//     user_id: "1***99",
//     isBidUp: true,
//     profit: 900
//   }
// }
function receiveSocketMessage(state,payload){switch(payload.op){case"social_trading":var timestamp=__WEBPACK_IMPORTED_MODULE_0_moment___default()().valueOf();var updatedState=[Object.assign({},payload,{timestamp:timestamp})].concat(_toConsumableArray(state));if(updatedState.length>30){updatedState.length=30;}return updatedState;default:return state;}}function socialTrading(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];var action=arguments[1];switch(action.type){case"RECEIVE_SOCKET_MESSAGE":return receiveSocketMessage(state,action.payload);default:return state;}}/* harmony default export */ __webpack_exports__["a"] = (socialTrading);

/***/ }),
/* 1665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ReferralBonusModal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReferralBonus__ = __webpack_require__(1666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ReferralBonusSlave__ = __webpack_require__(1670);
// Приглашающий и приглашённый.
// Аналогии с рабами и их хозяевами это не окей.
function ReferralBonusModal(props){switch(props.bonus_type){case 0:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1__ReferralBonus__["a" /* default */],props);case 1:return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__ReferralBonusSlave__["a" /* default */],props);default:return null;}}

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_big_coin_png__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_big_coin_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_big_coin_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_over_coin_png__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_over_coin_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_over_coin_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_under_coin_png__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_under_coin_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_under_coin_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  padding: 3.5em 7em 6em;\n\n  @media (max-width: 959px) {\n    padding: 1em 7em 1.75em;\n  }\n"],["\n  padding: 3.5em 7em 6em;\n\n  @media (max-width: 959px) {\n    padding: 1em 7em 1.75em;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 100%;\n  padding-bottom: 0.5em;\n  padding-top: 0.833em;\n  font-weight: 300;\n  font-size: 3em;\n  text-transform: uppercase;\n  color: ",";\n"],["\n  width: 100%;\n  padding-bottom: 0.5em;\n  padding-top: 0.833em;\n  font-weight: 300;\n  font-size: 3em;\n  text-transform: uppercase;\n  color: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  max-width: 22.222em;\n  margin: 0 auto;\n  padding-bottom: 0.833em;\n  font-weight: 500;\n  font-size: 1.8em;\n  color: #717171;\n"],["\n  max-width: 22.222em;\n  margin: 0 auto;\n  padding-bottom: 0.833em;\n  font-weight: 500;\n  font-size: 1.8em;\n  color: #717171;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  direction: ",";\n  max-width: 11.111em;\n  margin: 0 auto;\n  font-weight: 600;\n  font-size: 3.6em;\n  line-height: 1;\n  color: ",";\n"],["\n  direction: ",";\n  max-width: 11.111em;\n  margin: 0 auto;\n  font-weight: 600;\n  font-size: 3.6em;\n  line-height: 1;\n  color: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: 5em;\n  line-height: 1;\n"],["\n  font-size: 5em;\n  line-height: 1;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-weight: 600;\n  color: #3B9478;\n  font-size: 96px;\n"],["\n  font-weight: 600;\n  color: #3B9478;\n  font-size: 96px;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  font-weight: 400;\n  font-size: 0.49em;\n  color: #717171;\n"],["\n  font-weight: 400;\n  font-size: 0.49em;\n  color: #717171;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: inline-block;\n  margin-top: 2.222em;\n  font-weight: 500;\n  font-size: 1.8em;\n  text-decoration: none;\n  color: #3498db;\n\n  :hover {\n    cursor: pointer;\n  }\n"],["\n  display: inline-block;\n  margin-top: 2.222em;\n  font-weight: 500;\n  font-size: 1.8em;\n  text-decoration: none;\n  color: #3498db;\n\n  :hover {\n    cursor: pointer;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["position: absolute;"],["position: absolute;"]),_templateObject10=_taggedTemplateLiteral(["\n  width: 15.4em;\n  height: auto;\n  left: -5.2em;\n  top: -5em;\n\n  @media (max-width: 959px) {\n    width: 16em;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    top: -3.5em;\n  }\n"],["\n  width: 15.4em;\n  height: auto;\n  left: -5.2em;\n  top: -5em;\n\n  @media (max-width: 959px) {\n    width: 16em;\n  }\n  @media (max-width: 959px) and (min-width: 480px) {\n    top: -3.5em;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  width: 7.3em;\n  height: auto;\n  bottom: -2.7em;\n  right: -3.2em;\n"],["\n  width: 7.3em;\n  height: auto;\n  bottom: -2.7em;\n  right: -3.2em;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  width: 10.6em;\n  height: auto;\n  bottom: 3.1em;\n  right: -5.3em;\n  z-index: -1;\n"],["\n  width: 10.6em;\n  height: auto;\n  bottom: 3.1em;\n  right: -5.3em;\n  z-index: -1;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h3(_templateObject2,function(_ref){var theme=_ref.theme;return theme.foreground;});var SubHeading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var InfoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.direction;},function(_ref2){var theme=_ref2.theme;return theme.foreground;});var MoneyContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Value=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */].Value)(_templateObject6);var Currency=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */].Symbol)(_templateObject7);var Link=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Coin=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject9);var CoinBig=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Coin)(_templateObject10);var CoinOver=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Coin)(_templateObject11);var CoinUnder=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Coin)(_templateObject12);var domain= true?"IronTrade":"SiamOption";var ReferralBonus=function(_React$Component){_inherits(ReferralBonus,_React$Component);function ReferralBonus(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,ReferralBonus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=ReferralBonus.__proto__||Object.getPrototypeOf(ReferralBonus)).call.apply(_ref3,[this].concat(args))),_this),_this.handleRedirect=function(){_this.props.onDismiss();if(_this.props.location.match!=="profile"){_this.props.history.push("/profile");}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReferralBonus,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */],{onDismiss:this.props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"referral bonus")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubHeading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Your friend")," ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"has deposited necessary sum")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"You received a bonus"),":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MoneyContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{Value:Value,Symbol:Currency},this.props.amount)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Link,{onClick:this.handleRedirect},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Invite more friends to ",domain)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CoinBig,{src:__WEBPACK_IMPORTED_MODULE_6__images_big_coin_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_6__images_big_coin_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CoinOver,{src:__WEBPACK_IMPORTED_MODULE_7__images_over_coin_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_7__images_over_coin_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CoinUnder,{src:__WEBPACK_IMPORTED_MODULE_8__images_under_coin_png___default.a,alt:__WEBPACK_IMPORTED_MODULE_8__images_under_coin_png___default.a})));}}]);return ReferralBonus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(ReferralBonus));

/***/ }),
/* 1667 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/big-coin.064d8856.png";

/***/ }),
/* 1668 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1669 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_friend_coins_png__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_friend_coins_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_friend_coins_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_friend_coins_mobile_png__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_friend_coins_mobile_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_friend_coins_mobile_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal__ = __webpack_require__(228);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  color: ",";\n  background: ",";\n  z-index: 2000;\n"],["\n  color: ",";\n  background: ",";\n  z-index: 2000;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 0;\n\n  :nth-child(1) {\n    @media (max-width: 959px) {\n      padding-right: 54px;\n    }\n  }\n\n  :nth-child(2) {\n    display: block;\n    padding: 50px 55px 45px;\n    text-align: center;\n    background: ",";\n    border-bottom-right-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  font-size: 0;\n\n  :nth-child(1) {\n    @media (max-width: 959px) {\n      padding-right: 54px;\n    }\n  }\n\n  :nth-child(2) {\n    display: block;\n    padding: 50px 55px 45px;\n    text-align: center;\n    background: ",";\n    border-bottom-right-radius: 5px;\n    border-bottom-left-radius: 5px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  display: inline-block;\n  vertical-align: middle;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: none;\n  vertical-align: middle;\n\n  @media (max-width: 959px) {\n    display: inline-block;\n    width: 100px;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    width: 80px;\n  }\n"],["\n  display: none;\n  vertical-align: middle;\n\n  @media (max-width: 959px) {\n    display: inline-block;\n    width: 100px;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    width: 80px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  direction: ",";\n  display: inline-block;\n  vertical-align: middle;\n  color: ",";\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 1;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n\n  @media (max-width: 850px) {\n    max-width: 270px;\n  }\n"],["\n  direction: ",";\n  display: inline-block;\n  vertical-align: middle;\n  color: ",";\n  font-size: 36px;\n  font-weight: 600;\n  line-height: 1;\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n\n  @media (max-width: 850px) {\n    max-width: 270px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n  display: none;\n  color: ",";\n  align-items: center;\n  flex-direction: column;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 1;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex: 1;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    display: block;\n    margin: 0 auto;\n  }\n"],["\n  direction: ",";\n  display: none;\n  color: ",";\n  align-items: center;\n  flex-direction: column;\n  font-weight: 600;\n  font-size: 24px;\n  line-height: 1;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex: 1;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 360px) {\n    display: block;\n    margin: 0 auto;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  direction: ",";\n  color: ",";\n  font-size: 18px;\n  font-weight: 400;\n\n  @media (max-width: 959px) {\n    font-size: 28px;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: ",";\n  }\n"],["\n  direction: ",";\n  color: ",";\n  font-size: 18px;\n  font-weight: 400;\n\n  @media (max-width: 959px) {\n    font-size: 28px;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: ",";\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  padding-left: 7px;\n  font-weight: 600;\n  font-size: 48px;\n  color: #3B9478;\n\n  @media (max-width: 959px) {\n    color: #363636;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: 24px;\n  }\n"],["\n  padding-left: 7px;\n  font-weight: 600;\n  font-size: 48px;\n  color: #3B9478;\n\n  @media (max-width: 959px) {\n    color: #363636;\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: 24px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  top: -15px;\n  padding-left: 10px;\n  color: #717171;\n  font-size: 24px;\n  font-weight: 500;\n  vertical-align: super;\n\n  @media (max-width: 959px) {\n    top: -10px;\n    padding-left: 2px;\n    font-size: ",";\n    color: #363636;\n  }\n"],["\n  top: -15px;\n  padding-left: 10px;\n  color: #717171;\n  font-size: 24px;\n  font-weight: 500;\n  vertical-align: super;\n\n  @media (max-width: 959px) {\n    top: -10px;\n    padding-left: 2px;\n    font-size: ",";\n    color: #363636;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  margin-top: 20px;\n  color: #3498db;\n  font-size: 18px;\n  font-weight: 400;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: underline;\n  }\n\n  @media (max-width: 959px) {\n    font-size: 32px;\n    text-decoration: underline;\n\n    :hover {\n      text-decoration: none;\n    }\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: 16px;\n    margin-top: 10px;\n  }\n"],["\n  margin-top: 20px;\n  color: #3498db;\n  font-size: 18px;\n  font-weight: 400;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: underline;\n  }\n\n  @media (max-width: 959px) {\n    font-size: 32px;\n    text-decoration: underline;\n\n    :hover {\n      text-decoration: none;\n    }\n  }\n\n  @media (max-width: 640px), (max-height: 500px) {\n    font-size: 16px;\n    margin-top: 10px;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Tooltip=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.foreground;},function(_ref2){var theme=_ref2.theme;return theme.popupBackground;});var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref3){var theme=_ref3.theme;return theme.popupDarkBackground;});var FriendCoins=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject3);var FriendCoinsMobile=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.theme.direction;},function(_ref4){var theme=_ref4.theme;return theme.foreground;});var TitleMobile=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.direction;},function(_ref5){var theme=_ref5.theme;return theme.foreground;});var Subtitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.theme.direction;},function(_ref6){var theme=_ref6.theme;return theme.foreground;},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Amount=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Currency=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */].Symbol)(_templateObject9,function(_ref8){var theme=_ref8.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var Link=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var domain= true?"IronTrade":"SiamOption";var ReferralBonusSlave=function(_React$Component){_inherits(ReferralBonusSlave,_React$Component);function ReferralBonusSlave(){var _ref9;var _temp,_this,_ret;_classCallCheck(this,ReferralBonusSlave);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref9=ReferralBonusSlave.__proto__||Object.getPrototypeOf(ReferralBonusSlave)).call.apply(_ref9,[this].concat(args))),_this),_this.handleRedirect=function(){_this.props.onDismiss();if(_this.props.location.match!=="profile"){_this.props.history.push("/profile");}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReferralBonusSlave,[{key:"render",value:function render(){var _props=this.props,onDismiss=_props.onDismiss,amount=_props.amount,refBonusMinDepo=_props.apiConfigs.refBonusMinDepo,currency=_props.remoteTradeSettings.currency;var minDeposit=refBonusMinDepo[currency];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal__["a" /* default */],{onDismiss:onDismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tooltip,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FriendCoins,{src:__WEBPACK_IMPORTED_MODULE_6__images_friend_coins_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FriendCoinsMobile,{src:__WEBPACK_IMPORTED_MODULE_7__images_friend_coins_mobile_png___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You received a bonus"),":",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Amount,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],{Symbol:Currency},amount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleMobile,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You received a bonus"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],{Symbol:Currency},amount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subtitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"For every friend who signs up using your link and makes a one-time deposit of")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,minDeposit)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"or more in seven days after the registration date, you get"),":",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],null,amount))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{onClick:this.handleRedirect},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Invite more friends to ",domain)))));}}]);return ReferralBonusSlave;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__withData__["a" /* default */])(["apiConfigs","remoteTradeSettings"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(ReferralBonusSlave)));

/***/ }),
/* 1671 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/friend-coins.8c087aef.png";

/***/ }),
/* 1672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/friend-coins-mobile.151ee915.png";

/***/ }),
/* 1673 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1674)();
}


/***/ }),
/* 1674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(1675);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = /*#__PURE__*/function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return /*#__PURE__*/React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1677 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProfilePlease; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DataRequirement__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tournaments_Api__ = __webpack_require__(14);
function _ProfilePlease(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{status:props.statuses.profile,fetch:function fetch(){return props.fetch("/api/profile");},onData:function onData(payload){props.dispatch({type:"RECEIVE_PROFILE",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_PROFILE"});}});}function mapStateToProps(state){return{statuses:state.dataRequirementsStatus};}var ProfilePlease=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_2__common_fetch__["e" /* mapDispatchToFetch */])(_ProfilePlease);function DataPlease(props){var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__Tournaments_Api__["c" /* default */]);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:0,status:props.statuses.serverData,fetch:function fetch(){return props.fetch("/api/server-data");},onData:function onData(payload){props.dispatch({type:"RECEIVE_SERVER_DATA",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_SERVER_DATA"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:2,status:props.statuses.tradeSettings,fetch:function fetch(){return props.fetch("/api/trade-settings");},onData:function onData(payload){props.dispatch({type:"RECEIVE_TRADE_SETTINGS",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_TRADE_SETTINGS"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:3,status:props.statuses.operations,fetch:function fetch(){return props.fetch("/api/operations",{unstable_dontInferResponse:true});},onData:function onData(payload){if(payload.status==="ERROR"){props.dispatch({type:"INVALIDATE_DEAL_HISTORY"});}else{props.dispatch({type:"RECEIVE_DEAL_HISTORY",payload:payload});}},onError:function onError(){props.dispatch({type:"INVALIDATE_DEAL_HISTORY"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:4,status:props.statuses.apiConfigs,fetch:function fetch(){return props.fetch("/api/configs");},onData:function onData(payload){props.dispatch({type:"RECEIVE_API_CONFIGS",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_API_CONFIGS"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:5,status:props.statuses.apiCountries,fetch:function fetch(){return props.fetch("/api/countries");},onData:function onData(payload){props.dispatch({type:"RECEIVE_API_COUNTRIES",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_API_COUNTRIES"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:6,status:props.statuses.accounts,fetch:function fetch(){return props.fetch("/api/getAccounts");},onData:function onData(payload){props.dispatch({type:"RECEIVE_ACCOUNTS",payload:payload.accounts});},onError:function onError(){props.dispatch({type:"INVALIDATE_ACCOUNTS"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:7,status:props.statuses.stocks,fetch:function fetch(){return api.fetchEntity("/api/getAssets");},onData:function onData(entity){props.dispatch({type:"RECEIVE_STOCK_ASSETS",payload:entity.value});},onError:function onError(){props.dispatch({type:"INVALIDATE_STOCK_ASSETS"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:8,status:props.statuses.iOSShowDeposit,fetch:function fetch(){return props.fetch("/api/settings/ios_show_deposit");},onData:function onData(payload){props.dispatch({type:"RECEIVE_IOS_SHOW_DEPOSIT",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_IOS_SHOW_DEPOSIT"});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DataRequirement__["a" /* default */],{key:9,status:props.statuses.withdrawOutputMethods,fetch:function fetch(){return props.fetch("/api/withdraw/output-methods");},onData:function onData(payload){props.dispatch({type:"RECEIVE_WITHDRAW_OUTPUT_METHODS",payload:payload});},onError:function onError(){props.dispatch({type:"INVALIDATE_WITHDRAW_OUTPUT_METHODS"});}})];}/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_2__common_fetch__["e" /* mapDispatchToFetch */])(DataPlease));

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DataRequirement=function(_Component){_inherits(DataRequirement,_Component);function DataRequirement(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DataRequirement);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DataRequirement.__proto__||Object.getPrototypeOf(DataRequirement)).call.apply(_ref,[this].concat(args))),_this),_this.request=function(){return _this.props.fetch();},_this.receive=function(data){return _this.props.onData(data);},_this.handleError=function(error){return _this.props.onError(error);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DataRequirement,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.status==="PENDING"){this.request().then(this.receive,this.handleError);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.status!==prevProps.status&&this.props.status==="PENDING"){this.request().then(this.receive,this.handleError);}}},{key:"render",value:function render(){return null;}}]);return DataRequirement;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DataRequirement);

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Socket__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_webview_Rate__ = __webpack_require__(490);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function makeSocketUrl(_ref){var user_key=_ref.user_key,domain=_ref.domain,port=_ref.port;if(user_key==null||domain==null||port==null){throw new TypeError("Not enough information to open a connection");}if(String(port)==="6443"||String(port)==="443"){return"wss://"+domain+":"+port+"/ws/"+user_key;}return"ws://"+domain+":"+port+"/ws/"+user_key;}function openDealsFilter(deal){// Open deal has time and no profit
return deal.time!==undefined&&deal.profit===undefined;}var ReconnectableSocket=function(_React$Component){_inherits(ReconnectableSocket,_React$Component);function ReconnectableSocket(){var _ref2,_this2=this;var _temp,_this,_ret;_classCallCheck(this,ReconnectableSocket);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=ReconnectableSocket.__proto__||Object.getPrototypeOf(ReconnectableSocket)).call.apply(_ref2,[this].concat(args))),_this),_this.state={hackerUrl:null},_this.tick=function(){_this.props.onTick();},_this.updateProfile=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return _this.props.api.fetchEntity("/api/profile");case 2:payload=_context.sent;if(payload!=null){_this.props.onUpdateProfile(payload);}case 4:case"end":return _context.stop();}}},_callee,_this2);})),_this.onNotificationsMessage=function(message){_this.props.api.fetchEntity("/api/bell-tolls-items");_this.props.onSocketMessage(message);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ReconnectableSocket,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;this.interval=setInterval(this.tick,1000);window.hijackSocket=function(url){_this3.setState({hackerUrl:url+_this3.props.user_key});};}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearInterval(this.interval);}},{key:"render",value:function render(){var _this4=this;if(this.props.pass||this.props.user_key==null||this.props.domain==null||this.props.port==null||this.props.socket.connectionState===WebSocket.CLOSED){return null;}var tabs=[].concat(_toConsumableArray(this.props.tabs));var openStocks=this.props.deals.filter(openDealsFilter).reduce(function(res,deal){if(deal){res.push(deal.stock);}return res;},tabs);var stocks=[].concat(_toConsumableArray(new Set(openStocks)));return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["d" /* default */],{url:this.state.hackerUrl||makeSocketUrl(this.props),readyState:this.props.socket.connectionState,onChange:function onChange(e){if(e.target.readyState===WebSocket.CLOSED){Object(__WEBPACK_IMPORTED_MODULE_5__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Socket Error",eventAction:"Socket's been closed",eventLabel:"Failed to connect "+(_this4.props.socket.failedReconnects+1)+"x times"});}_this4.props.onSocketStateChange(e);}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"statPush_go",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"phone-confirm-call",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"statusChanged",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"operationOpened",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"tournamentOperationOpened",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"tournamentOperationClosed",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"tournament-status-change",onMessage:function onMessage(message){var component=null;var modalProps={};if(message.status==="started"){component=__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups__["e" /* StartPopup */];modalProps={id:message.id};}if(message.status==="ended"){component=__WEBPACK_IMPORTED_MODULE_8__Tournaments_Popups__["a" /* FinalPopup */];modalProps=Object.assign({},message.stats,{id:message.id});}if(component!==null){_this4.props.showModal(component,modalProps);}_this4.props.api.fetchEntity("/api/bell-tolls-items");_this4.props.onSocketMessage(message);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"announcements",onMessage:function onMessage(message){switch(message.type){case"tournament":_this4.props.api.fetchEntity("/api/bell-tolls-items");_this4.props.api.fetchEntity("/api/tournaments/list?status=1");break;case"invited-tournament":_this4.props.api.fetchEntity("/api/bell-tolls-items");_this4.props.api.fetchEntity("/api/tournaments/info?id="+message["2x_demo_tournament_id"]).then(function(data){if(data.value["2x_demo_balance_invite"]&&data.value.participation_status===0){return _this4.props.onSocketMessage(Object.assign({op:"demo-tournament"},data.value));}});break;case"news":_this4.props.api.clearEntities("/helpdesk/api/news");_this4.props.api.fetchEntity("/helpdesk/api/news");_this4.props.api.fetchEntity("/api/news");break;default:_this4.props.api.fetchEntity("/api/bell-tolls-items");break;}_this4.props.onSocketMessage(message);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"withdraw",onMessage:function onMessage(message){if(message.info.status==="success"){_this4.updateProfile();}_this4.onNotificationsMessage(message);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"verification",onMessage:function onMessage(message){_this4.updateProfile();_this4.onNotificationsMessage(message);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"unconfirmed_push_subscription",onMessage:this.onNotificationsMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"unconfirmed_email_subscription",onMessage:this.onNotificationsMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"deposit-bonus-inserted",onMessage:function onMessage(message){// Мы получаем события для обеих сторорн реферрального бонуса.
// Здесь мы решаем, какая из сторон — мы.
if(_this4.props.user_id===message.sql_user_id){_this4.props.onSocketMessage(message);}}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"operationClosed",onMessage:function onMessage(message){var ua=window.navigator.userAgent.toLowerCase();// Android Webview full app
var isWebView=/wvbo_full/g.test(ua);// Android Webview analytics
var isAnalyticsWebView="irontrade"==="irontrade"&&/androidweb.*com\.irontrade\.analytics.*wvbo/g.test(ua)&&!isWebView;if(isWebView||isAnalyticsWebView){var _localStorage=Object(__WEBPACK_IMPORTED_MODULE_9__components_webview_Rate__["c" /* localStorage */])(),_localStorage2=_slicedToArray(_localStorage,2),error=_localStorage2[0],store=_localStorage2[1];var KEY_DEALS_COUNT=__WEBPACK_IMPORTED_MODULE_9__components_webview_Rate__["c" /* localStorage */].keys.KEY_DEALS_COUNT;if(error==null&&Number(message.profit)>0){var current=store.get(KEY_DEALS_COUNT)||0;if(current!=="WASTED"){store.set(KEY_DEALS_COUNT,Number(current)+1);}}}_this4.props.onSocketMessage(message);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"compensation-updated",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"compensation-created",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"refreshFrontend",onMessage:this.props.onRefreshFrontend}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"turnoverChanged",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"deposit",onMessage:function onMessage(message){if(message.info.status==="success"){_this4.updateProfile();}_this4.onNotificationsMessage(message);}}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"user-accounts-updated",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"schedule-updated",onMessage:this.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["c" /* Subscription */],{op:"social_trading",onMessage:this.props.onSocketMessage}),stocks.map(function(stock){return[__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["b" /* StockSubscription */],{key:stock+"_points",stock:stock,onMessage:_this4.props.onSocketMessage}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_Socket__["a" /* PercentSubscription */],{key:stock+"_percent",stock:stock,onMessage:_this4.props.onSocketMessage})];}));}}]);return ReconnectableSocket;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function mapStateToProps(state){return{user_id:state.profile&&state.profile.id,user_key:state.profile&&state.profile.user_key,domain:state.serverData&&state.serverData.websocketDomain,port:state.serverData&&state.serverData.websocketWebPort,tabs:state.tabs.tabs,deals:state.deals,socket:state.socket};}var timer=null;var batch=[];function mapDispatchToProps(dispatch){return{onRefreshFrontend:function onRefreshFrontend(){window.location.reload(/* force: */true);},onSocketMessage:function onSocketMessage(message){batch.push({type:"RECEIVE_SOCKET_MESSAGE",payload:message});if(timer==null){timer=setTimeout(function(){__WEBPACK_IMPORTED_MODULE_2_react_dom__["unstable_batchedUpdates"](function(){batch.forEach(dispatch);batch=[];});timer=null;},600);}},onSocketStateChange:function onSocketStateChange(event){if(typeof event.target.readyState==="number"){dispatch({type:"SOCKET_STATE_CHANGE",payload:event.target.readyState});}},onTick:function onTick(){dispatch({type:"SOCKET_RECONNECT_TICK"});},onUpdateProfile:function onUpdateProfile(profile){dispatch({type:"RECEIVE_PROFILE",payload:profile.value});}};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref4){var showModal=_ref4.showModal;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ReconnectableSocket,Object.assign({},props,{api:api,showModal:showModal}));});});}));

/***/ }),
/* 1681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Subscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StockSubscription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PercentSubscription; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Subscription=function(_Component){_inherits(Subscription,_Component);function Subscription(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Subscription);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Subscription.__proto__||Object.getPrototypeOf(Subscription)).call.apply(_ref,[this].concat(args))),_this),_this.handleMessage=function(event){if(typeof event.data==="string"){try{var _data=JSON.parse(event.data);if(_data.op===_this.props.op){_this.props.onMessage(_data);}}catch(error){// Надо ли что-то делать?
}}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Subscription,[{key:"componentDidMount",value:function componentDidMount(){this.props.socket.addEventListener("message",this.handleMessage);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.socket!==prevProps.socket){prevProps.socket.removeEventListener("message",this.handleMessage);this.props.socket.addEventListener("message",this.handleMessage);}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.props.socket.removeEventListener("message",this.handleMessage);}},{key:"render",value:function render(){return null;}}]);return Subscription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function safelySend(socket,data){if(socket.readyState===WebSocket.OPEN){socket.send(JSON.stringify(data));}}var StockSubscription=function(_Component2){_inherits(StockSubscription,_Component2);function StockSubscription(){var _ref2;var _temp2,_this2,_ret2;_classCallCheck(this,StockSubscription);for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return _ret2=(_temp2=(_this2=_possibleConstructorReturn(this,(_ref2=StockSubscription.__proto__||Object.getPrototypeOf(StockSubscription)).call.apply(_ref2,[this].concat(args))),_this2),_this2.handleMessage=function(data){if(data.stock===_this2.props.stock){_this2.props.onMessage(data);}},_temp2),_possibleConstructorReturn(_this2,_ret2);}_createClass(StockSubscription,[{key:"componentDidMount",value:function componentDidMount(){safelySend(this.props.socket,{op:"subscribe",stock:this.props.stock});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.stock!==prevProps.stock){safelySend(this.props.socket,{op:"unsubscribe",stock:prevProps.stock});safelySend(this.props.socket,{op:"subscribe",stock:this.props.stock});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){safelySend(this.props.socket,{op:"unsubscribe",stock:this.props.stock});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subscription,{op:"stockPush",socket:this.props.socket,onMessage:this.handleMessage});}}]);return StockSubscription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var PercentSubscription=function(_Component3){_inherits(PercentSubscription,_Component3);function PercentSubscription(){var _ref3;var _temp3,_this3,_ret3;_classCallCheck(this,PercentSubscription);for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return _ret3=(_temp3=(_this3=_possibleConstructorReturn(this,(_ref3=PercentSubscription.__proto__||Object.getPrototypeOf(PercentSubscription)).call.apply(_ref3,[this].concat(args))),_this3),_this3.handleMessage=function(data){if(data.channel===_this3.props.stock){_this3.props.onMessage(data);}},_temp3),_possibleConstructorReturn(_this3,_ret3);}_createClass(PercentSubscription,[{key:"componentDidMount",value:function componentDidMount(){safelySend(this.props.socket,{op:"sql-subscribe",channel:this.props.stock});}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.stock!==prevProps.stock){safelySend(this.props.socket,{op:"sql-unsubscribe",channel:prevProps.stock});safelySend(this.props.socket,{op:"sql-subscribe",channel:this.props.stock});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){safelySend(this.props.socket,{op:"sql-unsubscribe",channel:this.props.stock});}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subscription,{op:"percent-updated",socket:this.props.socket,onMessage:this.handleMessage});}}]);return PercentSubscription;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var Socket=function(_PureComponent){_inherits(Socket,_PureComponent);function Socket(props){_classCallCheck(this,Socket);var _this4=_possibleConstructorReturn(this,(Socket.__proto__||Object.getPrototypeOf(Socket)).call(this,props));_this4.handleStateChange=function(event){_this4.props.onChange(event);// Отсоединить событие "close" можно только
// после закрытия. Иначе мы просто о нём не
// узнаем.
if(event.target.readyState===WebSocket.CLOSED){event.target.removeEventListener("close",_this4.handleStateChange);}};_this4.connect=function(){try{_this4.socket=new WebSocket(_this4.props.url);_this4.socket.addEventListener("open",_this4.handleStateChange);_this4.socket.addEventListener("close",_this4.handleStateChange);_this4.socket.addEventListener("error",_this4.handleStateChange);}catch(error){console.warn("Something's wrong with socket connection",error);}};_this4.disconnect=function(){try{_this4.socket.close();_this4.socket.removeEventListener("open",_this4.handleStateChange);_this4.socket.removeEventListener("error",_this4.handleStateChange);delete _this4.socket;}catch(error){console.warn("Something's wrong with socket disconnect",error);}};_this4.connect();return _this4;}_createClass(Socket,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.url!==prevProps.url){this.disconnect();this.connect();}// TODO: Инициировать .close(), если
// readyState был изменён вручную
}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.disconnect();}},{key:"render",value:function render(){var _this5=this;if(this.props.readyState===WebSocket.OPEN){return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(this.props.children,function(child,index){return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child,{socket:_this5.socket});});}return null;}}]);return Socket;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["d"] = (Socket);

/***/ }),
/* 1682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

__webpack_require__(1683);
var firebase = _interopDefault(__webpack_require__(686));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = firebase;


/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(setImmediate, global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_whatwg_fetch__);


// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

var globalNS = (function() {
  // the only reliable means to get the global object is
  // `Function('return this')()`
  // However, this causes CSP violations in Chrome apps.
  if (typeof self !== 'undefined') {
    return self;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  throw new Error('unable to locate global object');
})();

if (!globalNS.Promise) {
  globalNS.Promise = Promise;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _global = createCommonjsModule(function (module) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
});

var _core = createCommonjsModule(function (module) {
var core = module.exports = { version: '2.5.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
});
var _core_1 = _core.version;

var _isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var _anObject = function (it) {
  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

var _fails = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

// Thank's IE8 for his funny defineProperty
var _descriptors = !_fails(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

var document = _global.document;
// typeof document.createElement is 'object' in old IE
var is = _isObject(document) && _isObject(document.createElement);
var _domCreate = function (it) {
  return is ? document.createElement(it) : {};
};

var _ie8DomDefine = !_descriptors && !_fails(function () {
  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
});

// 7.1.1 ToPrimitive(input [, PreferredType])

// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var _toPrimitive = function (it, S) {
  if (!_isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

var dP = Object.defineProperty;

var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  _anObject(O);
  P = _toPrimitive(P, true);
  _anObject(Attributes);
  if (_ie8DomDefine) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var _objectDp = {
	f: f
};

var _propertyDesc = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var _hide = _descriptors ? function (object, key, value) {
  return _objectDp.f(object, key, _propertyDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var hasOwnProperty = {}.hasOwnProperty;
var _has = function (it, key) {
  return hasOwnProperty.call(it, key);
};

var id = 0;
var px = Math.random();
var _uid = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

var _redefine = createCommonjsModule(function (module) {
var SRC = _uid('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

_core.inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === _global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    _hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    _hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});
});

var _aFunction = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

// optional / simple context binding

var _ctx = function (fn, that, length) {
  _aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
    // extend global
    if (target) _redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) _hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
_global.core = _core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
var _export = $export;

var toString = {}.toString;

var _cof = function (it) {
  return toString.call(it).slice(8, -1);
};

// fallback for non-array-like ES3 and non-enumerable old V8 strings

// eslint-disable-next-line no-prototype-builtins
var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return _cof(it) == 'String' ? it.split('') : Object(it);
};

// 7.2.1 RequireObjectCoercible(argument)
var _defined = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

// 7.1.13 ToObject(argument)

var _toObject = function (it) {
  return Object(_defined(it));
};

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
var _toInteger = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

// 7.1.15 ToLength

var min = Math.min;
var _toLength = function (it) {
  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

// 7.2.2 IsArray(argument)

var _isArray = Array.isArray || function isArray(arg) {
  return _cof(arg) == 'Array';
};

var SHARED = '__core-js_shared__';
var store = _global[SHARED] || (_global[SHARED] = {});
var _shared = function (key) {
  return store[key] || (store[key] = {});
};

var _wks = createCommonjsModule(function (module) {
var store = _shared('wks');

var Symbol = _global.Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
};

$exports.store = store;
});

var SPECIES = _wks('species');

var _arraySpeciesConstructor = function (original) {
  var C;
  if (_isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || _isArray(C.prototype))) C = undefined;
    if (_isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)


var _arraySpeciesCreate = function (original, length) {
  return new (_arraySpeciesConstructor(original))(length);
};

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex





var _arrayMethods = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || _arraySpeciesCreate;
  return function ($this, callbackfn, that) {
    var O = _toObject($this);
    var self = _iobject(O);
    var f = _ctx(callbackfn, that, 3);
    var length = _toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = _wks('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) _hide(ArrayProto, UNSCOPABLES, {});
var _addToUnscopables = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)

var $find = _arrayMethods(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
_export(_export.P + _export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY);

var find = _core.Array.find;

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)

var $find$1 = _arrayMethods(6);
var KEY$1 = 'findIndex';
var forced$1 = true;
// Shouldn't skip holes
if (KEY$1 in []) Array(1)[KEY$1](function () { forced$1 = false; });
_export(_export.P + _export.F * forced$1, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find$1(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
_addToUnscopables(KEY$1);

var findIndex = _core.Array.findIndex;

// to indexed object, toObject with fallback for non-array-like ES3 strings


var _toIobject = function (it) {
  return _iobject(_defined(it));
};

var max = Math.max;
var min$1 = Math.min;
var _toAbsoluteIndex = function (index, length) {
  index = _toInteger(index);
  return index < 0 ? max(index + length, 0) : min$1(index, length);
};

// false -> Array#indexOf
// true  -> Array#includes



var _arrayIncludes = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = _toIobject($this);
    var length = _toLength(O.length);
    var index = _toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var shared = _shared('keys');

var _sharedKey = function (key) {
  return shared[key] || (shared[key] = _uid(key));
};

var arrayIndexOf = _arrayIncludes(false);
var IE_PROTO = _sharedKey('IE_PROTO');

var _objectKeysInternal = function (object, names) {
  var O = _toIobject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (_has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

// IE 8- don't enum bug keys
var _enumBugKeys = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

// 19.1.2.14 / 15.2.3.14 Object.keys(O)



var _objectKeys = Object.keys || function keys(O) {
  return _objectKeysInternal(O, _enumBugKeys);
};

var f$1 = Object.getOwnPropertySymbols;

var _objectGops = {
	f: f$1
};

var f$2 = {}.propertyIsEnumerable;

var _objectPie = {
	f: f$2
};

// 19.1.2.1 Object.assign(target, source, ...)





var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
var _objectAssign = !$assign || _fails(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = _toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = _objectGops.f;
  var isEnum = _objectPie.f;
  while (aLen > index) {
    var S = _iobject(arguments[index++]);
    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

// 19.1.3.1 Object.assign(target, source)


_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

var assign = _core.Object.assign;

// 7.2.8 IsRegExp(argument)


var MATCH = _wks('match');
var _isRegexp = function (it) {
  var isRegExp;
  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
};

// helper for String#{startsWith, endsWith, includes}



var _stringContext = function (that, searchString, NAME) {
  if (_isRegexp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(_defined(that));
};

var MATCH$1 = _wks('match');
var _failsIsRegexp = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH$1] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

_export(_export.P + _export.F * _failsIsRegexp(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = _stringContext(this, searchString, STARTS_WITH);
    var index = _toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

var startsWith = _core.String.startsWith;

var _stringRepeat = function repeat(count) {
  var str = String(_defined(this));
  var res = '';
  var n = _toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

_export(_export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: _stringRepeat
});

var repeat = _core.String.repeat;

var _meta = createCommonjsModule(function (module) {
var META = _uid('meta');


var setDesc = _objectDp.f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !_fails(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!_has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};
});
var _meta_1 = _meta.KEY;
var _meta_2 = _meta.NEED;
var _meta_3 = _meta.fastKey;
var _meta_4 = _meta.getWeak;
var _meta_5 = _meta.onFreeze;

var def = _objectDp.f;

var TAG = _wks('toStringTag');

var _setToStringTag = function (it, tag, stat) {
  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

var f$3 = _wks;

var _wksExt = {
	f: f$3
};

var _library = false;

var defineProperty = _objectDp.f;
var _wksDefine = function (name) {
  var $Symbol = _core.Symbol || (_core.Symbol = _library ? {} : _global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: _wksExt.f(name) });
};

// all enumerable object keys, includes symbols



var _enumKeys = function (it) {
  var result = _objectKeys(it);
  var getSymbols = _objectGops.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = _objectPie.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  _anObject(O);
  var keys = _objectKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
  return O;
};

var document$1 = _global.document;
var _html = document$1 && document$1.documentElement;

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



var IE_PROTO$1 = _sharedKey('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE$1 = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = _domCreate('iframe');
  var i = _enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  _html.appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
  return createDict();
};

var _objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE$1] = _anObject(O);
    result = new Empty();
    Empty[PROTOTYPE$1] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO$1] = O;
  } else result = createDict();
  return Properties === undefined ? result : _objectDps(result, Properties);
};

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

var f$4 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return _objectKeysInternal(O, hiddenKeys);
};

var _objectGopn = {
	f: f$4
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

var gOPN = _objectGopn.f;
var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
};

var _objectGopnExt = {
	f: f$5
};

var gOPD = Object.getOwnPropertyDescriptor;

var f$6 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = _toIobject(O);
  P = _toPrimitive(P, true);
  if (_ie8DomDefine) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
};

var _objectGopd = {
	f: f$6
};

// ECMAScript 6 symbols shim





var META = _meta.KEY;



















var gOPD$1 = _objectGopd.f;
var dP$1 = _objectDp.f;
var gOPN$1 = _objectGopnExt.f;
var $Symbol = _global.Symbol;
var $JSON = _global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE$2 = 'prototype';
var HIDDEN = _wks('_hidden');
var TO_PRIMITIVE = _wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = _shared('symbol-registry');
var AllSymbols = _shared('symbols');
var OPSymbols = _shared('op-symbols');
var ObjectProto = Object[PROTOTYPE$2];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = _global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = _descriptors && _fails(function () {
  return _objectCreate(dP$1({}, 'a', {
    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD$1(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP$1(it, key, D);
  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
} : dP$1;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  _anObject(it);
  key = _toPrimitive(key, true);
  _anObject(D);
  if (_has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP$1(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  _anObject(it);
  var keys = _enumKeys(P = _toIobject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = _toPrimitive(key, true));
  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = _toIobject(it);
  key = _toPrimitive(key, true);
  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
  var D = gOPD$1(it, key);
  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN$1(_toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, _propertyDesc(1, value));
    };
    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
    return this._k;
  });

  _objectGopd.f = $getOwnPropertyDescriptor;
  _objectDp.f = $defineProperty;
  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
  _objectPie.f = $propertyIsEnumerable;
  _objectGops.f = $getOwnPropertySymbols;

  if (_descriptors && !_library) {
    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  _wksExt.f = function (name) {
    return wrap(_wks(name));
  };
}

_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return _has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!_isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
_setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
_setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
_setToStringTag(_global.JSON, 'JSON', true);

// getting tag from 19.1.3.6 Object.prototype.toString()

var TAG$1 = _wks('toStringTag');
// ES3 wrong here
var ARG = _cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

var _classof = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
    // builtinTag case
    : ARG ? _cof(O)
    // ES3 arguments fallback
    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

// 19.1.3.6 Object.prototype.toString()

var test = {};
test[_wks('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  _redefine(Object.prototype, 'toString', function toString() {
    return '[object ' + _classof(this) + ']';
  }, true);
}

_wksDefine('asyncIterator');

_wksDefine('observable');

var symbol = _core.Symbol;

// true  -> String#at
// false -> String#codePointAt
var _stringAt = function (TO_STRING) {
  return function (that, pos) {
    var s = String(_defined(that));
    var i = _toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

var _iterators = {};

var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

var _iterCreate = function (Constructor, NAME, next) {
  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
  _setToStringTag(Constructor, NAME + ' Iterator');
};

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


var IE_PROTO$2 = _sharedKey('IE_PROTO');
var ObjectProto$1 = Object.prototype;

var _objectGpo = Object.getPrototypeOf || function (O) {
  O = _toObject(O);
  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto$1 : null;
};

var ITERATOR = _wks('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  _iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      _setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!_library && typeof IteratorPrototype[ITERATOR] != 'function') _hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!_library || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    _hide(proto, ITERATOR, $default);
  }
  // Plug for library
  _iterators[NAME] = $default;
  _iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) _redefine(proto, key, methods[key]);
    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

var $at = _stringAt(true);

// 21.1.3.27 String.prototype[@@iterator]()
_iterDefine(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

var _iterStep = function (done, value) {
  return { value: value, done: !!done };
};

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
  this._t = _toIobject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return _iterStep(1);
  }
  if (kind == 'keys') return _iterStep(0, index);
  if (kind == 'values') return _iterStep(0, O[index]);
  return _iterStep(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
_iterators.Arguments = _iterators.Array;

_addToUnscopables('keys');
_addToUnscopables('values');
_addToUnscopables('entries');

var ITERATOR$1 = _wks('iterator');
var TO_STRING_TAG = _wks('toStringTag');
var ArrayValues = _iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = _global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR$1]) _hide(proto, ITERATOR$1, ArrayValues);
    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
    _iterators[NAME] = ArrayValues;
    if (explicit) for (key in es6_array_iterator) if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
  }
}

var iterator = _wksExt.f('iterator');

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1684).setImmediate, __webpack_require__(27)))

/***/ }),
/* 1684 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1685);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1685 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27), __webpack_require__(185)))

/***/ }),
/* 1686 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_messaging__ = __webpack_require__(1688);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export registerMessaging */
/* unused harmony export isSupported */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tslib__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__firebase_app__);




/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ERROR_CODES = {
    AVAILABLE_IN_WINDOW: 'only-available-in-window',
    AVAILABLE_IN_SW: 'only-available-in-sw',
    SHOULD_BE_INHERITED: 'should-be-overriden',
    BAD_SENDER_ID: 'bad-sender-id',
    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
    PERMISSION_DEFAULT: 'permission-default',
    PERMISSION_BLOCKED: 'permission-blocked',
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
    INVALID_SAVED_TOKEN: 'invalid-saved-token',
    SW_REG_REDUNDANT: 'sw-reg-redundant',
    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
    TOKEN_UNSUBSCRIBE_FAILED: 'token-unsubscribe-failed',
    TOKEN_UPDATE_FAILED: 'token-update-failed',
    TOKEN_UPDATE_NO_TOKEN: 'token-update-no-token',
    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
    INVALID_DELETE_TOKEN: 'invalid-delete-token',
    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
    NO_SW_IN_REG: 'no-sw-in-reg',
    BAD_SCOPE: 'bad-scope',
    BAD_VAPID_KEY: 'bad-vapid-key',
    BAD_SUBSCRIPTION: 'bad-subscription',
    BAD_TOKEN: 'bad-token',
    BAD_PUSH_SET: 'bad-push-set',
    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key',
    INVALID_PUBLIC_VAPID_KEY: 'invalid-public-vapid-key',
    USE_PUBLIC_KEY_BEFORE_GET_TOKEN: 'use-public-key-before-get-token',
    PUBLIC_KEY_DECRYPTION_FAILED: 'public-vapid-key-decryption-failed'
};
var ERROR_MAP = (_a = {}, _a[ERROR_CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.', _a[ERROR_CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.', _a[ERROR_CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.', _a[ERROR_CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
        'correctly in the options passed into firebase.initializeApp().', _a[ERROR_CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.', _a[ERROR_CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.', _a[ERROR_CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
        'required to use the firebase SDK.', _a[ERROR_CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.', _a[ERROR_CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
        'default service worker. {$browserErrorMessage}', _a[ERROR_CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.', _a[ERROR_CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
        'any existing Push Subscriptions.', _a[ERROR_CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.', _a[ERROR_CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.', _a[ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.', _a[ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED] = 'A problem occured while unsubscribing the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_FAILED] = 'A problem occured while updating the ' + 'user from FCM: {$message}', _a[ERROR_CODES.TOKEN_UPDATE_NO_TOKEN] = 'FCM returned no token when updating ' + 'the user to push.', _a[ERROR_CODES.USE_SW_BEFORE_GET_TOKEN] = 'The useServiceWorker() method may only be called once and must be ' +
        'called before calling getToken() to ensure your service worker is used.', _a[ERROR_CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
        'deleteToken(), i.e. the token from getToken().', _a[ERROR_CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
        'be performed as the token was not found.', _a[ERROR_CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
        'scope could not be performed as the scope was not found.', _a[ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.', _a[ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.', _a[ERROR_CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
        'the FCM token for push messaging. Will have to resubscribe the ' +
        'user on next visit. {$message}', _a[ERROR_CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
        'user on next visit.', _a[ERROR_CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.', _a[ERROR_CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
        'successful, there was a problem accessing the service worker itself.', _a[ERROR_CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.", _a[ERROR_CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
        'least one character.', _a[ERROR_CODES.BAD_VAPID_KEY] = 'The public VAPID key is not a Uint8Array with 65 bytes.', _a[ERROR_CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.', _a[ERROR_CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
        'a valid token string.', _a[ERROR_CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
        'not a valid push set string.', _a[ERROR_CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.', _a[ERROR_CODES.INVALID_PUBLIC_VAPID_KEY] = 'The public VAPID key must be a string.', _a[ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED] = 'The public VAPID key did not equal ' + '65 bytes when decrypted.', _a);
var errorFactory = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('messaging', 'Messaging', ERROR_MAP);
var _a;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_PUBLIC_VAPID_KEY = new Uint8Array([
    0x04,
    0x33,
    0x94,
    0xf7,
    0xdf,
    0xa1,
    0xeb,
    0xb1,
    0xdc,
    0x03,
    0xa2,
    0x5e,
    0x15,
    0x71,
    0xdb,
    0x48,
    0xd3,
    0x2e,
    0xed,
    0xed,
    0xb2,
    0x34,
    0xdb,
    0xb7,
    0x47,
    0x3a,
    0x0c,
    0x8f,
    0xc4,
    0xcc,
    0xe1,
    0x6f,
    0x3c,
    0x8c,
    0x84,
    0xdf,
    0xab,
    0xb6,
    0x66,
    0x3e,
    0xf2,
    0x0c,
    0xd4,
    0x8b,
    0xfe,
    0xe3,
    0xf9,
    0x76,
    0x2f,
    0x14,
    0x1c,
    0x63,
    0x08,
    0x6a,
    0x6f,
    0x2d,
    0xb1,
    0x1a,
    0x95,
    0xb0,
    0xce,
    0x37,
    0xc0,
    0x9c,
    0x6e
]);
var ENDPOINT = 'https://fcm.googleapis.com';

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var MessageParameter;
(function (MessageParameter) {
    MessageParameter["TYPE_OF_MSG"] = "firebase-messaging-msg-type";
    MessageParameter["DATA"] = "firebase-messaging-msg-data";
})(MessageParameter || (MessageParameter = {}));
var MessageType;
(function (MessageType) {
    MessageType["PUSH_MSG_RECEIVED"] = "push-msg-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
})(MessageType || (MessageType = {}));

/**
 * Copyright 2018 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isArrayBufferEqual(a, b) {
    if (a == null || b == null) {
        return false;
    }
    if (a === b) {
        return true;
    }
    if (a.byteLength !== b.byteLength) {
        return false;
    }
    var viewA = new DataView(a);
    var viewB = new DataView(b);
    for (var i = 0; i < a.byteLength; i++) {
        if (viewA.getUint8(i) !== viewB.getUint8(i)) {
            return false;
        }
    }
    return true;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return btoa(String.fromCharCode.apply(null, uint8Version));
}
function arrayBufferToBase64(arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var IidModel = /** @class */ (function () {
    function IidModel() {
    }
    IidModel.prototype.getToken = function (senderId, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var p256dh, auth, fcmSubscribeBody, applicationPubKey, headers, subscribeOptions, responseData, response, err_1, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmSubscribeBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        subscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmSubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_1 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED);
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_FAILED, {
                                message: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_TOKEN);
                        }
                        if (!responseData.pushSet) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET);
                        }
                        return [2 /*return*/, {
                                token: responseData.token,
                                pushSet: responseData.pushSet
                            }];
                }
            });
        });
    };
    /**
     * Update the underlying token details for fcmToken.
     */
    IidModel.prototype.updateToken = function (senderId, fcmToken, fcmPushSet, subscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var p256dh, auth, fcmUpdateBody, applicationPubKey, headers, updateOptions, responseData, response, err_2, message;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        p256dh = arrayBufferToBase64(subscription.getKey('p256dh'));
                        auth = arrayBufferToBase64(subscription.getKey('auth'));
                        fcmUpdateBody = "push_set=" + fcmPushSet + "&" +
                            ("token=" + fcmToken + "&") +
                            ("authorized_entity=" + senderId + "&") +
                            ("endpoint=" + subscription.endpoint + "&") +
                            ("encryption_key=" + p256dh + "&") +
                            ("encryption_auth=" + auth);
                        if (!isArrayBufferEqual(publicVapidKey.buffer, DEFAULT_PUBLIC_VAPID_KEY.buffer)) {
                            applicationPubKey = arrayBufferToBase64(publicVapidKey);
                            fcmUpdateBody += "&application_pub_key=" + applicationPubKey;
                        }
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        updateOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUpdateBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/subscribe', updateOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_2 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED);
                    case 5:
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_FAILED, {
                                message: message
                            });
                        }
                        if (!responseData.token) {
                            throw errorFactory.create(ERROR_CODES.TOKEN_UPDATE_NO_TOKEN);
                        }
                        return [2 /*return*/, responseData.token];
                }
            });
        });
    };
    /**
     * Given a fcmToken, pushSet and messagingSenderId, delete an FCM token.
     */
    IidModel.prototype.deleteToken = function (senderId, fcmToken, fcmPushSet) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var fcmUnsubscribeBody, headers, unsubscribeOptions, response, responseData, message, err_3;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fcmUnsubscribeBody = "authorized_entity=" + senderId + "&" +
                            ("token=" + fcmToken + "&") +
                            ("pushSet=" + fcmPushSet);
                        headers = new Headers();
                        headers.append('Content-Type', 'application/x-www-form-urlencoded');
                        unsubscribeOptions = {
                            method: 'POST',
                            headers: headers,
                            body: fcmUnsubscribeBody
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch(ENDPOINT + '/fcm/connect/unsubscribe', unsubscribeOptions)];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        responseData = _a.sent();
                        if (responseData.error) {
                            message = responseData.error.message;
                            throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED, {
                                message: message
                            });
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.TOKEN_UNSUBSCRIBE_FAILED);
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return IidModel;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function base64ToArrayBuffer(base64String) {
    var padding = '='.repeat((4 - base64String.length % 4) % 4);
    var base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');
    var rawData = atob(base64);
    var outputArray = new Uint8Array(rawData.length);
    for (var i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
    }
    return outputArray;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OLD_DB_NAME = 'undefined';
var OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
function handleDb(db) {
    if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) {
        // We found a database with the name 'undefined', but our expected object
        // store isn't defined.
        return;
    }
    var transaction = db.transaction(OLD_OBJECT_STORE_NAME);
    var objectStore = transaction.objectStore(OLD_OBJECT_STORE_NAME);
    var iidModel = new IidModel();
    var openCursorRequest = objectStore.openCursor();
    openCursorRequest.onerror = function (event) {
        // NOOP - Nothing we can do.
        console.warn('Unable to cleanup old IDB.', event);
    };
    openCursorRequest.onsuccess = function () {
        var cursor = openCursorRequest.result;
        if (cursor) {
            // cursor.value contains the current record being iterated through
            // this is where you'd do something with the result
            var tokenDetails = cursor.value;
            iidModel.deleteToken(tokenDetails.fcmSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet);
            cursor.continue();
        }
        else {
            db.close();
            indexedDB.deleteDatabase(OLD_DB_NAME);
        }
    };
}
function cleanV1() {
    var request = indexedDB.open(OLD_DB_NAME);
    request.onerror = function (event) {
        // NOOP - Nothing we can do.
    };
    request.onsuccess = function (event) {
        var db = request.result;
        handleDb(db);
    };
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DbInterface = /** @class */ (function () {
    function DbInterface() {
        this.dbPromise = null;
    }
    /** Gets record(s) from the objectStore that match the given key. */
    DbInterface.prototype.get = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.get(key); });
    };
    /** Gets record(s) from the objectStore that match the given index. */
    DbInterface.prototype.getIndex = function (index, key) {
        function runRequest(objectStore) {
            var idbIndex = objectStore.index(index);
            return idbIndex.get(key);
        }
        return this.createTransaction(runRequest);
    };
    /** Assigns or overwrites the record for the given value. */
    // tslint:disable-next-line:no-any IndexedDB values are of type "any"
    DbInterface.prototype.put = function (value) {
        return this.createTransaction(function (objectStore) { return objectStore.put(value); }, 'readwrite');
    };
    /** Deletes record(s) from the objectStore that match the given key. */
    DbInterface.prototype.delete = function (key) {
        return this.createTransaction(function (objectStore) { return objectStore.delete(key); }, 'readwrite');
    };
    /**
     * Close the currently open database.
     */
    DbInterface.prototype.closeDatabase = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var db;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.dbPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.dbPromise];
                    case 1:
                        db = _a.sent();
                        db.close();
                        this.dbPromise = null;
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates an IndexedDB Transaction and passes its objectStore to the
     * runRequest function, which runs the database request.
     *
     * @return Promise that resolves with the result of the runRequest function
     */
    DbInterface.prototype.createTransaction = function (runRequest, mode) {
        if (mode === void 0) { mode = 'readonly'; }
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var db, transaction, request, result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getDb()];
                    case 1:
                        db = _a.sent();
                        transaction = db.transaction(this.objectStoreName, mode);
                        request = transaction.objectStore(this.objectStoreName);
                        return [4 /*yield*/, promisify(runRequest(request))];
                    case 2:
                        result = _a.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                transaction.oncomplete = function () {
                                    resolve(result);
                                };
                                transaction.onerror = function () {
                                    reject(transaction.error);
                                };
                            })];
                }
            });
        });
    };
    /** Gets the cached db connection or opens a new one. */
    DbInterface.prototype.getDb = function () {
        var _this = this;
        if (!this.dbPromise) {
            this.dbPromise = new Promise(function (resolve, reject) {
                var request = indexedDB.open(_this.dbName, _this.dbVersion);
                request.onsuccess = function () {
                    resolve(request.result);
                };
                request.onerror = function () {
                    _this.dbPromise = null;
                    reject(request.error);
                };
                request.onupgradeneeded = function (event) { return _this.onDbUpgrade(request, event); };
            });
        }
        return this.dbPromise;
    };
    return DbInterface;
}());
/** Promisifies an IDBRequest. Resolves with the IDBRequest's result. */
function promisify(request) {
    return new Promise(function (resolve, reject) {
        request.onsuccess = function () {
            resolve(request.result);
        };
        request.onerror = function () {
            reject(request.error);
        };
    });
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TokenDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(TokenDetailsModel, _super);
    function TokenDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_token_details_db';
        _this.dbVersion = 3;
        _this.objectStoreName = 'fcm_token_object_Store';
        return _this;
    }
    TokenDetailsModel.prototype.onDbUpgrade = function (request, event) {
        var db = request.result;
        // Lack of 'break' statements is intentional.
        switch (event.oldVersion) {
            case 0: {
                // New IDB instance
                var objectStore = db.createObjectStore(this.objectStoreName, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', { unique: true });
            }
            case 1: {
                // Prior to version 2, we were using either 'fcm_token_details_db'
                // or 'undefined' as the database name due to bug in the SDK
                // So remove the old tokens and databases.
                cleanV1();
            }
            case 2: {
                var objectStore = request.transaction.objectStore(this.objectStoreName);
                var cursorRequest_1 = objectStore.openCursor();
                cursorRequest_1.onsuccess = function () {
                    var cursor = cursorRequest_1.result;
                    if (cursor) {
                        var value = cursor.value;
                        var newValue = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, value);
                        if (!value.createTime) {
                            newValue.createTime = Date.now();
                        }
                        if (typeof value.vapidKey === 'string') {
                            newValue.vapidKey = base64ToArrayBuffer(value.vapidKey);
                        }
                        if (typeof value.auth === 'string') {
                            newValue.auth = base64ToArrayBuffer(value.auth).buffer;
                        }
                        if (typeof value.auth === 'string') {
                            newValue.p256dh = base64ToArrayBuffer(value.p256dh).buffer;
                        }
                        cursor.update(newValue);
                        cursor.continue();
                    }
                };
            }
        }
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!fcmToken) {
                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
                }
                validateInputs({ fcmToken: fcmToken });
                return [2 /*return*/, this.getIndex('fcmToken', fcmToken)];
            });
        });
    };
    /**
     * Given a service worker scope, this method will look up the details in
     * indexedDB.
     * @return The details associated with that token.
     */
    TokenDetailsModel.prototype.getTokenDetailsFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!swScope) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                validateInputs({ swScope: swScope });
                return [2 /*return*/, this.get(swScope)];
            });
        });
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @param input A plain js object containing args to save.
     */
    TokenDetailsModel.prototype.saveTokenDetails = function (tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (!tokenDetails.swScope) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                if (!tokenDetails.vapidKey) {
                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
                }
                if (!tokenDetails.endpoint || !tokenDetails.auth || !tokenDetails.p256dh) {
                    throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
                }
                if (!tokenDetails.fcmSenderId) {
                    throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
                }
                if (!tokenDetails.fcmToken) {
                    throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
                }
                if (!tokenDetails.fcmPushSet) {
                    throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
                }
                validateInputs(tokenDetails);
                return [2 /*return*/, this.put(tokenDetails)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     *
     * @return Resolves once the FCM token details have been deleted and returns
     * the deleted details.
     */
    TokenDetailsModel.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof token !== 'string' || token.length === 0) {
                            return [2 /*return*/, Promise.reject(errorFactory.create(ERROR_CODES.INVALID_DELETE_TOKEN))];
                        }
                        return [4 /*yield*/, this.getTokenDetailsFromToken(token)];
                    case 1:
                        details = _a.sent();
                        if (!details) {
                            throw errorFactory.create(ERROR_CODES.DELETE_TOKEN_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.delete(details.swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, details];
                }
            });
        });
    };
    return TokenDetailsModel;
}(DbInterface));
/**
 * This method takes an object and will check for known arguments and
 * validate the input.
 * @return Promise that resolves if input is valid, rejects otherwise.
 */
function validateInputs(input) {
    if (input.fcmToken) {
        if (typeof input.fcmToken !== 'string' || input.fcmToken.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_TOKEN);
        }
    }
    if (input.swScope) {
        if (typeof input.swScope !== 'string' || input.swScope.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
        }
    }
    if (input.vapidKey) {
        if (!(input.vapidKey instanceof Uint8Array) ||
            input.vapidKey.length !== 65) {
            throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
        }
    }
    if (input.endpoint) {
        if (typeof input.endpoint !== 'string' || input.endpoint.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.auth) {
        if (!(input.auth instanceof ArrayBuffer)) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.p256dh) {
        if (!(input.p256dh instanceof ArrayBuffer)) {
            throw errorFactory.create(ERROR_CODES.BAD_SUBSCRIPTION);
        }
    }
    if (input.fcmSenderId) {
        if (typeof input.fcmSenderId !== 'string' ||
            input.fcmSenderId.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
        }
    }
    if (input.fcmPushSet) {
        if (typeof input.fcmPushSet !== 'string' || input.fcmPushSet.length === 0) {
            throw errorFactory.create(ERROR_CODES.BAD_PUSH_SET);
        }
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var UNCOMPRESSED_PUBLIC_KEY_SIZE = 65;
var VapidDetailsModel = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(VapidDetailsModel, _super);
    function VapidDetailsModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dbName = 'fcm_vapid_details_db';
        _this.dbVersion = 1;
        _this.objectStoreName = 'fcm_vapid_object_Store';
        return _this;
    }
    VapidDetailsModel.prototype.onDbUpgrade = function (request) {
        var db = request.result;
        db.createObjectStore(this.objectStoreName, { keyPath: 'swScope' });
    };
    /**
     * Given a service worker scope, this method will look up the vapid key
     * in indexedDB.
     */
    VapidDetailsModel.prototype.getVapidFromSWScope = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var result;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof swScope !== 'string' || swScope.length === 0) {
                            throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                        }
                        return [4 /*yield*/, this.get(swScope)];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, result ? result.vapidKey : undefined];
                }
            });
        });
    };
    /**
     * Save a vapid key against a swScope for later date.
     */
    VapidDetailsModel.prototype.saveVapidDetails = function (swScope, vapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (typeof swScope !== 'string' || swScope.length === 0) {
                    throw errorFactory.create(ERROR_CODES.BAD_SCOPE);
                }
                if (vapidKey === null || vapidKey.length !== UNCOMPRESSED_PUBLIC_KEY_SIZE) {
                    throw errorFactory.create(ERROR_CODES.BAD_VAPID_KEY);
                }
                details = {
                    swScope: swScope,
                    vapidKey: vapidKey
                };
                return [2 /*return*/, this.put(details)];
            });
        });
    };
    /**
     * This method deletes details of the current FCM VAPID key for a SW scope.
     * Resolves once the scope/vapid details have been deleted and returns the
     * deleted vapid key.
     */
    VapidDetailsModel.prototype.deleteVapidDetails = function (swScope) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var vapidKey;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getVapidFromSWScope(swScope)];
                    case 1:
                        vapidKey = _a.sent();
                        if (!vapidKey) {
                            throw errorFactory.create(ERROR_CODES.DELETE_SCOPE_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.delete(swScope)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, vapidKey];
                }
            });
        });
    };
    return VapidDetailsModel;
}(DbInterface));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SENDER_ID_OPTION_NAME = 'messagingSenderId';
// Database cache should be invalidated once a week.
var TOKEN_EXPIRATION_MILLIS = 7 * 24 * 60 * 60 * 1000; // 7 days
var BaseController = /** @class */ (function () {
    /**
     * An interface of the Messaging Service API
     */
    function BaseController(app) {
        var _this = this;
        if (!app.options[SENDER_ID_OPTION_NAME] ||
            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
            throw errorFactory.create(ERROR_CODES.BAD_SENDER_ID);
        }
        this.messagingSenderId = app.options[SENDER_ID_OPTION_NAME];
        this.tokenDetailsModel = new TokenDetailsModel();
        this.vapidDetailsModel = new VapidDetailsModel();
        this.iidModel = new IidModel();
        this.app = app;
        this.INTERNAL = {
            delete: function () { return _this.delete(); }
        };
    }
    /**
     * @export
     */
    BaseController.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var currentPermission, swReg, publicVapidKey, pushSubscription, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        currentPermission = this.getNotificationPermission_();
                        if (currentPermission === 'denied') {
                            throw errorFactory.create(ERROR_CODES.NOTIFICATIONS_BLOCKED);
                        }
                        else if (currentPermission !== 'granted') {
                            // We must wait for permission to be granted
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        return [4 /*yield*/, this.getPublicVapidKey_()];
                    case 2:
                        publicVapidKey = _a.sent();
                        return [4 /*yield*/, this.getPushSubscription(swReg, publicVapidKey)];
                    case 3:
                        pushSubscription = _a.sent();
                        return [4 /*yield*/, this.tokenDetailsModel.getTokenDetailsFromSWScope(swReg.scope)];
                    case 4:
                        tokenDetails = _a.sent();
                        if (tokenDetails) {
                            return [2 /*return*/, this.manageExistingToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                        }
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    /**
     * manageExistingToken is triggered if there's an existing FCM token in the
     * database and it can take 3 different actions:
     * 1) Retrieve the existing FCM token from the database.
     * 2) If VAPID details have changed: Delete the existing token and create a
     * new one with the new VAPID key.
     * 3) If the database cache is invalidated: Send a request to FCM to update
     * the token, and to check if the token is still valid on FCM-side.
     */
    BaseController.prototype.manageExistingToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var isTokenValid, now;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isTokenValid = isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails);
                        if (isTokenValid) {
                            now = Date.now();
                            if (now < tokenDetails.createTime + TOKEN_EXPIRATION_MILLIS) {
                                return [2 /*return*/, tokenDetails.fcmToken];
                            }
                            else {
                                return [2 /*return*/, this.updateToken(swReg, pushSubscription, publicVapidKey, tokenDetails)];
                            }
                        }
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        return [4 /*yield*/, this.deleteTokenFromDB(tokenDetails.fcmToken)];
                    case 1:
                        // If the token is no longer valid (for example if the VAPID details
                        // have changed), delete the existing token from the FCM client and server
                        // database. No need to unsubscribe from the Service Worker as we have a
                        // good push subscription that we'd like to use in getNewToken.
                        _a.sent();
                        return [2 /*return*/, this.getNewToken(swReg, pushSubscription, publicVapidKey)];
                }
            });
        });
    };
    BaseController.prototype.updateToken = function (swReg, pushSubscription, publicVapidKey, tokenDetails) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var updatedToken, allDetails, e_1;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 6]);
                        return [4 /*yield*/, this.iidModel.updateToken(this.messagingSenderId, tokenDetails.fcmToken, tokenDetails.fcmPushSet, pushSubscription, publicVapidKey)];
                    case 1:
                        updatedToken = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: updatedToken,
                            fcmPushSet: tokenDetails.fcmPushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, updatedToken];
                    case 4:
                        e_1 = _a.sent();
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 5:
                        _a.sent();
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    BaseController.prototype.getNewToken = function (swReg, pushSubscription, publicVapidKey) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var tokenDetails, allDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.iidModel.getToken(this.messagingSenderId, pushSubscription, publicVapidKey)];
                    case 1:
                        tokenDetails = _a.sent();
                        allDetails = {
                            swScope: swReg.scope,
                            vapidKey: publicVapidKey,
                            fcmSenderId: this.messagingSenderId,
                            fcmToken: tokenDetails.token,
                            fcmPushSet: tokenDetails.pushSet,
                            createTime: Date.now(),
                            endpoint: pushSubscription.endpoint,
                            auth: pushSubscription.getKey('auth'),
                            p256dh: pushSubscription.getKey('p256dh')
                        };
                        return [4 /*yield*/, this.tokenDetailsModel.saveTokenDetails(allDetails)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.vapidDetailsModel.saveVapidDetails(swReg.scope, publicVapidKey)];
                    case 3:
                        _a.sent();
                        return [2 /*return*/, tokenDetails.token];
                }
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after,
     * unsubscribes the token from FCM  and then unregisters the push
     * subscription if it exists. It returns a promise that indicates
     * whether or not the unsubscribe request was processed successfully.
     */
    BaseController.prototype.deleteToken = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var registration, pushSubscription;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Delete the token details from the database.
                    return [4 /*yield*/, this.deleteTokenFromDB(token)];
                    case 1:
                        // Delete the token details from the database.
                        _a.sent();
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        registration = _a.sent();
                        if (!registration) return [3 /*break*/, 4];
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 3:
                        pushSubscription = _a.sent();
                        if (pushSubscription) {
                            return [2 /*return*/, pushSubscription.unsubscribe()];
                        }
                        _a.label = 4;
                    case 4: 
                    // If there's no SW, consider it a success.
                    return [2 /*return*/, true];
                }
            });
        });
    };
    /**
     * This method will delete the token from the client database, and make a
     * call to FCM to remove it from the server DB. Does not temper with the
     * push subscription.
     */
    BaseController.prototype.deleteTokenFromDB = function (token) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var details;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.tokenDetailsModel.deleteToken(token)];
                    case 1:
                        details = _a.sent();
                        return [4 /*yield*/, this.iidModel.deleteToken(details.fcmSenderId, details.fcmToken, details.fcmPushSet)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Gets a PushSubscription for the current user.
     */
    BaseController.prototype.getPushSubscription = function (swRegistration, publicVapidKey) {
        return swRegistration.pushManager.getSubscription().then(function (subscription) {
            if (subscription) {
                return subscription;
            }
            return swRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: publicVapidKey
            });
        });
    };
    //
    // The following methods should only be available in the window.
    //
    BaseController.prototype.requestPermission = function () {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.useServiceWorker = function (registration) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.usePublicVapidKey = function (b64PublicKey) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.onMessage = function (nextOrObserver, error, completed) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    BaseController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_WINDOW);
    };
    //
    // The following methods are used by the service worker only.
    //
    BaseController.prototype.setBackgroundMessageHandler = function (callback) {
        throw errorFactory.create(ERROR_CODES.AVAILABLE_IN_SW);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    BaseController.prototype.delete = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all([
                            this.tokenDetailsModel.closeDatabase(),
                            this.vapidDetailsModel.closeDatabase()
                        ])];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns the current Notification Permission state.
     */
    BaseController.prototype.getNotificationPermission_ = function () {
        // TODO: Remove the cast when this issue is fixed:
        // https://github.com/Microsoft/TypeScript/issues/14701
        // tslint:disable-next-line no-any
        return Notification.permission;
    };
    BaseController.prototype.getTokenDetailsModel = function () {
        return this.tokenDetailsModel;
    };
    BaseController.prototype.getVapidDetailsModel = function () {
        return this.vapidDetailsModel;
    };
    // Visible for testing
    // TODO: make protected
    BaseController.prototype.getIidModel = function () {
        return this.iidModel;
    };
    return BaseController;
}());
/**
 * Checks if the tokenDetails match the details provided in the clients.
 */
function isTokenStillValid(pushSubscription, publicVapidKey, tokenDetails) {
    if (!tokenDetails.vapidKey ||
        !isArrayBufferEqual(publicVapidKey.buffer, tokenDetails.vapidKey.buffer)) {
        return false;
    }
    var isEndpointEqual = pushSubscription.endpoint === tokenDetails.endpoint;
    var isAuthEqual = isArrayBufferEqual(pushSubscription.getKey('auth'), tokenDetails.auth);
    var isP256dhEqual = isArrayBufferEqual(pushSubscription.getKey('p256dh'), tokenDetails.p256dh);
    return isEndpointEqual && isAuthEqual && isP256dhEqual;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FCM_MSG = 'FCM_MSG';
var SwController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(SwController, _super);
    function SwController(app) {
        var _this = _super.call(this, app) || this;
        _this.bgMessageHandler = null;
        self.addEventListener('push', function (e) {
            _this.onPush(e);
        });
        self.addEventListener('pushsubscriptionchange', function (e) {
            _this.onSubChange(e);
        });
        self.addEventListener('notificationclick', function (e) {
            _this.onNotificationClick(e);
        });
        return _this;
    }
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onPush = function (event) {
        event.waitUntil(this.onPush_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onSubChange = function (event) {
        event.waitUntil(this.onSubChange_(event));
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.onNotificationClick = function (event) {
        event.waitUntil(this.onNotificationClick_(event));
    };
    /**
     * A handler for push events that shows notifications based on the content of
     * the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The
     * value of the `notification` property will be used as the NotificationOptions
     * object passed to showNotification. Additionally, the `title` property of the
     * notification object will be used as the title.
     *
     * If there is no notification data in the payload then no notification will be
     * shown.
     */
    SwController.prototype.onPush_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var msgPayload, hasVisibleClients, notificationDetails, notificationTitle, reg, actions, maxActions;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.data) {
                            return [2 /*return*/];
                        }
                        try {
                            msgPayload = event.data.json();
                        }
                        catch (err) {
                            // Not JSON so not an FCM message
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.hasVisibleClients_()];
                    case 1:
                        hasVisibleClients = _a.sent();
                        if (hasVisibleClients) {
                            // App in foreground. Send to page.
                            return [2 /*return*/, this.sendMessageToWindowClients_(msgPayload)];
                        }
                        notificationDetails = this.getNotificationData_(msgPayload);
                        if (!notificationDetails) return [3 /*break*/, 3];
                        notificationTitle = notificationDetails.title || '';
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 2:
                        reg = _a.sent();
                        actions = notificationDetails.actions;
                        maxActions = Notification.maxActions;
                        // tslint:enable no-any
                        if (actions && maxActions && actions.length > maxActions) {
                            console.warn("This browser only supports " + maxActions + " actions." +
                                "The remaining actions will not be displayed.");
                        }
                        return [2 /*return*/, reg.showNotification(notificationTitle, notificationDetails)];
                    case 3:
                        if (!this.bgMessageHandler) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.bgMessageHandler(msgPayload)];
                    case 4:
                        _a.sent();
                        return [2 /*return*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onSubChange_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var registration, err_1, err_2, tokenDetailsModel, tokenDetails;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        registration = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        err_1 = _a.sent();
                        throw errorFactory.create(ERROR_CODES.UNABLE_TO_RESUBSCRIBE, {
                            message: err_1
                        });
                    case 3:
                        _a.trys.push([3, 5, , 8]);
                        return [4 /*yield*/, registration.pushManager.getSubscription()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 8];
                    case 5:
                        err_2 = _a.sent();
                        tokenDetailsModel = this.getTokenDetailsModel();
                        return [4 /*yield*/, tokenDetailsModel.getTokenDetailsFromSWScope(registration.scope)];
                    case 6:
                        tokenDetails = _a.sent();
                        if (!tokenDetails) {
                            // This should rarely occure, but could if indexedDB
                            // is corrupted or wiped
                            throw err_2;
                        }
                        // Attempt to delete the token if we know it's bad
                        return [4 /*yield*/, this.deleteToken(tokenDetails.fcmToken)];
                    case 7:
                        // Attempt to delete the token if we know it's bad
                        _a.sent();
                        throw err_2;
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    SwController.prototype.onNotificationClick_ = function (event) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var msgPayload, link, windowClient, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!event.notification ||
                            !event.notification.data ||
                            !event.notification.data[FCM_MSG]) {
                            // Not an FCM notification, do nothing.
                            return [2 /*return*/];
                        }
                        else if (event.action) {
                            // User clicked on an action button.
                            // This will allow devs to act on action button clicks by using a custom
                            // onNotificationClick listener that they define.
                            return [2 /*return*/];
                        }
                        // Prevent other listeners from receiving the event
                        event.stopImmediatePropagation();
                        event.notification.close();
                        msgPayload = event.notification.data[FCM_MSG];
                        if (!msgPayload.notification) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        link = (msgPayload.fcmOptions && msgPayload.fcmOptions.link) ||
                            msgPayload.notification.click_action;
                        if (!link) {
                            // Nothing to do.
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getWindowClient_(link)];
                    case 1:
                        windowClient = _a.sent();
                        if (!!windowClient) return [3 /*break*/, 3];
                        return [4 /*yield*/, self.clients.openWindow(link)];
                    case 2:
                        // Unable to find window client so need to open one.
                        windowClient = _a.sent();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, windowClient.focus()];
                    case 4:
                        windowClient = _a.sent();
                        _a.label = 5;
                    case 5:
                        if (!windowClient) {
                            // Window Client will not be returned if it's for a third party origin.
                            return [2 /*return*/];
                        }
                        // Delete notification and fcmOptions data from payload before sending to
                        // the page.
                        delete msgPayload.notification;
                        delete msgPayload.fcmOptions;
                        internalMsg = createNewMsg(MessageType.NOTIFICATION_CLICKED, msgPayload);
                        // Attempt to send a message to the client to handle the data
                        // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
                        return [2 /*return*/, this.attemptToMessageClient_(windowClient, internalMsg)];
                }
            });
        });
    };
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getNotificationData_ = function (msgPayload) {
        if (!msgPayload) {
            return;
        }
        if (typeof msgPayload.notification !== 'object') {
            return;
        }
        var notificationInformation = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation.data = Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__assign"])({}, msgPayload.notification.data, (_a = {}, _a[FCM_MSG] = msgPayload, _a));
        return notificationInformation;
        var _a;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     *
     * @param callback The callback to be called when a push message is received
     * and a notification must be shown. The callback will be given the data from
     * the push message.
     */
    SwController.prototype.setBackgroundMessageHandler = function (callback) {
        if (!callback || typeof callback !== 'function') {
            throw errorFactory.create(ERROR_CODES.BG_HANDLER_FUNCTION_EXPECTED);
        }
        this.bgMessageHandler = callback;
    };
    /**
     * @param url The URL to look for when focusing a client.
     * @return Returns an existing window client or a newly opened WindowClient.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.getWindowClient_ = function (url) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var parsedURL, clientList, suitableClient, i, parsedClientUrl;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        parsedURL = new URL(url, self.location.href).href;
                        return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        suitableClient = null;
                        for (i = 0; i < clientList.length; i++) {
                            parsedClientUrl = new URL(clientList[i].url, self.location.href)
                                .href;
                            if (parsedClientUrl === parsedURL) {
                                suitableClient = clientList[i];
                                break;
                            }
                        }
                        return [2 /*return*/, suitableClient];
                }
            });
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @param client The WindowClient to send the message to.
     * @param message The message to send to the client.
     * @returns Returns a promise that resolves after sending the message. This
     * does not guarantee that the message was successfully received.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.attemptToMessageClient_ = function (client, message) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                // NOTE: This returns a promise in case this API is abstracted later on to
                // do additional work
                if (!client) {
                    throw errorFactory.create(ERROR_CODES.NO_WINDOW_CLIENT_TO_MSG);
                }
                client.postMessage(message);
                return [2 /*return*/];
            });
        });
    };
    /**
     * @returns If there is currently a visible WindowClient, this method will
     * resolve to true, otherwise false.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.hasVisibleClients_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var clientList;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        return [2 /*return*/, clientList.some(function (client) { return client.visibilityState === 'visible'; })];
                }
            });
        });
    };
    /**
     * @param msgPayload The data from the push event that should be sent to all
     * available pages.
     * @returns Returns a promise that resolves once the message has been sent to
     * all WindowClients.
     */
    // Visible for testing
    // TODO: Make private
    SwController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _this = this;
            var clientList, internalMsg;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getClientList()];
                    case 1:
                        clientList = _a.sent();
                        internalMsg = createNewMsg(MessageType.PUSH_MSG_RECEIVED, msgPayload);
                        return [4 /*yield*/, Promise.all(clientList.map(function (client) {
                                return _this.attemptToMessageClient_(client, internalMsg);
                            }))];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @return he service worker registration to be used for the push service.
     */
    SwController.prototype.getSWRegistration_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                return [2 /*return*/, self.registration];
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the
     * public VAPID key provided by the developer.
     */
    SwController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var swReg, vapidKeyFromDatabase;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getSWRegistration_()];
                    case 1:
                        swReg = _a.sent();
                        if (!swReg) {
                            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
                        }
                        return [4 /*yield*/, this.getVapidDetailsModel().getVapidFromSWScope(swReg.scope)];
                    case 2:
                        vapidKeyFromDatabase = _a.sent();
                        if (vapidKeyFromDatabase == null) {
                            return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
                        }
                        return [2 /*return*/, vapidKeyFromDatabase];
                }
            });
        });
    };
    return SwController;
}(BaseController));
function getClientList() {
    return self.clients.matchAll({
        type: 'window',
        includeUncontrolled: true
        // TS doesn't know that "type: 'window'" means it'll return WindowClient[]
    });
}
function createNewMsg(msgType, msgData) {
    return _a = {}, _a[MessageParameter.TYPE_OF_MSG] = msgType, _a[MessageParameter.DATA] = msgData, _a;
    var _a;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
var DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var WindowController = /** @class */ (function (_super) {
    Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__extends"])(WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        _this.registrationToUse = null;
        _this.publicVapidKeyToUse = null;
        _this.manifestCheckPromise = null;
        _this.messageObserver = null;
        // @ts-ignore: Unused variable error, this is not implemented yet.
        _this.tokenRefreshObserver = null;
        _this.onMessageInternal = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"])(function (observer) {
            _this.messageObserver = observer;
        });
        _this.onTokenRefreshInternal = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"])(function (observer) {
            _this.tokenRefreshObserver = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * This method returns an FCM token if it can be generated.
     * The return promise will reject if the browser doesn't support
     * FCM, if permission is denied for notifications or it's not
     * possible to generate a token.
     *
     * @return Returns a promise that resolves to an FCM token or null if
     * permission isn't granted.
     */
    WindowController.prototype.getToken = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.manifestCheckPromise) {
                            this.manifestCheckPromise = manifestCheck();
                        }
                        return [4 /*yield*/, this.manifestCheckPromise];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, _super.prototype.getToken.call(this)];
                }
            });
        });
    };
    /**
     * Request permission if it is not currently granted
     *
     * @return Resolves if the permission was granted, otherwise rejects
     */
    WindowController.prototype.requestPermission = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var permissionResult;
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.getNotificationPermission_() === 'granted') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, Notification.requestPermission()];
                    case 1:
                        permissionResult = _a.sent();
                        if (permissionResult === 'granted') {
                            return [2 /*return*/];
                        }
                        else if (permissionResult === 'denied') {
                            throw errorFactory.create(ERROR_CODES.PERMISSION_BLOCKED);
                        }
                        else {
                            throw errorFactory.create(ERROR_CODES.PERMISSION_DEFAULT);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     *
     * @param registration The service worker registration that should be used to
     * receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw errorFactory.create(ERROR_CODES.SW_REGISTRATION_EXPECTED);
        }
        if (this.registrationToUse != null) {
            throw errorFactory.create(ERROR_CODES.USE_SW_BEFORE_GET_TOKEN);
        }
        this.registrationToUse = registration;
    };
    /**
     * This method allows a developer to override the default vapid key
     * and instead use a custom VAPID public key.
     *
     * @param publicKey A URL safe base64 encoded string.
     */
    WindowController.prototype.usePublicVapidKey = function (publicKey) {
        if (typeof publicKey !== 'string') {
            throw errorFactory.create(ERROR_CODES.INVALID_PUBLIC_VAPID_KEY);
        }
        if (this.publicVapidKeyToUse != null) {
            throw errorFactory.create(ERROR_CODES.USE_PUBLIC_KEY_BEFORE_GET_TOKEN);
        }
        var parsedKey = base64ToArrayBuffer(publicKey);
        if (parsedKey.length !== 65) {
            throw errorFactory.create(ERROR_CODES.PUBLIC_KEY_DECRYPTION_FAILED);
        }
        this.publicVapidKeyToUse = parsedKey;
    };
    /**
     * @export
     * @param nextOrObserver An observer object or a function triggered on
     * message.
     * @param error A function triggered on message error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onMessageInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onMessageInternal(nextOrObserver);
        }
    };
    /**
     * @param nextOrObserver An observer object or a function triggered on token
     * refresh.
     * @param error A function triggered on token refresh error.
     * @param completed function triggered when the observer is removed.
     * @return The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, error, completed) {
        if (typeof nextOrObserver === 'function') {
            return this.onTokenRefreshInternal(nextOrObserver, error, completed);
        }
        else {
            return this.onTokenRefreshInternal(nextOrObserver);
        }
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @param registration Registration to wait for service worker to become active
     * @return Wait for service worker registration to become active
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(errorFactory.create(ERROR_CODES.NO_SW_IN_REG));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
                return;
            }
            var stateChangeListener = function () {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                }
                else if (serviceWorker.state === 'redundant') {
                    reject(errorFactory.create(ERROR_CODES.SW_REG_REDUNDANT));
                }
                else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will register the default service worker and return the registration
     * @return The service worker registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse) {
            return this.waitForRegistrationToActivate_(this.registrationToUse);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse is no longer undefined
        this.registrationToUse = null;
        return navigator.serviceWorker
            .register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        })
            .catch(function (err) {
            throw errorFactory.create(ERROR_CODES.FAILED_DEFAULT_REGISTRATION, {
                browserErrorMessage: err.message
            });
        })
            .then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service work to not
                // install
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This will return the default VAPID key or the uint8array version of the public VAPID key
     * provided by the developer.
     */
    WindowController.prototype.getPublicVapidKey_ = function () {
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
                if (this.publicVapidKeyToUse) {
                    return [2 /*return*/, this.publicVapidKeyToUse];
                }
                return [2 /*return*/, DEFAULT_PUBLIC_VAPID_KEY];
            });
        });
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     */
    // Visible for testing
    // TODO: Make private
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data || !event.data[MessageParameter.TYPE_OF_MSG]) {
                // Not a message from FCM
                return;
            }
            var workerPageMessage = event.data;
            switch (workerPageMessage[MessageParameter.TYPE_OF_MSG]) {
                case MessageType.PUSH_MSG_RECEIVED:
                case MessageType.NOTIFICATION_CLICKED:
                    var pushMessage = workerPageMessage[MessageParameter.DATA];
                    if (_this.messageObserver) {
                        _this.messageObserver.next(pushMessage);
                    }
                    break;
                default:
                    // Noop.
                    break;
            }
        }, false);
    };
    return WindowController;
}(BaseController));
/**
 * The method checks that a manifest is defined and has the correct GCM
 * sender ID.
 * @return Returns a promise that resolves if the manifest matches
 * our required sender ID
 */
// Exported for testing
function manifestCheck() {
    return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var manifestTag, manifestContent, response, e_1;
        return Object(__WEBPACK_IMPORTED_MODULE_1_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    manifestTag = document.querySelector('link[rel="manifest"]');
                    if (!manifestTag) {
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, fetch(manifestTag.href)];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    manifestContent = _a.sent();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _a.sent();
                    // If the download or parsing fails allow check.
                    // We only want to error if we KNOW that the gcm_sender_id is incorrect.
                    return [2 /*return*/];
                case 5:
                    if (!manifestContent || !manifestContent.gcm_sender_id) {
                        return [2 /*return*/];
                    }
                    if (manifestContent.gcm_sender_id !== '103953800507') {
                        throw errorFactory.create(ERROR_CODES.INCORRECT_GCM_SENDER_ID);
                    }
                    return [2 /*return*/];
            }
        });
    });
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function (app) {
        if (!isSupported()) {
            throw errorFactory.create(ERROR_CODES.UNSUPPORTED_BROWSER);
        }
        if (self && 'ServiceWorkerGlobalScope' in self) {
            // Running in ServiceWorker context
            return new SwController(app);
        }
        else {
            // Assume we are in the window context.
            return new WindowController(app);
        }
    };
    var namespaceExports = {
        isSupported: isSupported
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(__WEBPACK_IMPORTED_MODULE_2__firebase_app___default.a);
function isSupported() {
    if (self && 'ServiceWorkerGlobalScope' in self) {
        // Running in ServiceWorker context
        return isSWControllerSupported();
    }
    else {
        // Assume we are in the window context.
        return isWindowControllerSupported();
    }
}
/**
 * Checks to see if the required APIs exist.
 */
function isWindowControllerSupported() {
    return (navigator.cookieEnabled &&
        'serviceWorker' in navigator &&
        'PushManager' in window &&
        'Notification' in window &&
        'fetch' in window &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}
/**
 * Checks to see if the required APIs exist within SW Context.
 */
function isSWControllerSupported() {
    return ('PushManager' in self &&
        'Notification' in self &&
        ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
        PushSubscription.prototype.hasOwnProperty('getKey'));
}




/***/ }),
/* 1689 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(564),
    baseFilter = __webpack_require__(1690),
    baseIteratee = __webpack_require__(422),
    isArray = __webpack_require__(54);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 1690 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(1691);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 1691 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(1692),
    createBaseEach = __webpack_require__(1695);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 1692 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(1693),
    keys = __webpack_require__(173);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 1693 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(1694);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 1694 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 1695 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(318);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 45px;\n  padding: 0 8px;\n  background-color: ",";\n"],["\n  display: flex;\n  align-items: center;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 45px;\n  padding: 0 8px;\n  background-color: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: left center;\n"],["\n  background-repeat: no-repeat;\n  background-size: contain;\n  background-position: left center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 29px;\n  height: 23px;\n  margin: 0 10px;\n  background-image: url(",");\n\n  ",";\n"],["\n  width: 29px;\n  height: 23px;\n  margin: 0 10px;\n  background-image: url(",");\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      margin-top: -3px;\n      width: 34px;\n      height: 22px;\n    "],["\n      margin-top: -3px;\n      width: 34px;\n      height: 22px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  width: 79px;\n  height: 19px;\n  background-image: url(",");\n\n  ",";\n"],["\n  width: 79px;\n  height: 19px;\n  background-image: url(",");\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      width: 70px;\n      height: 13px;\n    "],["\n      width: 70px;\n      height: 13px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  width: 29px;\n  height: 29px;\n  margin-left: auto;\n"],["\n  width: 29px;\n  height: 29px;\n  margin-left: auto;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  fill: none;\n"],["\n  fill: none;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  fill: ",";\n"],["\n  fill: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.oneSignalHeaderBg;});var Logo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var LogoView=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Logo)(_templateObject3,function(props){return props.theme.indexLogo;},function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var LogoText=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Logo)(_templateObject5,function(props){return props.theme.headerLogoText;},function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var Svg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject7);var Transparent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].path(_templateObject8);var Colored=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].path(_templateObject9,function(props){return props.theme.accent;});function Header(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LogoView,{thProject:"irontrade"==="siamoption"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LogoText,{thProject:"irontrade"==="siamoption"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,{xmlns:"http://www.w3.org/2000/svg",viewBox:"460.4 83 33.199 33.199"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("g",{transform:"matrix(0.839, 0.545, -0.545, 0.839, 473.472, 83)"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Transparent,{d:"M0,0H24V24H0Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Colored,{d:"M7.58,4.08,6.15,2.65A10.425,10.425,0,0,0,2.03,10.5h2A8.446,8.446,0,0,1,7.58,4.08ZM19.97,10.5h2a10.489,10.489,0,0,0-4.12-7.85L16.43,4.08A8.5,8.5,0,0,1,19.97,10.5ZM18,11c0-3.07-1.64-5.64-4.5-6.32V4a1.5,1.5,0,0,0-3,0v.68C7.63,5.36,6,7.92,6,11v5L4,18v1H20V18l-2-2ZM12,22a1.752,1.752,0,0,0,.4-.04,2.029,2.029,0,0,0,1.44-1.18,2.008,2.008,0,0,0,.15-.78h-4A2.014,2.014,0,0,0,12,22Z"}))));}/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(1698);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Message__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Message__["b"]; });


/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Messages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icons_index__ = __webpack_require__(63);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: fixed;\n  left: 15px;\n  bottom: 15px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  max-width: 395px;\n  width: calc(100% - 20px);\n  z-index: 200;\n\n  @media (min-width: 568px) {\n    max-width: 395px;\n  }\n"],["\n  direction: ",";\n  position: fixed;\n  left: 15px;\n  bottom: 15px;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  max-width: 395px;\n  width: calc(100% - 20px);\n  z-index: 200;\n\n  @media (min-width: 568px) {\n    max-width: 395px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n  min-height: 100px;\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 15px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #000;\n  background-color: #fff;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);\n  border: 2px solid rgba(0, 0, 0, 0.16);\n  box-sizing: border-box;\n"],["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n  min-height: 100px;\n  width: 100%;\n  margin-bottom: 10px;\n  padding: 15px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #000;\n  background-color: #fff;\n  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.16);\n  border: 2px solid rgba(0, 0, 0, 0.16);\n  box-sizing: border-box;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 70px;\n  width: 70px;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 70px;\n  width: 70px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  flex: 1;\n\n  ",";\n"],["\n  flex: 1;\n\n  ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n        padding-right: 15px;\n      "],["\n        padding-right: 15px;\n      "]),_templateObject6=_taggedTemplateLiteral(["\n      padding-left: 15px;\n    "],["\n      padding-left: 15px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  height: auto;\n"],["\n  display: block;\n  width: 100%;\n  height: auto;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: flex-start;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.25;\n  margin-bottom: 0.5rem;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: flex-start;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.25;\n  margin-bottom: 0.5rem;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 16px;\n  color: #717171;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-basis: 16px;\n  color: #717171;\n  cursor: pointer;\n  transition: all 0.3s ease;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n        margin-right: 5px;\n      "],["\n        margin-right: 5px;\n      "]),_templateObject12=_taggedTemplateLiteral(["\n      margin-left: 5px;\n    "],["\n      margin-left: 5px;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Messages=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;});var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref2){var theme=_ref2.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject7);var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h5(_templateObject8);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject9);var Close=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Icons_index__["a" /* CloseIcon */])(_templateObject10,function(props){return props.theme.accent;},function(_ref3){var theme=_ref3.theme;if(theme.direction==="rtl")return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11);return Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);});function Message(_ref4){var title=_ref4.title,icon=_ref4.icon,children=_ref4.children,onDismiss=_ref4.onDismiss,onClick=_ref4.onClick;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{onClick:onClick},icon&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{src:icon,alt:title})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{width:"16px",onClick:onDismiss})),children));}/* harmony default export */ __webpack_exports__["b"] = (Message);

/***/ }),
/* 1699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(97);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_STATE_CLASSES = {
  animating: 'rah-animating',
  animatingUp: 'rah-animating--up',
  animatingDown: 'rah-animating--down',
  animatingToHeightZero: 'rah-animating--to-height-zero',
  animatingToHeightAuto: 'rah-animating--to-height-auto',
  animatingToHeightSpecific: 'rah-animating--to-height-specific',
  static: 'rah-static',
  staticHeightZero: 'rah-static--height-zero',
  staticHeightAuto: 'rah-static--height-auto',
  staticHeightSpecific: 'rah-static--height-specific'
};

var PROPS_TO_OMIT = ['animateOpacity', 'animationStateClasses', 'applyInlineTransitions', 'contentClassName', 'duration', 'easing', 'height', 'delay'];

function omit(obj) {
  for (var _len = arguments.length, keys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    keys[_key - 1] = arguments[_key];
  }

  if (!keys.length) {
    return obj;
  }

  var res = {};
  var objectKeys = Object.keys(obj);

  for (var i = 0; i < objectKeys.length; i++) {
    var key = objectKeys[i];

    if (keys.indexOf(key) === -1) {
      res[key] = obj[key];
    }
  }

  return res;
}

// Start animation helper using nested requestAnimationFrames
function startAnimationHelper(callback) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      callback();
    });
  });
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function isPercentage(height) {
  // Percentage height
  return typeof height === 'string' && height.search('%') === height.length - 1 && isNumber(height.substr(0, height.length - 1));
}

function runCallback(callback) {
  if (callback && typeof callback === 'function') {
    callback();
  }
}

var AnimateHeight = function (_React$Component) {
  _inherits(AnimateHeight, _React$Component);

  function AnimateHeight(props) {
    _classCallCheck(this, AnimateHeight);

    var _this = _possibleConstructorReturn(this, (AnimateHeight.__proto__ || Object.getPrototypeOf(AnimateHeight)).call(this, props));

    var height = 'auto';
    var overflow = 'visible';

    if (isNumber(props.height)) {
      height = props.height < 0 ? 0 : props.height;
      overflow = 'hidden';
    } else if (isPercentage(props.height)) {
      height = props.height;
      overflow = 'hidden';
    }

    _this.animationStateClasses = _extends({}, ANIMATION_STATE_CLASSES, props.animationStateClasses);

    var animationStateClasses = _this.getStaticStateClasses(height);

    _this.state = {
      animationStateClasses: animationStateClasses,
      height: height,
      overflow: overflow,
      shouldUseTransitions: false
    };
    return _this;
  }

  _createClass(AnimateHeight, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var height = this.state.height;

      // Hide content if height is 0 (to prevent tabbing into it)
      // Check for contentElement is added cause this would fail in tests (react-test-renderer)
      // Read more here: https://github.com/Stanko/react-animate-height/issues/17

      if (this.contentElement && this.contentElement.style) {
        this.hideContent(height);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props = this.props,
          delay = _props.delay,
          duration = _props.duration,
          height = _props.height,
          onAnimationEnd = _props.onAnimationEnd,
          onAnimationStart = _props.onAnimationStart;

      // Check if 'height' prop has changed

      if (this.contentElement && height !== prevProps.height) {
        var _cx;

        // Remove display: none from the content div
        // if it was hidden to prevent tabbing into it
        this.showContent(prevState.height);

        // Cache content height
        this.contentElement.style.overflow = 'hidden';
        var contentHeight = this.contentElement.offsetHeight;
        this.contentElement.style.overflow = '';

        // set total animation time
        var totalDuration = duration + delay;

        var newHeight = null;
        var timeoutState = {
          height: null, // it will be always set to either 'auto' or specific number
          overflow: 'hidden'
        };
        var isCurrentHeightAuto = prevState.height === 'auto';

        if (isNumber(height)) {
          // If new height is a number
          newHeight = height < 0 ? 0 : height;
          timeoutState.height = newHeight;
        } else if (isPercentage(height)) {
          newHeight = height;
          timeoutState.height = newHeight;
        } else {
          // If not, animate to content height
          // and then reset to auto
          newHeight = contentHeight; // TODO solve contentHeight = 0
          timeoutState.height = 'auto';
          timeoutState.overflow = null;
        }

        if (isCurrentHeightAuto) {
          // This is the height to be animated to
          timeoutState.height = newHeight;

          // If previous height was 'auto'
          // set starting height explicitly to be able to use transition
          newHeight = contentHeight;
        }

        // Animation classes
        var animationStateClasses = (0, _classnames2.default)((_cx = {}, _defineProperty(_cx, this.animationStateClasses.animating, true), _defineProperty(_cx, this.animationStateClasses.animatingUp, prevProps.height === 'auto' || height < prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingDown, height === 'auto' || height > prevProps.height), _defineProperty(_cx, this.animationStateClasses.animatingToHeightZero, timeoutState.height === 0), _defineProperty(_cx, this.animationStateClasses.animatingToHeightAuto, timeoutState.height === 'auto'), _defineProperty(_cx, this.animationStateClasses.animatingToHeightSpecific, timeoutState.height > 0), _cx));

        // Animation classes to be put after animation is complete
        var timeoutAnimationStateClasses = this.getStaticStateClasses(timeoutState.height);

        // Set starting height and animating classes
        // We are safe to call set state as it will not trigger infinite loop
        // because of the "height !== prevProps.height" check
        this.setState({ // eslint-disable-line react/no-did-update-set-state
          animationStateClasses: animationStateClasses,
          height: newHeight,
          overflow: 'hidden',
          // When animating from 'auto' we first need to set fixed height
          // that change should be animated
          shouldUseTransitions: !isCurrentHeightAuto
        });

        // Clear timeouts
        clearTimeout(this.timeoutID);
        clearTimeout(this.animationClassesTimeoutID);

        if (isCurrentHeightAuto) {
          // When animating from 'auto' we use a short timeout to start animation
          // after setting fixed height above
          timeoutState.shouldUseTransitions = true;

          startAnimationHelper(function () {
            _this2.setState(timeoutState);

            // ANIMATION STARTS, run a callback if it exists
            runCallback(onAnimationStart);
          });

          // Set static classes and remove transitions when animation ends
          this.animationClassesTimeoutID = setTimeout(function () {
            _this2.setState({
              animationStateClasses: timeoutAnimationStateClasses,
              shouldUseTransitions: false
            });

            // ANIMATION ENDS
            // Hide content if height is 0 (to prevent tabbing into it)
            _this2.hideContent(timeoutState.height);
            // Run a callback if it exists
            runCallback(onAnimationEnd);
          }, totalDuration);
        } else {
          // ANIMATION STARTS, run a callback if it exists
          runCallback(onAnimationStart);

          // Set end height, classes and remove transitions when animation is complete
          this.timeoutID = setTimeout(function () {
            timeoutState.animationStateClasses = timeoutAnimationStateClasses;
            timeoutState.shouldUseTransitions = false;

            _this2.setState(timeoutState);

            // ANIMATION ENDS
            // If height is auto, don't hide the content
            // (case when element is empty, therefore height is 0)
            if (height !== 'auto') {
              // Hide content if height is 0 (to prevent tabbing into it)
              _this2.hideContent(newHeight); // TODO solve newHeight = 0
            }
            // Run a callback if it exists
            runCallback(onAnimationEnd);
          }, totalDuration);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.timeoutID);
      clearTimeout(this.animationClassesTimeoutID);
      this.timeoutID = null;
      this.animationClassesTimeoutID = null;
      this.animationStateClasses = null;
    }
  }, {
    key: 'showContent',
    value: function showContent(height) {
      if (height === 0) {
        this.contentElement.style.display = '';
      }
    }
  }, {
    key: 'hideContent',
    value: function hideContent(newHeight) {
      if (newHeight === 0) {
        this.contentElement.style.display = 'none';
      }
    }
  }, {
    key: 'getStaticStateClasses',
    value: function getStaticStateClasses(height) {
      var _cx2;

      return (0, _classnames2.default)((_cx2 = {}, _defineProperty(_cx2, this.animationStateClasses.static, true), _defineProperty(_cx2, this.animationStateClasses.staticHeightZero, height === 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightSpecific, height > 0), _defineProperty(_cx2, this.animationStateClasses.staticHeightAuto, height === 'auto'), _cx2));
    }
  }, {
    key: 'render',
    value: function render() {
      var _cx3,
          _this3 = this;

      var _props2 = this.props,
          animateOpacity = _props2.animateOpacity,
          applyInlineTransitions = _props2.applyInlineTransitions,
          children = _props2.children,
          className = _props2.className,
          contentClassName = _props2.contentClassName,
          duration = _props2.duration,
          easing = _props2.easing,
          delay = _props2.delay,
          style = _props2.style;
      var _state = this.state,
          height = _state.height,
          overflow = _state.overflow,
          animationStateClasses = _state.animationStateClasses,
          shouldUseTransitions = _state.shouldUseTransitions;


      var componentStyle = _extends({}, style, {
        height: height,
        overflow: overflow || style.overflow
      });

      if (shouldUseTransitions && applyInlineTransitions) {
        componentStyle.transition = 'height ' + duration + 'ms ' + easing + ' ' + delay + 'ms';

        // Include transition passed through styles
        if (style.transition) {
          componentStyle.transition = style.transition + ', ' + componentStyle.transition;
        }

        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
      }

      var contentStyle = {};

      if (animateOpacity) {
        contentStyle.transition = 'opacity ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;

        if (height === 0) {
          contentStyle.opacity = 0;
        }
      }

      var componentClasses = (0, _classnames2.default)((_cx3 = {}, _defineProperty(_cx3, animationStateClasses, true), _defineProperty(_cx3, className, className), _cx3));

      return _react2.default.createElement(
        'div',
        _extends({}, omit.apply(undefined, [this.props].concat(PROPS_TO_OMIT)), {
          'aria-hidden': height === 0,
          className: componentClasses,
          style: componentStyle
        }),
        _react2.default.createElement(
          'div',
          {
            className: contentClassName,
            style: contentStyle,
            ref: function ref(el) {
              return _this3.contentElement = el;
            }
          },
          children
        )
      );
    }
  }]);

  return AnimateHeight;
}(_react2.default.Component);

AnimateHeight.propTypes = {
  animateOpacity: _propTypes2.default.bool,
  animationStateClasses: _propTypes2.default.object,
  applyInlineTransitions: _propTypes2.default.bool,
  children: _propTypes2.default.any.isRequired,
  className: _propTypes2.default.string,
  contentClassName: _propTypes2.default.string,
  duration: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  easing: _propTypes2.default.string,
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  onAnimationEnd: _propTypes2.default.func,
  onAnimationStart: _propTypes2.default.func,
  style: _propTypes2.default.object
};

AnimateHeight.defaultProps = {
  animateOpacity: false,
  animationStateClasses: ANIMATION_STATE_CLASSES,
  applyInlineTransitions: true,
  duration: 250,
  delay: 0,
  easing: 'ease',
  style: {}
};

exports.default = AnimateHeight;

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Loadable__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_trade__ = __webpack_require__(1701);
// <Trade/> сплитится на мобильный и десктопный
/* harmony default export */ __webpack_exports__["a"] = ([{path:"/setup-webapp",exact:true,component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 837));},"pages/index")},{path:"/regbonus",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 2108));},"pages/regbonus")},{path:"/harakiri",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 2109));},"pages/harakiri")},/*{
    path: "/binary-options",
    component: Loadable(() =>
      import(/!* webpackChunkName: "binary-options" *!/ "./pages/binary-options"), "pages/binary-options"
    )
  },*/{path:"/",exact:true,component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 2110));},"pages/analytics")},{path:"/item/:id",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 2111));},"pages/signal-item")},{path:"/news",exact:true,component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].enableHelpdeskNews===true&&"irontrade"!=="eztrader"?__webpack_require__.e/* import() */(75).then(__webpack_require__.bind(null, 2088)):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"pages/news")},{path:"/news/:id",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].enableHelpdeskNews===true&&"irontrade"!=="eztrader"?__webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 2112)):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"pages/news-item")},{path:"/error",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(77).then(__webpack_require__.bind(null, 2113));},"pages/error")},{path:"/trade/:stock*",render:function render(_ref){var match=_ref.match;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__pages_trade__["a" /* default */],{stock:match.params.stock});}},{path:"/conditions",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  false?import(/* webpackChunkName: "404" */"./pages/404"):__webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 2114));},"pages/conditions")},{path:"/risk-notifications",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 2115));},"pages/risk-notifications")},{path:"/payment-privacy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  false?import(/* webpackChunkName: "404" */"./pages/404"):__webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 2116));},"pages/payment-privacy")},{path:"/payment-policy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  false?import(/* webpackChunkName: "404" */"./pages/404"):__webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 2117));},"pages/payment-policy")},{path:"/privacy-policy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  false?import(/* webpackChunkName: "404" */"./pages/404"):__webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 2118));},"pages/privacy-policy")},{path:"/bonus-program",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 2119));},"pages/bonus-program")},/*{
    path: "/binaryvsoptions",
    component: Loadable(() =>
      import(/!* webpackChunkName: "binary-vs-options" *!/ "./pages/binary-vs-options"), "pages/binary-vs-options"
    )
  },*/{path:"/return-refund-policy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  false?import(/* webpackChunkName: "404" */"./pages/404"):__webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 2120));},"pages/return-refund-policy")},{path:"/aml-policy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 2121));},"pages/aml-policy")},{path:"/profile",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 2122));},"pages/profile")},// {
//   path: "/verification",
//   component: Loadable(
//     () =>
//       import(/* webpackChunkName: "verification" */ "./pages/verification"),
//     "pages/verification"
//   )
// },
{path:"/verification",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:"/profile"});}},{path:"/fillup",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 472));},"pages/fillup")},{path:"/billing/kerry-express",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 2123));},"pages/billing-kerry-express")},{path:"/about",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 875));},"pages/about")},{path:"/ios-about",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 875));},"pages/about")},{path:"/email/confirm/success",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(79).then(__webpack_require__.bind(null, 2124));},"pages/confirm-email")},{path:"/email/confirm/error",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(78).then(__webpack_require__.bind(null, 2125));},"pages/error-email")},{path:"/faq",component:function component(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Redirect */],{to:"/helpdesk/faq#intro"});}},{path:"/ios-faq",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 2126));},"pages/faq")},{path:"/withdraw-old",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2127));},"pages/withdraw")},{path:"/withdraw",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 2128));},"pages/withdraw-new")},{path:"/support",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 876));},"pages/support")},{path:"/ios-support",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 876));},"pages/support")},{path:"/unsubscribe",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(72).then(__webpack_require__.bind(null, 2129));},"pages/unsubscribe")},{path:"/tutorials",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 2130));},"pages/tutorials")},{path:"/trading-history",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 782));},"pages/trading-history")},{path:"/finance-history",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 2131));},"pages/finance-history")},{path:"/login",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 2132));},"pages/login")},{path:"/ios",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 837));},"pages/index")},{path:"/register",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(74).then(__webpack_require__.bind(null, 2133));},"pages/register")},{path:"/logout",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(76).then(__webpack_require__.bind(null, 2134));},"pages/logout")},{path:"/billing/offline",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 2135));},"pages/offline-billing")},{path:"/password-update",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 2136));},"pages/change-password")},{path:"/billing/*/success",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 181));},"pages/billing-success")},{path:"/billing/*/return",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 181));},"pages/billing-success")},{path:"/billing/*/complete",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 181));},"pages/billing-success")},{path:"/billing/*/fail",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 877));},"pages/billing-fail")},{path:"/billing/success",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 181));},"pages/billing-success")},{path:"/billing/return",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 181));},"pages/billing-success")},{path:"/billing/complete",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 181));},"pages/billing-success")},{path:"/billing/fail",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 877));},"pages/billing-fail")},{path:"/billing/redirect",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(80).then(__webpack_require__.bind(null, 2137));},"pages/billing-redirect")},// qr-кодов вроде не будет, но будем считать, что страничка есть
{path:"/billing/paytoday/show_qr",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 2138));},"pages/billing-qr")},// helpdesk index page
{path:"/contacts",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].enableHelpdesk===true?__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 878)):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"pages/helpdesk")},{path:"/aboutus",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].enableHelpdesk===true?__webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 878)):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"pages/helpdesk")},{path:"/promo",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 2139));},"pages/promo")},{path:"/sightseeing",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 2140));},"pages/sightseeing")},{path:"/app-download",exact:true,component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  false?import(/* webpackChunkName: "404" */"./pages/404"):__webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 2141));},"pages/app-download")},{path:"/tournaments",exact:true,component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].enableTournaments===true?__webpack_require__.e/* import() */(73).then(__webpack_require__.bind(null, 2142)):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"pages/tournaments")},{path:"/tournaments/:id",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __WEBPACK_IMPORTED_MODULE_2__FeatureFlags__["a" /* default */].enableTournaments===true?__webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 2089)):__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));},"pages/tournament")},// {
//   path: "/exclusive-strategy/",
//   exact: true,
//   component: Loadable(() =>
//     import(/* webpackChunkName: "exclusive-strategy-list" */ "./pages/exclusive-strategy-list.js"), "pages/exclusive-strategy-list.js"
//   )
// },
{path:"/exclusive-strategy/:name",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2143));},"pages/exclusive-strategy")},{path:"/ironcard/:bool",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  true?__webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 2144)):import(/* webpackChunkName: "404" */"./pages/404");},"pages/ironcard")},{path:"/new-fillup",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 2145));},"pages/html/fillup/index")},{path:"/test-for-users",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 2146));})},{path:"/complaint-handling-policy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  true?__webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 2147)):import(/* webpackChunkName: "404" */"./pages/404");})},{path:"/withdrawal-funds-policy",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  true?__webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 2148)):import(/* webpackChunkName: "404" */"./pages/404");})},{path:"/webview/rating",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return  true?__webpack_require__.e/* import() */(71).then(__webpack_require__.bind(null, 2149)):import(/* webpackChunkName: "404" */"./pages/404");})},{path:"/bonus-review",component:Object(__WEBPACK_IMPORTED_MODULE_3__components_Loadable__["a" /* default */])(function(){return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 122));})}]);

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Private__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_TradingPlatform__ = __webpack_require__(1702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_FreeBonusPopup__ = __webpack_require__(1729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Trade_Mobile__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Trade_Desktop__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_hooks_useBonusTimer__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_SocialTrading_ToggleSocial__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_ABTest__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_TradeModals_ProfitableTerms__ = __webpack_require__(2040);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var TourRotator=function TourRotator(props){var showTour=!props.tourRefBonus&&props.tourShownForUser!==1&&!props.tourGetReal&&!sessionStorage.getItem("showTourLater")&&props.showDeposit||parseFloat(props.tourGetFundsAvailableReal)>0&&props.tourRegScenario==="full_real"&&props.showDeposit;return showTour?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{push:true,to:"/sightseeing"}):null;};function Platform(props){var stock=props.stock;var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),_React$useState2=_slicedToArray(_React$useState,2),showSocialTrading=_React$useState2[0],toggleSocialTrading=_React$useState2[1];var _React$useState3=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),_React$useState4=_slicedToArray(_React$useState3,2),showBonusPopup=_React$useState4[0],toggleBonusPopup=_React$useState4[1];var bonus=Object(__WEBPACK_IMPORTED_MODULE_12__components_hooks_useBonusTimer__["a" /* useBonusTimerApi */])({time:props.time});var bonusAvailable=bonus!=null&&bonus.duration>0&&bonus.status==="available";__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function(){var shownKey=props.userId+":bonusPopup";try{var alreadyShown=localStorage.getItem(shownKey);if(bonusAvailable&&!JSON.parse(alreadyShown)){toggleBonusPopup(true);}}catch(e){}},[props.userId,toggleBonusPopup,bonusAvailable]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__components_SocialTrading_ToggleSocial__["a" /* SocialTradingContext */].Provider,{value:[showSocialTrading,toggleSocialTrading]},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__components_ThemeProvider__["d" /* TradeThemeProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__components_ABTest__["a" /* default */],{campaign:"80_percent_user"},showBonusPopup&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__components_FreeBonusPopup__["a" /* default */],{promo:bonus&&bonus.promo,onClose:function onClose(){toggleBonusPopup(false);try{localStorage.setItem(props.userId+":bonusPopup",JSON.stringify(true));}catch(e){}}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__components_TradeModals_ProfitableTerms__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TourRotator,props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__components_common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref){var showModal=_ref.showModal,hideModal=_ref.hideModal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__components_TradingPlatform__["a" /* default */],{userId:props.userId,dispatch:props.dispatch,layout:matches?__WEBPACK_IMPORTED_MODULE_9__components_Trade_Mobile__["a" /* default */]:__WEBPACK_IMPORTED_MODULE_10__components_Trade_Desktop__["a" /* default */],stock:(stock||"").toUpperCase(),showModal:showModal,hideModal:hideModal});});}))));}function mapStateToProps(state){if(state.serverData==null){throw new TypeError("Rare race condition when profile appears eariler than serverData");}return{time:state.time||Date.now(),userId:state.profile&&state.profile.id,tourGetFundsAvailableReal:state.serverData.tourGetFundsAvailableReal,tourGetReal:state.serverData.tourGetReal,tourRefBonus:state.serverData.tourRefBonus,tourRegScenario:state.serverData.tourRegScenario,tourShownForUser:state.profile&&state.profile.tour_shown};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__components_Private__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_11__components_common_withDeposit__["b" /* withDeposit */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(Platform))));

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_querystring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_clamp__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App_js__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_toastify_dist_ReactToastify_css__ = __webpack_require__(1705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_toastify_dist_ReactToastify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_react_toastify_dist_ReactToastify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__constants__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_TradeModals_EarlySalePopup__ = __webpack_require__(1706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__ = __webpack_require__(1725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_RtlProvider__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__redux_reducer_socket__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__redux_reducer_stocks__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Sightseeing_Intro__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Sightseeing_Outro__ = __webpack_require__(1728);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  color: #03a9f4;\n"],["\n  color: #03a9f4;\n"]),_templateObject2=_taggedTemplateLiteral(["Try to change the expiration time. Sometimes it's exactly what it takes to win."],["Try to change the expiration time. Sometimes it's exactly what it takes to win."]),_templateObject3=_taggedTemplateLiteral(["Try to use another asset. Probably you can have better profits with it."],["Try to use another asset. Probably you can have better profits with it."]),_templateObject4=_taggedTemplateLiteral(["Pay attention to the profit percentage."],["Pay attention to the profit percentage."]),_templateObject5=_taggedTemplateLiteral(["Try to trade different assets and earn maximum profits!"],["Try to trade different assets and earn maximum profits!"]);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { ToastContainer, toast } from 'react-toastify';
// import {
//   calcBalancePercentage,
//   disableRefill
// } from "./Tournaments/helpers/refill";
var Link=__WEBPACK_IMPORTED_MODULE_1_react__["memo"](Object(__WEBPACK_IMPORTED_MODULE_8_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_12__common_Link__["a" /* Link */])(_templateObject));var earlyClosePopupShown=false;var TradingPlatform=function(_React$Component){_inherits(TradingPlatform,_React$Component);function TradingPlatform(props){var _this2=this;_classCallCheck(this,TradingPlatform);var _this=_possibleConstructorReturn(this,(TradingPlatform.__proto__||Object.getPrototypeOf(TradingPlatform)).call(this,props));_this.state={refundFetching:new Set(),showInsufficientFundsMessage:false,showVerificationRequired:false,showIncreaseBidLimit:false,showTradeIsClosing:false,isDealAmountValid:true,errorMessage:"",adsMessage:"",dealsToCompensate:[],compensationUpdated:null,compensationCreated:null,isTriggerPopupOpened:false,showDemoTournament:false,demoTournament:null};_this.getActiveAccount=function(){var activeAccount=_this.props.accounts.find(function(account){return account.id===_this.props.profile.active_account_id;});return activeAccount;};_this.getRecommendedStocks=function(){var activeAccount=_this.getActiveAccount();// const foo = filterPopular(
//   this.props.stocks,
//   activeAccount && activeAccount.type === "real"
//     ? item => item.realProfit
//     : item => item.demoProfit,
//   3);
// const recommendations = Object.keys(foo)
//   .map(item => foo[item])
var recommendations=Object.keys(_this.props.stocks).map(function(symbol){return _this.props.stocks[symbol];}).filter(function(stock){return stock.enabled&&!_this.props.tabs.tabs.includes(stock.stock);}).sort(function(a,b){return activeAccount&&activeAccount.type==="real"?b.realProfit-a.realProfit:b.demoProfit-a.demoProfit;}).slice(0,3)||[];return recommendations;};_this.validateDealAmount=function(isDealAmountValid){_this.setState({isDealAmountValid:isDealAmountValid});};_this.showIncreaseBidLimitMessage=function(){_this.setState({showIncreaseBidLimit:true});};_this.dismissIncreaseBidLimitMessage=function(){var profile=_this.props.profile;var bid_limit=5000;if(profile){if(profile.bid_limit){bid_limit=_typeof(profile.bid_limit)==="object"?profile.bid_limit[profile.currency]:profile.bid_limit;}}_this.props.dispatch({type:"UPDATE_SETTINGS",payload:{currentBid:bid_limit}});_this.setState({showIncreaseBidLimit:false});};_this.dismissInsufficientFundsMessage=function(){_this.setState({showInsufficientFundsMessage:false});};_this.dismissErrorMessage=function(){_this.setState({errorMessage:""});};_this.dismissVerificationRequiredMessage=function(){_this.setState({showVerificationRequired:false});};_this.dismissTradeIsClosing=function(){_this.setState({showTradeIsClosing:false});};_this.dismissDemoTournament=function(){_this.setState({showDemoTournament:false});};_this.handleError=function(error){console.log(error);};_this.refillDemoAccount=function(){_this.setState({isRefillFetching:true});return _this.props.fetch("/ajax/refillDemoDeposit").then(_this.refreshProfile).then(function(){_this.props.dispatch({type:"REQUEST_ACCOUNTS"});}).catch(_this.handleError).then(function(){return _this.setState({isRefillFetching:false});});};_this.refundClickHandler=function(dealId){var refundFetching=new Set(_this.state.refundFetching);refundFetching.add(dealId);_this.setState({refundFetching:refundFetching});return _this.props.fetch("/api/trading/op-close-early?op_id="+dealId).catch(function(){var refundFetching=new Set(_this.state.refundFetching);refundFetching.delete(dealId);_this.setState({refundFetching:refundFetching});}).then(function(){// Ничего не делаем при успешном закрытии, чтобы компоненты закрытия сделки
// на графике и в истории не вернулись в исходное состояние.
// При получении сообщения в сокете о закрытии сделки они пропадут вместе со сделкой
});};_this.refreshProfile=function(){_this.props.dispatch({type:"REQUEST_PROFILE"});var p=new Promise(function(r){return r();});return p;};_this.tryMakingADeal=function(deal){if(deal.accountType==="real"){_this.threeDealsInARowTrigger();}return _this.props.mode==="tournament"?_this.tryMakingADealTournament(deal):_this.tryMakingADealBinary(deal);};_this.earlySaleCounters=function(){try{var shownKey=_this.props.profile.id+":earlyClosePopup";var storageShown=localStorage.getItem(shownKey);if(JSON.parse(storageShown)!==true){var _key=_this.props.profile.id+":earlyCloseDealsCount";var storage=localStorage.getItem(_key);var count=1;if(JSON.parse(storage)!=null){count=parseInt(storage,10)+1;}if(count<5){localStorage.setItem(_key,count);}if(count>=5&&!earlyClosePopupShown){_this.props.showModal(__WEBPACK_IMPORTED_MODULE_17__components_TradeModals_EarlySalePopup__["a" /* default */],{userId:_this.props.profile.id,lang:_this.props.profile.locale});earlyClosePopupShown=true;}}}catch(e){}};_this.requestStockHistory=function(){var stock=Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(_this.props.tabs);var limit=7200;//2 hours
return _this.props.fetch("/ajax/stockHistory?stock="+stock+"&limit="+limit+"&tz=UTC").then(function(history){_this.props.dispatch({type:"RECEIVE_STOCK_HISTORY",payload:{stock:stock,history:history}});}).catch(_this.handleError);};_this.recommendedStockClickHandler=function(stock){_this.props.dispatch({type:"SET_ACTIVE_STOCK",payload:{newStock:stock,activeStock:_this.props.activeStock}});};_this.handleReduxAction=function(action){if(action.type==="RECEIVE_SOCKET_MESSAGE"){switch(action.payload.op){//case "tournamentOperationOpened":
case"tournamentOperationClosed":{_this.setState({isDealAmountValid:true});_this.props.tournament.fetchEntity("/api/tournaments/stats");_this.props.tournament.fetchEntity("/api/tournaments/operations?account_id="+action.payload.accountId,{force:true});break;}case"tournament-status-change":_this.props.tournament.fetchEntity("/api/tournaments/stats");break;case"operationClosed":if(action.payload.can_compensate===true){_this.setState({dealsToCompensate:_this.state.dealsToCompensate.concat(action.payload)});}else if(!_this.state.isTriggerPopupOpened){var configLostPercent=_this.bigLossTrigger.params.percent;var lossPercent=action.payload.profit*100/(action.payload.profit-action.payload.balance);var a=_this.bigLossTrigger.trigger(null,{profitable:action.payload.profit>=0||action.payload.real===0,percent:configLostPercent,lowPercent:lossPercent>=configLostPercent});if(a===true){_this.setState({isTriggerPopupOpened:true});break;}var isVIP=_this.props.serverData.isVIP;var profitPercent=_this.lowProfitWinTrigger.params.percent;var vipProfitPercent=_this.lowProfitWinTrigger.params.vipPercent;var payloadPercent=action.payload.profitPercent;var b=_this.lowProfitWinTrigger.trigger(null,{profitable:action.payload.profit>0&&action.payload.real===1,percent:profitPercent,vipPercent:vipProfitPercent,lowPercent:isVIP&&payloadPercent<vipProfitPercent||!isVIP&&payloadPercent<profitPercent});if(b===true){_this.setState({isTriggerPopupOpened:true});break;}var c=_this.sameStockDealsTrigger(action.payload.stock,{profitable:action.payload.profit>=0||action.payload.real===0});if(c===true){_this.setState({isTriggerPopupOpened:true});break;}var d=_this.sameIntervalDealsTrigger(action.payload.bidTime,{profitable:action.payload.profit>=0||action.payload.real===0});if(d===true){_this.setState({isTriggerPopupOpened:true});break;}}break;case"compensation-updated":_this.setState({compensationUpdated:action.payload});break;case"compensation-created":_this.setState({compensationCreated:action.payload});break;case"demo-tournament":_this.setState({demoTournament:action.payload,showDemoTournament:true});break;default:break;}}};_this.onCompensation=function(deal){_this.setState(function(s){return{dealsToCompensate:s.dealsToCompensate.filter(function(d){return d!==deal;})};});};_this.onCompensationCreated=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var realAccount,data,payload;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(_this.state.compensationCreated!=null&&_this.state.compensationCreated.payload.real===0)){_context.next=3;break;}_this.setState({compensationCreated:null});return _context.abrupt("return");case 3:realAccount=_this.props.accounts.find(function(acc){return acc.type==="real";});if(!(!realAccount||realAccount.isActive===true)){_context.next=7;break;}_this.setState({compensationCreated:null});return _context.abrupt("return");case 7:_context.next=9;return _this.props.fetch("/ajax/setAccount?id="+realAccount.id);case 9:data=_context.sent;if(data.status==="OK"){_this.props.dispatch({type:"SWITCH_ACCOUNTS"});}_context.next=13;return _this.props.fetch("/api/profile");case 13:payload=_context.sent;_this.props.dispatch({type:"RECEIVE_PROFILE",payload:payload});_this.setState({compensationCreated:null});case 16:case"end":return _context.stop();}}},_callee,_this2);}));_this.showDemoCompensationsPopup=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var features,isDemoCompensationsAvailable,compensationsInfo,compensations,popupShown;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.tournament.readEntity("/api/features/list");case 2:features=_context2.sent;isDemoCompensationsAvailable=features.value&&features.value.find(function(feature){return feature.name==="demo_compensations";});if(isDemoCompensationsAvailable){_context2.next=6;break;}return _context2.abrupt("return");case 6:_context2.next=8;return _this.props.tournament.fetchEntity("/api/compensations/info");case 8:compensationsInfo=_context2.sent;compensations=__WEBPACK_IMPORTED_MODULE_9_idx___default()(compensationsInfo,function(_){return _.value;});popupShown=function popupShown(){try{return localStorage.getItem("demoCompensationsPopupShown");}catch(e){console.error(e);return true;}};// если у пользователя есть демокомпенсации,
// нету реальных компенсаций,
// не тратил демо компесанции
// и это его первая сессия,
// то показываем попап о начислении демокомпенсаций
if(compensations.demo.count>0&&compensations.real.count<1&&compensations.demo.stats.compensated==null&&_this.props.profile.session_count<2&&!popupShown()){try{localStorage.setItem("demoCompensationsPopupShown",true);}catch(e){console.error(e);}_this.setState({compensationCreated:{payload:{real:0}}});}case 12:case"end":return _context2.stop();}}},_callee2,_this2);}));_this.original=__WEBPACK_IMPORTED_MODULE_1_react__["createRef"](null);_this.originalLast=__WEBPACK_IMPORTED_MODULE_1_react__["createRef"](null);var sameIntervalDealsTrigger=Object(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["b" /* runBehaviourTrigger */])(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["a" /* config */].sameIntervalDeals,function(){console.log("sameIntervalDeals trigger complete");// toast(this.props.gettext`Try to change the expiration time. Sometimes it's exactly what it takes to win.`);
_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:_this.props.gettext(_templateObject2),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("TRIGGER_INTERVALS_SHOW");},{storageKeyPrefix:_this.props.profile.id});var sameStockDealsTrigger=Object(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["b" /* runBehaviourTrigger */])(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["a" /* config */].sameStockDeals,function(){console.log("sameStockDeals trigger complete");// toast(this.props.gettext`Try to use another asset. Probably you can have better profits with it.`);
_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:_this.props.gettext(_templateObject3),activeAccount:_this.getActiveAccount(),onStockClick:function onStockClick(stock){_this.recommendedStockClickHandler(stock);Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("TRIGGER_STOCKS_CLICK",{stock:stock});},recommendations:_this.getRecommendedStocks(),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});var stock=Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(_this.props.tabs);Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("TRIGGER_STOCKS_SHOW",{stock:stock});},{storageKeyPrefix:_this.props.profile.id});var lowProfitWinTrigger=Object(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["b" /* runBehaviourTrigger */])(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["a" /* config */].lowProfitWin,function(){console.log("lowProfitWin trigger complete");// toast(
//   this.props.gettext`Pay attention to the profit percentage.` + " " +
//   this.props.gettext`Try to use another asset. Probably you can have better profits with it.`);
_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:_this.props.gettext(_templateObject4)+" "+_this.props.gettext(_templateObject5),activeAccount:_this.getActiveAccount(),onStockClick:function onStockClick(stock){_this.recommendedStockClickHandler(stock);Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("TRIGGER_PERCENT_CLICK",{stock:stock});},recommendations:_this.getRecommendedStocks(),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});var stock=Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(_this.props.tabs);Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("TRIGGER_PERCENT_SHOW",{stock:stock});},{storageKeyPrefix:_this.props.profile.id});var bigLossTrigger=Object(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["b" /* runBehaviourTrigger */])(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["a" /* config */].bigLoss,function(){console.log("bigLoss trigger complete");// toast("bigLoss trigger complete");
_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:// prettier-ignore
__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__common_Gettext__["b" /* default */],null,"Maybe you should stop now and take a rest? It might be even worse further. Learn more about risk management here: ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Link,{to:"/news/effectivetrade",onClick:_this.props.hideModal},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",{style:{textTransform:"lowercase"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__common_Gettext__["b" /* default */],null,"News")))),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});Object(__WEBPACK_IMPORTED_MODULE_11__GA__["a" /* gaReducer */])("TRIGGER_LOSS_SHOW");},{storageKeyPrefix:_this.props.profile.id});var threeDealsInARowTrigger=Object(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["b" /* runBehaviourTrigger */])(__WEBPACK_IMPORTED_MODULE_14__configs_BehaviourTriggers__["a" /* config */].threeDealsInARow,function(){console.log("threeDealsInARow trigger complete");// toast("threeDealsInARow trigger complete");
_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:"Three deals ✔",activeAccount:_this.getActiveAccount(),onStockClick:_this.recommendedStockClickHandler,recommendations:_this.getRecommendedStocks(),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});},{storageKeyPrefix:_this.props.profile.id});_this.sameIntervalDealsTrigger=sameIntervalDealsTrigger[1];_this.sameStockDealsTrigger=sameStockDealsTrigger[1];_this.lowProfitWinTrigger=lowProfitWinTrigger[0];_this.bigLossTrigger=bigLossTrigger[0];_this.threeDealsInARowTrigger=threeDealsInARowTrigger[1];if(__WEBPACK_IMPORTED_MODULE_16__constants__["a" /* debugMode */]&&window.batman===true){window.sameIntervalDealsTrigger=function(){_this.setState({isTriggerPopupOpened:true});_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:_this.props.gettext(_templateObject2),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});};window.sameStockDealsTrigger=function(){_this.setState({isTriggerPopupOpened:true});_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:_this.props.gettext(_templateObject3),activeAccount:_this.getActiveAccount(),onStockClick:_this.recommendedStockClickHandler,recommendations:_this.getRecommendedStocks(),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});};window.lowProfitWinTrigger=function(){_this.setState({isTriggerPopupOpened:true});_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:_this.props.gettext(_templateObject4)+" "+_this.props.gettext(_templateObject5),activeAccount:_this.getActiveAccount(),onStockClick:_this.recommendedStockClickHandler,recommendations:_this.getRecommendedStocks(),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});};window.bigLossTrigger=function(){_this.setState({isTriggerPopupOpened:true});_this.props.showModal(__WEBPACK_IMPORTED_MODULE_18__components_TradeModals_BehaviourTriggersPopup__["a" /* default */],{text:// prettier-ignore
__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__common_Gettext__["b" /* default */],null,"Maybe you should stop now and take a rest? It might be even worse further. Learn more about risk management here: ",__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Link,{to:"/news/effectivetrade",onClick:_this.props.hideModal},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"]("span",{style:{textTransform:"lowercase"}},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__common_Gettext__["b" /* default */],null,"News")))),dismissTriggerPopup:function dismissTriggerPopup(){return _this.setState({isTriggerPopupOpened:false});}});};}return _this;}_createClass(TradingPlatform,[{key:"tryMakingADealTournament",value:function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(deal){var active_tournament,account,query,promise,res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:// Сначала — валидации
active_tournament=this.props.activeTournament.value;if(active_tournament==null){this.props.tournament.simulateError("not_running_tournament");console.error("No tournament chosen");}if(active_tournament.participation_status!==1){this.props.tournament.simulateError("not_running_tournament");console.error("Somehow the chosen tournament is not being participated");}account=active_tournament.account;if(!(deal.amount>parseFloat(account.balance))){_context3.next=8;break;}console.error("You don't have enough money to make this deal");this.validateDealAmount(false);// const refillSum = calcBalancePercentage(active_tournament);
// const disabledRefill = disableRefill({
//   api: this.props.tournament
// });
//
// switch (true) {
//   case parseFloat(account.balance) > refillSum:
//     this.props.tournament.simulateError("no_refill_no_bid");
//     console.error("refill % is not sufficient for refill");
//     break;
//   case disabledRefill:
//     this.props.tournament.simulateError("balance_not_low_refill");
//     console.error("refill is not possible");
//     break;
//   default:
//     this.setState({
//       showTournamentRefill: true
//     });
//     break;
// }
return _context3.abrupt("return");case 8:if(!(this.props.timeUntilNextLockToggle!==Infinity&&this.props.currentTradeInterval*1000>=this.props.timeUntilNextLockToggle)){_context3.next=11;break;}this.setState({showTradeIsClosing:true});// throw new TypeError("Trade is closing soon");
return _context3.abrupt("return");case 11:query=__WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify({stock:deal.stock,account_id:account.id,interval:""+deal.bTime,amount:deal.amount,type:deal.bidType?1:2,profit_percent:this.props.stocks[deal.stock].realProfit-this.props.stocks[deal.stock].profit_vip,serverTime:deal.date,value:deal.value});promise=this.props.fetch("/api/tournaments/openOperation?"+query);this.props.activeTournament.update(function(tournament){return Object.assign({},tournament,{account:Object.assign({},tournament.account,{balance:(parseFloat(tournament.account.balance)-deal.amount).toFixed(2)})});},promise);_context3.next=16;return promise;case 16:res=_context3.sent;//Бэк будет сам разруливать эту тему передавая в сделку нужные параметры
// const features = this.props.tournament.readEntity("/api/features/list");
// const closeEarly =
//   features.value &&
//   features.value.find(feature => feature.name === "operation_early_close");
if(res.payload&&res.payload.earlyClose){this.earlySaleCounters();}// Инвалидировать стату (пока нет апи)
// this.props.tournament.fetchEntity("/api/tournaments/stats");
// инвалидировать сделки
this.props.tournament.fetchEntity("/api/tournaments/operations?account_id="+account.id,{force:true});case 19:case"end":return _context3.stop();}}},_callee3,this);}));function tryMakingADealTournament(_x){return _ref3.apply(this,arguments);}return tryMakingADealTournament;}()},{key:"tryMakingADealBinary",value:function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(deal){var _this3=this;var _props,profile,accounts,stocks,dispatch,bid_limit,activeAccount,query,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_props=this.props,profile=_props.profile,accounts=_props.accounts,stocks=_props.stocks,dispatch=_props.dispatch;bid_limit=5000;if(profile){if(profile.bid_limit){bid_limit=_typeof(profile.bid_limit)==="object"?profile.bid_limit[profile.currency]:profile.bid_limit;}}if(!(profile===null)){_context4.next=5;break;}throw new TypeError("No profile");case 5:if(!(accounts.length===0)){_context4.next=7;break;}throw new TypeError("No accounts");case 7:activeAccount=accounts.find(function(account){return account.id===profile.active_account_id;});if(!((typeof activeAccount==="undefined"?"undefined":_typeof(activeAccount))!=="object")){_context4.next=10;break;}throw new TypeError("No active account, how's that possible?");case 10:if(!(deal.amount>parseFloat(activeAccount.estimatedBalance))){_context4.next=13;break;}this.setState({showInsufficientFundsMessage:true});return _context4.abrupt("return");case 13:if(!(activeAccount&&activeAccount.type!=="demo"&&deal.amount>bid_limit)){_context4.next=16;break;}this.setState({showIncreaseBidLimit:true});// throw new TypeError("Maximum bid exceeded");
return _context4.abrupt("return");case 16:if(!(this.props.timeUntilNextLockToggle!==Infinity&&this.props.currentTradeInterval*1000>=this.props.timeUntilNextLockToggle)){_context4.next=19;break;}this.setState({showTradeIsClosing:true});// throw new TypeError("Trade is closing soon");
return _context4.abrupt("return");case 19:dispatch({type:"REQUEST_DEAL_OPENING",payload:deal});query=__WEBPACK_IMPORTED_MODULE_5_querystring___default.a.stringify({type:deal.bidType?1:2,stock:deal.stock,interval:""+deal.bTime,amount:deal.amount,value:deal.value,accountId:profile.active_account_id,profitPercent:activeAccount.type==="real"?stocks[deal.stock].realProfit:stocks[deal.stock].demoProfit,serverTime:deal.date});_context4.next=23;return new Promise(function(resolve,reject){_this3.setState({isFetchingOpenOperation:true},resolve);});case 23:_context4.next=25;return this.props.fetch("/ajax/openOperation?"+query).then(function(res){if(res.type==="verificationRequired"){_this3.setState({showVerificationRequired:true});}return res;}).then(function(res){_this3.setState({isFetchingOpenOperation:false});return res;});case 25:response=_context4.sent;//Бэк будет сам разруливать эту тему передавая в сделку нужные параметры
//const features = this.props.tournament.readEntity("/api/features/list");
//  const closeEarly =
//    features.value &&
//    features.value.find(feature => feature.name === "operation_early_close");
if(response.type!=="verificationRequired"&&response.earlyClose){this.earlySaleCounters();}dispatch({type:"RECEIVE_DEAL_OPENING_SUCCESS",payload:Object.assign({},deal,{id:Math.random().toString(36).slice(2,8),timestamp:response.openTimestamp/1000,open_timestamp:response.openTimestamp/1000})});case 28:case"end":return _context4.stop();}}},_callee4,this);}));function tryMakingADealBinary(_x2){return _ref4.apply(this,arguments);}return tryMakingADealBinary;}()},{key:"componentDidMount",value:function componentDidMount(){var _this4=this;this.showDemoCompensationsPopup();this.unsubscribe=__WEBPACK_IMPORTED_MODULE_10__App_js__["b" /* store */].subscribeToActions(this.handleReduxAction);this.props.tournament.fetchEntity("/api/tournaments/stats").then(function(stats){var active_tournament=stats.value.active_tournament;if(active_tournament&&active_tournament.account){var account=active_tournament.account;_this4.props.tournament.fetchEntity("/api/tournaments/operations?account_id="+account.id);}else{_this4.props.dispatch({type:"ENGAGE_BINARY_MODE"});}});// Случай, когда компонент примонтировался на живой
// сокет. Такое бывает при переходе с других страниц.
if(this.props.socket.connectionState===WebSocket.OPEN){this.requestStockHistory();}var _props2=this.props,stock=_props2.stock,stocks=_props2.stocks,tabs=_props2.tabs;if(stock&&stocks[stock]&&stocks[stock].enabled){var index=tabs.tabs.indexOf(stock);if(index>-1){this.props.dispatch({type:"SET_ACTIVE_TAB",payload:index});}else if(tabs.tabs.length<__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["a" /* TABS_LIMIT */]){this.props.dispatch({type:"PUSH_TAB",payload:stock});}else{this.props.dispatch({type:"SET_ACTIVE_STOCK",payload:{newStock:stock,activeStock:this.props.activeStock}});}}}},{key:"componentWillUnmount",value:function componentWillUnmount(){this.unsubscribe();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var viewedStock=Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(this.props.tabs);// История точек
if(viewedStock!==Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(prevProps.tabs)||this.props.socket.connectionState!==prevProps.socket.connectionState&&this.props.socket.connectionState===WebSocket.OPEN){this.requestStockHistory();}if(this.props.mode==="tournament"){var stats=this.props.tournament.readEntity("/api/tournaments/stats");if(stats.value!=null&&(stats.value.active_tournament==null||stats.value.active_tournament.account==null)){this.props.dispatch({type:"ENGAGE_BINARY_MODE"});}}}},{key:"render",value:function render(){var _this5=this;var Layout=this.props.layout;var activeAccount=this.props.accounts.find(function(account){return account.id===_this5.props.profile.active_account_id;});if(!activeAccount){console.error("activeAccount not found!");}var deals=this.props.deals;var tournamentWillBeClosingSoon=false;if(this.props.mode==="tournament"){var stats=this.props.tournament.readEntity("/api/tournaments/stats");if(stats!=null&&stats.value!=null&&stats.value.active_tournament!=null&&stats.value.active_tournament.account!=null){var account=stats.value.active_tournament.account;var operations=this.props.tournament.readEntity("/api/tournaments/operations?account_id="+account.id);if(operations!=null&&operations.value!=null){deals=[].concat(_toConsumableArray(operations.value.open),_toConsumableArray(operations.value.closed));}else{deals=[];}// Copypasted from Settings.js
var endTime=__WEBPACK_IMPORTED_MODULE_3_moment___default()(stats.value.active_tournament.finish_date*1000);var maxTime=__WEBPACK_IMPORTED_MODULE_3_moment___default.a.duration(endTime.diff(__WEBPACK_IMPORTED_MODULE_3_moment___default()(this.props.time))).asSeconds();tournamentWillBeClosingSoon=this.props.possibleTradeIntervals[0]>maxTime;}else{deals=[];}}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__components_ThemeProvider__["d" /* TradeThemeProvider */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__components_RtlProvider__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__Tour__["b" /* default */],{step:"intro",originalRef:this.original},function(_ref5){var next=_ref5.next,isOriginal=_ref5.isOriginal,onLater=_ref5.onLater;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__Sightseeing_Intro__["a" /* default */],{ref:isOriginal?_this5.original:null,next:next,onLater:onLater});}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_27__Tour__["b" /* default */],{step:"outro",originalRef:this.originalLast},function(_ref6){var next=_ref6.next,isOriginal=_ref6.isOriginal,tour=_ref6.tour;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_29__Sightseeing_Outro__["a" /* default */],{ref:isOriginal?_this5.originalLast:null,next:next,tour:tour});}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Layout,{animated:this.props.animated,time:this.props.time,userId:this.props.userId,deals:deals,stocks:this.props.stocks,onRecommendedStockClick:this.recommendedStockClickHandler,activeAccount:activeAccount,dispatch:this.props.dispatch,refillDemoAccount:this.refillDemoAccount,refundClickHandler:this.refundClickHandler,refundFetching:this.state.refundFetching,isRefillFetching:this.state.isRefillFetching,isFetchingOpenOperation:this.state.isFetchingOpenOperation,accountsReady:this.props.accountsReady,dealsReady:this.props.dealsReady,tryMakingADeal:this.tryMakingADeal,refreshProfile:this.refreshProfile,dismissInsufficientFundsMessage:this.dismissInsufficientFundsMessage,dismissVerificationRequiredMessage:this.dismissVerificationRequiredMessage,adsMessage:this.state.adsMessage,showInsufficientFundsMessage:this.state.showInsufficientFundsMessage,showVerificationRequired:this.state.showVerificationRequired,showIncreaseBidLimitMessage:this.showIncreaseBidLimitMessage,dismissIncreaseBidLimitMessage:this.dismissIncreaseBidLimitMessage,showIncreaseBidLimit:this.state.showIncreaseBidLimit,showTradeIsClosing:this.state.showTradeIsClosing,dismissTradeIsClosing:this.dismissTradeIsClosing,connectionState:Object(__WEBPACK_IMPORTED_MODULE_25__redux_reducer_socket__["a" /* decryptConnectionState */])(this.props.socket.connectionState),untilNextReconnect:this.props.socket.untilNextReconnect,retrySocket:this.props.retrySocket,isIOS:this.props.serverData.isIOS,appVersion:this.props.serverData.app_version,stock:this.props.stocks[Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(this.props.tabs)],accountType:this.props.accountType,possibleTradeIntervals:this.props.possibleTradeIntervals,currentTradeInterval:this.props.currentTradeInterval,tradeControlsDisabled:tournamentWillBeClosingSoon||this.props.tradeControlsDisabled,timeUntilNextLockToggle:this.props.timeUntilNextLockToggle,validateDealAmount:this.validateDealAmount,isDealAmountValid:this.state.isDealAmountValid,dealsToCompensate:this.state.dealsToCompensate,onCompensation:this.onCompensation,compensationUpdated:this.state.compensationUpdated,compensationCreated:this.state.compensationCreated,onCompensationCreated:this.onCompensationCreated,demoTournament:this.state.demoTournament,showDemoTournament:this.state.showDemoTournament,dismissDemoTournament:this.dismissDemoTournament}))));}}]);return TradingPlatform;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);function TradingPlatformWithTournamentSupport(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__Tournaments_Api__["c" /* default */].Consumer,null,function(tournament){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__Tournaments_Api__["a" /* ActiveTournament */],null,function(activeTournament){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TradingPlatform,Object.assign({},props,{tournament:tournament,activeTournament:activeTournament}));});});}function mapStateToProps(state,ownProps){// Апи поля приходят свыше, от withData компонента
var serverData=ownProps.serverData,stocks=ownProps.stocks,profile=ownProps.profile,accounts=ownProps.accounts;var hasActiveDeals=state.deals.some(function(deal){return deal.time!=null;});var stock=Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs);var stockData=stocks[stock];var activeAccount=accounts.find(function(account){return account.id===profile.active_account_id;});var isReal=activeAccount?activeAccount.type==="real":false;var intervals=isReal?state.remoteTradeSettings.intervals:state.remoteTradeSettings.intervalsDemo;var currentInterval=state.settings.currentInterval||state.remoteTradeSettings.defaultInterval||60;var timeUntilNextLockToggle=Object(__WEBPACK_IMPORTED_MODULE_26__redux_reducer_stocks__["b" /* getTimeUntilNextLockToggle */])(state.time,stockData);if(timeUntilNextLockToggle!==Infinity){intervals=intervals.filter(function(interval){return interval===state.settings.currentInterval||interval*1000<=timeUntilNextLockToggle;});}return{animated:state.settings.animatedChart===undefined?true:state.settings.animatedChart,activeStock:Object(__WEBPACK_IMPORTED_MODULE_24__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs),time:state.time,tournaments:state.tournaments,profile:profile,accounts:accounts,accountsReady:state.dataRequirementsStatus.accounts==="AVAILABLE",hasActiveDeals:hasActiveDeals,theme:state.settings.theme,serverData:serverData,tabs:state.tabs,socket:state.socket,referralBonus:state.referralBonus,stocks:stocks,accountType:activeAccount&&activeAccount.type,possibleTradeIntervals:intervals,currentTradeInterval:__WEBPACK_IMPORTED_MODULE_7_lodash_clamp___default()(currentInterval,intervals[0],intervals[intervals.length-1]),tradeControlsDisabled:stock.enabled===false||intervals.length===0||intervals.length===1&&intervals[0]*1000>=timeUntilNextLockToggle,timeUntilNextLockToggle:timeUntilNextLockToggle,mode:state.settings.mode,deals:state.deals,dealsReady:state.dataRequirementsStatus.operations==="AVAILABLE"};}function mapDispatchToProps(dispatch){return Object.assign({retrySocket:function retrySocket(){dispatch({type:"SOCKET_CONNECT"});}},Object(__WEBPACK_IMPORTED_MODULE_19__components_common_fetch__["e" /* mapDispatchToFetch */])(dispatch));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_redux__["d" /* compose */])(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["g" /* withRouter */],Object(__WEBPACK_IMPORTED_MODULE_20__components_withData__["a" /* default */])(["serverData","stocks","profile","accounts"]),Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),__WEBPACK_IMPORTED_MODULE_13__common_Gettext__["g" /* withGettext */])(TradingPlatformWithTournamentSupport));

/***/ }),
/* 1703 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return config; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return runBehaviourTrigger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeatureFlags__ = __webpack_require__(41);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var config={/*
  // Правило
  behaviourTrigger: {
    // Активно/Не активно правило.
    enabled: boolean,
    // Нужно сохранять данные в localStorage или нет.
    persist: boolean,
    // Ключ в localStorage.
    storageKey: string,
    // Сколько раз выполнять правило. Если не указан — неограниченное количество раз.
    // Например, repeat=2 и counter=3:
    // - дождаться трёх триггеров
    // - вызвать onComplete
    // - повторить 1 раз
    repeat: number,
    // Условия для выполнения правила. Внутри должен быть либо counter, либо sequence.
    conditions: {
      // Сколько раз нужно вызвать функцию триггера, чтобы правило выполнилось.
      counter: number,
      // Последовательность действий, необходимых для выполнения правила.
      sequence: Array<string>,
      // Сколько раз подряд нужно вызвать функцию триггера с одинаковыми параметрами,
      // чтобы правило выполнилось.
      setOf: number,
      // Обязательно ли строгое следование вызовов триггера подряд. Если нет, то сбрасываем
      // счётчик/последовательность.
      strict: boolean
    },
    // Если указаны params, то для выполнения правила они должны совпадать с теми, что придут
    // в триггере
    params: {}
  }
  */// Сделать 3 сделки с одинаковым интервалом и проиграть их.
sameIntervalDeals:{enabled:true,persist:true,storageKey:"sameIntervalDealsTrigger",repeat:1,conditions:{setOf:3},params:{profitable:false}},// Сделать 5 сделок на одном активе и проиграть их.
sameStockDeals:{enabled:true,persist:true,storageKey:"sameStockDealsTrigger",repeat:1,conditions:{setOf:5},params:{profitable:false}},// Выиграть сделку с профитом меньше 80% (для VIP — 90%).
lowProfitWin:{enabled:true,persist:true,storageKey:"lowProfitWinTrigger",repeat:1,conditions:{counter:1},params:{profitable:true,percent:80,vipPercent:90,lowPercent:true}},// Проиграть более 80% баланса.
bigLoss:{enabled:true,persist:true,storageKey:"bigLossTrigger",repeat:1,conditions:{counter:1},params:{profitable:false,percent:80,lowPercent:true}},// Примеры
// Сделать 3 любых сделки.
threeDealsInARow:{enabled:false,persist:true,storageKey:"threeDealsInARowTrigger",conditions:{counter:3}},// Сделать 2 сделки Вверх и одну — Вниз. Выполнить правило 3 раза.
twoUpOneDown:{enabled:false,persist:true,storageKey:"twoUpOneDownTrigger",repeat:3,conditions:{sequence:["up","up","down"]}},// Переключить тему 2 раза и после сделать 2 сделки. Повторение правила не ограничено.
twoDealsAfterThemeSwitch:{enabled:false,persist:false,conditions:{sequence:["theme","theme","deal","deal"]}},// Добавить индикатор, удалить индикатор, добавить индикатор, удалить индикатор. Выполнить 1 раз.
addAndRemoveIndicators:{enabled:false,persist:false,storageKey:"addAndRemoveIndicatorsTrigger",repeat:1,conditions:{sequence:["add","remove","add","remove"]}},// Добавить индикатор, удалить индикатор. Выполнить 2 раза.
addAndRemoveIndicatorsTwice:{enabled:false,persist:false,repeat:2,storageKey:"addAndRemoveIndicatorsTwiceTrigger",conditions:{sequence:["add","remove"]}}};var runBehaviourTrigger=function runBehaviourTrigger(config,onComplete,params){var defaultStorage={value:undefined,completed:false,canceled:false,sequence:0};var counter=0;var sequence=config.conditions.sequence&&[].concat(_toConsumableArray(config.conditions.sequence));var set=[];var storage=defaultStorage;var completed=false;var canceled=false;var storageKeyPrefix=(params&&params.storageKeyPrefix)+":"||"";if(config.persist){try{storage=JSON.parse(localStorage.getItem(""+storageKeyPrefix+config.storageKey))||defaultStorage;if(config.conditions.counter){counter=storage.value||0;}else if(config.conditions.sequence){sequence=storage.value||[].concat(_toConsumableArray(config.conditions.sequence));}completed=storage.completed;canceled=storage.canceled;set=storage.value||[];}catch(error){console.warn(error);}}var triggerFn=function triggerFn(val,triggerParams){var didTrigger=false;if(config.persist){try{storage=JSON.parse(localStorage.getItem(""+storageKeyPrefix+config.storageKey))||defaultStorage;if(config.conditions.counter){counter=storage.value||0;}else if(config.conditions.sequence){sequence=storage.value||[].concat(_toConsumableArray(config.conditions.sequence));}completed=storage.completed;canceled=storage.canceled;set=storage.value||[];}catch(error){console.warn(error);}}if(!__WEBPACK_IMPORTED_MODULE_1__FeatureFlags__["a" /* default */].enableTriggers||!config.enabled||completed||canceled)return null;if(config.conditions.counter){if(config.params&&!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(config.params,triggerParams)){counter=config.conditions.strict?0:counter;}else{counter+=1;}if(counter===config.conditions.counter){if(typeof onComplete==="function"){didTrigger=true;onComplete();}completed=true;storage.sequence+=1;if(config.repeat===undefined||storage.sequence<config.repeat){counter=0;completed=false;}if(config.persist){try{localStorage.setItem(""+storageKeyPrefix+config.storageKey,JSON.stringify({value:counter,completed:completed,canceled:canceled,sequence:storage.sequence}));}catch(error){console.warn(error);}}}else if(counter>config.conditions.counter){completed=true;}else{if(config.persist){try{localStorage.setItem(""+storageKeyPrefix+config.storageKey,JSON.stringify({value:counter,completed:completed,canceled:canceled,sequence:storage.sequence}));}catch(error){console.warn(error);}}}}else if(config.conditions.sequence){if(config.params&&!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(config.params,triggerParams)){sequence=config.conditions.strict?[].concat(_toConsumableArray(config.conditions.sequence)):sequence;}else{if(sequence[0]&&sequence[0]===val){sequence.shift();}}if(sequence.length===0){if(typeof onComplete==="function"){didTrigger=true;onComplete();}completed=true;storage.sequence+=1;if(config.repeat===undefined||storage.sequence<config.repeat){sequence=[].concat(_toConsumableArray(config.conditions.sequence));completed=false;}}if(config.persist){try{localStorage.setItem(""+storageKeyPrefix+config.storageKey,JSON.stringify({value:sequence,completed:completed,canceled:canceled,sequence:storage.sequence}));}catch(error){console.warn(error);}}}else if(config.conditions.setOf){if(config.params&&!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(config.params,triggerParams)){set=[];}else if(set.length<config.conditions.setOf){if(set[0]===val){set.push(val);}else{set=[val];}}else{// TODO нужна ли эта ветвь?
set.shift();if(set[0]===val){set.push(val);}else{set=[val];}}if(set.length===config.conditions.setOf){if(typeof onComplete==="function"){didTrigger=true;onComplete();}completed=true;storage.sequence+=1;if(config.repeat===undefined||storage.sequence<config.repeat){set=[];completed=false;}}if(config.persist){try{localStorage.setItem(""+storageKeyPrefix+config.storageKey,JSON.stringify({value:set,completed:completed,canceled:canceled,sequence:storage.sequence}));}catch(error){console.warn(error);}}}return didTrigger;};var triggerItself=Object.assign({},config,{trigger:triggerFn,clearStorage:function clearStorage(){if(config.persist){try{localStorage.removeItem(""+storageKeyPrefix+config.storageKey);}catch(error){console.warn(error);}}},cancel:function cancel(){canceled=true;if(config.persist){try{storage=JSON.parse(localStorage.getItem(""+storageKeyPrefix+config.storageKey))||defaultStorage;storage.canceled=canceled;localStorage.setItem(""+storageKeyPrefix+config.storageKey,JSON.stringify(storage));}catch(error){console.warn(error);}}}});if(!config.enabled)triggerItself.clearStorage();return[triggerItself,triggerFn];};

/***/ }),
/* 1705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_earlySalePopup_earlySalePopupDarkImg1_png__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_earlySalePopup_earlySalePopupDarkImg1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_earlySalePopup_earlySalePopupDarkImg1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_earlySalePopup_earlySalePopupDarkImg2_png__ = __webpack_require__(1708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_earlySalePopup_earlySalePopupDarkImg2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_earlySalePopup_earlySalePopupDarkImg2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_earlySalePopup_en_d_png__ = __webpack_require__(1709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_earlySalePopup_en_d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_earlySalePopup_en_d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_earlySalePopup_hi_d_png__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_earlySalePopup_hi_d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_earlySalePopup_hi_d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_earlySalePopup_id_d_png__ = __webpack_require__(1711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_earlySalePopup_id_d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_earlySalePopup_id_d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_earlySalePopup_ph_d_png__ = __webpack_require__(1712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__images_earlySalePopup_ph_d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__images_earlySalePopup_ph_d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_earlySalePopup_th_d_png__ = __webpack_require__(1713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_earlySalePopup_th_d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_earlySalePopup_th_d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_earlySalePopup_vn_d_png__ = __webpack_require__(1714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_earlySalePopup_vn_d_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_earlySalePopup_vn_d_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_earlySalePopup_earlySalePopupDarkDesktopImg2_png__ = __webpack_require__(1715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__images_earlySalePopup_earlySalePopupDarkDesktopImg2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__images_earlySalePopup_earlySalePopupDarkDesktopImg2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_earlySalePopup_earlySalePopupLightImg1_png__ = __webpack_require__(1716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__images_earlySalePopup_earlySalePopupLightImg1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__images_earlySalePopup_earlySalePopupLightImg1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_earlySalePopup_earlySalePopupLightImg2_png__ = __webpack_require__(1717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__images_earlySalePopup_earlySalePopupLightImg2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__images_earlySalePopup_earlySalePopupLightImg2_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_earlySalePopup_en_l_png__ = __webpack_require__(1718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__images_earlySalePopup_en_l_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__images_earlySalePopup_en_l_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_earlySalePopup_hi_l_png__ = __webpack_require__(1719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_earlySalePopup_hi_l_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_earlySalePopup_hi_l_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_earlySalePopup_id_l_png__ = __webpack_require__(1720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__images_earlySalePopup_id_l_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__images_earlySalePopup_id_l_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_earlySalePopup_ph_l_png__ = __webpack_require__(1721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__images_earlySalePopup_ph_l_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__images_earlySalePopup_ph_l_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_earlySalePopup_th_l_png__ = __webpack_require__(1722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__images_earlySalePopup_th_l_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__images_earlySalePopup_th_l_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_earlySalePopup_vn_l_png__ = __webpack_require__(1723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__images_earlySalePopup_vn_l_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__images_earlySalePopup_vn_l_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_earlySalePopup_earlySalePopupLightDesktopImg2_png__ = __webpack_require__(1724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__images_earlySalePopup_earlySalePopupLightDesktopImg2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__images_earlySalePopup_earlySalePopupLightDesktopImg2_png__);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 40px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 32px 16px 38px;\n    border-radius: 0;\n  }\n  @media (max-height: 500px) { \n    display: block;\n    overflow-y: auto;\n    position: relative;\n    padding-top: 50px;\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 40px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 32px 16px 38px;\n    border-radius: 0;\n  }\n  @media (max-height: 500px) { \n    display: block;\n    overflow-y: auto;\n    position: relative;\n    padding-top: 50px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-bottom: 21px;\n  font-size: 28px;\n  line-height: 1.2;\n  color: ",";\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    margin-bottom: 17px;\n    font-weight: 500;\n  }\n"],["\n  margin-bottom: 21px;\n  font-size: 28px;\n  line-height: 1.2;\n  color: ",";\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    margin-bottom: 17px;\n    font-weight: 500;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  margin-bottom: 37px;\n  display: ",";\n\n  @media (max-width: 959px) {\n    display: ",";\n    font-size: ",";\n    margin-bottom: 0;\n  }\n"],["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  margin-bottom: 37px;\n  display: ",";\n\n  @media (max-width: 959px) {\n    display: ",";\n    font-size: ",";\n    margin-bottom: 0;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  width: 258px;\n  height: 89px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto 14px;\n  background-image: url(",");\n\n  @media (max-width: 959px) {\n    background-image: url(",");\n  }\n"],["\n  flex: 0 0 auto;\n  width: 258px;\n  height: 89px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto 14px;\n  background-image: url(",");\n\n  @media (max-width: 959px) {\n    background-image: url(",");\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex: 0 0 auto;\n  width: 203px;\n  height: 64px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto 30px;\n  background-image: url(",");\n  @media (max-width: 959px) {\n    width: 304px;\n    height: 109px;\n    background-image: url(",");\n  }\n"],["\n  flex: 0 0 auto;\n  width: 203px;\n  height: 64px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: contain;\n  margin: 0 auto 30px;\n  background-image: url(",");\n  @media (max-width: 959px) {\n    width: 304px;\n    height: 109px;\n    background-image: url(",");\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"],["\n  display: flex;\n  justify-content: center;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"],["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#919191":"#CCCCCC";},function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?"#F5F5F5":"#272B34";});var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?"#343434":"#ffffff";},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(18));var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref4){var theme=_ref4.theme;return theme.mode==="light"?"#919191":"#CCCCCC";},function(props){return props.mobile?"none":"block";},function(props){return props.mobile?"block":"none";},Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14));var Img1=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(_ref5){var images=_ref5.images,theme=_ref5.theme;return theme.mode==="light"?images.desktopLight:images.desktopDark;},function(_ref6){var images=_ref6.images,theme=_ref6.theme;return theme.mode==="light"?images.mobileLight:images.mobileDark;});var Img2=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref7){var images=_ref7.images,theme=_ref7.theme;return theme.mode==="light"?images.desktopLight:images.desktopDark;},function(_ref8){var images=_ref8.images,theme=_ref8.theme;return theme.mode==="light"?images.mobileLight:images.mobileDark;});var ButtonBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var closePopupHandler=function closePopupHandler(userId){return function(){try{localStorage.setItem(userId+":earlyClosePopup",JSON.stringify(true));}catch(e){}};};var EarlySalePopup=function EarlySalePopup(props){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){Object(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaReducer */])("EARLY_SALE_POPUP_SHOW");},[]);var desktopLightImg1=function(){switch(props.lang){default:case"en":return __WEBPACK_IMPORTED_MODULE_18__images_earlySalePopup_en_l_png___default.a;case"hi":return __WEBPACK_IMPORTED_MODULE_19__images_earlySalePopup_hi_l_png___default.a;case"id":return __WEBPACK_IMPORTED_MODULE_20__images_earlySalePopup_id_l_png___default.a;case"ph":return __WEBPACK_IMPORTED_MODULE_21__images_earlySalePopup_ph_l_png___default.a;case"th":return __WEBPACK_IMPORTED_MODULE_22__images_earlySalePopup_th_l_png___default.a;case"vn":return __WEBPACK_IMPORTED_MODULE_23__images_earlySalePopup_vn_l_png___default.a;}}();var desktopDarkImg1=function(){switch(props.lang){default:case"en":return __WEBPACK_IMPORTED_MODULE_9__images_earlySalePopup_en_d_png___default.a;case"hi":return __WEBPACK_IMPORTED_MODULE_10__images_earlySalePopup_hi_d_png___default.a;case"id":return __WEBPACK_IMPORTED_MODULE_11__images_earlySalePopup_id_d_png___default.a;case"ph":return __WEBPACK_IMPORTED_MODULE_12__images_earlySalePopup_ph_d_png___default.a;case"th":return __WEBPACK_IMPORTED_MODULE_13__images_earlySalePopup_th_d_png___default.a;case"vn":return __WEBPACK_IMPORTED_MODULE_14__images_earlySalePopup_vn_d_png___default.a;}}();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["d" /* TradeThemeProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:function onClick(){return props.onDismiss({callback:closePopupHandler(props.userId)});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Try a new feature of the early closure."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Now you can close your trade earlier than the expiration time.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img1,{images:{desktopLight:desktopLightImg1,desktopDark:desktopDarkImg1,mobileLight:__WEBPACK_IMPORTED_MODULE_16__images_earlySalePopup_earlySalePopupLightImg1_png___default.a,mobileDark:__WEBPACK_IMPORTED_MODULE_7__images_earlySalePopup_earlySalePopupDarkImg1_png___default.a}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,{mobile:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Click on the cross to open trades list and choose the one to close earlier. Please note that the cross is active only when the trade is possible to be closed earlier.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Close your trades with a button on a price chart, or in the opened trades list. Please note that the close button is active only when the trade is possible to be closed earlier.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img2,{images:{desktopLight:__WEBPACK_IMPORTED_MODULE_24__images_earlySalePopup_earlySalePopupLightDesktopImg2_png___default.a,desktopDark:__WEBPACK_IMPORTED_MODULE_15__images_earlySalePopup_earlySalePopupDarkDesktopImg2_png___default.a,mobileLight:__WEBPACK_IMPORTED_MODULE_17__images_earlySalePopup_earlySalePopupLightImg2_png___default.a,mobileDark:__WEBPACK_IMPORTED_MODULE_8__images_earlySalePopup_earlySalePopupDarkImg2_png___default.a}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:function onClick(){return props.onDismiss({callback:closePopupHandler(props.userId)});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Got it"))))));};/* harmony default export */ __webpack_exports__["a"] = (EarlySalePopup);

/***/ }),
/* 1707 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1708 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1709 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/en_d.ada80b71.png";

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hi_d.1ecfc899.png";

/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/id_d.ab5a3f97.png";

/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ph_d.398b6122.png";

/***/ }),
/* 1713 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/th_d.1f2b28f9.png";

/***/ }),
/* 1714 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vn_d.abca42c0.png";

/***/ }),
/* 1715 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1716 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1717 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1718 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/en_l.c2afef1b.png";

/***/ }),
/* 1719 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/hi_l.7e374dcb.png";

/***/ }),
/* 1720 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/id_l.cafb7c70.png";

/***/ }),
/* 1721 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/ph_l.bdc477bd.png";

/***/ }),
/* 1722 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/th_l.2d711d52.png";

/***/ }),
/* 1723 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/vn_l.967779ee.png";

/***/ }),
/* 1724 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMsAAABACAYAAAC0jIMoAAAABHNCSVQICAgIfAhkiAAAD19JREFUeJztnXt0FFWexz+3qro77IY8SKLZhLCMAjpBj6wzUV6zCOuKZ3YHlQCrzq6OiKPkIC+Zg6NCmhH0sIO8ZFF2QFYdR4cAIrNyhF1kcXkJqxPUgCPh8AjJaScJxCQq6e6q3/5R6byTbh4hSO7nnJzu3Lq/6tu36lu/x61KFBqNpn2Wi4+airMIQaOrx6LRXNacrulZ/65Wi0Wj6QifkwCA0mLRaDomJNqzaDQxYYQSARAtFo0mCsb33Fcp1WLRaDpC0b/+9XMtFo2mI8QZ4L4xtFg0mg6JeBbhc9XFQ9FoLl+Wi4/qiloUJhaJ2rNoNO1RUzkchQX8kdlpNVosGk37jKx/3QmgxaLRtIc4rlhEabFoNO3i/3M8SuUAEHa2A1jRbDLH5UnLNtvhFkM5Q5QyRpSuX5kbac/IfWxqpK3+/bIGI5HPcGRa6dsvv58+Ni/HNNhfun5lQ4GhZVtG7mNTUcZTCq5uattqTC22aTQXBZPxgAeRffivqoUYPUvp+pWq6U9g48oDsdiJONMiNraoiZjG9tQxUzKi2WXkTr5boR4JBo2b27Ntvl81NyN38t3R9rtkyZJRIqIrgJeAoS8+ub2rx3BBGNxX/+b1SFNUz3KxCGxceSAzd/JnluVkRu8tfVDGFxWbV5RFbDNyJ9/j9dk9W/YMbFx5IH1s3i9MJa8Am9rb47Jly+4F3ly+fPkbIvIvSimpbxdApk2bpkPSJgx98cntSjEq8rsgI/ZMWfjB0BWzX1ComcAZx5Hpe6cufK2p3ZDlsx8wDLUUSB764pPb67wy9qNHF351qcd/QTxflYwTGgWECJu/izRfshMkfWxejiiVFg4bpVE7G2orMDYzd/KDqWMm9gQo2/DSprKCl/7UVvfAxpUHUOqGjryWaZr/BRwCfrps2bLf+/1+LY6OUJIk8IogIwQZUefh4LAXfzlGoWYi6i6QpYahXv3BqtmJTc0MQ70q8Dai7lKKUb6Q8WBXfYXzxgn+M2AC7+JProo0x3TCZI7LkyY/G2L9TKWMZRE7w+APynbuj3iLjigreOlPouR6Qf3I542rzsjNW50xfvJ10ew68lpTpkypdBxnmIh8opQan5ycvNHv91sAItIqL+vuKNTNSmSkQu1EVL7b6AwC2P3485sF/gfAF+KmFqZnlEiSKOOgICPAeOfSjvwC8YsBzARAVDOveT45S250C5dIzlIXNDIB6uxgTLkOuIIp27ByUl3wbAI4nyBqZ7R8J5rXmjFjRpVhGD8CPgLuSk5O3gQQCck0jTiOPKiEe5Qjg87FQyhHRgJ/o7CPA3ftmbLgROeO9CLjPT0WVF+EE4RTmgn9AkIRdTLWnhWbV5Qh/KfX430Iop/UGbmT7454korNr9SUbXh5uYLdPo/99231z7znsVGIfBaL15o6dWp1MBgcAewD/iHW79Cd+MGq2YnK4Pi3Po7vmrrwoCAfK5ykWOwcg8Tdjy+8RpARCjVz6IpfTr0UY75oOM5sAAyex6+cppvOWyzBkLlfYFikCpU6ZkqGQj0iIq+31d8RVqGMp1LHTOzpntSyM2Nc3iLXdmJPQ/GowAtub+mjhFURT5I+Ni9HYJgt6lDL/aaPzcsR0/idwJxoY166dKm9bNky8Xq9tcDgSLsOw5rjC1lJCrUzLsS0+jzlZsfhOGIUArht3AZQ5+FgxK5HHX0VauewFbPngvXd8igAz1bcjuKHiFQQTF3bcvP55CySkfvY1IrNK8qU7dyvFNMzx+WJ1+t8LMhvyja81GZFKrBx5QEFuyPeRRSPIiRljssTnzeuGkVVMHh2HkDZhpeXi8hGn8femjkuT0wlryDyWNOSdWQsppJXlO3c397nas6dPVMWnHAceRDUdJS8I8jivVMXvubmKrIYJe+Amu448mDTSteuqQsPguSDmq6wj4vwfp3HebUrv0vM+MVCyQr3F+PX+FWwZRe95qC56AxdMftvFdy2e8rCX3X1WGJmQfkc4Fcgx+mRls1M9W3LLlosGs2zVd/DCB4G5UNkBM9c9UFb3fRag6Z74xcDI/QmKB/w2/aEAlosmu6Op2IOcCtIJco3vaOuOgzTdF+eq7gVR/agMEDdztOpHd7Ppj2LpnvyfFUy4rzlCoUXogkFtFg03RG/eLGDW0D1BSkklPpkLGZaLJruhYjCU/F7lBoMUonjHYdfhWMxNTt7bBrNZYV3yiJgIiJncbiNuSmt7gppj0v2PItG0+XML18CTAdsxLyHuSl/PBdz69SpU5WdMzKNJjq9e/dO6fQPEVE8V/FvwGS3Qf2MOSnvnetuLKVUr4s8NI3m8sEvBs9VrAImATaoiTyd+tvz2ZUOwzRXLv7KBKyKt4FRiNSi1BieTt1xvrvTYtFcmTxbfh3KfhelrgX5EsMcxVOxJ/NtoUvHmiuP+eU/xZCPUOpaRHYRirvhQoUC2rNoriSeP9MXO7wGxShQNkI+4bT5LZ94PF+0WDTffZaLj5rymTihfJTyAacQuY9nrtp1MT9Gi0XTQFGlYmBKFzxhPb/814DBM2lPnJOdXyw8FROpLp+HUukIDsgKfGlP8gv19cUepiotLdXPn2sAmPCexbo7Y7rz46KRudazAqWmIFKLcDNzrjoS1cgvFlblfeDMQyn3fz4Kh4EHeCbt/zprrFE9y7YSg/wPTU7WKoalOywebtM73tXXkkKT1YdNqurg3v4OLwxre6IHvumlqq7x91mDbGYMshv2v7jQ5NNKRenPWj32fEVTUOx+95O1ij7xwrxbbe7IcsPrpnN7Y4rwwtBwm1f9JYUmiwqb37W04c4Qg9PdvkWViqWfmGw5YTSb96YUVSom7bA4WasYst7DzEE24/tFD/O/+eYbvv76a9LS0lptq6mpwbZtkpLa/6Mwz+wzqRfKNxjG7TyV2rFQ/NWpWGd/DuWPo1R6/RMmp1DqOVJTVvOoCkUd9AUQVSwzdlksGR7mjiyHeftN5h0w+c3IMEWVitWHTbb+JESCV5j0vsWaQwYPZ7ee5Ko62hRCRCj+nHDDwe0u7Asopu+yGJbuMCnbZvFBixm7LIruC1JQbLCo0OTHf+1wR5aD/4DFhG0eiu5rPYfV9U2zmoigd7z7WlSpmLDNQ4JHmDXIZkh62wKI9Fk6PMyawybTd1kMSQ81XBTbo6KigoqKCmzbJj09vaG9qqqKY8eO0aNHDxITE1Gq+WNTAszeY/HGFwaIfAOM5qnUD9v8EL/E4SkfiTAedfb++icaAb4AWUgo7bVYb4S8UDoUy76AIiteGq52D2c73LreA7gn+oRrG73M+H4OBcWuWB7ZYdH7L4X8W2xO1SqSfG3vP/9DkyXDu59QAPYG3Kp9fo7NwBShOmizqNBsmPNZ9Vf33vHCqdrGbS3nqui04sYUadNjLP3E9Thbx4RI8LY9jqJKRVUdTLjWafAmBcUGX9U1iq49srKyCIVClJWVEQqFyMrK4vTp05w4cYK4uDj69evXplCm/6/J+qMGPhPqwoxuloivEg9fnrkeyx6Kwz9C+e2g4uofUwwhvAOsIZz67sWqcsVKVM+S4Gk8OC2vNE0PQFaTbfk5jQfuVK37GgnF7u3vkJ/jXghO1ioWF5rsDhj0iRdWj2w71LgSmdEiJNobcC8qETEMTrcpqlQcOmOwrtjgxhRp96JSUqsa5vfn2Tb5t7j73XLCtRu92cPJWtVmqDwwRegTL6w7apLdSxjfz4kpBANQSnHNNddw9OhRysvLOXv2LDU1NcTFxdG/f38sq/np5Qg8/oHFpmMGHgNm3WSz4GNjAAvKb0e4HriB8orrMLEQ6qMsBfAhyJuEfK/jTzwd0+A6gU6phjUVVXYvYeZN4YYDMGGrh4Jig4G93D6j+zisuzPMmkMGk3ZY7B3XqWHnZcmaQwa7Awa/uqX5iTzvgHshAVh7azv5YC8hq6fD+GttCo6a/Psh96TPTnbnt6RW4c8Js63E4K0jBtnJrUPl1SPDTNphMX2XxeJCOSdvHxHMkSNHqKmpwev1MmDAgFZCATek33TMAIGQDQs+NgHWuDtq0lHkLEptR/EHpMcmno7/MqbBdDKdXjpO8NLs4MwcZLO6yGBgL5sbU6Rh28PZDnP3W11XvuwiCooN5u63uLe/0+okXndnmOogPLHb4qHtFh+Oa51HRLwIQHavMG8d8bLvS4OseLd90vfdcG50H4ctJ7xsPdlaLANThL3jQuwLKPwHLB7e4WHrT6LnLBFqamr49ttvMU2TYDBIZWUlV199dat+viZ1iASv0CtOOF5jfITwJfAZSn0KxiekJR/u7GT9fIgqlpLaRsmfqm0ef576WrXZr1mf+vaWE987Hj6t7N5/L6Oo0k3yb0yRZuHRthKDokrFjEE2CV7ITha2nHBD2qZ5RHUQ1hwyGZji5pXVQXc+EzyNIVvTYwSQ2CJ/LCg2KCg2yM+xGZwujM5yWFRotvqs9jhz5gzHjx9vCL1KSkooLS3Ftm0yMpr/Hfd/HRrGa5is/dykzlEsHBLmn3Ku/uE5TFmX0uG9YYPTheqQoqDY7bbkoFuhAbgjy+G9k+5BrQ7CmsMmo/u4207VqgaR7A24ZcnqoHtwFxeaDEkXescLw9IdltSXPdcccvOW7uJVIpWqJJ/rbfcFFPsC7rx9VQeLCk0e2WFRUGywtcQgyeeevNtKDCa853rgBC+sKzaYscvtN++AO5dD/sqdw3v7u8eooNjgid3udTFSrImQnSzsDhg8scdiX0CxtcQ91j090b/D6dOnOXbsWLMcpW/fviQmJhIIBCgpKWllM3+wzUPX29TZ8MB2D8z/8/ALmcdLSdRFyX0BxYxdVpvrLGsOGSw+aLVaZ2laDQOYt99k3dHW6zFFlaohLu9uCX5b6yPQuAbVcp0lUl7fVmLw0HaLtX/nlvObzmGSzw27IoWDSAi35UTrbU1put6T5AN/TjimJD8QCHDmzJlWybyIcPToUUzTpG/fvq0qYuCusaz93GwsHV/kW1M6A72Cr2kg8z+857wwHA6H20zmHccVm2G0H7w8e8Dk5aJ6wRjGqHbXWi4T9C36mgY23HnuOXVbQgFXJB0JBWBOjg3CIpT6Cxznv3mufMA5D+ASoj2LpkvJzMxUDTdSPp06i8v4v7BpsWi6lMzMzO9MSVSHYRpNjGixaDQxosWi0cSIFotGEyNaLBpNjGixaDQxYn3/DUuXji9z9vy4vKqrx6ABqzpkfGfq3N2Y5K4egAasR687e1nfYqAB0zS77OlATSP/D5sLllXJwcGHAAAAAElFTkSuQmCC"

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_BehaviourTriggers_alert_png__ = __webpack_require__(1726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_BehaviourTriggers_alert_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_BehaviourTriggers_alert_png__);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 40px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 32px 16px 38px;\n    border-radius: 0;\n  }\n\n  @media (max-height: 500px) {\n    overflow-y: auto;\n    position: relative;\n    justify-content: space-around;\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 40px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 32px 16px 38px;\n    border-radius: 0;\n  }\n\n  @media (max-height: 500px) {\n    overflow-y: auto;\n    position: relative;\n    justify-content: space-around;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  font-weight: 700;\n  margin-bottom: 19px;\n"],["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  font-weight: 700;\n  margin-bottom: 19px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.7;\n  color: ",";\n  max-width: 280px;\n  margin: 0 auto;\n"],["\n  font-size: ",";\n  line-height: 1.7;\n  color: ",";\n  max-width: 280px;\n  margin: 0 auto;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin: 0 auto 22px;\n\n  @media (max-height: 500px) {\n    display: none;\n  }\n"],["\n  margin: 0 auto 22px;\n\n  @media (max-height: 500px) {\n    display: none;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-top: 73px;\n  @media (max-height: 500px) {\n    margin-top: 20px;\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  margin-top: 73px;\n  @media (max-height: 500px) {\n    margin-top: 20px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"],["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#919191":"#CCCCCC";},function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?"#F5F5F5":"#272B34";});var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(28),function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(14),function(_ref4){var theme=_ref4.theme;return theme.mode==="light"?"#919191":"#CCCCCC";});var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject7);var ButtonBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));var BehaviourTriggersPopup=function BehaviourTriggersPopup(props){Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){return function(){return props.dismissTriggerPopup();};},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ThemeProvider__["d" /* TradeThemeProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{onClick:props.onDismiss}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{src:__WEBPACK_IMPORTED_MODULE_7__images_BehaviourTriggers_alert_png___default.a}),false&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Hint:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,props.text),props.recommendations&&props.recommendations.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"You can use the following assets"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["g" /* StocksTable */],null,props.recommendations.map(function(stock){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["c" /* Stock */],{key:stock.stock,onClick:function onClick(){if(typeof props.onStockClick==="function"){props.onStockClick(stock.stock);}props.onDismiss();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["d" /* StockCategory */],null,stock.category.toUpperCase().replace("_OTC","")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["e" /* StockName */],null,stock.stock.replace("_OTC","")),stock.otc?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["b" /* OtcImage */],null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["a" /* Otc */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["f" /* StockPercent */],null,props.activeAccount.type==="real"?stock.realProfit+"%":stock.demoProfit+"%"));}))),(!props.recommendations||!props.recommendations.length)&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:props.onDismiss},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"OK"))))));};/* harmony default export */ __webpack_exports__["a"] = (BehaviourTriggersPopup);

/***/ }),
/* 1726 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FirstSlide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Orientation__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__themes_irontrade_IndexLogo__ = __webpack_require__(859);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  font-weight: 500;\n  font-size: 60px;\n  color: ",";\n  cursor: default;\n\n  @media (max-height: 840px) {\n    font-size: 46px;\n  }\n"],["\n  direction: ",";\n  font-weight: 500;\n  font-size: 60px;\n  color: ",";\n  cursor: default;\n\n  @media (max-height: 840px) {\n    font-size: 46px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  color: #feac00;\n"],["\n  color: #feac00;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n  overflow: auto;\n"],["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n  overflow: auto;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: table;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n"],["\n  display: table;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n"],["\n  display: table-cell;\n  vertical-align: middle;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 1000px;\n  width: 95%;\n  height: 792px;\n  margin: 0 auto;\n  padding: 50px 75px 44px 75px;\n  text-align: center;\n  border-radius: 20px;\n  background: ",";\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n\n  @media (max-width: 1000px) {\n    max-width: 940px;\n    width: 100%;\n  }\n\n  @media (max-height: 840px) {\n    height: 615px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 1000px;\n  width: 95%;\n  height: 792px;\n  margin: 0 auto;\n  padding: 50px 75px 44px 75px;\n  text-align: center;\n  border-radius: 20px;\n  background: ",";\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n\n  @media (max-width: 1000px) {\n    max-width: 940px;\n    width: 100%;\n  }\n\n  @media (max-height: 840px) {\n    height: 615px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-top: 30px;\n  margin-bottom: 85px;\n  font-weight: lighter;\n  font-size: 40px;\n  line-height: 1.2;\n  text-align: center;\n  color: ",";\n  cursor: default;\n\n  @media (max-height: 840px) {\n    margin-bottom: 45px;\n    font-size: 32px;\n  }\n"],["\n  margin-top: 30px;\n  margin-bottom: 85px;\n  font-weight: lighter;\n  font-size: 40px;\n  line-height: 1.2;\n  text-align: center;\n  color: ",";\n  cursor: default;\n\n  @media (max-height: 840px) {\n    margin-bottom: 45px;\n    font-size: 32px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-weight: lighter;\n  font-size: ",";\n  color: ",";\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n"],["\n  font-weight: lighter;\n  font-size: ",";\n  color: ",";\n  margin: 0;\n  padding: 0;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n          display: block;\n          max-width: 297px;\n          width: 90%;\n          height: 45px;\n          margin: 0 auto;\n          font-size: 18px;\n          text-align: center;\n          text-transform: uppercase;\n          color: ",";\n          background: ",";\n          border: none;\n          border-radius: 25px;\n\n          @media (max-width: 600px) {\n            font-size: 16px;\n          }\n\n          @media (max-width: 480px) {\n            font-size: ",";\n          }\n        "],["\n          display: block;\n          max-width: 297px;\n          width: 90%;\n          height: 45px;\n          margin: 0 auto;\n          font-size: 18px;\n          text-align: center;\n          text-transform: uppercase;\n          color: ",";\n          background: ",";\n          border: none;\n          border-radius: 25px;\n\n          @media (max-width: 600px) {\n            font-size: 16px;\n          }\n\n          @media (max-width: 480px) {\n            font-size: ",";\n          }\n        "]),_templateObject13=_taggedTemplateLiteral(["\n          height: 80px;\n          margin: 0;\n          padding: 0 50px;\n          min-width: 330px;\n          text-align: center;\n          border: none;\n          border-radius: 90px;\n          cursor: pointer;\n          font-size: 30px;\n          color: ",";\n          text-transform: uppercase;\n          background: ",";\n        "],["\n          height: 80px;\n          margin: 0;\n          padding: 0 50px;\n          min-width: 330px;\n          text-align: center;\n          border: none;\n          border-radius: 90px;\n          cursor: pointer;\n          font-size: 30px;\n          color: ",";\n          text-transform: uppercase;\n          background: ",";\n        "]),_templateObject14=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: ",";\n  z-index: 9999999;\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: ",";\n  z-index: 9999999;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"],["\n  width: 100%;\n  height: 100%;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  height: 100%;\n  overflow: hidden;\n  -webkit-text-size-adjust: 100%;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  height: 100%;\n  overflow: hidden;\n  -webkit-text-size-adjust: 100%;\n\n  ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n      flex-direction: row;\n    "],["\n      flex-direction: row;\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  overflow: auto;\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  flex: 1;\n  overflow: auto;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 20px;\n  padding: 0 20px;\n  font-weight: 500;\n  font-size: 28px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 360px) {\n    font-size: 32px;\n  }\n\n  ",";\n"],["\n  width: 100%;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 20px;\n  padding: 0 20px;\n  font-weight: 500;\n  font-size: 28px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 360px) {\n    font-size: 32px;\n  }\n\n  ",";\n"]),_templateObject20=_taggedTemplateLiteral(["\n      font-size: 32px;\n\n      @media (min-width: 600px) {\n        font-size: 40px;\n      }\n    "],["\n      font-size: 32px;\n\n      @media (min-width: 600px) {\n        font-size: 40px;\n      }\n    "]),_templateObject21=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 20px;\n  padding: 0 20px;\n  font-size: 20px;\n  line-height: 1.2;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 600px) {\n    margin-bottom: 40px;\n    font-size: 24px;\n  }\n\n  ",";\n"],["\n  width: 100%;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 20px;\n  padding: 0 20px;\n  font-size: 20px;\n  line-height: 1.2;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 600px) {\n    margin-bottom: 40px;\n    font-size: 24px;\n  }\n\n  ",";\n"]),_templateObject22=_taggedTemplateLiteral(["\n      margin-bottom: 30px;\n    "],["\n      margin-bottom: 30px;\n    "]),_templateObject23=_taggedTemplateLiteral(["\n  margin-top: 15px;\n  margin-bottom: 30px;\n  text-align: center;\n\n  ",";\n"],["\n  margin-top: 15px;\n  margin-bottom: 30px;\n  text-align: center;\n\n  ",";\n"]),_templateObject24=_taggedTemplateLiteral(["\n      margin-bottom: 10px;\n    "],["\n      margin-bottom: 10px;\n    "]),_templateObject25=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 25px;\n  margin-bottom: 15px;\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 25px;\n  margin-bottom: 15px;\n\n  ",";\n"]),_templateObject26=_taggedTemplateLiteral(["\n      margin-left: 20px;\n      margin-right: auto;\n    "],["\n      margin-left: 20px;\n      margin-right: auto;\n    "]),_templateObject27=_taggedTemplateLiteral(["\n  width: 30px;\n  height: 22px;\n  margin-right: 10px;\n  color: ",";\n\n  ",";\n"],["\n  width: 30px;\n  height: 22px;\n  margin-right: 10px;\n  color: ",";\n\n  ",";\n"]),_templateObject28=_taggedTemplateLiteral(["\n      width: 35px;\n      height: 22px;\n      background: url(",") no-repeat 50% 50%;\n      background-size: cover;\n    "],["\n      width: 35px;\n      height: 22px;\n      background: url(",") no-repeat 50% 50%;\n      background-size: cover;\n    "]),_templateObject29=_taggedTemplateLiteral(["\n  width: 84px;\n  height: 15px;\n  color: ",";\n\n  ",";\n"],["\n  width: 84px;\n  height: 15px;\n  color: ",";\n\n  ",";\n"]),_templateObject30=_taggedTemplateLiteral(["\n      width: 80px;\n      height: 15px;\n      background: url(",") no-repeat 50% 50%;\n      background-size: cover;\n    "],["\n      width: 80px;\n      height: 15px;\n      background: url(",") no-repeat 50% 50%;\n      background-size: cover;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ProjectTitle=function ProjectTitle(){switch("irontrade"){case"siamoption":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Siam,null,"Siam"),"Option");case"irontrade":return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{isIntlProject:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Iron,null,"Iron"),"Trade");default:return"Binary Options Broker";}};var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject,function(props){return props.theme.direction;},function(_ref){var isIntlProject=_ref.isIntlProject,theme=_ref.theme;return isIntlProject?theme.sightseeingTitle:"#fff";});var Siam=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2);var Iron=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject3,function(props){return props.theme.sightseeingIron;});var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Cell=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(_ref2){var theme=_ref2.theme;return theme.sightseeingBg;});var FirstContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var SubTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref3){var isIntlProject=_ref3.isIntlProject,theme=_ref3.theme;return isIntlProject?theme.sightseeingTitle:"#fff";});var Later=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject10,function(_ref4){var isMobile=_ref4.isMobile;return isMobile?"15px":"18px";},function(_ref5){var theme=_ref5.theme;return theme.sightseeingLater;});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject11,function(_ref6){var isMobile=_ref6.isMobile;return isMobile?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12,function(props){return props.theme.sightSeeingStartButtonColor;},function(props){return props.theme.sightSeeingStartButtonBg;},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"14px";}):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13,function(props){return props.theme.sightSeeingStartButtonColor;},function(props){return props.theme.sightSeeingStartButtonBg;});});var SliderContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(props){return props.theme.main;});var SliderView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var Slide=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);});var First=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject18);var FirstTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject19,function(_ref8){var isIntlProject=_ref8.isIntlProject,theme=_ref8.theme;return isIntlProject?theme.sightseeingTitle:"#fff";},function(props){return props.last&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject20);});var FirstText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject21,function(_ref9){var isIntlProject=_ref9.isIntlProject,theme=_ref9.theme;return isIntlProject?theme.sightseeingTitle:"#fff";},function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject22);});var LaterContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject23,function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject24);});var LogoContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject25,function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject26);});var Logo=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject27,function(_ref10){var theme=_ref10.theme;return theme.sightseeingTitle;},function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject28,function(props){return props.theme.indexLogo;});});var LogoText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject29,function(_ref11){var theme=_ref11.theme;return theme.sightseeingTitle;},function(props){return props.thProject&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject30,function(props){return props.theme.indexLogoText;});});var FirstSlideComponent=function FirstSlideComponent(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Orientation__["a" /* default */],null,function(screen){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SliderContainer,{ref:props.forwardedRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SliderView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Slide,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](First,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LogoContainer,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_4__common_Orientation__["b" /* isLandscape */])(screen)}, false?React.createElement(Logo,{thProject:true}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Logo,{thProject:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__themes_irontrade_IndexLogo__["a" /* IndexLogo */],{fill:"currentColor",width:30,height:22})), false?React.createElement(LogoText,{thProject:true}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LogoText,{thProject:false},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__themes_irontrade_IndexLogo__["b" /* IndexLogoText */],{fill:"currentColor",width:84,height:15}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FirstTitle,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Discover ", false?React.createElement(Gettext,null,"SiamOption"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"IronTrade"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FirstText,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_4__common_Orientation__["b" /* isLandscape */])(screen),isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Meet the new trade platform and learn about basic functions")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{isMobile:matches,onClick:function onClick(){props.next();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Get started"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](LaterContainer,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_4__common_Orientation__["b" /* isLandscape */])(screen)},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Later,{onClick:props.onLater,isMobile:matches},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"no, i\u2019d like to do it later")))))));}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Popup,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Table,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Cell,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FirstContainer,{ref:props.forwardedRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Discover ",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProjectTitle,null))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SubTitle,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Meet the new trade platform and learn about basic functions")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{onClick:function onClick(){props.next();}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Get started")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{marginTop:20}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Later,{onClick:props.onLater},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"no, i\u2019d like to do it later"))))))));});};var FirstSlide=__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](FirstSlideComponent,Object.assign({},props,{forwardedRef:ref}));});/* harmony default export */ __webpack_exports__["a"] = (FirstSlide);

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments_ColorfulCup__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Orientation__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_fetch__ = __webpack_require__(9);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  height: 62px;\n  padding-top: 10px;\n  font-weight: 500;\n  font-size: 52px;\n  color: ",";\n\n  @media (max-height: 840px) {\n    height: 42px;\n    padding-top: 0;\n    font-size: 32px;\n  }\n"],["\n  height: 62px;\n  padding-top: 10px;\n  font-weight: 500;\n  font-size: 52px;\n  color: ",";\n\n  @media (max-height: 840px) {\n    height: 42px;\n    padding-top: 0;\n    font-size: 32px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 586px;\n  margin: 20px auto;\n  margin-top: 50px;\n  margin-bottom: 48px;\n\n  @media (max-height: 840px) {\n    margin-top: 10px;\n    margin-bottom: 18px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 586px;\n  margin: 20px auto;\n  margin-top: 50px;\n  margin-bottom: 48px;\n\n  @media (max-height: 840px) {\n    margin-top: 10px;\n    margin-bottom: 18px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  z-index: 3;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 486px;\n  height: 331px;\n  box-shadow: 0 0 20px ",";\n  background-color: ",";\n"],["\n  position: relative;\n  z-index: 3;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 486px;\n  height: 331px;\n  box-shadow: 0 0 20px ",";\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: inline-block;\n  height: 57px;\n  min-width: 300px;\n  margin-top: 20px;\n  padding: 0 20px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  text-transform: uppercase;\n  border-radius: 90px;\n  border: none;\n  line-height: 57px;\n  cursor: pointer;\n  vertical-align: top;\n  text-decoration: none;\n  color: ",";\n  background: ",";\n"],["\n  display: inline-block;\n  height: 57px;\n  min-width: 300px;\n  margin-top: 20px;\n  padding: 0 20px;\n  font-size: 18px;\n  font-weight: bold;\n  text-align: center;\n  text-transform: uppercase;\n  border-radius: 90px;\n  border: none;\n  line-height: 57px;\n  cursor: pointer;\n  vertical-align: top;\n  text-decoration: none;\n  color: ",";\n  background: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: ",";\n  margin-left: ",";\n  background: none;\n  border: 2px solid\n    ",";\n  color: ",";\n  text-decoration: none;\n  line-height: 55px;\n"],["\n  display: inline-block;\n  margin-right: ",";\n  margin-left: ",";\n  background: none;\n  border: 2px solid\n    ",";\n  color: ",";\n  text-decoration: none;\n  line-height: 55px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n"],["\n  direction: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  font-size: 18px;\n  line-height: 1.2;\n  text-align: center;\n  cursor: default;\n  color: ",";\n"],["\n  margin-bottom: 20px;\n  font-size: 18px;\n  line-height: 1.2;\n  text-align: center;\n  cursor: default;\n  color: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: relative;\n  z-index: 2;\n  width: 29px;\n  height: 280px;\n  background: ",";\n  box-shadow: 0 0 20px ",";\n"],["\n  position: relative;\n  z-index: 2;\n  width: 29px;\n  height: 280px;\n  background: ",";\n  box-shadow: 0 0 20px ",";\n"]),_templateObject9=_taggedTemplateLiteral(["\n  position: relative;\n  z-index: 1;\n  width: 21px;\n  height: 220px;\n  background: ",";\n  box-shadow: 0 0 20px ",";\n"],["\n  position: relative;\n  z-index: 1;\n  width: 21px;\n  height: 220px;\n  background: ",";\n  box-shadow: 0 0 20px ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n  overflow: auto;\n"],["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 999999;\n  overflow: auto;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: table;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n"],["\n  display: table;\n  vertical-align: middle;\n  width: 100%;\n  height: 100%;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n"],["\n  display: table-cell;\n  vertical-align: middle;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 1000px;\n  width: 95%;\n  height: 792px;\n  margin: 0 auto;\n  padding: 50px 75px 44px 75px;\n  text-align: center;\n  border-radius: 20px;\n  background: ",";\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n\n  @media (max-width: 1000px) {\n    max-width: 940px;\n    width: 100%;\n  }\n\n  @media (max-height: 840px) {\n    height: 615px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 1000px;\n  width: 95%;\n  height: 792px;\n  margin: 0 auto;\n  padding: 50px 75px 44px 75px;\n  text-align: center;\n  border-radius: 20px;\n  background: ",";\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n\n  @media (max-width: 1000px) {\n    max-width: 940px;\n    width: 100%;\n  }\n\n  @media (max-height: 840px) {\n    height: 615px;\n    padding-top: 20px;\n    padding-bottom: 20px;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: ",";\n  z-index: 9999999;\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  width: 100%;\n  background-color: ",";\n  z-index: 9999999;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"],["\n  width: 100%;\n  height: 100%;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  height: 100%;\n  overflow: hidden;\n  -webkit-text-size-adjust: 100%;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: stretch;\n  height: 100%;\n  overflow: hidden;\n  -webkit-text-size-adjust: 100%;\n\n  ",";\n"]),_templateObject17=_taggedTemplateLiteral(["\n      flex-direction: row;\n    "],["\n      flex-direction: row;\n    "]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n  min-height: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  overflow: auto;\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  width: 100%;\n  min-height: 100%;\n  padding-top: 10px;\n  padding-bottom: 10px;\n  overflow: auto;\n\n  ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n      padding-top: 20px;\n      padding-bottom: 20px;\n    "],["\n      padding-top: 20px;\n      padding-bottom: 20px;\n    "]),_templateObject20=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 10px;\n  padding: 0 20px;\n  font-weight: 500;\n  font-size: 28px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 360px) {\n    font-size: 32px;\n  }\n\n  ",";\n"],["\n  width: 100%;\n  max-width: 500px;\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 10px;\n  padding: 0 20px;\n  font-weight: 500;\n  font-size: 28px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 360px) {\n    font-size: 32px;\n  }\n\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n      font-size: 32px;\n\n      @media (min-width: 600px) {\n        font-size: 40px;\n      }\n    "],["\n      font-size: 32px;\n\n      @media (min-width: 600px) {\n        font-size: 40px;\n      }\n    "]),_templateObject22=_taggedTemplateLiteral(["\n  text-align: center;\n  color: ",";\n\n  font-size: 22px;\n  padding-top: 15px;\n  padding-left: 5px;\n  padding-right: 5px;\n\n  ",";\n"],["\n  text-align: center;\n  color: ",";\n\n  font-size: 22px;\n  padding-top: 15px;\n  padding-left: 5px;\n  padding-right: 5px;\n\n  ",";\n"]),_templateObject23=_taggedTemplateLiteral(["\n      font-size: 16px;\n      padding-top: 0;\n      padding-bottom: 15px;\n    "],["\n      font-size: 16px;\n      padding-top: 0;\n      padding-bottom: 15px;\n    "]),_templateObject24=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 500px;\n  margin: 10px auto 20px;\n  padding: 0 20px;\n  font-size: 20px;\n  line-height: 1.2;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 600px) {\n    margin-bottom: 40px;\n    font-size: 24px;\n  }\n\n  ",";\n"],["\n  width: 100%;\n  max-width: 500px;\n  margin: 10px auto 20px;\n  padding: 0 20px;\n  font-size: 20px;\n  line-height: 1.2;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 600px) {\n    margin-bottom: 40px;\n    font-size: 24px;\n  }\n\n  ",";\n"]),_templateObject25=_taggedTemplateLiteral(["\n      margin-bottom: 30px;\n    "],["\n      margin-bottom: 30px;\n    "]),_templateObject26=_taggedTemplateLiteral(["\n  display: block;\n  max-width: 297px;\n  width: 90%;\n  height: 45px;\n  margin: 0 auto;\n  font-size: 18px;\n  text-align: center;\n  text-transform: uppercase;\n  color: ",";\n  background: ",";\n  border: none;\n  border-radius: 25px;\n\n  @media (max-width: 600px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: ",";\n  }\n"],["\n  display: block;\n  max-width: 297px;\n  width: 90%;\n  height: 45px;\n  margin: 0 auto;\n  font-size: 18px;\n  text-align: center;\n  text-transform: uppercase;\n  color: ",";\n  background: ",";\n  border: none;\n  border-radius: 25px;\n\n  @media (max-width: 600px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: ",";\n  }\n"]),_templateObject27=_taggedTemplateLiteral(["\n  display: block;\n  max-width: 297px;\n  width: 90%;\n  height: 45px;\n  margin: 0 auto;\n  font-size: 18px;\n  text-align: center;\n  text-transform: uppercase;\n  color: ",";\n  background: ",";\n  border: none;\n  border-radius: 25px;\n\n  @media (max-width: 600px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: ",";\n  }\n\n  line-height: 45px;\n  text-decoration: none;\n\n  ",";\n\n  ",";\n"],["\n  display: block;\n  max-width: 297px;\n  width: 90%;\n  height: 45px;\n  margin: 0 auto;\n  font-size: 18px;\n  text-align: center;\n  text-transform: uppercase;\n  color: ",";\n  background: ",";\n  border: none;\n  border-radius: 25px;\n\n  @media (max-width: 600px) {\n    font-size: 16px;\n  }\n\n  @media (max-width: 480px) {\n    font-size: ",";\n  }\n\n  line-height: 45px;\n  text-decoration: none;\n\n  ",";\n\n  ",";\n"]),_templateObject28=_taggedTemplateLiteral(["\n      margin-bottom: 15px;\n      line-height: 43px;\n      background: transparent;\n      border: 2px solid\n        ",";\n      color: ",";\n    "],["\n      margin-bottom: 15px;\n      line-height: 43px;\n      background: transparent;\n      border: 2px solid\n        ",";\n      color: ",";\n    "]),_templateObject29=_taggedTemplateLiteral(["\n      flex-basis: 50%;\n      width: 50%;\n      margin-left: 10px;\n      margin-right: 10px;\n    "],["\n      flex-basis: 50%;\n      width: 50%;\n      margin-left: 10px;\n      margin-right: 10px;\n    "]),_templateObject30=_taggedTemplateLiteral(["\n  width: 100%;\n\n  ",";\n"],["\n  width: 100%;\n\n  ",";\n"]),_templateObject31=_taggedTemplateLiteral(["\n      display: flex;\n      flex-direction: row;\n      max-width: 600px;\n      margin: 0 auto;\n    "],["\n      display: flex;\n      flex-direction: row;\n      max-width: 600px;\n      margin: 0 auto;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SlideTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var isIntlProject=_ref.isIntlProject,theme=_ref.theme;return isIntlProject?theme.sightseeingTitle:"#fff";});var ImageContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var CenterImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.sightSeeingImageShadow;},function(_ref3){var isIntlProject=_ref3.isIntlProject,theme=_ref3.theme;return isIntlProject?theme.indexMajor:"#251f2b";});var NextButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.sightSeeingStartButtonColor;},function(props){return props.theme.sightSeeingStartButtonBg;});var HelpButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(NextButton)(_templateObject5,function(props){return props.theme.direction!=="rtl"?"20px":0;},function(props){return props.theme.direction!=="rtl"?0:"20px";},function(_ref4){var isIntlProject=_ref4.isIntlProject,theme=_ref4.theme;return isIntlProject?theme.themeToggleActive:"#fff";},function(_ref5){var isIntlProject=_ref5.isIntlProject,theme=_ref5.theme;return isIntlProject?theme.themeToggleActive:"#fff";});var ButtonsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.direction;});var TextTutor=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(_ref6){var isIntlProject=_ref6.isIntlProject,theme=_ref6.theme;return isIntlProject?theme.sightseeingTitle:"#fff";});var BigBg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref7){var theme=_ref7.theme;return theme.sightseeingBigBg;},function(_ref8){var theme=_ref8.theme;return theme.sightSeeingBgShadow;});var SmallBg=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref9){var theme=_ref9.theme;return theme.sightseeingSmallBg;},function(_ref10){var theme=_ref10.theme;return theme.sightSeeingBgShadow;});var Popup=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var Cell=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13,function(props){return props.isIntlProject?props.theme.sightseeingBg:props.theme.sightseeingBg;});var SliderContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(props){return props.theme.main;});var SliderView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15);var Slide=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject17);});var LastSlideC=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject18,function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject19);});var FirstTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject20,function(_ref11){var isIntlProject=_ref11.isIntlProject,theme=_ref11.theme;return isIntlProject?theme.sightseeingTitle:"#fff";},function(props){return props.last&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject21);});var SubTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject22,function(_ref12){var isIntlProject=_ref12.isIntlProject,theme=_ref12.theme;return isIntlProject?theme.sightseeingTitle:"#fff";},function(_ref13){var isMobile=_ref13.isMobile;return isMobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject23);});var FirstText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject24,function(_ref14){var isIntlProject=_ref14.isIntlProject,theme=_ref14.theme;return isIntlProject?theme.sightseeingTitle:"#fff";},function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject25);});var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject26,function(props){return props.theme.sightSeeingStartButtonColor;},function(props){return props.theme.sightSeeingStartButtonBg;},function(_ref15){var theme=_ref15.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var LinkButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Button)(_templateObject27,function(props){return props.theme.sightSeeingStartButtonColor;},function(props){return props.theme.sightSeeingStartButtonBg;},function(_ref16){var theme=_ref16.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.help&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject28,function(_ref17){var isIntlProject=_ref17.isIntlProject,theme=_ref17.theme;return isIntlProject?theme.themeToggleActive:"#fff";},function(_ref18){var isIntlProject=_ref18.isIntlProject,theme=_ref18.theme;return isIntlProject?theme.themeToggleActive:"#fff";});},function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject29);});var Links=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject30,function(props){return props.isLandscape&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject31);});var endTour=function endTour(serverData,profile,dispatch,redirect,tour){Object(__WEBPACK_IMPORTED_MODULE_9__common_fetch__["d" /* get */])("/tours/stats?action=2&tour=tour"+tour.analyticsID);if(profile!=null){try{Object(__WEBPACK_IMPORTED_MODULE_9__common_fetch__["d" /* get */])("/ajax/saveSettings/?name=tourShown&value=1").then(function(){Object(__WEBPACK_IMPORTED_MODULE_9__common_fetch__["d" /* get */])("/api/server-data").then(function(serverData){dispatch({type:"RECEIVE_SERVER_DATA",payload:serverData});redirect();});});}catch(error){console.log("tourShown ajax ",error);}}else{try{Object(__WEBPACK_IMPORTED_MODULE_9__common_fetch__["d" /* get */])("/api/server-data").then(function(serverData){dispatch({type:"RECEIVE_SERVER_DATA",payload:serverData});redirect();});}catch(error){console.log("tourShown ajax ",error);}}};var LastSlideComponent=function LastSlideComponent(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),redirecting=_useState2[0],redirect=_useState2[1];if(redirecting!=null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{push:true,to:redirecting});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["a" /* default */],null,function(screen){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SliderContainer,{ref:props.forwardedRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SliderView,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Slide,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LastSlideC,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["b" /* isLandscape */])(screen)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FirstTitle,{last:true,isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Congratulations!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubTitle,{isIntlProject:"irontrade"==="irontrade",isMobile:matches},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You have made a good choice! Your forecast is correct!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments_ColorfulCup__["a" /* default */],{width:70}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FirstText,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Trading strategies, video tutorials and much more on the pages of our Help Center")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Links,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["b" /* isLandscape */])(screen)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkButton,{help:true,isLandscape:Object(__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["b" /* isLandscape */])(screen),onClick:function onClick(){endTour(props.serverData,props.profile,props.dispatch,function(){return redirect("/helpdesk");},props.tour);Object(__WEBPACK_IMPORTED_MODULE_7__GA__["a" /* gaReducer */])("CLICK_HELP_TOUR_"+props.tour.analyticsID);},isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Go to help center")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkButton,{isLandscape:Object(__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["b" /* isLandscape */])(screen),onClick:function onClick(){endTour(props.serverData,props.profile,props.dispatch,function(){return redirect("/trade");},props.tour);Object(__WEBPACK_IMPORTED_MODULE_7__GA__["a" /* gaReducer */])("CLICK_TRADE_TOUR_"+props.tour.analyticsID);},isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Trade now")))))));}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Popup,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Table,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Cell,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SlideTitle,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Congratulations!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SubTitle,{isIntlProject:"irontrade"==="irontrade",isMobile:matches},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"You have made a good choice! Your forecast is correct!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ImageContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallBg,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BigBg,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CenterImage,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments_ColorfulCup__["a" /* default */],{width:180})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BigBg,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SmallBg,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TextTutor,{isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Trading strategies, video tutorials and much more on the pages of our Help Center")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HelpButton,{onClick:function onClick(){endTour(props.serverData,props.profile,props.dispatch,function(){return redirect("/helpdesk");},props.tour);Object(__WEBPACK_IMPORTED_MODULE_7__GA__["a" /* gaReducer */])("CLICK_HELP_TOUR_"+props.tour.analyticsID);},isIntlProject:"irontrade"==="irontrade"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Go to help center")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NextButton,{onClick:function onClick(){endTour(props.serverData,props.profile,props.dispatch,function(){return redirect("/trade");},props.tour);Object(__WEBPACK_IMPORTED_MODULE_7__GA__["a" /* gaReducer */])("CLICK_TRADE_TOUR_"+props.tour.analyticsID);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Get started"))))))));});};var LastSlide=__WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LastSlideComponent,Object.assign({},props,{forwardedRef:ref}));});/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__withData__["a" /* default */])(["serverData","profile"])(LastSlide));

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_SideArrow__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_desktop_light_bonus_indicator_png__ = __webpack_require__(1730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_desktop_light_bonus_indicator_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_desktop_light_bonus_indicator_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_desktop_dark_bonus_indicator_png__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_desktop_dark_bonus_indicator_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_desktop_dark_bonus_indicator_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_mobile_light_bonus_indicator_png__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_mobile_light_bonus_indicator_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_mobile_light_bonus_indicator_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_mobile_dark_bonus_indicator_png__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__images_mobile_dark_bonus_indicator_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__images_mobile_dark_bonus_indicator_png__);
var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 43px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 20px 17px;\n    border-radius: 0;\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 43px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 20px 17px;\n    border-radius: 0;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: none;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: none;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-bottom: 20px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    margin-left: 46px;\n    margin-right: 46px;\n  }\n"],["\n  margin-bottom: 20px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    margin-left: 46px;\n    margin-right: 46px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  line-height: 1.2;\n  font-weight: bold;\n"],["\n  line-height: 1.2;\n  font-weight: bold;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-bottom: 10px;\n  font-size: 28px;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  margin-bottom: 10px;\n  font-size: 28px;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  font-size: 64px;\n\n  @media (max-width: 959px) {\n    font-size: 24px;\n  }\n"],["\n  font-size: 64px;\n\n  @media (max-width: 959px) {\n    font-size: 24px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  margin-bottom: 33px;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n    font-size: ",";\n  }\n"],["\n  margin-bottom: 33px;\n  font-size: ",";\n  line-height: 1.2;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    margin-bottom: 20px;\n    font-size: ",";\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 33px;\n\n  @media (max-width: 959px) {\n    margin-bottom: 21px;\n\n    @media (orientation: portrait) {\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n"],["\n  display: flex;\n  justify-content: center;\n  margin-bottom: 33px;\n\n  @media (max-width: 959px) {\n    margin-bottom: 21px;\n\n    @media (orientation: portrait) {\n      flex-direction: column;\n      align-items: center;\n    }\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  width: 413px;\n  margin-top: 18px;\n  margin-right: 10px;\n  font-size: ",";\n  line-height: 24px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    width: auto;\n    max-width: 250px;\n    font-size: ",";\n    line-height: 1.2;\n    margin-top: 9px;\n\n    @media (orientation: portrait) {\n      margin-top: 0;\n      margin-right: 0;\n      margin-bottom: 15px;\n    }\n  }\n"],["\n  width: 413px;\n  margin-top: 18px;\n  margin-right: 10px;\n  font-size: ",";\n  line-height: 24px;\n  color: ",";\n\n  @media (max-width: 959px) {\n    width: auto;\n    max-width: 250px;\n    font-size: ",";\n    line-height: 1.2;\n    margin-top: 9px;\n\n    @media (orientation: portrait) {\n      margin-top: 0;\n      margin-right: 0;\n      margin-bottom: 15px;\n    }\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  position: relative;\n  width: 92px;\n  height: 110px;\n  ",";\n\n  @media (max-width: 959px) {\n    width: 209px;\n    min-width: 209px;\n    height: 81px;\n\n    ",";\n  }\n"],["\n  position: relative;\n  width: 92px;\n  height: 110px;\n  ",";\n\n  @media (max-width: 959px) {\n    width: 209px;\n    min-width: 209px;\n    height: 81px;\n\n    ",";\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n          background-image: url(",");\n        "],["\n          background-image: url(",");\n        "]),_templateObject15=_taggedTemplateLiteral(["\n            background-image: url(",");\n          "],["\n            background-image: url(",");\n          "]),_templateObject16=_taggedTemplateLiteral(["\n  color: #0085eb;\n  text-decoration: underline;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: none;\n  }\n"],["\n  color: #0085eb;\n  text-decoration: underline;\n  cursor: pointer;\n\n  :hover {\n    text-decoration: none;\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  position: absolute;\n  left: -27px;\n  bottom: 0;\n  right: calc(100% - 10px);\n  width: 25px;\n  height: 16px;\n  color: ",";\n"],["\n  position: absolute;\n  left: -27px;\n  bottom: 0;\n  right: calc(100% - 10px);\n  width: 25px;\n  height: 16px;\n  color: ",";\n"]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"],["\n  display: flex;\n  justify-content: center;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"],["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to left, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to left, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.freeBonusPopupFontColor;},function(_ref2){var theme=_ref2.theme;return theme.popupDarkBackground;});var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject4);var TitleContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var LittleTitle=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Title)(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(18));var BigTitle=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Title)(_templateObject8);var Percent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject9,function(_ref3){var theme=_ref3.theme;return theme.freeBonusPopupPercentColor;});var Description=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(18),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var HintBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var HintText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14),function(_ref4){var theme=_ref4.theme;return theme.freeBonusPopupHintColor;},Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var HintImage=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13,function(_ref5){var theme=_ref5.theme;return theme.mode==="light"?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14,__WEBPACK_IMPORTED_MODULE_8__images_desktop_light_bonus_indicator_png___default.a):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject14,__WEBPACK_IMPORTED_MODULE_9__images_desktop_dark_bonus_indicator_png___default.a);},function(_ref6){var theme=_ref6.theme;return theme.mode==="light"?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject15,__WEBPACK_IMPORTED_MODULE_10__images_mobile_light_bonus_indicator_png___default.a):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject15,__WEBPACK_IMPORTED_MODULE_11__images_mobile_dark_bonus_indicator_png___default.a);});var HintLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["a" /* Link */])(_templateObject16);var HintImageArrow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject17,function(_ref7){var theme=_ref7.theme;return theme.freeBonusPopupArrowColor;});var ButtonBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject18);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject19,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12));var FreeBonusPopup=function FreeBonusPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TitleContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LittleTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Deposit any amount of money now and enjoy"))," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BigTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"a free ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Percent,null,"50%")," bonus!"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"We give this bonus to encourage and support our new traders, so you can start your trading career with maximum benefits and minimum losses.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HintBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HintText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Please note that you can use this bonus only for a limited time. You can always check the time left",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HintLink,{to:"/fillup?promocode="+props.promo},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"here")),"or near a bonus indicator.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HintImage,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HintImageArrow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Icons_SideArrow__["a" /* default */],null));}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Got it")))));};/* harmony default export */ __webpack_exports__["a"] = (FreeBonusPopup);

/***/ }),
/* 1730 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1731 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFwAAABuCAYAAACqXXT+AAAABHNCSVQICAgIfAhkiAAAIABJREFUeJztnXd4XMW5/z9zzvZV78WSLBdsI3fJxmB6C9VAaAmXBEJIIPcGzIVLICT8MBd+iROIAyRcEgKEACGEEkJMD8EYm2JbbrKNqySrWb1rtdp25v6xK2nL2dVKlhuX7/PoebQzZ9p75rzztpkRHGOQy1C4lCl4uBLBaUAJkAt0I3kTyRMobBFl9B+pPv7617++UFXV+ltvvXUrwGOPPZbk8/kulFK+J45Up8YCuY50DPwIyTeBCYBe/x3AO3i5Tyzii8PbQz9WrFhRAlwspXxPVdUDwHc0TasyGAxvHFUEl+UUYsLALKqFQA6l78DEAJch+QkwK87q3Ah+yEqeFsvQQupysQiNTqr4QlyFb7zHAbBixYoyRVGuA7oURdl16623/hnAcCgaixeynFzgEuBCJCcBabiBjXTLciqBViAZJ8cBaaOs3oTkSS7kIXkR+4EWBCb6mYUI1DUJlyxnO4J3kfxNlLFpvMbm8/lqVVXtlVIapZRbB9OP2AyX68lBsBKYiziyLx6QSBpQuEOU8vLBVvb4448nuN3u7wshGhRF2aNp2jdVVX35lltuKT8iBJebKEJjNVB0JNqPAQfwdVHG+wdTyYoVKy5TFMV02223/TXwe6Gqqid7PJ7nDvvMkqswoPEToGA05QYcKu0H7HQ22elts+EZMOBzG/C5VIrP243R7ENRQFUkRgNYjBpmo8RgABH/tLIDf5FbOFXMZccohzYEl8v1kcvlcg7+vv3229c//PDDVX19fV2HfYbLjZyJ5F3AGO0ZzQcupwFHl5mqikwavsjA0ZwYtc5Z312HatZf+wyqJMnmI8nufwGqAooyQicFr2HhelFCXzxjGg0OG8HlKgwkcykajwNZes94XAp1u9Jo2p1Gc3UKjnYryJGoE5vgwTCoEotJw2aWJFg1rGYZbfZ7kDyPi9vEyfSOWPEocFgILteRjsqjwFXozGyfR7Djk1y2vTsZ6Rs9l4uX4OGwmjXy0z1YzFEekGxD5SYxn89GXXkUjDvBpUSwkYVIyoBSBPOAGUDEsDoabezfkkX15mycndYxd2esBAcQQpJk00hN8GGzSpTILmhALfAFUAOsAt4XZXSPqb0x9TIK5CosJHIPcCOQgV/Oj2jD5xFs/ySXyrWF9PdYQMbbDYnR7iIx20FCmhOz3YPF5iF/XhOakGg+gccHA24Fl2dkVhQMVfETPjfdOxKP70OyB8nNYiEbRtUI40hw+SlWTNwH3EEUhUpK6Gi0U/6PKbRWpsZuXkgsiS7sqQMkZfeRPbmLnEnd2JPdcUkdmgYDbkGfU9DvUvB4BW6vQI7wclVFkpvuJcmu6c32YNQh+aZYwCcj9yZoWKN5OBqkRGEDv0RwGwJV7xmvV7B3XS7bPyzC1WOJ0SON1MJuJpc2k1nUQ1K6E6NZi/58fP3D6wOnW6HXodDlUGISXhGSZLtGdpoXg+5o/NUi+QIPC8RJOKM+FYbxIfh6TkPhFSBTL9/jUih/q5jKzwuisA+JweQjKbePOV+rIm9K92hk51HD54PmTpWefhWvD6KRwWbWyM/wYDbFrO6/RRn3xdv2+BC8nP8GfgJEcD9Ht4nylZOp25odpTlJ9rQ2jj+1nrypXYeU0OFweaCrV6WjV8Wn6TdsMWnkpXuxWaRuPlAJLBJltMXT5nhpmvPRITbAp69NpXlnJnrEVs0e5l60j6mlzaiGqDLxIYPZCFmpfqWorsWA2xs5hAG3Qm2LkcJsDzazLtHTgOnA2njaHN1SrgMpEcC88HRHj5F/Pl1C884sIogtNDKKOzn9hgqmn9CEwXj4iT3UFQFWs2Rynof0JC9BVuEhdNUl8dGzM+losupVYUMwI972DprgbOYU/B6XIXjdCpvenETzLj2WLpm8qIHTr9tO7qSeI0bocKgqZKf5KMr2oCrDRO+uTmX/u9Pp2JfBh3+YQ3ujLbyoCcksKeOj5UERXH5OEhp/JGgK+3yCzR8UUrM5l/CZrZq8TFlcx8IllVjs3oNp+pBAEZBgkxRkejCqGl1VadStnoR3wK8cD/RYWffyNPq6QlZRAVzCZnLiamOsnZMvo2Lkh8CkoTQJleXZ7P6oiHBiK0Yvx5+xnxOWVKIaoi5ARwX8RPfSXpGLtz9UQe5oSGbTuxORoUMoRPKE/JykkeoeE8HlKgxM4jwkPw5O72q2se2DiToGJ8nE0kZmnVmHOHgmdlhgs0oWLqnEZHeFZkhB7cZ8KlbnhxJdsgQjv5XlJMeqd9TDl1vIJ4FHkPwdSBhM13yw8a1inF3hSo2keEEDC5dUjmwWPcqQXdxN2aV7EGqknWbvx4W01yeEJkr+DcGrciMXS6mvAI6KBHIrWXj4EMEPwt1iOz7Jo2lXpPiXPrGb+RdUYzAe3WxED4oCxXPamHPhPgiTXgZ6zVR8GOFDUZCcjeRFNvFt3TrjbVyWk4ubtxAcF16uo9HGnjWFhBPbYPUw74J9WBOOvgUyXggB0xY2kVfSGp7DgR3ZVG9N1yuWgMajcgOnh2eMZoZfgWCuXkblxhyc3ZGsZN5Fe8meOK72+yMCg0lj1ln7CZ/lSMHWdyeHSy1+CBIRPCkrSA1Ojp/gksvR0Uw9boX9m7PDbCSSzCkdTJ7XetTI2QcDISCzwMHU02sIJ7qj00rt9oxwqWUQRQxwTnBCXASXqzAgOEEvb/MHhRHWP9WoMX1xParh4Kx8RxtKz91PakGo30H6FGq2ZuHz6s4sIwrzAto4EO8MT6YEiLCp9nUZ2bNqYsTjiZl9FMzo+FLM7mAYjJIZJ9cjlNCJ1L4/hdY6u14RgSCLIDrHZ7zykaBn6GvYlU74QikUjbkXVqFEtyOzZZ+drZXDHTQaJNMK+pk92YExUE6T0NBq4osaG00dJgqyXMyf2kdKgl9EW7U5mdoWMzMK+ymb1oeiQG2zmVVbkslNc3N2WRfrdyayu87KSSU9TJ0wgNcHH1ck09Bm5rQ53RRmuXB7BHvqreystdI/oHJ8UT/TC/tJtOl/nVmTurGnO+lrDSawYNu/JpI7aXtkAYnkleGf8RFcsB0/8xpW4b2ClqqUiEdTizrJn9oVs7q125L57d/zhqsXErvFx9wpfTz2w0psFklFlY0fP1lMQ7sZt0fBYvIxe5KDh26uJjvVw6sfZ/CvTalMyXPy8n07sVk09tRZ+fmLhZw4o4ezSrt4d30qL63K4sEb9gcILnh1dQZrKpLJS3dTmOXimXeyeeadHPoGVDRNkGDxcersbh68cT82HceHPdlNwdwmdv5zckh6y950ejrNJKWGKEoSSXNw/GJcLEWU0Y2kKjjN7TTQWhOmVAmNKWUtcbOSxTO7eebO3Tx0UzV2i0b5riR219lwugT///lCGtrN3HxRI8/cuZtzyzpZvyuJ5S9OwBMkZe47YOWJlbloY1gumjsMPPLaBIwGyVN37OEvP91Jot3L2+vTqKiMMFL5hyhg+qJGFGOYqCsVardHiIg+/PbyIYzGHl4PDL3WnjYL/Z2h5kpLkpuMgp64K8xK8XDSzF4a2kykJHjpcajYLBobdiWyrTqBxTO7uWlJI6oC84/rY0e1nXfWp3PzksaQev70XjYXLOwYxVD8GJwYXp8gye5jZnE/T9+5l7YuI8V5A1HL2ZM85Exr58D27JD0jtpkfN7GYFuRD4UDwc/ELxaGGYr3b8uIcJclpjlJyozbvcfrazOYfl0ZZ90xm911NpZe3sDUCU4a2vxy7fQCJ2qghxaTZFKev+6m9mGD0rllHZgMGr95PQ+XZ3SrdFaql++c14THK/jGA9O58eEp7K61Mq2gn4yk2MrapHnNhIuI3S02XM6QOSzxhj4U/wwX5AcXbdiZEfFIUl4fhlFYAmcVO7joxHYcAyp/XZXJys/SOXlWD06X/oqr50WfPclBTpqbNz7JID/dHXfbg/iPSw8ws9jBPzem8vkXiazdlsJFi9pZdn0NCdbofCoxfQCjzYOnf1jpcXRY8DgNkOgZTFJRQ8228cnh5UxHMnXwd3+fgf62hIjn8o5rj6e6IUzJd3Ld11q44fwmSiY62FVr49MdSeSm+Qk3ONMH0djh/52aNDQgjAbJbVc0oCqS5z8I/cRHQkObiYZWM/On9vHIf1Txjwe/oCBrgDc/T2fTnsjxBcOS4MGWHGpJ9A6Y6OsMMecaEZQFOydGJLhcRQKSp4PTOhv1ZE5J9sT4+TdAT7/K3noLO2tsNHeaUBRJRrKHk2b1MCFzgHc3pPHWZ6nsrbfw9NvZVFQlMHtSH1PzQ9mWzSz590sPYAxStISArFQPQkhWbUlme7WNTXsSqGq0oCiQnuRmZ42VS+4t4d4/FrG33oLbI0gN2H06eqPGmgJgsXuwhxEcoK0h7EVpXMJGJgz+HJmlJPADBCcGJ3U2R67g5qQBLLbRhZutqUhm455ENA36nCoTc52UHtdHst3HPf9Wx91PFvOTZ4qxmDR6+1Vy0108+N39WHWcueeVdfLce9nUtvj1M0XA109p483PUvloSwrluwPtDKh8/8JGZhb3IyWcOa+Tj7am8K2f21EVaO8xcnyRg1Nmx45kUw0SS3LkwtrZFDYZBROQPCslZwmBjKGeBPbcwCMIQhh21eYsOmpDZfCUgm6mlrXE7OQgGtpM9PYbyEnzO27zM9x848wW7v1WLelJ/pdWmO1i4fRezEYNKQUXLWrnx9fUMznPP6v21ltRFDippJcp+QPYLBp2q4/efgMzivo5eVYPCVaNi05sx27R8PgE+Zlu/vOKBq49pzUQSw5nzO1mar4Tl0fBapZcfGI7t11xgNx0T6whANDeaKNlX6goKAw+pi1qCklCUMwBWu//AxtiLuuynJuBxwljPR+/OI3azXkhzxaWNXDq1XtG7OSXCXvKs1j/15KQNEtqP1fcs07v8TWYuGQkHn4lOnze54n8MMy2kWfElw1GS6To6IsiYQFTcJE/EsFL9RJ97shKTdZj18kwVugR3KszGQNIB5JHIrhuVJ30RlYqlGPPhXaw0DNhSF9UkipoI7l1ZagdYKikOfLNepxHeuff4YdXh32opqhfei8qjtgEV3hbL9mgs9vA7fq/R3CPLsGjisb1eGmJTSXJC8D3INQvZ9CZ4c6e2IrCWDDgFlRU6mt8SXYv0wuHFSCPV9DSaaShzYzBoJGZ7CEnzYMxyNTgcguqmyz09KtkpXgoyHIN2WrG1D9H5Jj1+DoAko85gYbYBE9mD128guD7wcnW1EiBv6dF1+NxUGhoNfPt5dN0806c0cMf7x4WQ3//Zg5vf55GVaMVk0EjN93NeQs6+OFlBzAGRvnrV/P5x6fpdPQamJDp5pZLG7jkZL+V8f0NKcwo6qcgK357jKM9MrjTnqZrvNuPj+VCjLAnT0zFhcr9yNAI/9TMyJMx+tvtyDHYpDfttfPC+1m88H7kTsL61mG7RKLNG/JntQx/um+vT+W3r+dT1WjFZvZhUCU1zRZ+/2Yeq7f6FbRdtVaefS+Hs+Z38dqyL0i2ebnrD5PQNNjXYGHp45P5x6e6IQ+6kBIGuiIJnprjCE/yILlaLKIe4lDtxXwOyE3cgsZTQ5XmRlQKmkJLfQLZhaPbS7ppTyIPv+w3NVx7bqim2tHj757F5GPDE1t0yzucCo+/7lfCinOcPHXnXhQhuf4X06hptvDA84WcMrub5oDhq6TYwdSCAbLTPOyogT11Vla8OoHji/q56vTw2JPocPUb6O+JFOLS88PGL3gHK0Odj4+DzeOP+E92ACA5YwDVHKnoNOxOjUg7GLQHDEhTYjgD6lrNHAhYFc9b0El+hpvcdA+XLvZvSGjuNNHZYyA7YIHcUW1nb52F5g5/3TUtZtbvSuC/rq4jIzl+XcLZa6IvLKxPqBopWSHMwIfkX6KEIT4Vl2ghBJrcyF6kfw+PEJA7o5X6LaHqfWdNCppWN2IMYWO7iXW7EpEabK8eNoS9vmb4k77slHY+rvC78BraTdz40FTWbk8mP8PF4pnd3HB+MxNzXLjcCoNRCMELYGKQLbu+1UzZ9D5uXnKAv32cwaurMyjOHeCB66t55p0cLj+ljROPH92X6ew24+4LneH2tH5MoRq3FxHqmoxflpOETLOJs9oiCN7bYcXRZSYxLdJsGYwvamzc+3QRnjAl4cdPFQ/9f9GJ7YENT9DZa0QRMDnXSWWjlVdWZ+J0qTx0c3Xc3Qf4wcWNnLegc0hKWflpGu09Br5xZvysZBB1u1ORWmj/kzKcWEIJLtFC6TYa4TnEYphZ1IvB6sbrHH7L/Z0WuprsIxLcbNTISXPj8Sk4nAq9AaUpJ21YQjAa4MWf7qam2YzXB5PzXDgGFP7z8Ul8XJHCys/S+dE36kbRfTCbJNMLnUgJWyvtvPBBNhcuamdNRTLX/+I43F6F685p4ZpzmklLjG5q9noFNZsjnR3JOQ4MphCNW4HQ8OW4CC7LMSKZEhyCYrJ4SZ/QS/PeYTageVX2b8ug4PjYDt25U/p46r/2IoFXPsrk6Xf8Xqhn79od8WxR9vDLs1s0zl/YyccVfsljT52VlEQfETF/YUhNDOXNXp/gxX9lUpQ9wLQCJz/7cyHnlHZiMmj89o08hCL5wZLGqKyxamsm7r7IvaZ5M8I2svkjjKcGJ8W3aHqYhSDE62A0a2QVR8af1G3NxuWMaWYnwapRlONiYo4rhBgTA2kTc1wcaDNx/l0lTL+ujKW/mYRP8+8u3lkz3I28DDf5GS5MAeVmW7UNr8+/CfbDLf6JpShyaMEcRPnuBN76PJ2lX28Y2ib+w0sPcNsVfgf7/iZL1G2EPq9g39oJEemWZCe5xWGBqxIFyUT58nCseHwEN6N7WEnu9HbCZ5fmMbDu71PGJJMHIy3Jw7SAJrm6IpkHnivkZ38u4JXVfs42o9DBhEwXKQk+rjm7JfBcCvc+M5H7ni3i0x1+gn/3/KYQZ3Bzp5H7nyvk8lNbKZ3WN7SBqqbZTH2rnz0aVIkQ+l9N494UelrDlTxJydlR1hOBmSuHf8bHw90c0HsyI99B6sQOOveHKgxNuzJob6wnI19HXg/D1We0cr5OTInFJPnJtbU0thvZWpnIS6uGFaPMZDf3frt2SIO86aJGtlfZWbs9mdfXDi81cyf38b0LQ7wvmAwaZ87r4oITOjEbJTOL+0lL9PCjJyehBIi8eGZ3VJW/clN2hNHKkuJk0uwo+2Ilvdw/PCvjDuSQ5TQBEStFR7OVdx9dgBZiB5ZMXVzHgosrY8YYxoMBt+CzHUm8+rGfkCeV9LB4Zg8Tc0IX5t5+lTUVSby1Lo0km5cTZvRy5rxukuyx/aw+zR/r+Lc1GXi8gvMXdnLK7G7dPfYNe5NZ9dQc0IIyhWTGaTXMP786cv+SxAcsFQt4fOjxeAcuy3kCuFkvb9Vzx9OwLfRdqGYvZ9+8icwJI8/yYwFOh4GVDy/E3Re6q81kc3P6d7eSpa9hO4AyUcauwYT4bWUKzxGkbQZjyoJGjJZQzdPnMrDmhRIGHMe+2VbzwY6PCiKIDZIJc5qjEdsLPBdMbBgNwfexHo2fQuTBW7lTusiN2APjN2htfm8iXvcxtn0tDAcqU6hcnxeRnpDdR+n5uoulRPIObu4Iz4ibEuIqfGIhT6JxDRAS8WMwShZfvgeDNdK0Wfl5PvW7Y25dPKrR22lk9TOzQkLawG83KT2vGrNVd41Yj8p39c5RGf3UW8ibCC5DshoxfKarapSccPluDOFGLanw2Usl1GxPi7YP5qhFT5uZNX8u0T34bMLMZrKndIYn7wS+Rwunifn67HfUBBcgRSkf4uYqJB8E5xXObKdgbnNEGZ/byIbXp9FcPeLO6KMHEj55ZRodNZGbDqxp/Sy6fC8mS4iy4UHwDUp5WlxAVNvGmJmrWEwLkjtg+Fw/VZUsuKiStKJOIjaS9lhY+5cZNFYmjyl4/nCit8PMu7+fTXtV5JYaS+IAp31rRzgrGUDyTVFKhdA7/yMIB7WaiQVsB34WnGayaJx01W6Sc3uJIHqXjTXPl1C9JfOoZS+OHgOfvDSDtiq9w5wls75WRVpuhNywhlbejKf+gxcfqngo3AWXkuVkwWV7MNkjF1G3w8znf53BjrV5eFzKUUN4zedXbN5Yvoi26tSIzQaKwcf8r+9k2gnN4cqchsaqWGwkGONz5tUGPkFwUnh6Y1USn708nf52/fDm3BltzDp7fzQ59rChv9fAjo8KqSrPjZBGwE/skrOrmXOWjjlY0ovgm6KMt+Jpa7wOGfsf4Ad6eW0NdlY9NQdXhNIwCI0Z51Qz76zagzYDjAUt+xNY/fysmEf7zbt0FyWLG6NlNyFZLBaEenaiYVyGuOwm7AjORyc0zpbkIWNiF+31Cbj6TES+Y0FbdSqNVckYjBoGixej2XdIN9V6PYKmyhS2rSpg05tTQ5wowTDZXcy5cF8sYgO8KxbwZLxtj88MX0UKiXxAlOBPgJ52M+VvTo7Y+RXSGVXDnuokr6SFGYsPkJg6+j07seD1CPZtzKJqfR49LXa8Lt2TWgEwJQ5wyrU7yCrsjXWCURcGZoq5NMTbh/E7CnUDC4FXEVFvH0HzwZYPCqn8bAIuh95sH4Zi8JIzrY2i2W0kZ/nPmbXaPahGLf6jUB1GBvqM9HeZqd+TSs2mHDz90VibH0LRyJnexklX7o597IikA8HNoix4n/HIGN/DfjewGMEfIPqxclKDlppEKlYVRj3PMKwEBosXa5ILW5ILW8oA9gwntpQBTBYvZqsXoUrcTgPuARVXn4neVhvOTiv9PWYcPSa/d33Ec8gl9kwH875WTc7UztjbZyTNSP4dhZWijFEFxo//cdY7SMPJY8CpgA3/oQhWdETQys0ZbHt/Eo4Oa4QH/LBBSExWDxPmNFF6/v5othEvfvtRD5I3cfOAWEx8+2vCmzuYvsaC3EoWPgrxMgmYhcIlwPGELdR9XSb2b82ielM23QcOo+ovJAmZDopmt1Aws03fO+UPDVkLvA98iodNoznYV7fZgykcLyQI1pCChZ8hIp0YUoLPo1CzI42dayfQVZcyijPFR4+k/C7mnLufvMndGExR1wQnGhfTxtp4lZp4cFhPNJGrMJDIY/g9R/ptS+hut1C/K43OuiS6Wmz0dVjx6igk8UAx+LCl+rekp+T1UhhtNof2YQ8erhAnsW1MjcbA4b/lpIJU3PwLnfNqw+G/7cSI22nA0Wmmtd5Ox4EEelvtuPuN+FwqXpcBKQWq2YfB5MVg9mJPd5Ka7SB9Qh+p2U5MVg9muyf+k+UE32E+fxrJEDUWHJmLkzZyPZLfE2UP0RGDxIfgeUq54VAQG8bDeDUW9PAS8As4uAVonOFF8BJWbjpUxIYjeBcbgNzE5Wj8Bv0LOjREQMbVMES76iCeZvAHxWsIFPzX2gS348Fvz16OjYeDQ4sPBY74MWDycyZg5HQ0ShH43SsKPXipReA/ElOSj8J0BFcgifTm6sOHYC2wFh/bUGlFkoRgQVAdvQjWI/lMlOnv2BtvHHGCD0IuQ+E0FE5Hcj8y+A7MofwlTEfjVWJosv6H6QauoY8POQOXCPKEBI60U/gIwWq08HYONY4agseLwPU1dwCX4o9MTcLPFroC9o11wM/D40GOFhxzBIfALN1ANgYmAHY0fPjoxUQ3XdSLM/i/tw/9K3yFr/AVvsJX+Apf4SscSzh0Hp/NTMXHQ8Alh6qNIwLJaxj4sZjH3rEUjyD48uXLk81mcykwG8hVFCVRSukTQuwBPl26dOnGEfu0ke8juQ/JrUg+EQtpGqnMsQC5nhwEJyN4FMH9ojT+eJRBDBF82bJlpuTk5GsVRYl6cyCAlHKvx+N58s4779R1mwRm9jpgriijdrQdOhYQOM9xC0ZKxRxGtf9cAbjyyivVlJSU2xVFKWMEG7kQYqrRaLx7xYoVulfv4WMZgoe/rMQGCIztIb0tJSNBATjxxBMvF0IUxt2gEOmqqt4QJXsxRA/dleUsl+V0yHKkLGev3MjFQ3kbeENuwBnI073aXG5ijixnryxHyg045Qbe0GnjxkAdd0Xpw9ZA/uBfBD8OPBOdTwveQnBh1PwoUFasWJGmquqpepmdnZ23L1269N/R98yU/OpXv4r0S0rymY/OZQhD+UuBJ0UZAkkNkgfBTyTgXBSuQmEukCHLeSGivMZzQJsoQyC4BTg3UDYYd4WffhEGG3C3KEME/kL2w8ty7kJyXIzyMJ/tSCKuqhoJisFgWMwYXW2qqi6MSBQYhNC3Mcty7kLQIcq42986j+JfnEFyMfCJKGWlmM9W4APwX2Ujy9kqNwxtb7GB/7RnUcZTCOph+EaowH7StkD6YNoLsjwk/i8diHX29l0Ino01diHQxuKFMvh8vplKlGMTUlNTVzz66KMxGhWxZ4E+hg7MEqWslOUhecEL8f7hhvjp4PIePBvlJuagkY7gr0G/r0bhjICjwg+Fh9D4KKjuVOCXspw/APuAX4gy/xFTcgNvIFmDCGp/HKEIIXQv3hxkJzFYCoA16uI5jhClrBSlrIzI0Pgdkk1DeRq/A94OfCHD5eezdZCgAfwZwXWiDAG0AbcAyI1cjOAUVP7foRqLAugG06Wmpq5YtmxZjAvo/ejp6Tkim0YCi2WGWMDZEGBXUCjKuHaksqKMa4deksLNDLO1FcCT4S9sPKEIIUZ//lAAUsr+ZcuWxVqc9DB09ESwhAIQuNVpEJFXYA2WK+cJBGUoXBGUfA2QNyh5AFOA5eFSTEDKCV9kBxftKcBdgfLLgSmB/8cNihAiukQxAoQQowoFE2X8Aok1sLCB5B6gwp/JSiRzZTk3yk3MAZYA68D/YgZfTmAmX43CBcEzUZQxJ0jqEPh5891iAZeEEFlSiOQ3Q7/9bGifKOOpsPJ3B9LH1fyheL3eT6SUEWyls7Pz9sHZu3Tp0juklBFx0G63++OIGiU+uSNGRJVgGXB1YOZkIPgpDEkcryH5DRpIaKZwAAAA/0lEQVRbgNoh9iB5EI2lgRpuBFLR2BJLjg6Bxp3A/eBfDwISyC+D+nB7zPI6CBxLNbo7GAio9o888sjVQojTRtWglNtvu+22/4lI30AVgktE2fgHQh5NkOXMAlaKsuisTw8KQFdX12tSypq4G5Oy3ePx/Ek3088aloymE8ckBBcjWTP6YgEsW7bMlJKScp0QImZUq5Ryl8fjeTqq8WorxXjYjMIcMZ+4X+KxhIDxqgIDC8VcRnXxRcSC8Mgjj0yTUs4HcoFsIYRRSlmvKMoXDodj4z333DOiVBO4rOPeL6l5djGCx4AHRBm/G20dh9oB8Uv8EVJfJvwdlR+N1QHxv3/qgodVGvgmAAAAAElFTkSuQmCC"

/***/ }),
/* 1732 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1733 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_reducer_points__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_reducer_deals__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeMobile_TradeMobileLayout__ = __webpack_require__(1735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_connected__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TradeHeader__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Chart__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TradeMobile_TradeControlTabs__ = __webpack_require__(2000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__News__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TradeMobile_AdsBlock__ = __webpack_require__(2017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TradeMobile_Toolbar_ToolsPopup__ = __webpack_require__(2018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TradeMobile_Toolbar_Assets__ = __webpack_require__(2022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SocialTrading_Mobile__ = __webpack_require__(2023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PopupDeposit_PopupDeposit__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__InsufficientPopup_InsufficientPopup__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TradeModals_VerificationRequired_VerificationRequired__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TradeModals_TradeIsClosing__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__TradeModals_IncreaseBidLimit__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TradeModals_DemoTournamentPopup__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__StockClose__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__BonusTimer__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__ABTest__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__withErrorCatch__ = __webpack_require__(149);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}// import SwipeToZoom from "../TradeMobile/SwipeToZoom";
// Попробуем подключать каждый подкомпонент
// по-отдельности. В теории это должно дать
// некий прирост производительности. К тому
// же "вёрсточка" выглядит чище!
// Красота в том, что оборачиваемый
// компонент всегда в первой строке:
var ChartArea=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__Chart__["a" /* default */])(function(state,ownProps){var stock=Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs);var time=Object(__WEBPACK_IMPORTED_MODULE_4__redux_reducer_points__["b" /* getServerTime */])(stock,state.points)||0;var deals=_typeof(ownProps.deals)==="object"&&ownProps.deals.type==="SPECIAL TOUR DEAL"?ownProps.deals.deals:Object(__WEBPACK_IMPORTED_MODULE_5__redux_reducer_deals__["b" /* getActiveDeals */])(stock,time,ownProps.deals);return{key:stock,tradeMode:state.settings.mode,points:ownProps.points||state.points[stock]||[],settings:Object.assign({},state.settings,ownProps.settings),stats:state.stats[stock],profile:state.profile,deals:deals};});var News=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_11__News__["a" /* default */])(function(state){return{news:state.news,soundsEnabled:state.audio.enabled};},function(dispatch){return{onDismiss:function onDismiss(id){dispatch({type:"DISMISS_NEWS",payload:id});}};});var Header=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_8__TradeHeader__["a" /* default */])(function(state){return{profile:state.profile,accounts:state.accounts};});var InsufficientPopup=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_17__InsufficientPopup_InsufficientPopup__["a" /* default */])(function(state){var activeAccount=state.accounts.find(function(account){return state.profile?account.id===state.profile.active_account_id:account.isActive;});return{profileId:state.profile&&state.profile.id,initialDeposit:state.remoteTradeSettings.initial,minFillup:state.remoteTradeSettings.minFillup,isActiveAccountReal:activeAccount?activeAccount.type==="real":false};});var PopupDeposit=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__PopupDeposit_PopupDeposit__["a" /* default */])(function(state){var activeAccount=state.accounts.find(function(account){return state.profile?account.id===state.profile.active_account_id:account.isActive;});return{profileId:state.profile&&state.profile.id,accounts:state.accounts,initialDeposit:state.remoteTradeSettings.initial,minFillup:state.remoteTradeSettings.minFillup,isActiveAccountReal:activeAccount?activeAccount.type==="real":false};});var VerificationRequiredPopup=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__TradeModals_VerificationRequired_VerificationRequired__["a" /* default */])(function(state){return{validation:state.profile?state.profile.validation:{phone:0,email:0,profile:0,passport:0}};});var IncreaseBidLimitPopup=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_20__TradeModals_IncreaseBidLimit__["a" /* default */])(function(state){var profile=state.profile;var bid_limit=5000;if(profile){if(profile.bid_limit){bid_limit=_typeof(profile.bid_limit)==="object"?profile.bid_limit[profile.currency]:profile.bid_limit;}}return{bid_limit:bid_limit};});var TradeIsClosingPopup=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_19__TradeModals_TradeIsClosing__["a" /* default */])(function(state){//
});var Controls=Object(__WEBPACK_IMPORTED_MODULE_7__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10__TradeMobile_TradeControlTabs__["a" /* default */])(function(state,ownProps){var stock=Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs);var points=state.points[stock]||[];var bids=state.remoteTradeSettings.bids;var currency=state.remoteTradeSettings.currency;var maxBidVolume=void 0;if(state.profile){if(_typeof(state.profile.bid_limit)==="object"){maxBidVolume=state.profile.bid_limit[currency];}else{maxBidVolume=state.profile.bid_limit;}}if(!maxBidVolume&&state.apiConfigs){maxBidVolume=state.apiConfigs.maxBidVolume[currency];}if(bids&&bids.length&&bids[bids.length-1]>maxBidVolume){bids=bids.filter(function(bid){return bid<=maxBidVolume;});}var openDeals=function openDeals(deal){return deal.time!==undefined&&deal.profit===undefined;};var stocksWithOperations=ownProps.deals.filter(openDeals).reduce(function(res,deal){if(deal){res.push(deal.stock);}return res;},[]);var pointsByStock=stocksWithOperations.reduce(function(res,stock){var points=state.points[stock];if(points&&!res[stock]){res[stock]=points.length>0?points[points.length-1]:null;}return res;},{});return Object.assign({tradeMode:state.settings.mode,point:points.length>0?points[points.length-1]:null,pointsByStock:pointsByStock,percentBids:state.remoteTradeSettings.percentBids,percentBidThreshold:state.remoteTradeSettings.percentBidThreshold,suggestedBids:bids,currentBid:state.settings.currentBid,maxBidVolume:maxBidVolume||bids&&bids.length&&bids[bids.length-1],now:state.time,isIOS:state.serverData?state.serverData.isIOS:false},Object(__WEBPACK_IMPORTED_MODULE_23__common_Gettext__["f" /* mapStateToGettext */])(state));});var MobileTradeScreen=function MobileTradeScreen(props){var chartRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var tradeControlsRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var isStockClose=!props.stock.enabled||props.timeUntilNextLockToggle===0;var closeDealClickMobileHandler=function closeDealClickMobileHandler(){if(tradeControlsRef.current&&typeof tradeControlsRef.current.setActiveTab==="function"){tradeControlsRef.current.setActiveTab("deals");}};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TradeMobile_TradeMobileLayout__["a" /* default */],{isIOS:props.isIOS,appVersion:props.appVersion,showControls:!isStockClose,dealsToCompensate:props.dealsToCompensate,onCompensation:props.onCompensation,compensationUpdated:props.compensationUpdated,compensationCreated:props.compensationCreated,onCompensationCreated:props.onCompensationCreated,activeAccount:props.activeAccount,tabs:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{onProfileUpdate:props.refreshProfile,isRefillFetching:props.isRefillFetching,accountsReady:props.accountsReady,dealsReady:props.dealsReady,isFetchingOpenOperation:props.isFetchingOpenOperation,onRefillDemoClick:props.refillDemoAccount,deals:props.deals}),bonus:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__ABTest__["a" /* default */],{campaign:"first_deposit_bonus"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__BonusTimer__["a" /* default */],null)),controls:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Controls,{controlsRef:tradeControlsRef,onSubmit:props.tryMakingADeal,showIncreaseBidLimitMessage:props.showIncreaseBidLimitMessage,showTournamentRefill:props.showTournamentRefill,disabled:isStockClose||props.tradeControlsDisabled,accountType:props.accountType,activeAccount:props.activeAccount,possibleIntervals:props.possibleTradeIntervals,currentInterval:props.currentTradeInterval,stock:props.stock,timeUntilNextLockToggle:props.timeUntilNextLockToggle,deals:props.deals,isDealAmountValid:props.isDealAmountValid,validateDealAmount:props.validateDealAmount,refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching,dealsToCompensate:props.dealsToCompensate,onCompensation:props.onCompensation,compensationUpdated:props.compensationUpdated,compensationCreated:props.compensationCreated,onCompensationCreated:props.onCompensationCreated}),ads:props.adsMessage!==""&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TradeMobile_AdsBlock__["a" /* default */],null)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Tour__["b" /* default */],{step:["stareAtTheChart","showChart","chartWithProfit","chartWithDeals"],originalRef:chartRef,disabledTooltip:true,withoutStyles:true,showTimer:true},function(_ref){var next=_ref.next,isOriginal=_ref.isOriginal,isTourActive=_ref.isTourActive,isTourMode=_ref.isTourMode,deal=_ref.deal,step=_ref.step,tour=_ref.tour,startPointsLength=_ref.startPointsLength;return isOriginal?!isTourActive&&(isStockClose&&!isTourMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__StockClose__["h" /* default */],{stocks:props.stocks,onStockClick:props.onRecommendedStockClick,activeAccount:props.activeAccount,stock:props.stock}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartArea,{animated:props.animated,forwardedRef:chartRef,points:isTourMode?tour.points:void 0,visuals:"mobile",intent:null,isIOS:props.isIOS,stock:props.stock,timeUntilNextLockToggle:props.timeUntilNextLockToggle,deals:props.deals,refundClickHandler:closeDealClickMobileHandler,refundFetching:props.refundFetching,time:props.time})):step==="showChart"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartArea,{animated:props.animated,visuals:"mobile",points:tour.points,deals:{type:"SPECIAL TOUR DEAL",deals:tour.deals},intent:null,isIOS:props.isIOS,stock:props.stock,timeUntilNextLockToggle:props.timeUntilNextLockToggle,settings:{sentiments:false},refundClickHandler:closeDealClickMobileHandler,refundFetching:props.refundFetching,time:props.time}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ChartArea,{interactive:false,animated:props.animated,points:tour.points,visuals:"mobile",deals:{type:"SPECIAL TOUR DEAL",deals:tour.deals.slice(-1).filter(function(d){return startPointsLength-tour.points.length+d.bTime>=0;})},intent:null,isIOS:props.isIOS,stock:props.stock,timeUntilNextLockToggle:Infinity,onEditIndicator:function onEditIndicator(){return void 0;},settings:{indicators:[],timeSpan:60*1000/0.8,sentiments:false},refundClickHandler:closeDealClickMobileHandler,refundFetching:props.refundFetching,time:props.time}),startPointsLength-tour.points.length+tour.deals[0].bTime<0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__News__["a" /* default */],{news:[{payload:{op:"operationClosed",id:tour.deals[0].id,stock:tour.deals[0].stock,user_id:1,profit:tour.deals[0].amount+tour.deals[0].amount*(tour.deals[0].percent/100),accountId:1,real:0,balance:1,turnover:0,targetTurnover:false,isBidUp:true,close_time:tour.deals[0].timestamp},isDismissed:false}],onDismiss:function onDismiss(){return null;},soundsEnabled:false,mobile:true,tour:true}));}));};function OccasionalPopup(props){if(props.showInsufficientFundsMessage){// A/B test
return props.userId%2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopupDeposit,{onRefillDemoClick:props.refillDemoAccount,onDismiss:props.dismissInsufficientFundsMessage}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InsufficientPopup,{onRefillDemoClick:props.refillDemoAccount,onDismiss:props.dismissInsufficientFundsMessage});}if(props.showVerificationRequired){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VerificationRequiredPopup,{onDismiss:props.dismissVerificationRequiredMessage});}if(props.showIncreaseBidLimit!==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IncreaseBidLimitPopup,{onDismiss:props.dismissIncreaseBidLimitMessage});}if(props.showTradeIsClosing){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradeIsClosingPopup,{onDismiss:props.dismissTradeIsClosing,time:props.timeUntilNextLockToggle});}if(props.showDemoTournament&&props.demoTournament){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__TradeModals_DemoTournamentPopup__["a" /* default */],{tournament:props.demoTournament,onDismiss:props.dismissDemoTournament});}return null;}function _MobileLayout(_ref2){var history=_ref2.history,match=_ref2.match,location=_ref2.location,props=_objectWithoutProperties(_ref2,["history","match","location"]);// Я вынес <MobileTradeScreen/> чтобы лучше
// считывалось намерение отображать разницу
// между состояниями подключенния. Если это
// не удобно, то можно внести код обратно.
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MobileTradeScreen,props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(News,{mobile:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/trade/tools",component:__WEBPACK_IMPORTED_MODULE_13__TradeMobile_Toolbar_ToolsPopup__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/trade/assets",component:__WEBPACK_IMPORTED_MODULE_14__TradeMobile_Toolbar_Assets__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/trade/social",component:__WEBPACK_IMPORTED_MODULE_15__SocialTrading_Mobile__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/sightseeing/tools",component:__WEBPACK_IMPORTED_MODULE_13__TradeMobile_Toolbar_ToolsPopup__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/sightseeing/assets",component:__WEBPACK_IMPORTED_MODULE_14__TradeMobile_Toolbar_Assets__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OccasionalPopup,Object.assign({},props,{history:history,match:match,location:location})));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_27__withErrorCatch__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])()(_MobileLayout))));

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Dimensions__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Protection__ = __webpack_require__(178);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: ",";\n  ",";\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n  background-color: ",";\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      filter: blur(2px);\n    "],["\n      filter: blur(2px);\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n"],["\n  display: flex;\n  overflow: hidden;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  height: 48px;\n"],["\n  height: 48px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  flex: 1;\n  border-bottom: 1px solid ",";\n"],["\n  position: relative;\n  flex: 1;\n  border-bottom: 1px solid ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  height: 45px;\n"],["\n  height: 45px;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  width: 123px;\n\n  @media (min-width: 568px) {\n    width: 143px;\n  }\n"],["\n  width: 123px;\n\n  @media (min-width: 568px) {\n    width: 143px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex: 1;\n"],["\n  flex: 1;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  flex: 1;\n  flex-direction: column;\n"],["\n  flex: 1;\n  flex-direction: column;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.main;},function(_ref){var tour=_ref.tour;return tour!=null&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var View=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Tabs=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(View)(_templateObject4);var Chart=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(View)(_templateObject5,function(props){return props.theme.borderMainColor;});var Ads=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(View)(_templateObject6);var LandscapeControls=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(View)(_templateObject7);var PortraitContainer=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(View)(_templateObject8);var ContainerInner=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(View)(_templateObject9);function Landscape(_ref2){var tabs=_ref2.tabs,controls=_ref2.controls,ads=_ref2.ads,bonus=_ref2.bonus,children=_ref2.children,dealsToCompensate=_ref2.dealsToCompensate,onCompensation=_ref2.onCompensation,compensationUpdated=_ref2.compensationUpdated,compensationCreated=_ref2.compensationCreated,onCompensationCreated=_ref2.onCompensationCreated,props=_objectWithoutProperties(_ref2,["tabs","controls","ads","bonus","children","dealsToCompensate","onCompensation","compensationUpdated","compensationCreated","onCompensationCreated"]);var tour=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__Tour__["a" /* TourContext */]);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),showChart=_useState2[0],setShowChart=_useState2[1];var handleVisibilityChange=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(document.hidden){setShowChart(false);}else{setShowChart(true);}},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(document.hidden!==undefined){document.addEventListener("visibilitychange",handleVisibilityChange,false);return function(){document.removeEventListener("visibilitychange",handleVisibilityChange,false);};}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,Object.assign({},props,{tour:tour}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tabs,null,tabs),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PortraitContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ContainerInner,null,bonus,showChart&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Chart,null,children),ads&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ads,null,ads)),props.showControls&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LandscapeControls,null,controls)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Protection__["a" /* default */],{dealsToCompensate:dealsToCompensate,onCompensation:onCompensation,compensationUpdated:compensationUpdated,compensationCreated:compensationCreated,onCompensationCreated:onCompensationCreated,isDesktop:false,activeAccount:props.activeAccount}));}function Portrait(_ref3){var tabs=_ref3.tabs,children=_ref3.children,controls=_ref3.controls,ads=_ref3.ads,bonus=_ref3.bonus,dealsToCompensate=_ref3.dealsToCompensate,onCompensation=_ref3.onCompensation,compensationUpdated=_ref3.compensationUpdated,compensationCreated=_ref3.compensationCreated,onCompensationCreated=_ref3.onCompensationCreated,props=_objectWithoutProperties(_ref3,["tabs","children","controls","ads","bonus","dealsToCompensate","onCompensation","compensationUpdated","compensationCreated","onCompensationCreated"]);var tour=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__Tour__["a" /* TourContext */]);var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState4=_slicedToArray(_useState3,2),showChart=_useState4[0],setShowChart=_useState4[1];var handleVisibilityChange=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(document.hidden){setShowChart(false);}else{setShowChart(true);}},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(document.hidden!==undefined){document.addEventListener("visibilitychange",handleVisibilityChange,false);return function(){document.removeEventListener("visibilitychange",handleVisibilityChange,false);};}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,Object.assign({},props,{tour:tour}),props.isIOS&&props.appVersion>=2000000?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tabs,null,tabs),bonus,showChart&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Chart,null,children),ads&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Ads,null,ads),props.showControls&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,controls),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Protection__["a" /* default */],{dealsToCompensate:dealsToCompensate,onCompensation:onCompensation,compensationUpdated:compensationUpdated,compensationCreated:compensationCreated,onCompensationCreated:onCompensationCreated,isDesktop:false,activeAccount:props.activeAccount}));}var MobileLayout=function(_React$Component){_inherits(MobileLayout,_React$Component);function MobileLayout(){var _ref4;var _temp,_this,_ret;_classCallCheck(this,MobileLayout);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref4=MobileLayout.__proto__||Object.getPrototypeOf(MobileLayout)).call.apply(_ref4,[this].concat(args))),_this),_this.state={platform:null,browser:{}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MobileLayout,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["d" /* get */])("/ajax/userInfo").then(function(_ref5){var platform=_ref5.platform,browser=_ref5.browser;_this2.setState({platform:platform,browser:browser});});// TODO: .catch() please
}},{key:"render",value:function render(){var _this3=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Dimensions__["a" /* default */],null,function(inner){return inner.width>479?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Landscape,Object.assign({},_this3.state,_this3.props)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Portrait,Object.assign({},_this3.state,_this3.props));});}}]);return MobileLayout;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (MobileLayout);

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Dimensions=function(_Component){_inherits(Dimensions,_Component);function Dimensions(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Dimensions);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Dimensions.__proto__||Object.getPrototypeOf(Dimensions)).call.apply(_ref,[this].concat(args))),_this),_this.state={height:window.innerHeight,width:window.innerWidth},_this.handleSizeChange=function(){_this.setState({height:window.innerHeight,width:window.innerWidth});},_this.throttleSizeChange=__WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function(){return _this.handleSizeChange();},300),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Dimensions,[{key:"componentDidMount",value:function componentDidMount(){window.addEventListener("resize",this.throttleSizeChange,false);window.addEventListener("orientationchange",this.throttleSizeChange,false);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("orientationchange",this.throttleSizeChange);window.removeEventListener("resize",this.throttleSizeChange);}},{key:"render",value:function render(){if(typeof this.props.children!=="function"){return null;}return this.props.children(Object.assign({},this.state));}}]);return Dimensions;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Dimensions);

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__withLocaleChange__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Tabs__ = __webpack_require__(1738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Logo__ = __webpack_require__(1754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Button__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Navigation_Hamburger__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Navigation_Navigation__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__AccountType_AccountInHeader__ = __webpack_require__(1756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__hooks_useBonusTimer__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Toolbar_SwitchStock__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Tournaments_Account_Tournament_RatingExpander__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Tournaments_helpers_refill__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Tournaments_Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Timers__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Icons_BonusTimer__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Icons_Percent__ = __webpack_require__(1870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ABTest__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__material_ui_icons_MenuOutlined__ = __webpack_require__(1871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__material_ui_icons_MenuOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__material_ui_icons_MenuOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Bell_Labels__ = __webpack_require__(274);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 74px;\n  padding-left: 20px;\n  text-align: justify;\n  color: ",";\n  background-color: ",";\n  background-image: ",";\n  border-bottom: 1px solid ",";\n  ",";\n  flex: 1;\n\n  @media (max-width: 959px) {\n    height: 48px;\n    padding-left: 0;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  height: 74px;\n  padding-left: 20px;\n  text-align: justify;\n  color: ",";\n  background-color: ",";\n  background-image: ",";\n  border-bottom: 1px solid ",";\n  ",";\n  flex: 1;\n\n  @media (max-width: 959px) {\n    height: 48px;\n    padding-left: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      border-bottom: none;\n    "],["\n      border-bottom: none;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  line-height: normal;\n\n  "," ",";\n\n  @media (max-width: 959px) {\n    min-width: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: hidden;\n  }\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  line-height: normal;\n\n  "," ",";\n\n  @media (max-width: 959px) {\n    min-width: 0;\n    display: flex;\n    flex-flow: row nowrap;\n    overflow: hidden;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n      flex-grow: 1;\n      height: 73px;\n      margin-right: auto;\n\n      @media (max-width: 959px) {\n        height: 47px;\n      }\n    "],["\n      flex-grow: 1;\n      height: 73px;\n      margin-right: auto;\n\n      @media (max-width: 959px) {\n        height: 47px;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      height: 73px;\n      padding-right: 15px;\n\n      @media (max-width: 959px) {\n        height: 47px;\n      }\n    "],["\n      height: 73px;\n      padding-right: 15px;\n\n      @media (max-width: 959px) {\n        height: 47px;\n      }\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  display: table;\n  height: 100%;\n  white-space: nowrap;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    align-content: flex-end;\n    justify-content: flex-end;\n    flex: 1;\n    min-width: 0;\n  }\n"],["\n  display: table;\n  height: 100%;\n  white-space: nowrap;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    align-content: flex-end;\n    justify-content: flex-end;\n    flex: 1;\n    min-width: 0;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    align-content: flex-end;\n    justify-content: flex-end;\n    min-width: 0;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    align-content: flex-end;\n    justify-content: flex-end;\n    min-width: 0;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  color: #1d2027;\n\n  @media (max-width: 959px) {\n    top: 50%;\n    transform: translateY(-50%);\n    right: -18px;\n    width: 37px;\n    height: 37px;\n  }\n\n  @media (min-width: 960px) {\n    top: -6px;\n    right: -9px;\n    width: 25px;\n    height: 25px;\n  }\n"],["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  color: #1d2027;\n\n  @media (max-width: 959px) {\n    top: 50%;\n    transform: translateY(-50%);\n    right: -18px;\n    width: 37px;\n    height: 37px;\n  }\n\n  @media (min-width: 960px) {\n    top: -6px;\n    right: -9px;\n    width: 25px;\n    height: 25px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  ",";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  user-select: none;\n  pointer-events: none;\n"],["\n  position: absolute;\n  top: 0;\n  ",";\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  user-select: none;\n  pointer-events: none;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  flex-direction: column;\n  align-content: flex-start;\n  justify-content: flex-start;\n  color: #ffcc00;\n  z-index: 1;\n"],["\n  flex-direction: column;\n  align-content: flex-start;\n  justify-content: flex-start;\n  color: #ffcc00;\n  z-index: 1;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-right: auto;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  margin-right: auto;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  z-index: 2;\n"],["\n  z-index: 2;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  z-index: 3;\n"],["\n  z-index: 3;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  text-decoration: none;\n"],["\n  text-decoration: none;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.tradeHeaderAccent;},function(_ref2){var theme=_ref2.theme;return theme.mainDark;},function(_ref3){var theme=_ref3.theme;return"linear-gradient(to bottom, "+theme.tradeHeaderGradientTop+" 0, "+theme.tradeHeaderGradientBottom+" 100%)";},function(_ref4){var theme=_ref4.theme;return theme.mainSeparator;},function(_ref5){var theme=_ref5.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject2);});var Section=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.center&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject4);},function(props){return props.separate&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject5);});var Table=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject6);var TableCell=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject7);var BadgeContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject8);var Layers=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].i(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("left",0));var BadgeBgContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Layers)(_templateObject10);var StockLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */])(_templateObject11);var BonusTimerBadge=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_27__Icons_BonusTimer__["a" /* default */])(_templateObject12);var TimerContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Layers)(_templateObject13);var PercentContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Layers)(_templateObject14);var DepositBonusButton=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_14__Button__["a" /* default */])(_templateObject15);var DepositBonusBadge=function DepositBonusBadge(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BadgeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BadgeBgContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BonusTimerBadge,{width:matches?37:25})),props.timer!=null&&matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimerContainer,null,props.timer):null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PercentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_28__Icons_Percent__["a" /* default */],null)));});};function DepositButton(_ref6){var promocode=_ref6.promocode,children=_ref6.children;if(promocode!=null){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositBonusButton,{as:__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */],type:"deposit",to:"/fillup?promocode="+promocode},children,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositBonusBadge,null);}}));}else{return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositBonusButton,{as:__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */],type:"deposit",to:"/fillup"},children);}}var DepositBonusBtn=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_26__Timers__["b" /* mapStateToTime */])(function(props){var suggestedPromoCode=Object(__WEBPACK_IMPORTED_MODULE_32__Bell_Labels__["c" /* useSuggestedPromoCode */])();return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_30__ABTest__["a" /* default */],{campaign:"first_deposit_bonus"},function(showTest){if(showTest===false){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositButton,{promocode:suggestedPromoCode},props.children);}var bonus=Object(__WEBPACK_IMPORTED_MODULE_19__hooks_useBonusTimer__["a" /* useBonusTimerApi */])({time:props.time});if(bonus==null||bonus.duration<0||bonus.status!=="available"){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositButton,{promocode:suggestedPromoCode},props.children);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositButton,{promocode:bonus.promo},props.children);});});var Header=function(_React$PureComponent){_inherits(Header,_React$PureComponent);function Header(){var _ref7;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref7=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref7,[this].concat(args))),_this),_this.state={changeLocaleFetching:false,isNavActive:false},_this.toggle=function(){_this.setState({isNavActive:!_this.state.isNavActive});},_this.hide=function(){_this.setState({isNavActive:false});},_this.onDepositClick=function(){_this.props.history.push("/fillup");},_temp),_possibleConstructorReturn(_this,_ret);}// Use this method instead of `toggle`
//  as ClickOutside click handler due to slow
// unmount flow caused by Motion
_createClass(Header,[{key:"render",value:function render(){var _this2=this;var _props=this.props,profile=_props.profile,accounts=_props.accounts,isVIP=_props.isVIP,showDeposit=_props.showDeposit,isAndroidApp=_props.isAndroidApp,isIOS=_props.isIOS,appVersion=_props.appVersion;var activeAccount=accounts.find(function(account){return account.id===profile.active_account_id;});if(!activeAccount){return null;}if(isAndroidApp||isIOS&&appVersion>=2000000)return null;var openDealsSum=this.props.deals.reduce(function(res,item){return item.close_timestamp==null?res+item.amount:res;},0);var showRefillLoader=this.props.isRefillFetching||this.props.isFetchingOpenOperation||!this.props.accountsReady||!this.props.dealsReady;var disabledRefillDemo=showRefillLoader||parseFloat(activeAccount.balance)+openDealsSum>=this.props.minDemoRefillBalance;var refillDemoAvailable=this.props.tradeMode==="binary"&&activeAccount.type==="demo"&&!disabledRefillDemo;var refillTournamentAvailable=this.props.tradeMode==="tournament"&&!Object(__WEBPACK_IMPORTED_MODULE_23__Tournaments_helpers_refill__["a" /* disableRefill */])({api:this.props.api});return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Section,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Logo__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{display:"flex",alignItems:"center",paddingRight:5}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Navigation_Hamburger__["a" /* default */],{active:_this2.state.isNavActive,onClick:_this2.toggle,isIOS:_this2.props.isIOS,icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_31__material_ui_icons_MenuOutlined___default.a,{fontSize:"inherit",color:"inherit"}),trade:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Section,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StockLink,{replace:true,to:_this2.context!=null?"/sightseeing/assets":"/trade/assets"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Toolbar_SwitchStock__["a" /* StockInTools */],{value:_this2.props.activeStock}))));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Section,{center:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Tabs__["a" /* default */],{deals:_this2.props.deals}));}}),"\n",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Section,{separate:true},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Table,null,profile?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref8){var showModal=_ref8.showModal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__Tournaments_Account_Tournament_RatingExpander__["a" /* Provider */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__AccountType_AccountInHeader__["a" /* default */],{profile:profile,onDepositClick:_this2.onDepositClick,accounts:accounts,activeAccount:activeAccount,onRefillDemoClick:_this2.props.onRefillDemoClick,onProfileUpdate:_this2.props.onProfileUpdate,refillDemoAvailable:refillDemoAvailable,refillTournamentAvailable:refillTournamentAvailable,onRefillTournamentClick:function onRefillTournamentClick(){return showModal(__WEBPACK_IMPORTED_MODULE_25__Tournaments_Popups__["d" /* RefillPopup */]);},showRefillLoader:showRefillLoader,compensationUpdated:_this2.props.compensationUpdated,compensationCreated:_this2.props.compensationCreated})),showDeposit===true&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DepositBonusBtn,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(max-width: 479px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Icons_Tournaments__["m" /* Wallet */],{width:"17px"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Deposit");})));}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */],{to:"/login"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Button__["a" /* default */],{type:"deposit"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"login")))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Navigation_Hamburger__["a" /* default */],{active:_this2.state.isNavActive,onClick:_this2.toggle,isIOS:_this2.props.isIOS,trade:true}));}}))),"\n",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Navigation_Navigation__["a" /* default */],{open:this.state.isNavActive,profile:profile,onClose:this.hide,trade:true,changeLocaleFetching:this.state.changeLocaleFetching,onLocaleChange:this.props.onLocaleChange,isVIP:isVIP}));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);Header.contextType=__WEBPACK_IMPORTED_MODULE_29__Tour__["a" /* TourContext */];function mapStateToProps(state){return{activeStock:Object(__WEBPACK_IMPORTED_MODULE_10__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs),tradeMode:state.settings.mode,currentBid:state.settings.currentBid,profile:state.profile,minFillup:state.remoteTradeSettings.minFillup,initialDeposit:state.remoteTradeSettings.initial,minDemoRefillBalance:state.remoteTradeSettings.minDemoRefillBalance,accounts:state.accounts,isAndroidApp:state.serverData?state.serverData.isAndroidApp:false,isIOS:state.serverData?state.serverData.isIOS:false,isVIP:state.serverData?state.serverData.isVIP:false,appVersion:state.serverData?state.serverData.app_version:false};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps,__WEBPACK_IMPORTED_MODULE_9__common_fetch__["e" /* mapDispatchToFetch */])(Object(__WEBPACK_IMPORTED_MODULE_7__common_withDeposit__["b" /* withDeposit */])(Object(__WEBPACK_IMPORTED_MODULE_11__withLocaleChange__["a" /* default */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Header,Object.assign({},props,{api:api}));});})))));

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1739);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Tabs__["a" /* default */]);

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducer_deals__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AddTab__ = __webpack_require__(1740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Tab__ = __webpack_require__(1752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__redux_reducer_tabs__ = __webpack_require__(106);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  white-space: nowrap;\n"],["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  white-space: nowrap;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"],["\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TabsContainer=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject));var TabContainer=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2));function Tabs(props){// const shouldShowArrows = props.tabs.tabs.length > 2;
var shouldShowCloseButton=props.tabs.tabs.length>1;var activeAccount=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return props.accounts.find(function(account){return account.id===props.profile.active_account_id;});},[props.accounts,props.profile.active_account_id]);var Tabs=__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function(){return props.tabs.tabs.map(function(tab,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Tab__["a" /* default */],{key:index,id:index,tradeMode:props.tradeMode,stock:props.stocks[tab],deals:Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_deals__["b" /* getActiveDeals */])(tab,props.time,props.deals),points:props.points[tab],time:props.time,isActive:index===props.tabs.activeTab,onClick:function onClick(){props.dispatch({type:"SET_ACTIVE_TAB",payload:index});},onRemoveClick:function onRemoveClick(event){event.stopPropagation();props.dispatch({type:"REMOVE_TAB",payload:index});props.dispatch({type:"CLEAR_GRAPHICAL_TOOLS",payload:{activeStock:props.activeStock}});},shouldShowCloseButton:shouldShowCloseButton,activeAccount:activeAccount});});},[props.tabs,props.time,props.deals]);var nextTabHandler=__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function(tab){props.dispatch({type:"SET_ACTIVE_TAB",payload:tab});},[]);var newTabHandler=__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function(stock){props.dispatch({type:"PUSH_TAB",payload:stock});},[]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabContainer,null,Tabs,props.tabs.tabs.length<__WEBPACK_IMPORTED_MODULE_6__redux_reducer_tabs__["a" /* TABS_LIMIT */]&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__AddTab__["a" /* default */],{tabs:props.tabs,onNextActiveTab:nextTabHandler,onNewTab:newTabHandler})));}function mapStateToProps(state){return{tradeMode:state.settings.mode,activeStock:Object(__WEBPACK_IMPORTED_MODULE_6__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs),tabs:state.tabs,deals:state.deals,stocks:state.stocks,points:state.points,time:state.time,profile:state.profile,accounts:state.accounts};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Tabs));

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StockMenu__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Animations_Fade__ = __webpack_require__(311);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 10px;\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 10px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  background-color: transparent;\n  border: 1px solid ",";\n  cursor: pointer;\n\n  :hover {\n    background-color: ",";\n  }\n\n  :hover > div {\n    background-color: ",";\n  }\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  width: 32px;\n  height: 32px;\n  min-width: 32px;\n  min-height: 32px;\n  background-color: transparent;\n  border: 1px solid ",";\n  cursor: pointer;\n\n  :hover {\n    background-color: ",";\n  }\n\n  :hover > div {\n    background-color: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  background-color: ",";\n"],["\n  position: absolute;\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  top: 14px;\n  left: 5px;\n  width: 20px;\n  height: 2px;\n"],["\n  top: 14px;\n  left: 5px;\n  width: 20px;\n  height: 2px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  top: 5px;\n  left: 14px;\n  width: 2px;\n  height: 20px;\n"],["\n  top: 5px;\n  left: 14px;\n  width: 2px;\n  height: 20px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 32px;\n  left: 0px;\n  background-color: ",";\n  z-index: 10;\n"],["\n  position: absolute;\n  top: 32px;\n  left: 0px;\n  background-color: ",";\n  z-index: 10;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 450px;\n  padding: 12px;\n  background-color: ",";\n  z-index: 1;\n  overflow: hidden;\n"],["\n  display: flex;\n  width: 100%;\n  height: 450px;\n  padding: 12px;\n  background-color: ",";\n  z-index: 1;\n  overflow: hidden;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var AddTabView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject2,function(props){return props.theme.mainSeparator;},function(props){return props.theme.mainLight;},function(_ref){var theme=_ref.theme;return theme.foreground;});var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.textMuted;});var HLine=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Line)(_templateObject4);var VLine=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Line)(_templateObject5);var Menu=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.mainDark;});var InlineBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.theme.popupBackground;});var AddTab=function(_Component){_inherits(AddTab,_Component);function AddTab(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,AddTab);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=AddTab.__proto__||Object.getPrototypeOf(AddTab)).call.apply(_ref3,[this].concat(args))),_this),_this.state={shouldShowMenu:false},_this.toggleMenu=function(){_this.setState({shouldShowMenu:!_this.state.shouldShowMenu});},_this.handleOutsideClick=function(e){if(e&&typeof e.preventDefault==="function"){e.preventDefault();e.stopPropagation();}_this.setState({shouldShowMenu:false});},_this.handleStockSelection=function(stock){_this.toggleMenu();var tabIndex=_this.props.tabs.tabs.indexOf(stock);if(tabIndex===-1){_this.props.onNewTab(stock);}else{_this.props.onNextActiveTab(tabIndex);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddTab,[{key:"render",value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddTabView,{onClick:this.toggleMenu},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HLine,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VLine,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Animations_Fade__["a" /* default */],{"in":this.state.shouldShowMenu},function(_ref4){var style=_ref4.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Menu,{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InlineBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StockMenu__["a" /* default */],{onStockSelect:_this2.handleStockSelection,onClose:_this2.handleOutsideClick})));}));}}]);return AddTab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (AddTab);

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StockCategory__ = __webpack_require__(1742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StocksTable__ = __webpack_require__(1743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Toolbar_ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons__ = __webpack_require__(1751);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding-top: 17px;\n\n  @media (max-width: 959px) {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: stretch;\n    align-content: stretch;\n    border-top: none;\n    padding-top: 0;\n  }\n"],["\n  display: flex;\n  width: 100%;\n  height: 100%;\n  padding-top: 17px;\n\n  @media (max-width: 959px) {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    align-items: stretch;\n    align-content: stretch;\n    border-top: none;\n    padding-top: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  vertical-align: top;\n  height: 100%;\n\n  @media (max-width: 959px) {\n    display: block;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  vertical-align: top;\n  height: 100%;\n\n  @media (max-width: 959px) {\n    display: block;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 164px;\n  min-width: 164px;\n  max-width: 164px;\n  display: flex;\n  justify-content: start;\n\n  @media (max-width: 959px) {\n    height: 100%;\n    overflow: auto;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex: 0 0 164px;\n  }\n\n  @media (max-width: 479px) {\n    width: 138px;\n    min-width: 138px;\n    flex: 0 0 138px;\n  }\n"],["\n  width: 164px;\n  min-width: 164px;\n  max-width: 164px;\n  display: flex;\n  justify-content: start;\n\n  @media (max-width: 959px) {\n    height: 100%;\n    overflow: auto;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    flex: 0 0 164px;\n  }\n\n  @media (max-width: 479px) {\n    width: 138px;\n    min-width: 138px;\n    flex: 0 0 138px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: start;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 252px;\n  min-width: 252px;\n  border-left: 1px solid ",";\n  background-color: ",";\n\n  ","\n\n  @media (max-width: 959px) {\n    align-self: stretch;\n    width: auto;\n    min-width: auto;\n    height: calc(100vh - 45px);\n    border-left: none;\n  }\n"],["\n  display: flex;\n  justify-content: start;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 252px;\n  min-width: 252px;\n  border-left: 1px solid ",";\n  background-color: ",";\n\n  ","\n\n  @media (max-width: 959px) {\n    align-self: stretch;\n    width: auto;\n    min-width: auto;\n    height: calc(100vh - 45px);\n    border-left: none;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n      width: 100%;\n    "],["\n      width: 100%;\n    "]),_templateObject6=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n"],["\n  @media (max-width: 959px) {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n"]);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Table=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var Column=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var StockTitleList=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Column)(_templateObject3);var StockList=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.theme.mainDark;},function(props){return props.theme.popupDarkBackground;},function(_ref){var isTour=_ref.isTour;return isTour&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5);});var Info=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6);function filterObject(input,iteratee){return Object.keys(input).reduce(function(output,key){var value=input[key];if(iteratee(value,key,input)){return Object.assign(output,_defineProperty({},key,value));}return output;},{});}function filterPopular(input,profitFn){return Object.keys(input).filter(function(key){return input[key].enabled;}).sort(function(a,b){// Sort by profit
var profitA=profitFn(input[a]);var profitB=profitFn(input[b]);if(profitA===profitB){// Sort alphabetically
var titleA=input[a].title;var titleB=input[b].title;if(titleA>titleB)return 1;return-1;}if(profitA>profitB)return-1;return 1;}).slice(0,10).reduce(function(output,key){output[key]=input[key];return output;},{});}function checkObjectField(assets,field){for(var i in assets){if(assets.hasOwnProperty(i)){if(!assets[i][field]){// TODO: what if assets[i][field] === false OR 0 OR ''? Then false anyway?
return false;}}}return true;}var stockCategories={popular:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Popular"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["g" /* PopularStocksIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find quotations for the most popular assets on our platform.")},forex:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Forex"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["c" /* ForexIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find the currencies exchange rates from the Forex market. E.g., the rate of the euro to the US dollar.")},cryptos:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"cryptos"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["b" /* CryptosIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find cryptocurrencies rates.")},forex_otc:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Forex OTC"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["d" /* ForexOtcIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find the currencies exchange rates from the Forex market. E.g., the rate of the euro to the US dollar.")},indexes:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Indices"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["e" /* IndexesIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find the Indices that are formed from multiple assets and show the status of some part of financial markets.")},metals:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Metals"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["f" /* MetalsIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find rates for metals in USD.")},commodities:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Commodities"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["a" /* CommoditiesIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find rates of commodities. E.g., WTI, which reflects futures prices for crude oil WTI (West Texas Intermediate).")},us_stocks:{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Stocks"),Icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["h" /* StocksIcon */],null),info:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Here you can find rates for stocks of such famous companies as Google, Amazon, Apple, etc.")}};function getDefaultCategory(assets,categories){// Приоритет "forex" -> "forex_otc"
var stocks=Object.keys(assets);var forexIsAvailable=stocks.some(function(stock){return assets[stock].category==="forex"&&assets[stock].enabled;});if(forexIsAvailable){return"forex";}else{return"forex_otc";}}function StockMenu(props){var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(props.defaultCategory||getDefaultCategory(props.stocks,props.categories)),_useState2=_slicedToArray(_useState,2),activeCategory=_useState2[0],setActiveCategory=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState4=_slicedToArray(_useState3,2),hoveredCategory=_useState4[0],setHoveredCategory=_useState4[1];var onStockCategoryClick=function onStockCategoryClick(category){setActiveCategory(category);};var showInfo=function showInfo(category){setHoveredCategory(category);};var hideInfo=function hideInfo(){setHoveredCategory(null);};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){props.dispatch({type:"REQUEST_STOCK_ASSETS"});},[]);var activeAccount=props.accounts.find(function(account){return account.id===props.profile.active_account_id;});var assets=void 0;var getProfit=void 0;if(activeCategory==="popular"){if(props.tradeMode==="tournament"){getProfit=function getProfit(item){return item.realProfit-item.profit_vip;};}else{getProfit=function getProfit(item){return item.realProfit;};}assets=filterPopular(props.stocks,getProfit);}else{assets=filterObject(props.stocks,function(stock){return stock.category===activeCategory;});}var forexOtcIsFullyClosed=Object.keys(props.stocks).map(function(key){return props.stocks[key];}).filter(function(asset){return asset.category==="forex_otc";}).every(function(asset){return!asset.enabled;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_ClickOutside__["a" /* default */],{onOutsideClick:props.onClose,disabled:props.disabledOutside},function(_ref2){var innerRef=_ref2.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Table,{ref:innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockTitleList,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,props.categories.filter(function(category){return forexOtcIsFullyClosed?category!=="forex_otc":true;}).map(function(category){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StockCategory__["a" /* default */],Object.assign({key:category,active:activeCategory===category,category:category,onClick:onStockCategoryClick,showInfo:showInfo,hideInfo:hideInfo},stockCategories[category]));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Info,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Toolbar_ToolsContent__["b" /* InfoBlock */],null,hoveredCategory!=null?stockCategories[hoveredCategory].info:stockCategories[activeCategory].info))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(StockList,{isTour:props.isTour,enabled:checkObjectField(assets,"enabled"&&!props.isTour),description:checkObjectField(assets,"description"&&!props.isTour)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StocksTable__["a" /* default */],{assets:assets,tradeMode:props.tradeMode,tabs:props.tabs,hideName:activeCategory==="popular",activeStock:props.activeStock,onStockClick:props.onStockSelect,activeAccount:activeAccount})));});}function mapStateToProps(state){return{tradeMode:state.settings.mode,stocks:state.stocks,tabs:state.tabs.tabs,categories:["popular"].concat(_toConsumableArray(state.stockCategories)),activeStock:state.tabs.tabs[state.tabs.activeTab],profile:state.profile,accounts:state.accounts};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(StockMenu));

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 37px;\n  padding-left: 13px;\n  padding-right: 6px;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n  text-align: left;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    color: ",";\n  }\n\n  ",";\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"],["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 37px;\n  padding-left: 13px;\n  padding-right: 6px;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n  text-align: left;\n  text-transform: uppercase;\n  background-color: transparent;\n  border: none;\n  white-space: nowrap;\n  cursor: pointer;\n\n  &:hover {\n    color: ",";\n  }\n\n  ",";\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      color: ",";\n      background-color: ",";\n      &:hover {\n        color: ",";\n      }\n    "],["\n      color: ",";\n      background-color: ",";\n      &:hover {\n        color: ",";\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 19px;\n  margin-top: -2px;\n  margin-right: 10px;\n  color: #99959d;\n  line-height: 0;\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 19px;\n  margin-top: -2px;\n  margin-right: 10px;\n  color: #99959d;\n  line-height: 0;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Category=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.tradeHeaderAccent;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(props){return props.theme.popupDarkBackground;},function(_ref3){var theme=_ref3.theme;return theme.foreground;});},function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"10px";});var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(_ref5){var theme=_ref5.theme;return theme.foreground;});});function StockCategory(props){var handleClick=function handleClick(){return function(){return props.onClick(props.category);};};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:{minWidth:960}},function(matches){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{position:"relative",marginBottom:3}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Category,{active:props.active,onClick:handleClick(),onMouseEnter:matches?function(){return props.showInfo(props.category);}:null,onMouseLeave:matches?props.hideInfo:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{active:props.active},props.Icon),props.title));});}/* harmony default export */ __webpack_exports__["a"] = (StockCategory);

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StockRow__ = __webpack_require__(1744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tour__ = __webpack_require__(44);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 1;\n  width: 100%;\n  overflow: hidden;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  flex: 1;\n  width: 100%;\n  overflow: hidden;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      width: calc(100vw - 164px);\n\n      /* portrait */\n      @media (max-width: 479px) {\n        width: calc(100vw - 138px);\n      }\n    "],["\n      width: calc(100vw - 164px);\n\n      /* portrait */\n      @media (max-width: 479px) {\n        width: calc(100vw - 138px);\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 37px;\n  padding-left: 21px;\n  padding-right: 21px;\n  text-align: center;\n  font-size: ",";\n  color: ",";\n\n  ",";\n"],["\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  width: 100%;\n  height: 37px;\n  padding-left: 21px;\n  padding-right: 21px;\n  text-align: center;\n  font-size: ",";\n  color: ",";\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      padding-left: 12px;\n      padding-right: 12px;\n    "],["\n      padding-left: 12px;\n      padding-right: 12px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-self: stretch;\n  width: 100%;\n  height: calc(100% - 38px);\n  padding: 12px;\n  padding-right: 0;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-self: stretch;\n  width: 100%;\n  height: calc(100% - 38px);\n  padding: 12px;\n  padding-right: 0;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      height: calc(100vh - 45px - 38px);\n      padding: 12px;\n    "],["\n      height: calc(100vh - 45px - 38px);\n      padding: 12px;\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 50%;\n  ","\n\n  ","\n\n  ","\n"],["\n  position: relative;\n  display: flex;\n  flex: 1;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 50%;\n  ","\n\n  ","\n\n  ","\n"]),_templateObject8=_taggedTemplateLiteral(["\n      min-width: 74px;\n    "],["\n      min-width: 74px;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n      width: 33.3333%;\n      min-width: 0;\n    "],["\n      width: 33.3333%;\n      min-width: 0;\n    "]),_templateObject10=_taggedTemplateLiteral(["\n      width: 50%;\n      min-width: 0;\n    "],["\n      width: 50%;\n      min-width: 0;\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 1px;\n  margin: 0 12px;\n  background-color: ",";\n"],["\n  width: 100%;\n  height: 1px;\n  margin: 0 12px;\n  background-color: ",";\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Table=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var TableTitleRow=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.theme.accent;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var TableBody=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var TableTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(props){return!props.isNameColumnVisible&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8);},function(props){return props.mobile&&props.isNameColumnVisible&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);},function(props){return props.mobile&&!props.isNameColumnVisible&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject10);});var TableTitleSeparator=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11,function(props){return props.theme.mainSeparator;});var TitleRow=function TitleRow(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableTitleRow,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableTitle,{mobile:props.mobile,isNameColumnVisible:props.isNameColumnVisible},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Assets")),props.isNameColumnVisible&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableTitle,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Name")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableTitle,{mobile:props.mobile,isNameColumnVisible:props.isNameColumnVisible},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Income"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableTitleSeparator,null));};function StocksTable(_ref){var assets=_ref.assets,props=_objectWithoutProperties(_ref,["assets"]);var stocks=Object.keys(assets);if(!assets){// TODO: Decide, this never happens, can we remove this? or should we fix this?
// Question is whether we should show table header or not.
// Possible replacement is check of stocks.length
return null;}var firstAsset=assets[stocks[0]];var isNameColumnVisible=Boolean(firstAsset&&firstAsset.description&&props.hideName!==true);var original=__WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Table,{mobile:matches},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TitleRow,{mobile:matches,isNameColumnVisible:isNameColumnVisible}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableBody,{mobile:matches},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Scrollable__["a" /* default */],null,stocks.map(function(key,index){return index===0?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Tour__["b" /* default */],{step:"stockSelect",originalRef:original},function(_ref2){var next=_ref2.next,isOriginal=_ref2.isOriginal,tour=_ref2.tour;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__StockRow__["a" /* default */],{isOriginal:isOriginal,tour:tour,ref:isOriginal?original:null,key:index,tradeMode:props.tradeMode,item:assets[key],onClick:function onClick(){next(key);props.onStockClick(key);},activeAccount:props.activeAccount,isNameColumnVisible:isNameColumnVisible});}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__StockRow__["a" /* default */],{key:index,tradeMode:props.tradeMode,item:assets[key],onClick:function onClick(){return props.onStockClick(key);},activeAccount:props.activeAccount,isNameColumnVisible:isNameColumnVisible});}))));});}/* harmony default export */ __webpack_exports__["a"] = (StocksTable);

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StockName__ = __webpack_require__(1745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GA__ = __webpack_require__(11);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: flex;\n  flex-flow: row wrap;\n  height: 37px;\n  margin-bottom: 3px;\n  font-size: 12px;\n  color: #99959d;\n  text-align: center;\n  line-height: 33px;\n  cursor: pointer;\n\n  @media (min-width: 960px) {\n    padding-left: 9px;\n    padding-right: 21px;\n  }\n\n  @media (max-width: 959px) {\n    height: auto;\n  }\n\n  ",";\n\n  :after {\n    ",";\n\n    ",";\n  }\n"],["\n  direction: ",";\n  position: relative;\n  display: flex;\n  flex-flow: row wrap;\n  height: 37px;\n  margin-bottom: 3px;\n  font-size: 12px;\n  color: #99959d;\n  text-align: center;\n  line-height: 33px;\n  cursor: pointer;\n\n  @media (min-width: 960px) {\n    padding-left: 9px;\n    padding-right: 21px;\n  }\n\n  @media (max-width: 959px) {\n    height: auto;\n  }\n\n  ",";\n\n  :after {\n    ",";\n\n    ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n          opacity: 0.5;\n          cursor: default;\n\n          :hover {\n            opacity: 1;\n            color: ",";\n            "," {\n              color: #0085eb;\n            }\n\n            > div:last-of-type {\n              display: flex;\n            }\n          }\n        "],["\n          opacity: 0.5;\n          cursor: default;\n\n          :hover {\n            opacity: 1;\n            color: ",";\n            "," {\n              color: #0085eb;\n            }\n\n            > div:last-of-type {\n              display: flex;\n            }\n          }\n        "]),_templateObject3=_taggedTemplateLiteral(["\n          opacity: 0.5;\n          cursor: default;\n        "],["\n          opacity: 0.5;\n          cursor: default;\n        "]),_templateObject4=_taggedTemplateLiteral(["\n          :hover {\n            color: ",";\n          }\n        "],["\n          :hover {\n            color: ",";\n          }\n        "]),_templateObject5=_taggedTemplateLiteral(["\n        position: absolute;\n        left: -10px;\n        top: -10px;\n        right: -10px;\n        bottom: -10px;\n        border-radius: 6px;\n        ",";\n        content: \"\";\n      "],["\n        position: absolute;\n        left: -10px;\n        top: -10px;\n        right: -10px;\n        bottom: -10px;\n        border-radius: 6px;\n        ",";\n        content: \"\";\n      "]),_templateObject6=_taggedTemplateLiteral(["\n  position: relative;\n  flex: 1;\n  flex-basis: 50%;\n  padding-left: 7px;\n  padding-right: 7px;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  \n  @media (max-width: 336px) {\n    padding-right: 16px;\n  } \n\n  ",";\n    \n  ",";\n"],["\n  position: relative;\n  flex: 1;\n  flex-basis: 50%;\n  padding-left: 7px;\n  padding-right: 7px;\n  vertical-align: middle;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  \n  @media (max-width: 336px) {\n    padding-right: 16px;\n  } \n\n  ",";\n    \n  ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n      flex-basis: 33.3333%;\n    "],["\n      flex-basis: 33.3333%;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n    text-align:left;\n  "],["\n    text-align:left;\n  "]),_templateObject9=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 8px;\n  right: -2px;\n  font-size: 0;\n  line-height: 0;\n  z-index: 2;\n"],["\n  position: absolute;\n  top: 8px;\n  right: -2px;\n  font-size: 0;\n  line-height: 0;\n  z-index: 2;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 2px;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  padding-left: 21px;\n  padding-right: 21px;\n  font-size: ",";\n  color: ",";\n  background-color: ",";\n  box-shadow: 7px 0 0 0 ",";\n  z-index: 1;\n\n  @media (max-width: 959px) {\n    position: absolute;\n    top: 0;\n    left: auto;\n    right: 28px;\n    height: 33px;\n  }\n\n  @media (max-width: 479px) {\n    position: static;\n    width: 100%;\n    height: 15px;\n  }\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 2px;\n  display: none;\n  align-items: center;\n  justify-content: flex-start;\n  height: 100%;\n  padding-left: 21px;\n  padding-right: 21px;\n  font-size: ",";\n  color: ",";\n  background-color: ",";\n  box-shadow: 7px 0 0 0 ",";\n  z-index: 1;\n\n  @media (max-width: 959px) {\n    position: absolute;\n    top: 0;\n    left: auto;\n    right: 28px;\n    height: 33px;\n  }\n\n  @media (max-width: 479px) {\n    position: static;\n    width: 100%;\n    height: 15px;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TableRow=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},function(props){switch(true){case props.disabled&&props.willReopen:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2,function(_ref2){var theme=_ref2.theme;return theme.accent;},Disabled);case props.disabled:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject3);default:return Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,props.theme.accent);}},function(_ref3){var tourBorder=_ref3.tourBorder;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5,tourBorder.border);},function(_ref4){var tourBorderAnimation=_ref4.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation(tourBorderAnimation.keyframe);});var TableCell=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.description&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject7);},function(props){return props.stock&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8);});var Disabled=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject9);var Info=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(10),function(_ref5){var theme=_ref5.theme;return theme.foreground;},function(_ref6){var theme=_ref6.theme;return theme.stockInfoBg;},function(_ref7){var theme=_ref7.theme;return theme.stockInfoBg;});var InfoDate=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject11,function(_ref8){var theme=_ref8.theme;return theme.lightAccent;});var Lock=function Lock(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{fill:"currentColor",height:"16",viewBox:"0 0 24 24",width:"16",xmlns:"http://www.w3.org/2000/svg"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"}));};function StockRow(props){var handleClick=function handleClick(event){if(props.item.enabled){Object(__WEBPACK_IMPORTED_MODULE_6__GA__["a" /* gaReducer */])("CLICKBTN_STOCK",{buttonText:props.item.stock});props.onClick(event);}};var isNew=props.item.is_new;var _props$item=props.item,title=_props$item.title,description=_props$item.description,enabled=_props$item.enabled;var profit=void 0;if(props.tradeMode==="tournament"){profit=props.item.realProfit-props.item.profit_vip;}else{profit=props.activeAccount.type==="real"?props.item.realProfit:props.item.demoProfit;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableRow,{ref:props.forwardedRef,disabled:!props.item.enabled,willReopen:props.item.state_changed_at!=null,onClick:handleClick,tourBorder:!props.isOriginal&&props.tour&&props.tour.borderStyles,tourBorderAnimation:!props.isOriginal&&props.tour&&props.tour.outside&&props.tour.borderStyles},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,{stock:true,description:props.isNameColumnVisible&&description},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__StockName__["a" /* default */],{isNew:isNew,name:title})),description!=null&&props.isNameColumnVisible&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,{description:props.isNameColumnVisible&&description,title:description},description),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,{description:props.isNameColumnVisible&&description},profit,"%",!enabled&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Disabled,{description:description},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Lock,null))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,{description:props.isNameColumnVisible&&description},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Opening"),":\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoDate,null,props.item.state_changed_at!=null?__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.item.state_changed_at*1000).format("MMM Do, HH:mm"):null)));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](StockRow,Object.assign({},props,{forwardedRef:ref}));}));

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  line-height: normal;\n  display: inline-flex;\n  flex-flow: column;\n  align-items: flex-start;\n"],["\n  line-height: normal;\n  display: inline-flex;\n  flex-flow: column;\n  align-items: flex-start;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display:flex;\n  flex-flow:row;\n"],["\n  display:flex;\n  flex-flow:row;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: 12px;\n"],["\n  font-size: 12px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-size: 8px;\n"],["\n  font-size: 8px;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position:relative;\n"],["\n  position:relative;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 3px;\n  text-transform: uppercase;\n  font-size: ",";\n  z-index: 1;\n  color: ",";\n  \n  ",";\n  \n"],["\n  position: absolute;\n  top: 3px;\n  text-transform: uppercase;\n  font-size: ",";\n  z-index: 1;\n  color: ",";\n  \n  ",";\n  \n"]),_templateObject7=_taggedTemplateLiteral(["\n    position:static;\n    left:0;\n    right:0;\n    padding-left:3px;\n  "],["\n    position:static;\n    left:0;\n    right:0;\n    padding-left:3px;\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function splitStockName(fullName){var name=fullName;var specifier=null;var split=fullName.indexOf("(");if(~split){name=fullName.substring(0,split).trimEnd();specifier=fullName.substring(split);}return{name:name,specifier:specifier};}var Splitted=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Details=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2);var Name=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject3);var Specifier=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject4);var TextCont=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject5);var NewLabel=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(8),function(_ref){var theme=_ref.theme;return theme.accent;},function(props){return props.static&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7);});function SplittedName(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Splitted,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Name,null,props.name),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Details,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Specifier,null,props.specifier),props.isNew&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewLabel,{"static":true},"new")));}function StockName(props){// We migth get stock name as "stockname (some abbriviation)", so
// we split it to render differently
var _splitStockName=splitStockName(props.name),name=_splitStockName.name,specifier=_splitStockName.specifier;return specifier?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SplittedName,{isNew:props.isNew,name:name,specifier:specifier}):props.isNew?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TextCont,null,name,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NewLabel,null,"new")):name;}/* harmony default export */ __webpack_exports__["a"] = (StockName);

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PurseIcon */
/* unused harmony export CupIcon */
/* unused harmony export BigCupIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RawClock; });
/* unused harmony export Clock */
/* unused harmony export RateIcon */
/* unused harmony export CloseIcon */
/* unused harmony export PaymentErrorIcon */
/* unused harmony export MoneyIcon */
/* unused harmony export MoneyPlusIcon */
/* unused harmony export PersonIcon */
/* unused harmony export CupWinnerIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var PurseIcon=function PurseIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 17.574 16.197",width:"17px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"icon_account","data-name":"icon account",fill:"#ffffff",d:"M-5152.823-2891.833a1.178,1.178,0,0,1-1.177-1.178v-10.641a1.177,1.177,0,0,1,1.177-1.177h14.6a1.177,1.177,0,0,1,1.176,1.177v2.527h-4.051a1.528,1.528,0,0,0-1.527,1.526v2.537a1.529,1.529,0,0,0,1.527,1.527h4.051v2.526a1.178,1.178,0,0,1-1.176,1.178Zm11.727-4.54a.69.69,0,0,1-.69-.69v-2.537a.69.69,0,0,1,.69-.69h3.979a.691.691,0,0,1,.69.69v2.537a.691.691,0,0,1-.69.69Zm.375-1.958a1,1,0,0,0,1,1,1,1,0,0,0,1-1,1,1,0,0,0-1-1A1,1,0,0,0-5140.722-2898.332Zm-7.455-7.645,5.983-1.976a1.52,1.52,0,0,1,1.92.966l.333,1.01Z",transform:"translate(5154 2908.03)"})));};var CupIcon=function CupIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 20",width:"16px",height:props.height||"20px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_714","data-name":"Path 714",fill:"currentColor",d:"M-2295.042-119.769a.49.49,0,0,1-.445-.467v-.934a.49.49,0,0,1,.445-.467h.444v-2.222a.9.9,0,0,1,.889-.909h1.333v-.39a.439.439,0,0,1,.445-.482.439.439,0,0,0,.445-.482v-1.5a3.119,3.119,0,0,1-2.1-2.144h-.7a2.064,2.064,0,0,1-1.555-.681l-.755-.773a2.087,2.087,0,0,1-.667-1.591v-2.864a1.325,1.325,0,0,1,1.334-1.364h2.222v-.839a.921.921,0,0,1-.889-.944.921.921,0,0,1,.889-.944h8.888a.921.921,0,0,1,.889.944.92.92,0,0,1-.889.944v.839h2.222a1.325,1.325,0,0,1,1.334,1.364v2.864a2.157,2.157,0,0,1-.667,1.591l-.756.773a2,2,0,0,1-1.555.681h-.7a3.117,3.117,0,0,1-2.1,2.144v1.5a.438.438,0,0,0,.444.482.439.439,0,0,1,.445.482v.39h1.333a.9.9,0,0,1,.889.909v2.222h.444a.491.491,0,0,1,.444.467v.934a.491.491,0,0,1-.444.467Zm10.8-10.909a1.2,1.2,0,0,0,.933-.409l.756-.773a1.324,1.324,0,0,0,.4-.954v-2.864a.425.425,0,0,0-.444-.455h-2.222v5.455Zm-12.133-5v2.864a1.251,1.251,0,0,0,.4.954l.755.773a1.266,1.266,0,0,0,.933.409h.578v-5.455h-2.222A.425.425,0,0,0-2296.376-135.678Z",transform:"translate(2297.266 139.769)"})));};var BigCupIcon=function BigCupIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28.008 34.232",width:props.width||"28px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cup",transform:"translate(-46.545 0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_419","data-name":"Path 419",fill:"#9792a1",d:"M135.035,385.556A1.561,1.561,0,0,0,133.479,384h-15.56a1.561,1.561,0,0,0-1.556,1.556v3.89h18.672Z",transform:"translate(-65.15 -358.327)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_420","data-name":"Path 420",fill:"#7c7688",d:"M114.1,465.455a.837.837,0,0,1,.778.778v1.556a.837.837,0,0,1-.778.778H93.869a.837.837,0,0,1-.778-.778v-1.556a.837.837,0,0,1,.778-.778Z",transform:"translate(-43.434 -434.336)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_421","data-name":"Path 421",fill:"#f6b545",d:"M184.66,314.036a.735.735,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v2.567a.735.735,0,0,1-.778.778.735.735,0,0,0-.778.778v.778h10.892v-.778A.735.735,0,0,0,184.66,314.036Z",transform:"translate(-119.443 -289.919)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_422","data-name":"Path 422",fill:"#787382",d:"M319.627,389.446v-3.89A1.561,1.561,0,0,0,318.071,384h-3.89v5.446Z",transform:"translate(-249.742 -358.327)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_423","data-name":"Path 423",fill:"#ffcb5b",d:"M193.961,410.384h-6.224a1.561,1.561,0,0,1-1.556-1.556h0a1.561,1.561,0,0,1,1.556-1.556h6.224a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,193.961,410.384Z",transform:"translate(-130.3 -380.043)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_530","data-name":"Group 530",transform:"translate(59.771 27.229)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_424","data-name":"Path 424",fill:"#f6b545",d:"M245.92,410.385h-1.556l1.556-3.112h1.556Z",transform:"translate(-244.364 -407.273)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_425","data-name":"Path 425",fill:"#f6b545",d:"M282.384,408.828a1.561,1.561,0,0,0-1.556-1.556l-1.556,3.112h1.556A1.56,1.56,0,0,0,282.384,408.828Z",transform:"translate(-276.938 -407.272)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_426","data-name":"Path 426",fill:"#635d6e",d:"M114.1,465.455h-5.446v.778a1.561,1.561,0,0,1-1.556,1.556H94.648a.735.735,0,0,1-.778-.778v-1.556a.735.735,0,0,0-.778.778v1.556a.78.78,0,0,0,.778.778H114.1a.837.837,0,0,0,.778-.778v-1.556A.837.837,0,0,0,114.1,465.455Z",transform:"translate(-43.435 -434.336)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_427","data-name":"Path 427",fill:"#ffcb5b",d:"M186.571,360.727H188.9a.368.368,0,0,1,.389.389h0a.367.367,0,0,1-.389.389h-2.334a.367.367,0,0,1-.389-.389h0A.368.368,0,0,1,186.571,360.727Z",transform:"translate(-130.301 -336.61)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_428","data-name":"Path 428",fill:"#f6b545",d:"M53.547,82.267H51.758A3.649,3.649,0,0,1,49.035,81.1l-1.323-1.323a3.532,3.532,0,0,1-1.167-2.723v-4.9a2.292,2.292,0,0,1,2.334-2.334h3.89a.778.778,0,0,1,0,1.556h-3.89a.735.735,0,0,0-.778.778v4.9a2.119,2.119,0,0,0,.7,1.634l1.323,1.323a2.239,2.239,0,0,0,1.634.7h1.789a.778.778,0,0,1,0,1.556Z",transform:"translate(0 -65.152)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_430","data-name":"Path 430",fill:"#f6b545",d:"M351.658,82.268h-1.789a.778.778,0,1,1,0-1.556h1.789a2.119,2.119,0,0,0,1.634-.7l1.323-1.323a2.239,2.239,0,0,0,.7-1.634v-4.9a.735.735,0,0,0-.778-.778h-3.89a.778.778,0,1,1,0-1.556h3.89a2.292,2.292,0,0,1,2.334,2.334v4.9a3.649,3.649,0,0,1-1.167,2.723L354.381,81.1A3.532,3.532,0,0,1,351.658,82.268Z",transform:"translate(-282.318 -65.153)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_532","data-name":"Group 532",transform:"translate(66.773 4.667)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_431","data-name":"Path 431",fill:"#f19920",d:"M352.2,231.564c-.156,0-.311.078-.545.078h-1.789a.778.778,0,1,0,0,1.556h2.1a5.529,5.529,0,0,0,.233-1.634Z",transform:"translate(-349.091 -220.75)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_432","data-name":"Path 432",fill:"#f19920",d:"M360.727,70.6a.735.735,0,0,0,.778.778h1.556V69.818H361.5A.735.735,0,0,0,360.727,70.6Z",transform:"translate(-359.949 -69.818)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_433","data-name":"Path 433",fill:"#ffca5d",d:"M149.75,64.439h-4.668a5.413,5.413,0,0,1-5.446-5.446V46.545H155.2V58.993A5.412,5.412,0,0,1,149.75,64.439Z",transform:"translate(-86.867 -43.434)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_533","data-name":"Group 533",transform:"translate(56.659 7.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_434","data-name":"Path 434",fill:"#f19920",d:"M206.376,314.036a.837.837,0,0,1-.778-.778v-2.567a5.017,5.017,0,0,1-1.556.233h-4.668a5.017,5.017,0,0,1-1.556-.233v.778a5.017,5.017,0,0,0,1.556.233h2.334a1.561,1.561,0,0,1,1.556,1.556h0a.78.78,0,0,0,.778.778.735.735,0,0,1,.778.778v.778h2.334v-.778A.78.78,0,0,0,206.376,314.036Z",transform:"translate(-197.818 -296.92)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_435","data-name":"Path 435",fill:"#f19920",d:"M454.6,105.116v3.112a.367.367,0,0,1-.389.389h0a.367.367,0,0,1-.389-.389v-3.112a.367.367,0,0,1,.389-.389h0A.368.368,0,0,1,454.6,105.116Z",transform:"translate(-436.703 -104.727)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_534","data-name":"Group 534",transform:"translate(51.213 -0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_436","data-name":"Path 436",fill:"#f6b545",d:"M139.636,46.545v.778h10.892a1.561,1.561,0,0,1,1.556,1.556V58.993c0,3.034-1.634,5.446-4.668,5.446h2.334a5.413,5.413,0,0,0,5.446-5.446V46.545Z",transform:"translate(-138.08 -43.433)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_437","data-name":"Path 437",fill:"#f6b545",d:"M133.479,3.111h-15.56a1.561,1.561,0,0,1-1.556-1.556h0A1.561,1.561,0,0,1,117.919,0h15.56a1.561,1.561,0,0,1,1.556,1.556h0A1.561,1.561,0,0,1,133.479,3.111Z",transform:"translate(-116.363 0.001)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_442","data-name":"Path 442",fill:"#f19920",d:"M133.48,0h0a1.561,1.561,0,0,1-1.556,1.556h-15.56a1.561,1.561,0,0,0,1.556,1.556H133.4a1.665,1.665,0,0,0,1.634-1.323A1.576,1.576,0,0,0,133.48,0Z",transform:"translate(-65.151 -0.001)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_536","data-name":"Group 536",transform:"translate(54.325 5.445)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_444","data-name":"Path 444",fill:"#ffe27a",d:"M163.687,87.679h0a.735.735,0,0,1-.778-.778V82.233a.735.735,0,0,1,.778-.778h0a.735.735,0,0,1,.778.778V86.9A.735.735,0,0,1,163.687,87.679Z",transform:"translate(-162.909 -81.455)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{id:"Ellipse_5","data-name":"Ellipse 5",fill:"#ffe27a",cx:"0.778",cy:"0.778",r:"0.778",transform:"translate(0 7.002)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_445","data-name":"Path 445",fill:"#847f8e",d:"M117.919,384a1.561,1.561,0,0,0-1.556,1.556v3.89h1.556Z",transform:"translate(-65.15 -358.327)"}))));};var RawClock=function RawClock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 15.998 20.001",width:props.width||"16px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_713","data-name":"Path 713",fill:"currentColor",d:"M1238-12037.673a7.953,7.953,0,0,1,2.35-5.649l-.9-1.264a.493.493,0,0,1,.118-.692l1.318-.932a.5.5,0,0,1,.7.118l.889,1.252a7.939,7.939,0,0,1,2.262-.717v-.514a.6.6,0,0,0-.6-.6h-.33a.6.6,0,0,1-.6-.6v-1.823a.6.6,0,0,1,.6-.6h4.385a.6.6,0,0,1,.6.6v1.823a.6.6,0,0,1-.6.6h-.33a.6.6,0,0,0-.6.6v.514a7.854,7.854,0,0,1,2.12.65l.9-1.268a.5.5,0,0,1,.7-.117l1.318.934a.5.5,0,0,1,.121.693l-.877,1.233a7.948,7.948,0,0,1,2.462,5.758,8,8,0,0,1-8,7.983A8,8,0,0,1,1238-12037.673Zm1.92,0a6.078,6.078,0,0,0,6.078,6.066,6.081,6.081,0,0,0,6.081-6.066,6.083,6.083,0,0,0-6.081-6.069A6.081,6.081,0,0,0,1239.922-12037.673Zm6.039-.042v-4.96l.039,0a5.016,5.016,0,0,1,5.014,4.963Z",transform:"translate(-1238.001 12049.69)"}));};var Clock=function Clock(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RawClock,{width:props.width}));};var RateIcon=function RateIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 18 14",width:"18px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"Path_718","data-name":"Path 718",fill:"#ffffff",d:"M-1268-215h-11v-9h6v-5h6v8h6v6Z",transform:"translate(1279 229)"})));};var CloseIcon=function CloseIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 19.707 19.707",width:"19px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Group_82","data-name":"Group 82",transform:"translate(-901.146 -251.146)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{id:"Line_4","data-name":"Line 4",stroke:"#96949b",x2:"19",y2:"19",transform:"translate(901.5 251.5)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{id:"Line_5","data-name":"Line 5",stroke:"#96949b",x1:"19",y2:"19",transform:"translate(901.5 251.5)"}))));};var PaymentErrorIcon=function PaymentErrorIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{id:"Group_801","data-name":"Group 801",xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 67.5 67.5",width:"68px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Ellipse_1","data-name":"Ellipse 1",fill:"none",stroke:"#ef3522","stroke-width":"6px",transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{stroke:"none",cx:"33.75",cy:"33.75",r:"33.75"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"none",cx:"33.75",cy:"33.75",r:"30.75"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"coins",transform:"translate(13.297 14.301)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_143_",fill:"#fcc62d",d:"M36.53,29.211v.82c0,4.589-7.707,8.31-17.214,8.31a27.489,27.489,0,0,1-13.1-2.922c1.065,4.135,8.3,7.557,17.073,7.557,9.507,0,17.214-4.017,17.214-8.607,0-2.018-1.494-3.8-3.972-5.157",transform:"translate(-2.099 -9.871)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_142_",fill:"#e4af18",d:"M23.217,45.607C13.71,45.607,6,41.589,6,37v5.593c0,4.589,7.707,8.31,17.214,8.31s17.214-3.721,17.214-8.31V37c0,4.589-7.707,8.607-17.214,8.607",transform:"translate(-2.028 -12.504)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_141_",fill:"#ce9912",d:"M9,48.528a10.761,10.761,0,0,0,1.324,1.023V44.061A11,11,0,0,1,9,43Z",transform:"translate(-3.041 -14.531)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_140_",fill:"#ce9912",d:"M53,44.061V49.55a10.7,10.7,0,0,0,1.324-1.023V43A10.9,10.9,0,0,1,53,44.061",transform:"translate(-17.911 -14.531)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_139_",fill:"#ce9912",d:"M13,51.276q.628.325,1.324.615V46.467q-.7-.306-1.324-.646Z",transform:"translate(-4.393 -15.485)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_138_",fill:"#ce9912",d:"M49,51.89q.7-.29,1.324-.615V45.82q-.628.34-1.324.646Z",transform:"translate(-16.559 -15.484)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_137_",fill:"#ce9912",d:"M17,52.99q.642.219,1.324.41V48.028q-.682-.2-1.324-.434Z",transform:"translate(-5.745 -16.084)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_136_",fill:"#ce9912",d:"M45,53.4q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z",transform:"translate(-15.207 -16.084)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_135_",fill:"#ce9912",d:"M22,54.358c.432.087.875.166,1.324.235V49.267c-.45-.075-.892-.158-1.324-.251Z",transform:"translate(-7.435 -16.564)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_134_",fill:"#ce9912",d:"M40,54.592c.45-.07.892-.148,1.324-.235V49.015c-.432.093-.875.176-1.324.252Z",transform:"translate(-13.517 -16.564)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_133_",fill:"#ce9912",d:"M28,55.192c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z",transform:"translate(-9.462 -16.859)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_132_",fill:"#ce9912",d:"M34,55.263c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z",transform:"translate(-11.49 -16.859)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_131_",fill:"#e4af18",d:"M17.217,30.6C7.71,30.6,0,26.582,0,21.993v5.593C0,32.176,7.71,35.9,17.217,35.9s17.214-3.721,17.214-8.31V21.993c0,4.589-7.707,8.607-17.214,8.607",transform:"translate(0 -7.432)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_130_",fill:"#ce9912",d:"M3,33.521a10.761,10.761,0,0,0,1.324,1.023V29.055A11.064,11.064,0,0,1,3,27.994v5.527Z",transform:"translate(-1.014 -9.46)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_129_",fill:"#ce9912",d:"M47,29.054v5.489a10.7,10.7,0,0,0,1.324-1.023V27.993A10.9,10.9,0,0,1,47,29.054",transform:"translate(-15.883 -9.46)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_128_",fill:"#ce9912",d:"M7,36.269q.628.325,1.324.615V31.46q-.7-.306-1.324-.646v5.455Z",transform:"translate(-2.366 -10.413)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_127_",fill:"#ce9912",d:"M43,36.883q.7-.29,1.324-.615V30.813q-.628.34-1.324.646Z",transform:"translate(-14.531 -10.413)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_126_",fill:"#ce9912",d:"M11,37.983q.642.219,1.324.41V33.021q-.682-.2-1.324-.434Z",transform:"translate(-3.717 -11.012)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_125_",fill:"#ce9912",d:"M39,38.393q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z",transform:"translate(-13.179 -11.012)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_124_",fill:"#ce9912",d:"M16,39.351c.432.087.875.166,1.324.235V34.26c-.45-.075-.892-.158-1.324-.251Z",transform:"translate(-5.407 -11.493)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_123_",fill:"#ce9912",d:"M34,39.586c.45-.07.892-.148,1.324-.235V34.009c-.432.093-.875.176-1.324.252Z",transform:"translate(-11.49 -11.493)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_122_",fill:"#ce9912",d:"M22,40.186c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z",transform:"translate(-7.435 -11.788)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_121_",fill:"#ce9912",d:"M28,40.256c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z",transform:"translate(-9.462 -11.788)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_120_",fill:"#ffd949",d:"M38.48,33.3c-1.772,3.678-8.6,6.421-16.761,6.421a32.494,32.494,0,0,1-8.393-1.055c2.4,1.631,6.677,3.018,12.365,3.018,9.058,0,14.565-3.516,14.565-5.936A3.316,3.316,0,0,0,38.48,33.3",transform:"translate(-4.502 -11.254)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_119_",fill:"#ffd949",d:"M20.527,26.848c-9.507,0-17.214-3.721-17.214-8.31V14.8C1.234,16.1,0,17.734,0,19.566c0,4.589,7.707,8.607,17.214,8.607a27.934,27.934,0,0,0,11.817-2.411,32.377,32.377,0,0,1-8.507,1.087",transform:"translate(0 -5)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_118_",fill:"#e4af18",d:"M22.217,20.6C12.71,20.6,5,16.582,5,11.993v5.593c0,4.589,7.707,8.31,17.214,8.31s17.214-3.721,17.214-8.31V11.993c0,4.589-7.707,8.607-17.214,8.607",transform:"translate(-1.69 -4.053)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_117_",fill:"#ce9912",d:"M8,23.521a10.761,10.761,0,0,0,1.324,1.023V19.055A11.064,11.064,0,0,1,8,17.994Z",transform:"translate(-2.703 -6.081)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_116_",fill:"#ce9912",d:"M52,19.054v5.489a10.7,10.7,0,0,0,1.324-1.023V17.993A10.9,10.9,0,0,1,52,19.054",transform:"translate(-17.573 -6.08)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_115_",fill:"#ce9912",d:"M12,26.269q.628.325,1.324.615V21.46q-.7-.306-1.324-.646Z",transform:"translate(-4.055 -7.034)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_114_",fill:"#ce9912",d:"M48,26.883q.7-.29,1.324-.615V20.813q-.628.34-1.324.646Z",transform:"translate(-16.221 -7.033)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_113_",fill:"#ce9912",d:"M16,27.983q.642.219,1.324.41V23.021q-.682-.2-1.324-.434Z",transform:"translate(-5.407 -7.633)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_112_",fill:"#ce9912",d:"M44,28.393q.682-.191,1.324-.41v-5.4q-.642.231-1.324.434Z",transform:"translate(-14.869 -7.633)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_111_",fill:"#ce9912",d:"M21,29.351c.432.087.875.166,1.324.235V24.26c-.45-.075-.892-.158-1.324-.251Z",transform:"translate(-7.097 -8.113)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_110_",fill:"#ce9912",d:"M39,29.586c.45-.07.892-.148,1.324-.235V24.009c-.432.093-.875.176-1.324.252Z",transform:"translate(-13.179 -8.113)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_109_",fill:"#ce9912",d:"M27,30.186c.436.032.878.055,1.324.071v-5.3c-.446-.017-.888-.041-1.324-.076Z",transform:"translate(-9.124 -8.409)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_108_",fill:"#ce9912",d:"M33,30.256c.446-.017.888-.038,1.324-.071v-5.3c-.436.035-.878.059-1.324.077Z",transform:"translate(-11.152 -8.408)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_107_",fill:"#fcc62d",d:"M39.43,7.945c0,4.589-7.707,8.607-17.214,8.607S5,12.534,5,7.945,12.71,0,22.217,0,39.43,3.355,39.43,7.945",transform:"translate(-1.69)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"XMLID_106_",fill:"#ffd949",d:"M23.568,14.895C14.51,14.895,9,11.379,9,8.959S14.51,3,23.568,3,38.134,6.539,38.134,8.959s-5.507,5.936-14.565,5.936",transform:"translate(-3.041 -1.014)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{id:"Line_22","data-name":"Line 22",fill:"none",stroke:"#ef3522","stroke-width":"6px",x1:"47.582",y2:"43.156",transform:"translate(9.406 11.619)"})));};var MoneyIcon=function MoneyIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28 18.852",width:props.width||"28px",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-5394.775-808.251c-1.278-.394-1.545-.8-1.545-.891v-.012l-.03-1.757a7.887,7.887,0,0,0,1.509.551,18.645,18.645,0,0,0,4.551.521,17.922,17.922,0,0,0,5.006-.636,7.748,7.748,0,0,0,1.272-.515v1.818h.006c0,.085-.279.5-1.557.9a16.179,16.179,0,0,1-4.612.594A16.494,16.494,0,0,1-5394.775-808.251Zm-15.652-2.654a6.043,6.043,0,0,1,.4-8.532,6.1,6.1,0,0,1,4.066-1.569,6.169,6.169,0,0,1,1.788.267,6.083,6.083,0,0,1,4.133,4.551,6.311,6.311,0,0,1,.121,1.218,6,6,0,0,1-1.975,4.466,6.028,6.028,0,0,1-4.067,1.572A6.014,6.014,0,0,1-5410.428-810.9Zm10.071.533a7.3,7.3,0,0,0,1.164-1.994c.515.042,1.048.073,1.605.079v.109l.036,2.054A18.944,18.944,0,0,1-5400.357-810.372Zm3.982-2.03-.006-.509-.024-1.394a7.434,7.434,0,0,0,1.321.509,17.913,17.913,0,0,0,4.806.588,18.143,18.143,0,0,0,4.951-.618,6.93,6.93,0,0,0,1.327-.515v1.606h-.006c0,.061-.037.133-.037.2,0,.085-.285.5-1.594.9a16.759,16.759,0,0,1-4.648.582C-5393.642-811.056-5395.9-811.814-5396.375-812.4Zm-2.473-1.157a7.417,7.417,0,0,0,.14-1.418c0-.236-.012-.473-.03-.715.351.024.721.036,1.1.042l.037,2.145C-5398.03-813.5-5398.448-813.523-5398.848-813.559Zm4.108-1.382c-1.3-.382-1.66-.794-1.7-.921l-.012-.024a.047.047,0,0,1,.006-.024c.055-.164.485-.564,1.739-.915a16.488,16.488,0,0,1,4.321-.515h.1a16.981,16.981,0,0,1,4.666.576c1.291.388,1.594.788,1.6.879v.006c-.006.091-.309.509-1.654.909a16.834,16.834,0,0,1-4.605.57A16.909,16.909,0,0,1-5394.739-814.941Zm-2.569-1.915c-.582,0-1.145-.024-1.667-.06a7.171,7.171,0,0,0-1.085-2.254,21.839,21.839,0,0,0,2.746.176,18.082,18.082,0,0,0,5.023-.636,7.634,7.634,0,0,0,1.31-.521v1.588c-2.6.073-5.273.618-6.266,1.709Zm-4.121-3.812c-.019-.006-.03-.006-.048-.012a6.991,6.991,0,0,0-1.9-1.073l-.042-1.709a6.722,6.722,0,0,0,1.31.5,17.909,17.909,0,0,0,4.805.588,18.069,18.069,0,0,0,5.018-.636,7.24,7.24,0,0,0,1.314-.527v1.588a.35.35,0,0,0-.061.249c0,.079-.29.5-1.605.9a17.148,17.148,0,0,1-4.666.588A17.338,17.338,0,0,1-5401.429-820.667Zm-.345-3.448c-1.3-.376-1.667-.788-1.7-.921,0-.012-.007-.012-.007-.012.007-.121.285-.5,1.564-.891a16.37,16.37,0,0,1,4.6-.588,16.926,16.926,0,0,1,4.667.588c1.315.4,1.605.812,1.605.891s-.3.5-1.611.9a17.127,17.127,0,0,1-4.661.582A16.628,16.628,0,0,1-5401.774-824.115Z",transform:"translate(5412 826.527)"})));};var MoneyPlusIcon=function MoneyPlusIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 28.001 18.852",width:props.width||"28px",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-12095.176-27.148a16.515,16.515,0,0,1-4.6-.575c-1.283-.4-1.545-.8-1.545-.891l-.03-1.77a7.634,7.634,0,0,0,1.509.55,18.53,18.53,0,0,0,4.549.523,17.989,17.989,0,0,0,5.006-.636,7.636,7.636,0,0,0,1.271-.517v1.819c.007.066-.233.49-1.551.9A16.2,16.2,0,0,1-12095.176-27.148Zm-15.787-1.256a6.042,6.042,0,0,1-4.464-1.974,6,6,0,0,1-1.567-4.35,6,6,0,0,1,1.966-4.183,6.086,6.086,0,0,1,4.065-1.569,6.142,6.142,0,0,1,1.788.268,6.085,6.085,0,0,1,4.133,4.553,6.255,6.255,0,0,1,.122,1.216,6.024,6.024,0,0,1-1.977,4.467A6.026,6.026,0,0,1-12110.963-28.4Zm-4.038-6.843v2h3v3h2v-3h3v-2h-3v-3h-2v3Zm12.45,5.65h0a18.921,18.921,0,0,1-2.806-.249,7.2,7.2,0,0,0,1.164-1.992c.515.043,1.05.073,1.606.079v.109l.036,2.052Zm7.266-.934c-3.455,0-5.641-.786-6.089-1.344l-.006-.508-.024-1.4a7.418,7.418,0,0,0,1.319.511,18,18,0,0,0,4.806.587,18.2,18.2,0,0,0,4.951-.617,6.894,6.894,0,0,0,1.328-.517v1.606a1.008,1.008,0,0,0-.042.2c0,.082-.283.5-1.594.9A16.74,16.74,0,0,1-12095.285-30.53Zm-7.32-2.448h0c-.423,0-.842-.018-1.24-.055a7.3,7.3,0,0,0,.137-1.417c0-.237-.012-.471-.027-.715.351.024.721.036,1.1.043l.036,2.143Zm7.332-.9a16.836,16.836,0,0,1-4.465-.538c-1.239-.364-1.651-.762-1.7-.921.054-.235.538-.628,1.73-.964a16.6,16.6,0,0,1,4.321-.514h.1a17.093,17.093,0,0,1,4.665.575c1.3.393,1.594.793,1.6.879s-.3.515-1.651.915A16.819,16.819,0,0,1-12095.273-33.875Zm-6.974-2.454h-.061c-.584,0-1.146-.024-1.666-.061a7.185,7.185,0,0,0-1.086-2.253,21.871,21.871,0,0,0,2.746.176,18.141,18.141,0,0,0,5.023-.636,7.634,7.634,0,0,0,1.308-.523v1.587c-2.335.066-5.206.548-6.264,1.709Zm-.055-3.357a17.294,17.294,0,0,1-4.127-.453,7.839,7.839,0,0,0-1.946-1.086l-.042-1.709a6.668,6.668,0,0,0,1.311.5,17.983,17.983,0,0,0,4.8.587,18.075,18.075,0,0,0,5.015-.636,7.155,7.155,0,0,0,1.317-.529v1.587a.32.32,0,0,0-.061.228c0,.112-.295.522-1.606.919A17.063,17.063,0,0,1-12102.3-39.687Zm-.006-3.357a16.557,16.557,0,0,1-4.464-.544c-1.309-.374-1.671-.792-1.7-.921,0-.16.33-.529,1.557-.9a16.436,16.436,0,0,1,4.607-.587,16.961,16.961,0,0,1,4.665.587c1.32.4,1.605.811,1.605.891s-.287.5-1.611.9A17.1,17.1,0,0,1-12102.308-43.044Z",transform:"translate(12117.001 46)"})));};var PersonIcon=function PersonIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 16 16",width:props.width||"16px",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0,370v-2c0-2.2,3.6-4,8-4s8,1.8,8,4v2Zm4-12a4,4,0,1,1,4,4A4,4,0,0,1,4,358Z",transform:"translate(0 -354)"})));};var CupWinnerIcon=function CupWinnerIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 123.881 66"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-11.119 0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(99.342 0.755) rotate(30)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{"data-name":"Path 690",fill:"#f2f2f2",d:"M39.264,29.056c-13.088-9.977-26.176,9.977-39.264,0C0,20.367,0,11.57,0,2.88c13.088,9.977,26.176-9.977,39.264,0C39.264,11.57,39.264,20.26,39.264,29.056Z",transform:"translate(1.931 0.038)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{"data-name":"Group 693",transform:"translate(1.931 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z",transform:"translate(0 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.961,16.961,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(6.544 11.607)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A13.347,13.347,0,0,1,0,6.544C0,4.4,0,2.146,0,0A14.426,14.426,0,0,0,6.544,2.789C6.544,4.935,6.544,7.08,6.544,9.333Z",transform:"translate(0 16.006)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A16.961,16.961,0,0,1,0,7.08c0-2.146,0-4.4,0-6.544A16.962,16.962,0,0,0,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(6.544 24.696)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z",transform:"translate(13.088 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A52.526,52.526,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253A52.512,52.512,0,0,1,6.544,0C6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(19.632 7.209)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544C4.4,7.4,2.146,8.153,0,8.8,0,6.651,0,4.4,0,2.253A52.524,52.524,0,0,0,6.544,0C6.544,2.146,6.544,4.291,6.544,6.544Z",transform:"translate(13.088 16.006)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.544A52.52,52.52,0,0,0,0,8.8C0,6.651,0,4.4,0,2.253,2.146,1.395,4.4.644,6.544,0,6.544,2.253,6.544,4.4,6.544,6.544Z",transform:"translate(19.632 20.297)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.673A16.961,16.961,0,0,0,0,7.209V.665A16.961,16.961,0,0,1,6.544.128Z",transform:"translate(26.176 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z",transform:"translate(32.72 6.673)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,6.673A16.961,16.961,0,0,0,0,7.209C0,5.063,0,2.81,0,.665A16.961,16.961,0,0,1,6.544.128Z",transform:"translate(26.176 13.088)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M6.544,9.333A14.426,14.426,0,0,0,0,6.544V0A13.348,13.348,0,0,1,6.544,2.789Z",transform:"translate(32.72 19.761)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#231f20",opacity:"0.1",d:"M3.648,2.038A12.489,12.489,0,0,1,0,0C0,8.69,0,17.487,0,26.176a12.489,12.489,0,0,0,3.648,2.038Z",transform:"translate(1.931 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7058",d:"M2.038,51.494H1.717A1.7,1.7,0,0,1,0,49.778V1.717A1.7,1.7,0,0,1,1.717,0h.322A1.7,1.7,0,0,1,3.755,1.717V49.778A1.7,1.7,0,0,1,2.038,51.494Z",transform:"translate(0 0.021)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(11.101 21.098) rotate(-30)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f2f2f2",d:"M0,29.058c13.089-9.978,26.178,9.978,39.267,0,0-8.69,0-17.488,0-26.178C26.178,12.858,13.089-7.1,0,2.88,0,11.57,0,20.261,0,29.058Z",transform:"translate(0 0.038)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z",transform:"translate(32.722 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545a16.962,16.962,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(26.178 11.608)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A13.348,13.348,0,0,0,6.544,6.544c0-2.146,0-4.4,0-6.545A14.427,14.427,0,0,1,0,2.789C0,4.935,0,7.081,0,9.334Z",transform:"translate(32.722 16.007)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545a16.961,16.961,0,0,0,6.544.536c0-2.146,0-4.4,0-6.545A16.962,16.962,0,0,1,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(26.178 24.697)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.545A52.527,52.527,0,0,1,0,0C0,2.146,0,4.291,0,6.545Z",transform:"translate(19.633 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.545A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.544A52.517,52.517,0,0,0,0,0C0,2.253,0,4.4,0,6.545Z",transform:"translate(13.089 7.209)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.544C2.146,7.4,4.4,8.154,6.544,8.8c0-2.146,0-4.4,0-6.544A52.535,52.535,0,0,1,0,0C0,2.146,0,4.291,0,6.544Z",transform:"translate(19.633 16.007)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.544A52.527,52.527,0,0,1,6.545,8.8c0-2.146,0-4.4,0-6.545C4.4,1.395,2.146.644,0,0,0,2.253,0,4.4,0,6.544Z",transform:"translate(13.089 20.298)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.673a16.962,16.962,0,0,1,6.544.536V.665A16.962,16.962,0,0,0,0,.128Z",transform:"translate(6.544 0)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z",transform:"translate(0 6.673)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,6.673a16.962,16.962,0,0,1,6.544.536c0-2.146,0-4.4,0-6.545A16.961,16.961,0,0,0,0,.128Z",transform:"translate(6.544 13.089)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#40596b",d:"M0,9.334A14.427,14.427,0,0,1,6.544,6.544V0A13.348,13.348,0,0,0,0,2.789Z",transform:"translate(0 19.762)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#231f20",opacity:"0.1",d:"M0,2.038A12.49,12.49,0,0,0,3.648,0c0,8.69,0,17.488,0,26.178A12.49,12.49,0,0,1,0,28.216Z",transform:"translate(35.619 2.918)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ff7058",d:"M1.717,51.5h.322a1.7,1.7,0,0,0,1.717-1.717V1.717A1.7,1.7,0,0,0,2.038,0H1.717A1.7,1.7,0,0,0,0,1.717V49.781A1.7,1.7,0,0,0,1.717,51.5Z",transform:"translate(37.443 0.021)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#9792a1",d:"M152.363,387a3.009,3.009,0,0,0-3-3h-30a3.009,3.009,0,0,0-3,3v7.5h36Z",transform:"translate(-60.818 -334.501)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#7c7688",d:"M133.591,465.455a1.613,1.613,0,0,1,1.5,1.5v3a1.613,1.613,0,0,1-1.5,1.5h-39a1.613,1.613,0,0,1-1.5-1.5v-3a1.613,1.613,0,0,1,1.5-1.5Z",transform:"translate(-40.546 -405.456)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M194.046,317.141a1.417,1.417,0,0,1-1.5-1.5v-4.95a9.674,9.674,0,0,1-3,.45h-9a9.674,9.674,0,0,1-3-.45v4.95a1.417,1.417,0,0,1-1.5,1.5,1.417,1.417,0,0,0-1.5,1.5v1.5h21v-1.5A1.417,1.417,0,0,0,194.046,317.141Z",transform:"translate(-111.501 -270.642)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#787382",d:"M324.681,394.5V387a3.009,3.009,0,0,0-3-3h-7.5v10.5Z",transform:"translate(-233.136 -334.501)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M201.181,413.272h-12a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h12a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,201.181,413.272Z",transform:"translate(-121.636 -354.773)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(72.045 52.499)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M247.364,413.273h-3l3-6h3Z",transform:"translate(-244.364 -407.273)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M285.272,410.272a3.009,3.009,0,0,0-3-3l-3,6h3A3.009,3.009,0,0,0,285.272,410.272Z",transform:"translate(-274.772 -407.272)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#635d6e",d:"M133.592,465.455h-10.5v1.5a3.009,3.009,0,0,1-3,3h-24a1.417,1.417,0,0,1-1.5-1.5v-3a1.417,1.417,0,0,0-1.5,1.5v3a1.5,1.5,0,0,0,1.5,1.5h39a1.613,1.613,0,0,0,1.5-1.5v-3A1.613,1.613,0,0,0,133.592,465.455Z",transform:"translate(-40.547 -405.456)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffcb5b",d:"M186.932,360.727h4.5a.709.709,0,0,1,.75.75h0a.708.708,0,0,1-.75.75h-4.5a.708.708,0,0,1-.75-.75h0A.709.709,0,0,1,186.932,360.727Z",transform:"translate(-121.637 -314.228)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M60.045,93.819H56.6a7.036,7.036,0,0,1-5.25-2.25l-2.55-2.55a6.809,6.809,0,0,1-2.25-5.25v-9.45a4.42,4.42,0,0,1,4.5-4.5h7.5a1.5,1.5,0,0,1,0,3h-7.5a1.417,1.417,0,0,0-1.5,1.5v9.45a4.085,4.085,0,0,0,1.35,3.15l2.55,2.55a4.317,4.317,0,0,0,3.15,1.35h3.45a1.5,1.5,0,0,1,0,3Z",transform:"translate(0 -60.82)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M354.041,93.82h-3.45a1.5,1.5,0,1,1,0-3h3.45a4.085,4.085,0,0,0,3.15-1.35l2.55-2.55a4.317,4.317,0,0,0,1.35-3.15V74.32a1.417,1.417,0,0,0-1.5-1.5h-7.5a1.5,1.5,0,0,1,0-3h7.5a4.42,4.42,0,0,1,4.5,4.5v9.45a7.036,7.036,0,0,1-2.25,5.25l-2.55,2.55A6.809,6.809,0,0,1,354.041,93.82Z",transform:"translate(-263.546 -60.821)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(85.545 8.999)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M355.091,231.564c-.3,0-.6.15-1.05.15h-3.45a1.5,1.5,0,1,0,0,3h4.05a10.662,10.662,0,0,0,.45-3.15Z",transform:"translate(-349.091 -210.714)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M360.727,71.318a1.417,1.417,0,0,0,1.5,1.5h3v-3h-3A1.417,1.417,0,0,0,360.727,71.318Z",transform:"translate(-359.227 -69.818)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#ffca5d",d:"M159.136,81.045h-9a10.435,10.435,0,0,1-10.5-10.5v-24h30v24A10.435,10.435,0,0,1,159.136,81.045Z",transform:"translate(-81.091 -40.546)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(66.045 13.499)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M214.318,317.141a1.613,1.613,0,0,1-1.5-1.5v-4.95a9.673,9.673,0,0,1-3,.45h-9a9.674,9.674,0,0,1-3-.45v1.5a9.674,9.674,0,0,0,3,.45h4.5a3.009,3.009,0,0,1,3,3h0a1.5,1.5,0,0,0,1.5,1.5,1.417,1.417,0,0,1,1.5,1.5v1.5h4.5v-1.5A1.5,1.5,0,0,0,214.318,317.141Z",transform:"translate(-197.818 -284.141)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M455.319,105.477v6a.708.708,0,0,1-.75.75h0a.708.708,0,0,1-.75-.75v-6a.708.708,0,0,1,.75-.75h0A.709.709,0,0,1,455.319,105.477Z",transform:"translate(-420.819 -104.727)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(55.545 -0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M139.636,46.545v1.5h21a3.009,3.009,0,0,1,3,3v19.5c0,5.85-3.15,10.5-9,10.5h4.5a10.435,10.435,0,0,0,10.5-10.5v-24Z",transform:"translate(-136.636 -40.545)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f6b545",d:"M149.363,6h-30a3.009,3.009,0,0,1-3-3h0a3.009,3.009,0,0,1,3-3h30a3.009,3.009,0,0,1,3,3h0A3.009,3.009,0,0,1,149.363,6Z",transform:"translate(-116.363 0.001)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#f19920",d:"M149.364,0h0a3.009,3.009,0,0,1-3,3h-30a3.009,3.009,0,0,0,3,3h29.85a3.21,3.21,0,0,0,3.15-2.55A3.038,3.038,0,0,0,149.364,0Z",transform:"translate(-60.819 -0.001)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(61.545 10.499)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFE27A",d:"M164.409,93.455h0a1.417,1.417,0,0,1-1.5-1.5v-9a1.417,1.417,0,0,1,1.5-1.5h0a1.417,1.417,0,0,1,1.5,1.5v9A1.417,1.417,0,0,1,164.409,93.455Z",transform:"translate(-162.909 -81.455)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle",{fill:"#FFE27A",cx:"1.5",cy:"1.5",r:"1.5",transform:"translate(0 13.5)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#847f8e",d:"M119.363,384a3.009,3.009,0,0,0-3,3v7.5h3Z",transform:"translate(-60.818 -334.501)"}))));};

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Icons__ = __webpack_require__(121);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Icons__["s" /* LockIcon */],{isActive:props.value,onClick:function onClick(){return props.onClick(!props.value);}});});

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectColor__ = __webpack_require__(165);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n"],["\n  display: flex;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: 15px;\n  height: 15px;\n  margin: 5px;\n  padding: ","px;\n  border: ","px solid ",";\n  background-color: ","\n\n  :hover {\n    background-color: transparent;\n    border: 1px solid ",";\n    padding: 2px;\n  }\n"],["\n  width: 15px;\n  height: 15px;\n  margin: 5px;\n  padding: ","px;\n  border: ","px solid ",";\n  background-color: ","\n\n  :hover {\n    background-color: transparent;\n    border: 1px solid ",";\n    padding: 2px;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"],["\n  width: 100%;\n  height: 100%;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Color=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.active?2:0;},function(props){return props.active?1:0;},function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.active?"transparent":props.color;},function(_ref2){var theme=_ref2.theme;return theme.foreground;});var InnerColor=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var ColorGrid=function ColorGrid(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_2__SelectColor__["a" /* COLORS */].map(function(color,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Color,{key:index,color:color,onClick:function onClick(){return props.onChange(color);},active:props.value===color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InnerColor,{style:{backgroundColor:color}}));}));};/* harmony default export */ __webpack_exports__["a"] = (ColorGrid);

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SelectWidth__ = __webpack_require__(166);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-around;\n  margin: 8px auto;\n"],["\n  display: flex;\n  justify-content: space-around;\n  margin: 8px auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  height: 24px;\n  width: 60px;\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  padding: 4px;\n\n  :hover {\n    border: 1px solid;\n    border-color: ",";\n  }\n"],["\n  height: 24px;\n  width: 60px;\n  display: flex;\n  align-items: center;\n  border-radius: 5px;\n  padding: 4px;\n\n  :hover {\n    border: 1px solid;\n    border-color: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n width: 100%;\n height: ","px;\n background-color: ",";\n margin: auto;\n border-radius: 5px;\n"],["\n width: 100%;\n height: ","px;\n background-color: ",";\n margin: auto;\n border-radius: 5px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var CoolTool=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.active?"#aaa":"#666";});var CoolToolMool=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.width;},function(props){return props.color;});var ThicknessGrid=function ThicknessGrid(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_2__SelectWidth__["a" /* WIDTHS */].map(function(width,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CoolTool,{key:index,onClick:function onClick(){return props.onChange(width);},active:props.value===width},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CoolToolMool,{color:props.value===width?props.color:"grey",width:width}));}));};/* harmony default export */ __webpack_exports__["a"] = (ThicknessGrid);

/***/ }),
/* 1750 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/candle-arrow.25f73938.svg";

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ForexIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ForexOtcIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return IndexesIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MetalsIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CommoditiesIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return StocksIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PopularStocksIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CryptosIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var ForexIcon=function ForexIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 22 22",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19.011,13.066 C18.827,12.502 18.577,11.970 18.277,11.469 C18.729,11.440 19.168,11.228 19.168,10.740 C19.168,10.429 18.985,10.187 18.664,10.187 C18.526,10.187 18.168,10.282 18.021,10.282 C17.766,10.282 17.551,10.227 17.309,10.178 C17.060,9.908 16.797,9.648 16.513,9.415 C16.568,9.280 16.602,9.142 16.602,9.002 C16.602,8.924 16.585,8.864 16.558,8.795 L17.246,8.795 C17.603,8.795 17.785,8.665 17.785,8.380 C17.785,8.095 17.602,7.965 17.246,7.965 L16.297,7.965 C16.158,7.705 16.011,7.411 16.011,7.117 C16.011,6.556 16.498,6.253 17.011,6.253 C18.185,6.253 17.716,7.308 18.481,7.308 C18.864,7.308 19.133,7.092 19.133,6.702 C19.133,6.028 18.395,5.215 16.872,5.215 C15.645,5.215 14.688,5.967 14.688,7.039 C14.688,7.376 14.767,7.705 14.949,7.964 L14.767,7.964 C14.578,7.964 14.458,8.048 14.400,8.182 C13.518,7.834 12.560,7.637 11.556,7.629 C11.910,5.084 14.107,3.115 16.763,3.115 C19.664,3.115 22.024,5.461 22.025,8.345 C22.025,10.429 20.789,12.226 19.011,13.066 ZM18.079,15.472 C18.079,19.077 15.128,22.010 11.501,22.010 C7.875,22.010 4.924,19.077 4.924,15.472 C4.924,11.867 7.875,8.934 11.501,8.934 C15.128,8.934 18.079,11.867 18.079,15.472 ZM13.751,13.792 C14.121,13.792 14.437,13.544 14.437,13.123 C14.437,12.063 12.697,11.534 11.850,11.512 L11.850,10.936 C11.850,10.752 11.707,10.568 11.523,10.568 C11.338,10.568 11.197,10.752 11.197,10.936 L11.197,11.512 C9.838,11.555 8.609,12.312 8.609,13.782 C8.609,14.982 9.586,15.684 11.197,15.976 L11.197,18.235 C9.391,18.160 10.337,16.668 9.120,16.668 C8.706,16.668 8.446,16.917 8.446,17.348 C8.446,18.202 9.360,19.295 11.197,19.338 L11.197,20.008 C11.197,20.192 11.338,20.376 11.523,20.376 C11.707,20.376 11.850,20.192 11.850,20.008 L11.850,19.338 C13.469,19.241 14.557,18.506 14.557,17.058 C14.557,15.392 13.286,14.971 11.850,14.668 L11.850,12.615 C13.054,12.636 13.044,13.792 13.751,13.792 ZM9.979,13.533 C9.979,13.068 10.457,12.636 11.197,12.615 L11.197,14.549 C10.382,14.387 9.979,14.074 9.979,13.533 ZM13.188,17.175 C13.188,17.889 12.502,18.192 11.850,18.235 L11.850,16.095 C12.436,16.225 13.188,16.440 13.188,17.175 ZM5.143,10.844 C2.766,10.341 0.978,8.240 0.978,5.731 C0.978,2.846 3.339,0.500 6.239,0.500 C8.752,0.500 10.857,2.261 11.376,4.607 C10.738,5.511 10.324,6.581 10.217,7.740 C8.141,8.080 6.338,9.225 5.143,10.844 ZM7.996,2.600 C7.631,2.600 7.467,2.885 7.405,3.006 L6.240,5.212 L5.074,3.006 C5.013,2.885 4.848,2.600 4.482,2.600 C4.178,2.600 3.735,2.755 3.735,3.231 C3.735,3.352 3.795,3.482 3.856,3.586 L5.004,5.462 L4.473,5.462 C4.281,5.462 4.135,5.609 4.135,5.799 C4.135,5.990 4.281,6.136 4.473,6.136 L5.405,6.136 L5.553,6.387 L5.553,6.638 L4.473,6.638 C4.281,6.638 4.135,6.785 4.135,6.975 C4.135,7.166 4.281,7.313 4.473,7.313 L5.553,7.313 L5.553,8.168 C5.553,8.584 5.805,8.860 6.240,8.860 C6.674,8.860 6.926,8.584 6.926,8.168 L6.926,7.313 L8.005,7.313 C8.196,7.313 8.344,7.166 8.344,6.975 C8.344,6.785 8.196,6.638 8.005,6.638 L6.926,6.638 L6.926,6.387 L7.074,6.136 L8.005,6.136 C8.196,6.136 8.343,5.990 8.343,5.799 C8.343,5.609 8.196,5.462 8.005,5.462 L7.474,5.462 L8.623,3.585 C8.683,3.482 8.744,3.352 8.744,3.231 C8.744,2.756 8.301,2.600 7.996,2.600 Z"}));};var ForexOtcIcon=function ForexOtcIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 20 12",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.066,6.649a2.611,2.611,0,0,0-.638-1.8A2.112,2.112,0,0,0,5.772,4.13a2.077,2.077,0,0,0-1.639.716,2.633,2.633,0,0,0-.633,1.8v.623a2.622,2.622,0,0,0,.631,1.806,2.086,2.086,0,0,0,1.641.713A2.111,2.111,0,0,0,7.43,9.078a2.613,2.613,0,0,0,.636-1.806Zm-1.1.632a1.951,1.951,0,0,1-.315,1.152,1.016,1.016,0,0,1-.879.445A1,1,0,0,1,4.9,8.433a1.968,1.968,0,0,1-.3-1.155V6.641A1.963,1.963,0,0,1,4.9,5.5a.994.994,0,0,1,.867-.443,1.022,1.022,0,0,1,.879.445,1.911,1.911,0,0,1,.319,1.14v.637Zm5.613-3.066H8.4v.914H9.94V9.706h1.1V5.129h1.547V4.212Zm3.552,3.474a1.382,1.382,0,0,1-.246.89.924.924,0,0,1-.76.3.954.954,0,0,1-.822-.434A1.9,1.9,0,0,1,14,7.327V6.583a1.956,1.956,0,0,1,.289-1.105.894.894,0,0,1,.781-.434.988.988,0,0,1,.807.312,1.38,1.38,0,0,1,.259.9H17.2l.008-.025a2.023,2.023,0,0,0-.551-1.534,2.152,2.152,0,0,0-1.584-.565,1.968,1.968,0,0,0-1.562.693,2.611,2.611,0,0,0-.6,1.773v.733A2.562,2.562,0,0,0,13.527,9.1a2.048,2.048,0,0,0,1.6.689,2.057,2.057,0,0,0,1.537-.562,2.027,2.027,0,0,0,.539-1.52l0-.025H16.135ZM1.112.963H18.883a1.072,1.072,0,0,1,.79.354A1.265,1.265,0,0,1,20,2.174v9.579a1.166,1.166,0,0,1-1.115,1.211H1.112A1.166,1.166,0,0,1,0,11.752V2.174A1.166,1.166,0,0,1,1.112.963Z"}));};var IndexesIcon=function IndexesIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 1 19 18",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19,9.424v7.034A1.545,1.545,0,0,1,17.452,18H1.544A1.545,1.545,0,0,1,0,16.457V9.424l7.809,1.883v1.961a0.522,0.522,0,0,0,.522.521h2.334a0.522,0.522,0,0,0,.522-0.521V11.307Zm0-3.753v2.68l-7.809,1.883V10.086a0.522,0.522,0,0,0-.522-0.522H8.331a0.522,0.522,0,0,0-.522.522v0.148L0,8.351V5.671A1.545,1.545,0,0,1,1.544,4.128H5.662V2.99A2.22,2.22,0,0,1,7.88.773h3.236A2.22,2.22,0,0,1,13.334,2.99V4.128h4.118A1.545,1.545,0,0,1,19,5.671ZM6.705,4.128H12.29V2.99a1.175,1.175,0,0,0-1.174-1.174H7.88A1.175,1.175,0,0,0,6.705,2.99V4.128Z"}));};var MetalsIcon=function MetalsIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 23 12",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5.12,7.959h5.792a0.216,0.216,0,0,0,.2-0.306l-0.993-2.54a0.215,0.215,0,0,0-.2-0.143H6.119a0.215,0.215,0,0,0-.2.143l-1,2.558A0.216,0.216,0,0,0,5.12,7.959Zm7.768-2.846-1,2.558a0.216,0.216,0,0,0,.2.288h5.792a0.216,0.216,0,0,0,.2-0.306l-0.993-2.54a0.216,0.216,0,0,0-.2-0.143H13.091A0.216,0.216,0,0,0,12.888,5.112ZM6.17,9.085a0.216,0.216,0,0,0-.2-0.143H2.174a0.215,0.215,0,0,0-.2.143l-1,2.621a0.216,0.216,0,0,0,.2.288H6.967a0.216,0.216,0,0,0,.2-0.306Zm15.847,2.6-0.993-2.6a0.216,0.216,0,0,0-.2-0.143H17.029a0.216,0.216,0,0,0-.2.143l-1,2.621a0.216,0.216,0,0,0,.2.288h5.792A0.216,0.216,0,0,0,22.017,11.687Zm-8.389-2.6a0.216,0.216,0,0,0-.2-0.143H9.633a0.215,0.215,0,0,0-.2.143l-1,2.621a0.216,0.216,0,0,0,.2.288h5.792a0.216,0.216,0,0,0,.2-0.306Zm-5-5.074h5.792a0.216,0.216,0,0,0,.2-0.306L13.628,1.1a0.216,0.216,0,0,0-.2-0.143H9.633a0.216,0.216,0,0,0-.2.143l-1,2.621A0.216,0.216,0,0,0,8.633,4.01Z"}));};var CommoditiesIcon=function CommoditiesIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 18 18",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M16.394,0.93h-4.8A4.453,4.453,0,0,0,8.861,2.061L1.425,9.5a1.605,1.605,0,0,0,0,2.263L7.163,17.5a1.6,1.6,0,0,0,2.263,0l7.436-7.436a4.453,4.453,0,0,0,1.131-2.732V2.53A1.6,1.6,0,0,0,16.394.93ZM14.267,6.253a1.6,1.6,0,1,1,1.6-1.6A1.6,1.6,0,0,1,14.267,6.253Z"}));};var StocksIcon=function StocksIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 19 17",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M12.06,12.581V16.54a0.2,0.2,0,0,0,.106.177,0.2,0.2,0,0,0,.206-0.01l1.285-.857a0.468,0.468,0,0,1,.52,0l1.285,0.857a0.2,0.2,0,0,0,.206.01,0.2,0.2,0,0,0,.106-0.177V12.581A3.567,3.567,0,0,1,12.06,12.581ZM17.329,0.015H1.673A1.674,1.674,0,0,0,0,1.688V13.328A1.675,1.675,0,0,0,1.673,15h9.45V11.755a3.579,3.579,0,1,1,5.586,0V15h0.619A1.675,1.675,0,0,0,19,13.328V1.688A1.674,1.674,0,0,0,17.329.015ZM8.436,9.04H2.5a0.535,0.535,0,1,1,0-1.07H8.436A0.535,0.535,0,1,1,8.436,9.04Zm0-1.989H2.5a0.535,0.535,0,1,1,0-1.07H8.436A0.535,0.535,0,1,1,8.436,7.051ZM16.53,4H2.5a0.535,0.535,0,1,1,0-1.07H16.53A0.535,0.535,0,1,1,16.53,4ZM13.917,7.21a2.305,2.305,0,1,0,2.3,2.305A2.3,2.3,0,0,0,13.917,7.21ZM8.436,11.04H2.5a0.535,0.535,0,1,1,0-1.07H8.436A0.535,0.535,0,1,1,8.436,11.04Zm0,1.969H2.5a0.535,0.535,0,1,1,0-1.07H8.436A0.535,0.535,0,1,1,8.436,13.009Z"}));};var PopularStocksIcon=function PopularStocksIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 20 20",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm6.506,8.246-3.531,2.746,1.177,4.316a.416.416,0,0,1-.632.456L10,13.418,6.481,15.763a.416.416,0,0,1-.633-.456l1.177-4.316L3.494,8.246A.417.417,0,0,1,3.75,7.5h4.3L9.613,3.595a.434.434,0,0,1,.774,0L11.948,7.5h4.3a.417.417,0,0,1,.256.746Z"}));};var CryptosIcon=function CryptosIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"20",height:"20",viewBox:"0 0 20 20"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M3.98,13.922A6.078,6.078,0,1,1,10.058,20,6.085,6.085,0,0,1,3.98,13.922Zm5.659-3.95-.1.2-.257.515c-.121.242-.243.485-.365.728l-.418.839-.423.846-.375.751-.275.549a.871.871,0,0,0-.158.564.914.914,0,0,0,.245.378l.191.228.586.7.655.786.534.641.22.265a.467.467,0,0,0,.718,0l.113-.137.308-.368c.143-.171.284-.343.428-.514.158-.191.319-.383.478-.572s.3-.364.453-.545c.12-.143.238-.285.357-.429a1.082,1.082,0,0,0,.3-.459.1.1,0,0,0,0-.018.574.574,0,0,0-.071-.333c-.043-.087-.088-.175-.131-.262l-.213-.427c-.091-.183-.183-.365-.274-.547q-.155-.312-.311-.623l-.326-.653-.318-.635c-.1-.191-.192-.382-.287-.573l-.233-.466-.157-.313c-.02-.039-.038-.076-.059-.115a.487.487,0,0,0-.835,0ZM8.491,15.053l1.567-.626,1.566.626-1.566,1.88Zm1.74-1.564a.467.467,0,0,0-.347,0l-1.2.478,1.37-2.739,1.369,2.739ZM17.052,12h0a7.194,7.194,0,0,0-.935-2.057,1.524,1.524,0,0,0,.274-2.5A1.525,1.525,0,0,0,15.769,4.8V4.361a.384.384,0,1,0-.769,0v.384h-.769V4.361a.385.385,0,1,0-.77,0v.384a.385.385,0,0,0-.384.385v2.2a7.174,7.174,0,0,0-3.019-.658A5,5,0,1,1,17.053,12ZM4.021,9.9a5,5,0,1,1,5.69-3.227,7.208,7.208,0,0,0-2.465.559,1.532,1.532,0,0,0-.931-2.6,1.506,1.506,0,0,0,.223-.785,1.538,1.538,0,1,0-3.076,0,1.5,1.5,0,0,0,.223.785A1.534,1.534,0,1,0,5,7.161a1.533,1.533,0,0,0,1.154.531,1.591,1.591,0,0,0,.218-.015A7.346,7.346,0,0,0,4.022,9.9Zm11.633-.592h0a7.291,7.291,0,0,0-1.674-1.489h1.406a.769.769,0,0,1,.27,1.49ZM13.847,7.052V5.514h1.538a.769.769,0,1,1,0,1.538Zm-8.462-.9a.77.77,0,1,1,.769.77A.771.771,0,0,1,5.385,6.154Zm-2.308,0a.77.77,0,1,1,.77.77A.771.771,0,0,1,3.077,6.154ZM4.231,3.847A.769.769,0,1,1,5,4.615.771.771,0,0,1,4.231,3.847Z",fill:"currentColor"}));};

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatTime__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Deal__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n"],["\n  font-size: ",";\n  color: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 16px;\n  height: 16px;\n  margin: 0px;\n  padding: 0px;\n  line-height: 0;\n  color: #95989A;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  pointer-events: auto;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: absolute;\n  top: 7px;\n  right: 7px;\n  width: 16px;\n  height: 16px;\n  margin: 0px;\n  padding: 0px;\n  line-height: 0;\n  color: #95989A;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  pointer-events: auto;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  text-align: right;\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n"],["\n  text-align: right;\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: inline-block;\n  height: 17px;\n  margin-left: -5px;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: ",";\n  line-height: 17px;\n  text-transform: lowercase;\n  color: ",";\n  background-color: transparent;\n\n  :hover {\n    background-color: ",";\n  }\n"],["\n  display: inline-block;\n  height: 17px;\n  margin-left: -5px;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: ",";\n  line-height: 17px;\n  text-transform: lowercase;\n  color: ",";\n  background-color: transparent;\n\n  :hover {\n    background-color: ",";\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  height: 100%;\n  width: 100%;\n  max-width: 174px;\n  margin-right: 1px;\n  padding: 8px 15px;\n  color: ",";\n  border-right: 1px solid ",";\n  background-color: ",";\n  background-image: linear-gradient(\n    45deg,\n    "," 0%,\n    "," 100%\n  );\n  background-repeat: no-repeat;\n  background-position: right top;\n  cursor: pointer;\n  ",";\n\n  :first-of-type {\n    border-left: 1px solid ",";\n  }\n\n  :hover {\n    background: ",";\n    ",";\n    "," {\n      color: ",";\n    }\n  }\n\n  ",";\n"],["\n  position: relative;\n  display: block;\n  height: 100%;\n  width: 100%;\n  max-width: 174px;\n  margin-right: 1px;\n  padding: 8px 15px;\n  color: ",";\n  border-right: 1px solid ",";\n  background-color: ",";\n  background-image: linear-gradient(\n    45deg,\n    "," 0%,\n    "," 100%\n  );\n  background-repeat: no-repeat;\n  background-position: right top;\n  cursor: pointer;\n  ",";\n\n  :first-of-type {\n    border-left: 1px solid ",";\n  }\n\n  :hover {\n    background: ",";\n    ",";\n    "," {\n      color: ",";\n    }\n  }\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      color: #ffffff;\n      background-color: rgba(0, 0, 0, 0.25);\n      background-image: none;\n      border: none !important;\n      border-radius: 4px 4px 0 0;\n      \n      "," {\n        color: ",";\n      }\n    "],["\n      color: #ffffff;\n      background-color: rgba(0, 0, 0, 0.25);\n      background-image: none;\n      border: none !important;\n      border-radius: 4px 4px 0 0;\n      \n      "," {\n        color: ",";\n      }\n    "]),_templateObject7=_taggedTemplateLiteral(["\n        color: ",";\n        "," {\n          color: ",";\n        }\n      "],["\n        color: ",";\n        "," {\n          color: ",";\n        }\n      "]),_templateObject8=_taggedTemplateLiteral(["\n      background-color: ",";\n      background-image: linear-gradient(\n        45deg,\n        "," 0%,\n        "," 100%\n      );\n      box-shadow: inset 0px -2px 0px 0px ",";\n      \n      ",";\n      "," {\n        color: ",";\n      }\n      "," {\n        color: ",";\n      }\n    "],["\n      background-color: ",";\n      background-image: linear-gradient(\n        45deg,\n        "," 0%,\n        "," 100%\n      );\n      box-shadow: inset 0px -2px 0px 0px ",";\n      \n      ",";\n      "," {\n        color: ",";\n      }\n      "," {\n        color: ",";\n      }\n    "]),_templateObject9=_taggedTemplateLiteral(["\n        box-shadow: none;\n      "],["\n        box-shadow: none;\n      "]),_templateObject10=_taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  height: 100%;\n"],["\n  display: table;\n  width: 100%;\n  height: 100%;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n"],["\n  display: table-cell;\n  vertical-align: middle;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  width: 100%;\n  margin: 3px 0;\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  align-content: space-between;\n  justify-content: space-between;\n  width: 100%;\n  margin: 3px 0;\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject14=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 74px;\n  left: -1px;\n  z-index: 110;\n"],["\n  position: absolute;\n  top: 74px;\n  left: -1px;\n  z-index: 110;\n"]),_templateObject15=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n"],["\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n"]),_templateObject16=_taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: auto;\n  opacity: 0.5;\n  cursor: default;\n\n  :hover {\n    opacity: 1;\n  }\n"],["\n  display: inline-block;\n  margin-left: auto;\n  opacity: 0.5;\n  cursor: default;\n\n  :hover {\n    opacity: 1;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Time=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12,12),function(props){return props.theme.alternativeAccent;});// const ProgressContainer = styled.div`
//   position: absolute;
//   bottom: 0px;
//   left: 0px;
//   width: 100%;
//   height: 4px;
//   background-color: ${props => props.theme.mainLight};
// `;
//
// const Progress = styled.div`
//   height: 4px;
//   width: 0%;
//   background-color: ${props => props.theme.accent};
//   transition: all 0.1s ease;
// `;
var CloseButtonView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject2,function(_ref){var theme=_ref.theme;return theme.foreground;});var TabPercentTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14,14),function(props){return props.theme.isIntlProjectLight?"#ffffff":props.theme.accent;});var Deals=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12),function(_ref2){var theme=_ref2.theme;return theme.lightWhiteForeground;},function(_ref3){var theme=_ref3.theme;return theme.main;});var TabView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref4){var theme=_ref4.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.foreground,0.5);},function(props){return props.theme.mainSeparator;},function(props){return props.theme.mainDark;},function(props){return props.theme.mainDark;},function(props){return props.theme.main;},function(_ref5){var theme=_ref5.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,TabPercentTitle,function(_ref6){var theme=_ref6.theme;return theme.alternativeForeground;});},function(props){return props.theme.mainSeparator;},function(props){return props.theme.mainLight;},function(_ref7){var theme=_ref7.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject7,function(_ref8){var theme=_ref8.theme;return theme.foreground;},TabPercentTitle,function(_ref9){var theme=_ref9.theme;return theme.alternativeForeground;});},Deals,function(_ref10){var theme=_ref10.theme;return theme.alternativeForeground;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject8,function(props){return props.theme.mainLight;},function(props){return props.theme.mainLight;},function(props){return props.theme.main;},function(props){return props.theme.accent;},function(_ref11){var theme=_ref11.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject9);},TabPercentTitle,function(_ref12){var theme=_ref12.theme;return theme.foreground;},Deals,function(_ref13){var theme=_ref13.theme;return theme.alternativeForeground;});});var TableContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var TableCell=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var TabTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13,function(_ref14){var theme=_ref14.theme;return theme.foreground;});});var VerticalTabs=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(14,14));var Disabled=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16);function CloseButton(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButtonView,props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 24 24",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"})));}var Tab=function(_Component){_inherits(Tab,_Component);function Tab(){var _ref15;var _temp,_this,_ret;_classCallCheck(this,Tab);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref15=Tab.__proto__||Object.getPrototypeOf(Tab)).call.apply(_ref15,[this].concat(args))),_this),_this.state={isOpen:false},_this.open=function(){_this.setState({isOpen:true});},_this.close=function(){_this.setState({isOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tab,[{key:"render",value:function render(){var _this2=this;if(typeof this.props.stock==="undefined"||typeof this.props.activeAccount==="undefined"){return null;}var hasActiveDeals=this.props.deals.length>0;var currentPoint=Array.isArray(this.props.points)?this.props.points[this.props.points.length-1]:null;var endDate=hasActiveDeals?this.props.deals[0].timestamp*1000:0;var endDuration=hasActiveDeals?this.props.deals[0].bTime*1000:0;var endTime=hasActiveDeals?this.props.deals.reduce(function(value,deal){var date=deal.timestamp*1000;var duration=deal.bTime*1000;return Math.min(value,date+duration);},endDate+endDuration):0;var profit=void 0;if(this.props.tradeMode==="tournament"){profit=this.props.stock.realProfit-this.props.stock.profit_vip;}else{profit=this.props.activeAccount.type==="real"?this.props.stock.realProfit:this.props.stock.demoProfit;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabView,{onMouseLeave:this.close,onClick:this.props.onClick,active:this.props.isActive,enabled:this.props.stock.enabled},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TableCell,null,hasActiveDeals&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Time,null,Object(__WEBPACK_IMPORTED_MODULE_3__formatTime__["a" /* default */])(endTime-this.props.time)),this.props.shouldShowCloseButton===true&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:this.props.onRemoveClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabTitle,{active:this.props.isActive},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,this.props.stock.stock.replace("_OTC",""),this.props.stock.stock.endsWith("_OTC")&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Trade_StockClose__["b" /* OtcImage */],{tab:true},"OTC")),this.props.stock.enabled?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabPercentTitle,{green:this.props.activeAccount.type==="real"&&this.props.tradeMode==="binary"},profit,"%"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Disabled,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",height:"16",width:"16",viewBox:"0 0 24 24",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M0 0h24v24H0z",fill:"none"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"})))),hasActiveDeals&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Deals,{onMouseEnter:this.open,key:1},this.props.deals.length," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Deals"))// ,
// <ProgressContainer key={2}>
//   <Progress style={{ width: `${0}%` }} />
// </ProgressContainer>
,hasActiveDeals&&currentPoint&&this.state.isOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VerticalTabs,null,this.props.deals.map(function(deal,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Deal__["a" /* default */],Object.assign({key:i},deal,{currentPoint:currentPoint,tradeMode:_this2.props.tradeMode}));})))));}}]);return Tab;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 1753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatTime__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__ = __webpack_require__(39);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  width: 174px;\n  height: 71px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: ",";\n  border-bottom: 1px dashed ",";\n  background-color: ",";\n  background-repeat: no-repeat;\n  background-position: 100% 0;\n"],["\n  position: relative;\n  width: 174px;\n  height: 71px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  padding-left: 15px;\n  padding-right: 15px;\n  color: ",";\n  border-bottom: 1px dashed ",";\n  background-color: ",";\n  background-repeat: no-repeat;\n  background-position: 100% 0;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: table-cell;\n"],["\n  display: table-cell;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n"],["\n  display: table;\n  width: 100%;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  height: 100%;\n"],["\n  display: table;\n  width: 100%;\n  height: 100%;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n"],["\n  display: table-cell;\n  vertical-align: middle;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  padding-bottom: 2px;\n"],["\n  padding-bottom: 2px;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: ",";\n"],["\n  font-size: ",";\n  color: ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: table-cell;\n  font-size: ",";\n  text-transform: uppercase;\n"],["\n  display: table-cell;\n  font-size: ",";\n  text-transform: uppercase;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: table-cell;\n  font-size: ",";\n  font-weight: 700;\n  text-align: right;\n  color: ",";\n"],["\n  display: table-cell;\n  font-size: ",";\n  font-weight: 700;\n  text-align: right;\n  color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: table;\n  width: 100%;\n  padding-top: 5px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n"],["\n  display: table;\n  width: 100%;\n  padding-top: 5px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: top;\n"],["\n  display: table-cell;\n  vertical-align: top;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  width: 9px;\n  height: 7px;\n  margin-right: 4px;\n  line-height: 0;\n  color: #60a31c;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  width: 9px;\n  height: 7px;\n  margin-right: 4px;\n  line-height: 0;\n  color: #60a31c;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  color: ",";\n"]),_templateObject14=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: top;\n  padding-top: 1px;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: right;\n  color: ",";\n"],["\n  display: table-cell;\n  vertical-align: top;\n  padding-top: 1px;\n  font-weight: inherit;\n  font-size: inherit;\n  line-height: inherit;\n  text-align: right;\n  color: ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  height: 4px;\n  background-color: ",";\n"],["\n  position: absolute;\n  bottom: 0px;\n  left: 0px;\n  width: 100%;\n  height: 4px;\n  background-color: ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n  height: 4px;\n  width: 0%;\n  background-color: ",";\n  transition: all 0.1s ease;\n"],["\n  height: 4px;\n  width: 0%;\n  background-color: ",";\n  transition: all 0.1s ease;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Tab=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.theme.mainSeparator;},function(props){return props.theme.mainDark;});// prettier-ignore
var TabTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var TableContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var TableCell=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);// prettier-ignore
var TimeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var Time=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?"12px":"12px";},function(props){return props.theme.accent;});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?"14px":"14px";});var Bet=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject9,function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?"14px":"14px";},function(props){return props.win?"#60a31c":"#e74c3c";});var BetCount=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10,function(_ref5){var theme=_ref5.theme;return theme.locale==="ar"?"12px":"12px";});var DealTypeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var BetDirection=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var BetDirectionText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13,function(_ref6){var theme=_ref6.theme;return theme.foreground;});var BetCountText=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14,function(_ref7){var theme=_ref7.theme;return theme.foreground;});var ProgressContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject15,function(props){return props.theme.mainLight;});var Progress=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject16,function(props){return props.theme.accent;});function UpIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 9 7",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M4.5,0.494L0.779,6.921H8.226L4.5,0.494"}));}function DownIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",version:"1.1",viewBox:"0 0 9 7",fill:"#e74c3c"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M4.5,7.384L0.779,0.958H8.226L4.5,7.384"}));}function ProgressBar(props){var barWidth=Math.round(props.value*10000)/100;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProgressContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Progress,{style:{width:barWidth+"%"}}));}function Deal(props){var point=props.currentPoint;var now=point.date;var beginTime=parseInt(props.timestamp,10)*1000;var endTime=beginTime+props.bTime*1000;var progress=(now-beginTime)/(props.bTime*1000);var profit=props.amount*parseInt(props.percent||0,10)/100;var isWinning=props.bidType?props.value<=point.value:props.value>=point.value;var resultingAmount=isWinning?"+"+profit:"-"+props.amount;if(props.value===point.value){resultingAmount=0;}var stock=props.stock.substr(0,props.stock.length>6?6:props.stock.length);var currency=props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__["b" /* tournamentCurrency */]:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TableCell,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Time,null,Object(__WEBPACK_IMPORTED_MODULE_3__formatTime__["a" /* default */])(endTime-now))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Line,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabTitle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,stock)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bet,{win:isWinning},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:currency},resultingAmount))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetCount,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealTypeContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetDirection,null,props.bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](UpIcon,null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DownIcon,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetDirectionText,null,props.bidType?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Upper"):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"lower"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BetCountText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */],{currency:currency},props.amount))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProgressBar,{value:progress}))));}/* harmony default export */ __webpack_exports__["a"] = (Deal);

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 83px;\n  height: 47px;\n  margin-right: 20px;\n  margin-left: 3px;\n  color: #fff;\n"],["\n  position: relative;\n  top: 1px;\n  display: inline-block;\n  vertical-align: middle;\n  width: 83px;\n  height: 47px;\n  margin-right: 20px;\n  margin-left: 3px;\n  color: #fff;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var LogoView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LogoView,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeConsumer */],null,function(theme){return theme.logo;}));};/* harmony default export */ __webpack_exports__["a"] = (Logo);

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  vertical-align: middle;\n  min-height: 47px;\n  margin-left: 10px;\n  padding: 0 17px;\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n\n  ",";\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-shrink: 0;\n    flex-grow: 0;\n    align-self: center;\n    min-width: 0;\n    min-height: 30px;\n    font-size: 16px;\n    border-radius: 4px;\n  }\n\n  @media (max-width: 479px) {\n    min-width: 40px;\n    padding: 0 7px;\n    color: #fff;\n  }\n\n  @media (max-width: 425px) {\n    min-width: 34px;\n  }\n"],["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  vertical-align: middle;\n  min-height: 47px;\n  margin-left: 10px;\n  padding: 0 17px;\n  font-weight: 700;\n  font-size: 18px;\n  color: ",";\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n\n  ",";\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-shrink: 0;\n    flex-grow: 0;\n    align-self: center;\n    min-width: 0;\n    min-height: 30px;\n    font-size: 16px;\n    border-radius: 4px;\n  }\n\n  @media (max-width: 479px) {\n    min-width: 40px;\n    padding: 0 7px;\n    color: #fff;\n  }\n\n  @media (max-width: 425px) {\n    min-width: 34px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n          color: #99959d;\n          border: 2px solid #99959d;\n          cursor: auto;\n          pointer-events: none;\n        "],["\n          color: #99959d;\n          border: 2px solid #99959d;\n          cursor: auto;\n          pointer-events: none;\n        "]),_templateObject3=_taggedTemplateLiteral(["\n        background: none;\n        border: 2px solid #ffffff;\n        box-shadow: none;\n        text-shadow: none;\n        color: #ffffff;\n        transition: 0.3s all;\n\n        :hover,\n        :focus,\n        :active {\n          color: #1b546a;\n          background: #ffffff;\n          box-shadow: none;\n          text-shadow: none;\n        }\n      "],["\n        background: none;\n        border: 2px solid #ffffff;\n        box-shadow: none;\n        text-shadow: none;\n        color: #ffffff;\n        transition: 0.3s all;\n\n        :hover,\n        :focus,\n        :active {\n          color: #1b546a;\n          background: #ffffff;\n          box-shadow: none;\n          text-shadow: none;\n        }\n      "]),_templateObject4=_taggedTemplateLiteral(["\n        border-bottom: 2px solid #7a7c8a;\n        box-shadow: inset 0px -1px 0px 0px #bcbfce;\n        background-color: #a5a7b4;\n        background: linear-gradient(to top, #a5a7b4, #bdc0cf);\n        cursor: default;\n        pointer-events: none;\n\n        ",";\n      "],["\n        border-bottom: 2px solid #7a7c8a;\n        box-shadow: inset 0px -1px 0px 0px #bcbfce;\n        background-color: #a5a7b4;\n        background: linear-gradient(to top, #a5a7b4, #bdc0cf);\n        cursor: default;\n        pointer-events: none;\n\n        ",";\n      "]),_templateObject5=_taggedTemplateLiteral(["\n            color: #99959d;\n            background: none;\n            border: 2px solid #99959d;\n            box-shadow: none;\n            text-shadow: none;\n          "],["\n            color: #99959d;\n            background: none;\n            border: 2px solid #99959d;\n            box-shadow: none;\n            text-shadow: none;\n          "]),_templateObject6=_taggedTemplateLiteral(["\n        color: #fff;\n        text-shadow: -1px -1px #56a008;\n        border-bottom: 2px solid ",";\n        box-shadow: inset 0px -1px 0px 0px ",";\n        background-color: ",";\n        background: linear-gradient(\n          to top,\n          ",",\n          ","\n        );\n\n        ",";\n\n        :hover,\n        :focus,\n        :active {\n          background-color: ",";\n          background: linear-gradient(\n            to top,\n            ",",\n            ","\n          );\n\n          ",";\n        }\n        ",";\n      "],["\n        color: #fff;\n        text-shadow: -1px -1px #56a008;\n        border-bottom: 2px solid ",";\n        box-shadow: inset 0px -1px 0px 0px ",";\n        background-color: ",";\n        background: linear-gradient(\n          to top,\n          ",",\n          ","\n        );\n\n        ",";\n\n        :hover,\n        :focus,\n        :active {\n          background-color: ",";\n          background: linear-gradient(\n            to top,\n            ",",\n            ","\n          );\n\n          ",";\n        }\n        ",";\n      "]),_templateObject7=_taggedTemplateLiteral(["\n            box-shadow: inset 0px -1px 0px 0px ",";\n          "],["\n            box-shadow: inset 0px -1px 0px 0px ",";\n          "]),_templateObject8=_taggedTemplateLiteral(["\n              box-shadow: inset 0px -1px 0px 0px rgba(99, 191, 0, 1);\n            "],["\n              box-shadow: inset 0px -1px 0px 0px rgba(99, 191, 0, 1);\n            "]),_templateObject9=_taggedTemplateLiteral(["\n            background: none;\n            border: 2px solid #ffffff;\n            box-shadow: none;\n            text-shadow: none;\n\n            :hover,\n            :focus,\n            :active {\n              color: #1b546a;\n              background: #ffffff;\n              box-shadow: none;\n              text-shadow: none;\n            }\n          "],["\n            background: none;\n            border: 2px solid #ffffff;\n            box-shadow: none;\n            text-shadow: none;\n\n            :hover,\n            :focus,\n            :active {\n              color: #1b546a;\n              background: #ffffff;\n              box-shadow: none;\n              text-shadow: none;\n            }\n          "]),_templateObject10=_taggedTemplateLiteral(["\n      border-bottom: 2px solid #ca7700;\n      box-shadow: inset 0px -1px 0px 0px #ca7700;\n      background-color: #ca7700;\n      background: linear-gradient(to top, #fd9600, #ca7700);\n\n      :hover,\n      :focus,\n      :active {\n        background-color: #ca7700;\n        background: linear-gradient(to top, #ca7700, #fd9600);\n      }\n\n      ",";\n    "],["\n      border-bottom: 2px solid #ca7700;\n      box-shadow: inset 0px -1px 0px 0px #ca7700;\n      background-color: #ca7700;\n      background: linear-gradient(to top, #fd9600, #ca7700);\n\n      :hover,\n      :focus,\n      :active {\n        background-color: #ca7700;\n        background: linear-gradient(to top, #ca7700, #fd9600);\n      }\n\n      ",";\n    "]),_templateObject11=_taggedTemplateLiteral(["\n          background: none;\n          border: 2px solid #ffffff;\n          box-shadow: none;\n          text-shadow: none;\n\n          :hover,\n          :focus,\n          :active {\n            color: #1b546a;\n            background: #ffffff;\n            box-shadow: none;\n            text-shadow: none;\n          }\n        "],["\n          background: none;\n          border: 2px solid #ffffff;\n          box-shadow: none;\n          text-shadow: none;\n\n          :hover,\n          :focus,\n          :active {\n            color: #1b546a;\n            background: #ffffff;\n            box-shadow: none;\n            text-shadow: none;\n          }\n        "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var deployTarget="irontrade";var Button=__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.mainDark;},function(_ref){var type=_ref.type,disabled=_ref.disabled;if(deployTarget==="irontrade"&&type==="refill"){if(disabled===true){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject2);}return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject3);}if(disabled===true){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject5);});}if(type==="deposit"){return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject6,function(props){return props.theme.upperBorder;},function(props){return props.theme.upperBoxShadow;},function(props){return props.theme.upper;},function(props){return props.theme.upper;},function(props){return props.theme.upperAccent;},deployTarget==="siamoption"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject7,function(props){return props.theme.upperBoxShadow;}),function(props){return props.theme.upperAccent;},function(props){return props.theme.upperAccent;},function(props){return props.theme.upper;},deployTarget==="siamoption"&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject8),function(_ref3){var theme=_ref3.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject9);});}return Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject10,function(_ref4){var theme=_ref4.theme;return theme.isIntlProjectLight&&Object(__WEBPACK_IMPORTED_MODULE_0_styled_components__["c" /* css */])(_templateObject11);});});/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_withDeposit__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeMobile_Popup__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToggleAccount__ = __webpack_require__(1757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Account__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tour__ = __webpack_require__(44);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 20px;\n  margin-left: 20px;\n  font-size: 0px;\n  line-height: 0;\n  user-select: none;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n  }\n\n  @media (max-width: 425px) {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 20px;\n  margin-left: 20px;\n  font-size: 0px;\n  line-height: 0;\n  user-select: none;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex: 1;\n    overflow: hidden;\n  }\n\n  @media (max-width: 425px) {\n    margin-left: 0;\n    margin-right: 0;\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      margin-left: 0;\n      margin-right: 0;\n      pointer-events: none;\n    "],["\n      margin-left: 0;\n      margin-right: 0;\n      pointer-events: none;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    flex: 1;\n    overflow: hidden;\n  }\n"],["\n  position: relative;\n\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: column;\n    flex-wrap: nowrap;\n    flex: 1;\n    overflow: hidden;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var isOriginal=_ref.isOriginal;return!isOriginal&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var Relative=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);function AccountInHeader(props){var originalRef=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);var profile=props.profile,activeAccount=props.activeAccount,showDeposit=props.showDeposit;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isOpen=_useState2[0],setIsOpen=_useState2[1];var hide=function hide(e){if(e){e.preventDefault();e.stopPropagation();}setIsOpen(false);};var show=function show(){setIsOpen(true);};var refill=function refill(){if(props.refillTournamentAvailable){props.onRefillTournamentClick();}else if(props.refillDemoAvailable){console.log("refill demo");}};if((typeof activeAccount==="undefined"?"undefined":_typeof(activeAccount))!=="object"){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Tour__["b" /* default */],{step:["chartWithProfit","dealsProfit"],originalRef:originalRef,bgColor:"green",withMobileArrow:true},function(_ref2){var next=_ref2.next,isOriginal=_ref2.isOriginal,step=_ref2.step,isTourMode=_ref2.isTourMode,balance=_ref2.balance,tour=_ref2.tour;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{ref:originalRef,onClick:isOriginal?showDeposit?show:function(){return false;}:function(){return false;},type:!isTourMode?activeAccount.type:"demo",isOriginal:isOriginal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Relative,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ThemeProvider__["a" /* IronRedesignThemeProvider */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Account__["b" /* default */],{tradeMode:!isTourMode?props.mode:"binary",type:!isTourMode?activeAccount.type:"demo",activeAccount:!isTourMode?activeAccount:{balance:balance,estimatedBalance:balance,id:activeAccount.id,isActive:true,type:"demo"},profile:profile,showDeposit:showDeposit,isOpen:isOpen,mode:!isTourMode?props.mode:"binary",refillAvailable:props.refillDemoAvailable||props.refillTournamentAvailable,onRefillClick:refill}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Animations__["a" /* Fade */],{"in":isOpen},function(_ref3){var style=_ref3.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ToggleAccount__["a" /* default */],{profile:props.profile,accounts:props.accounts,refillDemoAvailable:props.refillDemoAvailable,refillTournamentAvailable:props.refillTournamentAvailable,showRefillLoader:props.showRefillLoader,onRefillDemoClick:props.onRefillDemoClick,onProfileUpdate:props.onProfileUpdate,onClose:hide,onDepositClick:props.onDepositClick,style:style,mode:props.mode});}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__common_Animations__["a" /* Fade */],{"in":isOpen},function(_ref4){var style=_ref4.style;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TradeMobile_Popup__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Account type"),onClick:hide,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ToggleAccount__["a" /* default */],{profile:props.profile,accounts:props.accounts,refillDemoAvailable:props.refillDemoAvailable,refillTournamentAvailable:props.refillTournamentAvailable,showRefillLoader:props.showRefillLoader,onRefillDemoClick:props.onRefillDemoClick,onProfileUpdate:props.onProfileUpdate,onClose:hide,onDepositClick:props.onDepositClick,mode:props.mode}));});}));});}function mapStateToProps(state){return Object.assign({},Object(__WEBPACK_IMPORTED_MODULE_5__common_withDeposit__["a" /* mapStateToShowDeposit */])(state),{mode:state.settings.mode});}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(AccountInHeader));

/***/ }),
/* 1757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_motion__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_motion__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_RefreshOutlined__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_RefreshOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_RefreshOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tournaments_Account_Tab__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Tournaments_Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Tab__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AccountInfo__ = __webpack_require__(1843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__AccountButton__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Tournaments_Account_TabContents__ = __webpack_require__(1844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Protection__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__TradeModals_CompensationPopup__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Icons__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Tournaments_images_invite_3x_png__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Tournaments_images_invite_3x_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__Tournaments_images_invite_3x_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Protection_ShieldIcon__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_compensation_bonus_bg_png__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__images_compensation_bonus_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__images_compensation_bonus_bg_png__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  text-align: center;\n  padding: 40px;\n"],["\n  text-align: center;\n  padding: 40px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 74px;\n  right: 0px;\n  width: 496px;\n  padding: 22px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  background-color: ",";\n  z-index: 10200;\n\n  ",";\n\n  @media (min-width: 960px) {\n    display: flex;\n    flex-direction: column;\n    max-height: calc(100vh - 72px);\n    overflow: hidden;\n  }\n\n  @media (max-width: 959px) {\n    position: relative;\n    top: 0;\n    flex-grow: 1;\n    flex-shrink: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    background-color: transparent;\n    display: flex;\n    flex-direction: column;\n  }\n"],["\n  position: absolute;\n  top: 74px;\n  right: 0px;\n  width: 496px;\n  padding: 22px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  background-color: ",";\n  z-index: 10200;\n\n  ",";\n\n  @media (min-width: 960px) {\n    display: flex;\n    flex-direction: column;\n    max-height: calc(100vh - 72px);\n    overflow: hidden;\n  }\n\n  @media (max-width: 959px) {\n    position: relative;\n    top: 0;\n    flex-grow: 1;\n    flex-shrink: 0;\n    width: 100%;\n    height: 100%;\n    padding: 0;\n    background-color: transparent;\n    display: flex;\n    flex-direction: column;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n      @media (min-width: 960px) {\n        box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16);\n      }\n    "],["\n      @media (min-width: 960px) {\n        box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.16);\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0 0 13px 0;\n  padding: 0 0 18px 0;\n  text-align: center;\n  text-transform: uppercase;\n  border-bottom: 1px solid ",";\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"],["\n  width: 100%;\n  margin: 0 0 13px 0;\n  padding: 0 0 18px 0;\n  text-align: center;\n  text-transform: uppercase;\n  border-bottom: 1px solid ",";\n\n  @media (max-width: 959px) {\n    display: none;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  align-content: flex-end;\n  width: 100%;\n  flex-shrink: 0;\n  flex-grow: 0;\n  border-bottom: 1px solid ",";\n\n  @media (max-width: 959px) {\n    border-bottom: none;\n  }\n\n  @media (max-width: 479px) {\n    padding: 10px;\n  }\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  align-content: flex-end;\n  width: 100%;\n  flex-shrink: 0;\n  flex-grow: 0;\n  border-bottom: 1px solid ",";\n\n  @media (max-width: 959px) {\n    border-bottom: none;\n  }\n\n  @media (max-width: 479px) {\n    padding: 10px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 23px 18px 18px;\n  /* background-color: ","; */\n  overflow-x:hidden;\n  overflow-y: auto;\n\n  @media (max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 0;\n    flex-flow: column nowrap;\n    height: 100%;\n    max-height: calc(100% - 60px);\n    padding: 23px 18px;\n    \n  }\n\n  @media (max-width: 479px) {\n    padding: 10px;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 23px 18px 18px;\n  /* background-color: ","; */\n  overflow-x:hidden;\n  overflow-y: auto;\n\n  @media (max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 0;\n    flex-flow: column nowrap;\n    height: 100%;\n    max-height: calc(100% - 60px);\n    padding: 23px 18px;\n    \n  }\n\n  @media (max-width: 479px) {\n    padding: 10px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 0 23px;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",";\n    margin-bottom: 20px;\n  }\n\n  :last-child {\n    padding-bottom: 0px;\n  }\n\n  @media (max-width: 959px) {\n    padding-bottom: 20px;\n\n    &:not(:last-child) {\n      border-bottom-color: ",";\n    }\n  }\n"],["\n  width: 100%;\n  padding: 0 0 23px;\n\n  &:not(:last-child) {\n    border-bottom: 1px solid ",";\n    margin-bottom: 20px;\n  }\n\n  :last-child {\n    padding-bottom: 0px;\n  }\n\n  @media (max-width: 959px) {\n    padding-bottom: 20px;\n\n    &:not(:last-child) {\n      border-bottom-color: ",";\n    }\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  /* portrait */\n  @media (max-width: 479px) {\n    flex-wrap: nowrap;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  /* portrait */\n  @media (max-width: 479px) {\n    flex-wrap: nowrap;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: space-between;\n  justify-content: space-between;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-content: space-between;\n  justify-content: space-between;\n  align-items: center;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  flex-wrap: wrap;\n  align-content: flex-start;\n  justify-content: flex-start;\n"],["\n  flex-wrap: wrap;\n  align-content: flex-start;\n  justify-content: flex-start;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  color: ",";\n  text-decoration: underline;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: #eb8a00;\n  }\n"],["\n  color: ",";\n  text-decoration: underline;\n  transition: all 0.3s ease;\n\n  :hover {\n    color: #eb8a00;\n  }\n"]),_templateObject12=_taggedTemplateLiteral(["\n  padding-bottom: 18px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: ",";\n"],["\n  padding-bottom: 18px;\n  font-weight: 400;\n  font-size: 18px;\n  line-height: 1;\n  color: ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n  direction: ",";\n  padding-bottom: 4px;\n"],["\n  direction: ",";\n  padding-bottom: 4px;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  padding-right: 12px;\n  font-weight: 700;\n  line-height: 22px;\n  white-space: nowrap;\n\n  ",";\n"],["\n  padding-right: 12px;\n  font-weight: 700;\n  line-height: 22px;\n  white-space: nowrap;\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n      padding-left: 12px;\n      color: ",";\n    "],["\n      padding-left: 12px;\n      color: ",";\n    "]),_templateObject16=_taggedTemplateLiteral(["\n  font-weight: 400;\n"],["\n  font-weight: 400;\n"]),_templateObject17=_taggedTemplateLiteral(["\n  display: table;\n"],["\n  display: table;\n"]),_templateObject18=_taggedTemplateLiteral(["\n  display: table-cell;\n  vertical-align: middle;\n  :last-of-type {\n    width: 100%;\n  }\n"],["\n  display: table-cell;\n  vertical-align: middle;\n  :last-of-type {\n    width: 100%;\n  }\n"]),_templateObject19=_taggedTemplateLiteral(["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 22px;\n  background-color: #99959d;\n"],["\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 22px;\n  background-color: #99959d;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n"],["\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  background-color: ",";\n  z-index: 0;\n"],["\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  height: 100%;\n  background-color: ",";\n  z-index: 0;\n"]),_templateObject22=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  /* landscape */\n  @media (min-width: 480px) {\n    flex-direction: row;\n    justify-content: space-between;\n    align-content: space-between;\n    align-items: center;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n\n  /* landscape */\n  @media (min-width: 480px) {\n    flex-direction: row;\n    justify-content: space-between;\n    align-content: space-between;\n    align-items: center;\n  }\n"]),_templateObject23=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  font-size: ",";\n  text-align: center;\n\n  /* portrait */\n  @media (max-width: 479px) {\n    margin-bottom: 18px;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  font-size: ",";\n  text-align: center;\n\n  /* portrait */\n  @media (max-width: 479px) {\n    margin-bottom: 18px;\n  }\n"]),_templateObject24=_taggedTemplateLiteral(["\n  margin-left: 6px;\n  font-size: 24px;\n"],["\n  margin-left: 6px;\n  font-size: 24px;\n"]),_templateObject25=_taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  background-color: #000;\n  white-space: normal;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n"],["\n  margin-bottom: 16px;\n  background-color: #000;\n  white-space: normal;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n  border-radius: 4px;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n"]),_templateObject26=_taggedTemplateLiteral(["\n  position: relative;\n  padding: 16px 16px 20px;\n"],["\n  position: relative;\n  padding: 16px 16px 20px;\n"]),_templateObject27=_taggedTemplateLiteral(["\n  color: #ffcc00;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 17px;\n  display: flex;\n  align-items: center;\n  mark {\n    background-color: unset;\n    color: #ffcc00;\n    margin-right: 5px;\n  }\n"],["\n  color: #ffcc00;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 17px;\n  display: flex;\n  align-items: center;\n  mark {\n    background-color: unset;\n    color: #ffcc00;\n    margin-right: 5px;\n  }\n"]),_templateObject28=_taggedTemplateLiteral(["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: #bebebe;\n"],["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: #bebebe;\n"]),_templateObject29=_taggedTemplateLiteral(["\n  font-size: 14px;\n  line-height: 1.6;\n  color: #fff;\n  margin-bottom: 20px;\n  font-weight: 700;\n  @media (max-width: 479px) {\n    line-height: 1.4;\n  }\n"],["\n  font-size: 14px;\n  line-height: 1.6;\n  color: #fff;\n  margin-bottom: 20px;\n  font-weight: 700;\n  @media (max-width: 479px) {\n    line-height: 1.4;\n  }\n"]),_templateObject30=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 479px) {\n    flex-direction: column;\n  }\n"],["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  @media (max-width: 479px) {\n    flex-direction: column;\n  }\n"]),_templateObject31=_taggedTemplateLiteral(["\n  @media (max-width: 479px) {\n    margin-bottom: 18px;\n  }\n"],["\n  @media (max-width: 479px) {\n    margin-bottom: 18px;\n  }\n"]),_templateObject32=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"],["\n  display: flex;\n  justify-content: center;\n"]),_templateObject33=_taggedTemplateLiteral(["\n  border: 2px solid #ffffff;\n  border-radius: 19px;\n  font-size: 12px;\n  line-height: 1;\n  padding: 10px 46px;\n  background-color: transparent;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.3s;\n  text-transform: uppercase;\n  text-decoration: none;\n  :hover:not([disabled]) {\n    background-color: #ffffff;\n    color: #3b9478;\n  }\n  :disabled {\n    color: #707070;\n    border-color: #707070;\n  }\n  @media (max-width: 479px) {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n"],["\n  border: 2px solid #ffffff;\n  border-radius: 19px;\n  font-size: 12px;\n  line-height: 1;\n  padding: 10px 46px;\n  background-color: transparent;\n  color: #fff;\n  font-weight: 700;\n  cursor: pointer;\n  transition: 0.3s;\n  text-transform: uppercase;\n  text-decoration: none;\n  :hover:not([disabled]) {\n    background-color: #ffffff;\n    color: #3b9478;\n  }\n  :disabled {\n    color: #707070;\n    border-color: #707070;\n  }\n  @media (max-width: 479px) {\n    margin-bottom: 20px;\n    width: 100%;\n  }\n"]),_templateObject34=_taggedTemplateLiteral(["\n  margin: 0 3px;\n  display: inline-block;\n  svg path {\n    fill: #ffcc00;\n  }\n"],["\n  margin: 0 3px;\n  display: inline-block;\n  svg path {\n    fill: #ffcc00;\n  }\n"]),_templateObject35=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 42px;\n  height: 42px;\n"]),_templateObject36=_taggedTemplateLiteral(["\n  margin-bottom: 8px;\n  background-color: ",";\n  white-space: normal;\n  position: relative;\n  padding: 16px;\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n"],["\n  margin-bottom: 8px;\n  background-color: ",";\n  white-space: normal;\n  position: relative;\n  padding: 16px;\n\n  :last-of-type {\n    margin-bottom: 0;\n  }\n"]),_templateObject37=_taggedTemplateLiteral(["\n  color: ",";\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n"],["\n  color: ",";\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 14px;\n  display: flex;\n  align-items: center;\n"]),_templateObject38=_taggedTemplateLiteral(["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: ",";\n"],["\n  margin-right: 10px;\n  flex: 0 0 auto;\n  color: ",";\n"]),_templateObject39=_taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 1.6;\n  color: ",";\n  margin-bottom: 16px;\n  @media (max-width: 479px) {\n    line-height: 1.4;\n  }\n"],["\n  font-size: 12px;\n  line-height: 1.6;\n  color: ",";\n  margin-bottom: 16px;\n  @media (max-width: 479px) {\n    line-height: 1.4;\n  }\n"]),_templateObject40=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"],["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"]),_templateObject41=_taggedTemplateLiteral(["\n  color: ",";\n  font-size: 12px;\n  text-transform: lowercase;\n  ",";\n"],["\n  color: ",";\n  font-size: 12px;\n  text-transform: lowercase;\n  ",";\n"]),_templateObject42=_taggedTemplateLiteral(["\n      color: #ffcc00;\n    "],["\n      color: #ffcc00;\n    "]),_templateObject43=_taggedTemplateLiteral(["\n  background-color: #0085eb;\n  color: #fff;\n  font-size: 12px;\n  padding: 11px 22px;\n  border-radius: 19px;\n  border: none;\n  text-transform: uppercase;\n  font-weight: 900;\n  transition: 0.3s;\n  cursor: pointer;\n  :hover:not([disabled]) {\n    background-color: #0468b5;\n  }\n  :disabled {\n    opacity: 0.4;\n  }\n"],["\n  background-color: #0085eb;\n  color: #fff;\n  font-size: 12px;\n  padding: 11px 22px;\n  border-radius: 19px;\n  border: none;\n  text-transform: uppercase;\n  font-weight: 900;\n  transition: 0.3s;\n  cursor: pointer;\n  :hover:not([disabled]) {\n    background-color: #0468b5;\n  }\n  :disabled {\n    opacity: 0.4;\n  }\n"]),_templateObject44=_taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  margin-right: -16px;\n  margin-left: -16px;\n  background-color: #000;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n"],["\n  margin-bottom: 16px;\n  margin-right: -16px;\n  margin-left: -16px;\n  background-color: #000;\n  background-image: url(",");\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  position: relative;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.7);\n  }\n"]),_templateObject45=_taggedTemplateLiteral(["\n  text-align: center;\n  padding: 16px;\n  position: relative;\n"],["\n  text-align: center;\n  padding: 16px;\n  position: relative;\n"]),_templateObject46=_taggedTemplateLiteral(["\n  color: #ffffff;\n  margin-bottom: 6px;\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n"],["\n  color: #ffffff;\n  margin-bottom: 6px;\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n"]),_templateObject47=_taggedTemplateLiteral(["\n  color: #ffcc00;\n  margin-bottom: 6px;\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n"],["\n  color: #ffcc00;\n  margin-bottom: 6px;\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n"]),_templateObject48=_taggedTemplateLiteral(["\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1.2;\n  margin-bottom: 6px;\n"],["\n  color: #ffffff;\n  font-size: 12px;\n  line-height: 1.2;\n  margin-bottom: 6px;\n"]),_templateObject49=_taggedTemplateLiteral(["\n  color: #ffffff;\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n"],["\n  color: #ffffff;\n  font-size: 18px;\n  line-height: 1.2;\n  font-weight: 700;\n"]),_templateObject50=_taggedTemplateLiteral(["\n  color: ",";\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 17px;\n  display: flex;\n  align-items: center;\n"],["\n  color: ",";\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 17px;\n  display: flex;\n  align-items: center;\n"]),_templateObject51=_taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 1.6;\n  color: ",";\n  @media (max-width: 479px) {\n    line-height: 1.4;\n  }\n"],["\n  font-size: 12px;\n  line-height: 1.6;\n  color: ",";\n  @media (max-width: 479px) {\n    line-height: 1.4;\n  }\n"]),_templateObject52=_taggedTemplateLiteral(["\n  color: ",";\n  font-size: 12px;\n  text-transform: lowercase;\n"],["\n  color: ",";\n  font-size: 12px;\n  text-transform: lowercase;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}//import _Scrollable from "../common/Scrollable";
var SpinnerWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(props){return props.theme.toggleAccountDarkBg;},"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject3));var Header=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].h2(_templateObject4,function(props){return props.theme.mainSeparator;});var TabContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.theme.mainSeparator;});var AccountView=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.theme.toggleAccountLightBg;});var AccountRow=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.theme.mainSeparator;},function(props){return props.theme.borderMainColor;});var AccountRowFlex=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(AccountRow)(_templateObject8);var BtnContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject9);var BtnInner=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(BtnContainer)(_templateObject10);var Link=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__common_Link__["a" /* Link */])(_templateObject11,function(props){return props.theme.accent;});var BonusHeader=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].h2(_templateObject12,function(_ref3){var theme=_ref3.theme;return theme.foreground;});var BonusSubheader=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].p(_templateObject13,function(props){return props.theme.direction;});var BalanceView=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject14,function(props){return props.dark&&Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject15,function(props){return props.theme.mainDark;});});var Currency=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */].Symbol)(_templateObject16);// prettier-ignore
var ProgressContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject17);var ProgressInner=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject18);var ProgressBar=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject19);var ProgressBarText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].span(_templateObject20);var ProgressBarFill=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject21,function(props){return props.theme.accent;});var Mobile=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject22);var BalanceMobileContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject23,function(props){return props.theme.direction;},function(_ref4){var theme=_ref4.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var BalanceMobile=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].span(_templateObject24);// const Scrollable = styled(_Scrollable)`
//   margin-bottom: 20px;
//   @media (max-width: 479px) {
//     margin-bottom: 10px;
//   }
// `;
// const ScrollableInner = styled.div`
//   padding-right: 15px;
//   @media (max-width: 479px) {
//     padding-right: 0;
//   }
// `;
function Balance(_ref5){var children=_ref5.children,dark=_ref5.dark;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalanceView,{dark:dark},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */],{Symbol:Currency},children));}var ToggleAccount=function(_React$Component){_inherits(ToggleAccount,_React$Component);function ToggleAccount(props){_classCallCheck(this,ToggleAccount);var _this=_possibleConstructorReturn(this,(ToggleAccount.__proto__||Object.getPrototypeOf(ToggleAccount)).call(this,props));_initialiseProps.call(_this);var accounts=props.accounts,profile=props.profile;var activeAccount=accounts.find(function(account){return account.id===profile.active_account_id;});var _activeAccount$type=activeAccount.type,type=_activeAccount$type===undefined?"demo":_activeAccount$type;_this.state={currentTab:props.mode==="tournament"?"tournament":type,isFetching:false,participationFee:null,tournamentForDemoMoney:null};return _this;}_createClass(ToggleAccount,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var api=this.props.api;var announcements=__WEBPACK_IMPORTED_MODULE_2_idx___default()(api.readEntity("/api/bell-tolls-items"),function(d){return d.value.payload.data;});var features=__WEBPACK_IMPORTED_MODULE_2_idx___default()(api.readEntity("/api/features/list"),function(d){return d.value;});features&&features.forEach(function(item){if(item.name==="participation_fee"){_this2.setState({participationFee:item.info.participation_fee});}});announcements&&announcements.forEach(function(announcement){if(announcement.type==="invited-tournament"&&announcement.info["2x_demo_balance_invite"]){_this2.setState({tournamentForDemoMoney:announcement.info});}});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,accounts=_props.accounts,onClose=_props.onClose,style=_props.style,profile=_props.profile,onDepositClick=_props.onDepositClick,onRefillDemoClick=_props.onRefillDemoClick,refillDemoAvailable=_props.refillDemoAvailable;var activeAccount=accounts.find(function(account){return account.id===profile.active_account_id;});if((typeof activeAccount==="undefined"?"undefined":_typeof(activeAccount))!=="object"){return null;}var realAccount=accounts.find(function(account){return account.type==="real";});var demoAccount=accounts.find(function(account){return account.type==="demo";});var realBalance=realAccount?realAccount.balance:0;var demoBalance=demoAccount?demoAccount.balance:0;var holdMenu=this.props.queue.length>0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_ClickOutside__["a" /* default */],{onOutsideClick:onClose,disabled:holdMenu},function(_ref6){var innerRef=_ref6.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{ref:innerRef,style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Account type")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabContainer,null,__WEBPACK_IMPORTED_MODULE_8__FeatureFlags__["a" /* default */].enableTournaments&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Tournaments_Account_Tab__["a" /* default */],{currentTab:_this3.state.currentTab,onClick:_this3.onTabClick}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Tab__["a" /* default */],{tab:"real",currentTab:_this3.state.currentTab,onClick:_this3.onTabClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Real account")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Tab__["a" /* default */],{tab:"demo",currentTab:_this3.state.currentTab,onClick:_this3.onTabClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Demo account"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TabContentSwitcher,Object.assign({},_this3.state,{demoBalance:demoBalance,realBalance:realBalance,profile:profile,onClose:onClose,onDepositClick:onDepositClick,onRefillDemoClick:onRefillDemoClick,refillDemoAvailable:refillDemoAvailable,showRefillLoader:_this3.props.showRefillLoader||!_this3.props.profileReady,showRefillDemo:_this3.props.tradeMode==="binary"&&activeAccount.type==="demo",participationFee:_this3.state.participationFee,tournamentForDemoMoney:_this3.state.tournamentForDemoMoney,compensationUpdated:_this3.props.compensationUpdated,compensationCreated:_this3.props.compensationCreated,isTradePage:true})));});}}]);return ToggleAccount;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);var _initialiseProps=function _initialiseProps(){var _this4=this;this.onTabClick=function(tab){if(tab===_this4.state.currentTab){return false;}switch(tab){case"tournament":var tournament_account=__WEBPACK_IMPORTED_MODULE_2_idx___default()(_this4.props.api.readEntity("/api/tournaments/stats"),function(stats){return stats.value.active_tournament.account;});if(tournament_account!=null){_this4.props.api.fetchEntity("/api/tournaments/operations?account_id="+tournament_account.id);_this4.props.dispatch({type:"ENGAGE_TOURNAMENT_MODE"});}_this4.setState({currentTab:"tournament"});break;case"real":case"demo":default:var account=_this4.props.accounts.find(function(account){return account.type===tab;});if(!account){if(tab==="real"){_this4.setState({currentTab:"real_stub"});return;}return _this4.props.history.push("/fillup");}_this4.setState({isFetching:true});Object(__WEBPACK_IMPORTED_MODULE_10__common_fetch__["d" /* get */])("/ajax/setAccount?id="+account.id).then(function(data){if(data.status==="OK"){_this4.setState({currentTab:tab});if(typeof _this4.props.onProfileUpdate==="function"){_this4.props.onProfileUpdate().then(function(){return _this4.props.dispatch({type:"SWITCH_ACCOUNTS"});});}else{_this4.props.dispatch({type:"SWITCH_ACCOUNTS"});}_this4.props.api.fetchEntity("/api/compensations/info");}else{_this4.props.history.push("/fillup");}}).catch(function(error){return error;}).then(function(){return _this4.setState({isFetching:false});});}};};function Buttons(_ref7){var balance=_ref7.balance,onClose=_ref7.onClose,onDepositClick=_ref7.onDepositClick,onRefillDemoClick=_ref7.onRefillDemoClick,children=_ref7.children,_ref7$showTrade=_ref7.showTrade,showTrade=_ref7$showTrade===undefined?true:_ref7$showTrade,showRefillDemo=_ref7.showRefillDemo,refillDemoAvailable=_ref7.refillDemoAvailable,showRefillLoader=_ref7.showRefillLoader,isReal=_ref7.isReal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Mobile,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalanceMobileContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Balance"),":"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BalanceMobile,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */],null,balance))),showRefillLoader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpinnerWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Spinners_SimpleSpinner__["c" /* default */],{accent:true})),showRefillDemo&&refillDemoAvailable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{style:{marginBottom:20},type:"trade",mobile:true,onClick:function onClick(e){onClose(e);onRefillDemoClick();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_RefreshOutlined___default.a,{style:{fontSize:28},color:"inherit"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Refill")),showTrade&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"refill",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_25__GA__["a" /* gaReducer */])("CLICKBTN_TRADE_DEPOSIT_ACCOUNT",{buttonText:e.currentTarget.textContent,accountType:isReal?"real":"demo"});onClose(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Trade"))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BtnContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BtnInner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"refill",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_25__GA__["a" /* gaReducer */])("CLICKBTN_TRADE_DEPOSIT_ACCOUNT",{buttonText:e.currentTarget.textContent,accountType:isReal?"real":"demo"});onClose(e);onDepositClick();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Deposit")),showRefillLoader&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Spinners_SimpleSpinner__["c" /* default */],{accent:true,style:{marginLeft:12}}),showRefillDemo&&refillDemoAvailable&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{style:{marginLeft:12},type:"trade",onClick:function onClick(e){onClose(e);onRefillDemoClick();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_RefreshOutlined___default.a,{style:{fontSize:28},color:"inherit"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Refill")),children),showTrade&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BtnInner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"trade",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_25__GA__["a" /* gaReducer */])("CLICKBTN_TRADE_DEPOSIT_ACCOUNT",{buttonText:e.currentTarget.textContent,accountType:isReal?"real":"demo"});onClose(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Trade"))));}));}function TabContentSwitcher(_ref8){var isFetching=_ref8.isFetching,currentTab=_ref8.currentTab,profile=_ref8.profile,onClose=_ref8.onClose,onDepositClick=_ref8.onDepositClick,onRefillDemoClick=_ref8.onRefillDemoClick,refillDemoAvailable=_ref8.refillDemoAvailable,showRefillLoader=_ref8.showRefillLoader,demoBalance=_ref8.demoBalance,realBalance=_ref8.realBalance,showRefillDemo=_ref8.showRefillDemo,tournamentForDemoMoney=_ref8.tournamentForDemoMoney,participationFee=_ref8.participationFee,isTradePage=_ref8.isTradePage,compensationUpdated=_ref8.compensationUpdated,compensationCreated=_ref8.compensationCreated;if(isFetching===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SpinnerWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Spinners_SimpleSpinner__["c" /* default */],null));}switch(currentTab){case"tournament":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__Tournaments_Account_TabContents__["a" /* default */],{isTradePage:isTradePage,onClose:onClose});case"real":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountView,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Buttons,{onClose:onClose,onDepositClick:onDepositClick,balance:realBalance,isReal:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"withdraw",to:"/withdraw"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Withdraw"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(RealAccountTabContent,{bonus:profile.bonus,actions:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"refill",to:"/fillup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"withdraw",to:"/withdraw"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Withdraw")))}));case"real_stub":return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountView,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(shouldShowTradeButton){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Buttons,{onClose:onClose,onDepositClick:onDepositClick,balance:realBalance,isReal:true,showTrade:shouldShowTradeButton});}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRowFlex,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__AccountInfo__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Trading is available only if you have funds on your real account."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRowFlex,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"refill",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_25__GA__["a" /* gaReducer */])("CLICKBTN_TRADE_DEPOSIT_ACCOUNT",{buttonText:e.currentTarget.textContent,accountType:"real"});onDepositClick();onClose(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"withdraw",to:"/withdraw"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Withdraw")));}}));case"demo":default:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountView,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Buttons,{balance:demoBalance,onClose:onClose,onDepositClick:onDepositClick,onRefillDemoClick:onRefillDemoClick,refillDemoAvailable:refillDemoAvailable,showRefillLoader:showRefillLoader,showRefillDemo:showRefillDemo}),tournamentForDemoMoney&&tournamentForDemoMoney.participation_status===1||!participationFee?null:tournamentForDemoMoney?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Congratulation,{tournament:tournamentForDemoMoney,type:"1"}):participationFee>profile.balance.demo&&"irontrade"!=="eztrader"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Advice,{participationFee:participationFee}):null,profile.real!==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Bonus,{compensationUpdated:compensationUpdated,compensationCreated:compensationCreated}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoAccountTabContent,{onClose:onClose,onDepositClick:onDepositClick}));}}function RealAccountTabContent(_ref9){var bonus=_ref9.bonus,actions=_ref9.actions;if(!bonus||!bonus.bonus_sum){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRowFlex,null,actions):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRow,null);});}var sum=bonus.bonus_sum,coeff=bonus.bonus_multiplier,turnover=bonus.turnover;var cashflow=sum*coeff;var progressPercent=Math.min(100,Math.round(turnover*100/cashflow));return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusHeader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You have an active bonus")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusSubheader,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Mandatory Trading Volume"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressInner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Balance,null,cashflow)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressInner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressBar,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressBarText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Balance,{dark:true},turnover)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_motion__["Motion"],{defaultStyle:{x:0},style:{x:Object(__WEBPACK_IMPORTED_MODULE_5_react_motion__["spring"])(progressPercent)}},function(value){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ProgressBarFill,{style:{width:value.x+"%"}});}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRow,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__AccountInfo__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You need to reach a mandatory trading turnover that displayed on this progress bar to withdraw your bonus. When it is completely full, you can withdraw your bonus funds."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{to:"/bonus-program"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"The Bonus program Policy")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRowFlex,null,actions);}}));}var mapStateToDemoAccLimit=function mapStateToDemoAccLimit(state){return{demoAccLimit:state.apiConfigs&&state.apiConfigs.demoAccLimit||1000};};var DemoRefill=Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToDemoAccLimit)(function(_ref10){var demoAccLimit=_ref10.demoAccLimit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */],null,demoAccLimit);});var DemoAccountTabContent=function DemoAccountTabContent(_ref11){var onDepositClick=_ref11.onDepositClick,onClose=_ref11.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRowFlex,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__AccountInfo__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"A demo account is a special account with virtual money, which allows you to check capabilities of the platform. You can't withdraw money from a demo account, but you can practice trading without any risk as much as you want. When a demo balance is close to ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DemoRefill,null)," you will be able to top it up for free."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountRowFlex,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"refill",onClick:function onClick(e){Object(__WEBPACK_IMPORTED_MODULE_25__GA__["a" /* gaReducer */])("CLICKBTN_TRADE_DEPOSIT_ACCOUNT",{buttonText:e.currentTarget.textContent,accountType:"demo"});onDepositClick();onClose(e);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__AccountButton__["a" /* default */],{type:"withdraw",to:"/withdraw"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Withdraw")));}}));};var BonusWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject25,__WEBPACK_IMPORTED_MODULE_29__images_compensation_bonus_bg_png___default.a);var BonusConteiner=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject26);var BonusTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject27);var BonusTitleIcon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject28);var BonusText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject29);var BonusFooter=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject30);var BonusIcons=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject31);var BonusButtonContainer=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject32);var BonusButton=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__common_Link__["a" /* Link */])(_templateObject33);var BonusIcon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject34);var BonusSticker=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject35);var Bonus=function Bonus(_ref12){var compensationUpdated=_ref12.compensationUpdated,compensationCreated=_ref12.compensationCreated;var compensations=Object(__WEBPACK_IMPORTED_MODULE_23__Protection__["b" /* useCompensations */])([compensationUpdated,compensationCreated]);var amountLimit=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return Object(__WEBPACK_IMPORTED_MODULE_24__TradeModals_CompensationPopup__["b" /* getAmountLimit */])(compensations);},[compensations]);var memoizedHotIcon=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Icons__["c" /* HotIcon */],null);},[]);var memoizedBonusIcons=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_28__Protection_ShieldIcon__["a" /* default */],null));},[]);var memoizedGiftIcon=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusTitleIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Icons__["b" /* GiftIcon */],null));},[]);if(compensations==null||compensations.demo==null||compensations.demo.count<1){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusSticker,null,memoizedHotIcon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusConteiner,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusTitle,null,memoizedGiftIcon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Bonus")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Don't worry about losing real money! Now we give newbie traders, who made their first deposit, ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"5 risk-free trades that can be used for all deals up to ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */],null,amountLimit)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusFooter,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusIcons,null,memoizedBonusIcons,memoizedBonusIcons,memoizedBonusIcons,memoizedBonusIcons,memoizedBonusIcons),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BonusButton,{to:"/fillup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Use bonus"))))));};var CongratulationWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject36,function(props){return props.theme.toggleAccountLightBg;});var CongratulationTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject37,function(_ref13){var theme=_ref13.theme;return theme.mode==="light"?"#3B9478":"#FFCC00";});var CongratulationTitleIcon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject38,function(_ref14){var theme=_ref14.theme;return theme.mode==="light"?"#919191":"#616265";});var CongratulationText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject39,function(_ref15){var theme=_ref15.theme;return theme.mode==="light"?"#919191":"#FFFFFF";});var CongratulationFooter=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject40);var CongratulationLink=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__common_Link__["a" /* Link */])(_templateObject41,function(_ref16){var theme=_ref16.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";},function(props){return props.color==="yellow"&&Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["c" /* css */])(_templateObject42);});var CongratulationButton=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].button(_templateObject43);var TournamentBlock=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject44,function(props){return props.img;});var TournamentContent=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject45);var TournamentTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject46);var TournamentFund=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject47);var TournamentStartLabel=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject48);var TournamentStartTime=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject49);var TournamentSticker=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject35);var Congratulation=function Congratulation(_ref17){var type=_ref17.type,tournament=_ref17.tournament;var memoizedGiftIcon=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationTitleIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Icons__["b" /* GiftIcon */],null));},[]);var memoizedInviteSticker=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_27__Tournaments_images_invite_3x_png___default.a,alt:""});},[]);if(tournament==null||tournament.pay_account!=="demo"){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationTitle,null,memoizedGiftIcon,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Congratulations")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You have enough DEMO money to purchase a tournament invitation!")),type==="2"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentBlock,{img:"https://picsum.photos/500"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentSticker,null,memoizedInviteSticker),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentContent,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentTitle,null,"__title__"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentFund,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Prize fund"),": $25"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentStartLabel,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"The tournament will start in"),":"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentStartTime,null,"02 : 19 : 18"))),type==="1"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationFooter,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationLink,{to:"/news/doubleup",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Details")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref18){var showModal=_ref18.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationButton,{onClick:function onClick(){return showModal(__WEBPACK_IMPORTED_MODULE_16__Tournaments_Popups__["b" /* JoinPopup */],tournament);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Buy the invitation"));})),type==="2"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationFooter,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationLink,{to:"/news/doubleup",target:"_blank",color:"yellow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Other tournaments")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CongratulationButton,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Buy for ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */],null,tournament.participation_price)," demo money"))));};var AdviceWrapper=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject36,function(props){return props.theme.toggleAccountLightBg;});var AdviceTitle=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject50,function(_ref19){var theme=_ref19.theme;return theme.mode==="light"?"#919191":"#FFFFFF";});var AdviceText=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject51,function(_ref20){var theme=_ref20.theme;return theme.mode==="light"?"#919191":"#FFFFFF";});var AdviceLink=Object(__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__common_Link__["b" /* NewsLink */])(_templateObject52,function(_ref21){var theme=_ref21.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";});var AdviceTitleIcon=__WEBPACK_IMPORTED_MODULE_6_styled_components__["d" /* default */].div(_templateObject38,function(_ref22){var theme=_ref22.theme;return theme.mode==="light"?"#919191":"#616265";});var Advice=function Advice(_ref23){var participationFee=_ref23.participationFee;var memoizedAdviceIcon=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdviceTitleIcon,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__Icons__["a" /* AdviceIcon */],null));},[]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdviceWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdviceTitle,null,memoizedAdviceIcon," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Advice")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdviceText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Don't know what to do with your DEMO money?")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Earn ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Money__["b" /* default */],null,participationFee)," and get a paid tournament invitation!")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AdviceLink,{to:"/doubleup",target:"_blank"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Details"))));};var mapStateToProps=function mapStateToProps(state){return{profileReady:state.dataRequirementsStatus.profile==="AVAILABLE",tournaments:state.tournaments,tradeMode:state.settings.mode};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref24){var queue=_ref24.queue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Tournaments_Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ToggleAccount,Object.assign({},props,{queue:queue,api:api}));});});})));

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(432);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(278);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(433);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(434);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(435);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(436);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = (function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
})(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(432);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(278);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(433);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(434);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(435);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(436);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

function shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
  for (var i = 0; i < currentStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) {
      return false;
    }
  }
  return true;
}

var StaggeredMotion = (function (_React$Component) {
  _inherits(StaggeredMotion, _React$Component);

  _createClass(StaggeredMotion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].objectOf(_propTypes2['default'].number)),
      styles: _propTypes2['default'].func.isRequired,
      children: _propTypes2['default'].func.isRequired
    },
    enumerable: true
  }]);

  function StaggeredMotion(props) {
    var _this = this;

    _classCallCheck(this, StaggeredMotion);

    _React$Component.call(this, props);
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _state = _this.state;
      var currentStyles = _state.currentStyles;
      var currentVelocities = _state.currentVelocities;
      var lastIdealStyles = _state.lastIdealStyles;
      var lastIdealVelocities = _state.lastIdealVelocities;

      var someDirty = false;
      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i];
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              someDirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
          }
        }
      }

      if (someDirty) {
        _this.setState({ currentStyles: currentStyles, currentVelocities: currentVelocities, lastIdealStyles: lastIdealStyles, lastIdealVelocities: lastIdealVelocities });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        var destStyles = _this.props.styles(_this.state.lastIdealStyles);

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyles = [];
        var newLastIdealVelocities = [];
        var newCurrentStyles = [];
        var newCurrentVelocities = [];

        for (var i = 0; i < destStyles.length; i++) {
          var destStyle = destStyles[i];
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in destStyle) {
            if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
              continue;
            }

            var styleValue = destStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
              var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  StaggeredMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;

    var currentStyles = defaultStyles || styles().map(_stripStyle2['default']);
    var currentVelocities = currentStyles.map(function (currentStyle) {
      return _mapToZero2['default'](currentStyle);
    });
    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: currentStyles,
      lastIdealVelocities: currentVelocities
    };
  };

  StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  StaggeredMotion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return StaggeredMotion;
})(_react2['default'].Component);

exports['default'] = StaggeredMotion;
module.exports = exports['default'];

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

// after checking for unreadPropStyles != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 1760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _mapToZero = __webpack_require__(432);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(278);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(433);

var _stepper4 = _interopRequireDefault(_stepper3);

var _mergeDiff = __webpack_require__(1761);

var _mergeDiff2 = _interopRequireDefault(_mergeDiff);

var _performanceNow = __webpack_require__(434);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(435);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(436);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
  // Copy the value to a `const` so that Flow understands that the const won't
  // change and will be non-nullable in the callback below.
  var cUnreadPropStyles = unreadPropStyles;
  if (cUnreadPropStyles == null) {
    return mergedPropsStyles.map(function (mergedPropsStyle, i) {
      return {
        key: mergedPropsStyle.key,
        data: mergedPropsStyle.data,
        style: plainStyles[i]
      };
    });
  }
  return mergedPropsStyles.map(function (mergedPropsStyle, i) {
    for (var j = 0; j < cUnreadPropStyles.length; j++) {
      if (cUnreadPropStyles[j].key === mergedPropsStyle.key) {
        return {
          key: cUnreadPropStyles[j].key,
          data: cUnreadPropStyles[j].data,
          style: plainStyles[i]
        };
      }
    }
    return { key: mergedPropsStyle.key, data: mergedPropsStyle.data, style: plainStyles[i] };
  });
}

function shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
  if (mergedPropsStyles.length !== destStyles.length) {
    return false;
  }

  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (mergedPropsStyles[i].key !== destStyles[i].key) {
      return false;
    }
  }

  // we have the invariant that mergedPropsStyles and
  // currentStyles/currentVelocities/last* are synced in terms of cells, see
  // mergeAndSync comment for more info
  for (var i = 0; i < mergedPropsStyles.length; i++) {
    if (!_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) {
      return false;
    }
  }

  return true;
}

// core key merging logic

// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key

// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
  var newMergedPropsStyles = _mergeDiff2['default'](oldMergedPropsStyles, destStyles, function (oldIndex, oldMergedPropsStyle) {
    var leavingStyle = willLeave(oldMergedPropsStyle);
    if (leavingStyle == null) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    if (_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
      didLeave({ key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data });
      return null;
    }
    return { key: oldMergedPropsStyle.key, data: oldMergedPropsStyle.data, style: leavingStyle };
  });

  var newCurrentStyles = [];
  var newCurrentVelocities = [];
  var newLastIdealStyles = [];
  var newLastIdealVelocities = [];
  for (var i = 0; i < newMergedPropsStyles.length; i++) {
    var newMergedPropsStyleCell = newMergedPropsStyles[i];
    var foundOldIndex = null;
    for (var j = 0; j < oldMergedPropsStyles.length; j++) {
      if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
        foundOldIndex = j;
        break;
      }
    }
    // TODO: key search code
    if (foundOldIndex == null) {
      var plainStyle = willEnter(newMergedPropsStyleCell);
      newCurrentStyles[i] = plainStyle;
      newLastIdealStyles[i] = plainStyle;

      var velocity = _mapToZero2['default'](newMergedPropsStyleCell.style);
      newCurrentVelocities[i] = velocity;
      newLastIdealVelocities[i] = velocity;
    } else {
      newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
      newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
      newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
      newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
    }
  }

  return [newMergedPropsStyles, newCurrentStyles, newCurrentVelocities, newLastIdealStyles, newLastIdealVelocities];
}

var TransitionMotion = (function (_React$Component) {
  _inherits(TransitionMotion, _React$Component);

  _createClass(TransitionMotion, null, [{
    key: 'propTypes',
    value: {
      defaultStyles: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].number).isRequired
      })),
      styles: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        key: _propTypes2['default'].string.isRequired,
        data: _propTypes2['default'].any,
        style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired
      }))]).isRequired,
      children: _propTypes2['default'].func.isRequired,
      willEnter: _propTypes2['default'].func,
      willLeave: _propTypes2['default'].func,
      didLeave: _propTypes2['default'].func
    },
    enumerable: true
  }, {
    key: 'defaultProps',
    value: {
      willEnter: function willEnter(styleThatEntered) {
        return _stripStyle2['default'](styleThatEntered.style);
      },
      // recall: returning null makes the current unmounting TransitionStyle
      // disappear immediately
      willLeave: function willLeave() {
        return null;
      },
      didLeave: function didLeave() {}
    },
    enumerable: true
  }]);

  function TransitionMotion(props) {
    var _this = this;

    _classCallCheck(this, TransitionMotion);

    _React$Component.call(this, props);
    this.unmounting = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyles = null;

    this.clearUnreadPropStyle = function (unreadPropStyles) {
      var _mergeAndSync = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

      var mergedPropsStyles = _mergeAndSync[0];
      var currentStyles = _mergeAndSync[1];
      var currentVelocities = _mergeAndSync[2];
      var lastIdealStyles = _mergeAndSync[3];
      var lastIdealVelocities = _mergeAndSync[4];

      for (var i = 0; i < unreadPropStyles.length; i++) {
        var unreadPropStyle = unreadPropStyles[i].style;
        var dirty = false;

        for (var key in unreadPropStyle) {
          if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) {
            continue;
          }

          var styleValue = unreadPropStyle[key];
          if (typeof styleValue === 'number') {
            if (!dirty) {
              dirty = true;
              currentStyles[i] = _extends({}, currentStyles[i]);
              currentVelocities[i] = _extends({}, currentVelocities[i]);
              lastIdealStyles[i] = _extends({}, lastIdealStyles[i]);
              lastIdealVelocities[i] = _extends({}, lastIdealVelocities[i]);
              mergedPropsStyles[i] = {
                key: mergedPropsStyles[i].key,
                data: mergedPropsStyles[i].data,
                style: _extends({}, mergedPropsStyles[i].style)
              };
            }
            currentStyles[i][key] = styleValue;
            currentVelocities[i][key] = 0;
            lastIdealStyles[i][key] = styleValue;
            lastIdealVelocities[i][key] = 0;
            mergedPropsStyles[i].style[key] = styleValue;
          }
        }
      }

      // unlike the other 2 components, we can't detect staleness and optionally
      // opt out of setState here. each style object's data might contain new
      // stuff we're not/cannot compare
      _this.setState({
        currentStyles: currentStyles,
        currentVelocities: currentVelocities,
        mergedPropsStyles: mergedPropsStyles,
        lastIdealStyles: lastIdealStyles,
        lastIdealVelocities: lastIdealVelocities
      });
    };

    this.startAnimationIfNecessary = function () {
      if (_this.unmounting) {
        return;
      }

      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // https://github.com/chenglou/react-motion/pull/420
        // > if execution passes the conditional if (this.unmounting), then
        // executes async defaultRaf and after that component unmounts and after
        // that the callback of defaultRaf is called, then setState will be called
        // on unmounted component.
        if (_this.unmounting) {
          return;
        }

        var propStyles = _this.props.styles;
        var destStyles = typeof propStyles === 'function' ? propStyles(rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;

        // check if we need to animate in the first place
        if (shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.accumulatedTime = 0;
          return;
        }

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var _mergeAndSync2 = mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);

        var newMergedPropsStyles = _mergeAndSync2[0];
        var newCurrentStyles = _mergeAndSync2[1];
        var newCurrentVelocities = _mergeAndSync2[2];
        var newLastIdealStyles = _mergeAndSync2[3];
        var newLastIdealVelocities = _mergeAndSync2[4];

        for (var i = 0; i < newMergedPropsStyles.length; i++) {
          var newMergedPropsStyle = newMergedPropsStyles[i].style;
          var newCurrentStyle = {};
          var newCurrentVelocity = {};
          var newLastIdealStyle = {};
          var newLastIdealVelocity = {};

          for (var key in newMergedPropsStyle) {
            if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) {
              continue;
            }

            var styleValue = newMergedPropsStyle[key];
            if (typeof styleValue === 'number') {
              newCurrentStyle[key] = styleValue;
              newCurrentVelocity[key] = 0;
              newLastIdealStyle[key] = styleValue;
              newLastIdealVelocity[key] = 0;
            } else {
              var newLastIdealStyleValue = newLastIdealStyles[i][key];
              var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
              for (var j = 0; j < framesToCatchUp; j++) {
                var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

                newLastIdealStyleValue = _stepper[0];
                newLastIdealVelocityValue = _stepper[1];
              }

              var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              var nextIdealX = _stepper2[0];
              var nextIdealV = _stepper2[1];

              newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
              newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
              newLastIdealStyle[key] = newLastIdealStyleValue;
              newLastIdealVelocity[key] = newLastIdealVelocityValue;
            }
          }

          newLastIdealStyles[i] = newLastIdealStyle;
          newLastIdealVelocities[i] = newLastIdealVelocity;
          newCurrentStyles[i] = newCurrentStyle;
          newCurrentVelocities[i] = newCurrentVelocity;
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyles: newCurrentStyles,
          currentVelocities: newCurrentVelocities,
          lastIdealStyles: newLastIdealStyles,
          lastIdealVelocities: newLastIdealVelocities,
          mergedPropsStyles: newMergedPropsStyles
        });

        _this.unreadPropStyles = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  TransitionMotion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyles = _props.defaultStyles;
    var styles = _props.styles;
    var willEnter = _props.willEnter;
    var willLeave = _props.willLeave;
    var didLeave = _props.didLeave;

    var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;

    // this is special. for the first time around, we don't have a comparison
    // between last (no last) and current merged props. we'll compute last so:
    // say default is {a, b} and styles (dest style) is {b, c}, we'll
    // fabricate last as {a, b}
    var oldMergedPropsStyles = undefined;
    if (defaultStyles == null) {
      oldMergedPropsStyles = destStyles;
    } else {
      oldMergedPropsStyles = defaultStyles.map(function (defaultStyleCell) {
        // TODO: key search code
        for (var i = 0; i < destStyles.length; i++) {
          if (destStyles[i].key === defaultStyleCell.key) {
            return destStyles[i];
          }
        }
        return defaultStyleCell;
      });
    }
    var oldCurrentStyles = defaultStyles == null ? destStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _stripStyle2['default'](s.style);
    });
    var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    }) : defaultStyles.map(function (s) {
      return _mapToZero2['default'](s.style);
    });

    var _mergeAndSync3 = mergeAndSync(
    // Because this is an old-style createReactClass component, Flow doesn't
    // understand that the willEnter and willLeave props have default values
    // and will always be present.
    willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, // oldLastIdealStyles really
    oldCurrentVelocities);

    var mergedPropsStyles = _mergeAndSync3[0];
    var currentStyles = _mergeAndSync3[1];
    var currentVelocities = _mergeAndSync3[2];
    var lastIdealStyles = _mergeAndSync3[3];
    var lastIdealVelocities = _mergeAndSync3[4];
    // oldLastIdealVelocities really

    return {
      currentStyles: currentStyles,
      currentVelocities: currentVelocities,
      lastIdealStyles: lastIdealStyles,
      lastIdealVelocities: lastIdealVelocities,
      mergedPropsStyles: mergedPropsStyles
    };
  };

  // after checking for unreadPropStyles != null, we manually go set the
  // non-interpolating values (those that are a number, without a spring
  // config)

  TransitionMotion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyles) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyles);
    }

    var styles = props.styles;
    if (typeof styles === 'function') {
      this.unreadPropStyles = styles(rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
    } else {
      this.unreadPropStyles = styles;
    }

    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounting = true;
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  TransitionMotion.prototype.render = function render() {
    var hydratedStyles = rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
    var renderedChildren = this.props.children(hydratedStyles);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return TransitionMotion;
})(_react2['default'].Component);

exports['default'] = TransitionMotion;
module.exports = exports['default'];

// list of styles, each containing interpolating values. Part of what's passed
// to children function. Notice that this is
// Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
// data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
// contains the key & data info (so that we only have a single source of truth
// for these, and to save space). Check the comment for `rehydrateStyles` to
// see how we regenerate the entirety of what's passed to children function

// the array that keeps track of currently rendered stuff! Including stuff
// that you've unmounted but that's still animating. This is where it lives

// it's possible that currentStyle's value is stale: if props is immediately
// changed from 0 to 400 to spring(0) again, the async currentStyle is still
// at 0 (didn't have time to tick and interpolate even once). If we naively
// compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
// In reality currentStyle should be 400

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?

// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous

// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a

// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements


exports.__esModule = true;
exports['default'] = mergeDiff;

function mergeDiff(prev, next, onRemove) {
  // bookkeeping for easier access of a key's index below. This is 2 allocations +
  // potentially triggering chrome hash map mode for objs (so it might be faster

  var prevKeyIndex = {};
  for (var i = 0; i < prev.length; i++) {
    prevKeyIndex[prev[i].key] = i;
  }
  var nextKeyIndex = {};
  for (var i = 0; i < next.length; i++) {
    nextKeyIndex[next[i].key] = i;
  }

  // first, an overly elaborate way of merging prev and next, eliminating
  // duplicates (in terms of keys). If there's dupe, keep the item in next).
  // This way of writing it saves allocations
  var ret = [];
  for (var i = 0; i < next.length; i++) {
    ret[i] = next[i];
  }
  for (var i = 0; i < prev.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
      // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
      // merge in keys that the user desires to kill
      var fill = onRemove(i, prev[i]);
      if (fill != null) {
        ret.push(fill);
      }
    }
  }

  // now all the items all present. Core sorting logic to have the right order
  return ret.sort(function (a, b) {
    var nextOrderA = nextKeyIndex[a.key];
    var nextOrderB = nextKeyIndex[b.key];
    var prevOrderA = prevKeyIndex[a.key];
    var prevOrderB = prevKeyIndex[b.key];

    if (nextOrderA != null && nextOrderB != null) {
      // both keys in next
      return nextKeyIndex[a.key] - nextKeyIndex[b.key];
    } else if (prevOrderA != null && prevOrderB != null) {
      // both keys in prev
      return prevKeyIndex[a.key] - prevKeyIndex[b.key];
    } else if (nextOrderA != null) {
      // key a in next, key b in prev

      // how to determine the order between a and b? We find a "pivot" (term
      // abuse), a key present in both prev and next, that is sandwiched between
      // a and b. In the context of our above example, if we're comparing a and
      // d, b's (the only) pivot
      for (var i = 0; i < next.length; i++) {
        var pivot = next[i].key;
        if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
          continue;
        }

        if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) {
          return -1;
        } else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) {
          return 1;
        }
      }
      // pluggable. default to: next bigger than prev
      return 1;
    }
    // prevOrderA, nextOrderB
    for (var i = 0; i < next.length; i++) {
      var pivot = next[i].key;
      if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) {
        continue;
      }
      if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) {
        return 1;
      } else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) {
        return -1;
      }
    }
    // pluggable. default to: next bigger than prev
    return -1;
  });
}

module.exports = exports['default'];
// to loop through and find a key's index each time), but I no longer care

/***/ }),
/* 1762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = spring;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _presets = __webpack_require__(694);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 1763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = reorderKeys;

var hasWarned = false;

function reorderKeys() {
  if (false) {
    if (!hasWarned) {
      hasWarned = true;
      console.error('`reorderKeys` has been removed, since it is no longer needed for TransitionMotion\'s new styles array API.');
    }
  }
}

module.exports = exports['default'];

/***/ }),
/* 1764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

exports.__esModule = true;
exports.default = void 0;

var _shouldUpdate = _interopRequireDefault(__webpack_require__(1765));

var _shallowEqual = _interopRequireDefault(__webpack_require__(1768));

var _setDisplayName = _interopRequireDefault(__webpack_require__(695));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(696));

var pure = function pure(BaseComponent) {
  var hoc = (0, _shouldUpdate.default)(function (props, nextProps) {
    return !(0, _shallowEqual.default)(props, nextProps);
  });

  if (false) {
    return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var _default = pure;
exports.default = _default;

/***/ }),
/* 1765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

exports.__esModule = true;
exports.default = void 0;

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(271));

var _react = __webpack_require__(0);

var _setDisplayName = _interopRequireDefault(__webpack_require__(695));

var _wrapDisplayName = _interopRequireDefault(__webpack_require__(696));

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = (0, _react.createFactory)(BaseComponent);

    var ShouldUpdate =
    /*#__PURE__*/
    function (_Component) {
      (0, _inheritsLoose2.default)(ShouldUpdate, _Component);

      function ShouldUpdate() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = ShouldUpdate.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      _proto.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(_react.Component);

    if (false) {
      return (0, _setDisplayName.default)((0, _wrapDisplayName.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }

    return ShouldUpdate;
  };
};

var _default = shouldUpdate;
exports.default = _default;

/***/ }),
/* 1766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */

    return BaseComponent;
  };
};

var _default = setStatic;
exports.default = _default;

/***/ }),
/* 1767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var getDisplayName = function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || 'Component';
};

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 1768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

exports.__esModule = true;
exports.default = void 0;

var _shallowEqual = _interopRequireDefault(__webpack_require__(1769));

var _default = _shallowEqual.default;
exports.default = _default;

/***/ }),
/* 1769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 1770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SvgIcon.default;
  }
});

var _SvgIcon = _interopRequireDefault(__webpack_require__(1771));

/***/ }),
/* 1771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.styles = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(103));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(6));

var _classnames = _interopRequireDefault(__webpack_require__(97));

var _utils = __webpack_require__(280);

var _withStyles = _interopRequireDefault(__webpack_require__(1778));

var _helpers = __webpack_require__(1841);

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: 24,
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: 20
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: 35
    }
  };
};

exports.styles = styles;

function SvgIcon(props) {
  var _classNames;

  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      Component = props.component,
      fontSize = props.fontSize,
      nativeColor = props.nativeColor,
      titleAccess = props.titleAccess,
      viewBox = props.viewBox,
      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "nativeColor", "titleAccess", "viewBox"]);
  return _react.default.createElement(Component, (0, _extends2.default)({
    className: (0, _classnames.default)(classes.root, (_classNames = {}, (0, _defineProperty2.default)(_classNames, classes["color".concat((0, _helpers.capitalize)(color))], color !== 'inherit'), (0, _defineProperty2.default)(_classNames, classes["fontSize".concat((0, _helpers.capitalize)(fontSize))], fontSize !== 'default'), _classNames), className),
    focusable: "false",
    viewBox: viewBox,
    color: nativeColor,
    "aria-hidden": titleAccess ? 'false' : 'true',
    role: titleAccess ? 'img' : 'presentation'
  }, other), children, titleAccess ? _react.default.createElement("title", null, titleAccess) : null);
}

 false ? SvgIcon.propTypes = {
  /**
   * Node passed into the SVG element.
   */
  children: _propTypes.default.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _utils.componentPropType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large']),

  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes.default.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: _propTypes.default.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes.default.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes.default.string
} : void 0;
SvgIcon.defaultProps = {
  color: 'inherit',
  component: 'svg',
  fontSize: 'default',
  viewBox: '0 0 24 24'
};
SvgIcon.muiName = 'SvgIcon';

var _default = (0, _withStyles.default)(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon);

exports.default = _default;

/***/ }),
/* 1772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(__webpack_require__(281));

var _reactIs = __webpack_require__(697);

/**
 * A factory that returns a propTypes validator that only accepts values that
 * are also accepted by React.createElement
 * e.g. "div", functional, class components, forwardRef etc.
 *
 * @param {boolean} isRequired If `true` returns a validator
 *                             that will throw if nullish values are passed
 */
function createComponentProp(isRequired) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function componentPropType(props, key, componentName, location, propFullName) {
    var prop = props[key];
    var propName = propFullName || key;
    var message;

    if (prop == null) {
      if (isRequired) {
        message = "The ".concat(location, " `").concat(propName, "` is marked as required in `").concat(componentName, "`, ") + "but its value is `".concat((0, _typeof2.default)(prop), "`.");
      }
    } else if (!(0, _reactIs.isValidElementType)(prop)) {
      var preciseType = (0, _typeof2.default)(prop);
      message = "Invalid ".concat(location, " `").concat(propName, "` of type `").concat(preciseType, "` ") + "supplied to `".concat(componentName, "`, expected a component.");
    }

    if (message != null) {
      // change error message slightly on every check to prevent caching when testing
      // which would not trigger console errors on subsequent fails
      return new Error("".concat(message).concat( false ? Date.now() : ''));
    }

    return null;
  };
}

var componentPropType = createComponentProp(false);
componentPropType.isRequired = createComponentProp(true);
var _default = componentPropType;
exports.default = _default;

/***/ }),
/* 1773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.8.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.memo"):
60115,r=b?Symbol.for("react.lazy"):60116;function t(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case h:return a;default:return u}}case r:case q:case d:return u}}}function v(a){return t(a)===m}exports.typeOf=t;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;
exports.Fragment=e;exports.Lazy=r;exports.Memo=q;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||"object"===typeof a&&null!==a&&(a.$$typeof===r||a.$$typeof===q||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n)};exports.isAsyncMode=function(a){return v(a)||t(a)===l};exports.isConcurrentMode=v;exports.isContextConsumer=function(a){return t(a)===k};
exports.isContextProvider=function(a){return t(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return t(a)===n};exports.isFragment=function(a){return t(a)===e};exports.isLazy=function(a){return t(a)===r};exports.isMemo=function(a){return t(a)===q};exports.isPortal=function(a){return t(a)===d};exports.isProfiler=function(a){return t(a)===g};exports.isStrictMode=function(a){return t(a)===f};
exports.isSuspense=function(a){return t(a)===p};


/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function chainPropTypes(propType1, propType2) {
  /* istanbul ignore if */
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var _default = chainPropTypes;
exports.default = _default;

/***/ }),
/* 1775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.specialProperty = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(103));

var _extends3 = _interopRequireDefault(__webpack_require__(62));

// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
exports.specialProperty = specialProperty;

function exactProp(propTypes) {
  /* istanbul ignore if */
  if (true) {
    return propTypes;
  }

  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following properties are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

var _default = exactProp;
exports.default = _default;

/***/ }),
/* 1776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFunctionName = getFunctionName;
exports.default = void 0;
// Fork of recompose/getDisplayName with added IE 11 support
// Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;

function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}

function getDisplayName(Component) {
  if (typeof Component === 'string') {
    return Component;
  }

  if (!Component) {
    return undefined;
  }

  return Component.displayName || Component.name || getFunctionName(Component) || 'Component';
}

var _default = getDisplayName;
exports.default = _default;

/***/ }),
/* 1777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

exports.default = _default;

/***/ }),
/* 1778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.sheetsManager = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(103));

var _extends3 = _interopRequireDefault(__webpack_require__(62));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(1779));

var _createClass2 = _interopRequireDefault(__webpack_require__(1780));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1781));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1782));

var _inherits2 = _interopRequireDefault(__webpack_require__(1783));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(6));

var _warning = _interopRequireDefault(__webpack_require__(93));

var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(1785));

var _utils = __webpack_require__(280);

var _jss = __webpack_require__(698);

var _reactJssContext = _interopRequireDefault(__webpack_require__(1803));

var _jssPreset = _interopRequireDefault(__webpack_require__(1804));

var _mergeClasses = _interopRequireDefault(__webpack_require__(1817));

var _multiKeyStore = _interopRequireDefault(__webpack_require__(1818));

var _createMuiTheme = _interopRequireDefault(__webpack_require__(1819));

var _themeListener = _interopRequireDefault(__webpack_require__(1837));

var _createGenerateClassName = _interopRequireDefault(__webpack_require__(1838));

var _getStylesCreator = _interopRequireDefault(__webpack_require__(1839));

var _getThemeProps = _interopRequireDefault(__webpack_require__(1840));

/* eslint-disable no-underscore-dangle */
// Default JSS instance.
var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = (0, _createGenerateClassName.default)(); // Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.

var indexCounter = -10e10; // Exported for test purposes

var sheetsManager = new Map(); // We use the same empty object to ref count the styles that don't need a theme object.

exports.sheetsManager = sheetsManager;
var noopTheme = {}; // In order to have self-supporting components, we rely on default theme when not provided.

var defaultTheme = (0, _createMuiTheme.default)({
  typography: {
    suppressWarning: true
  }
}); // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStylesOld = function withStylesOld(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var _extends2;

    var _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$flip = options.flip,
        flip = _options$flip === void 0 ? null : _options$flip,
        name = options.name,
        styleSheetOptions = (0, _objectWithoutProperties2.default)(options, ["withTheme", "flip", "name"]);
    var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
    var listenToTheme = stylesCreator.themingEnabled || typeof name === 'string' || withTheme;
    indexCounter += 1;
    stylesCreator.options.index = indexCounter;
     false ? (0, _warning.default)(indexCounter < 0, ['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n')) : void 0;

    var WithStyles =
    /*#__PURE__*/
    function (_React$Component) {
      (0, _inherits2.default)(WithStyles, _React$Component);

      function WithStyles(props, context) {
        var _this;

        (0, _classCallCheck2.default)(this, WithStyles);
        _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(WithStyles).call(this, props, context));
        _this.jss = context[_reactJssContext.default.jss] || jss;
        _this.sheetsManager = sheetsManager;
        _this.unsubscribeId = null;
        var muiThemeProviderOptions = context.muiThemeProviderOptions;

        if (muiThemeProviderOptions) {
          if (muiThemeProviderOptions.sheetsManager) {
            _this.sheetsManager = muiThemeProviderOptions.sheetsManager;
          }

          _this.sheetsCache = muiThemeProviderOptions.sheetsCache;
          _this.disableStylesGeneration = muiThemeProviderOptions.disableStylesGeneration;
        } // Attach the stylesCreator to the instance of the component as in the context
        // of react-hot-loader the hooks can be executed in a different closure context:
        // https://github.com/gaearon/react-hot-loader/blob/master/src/patch.dev.js#L107


        _this.stylesCreatorSaved = stylesCreator;
        _this.sheetOptions = (0, _extends3.default)({
          generateClassName: generateClassName
        }, context[_reactJssContext.default.sheetOptions]); // We use || as the function call is lazy evaluated.

        _this.theme = listenToTheme ? _themeListener.default.initial(context) || defaultTheme : noopTheme;

        _this.attach(_this.theme);

        _this.cacheClasses = {
          // Cache for the finalized classes value.
          value: null,
          // Cache for the last used classes prop pointer.
          lastProp: null,
          // Cache for the last used rendered classes pointer.
          lastJSS: {}
        };
        return _this;
      }

      (0, _createClass2.default)(WithStyles, [{
        key: "componentDidMount",
        value: function componentDidMount() {
          var _this2 = this;

          if (!listenToTheme) {
            return;
          }

          this.unsubscribeId = _themeListener.default.subscribe(this.context, function (theme) {
            var oldTheme = _this2.theme;
            _this2.theme = theme;

            _this2.attach(_this2.theme); // Rerender the component so the underlying component gets the theme update.
            // By theme update we mean receiving and applying the new class names.


            _this2.setState({}, function () {
              _this2.detach(oldTheme);
            });
          });
        }
      }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate() {
          // react-hot-loader specific logic
          if (this.stylesCreatorSaved === stylesCreator || "production" === 'production') {
            return;
          }

          this.detach(this.theme);
          this.stylesCreatorSaved = stylesCreator;
          this.attach(this.theme);
          this.forceUpdate();
        }
      }, {
        key: "componentWillUnmount",
        value: function componentWillUnmount() {
          this.detach(this.theme);

          if (this.unsubscribeId !== null) {
            _themeListener.default.unsubscribe(this.context, this.unsubscribeId);
          }
        }
      }, {
        key: "getClasses",
        value: function getClasses() {
          if (this.disableStylesGeneration) {
            return this.props.classes || {};
          } // Tracks if either the rendered classes or classes prop has changed,
          // requiring the generation of a new finalized classes object.


          var generate = false;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, this.theme);

          if (sheetManager.sheet.classes !== this.cacheClasses.lastJSS) {
            this.cacheClasses.lastJSS = sheetManager.sheet.classes;
            generate = true;
          }

          if (this.props.classes !== this.cacheClasses.lastProp) {
            this.cacheClasses.lastProp = this.props.classes;
            generate = true;
          }

          if (generate) {
            this.cacheClasses.value = (0, _mergeClasses.default)({
              baseClasses: this.cacheClasses.lastJSS,
              newClasses: this.props.classes,
              Component: Component
            });
          }

          return this.cacheClasses.value;
        }
      }, {
        key: "attach",
        value: function attach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var stylesCreatorSaved = this.stylesCreatorSaved;

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, stylesCreatorSaved, theme);

          if (!sheetManager) {
            sheetManager = {
              refs: 0,
              sheet: null
            };

            _multiKeyStore.default.set(this.sheetsManager, stylesCreatorSaved, theme, sheetManager);
          }

          if (sheetManager.refs === 0) {
            var sheet;

            if (this.sheetsCache) {
              sheet = _multiKeyStore.default.get(this.sheetsCache, stylesCreatorSaved, theme);
            }

            if (!sheet) {
              sheet = this.createSheet(theme);
              sheet.attach();

              if (this.sheetsCache) {
                _multiKeyStore.default.set(this.sheetsCache, stylesCreatorSaved, theme, sheet);
              }
            }

            sheetManager.sheet = sheet;
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.add(sheet);
            }
          }

          sheetManager.refs += 1;
        }
      }, {
        key: "createSheet",
        value: function createSheet(theme) {
          var styles = this.stylesCreatorSaved.create(theme, name);
          var meta = name;

          if (false) {
            // Provide a better DX outside production.
            meta = (0, _utils.getDisplayName)(Component);
            process.env.NODE_ENV !== "production" ? (0, _warning.default)(typeof meta === 'string', ['Material-UI: the component displayName is invalid. It needs to be a string.', "Please fix the following component: ".concat(Component, ".")].join('\n')) : void 0;
          }

          var sheet = this.jss.createStyleSheet(styles, (0, _extends3.default)({
            meta: meta,
            classNamePrefix: meta,
            flip: typeof flip === 'boolean' ? flip : theme.direction === 'rtl',
            link: false
          }, this.sheetOptions, this.stylesCreatorSaved.options, {
            name: name || Component.displayName
          }, styleSheetOptions));
          return sheet;
        }
      }, {
        key: "detach",
        value: function detach(theme) {
          if (this.disableStylesGeneration) {
            return;
          }

          var sheetManager = _multiKeyStore.default.get(this.sheetsManager, this.stylesCreatorSaved, theme);

          sheetManager.refs -= 1;

          if (sheetManager.refs === 0) {
            _multiKeyStore.default.delete(this.sheetsManager, this.stylesCreatorSaved, theme);

            this.jss.removeStyleSheet(sheetManager.sheet);
            var sheetsRegistry = this.context[_reactJssContext.default.sheetsRegistry];

            if (sheetsRegistry) {
              sheetsRegistry.remove(sheetManager.sheet);
            }
          }
        }
      }, {
        key: "render",
        value: function render() {
          var _this$props = this.props,
              classes = _this$props.classes,
              innerRef = _this$props.innerRef,
              other = (0, _objectWithoutProperties2.default)(_this$props, ["classes", "innerRef"]);
          var more = (0, _getThemeProps.default)({
            theme: this.theme,
            name: name,
            props: other
          }); // Provide the theme to the wrapped component.
          // So we don't have to use the `withTheme()` Higher-order Component.

          if (withTheme && !more.theme) {
            more.theme = this.theme;
          }

          return _react.default.createElement(Component, (0, _extends3.default)({}, more, {
            classes: this.getClasses(),
            ref: innerRef
          }));
        }
      }]);
      return WithStyles;
    }(_react.default.Component);

     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: _propTypes.default.object,

      /**
       * Use that property to pass a ref callback to the decorated component.
       */
      innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object])
    } : void 0;
    WithStyles.contextTypes = (0, _extends3.default)((_extends2 = {
      muiThemeProviderOptions: _propTypes.default.object
    }, (0, _defineProperty2.default)(_extends2, _reactJssContext.default.jss, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetOptions, _propTypes.default.object), (0, _defineProperty2.default)(_extends2, _reactJssContext.default.sheetsRegistry, _propTypes.default.object), _extends2), listenToTheme ? _themeListener.default.contextTypes : {});

    if (false) {
      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
    }

    (0, _hoistNonReactStatics.default)(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
    }

    return WithStyles;
  };
};
/* istanbul ignore if */


if (!_utils.ponyfillGlobal.__MUI_STYLES__) {
  _utils.ponyfillGlobal.__MUI_STYLES__ = {};
}

if (!_utils.ponyfillGlobal.__MUI_STYLES__.withStyles) {
  _utils.ponyfillGlobal.__MUI_STYLES__.withStyles = withStylesOld;
}

var _default = function _default(styles, options) {
  return _utils.ponyfillGlobal.__MUI_STYLES__.withStyles(styles, (0, _extends3.default)({
    defaultTheme: defaultTheme
  }, options));
};

exports.default = _default;

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 1780 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(281);

var assertThisInitialized = __webpack_require__(270);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1784);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 1784 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 1785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var ReactIs = __webpack_require__(697);
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};

var MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};

var TYPE_STATICS = {};
TYPE_STATICS[ReactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
    if (ReactIs.isMemo(component)) {
        return MEMO_STATICS;
    }
    return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        var targetStatics = getStatics(targetComponent);
        var sourceStatics = getStatics(sourceComponent);

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = getDynamicStyles;
/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);
      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/***/ }),
/* 1787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager = function () {
  function SheetsManager() {
    _classCallCheck(this, SheetsManager);

    this.sheets = [];
    this.refs = [];
    this.keys = [];
  }

  _createClass(SheetsManager, [{
    key: 'get',
    value: function get(key) {
      var index = this.keys.indexOf(key);
      return this.sheets[index];
    }
  }, {
    key: 'add',
    value: function add(key, sheet) {
      var sheets = this.sheets,
          refs = this.refs,
          keys = this.keys;

      var index = sheets.indexOf(sheet);

      if (index !== -1) return index;

      sheets.push(sheet);
      refs.push(0);
      keys.push(key);

      return sheets.length - 1;
    }
  }, {
    key: 'manage',
    value: function manage(key) {
      var index = this.keys.indexOf(key);
      var sheet = this.sheets[index];
      if (this.refs[index] === 0) sheet.attach();
      this.refs[index]++;
      if (!this.keys[index]) this.keys.splice(index, 0, key);
      return sheet;
    }
  }, {
    key: 'unmanage',
    value: function unmanage(key) {
      var index = this.keys.indexOf(key);
      if (index === -1) {
        // eslint-ignore-next-line no-console
        (0, _warning2['default'])(false, "SheetsManager: can't find sheet to unmanage");
        return;
      }
      if (this.refs[index] > 0) {
        this.refs[index]--;
        if (this.refs[index] === 0) this.sheets[index].detach();
      }
    }
  }, {
    key: 'size',
    get: function get() {
      return this.keys.length;
    }
  }]);

  return SheetsManager;
}();

exports['default'] = SheetsManager;

/***/ }),
/* 1788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = cloneStyle;

var _isObservable = __webpack_require__(700);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var isArray = Array.isArray;
function cloneStyle(style) {
  // Support empty values in case user ends up with them by accident.
  if (style == null) return style;

  // Support string value for SimpleRule.
  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);

  if (typeOfStyle === 'string' || typeOfStyle === 'number' || typeOfStyle === 'function') {
    return style;
  }

  // Support array for FontFaceRule.
  if (isArray(style)) return style.map(cloneStyle);

  // Support Observable styles.  Observables are immutable, so we don't need to
  // copy them.
  if ((0, _isObservable2['default'])(style)) return style;

  var newStyle = {};
  for (var name in style) {
    var value = style[name];
    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      newStyle[name] = cloneStyle(value);
      continue;
    }
    newStyle[name] = value;
  }

  return newStyle;
}

/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var CSS = global.CSS;

var env = "production";

var escapeRegex = /([[\].#*$><+~=|^:(),"'`])/g;

exports['default'] = function (str) {
  // We don't need to escape it in production, because we are not using user's
  // input for selectors, we are generating a valid selector.
  if (env === 'production') return str;

  if (!CSS || !CSS.escape) {
    return str.replace(escapeRegex, '\\$1');
  }

  return CSS.escape(str);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (global[ns] == null) global[ns] = 0;

// Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.
exports['default'] = global[ns]++;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isInBrowser = __webpack_require__(284);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _StyleSheet = __webpack_require__(703);

var _StyleSheet2 = _interopRequireDefault(_StyleSheet);

var _PluginsRegistry = __webpack_require__(1792);

var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);

var _rules = __webpack_require__(1793);

var _rules2 = _interopRequireDefault(_rules);

var _observables = __webpack_require__(1799);

var _observables2 = _interopRequireDefault(_observables);

var _functions = __webpack_require__(1800);

var _functions2 = _interopRequireDefault(_functions);

var _sheets = __webpack_require__(439);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(167);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createGenerateClassName = __webpack_require__(702);

var _createGenerateClassName2 = _interopRequireDefault(_createGenerateClassName);

var _createRule2 = __webpack_require__(283);

var _createRule3 = _interopRequireDefault(_createRule2);

var _DomRenderer = __webpack_require__(1801);

var _DomRenderer2 = _interopRequireDefault(_DomRenderer);

var _VirtualRenderer = __webpack_require__(1802);

var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var defaultPlugins = _rules2['default'].concat([_observables2['default'], _functions2['default']]);

var instanceCounter = 0;

var Jss = function () {
  function Jss(options) {
    _classCallCheck(this, Jss);

    this.id = instanceCounter++;
    this.version = "9.8.7";
    this.plugins = new _PluginsRegistry2['default']();
    this.options = {
      createGenerateClassName: _createGenerateClassName2['default'],
      Renderer: _isInBrowser2['default'] ? _DomRenderer2['default'] : _VirtualRenderer2['default'],
      plugins: []
    };
    this.generateClassName = (0, _createGenerateClassName2['default'])();

    // eslint-disable-next-line prefer-spread
    this.use.apply(this, defaultPlugins);
    this.setup(options);
  }

  _createClass(Jss, [{
    key: 'setup',
    value: function setup() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (options.createGenerateClassName) {
        this.options.createGenerateClassName = options.createGenerateClassName;
        // $FlowFixMe
        this.generateClassName = options.createGenerateClassName();
      }

      if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
      if (options.virtual || options.Renderer) {
        this.options.Renderer = options.Renderer || (options.virtual ? _VirtualRenderer2['default'] : _DomRenderer2['default']);
      }

      // eslint-disable-next-line prefer-spread
      if (options.plugins) this.use.apply(this, options.plugins);

      return this;
    }

    /**
     * Create a Style Sheet.
     */

  }, {
    key: 'createStyleSheet',
    value: function createStyleSheet(styles) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var index = options.index;
      if (typeof index !== 'number') {
        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
      }
      var sheet = new _StyleSheet2['default'](styles, _extends({}, options, {
        jss: this,
        generateClassName: options.generateClassName || this.generateClassName,
        insertionPoint: this.options.insertionPoint,
        Renderer: this.options.Renderer,
        index: index
      }));
      this.plugins.onProcessSheet(sheet);

      return sheet;
    }

    /**
     * Detach the Style Sheet and remove it from the registry.
     */

  }, {
    key: 'removeStyleSheet',
    value: function removeStyleSheet(sheet) {
      sheet.detach();
      _sheets2['default'].remove(sheet);
      return this;
    }

    /**
     * Create a rule without a Style Sheet.
     */

  }, {
    key: 'createRule',
    value: function createRule(name) {
      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      // Enable rule without name for inline styles.
      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
        options = style;
        style = name;
        name = undefined;
      }

      // Cast from RuleFactoryOptions to RuleOptions
      // https://stackoverflow.com/questions/41328728/force-casting-in-flow
      var ruleOptions = options;

      ruleOptions.jss = this;
      ruleOptions.Renderer = this.options.Renderer;
      if (!ruleOptions.generateClassName) ruleOptions.generateClassName = this.generateClassName;
      if (!ruleOptions.classes) ruleOptions.classes = {};
      var rule = (0, _createRule3['default'])(name, style, ruleOptions);

      if (!ruleOptions.selector && rule instanceof _StyleRule2['default']) {
        rule.selector = '.' + ruleOptions.generateClassName(rule);
      }

      this.plugins.onProcessRule(rule);

      return rule;
    }

    /**
     * Register plugin. Passed function will be invoked with a rule instance.
     */

  }, {
    key: 'use',
    value: function use() {
      var _this = this;

      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
        plugins[_key] = arguments[_key];
      }

      plugins.forEach(function (plugin) {
        // Avoids applying same plugin twice, at least based on ref.
        if (_this.options.plugins.indexOf(plugin) === -1) {
          _this.options.plugins.push(plugin);
          _this.plugins.use(plugin);
        }
      });

      return this;
    }
  }]);

  return Jss;
}();

exports['default'] = Jss;

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PluginsRegistry = function () {
  function PluginsRegistry() {
    _classCallCheck(this, PluginsRegistry);

    this.hooks = {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []

      /**
       * Call `onCreateRule` hooks and return an object if returned by a hook.
       */
    };
  }

  _createClass(PluginsRegistry, [{
    key: 'onCreateRule',
    value: function onCreateRule(name, decl, options) {
      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
        var rule = this.hooks.onCreateRule[i](name, decl, options);
        if (rule) return rule;
      }
      return null;
    }

    /**
     * Call `onProcessRule` hooks.
     */

  }, {
    key: 'onProcessRule',
    value: function onProcessRule(rule) {
      if (rule.isProcessed) return;
      var sheet = rule.options.sheet;

      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
        this.hooks.onProcessRule[i](rule, sheet);
      }

      // $FlowFixMe
      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);

      rule.isProcessed = true;
    }

    /**
     * Call `onProcessStyle` hooks.
     */

  }, {
    key: 'onProcessStyle',
    value: function onProcessStyle(style, rule, sheet) {
      var nextStyle = style;

      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
        nextStyle = this.hooks.onProcessStyle[i](nextStyle, rule, sheet);
        // $FlowFixMe
        rule.style = nextStyle;
      }
    }

    /**
     * Call `onProcessSheet` hooks.
     */

  }, {
    key: 'onProcessSheet',
    value: function onProcessSheet(sheet) {
      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
        this.hooks.onProcessSheet[i](sheet);
      }
    }

    /**
     * Call `onUpdate` hooks.
     */

  }, {
    key: 'onUpdate',
    value: function onUpdate(data, rule, sheet) {
      for (var i = 0; i < this.hooks.onUpdate.length; i++) {
        this.hooks.onUpdate[i](data, rule, sheet);
      }
    }

    /**
     * Call `onChangeValue` hooks.
     */

  }, {
    key: 'onChangeValue',
    value: function onChangeValue(value, prop, rule) {
      var processedValue = value;
      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
      }
      return processedValue;
    }

    /**
     * Register a plugin.
     * If function is passed, it is a shortcut for `{onProcessRule}`.
     */

  }, {
    key: 'use',
    value: function use(plugin) {
      for (var name in plugin) {
        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
      }
    }
  }]);

  return PluginsRegistry;
}();

exports['default'] = PluginsRegistry;

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SimpleRule = __webpack_require__(1794);

var _SimpleRule2 = _interopRequireDefault(_SimpleRule);

var _KeyframesRule = __webpack_require__(1795);

var _KeyframesRule2 = _interopRequireDefault(_KeyframesRule);

var _ConditionalRule = __webpack_require__(1796);

var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);

var _FontFaceRule = __webpack_require__(1797);

var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);

var _ViewportRule = __webpack_require__(1798);

var _ViewportRule2 = _interopRequireDefault(_ViewportRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var classes = {
  '@charset': _SimpleRule2['default'],
  '@import': _SimpleRule2['default'],
  '@namespace': _SimpleRule2['default'],
  '@keyframes': _KeyframesRule2['default'],
  '@media': _ConditionalRule2['default'],
  '@supports': _ConditionalRule2['default'],
  '@font-face': _FontFaceRule2['default'],
  '@viewport': _ViewportRule2['default'],
  '@-ms-viewport': _ViewportRule2['default']

  /**
   * Generate plugins which will register all rules.
   */
};
var plugins = Object.keys(classes).map(function (key) {
  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
  var re = new RegExp('^' + key);
  var RuleClass = classes[key];
  var onCreateRule = function onCreateRule(name, decl, options) {
    return re.test(name) ? new RuleClass(name, decl, options) : null;
  };
  return { onCreateRule: onCreateRule };
});

exports['default'] = plugins;

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SimpleRule = function () {
  function SimpleRule(key, value, options) {
    _classCallCheck(this, SimpleRule);

    this.type = 'simple';
    this.isProcessed = false;

    this.key = key;
    this.value = value;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  _createClass(SimpleRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.value)) {
        var str = '';
        for (var index = 0; index < this.value.length; index++) {
          str += this.key + ' ' + this.value[index] + ';';
          if (this.value[index + 1]) str += '\n';
        }
        return str;
      }

      return this.key + ' ' + this.value + ';';
    }
  }]);

  return SimpleRule;
}();

exports['default'] = SimpleRule;

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(208);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Rule for @keyframes
 */
var KeyframesRule = function () {
  function KeyframesRule(key, frames, options) {
    _classCallCheck(this, KeyframesRule);

    this.type = 'keyframes';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in frames) {
      this.rules.add(name, frames[name], _extends({}, this.options, {
        parent: this,
        selector: name
      }));
    }

    this.rules.process();
  }

  /**
   * Generates a CSS string.
   */


  _createClass(KeyframesRule, [{
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      if (inner) inner += '\n';
      return this.key + ' {\n' + inner + '}';
    }
  }]);

  return KeyframesRule;
}();

exports['default'] = KeyframesRule;

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _RuleList = __webpack_require__(208);

var _RuleList2 = _interopRequireDefault(_RuleList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Conditional rule for @media, @supports
 */
var ConditionalRule = function () {
  function ConditionalRule(key, styles, options) {
    _classCallCheck(this, ConditionalRule);

    this.type = 'conditional';
    this.isProcessed = false;

    this.key = key;
    this.options = options;
    this.rules = new _RuleList2['default'](_extends({}, options, { parent: this }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(ConditionalRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { indent: 1 };

      var inner = this.rules.toString(options);
      return inner ? this.key + ' {\n' + inner + '\n}' : '';
    }
  }]);

  return ConditionalRule;
}();

exports['default'] = ConditionalRule;

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(438);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FontFaceRule = function () {
  function FontFaceRule(key, style, options) {
    _classCallCheck(this, FontFaceRule);

    this.type = 'font-face';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(FontFaceRule, [{
    key: 'toString',
    value: function toString(options) {
      if (Array.isArray(this.style)) {
        var str = '';
        for (var index = 0; index < this.style.length; index++) {
          str += (0, _toCss2['default'])(this.key, this.style[index]);
          if (this.style[index + 1]) str += '\n';
        }
        return str;
      }

      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return FontFaceRule;
}();

exports['default'] = FontFaceRule;

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _toCss = __webpack_require__(438);

var _toCss2 = _interopRequireDefault(_toCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ViewportRule = function () {
  function ViewportRule(key, style, options) {
    _classCallCheck(this, ViewportRule);

    this.type = 'viewport';
    this.isProcessed = false;

    this.key = key;
    this.style = style;
    this.options = options;
  }

  /**
   * Generates a CSS string.
   */


  _createClass(ViewportRule, [{
    key: 'toString',
    value: function toString(options) {
      return (0, _toCss2['default'])(this.key, this.style, options);
    }
  }]);

  return ViewportRule;
}();

exports['default'] = ViewportRule;

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StyleRule = __webpack_require__(167);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(283);

var _createRule2 = _interopRequireDefault(_createRule);

var _isObservable = __webpack_require__(700);

var _isObservable2 = _interopRequireDefault(_isObservable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (!(0, _isObservable2['default'])(decl)) return null;

    // Cast `decl` to `Observable`, since it passed the type guard.
    var style$ = decl;

    var rule = (0, _createRule2['default'])(name, {}, options);

    // TODO
    // Call `stream.subscribe()` returns a subscription, which should be explicitly
    // unsubscribed from when we know this sheet is no longer needed.
    style$.subscribe(function (style) {
      for (var prop in style) {
        rule.prop(prop, style[prop]);
      }
    });

    return rule;
  },
  onProcessRule: function onProcessRule(rule) {
    if (!(rule instanceof _StyleRule2['default'])) return;
    var styleRule = rule;
    var style = styleRule.style;

    var _loop = function _loop(prop) {
      var value = style[prop];
      if (!(0, _isObservable2['default'])(value)) return 'continue';
      delete style[prop];
      value.subscribe({
        next: function next(nextValue) {
          styleRule.prop(prop, nextValue);
        }
      });
    };

    for (var prop in style) {
      var _ret = _loop(prop);

      if (_ret === 'continue') continue;
    }
  }
};

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RuleList = __webpack_require__(208);

var _RuleList2 = _interopRequireDefault(_RuleList);

var _StyleRule = __webpack_require__(167);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _createRule = __webpack_require__(283);

var _createRule2 = _interopRequireDefault(_createRule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// A symbol replacement.
var now = Date.now();

var fnValuesNs = 'fnValues' + now;
var fnStyleNs = 'fnStyle' + ++now;

exports['default'] = {
  onCreateRule: function onCreateRule(name, decl, options) {
    if (typeof decl !== 'function') return null;
    var rule = (0, _createRule2['default'])(name, {}, options);
    rule[fnStyleNs] = decl;
    return rule;
  },
  onProcessStyle: function onProcessStyle(style, rule) {
    var fn = {};
    for (var prop in style) {
      var value = style[prop];
      if (typeof value !== 'function') continue;
      delete style[prop];
      fn[prop] = value;
    }
    rule = rule;
    rule[fnValuesNs] = fn;
    return style;
  },
  onUpdate: function onUpdate(data, rule) {
    // It is a rules container like for e.g. ConditionalRule.
    if (rule.rules instanceof _RuleList2['default']) {
      rule.rules.update(data);
      return;
    }
    if (!(rule instanceof _StyleRule2['default'])) return;

    rule = rule;

    // If we have a fn values map, it is a rule with function values.
    if (rule[fnValuesNs]) {
      for (var prop in rule[fnValuesNs]) {
        rule.prop(prop, rule[fnValuesNs][prop](data));
      }
    }

    rule = rule;

    var fnStyle = rule[fnStyleNs];

    // If we have a style function, the entire rule is dynamic and style object
    // will be returned from that function.
    if (fnStyle) {
      var style = fnStyle(data);
      for (var _prop in style) {
        rule.prop(_prop, style[_prop]);
      }
    }
  }
};

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

var _sheets = __webpack_require__(439);

var _sheets2 = _interopRequireDefault(_sheets);

var _StyleRule = __webpack_require__(167);

var _StyleRule2 = _interopRequireDefault(_StyleRule);

var _toCssValue = __webpack_require__(282);

var _toCssValue2 = _interopRequireDefault(_toCssValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value = void 0;
  return function () {
    if (!value) value = fn();
    return value;
  };
};

/**
 * Get a style property value.
 */
function getPropertyValue(cssRule, prop) {
  try {
    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}

/**
 * Set a style property.
 */
function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = (0, _toCssValue2['default'])(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    }

    cssRule.style.setProperty(prop, cssValue);
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }
  return true;
}

/**
 * Remove a style property.
 */
function removeProperty(cssRule, prop) {
  try {
    cssRule.style.removeProperty(prop);
  } catch (err) {
    (0, _warning2['default'])(false, '[JSS] DOMException "%s" was thrown. Tried to remove property "%s".', err.message, prop);
  }
}

var CSSRuleTypes = {
  STYLE_RULE: 1,
  KEYFRAMES_RULE: 7

  /**
   * Get the CSS Rule key.
   */

};var getKey = function () {
  var extractKey = function extractKey(cssText) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return cssText.substr(from, cssText.indexOf('{') - 1);
  };

  return function (cssRule) {
    if (cssRule.type === CSSRuleTypes.STYLE_RULE) return cssRule.selectorText;
    if (cssRule.type === CSSRuleTypes.KEYFRAMES_RULE) {
      var name = cssRule.name;

      if (name) return '@keyframes ' + name;

      // There is no rule.name in the following browsers:
      // - IE 9
      // - Safari 7.1.8
      // - Mobile Safari 9.0.0
      var cssText = cssRule.cssText;

      return '@' + extractKey(cssText, cssText.indexOf('keyframes'));
    }

    // Conditionals.
    return extractKey(cssRule.cssText);
  };
}();

/**
 * Set the selector.
 */
function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText;

  // Return false if setter was not successful.
  // Currently works in chrome only.
  return cssRule.selectorText === selectorText;
}

/**
 * Gets the `head` element upon the first call and caches it.
 */
var getHead = memoize(function () {
  return document.head || document.getElementsByTagName('head')[0];
});

/**
 * Gets a map of rule keys, where the property is an unescaped key and value
 * is a potentially escaped one.
 * It is used to identify CSS rules and the corresponding JSS rules. As an identifier
 * for CSSStyleRule we normally use `selectorText`. Though if original selector text
 * contains escaped code points e.g. `:not(#\\20)`, CSSOM will compile it to `:not(# )`
 * and so CSS rule's `selectorText` won't match JSS rule selector.
 *
 * https://www.w3.org/International/questions/qa-escapes#cssescapes
 */
var getUnescapedKeysMap = function () {
  var style = void 0;
  var isAttached = false;

  return function (rules) {
    var map = {};
    // https://github.com/facebook/flow/issues/2696
    if (!style) style = document.createElement('style');
    for (var i = 0; i < rules.length; i++) {
      var rule = rules[i];
      if (!(rule instanceof _StyleRule2['default'])) continue;
      var selector = rule.selector;
      // Only unescape selector over CSSOM if it contains a back slash.

      if (selector && selector.indexOf('\\') !== -1) {
        // Lazilly attach when needed.
        if (!isAttached) {
          getHead().appendChild(style);
          isAttached = true;
        }
        style.textContent = selector + ' {}';
        var _style = style,
            sheet = _style.sheet;

        if (sheet) {
          var cssRules = sheet.cssRules;

          if (cssRules) map[cssRules[0].selectorText] = rule.key;
        }
      }
    }
    if (isAttached) {
      getHead().removeChild(style);
      isAttached = false;
    }
    return map;
  };
}();

/**
 * Find attached sheet with an index higher than the passed one.
 */
function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find attached sheet with the highest index.
 */
function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];
    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }
  return null;
}

/**
 * Find a comment with "jss" inside.
 */
function findCommentNode(text) {
  var head = getHead();
  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];
    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }
  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = _sheets2['default'].registry;


  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);
    if (sheet) return sheet.renderer.element;

    // Otherwise insert after the last attached.
    sheet = findHighestSheet(registry, options);
    if (sheet) return sheet.renderer.element.nextElementSibling;
  }

  // Try to find a comment placeholder if registry is empty.
  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);
    if (comment) return comment.nextSibling;
    // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.
    (0, _warning2['default'])(insertionPoint === 'jss', '[JSS] Insertion point "%s" not found.', insertionPoint);
  }

  return null;
}

/**
 * Insert style element into the DOM.
 */
function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;

  var prevNode = findPrevNode(options);

  if (prevNode) {
    var parentNode = prevNode.parentNode;

    if (parentNode) parentNode.insertBefore(style, prevNode);
    return;
  }

  // Works with iframes and any node types.
  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var _parentNode = insertionPointElement.parentNode;

    if (_parentNode) _parentNode.insertBefore(style, insertionPointElement.nextSibling);else (0, _warning2['default'])(false, '[JSS] Insertion point is not in the DOM.');
    return;
  }

  getHead().insertBefore(style, prevNode);
}

/**
 * Read jss nonce setting from the page if the user has set it.
 */
var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var DomRenderer = function () {
  function DomRenderer(sheet) {
    _classCallCheck(this, DomRenderer);

    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.getKey = getKey;
    this.getUnescapedKeysMap = getUnescapedKeysMap;
    this.hasInsertedRules = false;

    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) _sheets2['default'].add(sheet);

    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || document.createElement('style');
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }

  /**
   * Insert style element into render tree.
   */


  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696


  _createClass(DomRenderer, [{
    key: 'attach',
    value: function attach() {
      // In the case the element node is external and it is already in the DOM.
      if (this.element.parentNode || !this.sheet) return;

      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
      // browsers remove those rules.
      // TODO figure out if its a bug and if it is known.
      // Workaround is to redeploy the sheet before attaching as a string.
      if (this.hasInsertedRules) {
        this.deploy();
        this.hasInsertedRules = false;
      }

      insertStyle(this.element, this.sheet.options);
    }

    /**
     * Remove style element from render tree.
     */

  }, {
    key: 'detach',
    value: function detach() {
      this.element.parentNode.removeChild(this.element);
    }

    /**
     * Inject CSS string into element.
     */

  }, {
    key: 'deploy',
    value: function deploy() {
      if (!this.sheet) return;
      this.element.textContent = '\n' + this.sheet.toString() + '\n';
    }

    /**
     * Insert a rule into element.
     */

  }, {
    key: 'insertRule',
    value: function insertRule(rule, index) {
      var sheet = this.element.sheet;
      var cssRules = sheet.cssRules;

      var str = rule.toString();
      if (!index) index = cssRules.length;

      if (!str) return false;

      try {
        sheet.insertRule(str, index);
      } catch (err) {
        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
        return false;
      }
      this.hasInsertedRules = true;

      return cssRules[index];
    }

    /**
     * Delete a rule.
     */

  }, {
    key: 'deleteRule',
    value: function deleteRule(cssRule) {
      var sheet = this.element.sheet;

      var index = this.indexOf(cssRule);
      if (index === -1) return false;
      sheet.deleteRule(index);
      return true;
    }

    /**
     * Get index of a CSS Rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(cssRule) {
      var cssRules = this.element.sheet.cssRules;

      for (var _index = 0; _index < cssRules.length; _index++) {
        if (cssRule === cssRules[_index]) return _index;
      }
      return -1;
    }

    /**
     * Generate a new CSS rule and replace the existing one.
     */

  }, {
    key: 'replaceRule',
    value: function replaceRule(cssRule, rule) {
      var index = this.indexOf(cssRule);
      var newCssRule = this.insertRule(rule, index);
      this.element.sheet.deleteRule(index);
      return newCssRule;
    }

    /**
     * Get all rules elements.
     */

  }, {
    key: 'getRules',
    value: function getRules() {
      return this.element.sheet.cssRules;
    }
  }]);

  return DomRenderer;
}();

exports['default'] = DomRenderer;

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this */

/**
 * Rendering backend to do nothing in nodejs.
 */
var VirtualRenderer = function () {
  function VirtualRenderer() {
    _classCallCheck(this, VirtualRenderer);
  }

  _createClass(VirtualRenderer, [{
    key: 'setProperty',
    value: function setProperty() {
      return true;
    }
  }, {
    key: 'getPropertyValue',
    value: function getPropertyValue() {
      return '';
    }
  }, {
    key: 'removeProperty',
    value: function removeProperty() {}
  }, {
    key: 'setSelector',
    value: function setSelector() {
      return true;
    }
  }, {
    key: 'getKey',
    value: function getKey() {
      return '';
    }
  }, {
    key: 'attach',
    value: function attach() {}
  }, {
    key: 'detach',
    value: function detach() {}
  }, {
    key: 'deploy',
    value: function deploy() {}
  }, {
    key: 'insertRule',
    value: function insertRule() {
      return false;
    }
  }, {
    key: 'deleteRule',
    value: function deleteRule() {
      return true;
    }
  }, {
    key: 'replaceRule',
    value: function replaceRule() {
      return false;
    }
  }, {
    key: 'getRules',
    value: function getRules() {}
  }, {
    key: 'indexOf',
    value: function indexOf() {
      return -1;
    }
  }]);

  return VirtualRenderer;
}();

exports['default'] = VirtualRenderer;

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Share the same values than in
// https://github.com/cssinjs/jss/blob/master/packages/react-jss/src/ns.js
var ns = {
  jss: '64a55d578f856d258dc345b094a2a2b3',
  sheetsRegistry: 'd4bd0baacbc52bbd48bbb9eb24344ecd',
  sheetOptions: '6fc570d6bd61383819d0f9e7407c452d'
};
var _default = ns;
exports.default = _default;

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jssGlobal = _interopRequireDefault(__webpack_require__(1805));

var _jssNested = _interopRequireDefault(__webpack_require__(1806));

var _jssCamelCase = _interopRequireDefault(__webpack_require__(1807));

var _jssDefaultUnit = _interopRequireDefault(__webpack_require__(1809));

var _jssVendorPrefixer = _interopRequireDefault(__webpack_require__(1811));

var _jssPropsSort = _interopRequireDefault(__webpack_require__(1816));

// Subset of jss-preset-default with only the plugins the Material-UI components are using.
function jssPreset() {
  return {
    plugins: [(0, _jssGlobal.default)(), (0, _jssNested.default)(), (0, _jssCamelCase.default)(), (0, _jssDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : (0, _jssVendorPrefixer.default)(), (0, _jssPropsSort.default)()]
  };
}

var _default = jssPreset;
exports.default = _default;

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports['default'] = jssGlobal;

var _jss = __webpack_require__(698);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var propKey = '@global';
var prefixKey = '@global ';

var GlobalContainerRule = function () {
  function GlobalContainerRule(key, styles, options) {
    _classCallCheck(this, GlobalContainerRule);

    this.type = 'global';

    this.key = key;
    this.options = options;
    this.rules = new _jss.RuleList(_extends({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector], { selector: selector });
    }

    this.rules.process();
  }

  /**
   * Get a rule.
   */


  _createClass(GlobalContainerRule, [{
    key: 'getRule',
    value: function getRule(name) {
      return this.rules.get(name);
    }

    /**
     * Create and register rule, run plugins.
     */

  }, {
    key: 'addRule',
    value: function addRule(name, style, options) {
      var rule = this.rules.add(name, style, options);
      this.options.jss.plugins.onProcessRule(rule);
      return rule;
    }

    /**
     * Get index of a rule.
     */

  }, {
    key: 'indexOf',
    value: function indexOf(rule) {
      return this.rules.indexOf(rule);
    }

    /**
     * Generates a CSS string.
     */

  }, {
    key: 'toString',
    value: function toString() {
      return this.rules.toString();
    }
  }]);

  return GlobalContainerRule;
}();

var GlobalPrefixedRule = function () {
  function GlobalPrefixedRule(name, style, options) {
    _classCallCheck(this, GlobalPrefixedRule);

    this.name = name;
    this.options = options;
    var selector = name.substr(prefixKey.length);
    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
      parent: this,
      selector: selector
    }));
  }

  _createClass(GlobalPrefixedRule, [{
    key: 'toString',
    value: function toString(options) {
      return this.rule.toString(options);
    }
  }]);

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';
  for (var i = 0; i < parts.length; i++) {
    scoped += scope + ' ' + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }
  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;

  var rules = style[propKey];

  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], _extends({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[propKey];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop.substr(0, propKey.length) !== propKey) continue;

    var selector = addScope(prop.substr(propKey.length), rule.selector);
    options.sheet.addRule(selector, style[prop], _extends({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (name === propKey) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, prefixKey.length) === prefixKey) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;


    if (parent) {
      if (parent.type === 'global' || parent.options.parent.type === 'global') {
        options.global = true;
      }
    }

    if (options.global) options.selector = name;

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;

    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return { onCreateRule: onCreateRule, onProcessRule: onProcessRule };
}

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = jssNested;

var _warning = __webpack_require__(142);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;

/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */
function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container) {
    return function (match, key) {
      var rule = container.getRule(key);
      if (rule) return rule.selector;
      (0, _warning2.default)(false, '[JSS] Could not find the referenced rule %s in %s.', key, container.options.meta || container);
      return key;
    };
  }

  var hasAnd = function hasAnd(str) {
    return str.indexOf('&') !== -1;
  };

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);

    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', ';
        // Replace all & by the parent or prefix & with the parent.
        result += hasAnd(nested) ? nested.replace(parentRegExp, parent) : parent + ' ' + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return _extends({}, options, { index: options.index + 1 });

    var nestingLevel = rule.options.nestingLevel;

    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;

    return _extends({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    var container = rule.options.parent;
    var options = void 0;
    var replaceRef = void 0;
    for (var prop in style) {
      var isNested = hasAnd(prop);
      var isNestedConditional = prop[0] === '@';

      if (!isNested && !isNestedConditional) continue;

      options = getOptions(rule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, rule.selector
        // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.
        );if (!replaceRef) replaceRef = getReplaceRef(container
        // Replace all $refs.
        );selector = selector.replace(refRegExp, replaceRef);

        container.addRule(selector, style[prop], _extends({}, options, { selector: selector }));
      } else if (isNestedConditional) {
        container
        // Place conditional right after the parent rule to ensure right ordering.
        .addRule(prop, null, options).addRule(rule.key, style[prop], { selector: rule.selector });
      }

      delete style[prop];
    }

    return style;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelCase;

var _hyphenateStyleName = __webpack_require__(1808);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */
function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    converted[(0, _hyphenateStyleName2['default'])(prop)] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}

/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */
function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }
      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    var hyphenatedProp = (0, _hyphenateStyleName2['default'])(prop);

    // There was no camel case in place
    if (prop === hyphenatedProp) return value;

    rule.prop(hyphenatedProp, value);

    // Core will ignore that property value we set the proper one above.
    return null;
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var uppercasePattern = /[A-Z]/g;
var msPattern = /^ms-/;
var cache = {};

function hyphenateStyleName(string) {
    return string in cache
    ? cache[string]
    : cache[string] = string
      .replace(uppercasePattern, '-$&')
      .toLowerCase()
      .replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;


/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports['default'] = defaultUnit;

var _defaultUnits = __webpack_require__(1810);

var _defaultUnits2 = _interopRequireDefault(_defaultUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;
  var replace = function replace(str) {
    return str[1].toUpperCase();
  };
  var newObj = {};
  for (var key in obj) {
    newObj[key] = obj[key];
    newObj[key.replace(regExp, replace)] = obj[key];
  }
  return newObj;
}

var units = addCamelCasedVersion(_defaultUnits2['default']);

/**
 * Recursive deep style passing function
 *
 * @param {String} current property
 * @param {(Object|Array|Number|String)} property value
 * @param {Object} options
 * @return {(Object|Array|Number|String)} resulting value
 */
function iterate(prop, value, options) {
  if (!value) return value;

  var convertedValue = value;

  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  if (type === 'object' && Array.isArray(value)) type = 'array';

  switch (type) {
    case 'object':
      if (prop === 'fallbacks') {
        for (var innerProp in value) {
          value[innerProp] = iterate(innerProp, value[innerProp], options);
        }
        break;
      }
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + '-' + _innerProp, value[_innerProp], options);
      }
      break;
    case 'array':
      for (var i = 0; i < value.length; i++) {
        value[i] = iterate(prop, value[i], options);
      }
      break;
    case 'number':
      if (value !== 0) {
        convertedValue = value + (options[prop] || units[prop] || '');
      }
      break;
    default:
      break;
  }

  return convertedValue;
}

/**
 * Add unit to numeric values.
 */
function defaultUnit() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return { onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Generated jss-default-unit CSS property units
 *
 * @type object
 */
exports['default'] = {
  'animation-delay': 'ms',
  'animation-duration': 'ms',
  'background-position': 'px',
  'background-position-x': 'px',
  'background-position-y': 'px',
  'background-size': 'px',
  border: 'px',
  'border-bottom': 'px',
  'border-bottom-left-radius': 'px',
  'border-bottom-right-radius': 'px',
  'border-bottom-width': 'px',
  'border-left': 'px',
  'border-left-width': 'px',
  'border-radius': 'px',
  'border-right': 'px',
  'border-right-width': 'px',
  'border-spacing': 'px',
  'border-top': 'px',
  'border-top-left-radius': 'px',
  'border-top-right-radius': 'px',
  'border-top-width': 'px',
  'border-width': 'px',
  'border-after-width': 'px',
  'border-before-width': 'px',
  'border-end-width': 'px',
  'border-horizontal-spacing': 'px',
  'border-start-width': 'px',
  'border-vertical-spacing': 'px',
  bottom: 'px',
  'box-shadow': 'px',
  'column-gap': 'px',
  'column-rule': 'px',
  'column-rule-width': 'px',
  'column-width': 'px',
  'flex-basis': 'px',
  'font-size': 'px',
  'font-size-delta': 'px',
  height: 'px',
  left: 'px',
  'letter-spacing': 'px',
  'logical-height': 'px',
  'logical-width': 'px',
  margin: 'px',
  'margin-after': 'px',
  'margin-before': 'px',
  'margin-bottom': 'px',
  'margin-left': 'px',
  'margin-right': 'px',
  'margin-top': 'px',
  'max-height': 'px',
  'max-width': 'px',
  'margin-end': 'px',
  'margin-start': 'px',
  'mask-position-x': 'px',
  'mask-position-y': 'px',
  'mask-size': 'px',
  'max-logical-height': 'px',
  'max-logical-width': 'px',
  'min-height': 'px',
  'min-width': 'px',
  'min-logical-height': 'px',
  'min-logical-width': 'px',
  motion: 'px',
  'motion-offset': 'px',
  outline: 'px',
  'outline-offset': 'px',
  'outline-width': 'px',
  padding: 'px',
  'padding-bottom': 'px',
  'padding-left': 'px',
  'padding-right': 'px',
  'padding-top': 'px',
  'padding-after': 'px',
  'padding-before': 'px',
  'padding-end': 'px',
  'padding-start': 'px',
  'perspective-origin-x': '%',
  'perspective-origin-y': '%',
  perspective: 'px',
  right: 'px',
  'shape-margin': 'px',
  size: 'px',
  'text-indent': 'px',
  'text-stroke': 'px',
  'text-stroke-width': 'px',
  top: 'px',
  'transform-origin': '%',
  'transform-origin-x': '%',
  'transform-origin-y': '%',
  'transform-origin-z': '%',
  'transition-delay': 'ms',
  'transition-duration': 'ms',
  'vertical-align': 'px',
  width: 'px',
  'word-spacing': 'px',
  // Not existing properties.
  // Used to avoid issues with jss-expand intergration.
  'box-shadow-x': 'px',
  'box-shadow-y': 'px',
  'box-shadow-blur': 'px',
  'box-shadow-spread': 'px',
  'font-line-height': 'px',
  'text-shadow-x': 'px',
  'text-shadow-y': 'px',
  'text-shadow-blur': 'px'
};

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssVendorPrefixer;

var _cssVendor = __webpack_require__(1812);

var vendor = _interopRequireWildcard(_cssVendor);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 * Add vendor prefix to a property name when needed.
 *
 * @param {Rule} rule
 * @api public
 */
function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      rule.key = '@' + vendor.prefix.css + rule.key.substr(1);
    }
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      var value = style[prop];

      var changeProp = false;
      var supportedProp = vendor.supportedProperty(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;

      var changeValue = false;
      var supportedValue = vendor.supportedValue(supportedProp, value);
      if (supportedValue && supportedValue !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue || value;
      }
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return vendor.supportedValue(prop, value);
  }

  return { onProcessRule: onProcessRule, onProcessStyle: onProcessStyle, onChangeValue: onChangeValue };
}

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.supportedValue = exports.supportedProperty = exports.prefix = undefined;

var _prefix = __webpack_require__(440);

var _prefix2 = _interopRequireDefault(_prefix);

var _supportedProperty = __webpack_require__(1813);

var _supportedProperty2 = _interopRequireDefault(_supportedProperty);

var _supportedValue = __webpack_require__(1815);

var _supportedValue2 = _interopRequireDefault(_supportedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  prefix: _prefix2['default'],
  supportedProperty: _supportedProperty2['default'],
  supportedValue: _supportedValue2['default']
}; /**
    * CSS Vendor prefix detection and property feature testing.
    *
    * @copyright Oleg Slobodskoi 2015
    * @website https://github.com/jsstyles/css-vendor
    * @license MIT
    */

exports.prefix = _prefix2['default'];
exports.supportedProperty = _supportedProperty2['default'];
exports.supportedValue = _supportedValue2['default'];

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedProperty;

var _isInBrowser = __webpack_require__(284);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(440);

var _prefix2 = _interopRequireDefault(_prefix);

var _camelize = __webpack_require__(1814);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var el = void 0;
var cache = {};

if (_isInBrowser2['default']) {
  el = document.createElement('p');

  /**
   * We test every property on vendor prefix requirement.
   * Once tested, result is cached. It gives us up to 70% perf boost.
   * http://jsperf.com/element-style-object-access-vs-plain-object
   *
   * Prefill cache with known css properties to reduce amount of
   * properties we need to feature test at runtime.
   * http://davidwalsh.name/vendor-prefix
   */
  var computed = window.getComputedStyle(document.documentElement, '');
  for (var key in computed) {
    if (!isNaN(key)) cache[computed[key]] = computed[key];
  }
}

/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @return {String|Boolean}
 * @api public
 */
function supportedProperty(prop) {
  // For server-side rendering.
  if (!el) return prop;

  // We have not tested this prop yet, lets do the test.
  if (cache[prop] != null) return cache[prop];

  // Camelization is required because we can't test using
  // css syntax for e.g. in FF.
  // Test if property is supported as it is.
  if ((0, _camelize2['default'])(prop) in el.style) {
    cache[prop] = prop;
  }
  // Test if property is supported with vendor prefix.
  else if (_prefix2['default'].js + (0, _camelize2['default'])('-' + prop) in el.style) {
      cache[prop] = _prefix2['default'].css + prop;
    } else {
      cache[prop] = false;
    }

  return cache[prop];
}

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = camelize;
var regExp = /[-\s]+(.)?/g;

/**
 * Convert dash separated strings to camel cased.
 *
 * @param {String} str
 * @return {String}
 */
function camelize(str) {
  return str.replace(regExp, toUpper);
}

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedValue;

var _isInBrowser = __webpack_require__(284);

var _isInBrowser2 = _interopRequireDefault(_isInBrowser);

var _prefix = __webpack_require__(440);

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var cache = {};
var el = void 0;

if (_isInBrowser2['default']) el = document.createElement('p');

/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */
function supportedValue(property, value) {
  // For server-side rendering.
  if (!el) return value;

  // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  if (typeof value !== 'string' || !isNaN(parseInt(value, 10))) return value;

  var cacheKey = property + value;

  if (cache[cacheKey] != null) return cache[cacheKey];

  // IE can even throw an error in some cases, for e.g. style.content = 'bar'
  try {
    // Test value as it is.
    el.style[property] = value;
  } catch (err) {
    cache[cacheKey] = false;
    return false;
  }

  // Value is supported as it is.
  if (el.style[property] !== '') {
    cache[cacheKey] = value;
  } else {
    // Test value with vendor prefix.
    value = _prefix2['default'].css + value;

    // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
    if (value === '-ms-flex') value = '-ms-flexbox';

    el.style[property] = value;

    // Value is supported with vendor prefix.
    if (el.style[property] !== '') cache[cacheKey] = value;
  }

  if (!cache[cacheKey]) cache[cacheKey] = false;

  // Reset style value.
  el.style[property] = '';

  return cache[cacheKey];
}

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = jssPropsSort;
/**
 * Sort props by length.
 */
function jssPropsSort() {
  function sort(prop0, prop1) {
    return prop0.length - prop1.length;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    var newStyle = {};
    var props = Object.keys(style).sort(sort);
    for (var prop in props) {
      newStyle[props[prop]] = style[props[prop]];
    }
    return newStyle;
  }

  return { onProcessStyle: onProcessStyle };
}

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _warning = _interopRequireDefault(__webpack_require__(93));

var _utils = __webpack_require__(280);

function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = (0, _extends2.default)({}, baseClasses);

  if (false) {
    process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, ["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes property of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className property instead.'].join('\n')) : void 0;
    return baseClasses;
  }

  Object.keys(newClasses).forEach(function (key) {
     false ? (0, _warning.default)(baseClasses[key] || !newClasses[key], ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n')) : void 0;
     false ? (0, _warning.default)(!newClasses[key] || typeof newClasses[key] === 'string', ["Material-UI: the key `".concat(key, "` ") + "provided to the classes property is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n')) : void 0;

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

var _default = mergeClasses;
exports.default = _default;

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
var _default = multiKeyStore;
exports.default = _default;

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(103));

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

var _deepmerge = _interopRequireDefault(__webpack_require__(285));

var _isPlainObject = _interopRequireDefault(__webpack_require__(1820));

var _warning = _interopRequireDefault(__webpack_require__(93));

var _createBreakpoints = _interopRequireDefault(__webpack_require__(1822));

var _createMixins = _interopRequireDefault(__webpack_require__(1823));

var _createPalette = _interopRequireDefault(__webpack_require__(1824));

var _createTypography = _interopRequireDefault(__webpack_require__(1831));

var _shadows = _interopRequireDefault(__webpack_require__(1832));

var _shape = _interopRequireDefault(__webpack_require__(1833));

var _spacing = _interopRequireDefault(__webpack_require__(1834));

var _transitions = _interopRequireDefault(__webpack_require__(1835));

var _zIndex = _interopRequireDefault(__webpack_require__(1836));

// < 1kb payload overhead when lodash/merge is > 3kb.
function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      _options$spacing = options.spacing,
      spacingInput = _options$spacing === void 0 ? {} : _options$spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);
  var palette = (0, _createPalette.default)(paletteInput);
  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
  var spacing = (0, _extends2.default)({}, _spacing.default, spacingInput);
  var muiTheme = (0, _extends2.default)({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom properties
    shadows: shadowsInput || _shadows.default,
    typography: (0, _createTypography.default)(palette, typographyInput)
  }, (0, _deepmerge.default)({
    shape: _shape.default,
    spacing: spacing,
    transitions: _transitions.default,
    zIndex: _zIndex.default
  }, other, {
    isMergeableObject: _isPlainObject.default
  }));

  if (false) {
    var statesWarning = ['disabled', 'focused', 'selected', 'checked'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (statesWarning.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          process.env.NODE_ENV !== "production" ? (0, _warning.default)(false, ["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify((0, _defineProperty2.default)({}, "&$".concat(key), child), null, 2), '', 'https://material-ui.com/customization/overrides#internal-states'].join('\n')) : void 0;
        }
      }
    };

    traverse(other.overrides);
  }

   false ? (0, _warning.default)(muiTheme.shadows.length === 25, 'Material-UI: the shadows array provided to createMuiTheme should support 25 elevations.') : void 0;
  return muiTheme;
}

var _default = createMuiTheme;
exports.default = _default;

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(1821);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createBreakpoints;
exports.keys = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

exports.keys = keys;

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return (0, _extends2.default)({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createMixins;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(103));

var _extends3 = _interopRequireDefault(__webpack_require__(62));

function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return (0, _extends3.default)({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return (0, _extends3.default)({
        paddingLeft: spacing.unit * 2,
        paddingRight: spacing.unit * 2
      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
        paddingLeft: spacing.unit * 3,
        paddingRight: spacing.unit * 3
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPalette;
exports.dark = exports.light = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

var _warning = _interopRequireDefault(__webpack_require__(93));

var _deepmerge = _interopRequireDefault(__webpack_require__(285));

var _indigo = _interopRequireDefault(__webpack_require__(1825));

var _pink = _interopRequireDefault(__webpack_require__(1826));

var _grey = _interopRequireDefault(__webpack_require__(1827));

var _red = _interopRequireDefault(__webpack_require__(1828));

var _common = _interopRequireDefault(__webpack_require__(1829));

var _colorManipulator = __webpack_require__(1830);

// < 1kb payload overhead when lodash/merge is > 3kb.
var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: _common.default.white,
    default: _grey.default[50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
exports.light = light;
var dark = {
  text: {
    primary: _common.default.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: _grey.default[800],
    default: '#303030'
  },
  action: {
    active: _common.default.white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};
exports.dark = dark;

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: _indigo.default[300],
    main: _indigo.default[500],
    dark: _indigo.default[700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: _pink.default.A200,
    main: _pink.default.A400,
    dark: _pink.default.A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: _red.default[300],
    main: _red.default[500],
    dark: _red.default[700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]);

  function getContrastText(background) {
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
      process.env.NODE_ENV !== "production" ? (0, _warning.default)(contrast >= 3, ["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n')) : void 0;
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  augmentColor(primary);
  augmentColor(secondary, 'A400', 'A200', 'A700');
  augmentColor(error);
  var types = {
    dark: dark,
    light: light
  };
   false ? (0, _warning.default)(types[type], "Material-UI: the palette type `".concat(type, "` is not supported.")) : void 0;
  var paletteOutput = (0, _deepmerge.default)((0, _extends2.default)({
    // A collection of common colors.
    common: _common.default,
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: primary,
    // The colors used to represent secondary interface elements for a user.
    secondary: secondary,
    // The colors used to represent interface elements that the user should be made aware of.
    error: error,
    // The grey colors.
    grey: _grey.default,
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other, {
    clone: false // No need to clone deep

  });
  return paletteOutput;
}

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
var _default = indigo;
exports.default = _default;

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
var _default = pink;
exports.default = _default;

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
var _default = grey;
exports.default = _default;

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var _default = red;
exports.default = _default;

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
exports.default = _default;

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertHexToRGB = convertHexToRGB;
exports.rgbToHex = rgbToHex;
exports.decomposeColor = decomposeColor;
exports.recomposeColor = recomposeColor;
exports.getContrastRatio = getContrastRatio;
exports.getLuminance = getLuminance;
exports.emphasize = emphasize;
exports.fade = fade;
exports.darken = darken;
exports.lighten = lighten;

var _warning = _interopRequireDefault(__webpack_require__(93));

/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
   false ? (0, _warning.default)(value >= min && value <= max, "Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "].")) : void 0;

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function convertHexToRGB(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Pass hex straight through
  if (color.indexOf('#') === 0) {
    return color;
  }

  function intToHex(c) {
    var hex = c.toString(16);
    return hex.length === 1 ? "0".concat(hex) : hex;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  values = values.map(function (n) {
    return intToHex(n);
  });
  return "#".concat(values.join(''));
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  if (color.charAt(0) === '#') {
    return decomposeColor(convertHexToRGB(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);
  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });

  if (false) {
    if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
      throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
    }
  }

  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  }

  if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(color.type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance(color) {
  var decomposedColor = decomposeColor(color);

  if (decomposedColor.type.indexOf('rgb') !== -1) {
    var rgb = decomposedColor.values.map(function (val) {
      val /= 255; // normalized

      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
    }); // Truncate at 3 digits

    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
  } // else if (decomposedColor.type.indexOf('hsl') !== -1)


  return decomposedColor.values[2] / 100;
}
/**
 * Darken or lighten a colour, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function fade(color, value) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in fade(".concat(color, ", ").concat(value, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in darken(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten(color, coefficient) {
   false ? (0, _warning.default)(color, "Material-UI: missing color argument in lighten(".concat(color, ", ").concat(coefficient, ").")) : void 0;
  if (!color) return color;
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createTypography;

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

var _deepmerge = _interopRequireDefault(__webpack_require__(285));

var _warning = _interopRequireDefault(__webpack_require__(93));

var _utils = __webpack_require__(280);

// < 1kb payload overhead when lodash/merge is > 3kb.
function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      _ref$useNextVariants = _ref.useNextVariants,
      useNextVariants = _ref$useNextVariants === void 0 ? Boolean(_utils.ponyfillGlobal.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__) : _ref$useNextVariants,
      _ref$suppressWarning = _ref.suppressWarning,
      suppressWarning = _ref$suppressWarning === void 0 ? false : _ref$suppressWarning,
      allVariants = _ref.allVariants,
      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "htmlFontSize", "useNextVariants", "suppressWarning", "allVariants"]);

   false ? (0, _warning.default)(useNextVariants || suppressWarning, 'Material-UI: you are using the deprecated typography variants ' + 'that will be removed in the next major release.' + '\nPlease read the migration guide under https://material-ui.com/style/typography#migration-to-typography-v2') : void 0;
  var coef = fontSize / 14;

  var pxToRem = function pxToRem(size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return (0, _extends2.default)({
      color: palette.text.primary,
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following http://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, casing, allVariants);
  };

  var nextVariants = {
    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1Next: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2Next: buildVariant(fontWeightRegular, 14, 1.5, 0.15),
    buttonNext: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    captionNext: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  }; // To remove in v4

  var oldVariants = {
    display4: (0, _extends2.default)({
      fontSize: pxToRem(112),
      fontWeight: fontWeightLight,
      fontFamily: fontFamily,
      letterSpacing: '-.04em',
      lineHeight: "".concat(round(128 / 112), "em"),
      marginLeft: '-.04em',
      color: palette.text.secondary
    }, allVariants),
    display3: (0, _extends2.default)({
      fontSize: pxToRem(56),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      letterSpacing: '-.02em',
      lineHeight: "".concat(round(73 / 56), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display2: (0, _extends2.default)({
      fontSize: pxToRem(45),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(51 / 45), "em"),
      marginLeft: '-.02em',
      color: palette.text.secondary
    }, allVariants),
    display1: (0, _extends2.default)({
      fontSize: pxToRem(34),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(41 / 34), "em"),
      color: palette.text.secondary
    }, allVariants),
    headline: (0, _extends2.default)({
      fontSize: pxToRem(24),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(32.5 / 24), "em"),
      color: palette.text.primary
    }, allVariants),
    title: (0, _extends2.default)({
      fontSize: pxToRem(21),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24.5 / 21), "em"),
      color: palette.text.primary
    }, allVariants),
    subheading: (0, _extends2.default)({
      fontSize: pxToRem(16),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 16), "em"),
      color: palette.text.primary
    }, allVariants),
    body2: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(24 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    body1: (0, _extends2.default)({
      fontSize: pxToRem(14),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(20.5 / 14), "em"),
      color: palette.text.primary
    }, allVariants),
    caption: (0, _extends2.default)({
      fontSize: pxToRem(12),
      fontWeight: fontWeightRegular,
      fontFamily: fontFamily,
      lineHeight: "".concat(round(16.5 / 12), "em"),
      color: palette.text.secondary
    }, allVariants),
    button: (0, _extends2.default)({
      fontSize: pxToRem(14),
      textTransform: 'uppercase',
      fontWeight: fontWeightMedium,
      fontFamily: fontFamily,
      color: palette.text.primary
    }, allVariants)
  };
  return (0, _deepmerge.default)((0, _extends2.default)({
    pxToRem: pxToRem,
    round: round,
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium
  }, oldVariants, nextVariants, useNextVariants ? {
    body1: nextVariants.body1Next,
    body2: nextVariants.body2Next,
    button: nextVariants.buttonNext,
    caption: nextVariants.captionNext
  } : {}, {
    useNextVariants: useNextVariants
  }), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
}

var shadows = ['none', createShadow(0, 1, 3, 0, 0, 1, 1, 0, 0, 2, 1, -1), createShadow(0, 1, 5, 0, 0, 2, 2, 0, 0, 3, 1, -2), createShadow(0, 1, 8, 0, 0, 3, 4, 0, 0, 3, 3, -2), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var _default = shadows;
exports.default = _default;

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var shape = {
  borderRadius: 4
};
var _default = shape;
exports.default = _default;

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var spacing = {
  // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density
  unit: 8
};
var _default = spacing;
exports.default = _default;

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.isNumber = exports.isString = exports.formatMs = exports.duration = exports.easing = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(141));

var _warning = _interopRequireDefault(__webpack_require__(93));

/* eslint-disable no-restricted-globals */
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

exports.easing = easing;
var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
exports.duration = duration;

var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};

exports.formatMs = formatMs;

var isString = function isString(value) {
  return typeof value === 'string';
};

exports.isString = isString;

var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */


exports.isNumber = isNumber;
var _default = {
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
     false ? (0, _warning.default)(isString(props) || Array.isArray(props), 'Material-UI: argument "props" must be a string or Array.') : void 0;
     false ? (0, _warning.default)(isNumber(durationOption) || isString(durationOption), "Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, ".")) : void 0;
     false ? (0, _warning.default)(isString(easingOption), 'Material-UI: argument "easing" must be a string.') : void 0;
     false ? (0, _warning.default)(isNumber(delay) || isString(delay), 'Material-UI: argument "delay" must be a number or a string.') : void 0;
     false ? (0, _warning.default)(Object.keys(other).length === 0, "Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]")) : void 0;
    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
};
exports.default = _default;

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var _default = zIndex;
exports.default = _default;

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CHANNEL = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(103));

// Same value used by react-jss
var CHANNEL = '__THEMING__';
exports.CHANNEL = CHANNEL;
var themeListener = {
  contextTypes: (0, _defineProperty2.default)({}, CHANNEL, function () {}),
  initial: function initial(context) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].getState();
  },
  subscribe: function subscribe(context, cb) {
    if (!context[CHANNEL]) {
      return null;
    }

    return context[CHANNEL].subscribe(cb);
  },
  unsubscribe: function unsubscribe(context, subscriptionId) {
    if (context[CHANNEL]) {
      context[CHANNEL].unsubscribe(subscriptionId);
    }
  }
};
var _default = themeListener;
exports.default = _default;

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createGenerateClassName;

var _warning = _interopRequireDefault(__webpack_require__(93));

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;

function safePrefix(classNamePrefix) {
  var prefix = String(classNamePrefix);
   false ? (0, _warning.default)(prefix.length < 256, "Material-UI: the class name prefix is too long: ".concat(prefix, ".")) : void 0; // Sanitize the string as will be used to prefix the generated class name.

  return prefix.replace(escapeRegex, '-');
} // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js


function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$dangerouslyU = options.dangerouslyUseGlobalCSS,
      dangerouslyUseGlobalCSS = _options$dangerouslyU === void 0 ? false : _options$dangerouslyU,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;
     false ? (0, _warning.default)(ruleCounter < 1e10, ['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join('')) : void 0;

    if (dangerouslyUseGlobalCSS && styleSheet && styleSheet.options.name) {
      return "".concat(safePrefix(styleSheet.options.name), "-").concat(rule.key);
    }

    if (true) {
      return "".concat(productionPrefix).concat(seed).concat(ruleCounter);
    } // Help with debuggability.


    if (styleSheet && styleSheet.options.classNamePrefix) {
      return "".concat(safePrefix(styleSheet.options.classNamePrefix), "-").concat(rule.key, "-").concat(seed).concat(ruleCounter);
    }

    return "".concat(rule.key, "-").concat(seed).concat(ruleCounter);
  };
}

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(62));

var _typeof2 = _interopRequireDefault(__webpack_require__(281));

var _warning = _interopRequireDefault(__webpack_require__(93));

var _deepmerge = _interopRequireDefault(__webpack_require__(285));

// < 1kb payload overhead when lodash/merge is > 3kb.
// Support for the jss-expand plugin.
function arrayMerge(destination, source) {
  return source;
}

function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';
   false ? (0, _warning.default)((0, _typeof2.default)(stylesOrCreator) === 'object' || themingEnabled, ['Material-UI: the first argument provided to withStyles() is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n')) : void 0;

  function create(theme, name) {
    var styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;

    if (!name || !theme.overrides || !theme.overrides[name]) {
      return styles;
    }

    var overrides = theme.overrides[name];
    var stylesWithOverrides = (0, _extends2.default)({}, styles);
    Object.keys(overrides).forEach(function (key) {
       false ? (0, _warning.default)(stylesWithOverrides[key], ['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n')) : void 0;
      stylesWithOverrides[key] = (0, _deepmerge.default)(stylesWithOverrides[key], overrides[key], {
        arrayMerge: arrayMerge
      });
    });
    return stylesWithOverrides;
  }

  return {
    create: create,
    options: {},
    themingEnabled: themingEnabled
  };
}

var _default = getStylesCreator;
exports.default = _default;

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme.props || !name || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

var _default = getThemeProps;
exports.default = _default;

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalize = capitalize;
exports.contains = contains;
exports.findIndex = findIndex;
exports.find = find;
exports.createChainedFunction = createChainedFunction;

var _typeof2 = _interopRequireDefault(__webpack_require__(281));

var _warning = _interopRequireDefault(__webpack_require__(93));

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (false) {
    throw new Error('Material-UI: capitalize(string) expects a string argument.');
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

function contains(obj, pred) {
  return Object.keys(pred).every(function (key) {
    return obj.hasOwnProperty(key) && obj[key] === pred[key];
  });
}

function findIndex(arr, pred) {
  var predType = (0, _typeof2.default)(pred);

  for (var i = 0; i < arr.length; i += 1) {
    if (predType === 'function' && !!pred(arr[i], i, arr) === true) {
      return i;
    }

    if (predType === 'object' && contains(arr[i], pred)) {
      return i;
    }

    if (['string', 'number', 'boolean'].indexOf(predType) !== -1) {
      return arr.indexOf(pred);
    }
  }

  return -1;
}

function find(arr, pred) {
  var index = findIndex(arr, pred);
  return index > -1 ? arr[index] : undefined;
}
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */


function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

     false ? (0, _warning.default)(typeof func === 'function', 'Material-UI: invalid Argument Type, must only provide functions, undefined, or null.') : void 0;
    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 1842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = TournamentTab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AccountType_Tab__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(14);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      color: #3b9478;\n    "],["\n      color: #3b9478;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject);var CupIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__Icons_Tournaments__["e" /* Cup */])(_templateObject2,"irontrade"==="irontrade"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3));function TournamentTab(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__AccountType_Tab__["a" /* default */],{tab:"tournament",currentTab:props.currentTab,onClick:function onClick(tab){api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");props.onClick(tab);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 480px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CupIcon,{width:"16px",height:"20px",style:{marginRight:5}});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Tournaments")));});}

/***/ }),
/* 1843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons__ = __webpack_require__(180);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  flex: 1 1 auto;\n  ",";\n  font-size: ",";\n  line-height: 1.25;\n  ",";\n  color: #99959d;\n  white-space: normal;\n\n  @media (max-width: 959px) {\n    margin-right: 22px;\n  }\n\n  @media (max-width: 479px) {\n    flex-basis: 100%;\n    flex-shrink: 0;\n    width: 100%;\n    margin-right: 0;\n  }\n"],["\n  direction: ",";\n  position: relative;\n  flex: 1 1 auto;\n  ",";\n  font-size: ",";\n  line-height: 1.25;\n  ",";\n  color: #99959d;\n  white-space: normal;\n\n  @media (max-width: 959px) {\n    margin-right: 22px;\n  }\n\n  @media (max-width: 479px) {\n    flex-basis: 100%;\n    flex-shrink: 0;\n    width: 100%;\n    margin-right: 0;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  ",";\n  top: -2.5px;\n"],["\n  position: absolute;\n  ",";\n  top: -2.5px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Info=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("padding-left","23px"),Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["a" /* fontSize */])(12,16),Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("text-align","left"));var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("left",0));var AccountInfo=function AccountInfo(_ref2){var children=_ref2.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Icons__["d" /* InfoIcon */],null))," ",children);};/* harmony default export */ __webpack_exports__["a"] = (AccountInfo);

/***/ }),
/* 1844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Scrollable__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Card__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-height: 100%;\n  white-space: normal;\n  overflow: hidden;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  max-height: 100%;\n  white-space: normal;\n  overflow: hidden;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  padding: 40px 0;\n  text-align: center;\n"],["\n  padding: 40px 0;\n  text-align: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 15px;\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    padding: 15px 10px;\n  }\n\n  @media (min-width: 960px) {\n    ",";\n  }\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  padding: 15px;\n  overflow: hidden;\n\n  @media (max-width: 959px) {\n    padding: 15px 10px;\n  }\n\n  @media (min-width: 960px) {\n    ",";\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  align-content: flex-start;\n  flex: 1;\n\n  @media (min-width: 960px) {\n    margin-bottom: 1em;\n    padding: 0 15px;\n  }\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    padding: 0 16px;\n  }\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  align-content: flex-start;\n  flex: 1;\n\n  @media (min-width: 960px) {\n    margin-bottom: 1em;\n    padding: 0 15px;\n  }\n\n  @media (max-width: 959px) {\n    flex-direction: column;\n    justify-content: center;\n    align-content: center;\n    align-items: center;\n    padding: 0 16px;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-bottom: 1em;\n"],["\n  margin-bottom: 1em;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  margin-top: 0;\n\n  @media (min-width: 960px) {\n    ",";\n  }\n"],["\n  margin-top: 0;\n\n  @media (min-width: 960px) {\n    ",";\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  flex-grow: 2;\n\n  @media (min-width: 960px) {\n    :after {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      height: 1em;\n      background: linear-gradient(\n        to bottom,\n        ","\n          0%,\n        "," 100%\n      );\n    }\n  }\n\n  & + "," {\n    margin-top: 15px;\n  }\n"],["\n  flex-grow: 2;\n\n  @media (min-width: 960px) {\n    :after {\n      content: \"\";\n      position: absolute;\n      left: 0;\n      bottom: 0;\n      width: 100%;\n      height: 1em;\n      background: linear-gradient(\n        to bottom,\n        ","\n          0%,\n        "," 100%\n      );\n    }\n  }\n\n  & + "," {\n    margin-top: 15px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  margin-bottom: 8px;\n"],["\n  margin-bottom: 8px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin: 16px 10px;\n  font-size: 14px;\n  font-weight: bold;\n  color: ",";\n  text-transform: uppercase;\n  text-align: center;\n"],["\n  margin: 16px 10px;\n  font-size: 14px;\n  font-weight: bold;\n  color: ",";\n  text-transform: uppercase;\n  text-align: center;\n"]);function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import { disableRefill } from "../helpers/refill";
var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject);var Info=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject2);var Wrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["c" /* rtl */])("padding-right","3px"));var Cards=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject4);var Bar=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_11__styles__["d" /* Bar */])(_templateObject5);var Link=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__Link__["a" /* default */])(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_12__common_styled_mixins__["c" /* rtl */])("padding-right","15px"));var Scrollable=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_6__common_Scrollable__["a" /* default */])(_templateObject7, true?"rgba(49,49,49,0)":"rgba(60,52,70,0)",function(_ref){var theme=_ref.theme;return theme.mainHighlight;},Link);var Category=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject8);var CategoryTitle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject9,function(_ref2){var theme=_ref2.theme;return theme.tabsTournamentsCategoryTitle;});var TabContents=function(_React$Component){_inherits(TabContents,_React$Component);function TabContents(){var _ref3,_this2=this;var _temp,_this,_ret;_classCallCheck(this,TabContents);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=TabContents.__proto__||Object.getPrototypeOf(TabContents)).call.apply(_ref3,[this].concat(args))),_this),_this.onActivateTournament=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var _this$props,api,onClose,dispatch,activate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,api=_this$props.api,onClose=_this$props.onClose,dispatch=_this$props.dispatch;_context.next=3;return api.fetchEntity("/api/tournaments/activate?id="+id);case 3:activate=_context.sent;if(!(activate!==null)){_context.next=12;break;}api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/list?status=1&participation_status=1");api.fetchEntity("/api/tournaments/info?id="+id);_context.next=10;return api.fetchEntity("/api/tournaments/stats");case 10:dispatch({type:"ENGAGE_TOURNAMENT_MODE"});onClose();case 12:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref4.apply(this,arguments);};}(),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TabContents,[{key:"componentDidMount",value:function componentDidMount(){var api=this.props.api;api.fetchEntity("/api/tournaments/stats");api.fetchEntity("/api/tournaments/list?limit=100&offset=0&status=1");api.fetchEntity("/api/tournaments/list?limit=100&offset=0&status=1&participation_status=1");}},{key:"render",value:function render(){var _this3=this;var _props=this.props,api=_props.api,enabledStock=_props.enabledStock,onClose=_props.onClose;var stats=__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/tournaments/stats"),function(stats){return stats.value;});var current_tournament=__WEBPACK_IMPORTED_MODULE_3_idx___default()(stats,function(stats){return stats.active_tournament;});var participated_tournaments=__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/tournaments/list?limit=100&offset=0&status=1&participation_status=1"),function(tournaments){return tournaments.value;});var active_tournaments=__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/tournaments/list?limit=100&offset=0&status=1"),function(tournaments){return tournaments.value;});if(active_tournaments==null||participated_tournaments==null||stats==null){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Spinners_SimpleSpinner__["c" /* default */],{accent:true}));}if(active_tournaments!=null&&active_tournaments.count<1){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Info,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"There are no tournaments available.")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Link,{to:"/tournaments",target:"_self"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"All tournaments"))));}var excludeIds=participated_tournaments&&participated_tournaments.items.reduce(function(res,item){res.push(item.id);return res;},[])||[];var nearest=[];var nearestPaid=active_tournaments.items.find(function(item){return item.participation_status===0&&item.type==="pay"&&item.start_date*1000>_this3.props.time&&!excludeIds.includes(item.id);});var nearestFree=active_tournaments.items.find(function(item){return item.participation_status===0&&item.type==="free"&&item.start_date*1000>_this3.props.time&&!excludeIds.includes(item.id);});if(nearestPaid){nearest.push(nearestPaid);}if(nearestFree){nearest.push(nearestFree);}return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Scrollable,{bar:__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Bar,null)},participated_tournaments.items.length>0&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Category,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CategoryTitle,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You are participating")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cards,null,participated_tournaments.items.filter(function(item){return item.participation_status===1;}).map(function(tournament){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Card__["a" /* default */],Object.assign({key:tournament.id,layout:"horizontal",onClose:onClose,isCurrent:tournament.id===(current_tournament&&current_tournament.id),onActivateTournament:_this3.onActivateTournament,enabledStock:enabledStock},tournament));})))),nearest.length>0&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Category,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](CategoryTitle,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"The nearest tournaments"))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Cards,null,nearest.map(function(tournament){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Card__["a" /* default */],Object.assign({key:tournament.id,layout:"horizontal",onClose:onClose,onActivateTournament:_this3.onActivateTournament,enabledStock:enabledStock},tournament));})))),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Link,{to:"/tournaments",target:"_self"},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"All tournaments"))));}}]);return TabContents;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var mapStateToStocks=function mapStateToStocks(state){var activeTab=state.tabs.tabs[state.tabs.activeTab];return{time:state.time||Date.now(),enabledStock:state.stocks[activeTab].enabled};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToStocks)(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TabContents,Object.assign({},props,{api:api}));});}));

/***/ }),
/* 1845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(1846);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Card__["a" /* default */]);

/***/ }),
/* 1846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PrizeFund__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ButtonSwitcher__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Link__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Sticker__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_tournament_card_bg_png__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__images_tournament_card_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__images_tournament_card_bg_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  height: 228px;\n  padding: 18px;\n  font-size: 10px;\n  line-height: 1.1;\n  color: #cccccc;\n  background-color: ",";\n  background-image: linear-gradient(\n      to bottom,\n      ",",\n      ","\n    ),\n    url(",");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  box-shadow: inset 0px 0px 0px 1px ",";\n\n  @media (min-width: 960px) {\n    :nth-child(n + 3) {\n      margin-top: 18px;\n    }\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    margin: 9px;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n\n    :not(:first-child) {\n      margin-top: 18px;\n    }\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n"],["\n  direction: ",";\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  height: 228px;\n  padding: 18px;\n  font-size: 10px;\n  line-height: 1.1;\n  color: #cccccc;\n  background-color: ",";\n  background-image: linear-gradient(\n      to bottom,\n      ",",\n      ","\n    ),\n    url(",");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  box-shadow: inset 0px 0px 0px 1px ",";\n\n  @media (min-width: 960px) {\n    :nth-child(n + 3) {\n      margin-top: 18px;\n    }\n  }\n\n  @media (min-width: 480px) and (max-width: 959px) {\n    margin: 9px;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n\n    :not(:first-child) {\n      margin-top: 18px;\n    }\n  }\n\n  ",";\n\n  ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n        box-shadow: inset 0px 0px 0px ","px ",";\n      "],["\n        box-shadow: inset 0px 0px 0px ","px ",";\n      "]),_templateObject3=_taggedTemplateLiteral(["\n      box-shadow: none;\n    "],["\n      box-shadow: none;\n    "]),_templateObject4=_taggedTemplateLiteral(["\n  min-height: 14px;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  ",";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.3s ease;\n  pointer-events: none;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n"],["\n  min-height: 14px;\n  font-weight: 700;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  ",";\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: color 0.3s ease;\n  pointer-events: none;\n\n  :hover,\n  :focus,\n  :active {\n    color: ",";\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  color: inherit;\n  text-decoration: none;\n  pointer-events: auto;\n"],["\n  color: inherit;\n  text-decoration: none;\n  pointer-events: auto;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  padding-top: 0.1em;\n"],["\n  padding-top: 0.1em;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  color: #cccccc;\n"],["\n  color: #cccccc;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  margin-top: 0.5em;\n"],["\n  margin-top: 0.5em;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  padding: 5px 0;\n  color: ",";\n\n  "," + & {\n    margin-top: 1em;\n  }\n"],["\n  padding: 5px 0;\n  color: ",";\n\n  "," + & {\n    margin-top: 1em;\n  }\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},function(_ref2){var theme=_ref2.theme;return theme.tournamentCardBg;},function(_ref3){var theme=_ref3.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.tournamentCardBg,0.75);},function(_ref4){var theme=_ref4.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.tournamentCardBg,0.75);},function(_ref5){var bg=_ref5.bg;return bg?bg:__WEBPACK_IMPORTED_MODULE_19__images_tournament_card_bg_png___default.a;},function(_ref6){var theme=_ref6.theme;return theme.mainDark;},function(_ref7){var participating=_ref7.participating,trading=_ref7.trading,theme=_ref7.theme;if(trading===true||participating===true){return Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["c" /* css */])(_templateObject2,trading?3:1,theme.accent);}},function(_ref8){var isTournamentPage=_ref8.isTournamentPage;return isTournamentPage&&Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["c" /* css */])(_templateObject3);},""/* ${({ bg }) =>
    bg &&
    css`
      background-image: linear-gradient(
          rgba(0, 0, 0, 0.45),
          rgba(0, 0, 0, 0.45)
        ),
        url(${bg});
    `}; */);var Heading=__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */].div(_templateObject4,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14),function(_ref9){var theme=_ref9.theme;return theme.tournamentCardMainColor;},Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["c" /* rtl */])("text-align","left"),function(_ref10){var theme=_ref10.theme;return theme.alternativeAccent;});var HeadingLink=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */])(_templateObject5);var Text=__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */].div(_templateObject6);var TakingPart=__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */].div(_templateObject7);var Link=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_14__Link__["a" /* default */])(_templateObject8);var Timer=Object(__WEBPACK_IMPORTED_MODULE_7_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_11__Timer__["c" /* default */])(_templateObject9,function(_ref11){var theme=_ref11.theme;return theme.mode==="light"?theme.background:theme.foreground;},Heading);var Card=function(_React$Component){_inherits(Card,_React$Component);function Card(){var _ref12,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Card);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref12=Card.__proto__||Object.getPrototypeOf(Card)).call.apply(_ref12,[this].concat(args))),_this),_this.onTradeClick=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var _this$props,api,onClose,dispatch,id,activate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_this$props=_this.props,api=_this$props.api,onClose=_this$props.onClose,dispatch=_this$props.dispatch,id=_this$props.id;_context.next=3;return api.fetchEntity("/api/tournaments/activate?id="+id);case 3:activate=_context.sent;if(!(activate!==null)){_context.next=11;break;}api.fetchEntity("/api/tournaments/list?status=1");api.fetchEntity("/api/tournaments/info?id="+id);_context.next=9;return api.fetchEntity("/api/tournaments/stats");case 9:dispatch({type:"ENGAGE_TOURNAMENT_MODE"});onClose();case 11:case"end":return _context.stop();}}},_callee,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Card,[{key:"render",value:function render(){var _this3=this;var _props=this.props,api=_props.api,onActivateTournament=_props.onActivateTournament,enabledStock=_props.enabledStock,onClose=_props.onClose,isTournamentPage=_props.isTournamentPage,props=_objectWithoutProperties(_props,["api","onActivateTournament","enabledStock","onClose","isTournamentPage"]);var active_tournament=__WEBPACK_IMPORTED_MODULE_3_idx___default()(api.readEntity("/api/tournaments/stats"),function(stats){return stats.value.active_tournament;});var isParticipating=props.participation_status===1;var bg=__WEBPACK_IMPORTED_MODULE_3_idx___default()(props,function(props){return props.images.bar;});var isNew=Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["g" /* getNew */])(props);var active=Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["d" /* getActive */])(props);var isCompleted=Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["e" /* getCompleted */])(props);// const bg =
//   props.images && props.images.bar != null ? props.images.bar : null;
var isTrading=active_tournament!=null&&active_tournament.id===props.id;if(isCompleted||isTrading){return null;}var isAndroid=window.androidApp!==undefined;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(min-width: 960px)"},function(matches){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Container,{participating:isParticipating,trading:isTrading,bg:bg,isTournamentPage:isTournamentPage},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](HeadingLink,{to:"/tournaments/"+props.id},props.title)),isParticipating===true&&__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](TakingPart,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_Gettext__["b" /* default */],null,"You are participating")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Timer,{days:Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["f" /* getDuration */])(props,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["f" /* getDuration */])(props,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["f" /* getDuration */])(props,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_11__Timer__["f" /* getDuration */])(props,"seconds"),active:active,isCompleted:isCompleted,isParticipating:isParticipating,labelOnTop:true,small:true,start_date:props.start_date,finish_date:props.finish_date,toStart:true}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__PrizeFund__["a" /* default */],props,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_Gettext__["b" /* default */],null,"Prize fund"),":")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref14){var showModal=_ref14.showModal;return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__ButtonSwitcher__["a" /* default */],Object.assign({active:active,flat:true,isCompleted:isCompleted,isCardButton:true,usePlaceholders:true,onActiveTradeClick:function onActiveTradeClick(){return isAndroid?window.androidApp.tournamentTrade(props.id):onClose;},enabledStock:enabledStock,onTradeClick:isAndroid?function(){return window.androidApp.tournamentTrade(props.id);}:_this3.onTradeClick,onJoinClick:function onJoinClick(){return showModal(__WEBPACK_IMPORTED_MODULE_18__Popups__["b" /* JoinPopup */],props);},onLeaveClick:function onLeaveClick(){return showModal(__WEBPACK_IMPORTED_MODULE_18__Popups__["c" /* LeavePopup */],props);}},props));}),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Link,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_Gettext__["b" /* default */],null,"Learn more")),__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Sticker__["a" /* default */],Object.assign({},props,{active:active,isNew:isNew})));});}}]);return Card;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_11__Timer__["i" /* mapStateToTime */])(function(props){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](Card,Object.assign({},props,{key:props.id,api:api}));});})));

/***/ }),
/* 1847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HowMuchInBucks__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__ = __webpack_require__(37);
var _templateObject=_taggedTemplateLiteral(["\n  margin-top: auto;\n  margin-bottom: auto;\n  padding: 5px 0;\n"],["\n  margin-top: auto;\n  margin-bottom: auto;\n  padding: 5px 0;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  padding: 5px 0;\n  font-size: ",";\n  color: ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  padding: 5px 0;\n  font-size: ",";\n  color: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-weight: 400;\n\n  ",";\n"],["\n  font-weight: 400;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n          margin-right: 8px;\n          text-align: right;\n        "],["\n          margin-right: 8px;\n          text-align: right;\n        "]),_templateObject5=_taggedTemplateLiteral(["\n          margin-left: 8px;\n          text-align: left;\n        "],["\n          margin-left: 8px;\n          text-align: left;\n        "]),_templateObject6=_taggedTemplateLiteral(["\n  font-weight: 700;\n"],["\n  font-weight: 700;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.tournamentCardMainColor;});var Fund=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref3){var theme=_ref3.theme;return theme.direction==="rtl"?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);});var Money=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Money__["b" /* default */])(_templateObject6);var Currency=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Money__["b" /* default */].Symbol)(_templateObject7,function(_ref4){var theme=_ref4.theme;return theme.alternativeAccent;});function PrizeFund(_ref5){var children=_ref5.children,prize_fund_usd=_ref5.prize_fund_usd,prize_fund=_ref5.prize_fund;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,children,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_Tournaments__["e" /* Cup */],{width:"16px",height:"20px"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Fund,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__HowMuchInBucks__["a" /* default */],{value:prize_fund,valueUSD:prize_fund_usd,symbolStyle:Currency,moneyStyle:Money}))));}/* harmony default export */ __webpack_exports__["a"] = (PrizeFund);

/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/tournament-card-bg.005039b4.png";

/***/ }),
/* 1849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_RefreshOutlined__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_RefreshOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_RefreshOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helpers_refill__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AccountType_AccountButton__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sticker__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_default_tournament_bg_iron_jpg__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__images_default_tournament_bg_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__images_default_tournament_bg_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_default_tournament_bg_th_jpg__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__images_default_tournament_bg_th_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__images_default_tournament_bg_th_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PrizeFund__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Account_Card_ButtonSwitcher__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 463px;\n  min-height: 144px;\n  margin-bottom: 8px;\n  padding: 3px;\n  font-size: ",";\n  color: #fff;\n  background-color: #1d2027;\n  background-image: url(",");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50%;\n\n  ",";\n\n  @media (max-width: 959px) {\n    align-self: center;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n    flex-direction: column;\n    padding: 18px 3px;\n    background-size: cover;\n  }\n"],["\n  direction: ",";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 463px;\n  min-height: 144px;\n  margin-bottom: 8px;\n  padding: 3px;\n  font-size: ",";\n  color: #fff;\n  background-color: #1d2027;\n  background-image: url(",");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50%;\n\n  ",";\n\n  @media (max-width: 959px) {\n    align-self: center;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n    flex-direction: column;\n    padding: 18px 3px;\n    background-size: cover;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 2px #feac00;\n    "],["\n      box-shadow: inset 0 0 0 2px #feac00;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-flex;\n  ",";\n  font-size: ",";\n  font-weight: 700;\n  color: #ffffff;\n  text-decoration: none;\n\n  ",";\n"],["\n  display: inline-flex;\n  ",";\n  font-size: ",";\n  font-weight: 700;\n  color: #ffffff;\n  text-decoration: none;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      padding-left: 15px;\n    "],["\n      padding-left: 15px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  direction: ",";\n  min-width: 55%;\n  flex-basis: 55%;\n  ",";\n  color: #ffffff;\n\n  @media (max-width: 479px) {\n    flex-basis: 100%;\n    min-width: 100%;\n  }\n"],["\n  direction: ",";\n  min-width: 55%;\n  flex-basis: 55%;\n  ",";\n  color: #ffffff;\n\n  @media (max-width: 479px) {\n    flex-basis: 100%;\n    min-width: 100%;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  min-width: 45%;\n  flex-basis: 45%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  ",";\n\n  @media (max-width: 479px) {\n    padding-top: 10px;\n    text-align: center;\n  }\n"],["\n  min-width: 45%;\n  flex-basis: 45%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  ",";\n\n  @media (max-width: 479px) {\n    padding-top: 10px;\n    text-align: center;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n      margin-top: 34px;\n    "],["\n      margin-top: 34px;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 163px;\n  height: 33px;\n  font-weight: 700;\n  font-size: ",";\n  color: #ffffff;\n  text-align: center;\n"],["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 163px;\n  height: 33px;\n  font-weight: 700;\n  font-size: ",";\n  color: #ffffff;\n  text-align: center;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-top: 20px;\n  font-size: ",";\n  color: #feac00;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n\n  @media (max-width: 479px) {\n    display: inline-block;\n  }\n"],["\n  margin-top: 20px;\n  font-size: ",";\n  color: #feac00;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n\n  @media (max-width: 479px) {\n    display: inline-block;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #99959d;\n"],["\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 700;\n  color: #feac00;\n"],["\n  font-size: ",";\n  font-weight: 700;\n  color: #feac00;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 700;\n  color: #ffffff;\n"],["\n  font-size: ",";\n  font-weight: 700;\n  color: #ffffff;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  display: block;\n  font-weight: 700;\n  font-size: ",";\n  color: #ffffff;\n  text-align: center;\n"],["\n  display: block;\n  font-weight: 700;\n  font-size: ",";\n  color: #ffffff;\n  text-align: center;\n"]),_templateObject14=_taggedTemplateLiteral(["\n  margin-top: 15px;\n\n  @media (max-width: 479px) {\n    display: block;\n  }\n"],["\n  margin-top: 15px;\n\n  @media (max-width: 479px) {\n    display: block;\n  }\n"]),_templateObject15=_taggedTemplateLiteral(["\n  margin-top: 7px;\n  color: #ffffff;\n\n  ",";\n"],["\n  margin-top: 7px;\n  color: #ffffff;\n\n  ",";\n"]),_templateObject16=_taggedTemplateLiteral(["\n        color: #feac00;\n      "],["\n        color: #feac00;\n      "]),_templateObject17=_taggedTemplateLiteral(["\n        color: #bebebe;\n      "],["\n        color: #bebebe;\n      "]),_templateObject18=_taggedTemplateLiteral(["\n        color: #df9784;\n      "],["\n        color: #df9784;\n      "]),_templateObject19=_taggedTemplateLiteral(["\n  margin-bottom: 12px;\n"],["\n  margin-bottom: 12px;\n"]),_templateObject20=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: ",";\n  color: #ffffff;\n"],["\n  font-weight: 700;\n  font-size: ",";\n  color: #ffffff;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject22=_taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.4;\n  color: inherit;\n  opacity: 0.5;\n"],["\n  margin-bottom: 12px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.4;\n  color: inherit;\n  opacity: 0.5;\n"]),_templateObject23=_taggedTemplateLiteral(["\n  width: 163px;\n  margin-bottom: 14px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #ffcc00;\n  text-align: center;\n"],["\n  width: 163px;\n  margin-bottom: 14px;\n  font-size: 12px;\n  font-weight: bold;\n  color: #ffcc00;\n  text-align: center;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Tournament=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(12),function(_ref2){var bg=_ref2.bg;return bg?bg: false?tournamentBgSiam:__WEBPACK_IMPORTED_MODULE_13__images_default_tournament_bg_iron_jpg___default.a;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject2);});var Title=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_10__common_Link__["a" /* Link */])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["c" /* rtl */])("margin-bottom","12px","8px"),Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(16),function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject4);});var FirstHalf=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5,function(_ref4){var theme=_ref4.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["c" /* rtl */])("padding-left","20px"));var LastHalf=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject6,function(props){return!props.isCompleted&&props.isParticipating&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7);});var ButtonContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(16));var MoreLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_10__common_Link__["a" /* Link */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(12));var Place=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(10));var UserPlace=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(14));var AllPlaces=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(14));var UnavailableText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(16));var EndText=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(UnavailableText)(_templateObject14);var CupContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject15,function(_ref5){var place=_ref5.place;if(place===1){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject16);}if(place===2){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject17);}if(place===3){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject18);}});var Timer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__Timer__["c" /* default */])(_templateObject19);var Participants=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(14));var PersonIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_16__Icons_Tournaments__["i" /* Person */])(_templateObject21,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["c" /* rtl */])("margin-right","8px"));var TournamentDate=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject22,Object(__WEBPACK_IMPORTED_MODULE_20__common_styled_mixins__["a" /* fontSize */])(12));var TounamentStatus=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject23);var TournamentCard=function TournamentCard(props){var isParticipating=props.participation_status===1;var bg=__WEBPACK_IMPORTED_MODULE_4_idx___default()(props,function(props){return props.images.bar;});var isNew=Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["g" /* getNew */])(props);var active=Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["d" /* getActive */])(props);var isCompleted=Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["e" /* getCompleted */])(props);var isAndroid=window.androidApp!==undefined;var refillAvailable=props.isCurrent&&!Object(__WEBPACK_IMPORTED_MODULE_8__helpers_refill__["a" /* disableRefill */])({api:props.api});var timeInHours=Math.floor((props.start_date*1000-props.time)/1000/3600);var statusIsStartSoon=props.type==="free"&&props.subtype===false&&timeInHours>=12;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tournament,{active:active,bg:bg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FirstHalf,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{to:"/tournaments/"+props.id},props.title),!isCompleted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Timer,{completedTimer:__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.finish_date*1000).format("LLL"),days:Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["f" /* getDuration */])(props,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["f" /* getDuration */])(props,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["f" /* getDuration */])(props,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_7__Timer__["f" /* getDuration */])(props,"seconds"),active:active,isCompleted:isCompleted,start_date:props.start_date,finish_date:props.finish_date,publish_time:props.publish_time,toStart:true,isTradePage:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentDate,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"The tournament is finished")),__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.start_date*1000).format("LL")," /"," ",__WEBPACK_IMPORTED_MODULE_2_moment___default()(props.finish_date*1000).format("LL")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__PrizeFund__["a" /* default */],{active:active,isCompleted:isCompleted,prize_fund_usd:props.prize_fund_usd,prize_fund:props.prize_fund,isTradePage:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LastHalf,{isCompleted:isCompleted,isParticipating:isParticipating},isCompleted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,isParticipating?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.userPlace>0&&props.userPlace<4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CupContainer,{place:props.userPlace},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Icons_Tournaments__["e" /* Cup */],{width:"16px",height:"21px"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Place,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserPlace,null,"# ",props.userPlace)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"of")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllPlaces,null,props.participantsCount))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Participants,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PersonIcon,null),props.participant_count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EndText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"The tournament is finished")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MoreLink,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"Learn more"))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,!active&&!isCompleted&&!isParticipating&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TounamentStatus,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"The tournament has not started yet")),statusIsStartSoon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnavailableText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"Starts soon")):props.isLimited&&props.isLimitedForMoney||props.invited||isParticipating?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref6){var showModal=_ref6.showModal;return refillAvailable?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__AccountType_AccountButton__["a" /* default */],{style:{minWidth:130},type:"tradeCardRefill",onClick:function onClick(e){// props.onClose(e);
showModal(__WEBPACK_IMPORTED_MODULE_19__Popups__["d" /* RefillPopup */]);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_RefreshOutlined___default.a,{style:{fontSize:28},color:"inherit"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"Refill")):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Account_Card_ButtonSwitcher__["a" /* default */],Object.assign({flat:true,active:active,isCompleted:isCompleted},props,{onActiveTradeClick:function onActiveTradeClick(){return isAndroid?window.androidApp.tournamentTrade(props.id):props.onClose;},onTradeClick:isAndroid?function(){return window.androidApp.tournamentTrade(props.id);}:function(){return props.onActivateTournament(props.id);},onJoinClick:function onJoinClick(){return showModal(__WEBPACK_IMPORTED_MODULE_19__Popups__["b" /* JoinPopup */],Object.assign({},props,{dontRedirect:true,fromTournamentsList:true}));},onLeaveClick:function onLeaveClick(){return showModal(__WEBPACK_IMPORTED_MODULE_19__Popups__["c" /* LeavePopup */],Object.assign({},props,{dontRedirect:true}));},newStyle:true,usePlaceholders:true,isTradePageCard:true}));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnavailableText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"Available by invitation only")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MoreLink,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__common_Gettext__["b" /* default */],null,"Learn more")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Sticker__["a" /* default */],{type:props.type,subtype:props.subtype,isNew:isNew,active:active,limited:props.isLimited}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_7__Timer__["i" /* mapStateToTime */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentCard,Object.assign({},props,{key:props.id,api:api}));});}));

/***/ }),
/* 1850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Shield;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function Shield(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 38.828 42.107"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("filter",{id:"a",x:"0",y:"0",filterUnits:"userSpaceOnUse"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feOffset",{dy:"3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feGaussianBlur",{stdDeviation:"3",result:"b"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feFlood",{floodOpacity:"0.161"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite",{operator:"in",in2:"b"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("feComposite",{"in":"SourceGraphic"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"matrix(1, 0, 0, 1, 0, 0)",filter:"url(#a)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-7155.075-6085.915l13.536-13.536v6.471a7.524,7.524,0,0,1-3.355,6.27l-5.687,3.79Zm-6.045-.55,19.093-19.093,1.735,1.735-19.091,19.093Zm1.692-4.817a7.526,7.526,0,0,1-.193-1.7v-10.282h.28a11.976,11.976,0,0,0,8.523-3.529l.236-.237.237.237a11.994,11.994,0,0,0,3.841,2.583l-12.924,12.925Z",transform:"translate(7170.12 6113.03)",fill:"#fff"})));}

/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/compensation-bonus-bg.a13c15d3.png";

/***/ }),
/* 1852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_paginate__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_paginate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_paginate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination_styles_css__ = __webpack_require__(1863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pagination_styles_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pagination_styles_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Private__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_dataLayer__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__UnitedHeader__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Icons__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Icons__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_SupportLink_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Spinners_SimpleSpinner__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ActiveTournaments__ = __webpack_require__(1864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__AboutTournaments__ = __webpack_require__(1866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Helpdesk_ToTopButton__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HistoryPages_Select__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Helpdesk_Footer__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__TournamentId__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Bell_Labels__ = __webpack_require__(274);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function Invitations(){var tournaments=Object(__WEBPACK_IMPORTED_MODULE_26__Bell_Labels__["a" /* useRelevantTournamentInvitations */])();if(tournaments!=null&&tournaments.length>0){tournaments.sort(function(a,b){if(a.start_date>b.start_date)return 1;if(a.start_date<b.start_date)return-1;return 0;});var tournament=tournaments[0];// Короткая переменная чтобы избежать переноса строки чтобы избежать проблем
// с геттекстом 🙄
var c=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["k" /* InvitedTournamentName */],null,tournament.title);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* Count */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["s" /* Text */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You have a special invitation to participate in the tournament named ",c,".")));}else{return null;}}var ActiveTab=function ActiveTab(props){switch(props.activeTab){case"activeFreeTournaments":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ActiveTournaments__["a" /* default */],Object.assign({type:"free"},props));case"activePaidTournaments":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ActiveTournaments__["a" /* default */],Object.assign({type:"paid"},props));case"completedTournaments":return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__ActiveTournaments__["a" /* default */],Object.assign({isCompleted:true},props));default:return null;}};var Tournaments=function(_Component){_inherits(Tournaments,_Component);function Tournaments(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Tournaments);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Tournaments.__proto__||Object.getPrototypeOf(Tournaments)).call.apply(_ref,[this].concat(args))),_this),_this.state={activeTab:"activeFreeTournaments",isFetching:true,offset:0,activePage:0,initialLoading:true},_this.apiParams=function(type){var limit=_this.props.tournamentsPerPage;var offset=_this.state.offset;switch(type){case"activeFreeTournaments":case"activePaidTournaments":return"/list?limit=100&offset=0&status=1";case"completedTournaments":return"/list?limit="+limit+"&offset="+offset+"&status=2";default:return"/list?limit=100&offset=0&status=1";}},_this.activateTournament=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(id){var api,activate;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!window.androidApp){_context.next=3;break;}window.androidApp.tournamentTrade(id);return _context.abrupt("return");case 3:api=_this.props.api;_context.next=6;return api.fetchEntity("/api/tournaments/activate?id="+id);case 6:activate=_context.sent;if(!(activate!==null)){_context.next=13;break;}api.fetchEntity("/api/tournaments"+_this.apiParams(_this.state.activeTab));_context.next=11;return api.fetchEntity("/api/tournaments/stats");case 11:_this.props.dispatch({type:"ENGAGE_TOURNAMENT_MODE"});_this.props.history.push("/trade");case 13:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.popupCallback=function(status){if(status==="success"){var api=_this.props.api;api.fetchEntity("/api/tournaments"+_this.apiParams(_this.state.activeTab));}},_this.handleTabClick=function(tab){if(_this.state.activeTab!==tab){_this.setState({activeTab:tab,activePage:0,offset:0});Object(__WEBPACK_IMPORTED_MODULE_12__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Tournaments",eventAction:"all-tournaments-page-tab-changed",eventLabel:"\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u043B\u0441\u044F \u043D\u0430 \u0442\u0430\u0431 "+tab+" \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 \u0432\u0441\u0435\u0445 \u0442\u0443\u0440\u043D\u0438\u0440\u043E\u0432"});}return null;},_this.scrollToTop=function(){__WEBPACK_IMPORTED_MODULE_4_react_scroll__["animateScroll"].scrollToTop({duration:500,isDynamic:true});},_this.onPageSizeChange=function(value){if(value===_this.props.tournamentsPerPage){return false;}var data=_this.props.api.readEntity("/api/tournaments"+_this.apiParams(_this.state.activeTab));if(data.value!=null&&value>=data.value.count&&_this.props.tournamentsPerPage>=data.value.count){_this.props.dispatch({type:"UPDATE_SETTINGS",payload:{tournamentsPerPage:value}});_this.setState({offset:0,activePage:0});return false;}_this.props.dispatch({type:"UPDATE_SETTINGS",payload:{tournamentsPerPage:value}});_this.setState({offset:0,activePage:0});},_this.goToPage=function(data){var page=data.selected;if(page===_this.state.activePage){return false;}_this.setState({activePage:page,offset:_this.props.tournamentsPerPage*page});},_this.toggleAbout=function(){_this.props.dispatch({type:"UPDATE_SETTINGS",payload:{showAboutTournaments:!_this.props.showAboutTournaments}});},_this.handleInitialLoading=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return _this.props.api.fetchEntity("/api/tournaments"+_this.apiParams(_this.state.activeTab));case 2:_this.setState({initialLoading:false});case 3:case"end":return _context2.stop();}}},_callee2,_this2);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Tournaments,[{key:"componentDidMount",value:function componentDidMount(){Object(__WEBPACK_IMPORTED_MODULE_12__common_dataLayer__["a" /* default */])({event:"event-to-ga",eventCategory:"Tournaments",eventAction:"all-tournaments-page-mount",eventLabel:"Пользователь перешел на страницу всех турниров"});this.handleInitialLoading();this.props.api.fetchEntity("/api/tournaments/stats");}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var data=this.props.api.readEntity("/api/tournaments"+this.apiParams(this.state.activeTab));if(data.status!=="Pending"&&prevState.activeTab!==this.state.activeTab){this.props.api.fetchEntity("/api/tournaments"+this.apiParams(this.state.activeTab));this.props.api.fetchEntity("/api/tournaments/stats");}}},{key:"render",value:function render(){var _this3=this;var _props=this.props,profile=_props.profile,api=_props.api;var _state=this.state,activePage=_state.activePage,activeTab=_state.activeTab;var pageSizeOptions=[{label:10,value:10},{label:20,value:20},{label:30,value:30},{label:40,value:40}];var data=api.readEntity("/api/tournaments"+this.apiParams(activeTab));var isFetching=this.state.initialLoading||data.value==null;var limit=this.props.tournamentsPerPage;var showPagination=data.value!=null&&data.value.count>limit;// считаем высоту плиток турниров, что бы красиво посередине рисовать спиннер
var spinnerHeight=!isFetching&&(showPagination?Math.ceil(limit/2)*168:Math.ceil(data.value.count/2)*168);var stats=api.readEntity("/api/tournaments/stats");var locale=Object(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["d" /* inferLocale */])(this.props)||"en";var participationCount=stats.value!=null&&stats.value.participation_count>0?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* Count */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["s" /* Text */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You participated in",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["l" /* Numbers */],null," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,stats.value.participation_count)," "),"tournaments."))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* Count */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["s" /* Text */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You did not participate in any tournaments yet.")));var accumulatedProfitCount=stats.value!=null&&stats.value.accumulated_profit!=="0.00"?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* Count */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["s" /* Text */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You have earned",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["l" /* Numbers */],null," ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Money__["b" /* default */],null,stats.value.accumulated_profit)," "),"in tournaments."))):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["g" /* Count */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["s" /* Text */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"You are not the winner yet.")));var invitationCount=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Invitations,null);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__UnitedHeader__["b" /* default */],{showMainHeader:false,location:this.props.location,history:this.props.history}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["m" /* PageContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["t" /* Title */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Tournaments")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["f" /* Container */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["x" /* UserInfo */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["c" /* AccountInfo */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["v" /* UserEmail */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */],{to:"/profile"},profile.email)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["w" /* UserId */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Icons__["b" /* InfoIcon */],null),"id: ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_Link__["a" /* Link */],{to:"/profile"},profile.id))),stats.value!=null&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["h" /* Counts */],null,participationCount,accumulatedProfitCount,invitationCount)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["r" /* Tabs */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["q" /* Tab */],{active:this.state.activeTab==="activeFreeTournaments",onClick:function onClick(){return _this3.handleTabClick("activeFreeTournaments");}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Active free")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["q" /* Tab */],{active:this.state.activeTab==="activePaidTournaments",onClick:function onClick(){return _this3.handleTabClick("activePaidTournaments");}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Active paid")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["q" /* Tab */],{active:this.state.activeTab==="completedTournaments",onClick:function onClick(){return _this3.handleTabClick("completedTournaments");}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Finished"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["u" /* Tournaments */],null,!isFetching?__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ActiveTab,Object.assign({activeTab:this.state.activeTab,popupCallback:this.popupCallback},this.props,{data:data,onActivateTournament:this.activateTournament,onActiveTradeClick:this.activateTournament,onClick:this.handlePopupOpening,locale:locale,apiParams:this.apiParams(this.state.activeTab)})):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["p" /* SpinnerContainer */],{spinnerHeight:spinnerHeight},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Spinners_SimpleSpinner__["c" /* default */],{accent:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["e" /* Bottom */],{activeTab:activeTab},activeTab==="completedTournaments"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["n" /* PaginationSelect */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["o" /* SelectText */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Rows per page"),":"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__HistoryPages_Select__["a" /* default */],{name:"page-rows-select",options:pageSizeOptions,value:{value:limit,label:limit},onChange:function onChange(e){_this3.onPageSizeChange(Number(e.value));}})),showPagination&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_paginate___default.a,{initialPage:activePage,forcePage:activePage,previousLabel:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Icons__["a" /* PaginationArrow */],null),nextLabel:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Icons__["a" /* PaginationArrow */],null),breakLabel:__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,"..."),breakClassName:"break-me",pageCount:Math.ceil(data.value&&data.value.count/limit),marginPagesDisplayed:1,pageRangeDisplayed:5,onPageChange:this.goToPage,containerClassName:"pagination",subContainerClassName:"pages pagination",activeClassName:"active"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["i" /* HelpContainer */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["j" /* HelpLink */],{to:"helpdesk/faq",target:"_blank"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"Need any help?")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__common_SupportLink_js__["a" /* Icon */],null))),this.state.activeTab!=="completedTournaments"&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["b" /* AboutToggle */],{onClick:this.toggleAbout,isOpen:this.props.showAboutTournaments},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__styles__["a" /* AboutTitle */],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__common_Gettext__["b" /* default */],null,"About tournaments"))),this.props.showAboutTournaments&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__AboutTournaments__["a" /* default */],{locale:locale,isOpen:this.props.showAboutTournaments}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__Helpdesk_Footer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Helpdesk_ToTopButton__["a" /* default */],{onClick:this.scrollToTop,hideTrade:true})));}}]);return Tournaments;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);var T=function T(props){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__Api__["c" /* default */].Consumer,null,function(api){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__TournamentId__["b" /* default */].Consumer,null,function(contextId){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Tournaments,Object.assign({},props,contextId,{api:api}));});});};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__Private__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_9__withData__["a" /* default */])({required:["serverData"],optional:["profile"]})(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{time:state.time||Date.now(),tournamentsPerPage:state.settings.tournamentsPerPage||10,showAboutTournaments:state.settings.showAboutTournaments!=null?state.settings.showAboutTournaments:true};})(T)))));

/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(441);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(443);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(441);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(712);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(30);

var utils = __webpack_require__(209);
var scrollSpy = __webpack_require__(442);
var defaultScroller = __webpack_require__(286);
var PropTypes = __webpack_require__(6);
var scrollHash = __webpack_require__(711);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
          if (this.props.name !== nextProps.name) {
            this.registerElems(nextProps.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(6);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PageView = __webpack_require__(1861);

var _PageView2 = _interopRequireDefault(_PageView);

var _BreakView = __webpack_require__(1862);

var _BreakView2 = _interopRequireDefault(_BreakView);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationBoxView = function (_Component) {
  _inherits(PaginationBoxView, _Component);

  function PaginationBoxView(props) {
    _classCallCheck(this, PaginationBoxView);

    var _this = _possibleConstructorReturn(this, (PaginationBoxView.__proto__ || Object.getPrototypeOf(PaginationBoxView)).call(this, props));

    _this.handlePreviousPage = function (evt) {
      var selected = _this.state.selected;

      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (selected > 0) {
        _this.handlePageSelected(selected - 1, evt);
      }
    };

    _this.handleNextPage = function (evt) {
      var selected = _this.state.selected;
      var pageCount = _this.props.pageCount;


      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;
      if (selected < pageCount - 1) {
        _this.handlePageSelected(selected + 1, evt);
      }
    };

    _this.handlePageSelected = function (selected, evt) {
      evt.preventDefault ? evt.preventDefault() : evt.returnValue = false;

      if (_this.state.selected === selected) return;

      _this.setState({ selected: selected });

      // Call the callback with the new selected item:
      _this.callCallback(selected);
    };

    _this.callCallback = function (selectedItem) {
      if (typeof _this.props.onPageChange !== "undefined" && typeof _this.props.onPageChange === "function") {
        _this.props.onPageChange({ selected: selectedItem });
      }
    };

    _this.pagination = function () {
      var items = [];
      var _this$props = _this.props,
          pageRangeDisplayed = _this$props.pageRangeDisplayed,
          pageCount = _this$props.pageCount,
          marginPagesDisplayed = _this$props.marginPagesDisplayed,
          breakLabel = _this$props.breakLabel,
          breakClassName = _this$props.breakClassName;
      var selected = _this.state.selected;


      if (pageCount <= pageRangeDisplayed) {

        for (var index = 0; index < pageCount; index++) {
          items.push(_this.getPageElement(index));
        }
      } else {

        var leftSide = pageRangeDisplayed / 2;
        var rightSide = pageRangeDisplayed - leftSide;

        if (selected > pageCount - pageRangeDisplayed / 2) {
          rightSide = pageCount - selected;
          leftSide = pageRangeDisplayed - rightSide;
        } else if (selected < pageRangeDisplayed / 2) {
          leftSide = selected;
          rightSide = pageRangeDisplayed - leftSide;
        }

        var _index = void 0;
        var page = void 0;
        var breakView = void 0;
        var createPageView = function createPageView(index) {
          return _this.getPageElement(index);
        };

        for (_index = 0; _index < pageCount; _index++) {

          page = _index + 1;

          if (page <= marginPagesDisplayed) {
            items.push(createPageView(_index));
            continue;
          }

          if (page > pageCount - marginPagesDisplayed) {
            items.push(createPageView(_index));
            continue;
          }

          if (_index >= selected - leftSide && _index <= selected + rightSide) {
            items.push(createPageView(_index));
            continue;
          }

          if (breakLabel && items[items.length - 1] !== breakView) {
            breakView = _react2.default.createElement(_BreakView2.default, {
              key: _index,
              breakLabel: breakLabel,
              breakClassName: breakClassName
            });
            items.push(breakView);
          }
        }
      }

      return items;
    };

    _this.state = {
      selected: props.initialPage ? props.initialPage : props.forcePage ? props.forcePage : 0
    };
    return _this;
  }

  _createClass(PaginationBoxView, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          initialPage = _props.initialPage,
          disableInitialCallback = _props.disableInitialCallback;
      // Call the callback with the initialPage item:

      if (typeof initialPage !== 'undefined' && !disableInitialCallback) {
        this.callCallback(initialPage);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (typeof nextProps.forcePage !== 'undefined' && this.props.forcePage !== nextProps.forcePage) {
        this.setState({ selected: nextProps.forcePage });
      }
    }
  }, {
    key: 'hrefBuilder',
    value: function hrefBuilder(pageIndex) {
      var _props2 = this.props,
          hrefBuilder = _props2.hrefBuilder,
          pageCount = _props2.pageCount;

      if (hrefBuilder && pageIndex !== this.state.selected && pageIndex >= 0 && pageIndex < pageCount) {
        return hrefBuilder(pageIndex + 1);
      }
    }
  }, {
    key: 'getPageElement',
    value: function getPageElement(index) {
      var selected = this.state.selected;
      var _props3 = this.props,
          pageClassName = _props3.pageClassName,
          pageLinkClassName = _props3.pageLinkClassName,
          activeClassName = _props3.activeClassName,
          extraAriaContext = _props3.extraAriaContext;


      return _react2.default.createElement(_PageView2.default, {
        key: index,
        onClick: this.handlePageSelected.bind(null, index),
        selected: selected === index,
        pageClassName: pageClassName,
        pageLinkClassName: pageLinkClassName,
        activeClassName: activeClassName,
        extraAriaContext: extraAriaContext,
        href: this.hrefBuilder(index),
        page: index + 1 });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          disabledClassName = _props4.disabledClassName,
          previousClassName = _props4.previousClassName,
          nextClassName = _props4.nextClassName,
          pageCount = _props4.pageCount,
          containerClassName = _props4.containerClassName,
          previousLinkClassName = _props4.previousLinkClassName,
          previousLabel = _props4.previousLabel,
          nextLinkClassName = _props4.nextLinkClassName,
          nextLabel = _props4.nextLabel;
      var selected = this.state.selected;


      var previousClasses = previousClassName + (selected === 0 ? ' ' + disabledClassName : '');
      var nextClasses = nextClassName + (selected === pageCount - 1 ? ' ' + disabledClassName : '');

      return _react2.default.createElement(
        'ul',
        { className: containerClassName },
        _react2.default.createElement(
          'li',
          { className: previousClasses },
          _react2.default.createElement(
            'a',
            { onClick: this.handlePreviousPage,
              className: previousLinkClassName,
              href: this.hrefBuilder(selected - 1),
              tabIndex: '0',
              role: 'button',
              onKeyPress: this.handlePreviousPage },
            previousLabel
          )
        ),
        this.pagination(),
        _react2.default.createElement(
          'li',
          { className: nextClasses },
          _react2.default.createElement(
            'a',
            { onClick: this.handleNextPage,
              className: nextLinkClassName,
              href: this.hrefBuilder(selected + 1),
              tabIndex: '0',
              role: 'button',
              onKeyPress: this.handleNextPage },
            nextLabel
          )
        )
      );
    }
  }]);

  return PaginationBoxView;
}(_react.Component);

PaginationBoxView.propTypes = {
  pageCount: _propTypes2.default.number.isRequired,
  pageRangeDisplayed: _propTypes2.default.number.isRequired,
  marginPagesDisplayed: _propTypes2.default.number.isRequired,
  previousLabel: _propTypes2.default.node,
  nextLabel: _propTypes2.default.node,
  breakLabel: _propTypes2.default.node,
  hrefBuilder: _propTypes2.default.func,
  onPageChange: _propTypes2.default.func,
  initialPage: _propTypes2.default.number,
  forcePage: _propTypes2.default.number,
  disableInitialCallback: _propTypes2.default.bool,
  containerClassName: _propTypes2.default.string,
  pageClassName: _propTypes2.default.string,
  pageLinkClassName: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  previousClassName: _propTypes2.default.string,
  nextClassName: _propTypes2.default.string,
  previousLinkClassName: _propTypes2.default.string,
  nextLinkClassName: _propTypes2.default.string,
  disabledClassName: _propTypes2.default.string,
  breakClassName: _propTypes2.default.string
};
PaginationBoxView.defaultProps = {
  pageCount: 10,
  pageRangeDisplayed: 2,
  marginPagesDisplayed: 3,
  activeClassName: "selected",
  previousClassName: "previous",
  nextClassName: "next",
  previousLabel: "Previous",
  nextLabel: "Next",
  breakLabel: "...",
  disabledClassName: "disabled",
  disableInitialCallback: false
};
exports.default = PaginationBoxView;
;
//# sourceMappingURL=PaginationBoxView.js.map

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PageView = function PageView(props) {
  var cssClassName = props.pageClassName;
  var linkClassName = props.pageLinkClassName;
  var onClick = props.onClick;
  var href = props.href;
  var ariaLabel = 'Page ' + props.page + (props.extraAriaContext ? ' ' + props.extraAriaContext : '');
  var ariaCurrent = null;

  if (props.selected) {
    ariaCurrent = 'page';
    ariaLabel = 'Page ' + props.page + ' is your current page';
    if (typeof cssClassName !== 'undefined') {
      cssClassName = cssClassName + ' ' + props.activeClassName;
    } else {
      cssClassName = props.activeClassName;
    }
  }

  return _react2.default.createElement(
    'li',
    { className: cssClassName },
    _react2.default.createElement(
      'a',
      { onClick: onClick,
        role: 'button',
        className: linkClassName,
        href: href,
        tabIndex: '0',
        'aria-label': ariaLabel,
        'aria-current': ariaCurrent,
        onKeyPress: onClick },
      props.page
    )
  );
};

exports.default = PageView;
//# sourceMappingURL=PageView.js.map

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BreakView = function BreakView(props) {
  var label = props.breakLabel;
  var className = props.breakClassName || 'break';

  return _react2.default.createElement(
    'li',
    { className: className },
    label
  );
};

exports.default = BreakView;
//# sourceMappingURL=BreakView.js.map

/***/ }),
/* 1863 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Tournament__ = __webpack_require__(1865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  min-width: 100%;\n  margin-top: 5px;\n  margin-bottom: 30px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #bebebe;\n  line-height: 1.2;\n\n  @media (max-width: 969px) {\n    min-width: auto;\n    max-width: 463px;\n    margin-top: 0;\n    margin-bottom: 25px;\n  }\n"],["\n  width: 100%;\n  min-width: 100%;\n  margin-top: 5px;\n  margin-bottom: 30px;\n  font-size: 18px;\n  font-weight: bold;\n  color: #bebebe;\n  line-height: 1.2;\n\n  @media (max-width: 969px) {\n    min-width: auto;\n    max-width: 463px;\n    margin-top: 0;\n    margin-bottom: 25px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var TournamentTitle=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var freeForUser=function freeForUser(tournament){return!!(tournament.type==="free"&&tournament.subtype!=="demo"||tournament.is_limited&&tournament.invited);};function ActiveTournaments(props){var tournaments=props.data.value!=null?props.data.value.items:[];var tournamentsByType=function tournamentsByType(){switch(props.type){case"free":return tournaments.filter(function(tournament){return freeForUser(tournament);});case"paid":return tournaments.filter(function(tournament){return!freeForUser(tournament);});default:return tournaments;}};var participatingTournaments=tournamentsByType().filter(function(tournament){return tournament.participation_status===1;});var otherTournaments=tournamentsByType().filter(function(tournament){return tournament.participation_status===0;});var time=props.time;switch(true){case tournamentsByType().length===0:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{margin:"10px auto",paddingBottom:10,textAlign:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"There are no tournaments available."));case participatingTournaments.length>0:return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentTitle,null,props.isCompleted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You have participated"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You are participating")),participatingTournaments.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tournament__["a" /* default */],Object.assign({active:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["d" /* getActive */])(Object.assign({},item,{time:time})),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["e" /* getCompleted */])(Object.assign({},item,{time:time})),isNew:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["g" /* getNew */])(Object.assign({},item,{time:time})),isLimited:item.is_limited,isLimitedForMoney:item.limited_for_money,type:item.type,title:item.title,prize_fund:item.prize_fund_usd,userPlace:item.current_place,participantsCount:item.participant_count,participation_status:item.participation_status,key:i,id:item.id,apiParams:props.apiParams,dispatch:props.dispatch,onActivateTournament:props.onActivateTournament,onActiveTradeClick:props.onActiveTradeClick,onClick:props.onClick,popupCallback:props.popupCallback,time:time},item));}),otherTournaments.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Other tournaments")),otherTournaments.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tournament__["a" /* default */],Object.assign({active:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["d" /* getActive */])(Object.assign({},item,{time:time})),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["e" /* getCompleted */])(Object.assign({},item,{time:time})),isNew:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["g" /* getNew */])(Object.assign({},item,{time:time})),isLimited:item.is_limited,isLimitedForMoney:item.limited_for_money,type:item.type,title:item.title,prize_fund:item.prize_fund_usd,userPlace:item.current_place,participantsCount:item.participant_count,participation_status:item.participation_status,key:i,id:item.id,apiParams:props.apiParams,dispatch:props.dispatch,onActivateTournament:props.onActivateTournament,onActiveTradeClick:props.onActiveTradeClick,onClick:props.onClick,popupCallback:props.popupCallback,time:time},item));})));default:return tournamentsByType().map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Tournament__["a" /* default */],Object.assign({active:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["d" /* getActive */])(Object.assign({},item,{time:time})),isCompleted:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["e" /* getCompleted */])(Object.assign({},item,{time:time})),isNew:Object(__WEBPACK_IMPORTED_MODULE_3__Timer__["g" /* getNew */])(Object.assign({},item,{time:time})),isLimited:item.is_limited,isLimitedForMoney:item.limited_for_money,type:item.type,title:item.title,prize_fund:item.prize_fund_usd,userPlace:item.current_place,participantsCount:item.participant_count,participation_status:item.participation_status,key:i,id:item.id,apiParams:props.apiParams,dispatch:props.dispatch,onActivateTournament:props.onActivateTournament,onActiveTradeClick:props.onActiveTradeClick,onClick:props.onClick,popupCallback:props.popupCallback,time:time},item));});}}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{time:state.time||Date.now()};})(ActiveTournaments));

/***/ }),
/* 1865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Sticker__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_default_tournament_bg_iron_jpg__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__images_default_tournament_bg_iron_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__images_default_tournament_bg_iron_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_default_tournament_bg_th_jpg__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_default_tournament_bg_th_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_default_tournament_bg_th_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PrizeFund__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Account_Card_ButtonSwitcher__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popups__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 463px;\n  min-height: 144px;\n  margin-bottom: 24px;\n  padding: 3px;\n  font-size: ",";\n  color: #fff;\n  background-color: ",";\n  background-image: linear-gradient(\n      to bottom,\n      ",",\n      ","\n    ),\n    url(",");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50%;\n\n  ",";\n\n  @media (max-width: 959px) {\n    align-self: center;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n    flex-direction: column;\n    padding: 18px 3px;\n    background-size: cover;\n  }\n"],["\n  direction: ",";\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  max-width: 463px;\n  min-height: 144px;\n  margin-bottom: 24px;\n  padding: 3px;\n  font-size: ",";\n  color: #fff;\n  background-color: ",";\n  background-image: linear-gradient(\n      to bottom,\n      ",",\n      ","\n    ),\n    url(",");\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: 50%;\n\n  ",";\n\n  @media (max-width: 959px) {\n    align-self: center;\n  }\n\n  @media (max-width: 479px) {\n    width: 100%;\n    flex-direction: column;\n    padding: 18px 3px;\n    background-size: cover;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n      box-shadow: inset 0 0 0 3px ",";\n    "],["\n      box-shadow: inset 0 0 0 3px ",";\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  display: inline-flex;\n  ",";\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n  text-decoration: none;\n\n  ",";\n"],["\n  display: inline-flex;\n  ",";\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n  text-decoration: none;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      padding-left: 15px;\n    "],["\n      padding-left: 15px;\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  direction: ",";\n  min-width: 55%;\n  flex-basis: 55%;\n  ",";\n  color: ",";\n\n  @media (max-width: 479px) {\n    flex-basis: 100%;\n    min-width: 100%;\n  }\n"],["\n  direction: ",";\n  min-width: 55%;\n  flex-basis: 55%;\n  ",";\n  color: ",";\n\n  @media (max-width: 479px) {\n    flex-basis: 100%;\n    min-width: 100%;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  min-width: 45%;\n  flex-basis: 45%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  ",";\n\n  @media (max-width: 479px) {\n    display: block;\n    padding-top: 10px;\n    text-align: center;\n  }\n"],["\n  min-width: 45%;\n  flex-basis: 45%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  ",";\n\n  @media (max-width: 479px) {\n    display: block;\n    padding-top: 10px;\n    text-align: center;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n      margin-top: 34px;\n    "],["\n      margin-top: 34px;\n    "]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 163px;\n  height: 33px;\n  font-weight: 700;\n  font-size: ",";\n  color: ",";\n  text-align: center;\n"],["\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 163px;\n  height: 33px;\n  font-weight: 700;\n  font-size: ",";\n  color: ",";\n  text-align: center;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-top: 20px;\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n\n  @media (max-width: 479px) {\n    display: inline-block;\n  }\n"],["\n  margin-top: 20px;\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n  }\n\n  @media (max-width: 479px) {\n    display: inline-block;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  font-size: ",";\n  color: #99959d;\n"],["\n  font-size: ",";\n  color: #99959d;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n"],["\n  font-size: ",";\n  font-weight: 700;\n  color: ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: ",";\n  color: ",";\n  text-align: center;\n"],["\n  font-weight: 700;\n  font-size: ",";\n  color: ",";\n  text-align: center;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-top: 15px;\n\n  @media (max-width: 479px) {\n    display: block;\n  }\n"],["\n  margin-top: 15px;\n\n  @media (max-width: 479px) {\n    display: block;\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n  margin-top: 7px;\n  color: ",";\n\n  ",";\n"],["\n  margin-top: 7px;\n  color: ",";\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n        color: ",";\n      "],["\n        color: ",";\n      "]),_templateObject16=_taggedTemplateLiteral(["\n        color: #bebebe;\n      "],["\n        color: #bebebe;\n      "]),_templateObject17=_taggedTemplateLiteral(["\n        color: #df9784;\n      "],["\n        color: #df9784;\n      "]),_templateObject18=_taggedTemplateLiteral(["\n  margin-bottom: 12px;\n"],["\n  margin-bottom: 12px;\n"]),_templateObject19=_taggedTemplateLiteral(["\n  font-weight: 700;\n  font-size: ",";\n  color: ",";\n"],["\n  font-weight: 700;\n  font-size: ",";\n  color: ",";\n"]),_templateObject20=_taggedTemplateLiteral(["\n  ",";\n"],["\n  ",";\n"]),_templateObject21=_taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.4;\n  color: inherit;\n  opacity: 0.5;\n"],["\n  margin-bottom: 12px;\n  font-weight: 400;\n  font-size: ",";\n  line-height: 1.4;\n  color: inherit;\n  opacity: 0.5;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Tournament=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(12),function(_ref2){var theme=_ref2.theme;return theme.main;},function(_ref3){var theme=_ref3.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.main,0.75);},function(_ref4){var theme=_ref4.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.main,0.75);},function(_ref5){var bg=_ref5.bg;return bg?bg: false?tournamentBgSiam:__WEBPACK_IMPORTED_MODULE_7__images_default_tournament_bg_iron_jpg___default.a;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject2,props.theme.accent);});var Title=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["c" /* rtl */])("margin-bottom","12px","8px"),Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(16),function(_ref6){var theme=_ref6.theme;return theme.foreground;},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject4);});var FirstHalf=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject5,function(_ref8){var theme=_ref8.theme;return theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["c" /* rtl */])("padding-left","20px"),function(_ref9){var theme=_ref9.theme;return theme.foreground;});var LastHalf=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject6,function(props){return!props.isCompleted&&Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject7);});var ButtonContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject8,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(16),function(_ref10){var theme=_ref10.theme;return theme.foreground;});var MoreLink=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.theme.accent;});var Place=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(10));var UserPlace=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.theme.accent;});var AllPlaces=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(14),function(_ref11){var theme=_ref11.theme;return theme.foreground;});var UnavailableText=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].span(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(16),function(_ref12){var theme=_ref12.theme;return theme.foreground;});var EndText=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(UnavailableText)(_templateObject13);var CupContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject14,function(_ref13){var theme=_ref13.theme;return theme.foreground;},function(_ref14){var place=_ref14.place,theme=_ref14.theme;if(place===1){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject15,theme.accent);}if(place===2){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject16);}if(place===3){return Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["c" /* css */])(_templateObject17);}});var Timer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__Timer__["c" /* default */])(_templateObject18);var Participants=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject19,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(14),function(_ref15){var theme=_ref15.theme;return theme.foreground;});var PersonIcon=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_11__Icons_Tournaments__["i" /* Person */])(_templateObject20,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["c" /* rtl */])("margin-right","8px"));var TournamentDate=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject21,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(12));var TournamentCard=function TournamentCard(props){var isParticipating=props.participation_status===1;var timeInHours=Math.floor((props.start_date*1000-props.time)/1000/3600);var statusIsStartSoon=props.type==="free"&&props.subtype===false&&timeInHours>=12;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tournament,{active:props.active,bg:props.images&&props.images.bar!=null?props.images.bar:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(FirstHalf,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,{to:"/tournaments/"+props.id},props.title),!props.isCompleted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Timer,{completedTimer:__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.finish_date*1000).format("LLL"),days:Object(__WEBPACK_IMPORTED_MODULE_9__Timer__["f" /* getDuration */])(props,"days"),hours:Object(__WEBPACK_IMPORTED_MODULE_9__Timer__["f" /* getDuration */])(props,"hours"),minutes:Object(__WEBPACK_IMPORTED_MODULE_9__Timer__["f" /* getDuration */])(props,"minutes"),seconds:Object(__WEBPACK_IMPORTED_MODULE_9__Timer__["f" /* getDuration */])(props,"seconds"),active:props.active,isCompleted:props.isCompleted,start_date:props.start_date,finish_date:props.finish_date,publish_time:props.publish_time,toStart:true}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentDate,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"The tournament is finished")),__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.start_date*1000).format("LL")," /"," ",__WEBPACK_IMPORTED_MODULE_1_moment___default()(props.finish_date*1000).format("LL")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PrizeFund__["a" /* default */],{active:props.active,isCompleted:props.isCompleted,prize_fund_usd:props.prize_fund_usd,prize_fund:props.prize_fund})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LastHalf,{isCompleted:props.isCompleted},props.isCompleted?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,isParticipating?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,props.userPlace>0&&props.userPlace<4&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CupContainer,{place:props.userPlace},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Icons_Tournaments__["e" /* Cup */],{width:"16px",height:"21px"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Place,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UserPlace,null,"# ",props.userPlace)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"of")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllPlaces,null,props.participantsCount))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Participants,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PersonIcon,null),props.participant_count),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EndText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"The tournament is finished")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MoreLink,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Learn more"))):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,statusIsStartSoon?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnavailableText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Starts soon")):props.isLimited&&props.isLimitedForMoney||props.invited||props.subtype==="demo"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref16){var showModal=_ref16.showModal;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Account_Card_ButtonSwitcher__["a" /* default */],Object.assign({flat:true,active:props.active,isCompleted:props.isCompleted,isParticipating:isParticipating},props,{onActiveTradeClick:function onActiveTradeClick(){return props.onActivateTournament(props.id);},onTradeClick:function onTradeClick(){return props.onActivateTournament(props.id);},onJoinClick:function onJoinClick(){return showModal(__WEBPACK_IMPORTED_MODULE_14__Popups__["b" /* JoinPopup */],Object.assign({},props,{dontRedirect:true,fromTournamentsList:true}));},onLeaveClick:function onLeaveClick(){return showModal(__WEBPACK_IMPORTED_MODULE_14__Popups__["c" /* LeavePopup */],Object.assign({},props,{dontRedirect:true,fromTournamentsList:true}));}}));})):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(UnavailableText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Available by invitation only")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(MoreLink,{to:"/tournaments/"+props.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Learn more")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Sticker__["a" /* default */],{type:props.type,subtype:props.subtype,isNew:props.isNew,active:props.active,limited:props.isLimited}));};/* harmony default export */ __webpack_exports__["a"] = (TournamentCard);

/***/ }),
/* 1866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Tournament_TextPage__ = __webpack_require__(1867);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var locale=_ref.locale;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Tournament_TextPage__["a" /* default */],{locale:locale});});

/***/ }),
/* 1867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n\n  @media (max-width: 959px) {\n    width: 448px;\n  }\n\n  @media (max-width: 480px) {\n    width: 320px;\n  }\n\n  @media (max-width: 359px) {\n    width: 288px;\n  }\n"],["\n  width: 100%;\n  max-width: 960px;\n  margin: 0 auto;\n\n  @media (max-width: 959px) {\n    width: 448px;\n  }\n\n  @media (max-width: 480px) {\n    width: 320px;\n  }\n\n  @media (max-width: 359px) {\n    width: 288px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-size: ",";\n  line-height: 1.2;\n  color: #717171;\n"],["\n  margin-top: 15px;\n  margin-bottom: 15px;\n  font-size: ",";\n  line-height: 1.2;\n  color: #717171;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: block;\n  width: 100%;\n  min-width: 100%;\n  margin-bottom: 15px;\n  background-color: transparent;\n  overflow: hidden;\n"],["\n  display: block;\n  width: 100%;\n  min-width: 100%;\n  margin-bottom: 15px;\n  background-color: transparent;\n  overflow: hidden;\n"]),_templateObject4=_taggedTemplateLiteral([""],[""]),_templateObject5=_taggedTemplateLiteral(["\n  direction: ",";\n  position: relative;\n  display: block;\n  margin-bottom: 20px;\n  text-align: ",";\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    ",";\n    top: 4px;\n    display: block;\n    width: 7px;\n    height: 7px;\n    background-color: ",";\n    border-radius: 50%;\n  }\n\n  @media (max-width: 980px) {\n    :before {\n      ",";\n    }\n  }\n\n  @media (min-width: 960px) and (max-width: 1020px) {\n    :before {\n      ","\n    }\n\n    > p:first-of-type {\n      ",";\n    }\n  }\n"],["\n  direction: ",";\n  position: relative;\n  display: block;\n  margin-bottom: 20px;\n  text-align: ",";\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    ",";\n    top: 4px;\n    display: block;\n    width: 7px;\n    height: 7px;\n    background-color: ",";\n    border-radius: 50%;\n  }\n\n  @media (max-width: 980px) {\n    :before {\n      ",";\n    }\n  }\n\n  @media (min-width: 960px) and (max-width: 1020px) {\n    :before {\n      ","\n    }\n\n    > p:first-of-type {\n      ",";\n    }\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject2,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?"20px":"16px";});var Image=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].img(_templateObject3);var List=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].ul(_templateObject4);var Item=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].li(_templateObject5,function(props){return props.theme.direction;},function(_ref2){var theme=_ref2.theme;return theme.direction==="rtl"?"right":"left";},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("left","-17px"),function(_ref3){var theme=_ref3.theme;return theme.accent;},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("left","-14px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("left","2px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("margin-left","20px"));var TextPage=function TextPage(props){var locale=props.locale;// хардкод локалей, для которых есть папки с картинками
var imgLocales=["ar","en","hi","id","ph","vn","th","es"];var images=function images(isMobile){if(isMobile){return imgLocales.includes(locale)?""+"/images/about-tournaments/"+"irontrade"+"/"+locale+"/mobile":""+"/images/about-tournaments/"+"irontrade"+"/en/mobile";}return imgLocales.includes(locale)?""+"/images/about-tournaments/"+"irontrade"+"/"+locale:""+"/images/about-tournaments/"+"irontrade"+"/en";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 959px)"},function(isMobile){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(List,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"A tournament is a traders' competition where you use a special tournament account. Each tournament has its own goals that you can achieve and get prizes. A user may participate in several tournaments simultaneously."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"A tournament account is an account, which becomes accessible after the beginning of a tournament in case you've registered in it.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"You perform deals using a virtual currency named ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Money__["a" /* CurrencySymbol */],{currency:__WEBPACK_IMPORTED_MODULE_4__Icons_Kuchka__["b" /* tournamentCurrency */]})," while participating in a tournament. It is not directly associated with real funds. In tournaments, you may only spend real funds for a participation fee or for buying extra tournament coins. You may switch to your tournament account on a page with the list of your accounts on the platform.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/1.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"You should press the \"Register\" button on a page with the list of tournaments or any other page in order to sign up for a tournament. Also, you should possess the sufficient amount of money on your real account to cover a participation fee.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/2.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/3.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/4.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/5.png"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Refilling is a process of increasing your tournament account balance via purchasing extra tournament coins. Refilling is only possible if the amount of money on a tournament balance and the amount of money in opened deals is no more than the amount mentioned in the tournament rules.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/6.png"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Item,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"A prize fund of each tournament is formed beforehand. It may be fixed or depend on the amount spent by users to the tournament. The rules of each tournament are mentioned on its page. Moreover, each tournament has a guaranteed minimum prize fund, which indicates the minimum amount to be shared among the winners.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/7.png"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Image,{src:images(isMobile)+"/8.png"})));}));};/* harmony default export */ __webpack_exports__["a"] = (TextPage);

/***/ }),
/* 1868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Account__ = __webpack_require__(1869);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Account__["a" /* default */]);

/***/ }),
/* 1869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccountType_Account__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Tournaments__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Timer__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Tournament_RatingExpander__ = __webpack_require__(715);
var _templateObject=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    width: 22px;\n  }\n"],["\n  @media (max-width: 959px) {\n    width: 22px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  flex-basis: auto;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  cursor: pointer;\n"],["\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-end;\n  cursor: pointer;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"],["\n  min-width: 0;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-direction: column;\n  align-self: stretch;\n  margin-right: 7px;\n  padding-right: 7px;\n  border-right: 1px solid #463e54;\n\n  @media (min-width: 960px) {\n    margin-right: 17px;\n    padding-right: 17px;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  flex-direction: column;\n  align-self: stretch;\n  margin-right: 7px;\n  padding-right: 7px;\n  border-right: 1px solid #463e54;\n\n  @media (min-width: 960px) {\n    margin-right: 17px;\n    padding-right: 17px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  font-size: 10px;\n  line-height: 1.1;\n  color: #fff;\n\n  @media (min-width: 960px) {\n    margin-top: 0.3em;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  align-items: center;\n  font-size: 10px;\n  line-height: 1.1;\n  color: #fff;\n\n  @media (min-width: 960px) {\n    margin-top: 0.3em;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  margin-top: 0.2em;\n  color: ",";\n\n  @media (min-width: 960px) {\n    margin-top: 0.5em;\n  }\n"],["\n  margin-top: 0.2em;\n  color: ",";\n\n  @media (min-width: 960px) {\n    margin-top: 0.5em;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import moment from "moment";
var CupIcon=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_7__Icons_Tournaments__["d" /* ColorfulCup */])(_templateObject);var Flex=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject2);var Container=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject3);var AccountContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject4);var CupContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject5);var Text=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject6,function(_ref){var theme=_ref.theme;return theme.direction;});var TournamentText=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Text)(_templateObject7,function(_ref2){var theme=_ref2.theme;return theme.accent;});function TournamentAccount(props){// const tournament_id = "0000";
// const tournament_end = moment()
//   .add({ days: 7, hours: 3, minutes: 24 })
//   .fromNow();
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Api__["a" /* ActiveTournament */],null,function(active_tournament){var tournament=__WEBPACK_IMPORTED_MODULE_2_idx___default()(active_tournament,function(t){return t.value;});if(tournament==null){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CupContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentText,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Choose tournament"))));}var timer=Object(__WEBPACK_IMPORTED_MODULE_9__Timer__["b" /* compactTimer */])(Object.assign({},tournament,{time:props.time}));var account=__WEBPACK_IMPORTED_MODULE_2_idx___default()(tournament,function(t){return t.account;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Tournament_RatingExpander__["b" /* default */].Consumer,null,function(expander){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(min-width: 960px)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CupContainer,{onClick:function onClick(){return expander.switchExpanded(true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CupIcon,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TournamentText,null,"# ",tournament.current_place))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AccountContainer,{onClick:function onClick(){return expander.switchExpanded(false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__AccountType_Account__["a" /* Account */],Object.assign({},props,{activeAccount:{type:"tournament",id:account?account.id:0,isActive:true,balance:account?account.balance:"0.00"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,tournament.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Icons__["b" /* TimerIcon */],null)," ",timer))));});});}var mapStateToProps=function mapStateToProps(state){return{time:state.time||Date.now()};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps)(TournamentAccount));

/***/ }),
/* 1870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Percent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function Percent(_ref){var _ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,_ref$width=_ref.width,width=_ref$width===undefined?"12px":_ref$width,props=_objectWithoutProperties(_ref,["fill","width"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 12.119 10.243",width:width,fill:fill,fillRule:"evenodd"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8.561,10.041a2.569,2.569,0,1,1,1,.2A2.552,2.552,0,0,1,8.561,10.041ZM8.468,7.682a1.09,1.09,0,1,0,1.09-1.09A1.091,1.091,0,0,0,8.468,7.682Zm-5.9-.1L8.515,1.625l1.04,1.04L3.6,8.617Zm-1-2.657a2.569,2.569,0,1,1,1,.2A2.552,2.552,0,0,1,1.564,4.92ZM1.47,2.561a1.09,1.09,0,1,0,1.09-1.09A1.091,1.091,0,0,0,1.47,2.561Z",transform:"translate(0)"}));}

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(279));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0V0z"
}), _react.default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
})), 'MenuOutlined');

exports.default = _default;

/***/ }),
/* 1872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_fetch__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NextGenChartMath__ = __webpack_require__(110);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var fetchSection=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(section,profile){var interval,symbol,_Helpers$getSectionBo,_Helpers$getSectionBo2,start,end,response,text,lines,data,_iteratorNormalCompletion,_didIteratorError,_iteratorError,_iterator,_step,line,_line$split,_line$split2,epoch,open,close,min,max;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:if(!(section.interval===1000)){_context.next=2;break;}return _context.abrupt("return",{section:section,data:"darkness"});case 2:interval=section.interval/1000;symbol=section.stock;_Helpers$getSectionBo=__WEBPACK_IMPORTED_MODULE_4__NextGenChartMath__["i" /* getSectionBoundaries */](section).map(function(b){return b/1000;}),_Helpers$getSectionBo2=_slicedToArray(_Helpers$getSectionBo,2),start=_Helpers$getSectionBo2[0],end=_Helpers$getSectionBo2[1];_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_2__common_fetch__["c" /* apiCall */])("/api/stocks/history/csv?symbol="+symbol+"&interval="+interval+"&start="+start+"&end="+end+"&user_id="+profile.id);case 7:response=_context.sent;if(!(response.status!==200)){_context.next=12;break;}if(!(response.status===403)){_context.next=11;break;}return _context.abrupt("return",{section:section,data:"darkness"});case 11:throw new TypeError("Failed to load the history for "+symbol+" from "+new Date(start*1000).toString()+" to "+new Date(end*1000).toString()+" due to HTTP status code mismatch ("+response.status+")");case 12:_context.next=14;return response.text();case 14:text=_context.sent;lines=text.split("\n");data=[];_iteratorNormalCompletion=true;_didIteratorError=false;_iteratorError=undefined;_context.prev=20;for(_iterator=lines[Symbol.iterator]();!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){line=_step.value;if(line.length>0){_line$split=line.split(","),_line$split2=_slicedToArray(_line$split,5),epoch=_line$split2[0],open=_line$split2[1],close=_line$split2[2],min=_line$split2[3],max=_line$split2[4];data.push({epoch:parseInt(epoch,10),open:parseFloat(open),close:parseFloat(close),min:parseFloat(min),max:parseFloat(max)});}}_context.next=28;break;case 24:_context.prev=24;_context.t0=_context["catch"](20);_didIteratorError=true;_iteratorError=_context.t0;case 28:_context.prev=28;_context.prev=29;if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}case 31:_context.prev=31;if(!_didIteratorError){_context.next=34;break;}throw _iteratorError;case 34:return _context.finish(31);case 35:return _context.finish(28);case 36:if(!(data.length===0)){_context.next=38;break;}return _context.abrupt("return",{section:section,data:"void"});case 38:return _context.abrupt("return",{section:section,data:data});case 39:case"end":return _context.stop();}}},_callee,this,[[20,24,28,36],[29,,31,35]]);}));return function fetchSection(_x,_x2){return _ref.apply(this,arguments);};}();// Компонент, который загружает данные для
// секции. В зависимости от типа (прошлое,
// настоящее или будущее) может по-разному
// относиться к кешированию и обновлению.
var SectionData=function(_React$Component){_inherits(SectionData,_React$Component);function SectionData(){var _ref2,_this2=this;var _temp,_this,_ret;_classCallCheck(this,SectionData);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=SectionData.__proto__||Object.getPrototypeOf(SectionData)).call.apply(_ref2,[this].concat(args))),_this),_this.timer=null,_this.fetch=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var data;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:data=null;_context2.prev=1;_context2.next=4;return _this.props.fetchSection(_this.props.section,_this.props.profile);case 4:data=_context2.sent;_context2.next=10;break;case 7:_context2.prev=7;_context2.t0=_context2["catch"](1);// Если data == null, значит произошла ошибка в запросе.
// Я не сунул onData() в try-catch, потому что этим мы бы
// поймали ошибки, которые ловить не стоит.
if(false){console.error(_context2.t0);}case 10:if(data!=null){_this.props.onData(data);}case 11:case"end":return _context2.stop();}}},_callee2,_this2,[[1,7]]);})),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SectionData,[{key:"componentDidMount",value:function componentDidMount(){// Появление компонента вызывает запрос.
// Чтобы не делать миллион запросов при
// зуме/перемещении по истории, запрос
// происходит по будильнику, который мы
// отменим, если данные больше не нужны.
var _props=this.props,type=_props.type,cache=_props.cache;if(type==="present"||type==="past"&&cache==null){this.timer=setTimeout(this.fetch,200);}}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(prevProps.type==="present"&&this.props.type==="past"){if(this.timer!=null){clearTimeout(this.timer);this.timer=null;}this.fetch();}}},{key:"componentWillUnmount",value:function componentWillUnmount(){if(this.timer!=null){clearTimeout(this.timer);}}},{key:"render",value:function render(){return null;}}]);return SectionData;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SectionData);

/***/ }),
/* 1873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export point */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ordinal__ = __webpack_require__(733);



function band() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_1__ordinal__["a" /* default */])().unknown(undefined),
      domain = scale.domain,
      ordinalRange = scale.range,
      range = [0, 1],
      step,
      bandwidth,
      round = false,
      paddingInner = 0,
      paddingOuter = 0,
      align = 0.5;

  delete scale.unknown;

  function rescale() {
    var n = domain().length,
        reverse = range[1] < range[0],
        start = range[reverse - 0],
        stop = range[1 - reverse];
    step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
    if (round) step = Math.floor(step);
    start += (stop - start - step * (n - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["e" /* range */])(n).map(function(i) { return start + step * i; });
    return ordinalRange(reverse ? values.reverse() : values);
  }

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.range = function(_) {
    return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
  };

  scale.rangeRound = function(_) {
    return range = [+_[0], +_[1]], round = true, rescale();
  };

  scale.bandwidth = function() {
    return bandwidth;
  };

  scale.step = function() {
    return step;
  };

  scale.round = function(_) {
    return arguments.length ? (round = !!_, rescale()) : round;
  };

  scale.padding = function(_) {
    return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingInner = function(_) {
    return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
  };

  scale.paddingOuter = function(_) {
    return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
  };

  scale.align = function(_) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
  };

  scale.copy = function() {
    return band()
        .domain(domain())
        .range(range)
        .round(round)
        .paddingInner(paddingInner)
        .paddingOuter(paddingOuter)
        .align(align);
  };

  return rescale();
}

function pointish(scale) {
  var copy = scale.copy;

  scale.padding = scale.paddingOuter;
  delete scale.paddingInner;
  delete scale.paddingOuter;

  scale.copy = function() {
    return pointish(copy());
  };

  return scale;
}

function point() {
  return pointish(band().paddingInner(1));
}


/***/ }),
/* 1874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pairs__ = __webpack_require__(723);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values0, values1, reduce) {
  var n0 = values0.length,
      n1 = values1.length,
      values = new Array(n0 * n1),
      i0,
      i1,
      i,
      value0;

  if (reduce == null) reduce = __WEBPACK_IMPORTED_MODULE_0__pairs__["a" /* pair */];

  for (i0 = i = 0; i0 < n0; ++i0) {
    for (value0 = values0[i0], i1 = 0; i1 < n1; ++i1, ++i) {
      values[i] = reduce(value0, values1[i1]);
    }
  }

  return values;
});


/***/ }),
/* 1875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bisect__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(1877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__extent__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__identity__ = __webpack_require__(1878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__range__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ticks__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__ = __webpack_require__(730);









/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_4__identity__["a" /* default */],
      domain = __WEBPACK_IMPORTED_MODULE_3__extent__["a" /* default */],
      threshold = __WEBPACK_IMPORTED_MODULE_7__threshold_sturges__["a" /* default */];

  function histogram(data) {
    var i,
        n = data.length,
        x,
        values = new Array(n);

    for (i = 0; i < n; ++i) {
      values[i] = value(data[i], i, data);
    }

    var xz = domain(values),
        x0 = xz[0],
        x1 = xz[1],
        tz = threshold(values, x0, x1);

    // Convert number of thresholds into uniform thresholds.
    if (!Array.isArray(tz)) {
      tz = Object(__WEBPACK_IMPORTED_MODULE_6__ticks__["c" /* tickStep */])(x0, x1, tz);
      tz = Object(__WEBPACK_IMPORTED_MODULE_5__range__["a" /* default */])(Math.ceil(x0 / tz) * tz, x1, tz); // exclusive
    }

    // Remove any thresholds outside the domain.
    var m = tz.length;
    while (tz[0] <= x0) tz.shift(), --m;
    while (tz[m - 1] > x1) tz.pop(), --m;

    var bins = new Array(m + 1),
        bin;

    // Initialize bins.
    for (i = 0; i <= m; ++i) {
      bin = bins[i] = [];
      bin.x0 = i > 0 ? tz[i - 1] : x0;
      bin.x1 = i < m ? tz[i] : x1;
    }

    // Assign data to bins by value, ignoring any outside the domain.
    for (i = 0; i < n; ++i) {
      x = values[i];
      if (x0 <= x && x <= x1) {
        bins[Object(__WEBPACK_IMPORTED_MODULE_1__bisect__["a" /* default */])(tz, x, 0, m)].push(data[i]);
      }
    }

    return bins;
  }

  histogram.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : value;
  };

  histogram.domain = function(_) {
    return arguments.length ? (domain = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])([_[0], _[1]]), histogram) : domain;
  };

  histogram.thresholds = function(_) {
    return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["b" /* slice */].call(_)) : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(_), histogram) : threshold;
  };

  return histogram;
});


/***/ }),
/* 1877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return function() {
    return x;
  };
});


/***/ }),
/* 1878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quantile__ = __webpack_require__(445);





/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  values = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(values, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]).sort(__WEBPACK_IMPORTED_MODULE_1__ascending__["a" /* default */]);
  return Math.ceil((max - min) / (2 * (Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.75) - Object(__WEBPACK_IMPORTED_MODULE_3__quantile__["a" /* default */])(values, 0.25)) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deviation__ = __webpack_require__(724);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, min, max) {
  return Math.ceil((max - min) / (3.5 * Object(__WEBPACK_IMPORTED_MODULE_0__deviation__["a" /* default */])(values) * Math.pow(values.length, -1 / 3)));
});


/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      max;

  if (valueof == null) {
    while (++i < n) { // Find the first comparable value.
      if ((value = values[i]) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = values[i]) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  else {
    while (++i < n) { // Find the first comparable value.
      if ((value = valueof(values[i], i, values)) != null && value >= value) {
        max = value;
        while (++i < n) { // Compare the remaining values.
          if ((value = valueof(values[i], i, values)) != null && value > max) {
            max = value;
          }
        }
      }
    }
  }

  return max;
});


/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(210);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      m = n,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(values[i]))) sum += value;
      else --m;
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(valueof(values[i], i, values)))) sum += value;
      else --m;
    }
  }

  if (m) return sum / m;
});


/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__number__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quantile__ = __webpack_require__(445);




/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      numbers = [];

  if (valueof == null) {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(values[i]))) {
        numbers.push(value);
      }
    }
  }

  else {
    while (++i < n) {
      if (!isNaN(value = Object(__WEBPACK_IMPORTED_MODULE_1__number__["a" /* default */])(valueof(values[i], i, values)))) {
        numbers.push(value);
      }
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__quantile__["a" /* default */])(numbers.sort(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */]), 0.5);
});


/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(arrays) {
  var n = arrays.length,
      m,
      i = -1,
      j = 0,
      merged,
      array;

  while (++i < n) j += arrays[i].length;
  merged = new Array(j);

  while (--n >= 0) {
    array = arrays[n];
    m = array.length;
    while (--m >= 0) {
      merged[--j] = array[m];
    }
  }

  return merged;
});


/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, indexes) {
  var i = indexes.length, permutes = new Array(i);
  while (i--) permutes[i] = array[indexes[i]];
  return permutes;
});


/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(168);


/* unused harmony default export */ var _unused_webpack_default_export = (function(values, compare) {
  if (!(n = values.length)) return;
  var n,
      i = 0,
      j = 0,
      xi,
      xj = values[j];

  if (compare == null) compare = __WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */];

  while (++i < n) {
    if (compare(xi = values[i], xj) < 0 || compare(xj, xj) !== 0) {
      xj = xi, j = i;
    }
  }

  if (compare(xj, xj) === 0) return j;
});


/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(array, i0, i1) {
  var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
      t,
      i;

  while (m) {
    i = Math.random() * m-- | 0;
    t = array[m + i0];
    array[m + i0] = array[i + i0];
    array[i + i0] = t;
  }

  return array;
});


/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(values, valueof) {
  var n = values.length,
      i = -1,
      value,
      sum = 0;

  if (valueof == null) {
    while (++i < n) {
      if (value = +values[i]) sum += value; // Note: zero and null are equivalent.
    }
  }

  else {
    while (++i < n) {
      if (value = +valueof(values[i], i, values)) sum += value;
    }
  }

  return sum;
});


/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__transpose__ = __webpack_require__(732);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__transpose__["a" /* default */])(arguments);
});


/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nest__ = __webpack_require__(1891);
/* unused harmony reexport nest */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__set__ = __webpack_require__(1892);
/* unused harmony reexport set */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__map__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__map__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__keys__ = __webpack_require__(1893);
/* unused harmony reexport keys */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values__ = __webpack_require__(1894);
/* unused harmony reexport values */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__entries__ = __webpack_require__(1895);
/* unused harmony reexport entries */








/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(446);


/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = [],
      sortKeys = [],
      sortValues,
      rollup,
      nest;

  function apply(array, depth, createResult, setResult) {
    if (depth >= keys.length) {
      if (sortValues != null) array.sort(sortValues);
      return rollup != null ? rollup(array) : array;
    }

    var i = -1,
        n = array.length,
        key = keys[depth++],
        keyValue,
        value,
        valuesByKey = Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])(),
        values,
        result = createResult();

    while (++i < n) {
      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
        values.push(value);
      } else {
        valuesByKey.set(keyValue, [value]);
      }
    }

    valuesByKey.each(function(values, key) {
      setResult(result, key, apply(values, depth, createResult, setResult));
    });

    return result;
  }

  function entries(map, depth) {
    if (++depth > keys.length) return map;
    var array, sortKey = sortKeys[depth - 1];
    if (rollup != null && depth >= keys.length) array = map.entries();
    else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
  }

  return nest = {
    object: function(array) { return apply(array, 0, createObject, setObject); },
    map: function(array) { return apply(array, 0, createMap, setMap); },
    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
    key: function(d) { keys.push(d); return nest; },
    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
    sortValues: function(order) { sortValues = order; return nest; },
    rollup: function(f) { rollup = f; return nest; }
  };
});

function createObject() {
  return {};
}

function setObject(object, key, value) {
  object[key] = value;
}

function createMap() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */])();
}

function setMap(map, key, value) {
  map.set(key, value);
}


/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__map__ = __webpack_require__(446);


function Set() {}

var proto = __WEBPACK_IMPORTED_MODULE_0__map__["a" /* default */].prototype;

Set.prototype = set.prototype = {
  constructor: Set,
  has: proto.has,
  add: function(value) {
    value += "";
    this[__WEBPACK_IMPORTED_MODULE_0__map__["b" /* prefix */] + value] = value;
    return this;
  },
  remove: proto.remove,
  clear: proto.clear,
  values: proto.keys,
  size: proto.size,
  empty: proto.empty,
  each: proto.each
};

function set(object, f) {
  var set = new Set;

  // Copy constructor.
  if (object instanceof Set) object.each(function(value) { set.add(value); });

  // Otherwise, assume it’s an array.
  else if (object) {
    var i = -1, n = object.length;
    if (f == null) while (++i < n) set.add(object[i]);
    else while (++i < n) set.add(f(object[i], i, object));
  }

  return set;
}

/* unused harmony default export */ var _unused_webpack_default_export = (set);


/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
});


/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var values = [];
  for (var key in map) values.push(map[key]);
  return values;
});


/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(map) {
  var entries = [];
  for (var key in map) entries.push({key: key, value: map[key]});
  return entries;
});


/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__number__ = __webpack_require__(742);




function identity() {
  var domain = [0, 1];

  function scale(x) {
    return +x;
  }

  scale.invert = scale;

  scale.domain = scale.range = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_0__array__["a" /* map */].call(_, __WEBPACK_IMPORTED_MODULE_2__number__["a" /* default */]), scale) : domain.slice();
  };

  scale.copy = function() {
    return identity().domain(domain);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export gray */
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* unused harmony export Lab */
/* unused harmony export lch */
/* harmony export (immutable) */ __webpack_exports__["b"] = hcl;
/* unused harmony export Hcl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(734);




// https://beta.observablehq.com/@mbostock/lab-and-rgb
var K = 18,
    Xn = 0.96422,
    Yn = 1,
    Zn = 0.82521,
    t0 = 4 / 29,
    t1 = 6 / 29,
    t2 = 3 * t1 * t1,
    t3 = t1 * t1 * t1;

function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */];
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
  }
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = rgb2lrgb(o.r),
      g = rgb2lrgb(o.g),
      b = rgb2lrgb(o.b),
      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
  if (r === g && g === b) x = z = y; else {
    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
  }
  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}

function gray(l, opacity) {
  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}

function lab(l, a, b, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}

function Lab(l, a, b, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Lab, lab, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  darker: function(k) {
    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
  },
  rgb: function() {
    var y = (this.l + 16) / 116,
        x = isNaN(this.a) ? y : y + this.a / 500,
        z = isNaN(this.b) ? y : y - this.b / 200;
    x = Xn * lab2xyz(x);
    y = Yn * lab2xyz(y);
    z = Zn * lab2xyz(z);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
      this.opacity
    );
  }
}));

function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}

function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}

function lrgb2rgb(x) {
  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}

function rgb2lrgb(x) {
  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}

function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0, o.l, o.opacity);
  var h = Math.atan2(o.b, o.a) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */];
  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}

function lch(l, c, h, opacity) {
  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function hcl(h, c, l, opacity) {
  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}

function Hcl(h, c, l, opacity) {
  this.h = +h;
  this.c = +c;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Hcl, hcl, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
  },
  darker: function(k) {
    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
  },
  rgb: function() {
    return labConvert(this).rgb();
  }
}));


/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cubehelix;
/* unused harmony export Cubehelix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__define__ = __webpack_require__(449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(734);




var A = -0.14861,
    B = +1.78277,
    C = -0.29227,
    D = -0.90649,
    E = +1.97294,
    ED = E * D,
    EB = E * B,
    BC_DA = B * C - D * A;

function cubehelixConvert(o) {
  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */])) o = Object(__WEBPACK_IMPORTED_MODULE_1__color__["h" /* rgbConvert */])(o);
  var r = o.r / 255,
      g = o.g / 255,
      b = o.b / 255,
      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
      bl = b - l,
      k = (E * (g - l) - C * bl) / D,
      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
      h = s ? Math.atan2(k, bl) * __WEBPACK_IMPORTED_MODULE_2__math__["b" /* rad2deg */] - 120 : NaN;
  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}

function cubehelix(h, s, l, opacity) {
  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}

function Cubehelix(h, s, l, opacity) {
  this.h = +h;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}

Object(__WEBPACK_IMPORTED_MODULE_0__define__["a" /* default */])(Cubehelix, cubehelix, Object(__WEBPACK_IMPORTED_MODULE_0__define__["b" /* extend */])(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* Color */], {
  brighter: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* brighter */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  darker: function(k) {
    k = k == null ? __WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */] : Math.pow(__WEBPACK_IMPORTED_MODULE_1__color__["d" /* darker */], k);
    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
  },
  rgb: function() {
    var h = isNaN(this.h) ? 0 : (this.h + 120) * __WEBPACK_IMPORTED_MODULE_2__math__["a" /* deg2rad */],
        l = +this.l,
        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
        cosh = Math.cos(h),
        sinh = Math.sin(h);
    return new __WEBPACK_IMPORTED_MODULE_1__color__["b" /* Rgb */](
      255 * (l + a * (A * cosh + B * sinh)),
      255 * (l + a * (C * cosh + D * sinh)),
      255 * (l + a * (E * cosh)),
      this.opacity
    );
  }
}));


/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
});


/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__color__ = __webpack_require__(169);


/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_0__color__["c" /* hue */])(+a, +b);
  return function(t) {
    var x = i(t);
    return x - 360 * Math.floor(x / 360);
  };
});


/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return a = +a, b -= a, function(t) {
    return Math.round(a + b * t);
  };
});


/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return interpolateTransformCss; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interpolateTransformSvg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__number__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse__ = __webpack_require__(1903);



function interpolateTransform(parse, pxComma, pxParen, degParen) {

  function pop(s) {
    return s.length ? s.pop() + " " : "";
  }

  function translate(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push("translate(", null, pxComma, null, pxParen);
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb || yb) {
      s.push("translate(" + xb + pxComma + yb + pxParen);
    }
  }

  function rotate(a, b, s, q) {
    if (a !== b) {
      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "rotate(" + b + degParen);
    }
  }

  function skewX(a, b, s, q) {
    if (a !== b) {
      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(a, b)});
    } else if (b) {
      s.push(pop(s) + "skewX(" + b + degParen);
    }
  }

  function scale(xa, ya, xb, yb, s, q) {
    if (xa !== xb || ya !== yb) {
      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
      q.push({i: i - 4, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(xa, xb)}, {i: i - 2, x: Object(__WEBPACK_IMPORTED_MODULE_0__number__["a" /* default */])(ya, yb)});
    } else if (xb !== 1 || yb !== 1) {
      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
  }

  return function(a, b) {
    var s = [], // string constants and placeholders
        q = []; // number interpolators
    a = parse(a), b = parse(b);
    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
    rotate(a.rotate, b.rotate, s, q);
    skewX(a.skewX, b.skewX, s, q);
    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
    a = b = null; // gc
    return function(t) {
      var i = -1, n = q.length, o;
      while (++i < n) s[(o = q[i]).i] = o.x(t);
      return s.join("");
    };
  };
}

var interpolateTransformCss = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["a" /* parseCss */], "px, ", "px)", "deg)");
var interpolateTransformSvg = interpolateTransform(__WEBPACK_IMPORTED_MODULE_1__parse__["b" /* parseSvg */], ", ", ")", ")");


/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCss;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__decompose__ = __webpack_require__(1904);


var cssNode,
    cssRoot,
    cssView,
    svgNode;

function parseCss(value) {
  if (value === "none") return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
  cssNode.style.transform = value;
  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
  cssRoot.removeChild(cssNode);
  value = value.slice(7, -1).split(",");
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
}

function parseSvg(value) {
  if (value == null) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
  svgNode.setAttribute("transform", value);
  if (!(value = svgNode.transform.baseVal.consolidate())) return __WEBPACK_IMPORTED_MODULE_0__decompose__["b" /* identity */];
  value = value.matrix;
  return Object(__WEBPACK_IMPORTED_MODULE_0__decompose__["a" /* default */])(value.a, value.b, value.c, value.d, value.e, value.f);
}


/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return identity; });
var degrees = 180 / Math.PI;

var identity = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};

/* harmony default export */ __webpack_exports__["a"] = (function(a, b, c, d, e, f) {
  var scaleX, scaleY, skewX;
  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
  return {
    translateX: e,
    translateY: f,
    rotate: Math.atan2(b, a) * degrees,
    skewX: Math.atan(skewX) * degrees,
    scaleX: scaleX,
    scaleY: scaleY
  };
});


/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var rho = Math.SQRT2,
    rho2 = 2,
    rho4 = 4,
    epsilon2 = 1e-12;

function cosh(x) {
  return ((x = Math.exp(x)) + 1 / x) / 2;
}

function sinh(x) {
  return ((x = Math.exp(x)) - 1 / x) / 2;
}

function tanh(x) {
  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}

// p0 = [ux0, uy0, w0]
// p1 = [ux1, uy1, w1]
/* harmony default export */ __webpack_exports__["a"] = (function(p0, p1) {
  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
      dx = ux1 - ux0,
      dy = uy1 - uy0,
      d2 = dx * dx + dy * dy,
      i,
      S;

  // Special case for u0 ≅ u1.
  if (d2 < epsilon2) {
    S = Math.log(w1 / w0) / rho;
    i = function(t) {
      return [
        ux0 + t * dx,
        uy0 + t * dy,
        w0 * Math.exp(rho * t * S)
      ];
    }
  }

  // General case.
  else {
    var d1 = Math.sqrt(d2),
        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
    S = (r1 - r0) / rho;
    i = function(t) {
      var s = t * S,
          coshr0 = cosh(r0),
          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
      return [
        ux0 + u * dx,
        uy0 + u * dy,
        w0 * coshr0 / cosh(rho * s + r0)
      ];
    }
  }

  i.duration = S * 1000;

  return i;
});


/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hslLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(169);



function hsl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["d" /* hsl */])(end)).h),
        s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.s = s(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hsl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hslLong = hsl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lab;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(169);



function lab(start, end) {
  var l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(start)).l, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["e" /* lab */])(end)).l),
      a = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.a, end.a),
      b = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.b, end.b),
      opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
  return function(t) {
    start.l = l(t);
    start.a = a(t);
    start.b = b(t);
    start.opacity = opacity(t);
    return start + "";
  };
}


/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return hclLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(169);



function hcl(hue) {
  return function(start, end) {
    var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["c" /* hcl */])(end)).h),
        c = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.c, end.c),
        l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
        opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
    return function(t) {
      start.h = h(t);
      start.c = c(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
}

/* harmony default export */ __webpack_exports__["a"] = (hcl(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var hclLong = hcl(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return cubehelixLong; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__color__ = __webpack_require__(169);



function cubehelix(hue) {
  return (function cubehelixGamma(y) {
    y = +y;

    function cubehelix(start, end) {
      var h = hue((start = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(start)).h, (end = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(end)).h),
          s = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.s, end.s),
          l = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.l, end.l),
          opacity = Object(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */])(start.opacity, end.opacity);
      return function(t) {
        start.h = h(t);
        start.s = s(t);
        start.l = l(Math.pow(t, y));
        start.opacity = opacity(t);
        return start + "";
      };
    }

    cubehelix.gamma = cubehelixGamma;

    return cubehelix;
  })(1);
}

/* harmony default export */ __webpack_exports__["b"] = (cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["c" /* hue */]));
var cubehelixLong = cubehelix(__WEBPACK_IMPORTED_MODULE_1__color__["a" /* default */]);


/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = piecewise;
function piecewise(interpolate, values) {
  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
  while (i < n) I[i] = interpolate(v, v = values[++i]);
  return function(t) {
    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
    return I[i](t - i);
  };
}


/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(interpolator, n) {
  var samples = new Array(n);
  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
  return samples;
});


/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(743);



/* harmony default export */ __webpack_exports__["a"] = (function(domain, count, specifier) {
  var start = domain[0],
      stop = domain[domain.length - 1],
      step = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["g" /* tickStep */])(start, stop, count == null ? 10 : count),
      precision;
  specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["c" /* formatSpecifier */])(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["e" /* precisionPrefix */])(step, value))) specifier.precision = precision;
      return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["b" /* formatPrefix */])(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["f" /* precisionRound */])(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["d" /* precisionFixed */])(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
});


/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return format; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return formatPrefix; });
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__locale__ = __webpack_require__(744);


var locale;
var format;
var formatPrefix;

defaultLocale({
  decimal: ".",
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});

function defaultLocale(definition) {
  locale = Object(__WEBPACK_IMPORTED_MODULE_0__locale__["a" /* default */])(definition);
  format = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}


/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(grouping, thousands) {
  return function(value, width) {
    var i = value.length,
        t = [],
        j = 0,
        g = grouping[0],
        length = 0;

    while (i > 0 && g > 0) {
      if (length + g + 1 > width) g = Math.max(1, width - length);
      t.push(value.substring(i -= g, i + g));
      if ((length += g + 1) > width) break;
      g = grouping[j = (j + 1) % grouping.length];
    }

    return t.reverse().join(thousands);
  };
});


/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
});


/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
/* harmony default export */ __webpack_exports__["a"] = (function(s) {
  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
    switch (s[i]) {
      case ".": i0 = i1 = i; break;
      case "0": if (i0 === 0) i0 = i; i1 = i; break;
      default: if (i0 > 0) { if (!+s[i]) break out; i0 = 0; } break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
});


/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__formatRounded__ = __webpack_require__(1918);



/* harmony default export */ __webpack_exports__["a"] = ({
  "%": function(x, p) { return (x * 100).toFixed(p); },
  "b": function(x) { return Math.round(x).toString(2); },
  "c": function(x) { return x + ""; },
  "d": function(x) { return Math.round(x).toString(10); },
  "e": function(x, p) { return x.toExponential(p); },
  "f": function(x, p) { return x.toFixed(p); },
  "g": function(x, p) { return x.toPrecision(p); },
  "o": function(x) { return Math.round(x).toString(8); },
  "p": function(x, p) { return Object(__WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */])(x * 100, p); },
  "r": __WEBPACK_IMPORTED_MODULE_1__formatRounded__["a" /* default */],
  "s": __WEBPACK_IMPORTED_MODULE_0__formatPrefixAuto__["a" /* default */],
  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
  "x": function(x) { return Math.round(x).toString(16); }
});


/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__formatDecimal__ = __webpack_require__(452);


/* harmony default export */ __webpack_exports__["a"] = (function(x, p) {
  var d = Object(__WEBPACK_IMPORTED_MODULE_0__formatDecimal__["a" /* default */])(x, p);
  if (!d) return x + "";
  var coefficient = d[0],
      exponent = d[1];
  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
});


/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(x) {
  return x;
});


/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(289);


/* harmony default export */ __webpack_exports__["a"] = (function(step) {
  return Math.max(0, -Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(289);


/* harmony default export */ __webpack_exports__["a"] = (function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(value) / 3))) * 3 - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(Math.abs(step)));
});


/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__exponent__ = __webpack_require__(289);


/* harmony default export */ __webpack_exports__["a"] = (function(step, max) {
  step = Math.abs(step), max = Math.abs(max) - step;
  return Math.max(0, Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(max) - Object(__WEBPACK_IMPORTED_MODULE_0__exponent__["a" /* default */])(step)) + 1;
});


/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_format__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nice__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__continuous__ = __webpack_require__(288);






function deinterpolate(a, b) {
  return (b = Math.log(b / a))
      ? function(x) { return Math.log(x / a) / b; }
      : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(b);
}

function reinterpolate(a, b) {
  return a < 0
      ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
      : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
}

function pow10(x) {
  return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}

function powp(base) {
  return base === 10 ? pow10
      : base === Math.E ? Math.exp
      : function(x) { return Math.pow(base, x); };
}

function logp(base) {
  return base === Math.E ? Math.log
      : base === 10 && Math.log10
      || base === 2 && Math.log2
      || (base = Math.log(base), function(x) { return Math.log(x) / base; });
}

function reflect(f) {
  return function(x) {
    return -f(-x);
  };
}

function log() {
  var scale = Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["b" /* default */])(deinterpolate, reinterpolate).domain([1, 10]),
      domain = scale.domain,
      base = 10,
      logs = logp(10),
      pows = powp(10);

  function rescale() {
    logs = logp(base), pows = powp(base);
    if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
    return scale;
  }

  scale.base = function(_) {
    return arguments.length ? (base = +_, rescale()) : base;
  };

  scale.domain = function(_) {
    return arguments.length ? (domain(_), rescale()) : domain();
  };

  scale.ticks = function(count) {
    var d = domain(),
        u = d[0],
        v = d[d.length - 1],
        r;

    if (r = v < u) i = u, u = v, v = i;

    var i = logs(u),
        j = logs(v),
        p,
        k,
        t,
        n = count == null ? 10 : +count,
        z = [];

    if (!(base % 1) && j - i < n) {
      i = Math.round(i) - 1, j = Math.round(j) + 1;
      if (u > 0) for (; i < j; ++i) {
        for (k = 1, p = pows(i); k < base; ++k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      } else for (; i < j; ++i) {
        for (k = base - 1, p = pows(i); k >= 1; --k) {
          t = p * k;
          if (t < u) continue;
          if (t > v) break;
          z.push(t);
        }
      }
    } else {
      z = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["h" /* ticks */])(i, j, Math.min(j - i, n)).map(pows);
    }

    return r ? z.reverse() : z;
  };

  scale.tickFormat = function(count, specifier) {
    if (specifier == null) specifier = base === 10 ? ".0e" : ",";
    if (typeof specifier !== "function") specifier = Object(__WEBPACK_IMPORTED_MODULE_1_d3_format__["a" /* format */])(specifier);
    if (count === Infinity) return specifier;
    if (count == null) count = 10;
    var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
    return function(d) {
      var i = d / pows(Math.round(logs(d)));
      if (i * base < base - 0.5) i *= base;
      return i <= k ? specifier(d) : "";
    };
  };

  scale.nice = function() {
    return domain(Object(__WEBPACK_IMPORTED_MODULE_3__nice__["a" /* default */])(domain(), {
      floor: function(x) { return pows(Math.floor(logs(x))); },
      ceil: function(x) { return pows(Math.ceil(logs(x))); }
    }));
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_4__continuous__["a" /* copy */])(scale, log().base(base));
  };

  return scale;
}


/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export sqrt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__linear__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__continuous__ = __webpack_require__(288);




function raise(x, exponent) {
  return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
}

function pow() {
  var exponent = 1,
      scale = Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["b" /* default */])(deinterpolate, reinterpolate),
      domain = scale.domain;

  function deinterpolate(a, b) {
    return (b = raise(b, exponent) - (a = raise(a, exponent)))
        ? function(x) { return (raise(x, exponent) - a) / b; }
        : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(b);
  }

  function reinterpolate(a, b) {
    b = raise(b, exponent) - (a = raise(a, exponent));
    return function(t) { return raise(a + b * t, 1 / exponent); };
  }

  scale.exponent = function(_) {
    return arguments.length ? (exponent = +_, domain(domain())) : exponent;
  };

  scale.copy = function() {
    return Object(__WEBPACK_IMPORTED_MODULE_2__continuous__["a" /* copy */])(scale, pow().exponent(exponent));
  };

  return Object(__WEBPACK_IMPORTED_MODULE_1__linear__["b" /* linearish */])(scale);
}

function sqrt() {
  return pow().exponent(0.5);
}


/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(143);



function quantile() {
  var domain = [],
      range = [],
      thresholds = [];

  function rescale() {
    var i = 0, n = Math.max(1, range.length);
    thresholds = new Array(n - 1);
    while (++i < n) thresholds[i - 1] = Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["d" /* quantile */])(domain, i / n);
    return scale;
  }

  function scale(x) {
    if (!isNaN(x = +x)) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(thresholds, x)];
  }

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN] : [
      i > 0 ? thresholds[i - 1] : domain[0],
      i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
    ];
  };

  scale.domain = function(_) {
    if (!arguments.length) return domain.slice();
    domain = [];
    for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
    domain.sort(__WEBPACK_IMPORTED_MODULE_0_d3_array__["a" /* ascending */]);
    return rescale();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), rescale()) : range.slice();
  };

  scale.quantiles = function() {
    return thresholds.slice();
  };

  scale.copy = function() {
    return quantile()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__linear__ = __webpack_require__(211);




function quantize() {
  var x0 = 0,
      x1 = 1,
      n = 1,
      domain = [0.5],
      range = [0, 1];

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  function rescale() {
    var i = -1;
    domain = new Array(n);
    while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
    return scale;
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
  };

  scale.range = function(_) {
    return arguments.length ? (n = (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_)).length - 1, rescale()) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return i < 0 ? [NaN, NaN]
        : i < 1 ? [x0, domain[0]]
        : i >= n ? [domain[n - 1], x1]
        : [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return quantize()
        .domain([x0, x1])
        .range(range);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_2__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = threshold;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_array__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(143);



function threshold() {
  var domain = [0.5],
      range = [0, 1],
      n = 1;

  function scale(x) {
    if (x <= x) return range[Object(__WEBPACK_IMPORTED_MODULE_0_d3_array__["b" /* bisect */])(domain, x, 0, n)];
  }

  scale.domain = function(_) {
    return arguments.length ? (domain = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
  };

  scale.range = function(_) {
    return arguments.length ? (range = __WEBPACK_IMPORTED_MODULE_1__array__["b" /* slice */].call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
  };

  scale.invertExtent = function(y) {
    var i = range.indexOf(y);
    return [domain[i - 1], domain[i]];
  };

  scale.copy = function() {
    return threshold()
        .domain(domain)
        .range(range);
  };

  return scale;
}


/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export milliseconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);


var millisecond = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function() {
  // noop
}, function(date, step) {
  date.setTime(+date + step);
}, function(start, end) {
  return end - start;
});

// An optimized implementation for this simple case.
millisecond.every = function(k) {
  k = Math.floor(k);
  if (!isFinite(k) || !(k > 0)) return null;
  if (!(k > 1)) return millisecond;
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setTime(Math.floor(date / k) * k);
  }, function(date, step) {
    date.setTime(+date + step * k);
  }, function(start, end) {
    return (end - start) / k;
  });
};

/* harmony default export */ __webpack_exports__["a"] = (millisecond);
var milliseconds = millisecond.range;


/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export seconds */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var second = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["d" /* durationSecond */];
}, function(date) {
  return date.getUTCSeconds();
});

/* harmony default export */ __webpack_exports__["a"] = (second);
var seconds = second.range;


/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export minutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var minute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setTime(Math.floor(date / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (minute);
var minutes = minute.range;


/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var hour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  var offset = date.getTimezoneOffset() * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */] % __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  if (offset < 0) offset += __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
  date.setTime(Math.floor((+date - offset) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]) * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */] + offset);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getHours();
});

/* harmony default export */ __webpack_exports__["a"] = (hour);
var hours = hour.range;


/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export days */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var day = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setDate(date.getDate() + step);
}, function(start, end) {
  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (day);
var days = day.range;


/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return monday; });
/* unused harmony export tuesday */
/* unused harmony export wednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return thursday; });
/* unused harmony export friday */
/* unused harmony export saturday */
/* unused harmony export sundays */
/* unused harmony export mondays */
/* unused harmony export tuesdays */
/* unused harmony export wednesdays */
/* unused harmony export thursdays */
/* unused harmony export fridays */
/* unused harmony export saturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



function weekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setDate(date.getDate() + step * 7);
  }, function(start, end) {
    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var sunday = weekday(0);
var monday = weekday(1);
var tuesday = weekday(2);
var wednesday = weekday(3);
var thursday = weekday(4);
var friday = weekday(5);
var saturday = weekday(6);

var sundays = sunday.range;
var mondays = monday.range;
var tuesdays = tuesday.range;
var wednesdays = wednesday.range;
var thursdays = thursday.range;
var fridays = friday.range;
var saturdays = saturday.range;


/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export months */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);


var month = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setMonth(date.getMonth() + step);
}, function(start, end) {
  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
  return date.getMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (month);
var months = month.range;


/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export years */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);


var year = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setMonth(0, 1);
  date.setHours(0, 0, 0, 0);
}, function(date, step) {
  date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
  return end.getFullYear() - start.getFullYear();
}, function(date) {
  return date.getFullYear();
});

// An optimized implementation for this simple case.
year.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setFullYear(date.getFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (year);
var years = year.range;


/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMinutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var utcMinute = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCSeconds(0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["c" /* durationMinute */];
}, function(date) {
  return date.getUTCMinutes();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMinute);
var utcMinutes = utcMinute.range;


/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcHours */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var utcHour = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
  date.setTime(+date + step * __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */]);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["b" /* durationHour */];
}, function(date) {
  return date.getUTCHours();
});

/* harmony default export */ __webpack_exports__["a"] = (utcHour);
var utcHours = utcHour.range;


/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcDays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



var utcDay = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
  return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["a" /* durationDay */];
}, function(date) {
  return date.getUTCDate() - 1;
});

/* harmony default export */ __webpack_exports__["a"] = (utcDay);
var utcDays = utcDay.range;


/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return utcSunday; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return utcMonday; });
/* unused harmony export utcTuesday */
/* unused harmony export utcWednesday */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return utcThursday; });
/* unused harmony export utcFriday */
/* unused harmony export utcSaturday */
/* unused harmony export utcSundays */
/* unused harmony export utcMondays */
/* unused harmony export utcTuesdays */
/* unused harmony export utcWednesdays */
/* unused harmony export utcThursdays */
/* unused harmony export utcFridays */
/* unused harmony export utcSaturdays */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__duration__ = __webpack_require__(108);



function utcWeekday(i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step * 7);
  }, function(start, end) {
    return (end - start) / __WEBPACK_IMPORTED_MODULE_1__duration__["e" /* durationWeek */];
  });
}

var utcSunday = utcWeekday(0);
var utcMonday = utcWeekday(1);
var utcTuesday = utcWeekday(2);
var utcWednesday = utcWeekday(3);
var utcThursday = utcWeekday(4);
var utcFriday = utcWeekday(5);
var utcSaturday = utcWeekday(6);

var utcSundays = utcSunday.range;
var utcMondays = utcMonday.range;
var utcTuesdays = utcTuesday.range;
var utcWednesdays = utcWednesday.range;
var utcThursdays = utcThursday.range;
var utcFridays = utcFriday.range;
var utcSaturdays = utcSaturday.range;


/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcMonths */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);


var utcMonth = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCDate(1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
  return date.getUTCMonth();
});

/* harmony default export */ __webpack_exports__["a"] = (utcMonth);
var utcMonths = utcMonth.range;


/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export utcYears */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__interval__ = __webpack_require__(52);


var utcYear = Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
  date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
  return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
  return date.getUTCFullYear();
});

// An optimized implementation for this simple case.
utcYear.every = function(k) {
  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : Object(__WEBPACK_IMPORTED_MODULE_0__interval__["a" /* default */])(function(date) {
    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
  }, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step * k);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (utcYear);
var utcYears = utcYear.range;


/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isoFormat__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultLocale__ = __webpack_require__(454);



function parseIsoNative(string) {
  var date = new Date(string);
  return isNaN(date) ? null : date;
}

var parseIso = +new Date("2000-01-01T00:00:00.000Z")
    ? parseIsoNative
    : Object(__WEBPACK_IMPORTED_MODULE_1__defaultLocale__["c" /* utcParse */])(__WEBPACK_IMPORTED_MODULE_0__isoFormat__["a" /* isoSpecifier */]);

/* unused harmony default export */ var _unused_webpack_default_export = (parseIso);


/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__time__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_time_format__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_d3_time__ = __webpack_require__(212);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__time__["a" /* calendar */])(__WEBPACK_IMPORTED_MODULE_2_d3_time__["v" /* utcYear */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["q" /* utcMonth */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["u" /* utcWeek */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["l" /* utcDay */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["m" /* utcHour */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["o" /* utcMinute */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["r" /* utcSecond */], __WEBPACK_IMPORTED_MODULE_2_d3_time__["n" /* utcMillisecond */], __WEBPACK_IMPORTED_MODULE_1_d3_time_format__["b" /* utcFormat */]).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
});


/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(213);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf"));


/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(213);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6"));


/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(213);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9"));


/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(213);


/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5"));


/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(177);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(300, 0.5, 0.0), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-240, 0.5, 1.0)));


/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export warm */
/* unused harmony export cool */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_color__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_d3_interpolate__ = __webpack_require__(177);



var warm = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(-100, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var cool = Object(__WEBPACK_IMPORTED_MODULE_1_d3_interpolate__["interpolateCubehelixLong"])(Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(260, 0.75, 0.35), Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])(80, 1.50, 0.8));

var rainbow = Object(__WEBPACK_IMPORTED_MODULE_0_d3_color__["b" /* cubehelix */])();

/* unused harmony default export */ var _unused_webpack_default_export = (function(t) {
  if (t < 0 || t > 1) t -= Math.floor(t);
  var ts = Math.abs(t - 0.5);
  rainbow.h = 360 * t - 100;
  rainbow.s = 1.5 - 1.5 * ts;
  rainbow.l = 0.8 - 0.9 * ts;
  return rainbow + "";
});


/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export magma */
/* unused harmony export inferno */
/* unused harmony export plasma */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(213);


function ramp(range) {
  var n = range.length;
  return function(t) {
    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725")));

var magma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));

var inferno = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));

var plasma = ramp(Object(__WEBPACK_IMPORTED_MODULE_0__colors__["a" /* default */])("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));


/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__linear__ = __webpack_require__(211);


function sequential(interpolator) {
  var x0 = 0,
      x1 = 1,
      clamp = false;

  function scale(x) {
    var t = (x - x0) / (x1 - x0);
    return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
  }

  scale.domain = function(_) {
    return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
  };

  scale.clamp = function(_) {
    return arguments.length ? (clamp = !!_, scale) : clamp;
  };

  scale.interpolator = function(_) {
    return arguments.length ? (interpolator = _, scale) : interpolator;
  };

  scale.copy = function() {
    return sequential(interpolator).domain([x0, x1]).clamp(clamp);
  };

  return Object(__WEBPACK_IMPORTED_MODULE_0__linear__["b" /* linearish */])(scale);
}


/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = discountinuousScale;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_binary_search__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_binary_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_binary_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NextGenChartTypes__ = __webpack_require__(45);
function discountinuousScale(checkpoints){function scale(value){if(checkpoints.length===0){return value;}var bisectedIndex=__WEBPACK_IMPORTED_MODULE_0_binary_search___default()(checkpoints,value,function(checkpoint,value){return checkpoint.value-value;});if(bisectedIndex>-1){var _checkpoint=checkpoints[bisectedIndex];return _checkpoint.offset;}var index=-bisectedIndex-1;if(index===0){return value;}var checkpoint=checkpoints[index-1];if(checkpoint.type==="positive"){return checkpoint.offset+(value-checkpoint.value);}else{return checkpoint.offset;}}function invert(offset){if(checkpoints.length===0){return offset;}var bisectedIndex=__WEBPACK_IMPORTED_MODULE_0_binary_search___default()(checkpoints,offset,function(checkpoint,offset,index){return checkpoint.offset-offset;});if(bisectedIndex>-1){var _checkpoint2=checkpoints[bisectedIndex];return _checkpoint2.value;}var index=-bisectedIndex-1;if(index===0){return offset;}var checkpoint=checkpoints[index-1];if(checkpoint.type==="positive"){return checkpoint.value+(offset-checkpoint.offset);}else{return checkpoint.value;}}scale.invert=invert;scale.ticks=function(){return[];};return scale;}

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arc__ = __webpack_require__(1954);
/* unused harmony reexport arc */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(752);
/* unused harmony reexport area */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__line__ = __webpack_require__(455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__line__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pie__ = __webpack_require__(1956);
/* unused harmony reexport pie */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__areaRadial__ = __webpack_require__(1959);
/* unused harmony reexport areaRadial */
/* unused harmony reexport radialArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lineRadial__ = __webpack_require__(754);
/* unused harmony reexport lineRadial */
/* unused harmony reexport radialLine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pointRadial__ = __webpack_require__(755);
/* unused harmony reexport pointRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__link_index__ = __webpack_require__(1960);
/* unused harmony reexport linkHorizontal */
/* unused harmony reexport linkVertical */
/* unused harmony reexport linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__symbol__ = __webpack_require__(1961);
/* unused harmony reexport symbol */
/* unused harmony reexport symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__symbol_circle__ = __webpack_require__(757);
/* unused harmony reexport symbolCircle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__symbol_cross__ = __webpack_require__(758);
/* unused harmony reexport symbolCross */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__symbol_diamond__ = __webpack_require__(759);
/* unused harmony reexport symbolDiamond */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__symbol_square__ = __webpack_require__(761);
/* unused harmony reexport symbolSquare */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__symbol_star__ = __webpack_require__(760);
/* unused harmony reexport symbolStar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__symbol_triangle__ = __webpack_require__(762);
/* unused harmony reexport symbolTriangle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__symbol_wye__ = __webpack_require__(763);
/* unused harmony reexport symbolWye */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__curve_basisClosed__ = __webpack_require__(1962);
/* unused harmony reexport curveBasisClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__curve_basisOpen__ = __webpack_require__(1963);
/* unused harmony reexport curveBasisOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__curve_basis__ = __webpack_require__(293);
/* unused harmony reexport curveBasis */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__curve_bundle__ = __webpack_require__(1964);
/* unused harmony reexport curveBundle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__curve_cardinalClosed__ = __webpack_require__(764);
/* unused harmony reexport curveCardinalClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__curve_cardinalOpen__ = __webpack_require__(765);
/* unused harmony reexport curveCardinalOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__curve_cardinal__ = __webpack_require__(294);
/* unused harmony reexport curveCardinal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__curve_catmullRomClosed__ = __webpack_require__(1965);
/* unused harmony reexport curveCatmullRomClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__curve_catmullRomOpen__ = __webpack_require__(1966);
/* unused harmony reexport curveCatmullRomOpen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__curve_catmullRom__ = __webpack_require__(457);
/* unused harmony reexport curveCatmullRom */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__curve_linearClosed__ = __webpack_require__(1967);
/* unused harmony reexport curveLinearClosed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__curve_linear__ = __webpack_require__(291);
/* unused harmony reexport curveLinear */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__curve_monotone__ = __webpack_require__(1968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_28__curve_monotone__["a"]; });
/* unused harmony reexport curveMonotoneY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__curve_natural__ = __webpack_require__(1969);
/* unused harmony reexport curveNatural */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__curve_step__ = __webpack_require__(1970);
/* unused harmony reexport curveStep */
/* unused harmony reexport curveStepAfter */
/* unused harmony reexport curveStepBefore */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__stack__ = __webpack_require__(1971);
/* unused harmony reexport stack */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__offset_expand__ = __webpack_require__(1972);
/* unused harmony reexport stackOffsetExpand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__offset_diverging__ = __webpack_require__(1973);
/* unused harmony reexport stackOffsetDiverging */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__offset_none__ = __webpack_require__(216);
/* unused harmony reexport stackOffsetNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__offset_silhouette__ = __webpack_require__(1974);
/* unused harmony reexport stackOffsetSilhouette */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__offset_wiggle__ = __webpack_require__(1975);
/* unused harmony reexport stackOffsetWiggle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__order_ascending__ = __webpack_require__(458);
/* unused harmony reexport stackOrderAscending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__order_descending__ = __webpack_require__(1976);
/* unused harmony reexport stackOrderDescending */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__order_insideOut__ = __webpack_require__(1977);
/* unused harmony reexport stackOrderInsideOut */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__order_none__ = __webpack_require__(217);
/* unused harmony reexport stackOrderNone */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__order_reverse__ = __webpack_require__(1978);
/* unused harmony reexport stackOrderReverse */




 // Note: radialArea is deprecated!
 // Note: radialLine is deprecated!









































/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__math__ = __webpack_require__(215);




function arcInnerRadius(d) {
  return d.innerRadius;
}

function arcOuterRadius(d) {
  return d.outerRadius;
}

function arcStartAngle(d) {
  return d.startAngle;
}

function arcEndAngle(d) {
  return d.endAngle;
}

function arcPadAngle(d) {
  return d && d.padAngle; // Note: optional!
}

function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0,
      x32 = x3 - x2, y32 = y3 - y2,
      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
  return [x0 + t * x10, y0 + t * y10];
}

// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1,
      y01 = y0 - y1,
      lo = (cw ? rc : -rc) / Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(x01 * x01 + y01 * y01),
      ox = lo * y01,
      oy = -lo * x01,
      x11 = x0 + ox,
      y11 = y0 + oy,
      x10 = x1 + ox,
      y10 = y1 + oy,
      x00 = (x11 + x10) / 2,
      y00 = (y11 + y10) / 2,
      dx = x10 - x11,
      dy = y10 - y11,
      d2 = dx * dx + dy * dy,
      r = r1 - rc,
      D = x11 * y10 - x10 * y11,
      d = (dy < 0 ? -1 : 1) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["h" /* max */])(0, r * r * d2 - D * D)),
      cx0 = (D * dy - dx * d) / d2,
      cy0 = (-D * dx - dy * d) / d2,
      cx1 = (D * dy + dx * d) / d2,
      cy1 = (-D * dx + dy * d) / d2,
      dx0 = cx0 - x00,
      dy0 = cy0 - y00,
      dx1 = cx1 - x00,
      dy1 = cy1 - y00;

  // Pick the closer of the two intersection points.
  // TODO Is there a faster way to determine which intersection to use?
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;

  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var innerRadius = arcInnerRadius,
      outerRadius = arcOuterRadius,
      cornerRadius = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(0),
      padRadius = null,
      startAngle = arcStartAngle,
      endAngle = arcEndAngle,
      padAngle = arcPadAngle,
      context = null;

  function arc() {
    var buffer,
        r,
        r0 = +innerRadius.apply(this, arguments),
        r1 = +outerRadius.apply(this, arguments),
        a0 = startAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        a1 = endAngle.apply(this, arguments) - __WEBPACK_IMPORTED_MODULE_2__math__["g" /* halfPi */],
        da = Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(a1 - a0),
        cw = a1 > a0;

    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();

    // Ensure that the outer radius is always larger than the inner radius.
    if (r1 < r0) r = r1, r1 = r0, r0 = r;

    // Is it a point?
    if (!(r1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(0, 0);

    // Or is it a circle or annulus?
    else if (da > __WEBPACK_IMPORTED_MODULE_2__math__["m" /* tau */] - __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
      context.moveTo(r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a0), r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        context.moveTo(r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a1), r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    }

    // Or is it a circular or annular sector?
    else {
      var a01 = a0,
          a11 = a1,
          a00 = a0,
          a10 = a1,
          da0 = da,
          da1 = da,
          ap = padAngle.apply(this, arguments) / 2,
          rp = (ap > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) && (padRadius ? +padRadius.apply(this, arguments) : Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(r0 * r0 + r1 * r1)),
          rc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["a" /* abs */])(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
          rc0 = rc,
          rc1 = rc,
          t0,
          t1;

      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
      if (rp > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var p0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap)),
            p1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["c" /* asin */])(rp / r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(ap));
        if ((da0 -= p0 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }

      var x01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a01),
          y01 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a01),
          x10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a10),
          y10 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a10);

      // Apply rounded corners?
      if (rc > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        var x11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a11),
            y11 = r1 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a11),
            x00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a00),
            y00 = r0 * Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a00);

        // Restrict the corner radius according to the sector angle.
        if (da < __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */]) {
          var oc = da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */] ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
              ax = x01 - oc[0],
              ay = y01 - oc[1],
              bx = x11 - oc[0],
              by = y11 - oc[1],
              kc = 1 / Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(Object(__WEBPACK_IMPORTED_MODULE_2__math__["b" /* acos */])((ax * bx + ay * by) / (Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(ax * ax + ay * ay) * Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(bx * bx + by * by))) / 2),
              lc = Object(__WEBPACK_IMPORTED_MODULE_2__math__["l" /* sqrt */])(oc[0] * oc[0] + oc[1] * oc[1]);
          rc0 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r0 - lc) / (kc - 1));
          rc1 = Object(__WEBPACK_IMPORTED_MODULE_2__math__["i" /* min */])(rc, (r1 - lc) / (kc + 1));
        }
      }

      // Is the sector collapsed to a line?
      if (!(da1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.moveTo(x01, y01);

      // Does the sector’s outer ring have rounded corners?
      else if (rc1 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);

        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the outer ring just a circular arc?
      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);

      // Is there no inner ring, and it’s a circular sector?
      // Or perhaps it’s an annular sector collapsed due to padding?
      if (!(r0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) || !(da0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */])) context.lineTo(x10, y10);

      // Does the sector’s inner ring (or point) have rounded corners?
      else if (rc0 > __WEBPACK_IMPORTED_MODULE_2__math__["f" /* epsilon */]) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);

        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);

        // Have the corners merged?
        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);

        // Otherwise, draw the two corners and the ring.
        else {
          context.arc(t0.cx, t0.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y01, t0.x01), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t0.cy + t0.y11, t0.cx + t0.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y11, t1.x11), Object(__WEBPACK_IMPORTED_MODULE_2__math__["d" /* atan2 */])(t1.y01, t1.x01), !cw);
        }
      }

      // Or is the inner ring just a circular arc?
      else context.arc(0, 0, r0, a10, a00, cw);
    }

    context.closePath();

    if (buffer) return context = null, buffer + "" || null;
  }

  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - __WEBPACK_IMPORTED_MODULE_2__math__["j" /* pi */] / 2;
    return [Object(__WEBPACK_IMPORTED_MODULE_2__math__["e" /* cos */])(a) * r, Object(__WEBPACK_IMPORTED_MODULE_2__math__["k" /* sin */])(a) * r];
  };

  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : innerRadius;
  };

  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : outerRadius;
  };

  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : cornerRadius;
  };

  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padRadius;
  };

  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : startAngle;
  };

  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : endAngle;
  };

  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), arc) : padAngle;
  };

  arc.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
  };

  return arc;
});


/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pi = Math.PI,
    tau = 2 * pi,
    epsilon = 1e-6,
    tauEpsilon = tau - epsilon;

function Path() {
  this._x0 = this._y0 = // start of current subpath
  this._x1 = this._y1 = null; // end of current subpath
  this._ = "";
}

function path() {
  return new Path;
}

Path.prototype = path.prototype = {
  constructor: Path,
  moveTo: function(x, y) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
  },
  closePath: function() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._ += "Z";
    }
  },
  lineTo: function(x, y) {
    this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  quadraticCurveTo: function(x1, y1, x, y) {
    this._ += "Q" + (+x1) + "," + (+y1) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
    this._ += "C" + (+x1) + "," + (+y1) + "," + (+x2) + "," + (+y2) + "," + (this._x1 = +x) + "," + (this._y1 = +y);
  },
  arcTo: function(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    var x0 = this._x1,
        y0 = this._y1,
        x21 = x2 - x1,
        y21 = y2 - y1,
        x01 = x0 - x1,
        y01 = y0 - y1,
        l01_2 = x01 * x01 + y01 * y01;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x1,y1).
    if (this._x1 === null) {
      this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
    else if (!(l01_2 > epsilon));

    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
    // Equivalently, is (x1,y1) coincident with (x2,y2)?
    // Or, is the radius zero? Line to (x1,y1).
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
      this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
    }

    // Otherwise, draw an arc!
    else {
      var x20 = x2 - x0,
          y20 = y2 - y0,
          l21_2 = x21 * x21 + y21 * y21,
          l20_2 = x20 * x20 + y20 * y20,
          l21 = Math.sqrt(l21_2),
          l01 = Math.sqrt(l01_2),
          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
          t01 = l / l01,
          t21 = l / l21;

      // If the start tangent is not coincident with (x0,y0), line to.
      if (Math.abs(t01 - 1) > epsilon) {
        this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
      }

      this._ += "A" + r + "," + r + ",0,0," + (+(y01 * x20 > x01 * y20)) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
    }
  },
  arc: function(x, y, r, a0, a1, ccw) {
    x = +x, y = +y, r = +r;
    var dx = r * Math.cos(a0),
        dy = r * Math.sin(a0),
        x0 = x + dx,
        y0 = y + dy,
        cw = 1 ^ ccw,
        da = ccw ? a0 - a1 : a1 - a0;

    // Is the radius negative? Error.
    if (r < 0) throw new Error("negative radius: " + r);

    // Is this path empty? Move to (x0,y0).
    if (this._x1 === null) {
      this._ += "M" + x0 + "," + y0;
    }

    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
      this._ += "L" + x0 + "," + y0;
    }

    // Is this arc empty? We’re done.
    if (!r) return;

    // Does the angle go the wrong way? Flip the direction.
    if (da < 0) da = da % tau + tau;

    // Is this a complete circle? Draw two arcs to complete the circle.
    if (da > tauEpsilon) {
      this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
    }

    // Is this arc non-empty? Draw an arc!
    else if (da > epsilon) {
      this._ += "A" + r + "," + r + ",0," + (+(da >= pi)) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    }
  },
  rect: function(x, y, w, h) {
    this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + (+w) + "v" + (+h) + "h" + (-w) + "Z";
  },
  toString: function() {
    return this._;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (path);


/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__descending__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity__ = __webpack_require__(1958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__math__ = __webpack_require__(215);





/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var value = __WEBPACK_IMPORTED_MODULE_2__identity__["a" /* default */],
      sortValues = __WEBPACK_IMPORTED_MODULE_1__descending__["a" /* default */],
      sort = null,
      startAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0),
      endAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */]),
      padAngle = Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(0);

  function pie(data) {
    var i,
        n = data.length,
        j,
        k,
        sum = 0,
        index = new Array(n),
        arcs = new Array(n),
        a0 = +startAngle.apply(this, arguments),
        da = Math.min(__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], Math.max(-__WEBPACK_IMPORTED_MODULE_3__math__["m" /* tau */], endAngle.apply(this, arguments) - a0)),
        a1,
        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
        pa = p * (da < 0 ? -1 : 1),
        v;

    for (i = 0; i < n; ++i) {
      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
        sum += v;
      }
    }

    // Optionally sort the arcs by previously-computed values or by data.
    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });

    // Compute the arcs! They are stored in the original data's order.
    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
        data: data[j],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }

    return arcs;
  }

  pie.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : value;
  };

  pie.sortValues = function(_) {
    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
  };

  pie.sort = function(_) {
    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
  };

  pie.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : startAngle;
  };

  pie.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : endAngle;
  };

  pie.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_0__constant__["a" /* default */])(+_), pie) : padAngle;
  };

  return pie;
});


/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(a, b) {
  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
});


/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function(d) {
  return d;
});


/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__curve_radial__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__area__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lineRadial__ = __webpack_require__(754);




/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var a = Object(__WEBPACK_IMPORTED_MODULE_1__area__["a" /* default */])().curve(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["a" /* curveRadialLinear */]),
      c = a.curve,
      x0 = a.lineX0,
      x1 = a.lineX1,
      y0 = a.lineY0,
      y1 = a.lineY1;

  a.angle = a.x, delete a.x;
  a.startAngle = a.x0, delete a.x0;
  a.endAngle = a.x1, delete a.x1;
  a.radius = a.y, delete a.y;
  a.innerRadius = a.y0, delete a.y0;
  a.outerRadius = a.y1, delete a.y1;
  a.lineStartAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x0()); }, delete a.lineX0;
  a.lineEndAngle = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(x1()); }, delete a.lineX1;
  a.lineInnerRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y0()); }, delete a.lineY0;
  a.lineOuterRadius = function() { return Object(__WEBPACK_IMPORTED_MODULE_2__lineRadial__["a" /* lineRadial */])(y1()); }, delete a.lineY1;

  a.curve = function(_) {
    return arguments.length ? c(Object(__WEBPACK_IMPORTED_MODULE_0__curve_radial__["b" /* default */])(_)) : c()._curve;
  };

  return a;
});


/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export linkHorizontal */
/* unused harmony export linkVertical */
/* unused harmony export linkRadial */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__array__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constant__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__point__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pointRadial__ = __webpack_require__(755);






function linkSource(d) {
  return d.source;
}

function linkTarget(d) {
  return d.target;
}

function link(curve) {
  var source = linkSource,
      target = linkTarget,
      x = __WEBPACK_IMPORTED_MODULE_3__point__["a" /* x */],
      y = __WEBPACK_IMPORTED_MODULE_3__point__["b" /* y */],
      context = null;

  function link() {
    var buffer, argv = __WEBPACK_IMPORTED_MODULE_1__array__["a" /* slice */].call(arguments), s = source.apply(this, argv), t = target.apply(this, argv);
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    curve(context, +x.apply(this, (argv[0] = s, argv)), +y.apply(this, argv), +x.apply(this, (argv[0] = t, argv)), +y.apply(this, argv));
    if (buffer) return context = null, buffer + "" || null;
  }

  link.source = function(_) {
    return arguments.length ? (source = _, link) : source;
  };

  link.target = function(_) {
    return arguments.length ? (target = _, link) : target;
  };

  link.x = function(_) {
    return arguments.length ? (x = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : x;
  };

  link.y = function(_) {
    return arguments.length ? (y = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_2__constant__["a" /* default */])(+_), link) : y;
  };

  link.context = function(_) {
    return arguments.length ? ((context = _ == null ? null : _), link) : context;
  };

  return link;
}

function curveHorizontal(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0 = (x0 + x1) / 2, y0, x0, y1, x1, y1);
}

function curveVertical(context, x0, y0, x1, y1) {
  context.moveTo(x0, y0);
  context.bezierCurveTo(x0, y0 = (y0 + y1) / 2, x1, y0, x1, y1);
}

function curveRadial(context, x0, y0, x1, y1) {
  var p0 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0),
      p1 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x0, y0 = (y0 + y1) / 2),
      p2 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y0),
      p3 = Object(__WEBPACK_IMPORTED_MODULE_4__pointRadial__["a" /* default */])(x1, y1);
  context.moveTo(p0[0], p0[1]);
  context.bezierCurveTo(p1[0], p1[1], p2[0], p2[1], p3[0], p3[1]);
}

function linkHorizontal() {
  return link(curveHorizontal);
}

function linkVertical() {
  return link(curveVertical);
}

function linkRadial() {
  var l = link(curveRadial);
  l.angle = l.x, delete l.x;
  l.radius = l.y, delete l.y;
  return l;
}


/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export symbols */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_d3_path__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__symbol_circle__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__symbol_cross__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__symbol_star__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__symbol_square__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__symbol_wye__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__constant__ = __webpack_require__(144);










var symbols = [
  __WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_2__symbol_cross__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_3__symbol_diamond__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_5__symbol_square__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_4__symbol_star__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_6__symbol_triangle__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_7__symbol_wye__["a" /* default */]
];

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var type = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__symbol_circle__["a" /* default */]),
      size = Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(64),
      context = null;

  function symbol() {
    var buffer;
    if (!context) context = buffer = Object(__WEBPACK_IMPORTED_MODULE_0_d3_path__["a" /* path */])();
    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
    if (buffer) return context = null, buffer + "" || null;
  }

  symbol.type = function(_) {
    return arguments.length ? (type = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(_), symbol) : type;
  };

  symbol.size = function(_) {
    return arguments.length ? (size = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_8__constant__["a" /* default */])(+_), symbol) : size;
  };

  symbol.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
  };

  return symbol;
});


/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basis__ = __webpack_require__(293);



function BasisClosed(context) {
  this._context = context;
}

BasisClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2);
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
      default: Object(__WEBPACK_IMPORTED_MODULE_1__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisClosed(context);
});


/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(293);


function BasisOpen(context) {
  this._context = context;
}

BasisOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_0__basis__["b" /* point */])(this, x, y); break;
    }
    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new BasisOpen(context);
});


/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basis__ = __webpack_require__(293);


function Bundle(context, beta) {
  this._basis = new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context);
  this._beta = beta;
}

Bundle.prototype = {
  lineStart: function() {
    this._x = [];
    this._y = [];
    this._basis.lineStart();
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        j = x.length - 1;

    if (j > 0) {
      var x0 = x[0],
          y0 = y[0],
          dx = x[j] - x0,
          dy = y[j] - y0,
          i = -1,
          t;

      while (++i <= j) {
        t = i / j;
        this._basis.point(
          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
        );
      }
    }

    this._x = this._y = null;
    this._basis.lineEnd();
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(beta) {

  function bundle(context) {
    return beta === 1 ? new __WEBPACK_IMPORTED_MODULE_0__basis__["a" /* Basis */](context) : new Bundle(context, beta);
  }

  bundle.beta = function(beta) {
    return custom(+beta);
  };

  return bundle;
})(0.85));


/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__catmullRom__ = __webpack_require__(457);




function CatmullRomClosed(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_1__noop__["a" /* default */],
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 2: {
        this._context.lineTo(this._x3, this._y3);
        this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x3, this._y3);
        this.point(this._x4, this._y4);
        this.point(this._x5, this._y5);
        break;
      }
    }
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
      default: Object(__WEBPACK_IMPORTED_MODULE_2__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomClosed(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalClosed__["a" /* CardinalClosed */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__catmullRom__ = __webpack_require__(457);



function CatmullRomOpen(context, alpha) {
  this._context = context;
  this._alpha = alpha;
}

CatmullRomOpen.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._x2 =
    this._y0 = this._y1 = this._y2 = NaN;
    this._l01_a = this._l12_a = this._l23_a =
    this._l01_2a = this._l12_2a = this._l23_2a =
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;

    if (this._point) {
      var x23 = this._x2 - x,
          y23 = this._y2 - y;
      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
    }

    switch (this._point) {
      case 0: this._point = 1; break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
      case 3: this._point = 4; // proceed
      default: Object(__WEBPACK_IMPORTED_MODULE_1__catmullRom__["a" /* point */])(this, x, y); break;
    }

    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = ((function custom(alpha) {

  function catmullRom(context) {
    return alpha ? new CatmullRomOpen(context, alpha) : new __WEBPACK_IMPORTED_MODULE_0__cardinalOpen__["a" /* CardinalOpen */](context, 0);
  }

  catmullRom.alpha = function(alpha) {
    return custom(+alpha);
  };

  return catmullRom;
})(0.5));


/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noop__ = __webpack_require__(292);


function LinearClosed(context) {
  this._context = context;
}

LinearClosed.prototype = {
  areaStart: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  areaEnd: __WEBPACK_IMPORTED_MODULE_0__noop__["a" /* default */],
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._point) this._context.closePath();
  },
  point: function(x, y) {
    x = +x, y = +y;
    if (this._point) this._context.lineTo(x, y);
    else this._point = 1, this._context.moveTo(x, y);
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new LinearClosed(context);
});


/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = monotoneX;
/* unused harmony export monotoneY */
function sign(x) {
  return x < 0 ? -1 : 1;
}

// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0,
      h1 = x2 - that._x1,
      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
      p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}

// Calculate a one-sided slope.
function slope2(that, t) {
  var h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}

// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
  var x0 = that._x0,
      y0 = that._y0,
      x1 = that._x1,
      y1 = that._y1,
      dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

function MonotoneX(context) {
  this._context = context;
}

MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 =
    this._y0 = this._y1 =
    this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2: this._context.lineTo(this._x1, this._y1); break;
      case 3: point(this, this._t0, slope2(this, this._t0)); break;
    }
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x, y) {
    var t1 = NaN;

    x = +x, y = +y;
    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; break;
      case 2: this._point = 3; point(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
      default: point(this, this._t0, t1 = slope3(this, x, y)); break;
    }

    this._x0 = this._x1, this._x1 = x;
    this._y0 = this._y1, this._y1 = y;
    this._t0 = t1;
  }
}

function MonotoneY(context) {
  this._context = new ReflectContext(context);
}

(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
  MonotoneX.prototype.point.call(this, y, x);
};

function ReflectContext(context) {
  this._context = context;
}

ReflectContext.prototype = {
  moveTo: function(x, y) { this._context.moveTo(y, x); },
  closePath: function() { this._context.closePath(); },
  lineTo: function(x, y) { this._context.lineTo(y, x); },
  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
};

function monotoneX(context) {
  return new MonotoneX(context);
}

function monotoneY(context) {
  return new MonotoneY(context);
}


/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Natural(context) {
  this._context = context;
}

Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x = this._x,
        y = this._y,
        n = x.length;

    if (n) {
      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
      if (n === 2) {
        this._context.lineTo(x[1], y[1]);
      } else {
        var px = controlPoints(x),
            py = controlPoints(y);
        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
        }
      }
    }

    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x, y) {
    this._x.push(+x);
    this._y.push(+y);
  }
};

// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
  var i,
      n = x.length - 1,
      m,
      a = new Array(n),
      b = new Array(n),
      r = new Array(n);
  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
  a[n - 1] = r[n - 1] / b[n - 1];
  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
  b[n - 1] = (x[n] + a[n - 1]) / 2;
  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
  return [a, b];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Natural(context);
});


/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stepBefore */
/* unused harmony export stepAfter */
function Step(context, t) {
  this._context = context;
  this._t = t;
}

Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x, y) {
    x = +x, y = +y;
    switch (this._point) {
      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
      case 1: this._point = 2; // proceed
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y);
          this._context.lineTo(x, y);
        } else {
          var x1 = this._x * (1 - this._t) + x * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y);
        }
        break;
      }
    }
    this._x = x, this._y = y;
  }
};

/* unused harmony default export */ var _unused_webpack_default_export = (function(context) {
  return new Step(context, 0.5);
});

function stepBefore(context) {
  return new Step(context, 0);
}

function stepAfter(context) {
  return new Step(context, 1);
}


/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__array__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constant__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__offset_none__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__order_none__ = __webpack_require__(217);





function stackValue(d, key) {
  return d[key];
}

/* unused harmony default export */ var _unused_webpack_default_export = (function() {
  var keys = Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])([]),
      order = __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */],
      offset = __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */],
      value = stackValue;

  function stack(data) {
    var kz = keys.apply(this, arguments),
        i,
        m = data.length,
        n = kz.length,
        sz = new Array(n),
        oz;

    for (i = 0; i < n; ++i) {
      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
        si[j] = sij = [0, +value(data[j], ki, j, data)];
        sij.data = data[j];
      }
      si.key = ki;
    }

    for (i = 0, oz = order(sz); i < n; ++i) {
      sz[oz[i]].index = i;
    }

    offset(sz, oz);
    return sz;
  }

  stack.keys = function(_) {
    return arguments.length ? (keys = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : keys;
  };

  stack.value = function(_) {
    return arguments.length ? (value = typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(+_), stack) : value;
  };

  stack.order = function(_) {
    return arguments.length ? (order = _ == null ? __WEBPACK_IMPORTED_MODULE_3__order_none__["a" /* default */] : typeof _ === "function" ? _ : Object(__WEBPACK_IMPORTED_MODULE_1__constant__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__array__["a" /* slice */].call(_)), stack) : order;
  };

  stack.offset = function(_) {
    return arguments.length ? (offset = _ == null ? __WEBPACK_IMPORTED_MODULE_2__offset_none__["a" /* default */] : _, stack) : offset;
  };

  return stack;
});


/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(216);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 1)) return;
  for (var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j) {
    for (yp = yn = 0, i = 0; i < n; ++i) {
      if ((dy = (d = series[order[i]][j])[1] - d[0]) >= 0) {
        d[0] = yp, d[1] = yp += dy;
      } else if (dy < 0) {
        d[1] = yn, d[0] = yn += dy;
      } else {
        d[0] = yp;
      }
    }
  }
});


/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(216);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0)) return;
  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
    s0[j][1] += s0[j][0] = -y / 2;
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(216);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series, order) {
  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
      var si = series[order[i]],
          sij0 = si[j][1] || 0,
          sij1 = si[j - 1][1] || 0,
          s3 = (sij0 - sij1) / 2;
      for (var k = 0; k < i; ++k) {
        var sk = series[order[k]],
            skj0 = sk[j][1] || 0,
            skj1 = sk[j - 1][1] || 0;
        s3 += skj0 - skj1;
      }
      s1 += sij0, s2 += s3 * sij0;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    if (s1) y -= s2 / s1;
  }
  s0[j - 1][1] += s0[j - 1][0] = y;
  Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series, order);
});


/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ascending__ = __webpack_require__(458);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__ascending__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ascending__ = __webpack_require__(458);



/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  var n = series.length,
      i,
      j,
      sums = series.map(__WEBPACK_IMPORTED_MODULE_1__ascending__["b" /* sum */]),
      order = Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).sort(function(a, b) { return sums[b] - sums[a]; }),
      top = 0,
      bottom = 0,
      tops = [],
      bottoms = [];

  for (i = 0; i < n; ++i) {
    j = order[i];
    if (top < bottom) {
      top += sums[j];
      tops.push(j);
    } else {
      bottom += sums[j];
      bottoms.push(j);
    }
  }

  return bottoms.reverse().concat(tops);
});


/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__none__ = __webpack_require__(217);


/* unused harmony default export */ var _unused_webpack_default_export = (function(series) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__none__["a" /* default */])(series).reverse();
});


/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  z-index: 999999;\n  user-select: none;\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  z-index: 999999;\n  user-select: none;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      position: fixed;\n      top: 0px;\n      right: 0px;\n      bottom: 0px;\n      left: 0px;\n      background: rgba(0, 0, 0, 0.75);\n      overflow: hidden;\n    "],["\n      position: fixed;\n      top: 0px;\n      right: 0px;\n      bottom: 0px;\n      left: 0px;\n      background: rgba(0, 0, 0, 0.75);\n      overflow: hidden;\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  min-height: 100%;\n  padding: 5px 12px 11px;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n  }\n"],["\n  width: 100%;\n  min-height: 100%;\n  padding: 5px 12px 11px;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: space-between;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100%;\n    // max-width: 480px;\n    margin: 0 auto;\n  }\n"],["\n  @media (max-width: 959px) {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    width: 100%;\n    // max-width: 480px;\n    margin: 0 auto;\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  margin: 0 0 11px 0;\n  padding: 13px 0;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  color: ",";\n  text-align: center;\n\n  :after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: 0px;\n    left: 50%;\n    transform: translateX(-50%);\n    height: 0px;\n    width: 100%;\n    border-bottom: 1px solid ",";\n  }\n"],["\n  position: relative;\n  margin: 0 0 11px 0;\n  padding: 13px 0;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  color: ",";\n  text-align: center;\n\n  :after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: 0px;\n    left: 50%;\n    transform: translateX(-50%);\n    height: 0px;\n    width: 100%;\n    border-bottom: 1px solid ",";\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var PopupView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.mainDark;});var MobileContentWrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h2(_templateObject5,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(props){return props.theme.accent;},function(props){return props.theme.mainSeparator;});function Popup(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{mobile:props.mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PopupView,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](MobileContentWrapper,{mobile:props.mobile},props.children)),props.info));}/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  text-align: center;\n\n  :not(:last-of-type) {\n    margin: 0 0 24px;\n  }\n\n  :not(:last-of-type):after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: -12px;\n    left: 50%;\n    transform: translateX(-50%);\n    height: 0px;\n    border-bottom: 1px solid ",";\n  }\n\n  ","\n\n  ","\n\n  @media(max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 1;\n    align-items: center;\n    justify-content: space-between;\n    align-content: space-between;\n  }\n"],["\n  position: relative;\n  display: inline-flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  text-align: center;\n\n  :not(:last-of-type) {\n    margin: 0 0 24px;\n  }\n\n  :not(:last-of-type):after {\n    content: \"\";\n    display: block;\n    position: absolute;\n    bottom: -12px;\n    left: 50%;\n    transform: translateX(-50%);\n    height: 0px;\n    border-bottom: 1px solid ",";\n  }\n\n  ","\n\n  ","\n\n  @media(max-width: 959px) {\n    flex-grow: 1;\n    flex-shrink: 1;\n    align-items: center;\n    justify-content: space-between;\n    align-content: space-between;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n        @media(min-width:480px) and (max-width: 959px) {\n          width: ","%;\n        }\n        "],["\n        @media(min-width:480px) and (max-width: 959px) {\n          width: ","%;\n        }\n        "]),_templateObject3=_taggedTemplateLiteral(["\n          width: ","%;\n        "],["\n          width: ","%;\n        "]),_templateObject4=_taggedTemplateLiteral(["\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n  "],["\n    align-items: center;\n    align-content: center;\n    justify-content: center;\n  "]),_templateObject5=_taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0 0 5px 0;\n  padding: 0 0 0 7px;\n  box-sizing: border-box;\n  font-size: ",";\n  line-height: 1;\n  text-align: left;\n  color: ",";\n"],["\n  width: 100%;\n  margin: 0 0 5px 0;\n  padding: 0 0 0 7px;\n  box-sizing: border-box;\n  font-size: ",";\n  line-height: 1;\n  text-align: left;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  width: 100%;\n"],["\n  width: 100%;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.mainSeparator;},function(props){return props.share&&(props.share===3?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(props){return 100/props.share;}):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,function(props){return 100/props.share;}));},function(props){return props.buttonRow&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject5,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref2){var theme=_ref2.theme;return theme.foreground;});var ChildrenContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);function Row(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{share:props.share,buttonRow:props.buttonRow},props.title&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,props.title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ChildrenContainer,null,props.children));}/* harmony default export */ __webpack_exports__["a"] = (Row);

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  width: 120px;\n  margin: 6px;\n  padding: 9px 0;\n  font-weight: 300;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: ",";\n  background-color: ",";\n  border: 0px;\n  border-radius: 4px;\n  user-select: none;\n  cursor: pointer;\n\n  :focus {\n    outline: none;\n  }\n\n  :hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media(max-width: 959px) {\n    width: auto;\n    padding: 9px 18px;\n  }\n\n  ","\n"],["\n  display: inline-block;\n  width: 120px;\n  margin: 6px;\n  padding: 9px 0;\n  font-weight: 300;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  text-decoration: none;\n  color: ",";\n  background-color: ",";\n  border: 0px;\n  border-radius: 4px;\n  user-select: none;\n  cursor: pointer;\n\n  :focus {\n    outline: none;\n  }\n\n  :hover {\n    background-color: ",";\n    color: ",";\n  }\n\n  @media(max-width: 959px) {\n    width: auto;\n    padding: 9px 18px;\n  }\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    background-color: #97959a;\n\n    :hover {\n      cursor: default;\n      background-color: #97959a;\n      color: ",";\n    }\n  "],["\n    background-color: #97959a;\n\n    :hover {\n      cursor: default;\n      background-color: #97959a;\n      color: ",";\n    }\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ButtonView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme,isSubmit=_ref2.isSubmit;return isSubmit?theme.alternativeForeground:theme.foreground;},function(props){return props.isSubmit?props.theme.upper:"#bfbfbf";},function(props){return props.theme.accent;},function(props){return props.theme.mainDark;},function(props){return props.disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(_ref3){var theme=_ref3.theme;return theme.foreground;});});function Button(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonView,props);}/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Input */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: bottom;\n  width: 104px;\n  padding: 0 6px;\n  box-sizing: border-box;\n  text-align: left;\n\n  @media(max-width: 639px) {\n    width: 79px;\n  }\n\n  @media(max-width: 567px) {\n    width: 69px;\n  }\n"],["\n  display: inline-block;\n  vertical-align: bottom;\n  width: 104px;\n  padding: 0 6px;\n  box-sizing: border-box;\n  text-align: left;\n\n  @media(max-width: 639px) {\n    width: 79px;\n  }\n\n  @media(max-width: 567px) {\n    width: 69px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 27px;\n  height: 29px;\n  border: 1px solid ",";\n  border-radius: 3px;\n  font-weight: 300;\n  font-size: ",";\n  line-height: 27px;\n  color: ",";\n  padding: 0 7px;\n  background-color: ",";\n  box-shadow: inset 0px 2px 0px 0px rgba(0,0,0,.15);\n\n  :focus {\n    outline: none;\n  }\n"],["\n  display: inline-block;\n  width: 100%;\n  box-sizing: border-box;\n  min-height: 27px;\n  height: 29px;\n  border: 1px solid ",";\n  border-radius: 3px;\n  font-weight: 300;\n  font-size: ",";\n  line-height: 27px;\n  color: ",";\n  padding: 0 7px;\n  background-color: ",";\n  box-shadow: inset 0px 2px 0px 0px rgba(0,0,0,.15);\n\n  :focus {\n    outline: none;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  margin: 5px 0;\n  padding: 0;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n\n  ",";\n"],["\n  direction: ",";\n  margin: 5px 0;\n  padding: 0;\n  font-size: ",";\n  line-height: 1;\n  color: #99959d;\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n    text-align: right;\n  "],["\n    text-align: right;\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].label(_templateObject);var InputView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject2,function(props){return props.invalid?props.theme.lower:props.theme.borderMainColor;},function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(props){return props.theme.mainHighlight;});var Label=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.direction;},function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4);});function Input(props){var id=Math.random().toString(36).slice(2,16);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{htmlFor:id},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Label,null,props.label,":"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InputView,{id:id,name:props.name,type:props.type||"tel",value:props.value,onChange:props.onChange,invalid:props.invalid}));}/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_connected__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TradeModals_IntervalsModal__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ActiveStock__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NextGenTicks__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Surface__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Line__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Candlestick__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Bar__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Indicator__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__OscillatorVisuals__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Deal__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Dot__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__background_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__background_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__background_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Bars__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Sentiments__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ChartBottomNavigation__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__NextGenChartTypes__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Layers__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__TradeMobile_Toolbar_Toolbar__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__OnLine__ = __webpack_require__(462);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"],["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SurfaceContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Toolbar=Object(__WEBPACK_IMPORTED_MODULE_2__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_22__TradeMobile_Toolbar_Toolbar__["a" /* default */])(function(state){var activeStock=Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs);return{activeStock:activeStock,settings:state.settings,isOTC:state.stocks!=null&&state.stocks[activeStock]!=null?state.stocks[activeStock].otc:false};});function Underlay(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__ActiveStock__["a" /* default */],{mobile:true},props.stock.stock),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NextGenTicks__["a" /* HorizontalTicks */],{scaleX:props.scaleX,ticks:props.scaleX.ticks(3),mobile:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__NextGenTicks__["b" /* VerticalTicks */],{scaleY:props.scaleY,ticks:props.scaleY.ticks(3),mobile:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__OnLine__["b" /* default */],null,function(status){return!status&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__OnLine__["a" /* OfflineBadge */],null);}));}function fitsViewport(props,vector){var _vector=_slicedToArray(vector,2),x=_vector[0],y=_vector[1];return x>=0&&x<=props.width&&y>=0&&y<=props.height;}function Overlay(props){var scaleX=props.scaleX,scaleY=props.scaleY,settings=props.settings,lastPoint=props.lastPoint,tradeMode=props.tradeMode,lineColor=props.lineColor,chartHeight=props.chartHeight;var _ref=lastPoint||[],_ref2=_slicedToArray(_ref,3),lastPointX=_ref2[0],lastPointY=_ref2[1],lastPointSource=_ref2[2];var estimatedDealEndingX=scaleX(lastPointSource.date+settings.currentInterval*1000);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.deals.reduce(__WEBPACK_IMPORTED_MODULE_14__Deal__["c" /* dealDuplicatesReducer */],[]).map(function(deal,index,deals){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Deal__["d" /* default */],Object.assign({key:deal.id!=null?deal.id:index.toString(10)},deal,{now:props.time,scaleX:scaleX,scaleY:scaleY,viewportHeight:props.height,viewportWidth:props.width,lastPoint:lastPoint,opacity:Math.floor(1/(deals.length+1)*100)/100,tradeMode:tradeMode,refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching,chartHeight:chartHeight,mobile:true}));}),lastPoint&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,fitsViewport(props,[lastPointX,0])&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Bars__["c" /* VerticalBar */],{mobile:true,opening:true,x:lastPointX},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Opening of the trade")),estimatedDealEndingX-lastPointX>5&&fitsViewport(props,[estimatedDealEndingX,0])&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Bars__["c" /* VerticalBar */],{mobile:true,switchSide:true,x:estimatedDealEndingX},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Closing of the trade")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Bars__["a" /* HorizontalBar */],{y:lastPointY,value:lastPointSource.value,viewportHeight:props.height,mobile:true}),props.settings.chartType==="line"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_15__Dot__["a" /* default */],{x:lastPointX,y:lastPointY,color:lineColor,mobile:true})),props.settings.sentiments&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Sentiments__["a" /* default */],{stats:props.stats,mobile:true}));}var Visuals=function(_React$Component){_inherits(Visuals,_React$Component);function Visuals(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,Visuals);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=Visuals.__proto__||Object.getPrototypeOf(Visuals)).call.apply(_ref3,[this].concat(args))),_this),_this.state={isShownCandleModal:false},_this.toggleCandleModal=function(){_this.setState(function(state){return{isShownCandleModal:!state.isShownCandleModal};});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Visuals,[{key:"render",value:function render(){var _this2=this;var _props=this.props,points=_props.points,width=_props.width,height=_props.height,scaleX=_props.scaleX,scaleY=_props.scaleY,settings=_props.settings,theme=_props.theme;var getOscillatorBlockHeight=function getOscillatorBlockHeight(){return 0;};var getOscillatorHeight=function getOscillatorHeight(){return 0;};if(this.props.oscillators.length){var oscillatorHeightInPercents=Object(__WEBPACK_IMPORTED_MODULE_13__OscillatorVisuals__["c" /* getOscillatorHeightInPercents */])(this.props.oscillators.length);getOscillatorBlockHeight=function getOscillatorBlockHeight(height){return Object(__WEBPACK_IMPORTED_MODULE_13__OscillatorVisuals__["d" /* getRelativeHeight */])(height,oscillatorHeightInPercents);};getOscillatorHeight=function getOscillatorHeight(height){return Math.floor(height/_this2.props.oscillators.length);};}var oscillatorsHeight=getOscillatorBlockHeight(height);var chartHeight=height-oscillatorsHeight;var oscillatorHeight=getOscillatorHeight(oscillatorsHeight);var lineColor=settings.lineColor===theme.background?theme.foreground:settings.lineColor;var toolbarForTour=this.context!=null&&this.context.step==="showStockSelect";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{width:"100%",height:"100%",position:"absolute",top:0,left:0,display:"flex",flexDirection:"column"},ref:this.props.outerCountainerRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",Object.assign({style:{flex:"1 1 auto",position:"relative",height:"100%",top:0,left:0,backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_16__background_png___default.a+")"}},this.props.containerProps),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Underlay,this.props),this.props.settings.chartType==="candlestick"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Candlestick__["a" /* default */],{candles:this.props.candles,viewportWidth:this.props.width}),this.props.settings.chartType==="bar"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Bar__["a" /* default */],{candles:this.props.candles,viewportWidth:this.props.width}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SurfaceContainer,{id:"surface-container"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{// height: `${chartHeightInPercents}%`,
height:chartHeight+"px"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Surface__["a" /* default */],{width:width,height:height},this.props.settings.chartType==="line"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Line__["a" /* default */],{data:points,width:width,height:height,scaleX:scaleX,scaleY:scaleY,color:lineColor,strokeWidth:settings.lineThickness,displayGradient:false}),settings.indicators.filter(function(indicator){return indicator.enabled!==false;}).map(function(config,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Indicator__["a" /* default */],{key:index,data:points,width:width,height:height,scaleX:scaleX,scaleY:scaleY,config:config,interval:_this2.props.interval});}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__OscillatorVisuals__["b" /* default */],{stock:this.props.stock.stock,width:width,height:oscillatorsHeight+"px",oscillatorHeight:oscillatorHeight,indicators:this.props.settings.indicators,points:points,rawData:this.props.rawData,scaleX:scaleX,scaleY:scaleY,interval:this.props.interval,onHide:function onHide(index){_this2.props.dispatch({type:"TOGGLE_INDICATOR",payload:index});},onRemove:function onRemove(index){return _this2.props.dispatch({type:"REMOVE_INDICATOR",payload:index});},mobile:true})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,Object.assign({},this.props,{lineColor:lineColor,chartHeight:chartHeight}))),this.state.isShownCandleModal&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TradeModals_IntervalsModal__["b" /* default */],{value:this.props.interval,onChange:this.props.onIntervalChange,onToggle:this.toggleCandleModal,stock:this.props.stock}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{position:"absolute",top:0,width:"100%",transition:toolbarForTour?"none":"all 0.5s ease",opacity:this.props.isEngaged||toolbarForTour?1:0,transform:this.props.isEngaged||toolbarForTour?"translateY(30px)":"translateY(-40px)",zIndex:__WEBPACK_IMPORTED_MODULE_21__Layers__["a" /* default */].SENTIMENTS+2}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Toolbar,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{position:"absolute",bottom:0,width:"100%",transition:"all 0.5s ease",opacity:this.props.isEngaged?1:0,transform:this.props.isEngaged?"translateY(0)":"translateY(70px)",zIndex:__WEBPACK_IMPORTED_MODULE_21__Layers__["a" /* default */].SENTIMENTS+1}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__ChartBottomNavigation__["a" /* default */],{loading:this.props.loading,timeSpan:this.props.timeSpan,onTimeSpanChange:this.props.onTimeSpanChange,onBackToReality:this.props.onBackToReality,interval:this.props.interval,onIntervalChange:this.props.onIntervalChange,chartType:this.props.settings.chartType,isShownCandleModal:this.state.isShownCandleModal,toggleCandleModal:this.toggleCandleModal,stock:this.props.stock,now:this.props.lastPoint[2].date})));}}]);return Visuals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Visuals.contextType=__WEBPACK_IMPORTED_MODULE_23__Tour__["a" /* TourContext */];/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Visuals,Object.assign({},props,{theme:theme}));});});

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -2px;\n  left: 4px;\n  transform: translateX(0.5px);\n  height: 0;\n  width: 0;\n\n  ",";\n"],["\n  position: absolute;\n  top: -2px;\n  left: 4px;\n  transform: translateX(0.5px);\n  height: 0;\n  width: 0;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      top: 1px;\n      left: 2px;\n      transform: translateX(0);\n    "],["\n      top: 1px;\n      left: 2px;\n      transform: translateX(0);\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-left: -1px;\n  padding: 4px 6px;\n  font-size: ",";\n  line-height: 1;\n  white-space: nowrap;\n  color: rgba(255, 255, 2555, .7);\n  box-shadow: 0px 0px 1px 0px ",";\n  border-radius: 3px;\n  background: rgba(230, 76, 60, .7);\n  z-index: 2;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: -6px;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-bottom-color: rgba(230, 76, 60, .7);\n    border-top: none;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  top: 16px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-left: -1px;\n  padding: 4px 6px;\n  font-size: ",";\n  line-height: 1;\n  white-space: nowrap;\n  color: rgba(255, 255, 2555, .7);\n  box-shadow: 0px 0px 1px 0px ",";\n  border-radius: 3px;\n  background: rgba(230, 76, 60, .7);\n  z-index: 2;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    top: -6px;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-bottom-color: rgba(230, 76, 60, .7);\n    border-top: none;\n  }\n\n  ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      top: 7px;\n      font-size: ",";\n      border-radius: 2px;\n\n      :before {\n        top: -4px;\n        border-width: 4px;\n      }\n    "],["\n      top: 7px;\n      font-size: ",";\n      border-radius: 2px;\n\n      :before {\n        top: -4px;\n        border-width: 4px;\n      }\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-left: -1px;\n  padding: 4px 6px;\n  font-size: ",";\n  line-height: 1;\n  white-space: nowrap;\n  color: rgba(255, 255, 255, .7);\n  box-shadow: 0px 0px 1px 0px ",";\n  border-radius: 3px;\n  background: ",";\n  z-index: 2;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: -6px;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-top-color: ",";\n    border-bottom: none;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  top: -25px;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin-left: -1px;\n  padding: 4px 6px;\n  font-size: ",";\n  line-height: 1;\n  white-space: nowrap;\n  color: rgba(255, 255, 255, .7);\n  box-shadow: 0px 0px 1px 0px ",";\n  border-radius: 3px;\n  background: ",";\n  z-index: 2;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    left: 50%;\n    bottom: -6px;\n    transform: translateX(-50%);\n    width: 0;\n    height: 0;\n    border: 6px solid transparent;\n    border-top-color: ",";\n    border-bottom: none;\n  }\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      font-size: ",";\n      border-radius: 2px;\n\n      :before {\n        bottom: -4px;\n        border-width: 4px;\n      }\n    "],["\n      font-size: ",";\n      border-radius: 2px;\n\n      :before {\n        bottom: -4px;\n        border-width: 4px;\n      }\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var NegativeContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.main;},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"10px";});});var PositiveContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.main;},function(_ref4){var theme=_ref4.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.upper,.7);},function(_ref5){var theme=_ref5.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.upper,.7);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"10px";});});function Tooltip(_ref7){var children=_ref7.children,mobile=_ref7.mobile,isPositive=_ref7.isPositive;var Container=isPositive?PositiveContainer:NegativeContainer;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,{mobile:mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{isPositive:isPositive,mobile:mobile},children));}/* harmony default export */ __webpack_exports__["a"] = (Tooltip);

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Bar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toolbar_Icons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Profit__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SocialTrading_ToggleSocial__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ChartTypeTabs__ = __webpack_require__(1986);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: center;\n  flex: 1;\n  padding: 0 15px;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  align-content: space-between;\n  align-items: center;\n  flex: 1;\n  padding: 0 15px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin-left: 6px;\n  margin-right: 6px;\n  width: 26px;\n  height: 26px;\n  color: ",";\n  background-color: ",";\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  margin-left: 6px;\n  margin-right: 6px;\n  width: 26px;\n  height: 26px;\n  color: ",";\n  background-color: ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n  @media (max-width: 959px) {\n    background-color: ",";\n    color: blueviolet;\n    border-radius: 4px;\n  }\n"],["\n  @media (max-width: 959px) {\n    background-color: ",";\n    color: blueviolet;\n    border-radius: 4px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Bar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var ToggleSocialLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["a" /* Link */])(_templateObject2,function(_ref){var theme=_ref.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])(theme.foreground,0.7);},function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])("#919191",0.4);});var SettingsLink=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["a" /* Link */])(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_4_polished__["a" /* rgba */])("#919191",0.4));function ToolbarMobile(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/trade",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bar,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__SocialTrading_ToggleSocial__["b" /* default */],{as:ToggleSocialLink,replace:true,to:"/trade/social",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("OPEN_SOCIAL_TRADING");}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__ChartTypeTabs__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SettingsLink,{replace:true,to:"/trade/tools",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("CLICKBTN_SHOW_TRADE_SETTINGS");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_media__["a" /* default */],{query:"(max-width: 479px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Toolbar_Icons__["l" /* InstrumentsIcon */],{width:"18"}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Toolbar_Icons__["l" /* InstrumentsIcon */],{width:"24"});})));}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["e" /* Route */],{path:"/sightseeing",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Bar,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__SocialTrading_ToggleSocial__["b" /* default */],{as:ToggleSocialLink,replace:true,to:"/trade/social",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("OPEN_SOCIAL_TRADING");}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Profit__["a" /* default */],{percentage:90}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Link__["a" /* Link */],{replace:true,to:"/sightseeing/tools",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_9__GA__["a" /* gaReducer */])("CLICKBTN_SHOW_TRADE_SETTINGS");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Toolbar_Icons__["l" /* InstrumentsIcon */],null)));}}));}/* harmony default export */ __webpack_exports__["a"] = (ToolbarMobile);

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icons_Trade_ChartTypeTabs__ = __webpack_require__(1987);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  width: 53px;\n  margin: 0 auto;\n"],["\n  display: flex;\n  justify-content: space-between;\n  width: 53px;\n  margin: 0 auto;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  background-color: ",";\n  color: ",";\n  border: none;\n  border-radius: ",";\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 26px;\n  height: 26px;\n  padding: 0;\n  background-color: ",";\n  color: ",";\n  border: none;\n  border-radius: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var Tab=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var active=_ref.active;return active?"#3B9478":Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#919191",0.4);},function(_ref2){var active=_ref2.active;return active?"#FFFFFF":Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#919191",0.7);},function(_ref3){var left=_ref3.left;return left?"4px 0 0 4px":"0 4px 4px 0";});var ChartTypeTabs=function ChartTypeTabs(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tab,{left:true,active:props.chartType==="candlestick",onClick:function onClick(){props.dispatch({type:"UPDATE_SETTINGS",payload:{chartType:"candlestick"}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_Trade_ChartTypeTabs__["a" /* CandlestickChart */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Tab,{left:false,active:props.chartType==="line",onClick:function onClick(){props.dispatch({type:"UPDATE_SETTINGS",payload:{chartType:"line"}});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icons_Trade_ChartTypeTabs__["b" /* ZoneChart */],null)));};function mapStateToProps(state){return{chartType:state.settings.chartType};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(ChartTypeTabs));

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CandlestickChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ZoneChart; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var CandlestickChart=function CandlestickChart(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"19.998",height:"18.003",viewBox:"0 0 19.998 18.003",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1 0.001)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8983,16741v-2h-4v-2h4v-2h6v2h8v2h-8v2Zm1-7v-2h-5v-2h5v-2h8v2h5v2h-5v2Zm4-7v-2h-9v-2h9v-2h7v2h2v2h-2v2Z",transform:"translate(16740 -8979) rotate(90)"}))));};var ZoneChart=function ZoneChart(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"20",height:"12.98",viewBox:"0 0 20 12.98",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M3.5,18.49l6-6.01,4,4L22,6.92,20.59,5.51,13.5,13.48l-4-4L2,16.99Z",transform:"translate(-2 -5.51)"}));};

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__magnify__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ActiveStock__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NextGenTicks__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Surface__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Line__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Candlestick__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Bar__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Indicator__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__OscillatorVisuals__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Deal__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Dot__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__background_png__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__background_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__background_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Bars__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Arrow__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Sentiments__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ChartBottomNavigation__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__GraphicalTools_HorizontalLine__ = __webpack_require__(1993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__TourHint__ = __webpack_require__(1995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SocialTrading_Desktop__ = __webpack_require__(1996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__OnLine__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__BonusTimer__ = __webpack_require__(1999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__ABTest__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__NextGenChartMath__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__NextGenChartTypes__ = __webpack_require__(45);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"],["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SurfaceContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);function Underlay(props){var start=props.scaleX.invert(0);var finish=props.scaleX.invert(props.width);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__ActiveStock__["a" /* default */],null,props.stock.stock),__WEBPACK_IMPORTED_MODULE_1__FeatureFlags__["a" /* default */].debugHistoryFrames&&props.sections.map(function(section){var _Helpers$getSectionBo=__WEBPACK_IMPORTED_MODULE_26__NextGenChartMath__["i" /* getSectionBoundaries */](section),_Helpers$getSectionBo2=_slicedToArray(_Helpers$getSectionBo,2),from=_Helpers$getSectionBo2[0],to=_Helpers$getSectionBo2[1];var color=props.realtimeThreshold>to?"green":props.realtimeThreshold<=from?"red":"yellow";return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{key:from+"-"+to,style:{position:"absolute",left:Math.floor(props.scaleX(from))+1,right:props.width-Math.floor(props.scaleX(to))+1,top:100,bottom:100,border:"1px solid "+color,color:color}},__WEBPACK_IMPORTED_MODULE_26__NextGenChartMath__["j" /* getSectionKey */](section));}),__WEBPACK_IMPORTED_MODULE_1__FeatureFlags__["a" /* default */].debugHistoryFrames&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Bars__["c" /* VerticalBar */],{x:props.scaleX(props.cursor.date)}),props.emptySections&&typeof props.emptySections.map==="function"&&props.emptySections.map(function(section){var _Helpers$getSectionBo3=__WEBPACK_IMPORTED_MODULE_26__NextGenChartMath__["i" /* getSectionBoundaries */](section),_Helpers$getSectionBo4=_slicedToArray(_Helpers$getSectionBo3,2),from=_Helpers$getSectionBo4[0],to=_Helpers$getSectionBo4[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{key:from+"-"+to,style:{position:"absolute",left:Math.floor(props.scaleX(from))+1,right:props.width-Math.floor(props.scaleX(to))+1,top:100,bottom:100,// border: "1px solid red",
color:props.settings.lineColor,display:"flex",justifyContent:"center",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"The market was closed at this time"));}),__WEBPACK_IMPORTED_MODULE_1__FeatureFlags__["a" /* default */].debugWeekends&&props.checkpoints.filter(function(checkpoint){return checkpoint.value>start&&checkpoint.value<finish;}).map(function(checkpoint){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{key:"checkpoint"+checkpoint.value,style:{position:"relative",top:0,bottom:0,left:props.scaleX(checkpoint.value),borderLeftColor:"red",borderRightColor:"green",borderLeftWidth:checkpoint.type==="negative"?1:0,borderRightWidth:checkpoint.type==="positive"?1:0,borderStyle:"solid"}});}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__NextGenTicks__["a" /* HorizontalTicks */],{scaleX:props.scaleX,ticks:props.scaleX.ticks(6)}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__NextGenTicks__["b" /* VerticalTicks */],{scaleY:props.scaleY,ticks:props.scaleY.ticks(6)}));}function fitsViewport(props,vector){var _vector=_slicedToArray(vector,2),x=_vector[0],y=_vector[1];return x>=0&&x<=props.width&&y>=0&&y<=props.height;}function Overlay(props){var scaleX=props.scaleX,scaleY=props.scaleY,settings=props.settings,lastPoint=props.lastPoint,tradeMode=props.tradeMode,lineColor=props.lineColor;var _ref=lastPoint||[],_ref2=_slicedToArray(_ref,3),lastPointX=_ref2[0],lastPointY=_ref2[1],lastPointSource=_ref2[2];var estimatedDealEndingX=scaleX(lastPointSource.date+settings.currentInterval*1000);var scope=props.settings.chartType==="line"?Object(__WEBPACK_IMPORTED_MODULE_4__magnify__["a" /* default */])(props.points,props.mouseX,function(point,mouseX){return point[0]-mouseX;}):Object(__WEBPACK_IMPORTED_MODULE_4__magnify__["a" /* default */])(props.candles,props.mouseX,function(candle,mouseX){return candle.close[0]-mouseX;});var graphicalTools=props.settings.graphicalTools&&props.settings.graphicalTools[props.stock.stock];var shouldDisplayGraphicalTools=graphicalTools&&graphicalTools.enabled&&graphicalTools.tools&&graphicalTools.tools.length;var ticksHeight=24;var minLevel=scaleY.domain()[0];var maxLevel=scaleY.invert(ticksHeight);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,props.deals.reduce(__WEBPACK_IMPORTED_MODULE_13__Deal__["c" /* dealDuplicatesReducer */],[]).map(function(deal,index,deals){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Deal__["d" /* default */],Object.assign({key:deal.id!=null?deal.id:index.toString(10)},deal,{now:props.time,scaleX:scaleX,scaleY:scaleY,viewportHeight:props.height,viewportWidth:props.width,lastPoint:lastPoint,tradeMode:tradeMode,refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching}));}),lastPoint&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,fitsViewport(props,[lastPointX,0])&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Bars__["c" /* VerticalBar */],{x:lastPointX},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Opening of the trade")),estimatedDealEndingX-lastPointX>20&&fitsViewport(props,[estimatedDealEndingX,0])&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Bars__["c" /* VerticalBar */],{x:estimatedDealEndingX},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Closing of the trade")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Bars__["a" /* HorizontalBar */],{y:lastPointY,viewportHeight:props.height,value:lastPointSource.value}),props.intent&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_17__Arrow__["a" /* default */],{intent:props.intent,x:lastPointX,y:lastPointY,height:props.height})),props.settings.chartType==="line"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__Dot__["a" /* default */],{x:lastPointX,y:lastPointY,color:lineColor}),props.isHovered&&scope&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_16__Bars__["b" /* Scope */],{type:props.settings.chartType,value:scope,scaleX:scaleX,scaleY:scaleY,x:props.mouseX}),props.settings.sentiments&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_18__Sentiments__["a" /* default */],{stats:props.stats}),shouldDisplayGraphicalTools&&graphicalTools.tools.map(function(tool,index){if(tool.enabled===false){return null;}if(tool.anchorValue<minLevel||tool.anchorValue>maxLevel){// Do not display Line if it's not within visible range
return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__GraphicalTools_HorizontalLine__["a" /* default */],{key:index,value:scaleY(tool.anchorValue),color:tool.color,width:tool.width,locked:tool.locked===true,onDragEnd:function onDragEnd(e){e.stopPropagation();e.preventDefault();var clientY=e.type==="touchmove"?e.touches[0].clientY:e.clientY;var SUPER_DUPER_MEGA_CRUTCH_OF_HEAD_HEIGHT_OR_WHATEVER=157;var value=props.scaleY.invert(clientY-(props.rectTop||SUPER_DUPER_MEGA_CRUTCH_OF_HEAD_HEIGHT_OR_WHATEVER));// Stick Line to the border levels
if(value<minLevel){value=minLevel;}else if(value>maxLevel){value=maxLevel;}props.dispatch({type:"UPDATE_GRAPHICAL_TOOL",payload:{stock:tool.stock,index:index,anchorValue:value}});}});}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__OnLine__["b" /* default */],null,function(status){return!status&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_23__OnLine__["a" /* OfflineBadge */],null);}));}var Visuals=function(_React$Component){_inherits(Visuals,_React$Component);function Visuals(){var _ref3;var _temp,_this,_ret;_classCallCheck(this,Visuals);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref3=Visuals.__proto__||Object.getPrototypeOf(Visuals)).call.apply(_ref3,[this].concat(args))),_this),_this.state={isShownCandleModal:false},_this.toggleCandleModal=function(){_this.setState(function(state){return{isShownCandleModal:!state.isShownCandleModal};});},_this.canUpdate=true,_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Visuals,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(){return this.canUpdate;}},{key:"componentDidUpdate",value:function componentDidUpdate(){var _this2=this;this.canUpdate=false;requestAnimationFrame(function(){_this2.canUpdate=true;});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,points=_props.points,width=_props.width,height=_props.height,scaleX=_props.scaleX,scaleY=_props.scaleY,settings=_props.settings,theme=_props.theme;var getOscillatorBlockHeight=function getOscillatorBlockHeight(){return 0;};var getOscillatorHeight=function getOscillatorHeight(){return 0;};if(this.props.oscillators.length){var _oscillatorHeightInPercents=Object(__WEBPACK_IMPORTED_MODULE_12__OscillatorVisuals__["c" /* getOscillatorHeightInPercents */])(this.props.oscillators.length);getOscillatorBlockHeight=function getOscillatorBlockHeight(height){return Object(__WEBPACK_IMPORTED_MODULE_12__OscillatorVisuals__["d" /* getRelativeHeight */])(height,_oscillatorHeightInPercents);};getOscillatorHeight=function getOscillatorHeight(height){return Math.floor(height/_this3.props.oscillators.length);};}var oscillatorsHeight=getOscillatorBlockHeight(height);var chartHeight=height-oscillatorsHeight;var chartHeightInPercents=Math.floor(chartHeight*100/height);var oscillatorHeightInPercents=100-chartHeightInPercents;var oscillatorHeight=getOscillatorHeight(oscillatorsHeight);var lineColor=settings.lineColor===theme.background?theme.foreground:settings.lineColor;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{cursor:this.props.graphicalMode.graphicalTool!=null?"crosshair":"default",width:"100%",height:"100%",position:"absolute",top:0,left:0,display:"flex",flexDirection:"column"},ref:this.props.outerCountainerRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",Object.assign({style:{display:"flex",flex:1,position:"relative",backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_15__background_png___default.a+")"}},this.props.containerProps),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Underlay,this.props),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{width:width,height:height,position:"absolute",overflow:"hidden"}},this.props.settings.chartType==="candlestick"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Candlestick__["a" /* default */],{candles:this.props.candles,viewportWidth:this.props.width}),this.props.settings.chartType==="bar"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Bar__["a" /* default */],{candles:this.props.candles,viewportWidth:this.props.width}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SurfaceContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{style:{height:chartHeightInPercents+"%",marginBottom:-47}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Surface__["a" /* default */],{width:width,height:chartHeight},this.props.settings.chartType==="line"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Line__["a" /* default */],{data:points,width:width,height:chartHeight,scaleX:scaleX,scaleY:scaleY,color:lineColor,strokeWidth:settings.lineThickness,displayGradient:true}),settings.indicators.filter(function(indicator){return indicator.enabled!==false;}).map(function(config,index){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__Indicator__["a" /* default */],{key:index,data:points,width:width,height:chartHeight,scaleX:scaleX,scaleY:scaleY,config:config,interval:_this3.props.interval});}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__OscillatorVisuals__["b" /* default */],{stock:this.props.stock.stock,width:width,height:oscillatorHeightInPercents+"%",oscillatorHeight:oscillatorHeight,indicators:this.props.settings.indicators,points:points,rawData:this.props.rawData,scaleX:scaleX,scaleY:scaleY,interval:this.props.interval,mouseX:this.props.mouseX,isHovered:this.props.isHovered,onEdit:this.props.onEditIndicator,onHide:function onHide(index){_this3.props.dispatch({type:"TOGGLE_INDICATOR",payload:index});},onRemove:function onRemove(index){return _this3.props.dispatch({type:"REMOVE_INDICATOR",payload:index});}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Overlay,Object.assign({},this.props,{lineColor:lineColor}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__TourHint__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_25__ABTest__["a" /* default */],{campaign:"first_deposit_bonus"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_24__BonusTimer__["a" /* default */],null)),this.props.interactive&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__ChartBottomNavigation__["a" /* default */],{social:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__SocialTrading_Desktop__["a" /* default */],null),loading:this.props.loading,timeSpan:this.props.timeSpan,onTimeSpanChange:this.props.onTimeSpanChange,onBackToReality:this.props.onBackToReality,interval:this.props.interval,onIntervalChange:this.props.onIntervalChange,chartType:this.props.settings.chartType,isShownCandleModal:this.state.isShownCandleModal,toggleCandleModal:this.toggleCandleModal,stock:this.props.stock,now:this.props.lastPoint[2].date}));}}]);return Visuals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeConsumer */],null,function(theme){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Visuals,Object.assign({},props,{theme:theme}));});});

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Arrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_up_png__ = __webpack_require__(1990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__button_up_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__button_up_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_down_png__ = __webpack_require__(1991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__button_down_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__button_down_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ArrowTiny__ = __webpack_require__(1992);
var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 140px;\n\n  ","\n\n  ","\n"],["\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 140px;\n\n  ","\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    top: -140px;\n    background-color: rgba(96,163,28,0.1);\n    background: linear-gradient(to top, rgba(96,163,28,0.1) 0%, rgba(255,255,255,0) 100%);\n  "],["\n    top: -140px;\n    background-color: rgba(96,163,28,0.1);\n    background: linear-gradient(to top, rgba(96,163,28,0.1) 0%, rgba(255,255,255,0) 100%);\n  "]),_templateObject3=_taggedTemplateLiteral(["\n    top: 0;\n    background-color: rgba(230,76,60,0.1);\n    background: linear-gradient(to bottom, rgba(230,76,60,0.1) 0%, rgba(255,255,255,0) 100%);\n  "],["\n    top: 0;\n    background-color: rgba(230,76,60,0.1);\n    background: linear-gradient(to bottom, rgba(230,76,60,0.1) 0%, rgba(255,255,255,0) 100%);\n  "]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  left: 0;\n  height: 140px;\n  width: 200px;\n\n  ","\n\n  ","\n"],["\n  position: relative;\n  left: 0;\n  height: 140px;\n  width: 200px;\n\n  ","\n\n  ","\n"]),_templateObject5=_taggedTemplateLiteral(["\n    background-image: url(",");\n  "],["\n    background-image: url(",");\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.intent==="CAST_UP"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);},function(props){return props.intent==="CAST_DOWN"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3);});var ArrowView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(props){return props.intent==="CAST_UP"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,__WEBPACK_IMPORTED_MODULE_2__button_up_png___default.a);},function(props){return props.intent==="CAST_DOWN"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5,__WEBPACK_IMPORTED_MODULE_3__button_down_png___default.a);});function Arrow(_ref){var intent=_ref.intent,x=_ref.x,y=_ref.y,height=_ref.height;if(intent===""){return null;}var positionX=Math.floor(x);var positionY=Math.floor(y);var heightMinusArrows=height-positionY;var showTiny=heightMinusArrows<140||heightMinusArrows>height-140;var ArrowComponent=showTiny?__WEBPACK_IMPORTED_MODULE_4__ArrowTiny__["a" /* default */]:ArrowView;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{intent:intent,style:{WebkitTransform:"translateY("+positionY+"px)",transform:"translateY("+positionY+"px)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowComponent,{intent:intent,style:{WebkitTransform:"translateX("+positionX+"px)",transform:"translateX("+positionX+"px)"}}));}/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 1990 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1991 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  left: 0;\n  width: 50px;\n  height: 52px;\n\n  ","\n"],["\n  position: relative;\n  left: 0;\n  width: 50px;\n  height: 52px;\n\n  ","\n"]),_templateObject2=_taggedTemplateLiteral(["\n    top: 88px;\n  "],["\n    top: 88px;\n  "]),_templateObject3=_taggedTemplateLiteral(["\n  ","\n\n  ","\n"],["\n  ","\n\n  ","\n"]),_templateObject4=_taggedTemplateLiteral(["\n    fill: ",";\n  "],["\n    fill: ",";\n  "]),_templateObject5=_taggedTemplateLiteral(["\n    fill: rgb(230,76,60);\n  "],["\n    fill: rgb(230,76,60);\n  "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ArrowView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.intent==="CAST_UP"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var PathView=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].path(_templateObject3,function(props){return props.intent==="CAST_UP"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,function(props){return props.theme.upper;});},function(props){return props.intent==="CAST_DOWN"&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject5);}));function Svg(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"50px",height:"52px",fillRule:"evenodd"},children);}function Path(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PathView,props);}var Arrow=__WEBPACK_IMPORTED_MODULE_0_react__["memo"](function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowView,props,props.intent==="CAST_UP"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{intent:props.intent,d:"M47.936,4.610 L0.570,51.975 L0.573,48.642 L46.270,2.945 L46.268,2.943 L47.936,4.610 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{intent:props.intent,fillOpacity:0.259,d:"M44.989,51.024 L44.989,11.187 L46.179,9.997 L46.177,9.995 L46.989,9.183 L46.989,50.997 L44.989,51.024 ZM39.988,16.188 L41.989,14.187 L41.989,50.994 L39.988,50.995 L39.988,16.188 ZM34.988,21.188 L36.988,19.188 L36.988,50.987 L34.988,50.988 L34.988,21.188 ZM29.987,26.189 L31.987,24.188 L31.987,50.988 L29.987,51.019 L29.987,26.189 ZM24.987,31.189 L26.987,29.189 L26.987,50.988 L24.987,51.020 L24.987,31.189 ZM19.986,36.190 L21.986,34.189 L21.986,50.989 L19.986,51.020 L19.986,36.190 ZM14.986,41.190 L16.986,39.190 L16.986,50.989 L14.986,50.990 L14.986,41.190 ZM9.985,46.191 L11.985,44.191 L11.985,51.021 L9.985,50.990 L9.985,46.191 ZM4.985,50.628 L6.985,48.628 L6.985,51.021 L4.985,50.990 L4.985,50.628 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{intent:props.intent,d:"M36.997,0.981 L50.008,0.981 L50.008,13.991 L36.997,0.981 Z"})):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Svg,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{intent:props.intent,d:"M47.936,47.952 L0.570,0.587 L0.573,3.920 L46.270,49.617 L46.268,49.619 L47.936,47.952 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{intent:props.intent,fillOpacity:0.259,d:"M46.177,43.568 L46.179,43.565 L44.989,42.375 L44.989,1.992 L46.989,2.019 L46.989,44.380 L46.177,43.568 ZM39.988,2.022 L41.989,2.022 L41.989,39.375 L39.988,37.375 L39.988,2.022 ZM34.988,2.029 L36.988,2.029 L36.988,34.374 L34.988,32.374 L34.988,2.029 ZM29.987,1.997 L31.987,2.028 L31.987,29.374 L29.987,27.374 L29.987,1.997 ZM24.987,1.996 L26.987,2.028 L26.987,24.373 L24.987,22.373 L24.987,1.996 ZM19.986,1.996 L21.986,2.027 L21.986,19.373 L19.986,17.373 L19.986,1.996 ZM14.986,2.027 L16.986,2.027 L16.986,14.372 L14.986,12.372 L14.986,2.027 ZM9.985,2.026 L11.985,1.995 L11.985,9.372 L9.985,7.372 L9.985,2.026 ZM4.985,2.026 L6.985,1.995 L6.985,7.976 L4.985,5.975 L4.985,2.026 Z"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Path,{intent:props.intent,d:"M36.997,51.988 L50.008,51.988 L50.008,38.977 L36.997,51.988 Z"})));});/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripesUp_svg__ = __webpack_require__(1994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StripesUp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__StripesUp_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  height: ","px;\n  width: 100%;\n  position: absolute;\n  background-color: ",";\n\n  :hover {\n    box-shadow: 0 0 2px 1px ",";\n  }\n"],["\n  height: ","px;\n  width: 100%;\n  position: absolute;\n  background-color: ",";\n\n  :hover {\n    box-shadow: 0 0 2px 1px ",";\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  width: ","px;\n  height: ","px;\n  border-radius: 5px;\n  background-color: ",";\n  position: absolute;\n  top: -4px;\n  right: -50%;\n  left: 50%;\n  border: 1px solid ","\n\n  :hover {\n    background-color: ","\n    box-shadow: 0 0 2px 1px ",";\n    border-color: ",";\n  }\n\n  :hover:before {\n    content: \"\";\n    position: absolute;\n    top: -","px;\n    left: ","px;\n    width: 10px;\n    height: 12px;\n    background: url(",") no-repeat;\n  }\n\n  :hover:after {\n    content: \"\";\n    position: absolute;\n    top: ","px;\n    left: ","px;\n    width: 10px;\n    height: 12px;\n    background: url(",") no-repeat;\n    transform: scaleY(-1);\n  }\n"],["\n  width: ","px;\n  height: ","px;\n  border-radius: 5px;\n  background-color: ",";\n  position: absolute;\n  top: -4px;\n  right: -50%;\n  left: 50%;\n  border: 1px solid ","\n\n  :hover {\n    background-color: ","\n    box-shadow: 0 0 2px 1px ",";\n    border-color: ",";\n  }\n\n  :hover:before {\n    content: \"\";\n    position: absolute;\n    top: -","px;\n    left: ","px;\n    width: 10px;\n    height: 12px;\n    background: url(",") no-repeat;\n  }\n\n  :hover:after {\n    content: \"\";\n    position: absolute;\n    top: ","px;\n    left: ","px;\n    width: 10px;\n    height: 12px;\n    background: url(",") no-repeat;\n    transform: scaleY(-1);\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Line=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.width||2;},function(props){return props.color;},function(props){return props.color;});var Handler=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return parseInt(props.width,10)+8;},function(props){return parseInt(props.width,10)+8;},function(props){return props.theme.mainDark;},function(props){return props.color;},function(props){return props.color;},function(props){return props.color;},function(props){return props.theme.mainDark;},function(props){return parseInt(props.width,10)+19;},function(props){return 2%parseInt(props.width,10)?"0":"-1";},__WEBPACK_IMPORTED_MODULE_2__StripesUp_svg___default.a,function(props){return parseInt(props.width,10)+14;},function(props){return 2%parseInt(props.width,10)?"0":"-1";},__WEBPACK_IMPORTED_MODULE_2__StripesUp_svg___default.a);var HorizontalLine=function(_React$Component){_inherits(HorizontalLine,_React$Component);function HorizontalLine(){var _ref;var _temp,_this,_ret;_classCallCheck(this,HorizontalLine);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=HorizontalLine.__proto__||Object.getPrototypeOf(HorizontalLine)).call.apply(_ref,[this].concat(args))),_this),_this.onMouseDown=function(e){// Set some data for ChartEventHandlers to use
e.target.isDragHandleDown=true;e.target.dragHandleHandler=_this.props.onDragEnd;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(HorizontalLine,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){if(nextProps.color!==this.props.color||nextProps.width!==this.props.width||nextProps.locked!==this.props.locked||nextProps.value!==this.props.value){return true;}return false;}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Line,{color:this.props.color,width:this.props.width,style:{transform:"translateY("+this.props.value+"px)"}},!this.props.locked&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Handler,{onMouseDown:this.onMouseDown,onTouchStart:this.onMouseDown,color:this.props.color,width:this.props.width}));}}]);return HorizontalLine;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (HorizontalLine);;

/***/ }),
/* 1994 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/StripesUp.44cbeed5.svg";

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_pose__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icons_Info__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tour__ = __webpack_require__(44);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background-color: ",";\n  background-clip: padding-box;\n  border-top-left-radius: 50%;\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n  transition: inherit;\n  z-index: 2;\n"],["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  background-color: ",";\n  background-clip: padding-box;\n  border-top-left-radius: 50%;\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n  transition: inherit;\n  z-index: 2;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 100px;\n  left: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  height: 30px;\n  padding-left: 25px;\n  text-decoration: none;\n  transition: all ","ms ease-in-out;\n  opacity: 0.6;\n\n  "," {\n    color: #919191;\n  }\n\n  :hover {\n    opacity: 1;\n\n    "," {\n      color: ",";\n    }\n  }\n"],["\n  position: absolute;\n  top: 100px;\n  left: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  height: 30px;\n  padding-left: 25px;\n  text-decoration: none;\n  transition: all ","ms ease-in-out;\n  opacity: 0.6;\n\n  "," {\n    color: #919191;\n  }\n\n  :hover {\n    opacity: 1;\n\n    "," {\n      color: ",";\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  flex-grow: 1;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  height: 100%;\n  margin-left: -4px;\n  padding-left: 4px;\n  box-sizing: border-box;\n  transform-origin: left bottom;\n  overflow: hidden;\n  z-index: 1;\n"],["\n  position: relative;\n  flex-grow: 1;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  height: 100%;\n  margin-left: -4px;\n  padding-left: 4px;\n  box-sizing: border-box;\n  transform-origin: left bottom;\n  overflow: hidden;\n  z-index: 1;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n  margin-left: -13px;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 100%;\n  width: 17px;\n  overflow: hidden;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    box-shadow: 0px 0px 0px 50px\n      ",";\n  }\n"],["\n  position: relative;\n  margin-left: -13px;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 100%;\n  width: 17px;\n  overflow: hidden;\n\n  :before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    right: 0;\n    transform: translateY(-50%);\n    width: 34px;\n    height: 34px;\n    border-radius: 50%;\n    box-shadow: 0px 0px 0px 50px\n      ",";\n  }\n"]),_templateObject5=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  height: 100%;\n  padding-left: 4px;\n  padding-right: 10px;\n  font-size: ",";\n  white-space: nowrap;\n  color: ",";\n  background-color: ",";\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  height: 100%;\n  padding-left: 4px;\n  padding-right: 10px;\n  font-size: ",";\n  white-space: nowrap;\n  color: ",";\n  background-color: ",";\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var duration=200;// in ms
var InfoTourIcon=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_8__Icons_Info__["a" /* InfoTour */])(_templateObject,function(_ref){var theme=_ref.theme;return theme.background;});var Hint=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject2,duration,InfoTourIcon,InfoTourIcon,function(_ref2){var theme=_ref2.theme;return theme.upper;});var _Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Scoop=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].i(_templateObject4,function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?"#fff":"rgba(255, 255, 255, 0.1)";});var Text=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12),function(_ref4){var theme=_ref4.theme;return theme.accent;},function(_ref5){var theme=_ref5.theme;return theme.mode==="light"?"#fff":"rgba(255, 255, 255, 0.1)";});var Content=Object(__WEBPACK_IMPORTED_MODULE_3_react_pose__["b" /* default */])(_Content)({enter:{x:0,scaleX:1,transition:{duration:duration,ease:"easeInOut"}},exit:{x:-17,scaleX:0,originX:0,originY:"50%",transition:{duration:duration,ease:"easeInOut"}}});var TourHint=function TourHint(props){var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),_React$useState2=_slicedToArray(_React$useState,2),visible=_React$useState2[0],setVisibitily=_React$useState2[1];var session_count=props.profile.session_count;var tour=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__Tour__["a" /* TourContext */]);if(session_count>3||tour!=null){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Hint,{to:"/sightseeing",onMouseEnter:function onMouseEnter(){return setVisibitily(true);},onMouseLeave:function onMouseLeave(){return setVisibitily(false);},onClick:function onClick(){return Object(__WEBPACK_IMPORTED_MODULE_6__GA__["a" /* gaReducer */])("ACTIVATE_TOUR_FROM_ICON");}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoTourIcon,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_pose__["a" /* PoseGroup */],null,visible&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,{key:"content"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Scoop,null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Start Welcome Tour")))));};var mapStateToProps=function mapStateToProps(state){return{profile:state.profile};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(TourHint));

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Items__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Social__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ToggleSocial__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Icons_ArrowRight__ = __webpack_require__(1998);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  margin-left: 16px;\n  color: ",";\n"],["\n  margin-left: 16px;\n  color: ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  align-content: flex-end;\n  justify-content: flex-end;\n  height: 50px;\n  margin-left: auto;\n  padding-right: 16px;\n  font-size: ",";\n  white-space: nowrap;\n  color: ",";\n  cursor: pointer;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n\n    "," {\n      color: ",";\n    }\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  align-content: flex-end;\n  justify-content: flex-end;\n  height: 50px;\n  margin-left: auto;\n  padding-right: 16px;\n  font-size: ",";\n  white-space: nowrap;\n  color: ",";\n  cursor: pointer;\n  text-decoration: underline;\n\n  :hover {\n    text-decoration: none;\n\n    "," {\n      color: ",";\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: ",";\n  opacity: ",";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 256px;\n  background-color: ",";\n  box-shadow: 3px 3px 5px 0px ",";\n  z-index: 200;\n  transition: .5s;\n\n  @media (max-width: 959px) {\n    position: fixed;\n    height: auto;\n    bottom: 0;\n  }\n"],["\n  position: absolute;\n  top: 0;\n  left: ",";\n  opacity: ",";\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 256px;\n  background-color: ",";\n  box-shadow: 3px 3px 5px 0px ",";\n  z-index: 200;\n  transition: .5s;\n\n  @media (max-width: 959px) {\n    position: fixed;\n    height: auto;\n    bottom: 0;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ArrowIconContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])("#919191",0.59));var HideSocial=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12),function(_ref){var theme=_ref.theme;return theme.accent;},ArrowIconContainer,function(_ref2){var theme=_ref2.theme;return theme.foreground;});var SidebarContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.isOpen?"0":"-256px";},function(props){return props.isOpen?"1":"0";},function(_ref3){var theme=_ref3.theme;return theme.main;},function(_ref4){var theme=_ref4.theme;return Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])(theme.mainDark,0.5);});function SocialTrading(){var _React$useContext=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_9__ToggleSocial__["a" /* SocialTradingContext */]),_React$useContext2=_slicedToArray(_React$useContext,2),isOpen=_React$useContext2[0],toggleOpen=_React$useContext2[1];return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(min-width: 960px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SidebarContainer,{isOpen:isOpen},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Social__["b" /* default */],{hide:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HideSocial,{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaReducer */])("CLOSE_SOCIAL_TRADING");return toggleOpen(false);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Hide trader activity"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__Icons_ArrowRight__["a" /* default */],null)))},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Items__["a" /* default */],null)));}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__ToggleSocial__["b" /* default */],{onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaReducer */])(isOpen===true?"CLOSE_SOCIAL_TRADING":"OPEN_SOCIAL_TRADING");return toggleOpen(!isOpen);},isOpen:isOpen}));}/* harmony default export */ __webpack_exports__["a"] = (SocialTrading);

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Flag__ = __webpack_require__(174);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: inline-block;\n  position: relative;\n  box-sizing: border-box;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  z-index: 2;\n\n  &&& {\n    width: 22px;\n    height: 22px;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 0;\n  display: inline-block;\n  position: relative;\n  box-sizing: border-box;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n  border-radius: 50%;\n  border: 2px solid currentColor;\n  z-index: 2;\n\n  &&& {\n    width: 22px;\n    height: 22px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  ",";\n  bottom: 0;\n  z-index: 1;\n\n  &&& {\n    width: 18px;\n    height: 18px;\n  }\n"],["\n  position: absolute;\n  ",";\n  bottom: 0;\n  z-index: 1;\n\n  &&& {\n    width: 18px;\n    height: 18px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Flag=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_3__common_Flag__["c" /* CurrencyFlag */])(_templateObject);var SecondFlag=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(Flag)(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_2__common_styled_mixins__["c" /* rtl */])("right",0));var customFlags={bch:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["a" /* BchImage */],btc:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["b" /* BtcImage */],eth:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["d" /* EthImage */],ltc:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["f" /* LtcImage */],xag:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["g" /* SilverImage */],silver:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["g" /* SilverImage */],xau:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["e" /* GoldImage */],gold:__WEBPACK_IMPORTED_MODULE_3__common_Flag__["e" /* GoldImage */]};var StockFlags=function StockFlags(_ref){var stock=_ref.stock;var currency1=stock.toLowerCase().substring(0,3);var currency2=stock.toLowerCase().substring(3);if(customFlags[stock]){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{style:{backgroundImage:"url("+customFlags[stock]+")"}});}if(customFlags[currency1]){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{style:{backgroundImage:"url("+customFlags[currency1]+")"}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{as:SecondFlag,currency:currency2}));}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{currency:currency1}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Flag,{as:SecondFlag,currency:currency2}));};/* harmony default export */ __webpack_exports__["a"] = (StockFlags);

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var ArrowRight=function ArrowRight(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"6.295",height:"9.8",viewBox:"0 0 6.295 9.8"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M5,.328l4.9,4.9-1.4,1.4L5,3.119l-3.5,3.5L.1,5.219,4.986.328,5,.337Z",transform:"translate(-0.328 9.9) rotate(-90)",fill:"currentColor"}));};/* harmony default export */ __webpack_exports__["a"] = (ArrowRight);

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_pose__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hooks_useBonusTimer__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Timers__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CloseOutlined__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CloseOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CloseOutlined__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icons_BonusTimer__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icons_Info__ = __webpack_require__(221);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 160px;\n  left: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  padding-left: 25px;\n  text-decoration: none;\n  z-index: 5;\n"],["\n  position: absolute;\n  bottom: 160px;\n  left: 0;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: flex-start;\n  justify-content: flex-start;\n  padding-left: 25px;\n  text-decoration: none;\n  z-index: 5;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: block;\n  position: relative;\n  width: 120px;\n  height: 120px;\n  color: #ffcc00;\n  text-decoration: none;\n"],["\n  display: block;\n  position: relative;\n  width: 120px;\n  height: 120px;\n  color: #ffcc00;\n  text-decoration: none;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  user-select: none;\n"],["\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  user-select: none;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  z-index: 2;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  z-index: 2;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-weight: 900;\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #272b34;\n  z-index: 3;\n"],["\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-weight: 900;\n  line-height: 1.2;\n  text-transform: uppercase;\n  color: #272b34;\n  z-index: 3;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  max-width: 98px;\n  padding-top: 0.25em;\n  font-size: ",";\n  text-align: center;\n"],["\n  max-width: 98px;\n  padding-top: 0.25em;\n  font-size: ",";\n  text-align: center;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  font-size: 24px;\n"],["\n  font-size: 24px;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #919191;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 4;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: absolute;\n  top: -2px;\n  right: -2px;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  font-size: 13px;\n  color: #919191;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 4;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  align-self: flex-start;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding: 0 10px;\n  padding-top: 5px;\n  color: ",";\n"],["\n  align-self: flex-start;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding: 0 10px;\n  padding-top: 5px;\n  color: ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding-left: 8px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  padding-left: 8px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n"]),_templateObject11=_taggedTemplateLiteral([""],[""]),_templateObject12=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n\n  "," {\n    cursor: pointer;\n  }\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n\n  "," {\n    cursor: pointer;\n  }\n"]),_templateObject13=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: -6px;\n  transform: translateY(9px);\n  min-width: 250px;\n  padding: 6px;\n  font-size: ",";\n  line-height: 1.2;\n  border-radius: 6px;\n  background-color: ",";\n  color: #fff;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    bottom: 100%;\n    left: 7px;\n    border: 8px solid transparent;\n    border-bottom: 8px solid ",";\n    border-top: none;\n  }\n"],["\n  position: absolute;\n  top: 100%;\n  left: -6px;\n  transform: translateY(9px);\n  min-width: 250px;\n  padding: 6px;\n  font-size: ",";\n  line-height: 1.2;\n  border-radius: 6px;\n  background-color: ",";\n  color: #fff;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    bottom: 100%;\n    left: 7px;\n    border: 8px solid transparent;\n    border-bottom: 8px solid ",";\n    border-top: none;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject);var Badge=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_5__common_Link__["a" /* Link */])(_templateObject2);var BadgeLayer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject3);var RadialTimerContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(BadgeLayer)(_templateObject4);var BadgeContent=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(BadgeLayer)(_templateObject5);var Title=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].h3(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(16));var Percent=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].p(_templateObject7);var CloseContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject8,function(_ref){var theme=_ref.theme;return theme.foreground;});var TimerContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#919191",0.59));var Timer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject10,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(11),function(_ref2){var theme=_ref2.theme;return theme.accent;});var InfoIcon=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_13__Icons_Info__["b" /* default */])(_templateObject11);var InfoTooltip=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject12,InfoIcon);var _Tooltip=__WEBPACK_IMPORTED_MODULE_2_react_pose__["b" /* default */].div({enter:{opacity:1,transition:{duration:300}},exit:{opacity:0,transition:{duration:300}}});var Tooltip=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(_Tooltip)(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["a" /* fontSize */])(12),Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#919191",0.59),Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])("#919191",0.59));var BonusTimer=function BonusTimer(_ref3){var time=_ref3.time;var _React$useState=__WEBPACK_IMPORTED_MODULE_0_react__["useState"](false),_React$useState2=_slicedToArray(_React$useState,2),showTooltip=_React$useState2[0],toggleTooltip=_React$useState2[1];var tour=__WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_10__Tour__["a" /* TourContext */]);var _useBonusTimerStorage=Object(__WEBPACK_IMPORTED_MODULE_8__hooks_useBonusTimer__["b" /* useBonusTimerStorage */])(),_useBonusTimerStorage2=_slicedToArray(_useBonusTimerStorage,2),showTimer=_useBonusTimerStorage2[0],toggleTimer=_useBonusTimerStorage2[1];var bonus=Object(__WEBPACK_IMPORTED_MODULE_8__hooks_useBonusTimer__["a" /* useBonusTimerApi */])({time:time});if(showTimer===false||tour!==null||bonus==null||bonus.duration<0||bonus.status!=="available"){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseContainer,{onClick:function onClick(){return toggleTimer(false);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CloseOutlined___default.a,{fontSize:"inherit",color:"inherit"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Badge,{to:"/fillup?promocode="+bonus.promo},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Icons_BonusTimer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](RadialTimerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__Timers__["a" /* RadialTimer */],{width:102,strokeWidth:7,progress:bonus.progress,full:{stroke:"rgba(0,0,0,.1)"},stroke:"#A34141"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BadgeContent,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Bonus")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Percent,null,"+",bonus.percent,"%"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TimerContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoTooltip,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InfoIcon,{onMouseEnter:function onMouseEnter(){return toggleTooltip(true);},onMouseLeave:function onMouseLeave(){return toggleTooltip(false);}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_pose__["a" /* PoseGroup */],null,showTooltip&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tooltip,{key:"tooltip"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Gettext__["b" /* default */],null,"Get your special registration bonus for any deposit before the timer stops counting!")))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Timer,null,bonus.ticker)));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_9__Timers__["b" /* mapStateToTime */])(BonusTimer));

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Orientation__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TradeControls_TradeControls__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TradeControls_History__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TradeControls_Settings__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TradeControls_Buttons__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TradeControls_Icons__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TradeModals_TradeIsClosing__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Tournaments_Api__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Trade_OperationCheque__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__FeatureFlags__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Icons_Trade_LeftArrow__ = __webpack_require__(2012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Profit__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Protection_ProtectionInfo__ = __webpack_require__(783);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-content: flex-start;\n  align-items: flex-start;\n"],["\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  align-content: flex-start;\n  align-items: flex-start;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: auto;\n  background-color: ",";\n  flex-grow: 1;\n  flex-shrink: 1;\n\n  @media (max-width: 479px) {\n    display: block;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  height: auto;\n  background-color: ",";\n  flex-grow: 1;\n  flex-shrink: 1;\n\n  @media (max-width: 479px) {\n    display: block;\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  justify-content: space-between;\n  align-content: space-between;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 82px;\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n\n  @media (max-width: 479px) {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    width: 100%;\n    height: auto;\n    overflow: hidden;\n  }\n"],["\n  position: relative;\n  justify-content: space-between;\n  align-content: space-between;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 82px;\n  width: 100%;\n  height: auto;\n  overflow: hidden;\n\n  @media (max-width: 479px) {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    width: 100%;\n    height: auto;\n    overflow: hidden;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 40px;\n  width: calc(50% - 80px);\n  height: 100%;\n  overflow: auto;\n"],["\n  position: absolute;\n  top: 0;\n  right: 40px;\n  width: calc(50% - 80px);\n  height: 100%;\n  overflow: auto;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  width: 100%;\n  overflow: auto;\n\n  @media (max-width: 479px) {\n    display: flex;\n    flex-direction: column;\n    flex: 0;\n  }\n"],["\n  width: 100%;\n  overflow: auto;\n\n  @media (max-width: 479px) {\n    display: flex;\n    flex-direction: column;\n    flex: 0;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  flex-direction: row;\n  flex-grow: 0;\n  flex-shrink: 1;\n  flex-basis: 45px;\n  width: 100%;\n  min-height: 45px;\n\n  @media (min-width: 480px) {\n    flex-basis: 38px;\n    min-height: 38px;\n  }\n"],["\n  flex-direction: row;\n  flex-grow: 0;\n  flex-shrink: 1;\n  flex-basis: 45px;\n  width: 100%;\n  min-height: 45px;\n\n  @media (min-width: 480px) {\n    flex-basis: 38px;\n    min-height: 38px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: relative;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 50%;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-content: center;\n  align-items: center;\n  font-weight: 300;\n  font-size: ",";\n  height: 45px;\n  text-transform: uppercase;\n  color: #99959d;\n  background-color: ",";\n  cursor: pointer;\n\n  @media (min-width: 480px) {\n    justify-content: center;\n    height: 38px;\n  }\n\n  @media (min-width: 480px) and (max-height: 289px) {\n    height: 38px;\n  }\n\n  ",";\n"],["\n  position: relative;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 50%;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-content: center;\n  align-items: center;\n  font-weight: 300;\n  font-size: ",";\n  height: 45px;\n  text-transform: uppercase;\n  color: #99959d;\n  background-color: ",";\n  cursor: pointer;\n\n  @media (min-width: 480px) {\n    justify-content: center;\n    height: 38px;\n  }\n\n  @media (min-width: 480px) and (max-height: 289px) {\n    height: 38px;\n  }\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      color: ",";\n      background-color: ",";\n    "],["\n      color: ",";\n      background-color: ",";\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  position: relative;\n  align-self: center;\n\n  @media (max-width: 479px) {\n    position: absolute;\n    top: 50%;\n    left: 21px;\n    transform: translateY(-50%);\n  }\n"],["\n  position: relative;\n  align-self: center;\n\n  @media (max-width: 479px) {\n    position: absolute;\n    top: 50%;\n    left: 21px;\n    transform: translateY(-50%);\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  margin-left: 59px;\n\n  @media (min-width: 480px) {\n    display: none;\n    margin-left: 0;\n  }\n"],["\n  margin-left: 59px;\n\n  @media (min-width: 480px) {\n    display: none;\n    margin-left: 0;\n  }\n"]),_templateObject11=_taggedTemplateLiteral(["\n  width: 100%;\n  padding: 0 16px;\n\n  @media (max-width: 479px) {\n    padding: 10px 15px 0;\n  }\n\n  ",";\n"],["\n  width: 100%;\n  padding: 0 16px;\n\n  @media (max-width: 479px) {\n    padding: 10px 15px 0;\n  }\n\n  ",";\n"]),_templateObject12=_taggedTemplateLiteral(["\n      opacity: 0.4;\n      pointer-events: none;\n    "],["\n      opacity: 0.4;\n      pointer-events: none;\n    "]),_templateObject13=_taggedTemplateLiteral(["\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  width: 100%;\n  flex: 0 0 auto;\n  padding: 8px 15px;\n\n  @media (min-width: 480px) {\n    justify-content: space-between;\n    align-content: space-between;\n    flex-basis: 92px;\n    min-height: 92px;\n    padding: 5px 16px;\n  }\n\n  ",";\n\n  ",";\n\n  :before {\n    ",";\n\n    ",";\n  }\n"],["\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n  text-align: center;\n  width: 100%;\n  flex: 0 0 auto;\n  padding: 8px 15px;\n\n  @media (min-width: 480px) {\n    justify-content: space-between;\n    align-content: space-between;\n    flex-basis: 92px;\n    min-height: 92px;\n    padding: 5px 16px;\n  }\n\n  ",";\n\n  ",";\n\n  :before {\n    ",";\n\n    ",";\n  }\n"]),_templateObject14=_taggedTemplateLiteral(["\n      box-shadow: 0px -13px 26px 0px ",";\n      z-index: 2;\n    "],["\n      box-shadow: 0px -13px 26px 0px ",";\n      z-index: 2;\n    "]),_templateObject15=_taggedTemplateLiteral(["\n        position: absolute;\n        left: ",";\n        top: ",";\n        right: 10px;\n        bottom: 9px;\n        border-radius: ",";\n        ",";\n        content: \"\";\n      "],["\n        position: absolute;\n        left: ",";\n        top: ",";\n        right: 10px;\n        bottom: 9px;\n        border-radius: ",";\n        ",";\n        content: \"\";\n      "]),_templateObject16=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 100%;\n  align-self: stretch;\n  width: 100%;\n  margin: 0 auto;\n\n  @media (max-width: 959px) {\n    margin: 0;\n  }\n  @media (max-width: 479px) {\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 50%;\n    width: 50%;\n    align-self: center;\n\n    :first-of-type {\n      padding-right: 8px;\n    }\n    :last-of-type {\n      padding-left: 8px;\n    }\n  }\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 100%;\n  align-self: stretch;\n  width: 100%;\n  margin: 0 auto;\n\n  @media (max-width: 959px) {\n    margin: 0;\n  }\n  @media (max-width: 479px) {\n    flex-grow: 1;\n    flex-shrink: 1;\n    flex-basis: 50%;\n    width: 50%;\n    align-self: center;\n\n    :first-of-type {\n      padding-right: 8px;\n    }\n    :last-of-type {\n      padding-left: 8px;\n    }\n  }\n"]),_templateObject17=_taggedTemplateLiteral(["\n  position: relative;\n  margin: auto;\n  padding: 4px 16px;\n  font-weight: 400;\n  font-size: ",";\n  text-align: center;\n  color: #99959d;\n\n  @media (max-width: 479px) {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: center;\n  }\n"],["\n  position: relative;\n  margin: auto;\n  padding: 4px 16px;\n  font-weight: 400;\n  font-size: ",";\n  text-align: center;\n  color: #99959d;\n\n  @media (max-width: 479px) {\n    display: flex;\n    align-content: center;\n    align-items: center;\n    justify-content: center;\n  }\n"]),_templateObject18=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  color: ",";\n  cursor: default;\n\n  ",";\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px;\n  color: ",";\n  cursor: default;\n\n  ",";\n"]),_templateObject19=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject20=_taggedTemplateLiteral(["\n  margin-right: 7px;\n  font-size: 0;\n  line-height: 0;\n  color: inherit;\n  opacity: 0.4;\n"],["\n  margin-right: 7px;\n  font-size: 0;\n  line-height: 0;\n  color: inherit;\n  opacity: 0.4;\n"]),_templateObject21=_taggedTemplateLiteral(["\n  @media (max-width: 359px) {\n    padding-top: 0;\n  }\n"],["\n  @media (max-width: 359px) {\n    padding-top: 0;\n  }\n"]),_templateObject22=_taggedTemplateLiteral(["\n  position: absolute;\n  left: 5px;\n  top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 59px;\n  padding: 0;\n  color: #b5b7be;\n  background-color: transparent;\n  border: none;\n  z-index: 1;\n\n  ",";\n\n  ",";\n"],["\n  position: absolute;\n  left: 5px;\n  top: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 30px;\n  height: 59px;\n  padding: 0;\n  color: #b5b7be;\n  background-color: transparent;\n  border: none;\n  z-index: 1;\n\n  ",";\n\n  ",";\n"]),_templateObject23=_taggedTemplateLiteral(["\n      left: auto;\n      right: 5px;\n      transform: rotate(180deg);\n    "],["\n      left: auto;\n      right: 5px;\n      transform: rotate(180deg);\n    "]),_templateObject24=_taggedTemplateLiteral(["\n      opacity: 0.5;\n    "],["\n      opacity: 0.5;\n    "]),_templateObject25=_taggedTemplateLiteral(["\n  width: 100%;\n  text-align: center;\n  padding-bottom: ",";\n\n  @media (max-width: 479px) {\n    align-self: flex-end;\n    padding-top: ",";\n  }\n\n  ",";\n"],["\n  width: 100%;\n  text-align: center;\n  padding-bottom: ",";\n\n  @media (max-width: 479px) {\n    align-self: flex-end;\n    padding-top: ",";\n  }\n\n  ",";\n"]),_templateObject26=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  width: 200%;\n  overflow: hidden;\n  transition: transform 0.1s ease;\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  width: 200%;\n  overflow: hidden;\n  transition: transform 0.1s ease;\n  ",";\n"]),_templateObject27=_taggedTemplateLiteral(["\n      transform: translateX(",");\n    "],["\n      transform: translateX(",");\n    "]),_templateObject28=_taggedTemplateLiteral(["\n  flex: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  width: 50%;\n  min-width: 50%;\n  margin: 0 auto;\n  opacity: 1;\n  ",";\n"],["\n  flex: 1;\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  width: 50%;\n  min-width: 50%;\n  margin: 0 auto;\n  opacity: 1;\n  ",";\n"]),_templateObject29=_taggedTemplateLiteral(["\n      opacity: 0;\n      transition: opacity 0.1s ease;\n    "],["\n      opacity: 0;\n      transition: opacity 0.1s ease;\n    "]),_templateObject30=_taggedTemplateLiteral(["\n  width: 50%;\n  min-width: 50%;\n  margin: 0 auto;\n  opacity: 1;\n  ",";\n"],["\n  width: 50%;\n  min-width: 50%;\n  margin: 0 auto;\n  opacity: 1;\n  ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Flex=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject);var Container=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject2,function(props){return props.theme.mainLight;});var Content=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject3);var DealsInner=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject4);var DealsContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject5);var TabsContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject6);var TabView=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.theme.mainDark;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject8,function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.theme.mainLight;});});var SvgContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject9);var Title=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject10);var SettingsContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_9__TradeControls_Settings__["a" /* default */])(_templateObject11,function(_ref2){var disabled=_ref2.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject12);});var ButtonContainer=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(Flex)(_templateObject13,function(props){return props.deals&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject14,function(props){return props.theme.mainLight;});},function(_ref3){var disabled=_ref3.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject12);},function(_ref4){var tourBorder=_ref4.tourBorder,isLandscape=_ref4.isLandscape;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject15,isLandscape?0:"10px",isLandscape?0:0,isLandscape?"6px 0 0 0":0,tourBorder.border);},function(_ref5){var tourBorderAnimation=_ref5.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation(tourBorderAnimation.keyframe);});var ButtonWrapper=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject16);var ClockContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject17,Object(__WEBPACK_IMPORTED_MODULE_15__common_styled_mixins__["a" /* fontSize */])(12));var Clock=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject18,function(_ref6){var theme=_ref6.theme;return theme.foreground;},function(props){return props.timeOtc&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject19,function(_ref7){var theme=_ref7.theme;return theme.accent;});});var ClockIcon=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject20);var ClockText=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject21);var SlideButtonContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].button(_templateObject22,function(_ref8){var right=_ref8.right;return right&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject23);},function(_ref9){var disabled=_ref9.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject24);});var ProfitContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject25,function(_ref10){var showClock=_ref10.showClock;return showClock?0:"7px";},function(_ref11){var showClock=_ref11.showClock;return showClock?0:"7px";},function(_ref12){var disabled=_ref12.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject12);});// settings | deals
var AnimateContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject26,function(_ref13){var tab=_ref13.tab;return tab&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject27,tab==="settings"?0:"-50%");});var SettingsAnimateContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject28,function(_ref14){var showTab=_ref14.showTab;return showTab==="deals"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject29);});var DealsAnimateContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject30,function(_ref15){var showTab=_ref15.showTab;return showTab==="settings"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["c" /* css */])(_templateObject29);});var SlideButton=function SlideButton(_ref16){var onClick=_ref16.onClick,right=_ref16.right,disabled=_ref16.disabled;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SlideButtonContainer,{right:right,onClick:onClick,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_19__Icons_Trade_LeftArrow__["a" /* default */],{width:"10px"}));};function Tab0(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabView,{active:props.active,onClick:props.onClick,ref:props.forwardedRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SvgContainer,null,props.Icon),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Title,null,props.title));}var Tab=__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab0,Object.assign({},props,{forwardedRef:ref}));});var TradeControlTabs=function(_React$Component){_inherits(TradeControlTabs,_React$Component);function TradeControlTabs(){var _ref17;var _temp,_this,_ret;_classCallCheck(this,TradeControlTabs);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref17=TradeControlTabs.__proto__||Object.getPrototypeOf(TradeControlTabs)).call.apply(_ref17,[this].concat(args))),_this),_this.state={repetitive:0,specialAnimation:false,activeTab:"settings",tourInterval:30},_this.setActiveTabClick=function(key){if(key!==_this.state.activeTab){key==="settings"?Object(__WEBPACK_IMPORTED_MODULE_18__GA__["a" /* gaReducer */])("CLICK_MOBILE_SETTINGS"):Object(__WEBPACK_IMPORTED_MODULE_18__GA__["a" /* gaReducer */])("CLICK_MOBILE_DEALS");}_this.setActiveTab(key);},_this.setActiveTab=function(key){if(key===_this.state.activeTab){return _this.setState({repetitive:_this.state.repetitive+1,specialAnimation:true});}_this.setState({activeTab:key,specialAnimation:false});},_this.setNextTab=function(){_this.state.activeTab==="settings"?_this.setState({activeTab:"deals",showTab:"deals",specialAnimation:false}):_this.setState({activeTab:"settings",showTab:"settings",specialAnimation:false});},_this.handleSettingsUpdate=function(nextSettings){_this.props.dispatch({type:"UPDATE_SETTINGS",payload:nextSettings});},_this.original=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](null),_this.originalDeals=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](null),_this.originalDealsTab=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](null),_this.settingsRef=__WEBPACK_IMPORTED_MODULE_0_react__["createRef"](null),_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TradeControlTabs,[{key:"_submit",value:function _submit(type){var _props=this.props,currentBid=_props.currentBid,currentInterval=_props.currentInterval,point=_props.point,accountType=_props.accountType;type==="UP"?Object(__WEBPACK_IMPORTED_MODULE_18__GA__["a" /* gaReducer */])("CLICKBTN_UPPER_BET"):Object(__WEBPACK_IMPORTED_MODULE_18__GA__["a" /* gaReducer */])("CLICKBTN_LOWER_BET");if(!point){return;// Или может throw?
}this.props.onSubmit({id:null,time:1337,percent:null,bidType:type==="UP",amount:currentBid,bTime:currentInterval,stock:point.stock,value:point.value,accountType:accountType,timestamp:Number(point.date/1000),open_timestamp:Number(point.date/1000),date:point.date});}},{key:"render",value:function render(){var _this2=this;var _props2=this.props,activeAccount=_props2.activeAccount,deals=_props2.deals,percentBids=_props2.percentBids,suggestedBids=_props2.suggestedBids,percentBidThreshold=_props2.percentBidThreshold,possibleIntervals=_props2.possibleIntervals,currentBid=_props2.currentBid,currentInterval=_props2.currentInterval,maxBidVolume=_props2.maxBidVolume,showIncreaseBidLimitMessage=_props2.showIncreaseBidLimitMessage,accountType=_props2.accountType,tradeMode=_props2.tradeMode,showTournamentRefill=_props2.showTournamentRefill,active_tournament=_props2.active_tournament,isDealAmountValid=_props2.isDealAmountValid,validateDealAmount=_props2.validateDealAmount,disabled=_props2.disabled,dealsToCompensate=_props2.dealsToCompensate,compensationUpdated=_props2.compensationUpdated,compensationCreated=_props2.compensationCreated,onCompensationCreated=_props2.onCompensationCreated;var tourInterval=this.state.tourInterval;var id=__WEBPACK_IMPORTED_MODULE_2_idx___default()(active_tournament,function(t){return t.value.id;});if(tradeMode==="tournament"&&id!=null&&showTournamentRefill===true){var redirect="/trade/tournaments/refill/"+id;if(this.props.location.pathname!==redirect){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["d" /* Redirect */],{to:redirect});}}var TABS=[{key:"settings",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Settings"),Icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__TradeControls_Icons__["c" /* SettingsIcon */],null)},{key:"deals",title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Deals"),Icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__TradeControls_Icons__["b" /* DealsIcon */],null)}];// TODO: Показываем часы и красим их в жёлтый
var showClock=this.props.timeUntilNextLockToggle<1000*60*60*12;var timeOtc=this.props.stock.otc;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 479px)"},function(matches){return matches?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["a" /* default */],null,function(screen){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,tradeMode==="binary"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__Protection_ProtectionInfo__["a" /* default */],{isDesktop:false,dealsToCompensate:dealsToCompensate,compensationUpdated:compensationUpdated,compensationCreated:compensationCreated,onCompensationCreated:onCompensationCreated,activeAccount:activeAccount}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SlideButton,{onClick:_this2.setNextTab,disabled:_this2.state.activeTab==="settings"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SlideButton,{onClick:_this2.setNextTab,right:true,disabled:_this2.state.activeTab==="deals"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](AnimateContainer,{tab:_this2.state.activeTab},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SettingsAnimateContainer,{key:"settings",showTab:_this2.state.showTab,ref:_this2.settingsRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SettingsContainer,{tradeMode:tradeMode,activeAccount:activeAccount,percentBids:percentBids,suggestedBids:suggestedBids,possibleIntervals:possibleIntervals,percentBidThreshold:percentBidThreshold,currentBid:currentBid,currentInterval:currentInterval,onSettingsUpdate:_this2.handleSettingsUpdate,showIncreaseBidLimitMessage:showIncreaseBidLimitMessage,isActiveAccountReal:accountType==="real",maxBidVolume:maxBidVolume,isDealAmountValid:isDealAmountValid,validateDealAmount:validateDealAmount,tourInterval:tourInterval,onTourIntervalChange:function onTourIntervalChange(value){_this2.setState({tourInterval:value});},disabled:disabled},showClock&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClockContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Clock,{timeOtc:timeOtc},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClockIcon,{timeOtc:timeOtc},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"-5651.999 5637.688 15.997 20.001",width:"16",height:"20",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M1238-12037.673a7.953,7.953,0,0,1,2.35-5.649l-.9-1.264a.493.493,0,0,1,.118-.692l1.318-.932a.5.5,0,0,1,.7.118l.889,1.252a7.939,7.939,0,0,1,2.262-.717v-.514a.6.6,0,0,0-.6-.6h-.33a.6.6,0,0,1-.6-.6v-1.823a.6.6,0,0,1,.6-.6h4.385a.6.6,0,0,1,.6.6v1.823a.6.6,0,0,1-.6.6h-.33a.6.6,0,0,0-.6.6v.514a7.854,7.854,0,0,1,2.12.65l.9-1.268a.5.5,0,0,1,.7-.117l1.318.934a.5.5,0,0,1,.121.693l-.877,1.233a7.948,7.948,0,0,1,2.462,5.758,8,8,0,0,1-8,7.983A8,8,0,0,1,1238-12037.673Zm1.92,0a6.078,6.078,0,0,0,6.078,6.066,6.081,6.081,0,0,0,6.081-6.066,6.083,6.083,0,0,0-6.081-6.069A6.081,6.081,0,0,0,1239.922-12037.673Zm6.039-.042v-4.96l.039,0a5.016,5.016,0,0,1,5.014,4.963Z",transform:"translate(-6890 17687.379)"}))),Object(__WEBPACK_IMPORTED_MODULE_12__TradeModals_TradeIsClosing__["b" /* formatTimeInterval */])(_this2.props.timeUntilNextLockToggle)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 479px), (min-width: 640px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClockText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"left till the market closure"));}}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProfitContainer,{showClock:showClock},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_21__Profit__["a" /* default */],{percentage:90}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealsAnimateContainer,{key:"deals"+_this2.state.repetitive,showTab:_this2.state.showTab},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealsInner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealsContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref18){var showModal=_ref18.showModal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__TradeControls_History__["c" /* default */],{tradeMode:tradeMode,mobile:true,deals:deals,now:_this2.props.now,point:_this2.props.point,pointsByStock:_this2.props.pointsByStock,onOperationClick:function onOperationClick(operation){if(__WEBPACK_IMPORTED_MODULE_17__FeatureFlags__["a" /* default */].OperationCheque&&operation.profit!=null){showModal(__WEBPACK_IMPORTED_MODULE_16__Trade_OperationCheque__["a" /* default */],{operation:operation,type:tradeMode});}else{_this2.props.dispatch({type:"SWITCH_TO_STOCK",payload:operation.stock});}},refundClickHandler:_this2.props.refundClickHandler,refundFetching:_this2.props.refundFetching});}))))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Tour__["b" /* default */],{step:"makeDeal",originalRef:_this2.original},function(_ref19){var next=_ref19.next,isOriginal=_ref19.isOriginal,tour=_ref19.tour;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContainer,{tourBorder:!isOriginal&&tour&&tour.borderStyles,tourBorderAnimation:!isOriginal&&tour&&tour.outside&&tour.borderStyles,isLandscape:false,deals:_this2.state.activeTab==="deals",ref:isOriginal?_this2.original:null,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TradeControls_Buttons__["b" /* CastUp */],{onClick:function onClick(){if(isOriginal){_this2._submit("UP");}else{next(["UP",currentBid,tourInterval]);}}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TradeControls_Buttons__["a" /* CastDown */],{onClick:function onClick(){if(isOriginal){_this2._submit("DOWN");}else{next(["DOWN",currentBid,tourInterval]);}}})));})));}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__common_Orientation__["a" /* default */],null,function(screen){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TabsContainer,null,TABS.map(function(tab){var title=tab.title,key=tab.key,Icon=tab.Icon;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Tour__["b" /* default */],{step:"chartWithDeals",originalRef:_this2.originalDealsTab,withoutStyles:true,disabledTooltip:true,dealsTab:true},function(_ref20){var next=_ref20.next,isOriginal=_ref20.isOriginal;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tab,{ref:isOriginal?_this2.originalDealsTab:null,title:title,key:key,active:isOriginal?key===_this2.state.activeTab:"deals",Icon:Icon,onClick:isOriginal?function(){return _this2.setActiveTabClick(key);}:function(){return void 0;}});});})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Content,null,tradeMode==="binary"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_22__Protection_ProtectionInfo__["a" /* default */],{isDesktop:false,isLandscape:true,dealsToCompensate:dealsToCompensate,compensationUpdated:compensationUpdated,compensationCreated:compensationCreated,onCompensationCreated:onCompensationCreated,activeAccount:activeAccount}),_this2.state.activeTab==="settings"&&(_this2.context==null||_this2.context.step!=="chartWithDeals")?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SettingsContainer,{tradeMode:tradeMode,activeAccount:activeAccount,percentBids:percentBids,suggestedBids:suggestedBids,possibleIntervals:possibleIntervals,percentBidThreshold:percentBidThreshold,currentBid:currentBid,currentInterval:currentInterval,onSettingsUpdate:_this2.handleSettingsUpdate,showIncreaseBidLimitMessage:showIncreaseBidLimitMessage,isActiveAccountReal:accountType==="real",maxBidVolume:maxBidVolume,isDealAmountValid:isDealAmountValid,validateDealAmount:validateDealAmount,tourInterval:tourInterval,onTourIntervalChange:function onTourIntervalChange(value){_this2.setState({tourInterval:value});},disabled:disabled},showClock&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClockContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Clock,{timeOtc:timeOtc},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClockIcon,{timeOtc:timeOtc},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"-5651.999 5637.688 15.997 20.001",width:"16",height:"20",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:"M1238-12037.673a7.953,7.953,0,0,1,2.35-5.649l-.9-1.264a.493.493,0,0,1,.118-.692l1.318-.932a.5.5,0,0,1,.7.118l.889,1.252a7.939,7.939,0,0,1,2.262-.717v-.514a.6.6,0,0,0-.6-.6h-.33a.6.6,0,0,1-.6-.6v-1.823a.6.6,0,0,1,.6-.6h4.385a.6.6,0,0,1,.6.6v1.823a.6.6,0,0,1-.6.6h-.33a.6.6,0,0,0-.6.6v.514a7.854,7.854,0,0,1,2.12.65l.9-1.268a.5.5,0,0,1,.7-.117l1.318.934a.5.5,0,0,1,.121.693l-.877,1.233a7.948,7.948,0,0,1,2.462,5.758,8,8,0,0,1-8,7.983A8,8,0,0,1,1238-12037.673Zm1.92,0a6.078,6.078,0,0,0,6.078,6.066,6.081,6.081,0,0,0,6.081-6.066,6.083,6.083,0,0,0-6.081-6.069A6.081,6.081,0,0,0,1239.922-12037.673Zm6.039-.042v-4.96l.039,0a5.016,5.016,0,0,1,5.014,4.963Z",transform:"translate(-6890 17687.379)"}))),Object(__WEBPACK_IMPORTED_MODULE_12__TradeModals_TradeIsClosing__["b" /* formatTimeInterval */])(_this2.props.timeUntilNextLockToggle)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 479px), (min-width: 640px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ClockText,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"left till the market closure"));}}))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Tour__["b" /* default */],{step:"chartWithDeals",originalRef:_this2.originalDeals,withoutStyles:true,withMobileArrow:true,dealsContainer:true},function(_ref21){var next=_ref21.next,isOriginal=_ref21.isOriginal,isTourMode=_ref21.isTourMode;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](DealsContainer,{ref:_this2.originalDeals},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_14__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref22){var showModal=_ref22.showModal;return!isTourMode?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__TradeControls_History__["c" /* default */],{tradeMode:tradeMode,mobile:true,deals:deals,now:_this2.props.now,point:_this2.props.point,pointsByStock:_this2.props.pointsByStock,onOperationClick:isOriginal?function(operation){if(__WEBPACK_IMPORTED_MODULE_17__FeatureFlags__["a" /* default */].OperationCheque&&operation.profit!=null){showModal(__WEBPACK_IMPORTED_MODULE_16__Trade_OperationCheque__["a" /* default */],{operation:operation,type:tradeMode});}else{_this2.props.dispatch({type:"SWITCH_TO_STOCK",payload:operation.stock});}}:function(){return void 0;},refundClickHandler:_this2.props.refundClickHandler,refundFetching:_this2.props.refundFetching}):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",{ref:_this2.originalDeals,style:{pointerEvents:"none"}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__TradeControls_TradeControls__["a" /* ArtificialTourDeals */],{mobile:true}));}));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_20__Tour__["b" /* default */],{step:"makeDeal",originalRef:_this2.original},function(_ref23){var next=_ref23.next,isOriginal=_ref23.isOriginal,tour=_ref23.tour;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonContainer,{tourBorder:!isOriginal&&tour&&tour.borderStyles,tourBorderAnimation:!isOriginal&&tour&&tour.outside&&tour.borderStyles,isLandscape:true,deals:_this2.state.activeTab==="deals",ref:isOriginal?_this2.original:null,disabled:disabled},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TradeControls_Buttons__["b" /* CastUp */],{onClick:function onClick(){if(isOriginal){_this2._submit("UP");}else{next(["UP",currentBid,tourInterval]);}}})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ButtonWrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__TradeControls_Buttons__["a" /* CastDown */],{onClick:function onClick(){if(isOriginal){_this2._submit("DOWN");}else{next(["DOWN",currentBid,tourInterval]);}}})));})));});});}}]);return TradeControlTabs;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);TradeControlTabs.contextType=__WEBPACK_IMPORTED_MODULE_20__Tour__["a" /* TourContext */];/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["g" /* withRouter */])(function(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_13__Tournaments_Api__["a" /* ActiveTournament */],null,function(active_tournament){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TradeControlTabs,Object.assign({},props,{active_tournament:active_tournament,ref:props.controlsRef}));});}));

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Icons__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex-shrink: 0;\n  flex-grow: 0;\n  align-self: flex-start;\n  width: 100%;\n  padding: 18px 0;\n  padding-left: 28px;\n  padding-right: 18px;\n  color: #99959d;\n  cursor: pointer;\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n"],["\n  position: relative;\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  flex-shrink: 0;\n  flex-grow: 0;\n  align-self: flex-start;\n  width: 100%;\n  padding: 18px 0;\n  padding-left: 28px;\n  padding-right: 18px;\n  color: #99959d;\n  cursor: pointer;\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  background-color: ",";\n"],["\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n  background-color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 12px;\n  color: ","\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-right: 12px;\n  color: ","\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 10px;\n  height: 10px;\n  margin-left: auto;\n  transform: rotate(0deg) translateX(-50%);\n  transform-origin: 0;\n  transition: transform 0.2s linear;\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 10px;\n  height: 10px;\n  margin-left: auto;\n  transform: rotate(0deg) translateX(-50%);\n  transform-origin: 0;\n  transition: transform 0.2s linear;\n\n  ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n      transform: rotate(-180deg) translateX(-50%);\n    "],["\n      transform: rotate(-180deg) translateX(-50%);\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  user-select: none;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: ",";\n  line-height: 1;\n  text-transform: uppercase;\n  user-select: none;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var SectionTitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(_ref2){var theme=_ref2.theme;return theme.foreground;});});var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref3){var theme=_ref3.theme;return theme.mainLight;});var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref4){var theme=_ref4.theme;return theme.dealIconColor;});var ArrowContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject6);});var TextContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_3__common_styled_mixins__["a" /* fontSize */])(12));function toggle(state){return{isOpen:!state.isOpen};}var CollapsibleSection=function(_React$Component){_inherits(CollapsibleSection,_React$Component);function CollapsibleSection(){var _ref5;var _temp,_this,_ret;_classCallCheck(this,CollapsibleSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref5=CollapsibleSection.__proto__||Object.getPrototypeOf(CollapsibleSection)).call.apply(_ref5,[this].concat(args))),_this),_this.state={isOpen:Boolean(_this.props.isOpenByDefault)},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CollapsibleSection,[{key:"render",value:function render(){var _this2=this;var _props=this.props,title=_props.title,Icon=_props.Icon,children=_props.children;var isOpen=this.state.isOpen;if(typeof children!=="function"){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](SectionTitle,{id:"title-container",active:isOpen,onClick:function onClick(){return _this2.setState(toggle);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,null)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](TextContainer,null,title),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ArrowContainer,{active:isOpen},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__Icons__["a" /* ArrowIcon */],null))),children({isOpen:isOpen}));}}]);return CollapsibleSection;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CollapsibleSection);

/***/ }),
/* 2002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(24);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(279));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), _react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
})), 'Close');

exports.default = _default;

/***/ }),
/* 2003 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array ? array.length : 0;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * Checks if a cache value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    Set = getNative(root, 'Set'),
    nativeCreate = getNative(Object, 'create');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values ? values.length : 0;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each
 * element is kept.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length)
    ? baseUniq(array)
    : [];
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = uniq;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(27)))

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = Options;
/* harmony export (immutable) */ __webpack_exports__["a"] = Option;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  transform: translateY(-50%);\n  border: 4px solid transparent;\n  border-top-color: #99959d;\n  border-bottom: none;\n  z-index: 20;\n"],["\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  transform: translateY(-50%);\n  border: 4px solid transparent;\n  border-top-color: #99959d;\n  border-bottom: none;\n  z-index: 20;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n"],["\n  position: relative;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding: 6px 9px 5px;\n  font-size: ",";\n  color: ",";\n  border: 1px solid ",";\n  border-radius: 4px;\n  background: ",";\n  box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08);\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  padding: 6px 9px 5px;\n  font-size: ",";\n  color: ",";\n  border: 1px solid ",";\n  border-radius: 4px;\n  background: ",";\n  box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08);\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n      ",";\n    "],["\n      ",";\n    "]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  overflow: auto;\n  margin-top: -2px;\n  padding: 8px 0;\n  font-size: ",";\n  color: ",";\n  background: ",";\n  border-top: 1px solid #696969;\n  z-index: 1337;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    max-height: 85px;\n  }\n\n  @media (max-width: 479px) {\n    top: auto;\n    bottom: 100%;\n  }\n"],["\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  overflow: auto;\n  margin-top: -2px;\n  padding: 8px 0;\n  font-size: ",";\n  color: ",";\n  background: ",";\n  border-top: 1px solid #696969;\n  z-index: 1337;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n    max-height: 85px;\n  }\n\n  @media (max-width: 479px) {\n    top: auto;\n    bottom: 100%;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  padding: 4px 10px;\n  cursor: pointer;\n\n  :hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n    font-size: ",";\n  }\n"],["\n  padding: 4px 10px;\n  cursor: pointer;\n\n  :hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  ",";\n\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n    font-size: ",";\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n      background: rgba(255, 255, 255, 0.1);\n    "],["\n      background: rgba(255, 255, 255, 0.1);\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var DropdownButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var SelectView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var Value=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(16),function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.theme.borderMainColor;},function(props){return props.theme.mainDark;},function(_ref2){var tourBorder=_ref2.tourBorder;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4,tourBorder.border);},function(_ref3){var tourBorderAnimation=_ref3.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation(tourBorderAnimation.keyframe);});var OptionList=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(16),function(_ref4){var theme=_ref4.theme;return theme.foreground;},function(props){return props.theme.mainDark;},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(16));var OptionView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject7);},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(16));var contextTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,currentInterval:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number};function toggle(state){return{isOpen:!state.isOpen};}var Select=function(_Component){_inherits(Select,_Component);function Select(){var _ref5;var _temp,_this,_ret;_classCallCheck(this,Select);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref5=Select.__proto__||Object.getPrototypeOf(Select)).call.apply(_ref5,[this].concat(args))),_this),_this.state={isOpen:false},_this.handleChange=function(nextValue){_this.setState({isOpen:false});_this.props.onChange(nextValue);},_this.collapse=function(){_this.setState({isOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Select,[{key:"getChildContext",value:function getChildContext(){return{value:this.props.value,onChange:this.handleChange,currentInterval:this.props.currentInterval};}},{key:"render",value:function render(){var _this2=this;var _props=this.props,value=_props.value,children=_props.children,currentInterval=_props.currentInterval;var isOpen=this.state.isOpen;var options=isOpen&&typeof children==="function"?children():null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_ClickOutside__["a" /* default */],{onOutsideClick:this.collapse},function(_ref6){var innerRef=_ref6.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectView,{ref:innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownButton,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,{tourBorder:!_this2.props.isOriginal&&_this2.props.tour&&_this2.props.tour.borderStyles,tourBorderAnimation:!_this2.props.isOriginal&&_this2.props.tour&&_this2.props.tour.outside&&_this2.props.tour.borderStyles,onClick:function onClick(){_this2.setState(toggle);}},value," ",currentInterval&&currentInterval<60?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"sec"):currentInterval<120||currentInterval>600?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"min"):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"mins")),options);});}}]);return Select;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);Select.childContextTypes=contextTypes;/* harmony default export */ __webpack_exports__["c"] = (Select);function Options(_ref7){var children=_ref7.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionList,null,children);}function Option(_ref8,_ref9){var children=_ref8.children,value=_ref8.value;var selectValue=_ref9.selectValue,onChange=_ref9.onChange;var meaningfulValue=typeof value!=="undefined"?value:children;var isActive=meaningfulValue===selectValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionView,{active:isActive,onClick:function onClick(){onChange(meaningfulValue);}},children);}Option.contextTypes=contextTypes;

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Options */
/* unused harmony export Option */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  ",";\n\n  ",";\n"],["\n  ",";\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      border-radius: 6px;\n      ",";\n    "],["\n      border-radius: 6px;\n      ",";\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  transform: translateY(-50%);\n  border: 4px solid transparent;\n  border-top-color: #99959d;\n  border-bottom: none;\n  z-index: 20;\n"],["\n  position: absolute;\n  top: 50%;\n  right: 9px;\n  transform: translateY(-50%);\n  border: 4px solid transparent;\n  border-top-color: #99959d;\n  border-bottom: none;\n  z-index: 20;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: relative;\n"],["\n  position: relative;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  padding: 6px 9px 5px;\n  font-size: 16px;\n  color: ",";\n  border: 1px solid ",";\n  border-radius: 4px;\n  background: ",";\n  box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08);\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n  }\n"],["\n  position: relative;\n  width: 100%;\n  padding: 6px 9px 5px;\n  font-size: 16px;\n  color: ",";\n  border: 1px solid ",";\n  border-radius: 4px;\n  background: ",";\n  box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08);\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n      border-color: ",";\n      box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08),\n        inset 0px 0px 0px 2px ",";\n    "],["\n      border-color: ",";\n      box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08),\n        inset 0px 0px 0px 2px ",";\n    "]),_templateObject7=_taggedTemplateLiteral(["\n  padding-top: 4px;\n  padding-bottom: 1px;\n  margin: 0;\n  line-height: 1;\n  font-family: Roboto, sans-serif;\n\n  @media (max-width: 959px) {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n"],["\n  padding-top: 4px;\n  padding-bottom: 1px;\n  margin: 0;\n  line-height: 1;\n  font-family: Roboto, sans-serif;\n\n  @media (max-width: 959px) {\n    padding-top: 5px;\n    padding-bottom: 5px;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  overflow: auto;\n  padding: 8px 0;\n  color: ",";\n  background: ",";\n  z-index: 1337;\n\n  @media (max-width: 959px) {\n    font-size: 16px;\n  }\n"],["\n  position: absolute;\n  top: 100%;\n  width: 100%;\n  overflow: auto;\n  padding: 8px 0;\n  color: ",";\n  background: ",";\n  z-index: 1337;\n\n  @media (max-width: 959px) {\n    font-size: 16px;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  padding: 4px 18px;\n  cursor: pointer;\n\n  :hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  ",";\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n    font-size: 16px;\n  }\n"],["\n  padding: 4px 18px;\n  cursor: pointer;\n\n  :hover {\n    background: rgba(255, 255, 255, 0.1);\n  }\n\n  ",";\n  @media (max-width: 959px) {\n    padding: 5px 8px 5px;\n    font-size: 16px;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n      background: rgba(255, 255, 255, 0.1);\n    "],["\n      background: rgba(255, 255, 255, 0.1);\n    "]),_templateObject11=_taggedTemplateLiteral(["\n  & span span {\n    font-size: ",";\n    color: #99959d;\n\n    @media (max-width: 959px) {\n      font-size: ",";\n    }\n  }\n"],["\n  & span span {\n    font-size: ",";\n    color: #99959d;\n\n    @media (max-width: 959px) {\n      font-size: ",";\n    }\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(_ref){var tourBorder=_ref.tourBorder;return tourBorder&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2,tourBorder.border);},function(_ref2){var tourBorderAnimation=_ref2.tourBorderAnimation;return tourBorderAnimation&&tourBorderAnimation.animation();});var DropdownButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3);// prettier-ignore
var SelectView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject4);var Value=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5,function(_ref3){var theme=_ref3.theme;return theme.foreground;},function(props){return props.theme.borderMainColor;},function(props){return props.theme.mainDark;},function(_ref4){var invalid=_ref4.invalid,theme=_ref4.theme;return invalid&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6,theme.lower,theme.lower);});var ValueInput=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Value)(_templateObject7);var OptionList=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject8,function(_ref5){var theme=_ref5.theme;return theme.foreground;},function(props){return props.theme.mainDark;});var OptionView=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject9,function(props){return props.active&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);});var Money=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Money__["b" /* default */])(_templateObject11,function(_ref6){var theme=_ref6.theme;return theme.locale==="ar"?theme.minFontSize:"14px";},function(_ref7){var theme=_ref7.theme;return theme.locale==="ar"?theme.minFontSize:"12px";});var contextTypes={value:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,onChange:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func};var SelectWithInput=function(_Component){_inherits(SelectWithInput,_Component);function SelectWithInput(){var _ref8;var _temp,_this,_ret;_classCallCheck(this,SelectWithInput);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref8=SelectWithInput.__proto__||Object.getPrototypeOf(SelectWithInput)).call.apply(_ref8,[this].concat(args))),_this),_this.state={isOpen:false},_this.handleChange=function(nextValue){_this.setState({isOpen:false});_this.props.onChange(nextValue);},_this.handleInputChange=function(event){_this.props.onChange(event.target.value);},_this.handleKeyPress=function(event){if(event.key==="Enter"){_this.collapse();event.preventDefault();}},_this.collapse=function(){_this.setState({isOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SelectWithInput,[{key:"getChildContext",value:function getChildContext(){return{value:this.props.value,onChange:this.handleChange};}},{key:"render",value:function render(){var _this2=this;var _props=this.props,value=_props.value,children=_props.children,invalid=_props.invalid;var isOpen=this.state.isOpen;var options=isOpen&&typeof children==="function"?children():null;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{tourBorder:!this.props.isOriginal&&this.props.tour&&this.props.tour.borderStyles,tourBorderAnimation:!this.props.isOriginal&&this.props.tour&&this.props.tour.outside&&this.props.tour.borderStyles},isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_ClickOutside__["a" /* default */],{onOutsideClick:this.collapse},function(_ref9){var innerRef=_ref9.innerRef;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(SelectView,{ref:innerRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownButton,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ValueInput,{as:"input",ref:function ref(input){return input&&input.focus();},type:"tel",value:value,invalid:invalid,onChange:_this2.handleInputChange,onKeyPress:_this2.handleKeyPress,disabled:_this2.props.disabled}),options);}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Value,{onClick:function onClick(){_this2.setState({isOpen:true});},invalid:invalid},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DropdownButton,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Money,{currency:this.props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__["b" /* tournamentCurrency */]:null},value)));}}]);return SelectWithInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);SelectWithInput.childContextTypes=contextTypes;/* harmony default export */ __webpack_exports__["a"] = (SelectWithInput);function Options(_ref10){var children=_ref10.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionList,null,children);}function Option(_ref11,_ref12){var children=_ref11.children,value=_ref11.value;var selectValue=_ref12.selectValue,onChange=_ref12.onChange;var meaningfulValue=typeof value!=="undefined"?value:children;var isActive=meaningfulValue===selectValue;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OptionView,{active:isActive,onClick:function onClick(){onChange(meaningfulValue);}},children);}Option.contextTypes=contextTypes;

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withData__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icons_Kuchka__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  padding-top: 15px;\n  padding-bottom: 14px;\n  text-align: center;\n  border-top: 1px dashed ",";\n  border-bottom: 1px dashed ",";\n"],["\n  padding-top: 15px;\n  padding-bottom: 14px;\n  text-align: center;\n  border-top: 1px dashed ",";\n  border-bottom: 1px dashed ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n  animation: 1.3s "," cubic-bezier(0.4, 0, 1, 1);\n\n  @keyframes glow-positive {\n    0% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 25px ",",\n        0 0 30px ",";\n    }\n    40% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 15px ",",\n        0 0 20px ",";\n    }\n    100% {\n      text-shadow: none;\n    }\n  }\n\n  @keyframes glow-negative {\n    0% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 25px ",",\n        0 0 30px ",";\n    }\n    40% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 15px ",",\n        0 0 20px ",";\n    }\n    100% {\n      text-shadow: none;\n    }\n  }\n"],["\n  animation: 1.3s "," cubic-bezier(0.4, 0, 1, 1);\n\n  @keyframes glow-positive {\n    0% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 25px ",",\n        0 0 30px ",";\n    }\n    40% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 15px ",",\n        0 0 20px ",";\n    }\n    100% {\n      text-shadow: none;\n    }\n  }\n\n  @keyframes glow-negative {\n    0% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 25px ",",\n        0 0 30px ",";\n    }\n    40% {\n      text-shadow: 0 0 5px ",",\n        0 0 10px ",",\n        0 0 15px ",",\n        0 0 20px ",";\n    }\n    100% {\n      text-shadow: none;\n    }\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: block;\n  margin-bottom: 7px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  color: #99959d;\n"],["\n  display: block;\n  margin-bottom: 7px;\n  font-size: ",";\n  line-height: 1;\n  text-align: center;\n  color: #99959d;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  display: block;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1;\n  text-align: center;\n  color: ",";\n"],["\n  display: block;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1;\n  text-align: center;\n  color: ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.borderMainColor;},function(_ref2){var theme=_ref2.theme;return theme.borderMainColor;});var AnimatedContainer=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(Container)(_templateObject2,function(_ref3){var glow=_ref3.glow;return"glow-"+glow;},function(_ref4){var theme=_ref4.theme;return theme.accent;},function(_ref5){var theme=_ref5.theme;return theme.accent;},function(_ref6){var theme=_ref6.theme;return theme.upper;},function(_ref7){var theme=_ref7.theme;return theme.upper;},function(_ref8){var theme=_ref8.theme;return theme.accent;},function(_ref9){var theme=_ref9.theme;return theme.accent;},function(_ref10){var theme=_ref10.theme;return theme.upper;},function(_ref11){var theme=_ref11.theme;return theme.upper;},function(_ref12){var theme=_ref12.theme;return theme.accent;},function(_ref13){var theme=_ref13.theme;return theme.accent;},function(_ref14){var theme=_ref14.theme;return theme.lower;},function(_ref15){var theme=_ref15.theme;return theme.lower;},function(_ref16){var theme=_ref16.theme;return theme.accent;},function(_ref17){var theme=_ref17.theme;return theme.accent;},function(_ref18){var theme=_ref18.theme;return theme.lower;},function(_ref19){var theme=_ref19.theme;return theme.lower;});var Heading=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject3,function(_ref20){var theme=_ref20.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Money=Object(__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_6__Money__["b" /* default */])(_templateObject4,function(props){return props.theme.accent;});var Profit=function(_React$Component){_inherits(Profit,_React$Component);function Profit(){var _ref21;var _temp,_this,_ret;_classCallCheck(this,Profit);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref21=Profit.__proto__||Object.getPrototypeOf(Profit)).call.apply(_ref21,[this].concat(args))),_this),_this.state={percentUpdateIndication:false},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Profit,[{key:"UNSAFE_componentWillReceiveProps",value:function UNSAFE_componentWillReceiveProps(nextProps){var _this2=this;var percentageChanged=this.props.percent!==null&&nextProps.percent!==this.props.percent;var stockChanged=this.props.stock!==nextProps.stock;var accountChanged=this.props.accountType!==nextProps.accountType;if(percentageChanged&&!stockChanged&&!accountChanged){var indication=nextProps.percent>this.props.percent?"positive":"negative";this.setState({percentUpdateIndication:indication},function(){_this2.timer=setTimeout(function(){return _this2.setState({percentUpdateIndication:false});},1000);});}}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timer);}},{key:"render",value:function render(){var _this3=this;var _props=this.props,bid=_props.bid,stock=_props.stock,mode=_props.mode;var currency=mode==="tournament"?__WEBPACK_IMPORTED_MODULE_7__Icons_Kuchka__["b" /* tournamentCurrency */]:null;var C=this.state.percentUpdateIndication===false?Container:AnimatedContainer;var activeAccount=this.props.accounts.find(function(account){return account.id===_this3.props.profile.active_account_id;});var percent=0;if(activeAccount){percent=activeAccount.type==="real"?stock.realProfit:stock.demoProfit;if(mode==="tournament"){percent=stock.realProfit-stock.profit_vip;}}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](C,{glow:this.state.percentUpdateIndication},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"PROFIT")," ",percent,"%"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Money,{currency:currency},bid+bid*percent/100));}}]);return Profit;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var mapStateToProps=function mapStateToProps(state){var tabs=__WEBPACK_IMPORTED_MODULE_1_idx___default()(state,function(state){return state.tabs.tabs;});var active=__WEBPACK_IMPORTED_MODULE_1_idx___default()(state,function(state){return state.tabs.activeTab;});var stocks=__WEBPACK_IMPORTED_MODULE_1_idx___default()(state,function(state){return state.stocks;});if(tabs!=null&&active!=null&&stocks!=null){return{mode:state.settings.mode,stock:stocks[tabs[active]]};}return{mode:state.settings.mode};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__withData__["a" /* default */])(["accounts","profile"])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(Profit)));

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n\n  @media (max-width: 479px) {\n    width: 200px;\n    margin: 0 auto;\n  }\n"],["\n  display: flex;\n\n  @media (max-width: 479px) {\n    width: 200px;\n    margin: 0 auto;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  width: 100%;\n  padding: 6px 18px;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: ",";\n  border: 1px solid ",";\n  border-radius: 4px;\n  background: ",";\n  box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08);\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n  @media (max-width: 959px) {\n    padding: 4px 8px;\n  }\n\n  @media (max-width: 479px) {\n    display: flex;\n    justify-content: center;\n    width: 120px;\n    min-width: 120px;\n    height: 28px;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n\n    ",";\n  }\n"],["\n  position: relative;\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  width: 100%;\n  padding: 6px 18px;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: ",";\n  border: 1px solid ",";\n  border-radius: 4px;\n  background: ",";\n  box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08);\n  appearance: none;\n  cursor: pointer;\n\n  ",";\n  @media (max-width: 959px) {\n    padding: 4px 8px;\n  }\n\n  @media (max-width: 479px) {\n    display: flex;\n    justify-content: center;\n    width: 120px;\n    min-width: 120px;\n    height: 28px;\n    background: none;\n    border: none;\n    border-radius: 0;\n    box-shadow: none;\n\n    ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n      border-color: ",";\n      box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08),\n        inset 0px 0px 0px 2px ",";\n    "],["\n      border-color: ",";\n      box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08),\n        inset 0px 0px 0px 2px ",";\n    "]),_templateObject4=_taggedTemplateLiteral(["\n        box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08),\n          inset 0px 0px 0px 2px ",";\n      "],["\n        box-shadow: inset 0px 3px 0px 0px rgba(0, 0, 0, 0.08),\n          inset 0px 0px 0px 2px ",";\n      "]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n"],["\n  display: flex;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  /* \u041F\u043E\u043A\u0430 \u043D\u0435 \u0432 \u0444\u043E\u043A\u0443\u0441\u0435, \u043C\u0430\u0441\u043A\u0438\u0440\u0443\u0435\u043C\u0441\u044F \u043F\u043E\u0434 \u043A\u043D\u043E\u043F\u043A\u0443 */\n  position: absolute;\n  right: 0;\n  width: ","; /* \u042D\u0442\u043E \u0448\u0438\u0440\u0438\u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0438 */\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  opacity: 0;\n\n  :focus {\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 0;\n    bottom: 0;\n  }\n"],["\n  /* \u041F\u043E\u043A\u0430 \u043D\u0435 \u0432 \u0444\u043E\u043A\u0443\u0441\u0435, \u043C\u0430\u0441\u043A\u0438\u0440\u0443\u0435\u043C\u0441\u044F \u043F\u043E\u0434 \u043A\u043D\u043E\u043F\u043A\u0443 */\n  position: absolute;\n  right: 0;\n  width: ","; /* \u042D\u0442\u043E \u0448\u0438\u0440\u0438\u043D\u0430 \u043A\u043D\u043E\u043F\u043A\u0438 */\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  opacity: 0;\n\n  :focus {\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 0;\n    bottom: 0;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  align-self: flex-end;\n  min-height: 16px;\n  min-width: 16px;\n\n  @media (min-width: 480px) {\n    margin-left: auto;\n\n    :before {\n      content: \"\";\n      border: 5px solid transparent;\n      border-top-color: #99959d;\n      border-bottom: none;\n    }\n  }\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  align-self: flex-end;\n  min-height: 16px;\n  min-width: 16px;\n\n  @media (min-width: 480px) {\n    margin-left: auto;\n\n    :before {\n      content: \"\";\n      border: 5px solid transparent;\n      border-top-color: #99959d;\n      border-bottom: none;\n    }\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  min-width: 0;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: inherit;\n  border: none;\n  outline: none;\n  appearance: none;\n  text-fill-color: ",";\n  opacity: 1;\n  background: transparent;\n\n  @media (min-width: 414px) and (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (min-width: 414px) and (max-width: 567px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    margin-right: 5px;\n    width: auto;\n    text-align: right;\n  }\n"],["\n  min-width: 0;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  line-height: 1;\n  font-family: Roboto, Arial, sans-serif;\n  color: inherit;\n  border: none;\n  outline: none;\n  appearance: none;\n  text-fill-color: ",";\n  opacity: 1;\n  background: transparent;\n\n  @media (min-width: 414px) and (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (min-width: 414px) and (max-width: 567px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    margin-right: 5px;\n    width: auto;\n    text-align: right;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  flex-grow: 0;\n  flex-shrink: 1;\n  align-self: center;\n  white-space: nowrap;\n  font-size: ",";\n  color: #919191;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (min-width: 414px) and (max-width: 567px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    color: inherit;\n  }\n"],["\n  flex-grow: 0;\n  flex-shrink: 1;\n  align-self: center;\n  white-space: nowrap;\n  font-size: ",";\n  color: #919191;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (min-width: 414px) and (max-width: 567px) {\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    color: inherit;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  position: relative;\n  width: 40px;\n  min-width: 40px;\n  height: 28px;\n  background: none;\n  border: none;\n  border-radius: ",";\n  cursor: pointer;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 12px;\n    height: 2px;\n    margin-top: -1px;\n    margin-left: -6px;\n    background-color: ",";\n  }\n\n  ",";\n\n  ",";\n"],["\n  position: relative;\n  width: 40px;\n  min-width: 40px;\n  height: 28px;\n  background: none;\n  border: none;\n  border-radius: ",";\n  cursor: pointer;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 12px;\n    height: 2px;\n    margin-top: -1px;\n    margin-left: -6px;\n    background-color: ",";\n  }\n\n  ",";\n\n  ",";\n"]),_templateObject11=_taggedTemplateLiteral(["\n          margin-left: 1px;\n\n          &::after {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            width: 2px;\n            height: 12px;\n            margin-top: -6px;\n            margin-left: -1px;\n            background-color: ",";\n          }\n        "],["\n          margin-left: 1px;\n\n          &::after {\n            content: \"\";\n            position: absolute;\n            top: 50%;\n            left: 50%;\n            width: 2px;\n            height: 12px;\n            margin-top: -6px;\n            margin-left: -1px;\n            background-color: ",";\n          }\n        "]),_templateObject12=_taggedTemplateLiteral(["\n          margin-right: 1px;\n        "],["\n          margin-right: 1px;\n        "]),_templateObject13=_taggedTemplateLiteral(["\n      background: none;\n      cursor: auto;\n\n      &::before,\n      &::after {\n        background-color: ",";\n      }\n    "],["\n      background: none;\n      cursor: auto;\n\n      &::before,\n      &::after {\n        background-color: ",";\n      }\n    "]),_templateObject14=_taggedTemplateLiteral(["sec"],["sec"]),_templateObject15=_taggedTemplateLiteral(["mins"],["mins"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(_ref){var theme=_ref.theme;return theme.foreground;},function(props){return props.theme.borderMainColor;},function(props){return props.theme.mainDark;},function(_ref2){var theme=_ref2.theme,invalid=_ref2.invalid;return invalid&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,theme.lower,theme.lower);},function(_ref3){var theme=_ref3.theme,invalid=_ref3.invalid;return invalid&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject4,theme.lower);});var ValueContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var NativeSelect=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].select(_templateObject6,function(props){return props.full||props.isTourMode?"100%":"16px";});var PretentiousDropdownButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].label(_templateObject7);var BorderlessInput=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].input(_templateObject8,function(props){return props.disabled?props.theme.foreground:props.theme.foreground;},Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12));var Suffix=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(10));var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject10,function(_ref4){var direction=_ref4.direction;return direction==="plus"?"0 4px 4px 0":"4px 0 0 4px";},function(_ref5){var theme=_ref5.theme;return theme.suggestingInputButtonSymbol;},function(_ref6){var direction=_ref6.direction;return direction==="plus"?Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject11,function(_ref7){var theme=_ref7.theme;return theme.suggestingInputButtonSymbol;}):Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject12);},function(_ref8){var disabled=_ref8.disabled;return disabled&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject13,function(_ref9){var theme=_ref9.theme;return theme.suggestingInputButtonSymbolDisabled;});});function SuggestingInput(props){// input: HTMLInputElement;
function determineSuffix(str){return props.valueFormatFn&&parseInt(str||0,10)<60?props.gettext(_templateObject14):parseInt(str||0,10)<120||parseInt(str||0,10)>600?props.suffix:props.gettext(_templateObject15);}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 479px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{disabled:props.prevValue===null,onClick:function onClick(){return props.onChange({target:{value:props.prevValue}});}});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{className:props.className,style:props.style,invalid:props.invalid,ref:props.forwardedRef},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValueContainer,null,props.prefix,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](BorderlessInput,{size:props.valueFormatFn?props.valueFormatFn(props.value).toString().length:props.value.toString().length,value:props.valueFormatFn?props.valueFormatFn(props.value):props.value,onChange:props.onChange,type:"tel",disabled:props.disableInput}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Suffix,null,props.valueFormatFn?determineSuffix(props.value):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Money__["a" /* CurrencySymbol */],{currency:props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__["b" /* tournamentCurrency */]:null}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](PretentiousDropdownButton,{htmlFor:props.valueFormatFn?"time-select":"amount-select",full:!!props.valueFormatFn}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NativeSelect,{id:props.valueFormatFn?"time-select":"amount-select",full:!!props.valueFormatFn,value:props.isTourMode?props.suggestedValues[0]:props.value,onChange:props.onChange,isTourMode:props.isTourMode},props.suggestedValues.map(function(value,index){return props.valueFormatFn?index===0&&props.isTourMode?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option",{key:"fake",value:value,disabled:true,hidden:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option",{key:value,value:value},props.prefix,props.valueFormatFn(value)," ",determineSuffix(value))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option",{key:value,value:value},props.prefix,props.valueFormatFn(value)," ",determineSuffix(value)):index===0&&props.isTourMode?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option",{key:"fake",value:value,disabled:true,hidden:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option",{key:value,value:value},props.money(value,{currency:props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__["b" /* tournamentCurrency */]:null}))):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("option",{key:value,value:value},props.money(value,{currency:props.tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_5__Icons_Kuchka__["b" /* tournamentCurrency */]:null}));}))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_react_media__["a" /* default */],{query:"(max-width: 479px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{disabled:props.nextValue===null,direction:"plus",onClick:function onClick(){return props.onChange({target:{value:props.nextValue}});}});}}));}var S=Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["g" /* withGettext */])(Object(__WEBPACK_IMPORTED_MODULE_4__Money__["d" /* withMoney */])(SuggestingInput));/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react__["forwardRef"](function(props,ref){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](S,Object.assign({},props,{forwardedRef:ref}));}));

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UpIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DownIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  fill: ",";\n"],["\n  fill: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var BetIcon=function BetIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("svg",{xmlns:"http://www.w3.org/2000/svg",width:"9",height:"7",viewBox:"0 0 9 7",fill:props.fill,className:props.className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("path",{d:props.d}));};var Up=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(BetIcon)(_templateObject,function(_ref){var theme=_ref.theme;return theme.upper;});var Down=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(BetIcon)(_templateObject,function(_ref2){var theme=_ref2.theme;return theme.lower;});var UpIcon=function UpIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Up,{d:"M4.5,0.494L0.779,6.921H8.226L4.5,0.494"});};var DownIcon=function DownIcon(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Down,{d:"M4.5,7.384L0.779,0.958H8.226L4.5,7.384"});};

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_trading_history__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_Close__ = __webpack_require__(65);
var _templateObject=_taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n    transform: translateY(1000px);\n  }\n  80% {\n    opacity: 0.5;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"],["\n  from {\n    opacity: 0;\n    transform: translateY(1000px);\n  }\n  80% {\n    opacity: 0.5;\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100000;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 100000;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n"],["\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.75);\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 90%;\n  background-color: ",";\n  animation: "," 0.3s ease-out;\n"],["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  display: block;\n  width: 100%;\n  height: 90%;\n  background-color: ",";\n  animation: "," 0.3s ease-out;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n  right: 20px;\n  top: 20px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: ",";\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 150ms;\n  opacity: 0.5;\n\n  &:hover {\n    opacity: 1;\n    transform: rotate(90deg);\n  }\n"],["\n  position: absolute;\n  z-index: 2;\n  right: 20px;\n  top: 20px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: ",";\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: all 150ms;\n  opacity: 0.5;\n\n  &:hover {\n    opacity: 1;\n    transform: rotate(90deg);\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  max-height: 100%;\n  height: 100%;\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    flex: 1;\n    left: 10px;\n    margin-left: 10px;\n    background-color: rgba(255, 255, 255, 0.5);\n    opacity: 0.75;\n    border-radius: 4px;\n  }\n"],["\n  max-height: 100%;\n  height: 100%;\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    flex: 1;\n    left: 10px;\n    margin-left: 10px;\n    background-color: rgba(255, 255, 255, 0.5);\n    opacity: 0.75;\n    border-radius: 4px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var themes={darkPopup:{isHistoryPopup:true,historyPopupTitle:true,closeButtonColor:"#ffffff",money:"#ffffff",statisticTitle:"rgba(255, 255, 255, 0.62)",paginationTitle:"#ffffff",tableRowHover:"rgba(255, 255, 255, 0.75)",supportHover:"#8fcc00",tableBefore:"#737373",tableCellColor:"rgba(255, 255, 255, 0.58) !important",tableCellBorder:"#484848",calendarTitle:"rgba(255, 255, 255, 0.62)",paginationActiveBorder:"#666666",paginationActiveColor:"#ffffff",paginationActiveHoverBackground:"rgba(255,255,255,0.2)",loaderBackground:"transparent",scrollbarColor:"rgba(255, 255, 255, 0.5)",calendarContainerBackground:true,popupBackground:true,calendarBackground:true,calendarInputColor:"rgba(255, 255, 255, 0.58)",tableRowEven:true,tableRowOdd:true,tablePaginationHover:"#ffffff"},whitePopup:{isHistoryPopup:true,historyPopupTitle:true,closeButtonColor:"#272B34",scrollbarColor:"rgba(0, 0, 0, 0.5)"}};var bottomAnimation=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["e" /* keyframes */])(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Background=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,function(_ref){var theme=_ref.theme;return theme.popupBackground?theme.mainLight:"#ffffff";},bottomAnimation);var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject5,function(_ref2){var theme=_ref2.theme;return theme.closeButtonColor;});var HistoryContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject6);var HistoryPopup=function HistoryPopup(_ref3){var themeName=_ref3.themeName,onClose=_ref3.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* ThemeProvider */],{theme:themes[themeName]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Background,{onClick:onClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{type:"button",onClick:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HistoryContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__pages_trading_history__["default"],{type:"widget"})))));};/* harmony default export */ __webpack_exports__["a"] = (HistoryPopup);

/***/ }),
/* 2010 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__ = __webpack_require__(4);
var _templateObject=_taggedTemplateLiteral(["\n  /* position: absolute;\n  bottom: 85px;\n  left: 50%;\n  transform: translate(-50%, 0); */\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 62px;\n  padding: 0 20px;\n  white-space: pre-wrap;\n  font-size: ",";\n  color: #717171;\n  background-color: #f6f6f6;\n  line-height: 1.2;\n\n  @media (max-width: 959px) {\n    bottom: 15px;\n    height: 54px;\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    font-size: ",";\n  }\n\n  ",";\n"],["\n  /* position: absolute;\n  bottom: 85px;\n  left: 50%;\n  transform: translate(-50%, 0); */\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 62px;\n  padding: 0 20px;\n  white-space: pre-wrap;\n  font-size: ",";\n  color: #717171;\n  background-color: #f6f6f6;\n  line-height: 1.2;\n\n  @media (max-width: 959px) {\n    bottom: 15px;\n    height: 54px;\n    font-size: ",";\n  }\n\n  @media (max-width: 479px) {\n    font-size: ",";\n  }\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      color: ",";\n    "],["\n      color: ",";\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(16),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(14),Object(__WEBPACK_IMPORTED_MODULE_4__common_styled_mixins__["a" /* fontSize */])(12),function(props){return props.error&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2,function(props){return props.theme.lower;});});function NoData(_ref){var loading=_ref.loading,locale=_ref.locale,error=_ref.error,startDate=_ref.startDate,endDate=_ref.endDate;if(loading===true){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null);}if(error){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{error:true},error);}if(startDate!==null&&endDate!==null){var start=startDate.locale(locale).format("DD.MM.YYYY");var end=endDate.locale(locale).format("DD.MM.YYYY");return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"No operations found for the period"),": ",start," - ",end);}return null;}var mapStateToProps=function mapStateToProps(state){return{locale:Object(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["e" /* inferMomentLocale */])(state)};};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps)(NoData));

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var LeftArrow=function LeftArrow(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"6.295":_ref$width;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:width,viewBox:"0 0 6.295 9.801"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"\u0441\u0442\u0440",d:"M5,.328l4.9,4.9-1.4,1.4L5,3.119l-3.5,3.5L.1,5.219,4.986.328,5,.337Z",transform:"translate(-0.328 9.899) rotate(-90)",fill:"currentColor",fillRule:"evenodd"}));};/* harmony default export */ __webpack_exports__["a"] = (LeftArrow);

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_transition_group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_transition_group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Refund__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Animations__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Audio__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 24px;\n  right: 3px;\n  max-width: 500px;\n  z-index: 1000;\n\n  ",";\n"],["\n  position: absolute;\n  top: 24px;\n  right: 3px;\n  max-width: 500px;\n  z-index: 1000;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      top: ",";\n      right: 0;\n      left: 0;\n      max-width: 100%;\n\n      @media (max-width: 959px) and (min-width: 480px) {\n        right: ",";\n      }\n    "],["\n      top: ",";\n      right: 0;\n      left: 0;\n      max-width: 100%;\n\n      @media (max-width: 959px) and (min-width: 480px) {\n        right: ",";\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: relative;\n  min-height: 54px;\n  line-height: 54px;\n  padding-right: 83px;\n  text-align: right;\n  background-color: rgba(231, 76, 60, 0.25);\n  background: linear-gradient(\n    to left,\n    rgba(231, 76, 60, 0.5) 0%,\n    rgba(231, 76, 60, 0) 100%\n  );\n  background-clip: padding-box;\n\n  "," ",";\n"],["\n  position: relative;\n  min-height: 54px;\n  line-height: 54px;\n  padding-right: 83px;\n  text-align: right;\n  background-color: rgba(231, 76, 60, 0.25);\n  background: linear-gradient(\n    to left,\n    rgba(231, 76, 60, 0.5) 0%,\n    rgba(231, 76, 60, 0) 100%\n  );\n  background-clip: padding-box;\n\n  "," ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n      background-color: rgba(96, 163, 28, 0.25);\n      background: linear-gradient(\n        to left,\n        rgba(96, 163, 28, 0.5) 0%,\n        rgba(96, 163, 28, 0) 100%\n      );\n    "],["\n      background-color: rgba(96, 163, 28, 0.25);\n      background: linear-gradient(\n        to left,\n        rgba(96, 163, 28, 0.5) 0%,\n        rgba(96, 163, 28, 0) 100%\n      );\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      min-height: 27px;\n      padding-right: 45px;\n      line-height: 27px;\n      background: rgba(231, 76, 60, 0.3);\n\n      ",";\n    "],["\n      min-height: 27px;\n      padding-right: 45px;\n      line-height: 27px;\n      background: rgba(231, 76, 60, 0.3);\n\n      ",";\n    "]),_templateObject6=_taggedTemplateLiteral(["\n          background: rgba(96, 163, 28, 0.3);\n        "],["\n          background: rgba(96, 163, 28, 0.3);\n        "]),_templateObject7=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 45px;\n  transform: translateY(-50%);\n  width: 19px;\n  height: 19px;\n  opacity: 0.38;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(-45deg);\n    transform-origin: 50%;\n    display: block;\n  }\n\n  :before {\n    width: 100%;\n    border-top: 2px solid #fff;\n  }\n  :after {\n    height: 100%;\n    border-left: 2px solid #fff;\n  }\n\n  :hover {\n    opacity: 1;\n  }\n\n  ",";\n"],["\n  position: absolute;\n  top: 50%;\n  right: 45px;\n  transform: translateY(-50%);\n  width: 19px;\n  height: 19px;\n  opacity: 0.38;\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :before,\n  :after {\n    content: \"\";\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) rotate(-45deg);\n    transform-origin: 50%;\n    display: block;\n  }\n\n  :before {\n    width: 100%;\n    border-top: 2px solid #fff;\n  }\n  :after {\n    height: 100%;\n    border-left: 2px solid #fff;\n  }\n\n  :hover {\n    opacity: 1;\n  }\n\n  ",";\n"]),_templateObject8=_taggedTemplateLiteral(["\n      opacity: .7;\n      width: 15px;\n      height: 15px;\n      right: 15px;\n    "],["\n      opacity: .7;\n      width: 15px;\n      height: 15px;\n      right: 15px;\n    "]),_templateObject9=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: 600;\n  font-size: ",";\n  text-transform: uppercase;\n  text-align: left;\n  color: rgba(231, 76, 60, .7);\n\n  "," ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: 600;\n  font-size: ",";\n  text-transform: uppercase;\n  text-align: left;\n  color: rgba(231, 76, 60, .7);\n\n  "," ",";\n"]),_templateObject10=_taggedTemplateLiteral(["\n      color: rgba(96, 163, 28, .7);\n    "],["\n      color: rgba(96, 163, 28, .7);\n    "]),_templateObject11=_taggedTemplateLiteral(["\n      width: 50%;\n      padding-right: 14px;\n      font-size: ",";\n      text-align: right;\n      color: rgba(255, 255, 255, .7);\n    "],["\n      width: 50%;\n      padding-right: 14px;\n      font-size: ",";\n      text-align: right;\n      color: rgba(255, 255, 255, .7);\n    "]),_templateObject12=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 36px;\n  font-weight: 400;\n  font-size: ",";\n  color: rgba(255, 255, 255, .7);\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 36px;\n  font-weight: 400;\n  font-size: ",";\n  color: rgba(255, 255, 255, .7);\n\n  ",";\n"]),_templateObject13=_taggedTemplateLiteral(["\n      min-width: 124px;\n      margin-left: 0;\n      text-align: left;\n      font-size: ",";\n    "],["\n      min-width: 124px;\n      margin-left: 0;\n      text-align: left;\n      font-size: ",";\n    "]),_templateObject14=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 14px;\n  font-weight: 700;\n  font-size: 22px;\n\n  ",";\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  margin-left: 14px;\n  font-weight: 700;\n  font-size: 22px;\n\n  ",";\n"]),_templateObject15=_taggedTemplateLiteral(["\n      margin-left: 4px;\n      font-size: ",";\n    "],["\n      margin-left: 4px;\n      font-size: ",";\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject2,props.tour?"30px":"calc(86px + 15px)",props.tour?0:"146px");});var Item=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.positive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject5,function(props){return props.positive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject6);});});var Close=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject7,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject8);});var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.positive&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject10);},function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12));});var ValueContainer=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject12,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject13,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(12));});var Value=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject14,function(props){return props.mobile&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject15,Object(__WEBPACK_IMPORTED_MODULE_9__common_styled_mixins__["a" /* fontSize */])(14));});var NewsItem=function(_React$Component){_inherits(NewsItem,_React$Component);function NewsItem(){_classCallCheck(this,NewsItem);return _possibleConstructorReturn(this,(NewsItem.__proto__||Object.getPrototypeOf(NewsItem)).apply(this,arguments));}_createClass(NewsItem,[{key:"componentDidMount",value:function componentDidMount(){this.timer=setTimeout(this.props.onDismiss,2000);}},{key:"componentWillUnmount",value:function componentWillUnmount(){clearTimeout(this.timer);}},{key:"render",value:function render(){var _props=this.props,tradeMode=_props.tradeMode,mobile=_props.mobile,onDismiss=_props.onDismiss,style=_props.style,payload=_props.payload,soundsEnabled=_props.soundsEnabled;var positive=payload.profit>=0;var currency=tradeMode==="tournament"?__WEBPACK_IMPORTED_MODULE_6__Icons_Kuchka__["b" /* tournamentCurrency */]:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,{positive:positive,mobile:mobile,onClick:onDismiss,style:style},soundsEnabled&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__Audio__["a" /* Sound */],{play:positive?"PLAY_WIN_SOUND":"PLAY_LOOSE_SOUND"}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Close,{onClick:onDismiss,mobile:mobile}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,{mobile:mobile,positive:positive},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Operation closed")),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ValueContainer,{mobile:mobile},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Income"),":",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Value,{mobile:mobile},payload.profit===0?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__common_Refund__["a" /* default */],null):__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Money__["b" /* default */],{currency:currency},payload.profit))));}}]);return NewsItem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function News(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{mobile:props.mobile,tour:props.tour},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_transition_group__["TransitionGroup"],{component:null},props.news.filter(function(news){return!news.isDismissed;}).map(function(news){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__common_Animations__["a" /* Fade */],{"in":news.isDismissed,key:news.payload.id},function(style){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](NewsItem,{style:style,tradeMode:news.isTournament?"tournament":"binary",soundsEnabled:props.soundsEnabled,payload:news.payload,mobile:props.mobile,onDismiss:function onDismiss(){return props.onDismiss(news.payload.id);}});});})));}/* harmony default export */ __webpack_exports__["a"] = (News);

/***/ }),
/* 2014 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/coins.572bddc6.mp3";

/***/ }),
/* 2015 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/paper.9f8f2b0f.mp3";

/***/ }),
/* 2016 */
/***/ (function(module, exports) {

document.body.addEventListener('touchstart',iosAudioContextResume,false);document.body.addEventListener('touchend',iosAudioContextResume,false);function iosAudioContextResume(){if(window.audioctx){// alert(window.audioctx.state);
window.audioctx.resume();setTimeout(function(){// alert(window.audioctx.state);
if(window.audioctx.state==='running'){// alert("resumed");
document.body.removeEventListener('touchstart',iosAudioContextResume,false);document.body.removeEventListener('touchend',iosAudioContextResume,false);}},100);}}

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AdsContainer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  flex: 1;\n  padding: 5px 15px;\n"],["\n  flex: 1;\n  padding: 5px 15px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 5px 16px;\n  line-height: 1.2;\n  background-color: ",";\n  border-radius: 4px;\n"],["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  padding: 5px 16px;\n  line-height: 1.2;\n  background-color: ",";\n  border-radius: 4px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  width: 100%;\n  font-size: ",";\n  color: ",";\n"],["\n  width: 100%;\n  font-size: ",";\n  color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,function(props){return props.theme.mainLight;});var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(props){return props.theme.accent;});var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"10px";},function(_ref3){var theme=_ref3.theme;return theme.foreground;});function AdsContainer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Heading,null,"\u0411\u043B\u043E\u043A \u0434\u043B\u044F \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0439, \u0430\u043A\u0446\u0438\u0439, \u0440\u0435\u043A\u043B\u0430\u043C\u044B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,null,"adipiscing elit, sed do eiusmod tempor")));}

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ToolsPopup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Toolbar_ToolWrapper__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Toolbar_ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Toolbar_ToolsMenu__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Toolbar_ToolsActive__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup__ = __webpack_require__(151);
var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  align-content: flex-start;\n  height: 100%;\n  width: 100%;\n  flex: 1;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: flex-start;\n  justify-content: flex-start;\n  align-content: flex-start;\n  height: 100%;\n  width: 100%;\n  flex: 1;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// import screenfull from "screenfull";
var Inner=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);function ToolsPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Settings"),onClick:props.onClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Inner,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Toolbar_ToolWrapper__["a" /* default */],{isMobile:true},function(tools){return tools.instruments==="settings"?__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__Toolbar_ToolsMenu__["a" /* default */],{tools:tools.TOOLS,activeTool:tools.activeTool,changeActiveTool:tools.changeActiveTool,isMobile:true}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__Toolbar_ToolsContent__["d" /* default */],{activeTool:tools.activeToolObj,isMobile:true,dispatch:tools.dispatch,settings:tools.settings},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Toolbar_ToolsActive__["a" /* default */],{tools:tools.TOOLS,handlePopupOpen:tools.handlePopupOpen,activeTool:tools.activeTool,dispatch:tools.dispatch,settings:tools.settings,isMobile:true}))):tools.popup;})));}

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(95);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Самодельные выпадающие меню не испускают настоящих
// нативных событий, поэтому мы сделаем своё событие.
var IndicatorPopup=function(_Component){_inherits(IndicatorPopup,_Component);function IndicatorPopup(){var _ref;var _temp,_this,_ret;_classCallCheck(this,IndicatorPopup);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=IndicatorPopup.__proto__||Object.getPrototypeOf(IndicatorPopup)).call.apply(_ref,[this].concat(args))),_this),_this.state={indicator:_this.props.initialState,errors:null,activeSelect:""},_this.getValidator=function(field){if(!_this.props.validation)return null;return _this.props.validation[field];},_this.handleChange=function(event){var _event$target=event.target,name=_event$target.name,value=_event$target.value;var filtered=parseInt(value,10);_this.setState({indicator:Object.assign({},_this.state.indicator,_defineProperty({},name,isNaN(filtered)?value:filtered)),activeSelect:""});},_this.handleAsIsChange=function(event){var _event$target2=event.target,name=_event$target2.name,value=_event$target2.value;var errors=_this.state.errors||{};var validator=_this.getValidator(name);if(validator&&!validator(value)){errors[name]=true;}else{delete errors[name];}_this.setState({errors:errors,indicator:Object.assign({},_this.state.indicator,_defineProperty({},name,value)),activeSelect:""});},_this.handleNumberChange=function(event){var _event$target3=event.target,name=_event$target3.name,value=_event$target3.value;var filtered=/^\d*$/.test(value)?value:_this.state.indicator[name];var errors=_this.state.errors||{};var validator=_this.getValidator(name);if(validator&&!validator(filtered)){errors[name]=true;}else{delete errors[name];}_this.setState({errors:errors,indicator:Object.assign({},_this.state.indicator,_defineProperty({},name,filtered)),activeSelect:""});},_this.handleNestedChange=function(key,name){return function(event){var value=event.target.value;var errors=_this.state.errors||{};var validator=_this.getValidator(key+"_"+name);if(validator&&!validator(value)){errors[key+"_"+name]=true;}else{delete errors[key+"_"+name];}_this.setState({errors:errors,indicator:Object.assign({},_this.state.indicator,_defineProperty({},key,Object.assign({},_this.state.indicator[key],_defineProperty({},name,value)))),activeSelect:""});};},_this.handleClick=function(name){_this.setState({activeSelect:name});},_this.handleReset=function(){_this.setState({errors:null,indicator:_this.props.initialState,activeSelect:""});},_this.handleSubmit=function(){if(_this.checkEmptyFields()){return false;}if(_this.checkErrors()){return false;}_this.props.onSubmit(_this.state.indicator);},_this.checkEmptyFields=function(){var errors=[];var state=_this.state.indicator;Object.keys(_this.state.indicator).forEach(function(key){if(state[key]===""){errors.push(key);}});return errors.length>0;},_this.checkErrors=function(){return Object.keys(_this.state.errors||{}).length>0;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(IndicatorPopup,[{key:"render",value:function render(){var _state=this.state,indicator=_state.indicator,errors=_state.errors,activeSelect=_state.activeSelect;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["g" /* default */],{title:this.props.title,onClose:this.props.onClose,mobile:this.props.mobile,info:this.props.info},this.props.children({mobile:this.props.mobile,indicator:indicator,errors:errors,activeSelect:activeSelect,handleClick:this.handleClick,handleChange:this.handleChange,handleAsIsChange:this.handleAsIsChange,handleNumberChange:this.handleNumberChange,handleNestedChange:this.handleNestedChange}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["a" /* Button */],{onClick:this.props.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Cancel")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["a" /* Button */],{onClick:this.handleReset},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Reset")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["a" /* Button */],{onClick:this.handleSubmit,isSubmit:true,disabled:Object.keys(this.state.errors||{}).length>0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Apply"))));}}]);return IndicatorPopup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return state.settings;})(Object(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["g" /* withGettext */])(IndicatorPopup)));

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return indicatorTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__ = __webpack_require__(166);
var initialState={jaws:{period:13,shift:8,color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][0],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]},teeths:{period:8,shift:5,color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][1],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]},lips:{period:5,shift:3,color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][2],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]}};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Alligator");var Info=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToolsContent__["b" /* InfoBlock */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"This indicator contains three Moving Average lines with different periods and a different offset. ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Link__["a" /* Link */],{to:"/helpdesk/knowledge_base#kb_i"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Learn more about the indicator."))));var AlligatorPopup=function AlligatorPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Jaws"),share:props.mobile===true&&3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Period"),name:"jaws_period",value:props.indicator.jaws.period,onChange:props.handleNestedChange("jaws","period"),invalid:props.errors&&props.errors.jaws_period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Shift"),name:"jaws_shift",value:props.indicator.jaws.shift,onChange:props.handleNestedChange("jaws","shift"),invalid:props.errors&&props.errors.jaws_shift}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"jaws_color",value:props.indicator.jaws.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("jaws","color")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"jaws_strokeWidth",value:props.indicator.jaws.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("jaws","strokeWidth")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Teeth"),share:props.mobile===true&&3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Period"),name:"teeths_period",value:props.indicator.teeths.period,onChange:props.handleNestedChange("teeths","period"),invalid:props.errors&&props.errors.teeths_period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Shift"),name:"teeths_shift",value:props.indicator.teeths.shift,onChange:props.handleNestedChange("teeths","shift"),invalid:props.errors&&props.errors.teeths_shift}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"teeths_color",value:props.indicator.teeths.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("teeths","color")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"teeths_strokeWidth",value:props.indicator.teeths.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("teeths","strokeWidth")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Lips"),share:props.mobile===true&&3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Period"),name:"lips_period",value:props.indicator.lips.period,onChange:props.handleNestedChange("lips","period"),invalid:props.errors&&props.errors.lips_period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Shift"),name:"lips_shift",value:props.indicator.lips.shift,onChange:props.handleNestedChange("lips","shift"),invalid:props.errors&&props.errors.lips_shift}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"lips_color",value:props.indicator.lips.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("lips","color")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"lips_strokeWidth",value:props.indicator.lips.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("lips","strokeWidth")})));};/* harmony default export */ __webpack_exports__["b"] = (AlligatorPopup);

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return initialState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return indicatorTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Info; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Popup__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolsContent__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__ = __webpack_require__(166);
var initialState={period:14,rejection:2,upper:{color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][0],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]},middle:{color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][1],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]},lower:{color:__WEBPACK_IMPORTED_MODULE_5__Popup_SelectColor__["a" /* COLORS */][2],strokeWidth:__WEBPACK_IMPORTED_MODULE_6__Popup_SelectWidth__["a" /* WIDTHS */][0]}};var indicatorTitle=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Bollinger Lines");var Info=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__ToolsContent__["b" /* InfoBlock */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"This indicator shows a dynamic interval of possible price changes in form of two lines. ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common_Link__["a" /* Link */],{to:"/helpdesk/knowledge_base#kb_i"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Learn more about the indicator."))));var BollingerLinesPopup=function BollingerLinesPopup(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"General"),share:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Period"),name:"period",value:props.indicator.period,onChange:props.handleAsIsChange,invalid:props.errors&&props.errors.period}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["b" /* Input */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Rejection"),name:"rejection",value:props.indicator.rejection,onChange:props.handleAsIsChange,invalid:props.errors&&props.errors.rejection})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Top line"),share:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"upper_color",value:props.indicator.upper.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("upper","color")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"upper_strokeWidth",value:props.indicator.upper.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("upper","strokeWidth")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Middle line"),share:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"middle_color",value:props.indicator.middle.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("middle","color")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"middle_strokeWidth",value:props.indicator.middle.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("middle","strokeWidth")})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["c" /* Row */],{title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Lower line"),share:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["e" /* SelectColor */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Colour"),name:"lower_color",value:props.indicator.lower.color,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("lower","color")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Popup__["f" /* SelectWidth */],{label:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Width of lines"),name:"lower_strokeWidth",value:props.indicator.lower.strokeWidth,activeSelect:props.activeSelect,onClick:props.handleClick,onChange:props.handleNestedChange("lower","strokeWidth")})));};/* harmony default export */ __webpack_exports__["b"] = (BollingerLinesPopup);

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__layout_Mobile__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StockMenu__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Popup__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Tour__ = __webpack_require__(44);
var Assets=function Assets(props){var original=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(null);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__layout_Mobile__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Tour__["b" /* default */],{step:["allStocksSelect"],disabled:true,originalRef:original,withoutStyles:true},function(_ref){var next=_ref.next,isOriginal=_ref.isOriginal,isTourActive=_ref.isTourActive,step=_ref.step;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Popup__["a" /* default */],{ref:isOriginal?original:null,title:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Asset"),onClick:props.onClick,isTour:!isOriginal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__StockMenu__["a" /* default */],{isTour:!isOriginal,defaultCategory:isTourActive?"popular":null,onStockSelect:function onStockSelect(stock){next(stock);props.dispatch({type:"SET_ACTIVE_STOCK",payload:{newStock:stock,activeStock:props.activeStock}});if(!/sightseeing/.test(props.location.pathname)){props.history.replace("/trade");}else{props.history.replace("/sightseeing");}},onClose:isOriginal?props.onClick:null}));}));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function(state){return{settings:state.settings,activeStock:Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs)};})(function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Assets,props);})));

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_media__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TradeMobile_Popup__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Items__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Social__ = __webpack_require__(463);
var _templateObject=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding-top: 12px;\n  background-color: ",";\n"],["\n  flex-grow: 1;\n  flex-shrink: 1;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  width: 100%;\n  padding-top: 12px;\n  background-color: ",";\n"]);function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContentContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.main;});var SocialPopup=function SocialPopup(_ref2){var className=_ref2.className,props=_objectWithoutProperties(_ref2,["className"]);return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_1_react_media__["a" /* default */],{query:"(max-width: 959px)",render:function render(){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__TradeMobile_Popup__["a" /* default */],{title:null,type:"tournaments",onClick:function onClick(){Object(__WEBPACK_IMPORTED_MODULE_4__GA__["a" /* gaReducer */])("CLOSE_SOCIAL_TRADING");return props.history.replace("/trade");},className:className},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ContentContainer,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__Social__["b" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Items__["a" /* default */],{onItemClick:function onItemClick(){return props.history.replace("/trade");}}))));}});};/* harmony default export */ __webpack_exports__["a"] = (SocialPopup);

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Popup;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AnimationWrapper__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StyledComponents__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__safe_svg__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__safe_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__safe_svg__);
function Popup(_ref){var children=_ref.children,style=_ref.style,onDismiss=_ref.onDismiss;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledComponents__["f" /* Overlay */],{style:style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__AnimationWrapper__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledComponents__["g" /* PopupView */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledComponents__["h" /* SafeImg */],{src:__WEBPACK_IMPORTED_MODULE_3__safe_svg___default.a,alt:__WEBPACK_IMPORTED_MODULE_3__safe_svg___default.a}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__StyledComponents__["c" /* Close */],{onClick:onDismiss}),children)));}

/***/ }),
/* 2025 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/safe.21c52fb0.svg";

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hooks_useBonusTimer__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Timers__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_CloseOutlined__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_CloseOutlined___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_CloseOutlined__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 26px;\n  margin: 10px 15px;\n  margin-bottom: 0;\n  padding: 0 15px;\n  ",";\n  font-size: ",";\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  overflow: hidden;\n"],["\n  position: relative;\n  flex-grow: 0;\n  flex-shrink: 0;\n  height: 26px;\n  margin: 10px 15px;\n  margin-bottom: 0;\n  padding: 0 15px;\n  ",";\n  font-size: ",";\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  overflow: hidden;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  width: 100%;\n  height: 24px;\n  color: inherit;\n  text-decoration: none;\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  width: 100%;\n  height: 24px;\n  color: inherit;\n  text-decoration: none;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  ",";\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  font-size: 18px;\n  color: #919191;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 4;\n\n  :hover {\n    color: ",";\n  }\n"],["\n  position: absolute;\n  top: 0;\n  ",";\n  display: flex;\n  flex-flow: column nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  font-size: 18px;\n  color: #919191;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  z-index: 4;\n\n  :hover {\n    color: ",";\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  font-weight: 700;\n"],["\n  font-weight: 700;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin: 0 auto;\n  line-height: 1;\n  color: ",";\n"],["\n  display: flex;\n  flex-flow: row nowrap;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  margin: 0 auto;\n  line-height: 1;\n  color: ",";\n"]),_templateObject6=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  ",";\n  height: 2px;\n  width: 100%;\n  background-color: ",";\n"],["\n  position: absolute;\n  bottom: 0;\n  ",";\n  height: 2px;\n  width: 100%;\n  background-color: ",";\n"]),_templateObject7=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  ",";\n  height: 100%;\n  background-color: ",";\n"],["\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  ",";\n  height: 100%;\n  background-color: ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("padding-right","39px"),Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["a" /* fontSize */])(12),function(_ref){var theme=_ref.theme;return theme.foreground;},function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])(theme.foreground,0.1);});var Contents=Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_2__common_Link__["a" /* Link */])(_templateObject2);var CloseContainer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject3,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("right",0),function(_ref3){var theme=_ref3.theme;return theme.foreground;});var Percent=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].strong(_templateObject4);var Timer=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].span(_templateObject5,function(_ref4){var theme=_ref4.theme;return theme.accent;});var Progress=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("left",0),function(_ref5){var theme=_ref5.theme;return Object(__WEBPACK_IMPORTED_MODULE_3_polished__["a" /* rgba */])(theme.foreground,0.15);});var ProgressBar=__WEBPACK_IMPORTED_MODULE_4_styled_components__["d" /* default */].div(_templateObject7,Object(__WEBPACK_IMPORTED_MODULE_6__common_styled_mixins__["c" /* rtl */])("left",0),function(_ref6){var theme=_ref6.theme;return theme.alternativeAccent;});var BonusTimer=function BonusTimer(_ref7){var time=_ref7.time;var _useBonusTimerStorage=Object(__WEBPACK_IMPORTED_MODULE_7__hooks_useBonusTimer__["b" /* useBonusTimerStorage */])(),_useBonusTimerStorage2=_slicedToArray(_useBonusTimerStorage,2),showTimer=_useBonusTimerStorage2[0],toggleTimer=_useBonusTimerStorage2[1];var bonus=Object(__WEBPACK_IMPORTED_MODULE_7__hooks_useBonusTimer__["a" /* useBonusTimerApi */])({time:time});if(showTimer===false||bonus==null||bonus.duration<0||bonus.status!=="available"){return null;}return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Contents,{to:"/fillup?promocode="+bonus.promo},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Bonus"),"\xA0\xA0\xA0",__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Percent,null,"+",bonus.percent,"%"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Timer,null,bonus.ticker)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](CloseContainer,{onClick:function onClick(){return toggleTimer(false);}},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_CloseOutlined___default.a,{fontSize:"inherit",color:"inherit"})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Progress,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ProgressBar,{style:{width:bonus.progress+"%"}})));};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(__WEBPACK_IMPORTED_MODULE_8__Timers__["b" /* mapStateToTime */])(BonusTimer));

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_reducer_deals__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__redux_reducer_points__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TradeHeader__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Toolbar__ = __webpack_require__(2028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Chart__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_connected__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TradeControls__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TradeDesktopLayout__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__InsufficientPopup_InsufficientPopup__ = __webpack_require__(790);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PopupDeposit_PopupDeposit__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TradeModals_VerificationRequired_VerificationRequired__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__TradeModals_TradeIsClosing__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__TradeModals_IncreaseBidLimit__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__TradeModals_DemoTournamentPopup__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__News__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__StockClose__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__withErrorCatch__ = __webpack_require__(149);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var InsufficientPopup=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){var activeAccount=state.accounts.find(function(account){return state.profile?account.id===state.profile.active_account_id:account.isActive;});return{profileId:state.profile&&state.profile.id,initialDeposit:state.remoteTradeSettings.initial,minFillup:state.remoteTradeSettings.minFillup,isActiveAccountReal:activeAccount?activeAccount.type==="real":false};})(__WEBPACK_IMPORTED_MODULE_13__InsufficientPopup_InsufficientPopup__["a" /* default */]);var PopupDeposit=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){var activeAccount=state.accounts.find(function(account){return state.profile?account.id===state.profile.active_account_id:account.isActive;});return{profileId:state.profile&&state.profile.id,accounts:state.accounts,initialDeposit:state.remoteTradeSettings.initial,minFillup:state.remoteTradeSettings.minFillup,isActiveAccountReal:activeAccount?activeAccount.type==="real":false};})(__WEBPACK_IMPORTED_MODULE_14__PopupDeposit_PopupDeposit__["a" /* default */]);var VerificationRequiredPopup=Object(__WEBPACK_IMPORTED_MODULE_9__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_15__TradeModals_VerificationRequired_VerificationRequired__["a" /* default */])(function(state){return{validation:state.profile?state.profile.validation:{phone:0,email:0,profile:0,passport:0}};});var IncreaseBidLimitPopup=Object(__WEBPACK_IMPORTED_MODULE_9__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_17__TradeModals_IncreaseBidLimit__["a" /* default */])(function(state){var profile=state.profile;var bid_limit=5000;if(profile){if(profile.bid_limit){bid_limit=_typeof(profile.bid_limit)==="object"?profile.bid_limit[profile.currency]:profile.bid_limit;}}return{bid_limit:bid_limit};});var TradeIsClosingPopup=Object(__WEBPACK_IMPORTED_MODULE_9__common_connected__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_16__TradeModals_TradeIsClosing__["a" /* default */])(function(state){//
});var TradeHeader=Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{profile:state.profile,accounts:state.accounts};})(__WEBPACK_IMPORTED_MODULE_6__TradeHeader__["a" /* default */]));var TradeControls=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){var stock=Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs);var points=state.points[stock]||[];var bids=state.remoteTradeSettings.bids;var currency=state.remoteTradeSettings.currency;var maxBidVolume=void 0;if(state.profile){if(_typeof(state.profile.bid_limit)==="object"){maxBidVolume=state.profile.bid_limit[currency];}else{maxBidVolume=state.profile.bid_limit;}}if(!maxBidVolume&&state.apiConfigs){maxBidVolume=state.apiConfigs.maxBidVolume[currency];}if(bids[bids.length-1]>maxBidVolume){bids=bids.filter(function(bid){return bid<=maxBidVolume;});}var openDeals=function openDeals(deal){return deal.time!==undefined&&deal.profit===undefined;};var stocksWithOperations=props.deals.filter(openDeals).reduce(function(res,deal){if(deal){res.push(deal.stock);}return res;},[]);var pointsByStock=stocksWithOperations.reduce(function(res,stock){var points=state.points[stock];if(points&&!res[stock]){res[stock]=points.length>0?points[points.length-1]:null;}return res;},{});return Object.assign({tradeMode:state.settings.mode,point:points.length>0?points[points.length-1]:null,pointsByStock:pointsByStock,suggestedBids:bids,percentBidThreshold:state.remoteTradeSettings.percentBidThreshold,percentBids:state.remoteTradeSettings.percentBids,currentBid:state.settings.currentBid,maxBidVolume:maxBidVolume||bids[bids.length-1],now:state.time},Object(__WEBPACK_IMPORTED_MODULE_10__common_Gettext__["f" /* mapStateToGettext */])(state));})(__WEBPACK_IMPORTED_MODULE_11__TradeControls__["a" /* default */]);var Chart=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,ownProps){var stock=Object(__WEBPACK_IMPORTED_MODULE_3__redux_reducer_tabs__["c" /* getViewedStock */])(state.tabs);var time=Object(__WEBPACK_IMPORTED_MODULE_5__redux_reducer_points__["b" /* getServerTime */])(stock,state.points)||0;var deals=_typeof(ownProps.deals)==="object"&&ownProps.deals.type==="SPECIAL TOUR DEAL"?ownProps.deals.deals:Object(__WEBPACK_IMPORTED_MODULE_4__redux_reducer_deals__["b" /* getActiveDeals */])(stock,time,ownProps.deals);return{graphicalMode:state.graphicalMode,key:stock,tradeMode:state.settings.mode,points:ownProps.points||state.points[stock]||[],settings:Object.assign({},state.settings,ownProps.settings),stats:state.stats[stock],profile:state.profile,deals:deals};})(__WEBPACK_IMPORTED_MODULE_8__Chart__["a" /* default */]);var News=Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state){return{news:state.news,soundsEnabled:state.audio.enabled};},function(dispatch){return{onDismiss:function onDismiss(id){dispatch({type:"DISMISS_NEWS",payload:id});}};})(__WEBPACK_IMPORTED_MODULE_19__News__["a" /* default */]);var DesktopTradeScreen=function(_PureComponent){_inherits(DesktopTradeScreen,_PureComponent);function DesktopTradeScreen(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DesktopTradeScreen);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DesktopTradeScreen.__proto__||Object.getPrototypeOf(DesktopTradeScreen)).call.apply(_ref,[this].concat(args))),_this),_this.chartRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef(null),_this.state={intent:""},_this.onIntentUpdate=function(intent){_this.setState({intent:intent});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DesktopTradeScreen,[{key:"render",value:function render(){var _this2=this;var props=this.props;var isStockClose=!props.stock.enabled||props.timeUntilNextLockToggle===0;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TradeDesktopLayout__["a" /* default */],{headerHeight:127,sidebarWidth:174,dealsToCompensate:props.dealsToCompensate,onCompensation:props.onCompensation,compensationUpdated:props.compensationUpdated,compensationCreated:props.compensationCreated,onCompensationCreated:props.onCompensationCreated,activeAccount:props.activeAccount},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradeHeader,{isRefillFetching:props.isRefillFetching,isFetchingOpenOperation:props.isFetchingOpenOperation,accountsReady:props.accountsReady,dealsReady:props.dealsReady,deals:props.deals,onProfileUpdate:props.refreshProfile,onRefillDemoClick:props.refillDemoAccount,compensationUpdated:props.compensationUpdated,compensationCreated:props.compensationCreated}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Toolbar__["a" /* default */],{deals:props.deals,instruments:this.state.toolbarInstruments,onClose:function onClose(){return _this2.setState({toolbarInstruments:null});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradeControls,{activeAccount:props.activeAccount,onSubmit:props.tryMakingADeal,onIntentUpdate:this.onIntentUpdate,showIncreaseBidLimitMessage:props.showIncreaseBidLimitMessage,disabled:isStockClose||props.tradeControlsDisabled,accountType:props.accountType,possibleIntervals:props.possibleTradeIntervals,currentInterval:props.currentTradeInterval,stock:props.stock,timeUntilNextLockToggle:props.timeUntilNextLockToggle,deals:props.deals,isDealAmountValid:props.isDealAmountValid,validateDealAmount:props.validateDealAmount,refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching,time:props.time,dealsToCompensate:props.dealsToCompensate,onCompensation:props.onCompensation,compensationUpdated:props.compensationUpdated,compensationCreated:props.compensationCreated,onCompensationCreated:props.onCompensationCreated}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__Tour__["b" /* default */],{step:["stareAtTheChart","showChart","chartWithProfit","chartWithDeals"],originalRef:this.chartRef,disabled:true,showTimer:true},function(_ref2){var next=_ref2.next,isOriginal=_ref2.isOriginal,step=_ref2.step,isTourActive=_ref2.isTourActive,isTourMode=_ref2.isTourMode,deal=_ref2.deal,tour=_ref2.tour,startPointsLength=_ref2.startPointsLength;return isOriginal?!isTourActive&&(isStockClose&&!isTourMode?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__StockClose__["h" /* default */],{stocks:props.stocks,onStockClick:props.onRecommendedStockClick,activeAccount:props.activeAccount,stock:props.stock}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Chart,{animated:props.animated,forwardedRef:_this2.chartRef,points:isTourMode?tour.points:void 0,visuals:"desktop",deals:props.deals,intent:_this2.state.intent,stock:props.stock,timeUntilNextLockToggle:props.timeUntilNextLockToggle,dispatch:_this2.props.dispatch,onEditIndicator:function onEditIndicator(index,type){return _this2.setState({toolbarInstruments:"indicators?"+type+":"+index});},refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching,time:props.time})):step==="showChart"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Chart,{animated:props.animated,visuals:"desktop",points:tour.points,deals:{type:"SPECIAL TOUR DEAL",deals:tour.deals},intent:_this2.state.intent,stock:props.stock,timeUntilNextLockToggle:props.timeUntilNextLockToggle,dispatch:_this2.props.dispatch,onEditIndicator:function onEditIndicator(index,type){return _this2.setState({toolbarInstruments:"indicators?"+type+":"+index});},settings:{sentiments:false},refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching,time:props.time}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Chart,{interactive:false,animated:props.animated,points:tour.points,visuals:"desktop",deals:{type:"SPECIAL TOUR DEAL",deals:tour.deals.slice(-1).filter(function(d){return startPointsLength-tour.points.length+d.bTime>=0;})},intent:null,stock:props.stock,timeUntilNextLockToggle:Infinity,dispatch:_this2.props.dispatch,onEditIndicator:function onEditIndicator(){return void 0;},settings:{indicators:[],timeSpan:60*1000/0.8,sentiments:false},refundClickHandler:props.refundClickHandler,refundFetching:props.refundFetching,time:props.time}),startPointsLength-tour.points.length+tour.deals[0].bTime<0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__News__["a" /* default */],{news:[{payload:{op:"operationClosed",id:tour.deals[0].id,stock:tour.deals[0].stock,user_id:1,profit:tour.deals[0].amount+tour.deals[0].amount*(tour.deals[0].percent/100),accountId:1,real:0,balance:1,turnover:0,targetTurnover:false,isBidUp:true,close_time:tour.deals[0].timestamp},isDismissed:false}],onDismiss:function onDismiss(){return null;},soundsEnabled:false,mobile:false}));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(News,null));}}]);return DesktopTradeScreen;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);function OccasionalPopup(props){if(props.showInsufficientFundsMessage){// A/B test
return props.userId%2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PopupDeposit,{isFetching:props.isRefillFetching,onRefillDemoClick:props.refillDemoAccount,onDismiss:props.dismissInsufficientFundsMessage}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(InsufficientPopup,{isFetching:props.isRefillFetching,onRefillDemoClick:props.refillDemoAccount,onDismiss:props.dismissInsufficientFundsMessage});}if(props.showVerificationRequired){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VerificationRequiredPopup,{onDismiss:props.dismissVerificationRequiredMessage});}if(props.showIncreaseBidLimit!==false){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IncreaseBidLimitPopup,{onDismiss:props.dismissIncreaseBidLimitMessage});}if(props.showTradeIsClosing){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TradeIsClosingPopup,{onDismiss:props.dismissTradeIsClosing,time:props.timeUntilNextLockToggle});}if(props.showDemoTournament&&props.demoTournament){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__TradeModals_DemoTournamentPopup__["a" /* default */],{tournament:props.demoTournament,onDismiss:props.dismissDemoTournament});}return null;}function DesktopLayout(_ref3){var history=_ref3.history,location=_ref3.location,match=_ref3.match,props=_objectWithoutProperties(_ref3,["history","location","match"]);if(location.pathname!=="/trade"&&location.pathname!=="/sightseeing"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["d" /* Redirect */],{to:"/trade",replace:true});}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(DesktopTradeScreen,props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(OccasionalPopup,props));}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_22__withErrorCatch__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["g" /* withRouter */])(DesktopLayout)));

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(2029);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Toolbar__["a" /* default */]);

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Bar__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ToolsPopup__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SwitchStock__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToolSet__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GraphicalTools__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DealsStats__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_ClickOutside__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ToolBelt__ = __webpack_require__(2034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Icons_Tools__ = __webpack_require__(2035);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var shouldDisableOutsideClick=false;var Toolbar=function(_React$Component){_inherits(Toolbar,_React$Component);function Toolbar(){_classCallCheck(this,Toolbar);return _possibleConstructorReturn(this,(Toolbar.__proto__||Object.getPrototypeOf(Toolbar)).apply(this,arguments));}_createClass(Toolbar,[{key:"render",value:function render(){var props=this.props;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Bar__["a" /* default */],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"]("div",null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__SwitchStock__["b" /* default */],{value:props.activeStock,tabs:props.tabs,isOTC:props.isOTC,onChange:function onChange(stock){props.dispatch({type:"SET_ACTIVE_STOCK",payload:{newStock:stock,activeStock:props.activeStock}});},onNextActiveTab:function onNextActiveTab(tab){props.dispatch({type:"SET_ACTIVE_TAB",payload:tab});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ToolSet__["a" /* default */],{Icon:__WEBPACK_IMPORTED_MODULE_6__Icons__["l" /* InstrumentsIcon */],instruments:props.instruments,onClose:props.onClose},function(toolSet){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__ToolsPopup__["b" /* default */],{close:toolSet.close,onClick:toolSet.toggle,instruments:toolSet.instruments});}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_7__ToolSet__["a" /* default */],{Icon:__WEBPACK_IMPORTED_MODULE_6__Icons__["k" /* InstrumentIcon */],onClose:props.onClose},function(toolSet){return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_10__common_ClickOutside__["a" /* default */],{onOutsideClick:toolSet.close,disabled:shouldDisableOutsideClick},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_8__GraphicalTools__["a" /* default */],{lockOutsideClick:function lockOutsideClick(){return shouldDisableOutsideClick=true;},unlockOutsideClick:function unlockOutsideClick(){return shouldDisableOutsideClick=false;},onClick:toolSet.toggle,graphicalMode:props.graphicalMode,settings:props.settings,stock:props.activeStock,dispatch:props.dispatch}));}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2_styled_components__["a" /* ThemeConsumer */],null,function(theme){return "irontrade"==="irontrade"&&props.currency!=="THB"&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_11__ToolBelt__["a" /* default */],{value:props.tradeTheme,onClick:function onClick(theme){props.dispatch({type:"UPDATE_SETTINGS",payload:{theme:theme}});},buttons:[{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Icons_Tools__["a" /* ModeDark */],null),active:theme.mode==="dark",key:"default"},{icon:__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_12__Icons_Tools__["b" /* ModeLight */],null),active:theme.mode==="light",key:"light"}]});})),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_9__DealsStats__["a" /* default */],{deals:props.deals,mode:props.mode}));}}]);return Toolbar;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(_ref){var graphicalMode=_ref.graphicalMode,tabs=_ref.tabs,settings=_ref.settings,remoteTradeSettings=_ref.remoteTradeSettings,stocks=_ref.stocks,profile=_ref.profile;var activeStock=tabs.tabs[tabs.activeTab];return{graphicalMode:graphicalMode,activeStock:activeStock,settings:settings,tradeTheme:settings.theme,mode:settings.mode,tabs:tabs.tabs,indicators:settings.indicators,chartType:settings.chartType,lineColor:settings.lineColor,lineThickness:settings.lineThickness,interval:settings.interval,sentiments:settings.sentiments,isOTC:stocks!=null&&stocks[activeStock]!=null?stocks[activeStock].otc:false,currency:profile&&profile.currency};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Toolbar));

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  height: 53px;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n\n  @media (min-width: 960px) {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-right: 174px;\n  }\n"],["\n  position: relative;\n  height: 53px;\n  background-color: ",";\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n\n  @media (min-width: 960px) {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding-right: 174px;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.main;}));

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Tools */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GA__ = __webpack_require__(11);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 53px;\n  min-width: 42px;\n  font-size: 0;\n  line-height: 0;\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n"],["\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  height: 53px;\n  min-width: 42px;\n  font-size: 0;\n  line-height: 0;\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 0;\n  line-height: 0;\n"],["\n  display: inline-block;\n  vertical-align: middle;\n  font-size: 0;\n  line-height: 0;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 53px;\n  width: 34px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n"],["\n  display: flex;\n  align-items: center;\n  align-content: center;\n  justify-content: center;\n  height: 53px;\n  width: 34px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var ToolsView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Toggle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);function Tools(_ref){var children=_ref.children;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ToolsView,null,children);}var ToolSet=function(_React$Component){_inherits(ToolSet,_React$Component);function ToolSet(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,ToolSet);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=ToolSet.__proto__||Object.getPrototypeOf(ToolSet)).call.apply(_ref2,[this].concat(args))),_this),_this.state={isActive:false},_this.toggle=function(){_this.setState({isActive:!_this.state.isActive});if(typeof _this.props.onClose==="function"){_this.props.onClose();}},_this.close=function(){_this.setState({isActive:false});if(typeof _this.props.onClose==="function"){_this.props.onClose();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ToolSet,[{key:"render",value:function render(){var _this2=this;var _props=this.props,Icon=_props.Icon,children=_props.children,instruments=_props.instruments;var toggle=this.toggle;var close=this.close;var isActive=this.state.isActive;var tools=isActive&&typeof children==="function"?children({toggle:toggle,instruments:instruments,close:close}):null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,{active:isActive},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Tools,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Toggle,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Icon,{onClick:function onClick(){_this2.toggle();Object(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaReducer */])("CLICKBTN_SHOW_TRADE_SETTINGS");},isActive:isActive,className:"js-click-outside-disable"}))),tools);}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(nextProps,state){if(nextProps.instruments&&!state.isActive){return{isActive:true};}return null;}}]);return ToolSet;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ToolSet);

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tools__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HideTool__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 38px;\n  left: 0;\n  background-color: ",";\n  color: ",";\n  font-size: ",";\n  line-height: 1;\n  padding: 10px;\n  z-index: 2;\n  width: 270px;\n"],["\n  position: absolute;\n  top: 38px;\n  left: 0;\n  background-color: ",";\n  color: ",";\n  font-size: ",";\n  line-height: 1;\n  padding: 10px;\n  z-index: 2;\n  width: 270px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"],["\n  display: flex;\n  flex-direction: row;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 9px 11px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  border-bottom: 1px solid ",";\n\n  @media (min-width: 960px) {\n    height: 25px;\n    padding: 0 4px;\n  }\n"],["\n  direction: ",";\n  display: flex;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-self: flex-start;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 12px 9px 11px;\n  font-size: ",";\n  line-height: 1;\n  color: ",";\n  border-bottom: 1px solid ",";\n\n  @media (min-width: 960px) {\n    height: 25px;\n    padding: 0 4px;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  padding: 8px 0 0;\n  width: 100%;\n\n  // @media (min-width: 960px) {\n  //   overflow: hidden;\n  // }\n\n  @media (max-width: 959px) {\n    overflow: auto;\n  }\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  padding: 8px 0 0;\n  width: 100%;\n\n  // @media (min-width: 960px) {\n  //   overflow: hidden;\n  // }\n\n  @media (max-width: 959px) {\n    overflow: auto;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.popupDarkBackground;},function(_ref){var theme=_ref.theme;return theme.foreground;},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12));var HeadToolsContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Heading=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3,function(props){return props.theme.direction;},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14),function(props){return props.theme.accent;},function(props){return props.theme.mainSeparator;});var InnerContent=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var GraphicalTools=function(_React$Component){_inherits(GraphicalTools,_React$Component);function GraphicalTools(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,GraphicalTools);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=GraphicalTools.__proto__||Object.getPrototypeOf(GraphicalTools)).call.apply(_ref2,[this].concat(args))),_this),_this.state={coolTool:null},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GraphicalTools,[{key:"render",value:function render(){var _this2=this;var props=this.props;var tool=this.state.coolTool!=null&&props.settings.graphicalTools&&props.settings.graphicalTools[props.stock]&&props.settings.graphicalTools[props.stock].tools&&props.settings.graphicalTools[props.stock].tools[this.state.coolTool.index]||null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Heading,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_2__common_Gettext__["b" /* default */],null,"Horizontal line"),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](HeadToolsContainer,null,props.settings.graphicalTools&&props.settings.graphicalTools[props.stock]&&props.settings.graphicalTools[props.stock].tools.length>0&&__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_4__HideTool__["a" /* default */],{style:{marginRight:8,marginTop:-1},value:props.settings.graphicalTools[props.stock].enabled!==false,onClick:function onClick(value){return props.dispatch({type:"SET_GRAPHICAL_TOOLS_VISIBILITY",payload:{stock:props.stock,value:value}});}}),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Tools__["c" /* Remove */],{onClick:function onClick(){props.dispatch({type:"CLEAR_GRAPHICAL_TOOLS",payload:{activeStock:props.stock}});}})))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](InnerContent,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_3__Tools__["b" /* HorizontalLine */],{dispatch:props.dispatch,graphicalMode:props.graphicalMode||{},onToolCoolClick:function onToolCoolClick(tool,index){if(tool!=null&&index!=null){_this2.setState({coolTool:{tool:tool,index:index}});}else{_this2.setState({coolTool:null});}},editMode:tool!=null&&{tool:tool,index:this.state.coolTool.index}||null,tools:props.settings.graphicalTools&&props.settings.graphicalTools[props.stock]&&props.settings.graphicalTools[props.stock].tools||[],onClick:function onClick(){_this2.setState({coolTool:null});var resetGraphicalTool=function resetGraphicalTool(){props.unlockOutsideClick();props.dispatch({type:"SET_GRAPHICAL_MODE",payload:null});document.removeEventListener("click",resetGraphicalTool);};if(!props.graphicalMode.graphicalTool){// Reset graphical mode on any click
document.addEventListener("click",resetGraphicalTool);props.lockOutsideClick();props.dispatch({type:"SET_GRAPHICAL_MODE",payload:"horizontalLine"// type: "PUSH_GRAPHICAL_TOOL",
// payload: {
//   type: "horizontalLine",
//   anchorValue: this.props.lastPointValue
// }
});}}})));}}]);return GraphicalTools;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (GraphicalTools);

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_Kuchka__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__redux_reducer_deals__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Money__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  direction: ",";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding-right: 42px;\n"],["\n  direction: ",";\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  padding-right: 42px;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 0 10px;\n\n  :first-of-type {\n    ",";\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  padding: 0 10px;\n\n  :first-of-type {\n    ",";\n  }\n"]),_templateObject3=_taggedTemplateLiteral(["\n  font-size: 20px;\n  line-height: 1.2;\n  color: ",";\n"],["\n  font-size: 20px;\n  line-height: 1.2;\n  color: ",";\n"]),_templateObject4=_taggedTemplateLiteral(["\n  color: ",";\n"],["\n  color: ",";\n"]),_templateObject5=_taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #99959d;\n  white-space: nowrap;\n"],["\n  font-size: 12px;\n  color: #99959d;\n  white-space: nowrap;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.direction;});var Item=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2,function(_ref2){var theme=_ref2.theme;return Object(__WEBPACK_IMPORTED_MODULE_7__common_styled_mixins__["c" /* rtl */])("border-right","1px solid "+theme.ticksBorderColor);});var Value=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,function(_ref3){var theme=_ref3.theme;return theme.foreground;});var Profit=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(Value)(_templateObject4,function(_ref4){var isPositive=_ref4.isPositive,theme=_ref4.theme;return isPositive?theme.upper:theme.lower;});var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5);var DealsStats=function(_React$Component){_inherits(DealsStats,_React$Component);function DealsStats(){_classCallCheck(this,DealsStats);return _possibleConstructorReturn(this,(DealsStats.__proto__||Object.getPrototypeOf(DealsStats)).apply(this,arguments));}_createClass(DealsStats,[{key:"render",value:function render(){if(!this.props.deals.length)return null;if(!this.props.lastPoints.length)return null;var investment=0;var profit=0;var pointsByStock=this.props.lastPoints.reduce(function(res,point){res[point.stock]=point;return res;},{});this.props.deals.forEach(function(deal){var isProfitable=void 0;var point=pointsByStock[deal.stock];if(point&&point.value!==deal.value){if(point.value!==deal.value){isProfitable=deal.bidType?point.value>deal.value:point.value<deal.value;}}investment+=deal.amount;if(isProfitable!==undefined){profit+=isProfitable?deal.percent*deal.amount/100:-1*deal.amount;}});var currency=this.props.mode==="tournament"?__WEBPACK_IMPORTED_MODULE_3__Icons_Kuchka__["b" /* tournamentCurrency */]:null;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Value,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Money__["b" /* default */],{currency:currency},investment)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Total investment"))),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Item,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Profit,{isPositive:profit>=0},__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_6__Money__["b" /* default */],{currency:currency},profit)),__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Text,null,__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Current profit"))));}}]);return DealsStats;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(function(state,props){var lastPoints=[];var deals=[];state.tabs.tabs.forEach(function(tab){var points=state.points[tab];var lastPoint=points&&points.length>0?points[points.length-1]:null;if(lastPoint){lastPoints=lastPoints.concat([lastPoint]);}deals=deals.concat(Object(__WEBPACK_IMPORTED_MODULE_4__redux_reducer_deals__["b" /* getActiveDeals */])(tab,state.time,props.deals));});return{deals:deals,lastPoints:lastPoints};})(DealsStats));

/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_polished__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GA__ = __webpack_require__(11);
var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  vertical-align: middle;\n  height: 53px;\n  min-width: 42px;\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n"],["\n  position: relative;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  vertical-align: middle;\n  height: 53px;\n  min-width: 42px;\n\n  @media (max-width: 959px) {\n    height: 38px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  width: 36px;\n  height: 36px;\n  color: ",";\n  background-color: ",";\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :first-child {\n    border-radius: 8px 0 0 8px;\n  }\n\n  :last-child {\n    border-radius: 0 8px 8px 0;\n  }\n\n  :not(:first-of-type) {\n    margin-left: 1px;\n  }\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n"],["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-content: center;\n  width: 36px;\n  height: 36px;\n  color: ",";\n  background-color: ",";\n  transition: all 0.3s ease;\n  cursor: pointer;\n\n  :first-child {\n    border-radius: 8px 0 0 8px;\n  }\n\n  :last-child {\n    border-radius: 0 8px 8px 0;\n  }\n\n  :not(:first-of-type) {\n    margin-left: 1px;\n  }\n\n  :hover {\n    color: ",";\n  }\n\n  ",";\n"]),_templateObject3=_taggedTemplateLiteral(["\n      color: ",";\n      background-color: ",";\n      pointer-events: none;\n    "],["\n      color: ",";\n      background-color: ",";\n      pointer-events: none;\n    "]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Button=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2,Object(__WEBPACK_IMPORTED_MODULE_2_polished__["a" /* rgba */])("#919191",0.59),function(_ref){var theme=_ref.theme;return theme.background;},function(_ref2){var theme=_ref2.theme;return theme.foreground;},function(_ref3){var active=_ref3.active,theme=_ref3.theme;return active&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject3,theme.background,theme.themeToggleActive);});var ToolBelt=function ToolBelt(_ref4){var value=_ref4.value,onClick=_ref4.onClick,_ref4$buttons=_ref4.buttons,buttons=_ref4$buttons===undefined?[]:_ref4$buttons;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Container,null,buttons.map(function(_ref5){var icon=_ref5.icon,key=_ref5.key,active=_ref5.active;return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](Button,{key:key,active:active?active:key===value,onClick:function(_onClick){function onClick(){return _onClick.apply(this,arguments);}onClick.toString=function(){return _onClick.toString();};return onClick;}(function(){Object(__WEBPACK_IMPORTED_MODULE_3__GA__["a" /* gaReducer */])("CLICKBTN_CHANGE_THEME",{theme:key==="dark"||key==="default"?"night":"day"});return onClick(key);})},icon);}));};/* harmony default export */ __webpack_exports__["a"] = (ToolBelt);

/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModeLight__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModeDark__ = __webpack_require__(2037);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__ModeLight__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__ModeDark__["a"]; });


/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ModeLight;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function ModeLight(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"18px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 17.998 18.002",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-9908.881-12925.879v-1.407a.881.881,0,0,1,.88-.88.879.879,0,0,1,.881.88v1.407a.879.879,0,0,1-.881.88A.881.881,0,0,1-9908.881-12925.879Zm6-1.758-.993-.994a.878.878,0,0,1,0-1.244.879.879,0,0,1,1.244,0l.993,1a.873.873,0,0,1,0,1.24.877.877,0,0,1-.622.259A.881.881,0,0,1-9902.882-12927.637Zm-11.482,0a.879.879,0,0,1,0-1.244l.994-.994a.879.879,0,0,1,1.244,0,.878.878,0,0,1,0,1.244l-.994.994a.879.879,0,0,1-.622.259A.879.879,0,0,1-9914.364-12927.637Zm1.854-6.363a4.516,4.516,0,0,1,4.509-4.509,4.516,4.516,0,0,1,4.509,4.509,4.515,4.515,0,0,1-4.509,4.509A4.516,4.516,0,0,1-9912.51-12934Zm11.224.88a.881.881,0,0,1-.881-.88.879.879,0,0,1,.881-.88h1.406a.878.878,0,0,1,.88.88.88.88,0,0,1-.88.88Zm-14.835,0a.879.879,0,0,1-.877-.88.878.878,0,0,1,.877-.88h1.409a.878.878,0,0,1,.877.88.879.879,0,0,1-.877.88Zm12.246-5a.878.878,0,0,1,0-1.244l.993-.994a.882.882,0,0,1,1.248,0,.885.885,0,0,1,0,1.244l-1,.994a.879.879,0,0,1-.622.258A.876.876,0,0,1-9903.875-12938.125Zm-9.492,0-1-.994a.879.879,0,0,1,0-1.244.878.878,0,0,1,1.244,0l1,.994a.883.883,0,0,1,0,1.244.878.878,0,0,1-.623.258A.872.872,0,0,1-9913.367-12938.125Zm4.486-2.589v-1.406a.881.881,0,0,1,.88-.881.88.88,0,0,1,.881.881v1.406a.879.879,0,0,1-.881.88A.881.881,0,0,1-9908.881-12940.714Z",transform:"translate(9916.998 12943.001)"}));}

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ModeDark;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function ModeDark(_ref){var _ref$width=_ref.width,width=_ref$width===undefined?"13px":_ref$width,_ref$fill=_ref.fill,fill=_ref$fill===undefined?"currentColor":_ref$fill,props=_objectWithoutProperties(_ref,["width","fill"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 12.844 14.471",fill:fill,width:width},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M4.9,9.043a7.287,7.287,0,0,1,.984-3.662.341.341,0,0,0-.369-.508A7.346,7.346,0,1,0,12.757,16.95a.339.339,0,0,0-.268-.563c-.079,0-.159.005-.239.005A7.349,7.349,0,0,1,4.9,9.043Z",transform:"translate(0 -4.862)"}));}

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TradeControls__ = __webpack_require__(778);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__TradeControls__["b" /* default */]);

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Header */
/* unused harmony export Content */
/* unused harmony export Sidebar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Tour__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Protection__ = __webpack_require__(178);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: ","; /* TODO: \u0443\u0431\u0440\u0430\u0442\u044C, \u0446\u0432\u0435\u0442\u0430\u043C \u0442\u0443\u0442 \u043D\u0435 \u043C\u0435\u0441\u0442\u043E */\n  font-family: Roboto, Arial, Sans-Serif;\n  user-select: none;\n\n  ",";\n"],["\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: ","; /* TODO: \u0443\u0431\u0440\u0430\u0442\u044C, \u0446\u0432\u0435\u0442\u0430\u043C \u0442\u0443\u0442 \u043D\u0435 \u043C\u0435\u0441\u0442\u043E */\n  font-family: Roboto, Arial, Sans-Serif;\n  user-select: none;\n\n  ",";\n"]),_templateObject2=_taggedTemplateLiteral(["\n      filter: blur(2px);\n    "],["\n      filter: blur(2px);\n    "]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n"],["\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  will-change: transform;\n"],["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  will-change: transform;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n"],["\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  z-index: 2;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// <Layout>
// +-----------------------------------+
// |             <Header/>             |
// +----------------------+------------+
// |                      |            |
// |                      |            |
// |      <Content/>      | <Sidebar/> |
// |                      |            |
// |                      |            |
// +----------------------+------------+
// </Layout>
var LayoutView=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(props){return props.theme.main;},function(_ref){var tour=_ref.tour;return tour!=null&&Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["c" /* css */])(_templateObject2);});var Header=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4);var Sidebar=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);function OrderSensitiveDesktopLayout(props){var _props$children=_slicedToArray(props.children,5),header=_props$children[0],toolbar=_props$children[1],controls=_props$children[2],chart=_props$children[3],news=_props$children[4];var tour=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_2__Tour__["a" /* TourContext */]);var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(true),_useState2=_slicedToArray(_useState,2),showChart=_useState2[0],setShowChart=_useState2[1];var handleVisibilityChange=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useCallback"])(function(){if(document.hidden){setShowChart(false);}else{setShowChart(true);}},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(document.hidden!==undefined){document.addEventListener("visibilitychange",handleVisibilityChange,false);return function(){document.removeEventListener("visibilitychange",handleVisibilityChange,false);};}});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LayoutView,{tour:tour},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header,{style:{height:props.headerHeight}},header,toolbar),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Sidebar,{style:{top:props.headerHeight-53,width:props.sidebarWidth}},controls),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,{style:{top:props.headerHeight+30,right:props.sidebarWidth}},showChart&&chart,news),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Protection__["a" /* default */],{dealsToCompensate:props.dealsToCompensate,onCompensation:props.onCompensation,compensationUpdated:props.compensationUpdated,compensationCreated:props.compensationCreated,onCompensationCreated:props.onCompensationCreated,isDesktop:true,activeAccount:props.activeAccount}));}/* harmony default export */ __webpack_exports__["a"] = (OrderSensitiveDesktopLayout);

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Link__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons_Close__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Tournaments_Api__ = __webpack_require__(14);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"],["\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 20003;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 40px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 32px 16px 38px;\n    border-radius: 0;\n  }\n\n  @media (max-height: 500px) {\n    overflow-y: auto;\n    position: relative;\n    justify-content: space-between;\n  }\n"],["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  width: 740px;\n  padding: 40px 35px 32px;\n  color: ",";\n  background-color: ",";\n  border-radius: 4px;\n  text-align: center;\n\n  @media (max-width: 959px) {\n    top: 0;\n    left: 0;\n    transform: none;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    padding: 32px 16px 38px;\n    border-radius: 0;\n  }\n\n  @media (max-height: 500px) {\n    overflow-y: auto;\n    position: relative;\n    justify-content: space-between;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  top: 19px;\n  right: 19px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #717171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  margin-bottom: 33px;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    margin-bottom: 21px;\n  }\n\n  @media (max-height: 500px) {\n    margin-bottom: 0;\n  }\n"],["\n  margin-bottom: 33px;\n  font-size: ",";\n  line-height: 1.2;\n  color: ",";\n  font-weight: 700;\n\n  @media (max-width: 959px) {\n    margin-bottom: 21px;\n  }\n\n  @media (max-height: 500px) {\n    margin-bottom: 0;\n  }\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  margin-bottom: 20px;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (max-height: 500px) {\n    margin-bottom: 10px;\n  }\n"],["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  margin-bottom: 20px;\n\n  @media (max-width: 959px) {\n    font-size: ",";\n  }\n\n  @media (max-height: 500px) {\n    margin-bottom: 10px;\n  }\n"]),_templateObject7=_taggedTemplateLiteral(["\n  color: ",";\n  &:hover {\n    text-decoration: none;\n  }\n"],["\n  color: ",";\n  &:hover {\n    text-decoration: none;\n  }\n"]),_templateObject8=_taggedTemplateLiteral(["\n  flex-shrink: 0;\n  width: 157px;\n  height: 136px;\n  margin: 0 auto 23px;\n\n  @media (max-height: 500px) {\n    margin-bottom: 0;\n  }\n"],["\n  flex-shrink: 0;\n  width: 157px;\n  height: 136px;\n  margin: 0 auto 23px;\n\n  @media (max-height: 500px) {\n    margin-bottom: 0;\n  }\n"]),_templateObject9=_taggedTemplateLiteral(["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  margin-bottom: 19px;\n  font-weight: 500;\n\n  @media (max-width: 959px) {\n    margin-bottom: 21px;\n    font-weight: bold;\n  }\n\n  @media (max-height: 500px) {\n    margin-bottom: 0;\n  }\n"],["\n  font-size: ",";\n  line-height: 1.5;\n  color: ",";\n  margin-bottom: 19px;\n  font-weight: 500;\n\n  @media (max-width: 959px) {\n    margin-bottom: 21px;\n    font-weight: bold;\n  }\n\n  @media (max-height: 500px) {\n    margin-bottom: 0;\n  }\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n"],["\n  display: flex;\n  justify-content: center;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"],["\n  position: relative;\n  min-width: 140px;\n  padding: 12px 36px;\n  font-weight: bold;\n  font-size: ",";\n  color: #ffffff;\n  text-decoration: none;\n  text-transform: uppercase;\n  background-image: linear-gradient(to right, #47c0c8 0%, #5c6cc0 100%);\n  border: none;\n  border-radius: 32px;\n  cursor: pointer;\n  z-index: 2;\n\n  ::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n    display: block;\n    background-image: linear-gradient(to right, #5c6cc0 0%, #47c0c8 100%);\n    border-radius: inherit;\n    z-index: -1;\n    opacity: 0;\n    transition: opacity 0.5s;\n  }\n\n  :hover::before {\n    opacity: 1;\n  }\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject3,function(_ref){var theme=_ref.theme;return theme.mode==="light"?"#919191":"#CCCCCC";},function(_ref2){var theme=_ref2.theme;return theme.mode==="light"?"#F5F5F5":"#272B34";});var CloseButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].button(_templateObject4);var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject5,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(28),function(_ref3){var theme=_ref3.theme;return theme.mode==="light"?"#343434":"#ffffff";});var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject6,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14),function(_ref4){var theme=_ref4.theme;return theme.mode==="light"?"#919191":"#CCCCCC";},Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(14));var Link=Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__common_Link__["a" /* Link */])(_templateObject7,function(_ref5){var theme=_ref5.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";});var Img=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].img(_templateObject8);var Percent=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(36),function(_ref6){var theme=_ref6.theme;return theme.mode==="light"?"#0085EB":"#FFCC00";});var ButtonBlock=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject10);var Button=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].button(_templateObject11,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12));var EarlySalePopup=function EarlySalePopup(_ref7){var activeStock=_ref7.activeStock,dispatch=_ref7.dispatch;// Попап актива дня. Вылезает при старте при условии, что:
// - Актив дня есть
// - Клиент им уже не торгует
// - В этой сессии пока не вылезал
// Используем новомодные апи, чтобы не иметь дела с недостатком данных
var api=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_7__Tournaments_Api__["c" /* default */]);var assetsEntity=api.readEntity("/api/getAssets");if(assetsEntity.status==="Pending"&&assetsEntity.value==null){// Мне стыдно, что такая деталь просочилась в продуктовый код, работаем с
// тем, что есть. (throw Promise даёт реакту понять, что мы пока не готовы)
throw assetsEntity.promise;}var assets=assetsEntity.value;var assetOfTheDay=null;// Ходим в поисках актива дня. Помним, что его может и не быть.
if(assets){var _iteratorNormalCompletion=true;var _didIteratorError=false;var _iteratorError=undefined;try{cycle:for(var _iterator=Object.keys(assets)[Symbol.iterator](),_step;!(_iteratorNormalCompletion=(_step=_iterator.next()).done);_iteratorNormalCompletion=true){var category=_step.value;var _iteratorNormalCompletion2=true;var _didIteratorError2=false;var _iteratorError2=undefined;try{for(var _iterator2=assets[category][Symbol.iterator](),_step2;!(_iteratorNormalCompletion2=(_step2=_iterator2.next()).done);_iteratorNormalCompletion2=true){var asset=_step2.value;if(asset.pickOfTheDay===true){assetOfTheDay=asset;break cycle;}}}catch(err){_didIteratorError2=true;_iteratorError2=err;}finally{try{if(!_iteratorNormalCompletion2&&_iterator2.return){_iterator2.return();}}finally{if(_didIteratorError2){throw _iteratorError2;}}}}}catch(err){_didIteratorError=true;_iteratorError=err;}finally{try{if(!_iteratorNormalCompletion&&_iterator.return){_iterator.return();}}finally{if(_didIteratorError){throw _iteratorError;}}}}// Preseerved Stock of The Day — это айди актива, попап о котором мы уже пока-
// зывали. Нужен чтобы не повторяться.
var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(function(){try{return sessionStorage.getItem("stock_of_the_day");}catch(error){return null;}}),_useState2=_slicedToArray(_useState,1),preservedStockOfTheDay=_useState2[0];// Переменная engaged диктует, показывать попап или нет. Мы включаем её по-
// умолчанию только если это уместно:
var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(assetOfTheDay!=null&&assetOfTheDay.stock!==activeStock&&assetOfTheDay.stock!==preservedStockOfTheDay),_useState4=_slicedToArray(_useState3,2),engaged=_useState4[0],setEngaged=_useState4[1];// Эффект для запоминания уже показанного в рамках сесии.
Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(engaged&&assetOfTheDay!=null){try{sessionStorage.setItem("stock_of_the_day",assetOfTheDay.stock);}catch(error){}}},[engaged,assetOfTheDay]);function onClose(){setEngaged(false);}function onAccept(){setEngaged(false);dispatch({type:"SWITCH_TO_STOCK",payload:assetOfTheDay.stock});}if(!engaged||assetOfTheDay==null){return null;}var _assetOfTheDay=assetOfTheDay,stock=_assetOfTheDay.stock,profit=_assetOfTheDay.profit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,{onClick:onClose}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons_Close__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Get higher profit!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{src:"/img/flags-analytics/"+stock.toLowerCase()+".png",alt:stock.toLowerCase(),onError:function onError(e){e.target.onerror=null;e.target.style="display:none";}}),profit&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Percent,null,profit,"%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Today ",stock," is traded with a higher profit percentage!")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Start trading more efficiently with this ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Link,{to:"/news/profitpercent"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"tutorial about profit percentage")),".")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ButtonBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Button,{onClick:onAccept},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"Try now")))));};function Popup(_ref8){var activeStock=_ref8.activeStock,dispatch=_ref8.dispatch;// Магия Suspense — ради чего выше был throw Promise. Будет показывать
// fallback пока данные не готовы! В данном случае не покажет ничего!
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Suspense"],{fallback:null},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(EarlySalePopup,{activeStock:activeStock,dispatch:dispatch}));}function mapStateToProps(state){return{activeStock:state.tabs.tabs[state.tabs.activeTab]};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Popup));

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = AddToHomeScreen;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__GA__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Button__ = __webpack_require__(109);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n  max-width: 479px;\n  padding: 1.5em;\n  font-size: ",";\n  line-height: 1.5;\n  color: #414141;\n\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  border-top: 1px solid #ccc;\n  border-right: 1px solid #ccc;\n  background: #fff;\n  text-align: center;\n  z-index: 17000000;\n  box-shadow: 0px 0px 3px #ccc;\n\n  @media all and (display-mode: standalone) {\n    display: none;\n  }\n"],["\n  display: flex;\n  flex-direction: column;\n  align-content: space-between;\n  flex-grow: 1;\n  flex-shrink: 1;\n  width: 100%;\n  max-width: 479px;\n  padding: 1.5em;\n  font-size: ",";\n  line-height: 1.5;\n  color: #414141;\n\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  border-top: 1px solid #ccc;\n  border-right: 1px solid #ccc;\n  background: #fff;\n  text-align: center;\n  z-index: 17000000;\n  box-shadow: 0px 0px 3px #ccc;\n\n  @media all and (display-mode: standalone) {\n    display: none;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  flex-grow: 1;\n  flex-shrink: 0;\n  margin-bottom: 10px;\n"],["\n  flex-grow: 1;\n  flex-shrink: 0;\n  margin-bottom: 10px;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  width: 100%;\n"],["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-content: center;\n  justify-content: space-between;\n  width: 100%;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  color: #a7a7a7;\n  text-decoration: underline;\n  cursor: pointer;\n  user-select: none;\n"],["\n  color: #a7a7a7;\n  text-decoration: underline;\n  cursor: pointer;\n  user-select: none;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  width: auto;\n  min-width: 8.75em;\n  margin-left: auto;\n  user-select: none;\n"],["\n  width: auto;\n  min-width: 8.75em;\n  margin-left: auto;\n  user-select: none;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.locale==="ar"?theme.minFontSize:"14px";});var Content=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Buttons=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var CancelButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].span(_templateObject4);var AllowButton=Object(__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */])(__WEBPACK_IMPORTED_MODULE_4__Button__["a" /* default */])(_templateObject5);var STORAGE_KEY="a2hs";function AddToHomeScreen(props){var gaSent=false;var setupWebapp=window.setupWebapp;var wrongPages=["/fillup","/verification","/sightseeing"];var inTheWrongPlaceAtTheWrongTime=wrongPages.reduce(function(isWrongPage,page){if(isWrongPage)return true;return window.location.pathname.startsWith(page);},false);// Chrome will show mini-infobar starting from 68 version
// https://developers.google.com/web/updates/2018/06/a2hs-updates
var chromeCheck=/Chrome\/(\d+)/.exec(window.navigator.userAgent);var chromeIsShowingInfobar=props.isMobile&&chromeCheck&&parseInt(chromeCheck[1],10)>=68;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),deferredPrompt=_useState2[0],setDeferredPrompt=_useState2[1];var _useState3=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState4=_slicedToArray(_useState3,2),display=_useState4[0],setDisplay=_useState4[1];var eventHandler=function eventHandler(e){// Prevent Chrome 67 and earlier from automatically showing the prompt
e.preventDefault();// Stash the event so it can be triggered later.
setDeferredPrompt(e);};var clickHandler=function clickHandler(){setDisplay(false);// window.setupWebapp = null;
if(deferredPrompt){deferredPrompt.prompt();deferredPrompt.userChoice.then(function(choiceResult){if(choiceResult.outcome==="accepted"){Object(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaReducer */])("WEBAPP_INSTALL");console.log("User accepted the A2HS prompt");}else{Object(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaReducer */])("WEBAPP_DECLINE");console.log("User dismissed the A2HS prompt");}setDeferredPrompt(null);});}Object(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaReducer */])("WEBAPP_ACCEPT");};var closeHandler=function closeHandler(){try{localStorage.setItem(STORAGE_KEY,Date.now());}catch(error){}setDeferredPrompt(null);setDisplay(false);// window.setupWebapp = null; // crashes somewhat somehow if open on /setup-webapp
Object(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaReducer */])("WEBAPP_NOTNOW");};Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){window.addEventListener("beforeinstallprompt",eventHandler);return function(){window.removeEventListener("beforeinstallprompt",eventHandler);};},[]);Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){if(setupWebapp){setDisplay(true);return null;}var storage=void 0;try{storage=localStorage.getItem(STORAGE_KEY);}catch(error){}setDisplay(true);if(storage){var then=new Date(parseInt(storage,10));var now=new Date();var silentPeriod=1;// Do not display the popup if user closed it earlier today
if(Math.abs(then.getDate()-now.getDate())<=silentPeriod){setDisplay(false);}}},[setupWebapp]);if(inTheWrongPlaceAtTheWrongTime||chromeIsShowingInfobar||!deferredPrompt||!display){return null;}if(!gaSent){Object(__WEBPACK_IMPORTED_MODULE_2__GA__["a" /* gaReducer */])("WEBAPP_SHOW");gaSent=true;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Content,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"We have a smooth and fantastic web-app version of our website. Please allow the browser to add it to your home screen.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Buttons,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CancelButton,{onClick:closeHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"NO THANKS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AllowButton,{color:"green",onClick:clickHandler},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__common_Gettext__["b" /* default */],null,"ALLOW"))));}

/***/ }),
/* 2042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_add_to_home_screen_bg_png__ = __webpack_require__(2043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__images_add_to_home_screen_bg_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__images_add_to_home_screen_bg_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Icons_IronLogo__ = __webpack_require__(2044);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icons__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_iosVersion__ = __webpack_require__(2046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__GA__ = __webpack_require__(11);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 16000001;\n"],["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 16000001;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2);\n"],["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.2);\n"]),_templateObject3=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 9px;\n  left: 9px;\n  right: 9px;\n  bottom: 18px;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  border-radius: 8px;\n"],["\n  position: absolute;\n  top: 9px;\n  left: 9px;\n  right: 9px;\n  bottom: 18px;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n  border-radius: 8px;\n"]),_templateObject4=_taggedTemplateLiteral(["\n  flex-grow: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  background-image: url(","),\n    linear-gradient(to bottom, #47c0c8 0%, #5d67c0 100%);\n  background-size: cover;\n  background-repeat: no-repeat;\n  border-radius: 8px 8px 0 0;\n"],["\n  flex-grow: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 10px;\n  background-image: url(","),\n    linear-gradient(to bottom, #47c0c8 0%, #5d67c0 100%);\n  background-size: cover;\n  background-repeat: no-repeat;\n  border-radius: 8px 8px 0 0;\n"]),_templateObject5=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  margin-bottom: 70px;\n  background-color: #ffffff;\n  border-radius: 8px;\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 60px;\n  height: 60px;\n  margin-bottom: 70px;\n  background-color: #ffffff;\n  border-radius: 8px;\n"]),_templateObject6=_taggedTemplateLiteral(["\n  font-size: 28px;\n  font-weight: 700;\n"],["\n  font-size: 28px;\n  font-weight: 700;\n"]),_templateObject7=_taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n"],["\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 24px;\n"]),_templateObject8=_taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 121px;\n  border-radius: 0 0 8px 8px;\n"],["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 121px;\n  border-radius: 0 0 8px 8px;\n"]),_templateObject9=_taggedTemplateLiteral(["\n  margin-top: 23px;\n  margin-bottom: 29px;\n  font-size: ",";\n  color: #222222;\n"],["\n  margin-top: 23px;\n  margin-bottom: 29px;\n  font-size: ",";\n  color: #222222;\n"]),_templateObject10=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),_templateObject11=_taggedTemplateLiteral(["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  display: block;\n  width: 26px;\n  height: 13px;\n  margin-left: -13px;\n  border-top: 13px solid #ffffff;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n"],["\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  display: block;\n  width: 26px;\n  height: 13px;\n  margin-left: -13px;\n  border-top: 13px solid #ffffff;\n  border-left: 13px solid transparent;\n  border-right: 13px solid transparent;\n"]),_templateObject12=_taggedTemplateLiteral(["\n  margin-left: 17px;\n  margin-right: 22px;\n"],["\n  margin-left: 17px;\n  margin-right: 22px;\n"]),_templateObject13=_taggedTemplateLiteral(["\n  margin-right: 22px;\n"],["\n  margin-right: 22px;\n"]),_templateObject14=_taggedTemplateLiteral([""],[""]),_templateObject15=_taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 10;\n  top: 20px;\n  right: 18px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #ffffff;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"],["\n  position: absolute;\n  z-index: 10;\n  top: 20px;\n  right: 18px;\n  display: block;\n  width: 20px;\n  height: 20px;\n  padding: 0;\n  color: #ffffff;\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Wrapper=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject);var Overlay=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject2);var Container=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject3);var TopBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject4,__WEBPACK_IMPORTED_MODULE_2__images_add_to_home_screen_bg_png___default.a);var IconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject5);var Title=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].h3(_templateObject6);var Subtitle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject7);var BottomBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject8);var Description=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].p(_templateObject9,Object(__WEBPACK_IMPORTED_MODULE_5__common_styled_mixins__["a" /* fontSize */])(12));var IconsBlock=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject10);var Triangle=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject11);var ShareIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject12);var ArrowIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject13);var AddButtonIconContainer=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].div(_templateObject14);var CloseButton=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].button(_templateObject15);var A2HS_LS_KEY="a2hs_ios_ppp";var AddToHomeScreen=function(_React$Component){_inherits(AddToHomeScreen,_React$Component);function AddToHomeScreen(){var _ref;var _temp,_this,_ret;_classCallCheck(this,AddToHomeScreen);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=AddToHomeScreen.__proto__||Object.getPrototypeOf(AddToHomeScreen)).call.apply(_ref,[this].concat(args))),_this),_this.state={show:false},_this.checkState=function(){var ios=Object(__WEBPACK_IMPORTED_MODULE_7__common_iosVersion__["a" /* getIOSSemver */])();var properIos=ios&&(ios.major>11||ios.major===11&&ios.minor>=3);var portrait=window.innerWidth<window.innerHeight;var restrictedPage=/fillup|withdraw|sightseeing|verification/g.test(window.location.pathname);var webapp="standalone"in window.navigator&&window.navigator.standalone;var safari=/^((?!chrome|android|crios).)*safari/i.test(navigator.userAgent.toLowerCase());var iron="irontrade"==="irontrade";if(!portrait||!properIos||restrictedPage||webapp||!safari||!iron){return _this.setState({show:false});}if(window.setupWebapp){return _this.setState({show:true});}if(_this.props.sessionCount!==null){try{var showCount=1;var closeCount=0;var sessionCount=_this.props.sessionCount;var ls=localStorage.getItem(A2HS_LS_KEY);if(ls){var _ls$split=ls.split(","),_ls$split2=_slicedToArray(_ls$split,3),show=_ls$split2[0],close=_ls$split2[1],session=_ls$split2[2];showCount=parseInt(show,10);closeCount=parseInt(close,10);sessionCount=parseInt(session,10);if(_this.props.sessionCount===sessionCount&&showCount<=closeCount){return null;}}if(_this.props.sessionCount!==sessionCount){sessionCount=_this.props.sessionCount;showCount+=1;}if(showCount>2||closeCount>2){return null;}localStorage.setItem(A2HS_LS_KEY,showCount+","+closeCount+","+sessionCount);}catch(error){}_this.setState({show:true});Object(__WEBPACK_IMPORTED_MODULE_8__GA__["a" /* gaReducer */])("IOS_WEBAPP_POPUP_SHOW");}},_this.closePopup=function(){window.setupWebapp=undefined;if(_this.props.sessionCount!==null){try{var ls=localStorage.getItem(A2HS_LS_KEY);if(ls){var _ls$split3=ls.split(","),_ls$split4=_slicedToArray(_ls$split3,3),show=_ls$split4[0],close=_ls$split4[1],session=_ls$split4[2];localStorage.setItem(A2HS_LS_KEY,show+","+(parseInt(close,10)+1)+","+session);}}catch(error){}}_this.setState({show:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(AddToHomeScreen,[{key:"componentDidMount",value:function componentDidMount(){this.checkState();window.addEventListener("resize",this.checkState);}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("resize",this.checkState);}},{key:"render",value:function render(){if(!this.state.show){return null;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Wrapper,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Overlay,null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CloseButton,{onClick:this.closePopup},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons__["c" /* CloseIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(TopBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Icons_IronLogo__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Title,null,"irontrade"==="irontrade"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Install IronTrade")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Subtitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"to your device"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(BottomBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Description,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__common_Gettext__["b" /* default */],null,"Tap Share and then Add to homescreen")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(IconsBlock,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ShareIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons__["d" /* ShareIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(ArrowIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons__["b" /* ArrowIcon */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddButtonIconContainer,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Icons__["a" /* AddButtonIcon */],null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Triangle,null)));}}]);return AddToHomeScreen;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);/* harmony default export */ __webpack_exports__["a"] = (AddToHomeScreen);

/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/add-to-home-screen-bg.06bbfe06.png";

/***/ }),
/* 2044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var IronLogo=function IronLogo(_ref){var _ref$firstColor=_ref.firstColor,firstColor=_ref$firstColor===undefined?"#3b9478":_ref$firstColor,_ref$secondColor=_ref.secondColor,secondColor=_ref$secondColor===undefined?"#1b546a":_ref$secondColor;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"43.545",height:"31.815",viewBox:"0 0 43.545 31.815"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-295.904 -72.54)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2829.636-800.793l-2-2,4.448-4.449-3.611-3.612,9.557-9.557,3.612,3.611,4.43-4.43,2,2-4.43,4.43,3.612,3.612-9.557,9.556-3.611-3.611-4.448,4.448Zm2.911-10.133,5.217,5.217,5.4-5.4-5.217-5.218Z",transform:"translate(-2508.622 905.147)",fill:firstColor}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M2456.1-974.343l4.455-4.454-3.614-3.616L2478-1003.473l3.614,3.616,4.288-4.288,2.009,2.009-4.289,4.289,3.6,3.6-21.059,21.06-3.6-3.6-4.454,4.454Z",transform:"translate(-2160.197 1076.684)",fill:secondColor})));};/* harmony default export */ __webpack_exports__["a"] = (IronLogo);

/***/ }),
/* 2045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CloseIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ShareIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ArrowIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AddButtonIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(1);
var _templateObject=_taggedTemplateLiteral(["\n  display: block;\n"],["\n  display: block;\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Icon=__WEBPACK_IMPORTED_MODULE_1_styled_components__["d" /* default */].svg(_templateObject);var CloseIcon=function CloseIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",width:"21.213",height:"20.506",viewBox:"0 0 21.213 20.506",fill:"currentColor"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M-36.1,27.021l-8.485,8.485L-46,34.092l8.485-8.485-9.193-9.193L-45.292,15l9.192,9.192L-26.908,15l1.414,1.414-9.192,9.192,8.486,8.486-1.415,1.414Z",transform:"translate(46.708 -15)"}));};var ShareIcon=function ShareIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"20.351",height:"28.033",viewBox:"0 0 20.351 28.033"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M20.351,28.032H0V7.938H7.5V9H1.071V26.975H19.28V9H12.853V7.939h7.5V28.032h0ZM9.64,17.985V2.041L6.249,5.39l-.757-.748L10.193,0l.758.748,3.944,3.894-.758.748L10.711,2.007V17.985Z",fill:"#0085eb"}));};var ArrowIcon=function ArrowIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"16",height:"16",viewBox:"0 0 16 16"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M8,0,6.545,1.455l5.506,5.506H0V9.039H12.052L6.545,14.545,8,16l8-8Z",fill:"#b5b7be"}));};var AddButtonIcon=function AddButtonIcon(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Icon,{xmlns:"http://www.w3.org/2000/svg",width:"36.854",height:"36.854",viewBox:"0 0 36.854 36.854"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M3180,1141.184v-13.513c0-4.3.026-6.757,2.457-9.214s4.914-2.457,9.214-2.457h13.513c4.3,0,6.757,0,9.214,2.457s2.457,4.914,2.457,9.214v13.513c0,4.3,0,6.757-2.457,9.214s-4.915,2.457-9.214,2.457H3191.67c-4.3,0-6.757,0-9.214-2.457S3180,1145.484,3180,1141.184Z",transform:"translate(-3180 -1116)",fill:"#f5f5f5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(-114.073 -10.671)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(106.175 3.426)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M13.192,19.3H6.114c-2.282,0-3.54,0-4.826-1.287S0,15.474,0,13.192V6.114c0-2.2,0-3.526,1.287-4.827S3.9,0,6.114,0h7.079c2.282,0,3.539,0,4.826,1.287s1.288,2.544,1.288,4.827v7.078c0,2.282,0,3.539-1.288,4.825S15.474,19.3,13.192,19.3ZM8.775,10.249h.438v3.509h.879V10.249H13.6V9.371H10.093V5.861H9.214v3.51H5.7v.878Z",transform:"translate(16.672 16.515)",fill:"#0085eb",stroke:"rgba(0,0,0,0)",strokeWidth:"1"})))));};

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIOSSemver;
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Semver=function(){function Semver(major,minor,patch){_classCallCheck(this,Semver);this.major=major;this.minor=minor;this.patch=patch;}_createClass(Semver,[{key:"toString",value:function toString(){return this.major+"_"+this.minor+"_"+this.patch;}}]);return Semver;}();function isIOS(){var ua=window.navigator.userAgent;return ua.indexOf("iPhone")>0||ua.indexOf("iPad")>0;}function getIOSSemver(){if(isIOS()){var extract=window.navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);return new Semver(parseInt(extract[1]||0,10),parseInt(extract[2]||0,10),parseInt(extract[3]||0,10));}else{return null;// or [0,0,0]
}}

/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_idx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_idx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_hooks__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Gettext__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_Popup__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Buttons_FlatButton__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ModalProvider__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Tournaments_Api__ = __webpack_require__(14);
var _this=this;var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  margin: 0 auto 40px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 960px) {\n    max-width: 300px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-right: 32px;\n    padding-left: 32px;\n  }\n"],["\n  width: 100%;\n  margin: 0 auto 40px;\n  font-weight: 500;\n  font-size: 18px;\n  line-height: 21px;\n  color: ",";\n  text-align: center;\n\n  @media (min-width: 960px) {\n    max-width: 300px;\n  }\n\n  @media (max-width: 959px) and (min-width: 480px) {\n    padding-right: 32px;\n    padding-left: 32px;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  margin-bottom: 40px;\n  color: #96949b;\n  text-align: center;\n"],["\n  margin-bottom: 40px;\n  color: #96949b;\n  text-align: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  margin-top: 40px;\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n  background: transparent;\n  border: none;\n  border-radius: none;\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n  }\n"],["\n  margin-top: 40px;\n  font-size: ",";\n  color: ",";\n  text-decoration: underline;\n  background: transparent;\n  border: none;\n  border-radius: none;\n  cursor: pointer;\n\n  ",";\n\n  :hover,\n  :focus,\n  :active {\n    text-decoration: none;\n  }\n"]),_templateObject4=_taggedTemplateLiteral(["\n      font-size: 16px;\n    "],["\n      font-size: 16px;\n    "]);function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Title=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].div(_templateObject,function(_ref){var theme=_ref.theme;return theme.foreground;});var Text=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].span(_templateObject2);var LaterButton=__WEBPACK_IMPORTED_MODULE_2_styled_components__["d" /* default */].button(_templateObject3,function(_ref2){var theme=_ref2.theme;return theme.locale==="ar"?theme.minFontSize:"12px";},function(_ref3){var theme=_ref3.theme;return theme.alternativeAccent;},function(_ref4){var theme=_ref4.theme;return theme.direction==="rtl"&&Object(__WEBPACK_IMPORTED_MODULE_2_styled_components__["c" /* css */])(_templateObject4);});var InvitePopup=function InvitePopup(props){var onDismiss=function onDismiss(){props.addTournamentToShowedList();props.onDismiss();};var popupProps=Object.assign({},props,{onDismiss:onDismiss,mobileColumn:true});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Tournaments_Popups_Popup__["a" /* StyledPopup */],popupProps,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Title,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Use your invitation!")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Text,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"You've got a free invitation to the tournament ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"\"",props.info.title,"\""),".")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Buttons_FlatButton__["a" /* default */],{onClick:function onClick(){props.addTournamentToShowedList();props.onDismiss();},to:"/tournaments/"+props.info.id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Join")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LaterButton,{onClick:function onClick(){props.addTournamentToShowedList();props.onDismiss();}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__common_Gettext__["b" /* default */],null,"Later")));};var Invite=function Invite(_ref5){var showModal=_ref5.showModal,item=_ref5.item,addTournamentToShowedList=_ref5.addTournamentToShowedList;Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){showModal(InvitePopup,Object.assign({},item,{addTournamentToShowedList:addTournamentToShowedList}));},[]);return null;};var TournamentInvite=function TournamentInvite(){var api=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_9__Tournaments_Api__["c" /* default */]);var _useState=Object(__WEBPACK_IMPORTED_MODULE_1_react__["useState"])(null),_useState2=_slicedToArray(_useState,2),info=_useState2[0],setInfo=_useState2[1];var _useLocalStorage=Object(__WEBPACK_IMPORTED_MODULE_4__common_hooks__["a" /* useLocalStorage */])("showed_invited_tournament_popups",[]),_useLocalStorage2=_slicedToArray(_useLocalStorage,2),showedTournaments=_useLocalStorage2[0],setShowedTournaments=_useLocalStorage2[1];Object(__WEBPACK_IMPORTED_MODULE_1_react__["useEffect"])(function(){var f=function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(){var announcementsData,announcements,tournaments;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return api.readEntity("/api/bell-tolls-items");case 2:announcementsData=_context.sent;announcements=__WEBPACK_IMPORTED_MODULE_3_idx___default()(announcementsData,function(n){return n.value.payload;});tournaments=announcements&&announcements.data.filter(function(item){if(item.type==="invited-tournament"&&item.timestamp>announcements.lastViewTimestamp&&item.info.state!==2&&item.show_modal===true&&item.info.participation_status===0){if(showedTournaments.length>0){var storageTournament=showedTournaments.find(function(tournament){return tournament.id===item.info.id&&tournament.timestamp===item.timestamp;});if(storageTournament!==undefined){return false;}else{return true;}}else{return true;}}else{return false;}});setInfo(tournaments);case 6:case"end":return _context.stop();}}},_callee,_this);}));return function f(){return _ref6.apply(this,arguments);};}();if(api!=null){f();}},[api]);var _addTournamentToShowedList=function _addTournamentToShowedList(tournament){var showedTournaments=JSON.parse(window.localStorage.getItem("showed_invited_tournament_popups"));var filteredList=showedTournaments.filter(function(item){return tournament.id!==item.id;});setShowedTournaments([].concat(_toConsumableArray(filteredList),[tournament]));};if(info==null)return null;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__common_ModalProvider__["a" /* ModalConsumer */],null,function(_ref7){var showModal=_ref7.showModal;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,info.map(function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Invite,{showModal:showModal,addTournamentToShowedList:function addTournamentToShowedList(){return _addTournamentToShowedList({id:item.info.id,timestamp:item.timestamp});},item:item});}));});};/* harmony default export */ __webpack_exports__["a"] = (TournamentInvite);

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Integrations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(145);
/* unused harmony reexport Severity */
/* unused harmony reexport Status */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_core__ = __webpack_require__(80);
/* unused harmony reexport addGlobalEventProcessor */
/* unused harmony reexport addBreadcrumb */
/* unused harmony reexport captureException */
/* unused harmony reexport captureEvent */
/* unused harmony reexport captureMessage */
/* unused harmony reexport configureScope */
/* unused harmony reexport getHubFromCarrier */
/* unused harmony reexport getCurrentHub */
/* unused harmony reexport Hub */
/* unused harmony reexport Scope */
/* unused harmony reexport setContext */
/* unused harmony reexport setExtra */
/* unused harmony reexport setExtras */
/* unused harmony reexport setTag */
/* unused harmony reexport setTags */
/* unused harmony reexport setUser */
/* unused harmony reexport Span */
/* unused harmony reexport withScope */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client__ = __webpack_require__(803);
/* unused harmony reexport BrowserClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sdk__ = __webpack_require__(2074);
/* unused harmony reexport defaultIntegrations */
/* unused harmony reexport forceLoad */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__sdk__["a"]; });
/* unused harmony reexport lastEventId */
/* unused harmony reexport onLoad */
/* unused harmony reexport showReportDialog */
/* unused harmony reexport flush */
/* unused harmony reexport close */
/* unused harmony reexport wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(805);
/* unused harmony reexport SDK_NAME */
/* unused harmony reexport SDK_VERSION */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__integrations__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transports__ = __webpack_require__(804);
/* unused harmony reexport Transports */










var windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
// tslint:disable: no-unsafe-any
var _window = Object(__WEBPACK_IMPORTED_MODULE_6__sentry_utils__["i" /* getGlobalObject */])();
if (_window.Sentry && _window.Sentry.Integrations) {
    windowIntegrations = _window.Sentry.Integrations;
}
// tslint:enable: no-unsafe-any
var INTEGRATIONS = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, windowIntegrations, __WEBPACK_IMPORTED_MODULE_2__sentry_core__["d" /* Integrations */], __WEBPACK_IMPORTED_MODULE_7__integrations__);

//# sourceMappingURL=index.js.map

/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevel */
/** Console logging verbosity for the SDK. */
var LogLevel;
(function (LogLevel) {
    /** No logs will be generated. */
    LogLevel[LogLevel["None"] = 0] = "None";
    /** Only SDK internal errors will be logged. */
    LogLevel[LogLevel["Error"] = 1] = "Error";
    /** Information useful for debugging the SDK will be logged. */
    LogLevel[LogLevel["Debug"] = 2] = "Debug";
    /** All SDK actions will be logged. */
    LogLevel[LogLevel["Verbose"] = 3] = "Verbose";
})(LogLevel || (LogLevel = {}));
//# sourceMappingURL=loglevel.js.map

/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Severity; });
/** JSDoc */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */
    function fromString(level) {
        switch (level) {
            case 'debug':
                return Severity.Debug;
            case 'info':
                return Severity.Info;
            case 'warn':
            case 'warning':
                return Severity.Warning;
            case 'error':
                return Severity.Error;
            case 'fatal':
                return Severity.Fatal;
            case 'critical':
                return Severity.Critical;
            case 'log':
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})(Severity || (Severity = {}));
//# sourceMappingURL=severity.js.map

/***/ }),
/* 2051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/** The status of an event. */
var Status;
(function (Status) {
    /** The status could not be determined. */
    Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */
    Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */
    Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */
    Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */
    Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */
    Status["Failed"] = "failed";
})(Status || (Status = {}));
// tslint:disable:completed-docs
// tslint:disable:no-unnecessary-qualifier no-namespace
(function (Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */
    function fromHttpCode(code) {
        if (code >= 200 && code < 300) {
            return Status.Success;
        }
        if (code === 429) {
            return Status.RateLimit;
        }
        if (code >= 400 && code < 500) {
            return Status.Invalid;
        }
        if (code >= 500) {
            return Status.Failed;
        }
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})(Status || (Status = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 2052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = captureException;
/* unused harmony export captureMessage */
/* unused harmony export captureEvent */
/* unused harmony export configureScope */
/* unused harmony export addBreadcrumb */
/* unused harmony export setContext */
/* unused harmony export setExtras */
/* unused harmony export setTags */
/* unused harmony export setExtra */
/* unused harmony export setTag */
/* unused harmony export setUser */
/* harmony export (immutable) */ __webpack_exports__["b"] = withScope;
/* unused harmony export _callOnClient */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(2053);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(218);


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
    if (hub && hub[method]) {
        // tslint:disable-next-line:no-unsafe-any
        return hub[method].apply(hub, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __spread */](args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
function captureException(exception) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param level Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(message, level) {
    var syntheticException;
    try {
        throw new Error(message);
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureMessage', message, level, {
        originalException: message,
        syntheticException: syntheticException,
    });
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event) {
    return callOnHub('captureEvent', event);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
    callOnHub('configureScope', callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
    callOnHub('addBreadcrumb', breadcrumb);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normailzed.
 */
function setContext(name, context) {
    callOnHub('setContext', name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
    callOnHub('setExtras', extras);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
    callOnHub('setTags', tags);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normailzed.
 */
function setExtra(key, extra) {
    callOnHub('setExtra', key, extra);
}
/**
 * Set key:value that will be sent as tags data with the event.
 * @param key String key of tag
 * @param value String value of tag
 */
function setTag(key, value) {
    callOnHub('setTag', key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
    callOnHub('setUser', user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}
/**
 * Calls a function on the latest client. Use this with caution, it's meant as
 * in "internal" helper so we don't need to expose every possible function in
 * the shim. It is not guaranteed that the client actually implements the
 * function.
 *
 * @param method The method to call on the client/client.
 * @param args Arguments to pass to the client/fontend.
 */
function _callOnClient(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    callOnHub.apply(void 0, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __spread */](['_invokeClient', method], args));
}
//# sourceMappingURL=index.js.map

/***/ }),
/* 2053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export __extends */
/* unused harmony export __assign */
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* unused harmony export __awaiter */
/* unused harmony export __generator */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* unused harmony export __read */
/* harmony export (immutable) */ __webpack_exports__["a"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __await */
/* unused harmony export __asyncGenerator */
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 2054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export forget */
/* unused harmony export filterAsync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(797);

/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
function forget(promise) {
    promise.catch(function (e) {
        // TODO: Use a better logging mechanism
        console.error(e);
    });
}
/**
 * Helper to filter an array with asynchronous callbacks.
 *
 * @param array An array containing items to filter.
 * @param predicate An async predicate evaluated on every item.
 * @param thisArg Optional value passed as "this" into the callback.
 * @returns An array containing only values where the callback returned true.
 */
function filterAsync(array, predicate, thisArg) {
    return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __awaiter */](this, void 0, void 0, function () {
        var verdicts;
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __generator */](this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(array.map(predicate, thisArg))];
                case 1:
                    verdicts = _a.sent();
                    return [2 /*return*/, array.filter(function (_, index) { return verdicts[index]; })];
            }
        });
    });
}
//# sourceMappingURL=async.js.map

/***/ }),
/* 2055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setPrototypeOf; });
var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties); // tslint:disable-line:no-unbound-method
/**
 * setPrototypeOf polyfill using __proto__
 */
function setProtoOf(obj, proto) {
    // @ts-ignore
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!obj.hasOwnProperty(prop)) {
            // @ts-ignore
            obj[prop] = proto[prop];
        }
    }
    return obj;
}
//# sourceMappingURL=polyfill.js.map

/***/ }),
/* 2056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = fill;
/* harmony export (immutable) */ __webpack_exports__["d"] = urlEncode;
/* harmony export (immutable) */ __webpack_exports__["c"] = normalizeToSize;
/* unused harmony export walk */
/* harmony export (immutable) */ __webpack_exports__["b"] = normalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__memo__ = __webpack_require__(800);


/**
 * Wrap a given object method with a higher-order function
 *
 * @param source An object that contains a method to be wrapped.
 * @param name A name of method to be wrapped.
 * @param replacement A function that should be used to wrap a given method.
 * @returns void
 */
function fill(source, name, replacement) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacement(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    // tslint:disable-next-line:strict-type-predicates
    if (typeof wrapped === 'function') {
        try {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __sentry__: {
                    enumerable: false,
                    value: true,
                },
                __sentry_original__: {
                    enumerable: false,
                    value: original,
                },
                __sentry_wrapped__: {
                    enumerable: false,
                    value: wrapped,
                },
            });
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(
    // tslint:disable-next-line:no-unsafe-any
    function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms Error object into an object literal with all it's attributes
 * attached to it.
 *
 * Based on: https://github.com/ftlabs/js-abbreviate/blob/fa709e5f139e7770a71827b1893f22418097fbda/index.js#L95-L106
 *
 * @param error An Error containing all relevant information
 * @returns An object with all error properties
 */
function objectifyError(error) {
    // These properties are implemented as magical getters and don't show up in `for-in` loop
    var err = {
        message: error.message,
        name: error.name,
        stack: error.stack,
    };
    for (var i in error) {
        if (Object.prototype.hasOwnProperty.call(error, i)) {
            err[i] = error[i];
        }
    }
    return err;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // tslint:disable-next-line:no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/** Transforms any input value into a string form, either primitive value or a type of the input */
function serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return Object(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isPrimitive */])(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof global !== 'undefined' && value === global) {
        return '[Global]';
    }
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof Event !== 'undefined' && value instanceof Event) {
        return Object.getPrototypeOf(value) ? value.constructor.name : 'Event';
    }
    // React's SyntheticEvent thingy
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["i" /* isSyntheticEvent */])(value)) {
        return '[SyntheticEvent]';
    }
    if (Number.isNaN(value)) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + (value.name || '<unknown-function-name>') + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = new __WEBPACK_IMPORTED_MODULE_1__memo__["a" /* Memo */](); }
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) {
        return serializeValue(value);
    }
    // If value implements `toJSON` method, call it and return early
    // tslint:disable:no-unsafe-any
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    // tslint:enable:no-unsafe-any
    // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = normalizeValue(value, key);
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["f" /* isPrimitive */])(normalized)) {
        return normalized;
    }
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = (Object(__WEBPACK_IMPORTED_MODULE_0__is__["c" /* isError */])(value) ? objectifyError(value) : value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
function normalize(input, depth) {
    try {
        // tslint:disable-next-line:no-unsafe-any
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
//# sourceMappingURL=object.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(27)))

/***/ }),
/* 2057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export resolve */
/* unused harmony export relative */
/* unused harmony export normalizePath */
/* unused harmony export isAbsolute */
/* unused harmony export join */
/* unused harmony export dirname */
/* unused harmony export basename */
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js
/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for (var i = parts.length - 1; i >= 0; i--) {
        var last = parts[i];
        if (last === '.') {
            parts.splice(i, 1);
        }
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        }
        else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) {
        for (; up--; up) {
            parts.unshift('..');
        }
    }
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
var splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
/** JSDoc */
function splitPath(filename) {
    var parts = splitPathRe.exec(filename);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var resolvedPath = '';
    var resolvedAbsolute = false;
    for (var i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
        var path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) {
            continue;
        }
        resolvedPath = path + "/" + resolvedPath;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = normalizeArray(resolvedPath.split('/').filter(function (p) { return !!p; }), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */
function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
        if (arr[start] !== '') {
            break;
        }
    }
    var end = arr.length - 1;
    for (; end >= 0; end--) {
        if (arr[end] !== '') {
            break;
        }
    }
    if (start > end) {
        return [];
    }
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
    // tslint:disable:no-parameter-reassignment
    from = resolve(from).substr(1);
    to = resolve(to).substr(1);
    var fromParts = trim(from.split('/'));
    var toParts = trim(to.split('/'));
    var length = Math.min(fromParts.length, toParts.length);
    var samePartsLength = length;
    for (var i = 0; i < length; i++) {
        if (fromParts[i] !== toParts[i]) {
            samePartsLength = i;
            break;
        }
    }
    var outputParts = [];
    for (var i = samePartsLength; i < fromParts.length; i++) {
        outputParts.push('..');
    }
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
    var isPathAbsolute = isAbsolute(path);
    var trailingSlash = path.substr(-1) === '/';
    // Normalize the path
    var normalizedPath = normalizeArray(path.split('/').filter(function (p) { return !!p; }), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) {
        normalizedPath = '.';
    }
    if (normalizedPath && trailingSlash) {
        normalizedPath += '/';
    }
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */
function isAbsolute(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */
function join() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return normalizePath(args.join('/'));
}
/** JSDoc */
function dirname(path) {
    var result = splitPath(path);
    var root = result[0];
    var dir = result[1];
    if (!root && !dir) {
        // No dirname whatsoever
        return '.';
    }
    if (dir) {
        // It has a dirname, strip trailing slash
        dir = dir.substr(0, dir.length - 1);
    }
    return root + dir;
}
/** JSDoc */
function basename(path, ext) {
    var f = splitPath(path)[2];
    if (ext && f.substr(ext.length * -1) === ext) {
        f = f.substr(0, f.length - ext.length);
    }
    return f;
}
//# sourceMappingURL=path.js.map

/***/ }),
/* 2058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PromiseBuffer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error__ = __webpack_require__(798);

/** A simple queue that holds promises. */
var PromiseBuffer = /** @class */ (function () {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */
        this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */
    PromiseBuffer.prototype.isReady = function () {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any Promise<T>
     * @returns The original promise.
     */
    PromiseBuffer.prototype.add = function (task) {
        var _this = this;
        if (!this.isReady()) {
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_0__error__["a" /* SentryError */]('Not adding Promise due to buffer limit reached.'));
        }
        if (this._buffer.indexOf(task) === -1) {
            this._buffer.push(task);
        }
        task
            .then(function () { return _this.remove(task); })
            .catch(function () {
            return _this.remove(task).catch(function () {
                // We have to add this catch here otherwise we have an unhandledPromiseRejection
                // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any Promise<T>
     * @returns Removed promise.
     */
    PromiseBuffer.prototype.remove = function (task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */
    PromiseBuffer.prototype.length = function () {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */
    PromiseBuffer.prototype.drain = function (timeout) {
        var _this = this;
        return new Promise(function (resolve) {
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            Promise.all(_this._buffer)
                .then(function () {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            })
                .catch(function () {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}());

//# sourceMappingURL=promisebuffer.js.map

/***/ }),
/* 2059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = truncate;
/* unused harmony export snipLine */
/* harmony export (immutable) */ __webpack_exports__["c"] = safeJoin;
/* harmony export (immutable) */ __webpack_exports__["b"] = keysToEventMessage;
/* harmony export (immutable) */ __webpack_exports__["a"] = isMatchingPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(299);

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    // tslint:disable-next-line:strict-type-predicates
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) {
        return newLine;
    }
    if (colno > ll) {
        colno = ll; // tslint:disable-line:no-parameter-reassignment
    }
    var start = Math.max(colno - 60, 0);
    if (start < 5) {
        start = 0;
    }
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) {
        end = ll;
    }
    if (end === ll) {
        start = Math.max(end - 140, 0);
    }
    newLine = newLine.slice(start, end);
    if (start > 0) {
        newLine = "'{snip} " + newLine;
    }
    if (end < ll) {
        newLine += ' {snip}';
    }
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // tslint:disable-next-line:prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/** Merges provided array of keys into */
function keysToEventMessage(keys, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return '';
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["g" /* isRegExp */])(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.includes(pattern);
    }
    return false;
}
//# sourceMappingURL=string.js.map

/***/ }),
/* 2060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export supportsErrorEvent */
/* unused harmony export supportsDOMError */
/* unused harmony export supportsDOMException */
/* harmony export (immutable) */ __webpack_exports__["a"] = supportsFetch;
/* harmony export (immutable) */ __webpack_exports__["c"] = supportsNativeFetch;
/* unused harmony export supportsReportingObserver */
/* harmony export (immutable) */ __webpack_exports__["d"] = supportsReferrerPolicy;
/* harmony export (immutable) */ __webpack_exports__["b"] = supportsHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logger__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__misc__ = __webpack_require__(466);


/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
    try {
        // tslint:disable:no-unused-expression
        new ErrorEvent('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
    try {
        // It really needs 1 argument, not 0.
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore
        // tslint:disable:no-unused-expression
        new DOMError('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
    try {
        // tslint:disable:no-unused-expression
        new DOMException('');
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])())) {
        return false;
    }
    try {
        // tslint:disable-next-line:no-unused-expression
        new Headers();
        // tslint:disable-next-line:no-unused-expression
        new Request('');
        // tslint:disable-next-line:no-unused-expression
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var isNativeFunc = function (func) { return func.toString().indexOf('native') !== -1; };
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    var result = null;
    var doc = global.document;
    if (doc) {
        var sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        try {
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // tslint:disable-next-line no-unbound-method
                result = isNativeFunc(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            __WEBPACK_IMPORTED_MODULE_0__logger__["a" /* logger */].warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    if (result === null) {
        // tslint:disable-next-line no-unbound-method
        result = isNativeFunc(global.fetch);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
    // tslint:disable-next-line: no-unsafe-any
    return 'ReportingObserver' in Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        // tslint:disable:no-unused-expression
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = Object(__WEBPACK_IMPORTED_MODULE_1__misc__["e" /* getGlobalObject */])();
    var chrome = global.chrome;
    // tslint:disable-next-line:no-unsafe-any
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}
//# sourceMappingURL=supports.js.map

/***/ }),
/* 2061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SyncPromise; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__is__ = __webpack_require__(299);

/** SyncPromise internal states */
var States;
(function (States) {
    /** Pending */
    States["PENDING"] = "PENDING";
    /** Resolved / OK */
    States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */
    States["REJECTED"] = "REJECTED";
})(States || (States = {}));
/** JSDoc */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(callback) {
        var _this = this;
        /** JSDoc */
        this._state = States.PENDING;
        /** JSDoc */
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(value, States.RESOLVED);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(reason, States.REJECTED);
        };
        /** JSDoc */
        this._setResult = function (value, state) {
            if (_this._state !== States.PENDING) {
                return;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_0__is__["j" /* isThenable */])(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._value = value;
            _this._state = state;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === States.PENDING) {
                return;
            }
            if (_this._state === States.REJECTED) {
                // tslint:disable-next-line:no-unsafe-any
                _this._handlers.forEach(function (h) { return h.onFail && h.onFail(_this._value); });
            }
            else {
                // tslint:disable-next-line:no-unsafe-any
                _this._handlers.forEach(function (h) { return h.onSuccess && h.onSuccess(_this._value); });
            }
            _this._handlers = [];
            return;
        };
        /** JSDoc */
        this._attachHandler = function (handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        try {
            callback(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        // public then<U>(onSuccess?: HandlerOnSuccess<T, U>, onFail?: HandlerOnFail<U>): SyncPromise<T | U> {
        return new SyncPromise(function (resolve, reject) {
            _this._attachHandler({
                onFail: function (reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
                onSuccess: function (result) {
                    if (!onfulfilled) {
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    }
                    catch (e) {
                        reject(e);
                        return;
                    }
                },
            });
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onFail) {
        // tslint:disable-next-line:no-unsafe-any
        return this.then(function (val) { return val; }, onFail);
    };
    /** JSDoc */
    SyncPromise.prototype.toString = function () {
        return "[object SyncPromise]";
    };
    /** JSDoc */
    SyncPromise.resolve = function (value) {
        return new SyncPromise(function (resolve) {
            resolve(value);
        });
    };
    /** JSDoc */
    SyncPromise.reject = function (reason) {
        return new SyncPromise(function (_, reject) {
            reject(reason);
        });
    };
    return SyncPromise;
}());

//# sourceMappingURL=syncpromise.js.map

/***/ }),
/* 2062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* unused harmony export API_VERSION */
/* unused harmony export Hub */
/* unused harmony export getMainCarrier */
/* unused harmony export makeMain */
/* harmony export (immutable) */ __webpack_exports__["a"] = getCurrentHub;
/* unused harmony export getHubFromCarrier */
/* unused harmony export setHubOnCarrier */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__scope__ = __webpack_require__(795);



/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be incresed when the global interface
 * changes a and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 30;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */](); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [];
        this._stack.push({ client: client, scope: scope });
    }
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var top = this.getStackTop();
        if (top && top.client && top.client[method]) {
            (_a = top.client)[method].apply(_a, __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __spread */](args, [top.scope]));
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var stack = this.getStack();
        var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
        var scope = __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(parentScope);
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        return this.getStack().pop() !== undefined;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])());
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, finalHint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = (this._lastEventId = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])());
        this._invokeClient('captureEvent', event, __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, hint, { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var top = this.getStackTop();
        if (!top.scope || !top.client) {
            return;
        }
        var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
        if (maxBreadcrumbs <= 0) {
            return;
        }
        var timestamp = new Date().getTime() / 1000;
        var mergedBreadcrumb = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["e" /* consoleSandbox */])(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null) {
            return;
        }
        top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setContext = function (name, context) {
        var top = this.getStackTop();
        if (!top.scope) {
            return;
        }
        top.scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            callback(top.scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client) {
            return null;
        }
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        var top = this.getStackTop();
        if (top.scope && top.client) {
            var span = top.scope.getSpan();
            if (span) {
                return {
                    'sentry-trace': span.toTraceparent(),
                };
            }
        }
        return {};
    };
    return Hub;
}());

/** Returns the global shim registry. */
function getMainCarrier() {
    var carrier = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there
    try {
        // We need to use `dynamicRequire` because `require` on it's own will be optimized by webpack.
        // We do not want this to happen, we need to try to `require` the domain node module and fail if we are in browser
        // for example so we do not have to shim it and use `getCurrentHub` universally.
        var domain = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["f" /* dynamicRequire */])(module, 'domain');
        var activeDomain = domain.active;
        // If there no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or its an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, __WEBPACK_IMPORTED_MODULE_2__scope__["a" /* Scope */].clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return true;
    }
    return false;
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
        return carrier.__SENTRY__.hub;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier) {
        return false;
    }
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}
//# sourceMappingURL=hub.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(355)(module)))

/***/ }),
/* 2063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dsn__ = __webpack_require__(467);


var SENTRY_API_VERSION = '7';
/** Helper class to provide urls to different Sentry endpoints. */
var API = /** @class */ (function () {
    /** Create a new instance of API */
    function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new __WEBPACK_IMPORTED_MODULE_1__dsn__["a" /* Dsn */](dsn);
    }
    /** Returns the Dsn object. */
    API.prototype.getDsn = function () {
        return this._dsnObject;
    };
    /** Returns a string with auth headers in the url to the store endpoint. */
    API.prototype.getStoreEndpoint = function () {
        return "" + this._getBaseUrl() + this.getStoreEndpointPath();
    };
    /** Returns the store endpoint with auth added in url encoded. */
    API.prototype.getStoreEndpointWithUrlEncodedAuth = function () {
        var dsn = this._dsnObject;
        var auth = {
            sentry_key: dsn.user,
            sentry_version: SENTRY_API_VERSION,
        };
        // Auth is intentionally sent as part of query string (NOT as custom HTTP header)
        // to avoid preflight CORS requests
        return this.getStoreEndpoint() + "?" + Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["D" /* urlEncode */])(auth);
    };
    /** Returns the base path of the url including the port. */
    API.prototype._getBaseUrl = function () {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : '';
        var port = dsn.port ? ":" + dsn.port : '';
        return protocol + "//" + dsn.host + port;
    };
    /** Returns only the path component for the store endpoint. */
    API.prototype.getStoreEndpointPath = function () {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : '') + "/api/" + dsn.projectId + "/store/";
    };
    /** Returns an object that can be used in request headers. */
    API.prototype.getRequestHeaders = function (clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = ["Sentry sentry_version=" + SENTRY_API_VERSION];
        header.push("sentry_timestamp=" + new Date().getTime());
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) {
            header.push("sentry_secret=" + dsn.pass);
        }
        return {
            'Content-Type': 'application/json',
            'X-Sentry-Auth': header.join(', '),
        };
    };
    /** Returns the url to the report dialog endpoint. */
    API.prototype.getReportDialogEndpoint = function (dialogOptions) {
        if (dialogOptions === void 0) { dialogOptions = {}; }
        var dsn = this._dsnObject;
        var endpoint = "" + this._getBaseUrl() + (dsn.path ? "/" + dsn.path : '') + "/api/embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for (var key in dialogOptions) {
            if (key === 'user') {
                if (!dialogOptions.user) {
                    continue;
                }
                if (dialogOptions.user.name) {
                    encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                }
                if (dialogOptions.user.email) {
                    encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
                }
            }
            else {
                encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
            }
        }
        if (encodedOptions.length) {
            return endpoint + "?" + encodedOptions.join('&');
        }
        return endpoint;
    };
    return API;
}());

//# sourceMappingURL=api.js.map

/***/ }),
/* 2064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dsn__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__integration__ = __webpack_require__(2065);




/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Is the client still processing a call? */
        this._processing = false;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = new __WEBPACK_IMPORTED_MODULE_2__dsn__["a" /* Dsn */](options.dsn);
        }
        if (this._isEnabled()) {
            this._integrations = Object(__WEBPACK_IMPORTED_MODULE_3__integration__["a" /* setupIntegrations */])(this._options);
        }
    }
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        var promisedEvent = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["p" /* isPrimitive */])(message)
            ? this._getBackend().eventFromMessage("" + message, level, hint)
            : this._getBackend().eventFromException(message, hint);
        promisedEvent
            .then(function (event) { return _this._processEvent(event, hint, scope); })
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._processing = true;
        this._processEvent(event, hint, scope)
            .then(function (finalEvent) {
            // We need to check for finalEvent in case beforeSend returned null
            eventId = finalEvent && finalEvent.event_id;
            _this._processing = false;
        })
            .catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error(reason);
            _this._processing = false;
        });
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function (status) {
            clearInterval(status.interval);
            return _this._getBackend()
                .getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return status.ready && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegrations = function () {
        return this._integrations || {};
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Waits for the client to be done with processing. */
    BaseClient.prototype._isClientProcessing = function (timeout) {
        var _this = this;
        return new Promise(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = 0;
            clearInterval(interval);
            interval = setInterval(function () {
                if (!_this._processing) {
                    resolve({
                        interval: interval,
                        ready: true,
                    });
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        resolve({
                            interval: interval,
                            ready: false,
                        });
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _a = this.getOptions(), environment = _a.environment, release = _a.release, dist = _a.dist, _b = _a.maxValueLength, maxValueLength = _b === void 0 ? 250 : _b;
        var prepared = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event);
        if (prepared.environment === undefined && environment !== undefined) {
            prepared.environment = environment;
        }
        if (prepared.release === undefined && release !== undefined) {
            prepared.release = release;
        }
        if (prepared.dist === undefined && dist !== undefined) {
            prepared.dist = dist;
        }
        if (prepared.message) {
            prepared.message = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* truncate */])(prepared.message, maxValueLength);
        }
        var exception = prepared.exception && prepared.exception.values && prepared.exception.values[0];
        if (exception && exception.value) {
            exception.value = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* truncate */])(exception.value, maxValueLength);
        }
        var request = prepared.request;
        if (request && request.url) {
            request.url = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["C" /* truncate */])(request.url, maxValueLength);
        }
        if (prepared.event_id === undefined) {
            prepared.event_id = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["E" /* uuid4 */])();
        }
        this._addIntegrations(prepared.sdk);
        // We prepare the result here with a resolved Event.
        var result = __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */].resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (scope) {
            // In case we have a hub we reassign it.
            result = scope.applyToEvent(prepared, hint);
        }
        return result;
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */
    BaseClient.prototype._addIntegrations = function (sdkInfo) {
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) {
            sdkInfo.integrations = integrationsArray;
        }
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional informartion about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */].reject('SDK not enabled, will not send event.');
        }
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        if (typeof sampleRate === 'number' && Math.random() > sampleRate) {
            return __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */].reject('This event has been sampled, will not send event.');
        }
        return new __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["c" /* SyncPromise */](function (resolve, reject) {
            _this._prepareEvent(event, scope, hint).then(function (prepared) {
                if (prepared === null) {
                    reject('An event processor returned null, will not send event.');
                    return;
                }
                var finalEvent = prepared;
                try {
                    var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
                    if (isInternalException || !beforeSend) {
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                        return;
                    }
                    var beforeSendResult = beforeSend(prepared, hint);
                    if (typeof beforeSendResult === 'undefined') {
                        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].error('`beforeSend` method has to return `null` or a valid event.');
                    }
                    else if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["r" /* isThenable */])(beforeSendResult)) {
                        _this._handleAsyncBeforeSend(beforeSendResult, resolve, reject);
                    }
                    else {
                        finalEvent = beforeSendResult;
                        if (finalEvent === null) {
                            __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].log('`beforeSend` returned `null`, will not send event.');
                            resolve(null);
                            return;
                        }
                        // From here on we are really async
                        _this._getBackend().sendEvent(finalEvent);
                        resolve(finalEvent);
                    }
                }
                catch (exception) {
                    _this.captureException(exception, {
                        data: {
                            __sentry__: true,
                        },
                        originalException: exception,
                    });
                    reject('`beforeSend` throw an error, will not send event.');
                }
            });
        });
    };
    /**
     * Resolves before send Promise and calls resolve/reject on parent SyncPromise.
     */
    BaseClient.prototype._handleAsyncBeforeSend = function (beforeSend, resolve, reject) {
        var _this = this;
        beforeSend
            .then(function (processedEvent) {
            if (processedEvent === null) {
                reject('`beforeSend` returned `null`, will not send event.');
                return;
            }
            // From here on we are really async
            _this._getBackend().sendEvent(processedEvent);
            resolve(processedEvent);
        })
            .catch(function (e) {
            reject("beforeSend rejected with " + e);
        });
    };
    return BaseClient;
}());

//# sourceMappingURL=baseclient.js.map

/***/ }),
/* 2065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export installedIntegrations */
/* unused harmony export getIntegrationsToSetup */
/* unused harmony export setupIntegration */
/* harmony export (immutable) */ __webpack_exports__["a"] = setupIntegrations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(29);



var installedIntegrations = [];
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function (i) { return i.name; });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function (defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 &&
                pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function (userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    else {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](defaultIntegrations);
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */], __WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */]);
    installedIntegrations.push(integration.name);
    __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    return integrations;
}
//# sourceMappingURL=integration.js.map

/***/ }),
/* 2066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaseBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transports_noop__ = __webpack_require__(802);


/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* logger */].warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new __WEBPACK_IMPORTED_MODULE_1__transports_noop__["a" /* NoopTransport */]();
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["b" /* SentryError */]('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["b" /* SentryError */]('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        this._transport.sendEvent(event).catch(function (reason) {
            __WEBPACK_IMPORTED_MODULE_0__sentry_utils__["t" /* logger */].error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    return BaseBackend;
}());

//# sourceMappingURL=basebackend.js.map

/***/ }),
/* 2067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = initAndBind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_hub__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);


/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instanciate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        __WEBPACK_IMPORTED_MODULE_1__sentry_utils__["t" /* logger */].enable();
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_hub__["b" /* getCurrentHub */])().bindClient(new clientClass(options));
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functiontostring__ = __webpack_require__(2069);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionToString", function() { return __WEBPACK_IMPORTED_MODULE_0__functiontostring__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__inboundfilters__ = __webpack_require__(2070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InboundFilters", function() { return __WEBPACK_IMPORTED_MODULE_1__inboundfilters__["a"]; });


//# sourceMappingURL=index.js.map

/***/ }),
/* 2069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionToString; });
var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        originalFunctionToString = Function.prototype.toString;
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = this.__sentry__ ? this.__sentry_original__ : this;
            // tslint:disable-next-line:no-unsafe-any
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

//# sourceMappingURL=functiontostring.js.map

/***/ }),
/* 2070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InboundFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_hub__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(29);



// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["a" /* addGlobalEventProcessor */])(function (event) {
            var hub = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_hub__["b" /* getCurrentHub */])();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) {
                    return null;
                }
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to being internal Sentry Error.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return true;
        }
        if (this._isBlacklistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to being matched by `blacklistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isWhitelistedUrl(event, options)) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].warn("Event dropped due to not being matched by `whitelistUrls` option.\nEvent: " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            // tslint:disable-next-line:no-unsafe-any
            return event.exception.values[0].type === 'SentryError';
        }
        catch (_oO) {
            return false;
        }
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (options === void 0) { options = {}; }
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* isMatchingPattern */])(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isBlacklistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.blacklistUrls || !options.blacklistUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.blacklistUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isWhitelistedUrl = function (event, options) {
        if (options === void 0) { options = {}; }
        // TODO: Use Glob instead?
        if (!options.whitelistUrls || !options.whitelistUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.whitelistUrls.some(function (pattern) { return Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["n" /* isMatchingPattern */])(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            blacklistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((this._options.blacklistUrls || []), (clientOptions.blacklistUrls || [])),
            ignoreErrors: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
            whitelistUrls: __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]((this._options.whitelistUrls || []), (clientOptions.whitelistUrls || [])),
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                // tslint:disable-next-line:no-unsafe-any
                var _a = event.exception.values[0], type = _a.type, value = _a.value;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error("Cannot extract message for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                // tslint:disable:no-unsafe-any
                var frames_1 = event.stacktrace.frames;
                return frames_1[frames_1.length - 1].filename;
            }
            if (event.exception) {
                // tslint:disable:no-unsafe-any
                var frames_2 = event.exception.values[0].stacktrace.frames;
                return frames_2[frames_2.length - 1].filename;
            }
            return null;
        }
        catch (oO) {
            __WEBPACK_IMPORTED_MODULE_2__sentry_utils__["t" /* logger */].error("Cannot extract url for event " + Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["h" /* getEventDescription */])(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

//# sourceMappingURL=inboundfilters.js.map

/***/ }),
/* 2071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserBackend; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__parsers__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tracekit__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transports__ = __webpack_require__(804);







/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, this._options.transportOptions, { dsn: this._options.dsn });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["y" /* supportsFetch */])()) {
            return new __WEBPACK_IMPORTED_MODULE_6__transports__["a" /* FetchTransport */](transportOptions);
        }
        return new __WEBPACK_IMPORTED_MODULE_6__transports__["b" /* XHRTransport */](transportOptions);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        var _this = this;
        var event;
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["m" /* isErrorEvent */])(exception) && exception.error) {
            // If it is an ErrorEvent with `error` property, extract it to get actual Error
            var errorEvent = exception;
            exception = errorEvent.error; // tslint:disable-line:no-parameter-reassignment
            event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["a" /* _computeStackTrace */])(exception));
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(this._buildEvent(event, hint));
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* isDOMError */])(exception) || Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["k" /* isDOMException */])(exception)) {
            // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
            // then we just extract the name and message, as they don't provide anything else
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
            // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
            var domException = exception;
            var name_1 = domException.name || (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["j" /* isDOMError */])(domException) ? 'DOMError' : 'DOMException');
            var message_1 = domException.message ? name_1 + ": " + domException.message : name_1;
            return this.eventFromMessage(message_1, __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error, hint).then(function (messageEvent) {
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(messageEvent, message_1);
                return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(_this._buildEvent(messageEvent, hint));
            });
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["l" /* isError */])(exception)) {
            // we have a real Error object, do nothing
            event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["b" /* eventFromStacktrace */])(Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["a" /* _computeStackTrace */])(exception));
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(this._buildEvent(event, hint));
        }
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["o" /* isPlainObject */])(exception) && hint && hint.syntheticException) {
            // If it is plain Object, serialize it manually and extract options
            // This will allow us to group events based on top-level keys
            // which is much better than creating new group when any key/value change
            var objectException = exception;
            event = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["a" /* eventFromPlainObject */])(objectException, hint.syntheticException);
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(event, 'Custom Object', undefined, {
                handled: true,
                synthetic: true,
                type: 'generic',
            });
            event.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(this._buildEvent(event, hint));
        }
        // If none of previous checks were valid, then it means that
        // it's not a DOMError/DOMException
        // it's not a plain Object
        // it's not a valid ErrorEvent (one with an error property)
        // it's not an Error
        // So bail out and capture it as a simple message:
        var stringException = exception;
        return this.eventFromMessage(stringException, undefined, hint).then(function (messageEvent) {
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(messageEvent, "" + stringException, undefined, {
                handled: true,
                synthetic: true,
                type: 'generic',
            });
            messageEvent.level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error;
            return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(_this._buildEvent(messageEvent, hint));
        });
    };
    /**
     * This is an internal helper function that creates an event.
     */
    BrowserBackend.prototype._buildEvent = function (event, hint) {
        return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { event_id: hint && hint.event_id });
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Info; }
        var event = {
            event_id: hint && hint.event_id,
            level: level,
            message: message,
        };
        if (this._options.attachStacktrace && hint && hint.syntheticException) {
            var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_5__tracekit__["a" /* _computeStackTrace */])(hint.syntheticException);
            var frames_1 = Object(__WEBPACK_IMPORTED_MODULE_4__parsers__["d" /* prepareFramesForEvent */])(stacktrace.stack);
            event.stacktrace = {
                frames: frames_1,
            };
        }
        return __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["c" /* SyncPromise */].resolve(event);
    };
    return BrowserBackend;
}(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["b" /* BaseBackend */]));

//# sourceMappingURL=backend.js.map

/***/ }),
/* 2072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__base__ = __webpack_require__(469);




var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* getGlobalObject */])();
/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    FetchTransport.prototype.sendEvent = function (event) {
        var defaultOptions = {
            body: JSON.stringify(event),
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["B" /* supportsReferrerPolicy */])() ? 'origin' : ''),
        };
        return this._buffer.add(global.fetch(this.url, defaultOptions).then(function (response) { return ({
            status: __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(response.status),
        }); }));
    };
    return FetchTransport;
}(__WEBPACK_IMPORTED_MODULE_3__base__["a" /* BaseTransport */]));

//# sourceMappingURL=fetch.js.map

/***/ }),
/* 2073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XHRTransport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_types__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base__ = __webpack_require__(469);



/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    __WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */](XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    XHRTransport.prototype.sendEvent = function (event) {
        var _this = this;
        return this._buffer.add(new Promise(function (resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function () {
                if (request.readyState !== 4) {
                    return;
                }
                if (request.status === 200) {
                    resolve({
                        status: __WEBPACK_IMPORTED_MODULE_1__sentry_types__["b" /* Status */].fromHttpCode(request.status),
                    });
                }
                reject(request);
            };
            request.open('POST', _this.url);
            request.send(JSON.stringify(event));
        }));
    };
    return XHRTransport;
}(__WEBPACK_IMPORTED_MODULE_2__base__["a" /* BaseTransport */]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 2074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultIntegrations */
/* harmony export (immutable) */ __webpack_exports__["a"] = init;
/* unused harmony export showReportDialog */
/* unused harmony export lastEventId */
/* unused harmony export forceLoad */
/* unused harmony export onLoad */
/* unused harmony export flush */
/* unused harmony export close */
/* unused harmony export wrap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__client__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__helpers__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__integrations__ = __webpack_require__(806);





var defaultIntegrations = [
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].InboundFilters(),
    new __WEBPACK_IMPORTED_MODULE_0__sentry_core__["d" /* Integrations */].FunctionToString(),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["TryCatch"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["Breadcrumbs"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["GlobalHandlers"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["LinkedErrors"](),
    new __WEBPACK_IMPORTED_MODULE_4__integrations__["UserAgent"](),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_utils__["i" /* getGlobalObject */])();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["h" /* initAndBind */])(__WEBPACK_IMPORTED_MODULE_2__client__["a" /* BrowserClient */], options);
}
/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!options.eventId) {
        options.eventId = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().lastEventId();
    }
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().getClient();
    if (client) {
        client.showReportDialog(options);
    }
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().lastEventId();
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
    // Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
    callback();
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function flush(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().getClient();
    if (client) {
        return client.flush(timeout);
    }
    return Promise.reject(false);
}
/**
 * A promise that resolves when all current events have been sent.
 * If you provide a timeout and the queue takes longer to drain the promise returns false.
 *
 * @param timeout Maximum time in ms the client should wait.
 */
function close(timeout) {
    var client = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_core__["g" /* getCurrentHub */])().getClient();
    if (client) {
        return client.close(timeout);
    }
    return Promise.reject(false);
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function wrap(fn) {
    // tslint:disable-next-line: no-unsafe-any
    return Object(__WEBPACK_IMPORTED_MODULE_3__helpers__["d" /* wrap */])(fn)();
}
//# sourceMappingURL=sdk.js.map

/***/ }),
/* 2075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GlobalHandlers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__parsers__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__tracekit__ = __webpack_require__(301);







/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        Object(__WEBPACK_IMPORTED_MODULE_6__tracekit__["d" /* _subscribe */])(function (stack, _, error) {
            var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
            if (Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["c" /* shouldIgnoreOnError */])() || isFailedOwnDelivery) {
                return;
            }
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getIntegration(GlobalHandlers);
            if (self) {
                Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().captureEvent(self._eventFromGlobalHandler(stack, error), {
                    data: { stack: stack },
                    originalException: error,
                });
            }
        });
        if (this._options.onerror) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["t" /* logger */].log('Global Handler attached: onerror');
            Object(__WEBPACK_IMPORTED_MODULE_6__tracekit__["b" /* _installGlobalHandler */])();
        }
        if (this._options.onunhandledrejection) {
            __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["t" /* logger */].log('Global Handler attached: onunhandledrejection');
            Object(__WEBPACK_IMPORTED_MODULE_6__tracekit__["c" /* _installGlobalUnhandledRejectionHandler */])();
        }
    };
    /**
     * This function creates an Event from an TraceKitStackTrace.
     *
     * @param stacktrace TraceKitStackTrace to be converted to an Event.
     */
    GlobalHandlers.prototype._eventFromGlobalHandler = function (stacktrace, error) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* isString */])(stacktrace.message) && stacktrace.mechanism !== 'onunhandledrejection') {
            // There are cases where stacktrace.message is an Event object
            // https://github.com/getsentry/sentry-javascript/issues/1949
            // In this specific case we try to extract stacktrace.message.error.message
            var message = stacktrace.message;
            stacktrace.message =
                message.error && Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* isString */])(message.error.message) ? message.error.message : 'No error message';
        }
        if (stacktrace.mechanism === 'onunhandledrejection' && (stacktrace.incomplete || stacktrace.mode === 'failed')) {
            return this._eventFromIncompleteRejection(stacktrace, error);
        }
        var event = Object(__WEBPACK_IMPORTED_MODULE_5__parsers__["b" /* eventFromStacktrace */])(stacktrace);
        var data = {
            mode: stacktrace.mode,
        };
        if (stacktrace.message) {
            data.message = stacktrace.message;
        }
        if (stacktrace.name) {
            data.name = stacktrace.name;
        }
        var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getClient();
        var maxValueLength = (client && client.getOptions().maxValueLength) || 250;
        var fallbackValue = stacktrace.original
            ? Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["C" /* truncate */])(JSON.stringify(Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["u" /* normalize */])(stacktrace.original)), maxValueLength)
            : '';
        var fallbackType = stacktrace.mechanism === 'onunhandledrejection' ? 'UnhandledRejection' : 'Error';
        // This makes sure we have type/value in every exception
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["d" /* addExceptionTypeValue */])(event, fallbackValue, fallbackType, {
            data: data,
            handled: false,
            type: stacktrace.mechanism,
        });
        return event;
    };
    /**
     * This function creates an Event from an TraceKitStackTrace that has part of it missing.
     *
     * @param stacktrace TraceKitStackTrace to be converted to an Event.
     */
    GlobalHandlers.prototype._eventFromIncompleteRejection = function (stacktrace, error) {
        var event = {
            level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
        };
        if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["p" /* isPrimitive */])(error)) {
            event.exception = {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with value: " + error,
                    },
                ],
            };
        }
        else {
            event.exception = {
                values: [
                    {
                        type: 'UnhandledRejection',
                        value: "Non-Error promise rejection captured with keys: " + Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["s" /* keysToEventMessage */])(Object.keys(error).sort()),
                    },
                ],
            };
            event.extra = {
                __serialized__: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["v" /* normalizeToSize */])(error),
            };
        }
        if (event.exception.values && event.exception.values[0]) {
            event.exception.values[0].mechanism = {
                data: __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ mode: stacktrace.mode }, (stacktrace.incomplete && { incomplete: stacktrace.incomplete }), (stacktrace.message && { message: stacktrace.message }), (stacktrace.name && { name: stacktrace.name })),
                handled: false,
                type: stacktrace.mechanism,
            };
        }
        return event;
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());

//# sourceMappingURL=globalhandlers.js.map

/***/ }),
/* 2076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TryCatch; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__helpers__ = __webpack_require__(302);


/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    function TryCatch() {
        /** JSDoc */
        this._ignoreOnError = 0;
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
    }
    /** JSDoc */
    TryCatch.prototype._wrapTimeFunction = function (original) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var originalCallback = args[0];
            args[0] = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(originalCallback, {
                mechanism: {
                    data: { function: getFunctionName(original) },
                    handled: true,
                    type: 'instrument',
                },
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapRAF = function (original) {
        return function (callback) {
            return original(Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }));
        };
    };
    /** JSDoc */
    TryCatch.prototype._wrapEventTarget = function (target) {
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* getGlobalObject */])();
        var proto = global[target] && global[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(proto, 'addEventListener', function (original) {
            return function (eventName, fn, options) {
                try {
                    // tslint:disable-next-line:no-unbound-method strict-type-predicates
                    if (typeof fn.handleEvent === 'function') {
                        fn.handleEvent = Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(fn.handleEvent.bind(fn), {
                            mechanism: {
                                data: {
                                    function: 'handleEvent',
                                    handler: getFunctionName(fn),
                                    target: target,
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        });
                    }
                }
                catch (err) {
                    // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, Object(__WEBPACK_IMPORTED_MODULE_1__helpers__["d" /* wrap */])(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }), options);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(proto, 'removeEventListener', function (original) {
            return function (eventName, fn, options) {
                var callback = fn;
                try {
                    callback = callback && (callback.__sentry_wrapped__ || callback);
                }
                catch (e) {
                    // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, callback, options);
            };
        });
    };
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        this._ignoreOnError = this._ignoreOnError;
        var global = Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["i" /* getGlobalObject */])();
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(global, 'setTimeout', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(global, 'setInterval', this._wrapTimeFunction.bind(this));
        Object(__WEBPACK_IMPORTED_MODULE_0__sentry_utils__["g" /* fill */])(global, 'requestAnimationFrame', this._wrapRAF.bind(this));
        [
            'EventTarget',
            'Window',
            'Node',
            'ApplicationCache',
            'AudioTrackList',
            'ChannelMergerNode',
            'CryptoOperation',
            'EventSource',
            'FileReader',
            'HTMLUnknownElement',
            'IDBDatabase',
            'IDBRequest',
            'IDBTransaction',
            'KeyOperation',
            'MediaController',
            'MessagePort',
            'ModalWindow',
            'Notification',
            'SVGElementInstance',
            'Screen',
            'TextTrack',
            'TextTrackCue',
            'TextTrackList',
            'WebSocket',
            'WebSocketWorker',
            'Worker',
            'XMLHttpRequest',
            'XMLHttpRequestEventTarget',
            'XMLHttpRequestUpload',
        ].forEach(this._wrapEventTarget.bind(this));
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        return (fn && fn.name) || '<anonymous>';
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return '<anonymous>';
    }
}
//# sourceMappingURL=trycatch.js.map

/***/ }),
/* 2077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Breadcrumbs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_types__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_utils__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helpers__ = __webpack_require__(302);





var global = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["i" /* getGlobalObject */])();
var lastHref;
/** Default Breadcrumbs instrumentations */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /** JSDoc */
    Breadcrumbs.prototype._instrumentConsole = function () {
        if (!('console' in global)) {
            return;
        }
        ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
            if (!(level in global.console)) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global.console, level, function (originalConsoleLevel) {
                return function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var breadcrumbData = {
                        category: 'console',
                        data: {
                            extra: {
                                arguments: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["u" /* normalize */])(args, 3),
                            },
                            logger: 'console',
                        },
                        level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString(level),
                        message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["x" /* safeJoin */])(args, ' '),
                    };
                    if (level === 'assert') {
                        if (args[0] === false) {
                            breadcrumbData.message = "Assertion failed: " + (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["x" /* safeJoin */])(args.slice(1), ' ') || 'console.assert');
                            breadcrumbData.data.extra.arguments = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["u" /* normalize */])(args.slice(1), 3);
                        }
                    }
                    Breadcrumbs.addBreadcrumb(breadcrumbData, {
                        input: args,
                        level: level,
                    });
                    // this fails for some browsers. :(
                    if (originalConsoleLevel) {
                        Function.prototype.apply.call(originalConsoleLevel, global.console, args);
                    }
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentDOM = function () {
        if (!('document' in global)) {
            return;
        }
        // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
        // to the document. Do this before we instrument addEventListener.
        global.document.addEventListener('click', Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click'), false);
        global.document.addEventListener('keypress', Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])(), false);
        // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
        ['EventTarget', 'Node'].forEach(function (target) {
            var proto = global[target] && global[target].prototype;
            if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
                return;
            }
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(proto, 'addEventListener', function (original) {
                return function (eventName, fn, options) {
                    if (fn && fn.handleEvent) {
                        if (eventName === 'click') {
                            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                                return function (event) {
                                    Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click')(event);
                                    return innerOriginal.call(this, event);
                                };
                            });
                        }
                        if (eventName === 'keypress') {
                            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(fn, 'handleEvent', function (innerOriginal) {
                                return function (event) {
                                    Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])()(event);
                                    return innerOriginal.call(this, event);
                                };
                            });
                        }
                    }
                    else {
                        if (eventName === 'click') {
                            Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["a" /* breadcrumbEventHandler */])('click', true)(this);
                        }
                        if (eventName === 'keypress') {
                            Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["b" /* keypressEventHandler */])()(this);
                        }
                    }
                    return original.call(this, eventName, fn, options);
                };
            });
            Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(proto, 'removeEventListener', function (original) {
                return function (eventName, fn, options) {
                    var callback = fn;
                    try {
                        callback = callback && (callback.__sentry_wrapped__ || callback);
                    }
                    catch (e) {
                        // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                    }
                    return original.call(this, eventName, callback, options);
                };
            });
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentFetch = function () {
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["A" /* supportsNativeFetch */])()) {
            return;
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global, 'fetch', function (originalFetch) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var fetchInput = args[0];
                var method = 'GET';
                var url;
                if (typeof fetchInput === 'string') {
                    url = fetchInput;
                }
                else if ('Request' in global && fetchInput instanceof Request) {
                    url = fetchInput.url;
                    if (fetchInput.method) {
                        method = fetchInput.method;
                    }
                }
                else {
                    url = String(fetchInput);
                }
                if (args[1] && args[1].method) {
                    method = args[1].method;
                }
                var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (filterUrl && url.includes(filterUrl)) {
                        if (method === 'POST' && args[1] && args[1].body) {
                            addSentryBreadcrumb(args[1].body);
                        }
                        return originalFetch.apply(global, args);
                    }
                }
                var fetchData = {
                    method: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* isString */])(method) ? method.toUpperCase() : method,
                    url: url,
                };
                return originalFetch
                    .apply(global, args)
                    .then(function (response) {
                    fetchData.status_code = response.status;
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        type: 'http',
                    }, {
                        input: args,
                        response: response,
                    });
                    return response;
                })
                    .catch(function (error) {
                    Breadcrumbs.addBreadcrumb({
                        category: 'fetch',
                        data: fetchData,
                        level: __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].Error,
                        type: 'http',
                    }, {
                        error: error,
                        input: args,
                    });
                    throw error;
                });
            };
        });
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentHistory = function () {
        var _this = this;
        if (!Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["z" /* supportsHistory */])()) {
            return;
        }
        var captureUrlChange = function (from, to) {
            var parsedLoc = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* parseUrl */])(global.location.href);
            var parsedTo = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* parseUrl */])(to);
            var parsedFrom = Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["w" /* parseUrl */])(from);
            // Initial pushState doesn't provide `from` information
            if (!parsedFrom.path) {
                parsedFrom = parsedLoc;
            }
            // because onpopstate only tells you the "new" (to) value of location.href, and
            // not the previous (from) value, we need to track the value of the current URL
            // state ourselves
            lastHref = to;
            // Use only the path component of the URL if the URL matches the current
            // document (almost all the time when using pushState)
            if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                to = parsedTo.relative;
            }
            if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
                // tslint:disable-next-line:no-parameter-reassignment
                from = parsedFrom.relative;
            }
            Breadcrumbs.addBreadcrumb({
                category: 'navigation',
                data: {
                    from: from,
                    to: to,
                },
            });
        };
        // record navigation (URL) changes
        var oldOnPopState = global.onpopstate;
        global.onpopstate = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var currentHref = global.location.href;
            captureUrlChange(lastHref, currentHref);
            if (oldOnPopState) {
                return oldOnPopState.apply(_this, args);
            }
        };
        /**
         * @hidden
         */
        function historyReplacementFunction(originalHistoryFunction) {
            // note history.pushState.length is 0; intentionally not declaring
            // params to preserve 0 arity
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args.length > 2 ? args[2] : undefined;
                // url argument is optional
                if (url) {
                    // coerce to string (this is what pushState does)
                    captureUrlChange(lastHref, String(url));
                }
                return originalHistoryFunction.apply(this, args);
            };
        }
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global.history, 'pushState', historyReplacementFunction);
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(global.history, 'replaceState', historyReplacementFunction);
    };
    /** JSDoc */
    Breadcrumbs.prototype._instrumentXHR = function () {
        if (!('XMLHttpRequest' in global)) {
            return;
        }
        /**
         * @hidden
         */
        function wrapProp(prop, xhr) {
            // TODO: Fix XHR types
            if (prop in xhr && typeof xhr[prop] === 'function') {
                Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhr, prop, function (original) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* wrap */])(original, {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (original && original.name) || '<anonymous>',
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                });
            }
        }
        var xhrproto = XMLHttpRequest.prototype;
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhrproto, 'open', function (originalOpen) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = args[1];
                this.__sentry_xhr__ = {
                    method: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* isString */])(args[0]) ? args[0].toUpperCase() : args[0],
                    url: args[1],
                };
                var client = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getClient();
                var dsn = client && client.getDsn();
                if (dsn) {
                    var filterUrl = new __WEBPACK_IMPORTED_MODULE_1__sentry_core__["a" /* API */](dsn).getStoreEndpoint();
                    // if Sentry key appears in URL, don't capture it as a request
                    // but rather as our own 'sentry' type breadcrumb
                    if (Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["q" /* isString */])(url) && (filterUrl && url.includes(filterUrl))) {
                        this.__sentry_own_request__ = true;
                    }
                }
                return originalOpen.apply(this, args);
            };
        });
        Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhrproto, 'send', function (originalSend) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var xhr = this; // tslint:disable-line:no-this-assignment
                if (xhr.__sentry_own_request__) {
                    addSentryBreadcrumb(args[0]);
                }
                /**
                 * @hidden
                 */
                function onreadystatechangeHandler() {
                    if (xhr.readyState === 4) {
                        if (xhr.__sentry_own_request__) {
                            return;
                        }
                        try {
                            // touching statusCode in some platforms throws
                            // an exception
                            if (xhr.__sentry_xhr__) {
                                xhr.__sentry_xhr__.status_code = xhr.status;
                            }
                        }
                        catch (e) {
                            /* do nothing */
                        }
                        Breadcrumbs.addBreadcrumb({
                            category: 'xhr',
                            data: xhr.__sentry_xhr__,
                            type: 'http',
                        }, {
                            xhr: xhr,
                        });
                    }
                }
                ['onload', 'onerror', 'onprogress'].forEach(function (prop) {
                    wrapProp(prop, xhr);
                });
                if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                    Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["g" /* fill */])(xhr, 'onreadystatechange', function (original) {
                        return Object(__WEBPACK_IMPORTED_MODULE_4__helpers__["d" /* wrap */])(original, {
                            mechanism: {
                                data: {
                                    function: 'onreadystatechange',
                                    handler: (original && original.name) || '<anonymous>',
                                },
                                handled: true,
                                type: 'instrument',
                            },
                        }, onreadystatechangeHandler);
                    });
                }
                else {
                    // if onreadystatechange wasn't actually set by the page on this xhr, we
                    // are free to set our own and capture the breadcrumb
                    xhr.onreadystatechange = onreadystatechangeHandler;
                }
                return originalSend.apply(this, args);
            };
        });
    };
    /**
     * Helper that checks if integration is enabled on the client.
     * @param breadcrumb Breadcrumb
     * @param hint BreadcrumbHint
     */
    Breadcrumbs.addBreadcrumb = function (breadcrumb, hint) {
        if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getIntegration(Breadcrumbs)) {
            Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().addBreadcrumb(breadcrumb, hint);
        }
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            this._instrumentConsole();
        }
        if (this._options.dom) {
            this._instrumentDOM();
        }
        if (this._options.xhr) {
            this._instrumentXHR();
        }
        if (this._options.fetch) {
            this._instrumentFetch();
        }
        if (this._options.history) {
            this._instrumentHistory();
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());

/** JSDoc */
function addSentryBreadcrumb(serializedData) {
    // There's always something that can go wrong with deserialization...
    try {
        var event_1 = JSON.parse(serializedData);
        Breadcrumbs.addBreadcrumb({
            category: 'sentry',
            event_id: event_1.event_id,
            level: event_1.level || __WEBPACK_IMPORTED_MODULE_2__sentry_types__["a" /* Severity */].fromString('error'),
            message: Object(__WEBPACK_IMPORTED_MODULE_3__sentry_utils__["h" /* getEventDescription */])(event_1),
        }, {
            event: event_1,
        });
    }
    catch (_oO) {
        __WEBPACK_IMPORTED_MODULE_3__sentry_utils__["t" /* logger */].error('Error while adding sentry type breadcrumb');
    }
}
//# sourceMappingURL=breadcrumbs.js.map

/***/ }),
/* 2078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LinkedErrors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parsers__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tracekit__ = __webpack_require__(301);




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event, hint) {
            var self = Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getIntegration(LinkedErrors);
            if (self) {
                return self._handler(event, hint);
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._handler = function (event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(hint.originalException instanceof Error)) {
            return event;
        }
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */](linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype._walkErrorTree = function (error, key, stack) {
        if (stack === void 0) { stack = []; }
        if (!(error[key] instanceof Error) || stack.length + 1 >= this._limit) {
            return stack;
        }
        var stacktrace = Object(__WEBPACK_IMPORTED_MODULE_3__tracekit__["a" /* _computeStackTrace */])(error[key]);
        var exception = Object(__WEBPACK_IMPORTED_MODULE_2__parsers__["c" /* exceptionFromStacktrace */])(stacktrace);
        return this._walkErrorTree(error[key], key, __WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __spread */]([exception], stack));
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());

//# sourceMappingURL=linkederrors.js.map

/***/ }),
/* 2079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_core__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sentry_utils__ = __webpack_require__(29);



var global = Object(__WEBPACK_IMPORTED_MODULE_2__sentry_utils__["i" /* getGlobalObject */])();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["e" /* addGlobalEventProcessor */])(function (event) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__sentry_core__["g" /* getCurrentHub */])().getIntegration(UserAgent)) {
                if (!global.navigator || !global.location) {
                    return event;
                }
                // HTTP Interface: https://docs.sentry.io/clientdev/interfaces/http/?platform=javascript
                var request = event.request || {};
                request.url = request.url || global.location.href;
                request.headers = request.headers || {};
                request.headers['User-Agent'] = global.navigator.userAgent;
                return __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */]({}, event, { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

//# sourceMappingURL=useragent.js.map

/***/ }),
/* 2080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
function register(){if("production"==="production"&&"serviceWorker"in navigator){window.addEventListener("load",function(){var swUrl=""+"/sw.js";navigator.serviceWorker.register(swUrl).then(function(registration){console.log("Registration service worker");//registration.onupdatefound = () => {
//const installingWorker = registration.installing;
//installingWorker.onstatechange = () => {
//if (installingWorker.state === "installed") {
//if (navigator.serviceWorker.controller) {
// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
//console.log("New content is available; please refresh.");
//} else {
// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
//console.log("Content is cached for offline use.");
//}
//}
// };
//};
}).catch(function(error){console.error("Error during service worker registration:",error);});});}}function unregister(){if("serviceWorker"in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 2081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(isLocalhost){// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);// Add some additional logging to localhost, pointing developers to the
// service worker/PWA documentation.
navigator.serviceWorker.ready.then(function(){console.log('This web app is being served cache-first by a service '+'worker. To learn more, visit https://goo.gl/SC7cgQ');});}else{// Is not local host. Just register service worker
registerValidSW(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ }),
/* 2082 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2083 */,
/* 2084 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			var styleTarget = fn.call(this, selector);
			// Special case to return head of iframe instead of iframe itself
			if (styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[selector] = styleTarget;
		}
		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(1270);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.7e82bc86.js